(function () {
	'use strict';

	angular
		.module('pixerf', [
			'ngAnimate',
			'ngCookies',
			'ngTouch',
			'ngSanitize',
			'ngMessages',
			'ngAria',
			'ngResource',
			'ui.router',
			'ui.bootstrap',
			'ngMessageFormat',
			'toastr',
			'auth0.auth0',
			'angular-storage',
			'angular-jwt',
			'infinite-scroll',
			'angularMoment',
			'ngTagsInput',
			'ngDropzone',
			'countrySelect',
			'underscore',
			'permission',
			'permission.ui',
			'google.places',
			'angular-loading-bar',
			'angular-jquery-locationpicker',
			'ngDrag',
			'angularjs-dropdown-multiselect',
			'scrollToFixed',
			'720kb.socialshare',
			'monospaced.elastic',
			'paypal-button',
			'fancyboxplus',
			'ngQuill',
			'yaru22.angular-timeago',
			'dcbImgFallback',
			'angularLazyImg',
			'iso-3166-country-codes',
			'credit-cards',
			'angularPromiseButtons',
			'slick',
			'tw-currency-select',
			'formly',
			'formlyBootstrap',
			'angular-directive-select-usstates',
			'internationalPhoneNumber',
			'ui.select',
			'pascalprecht.translate'
		]);

})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('myEarningReferralsCtrl', myEarningReferralsCtrl);

	myEarningReferralsCtrl.$inject = ['$scope', 'toastr', 'photoSoldSvc', 'pixerfApiSalesSvc', 'pagingUtils'];

	function myEarningReferralsCtrl($scope, toastr, photoSoldSvc, pixerfApiSalesSvc, pagingUtils) {

		var self = this;
		self.spinner = {
			isVisible: false
		}
		self.fetchMorePurchasedItems = fetchMorePurchasedItems;
		self.selectedFilter = photoSoldSvc.getFilters();
		self.items = photoSoldSvc.getItems();
		self.totalMedia = photoSoldSvc.getTotalMedia();
		self.searchParams = photoSoldSvc.getSearchParams();
		self.onSearchFilterClick = onSearchFilterClick;
		self.onFilterChanged = onFilterChanged;
		self.filtersFromMonth = {
			"items": photoSoldSvc.buildMonthFilters(),
			'defaultText': 'Month'
		};
		self.filtersFromYear = {
			"items": photoSoldSvc.buildYearFilters(),
			'defaultText': 'Year'
		};
		self.filtersToMonth = {
			"items": photoSoldSvc.buildMonthFilters(),
			'defaultText': 'Month'
		};
		self.filtersToYear = {
			"items": photoSoldSvc.buildYearFilters(),
			'defaultText': 'Year'
		};

		$scope.altInputFormats = ['M!/yyyy'];
		initList();

		function initList() {
			onSearchFilterClick(self.selectedFilter, 'MOST_RECENT');
		}

		function onSearchFilterClick(filter, type) {
			self.searchParams = {
				page: 1,
				start_date: null,
				end_date: null
			};
			if (filter) {
				filter.type = type;
				var timeRange = photoSoldSvc.getTimeRange(filter);
				if (timeRange) {
					self.searchParams.start_date = timeRange.start_date;
					self.searchParams.end_date = timeRange.end_date;
				}
				photoSoldSvc.setSearchParams(self.searchParams);
				photoSoldSvc.setFilters(filter);
			}
			fetchPurchasedItems(self.searchParams, true);
		}

		function fetchPurchasedItems(searchParams, isFresh) {
			self.spinner.isVisible = true;
			if (isFresh) self.items = [];
			pixerfApiSalesSvc.post(searchParams).$promise.then(function (response) {
				if (searchParams.page === 1) self.items = [];
				self.spinner.isVisible = false;
				if (response && response.data && response.data.length > 0) {
					self.items = [{
							"email": "kathrynblack08@gmail.com",
							"image": 1,
							"expiry_date": "2 August 2019"
						},
						{
							"email": "john.tan@gmail.com",
							"image": 0,
							"expiry_date": "25 October 2019"
						}
					];
					self.totalMedia = getTotalMedia(response);
					photoSoldSvc.setTotalMedia(self.totalMedia);
					photoSoldSvc.setItems(self.items);
				}
				self.isLastPage = pagingUtils.isNoMorePageToLoad(searchParams.page, response);

			}, function () {
				self.spinner.isVisible = false;
				toastr.error('Failed to get order list. Please try again.');
			})
		}

		function fetchMorePurchasedItems() {
			if (self.spinner.isVisible) {
				return;
			}
			self.searchParams.page++;
			fetchPurchasedItems(self.searchParams);
		}

		function getTotalMedia(response) {
			return response.headers('total-media');
		}

		function onFilterChanged() {
			onSearchFilterClick(self.selectedFilter, 'DURATION');
		}

	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('myEarningImagesSoldCtrl', myEarningImagesSoldCtrl);

	myEarningImagesSoldCtrl.$inject = ['$scope', 'toastr', 'photoSoldSvc', 'pixerfApiSalesSvc', 'pagingUtils', 'translationSvc'];

	function myEarningImagesSoldCtrl($scope, toastr, photoSoldSvc, pixerfApiSalesSvc, pagingUtils, translationSvc) {

		var self = this;
		self.spinner = {
			isVisible: false
		}
		self.fetchMorePurchasedItems = fetchMorePurchasedItems;
		self.selectedFilter = photoSoldSvc.getFilters();
		self.items = photoSoldSvc.getItems();
		self.totalMedia = photoSoldSvc.getTotalMedia();
		self.searchParams = photoSoldSvc.getSearchParams();
		self.onSearchFilterClick = onSearchFilterClick;
		self.onFilterChanged = onFilterChanged;
		self.filtersFromMonth = {
			"items": photoSoldSvc.buildMonthFilters(),
			'defaultText': 'Month'
		};
		self.filtersFromYear = {
			"items": photoSoldSvc.buildYearFilters(),
			'defaultText': 'Year'
		};
		self.filtersToMonth = {
			"items": photoSoldSvc.buildMonthFilters(),
			'defaultText': 'Month'
		};
		self.filtersToYear = {
			"items": photoSoldSvc.buildYearFilters(),
			'defaultText': 'Year'
		};

		$scope.altInputFormats = ['M!/yyyy'];
		initList();

		function initList() {
			onSearchFilterClick(self.selectedFilter, 'MOST_RECENT');
		}

		function onSearchFilterClick(filter, type) {
			self.searchParams = {
				page: 1,
				start_date: null,
				end_date: null
			};
			if (filter) {
				filter.type = type;
				var timeRange = photoSoldSvc.getTimeRange(filter);
				if (timeRange) {
					self.searchParams.start_date = timeRange.start_date;
					self.searchParams.end_date = timeRange.end_date;
				}
				photoSoldSvc.setSearchParams(self.searchParams);
				photoSoldSvc.setFilters(filter);
			}
			fetchPurchasedItems(self.searchParams, true);
		}

		function fetchPurchasedItems(searchParams, isFresh) {
			self.spinner.isVisible = true;
			if (isFresh) self.items = [];
			pixerfApiSalesSvc.post(searchParams).$promise.then(function (response) {
				if (searchParams.page === 1) self.items = [];
				self.spinner.isVisible = false;
				if (response && response.data && response.data.length > 0) {
					self.items = self.items.concat(response.data);
					self.totalMedia = getTotalMedia(response);
					photoSoldSvc.setTotalMedia(self.totalMedia);
					photoSoldSvc.setItems(self.items);
				}
				self.isLastPage = pagingUtils.isNoMorePageToLoad(searchParams.page, response);

			}, function () {
				self.spinner.isVisible = false;
				toastr.error(translationSvc.FAILED_TO_DO_SOMETHING('FAILED_ORDER_LIST', true));
			})
		}

		function fetchMorePurchasedItems() {
			if (self.spinner.isVisible) {
				return;
			}
			self.searchParams.page++;
			fetchPurchasedItems(self.searchParams);
		}

		function getTotalMedia(response) {
			return response.headers('total-media');
		}

		function onFilterChanged() {
			onSearchFilterClick(self.selectedFilter, 'DURATION');
		}

	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('signatureGalleriesCtrl', signatureGalleriesCtrl);

	signatureGalleriesCtrl.$inject = ['$scope', 'pixerfApiCategorySvc', 'toastr', 'sessionManagerSvc'];

	function signatureGalleriesCtrl($scope, pixerfApiCategorySvc, toastr, sessionManagerSvc) {
		var self = this;
		self.categories = [];
		self.loginedUser = sessionManagerSvc.getCurrentLoginUser().data;
		$scope.$parent.vm.subContextPage = "Signature Galleries";

		init();

		function init() {
			getCategories();
		}

		function getCategories() {
			pixerfApiCategorySvc.get(function (response) {
				self.categories = response;
				self.categories = _.map(self.categories, function (cate) {
					cate.thumbnails['local'] = '../assets/images/signature-galleries/' + cate.name.split(' ')[0].toLowerCase() + '.jpg';
					return cate;
				})
			}, function () {
				toastr.error($translate.instant('failed-to-get-categories'));
			});
		}
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('pixerferGalleriesCtrl', pixerferGalleriesCtrl);

	pixerferGalleriesCtrl.$inject = ['galleryConst', '$scope', 'toastr', '$stateParams', 'headerSvc', 'sessionManagerSvc', '$state', 'numberUtils', 'systemUtils'];

	function pixerferGalleriesCtrl(galleryConst, $scope, toastr, $stateParams, headerSvc, sessionManagerSvc, $state, numberUtils, systemUtils) {
		var self = this;
		self.topGalleries = [];
		self.galleryGridAll = null;
		self.onScrollToGallery = onScrollToGallery;
		self.onStaredToggled = onStaredToggled;
		self.onLoadMorePage = onLoadMorePage;
		self.onBackbtnClicked = onBackbtnClicked;
		self.scrollToFixedHeaderSettings = headerSvc.getFixedByHeaderSetting();
		self.loginUser = sessionManagerSvc.getCurrentLoginUser().data;
		$scope.$parent.vm.subContextPage = "Pixerfer Galleries";

		$scope.$watch("vm.galleryGridAll", function () {
			if (self.galleryGridAll) {
				extractSearchParam();
				self.galleryGridAll.fetchGalleries({
					type: 'pixerf',
					page: $state.params.page ? $state.params.page : 1
				}, true).then(function () {
					self.pagerUnit = self.galleryGridAll.galleries.length === 1 ? "Gallery" : "Galleries";
					self.headerName = "pixerfer-galleries";
					self.description = "marketplace-pixerfer-galleries-description";
					self.pagerText = "Pixerfers'";
					self.mobileBreadcrumb = "Pixerfers' Galleries";
					self.topGalleries = getTopGalleries(self.galleryGridAll.galleries);
					$scope.$parent.vm.totalPage = self.galleryGridAll.totalPage;
				}, function () {

				})
			}
		})

		function extractSearchParam() {
			if (!$state.params.type) $state.params.type = galleryConst.GALLERY_TYPE.PIXERF;

			if ($state.params.page) {
				var parsePage = numberUtils.parseInt($state.params.page);
				$state.params.page = parsePage ? parsePage : 1;
			} else {
				$state.params.page = 1;
			}
			$scope.$parent.vm.page = $state.params.page;
		}

		function removeGallery(galleries, gallery) {
			galleries = _.reject(galleries, function (item) {
				return item.id === gallery.id;
			});
			return galleries;
		}

		function getTopGalleries(galleries) {
			var numTopGalleries = Math.min(galleries.length, galleryConst.TOP_PIXERFER_GALLERY);
			return galleries.slice(0, numTopGalleries);
		}

		function onStaredToggled(gallery) {
			if ($stateParams.type === galleryConst.GALLERY_TYPE.PIXERF) {
				if (!gallery.is_starred) {
					if (gallery.star_count <= 0) {
						self.galleryGridAll.galleries = removeGallery(self.galleryGridAll.galleries, gallery);
						self.topGalleries = removeGallery(self.topGalleries, gallery);
					}
				}
			}
		}

		function updateUrlParams(page) {
			if (systemUtils.isMobile()) {
				$state.params.page = "";
				$state.go($state.current.name, $state.params, {
					notify: false
				});
				return;
			}
			$scope.$parent.vm.page = page;
			$state.params.page = page;
			$state.go($state.current.name, $state.params, {
				notify: false
			});
		}

		function onScrollToGallery(page) {
			updateUrlParams(page);
		}

		function onLoadMorePage(page) {
			updateUrlParams(page);
		}

		function onBackbtnClicked() {
			$state.go("marketplabuy-stock-page.galleries");
		}
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('followedGalleriesCtrl', followedGalleriesCtrl);

	followedGalleriesCtrl.$inject = ['galleryConst', '$scope', '$stateParams', 'headerSvc', 'sessionManagerSvc', '$state', 'numberUtils', 'systemUtils'];

	function followedGalleriesCtrl(galleryConst, $scope, $stateParams, headerSvc, sessionManagerSvc, $state, numberUtils, systemUtils) {
		var self = this;
		self.topGalleries = [];
		self.galleryGridAll = null;
		self.onScrollToGallery = onScrollToGallery;
		self.onStaredToggled = onStaredToggled;
		self.onLoadMorePage = onLoadMorePage;
		self.onBackbtnClicked = onBackbtnClicked;
		self.scrollToFixedHeaderSettings = headerSvc.getFixedByHeaderSetting();
		self.loginUser = sessionManagerSvc.getCurrentLoginUser().data;
		$scope.$parent.vm.subContextPage = "Galleries you follow";

		$scope.$watch("vm.galleryGridAll", function () {
			if (self.galleryGridAll) {
				extractSearchParam();
				self.galleryGridAll.fetchGalleries({
					type: 'following',
					page: $state.params.page ? $state.params.page : 1,
					userid: self.loginUser.id
				}, true).then(function () {
					self.pagerUnit = self.galleryGridAll.galleries.length === 1 ? "Gallery" : "Galleries";
					self.headerName = "Galleries you followed";
					self.description = "marketplace-pixerfer-galleries-description";
					self.pagerText = "Pixerfers'";
					self.mobileBreadcrumb = "Galleries you followed";
					self.topGalleries = getTopGalleries(self.galleryGridAll.galleries);
					$scope.$parent.vm.totalPage = self.galleryGridAll.totalPage;
				}, function () {

				})
			}
		})

		function extractSearchParam() {
			if (!$state.params.type) $state.params.type = galleryConst.GALLERY_TYPE.FOLLOWING;

			if ($state.params.page) {
				var parsePage = numberUtils.parseInt($state.params.page);
				$state.params.page = parsePage ? parsePage : 1;
			} else {
				$state.params.page = 1;
			}
			$scope.$parent.vm.page = $state.params.page;
		}

		function removeGallery(galleries, gallery) {
			galleries = _.reject(galleries, function (item) {
				return item.id === gallery.id;
			});
			return galleries;
		}

		function getTopGalleries(galleries) {
			var numTopGalleries = Math.min(galleries.length, galleryConst.TOP_PIXERFER_GALLERY);
			return galleries.slice(0, numTopGalleries);
		}

		function onStaredToggled(gallery) {
			if ($stateParams.type === galleryConst.GALLERY_TYPE.PIXERF) {
				if (!gallery.is_starred) {
					if (gallery.star_count <= 0) {
						self.galleryGridAll.galleries = removeGallery(self.galleryGridAll.galleries, gallery);
						self.topGalleries = removeGallery(self.topGalleries, gallery);
					}
				}
			}
		}

		function updateUrlParams(page) {
			if (systemUtils.isMobile()) {
				$state.params.page = "";
				$state.go($state.current.name, $state.params, {
					notify: false
				});
				return;
			}
			$scope.$parent.vm.page = page;
			$state.params.page = page;
			$state.go($state.current.name, $state.params, {
				notify: false
			});
		}

		function onScrollToGallery(page) {
			updateUrlParams(page);
		}

		function onLoadMorePage(page) {
			updateUrlParams(page);
		}

		function onBackbtnClicked() {
			$state.go("marketplabuy-stock-page.galleries");
		}
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('curatedGalleriesCtrl', curatedGalleriesCtrl);

	curatedGalleriesCtrl.$inject = ['galleryConst', '$scope', '$stateParams', 'headerSvc', 'sessionManagerSvc', '$state', 'numberUtils', 'systemUtils'];

	function curatedGalleriesCtrl(galleryConst, $scope, $stateParams, headerSvc, sessionManagerSvc, $state, numberUtils, systemUtils) {
		var self = this;
		self.topGalleries = [];
		self.galleryGridAll = null;
		self.onScrollToGallery = onScrollToGallery;
		self.onStaredToggled = onStaredToggled;
		self.onLoadMorePage = onLoadMorePage;
		self.onBackbtnClicked = onBackbtnClicked;
		self.scrollToFixedHeaderSettings = headerSvc.getFixedByHeaderSetting();
		self.loginUser = sessionManagerSvc.getCurrentLoginUser().data;
		$scope.$parent.vm.subContextPage = "Curated galleries";

		$scope.$watch("vm.galleryGridAll", function () {
			if (self.galleryGridAll) {
				extractSearchParam();
				self.galleryGridAll.fetchGalleries({
					type: 'signature',
					page: $state.params.page ? $state.params.page : 1,
					userid: self.loginUser.id
				}, true).then(function () {
                    $scope.$parent.vm.pagerUnit = self.signatureGalleries.galleries.length === 1 ? "Gallery" : "Galleries";
                    $scope.$parent.vm.mobileBreadcrumb =  "Curated galleries";
                    self.topGalleries = getTopGalleries(self.signatureGalleries.galleries);
                    $scope.$parent.vm.totalPage = self.signatureGalleries.totalPage;
				}, function () {

				})
			}
		})

		function extractSearchParam() {
			if (!$state.params.type) $state.params.type = galleryConst.GALLERY_TYPE.CURATED;

			if ($state.params.page) {
				var parsePage = numberUtils.parseInt($state.params.page);
				$state.params.page = parsePage ? parsePage : 1;
			} else {
				$state.params.page = 1;
			}
			$scope.$parent.vm.page = $state.params.page;
		}

		function removeGallery(galleries, gallery) {
			galleries = _.reject(galleries, function (item) {
				return item.id === gallery.id;
			});
			return galleries;
		}

		function getTopGalleries(galleries) {
			var numTopGalleries = Math.min(galleries.length, galleryConst.TOP_PIXERFER_GALLERY);
			return galleries.slice(0, numTopGalleries);
		}

		function onStaredToggled(gallery) {
			if ($stateParams.type === galleryConst.GALLERY_TYPE.PIXERF) {
				if (!gallery.is_starred) {
					if (gallery.star_count <= 0) {
						self.galleryGridAll.galleries = removeGallery(self.galleryGridAll.galleries, gallery);
						self.topGalleries = removeGallery(self.topGalleries, gallery);
					}
				}
			}
		}

		function updateUrlParams(page) {
			if (systemUtils.isMobile()) {
				$state.params.page = "";
				$state.go($state.current.name, $state.params, {
					notify: false
				});
				return;
			}
			$scope.$parent.vm.page = page;
			$state.params.page = page;
			$state.go($state.current.name, $state.params, {
				notify: false
			});
		}

		function onScrollToGallery(page) {
			updateUrlParams(page);
		}

		function onLoadMorePage(page) {
			updateUrlParams(page);
		}

		function onBackbtnClicked() {
			$state.go("marketplabuy-stock-page.galleries");
		}
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('userProfilePortfolioGridCtrl', userProfilePortfolioGridCtrl);

	userProfilePortfolioGridCtrl.$inject = ['$scope', '$stateParams', 'stringUtils', '$state', 'sessionManagerSvc', 'uploadPortfolioPhotoSvc', 'commonConst'];

	function userProfilePortfolioGridCtrl($scope, $stateParams, stringUtils, $state, sessionManagerSvc, uploadPortfolioPhotoSvc, commonConst) {
		var self = this;
		self.parent = $scope.$parent.vm;
		self.user = self.parent.user;
		self.isMine = sessionManagerSvc.isMine(self.user);
		self.goBackBtnClicked = goBackBtnClicked;
		self.onPortfolioClicked = onPortfolioClicked;
		self.onUploadPortfolioPhoto = onUploadPortfolioPhoto;
		self.portfolioId = $stateParams.portfolioId;

		self.scrollOffsetTopPortfolio = 110;
		self.portfolioGrid = null;

		genPortfolioName(self.portfolioId);

		$scope.$watch("vm.portfolioGrid", function () {
			fetchPortfolios("portfolioGrid", self.portfolioId);
		})

		function fetchPortfolios(name, id) {
			if (self[name]) {
				self[name].fetchPortfolios({
					speciality: id,
					userid: self.user.id,
					page: 1
				}, true);
			}
		}

		function genPortfolioName(portfolioId) {
			if (!self.user.profile) return;
			for (var i = 0; i < self.user.profile.specialities.length; i++) {
				if (self.user.profile.specialities[i].id == portfolioId) {
					self.portfolioName = self.user.profile.specialities[i].name;
					self.portfolioType = stringUtils.replaceDashBySpace(self.portfolioName);
				}
			}
		}

		function onPortfolioClicked(portfolio) {
			$state.go(commonConst.STATE.PORTFOLIO_PHOTOS, {
				portfolioId: self.portfolioId,
				galleryId: portfolio.id
			});
		}

		function goBackBtnClicked() {
			window.history.back();
		}

		function onUploadPortfolioPhoto(portfolioId) {
			uploadPortfolioPhotoSvc.showUploadModal({
				portfolioId: portfolioId
			});
		}
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('userProfilePortfolioCarouselCtrl', userProfilePortfolioCarouselCtrl);

	userProfilePortfolioCarouselCtrl.$inject = ['$scope', '$rootScope', 'messageConst', 'sessionManagerSvc', "$state", "commonConst"];

	function userProfilePortfolioCarouselCtrl($scope, $rootScope, messageConst, sessionManagerSvc, $state, commonConst) {
		var self = this;
		$scope.$parent.vm.contextPage = "Portfolio";
		self.parent = $scope.$parent.vm.parent;
		self.user = self.parent.user;
		self.goBackBtnClicked = goBackBtnClicked;
		self.onPortfolioClicked = onPortfolioClicked;
		self.isMine = sessionManagerSvc.isMine(self.user);
		self.portfolios = [];
		self.photoGrid = null;

		init();

		$scope.$watch("vm.photoGrid", function () {
			if (self.photoGrid) {
				search();
			}
		})

		function search() {
			var params = {
				page: 1,
				portfolioid: self.portfolioClicked
			};
			if (self.photoGrid) {
				self.isSearching = true;
				self.photoGrid.fetchPhotos(params, true).then(function () {
					self.isSearching = false;
				});
			}
		}

		$rootScope.$on(messageConst.BROADCAST.USER_DATA_CHANGE, function () {
			if (self.user.id === sessionManagerSvc.getCurrentLoginUser().data.id) {
				self.user = sessionManagerSvc.getCurrentLoginUser().data;
				self.portfolios = sessionManagerSvc.getCurrentLoginUser().data.profile.specialities;
				init();
			}
		});

		function init() {
			if (!self.user.profile) return;
			self.portfolios = self.user.profile.specialities;
			for (var i = 0; i < self.portfolios.length; i++) {
				self.portfolios[i].grid = "g" + self.portfolios[i].id;
				if (!isWatcherExist(self.portfolios[i].grid)) {
					$scope.$watch("vm." + self.portfolios[i].grid, function (portfolioGrid) {
						if (!portfolioGrid || !portfolioGrid.portfolio) return;
						fetchPortfolios(portfolioGrid.portfolio.grid, portfolioGrid.portfolio.id);
					});
				}
			}
		}

		function isWatcherExist(eleWatched) {
			return $scope.$$watchers && search("vm." + eleWatched, $scope.$$watchers);
		}

		function search(nameKey, myArray) {
			for (var i = 0; i < myArray.length; i++) {
				if (myArray[i].exp === nameKey) {
					return true;
				}
			}
		}

		function onPortfolioClicked(portfolio) {
			$state.go(commonConst.STATE.PORTFOLIO_PHOTOS, {
				portfolioId: portfolio.portfolioId,
				galleryId: portfolio.id
			});
		}

		function fetchPortfolios(name, id) {
			if (self[name]) {
				self[name].fetchPortfolios({
					speciality: id,
					userid: self.user.id,
					page: 1
				}, true);
			}
		}

		function goBackBtnClicked() {
			window.history.back();
		}
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('userProfileCommunitiesGridCtrl', userProfileCommunitiesGridCtrl);

	userProfileCommunitiesGridCtrl.$inject = ['$scope', 'createCommunityPopupSvc', 'pixerfApiCommunitySvc', '$state', 'pagingUtils'];

	function userProfileCommunitiesGridCtrl($scope, createCommunityPopupSvc, pixerfApiCommunitySvc, $state, pagingUtils) {
		var self = this;
		self.parent = $scope.$parent.vm;
		self.isMyProfile = self.parent.isMyProfile;
		self.canManageCommunity = self.parent.canManageCommunity;
		self.parent.contextPage = "Communities";
		self.user = self.parent.user;
		self.onExploreCommunities = onExploreCommunities;
		self.onCreateCommunityClicked = onCreateCommunityClicked;
		self.fetchMoreJoinedCommunities = fetchMoreJoinedCommunities;
		self.fetchMoreMyCommunities = fetchMoreMyCommunities;
		self.communityGridOptions = {
			autoLoadWhenScroll: false,
			isMyProfile: self.isMyProfile,
			user: self.user
		};
		self.myCommunities = [];
		self.joinedCommunities = [];
		self.spinnerMyCommunities = {
			isVisible: false
		};
		self.spinnerJoinedCommunities = {
			isVisible: false
		};
		self.searchMyCommunitiesParams = {
			membership: 'owner',
			user_id: self.user.id,
			page: 1
		};
		self.searchJoinedCommunitiesParams = {
			status: 'accepted',
			user_id: self.user.id,
			page: 1
		};

		init();

		function init() {
			getMyCommunities(self.searchMyCommunitiesParams, true);
			getJoinedCommunities(self.searchJoinedCommunitiesParams, true);
		}

		function getMyCommunities(params, isRefresh) {
			self.spinnerMyCommunities.isVisible = true;
			pixerfApiCommunitySvc.list(params).$promise.then(function (res) {
				self.spinnerMyCommunities.isVisible = false;
				if (isRefresh) {
					self.myCommunities = res.data;
				} else {
					self.myCommunities = self.myCommunities.concat(res.data);
				}
				self.isLastMyCommunitiesPage = pagingUtils.isNoMorePageToLoad(self.searchMyCommunitiesParams.page, res);
				self.searchMyCommunitiesParams.page = params.page;
			}).catch(function (err) {
				console.log(err);
				self.spinnerMyCommunities.isVisible = false;
			})
		}

		function fetchMoreMyCommunities() {
			if (self.isLastMyCommunitiesPage || self.spinnerMyCommunities.isVisible) return;
			var searchParms = $.extend(true, {}, self.searchMyCommunitiesParams);
			searchParms.page++;
			getMyCommunities(searchParms);
		}

		function onExploreCommunities() {
			$state.go("for-creator-page.about-community");
		}

		function getJoinedCommunities(params, isRefresh) {
			self.spinnerJoinedCommunities.isVisible = true;
			pixerfApiCommunitySvc.get_user_communities(params).$promise.then(function (res) {
				self.spinnerJoinedCommunities.isVisible = false;
				if (isRefresh) {
					self.joinedCommunities = res.data;
				} else {
					self.joinedCommunities = self.joinedCommunities.concat(res.data);
				}
				self.isLastJoinedCommunitiesPage = pagingUtils.isNoMorePageToLoad(self.searchJoinedCommunitiesParams.page, res);
				self.searchJoinedCommunitiesParams.page = params.page;
			}).catch(function (err) {
				console.log(err);
				self.spinnerJoinedCommunities.isVisible = false;
			})
		}

		function fetchMoreJoinedCommunities() {
			if (self.isLastJoinedCommunitiesPage || self.spinnerJoinedCommunities.isVisible) return;
			var searchParms = $.extend(true, {}, self.searchJoinedCommunitiesParams);
			searchParms.page++;
			getJoinedCommunities(searchParms);
		}

		function onCreateCommunityClicked() {
			createCommunityPopupSvc.showPopup();
		}
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('sidebarPersonalProfileCtrl', sidebarPersonalProfileCtrl);

	sidebarPersonalProfileCtrl.$inject = ['$scope', 'userHomePageSvc', 'authSvc', 'arrayUtils', '$state', 'infoRequirePopupSvc', 'accountConst', 'peopleListPopupSvc'];

	function sidebarPersonalProfileCtrl($scope, userHomePageSvc, authSvc, arrayUtils, $state, infoRequirePopupSvc, accountConst, peopleListPopupSvc) {
		var self = this;

		self.user = $scope.$parent.vm.user;
		self.serviceData = $scope.$parent.vm.serviceData;
		self.isMyProfile = $scope.$parent.vm.isMyProfile;
		self.isProfileNotCompleted = $scope.$parent.vm.isProfileNotCompleted;

		self.onEditProfileClicked = authSvc.navigateTo;
		self.onCompleteProfileClicked = onCompleteProfileClicked;
		self.onFollowersBtnClicked = onFollowersBtnClicked;
		self.onFollowingsBtnClicked = onFollowingsBtnClicked;

		self.sidebarScrollToFixed = userHomePageSvc.getSidebarFixedPosition('.sidebar-personal-profile');
		self.scrollToFixedWhen = {
			minWidth: 768
		};

		function onCompleteProfileClicked() {
			var steps = {};
			if (!stringUtils.isValueString(self.user.profile) || !stringUtils.isValueString(self.user.profile.services_rate_amount) ||
				!self.user.profile.services_rate_type || !arrayUtils.isValueArr(self.user.profile.cameras) ||
				(!arrayUtils.isValueArr(self.user.profile.availability_weekdays) && !arrayUtils.isValueArr(self.user.profile.availability_weekends)) ||
				!self.user.profile_image && !accountUtils.isSocialAccount(self.user)) {
				$state.go("complete-profile-page");
			} else {
				if (!self.user.cover_image) {
					steps["COVER_IMAGE"] = {
						name: "COVER_IMAGE",
						title: "Choose a Cover Photo",
						requiredFields: ["cover_image"],
						validator: function (user) {
							return !user.cover_image ? "Please choose your cover photo!" : "";
						},
						canSkip: true
					};
				}
				if (self.user.canUploadPhotos && self.user.stats.media_count < 20) {
					steps["UPLOADS"] = {
						name: "UPLOADS",
						title: "Upload your photos",
						requiredFields: ["media_counts"],
						canSkip: true
					};
				}
				var popup = infoRequirePopupSvc.showPopup({
					user: self.user,
					steps: steps
				});
				self.isProfileNotCompleted = false;
				self.banner = "";
				requireInfoPoupHandler(popup);
			}
		}

		function onFollowersBtnClicked() {
			if (self.user.stats.follower_count === 0) {
				return;
			}
			peopleListPopupSvc.showPopup({
				type: accountConst.INTERACT_TYPE.FOLLOWER.toLowerCase(),
				user: self.user
			});
		}

		function onFollowingsBtnClicked() {
			if (self.user.stats.following_count === 0) {
				return;
			}
			peopleListPopupSvc.showPopup({
				type: accountConst.INTERACT_TYPE.FOLLOWING.toLowerCase(),
				user: self.user
			});
		}
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('personalProfileCtrl', personalProfileCtrl);

	personalProfileCtrl.$inject = ['userPromise', 'pixerfApiCommunitySvc', 'arrayUtils', '$state', '$stateParams', 'sessionManagerSvc', '$scope',
		'messageConst'];

	function personalProfileCtrl(userPromise, pixerfApiCommunitySvc, arrayUtils, $state, $stateParams, sessionManagerSvc, $scope,
		messageConst) {
		var self = this;
		var mProfileId = parseInt($stateParams.id);
		self.user = userPromise;
		self.loginnedUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.socialShareContent = buildSocialShareContent(self.user);
		self.onLearnMoreClicked = onLearnMoreClicked;
		self.canManageCommunity = self.loginnedUser && self.loginnedUser.data && self.loginnedUser.data.canManageCommunity;
		self.isMyProfile = (self.loginnedUser && self.loginnedUser.id === mProfileId) || (!mProfileId && self.loginnedUser);
		self.isSelectedPhotos = false;
		self.bulkSelectedPhoto = []
		self.options ={
			bulkEditPhoto: self.isSelectedPhotos,
			bulkSelectedPhoto: self.bulkSelectedPhoto,
			buldEditPhotoChanged: buldEditPhotoChanged,
			bulkSelectedPhotoChanged: bulkSelectedPhotoChanged
		}

		$scope.$on(messageConst.BROADCAST.BULK_SELECTED_PHOTO_CANCEL, function(){
			selectPhotoBtnClicked(false);
		});
		
		init();

		function init() {
			getCommunities();
			buildUserServiceData(self.user.profile);
		}

		function buldEditPhotoChanged(data){
			self.isSelectedPhotos = data
		}
		function bulkSelectedPhotoChanged(data){
			self.bulkSelectedPhoto = data
		}

		function selectPhotoBtnClicked(value){
			self.isSelectedPhotos = !self.isSelectedPhotos;
			self.options.bulkEditPhoto = self.isSelectedPhotos;
			if(value == false){
				self.options.bulkSelectedPhoto = [];
				self.bulkSelectedPhoto = [];
			}
		}

		function buildUserServiceData(serviceData) {
			self.serviceData = {};
			if (!serviceData) return;
			self.serviceData.specialities = buildSpecialities(serviceData.specialities);
			self.serviceData.years_of_experience = serviceData.years_of_experience;
			self.serviceData.availability_weekdays = arrayUtils.isValueArr(serviceData.availability_weekdays) ? buildAvailabilityText(serviceData.availability_weekdays) : "";
			self.serviceData.availability_weekends = arrayUtils.isValueArr(serviceData.availability_weekends) ? buildAvailabilityText(serviceData.availability_weekends) : "";
			self.serviceData.cameras = arrayUtils.isValueArr(serviceData.cameras) ? serviceData.cameras.join(", ") : "";
		}

		function buildAvailabilityText(time) {
			if (!time || !time.length) return "";
			if (time.length === 2) {
				return "day-and-evening";
			} else if (time[0] === "day") {
				return "day-only";
			} else {
				return "evening-only";
			}
		}

		function buildSpecialities(specialitiesArray) {
			if (!arrayUtils.isValueArr(specialitiesArray)) return "";
			var specialities = [];
			for (var i = 0; i < specialitiesArray.length; i++) {
				specialities.push(specialitiesArray[i].name);
			}
			return specialities.join(", ");
		}

		function getCommunities() {
			pixerfApiCommunitySvc.list({
				user_id: self.user.id,
				membership: 'owner'
			}).$promise.then(function (response) {
				self.communities = response.data.splice(0, 2);
			});
		}

		function buildSocialShareContent(user) {
			return {
				'url': user.path,
				'description': user.bio,
				'title': user.displayName,
				'media': user.avatar.profileImage
			};
		}

		function onLearnMoreClicked(section) {
			$state.go('introduction-support.faq.business', {
				section: section
			});
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.config(routerConfig);

	routerConfig.$inject = ['$stateProvider'];

	function routerConfig($stateProvider) {
		'ngInject';
		$stateProvider
			.state('user-home-page.personal.home', {
				url: '/home',
				views: {
					'mainPersonal@user-home-page.personal': {
						templateUrl: 'app/user-home-page/components/personal-home-page/personal-home-page.html',
						controller: 'personalHomePageCtrl',
						controllerAs: 'vm',
					}
				},
				data: {
					permissions: {
						only: ['EVERY_ONE']
					}
				}
			})
			.state('user-home-page.personal.feed', {
				url: '/feed',
				views: {
					'mainPersonal@user-home-page.personal': {
						templateUrl: 'app/user-home-page/components/user-front-page/user-front-page.html',
						controller: 'userFrontPageCtrl',
						controllerAs: 'vm',
					}
				},
				data: {
					permissions: {
						only: ['EVERY_ONE']
					}
				}
			})
			.state('user-home-page.personal.photos', {
				url: '/photos',
				views: {
					'mainPersonal@user-home-page.personal': {
						templateUrl: 'app/user-home-page/components/user-profile-photos/user-profile-photos.html',
						controller: 'userProfilePhotosCtrl',
						controllerAs: 'vm',
					}
				},
				data: {
					permissions: {
						only: ['EVERY_ONE']
					}
				}
			})
			.state('user-home-page.personal.galleries', {
				url: '/galleries',
				views: {
					'mainPersonal@user-home-page.personal': {
						templateUrl: 'app/user-home-page/components/user-profile-galleries/galleries.html',
						controller: 'galleriesCtrl',
						controllerAs: 'vm',
					}
				},
				data: {
					permissions: {
						only: ['EVERY_ONE']
					}
				}
			})
			.state('user-home-page.personal.galleries-type', {
				url: '/galleries/:type',
				views: {
					'mainPersonal@user-home-page.personal': {
						templateUrl: 'app/user-home-page/components/user-profile-galleries/galleries.html',
						controller: 'galleriesCtrl',
						controllerAs: 'vm',
					}
				},
				data: {
					permissions: {
						only: ['EVERY_ONE']
					}
				}
			})
			.state('user-home-page.personal.portfolio', {
				url: '/portfolio',
				views: {
					'mainPersonal@user-home-page.personal': {
						templateUrl: 'app/user-home-page/components/user-profile-portfolio/user-profile-portfolio.html',
						controller: 'userProfilePortfolioCtrl',
						controllerAs: 'vm',
					}
				},
				data: {
					permissions: {
						only: ['EVERY_ONE']
					}
				},
				resolve: {
					userPromise: function ($stateParams, sessionManagerSvc, $q, $state, userPromise) {
						var loginUser = sessionManagerSvc.getCurrentLoginUser().data;
						var defer = $q.defer();
						var userid = parseInt($stateParams.id);
						if ((loginUser && userid === loginUser.id && !loginUser.canManagePortfolios) || !userPromise.canManagePortfolios) {
							$state.go('404');
							defer.reject();
						} else {
							defer.resolve(userPromise);
						}
						return defer.promise;
					}
				}
			})
			.state('user-home-page.personal.communities', {
				url: '/community',
				views: {
					'mainPersonal@user-home-page.personal': {
						templateUrl: 'app/user-home-page/components/user-profile-communities/user-profile-communities-grid/user-profile-communities-grid.html',
						controller: 'userProfileCommunitiesGridCtrl',
						controllerAs: 'vm'
					}
				},
				data: {
					permissions: {
						only: ['EVERY_ONE']
					}
				}
			})
			.state('user-home-page.personal.communities.grid', {
				url: '/all',
				templateUrl: 'app/user-home-page/components/user-profile-communities/user-profile-communities-grid/user-profile-communities-grid.html',
				controller: 'userProfileCommunitiesGridCtrl',
				controllerAs: 'vm'
			});
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('sidebarGuestProfileCtrl', sidebarGuestProfileCtrl);

		sidebarGuestProfileCtrl.$inject = ['$scope', 'userHomePageSvc', 'authSvc', 'arrayUtils', '$state', 'infoRequirePopupSvc', 'accountConst', 'peopleListPopupSvc'];

	function sidebarGuestProfileCtrl($scope, userHomePageSvc, authSvc, arrayUtils, $state, infoRequirePopupSvc, accountConst, peopleListPopupSvc) {
		var self = this;

		self.user = $scope.$parent.vm.user;
		self.serviceData = $scope.$parent.vm.serviceData;
		self.isMyProfile = $scope.$parent.vm.isMyProfile;
		self.isProfileNotCompleted = $scope.$parent.vm.isProfileNotCompleted;

		self.onEditProfileClicked = authSvc.navigateTo;
		self.onCompleteProfileClicked = onCompleteProfileClicked;
		self.onFollowersBtnClicked = onFollowersBtnClicked;
		self.onFollowingsBtnClicked = onFollowingsBtnClicked;

		self.sidebarScrollToFixed = userHomePageSvc.getSidebarFixedPosition('.sidebar-personal-profile');
		self.scrollToFixedWhen = {
			minWidth: 768
		};

		function onCompleteProfileClicked() {
			var steps = {};
			if (!stringUtils.isValueString(self.user.profile) || !stringUtils.isValueString(self.user.profile.services_rate_amount) ||
				!self.user.profile.services_rate_type || !arrayUtils.isValueArr(self.user.profile.cameras) ||
				(!arrayUtils.isValueArr(self.user.profile.availability_weekdays) && !arrayUtils.isValueArr(self.user.profile.availability_weekends)) ||
				!self.user.profile_image && !accountUtils.isSocialAccount(self.user)) {
				$state.go("complete-profile-page");
			} else {
				if (!self.user.cover_image) {
					steps["COVER_IMAGE"] = {
						name: "COVER_IMAGE",
						title: "Choose a Cover Photo",
						requiredFields: ["cover_image"],
						validator: function (user) {
							return !user.cover_image ? "Please choose your cover photo!" : "";
						},
						canSkip: true
					};
				}
				if (self.user.canUploadPhotos && self.user.stats.media_count < 20) {
					steps["UPLOADS"] = {
						name: "UPLOADS",
						title: "Upload your photos",
						requiredFields: ["media_counts"],
						canSkip: true
					};
				}
				var popup = infoRequirePopupSvc.showPopup({
					user: self.user,
					steps: steps
				});
				self.isProfileNotCompleted = false;
				self.banner = "";
				requireInfoPoupHandler(popup);
			}
		}

		function onFollowersBtnClicked() {
			if (self.user.stats.follower_count === 0) {
				return;
			}
			peopleListPopupSvc.showPopup({
				type: accountConst.INTERACT_TYPE.FOLLOWER.toLowerCase(),
				user: self.user
			});
		}

		function onFollowingsBtnClicked() {
			if (self.user.stats.following_count === 0) {
				return;
			}
			peopleListPopupSvc.showPopup({
				type: accountConst.INTERACT_TYPE.FOLLOWING.toLowerCase(),
				user: self.user
			});
		}
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('guestProfileCtrl', guestProfileCtrl);

		guestProfileCtrl.$inject = ['userPromise', 'pixerfApiCommunitySvc', 'arrayUtils', '$state', '$stateParams', 'sessionManagerSvc'];

	function guestProfileCtrl(userPromise, pixerfApiCommunitySvc, arrayUtils, $state, $stateParams, sessionManagerSvc) {
		var self = this;
		var mProfileId = parseInt($stateParams.id);
		self.user = userPromise;
		self.loginnedUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.socialShareContent = buildSocialShareContent(self.user);
		self.onLearnMoreClicked = onLearnMoreClicked;
		self.isMyProfile = (self.loginnedUser && self.loginnedUser.id === mProfileId) || (!mProfileId && self.loginnedUser);

		init();

		function init() {
			getCommunities();
			buildUserServiceData(self.user.profile);
		}

		function buildUserServiceData(serviceData) {
			self.serviceData = {};
			if (!serviceData) return;
			self.serviceData.specialities = buildSpecialities(serviceData.specialities);
			self.serviceData.years_of_experience = serviceData.years_of_experience;
			self.serviceData.availability_weekdays = arrayUtils.isValueArr(serviceData.availability_weekdays) ? buildAvailabilityText(serviceData.availability_weekdays) : "";
			self.serviceData.availability_weekends = arrayUtils.isValueArr(serviceData.availability_weekends) ? buildAvailabilityText(serviceData.availability_weekends) : "";
			self.serviceData.cameras = arrayUtils.isValueArr(serviceData.cameras) ? serviceData.cameras.join(", ") : "";
		}

		function buildAvailabilityText(time) {
			if (!time || !time.length) return "";
			if (time.length === 2) {
				return "day-and-evening";
			} else if (time[0] === "day") {
				return "day-only";
			} else {
				return "evening-only";
			}
		}

		function buildSpecialities(specialitiesArray) {
			if (!arrayUtils.isValueArr(specialitiesArray)) return "";
			var specialities = [];
			for (var i = 0; i < specialitiesArray.length; i++) {
				specialities.push(specialitiesArray[i].name);
			}
			return specialities.join(", ");
		}

		function getCommunities() {
			pixerfApiCommunitySvc.list({
				user_id: self.user.id,
				membership: 'owner'
			}).$promise.then(function (response) {
				self.communities = response.data.splice(0, 2);
			});
		}

		function buildSocialShareContent(user) {
			return {
				'url': user.path,
				'description': user.bio,
				'title': user.displayName,
				'media': user.avatar.profileImage
			};
		}

		function onLearnMoreClicked(section) {
			$state.go('introduction-support.faq.business', {
				section: section
			});
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.config(routerConfig);

	routerConfig.$inject = ['$stateProvider'];

	function routerConfig($stateProvider) {
		'ngInject';
		$stateProvider
			.state('user-home-page.guest.home', {
				url: '/homepage',
				views: {
					'mainPersonal@user-home-page.guest': {
						templateUrl: 'app/user-home-page/components/guest-home-page/guest-home-page.html',
						controller: 'guestlHomePageCtrl',
						controllerAs: 'vm',
					}
				},
				data: {
					permissions: {
						only: ['EVERY_ONE']
					}
				}
			})
			.state('user-home-page.guest.feed', {
				url: '/feed',
				views: {
					'mainPersonal@user-home-page.guest': {
						templateUrl: 'app/user-home-page/components/user-front-page/user-front-page.html',
						controller: 'userFrontPageCtrl',
						controllerAs: 'vm',
					}
				},
				data: {
					permissions: {
						only: ['EVERY_ONE']
					}
				}
			})
			.state('user-home-page.guest.galleries', {
				url: '/galleries',
				views: {
					'mainPersonal@user-home-page.guest': {
						templateUrl: 'app/user-home-page/components/user-profile-galleries/galleries.html',
						controller: 'galleriesCtrl',
						controllerAs: 'vm',
					}
				},
				data: {
					permissions: {
						only: ['EVERY_ONE']
					}
				}
			})
			.state('user-home-page.guest.galleries-type', {
				url: '/galleries/:type',
				views: {
					'mainPersonal@user-home-page.guest': {
						templateUrl: 'app/user-home-page/components/user-profile-galleries/galleries.html',
						controller: 'galleriesCtrl',
						controllerAs: 'vm',
					}
				},
				data: {
					permissions: {
						only: ['EVERY_ONE']
					}
				}
			})
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('userProfileCommunitiesCtrl', userProfileCommunitiesCtrl);

	userProfileCommunitiesCtrl.$inject = ['userPromise', 'pixerfApiCommunitySvc', 'arrayUtils', '$state', 'infoRequirePopupSvc', '$stateParams', 'sessionManagerSvc'];

	function userProfileCommunitiesCtrl(userPromise, pixerfApiCommunitySvc, arrayUtils, $state, infoRequirePopupSvc, $stateParams, sessionManagerSvc) {
		var self = this;
		var mProfileId = parseInt($stateParams.id);
		self.user = userPromise;
		self.contextPage = "Communities";
		self.loginnedUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.socialShareContent = buildSocialShareContent(self.user);
		self.onLearnMoreClicked = onLearnMoreClicked;
		self.isMyProfile = (self.loginnedUser && self.loginnedUser.id === mProfileId) || (!mProfileId && self.loginnedUser);
		
		init();

		function init() {
			var popup = infoRequirePopupSvc.getPopup();
			if (popup) {
				requireInfoPoupHandler(popup);
			}
			getCommunities();
			buildUserServiceData(self.user.profile);
		}

		function buildUserServiceData(serviceData) {
			self.serviceData = {};
			self.serviceData.specialities = buildSpecialities(serviceData.specialities);
			self.serviceData.years_of_experience = serviceData.years_of_experience;
			self.serviceData.availability_weekdays = arrayUtils.isValueArr(serviceData.availability_weekdays) ? buildAvailabilityText(serviceData.availability_weekdays) : "";
			self.serviceData.availability_weekends = arrayUtils.isValueArr(serviceData.availability_weekends) ? buildAvailabilityText(serviceData.availability_weekends) : "";
			self.serviceData.cameras = arrayUtils.isValueArr(serviceData.cameras) ? serviceData.cameras.join(", ") : "";
		}

		function buildAvailabilityText(time) {
			if (!time || !time.length) return "";
			if (time.length === 2) {
				return "day-and-evening";
			} else if (time[0] === "day") {
				return "day-only";
			} else {
				return "evening-only";
			}
		}

		function buildSpecialities(specialitiesArray) {
			if (!arrayUtils.isValueArr(specialitiesArray)) return "";
			var specialities = [];
			for (var i = 0; i < specialitiesArray.length; i++) {
				specialities.push(specialitiesArray[i].name);
			}
			return specialities.join(", ");
		}

		function getCommunities() {
			pixerfApiCommunitySvc.list({
				user_id: self.user.id,
				membership: 'owner'
			}).$promise.then(function (response) {
				self.communities = response.data.splice(0, 2);
			});
		}

		function buildSocialShareContent(user) {
			return {
				'url': user.path,
				'description': user.bio,
				'title': user.displayName,
				'media': user.avatar.profileImage
			};
		}

		function onLearnMoreClicked(section) {
			$state.go('introduction-support.faq.business', {
				section: section
			});
		}
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('sidebarBusinessProfileCtrl', sidebarBusinessProfileCtrl);

	sidebarBusinessProfileCtrl.$inject = ['$scope', 'notifyTopupCreditPopupSvc', 'authSvc', 'arrayUtils', '$state', 'infoRequirePopupSvc', 'commisionNotAvailablePopupSvc', 'pixerfApiMissionSvc', 'pixerfApiCommunitySvc', 'pixerfApiCustomCommssionsSvc', 'userHomePageSvc', 'customCommissionBasicFormPopupSvc', 'createCommunityPopupSvc'];

	function sidebarBusinessProfileCtrl($scope, notifyTopupCreditPopupSvc, authSvc, arrayUtils, $state, infoRequirePopupSvc, commisionNotAvailablePopupSvc, pixerfApiMissionSvc, pixerfApiCommunitySvc, pixerfApiCustomCommssionsSvc, userHomePageSvc, customCommissionBasicFormPopupSvc, createCommunityPopupSvc) {
		var self = this;

		self.user = $scope.$parent.vm.user;
		self.serviceData = $scope.$parent.vm.serviceData;
		self.missions = $scope.$parent.vm.missions;
		self.isMyProfile = $scope.$parent.vm.isMyProfile;
		self.isProfileNotCompleted = $scope.$parent.vm.isProfileNotCompleted;

		self.onEditProfileClicked = authSvc.navigateTo;
		self.onCompleteProfileClicked = onCompleteProfileClicked;
		self.onRunCustomCommissionClicked = onRunCustomCommissionClicked;
		self.onRunMissionClicked = onRunMissionClicked;
        self.onBuyStock = onBuyStock;
        self.onCreateCommunity = onCreateCommunity;

		self.customCommissions = [];
        self.missions = [];

		self.shortcutCustomCommission = {
			"icon": "icon-pic-cam",
			"title": "Book a Shoot"
		};
		self.shortcutMission = {
			"icon": "icon-icons_mission",
			"title": "Run a Challenge"
		};
        self.shortcutStock = {
			"icon": "icon-Buy-Images",
			"title": "Buy Stock"
		};
        self.shortcutCommunity = {
			"icon": "icon-community_2",
			"title": "Create Community"
		};

		self.sidebarScrollToFixed = userHomePageSvc.getSidebarFixedPosition('.sidebar-business-profile');
		self.scrollToFixedWhen = {
			minWidth: 768
		};

		init();

		function init() {
			var popup = infoRequirePopupSvc.getPopup();
			if (popup) {
				requireInfoPoupHandler(popup);
			}
			getCommunities();
			getOngoingMissions(true);
			getCustomCommmissions();
		}

		function requireInfoPoupHandler(popup) {
			if (popup) {
				popup.result.then(function () {
					self.banner = buildBannerMessage();
				}, function () {
					self.banner = buildBannerMessage();
				})
			}
		}

		function getCommunities() {
			pixerfApiCommunitySvc.list({
				user_id: self.user.id,
				membership: 'owner'
			}).$promise.then(function (response) {
				self.communities = response.data.splice(0, 2);
			})
		}

		function getOngoingMissions(isFresh) {
			var action = "get_manage_mission";
			var searchParams = {};
			searchParams.page_size = 2;
			searchParams.type = 'current';
			if (!self.isMyProfile) {
				searchParams.user_id = self.user.id;
				action = "query";
			}
			searchParams.sort = ["inserted_at,desc"];
			if (isFresh) self.searchParams = searchParams;
			pixerfApiMissionSvc[action](searchParams).$promise.then(function (response) {
				if (isFresh) self.missions = [];
				if (response && response.data && response.data.missions && response.data.missions.length > 0) {
					var missions = self.missions.concat(response.data.missions);
					self.missions = missions.slice(0, 2);
				}
			}, function (err) {
				console.log(err);
			})
		}

		function getCustomCommmissions() {
			var membership = self.isContributor ? 'accepted' : 'owner';
			pixerfApiCustomCommssionsSvc.get({
				membership: membership
			}).$promise.then(function (repoonse) {
				self.customCommissions = repoonse.data;
			})
		}

		function onCompleteProfileClicked() {
			var steps = {};
			if (!stringUtils.isValueString(self.user.profile) || !stringUtils.isValueString(self.user.profile.services_rate_amount) ||
				!self.user.profile.services_rate_type || !arrayUtils.isValueArr(self.user.profile.cameras) ||
				(!arrayUtils.isValueArr(self.user.profile.availability_weekdays) && !arrayUtils.isValueArr(self.user.profile.availability_weekends)) ||
				!self.user.profile_image && !accountUtils.isSocialAccount(self.user)) {
				$state.go("complete-profile-page");
			} else {
				if (!self.user.cover_image) {
					steps["COVER_IMAGE"] = {
						name: "COVER_IMAGE",
						title: "Choose a Cover Photo",
						requiredFields: ["cover_image"],
						validator: function (user) {
							return !user.cover_image ? "Please choose your cover photo!" : "";
						},
						canSkip: true
					};
				}
				if (self.user.canUploadPhotos && self.user.stats.media_count < 20) {
					steps["UPLOADS"] = {
						name: "UPLOADS",
						title: "Upload your photos",
						requiredFields: ["media_counts"],
						canSkip: true
					};
				}
				var popup = infoRequirePopupSvc.showPopup({
					user: self.user,
					steps: steps
				});
				self.isProfileNotCompleted = false;
				self.banner = "";
				requireInfoPoupHandler(popup);
			}
		}

		function onRunCustomCommissionClicked() {
			customCommissionBasicFormPopupSvc.showPopup();
		}

		function onRunMissionClicked() {
			if (self.user && self.user.canCreateMission) {
				$state.go("setting.manage-missions.on-going");
				// $state.go("setting.manage-missions.create-mission.getting-started");
			}
		}

        function onBuyStock() {
			$state.go("buy-stock-page.about-stock");
		}

        function onCreateCommunity(){
            createCommunityPopupSvc.showPopup();
        }
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('businessProfileCtrl', businessProfileCtrl);

	businessProfileCtrl.$inject = ['userPromise', 'pixerfApiCommunitySvc', 'arrayUtils', '$state', 'infoRequirePopupSvc', '$stateParams', 'sessionManagerSvc', 'pixerfApiMissionSvc'];

	function businessProfileCtrl(userPromise, pixerfApiCommunitySvc, arrayUtils, $state, infoRequirePopupSvc, $stateParams, sessionManagerSvc, pixerfApiMissionSvc) {
		var self = this;
		var mProfileId = parseInt($stateParams.id);
		self.contextPage = "Feed";
		self.user = userPromise;
		self.loginnedUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.socialShareContent = buildSocialShareContent(self.user);
		self.onLearnMoreClicked = onLearnMoreClicked;
		self.canManageCommunity = self.loginnedUser && self.loginnedUser.data && self.loginnedUser.data.canManageCommunity;
		self.isMyProfile = (self.loginnedUser && self.loginnedUser.id === mProfileId) || (!mProfileId && self.loginnedUser);

		self.isSelectedPhotos = false;
		self.bulkSelectedPhoto = []
		self.options ={
			bulkEditPhoto: self.isSelectedPhotos,
			bulkSelectedPhoto: self.bulkSelectedPhoto,
			onBulkEditChanged: onBulkEditChanged
		}

		init();

		function init() {
			var popup = infoRequirePopupSvc.getPopup();
			if (popup) {
				requireInfoPoupHandler(popup);
			}
			getCommunities();
			getOngoingMissions(true);
		}

		function onBulkEditChanged(data){
			self.bulkSelectedPhoto = data
		}

		function getOngoingMissions(isFresh) {
			var action = "get_manage_mission";
			var searchParams = {};
			searchParams.page_size = 2;
			searchParams.type = 'current';
			if (!self.isMyProfile) {
				searchParams.user_id = self.user.id;
				action = "query";
			}
			searchParams.sort = ["inserted_at,desc"];
			if (isFresh) self.searchParams = searchParams;
			pixerfApiMissionSvc[action](searchParams).$promise.then(function (response) {
				if (isFresh) self.missions = [];
				if (response && response.data && response.data.missions && response.data.missions.length > 0) {
					var missions = self.missions.concat(response.data.missions);
					self.missions = missions.slice(0, 2);
				}
			}, function (err) {
				console.log(err);
			})
		}

		function getCommunities() {
			pixerfApiCommunitySvc.list({
				user_id: self.user.id,
				membership: 'owner'
			}).$promise.then(function (response) {
				self.communities = response.data.splice(0, 2);
			});
		}

		function buildSocialShareContent(user) {
			return {
				'url': user.path,
				'description': user.bio,
				'title': user.displayName,
				'media': user.avatar.profileImage
			};
		}

		function onLearnMoreClicked(section) {
			$state.go('introduction-support.faq.business', {
				section: section
			});
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.config(routerConfig);

	routerConfig.$inject = ['$stateProvider'];

	function routerConfig($stateProvider) {
		'ngInject';
		$stateProvider
			.state('user-home-page.business.communities', {
				url: '/community',
				views: {
					'mainBusiness@user-home-page.business': {
						templateUrl: 'app/user-home-page/components/user-profile-communities/user-profile-communities-grid/user-profile-communities-grid.html',
						controller: 'userProfileCommunitiesGridCtrl',
						controllerAs: 'vm'
					}
				},
				data: {
					permissions: {
						only: ['EVERY_ONE']
					}
				}
			})
			.state('user-home-page.business.galleries', {
                url: '/galleries',
                views: {
                    'mainBusiness@user-home-page.business': {
                        templateUrl: 'app/user-home-page/components/user-profile-galleries/galleries.html',
                        controller: 'galleriesCtrl',
                        controllerAs: 'vm',
                    }
                },
                data: {
                    permissions: {
                        only: ['EVERY_ONE']
                    }
                }
            })
			.state('user-home-page.business.communities.grid', {
				url: '/all',
				templateUrl: 'app/user-home-page/components/user-profile-communities/user-profile-communities-grid/user-profile-communities-grid.html',
				controller: 'userProfileCommunitiesGridCtrl',
				controllerAs: 'vm'
			});
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('sidebarInstitutionProfileCtrl', sidebarInstitutionProfileCtrl);

	sidebarInstitutionProfileCtrl.$inject = ['userPromise'];

	function sidebarInstitutionProfileCtrl(userPromise) {
		var self = this;
		self.user = userPromise;
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('InstitutionProfileCtrl', InstitutionProfileCtrl);

	InstitutionProfileCtrl.$inject = ['userPromise'];

	function InstitutionProfileCtrl(userPromise) {
		var self = this;
		self.user = userPromise;
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('marketplaceSignatureGalleriesCtrl', marketplaceSignatureGalleriesCtrl);

	marketplaceSignatureGalleriesCtrl.$inject = ['$scope', 'pixerfApiCategorySvc', 'toastr', '$rootScope', 'sessionManagerSvc'];

	function marketplaceSignatureGalleriesCtrl($scope, pixerfApiCategorySvc, toastr, $rootScope, sessionManagerSvc) {
		var self = this;
		self.categories = [];
		self.loginedUser = sessionManagerSvc.getCurrentLoginUser().data;

		init();

		function init() {
			getCategories();
		}

		function getCategories() {
			pixerfApiCategorySvc.get(function (response) {
				self.categories = response;
				self.categories = _.map(self.categories, function(cate){
					cate.thumbnails['local'] = '../assets/images/signature-galleries/' + cate.name.split(' ')[0].toLowerCase() + '.jpg';
					return cate;
				})
			}, function () {
				toastr.error($translate.instant('failed-to-get-categories'));
			});
		}
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('marketplacePixerferGalleriesCtrl', marketplacePixerferGalleriesCtrl);

	marketplacePixerferGalleriesCtrl.$inject = ['galleryConst', '$scope', 'toastr', '$stateParams', 'headerSvc', 'sessionManagerSvc', '$state', 'numberUtils', 'systemUtils'];

	function marketplacePixerferGalleriesCtrl(galleryConst, $scope, toastr, $stateParams, headerSvc, sessionManagerSvc, $state, numberUtils, systemUtils) {
		var self = this;
		self.topGalleries = [];
		self.galleryGridAll = null;
		self.onScrollToGallery = onScrollToGallery;
		self.onStaredToggled = onStaredToggled;
		self.onLoadMorePage = onLoadMorePage;
		self.onBackbtnClicked = onBackbtnClicked;
		self.scrollToFixedHeaderSettings = headerSvc.getFixedByHeaderSetting();
		self.loginUser = sessionManagerSvc.getCurrentLoginUser().data;

		$scope.$watch("vm.galleryGridAll", function () {
			if (self.galleryGridAll) {
				extractSearchParam();
				self.galleryGridAll.fetchGalleries({
					type: 'pixerf',
					page: $state.params.page ? $state.params.page : 1
				}, true).then(function () {
					self.pagerUnit = self.galleryGridAll.galleries.length === 1 ? "Gallery" : "Galleries";
					self.headerName = "pixerfer-galleries";
					self.description = "marketplace-pixerfer-galleries-description";
					self.pagerText = "Pixerfers'";
					self.mobileBreadcrumb = "Pixerfers' Galleries";
					self.topGalleries = getTopGalleries(self.galleryGridAll.galleries);
					$scope.$parent.vm.totalPage = self.galleryGridAll.totalPage;
				}, function () {

				})
			}
		})

		function extractSearchParam() {
			if (!$state.params.type) $state.params.type = galleryConst.GALLERY_TYPE.PIXERF;

			if ($state.params.page) {
				var parsePage = numberUtils.parseInt($state.params.page);
				$state.params.page = parsePage ? parsePage : 1;
			} else {
				$state.params.page = 1;
			}
			$scope.$parent.vm.page = $state.params.page;
		}

		function removeGallery(galleries, gallery) {
			galleries = _.reject(galleries, function (item) {
				return item.id === gallery.id;
			});
			return galleries;
		}

		function getTopGalleries(galleries) {
			var numTopGalleries = Math.min(galleries.length, galleryConst.TOP_PIXERFER_GALLERY);
			return galleries.slice(0, numTopGalleries);
		}

		function onStaredToggled(gallery) {
			if ($stateParams.type === galleryConst.GALLERY_TYPE.PIXERF) {
				if (!gallery.is_starred) {
					if (gallery.star_count <= 0) {
						self.galleryGridAll.galleries = removeGallery(self.galleryGridAll.galleries, gallery);
						self.topGalleries = removeGallery(self.topGalleries, gallery);
					}
				}
			}
		}

		function updateUrlParams(page) {
			if (systemUtils.isMobile()) {
				$state.params.page = "";
				$state.go($state.current.name, $state.params, {
					notify: false
				});
				return;
			}
			$scope.$parent.vm.page = page;
			$state.params.page = page;
			$state.go($state.current.name, $state.params, {
				notify: false
			});
		}

		function onScrollToGallery(page) {
			updateUrlParams(page);
		}

		function onLoadMorePage(page) {
			updateUrlParams(page);
		}

		function onBackbtnClicked() {
			$state.go("marketplace.galleries");
		}
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('marketplaceFollowedGalleriesCtrl', marketplaceFollowedGalleriesCtrl);

	marketplaceFollowedGalleriesCtrl.$inject = ['galleryConst', '$scope', 'toastr', '$stateParams', 'headerSvc', 'sessionManagerSvc', '$state', 'numberUtils', 'systemUtils'];

	function marketplaceFollowedGalleriesCtrl(galleryConst, $scope, toastr, $stateParams, headerSvc, sessionManagerSvc, $state, numberUtils, systemUtils) {
		var self = this;
		self.topGalleries = [];
		self.galleryGridAll = null;
		self.onScrollToGallery = onScrollToGallery;
		self.onStaredToggled = onStaredToggled;
		self.onLoadMorePage = onLoadMorePage;
		self.onBackbtnClicked = onBackbtnClicked;
		self.scrollToFixedHeaderSettings = headerSvc.getFixedByHeaderSetting();
		self.loginUser = sessionManagerSvc.getCurrentLoginUser().data;

		$scope.$watch("vm.galleryGridAll", function () {
			if (self.galleryGridAll) {
				extractSearchParam();
				self.galleryGridAll.fetchGalleries({
					type: 'following',
					page: $state.params.page ? $state.params.page : 1,
					userid: self.loginUser.id
				}, true).then(function () {
					self.pagerUnit = self.galleryGridAll.galleries.length === 1 ? "Gallery" : "Galleries";
					self.headerName = "Galleries you followed";
					self.description = "marketplace-pixerfer-galleries-description";
					self.pagerText = "Pixerfers'";
					self.mobileBreadcrumb = "Galleries you followed";
					self.topGalleries = getTopGalleries(self.galleryGridAll.galleries);
					$scope.$parent.vm.totalPage = self.galleryGridAll.totalPage;
				}, function () {

				})
			}
		})

		function extractSearchParam() {
			if (!$state.params.type) $state.params.type = galleryConst.GALLERY_TYPE.FOLLOWING;

			if ($state.params.page) {
				var parsePage = numberUtils.parseInt($state.params.page);
				$state.params.page = parsePage ? parsePage : 1;
			} else {
				$state.params.page = 1;
			}
			$scope.$parent.vm.page = $state.params.page;
		}

		function removeGallery(galleries, gallery) {
			galleries = _.reject(galleries, function (item) {
				return item.id === gallery.id;
			});
			return galleries;
		}

		function getTopGalleries(galleries) {
			var numTopGalleries = Math.min(galleries.length, galleryConst.TOP_PIXERFER_GALLERY);
			return galleries.slice(0, numTopGalleries);
		}

		function onStaredToggled(gallery) {
			if ($stateParams.type === galleryConst.GALLERY_TYPE.PIXERF) {
				if (!gallery.is_starred) {
					if (gallery.star_count <= 0) {
						self.galleryGridAll.galleries = removeGallery(self.galleryGridAll.galleries, gallery);
						self.topGalleries = removeGallery(self.topGalleries, gallery);
					}
				}
			}
		}

		function updateUrlParams(page) {
			if (systemUtils.isMobile()) {
				$state.params.page = "";
				$state.go($state.current.name, $state.params, {
					notify: false
				});
				return;
			}
			$scope.$parent.vm.page = page;
			$state.params.page = page;
			$state.go($state.current.name, $state.params, {
				notify: false
			});
		}

		function onScrollToGallery(page) {
			updateUrlParams(page);
		}

		function onLoadMorePage(page) {
			updateUrlParams(page);
		}

		function onBackbtnClicked() {
			$state.go("marketplace.galleries");
		}
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('marketplaceCuratedGalleriesCtrl', marketplaceCuratedGalleriesCtrl);

	marketplaceCuratedGalleriesCtrl.$inject = ['galleryConst', '$scope', 'toastr', '$stateParams', 'headerSvc', 'sessionManagerSvc', '$state', 'numberUtils', 'systemUtils'];

	function marketplaceCuratedGalleriesCtrl(galleryConst, $scope, toastr, $stateParams, headerSvc, sessionManagerSvc, $state, numberUtils, systemUtils) {
		var self = this;
		self.topGalleries = [];
		self.galleryGridAll = null;
		self.onScrollToGallery = onScrollToGallery;
		self.onStaredToggled = onStaredToggled;
		self.onLoadMorePage = onLoadMorePage;
		self.onBackbtnClicked = onBackbtnClicked;
		self.scrollToFixedHeaderSettings = headerSvc.getFixedByHeaderSetting();
		self.loginUser = sessionManagerSvc.getCurrentLoginUser().data;

		$scope.$watch("vm.galleryGridAll", function () {
			if (self.galleryGridAll) {
				extractSearchParam();
				self.galleryGridAll.fetchGalleries({
					type: 'signature',
					page: $state.params.page ? $state.params.page : 1,
					userid: self.loginUser.id
				}, true).then(function () {
                    $scope.$parent.vm.pagerUnit = self.signatureGalleries.galleries.length === 1 ? "Gallery" : "Galleries";
                    $scope.$parent.vm.mobileBreadcrumb =  "Curated galleries";
                    self.topGalleries = getTopGalleries(self.signatureGalleries.galleries);
                    $scope.$parent.vm.totalPage = self.signatureGalleries.totalPage;
				}, function () {

				})
			}
		})

		function extractSearchParam() {
			if (!$state.params.type) $state.params.type = galleryConst.GALLERY_TYPE.CURATED;

			if ($state.params.page) {
				var parsePage = numberUtils.parseInt($state.params.page);
				$state.params.page = parsePage ? parsePage : 1;
			} else {
				$state.params.page = 1;
			}
			$scope.$parent.vm.page = $state.params.page;
		}

		function removeGallery(galleries, gallery) {
			galleries = _.reject(galleries, function (item) {
				return item.id === gallery.id;
			});
			return galleries;
		}

		function getTopGalleries(galleries) {
			var numTopGalleries = Math.min(galleries.length, galleryConst.TOP_PIXERFER_GALLERY);
			return galleries.slice(0, numTopGalleries);
		}

		function onStaredToggled(gallery) {
			if ($stateParams.type === galleryConst.GALLERY_TYPE.PIXERF) {
				if (!gallery.is_starred) {
					if (gallery.star_count <= 0) {
						self.galleryGridAll.galleries = removeGallery(self.galleryGridAll.galleries, gallery);
						self.topGalleries = removeGallery(self.topGalleries, gallery);
					}
				}
			}
		}

		function updateUrlParams(page) {
			if (systemUtils.isMobile()) {
				$state.params.page = "";
				$state.go($state.current.name, $state.params, {
					notify: false
				});
				return;
			}
			$scope.$parent.vm.page = page;
			$state.params.page = page;
			$state.go($state.current.name, $state.params, {
				notify: false
			});
		}

		function onScrollToGallery(page) {
			updateUrlParams(page);
		}

		function onLoadMorePage(page) {
			updateUrlParams(page);
		}

		function onBackbtnClicked() {
			$state.go("marketplace.galleries");
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('managePhotosSoldListCtrl', managePhotosSoldListCtrl);

	managePhotosSoldListCtrl.$inject = ['$scope', 'toastr', 'pixerfApiSalesSvc', 'translationSvc'];

	function managePhotosSoldListCtrl($scope, toastr, pixerfApiSalesSvc, translationSvc) {
		var self = this;
		self.spinner = {isVisible: false}
		self.fetchMorePurchasedItems = fetchMorePurchasedItems;
		self.items = [];
		self.searchParams = {};

		initRecentSoldPhotos(self.selectedFilter);

		function initRecentSoldPhotos(filter){
			self.searchParams = {
				page: 1,
				page_size: 5,
				start_date: null,
				end_date: null
			};
			fetchPurchasedItems(self.searchParams, true);
		}
		function fetchPurchasedItems(searchParams, isFresh){
			var timeRange = null;
			self.spinner.isVisible = true;
			if(isFresh) self.items = [];
			pixerfApiSalesSvc.post(searchParams).$promise.then(function(response){
				if(searchParams.page === 1) self.items = [];
				self.items = response.data;
                self.spinner.isVisible = false;
			}, function(){
				self.spinner.isVisible = false;
				toastr.error(translationSvc.FAILED_TO_DO_SOMETHING('FAILED_ORDER_LIST', true));
			})
		}
		function fetchMorePurchasedItems(){
			 if(self.spinner.isVisible){
                return;
            }
            self.searchParams.page ++;
			fetchPurchasedItems(self.searchParams);
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('managePhotosSoldDetailsCtrl', managePhotosSoldDetailsCtrl);

	managePhotosSoldDetailsCtrl.$inject = ['$scope', '$stateParams', 'pixerfApiSalesSvc', 'pixerfApiDownloadSvc', 'pixerfUrl', 'toastr', '$timeout', 'translationSvc'];

	function managePhotosSoldDetailsCtrl($scope, $stateParams, pixerfApiSalesSvc, pixerfApiDownloadSvc, pixerfUrl, toastr, $timeout, translationSvc) {
		var self = this;
		self.spinner = {isVisible: false};
		self.onBackBtnClicked = onBackBtnClicked;
		self.orderId = $stateParams.orderId;
		self.onDownloadBtnClicked = onDownloadBtnClicked;

		self.searchParams = {
			orderId: self.orderId
		};

		fetchPurchasedItems(self.searchParams, true);

		function onDownloadBtnClicked(evt, item, type){
			var service = type  ?  type : "download" ;
			if(self.isWorking){
				return;
			}
			self.isWorking  = true;
			pixerfApiDownloadSvc.get({id: item.id}).$promise.then(function(response){
				item.downloadLink = pixerfUrl.full + "api/" + service + "?token=" + response.token;
				$timeout(function(){
					$(evt.target).next("a")[0].click();
					$timeout(function(){
						self.isWorking  = false;
					})
				})
			}, function(){
				self.isWorking  = false;
				toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
			})
		}

		function fetchPurchasedItems(searchParams, isFresh){
			self.spinner.isVisible = true;
			if(isFresh) self.item = {};
			pixerfApiSalesSvc.getById(searchParams).$promise.then(function(response){
				self.spinner.isVisible = false;
                if(response && response.data){
					self.item = response.data;
                }
			}, function(){
				self.spinner.isVisible = false;
				toastr.error(translationSvc.FAILED_TO_DO_SOMETHING('FAILED_PURCHASED_ITEMS', true));
			})
		}

		function onBackBtnClicked(){
			window.history.go(-1);
		}
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('customCommissionsDeliveryShootListCtrl', customCommissionsDeliveryShootListCtrl);

	customCommissionsDeliveryShootListCtrl.$inject = ['$scope', 'customCommissionsData', '$rootScope', 'customCommissionsConst'];

	function customCommissionsDeliveryShootListCtrl($scope, customCommissionsData, $rootScope, customCommissionsConst) {

		var self = this;
		self.customCommissionsConst = customCommissionsConst;
		self.customCommissions = customCommissionsData;
		self.customCommissionsDetailPageDeliveryCtrl = $scope.$parent.vm;
		self.items = [];

		self.onShootClicked = onShootClicked;
		self.selectedShoot = {};

		$rootScope.$on('loadedDeliveriedShoots', function (event, data) {
			if(self.customCommissions && [13, 28, 32].includes(self.customCommissions.id)){
				self.items = _.sortBy(self.customCommissionsDetailPageDeliveryCtrl.customCommissions, function(item){
					return parseInt(item.name.split('.')[0]);
				});
			} else{
				self.items = self.customCommissionsDetailPageDeliveryCtrl.customCommissions;
			}
		})

		function onShootClicked(shoot, isAllShoots) {
			self.customCommissionsDetailPageDeliveryCtrl.onShootClicked(shoot);
			if (isAllShoots) {
				self.isSelectAll = true;
			} else {
				self.isSelectAll = false;
				if (shoot.is_viewed) {
					shoot.is_viewed = false;
				}
			}
			$scope.$emit('loadedDetailsDeliveriedShoot', shoot);
		}
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('customCommissionsDeliveryMainContentCtrl', customCommissionsDeliveryMainContentCtrl);

	customCommissionsDeliveryMainContentCtrl.$inject = ['$scope', '$rootScope', 'pixerfApiCustomCommssionsSvc', 'customCommissionsData', 'uploadCustomCommissionsPopupSvc', 'customCommissionsDetailPageSvc'];

	function customCommissionsDeliveryMainContentCtrl($scope, $rootScope, pixerfApiCustomCommssionsSvc, customCommissionsData, uploadCustomCommissionsPopupSvc, customCommissionsDetailPageSvc) {

		var self = this;
		var customCommissionsDetailPageDeliveryCtrl = $scope.$parent.vm;
		self.selectAllBtn = 'select-all';
		self.shoot = {};
		self.items = [];
		self.searchParams = {
			page_size: 500
		};
		self.selectedItems = [];
		self.customCommissions = customCommissionsData;
		self.isManager = customCommissionsDetailPageDeliveryCtrl.isManager;
		self.onUploadPhotoClicked = onUploadPhotoClicked;
		self.dataSelected = dataSelected;
		self.dataDeselected = dataDeselected;
		self.onDownloadAllClicked = onDownloadAllClicked;
		self.onDownloadPhotosClicked = onDownloadPhotosClicked;
		self.isDownloading = false;
		self.decideSelecteOrDeselectAll = decideSelecteOrDeselectAll;

		self.customCommissionsTileOptions = {
			showBorder: true,
			showComment: true,
			showHoverBorder: false,
			canSelect: self.isManager,
			showDownloadButton: self.isManager,
			showDisableDownload: true,
			canDisableDownload: !self.isManager
		}

		$rootScope.$on('loadedDetailsDeliveriedShoot', function (event, data) {
			resetData();
			var param = {
				page_size: 500,
				type: self.isManager ? 'available_to_download' : 'my_hires_submission'
			};
			if (data && data.id) {
				param.shoot_id = data.id;
				self.shoot = data;

				pixerfApiCustomCommssionsSvc.getPhotosByShootId(param).$promise.then(function (res) {
					self.items = res.data;
					if(self.items && self.items.length){
						Tiff.initialize({TOTAL_MEMORY: 19777216 * self.items.length});
					}
				}).catch(function (err) {
					console.log(err);
				})
			} else {
				loadPhotosFromAll(param, true);
			}
		})

		$rootScope.$on('submissionStatusChanged', function (event, data) {
			self.items = self.items.map(function (item) {
				if (data.id === item.id) {
					item.isSelected = data.isSelected;
					if (item.isSelected) {
						self.selectedItems.push(data);
					} else {
						self.selectedItems = _.reject(self.selectedItems, function (item) {
							return item.id != data.id;
						})
					}
				}
				return item;
			})
		})

		function onUploadPhotoClicked() {
			self.customCommissions.hires = true;
			uploadCustomCommissionsPopupSvc.showUploadModal({
				files: self.customCommissions,
				shoot: self.shoot,
				popupTitle: 'Upload high resolution photos'
			});
		}

		function resetData(isResetSearch) {
			self.selectAllBtn = 'select-all';
			self.items = [];
			self.selectedItems = [];
			if (isResetSearch) {
				self.searchParams.page = 1;
			} else {
				self.searchParams = {
					page: 1,
					page_size: 500
				};
			}
		}

		function dataSelected(data) {
			self.selectedItems.push(data);
		}

		function dataDeselected(data) {
			self.selectedItems = _.reject(self.selectedItems, function (item) {
				return data.id === item.id;
			})
		}

		function onDownloadAllClicked() {
			if (!self.items.length) return;
			self.isDownloading = true;
			var downloadItems = self.items;
			downloadItems = filterDisabledDownloadItem(downloadItems);

			customCommissionsDetailPageSvc.downloadPhotos(self.shoot, downloadItems).then(function (respone) {
				self.isDownloading = false;
				window.location.href = respone;
			}).catch(function (err) {
				self.isDownloading = false;
				console.log(err);
			});
		}

		function filterDisabledDownloadItem(items) {
			items = _.reject(items, function (item) {
				return !item.is_download_enabled;
			})

			return items;
		}

		function onDownloadPhotosClicked() {
			customCommissionsDetailPageSvc.downloadPhotos(self.shoot, self.selectedItems).then(function (respone) {
				self.isDownloading = false;
				window.location.href = respone;
			}).catch(function (err) {
				self.isDownloading = false;
				console.log(err);
			});
		}

		function decideSelecteOrDeselectAll() {
			var availableItems = filterDisabledDownloadItem(self.items);
			if (self.selectedItems.length != availableItems.length) {
				self.selectedItems = availableItems;
				self.selectAllBtn = 'deselect-all';
				self.items = self.items.map(function (item) {
					if (_.pluck(self.selectedItems, 'id').includes(item.id)) {
						item.isSelected = true;
					}
					return item;
				});
			} else {
				self.items = self.items.map(function (item) {
					item.isSelected = false;
					return item;
				});
				self.selectAllBtn = 'select-all';
				self.selectedItems = [];
			}
		}

		function loadPhotosFromAll(searchParams, isRefresh) {
			if (isRefresh) {
				resetData(true);
			}
			searchParams.id = self.customCommissions.id;
			searchParams.is_hires = true;
			pixerfApiCustomCommssionsSvc.getPhotosByAllShoot(searchParams).$promise.then(function (res) {
				self.items = res.data;
			}).catch(function (err) {
				console.log(err);
			})
		}
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('customCommissionsApprovalShootListCtrl', customCommissionsApprovalShootListCtrl);

	customCommissionsApprovalShootListCtrl.$inject = ['$scope', 'customCommissionsData', '$rootScope', 'pixerfApiCustomCommssionsSvc', 'systemUtils', 'customCommissionsDetailPageSvc', 'sessionManagerSvc', 'customCommissionsConst'];

	function customCommissionsApprovalShootListCtrl($scope, customCommissionsData, $rootScope, pixerfApiCustomCommssionsSvc, systemUtils, customCommissionsDetailPageSvc, sessionManagerSvc, customCommissionsConst) {

		var self = this;
		self.customCommissionsConst = customCommissionsConst;
		self.customCommissions = customCommissionsData;
		self.onShootLabelEdit = onShootLabelEdit;
		self.customCommissionsDetailPageApprovalCtrl = $scope.$parent.vm;
		self.loginedUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.items = [];
		self.isMine = false;
		self.editShootLabel = false;
		self.onShootClicked = onShootClicked;
		self.onAcceptShootLabelClicked = onAcceptShootLabelClicked;
		self.onCancelShootLabelClicked = onCancelShootLabelClicked;
		self.selectedShoot = {};
		self.isManager = self.customCommissionsDetailPageApprovalCtrl.isManager;

		init();

		function init() {
			self.isMine = self.customCommissions.user.id === self.loginedUser.id;
			self.shootLabelName = self.customCommissions.shoot_label_name;
			$rootScope.$on('loadedShootList', function (event, data) {
				if(self.customCommissions && [13, 28, 32].includes(self.customCommissions.id)){
					self.items = _.sortBy(self.customCommissionsDetailPageApprovalCtrl.customCommissions, function(item){
						return parseInt(item.name.split('.')[0]);
					});
				} else{
					self.items = self.customCommissionsDetailPageApprovalCtrl.customCommissions;
				}
			})
		}

		function onShootClicked(shoot, isAllShoots) {
			self.customCommissionsDetailPageApprovalCtrl.onShootClicked(shoot);
			if (isAllShoots) {
				self.isSelectAll = true;
			} else {
				self.isSelectAll = false;
				if (self.isManager) {
					pixerfApiCustomCommssionsSvc.setViewed({
						shoot_id: shoot.id
					}, {}).$promise.then(function (res) {
						if (res.data.is_viewed) {
							shoot.is_viewed = true;
							customCommissionsDetailPageSvc.setCustomComission(shoot);
							systemUtils.digest($scope);
						}
					}).catch(function (err) {
						console.log(err);
					})
				}
			}
			$scope.$emit('loadedDetailsShoot', shoot);
		}

		function onShootLabelEdit() {
			self.editShootLabel = true;
		}

		function onAcceptShootLabelClicked() {
			self.editShootLabel = false;
			self.customCommissions.shoot_label_name = self.shootLabelName;
			pixerfApiCustomCommssionsSvc.update({
				id: self.customCommissions.id
			}, {
				'custom_commission': {
					'shoot_label_name': self.shootLabelName
				}
			}).$promise.then(function (response) {
				console.log(response);
			}).catch(function (error) {
				console.log(error);
			})
		}

		function onCancelShootLabelClicked() {
			self.editShootLabel = false;
			self.shootLabelName = self.customCommissions.shoot_label_name;
		}
	}
})();

(function(){

  angular
    .module('pixerf')
    .factory('missionApprovedPreviewSvc', missionApprovedPreviewSvc);

    missionApprovedPreviewSvc.$inject = ['$uibModal', 'pixerfApiMissionSvc', '$q'];

    function missionApprovedPreviewSvc($uibModal, pixerfApiMissionSvc, $q){
    	
		function showPopup(data){
            $uibModal.open({
                templateUrl: 'app/custom-commissions-detail-page/components/custom-commissions-detail-page-approval/mission-approved-preview/mission-approved-preview.html',
                controller: 'missionApprovedPreviewCtrl',
                controllerAs: 'vm',
                size: "full",
                animation: true,
                windowClass: 'zindex mission-approved-preview-popup',
                resolve: {
                    popupData: function(){
                        return data;
                    }
                }
            });
        }

		return {
			showPopup: showPopup
		};
    }
})();

(function(){

  angular
    .module('pixerf')
    .controller('missionApprovedPreviewCtrl', missionApprovedPreviewCtrl);

    missionApprovedPreviewCtrl.$inject = ["$scope", "popupData", "$uibModalInstance", "toastr", "$translate", "pixerfApiCustomCommssionsSvc", "translationSvc", "pixerfUrl", "$timeout"];

    function missionApprovedPreviewCtrl($scope, popupData, uibModalInstance, toastr, $translate, pixerfApiCustomCommssionsSvc, translationSvc, pixerfUrl, $timeout){
        var self = this;
        self.data = popupData;
        self.isWorking = false;
        self.downloadSizeItem = [
            {
                "size": "S",
                "toolTips": $translate.instant('tool-tip-small'),
            },
            {
                "size": "M",
                "toolTips": $translate.instant('tool-tip-medium'),
            },
            {
                "size": "L",
                "toolTips": $translate.instant('tool-tip-large'),
            }
        ];
        self.selectedSize =  null;
        self.currentPage = 1;
        self.totalPage = 1;
        self.footerDatetime = ''

        self.onDownloadSizeItemClicked = onDownloadSizeItemClicked;
        self.onDowloadBtnClicked = onDowloadBtnClicked;

        self.closePopup = function(){
            uibModalInstance.close();
        }

        function onDowloadBtnClicked(evt) {
            self.isWorking = true;
            var mediaIds = [];
            if (self.data.approvedList.length) {
                for (var i = 0; i < self.data.approvedList.length; i++) {
                    mediaIds.push(self.data.approvedList[i].media.id);
                }
            }
            var id = {
                id: self.data.shoot.id
            };

            var params = {
                shoot_id: self.data.shoot.id,
                media_ids: mediaIds,
                size: self.selectedSize.size
            };
            pixerfApiCustomCommssionsSvc.prepareDownloadContactSheetByShootId(id, params).$promise
                .then(function (response) {
                    self.downloadLink = pixerfUrl.full + "api/shoots/" + self.data.shoot.id + "/download_contact_sheet?token=" + response.data.token;
                    $timeout(function () {
                    	$(evt.target).next("a")[0].click();
                        self.isWorking = false;
                    })
                }).catch(function (err) {
                    toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
                    self.isWorking = false;
                })
        }

        function deselectAll(priceRange){
            for (var i = 0; i < self.downloadSizeItem.length; i ++){
                self.downloadSizeItem[i].isSelected = false;
            }
            self.selectedSize = null;
        }
        function onDownloadSizeItemClicked(evt, size){
            deselectAll();
            size.isSelected = true;
            self.selectedSize = size;
            self.bindingData = getListData();
        }

        function getListData() {
            var result = {
                col: 3,
                total: 20,
                items: []
            }
            switch (self.selectedSize.size) {
                case 'S':
                    result.col = 3;
                    result.total = 20;
                    break;
                case 'M':
                    result.col = 4;
                    result.total = 12;
                    break;
                case 'L':
                    result.col = 6;
                    result.total = 6;
                    break;
                default:
            }
            result.items = self.approvedList.slice(self.currentPage -1 , result.total );
            self.totalPage = Math.ceil(self.approvedList.length/result.total);
            return result;
        }

        function setDefaultSize(){
            self.selectedSize =  self.downloadSizeItem[0];
            self.downloadSizeItem[0].isSelected = true;
        }

        function init(){
            setDefaultSize();
            self.approvedList = self.data.approvedList;
            self.footerDatetime = $translate.instant('contact-sheet-prepared-on') + ' ' + moment().format("D MMMM YYYY" + '.');;
            self.organizationName = (self.data.customCommissions.organization && self.data.customCommissions.organization.name) ? self.data.customCommissions.organization.name : 'Organization';
            self.bindingData = getListData();
        }

        init();
       
    }
})();

(function () {

	angular
		.module('pixerf')
		.controller('customCommissionsApprovalMainContentCtrl', customCommissionsApprovalMainContentCtrl);

	customCommissionsApprovalMainContentCtrl.$inject = ['$scope', '$rootScope', 'pixerfApiCustomCommssionsSvc', 'sessionManagerSvc', 'pagingUtils', '$interval',
		 'uploadCustomCommissionsPopupSvc', 'customCommissionsData', 'customCommissionsDetailPageSvc', 'customCommissionsConst', 'confirmPopupSvc', 'missionApprovedPreviewSvc'];

	function customCommissionsApprovalMainContentCtrl($scope, $rootScope, pixerfApiCustomCommssionsSvc, sessionManagerSvc, pagingUtils, $interval, 
		uploadCustomCommissionsPopupSvc, customCommissionsData, customCommissionsDetailPageSvc, customCommissionsConst, confirmPopupSvc, missionApprovedPreviewSvc) {

		var self = this;
		self.customCommissionsConst = customCommissionsConst;
		var customCommissionsDetailPageApprovalCtrl = $scope.$parent.vm;
		self.selectAllBtn = 'select-all';
		self.shoot = {};
		self.items = [];
		self.dataDeselected = dataDeselected;
		self.dataSelected = dataSelected;
		self.dataChanged = dataChanged;
		self.onArrageChanged = onArrageChanged;
		self.onUploadPhotoClicked = onUploadPhotoClicked;
		self.onSubmissionDeleted = onSubmissionDeleted;
		self.onDownloadPdfClicked = onDownloadPdfClicked;
		self.onDownloadAllClicked = onDownloadAllClicked;
		self.loadMore = loadMore;
		self.decideSelecteOrDeselectAll = decideSelecteOrDeselectAll;
		self.customCommissions = customCommissionsData;
		self.arrange = {};
		self.loginedUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.isManager = customCommissionsDetailPageApprovalCtrl.isManager;
		self.arrangeOptions = {
			"items": [{
				name: "file-name",
				value: "name"
			},
			{
				name: "approval-status",
				value: "is_shortlisted"
			}]
		};
		self.customCommissionsTileOptions = {
			showBorder: true,
			showComment: true,
			showHoverBorder: false,
			canToggleStatus: true,
			showDisableDownload: false,
			canEdit: !self.isManager,
			canDelete: !self.isManager,
			canSelect: self.isManager
		}
		self.searchParams = {
			type: self.isManager ? 'submissions_in_my_shoot' : 'my_submissions',
			page: 1,
			page_size: 100
		};
		self.spinner = {
			isVisible: false
		};
		self.isLastPage = false;
		var mRangeSelection = {
			start: -1,
			end: -1
		};

		$rootScope.$on('loadedDetailsShoot', function (event, data) {
			resetData();
			if (data) {
				$interval.cancel(self.loadphoto);
				self.searchParams.shoot_id = data.id;
				loadPhotos(self.searchParams, true);
				self.customCommissionsTileOptions.canSelect = self.isManager && !data.is_download_requested;
				self.shoot = data;
			} else {
				loadPhotosFromAll(self.searchParams, true);
			}
		})

		$rootScope.$on('submissionStatusChanged', function (event, data) {
			self.items = self.items.map(function (item) {
				if (data.id === item.id) {
					item.is_shortlisted = data.isSelected;
					item.isSelected = data.isSelected;
				}
				return item;
			})
		})

		$rootScope.$on('confirmApproval', function (event, data) {
			self.customCommissionsTileOptions.canSelect = false;
			self.shoot = data;
		})

		function dataChanged() {
			var getList = _.pluck(self.items, 'is_shortlisted')
			if (getList.includes(false)) {
				self.selectAllBtn = 'select-all';
			} else {
				self.selectAllBtn = 'deselect-all';
			}
		}

		function dataSelected(data, event) {
			toggleAprroveSubmission(data, true, event);
		}

		function dataDeselected(data) {
			toggleAprroveSubmission(data, false);
		}

		function getListSelection(index) {
			listIds = _.pluck(self.items, 'id');
			if (mRangeSelection.start < 0) {
				mRangeSelection.start = listIds.indexOf(index);
			} else if (mRangeSelection.end < 0) {
				mRangeSelection.end = listIds.indexOf(index);
			}
			if (mRangeSelection.start > -1 && mRangeSelection.end > -1) {
				var results = self.items.slice(mRangeSelection.start, mRangeSelection.end + 1);
				results = _.reject(results, function (item) {
					return item.is_shortlisted;
				})
				return _.pluck(results, 'id');
			} else {
				return [];
			}
		}

		function toggleAprroveSubmission(data, isSelected, event) {
			var submissionIds = [];
			var shootId = self.customCommissions.selection_mode === self.customCommissionsConst.MODE.ACROSS_CC ? data.shoot_id : self.shoot.id;
			submissionIds.push(data.id);
			if (event && event.shiftKey) {
				submissionIds = getListSelection(data.id);
				if (submissionIds.length) {
					resetRangeSelection();
					pixerfApiCustomCommssionsSvc.approveSubmission({
						shoot_id: self.shoot.id
					}, {
						"submission_ids": submissionIds
					}).$promise.then(function (res) {
						self.items = self.items.map(function (item) {
							if (submissionIds.includes(item.id)) {
								item.isSelected = true;
							}
							return item;
						})
						self.shoot.stats.selected_submission_count += isSelected ? submissionIds.length : -submissionIds.length;
						customCommissionsDetailPageSvc.setShoot(self.shoot);
						dataChanged();
						$scope.$emit("loadedApprovedSubmissions", self.shoot)
					}).catch(function (err) {
						console.log(err);
						if (err.data && (err.data.key === 'selection_limit_exceeded' || err.data.data.key === 'selection_limit_exceeded')) {
							alertExceedPhotoSelection(submissionIds);
							customCommissionsDetailPageSvc.setShoot(self.shoot);
						}
					})
				}
			} else {
				resetRangeSelection();
				pixerfApiCustomCommssionsSvc.approveSubmission({
					shoot_id: shootId
				}, {
					"submission_ids": submissionIds
				}).$promise.then(function (res) {
					self.shoot.stats.selected_submission_count += isSelected ? 1 : -1;
					self.customCommissions.total_selected_submission_count += isSelected ? 1 : -1;
					customCommissionsDetailPageSvc.setShoot(self.shoot);
					self.items = _.map(self.items, function (item) {
						if (submissionIds.includes(item.id)) {
							item.is_shortlisted = isSelected;
						}
						return item;
					})
					dataChanged();
					$scope.$emit("loadedApprovedSubmissions", self.shoot)
				}).catch(function (err) {
					console.log(err);
					if (err.data && (err.data.key === 'selection_limit_exceeded' || err.data.data.key === 'selection_limit_exceeded')) {
						alertExceedPhotoSelection(submissionIds);
						customCommissionsDetailPageSvc.setShoot(self.shoot);
					}
				})
			}
		}

		function decideSelecteOrDeselectAll() {
			var getList = _.pluck(self.items, 'isSelected')
			if (getList.includes(false)) {
				onToggleSelected(true);
			} else {
				onToggleSelected(false);
			}
		}

		function onToggleSelected(value) {
			var selectedList = _.reject(self.items, function (item) {
				return item.is_shortlisted === value;
			})
			self.selectAllBtn = value ? 'deselect-all' : 'select-all';
			self.items = _.map(self.items, function (item) {
				item.isSelected = value;
				item.is_shortlisted = value;
				return item;
			})

			selectedList = _.pluck(selectedList, 'id');

			pixerfApiCustomCommssionsSvc.approveSubmission({
				shoot_id: self.shoot.id
			}, {
				"submission_ids": selectedList
			}).$promise.then(function (res) {
				self.shoot.stats.selected_submission_count = value ? self.items.length : 0;
				customCommissionsDetailPageSvc.setShoot(self.shoot);
				$scope.$emit("loadedApprovedSubmissions", self.shoot);
			}).catch(function (err) {
				console.log(err);
			})
		}

		function resetData(isResetSearch) {
			self.items = [];
			self.selectAllBtn = 'select-all';
			if (isResetSearch) {
				self.searchParams.page = 1;
			} else {
				self.searchParams = {
					type: self.isManager ? 'submissions_in_my_shoot' : 'my_submissions',
					page: 1,
					page_size: 100
				};
			}
		}

		function onArrageChanged(data) {
			self.items = [];
			self.spinner.isVisible = true;
			self.searchParams.sort = data.value;
			loadPhotos(self.searchParams, true);
		}

		function transformInfos(list) {
			for (var i = 0; i < list.length; i++) {
				list[i] = transformInfo(list[i]);
			}
			return list;
		}

		function transformInfo(data) {
			if (data.is_shortlisted) {
				data.isSelected = true;
			}
			return data;
		}

		function loadPhotos(searchParams, isRefresh) {
			if (isRefresh) {
				resetData(true);
			}
			self.spinner.isVisible = true;
			pixerfApiCustomCommssionsSvc.getPhotosByShootId(searchParams).$promise.then(function (res) {
				if(self.searchParams.shoot_id != searchParams.shoot_id) return;
				self.spinner.isVisible = false;
				self.items = self.items.concat(transformInfos(res.data));
				self.isLastPage = pagingUtils.isNoMorePageToLoad(self.searchParams.page, res);
				self.totalPage = pagingUtils.getTotalPage(res);
				if (!self.isLastPage && self.totalPage > 1) {
					self.loadphoto = $interval(function () {
						loadMore();
					}, 1500, (self.totalPage - 1))
				}
				dataChanged();
			}).catch(function (err) {
				self.spinner.isVisible = false;
				console.log(err);
			})
		}

		function loadPhotosFromAll(searchParams, isRefresh) {
			if (isRefresh) {
				resetData(true);
			}
			self.spinner.isVisible = true;
			searchParams.id = self.customCommissions.id;
			searchParams.is_hires = false;
			pixerfApiCustomCommssionsSvc.getPhotosByAllShoot(searchParams).$promise.then(function (res) {
				self.spinner.isVisible = false;
				self.items = self.items.concat(transformInfos(res.data));
				self.isLastPage = pagingUtils.isNoMorePageToLoad(self.searchParams.page, res);
				self.totalPage = pagingUtils.getTotalPage(res);
				if (!self.isLastPage && self.totalPage > 1) {
					$interval(function () {
						loadMoreAll();
					}, 1000, self.totalPage - 1)
				}
			}).catch(function (err) {
				self.spinner.isVisible = false;
				console.log(err);
			})
		}

		function loadMore() {
			if (self.spinner.isVisible) return;
			if (self.isLastPage) return;
			self.searchParams.page++;
			loadPhotos(self.searchParams);
		}

		function loadMoreAll() {
			if (self.spinner.isVisible) return;
			if (self.isLastPage) return;
			self.searchParams.page++;
			loadPhotosFromAll(self.searchParams);
		}

		function onUploadPhotoClicked() {
			uploadCustomCommissionsPopupSvc.showUploadModal({
				files: self.customCommissions,
				shoot: self.shoot,
				popupTitle: 'Upload'
			});
		}

		function resetRangeSelection() {
			mRangeSelection.start = -1;
			mRangeSelection.end = -1;
		}

		function onSubmissionDeleted(data) {
			self.items = _.reject(self.items, function (item) {
				return item.id === data.id;
			})
		}

		function alertExceedPhotoSelection(submissionIds) {
			confirmPopupSvc.showPopup({
				windowClass: 'exceed-photo-selection-popup',
				title: 'Your selections have exceeded the designated number of images!',
				message: 'Please deselect the excess number of images. If you require more images, you may change your brief requirements or contact PIXERF.',
				hideSubmitBtn: true,
				cancelBtnText: 'Got it'
			});

			self.items = _.map(self.items, function (item) {
				if (submissionIds.includes(item.id)) {
					item.isSelected = item.is_shortlisted;
				}
				return item;
			})
		}

		function getSelectedItems(){
			return _.reject(self.items, function (item) {
				return !item.isSelected;
			});
		}

		function onDownloadAllClicked() {
			var selectedList = (self.shoot.stats.selected_submission_count > 0 ) ? getSelectedItems() : self.items;
			if (!selectedList.length || !self.isLastPage) return;
			self.isDownloading = true;
			var downloadItems = selectedList;
			downloadItems = filterDisabledDownloadItem(downloadItems);
			var isLowres = true;

			customCommissionsDetailPageSvc.downloadPhotos(self.shoot, downloadItems, isLowres).then(function (respone) {
				self.isDownloading = false;
				window.location.href = respone;
			}).catch(function (err) {
				self.isDownloading = false;
				console.log(err);
			});
		}

		function filterDisabledDownloadItem(items) {
			items = _.reject(items, function (item) {
				return !item.is_download_enabled;
			})

			return items;
		}

		function onDownloadPdfClicked(){
			if(!self.isLastPage) return;
			var selectedList = (self.shoot.stats.selected_submission_count > 0 ) ? getSelectedItems() : self.items;
			var data = {
				approvedList: selectedList,
				customCommissions: self.customCommissions,
				shoot: self.shoot
			}
			missionApprovedPreviewSvc.showPopup(data);
		}
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('customCommissionsApprovalConfirmApprovalCtrl', customCommissionsApprovalConfirmApprovalCtrl);

	customCommissionsApprovalConfirmApprovalCtrl.$inject = ['$scope', '$rootScope', 'pixerfApiCustomCommssionsSvc', 'sessionManagerSvc', 'customCommissionsDetailPageSvc', 'pixerfConfirmPopupSvc', 'customCommissionsData', 'customCommissionsConst'];

	function customCommissionsApprovalConfirmApprovalCtrl($scope, $rootScope, pixerfApiCustomCommssionsSvc, sessionManagerSvc, customCommissionsDetailPageSvc, pixerfConfirmPopupSvc, customCommissionsData, customCommissionsConst) {

		var self = this;
		self.customCommissionsDetailPageApprovalCtrl = $scope.$parent.vm;
		self.isManager = self.customCommissionsDetailPageApprovalCtrl.isManager;
		self.customCommissions = customCommissionsData;
		self.customCommissionsConst = customCommissionsConst;
		self.isAcrossCC = self.customCommissions.selection_mode === self.customCommissionsConst.MODE.ACROSS_CC;
		self.onTabClicked = onTabClicked;
		self.tabs = ['approved', 'comments'];
		self.shoot = {};
		self.approvedList = [];
		self.commentList = [];
		self.isDisableConfirmApproval = false;
		self.isDownloadRequested = false;
		self.onRemoveAllPhotosClicked = onRemoveAllPhotosClicked;
		self.onCommentRemoved = onCommentRemoved;
		self.onConfirmApprovalClicked = onConfirmApprovalClicked;
		self.onRemoveAllCommentsClicked = onRemoveAllCommentsClicked;
		self.loginedUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.dataSelected = dataSelected;
		self.dataDeselected = dataDeselected;

		self.customCommissionsTileOptions = {
			canToggleStatus: true,
			canSelect: false,
			showDisableDownload: false
		}

		self.commentOptions = {
			canRemove: self.isManager
		}

		init();

		function init() {
			self.currentTab = self.isManager ? self.tabs[0] : self.tabs[1];
		}

		$rootScope.$on('loadedDetailsShoot', function (event, data) {
			if (!data) return;
			self.shoot = data;
			if (self.isAcrossCC) {
				self.isDisableConfirmApproval = self.customCommissions.total_selected_submission_count != self.customCommissions.required_selection_quantity;
			} else {
				self.isDisableConfirmApproval = data.stats.selected_submission_count != data.required_selection_quantity;
			}
			self.isDownloadRequested = data.is_download_requested;
			tabShouldLoaded(self.currentTab);
		})

		$rootScope.$on('loadedApprovedSubmissions', function (event, data) {
			if (!data) return;
			self.shoot = customCommissionsDetailPageSvc.getShoot();
			if (self.isAcrossCC) {
				self.isDisableConfirmApproval = self.customCommissions.total_selected_submission_count != self.customCommissions.required_selection_quantity;
			} else {
				self.isDisableConfirmApproval = data.stats.selected_submission_count != data.required_selection_quantity;
			}
			self.isDownloadRequested = data.is_download_requested;
			tabShouldLoaded(self.currentTab);
		})

		function onTabClicked(tabName) {
			self.currentTab = tabName;
			tabShouldLoaded(self.currentTab);
		}

		function tabShouldLoaded(tabName) {
			if (tabName === self.tabs[0]) {
				loadApproval(self.shoot);
			} else if (tabName === self.tabs[1]) {
				loadComments(self.shoot);
			}
		}

		function dataSelected(data) {
			toggleAprroveSubmission(data);
		}

		function dataDeselected(data) {
			toggleAprroveSubmission(data);
		}

		function toggleAprroveSubmission(data) {
			var shootIds = [];
			shootIds.push(data.id);
			pixerfApiCustomCommssionsSvc.approveSubmission({
				shoot_id: self.shoot.id
			}, {
				"submission_ids": shootIds
			}).$promise.then(function (res) {}).catch(function (err) {
				console.log(err);
			})
		}

		function transformCCTileInfos(list) {
			for (var i = 0; i < list.length; i++) {
				list[i] = transformCCTileInfo(list[i]);
			}
			return list;
		}

		function transformCCTileInfo(data) {
			if (data.is_shortlisted) {
				data.isSelected = true;
			}
			return data;
		}

		function onRemoveAllPhotosClicked(shootId) {
			pixerfApiCustomCommssionsSvc.removeAllApprovedPhotoByShootId(shootId).$promise.then(function (res) {
				self.approvedList = [];
			}).catch(function (err) {
				console.log(err);
			})
		}

		function loadApproval(data) {
			pixerfApiCustomCommssionsSvc.getApprovedPhotoByShootId({
				shoot_id: data.id
			}).$promise.then(function (res) {
				self.approvedList = transformCCTileInfos(res.data);
			}).catch(function (err) {
				console.log(err);
			})
		}

		function loadComments(data) {
			pixerfApiCustomCommssionsSvc.getCommentsByShootId({
				shoot_id: data.id
			}).$promise.then(function (res) {
				self.commentList = res.data;
			}).catch(function (err) {
				console.log(err);
			})
		}

		function onCommentRemoved(item) {
			self.commentList = _.reject(self.commentList, function (comment) {
				return comment.id == item.id;
			});
		}

		function onRemoveAllCommentsClicked(shootId) {
			pixerfApiCustomCommssionsSvc.removeAllCommentsByShootId(shootId).$promise.then(function (res) {
				self.commentList = [];
			}).catch(function (err) {
				console.log(err);
			})
		}

		function onConfirmApprovalClicked() {
			var photographer = self.approvedList[0].media.user;
			var modal = pixerfConfirmPopupSvc.showPopup({
				hideConfirmText: true,
				hideTitle: true,
				message: 'Do take note that you will not be able to re-select the shortlisted images, once you have submitted these images for Approval.<br/><br/>Upon Approval, PIXERF will prompt the Photographer to upload the hi-res file(s). Once ready for download, you will be notified via email.<br/><br/>Please confirm if you would like to proceed with this request.'
			});
			modal.result.then(function () {
				pixerfApiCustomCommssionsSvc.requestToDownload({
					id: self.shoot.id
				}, {
					user_id: photographer.id,
					content: "request to download"
				}).$promise.then(function (respone) {
					self.customCommissionsTileOptions.canSelect = false;
					self.shoot.is_download_requested = true;
					self.isDownloadRequested = true;
					$scope.$emit('confirmApproval', self.shoot);
				})
			})
		}
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('referralProgramTrackCtrl', referralProgramTrackCtrl);

	referralProgramTrackCtrl.$inject = ['$scope', 'sessionManagerSvc', 'earningsSvc'];

	function referralProgramTrackCtrl($scope, sessionManagerSvc, earningsSvc) {

		var self = this;
		self.today = moment().format('DD MMM YYYY');
		self.user = sessionManagerSvc.getCurrentLoginUser().data;
		$scope.$parent.vm.subContextPage = "Track";
		self.earnings = 0;

		init();

		function init(){
			earningsSvc.fetchEarnings().then(function(res){
				self.earnings = res;
			});
		}
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('referralProgramInviteCtrl', referralProgramInviteCtrl);

	referralProgramInviteCtrl.$inject = ['$scope', 'sessionManagerSvc', 'googleContactSvc', 'outlookContactSvc', 'communityInviteEmailPopupSvc', 'toastr', 'pixerfApiCampaignSvc', 'pagingUtils', 'systemUtils', 'pixerfUrl', 'translationSvc'];


	function referralProgramInviteCtrl($scope, sessionManagerSvc, googleContactSvc, outlookContactSvc, communityInviteEmailPopupSvc, toastr, pixerfApiCampaignSvc, pagingUtils, systemUtils, pixerfUrl, translationSvc) {

		var self = this;
		var mLoginedUser = sessionManagerSvc.getCurrentLoginUser().data;
		$scope.$parent.vm.subContextPage = "Invite";
		self.newInviteMessage = 'Your friend hasn\'t signed up yet';
		self.invitedSignedUp = 'Signed up successfully';

		self.onInviteClicked = onInviteClicked;
		self.onOutlookClicked = onOutlookClicked;
		self.onGmailClicked = onGmailClicked;
		self.fetchMoreEmails = fetchMoreEmails;
		self.onValidateTag = onValidateTag;
		self.copyToClipboard = systemUtils.copyStringToClipboard;
		self.onFbMessengerClicked= onFbMessengerClicked;
		self.onFbShareBtnClicked = onFbShareBtnClicked;
		self.sortBy = sortBy;

		self.friends = [];
		self.invitees = [];
		self.searchParams = {page: 1};
		self.totalEmails = 0;
		self.spinner = {isVisible: false};
		self.referralLink = mLoginedUser.referral_code ? pixerfUrl.full + "#/referral-congrat-page?code=" + mLoginedUser.referral_code : "";
		self.referralLinkEncoded = encodeURIComponent(self.referralLink);
		self.propertyName = '';
  		self.reverse = true;

		onInitInvitedFriends();

		function validate(invitees){
			if(invitees.length > 20){
				return "You can invite up to 20 friends each time";
			}
			for (var i = 0; i < invitees.length; i++) {
				if(isEmailExist(invitees[i].text)){
					return "Some of your friends are aldreay invited: " + invitees[i].text;
				}
			}
		}
		function buildSavedData(invitees){
			for(var i = 0; i < self.friends.length; i++){
				invitees = _.reject(invitees, function(it){
					return it.text == self.friends[i].email;
				})
			}
			invitees = _.reduce(invitees, function(memo, it){
				memo.push(it.text);
				return memo;
			},[]);
			return invitees;
		}
		function onInviteClicked() {
			if (!self.invitees) return;
			var errMsg = validate(self.invitees);
			if(errMsg) {
				toastr.error(errMsg);
				return;
			}
			invitees = buildSavedData(self.invitees);

			pixerfApiCampaignSvc.invite({"invitees": invitees}).$promise.then(function(res){
				if(!self.referralLink && res.data && res.data.referral_code){
					self.referralLink = getReferralLink(res.data.referral_code);
				}
				invitees = _.map(invitees, function(it){
					return  {email: it, statusDisplay: "Invite Sent"};
				})
				self.friends = invitees.concat(self.friends);
				self.totalEmails = self.friends.length;
				toastr.success("Your invitations have been succesfully sent to your friends!");
				self.invitees = [];

			},function (err){
				var errMsg = translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true);
				if(err && err.data && err.data.message === "ALREADY_SIGNED_UP"){
					errMsg = "Failed to send invitations. Some of your friends are already Pixerf users: ";
					for(var i = 0; i < err.data.emails.length; i ++){
						errMsg += err.data.emails[i];
						if(i !== err.data.emails.length){
							errMsg += ", "
						}
					}

				} else if(err && err.data && err.data.message === "ALREADY_INVITED"){
					errMsg = "Failed to send invitations. Some of your friends are aldreay invited: ";
					for(var i = 0; i < err.data.emails.length; i ++){
						errMsg += err.data.emails[i];
						if(i !== err.data.emails.length){
							errMsg += ", "
						}
					}
				}
				toastr.error(errMsg);
			})
		}
		function onGmailClicked() {
			// communityInviteEmailPopupSvc.showPopup(dataTest);
			googleContactSvc.auth(function () {
				var popup = communityInviteEmailPopupSvc.showPopup({
					getter: googleContactSvc.getContacts
				})
				popup.result.then(function(respone){
                    invitationSentHandler(respone.invited, respone.data);
                })
			});
		}
		function onOutlookClicked() {
			// communityInviteEmailPopupSvc.showPopup(dataTest);
			outlookContactSvc.auth(function () {
				var popup = communityInviteEmailPopupSvc.showPopup({
					getter: outlookContactSvc.getContacts
				})
				popup.result.then(function(respone){
                    invitationSentHandler(respone.invited, respone.data);
                })
			});
		}
		function onInitInvitedFriends() {
			getInvitedEmails(self.searchParams, true);
		}
		function getInvitedEmails(params, isFresh){
			self.spinner.isVisible = true;
			pixerfApiCampaignSvc.referrals(params).$promise.then(function(response){
				self.spinner.isVisible = false;
                if(!self.friends || isFresh) self.friends = [];
				if(response.data.length){
					self.friends = self.friends.concat(response.data);
					self.isLastPage = pagingUtils.isNoMorePageToLoad(params.page, response);
					self.totalEmails = pagingUtils.getTotalCount(response);
					self.searchParams.page = params.page;
				}
			})
		}
		function fetchMoreEmails(){
			if(self.isLastPage || self.spinner.isVisible) return;

            var searchParms = $.extend(true, {}, self.searchParams);
			searchParms.page++;
            getInvitedEmails(searchParms);
		}
		function onValidateTag($tag, $event){
			if(isEmailExist($tag)){
				toastr.error($tag.text + " has already been invited!");
				return false;
			}
			return true;
		}
		function isEmailExist(newUser){
			var isExistEmail = _.find(self.friends, function(friend){
				return friend.email === newUser.text;
			});
			if(isExistEmail){
				return true;
			} else {
				return false;
			}
		}
		function invitationSentHandler(invitees, data){
			if(!self.referralLink && data && data.referral_code){
				self.referralLink = getReferralLink(data.referral_code);
			}
			invitees = _.map(invitees, function(it){
				return  {email: it, statusDisplay: "Invite Sent"};
			})
			self.friends = invitees.concat(self.friends);
			self.totalEmails = self.friends.length;
		}
		function getReferralLink(referralCode){
			return pixerfUrl.full + "#/referral-congrat-page?code=" + referralCode;
		}
		function onFbMessengerClicked(){
			console.log(self.referralLink);
			FB.ui({
				method: 'send',
				link: self.referralLink,
			  });
		}
		function onFbShareBtnClicked(){
			FB.ui({
				method: 'share',
				mobile_iframe: true,
				href: "http://localhost:3000/#/referral-congrat-page?code=093083Q",
			  }, function(response){});
		}

		function sortBy(propertyName){
			self.reverse = (self.propertyName === propertyName) ? !self.reverse : false;
			self.propertyName = propertyName;
		};
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('soldListCtrl', soldListCtrl);

	soldListCtrl.$inject = ['$scope', 'dateUtils', 'toastr', 'photoSoldSvc', 'pixerfApiSalesSvc', 'pagingUtils', 'translationSvc'];

	function soldListCtrl($scope, dateUtils, toastr, photoSoldSvc, pixerfApiSalesSvc, pagingUtils, translationSvc) {
		var self = this;
		self.spinner = {
			isVisible: false
		}
		self.fetchMorePurchasedItems = fetchMorePurchasedItems;
		self.selectedFilter = photoSoldSvc.getFilters();
		self.items = photoSoldSvc.getItems();
		self.totalMedia = photoSoldSvc.getTotalMedia();
		self.searchParams = photoSoldSvc.getSearchParams();
		self.onSearchFilterClick = onSearchFilterClick;
		self.onFilterChanged = onFilterChanged;
		self.filtersFromMonth = {
			"items": photoSoldSvc.buildMonthFilters(),
			'defaultText': 'Month'
		};
		self.filtersFromYear = {
			"items": photoSoldSvc.buildYearFilters(),
			'defaultText': 'Year'
		};
		self.filtersToMonth = {
			"items": photoSoldSvc.buildMonthFilters(),
			'defaultText': 'Month'
		};
		self.filtersToYear = {
			"items": photoSoldSvc.buildYearFilters(),
			'defaultText': 'Year'
		};

		$scope.altInputFormats = ['M!/yyyy'];
		initList();

		function initList() {
			onSearchFilterClick(self.selectedFilter, 'MOST_RECENT');
		}

		function onSearchFilterClick(filter, type) {
			self.searchParams = {
				page: 1,
				start_date: null,
				end_date: null
			};
			if (filter) {
				filter.type = type;
				var timeRange = photoSoldSvc.getTimeRange(filter);
				if (timeRange) {
					self.searchParams.start_date = timeRange.start_date;
					self.searchParams.end_date = timeRange.end_date;
				}
				photoSoldSvc.setSearchParams(self.searchParams);
				photoSoldSvc.setFilters(filter);
			}
			fetchPurchasedItems(self.searchParams, true);
		}

		function fetchPurchasedItems(searchParams, isFresh) {
			self.spinner.isVisible = true;
			if (isFresh) self.items = [];
			pixerfApiSalesSvc.post(searchParams).$promise.then(function (response) {
				if (searchParams.page === 1) self.items = [];
				self.spinner.isVisible = false;
				if (response && response.data && response.data.length > 0) {
					self.items = self.items.concat(response.data);
					self.totalMedia = getTotalMedia(response);
					photoSoldSvc.setTotalMedia(self.totalMedia);
					photoSoldSvc.setItems(self.items);
				}
				self.isLastPage = pagingUtils.isNoMorePageToLoad(searchParams.page, response);

			}, function () {
				self.spinner.isVisible = false;
				toastr.error(translationSvc.FAILED_TO_DO_SOMETHING('FAILED_ORDER_LIST', true));
			})
		}

		function fetchMorePurchasedItems() {
			if (self.spinner.isVisible) {
				return;
			}
			self.searchParams.page++;
			fetchPurchasedItems(self.searchParams);
		}

		function getTotalMedia(response) {
			return response.headers('total-media');
		}

		function onFilterChanged() {
			onSearchFilterClick(self.selectedFilter, 'DURATION');
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('soldDetailsCtrl', soldDetailsCtrl);

	soldDetailsCtrl.$inject = ['$scope', '$stateParams', 'pixerfApiSalesSvc', 'pixerfApiDownloadSvc', 'pixerfUrl', 'toastr', '$timeout', 'translationSvc'];

	function soldDetailsCtrl($scope, $stateParams, pixerfApiSalesSvc, pixerfApiDownloadSvc, pixerfUrl, toastr, $timeout, translationSvc) {
		var self = this;
		self.spinner = {
			isVisible: false
		};
		self.onBackBtnClicked = onBackBtnClicked;
		self.orderId = $stateParams.orderId;
		self.onDownloadBtnClicked = onDownloadBtnClicked;

		self.searchParams = {
			orderId: self.orderId
		};

		fetchPurchasedItems(self.searchParams, true);

		function onDownloadBtnClicked(evt, item, type) {
			var service = type ? type : "download";
			if (self.isWorking) {
				return;
			}
			self.isWorking = true;
			pixerfApiDownloadSvc.get({
				id: item.id
			}).$promise.then(function (response) {
				item.downloadLink = pixerfUrl.full + "api/" + service + "?token=" + response.token;
				$timeout(function () {
					$(evt.target).next("a")[0].click();
					$timeout(function () {
						self.isWorking = false;
					})
				})
			}, function () {
				self.isWorking = false;
				toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
			})
		}

		function fetchPurchasedItems(searchParams, isFresh) {
			var timeRange = null;
			self.spinner.isVisible = true;
			if (isFresh) self.item = {};
			pixerfApiSalesSvc.getById(searchParams).$promise.then(function (response) {
				self.spinner.isVisible = false;
				if (response && response.data) {
					self.item = response.data;
				}
			}, function () {
				self.spinner.isVisible = false;
				toastr.error('Failed to get purchased items. Please try again.');
			})
		}

		function onBackBtnClicked() {
			window.history.go(-1);
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('creditPlanPaymentWireTransferCtrl', creditPlanPaymentWireTransferCtrl);

	creditPlanPaymentWireTransferCtrl.$inject = ["$scope", "$state"];

	function creditPlanPaymentWireTransferCtrl($scope, $state) {
		var self = this;
		self.onSubmitClicked = onSubmitClicked;

		function onSubmitClicked() {
			$state.go("checkout.credit-plan.credit-plan-list");
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('creditPlanPaymentSuccessfulCtrl', creditPlanPaymentSuccessfulCtrl);

	creditPlanPaymentSuccessfulCtrl.$inject = ["$state", "$location", "sessionManagerSvc", "credit", "numberUtils"];

	function creditPlanPaymentSuccessfulCtrl($state, $location, sessionManagerSvc, credit, numberUtils) {
		var self = this;
		self.onBrowseMarketplaceClicked = onBrowseMarketplaceClicked;
		self.onLaunchMissionClicked = onLaunchMissionClicked;
		self.loginUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.credit = credit.value;
		self.userCredit = (self.loginUser && self.loginUser.user_credit_plan && self.loginUser.user_credit_plan.balance) || 0;
		self.userCredit = parseInt(self.userCredit);
		self.formatTotalCredit = 0;
		self.originCredit = 0;

		init();

		function init() {
			if (self.userCredit) {
				self.formatTotalCredit = numberUtils.formatNumber(self.userCredit, ",", 3);
				self.originCredit = self.userCredit - parseInt(self.credit.split(",").join(""));
				self.formatOriginCredit = numberUtils.formatNumber(self.originCredit, ",", 3);
			}
		}

		function onBrowseMarketplaceClicked() {
			$location.path(sessionManagerSvc.getMarketplaceTabHistory());
		}

		function onLaunchMissionClicked() {
			if (self.loginUser && self.loginUser.canCreateMission) {
				$state.go("setting.manage-missions.create-mission.getting-started");
			}
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('creditPlanListCtrl', creditPlanListCtrl);

	creditPlanListCtrl.$inject = ['$scope', '$rootScope', 'sessionManagerSvc', 'messageConst', '$state', 'pixerfMessagePopupSvc', '$window', '$timeout', '$stateParams'];

	function creditPlanListCtrl($scope, $rootScope, sessionManagerSvc, messageConst, $state, pixerfMessagePopupSvc, $window, $timeout, $stateParams) {
		var self = this;

		var mMissionPlan = null;
		self.onPlanSelected = onPlanSelected;
		self.loginUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.selectedPlan = null;
		self.newBalance = 0;
		self.currentBalance = self.loginUser && self.loginUser.user_credit_plan ? self.loginUser.user_credit_plan.balance : 0;
		self.onPaymentComplete = onPaymentComplete;
		self.onPaymentMethodSelected = onPaymentMethodSelected;
		self.onError = onError;
		self.onMissionClicked = onMissionClicked;
		self.onMadeOrderClicked = onMadeOrderClicked;
		self.themePackages = [{
				"title": "supersaver",
				"subtitle": "get-percent-off",
				"percentOff": "20%",
				"description": "starter-1",
				"numberImages": 25
			},
			{
				"title": "saver",
				"subtitle": "get-percent-off",
				"percentOff": "15%",
				"description": "starter-1",
				"numberImages": 15
			},
			{
				"title": "starter",
				"subtitle": "get-percent-off",
				"percentOff": "10%",
				"description": "starter-1",
				"numberImages": 5
			}
		];

		self.imagePrices = [{
				"size": "size-x-small",
				"description": 'tool-tip-xsmall',
				"price": "$5"
			}, {
				"size": "size-small",
				"description": 'tool-tip-small',
				"price": "$10"
			},
			{
				"size": "size-medium",
				"description": 'tool-tip-medium',
				"price": "$30"
			},
			{
				"size": "size-large",
				"description": 'tool-tip-large',
				"price": "$50"
			},
			{
				"size": "size-x-large",
				"description": 'tool-tip-xlarge',
				"price": "$75"
			},
			{
				"size": "size-xx-large",
				"description": 'tool-tip-xxlarge',
				"price": "$100"
			}
		];

		self.crowdsourcedMissions = [{
				"title": "basic",
				"duration": "45-day",
				"subtitle": "Photo Mission",
				"description": [
					"promotional-blast-to-our-pixerf-community",
					"cash-prizes",
					"special-mention",
					"curation-by-experts",
					"licensing-for-use",
					"post-mission-report"
				],
				"numberOfWinners": 5,
				"mailTo": "business@pixerf.com?Subject=I\'m%20interested%20to%20purchase%20a%20Basic%20Photo%20Mission%20Package"
			},
			{
				"title": "mini",
				"duration": "30-day",
				"subtitle": "Photo Mission",
				"description": [
					"cash-prizes",
					"special-mention",
					"curation-by-experts",
					"licensing-for-use"
				],
				"numberOfWinners": 3,
				"mailTo": "business@pixerf.com?Subject=I\'m%20interested%20to%20purchase%20a%20Mini%20Photo%20Mission%20Package"
			},
			{
				"title": "enterprise",
				"type": "custom",
				"subtitle": "cant-find-what-you-need"
			}
		]

		self.imagesFaqs = [{
				question: 'credit-plans-faq-13',
				answer: 'credit-plans-faq-13a'
			},
			{
				question: 'credit-plans-faq-12',
				answer: 'credit-plans-faq-12a'
			},
			{
				question: 'credit-plans-faq-11',
				answer: 'credit-plans-faq-11a'
			},
			{
				question: 'credit-plans-faq-10',
				answer: 'credit-plans-faq-10a'
			},
			{
				question: 'credit-plans-faq-9',
				answer: 'credit-plans-faq-9a'
			},
			{
				question: 'credit-plans-faq-8',
				answer: 'credit-plans-faq-8a'
			},
			{
				question: 'credit-plans-faq-7',
				answer: 'credit-plans-faq-7a'
			}

		];
		self.missionFaqs = [{
				question: 'credit-plans-faq-6',
				answer: 'credit-plans-faq-6a'
			},
			{
				question: 'credit-plans-faq-5',
				answer: 'credit-plans-faq-5a'
			},
			{
				question: 'credit-plans-faq-4',
				answer: 'credit-plans-faq-4a'
			},
			{
				question: 'credit-plans-faq-3',
				answer: 'credit-plans-faq-3a'
			},
			{
				question: 'credit-plans-faq-2',
				answer: 'credit-plans-faq-2a'
			},
			{
				question: 'credit-plans-faq-1a',
				answer: 'credit-plans-faq'
			}
		]

		init();

		function init() {
			if ($stateParams && $stateParams.hashtag) {
				$timeout(function () {
					self.scrollToThis = true;
				}, 2000)
			}
		}

		function onPlanSelected(plan) {
			self.selectedPlan = plan;
			self.newBalance = parseFloat(self.currentBalance) + parseFloat(plan.price);
		}

		$rootScope.$on(messageConst.BROADCAST.USER_DATA_CHANGE, function () {
			if (self.loginUser.id === sessionManagerSvc.getCurrentLoginUser().data.id) {
				self.loginUser = sessionManagerSvc.getCurrentLoginUser().data;
				self.currentBalance = self.loginUser.user_credit_plan ? parseFloat(self.loginUser.user_credit_plan.balance) : 0;
				self.newBalance = parseFloat(self.currentBalance) + parseFloat(self.selectedPlan.price);
			}
		});

		function onPaymentMethodSelected(methodSelected) {
			self.paymentMethodSelected = methodSelected.id;
		}

		function onPaymentComplete(data) {
			if (self.paymentMethodSelected === 'WIRE_TRANSFER') {
				$state.go('checkout.credit-plan.credit-plan-payment-wire-transfer');
			} else {
				$state.go('checkout.credit-plan.credit-plan-payment-successful', {
					credit: self.selectedPlan.priceFormatted
				});
			}
		}

		function onError(err) {}

		function onMissionClicked(missionPlan) {
			if (missionPlan.isSelected) return;
			missionPlan.isSelected = true;
			if (mMissionPlan) {
				mMissionPlan.isSelected = false;
			}
			mMissionPlan = missionPlan;
		}

		function onMadeOrderClicked(email) {
			if (email) {
				$window.open('mailto:' + email, '_self');
			} else {
				return pixerfMessagePopupSvc.showPopup({
					message: 'To get started, call us at +65-6743 1356 or send us an email at business@pixerf.com!',
					autoClose: false,
					showBtn: true,
					btnClass: 'btn btn-submit pixerf-btn-sm'
				})
			}
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('creditPlanCheckoutCtrl', creditPlanCheckoutCtrl);

	creditPlanCheckoutCtrl.$inject = ['$scope', 'creditPlansSvc', '$state', '$stateParams'];

	function creditPlanCheckoutCtrl($scope, creditPlansSvc, $state, $stateParams) {
		var self = this;
		self.onToggleDetailsPlan = onToggleDetailsPlan;
		self.onPaymentComplete = onPaymentComplete;
		self.package = {};
		self.selectedPlan = {};
		self.isOpenDetailsPlan = false;

		init()

		function init() {
			self.package = creditPlansSvc.getCreditPlan().data;
			if (!self.package || !self.package.id) {
				creditPlansSvc.getCreditPlanById($stateParams.id).then(function (res) {
					self.package = res;
				});
			}
		}

		function onToggleDetailsPlan(isOpen) {
			self.isOpenDetailsPlan = !isOpen;
		}

		function onPaymentComplete(data) {
			$state.go('checkout.credit-plan.credit-plan-payment-successful', {
				credit: self.package
			});
		}
	}
})();

(function () {

	angular
		.module('pixerf')
		.factory('caseStudyDetailsSvc', caseStudyDetailsSvc);

	caseStudyDetailsSvc.$inject = [];

	function caseStudyDetailsSvc() {

		var mCaseStudies = [
            {id: 1, logo: "assets/images/casestudies/petronas/logo.png",cover: "assets/images/casestudies/petronas/banner.jpg",type: "Custom Content Assignment", contentType: "Photoshoot", title: "Multi-location & Multi-creator Photography", client: "Petronas", category: "Commercial - Out of Home", daysOfShoots: "8 days", imageLicensed: "83", location: "Malaysia", photos: [{badge: '',url: 'assets/images/casestudies/petronas/grid-photo-1.jpg'}, {badge: '',url: 'assets/images/casestudies/petronas/grid-photo-2.jpg'}]},
			{id: 2, logo: "assets/images/casestudies/shield/logo.png",cover: "assets/images/casestudies/shield/banner.jpg",type: "Custom Content Assignment", contentType: "Videoshoot", title: "Video shoot & Customer Story", client: "Shield", category: "Corporate", daysOfShoots: "1 day", location: "Indonesia", photos: [{badge: '',url: 'assets/images/casestudies/shield/grid-photo-1.jpg'}, {badge: '',url: 'assets/images/casestudies/shield/grid-photo-2.jpg'}]},
			{id: 3, logo: "assets/images/casestudies/blackmores/logo.png",cover: "assets/images/casestudies/blackmores/banner.jpg",type: "Custom Content Assignment", contentType: "Photoshoot", title: "Product & Lifestyle Photography", client: "Blackmores", category: "Product", daysOfShoots: "1.5 day", imageLicensed: "21", location: "Singapore", photos: [{badge: '',url: 'assets/images/casestudies/blackmores/grid-photo-1.jpg'}, {badge: '',url: 'assets/images/casestudies/blackmores/grid-photo-2.jpg'}, {badge: '',url: 'assets/images/casestudies/blackmores/grid-photo-3.jpg'}]},
			{id: 4, logo: "assets/images/casestudies/gurobu/logo.png",cover: "assets/images/casestudies/gurobu/banner.jpg",type: "Custom Content Assignment", contentType: "Photoshoot", title: "Brand Library & Website Content", client: "Gurobu", category: "Product, Branding", daysOfShoots: "4 days", imageLicensed: "400", location: "Singapore", photos: [{badge: '',url: 'assets/images/casestudies/gurobu/grid-photo-1.jpg'}, {badge: '',url: 'assets/images/casestudies/gurobu/grid-photo-2.jpg'}]},
			{id: 5, logo: "assets/images/casestudies/cellini/logo.png",cover: "assets/images/casestudies/cellini/banner.jpg",type: "Custom Content Assignment", contentType: "Photoshoot", title: "Product & Lifestyle Photography", client: "Cellini", category: "Product & Lifestyle", daysOfShoots: "2 days", imageLicensed: "100", location: "Singapore", photos: [{badge: '',url: 'assets/images/casestudies/cellini/grid-photo-1.jpg'}, {badge: '',url: 'assets/images/casestudies/cellini/grid-photo-2.jpg'}]},
			{id: 6, logo: "assets/images/casestudies/people/logo.png",cover: "assets/images/casestudies/people/banner.jpg",type: "Custom Content Assignment", contentType: "Photoshoot & Videoshoot", title: "Multi-location Photography & Videography", client: "People's Association", category: "Educational, Lifestyle, Branding", daysOfShoots: "11 days", imageLicensed: "342", location: "Singapore", photos: [{badge: '',url: 'assets/images/casestudies/people/grid-photo-1.jpg'}, {badge: '',url: 'assets/images/casestudies/people/grid-photo-2.jpg'}], photoSecondGrid: [{badge: '',url: 'assets/images/casestudies/people/grid-photo-3.jpg'}, {badge: '',url: 'assets/images/casestudies/people/grid-photo-4.jpg'}]},
			{id: 7, logo: "assets/images/casestudies/storytel/logo.png",cover: "assets/images/casestudies/storytel/banner.jpg",type: "Custom Content Assignment", contentType: "Photoshoot", title: "Brand Photoshoot", client: "Storytel", category: "Brand Photoshoot", daysOfShoots: "1 day", imageLicensed: "40", location: "Singapore", photos: [{badge: '',url: 'assets/images/casestudies/storytel/grid-photo-1.jpg'}, {badge: '',url: 'assets/images/casestudies/storytel/grid-photo-2.jpg'}]},
			{id: 8, logo: "assets/images/casestudies/ademco/logo.png",cover: "assets/images/casestudies/ademco/banner.jpg",type: "Custom Content Assignment", contentType: "Photoshoot", title: "Brand Photoshoot", client: "Ademco", category: "Brand Photoshoot", daysOfShoots: "1 day", imageLicensed: "40", location: "Singapore", photos: [{badge: '',url: 'assets/images/casestudies/ademco/grid-photo-1.jpg'}, {badge: '',url: 'assets/images/casestudies/ademco/grid-photo-2.jpg'}]},
			{id: 9, logo: "assets/images/casestudies/enterprise-singapore/logo.png",cover: "assets/images/casestudies/enterprise-singapore/banner.jpg",type: "Custom Content Assignment", contentType: "Photoshoot", title: "Going Through Challenges Campaign", client: "Enterprise Singapore", category: "Brand Photoshoot", daysOfShoots: "13 days", imageLicensed: "130", location: "Singapore", photos: [{badge: '',url: 'assets/images/casestudies/enterprise-singapore/grid-photo-1.jpg'}, {badge: '',url: 'assets/images/casestudies/enterprise-singapore/grid-photo-2.jpg'}]},
			{id: 10, logo: "assets/images/casestudies/straits/logo.png",cover: "assets/images/casestudies/straits/banner.jpg",type: "Community Challenge", contentType: "Photo Challenge", title: "Flashback To Penang-Buttersworth & Together At Home", client: "Straits City", company: "Straits Trading", imageSubmissions: "90 (Flashback to Penang-Buttersworth), 145 (Togetherness at Home)", reach: "Malaysia", photos: [{id: "306457", missionId: "107", missionName: "Flash-Back-to-Penang-Butterworth", badge: 'Flash Back to Penang Butterworth',url: 'assets/images/casestudies/straits/grid-photo-1.jpg'}, {id: "318284", badge: '',url: 'assets/images/casestudies/straits/grid-photo-2.jpg'}]},
			{id: 11, logo: "assets/images/casestudies/gojek/logo.png",cover: "assets/images/casestudies/gojek/banner.jpg",type: "Community Challenge", contentType: "Community Challenge", title: "Museum of Hacks", client: "Gojek", company: "Gojek Indonesia", imageSubmissions: "631", reach: "Indonesia", photos: [{id: "232567", badge: '',url: 'assets/images/casestudies/gojek/grid-photo-1.jpg'}, {id: "231993", badge: '',url: 'assets/images/casestudies/gojek/grid-photo-2.jpg'}], photoSecondGrid: [{id: "233111", badge: '',url: 'assets/images/casestudies/gojek/grid-photo-3.jpg'}, {id: "233113", badge: '',url: 'assets/images/casestudies/gojek/grid-photo-4.jpg'}]},
			{id: 12, logo: "assets/images/casestudies/wwf/logo.png",cover: "assets/images/casestudies/wwf/banner.jpg",type: "Community Challenge", contentType: "Community Challenge", title: "Youth In Urban Nature", client: "WWF", imageSubmissions: "218", reach: "Worldwide", photos: [{id: "280669", missionId: "85", missionName: "Youth-in-Urban-Nature", badge: 'Youth in Urban Nature',url: 'assets/images/casestudies/wwf/grid-photo-1.jpg'}, {id: "54898", badge: '',url: 'assets/images/casestudies/wwf/grid-photo-2.jpg'}]},
			{id: 13, logo: "assets/images/casestudies/cooler/logo.png",cover: "assets/images/casestudies/cooler/banner.jpg",type: "Community Challenge", contentType: "Community Challenge", title: "Super Canggih", client: "Cooler Lumpur", imageSubmissions: "131", reach: "Malaysia", photos: [{id: "272364", badge: '',url: 'assets/images/casestudies/cooler/grid-photo-1.jpg'}, {id: "262346", badge: '',url: 'assets/images/casestudies/cooler/grid-photo-2.jpg'}]},
			{id: 14, logo: "assets/images/casestudies/asian/logo.png",cover: "assets/images/casestudies/asian/banner.jpg",type: "Community Challenge", contentType: "Community Challenge", title: "Images of Asia 2018", client: "Asian Geographic", imageSubmissions: "670", reach: "Worldwide", photos: [{id: "169515", badge: 'Images of Asia - Landscape', missionId: "58", missionName: "Images-of-Asia-–-Landscape", url: 'assets/images/casestudies/asian/grid-photo-1.jpg'}, {id: "167563", badge: 'Images of Asia - Mobile', missionId: "59", missionName: "Images-of-Asia-–-Mobile", url: 'assets/images/casestudies/asian/grid-photo-2.jpg'}]},
			{id: 15, logo: "assets/images/casestudies/salam/logo.png",cover: "assets/images/casestudies/salam/banner.jpg",type: "Community Challenge", contentType: "Community Challenge", title: "Faces of Singaporean Muslims", client: "Salam Singapore", imageSubmissions: "120", reach: "Singapore", photos: [{id: "28737", missionId: "44", missionName: "Faces-of-Singaporean-Muslims", badge: 'Faces of Singaporean Muslims',url: 'assets/images/casestudies/salam/grid-photo-1.jpg'}, {id: "158990", badge: '',url: 'assets/images/casestudies/salam/grid-photo-2.jpg'}]}
        ];

		function getCaseStudiesDetails() {
			return mCaseStudies;
		}

		function getCaseStudiesByid(id){
			var caseStudy = _.find(mCaseStudies, function(cs){
				return cs.id == id;
			});
			return caseStudy;
		}

		return {
			getCaseStudiesDetails: getCaseStudiesDetails,
			getCaseStudiesByid: getCaseStudiesByid
		};
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('caseStudyDetailsCtrl', caseStudyDetailsCtrl);

	caseStudyDetailsCtrl.$inject = ['$scope', 'caseStudyDetailsSvc', 'caseStudy', '$state', 'systemUtils', 'caseStudiesSvc', 'customCommissionBasicFormPopupSvc', '$window'];

	function caseStudyDetailsCtrl($scope, caseStudyDetailsSvc, caseStudy, $state, systemUtils, caseStudiesSvc, customCommissionBasicFormPopupSvc, $window) {

		var self = this;
		$scope.$parent.vm.contextPage = "Case Studies";
		self.onBackAboutCaseStudy = onBackAboutCaseStudy;
		self.onGotoCaseStudy = onGotoCaseStudy;
		self.bookAShoot = bookAShoot;
		self.onNextSlide = onNextSlide;
		self.onPreviousSlide = onPreviousSlide;
        self.onGoMissionDetails = onGoMissionDetails;

		if (caseStudy && caseStudy.id) {
			self.caseStudy = caseStudyDetailsSvc.getCaseStudiesByid(caseStudy.id);
			self.slideDatas = caseStudiesSvc.getTheRestCaseStudies(caseStudy.id);
		}

		function bookAShoot() {
			customCommissionBasicFormPopupSvc.showPopup();
		}

		function onBackAboutCaseStudy() {
			$state.go("about-business-page.case-studies.about-case-studies");
		}

		self.slickSetting = {
			onInit: function (slick) {
				self.slick = slick;
				self.isFirstSlickSlide = true;
				self.isLastSlickSlide = false;
				systemUtils.digest($scope);
			},
			onAfterChange: function (event, slick, currentSlide) {
				if (currentSlide == 0) {
					self.isFirstSlickSlide = true;
					self.isLastSlickSlide = false;
				} else if (slick.$slides.length == (currentSlide + slick.options.slidesToScroll - 1)) {
					self.isFirstSlickSlide = false;
					self.isLastSlickSlide = true;
				} else {
					self.isFirstSlickSlide = false;
					self.isLastSlickSlide = false;
				}
				systemUtils.digest($scope);
			}
		}

		self.slickMobileSetting = {
			onInit: function (slick) {
				self.slickMobile = slick;
				self.isFirstSlickMobileSlide = true;
				self.isLastSlickMobileSlide = false;
				systemUtils.digest($scope);
			},
			onAfterChange: function (event, slick, currentSlide) {
				if (currentSlide == 0) {
					self.isFirstSlickMobileSlide = true;
					self.isLastSlickMobileSlide = false;
				} else if (slick.$slides.length == (currentSlide + 1)) {
					self.isFirstSlickMobileSlide = false;
					self.isLastSlickMobileSlide = true;
				} else {
					self.isFirstSlickMobileSlide = false;
					self.isLastSlickMobileSlide = false;
				}
				systemUtils.digest($scope);
			}
		}

		function onNextSlide() {
			self.slick.slickNext();
			self.slickMobile.slickNext();
		}

		function onPreviousSlide() {
			self.slick.slickPrev();
			self.slickMobile.slickPrev();
		}

		function onGotoCaseStudy(caseStudy) {
			switch (caseStudy.id) {
				case 1:
					$state.go("about-business-page.case-studies.case-study-petronas", {
						id: caseStudy.id,
						name: 'petronas'
					});
					break;
				case 2:
					$state.go("about-business-page.case-studies.case-study-shield", {
						id: caseStudy.id,
						name: 'shield'
					});
					break;
				case 3:
					$state.go("about-business-page.case-studies.case-study-blackmores", {
						id: caseStudy.id,
						name: 'blackmores'
					});
					break;
				case 4:
					$state.go("about-business-page.case-studies.case-study-gurobu", {
						id: caseStudy.id,
						name: 'gurobu'
					});
					break;
				case 5:
					$state.go("about-business-page.case-studies.case-study-cellini", {
						id: caseStudy.id,
						name: 'cellini'
					});
					break;
				case 6:
					$state.go("about-business-page.case-studies.case-study-people-association", {
						id: caseStudy.id,
						name: 'people-association'
					});
					break;
				case 7:
					$state.go("about-business-page.case-studies.case-study-straits-city", {
						id: caseStudy.id,
						name: 'straits-city'
					});
					break;
				case 8:
					$state.go("about-business-page.case-studies.case-study-gojek", {
						id: caseStudy.id,
						name: 'gojek'
					});
					break;
				case 9:
					$state.go("about-business-page.case-studies.case-study-wwf", {
						id: caseStudy.id,
						name: 'wwf'
					});
					break;
				case 10:
					$state.go("about-business-page.case-studies.case-study-cooler-lumpur", {
						id: caseStudy.id,
						name: 'cooler-lumpur'
					});
					break;
				case 11:
					$state.go("about-business-page.case-studies.case-study-asian-geographic", {
						id: caseStudy.id,
						name: 'asian-geographic'
					});
					break;
				case 12:
					$state.go("about-business-page.case-studies.case-study-salam-singapore", {
						id: caseStudy.id,
						name: 'salam-singapore'
					});
					break;
			}
		}

        function onGoMissionDetails(params){
            $window.event.stopPropagation();
            $state.go("mission-detail-page.brief", params);
        }
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.config(routerConfig);

	routerConfig.$inject = ['$stateProvider'];

	function routerConfig($stateProvider) {
		'ngInject';
		$stateProvider
			.state('about-business-page.case-studies.case-study-petronas', {
				url: '/1/:name',
				templateUrl: 'app/about-business-page/components/case-studies/case-study-details/case-study-petronas.html',
				controller: 'caseStudyDetailsCtrl',
				controllerAs: 'vm',
				data: {
					pageTitle: "PIXERF - Case Studies Petronas",
					permissions: {
						only: ['EVERY_ONE']
					}
				},
				resolve: {
					caseStudy: function () {
						return {id: 1};
					}
				}
			})
			.state('about-business-page.case-studies.case-study-shield', {
				url: '/2/:name',
				templateUrl: 'app/about-business-page/components/case-studies/case-study-details/case-study-shield.html',
				controller: 'caseStudyDetailsCtrl',
				controllerAs: 'vm',
				data: {
					pageTitle: "PIXERF - Case Studies Shield",
					permissions: {
						only: ['EVERY_ONE']
					}
				},
				resolve: {
					caseStudy: function () {
						return {id: 2};
					}
				}
			})
			.state('about-business-page.case-studies.case-study-blackmores', {
				url: '/3/:name',
				templateUrl: 'app/about-business-page/components/case-studies/case-study-details/case-study-blackmores.html',
				controller: 'caseStudyDetailsCtrl',
				controllerAs: 'vm',
				data: {
					pageTitle: "PIXERF - Case Studies Blackmores",
					permissions: {
						only: ['EVERY_ONE']
					}
				},
				resolve: {
					caseStudy: function () {
						return {id: 3};
					}
				}
			})
			.state('about-business-page.case-studies.case-study-gurobu', {
				url: '/4/:name',
				templateUrl: 'app/about-business-page/components/case-studies/case-study-details/case-study-gurobu.html',
				controller: 'caseStudyDetailsCtrl',
				controllerAs: 'vm',
				data: {
					pageTitle: "PIXERF - Case Studies Gurobu",
					permissions: {
						only: ['EVERY_ONE']
					}
				},
				resolve: {
					caseStudy: function () {
						return {id: 4};
					}
				}
			})
			.state('about-business-page.case-studies.case-study-cellini', {
				url: '/5/:name',
				templateUrl: 'app/about-business-page/components/case-studies/case-study-details/case-study-cellini.html',
				controller: 'caseStudyDetailsCtrl',
				controllerAs: 'vm',
				data: {
					pageTitle: "PIXERF - Case Studies Cellini",
					permissions: {
						only: ['EVERY_ONE']
					}
				},
				resolve: {
					caseStudy: function () {
						return {id: 5};
					}
				}
			})
			.state('about-business-page.case-studies.case-study-people-association', {
				url: '/6/:name',
				templateUrl: 'app/about-business-page/components/case-studies/case-study-details/case-study-people-association.html',
				controller: 'caseStudyDetailsCtrl',
				controllerAs: 'vm',
				data: {
					pageTitle: "PIXERF - Case Studies People Association",
					permissions: {
						only: ['EVERY_ONE']
					}
				},
				resolve: {
					caseStudy: function () {
						return {id: 6};
					}
				}
			})
			.state('about-business-page.case-studies.case-study-storytel', {
				url: '/7/:name',
				templateUrl: 'app/about-business-page/components/case-studies/case-study-details/case-study-storytel.html',
				controller: 'caseStudyDetailsCtrl',
				controllerAs: 'vm',
				data: {
					pageTitle: "PIXERF - Case Studies Storytel",
					permissions: {
						only: ['EVERY_ONE']
					}
				},
				resolve: {
					caseStudy: function () {
						return {id: 7};
					}
				}
			})
			.state('about-business-page.case-studies.case-study-ademco', {
				url: '/8/:name',
				templateUrl: 'app/about-business-page/components/case-studies/case-study-details/case-study-ademco.html',
				controller: 'caseStudyDetailsCtrl',
				controllerAs: 'vm',
				data: {
					pageTitle: "PIXERF - Case Studies Ademco",
					permissions: {
						only: ['EVERY_ONE']
					}
				},
				resolve: {
					caseStudy: function () {
						return {id: 8};
					}
				}
			})
			.state('about-business-page.case-studies.case-study-enterprise-singapore', {
				url: '/9/:name',
				templateUrl: 'app/about-business-page/components/case-studies/case-study-details/case-study-enterprise-singapore.html',
				controller: 'caseStudyDetailsCtrl',
				controllerAs: 'vm',
				data: {
					pageTitle: "PIXERF - Case Studies Enterprise Singapore",
					permissions: {
						only: ['EVERY_ONE']
					}
				},
				resolve: {
					caseStudy: function () {
						return {id: 9};
					}
				}
			})
			.state('about-business-page.case-studies.case-study-straits-city', {
				url: '/10/:name',
				templateUrl: 'app/about-business-page/components/case-studies/case-study-details/case-study-straits-city.html',
				controller: 'caseStudyDetailsCtrl',
				controllerAs: 'vm',
				data: {
					pageTitle: "PIXERF - Case Studies Straits City",
					permissions: {
						only: ['EVERY_ONE']
					}
				},
				resolve: {
					caseStudy: function () {
						return {id: 10};
					}
				}
			})
			.state('about-business-page.case-studies.case-study-gojek', {
				url: '/11/:name',
				templateUrl: 'app/about-business-page/components/case-studies/case-study-details/case-study-gojek.html',
				controller: 'caseStudyDetailsCtrl',
				controllerAs: 'vm',
				data: {
					pageTitle: "PIXERF - Case Studies Gojek",
					permissions: {
						only: ['EVERY_ONE']
					}
				},
				resolve: {
					caseStudy: function () {
						return {id: 11};
					}
				}
			})
			.state('about-business-page.case-studies.case-study-wwf', {
				url: '/12/:name',
				templateUrl: 'app/about-business-page/components/case-studies/case-study-details/case-study-wwf.html',
				controller: 'caseStudyDetailsCtrl',
				controllerAs: 'vm',
				data: {
					pageTitle: "PIXERF - Case Studies WWF",
					permissions: {
						only: ['EVERY_ONE']
					}
				},
				resolve: {
					caseStudy: function () {
						return {id: 12};
					}
				}
			})
			.state('about-business-page.case-studies.case-study-cooler-lumpur', {
				url: '/13/:name',
				templateUrl: 'app/about-business-page/components/case-studies/case-study-details/case-study-cooler-lumpur.html',
				controller: 'caseStudyDetailsCtrl',
				controllerAs: 'vm',
				data: {
					pageTitle: "PIXERF - Case Studies Cooler Lumpur",
					permissions: {
						only: ['EVERY_ONE']
					}
				},
				resolve: {
					caseStudy: function () {
						return {id: 13};
					}
				}
			})
			.state('about-business-page.case-studies.case-study-asian-geographic', {
				url: '/14/:name',
				templateUrl: 'app/about-business-page/components/case-studies/case-study-details/case-study-asian-geographic.html',
				controller: 'caseStudyDetailsCtrl',
				controllerAs: 'vm',
				data: {
					pageTitle: "PIXERF - Case Studies Asian Geographic",
					permissions: {
						only: ['EVERY_ONE']
					}
				},
				resolve: {
					caseStudy: function () {
						return {id: 14};
					}
				}
			})
			.state('about-business-page.case-studies.case-study-salam-singapore', {
				url: '/15/:name',
				templateUrl: 'app/about-business-page/components/case-studies/case-study-details/case-study-salam-singapore.html',
				controller: 'caseStudyDetailsCtrl',
				controllerAs: 'vm',
				data: {
					pageTitle: "PIXERF - Case Studies Salam Singapore",
					permissions: {
						only: ['EVERY_ONE']
					}
				},
				resolve: {
					caseStudy: function () {
						return {id: 15};
					}
				}
			});
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('aboutCaseStudiesCtrl', aboutCaseStudiesCtrl);

	aboutCaseStudiesCtrl.$inject = ['$scope', 'caseStudiesSvc', '$state'];

	function aboutCaseStudiesCtrl($scope, caseStudiesSvc, $state) {

		var self = this;

		self.caseStudies = caseStudiesSvc.getCaseStudies();
		self.onGoToDetails = onGoToDetails;

		function onGoToDetails(caseStudyId){
			$state.go("about-business-page.case-studies.case-study-details", {id: caseStudyId});
		}
	}
})();

(function () {

	angular
		.module('pixerf')
		.factory('userProfilePortfolioSvc', userProfilePortfolioSvc);

	userProfilePortfolioSvc.$inject = ['pixerfApiMediaSvc', 'toastr'];

	function userProfilePortfolioSvc(pixerfApiMediaSvc, toastr) {


		var mSpinner = {
			visible: false
		};
		var mPhotos = {
			data: []
		};
		var mBufferPhotos = {
			data: []
		};

		function getPhotos() {
			return mPhotos;
		}

		function getBufferPhotos() {
			return mBufferPhotos;
		}

		function getSpinner() {
			return mSpinner;
		}

		function reset() {
			mPhotos.data = [];
		}

		function fetchPhotos(searchParam) {
			pixerfApiMediaSvc.search({}, function (response) {
				mPhotos.data = response.data;
			}, function () {
				toastr.error("Failed to retrieve photos. Please try again.");
			})
		}

		return {
			getSpinner: getSpinner,
			getPhotos: getPhotos,
			fetchPhotos: fetchPhotos,
			reset: reset,
			getBufferPhotos: getBufferPhotos
		};
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('userProfilePortfolioCtrl', userProfilePortfolioCtrl);

	userProfilePortfolioCtrl.$inject = ['$scope', 'userPromise', 'sessionManagerSvc'];

	function userProfilePortfolioCtrl($scope, userPromise, sessionManagerSvc) {
		var self = this;
		$scope.$parent.vm.contextPage = "Portfolio";
		self.parent = $scope.$parent.vm;
		self.parent.isRightPanelShown = false;
		self.user = userPromise;
		self.isMine = sessionManagerSvc.isMine(self.user);
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.config(routerConfig);

	routerConfig.$inject = ['$stateProvider'];

	function routerConfig($stateProvider) {
		'ngInject';
		$stateProvider
			.state('user-home-page.personal.portfolio.portfolio-detail', {
				url: '/:portfolioId/gallery/:galleryId',
				abstract: true,
				templateUrl: 'app/portfolio-detail-page/portfolio-detail-page.html',
				controller: 'portfolioDetailPageCtrl',
				controllerAs: 'vm',
				data: {
					pageTitle: "PIXERF - Portfolio Detail",
					perportfolios: {
						only: ['EVERY_ONE']
					}
				},
				params: {
					"portfolioId": {
						squash: true,
						value: null
					},
					"galleryId": {
						squash: true,
						value: null
					}
				},
				resolve: {
					portfolioData: function ($stateParams, pixerfApiGallerySvc, $q, $state) {
						var defer = $q.defer();
						var self = this;
						var galleryId = parseInt($stateParams.galleryId);
						var portfolioId = $stateParams.portfolioId;
						if (!$stateParams.galleryId || ($stateParams.galleryId && isNaN(galleryId))) {
							$state.go('404');
							defer.reject();
						} else {
							pixerfApiGallerySvc.get({
								id: galleryId
							}).$promise.then(function (response) {
								var portfolio = response.data;
								self.data.pageTitle = "PIXERF - Portfolio " + portfolioId;
								defer.resolve(portfolio);
							}, function () {
								$state.go('404');
								defer.reject();
							})
						}
						return defer.promise;
					}
				}
			})
			.state('user-home-page.personal.portfolio.carousel', {
				url: '/all',
				templateUrl: 'app/user-home-page/components/user-profile-portfolio/user-profile-portfolio-carousel/user-profile-portfolio-carousel.html',
				controller: 'userProfilePortfolioCarouselCtrl',
				controllerAs: 'vm'
			})
			.state('user-home-page.personal.portfolio.grid', {
				url: '/:portfolioId',
				templateUrl: 'app/user-home-page/components/user-profile-portfolio/user-profile-portfolio-grid/user-profile-portfolio-grid.html',
				controller: 'userProfilePortfolioGridCtrl',
				controllerAs: 'vm'
			})
			.state('user-home-page.personal.portfolio.portfolio-detail.portfolio-photos', {
				url: '/details',
				templateUrl: 'app/portfolio-detail-page/portfolio-detail-page-photos/portfolio-detail-page-photos.html',
				controller: 'portfolioDetailPagePhotosCtrl',
				controllerAs: 'vm'
			});
	}

})();

﻿/*
 * Service handler for User Home Page module
 * We will implement all business logic for "home" module here
 */
/**
 * Controller for home module
 */
(function(){

  angular
    .module('pixerf')
    .factory('userHomePageSvc', userHomePageSvc);

    userHomePageSvc.$inject = ['pixerfApiMediaSvc', 'toastr', 'sessionManagerSvc', 'pixerfApiUserSvc'];

    function userHomePageSvc(pixerfApiMediaSvc, toastr, sessionManagerSvc, pixerfApiUserSvc){
    	
        var mCurrentPage = {
            data: 0
        };

        var mPhotos = {data: []};
    	var mBufferPhotos = {data: []};

        function getCurrentPhotoPage(){
            return mCurrentPage;
        }
    	function getPhotos(){
            return mPhotos;
        }
        function getBufferPhotos(){
    		return mBufferPhotos;
    	}
        function reset(){
            mPhotos.data = [];
            mBufferPhotos.data = [];
            mCurrentPage.data = 0;
        }
    	function fetchPhotos(searchParam){
    		return pixerfApiMediaSvc.search({
                    page: searchParam.page
                }, {
                user:{
                    username: searchParam.username
                }
            }).$promise;
    	}
        function fetchMorePhotos(searchParam){
            mCurrentPage.data++;
            searchParam.page = mCurrentPage.data;
            return fetchPhotos(searchParam);
        }
        function getUser(id){
            return pixerfApiUserSvc.get({
                id: id
            });
        }
		/*
		 * exports public methods
		 */
		return {
			getPhotos: getPhotos,
            getBufferPhotos: getBufferPhotos,
			fetchPhotos: fetchPhotos,
            reset: reset,
            getUser: getUser,
            fetchMorePhotos: fetchMorePhotos,
            getCurrentPhotoPage: getCurrentPhotoPage
		};
    }
})();

(function () {

	angular
		.module('pixerf')
		.controller('userProfilePhotosCtrl', userProfilePhotosCtrl);

	userProfilePhotosCtrl.$inject = ['resendVerificationEmailPopupSvc', 'uploadPhotoSvc', '$scope', 'sessionManagerSvc', '$q', 'pixerfApiUserSvc', 'pagingUtils', 'photoViewerSvc'];

	function userProfilePhotosCtrl(resendVerificationEmailPopupSvc, uploadPhotoSvc, $scope, sessionManagerSvc, $q, pixerfApiUserSvc, pagingUtils, photoViewerSvc) {
		var self = this;
		$scope.$parent.vm.contextPage = "Photos";
		self.parent = $scope.$parent.vm;
		self.parent.isLeftPanelShown = false;
		$scope.$parent.vm.userProfilePhotosCtrl = self;
		self.name = 'name';
		self.parent.isRightPanelShown = false;
		self.user = $scope.vm.user;
		self.photoGrid = null;
		self.isMyProfile = self.parent.isMyProfile;
		self.showUploadModal = showUploadModal;
		self.onFileRemoved = onFileRemoved;
		self.loginnedUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.fetchPhotos = fetchPhotos;
		self.fetchMorePhotos = fetchMorePhotos;
		self.onPhotoPopupClosed = onPhotoPopupClosed;
		self.onFilteredClicked = onFilteredClicked;
		self.bidingItems = [];
		self.selectedDefaultIndex = 1;
		self.gridSort = "freshness";
		self.selectedFilterItem = {};
		self.filterSetting = {
			"items": [{
					name: "Popularity",
					value: "popularity"
				},
				{
					name: "Upload date",
					value: "freshness"
				}
			]
		};
		self.spinner = {
			isVisible: false
		}
		self.searchParams = {
			page: 1,
			userId: self.user.id,
			sort: ["inserted_at,desc"]
		};
		self.photoIds = [];


		self.options = self.parent.options;
        self.isBulkEditPhoto = self.options && self.options.bulkEditPhoto || false;
		self.bulkSelectedPhoto = self.options && self.options.bulkSelectedPhoto || [];

		$scope.$watch('$parent.vm.bulkSelectedPhoto', function (value) {
			if(value != undefined ){
				self.bulkSelectedPhoto = value;
				self.options.bulkSelectedPhoto =  value;
			}
		}, true);
		$scope.$watch('$parent.vm.isSelectedPhotos', function (value) {
			if(value != undefined ){
				self.isBulkEditPhoto = value;
				self.options.isBulkEditPhoto =  value;
			}
		}, true);

		init();

		function init() {
			fetchPhotos(self.searchParams, true);
		}

		function showUploadModal() {
			if (self.user.is_email_verified) {
				uploadPhotoSvc.showUploadModal();
			} else {
				resendVerificationEmailPopupSvc.showVerifyEmailPopup();
			}
		}

		function onFileRemoved(file) {
			self.user.stats.media_count -= 1;
			self.photoGrid.totalPhotos--;
			if (file.isMine) {
				self.loginnedUser = sessionManagerSvc.getCurrentLoginUser().data;
				self.loginnedUser.stats.media_count--;
				sessionManagerSvc.setCurrentLoginUser(self.loginnedUser);
			}
		}

		function onPhotoPopupClosed(originalFile, newFile) {
			self.user.is_followed = newFile.user.is_followed;
		}

		function fetchPhotos(searchParams, isFresh) {
			if (self.spinner.isVisible && self.isWorking) return;
			self.searchParams = searchParams;
			self.spinner.isVisible = true;
			self.isWorking = true;
			self.isFresh = isFresh
			var urlParams = {
				id: searchParams.userId,
				page: searchParams.page
			}
			if (self.gridSort === "freshness") {
				groupPhotoByMonth(searchParams, urlParams, isFresh);
			} else {
				pixerfApiUserSvc.get_medias(urlParams, searchParams).$promise.then(function (response) {
					self.bidingItems = self.bidingItems.concat(response.data);
					photoViewerSvc.setSearchParams(self.searchParams);
					self.photoIds = _.pluck(self.bidingItems, "id");
					photoViewerSvc.setListPhoto(self.photoIds);
					self.isLastPage = pagingUtils.isNoMorePageToLoad(searchParams.page, response);
					self.totalPhotos = pagingUtils.getTotalCount(response);
					self.totalPage = pagingUtils.getTotalPage(response);
					self.isWorking = false;
					self.spinner.isVisible = false;
				}).catch(function () {
					self.isWorking = false;
					self.spinner.isVisible = false;
				})
			}
		}

		function fetchMorePhotos() {
			if (self.spinner.isVisible && self.isWorking) {
				return;
			}
			self.searchParams.page++;
			fetchPhotos(self.searchParams);
		}

		function onFilteredClicked(selectedFilterItem) {
			self.items = [];
			self.bidingItems = [];
			self.photoIds = []
			self.gridSort = selectedFilterItem.value;
			self.searchParams.page = 1;
			self.searchParams.sort = self.gridSort;
			fetchPhotos(self.searchParams, true)
		}

		function groupPhotoByMonth(searchParams, urlParams, isFresh) {
			pixerfApiUserSvc.get_medias(urlParams, searchParams).$promise.then(function (response) {
				if (searchParams.page === 1) {
					self.items = [];
				}
				if (response && response.data && response.data.length > 0) {
					self.items = self.items.concat(response.data);
					photoViewerSvc.setSearchParams(self.searchParams);
					groupedByMonth = _.groupBy(response.data, function (item) {
						return item.inserted_at.substring(0, 7);
					});
					for (obj in groupedByMonth) {
						var formatObjDate = moment(obj).format('MMMM') + ' ' + moment(obj).format('YYYY');
						var isExistInGroup = _.findIndex(self.bidingItems, function (item) {
							return item.title === formatObjDate;
						});

						if (isExistInGroup > -1) {
							self.bidingItems[isExistInGroup].data = self.bidingItems[isExistInGroup].data.concat(groupedByMonth[obj]);
							self.photoIds = self.photoIds.concat(_.pluck(self.bidingItems[isExistInGroup].data, "id"));

						} else {
							self.bidingItems.push({
								title: formatObjDate,
								data: groupedByMonth[obj],
								collapse: moment(obj).format('MMM') + '-' + moment(obj).format('YY')
							})
							self.photoIds = self.photoIds.concat(_.pluck(groupedByMonth[obj], "id"));
						}
					}
					photoViewerSvc.setListPhoto(self.photoIds);
				}
				self.isWorking = false;
				self.spinner.isVisible = false;
				self.isLastPage = pagingUtils.isNoMorePageToLoad(searchParams.page, response);
				self.totalPhotos = pagingUtils.getTotalCount(response);
				self.totalPage = pagingUtils.getTotalPage(response);
			})
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.component('userProfilePhotos', userProfilePhotos);

	function userProfilePhotos() {

		var component = {
			bindings: {
				user: "=",
				galleryType: "@"
			},
			templateUrl: 'app/user-home-page/components/user-profile-photos/user-profile-photos.html',
			controller: 'userProfilePhotosCtrl',
			controllerAs: 'vm'
		};
		return component;
	}

})();

(function () {

	angular
		.module('pixerf')
		.controller('userProfileNavigationCtrl', userProfileNavigationCtrl);

	userProfileNavigationCtrl.$inject = ['$scope', 'sessionManagerSvc', 'organizationDetailPopupSvc', '$timeout', '$rootScope', 'messageConst',
		'bulkEditPhotoPopupSvc', '$state'];

	function userProfileNavigationCtrl($scope, sessionManagerSvc, organizationDetailPopupSvc, $timeout, $rootScope, messageConst,
		bulkEditPhotoPopupSvc, $state) {
		var self = this;
		var canBulkEditPhotoOnState = [
			'user-home-page.personal.home',
			'user-home-page.personal.photos',
		]
		self.user = $scope.user;
		self.onOrgDetailClicked = onOrgDetailClicked;
		self.loginnedUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.socialShareContent = buildSocialShareContent();
		self.canBulkEditPhoto = self.loginnedUser && (self.loginnedUser.isAdminInternal || self.loginnedUser.isCurator || self.loginnedUser.isAdmin);
		self.bulkEditPhoto = bulkEditPhoto;
		self.selectPhotoBtnClicked = selectPhotoBtnClicked;
		self.isSelectedPhotos = $scope.options && $scope.options.bulkEditPhoto || false;
		self.bulkSelectedPhoto = $scope.options && $scope.options.bulkSelectedPhoto || [];
		self.allowBulkEditPhotoOnState = false;

		$scope.$watch('$scope.options.bulkSelectedPhoto', function (value) {
			if (value != undefined) {
				self.bulkSelectedPhoto = value;
			}
		});

		$scope.$watch('$scope.options.isSelectedPhotos', function (value) {
			if (value != undefined) {
				self.isSelectedPhotos = value;
			}
		});

		$rootScope.$on('$stateChangeSuccess', function (event, toState) {
			$timeout(function () {
				self.showTopCountMember = (toState.name == 'manage-community.members');
				self.showReportsNav = (toState.name == 'manage-community.reports');
				self.allowBulkEditPhotoOnState = showBulkEditPhoto();
			}, 300);
		});

		$rootScope.$on('$stateChangeStart', function (event, toState) {
			selectPhotoBtnClicked(false);
		});

		$scope.$on(messageConst.BROADCAST.BULK_SELECTED_PHOTO_CANCEL, function () {
			selectPhotoBtnClicked(false);
		});

		$timeout(function () {
			updateSocialShareContent();
		}, 0)

		self.scrollToFixedConfig = {
			marginTop: function () {
				var marginTop = $(window).height() - $('#user-profile-navigation').outerHeight(true) - 61;
				if (marginTop >= 0) return 57;
				return marginTop;
			}
		};

		self.scrollToFixedWhen = {
			minWidth: 768
		};

		self.isGuestUser = function () {
			return !self.user.account_type;
		}

		if ($scope.scrollToFixedConfig) {
			self.scrollToFixedConfig = $scope.scrollToFixedConfig;
		}

		function showBulkEditPhoto() {
			var route = $state.current;
			if (!(route && route.name)) return false;
			return canBulkEditPhotoOnState.includes(route.name);
		}

		function updateSocialShareContent() {
			self.socialShareContent = buildSocialShareContent();
		}

		function onOrgDetailClicked(businessInfo) {
			organizationDetailPopupSvc.showPopup(businessInfo);
		}

		function buildSocialShareContent() {
			return { 'url': window.location.href, 'description': self.user.displayName, 'title': self.user.displayName, 'media': self.user.avatar && self.user.avatar.coverImage };
		}

		function popupBulkEditChanged(key) {
			if (!($scope && $scope.options && $scope.options.buldEditPhotoChanged && $scope.options.bulkSelectedPhotoChanged)) return;
			switch (key) {
				case 'buldEditPhotoChanged':
					$scope.options.buldEditPhotoChanged(self.isSelectedPhotos);
					break;
				case 'bulkSelectedPhotoChanged':
					$scope.options.bulkSelectedPhotoChanged(self.bulkSelectedPhoto);
					break;
				default:
					break
			}
		}
		function selectPhotoBtnClicked(value) {
			if (value == false) {
				self.isSelectedPhotos = false;
				popupBulkEditChanged('buldEditPhotoChanged');
				self.bulkSelectedPhoto = [];
				return popupBulkEditChanged('bulkSelectedPhotoChanged');
			}
			self.isSelectedPhotos = !self.isSelectedPhotos;
			popupBulkEditChanged('buldEditPhotoChanged');
		}

		function bulkEditPhoto() {
			bulkEditPhotoPopupSvc.showUploadModal({ photos: self.bulkSelectedPhoto });
		}

		function init() {
			self.allowBulkEditPhotoOnState = showBulkEditPhoto();
		}

		init();
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('userProfileNavigation', userProfileNavigation);

	function userProfileNavigation() {

		var directive = {
			scope: {
				user: "=",
				navigationClass: "@?",
				scrollToFixedConfig: "=?",
				context: "@?",
				options: '='
			},
			restrict: 'E',
			templateUrl: 'app/user-home-page/components/user-profile-navigation/user-profile-navigation.html',
			controller: 'userProfileNavigationCtrl',
			controllerAs: 'vm',
			replace: true
		};
		return directive;
	}
})();

﻿(function () {

	angular
		.module('pixerf')
		.factory('galleriesSvc', galleriesSvc);

	galleriesSvc.$inject = ['pixerfApiMediaSvc', 'toastr'];

	function galleriesSvc(pixerfApiMediaSvc, toastr) {


		var mSpinner = {
			visible: false
		};
		var mPhotos = {
			data: []
		};
		var mBufferPhotos = {
			data: []
		};

		function getPhotos() {
			return mPhotos;
		}

		function getBufferPhotos() {
			return mBufferPhotos;
		}

		function getSpinner() {
			return mSpinner;
		}

		function reset() {
			mPhotos.data = [];
		}

		function fetchPhotos(searchParam) {
			pixerfApiMediaSvc.search({}, function (response) {
				mPhotos.data = response.data;
				console.log(mPhotos.data);
			}, function () {
				toastr.error("Failed to retrieve photos. Please try again.");
			})
		}

		return {
			getSpinner: getSpinner,
			getPhotos: getPhotos,
			fetchPhotos: fetchPhotos,
			reset: reset,
			getBufferPhotos: getBufferPhotos
		};
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('galleriesCtrl', galleriesCtrl);

	galleriesCtrl.$inject = ['$scope', 'createGallerySvc', 'sessionManagerSvc', '$state', 'userPromise', '$stateParams'];

	function galleriesCtrl($scope, createGallerySvc, sessionManagerSvc, $state, userPromise, $stateParams) {
		var self = this;
		$scope.$parent.vm.contextPage = "Galleries";
		self.parent = $scope.$parent.vm;
		self.user = userPromise;
		self.parent.isLeftPanelShown = false;
		self.parent.isRightPanelShown = false;
		self.isMine = sessionManagerSvc.isMine(self.user);
		self.loginnedUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.onGalleryClicked = onGalleryClicked;
		self.galleryDefault = null;
		self.galleryCurated = null;
		self.galleryFollowing = null;
		self.scrollOffsetTopGallery = 110;
		self.isTypeGalleryShowAll = $stateParams.type;
		self.goBackBtnClicked = goBackBtnClicked;
		self.onCreateGalleryBtnClicked = onCreateGalleryBtnClicked;

		$scope.$watch("vm.galleryDefault", function () {
			fetchGalleries('galleryDefault', 'default');
		})

		$scope.$watch("vm.galleryCurated", function () {
			fetchGalleries('galleryCurated', 'curated');
		})

		$scope.$watch("vm.galleryFollowing", function () {
			fetchGalleries('galleryFollowing', 'following');
		})

		function fetchGalleries(name, type) {
			if (self[name]) {
				self[name].fetchGalleries({
					type: type,
					userid: self.user.id,
					page: 1
				}, true);
			}
		}

		function onCreateGalleryBtnClicked(galleries) {
			var modal = createGallerySvc.showCreateGalleryModal({
				type: galleries.searchParams.type,
				overridSuccessMsg: true
			});
			modal.result.then(function (newCreatedGallery) {
				galleries.galleries.unshift(newCreatedGallery);
			});
		}

		function onGalleryClicked(gallery) {
			$state.go('gallery', {
				id: gallery.id
			})
		}

		function goBackBtnClicked() {
			window.history.back();
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.component('userProfileGalleries', userProfileGalleries);

	function userProfileGalleries() {

		var component = {
			bindings: {
				user: "=",
				galleryType: "@"
			},
			templateUrl: 'app/user-home-page/components/galleries/galleries.html',
			controller: 'galleriesCtrl',
			controllerAs: 'vm'
		};
		return component;
	}

})();

(function () {

	angular
		.module('pixerf')
		.controller('userProfileCommunitiesCtrl', userProfileCommunitiesCtrl);

	userProfileCommunitiesCtrl.$inject = ['$scope'];

	function userProfileCommunitiesCtrl($scope) {
		var self = this;
		self.parent = $scope.$parent.vm;
		self.parent.contextPage = "Communities";
		self.parent.isRightPanelShown = false;
		self.parent.isManagePage = false;
		self.isMyProfile = self.parent.isMyProfile;
		self.user = self.parent.user;
		self.scrolControl = 0;
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.config(routerConfig);

	routerConfig.$inject = ['$stateProvider'];

	function routerConfig($stateProvider) {
		'ngInject';
		$stateProvider
			.state('user-home-page.communities.community-detail', {
				url: '/:communityId',
				abstract: true,
				templateUrl: 'app/community-detail-page/community-detail-page.html',
				controller: 'communityDetailPageCtrl',
				controllerAs: 'vm',
				data: {
					pageTitle: "PIXERF - Mission Detail",
					permissions: {
						only: ['EVERY_ONE']
					}
				},
				params: {
					"communityId": {
						squash: true,
						value: null
					},
					"name": {
						squash: true,
						value: null
					}
				},
				resolve: {
					communityData: function ($stateParams, pixerfApiCommunitySvc, $q, $state) {
						var defer = $q.defer();
						var self = this;
						var communityId = parseInt($stateParams.communityId);
						if (!$stateParams.communityId || ($stateParams.communityId && isNaN(communityId))) {
							$state.go('404');
							defer.reject();
						} else {
							pixerfApiCommunitySvc.get({
								id: communityId
							}).$promise.then(function (response) {
								var community = response.data;
								self.data.pageTitle = "PIXERF - Community: " + community.name;
								defer.resolve(community);
							}, function (err) {
								console.log(err);
								$state.go('404');
								defer.reject();
							})
						}
						return defer.promise;
					}
				}
			})
			.state('user-home-page.communities.community-detail.community-detail-page-members', {
				url: '/members',
				templateUrl: 'app/community-detail-page/components/community-detail-page-members/community-detail-page-members.html',
				controller: 'communityDetailPageMembersCtrl',
				controllerAs: 'vm'
			})
			.state('user-home-page.communities.community-detail.community-detail-page-pending-approval', {
				url: '/pending-approval',
				templateUrl: 'app/community-detail-page/components/community-detail-page-pending-approval/community-detail-page-pending-approval.html',
				controller: 'communityDetailPagePendingApprovalCtrl',
				controllerAs: 'vm'
			})
			.state('user-home-page.communities.community-detail.community-detail-page-invite-member', {
				url: '/invite-member',
				templateUrl: 'app/community-detail-page/components/community-detail-page-invite-member/community-detail-page-invite-member.html',
				controller: 'communityDetailPageInviteMemberCtrl',
				controllerAs: 'vm'
			})
			.state('user-home-page.communities.community-detail.community-detail-page-brief', {
				url: '/brief',
				templateUrl: 'app/community-detail-page/components/community-detail-page-brief/community-detail-page-brief.html',
				controller: 'communityDetailPageBriefCtrl',
				controllerAs: 'vm'
			});
	}

})();

(function () {

	angular
		.module('pixerf')
		.controller('userFrontPageCtrl', userFrontPageCtrl);

	userFrontPageCtrl.$inject = ['$scope', 'composePostPopupSvc', 'notifyTopupCreditPopupSvc', 'sessionManagerSvc', '$state', 'notifyFeatureNotAvailablePopupSvc', 'commisionNotAvailablePopupSvc'];

	function userFrontPageCtrl($scope, composePostPopupSvc, notifyTopupCreditPopupSvc, sessionManagerSvc, $state, notifyFeatureNotAvailablePopupSvc, commisionNotAvailablePopupSvc) {
		var self = this;
		self.parent = $scope.$parent.vm;
		self.parent.isRightPanelShown = true;
		self.parent.contextPage = "Feed";
		self.user = self.parent.user;
		self.composePost = composePost;
		self.onInputClicked = onInputClicked;
		self.onOutSideClicked = onOutSideClicked;
		self.onCreateMissionClicked = onCreateMissionClicked;
		self.onCreateCustomCommissionClicked = onCreateCustomCommissionClicked;
		self.onBuildCommunityClicked = onBuildCommunityClicked;
		self.isMine = sessionManagerSvc.isMine(self.user);
		self.newFeedContent = null;
		self.filterSetting = {
			"items": [{
					name: "Public post",
					value: "public"
				},
				{
					name: "Privated post",
					value: "privated"
				}
			]
		};
		self.posts = [];

		function onInputClicked() {
			self.isFocusedInput = true;
		}

		function onOutSideClicked() {
			self.isFocusedInput = false;
		}

		function composePost() {
			composePostPopupSvc.showPopup();
		}

		function onCreateMissionClicked() {
			if (self.user && self.user.canCreateMission) {
				$state.go("setting.manage-missions.on-going");
				// $state.go("setting.manage-missions.create-mission.getting-started");
			}
		}

		function onCreateCustomCommissionClicked() {
			if (self.user.isHondaCC) {
				$state.go("setting.manage-custom-commissions.on-going");
			} else {
				commisionNotAvailablePopupSvc.showPopup();
			}
		}

		function onBuildCommunityClicked() {
			notifyFeatureNotAvailablePopupSvc.showPopup();
		}
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('personalHomePageCtrl', personalHomePageCtrl);

	personalHomePageCtrl.$inject = ['$scope', 'pixerfApiPortfolioSvc', '$q', '$state', 'sessionManagerSvc', 'photoViewerSvc', 'commonConst', 'pagingUtils', 'pixerfApiUserSvc'];

	function personalHomePageCtrl($scope, pixerfApiPortfolioSvc, $q, $state, sessionManagerSvc, photoViewerSvc, commonConst, pagingUtils, pixerfApiUserSvc) {
		var self = this;
		self.parent = $scope.$parent.vm;
		self.parent.contextPage = "Home";
		self.user = $scope.vm.user;
		self.portfolios = [];
		self.photoGrid = null;
		self.fetchPhotos = fetchPhotos;
		self.onPortfolioClicked = onPortfolioClicked;
		self.fetchMorePhotos = fetchMorePhotos;
		self.onPhotoPopupClosed = onPhotoPopupClosed;
		self.onFilteredClicked = onFilteredClicked;
		self.isMyProfile = self.parent.isMyProfile;
		self.loginnedUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.spinner = {
			isVisible: false
		};
		self.carouselConfig = {
			slidesToShow: 3,
			slidesToScroll: 3,
			responsive: [{
				breakpoint: 1024,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2
				}
			}, {
				breakpoint: 480,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1
				}
			}]
		};
		self.bidingItems = [];
		self.selectedDefaultIndex = 0;
		self.gridSort = "popularity";
		self.options = self.parent.options;
		self.selectedFilterItem = {};
		self.filterSetting = {
			"items": [{
				name: "Popularity",
				value: "popularity"
			},
			{
				name: "Upload date",
				value: "freshness"
			}
			]
		};
		self.searchParams = {
			page: 1,
			userId: self.user.id,
			sort: 'popularity'
		};

		self.photoIds = [];

		self.options = self.parent.options;
		self.isBulkEditPhoto = self.options && self.options.bulkEditPhoto || false;
		self.bulkSelectedPhoto = self.options && self.options.bulkSelectedPhoto || [];

		$scope.$watch('$parent.vm.bulkSelectedPhoto', function (value) {
			if (value != undefined) {
				self.bulkSelectedPhoto = value;
				self.options.bulkSelectedPhoto = value;
			}
		});

		$scope.$watch('$parent.vm.isSelectedPhotos', function (value) {
			if (value != undefined) {
				self.isBulkEditPhoto = value;
				self.options.isBulkEditPhoto = value;
			}
		});

		init();

		function init() {
			fetchPhotos(self.searchParams, true);
			if (self.user && self.user.profile && self.user.profile.specialities) {
				fetchPortfolios(self.user.profile.specialities);
			}
		}

		function fetchPhotos(searchParams, isFresh) {
			if (self.spinner.isVisible && self.isWorking) return;
			self.searchParams = searchParams;
			self.spinner.isVisible = true;
			self.isWorking = true;
			self.isFresh = isFresh
			var urlParams = {
				id: searchParams.userId,
				page: searchParams.page
			}
			if (self.gridSort === "freshness") {
				groupPhotoByMonth(searchParams, urlParams, isFresh);
			} else {
				pixerfApiUserSvc.get_medias(urlParams, searchParams).$promise.then(function (response) {
					self.bidingItems = self.bidingItems.concat(response.data);
					self.photoIds = _.pluck(self.bidingItems, "id");
					photoViewerSvc.setListPhoto(self.photoIds);
					self.isLastPage = pagingUtils.isNoMorePageToLoad(searchParams.page, response);
					self.totalPhotos = pagingUtils.getTotalCount(response);
					self.totalPage = pagingUtils.getTotalPage(response);
					self.isWorking = false;
					self.spinner.isVisible = false;
				}).catch(function () {
					self.isWorking = false;
					self.spinner.isVisible = false;
				})
			}
		}

		function groupPhotoByMonth(searchParams, urlParams, isFresh) {
			pixerfApiUserSvc.get_medias(urlParams, searchParams).$promise.then(function (response) {
				if (searchParams.page === 1) {
					self.items = [];
				}
				if (response && response.data && response.data.length > 0) {
					self.items = self.items.concat(response.data);
					var groupedByMonth = _.groupBy(response.data, function (item) {
						return item.inserted_at.substring(0, 7);
					});
					for (var obj in groupedByMonth) {
						var formatObjDate = moment(obj).format('MMMM') + ' ' + moment(obj).format('YYYY');
						var isExistInGroup = _.findIndex(self.bidingItems, function (item) {
							return item.title === formatObjDate;
						});

						if (isExistInGroup > -1) {
							self.bidingItems[isExistInGroup].data = self.bidingItems[isExistInGroup].data.concat(groupedByMonth[obj]);
						} else {
							self.bidingItems.push({
								title: formatObjDate,
								data: groupedByMonth[obj],
								collapse: moment(obj).format('MMM') + '-' + moment(obj).format('YY')
							});
						}
						self.photoIds = self.photoIds.concat(_.pluck(groupedByMonth[obj], "id"));
					}
					photoViewerSvc.setListPhoto(self.photoIds);
				}
				self.isWorking = false;
				self.spinner.isVisible = false;
				self.isLastPage = pagingUtils.isNoMorePageToLoad(searchParams.page, response);
				self.totalPhotos = pagingUtils.getTotalCount(response);
				self.totalPage = pagingUtils.getTotalPage(response);
			})
		}

		function fetchMorePhotos() {
			if (self.spinner.isVisible && self.isWorking) {
				return;
			}
			self.searchParams.page++;
			fetchPhotos(self.searchParams);
		}

		function onFilteredClicked(selectedFilterItem) {
			self.items = [];
			self.bidingItems = [];
			self.photoIds = []
			self.gridSort = selectedFilterItem.value;
			self.searchParams.page = 1;
			self.searchParams.sort = self.gridSort;
			fetchPhotos(self.searchParams, true)
		}

		function onPhotoPopupClosed(originalFile, newFile) {
			self.user.is_followed = newFile.user.is_followed;
		}

		function fetchPortfolios(specialities) {
			var params = {
				userid: self.user.id,
				page: 1
			};
			var portfolioGridPromises = [];

			self.spinner.isVisible = true;
			for (var i = 0; i < specialities.length; i++) {
				params.speciality = specialities[i].id;
				portfolioGridPromises.push(
					pixerfApiPortfolioSvc.getUserPortfolios(params).$promise.then(function (portfolio) {
						if (!portfolio.data || !portfolio.data.length) {
							return;
						}
						var mapSpec = _.findWhere(self.user.profile.specialities, {
							id: portfolio.data[0].speciality_id
						});
						if (!mapSpec) {
							return portfolio;
						}
						_.map(portfolio.data, function (ele) {
							ele.speciality = mapSpec.name;
							return ele;
						});
						return portfolio;
					})
				);
			}

			$q.all(portfolioGridPromises).then(function (portfolios) {
				for (var i = 0; i < portfolios.length; i++) {
					if (portfolios[i] && portfolios[i].data && portfolios[i].data.length) {
						portfolios[i].data = portfolios[i].data.slice(0, 3);
						self.portfolios = self.portfolios.concat(portfolios[i].data);
					}
				}
			});
		}

		function onPortfolioClicked(portfolio) {
			$state.go(commonConst.STATE.PORTFOLIO_PHOTOS, {
				portfolioId: portfolio.portfolio.speciality_id,
				galleryId: portfolio.portfolio.id
			});
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('moreTools', moreTools);

	function moreTools() {

		var directive = {
			scope: false,
			restrict: 'E',
			templateUrl: 'app/user-home-page/components/more-tools/more-tools.html',
			controllerAs: 'vm',
			replace: true
		};
		return directive;
	}

})();

(function () {

	angular
		.module('pixerf')
		.controller('guestlHomePageCtrl', guestlHomePageCtrl);

		guestlHomePageCtrl.$inject = ['$scope', 'pixerfApiPortfolioSvc', '$q', '$state', 'sessionManagerSvc', 'resendVerificationEmailPopupSvc', 'commonConst', 'pagingUtils', 'pixerfApiUserSvc'];

	function guestlHomePageCtrl($scope, pixerfApiPortfolioSvc, $q, $state, sessionManagerSvc, resendVerificationEmailPopupSvc, commonConst, pagingUtils, pixerfApiUserSvc) {
		var self = this;
		self.parent = $scope.$parent.vm;
		self.parent.contextPage = "Home";
		self.user = $scope.vm.user;
		self.portfolios = [];
		self.photoGrid = null;
		self.fetchPhotos = fetchPhotos;
		self.onPortfolioClicked = onPortfolioClicked;
		self.fetchMorePhotos = fetchMorePhotos;
		self.onPhotoPopupClosed = onPhotoPopupClosed;
		self.onFilteredClicked = onFilteredClicked;
		self.isMyProfile = self.parent.isMyProfile;
		self.loginnedUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.spinner = {
			isVisible: false
		};
		self.carouselConfig = {
			slidesToShow: 3,
			slidesToScroll: 3,
			responsive: [{
				breakpoint: 1024,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2
				}
			}, {
				breakpoint: 480,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1
				}
			}]
		};
		self.bidingItems = [];
		self.selectedDefaultIndex = 0;
		self.gridSort = "popularity";
		self.selectedFilterItem = {};
		self.filterSetting = {
			"items": [{
					name: "Popularity",
					value: "popularity"
				},
				{
					name: "Upload date",
					value: "freshness"
				}
			]
		};
		self.searchParams = {
			page: 1,
			userId: self.user.id,
			sort: 'popularity'
		};

		init();

		function init() {
			fetchPhotos(self.searchParams, true);
			if (self.user && self.user.profile && self.user.profile.specialities) {
				fetchPortfolios(self.user.profile.specialities);
			}
		}

		function fetchPhotos(searchParams, isFresh) {
			if (self.spinner.isVisible && self.isWorking) return;
			self.searchParams = searchParams;
			self.spinner.isVisible = true;
			self.isWorking = true;
			self.isFresh = isFresh
			var urlParams = {
				id: searchParams.userId,
				page: searchParams.page
			}
			if (self.gridSort === "freshness") {
				groupPhotoByMonth(searchParams, urlParams, isFresh);
			} else {
				pixerfApiUserSvc.get_medias(urlParams, searchParams).$promise.then(function (response) {
					self.bidingItems = self.bidingItems.concat(response.data);
					self.isLastPage = pagingUtils.isNoMorePageToLoad(searchParams.page, response);
					self.totalPhotos = pagingUtils.getTotalCount(response);
					self.totalPage = pagingUtils.getTotalPage(response);
					self.isWorking = false;
					self.spinner.isVisible = false;
				}).catch(function () {
					self.isWorking = false;
					self.spinner.isVisible = false;
				})
			}
		}

		function groupPhotoByMonth(searchParams, urlParams, isFresh) {
			pixerfApiUserSvc.get_medias(urlParams, searchParams).$promise.then(function (response) {
				if (searchParams.page === 1) {
					self.items = [];
				}
				if (response && response.data && response.data.length > 0) {
					self.items = self.items.concat(response.data);
					var groupedByMonth = _.groupBy(response.data, function (item) {
						return item.inserted_at.substring(0, 7);
					});
					for (var obj in groupedByMonth) {
						var formatObjDate = moment(obj).format('MMMM') + ' ' + moment(obj).format('YYYY');
						var isExistInGroup = _.findIndex(self.bidingItems, function (item) {
							return item.title === formatObjDate;
						});

						if (isExistInGroup > -1) {
							self.bidingItems[isExistInGroup].data = self.bidingItems[isExistInGroup].data.concat(groupedByMonth[obj]);
						} else {
							self.bidingItems.push({
								title: formatObjDate,
								data: groupedByMonth[obj],
								collapse: moment(obj).format('MMM') + '-' + moment(obj).format('YY')
							})
						}
					}
				}
				self.isWorking = false;
				self.spinner.isVisible = false;
				self.isLastPage = pagingUtils.isNoMorePageToLoad(searchParams.page, response);
				self.totalPhotos = pagingUtils.getTotalCount(response);
				self.totalPage = pagingUtils.getTotalPage(response);
			})
		}

		function fetchMorePhotos() {
			if (self.spinner.isVisible && self.isWorking) {
				return;
			}
			self.searchParams.page++;
			fetchPhotos(self.searchParams);
		}

		function onFilteredClicked(selectedFilterItem) {
			self.items = [];
			self.bidingItems = [];
			self.gridSort = selectedFilterItem.value;
			self.searchParams.page = 1;
			self.searchParams.sort = self.gridSort;
			fetchPhotos(self.searchParams, true)
		}

		function onPhotoPopupClosed(originalFile, newFile) {
			self.user.is_followed = newFile.user.is_followed;
		}

		function fetchPortfolios(specialities) {
			var params = {
				userid: self.user.id,
				page: 1
			};
			var portfolioGridPromises = [];

			self.spinner.isVisible = true;
			for (var i = 0; i < specialities.length; i++) {
				params.speciality = specialities[i].id;
				portfolioGridPromises.push(
					pixerfApiPortfolioSvc.getUserPortfolios(params).$promise.then(function (portfolio) {
						if (!portfolio.data || !portfolio.data.length) {
							return;
						}
						var mapSpec = _.findWhere(self.user.profile.specialities, {
							id: portfolio.data[0].speciality_id
						});
						if (!mapSpec) {
							return portfolio;
						}
						_.map(portfolio.data, function (ele) {
							ele.speciality = mapSpec.name;
							return ele;
						});
						return portfolio;
					})
				);
			}

			$q.all(portfolioGridPromises).then(function (portfolios) {
				for (var i = 0; i < portfolios.length; i++) {
					if (portfolios[i] && portfolios[i].data && portfolios[i].data.length) {
						portfolios[i].data = portfolios[i].data.slice(0, 3);
						self.portfolios = self.portfolios.concat(portfolios[i].data);
					}
				}
			});
		}

		function onPortfolioClicked(portfolio) {
			$state.go(commonConst.STATE.PORTFOLIO_PHOTOS, {
				portfolioId: portfolio.portfolio.speciality_id,
				galleryId: portfolio.portfolio.id
			});
		}
	}
})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.factory('signUpPersonalPopupSvc', signUpPersonalPopupSvc);
		signUpPersonalPopupSvc.$inject = ['messageAccountConst', '$translate', '$uibModal',
		'signUpPageSvc', 'auth0AuthenticationSvc', 'authenticationConst', 'toastr', 'sessionManagerSvc', 'accountConst', 'translationSvc'];

	function signUpPersonalPopupSvc(messageAccountConst, $translate, $uibModal
		, signUpPageSvc, auth0AuthenticationSvc, authenticationConst, toastr, sessionManagerSvc, accountConst, translationSvc) {
		var mUser = {
			data: {
				email: '',
				password: '',
				account_type: accountConst.ACCOUNT_TYPE.PERSONAL
			}
		};
		var mIsAgreedTnC = {
			data: false
		};
		var mIsShowPassword = {
			data: false
		};

		function validateUser(form) {
			form.$setDirty();
			var errMsg = ''
			if (form.name && form.name.$error.required) {
				errMsg = "Please input your name!";
			} else if (form.email.$error.required) {
				errMsg = $translate.instant("input-email") + "!";
			} else if (form.email.$error.email) {
				errMsg = "Invalid email address";
			} else if (form.password.$error.required) {
				errMsg = $translate.instant("input-password") + "!";
			} else if (form.password.$error.pattern) {
				errMsg = messageAccountConst.error.validation.password.format;
			}

			return errMsg;
		}

		function validateDOB(user) {
			var errMsg = '';
			var userAge = moment(user.date_of_birth);
			var now = moment(moment()._d);
			var age = now.diff(userAge, 'years', true);
			var loginUser = sessionManagerSvc.getCurrentLoginUser().data;
			if (loginUser && moment(user.date_of_birth).diff(moment(loginUser.date_of_birth)) === 0) {
				return;
			}
			if (!user.date_of_birth) {
				errMsg = $translate.instant('please-input-date-of-birth');
			} else if (age < 18) {
				errMsg = "Uh oh! You have to be at least 18 to sign up as a Pixerfer. Don’t worry, time flies when you’re having fun. Keep doing what you love, and we’ll be waiting for you.";
			} else if (age > 100) {
				errMsg = "Woah! Your birth date puts you at over 100 years old - that's either amazing or you've entered the wrong date by accident. Please check again.";
			}
			return errMsg;

		}

		function reset() {
			mUser.data = null;
			mIsShowPassword.data = false;
			mIsAgreedTnC.data = false;
		}

		function showPopup(data) {

			return $uibModal.open({
				templateUrl: 'app/sign-up-page/components/sign-up-personal-popup/sign-up-personal-popup.html',
				controller: 'signUpPersonalPopupCtrl',
				controllerAs: 'vm',
				animation: true,
				windowClass: 'sign-up-business-popup__modal',
				backdrop: 'static',
				resolve: {
					'resolveData': function () {
						return data;
					}
				}
			});
		}
		var mOfficeTypes = {
			data: accountConst.OFFICE_TYPE
		}

		function setUser(user) {
			mUser.data = user;
		}

		function validateProfile(user, form) {
			form.$setDirty();
			var errMsg = ''
			if (form.email && form.email.$error.required) {
				errMsg = "Please input your email";
			} else if (form.email && form.email.$error.email) {
				errMsg = "Invalid email address!";
			} else if (form.first_name.$error.required) {
				errMsg = $translate.instant('please-input-first-name');
			} else if (form.first_name.$error.maxlength) {
				errMsg = "Sorry, Your first name cannot exceed 20 characters.";
			} else if (form.last_name.$error.required) {
				errMsg = $translate.instant('please-input-last-name');
			} else if (form.last_name.$error.maxlength) {
				errMsg = "Sorry, Your last name cannot exceed 20 characters.";
			} else if (form.country.$error.required) {
				errMsg = "Please input your country!";
			} else if (form.location.$error.required) {
				errMsg = "Please input your location!";
			} else if (form.first_name.$error.validationNoNumber || form.first_name.$error.validationNoHyperlink) {
				errMsg = "Sorry, Your first name cannot contain link or number.";
			} else if (form.last_name.$error.validationNoNumber || form.last_name.$error.validationNoHyperlink) {
				errMsg = "Sorry, Your last name cannot contain link or number.";
			}

			if (!errMsg) {
				errMsg = validateDOB(user);
			}

			return errMsg;
		}

		function save(user) {
			sessionManagerSvc.setSigningUpUser(user);
			if (user.connection === authenticationConst.AUTH0_CONNECTION_TYPE.FACEBOOK || user.id ||
				user.connection === authenticationConst.AUTH0_CONNECTION_TYPE.GOOGLE) {
				signUpPageSvc.finaliseSignupProgress(user);
			} else {
				auth0AuthenticationSvc.customSignUp(mUser.data).promise.then(function (result) {
					auth0AuthenticationSvc.signInByUserNamePassword(mUser.data);
				}, function (error) {
					var errMsg = "";
					if (error.code === "user_exists") {
						errMsg = "Email is already in use.";
					} else {
						errMsg = translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true);
					}
					if (errMsg) toastr.error(errMsg);
					sessionManagerSvc.setSigningUpUser(null);
				});
			}
		}

		function officeParser(val) {
			return val.id;

		}

		function officeFormatter(options, val) {
			return _.find(options, function (item) {
				return item.id === val;
			});
		}

		return {
			user: mUser,
			isAgreedTnC: mIsAgreedTnC,
			isShowPassword: mIsShowPassword,
			reset: reset,
			validateUser: validateUser,
			showPopup: showPopup,
			officeTypes: mOfficeTypes,
			save: save,
			setUser: setUser,
			validateProfile: validateProfile,
			officeParser: officeParser,
			officeFormatter: officeFormatter
		};
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('signUpPersonalPopupCtrl', signUpPersonalPopupCtrl);

		signUpPersonalPopupCtrl.$inject = ['$scope', '$state', 'systemUtils', 'signUpPersonalPopupSvc', 'auth0AuthenticationSvc', 'toastr', 'translationSvc', '$uibModalInstance'
		, 'sessionManagerSvc', 'editProfileSvc', 'authenticationConst', 'signUpPersonalInfoSvc', 'signInPopupSvc', 'resolveData'];

	function signUpPersonalPopupCtrl($scope, $state, systemUtils, signUpPersonalPopupSvc, auth0AuthenticationSvc, toastr, translationSvc, $uibModalInstance
		, sessionManagerSvc, editProfileSvc, authenticationConst, signUpPersonalInfoSvc, signInPopupSvc, resolveData) {

		var self = this;
		self.user = signUpPersonalPopupSvc.user;
		self.isAgreedTnC = signUpPersonalPopupSvc.isAgreedTnC;
		self.isShowPassword = signUpPersonalPopupSvc.isShowPassword;
		self.onSignUpBtnClicked = onSignUpBtnClicked;
		self.checkPrivacyTooltipShown = checkPrivacyTooltipShown;
		self.onPasswordBlur = onPasswordBlur;
		self.isPasswordPrivacyTooltipShown = false;
		self.isWorking = false;
		self.onCheckEmailExist = onCheckEmailExist;
		self.loginBtnClicked = loginBtnClicked;
		self.states = {
			'validateEmail': 'sign-up-business-email',
			'fullfillInfo': 'sign-up-business-info'
		}

		self.currentState = self.states.validateEmail;
		self.onDoneBtnClicked = onDoneBtnClicked;
		self.officeTypes = signUpPersonalPopupSvc.officeTypes
		self.officeParser = signUpPersonalPopupSvc.officeParser;
		self.officeFormatter = officeFormatter;
		var mLoginnedUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.processGuestUser = mLoginnedUser && !mLoginnedUser.account_type;

		self.cancel = function () {
            $uibModalInstance.dismiss('cancel');
		};
		
		function officeFormatter(val) {
			signUpPersonalPopupSvc.officeFormatter(self.officeTypes.data, val);
		}

		function onDoneBtnClicked(user, form) {
			var errMsg = signUpPersonalPopupSvc.validateProfile(user, form, self.processGuestUser);
			if (errMsg) {
				toastr.error(errMsg);
				return false;
			}
			self.isWorking = true;
			if(self.processGuestUser){
				editProfileSvc.saveData(user, {});
			}else{
				signUpPersonalPopupSvc.save(user, form).then(function () {
					self.isWorking = false;
				}, function () {
					self.isWorking = false;
				});
			}
		}

		function onPasswordBlur(evt) {
			self.isPasswordPrivacyTooltipShown = false;
			systemUtils.digest($scope);
		}

		function checkPrivacyTooltipShown(evt) {
			self.isPasswordPrivacyTooltipShown = !$(evt.currentTarget).val();
			systemUtils.digest($scope);
		}

		function onSignUpBtnClicked(type, signUpForm) {

			self.user.data.connection = type;
			if (type === authenticationConst.AUTH0_CONNECTION_TYPE.FACEBOOK ||
				type === authenticationConst.AUTH0_CONNECTION_TYPE.GOOGLE) {
				if (resolveData && resolveData.referredBy) self.user.data.referred_by = resolveData.referredBy;
				auth0AuthenticationSvc.signInViaSocialConnection(type);

			} else {
				var errMsg = signUpPersonalPopupSvc.validateUser(signUpForm)
				if (errMsg) {
					if (signUpForm.email.$invalid) {
						self.isEmailValid = false;
						self.emailNotExist = "";
						self.errorEmailMessage = errMsg;
					} else {
						self.isEmailValid = self.emailNotExist;
						self.errorEmailMessage = self.isEmailValid ? "" : "Email has already been taken";
					}
					return;
				}
				self.isWorking = true;
				auth0AuthenticationSvc.isUserExisted(self.user.data.email).then(function (response) {
					self.isWorking = false;
					if (response.data && !response.data.existing) {
						signUpPersonalInfoSvc.setUser(self.user.data);
						self.currentState = self.states.fullfillInfo;
					} else {
						self.emailNotExist = false;
					}
				}, function () {
					self.isWorking = false;
					toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
				})
			}
		}

		function onCheckEmailExist(email, signUpForm) {
			self.isChecking = true;
			var errMsg = signUpPersonalPopupSvc.validateUser(signUpForm)
			if (errMsg && signUpForm.email.$invalid) {
				self.isChecking = false;
				self.isEmailValid = false;
				self.errorEmailMessage = errMsg;
				return;
			}
			auth0AuthenticationSvc.isUserExisted(email).then(function (response) {
				self.isChecking = false;
				if (response.data && !response.data.existing) {
					setEmailExistErr(true);
				} else {
					setEmailExistErr(false);
					self.errorEmailMessage = "Email has already been taken";
				}
			}, function (err) {
				self.isChecking = false;
				console.log(err);
			});
		}

		function setEmailExistErr(value) {
			self.emailNotExist = value;
			self.isEmailValid = value;
		}

		function loginBtnClicked(){
			$uibModalInstance.dismiss('cancel');
			signInPopupSvc.showPopup({});
		}
	}
})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.factory('signUpPersonalInfoSvc', signUpPersonalInfoSvc);
	signUpPersonalInfoSvc.$inject = ['signUpPageSvc', 'auth0AuthenticationSvc', 'authenticationConst', 'toastr', 'sessionManagerSvc', '$q', 'pixerfApiCampaignSvc', 'pixerfApiFileSvc', '$translate', 'translationSvc'];

	function signUpPersonalInfoSvc(signUpPageSvc, auth0AuthenticationSvc, authenticationConst, toastr, sessionManagerSvc, $q, pixerfApiCampaignSvc, pixerfApiFileSvc, $translate, translationSvc) {

		var mUser = {};
		var mIsFocusFirstInput = {
			data: false
		};
		var saveUserData = {};

		function setUser(user) {
			mUser.data = user;
		}

		function isFocusFirstInput() {
			return mIsFocusFirstInput;
		}

		function setIsFocusFirstInput(value) {
			mIsFocusFirstInput.data = value;
		}

		function validateDOB(user) {
			var errMsg = '';
			var userAge = moment(user.date_of_birth);
			var now = moment(moment()._d);
			var age = now.diff(userAge, 'years', true);
			var loginUser = sessionManagerSvc.getCurrentLoginUser().data;
			if (loginUser && moment(user.date_of_birth).diff(moment(loginUser.date_of_birth)) === 0) {
				return;
			}
			if (!user.date_of_birth) {
				errMsg = $translate.instant('please-input-date-of-birth');
			} else if (age < 18) {
				errMsg = "Uh oh! You have to be at least 18 to sign up as a Pixerfer. Don’t worry, time flies when you’re having fun. Keep doing what you love, and we’ll be waiting for you.";
			} else if (age > 100) {
				errMsg = "Woah! Your birth date puts you at over 100 years old - that's either amazing or you've entered the wrong date by accident. Please check again.";
			}
			return errMsg;

		}

		function validateProfile(user, form) {
			form.$setDirty();
			var errMsg = ''
			if (form.email && form.email.$error.required) {
				errMsg = "Please input your email";
			} else if (form.email && form.email.$error.email) {
				errMsg = "Invalid email address!";
			} else if (form.first_name.$error.required) {
				errMsg = $translate.instant('please-input-first-name');
			} else if (form.first_name.$error.maxlength) {
				errMsg = "Sorry, Your first name cannot exceed 20 characters.";
			} else if (form.last_name.$error.required) {
				errMsg = $translate.instant('please-input-last-name');
			} else if (form.last_name.$error.maxlength) {
				errMsg = "Sorry, Your last name cannot exceed 20 characters.";
			} else if (form.country.$error.required) {
				errMsg = "Please input your country!";
			} else if (form.location.$error.required) {
				errMsg = "Please input your location!";
			} else if (form.first_name.$error.validationNoNumber || form.first_name.$error.validationNoHyperlink) {
				errMsg = "Sorry, Your first name cannot contain link or number.";
			} else if (form.last_name.$error.validationNoNumber || form.last_name.$error.validationNoHyperlink) {
				errMsg = "Sorry, Your last name cannot contain link or number.";
			}

			if (!errMsg) {
				errMsg = validateDOB(user);
			}

			return errMsg;
		}

		function saveData(user) {
			var def = $q.defer();
			sessionManagerSvc.setSigningUpUser(user);
			if (user.connection === authenticationConst.AUTH0_CONNECTION_TYPE.FACEBOOK ||
				user.connection === authenticationConst.AUTH0_CONNECTION_TYPE.GOOGLE || user.id) {
				signUpPageSvc.finaliseSignupProgress(user);
				fbq('track', 'CompleteRegistration', {
					value: "FACEBOOK"
				});
			} else {
				fbq('track', 'CompleteRegistration', {
					value: "USERNAME_PASS"
				});
				auth0AuthenticationSvc.customSignUp(mUser.data).promise.then(function (result) {
					auth0AuthenticationSvc.signInByUserNamePassword(mUser.data);
				}, function (error) {
					def.reject();
					var errMsg = "";
					if (error.code === "user_exists") {
						errMsg = "Email is already in use.";
					} else {
						errMsg = translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true);
					}
					if (errMsg) toastr.error(errMsg);
					sessionManagerSvc.setSigningUpUser(null);
				});
			}
			return def.promise;
		}

		function signupBrief (user, callback){
			var def = $q.defer();
			sessionManagerSvc.setSigningUpUser(user.data);
			fbq('track', 'CompleteRegistration', {
				value: "USERNAME_PASS"
			});
			auth0AuthenticationSvc.customSignUp(user.data).promise.then(function (result) {
				if(callback) callback(result);
				auth0AuthenticationSvc.signInByUserNamePassword(user.data);
				def.resolve(result);
			}, function (error) {
				def.reject();
				var errMsg = "";
				if (error.code === "user_exists") {
					errMsg = "Email is already in use.";
				} else {
					errMsg = translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true);
				}
				if (errMsg) toastr.error(errMsg);
				sessionManagerSvc.setSigningUpUser(null);
			});
			return def.promise;
		}

		function buildCities(countryCode) {
			var def = $q.defer();
			pixerfApiFileSvc.query({
				path: 'assets/files/cities/' + countryCode.toUpperCase() + ".json"
			}).$promise.then(function (response) {
				def.resolve(response);
			}, function (err) {
				def.reject(err);
				console.log(err)
			});
			return def.promise;
		}

		function buildSavedPersonalUser(user) {
			var dayConvert = user.date_of_birth.getDate();
			var monthConvert = (user.date_of_birth.getMonth() + 1);
			if (user.date_of_birth.getMonth() < 9)
				monthConvert = "0" + (user.date_of_birth.getMonth() + 1);
			if (user.date_of_birth.getDate() < 10)
				dayConvert = "0" + user.date_of_birth.getDate();
			saveUserData.date_of_birth = user.date_of_birth.getFullYear() + "-" + monthConvert + "-" + dayConvert;
			saveUserData.account_type = user.account_type;
			saveUserData.email = user.email;
			saveUserData.first_name = user.first_name;
			saveUserData.last_name = user.last_name;
			saveUserData.location = user.location;
			saveUserData.password = user.password;
			saveUserData.username = user.username;
			saveUserData.connection = user.connection;
			saveUserData.address = {};
			saveUserData.address.country = user.address.country;
			saveUserData.bio = user.bio;
			saveUserData.id = user.id;
			saveUserData.profile = user.profile;
			if (user.referred_by) {
				saveUserData.referred_by = user.referred_by;
			}
			return saveUserData;
		}

		function save(user, form) {
			var errMsg = validateProfile(user, form);
			var def = $q.defer();
			if (errMsg) {
				toastr.error(errMsg);
				def.reject();
				return def.promise;
			}
			var willBeSavedData = buildSavedPersonalUser(user);
			if (willBeSavedData.referred_by) {
				pixerfApiCampaignSvc.valid_code({
					code: willBeSavedData.referred_by
				}).$promise.then(function (res) {
					saveData(willBeSavedData).then(function (res) {
						def.resolve(res);
					}, function () {
						def.reject();
					});
				}, function (err) {
					toastr.error("Your referral code is invalid!");
				})
			} else {
				saveData(willBeSavedData).then(function (res) {
					def.resolve(res);
				}, function () {
					def.reject();
				});
			}
			return def.promise;
		}

		function validateProfileAsForm(user, form) {
			form.$setDirty();
			var errMsg = ''
			if (form.first_name && form.first_name.$error.required) {
				errMsg = $translate.instant('please-input-first-name');
			} else if (form.first_name && form.first_name.$error.maxlength) {
				errMsg = "Sorry, Your first name cannot exceed 20 characters.";
			} else if (form.last_name && form.last_name.$error.required) {
				errMsg = $translate.instant('please-input-last-name');
			} else if (form.last_name && form.last_name.$error.maxlength) {
				errMsg = "Sorry, Your last name cannot exceed 20 characters.";
			} else if (form.country && form.country.$error.required) {
				errMsg = "Please input your country!";
			} else if (form.location && form.location.$error.required) {
				errMsg = "Please input your location!";
			} else if (form.first_name && (form.first_name.$error.validationNoNumber || form.first_name.$error.validationNoHyperlink)) {
				errMsg = "Sorry, Your first name cannot contain link or number.";
			} else if (form.last_name && (form.last_name.$error.validationNoNumber || form.last_name.$error.validationNoHyperlink)) {
				errMsg = "Sorry, Your last name cannot contain link or number.";
			}

			if (!errMsg) {
				errMsg = validateDOB(user);
			}

			return errMsg;
		}

		return {
			save: save,
			user: mUser,
			buildCities: buildCities,
			setUser: setUser,
			isFocusFirstInput: isFocusFirstInput,
			setIsFocusFirstInput: setIsFocusFirstInput,
			validateProfile: validateProfile,
			validateDOB: validateDOB,
			validateProfileAsForm: validateProfileAsForm,
			signupBrief: signupBrief
		};
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('signUpPersonalInfoCtrl', signUpPersonalInfoCtrl);

	signUpPersonalInfoCtrl.$inject = ['$scope', 'signUpPersonalInfoSvc', 'accountConst', 'userPromise', '$stateParams', '$state', 'editProfileSvc', 'sessionManagerSvc', 'signUpPersonalPopupSvc'];

	function signUpPersonalInfoCtrl($scope, signUpPersonalInfoSvc, accountConst, userPromise, $stateParams, $state, editProfileSvc, sessionManagerSvc, signUpPersonalPopupSvc) {

		var self = this;
		var mLoginnedUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.user = userPromise;
		self.isWorking = false;
		self.onDoneBtnClicked = onDoneBtnClicked;
		self.age = {
			min: accountConst.AGE.MIN_AGE,
			max: accountConst.AGE.MAX_AGE
		};
		self.onCountrySelected = onCountrySelected;
		self.gplacesOptions = {
			componentRestrictions: {
				country: self.user.data && self.user.data.address ? self.user.data.address.country : ''
			},
			types: ['(cities)']
		};
		self.processGuestUser = mLoginnedUser && !mLoginnedUser.account_type;

		init();

		function init() {
			if ((self.user.data && !self.user.data.email) || !self.user.data) {
				signUpPersonalPopupSvc.showPopup();
			}
		}

		function onDoneBtnClicked(userData, form) {
			if (self.isWorking) return;
			self.isWorking = true;
			if ($stateParams.code) {
				userData.referred_by = $stateParams.code
			}
			if(self.processGuestUser){
				editProfileSvc.saveData(userData, {});
			}else{
				signUpPersonalInfoSvc.save(userData, form).then(function () {
					self.isWorking = false;
				}, function () {
					self.isWorking = false;
				})
			}
		}

		function onCountrySelected(country) {
			self.cities = [];
			self.gplacesOptions = {
				componentRestrictions: {
					country: self.user.data && self.user.data.address ? self.user.data.address.country : country
				},
				types: ['(cities)']
			};
		}
	}
})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.factory('signUpPersonalEmailSvc', signUpPersonalEmailSvc);
	signUpPersonalEmailSvc.$inject = ['messageAccountConst', '$translate'];

	function signUpPersonalEmailSvc(messageAccountConst, $translate) {
		var mUser = {
			data: {
				email: '',
				password: '',
				account_type: 'personal'
			}
		};
		var mIsAgreedTnC = {
			data: false
		};
		var mIsShowPassword = {
			data: false
		};

		function validateUser(form) {
			form.$setDirty();
			var errMsg = ''
			if (form.name && form.name.$error.required) {
				errMsg = "Please input your name!";
			} else if (form.email.$error.required) {
				errMsg = $translate.instant("input-email") + "!";
			} else if (form.email.$error.email) {
				errMsg = "Invalid email address";
			} else if (form.password.$error.required) {
				errMsg = $translate.instant("input-password") + "!";
			} else if (form.password.$error.pattern) {
				errMsg = messageAccountConst.error.validation.password.format;
			}

			return errMsg;
		}

		function validateBriefUser(form){
			form.$setDirty();
			var errMsg = ''
			if (form.email.$error.required) {
				errMsg = $translate.instant("input-email") + "!";
			} else if (form.email.$error.email) {
				errMsg = "Invalid email address";
			} else if (form.password.$error.required) {
				errMsg = $translate.instant("input-password") + "!";
			} else if (form.password.$error.pattern) {
				errMsg = messageAccountConst.error.validation.password.format;
			}

			return errMsg;
		}

		function reset() {
			mUser.data = null;
			mIsShowPassword.data = false;
			mIsAgreedTnC.data = false;
		}

		return {
			user: mUser,
			isAgreedTnC: mIsAgreedTnC,
			isShowPassword: mIsShowPassword,
			reset: reset,
			validateUser: validateUser,
			validateBriefUser: validateBriefUser
		};
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('signUpPersonalEmailCtrl', signUpPersonalEmailCtrl);

	signUpPersonalEmailCtrl.$inject = ['systemUtils', 'signUpPersonalEmailSvc', 'signInSvc', '$scope', 'authenticationConst', 'auth0AuthenticationSvc', 'toastr', '$state', 'signUpPersonalInfoSvc', '$stateParams', 'translationSvc', 'signUpBusinessPopupSvc'];

	function signUpPersonalEmailCtrl(systemUtils, signUpPersonalEmailSvc, signInSvc, $scope, authenticationConst, auth0AuthenticationSvc, toastr, $state, signUpPersonalInfoSvc, $stateParams, translationSvc, signUpBusinessPopupSvc) {

		var self = this;
		self.user = signUpPersonalEmailSvc.user;
		self.onPasswordKeyup = onPasswordKeyup;
		self.isAgreedTnC = signUpPersonalEmailSvc.isAgreedTnC;
		self.isShowPassword = signUpPersonalEmailSvc.isShowPassword;
		self.onCheckEmailExist = onCheckEmailExist;
		self.onSignUpBtnClicked = onSignUpBtnClicked;
		self.onPasswordFocus = onPasswordFocus;
		self.onPasswordBlur = onPasswordBlur;
		self.isPasswordPrivacyTooltipShown = false;
		self.isWorking = false;
		self.onChangeTypeClicked = onChangeTypeClicked;
		self.errorEmailMessage = "";
		self.showSignInModal = function () {
			signInSvc.showSignInModal();
		}

		function onPasswordBlur(evt) {
			self.isPasswordPrivacyTooltipShown = false;
			systemUtils.digest($scope);
		}

		function onPasswordFocus(evt) {
			self.isPasswordPrivacyTooltipShown = !$(evt.currentTarget).val();
			systemUtils.digest($scope);
		}

		function onPasswordKeyup(evt) {
			self.isPasswordPrivacyTooltipShown = !$(evt.currentTarget).val();
			systemUtils.digest($scope);
		}

		function onSignUpBtnClicked(type, signUpForm) {
			self.user.data.connection = type;
			if (type === authenticationConst.AUTH0_CONNECTION_TYPE.FACEBOOK ||
				type === authenticationConst.AUTH0_CONNECTION_TYPE.GOOGLE) {
				if ($stateParams.code) self.user.data.referred_by = $stateParams.code;
				auth0AuthenticationSvc.signInViaSocialConnection(type);

			} else {
				var errMsg = signUpPersonalEmailSvc.validateUser(signUpForm)
				if (errMsg) {
					if (signUpForm.email.$invalid) {
						self.isEmailValid = false;
						self.emailNotExist = "";
						self.errorEmailMessage = errMsg;
					} else {
						self.isEmailValid = self.emailNotExist;
						self.errorEmailMessage = self.isEmailValid ? "" : "Email has already been taken";
					}
					return;
				}
				self.isWorking = true;
				auth0AuthenticationSvc.isUserExisted(self.user.data.email).then(function (response) {
					self.isWorking = false;
					if (response.data && !response.data.existing) {
						signUpPersonalInfoSvc.setUser(self.user.data);
						$state.go("sign-up.sign-up-personal-info");
					} else {
						self.emailNotExist = false;
					}
				}, function () {
					self.isWorking = false;
					toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
				})
			}
		}

		function onChangeTypeClicked() {
			signUpBusinessPopupSvc.showPopup();
		}

		function onCheckEmailExist(email, signUpForm) {
			self.isChecking = true;
			var errMsg = signUpPersonalEmailSvc.validateUser(signUpForm)
			if (errMsg && signUpForm.email.$invalid) {
				self.isChecking = false;
				self.isEmailValid = false;
				self.errorEmailMessage = errMsg;
				return;
			}
			auth0AuthenticationSvc.isUserExisted(email).then(function (response) {
				self.isChecking = false;
				if (response.data && !response.data.existing) {
					setEmailExistErr(true);
				} else {
					setEmailExistErr(false);
					self.errorEmailMessage = "Email has already been taken";
				}
			}, function (err) {
				self.isChecking = false;
				console.log(err);
			});
		}

		function setEmailExistErr(value) {
			self.emailNotExist = value;
			self.isEmailValid = value;
		}
	}
})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.factory('signUpGuestPopupSvc', signUpGuestPopupSvc);
		signUpGuestPopupSvc.$inject = ['messageAccountConst', '$translate', '$uibModal',
		'signUpPageSvc', 'auth0AuthenticationSvc', 'authenticationConst', 'toastr', 'sessionManagerSvc', 'accountConst', 'translationSvc'];

	function signUpGuestPopupSvc(messageAccountConst, $translate, $uibModal
		, signUpPageSvc, auth0AuthenticationSvc, authenticationConst, toastr, sessionManagerSvc, accountConst, translationSvc) {
		var mUser = {
			data: {
				email: '',
				password: '',
				account_type: ''
			}
		};
		var mIsAgreedTnC = {
			data: false
		};
		var mIsShowPassword = {
			data: false
		};

		function validateUser(form) {
			form.$setDirty();
			var errMsg = ''
			if (form.email.$error.required) {
				errMsg = $translate.instant("input-email") + "!";
			} else if (form.email.$error.email) {
				errMsg = "Invalid email address";
			} else if (form.password.$error.required) {
				errMsg = $translate.instant("input-password") + "!";
			} else if (form.password.$error.pattern) {
				errMsg = messageAccountConst.error.validation.password.format;
			}

			return errMsg;
		}

		function reset() {
			mUser.data = null;
			mIsShowPassword.data = false;
			mIsAgreedTnC.data = false;
		}

		function showPopup(data) {

			return $uibModal.open({
				templateUrl: 'app/sign-up-page/components/sign-up-guest-popup/sign-up-guest-popup.html',
				controller: 'signUpGuestPopupCtrl',
				controllerAs: 'vm',
				animation: true,
				windowClass: 'sign-up-business-popup__modal',
				backdrop: 'static',
				resolve: {
					'resolveData': function () {
						return data;
					}
				}
			});
		}
		var mOfficeTypes = {
			data: accountConst.OFFICE_TYPE
		}

		function setUser(user) {
			mUser.data = user;
		}

		function validateProfile(user, form) {
			form.$setDirty();
			var errMsg = ''
			if (form.company.$error.required) {
				errMsg = "Please input your company name!";
			} else if (form.company.$error.validationNoHyperlink) {
				errMsg = "Sorry, Your company name cannot contain link";
			} else if (form.registration.$error.required) {
				errMsg = "Please input your company registration no.!";
			} else if (form.registration.$error.validationNoHyperlink) {
				errMsg = "Sorry, Your company registration no. cannot contain link";
			} else if (form.officeType.$error.required) {
				errMsg = "Please choose your office type!";
			} else if (form.country.$error.required) {
				errMsg = "Please input your country!";
			}
			return errMsg;
		}

		function save(user) {
			sessionManagerSvc.setSigningUpUser(user);
			if (user.connection === authenticationConst.AUTH0_CONNECTION_TYPE.FACEBOOK || user.id ||
				user.connection === authenticationConst.AUTH0_CONNECTION_TYPE.GOOGLE) {
				signUpPageSvc.finaliseSignupProgress(user);
			} else {
				auth0AuthenticationSvc.customSignUp(mUser.data).promise.then(function (result) {
					auth0AuthenticationSvc.signInByUserNamePassword(mUser.data);
				}, function (error) {
					var errMsg = "";
					if (error.code === "user_exists") {
						errMsg = "Email is already in use.";
					} else {
						errMsg = translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true);
					}
					if (errMsg) toastr.error(errMsg);
					sessionManagerSvc.setSigningUpUser(null);
				});
			}
		}

		function officeParser(val) {
			return val.id;

		}

		function officeFormatter(options, val) {
			return _.find(options, function (item) {
				return item.id === val;
			});
		}

		return {
			user: mUser,
			isAgreedTnC: mIsAgreedTnC,
			isShowPassword: mIsShowPassword,
			reset: reset,
			validateUser: validateUser,
			showPopup: showPopup,
			officeTypes: mOfficeTypes,
			save: save,
			setUser: setUser,
			validateProfile: validateProfile,
			officeParser: officeParser,
			officeFormatter: officeFormatter
		};
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('signUpGuestPopupCtrl', signUpGuestPopupCtrl);

		signUpGuestPopupCtrl.$inject = ['$scope', '$state', 'systemUtils', 'signUpGuestPopupSvc', 'auth0AuthenticationSvc', 'toastr', 'translationSvc', '$uibModalInstance'
		, 'sessionManagerSvc', 'editProfileSvc', 'store', 'accountConst', 'signInPopupSvc', 'signUpPersonalInfoSvc', 'resolveData', 'pixerfApiSubscribeSvc'];

	function signUpGuestPopupCtrl($scope, $state, systemUtils, signUpGuestPopupSvc, auth0AuthenticationSvc, toastr, translationSvc, $uibModalInstance
		, sessionManagerSvc, editProfileSvc, store, accountConst, signInPopupSvc, signUpPersonalInfoSvc, resolveData, pixerfApiSubscribeSvc) {

		var self = this;
		self.user = signUpGuestPopupSvc.user;
		self.isAgreedTnC = signUpGuestPopupSvc.isAgreedTnC;
		self.isShowPassword = signUpGuestPopupSvc.isShowPassword;
		self.onSignUpBtnClicked = onSignUpBtnClicked;
		self.checkPrivacyTooltipShown = checkPrivacyTooltipShown;
		self.onPasswordBlur = onPasswordBlur;
		self.isPasswordPrivacyTooltipShown = false;
		self.isWorking = false;
		self.onCheckEmailExist = onCheckEmailExist;
		self.loginBtnClicked = loginBtnClicked;
		self.states = {
			'validateEmail': 'sign-up-business-email',
			'fullfillInfo': 'sign-up-business-info'
		}

		self.currentState = self.states.validateEmail;
		self.officeTypes = signUpGuestPopupSvc.officeTypes
		self.officeParser = signUpGuestPopupSvc.officeParser;
		var mLoginnedUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.processGuestUser = mLoginnedUser && !mLoginnedUser.account_type;
		self.hideLogin = resolveData.hideLogin;

		self.cancel = function () {
            $uibModalInstance.dismiss('cancel');
		};
		

		function onPasswordBlur(evt) {
			self.isPasswordPrivacyTooltipShown = false;
			systemUtils.digest($scope);
		}

		function checkPrivacyTooltipShown(evt) {
			self.isPasswordPrivacyTooltipShown = !$(evt.currentTarget).val();
			systemUtils.digest($scope);
		}

		function onSignUpBtnClicked(type, signUpForm) {
			// self.user.data.connection = type;
			var errMsg = signUpGuestPopupSvc.validateUser(signUpForm);
			if (errMsg) {
				if (signUpForm.email.$invalid) {
					self.isEmailValid = false;
					self.emailNotExist = "";
					self.errorEmailMessage = errMsg;
				} else {
					self.isEmailValid = self.emailNotExist;
					self.errorEmailMessage = self.isEmailValid ? "" : "Email has already been taken";
				}
				return;
			}
			self.isWorking = true;
			if (resolveData && resolveData.referredBy) self.user.data.referred_by = resolveData.referredBy;
			auth0AuthenticationSvc.isUserExisted(self.user.data.email).then(function (response) {
				self.isWorking = false;
				if (response.data && !response.data.existing) {
					if(resolveData.fromAdCampaign){
						self.user.data.from_ad_campaign = "true";
					}
					if(resolveData.emailSubscriberTopic){
						pixerfApiSubscribeSvc.subscribe({
							"email_subscriber": {
								topic: resolveData.emailSubscriberTopic,
								email: self.user.data.email
							}
						}).$promise.then(
							function (res) { },
							function (error) {
								toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
							});
					}
					signUpPersonalInfoSvc.signupBrief(self.user).then(
						function (response) { },
						function (error) {
						}
					);
				} else {
					self.emailNotExist = false;
				}
			}, function (err) {
				console.log(err);
				self.isWorking = false;
				toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
			})
		}

		function onCheckEmailExist(email, signUpForm) {
			self.isChecking = true;
			var errMsg = signUpGuestPopupSvc.validateUser(signUpForm)
			if (errMsg && signUpForm.email.$invalid) {
				self.isChecking = false;
				self.isEmailValid = false;
				self.errorEmailMessage = errMsg;
				return;
			}
			auth0AuthenticationSvc.isUserExisted(email).then(function (response) {
				self.isChecking = false;
				if (response.data && !response.data.existing) {
					setEmailExistErr(true);
				} else {
					setEmailExistErr(false);
					self.errorEmailMessage = "Email has already been taken";
				}
			}, function (err) {
				self.isChecking = false;
				console.log(err);
			});
		}

		function setEmailExistErr(value) {
			self.emailNotExist = value;
			self.isEmailValid = value;
		}

		function loginBtnClicked(){
			$uibModalInstance.dismiss('cancel');
			signInPopupSvc.showPopup({userType: accountConst.ACCOUNT_TYPE.GUEST});
		}
	}
})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.factory('signUpBusinessPopupSvc', signUpBusinessPopupSvc);
	signUpBusinessPopupSvc.$inject = ['messageAccountConst', '$translate', '$uibModal',
		'signUpPageSvc', 'auth0AuthenticationSvc', 'authenticationConst', 'toastr', 'sessionManagerSvc', 'accountConst', 'translationSvc'];

	function signUpBusinessPopupSvc(messageAccountConst, $translate, $uibModal
		, signUpPageSvc, auth0AuthenticationSvc, authenticationConst, toastr, sessionManagerSvc, accountConst, translationSvc) {
		var mUser = {
			data: {
				email: '',
				password: '',
				account_type: accountConst.ACCOUNT_TYPE.BUSINESS
			}
		};
		var mIsAgreedTnC = {
			data: false
		};
		var mIsShowPassword = {
			data: false
		};

		function validateUser(form) {
			form.$setDirty();
			var errMsg = ''
			if (form.name.$error.required) {
				errMsg = "Please input your name!";
			} else if (form.email.$error.required) {
				errMsg = $translate.instant("input-email") + "!";
			} else if (form.email.$error.email) {
				errMsg = "Invalid email address";
			} else if (form.password.$error.required) {
				errMsg = $translate.instant("input-password") + "!";
			} else if (form.password.$error.pattern) {
				errMsg = messageAccountConst.error.validation.password.format;
			}

			return errMsg;
		}

		function reset() {
			mUser.data = null;
			mIsShowPassword.data = false;
			mIsAgreedTnC.data = false;
		}

		function showPopup(data) {

			return $uibModal.open({
				templateUrl: 'app/sign-up-page/components/sign-up-business-popup/sign-up-business-popup.html',
				controller: 'signUpBusinessPopupCtrl',
				controllerAs: 'vm',
				animation: true,
				windowClass: 'sign-up-business-popup__modal',
				backdrop: 'static',
				resolve: {
					'resolveData': function () {
						return data;
					}
				}
			});
		}
		var mOfficeTypes = {
			data: accountConst.OFFICE_TYPE
		}

		function setUser(user) {
			mUser.data = user;
		}

		function validateProfile(user, form) {
			form.$setDirty();
			var errMsg = ''
			if (form.company.$error.required) {
				errMsg = "Please input your company name!";
			} else if (form.company.$error.validationNoHyperlink) {
				errMsg = "Sorry, Your company name cannot contain link";
			} else if (form.registration.$error.required) {
				errMsg = "Please input your company registration no.!";
			} else if (form.registration.$error.validationNoHyperlink) {
				errMsg = "Sorry, Your company registration no. cannot contain link";
			} else if (form.officeType.$error.required) {
				errMsg = "Please choose your office type!";
			} else if (form.telephone.$error.required) {
				errMsg = "Please input your phone number!";
			} else if (form.country.$error.required) {
				errMsg = "Please input your country!";
			} else if (form.city.$error.required) {
				errMsg = "Please input your city!";
			} 
			return errMsg;
		}

		function save(user) {
			sessionManagerSvc.setSigningUpUser(user);
			if (user.connection === authenticationConst.AUTH0_CONNECTION_TYPE.FACEBOOK || user.id ||
				user.connection === authenticationConst.AUTH0_CONNECTION_TYPE.GOOGLE) {
				signUpPageSvc.finaliseSignupProgress(user);
			} else {
				auth0AuthenticationSvc.customSignUp(mUser.data).promise.then(function (result) {
					auth0AuthenticationSvc.signInByUserNamePassword(mUser.data);
				}, function (error) {
					var errMsg = "";
					if (error.code === "user_exists") {
						errMsg = "Email is already in use.";
					} else {
						errMsg = translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true);
					}
					if (errMsg) toastr.error(errMsg);
					sessionManagerSvc.setSigningUpUser(null);
				});
			}
		}

		function officeParser(val) {
			return val.id;

		}

		function officeFormatter(options, val) {
			return _.find(options, function (item) {
				return item.id === val;
			});
		}

		return {
			user: mUser,
			isAgreedTnC: mIsAgreedTnC,
			isShowPassword: mIsShowPassword,
			reset: reset,
			validateUser: validateUser,
			showPopup: showPopup,
			officeTypes: mOfficeTypes,
			save: save,
			setUser: setUser,
			validateProfile: validateProfile,
			officeParser: officeParser,
			officeFormatter: officeFormatter
		};
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('signUpBusinessPopupCtrl', signUpBusinessPopupCtrl);

		signUpBusinessPopupCtrl.$inject = ['$scope', '$state', 'systemUtils', 'signUpBusinessPopupSvc', 'auth0AuthenticationSvc', 'toastr', 'translationSvc', '$uibModalInstance'
		, 'sessionManagerSvc', 'editProfileSvc', 'store', 'accountConst', 'signInPopupSvc', 'resolveData', 'accountUtils'];

	function signUpBusinessPopupCtrl($scope, $state, systemUtils, signUpBusinessPopupSvc, auth0AuthenticationSvc, toastr, translationSvc, $uibModalInstance
		, sessionManagerSvc, editProfileSvc, store, accountConst, signInPopupSvc, resolveData, accountUtils) {

		var self = this;
		self.user = signUpBusinessPopupSvc.user;
		self.isAgreedTnC = signUpBusinessPopupSvc.isAgreedTnC;
		self.isShowPassword = signUpBusinessPopupSvc.isShowPassword;
		self.onSignUpBtnClicked = onSignUpBtnClicked;
		self.checkPrivacyTooltipShown = checkPrivacyTooltipShown;
		self.onPasswordBlur = onPasswordBlur;
        self.onCountrySelected = onCountrySelected;
		self.isPasswordPrivacyTooltipShown = false;
		self.isWorking = false;
		self.onCheckEmailExist = onCheckEmailExist;
		self.loginBtnClicked = loginBtnClicked;
		self.isFixedForBiz = resolveData && resolveData.isBiz
		self.states = {
			'validateEmail': 'sign-up-business-email',
			'fullfillInfo': 'sign-up-business-info'
		}

		self.currentState = self.states.validateEmail;
		self.onDoneBtnClicked = onDoneBtnClicked;
		self.officeTypes = signUpBusinessPopupSvc.officeTypes
		self.officeParser = signUpBusinessPopupSvc.officeParser;
		self.officeFormatter = officeFormatter;
		var mLoginnedUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.processGuestUser = mLoginnedUser && !mLoginnedUser.account_type;
        self.gplacesOptions = {
			types: ['(cities)']
		}

		self.cancel = function () {
            $uibModalInstance.dismiss('cancel');
		};
		
		function officeFormatter(val) {
			signUpBusinessPopupSvc.officeFormatter(self.officeTypes.data, val);
		}

		function onDoneBtnClicked(user, form) {
			var errMsg = signUpBusinessPopupSvc.validateProfile(user, form, self.processGuestUser);
			if (errMsg) {
				toastr.error(errMsg);
				return false;
			}
			self.isWorking = true;
			if(self.processGuestUser){
				editProfileSvc.saveData(user, {});
			}else{
				if(self.isFixedForBiz){
					store.set(accountConst.TOKEN.CREDIT_PLAN_AFTER_SIGNED_EMAIL, self.user.data.email);
					store.set(accountConst.TOKEN.CREDIT_PLAN_AFTER_SIGNED_PAGE, $state.current.name);
				}
                user.organization.address.city = accountUtils.getUserGoogleLocation(user.organization.address.city);
				
				signUpBusinessPopupSvc.save(user, form).then(function () {
					self.isWorking = false;
				}, function () {
					self.isWorking = false;
				});
			}
		}

		function onPasswordBlur(evt) {
			self.isPasswordPrivacyTooltipShown = false;
			systemUtils.digest($scope);
		}

		function checkPrivacyTooltipShown(evt) {
			self.isPasswordPrivacyTooltipShown = !$(evt.currentTarget).val();
			systemUtils.digest($scope);
		}

		function onSignUpBtnClicked(type, signUpForm) {
			self.user.data.connection = type;
			var errMsg = signUpBusinessPopupSvc.validateUser(signUpForm);
			if (errMsg) {
				if (signUpForm.email.$invalid) {
					self.isEmailValid = false;
					self.emailNotExist = "";
					self.errorEmailMessage = errMsg;
				} else {
					self.isEmailValid = self.emailNotExist;
					self.errorEmailMessage = self.isEmailValid ? "" : "Email has already been taken";
				}
				return;
			}
			self.isWorking = true;
			if (resolveData && resolveData.referredBy) self.user.data.referred_by = resolveData.referredBy;
			auth0AuthenticationSvc.isUserExisted(self.user.data.email).then(function (response) {
				self.isWorking = false;
				if (response.data && !response.data.existing) {
					signUpBusinessPopupSvc.setUser(self.user.data);
					self.currentState = self.states.fullfillInfo;
				} else {
					self.emailNotExist = false;
				}
			}, function (err) {
				console.log(err);
				self.isWorking = false;
				toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
			})
		}

		function onCheckEmailExist(email, signUpForm) {
			self.isChecking = true;
			var errMsg = signUpBusinessPopupSvc.validateUser(signUpForm)
			if (errMsg && signUpForm.email.$invalid) {
				self.isChecking = false;
				self.isEmailValid = false;
				self.errorEmailMessage = errMsg;
				return;
			}
			auth0AuthenticationSvc.isUserExisted(email).then(function (response) {
				self.isChecking = false;
				if (response.data && !response.data.existing) {
					setEmailExistErr(true);
				} else {
					setEmailExistErr(false);
					self.errorEmailMessage = "Email has already been taken";
				}
			}, function (err) {
				self.isChecking = false;
				console.log(err);
			});
		}

		function setEmailExistErr(value) {
			self.emailNotExist = value;
			self.isEmailValid = value;
		}

		function loginBtnClicked(){
			$uibModalInstance.dismiss('cancel');
			var data = (self.isFixedForBiz ? {userType: accountConst.ACCOUNT_TYPE.BUSINESS} : {});
			signInPopupSvc.showPopup(data);
		}

        function onCountrySelected(country) {
			self.gplacesOptions.componentRestrictions = {
				country: country
			};
		}
	}
})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.factory('signUpBusinessInfoSvc', signUpBusinessInfoSvc);
	signUpBusinessInfoSvc.$inject = ['signUpPageSvc', 'auth0AuthenticationSvc', 'authenticationConst', 'toastr', 'sessionManagerSvc', 'accountConst', 'translationSvc'];

	function signUpBusinessInfoSvc(signUpPageSvc, auth0AuthenticationSvc, authenticationConst, toastr, sessionManagerSvc, accountConst, translationSvc) {

		var mOfficeTypes = {
			data: accountConst.OFFICE_TYPE
		}
		var mUser = {};

		function setUser(user) {
			mUser.data = user;
		}

		function validateProfile(user, form) {
			form.$setDirty();
			var errMsg = ''
			if (form.company.$error.required) {
				errMsg = "Please input your company name!";
			} else if (form.company.$error.validationNoHyperlink) {
				errMsg = "Sorry, Your company name cannot contain link";
			} else if (form.registration.$error.required) {
				errMsg = "Please input your company registration no.!";
			} else if (form.registration.$error.validationNoHyperlink) {
				errMsg = "Sorry, Your company registration no. cannot contain link";
			} else if (form.officeType.$error.required) {
				errMsg = "Please choose your office type!";
			} else if (form.telephone.$error.required) {
				errMsg = "Please input your phone number!";
			} else if (form.country.$error.required) {
				errMsg = "Please input your country!";
			} else if (form.city.$error.required) {
				errMsg = "Please input your city!";
			} 
			return errMsg;
		}

		function save(user) {
			sessionManagerSvc.setSigningUpUser(user);
			if (user.connection === authenticationConst.AUTH0_CONNECTION_TYPE.FACEBOOK || user.id ||
				user.connection === authenticationConst.AUTH0_CONNECTION_TYPE.GOOGLE) {
				signUpPageSvc.finaliseSignupProgress(user);
			} else {
				auth0AuthenticationSvc.customSignUp(mUser.data).promise.then(function (result) {
					auth0AuthenticationSvc.signInByUserNamePassword(mUser.data);
				}, function (error) {
					var errMsg = "";
					if (error.code === "user_exists") {
						errMsg = "Email is already in use.";
					} else {
						errMsg = translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true);
					}
					if (errMsg) toastr.error(errMsg);
					sessionManagerSvc.setSigningUpUser(null);
				});
			}
		}

		function officeParser(val) {
			return val.id;

		}

		function officeFormatter(options, val) {
			return _.find(options, function (item) {
				return item.id === val;
			});
		}

		return {
			officeTypes: mOfficeTypes,
			save: save,
			user: mUser,
			setUser: setUser,
			validateProfile: validateProfile,
			officeParser: officeParser,
			officeFormatter: officeFormatter
		};
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('signUpBusinessInfoCtrl', signUpBusinessInfoCtrl);

	signUpBusinessInfoCtrl.$inject = ['$scope', 'userPromise', 'signUpBusinessInfoSvc', 'toastr', 'sessionManagerSvc', 'editProfileSvc'];

	function signUpBusinessInfoCtrl($scope, userPromise, signUpBusinessInfoSvc, toastr, sessionManagerSvc, editProfileSvc) {

		var self = this;
		var mLoginnedUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.isWorking = false;
		self.user = userPromise;
		self.onDoneBtnClicked = onDoneBtnClicked;
		self.officeTypes = signUpBusinessInfoSvc.officeTypes
		self.officeParser = signUpBusinessInfoSvc.officeParser;
		self.officeFormatter = officeFormatter;
        self.onCountrySelected = onCountrySelected;
		self.processGuestUser = mLoginnedUser && !mLoginnedUser.account_type;
        self.gplacesOptions = {
			types: ['(cities)']
		}

		function officeFormatter(val) {
			signUpBusinessInfoSvc.officeFormatter(self.officeTypes.data, val);
		}

		function onDoneBtnClicked(user, form) {
			var errMsg = signUpBusinessInfoSvc.validateProfile(user, form, self.processGuestUser);
			if (errMsg) {
				toastr.error(errMsg);
				return false;
			}
			self.isWorking = true;
			if(self.processGuestUser){
				editProfileSvc.saveData(user, {});
			}else{
				signUpBusinessInfoSvc.save(user, form).then(function () {
					self.isWorking = false;
				}, function () {
					self.isWorking = false;
				});
			}
		}

        function onCountrySelected(country) {
			self.gplacesOptions.componentRestrictions = {
				country: country
			};
		}
	}
})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.factory('signUpBusinessEmailSvc', signUpBusinessEmailSvc);
	signUpBusinessEmailSvc.$inject = ['messageAccountConst', '$translate'];

	function signUpBusinessEmailSvc(messageAccountConst, $translate) {
		var mUser = {
			data: {
				email: '',
				password: '',
				account_type: 'business'
			}
		};
		var mIsAgreedTnC = {
			data: false
		};
		var mIsShowPassword = {
			data: false
		};

		function validateUser(form) {
			form.$setDirty();
			var errMsg = ''
			if (form.name.$error.required) {
				errMsg = "Please input your name!";
			} else if (form.email.$error.required) {
				errMsg = $translate.instant("input-email") + "!";
			} else if (form.email.$error.email) {
				errMsg = "Invalid email address";
			} else if (form.password.$error.required) {
				errMsg = $translate.instant("input-password") + "!";
			} else if (form.password.$error.pattern) {
				errMsg = messageAccountConst.error.validation.password.format;
			}

			return errMsg;
		}

		function reset() {
			mUser.data = null;
			mIsShowPassword.data = false;
			mIsAgreedTnC.data = false;
		}

		return {
			user: mUser,
			isAgreedTnC: mIsAgreedTnC,
			isShowPassword: mIsShowPassword,
			reset: reset,
			validateUser: validateUser
		};
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('signUpBusinessEmailCtrl', signUpBusinessEmailCtrl);

	signUpBusinessEmailCtrl.$inject = ['$scope', '$state', 'systemUtils', 'signUpBusinessEmailSvc', 'auth0AuthenticationSvc', 'toastr', 'signUpBusinessInfoSvc', 'translationSvc', 'signUpPersonalPopupSvc'];

	function signUpBusinessEmailCtrl($scope, $state, systemUtils, signUpBusinessEmailSvc, auth0AuthenticationSvc, toastr, signUpBusinessInfoSvc, translationSvc, signUpPersonalPopupSvc) {

		var self = this;
		self.user = signUpBusinessEmailSvc.user;
		self.isAgreedTnC = signUpBusinessEmailSvc.isAgreedTnC;
		self.isShowPassword = signUpBusinessEmailSvc.isShowPassword;
		self.onSignUpBtnClicked = onSignUpBtnClicked;
		self.checkPrivacyTooltipShown = checkPrivacyTooltipShown;
		self.onPasswordBlur = onPasswordBlur;
		self.isPasswordPrivacyTooltipShown = false;
		self.isWorking = false;
		self.onChangeTypeClicked = onChangeTypeClicked;
		self.onCheckEmailExist = onCheckEmailExist;

		function onPasswordBlur(evt) {
			self.isPasswordPrivacyTooltipShown = false;
			systemUtils.digest($scope);
		}

		function checkPrivacyTooltipShown(evt) {
			self.isPasswordPrivacyTooltipShown = !$(evt.currentTarget).val();
			systemUtils.digest($scope);
		}

		function onSignUpBtnClicked(type, signUpForm) {
			self.user.data.connection = type;
			var errMsg = signUpBusinessEmailSvc.validateUser(signUpForm);
			if (errMsg) {
				if (signUpForm.email.$invalid) {
					self.isEmailValid = false;
					self.emailNotExist = "";
					self.errorEmailMessage = errMsg;
				} else {
					self.isEmailValid = self.emailNotExist;
					self.errorEmailMessage = self.isEmailValid ? "" : "Email has already been taken";
				}
				return;
			}
			self.isWorking = true;
			auth0AuthenticationSvc.isUserExisted(self.user.data.email).then(function (response) {
				self.isWorking = false;
				if (response.data && !response.data.existing) {
					signUpBusinessInfoSvc.setUser(self.user.data);
					$state.go("sign-up.sign-up-business-info");
				} else {
					self.emailNotExist = false;
				}
			}, function (err) {
				console.log(err);
				self.isWorking = false;
				toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
			})
		}

		function onChangeTypeClicked() {
			signUpPersonalPopupSvc.showPopup();
		}

		function onCheckEmailExist(email, signUpForm) {
			self.isChecking = true;
			var errMsg = signUpBusinessEmailSvc.validateUser(signUpForm)
			if (errMsg && signUpForm.email.$invalid) {
				self.isChecking = false;
				self.isEmailValid = false;
				self.errorEmailMessage = errMsg;
				return;
			}
			auth0AuthenticationSvc.isUserExisted(email).then(function (response) {
				self.isChecking = false;
				if (response.data && !response.data.existing) {
					setEmailExistErr(true);
				} else {
					setEmailExistErr(false);
					self.errorEmailMessage = "Email has already been taken";
				}
			}, function (err) {
				self.isChecking = false;
				console.log(err);
			});
		}

		function setEmailExistErr(value) {
			self.emailNotExist = value;
			self.isEmailValid = value;
		}
	}
})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.factory('selectSignUpTypePopupSvc', selectSignUpTypePopupSvc);
		selectSignUpTypePopupSvc.$inject = ['$uibModal'];

	function selectSignUpTypePopupSvc($uibModal) {
		function showPopup(data) {
			return $uibModal.open({
				templateUrl: 'app/sign-up-page/components/select-sign-up-type-popup/select-sign-up-type-popup.html',
				controller: 'selectSignUpTypePopupCtrl',
				controllerAs: 'vm',
				animation: true,
				backdrop: 'static',
				windowClass: 'select-sign-up-type-popup-modal',
				resolve: {
					'resolveData': function () {
						return data;
					}
				}
			});
		}

		var mUser = {};

		function setUser(user) {
			mUser.data = user;
		}

		return {
			showPopup: showPopup,
			user: mUser,
			setUser: setUser
		};
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('selectSignUpTypePopupCtrl', selectSignUpTypePopupCtrl);

		selectSignUpTypePopupCtrl.$inject = ['$scope', '$state', 'sessionManagerSvc', 'signUpBusinessInfoSvc', 'signUpPersonalInfoSvc', 'accountConst',
		 	'signUpBusinessPopupSvc', '$uibModalInstance', '$uibModalStack', 'signUpGuestPopupSvc', 'signInPopupSvc', 'signUpPersonalPopupSvc', 'resolveData'];

	function selectSignUpTypePopupCtrl($scope, $state, sessionManagerSvc, signUpBusinessInfoSvc, signUpPersonalInfoSvc, accountConst, 
			signUpBusinessPopupSvc, $uibModalInstance, $uibModalStack, signUpGuestPopupSvc, signInPopupSvc, signUpPersonalPopupSvc, resolveData) {
		var self = this;

		self.onTypeClicked = onTypeClicked;
		self.onNextClicked = onNextClicked;
		self.loginBtnClicked =loginBtnClicked;
		self.canNext = canNext;
		self.cancel = function () {
            $uibModalInstance.dismiss('cancel');
		};

		self.loginnedUser = sessionManagerSvc.getCurrentLoginUser().data;

		function closeAllModal(){
			$uibModalStack.dismissAll();
		}

		function init(){
			closeAllModal();
			if(self.loginnedUser && !self.loginnedUser.account_type){//Guest user
				self.isGuest = true
			}
			if(!self.loginnedUser){
				self.loginnedUser = {}
			}	
		}

		function canNext(){
			return self.loginnedUser.account_type;
		}
		
		function onTypeClicked(accountType){
			if(accountType === 'business') {
				self.loginnedUser.account_type = accountConst.ACCOUNT_TYPE.BUSINESS;
			} else if(accountType === 'personal'){
				self.loginnedUser.account_type = accountConst.ACCOUNT_TYPE.PERSONAL;
			}else if(accountType === 'guest') {
				self.loginnedUser.account_type = accountConst.ACCOUNT_TYPE.GUEST;
			} 
		}

		function loginBtnClicked(){
			$uibModalInstance.dismiss('cancel');
			signInPopupSvc.showPopup();
		}

		function onNextClicked() {
			var data = resolveData && resolveData.referredBy ? {referredBy: resolveData.referredBy} : {};
			if(self.isGuest){//Guest user
				if(self.loginnedUser.account_type === 'business') {
					self.loginnedUser.account_type = accountConst.ACCOUNT_TYPE.BUSINESS;
					signUpBusinessInfoSvc.setUser(self.loginnedUser);
					signUpBusinessPopupSvc.showPopup();
				} else {
					self.loginnedUser.account_type = accountConst.ACCOUNT_TYPE.PERSONAL;
					signUpPersonalInfoSvc.setUser(self.loginnedUser);
					$state.go('sign-up.sign-up-personal-info');
				}
				return;
			}
			else if(self.loginnedUser.account_type === 'business') {
				closeAllModal();
				signUpBusinessPopupSvc.showPopup(data);
			} else if(self.loginnedUser.account_type === 'personal'){
				closeAllModal();
				signUpPersonalPopupSvc.showPopup(data);
			}else if(self.loginnedUser.account_type === 'guest') {
				closeAllModal();
				signUpGuestPopupSvc.showPopup(data);
			} 
		}

		init();
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('selectSignUpTypeCtrl', selectSignUpTypeCtrl);

	selectSignUpTypeCtrl.$inject = ['$scope', '$state', 'sessionManagerSvc', 'signUpBusinessInfoSvc', 'signUpPersonalInfoSvc', 'accountConst', 'signUpBusinessPopupSvc', 'signUpPersonalPopupSvc', 'signUpGuestPopupSvc'];

	function selectSignUpTypeCtrl($scope, $state, sessionManagerSvc, signUpBusinessInfoSvc, signUpPersonalInfoSvc, accountConst, signUpBusinessPopupSvc, signUpPersonalPopupSvc, signUpGuestPopupSvc) {
		var self = this;

		self.onTypeClicked = onTypeClicked;

		function onTypeClicked(accountType) {
			var mLoginnedUser = sessionManagerSvc.getCurrentLoginUser().data;
			if(mLoginnedUser && !mLoginnedUser.account_type){//Guest user
				if(accountType === 'business') {
					mLoginnedUser.account_type = accountConst.ACCOUNT_TYPE.BUSINESS;
					signUpBusinessInfoSvc.setUser(mLoginnedUser);
					$state.go('sign-up.sign-up-business-info');
				} else {
					mLoginnedUser.account_type = accountConst.ACCOUNT_TYPE.PERSONAL;
					signUpPersonalInfoSvc.setUser(mLoginnedUser);
					$state.go('sign-up.sign-up-personal-info');
				}
				return;
			}
			else if(accountType === 'business') {
				signUpBusinessPopupSvc.showPopup();
			} else if(accountType === 'personal') {
				signUpPersonalPopupSvc.showPopup();
			}
			else {
				signUpGuestPopupSvc.showPopup(data);
			}
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('pastChallengesCtrl', pastChallengesCtrl);

	pastChallengesCtrl.$inject = ['$scope', 'pixerfApiMissionSvc', 'toastr', 'sessionManagerSvc', 'pagingUtils', '$state'];

	function pastChallengesCtrl($scope, pixerfApiMissionSvc, toastr, sessionManagerSvc, pagingUtils, $state) {

		var self = this;
		self.loginnedUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.spinner = {
			isVisible: false
		}
		self.fetchMoreItems = fetchMoreItems;
		self.isLastPage = false;
		self.missions = null;
		$scope.$parent.vm.contextPage = "Past Challenges";
		self.searchParams = {
			page: 1,
		};
		self.isMyMission = $state.current.name.includes("manage-missions");

		init();

		function init() {
			fetchItems(self.searchParams, true);
		}

		function fetchItems(searchParams, isFresh) {
			var action = "query";
			if ($state.current.name.indexOf('manage-missions') > -1) {
				action = "get_manage_mission";
			}
			self.spinner.isVisible = true;
			searchParams.type = 'past';
			searchParams.sort = ["inserted_at,desc"];
			pixerfApiMissionSvc[action](searchParams).$promise.then(function (response) {
				if (searchParams.page === 1 || isFresh) self.missions = [];
				self.spinner.isVisible = false;
				if (response && response.data && response.data.missions && response.data.missions.length > 0) {
					self.missions = self.missions.concat(response.data.missions);
				}
				self.isLastPage = pagingUtils.isNoMorePageToLoad(searchParams.page, response);

			}, function () {
				self.spinner.isVisible = false;
				toastr.error('Failed to get missions!');
			})
		}

		function fetchMoreItems() {
			if (self.spinner.isVisible) {
				return;
			}
			self.searchParams.page++;
			fetchItems(self.searchParams);
		}

	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('liveChallengesCtrl', liveChallengesCtrl);

	liveChallengesCtrl.$inject = ['$scope', 'pixerfApiMissionSvc', 'toastr', 'pagingUtils', 'sessionManagerSvc', '$state'];

	function liveChallengesCtrl($scope, pixerfApiMissionSvc, toastr, pagingUtils, sessionManagerSvc, $state) {

		var self = this;
		self.loginnedUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.spinner = {
			isVisible: false
		}
		self.fetchMoreItems = fetchMoreItems;
		self.isLastPage = false;
		self.missions = null;
		$scope.$parent.vm.contextPage = "Live challenges";
		self.searchParams = {
			page: 1,
		};
		self.isMyMission = $state.current.name.includes("manage-missions");

		init();

		function init() {
			fetchItems(self.searchParams, true);
		}

		function fetchItems(searchParams, isFresh) {
			var action = "query";
			if ($state.current.name.indexOf('manage-missions') > -1) {
				action = "get_manage_mission";
			}
			self.spinner.isVisible = true;
			searchParams.type = 'current';
			searchParams.sort = ["inserted_at,desc"];
			pixerfApiMissionSvc[action](searchParams).$promise.then(function (response) {
				if (searchParams.page === 1 || isFresh) self.missions = [];
				self.spinner.isVisible = false;
				if (response && response.data && response.data.missions && response.data.missions.length > 0) {
					self.missions = self.missions.concat(response.data.missions);
				}
				self.isLastPage = pagingUtils.isNoMorePageToLoad(searchParams.page, response);

			}, function () {
				self.spinner.isVisible = false;
				toastr.error('Failed to get missions!');
			})
		}

		function fetchMoreItems() {
			if (self.spinner.isVisible) {
				return;
			}
			self.searchParams.page++;
			fetchItems(self.searchParams);
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('joinedChallengesCtrl', joinedChallengesCtrl);

	joinedChallengesCtrl.$inject = ['$scope', 'missionSvc', 'toastr', 'sessionManagerSvc', 'pagingUtils'];

	function joinedChallengesCtrl($scope, missionSvc, toastr, sessionManagerSvc, pagingUtils) {

		var self = this;
		self.loginnedUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.spinner = {isVisible: false}
		self.fetchMoreItems = fetchMoreItems;
		self.isLastPage = false;
		self.missions = null;
		$scope.$parent.vm.contextPage = "Joined Challenges";
		self.searchParams = {
			page: 1,
		};

		init();

		function init(){
			fetchItems(self.searchParams, true);
		}

		function fetchItems(searchParams, isFresh){
			self.spinner.isVisible = true;
			searchParams.type = 'joined';
			searchParams.sort = ["inserted_at,desc"];
			missionSvc.fetchMissions(searchParams).then(function(response){
				if(searchParams.page === 1 || isFresh) self.missions = [];
                self.spinner.isVisible = false;
                if(response && response.data && response.data.missions && response.data.missions.length > 0){
					self.missions = self.missions.concat(response.data.missions);
                }
                self.isLastPage = pagingUtils.isNoMorePageToLoad(searchParams.page, response);

			}, function(){
				self.spinner.isVisible = false;
				toastr.error('Failed to get missions!');
			})
		}
		function fetchMoreItems(){
			 if(self.spinner.isVisible){
                return;
            }
            self.searchParams.page ++;
			fetchItems(self.searchParams);
		}
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('communityChallengeAgreementGojekCtrl', communityChallengeAgreementGojekCtrl);

	communityChallengeAgreementGojekCtrl.$inject = ['$scope'];

	function communityChallengeAgreementGojekCtrl($scope) {
		var self = this;
		$scope.$parent.vm.contextPage = "Community Challenge Agreement Gojek";
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('communityChallengeAgreementCtrl', communityChallengeAgreementCtrl);

	communityChallengeAgreementCtrl.$inject = ['$scope'];

	function communityChallengeAgreementCtrl($scope) {
		var self = this;
		$scope.$parent.vm.contextPage = "Community Challenge Agreement";
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('challengeSponsorAgreementCtrl', challengeSponsorAgreementCtrl);

	challengeSponsorAgreementCtrl.$inject = ['$scope'];

	function challengeSponsorAgreementCtrl($scope) {
		var self = this;
		$scope.$parent.vm.contextPage = "Challenge Sponsor Agreement";
	}
})();

(function () {

	angular
		.module('pixerf')
		.factory('aboutChallengeSvc', aboutChallengeSvc);

	aboutChallengeSvc.$inject = [];

	function aboutChallengeSvc() {

		var mBannerBox = {
			style: {
				styleBackgroundBox: 'black--02',
				styleButton: 'dark-blue-btn',
			},
			title: 'Run a photo challenge for localised and culturally relevant photos.',
			description: 'Boost your branding and marketing with powerful photos from our global community of creators.',
			buttonText: 'Launch a Challenge'
		};

		var mCommunityChallengeSay = [
			{id: 1, logo: 'assets/images/about-challenges/community-challenge-1.png',name: 'Niharika Iyengar', role: 'Assistant', company: 'Digital Engagement', content: '" PIXERF\'s photo contest more than met our expectations by giving us diverse yet unique shots."'},
			{id: 2, logo: 'assets/images/about-challenges/community-challenge-2.png',name: 'John Thet', role: 'CEO', company: 'Asian Geographic', content: '" Bringing PIXERF onboard allowed us to leverage their platform and community. The partnership enhanced the submissions received and we gained useful data from it."'},
			{id: 3, logo: 'assets/images/about-challenges/community-challenge-3.png',name: 'VJ Anand', role: 'VP Creative', company: 'Gojek Indonesia', content: '" PIXERF has been super cool to work with. Very reactive and experimental. What we wanted was a wildly niche solution…but PIXERF came in with an interesting solution to gamify it."'},
			{id: 4, logo: 'assets/images/about-challenges/community-challenge-4.png',name: 'Kiran Girija', role: 'Director of Digital Marketing,', company: 'Asia Millennium Hotels and Resorts', content: '" Our collaboration with PIXERF has enhanced the visual content of our hotels to a higher level."'},
			{id: 5, logo: 'assets/images/about-challenges/community-challenge-5.png',name: 'Cheryl T. Hansen', role: 'Managing Director', company: 'Miss Earth Singapore', content: '" We were heartened by the many responses … they showed the diverse ways in which Asia is going green."'},
			{id: 6, logo: 'assets/images/about-challenges/community-challenge-6.png',name: 'Honda Malaysia', role: 'Brand Communication Team', content: '" It was a pleasant experience working with PIXERF. They were very responsive and helpful."'}
		]

		function getCommunityChallengeSay(){
			return mCommunityChallengeSay;
		}

		function getBannerBox(){
			return mBannerBox;
		}

		return {
			getBannerBox: getBannerBox,
			getCommunityChallengeSay: getCommunityChallengeSay
		};
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('aboutChallengeCtrl', aboutChallengeCtrl);

	aboutChallengeCtrl.$inject = ['$scope', 'aboutChallengeSvc', 'toastr', 'pixerfApiMissionSvc', 'pagingUtils', 'customCommissionBasicFormPopupSvc', '$timeout', '$location', '$anchorScroll', 
		'sessionManagerSvc', '$state', 'signUpBusinessPopupSvc', 'emailUsPopupSvc', '$window'];

	function aboutChallengeCtrl($scope, aboutChallengeSvc, toastr, pixerfApiMissionSvc, pagingUtils, customCommissionBasicFormPopupSvc, $timeout, $location, $anchorScroll, 
			sessionManagerSvc, $state, signUpBusinessPopupSvc, emailUsPopupSvc, $window) {

		var self = this;
		$scope.$parent.vm.contextPage = "Explore challenges";
		self.bookShoot = bookShoot;
		self.runChallenge = runChallenge;
		self.viewCaseStudies = viewCaseStudies;
		self.loginUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.isBusinessAcc = self.loginUser && self.loginUser.account_type === 'business';

		self.bannerBox = aboutChallengeSvc.getBannerBox();
		self.communityChallengesSay = aboutChallengeSvc.getCommunityChallengeSay();

		init();

		function init() {
			getOngoingMissions(true);
		}

		function getOngoingMissions(isFresh) {
			var searchParams = {
				type: 'current',
				sort: 'inserted_at,desc'
			}
			pixerfApiMissionSvc.query(searchParams).$promise.then(function (response) {
				if (searchParams.page === 1 || isFresh) self.missions = [];
				if (response && response.data && response.data.missions) {
					self.missions = self.missions.concat(response.data.missions);
				}
				self.isLastPage = pagingUtils.isNoMorePageToLoad(searchParams.page, response);

			}, function () {
				toastr.error('Failed to get missions!');
			})
		}

		function runChallenge() {
            $window.event.stopPropagation();
			if(!(self.loginUser && self.loginUser.id)){
				// var state = $state.href('setting.manage-missions.on-going', {}, {absolute: false});
				// state = state.replace('#/', "/");
				// sessionManagerSvc.setCallbackURL(state);
				// return signUpBusinessPopupSvc.showPopup();
				
				emailUsPopupSvc.showPopup();
				return;
			}
			if(self.isBusinessAcc){
				// $state.go("setting.manage-missions.on-going");
				emailUsPopupSvc.showPopup();
				return;
			}else{
				toastr.info('Challenges are only open to business account users.');
			}
		}

		function viewCaseStudies(){
			$timeout(function(){
				$location.hash('aboutChallengesCaseStudiesGridCarouselSection'); //TODO : link to case study
				$anchorScroll();
			})
		}

		function bookShoot() {
			customCommissionBasicFormPopupSvc.showPopup();
		}

	}
})();

/**
 * Controller for home module
 */
(function(){

  angular
    .module('pixerf')
    .controller('photographerPageLeaderboardCtrl', photographerPageLeaderboardCtrl);

    photographerPageLeaderboardCtrl.$inject = ['$scope', '$state', 'numberUtils', '$stateParams', 'sessionManagerSvc'];

    function photographerPageLeaderboardCtrl($scope, $state, numberUtils, $stateParams, sessionManagerSvc){
        var self = this;
        
        self.leaderBoard = null;
        self.onFilteredClicked = onFilteredClicked;
        self.type = $state.current.data.type;
        self.page = 1;
        self.order = null;
        self.selectedFilterItem = {};
        self.onPaging = onPaging;
        self.endingMessage = '';
        self.loginUser = sessionManagerSvc.getCurrentLoginUser().data;
        
        self.filterSetting = {"items" : [
            {
                name: "Points",
                value: "points"
            },
            {
                name: "Followers",
                value: "followers"
            },
            {
                name: "Likes",
                value: "likes"
            },
            {
                name: "Nominations",
                value: "nominations"
            }
        ]};

        init();

        function init(){

            if($scope.$parent.vm.onTabChanged){
                $scope.$parent.vm.onTabChanged(self.type);
            }
            if(self.type === 'leaderboard'){
                self.filterSetting.items.push({name: "Photos Sold", value: "sold"}, {name: "Eanings", value: 'earnings'});
                self.endingMessage = "These are just the top 30 photographers in our community right now - we have many, many more!<br/>Come join the fastest-growing photography community in Asia."
            }
            validateParams();
        }
        function validateParams(){
            var isNeedToBeRevised = false;
            if($state.params.page){
                var parseResult = numberUtils.parseInt($state.params.page);
                if(!parseResult){
                    $state.params.page = 1;
                    isNeedToBeRevised = true;
                }else {
                    self.page = $state.params.page;
                }
            }
            var defaultSelectedOrder  = self.filterSetting.items[0];
            if($state.params.order){
                var isValid = _.find(self.filterSetting.items, function(it){
                    return it.value === $state.params.order;
                });
                if(isValid){
                    defaultSelectedOrder = isValid;
                }
                $state.params.order = defaultSelectedOrder.value;
                isNeedToBeRevised = !isValid;
            }
            self.selectedFilterItem  = defaultSelectedOrder;
            self.order = self.selectedFilterItem.value;
            if(isNeedToBeRevised){
                updateUrlParams($state.params.page, $state.params.order)
            }
            
        }
        function updateUrlParams(page, order){
            $state.params.page = page;
            $state.params.order = order;
            $state.go($state.current.name, $state.params, {notify: false});
        }
        function onFilteredClicked(selectedFilterItem){
            self.leaderBoard.getLeaders({action: self.type, page: 1, order: selectedFilterItem.value, page_size: 10}, true);
            updateUrlParams(1, selectedFilterItem.value);
        }
        function onPaging(page){
            updateUrlParams(page, self.selectedFilterItem.value);
        }
    }
})();

(function(){

  angular
    .module('pixerf')
    .controller('leaderboardPageCtrl', leaderboardPageCtrl);

    leaderboardPageCtrl.$inject = ['$scope', '$state', 'numberUtils', '$timeout', 'sessionManagerSvc', 'pixerfApiUserSvc'];

    function leaderboardPageCtrl($scope, $state, numberUtils, $timeout, sessionManagerSvc, pixerfApiUserSvc){
        var self = this;

        self.leaderBoard = null;
        self.onFilteredClicked = onFilteredClicked;
        self.onSearch = _.debounce(onSearch, 300);
        self.type = 'leaderboard';
        $scope.$parent.vm.contextPage = "Leaderboard";
        self.page = 1;
        self.order = 'points';
        self.selectedFilterItem = {};
        self.onPaging = onPaging;
        self.endingMessage = '';
        self.loginUser = sessionManagerSvc.getCurrentLoginUser().data;
        self.onCountriesSelected = onCountriesSelected;
        self.onSpecialitiesSelected = onSpecialitiesSelected;
        self.onResetClicked = onResetClicked;
        self.searchParams = {
            action: self.type,
            order: 'points',
            page_size: 10
        };
        self.dopdownOpts = {
            "customAll": true,
            "container": "body",
            "maxOptions": self.maxSpecialitiesSelected,
            "maxOptionsText": "Please select up to a maximum of " + self.maxSpecialitiesSelected + " specialities",
            "noneSelectedText": "Any"
        };

        self.filterSetting = {"items" : [
            {
                name: "Followers",
                value: "followers"
            },
            {
                name: "Likes",
                value: "likes"
            },
            {
                name: "Nominations",
                value: "nominations"
            },
            {
                name: "Photos Sold",
                value: "sold"
            },
            {
                name: "Earnings",
                value: "earnings"
            }
        ]};

        init();

        function init(){
            buildSpecialitiesDropdown();
            if($scope.$parent.vm.onTabChanged){
                $scope.$parent.vm.onTabChanged(self.type);
            }
            if(self.type === 'leaderboard'){
                self.filterSetting.items.unshift({name: "Points", value: "points"});
                self.endingMessage = "These are just the top 30 photographers in our community right now - we have many, many more!<br/>Come join the fastest-growing photography community in Asia."
            }
            validateParams();
        }
        function validateParams(){
            var isNeedToBeRevised = false;
            if($state.params.page){
                var parseResult = numberUtils.parseInt($state.params.page);
                if(!parseResult){
                    $state.params.page = 1;
                    isNeedToBeRevised = true;
                }else {
                    self.page = $state.params.page;
                }
            }
            var defaultSelectedOrder  = self.filterSetting.items[0];
            if($state.params.order){
                var isValid = _.find(self.filterSetting.items, function(it){
                    return it.value === $state.params.order;
                });
                if(isValid){
                    defaultSelectedOrder = isValid;
                }
                $state.params.order = defaultSelectedOrder.value;
                isNeedToBeRevised = !isValid;
            }
            self.selectedFilterItem  = defaultSelectedOrder;
            self.order = self.selectedFilterItem.value;
            if(isNeedToBeRevised){
                updateUrlParams($state.params.page, $state.params.order)
            }

        }
        function updateUrlParams(page, order){
            $state.params.page = page;
            $state.params.order = order;
            $state.go($state.current.name, $state.params, {notify: false});
        }
        function onFilteredClicked(selectedFilterItem){
            self.onSearch(self.photographer, self.selectedFilterItem);
            updateUrlParams(1, selectedFilterItem.value);
        }
        function onPaging(page){
            updateUrlParams(page, self.selectedFilterItem.value);
        }

        function buildSpecialitiesDropdown() {
			pixerfApiUserSvc.getSpecialities().$promise.then(function (response) {
                self.specialities = response.data;
                self.specialities.unshift({id: 'all', name: 'All Specialities'});
			});
        }

        function onSearch(photographers, selectedFilterItem){
            var specialities = self.specialitiesSelected ? _.map(self.specialitiesSelected, function(obj){ return obj.id;}).toString() : null;
            var countries = self.countriesSelected ? _.map(self.countriesSelected, function(obj){ return obj.id;}).toString() : null;
            self.searchParams.page = 1;
            self.searchParams.order = selectedFilterItem.value;

            if(countries){
                self.searchParams.countries = countries;
            } else if (self.searchParams && self.searchParams.countries) {
                delete self.searchParams.countries;
            }
            if(specialities){
                self.searchParams.specialities = specialities;
            } else if (self.searchParams && self.searchParams.specialities) {
                delete self.searchParams.specialities;
            }
            if(photographers){
                self.searchParams.keywords = photographers;
            } else if (self.searchParams && self.searchParams.keywords) {
                delete self.searchParams.keywords;
            }

            self.leaderBoard.getLeaders(self.searchParams,true);
            updateUrlParams(1, selectedFilterItem.value);
        }

        function onCountriesSelected(countriesSelected){
            self.countriesSelected = countriesSelected;
            self.onSearch(self.photographer, self.selectedFilterItem);
        }

        function onSpecialitiesSelected(){
            self.onSearch(self.photographer, self.selectedFilterItem);
        }

        function onResetClicked(){
			$timeout(function() {
				$('.photographer-page-leaderboard__filter .specialities').find('select').selectpicker('deselectAll');
                $('.photographer-page-leaderboard__filter .countries').find('select').selectpicker('deselectAll');
                self.selectedFilterItem = self.filterSetting.items[0];
                self.photographer = "";
                self.onSearch(self.photographer, self.selectedFilterItem)
            });
            self.countrySelected = null;
        }
    }
})();

(function () {
  'use strict';

  angular
    .module('pixerf')
    .component('marketplacePhotos', marketplacePhotos);

  function marketplacePhotos() {

    var component = {
      templateUrl: 'app/marketplace/components/marketplace-photos/marketplace-photos.html',
      controller: 'marketplacePhotosCtrl',
      controllerAs: 'vm'
    };
    return component;
  }

})();

(function(){

	angular
	  .module('pixerf')
	  .controller('featuredPhotographerPageCtrl', featuredPhotographerPageCtrl);

	  featuredPhotographerPageCtrl.$inject = ['$scope', '$state', 'numberUtils', 'systemUtils', 'sessionManagerSvc', 'pixerfApiUserSvc', '$timeout'];

	  function featuredPhotographerPageCtrl($scope, $state, numberUtils, systemUtils, sessionManagerSvc, pixerfApiUserSvc, $timeout){
		  var self = this;

		  self.leaderBoard = null;
		  self.onSearchClicked = onSearchClicked;
		  self.onResetClicked = onResetClicked;
		  self.onCountriesSelected = onCountriesSelected;
		  self.type = 'featured_leaderboard';
		  $scope.$parent.vm.contextPage = "Featured Photographer";
		  self.page = 1;
		  self.order = null;
		  self.selectedFilterItem = {};
		  self.onPaging = onPaging;
		  self.endingMessage = '';
			self.loginUser = sessionManagerSvc.getCurrentLoginUser().data;
			self.searchParams = {
				action: self.type,
				order: 'point',
				page_size: 10
			};
		  self.dopdownOpts = {
			  "container": "body",
			  "maxOptionsText": "Any",
			  "noneSelectedText": "Any"
			};
			self.dopdownOptsSpec = {
				"customAll": true,
			  "container": "body",
			  "maxOptionsText": "Any",
			  "noneSelectedText": "Any"
			}
		  self.communities = [{"name": "Photography Community", "id": 1}];

		  init();

		  function init(){
			  buildSpecialitiesDropdown();
			  if($scope.$parent.vm.onTabChanged){
				  $scope.$parent.vm.onTabChanged(self.type);
			  }
				validateParams();
		  }
		  function validateParams(){
			  var isNeedToBeRevised = false;
			  if($state.params.page){
				  var parseResult = numberUtils.parseInt($state.params.page);
				  if(!parseResult){
					  $state.params.page = 1;
					  isNeedToBeRevised = true;
				  }else {
					  self.page = $state.params.page;
				  }
			  }
			  self.selectedFilterItem  = 'points';
			  self.order = self.selectedFilterItem.value;
			  if(isNeedToBeRevised){
				  updateUrlParams($state.params.page, $state.params.order)
			  }

		  }
		  function updateUrlParams(page, order){
			  $state.params.page = page;
			  $state.params.order = order;
			  $state.go($state.current.name, $state.params, {notify: false});
		  }
		  function onSearchClicked(){
				var specialities = self.specialitiesSelected ? _.map(self.specialitiesSelected, function(obj){ return obj.id;}).toString() : null;
				var countries = self.countriesSelected ? _.map(self.countriesSelected, function(obj){ return obj.id;}).toString() : null;
				self.searchParams.page = 1;

				if(countries){
					self.searchParams.countries = countries;
				} else if (self.searchParams && self.searchParams.countries) {
					delete self.searchParams.countries;
				}
				if(specialities){
					self.searchParams.specialities = specialities;
				} else if (self.searchParams && self.searchParams.specialities){
					delete self.searchParams.specialities;
				}

				self.leaderBoard.getPhotographers(self.searchParams,true);
				updateUrlParams(1, 'point');
		  }
		  function onPaging(page){
			  updateUrlParams(page, 'point');
		  }

		  function buildSpecialitiesDropdown() {
			  pixerfApiUserSvc.getSpecialities().$promise.then(function (response) {
					self.specialities = response.data;
					self.specialities.unshift({id: 'all', name: 'All Specialities'});
			  });
		  }
		  function onCountriesSelected(countriesSelected){
            self.countriesSelected = countriesSelected;
        }

		  function onResetClicked(){
			$timeout(function() {
				$('.featured-photographer-page__dropdown.specialities').find('select').selectpicker('deselectAll');
				$('.featured-photographer-page__dropdown.communities').find('select').selectpicker('deselectAll');
				$('.countries-dropdown__list.countries').find('select').selectpicker('deselectAll');
				self.specialitiesSelected = null;
				self.countriesSelected = null;
                self.onSearchClicked();
			});
			self.countrySelected = null;
		  }
	  }
  })();

(function () {

	angular
		.module('pixerf')
		.controller('visualInspirationCtrl', visualInspirationCtrl);

	visualInspirationCtrl.$inject = ["$scope", "missionInspirationPhotoSvc", "sessionManagerSvc"];

	function visualInspirationCtrl($scope, missionInspirationPhotoSvc, sessionManagerSvc) {
		var self = this;
		$scope.$parent.vm.contextPage = 'visual-inspiration';
		self.parent = $scope.$parent.vm;
		self.onPhotoGridInit = onPhotoGridInit;
		self.onSetMissionCoverClicked = onSetMissionCoverClicked;
		self.inspirationPhotoTemplate = getInspirationPhotoTemplate();
		self.bidingItems = [];

		init();

		function init() {
			if (self.parent.mission.is_multi_frame) {
				var visualPhotos = _.chunk(self.parent.mission.media, self.parent.mission.number_of_frames);
				for (var obj in visualPhotos) {
					self.bidingItems.push({
						title: obj,
						data: visualPhotos[obj],
					})
				}
			}
		}

		function getInspirationPhotoTemplate() {
			return '<mission-inspiration-photo media="vm.getFile(<%=id%>)" mission="mission" ></mission-inspiration-photo>';
		}

		function onPhotoGridInit(photoGridControl) {
			photoGridControl.photos = self.parent.mission.media;
			photoGridControl.render(self.parent.mission.media);
		}

		function onSetMissionCoverClicked(media) {
			missionInspirationPhotoSvc.setAsMissionCover(media, self.parent.mission);
		}
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('submissionsCtrl', submissionsCtrl);

	submissionsCtrl.$inject = ['$scope', 'uploadPhotoSvc', 'selectMyPhotoPopupSvc', 'toastr', 'pixerfApiMissionSvc', 'sessionManagerSvc', 'pixerfConfirmPopupSvc', 'subscriptionTypePopupSvc', 'actionPopupSvc', 'additionalEntriesPopupSvc', 'translationSvc', 'pagingUtils', 'photoViewerSvc', '$timeout'];

	function submissionsCtrl($scope, uploadPhotoSvc, selectMyPhotoPopupSvc, toastr, pixerfApiMissionSvc, sessionManagerSvc, pixerfConfirmPopupSvc, subscriptionTypePopupSvc, actionPopupSvc, additionalEntriesPopupSvc, translationSvc, pagingUtils, photoViewerSvc, $timeout) {
		var self = this;
		$scope.$parent.vm.submissionsCtrl = self;
		self.parent = $scope.$parent.vm;
		self.loginnedUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.onSubmitPhotoClicked = self.parent.onSubmitPhotoClicked;
		self.onRemoveParticipationClicked = onRemoveParticipationClicked;
		self.spinner = {
			isVisible: false
		};
		self.onUploadNewPhotoBtnClicked = onUploadNewPhotoBtnClicked;
		self.onUploadFromMineBtnClicked = onUploadFromMineBtnClicked;
		self.onSubmissionRemoved = onSubmissionRemoved;
		self.onPhotoSelected = onPhotoSelected;
		self.onMissionAgreed = onMissionAgreed;
		self.fetchMorePhotos = fetchMorePhotos;
		self.onCurrentPageChanged = onCurrentPageChanged;
		self.isFormDirty = false;
		self.isScrollToPixerferSubmission = false;
		self.context = self.parent.mission.is_multi_frame ? "multiframemission-" + self.parent.mission.id : "mission-" + self.parent.mission.id;
		$scope.$parent.vm.contextPage = "submissions";
		self.bidingItems = [];
		self.search = search;
		var photoIds = [];
		self.searchParams = {
			page: 1,
			page_size: self.parent.mission.is_multi_frame ? (self.parent.mission.number_of_frames * 4) : 17,
			missionId: self.parent.mission.id
		};

		// function init(){
        //     $scope.$watch("vm.photoGrid", function(){
        //         if(self.photoGrid){
        //             var params = {mission: self.parent.mission, page: 1};
        //             self.search(params);
        //         }
        //     });
        //     self.fixedSetting = {
        //         marginTop: function(){
        //             return  $(".mission-detail-page .pixerf-navigation-bar").outerHeight() + $(".header").height();
        //         },
        //         dontSetWidth : true
        //     }
        //     self.isAsiaGeoMission = self.parent.mission.is_ioa;
        // }
        function search(params){
            self.photoGrid.fetchPhotos(params, true).then(function () {
				if ($scope.$parent && self) {
					self.totalPage = self.photoGrid.totalPage;
					self.totalPhotos = self.photoGrid.totalPhotos;
				}
			});
        }


		init();

		function init() {
			// $timeout(function () {
			// 	self.isScrollToPixerferSubmission = true;
			// }, 500)
			// fetchPhotos(self.searchParams, true);

			$scope.$watch("vm.photoGrid", function(){
                if(self.photoGrid){
                    var params = {mission: self.parent.mission, page: 1};
                    self.search(params);
                }
            });

			self.fixedSetting = {
				marginTop: function () {
					return 120;
					;
				},
				dontSetWidth: true
			}
			self.isAsiaGeoMission = self.parent.mission.is_ioa;
		}

		function onSubmissionRemoved(participation, type) {
			if (type !== 'others' && type !== 'self') {
				if (participation.isMine) {
					self.loginnedUser = sessionManagerSvc.getCurrentLoginUser().data;
					self.loginnedUser.stats.media_count--;
					sessionManagerSvc.setCurrentLoginUser(self.loginnedUser);
				}
			}
			self.parent.mission.submissions--;
			if (type === "others") {
				self.photoGrid.totalPhotos--;
			}
			self.parent.mission.has_joined = self.mySubmissionGrid.photos.length > 0;
		}

		function onRemoveParticipationClicked(participation) {
			pixerfConfirmPopupSvc.showPopup({
				hideTitle: true,
				message: "Your photo will be removed from this Mission, but will still be available in the Marketplace.",
				okFn: function () {
					return pixerfApiMissionSvc.delete({
						id: self.parent.mission.id,
						action: 'participations',
						participation_id: participation.id
					}).$promise;
				},
				okFnCallback: function () {
					self.mySubmissionGrid.onFileRemoved(participation, 'self');
					toastr.success("Photo: " + participation.title + " is removed from this mission!");
				}
			})
		}

		function checkAgreeAgreement() {
			var errMsg = "";
			if (!self.parent.mission.is_agreement_accepted) {
				self.isFormDirty = true;
				errMsg = "Please agree to the Missions Agreement!";
			}
			return errMsg;
		}

		function onUploadNewPhotoBtnClicked() {
			var errMsg = checkAgreeAgreement();
			if (errMsg) {
				toastr.error(errMsg);
				return;
			}

			if (self.parent.mission.is_ioa) {
				var subscriptionTypePopup = subscriptionTypePopupSvc.showPopup({
					mission: self.parent.mission
				});
				subscriptionTypePopup.result.then(function (res) {
					self.parent.mission.ioaSubscriber = res;
					if (res.free_balance > 0) {
						uploadPhotoSvc.showUploadModal({
							mission: self.parent.mission
						});
					} else {
						actionPopupSvc.showPopup(res).result.then(function (res) {
							if (res) {
								additionalEntriesPopupSvc.showPopup(self.parent.mission).result.then(function (res) {
									uploadPhotoSvc.showUploadModal({
										mission: self.parent.mission
									});
								});
							}
						});
					}
				})
			} else {
				uploadPhotoSvc.showUploadModal({
					mission: self.parent.mission
				});
			}
		}

		function onUploadFromMineBtnClicked() {
			var errMsg = checkAgreeAgreement();
			if (errMsg) {
				toastr.error(errMsg);
				return;
			}

			if (self.parent.mission.is_ioa) {
				var subscriptionTypePopup = subscriptionTypePopupSvc.showPopup({
					mission: self.parent.mission
				});
				subscriptionTypePopup.result.then(function (res) {
					self.parent.mission.ioaSubscriber = res;
					if (res.free_balance > 0) {
						selectMyPhotoPopupSvc.showPopup({
							mission: self.parent.mission
						});
					} else {
						actionPopupSvc.showPopup(res).result.then(function (res) {
							if (res) {
								additionalEntriesPopupSvc.showPopup(self.parent.mission).result.then(function (res) {
									selectMyPhotoPopupSvc.showPopup({
										mission: self.parent.mission
									});
								});
							}
						});
					}
				});
			} else {
				selectMyPhotoPopupSvc.showPopup({
					mission: self.parent.mission
				});
			}
		}

		function onMissionAgreed() {
			pixerfApiMissionSvc.agree_agreement({
				id: self.parent.mission.id
			}, {}).$promise.then(function () {
				self.parent.mission.is_agreement_accepted = true;
			}, function () {
				self.parent.mission.is_agreement_accepted = false;
				toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
			})
		}

		function onPhotoSelected(photo) {
			photo.mission = self.parent.mission;
			photo.isMissionWinnerSelectionMode = !self.parent.mission.is_awarded && self.loginnedUser && self.loginnedUser.canManageMission && self.parent.mission.is_closed;
		}

		function fetchPhotos(searchParams, isFresh) {
			if (self.spinner.isVisible || self.isWorking) return;
			self.searchParams = searchParams;
			self.spinner.isVisible = true;
			self.isWorking = true;
			self.isFresh = isFresh
			var urlParams = {
				id: searchParams.missionId,
				page: searchParams.page,
				page_size: searchParams.page_size
			}
			if (self.parent.mission.is_multi_frame) {
				groupPhotoByPhotographer(searchParams, urlParams, isFresh);
			} else {
				pixerfApiMissionSvc.get_participations(urlParams, searchParams).$promise.then(function (response) {
					if (searchParams.page === 1 || isFresh) {
						self.bidingItems = [];
					}
					self.bidingItems = self.bidingItems.concat(response.data);
					photoIds = _.union(photoIds, _.pluck(self.bidingItems, "id"));
					photoViewerSvc.setListPhoto(photoIds);
					self.isLastPage = pagingUtils.isNoMorePageToLoad(searchParams.page, response);
					self.totalPhotos = pagingUtils.getTotalCount(response);
					self.totalPage = pagingUtils.getTotalPage(response);
					self.isWorking = false;
					self.spinner.isVisible = false;
				}).catch(function () {
					self.isWorking = false;
					self.spinner.isVisible = false;
				})
			}
		}

		function fetchMorePhotos() {
			if (self.spinner.isVisible || self.isWorking) {
				return;
			}
			self.searchParams.page++;
			self.parent.submissionPagination.page = self.searchParams.page;
			fetchPhotos(self.searchParams);
		}

		function groupPhotoByPhotographer(searchParams, urlParams, isFresh) {
			pixerfApiMissionSvc.get_participations(urlParams, searchParams).$promise.then(function (response) {
				if (searchParams.page === 1 || isFresh) {
					self.bidingItems = [];
				}
				if (response && response.data && response.data.length > 0) {
					var groupedByPhotographer = _.groupBy(response.data, function (item) {
						return item.user.id;
					});
					for (var obj in groupedByPhotographer) {
						self.bidingItems.push({
							title: groupedByPhotographer[obj][0].user.displayName,
							avatar: groupedByPhotographer[obj][0].user.avatar,
							data: groupedByPhotographer[obj],
							collapse: groupedByPhotographer[obj][0].user.id
						})
						photoIds = _.union(photoIds, _.pluck(groupedByPhotographer[obj], "id"));
					}
					photoViewerSvc.setListPhoto(photoIds);
				}
				self.isWorking = false;
				self.spinner.isVisible = false;
				self.isLastPage = pagingUtils.isNoMorePageToLoad(searchParams.page, response);
				self.totalPhotos = pagingUtils.getTotalCount(response);
				self.totalPage = pagingUtils.getTotalPage(response);
			})
		}

		function onCurrentPageChanged(pageNumber) {
			var params = {mission: self.parent.mission, page: pageNumber};
			self.search(params, true);
		}

	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('rejectedSubmissionsMissionCtrl', rejectedSubmissionsMissionCtrl);

		rejectedSubmissionsMissionCtrl.$inject = ['$scope', 'sessionManagerSvc'];

	function rejectedSubmissionsMissionCtrl($scope, sessionManagerSvc) {
		var self = this;
		$scope.$parent.vm.rejectSubmissionsMissionCtrl = self;
		$scope.$parent.vm.contextPage = 'reject';
		self.parent = $scope.$parent.vm;
		self.loginnedUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.photoGrid = null;
		self.mySubmissionGrid = {};
		self.search = search;
		self.options = {isRejectedState: true};

		init();

		function init() {
			$scope.$watch("vm.photoGrid", function () {
				if (self.photoGrid) {
					var params = {
						mission: self.parent.mission,
						page: 1,
						status: 'rejected'
					};
					self.search(params);
				}
			});
			self.fixedSetting = {
				marginTop: function () {
					return 120;
				},
				dontSetWidth: true
			}
		}

		function search(params) {
			return self.photoGrid.fetchPhotos(params, true);
		}
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('pendingSubmissionsMissionCtrl', pendingSubmissionsMissionCtrl);

	pendingSubmissionsMissionCtrl.$inject = ['$scope', 'sessionManagerSvc'];

	function pendingSubmissionsMissionCtrl($scope, sessionManagerSvc) {
		var self = this;
		$scope.$parent.vm.pendingSubmissionsMissionCtrl = self;
		$scope.$parent.vm.contextPage = 'pending';
		self.parent = $scope.$parent.vm;
		self.loginnedUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.photoGrid = null;
		self.mySubmissionGrid = {};
		self.search = search;
		self.options = {showBtnE: true};

		init();

		function init() {
			$scope.$watch("vm.photoGrid", function () {
				if (self.photoGrid) {
					var params = {
						mission: self.parent.mission,
						page: 1,
						status: 'pending'
					};
					self.search(params);
				}
			});
			self.fixedSetting = {
				marginTop: function () {
					return 120;
				},
				dontSetWidth: true
			}
		}

		function search(params) {
			return self.photoGrid.fetchPhotos(params, true);
		}
	}
})();

(function () {

  angular
    .module('pixerf')
    .controller('briefCtrl', briefCtrl);

  briefCtrl.$inject = ["$scope", "sessionManagerSvc"];

  function briefCtrl($scope, sessionManagerSvc) {
    var self = this;
    self.parent = $scope.$parent.vm;
    self.onSubmitPhotoClicked = self.parent.onSubmitPhotoClicked;
    self.onPhotoGridInit = onPhotoGridInit;
    self.loginnedUser = sessionManagerSvc.getCurrentLoginUser().data;
    self.inspirationPhotoTemplate = getInspirationPhotoTemplate();
    self.parent.contextPage = "brief";
    self.onVisualInspirationClicked = onVisualInspirationClicked;
    self.requirements = [{
      title: 'Orientation',
      value: self.parent.mission.orientation,
      className: 'orientation'
    }, {
      title: 'License Usage',
      value: self.parent.mission.license_usage,
      className: 'license-usage'
    }, {
      title: 'Environment',
      value: self.parent.mission.environment,
      className: 'environment'
    }, {
      title: 'Lighting',
      value: self.parent.mission.lighting,
      className: 'lighting'
    }, {
      title: 'Output',
      value: self.parent.mission.output,
      className: 'output'
    }, {
      title: 'Space for Copy',
      value: self.parent.mission.space_for_copy ? 'Yes' : 'No',
      className: 'space-for-copy'
    }]
    function onPhotoGridInit(photoGridControl) {
      photoGridControl.photos = self.parent.mission.media;
      photoGridControl.render(self.parent.mission.media);
    }
    function getInspirationPhotoTemplate() {
      return '<mission-inspiration-photo media="vm.getFile(<%=id%>)" mission="mission" ></mission-inspiration-photo>';
    }
    function onVisualInspirationClicked() {
      self.scrollToVisualInspiration = new Date().getTime();
    }

  }
})();

(function(){

  angular
    .module('pixerf')
    .controller('awardsCtrl', awardsCtrl);

    awardsCtrl.$inject = ["$scope", "submitMissionPhotoPopupSvc", "pixerfApiMissionSvc", "toastr", "pixerfConfirmPopupSvc", "$state", "photoSvc", "photoDetailPopupSvc", "missionConst", 'translationSvc', '$timeout'];

    function awardsCtrl($scope, submitMissionPhotoPopupSvc, pixerfApiMissionSvc, toastr, pixerfConfirmPopupSvc, $state, photoSvc, photoDetailPopupSvc, missionConst, translationSvc, $timeout){
        var self = this;
        self.onSubmitPhotoClicked = onSubmitPhotoClicked;
        self.parent = $scope.$parent.vm;
        self.onWinnerRemovedBtnClicked = onWinnerRemovedBtnClicked;
        self.onPublishWinnerBtnClicked = onPublishWinnerBtnClicked;
        self.getTemplate = getTemplate;
        self.filterAwardedPrize = filterAwardedPrize;
        self.isAllPrizeAwared = isAllPrizeAwared;
        self.isWorking = false;
        self.getCurrentUrl = getCurrentUrl;
        self.hyphen = hyphen;
        self.onAwardedPhotoClicked = onAwardedPhotoClicked;
        self.isRankingAward = missionConst.MISSION_RANKING_ORDER.MISSION_ID.includes(self.parent.mission.id);
		$scope.$parent.vm.contextPage = "awards";
		var mTemplates ={
            'AWARDS-SELECTION': 'app/mission-detail-page/components/awards/awards-selection/awards-selection.html',
            'AWARDS-PUBLIC': 'app/mission-detail-page/components/awards/awards-public/awards-public.html'
        }
        init();
        function init(){
            if(!self.parent.isAwardVisible()){
                $state.go("mission-detail-page.brief");
            }
        }

        self.getMissionDescription = function(){
            return self.parent.description;
        }

        function hyphen(text, maxLength){
            var array = text.split(' ');
            isSortText = true;
            for (var i = 0; i < array.length; i++) {
                if(array[i].length > maxLength){
                    isSortText = false;
                    break;
                }
            }
            if(isSortText) return text;
            for (var i = maxLength; i < text.length; i++) {
                if(text.charAt(i) != ' ' && text.charAt(i - 1) != ' ' && text.charAt(i + 1) != ' ' && i != text.length - 1){
                    text = [text.slice(0, i), '-', text.slice(i)].join('');
                    i = i + maxLength;
                }else if(text.charAt(i - 1) == ' '){
                    i = i + maxLength -1;
                }
            }
            result = text;
            return result;
        }

        function filterAwardedPrize(prize){
            return !!prize.winner
        }

        function getCurrentUrl(){
            return window.location.href;
        }
        
        function isAllPrizeAwared(prizesGrouped, type){
            var prizes;
            prizes = prizesGrouped[type];
            return _.every(prizes, function(p){
                return !!p.winner;
            });
        }
        function onSubmitPhotoClicked(){
            submitMissionPhotoPopupSvc.showPopup();
        }
        function getTemplate(mission){
            if(mission.is_awarded){
                return mTemplates['AWARDS-PUBLIC'];
            }
            return mTemplates["AWARDS-SELECTION"];
        }
        function validateBeforePublish(prizesGrouped){
            var prizes;
            var isFulfilled;
            for (var type in prizesGrouped){
                isFulfilled = isAllPrizeAwared(prizesGrouped, type);
                if(!isFulfilled){
                    return "You need to choose winner for all prizes!";
                }
            }
            return null;
        }
        function onPublishWinnerBtnClicked(){
            var errMsg = validateBeforePublish(self.parent.mission.prizes_grouped);
            if(errMsg) {
                toastr.error(errMsg);
                return;
            }
            var confirm = pixerfConfirmPopupSvc.showPopup({
                hideTitle: true,
                message: "Once you proceed, you will not be able to reselect your winning photo(s).",
                okBtnText: 'Yes',
                confirmText: 'Do you want to finalise your selection?'
            });
            confirm.result.then(function(){
                if(self.isWorking) return false;
                self.isWorking = true;
                pixerfApiMissionSvc.finalize({id:self.parent.mission.id}, {}).$promise.then(function(){
                    self.parent.mission.is_awarded = true;
                    toastr.success('Mission winner is finalised and published');
                    self.isWorking = false;
                }, function(){
                    self.isWorking = false;
                    toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
                })
            }, function(){
                //do nothing
            })
        }
        function onWinnerRemovedBtnClicked(prize){
			if(self.isWorking) return false;
			self.isWorking = true;
			pixerfApiMissionSvc.remove_winner({id:self.parent.mission.id, prize_id: prize.id}).$promise.then(function(response){
                var prizeType = prize.type === 'WINNER' ? 'Winning' : 'Special Mention';
                toastr.success('You have removed this as a ' + prizeType + ' photo.');
                prize.winner = null;
				self.isWorking = false;
            }, function(){
				self.isWorking = false;
                toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
            })
        }
        function onAwardedPhotoClicked(photo){
            var copyPhoto = {id: photo.id};
            photoSvc.updatePhotoInfo(copyPhoto, true).then(function(){
                copyPhoto.mission = self.parent.mission;
                copyPhoto.isMissionWinnerSelectionMode = !self.parent.mission.is_awarded && self.loginnedUser && self.parent.loginnedUser.canManageMission;
                var modal = photoDetailPopupSvc.showPopup({
                    photo: copyPhoto
                });
            });
        }
    }
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('onGoingCtrl', onGoingCtrl);

	onGoingCtrl.$inject = ['$scope', 'pixerfApiMissionSvc', 'toastr', 'pagingUtils', 'sessionManagerSvc', '$state'];

	function onGoingCtrl($scope, pixerfApiMissionSvc, toastr, pagingUtils, sessionManagerSvc, $state) {

		var self = this;
		self.loginnedUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.spinner = {isVisible: false}
		self.fetchMoreItems = fetchMoreItems;
		self.isLastPage = false;
		self.missions = null;
		$scope.$parent.vm.contextPage = "Ongoing";
		$scope.$parent.vm.subContextPage = "Ongoing";
		if( $scope.$parent && $scope.$parent.$parent && $scope.$parent.$parent.$parent && $scope.$parent.$parent.$parent.vm){
			$scope.$parent.$parent.$parent.vm.contextPage = "Community Challenges";
		}
		self.searchParams = {
			page: 1,
		};
		self.isMyMission = $state.current.name.includes("manage-missions");

		init();

		function init(){
			fetchItems(self.searchParams, true);
		}

		function fetchItems(searchParams, isFresh){
			var action = "query";
			if($state.current.name.indexOf('manage-missions') > -1){
				action = "get_manage_mission";
			}
			self.spinner.isVisible = true;
			searchParams.type = 'current';
			searchParams.sort = ["inserted_at,desc"];
			pixerfApiMissionSvc[action](searchParams).$promise.then(function(response){
				if(searchParams.page === 1 || isFresh) self.missions = [];
                self.spinner.isVisible = false;
                if(response && response.data && response.data.missions && response.data.missions.length > 0){
					self.missions = self.missions.concat(response.data.missions);
                }
                self.isLastPage = pagingUtils.isNoMorePageToLoad(searchParams.page, response);

			}, function(){
				self.spinner.isVisible = false;
				toastr.error('Failed to get missions!');
			})
		}
		function fetchMoreItems(){
			 if(self.spinner.isVisible){
                return;
            }
            self.searchParams.page ++;
			fetchItems(self.searchParams);
		}

	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('missionSponsorAgreementCtrl', missionSponsorAgreementCtrl);

	missionSponsorAgreementCtrl.$inject = ['$scope'];

	function missionSponsorAgreementCtrl($scope) {
		var self = this;
		$scope.$parent.vm.contextPage = "Missions Sponsor Agreement";
		self.missionPhoto = {
			"id": 7883,
			"url": "../assets/images/footer-pages/mission-agreement.jpg",
			"title": "Water and Sand",
			"user": {
				"name": "Chema Grenda",
				"id": 2360
			}
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('missionJoinedCtrl', missionJoinedCtrl);

	missionJoinedCtrl.$inject = ['$scope', 'missionSvc', 'toastr', 'sessionManagerSvc', 'pagingUtils'];

	function missionJoinedCtrl($scope, missionSvc, toastr, sessionManagerSvc, pagingUtils) {

		var self = this;
		self.loginnedUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.spinner = {isVisible: false}
		self.fetchMoreItems = fetchMoreItems;
		self.isLastPage = false;
		self.missions = null;
		$scope.$parent.vm.contextPage = "Joined";
		if( $scope.$parent && $scope.$parent.$parent && $scope.$parent.$parent.$parent && $scope.$parent.$parent.$parent.vm){
			$scope.$parent.$parent.$parent.vm.contextPage = "Community Challenges";
		}
		self.searchParams = {
			page: 1,
		};

		init();

		function init(){
			fetchItems(self.searchParams, true);
		}

		function fetchItems(searchParams, isFresh){
			var timeRange = null;
			self.spinner.isVisible = true;
			searchParams.type = 'joined';
			searchParams.sort = ["inserted_at,desc"];
			missionSvc.fetchMissions(searchParams).then(function(response){
				if(searchParams.page === 1 || isFresh) self.missions = [];
                self.spinner.isVisible = false;
                if(response && response.data && response.data.missions && response.data.missions.length > 0){
					self.missions = self.missions.concat(response.data.missions);
                }
                self.isLastPage = pagingUtils.isNoMorePageToLoad(searchParams.page, response);

			}, function(){
				self.spinner.isVisible = false;
				toastr.error('Failed to get missions!');
			})
		}
		function fetchMoreItems(){
			 if(self.spinner.isVisible){
                return;
            }
            self.searchParams.page ++;
			fetchItems(self.searchParams);
		}
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('missionInfoCtrl', missionInfoCtrl);

	missionInfoCtrl.$inject = ['$rootScope', '$translate', 'translationUtils', 'badgeUtils', 'sessionManagerSvc'];

	function missionInfoCtrl($rootScope, $translate, translationUtils, badgeUtils, sessionManagerSvc) {
		var self = this;
		self.tmpTranslatedDescription = self.mission.description;
		self.tmpTranslatedArtDirection = self.mission.art_direction;
		self.onPhotoGridInit = onPhotoGridInit;
		self.inspirationPhotoTemplate = getInspirationPhotoTemplate();
		self.onVisualInspirationClicked = onVisualInspirationClicked;
		self.onTranslateClicked = onTranslateClicked;
		self.translateArtDirectionBtnText = "translate";
		self.translateDescriptionBtnText = "translate";
		self.bidingItems = [];

		var pixerfEnv = new PixerfEnv().getEnv();
		self.isCustomMission124 = pixerfEnv === "PRODUCTION" ? [124].includes(self.mission.id) : [1641].includes(self.mission.id);

		init();

		$rootScope.$on('$translateChangeSuccess', function (event, current) {
			genImgRequirement();
		})

		function init() {
			showedLanguage();
			if (self.mission.is_multi_frame) {
				var visualPhotos = _.chunk(self.mission.media, self.mission.number_of_frames);
				for (var obj in visualPhotos) {
					self.bidingItems.push({
						title: obj,
						data: visualPhotos[obj],
					})
				}
			}
			genImgRequirement();
			self.kindWinners = badgeUtils.multiTierPrizeAnalyze(self.mission.prizes);
			self.isMultiWinners = self.kindWinners.winner && self.kindWinners.winner.quantity > 1;
		}

		if (self.mission.is_goJek || (self.mission.countries && self.mission.countries.length > 0)) {
			self.requirements.push({
				title: 'Photo resolution',
				value: '5 megapixels to 40MB',
				className: 'photo-resolution'
			});
		}
		$rootScope.$on("initLang", function (evt, data) {
			// showTranslateBtn();
			if ($rootScope.lang) {
				showedLanguage();
			}
		})
		$rootScope.$on('$translateChangeSuccess', function (event, current) {
			// showOriginalText();
			// showTranslateBtn();
			if ($rootScope.lang) {
				showedLanguage();
			}
		})

		function showedLanguage() {
			if ($rootScope.lang != 'en' && self.mission.translations[$rootScope.lang] && self.mission.translations[$rootScope.lang]['description']) {
				self.tmpTranslatedDescription = self.mission.translations[$rootScope.lang]['description'];
			} else {
				self.tmpTranslatedDescription = self.mission.description;
			}
			if ($rootScope.lang != 'en' && self.mission.translations[$rootScope.lang] && self.mission.translations[$rootScope.lang]['art_direction']) {
				self.tmpTranslatedArtDirection = self.mission.translations[$rootScope.lang]['art_direction'];
			} else {
				self.tmpTranslatedArtDirection = self.mission.art_direction;
			}
		}

		function showTranslateBtn() {
			if ($rootScope.lang != self.mission.description_detect_language && translationUtils.canTranslate(self.mission.translations, $rootScope.lang, 'description')) {
				self.showTranslateDescription = true;
			} else {
				self.showTranslateDescription = false;
			}
			if ($rootScope.lang != self.mission.art_direction_detect_language && translationUtils.canTranslate(self.mission.translations, $rootScope.lang, 'art_direction')) {
				self.showTranslateArtDirection = true;
			} else {
				self.showTranslateArtDirection = false;
			}
		}

		function showOriginalText() {
			self.isTranslatedDescription = false;
			self.isTranslatedArtDirection = false;
			self.tmpTranslatedDescription = self.mission.description;
			self.tmpTranslatedArtDirection = self.mission.art_direction;
			self.translateArtDirectionBtnText = "translate";
			self.translateDescriptionBtnText = "translate";
		}

		function genImgRequirement() {
			if (self.mission.id === 87) {
				self.requirements = [{
					title: $translate.instant('orientation'),
					value: self.mission.orientation.toLowerCase(),
					className: 'orientation'
				}, {
					title: $translate.instant('license-usage'),
					value: self.mission.license_usage === 'Commercial & Editorial' ? 'commercial-and-editorial' : self.mission.license_usage.toLowerCase(),
					className: 'license-usage'
				}, {
					title: $translate.instant('environment'),
					value: self.mission.environment.toLowerCase(),
					className: 'environment'
				}, {
					title: $translate.instant('lighting'),
					value: self.mission.lighting.toLowerCase(),
					className: 'lighting'
				}, {
					title: $translate.instant('space-for-copy'),
					value: self.mission.space_for_copy ? 'yes' : 'no',
					className: 'space-for-copy'
				}, {
					title: $translate.instant('output'),
					value: self.mission.output.toLowerCase(),
					className: 'output'
				}]
			} else {
				self.requirements = [{
					title: $translate.instant('orientation'),
					value: self.mission.orientation,
					className: 'orientation'
				}, {
					title: $translate.instant('license-usage'),
					value: self.mission.license_usage === 'Commercial & Editorial' ? 'commercial-and-editorial' : self.mission.license_usage,
					className: 'license-usage'
				}, {
					title: $translate.instant('environment'),
					value: self.mission.environment,
					className: 'environment'
				}, {
					title: $translate.instant('lighting'),
					value: self.mission.lighting,
					className: 'lighting'
				}, {
					title: $translate.instant('space-for-copy'),
					value: self.mission.space_for_copy ? 'Yes' : 'No',
					className: 'space-for-copy'
				}, {
					title: $translate.instant('output'),
					value: self.mission.output,
					className: 'output'
				}]
			}
		}

		function onPhotoGridInit(photoGridControl) {
			photoGridControl.photos = self.mission.media;
			photoGridControl.render(self.mission.media);
		}

		function getInspirationPhotoTemplate() {
			return '<mission-inspiration-photo media="vm.getFile(<%=id%>)" mission="mission" ></mission-inspiration-photo>';
		}

		function onVisualInspirationClicked() {
			if (!self.isPreviewMode) {
				self.scrollToVisualInspiration = new Date().getTime();
			}
		}

		function onTranslateClicked(field) {
			switch (field) {
				case 'artDirection':
					if (!self.isTranslatedArtDirection && translationUtils.canTranslate(self.mission.translations, $rootScope.lang, 'art_direction')) {
						self.tmpTranslatedArtDirection = self.mission.translations[$rootScope.lang]['art_direction'];
						self.isTranslatedArtDirection = true;
						self.translateArtDirectionBtnText = "see-original";
					} else if (self.isTranslatedArtDirection) {
						self.tmpTranslatedArtDirection = self.mission['art_direction'];
						self.isTranslatedArtDirection = false;
						self.translateArtDirectionBtnText = "translate";
					}
					break;
				case 'description':
					if (!self.isTranslatedDescription && translationUtils.canTranslate(self.mission.translations, $rootScope.lang, 'description')) {
						self.tmpTranslatedDescription = self.mission.translations[$rootScope.lang]['description'];
						self.isTranslatedDescription = true;
						self.translateDescriptionBtnText = "see-original";
					} else if (self.isTranslatedDescription) {
						self.tmpTranslatedDescription = self.mission['description'];
						self.isTranslatedDescription = false;
						self.translateDescriptionBtnText = "translate";
					}
					break;
			}
		}
	}
})();

(function () {
    'use strict';
  
    angular
      .module('pixerf')
      .component('missionInfo', missionInfo());
  
    function missionInfo() {
  
      var component = {
        bindings: {
            mission: "=",
            isPreviewMode: "=",
            allowToSubmitSubmission: "=",
            onSubmitPhotoClicked: "&?"
        },
        templateUrl: 'app/mission/components/mission-info/mission-info.html',
        controller: 'missionInfoCtrl as vm'
      };
      return component;
    }
  
  })();
  
(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('missionClosedCtrl', missionClosedCtrl);

	missionClosedCtrl.$inject = ['$scope', 'pixerfApiMissionSvc', 'toastr', 'sessionManagerSvc', 'pagingUtils', '$state'];

	function missionClosedCtrl($scope, pixerfApiMissionSvc, toastr, sessionManagerSvc, pagingUtils, $state) {

		var self = this;
		self.loginnedUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.spinner = {isVisible: false}
		self.fetchMoreItems = fetchMoreItems;
		self.isLastPage = false;
		self.missions = null;
		$scope.$parent.vm.contextPage = "Closed";
		$scope.$parent.vm.subContextPage = "Closed";
		if( $scope.$parent && $scope.$parent.$parent && $scope.$parent.$parent.$parent && $scope.$parent.$parent.$parent.vm){
			$scope.$parent.$parent.$parent.vm.contextPage = "Community Challenges";
		}
		self.searchParams = {
			page: 1,
		};
		self.isMyMission = $state.current.name.includes("manage-missions");

		init();

		function init(){
			fetchItems(self.searchParams, true);
		}

		function fetchItems(searchParams, isFresh){
			var action = "query";
			if($state.current.name.indexOf('manage-missions') > -1){
				action = "get_manage_mission";
			}
			self.spinner.isVisible = true;
			searchParams.type = 'past';
			searchParams.sort = ["inserted_at,desc"];
			pixerfApiMissionSvc[action](searchParams).$promise.then(function(response){
				if(searchParams.page === 1 || isFresh) self.missions = [];
                self.spinner.isVisible = false;
                if(response && response.data && response.data.missions && response.data.missions.length > 0){
					self.missions = self.missions.concat(response.data.missions);
                }
                self.isLastPage = pagingUtils.isNoMorePageToLoad(searchParams.page, response);

			}, function(){
				self.spinner.isVisible = false;
				toastr.error('Failed to get missions!');
			})
		}
		function fetchMoreItems(){
			 if(self.spinner.isVisible){
                return;
            }
            self.searchParams.page ++;
			fetchItems(self.searchParams);
		}

	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('missionAgreementCtrl', missionAgreementCtrl);

	missionAgreementCtrl.$inject = ['$scope'];

	function missionAgreementCtrl($scope) {
		var self = this;
		$scope.$parent.vm.contextPage = "Missions Agreement";
		self.missionPhoto = {
			"id": 7883,
			"url": "../assets/images/footer-pages/mission-agreement.jpg",
			"title": "Water and Sand",
			"user": {
				"name": "Chema Grenda",
				"id": 2360
			}
		}
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('missionAgreementCtrl', missionAgreementCtrl);

	missionAgreementCtrl.$inject = ['$scope'];

	function missionAgreementCtrl($scope) {
		var self = this;
		$scope.$parent.vm.contextPage = "Missions Agreement";
		self.missionPhoto = {
			"id": 7883,
			"url": "../assets/images/footer-pages/mission-agreement.jpg",
			"title": "Water and Sand",
			"user": {
				"name": "Chema Grenda",
				"id": 2360
			}
		}
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('rejectedSubmissionsCtrl', rejectedSubmissionsCtrl);

		rejectedSubmissionsCtrl.$inject = ['$scope', 'pagingUtils', 'pixerfApiMissionSvc', '$state'];

	function rejectedSubmissionsCtrl($scope, pagingUtils, pixerfApiMissionSvc, $state) {
		var self = this;
		self.bidingItems = [];
		self.fetchMorePhotos = fetchMorePhotos;
		self.spinner = {
			isVisible: false
		};
		self.searchParams = {
			page: 1
		};
		self.options = {showBtnE: true};

		init();

		function init() {
			if($state.params && $state.params.page){
				self.searchParams.page = $state.params.page;
			}
			fetchPhotos(self.searchParams, true);
		}

		function fetchPhotos(searchParams, isFresh) {
			if (self.spinner.isVisible && self.isWorking) return;
			self.searchParams = searchParams;
			self.spinner.isVisible = true;
			self.isWorking = true;
			self.isFresh = isFresh;

			groupPhotoByMission(searchParams, isFresh);
		}

		function fetchMorePhotos() {
			if (self.spinner.isVisible && self.isWorking) {
				return;
			}
			self.searchParams.page++;
			updateUrlParams(self.searchParams.page);
			fetchPhotos(self.searchParams);
		}

		function updateUrlParams(page) {
			$scope.$parent.vm.page = page;
			$state.params.page = page;
			$state.go($state.current.name, $state.params, {
				notify: false
			});
		}

		function groupPhotoByMission(searchParams, isFresh) {
			pixerfApiMissionSvc.get_rejected_in_missions(searchParams).$promise.then(function (response) {
				if (searchParams.page === 1 || isFresh) {
					self.bidingItems = [];
				}
				if (response && response.data && response.data.length > 0) {
					var groupedByMission = _.groupBy(response.data, 'mission_id');
					for (var obj in groupedByMission) {
						var isExistInGroup = _.findIndex(self.bidingItems, function (item) {
							return item.id === groupedByMission[obj][0].mission_id;
						});

						if (isExistInGroup > -1) {
							self.bidingItems[isExistInGroup].data = self.bidingItems[isExistInGroup].data.concat(groupedByMission[obj]);
						} else {
							self.bidingItems.push({
								title: groupedByMission[obj][0].mission_title,
								id: groupedByMission[obj][0].mission_id,
								data: groupedByMission[obj],
								collapse: groupedByMission[obj][0].mission_id
							})
						}
					}
				}
				self.isWorking = false;
				self.spinner.isVisible = false;
				self.isLastPage = pagingUtils.isNoMorePageToLoad(searchParams.page, response);
				self.totalPhotos = pagingUtils.getTotalCount(response);
				self.totalPage = pagingUtils.getTotalPage(response);
				$scope.$parent.vm.totalPage = self.totalPage;
			})
		}
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('pendingSubmissionsCtrl', pendingSubmissionsCtrl);

	pendingSubmissionsCtrl.$inject = ['$scope', 'pagingUtils', 'pixerfApiMissionSvc', '$state'];

	function pendingSubmissionsCtrl($scope, pagingUtils, pixerfApiMissionSvc, $state) {
		var self = this;
		self.bidingItems = [];
		self.fetchMorePhotos = fetchMorePhotos;
		self.spinner = {
			isVisible: false
		};
		self.searchParams = {
			page: 1
		};
		self.options = {showBtnE: true};

		init();

		function init() {
			if($state.params && $state.params.page){
				self.searchParams.page = $state.params.page;
			}
			fetchPhotos(self.searchParams, true);
		}

		function fetchPhotos(searchParams, isFresh) {
			if (self.spinner.isVisible && self.isWorking) return;
			self.searchParams = searchParams;
			self.spinner.isVisible = true;
			self.isWorking = true;
			self.isFresh = isFresh;

			groupPhotoByMission(searchParams, isFresh);
		}

		function fetchMorePhotos() {
			if (self.spinner.isVisible && self.isWorking) {
				return;
			}
			self.searchParams.page++;
			updateUrlParams(self.searchParams.page);
			fetchPhotos(self.searchParams);
		}

		function updateUrlParams(page) {
			$scope.$parent.vm.page = page;
			$state.params.page = page;
			$state.go($state.current.name, $state.params, {
				notify: false
			});
		}

		function groupPhotoByMission(searchParams, isFresh) {
			pixerfApiMissionSvc.get_pending_in_missions(searchParams).$promise.then(function (response) {
				if (searchParams.page === 1 || isFresh) {
					self.bidingItems = [];
				}
				if (response && response.data && response.data.length > 0) {
					var groupedByMission = _.groupBy(response.data, 'mission_id');
					for (var obj in groupedByMission) {
						var isExistInGroup = _.findIndex(self.bidingItems, function (item) {
							return item.id === groupedByMission[obj][0].mission_id;
						});

						if (isExistInGroup > -1) {
							self.bidingItems[isExistInGroup].data = self.bidingItems[isExistInGroup].data.concat(groupedByMission[obj]);
						} else {
							self.bidingItems.push({
								title: groupedByMission[obj][0].mission_title,
								id: groupedByMission[obj][0].mission_id,
								data: groupedByMission[obj],
								collapse: groupedByMission[obj][0].mission_id
							})
						}
					}
				}
				self.isWorking = false;
				self.spinner.isVisible = false;
				self.isLastPage = pagingUtils.isNoMorePageToLoad(searchParams.page, response);
				self.totalPhotos = pagingUtils.getTotalCount(response);
				self.totalPage = pagingUtils.getTotalPage(response);
				$scope.$parent.vm.totalPage = self.totalPage;
			})
		}
	}
})();

/**
 * Controller for home module
 */
(function () {

	angular
		.module('pixerf')
		.controller('marketplacePhotosCtrl', marketplacePhotosCtrl);

	marketplacePhotosCtrl.$inject = ['$scope', '$state', 'fileConst', 'stringUtils', 'sessionManagerSvc', '$location', 'numberUtils', 'systemUtils'];

	function marketplacePhotosCtrl($scope, $state, fileConst, stringUtils, sessionManagerSvc, $location, numberUtils, systemUtils) {
		var self = this;
		self.photoGrid = null;
		self.params = {};
		self.onLoadMorePage = onLoadMorePage;
		self.onScrollToPhoto = onScrollToPhoto;
		init();

		function extractSearchParam() {
			var arr = [];
			if (!$state.params.type) $state.params.type = fileConst.FILE_STATE_NAME.TRENDING;
			if ($state.params.categoryIds) {
				var categoryIds = $state.params.categoryIds.split(",");
				for (var i = 0; i < categoryIds.length; i++) {
					arr.push({
						id: numberUtils.parseInt(categoryIds[i])
					});

				}
			}
			$scope.$parent.vm.selectedCategories = arr;
			self.params.page = 1;
			if ($state.params.page) {
				self.params.page = numberUtils.parseInt($state.params.page);
			}
			$scope.$parent.vm.page = self.params.page ? self.params.page : 1;
			if ($state.params.categoryIds) {
				self.params.categoryIds = $state.params.categoryIds.split(",");
			}
			self.params.state = fileConst.FILE_STATE_DEFINITION[$state.params.type.toLowerCase()];
			if ($state.params.type.toLowerCase() === fileConst.FILE_STATE_NAME.REJECTED ||
				$state.params.type.toLowerCase() === fileConst.FILE_STATE_NAME.GENERAL) {
				self.params.sort = ["inserted_at,desc"];
			} else if ($state.params.type.toLowerCase() === fileConst.FILE_STATE_NAME.PENDING) {
				self.params.sort = ["inserted_at,asc"];
			} else if ($state.params.type.toLowerCase() === fileConst.FILE_STATE_NAME.PENDING_PORTFOLIO) {
				self.params.sort = ["inserted_at,asc"];
				self.params.type = "portfolio";
			} else if ($state.params.type.toLowerCase() === fileConst.FILE_STATE_NAME.PENDING_MISSIONS) {
                self.params.type = "pending_missions";
			}
			self.params.in_mission = ($state.params.type.toLowerCase() === fileConst.FILE_STATE_NAME.REJECTED || $state.params.type.toLowerCase() === fileConst.FILE_STATE_NAME.PENDING) ? false : undefined;


		}

		function updateUrlParams(page) {
			if (systemUtils.isMobile()) {
				$state.params.page = "";
				$state.go($state.current.name, $state.params, {
					notify: false
				});
				return;
			}
			$scope.$parent.vm.page = page;
			$state.params.page = page;
			$state.go($state.current.name, $state.params, {
				notify: false
			});
		}

		function onLoadMorePage(page) {
			updateUrlParams(page);
		}

		function onScrollToPhoto(page) {
			updateUrlParams(page);
		}

		function init() {
			sessionManagerSvc.setMarketplaceTabHistory($location.$$url);
			$scope.$watch("vm.photoGrid", function () {
				if (self.photoGrid && $scope.$parent) {
					extractSearchParam();
					$scope.$parent.vm.pagerText = stringUtils.toTitleCase($state.params.type).replace(/-/g, " ");
					$scope.$parent.vm.mobileBreadcrumb = $scope.$parent.vm.pagerText;
					$scope.$parent.vm.page = self.params.page;
					$scope.$parent.vm.pagerUnit = null;
					self.photoGrid.isTemporaryType = ($state.params.type == fileConst.FILE_STATE_NAME.TEMPORARY);
					self.photoGrid.fetchPhotos(self.params, true).then(function () {
						if ($scope.$parent && $scope.$parent.vm) {
							$scope.$parent.vm.totalPage = self.photoGrid.totalPage;
							$scope.$parent.vm.totalPhotos = self.photoGrid.totalPhotos;
						}
					});
				}
			})
		}
	}
})();

(function () {
  'use strict';

  angular
    .module('pixerf')
    .component('marketplacePhotos', marketplacePhotos);

  function marketplacePhotos() {

    var component = {
      templateUrl: 'app/marketplace/components/marketplace-photos/marketplace-photos.html',
      controller: 'marketplacePhotosCtrl',
      controllerAs: 'vm'
    };
    return component;
  }

})();

(function () {

	angular
		.module('pixerf')
		.controller('marketplaceGalleriesGridCtrl', marketplaceGalleriesGridCtrl);

	marketplaceGalleriesGridCtrl.$inject = ['galleryConst', '$scope', 'toastr', '$stateParams', 'headerSvc', 'sessionManagerSvc', '$state', 'numberUtils', 'systemUtils'];

	function marketplaceGalleriesGridCtrl(galleryConst, $scope, toastr, $stateParams, headerSvc, sessionManagerSvc, $state, numberUtils, systemUtils) {
		console.log($stateParams);
		var self = this;
		self.topGalleries = [];
		self.galleryGridAll = null;
		self.onScrollToGallery = onScrollToGallery;
		self.onStaredToggled = onStaredToggled;
		self.onLoadMorePage = onLoadMorePage;
		self.onBackbtnClicked = onBackbtnClicked;
		self.scrollToFixedHeaderSettings = headerSvc.getFixedByHeaderSetting();
		self.loginUser = sessionManagerSvc.getCurrentLoginUser().data;

		$scope.$watch("vm.galleryGridAll", function () {

			if(!self.loginUser && $stateParams.type === 'signature'){
				return;
			}
			if (self.galleryGridAll) {
				extractSearchParam();
				self.galleryGridAll.fetchGalleries({
					type: $stateParams.type,
					page: $state.params.page ? $state.params.page : 1,
					userid: $stateParams.type === 'following' ? self.loginUser.id : null
				}, true).then(function () {
					self.pagerUnit = self.galleryGridAll.galleries.length === 1 ? "Gallery" : "Galleries";
					if ($stateParams.type === 'signature') {
						self.headerName = "signature-galleries";
						self.description = "marketplace-signature-galleries-description";
						self.pagerText = "Pixerfers'";
						self.mobileBreadcrumb = "Pixerfers' Galleries";
					} else if ($stateParams.type === 'pixerf') {
						self.headerName = "pixerfer-galleries";
						self.description = "marketplace-pixerfer-galleries-description";
						self.pagerText = "Pixerfers'";
						self.mobileBreadcrumb = "Pixerfers' Galleries";
					} else {
						self.headerName = "Galleries you followed";
						self.description = "";
						self.mobileBreadcrumb = $stateParams.type + " Galleries";
						self.pagerText = $stateParams.type;
					}
					self.topGalleries = getTopGalleries(self.galleryGridAll.galleries);
					$scope.$parent.vm.totalPage = self.galleryGridAll.totalPage;
				}, function () {

				})
			}
		})

		function extractSearchParam() {
			var arr = [];
			if (!$state.params.type) $state.params.type = galleryConst.GALLERY_TYPE.PIXERF;

			if ($state.params.page) {
				var parsePage = numberUtils.parseInt($state.params.page);
				$state.params.page = parsePage ? parsePage : 1;
			} else {
				$state.params.page = 1;
			}
			$scope.$parent.vm.page = $state.params.page;
		}
		function removeGallery(galleries, gallery) {
			galleries = _.reject(galleries, function (item) {
				return item.id === gallery.id;
			});
			return galleries;
		}
		function getTopGalleries(galleries) {
			var numTopGalleries = Math.min(galleries.length, galleryConst.TOP_PIXERFER_GALLERY);
			return galleries.slice(0, numTopGalleries);
		}
		function onStaredToggled(gallery) {
			if ($stateParams.type === galleryConst.GALLERY_TYPE.PIXERF) {
				if (!gallery.is_starred) {
					if (gallery.star_count <= 0) {
						self.galleryGridAll.galleries = removeGallery(self.galleryGridAll.galleries, gallery);
						self.topGalleries = removeGallery(self.topGalleries, gallery);
					}
				}
			}
		}
		function updateUrlParams(page) {
			if (systemUtils.isMobile()) {
				$state.params.page = "";
				$state.go($state.current.name, $state.params, { notify: false });
				return;
			}
			$scope.$parent.vm.page = page;
			$state.params.page = page;
			$state.go($state.current.name, $state.params, { notify: false });
		}
		function onScrollToGallery(page) {
			updateUrlParams(page);
		}
		function onLoadMorePage(page) {
			updateUrlParams(page);
		}
		function onBackbtnClicked() {
			$state.go("marketplace.galleries");
		}

		function onCurrentPageChanged(pageNumber) {
			route = $state.current;
			$state.go(route, { page: pageNumber });
		}
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('marketplaceGalleriesCtrl', marketplaceGalleriesCtrl);

	marketplaceGalleriesCtrl.$inject = ['sessionManagerSvc', '$state', '$scope'];

	function marketplaceGalleriesCtrl(sessionManagerSvc, $state, $scope) {
		var self = this;
		self.onGalleriesTypeChanged = onGalleriesTypeChanged;
		self.parent = $scope.$parent.vm;
		self.parent.mobileBreadcrumb = "Galleries";
		self.loginUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.closeCreditPlanPopup = closeCreditPlanPopup;
		self.logKey = logKey;
		self.galleriesType = [{
				value: "signature",
				title: "Signature Galleries"
			},
			{
				value: "pixerfer",
				title: "Pixerfer Galleries"
			}
		];

		init();

		function init() {
			if (self.loginUser) {
				self.galleriesType.push({
					value: "followed",
					title: "Galleries you follow"
				});
			}
			if (self.loginUser && self.loginUser.isAdminInternal) {
				self.galleriesType.push({
					value: "curated",
					title: "Curated galleries"
				});
			}
			switch ($state.current.name) {
				case 'marketplace.galleries.followed-galleries':
					generateTemplate('followed');
					break;
				case 'marketplace.galleries.curated-galleries':
					generateTemplate('curated');
					break;
				case 'marketplace.galleries.pixerfer-galleries':
					generateTemplate('pixerfer');
					break;
				default:
					generateTemplate();
			}
		}

		function generateTemplate(value) {
			switch (value) {
				case 'pixerfer':
					self.defaultGalleriesType = self.galleriesType[1].value;
					break;
				case 'followed':
					self.defaultGalleriesType = self.galleriesType[2].value;
					break;
				case 'curated':
					self.defaultGalleriesType = self.galleriesType[3].value;
					break;
				default:
					self.defaultGalleriesType = self.galleriesType[0].value;

			}
			switch (self.defaultGalleriesType) {
				case 'pixerfer':
					self.header = "Pixerfer galleries";
					self.description = "A curated look into our gallery of authentic images from Pixerfers.";
					self.showCreditPlanBar = false;
					break;
				case 'followed':
					self.header = "Galleries you followed";
					self.description = "";
					self.showCreditPlanBar = false;
					break;
				case 'curated':
					self.header = "Curated galleries";
					self.description = "The best of PIXERF, curated by our curating team";
					self.showCreditPlanBar = false;
					break;
				default:
					self.header = "Signature galleries";
					self.description = "Discover the finest selection of Asian stock images in every category and make it yours, starting from $5.<br/>Curated by our in-house photography pros.";
					self.showCreditPlanBar = !self.loginUser || (self.loginUser && self.loginUser.canBuyCreditPlan);
			}
		}

		function onGalleriesTypeChanged(data) {
			self.defaultGalleriesType = data.value;
			generateTemplate(data.value);
			switch (data.value) {
				case 'pixerfer':
					$state.go('marketplace.galleries.pixerfer-galleries');
					break;
				case 'followed':
					$state.go('marketplace.galleries.followed-galleries');
					break;
				case 'curated':
					$state.go('marketplace.galleries.curated-galleries');
					break;
				default:
					$state.go('marketplace.galleries.signature-galleries');
			}
		}

		function closeCreditPlanPopup(){
            $('.collapse').collapse('hide');
        }

        function logKey(e) {
			switch (e.which) {
				case 27:
					closeCreditPlanPopup();
			}
        }
	}
})();

(function () {
  'use strict';

  angular
    .module('pixerf')
    .component('userProfileGalleries', userProfileGalleries);

  function userProfileGalleries() {

    var component = {
      templateUrl: 'app/marketplace/components/marketplace-galleries/marketplace-galleries.html',
      controller: 'galleries1Ctrl',
      controllerAs: 'vm'
    };
    return component;
  }

})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('photosPendingReviewCtrl', photosPendingReviewCtrl);

	photosPendingReviewCtrl.$inject = ['$scope', 'sessionManagerSvc', 'translationSvc', 'toastr', 'photoGridSvc', 'pagingUtils', 'uploadPhotoSvc', '$timeout'];

	function photosPendingReviewCtrl($scope, sessionManagerSvc, translationSvc, toastr, photoGridSvc, pagingUtils, uploadPhotoSvc, $timeout) {
		var self = this;
		var mLoginUser = sessionManagerSvc.getCurrentLoginUser().data;

		$scope.$parent.$parent.$parent.vm.contextPage = "Photos";
		$scope.$parent.vm.contextPage = 'in-review';
		self.spinner = {
			isVisible: false
		};
		self.isLastPage = false;
		self.items = null;
		self.searchParams = {
			page: 1,
			state: ['h'],
			sort: ["inserted_at,desc"],
			more_type: ["portfolio"]
		};
		self.fetchMoreItems = fetchMoreItems;
		self.onMediaDeleted = onMediaDeleted;
		self.onCloseBtnClicked = onCloseBtnClicked;
		self.showUploadModal = showUploadModal;

		(function init() {
			fetchItems(self.searchParams, true);
		})()

		function showUploadModal() {
			onCloseBtnClicked();
			uploadPhotoSvc.showUploadModal();
		}

		function onCloseBtnClicked() {
			$timeout(function () {
				$("#header-navbar-btn").trigger("click");
			});
		}

		function fetchItems(searchParams, isFresh) {
			self.spinner.isVisible = true;
			searchParams.userId = mLoginUser.id;
			photoGridSvc.fetchPhotos(searchParams).then(function (response) {
				if (searchParams.page === 1 || isFresh) self.items = [];
				self.spinner.isVisible = false;
				if (response && response.data && response.data.length > 0) {
					self.items = self.items.concat(response.data);
				}
				self.isLastPage = pagingUtils.isNoMorePageToLoad(searchParams.page, response);

			}, function () {
				self.spinner.isVisible = false;
				toastr.error(translationSvc.FAILED_TO_DO_SOMETHING('FAILED_PENDING_PHOTOS', true));
			})
		}

		function fetchMoreItems() {
			if (self.spinner.isVisible) {
				return;
			}
			self.searchParams.page++;
			fetchItems(self.searchParams);
		}

		function onMediaDeleted(media) {
			var totalPhotosReviewing = parseInt($scope.$parent.vm.numberPhotosReviewing);
			totalPhotosReviewing--;
			$scope.$parent.vm.numberPhotosReviewing = totalPhotosReviewing;
			self.items = _.reject(self.items, function (item) {
				return item.id === media.id;
			});
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('photosRejectedCtrl', photosRejectedCtrl);

	photosRejectedCtrl.$inject = ['$scope', 'sessionManagerSvc', 'translationSvc', 'toastr', 'photoGridSvc', 'pagingUtils', 'uploadPhotoSvc', '$timeout'];

	function photosRejectedCtrl($scope, sessionManagerSvc, translationSvc, toastr, photoGridSvc, pagingUtils, uploadPhotoSvc, $timeout) {
		var self = this;

		self.spinner = {isVisible: false}
		self.fetchMoreItems = fetchMoreItems;
		self.onMediaDeleted = onMediaDeleted;
		self.onSectionClicked = onSectionClicked;
		$scope.$parent.$parent.$parent.vm.contextPage = "Photos";
		$scope.$parent.vm.contextPage = "rejected";
		self.isLastPage = false;
		var mLoginUser = sessionManagerSvc.getCurrentLoginUser().data;

		self.items = null;
		self.searchParams = {
			page: 1,
		};
		self.onCloseBtnClicked = onCloseBtnClicked;
		self.showUploadModal = showUploadModal;

		init();


		function init(){
			fetchItems(self.searchParams, true);
		}

		function showUploadModal(){
			onCloseBtnClicked();
			uploadPhotoSvc.showUploadModal();
		}

		function onCloseBtnClicked(){
			$timeout(function(){
				$("#header-navbar-btn").trigger("click");
            });
		}

		function onSectionClicked(target){
            if(target === self.targetSection){
                self.targetSection = null;
            } else {
                self.targetSection = target;
            }
        }

		function fetchItems(searchParams, isFresh){
			var timeRange = null;
			self.spinner.isVisible = true;
			searchParams.state = ['r'];
			searchParams.userId = mLoginUser.id;
			searchParams.sort = ["inserted_at,desc"];
			searchParams.more_type = ["portfolio"];
			photoGridSvc.fetchPhotos(searchParams).then(function(response){
				if(searchParams.page === 1 || isFresh) self.items = [];
                self.spinner.isVisible = false;
                if(response && response.data && response.data.length > 0){
					self.items = self.items.concat(response.data);
                }
                self.isLastPage = pagingUtils.isNoMorePageToLoad(searchParams.page, response);

			}, function(){
				self.spinner.isVisible = false;
				toastr.error(translationSvc.FAILED_TO_DO_SOMETHING('FAILED_REJECTED_PHOTOS', true));
			})
		}
		function fetchMoreItems(){
			if(self.spinner.isVisible){
                return;
            }
            self.searchParams.page ++;
			fetchItems(self.searchParams);
		}
		function onMediaDeleted(media){
			var totalPhotosRejected = parseInt($scope.$parent.vm.numberPhotosRejected);
			totalPhotosRejected --;
			$scope.$parent.vm.numberPhotosRejected = totalPhotosRejected;
			self.items = _.reject(self.items, function(item){
				return item.id === media.id;
			});
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('photosApprovedCtrl', photosApprovedCtrl);

	photosApprovedCtrl.$inject = ['$scope', 'sessionManagerSvc', 'pixerfApiUserSvc', 'pagingUtils', 'systemUtils', '$state', 'moment', '$q'];

	function photosApprovedCtrl($scope, sessionManagerSvc, pixerfApiUserSvc, pagingUtils, systemUtils, $state, moment, $q) {

		var self = this;
		$scope.$parent.$parent.$parent.vm.contextPage = "Photos";
		$scope.$parent.vm.contextPage = "approved";
		self.spinner = {
			isVisible: false
		};
		self.onFilteredClicked = onFilteredClicked;
		self.user = sessionManagerSvc.getCurrentLoginUser().data;
		self.items = [];
		self.searchParams = {
			page: 1,
			userId: self.user.id,
			sort: ["inserted_at,desc"],
			more_type: ["portfolio"]
		};
		self.bidingItems = [];
		self.groupPhotosByMonth = [];
		self.photoGrid = null;
		self.fetchPhotos = fetchPhotos;
		self.fetchMorePhotos = fetchMorePhotos;
		self.gridSort = "popularity";
		self.previousItem = {};

		init();

		function init() {
			self.filterSetting = {
				"items": [{
						name: "Popularity",
						value: "popularity"
					},
					{
						name: "Upload date",
						value: "freshness"
					}
				]
			};
			fetchPhotos(self.searchParams, true);
		}

		function fetchPhotos(searchParams, isFresh) {
			if (self.spinner.isVisible && self.isWorking) return;
			self.searchParams = searchParams;
			self.spinner.isVisible = true;
			self.isWorking = true;
			self.isFresh = isFresh
			var urlParams = {
				id: searchParams.userId,
				page: searchParams.page
			}
			if (self.gridSort === "freshness") {
				groupPhotoByMonth(searchParams, urlParams, isFresh);
			} else {
				pixerfApiUserSvc.get_medias(urlParams, searchParams).$promise.then(function (response) {
					self.bidingItems = self.bidingItems.concat(response.data);
					self.isLastPage = pagingUtils.isNoMorePageToLoad(searchParams.page, response);
					self.totalPhotos = pagingUtils.getTotalCount(response);
					self.totalPage = pagingUtils.getTotalPage(response);
					self.isWorking = false;
					self.spinner.isVisible = false;
				}).catch(function () {
					self.isWorking = false;
					self.spinner.isVisible = false;
				})
			}
		}

		function fetchMorePhotos() {
			if (self.spinner.isVisible && self.isWorking) {
				return;
			}
			self.searchParams.page++;
			fetchPhotos(self.searchParams);
		}

		function onFilteredClicked(selectedFilterItem) {
			self.items = [];
			self.bidingItems = [];
			updateUrlParams(1, selectedFilterItem.value);
			self.gridSort = selectedFilterItem.value;
			self.searchParams.page = 1;
			self.searchParams.sort = self.gridSort
			fetchPhotos(self.searchParams, true)
		}

		function updateUrlParams(page, order) {
			$state.params.page = page;
			$state.params.order = order;
			$state.go($state.current.name, $state.params, {
				notify: false
			});
		}

		function groupPhotoByMonth(searchParams, urlParams, isFresh) {
			pixerfApiUserSvc.get_medias(urlParams, searchParams).$promise.then(function (response) {
				if (searchParams.page === 1) {
					self.items = [];
				}
				if (response && response.data && response.data.length > 0) {
					self.items = self.items.concat(response.data);
					var groupedByMonth = _.groupBy(response.data, function (item) {
						return item.inserted_at.substring(0, 7);
					});
					for (var obj in groupedByMonth) {
						var formatObjDate = moment(obj).format('MMMM') + ' ' + moment(obj).format('YYYY');
						var isExistInGroup = _.findIndex(self.bidingItems, function (item) {
							return item.title === formatObjDate;
						});

						if (isExistInGroup > -1) {
							self.bidingItems[isExistInGroup].data = self.bidingItems[isExistInGroup].data.concat(groupedByMonth[obj]);
						} else {
							self.bidingItems.push({
								title: formatObjDate,
								data: groupedByMonth[obj],
								collapse: moment(obj).format('MMM') + '-' + moment(obj).format('YY')
							})
						}
					}
				}
				self.isWorking = false;
				self.spinner.isVisible = false;
				self.isLastPage = pagingUtils.isNoMorePageToLoad(searchParams.page, response);
				self.totalPhotos = pagingUtils.getTotalCount(response);
				self.totalPage = pagingUtils.getTotalPage(response);
			})
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('managePhotosSoldCtrl', managePhotosSoldCtrl);

	managePhotosSoldCtrl.$inject = ['$scope', 'pixerfApiSalesSvc', 'toastr', 'pagingUtils', 'earningsSvc', 'dateUtils'];

	function managePhotosSoldCtrl($scope, pixerfApiSalesSvc, toastr, pagingUtils, earningsSvc, dateUtils) {
		var self = this;

		self.spinner = {isVisible: false}
		self.fetchMoreSoldItems = fetchMoreSoldItems;

		self.isLastPage = false;

		self.items = null;
		self.earnings = null;
		self.today = dateUtils.now("D MMM YYYY");
		$scope.$parent.vm.contextPage = "Photos sold";
		init();

		function init(){
			self.searchParams = {
				page: 1,
				start_date: null,
				end_date: null
			};
			fetchSoldItems(self.searchParams, true);
			fetchEarnings();
		}
		function fetchEarnings(){
            earningsSvc.fetchEarnings().then(function(response){
                self.earnings = response;
            })
        }
		function fetchSoldItems(searchParams, isFresh){
			var timeRange = null;
			self.spinner.isVisible = true;
			pixerfApiSalesSvc.post(searchParams).$promise.then(function(response){
				if(searchParams.page === 1 || isFresh) self.items = [];
                self.spinner.isVisible = false;
                if(response && response.data && response.data.length > 0){
					self.items = self.items.concat(response.data);
                }
                self.isLastPage = pagingUtils.isNoMorePageToLoad(searchParams.page, response);

			}, function(){
				self.spinner.isVisible = false;
				toastr.error('Failed to get purchases items. Please try again.');
			})
		}
		function fetchMoreSoldItems(){
			 if(self.spinner.isVisible){
                return;
            }
            self.searchParams.page ++;
			fetchSoldItems(self.searchParams);
		}
	}
})();

(function () {
	'use strict';

	angular
	.module('pixerf')
	.config(routerDefaultConfig)
	.config(routerConfig);

	routerDefaultConfig.$inject = ['$urlRouterProvider'];

	function routerDefaultConfig($urlRouterProvider) {
		'ngInject';
		$urlRouterProvider.when("/manage-photos/photos-sold", "/manage-photos/photos-sold/sold-list");
	}

	routerConfig.$inject = ['$stateProvider'];

	function routerConfig($stateProvider) {
	  'ngInject';
	  $stateProvider
		.state('manage-photos.manage-photos-sold', {
			url: '/manage-photos/photos-sold',
			templateUrl: 'app/manage-photos/components/manage-photos-sold/manage-photos-sold.html',
			controller: 'managePhotosSoldCtrl',
			controllerAs: 'vm',
			data: {
				pageTitle: "PIXERF - Photos Sold"
			}
		})
		.state('manage-photos.manage-photos-sold.sold-list', {
			url: '/sold-list',
			templateUrl: 'app/manage-photos/components/manage-photos-sold/manage-photos-sold-list/manage-photos-sold-list.html',
			controller: 'managePhotosSoldListCtrl',
			controllerAs: 'vm',
			data: {
				pageTitle: "PIXERF - Photos Sold"
			}
		})
		.state('manage-photos.manage-photos-sold.sold-details', {
			url: '/sold-details/:orderId',
			templateUrl: 'app/manage-photos/components/manage-photos-sold/manage-photos-sold-details/manage-photos-sold-details.html',
			controller: 'managePhotosSoldDetailsCtrl',
			controllerAs: 'vm',
			data: {
				pageTitle: "PIXERF - Photos Sold Details"
			}
		});
	}
  })();

(function () {

	angular
		.module('pixerf')
		.controller('listMissionsDraftCtrl', listMissionsDraftCtrl);

	listMissionsDraftCtrl.$inject = ["pixerfApiMissionSvc", "toastr", "pagingUtils", "$scope", "sessionManagerSvc"];

	function listMissionsDraftCtrl(pixerfApiMissionSvc, toastr, pagingUtils, $scope, sessionManagerSvc) {
		var self = this;
		$scope.$parent.vm.contextPage = "Unpublished Missions";
		$scope.$parent.vm.subContextPage = "Unpublished Missions";
		self.loginedUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.onMissionDeleted = onMissionDeleted;
		self.spinner = { isVisible: false }
		self.fetchMoreItems = fetchMoreItems;
		self.onFilterSelected = onFilterSelected;
		self.isLastPage = false;
		self.items = null;
		self.searchParams = {
			page: 1,
			page_size: 20
		};

		self.filterSetting = {
			"items": [
				{ "name": "All", "value": "not_launched" },
				{ "name": "Draft", "value": "draft" },
				{ "name": "In Review", "value": "pending_approval" },
				{ "name": "Action Required", "value": "to_revise" },
				{ "name": "Rejected", "value": "rejected" },
				{ "name": "Approved", "value": "pending_payment" },
				{ "name": "Ready to Launch", "value": "ready_to_launch" }
			]
		};

		if(self.loginedUser.isMaketerInternal){
			self.filterSetting.items = self.filterSetting.items.filter(function(inputs){
				console.log(inputs);
				return inputs.value !== 'draft'});
		}

		init();

		function init() {
			fetchItems(self.searchParams, true, true);
		}

		function fetchItems(searchParams, isFresh, firstTime) {
			self.spinner.isVisible = true;
			searchParams.type = searchParams.type ? searchParams.type : 'not_launched';
			searchParams.sort = ["inserted_at,desc"];
			pixerfApiMissionSvc.get_manage_mission(searchParams).$promise.then(function (response) {
				if (searchParams.page === 1 || isFresh) self.items = [];
				self.spinner.isVisible = false;
				if (response && response.data && response.data.missions && response.data.missions.length > 0) {
					self.items = self.items.concat(response.data.missions);
				}
				if(firstTime && !self.items.length){
					self.noUnpublishedMission = true;
				}
				self.isLastPage = pagingUtils.isNoMorePageToLoad(searchParams.page, response);

			}, function () {
				self.spinner.isVisible = false;
				toastr.error('Failed to get missions!');
			})
		}
		function fetchMoreItems() {
			if (self.spinner.isVisible) {
				return;
			}
			self.searchParams.page++;
			fetchItems(self.searchParams);
		}

		function onMissionDeleted(mission) {
			self.items = _.reject(self.items, function (item) {
				return item.id === mission.id;
			})
		}

		function onFilterSelected(searchType) {
			self.items = [];
			self.searchParams.type = searchType;
			self.searchParams.page = 1;
			fetchItems({ type: searchType }, true);
		}
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('createMissionStepVisualInspirationCtrl', createMissionStepVisualInspirationCtrl);

	createMissionStepVisualInspirationCtrl.$inject = ['missionData', '$scope', 'createMissionSvc', 'stringUtils'];

	function createMissionStepVisualInspirationCtrl(missionData, $scope, createMissionSvc, stringUtils) {
		var self = this;
		self.isWorking = false;
		self.createMissionCtrl = $scope.$parent.vm;
		self.artDirectionEditorOptions = createMissionSvc.getMissionArtDirectionEditorConfiguraion();
		self.artDirectionEditorOptions.onContentChanged = function (editor, html, text, delta, oldDelta, source) {
			self.descriptionLength = html ? text.length - 1 : 0;
		}

		self.mission = missionData;
		self.numProcessingFile = 0;

		init();

		function init(){
			if(self.mission.art_direction){
				self.descriptionLength = stringUtils.htmlToPlaintext(self.mission.art_direction).length;
			}
		}

	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('createMissionStepSponsorOptionsCtrl', createMissionStepSponsorOptionsCtrl);

	createMissionStepSponsorOptionsCtrl.$inject = ['missionData', '$scope', 'pixerfUrl', 'sessionManagerSvc', 'imageUtils', 'systemUtils', 'toastr', 'messageConst', 'uploadPhotoSvc', 'pathUtils'];

	function createMissionStepSponsorOptionsCtrl(missionData, $scope, pixerfUrl, sessionManagerSvc, imageUtils, systemUtils, toastr, messageConst, uploadPhotoSvc, pathUtils) {
		var self = this;
		self.isWorking = false;
		self.createMissionCtrl = $scope.$parent.vm;
		self.mission = missionData;
		
		self.onCheckboxChanged = onCheckboxChanged;

		init();
		
		function init(){
			self.mission.noSponsor = !self.mission.sponsor;
		}
		function onCheckboxChanged(){
			if(self.mission.noSponsor){
				self.mission.sponsor = null;
			}
		}
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('createMissionStepSponsorCtrl', createMissionStepSponsorCtrl);

	createMissionStepSponsorCtrl.$inject = ['missionData', '$scope', 'pixerfUrl', 'sessionManagerSvc', 'imageUtils', 'systemUtils', 'toastr', 'messageConst', 'uploadPhotoSvc', 'pathUtils'];

	function createMissionStepSponsorCtrl(missionData, $scope, pixerfUrl, sessionManagerSvc, imageUtils, systemUtils, toastr, messageConst, uploadPhotoSvc, pathUtils) {
		var self = this;
		self.isWorking = false;
		self.createMissionCtrl = $scope.$parent.vm;
		self.mission = missionData;

		init();
		
		function init(){
			if(!self.mission.sponsor) self.mission.sponsor = {};
		}
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('createMissionStepSpecificationOneCtrl', createMissionStepSpecificationOneCtrl);

	createMissionStepSpecificationOneCtrl.$inject = ['$scope', 'manageMissionsSvc', 'createMissionSvc', 'missionData', '$state'];

	function createMissionStepSpecificationOneCtrl($scope, manageMissionsSvc, createMissionSvc, missionData, $state) {
		var self = this;
		self.createMissionCtrl = $scope.$parent.vm;
		self.mission = missionData;
		self.specifications = buildSpecifications()
		function buildSpecifications(){
			var allowOptions = ["lighting", "output", "space_for_copy"];
			var options = createMissionSvc.getMissionSpecifications();
			return _.reject(options, function(spec){
				return allowOptions.indexOf(spec.value) === -1;
			})
		}
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('createMissionStepSpecificationCtrl', createMissionStepSpecificationCtrl);

	createMissionStepSpecificationCtrl.$inject = ['$scope', 'manageMissionsSvc', 'createMissionSvc', 'missionData'];

	function createMissionStepSpecificationCtrl($scope, manageMissionsSvc, createMissionSvc, missionData) {
		var self = this;
		self.mission = missionData;
		self.createMissionCtrl = $scope.$parent.vm;
		self.specifications = buildSpecifications()
		function buildSpecifications(){
			var allowOptions = ["license_usage", "orientation", "environment"];
			var options = createMissionSvc.getMissionSpecifications();
			return _.reject(options, function(spec){
				return allowOptions.indexOf(spec.value) === -1;
			})
		}
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('createMissionStepRewardCtrl', createMissionStepRewardCtrl);

	createMissionStepRewardCtrl.$inject = ['missionData', '$scope', 'createMissionSvc', 'sessionManagerSvc', 'badgeUtils', '$translate'];

	function createMissionStepRewardCtrl(missionData, $scope, createMissionSvc, sessionManagerSvc, badgeUtils, $translate) {
		var self = this;
		self.isWorking = false;

		self.createMissionCtrl = $scope.$parent.vm;
		self.loginUser = sessionManagerSvc.getCurrentLoginUser().data;

		self.validateMission = validateMission;
		self.onRewardChanged = onRewardChanged;
		self.prizeRuleSet = createMissionSvc.getPrizeRuleSet();


		self.mission = missionData;


		init();


		function buildPrize(){
			var prizes_grouped = badgeUtils.compactPrizes(self.mission.prizes);
			if(prizes_grouped["WINNER"].value == 0){
				prizes_grouped["WINNER"].value = self.prizeRuleSet[self.mission.price.name]["WINNER"].value.min;
			}
			return prizes_grouped;
		}
		function init(){
			self.mission.prizes_grouped = buildPrize();
			onRewardChanged();
		}

		function validateMission(mission) {
			var errMsg = '';
			if (!mission.duration) {
				errMsg = $translate.instant("please-input-duration");
			} else if (mission.duration < 1) {
				errMsg = $translate.instant("please-key-in-whole-number");
			} else if (isNaN(mission.duration) || mission.duration < 1) {
				errMsg = $translate.instant("please-key-in-whole-number");
			} else if (!self.mission.data.prizes || !self.mission.data.prizes.length) {
				errMsg = $translate.instant("please-input-number-winners");
			}
			return errMsg;
		}


		function onRewardChanged() {
			if(!self.mission.bill) self.mission.bill = {};
			if(self.mission.prizes_grouped["WINNER"].quantity > 10000 || (self.mission.prizes_grouped["CONSOLATION"] && self.mission.prizes_grouped["CONSOLATION"].quantity > 10000)) return;
			self.mission.prizes_grouped["WINNER"].total = self.mission.prizes_grouped["WINNER"].value * self.mission.prizes_grouped["WINNER"].quantity;
			if(self.mission.prizes_grouped["CONSOLATION"]){
				self.mission.prizes_grouped["CONSOLATION"].total = self.mission.prizes_grouped["CONSOLATION"].value * self.mission.prizes_grouped["CONSOLATION"].quantity;
				self.mission.prizes_grouped.totalReward = self.mission.prizes_grouped["WINNER"].total + self.mission.prizes_grouped["CONSOLATION"].total;
			} else {
				self.mission.prizes_grouped.totalReward = self.mission.prizes_grouped["WINNER"].total;
			}
			self.mission.bill.totalToPay = self.mission.price.service_fee ? self.mission.prizes_grouped.totalReward + parseFloat(self.mission.price.service_fee)  : self.mission.prizes_grouped.totalReward;
			self.mission.prizes = badgeUtils.extractPrizes(self.mission.prizes_grouped);
		}
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('createMissionStepReviewCtrl', createMissionStepReviewCtrl);

	createMissionStepReviewCtrl.$inject = ['manageMissionsSvc', 'missionData', 'missionPreviewSvc', '$scope', 'pixerfApiMissionSvc', 'toastr', '$state', 'createMissionSvc', 'messageConst', 'pixerfConfirmPopupSvc', 'sessionManagerSvc'];

	function createMissionStepReviewCtrl(manageMissionsSvc, missionData, missionPreviewSvc, $scope, pixerfApiMissionSvc, toastr, $state, createMissionSvc, messageConst, pixerfConfirmPopupSvc, sessionManagerSvc) {
		var self = this;
		var mCreateMissionCtrl = $scope.$parent.vm;
		self.isWorking = false;
		self.loginUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.isMine = sessionManagerSvc.isMine(self.loginUser);
		self.mission = missionData;
		mCreateMissionCtrl.navigationBtnStatus.back = false;
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('createMissionStepGettingStartedCtrl', createMissionStepGettingStartedCtrl);

	createMissionStepGettingStartedCtrl.$inject = ['$scope', 'manageMissionsSvc', 'createMissionSvc', 'missionData', '$timeout', 'ISO3166'];

	function createMissionStepGettingStartedCtrl($scope, manageMissionsSvc, createMissionSvc, missionData, $timeout, ISO3166) {
		var self = this;
		self.createMissionCtrl = $scope.$parent.vm;
		self.mission = missionData;
		self.selectedPrices = [self.mission.price];
		self.onMissionDurationSelected = onMissionDurationSelected;
		self.onCountriesSelected = onCountriesSelected;
		self.maxCountries = 3;
		self.countriesOpts = {
			"maxOptions": self.maxCountries,
			'noneSelectedText': 'All Countries',
			"container": "body",
			"customAll": true,
			"dropupAuto": false,
			"maxOptionsText": "Please select up to a maximum of " + self.maxCountries + " countries",
		};
		self.durationOpts = {
			'maxOptions': 1,
			'noneSelectedText': ''
		};

		init();

		function onMissionDurationSelected(selectedItems){
			self.mission.price = self.selectedPrices[0];
		}

		function onCountriesSelected(countriesSelected){
			if(!self.selectedCountries || !self.selectedCountries.length){
				delete self.mission.countries;
				self.selectedCountries = [{id: 'all', name: 'All Countries'}];
			} else {
				self.mission.countries = _.pluck(self.selectedCountries, 'id');
			}
		}

		function buildCountries(){
            var arr = [{id: 'all', name: 'All Countries'}];
            for (var key in ISO3166.codeToCountry){
                arr.push({
                    id: key,
                    name: ISO3166.codeToCountry[key]
                })
            }
            return arr;
        }

		function init(){
			self.countries = buildCountries();
			if(self.mission && (!Array.isArray(self.mission.countries) || !self.mission.countries.length)){
				delete self.mission.countries;
				self.selectedCountries = [{id: 'all', name: 'All Countries'}];
			} else if (self.mission) {
				self.selectedCountries = self.countries.filter(function(obj){
					return self.mission.countries.includes(obj.id);
				});
			}
		}

	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('createMissionStepBriefCtrl', createMissionStepBriefCtrl);

	createMissionStepBriefCtrl.$inject = ['missionData', '$scope', 'createMissionSvc', 'stringUtils'];

	function createMissionStepBriefCtrl(missionData, $scope, createMissionSvc, stringUtils) {
		var self = this;
		self.isWorking = false;
		self.createMissionCtrl = $scope.$parent.vm;
		self.briefEditorOptions = createMissionSvc.getMissionBriefEditorConfiguration();
		self.briefEditorOptions.onContentChanged = function (editor, html, text, delta, oldDelta, source) {
			self.briefLength = html ? text.length - 1 : 0;
		}
		self.mission = missionData;

		init();

		function init(){
			if(self.mission.description){
				self.briefLength = stringUtils.htmlToPlaintext(self.mission.description).length;
			}
		}
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('manageDetailCommunityUnpublishedDiscussionsCtrl', manageDetailCommunityUnpublishedDiscussionsCtrl);

	manageDetailCommunityUnpublishedDiscussionsCtrl.$inject = ['$scope', 'communityData'];

	function manageDetailCommunityUnpublishedDiscussionsCtrl($scope, communityData) {
		var self = this;
		self.parent = $scope.$parent.vm;
		self.community = communityData;
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('manageDetailCommunityRequestedMembersCtrl', manageDetailCommunityRequestedMembersCtrl);

	manageDetailCommunityRequestedMembersCtrl.$inject = ['$scope', 'communityData'];

	function manageDetailCommunityRequestedMembersCtrl($scope, communityData) {
		var self = this;
		self.parent = $scope.$parent.vm;
		self.community = communityData;
		self.onMemberGridInit = onMemberGridInit;
		self.parent.contextPage = "requested";
		self.onSearchStringChanged = _.debounce(onSearchStringChanged, 300);

		function onMemberGridInit(instance) {
			self.memberGrid = instance;
			self.isEmptyList = !self.memberGrid.peoples || !self.memberGrid.peoples.length;
		}

		function onSearchStringChanged() {
			var searchParams = {
				id: self.community.id,
				membership: 'requested',
				page: 1
			}
			if (self.searchString) {
				searchParams.keywords = self.searchString
			} else {
				delete searchParams.keywords;
			}
			self.memberGrid.fetch(searchParams, true);
		}
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('manageDetailCommunityPendingDiscussionsCtrl', manageDetailCommunityPendingDiscussionsCtrl);

	manageDetailCommunityPendingDiscussionsCtrl.$inject = ['$scope', 'communityData', 'pixerfApiCommunityDiscussionSvc', 'pagingUtils'];

	function manageDetailCommunityPendingDiscussionsCtrl($scope, communityData, pixerfApiCommunityDiscussionSvc, pagingUtils) {
		var self = this;
		self.parent = $scope.$parent.vm;
		self.community = communityData;
		self.totalPendingDiscussions = 0;
		self.discussions = [];
		self.fetchMorePendingDiscussions = fetchMorePendingDiscussions;
		self.getListPendingDiscussions = getListPendingDiscussions;
		self.onStatusChanged = onStatusChanged;
		self.spinner = {
			isVisible: false
		}
		self.isWorking = false;
		self.searchParams = {
			page: 1
		}

		init();

		function init() {
			self.totalPendingDiscussions = self.community.stats ? self.community.stats.pending_discussions : 0;
			getListPendingDiscussions(self.searchParams, true);
		}

		function getListPendingDiscussions(params, isFresh) {
			self.searchParams = params;
			self.spinner.isVisible = true;
			self.isWorking = true;
			pixerfApiCommunityDiscussionSvc.get_list_pending({
				id: self.community.id
			}).$promise.then(function (respone) {
				if (!self.discussions || isFresh) self.discussions = [];
				self.discussions = self.discussions.concat(respone.data);
				self.isLastPage = pagingUtils.isNoMorePageToLoad(self.searchParams.page, respone);
				self.spinner.isVisible = false;
				self.searchParams.page = params.page;
				self.isWorking = false;
			}).catch(function (err) {
				self.isWorking = false;
				self.spinner.isVisible = false;
				console.log(err);
			})
		}

		function fetchMorePendingDiscussions() {
			if (self.isLastPage || self.spinner.isVisible) return;
			var searchParms = $.extend(true, {}, self.searchParams);
			searchParms.page++;
			getListPendingDiscussions(searchParms);
		}

		function onStatusChanged(discussion) {
			self.totalPendingDiscussions--;
			removeDiscussionFromList(discussion);
		}

		function removeDiscussionFromList(discussion) {
			self.discussions = _.reject(self.discussions, function (ele) {
				return ele.id === discussion.id;
			});
		}
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('manageDetailCommunityMembersCtrl', manageDetailCommunityMembersCtrl);

	manageDetailCommunityMembersCtrl.$inject = ['$scope', 'communityData', 'pixerfApiCommunitySvc', 'toastr', 'commonConst', 'pixerfConfirmPopupSvc', '$state', 'createCommunitySvc', 'systemUtils', 'sessionManagerSvc', 'translationSvc', '$timeout'];

	function manageDetailCommunityMembersCtrl($scope, communityData, pixerfApiCommunitySvc, toastr, commonConst, pixerfConfirmPopupSvc, $state, createCommunitySvc, systemUtils, sessionManagerSvc, translationSvc, $timeout) {
		var self = this;

		self.loginUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.communityDetailControler = $scope.$parent.vm;
		self.communityDetailControler.contextPage = "community-details";
		self.community = communityData;
		self.commonConst = commonConst;
		self.orginialData = {};
		self.onMemberGridInit = onMemberGridInit;
		self.cancelBtnClicked = cancelBtnClicked;
		self.saveBtnClicked = saveBtnClicked;
		self.deleteBtnClicked = deleteBtnClicked;
		self.createCommunityForm = {};
		self.createCommunityFormOptions = {
			hideAvatar: true
		}
		init();

		function init() {
			backup();
			if(!self.community.cover){
				self.community.cover = {canEdit: true};
			}
			self.community.cover.canEdit = true;
			self.communityDetailControler.uploadCommunityAvatarOptions = createCommunitySvc.getUploadCommunityAvatarOptions(self.community, {
				onSuccess: function (response) {
					self.communityDetailControler.communityAvatar.url = "";
					$timeout(function () {
						self.communityDetailControler.communityAvatar.url = response.thumbnail;
					}, 500);
					systemUtils.digest($scope);
				}
			});
		}

		function onMemberGridInit(instance) {
			self.memberGrid = instance;
		}

		function backup() {
			self.orginialData.name = self.community.name;
			self.orginialData.description = self.community.description;
			self.orginialData.is_private = self.community.is_private;
			self.orginialData.is_unlisted = self.community.is_unlisted;
		}

		function restore() {
			self.community.name = self.orginialData.name;
			self.community.description = self.orginialData.description;
			self.community.is_private = self.orginialData.is_private;
			self.community.is_unlisted = self.orginialData.is_unlisted;
		}

		function saveBtnClicked(community) {
			if (community.cover) {
				delete community.cover;
			}
			var errMsg = createCommunitySvc.validate(community);
			if (errMsg) {
				toastr.error(errMsg);
				return;
			}
			pixerfApiCommunitySvc.update({
				id: community.id
			}, community).$promise.then(function (response) {
				toastr.success(translationSvc.SOMETHING_HAS_BEEN_DONE("THIS_COMMUNITY", "SUCCESSFULLY_UPDATED") + "!");
				backup();
				$state.go(commonConst.STATE.MANAGE_COMMUNITIES);
			}, function (err) {
				var errMessage = translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true);
				if(err && err.data && err.data.data && err.data.data.key == 'community_privacy_change'){
					errMessage = err.data.data.message;
				}
				toastr.error(errMessage);
			})
		}

		function cancelBtnClicked() {
			restore();
			window.history.go(-1);
		}

		function deleteBtnClicked(community) {
			if (self.isWorking) return;
			var confirmMessage = translationSvc.ARE_YOU_SURE_TO_DO_SOMETHING("DELETE_THIS_COMMUNITY");
			var modal = pixerfConfirmPopupSvc.showPopup({
				hideTitle: true,
				hideConfirmText: true,
				message: confirmMessage
			});
			modal.result.then(function () {
				self.isWorking = true;
				pixerfApiCommunitySvc.delete({
					id: community.id
				}).$promise.then(function (response) {
					toastr.success(translationSvc.SOMETHING_HAS_BEEN_DONE("THIS_COMMUNITY", "SUCCESSFULLY_DELETED") + "!");
					$state.go("user-home-page." + self.loginUser.account_type + ".communities.grid");
					self.isWorking = false;
				}, function (err) {
					$state.go("user-home-page." + self.loginUser.account_type + ".communities.grid");
					self.isWorking = false;
					toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
				});
			})
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.config(routerConfig);

	routerConfig.$inject = ['$stateProvider'];

	function routerConfig($stateProvider) {
		'ngInject';
		$stateProvider
			.state('manage-detail-community.manage-detail-community-members', {
				url: '/community-manage-members',
				templateUrl: 'app/manage-detail-community-page/components/manage-detail-community-members/manage-detail-community-members.html',
				controller: 'manageDetailCommunityMembersCtrl',
				controllerAs: 'vm',
				abstract: true
			})
			.state('manage-detail-community.manage-detail-community-members.manage-detail-community-invited-members', {
				url: '/invited-members',
				templateUrl: 'app/manage-detail-community-page/components/manage-detail-community-invited-members/manage-detail-community-invited-members.html',
				controller: 'manageDetailCommunityInvitedMembersCtrl',
				controllerAs: 'vm',
			})
			.state('manage-detail-community.manage-detail-community-members.manage-detail-community-requested-members', {
				url: '/requested-members',
				templateUrl: 'app/manage-detail-community-page/components/manage-detail-community-requested-members/manage-detail-community-requested-members.html',
				controller: 'manageDetailCommunityRequestedMembersCtrl',
				controllerAs: 'vm',
			})
			.state('manage-detail-community.manage-detail-community-members.manage-detail-community-current-members', {
				url: '/current-members',
				templateUrl: 'app/manage-detail-community-page/components/manage-detail-community-current-members/manage-detail-community-current-members.html',
				controller: 'manageDetailCommunityCurrentMembersCtrl',
				controllerAs: 'vm',
			})
			.state('manage-detail-community.manage-detail-community-members.manage-detail-community-blocked-members', {
				url: '/blocked-members',
				templateUrl: 'app/manage-detail-community-page/components/manage-detail-community-blocked-members/manage-detail-community-blocked-members.html',
				controller: 'manageDetailCommunityBlockedMembersCtrl',
				controllerAs: 'vm',
			});
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('manageDetailCommunityInvitedMembersCtrl', manageDetailCommunityInvitedMembersCtrl);

	manageDetailCommunityInvitedMembersCtrl.$inject = ['$scope', 'communityData', 'sessionManagerSvc'];

	function manageDetailCommunityInvitedMembersCtrl($scope, communityData, sessionManagerSvc) {
		var self = this;
		self.community = communityData;
		$scope.$parent.vm.contextPage = "invited";
		$scope.$parent.$parent.vm.memberGrid = {};
		self.onMemberGridInit = onMemberGridInit;
		self.loginUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.onSearchStringChanged = _.debounce(onSearchStringChanged, 300);

		function onMemberGridInit(instance) {
			$scope.$parent.$parent.vm.memberGrid = instance;
			self.totalCount = self.community.invited_count;
			self.isEmptyList = !$scope.$parent.$parent.vm.memberGrid.peoples || !$scope.$parent.$parent.vm.memberGrid.peoples.length;
		}
		self.searchFilterOptions = {
			parentClass: ".community-detail-page-manage-invited-member"
		}

		function onSearchStringChanged() {
			var searchParams = {
				id: self.community.id,
				membership: 'invited',
				page: 1
			}
			if (self.searchString) {
				searchParams.keywords = self.searchString
			} else {
				delete searchParams.keywords;
			}
			$scope.$parent.$parent.vm.memberGrid.fetch(searchParams, true);
		}
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('manageDetailCommunityDiscussionsCtrl', manageDetailCommunityDiscussionsCtrl);

	manageDetailCommunityDiscussionsCtrl.$inject = ['$scope', 'communityData', 'sessionManagerSvc', 'commonConst'];

	function manageDetailCommunityDiscussionsCtrl($scope, communityData, sessionManagerSvc, commonConst) {
		var self = this;

		self.loginUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.communityDetailControler = $scope.$parent.vm;
        self.communityDetailControler.contextPage = "community-details";
		self.community = communityData;
		self.commonConst = commonConst;
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.config(routerConfig);

	routerConfig.$inject = ['$stateProvider'];

	function routerConfig($stateProvider) {
		'ngInject';
		$stateProvider
			.state('manage-detail-community.manage-detail-community-discussions', {
				url: '/community-manage-discussions',
				templateUrl: 'app/manage-detail-community-page/components/manage-detail-community-discussions/manage-detail-community-discussions.html',
				controller: 'manageDetailCommunityDiscussionsCtrl',
				controllerAs: 'vm',
				abstract: true
			})
			.state('manage-detail-community.manage-detail-community-discussions.manage-detail-community-pending-discussions', {
				url: '/pending-discussions',
				templateUrl: 'app/manage-detail-community-page/components/manage-detail-community-pending-discussions/manage-detail-community-pending-discussions.html',
				controller: 'manageDetailCommunityPendingDiscussionsCtrl',
				controllerAs: 'vm',
			})
			.state('manage-detail-community.manage-detail-community-discussions.manage-detail-community-unpublished-discussions', {
				url: '/unpublished-discussion',
				templateUrl: 'app/manage-detail-community-page/components/manage-detail-community-unpublished-discussions/manage-detail-community-unpublished-discussions.html',
				controller: 'manageDetailCommunityUnpublishedDiscussionsCtrl',
				controllerAs: 'vm',
			})
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('manageDetailCommunityCurrentMembersCtrl', manageDetailCommunityCurrentMembersCtrl);

	manageDetailCommunityCurrentMembersCtrl.$inject = ["$scope"];

	function manageDetailCommunityCurrentMembersCtrl($scope) {
		var self = this;
		self.parent = $scope.$parent.vm;
		self.onMemberGridInit = onMemberGridInit;
		self.communityDetailOptions = {
			scrollToPaging: true
		}

		function onMemberGridInit(instance) {
			self.memberGrid = instance;
		}
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('manageDetailCommunityBriefCtrl', manageDetailCommunityBriefCtrl);

	manageDetailCommunityBriefCtrl.$inject = ['$scope', 'communityData', 'pixerfApiCommunitySvc', 'toastr', 'commonConst', 'confirmPopupSvc', '$state', 'createCommunitySvc', 'systemUtils', 'sessionManagerSvc', 'translationSvc', '$timeout', '$q', '$translate'];

	function manageDetailCommunityBriefCtrl($scope, communityData, pixerfApiCommunitySvc, toastr, commonConst, confirmPopupSvc, $state, createCommunitySvc, systemUtils, sessionManagerSvc, translationSvc, $timeout, $q, $translate) {
		var self = this;

		self.loginUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.communityDetailControler = $scope.$parent.vm;
		self.communityDetailControler.contextPage = "community-details";
		self.community = communityData;
		self.orginialData = {};
		self.onMemberGridInit = onMemberGridInit;
		self.cancelBtnClicked = cancelBtnClicked;
		self.saveBtnClicked = saveBtnClicked;
		self.deleteBtnClicked = deleteBtnClicked;
		self.createCommunityForm = {};
		self.createCommunityFormOptions = {
			hideAvatar: true
		}
		init();

		function init() {
			backup();
			self.community.cover.canEdit = true;
			self.communityDetailControler.uploadCommunityAvatarOptions = createCommunitySvc.getUploadCommunityAvatarOptions(self.community, {
				onSuccess: function (response) {
					self.communityDetailControler.communityAvatar.url = "";
					$timeout(function () {
						self.communityDetailControler.communityAvatar.url = response.thumbnail;
					}, 500);
					systemUtils.digest($scope);
				}
			});
		}

		function onMemberGridInit(instance) {
			self.memberGrid = instance;
		}

		function backup() {
			self.orginialData.name = self.community.name;
			self.orginialData.description = self.community.description;
			self.orginialData.is_private = self.community.is_private;
			self.orginialData.is_unlisted = self.community.is_unlisted;
		}

		function restore() {
			self.community.name = self.orginialData.name;
			self.community.description = self.orginialData.description;
			self.community.is_private = self.orginialData.is_private;
			self.community.is_unlisted = self.orginialData.is_unlisted;
		}

		function saveBtnClicked(community) {
			if (community.cover) {
				delete community.cover;
			}
			var errMsg = createCommunitySvc.validate(community, true);
			if (errMsg) {
				toastr.error(errMsg);
				return;
			}
			pixerfApiCommunitySvc.update({
				id: community.id
			}, community).$promise.then(function (response) {
				backup();
				if (self.dropzoneInstance) {
					self.dropzoneInstance.processQueue();
					self.dropzoneInstance.on("complete", function () {
						toastr.success(translationSvc.SOMETHING_HAS_BEEN_DONE("THIS_COMMUNITY", "SUCCESSFULLY_UPDATED") + "!");
						$state.go(commonConst.STATE.MANAGE_COMMUNITIES);
					})
				} else {
					toastr.success(translationSvc.SOMETHING_HAS_BEEN_DONE("THIS_COMMUNITY", "SUCCESSFULLY_UPDATED") + "!");
					$state.go(commonConst.STATE.MANAGE_COMMUNITIES);
				}
			}, function (err) {
				var errMessage = translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true);
				if (err && err.data && err.data.data && err.data.data.key == 'community_privacy_change') {
					self.community.is_private = self.orginialData.is_private;
					self.community.is_unlisted = self.orginialData.is_unlisted;
					confirmPopupSvc.showPopup({
						windowClass: 'confirm-action-popup',
						title: 'Oops, sorry.',
						message: 'You can only change a Community from private to public automatically within 30 days from the date of creation. If you would like to proceed, send us a request.',
						hideSubmitBtn: false,
						cancelBtnText: 'Cancel',
						submitBtnText: 'Send request',
						submit: onSendRequest
					});
				} else {
					toastr.error(errMessage);
				}
			})
		}

		function cancelBtnClicked() {
			restore();
			window.history.go(-1);
		}

		function onSendRequest() {
			var def = $q.defer();
			pixerfApiCommunitySvc.change_privacy({
				id: self.community.id
			}).$promise.then(function (res) {
				toastr.success("Sent request!");
				def.resolve(res);
			}).catch(function (err) {
				toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
				def.reject(err);
			})
			return def.promise;
		}

		function deleteBtnClicked(community) {
			if (self.isWorking) return;
			var confirmMessage = $translate.instant("delete-community-confirm");
			var modal = confirmPopupSvc.showPopup({
				windowClass: 'confirm-action-popup',
				hideTitle: true,
				hideConfirmText: true,
				cancelBtnText: 'Cancel',
				title: confirmMessage
			});
			modal.result.then(function () {
				self.isWorking = true;
				pixerfApiCommunitySvc.delete({
					id: community.id
				}).$promise.then(function (response) {
					toastr.success(translationSvc.SOMETHING_HAS_BEEN_DONE("THIS_COMMUNITY", "SUCCESSFULLY_DELETED") + "!");
					$state.go("user-home-page." + self.loginUser.account_type + ".communities.grid");
					self.isWorking = false;
				}, function (err) {
					$state.go("user-home-page." + self.loginUser.account_type + ".communities.grid");
					self.isWorking = false;
					toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
				});
			})
		}
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('manageDetailCommunityBlockedMembersCtrl', manageDetailCommunityBlockedMembersCtrl);

	manageDetailCommunityBlockedMembersCtrl.$inject = ['$scope', 'communityData'];

	function manageDetailCommunityBlockedMembersCtrl($scope, communityData) {
		var self = this;
		self.parent = $scope.$parent.vm;
		self.community = communityData;
		self.onMemberGridInit = onMemberGridInit;
		self.parent.contextPage = "blocked";
		self.onSearchStringChanged = _.debounce(onSearchStringChanged, 300);

		function onMemberGridInit(instance) {
			self.memberGrid = instance;
			self.isEmptyList = !self.memberGrid.peoples || !self.memberGrid.peoples.length;
		}

		function onSearchStringChanged() {
			var searchParams = {
				id: self.community.id,
				membership: 'blocked',
				page: 1
			}
			if (self.searchString) {
				searchParams.keywords = self.searchString
			} else {
				delete searchParams.keywords;
			}
			self.memberGrid.fetch(searchParams, true);
		}
	}
})();

/**
 * Controller for home module
 */
(function(){
  'use strict';
  angular
    .module('pixerf')
    .factory('releasesSvc', releasesSvc);
    releasesSvc.$inject = ['$uibModal', 'toastr'];

    function releasesSvc($uibModal, toastr){
    	
		return;
    }
})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('releasesCtrl', releasesCtrl);

    releasesCtrl.$inject = ['$scope'];

    function releasesCtrl($scope) {

		var self = this;
		$scope.$parent.vm.contextPage = "Releases";
        self.brandingPhoto = {
				"id": 3897,
				"title": "Coworkinc",
				"user": {
					"name": "Kenny Peters",
					"id": 816
				}
			};
    }
})();
(function () {

	angular
		.module('pixerf')
		.controller('faqPersonalCtrl', faqPersonalCtrl);

	faqPersonalCtrl.$inject = ['$state', '$anchorScroll', '$location', '$timeout', '$scope', 'pagingUtils', 'sessionManagerSvc', 'signUpPersonalPopupSvc', 'emailUsPopupSvc'];

	function faqPersonalCtrl($state, $anchorScroll, $location, $timeout, $scope, pagingUtils, sessionManagerSvc, signUpPersonalPopupSvc, emailUsPopupSvc) {

		var self = this;
		$scope.$parent.vm.contextPage = "Contributor";
		self.targetSection = 'general';
		self.onSectionClicked = onSectionClicked;
		self.onManagePhotoClicked = onManagePhotoClicked;
		self.onEditProfilePage = onEditProfilePage;
		self.onPortfolioPage = onPortfolioPage;
		self.onEarningClicked = onEarningClicked;
		self.onDropEmailUs = onDropEmailUs;
        self.onQuestionClicked = onQuestionClicked;
		self.onCommunityChallengeClicked = onCommunityChallengeClicked;
		self.loginnedUser = sessionManagerSvc.getCurrentLoginUser().data;

		init();

		function onSectionClicked(target) {
			if (target === self.targetSection) {
				self.targetSection = null;
			} else {
				self.targetSection = target;
				$timeout(function () {
					pagingUtils.scrollToSection("#" + target, 90);
				}, 400);
			}
		}

		function init() {
			$anchorScroll.yOffset = function () {
				return $(".faq-page #" + self.targetSection).position().top + 120;
			}
			self.targetSection = $state.params.section ? $state.params.section : null;
			if (self.targetSection) {
				$location.hash(self.targetSection);
				$anchorScroll();
			}
		}

		function onManagePhotoClicked() {
			onRedirecttoPage('setting.manage-photos.pending-review');
		}

		function onCommunityChallengeClicked() {
			onRedirecttoPage('setting.manage-photos-mission.pending');
		}

		function onEditProfilePage() {
			onRedirecttoPage('setting.edit_profile_personal');
		}

		function onPortfolioPage() {
			onRedirecttoPage('user-home-page.personal.portfolio');
		}

		function onEarningClicked() {
			onRedirecttoPage('setting.earnings.my_earnings.images_sold');
		}

		function onRedirecttoPage(route) {
			if (self.loginnedUser && self.loginnedUser.isContributor) {
				var url = $state.href(route);
				window.open(url, '_blank');
			} else {
				signUpPersonalPopupSvc.showPopup();
			}
		}

		function onDropEmailUs() {
			emailUsPopupSvc.showPopup({
				topicId: 11
			});
		}

		function onQuestionClicked(target) {
			pagingUtils.scrollToSection("#" + target, 135);
		}
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('faqBusinessCtrl', faqBusinessCtrl);

	faqBusinessCtrl.$inject = ['$state', '$anchorScroll', '$location', '$timeout', '$scope', 'pagingUtils', 'customCommissionBasicFormPopupSvc', 'emailUsPopupSvc'];

	function faqBusinessCtrl($state, $anchorScroll, $location, $timeout, $scope, pagingUtils, customCommissionBasicFormPopupSvc, emailUsPopupSvc) {

		var self = this;
		self.onSectionClicked = onSectionClicked;
        self.onBookingForm = onBookingForm;
        self.onEmailUsPopup = onEmailUsPopup;
        self.onPricingPageClicked = onPricingPageClicked;
		self.targetSection = 'general';
		$scope.$parent.vm.contextPage = "Business";

		init();

		function onSectionClicked(target) {
			if (target === self.targetSection) {
				self.targetSection = null;
			} else {
				self.targetSection = target;
				$timeout(function () {
					pagingUtils.scrollToSection("#" + target, 90);
				}, 400);
			}
		}

		function init() {
			$anchorScroll.yOffset = function () {
				return $(".faq-page #" + self.targetSection).position().top + 120;
			}
			self.targetSection = $state.params.section ? $state.params.section : null;
			if (self.targetSection) {
				$location.hash(self.targetSection);
				$anchorScroll();
			}
		}

        function onPricingPageClicked(){
            onRedirecttoPage('about-business-page.pricing');
        }

		function onRedirecttoPage(route) {
			var url = $state.href(route);
			window.open(url, '_blank');
		}

        function onBookingForm(){
            customCommissionBasicFormPopupSvc.showPopup();
        }

        function onEmailUsPopup(topicId){
            if(!topicId){
                emailUsPopupSvc.showPopup();
            } else {
                emailUsPopupSvc.showPopup({topicId: topicId});
            }
        }
	}
})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('subscriptionsPersonalCtrl', subscriptionsPersonalCtrl);

    subscriptionsPersonalCtrl.$inject = ['$scope'];

    function subscriptionsPersonalCtrl($scope) {

		var self = this;
		$scope.$parent.vm.contextPage = "Personal";
		self.brandingPhoto = {
				"id": 53,
				"title": "Cityscape, Clarke Quay",
				"user": {
					"name": "Athena Tan",
					"id": 560
				}
			};
    }
})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('subscriptionsBusinessCtrl', subscriptionsBusinessCtrl);

    subscriptionsBusinessCtrl.$inject = ['$scope'];

    function subscriptionsBusinessCtrl($scope) {

		var self = this;
		$scope.$parent.vm.contextPage = "Business";
		self.brandingPhoto = {
				"id": 44,
				"title": "Singapore Cityscape",
				"user": {
					"name": "Athena Tan",
					"id": 560
				}
			};
    }
})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('payoutPersonalCtrl', payoutPersonalCtrl);

    payoutPersonalCtrl.$inject = ['$scope'];

    function payoutPersonalCtrl($scope) {

		var self = this;
		$scope.$parent.vm.contextPage = "Payout & Pricing";
		self.brandingPhoto = {
				"id": 37,
				"title": "Blacksmith in Taiwan",
				"user": {
					"name": "Athena Tan",
					"id": 560
				}
			};
    }
})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('termsCtrl', termsCtrl);

    termsCtrl.$inject = ['$scope'];

    function termsCtrl($scope) {

		var self = this;
		$scope.$parent.vm.contextPage = "Terms";
		self.brandingPhoto = {
				"id": 1212,
				"title": "Concert Crowds",
				"user": {
					"name": "Senry Alvin",
					"id": 749
				}
			};
    }
})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('privacyCtrl', privacyCtrl);

    privacyCtrl.$inject = ['$scope'];

    function privacyCtrl($scope) {

		var self = this;
		$scope.$parent.vm.contextPage = "Privacy";
		self.brandingPhoto = {
				"id": 38,
				"title": "Steel Works",
				"user": {
					"name": "Athena Tan",
					"id": 560
				}
			};
    }
})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('licenseCtrl', licenseCtrl);

    licenseCtrl.$inject = ['$scope'];

    function licenseCtrl($scope) {

		var self = this;
		$scope.$parent.vm.contextPage = "Licence Agreement";
		self.brandingPhoto = {
				"id": 1020,
				"title": "Infinity",
				"user": {
					"name": "Shaahid Hisam",
					"id": 766
				}
			};
    }
})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('communityGuidelinesCtrl', communityGuidelinesCtrl);

		communityGuidelinesCtrl.$inject = ['$scope'];

    function communityGuidelinesCtrl($scope) {

		var self = this;
		$scope.$parent.vm.contextPage = "Community Guidelines";
		self.brandingPhoto = {
				"id": 300573,
				"title": "Multiracial friends playing and laughing",
				"user": {
					"name": "Samuel Goh",
					"id": 71124
				}
			};
    }
})();

(function () {

	angular
		.module('pixerf')
		.controller('searchCommunitiesEventsResultsCtrl', searchCommunitiesEventsResultsCtrl);

	searchCommunitiesEventsResultsCtrl.$inject = ['$scope', 'pagingUtils', 'pixerfApiCommunitySvc', '$translate', 'toastr'];

	function searchCommunitiesEventsResultsCtrl($scope, pagingUtils, pixerfApiCommunitySvc, $translate, toastr) {

		var self = this;
		self.searchInfoParams = $scope.$parent.vm;
		self.onArrangeChanged = onArrangeChanged;
		self.onFilterByLetter = onFilterByLetter;
		self.fetchMoreCommunities = fetchMoreCommunities;
		self.communities = [];
		self.events = [];
		self.eventClasses = [];
		self.typeSearch = '';
		self.spinner = {
			isVisible: false
		};
		self.arrangeBy = {};
		self.letters = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
		self.searchParams = {
			keywords: self.searchInfoParams.keywords.join(),
			order: 'mostEngagement',
			page: 1
		};

		init();

		function init() {
			self.arrangeBy.mostEngagement = true
			getCommunitiesEventsList(self.searchParams, true);
			if (self.searchInfoParams) {
				addTypeToSearchParams(self.searchInfoParams.selecetedType);
			}
		}

		function addTypeToSearchParams(type) {
			if (type === 'communities') {
				self.searchParams.type = 'community';
			} else if (type === 'events') {
				self.searchParams.type = 'event';
				self.searchParams.event_type = 'standard';
			} else if (type === 'classes') {
				self.searchParams.type = 'event';
				self.searchParams.event_type = 'class';
			} else {
				delete self.searchParams.type;
				delete self.searchParams.event_type;
			}
		}

		function getCommunitiesEventsList(params, isFresh) {
			self.searchParams = params;
			self.spinner.isVisible = true;
			pixerfApiCommunitySvc.explore(self.searchParams).$promise.then(function (response) {
				if (isFresh) {
					self.communities = [];
					self.events = [];
					self.eventClasses = [];
				}
				distributeItem(response.data);
				self.isLastPage = pagingUtils.isNoMorePageToLoad(params.page, response);
				self.totalPage = pagingUtils.getTotalPage(response);
				self.spinner.isVisible = false;
				self.searchParams.page = params.page;
			}, function () {
				toastr.error($translate.instant("failed-to-get-communities-list"));
				self.spinner.isVisible = false;
			});
		}

		function fetchMoreCommunities() {
			if (self.isLastPage || self.spinner.isVisible) return;

			var searchParams = $.extend(true, {}, self.searchParams);
			searchParams.page++;
			getCommunitiesEventsList(searchParams);
		}

		function distributeItem(data) {
			var communities = _.filter(data, function (item) {
				return item.type === 'Community';
			});
			var events = _.filter(data, function (item) {
				return item.type === 'CommunityEvent' && (item.event_type === 'standard' || !item.event_type);
			});
			var eventClasses = _.filter(data, function (item) {
				return item.type === 'CommunityEvent' && item.event_type === 'class';
			});
			self.communities = self.communities.concat(communities);
			self.events = self.events.concat(events);
			self.eventClasses = self.eventClasses.concat(eventClasses);
		}

		function onArrangeChanged(data) {
			self.searchParams.page = 1;
			if (!data.name) {
				delete self.searchParams.alphabet;
			}
			for (key in data) {
				if (data[key]) {
					self.searchParams.order = key;
				}
			}
			getCommunitiesEventsList(self.searchParams, true);
		}

		function onFilterByLetter(letter) {
			self.isLettedSelected = letter;
			self.searchParams.page = 1;
			self.searchParams.alphabet = letter;
			getCommunitiesEventsList(self.searchParams, true);
		}
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('exploreEventsCtrl', exploreEventsCtrl);

	exploreEventsCtrl.$inject = ['$scope', 'pagingUtils', 'pixerfApiCommunitySvc', '$translate', 'toastr'];

	function exploreEventsCtrl($scope, pagingUtils, pixerfApiCommunitySvc, $translate, toastr) {

		var self = this;
        $scope.$parent.vm.contextPage = "Events";
		self.onArrangeChanged = onArrangeChanged;
		self.onFilterByLetter = onFilterByLetter;
		self.fetchMoreEvents = fetchMoreEvents;
		self.events = [];
		self.typeSearch = '';
		self.spinner = {
			isVisible: false
		};
		self.arrangeBy = {};
		self.letters = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
		self.searchParams = {
            type: 'event',
            event_type: 'standard',
			order: 'mostEngagement',
			page: 1
		};

		init();

		function init() {
			self.arrangeBy.mostEngagement = true
			// getEventsList(self.searchParams, true);
		}

		function getEventsList(params, isFresh) {
			self.searchParams = params;
			self.spinner.isVisible = true;
			pixerfApiCommunitySvc.explore(self.searchParams).$promise.then(function (response) {
				if (isFresh) {
					self.events = [];
				}
				self.events = self.events.concat(response.data);
				self.isLastPage = pagingUtils.isNoMorePageToLoad(params.page, response);
				self.totalPage = pagingUtils.getTotalPage(response);
				self.spinner.isVisible = false;
				self.searchParams.page = params.page;
			}, function () {
				toastr.error($translate.instant("failed-to-get-communities-list"));
				self.spinner.isVisible = false;
			});
		}

		function fetchMoreEvents() {
			if (self.isLastPage || self.spinner.isVisible) return;

			var searchParams = $.extend(true, {}, self.searchParams);
			searchParams.page++;
			getEventsList(searchParams);
		}

		function onArrangeChanged(data) {
			self.searchParams.page = 1;
			if (!data.name) {
				delete self.searchParams.alphabet;
			}
			for (key in data) {
				if (data[key]) {
					self.searchParams.order = key;
				}
			}
			getEventsList(self.searchParams, true);
		}

		function onFilterByLetter(letter) {
			self.isLettedSelected = letter;
			self.searchParams.page = 1;
			self.searchParams.alphabet = letter;
			getEventsList(self.searchParams, true);
		}
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('exploreCommunitiesCtrl', exploreCommunitiesCtrl);

	exploreCommunitiesCtrl.$inject = ['$scope', 'pagingUtils', 'pixerfApiCommunitySvc', '$translate', 'toastr'];

	function exploreCommunitiesCtrl($scope, pagingUtils, pixerfApiCommunitySvc, $translate, toastr) {

		var self = this;
		$scope.$parent.vm.contextPage = "Communities";
		self.onArrangeChanged = onArrangeChanged;
		self.onFilterByLetter = onFilterByLetter;
		self.fetchMoreCommunities = fetchMoreCommunities;
		self.communities = [];
		self.typeSearch = '';
		self.spinner = {
			isVisible: false
		};
		self.arrangeBy = {};
		self.letters = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
		self.searchParams = {
			type: 'community',
			order: 'mostEngagement',
			page: 1
		};

		init();

		function init() {
			self.arrangeBy.mostEngagement = true
			getCommunitiesList(self.searchParams, true);
		}

		function getCommunitiesList(params, isFresh) {
			self.searchParams = params;
			self.spinner.isVisible = true;
			pixerfApiCommunitySvc.explore(self.searchParams).$promise.then(function (response) {
				if (isFresh) {
					self.communities = [];
					if(self.searchParams.order === 'mostEngagement'){
						self.communities = _.reject(response.data, function(com){
							return com.id === 16;
						})
						var tmp = _.reject(response.data, function(com){
							return com.id != 16;
						})
						self.communities.unshift(tmp[0]);
					} else {
						self.communities = response.data;
					}
				} else {
					self.communities = self.communities.concat(response.data);
				}
				self.isLastPage = pagingUtils.isNoMorePageToLoad(params.page, response);
				self.totalPage = pagingUtils.getTotalPage(response);
				self.spinner.isVisible = false;
				self.searchParams.page = params.page;
			}, function () {
				toastr.error($translate.instant("failed-to-get-communities-list"));
				self.spinner.isVisible = false;
			});
		}

		function fetchMoreCommunities() {
			if (self.isLastPage || self.spinner.isVisible) return;

			var searchParams = $.extend(true, {}, self.searchParams);
			searchParams.page++;
			getCommunitiesList(searchParams);
		}

		function onArrangeChanged(data) {
			self.searchParams.page = 1;
			if (!data.name) {
				delete self.searchParams.alphabet;
			}
			for (key in data) {
				if (data[key]) {
					self.searchParams.order = key;
				}
			}
			getCommunitiesList(self.searchParams, true);
		}

		function onFilterByLetter(letter) {
			self.isLettedSelected = letter;
			self.searchParams.page = 1;
			self.searchParams.alphabet = letter;
			getCommunitiesList(self.searchParams, true);
		}
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('exploreClassesCtrl', exploreClassesCtrl);

	exploreClassesCtrl.$inject = ['$scope', 'pagingUtils', 'pixerfApiCommunitySvc', '$translate', 'toastr'];

	function exploreClassesCtrl($scope, pagingUtils, pixerfApiCommunitySvc, $translate, toastr) {

		var self = this;
        $scope.$parent.vm.contextPage = "Classes";
		self.onArrangeChanged = onArrangeChanged;
		self.onFilterByLetter = onFilterByLetter;
		self.fetchMoreEvents = fetchMoreEvents;
		self.events = [];
		self.typeSearch = '';
		self.spinner = {
			isVisible: false
		};
		self.arrangeBy = {};
		self.letters = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
		self.searchParams = {
            type: 'event',
            event_type: 'class',
			order: 'mostEngagement',
			page: 1
		};

		init();

		function init() {
			self.arrangeBy.mostEngagement = true
			// getEventsList(self.searchParams, true);
		}

		function getEventsList(params, isFresh) {
			self.searchParams = params;
			self.spinner.isVisible = true;
			pixerfApiCommunitySvc.explore(self.searchParams).$promise.then(function (response) {
				if (isFresh) {
					self.events = [];
				}
				self.events = self.events.concat(response.data);
				self.isLastPage = pagingUtils.isNoMorePageToLoad(params.page, response);
				self.totalPage = pagingUtils.getTotalPage(response);
				self.spinner.isVisible = false;
				self.searchParams.page = params.page;
			}, function () {
				toastr.error($translate.instant("failed-to-get-communities-list"));
				self.spinner.isVisible = false;
			});
		}

		function fetchMoreEvents() {
			if (self.isLastPage || self.spinner.isVisible) return;

			var searchParams = $.extend(true, {}, self.searchParams);
			searchParams.page++;
			getEventsList(searchParams);
		}

		function onArrangeChanged(data) {
			self.searchParams.page = 1;
			if (!data.name) {
				delete self.searchParams.alphabet;
			}
			for (key in data) {
				if (data[key]) {
					self.searchParams.order = key;
				}
			}
			getEventsList(self.searchParams, true);
		}

		function onFilterByLetter(letter) {
			self.isLettedSelected = letter;
			self.searchParams.page = 1;
			self.searchParams.alphabet = letter;
			getEventsList(self.searchParams, true);
		}
	}
})();

(function () {

	angular
		.module('pixerf')
		.factory('aboutCommunitySvc', aboutCommunitySvc);

	aboutCommunitySvc.$inject = [];

	function aboutCommunitySvc() {

		var mBannerBox = {
			title: 'The fastest growing community of creators in	Asia you\'ve been waiting for.',
			description: 'Looking to connect with like-minded professionals and aspiring creators?'
		};

		function getBannerBox() {
			return mBannerBox;
		}

		return {
			getBannerBox: getBannerBox
		};
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('aboutCommunityCtrl', aboutCommunityCtrl);

	aboutCommunityCtrl.$inject = ['$scope', 'pixerfApiCommunitySvc', 'pagingUtils', 'aboutCommunitySvc', '$timeout', '$anchorScroll', '$location', 'emailUsPopupSvc', '$window', 'createCommunityPopupSvc', 'sessionManagerSvc', '$state'];

	function aboutCommunityCtrl($scope, pixerfApiCommunitySvc, pagingUtils, aboutCommunitySvc, $timeout, $anchorScroll, $location, emailUsPopupSvc, $window, createCommunityPopupSvc, sessionManagerSvc, $state) {

		var self = this;
		$scope.$parent.vm.contextPage = "Explore Community";
		self.loginedUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.getCommunities = getCommunities;
		self.getEvents = getEvents;
		self.getEventClasses = getEventClasses;
		self.bannerBox = aboutCommunitySvc.getBannerBox();
		self.whyCommunityHubBtnClicked = whyCommunityHubBtnClicked;
		self.applyCommunityBtnClicked = applyCommunityBtnClicked;
		self.createCommunity = createCommunity;
		self.onSeeMore = onSeeMore;
		self.communities = [];
		self.events = [];
		self.eventClasses = [];

		self.searchCommunitiesParams = {
			order: 'mostEngagement',
			type: 'community',
			page_size: 4,
			page: 1
		};
		self.searchEventsParams = {
			order: 'mostEngagement',
			type: 'event',
            event_type: 'standard',
			page_size: 2,
			page: 1
		};
		self.searchEventClassesParams = {
			order: 'mostEngagement',
			type: 'event',
			event_type: 'class',
			page_size: 2,
			page: 1
		};
		self.canCreateCommunity = false;

		init();

		function init() {
			getCommunities(self.searchCommunitiesParams, true);
			// getEventClasses(self.searchEventClassesParams, true);
			// getEvents(self.searchEventsParams, true);
			self.canCreateCommunity = (self.loginedUser && self.loginedUser.canManageCommunity);
		}

		function createCommunity() {
			createCommunityPopupSvc.showPopup();
		}

		function getCommunities(params, isRefresh) {
			// pixerfApiCommunitySvc.list(params).$promise.then(function (res) {
			pixerfApiCommunitySvc.explore(params).$promise.then(function (res) {
				if (isRefresh) {
					// self.communities = res.data;
					var tmp = _.reject(res.data, function(com){
						return com.id != 16;
					})
					self.communities = _.reject(res.data, function(com){
						return com.id === 16;
					})
					self.communities.unshift(tmp[0]);
				} else {
					self.communities.concat(res.data);
				}
				self.isLastCommunitiesPage = pagingUtils.isNoMorePageToLoad(self.searchCommunitiesParams.page, res);
				self.searchCommunitiesParams.page = params.page;
			})
		}

		function getEvents(params, isRefresh) {
			pixerfApiCommunitySvc.explore(params).$promise.then(function (res) {
				if (isRefresh) {
					self.events = res.data;
				} else {
					self.events = self.events.concat(res.data);
				}
				self.isLastEventsPage = pagingUtils.isNoMorePageToLoad(self.searchEventsParams.page, res);
				self.searchEventsParams.page = params.page;
			})
		}

		function getEventClasses(params, isRefresh) {
			pixerfApiCommunitySvc.explore(params).$promise.then(function (res) {
				if (isRefresh) {
					self.eventClasses = res.data;
				} else {
					self.eventClasses = self.eventClasses.concat(res.data);
				}
				self.isLastEventClassesPage = pagingUtils.isNoMorePageToLoad(self.searchEventClassesParams.page, res);
				self.searchEventClassesParams.page = params.page;
			})
		}

		function whyCommunityHubBtnClicked() {
			$window.event.stopPropagation();
			$timeout(function () {
				$location.hash('reasonsToJoinPIXERFCommunityHub');
				$anchorScroll.yOffset = 110;
				$anchorScroll();
			})
		}

		function applyCommunityBtnClicked() {
			emailUsPopupSvc.showPopup({
				topicId: 11
			});
		}

		function onSeeMore(type) {
			switch (type) {
				case 'communities':
					$state.go('for-creator-page.communities');
					break;
				case 'classes':
					$state.go('for-creator-page.classes');
					break;
				case 'events':
					$state.go('for-creator-page.events');
					break;
			}
		}
	}
})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('payoutAndPricingCtrl', payoutAndPricingCtrl);

    payoutAndPricingCtrl.$inject = ['$scope'];

    function payoutAndPricingCtrl($scope) {

		var self = this;
		$scope.$parent.vm.contextPage = "Payout & Pricing";
		self.brandingPhoto = {
				"id": 37,
				"title": "Blacksmith in Taiwan",
				"user": {
					"name": "Athena Tan",
					"id": 560
				}
			};
    }
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('exploreCommunnityHubCtrl', exploreCommunnityHubCtrl);

	exploreCommunnityHubCtrl.$inject = ['$scope', 'exploreCommunityHubSvc', 'signUpPersonalPopupSvc', 'sessionManagerSvc', '$state', '$window'];

	function exploreCommunnityHubCtrl($scope, exploreCommunityHubSvc, signUpPersonalPopupSvc, sessionManagerSvc, $state, $window) {

		var self = this;
		$scope.$parent.vm.contextPage = "Explore Creators";
		self.loginedUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.bannerBox = exploreCommunityHubSvc.getBannerBox();
		self.onSignUpCreator = onSignUpCreator;
		self.bannerBtnText = self.loginedUser && self.loginedUser.isContributor ? 'Manage your profile' : 'Sign Up for Creator Account';

		function onSignUpCreator() {
            $window.event.stopPropagation();
			if (self.loginedUser && self.loginedUser.isContributor ) {
				$state.go("user-home-page.personal.home", {
					id: self.loginedUser.id
				});
			} else {
				signUpPersonalPopupSvc.showPopup();
			}
		}
	}
})();

(function () {

	angular
		.module('pixerf')
		.factory('exploreCommunityHubSvc', exploreCommunityHubSvc);

        exploreCommunityHubSvc.$inject = [];

	function exploreCommunityHubSvc() {

		var mBannerBox = {
			style: {
				styleBackgroundBox: 'black--02'
			},
			title: 'The search continues for Asia’s best and most promising creators.'
		};

		function getBannerBox() {
			return mBannerBox;
		}

		return {
			getBannerBox: getBannerBox
		};
	}
})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('creatorAgreementCtrl', creatorAgreementCtrl);

    creatorAgreementCtrl.$inject = ['$scope'];

    function creatorAgreementCtrl($scope) {

		var self = this;
		$scope.$parent.vm.contextPage = "Creator Agreement";
		self.brandingPhoto = {
				"id": 3766,
				"title": "Cleaning the Big Eagle",
				"user": {
					"name": "Ferry Tan",
					"id": 861
				}
			};
    }
})();

(function () {

	angular
		.module('pixerf')
		.controller('eventScheduleCtrl', eventScheduleCtrl);

	eventScheduleCtrl.$inject = ['$scope'];

	function eventScheduleCtrl($scope) {

		var self = this;
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('eventPhotosCtrl', eventPhotosCtrl);

	eventPhotosCtrl.$inject = ['$scope', 'pixerfApiEventSvc', 'sessionManagerSvc', 'uploadCommunityEventPhotoSvc', 'pixerfConfirmPopupSvc', 'toastr'];

	function eventPhotosCtrl($scope, pixerfApiEventSvc, sessionManagerSvc, uploadCommunityEventPhotoSvc, pixerfConfirmPopupSvc, toastr) {

		var self = this;
		self.event = $scope.$parent.vm.event;
		self.isTypeClass = self.event && self.event.event_type == 'class';
		self.itemType = self.isTypeClass ? 'class' : 'event';
		self.loginedUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.isMine = self.loginedUser && self.event.owner.id === self.loginedUser.id;
		self.photos = [];
		self.onAddPhotos = onAddPhotos;
		self.emptyPhotos = {
			title: self.isMine ? "You have not uploaded any photos yet!" : (self.event.community_name + ' has not uploaded any photos yet!'),
			description: self.isMine ? 'Share some photos from your ' + (self.isTypeClass ? "class" : "event") + ' and increase engagement in your ' + (self.isTypeClass ? "classes" : "events") + ' page.' : 'No photos yet',
			buttonText: self.isMine ? 'Add new photos' : null
		}
		self.onDeletePhoto = onDeletePhoto;

		function init() {
			getEventPhotos();
			if (self.event.id === 3) {
				self.photos = [
					{
						url: {
							large: "assets/images/event-photos-3/1-CAROUSEL.png",
							medium: "assets/images/event-photos-3/1-CAROUSEL.png"
						}
					},
					{
						url: {
							large: "assets/images/event-photos-3/2-CAROUSEL.png",
							medium: "assets/images/event-photos-3/2-CAROUSEL.png"
						}
					},
					{
						url: {
							large: "assets/images/event-photos-3/3-CAROUSEL.png",
							medium: "assets/images/event-photos-3/3-CAROUSEL.png"
						}
					},
					{
						url: {
							large: "assets/images/event-photos-3/4-CAROUSEL.png",
							medium: "assets/images/event-photos-3/4-CAROUSEL.png"
						}
					},
					{
						url: {
							large: "assets/images/event-photos-3/5-CAROUSEL.png",
							medium: "assets/images/event-photos-3/5-CAROUSEL.png"
						}
					}
				];
			}

		}

		function getEventPhotos() {
			var params = { id: self.event.id }
			pixerfApiEventSvc.getEventPhotos(params).$promise.then(function (res) {
				if (self.event.id != 3) {
					self.photos = res.data;
				}
			}).catch(function (err) {
				console.log(err);
			})
		}

		function onAddPhotos() {
			var uploadPopup = uploadCommunityEventPhotoSvc.showUploadModal({
				eventId: self.event.id
			});
			uploadPopup.result.then(function (data) {
				getEventPhotos();
			})
		}
		function onDeletePhoto(photo) {
			var modal = pixerfConfirmPopupSvc.showPopup({
				hideTitle: true,
				hideConfirmText: true,
				message: "Are you sure you want to delete this photo?"
			});

			modal.result.then(function () {
				pixerfApiEventSvc.delete_photo_community_event({
					id: photo.id
				}).$promise.then(function (respone) {
					self.photos = _.reject(self.photos, function (it) {
						return it.id === photo.id;
					})
					toastr.success("Photo has been successfully deleted!");
				}).catch(function (err) {
					console.log(err);
				});
			});
		}

		init();
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('eventFeedCtrl', eventFeedCtrl);

	eventFeedCtrl.$inject = ['$scope', 'sessionManagerSvc', 'createEventPostPopupSvc', 'pixerfApiCommunitySvc', 'pagingUtils', 'toastr'];

	function eventFeedCtrl($scope, sessionManagerSvc, createEventPostPopupSvc, pixerfApiCommunitySvc, pagingUtils, toastr) {

		var self = this;
		self.event = $scope.$parent.vm.event;
		self.community = $scope.$parent.vm.community;
		self.isTypeClass = self.event && self.event.event_type == 'class';
		self.itemType = self.isTypeClass ? 'class' : 'event';
		self.isWorking = false;
		self.spinner = {
			isVisible: false
		}
		self.loginedUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.isMine = self.loginedUser && self.event.owner.id === self.loginedUser.id;
		self.canStartPost = (self.event.is_private && (self.isMine || self.event.is_community_member)) || !self.event.is_private;
		var owner = (self.isMine ? 'You do not' : (self.event.name + ' doesn\'t'));
		self.fetchMorePosts = fetchMorePosts;
		self.onPostRemoved = onPostRemoved;
		self.posts = [];
		self.onStartPost = onStartPost;
		self.emptyPost = {
			title: self.isMine ? (owner + ' have any posts yet') : null,
			description: self.isMine ? 'Create some content to boost visibility and increase engagement for your event!' : 'No posts yet',
			buttonText: self.isMine ? 'Create a new post' : null
		};
		self.arrangeOptions = {
			props: "arrangeBy",
			selections: [{
					label: "recent",
					value: "inserted_at"
				}
			]
		};
		self.arrangeBy = {
			arrangeBy: 'inserted_at'
		};
		self.defaultArrangeBy = {
			arrangeBy: self.arrangeOptions.selections[0].value
		};
		self.searchParams = {
			id: self.event.id,
			page: 1,
			sort: self.defaultArrangeBy.arrangeBy
		};

		init();

		function init(){
			getEventPosts(self.searchParams, true);
			// self.canCreatePost = true;//TODO: start_discussion_permission
		}

		function getEventPosts(params, isFresh) {
			self.searchParams = params;
			self.spinner.isVisible = true;
			self.isWorking = true;
			pixerfApiCommunitySvc.get_post_by_event_id(self.searchParams).$promise.then(function (res) {
				if (!self.posts || isFresh) self.posts = [];
				self.posts = self.posts.concat(res.data);
				self.isLastPage = pagingUtils.isNoMorePageToLoad(self.searchParams.page, res);
				self.spinner.isVisible = false;
				self.searchParams.page = params.page;
				self.isWorking = false;
			}).catch(function (err) {
				self.isWorking = false;
				self.spinner.isVisible = false;
				console.log(err);
			})
		}

		function fetchMorePosts() {
			if (self.isLastPage || self.spinner.isVisible) return;
			var searchParms = $.extend(true, {}, self.searchParams);
			searchParms.page++;
			getPosts(searchParms);
		}

		function onStartPost() {
			var errorMessage = 'The ' +  self.itemType + ' discussion is being disabled';
			toastr.error(errorMessage);
			return;
			createEventPostPopupSvc.showPopup({
				event: self.event,
				createdCallback: function (eventPost) {
					self.posts.unshift(eventPost);
				}
			});
		}

		function onPostRemoved(post) {
			self.posts = _.reject(self.posts, function (item) {
				return item.id === post.id;
			})
		}
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('communityNotFoundCtrl', communityNotFoundCtrl);

	communityNotFoundCtrl.$inject = [];

	function communityNotFoundCtrl() {
		var self = this;

		self.takeBack = function () {
			window.history.back();
		}
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('customCommissionsDetailPageshortListCtrl', customCommissionsDetailPageshortListCtrl);

	customCommissionsDetailPageshortListCtrl.$inject = ['$scope', 'pixerfApiCustomCommssionsSvc', 'requestHiresPopupSvc', 'pagingUtils', '$q', 'customCommissionsData', 'toastr', '$state', '$timeout'];

	function customCommissionsDetailPageshortListCtrl($scope, pixerfApiCustomCommssionsSvc, requestHiresPopupSvc, pagingUtils, $q, customCommissionsData, toastr, $state, $timeout) {

		var self = this;
		self.parent = $scope.$parent.vm;
		self.parent.contextPage = "Selected photo";
		self.isContributor = self.parent.loginedUser.isContributor;
		self.onDelBtnClicked = onDelBtnClicked;
		self.onPhotoSelected = onPhotoSelected;
		self.onRequestBtnClicked = onRequestBtnClicked;
		self.customCommissionsData = customCommissionsData;
		self.selectedItems = [];
		self.settingsCustomComissionsTile = self.canRequestDownload ? {} : {'disableCheckbox': true, 'defaultSelected': false};
		self.isManager = self.parent.isManager;
		self.canRequestDownload = self.isManager && !self.customCommissionsData.selection_state;
		self.searchParams = {
			id: self.customCommissionsData.id,
			type: self.isManager ? "shortlisted_submissions_by_me" : "my_shortlisted_submissions",
			page: 1
		};
		self.onPhotoGridInit = onPhotoGridInit;

		init();

		function init() {
		}
		function onPhotoGridInit(instance){
			self.photoGrid = instance;
			self.photoGrid.fetchItems(self.searchParams);
		}
		
		function onPhotoSelected(item) {
			if (item.selected) {
				self.selectedItems.push(item.data);
			} else {
				self.selectedItems = _.reject(self.selectedItems, function (obj) {
					return obj.id === item.data.id;
				});
			}
		}
		function updateList(items) {
			if (!items.length) return;
			var ids = [];
			for (var i = 0; i < items.length; i++) {
				ids.push(items[i].id);
			}
			self.photoGrid.removeItem(ids);
		}
		function onDelBtnClicked(items) {
			if (!items.length) return;
			var ids = [];
			for (var i = 0; i < items.length; i++) {
				ids.push(items[i].id);
			}
			var params = {
				'submission_ids': ids
			}
			pixerfApiCustomCommssionsSvc.addToShortlist({'id': self.customCommissionsData.id}, params).$promise.then(function(response){
				self.customCommissionsData.stats.selected_submission_count -= ids.length;
				updateList(items);
				resetSelectionList();
			}, function(){
				ids = [];
			});
		}
		
		function resetSelectionList() {
			self.selectedItems = [];
		}

		function onRequestBtnClicked(){
			var obj = {
				author: self.photoGrid.items[0].media.user.id,
				data: self.customCommissionsData
			}
			var modal = requestHiresPopupSvc.showPopup(obj);
			modal.result.then(function() {
				toastr.success("Request successful! You will be notified once the photographer has uploaded the high resolution files.");
				self.customCommissionsData.selection_state = 'open';
				$timeout(function(){
					$state.go("custom-commissions-detail-page.download");
				}, 2000);
            }, function() {
            });
		}
		
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('customCommissionsDetailPageSelectionCtrl', customCommissionsDetailPageSelectionCtrl);

	customCommissionsDetailPageSelectionCtrl.$inject = ['$scope', 'pixerfApiCustomCommssionsSvc', 'uploadCustomCommissionsPopupSvc', 'customCommissionsData', 'toastr', 'maxPhotosCommissionsCopupSvc', 'translationSvc'];

	function customCommissionsDetailPageSelectionCtrl($scope, pixerfApiCustomCommssionsSvc, uploadCustomCommissionsPopupSvc, customCommissionsData, toastr, maxPhotosCommissionsCopupSvc, translationSvc) {

		var self = this;
		self.commissionsData = customCommissionsData;
		self.parent = $scope.$parent.vm;
		self.parent.contextPage = "Selected photo";
		self.searchParams = {
			id: self.commissionsData.id,
			page: 1
		};
		self.settingsCustomComissionsTile = !self.commissionsData.selection_state ? {} : {'disableCheckbox': true, 'defaultSelected': false};
		self.onPhotoSelected = onPhotoSelected;
		self.onAddToShortlist = onAddToShortlist;
		self.onUploadPhotoClicked = onUploadPhotoClicked;
		self.onDelBtnClicked = onDelBtnClicked;
		self.selectedItems = [];
		self.loginedUser = self.parent.loginedUser;
		self.onPhotoGridInit = onPhotoGridInit;

		function onPhotoGridInit(instance){
			self.photoGrid = instance;
			self.photoGrid.fetchItems(self.searchParams);
		}

		function onPhotoSelected(item) {
			if (item.selected) {
				if(self.loginedUser.isBiz){
					if(self.selectedItems.length + self.commissionsData.stats.selected_submission_count === self.commissionsData.selection_limit){
						maxPhotosCommissionsCopupSvc.showPopup(self.commissionsData.selection_limit);
						item.selected = !item.selected;
					} else{
						self.selectedItems.push(item.data);
					}
				} else{
					self.selectedItems.push(item.data);
				}
			} else {
				self.selectedItems = _.reject(self.selectedItems, function (obj) {
					return obj.id === item.data.id;
				});
			}
		}

		function onAddToShortlist(items) {
			var ids = [];
			for (var i = 0; i < items.length; i++) {
				ids.push(items[i].id);
			}
			var params = {
				'submission_ids': ids
			}
			pixerfApiCustomCommssionsSvc.addToShortlist({'id': self.commissionsData.id}, params).$promise.then(function(response){
				self.parent.customCommissions.stats.selected_submission_count += items.length;
				updateList(items);
				resetSelectionList();
			}, function(err){
				toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
			});
		}

		function resetSelectionList() {
			self.selectedItems = [];
		}

		function onUploadPhotoClicked() {
			uploadCustomCommissionsPopupSvc.showUploadModal({ files: self.commissionsData ,popupTitle: 'Upload to Contact sheet'});
		}

		function onDelBtnClicked(items) {
			var ids = [];
			for (var i = 0; i < items.length; i++) {
				ids.push(items[i].id);
			}
			var params = {
				'custom_commissions_id': self.commissionsData.id,
				'submission_ids': _.reduce(items, function(memo, item){
					memo.push(item.id);
					return memo;
				}, [])
			};
			pixerfApiCustomCommssionsSvc.removeMySubmissions(params).$promise.then(function(response){
				updateList(items);
				resetSelectionList();
			}, function(err){
				toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
			});
		}

		function updateList(items) {
			if (!items.length) return;
			var ids = [];
			for (var i = 0; i < items.length; i++) {
				ids.push(items[i].id);
			}
			self.photoGrid.removeItem(ids);
		}

	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('customCommissionsDetailPageHiResCtrl', customCommissionsDetailPageHiResCtrl);

	customCommissionsDetailPageHiResCtrl.$inject = ['pixerfMessagePopupSvc', '$scope', 'pixerfApiCustomCommssionsSvc', 'pixerfConfirmPopupSvc', 'uploadCustomCommissionsPopupSvc', 'customCommissionsData', 'toastr', 'translationSvc'];

	function customCommissionsDetailPageHiResCtrl(pixerfMessagePopupSvc, $scope, pixerfApiCustomCommssionsSvc, pixerfConfirmPopupSvc, uploadCustomCommissionsPopupSvc, customCommissionsData, toastr, translationSvc) {

		var self = this;
		self.parent = $scope.$parent.vm;
		self.spinner = {
			isVisible: false
		};
		self.customCommissionsData = customCommissionsData;
		self.onUploadPhotoClicked = onUploadPhotoClicked;
		self.onPhotoGridInit = onPhotoGridInit;
		self.onDelBtnClicked = onDelBtnClicked;
		self.onPhotoSelected = onPhotoSelected;
		self.onRequestAgainClicked = onRequestAgainClicked;
		self.onReleaseClicked = onReleaseClicked;
		self.isContributor = self.parent.loginedUser && self.parent.loginedUser.isContributor;
		self.settingsCustomComissionsTile = self.customCommissionsData.selection_state != 'responded' ? {} : {'disableCheckbox': true, 'defaultSelected': false};
		self.isManager = self.parent.isManager;
		self.searchParams = {
			id: self.customCommissionsData.id,
			type: self.isManager ? "available_to_download" : "my_hires_submission",
			page: 1
		};
		self.parent.contextPage = self.isManager ? "Upload Hi-res" : "Request Hi-res";
		self.selectedItems = [];
		self.shortlist = [];

		self.onSortChange = onSortChange;

		function onSortChange(item){
			self.searchParams.sort = item.value;
			self.photoGrid.fetchItems(self.searchParams);
		}

		function onPhotoGridInit(instance){
			self.photoGrid = instance;
			self.photoGrid.fetchItems(self.searchParams);
		}

		function onPhotoSelected(item) {
			if (item.selected) {
				if(self.loginedUser.isBiz){
					if(self.selectedItems.length === self.customCommissionsData.selection_limit){
						maxPhotosCommissionsCopupSvc.showPopup(self.customCommissionsData.selection_limit);
						item.selected = !item.selected;
					} else{
						self.selectedItems.push(item.data);
					}
				} else{
					self.selectedItems.push(item.data);
				}
			} else {
				self.selectedItems = _.reject(self.selectedItems, function (obj) {
					return obj.id === item.data.id;
				});
			}
		}

		function onUploadPhotoClicked(){
			var files = self.customCommissionsData;
			files.hires = true;
			uploadCustomCommissionsPopupSvc.showUploadModal({files: files, popupTitle: 'Upload final photos'});
		}
		function onReleaseClicked(){
			var modal = pixerfConfirmPopupSvc.showPopup({
				hideTitle: true,
				message: 'Please confirm if you would like to upload the high resolution photos as part of this Custom Commission\'s final deliverables.',
				hideConfirmText: true,
				okBtnText: 'Yes',
				cancelBtnText: 'No'
			});

			modal.result.then(function () {
				var progressPopup = pixerfMessagePopupSvc.showPopup({
					message: '<p>Please hang on while your high resolution files are being uploaded! This may take awhile, so thank you for your patience!</p>',
					autoClose: false,
					backdrop: 'static'
				})
                pixerfApiCustomCommssionsSvc.release({id: self.customCommissionsData.id}, {"content": "release to download"}).$promise.then(function (response) {
					toastr.success("Your high resolution photos have been successfully uploaded! You will be notified once the client downloads the files.");
					self.customCommissionsData.selection_state = 'responded';
					progressPopup.close();
				}, function (err) {
					progressPopup.close();
					toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
				});
			})
		}

		function onPhotoSelected(item){
			if(item.selected){
				self.selectedItems.push(item.data);
			} else {
				self.selectedItems =  _.reject(self.selectedItems, function(obj){
                    return obj.id === item.data.id;
                });
			}
		}
		function updateList(items) {
			if (!items.length) return;
			var ids = [];
			for (var i = 0; i < items.length; i++) {
				ids.push(items[i].id);
			}
			self.photoGrid.removeItem(ids);
		}

		function onDelBtnClicked(items) {
			for (var i = 0; i < items.length; i++) {
				self.shortlist.push(items[i].id);
			}
			var params = {
				'custom_commissions_id': self.customCommissionsData.id,
				'submission_ids': _.reduce(items, function(memo, item){
					memo.push(item.id);
					return memo;
				}, [])
			};
			pixerfApiCustomCommssionsSvc.removeMySubmissions(params).$promise.then(function(response){
				updateList(items);
				resetSelectionList();
				self.totalPhotos -= items.length;
			}, function(err){
				toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
			});
		}
		function resetSelectionList(){
			self.selectedItems = [];
			self.shortlist = [];
		}

		function onRequestAgainClicked(){
			return pixerfConfirmPopupSvc.showPopup({
				hideTitle: true,
				message: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maximus dolor, inquit, brevis est.',
				hideConfirmText: true,
				okBtnText: 'Yes',
				cancelBtnText: 'No'
			});
		}
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('customCommissionsDetailPageDownloadCtrl', customCommissionsDetailPageDownloadCtrl);

	customCommissionsDetailPageDownloadCtrl.$inject = ['$scope', 'pixerfApiCustomCommssionsSvc', 'customCommissionDetailPageService', '$q', 'customCommissionsData'];

	function customCommissionsDetailPageDownloadCtrl($scope, pixerfApiCustomCommssionsSvc, customCommissionDetailPageService, $q, customCommissionsData) {

		var self = this;
		self.parent = $scope.$parent.vm;
		self.tickets = null;
		self.spinner = {
			isVisible: false
		};
		self.customCommissionsData = customCommissionsData;

		init();

		function init() {
			fetchDownloadRequests();
		}

		function fetchDownloadRequests() {
			var def = $q.defer();
	
			pixerfApiCustomCommssionsSvc.getDownloadLink({id: self.customCommissionsData.id}).$promise.then(function(response){
				self.tickets = customCommissionDetailPageService.formatTickets(response);
				console.log(self.tickets);
				def.resolve(response);
			}, function () {
				self.isFresh = false;
				self.spinner.isVisible = false;
				def.reject(self);
			});
		}

		// function onRequestAgainClicked(){
		// 	return pixerfConfirmPopupSvc.showPopup({
		// 		hideTitle: true,
		// 		message: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maximus dolor, inquit, brevis est.',
		// 		hideConfirmText: true,
		// 		okBtnText: 'Yes',
		// 		cancelBtnText: 'No'
		// 	});
		// }
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('customCommissionsDetailPageDeliveryCtrl', customCommissionsDetailPageDeliveryCtrl);

	customCommissionsDetailPageDeliveryCtrl.$inject = ['$scope', 'pixerfApiCustomCommssionsSvc', 'customCommissionsData', 'sessionManagerSvc'];

	function customCommissionsDetailPageDeliveryCtrl($scope, pixerfApiCustomCommssionsSvc, customCommissionsData, sessionManagerSvc) {

		var self = this;
		self.parent = $scope.$parent.vm;

		self.onShootClicked = onShootClicked;
		self.selectedShoot = {};
		self.loginedUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.isManager = self.parent.isManager;

		init();

		function init() {
			getShootsById(customCommissionsData.id);
		}

		function onShootClicked(shoot) {
			self.selectedShoot = shoot;
		}

		function getShootsById(id) {
			var params = {
				id: id,
				action: 'shoots',
				page_size: 500
			}
			pixerfApiCustomCommssionsSvc.getListShoots(params).$promise.then(function (res) {
				if (res.data && res.data.shoots) {
					self.customCommissions = _.reject(res.data.shoots, function (shoot) {
						return !shoot.is_download_requested;
					});
				} else {
					self.customCommissions = _.reject(res.data, function (shoot) {
						return !shoot.is_download_requested;
					});
				}
				if (self.customCommissions && self.customCommissions.length) {
					self.selectedShoot = self.customCommissions[0];
				}
				$scope.$emit('loadedDeliveriedShoots', self.customCommissions);
				$scope.$emit('loadedDetailsDeliveriedShoot', self.selectedShoot);
			}).catch(function (err) {
				console.log(err);
			})
		}
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('customCommissionsDetailPageBriefCtrl', customCommissionsDetailPageBriefCtrl);

	customCommissionsDetailPageBriefCtrl.$inject = [];

	function customCommissionsDetailPageBriefCtrl() {

		var self = this;

	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('customCommissionsDetailPageApprovalCtrl', customCommissionsDetailPageApprovalCtrl);

	customCommissionsDetailPageApprovalCtrl.$inject = ['$scope', 'pixerfApiCustomCommssionsSvc', 'customCommissionsData', '$rootScope', 'systemUtils', 'sessionManagerSvc', 'customCommissionsDetailPageSvc'];

	function customCommissionsDetailPageApprovalCtrl($scope, pixerfApiCustomCommssionsSvc, customCommissionsData, $rootScope, systemUtils, sessionManagerSvc, customCommissionsDetailPageSvc) {

		var self = this;
		self.parent = $scope.$parent.vm;

		self.onShootClicked = onShootClicked;
		self.selectedShoot = {};
		self.loginedUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.isManager = self.parent.isManager;

		init();

		function init() {
			getShootsById(customCommissionsData.id);
		}

		function onShootClicked(shoot) {
			self.selectedShoot = shoot;
			customCommissionsDetailPageSvc.setShoot(self.selectedShoot);
		}

		function getShootsById(id) {
			var params = {
				id: id,
				action: 'shoots',
				page_size: 500
			}
			pixerfApiCustomCommssionsSvc.getListShoots(params).$promise.then(function (res) {
				if (res.data && res.data.shoots) {
					self.customCommissions = res.data.shoots;
				} else {
					self.customCommissions = res.data;
				}
				if (self.customCommissions && self.customCommissions.length) {
					self.selectedShoot = self.customCommissions[0];
				}
				$scope.$emit('loadedDetailsShoot', self.selectedShoot);
				$scope.$emit('loadedShootList', self.customCommissions);
			}).catch(function (err) {
				console.log(err);
			})
		}
	}
})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .directive('customCommissionDetailPageUploadGuidedZone', customCommissionDetailPageUploadGuidedZone);
        customCommissionDetailPageUploadGuidedZone.$inject = [];
    function customCommissionDetailPageUploadGuidedZone() {
        var directive = {
            restrict: 'E',
            scope: {
                text: '@',
                onSelectBtnClicked: '&'
            },
            templateUrl: 'app/custom-commissions-detail-page/components/custom-commission-detail-page-upload-guided-zone/custom-commission-detail-page-upload-guided-zone.html',
            replace: true
          };
          return directive;
    }
})();                                                                  
(function() {
    'use strict';

    angular
        .module('pixerf')
        .directive('customCommissionDetailPageSelectionGuidedText', customCommissionDetailPageSelectionGuidedText);
        customCommissionDetailPageSelectionGuidedText.$inject = [];
    function customCommissionDetailPageSelectionGuidedText() {
        var directive = {
            restrict: 'E',
            scope: {
                data: '=',
                iconClass: '@'
            },
            templateUrl: 'app/custom-commissions-detail-page/components/custom-commission-detail-page-selection-guided-text/custom-commission-detail-page-selection-guided-text.html',
            replace: true
          };
          return directive;
    }
})();                                                                  
(function () {

	angular
		.module('pixerf')
		.controller('customCommissionDetailPagePhotoGridCtrl', customCommissionDetailPagePhotoGridCtrl);

	customCommissionDetailPagePhotoGridCtrl.$inject = ['$scope', 'pixerfApiCustomCommssionsSvc', '$q', 'pagingUtils'];

	function customCommissionDetailPagePhotoGridCtrl($scope, pixerfApiCustomCommssionsSvc, $q, pagingUtils) {

		var self = this;
		self.spinner = {
			isVisible: false
		};
		self.fetchMoreItems = fetchMoreItems;
		self.fetchItems = fetchItems;
		self.onPhotoSelected = onPhotoSelected;
		self.removeItem = removeItem;
		self.items = null;
		self.onSortChange = onSortChange;
		self.viewMode = $scope.viewMode ? $scope.viewMode : 'group' //group/flat/grid/list
		init();

		function onSortChange(item){
			self.searchParams.sort = item.value;
			fetchItems(self.searchParams, true);
		}
		function onPhotoSelected(item){
			console.log(item);
			if($scope.onPhotoSelected) $scope.onPhotoSelected({item: item})
		}
		function init(){
			if($scope.onInit) $scope.onInit({instance: self});
		}
		function makeGroup(items){
			return _.groupBy(items, function(it){
				var date = it.inserted_at.substr(0,10); 
				return it.title + date + it.media.user.id + it.note;
			})
		}
		function fetchItems(searchParams) {
			if(self.spinner.isVisible) return;
			if(searchParams.sort === 'comment_count'){
				self.viewMode = 'flat';
			} else{
				self.viewMode = 'group';
			}
			self.spinner.isVisible = true;
			self.searchParams = searchParams;
			var def = $q.defer();
			pixerfApiCustomCommssionsSvc.getListSelections(searchParams).$promise.then(function (response) {
				self.spinner.isVisible = false;
				if (self.searchParams.page === 1) {
					self.items = [];
				}
				if (response && response.data && response.data.length > 0) {
					self.items = self.items.concat(response.data);
					self.itemByGroup = makeGroup(self.items);
				}
				self.isLastPage = pagingUtils.isNoMorePageToLoad(self.searchParams.page, response);
				self.totalPhotos = pagingUtils.getTotalCount(response);
				self.totalPage = pagingUtils.getTotalPage(response);
				def.resolve(self);
			}, function () {
				self.spinner.isVisible = false;
				def.reject(self);
			});
		}
		function fetchMoreItems() {
			if (self.spinner.isVisible) {
				return;
			}
			self.searchParams.page++;
			fetchItems(self.searchParams);
		}
		function removeItem(removedItems){
			self.items = _.reject(self.items, function(item){
				return removedItems.indexOf(item.id) !== -1;
			})
			self.itemByGroup = makeGroup(self.items);
		}
		
	}
})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .directive('customCommissionDetailPagePhotoGrid', customCommissionDetailPagePhotoGrid);
    customCommissionDetailPagePhotoGrid.$inject = [];
    function customCommissionDetailPagePhotoGrid() {
        var directive = {
            restrict: 'E',
            scope: {
                onInit: '&?',
                onPhotoSelected: '&',
                customCommissionId: '@',
                settingsCustomComissionsTile: '=',
                viewMode: '@',
                itemCheckboxTooltip: '@',
                itemUncheckedCheckboxTooltip: '@',
                itemCheckedCheckboxTooltip: '@',
                hideComment: '='
            },
            templateUrl: 'app/custom-commissions-detail-page/components/custom-commission-detail-page-photo-grid/custom-commission-detail-page-photo-grid.html',
            controller: 'customCommissionDetailPagePhotoGridCtrl',
            controllerAs: 'vm',
            replace: true,
            transclude: true
          };
          return directive;
    }
})();                                                                  
(function () {

	angular
		.module('pixerf')
		.controller('customCommissionDetailPageGridControlsCtrl', customCommissionDetailPageGridControlsCtrl);

	customCommissionDetailPageGridControlsCtrl.$inject = ['$scope'];

	function customCommissionDetailPageGridControlsCtrl($scope) {

		var self = this;
		self.onSelectionChange = onSelectionChange
		self.selectedFilterItem = {}
		init();

		function onSelectionChange(item){
			$scope.onSelectionChange({item: item})
		}
		function init() {
			self.filterSetting = {
				"items": [
					{
						name: "Upload date",
						value: "date"
					},
					{
						name: "Notes",
						value: "comment_count"
					}
				]
			};
		}
	}
})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .directive('customCommissionDetailPageGridControls', customCommissionDetailPageGridControls);
    customCommissionDetailPageGridControls.$inject = [];
    function customCommissionDetailPageGridControls() {
        var directive = {
            restrict: 'E',
            scope: {
                onSelectionChange: '&'
            },
            templateUrl: 'app/custom-commissions-detail-page/components/custom-commission-detail-page-grid-controls/custom-commission-detail-page-grid-controls.html',
            controller: 'customCommissionDetailPageGridControlsCtrl',
            controllerAs: 'vm',
            replace: true
          };
          return directive;
    }
})();                                                                  
(function () {

	angular
		.module('pixerf')
		.controller('viewEventMembersCtrl', viewEventMembersCtrl);

		viewEventMembersCtrl.$inject = ['$scope', 'pagingUtils', 'ISO3166', 'eventData', '$q', 'pixerfApiEventSvc', 'sessionManagerSvc', 'toastr', 
			'translationSvc', '$stateParams', 'pixerfApiCommunitySvc', 'accountUtils'];

	function viewEventMembersCtrl($scope, pagingUtils, ISO3166, eventData, $q, pixerfApiEventSvc, sessionManagerSvc, toastr, 
			translationSvc, $stateParams, pixerfApiCommunitySvc, accountUtils) {

		var USER_CONTROL_ADMINDASHBOARD = ['curator_internal', 'admin_internal', 'marketer_internal'];
		var self = this;
		self.loginedUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.isAdmin = self.loginedUser && (USER_CONTROL_ADMINDASHBOARD.includes(self.loginedUser.role) || self.loginedUser.email === 'marcom@pixerf.com');
		self.parent = $scope.$parent.vm;
		self.spinner = {
			isVisible: false
		};
		self.event = eventData;
		self.members = [];
		self.stateName = 'attendees';
		self.onSearchMembers =  _.debounce(onSearchMembersByKeyword, 300);;
		self.searchMemberString = '';
		self.onRemovedUser = onRemovedUser;
		self.onStatusChanged = onStatusChanged;
		self.showAdmin = false;
		self.showStatus = false;
		self.customPagingOptions = {
			label: "Rows per page:",
			showValues: [30, 50, 100]
		}

		self.stateToMemberShip = {
			attendees: 'attendees',
			interested: 'interested',
			invited: 'invited'
		};
		self.parent.subContextPage = $stateParams.status;
		self.managerList = self.parent.managerList;
		self.community = self.parent.community;

		$scope.$watch('self.managerList', function (newValue, oldValue) {
			if(newValue){
				self.managerList = newValue;
				setUserRole();
			}
		});
		$scope.$watch('self.community', function (newValue, oldValue) {
			if(newValue){
				self.community = newValue;
			}
		});
		self.onPageSizeChanged = onPageSizeChanged;
		self.onListChanged = onListChanged;
		

		self.searchParams = {
			id: self.event.community_id,
			membership: 'accepted',
			page: 1,
			page_size: self.customPagingOptions.showValues[0]
		};
		self.sortByProps = sortByProps;

		function init() {
			self.memberShipName = getMemberShipFromStateName(self.stateName);
			if(!self.memberShipName) {
				toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
				return;
			}
			setUserLayout(self.stateName);
			getMemberOfCommunity(self.stateName);
		}

		function setUserRole(){
			for(var i = 0; i < self.members.length; i++){
				var containList = _.filter(self.managerList, function(item){ return item.id == self.members[i].id; });
				self.members[i].isCommunityManager = (containList && containList.length) ? true : false;
			}
		}

		function buildMembersProperty(members){
			for(var i = 0; i< members.length; i++){{
				var countryCode = (members[i].organization && members[i].organization.address) ? (members[i].organization.address.country ) : (members[i].address ? members[i].address.country : members[i].country);
				members[i].country = ISO3166.getCountryName(countryCode);
				members[i].inviteStatus = transformedUserStatus(members[i].status);
			}}
		}

		function transformedUserStatus(status){
			var result = 'Accepted';
			switch (status) {
				case 'not_responded':
					result = 'Not responded'
					break;
				case 'declined':
					result = 'Declined'
					break;
				case 'accepted':
					result = 'Accepted'
					break;
			}
			return result;
		}

		function sortByProps(propertyName, isActtionRequiredTable) {
			if (isActtionRequiredTable) {
				$scope.reverseActionRequired = ($scope.propertyActionRequiredName === propertyName) ? !$scope.reverseActionRequired : false;
				$scope.propertyActionRequiredName = propertyName;
			} else {
				$scope.reverse = ($scope.propertyName === propertyName) ? !$scope.reverse : false;
				$scope.propertyName = propertyName;
			}
		};

		function onPageSizeChanged(pageSize) {
			self.searchParams.page = 1;
			self.searchParams.page_size = pageSize;
		}

		function onListChanged(data) {
			self.searchParams.page = data.currentPage;
		}

		function getMemberOfCommunity(memberShipName) {

			switch (self.stateName) {
				case 'attendees':
					getEventAttendees('joined', self.searchParams);
					getMembersOfCommunity();
					break;
				case 'interested':
					getEventAttendees('interested', self.searchParams);
					getMembersOfCommunity();
					break;
				case 'invited':
					getEventInvited(self.searchParams);
					break;
			}
		}

		function getEventAttendees(status, params) {
			var defer = $q.defer();
			var eventId = self.event.id;
			if(!eventId){
				return defer.reject();
			}
			self.spinner.isVisible = true;
			pixerfApiEventSvc.getEventAttendees({
				id: eventId,
				status: status
			}).$promise.then(function (response) {
				self.members = filterEventAttendees(response.data);
				self.members = _.reject(self.members, function (item) {
						return item.id == self.loginedUser.id;
				})
				buildMembersProperty(self.members);
				setUserRole();
				self.stateName =='attendees' ? (self.event.stats.going = self.members.length) : '';
				self.isLastPage = pagingUtils.isNoMorePageToLoad(params.page, response);
				self.totalPage = pagingUtils.getTotalPage(response);
				self.totalMembers = pagingUtils.getTotalCount(response);
				self.searchParams.page = params.page;
				self.spinner.isVisible = false;
				defer.resolve(response.data);
			}, function (err) {
				console.log(err);
				defer.reject(err);
				self.spinner.isVisible = false;
			})
			return defer.promise;
		}

		function filterEventAttendees(users){
			var result = [];
			for(var i =0; i < users.length; i++){
				users[i].user.displayName = accountUtils.buildUserDisplayName(users[i].user);
				users[i].user.avatar = accountUtils.buildUserAvatarPhotoUrl(users[i].user);
				result.push(users[i].user);
			}
			return result;
		} 

		function getMembersOfCommunity() {
			var params = {
				id: self.event.community_id,
				membership: 'accepted'
			};
			pixerfApiCommunitySvc.get_members(params).$promise.then(function (res) {
				self.CommunityMembers = res.data;
				for(var i = 0; i < self.members.length; i++){
					var containList = _.filter(self.CommunityMembers, function(item){ return item.id == self.members[i].id; });
					self.members[i].isCommunityMember = ((containList && containList.length) || (self.members[i].id == self.event.owner.id)) ? true : false;
				}

			}).catch(function (err) {
				console.log(err)
			})
		}

		function getEventInvited(params) {
			var defer = $q.defer();
			self.spinner.isVisible = true;
			var eventId = self.event.id;
			if(!eventId){
				return defer.reject();
			}
			pixerfApiEventSvc.getEventInvited({
				id: eventId
			}).$promise.then(function (response) {
				self.members = transformedUserList(response.data);
				buildMembersProperty(self.members)
				setUserRole();
				getMembersOfCommunity();
				self.isLastPage = pagingUtils.isNoMorePageToLoad(params.page, response);
				self.totalPage = pagingUtils.getTotalPage(response);
				self.totalMembers = pagingUtils.getTotalCount(response);
				self.searchParams.page = params.page;
				self.spinner.isVisible = false;
				defer.resolve(self.members);
			}, function (err) {
				console.log(err);
				defer.reject(err);
				self.spinner.isVisible = false;
			})
			return defer.promise;
		}

		function transformedUser(data){
			var user = (data.user ? data.user : data);
			user.displayName = user.first_name ? (user.first_name + ' ' + user.last_name) : user.email;
			return user;
		}

		function transformedUserList(data){
			var people = [];
			for (var i = 0; i < data.length; i++) {
				people.push(transformedUser(data[i]));
			}
			return people;
		}

		function getMemberShipFromStateName(stateName){
			return self.stateToMemberShip[stateName];
		}

		function onSearchMembersByKeyword(){
			getMemberOfCommunity(self.memberShipName);
		}

		function onRemovedUser(member){
			self.members = _.reject(self.members, function (item) {
				return item.id === member.id;
			})
		}

		function onStatusChanged(member){
			self.members = _.reject(self.members, function (item) {
				return item.id === member.id;
			})
		}
		function setUserLayout(type) {
			switch (type) {
				case 'attendees':
					self.showAdmin = true;
					self.showInvitationFrom = false;
					self.showStatus = false
					
					break;
				case 'interested':
					self.showAdmin = false;
					self.showStatus = false
					
					break;
				case 'invited':
					self.showAdmin = false;
					self.showStatus = true
					
					break;
			}
		}

		init();
		
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('viewEventPendingPostsCtrl', viewEventPendingPostsCtrl);

        viewEventPendingPostsCtrl.$inject = ['$scope', 'sessionManagerSvc', 'eventData', 'pixerfApiCommunitySvc', 'pagingUtils', 'removeMemberPopupSvc', 'blockMemberPopupSvc', 'confirmSuccessPopupSvc', '$state', 'pixerfApiCommunityDiscussionSvc', '$q', 'confirmPopupSvc'];

	function viewEventPendingPostsCtrl($scope, sessionManagerSvc, eventData, pixerfApiCommunitySvc, pagingUtils, removeMemberPopupSvc, blockMemberPopupSvc, confirmSuccessPopupSvc, $state, pixerfApiCommunityDiscussionSvc, $q, confirmPopupSvc ) {

		var self = this;
		self.isWorking = false;
		self.parent = $scope.$parent.vm;
		self.spinner = {
			isVisible: false
		}
		self.isLastPage = false;
		self.posts = [];
        self.event = eventData;
		self.loginUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.isOwner = self.loginUser && self.loginUser.id === self.event.owner.id;
        self.arrangeOptions = {
			props: "arrangeBy",
			selections: [{
					label: "recent",
					value: "inserted_at"
				},
				{
					label: "bookmarked",
					value: "is_bookmarked"
				}
			]
		};
		self.submitButtonText = "Join Community";
		self.arrangeBy= {arrangeBy: 'inserted_at'};
		self.defaultArrangeBy = {arrangeBy: self.arrangeOptions.selections[0].value};
        self.searchParams = {
			id: self.event.id,
			page: 1,
			status: 'pending',
			sort: self.defaultArrangeBy.arrangeBy
		};
		self.onRemoveFromCommunity = onRemoveFromCommunity;
		self.onBlockFromCommunity = onBlockFromCommunity;
		self.onApprovePost = onApprovePost;
		self.onRejectPost = onRejectPost;
		self.fetchMoreDisPosts = fetchMoreDisPosts;
		self.community = self.parent.community;
		$scope.$watch('self.community', function (newValue, oldValue) {
			if(newValue){
				self.community = newValue;
			}
		});

		function init() {
			if (!self.community.is_private || (self.loginUser && self.community.is_private && (self.community.membership_status === 'accepted' || self.community.membership_status === 'owner'))) {
				getPosts(self.searchParams, true);
			}
			if (self.community.is_private && self.community.membership_status === 'requested') {
				self.submitButtonText = "Requested";
			}
		}

		function getPosts(params, isFresh) {
			self.searchParams = params;
			self.spinner.isVisible = true;
			self.isWorking = true;
			pixerfApiCommunitySvc.get_post_by_event_id(self.searchParams).$promise.then(function (res) {
				if (!self.posts || isFresh) self.posts = [];
				self.posts = self.posts.concat(res.data);
				self.isLastPage = pagingUtils.isNoMorePageToLoad(self.searchParams.page, res);
				self.spinner.isVisible = false;
				self.searchParams.page = params.page;
				self.isWorking = false;
			}).catch(function (err) {
				self.isWorking = false;
				self.spinner.isVisible = false;
				console.log(err);
			})
		}

		function fetchMoreDisPosts() {
			if (self.isLastPage || self.spinner.isVisible) return;
			var searchParms = $.extend(true, {}, self.searchParams);
			searchParms.page++;
			getPosts(searchParms);
		}

		function onRemoveUser(member){
			self.posts = _.reject(self.posts, function (item) {
				return item.user.id === member.id;
			})
		}

		function showConfirmSuccessPopupMessage(message) {
			confirmSuccessPopupSvc.showPopup({
				windowClass: 'manager-member-list-view__confirm-success-popup',
				message: message
			});
		}

		function onRemoveFromCommunity(member) {
			var removePopup = removeMemberPopupSvc.showPopup({
				community: self.community,
				user: member
			})
			removePopup.result.then(function (data) {
				onRemoveUser(member);
				showConfirmSuccessPopupMessage((member.displayName || member.email) + ' has been removed from your Community.');
			})
		}

		function onApprovePost(post) {
			pixerfApiCommunitySvc.update_event_post_status({
				id: post.id,
				action: 'approve'
			}, {}).$promise.then(function (respone) {
				self.posts = _.reject(self.posts, function (item) {
					return item.id === post.id;
				})
			}).catch(function (err) {
				console.log(err);
			});
		}

		function onRejectPost(post) {
			confirmPopupSvc.showPopup({
				windowClass: 'reject-discussion-popup',
				title: "You're about to reject this post.",
				message: 'Rejected post will be permanently deleted and the member will not be notified. Are you sure?',
				submitBtnText: 'Confirm',
				cancelBtnText: 'Cancel',
				submit: function () {
					var def = $q.defer();
					pixerfApiCommunitySvc.update_event_post_status({
						id: post.id,
						action: 'reject'
					}, {}).$promise.then(function (respone) {
						self.posts = _.reject(self.posts, function (item) {
							return item.id === post.id;
						})
						def.resolve(respone);
					}).catch(function (err) {
						def.reject(err);
					})
					return def.promise;
				}
			});
		}

		function onBlockFromCommunity(member) {

			var blockPopup = blockMemberPopupSvc.showPopup({
				community: self.community,
				user: member
			})
			blockPopup.result.then(function (data) {
				if(data && data.user){
					onRemoveUser(member);
					showConfirmSuccessPopupMessage('<strong>' + (member.displayName || member.email) + '</strong> has been blocked from your Community.');
				}
			}).catch(function (err) {
				console.log(err);
			})
		}

		init();
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('viewCommunityMembersCtrl', viewCommunityMembersCtrl);

	viewCommunityMembersCtrl.$inject = ['$scope', 'ISO3166', '$timeout', 'communityData', 'pixerfApiCommunitySvc', 'pagingUtils', 'sessionManagerSvc', 'toastr', 'translationSvc', '$stateParams', '$state'];

	function viewCommunityMembersCtrl($scope, ISO3166, $timeout, communityData, pixerfApiCommunitySvc, pagingUtils, sessionManagerSvc, toastr, translationSvc, $stateParams, $state) {

		var USER_CONTROL_ADMINDASHBOARD = ['curator_internal', 'admin_internal', 'marketer_internal'];
		var self = this;
		self.loginedUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.isAdmin = self.loginedUser && (USER_CONTROL_ADMINDASHBOARD.includes(self.loginedUser.role) || self.loginedUser.email === 'marcom@pixerf.com');
		self.parent = $scope.$parent.vm;
		self.spinner = {
			isVisible: false
		};
		self.community = communityData;
		self.members = [];
		self.onSearchMembers = _.debounce(onSearchMembersByKeyword, 300);;
		self.searchMemberString = '';
		self.onRemovedUser = onRemovedUser;
		self.onStatusChanged = onStatusChanged;
		self.showMemberSince = false;
		self.showDateRequest = false;
		self.showDateInvited = false;
		self.showDateBlocked = false;
		self.showAdmin = false
		self.showInvitationFrom = false;
		self.customPagingOptions = {
			label: "Rows per page:",
			showValues: [30, 50, 100]
		}
		self.parent.subContextPage = $stateParams.status;
		self.onPageSizeChanged = onPageSizeChanged;
		self.onListChanged = onListChanged;
		self.selectedspecialties = [];
		self.searchParams = {
			id: self.community.id,
			membership: 'accepted',
			page: 1,
			page_size: self.customPagingOptions.showValues[0]
		};
		self.sortByProps = sortByProps;
		self.reverse = false;
		self.onSpecialtyFilterChanged = onSpecialtyFilterChanged;
		self.onTypeFilterChanged = onTypeFilterChanged;
		self.stateName = $stateParams.status;
		self.listViewType = 'viewMembers';

		function init() {
			if (self.stateName != 'members') {
				$state.go("404");
			}
			self.memberShipName = 'accepted';
			setUserLayout();
			getMemberOfCommunity(self.searchParams, true);
			getSpecialitiesCount();
			self.isUserManager = self.parent.isManager();
		}

		function sortByProps(propertyName, isActtionRequiredTable) {
			if (isActtionRequiredTable) {
				$scope.reverseActionRequired = ($scope.propertyActionRequiredName === propertyName) ? !$scope.reverseActionRequired : false;
				$scope.propertyActionRequiredName = propertyName;
			} else {
				self.reverse = ($scope.propertyName === propertyName) ? !self.reverse : false;
				$scope.propertyName = propertyName;
			}
		};

		function clearFilter() {
			delete self.searchParams.specialities;
			delete self.searchParams.ambassadorship;
		}

		function onTypeFilterChanged(selectedItems) {
			self.selectedSpecialties = [];
			clearFilter();
			var types = (_.pluck(selectedItems, 'value'));
			if (types && types.length) {
				self.searchParams.ambassadorship = types.toString()
			}
			getMemberOfCommunity(self.searchParams, true);
		}

		function onSpecialtyFilterChanged(selectedItems) {
			self.selectedTypes = [];
			clearFilter();
			var specialities = (_.pluck(selectedItems, 'value'));
			if (specialities && specialities.length) {
				self.searchParams.specialities = specialities.toString()
			}
			getMemberOfCommunity(self.searchParams, true);
		}

		function buildSpecialties(specialties) {
			self.specialtyFilterOptions = [];
			for (key in specialties) {
				if (specialties[key].user_count > 0) {
					var option = {
						label: specialties[key].speciality + ' (' + specialties[key].user_count + ')',
						value: specialties[key].id
					}
					self.specialtyFilterOptions.push(option);
				}
			}
		}

		function buildMemberAccountTypes() {
			self.accountTypeFilterOptions = [{
					value: 'maestro',
					label: 'Ambassador Maestro' + ' (' + self.community.stats.ambassador_maestro_count + ')',
					count: self.community.stats.ambassador_maestro_count
				},
				{
					value: 'pro',
					label: 'Ambassador Pro' + ' (' + self.community.stats.ambassador_pro_count + ')',
					count: self.community.stats.ambassador_pro_count
				},
				{
					value: 'pixerfer',
					label: 'Pixerfer' + ' (' + self.community.stats.pixerfer_count + ')',
					count: self.community.stats.pixerfer_count
				}
			];

			self.accountTypeFilterOptions = _.reject(self.accountTypeFilterOptions, function (item) {
				return item.count <= 0;
			})
		}

		function buildAccountTypes() {

			if ($stateParams.status == 'members') {
				return buildMemberAccountTypes();
			}

			self.accountTypeFilterOptions = [];
		}

		function onPageSizeChanged(pageSize) {
			self.searchParams.page = 1;
			self.searchParams.page_size = pageSize;
			getMemberOfCommunity(self.searchParams, true);
		}

		function onListChanged(data) {
			self.searchParams.page = data.currentPage;
			getMemberOfCommunity(self.searchParams, true);
		}

		function buildMembersProperty(members) {
			for (var i = 0; i < members.length; i++) {
				{
					var countryCode = (members[i].organization && members[i].organization.address) ? (members[i].organization.address.country) : (members[i].address ? members[i].address.country : '');
					members[i].country = ISO3166.getCountryName(countryCode);
				}
			}
		}

		function getMemberOfCommunity(params, isRefresh) {
			if (self.spinner.isVisible) return;
			self.spinner.isVisible = true;
			if (isRefresh) {
				self.totalMembers = 0;
				self.totalPage = 0;
			}
			if (self.searchMemberString) {
				params.keywords = self.searchMemberString;
				params.page = 1;
			} else {
				delete params.keywords;
			}
			pixerfApiCommunitySvc.get_members(params).$promise.then(function (res) {
				self.members = res.data;
				for (var i = 0; i < self.members.length; i++) {
					self.members[i].avatar = {
						profileImage: self.members[i].profile_image_media['300x']
					};
				}
				buildAccountTypes(self.members);
				buildMembersProperty(self.members);
				self.isLastPage = pagingUtils.isNoMorePageToLoad(params.page, res);
				self.totalPage = pagingUtils.getTotalPage(res);
				self.totalMembers = pagingUtils.getTotalCount(res);
				self.searchParams.page = params.page;
				self.spinner.isVisible = false;
			}).catch(function (err) {
				self.spinner.isVisible = false;
				console.log(err)
			})
		}

		function getSpecialitiesCount() {
			pixerfApiCommunitySvc.getSpecialitiesCount({
				id: self.community.id,
				membership: self.memberShipName
			}).$promise.then(function (res) {
				buildSpecialties(res.data);
			}).catch(function (err) {
				console.log(err)
			})
		}

		function onSearchMembersByKeyword() {
			getMemberOfCommunity(self.memberShipName);
		}

		function onRemovedUser(member) {
			self.members = _.reject(self.members, function (item) {
				return item.id === member.id;
			})
		}

		function onStatusChanged(member) {
			self.members = _.reject(self.members, function (item) {
				return item.id === member.id;
			})
		}

		function setUserLayout() {
			self.showMemberSince = true;
			self.showDateRequest = false;
			self.showDateInvited = false;
			self.showDateBlocked = false;
			self.showAdmin = true;
			self.showInvitationFrom = false;
			self.joinDate = 'membership_joined_at';
		}

		init();

	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('viewCommunityPendingPostsCtrl', viewCommunityPendingPostsCtrl);

        viewCommunityPendingPostsCtrl.$inject = ['$scope', 'sessionManagerSvc', 'communityData', 'pixerfApiCommunitySvc', 'pagingUtils', 'removeMemberPopupSvc', 'blockMemberPopupSvc', 'confirmSuccessPopupSvc', 'createDiscussionTopicPopupSvc', 'pixerfApiCommunityDiscussionSvc', '$q', 'confirmPopupSvc'];

	function viewCommunityPendingPostsCtrl($scope, sessionManagerSvc, communityData, pixerfApiCommunitySvc, pagingUtils, removeMemberPopupSvc, blockMemberPopupSvc, confirmSuccessPopupSvc, createDiscussionTopicPopupSvc, pixerfApiCommunityDiscussionSvc, $q, confirmPopupSvc ) {

		var self = this;
		self.isWorking = false;
		self.spinner = {
			isVisible: false
		}
		self.isLastPage = false;
		self.discussions = [];
        self.community = communityData;
		self.isMember = self.community.membership_status === 'accepted';
		self.loginUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.isBusinessAcc = self.loginUser && self.loginUser.account_type === 'business';
		self.isOwner = self.loginUser && self.loginUser.id === self.community.owner.id;
		self.fetchMoreDiscussions = fetchMoreDiscussions;
        self.arrangeOptions = {
			props: "arrangeBy",
			selections: [{
					label: "recent",
					value: "inserted_at"
				},
				{
					label: "bookmarked",
					value: "is_bookmarked"
				}
			]
		};
		self.submitButtonText = "Join Community";
		self.arrangeBy= {arrangeBy: 'inserted_at'};
		self.defaultArrangeBy = {arrangeBy: self.arrangeOptions.selections[0].value};
        self.searchParams = {
			id: self.community.id,
			page: 1,
			status: 'pending',
			sort: self.defaultArrangeBy.arrangeBy
		};
		self.onRemoveFromCommunity = onRemoveFromCommunity;
		self.onBlockFromCommunity = onBlockFromCommunity;
		self.onApproveDiscussion = onApproveDiscussion;
		self.onRejectDiscussion = onRejectDiscussion;
		self.onDeleteDiscussion = onDeleteDiscussion;

		function init() {
			if (!self.community.is_private || (self.loginUser && self.community.is_private && (self.community.membership_status === 'accepted' || self.community.membership_status === 'owner'))) {
				getDiscussions(self.searchParams, true);
			}
			if (self.community.is_private && self.community.membership_status === 'requested') {
				self.submitButtonText = "Requested";
			}
		}

		function filterDiscussion(discussions){
			_.each(discussions, function(item) { 
				item.content_type = 'discussion';
			 });
			var result = _.reject(discussions, function (d) {
				return d.user && d.user.id != self.loginUser.id;
			})
			return discussions;//TODO
		}

		function getDiscussions(params, isFresh) {
			self.searchParams = params;
			self.spinner.isVisible = true;
			self.isWorking = true;
			pixerfApiCommunitySvc.get_discussions_by_community_id(self.searchParams).$promise.then(function (res) {
				if (!self.discussions || isFresh) self.discussions = [];
				self.discussions = filterDiscussion(self.discussions.concat(res.data));
				self.isLastPage = pagingUtils.isNoMorePageToLoad(self.searchParams.page, res);
				self.spinner.isVisible = false;
				self.searchParams.page = params.page;
				self.isWorking = false;
			}).catch(function (err) {
				self.isWorking = false;
				self.spinner.isVisible = false;
				console.log(err);
			})
		}

		function fetchMoreDiscussions() {
			if (self.isLastPage || self.spinner.isVisible) return;
			var searchParms = $.extend(true, {}, self.searchParams);
			searchParms.page++;
			getDiscussions(searchParms);
		}

		function onRemoveUser(member){
			self.discussions = _.reject(self.discussions, function (item) {
				return item.user.id === member.id;
			})
		}

		function showConfirmSuccessPopupMessage(message) {
			confirmSuccessPopupSvc.showPopup({
				windowClass: 'manager-member-list-view__confirm-success-popup',
				message: message
			});
		}

		function onRemoveFromCommunity(member) {
			var removePopup = removeMemberPopupSvc.showPopup({
				community: self.community,
				user: member
			})
			removePopup.result.then(function (data) {
				onRemoveUser(member);
				showConfirmSuccessPopupMessage((member.displayName || member.email) + ' has been removed from your Community.');
			})
		}

		function onApproveDiscussion(discussion) {
			pixerfApiCommunityDiscussionSvc.move_status({
				id: discussion.id,
				action: 'approve'
			}, {}).$promise.then(function (respone) {
				return pixerfApiCommunitySvc.update_discussion({
					id: discussion.id
				}, {
					status: 'published'
				}).$promise;
			}).then(function (respone) {
				self.discussions = _.reject(self.discussions, function (item) {
					return item.id === discussion.id;
				})
			}).catch(function (err) {
				console.log(err);
			});
		}

		function onRejectDiscussion(discussion) {
			confirmPopupSvc.showPopup({
				windowClass: 'reject-discussion-popup',
				title: "You're about to reject this post.",
				message: 'Rejected post will be permanently deleted and the member will be notified. Are you sure?',
				submitBtnText: 'Confirm',
				cancelBtnText: 'Cancel',
				submit: function () {
					var def = $q.defer();
					pixerfApiCommunityDiscussionSvc.move_status({
						id: discussion.id,
						action: 'reject'
					}, {}).$promise.then(function (respone) {
						self.discussions = _.reject(self.discussions, function (item) {
							return item.id === discussion.id;
						})
						def.resolve(respone);
					}).catch(function (err) {
						def.reject(err);
					})
					return def.promise;
				}
			});
		}

		function onRemoved(discussion){
			self.discussions = _.reject(self.discussions, function (item) {
				return item.id === discussion.id;
			})
		}

		function onDeleteDiscussion(discussion){
			if(discussion.content_type == 'discussion'){
				onDeleteDiscussion(discussion)
			}else{
				onRemoveComment(discussion)
			}
		}
		
		function onDeleteDiscussion(discussion){
			var popup = confirmPopupSvc.showPopup({
				windowClass: 'remove-discussion-confirm-popup',
				title: 'Are you sure you want to delete this post?',
				message: 'You will lose all the engagements and comments from this post.',
				submitBtnText: 'Yes, delete it',
				cancelBtnText: 'No, keep it',
				submit: function () {
					var def = $q.defer();
					pixerfApiCommunitySvc.remove_disscussion({
						id: discussion.id
					}).$promise.then(function (res) {
						self.discussions = _.reject(self.discussions, function (item) {
							return item.id === discussion.id;
						})
						self.discussions = _.reject(self.discussions, function (item) {
							return item.id === discussion.id;
						})
						def.resolve(res);
					}).catch(function (err) {
						def.reject(err);
					})
					return def.promise;
				},
				submitCallback: function (res) {
					$scope.onRemoved(res);
				}
			});

			return popup;
		}

		function onRemoveComment(comment, subComment) {
			pixerfApiCommunitySvc.remove_reply({
				id: comment.id
			}).$promise.then(function (res) {
				self.discussions = _.reject(self.discussions, function (item) {
					return item.id === discussion.id;
				})
				if (subComment) {
					self.subComments = _.reject(self.subComments, function (item) {
						return item.id === comment.id;
					})
					self.comment.reply_count--;
				} else {
					$scope.onRemoved({
						data: comment
					});
				}
			}).catch(function (err) {
				console.log(err);
			})
		}

		function onBlockFromCommunity(member) {

			var blockPopup = blockMemberPopupSvc.showPopup({
				community: self.community,
				user: member
			})
			blockPopup.result.then(function (data) {
				if(data && data.user){
					onRemoveUser(member);
					showConfirmSuccessPopupMessage('<strong>' + (member.displayName || member.email) + '</strong> has been blocked from your Community.');
				}
			}).catch(function (err) {
				console.log(err);
			})
		}

		init();
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('verificationVerifiedUsersCtrl', verificationVerifiedUsersCtrl);

	verificationVerifiedUsersCtrl.$inject = ['$scope', 'pixerfApiUserSvc', 'pagingUtils'];

	function verificationVerifiedUsersCtrl($scope, pixerfApiUserSvc, pagingUtils) {
		var self = this;
		self.parent = $scope.$parent.vm;
		self.parent.contextPage = "Verified users";
		self.fetchMoreUsers = fetchMoreUsers;
		self.users = [];
		self.searchParams = {
			verification_status: 'verified',
			page: 1
		}
		self.spinner = {
			isVisible: false
		}

		init();

		function init() {
			getNewSignupUsers(self.searchParams);
		}

		function getNewSignupUsers(searchParams) {
			if (self.spinner.isVisible) return;
			self.spinner.isVisible = true;
			pixerfApiUserSvc.query(searchParams).$promise.then(function (response) {
				self.users = self.users.concat(response.data);
				self.isLastPage = pagingUtils.isNoMorePageToLoad(self.searchParams.page, response);
				self.spinner.isVisible = false;
				self.searchParams.page = searchParams.page;
			}).catch(function () {
				self.spinner.isVisible = false;
			})
		}

		function fetchMoreUsers() {
			if (self.isLastPage || self.spinner.isVisible) return;
			var searchParams = $.extend(true, {}, self.searchParams);
			searchParams.page++;
			getNewSignupUsers(searchParams);
		}
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('verificationRespondedUsersCtrl', verificationRespondedUsersCtrl);

	verificationRespondedUsersCtrl.$inject = ['$scope', 'pixerfApiUserSvc', 'pagingUtils'];

	function verificationRespondedUsersCtrl($scope, pixerfApiUserSvc, pagingUtils) {
		var self = this;
        self.parent = $scope.$parent.vm;
		self.parent.contextPage = "Responded users";
        self.onUserStatusChanged = onUserStatusChanged;
        self.fetchMoreUsers = fetchMoreUsers;
		self.users = [];
		self.searchParams = {
            verification_status: 'pending_further_review',
			page: 1
		}
		self.spinner = {
			isVisible: false
		}

		init();

		function init() {
			getNewSignupUsers(self.searchParams);
		}

        function getNewSignupUsers(searchParams) {
			if (self.spinner.isVisible) return;
			self.spinner.isVisible = true;
			pixerfApiUserSvc.query(searchParams).$promise.then(function (response) {
				self.users = self.users.concat(response.data);
				self.isLastPage = pagingUtils.isNoMorePageToLoad(self.searchParams.page, response);
				self.spinner.isVisible = false;
				self.searchParams.page = searchParams.page;
			}).catch(function () {
				self.spinner.isVisible = false;
			})
		}

		function fetchMoreUsers() {
			if (self.isLastPage || self.spinner.isVisible) return;
			var searchParams = $.extend(true, {}, self.searchParams);
			searchParams.page++;
			getNewSignupUsers(searchParams);
		}

        function onUserStatusChanged(user){
            self.users = _.reject(self.users, function (item) {
				return item.id === user.id;
			});
        }
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('verificationRejectedUsersCtrl', verificationRejectedUsersCtrl);

	verificationRejectedUsersCtrl.$inject = ['$scope', 'pixerfApiUserSvc', 'pagingUtils'];

	function verificationRejectedUsersCtrl($scope, pixerfApiUserSvc, pagingUtils) {
		var self = this;
        self.parent = $scope.$parent.vm;
		self.parent.contextPage = "Rejected users";
        self.onUserStatusChanged = onUserStatusChanged;
        self.fetchMoreUsers = fetchMoreUsers;
		self.users = [];
		self.searchParams = {
            verification_status: 'rejected',
			page: 1
		}
		self.spinner = {
			isVisible: false
		}

		init();

		function init() {
			getUsers(self.searchParams);
		}

        function getUsers(searchParams) {
			if (self.spinner.isVisible) return;
			self.spinner.isVisible = true;
			pixerfApiUserSvc.query(searchParams).$promise.then(function (response) {
				self.users = self.users.concat(response.data);
				self.isLastPage = pagingUtils.isNoMorePageToLoad(self.searchParams.page, response);
				self.spinner.isVisible = false;
				self.searchParams.page = searchParams.page;
			}).catch(function () {
				self.spinner.isVisible = false;
			})
		}

		function fetchMoreUsers() {
			if (self.isLastPage || self.spinner.isVisible) return;
			var searchParams = $.extend(true, {}, self.searchParams);
			searchParams.page++;
			getUsers(searchParams);
		}

        function onUserStatusChanged(user){
            self.users = _.reject(self.users, function (item) {
				return item.id === user.id;
			});
        }
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('verificationPendingUserResponseCtrl', verificationPendingUserResponseCtrl);

	verificationPendingUserResponseCtrl.$inject = ['$scope', 'pixerfApiUserSvc', 'pagingUtils'];

	function verificationPendingUserResponseCtrl($scope, pixerfApiUserSvc, pagingUtils) {
		var self = this;
        self.parent = $scope.$parent.vm;
		self.parent.contextPage = "Pending user response";
        self.fetchMoreUsers = fetchMoreUsers;
        self.onUserStatusChanged = onUserStatusChanged;
		self.users = [];
		self.searchParams = {
            verification_status: 'changes_requested',
			page: 1
		}
		self.spinner = {
			isVisible: false
		}

		init();

		function init() {
			getNewSignupUsers(self.searchParams);
		}

        function getNewSignupUsers(searchParams) {
			if (self.spinner.isVisible) return;
			self.spinner.isVisible = true;
			pixerfApiUserSvc.query(searchParams).$promise.then(function (response) {
				self.users = self.users.concat(response.data);
				self.isLastPage = pagingUtils.isNoMorePageToLoad(self.searchParams.page, response);
				self.spinner.isVisible = false;
				self.searchParams.page = searchParams.page;
			}).catch(function () {
				self.spinner.isVisible = false;
			})
		}

		function fetchMoreUsers() {
			if (self.isLastPage || self.spinner.isVisible) return;
			var searchParams = $.extend(true, {}, self.searchParams);
			searchParams.page++;
			getNewSignupUsers(searchParams);
		}

        function onUserStatusChanged(user){
            self.users = _.reject(self.users, function (item) {
				return item.id === user.id;
			});
        }
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('verificationNewSignUpCtrl', verificationNewSignUpCtrl);

	verificationNewSignUpCtrl.$inject = ['$scope', 'pixerfApiUserSvc', 'pagingUtils'];

	function verificationNewSignUpCtrl($scope, pixerfApiUserSvc, pagingUtils) {
		var self = this;
		self.parent = $scope.$parent.vm;
		self.parent.contextPage = "New sign-up";
        self.onUserStatusChanged = onUserStatusChanged;
        self.fetchMoreUsers = fetchMoreUsers;
		self.users = [];
		self.searchParams = {
            verification_status: 'pending_initial_review',
			page: 1
		}
		self.spinner = {
			isVisible: false
		}

		init();

		function init() {
			getNewSignupUsers(self.searchParams);
		}

        function getNewSignupUsers(searchParams) {
			if (self.spinner.isVisible) return;
			self.spinner.isVisible = true;
			pixerfApiUserSvc.query(searchParams).$promise.then(function (response) {
				self.users = self.users.concat(response.data);
				self.isLastPage = pagingUtils.isNoMorePageToLoad(self.searchParams.page, response);
				self.spinner.isVisible = false;
				self.searchParams.page = searchParams.page;
			}).catch(function () {
				self.spinner.isVisible = false;
			})
		}

		function fetchMoreUsers() {
			if (self.isLastPage || self.spinner.isVisible) return;
			var searchParams = $.extend(true, {}, self.searchParams);
			searchParams.page++;
			getNewSignupUsers(searchParams);
		}

        function onUserStatusChanged(user){
            self.users = _.reject(self.users, function (item) {
				return item.id === user.id;
			});
        }
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('purchaseHistoryMissionDetailsCtrl', purchaseHistoryMissionDetailsCtrl);

	purchaseHistoryMissionDetailsCtrl.$inject = ['$scope', '$stateParams', 'pixerfApiOrdersSvc', 'pixerfApiDownloadSvc', 'pixerfUrl', 'toastr', '$timeout', 'translationSvc', '$state'];

	function purchaseHistoryMissionDetailsCtrl($scope, $stateParams, pixerfApiOrdersSvc, pixerfApiDownloadSvc, pixerfUrl, toastr, $timeout, translationSvc, $state) {
		var self = this;
		self.spinner = {
			isVisible: false
		};
		self.onBackBtnClicked = onBackBtnClicked;
		self.orderId = $stateParams.orderId;
		self.onDownloadBtnClicked = onDownloadBtnClicked;
		$scope.$parent.vm.hideHeaderBar = true;

		self.searchParams = {
			orderId: self.orderId
		};

		fetchPurchasedItems(self.searchParams, true);

		function onDownloadBtnClicked(evt, item, type) {
			var service = type ? type : "download";
			if (self.isWorking) {
				return;
			}
			self.isWorking = true;
			pixerfApiDownloadSvc.get({
				id: item.id
			}).$promise.then(function (response) {
				item.downloadLink = pixerfUrl.full + "api/" + service + "?token=" + response.token;
				$timeout(function () {
					$(evt.target).next("a")[0].click();
					$timeout(function () {
						self.isWorking = false;
					})
				})
			}, function () {
				self.isWorking = false;
				toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
			})
		}

		function fetchPurchasedItems(searchParams, isFresh) {
			self.spinner.isVisible = true;
			if (isFresh) self.item = {};
			pixerfApiOrdersSvc.getById(searchParams).$promise.then(function (response) {
				self.spinner.isVisible = false;
				if (response && response.data) {
					self.item = response.data;
				}
			}, function () {
				self.spinner.isVisible = false;
				toastr.error('Failed to get purchased items. Please try again.');
			})
		}

		function onBackBtnClicked() {
			// window.history.go(-1);
			$state.go("setting.purchase-history.order-list");
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('orderListCtrl', orderListCtrl);

	orderListCtrl.$inject = ['$scope', 'pixerfApiDownloadSvc', '$timeout', 'toastr', 'pixerfApiOrdersSvc', 'pagingUtils', 'purchaseHistorySvc', 'pixerfUrl', '$stateParams', 'translationSvc'];

	function orderListCtrl($scope, pixerfApiDownloadSvc, $timeout, toastr, pixerfApiOrdersSvc, pagingUtils, purchaseHistorySvc, pixerfUrl, $stateParams, translationSvc) {
		var self = this;
		self.orderListCtrl = $scope.$parent.vm;
		$scope.$parent.$parent.vm.contextPage = "Purchase History";
		$scope.$parent.vm.navigation.context = "Stock";
		self.orderListCtrl.hideHeaderBar = false;
		self.spinner = {
			isVisible: false
		}
		self.selectedItems = [];
		self.onDownloadBtnClicked = onDownloadBtnClicked;
		self.onDownloadSelectedItemsClicked = onDownloadSelectedItemsClicked;
		self.fetchMorePurchasedItems = fetchMorePurchasedItems;
		self.onSearchFilterClick = onSearchFilterClick;
		self.onFilterChanged = onFilterChanged;
		self.onSelectedItem = onSelectedItem;
		self.onSelectedImage = onSelectedImage;
		self.onArrageChanged = onArrageChanged;
		self.onDownloadReceipts = onDownloadReceipts;
		self.orderListCtrl.orderId = $stateParams.orderId;
		self.onSearch = _.debounce(onSearch, 300);
		self.totalItem = 0;
		self.fromDate = {};
		self.toDate = {};
		self.selectedFilter = {
			fromDate: '',
			toDate: '',
		};
		self.searchParams = {
			page: 1,
			start_date: null,
			end_date: null
		};
		self.viewBy = 'images';
		self.viewByProps = {};
		self.viewByOptions = {
			props: "viewBy",
			selections: [{
					label: "Dates",
					value: "order"
				},
				{
					label: "Images",
					value: "images"
				}
			]
		}
		self.downloadText = 'Download all receipts';

		initList();

		function initList() {
			onSearchFilterClick(self.selectedFilter, 'MOST_RECENT');
		}

		$scope.$watch('vm.selectedFilter', function () {
			onSearchFilterClick(self.selectedFilter, 'DURATION');
		}, true)

		function onSearchFilterClick(filter, type) {
			if (filter) {
				filter.type = type;
				var timeRange = purchaseHistorySvc.getTimeRange(filter);
				if (timeRange) {
					self.searchParams.start_date = timeRange.start_date;
					self.searchParams.end_date = timeRange.end_date;
				}
			}
			fetchPurchasedItems(self.searchParams, true);
		}

		function fetchPurchasedItems(searchParams, isFresh) {
			self.spinner.isVisible = true;
			if (isFresh) self.items = [];
			if (self.viewBy === 'images') {
				searchParams.type = 'images';
			} else {
				delete searchParams.type;
			}
			pixerfApiOrdersSvc.post(searchParams).$promise.then(function (response) {
				if (searchParams.page === 1) self.items = [];
				self.spinner.isVisible = false;
				if (response && response.data && response.data.length > 0) {
					self.items = self.items.concat(response.data);
					self.items = translateListMethod(self.items);
					self.items = transformFormatedLicense(self.items);
					self.totalItem = getTotalItem(response);
				}
				self.isLastPage = pagingUtils.isNoMorePageToLoad(searchParams.page, response);

			}, function () {
				self.spinner.isVisible = false;
				toastr.error(translationSvc.FAILED_TO_DO_SOMETHING('FAILED_ORDER_LIST', true));
			})
		}

		function fetchMorePurchasedItems() {
			if (self.spinner.isVisible) {
				return;
			}
			self.searchParams.page++;
			fetchPurchasedItems(self.searchParams);
		}

		function getTotalItem(response) {
			return response.headers('total-media');
		}

		function onFilterChanged() {
			self.searchParams.page = 1;
			onSearchFilterClick(self.selectedFilter, 'DURATION');
		}

		function onDownloadBtnClicked(evt, item, type) {
			if (self.isWorking) {
				return;
			}
			var service = type ? type : "download";
			self.isWorking = true;
			pixerfApiDownloadSvc.order_receipt({}, {
				'payment_ids': item.download_id ? [item.download_id] : [item.id],
				type: 'orders'
			}).$promise.then(function (response) {
				item.downloadLink = pixerfUrl.full + "api/" + service + "?token=" + response.data.token;
				$timeout(function () {
					$(evt.target).next("a")[0].click();
					$timeout(function () {
						self.isWorking = false;
					})
				})
			}, function () {
				self.isWorking = false;
				toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
			})
		}

		function translatePaymenMethod(method) {
			if (method === 'Credit/Debit Card') {
				return 'credit-rebit-card';
			} else if (method === 'Credit Plan') {
				return 'credit-plan';
			} else {
				return method;
			}
		}

		function translateListMethod(items) {
			for (var i = 0; i < items.length; i++) {
				if (!items[i].payment || !items[i].payment.payment_method) break;
				items[i].payment.payment_method = translatePaymenMethod(items[i].payment.payment_method);
			}
			return items;
		}

		function onSelectedItem(receipt) {
			if (self.isSelectedAll) {
				self.isSelectedAll = false;
				self.selectedItems = [];
			}
			if (receipt.selected) {
				self.selectedItems = self.selectedItems.concat(receipt.id);
				self.downloadText = 'Download selected receipts';
			} else {
				self.selectedItems = _.reject(self.selectedItems, function (item) {
					return receipt.id === item;
				})
			}
			if (!self.selectedItems.length) {
				self.downloadText = 'Download all receipts';
			}
		}

		function onArrageChanged(item) {
			self.searchParams.page = 1;
			self.selectedItems = [];
			if (item.viewBy === 'images') {
				self.viewBy = item.viewBy;
			} else {
				delete self.viewBy;
			}
			onSearchFilterClick(self.searchParams, 'MOST_RECENT');
		}

		function onDownloadReceipts() {
			if (self.isWorking) {
				return;
			}
			self.isWorking = true;

			if (!self.selectedItems || !self.selectedItems.length) {
				self.isSelectedAll = true;
				pixerfApiOrdersSvc.post({
					page_size: 200
				}).$promise.then(function (response) {
					self.isWorking = false;
					self.selectedItems = _.pluck(response.data, 'id');
					onDownloadReceipts();
				})
			} else {
				pixerfApiDownloadSvc.order_receipt({}, {
					'payment_ids': self.selectedItems,
					type: 'orders'
				}).$promise.then(function (response) {
					$timeout(function () {
						window.location.href = pixerfUrl.full + "api/receipt?token=" + response.data.token;
						self.isWorking = false;
					})
				}, function () {
					self.isWorking = false;
					toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
				})
			}
		}

		function onSearch() {
			var search = {
				page: 1,
				type: 'images'
			};
			if (self.searchString) {
				search.keywords = self.searchString;
				fetchPurchasedItems(search, true);
			} else {
				fetchPurchasedItems(search, true);
			}
		}

		function transformFormatedLicense(items) {
			for (var i = 0; i < items.length; i++) {
				items[i].formatedLicense = transformLicense(items[i].license);
			}
			return items;
		}

		function transformLicense(item) {
			if (item === 'editorial') {
				item = 'Editorial License Only';
			} else if (item === 'commercial') {
				item = 'Editorial & Commercial License';
			}
			return item;
		}

		function onSelectedImage(image) {
			if (self.isSelectedAll) {
				self.isSelectedAll = false;
				self.selectedItems = [];
			}
			if (image.isSelected) {
				self.selectedItems = self.selectedItems.concat(image.download_id);
			} else {
				self.selectedItems = _.reject(self.selectedItems, function (item) {
					return image.download_id === item;
				})
			}
		}

		function onDownloadSelectedItemsClicked() {
			if (self.isWorking || !self.selectedItems.length) {
				return;
			}
			self.isWorking = true;
			pixerfApiDownloadSvc.order_receipt({}, {
				'payment_ids': self.selectedItems,
				type: 'orders'
			}).$promise.then(function (response) {
				$timeout(function () {
					window.location.href = pixerfUrl.full + "api/download?token=" + response.data.token;
					self.isWorking = false;
				})
			}, function () {
				self.isWorking = false;
				toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
			})
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('orderDetailsCtrl', orderDetailsCtrl);

	orderDetailsCtrl.$inject = ['$scope', '$stateParams', 'pixerfApiOrdersSvc', 'pixerfApiDownloadSvc', 'pixerfUrl', 'toastr', '$timeout', 'translationSvc', '$state'];

	function orderDetailsCtrl($scope, $stateParams, pixerfApiOrdersSvc, pixerfApiDownloadSvc, pixerfUrl, toastr, $timeout, translationSvc, $state) {
		var self = this;
		self.spinner = {
			isVisible: false
		};
		self.onBackBtnClicked = onBackBtnClicked;
		self.orderId = $stateParams.orderId;
		self.onDownloadBtnClicked = onDownloadBtnClicked;
		$scope.$parent.vm.hideHeaderBar = true;
		self.onSelectedMedia = onSelectedMedia;
		self.onDownloadSelected = onDownloadSelected;
		self.downloadText = 'Download all images';
		self.selectedItems = [];

		self.searchParams = {
			orderId: self.orderId
		};

		fetchPurchasedItems(self.searchParams, true);

		function onDownloadBtnClicked(evt, item, type) {
			var service = type ? type : "download";
			if (self.isWorking) {
				return;
			}
			self.isWorking = true;
			pixerfApiDownloadSvc.order_receipt({}, {
				'payment_ids': [item.id],
				type: 'orders'
			}).$promise.then(function (response) {
				item.downloadLink = pixerfUrl.full + "api/" + service + "?token=" + response.data.token;
				$timeout(function () {
					$(evt.target).next("a")[0].click();
					$timeout(function () {
						self.isWorking = false;
					})
				})
			}, function () {
				self.isWorking = false;
				toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
			})
		}

		function fetchPurchasedItems(searchParams, isFresh) {
			self.spinner.isVisible = true;
			if (isFresh) self.item = {};
			pixerfApiOrdersSvc.getById(searchParams).$promise.then(function (response) {
				self.spinner.isVisible = false;
				if (response && response.data) {
					self.item = response.data;
				}
			}, function () {
				self.spinner.isVisible = false;
				toastr.error('Failed to get purchased items. Please try again.');
			})
		}

		function onBackBtnClicked() {
			// window.history.go(-1);
			$state.go("setting.purchase-history.order-list");
		}

		function onSelectedMedia(receipt) {
			if (receipt.selected) {
				self.selectedItems = self.selectedItems.concat(receipt.download_id);
				self.downloadText = 'Download selected images';
			} else {
				self.selectedItems = _.reject(self.selectedItems, function (item) {
					return receipt.download_id === item;
				})
			}
			if (!self.selectedItems.length) {
				self.downloadText = 'Download all images';
			}
		}

		function onDownloadSelected() {
			if (self.isWorking) {
				return;
			}
			self.isWorking = true;
			var paymentIds = self.selectedItems;
			if (!self.selectedItems || !self.selectedItems.length) {
				paymentIds = _.pluck(self.item.media, "download_id");
			}
			pixerfApiDownloadSvc.order_receipt({}, {
				'payment_ids': paymentIds,
				type: 'orders'
			}).$promise.then(function (response) {
				$timeout(function () {
					window.location.href = pixerfUrl.full + "api/download?token=" + response.data.token;
					self.isWorking = false;
				})
			}, function () {
				self.isWorking = false;
				toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
			})
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('missionListCtrl', missionListCtrl);

	missionListCtrl.$inject = ['$scope', 'pixerfApiOrdersSvc', 'toastr', 'purchaseHistorySvc', 'pagingUtils', 'pixerfApiDownloadSvc', 'pixerfUrl', '$timeout', 'translationSvc'];

	function missionListCtrl($scope, pixerfApiOrdersSvc, toastr, purchaseHistorySvc, pagingUtils, pixerfApiDownloadSvc, pixerfUrl, $timeout, translationSvc) {
		var self = this;
		self.orderListCtrl = $scope.$parent.vm;
		$scope.$parent.$parent.vm.contextPage = "Purchase History";
		$scope.$parent.vm.navigation.context = "Community Challenges";
		self.orderListCtrl.hideHeaderBar = false;
		self.spinner = {
			isVisible: false
		}
		self.onDownloadBtnClicked = onDownloadBtnClicked;
		self.fetchMorePurchasedItems = fetchMorePurchasedItems;
		self.onSearchFilterClick = onSearchFilterClick;
		self.onFilterChanged = onFilterChanged;
		self.onSelectedItem = onSelectedItem;
		self.onDownloadReceipts = onDownloadReceipts;
		self.selectedItems = [];
		self.totalItem = 0;
		self.filtersFromMonth = self.orderListCtrl.filtersFromMonth;
		self.filtersFromYear = self.orderListCtrl.filtersFromYear;
		self.filtersToMonth = self.orderListCtrl.filtersToMonth;
		self.filtersToYear = self.orderListCtrl.filtersToYear;
		self.selectedFilter = {
			fromDate: '',
			toDate: '',
		};
		self.searchParams = {
			type: 'mission',
			page: 1,
			start_date: null,
			end_date: null
		};
		self.downloadText = 'Download all receipts';

		initList();

		function initList() {
			onSearchFilterClick(self.selectedFilter, 'MOST_RECENT');
		}

		$scope.$watch('vm.selectedFilter', function () {
			onSearchFilterClick(self.selectedFilter, 'DURATION');
		}, true)

		function onSearchFilterClick(filter, type) {
			if (filter) {
				filter.type = type;
				var timeRange = purchaseHistorySvc.getTimeRange(filter);
				if (timeRange) {
					self.searchParams.start_date = timeRange.start_date;
					self.searchParams.end_date = timeRange.end_date;
				}
			}
			fetchPurchasedItems(self.searchParams, true);
		}

		function fetchPurchasedItems(searchParams, isFresh) {
			self.spinner.isVisible = true;
			if (isFresh) self.items = [];
			pixerfApiOrdersSvc.getTransactionItems(searchParams).$promise.then(function (response) {
				if (searchParams.page === 1) self.items = [];
				self.spinner.isVisible = false;
				if (response && response.data && response.data.length > 0) {
					self.items = self.items.concat(response.data);
					self.totalItem = getTotalItem(response);
				}
				self.isLastPage = pagingUtils.isNoMorePageToLoad(searchParams.page, response);

			}, function () {
				self.spinner.isVisible = false;
				toastr.error('Failed to get mission list. Please try again.');
			})
		}

		function fetchMorePurchasedItems() {
			if (self.spinner.isVisible) {
				return;
			}
			self.searchParams.page++;
			fetchPurchasedItems(self.searchParams);
		}

		function getTotalItem(response) {
			return response.headers('total');
		}

		function onDownloadBtnClicked(evt, item) {
			if (self.isWorking) {
				return;
			}
			self.isWorking = true;
			pixerfApiDownloadSvc.transaction_receipt({}, {
				payment_ids: [item.id],
				type: 'mission'
			}).$promise.then(function (response) {
				item.downloadLink = pixerfUrl.full + "api/transaction_receipt?payment_id=" + item.id + "&type=mission&token=" + response.data.token;
				$timeout(function () {
					$(evt.target).next("a")[0].click();
					$timeout(function () {
						self.isWorking = false;
					})
				})
			}, function () {
				self.isWorking = false;
				toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
			})
		}

		function onFilterChanged() {
			onSearchFilterClick(self.selectedFilter, 'DURATION');
		}

		function onSelectedItem(receipt) {
			if (self.isSelectedAll) {
				self.isSelectedAll = false;
				self.selectedItems = [];
			}
			if (receipt.selected) {
				self.selectedItems = self.selectedItems.concat(receipt.id);
				self.downloadText = 'Download selected receipts';
			} else {
				self.selectedItems = _.reject(self.selectedItems, function (item) {
					return receipt.id === item;
				})
			}
			if (!self.selectedItems.length) {
				self.downloadText = 'Download all receipts';
			}
		}

		function onDownloadReceipts() {
			if (self.isWorking) {
				return;
			}
			self.isWorking = true;

			if (!self.selectedItems || !self.selectedItems.length) {
				self.isSelectedAll = true;
				pixerfApiOrdersSvc.getTransactionItems({
					type: 'mission',
					page_size: 200
				}).$promise.then(function (response) {
					self.isWorking = false;
					self.selectedItems = _.pluck(response.data, 'id');
					onDownloadReceipts();
				})
			} else {
				pixerfApiDownloadSvc.transaction_receipt({}, {
					'payment_ids': self.selectedItems,
					type: 'mission'
				}).$promise.then(function (response) {
					$timeout(function () {
						window.location.href = pixerfUrl.full + "api/receipt?token=" + response.data.token;
						self.isWorking = false;
					})
				}, function () {
					self.isWorking = false;
					toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
				})
			}
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('customContentAssignmentCtrl', customContentAssignmentCtrl);

	customContentAssignmentCtrl.$inject = ['$scope', 'pixerfApiOrdersSvc', 'toastr', 'purchaseHistorySvc', 'pagingUtils', 'pixerfApiDownloadSvc', 'pixerfUrl', '$timeout', 'translationSvc'];

	function customContentAssignmentCtrl($scope, pixerfApiOrdersSvc, toastr, purchaseHistorySvc, pagingUtils, pixerfApiDownloadSvc, pixerfUrl, $timeout, translationSvc) {
		var self = this;
		self.CCACtrl = $scope.$parent.vm;
		$scope.$parent.$parent.vm.contextPage = "Purchase History";
		$scope.$parent.vm.navigation.context = "Custom Content Assignments";
		self.CCACtrl.hideHeaderBar = false;
		self.spinner = {
			isVisible: false
		}
		self.onDownloadBtnClicked = onDownloadBtnClicked;
		self.fetchMorePurchasedItems = fetchMorePurchasedItems;
		self.onSearchFilterClick = onSearchFilterClick;
		self.onFilterChanged = onFilterChanged;
		self.onDownloadReceipts = onDownloadReceipts;
		self.onSelectedItem = onSelectedItem;
		self.filtersFromMonth = self.CCACtrl.filtersFromMonth;
		self.filtersFromYear = self.CCACtrl.filtersFromYear;
		self.filtersToMonth = self.CCACtrl.filtersToMonth;
		self.filtersToYear = self.CCACtrl.filtersToYear;
		self.selectedFilter = {
			fromDate: '',
			toDate: '',
		};
		self.searchParams = {
			type: 'custom_commission',
			page: 1,
			start_date: null,
			end_date: null
		};
		self.downloadText = 'Download all receipts';

		initList();

		function initList() {
			onSearchFilterClick(self.selectedFilter, 'MOST_RECENT');
		}

		$scope.$watch('vm.selectedFilter', function () {
			onSearchFilterClick(self.selectedFilter, 'DURATION');
		}, true)

		function onSearchFilterClick(filter, type) {
			if (filter) {
				filter.type = type;
				var timeRange = purchaseHistorySvc.getTimeRange(filter);
				if (timeRange) {
					self.searchParams.start_date = timeRange.start_date;
					self.searchParams.end_date = timeRange.end_date;
				}
			}
			fetchPurchasedItems(self.searchParams, true);
		}

		function fetchPurchasedItems(searchParams, isFresh) {
			self.spinner.isVisible = true;
			if (isFresh) self.items = [];
			pixerfApiOrdersSvc.getTransactionItems(searchParams).$promise.then(function (response) {
				if (searchParams.page === 1) self.items = [];
				self.spinner.isVisible = false;
				if (response && response.data && response.data.length > 0) {
					self.items = self.items.concat(response.data);
					self.items = translateListMethod(self.items);
				}
				self.isLastPage = pagingUtils.isNoMorePageToLoad(searchParams.page, response);
			}, function () {
				self.spinner.isVisible = false;
				toastr.error('Failed to get credit list. Please try again.');
			})
		}

		function fetchMorePurchasedItems() {
			if (self.spinner.isVisible) {
				return;
			}
			self.searchParams.page++;
			fetchPurchasedItems(self.searchParams);
		}

		function onDownloadBtnClicked(evt, item) {
			if (self.isWorking) {
				return;
			}
			self.isWorking = true;
			pixerfApiDownloadSvc.transaction_receipt({}, {
				payment_ids: [item.id],
				type: 'custom_commission'
			}).$promise.then(function (response) {
				item.downloadLink = pixerfUrl.full + "api/transaction_receipt?payment_id=" + item.id + "&type=custom_commission&token=" + response.data.token;
				$timeout(function () {
					$(evt.target).next("a")[0].click();
					$timeout(function () {
						self.isWorking = false;
					})
				})
			}, function () {
				self.isWorking = false;
				toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
			})
		}

		function onFilterChanged() {
			onSearchFilterClick(self.selectedFilter, 'DURATION');
		}

		function translatePaymenMethod(method) {
			if (method === 'Credit/Debit Card') {
				return 'credit-rebit-card';
			} else if (method === 'Credit Plan') {
				return 'credit-plan';
			} else {
				return method;
			}
		}

		function translateListMethod(items) {
			for (var i = 0; i < items.length; i++) {
				items[i].payment_method = translatePaymenMethod(items[i].payment_method);
			}
			return items;
		}

		function onSelectedItem(receipt) {
			if (self.isSelectedAll) {
				self.isSelectedAll = false;
				self.selectedItems = [];
			}
			if (receipt.selected) {
				self.selectedItems = self.selectedItems.concat(receipt.id);
				self.downloadText = 'Download selected receipts';
			} else {
				self.selectedItems = _.reject(self.selectedItems, function (item) {
					return receipt.id === item;
				})
			}
			if (!self.selectedItems.length) {
				self.downloadText = 'Download all receipts';
			}
		}

		function onDownloadReceipts() {
			if (self.isWorking) {
				return;
			}
			self.isWorking = true;

			if (!self.selectedItems || !self.selectedItems.length) {
				self.isSelectedAll = true;
				pixerfApiOrdersSvc.getTransactionItems({
					type: 'custom_commission',
					page_size: 200
				}).$promise.then(function (response) {
					self.isWorking = false;
					self.selectedItems = _.pluck(response.data, 'id');
					onDownloadReceipts();
				})
			} else {
				pixerfApiDownloadSvc.transaction_receipt({}, {
					'payment_ids': self.selectedItems,
					type: 'custom_commission'
				}).$promise.then(function (response) {
					$timeout(function () {
						window.location.href = pixerfUrl.full + "api/receipt?token=" + response.data.token;
						self.isWorking = false;
					})
				}, function () {
					self.isWorking = false;
					toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
				})
			}
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('creditListCtrl', creditListCtrl);

	creditListCtrl.$inject = ['$scope', 'pixerfApiOrdersSvc', 'toastr', 'purchaseHistorySvc', 'pagingUtils', 'pixerfApiDownloadSvc', 'pixerfUrl', '$timeout', 'translationSvc'];

	function creditListCtrl($scope, pixerfApiOrdersSvc, toastr, purchaseHistorySvc, pagingUtils, pixerfApiDownloadSvc, pixerfUrl, $timeout, translationSvc) {
		var self = this;
		self.orderListCtrl = $scope.$parent.vm;
		$scope.$parent.$parent.vm.contextPage = "Purchase History";
		$scope.$parent.vm.navigation.context = "Credit Plans";
		self.orderListCtrl.hideHeaderBar = false;
		self.spinner = {
			isVisible: false
		}
		self.onDownloadBtnClicked = onDownloadBtnClicked;
		self.fetchMorePurchasedItems = fetchMorePurchasedItems;
		self.onSearchFilterClick = onSearchFilterClick;
		self.onFilterChanged = onFilterChanged;
		self.onDownloadReceipts = onDownloadReceipts;
		self.onSelectedItem = onSelectedItem;
		self.filtersFromMonth = self.orderListCtrl.filtersFromMonth;
		self.filtersFromYear = self.orderListCtrl.filtersFromYear;
		self.filtersToMonth = self.orderListCtrl.filtersToMonth;
		self.filtersToYear = self.orderListCtrl.filtersToYear;
		self.selectedFilter = {
			fromDate: '',
			toDate: '',
		};
		self.searchParams = {
			type: 'credit_plan',
			page: 1,
			start_date: null,
			end_date: null
		};
		self.downloadText = 'Download all receipts';

		initList();

		function initList() {
			onSearchFilterClick(self.selectedFilter, 'MOST_RECENT');
		}

		$scope.$watch('vm.selectedFilter', function () {
			onSearchFilterClick(self.selectedFilter, 'DURATION');
		}, true)

		function onSearchFilterClick(filter, type) {
			if (filter) {
				filter.type = type;
				var timeRange = purchaseHistorySvc.getTimeRange(filter);
				if (timeRange) {
					self.searchParams.start_date = timeRange.start_date;
					self.searchParams.end_date = timeRange.end_date;
				}
			}
			fetchPurchasedItems(self.searchParams, true);
		}

		function fetchPurchasedItems(searchParams, isFresh) {
			self.spinner.isVisible = true;
			if (isFresh) self.items = [];
			pixerfApiOrdersSvc.getTransactionItems(searchParams).$promise.then(function (response) {
				if (searchParams.page === 1) self.items = [];
				self.spinner.isVisible = false;
				if (response && response.data && response.data.length > 0) {
					self.items = self.items.concat(response.data);
					self.items = translateListMethod(self.items);
				}
				self.isLastPage = pagingUtils.isNoMorePageToLoad(searchParams.page, response);
			}, function () {
				self.spinner.isVisible = false;
				toastr.error('Failed to get credit list. Please try again.');
			})
		}

		function fetchMorePurchasedItems() {
			if (self.spinner.isVisible) {
				return;
			}
			self.searchParams.page++;
			fetchPurchasedItems(self.searchParams);
		}

		function onDownloadBtnClicked(evt, item) {
			if (self.isWorking) {
				return;
			}
			self.isWorking = true;
			pixerfApiDownloadSvc.transaction_receipt({}, {
				payment_ids: [item.id],
				type: 'credit_plan'
			}).$promise.then(function (response) {
				item.downloadLink = pixerfUrl.full + "api/transaction_receipt?payment_id=" + item.id + "&type=credit_plan&token=" + response.data.token;
				$timeout(function () {
					$(evt.target).next("a")[0].click();
					$timeout(function () {
						self.isWorking = false;
					})
				})
			}, function () {
				self.isWorking = false;
				toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
			})
		}

		function onFilterChanged() {
			onSearchFilterClick(self.selectedFilter, 'DURATION');
		}

		function translatePaymenMethod(method) {
			if (method === 'Credit/Debit Card') {
				return 'credit-rebit-card';
			} else if (method === 'Credit Plan') {
				return 'credit-plan';
			} else {
				return method;
			}
		}

		function translateListMethod(items) {
			for (var i = 0; i < items.length; i++) {
				items[i].payment_method = translatePaymenMethod(items[i].payment_method);
			}
			return items;
		}

		function onSelectedItem(receipt) {
			if (self.isSelectedAll) {
				self.isSelectedAll = false;
				self.selectedItems = [];
			}
			if (receipt.selected) {
				self.selectedItems = self.selectedItems.concat(receipt.id);
				self.downloadText = 'Download selected receipts';
			} else {
				self.selectedItems = _.reject(self.selectedItems, function (item) {
					return receipt.id === item;
				})
			}
			if (!self.selectedItems.length) {
				self.downloadText = 'Download all receipts';
			}
		}

		function onDownloadReceipts() {
			if (self.isWorking) {
				return;
			}
			self.isWorking = true;

			if (!self.selectedItems || !self.selectedItems.length) {
				self.isSelectedAll = true;
				pixerfApiOrdersSvc.getTransactionItems({
					type: 'credit_plan',
					page_size: 200
				}).$promise.then(function (response) {
					self.isWorking = false;
					self.selectedItems = _.pluck(response.data, 'id');
					onDownloadReceipts();
				})
			} else {
				pixerfApiDownloadSvc.transaction_receipt({}, {
					'payment_ids': self.selectedItems,
					type: 'credit_plan'
				}).$promise.then(function (response) {
					$timeout(function () {
						window.location.href = pixerfUrl.full + "api/receipt?token=" + response.data.token;
						self.isWorking = false;
					})
				}, function () {
					self.isWorking = false;
					toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
				})
			}
		}
	}
})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('missionReviewSectionTitleCtrl', missionReviewSectionTitleCtrl);

    missionReviewSectionTitleCtrl.$inject = ['pathUtils', 'createMissionSvc'];

    function missionReviewSectionTitleCtrl(pathUtils, createMissionSvc) {
		var self = this;
		self.backup = backup;
		self.restore = restore;
		self.validator = createMissionSvc.validateBrief;
		self.isEditing = false;
		self.originalValues = {};

		function backup(){
			self.originalValues.title = self.mission.title;
		}
		function restore(){
			self.mission.title = self.originalValues.title;
		}
    }
})();
(function () {
	'use strict';

	angular
	  .module('pixerf')
	  .component('missionReviewSectionTitle', {
		templateUrl: 'app/components/mission-review/mission-review-section-title/mission-review-section-title.html',
		bindings: {
		  mission: '=',
		  isEditable: '='
		},
		controller: 'missionReviewSectionTitleCtrl as vm'
	  });

  })();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('missionReviewSectionSponsorCtrl', missionReviewSectionSponsorCtrl);

    missionReviewSectionSponsorCtrl.$inject = ['sessionManagerSvc', 'createMissionSvc', 'pathUtils'];

    function missionReviewSectionSponsorCtrl(sessionManagerSvc, createMissionSvc, pathUtils) {
		var self = this;
		self.backup = backup;
		self.restore = restore;
		self.isEditing = false;
		self.originalValues = {};
		self.mission.noSponsor = !self.mission.sponsor;
		self.onCheckboxChanged = onCheckboxChanged;
		self.validator = createMissionSvc.validateSponsor;

		function backup(){
			self.originalValues.noSponsor = self.mission.noSponsor;
			self.originalValues.name = self.mission.sponsor ? self.mission.sponsor.name : '';
			self.originalValues.description = self.mission.sponsor ? self.mission.sponsor.description : '';
			self.originalValues.profile_image = self.mission.sponsor ? self.mission.sponsor.profile_image : '';
		}
		function restore(){
			self.mission.noSponsor = self.originalValues.noSponsor;
			if(self.originalValues.noSponsor) {
				self.mission.sponsor = null;
				return;
			}
			restoreSponsorValue();
			
		}
		function restoreSponsorValue(){
			self.mission.sponsor = {};
			self.mission.sponsor.name = self.originalValues.name;
			self.mission.sponsor.description = self.originalValues.description;
			self.mission.sponsor.profile_image = self.originalValues.profile_image;
			self.mission.sponsor.logoUrl = pathUtils.buildMissionLogoUrl(self.mission.sponsor.profile_image);
		}
		function onCheckboxChanged(){
			if(self.mission.noSponsor){
				self.mission.sponsor = null;
			} else{
				self.mission.sponsor = {};
				if(!self.originalValues.noSponsor){
					restoreSponsorValue();
				}
			}
		}
    }
})();
(function () {
  'use strict';

  angular
    .module('pixerf')
    .component('missionReviewSectionSponsor', {
      templateUrl: 'app/components/mission-review/mission-review-section-sponsor/mission-review-section-sponsor.html',
      bindings: {
        mission: '=',
        isEditable: '='
      },
      controller: 'missionReviewSectionSponsorCtrl as vm'
    });

})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('missionReviewSectionRewardCtrl', missionReviewSectionRewardCtrl);

    missionReviewSectionRewardCtrl.$inject = ['sessionManagerSvc', '$state', 'createMissionSvc'];

    function missionReviewSectionRewardCtrl(sessionManagerSvc, $state, createMissionSvc) {
		var self = this;
        self.backup = backup;
        self.originalValues = {prizes: [], price: {}};
        self.restore = restore;
        self.validator = validator;
        self.onMssionAwardInit = onMssionAwardInit;
		
        function backup(){
            self.originalValues = {prizes: [], price: {}};
            self.originalValues.price = {id: self.mission.price.id, duration: self.mission.price.duration};
			for(var i = 0;  i < self.mission.prizes.length; i ++){
                self.originalValues.prizes.push({
                    id: self.mission.prizes[i].id,
                    value: self.mission.prizes[i].value,
                    type: self.mission.prizes[i].type
                })
			}
        }
        function onMssionAwardInit(instance){
            self.mssionAward = instance;
        }
		function restore(){
            var prizes = [];
            self.mission.price = _.find(self.mission.prices, function(p){
                return p.id === self.originalValues.price.id
            })
            if(self.mission.price.id === -1) self.mission.price.duration = self.originalValues.price.duration;
			for(var i = 0;  i < self.originalValues.prizes.length; i ++){
                prizes.push({
                    id: self.originalValues.prizes[i].id,
                    value: self.originalValues.prizes[i].value,
                    type: self.originalValues.prizes[i].type
                })
            }
            self.mission.prizes = prizes;
        }
        function validator(mission){
            self.mssionAward.rewardForm.$setDirty(true);
            return createMissionSvc.validatePrizes(self.mission);
        }
    }
})();
(function () {
  'use strict';

  angular
    .module('pixerf')
    .component('missionReviewSectionReward', {
      templateUrl: 'app/components/mission-review/mission-review-section-reward/mission-review-section-reward.html',
      bindings: {
        mission: '=',
        isEditable: '='
      },
      controller: 'missionReviewSectionRewardCtrl as vm'
    });

})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('missionReviewSectionEditBtnCtrl', missionReviewSectionEditBtnCtrl);

    missionReviewSectionEditBtnCtrl.$inject = ['sessionManagerSvc', 'stringUtils', '$state', 'createMissionSvc', 'toastr'];

    function missionReviewSectionEditBtnCtrl(sessionManagerSvc, stringUtils, $state, createMissionSvc, toastr) {
		var self = this;
		self.onEditBtnClicked = onEditBtnClicked;
		self.onCancelBtnClicked = onCancelBtnClicked;
		self.onSaveBtnClicked = onSaveBtnClicked;
		self.isEditing = false;

		function onEditBtnClicked() {
			self.backup();
			self.isEditing = !self.isEditing;
			
		}
		function onCancelBtnClicked(){
			self.isEditing = false;
			if(self.restore){
				self.restore();
			}
		}
		function onSaveBtnClicked(){
			if(self.isWorking) return;
			if(self.validator){
				var errMsg = self.validator(self.mission);
				if(errMsg){
					toastr.error(errMsg);
					return;
				}
			}
			self.isWorking = true;
			createMissionSvc.saveMission(self.mission).then(function(){
				self.isEditing = false;
				self.isWorking = false;
			}, function(){
				self.isWorking = false;
				self.isEditing = false;
			})
		}
    }
})();
(function () {
  'use strict';

  angular
    .module('pixerf')
    .component('missionReviewSectionEditBtn', {
      templateUrl: 'app/components/mission-review/mission-review-section-edit-btn/mission-review-section-edit-btn.html',
      bindings: {
        mission: '=',
        restore: '&?',
        backup: '&?',
        isEditing: '=',
        validator: '&?'

      },
      controller: 'missionReviewSectionEditBtnCtrl as vm'
    });

})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('missionReviewSectionBriefCtrl', missionReviewSectionBriefCtrl);

    missionReviewSectionBriefCtrl.$inject = ['sessionManagerSvc', '$state', 'createMissionSvc'];

    function missionReviewSectionBriefCtrl(sessionManagerSvc, $state, createMissionSvc) {
		var self = this;
        self.backup = backup;
		self.restore = restore;
		self.isEditing = false;
        self.originalValues = {};
        self.validator = createMissionSvc.validateBrief;
        self.briefEditorOptions = createMissionSvc.getMissionBriefEditorConfiguration();
		self.briefEditorOptions.onContentChanged = function (editor, html, text, delta, oldDelta, source) {
			self.briefLength = html ? text.length - 1 : 0;
		}

		
        function backup(){
			self.originalValues.description = self.mission.description;
		}
		function restore(){
			self.mission.description = self.originalValues.description;
		}
    }
})();
(function () {
  'use strict';

  angular
    .module('pixerf')
    .component('missionReviewSectionBrief', {
      templateUrl: 'app/components/mission-review/mission-review-section-brief/mission-review-section-brief.html',
      bindings: {
        mission: '=',
        isEditable: '='
      },
      controller: 'missionReviewSectionBriefCtrl as vm'
    });

})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('missionReviewSectionDetailCtrl', missionReviewSectionDetailCtrl);

    missionReviewSectionDetailCtrl.$inject = ['sessionManagerSvc', 'stringUtils', '$state', 'createMissionSvc', 'ISO3166'];

    function missionReviewSectionDetailCtrl(sessionManagerSvc, stringUtils, $state, createMissionSvc, ISO3166) {
		var self = this;
		self.backup = backup;
		self.restore = restore;
		self.isEditing = false;
		self.onComboboxInit = onComboboxInit;
		self.originalValues = {};
		self.comboboxes = {};
		self.onCountriesSelected = onCountriesSelected;
		self.fields = buildFields();
		self.countriesOpts = {
			"maxOptions": 0,
			'noneSelectedText': 'All Countries',
			"container": "body",
			"customAll": true,
			"dropupAuto": false
		};

		init();

		function onComboboxInit(instance){
			self.comboboxes[instance.configs.id] = instance;
		}
		function buildFields(){
			var options = createMissionSvc.getMissionSpecifications();

			return options;
		}

		function backup(){
			for(var i = 0; i < self.fields.length; i++){
				self.originalValues[self.fields[i].value] = self.mission[self.fields[i].value];
			}
			self.originalValues.countries = $.extend(true, [], self.mission.countries);
            self.originalValues.selectedCountries = $.extend(true, [], self.selectedCountries);
		}
		function restore(){
			for(var i = 0; i < self.fields.length; i++){
				if(self.mission[self.fields[i].value] !== self.originalValues[self.fields[i].value]){
					self.mission[self.fields[i].value] = self.originalValues[self.fields[i].value];
					self.comboboxes[self.fields[i].value].setDefaultValue(self.mission[self.fields[i].value]);
				}

			}
			self.mission.countries = $.extend(true, [], self.originalValues.countries);
            self.selectedCountries = $.extend(true, [], self.originalValues.selectedCountries);
		}

		function init(){
			self.countries = buildCountries();
			if(self.mission && (!Array.isArray(self.mission.countries) || !self.mission.countries.length)){
				delete self.mission.countries;
				self.selectedCountries = [{id: 'all', name: 'All Countries'}];
			} else if (self.mission) {
				self.selectedCountries = self.countries.filter(function(obj){
					return self.mission.countries.includes(obj.id);
				});
			}
		}

		function buildCountries(){
            var arr = [{id: 'all', name: 'All Countries'}];
            for (var key in ISO3166.codeToCountry){
                arr.push({
                    id: key,
                    name: ISO3166.codeToCountry[key]
                })
            }
            return arr;
		}

		function onCountriesSelected(countriesSelected){
			if(!self.selectedCountries || !self.selectedCountries.length){
				delete self.mission.countries;
				self.selectedCountries = [{id: 'all', name: 'All Countries'}];
			} else {
				self.mission.countries = _.pluck(self.selectedCountries, 'id');
			}
		}
    }
})();
(function () {
  'use strict';

  angular
    .module('pixerf')
    .component('missionReviewSectionDetail', {
      templateUrl: 'app/components/mission-review/mission-review-section-detail/mission-review-section-detail.html',
      bindings: {
        mission: '=',
        isEditable: '='
      },
      controller: 'missionReviewSectionDetailCtrl as vm'
    });

})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('missionReviewSectionArtDirectionCtrl', missionReviewSectionArtDirectionCtrl);

    missionReviewSectionArtDirectionCtrl.$inject = ['createMissionSvc'];

    function missionReviewSectionArtDirectionCtrl(createMissionSvc) {
		var self = this;
        self.backup = backup;
        self.restore = restore;
        self.validator = createMissionSvc.validateVisualInspiration;
		self.isEditing = false;
        self.originalValues = {};
        self.artDirectionEditorOptions = createMissionSvc.getMissionArtDirectionEditorConfiguraion();
		self.artDirectionEditorOptions.onContentChanged = function (editor, html, text, delta, oldDelta, source) {
			self.descriptionLength = html ? text.length - 1 : 0;
		}

        function backup(){
			self.originalValues.art_direction = self.mission.art_direction;
		}
		function restore(){
			self.mission.art_direction = self.originalValues.art_direction;
		}
    }
})();
(function () {
  'use strict';

  angular
    .module('pixerf')
    .component('missionReviewSectionArtDirection', {
      templateUrl: 'app/components/mission-review/mission-review-section-art-direction/mission-review-section-art-direction.html',
      bindings: {
        mission: '=',
        isEditable: '='
      },
      controller: 'missionReviewSectionArtDirectionCtrl as vm'
    });

})();

(function () {

	angular
		.module('pixerf')
		.controller('managePendingReportsCtrl', managePendingReportsCtrl);

	managePendingReportsCtrl.$inject = ['$scope', 'sessionManagerSvc', 'manageReportsSvc', 'pagingUtils', 'pixerfApiCommunitySvc', '$timeout', 'systemUtils', '$compile', 'communityResolveReportPopupSvc'];

	function managePendingReportsCtrl($scope, sessionManagerSvc, manageReportsSvc, pagingUtils, pixerfApiCommunitySvc, $timeout, systemUtils, $compile, communityResolveReportPopupSvc) {

		var USER_CONTROL_ADMINDASHBOARD = ['curator_internal', 'admin_internal', 'marketer_internal'];
		var self = this;
		self.loginedUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.countTotal = self.loginedUser.stats || {};
		self.isAdmin = self.loginedUser && (USER_CONTROL_ADMINDASHBOARD.includes(self.loginedUser.role) || self.loginedUser.email === 'marcom@pixerf.com');
		self.parent = $scope.$parent.vm;
		self.parent.subContextPage = "pending";
		self.customPagingOptions = manageReportsSvc.getCustomPagingOptions();
		self.onReportGridChanged = onReportGridChanged;
		self.onSortByChanged = onSortByChanged;
		self.onSearchPendingReport = _.debounce(onSearchPendingReport, 800);
		self.onSelectAllPendingReports = onSelectAllPendingReports;
		self.onSelectPendingReport = onSelectPendingReport;
		self.onCloseNotification = onCloseNotification;
		self.onCummunityFilterClicked = onCummunityFilterClicked;
		self.onReportClicked = onReportClicked;
		self.onReportDetailsViewClosed = onReportDetailsViewClosed;
		self.sortByProps = sortByProps;
		self.onPendingReportsListChanged = onPendingReportsListChanged;
		self.onResolveReports = onResolveReports;
		self.seletedPendingReports = [];
		self.isReportDetailsViewOpen = false;
		self.spinner = {
			isVisible: false
		};
		self.typeFilterOptions = [];
		self.reasonFilterOptions = [];
		self.communityNameFilterOptions = [];
		self.searchParams = {
			type: 'pending',
			page: 1,
			page_size: self.customPagingOptions.showValues[0]
		};
		self.sortBy = [{
				value: "date,desc",
				title: "Date of report"
			},
			{
				value: "item_type,asc",
				title: "Type of report"
			},
			{
				value: "reason,asc",
				title: "Reason for report"
			},
			{
				value: "community_name,asc",
				title: "Community Name"
			}
		];
		self.selectedCommunities = [];
		self.selectedReasons = [];
		self.selectedTypes = [];
		self.onFilterChanged = onFilterChanged;
		self.onReasonFilterChanged = onReasonFilterChanged;
		self.onTypeFilterChanged = onTypeFilterChanged;

		init();

		function init() {
			self.defaultSortBy = self.sortBy[0].value;

			self.pendingReports = [];

			getPendingReportsList(self.searchParams, true);
			getCommunitiesWithReports();
			getReasonWithReports();
			getTypeWithReports();
		}

		function getCommunitiesWithReports() {
			var param = {type: 'pending'};
			pixerfApiCommunitySvc.get_communities_with_reports(param).$promise.then(
				function success(respone) {
					buildCommunityGroupName(respone.data);
				}, function error(error) {
					console.log(error);
				});
		}

		function getReasonWithReports() {
			var param = {type: 'pending'};
			pixerfApiCommunitySvc.get_reasons_with_reports(param).$promise.then(
				function success(respone) {
					buildReasonGroupName(respone.data);
				}, function error(error) {
					console.log(error);
				});
		}

		function getTypeWithReports() {
			var param = {type: 'pending'};
			pixerfApiCommunitySvc.get_report_types(param).$promise.then(
				function success(respone) {
					buildTypeGroupName(respone.data);
				}, function error(error) {
					console.log(error);
				});
		}

		function getPendingReportsList(params, isRefresh) {
			if (self.spinner.isVisible) return;
			self.spinner.isVisible = true;
			if (isRefresh) {
				self.totalPendingReports = 0;
				self.totalPendingPage = 0;
			}
			pixerfApiCommunitySvc.get_pending_reports(params).$promise.then(function (respone) {
				if (isRefresh) {
					self.pendingReports = respone.data;
				} else {
					self.pendingReports = self.pendingReports.concat(respone.data);
				}
				self.isLastPage = pagingUtils.isNoMorePageToLoad(params.page, respone);
				self.totalPendingPage = pagingUtils.getTotalPage(respone);
				self.totalPendingReports = pagingUtils.getTotalCount(respone);
				self.searchParams.page = params.page;
				self.spinner.isVisible = false;
			}).catch(function (error) {
				console.log(error);
				self.spinner.isVisible = false;
			})
		}

		function onReportGridChanged(report) {
			removeReportsFromList(_.pluck(report, "id"));
		}

		function removeReportsFromList(reportIds) {
			self.pendingReports = _.reject(self.pendingReports, function (re) {
				return reportIds.includes(re.id);
			})
		}

		function onSortByChanged(sortBy) {
			self.searchParams.sort = sortBy.value;
			getPendingReportsList(self.searchParams, true);
		}

		function sortByProps(propertyName, isActtionRequiredTable) {
			if (isActtionRequiredTable) {
				$scope.reverseActionRequired = ($scope.propertyActionRequiredName === propertyName) ? !$scope.reverseActionRequired : false;
				$scope.propertyActionRequiredName = propertyName;
			} else {
				$scope.reverse = ($scope.propertyName === propertyName) ? !$scope.reverse : false;
				$scope.propertyName = propertyName;
			}
		};

		function onSearchPendingReport() {
			if (self.searchPendingReportString) {
				self.searchParams.keywords = self.searchPendingReportString;
			} else {
				delete self.searchParams.keywords;
			}
			getPendingReportsList(self.searchParams, true);
		}

		function onSelectPendingReport(report) {
			self.isOpenPendingNotification = true;
			if (!report.isSelected) {
				self.isSelectedAllPendingReports = false;
				self.seletedPendingReports = _.reject(self.seletedPendingReports, function (re) {
					return report.id === re.id;
				})
			} else {
				self.seletedPendingReports.push(report);
			}
		}

		function onSelectAllPendingReports(isSelectedAllPendingReports) {
			self.isOpenPendingNotification = true;
			self.pendingReports = _.map(self.pendingReports, function (re) {
				re.isSelected = isSelectedAllPendingReports;
				if ((re.community && re.community.previous_deactivation_count >= 3) || (re.item_type == 'discussion') || (re.item_type == 'discussion_reply')) {
					re.isSelected = false;
				}
				return re;
			})

			if (self.isSelectedAllPendingReports) {
				self.seletedPendingReports = _.reject(self.pendingReports, function (re) {
					return !re.isSelected;
				});
			} else {
				self.seletedPendingReports = [];
			}
		}

		function onCloseNotification() {
			self.isOpenPendingNotification = false;
		}

		function buildCommunityGroupName(communityCountList) {
			self.communityNameFilterOptions = [];
			for (var i = 0; i < communityCountList.length; i++) {
				if(communityCountList[i].report_count > 0) {
					var option = {
						label: communityCountList[i].name + ' (' + communityCountList[i].report_count + ')',
						value: communityCountList[i].id
					}
					self.communityNameFilterOptions.push(option);
				}
			}
		}

		function buildReasonGroupName(reasonCountList) {
			self.reasonFilterOptions = [];
			for (var i = 0; i < reasonCountList.length; i++) {
				if(reasonCountList[i].report_count > 0) {
					var option = {
						label: reasonCountList[i].reason + ' (' + reasonCountList[i].report_count + ')',
						value: reasonCountList[i].reason
					}
					self.reasonFilterOptions.push(option);
				}
			}
		}

		function buildTypeGroupName(typeCountList) {
			self.typeFilterOptions = [];
			for (var i = 0; i < typeCountList.length; i++) {
				if(typeCountList[i].report_count > 0) {
					var option = {
						label: typeCountList[i].report_type + ' (' + typeCountList[i].report_count + ')',
						value: typeCountList[i].report_type
					}
					self.typeFilterOptions.push(option);
				}
			}
		}

		function clearFilter(){
			delete self.searchParams.community_ids;
			delete self.searchParams.report_types;
			delete self.searchParams.reasons; 
		}
		function onFilterChanged(selectedCommunities){
			self.selectedReasons = [];
			self.selectedTypes = [];
			clearFilter();
			var community_ids = (_.pluck(selectedCommunities, 'value'));
			if(community_ids && community_ids.length){
				self.searchParams.community_ids = community_ids.toString()
			}
			getPendingReportsList(self.searchParams, true);
		}

		function onReasonFilterChanged(selectedReasons){
			self.selectedCommunities = [];
			self.selectedTypes = [];
			clearFilter();
			var reasons = (_.pluck(selectedReasons, 'value'));
			if(reasons && reasons.length){
				self.searchParams.reasons = reasons.toString()
			}
			getPendingReportsList(self.searchParams, true);
		}

		function onTypeFilterChanged(selectedTypes){
			self.selectedCommunities = [];
			self.selectedReasons = [];
			clearFilter();
			var report_types = (_.pluck(selectedTypes, 'value'));
			if(report_types && report_types.length){
				self.searchParams.report_types = report_types.toString()
			}
			getPendingReportsList(self.searchParams, true);
		}

		function onCummunityFilterClicked() {
			self.isOpenCommunityFilter = !self.isOpenCommunityFilter;
		}

		function onReportClicked(report) {
			self.pendingReports = _.map(self.pendingReports, function (report) {
				report.selected = false;
				return report;
			})
			self.selectedReport = null;
			$timeout(function () {
				self.selectedReport = report;
				report.selected = true;
				if (window.innerWidth < 480) {
					var element = angular.element('<report-detail-compile-template id="reportDetailCompileTemplate" append-to-body="true" report="vm.selectedReport" on-closed="vm.onReportDetailsViewClosed()" context="pending" on-status-changed="vm.onReportGridChanged(data)"> </report-detail-compile-template>');
					$("body").append(element);
					$("body").addClass("modal-open");
					$compile(element)($scope);
				} else {
					self.isReportDetailsViewOpen = true;
				}
			})
			systemUtils.digest($scope);
		}

		function onReportDetailsViewClosed() {
			if (window.innerWidth < 480) {
				$("#reportDetailCompileTemplate").remove();
				$("body").removeClass("modal-open");
			} else {
				self.isReportDetailsViewOpen = false;
			}
			self.pendingReports = _.map(self.pendingReports, function (report) {
				report.selected = false;
				return report;
			})
		}

		
		function onPendingReportsListChanged(data) {
			self.searchParams.page = data.currentPage;
			getPendingReportsList(self.searchParams, true);
		}

		function onResolveReports(reports) {
			var ids = _.pluck(reports, 'id');
			var resolveReport = communityResolveReportPopupSvc.showPopup({
				data: ids,
				target: 'many'
			})

			resolveReport.result.then(function (data) {
				onReportGridChanged(reports);
			})
		}
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('managePastReportsCtrl', managePastReportsCtrl);

	managePastReportsCtrl.$inject = ['$scope', 'sessionManagerSvc', 'manageReportsSvc', 'pagingUtils', 'pixerfApiCommunitySvc', '$timeout', 'systemUtils', '$compile'];

	function managePastReportsCtrl($scope, sessionManagerSvc, manageReportsSvc, pagingUtils, pixerfApiCommunitySvc, $timeout, systemUtils, $compile) {

		var USER_CONTROL_ADMINDASHBOARD = ['curator_internal', 'admin_internal', 'marketer_internal'];
		var self = this;
		self.loginedUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.countTotal = self.loginedUser.stats || {};
		self.isAdmin = self.loginedUser && (USER_CONTROL_ADMINDASHBOARD.includes(self.loginedUser.role) || self.loginedUser.email === 'marcom@pixerf.com');
		self.parent = $scope.$parent.vm;
		self.parent.subContextPage = "past";
		self.customPagingOptions = manageReportsSvc.getCustomPagingOptions();
		self.onReportGridChanged = onReportGridChanged;
		self.onSortByChanged = onSortByChanged;
		self.onSearchPastReport = _.debounce(onSearchPastReport, 800);
		self.onCummunityFilterClicked = onCummunityFilterClicked;
		self.onReportClicked = onReportClicked;
		self.onReportDetailsViewClosed = onReportDetailsViewClosed;
		self.sortByProps = sortByProps;
		self.onPastReportsListChanged = onPastReportsListChanged;
		self.seletedPastReports = [];
		self.isReportDetailsViewOpen = false;
		self.spinner = {
			isVisible: false
		};
		self.typeFilterOptions = [];
		self.reasonFilterOptions = [];
		self.communityNameFilterOptions = [];
		self.searchParams = {
			type: 'past',
			page: 1,
			page_size: self.customPagingOptions.showValues[0]
		};
		self.sortBy = [{
				value: "date,desc",
				title: "Date of report"
			},
			{
				value: "item_type,asc",
				title: "Type of report"
			},
			{
				value: "reason,asc",
				title: "Reason for report"
			},
			{
				value: "community_name,asc",
				title: "Community Name"
			}, {
				value: "status,asc",
				title: "Status of report"
			}
		];

		self.selectedCommunities = [];
		self.selectedReasons = [];
		self.selectedTypes = [];
		self.onFilterChanged = onFilterChanged;
		self.onReasonFilterChanged = onReasonFilterChanged;
		self.onTypeFilterChanged = onTypeFilterChanged;

		init();

		function init() {
			self.defaultSortBy = self.sortBy[0].value;

			self.pastReports = [];

			getPastReportsList(self.searchParams, true);
			getCommunitiesWithReports();
			getReasonWithReports();
			getTypeWithReports();
		}

		function getCommunitiesWithReports() {
			var param = {type: 'past'};
			pixerfApiCommunitySvc.get_communities_with_reports(param).$promise.then(
				function success(respone) {
					buildCommunityGroupName(respone.data);
				}, function error(error) {
					console.log(error);
				});
		}

		function getReasonWithReports() {
			var param = {type: 'past'};
			pixerfApiCommunitySvc.get_reasons_with_reports(param).$promise.then(
				function success(respone) {
					buildReasonGroupName(respone.data);
				}, function error(error) {
					console.log(error);
				});
		}

		function getTypeWithReports() {
			var param = {type: 'past'};
			pixerfApiCommunitySvc.get_report_types(param).$promise.then(
				function success(respone) {
					buildTypeGroupName(respone.data);
				}, function error(error) {
					console.log(error);
				});
		}

		function getPastReportsList(params, isRefresh) {
			if (self.spinner.isVisible) return;
			self.spinner.isVisible = true;
			if (isRefresh) {
				self.totalPastReports = 0;
				self.totalPastPage = 0;
			}
			pixerfApiCommunitySvc.get_pending_reports(params).$promise.then(function (respone) {
				if (isRefresh) {
					self.pastReports = respone.data;
				} else {
					self.pastReports = self.pastReports.concat(respone.data);
				}
				self.isLastPage = pagingUtils.isNoMorePageToLoad(params.page, respone);
				self.totalPastPage = pagingUtils.getTotalPage(respone);
				self.totalPastReports = pagingUtils.getTotalCount(respone);
				self.searchParams.page = params.page;
				self.spinner.isVisible = false;
			}).catch(function (error) {
				console.log(error);
				self.spinner.isVisible = false;
			})
		}

		function onReportGridChanged(report) {
			removeReportsFromList(_.pluck(report, "id"));
		}

		function removeReportsFromList(reportIds) {
			self.pastReports = _.reject(self.pastReports, function (re) {
				return reportIds.includes(re.id);
			})
		}

		function onSortByChanged(sortBy) {
			self.searchParams.sort = sortBy.value;
			getPastReportsList(self.searchParams, true);
		}

		function sortByProps(propertyName, isActtionRequiredTable) {
			if (isActtionRequiredTable) {
				$scope.reverseActionRequired = ($scope.propertyActionRequiredName === propertyName) ? !$scope.reverseActionRequired : false;
				$scope.propertyActionRequiredName = propertyName;
			} else {
				$scope.reverse = ($scope.propertyName === propertyName) ? !$scope.reverse : false;
				$scope.propertyName = propertyName;
			}
		};

		function onSearchPastReport() {
			if (self.searchPastReportString) {
				self.searchParams.keywords = self.searchPastReportString;
			} else {
				delete self.searchParams.keywords;
			}
			getPastReportsList(self.searchParams, true);
		}

		function buildCommunityGroupName(communityCountList) {
			self.communityNameFilterOptions = [];
			for (var i = 0; i < communityCountList.length; i++) {
				if (communityCountList[i].report_count > 0) {
					var option = {
						label: communityCountList[i].name + ' (' + communityCountList[i].report_count + ')',
						value: communityCountList[i].id
					}
					self.communityNameFilterOptions.push(option);
				}
			}
		}

		function buildReasonGroupName(reasonCountList) {
			self.reasonFilterOptions = [];
			for (var i = 0; i < reasonCountList.length; i++) {
				if(reasonCountList[i].report_count > 0) {
					var option = {
						label: reasonCountList[i].reason + ' (' + reasonCountList[i].report_count + ')',
						value: reasonCountList[i].reason
					}
					self.reasonFilterOptions.push(option);
				}
			}
		}

		function buildTypeGroupName(typeCountList) {
			self.typeFilterOptions = [];
			for (var i = 0; i < typeCountList.length; i++) {
				if(typeCountList[i].report_count > 0) {
					var option = {
						label: typeCountList[i].report_type + ' (' + typeCountList[i].report_count + ')',
						value: typeCountList[i].report_type
					}
					self.typeFilterOptions.push(option);
				}
			}
		}
		function clearFilter(){
			delete self.searchParams.community_ids;
			delete self.searchParams.report_types;
			delete self.searchParams.reasons; 
		}
		function onFilterChanged(selectedCommunities){
			self.selectedReasons = [];
			self.selectedTypes = [];
			clearFilter();
			var community_ids = (_.pluck(selectedCommunities, 'value'));
			if(community_ids && community_ids.length){
				self.searchParams.community_ids = community_ids.toString()
			}
			getPastReportsList(self.searchParams, true);
		}

		function onReasonFilterChanged(selectedReasons){
			self.selectedCommunities = [];
			self.selectedTypes = [];
			clearFilter();
			var reasons = (_.pluck(selectedReasons, 'value'));
			if(reasons && reasons.length){
				self.searchParams.reasons = reasons.toString()
			}
			getPastReportsList(self.searchParams, true);
		}

		function onTypeFilterChanged(selectedTypes){
			self.selectedCommunities = [];
			self.selectedReasons = [];
			clearFilter();
			var report_types = (_.pluck(selectedTypes, 'value'));
			if(report_types && report_types.length){
				self.searchParams.report_types = report_types.toString()
			}
			getPastReportsList(self.searchParams, true);
		}

		function onCummunityFilterClicked() {
			self.isOpenCommunityFilter = !self.isOpenCommunityFilter;
		}

		function onReportClicked(report) {
			self.pastReports = _.map(self.pastReports, function (report) {
				report.selected = false;
				return report;
			})
			self.selectedReport = null;
			$timeout(function () {
				self.selectedReport = report;
				report.selected = true;
				if (window.innerWidth < 480) {
					var element = angular.element('<report-detail-compile-template id="reportDetailCompileTemplate" append-to-body="true" report="vm.selectedReport" on-closed="vm.onReportDetailsViewClosed()" context="pending" on-status-changed="vm.onReportGridChanged(data)"> </report-detail-compile-template>');
					$("body").append(element);
					$("body").addClass("modal-open");
					$compile(element)($scope);
				} else {
					self.isReportDetailsViewOpen = true;
				}
			})
			systemUtils.digest($scope);
		}
		
		function onPastReportsListChanged(data) {
			self.searchParams.page = data.currentPage;
			getPastReportsList(self.searchParams, true);
		}

		function onReportDetailsViewClosed() {
			if (window.innerWidth < 480) {
				$("#reportDetailCompileTemplate").remove();
				$("body").removeClass("modal-open");
			} else {
				self.isReportDetailsViewOpen = false;
			}
			self.pastReports = _.map(self.pastReports, function (report) {
				report.selected = false;
				return report;
			})
		}
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('managePastEventsCtrl', managePastEventsCtrl);

	managePastEventsCtrl.$inject = ['$scope', 'eventConst', 'pixerfApiEventSvc', 'sessionManagerSvc', 'pagingUtils', 'manageEventsSvc'];

	function managePastEventsCtrl($scope, eventConst, pixerfApiEventSvc, sessionManagerSvc, pagingUtils, manageEventsSvc) {

		var self = this;
		self.loginedUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.eventConst = eventConst;
		self.parent = $scope.$parent.vm;
		self.isMyProfile = self.parent.isMyProfile;
		self.parent.subContextPage = "Past Events";
		self.user = self.parent.user;
		self.onSortByChanged = onSortByChanged;
		self.onSelectAllEvents = onSelectAllEvents;
		self.onSelectedEvent = onSelectedEvent;
		self.onCloseNotification = onCloseNotification;
		self.eventGridChanged = eventGridChanged;
		self.onSearchEvent = _.debounce(onSearchEvent, 800);
		self.fetchMoreEventsList = fetchMoreEventsList;
		self.eventsListChanged = eventsListChanged;
		self.onPageSizeEventsChanged = onPageSizeEventsChanged;
		self.selectedEvents = [];
		self.sortDateBy = 'asc';
		self.sortNameBy = 'asc';
		self.sortStatsBy = 'asc';
		self.customPagingOptions = manageEventsSvc.getCustomPagingOptions();
		self.spinner = {
			isVisible: false
		};
		self.searchParams = {
			page: 1,
			event_statuses: 'cancelled,deleted,rejected,active,reported',
			type: 'past',
			id: self.loginedUser.id,
			user_id: self.loginedUser.id,
			page_size: self.customPagingOptions.showValues[0]
		};
		self.sortBy = [{
			value: "inserted_at,desc",
			title: "Date created"
		},
		{
			value: "is_private,desc",
			title: "Privacy"
		},
		{
			value: "member_count,desc",
			title: "Members"
		}
		];

		init();

		function init() {
			self.defaultSortBy = self.sortBy[0].value;
			self.searchParams.sort = self.sortBy[0].value;
			self.events = [];
			getEventsList(self.searchParams, true);
		}

		function onSortByChanged(value, type) {
			if (value === 'name') {
				self.sortNameBy = (type === 'asc') ? 'desc' : 'asc';
			}
			if (value === 'event_datetimes') {
				self.sortDateBy = (type === 'asc') ? 'desc' : 'asc';
			}
			if (value === 'stats.going') {
				self.sortStatsBy = (type === 'asc') ? 'desc' : 'asc';
			}
			self.searchParams.sort = value + ',' + type;
			getEventsList(self.searchParams, true);
		}

		function getEventsList(params, isRefresh) {
			if (self.spinner.isVisible) return;
			self.spinner.isVisible = true;
			pixerfApiEventSvc.get_past_events(params).$promise.then(function (response) {
				if (isRefresh) {
					self.events = response.data;
				} else {
					self.events = self.events.concat(response.data);
				}
				self.isLastPage = pagingUtils.isNoMorePageToLoad(params.page, response);
				self.totalPage = pagingUtils.getTotalPage(response);
				self.totalEvents = pagingUtils.getTotalCount(response);
				self.searchParams.page = params.page;
				self.spinner.isVisible = false;
			}).catch(function (error) {
				console.log(error);
				self.spinner.isVisible = false;
			})
		}

		function eventsListChanged(data) {
			self.searchParams.page = data.currentPage;
			getEventsList(self.searchParams, true);
		}

		function onPageSizeEventsChanged(pageSize) {
			self.searchParams.page = 1
			self.searchParams.page_size = pageSize;
			getEventsList(self.searchParams, true);
		}

		function fetchMoreEventsList() {
			if (self.isLastPage || self.spinner.isVisible) return;
			var searchParams = $.extend(true, {}, self.searchParams);
			searchParams.page++;
			getEventsList(searchParams);
		}

		function onSelectAllEvents(isSelectedAllEvents) {
			self.isOpenNotification = true;
			self.events = _.map(self.events, function (item) {
				item.isSelected = isSelectedAllEvents;
				return item;
			})

			if (self.isSelectedAllEvents) {
				self.selectedEvents = self.events;
			} else {
				self.selectedEvents = [];
			}
		}

		function onSelectedEvent(event) {
			self.isOpenNotification = true;
			if (!event.isSelected) {
				self.isSelectedAllEvents = false;
				self.selectedEvents = _.reject(self.selectedEvents, function (item) {
					return event.id === item.id;
				})
			} else {
				self.selectedEvents.push(event);
			}
		}

		function onCloseNotification() {
			self.isOpenNotification = false;
		}

		function removeEventsFromList(eventIds) {
			self.events = _.reject(self.events, function (item) {
				return eventIds.includes(item.id);
			})
		}

		function removeEventFromList(eventId) {
			self.events = _.reject(self.events, function (item) {
				return eventId == item.id;
			})
		}

		function eventGridChanged(event) {
			if (event && event.length) {
				removeEventsFromList(_.pluck(event, "id"));
			} else {
				removeEventFromList(event.id);
			}
			onEventDetailsViewClosed();
		}

		function onSearchEvent() {
			if (self.searchEventString) {
				self.searchParams.keywords = self.searchEventString;
			} else {
				delete self.searchParams.keywords;
			}
			getEventsList(self.searchParams, true);
		}
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('manageInvitedEventsCtrl', manageInvitedEventsCtrl);

	manageInvitedEventsCtrl.$inject = ['$scope', 'eventConst', 'pixerfApiEventSvc', 'sessionManagerSvc', 'pagingUtils', 'manageEventsSvc'];

	function manageInvitedEventsCtrl($scope, eventConst, pixerfApiEventSvc, sessionManagerSvc, pagingUtils, manageEventsSvc) {

		var self = this;
		self.loginedUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.eventConst = eventConst;
		self.parent = $scope.$parent.vm;
		self.isMyProfile = self.parent.isMyProfile;
		self.parent.subContextPage = "Invited";
		self.user = self.parent.user;
		self.onSortByChanged = onSortByChanged;
		self.onSelectAllEvents = onSelectAllEvents;
		self.onSelectedEvent = onSelectedEvent;
		self.onCloseNotification = onCloseNotification;
		self.eventGridChanged = eventGridChanged;
		self.onSearchEvent = _.debounce(onSearchEvent, 800);
		self.fetchMoreEventsList = fetchMoreEventsList;
		self.eventsListChanged = eventsListChanged;
		self.onPageSizeEventsChanged = onPageSizeEventsChanged;
		self.selectedEvents = [];
		self.sortDateBy = 'asc';
		self.sortNameBy = 'asc';
		self.customPagingOptions = manageEventsSvc.getCustomPagingOptions();
		self.spinner = {
			isVisible: false
		};
		self.searchParams = {
			id: self.loginedUser.id,
			user_id: self.loginedUser.id,
			event_statuses: 'cancelled,deleted,rejected,active,reported',
			page: 1,
			page_size: self.customPagingOptions.showValues[0]
		};
		self.sortBy = [{
				value: "inserted_at,desc",
				title: "Date created"
			},
			{
				value: "is_private,desc",
				title: "Privacy"
			},
			{
				value: "member_count,desc",
				title: "Members"
			}
		];

		init();

		function init() {
			self.defaultSortBy = self.sortBy[0].value;
			self.searchParams.sort = self.sortBy[0].value;
			self.events = [];
			getEventsList(self.searchParams, true);
		}

		function onSortByChanged(value, type) {
			if (value === 'name') {
				self.sortNameBy = (type === 'asc') ? 'desc' : 'asc';
			}
			if (value === 'event_datetimes') {
				self.sortDateBy = (type === 'asc') ? 'desc' : 'asc';
			}

			self.searchParams.sort = value + ',' + type;
			getEventsList(self.searchParams, true);
		}

		function getEventsList(params, isRefresh) {
			if (self.spinner.isVisible) return;
			self.spinner.isVisible = true;
			pixerfApiEventSvc.get_invited_events(params).$promise.then(function (response) {
				if (isRefresh) {
					self.events = response.data;
				} else {
					self.events = self.events.concat(response.data);
				}
				self.isLastPage = pagingUtils.isNoMorePageToLoad(params.page, response);
				self.totalInvitedPage = pagingUtils.getTotalPage(response);
				self.totalEvents = pagingUtils.getTotalCount(response);
				self.searchParams.page = params.page;
				self.spinner.isVisible = false;
			}).catch(function (error) {
				console.log(error);
				self.spinner.isVisible = false;
			})
		}

		function eventsListChanged(data) {
			self.searchParams.page = data.currentPage;
			getEventsList(self.searchParams, true);
		}

		function onPageSizeEventsChanged(pageSize) {
			self.searchParams.page = 1
			self.searchParams.page_size = pageSize;
			getEventsList(self.searchParams, true);
		}

		function fetchMoreEventsList() {
			if (self.isLastPage || self.spinner.isVisible) return;
			var searchParams = $.extend(true, {}, self.searchParams);
			searchParams.page++;
			getEventsList(searchParams);
		}

		function onSelectAllEvents(isSelectedAllEvents) {
			self.isOpenNotification = true;
			self.events = _.map(self.events, function (item) {
				item.isSelected = isSelectedAllEvents;
				return item;
			})

			if (self.isSelectedAllEvents) {
				self.selectedEvents = self.events;
			} else {
				self.selectedEvents = [];
			}
		}

		function onSelectedEvent(event) {
			self.isOpenNotification = true;
			if (!event.isSelected) {
				self.isSelectedAllEvents = false;
				self.selectedEvents = _.reject(self.selectedEvents, function (item) {
					return event.id === item.id;
				})
			} else {
				self.selectedEvents.push(event);
			}
		}

		function onCloseNotification() {
			self.isOpenNotification = false;
		}

		function removeEventsFromList(eventIds) {
			self.events = _.reject(self.events, function (item) {
				return eventIds.includes(item.id);
			})
		}

		function removeEventFromList(eventId) {
			self.events = _.reject(self.events, function (item) {
				return eventId == item.id;
			})
		}

		function eventGridChanged(event) {
			if (event && event.length) {
				removeEventsFromList(_.pluck(event, "id"));
			} else {
				removeEventFromList(event.id);
			}
			onEventDetailsViewClosed();
		}

		function onSearchEvent() {
			if (self.searchEventString) {
				self.searchParams.keywords = self.searchEventString;
			} else {
				delete self.searchParams.keywords;
			}
			getEventsList(self.searchParams, true);
		}
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('manageInterestedEventsCtrl', manageInterestedEventsCtrl);

	manageInterestedEventsCtrl.$inject = ['$scope', 'eventConst', 'pixerfApiEventSvc', 'sessionManagerSvc', 'pagingUtils', 'manageEventsSvc'];

	function manageInterestedEventsCtrl($scope, eventConst, pixerfApiEventSvc, sessionManagerSvc, pagingUtils, manageEventsSvc) {

		var self = this;
		self.loginedUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.eventConst = eventConst;
		self.parent = $scope.$parent.vm;
		self.isMyProfile = self.parent.isMyProfile;
		self.parent.subContextPage = "Interested";
		self.user = self.parent.user;
		self.onSortByChanged = onSortByChanged;
		self.onSelectAllEvents = onSelectAllEvents;
		self.onSelectedEvent = onSelectedEvent;
		self.isEventDetailsViewOpen = false;
		self.onCloseNotification = onCloseNotification;
		self.eventGridChanged = eventGridChanged;
		self.onSearchEvent = _.debounce(onSearchEvent, 800);
		self.fetchMoreEventsList = fetchMoreEventsList;
		self.eventsListChanged = eventsListChanged;
		self.onPageSizeEventsChanged = onPageSizeEventsChanged;
		self.onGoingCommunities = onGoingCommunities;
		self.selectedEvents = [];
		self.sortDateBy = 'asc';
		self.sortNameBy = 'asc';
		self.customPagingOptions = manageEventsSvc.getCustomPagingOptions();
		self.spinner = {
			isVisible: false
		};
		self.searchParams = {
			id: self.loginedUser.id,
			user_id: self.loginedUser.id,
			event_statuses: 'cancelled,deleted,rejected,active,reported',
			page: 1,
			page_size: self.customPagingOptions.showValues[0]
		};
		self.sortBy = [{
				value: "inserted_at,desc",
				title: "Date created"
			},
			{
				value: "is_private,desc",
				title: "Privacy"
			},
			{
				value: "member_count,desc",
				title: "Members"
			}
		];

		init();

		function init() {
			self.defaultSortBy = self.sortBy[0].value;
			self.searchParams.sort = self.sortBy[0].value;
			self.events = [];
			getEventsList(self.searchParams, true);
		}
		
		function onSortByChanged(value, type) {
			if (value === 'name') {
				self.sortNameBy = (type === 'asc') ? 'desc' : 'asc';
			}
			if (value === 'event_datetimes') {
				self.sortDateBy = (type === 'asc') ? 'desc' : 'asc';
			}

			self.searchParams.sort = value + ',' + type;
			getEventsList(self.searchParams, true);
		}
		
		function getEventsList(params, isRefresh) {
			if (self.spinner.isVisible) return;
			self.spinner.isVisible = true;
			pixerfApiEventSvc.get_interested_events(params).$promise.then(function (response) {
				if (isRefresh) {
					self.events = response.data;
				} else {
					self.events = self.events.concat(response.data);
				}
				self.isLastPage = pagingUtils.isNoMorePageToLoad(params.page, response);
				self.totalInvitedPage = pagingUtils.getTotalPage(response);
				self.totalEvents = pagingUtils.getTotalCount(response);
				self.searchParams.page = params.page;
				self.spinner.isVisible = false;
			}).catch(function (error) {
				console.log(error);
				self.spinner.isVisible = false;
			})
		}

		function eventsListChanged(data) {
			self.searchParams.page = data.currentPage;
			getEventsList(self.searchParams, true);
		}

		function onPageSizeEventsChanged(pageSize) {
			self.searchParams.page = 1
			self.searchParams.page_size = pageSize;
			getEventsList(self.searchParams, true);
		}

		function fetchMoreEventsList() {
			if (self.isLastPage || self.spinner.isVisible) return;
			var searchParams = $.extend(true, {}, self.searchParams);
			searchParams.page++;
			getEventsList(searchParams);
		}

		function onSelectAllEvents(isSelectedAllEvents) {
			self.isOpenNotification = true;
			self.events = _.map(self.events, function (item) {
				item.isSelected = isSelectedAllEvents;
				return item;
			})

			if (self.isSelectedAllEvents) {
				self.selectedEvents = self.events;
			} else {
				self.selectedEvents = [];
			}
		}

		function onSelectedEvent(event) {
			self.isOpenNotification = true;
			if (!event.isSelected) {
				self.isSelectedAllEvents = false;
				self.selectedEvents = _.reject(self.selectedEvents, function (item) {
					return event.id === item.id;
				})
			} else {
				self.selectedEvents.push(event);
			}
		}

		function onCloseNotification() {
			self.isOpenNotification = false;
		}

		function removeEventsFromList(eventIds) {
			self.events = _.reject(self.events, function (item) {
				return eventIds.includes(item.id);
			})
		}

		function removeEventFromList(eventId) {
			self.events = _.reject(self.events, function (item) {
				return eventId == item.id;
			})
		}

		function eventGridChanged(event) {
			if (event && event.length) {
				removeEventsFromList(_.pluck(event, "id"));
			} else {
				removeEventFromList(event.id);
			}
		}

		function onSearchEvent() {
			if (self.searchEventString) {
				self.searchParams.keywords = self.searchEventString;
			} else {
				delete self.searchParams.keywords;
			}
			getEventsList(self.searchParams, true);
		}

		function onGoingCommunities() {

		}
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('manageInReviewEventsCtrl', manageInReviewEventsCtrl);

	manageInReviewEventsCtrl.$inject = ['$scope', 'communityConst', '$timeout', 'systemUtils', 'pixerfApiEventSvc', 'toastr', 'pagingUtils', 'sessionManagerSvc', 'translationSvc', 'manageEventsSvc', '$compile', 'pixerfApiCommunitySvc'];

	function manageInReviewEventsCtrl($scope, communityConst, $timeout, systemUtils, pixerfApiEventSvc, toastr, pagingUtils, sessionManagerSvc, translationSvc, manageEventsSvc, $compile, pixerfApiCommunitySvc) {

		var USER_CONTROL_ADMINDASHBOARD = ['curator_internal', 'admin_internal', 'marketer_internal'];
		var self = this;
		self.loginedUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.countTotal = self.loginedUser.stats || {};
		self.isAdmin = self.loginedUser && (USER_CONTROL_ADMINDASHBOARD.includes(self.loginedUser.role) || self.loginedUser.email === 'marcom@pixerf.com');
		self.communityConst = communityConst;
		self.parent = $scope.$parent.vm;
		self.isMyProfile = self.parent.isMyProfile;
		self.parent.subContextPage = "in review";
		self.user = self.parent.user;
		self.onToggleActionRequired = onToggleActionRequired;
		self.onSortByChanged = onSortByChanged;
		self.onSelectAllEvents = onSelectAllEvents;
		self.onSelectedEvent = onSelectedEvent;
		self.onEventClicked = onEventClicked;
		self.onEventDetailsViewClosed = onEventDetailsViewClosed;
		self.isEventDetailsViewOpen = false;
		self.onCloseNotification = onCloseNotification;
		self.onApproveEvents = onApproveEvents;
		self.onRejectEvents = onRejectEvents;
		self.onCommunityGridChanged = onCommunityGridChanged;
		self.fetchMorePendingCommunitiesList = fetchMorePendingCommunitiesList;
		self.selectedEvents = [];
		self.selecedActionRequiredCommunities = [];
		self.sortByProps = sortByProps;
		self.sortBySelected = sortBySelected;
		self.onFilterChanged = onFilterChanged;
		self.selectedCommunity = [];
		self.onSearchOngoingEvent = _.debounce(onSearchOngoingEvent, 800);
		self.onListChanged = onListChanged;

		self.customPagingOptions = manageEventsSvc.getCustomPagingOptions();
		self.onPageSizeChanged = onPageSizeChanged;
		self.searchParams = {
			page: 1,
			status: 'reported',
			page_size: self.customPagingOptions.showValues[0]
		};
		self.spinner = {
			isVisible: false
		};
		self.searchParamsActionRequired = {
			page: 1
		};
		self.searchOngoingEventString = '';
		self.viewEventDetailOptions = {};

		self.sortBy = [{
				value: "date,desc",
				title: "Date of event"
			},
			{
				value: "community_name,desc",
				title: "Community"
			},
			{
				value: "privacy,desc",
				title: "Privacy"
			}
		];
		self.communityPrivacyFilterOptions = [{
				label: 'Public first',
				value: 'is_privateDesc',
				key: 'is_private',
				orderBy: 'desc'
			},
			{
				label: 'Private first',
				value: 'is_private',
				key: 'is_private',
			}
		];
		self.dateOfEventFilterOptions = [{
				label: 'Ascending',
				value: 'eventStartDate',
				key: 'eventStartDate',
			},
			{
				label: 'Descending',
				value: 'eventStartDateDesc',
				key: 'eventStartDate',
				orderBy: 'desc'
			}

		];

		self.communityNameFilterOptions = [];
		self.onCommunityFilterClicked = onCommunityFilterClicked;
		self.isOpenCommunityFilter = false;
		self.showAdminColm = false;
		self.colsOrder = {
			selectBox: 1,
			eventName: 2,
			communityName: 3,
			admin: 3,
			privacy: 6,
			status: 4,
			eventTime: 5,
			attendees: 7,
			statGoing: 8,
			interested: 9,
			invited: 10,
			actions: 11
		};

		init();

		function init() {
			self.defaultSortBy = self.sortBy[0].value;
			self.isOpenPendingApproval = true;
			self.isOpenActionRequired = true;
			self.showAdminColm = self.isAdmin ? true : false;

			self.events = [];
			self.actionRequiredCommunities = [];

			getEventList(self.searchParams);

			getCommunitiesWithEvents();
		}

		function onToggleActionRequired(isOpen) {
			self.isOpenActionRequired = !isOpen;
		}

		function onSortByChanged(sortBy) {
			self.searchParams.sort = sortBy.value;
			getEventList(self.searchParams, true);
		}

		function getCommunitiesWithEvents() {
			var param = {
				status: 'reported'
			};
			pixerfApiCommunitySvc.get_communities_with_events(param).$promise.then(
				function success(respone) {
					buildCommunityGroupName(respone.data);
				},
				function error(error) {
					console.log(error);
				});
		}

		function getEventList(params, isRefresh) {
			if (self.spinner.isVisible) return;
			if (isRefresh) {
				self.totalActiveEvents = 0;
				self.totalActivePage = 0;
			}
			self.spinner.isVisible = true;
			var community_ids = (_.pluck(self.selectedCommunity, 'value'));
			delete params.community_ids;
			if (community_ids.length) {
				params.community_ids = community_ids.toString()
			}
			pixerfApiEventSvc.getAllEvent(params).$promise.then(function (respone) {
				if (isRefresh) {
					self.events = respone.data;
				} else {
					self.events = self.events.concat(respone.data);
				}
				self.isLastPendingPage = pagingUtils.isNoMorePageToLoad(params.page, respone);
				self.searchParams.page = params.page;
				self.totalActiveEvents = pagingUtils.getTotalCount(respone);
				self.totalActivePage = pagingUtils.getTotalPage(respone);
				self.spinner.isVisible = false;
			}).catch(function (error) {
				console.log(error);
				self.spinner.isVisible = false;
			})
		}

		function buildCommunityGroupName(communityCountList) {
			self.communityNameFilterOptions = [];
			for (var i = 0; i < communityCountList.length; i++) {
				var option = {
					label: communityCountList[i].name + ' (' + communityCountList[i].event_count + ')',
					value: communityCountList[i].id
				}
				self.communityNameFilterOptions.push(option);
			}

		}

		function onSelectAllEvents(isSelectedAllEvents) {
			self.isOpenPendingNotification = true;
			self.events = _.map(self.events, function (com) {
				com.isSelected = isSelectedAllEvents;
				return com;
			})

			if (self.isSelectedAllEvents) {
				self.selectedEvents = self.events;
			} else {
				self.selectedEvents = [];
			}
		}

		function fetchMorePendingCommunitiesList() {
			if (self.isLastPendingPage || self.spinner.isVisible) return;
			var searchParams = $.extend(true, {}, self.searchParams);
			searchParams.page++;
			getEventList(searchParams);
		}

		function onSelectedEvent(event) {
			self.isOpenPendingNotification = true;
			if (!event.isSelected) {
				self.isSelectedAllEvents = false;
				self.selectedEvents = _.reject(self.selectedEvents, function (com) {
					return event.id === com.id;
				})
			} else {
				self.selectedEvents.push(event);
			}
		}

		function onEventClicked(event, action) {
			self.selectedEvent = null;
			self.events = _.map(self.events, function (event) {
				event.selected = false;
				return event;
			})
			$timeout(function () {
				self.selectedEvent = event;
				self.viewEventDetailOptions.editEventDetail = (action == 'editEventDetail');
				self.viewEventDetailOptions.manageAttendees = (action == 'manageAttendees');

				event.selected = true;
				if (window.innerWidth < 480) {
					var element = angular.element('<event-detail-compile-template id="eventDetailCompileTemplate" append-to-body="true" event="vm.selectedEvent" on-closed="vm.onEventDetailsViewClosed(event)" context="unpublished" options="vm.viewEventDetailOptions" on-status-changed="vm.onCommunityGridChanged(community, vm.contextCompileTemplate)"></event-detail-compile-template>');
					$("body").append(element);
					$("body").addClass("modal-open");
					$compile(element)($scope);
				} else {
					self.isEventDetailsViewOpen = true;
				}
			})
			systemUtils.digest($scope);
		}

		function onEventDetailsViewClosed(event) {
			if (window.innerWidth < 480) {
				$("#eventDetailCompileTemplate").remove();
				$("body").removeClass("modal-open");
			} else {
				self.isEventDetailsViewOpen = false;
			}
			self.events = _.map(self.events, function (event) {
				event.selected = false;
				return event;
			})
			if (event && event.id) {
				self.selectedEvent = event;
				var index = _.findIndex(self.events, function (i) {
					return i.id === event.id;
				})
				self.events[index] = event;

				if (event.status == 'active') {
					self.events = _.reject(self.events, function (com) {
						return event.id === com.id;
					})
				}
				if (event.status == 'rejected') {
					self.events = _.reject(self.events, function (com) {
						return event.id === com.id;
					})
				}
				$scope.$parent.vm.getUpdatedCountTotal();
			}
		}

		function onCloseNotification(type) {
			switch (type) {
				case 'pending':
					self.isOpenPendingNotification = false;
					break;
				case 'action-required':
					self.isOpenActionRequiredNotification = false;
					break;
			}
		}

		function onEventsStatusChanged(events) {
			for (var i = 0; i < events.length; i++) {
				onEventDetailsViewClosed(events[i]);
			}
		}

		function onApproveEvents(events) {
			self.parent.updateEventsStatus(events, 'active').then(
				function success(res) {
					onEventsStatusChanged(events);
					self.selectedEvents = [];
					self.isSelectedAllEvents = false;
					toastr.success("Your events updated successfully");
				},
				function error(err) {
					toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
				}
			)
		}

		function onRejectEvents(events) {
			self.parent.updateEventsStatus(events, 'rejected').then(
				function success(res) {
					onEventsStatusChanged(events);
					self.selectedEvents = [];
					self.isSelectedAllEvents = false;
					toastr.success("Your events updated successfully");
				},
				function error(err) {
					toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
				}
			)
		}

		function onPageSizeChanged(pageSize) {
			self.searchParams.page = 1;
			self.searchParams.page_size = pageSize;
			getEventList(self.searchParams, true);
		}

		function removeCommunitiesFromList(communityIds, type) {
			switch (type) {
				case 'pending':
					self.events = _.reject(self.events, function (com) {
						return communityIds.includes(com.id);
					})
					break;
				case 'action-required':
					self.actionRequiredCommunities = _.reject(self.actionRequiredCommunities, function (com) {
						return communityIds.includes(com.id);
					})
					break;
			}
		}

		function onCommunityGridChanged(community, context) {
			switch (context) {
				case 'pending':
					removeCommunitiesFromList([community.id], context);
					self.actionRequiredCommunities.push(community);
					break;
			}
		}

		function onFilterChanged(items) {
			self.selectedCommunity = items;
			getEventList(self.searchParams, true);
		}

		function sortBySelected(selectedItems) {
			if (selectedItems && selectedItems[0]) {
				sortByProps(selectedItems[0].key, selectedItems[0].orderBy)
			}
		}

		function sortByProps(propertyName, orderBy) {
			if (orderBy) {
				$scope.reverse = (orderBy == 'desc');
			} else {
				$scope.reverse = ($scope.propertyName === propertyName) ? !$scope.reverse : false;
			}
			$scope.propertyName = propertyName;
		};

		function onSearchOngoingEvent() {
			if (self.searchOngoingEventString) {
				self.searchParams.keywords = self.searchOngoingEventString;
			} else {
				delete self.searchParams.keywords;
			}
			getEventList(self.searchParams, true);

		}

		function onCommunityFilterClicked() {
			self.isOpenCommunityFilter = !self.isOpenCommunityFilter;
		}

		function onListChanged(data) {
			self.searchParams.page = data.currentPage;
			getEventList(self.searchParams, true);
		}
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('manageHostingEventsCtrl', manageHostingEventsCtrl);

	manageHostingEventsCtrl.$inject = ['$scope', 'eventConst', 'pixerfApiEventSvc', 'sessionManagerSvc', 'pagingUtils', 'manageEventsSvc', 'confirmPopupSvc', '$q', 'toastr', '$translate'];

	function manageHostingEventsCtrl($scope, eventConst, pixerfApiEventSvc, sessionManagerSvc, pagingUtils, manageEventsSvc, confirmPopupSvc, $q, toastr, $translate) {

		var self = this;
		self.loginedUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.eventConst = eventConst;
		self.parent = $scope.$parent.vm;
		self.isMyProfile = self.parent.isMyProfile;
		self.parent.subContextPage = "Hosting";
		self.user = self.parent.user;
		self.onSortByChanged = onSortByChanged;
		self.onSelectAllEvents = onSelectAllEvents;
		self.onSelectedEvent = onSelectedEvent;
		self.onCloseNotification = onCloseNotification;
		self.eventGridChanged = eventGridChanged;
		self.onSearchEvent = _.debounce(onSearchEvent, 800);
		self.fetchMoreEventsList = fetchMoreEventsList;
		self.eventsListChanged = eventsListChanged;
		self.onPageSizeEventsChanged = onPageSizeEventsChanged;
		self.onDeleteEvents = onDeleteEvents;
		self.selectedEvents = [];
		self.sortDateBy = 'asc';
		self.sortNameBy = 'asc';
		self.customPagingOptions = manageEventsSvc.getCustomPagingOptions();
		self.spinner = {
			isVisible: false
		};
		self.searchParams = {
			event_statuses: 'cancelled,deleted,rejected,active,reported',
			id: self.loginedUser.id,
			user_id: self.loginedUser.id,
			page: 1,
			page_size: self.customPagingOptions.showValues[0]
		};
		self.sortBy = [{
			value: "inserted_at,desc",
			title: "Date created"
		},
		{
			value: "is_private,desc",
			title: "Privacy"
		},
		{
			value: "member_count,desc",
			title: "Members"
		}
		];

		init();

		function init() {
			self.defaultSortBy = self.sortBy[0].value;
			self.searchParams.sort = self.sortBy[0].value;
			self.events = [];
			getEventsList(self.searchParams, true);
		}
		
		function onSortByChanged(value, type) {
			if (value === 'name') {
				self.sortNameBy = (type === 'asc') ? 'desc' : 'asc';
			}
			if (value === 'event_datetimes') {
				self.sortDateBy = (type === 'asc') ? 'desc' : 'asc';
			}

			self.searchParams.sort = value + ',' + type;
			getEventsList(self.searchParams, true);
		}

		function getEventsList(params, isRefresh) {
			if (self.spinner.isVisible) return;
			self.spinner.isVisible = true;
			pixerfApiEventSvc.get_hosting_events(params).$promise.then(function (response) {
				if (isRefresh) {
					self.events = response.data;
				} else {
					self.events = self.events.concat(response.data);
				}
				self.isLastPage = pagingUtils.isNoMorePageToLoad(params.page, response);
				self.totalInvitedPage = pagingUtils.getTotalPage(response);
				self.totalEvents = pagingUtils.getTotalCount(response);
				self.searchParams.page = params.page;
				self.spinner.isVisible = false;
			}).catch(function (error) {
				console.log(error);
				self.spinner.isVisible = false;
			})
		}

		function eventsListChanged(data) {
			self.searchParams.page = data.currentPage;
			getEventsList(self.searchParams, true);
		}

		function onPageSizeEventsChanged(pageSize) {
			self.searchParams.page = 1
			self.searchParams.page_size = pageSize;
			getEventsList(self.searchParams, true);
		}

		function fetchMoreEventsList() {
			if (self.isLastPage || self.spinner.isVisible) return;
			var searchParams = $.extend(true, {}, self.searchParams);
			searchParams.page++;
			getEventsList(searchParams);
		}

		function onSelectAllEvents(isSelectedAllEvents) {
			self.isOpenNotification = true;
			self.events = _.map(self.events, function (item) {
				item.isSelected = isSelectedAllEvents;
				return item;
			})

			if (self.isSelectedAllEvents) {
				self.selectedEvents = self.events;
			} else {
				self.selectedEvents = [];
			}
		}

		function onSelectedEvent(event) {
			self.isOpenNotification = true;
			if (!event.isSelected) {
				self.isSelectedAllEvents = false;
				self.selectedEvents = _.reject(self.selectedEvents, function (item) {
					return event.id === item.id;
				})
			} else {
				self.selectedEvents.push(event);
			}
		}

		function onCloseNotification() {
			self.isOpenNotification = false;
		}

		function removeEventsFromList(eventIds) {
			self.events = _.reject(self.events, function (item) {
				return eventIds.includes(item.id);
			})
		}

		function removeEventFromList(eventId) {
			self.events = _.reject(self.events, function (item) {
				return eventId == item.id;
			})
		}

		function eventGridChanged(event) {
			if (event && event.length && ['deleted'].includes(event[0].status)) {
				removeEventsFromList(_.pluck(event, "id"));
			} else if (['deleted'].includes(event.status)) {
				removeEventFromList(event.id);
			}
		}

		function onSearchEvent() {
			if (self.searchEventString) {
				self.searchParams.keywords = self.searchEventString;
			} else {
				delete self.searchParams.keywords;
			}
			getEventsList(self.searchParams, true);
		}

		function onDeleteEvents(events) {
			confirmPopupSvc.showPopup({
				windowClass: 'delete-event-confirm-popup',
				title: $translate.instant("you-are-about-to-delete-these-events"),
				message: $translate.instant("deleting-your-events-will-remove-it"),
				submitBtnText: 'Yes',
				cancelBtnText: 'Cancel',
				submit: function () {
					var def = $q.defer();
					updateEventsStatus(events, 'deleted').then(
						function (res) {
							toastr.success("You have deleted successfully");
							eventGridChanged(events);
							def.resolve(res);
						},
						function (err) {
							def.reject(err);
						}
					);
					return def.promise;
				}
			});
		}

		function updateEventsStatus(events, status) {
			var def = $q.defer();
			var eventIds = _.pluck(events, 'id');
			events = _.map(events, function (event) {
				event.status = status;
				return event;
			});
			pixerfApiEventSvc.update_many({}, {
				event_ids: eventIds,
				event: {
					status: status
				}
			}).$promise.then(function (res) {
				def.resolve(res);
			}).catch(function (err) {
				console.log(err);
				def.reject(err);
			})
			return def.promise;
		}
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('manageGoingEventsCtrl', manageGoingEventsCtrl);

	manageGoingEventsCtrl.$inject = ['$scope', 'eventConst', 'pixerfApiEventSvc', 'sessionManagerSvc', 'pagingUtils', 'manageEventsSvc'];

	function manageGoingEventsCtrl($scope, eventConst, pixerfApiEventSvc, sessionManagerSvc, pagingUtils, manageEventsSvc) {

		var self = this;
		self.loginedUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.eventConst = eventConst;
		self.parent = $scope.$parent.vm;
		self.isMyProfile = self.parent.isMyProfile;
		self.parent.subContextPage = "Going";
		self.user = self.parent.user;
		self.onSortByChanged = onSortByChanged;
		self.onSelectAllGoingEvent = onSelectAllGoingEvent;
		self.onSelectedGoingEvent = onSelectedGoingEvent;
		self.onCloseNotification = onCloseNotification;
		self.onGoingEventGridChanged = onGoingEventGridChanged;
		self.onSearchGoingEvents = _.debounce(onSearchGoingEvents, 800);
		self.onSearchUpcomingEvents = _.debounce(onSearchUpcomingEvents, 800);
		self.fetchMoreGoingEventsList = fetchMoreGoingEventsList;
		self.onGoingEventsListChanged = onGoingEventsListChanged;
		self.onPageSizeGoingEventsChanged = onPageSizeGoingEventsChanged;
		self.selectedGoingEvents = [];
		self.onSelectAllUpcomingEvent = onSelectAllUpcomingEvent;
		self.onSelectedUpcomingEvent = onSelectedUpcomingEvent;
		self.onUpcomingEventGridChanged = onUpcomingEventGridChanged;
		self.fetchMoreUpcomingEventsList = fetchMoreUpcomingEventsList;
		self.onUpcomingEventsListChanged = onUpcomingEventsListChanged;
		self.onPageSizeUpcomingEventsChanged = onPageSizeUpcomingEventsChanged;
		self.onNotGoingEvents = onNotGoingEvents;
		self.selectedUpcomingEvents = [];
		self.sortDateBy = 'asc';
		self.sortNameBy = 'asc';
		self.customPagingOptions = manageEventsSvc.getCustomPagingOptions();
		self.spinner = {
			isVisible: false
		};
		self.spinnerUpcoming = {
			isVisible: false
		};
		self.searchParams = {
			page: 1,
			type: 'ongoing',
			id: self.loginedUser.id,
			user_id: self.loginedUser.id,
			event_statuses: 'active,cancelled,rejected,deleted,reported',
			page_size: self.customPagingOptions.showValues[0]
		};
		self.searchUpcomingParams = {
			page: 1,
			type: 'upcoming',
			id: self.loginedUser.id,
			user_id: self.loginedUser.id,
			event_statuses: 'active,cancelled,rejected,deleted,reported',
			page_size: self.customPagingOptions.showValues[0]
		};
		self.sortBy = [{
			value: "inserted_at,desc",
			title: "Date created"
		},
		{
			value: "is_private,desc",
			title: "Privacy"
		},
		{
			value: "member_count,desc",
			title: "Members"
		}
		];

		init();

		function init() {
			self.defaultSortBy = self.sortBy[0].value;
			self.searchParams.sort = self.sortBy[0].value;
			self.goingEvents = [];
			self.upcomingEvents = [];
			getGoingEventsList(self.searchParams, true);
			getUpcomingEventsList(self.searchUpcomingParams, true);
		}

		function onSortByChanged(value, type, isUpcominng) {
			if (value === 'name') {
				self.sortNameBy = (type === 'asc') ? 'desc' : 'asc';
			}
			if (value === 'event_datetimes') {
				self.sortDateBy = (type === 'asc') ? 'desc' : 'asc';
			}

			if (isUpcominng) {
				self.searchUpcomingParams.sort = value + ',' + type;
				getUpcomingEventsList(self.searchUpcomingParams, true);
			} else {
				self.searchParams.sort = value + ',' + type;
				getGoingEventsList(self.searchParams, true);
			}
		}

		function getGoingEventsList(params, isRefresh) {
			if (self.spinner.isVisible) return;
			self.spinner.isVisible = true;
			pixerfApiEventSvc.get_joined_events(params).$promise.then(function (response) {
				if (isRefresh) {
					self.goingEvents = response.data;
				} else {
					self.goingEvents = self.goingEvents.concat(response.data);
				}
				self.isLastPage = pagingUtils.isNoMorePageToLoad(params.page, response);
				self.totalPage = pagingUtils.getTotalPage(response);
				self.totalGoingEvents = pagingUtils.getTotalCount(response);
				self.searchParams.page = params.page;
				self.spinner.isVisible = false;
			}).catch(function (error) {
				console.log(error);
				self.spinner.isVisible = false;
			})
		}

		function onGoingEventsListChanged(data) {
			self.searchParams.page = data.currentPage;
			getGoingEventsList(self.searchParams, true);
		}

		function onPageSizeGoingEventsChanged(pageSize) {
			self.searchParams.page = 1
			self.searchParams.page_size = pageSize;
			getGoingEventsList(self.searchParams, true);
		}

		function fetchMoreGoingEventsList() {
			if (self.isLastPage || self.spinner.isVisible) return;
			var searchParams = $.extend(true, {}, self.searchParams);
			searchParams.page++;
			getGoingEventsList(searchParams);
		}

		function onSelectAllGoingEvent(isSelectedAllGoingEvent) {
			self.isOpenNotification = true;
			self.goingEvents = _.map(self.goingEvents, function (item) {
				item.isSelected = isSelectedAllGoingEvent;
				return item;
			})

			if (self.isSelectedAllGoingEvent) {
				self.selectedGoingEvents = self.goingEvents;
			} else {
				self.selectedGoingEvents = [];
			}
		}

		function onSelectedGoingEvent(event) {
			self.isOpenNotification = true;
			if (!event.isSelected) {
				self.isSelectedAllGoingEvent = false;
				self.selectedGoingEvents = _.reject(self.selectedGoingEvents, function (item) {
					return event.id === item.id;
				})
			} else {
				self.selectedGoingEvents.push(event);
			}
		}

		function onCloseNotification() {
			self.isOpenNotification = false;
		}

		function removeEventsFromList(eventIds) {
			self.goingEvents = _.reject(self.goingEvents, function (item) {
				return eventIds.includes(item.id);
			})
		}

		function removeEventFromList(eventId) {
			self.goingEvents = _.reject(self.goingEvents, function (item) {
				return eventId == item.id;
			})
		}

		function onGoingEventGridChanged(event) {
			if (event && event.length) {
				removeEventsFromList(_.pluck(event, "id"));
			} else {
				removeEventFromList(event.id);
			}
		}

		function onSearchGoingEvents() {
			if (self.searchGoingEventsString) {
				self.searchParams.keywords = self.searchGoingEventsString;
			} else {
				delete self.searchParams.keywords;
			}
			getGoingEventsList(self.searchParams, true);
		}

		function onSearchUpcomingEvents() {
			if (self.searchUpcomingEventString) {
				self.searchUpcomingParams.keywords = self.searchUpcomingEventString;
			} else {
				delete self.searchUpcomingParams.keywords;
			}
			getUpcomingEventsList(self.searchUpcomingParams, true);
		}

		function getUpcomingEventsList(params, isRefresh) {
			if (self.spinnerUpcoming.isVisible) return;
			self.spinnerUpcoming.isVisible = true;
			pixerfApiEventSvc.get_joined_events(params).$promise.then(function (response) {
				if (isRefresh) {
					self.upcomingEvents = response.data;
				} else {
					self.upcomingEvents = self.upcomingEvents.concat(response.data);
				}
				self.isLastUpcomingPage = pagingUtils.isNoMorePageToLoad(params.page, response);
				self.totalUpcomingPage = pagingUtils.getTotalPage(response);
				self.totalUpcomingEvents = pagingUtils.getTotalCount(response);
				self.searchUpcomingParams.page = params.page;
				self.spinnerUpcoming.isVisible = false;
			}).catch(function (error) {
				console.log(error);
				self.spinnerUpcoming.isVisible = false;
			})
		}

		function onUpcomingEventsListChanged(data) {
			self.searchUpcomingParams.page = data.currentPage;
			getUpcomingEventsList(self.searchUpcomingParams, true);
		}

		function onPageSizeUpcomingEventsChanged(pageSize) {
			self.searchUpcomingParams.page = 1
			self.searchUpcomingParams.page_size = pageSize;
			getUpcomingEventsList(self.searchUpcomingParams, true);
		}

		function fetchMoreUpcomingEventsList() {
			if (self.isLastUpcomingPage || self.spinnerUpcoming.isVisible) return;
			var searchUpcomingParams = $.extend(true, {}, self.searchUpcomingParams);
			searchUpcomingParams.page++;
			getUpcomingEventsList(searchUpcomingParams);
		}

		function onSelectAllUpcomingEvent(isSelectedAllUpcomingEvent) {
			self.isOpenNotification = true;
			self.upcomingEvents = _.map(self.upcomingEvents, function (item) {
				item.isSelected = isSelectedAllUpcomingEvent;
				return item;
			})

			if (self.isSelectedAllUpcomingEvent) {
				self.selectedUpcomingEvents = self.upcomingEvents;
			} else {
				self.selectedUpcomingEvents = [];
			}
		}

		function onSelectedUpcomingEvent(event) {
			self.isOpenNotification = true;
			if (!event.isSelected) {
				self.isSelectedAllUpcomingEvent = false;
				self.selectedUpcomingEvents = _.reject(self.selectedUpcomingEvents, function (item) {
					return event.id === item.id;
				})
			} else {
				self.selectedUpcomingEvents.push(event);
			}
		}

		function removeUpcomingEventsFromList(eventIds) {
			self.upcomingEvents = _.reject(self.upcomingEvents, function (item) {
				return eventIds.includes(item.id);
			})
		}

		function removeUpcomingEventFromList(eventId) {
			self.upcomingEvents = _.reject(self.upcomingEvents, function (item) {
				return eventId == item.id;
			})
		}

		function onUpcomingEventGridChanged(event) {
			if (event && event.length) {
				removeUpcomingEventsFromList(_.pluck(event, "id"));
			} else {
				removeUpcomingEventFromList(event.id);
			}
		}

		function onNotGoingEvents(selectedEvents, type) {
			switch (type) {
				case 'going':
					onGoingEventGridChanged(selectedEvents);
					break;
				case 'upcoming':
					onUpcomingEventGridChanged(selectedEvents);
					break;
			}
		}
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('manageDraftEventsCtrl', manageDraftEventsCtrl);

	manageDraftEventsCtrl.$inject = ['$scope', 'eventConst', 'pixerfApiEventSvc', 'sessionManagerSvc', 'pagingUtils', 'manageEventsSvc', '$translate', 'confirmPopupSvc', '$q', 'toastr'];

	function manageDraftEventsCtrl($scope, eventConst, pixerfApiEventSvc, sessionManagerSvc, pagingUtils, manageEventsSvc, $translate, confirmPopupSvc, $q, toastr) {

		var self = this;
		self.loginedUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.eventConst = eventConst;
		self.parent = $scope.$parent.vm;
		self.isMyProfile = self.parent.isMyProfile;
		self.parent.subContextPage = "Drafts";
		self.user = self.parent.user;
		self.onSortByChanged = onSortByChanged;
		self.onSelectAllEvents = onSelectAllEvents;
		self.onSelectedEvent = onSelectedEvent;
		self.onCloseNotification = onCloseNotification;
		self.eventGridChanged = eventGridChanged;
		self.onSearchEvent = _.debounce(onSearchEvent, 800);
		self.fetchMoreEventsList = fetchMoreEventsList;
		self.eventsListChanged = eventsListChanged;
		self.onPageSizeEventsChanged = onPageSizeEventsChanged;
		self.onCreateEvents = onCreateEvents;
		self.onDeleteEvents = onDeleteEvents;
		self.selectedEvents = [];
		self.sortDateBy = 'asc';
		self.sortNameBy = 'asc';
		self.customPagingOptions = manageEventsSvc.getCustomPagingOptions();
		self.spinner = {
			isVisible: false
		};
		self.searchParams = {
			id: self.loginedUser.id,
			user_id: self.loginedUser.id,
			page: 1,
			page_size: self.customPagingOptions.showValues[0]
		};
		self.sortBy = [{
				value: "inserted_at,desc",
				title: "Date created"
			},
			{
				value: "is_private,desc",
				title: "Privacy"
			},
			{
				value: "member_count,desc",
				title: "Members"
			}
		];

		init();

		function init() {
			self.defaultSortBy = self.sortBy[0].value;
			self.searchParams.sort = self.sortBy[0].value;
			self.events = [];
			getEventsList(self.searchParams, true);
		}

		function onSortByChanged(value, type) {
			if (value === 'name') {
				self.sortNameBy = (type === 'asc') ? 'desc' : 'asc';
			}
			if (value === 'event_datetimes') {
				self.sortDateBy = (type === 'asc') ? 'desc' : 'asc';
			}

			self.searchParams.sort = value + ',' + type;
			getEventsList(self.searchParams, true);
		}

		function getEventsList(params, isRefresh) {
			if (self.spinner.isVisible) return;
			self.spinner.isVisible = true;
			pixerfApiEventSvc.get_drafts_events(params).$promise.then(function (response) {
				if (isRefresh) {
					self.events = response.data;
				} else {
					self.events = self.events.concat(response.data);
				}
				self.isLastPage = pagingUtils.isNoMorePageToLoad(params.page, response);
				self.totalPage = pagingUtils.getTotalPage(response);
				self.totalEvents = pagingUtils.getTotalCount(response);
				self.searchParams.page = params.page;
				self.spinner.isVisible = false;
			}).catch(function (error) {
				console.log(error);
				self.spinner.isVisible = false;
			})
		}

		function eventsListChanged(data) {
			self.searchParams.page = data.currentPage;
			getEventsList(self.searchParams, true);
		}

		function onPageSizeEventsChanged(pageSize) {
			self.searchParams.page = 1
			self.searchParams.page_size = pageSize;
			getEventsList(self.searchParams, true);
		}

		function fetchMoreEventsList() {
			if (self.isLastPage || self.spinner.isVisible) return;
			var searchParams = $.extend(true, {}, self.searchParams);
			searchParams.page++;
			getEventsList(searchParams);
		}

		function onSelectAllEvents(isSelectedAllEvents) {
			self.isOpenNotification = true;
			self.events = _.map(self.events, function (item) {
				item.isSelected = isSelectedAllEvents;
				return item;
			})

			if (self.isSelectedAllEvents) {
				self.selectedEvents = self.events;
			} else {
				self.selectedEvents = [];
			}
		}

		function onSelectedEvent(event) {
			self.isOpenNotification = true;
			if (!event.isSelected) {
				self.isSelectedAllEvents = false;
				self.selectedEvents = _.reject(self.selectedEvents, function (item) {
					return event.id === item.id;
				})
			} else {
				self.selectedEvents.push(event);
			}
		}

		function onCloseNotification() {
			self.isOpenNotification = false;
		}

		function removeEventsFromList(eventIds) {
			self.events = _.reject(self.events, function (item) {
				return eventIds.includes(item.id);
			})
		}

		function removeEventFromList(eventId) {
			self.events = _.reject(self.events, function (item) {
				return eventId == item.id;
			})
		}

		function eventGridChanged(event) {
			if (event && event.length) {
				removeEventsFromList(_.pluck(event, "id"));
			} else {
				removeEventFromList(event.id);
			}
		}

		function onSearchEvent() {
			if (self.searchEventString) {
				self.searchParams.keywords = self.searchEventString;
			} else {
				delete self.searchParams.keywords;
			}
			getEventsList(self.searchParams, true);
		}

		function onCreateEvents(events) {
			confirmPopupSvc.showPopup({
				windowClass: 'delete-event-confirm-popup',
				title: $translate.instant("you-are-about-to-delete-this-event"),
				message: $translate.instant("deleting-your-Event-will-remove-it"),
				submitBtnText: 'Yes',
				cancelBtnText: 'Cancel',
				submit: function () {
					var def = $q.defer();
					updateEventsStatus(events, 'active').then(
						function (res) {
							toastr.success("You have created successfully");
							eventGridChanged(events);
							def.resolve(res);
						},
						function (err) {
							def.reject(err);
						}
					);
					return def.promise;
				}
			});
		}

		function onDeleteEvents(events) {
			confirmPopupSvc.showPopup({
				windowClass: 'delete-event-confirm-popup',
				title: $translate.instant("you-are-about-to-delete-these-events"),
				message: $translate.instant("deleting-your-events-will-remove-it"),
				submitBtnText: 'Yes',
				cancelBtnText: 'Cancel',
				submit: function () {
					var def = $q.defer();
					updateEventsStatus(events, 'deleted').then(
						function (res) {
							toastr.success("You have deleted successfully");
							eventGridChanged(events);
							def.resolve(res);
						},
						function (err) {
							def.reject(err);
						}
					);
					return def.promise;
				}
			});
		}

		function updateEventsStatus(events, status) {
			var def = $q.defer();
			var eventIds = _.pluck(events, 'id');
			events = _.map(events, function(event){
				event.status = status;
				return event;
			});
			pixerfApiEventSvc.update_many({}, {
				event_ids: eventIds,
				event: {
					status: status
				}
			}).$promise.then(function (res) {
				def.resolve(res);
			}).catch(function (err) {
				console.log(err);
				def.reject(err);
			})
			return def.promise;
		}
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('manageEventPendingPostsCtrl', manageEventPendingPostsCtrl);

        manageEventPendingPostsCtrl.$inject = ['$scope', 'sessionManagerSvc', 'eventData', 'pixerfApiCommunitySvc', 'pagingUtils', 'removeMemberPopupSvc', 'blockMemberPopupSvc', 'confirmSuccessPopupSvc', '$state', 'pixerfApiCommunityDiscussionSvc', '$q', 'confirmPopupSvc'];

	function manageEventPendingPostsCtrl($scope, sessionManagerSvc, eventData, pixerfApiCommunitySvc, pagingUtils, removeMemberPopupSvc, blockMemberPopupSvc, confirmSuccessPopupSvc, $state, pixerfApiCommunityDiscussionSvc, $q, confirmPopupSvc ) {

		var self = this;
		self.isWorking = false;
		self.parent = $scope.$parent.vm;
		self.spinner = {
			isVisible: false
		}
		self.isLastPage = false;
		self.posts = [];
        self.event = eventData;
		self.loginUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.isOwner = self.loginUser && self.loginUser.id === self.event.owner.id;
        self.arrangeOptions = {
			props: "arrangeBy",
			selections: [{
					label: "recent",
					value: "inserted_at"
				},
				{
					label: "bookmarked",
					value: "is_bookmarked"
				}
			]
		};
		self.submitButtonText = "Join Community";
		self.arrangeBy= {arrangeBy: 'inserted_at'};
		self.defaultArrangeBy = {arrangeBy: self.arrangeOptions.selections[0].value};
        self.searchParams = {
			id: self.event.id,
			page: 1,
			status: 'pending',
			sort: self.defaultArrangeBy.arrangeBy
		};
		self.onRemoveFromCommunity = onRemoveFromCommunity;
		self.onBlockFromCommunity = onBlockFromCommunity;
		self.onApprovePost = onApprovePost;
		self.onRejectPost = onRejectPost;
		self.fetchMoreDisPosts = fetchMoreDisPosts;
		self.community = self.parent.community;
		$scope.$watch('self.community', function (newValue, oldValue) {
			if(newValue){
				self.community = newValue;
			}
		});

		function init() {
			if (!self.community.is_private || (self.loginUser && self.community.is_private && (self.community.membership_status === 'accepted' || self.community.membership_status === 'owner'))) {
				getPosts(self.searchParams, true);
			}
			if (self.community.is_private && self.community.membership_status === 'requested') {
				self.submitButtonText = "Requested";
			}
		}

		function getPosts(params, isFresh) {
			self.searchParams = params;
			self.spinner.isVisible = true;
			self.isWorking = true;
			pixerfApiCommunitySvc.get_post_by_event_id(self.searchParams).$promise.then(function (res) {
				if (!self.posts || isFresh) self.posts = [];
				self.posts = self.posts.concat(res.data);
				self.isLastPage = pagingUtils.isNoMorePageToLoad(self.searchParams.page, res);
				self.spinner.isVisible = false;
				self.searchParams.page = params.page;
				self.isWorking = false;
			}).catch(function (err) {
				self.isWorking = false;
				self.spinner.isVisible = false;
				console.log(err);
			})
		}

		function fetchMoreDisPosts() {
			if (self.isLastPage || self.spinner.isVisible) return;
			var searchParms = $.extend(true, {}, self.searchParams);
			searchParms.page++;
			getPosts(searchParms);
		}

		function onRemoveUser(member){
			self.posts = _.reject(self.posts, function (item) {
				return item.user.id === member.id;
			})
		}

		function showConfirmSuccessPopupMessage(message) {
			confirmSuccessPopupSvc.showPopup({
				windowClass: 'manager-member-list-view__confirm-success-popup',
				message: message
			});
		}

		function onRemoveFromCommunity(member) {
			var removePopup = removeMemberPopupSvc.showPopup({
				community: self.community,
				user: member
			})
			removePopup.result.then(function (data) {
				onRemoveUser(member);
				showConfirmSuccessPopupMessage((member.displayName || member.email) + ' has been removed from your Community.');
			})
		}

		function onApprovePost(post) {
			pixerfApiCommunitySvc.update_event_post_status({
				id: post.id,
				action: 'approve'
			}, {}).$promise.then(function (respone) {
				self.posts = _.reject(self.posts, function (item) {
					return item.id === post.id;
				})
			}).catch(function (err) {
				console.log(err);
			});
		}

		function onRejectPost(post) {
			confirmPopupSvc.showPopup({
				windowClass: 'reject-discussion-popup',
				title: "You're about to reject this post.",
				message: 'Rejected post will be permanently deleted and the member will not be notified. Are you sure?',
				submitBtnText: 'Confirm',
				cancelBtnText: 'Cancel',
				submit: function () {
					var def = $q.defer();
					pixerfApiCommunitySvc.update_event_post_status({
						id: post.id,
						action: 'reject'
					}, {}).$promise.then(function (respone) {
						self.posts = _.reject(self.posts, function (item) {
							return item.id === post.id;
						})
						def.resolve(respone);
					}).catch(function (err) {
						def.reject(err);
					})
					return def.promise;
				}
			});
		}

		function onBlockFromCommunity(member) {

			var blockPopup = blockMemberPopupSvc.showPopup({
				community: self.community,
				user: member
			})
			blockPopup.result.then(function (data) {
				if(data && data.user){
					onRemoveUser(member);
					showConfirmSuccessPopupMessage('<strong>' + (member.displayName || member.email) + '</strong> has been blocked from your Community.');
				}
			}).catch(function (err) {
				console.log(err);
			})
		}

		init();
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('manageEventReportsCtrl', manageEventReportsCtrl);

        manageEventReportsCtrl.$inject = ['$scope', 'sessionManagerSvc', 'eventData', 'pixerfApiCommunitySvc', 'pagingUtils', 'confirmSuccessPopupSvc', 
			'communityResolveReportPopupSvc', '$state', 'communityRemoveReportPopupSvc', 'removeMemberPopupSvc', '$timeout', 'systemUtils', 'blockMemberPopupSvc', '$translate'];

	function manageEventReportsCtrl($scope, sessionManagerSvc, eventData, pixerfApiCommunitySvc, pagingUtils, confirmSuccessPopupSvc, 
			communityResolveReportPopupSvc, $state, communityRemoveReportPopupSvc, removeMemberPopupSvc, $timeout, systemUtils, blockMemberPopupSvc, $translate) {

		var self = this;
		self.isWorking = false;
		self.parent = $scope.$parent.vm;
		self.spinner = {
			isVisible: false
		}
		self.isLastPage = false;
		self.discussions = [];
		self.event = eventData;
		self.loginUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.isOwner = self.loginUser && self.loginUser.id === self.event.owner.id;
		self.status = $state.params && $state.params.status ? $state.params.status : '';
		self.onKeepPost = onKeepPost;
		self.onRemovePost = onRemovePost;
		self.onRemoveFromCommunity = onRemoveFromCommunity;
		self.onBlockFromCommunity = onBlockFromCommunity;
		self.onReportClicked = onReportClicked;
		self.onReportDetailsViewClosed = onReportDetailsViewClosed;
		self.isReportDetailsViewOpen = false;
		self.searchParams = {
			type: 'pending',
			page: 1,
			page_size: 15
		};
		self.parent.subContextPage = self.status;
		self.community = self.parent.community;
		$scope.$watch('self.parent.community', function (newValue, oldValue) {
			if(newValue){
				self.community = newValue;
			}
		});

		function init() {
			self.searchParams.type = 'pending';
			self.searchParams.community_ids = [self.community.id]
			getPendingReportsList(self.searchParams, true);

		}

		function getPendingReportsList(params, isRefresh) {
			if (self.spinner.isVisible) return;
			self.spinner.isVisible = true;
			if (isRefresh) {
				self.totalPendingReports = 0;
				self.totalPendingPage = 0;
			}
			pixerfApiCommunitySvc.get_pending_reports(params).$promise.then(function (respone) {
				if (isRefresh) {
					self.reports = respone.data;
				} else {
					self.reports = self.reports.concat(respone.data);
				}
				self.isLastPage = pagingUtils.isNoMorePageToLoad(params.page, respone);
				self.totalPendingPage = pagingUtils.getTotalPage(respone);
				self.totalPendingReports = pagingUtils.getTotalCount(respone);
				self.searchParams.page = params.page;
				self.spinner.isVisible = false;
			}).catch(function (error) {
				console.log(error);
				self.spinner.isVisible = false;
			})
		} 

		function removeReport(report){
			self.reports = _.reject(self.reports, function (item) {
				return item.id === report.id;
			})
		}

		function onKeepPost(report) {
			var url = $state.href('manage-community.reports', {
				id: self.community.id,
				name: self.community.name,
				manage: true,
				status: 'past-reported-posts'
			});
			var popupDescription = 'resolve-event-report-description';
			var successDescription = $translate.instant('remove-event-report-description', {communityPastReportLink: url});
			var popupTitle = 'keep-post';
			var resolveReport = communityResolveReportPopupSvc.showPopup({
				data: report,
				target: report.item_type,
				popupDescription: popupDescription,
				successDescription: successDescription,
				popupTitle: popupTitle 
			})

			resolveReport.result.then(function (data) {
				if(data){
					removeReport(report);
				}
			})
		}

		function onRemovePost(report) {
			
			var url = $state.href('manage-community.reports', {
				id: self.community.id,
				name: self.community.name,
				manage: true,
				status: 'past-reported-posts'
			});
			var successDescription = $translate.instant('remove-event-report-description', {communityPastReportLink: url});
			var removeReport = communityRemoveReportPopupSvc.showPopup({
				data: report,
				target: report.item_type,
				successDescription: successDescription
			})

			removeReport.result.then(function (data) {
				if(data){
					removeReport(report);
				}
			})
		}

		function showConfirmSuccessPopupMessage(message) {
			confirmSuccessPopupSvc.showPopup({
				windowClass: 'manager-member-list-view__confirm-success-popup',
				message: message
			});
		}

		function onRemoveFromCommunity(member) {
			var removePopup = removeMemberPopupSvc.showPopup({
				community: self.community,
				user: member
			})
			removePopup.result.then(function (data) {
				getPendingReportsList(self.searchParams, true);
				showConfirmSuccessPopupMessage((member.displayName || member.email) + ' has been removed from your Community.');
			})
		}

		function onBlockFromCommunity(member) {
			var blockPopup = blockMemberPopupSvc.showPopup({
				community: self.community,
				user: member
			})
			blockPopup.result.then(function (data) {
				if(data && data.user){
					getPendingReportsList(self.searchParams, true);
					showConfirmSuccessPopupMessage('<strong>' + (member.displayName || member.email) + '</strong> has been blocked from your Community.');
				}
			}).catch(function (err) {
				console.log(err);
			})
		}

		function onReportClicked(report){
			self.reports = _.map(self.reports, function (report) {
				report.selected = false;
				return report;
			})
			self.selectedReport = null;
			$timeout(function () {
				self.selectedReport = report;
				report.selected = true;
				if (window.innerWidth < 480) {
					var element = angular.element('<manage-report-detail-compile-template id="manageReportDetailCompileTemplate" append-to-body="true" report="vm.selectedReport" on-closed="vm.onReportDetailsViewClosed()" context="pending" on-status-changed="vm.onReportGridChanged(data)"> </manage-report-detail-compile-template>');
					$("body").append(element);
					$("body").addClass("modal-open");
					$compile(element)($scope);
				} else {
					self.isReportDetailsViewOpen = true;
				}
			})
			systemUtils.digest($scope);
		}

		function onReportDetailsViewClosed() {
			if (window.innerWidth < 480) {
				$("#manageReportDetailCompileTemplate").remove();
				$("body").removeClass("modal-open");
			} else {
				self.isReportDetailsViewOpen = false;
			}
			self.reports = _.map(self.reports, function (report) {
				report.selected = false;
				return report;
			})
		}

		init();
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('manageEventMembersCtrl', manageEventMembersCtrl);

		manageEventMembersCtrl.$inject = ['$scope', 'pagingUtils', 'ISO3166', 'eventData', '$q', 'pixerfApiEventSvc', 'sessionManagerSvc', 'toastr', 
			'translationSvc', '$stateParams', 'pixerfApiCommunitySvc', 'accountUtils'];

	function manageEventMembersCtrl($scope, pagingUtils, ISO3166, eventData, $q, pixerfApiEventSvc, sessionManagerSvc, toastr, 
			translationSvc, $stateParams, pixerfApiCommunitySvc, accountUtils) {

		var USER_CONTROL_ADMINDASHBOARD = ['curator_internal', 'admin_internal', 'marketer_internal'];
		var self = this;
		self.loginedUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.isAdmin = self.loginedUser && (USER_CONTROL_ADMINDASHBOARD.includes(self.loginedUser.role) || self.loginedUser.email === 'marcom@pixerf.com');
		self.parent = $scope.$parent.vm;
		self.spinner = {
			isVisible: false
		};
		self.event = eventData;
		self.members = [];
		self.stateName = $stateParams.status || 'attendees';
		self.onSearchMembers =  _.debounce(onSearchMembersByKeyword, 300);;
		self.searchMemberString = '';
		self.onRemovedUser = onRemovedUser;
		self.onStatusChanged = onStatusChanged;
		self.showAdmin = false;
		self.showStatus = false;
		self.customPagingOptions = {
			label: "Rows per page:",
			showValues: [30, 50, 100]
		}

		self.stateToMemberShip = {
			attendees: 'attendees',
			interested: 'interested',
			invited: 'invited'
		};
		self.parent.subContextPage = $stateParams.status;
		self.managerList = self.parent.managerList;
		self.community = self.parent.community;

		$scope.$watch('self.managerList', function (newValue, oldValue) {
			if(newValue){
				self.managerList = newValue;
				setUserRole();
			}
		});
		$scope.$watch('self.community', function (newValue, oldValue) {
			if(newValue){
				self.community = newValue;
			}
		});
		self.onPageSizeChanged = onPageSizeChanged;
		self.onListChanged = onListChanged;
		

		self.searchParams = {
			id: self.event.community_id,
			membership: 'accepted',
			page: 1,
			page_size: self.customPagingOptions.showValues[0]
		};
		self.sortByProps = sortByProps;

		function init() {
			self.memberShipName = getMemberShipFromStateName(self.stateName);
			if(!self.memberShipName) {
				toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
				return;
			}
			setUserLayout(self.stateName);
			getMemberOfCommunity(self.stateName);
		}

		function setUserRole(){
			for(var i = 0; i < self.members.length; i++){
				var containList = _.filter(self.managerList, function(item){ return item.id == self.members[i].id; });
				self.members[i].isCommunityManager = (containList && containList.length) ? true : false;
			}
		}

		function buildMembersProperty(members){
			for(var i = 0; i< members.length; i++){{
				var countryCode = (members[i].organization && members[i].organization.address) ? (members[i].organization.address.country ) : (members[i].address ? members[i].address.country : members[i].country);
				members[i].country = ISO3166.getCountryName(countryCode);
				members[i].inviteStatus = transformedUserStatus(members[i].status);
			}}
		}

		function transformedUserStatus(status){
			var result = 'Accepted';
			switch (status) {
				case 'not_responded':
					result = 'Not responded'
					break;
				case 'declined':
					result = 'Declined'
					break;
				case 'accepted':
					result = 'Accepted'
					break;
			}
			return result;
		}

		function sortByProps(propertyName, isActtionRequiredTable) {
			if (isActtionRequiredTable) {
				$scope.reverseActionRequired = ($scope.propertyActionRequiredName === propertyName) ? !$scope.reverseActionRequired : false;
				$scope.propertyActionRequiredName = propertyName;
			} else {
				$scope.reverse = ($scope.propertyName === propertyName) ? !$scope.reverse : false;
				$scope.propertyName = propertyName;
			}
		};

		function onPageSizeChanged(pageSize) {
			self.searchParams.page = 1;
			self.searchParams.page_size = pageSize;
		}

		function onListChanged(data) {
			self.searchParams.page = data.currentPage;
		}

		function getMemberOfCommunity(memberShipName) {

			switch (self.stateName) {
				case 'attendees':
					getEventAttendees('joined', self.searchParams);
					getMembersOfCommunity();
					break;
				case 'interested':
					getEventAttendees('interested', self.searchParams);
					getMembersOfCommunity();
					break;
				case 'invited':
					getEventInvited(self.searchParams);
					break;
			}
		}

		function getEventAttendees(status, params) {
			var defer = $q.defer();
			var eventId = self.event.id;
			if(!eventId){
				return defer.reject();
			}
			self.spinner.isVisible = true;
			pixerfApiEventSvc.getEventAttendees({
				id: eventId,
				status: status
			}).$promise.then(function (response) {
				self.members = filterEventAttendees(response.data);
				self.members = _.reject(self.members, function (item) {
						return item.id == self.event.owner.id;
				})
				buildMembersProperty(self.members);
				setUserRole();
				self.stateName =='attendees' ? (self.event.stats.going = self.members.length) : '';
				self.isLastPage = pagingUtils.isNoMorePageToLoad(params.page, response);
				self.totalPage = pagingUtils.getTotalPage(response);
				self.totalMembers = pagingUtils.getTotalCount(response);
				self.searchParams.page = params.page;
				self.spinner.isVisible = false;
				defer.resolve(response.data);
			}, function (err) {
				console.log(err);
				defer.reject(err);
				self.spinner.isVisible = false;
			})
			return defer.promise;
		}

		function filterEventAttendees(users){
			var result = [];
			for(var i =0; i < users.length; i++){
				users[i].user.displayName = accountUtils.buildUserDisplayName(users[i].user);
				users[i].user.avatar = accountUtils.buildUserAvatarPhotoUrl(users[i].user);
				result.push(users[i].user);
			}
			return result;
		} 

		function getMembersOfCommunity() {
			var params = {
				id: self.event.community_id,
				membership: 'accepted'
			};
			pixerfApiCommunitySvc.get_members(params).$promise.then(function (res) {
				self.CommunityMembers = res.data;
				for(var i = 0; i < self.members.length; i++){
					var containList = _.filter(self.CommunityMembers, function(item){ return item.id == self.members[i].id; });
					self.members[i].isCommunityMember = ((containList && containList.length) || (self.members[i].id == self.event.owner.id)) ? true : false;
				}

			}).catch(function (err) {
				console.log(err)
			})
		}

		function getEventInvited(params) {
			var defer = $q.defer();
			self.spinner.isVisible = true;
			var eventId = self.event.id;
			if(!eventId){
				return defer.reject();
			}
			pixerfApiEventSvc.getEventInvited({
				id: eventId
			}).$promise.then(function (response) {
				self.members = transformedUserList(response.data);
				buildMembersProperty(self.members)
				setUserRole();
				getMembersOfCommunity();
				self.isLastPage = pagingUtils.isNoMorePageToLoad(params.page, response);
				self.totalPage = pagingUtils.getTotalPage(response);
				self.totalMembers = pagingUtils.getTotalCount(response);
				self.searchParams.page = params.page;
				self.spinner.isVisible = false;
				defer.resolve(self.members);
			}, function (err) {
				console.log(err);
				defer.reject(err);
				self.spinner.isVisible = false;
			})
			return defer.promise;
		}

		function transformedUser(data){
			var user = (data.user ? data.user : data);
			user.displayName = user.first_name ? (user.first_name + ' ' + user.last_name) : user.email;
			return user;
		}

		function transformedUserList(data){
			var people = [];
			for (var i = 0; i < data.length; i++) {
				people.push(transformedUser(data[i]));
			}
			return people;
		}

		function getMemberShipFromStateName(stateName){
			return self.stateToMemberShip[stateName];
		}

		function onSearchMembersByKeyword(){
			getMemberOfCommunity(self.memberShipName);
		}

		function onRemovedUser(member){
			self.members = _.reject(self.members, function (item) {
				return item.id === member.id;
			})
		}

		function onStatusChanged(member){
			self.members = _.reject(self.members, function (item) {
				return item.id === member.id;
			})
		}
		function setUserLayout(type) {
			switch (type) {
				case 'attendees':
					self.showAdmin = true;
					self.showInvitationFrom = false;
					self.showStatus = false
					
					break;
				case 'interested':
					self.showAdmin = false;
					self.showStatus = false
					
					break;
				case 'invited':
					self.showAdmin = false;
					self.showStatus = true
					
					break;
			}
		}

		init();
		
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('editEventCtrl', editEventCtrl);

	editEventCtrl.$inject = ['$scope', '$state', 'sessionManagerSvc', 'eventData', 'pixerfUrl', 'uploadCoverPopupSvc', 'systemUtils', 'pixerfApiEventSvc', 
		'toastr', 'accountUtils', 'confirmPopupSvc', '$translate', '$q', 'translationSvc', 'pixerfApiCommunitySvc'];

	function editEventCtrl($scope, $state, sessionManagerSvc, eventData, pixerfUrl, uploadCoverPopupSvc, systemUtils, pixerfApiEventSvc, 
		toastr, accountUtils, confirmPopupSvc, $translate, $q, translationSvc, pixerfApiCommunitySvc) {
		var self = this;
		self.loginUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.communityDetailControler = $scope.$parent.vm;
		self.isOwner = self.loginUser && (self.loginUser.id === eventData.owner.id);
		self.isTypeClass = eventData && eventData.event_type == 'class';
		self.itemType = 'event';
		self.itemTypeUpercase = 'Event';
		self.parent = $scope.$parent.vm;
		self.community = self.parent.community;
		self.calendar = {};
		self.eventCover = {};
		self.isPhotoUploading = false;
		self.event = Object.assign({}, eventData);
		self.eventCover.url = (self.event.cover && self.event.cover.original) ? self.event.cover.original : null;
		self.dateTimes = reTransformDateTime(self.event.event_datetimes);
		if (self.event.admission_type == 'ticketed_pixerf') {
			self.event.paid_event = (self.event.ticket_price && !((self.event.ticket_price == 0) || (!self.event.ticket_price)) ? true : false);
		}
		self.itemType = self.event.event_type == 'class' ? 'class' : 'event';
		self.itemTypeUpercase = self.isTypeClass ? 'Class' : 'Event';
		self.onCreateEvent = onCreateEvent;
		self.onCancelCreateEvent = onCancelCreateEvent;
		self.onSaveAsDraftEvent = onSaveAsDraftEvent;
        self.cancelBtnClicked = cancelBtnClicked;
		self.deleteBtnClicked = deleteBtnClicked;
		self.timerOptions = {
			hideSecondLabel: true,
			noSecond: true,
			showPm: true
		};

		self.admissionTypes = [{
				value: 'free',
				title: "Free Event/Class",
				description: "Event goers do not require a ticket to join the event."
			},
			{
				value: 'ticketed_pixerf',
				title: "Ticketed Event/Class by PIXERF",
				description: "Event/Class goers require a ticket to join the event/Class. Tickets sold through PIXERF."
			},
			{
				value: 'ticketed_external',
				title: "Ticketed Event/Class via External Link",
				description: "Event/Class goers require a ticket to join the event. Tickets sold through an external link."
			}
		]
		self.capacityTypes = [{
				value: 'unlimited',
				title: "Unlimited Capacity",
				description: "Event/Class has no maximum number of guests."
			},
			{
				value: 'limited',
				title: "Limited Capacity",
				description: "Event/Class is limited to a fixed number of guests."
			}
		]
		self.privacyTypes = [{
				value: false,
				title: "Public Event/Class",
				description: "Anyone can join the event/class"
			},
			{
				value: true,
				title: "Private Event/Class",
				description: "Only members of the Community can join the event/class"
			}
		]
		self.eventTypes = [{
				value: 'standard',
				title: "Events",
				description: "Meetings, networking events and talks"
			},
			{
				value: 'class',
				title: "Classes",
				description: "Courses, Trainings or workshops"
			}
		];


		self.postingTypes = [{
				value: 'anyone',
				title: "Anyone in the Community",
				description: "Any member in the Community can start a discussion and reply to the threads."
			},
			{
				value: 'only_admin',
				title: "Only Admin",
				description: "Only admins can create a new discussion topic."
			}
		];

		self.moderationType = [{
				value: true,
				title: "Approval required",
				description: "Admin must approve all posts before they are published."
			},
			{
				value: false,
				title: "No approval required",
				description: "Admin does not need to approve posts before they are published."
			}
		];

		self.onAddDateTime = onAddDateTime;
		self.onRemoveDateTime = onRemoveDateTime;
		self.showUploadAvatarPopup = showUploadAvatarPopup;
		self.onAdmissionTypeChanged = onAdmissionTypeChanged;
		self.onCapacityTypeChanged = onCapacityTypeChanged;
		self.onEventTypeChanged = onEventTypeChanged;
		self.onPrivacyTypeChanged = onPrivacyTypeChanged;
		self.canSaveEvent = canSaveEvent;
		self.onCheckboxPaidEventChanged = onCheckboxPaidEventChanged;
		self.onModerationTypeChanged = onModerationTypeChanged;
		self.onPostingTypeChanged = onPostingTypeChanged;
		self.cancelEvent = cancelEvent;
		self.isFormEdited = false;

		self.defaultPrivacyType = self.event.is_private;
		self.defaultEventType = self.event.event_type || self.eventTypes[1].value;;
		self.defaultCapacityType = self.event.capacity_type || self.capacityTypes[0].value;
		self.defaultAdmission = self.event.admission_type || self.admissionTypes[0].value;
		self.defaultPostingType = self.event.start_discussion_permission || self.postingTypes[1].value;
		self.isLimitedCapacity = self.event.capacity_type === 'limited';
		self.canConfigmoderation = (self.event.start_discussion_permission === 'anyone' ? true : false);
		self.defaultModerationType = self.event.moderate_event_posts || self.moderationType[0].value;

		self.uploadEventCoverOptions = {
			dropzoneConfig: {
				'options': {
					url: pixerfUrl.full + 'api/community_events/',
					method: 'put',
					paramName: 'cover',
					autoProcessQueue: false,
				},
				eventHandlers: {
					"success": function (file, respone) {
						self.event = respone;
					}
				}
			},
			isManual: true,
			introText: "Choose a photo as your " + self.itemType + " cover",
			canEdit: true,
			editText: "Change " + self.itemType + " cover",
			cropper: {
				options: {
					viewport: {
						type: 'square'
					},
					boundary: {
						width: 500,
						height: 160
					},
					showZoomer: false
				}
			}
		};

		$scope.$watch('self.community', function (newValue, oldValue) {
			if (newValue) {
				self.community = newValue;
			}
		});

		function init() {
			if (!self.isOwner) {
				$state.go("manage-community.members", {
					status: 'members'
				});
			}
			self.disableOnlineEvent = false;
			if (self.event.event_type && self.event.event_type === 'standard') {
				self.disableOnlineEvent = true;
				self.event.is_online = false;
			}
		}

		function onAddDateTime() {
			self.dateTimes.push({
				date: null,
				start_time: null,
				end_time: null
			});
		}

		function onRemoveDateTime(index) {
			self.dateTimes.splice(index, 1);
		}

		function showUploadAvatarPopup() {
			if (self.uploadEventCoverOptions && self.uploadEventCoverOptions.canEdit) {
				var popup = uploadCoverPopupSvc.showPopup(self.uploadEventCoverOptions);

				popup.result.then(function (instance) {
					self.eventCover.url = instance.thumbnail;
					systemUtils.digest($scope);
					setFormEdited();
					self.isFormEdited = true;

					self.dropzoneInstance = instance.dropzone;
				})
			}
		}

		function setFormEdited() {
			self.isFormEdited = true;
		}

		function onModerationTypeChanged(item) {
			self.event.moderate_event_posts = item.value;
			setFormEdited();
		}

		function onPostingTypeChanged(item) {
			self.event.start_discussion_permission = item.value;
			if (self.event.start_discussion_permission === 'anyone') {
				self.canConfigmoderation = true;
			} else {
				self.canConfigmoderation = false;
			}
			setFormEdited();
		}

		function onAdmissionTypeChanged(item) {
			self.event.admission_type = item.value;
			setFormEdited();
		}

		function onCheckboxPaidEventChanged(value) {
			if (!value) {
				self.event.ticket_price = 0;
			}
			setFormEdited();
		}

		function onCapacityTypeChanged(item) {
			self.isLimitedCapacity = item.value === 'limited';
			self.event.capacity_type = item.value;
			setFormEdited();
		}

		function onEventTypeChanged(item) {
			self.event.event_type = item.value;
			if (self.event.event_type && self.event.event_type === 'standard') {
				self.disableOnlineEvent = true;
				self.event.is_online = false;
			} else {
				self.disableOnlineEvent = false;
			}
			setFormEdited();
		}

		function onPrivacyTypeChanged(item) {
			self.event.is_private = item.value;
			setFormEdited();
		}

		function canSaveEvent(eventForm) {
			return ((eventForm.$dirty || self.isFormEdited) && !eventForm.$invalid);
		}

		function onCreateEvent() {
			if (!validate()) return;
			if (self.event.id) {
				return updateEvent();
			}
			self.event = transformEventObject(self.event);
			self.event.status = 'active';
			pixerfApiEventSvc.create({
				community_id: self.community.id
			}, self.event).$promise.then(function (res) {
				self.event = res.data;
				if (self.dropzoneInstance) {
					self.dropzoneInstance.options.url = pixerfUrl.full + 'api/community_events/' + self.event.id;
					self.dropzoneInstance.processQueue();
				}
				var successMessage = 'Your ' + getItemType(self.event.event_type) + ' was created successfully';
				toastr.success(successMessage);
			}).catch(function (err) {
				console.log(err);
			})
		}

		function getItemType(type) {
			if (!type) {
				return 'event/class';
			} else if (type == 'class') {
				return 'class';
			} else {
				return 'event';
			}
		}

		function updateEvent() {
			if (!validate()) return;
			var eventToSave = Object.assign({}, self.event);
			delete eventToSave.cover;
			var convertData = transformEventObject(self.event);
			eventToSave.event_datetimes = convertData.event_datetimes;
			eventToSave.location = convertData.location;
			if (eventToSave.countries && eventToSave.countries.length) {
				delete eventToSave.countries; //TODO: remove event country on pw-973
			}
			pixerfApiEventSvc.update({
				id: eventToSave.id
			}, eventToSave).$promise.then(function (res) {
				self.event = res.data;
				self.dateTimes = reTransformDateTime(res.data.event_datetimes);
				if (self.dropzoneInstance) {
					self.dropzoneInstance.options.url = pixerfUrl.full + 'api/community_events/' + self.event.id;
					self.dropzoneInstance.processQueue();
				}
				if (self.event.admission_type == 'ticketed_pixerf') {
					self.event.paid_event = (self.event.ticket_price && !((self.event.ticket_price == 0) || (!self.event.ticket_price)) ? true : false);
				}
				var successMessage = 'Your ' + getItemType(eventToSave.event_type) + ' updated successfully';
				toastr.success(successMessage);
				$state.go('event-detail-page.event-photos', {
					id: self.event.id,
					name: self.event.name
				});
			}).catch(function (err) {
				console.log(err);
			})
		}

		function onSaveAsDraftEvent() {
			self.event = transformEventObject(self.event);
			pixerfApiEventSvc.create({
				community_id: self.community.id
			}, self.event).$promise.then(function (res) {
				self.event = res.data
				if (self.dropzoneInstance) {
					self.dropzoneInstance.options.url = pixerfUrl.full + 'api/community_events/' + self.event.id;
					self.dropzoneInstance.processQueue();
				}
				var successMessage = 'Your ' + getItemType(self.event.event_type) + ' has been successfully saved as draft';
				toastr.success(successMessage);
			}).catch(function (err) {
				console.log(err);
			})
		}

		function onCancelCreateEvent() {}

		function transformEventObject(eventData) {
			var transformedEvent = {
				event_datetimes: []
			};
			if (eventData.id) {
				transformedEvent.id = self.event.id;
			}

			transformedEvent.name = self.event.name;
			transformedEvent.description = self.event.description;
			transformedEvent.is_private = self.event.is_private;
			transformedEvent.capacity_type = self.event.capacity_type;
			transformedEvent.admission_type = self.event.admission_type;
			transformedEvent.ticket_url = self.event.ticket_url;
			transformedEvent.max_attendees = self.event.max_attendees;
			transformedEvent.moderate_event_posts = self.event.moderate_event_posts;
			transformedEvent.start_discussion_permission = self.event.start_discussion_permission;
			transformedEvent.event_type = self.event.event_type;

			if (eventData.location) {
				transformedEvent.location = accountUtils.getUserGoogleLocation(eventData.location);
			}

			if (transformedEvent.admission_type == 'ticketed_pixerf') {
				transformedEvent.ticket_price = self.event.ticket_price;
			}

			for (var i = 0; i < self.dateTimes.length; i++) {
				var formattedDate = transformTime(self.dateTimes[i]);
				if (self.dateTimes[i].date && !_.isEmpty(formattedDate)) {
					transformedEvent.event_datetimes.push(formattedDate);
				}
			}

			return transformedEvent;
		}

		function transformTime(date) {
			var formattedStartDate = moment(date.date.getDate() + "/" + (date.date.getMonth() + 1) + "/" + date.date.getFullYear() + " " + date.start_time, "DD/MM/YYYY HH:mm:ss");
			var formattedEndDate = moment(date.date.getDate() + "/" + (date.date.getMonth() + 1) + "/" + date.date.getFullYear() + " " + date.end_time, "DD/MM/YYYY HH:mm:ss");
			var isValidDuration = moment(formattedEndDate, "DD/MM/YYYY HH:mm:ss").diff(moment(formattedStartDate, "DD/MM/YYYY HH:mm:ss")) >= 0;

			if (!isValidDuration) {
				return {};
			}

			return {
				start_datetime: formattedStartDate.format(),
				end_datetime: formattedEndDate.format()
			};
		}

		function validate(eventData) {
			var result = true;
			for (var i = 0; i < self.dateTimes.length; i++) {
				var formattedDate = transformTime(self.dateTimes[i]);
				if (!self.dateTimes[i].date || _.isEmpty(formattedDate)) {
					result = false;
					toastr.error("Invalid time ");
				}
			}
			return result;
		}

		function reTransformDateTime(dateTimes) {
			var result = [];
			for (var i = 0; i < dateTimes.length; i++) {

				var formattedDate = {
					date: new Date(dateTimes[i].start_datetime)
				};

				if (parseInt(moment(new Date(dateTimes[i].start_datetime)).format("HH")) > 12) {
					formattedDate.start_time = {
						hour: parseInt(moment(new Date(dateTimes[i].start_datetime)).format("HH")) - 12,
						min: parseInt(moment(new Date(dateTimes[i].start_datetime)).format("mm")),
						second: parseInt(moment(new Date(dateTimes[i].start_datetime)).format("ss")),
						options: "PM"
					}
				} else {
					formattedDate.start_time = {
						hour: parseInt(moment(new Date(dateTimes[i].start_datetime)).format("HH")),
						min: parseInt(moment(new Date(dateTimes[i].start_datetime)).format("mm")),
						second: parseInt(moment(new Date(dateTimes[i].start_datetime)).format("ss")),
						options: "AM"
					}
				}

				if (formattedDate.start_time.hour < 10) {
					formattedDate.start_time.hour = "0" + formattedDate.start_time.hour;
				}
				if (formattedDate.start_time.min < 10) {
					formattedDate.start_time.min = "0" + formattedDate.start_time.min;
				}

				if (parseInt(moment(new Date(dateTimes[i].end_datetime)).format("HH")) > 12) {
					formattedDate.end_time = {
						hour: parseInt(moment(new Date(dateTimes[i].end_datetime)).format("HH")) - 12,
						min: parseInt(moment(new Date(dateTimes[i].end_datetime)).format("mm")),
						second: parseInt(moment(new Date(dateTimes[i].end_datetime)).format("ss")),
						options: "PM"
					}
				} else {
					formattedDate.end_time = {
						hour: parseInt(moment(new Date(dateTimes[i].end_datetime)).format("HH")),
						min: parseInt(moment(new Date(dateTimes[i].end_datetime)).format("mm")),
						second: parseInt(moment(new Date(dateTimes[i].end_datetime)).format("ss")),
						options: "AM"
					}
				}

				if (formattedDate.end_time.hour < 10) {
					formattedDate.end_time.hour = "0" + formattedDate.end_time.hour;
				}
				if (formattedDate.end_time.min < 10) {
					formattedDate.end_time.min = "0" + formattedDate.end_time.min;
				}

				if (formattedDate.date && !_.isEmpty(formattedDate)) {
					result.push(formattedDate);
				}
			}

			return result;

		}

        function cancelBtnClicked(){
            $state.go("event-detail-page.event-photos", ({id: self.event.id,name: self.event.name}));
        }

		function deleteBtnClicked() {
			var event = self.event;
			confirmPopupSvc.showPopup({
				windowClass: 'delete-event-confirm-popup',
				title: $translate.instant("you-are-about-to-delete-this-event"),
				message: $translate.instant("deleting-your-Event-will-remove-it"),
				submitBtnText: 'Yes',
				cancelBtnText: 'Cancel',
				submit: function () {
					var def = $q.defer();
					pixerfApiEventSvc.deleteEvent({
						id: event.id
					}).$promise.then(
						function (res) {
							toastr.success("Your event deleted successfully");
							def.resolve(res);
						},
						function error(err) {
							if (err && err.data && err.data.data && err.data.data.message) {
								toastr.error(err.data.data.message);
							} else {
								toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
							}
						}
					).catch(function (err) {
						def.reject(err);

					});
					return def.promise;
				}
			});
		}

		function cancelEvent() {

			confirmPopupSvc.showPopup({
				windowClass: 'cancel-event-confirm-popup',
				title: $translate.instant("you-are-about-to-cancel-this-event"),
				message: $translate.instant("if-you-cancel-this-event"),
				submitBtnText: 'Yes',
				cancelBtnText: 'Cancel',
				submit: function () {
					var def = $q.defer();
					pixerfApiCommunitySvc.cancel_community_event({
						id: self.event.id
					}).$promise.then(
						function success(res) {
							toastr.success("this event has been successfully canceled");
							def.resolve(res);
						},
						function error(err) {
							if (err && err.data && err.data.data && err.data.data.message) {
								toastr.error(err.data.data.message);
							} else {
								toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
							}
							console.log(err);
							def.reject(err);
						}
					);
					return def.promise;
				},
				submitCallback: function () {
					if ($scope.onStatusChanged) {
						$scope.onStatusChanged({
							event: event
						});
					}
				}
			});
		}

		init();

	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('manageCommunityPendingPostsCtrl', manageCommunityPendingPostsCtrl);

        manageCommunityPendingPostsCtrl.$inject = ['$scope', 'sessionManagerSvc', 'communityData', 'pixerfApiCommunitySvc', 'pagingUtils', 'removeMemberPopupSvc', 'blockMemberPopupSvc', 'confirmSuccessPopupSvc', '$state', 'pixerfApiCommunityDiscussionSvc', '$q', 'confirmPopupSvc'];

	function manageCommunityPendingPostsCtrl($scope, sessionManagerSvc, communityData, pixerfApiCommunitySvc, pagingUtils, removeMemberPopupSvc, blockMemberPopupSvc, confirmSuccessPopupSvc, $state, pixerfApiCommunityDiscussionSvc, $q, confirmPopupSvc ) {

		var self = this;
		self.isWorking = false;
		self.spinner = {
			isVisible: false
		}
		self.isLastPage = false;
		self.discussions = [];
        self.community = communityData;
		self.isMember = self.community.membership_status === 'accepted';
		self.loginUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.isBusinessAcc = self.loginUser && self.loginUser.account_type === 'business';
		self.isOwner = self.loginUser && self.loginUser.id === self.community.owner.id;
        self.arrangeOptions = {
			props: "arrangeBy",
			selections: [{
					label: "recent",
					value: "inserted_at"
				},
				{
					label: "bookmarked",
					value: "is_bookmarked"
				}
			]
		};
		self.submitButtonText = "Join Community";
		self.arrangeBy= {arrangeBy: 'inserted_at'};
		self.defaultArrangeBy = {arrangeBy: self.arrangeOptions.selections[0].value};
        self.searchParams = {
			id: self.community.id,
			page: 1,
			status: 'pending',
			sort: self.defaultArrangeBy.arrangeBy
		};
		self.onRemoveFromCommunity = onRemoveFromCommunity;
		self.onBlockFromCommunity = onBlockFromCommunity;
		self.onApproveDiscussion = onApproveDiscussion;
		self.onRejectDiscussion = onRejectDiscussion;

		function init() {
			if (!self.community.is_private || (self.loginUser && self.community.is_private && (self.community.membership_status === 'accepted' || self.community.membership_status === 'owner'))) {
				getDiscussions(self.searchParams, true);
			}
			if (self.community.is_private && self.community.membership_status === 'requested') {
				self.submitButtonText = "Requested";
			}
		}

		function getDiscussions(params, isFresh) {
			self.searchParams = params;
			self.spinner.isVisible = true;
			self.isWorking = true;
			pixerfApiCommunitySvc.get_discussions_by_community_id(self.searchParams).$promise.then(function (res) {
				if (!self.discussions || isFresh) self.discussions = [];
				self.discussions = self.discussions.concat(res.data);
				self.isLastPage = pagingUtils.isNoMorePageToLoad(self.searchParams.page, res);
				self.spinner.isVisible = false;
				self.searchParams.page = params.page;
				self.isWorking = false;
			}).catch(function (err) {
				self.isWorking = false;
				self.spinner.isVisible = false;
				console.log(err);
			})
		}

		function fetchMoreDiscussions() {
			if (self.isLastPage || self.spinner.isVisible) return;
			var searchParms = $.extend(true, {}, self.searchParams);
			searchParms.page++;
			getDiscussions(searchParms);
		}

		function onRemoveUser(member){
			self.discussions = _.reject(self.discussions, function (item) {
				return item.user.id === member.id;
			})
		}

		function showConfirmSuccessPopupMessage(message) {
			confirmSuccessPopupSvc.showPopup({
				windowClass: 'manager-member-list-view__confirm-success-popup',
				message: message
			});
		}

		function onRemoveFromCommunity(member) {
			var removePopup = removeMemberPopupSvc.showPopup({
				community: self.community,
				user: member
			})
			removePopup.result.then(function (data) {
				onRemoveUser(member);
				showConfirmSuccessPopupMessage((member.displayName || member.email) + ' has been removed from your Community.');
			})
		}

		function onApproveDiscussion(discussion) {
			pixerfApiCommunityDiscussionSvc.move_status({
				id: discussion.id,
				action: 'approve'
			}, {}).$promise.then(function (respone) {
				return pixerfApiCommunitySvc.update_discussion({
					id: discussion.id
				}, {
					status: 'published'
				}).$promise;
			}).then(function (respone) {
				self.discussions = _.reject(self.discussions, function (item) {
					return item.id === discussion.id;
				})
			}).catch(function (err) {
				console.log(err);
			});
		}

		function onRejectDiscussion(discussion) {
			confirmPopupSvc.showPopup({
				windowClass: 'reject-discussion-popup',
				title: "You're about to reject this post.",
				message: 'Rejected post will be permanently deleted and the member will be notified. Are you sure?',
				submitBtnText: 'Confirm',
				cancelBtnText: 'Cancel',
				submit: function () {
					var def = $q.defer();
					pixerfApiCommunityDiscussionSvc.move_status({
						id: discussion.id,
						action: 'reject'
					}, {}).$promise.then(function (respone) {
						self.discussions = _.reject(self.discussions, function (item) {
							return item.id === discussion.id;
						})
						def.resolve(respone);
					}).catch(function (err) {
						def.reject(err);
					})
					return def.promise;
				}
			});
		}

		function onBlockFromCommunity(member) {

			var blockPopup = blockMemberPopupSvc.showPopup({
				community: self.community,
				user: member
			})
			blockPopup.result.then(function (data) {
				if(data && data.user){
					onRemoveUser(member);
					showConfirmSuccessPopupMessage('<strong>' + (member.displayName || member.email) + '</strong> has been blocked from your Community.');
				}
			}).catch(function (err) {
				console.log(err);
			})
		}

		init();
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('manageCommunityReportsCtrl', manageCommunityReportsCtrl);

        manageCommunityReportsCtrl.$inject = ['$scope', 'sessionManagerSvc', 'communityData', 'pixerfApiCommunitySvc', 'pagingUtils', 'confirmSuccessPopupSvc', 
			'communityResolveReportPopupSvc', '$state', 'communityRemoveReportPopupSvc', 'removeMemberPopupSvc', '$timeout', 'systemUtils', 'blockMemberPopupSvc'
			,'$translate'];

	function manageCommunityReportsCtrl($scope, sessionManagerSvc, communityData, pixerfApiCommunitySvc, pagingUtils, confirmSuccessPopupSvc, 
			communityResolveReportPopupSvc, $state, communityRemoveReportPopupSvc, removeMemberPopupSvc, $timeout, systemUtils, blockMemberPopupSvc
			, $translate) {

		var self = this;
		self.isWorking = false;
		self.parent = $scope.$parent.vm;
		self.spinner = {
			isVisible: false
		}
		self.isLastPage = false;
		self.discussions = [];
        self.community = communityData;
		self.isMember = self.community.membership_status === 'accepted';
		self.loginUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.isBusinessAcc = self.loginUser && self.loginUser.account_type === 'business';
		self.isOwner = self.loginUser && self.loginUser.id === self.community.owner.id;
		self.status = $state.params && $state.params.status ? $state.params.status : '';
		self.onKeepPost = onKeepPost;
		self.onRemovePost = onRemovePost;
		self.onRemoveFromCommunity = onRemoveFromCommunity;
		self.onBlockFromCommunity = onBlockFromCommunity;
		self.onReportClicked = onReportClicked;
		self.onReportDetailsViewClosed = onReportDetailsViewClosed;
		self.isReportDetailsViewOpen = false;
		self.customPagingOptions = {
			label: "Rows per page:",
			showValues: [30, 50, 100]
		}
		self.searchParams = {
			type: 'pending',
			page: 1,
			page_size: self.customPagingOptions.showValues[0]
		};
		self.parent.subContextPage = self.status;
		self.onPageSizeChanged = onPageSizeChanged;
		self.onListChanged = onListChanged;
		self.sortByProps = sortByProps;

		function init() {
			self.searchParams.type = (self.status == 'reported-posts-action-required' ? 'pending' : 'past')
			self.searchParams.community_ids = [self.community.id]
			getPendingReportsList(self.searchParams, true);
		}
		function sortByProps(propertyName, isActtionRequiredTable) {
			if (isActtionRequiredTable) {
				$scope.reverseActionRequired = ($scope.propertyActionRequiredName === propertyName) ? !$scope.reverseActionRequired : false;
				$scope.propertyActionRequiredName = propertyName;
			} else {
				$scope.reverse = ($scope.propertyName === propertyName) ? !$scope.reverse : false;
				$scope.propertyName = propertyName;
			}
		};

		function convertStatus(items) {
			for(var i = 0; i < items.length; i++){
				var type = (items[i].item_type == 'discussion_reply' ? 'Comment' : "Post");
				var statusText = '';
				switch (items[i].status) {
					case "open":
						statusText = type + " In Review";
						break;
					case "validated":
						statusText = type + " Removed";
						break;
					case "resolved":
						statusText = type + " Kept";
						break;
					default:
						statusText = type + " Removed";
				}
				items[i].statusText = statusText;
			}
		}

		function getPendingReportsList(params, isRefresh) {
			if (self.spinner.isVisible) return;
			self.spinner.isVisible = true;
			if (isRefresh) {
				self.totalPastReports = 0;
				self.totalPage = 0;
			}
			pixerfApiCommunitySvc.get_pending_reports(params).$promise.then(function (respone) {
				if (isRefresh) {
					self.reports = respone.data;
				} else {
					self.reports = self.reports.concat(respone.data);
				}

				convertStatus(self.reports);
				self.isLastPage = pagingUtils.isNoMorePageToLoad(params.page, respone);
				self.totalPage = pagingUtils.getTotalPage(respone);
				self.totalPastReports = pagingUtils.getTotalCount(respone);
				self.searchParams.page = params.page;
				self.spinner.isVisible = false;
			}).catch(function (error) {
				console.log(error);
				self.spinner.isVisible = false;
			})
		}

		function removeReport(report){
			self.reports = _.reject(self.reports, function (item) {
				return item.id === report.id;
			})
		}

		function onPageSizeChanged(pageSize) {
			self.searchParams.page = 1;
			self.searchParams.page_size = pageSize;
			getPendingReportsList(self.searchParams, true);
		}

		function onListChanged(data) {
			self.searchParams.page = data.currentPage;
			getPendingReportsList(self.searchParams, true);
		}

		function onKeepPost(report) {
			var url = $state.href('manage-community.reports', {
				id: self.community.id,
				name: self.community.name,
				manage: true,
				status: 'past-reported-posts'
			});
			var popupDescription = 'resolve-event-report-description';
			var successDescription = $translate.instant('remove-event-report-description', {communityPastReportLink: url});
			var popupTitle = 'keep-post';
			var resolveReport = communityResolveReportPopupSvc.showPopup({
				data: report,
				target: report.item_type,
				popupDescription: popupDescription,
				successDescription: successDescription,
				popupTitle: popupTitle 
			})

			resolveReport.result.then(function (data) {
				if(data){
					removeReport(report);
				}
			})
		}

		function onRemovePost(report) {
			var removeReport = communityRemoveReportPopupSvc.showPopup({
				data: report,
				target: report.item_type
			})

			removeReport.result.then(function (data) {
				if(data){
					removeReport(report);
				}
			})
		}

		function showConfirmSuccessPopupMessage(message) {
			confirmSuccessPopupSvc.showPopup({
				windowClass: 'manager-member-list-view__confirm-success-popup',
				message: message
			});
		}

		function onRemoveFromCommunity(member) {
			var removePopup = removeMemberPopupSvc.showPopup({
				community: self.community,
				user: member
			})
			removePopup.result.then(function (data) {
				getPendingReportsList(self.searchParams, true);
				showConfirmSuccessPopupMessage((member.displayName || member.email) + ' has been removed from your Community.');
			})
		}

		function onBlockFromCommunity(member) {
			var blockPopup = blockMemberPopupSvc.showPopup({
				community: self.community,
				user: member
			})
			blockPopup.result.then(function (data) {
				if(data && data.user){
					getPendingReportsList(self.searchParams, true);
					showConfirmSuccessPopupMessage('<strong>' + (member.displayName || member.email) + '</strong> has been blocked from your Community.');
				}
			}).catch(function (err) {
				console.log(err);
			})
		}

		function onReportClicked(report){
			self.reports = _.map(self.reports, function (report) {
				report.selected = false;
				return report;
			})
			self.selectedReport = null;
			$timeout(function () {
				self.selectedReport = report;
				report.selected = true;
				if (window.innerWidth < 480) {
					var element = angular.element('<manage-report-detail-compile-template id="manageReportDetailCompileTemplate" append-to-body="true" report="vm.selectedReport" on-closed="vm.onReportDetailsViewClosed()" context="pending" on-status-changed="vm.onReportGridChanged(data)"> </manage-report-detail-compile-template>');
					$("body").append(element);
					$("body").addClass("modal-open");
					$compile(element)($scope);
				} else {
					self.isReportDetailsViewOpen = true;
				}
			})
			systemUtils.digest($scope);
		}

		function onReportDetailsViewClosed() {
			if (window.innerWidth < 480) {
				$("#manageReportDetailCompileTemplate").remove();
				$("body").removeClass("modal-open");
			} else {
				self.isReportDetailsViewOpen = false;
			}
			self.reports = _.map(self.reports, function (report) {
				report.selected = false;
				return report;
			})
		}

		init();
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('editCommunityCtrl', editCommunityCtrl);

	editCommunityCtrl.$inject = ['$scope', 'communityData', 'pixerfApiCommunitySvc', 'toastr', 'commonConst', 'confirmPopupSvc', '$state', 'createCommunitySvc', 'systemUtils', 'sessionManagerSvc', 'translationSvc', '$timeout', '$q', '$translate'];

	function editCommunityCtrl($scope, communityData, pixerfApiCommunitySvc, toastr, commonConst, confirmPopupSvc, $state, createCommunitySvc, systemUtils, sessionManagerSvc, translationSvc, $timeout, $q, $translate) {
		var self = this;

		self.loginUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.communityDetailControler = $scope.$parent.vm;
		self.communityDetailControler.contextPage = "community-details";
		self.community = Object.assign({}, communityData);
		self.parent = $scope.$parent.vm;
		self.orginialData = {};
		self.onMemberGridInit = onMemberGridInit;
		self.cancelBtnClicked = cancelBtnClicked;
		self.saveBtnClicked = saveBtnClicked;
		self.deleteBtnClicked = deleteBtnClicked;
		self.formOnChange = formOnChange;
		self.createCommunityForm = {};
		self.createCommunityFormOptions = {
			hideAvatar: true
		}
		self.isOwner = self.loginUser && (self.loginUser.id === self.community.owner.id);
		self.reasonList = {};
		self.reasonListNeedUpdate = {};
		self.isFinishActionRequired = isFinishActionRequired;
		self.showFinishActionRequireMessage = false;
		self.spinner = {
			isVisible: false
		};
		self.showActionRequired = false;
		self.formChanged = false;

		function init() {
			if(!self.isOwner){
				$state.go("manage-community.members", {status: 'members'});
			}
			backup();
			self.community.cover.canEdit = true;
			self.communityDetailControler.uploadCommunityAvatarOptions = createCommunitySvc.getUploadCommunityAvatarOptions(self.community, {
				onSuccess: function (response) {
					self.communityDetailControler.communityAvatar.url = "";
					$timeout(function () {
						self.communityDetailControler.communityAvatar.url = response.thumbnail;
					}, 500);
					systemUtils.digest($scope);
				}
			});
			
			if(self.community && self.community.status =='approve_required'  && self.community.community_reject_comments && self.community.community_reject_comments.length){
				buildActionRequire();
				self.showActionRequired = true;
			}
		}

		function isFinishActionRequired(){
			var result = false;
			var arrayReason = Object.keys(self.reasonListNeedUpdate).map(function(key) {
				return key});
			if((arrayReason.length <= 0) || ((arrayReason.length == 1) && arrayReason[0] == 'others')){
				result = true;
			}

			return result;
		}

		function buildActionRequire(){
			if(!self.community || !self.community.community_reject_comments || !self.community.community_reject_comments.length){
				return;
			}

			self.reasonList = {};
			for(var i = 0; i < self.community.community_reject_comments.length; i++){
				if(self.community.community_reject_comments[i].reason){
					var reasons = (self.community.community_reject_comments[i].reason).split(",");
					for(var j =0; j < reasons.length; j++){
						var reasonId = ((reasons[j]).toLowerCase()).replace(/\s+/g, '');
						self.reasonList[reasonId] = true;
					}
				}

			}
			self.reasonListNeedUpdate = Object.assign({}, self.reasonList);

		}

		function formOnChange(){
			self.formChanged = true;
			self.showFinishActionRequireMessage = false;
		}

		function onMemberGridInit(instance) {
			self.memberGrid = instance;
		}

		function backup() {
			self.orginialData.name = self.community.name;
			self.orginialData.description = self.community.description;
			self.orginialData.is_private = self.community.is_private;
			self.orginialData.is_unlisted = self.community.is_unlisted;
		}

		function restore() {
			self.community.name = self.orginialData.name;
			self.community.description = self.orginialData.description;
			self.community.is_private = self.orginialData.is_private;
			self.community.is_unlisted = self.orginialData.is_unlisted;
		}

		function saveBtnClicked(community) {
			
			self.showFinishActionRequireMessage = false;
			self.spinner.isVisible = true;
			if (community.cover) {
				delete community.cover;
			}
			var errMsg = createCommunitySvc.validate(community, true);
			if (errMsg) {
				toastr.error(errMsg);
				return;
			}
			pixerfApiCommunitySvc.update({
				id: community.id
			}, community).$promise.then(function (response) {
				backup();
				community.status = response.data.status;
				communityData = Object.assign({}, community);
				self.parent.community.status = response.data.status;
				self.showFinishActionRequireMessage = true;
				self.showActionRequired = false;
				if (self.dropzoneInstance) {
					self.dropzoneInstance.processQueue();
					self.dropzoneInstance.on("complete", function () {
						self.spinner.isVisible = false;
						self.formChanged = false;
						self.dropzoneInstance = undefined;
						toastr.success($translate.instant('your-changes-have-been-successfully-submitted-approval'));
						$scope.$apply()
                        $state.go("community-detail-page.community-detail-discussions",{id: self.parent.community.id,name: self.parent.community.name});
					})
				}else{
					self.spinner.isVisible = false;
					toastr.success($translate.instant('your-changes-have-been-successfully-submitted-approval'));
					self.formChanged = false;
                    $state.go("community-detail-page.community-detail-discussions",{id: self.parent.community.id,name: self.parent.community.name});
				}
			}, function (err) {
				var errMessage = translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true);
				self.spinner.isVisible = false;
				self.formChanged = false;
				self.showActionRequired = false;
				if (err && err.data && err.data.data && err.data.data.key == 'community_privacy_change') {
					self.community.is_private = self.orginialData.is_private;
					self.community.is_unlisted = self.orginialData.is_unlisted;
					confirmPopupSvc.showPopup({
						windowClass: 'confirm-action-popup',
						title: 'Oops, sorry.',
						message: 'You can only change a Community from private to public automatically within 30 days from the date of creation. If you would like to proceed, send us a request.',
						hideSubmitBtn: false,
						cancelBtnText: 'Cancel',
						submitBtnText: 'Send request',
						submit: onSendRequest
					});
				} else {
					toastr.error(errMessage);
				}
			})
		}

		function cancelBtnClicked() {
			restore();
			$state.go("community-detail-page.community-detail-discussions", ({id: self.community.id,name: self.community.name}));
		}

		function onSendRequest() {
			var def = $q.defer();
			pixerfApiCommunitySvc.change_privacy({
				id: self.community.id
			}).$promise.then(function (res) {
				toastr.success("Sent request!");
                $state.go("community-detail-page.community-detail-discussions", ({id: self.community.id,name: self.community.name}));
				def.resolve(res);
			}).catch(function (err) {
				toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
				def.reject(err);
			})
			return def.promise;
		}

		function deleteBtnClicked(community) {
			if (self.isWorking) return;
			var confirmMessage = $translate.instant("delete-community-confirm");
			var modal = confirmPopupSvc.showPopup({
				windowClass: 'confirm-action-popup',
				hideTitle: true,
				hideConfirmText: true,
				cancelBtnText: 'Cancel',
				title: confirmMessage
			});
			modal.result.then(function () {
				self.isWorking = true;
				pixerfApiCommunitySvc.delete({
					id: community.id
				}).$promise.then(function (response) {
					toastr.success(translationSvc.SOMETHING_HAS_BEEN_DONE("THIS_COMMUNITY", "SUCCESSFULLY_DELETED") + "!");
					$state.go("user-home-page." + self.loginUser.account_type + ".communities.grid");
					self.isWorking = false;
				}, function (err) {
					$state.go("user-home-page." + self.loginUser.account_type + ".communities.grid");
					self.isWorking = false;
					toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
				});
			})
		}

		init();
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('manageCommunityMembersCtrl', manageCommunityMembersCtrl);

		manageCommunityMembersCtrl.$inject = ['$scope', 'ISO3166', '$timeout', 'communityData', 'pixerfApiCommunitySvc', 'pagingUtils', 'sessionManagerSvc', 'toastr', 'translationSvc', '$stateParams'];

	function manageCommunityMembersCtrl($scope, ISO3166, $timeout, communityData, pixerfApiCommunitySvc, pagingUtils, sessionManagerSvc, toastr, translationSvc, $stateParams) {

		var USER_CONTROL_ADMINDASHBOARD = ['curator_internal', 'admin_internal', 'marketer_internal'];
		var self = this;
		self.loginedUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.isAdmin = self.loginedUser && (USER_CONTROL_ADMINDASHBOARD.includes(self.loginedUser.role) || self.loginedUser.email === 'marcom@pixerf.com');
		self.parent = $scope.$parent.vm;
		self.spinner = {
			isVisible: false
		};
		self.community = communityData;
		self.members = [];
		self.stateName = $stateParams.status || 'members';
		self.onSearchMembers =  _.debounce(onSearchMembersByKeyword, 300);;
		self.searchMemberString = '';
		self.onRemovedUser = onRemovedUser;
		self.onStatusChanged = onStatusChanged;
		self.showMemberSince = false;
		self.showDateRequest = false;
		self.showDateInvited = false;
		self.showDateBlocked = false;
		self.showAdmin = false
		self.showInvitationFrom = false;
		self.customPagingOptions = {
			label: "Rows per page:",
			showValues: [30, 50, 100]
		}

		self.stateToMemberShip = {
			members: 'accepted',
			requested: 'requested',
			invited: 'invited',
			blocked: 'banned',
			admin: 'manager,owner'
		};
		self.parent.subContextPage = $stateParams.status;
		self.onPageSizeChanged = onPageSizeChanged;
		self.onListChanged = onListChanged;
		self.selectedspecialties = [];
		self.searchParams = {
			id: self.community.id,
			membership: self.memberShipName,
			page: 1,
			page_size: self.customPagingOptions.showValues[0]
		};
		self.sortByProps = sortByProps;
		self.reverse = false;
		self.onSpecialtyFilterChanged = onSpecialtyFilterChanged;
		self.onTypeFilterChanged = onTypeFilterChanged;

		function init() {
			self.memberShipName = getMemberShipFromStateName(self.stateName);
			self.searchParams.membership = self.memberShipName;
			if(!self.memberShipName) {
				toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
				return;
			}
			setUserLayout(self.stateName);
			getMemberOfCommunity(self.searchParams, true);
			getSpecialitiesCount();
			self.isUserManager = self.parent.isManager();
		}

		function sortByProps(propertyName, isActtionRequiredTable) {
			if (isActtionRequiredTable) {
				$scope.reverseActionRequired = ($scope.propertyActionRequiredName === propertyName) ? !$scope.reverseActionRequired : false;
				$scope.propertyActionRequiredName = propertyName;
			} else {
				self.reverse = ($scope.propertyName === propertyName) ? !self.reverse : false;
				$scope.propertyName = propertyName;
			}
		};

		function clearFilter(){
			delete self.searchParams.specialities;
			delete self.searchParams.ambassadorship; 
		}

		function onTypeFilterChanged(selectedItems){
			self.selectedSpecialties = [];
			clearFilter();
			var types = (_.pluck(selectedItems, 'value'));
			if(types && types.length){
				self.searchParams.ambassadorship = types.toString()
			}
			getMemberOfCommunity(self.searchParams, true);
		}

		function onSpecialtyFilterChanged(selectedItems){
			self.selectedTypes = [];
			clearFilter();
			var specialities = (_.pluck(selectedItems, 'value'));
			if(specialities && specialities.length){
				self.searchParams.specialities = specialities.toString()
			}
			getMemberOfCommunity(self.searchParams, true);
		}

		function buildSpecialties(specialties) {
			self.specialtyFilterOptions = [];
			for (key in specialties) {
				if(specialties[key].user_count > 0) {
					var option = {
						label: specialties[key].speciality + ' (' + specialties[key].user_count + ')',
						value: specialties[key].id
					}
					self.specialtyFilterOptions.push(option);
				}
			}
		}

		function buildMemberAccountTypes(){
			self.accountTypeFilterOptions = [
				{
					value: 'maestro',
					label: 'Ambassador Maestro' + ' (' + self.community.stats.ambassador_maestro_count + ')',
					count: self.community.stats.ambassador_maestro_count
				},
				{
					value: 'pro',
					label: 'Ambassador Pro' + ' (' + self.community.stats.ambassador_pro_count + ')',
					count: self.community.stats.ambassador_pro_count
				},
				{
					value: 'pixerfer',
					label: 'Pixerfer' + ' (' + self.community.stats.pixerfer_count + ')',
					count: self.community.stats.pixerfer_count
				}
			];

			self.accountTypeFilterOptions = _.reject(self.accountTypeFilterOptions, function (item) {
				return item.count <= 0;
			})
		}

		function buildAccountTypes() {

			if( $stateParams.status == 'members'){
				return buildMemberAccountTypes();
			}

			self.accountTypeFilterOptions = [];
		}

		function onPageSizeChanged(pageSize) {
			self.searchParams.page = 1;
			self.searchParams.page_size = pageSize;
			getMemberOfCommunity(self.searchParams, true);
		}

		function onListChanged(data) {
			self.searchParams.page = data.currentPage;
			getMemberOfCommunity(self.searchParams, true);
		}

		function buildMembersProperty(members){
			for(var i = 0; i< members.length; i++){{
				var countryCode = (members[i].organization && members[i].organization.address) ? (members[i].organization.address.country ) : (members[i].address ? members[i].address.country : '');
				members[i].country = ISO3166.getCountryName(countryCode);
			}}
		}

		function getMemberOfCommunity(params, isRefresh) {
			if (self.spinner.isVisible) return;
			self.spinner.isVisible = true;
			if (isRefresh) {
				self.totalMembers = 0;
				self.totalPage = 0;
			}
			if (self.searchMemberString) {
				params.keywords = self.searchMemberString;
				params.page = 1;
			} else {
				delete params.keywords;
			}
			pixerfApiCommunitySvc.get_members(params).$promise.then(function (res) {
				self.members = res.data;
				for (var i = 0; i < self.members.length; i++) {
					self.members[i].avatar = self.members[i].profile_image_media && self.members[i].profile_image_media['100x'] ? self.members[i].profile_image_media['100x'] : 'assets/images/default/default-profile.png';
				}
				buildAccountTypes(self.members);
				buildMembersProperty(self.members);
				self.isLastPage = pagingUtils.isNoMorePageToLoad(params.page, res);
				self.totalPage = pagingUtils.getTotalPage(res);
				self.totalMembers = pagingUtils.getTotalCount(res);
				self.searchParams.page = params.page;
				self.spinner.isVisible = false;
			}).catch(function (err) {
				self.spinner.isVisible = false;
				console.log(err)
			})
		}

		function getSpecialitiesCount(){
			pixerfApiCommunitySvc.getSpecialitiesCount({id:self.community.id, membership: self.memberShipName}).$promise.then(function (res) {
				buildSpecialties(res.data);
			}).catch(function (err) {
				console.log(err)
			})
		}

		function getMemberShipFromStateName(stateName){
			return self.stateToMemberShip[stateName];
		}

		function onSearchMembersByKeyword(){
			getMemberOfCommunity(self.memberShipName);
		}

		function onRemovedUser(member){
			self.members = _.reject(self.members, function (item) {
				return item.id === member.id;
			})
		}

		function onStatusChanged(member){
			self.members = _.reject(self.members, function (item) {
				return item.id === member.id;
			})
		}
		function setUserLayout(type) {
			switch (type) {
				case 'members':
					self.showMemberSince = true;
					self.showDateRequest = false;
					self.showDateInvited = false;
					self.showDateBlocked = false;	
					self.showAdmin = false;
					self.showInvitationFrom = false;
					self.joinDate = 'membership_joined_at';
					
					break;
				case 'requested':
					self.showMemberSince = false;
					self.showDateRequest = true;
					self.showDateInvited = false;
					self.showDateBlocked = false;
					self.showAdmin = false;
					self.showInvitationFrom = false;
					self.joinDate = 'membership_joined_at';
					
					break;
				case 'invited':
					self.showMemberSince = false;
					self.showDateRequest = false;
					self.showDateInvited = true;
					self.showDateBlocked = false;
					self.showAdmin = false;
					self.showInvitationFrom = true;
					self.joinDate = 'membership_joined_at';
					
					break;
				case 'blocked':
					self.showMemberSince = false;
					self.showDateRequest = false;
					self.showDateInvited = false;
					self.showDateBlocked = true;
					self.showAdmin = false;
					self.showInvitationFrom = false;
					self.joinDate = 'membership_banned_at';
					
					break;
				case 'admin':
					self.showMemberSince = true;
					self.showDateRequest = false;
					self.showDateInvited = false;
					self.showDateBlocked = false;
					self.showAdmin = true;
					self.showInvitationFrom = false;
					self.joinDate = 'membership_joined_at';
					
					break;
			}
		}

		init();
		
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('manageRequestedCommunitiesCtrl', manageRequestedCommunitiesCtrl);

	manageRequestedCommunitiesCtrl.$inject = ['$scope', 'communityConst', 'confirmPopupSvc', 'pixerfApiCommunitySvc', 'sessionManagerSvc', 'pagingUtils', 'manageCommunitiesSvc', 'translationSvc', 'toastr', '$translate'];

	function manageRequestedCommunitiesCtrl($scope, communityConst, confirmPopupSvc, pixerfApiCommunitySvc, sessionManagerSvc, pagingUtils, manageCommunitiesSvc, translationSvc, toastr, $translate) {

		var self = this;
		self.loginedUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.communityConst = communityConst;
		self.parent = $scope.$parent.vm;
		self.isMyProfile = self.parent.isMyProfile;
		self.parent.subContextPage = "Requested";
		self.user = self.parent.user;
		self.onSortByChanged = onSortByChanged;
		self.onSelectAllRequestedCommunities = onSelectAllRequestedCommunities;
		self.onSelectRequestedCommunity = onSelectRequestedCommunity;
		self.onCloseNotification = onCloseNotification;
		self.onRequestedCommunityGridChanged = onRequestedCommunityGridChanged;
		self.onSearchCommunity = _.debounce(onSearchCommunity, 800);
		self.fetchMoreRequestedCommunitiesList = fetchMoreRequestedCommunitiesList;
		self.onRequestedCommunitiesListChanged = onRequestedCommunitiesListChanged;
		self.onPageSizeRequestedCommunitiesChanged = onPageSizeRequestedCommunitiesChanged;
		self.onWithdrawCommunities = onWithdrawCommunities;
		self.selecedRequestedCommunities = [];
		self.customPagingOptions = manageCommunitiesSvc.getCustomPagingOptions();
		self.sortNameBy = 'asc';
		self.sortDateBy = 'asc';
		self.spinner = {
			isVisible: false
		};
		self.searchParams = {
			membership: 'requested',
			page: 1,
			page_size: self.customPagingOptions.showValues[0]
		};

		self.sortBy = [{
				value: "inserted_at,desc",
				title: "Date created"
			},
			{
				value: "is_private,desc",
				title: "Privacy"
			},
			{
				value: "member_count,desc",
				title: "Members"
			}
		];

		init();

		function init() {
			self.defaultSortBy = self.sortBy[0].value;
			self.searchParams.sort = self.sortBy[0].value;
			self.requestedCommunities = [];
			if (!self.isAdmin) {
				self.searchParams.user_id = self.loginedUser.id;
			}
			getRequestedCommunitiesList(self.searchParams, true);
		}

		function onSortByChanged(value, type) {
			if (value === 'name') {
				self.sortNameBy = (type === 'asc') ? 'desc' : 'asc';
			}
			if (value === 'membership_inserted_at') {
				self.sortDateBy = (type === 'asc') ? 'desc' : 'asc';
			}
			self.searchParams.sort = value + ',' + type;
			getRequestedCommunitiesList(self.searchParams, true);
		}

		function getRequestedCommunitiesList(params, isRefresh) {
			if (self.spinner.isVisible) return;
			self.spinner.isVisible = true;
			pixerfApiCommunitySvc.list(self.searchParams).$promise.then(function (response) {
				if (isRefresh) {
					self.requestedCommunities = response.data;
				} else {
					self.requestedCommunities = self.requestedCommunities.concat(response.data);
				}
				self.isLastPage = pagingUtils.isNoMorePageToLoad(params.page, response);
				self.totalRequestedPage = pagingUtils.getTotalPage(response);
				self.totalRequestedCommunities = pagingUtils.getTotalCount(response);
				self.searchParams.page = params.page;
				self.spinner.isVisible = false;
			}).catch(function (error) {
				console.log(error);
				self.spinner.isVisible = false;
			})
		}

		function onRequestedCommunitiesListChanged(data) {
			self.searchParams.page = data.currentPage;
			getRequestedCommunitiesList(self.searchParams, true);
		}

		function onPageSizeRequestedCommunitiesChanged(pageSize) {
			self.searchParams.page = 1
			self.searchParams.page_size = pageSize;
			getRequestedCommunitiesList(self.searchParams, true);
		}

		function fetchMoreRequestedCommunitiesList() {
			if (self.isLastPage || self.spinner.isVisible) return;
			var searchParams = $.extend(true, {}, self.searchParams);
			searchParams.page++;
			getRequestedCommunitiesList(searchParams);
		}

		function onSelectAllRequestedCommunities(isSelectedAllRequestedCommunities) {
			self.isOpenNotification = true;
			self.requestedCommunities = _.map(self.requestedCommunities, function (com) {
				com.isSelected = isSelectedAllRequestedCommunities;
				return com;
			})

			if (self.isSelectedAllRequestedCommunities) {
				self.selecedRequestedCommunities = self.requestedCommunities;
			} else {
				self.selecedRequestedCommunities = [];
			}
		}

		function onSelectRequestedCommunity(community) {
			self.isOpenNotification = true;
			if (!community.isSelected) {
				self.isSelectedAllRequestedCommunities = false;
				self.selecedRequestedCommunities = _.reject(self.selecedRequestedCommunities, function (com) {
					return community.id === com.id;
				})
			} else {
				self.selecedRequestedCommunities.push(community);
			}
		}

		function onCloseNotification() {
			self.isOpenNotification = false;
		}

		function removeCommunitiesFromList(communityIds) {
			self.requestedCommunities = _.reject(self.requestedCommunities, function (com) {
				return communityIds.includes(com.id);
			})
		}

		function removeCommunityFromList(communityId) {
			self.requestedCommunities = _.reject(self.requestedCommunities, function (com) {
				return communityId == com.id;
			})
		}

		function onRequestedCommunityGridChanged(community) {
			if (community && community.length) {
				removeCommunitiesFromList(_.pluck(community, "id"));
			} else {
				removeCommunityFromList(community.id);
			}
		}

		function onSearchCommunity() {
			if (self.searchCommunityString) {
				self.searchParams.keyword = self.searchCommunityString;
			} else {
				delete self.searchParams.keyword;
			}
			getRequestedCommunitiesList(self.searchParams, true);
		}

		function onWithdrawCommunities(selectedCommunities) {
			var communityNames = _.pluck(selectedCommunities, "name").join(", ");
			var confirmMessage = translationSvc.ARE_YOU_SURE_TO_DO_SOMETHING("WITHDRAW_REQUEST_JOIN_THE_COMMUNITIES", {
				communities: communityNames
			});
			var modal = confirmPopupSvc.showPopup({
				windowClass: 'confirm-withdraw-request-to-join-community-popup',
				hideTitle: true,
				hideConfirmText: true,
				cancelBtnText: 'Cancel',
				submitBtnText: 'Confirm',
				message: confirmMessage
			});

			modal.result.then(function () {
				pixerfApiCommunitySvc.withdraw_request({
					community_ids: _.pluck(selectedCommunities, "id")
				}).$promise.then(function () {
					onRequestedCommunityGridChanged(selectedCommunities);
					toastr.success($translate.instant('you-have-withdrawn-successfully'));
				}).catch(function (err) {
					console.log(err);
					toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
				})
			})
		}
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('managePendingCommunitiesCtrl', managePendingCommunitiesCtrl);

	managePendingCommunitiesCtrl.$inject = ['$scope', 'communityConst', '$state', 'pixerfApiCommunitySvc', 'sessionManagerSvc', 'pagingUtils', 'manageCommunitiesSvc'];

	function managePendingCommunitiesCtrl($scope, communityConst, $state, pixerfApiCommunitySvc, sessionManagerSvc, pagingUtils, manageCommunitiesSvc) {

		var self = this;
		self.loginedUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.communityConst = communityConst;
		self.parent = $scope.$parent.vm;
		self.isMyProfile = self.parent.isMyProfile;
		self.parent.subContextPage = "Pending";
		self.user = self.parent.user;
		self.onSortByChanged = onSortByChanged;
		self.onSelectAllCommunities = onSelectAllCommunities;
		self.onSelectCommunity = onSelectCommunity;
		self.onCloseNotification = onCloseNotification;
		self.onCommunityGridChanged = onCommunityGridChanged;
		self.onSearchCommunity = _.debounce(onSearchCommunity, 800);
		self.fetchMoreCommunitiesList = fetchMoreCommunitiesList;
		self.onDeleteCommunities = onDeleteCommunities;
		self.onCommunitiesListChanged = onCommunitiesListChanged;
		self.onPageSizeCommunitiesChanged = onPageSizeCommunitiesChanged;
		self.selectedCommunities = [];
		self.customPagingOptions = manageCommunitiesSvc.getCustomPagingOptions();
		self.onManageCommunityClicked = onManageCommunityClicked;
		self.sortNameBy = 'asc';
		self.sortDateBy = 'asc';
		self.sortStatusBy = 'asc';
		self.sortReasonBy = 'asc';
		self.spinner = {
			isVisible: false
		};
		self.searchParams = {
			status: 'pending,approve_required',
			membership: 'owner',
			page: 1,
			page_size: self.customPagingOptions.showValues[0]
		};
		self.sortBy = [{
				value: "inserted_at,desc",
				title: "Date created"
			},
			{
				value: "is_private,desc",
				title: "Privacy"
			},
			{
				value: "member_count,desc",
				title: "Members"
			}
		];

		init();

		function init() {
			self.defaultSortBy = self.sortBy[0].value;
			self.searchParams.sort = self.sortBy[0].value;
			self.communities = [];
			if (!self.isAdmin) {
				self.searchParams.user_id = self.loginedUser.id;
			}
			getCommunitiesList(self.searchParams, true);
		}

		function onSortByChanged(value, type) {
			if (value === 'name') {
				self.sortNameBy = (type === 'asc') ? 'desc' : 'asc';
			}
			if (value === 'inserted_at') {
				self.sortDateBy = (type === 'asc') ? 'desc' : 'asc';
			}
			if (value === 'status') {
				self.sortStatusBy = (type === 'asc') ? 'desc' : 'asc';
			}
			if (value === 'community_reject_comments') {
				self.sortReasonBy = (type === 'asc') ? 'desc' : 'asc';
			}
			self.searchParams.sort = value + ',' + type;
			getCommunitiesList(self.searchParams, true);
		}

		function getCommunitiesList(params, isRefresh) {
			if (self.spinner.isVisible) return;
			self.spinner.isVisible = true;
			pixerfApiCommunitySvc.list(self.searchParams).$promise.then(function (response) {
				if (isRefresh) {
					self.communities = response.data;
				} else {
					self.communities = self.communities.concat(response.data);
				}
				self.isLastPage = pagingUtils.isNoMorePageToLoad(params.page, response);
				self.totalPage = pagingUtils.getTotalPage(response);
				self.totalCommunities = pagingUtils.getTotalCount(response);
				self.searchParams.page = params.page;
				self.spinner.isVisible = false;
			}).catch(function (error) {
				console.log(error);
				self.spinner.isVisible = false;
			})
		}

		function onCommunitiesListChanged(data) {
			self.searchParams.page = data.currentPage;
			getCommunitiesList(self.searchParams, true);
		}

		function onPageSizeCommunitiesChanged(pageSize) {
			self.searchParams.page = 1
			self.searchParams.page_size = pageSize;
			getCommunitiesList(self.searchParams, true);
		}

		function fetchMoreCommunitiesList() {
			if (self.isLastPage || self.spinner.isVisible) return;
			var searchParams = $.extend(true, {}, self.searchParams);
			searchParams.page++;
			getCommunitiesList(searchParams);
		}

		function onSelectAllCommunities(isSelectedAllCommunities) {
			self.isOpenNotification = true;
			self.communities = _.map(self.communities, function (com) {
				com.isSelected = isSelectedAllCommunities;
				return com;
			})

			if (self.isSelectedAllCommunities) {
				self.selectedCommunities = self.communities;
			} else {
				self.selectedCommunities = [];
			}
		}

		function onSelectCommunity(community) {
			self.isOpenNotification = true;
			if (!community.isSelected) {
				self.isSelectedAllCommunities = false;
				self.selectedCommunities = _.reject(self.selectedCommunities, function (com) {
					return community.id === com.id;
				})
			} else {
				self.selectedCommunities.push(community);
			}
		}

		function onCloseNotification() {
			self.isOpenNotification = false;
		}

		function removeCommunitiesFromList(communityIds) {
			self.communities = _.reject(self.communities, function (com) {
				return communityIds.includes(com.id);
			})
		}

		function removeCommunityFromList(communityId) {
			self.communities = _.reject(self.communities, function (com) {
				return communityId == com.id;
			})
		}

		function onCommunityGridChanged(community) {
			if (community && community.length) {
				removeCommunitiesFromList(_.pluck(community, "id"));
			} else {
				removeCommunityFromList(community.id);
			}
		}

		function onSearchCommunity() {
			if (self.searchCommunityString) {
				self.searchParams.keyword = self.searchCommunityString;
			} else {
				delete self.searchParams.keyword;
			}
			getCommunitiesList(self.searchParams, true);
		}

		function onDeleteCommunities(communities) {
			var communityIds = _.pluck(communities, "id");
			pixerfApiCommunitySvc.approve_community(null, {
				community_ids: communityIds
			}).$promise.then(function (res) {
				onCommunityGridChanged(res.data);
			}).catch(function (err) {
				console.log(err);
			})
		}

		function onManageCommunityClicked(community) {
			var url = $state.href('manage-community.edit-community', {
				id: community.id
			});
			window.open(url, '_blank');
		}
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('manageMyCommunitiesCtrl', manageMyCommunitiesCtrl);

	manageMyCommunitiesCtrl.$inject = ['$scope', 'communityConst', '$state', 'pixerfApiCommunitySvc', 'sessionManagerSvc', 'pagingUtils', 'manageCommunitiesSvc'];

	function manageMyCommunitiesCtrl($scope, communityConst, $state, pixerfApiCommunitySvc, sessionManagerSvc, pagingUtils, manageCommunitiesSvc) {

		var self = this;
		self.loginedUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.communityConst = communityConst;
		self.parent = $scope.$parent.vm;
		self.isMyProfile = self.parent.isMyProfile;
		self.parent.subContextPage = "Your communities";
		self.user = self.parent.user;
		self.onSortByChanged = onSortByChanged;
		self.onSelectAllDeactivatedCommunities = onSelectAllDeactivatedCommunities;
		self.onSelectDeactivatedCommunity = onSelectDeactivatedCommunity;
		self.onCloseNotification = onCloseNotification;
		self.onDeactivatedCommunityGridChanged = onDeactivatedCommunityGridChanged;
		self.onSearchCommunity = _.debounce(onSearchCommunity, 800);
		self.fetchMoreDeactivatedCommunitiesList = fetchMoreDeactivatedCommunitiesList;
		self.onReactivateCommunities = onReactivateCommunities;
		self.onDeactivatedCommunitiesListChanged = onDeactivatedCommunitiesListChanged;
		self.onPageSizeDeactivatedCommunitiesChanged = onPageSizeDeactivatedCommunitiesChanged;
		self.selecedDeactivatedCommunities = [];
		self.customPagingOptions = manageCommunitiesSvc.getCustomPagingOptions();
		self.onManageCommunityClicked = onManageCommunityClicked;
		self.sortNameBy = 'asc';
		self.sortDateBy = 'asc';
		self.spinner = {
			isVisible: false
		};
		self.searchParams = {
			type: 'ongoing',
			status: 'active,in_review',
			membership: 'accepted,owner,manager',
			page: 1,
			page_size: self.customPagingOptions.showValues[0]
		};

		self.sortBy = [{
				value: "inserted_at,desc",
				title: "Date created"
			},
			{
				value: "is_private,desc",
				title: "Privacy"
			},
			{
				value: "member_count,desc",
				title: "Members"
			}
		];

		init();

		function init() {
			self.defaultSortBy = self.sortBy[0].value;
			self.searchParams.sort = self.sortBy[0].value;
			self.deactivatedCommunities = [];
			if (!self.isAdmin) {
				self.searchParams.user_id = self.loginedUser.id;
			}
			getDeactivatedCommunitiesList(self.searchParams, true);
		}

		function onSortByChanged(value, type) {
			if (value === 'name') {
				self.sortNameBy = (type === 'asc') ? 'desc' : 'asc';
			}
			if (value === 'membership_inserted_at') {
				self.sortDateBy = (type === 'asc') ? 'desc' : 'asc';
			}
			self.searchParams.sort = value + ',' + type;
			getDeactivatedCommunitiesList(self.searchParams, true);
		}

		function getDeactivatedCommunitiesList(params, isRefresh) {
			if (self.spinner.isVisible) return;
			self.spinner.isVisible = true;
			pixerfApiCommunitySvc.list(self.searchParams).$promise.then(function (response) {
				if (isRefresh) {
					self.deactivatedCommunities = response.data;
				} else {
					self.deactivatedCommunities = self.deactivatedCommunities.concat(response.data);
				}
				self.isLastPage = pagingUtils.isNoMorePageToLoad(params.page, response);
				self.totalDeactivatedPage = pagingUtils.getTotalPage(response);
				self.totalDeactivatedCommunities = pagingUtils.getTotalCount(response);
				self.searchParams.page = params.page;
				self.spinner.isVisible = false;
			}).catch(function (error) {
				console.log(error);
				self.spinner.isVisible = false;
			})
		}

		function onDeactivatedCommunitiesListChanged(data) {
			self.searchParams.page = data.currentPage;
			getDeactivatedCommunitiesList(self.searchParams, true);
		}

		function onPageSizeDeactivatedCommunitiesChanged(pageSize) {
			self.searchParams.page = 1
			self.searchParams.page_size = pageSize;
			getDeactivatedCommunitiesList(self.searchParams, true);
		}

		function fetchMoreDeactivatedCommunitiesList() {
			if (self.isLastPage || self.spinner.isVisible) return;
			var searchParams = $.extend(true, {}, self.searchParams);
			searchParams.page++;
			getDeactivatedCommunitiesList(searchParams);
		}

		function onSelectAllDeactivatedCommunities(isSelectedAllDeactivatedCommunities) {
			self.isOpenNotification = true;
			self.deactivatedCommunities = _.map(self.deactivatedCommunities, function (com) {
				com.isSelected = isSelectedAllDeactivatedCommunities;
				return com;
			})

			if (self.isSelectedAllDeactivatedCommunities) {
				self.selecedDeactivatedCommunities = self.deactivatedCommunities;
			} else {
				self.selecedDeactivatedCommunities = [];
			}
		}

		function onSelectDeactivatedCommunity(community) {
			self.isOpenNotification = true;
			if (!community.isSelected) {
				self.isSelectedAllDeactivatedCommunities = false;
				self.selecedDeactivatedCommunities = _.reject(self.selecedDeactivatedCommunities, function (com) {
					return community.id === com.id;
				})
			} else {
				self.selecedDeactivatedCommunities.push(community);
			}
		}

		function onCloseNotification() {
			self.isOpenNotification = false;
		}

		function removeCommunitiesFromList(communityIds) {
			self.deactivatedCommunities = _.reject(self.deactivatedCommunities, function (com) {
				return communityIds.includes(com.id);
			})
		}

		function removeCommunityFromList(communityId) {
			self.deactivatedCommunities = _.reject(self.deactivatedCommunities, function (com) {
				return communityId == com.id;
			})
		}

		function onDeactivatedCommunityGridChanged(community) {
			if (community && community.length) {
				removeCommunitiesFromList(_.pluck(community, "id"));
			} else {
				removeCommunityFromList(community.id);
			}
		}

		function onSearchCommunity() {
			if (self.searchCommunityString) {
				self.searchParams.keyword = self.searchCommunityString;
			} else {
				delete self.searchParams.keyword;
			}
			getDeactivatedCommunitiesList(self.searchParams, true);
		}

		function onReactivateCommunities(communities) {
			var communityIds = _.pluck(communities, "id");
			pixerfApiCommunitySvc.approve_community(null, {
				community_ids: communityIds
			}).$promise.then(function (res) {
				onDeactivatedCommunityGridChanged(res.data);
			}).catch(function (err) {
				console.log(err);
			})
		}

		function onManageCommunityClicked(community) {
			var url = $state.href('manage-community.edit-community', {
				id: community.id
			});
			window.open(url, '_blank');
		}
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('managePendingApprovalCommunitiesCtrl', managePendingApprovalCommunitiesCtrl);

	managePendingApprovalCommunitiesCtrl.$inject = ['$scope', 'communityConst', '$timeout', 'systemUtils', 'pixerfApiCommunitySvc', 'manageCommunitiesSvc', 'pagingUtils', 'sessionManagerSvc', '$compile'];

	function managePendingApprovalCommunitiesCtrl($scope, communityConst, $timeout, systemUtils, pixerfApiCommunitySvc, manageCommunitiesSvc, pagingUtils, sessionManagerSvc, $compile) {

		var self = this;
		self.loginedUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.communityConst = communityConst;
		self.parent = $scope.$parent.vm;
		self.isMyProfile = self.parent.isMyProfile;
		self.parent.subContextPage = "Pending approval";
		self.user = self.parent.user;
		self.onSortByPendingChanged = onSortByPendingChanged;
		self.onSelectAllPendingCommunities = onSelectAllPendingCommunities;
		self.onSelectPendingCommunity = onSelectPendingCommunity;
		self.onCommunityClicked = onCommunityClicked;
		self.onCommunityDetailsViewClosed = onCommunityDetailsViewClosed;
		self.isCommunityDetailsViewOpen = false;
		self.onCloseNotification = onCloseNotification;
		self.onApproveCommunities = onApproveCommunities;
		self.onCommunityGridChanged = onCommunityGridChanged;
		self.fetchMorePendingCommunitiesList = fetchMorePendingCommunitiesList;
		self.onPendingCommunitiesListChanged = onPendingCommunitiesListChanged;
		self.onPageSizePendingCommunitiesChanged = onPageSizePendingCommunitiesChanged;
		self.selecedPendingCommunities = [];
		self.sortByProps = sortByProps;
		self.onSearchPendingCommunity = _.debounce(onSearchPendingCommunity, 800);
		self.customPagingOptions = manageCommunitiesSvc.getCustomPagingOptions();
		self.spinnerPending = {
			isVisible: false
		};
		self.searchParamsPending = {
			status: 'pending',
			page: 1,
			page_size: self.customPagingOptions.showValues[0]
		};
		self.sortByPending = [{
				value: "inserted_at,desc",
				title: "Date created"
			},
			{
				value: "is_private,desc",
				title: "Privacy"
			}
		];

		init();

		function init() {
			self.searchParamsPending.sort = self.sortByPending[0].value;
			self.defaultSortByPending = self.sortByPending[0].value;
			self.pendingCommunities = [];
			getPendingCommunitiesList(self.searchParamsPending, true);
		}

		function onSortByPendingChanged(sortBy) {
			self.searchParamsPending.sort = sortBy.value;
			getPendingCommunitiesList(self.searchParamsPending, true);
		}

		function getPendingCommunitiesList(params, isRefresh) {
			if (self.spinnerPending.isVisible) return;
			self.spinnerPending.isVisible = true;
			if (isRefresh) {
				self.totalActiveCommunities = 0;
				self.totalActivePage = 0;
			}
			pixerfApiCommunitySvc.list(params).$promise.then(function (respone) {
				if (isRefresh) {
					self.pendingCommunities = respone.data;
				} else {
					self.pendingCommunities = self.pendingCommunities.concat(respone.data);
				}
				self.isLastPendingPage = pagingUtils.isNoMorePageToLoad(params.page, respone);
				self.totalPendingPage = pagingUtils.getTotalPage(respone);
				self.totalPendingCommunities = pagingUtils.getTotalCount(respone);
				self.searchParamsPending.page = params.page;
				self.spinnerPending.isVisible = false;
			}).catch(function (error) {
				console.log(error);
				self.spinnerPending.isVisible = false;
			})
		}

		function onPendingCommunitiesListChanged(data) {
			self.searchParamsPending.page = data.currentPage;
			getPendingCommunitiesList(self.searchParamsPending, true);
		}

		function onPageSizePendingCommunitiesChanged(pageSize) {
			self.searchParamsPending.page = 1;
			self.searchParamsPending.page_size = pageSize;
			getPendingCommunitiesList(self.searchParamsPending, true);
		}

		function onSelectAllPendingCommunities(isSelectedAllPendingCommunities) {
			self.isOpenPendingNotification = true;
			self.pendingCommunities = _.map(self.pendingCommunities, function (com) {
				com.isSelected = isSelectedAllPendingCommunities;
				return com;
			})

			if (self.isSelectedAllPendingCommunities) {
				self.selecedPendingCommunities = self.pendingCommunities;
			} else {
				self.selecedPendingCommunities = [];
			}
		}

		function fetchMorePendingCommunitiesList() {
			if (self.isLastPendingPage || self.spinnerPending.isVisible) return;
			var searchParams = $.extend(true, {}, self.searchParamsPending);
			searchParams.page++;
			getPendingCommunitiesList(searchParams);
		}

		function onSelectPendingCommunity(community) {
			self.isOpenPendingNotification = true;
			if (!community.isSelected) {
				self.isSelectedAllPendingCommunities = false;
				self.selecedPendingCommunities = _.reject(self.selecedPendingCommunities, function (com) {
					return community.id === com.id;
				})
			} else {
				self.selecedPendingCommunities.push(community);
			}
		}

		function onCommunityClicked(community, context) {
			self.selectedCommunity = null;
			self.contextCompileTemplate = context;
			self.pendingCommunities = _.map(self.pendingCommunities, function (com) {
				com.selected = false;
				return com;
			})
			self.actionRequiredCommunities = _.map(self.actionRequiredCommunities, function (com) {
				com.selected = false;
				return com;
			})
			$timeout(function () {
				self.selectedCommunity = community;
				community.selected = true;
				if (window.innerWidth < 480) {
					var element = null;
					element = angular.element('<community-detail-compile-template id="communitiesDetailCompileTemplate" append-to-body="true" community="vm.selectedCommunity" on-closed="vm.onCommunityDetailsViewClosed()" context="{{vm.contextCompileTemplate}}" on-status-changed="vm.onCommunityGridChanged(community, vm.contextCompileTemplate)"> </community-detail-compile-template>');
					$("body").append(element);
					$("body").addClass("modal-open");
					$compile(element)($scope);
				} else {
					self.isCommunityDetailsViewOpen = true;
				}
			})
			systemUtils.digest($scope);
		}

		function onCommunityDetailsViewClosed() {
			if (window.innerWidth < 480) {
				$("#communitiesDetailCompileTemplate").remove();
				$("body").removeClass("modal-open");
			} else {
				self.isCommunityDetailsViewOpen = false;
			}
			self.pendingCommunities = _.map(self.pendingCommunities, function (com) {
				com.selected = false;
				return com;
			})
			self.actionRequiredCommunities = _.map(self.actionRequiredCommunities, function (com) {
				com.selected = false;
				return com;
			})
		}

		function onCloseNotification(type) {
			self.isOpenActionRequiredNotification = false;
		}

		function onApproveCommunities(communities) {
			var communitiIds = _.pluck(communities, 'id');
			pixerfApiCommunitySvc.approve_community(null, {
				community_ids: communitiIds
			}).$promise.then(function (res) {
				removeCommunitiesFromList(communitiIds, 'pending');
			}).catch(function (err) {
				console.log(err);
			})
		}

		function removeCommunitiesFromList(communityIds, type) {
			self.pendingCommunities = _.reject(self.pendingCommunities, function (com) {
				return communityIds.includes(com.id);
			})
		}

		function onCommunityGridChanged(community, context) {
			removeCommunitiesFromList(_.pluck(community, "id"), context);
			self.actionRequiredCommunities = self.actionRequiredCommunities.concat(community);
		}

		function sortByProps(propertyName) {
			$scope.reverse = ($scope.propertyName === propertyName) ? !$scope.reverse : false;
			$scope.propertyName = propertyName;
		};

		function onSearchPendingCommunity() {
			if (self.searchPendingCommunityString) {
				self.searchParamsPending.keyword = self.searchPendingCommunityString;
			} else {
				delete self.searchParamsPending.keyword;
			}
			getPendingCommunitiesList(self.searchParamsPending, true);
		}
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('manageJoinedCommunitiesCtrl', manageJoinedCommunitiesCtrl);

	manageJoinedCommunitiesCtrl.$inject = ['$scope', 'createCommunityPopupSvc', 'pixerfApiCommunitySvc', '$state', 'communityConst', 'commonConst'];

	function manageJoinedCommunitiesCtrl($scope, createCommunityPopupSvc, pixerfApiCommunitySvc, $state, communityConst, commonConst) {
		var self = this;
		self.parent = $scope.$parent.vm;
		self.communityConst = communityConst;
		self.isMyProfile = self.parent.isMyProfile;
		self.onCreatedCommunityGridInit = onCreatedCommunityGridInit;
		self.parent.subContextPage = "joined-communities";
		self.user = self.parent.user;
		self.getUserCommunities = getUserCommunities;
		self.onExploreCommunitiesClicked = onExploreCommunitiesClicked;
		self.onCreateCommunityClicked = onCreateCommunityClicked;
		self.communityGridOptions = {
			autoLoadWhenScroll: false,
			isMyProfile: self.parent.isMyProfile,
			user: self.user
		};
		self.createdCommunityGrid = null;
		self.joinedCommunityGrid = null;

		function getUserCommunities() {
			return pixerfApiCommunitySvc.get_user_communities;
		}

		function onCreatedCommunityGridInit(instance) {
			self.createdCommunityGrid = instance;
		}

		function onCreateCommunityClicked() {
			createCommunityPopupSvc.showPopup();
		}

		function onExploreCommunitiesClicked() {
			$state.go(commonConst.STATE.EXPLORE_COMMUNITY);
		}
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('manageInvitedCommunitiesCtrl', manageInvitedCommunitiesCtrl);

	manageInvitedCommunitiesCtrl.$inject = ['$scope', 'communityConst', '$timeout', 'systemUtils', 'pixerfApiCommunitySvc', 'sessionManagerSvc', 'pagingUtils', 'manageCommunitiesSvc', '$compile'];

	function manageInvitedCommunitiesCtrl($scope, communityConst, $timeout, systemUtils, pixerfApiCommunitySvc, sessionManagerSvc, pagingUtils, manageCommunitiesSvc, $compile) {

		var self = this;
		self.loginedUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.communityConst = communityConst;
		self.parent = $scope.$parent.vm;
		self.isMyProfile = self.parent.isMyProfile;
		self.parent.subContextPage = "Invited";
		self.user = self.parent.user;
		self.onSortByChanged = onSortByChanged;
		self.onSelectAllCommunities = onSelectAllCommunities;
		self.onSelectCommunity = onSelectCommunity;
		self.onCloseNotification = onCloseNotification;
		self.onCommunityGridChanged = onCommunityGridChanged;
		self.onSearchCommunity = _.debounce(onSearchCommunity, 800);
		self.fetchMoreCommunitiesList = fetchMoreCommunitiesList;
		self.onReactivateCommunities = onReactivateCommunities;
		self.onCommunitiesListChanged = onCommunitiesListChanged;
		self.onPageSizeCommunitiesChanged = onPageSizeCommunitiesChanged;
		self.selectedCommunities = [];
		self.customPagingOptions = manageCommunitiesSvc.getCustomPagingOptions();
		self.onDeclineCommunities = onDeclineCommunities;
		self.onAcceptCommunities = onAcceptCommunities;
		self.sortNameBy = 'asc';
		self.sortDateBy = 'asc';
		self.spinner = {
			isVisible: false
		};
		self.searchParams = {
			membership: 'invited',
			page: 1,
			page_size: self.customPagingOptions.showValues[0]
		};

		self.sortBy = [{
				value: "inserted_at,desc",
				title: "Date created"
			},
			{
				value: "is_private,desc",
				title: "Privacy"
			},
			{
				value: "member_count,desc",
				title: "Members"
			}
		];

		init();

		function init() {
			self.defaultSortBy = self.sortBy[0].value;
			self.searchParams.sort = self.sortBy[0].value;
			self.communities = [];
			if (!self.isAdmin) {
				self.searchParams.user_id = self.loginedUser.id;
			}
			getCommunitiesList(self.searchParams, true);
		}

		function onSortByChanged(value, type) {
			if (value === 'name') {
				self.sortNameBy = (type === 'asc') ? 'desc' : 'asc';
			}
			if (value === 'membership_inserted_at') {
				self.sortDateBy = (type === 'asc') ? 'desc' : 'asc';
			}
			self.searchParams.sort = value + ',' + type;
			getCommunitiesList(self.searchParams, true);
		}

		function getCommunitiesList(params, isRefresh) {
			if (self.spinner.isVisible) return;
			self.spinner.isVisible = true;
			pixerfApiCommunitySvc.list(self.searchParams).$promise.then(function (response) {
				if (isRefresh) {
					self.communities = response.data;
				} else {
					self.communities = self.communities.concat(response.data);
				}
				self.isLastPage = pagingUtils.isNoMorePageToLoad(params.page, response);
				self.totalPage = pagingUtils.getTotalPage(response);
				self.totalCommunities = pagingUtils.getTotalCount(response);
				self.searchParams.page = params.page;
				self.spinner.isVisible = false;
			}).catch(function (error) {
				console.log(error);
				self.spinner.isVisible = false;
			})
		}

		function onCommunitiesListChanged(data) {
			self.searchParams.page = data.currentPage;
			getCommunitiesList(self.searchParams, true);
		}

		function onPageSizeCommunitiesChanged(pageSize) {
			self.searchParams.page = 1
			self.searchParams.page_size = pageSize;
			getCommunitiesList(self.searchParams, true);
		}

		function fetchMoreCommunitiesList() {
			if (self.isLastPage || self.spinner.isVisible) return;
			var searchParams = $.extend(true, {}, self.searchParams);
			searchParams.page++;
			getCommunitiesList(searchParams);
		}

		function onSelectAllCommunities(isSelectedAllCommunities) {
			self.isOpenNotification = true;
			self.communities = _.map(self.communities, function (com) {
				com.isSelected = isSelectedAllCommunities;
				return com;
			})

			if (self.isSelectedAllCommunities) {
				self.selectedCommunities = self.communities;
			} else {
				self.selectedCommunities = [];
			}
		}

		function onSelectCommunity(community) {
			self.isOpenNotification = true;
			if (!community.isSelected) {
				self.isSelectedAllCommunities = false;
				self.selectedCommunities = _.reject(self.selectedCommunities, function (com) {
					return community.id === com.id;
				})
			} else {
				self.selectedCommunities.push(community);
			}
		}

		function onCloseNotification() {
			self.isOpenNotification = false;
		}

		function removeCommunitiesFromList(communityIds) {
			self.communities = _.reject(self.communities, function (com) {
				return communityIds.includes(com.id);
			})
		}

		function removeCommunityFromList(communityId) {
			self.communities = _.reject(self.communities, function (com) {
				return communityId == com.id;
			})
		}

		function onCommunityGridChanged(community) {
			if (community && community.length) {
				removeCommunitiesFromList(_.pluck(community, "id"));
			} else {
				removeCommunityFromList(community.id);
			}
		}

		function onSearchCommunity() {
			if (self.searchCommunityString) {
				self.searchParams.keyword = self.searchCommunityString;
			} else {
				delete self.searchParams.keyword;
			}
			getCommunitiesList(self.searchParams, true);
		}

		function onReactivateCommunities(communities) {
			var communityIds = _.pluck(communities, "id");
			pixerfApiCommunitySvc.approve_community(null, {
				community_ids: communityIds
			}).$promise.then(function (res) {
				onCommunityGridChanged(res.data);
			}).catch(function (err) {
				console.log(err);
			})
		}

		function onAcceptCommunities(){}

		function onDeclineCommunities(){}
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('manageInreviewCommunitiesCtrl', manageInreviewCommunitiesCtrl);

	manageInreviewCommunitiesCtrl.$inject = ['$scope', 'communityConst', '$timeout', 'systemUtils', 'pixerfApiCommunitySvc', 'sessionManagerSvc', 'pagingUtils', 'manageCommunitiesSvc', '$compile'];

	function manageInreviewCommunitiesCtrl($scope, communityConst, $timeout, systemUtils, pixerfApiCommunitySvc, sessionManagerSvc, pagingUtils, manageCommunitiesSvc, $compile) {

		var USER_CONTROL_ADMINDASHBOARD = ['curator_internal', 'admin_internal', 'marketer_internal'];
		var self = this;
		self.loginedUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.isAdmin = self.loginedUser && (USER_CONTROL_ADMINDASHBOARD.includes(self.loginedUser.role) || self.loginedUser.email === 'marcom@pixerf.com');
		self.communityConst = communityConst;
		self.parent = $scope.$parent.vm;
		self.isMyProfile = self.parent.isMyProfile;
		self.parent.subContextPage = "in-review";
		self.user = self.parent.user;
		self.onSortByChanged = onSortByChanged;
		self.onSelectAllInreviewCommunities = onSelectAllInreviewCommunities;
		self.onSelectInreviewCommunity = onSelectInreviewCommunity;
		self.onCommunityClicked = onCommunityClicked;
		self.onCommunityDetailsViewClosed = onCommunityDetailsViewClosed;
		self.isCommunityDetailsViewOpen = false;
		self.onCloseNotification = onCloseNotification;
		self.onInreviewCommunityGridChanged = onInreviewCommunityGridChanged;
		self.onSearchCommunity = _.debounce(onSearchCommunity, 800);
		self.fetchMoreInreviewCommunitiesList = fetchMoreInreviewCommunitiesList;
		self.onReactivateCommunities = onReactivateCommunities;
		self.onDeactivateCommunities = onDeactivateCommunities;
		self.onInreviewCommunitiesListChanged = onInreviewCommunitiesListChanged;
		self.onPageSizeInreviewCommunitiesChanged = onPageSizeInreviewCommunitiesChanged;
		self.selecedInreviewCommunities = [];
		self.customPagingOptions = manageCommunitiesSvc.getCustomPagingOptions();
		self.spinner = {
			isVisible: false
		};
		self.searchParams = {
			status: 'in_review',
			page: 1,
			page_size: self.customPagingOptions.showValues[0]
		};

		self.sortBy = [{
				value: "inserted_at,desc",
				title: "Date created"
			},
			{
				value: "is_private,desc",
				title: "Privacy"
			},
			{
				value: "member_count,desc",
				title: "Members"
			}
		];

		init();

		function init() {
			self.defaultSortBy = self.sortBy[0].value;
			self.searchParams.sort = self.sortBy[0].value;
			self.inreviewCommunities = [];
			if (!self.isAdmin) {
				self.searchParams.user_id = self.loginedUser.id;
			}
			getInreviewCommunitiesList(self.searchParams, true);
		}

		function onSortByChanged(sortBy) {
			self.searchParams.sort = sortBy.value;
			getInreviewCommunitiesList(self.searchParams, true);
		}

		function getInreviewCommunitiesList(params, isRefresh) {
			if (self.spinner.isVisible) return;
			self.spinner.isVisible = true;
			if (isRefresh) {
				self.totalInReviewCommunities = 0;
				self.totalInReviewPage = 0;
			}
			pixerfApiCommunitySvc.list(params).$promise.then(function (respone) {
				if (isRefresh) {
					self.inreviewCommunities = respone.data;
				} else {
					self.inreviewCommunities = self.inreviewCommunities.concat(respone.data);
				}
				self.isLastPage = pagingUtils.isNoMorePageToLoad(params.page, respone);
				self.totalInReviewPage = pagingUtils.getTotalPage(respone);
				self.totalInReviewCommunities = pagingUtils.getTotalCount(respone);
				self.searchParams.page = params.page;
				self.spinner.isVisible = false;
			}).catch(function (error) {
				console.log(error);
				self.spinner.isVisible = false;
			})
		}

		function onInreviewCommunitiesListChanged(data) {
			self.searchParams.page = data.currentPage;
			getInreviewCommunitiesList(self.searchParams, true);
		}

		function onPageSizeInreviewCommunitiesChanged(pageSize) {
			self.searchParams.page = 1;
			self.searchParams.page_size = pageSize;
			getInreviewCommunitiesList(self.searchParams, true);
		}

		function fetchMoreInreviewCommunitiesList() {
			if (self.isLastPage || self.spinner.isVisible) return;
			var searchParams = $.extend(true, {}, self.searchParams);
			searchParams.page++;
			getInreviewCommunitiesList(searchParams);
		}

		function onSelectAllInreviewCommunities(isSelectedAllInreviewCommunities) {
			self.isOpenNotification = true;
			self.inreviewCommunities = _.map(self.inreviewCommunities, function (com) {
				com.isSelected = isSelectedAllInreviewCommunities;
				return com;
			})

			if (self.isSelectedAllInreviewCommunities) {
				self.selecedInreviewCommunities = self.inreviewCommunities;
			} else {
				self.selecedInreviewCommunities = [];
			}
		}

		function onSelectInreviewCommunity(community) {
			self.isOpenNotification = true;
			if (!community.isSelected) {
				self.isSelectedAllInreviewCommunities = false;
				self.selecedInreviewCommunities = _.reject(self.selecedInreviewCommunities, function (com) {
					return community.id === com.id;
				})
			} else {
				self.selecedInreviewCommunities.push(community);
			}
		}

		function onCommunityClicked(community) {
			self.selectedCommunity = null;
			self.inreviewCommunities = _.map(self.inreviewCommunities, function (com) {
				com.selected = false;
				return com;
			})
			$timeout(function () {
				self.selectedCommunity = community;
				community.selected = true;
				if (window.innerWidth < 480) {
					var element = angular.element('<community-detail-compile-template id="inreviewCommunitiesDetailCompileTemplate" append-to-body="true" community="vm.selectedCommunity" on-closed="vm.onCommunityDetailsViewClosed()" context="in-review" on-status-changed="vm.onInreviewCommunityGridChanged(community)"></community-detail-compile-template>');
					$("body").append(element);
					$("body").addClass("modal-open");
					$compile(element)($scope);
				} else {
					self.isCommunityDetailsViewOpen = true;
				}
			})
			systemUtils.digest($scope);
		}

		function onCommunityDetailsViewClosed() {
			if (window.innerWidth < 480) {
				$("#inreviewCommunitiesDetailCompileTemplate").remove();
				$("body").removeClass("modal-open");
			} else {
				self.isCommunityDetailsViewOpen = false;
			}

			self.inreviewCommunities = _.map(self.inreviewCommunities, function (com) {
				com.selected = false;
				return com;
			})
		}

		function onCloseNotification() {
			self.isOpenNotification = false;
		}

		function removeCommunitiesFromList(communityIds) {
			self.inreviewCommunities = _.reject(self.inreviewCommunities, function (com) {
				return communityIds.includes(com.id);
			})
		}

		function onInreviewCommunityGridChanged(community) {
			removeCommunitiesFromList(_.pluck(community, "id"));
			onCommunityDetailsViewClosed();
		}

		function onSearchCommunity() {
			if (self.searchCommunityString) {
				self.searchParams.keyword = self.searchCommunityString;
			} else {
				delete self.searchParams.keyword;
			}
			getInreviewCommunitiesList(self.searchParams, true);
		}

		function onReactivateCommunities(communities) {
			var communityIds = _.pluck(communities, "id");
			pixerfApiCommunitySvc.approve_community(null, {
				community_ids: communityIds
			}).$promise.then(function (res) {
				onInreviewCommunityGridChanged(res.data);
			}).catch(function (err) {
				console.log(err);
			})
		}

		function onDeactivateCommunities(communities) {
			var communityIds = _.pluck(communities, "id");
			pixerfApiCommunitySvc.deactivate_community(null, {
				community_ids: communityIds
			}).$promise.then(function (res) {
				onInreviewCommunityGridChanged(res.data);
			}).catch(function (err) {
				console.log(err);
			})
		}
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('manageDeactivatedCommunitiesCtrl', manageDeactivatedCommunitiesCtrl);

	manageDeactivatedCommunitiesCtrl.$inject = ['$scope', 'communityConst', '$timeout', 'systemUtils', 'pixerfApiCommunitySvc', 'sessionManagerSvc', 'pagingUtils', 'manageCommunitiesSvc', '$compile'];

	function manageDeactivatedCommunitiesCtrl($scope, communityConst, $timeout, systemUtils, pixerfApiCommunitySvc, sessionManagerSvc, pagingUtils, manageCommunitiesSvc, $compile) {

		var USER_CONTROL_ADMINDASHBOARD = ['curator_internal', 'admin_internal', 'marketer_internal'];
		var self = this;
		self.loginedUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.isAdmin = self.loginedUser && (USER_CONTROL_ADMINDASHBOARD.includes(self.loginedUser.role) || self.loginedUser.email === 'marcom@pixerf.com');
		self.communityConst = communityConst;
		self.parent = $scope.$parent.vm;
		self.isMyProfile = self.parent.isMyProfile;
		self.parent.subContextPage = "deactivated";
		self.user = self.parent.user;
		self.onSortByChanged = onSortByChanged;
		self.onSelectAllDeactivatedCommunities = onSelectAllDeactivatedCommunities;
		self.onSelectDeactivatedCommunity = onSelectDeactivatedCommunity;
		self.onCommunityClicked = onCommunityClicked;
		self.onCommunityDetailsViewClosed = onCommunityDetailsViewClosed;
		self.isCommunityDetailsViewOpen = false;
		self.onCloseNotification = onCloseNotification;
		self.onDeactivatedCommunityGridChanged = onDeactivatedCommunityGridChanged;
		self.onSearchCommunity = _.debounce(onSearchCommunity, 800);
		self.fetchMoreDeactivatedCommunitiesList = fetchMoreDeactivatedCommunitiesList;
		self.onReactivateCommunities = onReactivateCommunities;
		self.onDeactivatedCommunitiesListChanged = onDeactivatedCommunitiesListChanged;
		self.onPageSizeDeactivatedCommunitiesChanged = onPageSizeDeactivatedCommunitiesChanged;
		self.selecedDeactivatedCommunities = [];
		self.customPagingOptions = manageCommunitiesSvc.getCustomPagingOptions();
		self.spinner = {
			isVisible: false
		};
		self.searchParams = {
			status: 'deactivated',
			page: 1,
			page_size: self.customPagingOptions.showValues[0]
		};

		self.sortBy = [{
				value: "inserted_at,desc",
				title: "Date created"
			},
			{
				value: "is_private,desc",
				title: "Privacy"
			},
			{
				value: "member_count,desc",
				title: "Members"
			}
		];

		init();

		function init() {
			self.defaultSortBy = self.sortBy[0].value;
			self.searchParams.sort = self.sortBy[0].value;
			self.deactivatedCommunities = [];
			if (!self.isAdmin) {
				self.searchParams.user_id = self.loginedUser.id;
			}
			getDeactivatedCommunitiesList(self.searchParams, true);
		}

		function onSortByChanged(sortBy) {
			self.searchParams.sort = sortBy.value;
			getDeactivatedCommunitiesList(self.searchParams, true);
		}

		function getDeactivatedCommunitiesList(params, isRefresh) {
			if (self.spinner.isVisible) return;
			self.spinner.isVisible = true;
			if (isRefresh) {
				self.totalInReviewCommunities = 0;
				self.totalInReviewPage = 0;
			}
			pixerfApiCommunitySvc.list(params).$promise.then(function (respone) {
				if (isRefresh) {
					self.deactivatedCommunities = respone.data;
				} else {
					self.deactivatedCommunities = self.deactivatedCommunities.concat(respone.data);
				}
				self.isLastPage = pagingUtils.isNoMorePageToLoad(params.page, respone);
				self.totalDeactivatedPage = pagingUtils.getTotalPage(respone);
				self.totalDeactivatedCommunities = pagingUtils.getTotalCount(respone);
				self.searchParams.page = params.page;
				self.spinner.isVisible = false;
			}).catch(function (error) {
				console.log(error);
				self.spinner.isVisible = false;
			})
		}

		function onDeactivatedCommunitiesListChanged(data) {
			self.searchParams.page = data.currentPage;
			getDeactivatedCommunitiesList(self.searchParams, true);
		}

		function onPageSizeDeactivatedCommunitiesChanged(pageSize) {
			self.searchParams.page = 1
			self.searchParams.page_size = pageSize;
			getDeactivatedCommunitiesList(self.searchParams, true);
		}

		function fetchMoreDeactivatedCommunitiesList() {
			if (self.isLastPage || self.spinner.isVisible) return;
			var searchParams = $.extend(true, {}, self.searchParams);
			searchParams.page++;
			getDeactivatedCommunitiesList(searchParams);
		}

		function onSelectAllDeactivatedCommunities(isSelectedAllDeactivatedCommunities) {
			self.isOpenNotification = true;
			self.deactivatedCommunities = _.map(self.deactivatedCommunities, function (com) {
				com.isSelected = isSelectedAllDeactivatedCommunities;
				return com;
			})

			if (self.isSelectedAllDeactivatedCommunities) {
				self.selecedDeactivatedCommunities = self.deactivatedCommunities;
			} else {
				self.selecedDeactivatedCommunities = [];
			}
		}

		function onSelectDeactivatedCommunity(community) {
			self.isOpenNotification = true;
			if (!community.isSelected) {
				self.isSelectedAllDeactivatedCommunities = false;
				self.selecedDeactivatedCommunities = _.reject(self.selecedDeactivatedCommunities, function (com) {
					return community.id === com.id;
				})
			} else {
				self.selecedDeactivatedCommunities.push(community);
			}
		}

		function onCommunityClicked(community) {
			self.selectedCommunity = null;
			self.deactivatedCommunities = _.map(self.deactivatedCommunities, function (com) {
				com.selected = false;
				return com;
			})
			$timeout(function () {
				self.selectedCommunity = community;
				community.selected = true;
				if (window.innerWidth < 480) {
					var element = angular.element('<community-detail-compile-template id="deactivatedCommunitiesDetailCompileTemplate" append-to-body="true" community="vm.selectedCommunity" on-closed="vm.onCommunityDetailsViewClosed()" context="deactivate" on-status-changed="vm.onDeactivatedCommunityGridChanged(community)"></community-detail-compile-template>');
					$("body").append(element);
					$("body").addClass("modal-open");
					$compile(element)($scope);
				} else {
					self.isCommunityDetailsViewOpen = true;
				}
			})
			systemUtils.digest($scope);
		}

		function onCommunityDetailsViewClosed() {
			if (window.innerWidth < 480) {
				$("#deactivatedCommunitiesDetailCompileTemplate").remove();
				$("body").removeClass("modal-open");
			} else {
				self.isCommunityDetailsViewOpen = false;
			}

			self.deactivatedCommunities = _.map(self.deactivatedCommunities, function (com) {
				com.selected = false;
				return com;
			})
		}

		function onCloseNotification() {
			self.isOpenNotification = false;
		}

		function removeCommunitiesFromList(communityIds) {
			self.deactivatedCommunities = _.reject(self.deactivatedCommunities, function (com) {
				return communityIds.includes(com.id);
			})
		}

		function onDeactivatedCommunityGridChanged(community) {
			removeCommunitiesFromList(_.pluck(community, "id"));
			onCommunityDetailsViewClosed();
		}

		function onSearchCommunity() {
			if (self.searchCommunityString) {
				self.searchParams.keyword = self.searchCommunityString;
			} else {
				delete self.searchParams.keyword;
			}
			getDeactivatedCommunitiesList(self.searchParams, true);
		}

		function onReactivateCommunities(communities) {
			var communityIds = _.pluck(communities, "id");
			pixerfApiCommunitySvc.approve_community(null, {
				community_ids: communityIds
			}).$promise.then(function (res) {
				onDeactivatedCommunityGridChanged(res.data);
			}).catch(function (err) {
				console.log(err);
			})
		}
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('manageActiveCommunitiesCtrl', manageActiveCommunitiesCtrl);

	manageActiveCommunitiesCtrl.$inject = ['$scope', 'communityConst', '$timeout', 'systemUtils', 'pixerfApiCommunitySvc', 'pagingUtils', 'sessionManagerSvc', 'manageCommunitiesSvc', '$compile'];

	function manageActiveCommunitiesCtrl($scope, communityConst, $timeout, systemUtils, pixerfApiCommunitySvc, pagingUtils, sessionManagerSvc, manageCommunitiesSvc, $compile) {

		var USER_CONTROL_ADMINDASHBOARD = ['curator_internal', 'admin_internal', 'marketer_internal'];
		var self = this;
		self.loginedUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.isAdmin = self.loginedUser && (USER_CONTROL_ADMINDASHBOARD.includes(self.loginedUser.role) || self.loginedUser.email === 'marcom@pixerf.com');
		self.communityConst = communityConst;
		self.parent = $scope.$parent.vm;
		self.isMyProfile = self.parent.isMyProfile;
		self.parent.subContextPage = "active";
		self.user = self.parent.user;
		self.onSortByChanged = onSortByChanged;
		self.onSelectAllActiveCommunities = onSelectAllActiveCommunities;
		self.onSelectActiveCommunity = onSelectActiveCommunity;
		self.onCommunityClicked = onCommunityClicked;
		self.onCommunityDetailsViewClosed = onCommunityDetailsViewClosed;
		self.onCloseNotification = onCloseNotification;
		self.onActiveCommunityGridChanged = onActiveCommunityGridChanged;
		self.fetchMoreActivateCommunitiesList = fetchMoreActivateCommunitiesList;
		self.sortByProps = sortByProps;
		self.onMoveInReviewCommunities = onMoveInReviewCommunities;
		self.onDeactiveCommunities = onDeactiveCommunities;
		self.onSearchCommunity = _.debounce(onSearchCommunity, 800);
		self.onActiveCommunitiesListChanged = onActiveCommunitiesListChanged;
		self.onPageSizeActiveCommunitiesChanged = onPageSizeActiveCommunitiesChanged;
		self.isCommunityDetailsViewOpen = false;
		self.selecedActiveCommunities = [];
		self.customPagingOptions = manageCommunitiesSvc.getCustomPagingOptions();
		self.spinner = {
			isVisible: false
		};
		self.searchParams = {
			status: 'active',
			page: 1,
			page_size: self.customPagingOptions.showValues[0]
		};

		self.sortBy = [{
				value: "inserted_at,desc",
				title: "Date created"
			},
			{
				value: "is_private,desc",
				title: "Privacy"
			},
			{
				value: "member_count,desc",
				title: "Members"
			}
		];

		init();

		function init() {
			self.defaultSortBy = self.sortBy[0].value;
			self.searchParams.sort = self.sortBy[0].value;
			self.activeCommunities = [];
			if (!self.isAdmin) {
				self.searchParams.user_id = self.loginedUser.id;
			}
			getActiveCommunitiesList(self.searchParams, true);
		}

		function onSortByChanged(sortBy) {
			self.searchParams.sort = sortBy.value;
			getActiveCommunitiesList(self.searchParams, true);
		}

		function getActiveCommunitiesList(params, isRefresh) {
			if (self.spinner.isVisible) return;
			self.spinner.isVisible = true;
			if (isRefresh) {
				self.totalActiveCommunities = 0;
				self.totalActivePage = 0;
			}
			pixerfApiCommunitySvc.list(params).$promise.then(function (respone) {
				if (isRefresh) {
					self.activeCommunities = respone.data;
				} else {
					self.activeCommunities = self.activeCommunities.concat(respone.data);
				}
				self.isLastPage = pagingUtils.isNoMorePageToLoad(params.page, respone);
				self.totalActivePage = pagingUtils.getTotalPage(respone);
				self.totalActiveCommunities = pagingUtils.getTotalCount(respone);
				self.searchParams.page = params.page;
				self.spinner.isVisible = false;
			}).catch(function (error) {
				console.log(error);
				self.spinner.isVisible = false;
			})
		}

		function onActiveCommunitiesListChanged(data) {
			self.searchParams.page = data.currentPage;
			getActiveCommunitiesList(self.searchParams, true);
		}

		function onPageSizeActiveCommunitiesChanged(pageSize) {
			self.searchParams.page = 1;
			self.searchParams.page_size = pageSize;
			getActiveCommunitiesList(self.searchParams, true);
		}

		function fetchMoreActivateCommunitiesList() {
			if (self.isLastPage || self.spinner.isVisible) return;
			var searchParams = $.extend(true, {}, self.searchParams);
			searchParams.page++;
			getActiveCommunitiesList(searchParams);
		}

		function onSelectAllActiveCommunities(isSelectedAllActiveCommunities) {
			self.isOpenNotification = true;
			self.activeCommunities = _.map(self.activeCommunities, function (com) {
				com.isSelected = isSelectedAllActiveCommunities;
				return com;
			})

			if (self.isSelectedAllActiveCommunities) {
				self.selecedActiveCommunities = self.activeCommunities;
			} else {
				self.selecedActiveCommunities = [];
			}
		}

		function onSelectActiveCommunity(community) {
			self.isOpenNotification = true;
			if (!community.isSelected) {
				self.isSelectedAllActiveCommunities = false;
				self.selecedActiveCommunities = _.reject(self.selecedActiveCommunities, function (com) {
					return community.id === com.id;
				})
			} else {
				self.selecedActiveCommunities.push(community);
			}
		}

		function onCommunityClicked(community, context) {
			self.selectedCommunity = null;
			self.contextCompileTemplate = context;
			self.activeCommunities = _.map(self.activeCommunities, function (com) {
				com.selected = false;
				return com;
			})
			$timeout(function () {
				self.selectedCommunity = community;
				community.selected = true;
				if (window.innerWidth < 480) {
					var element = angular.element('<community-detail-compile-template id="activeCommunitiesDetailCompileTemplate" append-to-body="true" community="vm.selectedCommunity" on-closed="vm.onCommunityDetailsViewClosed()" context="{{vm.contextCompileTemplate}}" on-status-changed="vm.onActiveCommunityGridChanged(community)"> </community-detail-compile-template>');
					$("body").append(element);
					$("body").addClass("modal-open");
					$compile(element)($scope);
				} else {
					self.isCommunityDetailsViewOpen = true;
				}
			})
			systemUtils.digest($scope);
		}

		function onCommunityDetailsViewClosed() {
			if (window.innerWidth < 480) {
				$("#activeCommunitiesDetailCompileTemplate").remove();
				$("body").removeClass("modal-open");
			} else {
				self.isCommunityDetailsViewOpen = false;
			}

			self.activeCommunities = _.map(self.activeCommunities, function (com) {
				com.selected = false;
				return com;
			})
		}

		function onCloseNotification() {
			self.isOpenNotification = false;
		}

		function removeCommunitiesFromList(communityIds) {
			self.activeCommunities = _.reject(self.activeCommunities, function (com) {
				return communityIds.includes(com.id);
			})
		}

		function onActiveCommunityGridChanged(community) {
			removeCommunitiesFromList(_.pluck(community, "id"));
			onCommunityDetailsViewClosed();
		}

		function sortByProps(propertyName) {
			$scope.reverse = ($scope.propertyName === propertyName) ? !$scope.reverse : false;
			$scope.propertyName = propertyName;
		};

		function onSearchCommunity() {
			if (self.searchCommunityString) {
				self.searchParams.keyword = self.searchCommunityString;
			} else {
				delete self.searchParams.keyword;
			}
			getActiveCommunitiesList(self.searchParams, true);
		}

		function onMoveInReviewCommunities(communities) {
			var communityIds = _.pluck(communities, "id");
			pixerfApiCommunitySvc.move_to_in_review(null, {
				community_ids: communityIds
			}).$promise.then(function (res) {
				onActiveCommunityGridChanged(res.data);
			}).catch(function (err) {
				console.log(err);
			})
		}

		function onDeactiveCommunities(communities) {
			var communityIds = _.pluck(communities, "id");
			pixerfApiCommunitySvc.deactivate_community(null, {
				community_ids: communityIds
			}).$promise.then(function (res) {
				onActiveCommunityGridChanged(res.data);
			}).catch(function (err) {
				console.log(err);
			})
		}
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('manageActionRequiredCommunitiesCtrl', manageActionRequiredCommunitiesCtrl);

	manageActionRequiredCommunitiesCtrl.$inject = ['$scope', 'communityConst', '$timeout', 'systemUtils', 'pixerfApiCommunitySvc', 'manageCommunitiesSvc', 'pagingUtils', 'sessionManagerSvc', '$compile'];

	function manageActionRequiredCommunitiesCtrl($scope, communityConst, $timeout, systemUtils, pixerfApiCommunitySvc, manageCommunitiesSvc, pagingUtils, sessionManagerSvc, $compile) {

		var self = this;
		self.loginedUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.communityConst = communityConst;
		self.parent = $scope.$parent.vm;
		self.isMyProfile = self.parent.isMyProfile;
		self.parent.subContextPage = "action-required";
		self.user = self.parent.user;
		self.onSortByActionRequiredChanged = onSortByActionRequiredChanged;
		self.onSelectActionRequiredCommunity = onSelectActionRequiredCommunity;
		self.onSelectAllActionRequiredCommunities = onSelectAllActionRequiredCommunities;
		self.onCommunityClicked = onCommunityClicked;
		self.onCommunityDetailsViewClosed = onCommunityDetailsViewClosed;
		self.isCommunityDetailsViewOpen = false;
		self.onCloseNotification = onCloseNotification;
		self.fetchMoreActionRequiredCommunitiesList = fetchMoreActionRequiredCommunitiesList;
		self.onActionRequiredCommunitiesListChanged = onActionRequiredCommunitiesListChanged;
		self.onPageSizeActionRequiredCommunitiesChanged = onPageSizeActionRequiredCommunitiesChanged;
		self.selecedActionRequiredCommunities = [];
		self.sortByProps = sortByProps;
		self.onSearchActionRequiredCommunity = _.debounce(onSearchActionRequiredCommunity, 800);
		self.customPagingOptions = manageCommunitiesSvc.getCustomPagingOptions();
		self.spinnerActionRequired = {
			isVisible: false
		};
		self.searchParamsActionRequired = {
			status: 'approve_required',
			page: 1,
			page_size: self.customPagingOptions.showValues[0]
		};
		self.sortByActionRequired = [{
				value: "inserted_at,desc",
				title: "Date created"
			},
			{
				value: "is_private,desc",
				title: "Privacy"
			}
		];

		init();

		function init() {
			self.defaultSortByActionRequired = self.sortByActionRequired[0].value;
			self.searchParamsActionRequired.sort = self.sortByActionRequired[0].value;
			self.actionRequiredCommunities = [];
			getActionRequiredCommunitiesList(self.searchParamsActionRequired, true);
		}

		function onSortByActionRequiredChanged(sortBy) {
			self.searchParamsActionRequired.sort = sortBy.value;
			getActionRequiredCommunitiesList(self.searchParamsActionRequired, true);
		}

		function getActionRequiredCommunitiesList(params, isRefresh) {
			if (self.spinnerActionRequired.isVisible) return;
			self.spinnerActionRequired.isVisible = true;
			if (isRefresh) {
				self.totalActiveCommunities = 0;
				self.totalActivePage = 0;
			}
			pixerfApiCommunitySvc.list(params).$promise.then(function (respone) {
				if (isRefresh) {
					self.actionRequiredCommunities = respone.data;
				} else {
					self.actionRequiredCommunities = self.actionRequiredCommunities.concat(respone.data);
				}
				self.isLastActionRequiredPage = pagingUtils.isNoMorePageToLoad(params.page, respone);
				self.totalActionRequiredPage = pagingUtils.getTotalPage(respone);
				self.totalActionRequiredCommunities = pagingUtils.getTotalCount(respone);
				self.searchParamsActionRequired.page = params.page;
				self.spinnerActionRequired.isVisible = false;
			}).catch(function (error) {
				console.log(error);
				self.spinnerActionRequired.isVisible = false;
			})
		}

		function onActionRequiredCommunitiesListChanged(data) {
			self.searchParamsActionRequired.page = data.currentPage;
			getActionRequiredCommunitiesList(self.searchParamsActionRequired, true);
		}

		function onPageSizeActionRequiredCommunitiesChanged(pageSize) {
			self.searchParamsActionRequired.page = 1;
			self.searchParamsActionRequired.page_size = pageSize;
			getActionRequiredCommunitiesList(self.searchParamsActionRequired, true);
		}

		function fetchMoreActionRequiredCommunitiesList() {
			if (self.isLastActionRequiredPage || self.spinnerActionRequired.isVisible) return;
			var searchParams = $.extend(true, {}, self.searchParamsActionRequired);
			searchParams.page++;
			getActionRequiredCommunitiesList(searchParams);
		}

		function onSelectAllActionRequiredCommunities(isSelectedAllActionRequiredCommunities) {
			self.isOpenActionRequiredNotification = true;
			self.actionRequiredCommunities = _.map(self.actionRequiredCommunities, function (com) {
				com.isSelected = isSelectedAllActionRequiredCommunities;
				return com;
			})

			if (self.isSelectedAllActionRequiredCommunities) {
				self.selecedActionRequiredCommunities = self.actionRequiredCommunities;
			} else {
				self.selecedActionRequiredCommunities = [];
			}
		}

		function onSelectActionRequiredCommunity(community) {
			self.isOpenActionRequiredNotification = true;
			if (!community.isSelected) {
				self.isSelectedAllActionRequiredCommunities = false;
				self.selecedActionRequiredCommunities = _.reject(self.selecedActionRequiredCommunities, function (com) {
					return community.id === com.id;
				})
			} else {
				self.selecedActionRequiredCommunities.push(community);
			}
		}

		function onCommunityClicked(community, context) {
			self.selectedCommunity = null;
			self.contextCompileTemplate = context;
			self.actionRequiredCommunities = _.map(self.actionRequiredCommunities, function (com) {
				com.selected = false;
				return com;
			})
			$timeout(function () {
				self.selectedCommunity = community;
				community.selected = true;
				if (window.innerWidth < 480) {
					var element = null;
					element = angular.element('<community-detail-compile-template id="communitiesDetailCompileTemplate" append-to-body="true" community="vm.selectedCommunity" on-closed="vm.onCommunityDetailsViewClosed()" context="{{vm.contextCompileTemplate}}" on-status-changed="vm.onCommunityGridChanged(community, vm.contextCompileTemplate)"> </community-detail-compile-template>');
					$("body").append(element);
					$("body").addClass("modal-open");
					$compile(element)($scope);
				} else {
					self.isCommunityDetailsViewOpen = true;
				}
			})
			systemUtils.digest($scope);
		}

		function onCommunityDetailsViewClosed() {
			if (window.innerWidth < 480) {
				$("#communitiesDetailCompileTemplate").remove();
				$("body").removeClass("modal-open");
			} else {
				self.isCommunityDetailsViewOpen = false;
			}
			self.actionRequiredCommunities = _.map(self.actionRequiredCommunities, function (com) {
				com.selected = false;
				return com;
			})
		}

		function onCloseNotification(type) {
            self.isOpenActionRequiredNotification = false;
		}

		function sortByProps(propertyName, isActtionRequiredTable) {
			if (isActtionRequiredTable) {
				$scope.reverseActionRequired = ($scope.propertyActionRequiredName === propertyName) ? !$scope.reverseActionRequired : false;
				$scope.propertyActionRequiredName = propertyName;
			} else {
				$scope.reverse = ($scope.propertyName === propertyName) ? !$scope.reverse : false;
				$scope.propertyName = propertyName;
			}
		};

		function onSearchActionRequiredCommunity() {
			if (self.searchActionRequiredCommunityString) {
				self.searchParamsActionRequired.keyword = self.searchActionRequiredCommunityString;
			} else {
				delete self.searchParamsActionRequired.keyword;
			}
			getActionRequiredCommunitiesList(self.searchParamsActionRequired, true);
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('payoutMethodCtrl', payoutMethodCtrl);

	payoutMethodCtrl.$inject = ['$scope', '$q', 'pixerfConfirmPopupSvc', 'addPayoutMethodPopupSvc', 'toastr', 'pixerfApiPayoutMethodSvc', 'registerBankInfoPopupSvc', '$timeout', 'systemUtils', 'translationSvc'];

	function payoutMethodCtrl($scope, $q, pixerfConfirmPopupSvc, addPayoutMethodPopupSvc, toastr, pixerfApiPayoutMethodSvc, registerBankInfoPopupSvc, $timeout, systemUtils, translationSvc) {

		var self = this;
		$scope.$parent.vm.subContextPage = "payout-method";
		self.addPaymentMethod = addPaymentMethod;
		self.onPaymentMethodClicked = onPaymentMethodClicked;
		self.onRemovePaymentMethodClicked = onRemovePaymentMethodClicked;
		self.onEditPaymentMethodClicked = onEditPaymentMethodClicked;
		self.paypalInfo = {};
		self.today = moment().format('DD MMMM YYYY');
		self.isWorking = false;

		init();

		function init() {
			fetchPayoutMethods();
		}

		function fetchPayoutMethods() {
			pixerfApiPayoutMethodSvc.query().$promise.then(function (response) {
				self.payoutMethods = response;
				if (self.payoutMethods && self.payoutMethods.length > 0) {
					var preferreMethod = _.find(self.payoutMethods, function (p) {
						return p.is_default;
					});
					if (preferreMethod) {
						self.selectedPaymentMethod = preferreMethod;
					}

				}
			}, function (error) {
				toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
			})
		}

		function selectPaymentMethod(paymentMethod) {
			if (self.selectedPaymentMethod) {
				self.selectedPaymentMethod.is_default = false;
			}
			paymentMethod.is_default = true;
			self.selectedPaymentMethod = paymentMethod;
		}

		function onPaymentMethodClicked(paymentMethod) {
			saveDefaultPayoutMethod(paymentMethod);
		}

		function onRemovePaymentMethodClicked(payoutMethod) {
			pixerfConfirmPopupSvc.showPopup({
				okFn: function () {
					if (self.isWorking) return;
					self.isWorking = true;
					var def = $q.defer();
					pixerfApiPayoutMethodSvc.delete({
						id: payoutMethod.id
					}).$promise.then(function () {
						if (self.selectedPaymentMethod && self.selectedPaymentMethod.id === payoutMethod.id) {
							self.selectedPaymentMethod = null;
						}
						self.isWorking = false;
						self.payoutMethods = _.reject(self.payoutMethods, function (item) {
							return item.id === payoutMethod.id;
						});
						toastr.success(payoutMethod.name + " is removed from your payout method(s).");
						def.resolve();
					}, function (err) {
						self.isWorking = false;
						var errMsg = translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true);
						toastr.error(errMsg);
						def.reject(err);
					});
					return def.promise;
				},
				message: 'This payout method will be removed.',
				hideTitle: true
			})

		}

		function addPaymentMethod() {
			var addPayoutMethodPopup = addPayoutMethodPopupSvc.showPopup({
				isSetAsDefault: !self.selectedPaymentMethod
			});
			addPayoutMethodPopup.result.then(function (addedPayoutMethod) {
				if (!addedPayoutMethod) return;
				self.payoutMethods.push(addedPayoutMethod);
				if (!self.selectedPaymentMethod) {
					self.selectedPaymentMethod = addedPayoutMethod;
				}
			})
		}

		function onEditPaymentMethodClicked(paymentMethod) {
			var editingPaymentMethod = systemUtils.clone(systemUtils.exportAngularObject(paymentMethod));
			registerBankInfoPopupSvc.showPoup({
				bankInfo: editingPaymentMethod.details,
				onSaveHandler: function (bankInfo) {
					var def = $q.defer();
					editingPaymentMethod.details = bankInfo;
					addPayoutMethodPopupSvc.savePaymentMethod(editingPaymentMethod).then(function () {
						toastr.success(paymentMethod.name + " details has been successfully updated.");
						$timeout(function () {
							paymentMethod.details = editingPaymentMethod.details;
							registerBankInfoPopupSvc.closePopup();
							def.resolve();
						}, 1000);
					}, function () {
						def.reject();
						toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
					});
					return def.promise;
				}
			});
		}

		function saveDefaultPayoutMethod(payoutMethod) {
			var def = $q.defer();
			if (self.isWorking) def.resolve();

			self.isWorking = true;
			pixerfApiPayoutMethodSvc.put({
				id: payoutMethod.id,
				is_default: true
			}).$promise.then(function () {
				self.isWorking = false;
				selectPaymentMethod(payoutMethod);
				def.resolve();
				toastr.success(payoutMethod.name + " has been successfully set as your preferred payout method.");
			}, function () {
				self.isWorking = false;
				payoutMethod.is_default = false;
				toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
				def.reject();
			});
			return def.promise;
		}

	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('transactionHistoryCtrl', transactionHistoryCtrl);

	transactionHistoryCtrl.$inject = ['$scope', 'pixerfApiPayoutMethodSvc', 'toastr', 'pagingUtils', '$translate', 'translationSvc', 'purchaseHistorySvc'];

	function transactionHistoryCtrl($scope, pixerfApiPayoutMethodSvc, toastr, pagingUtils, $translate, translationSvc, purchaseHistorySvc) {

		var self = this;
		$scope.$parent.vm.subContextPage = "transaction-history";
		self.spinner = {
			isVisible: false
		};
		self.selectedFilter = {
			fromDate: '',
			toDate: '',
		};
		self.searchParams = {
			page: 1
		};

		self.statusToolTips = {
			'processing': $translate.instant("processing-payout-explain"),
			'rejected': $translate.instant("rejected-payout-explain"),
			'completed': $translate.instant("completed-payout-explain"),
		};

		$scope.$watch('vm.selectedFilter', function () {
			onSearchFilterClick(self.selectedFilter, 'DURATION');
		}, true)

		init();

		function onSearchFilterClick(filter, type) {
			if (filter) {
				filter.type = type;
				var timeRange = purchaseHistorySvc.getTimeRange(filter);
				if (timeRange) {
					self.searchParams.start_date = timeRange.start_date;
					self.searchParams.end_date = timeRange.end_date;
				}
			}
			fetchPurchasedItems(self.searchParams, true);
		}

		function init() {
			onSearchFilterClick(self.selectedFilter, 'MOST_RECENT');
			// fetchPurchasedItems(self.searchParams, true);
		}

		function fetchPurchasedItems(searchParams, isFresh) {
			self.spinner.isVisible = true;
			if (isFresh) self.items = [];
			pixerfApiPayoutMethodSvc.getTransactionHistory(searchParams).$promise.then(function (response) {
				if (searchParams.page === 1) self.items = [];
				self.spinner.isVisible = false;
				if (response && response.data && response.data.length > 0) {
					self.items = self.items.concat(response.data);
				}
				self.isLastPage = pagingUtils.isNoMorePageToLoad(searchParams.page, response);

			}, function () {
				self.spinner.isVisible = false;
				toastr.error(translationSvc.FAILED_TO_DO_SOMETHING('FAILED_ORDER_LIST', true));
			})
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('photosSoldCtrl', photosSoldCtrl);

	photosSoldCtrl.$inject = ['$scope'];

	function photosSoldCtrl($scope) {
		var self = this;

		$scope.$parent.vm.subContextPage = "photos-sold";
	}
})();

(function () {
	'use strict';

	angular
	.module('pixerf')
	.config(routerDefaultConfig)
	.config(routerConfig);

	routerDefaultConfig.$inject = ['$urlRouterProvider'];

	function routerDefaultConfig($urlRouterProvider) {
		'ngInject';
	}

	routerConfig.$inject = ['$stateProvider'];

	function routerConfig($stateProvider) {
	  'ngInject';
	  $stateProvider
		.state('setting.earnings.photos_sold', {
			url: '/photos-sold',
			templateUrl: 'app/components/earnings/photos-sold/photos-sold.html',
			controller: 'photosSoldCtrl',
			controllerAs: 'vm',
			data: {
			  pageTitle: "PIXERF - Photos Sold",
			}
		})
		.state('setting.earnings.photos_sold.sold-list', {
			url: '/sold-list',
			templateUrl: 'app/components/earnings/photos-sold/sold-list/sold-list.html',
			controller: 'soldListCtrl',
			controllerAs: 'vm',
			data: {
				pageTitle: "PIXERF - Sold History"
			}
		})
		.state('setting.earnings.photos_sold.sold-details', {
			url: '/sold-details/:orderId',
			templateUrl: 'app/components/earnings/photos-sold/sold-details/sold-details.html',
			controller: 'soldDetailsCtrl',
			controllerAs: 'vm',
			data: {
				pageTitle: "PIXERF - Sold Details"
			}
		});
	}
  })();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .factory('photoSoldSvc', photoSoldSvc);

     photoSoldSvc.$inject = ['dateUtils'];

    function photoSoldSvc(dateUtils) {

		var mFilters = {
			fromMonth: '',
			fromYear: '',
			toMonth: '',
			toYear: '',
		};
		var mItems = [];
		var mTotalMedia = 0;
		var mSearchParams = {
			page: 1,
			start_date: null,
			end_date: null
		};

		function getFilters(){
            return mFilters;
        }

		function setFilters(filters){
			mFilters = filters;
		}

		function getItems(){
            return mItems;
        }

		function setItems(items){
			mItems = items;
		}

		function getSearchParams(){
			return mSearchParams;
		}

		function setTotalMedia(totalMedia){
			mTotalMedia = totalMedia;
		}

		function getTotalMedia(){
			return mTotalMedia;
		}

		function setSearchParams(searchParams){
			mSearchParams = searchParams;
		}

        function getTimeRange(filter){
			var timeRange = {
				start_date: null,
				end_date: null
			};

			if (filter.type === "MOST_RECENT") {
				timeRange = null;
			} else if (filter.type === "DURATION") {
				if ((!filter.fromMonth || filter.fromMonth.value === 'all') && filter.fromYear && filter.fromYear.value != 'all') {
					timeRange.start_date = dateUtils.getStartOfYear(filter.fromYear.value);
				} else {
					timeRange.start_date = dateUtils.getMonthDateRange(filter.fromMonth.value, filter.fromYear.value).start;
				}
				if ((!filter.toMonth || filter.toMonth.value === 'all') && filter.toYear && filter.toYear.value != 'all') {
					timeRange.end_date = dateUtils.getEndOfYear(filter.toYear.value);
				} else {
					timeRange.end_date = dateUtils.getMonthDateRange(filter.toMonth.value, filter.toYear.value).end;
				}
			}

			return timeRange;
		}

		function buildMonthFilters() {
			var monthlyFilters = [{ "name": "All", "value": "all" }, { "name": "January", "value": 1 }, { "name": "February", "value": 2 }, { "name": "March", "value": 3 }, { "name": "April", "value": 4 }, { "name": "May", "value": 5 }, { "name": "June", "value": 6 }, { "name": "July", "value": 7 }, { "name": "August", "value": 8 }, { "name": "September", "value": 9 }, { "name": "October", "value": 10 }, { "name": "November", "value": 11 }, { "name": "December", "value": 12 }];

			return monthlyFilters;
		}

		function buildYearFilters() {
			var recentYears = dateUtils.getRecentYears(3);
			var yearlyFilters = [];
			yearlyFilters.push({ "name": "All", "value": "all" });
			for (var i = 0; i < recentYears.length; i++) {
				yearlyFilters.push({
					name: recentYears[i],
					value: recentYears[i]
				})
			}

			return yearlyFilters;
		}

        return {
		   getFilters: getFilters,
		   setFilters: setFilters,
		   getItems: getItems,
		   setItems: setItems,
		   getSearchParams: getSearchParams,
		   setSearchParams: setSearchParams,
		   setTotalMedia: setTotalMedia,
		   getTotalMedia: getTotalMedia,
		   getTimeRange: getTimeRange,
		   buildMonthFilters: buildMonthFilters,
		   buildYearFilters: buildYearFilters
        };
    }
})();
(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('myEarningCtrl', myEarningCtrl);

	myEarningCtrl.$inject = ['$scope', 'sessionManagerSvc', 'accountConst', "$translate", "$rootScope", "earningsSvc", "pixerfApiMediaSvc", "photoDetailPopupSvc", "earningsPopupPopupSvc", 'uploadPhotoSvc'];

	function myEarningCtrl($scope, sessionManagerSvc, accountConst, $translate, $rootScope, earningsSvc, pixerfApiMediaSvc, photoDetailPopupSvc, earningsPopupPopupSvc, uploadPhotoSvc) {

		var self = this;
		$scope.$parent.vm.subContextPage = "my-earnings";
		self.loginnedUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.today = moment().format('DD MMM YYYY');
		self.earningCommissionText = "";
		self.onPayoutRequested = onPayoutRequested;
		self.onToggleDetailsEarning = onToggleDetailsEarning;
		self.isOpenDetailsEarning = false;
		self.onPhotoCLick = onPhotoCLick;
		self.onEaningsClicked = onEaningsClicked;

		init();

		$rootScope.$on('$translateChangeSuccess', function (event, current) {
			if (event.currentScope.$state.current.controller === 'myEarningImagesSoldCtrl') {
				buildEarningCommisionText();
			}
		});

		function init() {
			buildEarningCommisionText();
			genEarnedMoney();
		}
		function showUploadModal() {
			uploadPhotoSvc.showUploadModal();
        }

		function onEaningsClicked(){
			earningsPopupPopupSvc.showPopup({onShowUploadModal: showUploadModal});
		}

		function buildEarningCommisionText() {
			var commissionRate = accountConst.COMMISSION_RATE[self.loginnedUser.ambassadorship ? "AMBASSADOR_" + self.loginnedUser.ambassadorship.toUpperCase() : "PIXERFER"];
			console.log($scope.earnings);
			self.earningCommissionText = $translate.instant('my-earnings-description', {
				'percent': commissionRate
			});
		}

		function onPayoutRequested(earnings) {
			$scope.earnings = earnings;
		}

		function onToggleDetailsEarning(isOpen) {
			self.isOpenDetailsEarning = !isOpen;
		}

		function genEarnedMoney() {
			earningsSvc.fetchEarnings().then(function (response) {
				$scope.earnings = response;
				transformEarning($scope.earnings);
			})
		}

		function transformEarning(earning) {
			for (var i = 0; i < earning.components.length; i++) {
				earning.components[i].date = moment(earning.components[i].date).format('D MMM YYYY');
			}
		}

		function onPhotoCLick(photoId) {
			pixerfApiMediaSvc.get({
				id: photoId
			}).$promise.then(function (response) {
				photoDetailPopupSvc.showPopup({
					photo: response.data
				});
			})
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('commentInputCtrl', commentInputCtrl);

	commentInputCtrl.$inject = ['$scope', 'sessionManagerSvc', 'pixerfApiMediaSvc', 'toastr', 'commentSvc', '$state', '$uibModalStack', 'commonConst', 'pixerfApiCustomCommssionsSvc', 'selectSignUpTypePopupSvc'];

	function commentInputCtrl($scope, sessionManagerSvc, pixerfApiMediaSvc, toastr, commentSvc, $state, $uibModalStack, commonConst, pixerfApiCustomCommssionsSvc, selectSignUpTypePopupSvc) {

		var self = this;
		self.submit = submit;
		self.onSignUpClicked = onSignUpClicked;
		self.isWorking = false;

		function buildSavedData(comment, action) {
			var savedData = {
				text: comment.text
			}
			if (action === "editComment") {
				savedData.inserted_at = comment.inserted_at;
				savedData.id = comment.id
			}
			return savedData;
		}

		function submit(formData) {
			if (!$scope.comment.text) {
				return false;
			}
			var errMsg = commentSvc.validate(formData);
			if (errMsg) {
				toastr.error(errMsg);
				return;
			}
			var action = $scope.comment.id ? 'editComment' : 'createComment';
			self.isWorking = true;
			if ($scope.isCustomCommissions) {
				commentInCustomCommission();
			} else {
				pixerfApiMediaSvc[action]({
					id: $scope.mediaid,
					commentid: $scope.comment.id
				}, buildSavedData($scope.comment, action)).$promise.then(function (response) {
					if ($scope.onCreatedNew && action === 'createComment') {

						$scope.comment = commentSvc.addOnInfo(response, $scope.mediaid);
						$scope.comment.user = sessionManagerSvc.getCurrentLoginUser().data;
						$scope.onCreatedNew({
							comment: $.extend(true, {}, $scope.comment)
						});
						$scope.comment.text = '';
						$scope.comment.id = null;
					} else if ($scope.onEdited) {
						$scope.comment.updated_at = response.updated_at;
						$scope.comment.isEdited = true;
						$scope.onEdited();
					}
					self.isWorking = false;
				}, function () {
					self.isWorking = false;
					toastr.error("Failed to save comment!");
				})
			}
		}

		function onSignUpClicked() {
			selectSignUpTypePopupSvc.showPopup();
			$uibModalStack.dismissAll();
		}

		function commentInCustomCommission() {
			var action = $scope.comment.id ? 'editCommentOnSubmissions' : 'commentOnSubmissions';
			pixerfApiCustomCommssionsSvc[action]({
				shoot_id: $scope.shootId,
				submission_id: $scope.submissionId,
				comment_id: $scope.comment.id
			}, buildSavedData($scope.comment, action)).$promise.then(function (response) {
				if ($scope.onCreatedNew && action === 'commentOnSubmissions') {
					$scope.comment = commentSvc.addOnInfo(response, $scope.mediaid);
					$scope.comment.user = sessionManagerSvc.getCurrentLoginUser().data;
					$scope.onCreatedNew({
						comment: $.extend(true, {}, $scope.comment)
					});
					$scope.comment.text = '';
					$scope.comment.id = null;
				} else if ($scope.onEdited) {
					$scope.comment.updated_at = response.updated_at;
					$scope.comment.isEdited = true;
					$scope.onEdited();
				}
				self.isWorking = false;
			}, function () {
				self.isWorking = false;
				toastr.error("Failed to save comment!");
			})
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('commentInput', commentInput);

	commentInput.$inject = ['commentSvc'];

	function commentInput(commentSvc) {

		var directive = {
			scope: {
				onCreatedNew: '&',
				onEdited: '&',
				comment: '=',
				settings: "=",
				mediaid: '=',
				focus: '=',
				isCustomCommissions: '@?',
				shootId: '@?',
				submissionId: '@?',
				placeholderText: '@'
			},
			restrict: 'E',
			templateUrl: 'app/components/comment-list/comment-input/comment-input.html',
			controller: 'commentInputCtrl',
			controllerAs: 'vm',
			replace: true
		};
		return directive;
	}

})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.factory('commentSvc', commentSvc);
	commentSvc.$inject = ['sessionManagerSvc'];

	function commentSvc(sessionManagerSvc) {
		function addOnInfo(comment, mediaid) {
			comment.mediaid = mediaid;
			comment.isEdited = comment.inserted_at !== comment.updated_at;
			comment.isMine = sessionManagerSvc.isMine(comment.user);
			comment.createdAtFormated = moment(comment.inserted_at).format("D MMM YYYY");
			return comment;
		}

		function validate(form) {
			form.$setDirty();
			var errMsg = '';
			if (form.commentText.$error.validationNoHyperlink) {
				errMsg = "Sorry, comment cannot contain link.";
			}
			return errMsg;
		}
		return {
			addOnInfo: addOnInfo,
			validate: validate
		};
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('commentCtrl', commentCtrl);

	commentCtrl.$inject = ['$scope', 'pixerfApiMediaSvc', 'toastr', 'pixerfApiCustomCommssionsSvc'];

	function commentCtrl($scope, pixerfApiMediaSvc, toastr, pixerfApiCustomCommssionsSvc) {

		var self = this;
		self.onEditCommentCliced = onEditCommentCliced;
		self.onDeleteCommentClicked = onDeleteCommentClicked;
		self.onCancelBtnClicked = onCancelBtnClicked;
		self.onEditedCallback = onEditedCallback;
		self.isEditMode = false;
		self.isWorking = false;

		function onEditCommentCliced() {
			self.isEditMode = !self.isEditMode;
			$scope.comment.originalText = $scope.comment.text;
		}

		function onDeleteCommentClicked() {
			if (!$scope.comment.text) {
				return false;
			}
			if (self.isWorking) return;
			self.isWorking = true;
			if ($scope.isCustomCommissions) {
				onDeleteCommentCustomCommission();
			} else {
				pixerfApiMediaSvc.deleteComment({
					id: $scope.comment.mediaid,
					commentid: $scope.comment.id
				}).$promise.then(function () {
					self.isWorking = false;
					if ($scope.onDeleted) {
						$scope.onDeleted({
							comment: $scope.comment
						});
					}

				}, function () {
					self.isWorking = false;
					toastr.error("Failed to delete comment!");
				})
			}
		}

		function onCancelBtnClicked() {
			$scope.comment.text = $scope.comment.originalText;
			self.isEditMode = !self.isEditMode;
		}

		function onEditedCallback() {
			self.isEditMode = !self.isEditMode;
			$scope.comment.isEdited = true;
		}

		function onDeleteCommentCustomCommission(){
			pixerfApiCustomCommssionsSvc.deleteCommentOnSubmissions({
				submission_id: $scope.submissionId,
				shoot_id: $scope.shootId,
				comment_id: $scope.comment.id
			}).$promise.then(function () {
				self.isWorking = false;
				if ($scope.onDeleted) {
					$scope.onDeleted({
						comment: $scope.comment
					});
				}

			}, function () {
				self.isWorking = false;
				toastr.error("Failed to delete comment!");
			})
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('comment', comment);

	comment.$inject = ['commentSvc'];

	function comment(commentSvc) {

		var directive = {
			scope: {
				comment: "=",
				onDeleted: "&",
				mediaid: '=',
				context: '=',
				isCustomCommissions: "@?",
				submissionId: "@?",
				shootId: "@?"
			},
			restrict: 'E',
			controller: 'commentCtrl',
			controllerAs: 'vm',
			templateUrl: 'app/components/comment-list/comment/comment.html',
			replace: true,
			link: function (scope) {
				commentSvc.addOnInfo(scope.comment, scope.mediaid);
			}

		};
		return directive;
	}

})();

(function () {

	angular
		.module('pixerf')
		.controller('completeProfileSkillsCtrl', completeProfileSkillsCtrl);

	completeProfileSkillsCtrl.$inject = ['$scope', 'toastr', 'pixerfApiUserSvc', 'accountConst', 'portfolioConst', 'systemUtils', 'messageConst', 'sessionManagerSvc', '$state', 'arrayUtils', 'editProfileSvc', 'signUpPersonalInfoSvc', 'accountUtils', '$translate', 'translationSvc'];

	function completeProfileSkillsCtrl($scope, toastr, pixerfApiUserSvc, accountConst, portfolioConst, systemUtils, messageConst, sessionManagerSvc, $state, arrayUtils, editProfileSvc, signUpPersonalInfoSvc, accountUtils, $translate, translationSvc) {

		var self = this;
		self.loginedUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.user = {};
		self.buildSpecialitiesDropdown = buildSpecialitiesDropdown;
		self.onServiceRatesSelected = onServiceRatesSelected;
		self.onAvailabilityShowed = onAvailabilityShowed;
		self.onBackBtnClicked = onBackBtnClicked;
		self.onItemChanged = onItemChanged;
		self.onCompleted = onCompleted;
		self.onAvailabilityChanged = onAvailabilityChanged;
		self.serviceRates = [
			{"name": "Hourly rate", "id": 1},
			{"name": "Half-day", "id": 2},
			{"name": "Full Day", "id": 3},
			{"name": "Upon request", "id": 4}
		];
        self.CONST = {
            SERVICES_RATE_MIN: accountConst.PROFILE.SERVICES_RATE_MIN,
            SERVICES_RATE_MAX: accountConst.PROFILE.SERVICES_RATE_MAX
        }
		self.maxSpecialitiesSelected = portfolioConst.LIMIT_SPECIALITIES;
		self.serviceData = {};
		self.availability_weekdays = {};
		self.availability_weekends = {};
		self.gplacesOptions = {
			types: ['(cities)']
		}

		init();

		function init() {
			buildSpecialitiesDropdown();
			fillExistedInfo(self.loginedUser);
		}

		function fillExistedInfo(user){
			self.user.first_name = user.first_name;
			self.user.last_name = user.last_name;
			self.user.country  = user.address && user.address.country ? user.address.country : null;
			self.user.location = user.location;
			self.user.date_of_birth = user.date_of_birth;
			self.user.bio = user.bio;
			self.serviceData.availability = user.is_available_for_cc;
			self.serviceData.years_of_experience = user.profile ? user.profile.years_of_experience : null;
			self.serviceData.specialities = user.profile ? user.profile.specialities : null;
			self.serviceData.cameras = user.profile ? user.profile.cameras : null;
			self.serviceData.serviceRatesSelected = user.profile ? _.filter(self.serviceRates, function (obj) { return obj.name === user.profile.services_rate_type; }) : null;
			self.serviceData.services_rate_amount = user.profile ? user.profile.services_rate_amount : null;
			if(user.profile && arrayUtils.isValueArr(user.profile.availability_weekdays)){
                extractAvailability(user.profile, 'availability_weekdays');
            }
            if(user.profile && arrayUtils.isValueArr(user.profile.availability_weekends)){
                extractAvailability(user.profile, 'availability_weekends');
			}
		}

		function onItemChanged(result){
			if(!self.serviceData.specialities){
				self.serviceData.specialities = [];
			}
			self.serviceData.specialities = _.map(result.items, function(item) {
				return {id: item.id, description: item.description, name: item.name};
			});
		}

		function buildSpecialitiesDropdown() {
			pixerfApiUserSvc.getSpecialities().$promise.then(function (response) {
				self.specialities = response.data;
			});
		}

		function onServiceRatesSelected(serviceRatesSelected) {
			if (!serviceRatesSelected) {
				toastr.error("Please input your service rates!");
				return;
			}
			self.serviceData.services_rate_type = serviceRatesSelected[0] ? serviceRatesSelected[0].name : "";
			if (!self.serviceData.services_rate_type) {
				self.serviceData.services_rate_amount = null;
				systemUtils.digest($scope);
			}
		}

		function onBackBtnClicked(){
			$state.go("complete-profile-page");
		}

		function onCompleted(form){
			var errMsg = signUpPersonalInfoSvc.validateProfileAsForm(self.user, form);
			if(!errMsg){
				errMsg = editProfileSvc.validateServiceData(self.serviceData, form);
			}
			if(errMsg){
				toastr.error(errMsg);
				return;
			}
			buildSavedData();
			pixerfApiUserSvc.put(self.loginedUser, function(userData){
				toastr.success($translate.instant(messageConst.success.USER_INFO_UPDATED));
				sessionManagerSvc.setCurrentLoginUser(userData);
				$state.go("user-home-page.business", {id: userData.id, userName: userData.displayName.replace(/ /g, '-')});
			},function(err){
				console.log(err);
				toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
			});
		}

		function buildSavedData(){
			if(self.serviceData && self.serviceData.serviceRatesSelected && !self.serviceData.services_rate_type){
				onServiceRatesSelected(self.serviceData.serviceRatesSelected);
			}
			delete self.serviceData.serviceRatesSelected;

			self.loginedUser.first_name = self.user.first_name;
			self.loginedUser.last_name = self.user.last_name;
			self.loginedUser.location = accountUtils.getUserGoogleLocation(self.user.location);
			self.loginedUser.address = {};
			self.loginedUser.address.country = self.user.country;
			self.loginedUser.date_of_birth = buildDateOfBirth(self.user);
			self.loginedUser.bio = self.user.bio;

			if(self.serviceData){
				self.loginedUser.profile = self.serviceData;
				self.loginedUser.is_available_for_cc = self.serviceData.availability;
				self.loginedUser.profile.cameras = self.loginedUser.profile.cameras ? _.map(self.loginedUser.profile.cameras, function(obj){ return obj.text; }) : null;
			}
		}

		function buildDateOfBirth(user){
			var DateOfBirth = null;
			var dayConvert = user.date_of_birth.getDate();
			var monthConvert = (user.date_of_birth.getMonth() + 1);
			if (user.date_of_birth.getMonth() < 9)
				monthConvert = "0" + (user.date_of_birth.getMonth() + 1);
			if (user.date_of_birth.getDate() < 10)
				dayConvert = "0" + user.date_of_birth.getDate();
			DateOfBirth = user.date_of_birth.getFullYear() + "-" + monthConvert + "-" + dayConvert;

			return DateOfBirth;
		}

		function extractAvailability(serviceData, timeDuration){
            for(var i = 0; i < serviceData[timeDuration].length; i++){
                if(serviceData[timeDuration][i] === "day"){
                    self[timeDuration].day = true;
                }
                if(serviceData[timeDuration][i] === "evening"){
                    self[timeDuration].evening = true;
                }
                if(i === serviceData[timeDuration].length - 1){
                    onAvailabilityChanged(timeDuration);
                }
            }
		}

		function onAvailabilityChanged(timeDuration) {
			if (!self.serviceData[timeDuration]) {
				self.serviceData[timeDuration] = [];
			}
			if (self[timeDuration].day && self[timeDuration].evening) {
				self.serviceData[timeDuration] = ['day', 'evening'];
			} else if (self[timeDuration].day) {
				self.serviceData[timeDuration] = ['day'];
			} else if (self[timeDuration].evening) {
				self.serviceData[timeDuration] = ['evening'];
			} else {
				self.serviceData[timeDuration]= [];
			}
		}

		function onAvailabilityShowed(isAvailability){
			if(!isAvailability){
				self.serviceData.availability_weekdays = [];
				self.serviceData.availability_weekends = [];
				self.availability_weekdays = {};
        		self.availability_weekends = {};
			}
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.config(routerConfig);

	routerConfig.$inject = ['$stateProvider'];

	function routerConfig($stateProvider) {
		'ngInject';
		$stateProvider
			.state('complete-profile-skills', {
				url: '/complete-profile-skills',
				templateUrl: 'app/complete-profile-page/components/complete-profile-skills/complete-profile-skills.html',
				controller: 'completeProfileSkillsCtrl',
				controllerAs: 'vm',
				data: {
					pageTitle: "PIXERF - Complete Profile Skills",
					permissions: {
						only: ['AUTHORIZED'],
						redirectTo: function () {
							return "404"  ;
						}
					},
					hideFooter: true
				}
			});
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('completeProfilePhotoCtrl', completeProfilePhotoCtrl);

	completeProfilePhotoCtrl.$inject = ['$rootScope', '$scope', '$state', 'toastr', 'sessionManagerSvc', 'systemUtils', 'settingSvc', 'messageConst'];

	function completeProfilePhotoCtrl($rootScope, $scope, $state, toastr, sessionManagerSvc, systemUtils, settingSvc, messageConst) {

		var self = this;
		self.loginedUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.onSkipUpadateAvatarClicked = onSkipUpadateAvatarClicked;
		self.onUploadphoto = onUploadphoto;
		self.onAvatarAdded = onAvatarAdded;
		self.onBackBtnClicked = onBackBtnClicked;
		self.onDropzoneInit = onDropzoneInit;
		self.onSaveAvatar = onSaveAvatar;
		self.onAvataUpdated = onAvataUpdated;
		self.isAdjustedPhoto = false;
		self.newAvatar = false;

		function onDropzoneInit(instance){
			self.dropzoneInstance = instance;
		}

		function onSkipUpadateAvatarClicked(){
			$state.go('complete-profile-skills');
		}

		function onUploadphoto(){
			self.isAdjustedPhoto = false;
			systemUtils.digest($scope);
			$(".dropzone-info").click();
		}

		function onAvatarAdded(file){
			if(file && file.status === 'added'){
				self.newAvatar = true;
			} else {
				self.newAvatar = false;
			}
		}

		function onSaveAvatar() {
			if (self.dropzoneInstance.dropzoneConfig.instance.getAcceptedFiles().length === 0) {
				toastr.error("You have not selected any photo to upload.");
				return;
			}
			if (self.dropzoneInstance.cropper && !self.isAdjustedPhoto){
				self.dropzoneInstance.cropper.instance.croppie('result', {type: 'canvas', size: 'viewport'}).then(function (img) {
					$('#adjusted-photo').find('img').remove();
					$('#adjusted-photo').prepend($('<img>',{src: img}));
					self.isAdjustedPhoto = true;
					systemUtils.digest($scope);
				});
			} else if (self.dropzoneInstance.cropper && self.isAdjustedPhoto) {
				self.dropzoneInstance.cropper.instance.croppie('result', {type: 'blob', size: {width: 300, height: 300}}).then(function (croppedBlobFile, test) {
					self.dropzoneInstance.dropzoneConfig.instance.removeAllFiles();
					croppedBlobFile.isCropped = true;
					self.dropzoneInstance.dropzoneConfig.instance.addFile(croppedBlobFile);
					self.dropzoneInstance.dropzoneConfig.instance.processQueue();
				});
			} else {
				self.dropzoneInstance.dropzoneConfig.instance.processQueue();
			}
			self.dropzoneInstance.dropzoneConfig.instance.on("complete", function(respone){
				var avatar = JSON.parse(respone.xhr.response).thumbnails;
				self.loginedUser.profile_image_media = avatar;
				self.loginedUser.profile_image = JSON.parse(respone.xhr.response).handle;
				self.loginedUser.avatar.profileImageSmall = self.loginedUser.profile_image_media['100x'];
				self.loginedUser.avatar.profileImage = self.loginedUser.profile_image_media['300x'];
				self.loginedUser.avatar.profileImageBig = self.loginedUser.profile_image_media['800x'];
				sessionManagerSvc.setCurrentLoginUser(self.loginedUser);
				$rootScope.$broadcast(messageConst.BROADCAST.USER_DATA_CHANGE);
			});
		};

		function onBackBtnClicked(){
			window.history.go(-1);
		}

		function onAvataUpdated(handle){
			settingSvc.updateUserProfilePhotos(self.loginedUser, 'profile', handle);
			$state.go("complete-profile-page");
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.config(routerConfig);

	routerConfig.$inject = ['$stateProvider'];

	function routerConfig($stateProvider) {
		'ngInject';
		$stateProvider
			.state('complete-profile-photo', {
				url: '/complete-profile-photo',
				templateUrl: 'app/complete-profile-page/components/complete-profile-photo/complete-profile-photo.html',
				controller: 'completeProfilePhotoCtrl',
				controllerAs: 'vm',
				data: {
					pageTitle: "PIXERF - Complete Profile Photo",
					permissions: {
						only: ['AUTHORIZED'],
						redirectTo: function () {
							return "404"  ;
						}
					},
					hideFooter: true
				}
			});
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('communityDetailPhotosCtrl', communityDetailPhotosCtrl);

	communityDetailPhotosCtrl.$inject = ["$scope", "$state", 'createCommunityAlbumPopupSvc', 'pixerfApiCommunitySvc', 'pixerfApiEventSvc', 'pagingUtils', 'sessionManagerSvc'];

	function communityDetailPhotosCtrl($scope, $state, createCommunityAlbumPopupSvc, pixerfApiCommunitySvc, pixerfApiEventSvc, pagingUtils, sessionManagerSvc) {
		var self = this;
		self.community = $scope.$parent.vm.community;
		self.loginUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.isMine = self.loginUser && self.community.owner.id === self.loginUser.id;
		self.onCommunityAlbumClicked = onCommunityAlbumClicked;
		self.onEventAlbumClicked = onEventAlbumClicked;
		self.fetchMoreCommunityAlbums = fetchMoreCommunityAlbums;
		self.fetchMoreEventAlbums = fetchMoreEventAlbums;
		self.onCreateNewAlbum = onCreateNewAlbum;

		self.communityAlbums = [];
		self.eventAlbums = [];
		self.spinnerCommunity = {
			isVisible: false
		};
		self.spinnerEvent = {
			isVisible: false
		};
		self.emptyCommunityAlbums = {
			title: self.isMine ? 'You have not created any albums yet!' : (self.community.owner.displayName + ' has not created any albums yet!')
		};

		self.searchCommunityAlbumsParams = {
			community_id: self.community.id,
			page: 1
		}

		self.searchEventAlbumsParams = {
			community_id: self.community.id,
			page: 1
		}

		init();

		function init() {
			fetchCommunityAlbums(self.searchCommunityAlbumsParams, true);
			fetchEventAlbums(self.searchEventAlbumsParams, true);
		}

		function onCommunityAlbumClicked(photo) {
			$state.go('community-detail-page.community-detail-album-detail', {
				albumId: photo.id,
				albumName: photo.name.replace(/ /g, '-')
			});
		}

		function onEventAlbumClicked(photo) {
			$state.go('event-detail-page.event-photos', {
				id: photo.id,
				name: photo.name.replace(/ /g, '-')
			});
		}

		function fetchCommunityAlbums(params, isFresh) {
			self.searchCommunityAlbumsParams = params;
			self.spinnerCommunity.isVisible = true;
			pixerfApiCommunitySvc.get_list_albums(self.searchCommunityAlbumsParams).$promise.then(function (res) {
				self.spinnerCommunity.isVisible = false;
				if (!self.communityAlbums || isFresh) self.communityAlbums = [];
				self.communityAlbums = self.communityAlbums.concat(res.data);
				self.isLastCommunityPage = pagingUtils.isNoMorePageToLoad(self.searchCommunityAlbumsParams.page, res);
				self.searchCommunityAlbumsParams.page = params.page;
			}).catch(function (err) {
				self.spinnerCommunity.isVisible = false;
				console.log(err);
			})
		}

		function fetchMoreCommunityAlbums() {
			if (self.isLastCommunityPage || self.spinnerCommunity.isVisible) return;
			var searchParms = $.extend(true, {}, self.searchCommunityAlbumsParams);
			searchParms.page++;
			fetchCommunityAlbums(searchParms);
		}

		function fetchEventAlbums(params, isFresh) {
			self.searchEventAlbumsParams = params;
			self.spinnerEvent.isVisible = true;
			pixerfApiEventSvc.getEvents(self.searchEventAlbumsParams).$promise.then(function (res) {
				if (!self.eventAlbums || isFresh) self.eventAlbums = [];
				self.eventAlbums = self.eventAlbums.concat(res.data);
				self.isLastEventPage = pagingUtils.isNoMorePageToLoad(self.searchEventAlbumsParams.page, res);
				self.spinnerEvent.isVisible = false;
				self.searchEventAlbumsParams.page = params.page;
			}).catch(function (err) {
				self.spinnerEvent.isVisible = false;
				console.log(err);
			})
		}

		function fetchMoreEventAlbums() {
			if (self.isLastEventPage || self.spinnerEvent.isVisible) return;
			var searchParms = $.extend(true, {}, self.searchEventAlbumsParams);
			searchParms.page++;
			fetchEventAlbums(searchParms);
		}

		function onCreateNewAlbum() {
			createCommunityAlbumPopupSvc.showPopup({
				communityId: self.community.id
			});
		}
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('communityDetailPageMembersCtrl', communityDetailPageMembersCtrl);

	communityDetailPageMembersCtrl.$inject = ["$scope"];

	function communityDetailPageMembersCtrl($scope) {
		var self = this;
		self.parent = $scope.$parent.vm;
		self.onMemberGridInit = onMemberGridInit;
		self.communityDetailOptions = {
			scrollToPaging: true
		}

		function onMemberGridInit(instance) {
			self.memberGridInit = instance;
		}
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('communityDetailPageInviteMemberCtrl', communityDetailPageInviteMemberCtrl);

	communityDetailPageInviteMemberCtrl.$inject = ['communityData', 'outlookContactSvc', 'communityInviteEmailPopupSvc', 'googleContactSvc', 'commonConst', 'inviteCommunityMembersPopupSvc'];


	function communityDetailPageInviteMemberCtrl(communityData, outlookContactSvc, communityInviteEmailPopupSvc, googleContactSvc, commonConst, inviteCommunityMembersPopupSvc) {

		var self = this;
		self.community = communityData;
		self.onOutlookClicked = onOutlookClicked;
		self.onGmailClicked = onGmailClicked;
		self.onInvitePxerferClicked = onInvitePxerferClicked;
		self.onMemberGridInit = onMemberGridInit;

		function invitationSentHandler(invitedPeoples) {
			var array = invitedPeoples.concat(self.memberGridInit.peoples)
			self.memberGridInit.peoples = array;
		}

		function onMemberGridInit(instance) {
			self.memberGridInit = instance;
		}

		function onGmailClicked() {
			googleContactSvc.auth(function () {
				var popup = communityInviteEmailPopupSvc.showPopup({
					getter: googleContactSvc.getContacts,
					community: self.community
				});
				popup.result.then(function () {
					invitationSentHandler()
				})
			});
		}

		function onOutlookClicked() {
			console.log(outlookContactSvc.buildAuthUrl());
			outlookContactSvc.auth(function () {
				var popup = communityInviteEmailPopupSvc.showPopup({
					getter: outlookContactSvc.getContacts,
					community: self.community
				});
				popup.result.then(function () {
					invitationSentHandler()
				})
			});
		}

		function onInvitePxerferClicked() {
			var popup = inviteCommunityMembersPopupSvc.showPopup({
				community: self.community,
				defaultSearchCondition: {
					isDirectoryChecked: false,
					isEmailChecked: true,
					country: "",
					speciality: ""
				}
			});
			popup.result.then(function (invitedPeoples) {
				invitationSentHandler(invitedPeoples)
			})
		}
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('communityDetailPageBriefCtrl', communityDetailPageBriefCtrl);

	communityDetailPageBriefCtrl.$inject = ["$scope", 'communityConst'];

	function communityDetailPageBriefCtrl($scope, communityConst) {
		var self = this;
		self.parent = $scope.$parent.vm;
		self.community = self.parent.community;
		self.isPrivatedContent = self.community.is_private && !self.community.isMine && self.community.membership_status != communityConst.MEMBERSHIP.ACCEPTED;
		self.communityDetailOptions = {
			hideTools: true,
			navigateOnShowAll: 'community-detail-page.community-detail-page-members({id: ' + self.community.id + '})'
		}
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('communityDetailEventsCtrl', communityDetailEventsCtrl);

	communityDetailEventsCtrl.$inject = ['$scope', 'sessionManagerSvc', 'createEventPopupSvc', 'pixerfApiEventSvc', 'pagingUtils', 'inviteUserPopupSvc', 'commonConst', '$state'];

	function communityDetailEventsCtrl($scope, sessionManagerSvc, createEventPopupSvc, pixerfApiEventSvc, pagingUtils, inviteUserPopupSvc, commonConst, $state) {

		var self = this;
		self.community = $scope.$parent.vm.community;
		self.canUpdateCommunity = (self.community && self.community.status == 'active');
		self.loginUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.isMine = self.loginUser && self.community.owner.id === self.loginUser.id;
		self.onCreateEvent = onCreateEvent;
		self.onSearchEvents = _.debounce(onSearchEvents, 400);
		self.fetchMoreEvents = fetchMoreEvents;
		self.spinner = {
			isVisible: false
		};
		self.spinnerUpcomingEvents = {
			isVisible: false
		};
		self.spinnerPastEvents = {
			isVisible: false
		};
		self.searchEventParams = {
			community_id: self.community.id,
			page: 1
		};
		self.upcomingEventParams = {
			community_id: self.community.id,
			type: 'upcoming',
			status: 'active',
            event_type: 'standard',
			page: 1
		};
		self.pastEventParams = {
			community_id: self.community.id,
			type: 'past',
			status: 'active',
            event_type: 'standard',
			page: 1
		}

		self.upcomingEvents = [];
		self.pastEvents = [];

		var owner = (self.isMine ? 'you have' : self.community.name + ' has');
		self.emptyUpcomingEvents = {
			title: 'Looks like ' + owner + ' no event coming up.',
			description: ((self.isMine || self.community.membership_status == 'manager') && self.canUpdateCommunity ) ? 'Hosting an event is a great way to engage your audience.<br/>Want to set up an event? Let’s get started.' : null,
			buttonText: ((self.isMine || self.community.membership_status == 'manager') && self.canUpdateCommunity ) ? 'Create event' : null
		};

		self.emptySearchEvent = {
			description: 'No results'
		}

		init();

		function init() {
			getlistUpcomingEvents(self.upcomingEventParams, true);
			getlistPastEvents(self.pastEventParams, true);
		}

		function onCreateEvent() {
			var popupData = {
				community: self.community,
				type: 'event'
			}
			var eventPopup = createEventPopupSvc.showPopup(popupData);

			eventPopup.result.then(function (event) {
				if(event.status === 'active'){
					self.upcomingEvents.unshift(event);
					showInviteFriendsPopup(event);
				} else {
					$state.go(commonConst.STATE.MANAGE_DRAFT_EVENTS);
				}
			})
		}

		function getItemType(type){
			if(!type){
				return 'Event/Class';
			}else if(type == 'class'){
				return 'Class';
			}else {
				return 'Event';
			}
		}

		function showInviteFriendsPopup(event){
			var inviteText = "Invite members to " + getItemType(event.event_type);
			var popup = inviteUserPopupSvc.showPopup({
				options: {
					title: inviteText
				},
				community: {
					id: self.community.id,
				},
				event: {
					id: event.id,
					short_code: event.short_code
				},
				defaultSearchCondition: {
					isDirectoryChecked: true,
					isEmailChecked: false,
					country: "",
					speciality: "",
					showSkipBtn: true
				}
			});
			popup.result.then(function (invitedPeoples) {
				console.log(invitedPeoples);
				// invitationSentHandler(invitedPeoples);
			});
		}

		function getlistUpcomingEvents(params, isFresh) {
			if(self.isUsomcingEventsWorking || self.spinnerUpcomingEvents.isVisible) return;
			self.isUsomcingEventsWorking = true;
			self.spinnerUpcomingEvents.isVisible = true;
			pixerfApiEventSvc.getEvents(params).$promise.then(function (res) {
				if (!self.upcomingEvents || isFresh) self.upcomingEvents = [];
				self.upcomingEvents = self.upcomingEvents.concat(res.data);
				self.isLastUpcomingEvent = pagingUtils.isNoMorePageToLoad(params.page, res);
				self.upcomingEventParams.page = params.page;
				self.isUsomcingEventsWorking = false;
				self.spinnerUpcomingEvents.isVisible = false;
			}).catch(function (err) {
				self.isUsomcingEventsWorking = false;
				self.spinnerUpcomingEvents.isVisible = false;
				console.log(err);
			})
		}

		function getlistPastEvents(params, isFresh) {
			if(self.isPastEventsWorking || self.spinnerPastEvents.isVisible) return;
			self.isPastEventsWorking = true;
			self.spinnerPastEvents.isVisible = true;
			pixerfApiEventSvc.getEvents(params).$promise.then(function (res) {
				if (!self.pastEvents || isFresh) self.pastEvents = [];
				self.pastEvents = self.pastEvents.concat(res.data);
				self.isLastPastEvent = pagingUtils.isNoMorePageToLoad(params.page, res);
				self.pastEventParams.page = params.page;
				self.isPastEventsWorking = false;
				self.spinnerPastEvents.isVisible = false;
			}).catch(function (err) {
				self.isPastEventsWorking = false;
				self.spinnerPastEvents.isVisible = false;
				console.log(err);
			})
		}

		function onSearchEvents() {
			self.events = [];
			self.searchEventParams.page = 1;
			if (self.searchEventsString) {
				self.searchEventParams.keywords = self.searchEventsString;
			} else {
				delete self.searchEventParams.keywords;
			}
			getSearchEvents(self.searchEventParams, true);
		}

		function getSearchEvents(params, isFresh) {
			self.isWorking = true;
			self.spinner.isVisible = true;
			pixerfApiEventSvc.getEvents(params).$promise.then(function (res) {
				if (!self.searchEvents || isFresh) self.searchEvents = [];
				self.searchEvents = self.searchEvents.concat(res.data);
				self.isLastSearchEvent = pagingUtils.isNoMorePageToLoad(params.page, res);
				self.searchEventParams.page = params.page;
				self.isWorking = false;
				self.spinner.isVisible = false;
			}).catch(function (err) {
				self.isWorking = false;
				self.spinner.isVisible = false;
				console.log(err);
			})
		}

		function fetchMoreEvents(type) {
			var searchParams;
			switch (type) {
				case 'upcoming':
					if (self.isLastUpcomingEvent || self.spinner.isVisible) return;
					searchParams = $.extend(true, {}, self.upcomingEventParams);
					searchParams.page++;
					getlistUpcomingEvents(searchParams);
					break;
				case 'past':
					if (self.isLastPastEvent || self.spinner.isVisible) return;
					searchParams = $.extend(true, {}, self.pastEventParams);
					searchParams.page++;
					getlistPastEvents(searchParams);
					break;
				default:
					if (self.isLastSearchEvent || self.spinner.isVisible) return;
					searchParams = $.extend(true, {}, self.searchEventParams);
					searchParams.page++;
					getSearchEvents(searchParams)
					break;
			}
		}
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('communityDetailDiscussionsCtrl', communityDetailDiscussionsCtrl);

	communityDetailDiscussionsCtrl.$inject = ['$scope', 'sessionManagerSvc', 'createDiscussionTopicPopupSvc', 'pixerfApiCommunitySvc', 'pagingUtils', 'systemUtils', 'toastr', 'commonConst', '$state', 'translationSvc', '$translate'];

	function communityDetailDiscussionsCtrl($scope, sessionManagerSvc, createDiscussionTopicPopupSvc, pixerfApiCommunitySvc, pagingUtils, systemUtils, toastr, commonConst, $state, translationSvc, $translate) {

		var self = this;
		self.commonConst = commonConst;
		self.isWorking = false;
		self.spinner = {
			isVisible: false
		}
		self.isLastPage = false;
		self.community = $scope.$parent.vm.community;
		self.canUpdateCommunity = (self.community && self.community.status == 'active');
		self.onRequestToJoinedClicked = onRequestToJoinedClicked;
		self.loginUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.isBusinessAcc = self.loginUser && self.loginUser.account_type === 'business';
		self.isOwner = self.loginUser && self.loginUser.id === self.community.owner.id;
		self.arrangeOptions = {
			props: "arrangeBy",
			selections: [{
					label: "recent",
					value: "inserted_at"
				},
				{
					label: "bookmarked",
					value: "is_bookmarked"
				}
			]
		};
		self.submitButtonText = "Join Community";
		self.arrangeBy= {arrangeBy: 'inserted_at'};
		self.defaultArrangeBy = {arrangeBy: self.arrangeOptions.selections[0].value};
		self.searchParams = {
			id: self.community.id,
			page: 1,
			sort: self.defaultArrangeBy.arrangeBy
		};
		self.discussions = [];
		self.draftDiscussions = [];
		self.showDiscussions = !self.community.is_private || (self.community.is_private && (self.community.membership_status === 'accepted' || self.community.membership_status === 'owner' || self.community.membership_status === 'manager'));
		self.showSearchDiscussion = !self.community.is_private || (self.community.is_private && (self.community.membership_status === 'accepted' || self.community.membership_status === 'owner' || self.community.membership_status === 'manager'));
		self.canStartDiscussion = self.isOwner || (self.community.is_private && self.community.start_discussion_permission === 'anyone' && (self.community.membership_status === 'accepted' || self.community.membership_status === 'manager' || self.community.membership_status === 'owner') ) || (!self.community.is_private && self.community.start_discussion_permission === 'anyone');
		self.onStartDiscussion = onStartDiscussion;
		self.onArrageChanged = onArrageChanged;
		self.fetchMoreDiscussions = fetchMoreDiscussions;
		self.onDiscussionRemoved = onDiscussionRemoved;
		self.onSearchDiscussion = _.debounce(onSearchDiscussion, 400);
		self.onDraftDiscussionPublished = onDraftDiscussionPublished;
		self.onDraftDiscussionRemoved = onDraftDiscussionRemoved;

		init();

		function init() {
			if (!self.community.is_private || (self.loginUser && self.community.is_private && (self.community.membership_status === 'accepted' || self.community.membership_status === 'owner' || self.community.membership_status === 'manager'))) {
				getDiscussions(self.searchParams, true);
				getDraftDiscussions(self.searchParams, true);
			}
			if (self.community.is_private && self.community.membership_status === 'requested') {
				self.submitButtonText = "Requested";
			}
		}

		function onRequestToJoinedClicked() {
			if (self.community.membership_status === 'requested' || self.isWorking) return;
			self.isWorking = true;
			pixerfApiCommunitySvc.join({
				id: self.community.id
			}, null).$promise.then(function (respone) {
				self.isWorking = false;
				self.submitButtonText = "Requested";
				toastr.success($translate.instant('requested-join-community'));
				$state.reload();
			}, function () {
				self.isWorking = false;
				toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
			})
		}

		function onArrageChanged(data) {
			self.discussions = [];
			self.searchParams.page = 1;
			self.searchParams.sort = data.arrangeBy;
			getDiscussions(self.searchParams, true);
		}

		function onStartDiscussion() {
			var popup = createDiscussionTopicPopupSvc.showPopup({
				community: self.community,
				createdCallback: function (discussion) {
					self.discussions.unshift(discussion);
				}
			});

			popup.result.then(function (data) {
				if (data.id && (!data.status || data.status === 'draft')) {
					self.draftDiscussions.unshift(data);
				}
			})
		}

		function getDiscussions(params, isFresh) {
			self.searchParams = params;
			self.spinner.isVisible = true;
			self.isWorking = true;
			pixerfApiCommunitySvc.get_discussions_by_community_id(self.searchParams).$promise.then(function (res) {
				if (!self.discussions || isFresh) self.discussions = [];
				self.discussions = self.discussions.concat(res.data);
				self.isLastPage = pagingUtils.isNoMorePageToLoad(self.searchParams.page, res);
				self.spinner.isVisible = false;
				self.searchParams.page = params.page;
				self.isWorking = false;
			}).catch(function (err) {
				self.isWorking = false;
				self.spinner.isVisible = false;
				console.log(err);
			})
		}

		function fetchMoreDiscussions() {
			if (self.isLastPage || self.spinner.isVisible) return;
			var searchParms = $.extend(true, {}, self.searchParams);
			searchParms.page++;
			getDiscussions(searchParms);
		}

		function onDiscussionRemoved(discussion) {
			self.discussions = _.reject(self.discussions, function (item) {
				return item.id === discussion.id;
			})
		}

		function onSearchDiscussion() {
			self.discussions = [];
			self.searchParams.page = 1;
			if (self.searchDiscussionString) {
				self.searchParams.keywords = self.searchDiscussionString;
			} else {
				delete self.searchParams.keywords;
			}
			getDiscussions(self.searchParams, true);
		}

		function getDraftDiscussions(params, isFresh) {
			self.searchParams = params;
			self.isWorking = true;
			pixerfApiCommunitySvc.get_draft_discussions_by_community_id(self.searchParams).$promise.then(function (res) {
				if (!self.draftDiscussions || isFresh) self.draftDiscussions = [];
				self.draftDiscussions = self.draftDiscussions.concat(res.data);
			}).catch(function (err) {
				self.isWorking = false;
				console.log(err);
			})
		}

		function onDraftDiscussionPublished(discussion) {
			self.draftDiscussions = _.reject(self.draftDiscussions, function (item) {
				return item.id === discussion.id;
			});

			self.discussions.unshift(discussion);
			systemUtils.digest($scope);
		}

		function onDraftDiscussionRemoved(discussion) {
			self.draftDiscussions = _.reject(self.draftDiscussions, function (item) {
				return item.id === discussion.id;
			});

			systemUtils.digest($scope);
		}
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('communityDetailClassesCtrl', communityDetailClassesCtrl);

	communityDetailClassesCtrl.$inject = ['$scope', 'sessionManagerSvc', 'createEventPopupSvc', 'pixerfApiEventSvc', 'pagingUtils', 'inviteUserPopupSvc', 'commonConst', '$state'];

	function communityDetailClassesCtrl($scope, sessionManagerSvc, createEventPopupSvc, pixerfApiEventSvc, pagingUtils, inviteUserPopupSvc, commonConst, $state) {

		var self = this;
		self.community = $scope.$parent.vm.community;
		self.canUpdateCommunity = (self.community && self.community.status == 'active');
		self.loginUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.isMine = self.loginUser && self.community.owner.id === self.loginUser.id;
		self.onCreateEvent = onCreateEvent;
		self.onSearchEvents = _.debounce(onSearchEvents, 400);
		self.fetchMoreEvents = fetchMoreEvents;
		self.spinner = {
			isVisible: false
		};
		self.spinnerUpcomingEvents = {
			isVisible: false
		};
		self.spinnerPastEvents = {
			isVisible: false
		};
		self.searchEventParams = {
			community_id: self.community.id,
			page: 1
		};
		self.upcomingEventParams = {
			community_id: self.community.id,
			type: 'upcoming',
			status: 'active',
            event_type: 'class',
			page: 1
		};
		self.pastEventParams = {
			community_id: self.community.id,
			type: 'past',
			status: 'active',
            event_type: 'class',
			page: 1
		}

		self.upcomingEvents = [];
		self.pastEvents = [];

		var owner = (self.isMine ? 'you have' : self.community.name + ' has');
		self.emptyUpcomingEvents = {
			title: 'Looks like ' + owner + ' no class coming up.',
			description: ((self.isMine || self.community.membership_status == 'manager') && self.canUpdateCommunity ) ? 'Hosting an class is a great way to engage your audience.<br/>Want to set up an class? Let’s get started.' : null,
			buttonText: ((self.isMine || self.community.membership_status == 'manager') && self.canUpdateCommunity ) ? 'Create class' : null
		};

		self.emptySearchEvent = {
			description: 'No results'
		}

		init();

		function init() {
			getlistUpcomingEvents(self.upcomingEventParams, true);
			getlistPastEvents(self.pastEventParams, true);
		}

		function onCreateEvent() {
			var popupData = {
				community: self.community,
				type: 'class'
			}
			var eventPopup = createEventPopupSvc.showPopup(popupData);

			eventPopup.result.then(function (event) {
				if(event.status === 'active'){
					self.upcomingEvents.unshift(event);
					showInviteFriendsPopup(event);
				} else {
					$state.go(commonConst.STATE.MANAGE_DRAFT_EVENTS);
				}
			})
		}

		function getItemType(type){
			if(!type){
				return 'Event/Class';
			}else if(type == 'class'){
				return 'Class';
			}else {
				return 'Event';
			}
		}

		function showInviteFriendsPopup(event){
			var inviteText = "Invite members to " + getItemType(event.event_type);
			var popup = inviteUserPopupSvc.showPopup({
				options: {
					title: inviteText
				},
				community: {
					id: self.community.id,
				},
				event: {
					id: event.id,
					short_code: event.short_code
				},
				defaultSearchCondition: {
					isDirectoryChecked: true,
					isEmailChecked: false,
					country: "",
					speciality: "",
					showSkipBtn: true
				}
			});
			popup.result.then(function (invitedPeoples) {
				console.log(invitedPeoples);
				// invitationSentHandler(invitedPeoples);
			});
		}

		function getlistUpcomingEvents(params, isFresh) {
			if(self.isUsomcingEventsWorking || self.spinnerUpcomingEvents.isVisible) return;
			self.isUsomcingEventsWorking = true;
			self.spinnerUpcomingEvents.isVisible = true;
			pixerfApiEventSvc.getEvents(params).$promise.then(function (res) {
				if (!self.upcomingEvents || isFresh) self.upcomingEvents = [];
				self.upcomingEvents = self.upcomingEvents.concat(res.data);
				self.isLastUpcomingEvent = pagingUtils.isNoMorePageToLoad(params.page, res);
				self.upcomingEventParams.page = params.page;
				self.isUsomcingEventsWorking = false;
				self.spinnerUpcomingEvents.isVisible = false;
			}).catch(function (err) {
				self.isUsomcingEventsWorking = false;
				self.spinnerUpcomingEvents.isVisible = false;
				console.log(err);
			})
		}

		function getlistPastEvents(params, isFresh) {
			if(self.isPastEventsWorking || self.spinnerPastEvents.isVisible) return;
			self.isPastEventsWorking = true;
			self.spinnerPastEvents.isVisible = true;
			pixerfApiEventSvc.getEvents(params).$promise.then(function (res) {
				if (!self.pastEvents || isFresh) self.pastEvents = [];
				self.pastEvents = self.pastEvents.concat(res.data);
				self.isLastPastEvent = pagingUtils.isNoMorePageToLoad(params.page, res);
				self.pastEventParams.page = params.page;
				self.isPastEventsWorking = false;
				self.spinnerPastEvents.isVisible = false;
			}).catch(function (err) {
				self.isPastEventsWorking = false;
				self.spinnerPastEvents.isVisible = false;
				console.log(err);
			})
		}

		function onSearchEvents() {
			self.events = [];
			self.searchEventParams.page = 1;
			if (self.searchEventsString) {
				self.searchEventParams.keywords = self.searchEventsString;
			} else {
				delete self.searchEventParams.keywords;
			}
			getSearchEvents(self.searchEventParams, true);
		}

		function getSearchEvents(params, isFresh) {
			self.isWorking = true;
			self.spinner.isVisible = true;
			pixerfApiEventSvc.getEvents(params).$promise.then(function (res) {
				if (!self.searchEvents || isFresh) self.searchEvents = [];
				self.searchEvents = self.searchEvents.concat(res.data);
				self.isLastSearchEvent = pagingUtils.isNoMorePageToLoad(params.page, res);
				self.searchEventParams.page = params.page;
				self.isWorking = false;
				self.spinner.isVisible = false;
			}).catch(function (err) {
				self.isWorking = false;
				self.spinner.isVisible = false;
				console.log(err);
			})
		}

		function fetchMoreEvents(type) {
			var searchParams;
			switch (type) {
				case 'upcoming':
					if (self.isLastUpcomingEvent || self.spinner.isVisible) return;
					searchParams = $.extend(true, {}, self.upcomingEventParams);
					searchParams.page++;
					getlistUpcomingEvents(searchParams);
					break;
				case 'past':
					if (self.isLastPastEvent || self.spinner.isVisible) return;
					searchParams = $.extend(true, {}, self.pastEventParams);
					searchParams.page++;
					getlistPastEvents(searchParams);
					break;
				default:
					if (self.isLastSearchEvent || self.spinner.isVisible) return;
					searchParams = $.extend(true, {}, self.searchEventParams);
					searchParams.page++;
					getSearchEvents(searchParams)
					break;
			}
		}
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('communityDetailAlbumDetailsCtrl', communityDetailAlbumDetailsCtrl);

	communityDetailAlbumDetailsCtrl.$inject = ["$scope", "$stateParams", "pixerfApiCommunitySvc", "createCommunityAlbumPopupSvc", "uploadCommunityAlbumPhotoSvc", "sessionManagerSvc", "toastr", "pixerfConfirmPopupSvc", "$state"];

	function communityDetailAlbumDetailsCtrl($scope, $stateParams, pixerfApiCommunitySvc, createCommunityAlbumPopupSvc, uploadCommunityAlbumPhotoSvc, sessionManagerSvc, toastr, pixerfConfirmPopupSvc, $state) {
		var self = this;
		self.onEditAlbum = onEditAlbum;
		self.community = $scope.$parent.vm.community;
		self.album = {};
		self.photos = [];
		self.onUploadBtnClicked = onUploadBtnClicked;
		self.onDeletePhotoAlbum = onDeletePhotoAlbum;
		self.onDeleteAlbum = onDeleteAlbum;
		self.setAsCover = setAsCover;
		self.loginUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.isMine = self.loginUser && self.community.owner.id === self.loginUser.id;

		init();

		function init() {
			getAlbumDetails($stateParams.albumId);
		}

		function getAlbumDetails(id) {
			pixerfApiCommunitySvc.show_community_album({
				album_id: id
			}).$promise.then(function (result) {
				self.album = result;
				self.photos = result.photos;
			}).catch(function (err) {
				console.log(err);
			})
		}

		function onUploadBtnClicked() {
			var uploadPopup = uploadCommunityAlbumPhotoSvc.showUploadModal({
				albumId: $stateParams.albumId
			});
			uploadPopup.result.then(function (data) {
				getAlbumDetails($stateParams.albumId);
			})
		}

		function onEditAlbum() {
			var editAlbumPopup = createCommunityAlbumPopupSvc.showPopup({
				communityId: self.community.id,
				albumId: $stateParams.albumId
			});

			editAlbumPopup.result.then(function (data) {
				if (!data) return;
				self.album.name = data.name;
			})
		}

		function onDeletePhotoAlbum(photo) {
			var modal = pixerfConfirmPopupSvc.showPopup({
				hideTitle: true,
				hideConfirmText: true,
				message: "Are you sure you want to delete this photo?"
			});

			modal.result.then(function () {
				pixerfApiCommunitySvc.delete_photo_community_album({
					id: photo.id
				}).$promise.then(function (respone) {
					self.photos = _.reject(self.photos, function (it) {
						return it.id === photo.id;
					})
					toastr.success("Photo has been successfully deleted!");
				}).catch(function (err) {
					console.log(err);
				});
			});
		}

		function setAsCover(photo) {
			pixerfApiCommunitySvc.set_as_cover({
				id: $stateParams.albumId
			}, {
				cover_photo_id: photo.id
			}).$promise.then(function (respone) {
				toastr.success("This photo is set as cover for this album!");
			}).catch(function (err) {
				console.log(err);
			})
		}

		function onDeleteAlbum(){
			var modal = pixerfConfirmPopupSvc.showPopup({
				hideTitle: true,
				hideConfirmText: true,
				message: "Are you sure you want to delete this album?"
			});

			modal.result.then(function () {
				pixerfApiCommunitySvc.delete_community_album({
					id: self.album.id
				}).$promise.then(function (respone) {
					$state.go("community-detail-page.community-detail-photos", {id: self.community.id});
					toastr.success("Album " + self.album.name + " has been successfully deleted!");
				}).catch(function (err) {
					console.log(err);
				});
			});
		}
	}
})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.constant('translationConst', {
			"OOPS": "oops",
			"EDIT": "edit",
			"CANCEL": "cancel",
			"CONTINUE": "continue",
			"PLEASE_TRY_AGAIN": "please-try-again",
			"SOME_THING_WRONG": "looks-like-something-went-wrong",
			"SOMETHING_HAS_BEEN_DONE": "something-has-been-done",
			"SOME_THING_WRONG_WHEN_LIKE_PHOTO": "something-went-wrong-when-like-this-photo",
			"LOGIN_TO_USE_FUNCTION": "login-or-sign-up-to-use-function",
			"FAILED_PHOTO_DETAILS": "failed-photo-details",
			"LOGIN_TO_FOLLOW_PERSON": "login-or-sign-up-to-follow-person",
			"LOGIN_TO_FOLLOW_GALLERY": "login-or-sign-up-to-follow-gallery",
			"LOGIN_TO_SUGESST_PERSON": "login-or-sign-up-to-suggest-person",
			"LOGIN_TO_VERIFY_PERSON": "login-or-sign-up-to-verify-person",
			"SUBMISSION_WAIT_FOR_CURATION": "submission-received-wait-for-curation",
			"PORTFOLIO_GALLERY": "portfolio-gallery",
			"SUCCESSFULLY_UPDATED": "successfully-updated",
			"SUCCESSFULLY_DELETED": "successfully-deleted",
			"PORTFOLIO_GALLERY_CREATED": "portfolio-gallery-created",
			"ADD_NEW_PORTFOLIO_GALLERY": "add-new-portfolio-gallery",
			"CANNOT_GET_GALLERY_DETAIL": "cannot-get-gallery-detail",
			"ARE_YOU_SURE_TO_DO_SOMETHING": "are-you-sure-to-do-something",
			"DELETE_THIS_GALLERY": "are-you-sure-you-want-to-delete-this-gallery",
			"DELETE_THIS_PHOTO": "are-you-sure-you-want-to-delete-this-photo",
			"DELETE_THIS_PHOTOS": "are-you-sure-you-want-to-delete-this-photos",
			"DELETE_THIS_MISSION": "delete-this-mission",
			"DELETE_THIS_PORTFOLIO_GALLERY": "are-you-sure-you-want-to-delete-this-portfolio-gallery",
			"PAY_THIS_MISSION": "are-you-sure-you-want-to-pay-this-mission",
			"LAUNCH_THIS_MISSION": "are-you-sure-you-want-to-launch-this-mission",
			"SUBMIT_THIS_MISSION": "are-you-sure-you-want-to-submit-mission",
			"DELETE_THIS_COMMUNITY": "are-you-sure-you-want-to-delete-this-community",
			"FAILED_PENDING_PHOTOS": "failed-pending-photos",
			"FAILED_REJECTED_PHOTOS": "failed-rejected-photos",
			"FAILED_APPROVED_PHOTOS": "failed-approved-photos",
			"FAILED_GET_PHOTOS": "failed-get-photos",
			"FAILED_PURCHASED_ITEMS": "failed-purchased-items",
			"FAILED_ORDER_LIST": "failed-order-list",
			"THIS_COMMUNITY": "this-community",
			"THIS_PHOTO": "this-photo",
			"FAILED_GET_COMMENTS": "failed-get-comments",
			"LEAVE_THE_COMMUNITY": "leave-the-community",
			"WITHDRAW_REQUEST_JOIN_THE_COMMUNITY": "withdraw-request-to-join-community",
			"WITHDRAW_REQUEST_JOIN_THE_COMMUNITIES": "withdraw-request-to-join-communities",
			"ALL_FIELDS_REQUIRED": "all-fields-required"
		});
})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.constant('messageConst', {
			"error": {
				"SOME_THING_WRONG": "oops-looks-like-something-went-wrong",
				"MISSION_CART": "{quantity, plural, =1{This photo}other{Photos}}{photo_name} {quantity, plural, =1{is}other{are}} temporarily unavailable for licensing in the Marketplace as {quantity, plural, =1{it is}other{they are}} currently part of a Mission.",
				"CART_ITEM_REMOVED": "{quantity, plural, =1{This photo is}other{Those photos are}} not in your cart anymore or temporarily unavailable for licensing in the Marketplace!",
				"CALL_TO_ACTION_REMOVE_ITEM_TO_CHECKOUT": "Please remove the photo(s) from your cart and checkout again!",
				"PRICE_NOT_ALLOWED": "Oops! This price point is not available for your account type. Please refresh and try again.",
				"MY_CREDIT_INSUFFICIENT_FUNDS": "Oops! Looks like your credit balance is not enough. Please topup your credit balance then try again!",
				"EMAIL_REQUIRED": "Please input your email!",
				"EMAIL_FORMAT_ERROR": "Invalid email address!",
				"SAVE_COMMENT": "Failed to save comment!",
				"YOU_SELECTED_MAXIMUM_PHOTOS_ALLOWED": "you-selected-maximum-photos-allowed",
				"SUBMIT_PER_MISSION": "submit-this-mission"
			},
			"success": {
				"PHOTO_GALLERY_ADDED_REMOVED": "This photo has been successfully {action, select, addPhotoToGallery{added to} other{removed from}}  gallery: {gallery_name} ",
				"SUBSCRIBE": "Thanks for subscribing to XERFIE!",
				"USER_INFO_UPDATED": "user-info-updated",
				"YOUR_PHOTO_SUBMITTED_TO_MISSION": "your-photo-submitted-to-mission"
			},
			"FOLLOW": "follow",
			"UNFOLLOW": "unfollow",
			"FOLLOWING": "following",
			"FOLLOWINGS": "followings",
			"FOLLOWING_BTN": "following-button",
			"info": {
				"FOR_PHOTOGRAPHERS_IN": "For Photographers in Indonesia only"
			},
			"BROADCAST": {
				"USER_DATA_CHANGE": "USER_DATA_CHANGE",
				"TOOGLE_CART_POPUP": "TOOGLE_CART_POPUP",
				"OMISE_CHECKOUT_ERROR": "OMISE_CHECKOUT_ERROR",
				"PAYMENT_CARD_INFO": "PAYMENT_CARD_INFO",
				"PAYMENT_CARD_INFO_REFILL": "PAYMENT_CARD_INFO_REFILL",
				"ACTION_PAY_AFTER_SIGNED": "ACTION_PAY_AFTER_SIGNED",
				'BULK_EDIT_PHOTO': 'BULK_EDIT_PHOTO',
				'BULK_SELECTED_PHOTO_CHANGED': 'BULK_SELECTED_PHOTO_CHANGED',
				'BULK_SELECTED_PHOTO_CANCEL': 'BULK_SELECTED_PHOTO_CANCEL',
				'BULK_PHOTO_STATE_CHANGED': 'BULK_PHOTO_STATE_CHANGED'
			},
		});
})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.constant('messageAccountConst', {
			"error": {
				"validation": {
					"password": {
						"required": "Please fill in your new password",
						"format": "Password must be at least 8 characters long and include 1 lower and 1 uppercase letter, and 1 numeric character."
					},
					"email": {
						"invalid_format": "Email is not valid",
						"free_email": "You are using free email. Please user company email to register for business account."
					}
				}
			},
			"reset_password": {
				"success": "Password for account <%=email%> is changed. <%=message%>",
				"link_used": "The link to reset password can only be used once.",
			},
			"verify_account": {
				"success": "You’re now a PIxerfer! Get started on your PIXERF journey by uploading your photos and establishing your online presence. All it takes is three easy steps: <br/>",
				"link_used": "The link to verify account can only be used once."

			}
		});
})();

 (function () {

 	angular
 		.module('pixerf')
 		.controller('trendingPhotoCtrl', trendingPhotoCtrl);

 	trendingPhotoCtrl.$inject = ['$scope', '$state', 'stringUtils', 'sessionManagerSvc', '$location', 'numberUtils', 'systemUtils', '$rootScope',
		'messageConst', 'bulkEditPhotoPopupSvc'];

 	function trendingPhotoCtrl($scope, $state, stringUtils, sessionManagerSvc, $location, numberUtils, systemUtils, $rootScope,
		messageConst, bulkEditPhotoPopupSvc) {
 		var self = this;
 		$scope.$parent.vm.contextPage = "Trending";
 		self.photoGrid = null;
 		self.params = {};
 		self.onLoadMorePage = onLoadMorePage;
 		self.onScrollToPhoto = onScrollToPhoto;
 		self.onCurrentPageChanged = onCurrentPageChanged;
		self.loginnedUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.bulkEditPhoto = bulkEditPhoto;
		self.selectPhotoBtnClicked = selectPhotoBtnClicked;

		self.canBulkEditPhoto = self.loginnedUser && (self.loginnedUser.isAdminInternal || self.loginnedUser.isCurator || self.loginnedUser.isAdmin);
 		self.pagingBarSetting = {
 			zIndex: 550,
 			marginTop: _.debounce(function () {
 				return $(".buy-stock-page__top-navigation").height() + $(".main-header").height();
 			}, 500),
 			preFixed: function () {
 				$(this).addClass('paging-bar-fixed');
 			},
 			postFixed: function () {
 				$(this).removeClass('paging-bar-fixed');
 			},
			 dontSetWidth: true
 		}

		self.isSelectedPhotos = false;
		self.bulkSelectedPhoto = []
		self.options ={
			bulkEditPhoto: self.isSelectedPhotos,
			bulkSelectedPhoto: self.bulkSelectedPhoto,
			onBulkEditChanged: onBulkEditChanged
		}
		$scope.$on(messageConst.BROADCAST.BULK_SELECTED_PHOTO_CANCEL, function(){
			selectPhotoBtnClicked(false);
		});

 		init();

		function onBulkEditChanged(data){
			self.bulkSelectedPhoto = data
		}

		function bulkEditPhoto(){
			var bulkEditPhotoPopup = bulkEditPhotoPopupSvc.showUploadModal({photos:self.bulkSelectedPhoto});
		}
		function selectPhotoBtnClicked(value){
			self.isSelectedPhotos = !self.isSelectedPhotos;
			self.options.bulkEditPhoto = self.isSelectedPhotos;
			if(value == false){
				self.options.bulkSelectedPhoto = [];
				self.bulkSelectedPhoto = [];
				return self.photoGrid.reRender();
			}
			self.photoGrid.reRender();
		}

 		function extractSearchParam() {
 			var arr = [];
 			$state.params.type = 'trending';
 			if ($state.params.categoryIds) {
 				var categoryIds = $state.params.categoryIds.split(",");
 				for (var i = 0; i < categoryIds.length; i++) {
 					arr.push({
 						id: numberUtils.parseInt(categoryIds[i])
 					});

 				}
 			}
 			self.selectedCategories = arr;
 			self.params.page = 1;
 			if ($state.params.page) {
 				self.params.page = numberUtils.parseInt($state.params.page);
 			}
 			self.page = self.params.page ? self.params.page : 1;
 			if ($state.params.categoryIds) {
 				self.params.categoryIds = $state.params.categoryIds.split(",");
 			}
 			self.params.state = 't';
 		}

 		function updateUrlParams(page) {
 			// if (systemUtils.isMobile()) {
 			// 	$state.params.page = "";
 			// 	$state.go($state.current.name, $state.params, {
 			// 		notify: false
 			// 	});
 			// 	return;
 			// }
 			self.page = page;
 			$state.params.page = page;
			if (!systemUtils.isMobile()) {
				$state.go($state.current.name, $state.params, {
					notify: false
				});
			}
 		}

 		function onLoadMorePage(page) {
 			updateUrlParams(page);
 		}

 		function onScrollToPhoto(page) {
 			updateUrlParams(page);
 		}

 		function onCurrentPageChanged(pageNumber) {
 			var route = $state.current;
 			$state.go(route, {
 				page: pageNumber
 			});
 		}

 		function init() {
 			sessionManagerSvc.setMarketplaceTabHistory($location.$$url);
 			$scope.$watch("vm.photoGrid", function () {
 				if (self.photoGrid && $scope.$parent) {
 					extractSearchParam();
 					self.pagerText = stringUtils.toTitleCase($state.params.type).replace(/-/g, " ");
 					self.mobileBreadcrumb = self.pagerText;
 					self.page = self.params.page;
 					self.pagerUnit = null;
 					self.photoGrid.fetchPhotos(self.params, true).then(function () {
 						if ($scope.$parent && self) {
 							self.totalPage = self.photoGrid.totalPage;
 							self.totalPhotos = self.photoGrid.totalPhotos;
 						}
 					});
 				}
 			})
 		}
 	}
 })();

(function () {

    angular
        .module('pixerf')
        .controller('temporaryPhotosCtrl', temporaryPhotosCtrl);

    temporaryPhotosCtrl.$inject = ['$scope', '$state', 'stringUtils', 'sessionManagerSvc', '$location', 'numberUtils', 'systemUtils'];

    function temporaryPhotosCtrl($scope, $state, stringUtils, sessionManagerSvc, $location, numberUtils, systemUtils) {
        var self = this;
        $scope.$parent.vm.contextPage = "Temporary Photos";
        self.photoGrid = null;
        self.params = {};
        self.onLoadMorePage = onLoadMorePage;
        self.onScrollToPhoto = onScrollToPhoto;
        self.onCurrentPageChanged = onCurrentPageChanged;
        self.pagingBarSetting = {
            zIndex: 550,
            marginTop: _.debounce(function () {
               return $(".buy-stock-page__top-navigation").height() + $(".main-header").height();
           }, 500),
            preFixed: function () {
                $(this).addClass('paging-bar-fixed');
            },
            postFixed: function () {
                $(this).removeClass('paging-bar-fixed');
            },
            dontSetWidth: true
        }

        init();

        function extractSearchParam() {
            var arr = [];
            $state.params.type = 'temporary';
            if ($state.params.categoryIds) {
                var categoryIds = $state.params.categoryIds.split(",");
                for (var i = 0; i < categoryIds.length; i++) {
                    arr.push({
                        id: numberUtils.parseInt(categoryIds[i])
                    });

                }
            }
            self.selectedCategories = arr;
            self.params.page = 1;
            if ($state.params.page) {
                self.params.page = numberUtils.parseInt($state.params.page);
            }
            self.page = self.params.page ? self.params.page : 1;
            if ($state.params.categoryIds) {
                self.params.categoryIds = $state.params.categoryIds.split(",");
            }
            self.params.state = 'p';
        }

        function updateUrlParams(page) {
            // if (systemUtils.isMobile()) {
            //     $state.params.page = "";
            //     $state.go($state.current.name, $state.params, {
            //         notify: false
            //     });
            //     return;
            // }
            self.page = page;
            $state.params.page = page;
            if (!systemUtils.isMobile()) {
                $state.go($state.current.name, $state.params, {
                    notify: false
                });
            }
        }

        function onLoadMorePage(page) {
            updateUrlParams(page);
        }

        function onScrollToPhoto(page) {
            updateUrlParams(page);
        }

        function onCurrentPageChanged(pageNumber) {
            var route = $state.current;
            $state.go(route, {
                page: pageNumber
            });
        }

        function init() {
            sessionManagerSvc.setMarketplaceTabHistory($location.$$url);
            $scope.$watch("vm.photoGrid", function () {
                if (self.photoGrid && $scope.$parent) {
					extractSearchParam();
					self.pagerText = stringUtils.toTitleCase($state.params.type).replace(/-/g, " ");
 					self.mobileBreadcrumb = self.pagerText;
 					self.page = self.params.page;
 					self.pagerUnit = null;
					self.photoGrid.isTemporaryType = true;
					self.photoGrid.fetchPhotos(self.params, true).then(function () {
						if ($scope.$parent && self) {
                            self.totalPage = self.photoGrid.totalPage;
                            self.totalPhotos = self.photoGrid.totalPhotos;
                        }
					});
				}
            })
        }
    }
})();

(function () {

	angular
		.module('pixerf')
		.controller('stockGalleriesCtrl', stockGalleriesCtrl);

	stockGalleriesCtrl.$inject = ['sessionManagerSvc', '$state', '$scope'];

	function stockGalleriesCtrl(sessionManagerSvc, $state, $scope) {
		var self = this;
		$scope.$parent.vm.contextPage = "Galleries";
		self.onGalleriesTypeChanged = onGalleriesTypeChanged;
		self.parent = $scope.$parent.vm;
		self.parent.mobileBreadcrumb = "Galleries";
		self.loginUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.closeCreditPlanPopup = closeCreditPlanPopup;
		self.logKey = logKey;
		self.galleriesType = [{
				value: "signature",
				title: "Signature Galleries"
			},
			{
				value: "pixerfer",
				title: "Pixerfer Galleries"
			}
		];

		init();

		function init() {
			if (self.loginUser) {
				self.galleriesType.push({
					value: "followed",
					title: "Galleries you follow"
				});
			}
			if (self.loginUser && self.loginUser.isAdminInternal) {
				self.galleriesType.push({
					value: "curated",
					title: "Curated galleries"
				});
			}
			switch ($state.current.name) {
				case 'buy-stock-page.galleries.followed-galleries':
					generateTemplate('followed');
					break;
				case 'buy-stock-page.galleries.curated-galleries':
					generateTemplate('curated');
					break;
				case 'buy-stock-page.galleries.pixerfer-galleries':
					generateTemplate('pixerfer');
					break;
				default:
					generateTemplate();
			}
		}

		function generateTemplate(value) {
			switch (value) {
				case 'pixerfer':
					self.defaultGalleriesType = self.galleriesType[1].value;
					break;
				case 'followed':
					self.defaultGalleriesType = self.galleriesType[2].value;
					break;
				case 'curated':
					self.defaultGalleriesType = self.galleriesType[3].value;
					break;
				default:
					self.defaultGalleriesType = self.galleriesType[0].value;

			}
			switch (self.defaultGalleriesType) {
				case 'pixerfer':
					self.header = "Pixerfer galleries";
					self.description = "A curated look into our gallery of authentic images from Pixerfers.";
					self.showCreditPlanBar = false;
					break;
				case 'followed':
					self.header = "Galleries you followed";
					self.description = "";
					self.showCreditPlanBar = false;
					break;
				case 'curated':
					self.header = "Curated galleries";
					self.description = "The best of PIXERF, curated by our curating team";
					self.showCreditPlanBar = false;
					break;
				default:
					self.header = "Signature galleries";
					self.description = "Discover the finest selection of Asian stock images in every category and make it yours, starting from $5.<br/>Curated by our in-house photography pros.";
					self.showCreditPlanBar = !self.loginUser || (self.loginUser && self.loginUser.canBuyCreditPlan);
			}
		}

		function onGalleriesTypeChanged(data) {
			self.defaultGalleriesType = data.value;
			generateTemplate(data.value);
			switch (data.value) {
				case 'pixerfer':
					$state.go('buy-stock-page.galleries.pixerfer-galleries');
					break;
				case 'followed':
					$state.go('buy-stock-page.galleries.followed-galleries');
					break;
				case 'curated':
					$state.go('buy-stock-page.galleries.curated-galleries');
					break;
				default:
					$state.go('buy-stock-page.galleries.signature-galleries');
			}
		}

		function closeCreditPlanPopup(){
            $('.collapse').collapse('hide');
        }

        function logKey(e) {
			switch (e.which) {
				case 27:
					closeCreditPlanPopup();
			}
        }
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.config(routerConfig);

	routerConfig.$inject = ['$stateProvider'];

	function routerConfig($stateProvider) {
		'ngInject';
		$stateProvider
			.state('buy-stock-page.galleries', {
				abstract: true,
				url: '/galleries?categoryIds&page',
				templateUrl: 'app/buy-stock-page/components/stock-galleries/stock-galleries.html',
				controller: 'stockGalleriesCtrl',
				controllerAs: 'vm',
                data: {
					pageTitle: "PIXERF - Galleries",
					hideFooter: true
                }
			})
			.state('buy-stock-page.galleries.pixerfer-galleries', {
				url: '/pixerfer-galleries',
				templateUrl: 'app/buy-stock-page/components/stock-galleries/components/pixerfer-galleries/pixerfer-galleries.html',
				controller: 'pixerferGalleriesCtrl',
				controllerAs: 'vm',
                data: {
					pageTitle: "PIXERF - Pixerfer galleries"
                }
			})
			.state('buy-stock-page.galleries.followed-galleries', {
				url: '/followed-galleries',
				templateUrl: 'app/buy-stock-page/components/stock-galleries/components/followed-galleries/followed-galleries.html',
				controller: 'followedGalleriesCtrl',
				controllerAs: 'vm',
                data: {
					pageTitle: "PIXERF - Followed galleries"
                }
			})
			.state('buy-stock-page.galleries.curated-galleries', {
				url: '/curated-galleries',
				templateUrl: 'app/buy-stock-page/components/stock-galleries/components/curated-galleries/curated-galleries.html',
				controller: 'curatedGalleriesCtrl',
				controllerAs: 'vm',
                data: {
					pageTitle: "PIXERF - Curated galleries"
                }
			})
			.state('buy-stock-page.galleries.signature-galleries', {
				url: '',
				templateUrl: 'app/buy-stock-page/components/stock-galleries/components/signature-galleries/signature-galleries.html',
				controller: 'signatureGalleriesCtrl',
				controllerAs: 'vm',
                data: {
					pageTitle: "PIXERF - Signature galleries"
                }
			});
	}
})();

 (function () {

 	angular
 		.module('pixerf')
 		.controller('stockSearchResultPageCtrl', stockSearchResultPageCtrl);

 	stockSearchResultPageCtrl.$inject = ['$scope', '$state', 'searchInputSvc', '$timeout', 'stringUtils', 'headerSvc'];

 	function stockSearchResultPageCtrl($scope, $state, searchInputSvc, $timeout, stringUtils, headerSvc) {
 		var self = this;

 		self.search = search;
 		self.onLoadMorePage = onLoadMorePage;
 		self.onSearchConditionClicked = _.debounce(onSearchConditionClicked, 300);
 		self.onFilterCheckboxClicked = onFilterCheckboxClicked;
 		self.onScrollToPhoto = onScrollToPhoto;
 		self.onCurrentPageChanged = onCurrentPageChanged;
 		self.onFileRemoved = onFileRemoved;
 		self.photoPager = null;
 		self.photoGrid = null;
 		self.page = 1;
 		self.totalPage = 0;
 		self.isShowAllFilters = false;
 		self.keywords = null;
 		self.searchFilterBarSettings = {
			zIndex: 550,
			marginTop: _.debounce(function () {
				return $(".buy-stock-page__top-navigation").height() + $(".main-header").height();
			}, 500),
			preFixed: function () {
				$(this).addClass('paging-bar-fixed');
			},
			postFixed: function () {
				$(this).removeClass('paging-bar-fixed');
			}
		};
 		self.categoryBtnSettings = {
 			dropdownClass: 'gallery-categoryIds-dropdown-menu',
 			dynamicButtonTextSuffix: ' Categories Selected',
 			smartButtonMaxItems: 3,
 			caretClass: 'icon-icons_chevron-down',
 			closeOnClick: true,
 			singleClick: true,
 			uncheckCustomText: 'All categories',
 			buttonClasses: 'multiple-dropdown-selection__btn-dropdown',
 			events: {
 				onSelectionChanged: function () {
 					self.onSearchConditionClicked();
 				}
 			}
 		}
 		self.pagingBarSetting = {
			dontSetWidth: true,
 			zIndex: 550,
 			marginTop: _.debounce(function () {
				return $(".buy-stock-page__top-navigation").height() + $(".main-header").height();
 			}, 500),
 			preFixed: function () {
 				$(this).addClass('paging-bar-fixed');
 			},
 			postFixed: function () {
 				$(this).removeClass('paging-bar-fixed');
 			}
 		}

 		resetFilter();
 		init();

 		function init() {
 			extractSearchParam($state.params);
 			$scope.$watch("vm.photoGrid", function () {
 				if (self.photoGrid) {
 					self.search();
 				}
 			})
 		}

 		function resetFilter() {
 			self.selectedCategories = [];
 			self.selectedOrientation = null;
 			self.selectedUsage = null;
 			self.selectedSize = null;
 		}

 		function onFilterCheckboxClicked() {
 			if (!self.isShowAllFilters) {
 				var isHasFilter = !self.selectedOrientation.isDefault || !self.selectedUsage.isDefault || !self.selectedSize.isDefault || self.selectedCategories.length > 0;
 				resetFilter();
 				var searchParams = {
 					orientation: null,
 					license: null,
 					megapixels: null,
 					categoryIds: null
 				}
 				$state.go("buy-stock-page.search-result-page", searchParams, {
 					notify: false
 				});
 				if (isHasFilter) {
 					search();
 				}
 			}

 		}

 		function extractSearchParam() {
 			if ($state.params.keywords) {
 				searchInputSvc.setTags($state.params.keywords.split(","));
 				self.keywords = $state.params.keywords;
 				self.type = $state.params.type;
 				$timeout(function () {
 					$(window).trigger("resize.ScrollToFixed");
 				});
 			}
 			self.selectedCategories = [];

 			if (typeof $state.params.categoryIds == 'string') {
 				var categoryIds = $state.params.categoryIds.split(",");
 				var arr = [];
 				for (var i = 0; i < categoryIds.length; i++) {
 					arr.push({
 						id: parseInt(categoryIds[i])
 					});

 				}
 				self.selectedCategories = arr;
 			} else if (typeof $state.params.categoryIds == 'object') {
 				self.selectedCategories = $state.params.categoryIds;
 			}
 			if ($state.params.orientation) {
 				self.selectedOrientation = {
 					value: $state.params.orientation
 				};
 			}
 			if ($state.params.license) {
 				self.selectedUsage = {
 					value: $state.params.license
 				};
 			}
 			if ($state.params.megapixels) {
 				self.selectedSize = {
 					value: $state.params.megapixels
 				};
 			}
 			if ($state.params.page) {
 				self.page = $state.params.page;
 			}

 			self.isShowAllFilters = !!($state.params.categoryIds || $state.params.orientation || $state.params.license || $state.params.megapixels);
 		}

 		function onSearchConditionClicked() {
 			var searchParams = buildSearchParams();
 			$state.go("buy-stock-page.search-result-page", searchParams, {
 				notify: false
 			});
 			search();
 		}

 		function search() {
 			if (self.photoGrid) {
 				var params = buildSearchParams();
 				return self.photoGrid.fetchPhotos(params, true);
 			}
 		}

 		function buildSearchParams() {
 			var params = {
 				page: self.page ? self.page : 1
 			};
 			if (self.selectedCategories.length > 0) {
 				params.categoryIds = [];
 				for (var i = 0; i < self.selectedCategories.length; i++) {
 					if (self.selectedCategories[i].id) {
 						params.categoryIds.push(self.selectedCategories[i].id);
 					} else {
 						params.categoryIds.push(self.selectedCategories[i]);
 					}
 				}
 				params.categoryIds = stringUtils.arrayToString(params.categoryIds);
 			}
 			if (self.selectedOrientation && !self.selectedOrientation.isDefault) {
 				params.orientation = self.selectedOrientation.value;
 			}
 			if (self.selectedSize && !self.selectedSize.isDefault) {
 				params.megapixels = self.selectedSize.value;
 			}
 			if (self.selectedUsage && !self.selectedUsage.isDefault) {
 				params.license = self.selectedUsage.value;
 			}
 			if (self.keywords) {
 				params.keywords = self.keywords;
 			}
 			return params;
 		}

 		function updateUrl() {
 			var searchParams = buildSearchParams();
 			$state.go("buy-stock-page.search-result-page", searchParams, {
 				notify: false
 			});
 		}

 		function onLoadMorePage(page) {
 			self.page = page;
 			updateUrl();
 		}

 		function onCurrentPageChanged(pageNumber) {
 			updateUrl();
 			search();
 		}

 		function onScrollToPhoto(page) {
 			self.page = page;
 			updateUrl();
 		}

 		function onFileRemoved() {
 			self.photoGrid.totalPhotos--;
 		}

 	}
 })();

(function () {

    angular
        .module('pixerf')
        .controller('rejectedPhotosCtrl', rejectedPhotosCtrl);

    rejectedPhotosCtrl.$inject = ['$scope', '$state', 'stringUtils', 'sessionManagerSvc', '$location', 'numberUtils', 'systemUtils'];

    function rejectedPhotosCtrl($scope, $state, stringUtils, sessionManagerSvc, $location, numberUtils, systemUtils) {
        var self = this;
        $scope.$parent.vm.contextPage = "Rejected Photos";
        self.photoGrid = null;
        self.params = {};
        self.onLoadMorePage = onLoadMorePage;
        self.onScrollToPhoto = onScrollToPhoto;
        self.onCurrentPageChanged = onCurrentPageChanged;
        self.pagingBarSetting = {
            zIndex: 550,
            marginTop: _.debounce(function () {
               return $(".buy-stock-page__top-navigation").height() + $(".main-header").height();
           }, 500),
            preFixed: function () {
                $(this).addClass('paging-bar-fixed');
            },
            postFixed: function () {
                $(this).removeClass('paging-bar-fixed');
            },
            dontSetWidth: true
        }

        init();

        function extractSearchParam() {
            var arr = [];
            $state.params.type = 'rejected';
            if ($state.params.categoryIds) {
                var categoryIds = $state.params.categoryIds.split(",");
                for (var i = 0; i < categoryIds.length; i++) {
                    arr.push({
                        id: numberUtils.parseInt(categoryIds[i])
                    });

                }
            }
            self.selectedCategories = arr;
            self.params.page = 1;
            if ($state.params.page) {
                self.params.page = numberUtils.parseInt($state.params.page);
            }
            self.page = self.params.page ? self.params.page : 1;
            if ($state.params.categoryIds) {
                self.params.categoryIds = $state.params.categoryIds.split(",");
            }
            self.params.state = 'r';
        }

        function updateUrlParams(page) {
            // if (systemUtils.isMobile()) {
            //     $state.params.page = "";
            //     $state.go($state.current.name, $state.params, {
            //         notify: false
            //     });
            //     return;
            // }
            self.page = page;
            $state.params.page = page;
            if (!systemUtils.isMobile()) {
                $state.go($state.current.name, $state.params, {
                    notify: false
                });
            }
        }

        function onLoadMorePage(page) {
            updateUrlParams(page);
        }

        function onScrollToPhoto(page) {
            updateUrlParams(page);
        }

        function onCurrentPageChanged(pageNumber) {
            var route = $state.current;
            $state.go(route, {
                page: pageNumber
            });
        }

        function init() {
            sessionManagerSvc.setMarketplaceTabHistory($location.$$url);
            $scope.$watch("vm.photoGrid", function () {
                if (self.photoGrid && $scope.$parent) {
                    extractSearchParam();
                    self.pagerText = stringUtils.toTitleCase($state.params.type).replace(/-/g, " ");
                    self.mobileBreadcrumb = self.pagerText;
                    self.page = self.params.page;
                    self.pagerUnit = null;
                    self.photoGrid.fetchPhotos(self.params, true).then(function () {
                        if ($scope.$parent && self) {
                            self.totalPage = self.photoGrid.totalPage;
                            self.totalPhotos = self.photoGrid.totalPhotos;
                        }
                    });
                }
            })
        }
    }
})();

(function () {

    angular
        .module('pixerf')
        .controller('pendingPortfolioCtrl', pendingPortfolioCtrl);

    pendingPortfolioCtrl.$inject = ['$scope', '$state', 'stringUtils', 'sessionManagerSvc', '$location', 'numberUtils', 'systemUtils'];

    function pendingPortfolioCtrl($scope, $state, stringUtils, sessionManagerSvc, $location, numberUtils, systemUtils) {
        var self = this;
        $scope.$parent.vm.contextPage = "Pending Portfolio";
        self.photoGrid = null;
        self.params = {};
        self.onLoadMorePage = onLoadMorePage;
        self.onScrollToPhoto = onScrollToPhoto;
        self.onCurrentPageChanged = onCurrentPageChanged;
        self.pagingBarSetting = {
            zIndex: 550,
            marginTop: _.debounce(function () {
               return $(".buy-stock-page__top-navigation").height() + $(".main-header").height();
           }, 500),
            preFixed: function () {
                $(this).addClass('paging-bar-fixed');
            },
            postFixed: function () {
                $(this).removeClass('paging-bar-fixed');
            },
            dontSetWidth: true
        }

        init();

        function extractSearchParam() {
            var arr = [];
            self.params.sort = ["inserted_at,asc"];
			self.params.type = "portfolio";
            if ($state.params.categoryIds) {
                var categoryIds = $state.params.categoryIds.split(",");
                for (var i = 0; i < categoryIds.length; i++) {
                    arr.push({
                        id: numberUtils.parseInt(categoryIds[i])
                    });

                }
            }
            self.selectedCategories = arr;
            self.params.page = 1;
            if ($state.params.page) {
                self.params.page = numberUtils.parseInt($state.params.page);
            }
            self.page = self.params.page ? self.params.page : 1;
            if ($state.params.categoryIds) {
                self.params.categoryIds = $state.params.categoryIds.split(",");
            }
            self.params.state = 'h';
        }

        function updateUrlParams(page) {
            // if (systemUtils.isMobile()) {
            //     $state.params.page = "";
            //     $state.go($state.current.name, $state.params, {
            //         notify: false
            //     });
            //     return;
            // }
            self.page = page;
            $state.params.page = page;
            if (!systemUtils.isMobile()) {
                $state.go($state.current.name, $state.params, {
                    notify: false
                });
            }
        }

        function onLoadMorePage(page) {
            updateUrlParams(page);
        }

        function onScrollToPhoto(page) {
            updateUrlParams(page);
        }

        function onCurrentPageChanged(pageNumber) {
            var route = $state.current;
            $state.go(route, {
                page: pageNumber
            });
        }

        function init() {
            sessionManagerSvc.setMarketplaceTabHistory($location.$$url);
            $scope.$watch("vm.photoGrid", function () {
                if (self.photoGrid && $scope.$parent) {
                    extractSearchParam();
                    self.pagerText = stringUtils.toTitleCase($state.params.type).replace(/-/g, " ");
                    self.mobileBreadcrumb = self.pagerText;
                    self.page = self.params.page;
                    self.pagerUnit = null;
                    self.photoGrid.fetchPhotos(self.params, true).then(function () {
                        if ($scope.$parent && self) {
                            self.totalPage = self.photoGrid.totalPage;
                            self.totalPhotos = self.photoGrid.totalPhotos;
                        }
                    });
                }
            })
        }
    }
})();

(function () {

    angular
        .module('pixerf')
        .controller('pendingPhotosCtrl', pendingPhotosCtrl);

    pendingPhotosCtrl.$inject = ['$scope', '$state', 'stringUtils', 'sessionManagerSvc', '$location', 'numberUtils', 'systemUtils',
        'messageConst', 'bulkEditPhotoPopupSvc'];

    function pendingPhotosCtrl($scope, $state, stringUtils, sessionManagerSvc, $location, numberUtils, systemUtils,
        messageConst, bulkEditPhotoPopupSvc) {
        var self = this;
        $scope.$parent.vm.contextPage = "Pending Photos";
        self.photoGrid = null;
        self.params = {};
        self.onLoadMorePage = onLoadMorePage;
        self.onScrollToPhoto = onScrollToPhoto;
        self.onCurrentPageChanged = onCurrentPageChanged;
        self.pagingBarSetting = {
            zIndex: 550,
            marginTop: _.debounce(function () {
               return $(".buy-stock-page__top-navigation").height() + $(".main-header").height();
           }, 500),
            preFixed: function () {
                $(this).addClass('paging-bar-fixed');
            },
            postFixed: function () {
                $(this).removeClass('paging-bar-fixed');
            },
            dontSetWidth: true
        }

        self.loginnedUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.isSelectedPhotos = false;
		self.bulkSelectedPhoto = []
		self.bulkEditPhoto = bulkEditPhoto;
		self.selectPhotoBtnClicked = selectPhotoBtnClicked;
        self.options ={
			bulkEditPhoto: self.isSelectedPhotos,
			bulkSelectedPhoto: self.bulkSelectedPhoto,
			onBulkEditChanged: onBulkEditChanged
		}

		$scope.$on(messageConst.BROADCAST.BULK_SELECTED_PHOTO_CANCEL, function(){
			selectPhotoBtnClicked(false);
		});
		self.canBulkEditPhoto = self.loginnedUser && (self.loginnedUser.isAdminInternal || self.loginnedUser.isCurator || self.loginnedUser.isAdmin);

        init();

        function onBulkEditChanged(data){
			self.bulkSelectedPhoto = data
		}

		function bulkEditPhoto(){
			var bulkEditPhotoPopup = bulkEditPhotoPopupSvc.showUploadModal({photos:self.bulkSelectedPhoto});
		}
		function selectPhotoBtnClicked(value){
			self.isSelectedPhotos = !self.isSelectedPhotos;
			self.options.bulkEditPhoto = self.isSelectedPhotos;
			if(value == false){
				self.options.bulkSelectedPhoto = [];
				self.bulkSelectedPhoto = [];
				return self.photoGrid.reRender();
			}
			self.photoGrid.reRender();
		}

        function extractSearchParam() {
            var arr = [];
            $state.params.type = 'pending';
            if ($state.params.categoryIds) {
                var categoryIds = $state.params.categoryIds.split(",");
                for (var i = 0; i < categoryIds.length; i++) {
                    arr.push({
                        id: numberUtils.parseInt(categoryIds[i])
                    });

                }
            }
            self.selectedCategories = arr;
            self.params.page = 1;
            if ($state.params.page) {
                self.params.page = numberUtils.parseInt($state.params.page);
            }
            self.page = self.params.page ? self.params.page : 1;
            if ($state.params.categoryIds) {
                self.params.categoryIds = $state.params.categoryIds.split(",");
            }
            self.params.state = 'h';
        }

        function updateUrlParams(page) {
            // if (systemUtils.isMobile()) {
            //     $state.params.page = "";
            //     $state.go($state.current.name, $state.params, {
            //         notify: false
            //     });
            //     return;
            // }
            self.page = page;
            $state.params.page = page;
            if (!systemUtils.isMobile()) {
                $state.go($state.current.name, $state.params, {
                    notify: false
                });
            }
        }

        function onLoadMorePage(page) {
            updateUrlParams(page);
        }

        function onScrollToPhoto(page) {
            updateUrlParams(page);
        }

        function onCurrentPageChanged(pageNumber) {
            var route = $state.current;
            $state.go(route, {
                page: pageNumber
            });
        }

        function init() {
            sessionManagerSvc.setMarketplaceTabHistory($location.$$url);
            $scope.$watch("vm.photoGrid", function () {
                if (self.photoGrid && $scope.$parent) {
                    extractSearchParam();
                    self.pagerText = stringUtils.toTitleCase($state.params.type).replace(/-/g, " ");
                    self.mobileBreadcrumb = self.pagerText;
                    self.page = self.params.page;
                    self.pagerUnit = null;
                    self.photoGrid.fetchPhotos(self.params, true).then(function () {
                        if ($scope.$parent && self) {
                            self.totalPage = self.photoGrid.totalPage;
                            self.totalPhotos = self.photoGrid.totalPhotos;
                        }
                    });
                }
            })
        }
    }
})();

(function () {

    angular
        .module('pixerf')
        .controller('pendingCommercialLicenseCtrl', pendingCommercialLicenseCtrl);

    pendingCommercialLicenseCtrl.$inject = ['$scope', '$state', 'stringUtils', 'sessionManagerSvc', '$location', 'numberUtils', 'systemUtils'];

    function pendingCommercialLicenseCtrl($scope, $state, stringUtils, sessionManagerSvc, $location, numberUtils, systemUtils) {
        var self = this;
        $scope.$parent.vm.contextPage = "Pending Commercial License";
        self.photoGrid = null;
        self.params = {};
        self.onLoadMorePage = onLoadMorePage;
        self.onScrollToPhoto = onScrollToPhoto;
        self.onCurrentPageChanged = onCurrentPageChanged;
        self.pagingBarSetting = {
            zIndex: 550,
            marginTop: _.debounce(function () {
               return $(".buy-stock-page__top-navigation").height() + $(".main-header").height();
           }, 500),
            preFixed: function () {
                $(this).addClass('paging-bar-fixed');
            },
            postFixed: function () {
                $(this).removeClass('paging-bar-fixed');
            },
            dontSetWidth: true
        }

        init();

        function extractSearchParam() {
            var arr = [];
            $state.params.type = 'pending';
            if ($state.params.categoryIds) {
                var categoryIds = $state.params.categoryIds.split(",");
                for (var i = 0; i < categoryIds.length; i++) {
                    arr.push({
                        id: numberUtils.parseInt(categoryIds[i])
                    });

                }
            }
            self.selectedCategories = arr;
            self.params.page = 1;
            if ($state.params.page) {
                self.params.page = numberUtils.parseInt($state.params.page);
            }
            self.page = self.params.page ? self.params.page : 1;
            if ($state.params.categoryIds) {
                self.params.categoryIds = $state.params.categoryIds.split(",");
            }
            self.params.status = 'pending';
            self.params.license = 'commercial';
        }

        function updateUrlParams(page) {
            // if (systemUtils.isMobile()) {
            //     $state.params.page = "";
            //     $state.go($state.current.name, $state.params, {
            //         notify: false
            //     });
            //     return;
            // }
            self.page = page;
            $state.params.page = page;
            if (!systemUtils.isMobile()) {
                $state.go($state.current.name, $state.params, {
                    notify: false
                });
            }
        }

        function onLoadMorePage(page) {
            updateUrlParams(page);
        }

        function onScrollToPhoto(page) {
            updateUrlParams(page);
        }

        function onCurrentPageChanged(pageNumber) {
            var route = $state.current;
            $state.go(route, {
                page: pageNumber
            });
        }

        function init() {
            sessionManagerSvc.setMarketplaceTabHistory($location.$$url);
            $scope.$watch("vm.photoGrid", function () {
                if (self.photoGrid && $scope.$parent) {
                    extractSearchParam();
                    self.pagerText = stringUtils.toTitleCase($state.params.type).replace(/-/g, " ");
                    self.mobileBreadcrumb = self.pagerText;
                    self.page = self.params.page;
                    self.pagerUnit = null;
                    self.photoGrid.fetchPhotos(self.params, true).then(function () {
                        if ($scope.$parent && self) {
                            self.totalPage = self.photoGrid.totalPage;
                            self.totalPhotos = self.photoGrid.totalPhotos;
                        }
                    });
                }
            })
        }
    }
})();

(function () {

    angular
        .module('pixerf')
        .controller('generalPhotosCtrl', generalPhotosCtrl);

    generalPhotosCtrl.$inject = ['$scope', '$state', 'stringUtils', 'sessionManagerSvc', '$location', 'numberUtils', 'systemUtils'];

    function generalPhotosCtrl($scope, $state, stringUtils, sessionManagerSvc, $location, numberUtils, systemUtils) {
        var self = this;
        $scope.$parent.vm.contextPage = "General Photos";
        self.photoGrid = null;
        self.params = {};
        self.onLoadMorePage = onLoadMorePage;
        self.onScrollToPhoto = onScrollToPhoto;
        self.onCurrentPageChanged = onCurrentPageChanged;
        self.pagingBarSetting = {
            zIndex: 550,
            marginTop: _.debounce(function () {
               return $(".buy-stock-page__top-navigation").height() + $(".main-header").height();
           }, 500),
            preFixed: function () {
                $(this).addClass('paging-bar-fixed');
            },
            postFixed: function () {
                $(this).removeClass('paging-bar-fixed');
            },
            dontSetWidth: true
        }

        init();

        function extractSearchParam() {
            var arr = [];
            $state.params.type = 'general';
            if ($state.params.categoryIds) {
                var categoryIds = $state.params.categoryIds.split(",");
                for (var i = 0; i < categoryIds.length; i++) {
                    arr.push({
                        id: numberUtils.parseInt(categoryIds[i])
                    });

                }
            }
            self.selectedCategories = arr;
            self.params.page = 1;
            if ($state.params.page) {
                self.params.page = numberUtils.parseInt($state.params.page);
            }
            self.page = self.params.page ? self.params.page : 1;
            if ($state.params.categoryIds) {
                self.params.categoryIds = $state.params.categoryIds.split(",");
            }
            self.params.state = 'g';
        }

        function updateUrlParams(page) {
            // if (systemUtils.isMobile()) {
            //     $state.params.page = "";
            //     $state.go($state.current.name, $state.params, {
            //         notify: false
            //     });
            //     return;
            // }
            self.page = page;
            $state.params.page = page;
            if (!systemUtils.isMobile()) {
                $state.go($state.current.name, $state.params, {
                    notify: false
                });
            }
        }

        function onLoadMorePage(page) {
            updateUrlParams(page);
        }

        function onScrollToPhoto(page) {
            updateUrlParams(page);
        }

        function onCurrentPageChanged(pageNumber) {
			var route = $state.current;
			$state.go(route, { page: pageNumber });
		}

        function init() {
            sessionManagerSvc.setMarketplaceTabHistory($location.$$url);
            $scope.$watch("vm.photoGrid", function () {
                if (self.photoGrid && $scope.$parent) {
                    extractSearchParam();
                    self.pagerText = stringUtils.toTitleCase($state.params.type).replace(/-/g, " ");
                    self.mobileBreadcrumb = self.pagerText;
                    self.page = self.params.page;
                    self.pagerUnit = null;
                    self.photoGrid.fetchPhotos(self.params, true).then(function () {
                        if ($scope.$parent && self) {
                            self.totalPage = self.photoGrid.totalPage;
                            self.totalPhotos = self.photoGrid.totalPhotos;
                        }
                    });
                }
            })
        }
    }
})();

(function () {

	angular
		.module('pixerf')
		.controller('editorPickCtrl', editorPickCtrl);

	editorPickCtrl.$inject = ['$scope', '$state', 'stringUtils', 'sessionManagerSvc', '$location', 'numberUtils', 'systemUtils'];

	function editorPickCtrl($scope, $state, stringUtils, sessionManagerSvc, $location, numberUtils, systemUtils) {
		var self = this;
		$scope.$parent.vm.contextPage = "Editor's Pick";
		self.photoGrid = null;
		self.params = {};
		self.onLoadMorePage = onLoadMorePage;
		self.onScrollToPhoto = onScrollToPhoto;
		self.onCurrentPageChanged = onCurrentPageChanged;
		self.pagingBarSetting = {
			zIndex: 550,
			marginTop: _.debounce(function () {
			   return $(".buy-stock-page__top-navigation").height() + $(".main-header").height();
		   }, 500),
			preFixed: function () {
				$(this).addClass('paging-bar-fixed');
			},
			postFixed: function () {
				$(this).removeClass('paging-bar-fixed');
			},
            dontSetWidth: true
		}
		
		init();

		function extractSearchParam() {
			var arr = [];
			$state.params.type = "editor's-pick";
			if ($state.params.categoryIds) {
				var categoryIds = $state.params.categoryIds.split(",");
				for (var i = 0; i < categoryIds.length; i++) {
					arr.push({
						id: numberUtils.parseInt(categoryIds[i])
					});

				}
			}
			self.selectedCategories = arr;
			self.params.page = 1;
			if ($state.params.page) {
				self.params.page = numberUtils.parseInt($state.params.page);
			}
			self.page = self.params.page ? self.params.page : 1;
			if ($state.params.categoryIds) {
				self.params.categoryIds = $state.params.categoryIds.split(",");
			}
			self.params.state = 'e';
		}

		function updateUrlParams(page) {
			// if (systemUtils.isMobile()) {
			// 	$state.params.page = "";
			// 	$state.go($state.current.name, $state.params, {
			// 		notify: false
			// 	});
			// 	return;
			// }
			self.page = page;
			$state.params.page = page;
			if (!systemUtils.isMobile()) {
				$state.go($state.current.name, $state.params, {
					notify: false
				});
			}
		}

		function onLoadMorePage(page) {
			updateUrlParams(page);
		}

		function onScrollToPhoto(page) {
			updateUrlParams(page);
		}

		function onCurrentPageChanged(pageNumber) {
			var route = $state.current;
			$state.go(route, { page: pageNumber });
		}

		function init() {
			sessionManagerSvc.setMarketplaceTabHistory($location.$$url);
			$scope.$watch("vm.photoGrid", function () {
				if (self.photoGrid && $scope.$parent) {
					extractSearchParam();
					self.pagerText = stringUtils.toTitleCase($state.params.type).replace(/-/g, " ");
					self.mobileBreadcrumb = self.pagerText;
					self.page = self.params.page;
					self.pagerUnit = null;
					self.photoGrid.fetchPhotos(self.params, true).then(function () {
						if ($scope.$parent && self) {
							self.totalPage = self.photoGrid.totalPage;
							self.totalPhotos = self.photoGrid.totalPhotos;
						}
					});
				}
			})
		}
	}
})();

(function () {

	angular
		.module('pixerf')
		.factory('aboutStockSvc', aboutStockSvc);

        aboutStockSvc.$inject = [];

	function aboutStockSvc() {

		var mBannerBox = {
			style: {
				styleBackgroundBox: 'black--02',
				styleButton: 'magento-btn',
			},
			title: 'Buy the best photos of Asia you can’t find in any other marketplace.',
			description: 'Unique, royalty-free photos for all your creative projects.',
			buttonText: 'Buy a Credit Plan'
		};

        var categoriesQA = [
			{id: 13, name: 'Abstract', thumbnails: 'assets/images/about-stock/category-1.jpg'},
			{id: 34, name: 'Aerial', thumbnails: 'assets/images/about-stock/category-2.jpg'},
			{id: 42, name: 'Agriculture', thumbnails: 'assets/images/about-stock/category-3.jpg'},
			{id: 8, name: 'Animals', thumbnails: 'assets/images/about-stock/category-4.jpg'},
			{id: 3, name: 'Architecture', thumbnails: 'assets/images/about-stock/category-5.jpg'},
			{id: 18, name: 'Arts', thumbnails: 'assets/images/about-stock/category-6.jpg'},
			{id: 24, name: 'Asian Faces', thumbnails: 'assets/images/about-stock/category-7.jpg'},
			{id: 45, name: 'Automotive', thumbnails: 'assets/images/about-stock/category-8.jpg'},
			{id: 44, name: 'Beauty', thumbnails: 'assets/images/about-stock/category-9.jpg'},
			{id: 9, name: 'Black & White', thumbnails: 'assets/images/about-stock/category-10.jpg'},
			{id: 26, name: 'Business', thumbnails: 'assets/images/about-stock/category-11.jpg'},
			{id: 14, name: 'City', thumbnails: 'assets/images/about-stock/category-12.jpg'},
			{id: 46, name: 'Commercial', thumbnails: 'assets/images/about-stock/category-13.jpg'},
			{id: 23, name: 'Culture', thumbnails: 'assets/images/about-stock/category-14.jpg'},
			{id: 29, name: 'Education', thumbnails: 'assets/images/about-stock/category-15.jpg'}
		];
		var categoriesProd = [
			{id: 13, name: 'Abstract', thumbnails: 'assets/images/about-stock/category-1.jpg'},
			{id: 31, name: 'Aerial', thumbnails: 'assets/images/about-stock/category-2.jpg'},
			{id: 37, name: 'Agriculture', thumbnails: 'assets/images/about-stock/category-3.jpg'},
			{id: 8, name: 'Animals', thumbnails: 'assets/images/about-stock/category-4.jpg'},
			{id: 3, name: 'Architecture', thumbnails: 'assets/images/about-stock/category-5.jpg'},
			{id: 18, name: 'Arts', thumbnails: 'assets/images/about-stock/category-6.jpg'},
			{id: 24, name: 'Asian Faces', thumbnails: 'assets/images/about-stock/category-7.jpg'},
			{id: 43, name: 'Automotive', thumbnails: 'assets/images/about-stock/category-8.jpg'},
			{id: 39, name: 'Beauty', thumbnails: 'assets/images/about-stock/category-9.jpg'},
			{id: 9, name: 'Black & White', thumbnails: 'assets/images/about-stock/category-10.jpg'},
			{id: 26, name: 'Business', thumbnails: 'assets/images/about-stock/category-11.jpg'},
			{id: 14, name: 'City', thumbnails: 'assets/images/about-stock/category-12.jpg'},
			{id: 44, name: 'Commercial', thumbnails: 'assets/images/about-stock/category-13.jpg'},
			{id: 23, name: 'Culture', thumbnails: 'assets/images/about-stock/category-14.jpg'},
			{id: 29, name: 'Education', thumbnails: 'assets/images/about-stock/category-15.jpg'}
		];

		function getCategories() {
            var categories = {
                qa: categoriesQA,
                prod: categoriesProd
            };
			return categories;
		}

		function getBannerBox() {
			return mBannerBox;
		}

		return {
			getCategories: getCategories,
			getBannerBox: getBannerBox
		};
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('aboutStockCtrl', aboutStockCtrl);

	aboutStockCtrl.$inject = ['$scope', 'customCommissionBasicFormPopupSvc', '$timeout', '$anchorScroll', '$location', '$state', 'aboutStockSvc', 'emailUsPopupSvc', '$window'];

	function aboutStockCtrl($scope, customCommissionBasicFormPopupSvc, $timeout, $anchorScroll, $location, $state, aboutStockSvc, emailUsPopupSvc, $window) {

		var self = this;
		$scope.$parent.vm.contextPage = "Explore Stock";
		var pixerfEnv = new PixerfEnv().getEnv();
		var allCategories = aboutStockSvc.getCategories();
		self.bookAShoot = bookAShoot;
		self.moveTocreditPlansSection = moveTocreditPlansSection;
		self.goToHomepageContact = goToHomepageContact;
		self.buyCreditPlan = buyCreditPlan;
		self.categories = allCategories.prod;
		self.bookADemo = bookADemo;
		self.bannerBox = aboutStockSvc.getBannerBox();

		init();

		function init() {
			getCategories();
		}
		
        function bookAShoot() {
            $window.event.stopPropagation();
			customCommissionBasicFormPopupSvc.showPopup();
		}

		function moveTocreditPlansSection() {
            $window.event.stopPropagation();
			$timeout(function(){
				$location.hash('creditPlansSection');
				$anchorScroll();
			})
		}
		function goToHomepageContact(){
			$state.go('about-business-page.about-business', {
				section: 'generalContactFormSection'
			});
		}

		function getCategories(){
			self.categories = (pixerfEnv !== "PRODUCTION") ? allCategories.qa : allCategories.prod;
		}

		function bookADemo(){
			emailUsPopupSvc.showPopup();
		}

		function buyCreditPlan(){
            $window.event.stopPropagation();
			$timeout(function(){
				$location.hash('creditPlansSection');
				$anchorScroll();
			})
		}
	}
})();

(function () {

    angular
        .module('pixerf')
        .controller('discoverPhotoCtrl', discoverPhotoCtrl);

    discoverPhotoCtrl.$inject = ['$scope', '$state', 'stringUtils', 'sessionManagerSvc', '$location', 'numberUtils', 'systemUtils'];

    function discoverPhotoCtrl($scope, $state, stringUtils, sessionManagerSvc, $location, numberUtils, systemUtils) {
        var self = this;
        $scope.$parent.vm.contextPage = "Discover";
        self.photoGrid = null;
        self.params = {};
        self.onLoadMorePage = onLoadMorePage;
        self.onScrollToPhoto = onScrollToPhoto;
        self.onCurrentPageChanged = onCurrentPageChanged;
        self.pagingBarSetting = {
            zIndex: 550,
            marginTop: _.debounce(function () {
                return $(".buy-stock-page__top-navigation").height() + $(".main-header").height();
            }, 500),
            preFixed: function () {
                $(this).addClass('paging-bar-fixed');
            },
            postFixed: function () {
                $(this).removeClass('paging-bar-fixed');
            },
            dontSetWidth: true
        }

        init();

        function extractSearchParam() {
            var arr = [];
            $state.params.type = 'discover';
            if ($state.params.categoryIds) {
                var categoryIds = $state.params.categoryIds.split(",");
                for (var i = 0; i < categoryIds.length; i++) {
                    arr.push({
                        id: numberUtils.parseInt(categoryIds[i])
                    });

                }
            }
            self.selectedCategories = arr;
            self.params.page = 1;
            if ($state.params.page) {
                self.params.page = numberUtils.parseInt($state.params.page);
            }
            self.page = self.params.page ? self.params.page : 1;
            if ($state.params.categoryIds) {
                self.params.categoryIds = $state.params.categoryIds.split(",");
            }
            self.params.state = 'd';
        }

        function updateUrlParams(page) {
            // if (systemUtils.isMobile()) {
            //     $state.params.page = "";
            //     $state.go($state.current.name, $state.params, {
            //         notify: false
            //     });
            //     return;
            // }
            self.page = page;
            $state.params.page = page;
            if (!systemUtils.isMobile()) {
                $state.go($state.current.name, $state.params, {
                    notify: false
                });
            }
        }

        function onLoadMorePage(page) {
            updateUrlParams(page);
        }

        function onScrollToPhoto(page) {
            updateUrlParams(page);
        }

        function onCurrentPageChanged(pageNumber) {
            var route = $state.current;
            $state.go(route, {
                page: pageNumber
            });
        }

        function init() {
            sessionManagerSvc.setMarketplaceTabHistory($location.$$url);
            $scope.$watch("vm.photoGrid", function () {
                if (self.photoGrid && $scope.$parent) {
                    extractSearchParam();
                    self.pagerText = stringUtils.toTitleCase($state.params.type).replace(/-/g, " ");
                    self.mobileBreadcrumb = self.pagerText;
                    self.page = self.params.page;
                    self.pagerUnit = null;
                    self.photoGrid.fetchPhotos(self.params, true).then(function () {
                        if ($scope.$parent && self) {
                            self.totalPage = self.photoGrid.totalPage;
                            self.totalPhotos = self.photoGrid.totalPhotos;
                        }
                    });
                }
            })
        }
    }
})();

(function () {

	angular
		.module('pixerf')
		.factory('aboutCustomContentSvc', aboutCustomContentSvc);

        aboutCustomContentSvc.$inject = [];

	function aboutCustomContentSvc() {

		var mBannerBox = {
			style: {
				styleBackgroundBox: 'black--02',
				styleButton: 'light-blue-btn',
			},
			title: 'Book professional photo and video shoots anywhere in Asia and the world.',
			description: 'Get exclusive photos and videos shot the way you want it.',
			buttonText: 'Book a Shoot'
		};

        var mCategories = [
			{id: 1, name: 'Portrait', thumbnails: 'assets/images/about-custom-content/grid-1.jpg'},
			{id: 2, name: 'Event', thumbnails: 'assets/images/about-custom-content/grid-2.jpg'},
			{id: 3, name: 'Food & Beverage', thumbnails: 'assets/images/about-custom-content/grid-3.jpg'},
			{id: 4, name: 'Product', thumbnails: 'assets/images/about-custom-content/grid-4.jpg'},
			{id: 5, name: 'Aerial', thumbnails: 'assets/images/about-custom-content/grid-5.jpg'},
			{id: 6, name: 'Property', thumbnails: 'assets/images/about-custom-content/grid-6.jpg'},
			{id: 7, name: '360 Virtual', thumbnails: 'assets/images/about-custom-content/grid-7.jpg'},
			{id: 8, name: 'News & Media', thumbnails: 'assets/images/about-custom-content/grid-8.jpg'},
			{id: 9, name: 'Influencer', thumbnails: 'assets/images/about-custom-content/grid-9.jpg'}
		]

		var mBrands = [
			{ id: 1, photo: 'assets/images/about-custom-content/client-grabfood.png', photoMobile: 'assets/images/about-custom-content/client-grabfood-mobile.png' },
			{ id: 2, photo: 'assets/images/about-custom-content/client-honda-square.png', photoMobile: 'assets/images/about-custom-content/client-honda-mobile.png' },
			{ id: 3, photo: 'assets/images/about-custom-content/client-blackmore-square.png', photoMobile: 'assets/images/about-custom-content/client-blackmore-mobile.png' },
			{ id: 4, photo: 'assets/images/about-custom-content/client-people-association-square.png', photoMobile: 'assets/images/about-custom-content/client-people-association-mobile.png' },
			{ id: 5, photo: 'assets/images/about-custom-content/client-gurobu.png', photoMobile: 'assets/images/about-custom-content/client-gurobu-mobile.png' },
			{ id: 6, photo: 'assets/images/about-custom-content/client-celini-square.png', photoMobile: 'assets/images/about-custom-content/client-celini-mobile.png' },
			{ id: 7, photo: 'assets/images/about-custom-content/client-enterprise-singapore-square.png', photoMobile: 'assets/images/about-custom-content/client-enterprise-singapore-mobile.png' },
			{ id: 8, photo: 'assets/images/about-custom-content/client-petronas-square.png', photoMobile: 'assets/images/about-custom-content/client-petronas-mobile.png' },
			{ id: 9, photo: 'assets/images/about-custom-content/client-shield-square.png', photoMobile: 'assets/images/about-custom-content/client-shield-mobile.png' },
			{ id: 10, photo: 'assets/images/about-custom-content/client-skill-future-square.png', photoMobile: 'assets/images/about-custom-content/client-skill-future-mobile.png' },
		]
		
		function getCategories() {
			return mCategories;
		}

		function getBannerBox() {
			return mBannerBox;
		}

        function getBrands(){
            return mBrands;
        }

		return {
			getCategories: getCategories,
			getBannerBox: getBannerBox,
            getBrands: getBrands
		};
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('aboutCustomContentCtrl', aboutCustomContentCtrl);

	aboutCustomContentCtrl.$inject = ['$scope', 'customCommissionBasicFormPopupSvc', '$timeout', '$location', '$anchorScroll', 'emailUsPopupSvc', 'aboutCustomContentSvc', 'systemUtils',
		'$state'];

	function aboutCustomContentCtrl($scope, customCommissionBasicFormPopupSvc, $timeout, $location, $anchorScroll, emailUsPopupSvc, aboutCustomContentSvc, systemUtils,
		$state) {

		var self = this;
		$scope.$parent.vm.contextPage = "Explore custom content";
		self.bookShoot = bookShoot;
		self.viewCaseStudies = viewCaseStudies;
		self.runChallenge = runChallenge;
		self.onEmailUs = onEmailUs;
		self.bannerBox = aboutCustomContentSvc.getBannerBox();
		self.categories = aboutCustomContentSvc.getCategories();
		self.brands = aboutCustomContentSvc.getBrands();
		self.navigateNext = navigateNext;
		self.navigateRight = navigateRight;

		self.slickSetting = {
			onInit: function (slick) {
				self.slick = slick;
				systemUtils.digest($scope);
			},
			onAfterChange: function (event, slick, currentSlide) {
				if (slick.$slides.length == currentSlide + slick.options.slidesToScroll) {
					self.isLastBrandsSlide = true;
				} else {
					self.isLastBrandsSlide = false;
				}
				systemUtils.digest($scope);
			}
		}

		self.responsive = [{
			breakpoint: 1200,
			settings: {
				slidesToShow: 5,
				slidesToScroll: 5
			}
		}, {
			breakpoint: 992,
			settings: {
				slidesToShow: 4,
				slidesToScroll: 4
			}
		}, {
			breakpoint: 768,
			settings: {
				slidesToShow: 3,
				slidesToScroll: 3
			}
		}];

		function navigateNext() {
			self.slick.slickNext();
		}

		function navigateRight() {
			self.slick.slickPrev();
		}


		function bookShoot(categoryName) {
			customCommissionBasicFormPopupSvc.showPopup({category: categoryName, fromPage:'book-a-shoot-page.about-custom-content'});
		}

		function viewCaseStudies() {
			$timeout(function(){
				$location.hash('caseStudySection');
				$anchorScroll();
			})
		}

		function runChallenge() {
			$timeout(function(){
				$location.hash('generalContactFormSection');
				$anchorScroll();
			})
		}

		function onEmailUs(){
			emailUsPopupSvc.showPopup();
		}

		function init() {
			self.targetSection = $state.params.section ? $state.params.section : null;
			if (self.targetSection) {
				$location.hash(self.targetSection);
				$anchorScroll();
			}
		}

		init();
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('pricingCtrl', pricingCtrl);

	pricingCtrl.$inject = ['$scope', 'customCommissionBasicFormPopupSvc', 'emailUsPopupSvc', 'alertMessagePopupSvc', 'sessionManagerSvc', '$state', 'pagingUtils', '$timeout', '$anchorScroll', '$location', '$rootScope', 'systemUtils'];

	function pricingCtrl($scope, customCommissionBasicFormPopupSvc, emailUsPopupSvc, alertMessagePopupSvc, sessionManagerSvc, $state, pagingUtils, $timeout, $anchorScroll, $location, $rootScope, systemUtils) {
		var self = this;
		self.loginedUser = sessionManagerSvc.getCurrentLoginUser().data;
		$scope.$parent.vm.contextPage = "Pricing";
		self.onBookAShoot = onBookAShoot;
		self.onFindOutHow = onFindOutHow;
		self.onGetInTrouch = onGetInTrouch;
		self.onChallengePlanClicked = onChallengePlanClicked;
		self.onRequeestCustomPlan = onRequeestCustomPlan;
		self.onLaunchChallenge = onLaunchChallenge;
		self.onGoToSection = onGoToSection;
		self.subContextPage = "Book Your Shoot Now";

		self.subPricingNavOptions = {
			marginTop: _.debounce(function () {
				return 150;
			}, 500),
			limit: _.debounce(function () {
				return $(".pricing__col-right").height();
			}, 500),
			dontSetWidth: false,
			zIndex: 100
		}

		$rootScope.$on('pricingPageScroll#section-1', function () {
			self.subContextPage = "Book Your Shoot Now";
			self.isLightblueContext = true;
			self.isDarkblueContext = false;
			self.isRedContext = false;
			systemUtils.digest($scope);
		});

		$rootScope.$on('pricingPageScroll#section-2', function () {
			self.subContextPage = "Buy Photo Challenge Plans";
			self.isLightblueContext = false;
			self.isDarkblueContext = true;
			self.isRedContext = false;
			systemUtils.digest($scope);
		});

		$rootScope.$on('pricingPageScroll#section-3', function () {
			self.subContextPage = "Buy Stock Image Credit Plans";
			self.isLightblueContext = false;
			self.isDarkblueContext = false;
			self.isRedContext = true;
			systemUtils.digest($scope);
		});

		function onBookAShoot() {
			customCommissionBasicFormPopupSvc.showPopup();
		}

		function onFindOutHow() {
			emailUsPopupSvc.showPopup({topicId: 12});
		}

		function onChallengePlanClicked() {
			if (self.loginedUser && self.loginedUser.isContributor) {
				alertMessagePopupSvc.showPopup({
					title: "Challenges are only open to business account users."
				});
			} else {
				emailUsPopupSvc.showPopup();
			}
		}

		function onLaunchChallenge() {
			if (self.loginedUser && self.loginedUser.isContributor) {
				alertMessagePopupSvc.showPopup({
					title: "Challenges are only open to business account users."
				});
			} else {
				emailUsPopupSvc.showPopup();
			}
		}

		function onGetInTrouch() {
			emailUsPopupSvc.showPopup({topicId: 2});
		}

		function onRequeestCustomPlan() {
			emailUsPopupSvc.showPopup({topicId: 13});
		}

		function onGoToSection(section) {
			switch (section) {
				case "#section-1":
					self.subContextPage = "Book Your Shoot Now";
					break;
				case "#section-2":
					self.subContextPage = "Buy Photo Challenge Plans";
					break;
				case "#section-3":
					self.subContextPage = "Buy Stock Image Credit Plans";
					break;
				default:
					self.subContextPage = "Book Your Shoot Now";
			}
			pagingUtils.scrollToSection(section, 135);
		}

		function goToHash(targetSection){
			if (targetSection) {
				$timeout(function () {
					$location.hash(targetSection);
					$anchorScroll();
				})
			}
		}

		function init() {
			self.targetSection = $state.params.section ? $state.params.section : null;
			goToHash(self.targetSection)
			var locationHash = window.location.href.split('#')[2];
			if(locationHash && (locationHash == 'section-2')){
				$timeout(function () {
					onGoToSection('#section-2');
				}, 2000)
			}
		}

		init();
	}
})();

(function () {

	angular
		.module('pixerf')
		.factory('caseStudiesSvc', caseStudiesSvc);

	caseStudiesSvc.$inject = [];

	function caseStudiesSvc() {

		var mCaseStudies = [
            {id: 1, cover: 'assets/images/casestudies/case-study-petronas.jpg', logo: 'assets/images/casestudies/case-study-petronas-logo.png', owner: 'Petronas', type: 'Custom Content', isDash: true, subType: 'photography'},
            {id: 2, cover: 'assets/images/casestudies/case-study-shield.jpg', logo: 'assets/images/casestudies/case-study-shield-logo.png', owner: 'Shield', type: 'Custom Content', isDash: true, subType: 'videography'},
            {id: 3, cover: 'assets/images/casestudies/case-study-blackmores.jpg', logo: 'assets/images/casestudies/case-study-blackmores-logo.png', owner: 'Blackmores', type: 'Custom Content', isDash: true, subType: 'photography'},
            {id: 4, cover: 'assets/images/casestudies/case-study-gurobu.jpg', logo: 'assets/images/casestudies/case-study-gurobu-logo.png', owner: 'Gurobu', type: 'Custom Content', isDash: true, subType: 'photography'},
            {id: 5, cover: 'assets/images/casestudies/case-study-cellini.jpg', logo: 'assets/images/casestudies/case-study-cellini-logo.png', owner: 'Cellini', type: 'Custom Content', isDash: true, subType: 'photography'},
            {id: 6, cover: 'assets/images/casestudies/case-study-people.jpg', logo: 'assets/images/casestudies/case-study-people-logo.png', owner: 'People\'s Association', type: 'Custom Content', isDash: true, subType: 'photography & videography'},
            {id: 7, cover: 'assets/images/casestudies/case-study-storytel.jpg', logo: 'assets/images/casestudies/case-study-storytel-logo.png', owner: 'Storytel', type: 'photography'},
            {id: 8, cover: 'assets/images/casestudies/case-study-ademco.jpg', logo: 'assets/images/casestudies/case-study-ademco-logo.png', owner: 'Ademco', type: 'photography'},
            {id: 9, cover: 'assets/images/casestudies/case-study-enterprise.jpg', logo: 'assets/images/casestudies/case-study-enterprise-logo.png', owner: 'Enterprise Singapore', type: 'photography'},     
            {id: 10, cover: 'assets/images/casestudies/case-study-straits.jpg', logo: 'assets/images/casestudies/case-study-straits-logo.png', owner: 'Straits City', type: 'Community Challenge'},
            {id: 11, cover: 'assets/images/casestudies/case-study-gojek.jpg', logo: 'assets/images/casestudies/case-study-gojek-logo.png', owner: 'Gojek', type: 'Community Challenge'},
            {id: 12, cover: 'assets/images/casestudies/case-study-wwf.jpg', logo: 'assets/images/casestudies/case-study-wwf-logo.png', owner: 'WWF', type: 'Community Challenge'},
            {id: 13, cover: 'assets/images/casestudies/case-study-cooler.jpg', logo: 'assets/images/casestudies/case-study-cooler-logo.png', owner: 'Cooler Lumpur', type: 'Community Challenge'},
            {id: 14, cover: 'assets/images/casestudies/case-study-asian.jpg', logo: 'assets/images/casestudies/case-study-asian-logo.png', owner: 'Asian Geographic', type: 'Community Challenge'},
            {id: 15, cover: 'assets/images/casestudies/case-study-salam.jpg', logo: 'assets/images/casestudies/case-study-salam-logo.png', owner: 'Salam Singapore', type: 'Community Challenge'}
        ];

		function getCaseStudies() {
			return mCaseStudies;
		}

        function getTheRestCaseStudies(exceptId){
            var theRest = _.filter(mCaseStudies, function(cs){
                return cs.id != exceptId;
            })

            return theRest;
        }

		return {
			getCaseStudies: getCaseStudies,
            getTheRestCaseStudies: getTheRestCaseStudies
		};
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('caseStudiesCtrl', caseStudiesCtrl);

	caseStudiesCtrl.$inject = ['$scope', 'caseStudiesSvc'];

	function caseStudiesCtrl($scope, caseStudiesSvc) {

		var self = this;
		$scope.$parent.vm.contextPage = "Case Studies";

		self.caseStudies = caseStudiesSvc.getCaseStudies();
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.config(routerConfig);

	routerConfig.$inject = ['$stateProvider'];

	function routerConfig($stateProvider) {
		'ngInject';
		$stateProvider
			.state('about-business-page.case-studies', {
				abstract: true,
				url: '/case-studies',
				templateUrl: 'app/about-business-page/components/case-studies/case-studies.html',
				controller: 'caseStudiesCtrl',
				controllerAs: 'vm',
				data: {
					pageTitle: "PIXERF - Case Studies",
					permissions: {
						only: ['EVERY_ONE']
					},
					headerClass: 'case-study-highlight'
				}
			})
			.state('about-business-page.case-studies.case-study-details', {
				url: '/:id',
				templateUrl: 'app/about-business-page/components/case-studies/case-study-details/case-study-details.html',
				controller: 'caseStudyDetailsCtrl',
				controllerAs: 'vm',
				data: {
					pageTitle: "PIXERF - Case Studies Details",
					permissions: {
						only: ['EVERY_ONE']
					},
				},
				resolve: {
					caseStudy: function ($stateParams, caseStudyDetailsSvc, $state) {
						var caseStudies = caseStudyDetailsSvc.getCaseStudiesDetails();
						var caseStudy;
						caseStudy = _.find(caseStudies, function (cs) {
							return cs.id == $stateParams.id;
						})
						switch (caseStudy.id) {
							case 1:
								$state.go("about-business-page.case-studies.case-study-petronas", {
									id: caseStudy.id,
									name: 'petronas'
								});
								break;
							case 2:
								$state.go("about-business-page.case-studies.case-study-shield", {
									id: caseStudy.id,
									name: 'shield'
								});
								break;
							case 3:
								$state.go("about-business-page.case-studies.case-study-blackmores", {
									id: caseStudy.id,
									name: 'blackmores'
								});
								break;
							case 4:
								$state.go("about-business-page.case-studies.case-study-gurobu", {
									id: caseStudy.id,
									name: 'gurobu'
								});
								break;
							case 5:
								$state.go("about-business-page.case-studies.case-study-cellini", {
									id: caseStudy.id,
									name: 'cellini'
								});
								break;
							case 6:
								$state.go("about-business-page.case-studies.case-study-people-association", {
									id: caseStudy.id,
									name: 'people-association'
								});
								break;
							case 7:
								$state.go("about-business-page.case-studies.case-study-storytel", {
									id: caseStudy.id,
									name: 'storytel'
								});
								break;
							case 8:
								$state.go("about-business-page.case-studies.case-study-ademco", {
									id: caseStudy.id,
									name: 'ademco'
								});
								break;
							case 9:
								$state.go("about-business-page.case-studies.case-study-enterprise-singapore", {
									id: caseStudy.id,
									name: 'enterprise-singapore'
								});
								break;
							case 10:
								$state.go("about-business-page.case-studies.case-study-straits-city", {
									id: caseStudy.id,
									name: 'straits-city'
								});
								break;
							case 11:
								$state.go("about-business-page.case-studies.case-study-gojek", {
									id: caseStudy.id,
									name: 'gojek'
								});
								break;
							case 12:
								$state.go("about-business-page.case-studies.case-study-wwf", {
									id: caseStudy.id,
									name: 'wwf'
								});
								break;
							case 13:
								$state.go("about-business-page.case-studies.case-study-cooler-lumpur", {
									id: caseStudy.id,
									name: 'cooler-lumpur'
								});
								break;
							case 14:
								$state.go("about-business-page.case-studies.case-study-asian-geographic", {
									id: caseStudy.id,
									name: 'asian-geographic'
								});
								break;
							case 15:
								$state.go("about-business-page.case-studies.case-study-salam-singapore", {
									id: caseStudy.id,
									name: 'salam-singapore'
								});
								break;
						}
					}
				}
			})
			.state('about-business-page.case-studies.about-case-studies', {
				url: '',
				templateUrl: 'app/about-business-page/components/case-studies/about-case-studies/about-case-studies.html',
				controller: 'aboutCaseStudiesCtrl',
				controllerAs: 'vm',
				data: {
					pageTitle: "PIXERF - Explore Case Studiess",
					permissions: {
						only: ['EVERY_ONE']
					}
				},
				params: {
					"section": {
						squash: true,
						value: null
					}
				},
			});
	}
})();

(function () {

	angular
		.module('pixerf')
		.factory('aboutBusinessSvc', aboutBusinessSvc);

	aboutBusinessSvc.$inject = [];

	function aboutBusinessSvc() {

		var mColBoxData = [
			{"theme":"brown-1","icon":"icon-checkbox-border","text":"Access to a directory of amazing creators"},
			{"theme":"brown-1","icon":"icon-checkbox-border","text":"Support from a customer success manager"},
			{"theme":"brown-1","icon":"icon-checkbox-border","text":"Tools that make content creation simple"},
			{"theme":"brown-1","icon":"icon-checkbox-border","text":"Discounts on bookings of photo and video shoots"},
			{"theme":"brown-1","icon":"icon-checkbox-border","text":"Buy one, free one community challenges"}
		];

		var mBannerBox = {
			style: {
				styleBackgroundBox: 'white--065'
			},
			title: 'We make content creation simple. So you can	focus on your business.',
			description: 'More than 400 brands have signed up for a	free business account. Find out why.'
		};

		function getColBoxData() {
			return mColBoxData;
		}

		function getBannerBox() {
			return mBannerBox;
		}

		return {
			getColBoxData: getColBoxData,
			getBannerBox: getBannerBox
		};
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('aboutBusinessCtrl', aboutBusinessCtrl);

	aboutBusinessCtrl.$inject = ['$scope', 'aboutBusinessSvc', 'sessionManagerSvc', 'accountConst', '$timeout', '$location', '$anchorScroll', '$state', 'emailUsPopupSvc', 'signUpBusinessPopupSvc', '$window'];

	function aboutBusinessCtrl($scope, aboutBusinessSvc, sessionManagerSvc, accountConst, $timeout, $location, $anchorScroll, $state, emailUsPopupSvc, signUpBusinessPopupSvc, $window) {

		var self = this;
		$scope.$parent.vm.contextPage = "Explore Business";
		var mLoginUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.colBoxData = aboutBusinessSvc.getColBoxData();
		self.isLoggedInBusiness = (mLoginUser && mLoginUser.account_type === accountConst.ACCOUNT_TYPE.BUSINESS);
		self.runChallenge = runChallenge;
		self.onEmailUs = onEmailUs;
		self.bannerBox = aboutBusinessSvc.getBannerBox();
		self.onContactUsBtnClicked = onContactUsBtnClicked;
		self.onRequestADemoBtnClicked = onRequestADemoBtnClicked;
		self.bannerBtnText = mLoginUser && mLoginUser.isBiz ? 'Manage your profile' : 'Sign Up for Business Account';
		self.onSignUpBiz = onSignUpBiz;

		function runChallenge() {
			$timeout(function () {
				$location.hash('generalContactFormSection');
				$anchorScroll();
			})
		}

		function onSignUpBiz(){
            $window.event.stopPropagation();
			if (mLoginUser && mLoginUser.isBiz ) {
				$state.go("user-home-page.homepage", {
					id: mLoginUser.id
				});
			} else {
				signUpBusinessPopupSvc.showPopup();
			}
		}

		function onEmailUs() {
			emailUsPopupSvc.showPopup();
		}

		function onContactUsBtnClicked(){
			emailUsPopupSvc.showPopup();
		}

		function onRequestADemoBtnClicked(){
			emailUsPopupSvc.showPopup();
		}

		function init() {
			self.targetSection = $state.params.section ? $state.params.section : null;
			if (self.targetSection) {
				$timeout(function () {
					$location.hash(self.targetSection);
					$anchorScroll();
				})
			}
		}

		init();
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('portfolioDetailPagePhotosCtrl', portfolioDetailPagePhotosCtrl);

	portfolioDetailPagePhotosCtrl.$inject = ['$scope', '$stateParams', 'userPromise', '$state', 'uploadPortfolioPhotoSvc', 'sessionManagerSvc', 'pixerfApiGallerySvc', '$q', 'toastr', 'createPortfolioGallerySvc', 'commonConst', '$timeout'];

	function portfolioDetailPagePhotosCtrl($scope, $stateParams, userPromise, $state, uploadPortfolioPhotoSvc, sessionManagerSvc, pixerfApiGallerySvc, $q, toastr, createPortfolioGallerySvc, commonConst, $timeout) {
		var self = this;
		self.user = userPromise;
		self.isMine = sessionManagerSvc.isMine(self.user);
		self.breadcrumbRoot = "All";
		self.breadcrumbSublevel = $stateParams.name;
		self.portfolioName = $stateParams.name;
        self.portfolioType = $stateParams.type;
        self.goBackBtnClicked = goBackBtnClicked;
		self.showEditPortfolioGalleryPopup = showEditPortfolioGalleryPopup;
        self.portfolioGallery = {data: null};
        self.onUploadPortfolioPhoto = onUploadPortfolioPhoto;
        self.onPortfolioPhotoRemoved = onPortfolioPhotoRemoved;
        self.portfolioId = $stateParams.portfolioId;
        self.onPortfolioClicked = onPortfolioClicked;
		self.gallery = {
			id: $stateParams.galleryId,
			name: $stateParams.name
        };
        self.portfolio = {
			"grid": "photoGrid",
			"id": self.portfolioId,
			"name": ""
		};

		self.scrollOffsetTopPortfolio = 110;
		self.portfolioGrid = null;
        self.portfolioPhotoGrid = null;

		genBreadscrum($stateParams.portfolioId);

		function genBreadscrum(porfolioId){
            if(!self.user.profile) return;
            for (var i = 0; i < self.user.profile.specialities.length; i++){
                if(porfolioId == self.user.profile.specialities[i].id){
                    if(!self.breadcrumbSublevel){
                        self.breadcrumbSublevel = self.user.profile.specialities[i].name;
                        self.portfolio.name = self.breadcrumbSublevel;
                    }
                }
            }
		}

		$scope.$watch("vm.portfolioPhotoGrid", function(){
            if(!$stateParams.galleryId){
                $state.go("404");
                return;
            }
            if(self.portfolioPhotoGrid){
                fetchData().then(function(gallery){
                    if(!gallery){
                        toastr.error("Cannot get gallery detail. Please try again.");
                        return;
                    }
                    // portfolioGallery.isMine = sessionManagerSvc.isMine(portfolioGallery.user);
                    self.portfolioGallery.data = gallery;
                    self.user = gallery.user;
                    fetchPortfolioPhotos();
                }, function(){
                    toastr.error("Cannot get gallery detail. Please try again.");
                })
            }
		})

		function fetchPortfolioPhotos(){
            self.portfolioPhotoGrid.fetchPhotos({
                galleryIds: self.gallery.id + ""
            });
		}

		function fetchData(){
            var def = $q.defer();
            if($stateParams.portfolioGallery){
                def.resolve($stateParams.portfolioGallery);
            } else {
                fetchPortfolioGallery({
                    id: $stateParams.galleryId
                }).then(function(response){
                    def.resolve(response.data);
                }, function(){
                    def.reject();
                });
            }
            return def.promise;
        }
        function fetchPortfolioGallery(param){
            return pixerfApiGallerySvc.get(param).$promise;
        }

        function goBackBtnClicked(){
            window.history.back();
        }

		function showEditPortfolioGalleryPopup(){
            var modal = createPortfolioGallerySvc.showCreatePortfolioGalleryModal({mode: commonConst.ACTION.EDIT, portfolioGallery: self.portfolioGallery.data});
            modal.result.then(function(response){
                if(response.mode === commonConst.ACTION.DELETE){
                    goBackBtnClicked();
                } else {
                    self.isRefeshing = true;
                    $timeout(function(){
                        self.isRefeshing = false;
                    })
                }
            });
        }

        function onPortfolioPhotoRemoved(file){
            self.gallery.data.media_count -= 1;
            if(file.isMine){
                self.loginnedUser = sessionManagerSvc.getCurrentLoginUser().data;
                self.loginnedUser.stats.media_count --;
                sessionManagerSvc.setCurrentLoginUser(self.loginnedUser);
            }
        }

        function onUploadPortfolioPhoto(portfolioId){
            uploadPortfolioPhotoSvc.showUploadModal({portfolioId: portfolioId});
        }

        $scope.$watch("vm.portfolioGrid", function (portfolioGrid) {
            if (!portfolioGrid || !portfolioGrid.portfolio) return;
            fetchPortfolios("portfolioGrid", self.portfolioId);
        });

        function fetchPortfolios(name, id) {
			if (self[name]) {
				self[name].fetchPortfolios({
					speciality: id,
					userid: self.user.id,
					page: 1
				}, true);
			}
        }

        function onPortfolioClicked(portfolio) {
			$state.go(commonConst.STATE.PORTFOLIO_PHOTOS, { portfolioId: portfolio.portfolioId, galleryId: portfolio.id});
		}
	}
})();

/**
 * Controller for home module
 */
(function(){

  angular
    .module('pixerf')
    .controller('peoplesPageByAffectionsCtrl', peoplesPageByAffectionsCtrl);

    peoplesPageByAffectionsCtrl.$inject = ['$scope'];

    function peoplesPageByAffectionsCtrl($scope){
        var self = this;

        self.parent = $scope.$parent.vm;

        init();

        function init(){
            if(self.parent.initilizing){
                self.parent.initilizing = !self.parent.initilizing;
            } else {
                self.parent.peoples = null;
                self.parent.searchParams.page = 1;
                self.parent.fetchPeopleList();
            }
        }
    }
})();

(function(){

  angular
    .module('pixerf')
    .controller('notificationPageNotificationsCtrl', notificationPageNotificationsCtrl);

    notificationPageNotificationsCtrl.$inject = ['pagingUtils', '$timeout'];

    function notificationPageNotificationsCtrl(pagingUtils, $timeout){
        var self = this;
        self.onNotificationListInit = onNotificationListInit;
        self.scrollToTop = scrollToTop;

        function init(){
            showScrollBtn();
        }

        function onNotificationListInit(instance){
            self.notificationListInstance = instance;
            self.notificationListInstance.init();
        }

        function scrollToTop(){
            pagingUtils.scrollElementToTop('.notification-list.scroll-spy-component');
        }

        function showScrollBtn(){
            $timeout(function () {
                var element = angular.element(document.querySelector('.notification-page__notification-list-wrapper .notification-list.scroll-spy-component'));
                var scrollBtn = $('.notification-page__notification-list-wrapper .scroll-to-top-btn');
                element.bind('scroll', function () {
                    if (element.prop('scrollTop') > 1 * $(element).innerHeight()) {
                        scrollBtn.addClass('scroll-to-top-btn--show');
                    } else {
                        scrollBtn.removeClass('scroll-to-top-btn--show');
                    }
                })
            }, 200)
        }

        init();
    }
})();

(function() {
  'use strict';

  angular
    .module('pixerf')
    .config(routerConfig);

  routerConfig.$inject = ['$stateProvider'];

  function routerConfig($stateProvider) {
    'ngInject';
    $stateProvider
      .state('notification.notifications', {
        url: '/notifications',
        templateUrl: 'app/notification-page/notification-page-notifications/notification-page-notifications.html',
        controller: 'notificationPageNotificationsCtrl',
        controllerAs: 'vm',
        data: {
                permissions: {
                only: ['AUTHORIZED']
            },
            pageTitle: "PIXERF - Notifications",
            hideFooter: true
        }
      });
  }

})();

/**
 * Controller for notificationPage module
 */
(function(){

  angular
    .module('pixerf')
    .controller('notificationPageFollowingCtrl', notificationPageFollowingCtrl);
    function notificationPageFollowingCtrl(){
        var self = this;
        self.onNotificationListInit = onNotificationListInit;
        function onNotificationListInit(instance){
            self.notificationListInstance = instance;
            self.notificationListInstance.init();
        }

     
    }
})();

(function() {
  'use strict';

  angular
    .module('pixerf')
    .config(routerConfig);

  routerConfig.$inject = ['$stateProvider'];

  function routerConfig($stateProvider) {
    'ngInject';
    $stateProvider
      .state('notification.following', {
        url: '/following',
        templateUrl: 'app/notification-page/notification-page-following/notification-page-following.html',
        controller: 'notificationPageFollowingCtrl',
        controllerAs: 'vm',
        data: {
                permissions: {
                only: ['AUTHORIZED']
            },
            pageTitle: "PIXERF - Following",
            hideFooter: true
        }
      });
  }

})();

(function () {

	angular
		.module('pixerf')
		.controller('stayHomeStayCreativeCtrl', stayHomeStayCreativeCtrl);

	stayHomeStayCreativeCtrl.$inject = ['$scope', '$timeout', '$state', '$translate', '$rootScope', 'videoPopupSvc', '$interval', 'dateUtils', 'pixerfApiMissionSvc'];

	function stayHomeStayCreativeCtrl($scope, $timeout, $state, $translate, $rootScope, videoPopupSvc, $interval, dateUtils, pixerfApiMissionSvc) {
		var self = this;

		var today = new Date();
		self.scrollNextSection = scrollNextSection;
		self.goMissionDetail = goMissionDetail;
		self.selectedDefaultIndex = 0;
		self.seeMoreSmilesClicked = seeMoreSmilesClicked;
		self.videoSmiles = {
			"id": 0,
			"url": "https://pixerf-bucket.s3-ap-southeast-1.amazonaws.com/videos/v05_PIXERF+Wearasmile.mp4"
		}
		self.missionOutsideMyWindow = {
			id: 87,
			name: 'Outside My Window',
			startDate: new Date("05/01/2020"),
			endDate: new Date("05/31/2020"),
			remaining: 0,
			launchesDate: moment("05/01/2020").format("DD MMMM YYYY"),
			winners: "20 winners",
			value: "SGD50 each",
			label: 'coming-soon',
			btnText: 'join-the-mission',
			status: 'upcoming'
		}
		self.missionSuddenlyChef = {
			id: 88,
			name: 'Suddenly Chef',
			startDate: new Date("05/22/2020"),
			endDate: new Date("07/02/2020"),
			remaining: 0,
			launchesDate: moment("05/22/2020").format("DD MMMM YYYY"),
			winners: "20 winners",
			value: "SGD50 each",
			label: 'coming-soon',
			btnText: 'join-the-mission',
			status: 'upcoming'
		}
		self.missionFrameStories = {
			id: 89,
			name: '4-Frame Stories',
			startDate: new Date("06/19/2021"),
			endDate: new Date("07/19/2020"),
			remaining: 0,
			// winners: "20 winners",
			// value: "SGD50 each",
			customPrize: 'stayhomestaycreative-customprize-frameseries',
			launchesDate: "19 June 2020",
			winners: "20 winners",
			value: "SGD50 each",
			label: 'coming-soon',
			btnText: 'join-the-mission',
			status: 'upcoming'
		}
		self.language = {};
		self.onLanguagesSelected = onLanguagesSelected;
		self.languagesSetting = {
			"items": [{
					"name": "English",
					"value": "en"
				},
				{
					"name": "Bahasa Indonesia",
					"value": "id"
				}
			]
		};

		init();

		function init() {
			checkMissionLaunched(today.getTime());
			checkLaunchingMission();
			initLanguage();
		}

		function onLanguagesSelected(language) {
			$translate.use(language.value);
			$rootScope.lang = language.value;
			moment.locale(language.value);
			updateLocaleDate();
		}

		function initLanguage() {
			if ($translate.getAvailableLanguageKeys().includes(navigator.language)) {
				self.selectedDefaultIndex = self.languagesSetting.items.findIndex(function (langCode) {
					return langCode.value === navigator.language;
				})
				moment.locale(navigator.language);
				updateLocaleDate();
			}
		}

		function updateLocaleDate() {
			self.missionOutsideMyWindow.launchesDate = moment("05/01/2020").format("DD MMMM YYYY");
			self.missionSuddenlyChef.launchesDate = moment("05/22/2020").format("DD MMMM YYYY");
			self.missionFrameStories.launchesDate = moment("06/19/2020").format("DD MMMM YYYY");
		}

		function checkMissionLaunched(today) {
			if (today < self.missionOutsideMyWindow.startDate.getTime()) return;
			checkAward();

			if (today >= self.missionOutsideMyWindow.startDate.getTime() && today < self.missionOutsideMyWindow.endDate.getTime()) {
				self.missionOutsideMyWindow.label = 'ongoing-mission';
				self.missionOutsideMyWindow.status = 'happening';
				self.missionOutsideMyWindow.remaining = moment(self.missionOutsideMyWindow.endDate).diff(moment(), 'days');
			} else if (today > self.missionOutsideMyWindow.endDate.getTime()) {
				self.missionOutsideMyWindow.label = 'mission-closed';
				self.missionOutsideMyWindow.status = 'past';
			}

			if (today >= self.missionSuddenlyChef.startDate.getTime() && today < self.missionSuddenlyChef.endDate.getTime()) {
				self.missionSuddenlyChef.label = 'ongoing-mission';
				self.missionSuddenlyChef.status = 'happening';
				self.missionSuddenlyChef.remaining = moment(self.missionSuddenlyChef.endDate).diff(moment(), 'days');
				if (self.missionSuddenlyChef.remaining == 0) {
					$interval(function () {
						countDown(self.missionSuddenlyChef.endDate);
					}, 1000);
				}
			} else if (today > self.missionSuddenlyChef.endDate.getTime()) {
				self.missionSuddenlyChef.label = 'mission-closed';
				self.missionSuddenlyChef.status = 'past';
			}

			if (today >= self.missionFrameStories.startDate.getTime() && today < self.missionFrameStories.endDate.getTime()) {
				self.missionFrameStories.label = 'ongoing-mission';
				self.missionFrameStories.status = 'happening';
				self.missionFrameStories.remaining = moment(self.missionFrameStories.endDate).diff(moment(), 'days');
			} else if (today > self.missionFrameStories.endDate.getTime()) {
				self.missionFrameStories.label = 'mission-closed';
				self.missionFrameStories.status = 'past';
			}
		}

		function checkAward(){
			pixerfApiMissionSvc.get({
				id: self.missionOutsideMyWindow.id
			}).$promise.then(function (response) {
				if (response && response.mission && response.mission.is_closed) {
					self.missionOutsideMyWindow.isAwarded = response.mission.is_awarded;
					self.missionOutsideMyWindow.btnText =  response.mission.is_awarded ? "view-mission-winners" : "view-submissions";
				}
				return pixerfApiMissionSvc.get({
					id: self.missionSuddenlyChef.id
				}).$promise;
			}).then(function (response) {
				if (response && response.mission && response.mission.is_closed) {
					self.missionSuddenlyChef.isAwarded = response.mission.is_awarded;
					self.missionSuddenlyChef.btnText =  response.mission.is_awarded ? "view-mission-winners" : "view-submissions";
				}
				return pixerfApiMissionSvc.get({
					id: self.missionFrameStories.id
				}).$promise;
			}).then(function (response) {
				if (response && response.mission && response.mission.is_closed) {
					self.missionFrameStories.isAwarded = response.mission.is_awarded;
					self.missionFrameStories.btnText =  response.mission.is_awarded ? "view-mission-winners" : "view-submissions";
				}
			})
		}

		function checkLaunchingMission() {
			if (self.missionOutsideMyWindow.status === 'happening') {
				self.isFirstLauching = self.missionOutsideMyWindow;
			}
			if (self.missionSuddenlyChef.status === 'happening') {
				if (self.isFirstLauching && self.isFirstLauching.id) {
					self.isSecondLauching = self.missionSuddenlyChef;
				} else {
					self.isFirstLauching = self.missionSuddenlyChef;
				}
			}
			if (self.missionFrameStories.status === 'happening') {
				if (self.isFirstLauching && self.isFirstLauching.id) {
					self.isSecondLauching = self.missionFrameStories;
				} else {
					self.isFirstLauching = self.missionFrameStories;
				}
			}
		}

		function scrollNextSection(name) {
			$timeout(function () {
				var $target = $("html, body");
				$target.stop().animate({
					scrollTop: $('#' + name).offset().top
				}, '500', 'swing');
			}, 100);
		}

		function goMissionDetail(mission, condition) {
			if (condition && condition === 'past') {
				if (mission.isAwarded) {
					$state.go("mission-detail-page.awards", {
						id: mission.id
					});
				}
				else {
					$state.go("mission-detail-page.submissions", {
						id: mission.id
					});
				}
			} else if (condition && condition === 'happening') {
				$state.go("mission-detail-page.brief", {
					id: mission.id
				});
			} else if (!condition) {
				$state.go("mission-detail-page.brief", {
					id: mission.id
				});
			}
		}

		function seeMoreSmilesClicked(video) {
			videoPopupSvc.showPopup({
				windowClass: 'stay-home-stay-creative',
				data: video,
				videoId: 'wearasmileVideo'
			});
		}

		function countDown(timer) {
			var endDateMoment = moment.utc(timer, "DD MMMM YYYY");
			var duration = moment.duration(dateUtils.countDown(endDateMoment, 1000), 'milliseconds');
			if (duration < 0) {
				self.missionOutsideMyWindow.status = 'past';
				$interval.cancel(countDownInterval);
				return;
			}
			var mn = duration.minutes();
			var sc = duration.seconds();
			$scope.countDown = duration.hours() + ":" + (mn > 9 ? mn : "0" + mn) + ":" + (sc > 9 ? sc : "0" + sc);
		}

		$rootScope.$on('videoLoaded' + 'wearasmileVideo', function () {
			$('.video-popup__content video').width("inherit");
		})
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.config(routerConfig);

	routerConfig.$inject = ['$stateProvider'];

	function routerConfig($stateProvider) {
		'ngInject';
		$stateProvider
			.state('stay-home-stay-creative', {
				url: '/stayhomestaycreative',
				templateUrl: 'app/microsites/stay-home-stay-creative/stay-home-stay-creative.html',
				controller: 'stayHomeStayCreativeCtrl',
				controllerAs: 'vm',
				data: {
					pageTitle: "PIXERF - Stay home stay creative",
					hideHeader: true,
					hideFooter: true
				}
			})
	}

})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('manageRejectedPhotosMissionCtrl', manageRejectedPhotosMissionCtrl);

	manageRejectedPhotosMissionCtrl.$inject = ['$scope', 'sessionManagerSvc', 'toastr', 'pixerfApiMissionSvc', 'pagingUtils', 'uploadPhotoSvc', '$timeout', 'translationSvc', '$state', 'fileConst'];

	function manageRejectedPhotosMissionCtrl($scope, sessionManagerSvc, toastr, pixerfApiMissionSvc, pagingUtils, uploadPhotoSvc, $timeout, translationSvc, $state, fileConst) {

		var self = this;
		var mLoginUser = sessionManagerSvc.getCurrentLoginUser().data;
		var groupedData = [];

		$scope.$parent.vm.contextPage = "rejected";
		self.spinner = {
			isVisible: false
		};
		self.isLastPage = false;
		self.isCollapsed = {};
		self.items = null;
		self.showedData = [];
		self.searchParams = {
			page: 1,
			page_size: 100,
			state: "rejected",
			userId: mLoginUser.id
		};
		self.fileConst = fileConst;

		self.fetchMoreItems = fetchMoreItems;
		self.onMediaDeleted = onMediaDeleted;
		self.onCloseBtnClicked = onCloseBtnClicked;
		self.onCollapseToggle = onCollapseToggle;
		self.onExploreMissionsClicked = onExploreMissionsClicked;

		(function init() {
			fetchItems(self.searchParams, true);
		})()

		function onCloseBtnClicked() {
			$timeout(function () {
				$("#header-navbar-btn").trigger("click");
			});
		}

		function fetchItems(searchParams, isFresh) {
			self.spinner.isVisible = true;
			pixerfApiMissionSvc.pending_photo_mission(searchParams).$promise.then(function (response) {
				if (searchParams.page === 1 || isFresh) self.items = [];
				self.spinner.isVisible = false;
				if (response && response.data && response.data.length > 0) {
					self.items = self.items.concat(response.data);
					groupedData = _.groupBy(self.items, function(data){ return data.mission.id; });
					groupedData = _.map(groupedData, function (value, key) {
						return {
							photos: value,
							mission: {
								id: "G" + key,
								name: value[0].mission.title,
								sponsor: value[0].mission.sponsor && value[0].mission.sponsor.name ? value[0].mission.sponsor.name : null,
								rejected: value.length
							}
						}
					});
					self.showedData = groupedData;
				}
				self.isLastPage = pagingUtils.isNoMorePageToLoad(searchParams.page, response);
			}, function () {
				self.spinner.isVisible = false;
				toastr.error(translationSvc.FAILED_TO_DO_SOMETHING('FAILED_REJECTED_PHOTOS', true));
			})
		}

		function fetchMoreItems() {
			if (self.spinner.isVisible) {
				return;
			}
			self.searchParams.page++;
			fetchItems(self.searchParams);
		}

		function onMediaDeleted(media) {
			var totalPhotosReviewing = parseInt($scope.$parent.vm.numberPhotosReviewing);
			totalPhotosReviewing--;
			$scope.$parent.vm.numberPhotosReviewing = totalPhotosReviewing;
			for (var i = 0; i < self.showedData.length; i++) {
				self.showedData[i].photos = _.reject(self.showedData[i].photos, function (item) {
					return item.id === media.id;
				});
			}
		}

		function onCollapseToggle(mission) {
			self.isCollapsed[mission] = !self.isCollapsed[mission];
		}

		function onExploreMissionsClicked(){
			$state.go("run-a-challenge-page.live-challenges");
		}

	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('managePendingPhotosMissionCtrl', managePendingPhotosMissionCtrl);

	managePendingPhotosMissionCtrl.$inject = ['$scope', 'sessionManagerSvc', 'toastr', 'pagingUtils', 'uploadPhotoSvc', '$timeout', 'translationSvc', 'pixerfApiMissionSvc', '$state', 'fileConst'];

	function managePendingPhotosMissionCtrl($scope, sessionManagerSvc, toastr, pagingUtils, uploadPhotoSvc, $timeout, translationSvc, pixerfApiMissionSvc, $state, fileConst) {

		var self = this;
		var mLoginUser = sessionManagerSvc.getCurrentLoginUser().data;
		var groupedData = [];

		$scope.$parent.vm.contextPage = "in-review";
		self.spinner = {
			isVisible: false
		};
		self.isLastPage = false;
		self.isCollapsed = {};
		self.items = null;
		self.showedData = [];
		self.searchParams = {
			page: 1,
			page_size: 100,
			state: "pending",
			userId: mLoginUser.id
		};
		self.fileConst = fileConst;

		self.fetchMoreItems = fetchMoreItems;
		self.onMediaDeleted = onMediaDeleted;
		self.onCloseBtnClicked = onCloseBtnClicked;
		self.onCollapseToggle = onCollapseToggle;
		self.onExploreMissionsClicked = onExploreMissionsClicked;

		(function init() {
			fetchItems(self.searchParams, true);
		})()

		function onCloseBtnClicked() {
			$timeout(function () {
				$("#header-navbar-btn").trigger("click");
			});
		}

		function fetchItems(searchParams, isFresh) {
			self.spinner.isVisible = true;
			pixerfApiMissionSvc.pending_photo_mission(searchParams).$promise.then(function (response) {
				if (searchParams.page === 1 || isFresh) self.items = [];
				self.spinner.isVisible = false;
				if (response && response.data && response.data.length > 0) {
					self.items = self.items.concat(response.data);
					groupedData = _.groupBy(self.items, function(data){ return data.mission.id; });
					groupedData = _.map(groupedData, function (value, key) {
						return {
							photos: value,
							mission: {
								id: "G" + key,
								name: value[0].mission.title,
								sponsor: value[0].mission.sponsor && value[0].mission.sponsor.name ? value[0].mission.sponsor.name : null,
								pending: value.length
							}
						}
					});
					self.showedData = groupedData;
				}
				self.isLastPage = pagingUtils.isNoMorePageToLoad(searchParams.page, response);
			}, function () {
				self.spinner.isVisible = false;
				toastr.error(translationSvc.FAILED_TO_DO_SOMETHING('FAILED_PENDING_PHOTOS', true));
			})
		}

		function fetchMoreItems() {
			if (self.spinner.isVisible) {
				return;
			}
			self.searchParams.page++;
			fetchItems(self.searchParams);
		}

		function onMediaDeleted(media) {
			var totalPhotosReviewing = parseInt($scope.$parent.vm.numberPhotosReviewing);
			totalPhotosReviewing--;
			$scope.$parent.vm.numberPhotosReviewing = totalPhotosReviewing;
			for (var i = 0; i < self.showedData.length; i++) {
				self.showedData[i].photos = _.reject(self.showedData[i].photos, function (item) {
					return item.id === media.id;
				});
			}
		}

		function onCollapseToggle(mission) {
			self.isCollapsed[mission] = !self.isCollapsed[mission];
		}

		function onExploreMissionsClicked(){
			$state.go("run-a-challenge-page.live-challenges");
		}

	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('manageAwardsPhotosMissionCtrl', manageAwardsPhotosMissionCtrl);

	manageAwardsPhotosMissionCtrl.$inject = ['$scope', 'sessionManagerSvc', 'toastr', 'pagingUtils', '$timeout', 'translationSvc', 'pixerfApiMissionSvc', '$state', 'fileConst', '$q'];

	function manageAwardsPhotosMissionCtrl($scope, sessionManagerSvc, toastr, pagingUtils, $timeout, translationSvc, pixerfApiMissionSvc, $state, fileConst, $q) {

		var self = this;
		var mLoginUser = sessionManagerSvc.getCurrentLoginUser().data;

		$scope.$parent.vm.contextPage = "awards";
		self.spinner = {
			isVisible: false
		};
		self.isLastPage = {
			pending: false,
			past: false
		};
		self.isCollapsed = {};
		self.pendingAwards = null;
		self.claimedAwards = null;
		self.showedData = [];
		self.searchPendingParams = {
			page: 1,
			page_size: 10,
			state: 'pending',
			userId: mLoginUser.id
		};
		self.searchClaimedParams = {
			page: 1,
			page_size: 10,
			state: 'claimed',
			userId: mLoginUser.id
		};
		self.fileConst = fileConst;

		self.fetchMoreItems = fetchMoreItems;
		self.onCloseBtnClicked = onCloseBtnClicked;
		self.onCollapseToggle = onCollapseToggle;
		self.onExploreMissionsClicked = onExploreMissionsClicked;

		init();

		function init() {
			fetchItems(true, 'pending');
			fetchItems(true, 'claimed');
		}

		function onCloseBtnClicked() {
			$timeout(function () {
				$("#header-navbar-btn").trigger("click");
			});
		}

		function fetchItems(isFresh, type) {
			var isPendingAwards = type === 'pending',
				isClaimedAwards = type === 'claimed';

			if (isPendingAwards) {
				getAwards('pending', isFresh).then(function (res) {
					self.pendingAwards = res;
				});
			}
			if (isClaimedAwards) {
				getAwards('claimed', isFresh).then(function (res) {
					self.claimedAwards = res;
				});
			}
		}

		function getAwards(state, isFresh) {
			var def = $q.defer();
			var searchParams = {};
			var isPendingAwards = state === 'pending';
			var items = [];
			if (isPendingAwards) {
				searchParams = self.searchPendingParams;
				items = self.pendingAwards || [];
			} else {
				searchParams = self.searchClaimedParams;
				items = self.claimedAwards || [];
			}
			self.spinner.isVisible = true;
			pixerfApiMissionSvc.manage_award_photo_mission(searchParams).$promise.then(function (response) {
				if ((searchParams.page === 1 || isFresh) && isPendingAwards) {
					self.pendingAwards = [];
				} else if ((searchParams.page === 1 || isFresh) && !isPendingAwards) {
					self.claimedAwards = [];
				}
				if (response && response.data && response.data.length > 0) {
					items = items.concat(response.data);
				}
				self.spinner.isVisible = false;
				self.isLastPage[state] = pagingUtils.isNoMorePageToLoad(searchParams.page, response);

				def.resolve(items);
			}, function () {
				self.spinner.isVisible = false;
				toastr.error(translationSvc.FAILED_TO_DO_SOMETHING('FAILED_GET_PHOTOS', true));

				def.reject();
			})

			return def.promise;
		}

		function fetchMoreItems(state) {
			if (self.spinner.isVisible) {
				return;
			}
			var isPendingAwards = state === 'pending';
			if (isPendingAwards) {
				self.searchPendingParams.page++;
			} else {
				self.searchClaimedParams.page++;
			}
			fetchItems(false, state);
		}

		function onCollapseToggle(mission) {
			self.isCollapsed[mission] = !self.isCollapsed[mission];
		}

		function onExploreMissionsClicked() {
			$state.go("run-a-challenge-page.live-challenges");
		}

	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('manageApprovedPhotosMissionCtrl', manageApprovedPhotosMissionCtrl);

	manageApprovedPhotosMissionCtrl.$inject = ['$scope', 'photoSvc', 'photoDetailPopupSvc', 'commonConst', 'sessionManagerSvc', 'toastr', 'pagingUtils', 'uploadPhotoSvc', '$timeout', 'translationSvc', 'pixerfApiMissionSvc', '$state', 'fileConst'];

	function manageApprovedPhotosMissionCtrl($scope, photoSvc, photoDetailPopupSvc, commonConst, sessionManagerSvc, toastr, pagingUtils, uploadPhotoSvc, $timeout, translationSvc, pixerfApiMissionSvc, $state, fileConst) {

		var self = this;
		var mLoginUser = sessionManagerSvc.getCurrentLoginUser().data;
		var groupedData = [];

		$scope.$parent.vm.contextPage = "approved";
		self.spinner = {
			isVisible: false
		};
		self.isLastPage = false;
		self.isCollapsed = {};
		self.items = null;
		self.showedData = [];
		self.searchParams = {
			page: 1,
			page_size: 50,
			userId: mLoginUser.id,
			state: "approved"
		};
		self.fileConst = fileConst;

		self.fetchMoreItems = fetchMoreItems;
		self.onMediaDeleted = onMediaDeleted;
		self.onCloseBtnClicked = onCloseBtnClicked;
		self.showUploadModal = showUploadModal;
		self.onCollapseToggle = onCollapseToggle;
		self.onExploreMissionsClicked = onExploreMissionsClicked;
		self.onPhotoClicked = onPhotoClicked;

		(function init() {
			fetchItems(self.searchParams, true);
		})()

		function showUploadModal() {
			onCloseBtnClicked();
			uploadPhotoSvc.showUploadModal();
		}

		function onPhotoClicked(file) {
			photoSvc.updatePhotoInfo(file).then(function () {
				self.isWorking = false;
				photoDetailPopupSvc.setShouldSrollTop(new Date().getTime());
				if (photoDetailPopupSvc.isPopupShowing()) {
					photoDetailPopupSvc.updateUI({
						photo: file
					});

				} else {
					var modal = photoDetailPopupSvc.showPopup({
						photo: file,
						context: file.mission.is_multi_frame ? ('multiframemission-' + file.mission.id) : ('mission-' + file.mission.id)
					});
					modal.result.then(function (response) {
						if (response.action === commonConst.ACTION.DELETE) {
							onMediaDeleted(response.photo);
						}
					});
				}

			}, function () {
				self.isWorking = false;
			});
		}

		function onCloseBtnClicked() {
			$timeout(function () {
				$("#header-navbar-btn").trigger("click");
			});
		}

		function fetchItems(searchParams, isFresh) {
			self.spinner.isVisible = true;
			pixerfApiMissionSvc.pending_photo_mission(searchParams).$promise.then(function (response) {
				if (searchParams.page === 1 || isFresh) self.items = [];
				self.spinner.isVisible = false;
				if (response && response.data && response.data.length > 0) {
					self.items = self.items.concat(response.data);
					groupedData = _.groupBy(self.items, function (data) {
						return data.mission.id;
					});
					groupedData = _.map(groupedData, function (value, key) {
						return {
							photos: value,
							mission: {
								id: "G" + key,
								name: value[0].mission.title,
								sponsor: value[0].mission.sponsor && value[0].mission.sponsor.name ? value[0].mission.sponsor.name : null,
								approved: value.length
							}
						}
					});
					self.showedData = groupedData;
				}
				self.isLastPage = pagingUtils.isNoMorePageToLoad(searchParams.page, response);
			}, function () {
				self.spinner.isVisible = false;
				toastr.error(translationSvc.FAILED_TO_DO_SOMETHING('FAILED_APPROVED_PHOTOS', true));
			})
		}

		function fetchMoreItems() {
			if (self.spinner.isVisible) {
				return;
			}
			self.searchParams.page++;
			fetchItems(self.searchParams);
		}

		function onMediaDeleted(media) {
			var totalPhotosReviewing = parseInt($scope.$parent.vm.numberPhotosReviewing);
			totalPhotosReviewing--;
			$scope.$parent.vm.numberPhotosReviewing = totalPhotosReviewing;
			for (var i = 0; i < self.showedData.length; i++) {
				self.showedData[i].photos = _.reject(self.showedData[i].photos, function (item) {
					return item.id === media.id;
				});
			}
		}

		function onCollapseToggle(mission) {
			self.isCollapsed[mission] = !self.isCollapsed[mission];
		}

		function onExploreMissionsClicked() {
			$state.go("run-a-challenge-page.live-challenges");
		}

	}
})();

(function(){

  angular
    .module('pixerf')
    .factory('missionPreviewSvc', missionPreviewSvc);

    missionPreviewSvc.$inject = ['$uibModal', 'pixerfApiMissionSvc', '$q'];

    function missionPreviewSvc($uibModal, pixerfApiMissionSvc, $q){
    	
		function showPopup(data){
            $uibModal.open({
                templateUrl: 'app/manage-missions/mission-preview/mission-preview.html',
                controller: 'missionPreviewCtrl',
                controllerAs: 'vm',
                size: "full",
                animation: true,
                windowClass: 'zindex mission-preview-popup',
                resolve: {
                    popupData: function(){
                        return data;
                    }
                }
            });
        }

		return {
			showPopup: showPopup
		};
    }
})();

(function(){

  angular
    .module('pixerf')
    .controller('missionPreviewCtrl', missionPreviewCtrl);

    missionPreviewCtrl.$inject = ["$scope", "popupData", "$uibModalInstance", "manageMissionsSvc", "ISO3166"];

    function missionPreviewCtrl($scope, popupData, uibModalInstance, manageMissionsSvc, ISO3166){
        var self = this;
        self.mission = popupData;
        self.coverMedia = self.mission.cover_media.thumbnails ? self.mission.cover_media.thumbnails['1440x'] : self.mission.cover_media.url;
        self.onPhotoGridInit  = onPhotoGridInit;
        self.inspirationPhotoTemplate = getInspirationPhotoTemplate();
        self.closePopup = function(){
            uibModalInstance.close();
        }
        self.countriesName = buildRequirementNote();
        
        convertOutputRequirement();

		function convertOutputRequirement(){
			self.mission.outputMapping = manageMissionsSvc.getRequirementString('output', self.mission.output);
        }
        function onPhotoGridInit(photoGridControl){
            photoGridControl.photos = self.mission.media;
            photoGridControl.render(self.mission.media);
        }
        function getInspirationPhotoTemplate(){
            return '<mission-inspiration-photo media="vm.getFile(<%=id%>)" mission="mission" ></mission-inspiration-photo>';
        }

        function buildRequirementNote(){
			if(!self.mission.countries || (self.mission.countries.length <= 0)){
				return '';
			}

			var countriesName = getCountries(self.mission.countries).join(", ");;

			return ('For Photographers in ' + countriesName + ' only');

		}

		function getCountries(countryCodes){
            return Object.values(ISO3166.getCountryNames(countryCodes));
        }
    }
})();

(function () {

	angular
		.module('pixerf')
		.controller('missionPendingCtrl', missionPendingCtrl);

	missionPendingCtrl.$inject = ["pixerfApiMissionSvc", "toastr", "pagingUtils", "$scope"];

	function missionPendingCtrl(pixerfApiMissionSvc, toastr, pagingUtils, $scope) {
		var self = this;
		$scope.$parent.vm.contextPage = "Pending";
		$scope.$parent.vm.subContextPage = "Pending";
		self.onMissionDeleted = onMissionDeleted;
		self.spinner = {isVisible: false}
		self.fetchMoreItems = fetchMoreItems;
		self.isLastPage = false;
		self.items = null;
		self.searchParams = {
			page: 1,
			page_size: 20
		};

		init();

		function init(){
			fetchItems(self.searchParams, true);
		}

		function fetchItems(searchParams, isFresh){
			var timeRange = null;
			self.spinner.isVisible = true;
			searchParams.type = 'draft';
			searchParams.sort = ["inserted_at,desc"];
			pixerfApiMissionSvc.get_manage_mission(searchParams).$promise.then(function (response) {
				if(searchParams.page === 1 || isFresh) self.items = [];
                self.spinner.isVisible = false;
                if(response && response.data && response.data.missions && response.data.missions.length > 0){
					self.items = self.items.concat(response.data.missions);
                }
                self.isLastPage = pagingUtils.isNoMorePageToLoad(searchParams.page, response);

			}, function(){
				self.spinner.isVisible = false;
				toastr.error('Failed to get missions!');
			})
		}
		function fetchMoreItems(){
			 if(self.spinner.isVisible){
                return;
            }
            self.searchParams.page ++;
			fetchItems(self.searchParams);
		}

		function onMissionDeleted(mission){
			self.items = _.reject(self.items, function(item){
				return item.id === mission.id;
			})
		}
	}
})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.factory('createMissionSvc', createMissionSvc);
	createMissionSvc.$inject = ['toastr', '$q', 'pixerfApiMissionSvc', '$location', 'stringUtils', '$timeout', '$translate', 'translationSvc'];

	function createMissionSvc(toastr, $q, pixerfApiMissionSvc, $location, stringUtils, $timeout, $translate, translationSvc) {

		var mMissionSpecifications = [{
				"label": "License Usage",
				"value": "license_usage",
				"options": [{
					"label": "Editorial",
					"isSelected": false
				}, {
					"label": "Commercial",
					"isSelected": false
				}, {
					"label": "Commercial & Editorial",
					"isSelected": false
				}]
			},
			{
				"label": "Orientation",
				"value": "orientation",
				"options": [{
					"label": "Portrait",
					"isSelected": false
				}, {
					"label": "Landscape",
					"isSelected": false
				}, {
					"label": "Square",
					"isSelected": false
				}, {
					"label": "Any",
					"isSelected": false
				}]
			},
			{
				"label": "Environment",
				"value": "environment",
				"options": [{
					"label": "Indoor",
					"isSelected": false
				}, {
					"label": "Outdoor",
					"isSelected": false
				}, {
					"label": "Studio",
					"isSelected": false
				}, {
					"label": "Any",
					"isSelected": false
				}]
			},
			{
				"label": "Lighting",
				"value": "lighting",
				"options": [{
					"label": "Natural",
					"isSelected": false
				}, {
					"label": "Artificial",
					"isSelected": false
				}, {
					"label": "Any",
					"isSelected": false
				}]
			},
			{
				"label": "Output",
				"value": "output",
				"options": [{
					"label": "Colour Only",
					"isSelected": false
				}, {
					"label": "Black & White Only",
					"isSelected": false
				}, {
					"label": "Any",
					"isSelected": false
				}]
			},
			{
				"label": "Space for copy",
				"value": "space_for_copy",
				"options": [{
					"label": "Yes",
					"isSelected": false,
					"value": true
				}, {
					"label": "No",
					"isSelected": false,
					"value": false
				}]
			},
		];
		var mArtDirectionEditorOptions = {
			'modules': {
				'toolbar': [
					['bold', 'italic', 'underline'],
					[{
						'list': 'ordered'
					}, {
						'list': 'bullet'
					}],
					['link', 'image']
				],
				'imageResize': {
					'displaySize': true
				},
				'AutoLink': {}
			},
			'placeholder': "Tell us about the look and feel and art direction you're looking for.",
			"maxLength": 1500
		};
		var mBriefEditorOptions = {
			'modules': {
				'toolbar': [
					['bold', 'italic', 'underline'],
					[{
						'list': 'ordered'
					}, {
						'list': 'bullet'
					}],
					['link', 'image']
				],
				'imageResize': {
					'displaySize': true
				},
				'AutoLink': {}
			},
			'placeholder': "What is the inspiration behind the Mission? What’s the story you want to tell? Who are you trying to reach? Write your brief here and include more details to help photographers understand your requirements better",
			"maxLength": 3000
		};
		var mPrizeValidationRules = {
			"30-day Mission": {
				"WINNER": {
					quantity: {
						max: 3,
						min: 1
					},
					value: {
						min: 150,
						max: 500
					}
				},
				"CONSOLATION": {
					quantity: {
						min: 0,
						max: 5
					},
					value: {
						fixed: 50
					}
				}

			},
			"45-day Mission": {
				"WINNER": {
					quantity: {
						max: 5,
						min: 1
					},
					value: {
						min: 150,
						max: 800
					}
				},
				"CONSOLATION": {
					quantity: {
						min: 0,
						max: 10
					},
					value: {
						fixed: 50
					}
				}

			},
			"Customised Mission": {
				"duration": {
					min: 1,
					max: 60
				},
				"WINNER": {
					quantity: {
						min: 1,
						max: 100
					},
					value: {
						min: 100,
						max: 10000
					}
				},
				"CONSOLATION": {
					quantity: {
						min: 0,
						max: 500
					},
					value: {
						fixed: 50
					}
				}

			}
		};
		var SAMPLE_MISSION = {
			title: '',
			media: [],
			bill: {
				total_to_pay: 0,
			},
			prizes: [{
				name: "Single Winner",
				type: "WINNER",
				value: 0
			}, {
				name: "Special Mention",
				type: "CONSOLATION",
				value: 50
			}]
		};
		var mCurrentPath = [];
		var mCurrentStepIndex = 0;
		var mMission = $.extend(true, {}, SAMPLE_MISSION);
		var mListSteps = [];


		function getStepUrl(step) {
			return "/setting/manage-missions/create-mission/" + mMission.data.id + "/" + step.id.toLowerCase();
		}

		function buildStepsList() {
			for (var i = 0; i < mListSteps.length; i++) {
				mListSteps[i].index = i;
			}
		}

		function validatePrizes(mission) {
			var messageTypeMap = {
				"WINNER": " Mission Winner(s)",
				"CONSOLATION": " Special Mention(s)"
			}
			var ruleSet = mPrizeValidationRules[mission.price.name];
			if (!ruleSet) ruleSet = mPrizeValidationRules["Customised Mission"];
			var prizes = ["WINNER", "CONSOLATION"];
			if (mission.price.id == -1) {
				if (!mission.price.duration) return "Please input the Mission Duration!";
				if (mission.price.duration > ruleSet.duration.max) return "Please input maximum of " + ruleSet.duration.max + " days for Mission Duration!"
			}
			for (var i = 0; i < prizes.length; i++) {
				var type = prizes[i];
				var textRuleSetValueMax = ruleSet[type].value.max ? ruleSet[type].value.max.toLocaleString('en-US', {
					minimumFractionDigits: 0
				}) : 0;
				if (mission.prizes_grouped[type]) {
					if (isNaN(mission.prizes_grouped[type].quantity) || mission.prizes_grouped[type].quantity < ruleSet[type].quantity.min) return "Please input minimum of " + ruleSet[type].quantity.min + messageTypeMap[type];
					if (ruleSet[type].quantity.max && mission.prizes_grouped[type].quantity > ruleSet[type].quantity.max) return "Please input maximum of " + ruleSet[type].quantity.max + messageTypeMap[type];
					if (mission.prizes_grouped[type].value < ruleSet[type].value.min) return "Please input minimum of " + ruleSet[type].value.min + " SGD";
					if (ruleSet[type].value.max && mission.prizes_grouped[type].value > ruleSet[type].value.max) return "Please input maximum of " + textRuleSetValueMax + " SGD";
				}
			}
		}

		function validateSponsor(mission) {
			if (!mission.sponsor) return;
			var errMsg;
			if (!mission.sponsor.name) {
				errMsg = $translate.instant("input-sponsor-name");
			} else if (!mission.description) {
				errMsg = $translate.instant("input-sponsor-description");
			} else if (!mission.sponsor.profile_image) {
				errMsg = $translate.instant("upload-sponsor-logo");
			}
			return errMsg;
		}

		function validateSponsorOptions(mission) {
			if (typeof mission.noSponsor === 'undefined') {
				return $translate.instant("missions-form-07");
			}
		}

		function validateBrief(mission) {
			var errMsg;
			if (!mission.title) {
				errMsg = $translate.instant("please-input-mission-name");
			} else if (!mission.description) {
				errMsg = $translate.instant("please-input-brief");
			} else if (mission.description > 1500) {
				errMsg = "Maximum Description is 1500 characters!";
			}
			return errMsg;
		}

		function validateVisualInspiration(mission) {
			var errMsg;
			if (!mission.art_direction) {
				errMsg = $translate.instant("please-input-art-direction");
			} else if (mission.art_direction > 1500) {
				errMsg = $translate.instant("maximum-art-direction-characters", {
					number: 1500
				});
			} else if (mission.media.length < 3) {
				return $translate.instant("please-upload-at-least-number-photos", {
					number: 3
				});
			} else if (mission.media.length > mission.inspiration_limit) {
				return $translate.instant("only-can-upload-number-photos", {
					number: mission.inspiration_limit
				});
			}
			return errMsg;
		}

		function validateSpecification(mission, specifications) {
			var isInvalid = _.some(specifications, function (s) {
				var propName = s.value ? s.value : s;
				return typeof mission[propName] === 'undefined' || mission[propName] === null;
			})
			return isInvalid ? $translate.instant("choose-mission-specifications") : null;
		}

		function validateMission(mission) {
			var errMsg = validateBrief(mission);
			if (errMsg) return errMsg;
			errMsg = validatePrizes(mission);
			if (errMsg) return errMsg;
			errMsg = validateVisualInspiration(mission);
			if (errMsg) return errMsg;
			errMsg = validateSpecification(mission, mMissionSpecifications);
			if (errMsg) return errMsg;
		}

		function init() {
			mListSteps = [{
					id: "GETTING-STARTED",
					label: "getting-started",
					name: "GETTING-STARTED",
					title: "Getting Started",
					formName: 'gettingStartedForm',
					route: 'setting.manage-missions.create-mission.getting-started',
					validator: function (mission, form) {
						if (!mission.price) return "Please choose Mission Duration!"
					},
					childrenStepIndex: -1,
					children: [{
						id: "REWARD",
						label: "Reward",
						name: "Reward",
						title: "Reward",
						formName: 'rewardForm',
						route: 'setting.manage-missions.create-mission.reward',
						validator: function (mission, form) {
							return validatePrizes(mission)
						}
					}]
				},
				{
					id: "BRIEF",
					label: "brief",
					name: "BRIEF",
					title: "BRIEF",
					formName: 'briefForm',
					route: 'setting.manage-missions.create-mission.brief',
					validator: function (mission, form) {
						return validateBrief(mission)
					},
					children: [{
						route: 'setting.manage-missions.create-mission.sponsor-options',
						formName: 'sponsorOptionsForm',
						validator: function (mission, form) {
							return validateSponsorOptions(mission)
						}
					}, {
						enable: function (mission) {
							return !mission.noSponsor;
						},
						route: 'setting.manage-missions.create-mission.sponsor',
						formName: 'sponsorForm',
						validator: function (mission, form) {
							return validateSponsor(mission)
						}
					}]
				},
				{
					id: "VISUAL",
					label: "visual-inspiration",
					name: "VISUAL",
					title: "VISUAL",
					formName: 'visualInspirationForm',
					route: 'setting.manage-missions.create-mission.visual-inspiration',
					validator: function (mission, form) {
						return validateVisualInspiration(mission)
					}
				},
				{
					id: "Specifications",
					label: "specifications",
					name: "Specifications",
					title: "Specifications",
					formName: "specificationForm",
					route: 'setting.manage-missions.create-mission.specification',
					validator: function (mission, form) {
						return validateSpecification(mission, ["environment", "orientation", "license_usage"]);
					},
					childrenStepIndex: -1,
					children: [{
						route: 'setting.manage-missions.create-mission.specification-one',
						formName: 'specificationOneForm',
						validator: function (mission, form) {
							return validateSpecification(mission, ["lighting", "space_for_copy", "output"])
						}
					}]
				},
				{
					id: "Review",
					label: "summary",
					name: "Review",
					title: "Review",
					route: 'setting.manage-missions.create-mission.review'
				}

			];
			buildStepsList();
		}

		function getMission() {
			return mMission;
		}

		function setMission(mission) {
			mMission.data = mission;
		}

		function reset() {
			mMission = {
				data: $.extend(true, {}, SAMPLE_MISSION)
			};
		}

		function setCurrentStepIndex(index) {
			mCurrentStepIndex = index;
		}

		function findStepIndexByRoute(steps, route) {
			for (var i = 0; i < steps.length; i++) {
				if (steps[i].route == route) {
					mCurrentPath.push(steps[i]);
					steps[i].index = i;
					steps[i].childrenStepIndex = -1;
					return steps[i];
				}
				if (steps[i].children) {
					var found = findStepIndexByRoute(steps[i].children, route);
					if (found != null) {
						steps[i].childrenStepIndex = found.index;
						console.log(steps[i]);
						mCurrentPath.push(steps[i]);
						return steps[i];
					}
				}
			}
			return null;
		}

		function findStepPathRoute(path, steps, route) {
			for (var i = 0; i < steps.length; i++) {
				if (steps[i].route == route) {
					path.push(steps[i]);
					steps[i].index = i;
					return steps[i];
				}
				if (steps[i].children) {
					var found = findStepPathRoute(path, steps[i].children, route);
					if (found != null) {
						console.log(steps[i]);
						path.push(steps[i]);
						return steps[i];
					}
				}
			}
			return null;
		}

		function findNextStep(route, path) {
			if (!path) {
				path = [];
				findStepPathRoute(path, mListSteps, route);
			}

			if (path.length > 1) {
				var parent = mCurrentPath[1];
				if (path[0].index + 1 < parent.children.length) {
					return parent.children[path[0].index + 1];
				} else {
					return findNextStep(parent.route);
				}

			} else {
				if (path[0].index + 1 < mListSteps.length) {
					return mListSteps[path[0].index + 1];
				}
			}
		}

		function findPreviousStep(route, path) {
			if (!path) {
				path = [];
				findStepPathRoute(path, mListSteps, route);
			}
			if (path.length > 1) {
				var parent = mCurrentPath[1];
				if (path[0].index - 1 >= 0) {
					return parent.children[path[0].index - 1];
				} else {
					return parent;
				}

			} else {
				if (path[0].index - 1 >= 0) {
					var prevStep = mListSteps[path[0].index - 1];
					return prevStep.children ? prevStep.children[prevStep.children.length - 1] : prevStep;
				}
			}
		}

		function getNextStep(route) {
			if (mCurrentPath[0].children) {
				return mCurrentPath[0].children[0]
			} else {
				return findNextStep(route, mCurrentPath);
			}

		}

		function getPreviousStep(route) {
			return findPreviousStep(route, mCurrentPath);
		}

		function updateStepsIndex(steps, currentRoute) {
			mCurrentPath = [];
			findStepIndexByRoute(mListSteps, currentRoute);
			mCurrentStepIndex = mCurrentPath[mCurrentPath.length - 1].index;
		}

		function getCurrentStep(route) {
			return mCurrentPath[0];
		}

		function getCurrentStepIndex() {
			return mCurrentPath[0].index;
		}

		function getCurrentRootStep() {
			return mCurrentPath[mCurrentPath.length - 1].index;
		}

		function getListStep() {
			return mListSteps;
		}

		function buildDataSaved(mission) {
			if(mission.countries && mission.countries.length){
				for (var i = 0; i <  mission.countries.length; i++) {
					if(mission.countries[i] == 'all'){
						mission.countries = [];
						break;
					}
				}
			}
			mission.description = stringUtils.convertToTrustHtml(mission.description);
			mission.mission_price_id = mission.price ? mission.price.id : null;
			if (mission.price) {
				mission.duration = mission.price.duration;
			}
		}

		function getMissionArtDirectionEditorConfiguraion() {
			return mArtDirectionEditorOptions;
		}

		function getMissionBriefEditorConfiguration() {
			return mBriefEditorOptions;
		}

		function saveMission(mission) {
			var def = $q.defer();

			buildDataSaved(mission);
			var action = mission.id ? "update" : "create";
			var params = action === "update" ? [{
				id: mission.id
			}, {
				mission: mission
			}] : [{
				mission: mission
			}];
			pixerfApiMissionSvc[action].apply(null, params).$promise.then(function (response) {
				def.resolve(response);
			}, function () {
				toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
				def.reject();
			});
			return def.promise;
		}

		function goBack() {
			window.history.go(-1);
		}

		function saveDraft(mission) {
			var def = $q.defer();
			saveMission(mission).then(function (response) {
				toastr.success("Mission has been successfully saved as draft!");
				$timeout(function () {
					$location.path('/setting/manage-missions/unpublished-missions');
				}, 1000);
				def.resolve(response);
			}, function (err) {
				def.reject(err);
			});
			return def.promise;
		}

		function discard(mission) {
			var def = $q.defer();
			pixerfApiMissionSvc.delete({
				id: mission.id
			}).$promise.then(function (response) {
				$location.path('/setting/mission');
				def.resolve(response);
			}, function (err) {
				self.isWorking = false;
				def.reject(err);
			});
			return def.promise;
		}

		function getCurrentPath() {
			return mCurrentPath;
		}

		function getPrizeRuleSet() {
			return mPrizeValidationRules;
		}

		function getMissionSpecifications() {
			return $.extend(true, [], mMissionSpecifications);
		}

		init();

		return {
			getCurrentPath: getCurrentPath,
			getMission: getMission,
			setMission: setMission,
			setCurrentStepIndex: setCurrentStepIndex,
			getCurrentStepIndex: getCurrentStepIndex,
			getCurrentRootStep: getCurrentRootStep,
			getCurrentStep: getCurrentStep,
			getListStep: getListStep,
			getNextStep: getNextStep,
			getPreviousStep: getPreviousStep,
			goBack: goBack,
			reset: reset,
			saveMission: saveMission,
			updateStepsIndex: updateStepsIndex,
			validateMission: validateMission,
			saveDraft: saveDraft,
			discard: discard,
			findStepIndexByRoute: findStepIndexByRoute,
			getMissionArtDirectionEditorConfiguraion: getMissionArtDirectionEditorConfiguraion,
			getMissionBriefEditorConfiguration: getMissionBriefEditorConfiguration,
			getPrizeRuleSet: getPrizeRuleSet,
			validatePrizes: validatePrizes,
			getMissionSpecifications: getMissionSpecifications,
			validateSponsor: validateSponsor,
			validateVisualInspiration: validateVisualInspiration,
			validateBrief: validateBrief
		};
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('createMissionCtrl', createMissionCtrl);

	createMissionCtrl.$inject = ['$scope', '$rootScope', 'toastr', '$location', 'createMissionSvc', 'pixerfConfirmPopupSvc', 'pixerfApiMissionSvc', '$q', 'missionData', '$state', '$stateParams', 'badgeUtils'];

	function createMissionCtrl($scope, $rootScope, toastr, $location, createMissionSvc, pixerfConfirmPopupSvc, pixerfApiMissionSvc, $q, missionData, $state, $stateParams, badgeUtils) {
		var self = this;
		createMissionSvc.reset();
		self.isWorking = false;
		self.mission = missionData;
		$scope.$parent.vm.contextPage = "Create Mission";
		$scope.$parent.vm.subContextPage = "Create Mission";
		self.onNextBtnClicked = onNextBtnClicked;
		self.onBackBtnClicked = onBackBtnClicked;
		self.onCancelBtnClicked = onCancelBtnClicked;
		self.onSaveDraftBtnClicked = onSaveDraftBtnClicked;
		self.onBreadCrumInit = onBreadCrumInit;
		self.navigateTo = navigateTo;
		self.breadCrumbs = null;
		self.listSteps = createMissionSvc.getListStep();
		self.navigationBtnStatus = {
			next: true,
			back: true
		}

		createMissionSvc.updateStepsIndex(createMissionSvc.getListStep(), $state.current.name);
		updateNavigationBtns();
		$rootScope.$on('$stateChangeSuccess', function (event, toState) {
			if (toState.name.indexOf('create-mission') === -1) {
				createMissionSvc.reset();
			} else {
				createMissionSvc.updateStepsIndex(createMissionSvc.getListStep(), $state.current.name);
				self.breadCrumbs.setCurrentIndex(createMissionSvc.getCurrentRootStep());
				updateNavigationBtns();
			}

		});

		function updateNavigationBtns() {
			var currentStep = createMissionSvc.getCurrentStep();
			self.navigationBtnStatus.next = !!createMissionSvc.getNextStep(currentStep.route);
			self.navigationBtnStatus.back = !!createMissionSvc.getPreviousStep(currentStep.route);
		}
		function onBreadCrumInit(instance) {
			self.breadCrumbs = instance;
			self.breadCrumbs.setCurrentIndex(createMissionSvc.getCurrentRootStep());
		}
		function onCancelBtnClicked() {
			var me = this;
			var modal = pixerfConfirmPopupSvc.showPopup({ hideTitle: true, hideConfirmText: true, message: 'Are you sure you want to delete this Mission?' });
			modal.result.then(function () {
				if (self.isWorking) return;
				self.isWorking = true;
				pixerfApiMissionSvc.delete({ id: me.mission.data.id }).$promise.then(function (response) {
					self.isWorking = false;
					toastr.success("Mission has been deleted!");
					$location.path('/setting/mission');
				}, function () {
					self.isWorking = false;
					toastr.error("Failed to delete this Mission!");
				});
			})
		}
		function navigateStep(direction, form) {
			var def = $q.defer();
			var currentStep = createMissionSvc.getCurrentStep();
			if (direction === "next") {
				var validator = currentStep.validator;
				if (validator && !currentStep.canSkip) {
					var errMsg = validator(self.mission);
					if (errMsg) {
						if (currentStep.formName && self[currentStep.formName]) {
							self[currentStep.formName].$setDirty();
						}
						toastr.error(errMsg);
						def.reject();
					} else {
						if (!self.mission.prizes || !self.mission.prizes.length) {
							self.mission.prizes = [{
								name: "Single Winner",
								type: "WINNER",
								value: 0
							}, {
								name: "Special Mention",
								type: "CONSOLATION",
								value: 50
							}]
						}
						createMissionSvc.saveMission(self.mission).then(function (response) {
							self.mission.id = response.mission.id;
							if (self.mission.sponsor) {
								self.mission.sponsor.id = response.mission.sponsor.id;
							}
							def.resolve();
						}, function () {
							def.reject()
						})
					}
				}
			} else {
				def.resolve();
			}
			return def.promise;
		}
		function navigateTo(step) {
			$state.go(step.route, { id: self.mission.id });
		}
		function onNextBtnClicked(formData) {
			navigateStep("next", formData).then(function (response) {
				var currentStep = createMissionSvc.getCurrentStep();
				var nextStep = createMissionSvc.getNextStep(currentStep.route);
				while (nextStep.enable && !nextStep.enable(self.mission)) {
					createMissionSvc.updateStepsIndex(createMissionSvc.getListStep(), nextStep.route);
					currentStep = createMissionSvc.getCurrentStep();
					nextStep = createMissionSvc.getNextStep(currentStep.route);

				}
				$state.go(nextStep.route, { id: self.mission.id });
			});
		}
		function onBackBtnClicked(formData) {
			navigateStep("back", formData).then(function (response) {
				var currentStep = createMissionSvc.getCurrentStep();
				var previousStep = createMissionSvc.getPreviousStep(currentStep.route);

				while (previousStep.enable && !previousStep.enable(self.mission)) {
					createMissionSvc.updateStepsIndex(createMissionSvc.getListStep(), previousStep.route);
					currentStep = createMissionSvc.getCurrentStep();
					previousStep = createMissionSvc.getPreviousStep(currentStep.route);

				}
				$state.go(previousStep.route);
			});
		}
		function onSaveDraftBtnClicked() {
			var me = this;
			me.isWorking = true;
			createMissionSvc.saveDraft(me.mission.data).then(function (response) {
				me.isWorking = false;
			}, function () {
				me.isWorking = false;
			})
		}
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('publishedMediaPostCtrl', publishedMediaPostCtrl);

	publishedMediaPostCtrl.$inject = ['$scope', 'pixerfApiNewsSvc', 'pagingUtils'];

	function publishedMediaPostCtrl($scope, pixerfApiNewsSvc, pagingUtils) {
		var self = this;
		$scope.$parent.vm.subContextPage = "Published";
		self.onDeletedPost = onDeletedPost;
		self.fetchMorePosts = fetchMorePosts;
		self.posts = [];
		self.searchParams = {
			page: 1
		}
		self.spinner = {
			isVisible: false
		}

		init();

		function init() {
			getPosts(self.searchParams);
		}

		function getPosts(searchParams) {
			if (self.spinner.isVisible) return;
			self.spinner.isVisible = true;
			pixerfApiNewsSvc.get(searchParams).$promise.then(function (response) {
				self.posts = self.posts.concat(response.data);
				self.isLastPage = pagingUtils.isNoMorePageToLoad(self.searchParams.page, response);
				self.spinner.isVisible = false;
				self.searchParams.page = searchParams.page;
			}).catch(function () {
				self.spinner.isVisible = false;
			})
		}

		function onDeletedPost(id) {
			self.posts = _.reject(self.posts, function (item) {
				return item.id === id;
			});
		}

		function fetchMorePosts() {
			if (self.isLastPage || self.spinner.isVisible) return;
			var searchParams = $.extend(true, {}, self.searchParams);
			searchParams.page++;
			getPosts(searchParams);
		}
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('createMediaPostCtrl', createMediaPostCtrl);

	createMediaPostCtrl.$inject = ['$scope', 'sessionManagerSvc', 'pixerfUrl', 'systemUtils', 'pixerfApiNewsSvc', '$state', 'confirmWithinIconPopupSvc', '$q', 'imageUtils', '$timeout'];

	function createMediaPostCtrl($scope, sessionManagerSvc, pixerfUrl, systemUtils, pixerfApiNewsSvc, $state, confirmWithinIconPopupSvc, $q, imageUtils, $timeout) {
		var self = this;
		self.showAttachPhotoBtn = true;
		$scope.$parent.vm.subContextPage = "Create Post";
		self.savePost = savePost;
		self.post = {};

		self.dropzoneConfig = {
			'instance': {},
			'options': {
				url: pixerfUrl.full + 'api/blog_posts/',
				maxFiles: 1,
				paramName: 'photo',
				acceptedFiles: "image/jpeg,image/png,image/jpg",
				addRemoveLinks: true,
				autoProcessQueue: false,
				dictRemoveFile: "X",
				thumbnailWidth: null,
				thumbnailHeight: null,
				method: "put",
				previewsContainer: '#preview',
				clickable: ['.create-media-post__content__col-left__dropzone'],
				headers: {
					"Authorization": "Bearer " + sessionManagerSvc.getToken()
				}
			},
			'eventHandlers': {
				addedfile: function (file, xhr, form) {
					isShowAttachPhotoBtn();
					if (this.files.length > 1) {
						this.removeFile(this.files[0]);
					}
					systemUtils.digest($scope);
				},
				removedfile: function (file) {
					isShowAttachPhotoBtn();
				},
				canceled: function (file) {
					this.removeAllFiles();
				},
				thumbnail: function (file, dataUrl) {
					file.thumbnail = dataUrl;
					$scope.$apply();
					return true;
				}
			}
		}

		function isShowAttachPhotoBtn() {
			if (self.dropzoneConfig.instance.files && self.dropzoneConfig.instance.files.length) {
				self.showAttachPhotoBtn = false;
			} else {
				self.showAttachPhotoBtn = true;
			}
			systemUtils.digest($scope);
		}

		function savePost() {
			confirmWithinIconPopupSvc.showPopup({
				icon: "icon-attention",
				title: "You are about to publish a Media Post.",
				description: "Please confirm if you want to proceed.<br/>If you say yes, the Media Post will be published to the Media page of the live site.",
				cancelBtnText: "No - return to create post",
				submitBtnText: "Yes - publish post",
				submit: function () {
					if (self.post.posted_at) {
						self.post.posted_at = moment(self.post.posted_at).format("YYYY-MM-DD");
					}
					return pixerfApiNewsSvc.save(self.post).$promise;
				},
				submitCallback: function (res) {
					self.dropzoneConfig.instance.options.url += res.id;
					self.dropzoneConfig.instance.processQueue();

					confirmWithinIconPopupSvc.showPopup({
						icon: "icon-checked_full_circle",
						title: "You have successfully published the Media Post.",
						cancelBtnText: "Back to Manage Media",
						submitBtnText: "View Media Page",
						backToState: "setting.manage-media-post.published",
						submit: function () {
							var def = $q.defer();
							$state.go("media-page");
							def.resolve();
							return def.promise;
						},
					})
				}
			})
		}
	}
})();


(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('customCommissionsOnGoingCtrl', customCommissionsOnGoingCtrl);

	customCommissionsOnGoingCtrl.$inject = ['$scope', 'pixerfApiCustomCommssionsSvc', 'pagingUtils'];

	function customCommissionsOnGoingCtrl($scope, pixerfApiCustomCommssionsSvc, pagingUtils) {

		var self = this;
		self.fetchMoreOngoingCustomCommission = fetchMoreOngoingCustomCommission;
		self.parent = $scope.$parent.vm;
		self.parent.contextPage = "Ongoing";
		$scope.$parent.$parent.$parent.vm.contextPage = "Custom Content Assignments";
		self.isContributor = self.parent.loginedUser.isContributor;
		self.customCommissions = [];
		self.searchParams = {
			page: 1
		};
		self.filterSetting = {
			"items": [{
				name: "Latest Date",
				value: "date"
			}]
		};
		self.spinner = {
			isVisible: false
		}

		init();

		function init() {
			fechOngoingCustomCommission(self.searchParams, true);
		}

		function fechOngoingCustomCommission(params, isFresh) {
			self.searchParams = params;

			pixerfApiCustomCommssionsSvc.getListOngoing(self.searchParams).$promise.then(function (reponse) {
				if (isFresh) self.customCommissions = [];
				self.customCommissions = self.customCommissions.concat(reponse.data);

				self.isLastPage = pagingUtils.isNoMorePageToLoad(self.searchParams.page, reponse);
				self.spinner.isVisible = false;
				self.searchParams.page = params.page;
			}).catch(function (err) {
				self.spinner.isVisible = false;
				console.log(err);
			})
		}

		function fetchMoreOngoingCustomCommission() {
			if (self.isLastPage || self.spinner.isVisible) return;
			var searchParms = $.extend(true, {}, self.searchParams);
			searchParms.page++;
			fechOngoingCustomCommission(searchParms);
		}
	}
})();




/**
 * Controller for home module
 */
(function(){

  angular
    .module('pixerf')
    .controller('supportCtrl', supportCtrl);

    supportCtrl.$inject = ['headerSvc'];

    function supportCtrl(headerSvc){
        var self = this;
        self.contextPage = 'Support';
        self.searchFilterBarSettings = headerSvc.getFixedByHeaderSetting();
    }
})();

(function() {
  'use strict';

  angular
    .module('pixerf')
    .config(routerConfig);

  routerConfig.$inject = ['$stateProvider'];

  function routerConfig($stateProvider) {
    'ngInject';
    $stateProvider
      .state('introduction-support', {
        templateUrl: 'app/introduction/support/support.html',
        abstract: true,
        controller: 'supportCtrl',
        controllerAs: 'vm',
      })
      .state('introduction-support.faq', {
        url: '/introduction/support/faq',
        templateUrl: 'app/introduction/support/faq/faq.html',
        data: {
            pageTitle: "PIXERF - FAQ",
            permissions: {
                only: ['EVERY_ONE']
            }
        },
        abstract: true
      })
      .state('introduction-support.faq.business', {
        url: '/business/:section',
        templateUrl: 'app/introduction/support/faq/faq-business.html',
        controller: 'faqBusinessCtrl',
        controllerAs: 'vm',
        data: {
          pageTitle: "PIXERF - FAQ",
          permissions: {
            only: ['EVERY_ONE']
          }
        }
      })
      .state('introduction-support.faq.personal', {
        url: '/:section',
        templateUrl: 'app/introduction/support/faq/faq-personal.html',
        controller: 'faqPersonalCtrl',
        controllerAs: 'vm',
        data: {
            pageTitle: "PIXERF - FAQ",
            permissions: {
                only: ['EVERY_ONE']
            }
        }
      })
      .state('introduction-support.releases', {
        url: '/introduction/support/releases',
        templateUrl: 'app/model-and-property-releases/model-and-property-releases.html',
        controller: 'modelAndPopertyReleasesCtrl',
        controllerAs: 'vm',
        data: {
            pageTitle: "PIXERF - Releases",
            permissions: {
                only: ['EVERY_ONE']
            }
        }
      });
  }

})();

/**
 * Controller for home module
 */
(function(){

  angular
    .module('pixerf')
    .controller('pixerferCtrl', pixerferCtrl);

    pixerferCtrl.$inject = ['headerSvc'];

    function pixerferCtrl(headerSvc){
        var self = this;
        self.contextPage = 'Personal';
        self.searchFilterBarSettings = headerSvc.getFixedByHeaderSetting();
    }
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.config(routerConfig);

	routerConfig.$inject = ['$stateProvider'];

	function routerConfig($stateProvider) {
		'ngInject';
		$stateProvider
			.state('introduction-pixerfer', {
				templateUrl: 'app/introduction/pixerfer/pixerfer.html',
				abstract: true,
				controller: 'pixerferCtrl',
				controllerAs: 'vm',
			})
			//   .state('introduction-pixerfer.about-leveling', {
			//     url: '/introduction/pixerfer/about-leveling',
			//     templateUrl: 'app/introduction/pixerfer/about-leveling/about-leveling.html',
			//     data: {
			//         pageTitle: "PIXERF - About Leveling Introduction",
			//         permissions: {
			//             only: ['EVERY_ONE']
			//         }
			//     }
			//   })
			.state('introduction-pixerfer.payout', {
				url: '/introduction/pixerfer/payout',
				templateUrl: 'app/introduction/pixerfer/payout/payout.html',
				data: {
					pageTitle: "PIXERF - Payout Introduction",
				},
				abstract: true
			})

			.state('introduction-pixerfer.payout.personal', {
				url: '',
				templateUrl: 'app/introduction/pixerfer/payout/per-payout.html',
				controller: 'payoutPersonalCtrl',
				controllerAs: 'vm',
				data: {
					pageTitle: "PIXERF - Personal Payout",
					permissions: {
						only: ['EVERY_ONE']
					}
				}
			})
			.state('introduction-pixerfer.payout.business', {
				url: '/bz',
				templateUrl: 'app/introduction/pixerfer/payout/biz-payout.html',
				data: {
					pageTitle: "PIXERF - Business Payout",
					permissions: {
						only: ['EVERY_ONE']
					}
				}
			})
			.state('introduction-pixerfer.subscriptions', {
				url: '/introduction/pixerfer/subscriptions',
				templateUrl: 'app/introduction/pixerfer/subscriptions/subscriptions.html',
				abstract: true
			})

			.state('introduction-pixerfer.subscriptions.personal', {
				url: '',
				templateUrl: 'app/introduction/pixerfer/subscriptions/per-subscriptions.html',
				controller: 'subscriptionsPersonalCtrl',
				controllerAs: 'vm',
				data: {
					pageTitle: "PIXERF - Personal Subscriptions",
					permissions: {
						only: ['EVERY_ONE']
					}
				}
			})
			.state('introduction-pixerfer.subscriptions.business', {
				url: '/bz',
				templateUrl: 'app/introduction/pixerfer/subscriptions/biz-subscriptions.html',
				controller: 'subscriptionsBusinessCtrl',
				controllerAs: 'vm',
				data: {
					pageTitle: "PIXERF - Business Subscriptions",
					permissions: {
						only: ['EVERY_ONE']
					}
				}
			})
			.state('introduction-pixerfer.credit-plans', {
				url: '/introduction/pixerfer/credit-plans',
				templateUrl: 'app/introduction/pixerfer/credit-plans/credit-plans.html',
				data: {
					pageTitle: "PIXERF - Credit Plans",
					permissions: {
						only: ['EVERY_ONE']
					}
				}
			});

	}

})();

(function() {
  'use strict';

  angular
    .module('pixerf')
    .config(routerConfig);

  routerConfig.$inject = ['$stateProvider'];

  function routerConfig($stateProvider) {
    'ngInject';
    $stateProvider
      .state('introduction-discover', {
        templateUrl: 'app/introduction/discover/discover.html',
        data: {
                permissions: {
                only: ['EVERY_ONE']
            }
        },
        abstract: true
      })
      .state('introduction-discover.marketplace', {
        url: '/introduction/discover/marketplace',
        templateUrl: 'app/introduction/discover/marketplace/marketplace.html',
        data: {
            pageTitle: "PIXERF - Market Place Introduction",
        }
      })
      .state('introduction-discover.signature-gallery', {
        url: '/introduction/discover/signature-gallery',
        templateUrl: 'app/introduction/discover/signature-gallery/signature-gallery.html',
        data: {
            pageTitle: "PIXERF - Market Place Introduction",
        }
      });

  }

})();

/**
 * Controller for home module
 */
(function(){

  angular
    .module('pixerf')
    .controller('companyCtrl', companyCtrl);

    companyCtrl.$inject = ['headerSvc'];

    function companyCtrl(headerSvc){
        var self = this;
        self.contextPage = 'About';
        self.searchFilterBarSettings = headerSvc.getFixedByHeaderSetting();
    }
})();

(function() {
  'use strict';

  angular
    .module('pixerf')
    .config(routerConfig);

  routerConfig.$inject = ['$stateProvider'];

  function routerConfig($stateProvider) {
    'ngInject';
    $stateProvider
      .state('introduction-company', {
        templateUrl: 'app/introduction/company/company.html',
        data: {
                permissions: {
                only: ['EVERY_ONE']
            },

        },
        abstract: true,
        controller: 'companyCtrl',
        controllerAs: 'vm',
      })
      .state('introduction-company.terms', {
        url: '/introduction/company/terms',
        templateUrl: 'app/introduction/company/terms/terms.html',
        controller: 'termsCtrl',
        controllerAs: 'vm',
        data: {
            pageTitle: "PIXERF - Terms of Use",
        }
      })
      .state('introduction-company.privacy', {
        url: '/introduction/company/privacy',
        templateUrl: 'app/introduction/company/privacy/privacy.html',
        controller: 'privacyCtrl',
        controllerAs: 'vm',
        data: {
            pageTitle: "PIXERF - Privacy Policy",
        }
      })
      .state('introduction-company.license', {
        url: '/introduction/company/license',
        templateUrl: 'app/introduction/company/license/license.html',
        controller: 'licenseCtrl',
        controllerAs: 'vm',
        data: {
            pageTitle: "PIXERF - License Agreement",
        }
      });

  }

})();

/**
 * Controller for home module
 */
(function(){

  angular
    .module('pixerf')
    .controller('serverErrorCtrl', serverErrorCtrl);

    serverErrorCtrl.$inject = ['$state'];

    function serverErrorCtrl($state){
    	var self = this;
    }
})();
(function() {
    'use strict';

    angular
    .module('pixerf')
    .config(routerConfig);

    routerConfig.$inject = ['$stateProvider'];

    function routerConfig($stateProvider) {
        'ngInject';
        $stateProvider
        .state('500', {
            url: '/500',
            templateUrl: 'app/error/500/500.html',
            controller: 'serverErrorCtrl',
            controllerAs: 'vm',
            data: {
                permissions: {
                    only: ['EVERY_ONE']
                },
                pageTitle: "500 - Server error",
                hideFooter: true
            }
        });
    }

})();

/**
 * Controller for home module
 */
(function(){

  angular
    .module('pixerf')
    .controller('notFoundCtrl', notFoundCtrl);

    notFoundCtrl.$inject = ['$state'];

    function notFoundCtrl($state){
    	var self = this;

    	self.takeBack = function(){
    		window.history.back();
    	}
    }
})();
(function() {
    'use strict';

    angular
    .module('pixerf')
    .config(routerConfig);

    routerConfig.$inject = ['$stateProvider'];

    function routerConfig($stateProvider) {
        'ngInject';
        $stateProvider
        .state('404', {
            url: '/404',
            templateUrl: 'app/error/404/404.html',
            controller: 'notFoundCtrl',
            controllerAs: 'vm',
            data: {
                permissions: {
                    only: ['EVERY_ONE']
                },
                pageTitle: "404 - Not found",
                hideFooter: true
            }
        })
        .state('community-not-found', {
            url: '/community-not-found',
            templateUrl: 'app/error/404/community/community-not-found.html',
            controller: 'communityNotFoundCtrl',
            controllerAs: 'vm',
            data: {
                permissions: {
                    only: ['EVERY_ONE']
                },
                pageTitle: "404 - Community not found",
                hideFooter: true
            }
        });
    }

})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('winnerPhotoSelectionCtrl', winnerPhotoSelectionCtrl);

    winnerPhotoSelectionCtrl.$inject = ['$scope', 'pixerfApiMissionSvc', 'toastr', '$uibModalStack' ,'$timeout', '$state', '$q', 'translationSvc'];

    function winnerPhotoSelectionCtrl($scope, pixerfApiMissionSvc, toastr, $uibModalStack, $timeout, $state, $q, translationSvc) {
        var self = this;
		self.consolation = getConsolationSlot($scope.mission.prizes_grouped, $scope.media.id);
		self.numberConsolationRemaining = getNumberOfUnawardedPrize($scope.mission.prizes_grouped, "CONSOLATION");
		self.numberWinnersRemaining = getNumberOfUnawardedPrize($scope.mission.prizes_grouped, "WINNER") + getNumberOfUnawardedPrize($scope.mission.prizes_grouped, "GRAND_WINNER");
		self.onWinnerSelectionChanged = onWinnerSelectionChanged;
		self.onConsolationSelectionChanged = onConsolationSelectionChanged;
		self.filterUnawardedPrizes = filterUnawardedPrizes;
		self.isPhotoAwarded = isPhotoAwarded();
		self.isWorking = false;
		setSelectedPrize($scope.mission.prizes_grouped, $scope.media);
        function setSelectedPrize(prizesGrouped, media){
			for(var type in prizesGrouped){
				var prizes = prizesGrouped[type];
				for(var i = 0; i < prizes.length; i++){
					prizes[i].isSelected = false;
					if(prizes[i].winner && prizes[i].winner.media.id === media.id){
						prizes[i].isSelected = true;
					}
				}
			}
		}
		function saveSelection(prize){
			if(self.isWorking) return false;
			self.isWorking = true;
			var def = $q.defer();
			var verb = 'winner';
			var params = [{id: $scope.mission.id}];
			if(!prize.isSelected){
				verb = "remove_winner";
				params[0].prize_id = prize.id;
			} else {
				params.push({prize_id: prize.id, media_id: $scope.media.id});
			}
			pixerfApiMissionSvc[verb].apply(null, params).$promise.then(function(response){
				var prizeType = prize.type === 'WINNER' ? 'winning' : 'consolation';
				var msg = prize.isSelected ? 'Success! You have chosen this as a ' + prizeType + ' photo.' : 'You have removed this as a '  + prizeType  + ' photo.';
				$scope.mission.prizes_grouped = response.mission.prizes_grouped;
				setSelectedPrize($scope.mission.prizes_grouped, $scope.media);
				self.numberConsolationRemaining = getNumberOfUnawardedPrize($scope.mission.prizes_grouped, "CONSOLATION");
				self.numberWinnersRemaining = getNumberOfUnawardedPrize($scope.mission.prizes_grouped, "WINNER") + getNumberOfUnawardedPrize($scope.mission.prizes_grouped, "GRAND_WINNER");
                toastr.success(msg);
				self.isWorking = false;
				$timeout(function(){
					$uibModalStack.dismissAll();
					$state.go("mission-detail-page.awards");
				}, 1000);
				self.isPhotoAwarded = isPhotoAwarded();
				def.resolve();
            }, function(){
				self.isWorking = false;
				prize.isSelected = !prize.isSelected;
                toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
				def.reject();
            })
		}

		function removeWinner(prize){
			var def = $q.defer();
			pixerfApiMissionSvc.remove_winner({id: $scope.mission.id, prize_id: prize.id}).$promise.then(function(response){
                def.resolve();
            }, function(){
				def.reject();
			})
			
			return def.promise;;
		}

		function getSelectedPrize(prizesGrouped) {
			var result = null;
			for (var type in prizesGrouped) {
				var prizes = prizesGrouped[type];
				for (var i = 0; i < prizes.length; i++) {
					if (prizes[i].isSelected == true) {
						return result = prizes[i];
					}
				}
			}
			return result
		}

		function deselectAll(prizesGrouped){
            for(var type in prizesGrouped){
				var prizes = prizesGrouped[type];
				for(var i = 0; i < prizes.length; i++){
					prizes[i].isSelected = false;
				}
			}
        }
        function onWinnerSelectionChanged(prize){
			if(prize.isSelected){
				prize.isSelected = false;
			} else {
				deselectAll($scope.mission.prizes_grouped);
				prize.isSelected = true;
			}
			saveSelection(prize);
        }
		function getNumberOfUnawardedPrize(prizesGrouped, type){
			var countByAwardedState =  _.countBy(prizesGrouped[type], function(consolation){
				return consolation.winner ? "awarded" : 'unawarded';
			});
			return countByAwardedState['unawarded'] ? countByAwardedState['unawarded'] : 0;
		}
		function getAwardedPrize(mediaId, prizesGrouped, type){
			var prizes = prizesGrouped[type];
			return _.find(prizes, function(prize){
				return prize.winner && prize.winner.media.id === mediaId;
			})
		}
		function getUnawardedPrize(prizesGrouped, type){
			var prizes = prizesGrouped[type];
			return _.find(prizes, function(prize){
				return !prize.winner;
			})
		}
		function getConsolationSlot(prizesGrouped, mediaId){
			var awardedPrize = getAwardedPrize(mediaId, $scope.mission.prizes_grouped, "CONSOLATION");
			if(awardedPrize) {
				awardedPrize.isSelected = true;
				return awardedPrize;
			}
			return getUnawardedPrize($scope.mission.prizes_grouped, "CONSOLATION");
		}


		function onConsolationSelectionChanged() {
			if (self.isWorking) return false;
			var selectedPrize = getSelectedPrize($scope.mission.prizes_grouped);
			if (selectedPrize && self.consolation && (selectedPrize.id != self.consolation.id) && selectedPrize.isSelected) {
				removeWinner(selectedPrize).then(
					function success() {
						self.consolation.isSelected = !self.consolation.isSelected;
						saveSelection(self.consolation);
					},
					function error() {
						toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
					}
				)
			} else {
				self.consolation.isSelected = !self.consolation.isSelected;
				saveSelection(self.consolation);
			}
		}

		function isPhotoAwarded(){
			for(var type in $scope.mission.prizes_grouped){
				var result = isPhotoAwardedByType(type);
				if(result) return true;
			}
			return false;
		}
		function isPhotoAwardedByType(type){
			var awarded = _.find($scope.mission.prizes_grouped[type], function(item){
				return item.winner && item.winner.media.id == $scope.media.id;
			})
			if(awarded) return true;
			return false;
		}
        function filterUnawardedPrizes(value, index, array){
			var awarded = isPhotoAwarded();
			return (!awarded &&  !value.winner)  || (awarded && value.winner && value.winner.media.id == $scope.media.id);
		}
    }
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('winnerPhotoSelection', winnerPhotoSelection);

	function winnerPhotoSelection() {

		var directive = {
			restrict: 'E',
			templateUrl: 'app/components/winner-photo-selection/winner-photo-selection.html',
			controller: 'winnerPhotoSelectionCtrl',
			controllerAs: 'vm',
			replace: true,
			scope: {
				'mission': "=",
				"media": "="
			}
		};
		return directive;
	}

})();

/**
 * Controller for home module
 */
(function(){
  'use strict';
  angular
    .module('pixerf')
    .factory('welcomePopupSvc', welcomePopupSvc);
    welcomePopupSvc.$inject = ['$uibModalStack', '$uibModal'];

    function welcomePopupSvc($uibModalStack, $uibModal){
        function showPopup(data){
            return $uibModal.open({
                templateUrl: 'app/components/welcome-popup/welcome-popup.html',
                controller: 'welcomePopupCtrl',
                controllerAs: 'vm',
                animation: true,
                windowClass: 'zindex welcome-screen',
                resolve: {
                    'resolveData': function(){
                        return data;
                    }
                }
            });

        }
        
        return {
            showPopup: showPopup
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('welcomePopupCtrl', welcomePopupCtrl);

    welcomePopupCtrl.$inject = ['$uibModalInstance','resolveData','accountUtils'];

    function welcomePopupCtrl($uibModalInstance, resolveData, accountUtils) {

        var self = this;

        self.person = resolveData;
        self.greetingMessage = "Hi, " + accountUtils.buildUserDisplayName(resolveData);
        self.welcomeMessage = "welcome-back-to-pixerf";
        setTimeout(function(){ $uibModalInstance.close();}, 3000);
    }
})();
 (function () {
 	'use strict';
 	angular
 		.module('pixerf')
 		.factory('waitingEventLaunchPopupSvc', waitingEventLaunchPopupSvc);
 	waitingEventLaunchPopupSvc.$inject = ['$uibModal'];

 	function waitingEventLaunchPopupSvc($uibModal) {
 		function showPopup(data) {
 			return $uibModal.open({
 				templateUrl: 'app/components/waiting-event-launch-popup/waiting-event-launch-popup.html',
 				controller: 'waitingEventLaunchPopupCtrl',
 				controllerAs: 'vm',
 				animation: true,
 				backdrop: 'static',
 				windowClass: 'zindex waiting-event-launch-popup__screen',
 				resolve: {
 					'resolveData': function () {
 						return data;
 					}
 				}
 			});
 		}

 		return {
 			showPopup: showPopup
 		};
 	}
 })();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('waitingEventLaunchPopupCtrl', waitingEventLaunchPopupCtrl);

	waitingEventLaunchPopupCtrl.$inject = ['$uibModalInstance', 'resolveData'];

	function waitingEventLaunchPopupCtrl($uibModalInstance, resolveData) {

		var self = this;

		self.eventDateTime = resolveData.eventDateTime;
		self.eventType = resolveData.eventType || 'event/class';
		self.launchNow = launchNow;
		self.launchLater = launchLater;
		self.close = close;

		function launchNow() {
			$uibModalInstance.close("now");
		}

		function launchLater() {
			var later = moment(self.eventDateTime.date).subtract(30, 'days');
			later = later.format("YYYY-MM-DD");
			$uibModalInstance.close(later);
		}

		function close() {
			$uibModalInstance.dismiss();
		}
	}
})();

(function () {

	angular
		.module('pixerf')
		.factory('manageEventSvc', manageEventSvc);

		manageEventSvc.$inject = [];

	function manageEventSvc() {

		var mCustomPagingOptions = {
			label: "Rows per page:",
			showValues: [30, 50, 100]
		}

		function getCustomPagingOptions() {
			return mCustomPagingOptions;
		}

		return {
			getCustomPagingOptions: getCustomPagingOptions
		}
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('viewEventCtrl', viewEventCtrl);

		viewEventCtrl.$inject = ['$rootScope', 'sessionManagerSvc', 'eventData', '$state', '$timeout', 'pixerfApiCommunitySvc'];


	function viewEventCtrl($rootScope, sessionManagerSvc, eventData, $state, $timeout, pixerfApiCommunitySvc) {

		var USER_CONTROL_ADMINDASHBOARD = ['curator_internal', 'admin_internal', 'marketer_internal'];
		var self = this;
		self.user = sessionManagerSvc.getCurrentLoginUser().data;
		self.isAdmin = self.user && (USER_CONTROL_ADMINDASHBOARD.includes(self.user.role) || self.user.email === 'marcom@pixerf.com');
		self.subContextPage = "communities";
		self.isMyProfile = true;
		self.event = eventData;
		self.community = {};
		self.showTopCountMember = ($state.current.name == 'manage-event.members');
		self.showReportsNav = ($state.current.name == 'manage-event.reports');
		self.managerList = [];
		self.isOwner = self.user && (self.user.id === self.event.owner.id);
		self.loading = false;


		self.isScreenMobile = $rootScope.isScreenMobile;
        $(window).resize(function(){
            self.isScreenMobile = $rootScope.isScreenMobile;
        })

		$rootScope.$on('$stateChangeSuccess', function(event, toState){
            $timeout(function() {
                self.showTopCountMember = (toState.name == 'manage-event.members');
                self.showReportsNav = (toState.name == 'manage-event.reports');
            });
        });

		function isManager(){
			var result = true;
			var selectedUser = _.filter(self.managerList, function (item) {
				return item.id === self.user.id;
			});
			if(!selectedUser || !selectedUser.length){
				result = false;
			}
			return result;
		}
		function updateMembersCount(){
			if(self.event && self.event.stats){
				var members = _.filter(self.event.joined_users, function (user) {
					return user.id !== self.user.id;
				});
				self.event.stats.going = members.length;
				eventData.stats.going =  members.length;
			}
		}

		function isMember(){

			var result = false;
			if(!self.user || !self.user.id){
				return result
			}
			var member = _.find(self.event.joined_users, function(user){
				return user.id === self.user.id;
			});
			result = (member && member.id);

			return result
		}

		function getCommunity(communityId){
			self.loading = true;
			pixerfApiCommunitySvc.get({
				id: communityId
			}).$promise.then(function (response) {
				self.community = response.data;
				self.managerList = _.filter(self.community.members, function (item) {
					return item.status === 'manager';
				})

				if(!isMember()){
					$state.go("404");
				}
				self.loading = false;
			}, function (err) {
				console.log(err);
				self.loading = false;
			})
		}
		
		function init(){
			getCommunity(self.event.community_id);
			updateMembersCount();
		}

		init();

	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.config(routerConfig);

	routerConfig.$inject = ['$stateProvider'];

	function routerConfig($stateProvider) {
		'ngInject';

		$stateProvider
			.state('view-event', {
				url: '/view-event/:id/:name',
				templateUrl: 'app/components/view-event/view-event.html',
				controller: 'viewEventCtrl',
				controllerAs: 'vm',
				abstract: true,
				data: {
					permissions: {
						only: ['AUTHORIZED'],
						redirectTo: function () {
							return "404";
						}
					},
					pageTitle: "PIXERF - View Event"
				},
				params: {
					"id": {
						squash: true,
						value: null
					},
					"name": {
						squash: true,
						value: null
					}
				},
				resolve: {
					eventData: function ($stateParams, pixerfApiEventSvc, $q, $state, commonConst) {
						var defer = $q.defer();
						var self = this;
						var eventId = parseInt($stateParams.id);
						if (!$stateParams.id || ($stateParams.id && isNaN(eventId))) {
							$state.go('404');
							defer.reject();
						} else {
							pixerfApiEventSvc.get({
								id: eventId
							}).$promise.then(function (response) {
								var event = response.data;
								self.data.pageTitle = "PIXERF - Event: " + event.name;
								defer.resolve(event);
							}, function (err) {
								console.log(err);
								defer.reject();
							})
						}
						return defer.promise;
					}
				}
			})
			.state('view-event.members', {
				url: '/attendees/:status',
				templateUrl: 'app/components/view-event/view-event-members/view-event-members.html',
				controller: 'viewEventMembersCtrl',
				controllerAs: 'vm',
				data: {
					pageTitle: "PIXERF - View Event Attendees"
				}
			})
			.state('view-event.pending-posts', {
				url: '/pending-posts',
				templateUrl: 'app/components/view-event/pending-posts/pending-posts.html',
				controller: 'viewEventPendingPostsCtrl',
				controllerAs: 'vm',
				data: {
					pageTitle: "PIXERF - View event Pending Posts"
				}
			})
	}
})();

(function () {

	angular
		.module('pixerf')
		.factory('viewCommunitySvc', viewCommunitySvc);

		viewCommunitySvc.$inject = [];

	function viewCommunitySvc() {

		var mCustomPagingOptions = {
			label: "Rows per page:",
			showValues: [30, 50, 100]
		}

		function getCustomPagingOptions() {
			return mCustomPagingOptions;
		}

		return {
			getCustomPagingOptions: getCustomPagingOptions
		}
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('viewCommunityCtrl', viewCommunityCtrl);

		viewCommunityCtrl.$inject = ['$rootScope', 'sessionManagerSvc', 'communityData', '$state', '$timeout'];


	function viewCommunityCtrl($rootScope, sessionManagerSvc, communityData, $state, $timeout) {

		var USER_CONTROL_ADMINDASHBOARD = ['curator_internal', 'admin_internal', 'marketer_internal'];
		var self = this;
		self.user = sessionManagerSvc.getCurrentLoginUser().data;
		self.isAdmin = self.user && (USER_CONTROL_ADMINDASHBOARD.includes(self.user.role) || self.user.email === 'marcom@pixerf.com');
		self.subContextPage = "communities";
		self.isMyProfile = true;
		self.community = communityData;
		self.showTopCountMember = ($state.current.name == 'view-community.members');
		self.showReportsNav = ($state.current.name == 'view-community.reports');
		self.managerList = _.filter(self.community.members, function (item) {
			return item.status === 'manager';
		})
		self.memberList = _.filter(self.community.members, function (item) {
			return item.status === 'accepted';
		})
		self.isOwner = self.user && (self.user.id === self.community.owner.id);
		self.isManager = isManager;
		self.isMember = isMember;


		self.isScreenMobile = $rootScope.isScreenMobile;
        $(window).resize(function(){
            self.isScreenMobile = $rootScope.isScreenMobile;
        })

		$rootScope.$on('$stateChangeSuccess', function(event, toState){
            $timeout(function() {
                self.showTopCountMember = (toState.name == 'view-community.members');
                self.showReportsNav = (toState.name == 'view-community.reports');
            });
        });

		function isManager(){
			var result = true;
			var selectedUser = _.filter(self.managerList, function (item) {
				return item.id === self.user.id;
			});
			if(!selectedUser || !selectedUser.length){
				result = false;
			}
			return result;
		}

		function isMember(){
			var result = true;
			var selectedUser = _.filter(self.memberList, function (item) {
				return item.id === self.user.id;
			});
			if(!selectedUser || !selectedUser.length){
				result = false;
			}
			return result;
		}
		
		function init(){
			if(!isMember()){
				$state.go("404");
			}
		}

		init();

	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.config(routerConfig);

	routerConfig.$inject = ['$stateProvider'];

	function routerConfig($stateProvider) {
		'ngInject';

		$stateProvider
			.state('view-community', {
				url: '/view-community/:id/:name',
				templateUrl: 'app/components/view-community/view-community.html',
				controller: 'viewCommunityCtrl',
				controllerAs: 'vm',
				abstract: true,
				data: {
					permissions: {
						only: ['AUTHORIZED'],
						redirectTo: function () {
							return "404";
						}
					},
					pageTitle: "PIXERF - View community"
				},
				params: {
					"id": {
						squash: true,
						value: null
					},
					"name": {
						squash: true,
						value: null
					}
				},
				resolve: {
					communityData: function ($stateParams, pixerfApiCommunitySvc, $q, $state, commonConst) {
						var defer = $q.defer();
						var self = this;
						var communityId = parseInt($stateParams.id);
						if (!$stateParams.id || ($stateParams.id && isNaN(communityId))) {
							$state.go('404');
							defer.reject();
						} else {
							pixerfApiCommunitySvc.get({
								id: communityId
							}).$promise.then(function (response) {
								var community = response.data;
								self.data.pageTitle = "PIXERF - Community: " + community.name;
								defer.resolve(community);
							}, function (err) {
								console.log(err);
								$state.go(commonConst.STATE.COMMUNITY_NOT_FOUND);
								defer.reject();
							})
						}
						return defer.promise;
					}
				}
			})
			.state('view-community.members', {
				url: '/members/:status',
				templateUrl: 'app/components/view-community/view-community-members/view-community-members.html',
				controller: 'viewCommunityMembersCtrl',
				controllerAs: 'vm',
				data: {
					pageTitle: "PIXERF - View community members"
				}
			})
			.state('view-community.pending-posts', {
				url: '/pending-posts',
				templateUrl: 'app/components/view-community/pending-posts/pending-posts.html',
				controller: 'viewCommunityPendingPostsCtrl',
				controllerAs: 'vm',
				data: {
					pageTitle: "PIXERF - View community Pending Posts"
				}
			})
	}
})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.factory('videoPopupSvc', videoPopupSvc);
	videoPopupSvc.$inject = ['$uibModal'];

	function videoPopupSvc($uibModal) {

		function showPopup(data) {
			return $uibModal.open({
				templateUrl: 'app/components/video-popup/video-popup.html',
				controller: 'videoPopupCtrl',
				controllerAs: 'vm',
				animation: true,
				windowClass: 'zindex video-popup ' + data.windowClass,
				resolve: {
					'resolveData': function () {
						return data;
					}
				}
			});
		}

		return {
			showPopup: showPopup
		};
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('videoPopupCtrl', videoPopupCtrl);

	videoPopupCtrl.$inject = ['$uibModalInstance', 'resolveData', '$timeout', '$rootScope'];

	function videoPopupCtrl($uibModalInstance, resolveData, $timeout, $rootScope) {

		var self = this;
		self.close = close;
		self.videoId = resolveData.videoId;
		self.video = resolveData.data && resolveData.data.url ? resolveData.data.url : resolveData.data;

		function close() {
			$uibModalInstance.close();
		}

		$timeout(function () {
			if (self.videoId) {
				var vid = document.getElementById(self.videoId);
				vid.onloadedmetadata = function () {
					$rootScope.$emit("videoLoaded" + self.videoId);
				};
			}
		})
	}
})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('verifyBusinessBtnCtrl', verifyBusinessBtnCtrl);

    verifyBusinessBtnCtrl.$inject = ['$scope', 'pixerfApiUserSvc', 'pixerfConfirmPopupSvc', 'sessionManagerSvc', 'toastr'];

    function verifyBusinessBtnCtrl($scope, pixerfApiUserSvc, pixerfConfirmPopupSvc, sessionManagerSvc, toastr) {

        var self = this;
		self.isLoginedUser = sessionManagerSvc.getCurrentLoginUser();
        self.isDoingVerify = false;
        self.onVerifiedEmailClicked = onVerifiedEmailClicked;
        self.btnLabel = "";

        $scope.$watch('user.is_email_verified', function(newValue, oldValue){
            if($scope.user){
                setBtnLabel();
            }
        });

        function onVerifiedEmailClicked(){
			if(self.isDoingVerify) return;
			self.isDoingVerify = true;
			if(!$scope.user.is_email_verified){
				var pixerfConfirmPopup = pixerfConfirmPopupSvc.showPopup({
					hideTitle: true,
					hideConfirmText: true,
					message: "Are you sure you want to verify this business user?",
					okFn: function(){
						return  pixerfApiUserSvc.verify_user({user_id: $scope.user.id}).$promise;
					},
					okFnCallback: function(){
						self.isDoingVerify = false;
						$scope.user.is_email_verified = true;
						if($scope.onVerifiedEmailChanged) $scope.onVerifiedEmailChanged({status: $scope.user.is_email_verified});
						setBtnLabel();
						toastr.success("This user profile has been successfully verified!");
					}
				})

				pixerfConfirmPopup.result.then(function(){},function(){
					self.isDoingVerify = false;
				});
			}
        }

        function setBtnLabel(){
            self.btnLabel = $scope.user.is_email_verified ? "Verified User" : "Verify User";
        }

    }
})();

(function () {
	'use strict';

	angular
	  .module('pixerf')
	  .directive('verifyBusinessBtn', verifyBusinessBtn);

	function verifyBusinessBtn() {

	  var directive = {
		scope: {
		  "user" : "=",
		  "onVerifiedEmailChanged": "&"
		},
		restrict: 'E',
		templateUrl: 'app/components/verify-business-btn/verify-business-btn.html',
		controller: 'verifyBusinessBtnCtrl',
		controllerAs: 'vm',
		replace: true
	  };
	  return directive;
	}

  })();

/**
 * Controller for home module
 */
(function(){
  'use strict';
  angular
    .module('pixerf')
    .factory('verifiedEmailPopupSvc', verifiedEmailPopupSvc);
    verifiedEmailPopupSvc.$inject = ['$uibModalStack', '$uibModal'];

    function verifiedEmailPopupSvc($uibModalStack, $uibModal){
        function showPopup(data){
            return $uibModal.open({
                templateUrl: 'app/components/verified-email-popup/verified-email-popup.html',
                controller: 'verifiedEmailPopupCtrl',
                controllerAs: 'vm',
                animation: true,
                windowClass: 'zindex verified-email-screen',
                resolve: {
                    'resolveData': function(){
                        return data;
                    }
                }
            });

        }
        
        return {
            showPopup: showPopup
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('verifiedEmailPopupCtrl', verifiedEmailPopupCtrl);

    verifiedEmailPopupCtrl.$inject = ['$rootScope', '$uibModalInstance','resolveData','accountUtils', 'systemUtils', 'uploadPhotoSvc'];

    function verifiedEmailPopupCtrl($rootScope, $uibModalInstance, resolveData, accountUtils, systemUtils, uploadPhotoSvc) {

        var self = this;
        self.close = close;
        self.mobileOS = systemUtils.getMobileOS();
        self.showUploadModal = showUploadModal;
        function showUploadModal(){
            close();
			uploadPhotoSvc.showUploadModal();
		}
        function close(){
            $uibModalInstance.close();
        }
    }
})();
(function () {
	'use strict';
	angular
		.module('pixerf')
		.factory('verifiedBusinessUserPopupSvc', verifiedBusinessUserPopupSvc);
	verifiedBusinessUserPopupSvc.$inject = ['$uibModal'];

	function verifiedBusinessUserPopupSvc($uibModal) {

		function showPopup(data){
            return $uibModal.open({
                templateUrl: 'app/components/verified-business-user-popup/verified-business-user-popup.html',
                controller: 'verifiedBusinessUserPopupCtrl',
                controllerAs: 'vm',
                animation: true,
                windowClass: 'zindex verified-business-user-screen',
                resolve: {
                    'resolveData': function(){
                        return data;
                    }
                }
            });
        }

        return {
            showPopup: showPopup
        };
	}
})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('verifiedBusinessUserPopupCtrl', verifiedBusinessUserPopupCtrl);

    verifiedBusinessUserPopupCtrl.$inject = ['$uibModalInstance', '$state'];

    function verifiedBusinessUserPopupCtrl($uibModalInstance, $state) {

        var self = this;
        self.close = close;
		self.onBrowseMarketplaceClicked = onBrowseMarketplaceClicked;

		self.message = {
			header: "Thank You for Your Application",
			content: "Our team will review your application and confirm your Business Account within 7 working days. In the meantime, browse our Marketplace for inspiration or explore other features on our platform."
		};

		function onBrowseMarketplaceClicked(){
            $uibModalInstance.close();
            $state.go("buy-stock-page.trending");
        }

        function close(){
            $uibModalInstance.close();
        }
    }
})();
(function(){
	'use strict';
	angular
	  .module('pixerf')
	  .factory('verifiedBusinessEmailPopupSvc', verifiedBusinessEmailPopupSvc);
	  verifiedBusinessEmailPopupSvc.$inject = ['$uibModalStack', '$uibModal'];

	  function verifiedBusinessEmailPopupSvc($uibModalStack, $uibModal){
		  function showPopup(data){
			  return $uibModal.open({
				  templateUrl: 'app/components/verified-business-email-popup/verified-business-email-popup.html',
				  controller: 'verifiedBusinessEmailPopupCtrl',
				  controllerAs: 'vm',
				  animation: true,
				  windowClass: 'zindex verified-business-email-screen',
				  resolve: {
					  'resolveData': function(){
						  return data;
					  }
				  }
			  });

		  }

		  return {
			  showPopup: showPopup
		  };
	  }
  })();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('verifiedBusinessEmailPopupCtrl', verifiedBusinessEmailPopupCtrl);

    verifiedBusinessEmailPopupCtrl.$inject = ['$uibModalInstance', 'systemUtils'];

    function verifiedBusinessEmailPopupCtrl($uibModalInstance, systemUtils) {

        var self = this;
        self.close = close;
        self.mobileOS = systemUtils.getMobileOS();
        self.onStartClicked = onStartClicked;
        function onStartClicked(){
            close();
		}
        function close(){
            $uibModalInstance.close();
        }
    }
})();
(function() {
    'use strict';
    angular
        .module('pixerf')
        .directive('validationUnderMinAge', validationUnderMinAge);
    validationUnderMinAge.$inject = ['accountUtils'];

    function validationUnderMinAge(accountUtils) {
        return {
            require: 'ngModel',
            link: function(scope, elem, attr, ngModel) {
                var minAge = 18;
                //For DOM -> model validation
                ngModel.$parsers.unshift(function(value) {
                    var valid = !accountUtils.isUnderMinAge(value, minAge);
                    ngModel.$setValidity('validationUnderMinAge', valid);
                    return value;
                });

                //For model -> DOM validation
                ngModel.$formatters.unshift(function(value) {
                    var valid = !accountUtils.isUnderMinAge(value, minAge);
                    ngModel.$setValidity('validationUnderMinAge', valid);
                    return value;
                });
            }
        };
    }
})();

(function() {
    'use strict';
    angular
        .module('pixerf')
        .directive('validationOverMaxAge', validationOverMaxAge);
    validationOverMaxAge.$inject = ['accountUtils'];

    function validationOverMaxAge(accountUtils) {
        return {
            require: 'ngModel',
            link: function(scope, elem, attr, ngModel) {
                var maxAge = 100;
                //For DOM -> model validation
                ngModel.$parsers.unshift(function(value) {
                    var valid = !accountUtils.isOverMaxAge(value, maxAge);
                    ngModel.$setValidity('validationOverMaxAge', valid);
                    return value;
                });

                //For model -> DOM validation
                ngModel.$formatters.unshift(function(value) {
                    var valid = !accountUtils.isOverMaxAge(value, maxAge);
                    ngModel.$setValidity('validationOverMaxAge', valid);
                    return value;
                });
            }
        };
    }
})();

(function() {
    'use strict';
    angular
        .module('pixerf')
        .directive('validationNoSpecialCharacter', validationNoSpecialCharacter);
    validationNoSpecialCharacter.$inject = ['stringUtils'];

    function validationNoSpecialCharacter(stringUtils) {
        return {
            require: 'ngModel',
            link: function(scope, elem, attr, ngModel) {

                //For DOM -> model validation
                ngModel.$parsers.unshift(function(value) {
                    var valid = !stringUtils.isContainSpecialCharacter(value);
                    ngModel.$setValidity('validationNoSpecialCharacter', valid);
                    return value ;
                });

                //For model -> DOM validation
                ngModel.$formatters.unshift(function(value) {
                    var valid = !stringUtils.isContainSpecialCharacter(value);
                    ngModel.$setValidity('validationNoSpecialCharacter', valid);
                    return value;
                });
            }
        };
    }
})();

(function() {
    'use strict';
    angular
        .module('pixerf')
        .directive('validationNoNumber', validationNoNumber);
    validationNoNumber.$inject = ['accountUtils'];

    function validationNoNumber(accountUtils) {
        return {
            require: 'ngModel',
            link: function(scope, elem, attr, ngModel) {

                //For DOM -> model validation
                ngModel.$parsers.unshift(function(value) {
                    var valid = !accountUtils.isContainsNumber(value);
                    ngModel.$setValidity('validationNoNumber', valid);
                    return value;
                });

                //For model -> DOM validation
                ngModel.$formatters.unshift(function(value) {
                    var valid = !accountUtils.isContainsNumber(value);
                    ngModel.$setValidity('validationNoNumber', valid);
                    return value;
                });
            }
        };
    }
})();

(function() {
    'use strict';
    angular
        .module('pixerf')
        .directive('validationNoHyperlink', validationNoHyperlink);
    validationNoHyperlink.$inject = ['accountUtils'];

    function validationNoHyperlink(accountUtils) {
        return {
            require: 'ngModel',
            link: function(scope, elem, attr, ngModel) {

                //For DOM -> model validation
                ngModel.$parsers.unshift(function(value) {
                    var valid = !accountUtils.isContainsLink(value);
                    ngModel.$setValidity('validationNoHyperlink', valid);
                    return value ;
                });

                //For model -> DOM validation
                ngModel.$formatters.unshift(function(value) {
                    var valid = !accountUtils.isContainsLink(value);
                    ngModel.$setValidity('validationNoHyperlink', valid);
                    return value;
                });
            }
        };
    }
})();

(function() {
    'use strict';
    angular
        .module('pixerf')
        .directive('validationNoFileExtension', validationNoFileExtension);
    validationNoFileExtension.$inject = ['accountUtils'];

    function validationNoFileExtension(accountUtils) {
        return {
            require: 'ngModel',
            link: function(scope, elem, attr, ngModel) {

                //For DOM -> model validation
                ngModel.$parsers.unshift(function(value) {
                    var valid = !accountUtils.isContainsFileExtension(value);
                    ngModel.$setValidity('validationNoFileExtension', valid);
                    return value;
                });

                //For model -> DOM validation
                ngModel.$formatters.unshift(function(value) {
                    var valid = !accountUtils.isContainsFileExtension(value);
                    ngModel.$setValidity('validationNoFileExtension', valid);
                    return value;
                });
            }
        };
    }
})();

(function() {
    'use strict';
    angular
        .module('pixerf')
        .directive('validationMinMax', validationMinMax);
        validationMinMax.$inject = ['accountUtils'];

    function validationMinMax(accountUtils) {
        return {
            require: 'ngModel',
            scope: {
                validationMinMaxMin: "=", 
                validationMinMaxMax: "=",
            },
            link: function(scope, elem, attr, ngModel) {
                
                scope.$watchGroup(["validationMinMaxMin", "validationMinMaxMax"], function(){
                    ngModel.$setValidity('validationMinMaxMin', parseInt($(elem).val()) >= scope.validationMinMaxMin);
                    ngModel.$setValidity('validationMinMaxMax', parseInt($(elem).val()) <= scope.validationMinMaxMax);
                })
                //For DOM -> model validation
                ngModel.$parsers.unshift(function(value) {
                    // var range =  angular.fromJson(attr["validationMinMax"]);
                    value = parseFloat(value);
                    ngModel.$setValidity('validationMinMaxMin', value >= scope.validationMinMaxMin);
                    ngModel.$setValidity('validationMinMaxMax', value <= scope.validationMinMaxMax);
                    return value;
                });

                //For model -> DOM validation
                ngModel.$formatters.unshift(function(value) {
                    // var range =  angular.fromJson(attr["validationMinMax"]);
                    value = parseFloat(value);
                    ngModel.$setValidity('validationMinMaxMin', value >= scope.validationMinMaxMin);
                    ngModel.$setValidity('validationMinMaxMax', value <= scope.validationMinMaxMax);
                    return value;
                });
            }
        };
    }
})();

(function() {
    'use strict';
    angular
        .module('pixerf')
        .directive('validationForbiddenAge', validationForbiddenAge);
    validationForbiddenAge.$inject = ['accountUtils'];

    function validationForbiddenAge(accountUtils) {
        return {
            require: 'ngModel',
            link: function(scope, elem, attr, ngModel) {
                var forbiddenAge = 14;
                //For DOM -> model validation
                ngModel.$parsers.unshift(function(value) {
                    var valid = !accountUtils.isUnderMinAge(value, forbiddenAge);
                    ngModel.$setValidity('validationForbiddenAge', valid);
                    return value;
                });

                //For model -> DOM validation
                ngModel.$formatters.unshift(function(value) {
                    var valid = !accountUtils.isUnderMinAge(value, forbiddenAge);
                    ngModel.$setValidity('validationForbiddenAge', valid);
                    return value;
                });
            }
        };
    }
})();

(function() {
    'use strict';
    angular
        .module('pixerf')
        .directive('regEx', regEx);
    regEx.$inject = [''];

    function regEx() {
        return {
            restrict: "A",
            link: function(scope, elem, attrs) {
                var char;
                elem.on("keypress", function(event) {
                    char = String.fromCharCode(event.which)
                    if (!regexp.test(elem.val())){
                        event.preventDefault();
                    }
                })
            }
        };
    }
})();

(function() {
    'use strict';
    angular
        .module('pixerf')
        .directive('numberRange', numberRange);
    numberRange.$inject = ['accountUtils', 'systemUtils'];

    function numberRange(accountUtils, systemUtils) {
        return {
            restrict: "A",
            link: function(scope, elem, attrs) {
                function replaceSelection(str, selectionStart, selectionEnd){
                    // obtain the selected text
                    var sel = str.substring(selectionStart, selectionEnd);
                    //append te text;
                    return str.substring(0, selectionStart) + sel + str.substring(selectionEnd, str.length);
                }
                function doGetCaretPosition (oField) {

                    // Initialize
                    var iCaretPos = 0;

                    // IE Support
                    if (document.selection) {

                        // Set focus on the element
                        oField.focus();

                        // To get cursor position, get empty selection range
                        var oSel = document.selection.createRange();

                        // Move selection start to 0 position
                        oSel.moveStart('character', -oField.value.length);

                        // The caret position is selection length
                        iCaretPos = oSel.text.length;
                    }

                    // Firefox support
                    else if (oField.selectionStart || oField.selectionStart == '0')
                        iCaretPos = oField.selectionStart;

                    // Return results
                    return iCaretPos;
                }
                elem.on("keydown", function(e) {
                    
                    if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 110, 190]) !== -1 ||
                        // Allow: Ctrl+A, Command+A
                        (e.keyCode === 65 && (e.ctrlKey === true || e.metaKey === true)) || 
                        // Allow: home, end, left, right, down, up
                        (e.keyCode >= 35 && e.keyCode <= 40)) {
                            // let it happen, don't do anything
                            return;
                    }
                    // only allow number
                    if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
                        e.preventDefault();
                    }

                })
                elem.on("keypress", function(e) {

                    var char = String.fromCharCode(e.which);
                    if(!/[0-9]/g.test(char)){
                        return;
                    }
                    console.log(char);
                    var range = eval(attrs.numberRange);

                    var min = range[0];
                    var max = range[1];
                    min = min ? parseInt(min) : 0;
                    max = max ? parseInt(max) : undefined;
                    var number = parseInt(elem.val());

                    var selectionText = systemUtils.getInputSelectionText(elem[0]);
                    if(selectionText){
                        number = parseInt(elem.val().replace(selectionText, char));
                    } else{
                        var pos = doGetCaretPosition(elem[0]);
                        number = parseInt([elem.val().slice(0, pos), char, elem.val().slice(pos)].join(''));
                    }

                    var notValid = max ? (number < min || number > max) : (number < min);
                    if(notValid) {
                        e.preventDefault();
                    }
                })
                
            }
        };
    }
})();

(function () {

	angular
		.module('pixerf')
		.controller('userVerificationCtrl', userVerificationCtrl);

	userVerificationCtrl.$inject = ['$scope'];

	function userVerificationCtrl($scope) {
		var self = this;
		self.contextPage = "New sign-up";
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.config(routerConfig);

	routerConfig.$inject = ['$stateProvider'];

	function routerConfig($stateProvider) {
		'ngInject';
		$stateProvider

			.state('setting.user-verification', {
				url: '/user-verification',
				templateUrl: 'app/components/user-verification/user-verification.html',
				controller: 'userVerificationCtrl',
				controllerAs: 'vm',
				data: {
					permissions: {
						only: ['INTERNAL_MARKETER', 'ADMIN'],
						redirectTo: function () {
							return {
								state: 'home',
								params: {
									callback: location.hash.replace("#", '')
								}
							}
						}
					},
					hideFooter: true,
					pageTitle: "PIXERF - User Verification"
				}
			})
			.state('setting.user-verification.sign-up', {
				url: '/user-verification/new-sign-up',
				templateUrl: 'app/components/user-verification/new-sign-up/verification-new-sign-up.html',
				controller: 'verificationNewSignUpCtrl',
				controllerAs: 'vm',
				data: {
					pageTitle: "PIXERF - Verification New Sign Up"
				}
			})
            .state('setting.user-verification.pending-response', {
				url: '/user-verification/pending-user-response',
				templateUrl: 'app/components/user-verification/pending-user-response/verification-pending-user-response.html',
				controller: 'verificationPendingUserResponseCtrl',
				controllerAs: 'vm',
				data: {
					pageTitle: "PIXERF - Verification New Sign Up"
				}
			})
            .state('setting.user-verification.responded', {
				url: '/user-verification/responded-users',
				templateUrl: 'app/components/user-verification/responded-users/verification-responded-users.html',
				controller: 'verificationRespondedUsersCtrl',
				controllerAs: 'vm',
				data: {
					pageTitle: "PIXERF - Responded Users"
				}
			})
            .state('setting.user-verification.verified', {
				url: '/user-verification/verified-users',
				templateUrl: 'app/components/user-verification/verified-users/verification-verified-users.html',
				controller: 'verificationVerifiedUsersCtrl',
				controllerAs: 'vm',
				data: {
					pageTitle: "PIXERF - Verified Users"
				}
			})
            .state('setting.user-verification.rejected', {
				url: '/user-verification/rejected-users',
				templateUrl: 'app/components/user-verification/rejected-users/verification-rejected-users.html',
				controller: 'verificationRejectedUsersCtrl',
				controllerAs: 'vm',
				data: {
					pageTitle: "PIXERF - Rejected Users"
				}
			});
	}
})();

(function(){

	angular
	  .module('pixerf')
	  .controller('userTagCtrl', userTagCtrl);

	  userTagCtrl.$inject = ['$scope', 'sessionManagerSvc'];

	  function userTagCtrl($scope, sessionManagerSvc){

		  var self = this;
		  self.loginUser = sessionManagerSvc.getCurrentLoginUser().data;
		  self.isMyProfile =  self.loginnedUser && self.loginnedUser.id === $scope.userData.id;
	  }
  })();

(function () {
	'use strict';

	angular
	  .module('pixerf')
	  .directive('userTag', userTag);

	  userTag.$inject = ['$rootScope', '$interval'];
	  function userTag($rootScope, $interval) {

	  var directive = {
		scope: {
		  userData: "=",
		  onFollowStatusChanged: "&?",
		  isHideRemoveBtn: "="
		},
		  restrict: 'E',
		  templateUrl: 'app/components/user-tag/user-tag.html',
		  controller: 'userTagCtrl',
		  controllerAs: 'vm',
		  replace: true
		};
		return directive;
	  }

  })();

(function () {
  'use strict';

  angular
    .module('pixerf')
    .controller('userPostTileCtrl', userPostTileCtrl);

  userPostTileCtrl.$inject = ['$scope', '$timeout', 'systemUtils'];

  function userPostTileCtrl($scope, $timeout, systemUtils) {

    var self = this;
    self.images = $scope.postData.medias;
    self.trustedSource = systemUtils.trustSrc;
    self.isOwner = ($scope.isOwner == 'true');
    self.spinner = {
      isVisible: true
    };

    $timeout(function () {
      $(function () {
        var cells = 4;
        $('#justified-gallery-' + $scope.postData.id).imagesGrid({
          images: self.images,
          align: true,
          cells: cells,
          getViewAllText: function (imgsCount) { return imgsCount - cells + ' +' },
          onGridAligned: function () {
            self.loaded = true;
            systemUtils.digest($scope);
          }
        });

      });
    });
  }
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('userPostTile', userPostTile);

	function userPostTile() {

		var directive = {
			scope: {
				postData: "=",
				isOwner: "@?"
			},
			restrict: 'E',
			templateUrl: 'app/components/user-post-tile/user-post-tile.html',
			controller: 'userPostTileCtrl',
			controllerAs: 'vm',
			replace: true
		};
		return directive;
	}

})();

(function () {

	angular
		.module('pixerf')
		.controller('userListViewCtrl', userListViewCtrl);

		userListViewCtrl.$inject = ['$scope', 'sessionManagerSvc', 'systemUtils', 'confirmPopupSvc', 'removeMemberPopupSvc', '$q', 'toastr', 'translationSvc', '$translate', '$rootScope', 'pixerfApiEventSvc'];

	function userListViewCtrl($scope, sessionManagerSvc, systemUtils, confirmPopupSvc, removeMemberPopupSvc, $q, toastr, translationSvc, $translate, $rootScope, pixerfApiEventSvc) {

		var self = this;
		self.loginnedUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.onRemoveMember = onRemoveMember;
		self.users = $scope.users;
		self.event = $scope.event;

		$scope.$watch('context', function (newValue, oldValue) {
			if (oldValue !== newValue) {
				generateControl($scope.context);
			}
		});

		function init() {
			systemUtils.digest($scope);
			generateControl($scope.context);
		}

		function onRemoveMember(user) {
			$scope.onRemoved({
				user: user
			});
		}

		function removeMemberFromEvent(user){
			var def = $q.defer();
			var title = "Remove " + (user.displayName || user.first_name) + " from your Event?"
			var modal = confirmPopupSvc.showPopup({
				windowClass: 'cancel-event-confirm-popup',
				title: title,
				message: $translate.instant("this-user-will-no-longer-receive"),
				submitBtnText: 'Yes',
				cancelBtnText: 'Cancel'
			});

			modal.result.then(function () {
				var memberList ={'user_ids': [user.id]}; 
				pixerfApiEventSvc.removeMembers({
					event_id: self.event.id
				}, memberList).$promise.then(
					function success(res) {
						onRemoveMember(user);
						toastr.success("this event has been successfully canceled");
						def.resolve(res);
					},
					function error(err) {
						toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
						console.log(err);
						def.reject(err);
					}
				);
			},
			function err(err){
				var a;

				def.reject(err);
			})
			return def.promise;
		}

		function uninviteMemberFromEvent(user) {
			var def = $q.defer();
			pixerfApiEventSvc.deleteEventInvite({
				event_id: self.event.id,
				community_id: self.event.community_id
			}).$promise.then(
				function success(res) {
					onRemoveMember(user);
					toastr.success("this user has been successfully uninvited");
					def.resolve(res);
				},
				function error(err) {
					toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
					console.log(err);
					def.reject(err);
				}
			);
			return def.promise;
		}

		function removeMemberFromCommunity(user){
			var community = { id: self.event.community_id }
			var def = $q.defer();
			var removePopup = removeMemberPopupSvc.showPopup({
				community: community,
				user: user
			})
			removePopup.result.then(
				function (data) {
					if (data.user) {
						self.profiles = _.reject(self.profiles, function (p) {
							return p.id === data.user.id;
						})
						def.resolve(data);
					}
				},
				function error(err) {
					def.reject(err);
				})
			return def.promise;
		}

		function removeFromeEventAndCommunity(user){
			removeMemberFromEvent(user).then(
				function success(res){
					removeMemberFromCommunity(user);

				},
				function error(err){
					if(err != 'cancel'){
						toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
					}
				}
			)
		}


		function generateControl(context){
			switch (context) {
				case 'pending':
					self.isShowActionRequiredButton = true;
					self.isShowAprroveButton = true;
					break;
				case 'going':
					self.actions = [{
							label: 'Remove from Event',
							cta: removeMemberFromEvent
						},
						{
							label: 'Remove from Event and Community',
							cta: removeFromeEventAndCommunity
						}
						];
					break;
				case 'invited':
					self.actions = [{
						label: 'Uninvite',
						cta: uninviteMemberFromEvent
					}
					];
					break;
				case 'interested':
					self.isShowMoreButton = true;
					self.actions = [];
					break;
			}
		}

		init()
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('userListView', userListView);

		userListView.$inject = [];

	function userListView() {

		var directive = {
			scope: {
				users: "=",
				control: "=",
				context: "@",
				event: "=",
				onRemoved: "&"
			},
			restrict: 'E',
			templateUrl: 'app/components/user-list-view/user-list-view.html',
			controller: 'userListViewCtrl',
			controllerAs: 'vm',
			replace: true
		};
		return directive;
	}

})();

(function () {

	angular
		.module('pixerf')
		.controller('userInfoVerificationTileCtrl', userInfoVerificationTileCtrl);

	userInfoVerificationTileCtrl.$inject = ['$scope', 'ISO3166', 'confirmSuccessPopupSvc', 'confirmPopupSvc', '$q', 'pixerfApiUserSvc', 'toastr'];

	function userInfoVerificationTileCtrl($scope, ISO3166, confirmSuccessPopupSvc, confirmPopupSvc, $q, pixerfApiUserSvc, toastr) {

		var self = this;
		self.user = $scope.data;
		self.invalidInfo = {};
		self.context = $scope.context;
		self.emailUserToValidateInfo = emailUserToValidateInfo;
		self.verifyUser = verifyUser;
		self.remindUserValidate = remindUserValidate;
		self.rejectUser = rejectUser;

		init();

		function init() {
			self.country = ISO3166.getCountryName(self.user.organization.address.country);
			genTemplate(self.context);
		}

		function genTemplate(context) {
			switch (context) {
				case "new":
					self.hintAction = "Verify the user if all the fields below can be validated. Otherwise, please select the fields that require further validation from the user.";
					self.showEmailBtn = true;
					self.showVerifyBtn = true;
					self.showComment = true;
					break;
				case "pending":
					self.hintAction = "The checked fields below are those that PIXERF has reached out to the user for further validation.";
					self.showRemindBtn = true;
					self.disabledInput = true;
					self.showComment = true;
					initInvalidInfo();
					validationRequestDateFormat();
					break;
				case "responded":
					self.hintAction = "The field(s) previously flagged by PIXERF for further validation is/are highlighted.<br/>Verify the user if all the fields below can be validated. Otherwise, please select the fields that require further validation from the user.";
					self.showEmailBtn = true;
					self.showVerifyBtn = true;
					self.showComment = true;
					initUserUpdatedInfo();
					validationRequestDateFormat();
					break;
				case "verified":
					self.hideCheckbox = true;
					break;
				case "rejected":
					self.hideCheckbox = true;
					self.hideRejectBtn = true;
					break;
			}
		}

		function emailUserToValidateInfo() {
			if (!self.comment) {
				toastr.error("Please input Additional Comment for the user!");
				return;
			}
			var invalidInfo = _.pick(self.invalidInfo,
				function (info) {
					return info === true;
				}
			);
			invalidInfo = _.keys(invalidInfo);

			pixerfApiUserSvc.transit_verification_status({
				id: self.user.id,
				action: 'request_changes'
			}, {
				description: self.comment,
				unverified_fields: invalidInfo
			}).$promise.then(function (response) {
				confirmSuccessPopupSvc.showPopup({
					windowClass: 'user-info-verification-tile__confirm-success-popup',
					message: 'An email has been sent to the user.'
				});
				$scope.onStatusChanged({
					user: self.user
				});
			})
		}

		function verifyUser() {
			confirmPopupSvc.showPopup({
				message: "Are you sure you want to verify business user <span class=\"text--bold text--color-black\">" + self.user.first_name + "</span>?",
				submitBtnText: 'Yes',
				cancelBtnText: 'No',
				submit: function () {
					var def = $q.defer();
					pixerfApiUserSvc.transit_verification_status({
						id: self.user.id,
						action: 'verify'
					}, null).$promise.then(function (response) {
						confirmSuccessPopupSvc.showPopup({
							windowClass: 'user-info-verification-tile__confirm-success-popup',
							message: "<span class=\"text--bold text--color-black\">" + self.user.first_name + "</span> has been successfully verified."
						});
						def.resolve(response);
					}).catch(function () {
						def.reject();
					})
					return def.promise;
				},
				submitCallback: function () {
					$scope.onStatusChanged({
						user: self.user
					});
				}
			});
		}

		function remindUserValidate() {
			var invalidInfo = _.pick(self.invalidInfo,
				function (info) {
					return info === true;
				}
			);
			invalidInfo = _.keys(invalidInfo);

			pixerfApiUserSvc.transit_verification_status({
				id: self.user.id,
				action: 'request_changes'
			}, {
				description: self.comment,
				unverified_fields: invalidInfo
			}).$promise.then(function (response) {
                validationRequestDateFormat(true);
				confirmSuccessPopupSvc.showPopup({
					windowClass: 'user-info-verification-tile__confirm-success-popup',
					message: 'An email has been sent to the user.'
				});
			})
		}

		function initInvalidInfo() {
			self.invalidInfo = {
				first_name: self.user.verification_comment.unverified_fields.includes('first_name'),
				email: self.user.verification_comment.unverified_fields.includes('email'),
				telephone: self.user.verification_comment.unverified_fields.includes('telephone'),
				name: self.user.verification_comment.unverified_fields.includes('name'),
				registration_no: self.user.verification_comment.unverified_fields.includes('registration_no'),
				office_type: self.user.verification_comment.unverified_fields.includes('office_type'),
				country: self.user.verification_comment.unverified_fields.includes('country'),
				city: self.user.verification_comment.unverified_fields.includes('city')
			};
			self.comment = self.user.verification_comment.description;
		}

		function initUserUpdatedInfo() {
			self.updatedInfo = {
				first_name: self.user.verification_comment.unverified_fields.includes('first_name'),
				email: self.user.verification_comment.unverified_fields.includes('email'),
				telephone: self.user.verification_comment.unverified_fields.includes('telephone'),
				name: self.user.verification_comment.unverified_fields.includes('name'),
				registration_no: self.user.verification_comment.unverified_fields.includes('registration_no'),
				office_type: self.user.verification_comment.unverified_fields.includes('office_type'),
				country: self.user.verification_comment.unverified_fields.includes('country'),
				city: self.user.verification_comment.unverified_fields.includes('city')
			};
			self.comment = self.user.verification_comment.description;
		}

		function validationRequestDateFormat(isToday) {
            if(isToday){
                self.verificationDate = moment().format("DD/MM/YYYY");
            } else if (self.user.verification_comment.updated_at) {
				self.verificationDate = moment(self.user.verification_comment.updated_at).format("DD/MM/YYYY");
			} else if (self.user.verification_comment.inserted_at) {
				self.verificationDate = moment(self.user.verification_comment.inserted_at).format("DD/MM/YYYY");
			}
		}

		function rejectUser() {
			confirmPopupSvc.showPopup({
				message: "Are you sure you want to reject business user <span class=\"text--bold text--color-black\">" + self.user.first_name + "</span>?",
				submitBtnText: 'Yes',
				cancelBtnText: 'No',
				submit: function () {
					var def = $q.defer();
					pixerfApiUserSvc.transit_verification_status({
						id: self.user.id,
						action: 'reject'
					}, null).$promise.then(function (response) {
						confirmSuccessPopupSvc.showPopup({
							message: 'You have rejected ' + self.user.displayName
						});
						def.resolve(response);
					}).catch(function () {
						def.reject();
					})
					return def.promise;
				},
				submitCallback: function () {
					$scope.onStatusChanged({
						user: self.user
					});
				}
			});
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('userInfoVerificationTile', userInfoVerificationTile);

	userInfoVerificationTile.$inject = [];

	function userInfoVerificationTile() {

		var directive = {
			scope: {
				data: "=",
                context: "@",
                onStatusChanged: "&?"
			},
			restrict: 'E',
			templateUrl: 'app/components/user-info-verification-tile/user-info-verification-tile.html',
			controller: 'userInfoVerificationTileCtrl',
			controllerAs: 'vm',
			replace: true
		};
		return directive;
	}

})();

(function(){

	angular
	  .module('pixerf')
	  .controller('userInfoCtrl', userInfoCtrl);

	  userInfoCtrl.$inject = [];

	  function userInfoCtrl(){

		  var self = this;
	  }
  })();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('userInfo', userInfo);

	userInfo.$inject = [];
	function userInfo() {

		var directive = {
			scope: {
				userData: "=",
			},
			restrict: 'E',
			templateUrl: 'app/components/user-info/user-info.html',
			controller: 'userInfoCtrl',
			controllerAs: 'vm',
			replace: true
		};
		return directive;
	}

})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.factory('uploadProfilePhotoSvc', uploadProfilePhotoSvc);

	uploadProfilePhotoSvc.$inject = ['$uibModal', '$log'];

	function uploadProfilePhotoSvc($uibModal, $log) {

		function showPopup(params) {

			$log.debug('Open file upload modal');

			var uploadModal = $uibModal.open({
				size: 'lg',
				openedClass: 'upload-profile-photo-popup',
				templateUrl: 'app/components/upload-profile-photo/upload-profile-photo.html',
				controller: 'uploadProfilePhotoCtrl',
				controllerAs: 'vm',
				resolve: {
					data: function () {
						return params;
					}
				}
			});

			return uploadModal;
		}

		return {
			showPopup: showPopup
		};
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('uploadProfilePhotoCtrl', uploadProfilePhotoCtrl);

	uploadProfilePhotoCtrl.$inject = ['uploadPhotoSvc', '$scope', 'sessionManagerSvc', '$log', '$uibModalInstance', 'pixerfUrl', 'toastr', 'data', 'systemUtils', 'fileConst', 'imageUtils'];

	function uploadProfilePhotoCtrl(uploadPhotoSvc, $scope, sessionManagerSvc, $log, $uibModalInstance, pixerfUrl, toastr, data, systemUtils, fileConst, imageUtils) {

		var self = this;
		self.data = data;
		self.showMessage = true;
		self.uploading = false;
		self.canceling = false;
		self.loginedUser = sessionManagerSvc.getCurrentLoginUser().data;
		// Note: add /zuul/ to avoid duplicate processing!
		$scope.$on('modal.closing', function (uploadPhotoClosingEvent) {
			if (self.uploading) {
				self.cancelConfirmResult = confirm('Hang on, your ' + self.data.type + ' photo has not been uploaded yet. Are you sure you want to cancel?');
				uploadPhotoClosingEvent.preventDefault();
				if (self.cancelConfirmResult) {
					self.dropzoneConfig.instance.removeAllFiles(true);
				}
			}
		});
		self.cropper = self.data.type === 'profile' ? {
			instance: null,
			options: {
				viewport: {
					width: 145,
					height: 145,
					type: self.loginedUser.account_type === 'business' ? 'square' : 'circle'
				}
			}
		} : {
			instance: null,
			options: {
				showZoomer: true,
				viewport: {
					width: 500,
					height: 200
				}
			}
		};
		self.dropzoneConfig = {
			'instance': {},
			'options': {
				url: self.data.url ? self.data.url : pixerfUrl.full + 'api/users/' + self.data.type,
				maxFilesize: 10,
				maxFiles: 1,
				paramName: self.data.paramName ? self.data.paramName : 'media',
				parallelUploads: 10,
				autoProcessQueue: false,
				thumbnailHeight: null,
				thumbnailWidth: null,
				dictRemoveFile: "Remove photo",
				createImageThumbnails: false,
				previewsContainer: '#previews',
				clickable: '.upload-photo__upload-area__dropzone__main-content__browse-btn',
				method: self.data.method ? self.data.method : 'post',
				headers: {
					"Authorization": "Bearer " + sessionManagerSvc.getToken()
				},
				dictFileTooBig: "File is too big ({{filesize}} MB). Max file size is: {{maxFilesize}} MB.",
				accept: function (file, done) {
					var errMsg = fileTypeValidation(file);
					done(errMsg);
				}
			},
			'eventHandlers': {
				'success': function (file, response) {
					self.uploading = false;
					console.log(file);
					if (self.canceling) return;
					var returnThumbnails = self.data.returnParams ? response[self.data.returnParams] : response.thumbnails;
					for (var props in returnThumbnails) {
						if (returnThumbnails[props]) {
							returnThumbnails[props] += '?t=' + moment().unix();
						}
					}
					var responseData = {
						response: response, 
						thumbnails: returnThumbnails
					}
					$uibModalInstance.close(responseData);
					systemUtils.digest($scope);
				},
				'error': function (file, err) {
					console.log(err);
					self.uploading = false;
					self.showMessage = true;
					self.isGeneratingThumbnail = false;
					toastr.error(err);
					self.dropzoneConfig.instance.removeAllFiles();
					systemUtils.digest($scope);
				},
				'canceled': function (file) {
					self.uploading = false;
					this.removeAllFiles();
					$uibModalInstance.dismiss();
				},
				'addedfile': function (file) {
					self.showMessage = false;
					if (this.files.length > 1) {
						this.removeFile(this.files[0]);
					}
					self.isGeneratingThumbnail = true;
					if (!uploadPhotoSvc.isExceedMaxSize(file, self.dropzoneConfig.options.maxFilesize * 1024 * 1024) && !fileTypeValidation(file)) {
						imageUtils.customDropzoneThumbnail(file, this);
					}

					systemUtils.digest($scope);

				},
				'thumbnail': function (file, dataUrl) {
					if (file.isCropped) return false;
					self.isGeneratingThumbnail = false;
					file.thumbnail = dataUrl;
					$scope.$apply();
					return true;

				}
			}
		};
		self.cancel = function () {
			$uibModalInstance.dismiss();
		};
		self.upload = function () {
			if (self.dropzoneConfig.instance.getAcceptedFiles().length === 0) {
				toastr.error("You have not selected any photo to upload.");
				return;
			}
			self.uploading = true;
			if (self.cropper) {
				var croppedSize = self.data.type === 'profile' ? {
					width: 300,
					height: 300
				} : {
					width: 1500,
					height: 600
				};
				self.cropper.instance.croppie('result', {
					type: 'blob',
					size: croppedSize
				}).then(function (croppedBlobFile) {
					self.dropzoneConfig.instance.removeAllFiles();
					croppedBlobFile.isCropped = true;
					self.dropzoneConfig.instance.addFile(croppedBlobFile);
					self.dropzoneConfig.instance.processQueue();
				});
			} else {
				self.dropzoneConfig.instance.processQueue();
			}
		};

		self.reset = function () {
			self.dropzoneConfig.instance.removeAllFiles();
		};

		function fileTypeValidation(file) {
			if (file.type !== "image/jpeg" &&
				file.type !== "image/png") {
				return "Sorry, we only accept JPEG or PNG file.";
			}
		}

		var mPhotoRestriction = {
			'cover': {
				idealWidth: 1500,
				idealHeight: 1500,
				maxWidth: 20000,
				maxHeight: 20000,
			},
			'profile': {
				idealWidth: 400,
				idealHeight: 400,
				maxWidth: 20000,
				maxHeight: 20000,
			}
		}

		function checkFileDimension(file) {
			var photoRestriction = mPhotoRestriction[self.data.type];
			if (file.width > photoRestriction.maxWidth || file.height > photoRestriction.maxHeight) {
				return _.template("Your photo's dimension must be less than <%= maxWidth %> pixels for width and height")(photoRestriction);
			}
		}

		function checkIdealDimension(file) {
			var photoRestriction = mPhotoRestriction[self.data.type];
			if (file.width !== file.height && file.width !== photoRestriction.idealWidth || file.height != photoRestriction.idealHeight) {
				return _.template("Your photo is still ok but it should be square. The ideal pixel size for your photo is <%= idealWidth %> x <%= idealHeight %>.")(photoRestriction);
			}
		}

	}
})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.factory('uploadPortfolioPhotoDetailSvc', uploadPortfolioPhotoDetailSvc);

	uploadPortfolioPhotoDetailSvc.$inject = ['addToPortfolioGallerySvc', 'accountUtils', '$translate'];

	function uploadPortfolioPhotoDetailSvc(addToPortfolioGallerySvc, accountUtils, $translate) {

		function isMultipleValue(files, property) {
			var firstFile = files[0];
			return !_.every(files, function (f) {
				return _.isEqual(firstFile[property], f[property]);
			})
		}

		function validate(files) {
			for (var i = 0; i < files.length; i++) {
				var file = files[i];
				if (!file.galleries || !file.galleries.length){
					return $translate.instant("please-select-portfolio-gallery-for-your-photos");
				}
				var valid = !accountUtils.isContainsFileExtension(file.title);
				if (!valid) return "Sorry, " + "Photo title cannot contain extension.";
			}
		}

		function synchonizedFilesInfo(files, property, value) {
			for (var i = 0; i < files.length; i++) {
				if (typeof value === 'object') {
					if (Array.isArray(value)) {
						files[i][property] = $.extend(true, [], value);
					} else {
						files[i][property] = $.extend(true, {}, value);
					}
				} else {
					files[i][property] = value;
				}
			}
		}

		function updateMasterFile(masterFile, property, value) {
			masterFile.data[property] = value;
		}

		function buildMasterFilePortfolioGalleries(files) {
			var arr = _.reduce(files, function (memo, item) {
				if (item.galleries && item.galleries.length > 0) {
					memo = memo.concat(item.galleries);
				}
				return memo;
			}, []);
			return _.uniq(arr, function (item) {
				return item.id;
			});
		}

		function buildMasterFile(masterFile, files, synchronizable) {

			var firstFile = files[0];
			if (!synchronizable) {
				masterFile.data = firstFile;
			} else {

				masterFile.data = {
					name: '',
					galleries: [],
					user: null
				};
			}
			if (!firstFile) {
				masterFile.data = null;
				return;
			}
			masterFile.data.name = firstFile.name;
			for (var property in masterFile.data) {
				if (property === "user") {
					masterFile.data.user = firstFile.user;
				} else if (property === "galleries") {
					masterFile.data.galleries = files.length > 1 && isMultipleValue(files, property) ? buildMasterFilePortfolioGalleries(files) : firstFile.galleries;
					masterFile.data.portfolioGalleriesName = addToPortfolioGallerySvc.buildPortfolioGalleriesNames(masterFile.data.galleries);
				} else {
					if (Array.isArray(masterFile.data[property])) {
						masterFile.data[property] = files.length > 1 && isMultipleValue(files, property) ? 'Multiple ' + property + "s" : firstFile[property];
					} else if (typeof masterFile.data[property] === "object") {
						masterFile.data[property] = files.length > 1 && isMultipleValue(files, property) ? 'Multiple ' + property + "s" : firstFile[property] ? firstFile[property] : undefined;
					} else {
						masterFile.data[property] = files.length > 1 && isMultipleValue(files, property) ? 'Multiple ' + property + "s" : firstFile[property];
					}
				}
			}
		}
		return {
			synchonizedFilesInfo: synchonizedFilesInfo,
			validate: validate,
			buildMasterFile: buildMasterFile,
			updateMasterFile: updateMasterFile
		};
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('uploadPortfolioPhotoDetailCtrl', uploadPortfolioPhotoDetailCtrl);

	uploadPortfolioPhotoDetailCtrl.$inject = ['portfolioPhotoSvc', 'sessionManagerSvc', '$scope', 'uploadPortfolioPhotoDetailSvc', 'addToPortfolioGallerySvc', 'toastr', 'portfolioConst'];

	function uploadPortfolioPhotoDetailCtrl(portfolioPhotoSvc, sessionManagerSvc, $scope, uploadPortfolioPhotoDetailSvc, addToPortfolioGallerySvc, toastr, portfolioConst) {

		var self = this;
		self.onPortfolioGallerySelected = onPortfolioGallerySelected;
		self.synchonizedFilesInfo = synchonizedFilesInfo;
		self.loginUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.masterFile = { data: null };
		self.showSelectPortfolio = false;
		self.onSelectPortfolioClicked = onSelectPortfolioClicked;
		self.portfolioSetting = {
			"items": []
		};
		self.portfolioId = $scope.portfolioId;
		self.selectedPortfolio = null;

		$scope.$watch("portfolioId", function(){
            self.portfolioId = $scope.portfolioId;
		});
		
		function synchonizedFilesInfo() {
			if ($scope.synchronizable) {
				uploadPortfolioPhotoDetailSvc.synchonizedFilesInfo.apply(uploadPortfolioPhotoDetailSvc, arguments);
			}
			$scope.formError = uploadPortfolioPhotoDetailSvc.validate($scope.files);
		}
		$scope.$watchCollection("files", function (newFiles, oldValue) {
			uploadPortfolioPhotoDetailSvc.buildMasterFile(self.masterFile, newFiles, $scope.synchronizable, $scope.categories);
		});
		function onPortfolioGallerySelected(portfolioGallery) {
			if($scope.files && !!$scope.files.length && ($scope.files.length + portfolioGallery.media_count + portfolioGallery.pending_media_count) > portfolioConst.MAX_PHOTO_GALLERY){
				portfolioGallery.isSelected = false;
				toastr.error("You have reached the upload limit for " + portfolioGallery.title);
			} else {
				portfolioPhotoSvc.updateFileGalleriesInfo(self.masterFile.data, portfolioGallery);
				self.masterFile.data.portfolioGalleriesName = addToPortfolioGallerySvc.buildPortfolioGalleriesNames(self.masterFile.data.galleries);
			}
		}

		function onSelectPortfolioClicked(portfolio){
			self.selectedPortfolio = portfolio;
			self.portfolioId = portfolio.value;
		}

		function buildSpecialList(){
			var specialities = self.loginUser.profile.specialities;
			for(var i = 0; i< specialities.length; i++){
				self.portfolioSetting.items.push({
					name: specialities[i].name,
					value: specialities[i].id
				})
			}
			self.selectedPortfolio = self.portfolioSetting.items[0];
			self.portfolioId = self.selectedPortfolio.value;
		}

		function init(){
			if(!$scope.portfolioId && (self.loginUser.profile && self.loginUser.profile.specialities && self.loginUser.profile.specialities.length)){
				buildSpecialList();
				self.showSelectPortfolio = true;
			}

		}

		init();
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('uploadPortfolioPhotoDetail', uploadPortfolioPhotoDetail);

	function uploadPortfolioPhotoDetail() {

		var directive = {
			scope: {
				files: "=",
				portfolioId: "@",
				synchronizable: '=',
				formError: "=",
				isFormDirty: "="
			},
			restrict: 'E',
			templateUrl: 'app/components/upload-portfolio-photo-detail/upload-portfolio-photo-detail.html',
			controller: 'uploadPortfolioPhotoDetailCtrl',
			controllerAs: 'vm',
			replace: true
		};
		return directive;
	}

})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.factory('uploadPortfolioPhotoSvc', uploadPortfolioPhotoSvc);
	uploadPortfolioPhotoSvc.$inject = ['toastr', 'arrayUtils', 'numberUtils', '$window', '$q', 'resendVerificationEmailPopupSvc', 'editProfileSvc', 'agreementPopupSvc', 'sessionManagerSvc', 'googleAnalyticSvc', 'pixerfApiMediaSvc', '$uibModal', 'fileUtils', 'translationSvc'];

	function uploadPortfolioPhotoSvc(toastr, arrayUtils, numberUtils, $window, $q, resendVerificationEmailPopupSvc, editProfileSvc, agreementPopupSvc, sessionManagerSvc, googleAnalyticSvc, pixerfApiMediaSvc, $uibModal, fileUtils, translationSvc) {

		var mFiles = {
			data: []
		};
		var mAddedBufferFiles = {
			data: []
		};
		var mSelectedFiles = {
			data: []
		};

		var isFullscreenDropzone = {
			data: false
		};

		var mOverlay = {
			data: false
		};
		var mUploadModal = {
			data: null
		};

		var dragPhotoEvent = {

			over: function (overlay) {
				if (!mUploadModal.data) return;
				isFullscreenDropzone.data = true;
			},
			leave: function (overlay) {
				isFullscreenDropzone.data = false;
			}
		};

		function setOverlay(status) {
			mOverlay.data.visible = status;
		}

		function getUploadModal() {
			return mUploadModal;
		}

		function getSelectedFiles() {
			return mSelectedFiles;
		}

		function showPopup(data) {

			googleAnalyticSvc.trackPageView("Upload Portfolio Photo");
			mUploadModal.data = $uibModal.open({
				size: 'full',
				templateUrl: 'app/components/upload-portfolio-photo/upload-portfolio-photo.html',
				controller: 'uploadPortfolioPhotoCtrl',
				controllerAs: 'vm',
				openedClass: 'upload-portfolio-photo-modal',
				resolve: {
					popupData: function () {
						var def = $q.defer();
						def.resolve(data);
						return def.promise;
					}
				}
			});

			mUploadModal.data.result.then(function () { }, function () { });
		}

		function runFakeProgress(file) {

			file.fakeProgressInterval = $window.setInterval(function () {
				if (file.upload.progress >= 99) {
					$window.clearInterval(file.fakeProgressInterval);
					delete file.fakeProgressInterval;
					return;
				}
				var leftleft = 99 - file.upload.progress;
				var step = numberUtils.getRandomInRange(1, leftleft);
				var progress = step + file.upload.progress;
				updateProgress(file, progress);
			}, 1000);

		}

		function showUploadModal(data) {
			var loginUser = sessionManagerSvc.getCurrentLoginUser().data;
			if (loginUser.is_email_verified) {
				if (!loginUser.is_contributor_agreement_accepted) {
					var modal = agreementPopupSvc.showPopup({
						windowClass: 'agree-terms-popup',
						message: 'I agree to the <a ui-sref="introduction-company.terms" target="_blank" class="text--bold text--color-pixerf-theme">Terms</a>',
						okFn: function (isAgree, isWorking) {
							var def = $q.defer();
							loginUser = sessionManagerSvc.getCurrentLoginUser().data;
							loginUser.is_contributor_agreement_accepted = true;
							sessionManagerSvc.setCurrentLoginUser(loginUser);
							editProfileSvc.updateUser(loginUser).then(function () {
								modal.close();
								def.resolve(showPopup(data));
							}, function () {
								toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
								def.reject();
							});
							return def.promise;
						}
					})
				} else {
					showPopup(data);
				}
			} else {
				resendVerificationEmailPopupSvc.showVerifyEmailPopup();
			}

		}

		function showExitConfirmModal(callbackFn) {
			var exitUploadConfirmModal = $uibModal.open({
				size: 'small',
				templateUrl: 'app/components/upload-photo-exit-confirm/upload-photo-exit-confirm.html',
				controller: 'uploadPhotoExitConfirmCtrl',
				controllerAs: 'vm',
				openedClass: 'confirm-exit-popup'
			});
			return exitUploadConfirmModal;
		}

		function getuploadPortfolioPhotoSvc() {
			return mFiles;
		}

		function updateProgress(file, progress) {
			var updatingFile = _.find(mFiles.data, function (itFile) {
				return itFile.name === file.name;
			})
			if (updatingFile) {
				updatingFile.upload.progress = progress;
			}
		}

		function updateThumbnail(file, thumbnail) {
			var updatingFile = _.find(mFiles.data, function (itFile) {
				return itFile.name === file.name;
			})
			if (updatingFile) {
				updatingFile.thumbnail = thumbnail;
			}
		}

		function isFileDirty(file) {
			return (file.galleries && file.galleries.length > 0);
		}

		function updateFileInfo(updatingFile, fileInfo) {
			if (updatingFile) {
				updatingFile.key = fileInfo.key;
				updatingFile.username = fileInfo.username;
				updatingFile.inserted_at = fileInfo.inserted_at;
				updatingFile.title = fileInfo.name;
				updatingFile.handle = fileInfo.handle;
			}
		}

		function setThumbnail(files) {
			for (var i = 0; i < files.length; i++) {
				files[i].thumbnail = files.url;
			}
		}

		function removeFileFromSelectedFiles(fileName) {
			mSelectedFiles.data = _.reject(mSelectedFiles.data, function (file) {
				if (file.name === fileName) {
					file.isSelected = false;
					return true;
				}
			});
		}

		function getFileByName(pixerfFile) {
			return _.find(mFiles.data, function (f) {
				return f.name === pixerfFile.name;
			});
		}

		function removeUploadedFile(index) {

			removeFileFromSelectedFiles(mFiles.data[index].name);
			mFiles.data.splice(index, 1);
		}

		function removeFileByName(fileName) {
			removeFileFromSelectedFiles(fileName);
			mFiles.data = _.reject(mFiles.data, function (file) {
				return file.name === fileName;
			})
		}

		function replaceFileByName(fileName, newElement) {
			var index = arrayUtils.indexOf(mFiles.data, function (it) {
				return it.name === fileName;
			});
			mFiles.data[index] = newElement;

		}

		function setSelectedFiles(files, isSelected) {
			for (var i = 0; i < files.length; i++) {
				files[i].isSelected = isSelected;
			}
		}

		function isSameFile(fileOne, fileTwo) {
			return fileOne.name === fileTwo.name &&
				fileOne.size === fileTwo.size;

		}

		function isFileExisted(files, file, isInclusiveErrorFile) {
			var isExisted = _.find(files, function (f) {
				return isInclusiveErrorFile ? isSameFile(f, file) : !f.pixerfError && isSameFile(f, file);
			})
			return isExisted;
		}

		function addFile(file) {
			var isExisted = isFileExisted(mFiles.data, file, true);
			if (isExisted) {
				if (!isExisted.pixerfError) {
					return isExisted;
				} else {
					replaceFileByName(isExisted.name, file);
				}
			} else {
				mFiles.data.unshift(file);
			}
		}

		function getDuplicatedFiles(exisingFiles, willBeAddedFiles) {
			var arr = [];
			for (var i = 0; i < willBeAddedFiles.length; i++) {
				if (isFileExisted(exisingFiles, willBeAddedFiles[i])) {
					arr.push(willBeAddedFiles[i]);
				}
			}
			return arr;
		}

		function addFiles(files) {
			var errMsg;
			for (var i = 0; i < files.length; i++) {
				errMsg = addFile(files[i]);
			}
			return errMsg;
		}

		function selectAllFiles() {
			var selectedFiles = [];
			for (var i = 0; i < mFiles.data.length; i++) {
				var file = mFiles.data[i];
				if (file.upload.progress === 100) {
					file.isSelected = true;
					selectedFiles.push(file);
				}
			}
			mSelectedFiles.data = selectedFiles;
		}

		function deselectAllFiles() {
			for (var i = 0; i < mFiles.data.length; i++) {
				mFiles.data[i].isSelected = false;
			}
			mSelectedFiles.data = [];
		}

		function deSelectFile(file) {
			if (!file.isSelected) return;
			file.isSelected = false;
			mSelectedFiles.data = _.reject(mSelectedFiles.data, function (f) {
				return f.id === file.id;
			})
		}

		function selectFiles(files) {
			for (var i = 0; i < files.length; i++) {
				selectFile(file);
			}
		}

		function selectFile(file) {
			if (!file) return;
			if (file.isSelected) return;
			var isExisted = _.find(mSelectedFiles.data, function (itFile) {
				return itFile.name === file.name;
			})
			if (isExisted) return;
			file.isSelected = true;
			mSelectedFiles.data.push(file);
		}

		function toggleFileSelection(file, isSelected) {
			if (file.upload.progress !== 100) return;
			if (typeof isSelected === 'undefined') {
				isSelected = !file.isSelected;
			}
			if (isSelected) {
				selectFile(file);
			} else {
				deSelectFile(file);
			}
		}

		function onFileClicked(evt, file) {
			if (file.upload.progress !== 100) return;
			if (evt && evt.shiftKey) {
				return;
			} else if (evt && (evt.ctrlKey || evt.metaKey)) {
				toggleFileSelection(file);
			} else {
				for (var i = 0; i < mSelectedFiles.data.length; i++) {
					mSelectedFiles.data[i].isSelected = false;
				}
				file.isSelected = true;
				mSelectedFiles.data = [file];
			}
		}

		function buildSavedFilesData(files) {
			var arr = [];
			for (var i = 0; i < files.length; i++) {
				var file = files[i];
				file.type = 'portfolio';
				arr.push(fileUtils.buildSavedFileObject(file));
			}
			return arr;
		}

		function isValidFileType(file) {
			var fileExtension = fileUtils.getFileExtension(file.name);
			return fileExtension.toLowerCase() === "jpeg" || fileExtension.toLowerCase() === "jpg";
		}

		function isExceedMaxSize(file, maxSize) {
			return file.size > maxSize;
		}

		function isUnderMinSize(file, minSize) {
			return file.size < minSize;
		}

		function isExceedNumberOfUpload(filesWillBeUploaded, limit) {
			var validToUploadFiles = _.reject(mFiles.data, function (f) {
				return f.pixerfError;
			})
			return validToUploadFiles.length + filesWillBeUploaded.length > limit;
		}

		function isBelowMinResolution(file, minRes) {
			var resolution = file.width * file.height;
			return resolution < minRes;
		}

		function isAboveMaxResolution(file, maxRes) {
			var resolution = file.width * file.height;
			return resolution >= maxRes;
		}

		function publish(files) {
			var savedData = buildSavedFilesData(files);
			return pixerfApiMediaSvc.multipleUpdate({
				type: 'portfolio',
				'api_version': 'new'
			}, savedData);
		}

		function reset() {
			mFiles.data = [];
			mSelectedFiles.data = [];
		}

		return {
			setOverlay: setOverlay,
			isFullscreenDropzone: isFullscreenDropzone,
			dragPhotoEvent: dragPhotoEvent,
			getUploadModal: getUploadModal,
			showUploadModal: showUploadModal,
			showExitConfirmModal: showExitConfirmModal,
			getuploadPortfolioPhotoSvc: getuploadPortfolioPhotoSvc,
			updateProgress: updateProgress,
			updateThumbnail: updateThumbnail,
			removeUploadedFile: removeUploadedFile,
			removeFileByName: removeFileByName,
			addFile: addFile,
			addFiles: addFiles,
			isFileExisted: isFileExisted,
			onFileClicked: onFileClicked,
			selectFile: selectFile,
			selectFiles: selectFiles,
			toggleFileSelection: toggleFileSelection,
			selectAllFiles: selectAllFiles,
			getSelectedFiles: getSelectedFiles,
			publish: publish,
			updateFileInfo: updateFileInfo,
			reset: reset,
			setThumbnail: setThumbnail,
			isValidFileType: isValidFileType,
			isBelowMinResolution: isBelowMinResolution,
			isAboveMaxResolution: isAboveMaxResolution,
			isExceedMaxSize: isExceedMaxSize,
			isUnderMinSize: isUnderMinSize,
			deselectAllFiles: deselectAllFiles,
			deSelectFile: deSelectFile,
			getDuplicatedFiles: getDuplicatedFiles,
			isExceedNumberOfUpload: isExceedNumberOfUpload,
			runFakeProgress: runFakeProgress,
			getFileByName: getFileByName,
			isSameFile: isSameFile,

		};
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('uploadPortfolioPhotoCtrl', uploadPortfolioPhotoCtrl);

	uploadPortfolioPhotoCtrl.$inject = ['popupData', 'googleAnalyticSvc', '$uibModalStack', 'uploadPortfolioPhotoDetailSvc', '$scope', 'toastr', 'sessionManagerSvc', 'systemUtils', '$uibModalInstance', 'pixerfUrl', '$uibModal', 'uploadPortfolioPhotoSvc', '$location', '$state', '$timeout', 'filePickerSvc', 'fileUtils', 'pixerfConfirmPopupSvc', '$q', 'pixerfApiMediaSvc', 'imageUtils', 'portfolioConst', '$translate', 'translationSvc'];

	function uploadPortfolioPhotoCtrl(popupData, googleAnalyticSvc, $uibModalStack, uploadPortfolioPhotoDetailSvc, $scope, toastr, sessionManagerSvc, systemUtils, $uibModalInstance, pixerfUrl, $uibModal, uploadPortfolioPhotoSvc, $location, $state, $timeout, filePickerSvc, fileUtils, pixerfConfirmPopupSvc, $q, pixerfApiMediaSvc, imageUtils, portfolioConst, $translate, translationSvc) {

		var self = this;

		uploadPortfolioPhotoSvc.reset();
		self.loginUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.uploadedFiles = uploadPortfolioPhotoSvc.getuploadPortfolioPhotoSvc();
		self.removeUploadedFile = uploadPortfolioPhotoSvc.removeUploadedFile;
		self.onFileClicked = uploadPortfolioPhotoSvc.onFileClicked;
		self.toggleFileSelection = uploadPortfolioPhotoSvc.toggleFileSelection;
		self.selectAllFiles = uploadPortfolioPhotoSvc.selectAllFiles;
		self.selectedFiles = uploadPortfolioPhotoSvc.getSelectedFiles();
		self.onPublishBtnClicked = onPublishBtnClicked;
		self.reset = reset;
		self.closeUploadModal = closeUploadModal;
		self.uploadModal = uploadPortfolioPhotoSvc.getUploadModal();
		self.isFullscreenDropzone = uploadPortfolioPhotoSvc.isFullscreenDropzone;
		self.showFilePickerPopup = showFilePickerPopup;
		self.selection = {};
		self.pixerfAlert = {};
		self.removeSelectedPhotos = removeSelectedPhotos;
		self.rotatePhoto = rotatePhoto;
		self.publishing = false;
		self.dragCounter = 0;
		self.numProcessingFile = 0;
		self.updateMasterFile = updateMasterFile;
		self.navigateTo = navigateTo;
		self.errors = [];
		self.maxPhotoPerGallery = portfolioConst.MAX_PHOTO_GALLERY;
		self.maxFileRes = portfolioConst.UPLOAD_PHOTO_VALIDATION.PHOTO_SIZE.MAX_FILE_SIZE;
		self.minFileRes = portfolioConst.UPLOAD_PHOTO_VALIDATION.PHOTO_SIZE.MIN_RESOLUTION;
		self.portfolioId = popupData.portfolioId;
		self.isCancelUpload = false;
		var errorHandlerFn = _.debounce(errorHandler, 1000);

		function beforeUnloadHandler(event) {
			if (self.uploadedFiles.data.length > 0) {
				var confirmationMessage = $translate.instant("are-you-sure");
				event.returnValue = confirmationMessage; // Gecko, Trident, Chrome 34+
				return confirmationMessage;
			}
		}
		window.addEventListener("beforeunload", beforeUnloadHandler);
		var mFileStackSocaialHandler = {
			onSuccess: function (responsedFiles) {
				var promises = [];
				if (!Array.isArray(responsedFiles)) {
					responsedFiles = [responsedFiles];
				}
				uploadPortfolioPhotoSvc.deselectAllFiles();
				var pixerfBlobs = fileUtils.createPixerfBlob(responsedFiles.length);
				convertToPixerfFiles(pixerfBlobs, responsedFiles);
				for (var i = 0; i < pixerfBlobs.length; i++) {
					(function (index) {
						var pixerfFile = pixerfBlobs[index];
						var filestackFile = responsedFiles[index];
						var error = validateBeforeUploading(pixerfFile);
						if (error) {
							var def = $q.defer();
							setErrors(error);
							def.resolve();
							promises.push(def.promise);
						} else {
							var def2 = $q.defer();
							self.numProcessingFile++;
							uploadPortfolioPhotoSvc.addFile(pixerfFile);
							uploadPortfolioPhotoSvc.runFakeProgress(pixerfFile);
							systemUtils.digest($scope);
							var uploader = pixerfApiMediaSvc.upload({
								"url": filestackFile.url,
								"type": "portfolio"
							});
							uploader.$promise.then(function (uploadResponse) {
								self.numProcessingFile--; //done
								//if uploading prgress is cancelled.
								var isRemoved = !uploadPortfolioPhotoSvc.getFileByName(pixerfFile);
								if (isRemoved) {
									def2.resolve();
									return;
								}
								pixerfFile.id = uploadResponse.id;
								pixerfFile.upload.progress = 100;
								uploadPortfolioPhotoSvc.selectFile(pixerfFile);
								systemUtils.digest($scope);
								def2.resolve();
							}, function (errorResponse) {
								self.numProcessingFile--;
								var pixerfBlob = _.find(self.uploadedFiles.data, function (f) {
									return f.name === pixerfFile.name;
								});
								pixerfBlob.upload.progress = 0;
								if (errorResponse.error && errorResponse.error === 'invalid_file_size') {
									setErrors({
										code: portfolioConst.UPLOAD_PHOTO_VALIDATION.ERROR_CODE.PORTFOLIO_INVALID_MAX_FILESIZE,
										file: pixerfBlob
									});
								} else if (errorResponse.error && errorResponse.error === 'media_under_size_limit') {
									setErrors({
										code: portfolioConst.UPLOAD_PHOTO_VALIDATION.ERROR_CODE.PORTFOLIO_INVALID_MIN_RESOLUTION,
										file: pixerfBlob
									});
								} else {
									setErrors({
										code: portfolioConst.UPLOAD_PHOTO_VALIDATION.ERROR_CODE.FAILED_TO_UPLOAD,
										file: pixerfBlob
									});
								}
								uploadErrorHandler(pixerfFile);
								def2.resolve();
								promises.push(def2.promise);
							});
						}
					})(i)
					systemUtils.digest($scope);
				}
				$q.all(promises).then(function () {
					errorHandlerFn(self.errors);
				})
			},
			onError: function (filesFailed) {
				for (var i = 0; i < filesFailed.length; i++) {
					setErrors({
						code: portfolioConst.UPLOAD_PHOTO_VALIDATION.ERROR_CODE.FAILED_TO_UPLOAD,
						file: filesFailed[i]
					});
				}
				errorHandlerFn(self.errors);
			}
		};
		self.dropzoneConfig = {
			'methods': {},
			'instance': {},
			'options': {
				url: pixerfUrl.full + 'api/media/store',
				dictDefaultMessage: '',
				autoProcessQueue: true,
				maxFiles: 100,
				paramName: 'media',
				parallelUploads: 10,
				previewsContainer: '.upload-photo__upload-area__dropzone__main-content__preview',
				method: "post",
				clickable: ".upload-photo__upload-area__dropzone__main-content__browse-btn",
				thumbnailWidth: 300,
				thumbnailHeight: 300,
				headers: {
					"Authorization": "Bearer " + sessionManagerSvc.getToken()
				},
				dictFileTooBig: "Size of this photo is {{filesize}} MB file. The maximum size is {{maxFilesize}} MB",
				createImageThumbnails: false
			},
			'eventHandlers': {
				sending: function (file, xhr, formData) {
					formData.append('title', file.name);
					formData.append('type', "portfolio");
				},

				thumbnail: function (file, dataUrl) {
					if (!file.pixerfError) {
						uploadPortfolioPhotoSvc.updateThumbnail(file, dataUrl);
						systemUtils.digest($scope);
					}
				},
				drop: function (file, errMsg) {
					self.isFullscreenDropzone.data = false;
					uploadPortfolioPhotoSvc.dragPhotoEvent.leave();
					systemUtils.digest($scope);
				},
				dragover: function () {
					self.dragCounter++;
					uploadPortfolioPhotoSvc.dragPhotoEvent.over();
					systemUtils.digest($scope);
				},
				addedfile: function (file) {
					imageUtils.customDropzoneThumbnail(file, this);
					var error = "";
					error = validateBeforeUploading(file);
					if (error) {
						setErrors(error);
						errorHandlerFn();
						this.removeFile(file);
					} else {
						self.numProcessingFile++;
						var pixerfBlob = fileUtils.convertFromFileObject2PixerfBlob(file);
						uploadPortfolioPhotoSvc.addFile(pixerfBlob);
					}
					systemUtils.digest($scope);
				},
				uploadprogress: function (file, progress) {
					var roundProgress = Math.round(progress);
					if (roundProgress === 100) return;
					uploadPortfolioPhotoSvc.updateProgress(file, roundProgress);
					systemUtils.digest($scope);
				},
				success: function (file, responsedFile) {
					self.numProcessingFile--; // done
					var pixerfBlob = _.find(self.uploadedFiles.data, function (f) {
						return f.name === file.name;
					});
					//if uploading prgress is cancelled.
					if (!pixerfBlob) {
						return;
					}
					pixerfBlob.upload.progress = 100;
					pixerfBlob.id = responsedFile.id;
					uploadPortfolioPhotoSvc.selectFile(pixerfBlob);
					systemUtils.digest($scope);
				},
				error: function (file, errorResponse) {
					self.numProcessingFile--;
					var pixerfBlob = _.find(self.uploadedFiles.data, function (f) {
						return f.name === file.name;
					});
					if (!pixerfBlob) pixerfBlob = file;
					if (errorResponse.error && errorResponse.error === 'invalid_file_size') {
						setErrors({
							code: portfolioConst.UPLOAD_PHOTO_VALIDATION.ERROR_CODE.PORTFOLIO_INVALID_MAX_FILESIZE,
							file: pixerfBlob
						});
					} else if (errorResponse && errorResponse.data && errorResponse.data.message === 'Image resolution is too low') {
						setErrors({
							code: portfolioConst.UPLOAD_PHOTO_VALIDATION.ERROR_CODE.PORTFOLIO_INVALID_MIN_RESOLUTION,
							file: pixerfBlob
						});
					} else if (errorResponse && errorResponse.data && errorResponse.data.message === 'Image resolution is too high') {
						setErrors({
							code: portfolioConst.UPLOAD_PHOTO_VALIDATION.ERROR_CODE.PORTFOLIO_INVALID_MAX_FILESIZE,
							file: pixerfBlob
						});
					} else {
						setErrors({
							code: portfolioConst.UPLOAD_PHOTO_VALIDATION.ERROR_CODE.FAILED_TO_UPLOAD,
							file: pixerfBlob
						});
					}
					pixerfBlob.upload.progress = 0;
					uploadErrorHandler(pixerfBlob);
					systemUtils.digest($scope);
				}
			}
		};
		self.dropzoneConfigSmall = $.extend(true, {}, self.dropzoneConfig);
		self.dropzoneConfigSmall.options.clickable = ".upload-photo-preview--add-more__dropzone__content__browse-btn--small";
		$scope.$on('modal.closing', closeConfirm);

		function updateMasterFile(file, property) {
			var selectedFile = self.selectedFiles.data[0];
			if (self.selectedFiles.data.length === 1 && self.masterFile && self.masterFile.name === selectedFile.name && file.name === selectedFile.name) {
				uploadPortfolioPhotoDetailSvc.updateMasterFile(self.masterFile, property, file[property]);
			}
		}

		function setErrors(error) {
			error.file.pixerfError = error.code;
			self.errors.push(error);
		}

		function validateBeforeUploading(validatedFile) {
			if (uploadPortfolioPhotoSvc.isExceedNumberOfUpload([validatedFile], portfolioConst.MAX_PHOTO_GALLERY)) {
				return {
					code: portfolioConst.UPLOAD_PHOTO_VALIDATION.ERROR_CODE.EXCEED_NUMBER_OF_UPLOAD_PER_TIMES,
					file: validatedFile
				};
			}
			if (!uploadPortfolioPhotoSvc.isValidFileType(validatedFile)) {
				return {
					code: portfolioConst.UPLOAD_PHOTO_VALIDATION.ERROR_CODE.INVALID_FILETYPE,
					file: validatedFile
				};
			}
			if (uploadPortfolioPhotoSvc.isFileExisted(self.uploadedFiles.data, validatedFile)) {
				return {
					code: portfolioConst.UPLOAD_PHOTO_VALIDATION.ERROR_CODE.DUPLICATED,
					file: validatedFile
				};
			}
		}

		function buildErrorFilename(files) {
			var errMsg = '';
			for (var i = 0; i < files.length; i++) {
				errMsg += ("<div class='upload-photo__invalid-file text--truncate'> - " + files[i].file.name + "</div>");
			}
			return errMsg;
		}

		function errorHandler(errors) {
			if (!errors) errors = self.errors;
			if (errors.length === 0) return;
			var errMsg = '';
			var callToActionMsg = '';
			var groupedError = _.groupBy(errors, function (item) {
				return item.code;
			});
			for (var key in groupedError) {
				callToActionMsg = '';
				if (key === portfolioConst.UPLOAD_PHOTO_VALIDATION.ERROR_CODE.DUPLICATED) {
					errMsg += "<p>" + $translate.instant("the-following-photos-uploaded-before") + "</p>";
					callToActionMsg += "<p class='upload-photo__validation-popup__call-to-action-msg'>" + $translate.instant("try-uploading-new-ones") + "!</p>";
				}
				if (key === portfolioConst.UPLOAD_PHOTO_VALIDATION.ERROR_CODE.INVALID_FILETYPE) {
					errMsg += "<p>" + $translate.instant("upload-photos-wrong-format") + "</p>";
					callToActionMsg += "<p class='upload-photo__validation-popup__call-to-action-msg'>" + $translate.instant("type-photo-allowed-upload", {
						type_1: 'JPG',
						type_2: 'JPEG'
					}) + "</p>";
				}
				if (key === portfolioConst.UPLOAD_PHOTO_VALIDATION.ERROR_CODE.PORTFOLIO_INVALID_MAX_FILESIZE) {
					errMsg += "<p>" + $translate.instant("upload-photos-too-large") + "</p>";
					callToActionMsg += ("<p class='upload-photo__validation-popup__call-to-action-msg'>" + $translate.instant("upload-files-smaller-than", {
						value: portfolioConst.UPLOAD_PHOTO_VALIDATION.PHOTO_SIZE.MAX_FILE_SIZE,
						unit: 'MB'
					}) + "</p>");
				}
				if (key === portfolioConst.UPLOAD_PHOTO_VALIDATION.ERROR_CODE.PORTFOLIO_INVALID_MIN_RESOLUTION) {
					errMsg += "<p>" + $translate.instant("upload-photos-too-small") + "</p>";
					callToActionMsg += ("<p class='upload-photo__validation-popup__call-to-action-msg'>" + $translate.instant("upload-files-larger-than", {
						value: portfolioConst.UPLOAD_PHOTO_VALIDATION.PHOTO_SIZE.MIN_RESOLUTION,
						unit: $translate.instant('megapixels')
					}) + "</p>");
				}
				if (key === portfolioConst.UPLOAD_PHOTO_VALIDATION.ERROR_CODE.EXCEED_NUMBER_OF_UPLOAD_PER_TIMES) {
					errMsg += "<p>" + $translate.instant("upload-photos-exceeded-limit-per-gallery", {
						number: portfolioConst.MAX_PHOTO_GALLERY
					}) + "</p>";
				}
				if (key === portfolioConst.UPLOAD_PHOTO_VALIDATION.ERROR_CODE.FAILED_TO_UPLOAD) {
					errMsg += "<p>" + $translate.instant("upload-photos-failed") + "</p>";
					callToActionMsg += ("<p class='upload-photo__validation-popup__call-to-action-msg'>" + $translate.instant("try-uploading-them-again") + "!</p>");
				}
				errMsg += buildErrorFilename(groupedError[key]);
				errMsg += callToActionMsg;
			}
			pixerfConfirmPopupSvc.showPopup({
				hideCancelBtn: true,
				hideConfirmText: true,
				hideTitle: true,
				message: errMsg,
				windowClass: 'upload-photo__validation-popup',
				okBtnText: 'OK'
			});
			self.errors = [];
		}

		function updateUserUploadBalance(numJustUploaded) {
			try {
				self.loginUser = sessionManagerSvc.getCurrentLoginUser().data;
				self.loginUser.stats.weekly_upload_balance -= numJustUploaded;
				sessionManagerSvc.setCurrentLoginUser(self.loginUser);
			} catch (ex) {}
		}

		function upload(files) {
			self.publishing = true;
			uploadPortfolioPhotoSvc.publish(files).$promise.then(function () {
				$timeout(function () {
					updateUserUploadBalance(files.length);
					self.publishing = false;
					$uibModalInstance.dismiss();
					$state.go("setting.manage-photos.pending-review");
				}, 2000);
			}, function (error) {
				self.publishing = false;
				var errorMsg = translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true);
				if (error.data && error.data.data && error.data.data.key === 'weekly_upload_limit_reached') {
					errorMsg = $translate.instant('you-have-limit-upload-this-time', {
						number: self.loginUser.stats.weekly_upload_balance
					});
					errorMsg += $translate.instant('please-remove-photo-from-upload');
				}
				toastr.error(errorMsg);
			})
		}

		function onPublishBtnClicked(files) {
			self.isFormDirty = true;
			var validToUploadFiles = _.reject(files, function (f) {
				return f.pixerfError;
			})
			if (validToUploadFiles.length === 0) {
				return;
			}
			var errorMsg = '';
			if (validToUploadFiles.length - self.loginUser.stats.weekly_upload_balance > 0) {
				errorMsg = $translate.instant('you-have-limit-upload-this-time', {
					number: self.loginUser.stats.weekly_upload_balance
				});
			}
			if (errorMsg) {
				errorMsg += $translate.instant('please-remove-photo-from-upload');
			}
			if (!errorMsg) {
				errorMsg = uploadPortfolioPhotoDetailSvc.validate(validToUploadFiles);
			}
			if (errorMsg) {
				toastr.error(errorMsg);
				return false;
			}

			upload(validToUploadFiles);
		}

		function closeConfirm(uploadPhotoClosingEvent, reason, closed) {
			if (reason && self.uploadedFiles.data.length > 0) {
				uploadPhotoClosingEvent.preventDefault();
				var exitUploadConfirmModal = uploadPortfolioPhotoSvc.showExitConfirmModal();
				exitUploadConfirmModal.result.then(function () {
					window.removeEventListener("beforeunload", beforeUnloadHandler);
					$uibModalStack.dismissAll();
				}, function () {
					window.removeEventListener("beforeunload", beforeUnloadHandler);
				});
			} else {
				if(self.isCancelUpload){
					deletePhotos(self.uploadedFiles.data);
				}
				window.removeEventListener("beforeunload", beforeUnloadHandler);
				self.uploadModal.data = null;
			}
		}

		function navigate(path) {
			uibModalInstance.dismiss("cancel")
		}

		function closeUploadModal() {
			self.isCancelUpload = true;
			$uibModalInstance.dismiss("cancel");
		}

		function deletePhotos(photos){
			if(photos && photos.length){
				for(var i = 0; i < photos.length; i++){
					pixerfApiMediaSvc.delete({id: photos[i].id});
				}
			}
		}

		function navigateTo(path) {
			var exitUploadConfirmModal = uploadPortfolioPhotoSvc.showExitConfirmModal();
			exitUploadConfirmModal.result.then(function () {
				window.removeEventListener("beforeunload", beforeUnloadHandler);
				$uibModalStack.dismissAll();
				$location.path(path);
			}, function () {
				window.removeEventListener("beforeunload", beforeUnloadHandler);
			});
		}

		function reset() {
			self.dropzoneConfig.instance.removeAllFiles();
			self.dropzoneConfigSmall.instance.removeAllFiles();
			uploadPortfolioPhotoSvc.reset();

		}

		function uploadErrorHandler(pixerfFileBlob) {
			errorHandlerFn();
			systemUtils.digest($scope);
		}

		function convertToPixerfFile(pixerfFileBlob, filestackBlob) {
			fileUtils.fromFilestackBlob2PixerfBlob(pixerfFileBlob, filestackBlob);
			pixerfFileBlob.title = fileUtils.getFileNameWithoutExtension(pixerfFileBlob.name);
		}

		function convertToPixerfFiles(pixerfFileBlobs, filestackBlobs) {
			var length = Math.min(pixerfFileBlobs.length, filestackBlobs.length);
			for (var i = 0; i < length; i++) {
				(function (index) {
					var pixerfFileBlob = pixerfFileBlobs[index];
					var filestackBlob = filestackBlobs[index];
					convertToPixerfFile(pixerfFileBlob, filestackBlob);
				})(i)
			}
		}

		function showFilePickerPopup(defaultService) {
			googleAnalyticSvc.trackPageView("Upload Photo - Social - " + defaultService);
			filePickerSvc.pickMultiple({
				callbacks: mFileStackSocaialHandler,
				defaultService: defaultService
			});
		}

		function removeSelectedPhotos(photos) {
			if (photos.length === self.uploadedFiles.data.length) {
				var modal = pixerfConfirmPopupSvc.showPopup({
					message: 'Hi, All photos will be removed.'
				});
				modal.result.then(function () {
					self.reset();
				});
			} else {

				for (var i = 0; i < photos.length; i++) {
					uploadPortfolioPhotoSvc.removeFileByName(photos[i].name);
				}
			}
		}

		function rotatePhoto(file) {
			if (!file.rotate_by) file.rotate_by = 0;
			file.rotate_by += 90;
			if (file.rotate_by === 360) {
				file.rotate_by = 0;
			}
		}

	}
})();

(function () {
  'use strict';

  angular
    .module('pixerf')
    .directive('uploadPhotoPreview', uploadPhotoPreview);

  function uploadPhotoPreview() {

    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/upload-photo-preview/upload-photo-preview.html',
      controllerAs: 'vm',
      replace: true
    };
    return directive;
  }

})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .directive('uploadPhotoPreviewSwapDimension', uploadPhotoPreviewSwapDimension);
    uploadPhotoPreviewSwapDimension.$inject = ['$parse', 'pathUtils'];

    function uploadPhotoPreviewSwapDimension($parse, pathUtils) {
        return function(scope, element, attrs) {
            scope.$watch(attrs.uploadPhotoPreviewSwapDimension, function (rotateDegrees) {
                var $element = $(element);
                var $overlay = $element.find(".upload-photo-preview__overlay");
                var width = $overlay.width();
                var height = $overlay.height();
                $overlay.width(height);
                $overlay.height(width);
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .directive('uploadPhotoPreviewScale', uploadPhotoPreviewScale);
    uploadPhotoPreviewScale.$inject = ['$parse', 'pathUtils'];

    function uploadPhotoPreviewScale($parse, pathUtils) {
        return function(scope, element, attrs) {
            var $element = $(element);
            var $img = $element.find("img");
            var $overlay = $element.find(".upload-photo-preview__overlay");

            $img.on('bestfit', function() {
                $overlay.width($img.width());
                $overlay.height($img.height());
            }).on('load', function() {
                $(this).trigger('bestfit');
            }).trigger('bestfit');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('uploadPhotoExitConfirmCtrl', uploadPhotoExitConfirmCtrl);

    uploadPhotoExitConfirmCtrl.$inject = ['$uibModalInstance'];

    function uploadPhotoExitConfirmCtrl($uibModalInstance) {

        var self = this;
        
        self.ok = function () {
            $uibModalInstance.close();
        };

        self.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
(function () {
	'use strict';
	angular
		.module('pixerf')
		.factory('uploadPhotoDetailSvc', uploadPhotoDetailSvc);

	uploadPhotoDetailSvc.$inject = ['addToGallerySvc', 'pixerfApiKeywordSvc', '$q', 'accountUtils', 'sessionManagerSvc', '$translate'];

	function uploadPhotoDetailSvc(addToGallerySvc, pixerfApiKeywordSvc, $q, accountUtils, sessionManagerSvc, $translate) {

		function isMultipleValue(files, property) {
			var firstFile = files[0];
			return !_.every(files, function (f) {
				return _.isEqual(firstFile[property], f[property]);
			})
		}

		function buildKeywords(keywords, max) {
			var firstNine = [];
			for (var i = 0; i < keywords.length; i++) {
				if (firstNine.length === max) return firstNine;
				var keyword = keywords[i];
				if (!_.contains(firstNine, keyword) && validateKeyword(keyword)) {
					firstNine.push(keyword);
				}
			}
			return firstNine;
		}

		function validateKeyword(keyword) {
			return keyword.length > 2;

		}

		function buildCallToActionMessages(file) {
			var messages = [];
			if (!file) return messages;
			var loginUser = sessionManagerSvc.getCurrentLoginUser().data;
			if (!loginUser) return messages;
			if (!loginUser.canCurate && !file.isMine) return messages;
			if (!file.price) {
				messages.push("- Please set a price before this photo can be featured in the Marketplace.");
			}

			if (!file.releases) file.releases = [];
			if (file.license === 'commercial' && file.has_model_property && file.releases.length === 0) {
				messages.push('<div>- Please upload photo release form(s) </div><get-release-form-btn class="pixerf-link--color-blue text--bold" text="You can download the forms here."></get-release-form-btn>');
			}
			return messages;
		}

		function loadTags(query) {
			var deferred = $q.defer();
			pixerfApiKeywordSvc.query({
				'word': query
			}, function (response) {
				var firstNine = buildKeywords(response, 10);
				deferred.resolve(firstNine);
			}, function (error) {
				deferred.reject(error);
			});
			return deferred.promise;
		}

		function validate(files) {
			for (var i = 0; i < files.length; i++) {
				var file = files[i];
				var photoName = "Photo " + (file.title ? file.title : file.name);
				if ((file.license === "commercial" && file.has_model_property == null) || !file.license) {
					return $translate.instant("photo-apply-commercial-license", {
						name: photoName
					});
				}
				if (!file.title) {
					return photoName + ": Please input the title of this photo!";
				}
				if (!file.categories || !file.categories.length) {
					return $translate.instant("photo-select-category", {
						name: photoName
					});
				}
				if (!file.price || (file.price && !file.price.id)) {
					return photoName + ": Please select the price of this photo!";
				}
				var valid = !(accountUtils.isContainsLink(file.description));
				if (!valid) return "Sorry, " + photoName + ": description cannot contain link or email.";
				valid = !accountUtils.isContainsFileExtension(file.title);
				if (!valid) return "Sorry, " + "Photo title cannot contain extension.";
			}
		}

		function isPriceSet(files) {
			for (var i = 0; i < files.length; i++) {
				var file = files[i];
				if (!file.price) return false;
			}
			return true;
		}

		function synchonizeSuggestedKeywords(action, $tag, files) {

			for (var i = 0; i < files.length; i++) {
				var file = files[i];
				if (!file.suggestedKeywords) file.suggestedKeywords = [];
				var isInSuggestedKeyword = _.find(file.originalSuggestedKeywords, function (t) {
					return t === $tag.text;
				});
				if (action === "add") {
					if (isInSuggestedKeyword) {
						file.suggestedKeywords = _.reject(file.suggestedKeywords, function (t) {
							return $tag.text && t === $tag.text;
						});
					}
				} else if (action === "remove") {
					var isExisted = _.find(file.suggestedKeywords, function (t) {
						return t === $tag.text;
					});

					if (!isExisted && isInSuggestedKeyword) file.suggestedKeywords.push($tag.text);
				}
			}
		}

		function synchonizeKeywords(action, $tag, files) {

			for (var i = 0; i < files.length; i++) {
				var file = files[i];
				if (!file.tags) file.tags = [];
				var isExisted = _.find(file.tags, function (t) {
					return t.text === $tag.text;
				});
				if (action === "add") {
					if (!isExisted) {
						file.tags.push($tag);
					}
				} else if (action === "remove") {
					file.tags = _.reject(file.tags, function (t) {
						return t.text === $tag.text;
					});
				}
			}
		}

		function synchonizedFilesInfo(files, property, value) {
			for (var i = 0; i < files.length; i++) {
				if (typeof value === 'object') {
					if (Array.isArray(value)) {
						files[i][property] = $.extend(true, [], value);
					} else {
						files[i][property] = $.extend(true, {}, value);
					}
				} else {
					files[i][property] = value;
				}
			}
		}

		function synchonizePrice(files, price) {
			for (var i = 0; i < files.length; i++) {
				var file = files[i];
				var isExisted = _.find(file.price_ranges, function (p) {
					return p.id === price.id;
				})
				if (isExisted) {
					file.price = isExisted;
				}
			}
		}

		function updateMasterFile(masterFile, property, value) {
			masterFile.data[property] = value;
		}

		function buildMasterFileKeywords(files) {
			var arrays = [];
			for (var i = 0; i < files.length; i++) {
				arrays.push(files[i].tags);
			}
			var buff = [];
			var i, all, shortest, nShortest, n, len, ret = [],
				obj = {},
				nOthers, isExisted;
			nOthers = arrays.length - 1;
			nShortest = arrays[0].length;
			shortest = 0;
			for (i = 0; i <= nOthers; i++) {
				n = arrays[i].length;
				if (n < nShortest) {
					shortest = i;
					nShortest = n;
				}
			}
			for (i = 0; i <= nOthers; i++) {
				n = (i === shortest) ? 0 : (i || shortest);
				len = arrays[n].length;
				for (var j = 0; j < len; j++) {
					var tag = arrays[n][j];
					tag.isSameKeyword = false;
					isExisted = _.find(buff, function (t) {
						return t.text === tag.text;
					})
					if (!isExisted) {
						buff.push(tag);
					}
					var elem = tag['text'];
					if (obj[elem] === i - 1) {
						if (i === nOthers) {
							ret.push(tag);
							isExisted = _.find(buff, function (t) {
								return t.text === tag.text;
							})
							if (isExisted) {
								isExisted.isSameKeyword = true;
							}
							obj[elem] = 0;
						} else {
							obj[elem] = i;
						}
					} else if (i === 0) {
						obj[elem] = 0;
					}
				}
			}
			return buff;
		}

		function resetKeyworkd(tags) {
			for (var i = 0; i < tags.length; i++) {
				tags[i].isSameKeyword = false;
			}
			return tags;
		}

		function buildMasterFileReleases(files) {
			var arr = _.reduce(files, function (memo, item) {
				if (item.releases && item.releases.length > 0) {
					memo = memo.concat(item.releases);
				}
				return memo;
			}, []);
			return _.uniq(arr, function (item) {
				return item.id;
			});
		}

		function buildMasterFileGalleries(files) {
			var arr = _.reduce(files, function (memo, item) {
				if (item.galleries && item.galleries.length > 0) {
					memo = memo.concat(item.galleries);
				}
				return memo;
			}, []);
			return _.uniq(arr, function (item) {
				return item.id;
			});
		}

		function buildPriceRanges(files) {
			var maxPriceRanges = files[0].price_ranges;
			for (var i = 1; i < files.length; i++) {
				var file = files[i];
				if (file.price_ranges[file.price_ranges.length - 1].value > maxPriceRanges[maxPriceRanges.length - 1].value) {
					maxPriceRanges = file.price_ranges;
				}
			}
			return maxPriceRanges;
		}

		function buildMasterFile(masterFile, files, synchronizable, categories) {

			var firstFile = files[0];
			if (!synchronizable) {
				masterFile.data = firstFile;
			} else {

				masterFile.data = {
					name: '',
					title: '',
					license: '',
					categories: [],
					description: '',
					location: '',
					galleries: [],
					tags: [],
					suggestedKeywords: [],
					originalSuggestedKeywords: [],
					price: null,
					releases: [],
					has_model_property: false,
					price_ranges: [],
					user: null
				};
			}
			if (!firstFile) {
				masterFile.data = null;
				return;
			}
			masterFile.data.name = firstFile.name;
			for (var property in masterFile.data) {
				if (property === "user") {
					masterFile.data.user = firstFile.user;
				} else if (property === "categories") {
					if (files.length > 1 && isMultipleValue(files, property)) {
						var multiple = {
							id: -1,
							name: 'Multiple categories'
						};
						if (categories.data[0].id !== -1) {
							categories.data.unshift(multiple);
						}
						masterFile.data.categories = [multiple];
					} else {
						masterFile.data.categories = firstFile.categories || [];
						if (categories.data[0].id === -1) {
							categories.data.shift(multiple);
						}
					}

				} else if (property === "tags") {
					firstFile.tags = firstFile.tags || [];
					masterFile.data.tags = files.length > 1 ? buildMasterFileKeywords(files) : resetKeyworkd(firstFile.tags);
				} else if (property === "releases") {
					if (!firstFile.releases) firstFile.releases = [];
					masterFile.data.releases = files.length > 1 && isMultipleValue(files, property) ? buildMasterFileReleases(files) : firstFile.releases;
				} else if (property === "suggestedKeywords") {
					masterFile.data.suggestedKeywords = files.length > 1 ? [] : (firstFile.suggestedKeywords || []);
				} else if (property === "originalSuggestedKeywords") {
					masterFile.data.originalSuggestedKeywords = files.length > 1 ? [] : (firstFile.originalSuggestedKeywords || []);
				} else if (property === "galleries") {
					masterFile.data.galleries = files.length > 1 && isMultipleValue(files, property) ? buildMasterFileGalleries(files) : firstFile.galleries;
					masterFile.data.galleriesName = addToGallerySvc.buildGalleriesNames(masterFile.data.galleries);
				} else if (property === "price_ranges") {
					masterFile.data.price_ranges = files.length > 1 ? buildPriceRanges(files) : firstFile.price_ranges;
				} else {
					if (Array.isArray(masterFile.data[property])) {
						masterFile.data[property] = files.length > 1 && isMultipleValue(files, property) ? 'Multiple ' + property + "s" : firstFile[property];
					} else if (typeof masterFile.data[property] === "object") {
						masterFile.data[property] = files.length > 1 && isMultipleValue(files, property) ? 'Multiple ' + property + "s" : firstFile[property] ? firstFile[property] : undefined;
					} else {
						masterFile.data[property] = files.length > 1 && isMultipleValue(files, property) ? 'Multiple ' + property + "s" : firstFile[property];
					}
				}
			}
		}
		return {
			synchonizedFilesInfo: synchonizedFilesInfo,
			loadTags: loadTags,
			synchonizeSuggestedKeywords: synchonizeSuggestedKeywords,
			validate: validate,
			isPriceSet: isPriceSet,
			buildMasterFile: buildMasterFile,
			updateMasterFile: updateMasterFile,
			buildCallToActionMessages: buildCallToActionMessages,
			synchonizeKeywords: synchonizeKeywords,
			synchonizePrice: synchonizePrice
		};
	}
})();

(function () {
    'use strict';

    angular
        .module('pixerf')
        .controller('uploadPhotoDetailCtrl', uploadPhotoDetailCtrl);

    uploadPhotoDetailCtrl.$inject = ['photoSvc', 'sessionManagerSvc', 'sendReleaseFormEmailPopupSvc', '$scope', 'uploadPhotoDetailSvc', '$q', 'toastr', '$timeout', 'addToGallerySvc', 'systemUtils'];

    function uploadPhotoDetailCtrl(photoSvc, sessionManagerSvc, sendReleaseFormEmailPopupSvc, scope, uploadPhotoDetailSvc, $q, toastr, $timeout, addToGallerySvc, systemUtils) {

        var self = this;
        self.onGallerySelected = onGallerySelected;
        self.synchonizedFilesInfo = synchonizedFilesInfo;
        self.synchonizePrice = synchonizePrice;
        self.loadTags = loadTags;
        self.addTag = addTag;
        self.onTagRemoved = onTagRemoved;
        self.onInvalidTag = onInvalidTag;
        self.loginUser = sessionManagerSvc.getCurrentLoginUser().data;
        self.onTagAdded = onTagAdded;
        self.masterFile = { data: null };
        self.onRequiredReleaseRadioBtnClicked = onRequiredReleaseRadioBtnClicked;
        self.onPhotoUsageItemClicked = onPhotoUsageItemClicked;
        self.onQuestionAnswered = onQuestionAnswered;
        self.getTagClass = getTagClass;
        self.callToActionMesages = [];
        self.categoryDropdownSettings = {
            displayProp: 'name',
            idProp: 'id',
            smartButtonMaxItems: 3,
            selectionLimit: 3,
            showCheckAll: false,
            showUncheckAll: false,
            scrollable: true,
            scrollableHeight: "275px",
            buttonClasses: 'multiple-dropdown-selection__btn-dropdown text--truncate text-left',
            events: {
                onSelectionChanged: function () {
                    var files = scope.files;
                    if (scope.categories.data[0] && scope.categories.data[0].id === -1) {
                        self.masterFile.data.categories.shift();
                        scope.categories.data.shift();
                    }
                    synchonizedFilesInfo(files, "categories", self.masterFile.data.categories);
                },
                onMaxSelectionReached: function () {
                    toastr.error("Please select up to a maximum of three categories only.");
                }
            }
        };

        GetMap();

        function GetMap() {
            Microsoft.Maps.loadModule('Microsoft.Maps.AutoSuggest', {
                callback: function () {
                    var manager = new Microsoft.Maps.AutosuggestManager({
                        placeSuggestions: false,
                        showBingLogo: false
                    });
                    manager.attachAutosuggest('#searchBox', '#searchBoxContainer', selectedSuggestion);
                },
                errorCallback: function(msg){
                    alert(msg);
                },
                credentials: 'Asn0tvgjR738cXuveLVKAO1ol02qvwCWFCS4dxJKISGijOYOqgAsu1PNXtxIqffp' 
            });
        }

        function selectedSuggestion(result) {
            document.getElementById('searchBox').value = result.address.locality || '';
            systemUtils.digest(scope);
            self.masterFile.data.location = result.address.locality;
            synchonizedFilesInfo(scope.files, 'location', self.masterFile.data.location);
        }

        function synchonizedFilesInfo() {
            if (scope.synchronizable) {
                uploadPhotoDetailSvc.synchonizedFilesInfo.apply(uploadPhotoDetailSvc, arguments);
            } else {//editphoto mode
                self.callToActionMesages = uploadPhotoDetailSvc.buildCallToActionMessages(self.masterFile.data);
            }
            scope.formError = uploadPhotoDetailSvc.validate(scope.files);
        }
        scope.$watchCollection("files", function (newFiles, oldValue) {
            uploadPhotoDetailSvc.buildMasterFile(self.masterFile, newFiles, scope.synchronizable, scope.categories);
            self.callToActionMesages = uploadPhotoDetailSvc.buildCallToActionMessages(self.masterFile.data);
        });
        function getTagClass($tag) {
            return $tag.isSameKeyword ? 'tag-item--bolder' : '';
        }
        function onTagAdded($tag) {
            var files = scope.files;
            $tag.isSameKeyword = files.length > 1;
            $timeout(function () {
                var isInSuggestedKeyword = _.find(self.masterFile.data.originalSuggestedKeywords, function (t) {
                    return t === $tag.text;
                });
                if (isInSuggestedKeyword) {
                    self.masterFile.data.suggestedKeywords = _.reject(self.masterFile.data.suggestedKeywords, function (t) {
                        return t === $tag.text;
                    });
                }
                if (scope.synchronizable) {
                    uploadPhotoDetailSvc.synchonizeKeywords("add", $tag, files);
                    uploadPhotoDetailSvc.synchonizeSuggestedKeywords("add", $tag, files);
                }
            }, 300);
        }
        function onInvalidTag($tag, tiScope) {
            var files = scope.files;
            var isExisted = _.find(self.masterFile.data.tags, function (t) {
                return t.text === $tag.text;
            });
            if (isExisted && !isExisted.isSameKeyword && files.length > 1) {
                isExisted.isSameKeyword = true;
                tiScope.newTag.text('');
            }
            if (scope.synchronizable) {
                uploadPhotoDetailSvc.synchonizeKeywords("add", $tag, files);
                uploadPhotoDetailSvc.synchonizeSuggestedKeywords("add", $tag, files);
            }
        }
        function onTagRemoved($tag) {
            var files = scope.files;
            var isExisted = _.find(self.masterFile.data.suggestedKeywords, function (t) {
                return t === $tag.text;
            });
            var isInSuggestedKeyword = _.find(self.masterFile.data.originalSuggestedKeywords, function (t) {
                return t === $tag.text;
            });
            if (!isExisted && isInSuggestedKeyword) self.masterFile.data.suggestedKeywords.push($tag.text);
            if (scope.synchronizable) {
                uploadPhotoDetailSvc.synchonizeKeywords("remove", $tag, files);
                uploadPhotoDetailSvc.synchonizeSuggestedKeywords("remove", $tag, files);
            }
        }
        function addTag(tags, tagText) {
            var files = scope.files;
            if (!tags) tags = [];
            var isExisted = _.find(tags, function (t) {
                return t.text === tagText;
            })
            if (!isExisted) {
                tags.push({ text: tagText });
                onTagAdded({ text: tagText });
            }

        }
        function loadTags(query) {
            var files = scope.files;
            var deferred = $q.defer();
            uploadPhotoDetailSvc.loadTags(query).then(function (tags) {
                deferred.resolve(tags);
                // self.masterFile.data.suggestedKeywords = tags;
            }, function (error) {
                deferred.reject(error);
                toastr.error("Failed to get tags.");
            })
            return deferred.promise;
        }
        function onGallerySelected(gallery) {
            photoSvc.updateFileGalleriesInfo(self.masterFile.data, gallery);
            self.masterFile.data.galleriesName = addToGallerySvc.buildGalleriesNames(self.masterFile.data.galleries);
        }
        function showSendReleaseFormPopup() {
            sendReleaseFormEmailPopupSvc.showPopup();
        }
        function onPhotoUsageItemClicked(usage) {
            self.masterFile.data.license = usage;
            self.masterFile.data.has_model_property = null;
            self.masterFile.data.releases = [];
        }
        function onRequiredReleaseRadioBtnClicked() {
            self.synchonizedFilesInfo(scope.files, 'has_model_property', self.masterFile.data.has_model_property)
            if (self.masterFile.data.has_model_property) {
                showSendReleaseFormPopup();
            } else {
                self.masterFile.data.releases = [];
            }

        }
        function synchonizePrice() {
            uploadPhotoDetailSvc.synchonizePrice.apply(null, arguments);
        }
        function onQuestionAnswered(question) {
            if (question === 'COMMERCIAL?') {
                self.onPhotoUsageItemClicked('commercial');
                self.synchonizedFilesInfo(scope.files, 'license', 'commercial');
            } else if (question === 'NO_NEED_RELEASE?' || question === 'NEED_RELEASE_FORM?') {
                self.onRequiredReleaseRadioBtnClicked();
            }
            else if (question === 'NOT_COMMERCIAL?') {
                self.onPhotoUsageItemClicked('editorial');
                self.synchonizedFilesInfo(scope.files, 'license', 'editorial')
            }
        }
    }
})();

(function () {
  'use strict';

  angular
    .module('pixerf')
    .directive('uploadPhotoDetail', uploadPhotoDetail);

  function uploadPhotoDetail() {

    var directive = {
      scope: {
          files: "=",
          categories : '=',
          synchronizable: '=',
          formError: "=",
          isFormDirty: "=",
          alert: "=",
          isLoadingClarifai: '='
      },
      restrict: 'E',
      templateUrl: 'app/components/upload-photo-detail/upload-photo-detail.html',
      controller: 'uploadPhotoDetailCtrl',
      controllerAs: 'vm',
      replace: true
    };
    return directive;
  }

})();

(function(){
  'use strict';
  angular
    .module('pixerf')
    .factory('uploadPhotoSvc', uploadPhotoSvc);
    uploadPhotoSvc.$inject = ['toastr', 'pixerfApiMissionSvc', 'arrayUtils','numberUtils', '$window', '$q','resendVerificationEmailPopupSvc','editProfileSvc','agreementPopupSvc','sessionManagerSvc','googleAnalyticSvc', 'pixerfApiMediaSvc', 'pixerfApiCategorySvc', 'verifiedBusinessUserPopupSvc', 'fileUtils', '$uibModal', 'translationSvc'];

    function uploadPhotoSvc(toastr, pixerfApiMissionSvc, arrayUtils, numberUtils, $window, $q, resendVerificationEmailPopupSvc, editProfileSvc, agreementPopupSvc, sessionManagerSvc, googleAnalyticSvc, pixerfApiMediaSvc, pixerfApiCategorySvc, verifiedBusinessUserPopupSvc, fileUtils, $uibModal, translationSvc){

        var mFiles = {
            data: []
        };
        var mAddedBufferFiles = {
            data: []
        };
        var mSelectedFiles = {
            data: []
        };
        var mCategories = {data: []};

        var isFullscreenDropzone = {
            data: false
        };

        var mOverlay = {
            data: false
        };
        var mUploadModal = {data: null};

        var dragPhotoEvent = {

            over: function(overlay){
                //mOverlay.data = overlay;
                if(!mUploadModal.data) return;
                //setOverlay(true)
                isFullscreenDropzone.data = true;
            },
            leave: function(overlay){
                isFullscreenDropzone.data = false;
                //setOverlay(false);
            }
        };
        function setOverlay(status){
            mOverlay.data.visible = status;
        }
        function getUploadModal(){
            return mUploadModal;
        }

        function getCategories(){
            pixerfApiCategorySvc.get(function(response){
                mCategories.data = response;
            }, function(){

            });
        }
        function getSelectedFiles(){
            return mSelectedFiles;
        }
        function showPopup(data){

            googleAnalyticSvc.trackPageView("Upload Photo");
            mUploadModal.data = $uibModal.open({
                size: 'full',
                templateUrl: 'app/components/upload-photo/upload-photo.html',
                controller: 'uploadPhotoCtrl',
                controllerAs: 'vm',
                openedClass: 'upload-photo-modal',
                resolve: {
                    popupData: function(){
                        var def = $q.defer();
                        if(data && data.mission){
                            pixerfApiMissionSvc.get_participations({id: data.mission.id, type: 'self'}).$promise.then(function(response){
                                data.mission.submittedPhotos = response.data;
                                def.resolve(data);
                            }, function(){
                                def.reject(data);
                                toastr.error("Failed to get your submitted entries! Please try again!");
                            });
                        } else{
                            def.resolve(data);
                        }
                        return def.promise;
                    }
                }
            });

            mUploadModal.data.result.then(function() {}, function() {
            });
        }
        function runFakeProgress(file){

            file.fakeProgressInterval = $window.setInterval(function(){
                if(file.upload.progress >= 99){
                    $window.clearInterval(file.fakeProgressInterval);
                    delete file.fakeProgressInterval;
                    return;
                }
                var leftleft  = 99 - file.upload.progress;
                var step = numberUtils.getRandomInRange(1, leftleft);
                var progress = step + file.upload.progress;
                updateProgress(file, progress);
            }, 1000);

        }
        function showUploadModal(data) {
            var loginUser = sessionManagerSvc.getCurrentLoginUser().data;
            if(loginUser.is_email_verified){
                if(!loginUser.is_contributor_agreement_accepted){
                    var modal = agreementPopupSvc.showPopup({
                        message: 'i-agree-contributor-agreement',
                        okFn: function(isAgree, isWorking){
                            var def = $q.defer();
                            loginUser = sessionManagerSvc.getCurrentLoginUser().data;
                            loginUser.is_contributor_agreement_accepted = true;
                            sessionManagerSvc.setCurrentLoginUser(loginUser);
                            editProfileSvc.updateUser(loginUser).then(function(){
                                modal.close();
                                def.resolve(showPopup(data));
                            }, function(){
                                toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
                                def.reject();
                            });
                            return def.promise;
                        }
                    })
                } else {
                    showPopup(data);
                }
            } else {
                if(loginUser.isBiz){
                    verifiedBusinessUserPopupSvc.showPopup();
                } else {
                    resendVerificationEmailPopupSvc.showVerifyEmailPopup();
                }
            }

        }
        function showGoogleMapPicker(){
            $("#location-picker").locationpicker({
                location: {
                        latitude: 46.15242437752303,
                        longitude: 2.7470703125
                },
                inputBinding: {
                    locationNameInput: $('#location-input')
                },
                radius: 300,
                enableAutocomplete: true,
                autocompleteOptions: {

                }
            })
        }
        function showExitConfirmModal(callbackFn){
            var exitUploadConfirmModal = $uibModal.open({
              size: 'small',
              templateUrl: 'app/components/upload-photo-exit-confirm/upload-photo-exit-confirm.html',
              controller: 'uploadPhotoExitConfirmCtrl',
              controllerAs: 'vm',
              openedClass: 'confirm-exit-popup'
            });
            return exitUploadConfirmModal;
        }
        function getUploadPhotoSvc(){
            return mFiles;
        }
        function updateProgress(file, progress){
            var updatingFile = _.find(mFiles.data, function(itFile){
                return itFile.name === file.name;
            })
            if(updatingFile){
                updatingFile.upload.progress = progress;
            }
        }
        function updateThumbnail(file, thumbnail){
            var updatingFile = _.find(mFiles.data, function(itFile){
                return itFile.name === file.name;
            })
            if(updatingFile){
                updatingFile.thumbnail = thumbnail;
            }
        }
        function isFileDirty(file){
            return file.license ||
                file.location ||
                file.description ||
                (file.categories && file.categories.length > 0) ||
                (file.tags &&
                file.tags.length > 0) ||
                (file.galleries &&
                file.galleries.length > 0);
        }
        function updateFileInfo(updatingFile, fileInfo){
            if(updatingFile){
                updatingFile.key = fileInfo.key;
                updatingFile.username = fileInfo.username;
                updatingFile.inserted_at = fileInfo.inserted_at;
                updatingFile.title = fileInfo.name;
                updatingFile.handle = fileInfo.handle;
                updatingFile.license = fileInfo.license;
            }
        }
         function setThumbnail(files){
            for (var i = 0; i < files.length; i ++){
                files[i].thumbnail = files.url;
            }
        }
        function removeFileFromSelectedFiles(fileName){
            mSelectedFiles.data = _.reject(mSelectedFiles.data, function(file){
                if(file.name === fileName){
                    file.isSelected = false;
                    return true;
                }
            });
        }
        function getFileByName(pixerfFile){
            return _.find(mFiles.data, function(f){
                return f.name === pixerfFile.name;
            });
        }
        function removeUploadedFile(index){
            deletePhoto(mFiles.data[index]);
            removeFileFromSelectedFiles(mFiles.data[index].name);
            mFiles.data.splice(index, 1);
        }
        function deletePhoto(photo){
			pixerfApiMediaSvc.delete({id: photo.id});
		}
        function removeFileByName(fileName){
            removeFileFromSelectedFiles(fileName);
            mFiles.data = _.reject(mFiles.data, function(file){
                return file.name === fileName;
            })
        }
        function replaceFileByName(fileName, newElement){
            var index = arrayUtils.indexOf(mFiles.data, function(it){
                return it.name === fileName;
            });
            mFiles.data[index] = newElement;

        }
        function setSelectedFiles(files, isSelected){
            for (var i = 0; i < files.length; i ++){
                files[i].isSelected = isSelected;
            }
        }
        function isSameFile(fileOne, fileTwo){
            return fileOne.name === fileTwo.name &&
                fileOne.size === fileTwo.size ;

        }
        function isFileExisted(files, file, isInclusiveErrorFile){
            var isExisted = _.find(files, function(f){
                return isInclusiveErrorFile ? isSameFile(f, file) : !f.pixerfError && isSameFile(f, file) ;
            })
            return isExisted;
        }
        function isPriceSet(files){
            var isExisted = _.find(files, function(f){
                return f.price && f.price.id ;
            })
            return isExisted;
        }
        function addFile(file){
            var isExisted = isFileExisted(mFiles.data, file, true);
            if(isExisted) {
                if(!isExisted.pixerfError){
                    return isExisted;
                } else {
                    replaceFileByName(isExisted.name, file);
                }
            } else {
                mFiles.data.unshift(file);
            }
        }
        function getDuplicatedFiles(exisingFiles, willBeAddedFiles){
            var arr = [];
            for (var i = 0; i < willBeAddedFiles.length; i ++){
                if(isFileExisted(exisingFiles, willBeAddedFiles[i])){
                    arr.push(willBeAddedFiles[i]);
                }
            }
            return arr;
        }
        function addFiles(files){
            var errMsg;
            for (var i = 0; i < files.length; i ++){
                errMsg = addFile(files[i]);
            }
            return errMsg;
        }
        function selectAllFiles(){
            var selectedFiles = [];
            for (var i = 0; i < mFiles.data.length; i ++){
                var file = mFiles.data[i];
                if(file.upload.progress === 100){
                    file.isSelected = true;
                    selectedFiles.push(file);
                }
            }
            mSelectedFiles.data = selectedFiles;
        }
        function deselectAllFiles(){
            for (var i = 0; i < mFiles.data.length; i ++){
                mFiles.data[i].isSelected = false;
            }
            mSelectedFiles.data = [];
        }
        function deSelectFile(file){
            if(!file.isSelected) return;
            file.isSelected = false;
            mSelectedFiles.data = _.reject(mSelectedFiles.data, function(f){
                return f.id === file.id;
            })
        }
        function selectFiles(files){
            for (var i = 0; i < files.length; i ++){
                selectFile(file);
            }
        }
        function selectFile(file){
            if(!file) return;
            if(file.isSelected) return;
            var isExisted = _.find(mSelectedFiles.data, function(itFile){
                return itFile.name === file.name;
            })
            if(isExisted) return;
            file.isSelected = true;
            mSelectedFiles.data.push(file);
        }
        function toggleFileSelection(file, isSelected){
            if(file.upload.progress !== 100) return;
            if(typeof isSelected === 'undefined'){
                isSelected = !file.isSelected;
            }
            if(isSelected){
                selectFile(file);
            } else {
                deSelectFile(file);
            }
        }
        function onFileClicked(evt, file){
            if(file.upload.progress !== 100) return;
            if(evt && evt.shiftKey){
                return;
            } else if(evt && (evt.ctrlKey || evt.metaKey)){
                toggleFileSelection(file);
            } else{
                for (var i = 0; i < mSelectedFiles.data.length; i ++){
                    mSelectedFiles.data[i].isSelected = false;
                }
                file.isSelected = true;
                mSelectedFiles.data = [file];
            }
        }
        function buildSavedFilesData(files){
            var arr = [];
            for (var i = 0; i < files.length; i ++){
                var file = files[i];
                arr.push(fileUtils.buildSavedFileObject(file));
            }
            return arr;
        }
        function buildSavedMissionData(photos, missionId) {
			var participations = _.reduce(photos, function (memo, item) {
				memo.push({
					media_id: item.id,
					mission_id: missionId
				});
				return memo;
			}, []);
			return {
				"participations": participations
			};
		}
        function isValidFileType (file){
            var fileExtension = fileUtils.getFileExtension(file.name);
            return fileExtension.toLowerCase() === "jpeg" || fileExtension.toLowerCase() === "jpg";
        }
        function isValidFileThreeType (file){
            var fileExtension = fileUtils.getFileExtension(file.name);
            return fileExtension.toLowerCase() === "jpeg" || fileExtension.toLowerCase() === "jpg" || fileExtension.toLowerCase() === "tiff" || fileExtension.toLowerCase() === "tif";
        }
        function isExceedMaxSize(file, maxSize){
            return file.size > maxSize;
        }
        function isExceedNumberOfUpload(filesWillBeUploaded, limit){
            var validToUploadFiles = _.reject(mFiles.data, function(f){
                return f.pixerfError;
            })
            return validToUploadFiles.length + filesWillBeUploaded.length > limit;
        }
        function isBelowMinResolution(file, minRes){
            var resolution = file.width * file.height;
            return resolution < minRes;
        }
        function isAboveMaxResolution(file, maxRes){
            var resolution = file.width * file.height;
            return resolution >= maxRes;
        }
        function publish(files, mission){
            var savedData = buildSavedFilesData(files);
            if(mission) {
                var savedData = buildSavedMissionData(files);
                if(mission.is_ioa){
                    for(var i = 0; i < savedData.length; i++){
                        savedData[i].ioa_subscriber_type = mission.ioaSubscriber.ioa_subscriber_type;
                        savedData[i].ioa_submission_type = mission.ioaSubscriber.ioa_submission_type,
                        savedData[i].ioa_subscriber_email = mission.ioaSubscriber.ioa_subscriber_email;
                    }
                }
                return pixerfApiMissionSvc.submit_participations({id : mission.id},savedData);
            }
            return pixerfApiMediaSvc.multipleUpdate({'api_version': 'new'}, savedData);
        }

        function reset(){

            mFiles.data = [];
            mSelectedFiles.data = [];
        }
		return {
            setOverlay: setOverlay,
            isFullscreenDropzone: isFullscreenDropzone,
            dragPhotoEvent: dragPhotoEvent,
            getUploadModal: getUploadModal,
            showUploadModal: showUploadModal,
            showGoogleMapPicker: showGoogleMapPicker,
            showExitConfirmModal: showExitConfirmModal,
            getUploadPhotoSvc: getUploadPhotoSvc,
            updateProgress: updateProgress,
            updateThumbnail: updateThumbnail,
            removeUploadedFile: removeUploadedFile,
            removeFileByName: removeFileByName,
            addFile: addFile,
            addFiles: addFiles,
            isFileExisted: isFileExisted,
            onFileClicked: onFileClicked,
            selectFile: selectFile,
            selectFiles: selectFiles,
            toggleFileSelection: toggleFileSelection,
            selectAllFiles: selectAllFiles,
            getSelectedFiles: getSelectedFiles,
            publish: publish,
            getCategories: getCategories,
            categories: mCategories,
            updateFileInfo: updateFileInfo,
            reset: reset,
            setThumbnail: setThumbnail,
            isValidFileType: isValidFileType,
            isValidFileThreeType: isValidFileThreeType,
            isBelowMinResolution: isBelowMinResolution,
            isAboveMaxResolution: isAboveMaxResolution,
            isExceedMaxSize: isExceedMaxSize,
            deselectAllFiles: deselectAllFiles,
            deSelectFile: deSelectFile,
            getDuplicatedFiles: getDuplicatedFiles,
            isExceedNumberOfUpload: isExceedNumberOfUpload,
            runFakeProgress: runFakeProgress,
            getFileByName: getFileByName,
            isSameFile: isSameFile,
            isPriceSet: isPriceSet

		};
    }
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('uploadPhotoCtrl', uploadPhotoCtrl);

	uploadPhotoCtrl.$inject = ['popupData', 'googleAnalyticSvc', 'fileConst', '$uibModalStack', 'uploadPhotoDetailSvc', '$scope', 'toastr', 'sessionManagerSvc', 'systemUtils', '$uibModalInstance', 'pixerfUrl', 'pixerfApiClarifaiSvc', 'uploadPhotoSvc', '$location', '$state', '$timeout', 'filePickerSvc', 'fileUtils', 'pixerfConfirmPopupSvc', '$q', 'pixerfApiMediaSvc', 'tagUtils', 'imageUtils', 'priceUtils', '$translate', 'commonConst', 'translationSvc', 'translationConst', '$rootScope'];

	function uploadPhotoCtrl(popupData, googleAnalyticSvc, fileConst, $uibModalStack, uploadPhotoDetailSvc, $scope, toastr, sessionManagerSvc, systemUtils, $uibModalInstance, pixerfUrl, pixerfApiClarifaiSvc, uploadPhotoSvc, $location, $state, $timeout, filePickerSvc, fileUtils, pixerfConfirmPopupSvc, $q, pixerfApiMediaSvc, tagUtils, imageUtils, priceUtils, $translate, commonConst, translationSvc, translationConst, $rootScope) {

		var self = this;

		uploadPhotoSvc.reset();
		self.mission = popupData ? popupData.mission : null;
		self.isHideFooter = popupData ? popupData.isHideFooter : false;
		self.noMorePhotos = popupData ? popupData.noMorePhotos : false;
		self.manualProcess = popupData ? popupData.manualProcess : false;
		self.loginUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.uploadedFiles = uploadPhotoSvc.getUploadPhotoSvc();
		self.removeUploadedFile = uploadPhotoSvc.removeUploadedFile;
		self.onFileClicked = uploadPhotoSvc.onFileClicked;
		self.toggleFileSelection = uploadPhotoSvc.toggleFileSelection;
		self.selectAllFiles = uploadPhotoSvc.selectAllFiles;
		self.selectedFiles = uploadPhotoSvc.getSelectedFiles();
		self.onPublishBtnClicked = onPublishBtnClicked;
		self.categories = uploadPhotoSvc.categories;
		self.reset = reset;
		self.onAddLocationBtnClicked = uploadPhotoSvc.showGoogleMapPicker;
		self.closeUploadModal = closeUploadModal;
		self.uploadModal = uploadPhotoSvc.getUploadModal();
		self.isFullscreenDropzone = uploadPhotoSvc.isFullscreenDropzone;
		self.showFilePickerPopup = showFilePickerPopup;
		self.selection = {};
		self.pixerfAlert = {};
		self.removeSelectedPhotos = removeSelectedPhotos;
		self.rotatePhoto = rotatePhoto;
		self.publishing = false;
		self.dragCounter = 0;
		self.numProcessingFile = 0;
		self.updateMasterFile = updateMasterFile;
		self.navigateTo = navigateTo;
		self.isCancelUpload = false;
		self.errors = [];
		if (self.mission && self.mission.is_ioa) {
			self.footerText = 'You can submit up to a maximum of 10 entries across the Images of Asia Missions.';
		} else {
			self.footerText = $translate.instant('submit-this-mission', {
				number: self.mission && self.mission.user_participation_limit ? self.mission.user_participation_limit : fileConst.UPLOAD_PHOTO_VALIDATION.MISSION_LIMIT
			});
		}
		var errorHandlerFn = _.debounce(errorHandler, 1000);

		function beforeUnloadHandler(event) {
			if (self.uploadedFiles.data.length > 0) {
				var confirmationMessage = $translate.instant("are-you-sure");
				event.returnValue = confirmationMessage;
				return confirmationMessage;
			}
		}
		window.addEventListener("beforeunload", beforeUnloadHandler);
		var mFileStackSocaialHandler = {
			onSuccess: function (responsedFiles) {
				var promises = [];
				if (!Array.isArray(responsedFiles)) {
					responsedFiles = [responsedFiles];
				}
				uploadPhotoSvc.deselectAllFiles();
				var pixerfBlobs = fileUtils.createPixerfBlob(responsedFiles.length);
				convertToPixerfFiles(pixerfBlobs, responsedFiles);
				for (var i = 0; i < pixerfBlobs.length; i++) {
					(function (index) {
						var pixerfFile = pixerfBlobs[index];
						var filestackFile = responsedFiles[index];
						var error = validateBeforeUploading(pixerfFile);
						if (error) {
							var def = $q.defer();
							setErrors(error);
							def.resolve();
							promises.push(def.promise);
						} else {
							var def2 = $q.defer();
							self.numProcessingFile++;
							uploadPhotoSvc.addFile(pixerfFile);
							uploadPhotoSvc.runFakeProgress(pixerfFile);
							systemUtils.digest($scope);
							var uploader = self.mission ? pixerfApiMediaSvc.upload_to_mission({
								"mission_id": self.mission.id
							}, {
								"url": filestackFile.url
							}) : pixerfApiMediaSvc.upload({
								"url": filestackFile.url
							});
							uploader.$promise.then(function (uploadResponse) {
								var isRemoved = !uploadPhotoSvc.getFileByName(pixerfFile);
								if (isRemoved) {
									self.numProcessingFile--;
									def2.resolve();
									return;
								}
								if (uploadResponse.price_ranges) {
									var priceSet = uploadResponse.price_ranges.length > 1 ? priceUtils.createSkeletonPriceStructure(uploadResponse.price_ranges[0]) : uploadResponse.price_ranges[0];
									pixerfFile.price = priceSet;
								}
								pixerfFile.price_ranges = uploadResponse.price_ranges;
								pixerfFile.id = uploadResponse.id;
								pixerfFile.title = uploadResponse.title;
								pixerfFile.description = uploadResponse.description;
								pixerfFile.tags = tagUtils.stringsToTag(uploadResponse.tags || uploadResponse.clarifai);
								pixerfFile.originalSuggestedKeywords = uploadResponse.clarifai;
								// if (!uploadResponse.tags || (uploadResponse.tags && uploadResponse.tags.length === 0)) {
								pixerfApiClarifaiSvc.genKeywordsPhoto(pixerfFile.thumbnail, 'base64').then(function (response) {
									if (response.data && response.data.outputs[0] && response.data.outputs[0].data && response.data.outputs[0].data.concepts && response.data.outputs[0].data.concepts.length) {
										self.numProcessingFile--;
										pixerfFile.clarifai = _.map(response.data.outputs[0].data.concepts, function (result) { return result.name });
										pixerfFile.tags = tagUtils.stringsToTag(pixerfFile.clarifai);
										pixerfFile.originalSuggestedKeywords = pixerfFile.clarifai;
										uploadPhotoSvc.selectFile(pixerfFile);
										pixerfFile.upload.progress = 100;
										systemUtils.digest($scope);
									}
									def2.resolve();
								}).catch(function () {
									self.numProcessingFile--;
									uploadPhotoSvc.selectFile(pixerfFile);
									pixerfFile.upload.progress = 100;
									systemUtils.digest($scope);
									def2.resolve();
								})
								// } else {
								// 	self.numProcessingFile--; //done
								// 	uploadPhotoSvc.selectFile(pixerfFile);
								// 	pixerfFile.upload.progress = 100;
								// 	systemUtils.digest($scope);
								// 	def2.resolve();
								// }
							}, function (errorResponse) {
								self.numProcessingFile--;
								var pixerfBlob = _.find(self.uploadedFiles.data, function (f) {
									return f.name === pixerfFile.name;
								});
								pixerfBlob.upload.progress = 0;
								if (errorResponse.data && errorResponse.data.error) {
									setErrors({
										code: fileConst.UPLOAD_PHOTO_VALIDATION.ERROR_CODE.INVALID_MIN_RESOLUTION,
										file: pixerfBlob
									});
								} else {
									setErrors({
										code: fileConst.UPLOAD_PHOTO_VALIDATION.ERROR_CODE.FAILED_TO_UPLOAD,
										file: pixerfBlob
									});
								}
								uploadErrorHandler(pixerfFile);
								def2.resolve();
								promises.push(def2.promise);
							});
						}
					})(i)
					systemUtils.digest($scope);
				}
				$q.all(promises).then(function () {
					errorHandlerFn(self.errors);
				})
			},
			onError: function (filesFailed) {
				for (var i = 0; i < filesFailed.length; i++) {
					setErrors({
						code: fileConst.UPLOAD_PHOTO_VALIDATION.ERROR_CODE.FAILED_TO_UPLOAD,
						file: filesFailed[i]
					});
				}
				errorHandlerFn(self.errors);
				console.log(filesFailed);
			}
		};
		self.dropzoneConfig = {
			'methods': {},
			'instance': {},
			'options': {
				url: 'https://qa2.pixerf.com/api/v2/media/store',
				dictDefaultMessage: '',
				autoProcessQueue: true,
				maxFiles: self.noMorePhotos ? 1 : 500,
				maxThumbnailFilesize: fileConst.UPLOAD_PHOTO_VALIDATION.PHOTO_SIZE.MAX_FILE_SIZE,
				paramName: 'media',
				parallelUploads: 10,
				previewsContainer: '.upload-photo__upload-area__dropzone__main-content__preview',
				method: "post",
				clickable: ".upload-photo__upload-area__dropzone__main-content__browse-btn",
				thumbnailWidth: 300,
				thumbnailHeight: 300,
				headers: {
					"Authorization": "Bearer " + sessionManagerSvc.getToken()
				},
				dictFileTooBig: "Size of this photo is {{filesize}} MB file. The maximum size is {{maxFilesize}} MB",
				createImageThumbnails: false
			},
			'eventHandlers': {
				sending: function (file, xhr, formData) {
					if (self.mission && self.mission.is_ioa) {
						formData.append('ioa_subscriber_type', self.mission.ioaSubscriber.ioa_subscriber_type);
						formData.append('ioa_submission_type', self.mission.ioaSubscriber.ioa_submission_type);
						formData.append('ioa_subscriber_email', self.mission.ioaSubscriber.ioa_subscriber_email);
					}
					formData.append('title', file.name);
				},

				thumbnail: function (file, dataUrl) {

					if (!file.pixerfError) {
						uploadPhotoSvc.updateThumbnail(file, dataUrl);
						systemUtils.digest($scope);
					}
				},
				drop: function (file, errMsg) {
					self.isFullscreenDropzone.data = false;
					uploadPhotoSvc.dragPhotoEvent.leave();
					systemUtils.digest($scope);
				},
				dragover: function () {
					self.dragCounter++;
					uploadPhotoSvc.dragPhotoEvent.over();
					systemUtils.digest($scope);
				},
				addedfile: function (file) {
					imageUtils.customDropzoneThumbnail(file, this);
					var error = "";
					error = validateBeforeUploading(file);
					if (error) {
						setErrors(error);
						errorHandlerFn();
						this.removeFile(file);
					} else {
						self.numProcessingFile++;
						var pixerfBlob = fileUtils.convertFromFileObject2PixerfBlob(file);
						uploadPhotoSvc.addFile(pixerfBlob);
					}
					systemUtils.digest($scope);
				},
				uploadprogress: function (file, progress) {
					var roundProgress = Math.round(progress);
					if (roundProgress === 100) return;
					uploadPhotoSvc.updateProgress(file, roundProgress);
					systemUtils.digest($scope);
				},
				success: function (file, responsedFile) {
					var pixerfBlob = _.find(self.uploadedFiles.data, function (f) {
						return f.name === file.name;
					});
					//if uploading prgress is cancelled.
					if (!pixerfBlob) {
						self.numProcessingFile--; // done
						return;
					}

					if (responsedFile.price_ranges) {
						var priceSet = responsedFile.price_ranges.length > 1 ? priceUtils.createSkeletonPriceStructure(responsedFile.price_ranges[0]) : responsedFile.price_ranges[0];
						pixerfBlob.price = priceSet;
					}
					pixerfBlob.price_ranges = responsedFile.price_ranges;
					pixerfBlob.id = responsedFile.id;
					if (responsedFile.title) {
						pixerfBlob.title = responsedFile.title;
					}
					if (responsedFile.description) {
						pixerfBlob.description = responsedFile.description;
					}
					pixerfBlob.tags = tagUtils.stringsToTag(responsedFile.tags || responsedFile.clarifai);
					pixerfBlob.originalSuggestedKeywords = responsedFile.clarifai;
					// if (!responsedFile.tags || (responsedFile.tags && responsedFile.tags.length === 0)) {
					pixerfApiClarifaiSvc.genKeywordsPhoto(pixerfBlob.thumbnail, 'base64').then(function (response) {
						if (response.data && response.data.outputs[0] && response.data.outputs[0].data && response.data.outputs[0].data.concepts && response.data.outputs[0].data.concepts.length) {
							self.numProcessingFile--;
							pixerfBlob.clarifai = _.map(response.data.outputs[0].data.concepts, function (result) { return result.name });
							pixerfBlob.tags = tagUtils.stringsToTag(pixerfBlob.clarifai);
							pixerfBlob.originalSuggestedKeywords = pixerfBlob.clarifai;
							uploadPhotoSvc.selectFile(pixerfBlob);
							pixerfBlob.upload.progress = 100;
							systemUtils.digest($scope);
						}
					}).catch(function () {
						self.numProcessingFile--;
						uploadPhotoSvc.selectFile(pixerfBlob);
						pixerfBlob.upload.progress = 100;
						systemUtils.digest($scope);
					})
					// } else {
					// 	self.numProcessingFile--; // done
					// 	uploadPhotoSvc.selectFile(pixerfBlob);
					// 	pixerfBlob.upload.progress = 100;
					// 	systemUtils.digest($scope);
					// }
				},
				error: function (file, errorResponse) {
					self.numProcessingFile--;
					var pixerfBlob = _.find(self.uploadedFiles.data, function (f) {
						return f.name === file.name;
					});
					if (!pixerfBlob) pixerfBlob = file;
					if (errorResponse && errorResponse.data && errorResponse.data.message === 'Image resolution is too low') {
						toastr.error(errorResponse.data.message);
						setErrors({
							code: fileConst.UPLOAD_PHOTO_VALIDATION.ERROR_CODE.INVALID_MIN_RESOLUTION,
							file: pixerfBlob
						});
					} else if (errorResponse && errorResponse.data && errorResponse.data.key === 'participation_limit_exceeded') {
						toastr.error(errorResponse.data.message);
						setErrors({
							code: fileConst.UPLOAD_PHOTO_VALIDATION.ERROR_CODE.EXCEED_NUMBER_OF_UPLOAD_THIS_MISSION,
							file: pixerfBlob
						});
					} else {
						setErrors({
							code: fileConst.UPLOAD_PHOTO_VALIDATION.ERROR_CODE.FAILED_TO_UPLOAD,
							file: pixerfBlob
						});
					}
					pixerfBlob.upload.progress = 0;
					uploadErrorHandler(pixerfBlob);
					systemUtils.digest($scope);
				}
			}
		};
		self.dropzoneConfigSmall = $.extend(true, {}, self.dropzoneConfig);
		self.dropzoneConfigSmall.options.clickable = ".upload-photo-preview--add-more__dropzone__content__browse-btn--small";
		uploadPhotoSvc.getCategories();
		$scope.$on('modal.closing', closeConfirm);

		function updateMasterFile(file, property) {
			var selectedFile = self.selectedFiles.data[0];
			if (self.selectedFiles.data.length === 1 && masterFile && masterFile.name === selectedFile.name && file.name === selectedFile.name) {
				uploadPhotoDetailSvc.updateMasterFile(self.masterFile, property, file[property]);
			}
		}

		function setErrors(error) {
			error.file.pixerfError = error.code;
			self.errors.push(error);
		}

		function validateBeforeUploading(validatedFile) {
			if (!self.mission || !self.mission.is_ioa) {
				if (uploadPhotoSvc.isExceedNumberOfUpload([validatedFile], self.loginUser.stats.weekly_upload_balance)) {
					return {
						code: fileConst.UPLOAD_PHOTO_VALIDATION.ERROR_CODE.EXCEED_NUMBER_OF_UPLOAD_PER_WEEK,
						file: validatedFile
					};
				}
			}
			if (self.mission) {
				var limitSubmission = self.mission.user_participation_limit ? self.mission.user_participation_limit : fileConst.UPLOAD_PHOTO_VALIDATION.MISSION_LIMIT;
				var limit = self.mission.submittedPhotos ? limitSubmission - self.mission.submittedPhotos.length : 0;
				if (self.mission.is_ioa) {
					limit = self.mission.ioaSubscriber.free_balance ? self.mission.ioaSubscriber.free_balance : self.mission.ioaSubscriber.total_balance;
				} else if (self.mission.is_goJek) {
					limit = self.mission.submittedPhotos ? limitSubmission - self.mission.submittedPhotos.length : 0;
				}
				if (uploadPhotoSvc.isExceedNumberOfUpload([validatedFile], limit)) {
					return {
						code: fileConst.UPLOAD_PHOTO_VALIDATION.ERROR_CODE.EXCEED_NUMBER_OF_UPLOAD_THIS_MISSION,
						file: validatedFile
					};
				}
			}
			if (!uploadPhotoSvc.isValidFileType(validatedFile)) {
				return {
					code: fileConst.UPLOAD_PHOTO_VALIDATION.ERROR_CODE.INVALID_FILETYPE,
					file: validatedFile
				};
			}
			if (uploadPhotoSvc.isExceedMaxSize(validatedFile, fileConst.UPLOAD_PHOTO_VALIDATION.PHOTO_SIZE.MAX_FILE_SIZE * 1024 * 1024)) {
				return {
					code: fileConst.UPLOAD_PHOTO_VALIDATION.ERROR_CODE.INVALID_MAX_FILESIZE,
					file: validatedFile
				};
			}
			if (uploadPhotoSvc.isFileExisted(self.uploadedFiles.data, validatedFile)) {
				return {
					code: fileConst.UPLOAD_PHOTO_VALIDATION.ERROR_CODE.DUPLICATED,
					file: validatedFile
				};
			}
		}

		function buildErrorFilename(files) {
			var errMsg = '';
			for (var i = 0; i < files.length; i++) {
				errMsg += ("<li class='upload-photo__invalid-file text--truncate'><span>" + files[i].file.name + "</span></li>");
			}
			return errMsg;
		}

		function errorHandler(errors) {
			if (!errors) errors = self.errors;
			if (errors.length === 0) return;
			var errMsg = '';
			var callToActionMsg = '';
			var okBtnText = 'OK';
			var windowClass = '';
			var groupedError = _.groupBy(errors, function (item) {
				return item.code;
			});
			for (var key in groupedError) {
				callToActionMsg = '';
				if (key === fileConst.UPLOAD_PHOTO_VALIDATION.ERROR_CODE.DUPLICATED) {
					windowClass = key.toLocaleLowerCase();
					errMsg += "<p class='error-message'>" + $translate.instant("the-following-photos-uploaded-before") + "</p>";
					callToActionMsg += "<p class='upload-photo__validation-popup__call-to-action-msg'>" + $translate.instant("try-uploading-new-ones") + "!</p>";
				}
				if (key === fileConst.UPLOAD_PHOTO_VALIDATION.ERROR_CODE.INVALID_MIN_RESOLUTION) {
					windowClass = key.toLocaleLowerCase();
					errMsg += "<p class='error-message'>" + $translate.instant("photos-too-small-uploaded") + "</p>";
					callToActionMsg += ("<p class='upload-photo__validation-popup__call-to-action-msg'>" + $translate.instant("upload-photos-at-least-megapixels", {
						number: fileConst.UPLOAD_PHOTO_VALIDATION.PHOTO_SIZE.MIN_RESOLUTION
					}) + "</p>");
				}
				if (key === fileConst.UPLOAD_PHOTO_VALIDATION.ERROR_CODE.INVALID_FILETYPE) {
					windowClass = key.toLocaleLowerCase();
					errMsg += "<p class='error-message'>" + $translate.instant("upload-photos-wrong-format") + "</p>";
					callToActionMsg += "<p class='upload-photo__validation-popup__call-to-action-msg'>" + $translate.instant("type-photo-allowed-upload", {
						type_1: 'JPG',
						type_2: 'JPEG'
					}) + "</p>";
				}
				if (key === fileConst.UPLOAD_PHOTO_VALIDATION.ERROR_CODE.INVALID_MAX_FILESIZE) {
					windowClass = key.toLocaleLowerCase();
					errMsg += "<p class='error-message'>" + $translate.instant("upload-photos-too-large") + "</p>";
					callToActionMsg += ("<p class='upload-photo__validation-popup__call-to-action-msg'>" + $translate.instant("upload-files-smaller-than", {
						value: fileConst.UPLOAD_PHOTO_VALIDATION.PHOTO_SIZE.MAX_FILE_SIZE,
						unit: 'MB'
					}) + "</p>");

				}
				if (key === fileConst.UPLOAD_PHOTO_VALIDATION.ERROR_CODE.EXCEED_NUMBER_OF_UPLOAD_PER_WEEK) {
					windowClass = key.toLocaleLowerCase();
					errMsg += "<p class='error-message'>" + $translate.instant("upload-photos-exceeded-limit-per-week", {
						number: 50
					}) + "</p>";
					callToActionMsg += ("<p class='upload-photo__validation-popup__call-to-action-msg'>" + $translate.instant("try-uploading-next-week") + "</p>");
				}
				if (key === fileConst.UPLOAD_PHOTO_VALIDATION.ERROR_CODE.EXCEED_NUMBER_OF_UPLOAD_THIS_MISSION && self.mission.ioaSubscriber) {
					windowClass = key.toLocaleLowerCase();
					if (self.mission.ioaSubscriber.free_balance) {
						errMsg += "<p class='error-message'>The following photos could not be uploaded because you have exceeded your limit of " + self.mission.ioaSubscriber.free_balance + " free submission(s) this mission:</p>";
					} else {
						errMsg += "<p class='error-message'>The following photos could not be uploaded because you have exceeded your limit of " + self.mission.ioaSubscriber.total_balance + " submission(s) this mission:</p>";
					}
					callToActionMsg += ("<p class='upload-photo__validation-popup__call-to-action-msg'>" + $translate.instant("please-remove-photos-from-submissions") + "</p>");
				} else if (key === fileConst.UPLOAD_PHOTO_VALIDATION.ERROR_CODE.EXCEED_NUMBER_OF_UPLOAD_THIS_MISSION) {
					windowClass = key.toLocaleLowerCase();
					errMsg += "<p class='error-message'>" + $translate.instant("upload-photos-exceeded-limit-this-mission", {
						number: self.mission && self.mission.user_participation_limit ? self.mission.user_participation_limit : fileConst.UPLOAD_PHOTO_VALIDATION.MISSION_LIMIT
					}) + "</p>";
					callToActionMsg += ("<p class='upload-photo__validation-popup__call-to-action-msg'>" + $translate.instant("please-remove-photos-from-submissions") + "</p>");
				}
				if (key === fileConst.UPLOAD_PHOTO_VALIDATION.ERROR_CODE.FAILED_TO_UPLOAD) {
					windowClass = key.toLocaleLowerCase();
					errMsg += "<p class='error-message'>" + $translate.instant("upload-photos-failed") + "</p>";
					callToActionMsg += ("<p class='upload-photo__validation-popup__call-to-action-msg'>" + $translate.instant("try-uploading-them-again") + "!</p>");
				}
				errMsg += buildErrorFilename(groupedError[key]);
				errMsg += callToActionMsg;
			}
			pixerfConfirmPopupSvc.showPopup({
				hideCancelBtn: true,
				hideConfirmText: true,
				hideTitle: true,
				message: errMsg,
				windowClass: 'upload-photo__validation-popup ' + windowClass,
				okBtnText: okBtnText,
				showCloseBtn: true
			});
			self.errors = [];
		}

		function updateUserUploadBalance(numJustUploaded) {
			try {
				self.loginUser = sessionManagerSvc.getCurrentLoginUser().data;
				self.loginUser.stats.weekly_upload_balance -= numJustUploaded;
				self.loginUser.stats.inreview_media_count += numJustUploaded;
				sessionManagerSvc.setCurrentLoginUser(self.loginUser);
			} catch (ex) { }
		}

		function upload(files) {
			self.publishing = true;
			uploadPhotoSvc.publish(files).$promise.then(function (response) {
				$timeout(function () {
					updateUserUploadBalance(files.length);
					self.publishing = false;
					$uibModalInstance.dismiss();

					if ($state.current.name === commonConst.STATE.MANAGE_PHOTO_PENDING) {
						$state.reload();
					} else {
						$state.go(commonConst.STATE.MANAGE_PHOTO_PENDING);
					}
				}, 2000);
			}).catch(function (error) {
				self.publishing = false;
				Sentry.captureException(error);
				var errorMsg = '';
				if (error.data && error.data.data && error.data.data.key === 'weekly_upload_limit_reached') {
					errorMsg = $translate.instant('you-have-limit-upload-this-time', {
						number: self.loginUser.stats.weekly_upload_balance
					});
					errorMsg += $translate.instant('please-remove-photo-from-upload');
					toastr.error(errorMsg);
				}
			})
		}

		function uploadToMission(files, ioaGuest) {
			self.publishing = true;
			if (self.mission.is_ioa) {
				self.mission.ioa_subscriber_type = ioaGuest.ioaSubscriber.ioa_subscriber_type;
				self.mission.ioa_submission_type = ioaGuest.ioaSubscriber.ioa_submission_type;
				self.mission.ioa_subscriber_email = ioaGuest.ioaSubscriber.ioa_subscriber_email;
			}
			if (self.manualProcess) {
				$rootScope.$broadcast("uploadPhoto", {
					files: files,
					dropzone: self.dropzoneConfig.instance,
					mission: self.mission
				});
				$uibModalInstance.dismiss();
				return;
			}
			uploadPhotoSvc.publish(files, self.mission).$promise.then(function () {
				$timeout(function () {
					if (!self.mission.is_ioa) {
						updateUserUploadBalance(files.length);
					}
					self.publishing = false;
					$uibModalInstance.dismiss();

					toastr.success($translate.instant(translationConst.SUBMISSION_WAIT_FOR_CURATION));
					if ($state.current.name === commonConst.STATE.MISSION_SUBMISSIONS) {
						$state.reload();
					} else {
						$state.go(commonConst.STATE.MISSION_SUBMISSIONS, null, {
							reload: true
						});
					}

				}, 2000);
			}).catch(function (error) {
				var exception = error.data.data || error.data;
				Sentry.captureException(exception);
				self.publishing = false;
				var limitPhoto = self.mission && self.mission.user_participation_limit ? self.mission.user_participation_limit : fileConst.UPLOAD_PHOTO_VALIDATION.MISSION_LIMIT;
				var errorMsg = '';
				if (error.data && error.data.data && error.data.data.message === 'LIMIT_EXCEEDED') {
					errorMsg = $translate.instant('hi') + ", " + $translate.instant('submit-this-mission', {
						number: limitPhoto
					});
				} else if (error.data && error.data.data && error.data.data.key === 'participation_limit_exceeded' && error.data.data.message.includes("0")) {
					errorMsg = 'You have reached your ' + limitPhoto + ' photo submission limit.';
				} else if (error.data && error.data.data && error.data.data.key === 'participation_limit_exceeded' && error.data.data.message) {
					errorMsg = error.data.data.message;
				}

				if (errorMsg) {
					toastr.error(errorMsg);
				}
			})
		}

		function onPublishBtnClicked(files) {
			if (self.selectedFiles && self.selectedFiles.data && self.selectedFiles.data.length === 0) {
				return toastr.warning($translate.instant('no-photo-is-selected'));
			}
			self.isFormDirty = true;
			var validToUploadFiles = _.reject(files, function (f) {
				return f.pixerfError;
			})
			if (validToUploadFiles.length === 0) {
				return;
			}
			var errorMsg = '';
			if (!self.mission || (!self.mission.is_ioa && !self.mission.is_goJek)) {
				if (validToUploadFiles.length - self.loginUser.stats.weekly_upload_balance > 0) {
					errorMsg = $translate.instant('you-have-limit-upload-this-time', {
						number: self.loginUser.stats.weekly_upload_balance
					});
				} else if (self.mission) {
					var balance = self.mission.user_participation_limit - (self.mission.submittedPhotos ? self.mission.submittedPhotos.length : 0);
					if (validToUploadFiles.length - balance > 0) {
						errorMsg = "You have " + self.mission.user_participation_limit + " uploads this mission.";
					}
				}
			}
			if (errorMsg) {
				errorMsg += $translate.instant('please-remove-photo-from-upload');
			}
			if (!errorMsg) {
				errorMsg = uploadPhotoDetailSvc.validate(validToUploadFiles);
			}
			if (errorMsg) {
				toastr.error(errorMsg);
				return false;
			}
			if (self.mission) {
				uploadToMission(validToUploadFiles, self.mission);
			} else {

				var isPriceSet = uploadPhotoDetailSvc.isPriceSet(validToUploadFiles);
				if (!isPriceSet) {
					var modal = pixerfConfirmPopupSvc.showPopup({
						hideTitle: true,
						message: "Hey, we realise that you haven't set prices for some of your photos. Without prices, your photos won't be discoverable on the Marketplace."
					});
					modal.result.then(function () {
						upload(validToUploadFiles);
					}, function () {

					})
				} else {
					upload(validToUploadFiles);
				}
			}
		}

		function closeConfirm(uploadPhotoClosingEvent, reason, closed) {
			if (reason && self.uploadedFiles.data.length > 0) {
				uploadPhotoClosingEvent.preventDefault();
				var exitUploadConfirmModal = uploadPhotoSvc.showExitConfirmModal();
				exitUploadConfirmModal.result.then(function () {
					window.removeEventListener("beforeunload", beforeUnloadHandler);
					if (self.manualProcess) {
						$timeout(function () {
							self.uploadModal.data.dismiss();
						});
					} else {
						$uibModalStack.dismissAll();
					}
				}, function () {
					window.removeEventListener("beforeunload", beforeUnloadHandler);
				});
			} else {
				if (self.isCancelUpload) {
					deletePhotos(self.uploadedFiles.data);
				}
				window.removeEventListener("beforeunload", beforeUnloadHandler);
				self.uploadModal.data = null;
			}
		}

		function navigate(path) {
			uibModalInstance.dismiss("cancel")
		}

		function closeUploadModal() {
			self.isCancelUpload = true;
			$uibModalInstance.dismiss("cancel");
		}

		function deletePhotos(photos) {
			if (photos && photos.length) {
				for (var i = 0; i < photos.length; i++) {
					pixerfApiMediaSvc.delete({ id: photos[i].id });
				}
			}
		}

		function navigateTo(path) {
			var exitUploadConfirmModal = uploadPhotoSvc.showExitConfirmModal();
			exitUploadConfirmModal.result.then(function () {
				window.removeEventListener("beforeunload", beforeUnloadHandler);
				$uibModalStack.dismissAll();
				$location.path(path);
			}, function () {
				window.removeEventListener("beforeunload", beforeUnloadHandler);
			});
		}

		function reset() {
			self.dropzoneConfig.instance.removeAllFiles();
			self.dropzoneConfigSmall.instance.removeAllFiles();
			uploadPhotoSvc.reset();

		}

		function uploadErrorHandler(pixerfFileBlob) {
			errorHandlerFn();
			systemUtils.digest($scope);
		}

		function convertToPixerfFile(pixerfFileBlob, filestackBlob) {
			fileUtils.fromFilestackBlob2PixerfBlob(pixerfFileBlob, filestackBlob);
			pixerfFileBlob.title = fileUtils.getFileNameWithoutExtension(pixerfFileBlob.name);
		}

		function convertToPixerfFiles(pixerfFileBlobs, filestackBlobs) {
			var length = Math.min(pixerfFileBlobs.length, filestackBlobs.length);
			for (var i = 0; i < length; i++) {
				(function (index) {
					var pixerfFileBlob = pixerfFileBlobs[index];
					var filestackBlob = filestackBlobs[index];
					convertToPixerfFile(pixerfFileBlob, filestackBlob);
				})(i)
			}
		}

		function showFilePickerPopup(defaultService) {
			googleAnalyticSvc.trackPageView("Upload Photo - Social - " + defaultService);
			filePickerSvc.pickMultiple({
				callbacks: mFileStackSocaialHandler,
				defaultService: defaultService
			});
		}
		function removeSelectedPhotos(photos) {
			if (photos.length === self.uploadedFiles.data.length) {
				var modal = pixerfConfirmPopupSvc.showPopup({
					message: '',
					htmlConfirmText: $translate.instant('all-photos-will-be-removed') + '</br>' + $translate.instant('are-you-sure-you-want-to-continue'),
					hideTitle: true,
					hideConfirmText: true,
					windowClass: 'upload-photo__validation-popup remove-selected-photos',
					okBtnText: 'Yes',
					showCloseBtn: true
				});
				modal.result.then(function () {
					self.reset();
				}, function () {
					//do nothing
				})
			} else {

				for (var i = 0; i < photos.length; i++) {
					uploadPhotoSvc.removeFileByName(photos[i].name);
				}
			}
		}

		function rotatePhoto(file) {
			if (!file.rotate_by) file.rotate_by = 0;
			file.rotate_by += 90;
			if (file.rotate_by === 360) {
				file.rotate_by = 0;
			}
		}

	}
})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.factory('uploadCustomCommissionsPopupSvc', uploadCustomCommissionsPopupSvc);
	uploadCustomCommissionsPopupSvc.$inject = ['toastr', 'arrayUtils', 'numberUtils', '$window', '$q', 'resendVerificationEmailPopupSvc', 'editProfileSvc', 'agreementPopupSvc', 'sessionManagerSvc', 'googleAnalyticSvc', 'pixerfApiMediaSvc', '$uibModal', 'fileUtils', 'accountUtils', 'translationSvc'];

	function uploadCustomCommissionsPopupSvc(toastr, arrayUtils, numberUtils, $window, $q, resendVerificationEmailPopupSvc, editProfileSvc, agreementPopupSvc, sessionManagerSvc, googleAnalyticSvc, pixerfApiMediaSvc, $uibModal, fileUtils, accountUtils, translationSvc) {

		var mFiles = {
			data: []
		};
		var mSelectedFiles = {
			data: []
		};

		var isFullscreenDropzone = {
			data: false
		};

		var mOverlay = {
			data: false
		};
		var mUploadModal = {
			data: null
		};

		var dragPhotoEvent = {

			over: function (overlay) {
				if (!mUploadModal.data) return;
				isFullscreenDropzone.data = true;
			},
			leave: function (overlay) {
				isFullscreenDropzone.data = false;
			}
		};

		function setOverlay(status) {
			mOverlay.data.visible = status;
		}

		function getUploadModal() {
			return mUploadModal;
		}

		function getSelectedFiles() {
			return mSelectedFiles;
		}

		function showPopup(data) {
			mUploadModal.data = $uibModal.open({
				size: 'full',
				templateUrl: 'app/components/upload-custom-commissions-popup/upload-custom-commissions-popup.html',
				controller: 'uploadCustomCommissionsPopupCtrl',
				controllerAs: 'vm',
				openedClass: 'upload-custom-commissions-modal',
				resolve: {
					popupData: function () {
						var def = $q.defer();
						def.resolve(data);
						return def.promise;
					}
				}
			});
		}

		function runFakeProgress(file) {

			file.fakeProgressInterval = $window.setInterval(function () {
				if (file.upload.progress >= 99) {
					$window.clearInterval(file.fakeProgressInterval);
					delete file.fakeProgressInterval;
					return;
				}
				var leftleft = 99 - file.upload.progress;
				var step = numberUtils.getRandomInRange(1, leftleft);
				var progress = step + file.upload.progress;
				updateProgress(file, progress);
			}, 1000);

		}

		function showUploadModal(data) {
			var loginUser = sessionManagerSvc.getCurrentLoginUser().data;
			if (loginUser.is_email_verified) {
				if (!loginUser.is_contributor_agreement_accepted) {
					var modal = agreementPopupSvc.showPopup({
						windowClass: 'agree-terms-popup',
						message: 'I agree to the <a ui-sref="introduction-company.terms" target="_blank" class="text--bold text--color-pixerf-theme">Terms</a>',
						okFn: function (isAgree, isWorking) {
							var def = $q.defer();
							loginUser = sessionManagerSvc.getCurrentLoginUser().data;
							loginUser.is_contributor_agreement_accepted = true;
							sessionManagerSvc.setCurrentLoginUser(loginUser);
							editProfileSvc.updateUser(loginUser).then(function () {
								modal.close();
								def.resolve(showPopup(data));
							}, function () {
								toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
								def.reject();
							});
							return def.promise;
						}
					})
				} else {
					showPopup(data);
				}
			} else {
				resendVerificationEmailPopupSvc.showVerifyEmailPopup();
			}

		}

		function showExitConfirmModal(callbackFn) {
			var exitUploadConfirmModal = $uibModal.open({
				size: 'small',
				templateUrl: 'app/components/upload-photo-exit-confirm/upload-photo-exit-confirm.html',
				controller: 'uploadPhotoExitConfirmCtrl',
				controllerAs: 'vm',
				openedClass: 'confirm-exit-popup'
			});
			return exitUploadConfirmModal;
		}

		function getuploadPortfolioPhotoSvc() {
			return mFiles;
		}

		function updateProgress(file, progress) {
			var updatingFile = _.find(mFiles.data, function (itFile) {
				return itFile.name === file.name;
			})
			if (updatingFile) {
				updatingFile.upload.progress = progress;
			}
		}

		function updateThumbnail(file, thumbnail) {
			var updatingFile = _.find(mFiles.data, function (itFile) {
				return itFile.name === file.name;
			})
			if (updatingFile) {
				updatingFile.thumbnail = thumbnail;
			}
		}

		function updateFileInfo(updatingFile, fileInfo) {
			if (updatingFile) {
				updatingFile.key = fileInfo.key;
				updatingFile.username = fileInfo.username;
				updatingFile.inserted_at = fileInfo.inserted_at;
				updatingFile.title = fileInfo.name;
				updatingFile.handle = fileInfo.handle;
			}
		}

		function setThumbnail(files) {
			for (var i = 0; i < files.length; i++) {
				files[i].thumbnail = files.url;
			}
		}

		function removeFileFromSelectedFiles(fileName) {
			mSelectedFiles.data = _.reject(mSelectedFiles.data, function (file) {
				if (file.name === fileName) {
					file.isSelected = false;
					return true;
				}
			});
		}

		function getFileByName(pixerfFile) {
			return _.find(mFiles.data, function (f) {
				return f.name === pixerfFile.name;
			});
		}

		function removeUploadedFile(index) {
			deletePhoto(mFiles.data[index]);
			removeFileFromSelectedFiles(mFiles.data[index].name);
			mFiles.data.splice(index, 1);
		}

		function deletePhoto(photo){
			pixerfApiMediaSvc.delete({id: photo.id});
		}

		function removeFileByName(fileName) {
			removeFileFromSelectedFiles(fileName);
			mFiles.data = _.reject(mFiles.data, function (file) {
				return file.name === fileName;
			})
		}

		function replaceFileByName(fileName, newElement) {
			var index = arrayUtils.indexOf(mFiles.data, function (it) {
				return it.name === fileName;
			});
			mFiles.data[index] = newElement;

		}

		function isSameFile(fileOne, fileTwo) {
			return fileOne.name === fileTwo.name &&
				fileOne.size === fileTwo.size;

		}

		function isFileExisted(files, file, isInclusiveErrorFile) {
			var isExisted = _.find(files, function (f) {
				return isInclusiveErrorFile ? isSameFile(f, file) : !f.pixerfError && isSameFile(f, file);
			})
			return isExisted;
		}

		function addFile(file) {
			var isExisted = isFileExisted(mFiles.data, file, true);
			if (isExisted) {
				if (!isExisted.pixerfError) {
					return isExisted;
				} else {
					replaceFileByName(isExisted.name, file);
				}
			} else {
				mFiles.data.unshift(file);
			}
		}

		function getDuplicatedFiles(exisingFiles, willBeAddedFiles) {
			var arr = [];
			for (var i = 0; i < willBeAddedFiles.length; i++) {
				if (isFileExisted(exisingFiles, willBeAddedFiles[i])) {
					arr.push(willBeAddedFiles[i]);
				}
			}
			return arr;
		}

		function addFiles(files) {
			var errMsg;
			for (var i = 0; i < files.length; i++) {
				errMsg = addFile(files[i]);
			}
			return errMsg;
		}

		function selectAllFiles() {
			var selectedFiles = [];
			for (var i = 0; i < mFiles.data.length; i++) {
				var file = mFiles.data[i];
				if (file.upload.progress === 100) {
					file.isSelected = true;
					selectedFiles.push(file);
				}
			}
			mSelectedFiles.data = selectedFiles;
		}

		function deselectAllFiles() {
			for (var i = 0; i < mFiles.data.length; i++) {
				mFiles.data[i].isSelected = false;
			}
			mSelectedFiles.data = [];
		}

		function deSelectFile(file) {
			if (!file.isSelected) return;
			file.isSelected = false;
			mSelectedFiles.data = _.reject(mSelectedFiles.data, function (f) {
				return f.id === file.id;
			})
		}

		function selectFiles(files) {
			for (var i = 0; i < files.length; i++) {
				selectFile(file);
			}
		}

		function selectFile(file) {
			if (!file) return;
			if (file.isSelected) return;
			var isExisted = _.find(mSelectedFiles.data, function (itFile) {
				return itFile.name === file.name;
			})
			if (isExisted) return;
			file.isSelected = true;
			mSelectedFiles.data.push(file);
		}

		function toggleFileSelection(file, isSelected) {
			if (file.upload.progress !== 100) return;
			if (typeof isSelected === 'undefined') {
				isSelected = !file.isSelected;
			}
			if (isSelected) {
				selectFile(file);
			} else {
				deSelectFile(file);
			}
		}

		function onFileClicked(evt, file) {
			if (file.upload.progress !== 100) return;
			if (evt && evt.shiftKey) {
				return;
			} else if (evt && (evt.ctrlKey || evt.metaKey)) {
				toggleFileSelection(file);
			} else {
				for (var i = 0; i < mSelectedFiles.data.length; i++) {
					mSelectedFiles.data[i].isSelected = false;
				}
				file.isSelected = true;
				mSelectedFiles.data = [file];
			}
		}

		function buildSavedFilesData(files) {
			var arr = [];
			for (var i = 0; i < files.length; i++) {
				var file = files[i];
				arr.push(fileUtils.buildSavedFileObject(file));
			}
			return arr;
		}

		function isValidFileType(file) {
			var fileExtension = fileUtils.getFileExtension(file.name);
			return fileExtension.toLowerCase() === "jpeg" || fileExtension.toLowerCase() === "jpg";
		}

		function isExceedMaxSize(file, maxSize) {
			return file.size > maxSize;
		}

		function isUnderMinSize(file, minSize) {
			return file.size < minSize;
		}

		function isExceedNumberOfUpload(filesWillBeUploaded, limit) {
			var validToUploadFiles = _.reject(mFiles.data, function (f) {
				return f.pixerfError;
			})
			return validToUploadFiles.length + filesWillBeUploaded.length > limit;
		}

		function isBelowMinResolution(file, minRes) {
			var resolution = file.width * file.height;
			return resolution < minRes;
		}

		function isAboveMaxResolution(file, maxRes) {
			var resolution = file.width * file.height;
			return resolution >= maxRes;
		}

		function publish(files) {
			var savedData = buildSavedFilesData(files);
			return pixerfApiMediaSvc.multipleUpdate({
				'api_version': 'new'
			}, savedData);
		}

		function reset() {
			mFiles.data = [];
			mSelectedFiles.data = [];
		}

		function validate(files) {
			for (var i = 0; i < files.length; i++) {
				var file = files[i];
				var photoName = "Photo " + (file.title ? file.title : file.name);
				if (!file.title) {
					return "Please input the title of your photo!";
				}
				var valid = !(accountUtils.isContainsLink(file.description));
				if (!valid) return "Sorry, " + photoName + ": description cannot contain link or email.";
				valid = !accountUtils.isContainsFileExtension(file.title);
				if (!valid) return "Sorry, " + "Photo title cannot contain extension.";
			}
		}

		return {
			setOverlay: setOverlay,
			isFullscreenDropzone: isFullscreenDropzone,
			dragPhotoEvent: dragPhotoEvent,
			getUploadModal: getUploadModal,
			showUploadModal: showUploadModal,
			showExitConfirmModal: showExitConfirmModal,
			getuploadPortfolioPhotoSvc: getuploadPortfolioPhotoSvc,
			updateProgress: updateProgress,
			updateThumbnail: updateThumbnail,
			removeUploadedFile: removeUploadedFile,
			removeFileByName: removeFileByName,
			addFile: addFile,
			addFiles: addFiles,
			isFileExisted: isFileExisted,
			onFileClicked: onFileClicked,
			selectFile: selectFile,
			selectFiles: selectFiles,
			toggleFileSelection: toggleFileSelection,
			selectAllFiles: selectAllFiles,
			getSelectedFiles: getSelectedFiles,
			publish: publish,
			updateFileInfo: updateFileInfo,
			reset: reset,
			setThumbnail: setThumbnail,
			isValidFileType: isValidFileType,
			isBelowMinResolution: isBelowMinResolution,
			isAboveMaxResolution: isAboveMaxResolution,
			isExceedMaxSize: isExceedMaxSize,
			isUnderMinSize: isUnderMinSize,
			deselectAllFiles: deselectAllFiles,
			deSelectFile: deSelectFile,
			getDuplicatedFiles: getDuplicatedFiles,
			isExceedNumberOfUpload: isExceedNumberOfUpload,
			runFakeProgress: runFakeProgress,
			getFileByName: getFileByName,
			isSameFile: isSameFile,
			validate: validate
		};
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('uploadCustomCommissionsPopupCtrl', uploadCustomCommissionsPopupCtrl);

	uploadCustomCommissionsPopupCtrl.$inject = ['$uibModalStack', 'uploadPhotoDetailSvc', '$scope', 'toastr', 'sessionManagerSvc', 'systemUtils', '$uibModalInstance', 'pixerfUrl', 'uploadCustomCommissionsPopupSvc', 'uploadPhotoSvc', '$location', '$state', '$timeout', 'fileUtils', 'pixerfConfirmPopupSvc', 'imageUtils', 'fileConst', 'popupData', 'pixerfApiCustomCommssionsSvc', '$translate', 'translationSvc', 'pixerfApiMediaSvc'];

	function uploadCustomCommissionsPopupCtrl($uibModalStack, uploadPhotoDetailSvc, $scope, toastr, sessionManagerSvc, systemUtils, $uibModalInstance, pixerfUrl, uploadCustomCommissionsPopupSvc, uploadPhotoSvc, $location, $state, $timeout, fileUtils, pixerfConfirmPopupSvc, imageUtils, fileConst, popupData, pixerfApiCustomCommssionsSvc, $translate, translationSvc, pixerfApiMediaSvc) {

		var self = this;

		uploadPhotoSvc.reset();
		self.loginUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.uploadedFiles = uploadPhotoSvc.getUploadPhotoSvc();
		self.removeUploadedFile = uploadPhotoSvc.removeUploadedFile;
		self.onFileClicked = uploadPhotoSvc.onFileClicked;
		self.toggleFileSelection = uploadPhotoSvc.toggleFileSelection;
		self.selectAllFiles = uploadPhotoSvc.selectAllFiles;
		self.selectedFiles = uploadPhotoSvc.getSelectedFiles();
		self.onPublishBtnClicked = onPublishBtnClicked;
		self.reset = reset;
		self.closeUploadModal = closeUploadModal;
		self.uploadModal = uploadPhotoSvc.getUploadModal();
		self.isFullscreenDropzone = uploadPhotoSvc.isFullscreenDropzone;
		self.selection = {};
		self.pixerfAlert = {};
		self.removeSelectedPhotos = removeSelectedPhotos;
		self.rotatePhoto = rotatePhoto;
		self.publishing = false;
		self.dragCounter = 0;
		self.numProcessingFile = 0;
		self.updateMasterFile = updateMasterFile;
		self.navigateTo = navigateTo;
		self.errors = [];
		self.hideSocialUpload = true;
		self.isCancelUpload = false;
		self.chooseFileBtnText = 'upload-more';
		self.popupData = popupData;
		self.popupData.files = popupData.files;
		self.shoot = popupData.shoot;
		self.batch = {};
		self.uploadBtnText = 'Upload';
		var errorHandlerFn = _.debounce(errorHandler, 1000);

		function beforeUnloadHandler(event) {
			if (self.uploadedFiles.data.length > 0) {
				var confirmationMessage = $translate.instant("are-you-sure");
				event.returnValue = confirmationMessage;
				return confirmationMessage;
			}
		}
		window.addEventListener("beforeunload", beforeUnloadHandler);
		self.dropzoneConfig = {
			'methods': {},
			'instance': {},
			'options': {
				url: pixerfUrl.full + 'api/media/store',
				dictDefaultMessage: '',
				autoProcessQueue: true,
				acceptedFiles: self.popupData.files.hires ? ".jpeg, .jpg, .tiff, .tif" : ".jpeg, .jpg",
				maxFiles: 500,
				paramName: 'media',
				parallelUploads: self.popupData.files.hires ? 2 : 10,
				previewsContainer: '.upload-custom-commissions-popup__frame__upload-area__preview',
				method: "post",
				clickable: ".upload-custom-commissions-popup__frame__upload-area__browse-btn",
				thumbnailWidth: 300,
				thumbnailHeight: 300,
				maxFilesize: 1024,
				headers: {
					"Authorization": "Bearer " + sessionManagerSvc.getToken()
				},
				dictFileTooBig: "Size of this photo is {{filesize}} MB file. The maximum size is {{maxFilesize}} MB",
				createImageThumbnails: false
			},
			'eventHandlers': {
				sending: function (file, xhr, formData) {
					formData.append('title', file.name);
					formData.append('type', "custom_commission");
				},

				thumbnail: function (file, dataUrl) {
					if (!file.pixerfError) {
						uploadPhotoSvc.updateThumbnail(file, dataUrl);
						systemUtils.digest($scope);
					}
				},
				drop: function (file, errMsg) {
					self.isFullscreenDropzone.data = false;
					uploadPhotoSvc.dragPhotoEvent.leave();
					systemUtils.digest($scope);
				},
				dragover: function () {
					self.dragCounter++;
					uploadPhotoSvc.dragPhotoEvent.over();
					systemUtils.digest($scope);
				},
				addedfile: function (file) {
					imageUtils.customDropzoneThumbnail(file, this);
					var error = "";
					error = validateBeforeUploading(file);
					if (error) {
						setErrors(error);
						errorHandlerFn();
						this.removeFile(file);
					} else {
						self.numProcessingFile++;
						var pixerfBlob = fileUtils.convertFromFileObject2PixerfBlob(file);
						uploadPhotoSvc.addFile(pixerfBlob);
					}
					systemUtils.digest($scope);
				},
				uploadprogress: function (file, progress) {
					var roundProgress = Math.round(progress);
					if (roundProgress === 100) return;
					uploadPhotoSvc.updateProgress(file, roundProgress);
					systemUtils.digest($scope);
				},
				success: function (file, responsedFile) {
					self.numProcessingFile--;
					var pixerfBlob = _.find(self.uploadedFiles.data, function (f) {
						return f.name === file.name;
					});
					if (!pixerfBlob) {
						return;
					}
					pixerfBlob.upload.progress = 100;
					pixerfBlob.id = responsedFile.id;

					if (file && (file.type === 'image/tiff' || file.type === 'image/tif')) {
						this.emit("thumbnail", file, responsedFile.thumbnails["300x"]);
					}

					uploadPhotoSvc.selectFile(pixerfBlob);
					systemUtils.digest($scope);
				},
				error: function (file, errorResponse) {
					self.numProcessingFile--;
					var pixerfBlob = _.find(self.uploadedFiles.data, function (f) {
						return f.name === file.name;
					});
					if (!pixerfBlob) pixerfBlob = file;
					if (errorResponse.error && errorResponse.error === 'media_exceeds_size_limit') {
						setErrors({
							code: fileConst.UPLOAD_PHOTO_VALIDATION.ERROR_CODE.INVALID_MAX_RESOLUTION,
							file: pixerfBlob
						});
					} else if (errorResponse.error && errorResponse.error === 'media_under_size_limit') {
						setErrors({
							code: fileConst.UPLOAD_PHOTO_VALIDATION.ERROR_CODE.INVALID_MIN_RESOLUTION,
							file: pixerfBlob
						});
					} else {
						setErrors({
							code: fileConst.UPLOAD_PHOTO_VALIDATION.ERROR_CODE.FAILED_TO_UPLOAD,
							file: pixerfBlob
						});
					}
					pixerfBlob.upload.progress = 0;
					uploadErrorHandler(pixerfBlob);
					systemUtils.digest($scope);
				}
			}
		};
		self.dropzoneConfigSmall = $.extend(true, {}, self.dropzoneConfig);
		self.dropzoneConfigSmall.options.clickable = ".upload-photo-preview--add-more__dropzone__content__browse-btn--small";
		$scope.$on('modal.closing', closeConfirm);

		function updateMasterFile(file, property) {
			var selectedFile = self.selectedFiles.data[0];
			if (self.selectedFiles.data.length === 1 && self.masterFile && self.masterFile.name === selectedFile.name && file.name === selectedFile.name) {
				uploadPhotoDetailSvc.updateMasterFile(self.masterFile, property, file[property]);
			}
		}

		function setErrors(error) {
			error.file.pixerfError = error.code;
			self.errors.push(error);
		}

		function validateBeforeUploading(validatedFile) {
			if (self.popupData.files.hires && !uploadPhotoSvc.isValidFileThreeType(validatedFile)) {
				return {
					code: fileConst.UPLOAD_PHOTO_VALIDATION.ERROR_CODE.INVALID_THREE_FILETYPE,
					file: validatedFile
				};
			} else if (!self.popupData.files.hires && !uploadPhotoSvc.isValidFileType(validatedFile)) {
				return {
					code: fileConst.UPLOAD_PHOTO_VALIDATION.ERROR_CODE.INVALID_FILETYPE,
					file: validatedFile
				};
			}
			if (self.popupData.files.hires && uploadPhotoSvc.isExceedMaxSize(validatedFile, fileConst.UPLOAD_PHOTO_VALIDATION.PHOTO_SIZE.MAX_TIFF_FILE_SIZE * 1024 * 1024)) {
				return {
					code: fileConst.UPLOAD_PHOTO_VALIDATION.ERROR_CODE.INVALID_MAX_TIFF_FILE_SIZE,
					file: validatedFile
				}
			}
			if (uploadPhotoSvc.isFileExisted(self.uploadedFiles.data, validatedFile)) {
				return {
					code: fileConst.UPLOAD_PHOTO_VALIDATION.ERROR_CODE.DUPLICATED,
					file: validatedFile
				};
			}
		}

		function buildErrorFilename(files) {
			var errMsg = '';
			for (var i = 0; i < files.length; i++) {
				errMsg += ("<div class='upload-photo__invalid-file text--truncate'> - " + files[i].file.name + "</div>");
			}
			return errMsg;
		}

		function errorHandler(errors) {
			if (!errors) errors = self.errors;
			if (errors.length === 0) return;
			var errMsg = '';
			var callToActionMsg = '';
			var groupedError = _.groupBy(errors, function (item) {
				return item.code;
			});
			for (var key in groupedError) {
				callToActionMsg = '';
				if (key === fileConst.UPLOAD_PHOTO_VALIDATION.ERROR_CODE.DUPLICATED) {
					errMsg += "<p>" + $translate.instant("the-following-photos-uploaded-before") + "</p>";
					callToActionMsg += "<p class='upload-photo__validation-popup__call-to-action-msg'>" + $translate.instant("try-uploading-new-ones") + "!</p>";
				}
				if (key === fileConst.UPLOAD_PHOTO_VALIDATION.ERROR_CODE.INVALID_FILETYPE) {
					errMsg += "<p>" + $translate.instant("upload-photos-wrong-format") + "</p>";
					callToActionMsg += "<p class='upload-photo__validation-popup__call-to-action-msg'>" + $translate.instant("type-photo-allowed-upload", {
						type_1: 'JPG',
						type_2: 'JPEG'
					}) + "</p>";
				} else if (key === fileConst.UPLOAD_PHOTO_VALIDATION.ERROR_CODE.INVALID_THREE_FILETYPE) {
					errMsg += "<p>" + $translate.instant("upload-photos-wrong-format") + "</p>";
					callToActionMsg += "<p class='upload-photo__validation-popup__call-to-action-msg'>" + $translate.instant("three-type-photo-allowed-upload", {
						type_1: 'JPG',
						type_2: 'JPEG',
						type_3: 'TIFF'
					}) + "</p>";
				}
				if (key === fileConst.UPLOAD_PHOTO_VALIDATION.ERROR_CODE.INVALID_MAX_TIFF_FILE_SIZE) {
					errMsg += "<p>" + $translate.instant("upload-photos-too-large") + "</p>";
					callToActionMsg += ("<p class='upload-photo__validation-popup__call-to-action-msg'>" + $translate.instant("upload-files-smaller-than", {
						value: fileConst.UPLOAD_PHOTO_VALIDATION.PHOTO_SIZE.MAX_TIFF_FILE_SIZE,
						unit: 'MB'
					}) + "</p>");

				} else if (key === fileConst.UPLOAD_PHOTO_VALIDATION.ERROR_CODE.INVALID_MAX_FILESIZE) {
					errMsg += "<p>" + $translate.instant("upload-photos-too-large") + "</p>";
					callToActionMsg += ("<p class='upload-photo__validation-popup__call-to-action-msg'>" + $translate.instant("upload-files-smaller-than", {
						value: fileConst.UPLOAD_PHOTO_VALIDATION.PHOTO_SIZE.MAX_FILE_SIZE,
						unit: 'MB'
					}) + "</p>");

				}
				if (key === fileConst.UPLOAD_PHOTO_VALIDATION.ERROR_CODE.INVALID_MAX_RESOLUTION) {
					errMsg += "<p>" + $translate.instant("upload-photos-too-large") + "</p>";
					callToActionMsg += ("<p class='upload-photo__validation-popup__call-to-action-msg'>" + $translate.instant("upload-files-smaller-than", {
						value: fileConst.UPLOAD_PHOTO_VALIDATION.PHOTO_SIZE.MAX_RESOLUTION,
						unit: $translate.instant('megapixels')
					}) + "</p>");
				}
				if (key === fileConst.UPLOAD_PHOTO_VALIDATION.ERROR_CODE.INVALID_MIN_RESOLUTION) {
					errMsg += "<p>" + $translate.instant("upload-photos-too-small") + "</p>";
					callToActionMsg += ("<p class='upload-photo__validation-popup__call-to-action-msg'>" + $translate.instant("upload-files-larger-than", {
						value: fileConst.UPLOAD_PHOTO_VALIDATION.PHOTO_SIZE.MIN_RESOLUTION,
						unit: $translate.instant('megapixels')
					}) + "</p>");
				}
				if (key === fileConst.UPLOAD_PHOTO_VALIDATION.ERROR_CODE.FAILED_TO_UPLOAD) {
					errMsg += "<p>" + $translate.instant("upload-photos-failed") + "</p>";
					callToActionMsg += ("<p class='upload-photo__validation-popup__call-to-action-msg'>" + $translate.instant("try-uploading-them-again") + "!</p>");
				}
				errMsg += buildErrorFilename(groupedError[key]);
				errMsg += callToActionMsg;
			}
			pixerfConfirmPopupSvc.showPopup({
				hideCancelBtn: true,
				hideConfirmText: true,
				hideTitle: true,
				message: errMsg,
				windowClass: 'upload-photo__validation-popup',
				okBtnText: 'OK'
			});
			self.errors = [];
		}

		function upload(files, batch) {
			if (self.publishing) return;
			self.publishing = true;
			self.uploadBtnText = 'Uploading...';
			publish(files, batch).$promise.then(function (res) {
				$timeout(function () {
					console.log(res);
					self.publishing = false;
					self.uploadBtnText = 'Upload';
					$uibModalInstance.dismiss();
					if (self.popupData.files && self.popupData.files.hires) {
						self.shoot.stats.uploaded_hires_count += files.length;
						$scope.$emit('loadedDetailsDeliveriedShoot', self.shoot)
					} else {
						self.shoot.stats.uploaded_lowres_count += files.length;
						$scope.$emit('loadedDetailsShoot', self.shoot)
					}
				}, 2000);
			}).catch(function (error) {
				var exception = error.data.data || error.data;
				Sentry.captureException(exception);
				self.uploadBtnText = 'Upload';
				self.publishing = false;
				var errorMsg = translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true);
				toastr.error(errorMsg);
			})
		}

		function publish(files, batch) {
			var savedData = buildSavedFilesData(files, batch);
			var param = {
				'shoot_id': self.shoot.id
			};

			return pixerfApiCustomCommssionsSvc.uploadToSubmission(param, savedData);
		}

		function buildSavedFilesData(files, batch) {
			var arr = [];
			var obj = {};
			for (var i = 0; i < files.length; i++) {
				arr.push({
					id: files[i].id,
					title: files[i].title
				});
			}
			obj = {
				"medias": arr,
				"note": batch.comment,
				"title": "custom commission batch"
			};
			if (self.popupData.files.hires) {
				obj.is_hires = true;
			}
			return obj;
		}

		function onPublishBtnClicked(files) {
			self.isFormDirty = true;
			self.uploadForm.$setDirty();
			var validToUploadFiles = _.reject(files, function (f) {
				return f.pixerfError;
			})
			if (validToUploadFiles.length === 0) {
				return;
			}
			var errorMsg = '';
			errorMsg = uploadCustomCommissionsPopupSvc.validate(validToUploadFiles);

			if (errorMsg) {
				toastr.error(errorMsg);
				return false;
			}

			upload(validToUploadFiles, self.batch);
		}

		function closeConfirm(uploadPhotoClosingEvent, reason, closed) {
			if (reason && self.uploadedFiles.data.length > 0) {
				uploadPhotoClosingEvent.preventDefault();
				var exitUploadConfirmModal = uploadPhotoSvc.showExitConfirmModal();
				exitUploadConfirmModal.result.then(function () {
					window.removeEventListener("beforeunload", beforeUnloadHandler);
					$uibModalStack.dismissAll();
				}, function () {
					window.removeEventListener("beforeunload", beforeUnloadHandler);
				});
			} else {
				if(self.isCancelUpload){
					deletePhotos(self.uploadedFiles.data);
				}
				window.removeEventListener("beforeunload", beforeUnloadHandler);
				self.uploadModal.data = null;
			}
		}

		function closeUploadModal() {
			self.isCancelUpload = true;
			$uibModalInstance.dismiss("cancel");
		}

		function deletePhotos(photos){
			if(photos && photos.length){
				for(var i = 0; i < photos.length; i++){
					pixerfApiMediaSvc.delete({id: photos[i].id});
				}
			}
		}

		function navigateTo(path) {
			var exitUploadConfirmModal = uploadPhotoSvc.showExitConfirmModal();
			exitUploadConfirmModal.result.then(function () {
				window.removeEventListener("beforeunload", beforeUnloadHandler);
				$uibModalStack.dismissAll();
				$location.path(path);
			}, function () {
				window.removeEventListener("beforeunload", beforeUnloadHandler);
			});
		}

		function reset() {
			self.dropzoneConfig.instance.removeAllFiles();
			self.dropzoneConfigSmall.instance.removeAllFiles();
			uploadPhotoSvc.reset();
		}

		function uploadErrorHandler(pixerfFileBlob) {
			errorHandlerFn();
			systemUtils.digest($scope);
		}

		function removeSelectedPhotos(photos) {
			if (photos.length === self.uploadedFiles.data.length) {
				var modal = pixerfConfirmPopupSvc.showPopup({
					message: 'Hi, All photos will be removed.'
				});
				modal.result.then(function () {
					self.reset();
				});
			} else {
				for (var i = 0; i < photos.length; i++) {
					uploadPhotoSvc.removeFileByName(photos[i].name);
				}
			}
		}

		function rotatePhoto(file) {
			if (!file.rotate_by) file.rotate_by = 0;
			file.rotate_by += 90;
			if (file.rotate_by === 360) {
				file.rotate_by = 0;
			}
		}

	}
})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.factory('uploadCoverPopupSvc', uploadCoverPopupSvc);

	uploadCoverPopupSvc.$inject = ['$uibModal'];

	function uploadCoverPopupSvc($uibModal) {

		function showPopup(popupData) {

			return $uibModal.open({
				size: 'lg',
				openedClass: 'upload-cover-popup',
				templateUrl: 'app/components/upload-cover-popup/upload-cover-popup.html',
				controller: 'uploadCoverPopupCtrl',
				windowClass: 'upload-cover-popup__wrapper',
				controllerAs: 'vm',
				resolve: {
					popupData: function () {
						return popupData;
					}
				}
			});
		}

		return {
			showPopup: showPopup
		};
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('uploadCoverPopupCtrl', uploadCoverPopupCtrl);

	uploadCoverPopupCtrl.$inject = ['uploadPhotoSvc', '$scope', 'sessionManagerSvc', '$uibModalInstance', 'toastr', 'popupData', 'systemUtils', 'imageUtils'];

	function uploadCoverPopupCtrl(uploadPhotoSvc, $scope, sessionManagerSvc, $uibModalInstance, toastr, popupData, systemUtils, imageUtils) {

		var self = this;
		self.popupData = popupData;
		self.showMessage = true;
		self.uploading = false;
		self.canceling = false;
		self.loginedUser = sessionManagerSvc.getCurrentLoginUser().data;

		$scope.$on('modal.closing', function (uploadPhotoClosingEvent) {
			if (self.uploading) {
				self.cancelConfirmResult = confirm('Hang on, your cover photo has not been uploaded yet. Are you sure you want to cancel?');
				uploadPhotoClosingEvent.preventDefault();
				if (self.cancelConfirmResult) {
					self.dropzoneConfig.instance.removeAllFiles(true);
				}
			}
		});

		self.cropper = $.extend(true, {
			instance: null,
			options: {
				viewport: {
					width: 500,
					height: 160,
					type: 'square'
				}
			}
		}, self.popupData.cropper);

		self.dropzoneConfig = $.extend(true, {
			'instance': {},
			'options': {
				url: null,
				maxFiles: 1,
				paramName: 'media',
				autoProcessQueue: false,
				thumbnailHeight: null,
				thumbnailWidth: null,
				createImageThumbnails: false,
				dictRemoveFile: "Remove photo",
				previewsContainer: '.upload-cover-popup__previews',
				clickable: '.upload-cover-popup__upload',
				method: "post",
				headers: {
					"Authorization": "Bearer " + sessionManagerSvc.getToken()
				},
				accept: function (file, done) {
					var errMsg = fileTypeValidation(file);
					done(errMsg);
				}
			},
			'eventHandlers': {
				'success': function (file, response) {
					self.uploading = false;
					if (self.canceling) return;
					if (self.popupData.onSuccess) {
						self.popupData.onSuccess(file, response);
					}
					$uibModalInstance.close(response.handle);
					systemUtils.digest($scope);
				},
				'error': function (file, err) {
					self.uploading = false;
					self.showMessage = true;
					self.isGeneratingThumbnail = false;
					toastr.error(err);
					self.dropzoneConfig.instance.removeAllFiles();
					systemUtils.digest($scope);
				},
				'canceled': function (file) {
					self.uploading = false;
					this.removeAllFiles();
					$uibModalInstance.dismiss();
				},
				'addedfile': function (file) {
					self.showMessage = false;
					if (this.files.length > 1) {
						this.removeFile(this.files[0]);
					}
					self.isGeneratingThumbnail = true;
					if (!uploadPhotoSvc.isExceedMaxSize(file, self.dropzoneConfig.options.maxFilesize * 1024 * 1024) && !fileTypeValidation(file)) {
						imageUtils.customDropzoneThumbnail(file, this);
					}
					systemUtils.digest($scope);
				},
				'thumbnail': function (file, dataUrl) {
					if (file.isCropped) return false;
					self.isGeneratingThumbnail = false;
					file.thumbnail = dataUrl;
					$scope.$apply();
					return true;

				}
			}
		}, self.popupData.dropzoneConfig);

		self.cancel = function () {
			$uibModalInstance.dismiss();
		};

		self.upload = function () {
			if (self.dropzoneConfig.instance.getAcceptedFiles().length === 0) {
				toastr.error("You have not selected any photo to upload.");
				return;
			}
			self.uploading = true;
			if (self.cropper) {
				self.cropper.instance.croppie('result', {
					type: 'blob', size: 'original', format:'jpeg'
				}).then(function (croppedBlobFile) {
					self.dropzoneConfig.instance.removeAllFiles();
					croppedBlobFile.isCropped = true;
					self.dropzoneConfig.instance.addFile(croppedBlobFile);
					if (self.popupData.isManual) {
						self.uploading = false;
						self.dropzoneConfig.instance.on("thumbnail", function (file, thumbnail) {
							$uibModalInstance.close({
								dropzone: self.dropzoneConfig.instance,
								thumbnail: thumbnail
							});
						});
					} else {
						self.dropzoneConfig.instance.processQueue();
					}
				});
			} else if (self.popupData.isManual) {
				self.uploading = false;
				$uibModalInstance.close({
					dropzone: self.dropzoneConfig.instance,
					thumbnail: self.dropzoneConfig.instance.files[0].thumbnail
				});
			} else {
				self.dropzoneConfig.instance.processQueue();
			}
		};

		self.reset = function () {
			self.dropzoneConfig.instance.removeAllFiles();
		};

		function fileTypeValidation(file) {
			if (file.type !== "image/jpeg" &&
				file.type !== "image/png") {
				return "Sorry, we only accept JPEG or PNG file.";
			}
		}

	}
})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.factory('uploadCommunityEventPhotoSvc', uploadCommunityEventPhotoSvc);
		uploadCommunityEventPhotoSvc.$inject = ['toastr', 'arrayUtils', 'numberUtils', '$window', '$q', 'resendVerificationEmailPopupSvc', 'editProfileSvc', 'agreementPopupSvc', 'sessionManagerSvc', 'googleAnalyticSvc', 'pixerfApiMediaSvc', '$uibModal', 'fileUtils', 'translationSvc'];

	function uploadCommunityEventPhotoSvc(toastr, arrayUtils, numberUtils, $window, $q, resendVerificationEmailPopupSvc, editProfileSvc, agreementPopupSvc, sessionManagerSvc, googleAnalyticSvc, pixerfApiMediaSvc, $uibModal, fileUtils, translationSvc) {

		var mFiles = {
			data: []
		};
		var mAddedBufferFiles = {
			data: []
		};
		var mSelectedFiles = {
			data: []
		};

		var isFullscreenDropzone = {
			data: false
		};

		var mOverlay = {
			data: false
		};
		var mUploadModal = {
			data: null
		};

		var dragPhotoEvent = {

			over: function (overlay) {
				if (!mUploadModal.data) return;
				isFullscreenDropzone.data = true;
			},
			leave: function (overlay) {
				isFullscreenDropzone.data = false;
			}
		};

		function setOverlay(status) {
			mOverlay.data.visible = status;
		}

		function getUploadModal() {
			return mUploadModal;
		}

		function getSelectedFiles() {
			return mSelectedFiles;
		}

		function showPopup(data) {

			googleAnalyticSvc.trackPageView("Upload Community Album Photo");
			return mUploadModal.data = $uibModal.open({
				size: 'full',
				templateUrl: 'app/components/upload-community-event-photo/upload-community-event-photo.html',
				controller: 'uploadCommunityEventPhotoCtrl',
				controllerAs: 'vm',
				openedClass: 'upload-community-event-photo-modal',
				resolve: {
					popupData: function () {
						var def = $q.defer();
						def.resolve(data);
						return def.promise;
					}
				}
			});
		}

		function runFakeProgress(file) {

			file.fakeProgressInterval = $window.setInterval(function () {
				if (file.upload.progress >= 99) {
					$window.clearInterval(file.fakeProgressInterval);
					delete file.fakeProgressInterval;
					return;
				}
				var leftleft = 99 - file.upload.progress;
				var step = numberUtils.getRandomInRange(1, leftleft);
				var progress = step + file.upload.progress;
				updateProgress(file, progress);
			}, 1000);

		}

		function showUploadModal(data) {
			var loginUser = sessionManagerSvc.getCurrentLoginUser().data;
			if (loginUser.is_email_verified) {
				if (!loginUser.is_contributor_agreement_accepted) {
					var modal = agreementPopupSvc.showPopup({
						windowClass: 'agree-terms-popup',
						message: 'I agree to the <a ui-sref="introduction-company.terms" target="_blank" class="text--bold text--color-pixerf-theme">Terms</a>',
						okFn: function (isAgree, isWorking) {
							var def = $q.defer();
							loginUser = sessionManagerSvc.getCurrentLoginUser().data;
							loginUser.is_contributor_agreement_accepted = true;
							sessionManagerSvc.setCurrentLoginUser(loginUser);
							editProfileSvc.updateUser(loginUser).then(function () {
								modal.close();
								def.resolve(showPopup(data));
							}, function () {
								toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
								def.reject();
							});
							return def.promise;
						}
					})
				} else {
					return  showPopup(data);
				}
			} else {
				resendVerificationEmailPopupSvc.showVerifyEmailPopup();
			}

		}

		function showExitConfirmModal(callbackFn) {
			var exitUploadConfirmModal = $uibModal.open({
				size: 'small',
				templateUrl: 'app/components/upload-photo-exit-confirm/upload-photo-exit-confirm.html',
				controller: 'uploadPhotoExitConfirmCtrl',
				controllerAs: 'vm',
				openedClass: 'confirm-exit-popup'
			});
			return exitUploadConfirmModal;
		}

		function getuploadPortfolioPhotoSvc() {
			return mFiles;
		}

		function updateProgress(file, progress) {
			var updatingFile = _.find(mFiles.data, function (itFile) {
				return itFile.name === file.name;
			})
			if (updatingFile) {
				updatingFile.upload.progress = progress;
			}
		}

		function updateThumbnail(file, thumbnail) {
			var updatingFile = _.find(mFiles.data, function (itFile) {
				return itFile.name === file.name;
			})
			if (updatingFile) {
				updatingFile.thumbnail = thumbnail;
			}
		}

		function updateFileInfo(updatingFile, fileInfo) {
			if (updatingFile) {
				updatingFile.key = fileInfo.key;
				updatingFile.username = fileInfo.username;
				updatingFile.inserted_at = fileInfo.inserted_at;
				updatingFile.title = fileInfo.name;
				updatingFile.handle = fileInfo.handle;
			}
		}

		function setThumbnail(files) {
			for (var i = 0; i < files.length; i++) {
				files[i].thumbnail = files.url;
			}
		}

		function removeFileFromSelectedFiles(fileName) {
			mSelectedFiles.data = _.reject(mSelectedFiles.data, function (file) {
				if (file.name === fileName) {
					file.isSelected = false;
					return true;
				}
			});
		}

		function getFileByName(pixerfFile) {
			return _.find(mFiles.data, function (f) {
				return f.name === pixerfFile.name;
			});
		}

		function removeUploadedFile(index) {

			removeFileFromSelectedFiles(mFiles.data[index].name);
			mFiles.data.splice(index, 1);
		}

		function removeFileByName(fileName) {
			removeFileFromSelectedFiles(fileName);
			mFiles.data = _.reject(mFiles.data, function (file) {
				return file.name === fileName;
			})
		}

		function replaceFileByName(fileName, newElement) {
			var index = arrayUtils.indexOf(mFiles.data, function (it) {
				return it.name === fileName;
			});
			mFiles.data[index] = newElement;

		}

		function setSelectedFiles(files, isSelected) {
			for (var i = 0; i < files.length; i++) {
				files[i].isSelected = isSelected;
			}
		}

		function isSameFile(fileOne, fileTwo) {
			return fileOne.name === fileTwo.name &&
				fileOne.size === fileTwo.size;

		}

		function isFileExisted(files, file, isInclusiveErrorFile) {
			var isExisted = _.find(files, function (f) {
				return isInclusiveErrorFile ? isSameFile(f, file) : !f.pixerfError && isSameFile(f, file);
			})
			return isExisted;
		}

		function addFile(file) {
			var isExisted = isFileExisted(mFiles.data, file, true);
			if (isExisted) {
				if (!isExisted.pixerfError) {
					return isExisted;
				} else {
					replaceFileByName(isExisted.name, file);
				}
			} else {
				mFiles.data.unshift(file);
			}
		}

		function getDuplicatedFiles(exisingFiles, willBeAddedFiles) {
			var arr = [];
			for (var i = 0; i < willBeAddedFiles.length; i++) {
				if (isFileExisted(exisingFiles, willBeAddedFiles[i])) {
					arr.push(willBeAddedFiles[i]);
				}
			}
			return arr;
		}

		function addFiles(files) {
			var errMsg;
			for (var i = 0; i < files.length; i++) {
				errMsg = addFile(files[i]);
			}
			return errMsg;
		}

		function selectAllFiles() {
			var selectedFiles = [];
			for (var i = 0; i < mFiles.data.length; i++) {
				var file = mFiles.data[i];
				if (file.upload.progress === 100) {
					file.isSelected = true;
					selectedFiles.push(file);
				}
			}
			mSelectedFiles.data = selectedFiles;
		}

		function deselectAllFiles() {
			for (var i = 0; i < mFiles.data.length; i++) {
				mFiles.data[i].isSelected = false;
			}
			mSelectedFiles.data = [];
		}

		function deSelectFile(file) {
			if (!file.isSelected) return;
			file.isSelected = false;
			mSelectedFiles.data = _.reject(mSelectedFiles.data, function (f) {
				return f.id === file.id;
			})
		}

		function selectFiles(files) {
			for (var i = 0; i < files.length; i++) {
				selectFile(file);
			}
		}

		function selectFile(file) {
			if (!file) return;
			if (file.isSelected) return;
			var isExisted = _.find(mSelectedFiles.data, function (itFile) {
				return itFile.name === file.name;
			})
			if (isExisted) return;
			file.isSelected = true;
			mSelectedFiles.data.push(file);
		}

		function toggleFileSelection(file, isSelected) {
			if (file.upload.progress !== 100) return;
			if (typeof isSelected === 'undefined') {
				isSelected = !file.isSelected;
			}
			if (isSelected) {
				selectFile(file);
			} else {
				deSelectFile(file);
			}
		}

		function onFileClicked(evt, file) {
			if (file.upload.progress !== 100) return;
			if (evt && evt.shiftKey) {
				return;
			} else if (evt && (evt.ctrlKey || evt.metaKey)) {
				toggleFileSelection(file);
			} else {
				for (var i = 0; i < mSelectedFiles.data.length; i++) {
					mSelectedFiles.data[i].isSelected = false;
				}
				file.isSelected = true;
				mSelectedFiles.data = [file];
			}
		}

		function buildSavedFilesData(files) {
			var arr = [];
			for (var i = 0; i < files.length; i++) {
				var file = files[i];
				file.type = 'community_album_photo';
				file.title = file.name;
				arr.push(fileUtils.buildSavedFileObject(file));
			}
			return arr;
		}

		function isValidFileType(file) {
			var fileExtension = fileUtils.getFileExtension(file.name);
			return fileExtension.toLowerCase() === "jpeg" || fileExtension.toLowerCase() === "jpg";
		}

		function isExceedMaxSize(file, maxSize) {
			return file.size > maxSize;
		}

		function isUnderMinSize(file, minSize) {
			return file.size < minSize;
		}

		function isExceedNumberOfUpload(filesWillBeUploaded, limit) {
			var validToUploadFiles = _.reject(mFiles.data, function (f) {
				return f.pixerfError;
			})
			return validToUploadFiles.length + filesWillBeUploaded.length > limit;
		}

		function isBelowMinResolution(file, minRes) {
			var resolution = file.width * file.height;
			return resolution < minRes;
		}

		function isAboveMaxResolution(file, maxRes) {
			var resolution = file.width * file.height;
			return resolution >= maxRes;
		}

		function publish(files) {
			var savedData = buildSavedFilesData(files);
			return pixerfApiMediaSvc.multipleUpdate({
				type: 'community_album_photo',
				'api_version': 'new'
			}, savedData);
		}

		function reset() {
			mFiles.data = [];
			mSelectedFiles.data = [];
		}

		return {
			setOverlay: setOverlay,
			buildSavedFilesData: buildSavedFilesData,
			isFullscreenDropzone: isFullscreenDropzone,
			dragPhotoEvent: dragPhotoEvent,
			getUploadModal: getUploadModal,
			showUploadModal: showUploadModal,
			showExitConfirmModal: showExitConfirmModal,
			getuploadPortfolioPhotoSvc: getuploadPortfolioPhotoSvc,
			updateProgress: updateProgress,
			updateThumbnail: updateThumbnail,
			removeUploadedFile: removeUploadedFile,
			removeFileByName: removeFileByName,
			addFile: addFile,
			addFiles: addFiles,
			isFileExisted: isFileExisted,
			onFileClicked: onFileClicked,
			selectFile: selectFile,
			selectFiles: selectFiles,
			toggleFileSelection: toggleFileSelection,
			selectAllFiles: selectAllFiles,
			getSelectedFiles: getSelectedFiles,
			publish: publish,
			updateFileInfo: updateFileInfo,
			reset: reset,
			setThumbnail: setThumbnail,
			isValidFileType: isValidFileType,
			isBelowMinResolution: isBelowMinResolution,
			isAboveMaxResolution: isAboveMaxResolution,
			isExceedMaxSize: isExceedMaxSize,
			isUnderMinSize: isUnderMinSize,
			deselectAllFiles: deselectAllFiles,
			deSelectFile: deSelectFile,
			getDuplicatedFiles: getDuplicatedFiles,
			isExceedNumberOfUpload: isExceedNumberOfUpload,
			runFakeProgress: runFakeProgress,
			getFileByName: getFileByName,
			isSameFile: isSameFile,

		};
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('uploadCommunityEventPhotoCtrl', uploadCommunityEventPhotoCtrl);

	uploadCommunityEventPhotoCtrl.$inject = ['popupData', 'googleAnalyticSvc', '$uibModalStack', 'uploadCommunityEventPhotoSvc', '$scope', 'toastr', 'sessionManagerSvc', 'systemUtils', '$uibModalInstance', 'pixerfUrl', '$uibModal', 'uploadPortfolioPhotoDetailSvc', '$location', 'pixerfApiCommunitySvc', '$timeout', 'filePickerSvc', 'fileUtils', 'pixerfConfirmPopupSvc', '$q', 'pixerfApiMediaSvc', 'imageUtils', 'portfolioConst', '$translate', 'translationSvc'];

	function uploadCommunityEventPhotoCtrl(popupData, googleAnalyticSvc, $uibModalStack, uploadCommunityEventPhotoSvc, $scope, toastr, sessionManagerSvc, systemUtils, $uibModalInstance, pixerfUrl, $uibModal, uploadPortfolioPhotoDetailSvc, $location, pixerfApiCommunitySvc, $timeout, filePickerSvc, fileUtils, pixerfConfirmPopupSvc, $q, pixerfApiMediaSvc, imageUtils, portfolioConst, $translate, translationSvc) {

		var self = this;

		self.spinner = {isVisible: true};
		uploadCommunityEventPhotoSvc.reset();
		self.loginUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.uploadedFiles = uploadCommunityEventPhotoSvc.getuploadPortfolioPhotoSvc();
		self.removeUploadedFile = removeUploadedFile;
		self.onFileClicked = uploadCommunityEventPhotoSvc.onFileClicked;
		self.toggleFileSelection = uploadCommunityEventPhotoSvc.toggleFileSelection;
		self.selectAllFiles = uploadCommunityEventPhotoSvc.selectAllFiles;
		self.selectedFiles = uploadCommunityEventPhotoSvc.getSelectedFiles();
		self.onPublishBtnClicked = onPublishBtnClicked;
		self.reset = reset;
		self.closeUploadModal = closeUploadModal;
		self.uploadModal = uploadCommunityEventPhotoSvc.getUploadModal();
		self.isFullscreenDropzone = uploadCommunityEventPhotoSvc.isFullscreenDropzone;
		self.showFilePickerPopup = showFilePickerPopup;
		self.selection = {};
		self.pixerfAlert = {};
		self.removeSelectedPhotos = removeSelectedPhotos;
		self.publishing = false;
		self.dragCounter = 0;
		self.numProcessingFile = 0;
		self.updateMasterFile = updateMasterFile;
		self.errors = [];
		self.eventId = popupData.eventId;
		self.maxPhotoPerAlbum = 100;
		self.isCancelUpload = false;
		var errorHandlerFn = _.debounce(errorHandler, 1000);

		function removeUploadedFile(index){
			var files = uploadCommunityEventPhotoSvc.getuploadPortfolioPhotoSvc();
			var willBeDeleted = _.find(self.dropzoneConfig.instance.files, function(file){
				return file.name === files.data[index].name;
			});
			if(willBeDeleted) self.dropzoneConfig.instance.removeFile(willBeDeleted);
			uploadCommunityEventPhotoSvc.removeUploadedFile(index);
		}

		function beforeUnloadHandler(event) {
			if (self.uploadedFiles.data.length > 0) {
				var confirmationMessage = $translate.instant("are-you-sure");
				event.returnValue = confirmationMessage; // Gecko, Trident, Chrome 34+
				return confirmationMessage;
			}
		}
		window.addEventListener("beforeunload", beforeUnloadHandler);
		var mFileStackSocaialHandler = {
			onSuccess: function (responsedFiles) {
				var promises = [];
				if (!Array.isArray(responsedFiles)) {
					responsedFiles = [responsedFiles];
				}
				uploadCommunityEventPhotoSvc.deselectAllFiles();
				$q.all(promises).then(function () {
					errorHandlerFn(self.errors);
				})
			},
			onError: function (filesFailed) {
				for (var i = 0; i < filesFailed.length; i++) {
					setErrors({
						code: portfolioConst.UPLOAD_PHOTO_VALIDATION.ERROR_CODE.FAILED_TO_UPLOAD,
						file: filesFailed[i]
					});
				}
				errorHandlerFn(self.errors);
			}
		};
		self.dropzoneConfig = {
			'methods': {},
			'instance': {},
			'options': {
				url: pixerfUrl.full + 'api/community_events/upload_many',
				dictDefaultMessage: '',
				autoProcessQueue: false,
				uploadMultiple: true,
				maxFiles: 100,
				paramName: 'photos[]',
				parallelUploads: 10,
				previewsContainer: '.upload-photo__upload-area__dropzone__main-content__preview',
				method: "post",
				clickable: ".upload-photo__upload-area__dropzone__main-content__browse-btn",
				thumbnailWidth: 300,
				dictRemoveFile: "X",
				addRemoveLinks: true,
				thumbnailHeight: 300,
				headers: {
					"Authorization": "Bearer " + sessionManagerSvc.getToken()
				},
				dictFileTooBig: "Size of this photo is {{filesize}} MB file. The maximum size is {{maxFilesize}} MB",
				createImageThumbnails: false
			},
			'eventHandlers': {
				'sending': function(file, xhr, formData){
                    formData.append('community_event_id', self.eventId);
                },
				thumbnail: function (file, dataUrl) {
					if (!file.pixerfError) {
						uploadCommunityEventPhotoSvc.updateThumbnail(file, dataUrl);
						systemUtils.digest($scope);
					}
				},
				drop: function (file, errMsg) {
					self.isFullscreenDropzone.data = false;
					uploadCommunityEventPhotoSvc.dragPhotoEvent.leave();
					systemUtils.digest($scope);
				},
				dragover: function () {
					self.dragCounter++;
					uploadCommunityEventPhotoSvc.dragPhotoEvent.over();
					systemUtils.digest($scope);
				},
				addedfile: function (file) {
					imageUtils.customDropzoneThumbnail(file, this);
					var error = "";
					if (error) {
						setErrors(error);
						errorHandlerFn();
						this.removeFile(file);
					} else {
						self.numProcessingFile++;
						var pixerfBlob = fileUtils.convertFromFileObject2PixerfBlob(file);
						uploadCommunityEventPhotoSvc.addFile(pixerfBlob);
					}
					systemUtils.digest($scope);
				},
				uploadprogress: function (file, progress) {
					var roundProgress = Math.round(progress);
					if (roundProgress === 100) return;
					// uploadCommunityEventPhotoSvc.updateProgress(file, roundProgress);
					systemUtils.digest($scope);
				},
				success: function (file, responsedFile) {
					self.numProcessingFile--; // done
					var pixerfBlob = _.find(self.uploadedFiles.data, function (f) {
						return f.name === file.name;
					});
					//if uploading prgress is cancelled.
					if (!pixerfBlob) {
						return;
					}
					pixerfBlob.upload.progress = 100;
					pixerfBlob.id = responsedFile.id;
					uploadCommunityEventPhotoSvc.selectFile(pixerfBlob);
					$uibModalInstance.close(responsedFile.handle);
					self.publishing = false
					systemUtils.digest($scope);
				},
				error: function (file, errorResponse) {
					self.numProcessingFile--;
					var pixerfBlob = _.find(self.uploadedFiles.data, function (f) {
						return f.name === file.name;
					});
					if (!pixerfBlob) {
						pixerfBlob = file;
					}
					setErrors({
						code: portfolioConst.UPLOAD_PHOTO_VALIDATION.ERROR_CODE.FAILED_TO_UPLOAD,
						file: pixerfBlob
					});
					self.publishing = false;
					pixerfBlob.upload.progress = 0;
					uploadErrorHandler(pixerfBlob);
					systemUtils.digest($scope);
				}
			}
		};
		self.dropzoneConfigSmall = $.extend(true, {}, self.dropzoneConfig);
		self.dropzoneConfigSmall.options.clickable = ".upload-photo-preview--add-more__dropzone__content__browse-btn--small";
		$scope.$on('modal.closing', closeConfirm);

		function updateMasterFile(file, property) {
			var selectedFile = self.selectedFiles.data[0];
			if (self.selectedFiles.data.length === 1 && self.masterFile && self.masterFile.name === selectedFile.name && file.name === selectedFile.name) {
				uploadPortfolioPhotoDetailSvc.updateMasterFile(self.masterFile, property, file[property]);
			}
		}

		function setErrors(error) {
			var isExisted = _.find(self.errors, function (err) {
				return err.file === error.file;
			})
			if (isExisted) return;
			error.file.pixerfError = error.code;
			self.errors.push(error);
		}

		function buildErrorFilename(files) {
			var errMsg = '';
			for (var i = 0; i < files.length; i++) {
				errMsg += ("<div class='upload-photo__invalid-file text--truncate'> - " + files[i].file.name + "</div>");
			}
			return errMsg;
		}

		function errorHandler(errors) {
			if (!errors) errors = self.errors;
			if (errors.length === 0) return;
			var errMsg = '';
			var callToActionMsg = '';
			var groupedError = _.groupBy(errors, function (item) {
				return item.code;
			});
			for (var key in groupedError) {
				callToActionMsg = '';
				if (key === portfolioConst.UPLOAD_PHOTO_VALIDATION.ERROR_CODE.DUPLICATED) {
					errMsg += "<p>" + $translate.instant("the-following-photos-uploaded-before") + "</p>";
					callToActionMsg += "<p class='upload-photo__validation-popup__call-to-action-msg'>" + $translate.instant("try-uploading-new-ones") + "!</p>";
				}
				if (key === portfolioConst.UPLOAD_PHOTO_VALIDATION.ERROR_CODE.FAILED_TO_UPLOAD) {
					errMsg += "<p>" + $translate.instant("upload-photos-failed") + "</p>";
					callToActionMsg += ("<p class='upload-photo__validation-popup__call-to-action-msg'>" + $translate.instant("try-uploading-them-again") + "!</p>");
				}
				errMsg += buildErrorFilename(groupedError[key]);
				errMsg += callToActionMsg;
			}
			pixerfConfirmPopupSvc.showPopup({
				hideCancelBtn: true,
				hideConfirmText: true,
				hideTitle: true,
				message: errMsg,
				windowClass: 'upload-photo__validation-popup',
				okBtnText: 'OK'
			});
			self.errors = [];
		}

		function upload(files) {
			if(!files.length) return toastr.error("Please select photo!");;
			self.publishing = true;
			self.dropzoneConfig.instance.processQueue();
		}

		function onPublishBtnClicked(files) {
			self.isFormDirty = true;
			var validToUploadFiles = _.reject(files, function (f) {
				return f.pixerfError;
			})
			if (validToUploadFiles.length === 0) {
				return;
			}

			upload(validToUploadFiles);
		}

		function closeConfirm(uploadPhotoClosingEvent, reason, closed) {
			if (reason && self.uploadedFiles.data.length > 0) {
				uploadPhotoClosingEvent.preventDefault();
				var exitUploadConfirmModal = uploadCommunityEventPhotoSvc.showExitConfirmModal();
				exitUploadConfirmModal.result.then(function () {
					window.removeEventListener("beforeunload", beforeUnloadHandler);
					$uibModalStack.dismissAll();
				}, function () {
					window.removeEventListener("beforeunload", beforeUnloadHandler);
				});
			} else {
				if(self.isCancelUpload){
					deletePhotos(self.uploadedFiles.data);
				}
				window.removeEventListener("beforeunload", beforeUnloadHandler);
				self.uploadModal.data = null;
			}
		}

		function navigate(path) {
			uibModalInstance.dismiss("cancel")
		}

		function closeUploadModal() {
			self.isCancelUpload = true;
			$uibModalInstance.dismiss("cancel");
		}

		function deletePhotos(photos){
			if(photos && photos.length){
				for(var i = 0; i < photos.length; i++){
					pixerfApiMediaSvc.delete({id: photos[i].id});
				}
			}
		}

		function reset() {
			self.dropzoneConfig.instance.removeAllFiles();
			self.dropzoneConfigSmall.instance.removeAllFiles();
			uploadCommunityEventPhotoSvc.reset();

		}

		function uploadErrorHandler(pixerfFileBlob) {
			errorHandlerFn();
			systemUtils.digest($scope);
		}

		function convertToPixerfFile(pixerfFileBlob, filestackBlob) {
			fileUtils.fromFilestackBlob2PixerfBlob(pixerfFileBlob, filestackBlob);
			pixerfFileBlob.title = fileUtils.getFileNameWithoutExtension(pixerfFileBlob.name);
		}

		function convertToPixerfFiles(pixerfFileBlobs, filestackBlobs) {
			var length = Math.min(pixerfFileBlobs.length, filestackBlobs.length);
			for (var i = 0; i < length; i++) {
				(function (index) {
					var pixerfFileBlob = pixerfFileBlobs[index];
					var filestackBlob = filestackBlobs[index];
					convertToPixerfFile(pixerfFileBlob, filestackBlob);
				})(i)
			}
		}

		function showFilePickerPopup(defaultService) {
			googleAnalyticSvc.trackPageView("Upload Photo - Social - " + defaultService);
			filePickerSvc.pickMultiple({
				callbacks: mFileStackSocaialHandler,
				defaultService: defaultService
			});
		}

		function removeSelectedPhotos(photos) {
			if (photos.length === self.uploadedFiles.data.length) {
				var modal = pixerfConfirmPopupSvc.showPopup({
					message: 'Hi, All photos will be removed.'
				});
				modal.result.then(function () {
					self.reset();
				});
			} else {

				for (var i = 0; i < photos.length; i++) {
					uploadCommunityEventPhotoSvc.removeFileByName(photos[i].name);
				}
			}
		}

	}
})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.factory('uploadCommunityAlbumPhotoSvc', uploadCommunityAlbumPhotoSvc);
		uploadCommunityAlbumPhotoSvc.$inject = ['toastr', 'arrayUtils', 'numberUtils', '$window', '$q', 'resendVerificationEmailPopupSvc', 'editProfileSvc', 'agreementPopupSvc', 'sessionManagerSvc', 'googleAnalyticSvc', 'pixerfApiMediaSvc', '$uibModal', 'fileUtils', 'translationSvc'];

	function uploadCommunityAlbumPhotoSvc(toastr, arrayUtils, numberUtils, $window, $q, resendVerificationEmailPopupSvc, editProfileSvc, agreementPopupSvc, sessionManagerSvc, googleAnalyticSvc, pixerfApiMediaSvc, $uibModal, fileUtils, translationSvc) {

		var mFiles = {
			data: []
		};
		var mAddedBufferFiles = {
			data: []
		};
		var mSelectedFiles = {
			data: []
		};

		var isFullscreenDropzone = {
			data: false
		};

		var mOverlay = {
			data: false
		};
		var mUploadModal = {
			data: null
		};

		var dragPhotoEvent = {

			over: function (overlay) {
				if (!mUploadModal.data) return;
				isFullscreenDropzone.data = true;
			},
			leave: function (overlay) {
				isFullscreenDropzone.data = false;
			}
		};

		function setOverlay(status) {
			mOverlay.data.visible = status;
		}

		function getUploadModal() {
			return mUploadModal;
		}

		function getSelectedFiles() {
			return mSelectedFiles;
		}

		function showPopup(data) {

			googleAnalyticSvc.trackPageView("Upload Community Album Photo");
			return mUploadModal.data = $uibModal.open({
				size: 'full',
				templateUrl: 'app/components/upload-community-album-photo/upload-community-album-photo.html',
				controller: 'uploadCommunityAlbumPhotoCtrl',
				controllerAs: 'vm',
				openedClass: 'upload-community-album-photo-modal',
				resolve: {
					popupData: function () {
						var def = $q.defer();
						def.resolve(data);
						return def.promise;
					}
				}
			});
		}

		function runFakeProgress(file) {

			file.fakeProgressInterval = $window.setInterval(function () {
				if (file.upload.progress >= 99) {
					$window.clearInterval(file.fakeProgressInterval);
					delete file.fakeProgressInterval;
					return;
				}
				var leftleft = 99 - file.upload.progress;
				var step = numberUtils.getRandomInRange(1, leftleft);
				var progress = step + file.upload.progress;
				updateProgress(file, progress);
			}, 1000);

		}

		function showUploadModal(data) {
			var loginUser = sessionManagerSvc.getCurrentLoginUser().data;
			if (loginUser.is_email_verified) {
				if (!loginUser.is_contributor_agreement_accepted) {
					var modal = agreementPopupSvc.showPopup({
						windowClass: 'agree-terms-popup',
						message: 'I agree to the <a ui-sref="introduction-company.terms" target="_blank" class="text--bold text--color-pixerf-theme">Terms</a>',
						okFn: function (isAgree, isWorking) {
							var def = $q.defer();
							loginUser = sessionManagerSvc.getCurrentLoginUser().data;
							loginUser.is_contributor_agreement_accepted = true;
							sessionManagerSvc.setCurrentLoginUser(loginUser);
							editProfileSvc.updateUser(loginUser).then(function () {
								modal.close();
								def.resolve(showPopup(data));
							}, function () {
								toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
								def.reject();
							});
							return def.promise;
						}
					})
				} else {
					return  showPopup(data);
				}
			} else {
				resendVerificationEmailPopupSvc.showVerifyEmailPopup();
			}

		}

		function showExitConfirmModal(callbackFn) {
			var exitUploadConfirmModal = $uibModal.open({
				size: 'small',
				templateUrl: 'app/components/upload-photo-exit-confirm/upload-photo-exit-confirm.html',
				controller: 'uploadPhotoExitConfirmCtrl',
				controllerAs: 'vm',
				openedClass: 'confirm-exit-popup'
			});
			return exitUploadConfirmModal;
		}

		function getuploadPortfolioPhotoSvc() {
			return mFiles;
		}

		function updateProgress(file, progress) {
			var updatingFile = _.find(mFiles.data, function (itFile) {
				return itFile.name === file.name;
			})
			if (updatingFile) {
				updatingFile.upload.progress = progress;
			}
		}

		function updateThumbnail(file, thumbnail) {
			var updatingFile = _.find(mFiles.data, function (itFile) {
				return itFile.name === file.name;
			})
			if (updatingFile) {
				updatingFile.thumbnail = thumbnail;
			}
		}

		function updateFileInfo(updatingFile, fileInfo) {
			if (updatingFile) {
				updatingFile.key = fileInfo.key;
				updatingFile.username = fileInfo.username;
				updatingFile.inserted_at = fileInfo.inserted_at;
				updatingFile.title = fileInfo.name;
				updatingFile.handle = fileInfo.handle;
			}
		}

		function setThumbnail(files) {
			for (var i = 0; i < files.length; i++) {
				files[i].thumbnail = files.url;
			}
		}

		function removeFileFromSelectedFiles(fileName) {
			mSelectedFiles.data = _.reject(mSelectedFiles.data, function (file) {
				if (file.name === fileName) {
					file.isSelected = false;
					return true;
				}
			});
		}

		function getFileByName(pixerfFile) {
			return _.find(mFiles.data, function (f) {
				return f.name === pixerfFile.name;
			});
		}

		function removeUploadedFile(index) {

			removeFileFromSelectedFiles(mFiles.data[index].name);
			mFiles.data.splice(index, 1);
		}

		function removeFileByName(fileName) {
			removeFileFromSelectedFiles(fileName);
			mFiles.data = _.reject(mFiles.data, function (file) {
				return file.name === fileName;
			})
		}

		function replaceFileByName(fileName, newElement) {
			var index = arrayUtils.indexOf(mFiles.data, function (it) {
				return it.name === fileName;
			});
			mFiles.data[index] = newElement;

		}

		function setSelectedFiles(files, isSelected) {
			for (var i = 0; i < files.length; i++) {
				files[i].isSelected = isSelected;
			}
		}

		function isSameFile(fileOne, fileTwo) {
			return fileOne.name === fileTwo.name &&
				fileOne.size === fileTwo.size;

		}

		function isFileExisted(files, file, isInclusiveErrorFile) {
			var isExisted = _.find(files, function (f) {
				return isInclusiveErrorFile ? isSameFile(f, file) : !f.pixerfError && isSameFile(f, file);
			})
			return isExisted;
		}

		function addFile(file) {
			var isExisted = isFileExisted(mFiles.data, file, true);
			if (isExisted) {
				if (!isExisted.pixerfError) {
					return isExisted;
				} else {
					replaceFileByName(isExisted.name, file);
				}
			} else {
				mFiles.data.unshift(file);
			}
		}

		function getDuplicatedFiles(exisingFiles, willBeAddedFiles) {
			var arr = [];
			for (var i = 0; i < willBeAddedFiles.length; i++) {
				if (isFileExisted(exisingFiles, willBeAddedFiles[i])) {
					arr.push(willBeAddedFiles[i]);
				}
			}
			return arr;
		}

		function addFiles(files) {
			var errMsg;
			for (var i = 0; i < files.length; i++) {
				errMsg = addFile(files[i]);
			}
			return errMsg;
		}

		function selectAllFiles() {
			var selectedFiles = [];
			for (var i = 0; i < mFiles.data.length; i++) {
				var file = mFiles.data[i];
				if (file.upload.progress === 100) {
					file.isSelected = true;
					selectedFiles.push(file);
				}
			}
			mSelectedFiles.data = selectedFiles;
		}

		function deselectAllFiles() {
			for (var i = 0; i < mFiles.data.length; i++) {
				mFiles.data[i].isSelected = false;
			}
			mSelectedFiles.data = [];
		}

		function deSelectFile(file) {
			if (!file.isSelected) return;
			file.isSelected = false;
			mSelectedFiles.data = _.reject(mSelectedFiles.data, function (f) {
				return f.id === file.id;
			})
		}

		function selectFiles(files) {
			for (var i = 0; i < files.length; i++) {
				selectFile(file);
			}
		}

		function selectFile(file) {
			if (!file) return;
			if (file.isSelected) return;
			var isExisted = _.find(mSelectedFiles.data, function (itFile) {
				return itFile.name === file.name;
			})
			if (isExisted) return;
			file.isSelected = true;
			mSelectedFiles.data.push(file);
		}

		function toggleFileSelection(file, isSelected) {
			if (file.upload.progress !== 100) return;
			if (typeof isSelected === 'undefined') {
				isSelected = !file.isSelected;
			}
			if (isSelected) {
				selectFile(file);
			} else {
				deSelectFile(file);
			}
		}

		function onFileClicked(evt, file) {
			if (file.upload.progress !== 100) return;
			if (evt && evt.shiftKey) {
				return;
			} else if (evt && (evt.ctrlKey || evt.metaKey)) {
				toggleFileSelection(file);
			} else {
				for (var i = 0; i < mSelectedFiles.data.length; i++) {
					mSelectedFiles.data[i].isSelected = false;
				}
				file.isSelected = true;
				mSelectedFiles.data = [file];
			}
		}

		function buildSavedFilesData(files) {
			var arr = [];
			for (var i = 0; i < files.length; i++) {
				var file = files[i];
				file.type = 'community_album_photo';
				file.title = file.name;
				arr.push(fileUtils.buildSavedFileObject(file));
			}
			return arr;
		}

		function isValidFileType(file) {
			var fileExtension = fileUtils.getFileExtension(file.name);
			return fileExtension.toLowerCase() === "jpeg" || fileExtension.toLowerCase() === "jpg";
		}

		function isExceedMaxSize(file, maxSize) {
			return file.size > maxSize;
		}

		function isUnderMinSize(file, minSize) {
			return file.size < minSize;
		}

		function isExceedNumberOfUpload(filesWillBeUploaded, limit) {
			var validToUploadFiles = _.reject(mFiles.data, function (f) {
				return f.pixerfError;
			})
			return validToUploadFiles.length + filesWillBeUploaded.length > limit;
		}

		function isBelowMinResolution(file, minRes) {
			var resolution = file.width * file.height;
			return resolution < minRes;
		}

		function isAboveMaxResolution(file, maxRes) {
			var resolution = file.width * file.height;
			return resolution >= maxRes;
		}

		function publish(files) {
			var savedData = buildSavedFilesData(files);
			return pixerfApiMediaSvc.multipleUpdate({
				type: 'community_album_photo',
				'api_version': 'new'
			}, savedData);
		}

		function reset() {
			mFiles.data = [];
			mSelectedFiles.data = [];
		}

		return {
			setOverlay: setOverlay,
			buildSavedFilesData: buildSavedFilesData,
			isFullscreenDropzone: isFullscreenDropzone,
			dragPhotoEvent: dragPhotoEvent,
			getUploadModal: getUploadModal,
			showUploadModal: showUploadModal,
			showExitConfirmModal: showExitConfirmModal,
			getuploadPortfolioPhotoSvc: getuploadPortfolioPhotoSvc,
			updateProgress: updateProgress,
			updateThumbnail: updateThumbnail,
			removeUploadedFile: removeUploadedFile,
			removeFileByName: removeFileByName,
			addFile: addFile,
			addFiles: addFiles,
			isFileExisted: isFileExisted,
			onFileClicked: onFileClicked,
			selectFile: selectFile,
			selectFiles: selectFiles,
			toggleFileSelection: toggleFileSelection,
			selectAllFiles: selectAllFiles,
			getSelectedFiles: getSelectedFiles,
			publish: publish,
			updateFileInfo: updateFileInfo,
			reset: reset,
			setThumbnail: setThumbnail,
			isValidFileType: isValidFileType,
			isBelowMinResolution: isBelowMinResolution,
			isAboveMaxResolution: isAboveMaxResolution,
			isExceedMaxSize: isExceedMaxSize,
			isUnderMinSize: isUnderMinSize,
			deselectAllFiles: deselectAllFiles,
			deSelectFile: deSelectFile,
			getDuplicatedFiles: getDuplicatedFiles,
			isExceedNumberOfUpload: isExceedNumberOfUpload,
			runFakeProgress: runFakeProgress,
			getFileByName: getFileByName,
			isSameFile: isSameFile,

		};
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('uploadCommunityAlbumPhotoCtrl', uploadCommunityAlbumPhotoCtrl);

	uploadCommunityAlbumPhotoCtrl.$inject = ['popupData', 'googleAnalyticSvc', '$uibModalStack', 'uploadCommunityAlbumPhotoSvc', '$scope', 'toastr', 'sessionManagerSvc', 'systemUtils', '$uibModalInstance', 'pixerfUrl', '$uibModal', 'uploadPortfolioPhotoDetailSvc', '$location', 'pixerfApiCommunitySvc', '$timeout', 'filePickerSvc', 'fileUtils', 'pixerfConfirmPopupSvc', '$q', 'pixerfApiMediaSvc', 'imageUtils', 'portfolioConst', '$translate', 'translationSvc'];

	function uploadCommunityAlbumPhotoCtrl(popupData, googleAnalyticSvc, $uibModalStack, uploadCommunityAlbumPhotoSvc, $scope, toastr, sessionManagerSvc, systemUtils, $uibModalInstance, pixerfUrl, $uibModal, uploadPortfolioPhotoDetailSvc, $location, pixerfApiCommunitySvc, $timeout, filePickerSvc, fileUtils, pixerfConfirmPopupSvc, $q, pixerfApiMediaSvc, imageUtils, portfolioConst, $translate, translationSvc) {

		var self = this;

		self.spinner = {isVisible: true};
		uploadCommunityAlbumPhotoSvc.reset();
		self.loginUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.uploadedFiles = uploadCommunityAlbumPhotoSvc.getuploadPortfolioPhotoSvc();
		self.removeUploadedFile = removeUploadedFile;
		self.onFileClicked = uploadCommunityAlbumPhotoSvc.onFileClicked;
		self.toggleFileSelection = uploadCommunityAlbumPhotoSvc.toggleFileSelection;
		self.selectAllFiles = uploadCommunityAlbumPhotoSvc.selectAllFiles;
		self.selectedFiles = uploadCommunityAlbumPhotoSvc.getSelectedFiles();
		self.onPublishBtnClicked = onPublishBtnClicked;
		self.reset = reset;
		self.closeUploadModal = closeUploadModal;
		self.uploadModal = uploadCommunityAlbumPhotoSvc.getUploadModal();
		self.isFullscreenDropzone = uploadCommunityAlbumPhotoSvc.isFullscreenDropzone;
		self.showFilePickerPopup = showFilePickerPopup;
		self.selection = {};
		self.pixerfAlert = {};
		self.removeSelectedPhotos = removeSelectedPhotos;
		self.publishing = false;
		self.dragCounter = 0;
		self.numProcessingFile = 0;
		self.updateMasterFile = updateMasterFile;
		self.errors = [];
		self.albumId = popupData.albumId;
		self.isCancelUpload = false;
		var errorHandlerFn = _.debounce(errorHandler, 1000);

		function removeUploadedFile(index){
			var files = uploadCommunityAlbumPhotoSvc.getuploadPortfolioPhotoSvc();
			var willBeDeleted = _.find(self.dropzoneConfig.instance.files, function(file){
				return file.name === files.data[index].name;
			});
			if(willBeDeleted) self.dropzoneConfig.instance.removeFile(willBeDeleted);
			uploadCommunityAlbumPhotoSvc.removeUploadedFile(index);
		}

		function beforeUnloadHandler(event) {
			if (self.uploadedFiles.data.length > 0) {
				var confirmationMessage = $translate.instant("are-you-sure");
				event.returnValue = confirmationMessage; // Gecko, Trident, Chrome 34+
				return confirmationMessage;
			}
		}
		window.addEventListener("beforeunload", beforeUnloadHandler);
		var mFileStackSocaialHandler = {
			onSuccess: function (responsedFiles) {
				var promises = [];
				if (!Array.isArray(responsedFiles)) {
					responsedFiles = [responsedFiles];
				}
				uploadCommunityAlbumPhotoSvc.deselectAllFiles();
				$q.all(promises).then(function () {
					errorHandlerFn(self.errors);
				})
			},
			onError: function (filesFailed) {
				for (var i = 0; i < filesFailed.length; i++) {
					setErrors({
						code: portfolioConst.UPLOAD_PHOTO_VALIDATION.ERROR_CODE.FAILED_TO_UPLOAD,
						file: filesFailed[i]
					});
				}
				errorHandlerFn(self.errors);
			}
		};
		self.dropzoneConfig = {
			'methods': {},
			'instance': {},
			'options': {
				url: pixerfUrl.full + 'api/community_albums/' + self.albumId+ '/photos/create_many',
				dictDefaultMessage: '',
				autoProcessQueue: false,
				uploadMultiple: true,
				maxFiles: 100,
				paramName: 'photos[]',
				parallelUploads: 10,
				previewsContainer: '.upload-photo__upload-area__dropzone__main-content__preview',
				method: "post",
				clickable: ".upload-photo__upload-area__dropzone__main-content__browse-btn",
				thumbnailWidth: 300,
				dictRemoveFile: "X",
				addRemoveLinks: true,
				thumbnailHeight: 300,
				headers: {
					"Authorization": "Bearer " + sessionManagerSvc.getToken()
				},
				dictFileTooBig: "Size of this photo is {{filesize}} MB file. The maximum size is {{maxFilesize}} MB",
				createImageThumbnails: false
			},
			'eventHandlers': {
				thumbnail: function (file, dataUrl) {
					if (!file.pixerfError) {
						uploadCommunityAlbumPhotoSvc.updateThumbnail(file, dataUrl);
						systemUtils.digest($scope);
					}
				},
				drop: function (file, errMsg) {
					self.isFullscreenDropzone.data = false;
					uploadCommunityAlbumPhotoSvc.dragPhotoEvent.leave();
					systemUtils.digest($scope);
				},
				dragover: function () {
					self.dragCounter++;
					uploadCommunityAlbumPhotoSvc.dragPhotoEvent.over();
					systemUtils.digest($scope);
				},
				addedfile: function (file) {
					imageUtils.customDropzoneThumbnail(file, this);
					var error = "";
					if (error) {
						setErrors(error);
						errorHandlerFn();
						this.removeFile(file);
					} else {
						self.numProcessingFile++;
						var pixerfBlob = fileUtils.convertFromFileObject2PixerfBlob(file);
						uploadCommunityAlbumPhotoSvc.addFile(pixerfBlob);
					}
					systemUtils.digest($scope);
				},
				uploadprogress: function (file, progress) {
					var roundProgress = Math.round(progress);
					if (roundProgress === 100) return;
					// uploadCommunityAlbumPhotoSvc.updateProgress(file, roundProgress);
					systemUtils.digest($scope);
				},
				success: function (file, responsedFile) {
					self.numProcessingFile--; // done
					var pixerfBlob = _.find(self.uploadedFiles.data, function (f) {
						return f.name === file.name;
					});
					//if uploading prgress is cancelled.
					if (!pixerfBlob) {
						return;
					}
					pixerfBlob.upload.progress = 100;
					pixerfBlob.id = responsedFile.id;
					uploadCommunityAlbumPhotoSvc.selectFile(pixerfBlob);
					$uibModalInstance.close(responsedFile.handle);
					self.publishing = false
					systemUtils.digest($scope);
				},
				error: function (file, errorResponse) {
					self.numProcessingFile--;
					var pixerfBlob = _.find(self.uploadedFiles.data, function (f) {
						return f.name === file.name;
					});
					if (!pixerfBlob) {
						pixerfBlob = file;
					}
					setErrors({
						code: portfolioConst.UPLOAD_PHOTO_VALIDATION.ERROR_CODE.FAILED_TO_UPLOAD,
						file: pixerfBlob
					});
					self.publishing = false;
					pixerfBlob.upload.progress = 0;
					uploadErrorHandler(pixerfBlob);
					systemUtils.digest($scope);
				}
			}
		};
		self.dropzoneConfigSmall = $.extend(true, {}, self.dropzoneConfig);
		self.dropzoneConfigSmall.options.clickable = ".upload-photo-preview--add-more__dropzone__content__browse-btn--small";
		$scope.$on('modal.closing', closeConfirm);

		function updateMasterFile(file, property) {
			var selectedFile = self.selectedFiles.data[0];
			if (self.selectedFiles.data.length === 1 && self.masterFile && self.masterFile.name === selectedFile.name && file.name === selectedFile.name) {
				uploadPortfolioPhotoDetailSvc.updateMasterFile(self.masterFile, property, file[property]);
			}
		}

		function setErrors(error) {
			var isExisted = _.find(self.errors, function (err) {
				return err.file === error.file;
			})
			if (isExisted) return;
			error.file.pixerfError = error.code;
			self.errors.push(error);
		}

		function buildErrorFilename(files) {
			var errMsg = '';
			for (var i = 0; i < files.length; i++) {
				errMsg += ("<div class='upload-photo__invalid-file text--truncate'> - " + files[i].file.name + "</div>");
			}
			return errMsg;
		}

		function errorHandler(errors) {
			if (!errors) errors = self.errors;
			if (errors.length === 0) return;
			var errMsg = '';
			var callToActionMsg = '';
			var groupedError = _.groupBy(errors, function (item) {
				return item.code;
			});
			for (var key in groupedError) {
				callToActionMsg = '';
				if (key === portfolioConst.UPLOAD_PHOTO_VALIDATION.ERROR_CODE.DUPLICATED) {
					errMsg += "<p>" + $translate.instant("the-following-photos-uploaded-before") + "</p>";
					callToActionMsg += "<p class='upload-photo__validation-popup__call-to-action-msg'>" + $translate.instant("try-uploading-new-ones") + "!</p>";
				}
				if (key === portfolioConst.UPLOAD_PHOTO_VALIDATION.ERROR_CODE.FAILED_TO_UPLOAD) {
					errMsg += "<p>" + $translate.instant("upload-photos-failed") + "</p>";
					callToActionMsg += ("<p class='upload-photo__validation-popup__call-to-action-msg'>" + $translate.instant("try-uploading-them-again") + "!</p>");
				}
				errMsg += buildErrorFilename(groupedError[key]);
				errMsg += callToActionMsg;
			}
			pixerfConfirmPopupSvc.showPopup({
				hideCancelBtn: true,
				hideConfirmText: true,
				hideTitle: true,
				message: errMsg,
				windowClass: 'upload-photo__validation-popup',
				okBtnText: 'OK'
			});
			self.errors = [];
		}

		function upload(files) {
			if(!files.length) return toastr.error("Please select photo!");;
			self.publishing = true;
			self.dropzoneConfig.instance.processQueue();
		}

		function onPublishBtnClicked(files) {
			self.isFormDirty = true;
			var validToUploadFiles = _.reject(files, function (f) {
				return f.pixerfError;
			})
			if (validToUploadFiles.length === 0) {
				return;
			}

			upload(validToUploadFiles);
		}

		function closeConfirm(uploadPhotoClosingEvent, reason, closed) {
			if (reason && self.uploadedFiles.data.length > 0) {
				uploadPhotoClosingEvent.preventDefault();
				var exitUploadConfirmModal = uploadCommunityAlbumPhotoSvc.showExitConfirmModal();
				exitUploadConfirmModal.result.then(function () {
					window.removeEventListener("beforeunload", beforeUnloadHandler);
					$uibModalStack.dismissAll();
				}, function () {
					window.removeEventListener("beforeunload", beforeUnloadHandler);
				});
			} else {
				if(self.isCancelUpload){
					deletePhotos(self.uploadedFiles.data);
				}
				window.removeEventListener("beforeunload", beforeUnloadHandler);
				self.uploadModal.data = null;
			}
		}

		function navigate(path) {
			uibModalInstance.dismiss("cancel")
		}

		function closeUploadModal() {
			self.isCancelUpload = true;
			$uibModalInstance.dismiss("cancel");
		}

		function deletePhotos(photos){
			if(photos && photos.length){
				for(var i = 0; i < photos.length; i++){
					pixerfApiMediaSvc.delete({id: photos[i].id});
				}
			}
		}

		function reset() {
			self.dropzoneConfig.instance.removeAllFiles();
			self.dropzoneConfigSmall.instance.removeAllFiles();
			uploadCommunityAlbumPhotoSvc.reset();

		}

		function uploadErrorHandler(pixerfFileBlob) {
			errorHandlerFn();
			systemUtils.digest($scope);
		}

		function convertToPixerfFile(pixerfFileBlob, filestackBlob) {
			fileUtils.fromFilestackBlob2PixerfBlob(pixerfFileBlob, filestackBlob);
			pixerfFileBlob.title = fileUtils.getFileNameWithoutExtension(pixerfFileBlob.name);
		}

		function convertToPixerfFiles(pixerfFileBlobs, filestackBlobs) {
			var length = Math.min(pixerfFileBlobs.length, filestackBlobs.length);
			for (var i = 0; i < length; i++) {
				(function (index) {
					var pixerfFileBlob = pixerfFileBlobs[index];
					var filestackBlob = filestackBlobs[index];
					convertToPixerfFile(pixerfFileBlob, filestackBlob);
				})(i)
			}
		}

		function showFilePickerPopup(defaultService) {
			googleAnalyticSvc.trackPageView("Upload Photo - Social - " + defaultService);
			filePickerSvc.pickMultiple({
				callbacks: mFileStackSocaialHandler,
				defaultService: defaultService
			});
		}

		function removeSelectedPhotos(photos) {
			if (photos.length === self.uploadedFiles.data.length) {
				var modal = pixerfConfirmPopupSvc.showPopup({
					message: 'Hi, All photos will be removed.'
				});
				modal.result.then(function () {
					self.reset();
				});
			} else {

				for (var i = 0; i < photos.length; i++) {
					uploadCommunityAlbumPhotoSvc.removeFileByName(photos[i].name);
				}
			}
		}

	}
})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('uploadBtnCtrl', uploadBtnCtrl);

    uploadBtnCtrl.$inject = ['$scope','uploadPhotoSvc'];

    function uploadBtnCtrl( $scope, uploadPhotoSvc) {

        var self = this;
        self.onStartUploading = onStartUploading;

        function onStartUploading(){
			uploadPhotoSvc.showUploadModal();
		}
    }
})();
(function () {
  'use strict';

  angular
    .module('pixerf')
    .directive('uploadBtn', uploadBtn);

  function uploadBtn() {

    var directive = {
      scope: {},
      restrict: 'E',
      templateUrl: 'app/components/upload-btn/upload-btn.html',
      controller: 'uploadBtnCtrl',
      controllerAs: 'vm',
      replace: true
    };
    return directive;
  }

})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('uploadAvatarZoneCtrl', uploadAvatarZoneCtrl);

	uploadAvatarZoneCtrl.$inject = ['uploadPhotoSvc', '$scope', 'sessionManagerSvc', 'pixerfUrl', 'toastr', 'systemUtils', '$state', 'imageUtils'];

	function uploadAvatarZoneCtrl(uploadPhotoSvc, $scope, sessionManagerSvc, pixerfUrl, toastr, systemUtils, $state, imageUtils) {

		var self = this;
		self.data = { type: 'profile' };
		self.showMessage = true;
		self.uploading = false;
		self.canceling = false;
		self.loginedUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.onBackbtnClicked = onBackbtnClicked;
		self.cropper = self.data.type === 'profile' ? {
			instance: null,
			options: {
				viewport: {
					width: 230,
					height: 230,
					type: self.loginedUser.account_type === 'business' ? 'square' : 'circle'
				},
				boundary: {
					width: 300,
					height: 300
				},
				showZoomer: true
			}
		} : null;
		self.dropzoneConfig = {
			'instance': {},
			'options': {
				url: self.data.url ? self.data.url : pixerfUrl.full + 'api/users/' + self.data.type,
				maxFilesize: 10,
				maxFiles: 1,
				paramName: 'media',
				parallelUploads: 10,
				autoProcessQueue: false,
				thumbnailHeight: 300,
				thumbnailWidth: null,
				dictRemoveFile: "Remove photo",
				createImageThumbnails: false,
				previewsContainer: '#previews',
				method: "post",
				headers: {
					"Authorization": "Bearer " + sessionManagerSvc.getToken()
				},
				dictFileTooBig: "File is too big ({{filesize}} MB). Max file size is: {{maxFilesize}} MB.",
				accept: function (file, done) {
					var errMsg = fileTypeValidation(file);
					done(errMsg);
				}
			},
			'eventHandlers': {
				'success': function (file, response) {
					self.uploading = false;
					self.isGeneratingThumbnail = false;
					if (self.canceling) return;
					//   $uibModalInstance.close(response.handle);
					$scope.onSuccessed({handle: response.handle});
					systemUtils.digest($scope);
				},
				'error': function (file, err) {
					self.uploading = false;
					self.showMessage = true;
					self.isGeneratingThumbnail = false;
					toastr.error(err);
					self.dropzoneConfig.instance.removeAllFiles();
					systemUtils.digest($scope);
				},
				'canceled': function (file) {
					self.uploading = false;
					this.removeAllFiles();
					//   $uibModalInstance.dismiss();
				},
				'addedfile': function (file) {
					self.showMessage = false;
					if (this.files.length > 1) {
						this.removeFile(this.files[0]);
					}
					self.isGeneratingThumbnail = true;
					if (!uploadPhotoSvc.isExceedMaxSize(file, self.dropzoneConfig.options.maxFilesize * 1024 * 1024) && !fileTypeValidation(file)) {
						imageUtils.customDropzoneThumbnail(file, this);
					}
					$scope.onFileAdded({file: file});
					systemUtils.digest($scope);
				},
				'thumbnail': function (file, dataUrl) {
					if (file.isCropped) return false;
					self.isGeneratingThumbnail = false;
					file.thumbnail = dataUrl;
					$scope.$apply();
					return true;

				}
			}
		};
		if($scope.onInit){
			$scope.onInit({instance: self});
		}
		self.cancel = function () {
			// $uibModalInstance.dismiss();
		};
		self.upload = function () {
			if (self.dropzoneConfig.instance.getAcceptedFiles().length === 0) {
				toastr.error("You have not selected any photo to upload.");
				return;
			}
			self.uploading = true;
			if (self.cropper) {
				self.cropper.instance.croppie('result', { type: 'blob', size: { width: 230, height: 230 } }).then(function (croppedBlobFile) {
					self.dropzoneConfig.instance.removeAllFiles();
					croppedBlobFile.isCropped = true;
					self.dropzoneConfig.instance.addFile(croppedBlobFile);
					self.dropzoneConfig.instance.processQueue();
					$state.go("complete-profile-skills");
				});
			} else {
				self.dropzoneConfig.instance.processQueue();
			}
		};

		self.reset = function () {
			self.dropzoneConfig.instance.removeAllFiles();
		};
		function fileTypeValidation(file) {
			if (file.type !== "image/jpeg" &&
				file.type !== "image/png") {
				return "Sorry, we only accept JPEG or PNG file.";
			}
		}
		function onBackbtnClicked(){
			window.history.go(-1);
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('uploadAvatarZone', uploadAvatarZone);

	uploadAvatarZone.$inject = [];
	function uploadAvatarZone() {

		var directive = {
			scope: {
				onInit: "&?",
				onFileAdded: "&",
				hideControl: "@",
				onSuccessed: "&"
			},
			restrict: 'E',
			templateUrl: 'app/components/upload-avatar-zone/upload-avatar-zone.html',
			controller: 'uploadAvatarZoneCtrl',
			controllerAs: 'vm',
			replace: true
		};
		return directive;
	}

})();

(function () {
    'use strict';
    angular
        .module('pixerf')
        .factory('uploadAvatarPopupSvc', uploadAvatarPopupSvc);

    uploadAvatarPopupSvc.$inject = ['$uibModal'];

    function uploadAvatarPopupSvc($uibModal) {

        function showPopup(popupData) {

            return $uibModal.open({
                size: 'lg',
                openedClass: 'upload-avatar-popup-popup',
                templateUrl: 'app/components/upload-avatar-popup/upload-avatar-popup.html',
                controller: 'uploadAvatarPopupCtrl',
                windowClass: 'upload-avatar-popup-window-class',
                controllerAs: 'vm',
                resolve: {
                    popupData: function () {
                        return popupData;
                    }
                }
            });
        }

        return {
            showPopup: showPopup
        };
    }
})();

(function() {
    'use strict';

    angular
      .module('pixerf')
      .controller('uploadAvatarPopupCtrl', uploadAvatarPopupCtrl);

    uploadAvatarPopupCtrl.$inject = ['uploadPhotoSvc','$scope', 'sessionManagerSvc', '$log', '$uibModalInstance', 'pixerfUrl', 'toastr', 'popupData', 'systemUtils', 'fileConst', 'imageUtils'];

    function uploadAvatarPopupCtrl(uploadPhotoSvc, $scope, sessionManagerSvc, $log, $uibModalInstance, pixerfUrl, toastr, popupData, systemUtils, fileConst, imageUtils) {

      var self = this;
      self.popupData = popupData;
      self.showMessage = true;
      self.uploading = false;
      self.canceling = false;
      self.loginedUser = sessionManagerSvc.getCurrentLoginUser().data;
      // Note: add /zuul/ to avoid duplicate processing!
      $scope.$on('modal.closing', function(uploadPhotoClosingEvent){
          if(self.uploading){
              self.cancelConfirmResult = confirm('Hang on, your ' + self.popupData.type  + ' photo has not been uploaded yet. Are you sure you want to cancel?');
              uploadPhotoClosingEvent.preventDefault();
              if(self.cancelConfirmResult){
                  self.dropzoneConfig.instance.removeAllFiles(true);
              }
          }
      });
      self.cropper = $.extend(true, {
          instance: null,
          options: {
                  viewport: {
                      width: 145,
                      height: 145,
                      type:  'square'
              }
          }
      }, self.popupData.cropper);

      self.dropzoneConfig = $.extend(true ,{
        'instance' : {},
        'options': {
          url: null,
          maxFilesize: 10,
          maxFiles: 1,
          paramName: 'media',
          parallelUploads: 10,
          autoProcessQueue: false,
          thumbnailHeight: 300,
          thumbnailWidth:  null,
          dictRemoveFile: "Remove photo",
          createImageThumbnails: false,
          previewsContainer: '.upload-avatar-popup__previews',
          clickable: '.upload-avatar-popup__upload-photo__upload-area__dropzone__main-content__browse-btn',
          method: "post",
          headers: {
            "Authorization": "Bearer " + sessionManagerSvc.getToken()
          },
          dictFileTooBig: "File is too big ({{filesize}} MB). Max file size is: {{maxFilesize}} MB.",
          accept: function(file, done){
              var errMsg = fileTypeValidation(file);
              done(errMsg);
          }
        },
        'eventHandlers': {
          'success': function(file, response){
              self.uploading = false;
              if(self.canceling) return;
              if(self.popupData.onSuccess) {
                self.popupData.onSuccess(file, response);
              }
              $uibModalInstance.close(response.handle);
              systemUtils.digest($scope);
          },
          'error': function(file, err){
              console.log(err);
              self.uploading = false;
              self.showMessage = true;
              self.isGeneratingThumbnail = false;
              toastr.error(err);
              self.dropzoneConfig.instance.removeAllFiles();
              systemUtils.digest($scope);
          },
          'canceled': function(file){
              self.uploading = false;
              this.removeAllFiles();
              $uibModalInstance.dismiss();
          },
          'addedfile': function(file) {
            self.showMessage = false;
              if(this.files.length > 1){
                  this.removeFile(this.files[0]);
              }
              self.isGeneratingThumbnail = true;
              if(!uploadPhotoSvc.isExceedMaxSize(file, self.dropzoneConfig.options.maxFilesize*1024*1024) && !fileTypeValidation(file)){
                imageUtils.customDropzoneThumbnail(file, this);
              }

              systemUtils.digest($scope);

          },
          'thumbnail': function(file, dataUrl){
              if(file.isCropped) return false;
              self.isGeneratingThumbnail = false;
              file.thumbnail = dataUrl;
              $scope.$apply();
              return true;

          }
        }
      }, self.popupData.dropzoneConfig);
      self.cancel = function(){
        $uibModalInstance.dismiss();
      };
      self.upload = function() {
            if(self.dropzoneConfig.instance.getAcceptedFiles().length === 0){
                toastr.error("You have not selected any photo to upload.");
                return;
            }
            self.uploading = true;
            if(self.cropper){
                self.cropper.instance.croppie('result', {type: 'blob', size: {width: 300, height: 300}}).then(function(croppedBlobFile){
                    self.dropzoneConfig.instance.removeAllFiles();
                    croppedBlobFile.isCropped = true;
                    self.dropzoneConfig.instance.addFile(croppedBlobFile);
                    if(self.popupData.isManual){
                        self.uploading = false;
                        self.dropzoneConfig.instance.on("thumbnail", function(file, thumbnail){
                            $uibModalInstance.close({dropzone: self.dropzoneConfig.instance,thumbnail: thumbnail});
                        });
                    } else {
                        self.dropzoneConfig.instance.processQueue();
                    }
                });
            } else {
                if(self.popupData.isManual){
                    self.uploading = false;
                    $uibModalInstance.close({dropzone: self.dropzoneConfig.instance,thumbnail: self.dropzoneConfig.instance.files[0].thumbnail});
                } else {
                    self.dropzoneConfig.instance.processQueue();
                }
            }
      };

      self.reset = function() {
        self.dropzoneConfig.instance.removeAllFiles();
      };
      function fileTypeValidation(file){
          if (file.type !== "image/jpeg" &&
            file.type !== "image/png" ) {
              return "Sorry, we only accept JPEG or PNG file.";
          }
      }

    }
  })();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('topUpSummaryCtrl', topUpSummaryCtrl);

    topUpSummaryCtrl.$inject = ['$scope'];

    function topUpSummaryCtrl($scope) {

		var self = this;
        self.today = moment().format('DD MMM YYYY');
    }
})();
(function () {
  'use strict';

  angular
    .module('pixerf')
    .directive('topUpSummary', topUpSummary);

  function topUpSummary() {

    var directive = {
      scope: {
        item: '=',
        title: '@',
        currentBalance: '=',
        newBalance: '='
      },
      restrict: 'E',
      templateUrl: 'app/components/top-up-summary/top-up-summary.html',
      controller: 'topUpSummaryCtrl',
			controllerAs: 'vm',
      replace: true
    };
    return directive;
  }

})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.factory('topUpSuccessfullyPopupSvc', topUpSuccessfullyPopupSvc);
	topUpSuccessfullyPopupSvc.$inject = ['$uibModal'];

	function topUpSuccessfullyPopupSvc($uibModal) {

		function showPopup(data) {
			return $uibModal.open({
				templateUrl: 'app/components/top-up-successfully-popup/top-up-successfully-popup.html',
				controller: 'topUpSuccessfullyPopupCtrl',
				controllerAs: 'vm',
				animation: true,
				windowClass: 'zindex top-up-successfully-screen',
				resolve: {
					'resolveData': function () {
						return data;
					}
				}
			});
		}

		return {
			showPopup: showPopup
		};
	}
})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('topUpSuccessfullyPopupCtrl', topUpSuccessfullyPopupCtrl);

    topUpSuccessfullyPopupCtrl.$inject = ['$uibModalInstance', 'resolveData', '$state'];

    function topUpSuccessfullyPopupCtrl($uibModalInstance, resolveData, $state) {

		var self = this;
        self.close = close;
        self.credit = resolveData;

		self.message = {
			header: "Thank you!",
			content: "You have credited SGD" + self.credit.price + " to your account. <br/> You're well on your way to using our services and getting great Asian visual content for your needs!"
		};

		function close(){
            $uibModalInstance.close();
            $state.go('setting.my_credit');
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('toogleUserCoverFullheightBtnCtrl', toogleUserCoverFullheightBtnCtrl);

    toogleUserCoverFullheightBtnCtrl.$inject = ['$scope','systemUtils', '$timeout'];

    function toogleUserCoverFullheightBtnCtrl( $scope, systemUtils, $timeout) {
        var self = this;
        self.isExpandable = false;
        self.onUserCoverImageLoaded = {
            success: function(img){
                $scope.coverImage.img = img;
                self.isExpandable = $scope.coverImage.img.height > self.originalHeight;
            }
        }

        self.toolgeFullviewMode = toolgeFullviewMode;
        function toolgeFullviewMode(){
            if($scope.coverImage.img.height < self.originalHeight) return;
            if($scope.coverImage.isFull){
                $scope.coverImage.cssHeight =  self.originalHeight;   
            } else {
                var viewportHeight =  systemUtils.getViewportDimension().height;
                var anchorBottomPosition = viewportHeight - $scope.$anchor.offset().top - $scope.$anchor.height();
                $scope.coverImage.cssHeight =  (anchorBottomPosition + self.originalHeight) + "px";
            }
            $scope.coverImage.isFull = !$scope.coverImage.isFull;
            $timeout(function(){
                systemUtils.scrollTo({direction: 'up', howFar: 'vh'});
            })

        }
        
    }
})();
(function () {
  'use strict';

  angular
    .module('pixerf')
    .directive('toogleUserCoverFullheightBtn', toogleUserCoverFullheightBtn);

  function toogleUserCoverFullheightBtn() {

    var directive = {
      scope: {
        "coverImage" : "=",
        "coverImageContainer": "@",
        'anchor': '@',
      },
      restrict: 'E',
      templateUrl: 'app/components/toogle-user-cover-fullheight-btn/toogle-user-cover-fullheight-btn.html',
      controller: 'toogleUserCoverFullheightBtnCtrl',
      controllerAs: 'vm',
      replace: true,
      transclude: true,
      link: function(scope, element, attrs, ctrl){
         scope.$anchor = $(scope.anchor);
         scope.$coverImageContainer = $(scope.coverImageContainer);
         ctrl.originalHeight = scope.$coverImageContainer.height();
      }
    };
    return directive;
  }

})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('timerDropdownCtrl', timerDropdownCtrl);

	timerDropdownCtrl.$inject = ['$scope'];

	function timerDropdownCtrl($scope) {

		var self = this;
		self.options = {};
		self.timer = {};
		self.hours = [];
		self.mins = [];
		self.seconds = [];
		self.showOption = ["AM", "PM"];
		self.selectedShowOptions = {};

		init();

		$scope.$watch('vm.timer', function (newTimer) {
			var Selectedhour = parseInt(newTimer.hour);
			if (!_.isEmpty(newTimer) && newTimer.options === "PM") {
				Selectedhour = (Selectedhour == 12) ? 12 : (Selectedhour + 12);
				$scope.model = (Selectedhour || 0) + ":" + (parseInt(newTimer.min) || 0) + ":" + (newTimer.second || 0);
			} else if (!_.isEmpty(newTimer)){
				Selectedhour = (Selectedhour == 12) ? 0 : Selectedhour;
				$scope.model = ((Selectedhour|| 0)) + ":" + (parseInt(newTimer.min) || 0) + ":" + (newTimer.second || 0);
			}
		}, true)

		function init() {
			self.options = $scope.options;
			if ($scope.model) {
				self.timer = $scope.model;
				if(self.timer.hour == 0 && self.timer.options =='AM'){
					self.timer.hour = 12;
				}else if(self.timer.hour == 12 && self.timer.options =='AM'){
					self.timer.options ='PM'
				}
			}
			genTimer();
		}

		function genTimer() {
			for (var i = 1; i < 13; i++) {
				if(i < 10){
					self.hours.push("0" + i);
				} else {
					self.hours.push(i);
				}
			}
			for (var i = 0; i < 60;) {
				if(i < 10){
					self.mins.push("0" + i);
				} else {
					self.mins.push(i);
				}
				i += 5;
			}
			if(!self.options.noSecond){
				for (var i = 0; i < 60; i++) {
					if(i < 10){
						self.seconds.push("0" + i);
					} else {
						self.seconds.push(i);
					}
				}
			}
		}
	}
})();

(function () {
    'use strict';

    angular
        .module('pixerf')
        .directive('timerDropdown', timerDropdown);

    function timerDropdown() {

        var directive = {
            scope: {
                model: "=",
                placeholder: "=",
                options: "=",
                isRequired: '='
            },
            restrict: 'E',
            templateUrl: 'app/components/timer-dropdown/timer-dropdown.html',
            replace: true,
            controller: 'timerDropdownCtrl',
            controllerAs: 'vm'
        };
        return directive;
    }

})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('tilePhotoCtrl', tilePhotoCtrl);

	tilePhotoCtrl.$inject = ['messageConst', 'gallerySvc', 'photoDetailSvc', '$scope', 'photoSvc', 'toastr', 'pixerfApiGallerySvc', 'pixerfConfirmPopupSvc', 'sessionManagerSvc',
		'photoDetailPopupSvc', 'commonConst', '$state', 'messageSvc', 'translationSvc', 'addToCartBtnSvc', 'cartSvc', 'popoverCartSvc', 'store', 'cartUtils', 'accountConst',
		'$rootScope'];

	function tilePhotoCtrl(messageConst, gallerySvc, photoDetailSvc, scope, photoSvc, toastr, pixerfApiGallerySvc, pixerfConfirmPopupSvc, sessionManagerSvc,
		photoDetailPopupSvc, commonConst, $state, messageSvc, translationSvc, addToCartBtnSvc, cartSvc, popoverCartSvc, store, cartUtils, accountConst,
		$rootScope) {
		var self = this;
		self.imageUrl = scope.file.thumbnails['x400'];
		self.onGalleryItemClicked = onGalleryItemClicked;
		self.likePhotoBtnClick = likePhotoBtnClick;
		self.setPhotoAsCover = setPhotoAsCover;
		self.removePhotoFromGallery = removePhotoFromGallery;
		self.isLogined = !!sessionManagerSvc.getCurrentLoginUser().data;
		self.loginUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.onPhotoClicked = onPhotoClicked;
		self.socialShareContent = scope.file ? photoDetailSvc.buildSocialShareContent(scope.file) : {};
		self.clickOutSide = clickOutSide;
		self.isPortfolioPhoto = (scope.file.type === 'portfolio' || scope.file.type === 5);
		self.showAddToCart = !(scope.file.type === 'portfolio' || scope.file.type === 5 || scope.file.isMine || scope.file.in_mission);
		self.onAddToCartBtnClicked = onAddToCartBtnClicked;
		self.cart = cartSvc.getCart();
		self.isAddedToCart = cartSvc.getCartItemByMediaId(self.cart.data, scope.file.id) ? true : false;
		self.isBulkEditPhotoSelected = isBulkEditPhotoSelected;
		self.isBulkEditPhoto = scope.options && scope.options.bulkEditPhoto || false;
		self.bulkSelectedPhoto = scope.options && scope.options.bulkSelectedPhoto || [];

		scope.$watch('options.bulkSelectedPhoto', function (value) {
			if (value != undefined) {
				self.bulkSelectedPhoto = value;
			}
		});

		scope.$watch('options.isBulkEditPhoto', function (value) {
			if (value != undefined) {
				self.isBulkEditPhoto = value;
			}
		});

		init();

		function init() {
			if (scope.mission) {
				scope.file.mission = scope.mission;
			}
		}

		function isBulkEditPhotoSelected() {
			if (!self.isBulkEditPhoto || !scope.file || !scope.file.id) return false;
			var result = false;
			for (var i = 0; i < self.bulkSelectedPhoto.length; i++) {
				if (self.bulkSelectedPhoto[i].id == scope.file.id) {
					result = true;
				}
			}
			self.isBulkEditPhotoSelectedItem = result;
			return result;
		}

		function onGalleryItemClicked(file, gallery) {
			if (!file) return;
			self.isSaving = true;
			var action = gallery.isSelected ? "addPhotoToGallery" : "removePhotoToGallery";
			photoSvc[action](file, gallery).then(function (response) {
				var message = messageSvc.compile(messageConst.success.PHOTO_GALLERY_ADDED_REMOVED, {
					action: action,
					gallery_name: gallery.title
				});
				toastr.success(message);
				gallerySvc.updateGalleryCover(gallery);
			}, function () {
				toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
			})
		}

		function clickOutSide($event) {
			$("body").trigger("click");
			$event.stopPropagation();
		}

		function likePhotoBtnClick(file) {
			if (file.isLiking) return;
			file.isLiking = true;
			photoSvc.likePhoto(file).then(function (response) {
				delete file.isLiking;
				file.is_liked = !file.is_liked;
			}, function () {
				delete file.isLiking;
				toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
			})
		}

		function setPhotoAsCover() {
			var originalCoverImage;
			if (!scope.gallery.cover_media) {
				originalCoverImage = scope.gallery.cover_image;
			} else {
				originalCoverImage = scope.gallery.cover_media.handle;
			}
			scope.gallery.cover_media_id = scope.file.id;
			pixerfApiGallerySvc.put({
				id: scope.gallery.id,
			}, scope.gallery).$promise.then(function (response) {
				scope.gallery.coverImagePath = response.data.coverImagePath;
				toastr.success("This photo has been set as cover of gallery");
			}, function (err) {
				console.log(err)
				scope.gallery.cover_media.handle = originalCoverImage;
				toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
			})
		}

		function removePhotoFromGallery(file, gallery) {
			var modal = pixerfConfirmPopupSvc.showPopup({
				message: 'Hi, This photo will be removed from this gallery.'
			});
			modal.result.then(function () {
				photoSvc.removePhotoToGallery(file, gallery).then(function () {
					file.galleries = _.reject(file.galleries, function (gl) {
						return gl.id === gallery.id;
					})
					scope.onFileRemoved({
						file: file
					});
				}, function () {
					toastr.error("Cannot " + (isRemove ? 'remove' : 'add') + " this photo to gallery. Please try again.");
				})
			})
		}

		function setSelectedVariant(photo, cartItem) {
			if (cartItem) {
				self.cartItem = cartItem;
				self.cartItem.media.data = photo;
			} else {
				self.cartItem = {
					media: {
						id: photo.id,
						price: $.extend(true, {}, photo.price),
						data: photo
					}
				};
				self.cartItem.sub_total = 0;
				cartUtils.updateCartSelectedVariant(self.cartItem, {})
			}
		}

		function onAddToCartBtnClicked(media) {
			if (self.isWorking || self.isAddedToCart) return;
			self.isWorking = true;

			photoSvc.updatePhotoInfo(media).then(function () {
				self.isWorking = false;
				var cartItem = cartSvc.getCartItemByMediaId(self.cart.data, media.id);
				setSelectedVariant(media, cartItem);
				(self.loginUser) ? onAddToCartForLoggedUser(media) : onAddToCartForGuestUser(media);

			}, function () {
				self.isWorking = false;
			});
		}

		function onAddToCartForLoggedUser(media) {
			var savedCartItemData = addToCartBtnSvc.buildSavedCartItem(media, true);
			console.log(savedCartItemData);
			var errMsg = addToCartBtnSvc.validate(savedCartItemData);
			if (errMsg) {
				toastr.error(errMsg)
			};

			var action = "addItemToCart";
			cartSvc[action](savedCartItemData).then(function (response) {
				self.isWorking = false;
				self.isAddedToCart = true;
				var addedCartItem = cartSvc.getCartItemByMediaId(response.data, media.id);
				self.cartItem.id = addedCartItem.id
			}).catch(function (err) {
				self.isWorking = false;
				var message = translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true);
				if (err.data && err.data.message === "MEDIA_IN_MISSION") {
					message = messageSvc.compile(messageConst.error.MISSION_CART, { photo_name: ": " + media.data.title, quantity: 1 });
					media.data.in_mission = true;
				}
				toastr.error(message);
			});
		}

		function onAddToCartForGuestUser(media) {
			var guestUserToken = store.get(accountConst.TOKEN.GUEST_USER_TOKEN);
			if (guestUserToken) {
				processAddToCard(guestUserToken, media);
			} else {
				cartSvc.generateUUID(10, processAddToCard, media);
			}

			function processAddToCard(uuid, media) {
				if (!store.get(accountConst.TOKEN.GUEST_USER_TOKEN)) {
					store.set(accountConst.TOKEN.GUEST_USER_TOKEN, uuid);
				}

				var savedCartItemData = addToCartBtnSvc.buildSavedCartItem(media, true);
				console.log(savedCartItemData);
				var errMsg = addToCartBtnSvc.validate(savedCartItemData);
				if (errMsg) toastr(errMsg);

				var action = "addItemToCart";
				cartSvc[action](savedCartItemData, uuid).then(function (response) {
					self.isWorking = false;
					self.isAddedToCart = true;
					var addedCartItem = cartSvc.getCartItemByMediaId(response.data, media.id);
					self.cartItem.id = addedCartItem.id
				}).catch(function (err) {
					self.isWorking = false;
					var message = translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true);
					if (err.data && err.data.message === "MEDIA_IN_MISSION") {
						message = messageSvc.compile(messageConst.error.MISSION_CART, { photo_name: ": " + media.data.title, quantity: 1 });
						media.data.in_mission = true;
					}
					toastr.error(message);
				});
			}
		}

		function removeFileFromBulkEditPhotoList(fileId) {
			var index = -1;
			for (var i = 0; i < self.bulkSelectedPhoto.length; i++) {
				if (self.bulkSelectedPhoto[i].id == scope.file.id) {
					index = i;
				}
			}

			if (index >= 0) {
				self.bulkSelectedPhoto.splice(index, 1);
			}
		}

		function popupBulkEditChanged(key) {
			if (!(scope && scope.options && scope.options.buldEditPhotoChanged && scope.options.bulkSelectedPhotoChanged)) return;
			switch (key) {
				case 'buldEditPhotoChanged':
					scope.options.buldEditPhoto(self.isBulkEditPhoto);
					break;
				case 'bulkSelectedPhotoChanged':
					scope.options.bulkSelectedPhotoChanged(self.bulkSelectedPhoto);
					break;
				default:
					break
			}
		}

		function onPhotoClicked(file) {
			if (self.isBulkEditPhoto) {
				if (self.isBulkEditPhotoSelected()) {
					removeFileFromBulkEditPhotoList(scope.file.id)
				} else {
					self.bulkSelectedPhoto.push(scope.file);
				}
				popupBulkEditChanged('bulkSelectedPhotoChanged');
				// $rootScope.$broadcast(messageConst.BROADCAST.BULK_SELECTED_PHOTO_CHANGED, {bulkSelectedPhoto: self.bulkSelectedPhoto});
				return;
			}
			if (self.isWorking || file.type === 'portfolio' || file.type === 5) {
				return false;
			};
			self.isWorking = true;
			photoSvc.updatePhotoInfo(scope.file).then(function () {
				self.isWorking = false;
				if (scope.context === "photo-page") {
					$state.go("photo", {
						id: scope.file.id
					});
				} else {
					photoDetailPopupSvc.setShouldSrollTop(new Date().getTime());
					if (photoDetailPopupSvc.isPopupShowing()) {
						photoDetailPopupSvc.updateUI({
							photo: scope.file
						});

					} else {
						var modal = photoDetailPopupSvc.showPopup({
							photo: scope.file,
							context: scope.context,
							onPhotoPopupSaved: scope.onPhotoPopupSaved,
							onPhotoPopupClosed: scope.onPhotoPopupClosed
						});
						modal.result.then(function (response) {
							self.isAddedToCart = cartSvc.getCartItemByMediaId(self.cart.data, scope.file.id) ? true : false;
							if (response.action === commonConst.ACTION.DELETE) {
								scope.onFileRemoved({
									file: response.photo
								});
							} else {
								scope.onAddedOrRemovedFromGallery({
									file: scope.file
								});
							}
						}, function (response) {
							self.isAddedToCart = cartSvc.getCartItemByMediaId(self.cart.data, scope.file.id) ? true : false;
							scope.onAddedOrRemovedFromGallery({
								file: scope.file
							});
						});
					}
				}

			}, function () {
				self.isWorking = false;
			});
			if (scope.onPhotoClickedCallback) {
				scope.onPhotoClickedCallback({
					file: scope.file
				});
			}
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('tilePhoto', tilePhoto);

	function tilePhoto() {

		var directive = {
			scope: {
				displaySize: "@",
				file: "=",
				mission: "=",
				gallery: "=",
				onFileRemoved: "&",
				onAddedOrRemovedFromGallery: "&",
				context: '=',
				onPhotoClicked: '&?',
				onPhotoClickedCallback: '&?',
				simpleSelectMode: '=',
				overlayMode: '=',
				onPhotoPopupSaved: '&',
				onPhotoPopupClosed: '&',
				options: '=',
				onRemoveBtnClick: '&?',
				showLicense: '=',
				hideCaption: '='
			},
			restrict: 'E',
			templateUrl: 'app/components/tile-photo/tile-photo.html',
			controller: 'tilePhotoCtrl',
			controllerAs: 'vm',
			replace: true
		};
		return directive;
	}

})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('suggestBtnCtrl', suggestBtnCtrl);

    suggestBtnCtrl.$inject = ['$scope','pixerfApiUserSvc', 'toastr', 'sessionManagerSvc', 'pixerfConfirmPopupSvc', 'translationSvc'];

    function suggestBtnCtrl( $scope, pixerfApiUserSvc, toastr, sessionManagerSvc, pixerfConfirmPopupSvc, translationSvc) {

		var self = this;
		self.isLoginedUser = sessionManagerSvc.getCurrentLoginUser();
        self.isDoingSuggest = false;
        self.onSuggestClicked = onSuggestClicked;
        self.btnLabel = "";

        self.onMouseOver = onMouseOver;
        self.onMouseLeave = onMouseLeave;
        self.isHovering = false;

        $scope.$watch('user.is_suggested', function(newValue, oldValue){
            if($scope.user){
                setBtnLabel();
            }
        });

        function onSuggestClicked(){
			if(self.isDoingSuggest) return;
			self.isDoingSuggest = true;
			if($scope.user.is_suggested){
				var pixerfConfirmPopup = pixerfConfirmPopupSvc.showPopup({
					hideTitle: true,
					hideConfirmText: true,
					message: "Are you sure you want to remove this user profile from Featured Photographers?",
					okFn: function(){
						return pixerfApiUserSvc.unSuggestedProfiles({id: $scope.user.id}).$promise;
					},
					okFnCallback: function(){
						self.isDoingSuggest = false;
						$scope.user.is_suggested = !$scope.user.is_suggested;
						if($scope.onSuggestStatusChanged) $scope.onSuggestStatusChanged({status: $scope.user.is_suggested});
						setBtnLabel();
						toastr.success("This user profile has been successfully removed from Featured Photographers!");
						self.isHovering = false;
					}
				})

				pixerfConfirmPopup.result.then(function(){},function(){
					self.isDoingSuggest = false;
				});

			} else {
				pixerfApiUserSvc.suggestedProfiles({"user_id": $scope.user.id}).$promise.then(function(respone){
					self.isDoingSuggest = false;
					$scope.user.is_suggested = !$scope.user.is_suggested;
					if($scope.onSuggestStatusChanged) $scope.onSuggestStatusChanged({status: $scope.user.is_suggested});
					setBtnLabel();
					toastr.success("This user profile has been successfully added to Featured Photographers!");
					self.isHovering = false;
				}, function(){
					self.isDoingSuggest = false;
					toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
				})
			}
        }
        function setBtnLabel(){
            self.btnLabel = $scope.user.is_suggested ? "Suggested Profile" : "Suggest Profile";
        }
        function onMouseOver(){
            if(!$scope.user.is_suggested) return;
            self.isHovering = true;
            self.btnLabel =  "Unsuggest Profile";
        }
        function onMouseLeave(){
            self.isHovering = false;
            if(!$scope.user.is_suggested) return;
            self.btnLabel =  "Suggested Profile";
        }
    }
})();

(function () {
  'use strict';

  angular
    .module('pixerf')
    .directive('suggestBtn', suggestBtn);

  function suggestBtn() {

    var directive = {
      scope: {
        "user" : "=",
        "onSuggestStatusChanged": "&"
      },
      restrict: 'E',
      templateUrl: 'app/components/suggest-btn/suggest-btn.html',
      controller: 'suggestBtnCtrl',
      controllerAs: 'vm',
      replace: true
    };
    return directive;
  }

})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.factory('sucessfullyActionPopupSvc', sucessfullyActionPopupSvc);
	sucessfullyActionPopupSvc.$inject = ['$uibModal'];

	function sucessfullyActionPopupSvc($uibModal) {

		function showPopup(data) {
			return $uibModal.open({
				templateUrl: 'app/components/successfully-action-popup/successfully-action-popup.html',
				controller: 'sucessfullyActionPopupCtrl',
				controllerAs: 'vm',
				animation: true,
				windowClass: 'zindex successfully-action-popup__screen',
				resolve: {
					'resolveData': function () {
						return data;
					}
				}
			});
		}

		return {
			showPopup: showPopup
		};
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('sucessfullyActionPopupCtrl', sucessfullyActionPopupCtrl);

	sucessfullyActionPopupCtrl.$inject = ['$uibModalInstance', 'resolveData'];

	function sucessfullyActionPopupCtrl($uibModalInstance, resolveData) {

		var self = this;
		self.close = close;
		self.data = resolveData;
		self.leftBtnClicked = leftBtnClicked;
		self.rightBtnClicked = rightBtnClicked;

		function leftBtnClicked() {
			resolveData.leftBtnSubmit();
			$uibModalInstance.close();
		};

		function rightBtnClicked() {
			resolveData.rightBtnSubmit();
			$uibModalInstance.close();
		};

		function close() {
			$uibModalInstance.dismiss();
		}
	}
})();

(function () {

	angular
		.module('pixerf')
		.factory('subscriptionTypePopupSvc', subscriptionTypePopupSvc);

	subscriptionTypePopupSvc.$inject = ['$uibModal'];

	function subscriptionTypePopupSvc($uibModal) {

		var mModal = null;

		function showPopup(data) {
			mModal = $uibModal.open({
				templateUrl: 'app/components/subscription-type-popup/subscription-type-popup.html',
				controller: 'subscriptionTypePopupCtrl',
				controllerAs: 'vm',
				animation: true,
				windowClass: 'zindex subscription-type-screen',
				backdrop: 'static',
				resolve: {
					popupData: function () {
						return data;
					}
				}
			});
			return mModal;
		}

		function closePopup() {
			mModal.close();
		}

		return {
			showPopup: showPopup,
			closePopup: closePopup
		};
	}
})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('subscriptionTypePopupCtrl', subscriptionTypePopupCtrl);

    subscriptionTypePopupCtrl.$inject = ['popupData', '$uibModalInstance', 'toastr', 'pixerfApiMissionSvc', 'systemUtils', '$scope', 'sessionManagerSvc'];

    function subscriptionTypePopupCtrl(popupData, $uibModalInstance, toastr, pixerfApiMissionSvc, systemUtils, $scope, sessionManagerSvc) {

        var self = this;
        self.onSubscriptionSelected = onSubscriptionSelected;
        self.loginnedUser = sessionManagerSvc.getCurrentLoginUser().data;
        self.onNextClicked = onNextClicked;
        self.onSubmitClicked = onSubmitClicked;
        self.onCancelClicked = onCancelClicked;
        self.mission = popupData.mission;
        self.geoGraphicInstance = {};
        self.quantities = [];
        self.freeEntriesCount = 0;
        self.bootstrapSelectOptions = {"dropupAuto": false, "noneSelectedText": "", "maxOptions": 1};
        self.slickSetting = {
            nextArrow: '.subscription-type-popup__btn',
            onAfterChange: function(event){
                initQuantityEntries(self.geoGraphicInstance.addition_entries);
                self.freeEntriesCount = self.geoGraphicInstance.free_entries ? self.geoGraphicInstance.free_entries : 0;
            },
            onInit: function(slick){
                self.slick = slick;
            }
        }

        function onSubscriptionSelected(type){
            if(type === 'print_subscriber') {
                self.geoGraphicInstance.isPrintSubscriber = true;
                self.geoGraphicInstance.isEScubscriber = false;
                self.geoGraphicInstance.isNotAScubscriber = false;
                self.geoGraphicInstance.email = '';
                self.isSubscriber = 'print_subscriber';
                self.geoGraphicInstance.ioa_subscriber_type = 'print';
                onSectionClicked('print_subscriber');
            } else if(type === 'e_subscriber') {
                self.geoGraphicInstance.isEScubscriber = true;
                self.geoGraphicInstance.isPrintSubscriber = false;
                self.geoGraphicInstance.isNotAScubscriber = false;
                self.geoGraphicInstance.email = '';
                self.isSubscriber = 'e_subscriber';
                self.geoGraphicInstance.ioa_subscriber_type = 'e';
                onSectionClicked('e_subscriber');
            } else {
                self.geoGraphicInstance.isNotAScubscriber = true;
                self.geoGraphicInstance.isPrintSubscriber = false;
                self.geoGraphicInstance.isEScubscriber = false;
                self.geoGraphicInstance.email = self.loginnedUser.email;
                self.isSubscriber = 'not_subscriber';
                self.geoGraphicInstance.ioa_subscriber_type = null;
                onSectionClicked('not_subscriber');
            }
            self.geoGraphicInstance.ioa_submission_type = 'free';
        }
        function onNextClicked(form){
            var error = "";
            error = validate(self.geoGraphicInstance, form);
            if(error){
                toastr.error(error);
                return;
            }
            pixerfApiMissionSvc.get_maximum_uploads({
                id: self.mission.id,
                user_id: self.loginnedUser.id,
                ioa_subscriber_email: self.geoGraphicInstance.email ? self.geoGraphicInstance.email : self.loginnedUser.email,
                ioa_subscriber_type: self.geoGraphicInstance.ioa_subscriber_type || 'pixerf',
                ioa_submission_type: self.geoGraphicInstance.ioa_submission_type}).$promise.then(function (response) {
                    response.ioa_subscriber_type = self.geoGraphicInstance.ioa_subscriber_type || 'pixerf';
                    response.ioa_submission_type = "free";
                    response.ioa_subscriber_email = self.geoGraphicInstance.email ? self.geoGraphicInstance.email : self.loginnedUser.email;
                    $uibModalInstance.close(response);
                })
        }
        function onSubmitClicked(form){
            $uibModalInstance.close(self.geoGraphicInstance);
        }
        function validate(IOAInfo, form){
            if(IOAInfo.isNotAScubscriber){
                return;
            }
            form.$setDirty();
            if(form.email.$error.required){
                return "Plese input your email!";
            } else if (form.email.$error.email){
                return "Invalid email address";
            }
        }
        function onSectionClicked(target){
            if(target === self.targetSection){
                self.targetSection = null;
            } else {
                self.targetSection = target;
            }
        }
        function initQuantityEntries(addtionalEntries){
            for(var i = 0; i < addtionalEntries; i++){
                self.quantities.push({id: i, name: (i + 1)});
            }
            systemUtils.digest($scope);
        }
        function onCancelClicked(){
            $uibModalInstance.dismiss();
        }
    }
})();

(function () {

	angular
		.module('pixerf')
		.factory('subscribeSvc', subscribeSvc);

	subscribeSvc.$inject = ['$q', 'pixerfApiSubscribeSvc', 'toastr', 'messageConst', 'translationSvc'];

	function subscribeSvc($q, pixerfApiSubscribeSvc, toastr, messageConst, translationSvc) {

		var self = this;
		self.onSendEmail = onSendEmail;

		function onSendEmail(form) {
			var def = $q.defer();

			var errMsg = onValidateEmail(form);
			if (errMsg) {
				toastr.error(errMsg);
				def.reject(errMsg);
			} else {
				pixerfApiSubscribeSvc.subscribe({ "email_subscriber": { topic: 'xerfie', email: form.email.$viewValue } }).$promise.then(function (res) {
					toastr.success(messageConst.success.SUBSCRIBE);
					def.resolve(res);
				}, function (error) {
					toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
					def.reject(error);
				});
				def.resolve();
			}

			return def.promise;
		}

		function onValidateEmail(form) {
			form.$setDirty();
			var errMsg = ''
			if (form.email && form.email.$error.required) {
				errMsg = messageConst.error.EMAIL_REQUIRED;
			} else if (form.email && form.email.$error.email) {
				errMsg = messageConst.error.EMAIL_FORMAT_ERROR;
			}

			return errMsg;
		}

		return {
			onSendEmail: onSendEmail
		};
	}
})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.factory('subscribePopupSvc', subscribePopupSvc);
	subscribePopupSvc.$inject = ['$uibModal'];

	function subscribePopupSvc($uibModal) {

		var mModal = null;

		function showPopup(data) {
			mModal = $uibModal.open({
				templateUrl: 'app/components/subscribe/subscribe-popup.html',
				controller: 'subscribePopupCtrl',
				controllerAs: 'vm',
				animation: true,
				windowClass: 'zindex subscribe-popup',
				backdrop: 'static',
				resolve: {
					popupData: function () {
						return data;
					}
				}
			});
		}

		function closePopup() {
			mModal.close();
		}

		return {
			closePopup: closePopup,
			showPopup: showPopup
		};
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('subscribePopupCtrl', subscribePopupCtrl);

	subscribePopupCtrl.$inject = ['subscribeSvc', 'subscribePopupSvc'];

	function subscribePopupCtrl(subscribeSvc, subscribePopupSvc) {

		var self = this;
		self.onSendEmail = onSendEmail;
		self.closePopup = subscribePopupSvc.closePopup;

		function onSendEmail(form) {
			subscribeSvc.onSendEmail(form).then(function(){
				subscribePopupSvc.closePopup();
			});
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('subscribeCtrl', subscribeCtrl);

	subscribeCtrl.$inject = ['$scope', 'subscribeSvc'];

	function subscribeCtrl($scope, subscribeSvc) {

		var self = this;
		self.onSendEmail = onSendEmail;

		function onSendEmail(form) {
			var form = form;
			subscribeSvc.onSendEmail(form).then(function(res){
				resetForm(form);
				$scope.onSubscribed({res: res});
			});
		}

		function resetForm(form){
			form.$setPristine();
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('subscribe', subscribe);

	function subscribe() {

		var directive = {
			scope: {
				onSubscribed: "&?"
			},
			restrict: 'E',
			templateUrl: 'app/components/subscribe/subscribe.html',
			controller: 'subscribeCtrl',
			controllerAs: 'vm',
			replace: true
		};
		return directive;
	}

})();

(function(){

  angular
    .module('pixerf')
    .factory('submitMissionPhotoPopupSvc', submitMissionPhotoPopupSvc);

    submitMissionPhotoPopupSvc.$inject = ['$uibModal'];

    function submitMissionPhotoPopupSvc($uibModal){

		function showPopup(data){
            $uibModal.open({
                templateUrl: 'app/components/submit-mission-photo-popup/submit-mission-photo-popup.html',
                controller: 'submitMissionPhotoPopupCtrl',
                controllerAs: 'vm',
                animation: true,
                windowClass: 'zindex submit-mission-photo',
                backdrop: 'static',
                resolve: {
                    popupData: function(){
                        return data;
                    }
                }
            });
        }

		return {
			showPopup: showPopup
		};
    }
})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('submitMissionPhotoPopupCtrl', submitMissionPhotoPopupCtrl);

    submitMissionPhotoPopupCtrl.$inject = ['pixerfApiMissionSvc', 'popupData', '$uibModalInstance', 'uploadPhotoSvc', 'selectMyPhotoPopupSvc', 'toastr', '$translate', 'translationSvc'];

    function submitMissionPhotoPopupCtrl(pixerfApiMissionSvc, popupData, $uibModalInstance, uploadPhotoSvc, selectMyPhotoPopupSvc, toastr, $translate, translationSvc) {

        var self = this;
        self.mission = popupData ? popupData.mission : null;
		self.closePopup = closePopup;
        self.onUploadNewPhotoBtnClicked = onUploadNewPhotoBtnClicked;
        self.onUploadFromMineBtnClicked = onUploadFromMineBtnClicked;
        self.onMissionAgreed = onMissionAgreed;
        self.isFormDirty = false;

        init();

		function closePopup(){
            $uibModalInstance.close();
        }

        function checkAgreeAgreement(){
            var errMsg = "";
            if(!self.mission.is_agreement_accepted){
                self.isFormDirty = true;
                errMsg = "Please agree to the Missions Agreement!";
            }
            return errMsg;
        }

        function onUploadNewPhotoBtnClicked(){
            var errMsg = checkAgreeAgreement();
            if(errMsg){
                toastr.error(errMsg);
                return;
            }
            closePopup();
            uploadPhotoSvc.showUploadModal(popupData);
        }

        function onUploadFromMineBtnClicked(){
            var errMsg = checkAgreeAgreement();
            if(errMsg){
                toastr.error(errMsg);
                return;
            }
            closePopup();
            selectMyPhotoPopupSvc.showPopup(popupData);
        }
        function onMissionAgreed(){
            pixerfApiMissionSvc.agree_agreement({id: self.mission.id},{}).$promise.then(function(){
                self.mission.is_agreement_accepted = true;
            }, function(){
                self.mission.is_agreement_accepted = false;
                toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
            })
        }

        function init(){
            compileAgreementText();
        }

        function compileAgreementText(){
            var text = "";
            if(self.mission.is_gojek){
                text = $translate.instant("submission-popup-agreement", {'agreement': $translate.instant('gojek-missions-agreement-link')});
            } else {
                text = $translate.instant("submission-popup-agreement", {'agreement': $translate.instant('missions-agreement-link')});
            }
            self.missionAgreement = text;
        }
    }
})();

(function () {

	angular
		.module('pixerf')
		.factory('submitFrameMissionPopupSvc', submitFrameMissionPopupSvc);

	submitFrameMissionPopupSvc.$inject = ['$uibModal'];

	function submitFrameMissionPopupSvc($uibModal) {

		function showPopup(data) {
			return $uibModal.open({
				templateUrl: 'app/components/submit-frame-mission-popup/submit-frame-mission-popup.html',
				controller: 'submitFrameMissionPopupCtrl',
				controllerAs: 'vm',
				animation: true,
				windowClass: 'submit-frame-mission-popup__screen',
				backdrop: 'static',
				resolve: {
					popupData: function () {
						return data;
					}
				}
			});
		}

		return {
			showPopup: showPopup
		};
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('submitFrameMissionPopupCtrl', submitFrameMissionPopupCtrl);

	submitFrameMissionPopupCtrl.$inject = ['pixerfApiMissionSvc', 'popupData', '$uibModalStack', 'uploadPhotoSvc', 'selectMyPhotoPopupSvc', 'toastr', '$translate', 'translationSvc', 'messageSvc', '$scope', '$rootScope', 'alertMessagePopupSvc', 'confirmPopupSvc', '$uibModalInstance', '$q', 'fileUtils', 'pixerfApiMediaSvc'];

	function submitFrameMissionPopupCtrl(pixerfApiMissionSvc, popupData, $uibModalStack, uploadPhotoSvc, selectMyPhotoPopupSvc, toastr, $translate, translationSvc, messageSvc, $scope, $rootScope, alertMessagePopupSvc, confirmPopupSvc, $uibModalInstance, $q, fileUtils, pixerfApiMediaSvc) {

		var self = this;
		var savedData = [];
		self.mission = popupData ? popupData.mission : null;
		self.closePopup = closePopup;
		self.onUploadNewPhotoBtnClicked = onUploadNewPhotoBtnClicked;
		self.onUploadFromMineBtnClicked = onUploadFromMineBtnClicked;
		self.onMissionAgreed = onMissionAgreed;
		self.numberOfFrames = new Array(self.mission.number_of_frames);
		self.isFormDirty = false;
		self.fromMinePhotos = false;
		self.uploadNewPhoto = false;
		self.storedPhoto = 1;
		self.uploadPhotos = [];
		self.existPhotoIds = {
			participations: []
		};
		self.selectedPhotos = [];

		init();

		function closePopup() {
			if (self.selectedPhotos.length) {
				savedData = buildSavedFilesData(self.selectedPhotos);
			}
			confirmPopupSvc.showPopup({
				windowClass: 'cancel-upload-frame-mission-popup',
				title: 'Are you sure you want to cancel your upload?',
				message: 'Your previous upload(s) will not be saved.',
				cancelBtnText: 'Continue with upload',
				submitBtnText: 'Yes, cancel',
				submit: function () {
					var def = $q.defer();
					pixerfApiMediaSvc.multipleUpdate({
						api_version: 'new'
					}, savedData).$promise.then(function (res) {
						def.resolve(res);
					}).catch(function (err) {
						def.reject(err);
					})
					return def.promise;
				},
				submitCallback: function () {
					$uibModalStack.dismissAll();
				}
			});

		}

		function buildSavedFilesData(files) {
			var arr = [];
			for (var i = 0; i < files.length; i++) {
				arr.push({
					id: files[i].id,
					in_mission: false
				});
			}
			return arr;
		}

		function checkAgreeAgreement() {
			var errMsg = "";
			if (!self.mission.is_agreement_accepted) {
				self.isFormDirty = true;
				errMsg = "Please agree to the Missions Agreement!";
			}
			return errMsg;
		}

		function onUploadNewPhotoBtnClicked() {
			var errMsg = checkAgreeAgreement();
			if (errMsg) {
				toastr.error(errMsg);
				return;
			}
			popupData.isHideFooter = true;
			popupData.noMorePhotos = true;
			popupData.manualProcess = true;
			self.uploadNewPhoto = true;
			uploadPhotoSvc.showUploadModal(popupData);
		}

		function buildSavedData(photoIds, missionId) {
			photoIds.participations.forEach(function (element) {
				element.mission_id = missionId;
			});
			return photoIds;
		}

		$rootScope.$on('uploadPhoto', function (event, data) {
			if (data.fileIds && data.fileIds.participations && data.fileIds.participations.length) {
				self.existPhotoIds.participations = self.existPhotoIds.participations.concat(data.fileIds.participations);
				self.selectedPhotos = self.selectedPhotos.concat(data.medias);
				self.storedPhoto += data.fileIds.participations.length;
			} else {
				self.uploadPhotos.push(data.files[0]);
				self.selectedPhotos = self.selectedPhotos.concat(data.files[0]);
				self.storedPhoto++;
			}
			if (self.storedPhoto === (self.mission.number_of_frames + 1)) {
				if (self.fromMinePhotos && self.uploadNewPhoto) {
					uploadPhotoSvc.publish(self.uploadPhotos, data.mission).$promise.then(function (reponse) {
						var postData = buildSavedData(self.existPhotoIds, data.mission.id);
						return pixerfApiMissionSvc.submit_participations({
							id: data.mission.id
						}, postData).$promise;
					}).then(function () {
						$uibModalInstance.close({
							numberPhoto: self.storedPhoto - 1
						});
						alertMessagePopupSvc.showPopup({
							title: "All the Best!",
							description: "Your " + self.mission.number_of_frames + " photos have been submitted for review. It may take a few days for your photos to appear in Mission Submissions."
						});
					})
				} else if (self.uploadNewPhoto) {
					uploadPhotoSvc.publish(self.uploadPhotos, data.mission).$promise.then(function (reponse) {
						$uibModalInstance.close({
							numberPhoto: self.storedPhoto - 1
						});
						alertMessagePopupSvc.showPopup({
							title: "All the Best!",
							description: "Your " + self.mission.number_of_frames + " photos have been submitted for review. It may take a few days for your photos to appear in Mission Submissions."
						});
					})
				} else if (self.fromMinePhotos) {
					var postData = buildSavedData(self.existPhotoIds, data.mission.id);
					pixerfApiMissionSvc.submit_participations({
						id: data.mission.id
					}, postData).$promise.then(function (response) {
						$uibModalInstance.close({
							numberPhoto: self.storedPhoto - 1
						});
						alertMessagePopupSvc.showPopup({
							title: "All the Best!",
							description: "Your " + self.mission.number_of_frames + " photos have been submitted photos for review. It may take a few days for your photos to appear in Mission Submissions."
						});
					})
				}
			}
		})

		function onUploadFromMineBtnClicked() {
			var errMsg = checkAgreeAgreement();
			if (errMsg) {
				toastr.error(errMsg);
				return;
			}
			popupData.manualProcess = true;
			self.fromMinePhotos = true;
			selectMyPhotoPopupSvc.showPopup(popupData);
		}

		function onMissionAgreed() {
			pixerfApiMissionSvc.agree_agreement({
				id: self.mission.id
			}, {}).$promise.then(function () {
				self.mission.is_agreement_accepted = true;
			}, function () {
				self.mission.is_agreement_accepted = false;
				toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
			})
		}

		function init() {
			compileAgreementText();
		}

		function compileAgreementText() {
			var text = "";
			text = $translate.instant("submission-popup-agreement", {
				'agreement': $translate.instant('missions-agreement-link')
			});
			self.missionAgreement = messageSvc.compile(text);
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('stickCheckbox', stickCheckbox);

	stickCheckbox.$inject = [];

	function stickCheckbox() {
		return {
			restrict: 'E',
			replace: true,
			templateUrl: 'app/components/stick-checkbox/stick-checkbox.html',
			scope: {
				model: "=",
				label: "@",
				customClass: "@",
				layoutStyle: "@",
				modelProperty: "@",
				onChanged: '&',
				isDisabled: '=',
				error: '=',
				authenticationCheck: '=',
				isReversed: '=',
				group: '@',
			},
			link: function (scope, element) {
				scope.toogle = function (evt) {
					evt.stopPropagation();
					if (scope.isDisabled) return;
					if (typeof scope.model[scope.modelProperty] !== 'boolean' && scope.isReversed) {
						scope.model[scope.modelProperty] = false;
					} else if (scope.group) {
						scope.model = _.mapObject(scope.model, function (val, key) {
							return val = false;
						})
						scope.model[scope.modelProperty] = true;
					} else {
						scope.model[scope.modelProperty] = !scope.model[scope.modelProperty];
					}
					scope.onChanged({
						data: scope.model
					});
				}

			}
		};
	}
})();

(function () {
    'use strict';

    angular
        .module('pixerf')
        .controller('starItemCtrl', starItemCtrl);

    starItemCtrl.$inject = ['$scope', 'pixerfConfirmPopupSvc', 'pixerfApiGallerySvc', 'pixerfApiMediaSvc', 'toastr', 'sessionManagerSvc'];

    function starItemCtrl($scope, pixerfConfirmPopupSvc, pixerfApiGallerySvc, pixerfApiMediaSvc, toastr, sessionManagerSvc) {

        var self = this;
        self.isWorking = false;
        self.loginUser = sessionManagerSvc.getCurrentLoginUser().data;
        self.onRemoveStarBtnClick = onRemoveStarBtnClick;

        function onRemoveStarBtnClick(star) {
            if (self.isWorking) return;
            self.isWorking = true;
            var warningMessage = "Are you sure to remove this star?";
            var pixerfConfirmPopup = pixerfConfirmPopupSvc.showPopup({
                hideTitle: true,
                hideConfirmText: true,
                message: warningMessage
            });

            pixerfConfirmPopup.result.then(function () {
                var reqParams = {
                    id: star.id
                };
                var service;
                if ($scope.ownerType === 'gallery') {
                    reqParams.gallery_id = $scope.ownerId;
                    service = pixerfApiGallerySvc;
                } else {
                    reqParams.media_id = $scope.ownerId;
                    service = pixerfApiMediaSvc;
                }
                service.overrideUnstar(reqParams).$promise.then(function (response) {
                    $scope.onStarRemoved({star: star});
                    toastr.success("Star has been successfully removed!");
                    self.isWorking = false;
                }, function () {
                    toastr.error("Oops! Failed to remove this star. Please try again.");
                    self.isWorking = false;
                });
            }, function () {
                self.isWorking = false;
            });
        }

    }
})();
(function () {
  'use strict';

  angular
    .module('pixerf')
    .directive('starItem', starItem);

  function starItem() {

    var directive = {
      scope: {
        "star": "=",
        "ownerType": "@",
        "ownerId": "=",
        "onStarRemoved": "&?"
      },
      restrict: 'E',
      templateUrl: 'app/components/star-item/star-item.html',
      controller: 'starItemCtrl',
      controllerAs: 'vm',
      replace: true
    };
    return directive;
  }

})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('starBtnCtrl', starBtnCtrl);

    starBtnCtrl.$inject = ['$scope', 'pixerfApiMediaSvc', 'pixerfApiGallerySvc', 'toastr', 'sessionManagerSvc', 'curatorStarPopupSvc', 'translationSvc'];

    function starBtnCtrl($scope, pixerfApiMediaSvc, pixerfApiGallerySvc, toastr, sessionManagerSvc, curatorStarPopupSvc, translationSvc) {

        var self = this;
        self.onStarBtnClicked = onStarBtnClicked;
        self.loginnedUser = sessionManagerSvc.getCurrentLoginUser().data;
        self.isWorking = false;
        self.getStarCount = getStarCount;
        self.onMouseInCuratorStars = onMouseInCuratorStars;
        self.updateTooltip = updateTooltip;
        self.tooltipsCurators = [];
        var LOADING_TEXT = "loading...";

        function onStarBtnClicked(target, e){
            console.log(e.metaKey);
            if (self.loginnedUser.canOverrideCuration && e.altKey && target.star_count > 0){
                e.preventDefault();
                self.curatorStarPopup = curatorStarPopupSvc.showPopup({type: $scope.targetType, target: $scope.target, onStaredToggled: $scope.onStaredToggled});
                return;
            }
            var action = target.is_starred ? "delete_star" : "star";
            if(self.isWorking) return;
            self.isWorking = true;
            var service = pixerfApiMediaSvc;
            if($scope.targetType === "gallery"){
                service = pixerfApiGallerySvc;
            }
            service[action]({id: target.id}, {}).$promise.then(function(){
                self.isWorking = false;
                target.is_starred = !target.is_starred;
                var step = target.is_starred ? 1 : -1;
                target.star_count += step;
                self.updateTooltip(target);
                $scope.onStaredToggled({target: target});
            }, function(){
                self.isWorking = false;
                toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
            });
        }

        function getStarCount(starNumber){
            return starNumber > 999 ? (starNumber/1000).toFixed(1) + 'K' : starNumber;
        }

        function onMouseInCuratorStars(target){
            if(target.star_count === self.tooltipsCurators.length){
                return;
            }
            self.updateTooltip(target);
        }

        function updateTooltip(target){
            self.tooltipsCurators = [];
            self.tooltipsCurators.push(LOADING_TEXT);
            var service = $scope.targetType === "gallery" ? pixerfApiGallerySvc:  pixerfApiMediaSvc;
            service.get_stars({id: target.id}).$promise.then(function(response){
                self.tooltipsCurators = [];
                for(var i=0; i < response.data.length; i++){
                    self.tooltipsCurators.push(self.loginnedUser.id === response.data[i].user.id ? 'You' : response.data[i].user.first_name);
                }
            });
        }
    }
})();

(function () {
  'use strict';

  angular
    .module('pixerf')
    .directive('starBtn', starBtn);

  function starBtn() {

    var directive = {
      scope: {
        "target" : "=",
        "targetType": "=",
        "onStaredToggled": "&",
        "hoverShowNumber" : "=",
        "isShowTooltip": "=?"
      },
      restrict: 'E',
      templateUrl: 'app/components/star-btn/star-btn.html',
      controller: 'starBtnCtrl',
      controllerAs: 'vm',
      replace: true
    };
    return directive;
  }

})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.factory('splashMessagePopupSvc', splashMessagePopupSvc);
	splashMessagePopupSvc.$inject = ['$uibModal', 'store', '$state'];

	function splashMessagePopupSvc($uibModal, store, $state) {

		var mPopupData = [{
			id: "splashPopupShowFlag_1371",
			startDate: new Date("01/03/2022"),
			endDate: new Date("02/21/2023")
		}];

		function showPopup(data) {
			if ($state.current.name === 'trend-report-landing-page' || $state.current.name === 'trends-report-download-page') {
				return;
			}
			var today = new Date();
			today.setHours(0, 0, 0, 0);
			var isPopupVisible = false;
			for (var key in localStorage) {
				if ((localStorage[key] === "null" || localStorage[key] === "undefined" || key.includes("Popup")) && !["splashPopupShowFlag_1371"].includes(key)) {
					store.remove(key);
				}
			}
			for (var i = 0; i < mPopupData.length; i++) {
				if (!store.get(mPopupData[i].id)) {
					isPopupVisible = true;
				} else {
					isPopupVisible = false;
				}
				var isSignout = store.get("signout");
				if (isSignout) {
					store.set("signout", false);
					return;
				}
				var isSignin = store.get("signin");
				if (isSignin) {
					store.set("signin", false);
					return;
				}
				if (today.getTime() > mPopupData[i].endDate.getTime() && store.get(mPopupData[i].id) != null) {
					store.set(mPopupData[i].id, null);
				}
				if (today.getTime() >= mPopupData[i].startDate.getTime() && today.getTime() <= mPopupData[i].endDate.getTime() && isPopupVisible) {
					return $uibModal.open({
						templateUrl: 'app/components/splash-message-popup/splash-message-popup.html',
						controller: 'splashMessagePopupCtrl',
						controllerAs: 'vm',
						animation: true,
						windowClass: 'splash-message-screen',
						resolve: {
							'resolveData': function () {
								return mPopupData[i];
							}
						}
					});
				}
			}
		}

		return {
			showPopup: showPopup
		};
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('splashMessagePopupCtrl', splashMessagePopupCtrl);

	splashMessagePopupCtrl.$inject = ['$uibModalInstance', '$state', 'store', 'resolveData'];

	function splashMessagePopupCtrl($uibModalInstance, $state, store, resolveData) {

		var self = this;
		self.onCloseBtnClicked = onCloseBtnClicked;
		self.onDontShowAgainClicked = onDontShowAgainClicked;
		self.onCheckboxClicked = onCheckboxClicked;
		self.onFindout = onFindout;
		self.onJoinChallenge = onJoinChallenge;
		self.splashPopupShowFlag = resolveData.id;
		self.popup = resolveData;

		var randomBanner = [
			"../../assets/images/splash-popup/mission-intro-1.png"
		]

		init();

		function init() {
			self.end_date = "2023-02-21";
			self.bannerSrc = randomBanner[0];
		}

		function onCloseBtnClicked() {
			resolveData.visible = false;
			$uibModalInstance.close();
			if (self.isDontShowAgain) {
				store.set(self.splashPopupShowFlag, true);
			} else {
				store.set(self.splashPopupShowFlag, false);
			}
		};

		function onDontShowAgainClicked() {
			if (!self.isDontShowAgain) {
				self.isDontShowAgain = true;
				store.set(self.splashPopupShowFlag, true);
			} else {
				self.isDontShowAgain = false;
				store.set(self.splashPopupShowFlag, false);
			}
		}

		function onCheckboxClicked() {
			if (self.isDontShowAgain) {
				store.set(self.splashPopupShowFlag, true);
			} else {
				store.set(self.splashPopupShowFlag, false);
			}
		}

		function onFindout() {
			$state.go("run-a-challenge-page.live-challenges");
			$uibModalInstance.close();
		}

		function onJoinChallenge(challengeId){
			$state.go("mission-detail-page.brief", {id: challengeId});
			$uibModalInstance.close();
		}

		function getRandomBannerExcept(){
			var randomSrc = 0;
			var randomBan = store.get('challengeBanner');
			var newBanner = [];
			if(randomBan && randomBan.length){
				randomSrc = Math.floor(Math.random() * randomBan.length);
				newBanner = _.reject(randomBan, function (mem) {
					return randomBan[randomSrc] === mem;
				});
				store.set('challengeBanner', newBanner);
				return randomBan[randomSrc];
			} else {
				randomSrc = Math.floor(Math.random() * randomBanner.length);
				newBanner = _.reject(randomBanner, function (mem) {
					return randomBanner[randomSrc] === mem;
				});
				store.set('challengeBanner', newBanner);
				return randomBanner[randomSrc];
			}
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('splashMessagePopup', splashMessagePopup);

	splashMessagePopup.$inject = ['$timeout', 'splashMessagePopupSvc'];

	function splashMessagePopup($timeout, splashMessagePopupSvc) {

		var directive = {
			scope: {},
			restrict: 'E',
			link: function (scope, elem, attrs) {
				$timeout(function () {
					splashMessagePopupSvc.showPopup();
				}, 1800);
			},
			replace: true
		};
		return directive;
	}

})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .directive('spinnerWin', spinnerWin);
    spinnerWin.$inject = [];
    function spinnerWin() {
        return {
            restrict: 'E',
            scope: {
                "spinner": "=",
                "isOverlayMode": "="
            },
            templateUrl: "app/components/spinner-win/spinner-win.html",
            replace: true
        };
    }
})();                                                                  
(function() {
    'use strict';

    angular
        .module('pixerf')
        .directive('spinner', spinner);
    spinner.$inject = [];
    function spinner() {
        return {
            restrict: 'E',
            scope: {
                "spinner": "="
            },
            templateUrl: "app/components/spinner/spinner.html",
            replace: true
        };
    }
})();                                                                  
(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('siteLanguage', siteLanguage);

	siteLanguage.$inject = ['$translate', '$rootScope', "$timeout"];

	function siteLanguage($translate, $rootScope, $timeout) {

		var directive = {
			scope: {},
			restrict: 'E',
			link: function (scope, elem, attrs) {
				$timeout(function () {
					// var initLangSite = $translate.getAvailableLanguageKeys().includes(navigator.language) ? navigator.language : 'en';
					var initLangSite = 'en';
					$translate.use(initLangSite);
					$rootScope.lang = initLangSite;
					$rootScope.$emit("initLang", initLangSite);
				}, 1500);
			},
			replace: true
		};
		return directive;
	}

})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('similarDiscussionTileCtrl', similarDiscussionTileCtrl);

	similarDiscussionTileCtrl.$inject = ['$scope', '$state', 'commonConst'];

	function similarDiscussionTileCtrl($scope, $state, commonConst) {

		var self = this;
		self.commonConst = commonConst;
		self.discussion = $scope.discussion;
		self.goDetailDiscussion = goDetailDiscussion;

		init();

		function init() {
			self.inserted_at = self.discussion.inserted_at ? moment(self.discussion.inserted_at).format('DD MMM YYYY') : "";
		}

		function goDetailDiscussion(discussion) {
			$state.go(self.commonConst.STATE.DISCUSSION_DETAIL, {
				id: discussion.id,
				subject: discussion.subject.replace(/ /g, '-')
			});
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('similarDiscussionTile', similarDiscussionTile);

	function similarDiscussionTile() {

		var directive = {
			scope: {
				"discussion": "="
			},
			restrict: 'E',
			templateUrl: 'app/components/similar-discussion-tile/similar-discussion-tile.html',
			controller: 'similarDiscussionTileCtrl',
			controllerAs: 'vm',
			replace: true
		};
		return directive;
	}

})();

/**
 * Controller for home module
 */
(function(){
  'use strict';
  angular
    .module('pixerf')
    .factory('signupAddRolePopupSvc', signupAddRolePopupSvc);
    signupAddRolePopupSvc.$inject = ['$uibModal'];

    function signupAddRolePopupSvc($uibModal){
        
        var mModal = null;
        function showPopup(data){
            mModal = $uibModal.open({
                size: "lg",
                templateUrl: 'app/components/signup-add-role-popup/signup-add-role-popup.html',
                controller: 'signupAddRolePopupCtrl',
                controllerAs: 'vm',
                openedClass: 'signup-add-role-popup',
                resolve: {
                    popupData: function(){
                        return data;
                    }
                }
            });
        }
        function closePopup(){
            mModal.close();
        }
		return {
			closePopup: closePopup,
            showPopup: showPopup
		};
    }
})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('signupAddRolePopupCtrl', signupAddRolePopupCtrl);

    signupAddRolePopupCtrl.$inject = ['signupAddRolePopupSvc', 'popupData', '$uibModalInstance', 'auth0AuthenticationSvc', 'signUpBusinessSvc'];

    function signupAddRolePopupCtrl(signupAddRolePopupSvc, popupData, $uibModalInstance, auth0AuthenticationSvc, signUpBusinessSvc) {

        var self = this;
        self.user = popupData.user;
        self.onCloseBtnClicked = signupAddRolePopupSvc.closePopup;
        self.onDoneBtnClicked = onDoneBtnClicked;

        self.cancel = function () {
        };
        function onDoneBtnClicked(user, form){
            signUpBusinessSvc.save(user, form);
        }

    }
})();
(function(){

  angular
    .module('pixerf')
    .controller('signatureGallariesSectionCtrl', signatureGallariesSectionCtrl);

    signatureGallariesSectionCtrl.$inject = ['$rootScope', 'homeSvc', 'sessionManagerSvc', 'uploadPhotoSvc'];

    function signatureGallariesSectionCtrl($rootScope, homeSvc, sessionManagerSvc, uploadPhotoSvc){
    	var self = this;
        self.onCategorySelected = changeCategory;
		self.onGallerySelected = homeSvc.selectGallery;
		self.signatureCategories = homeSvc.getCategories();
        self.selectedCategory = homeSvc.getSelectedCategory();
        self.loginUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.onStartUploading = startUpload;
		self.slideInterval = 4000;
		self.slickConfig = {
			"dots": true,
			"infinite": true,
			"speed": "1000",
			"autoplaySpeed": "4000",
			"touch-move": true,
			"autoplay": true,
			"slides-to-scroll": 1
		}

		initSlider();
		function initSlider(){
			$.grep(self.signatureCategories.data.expanded, function(e){
				if(e.name == self.selectedCategory.data.name){
					self.slides = e.galleries;
					for(var i = 0; i < self.slides.length; i++){
						self.slides[i].id = i;
					}
					return;
				}
			});
		}

		function changeCategory(category){
			// $('.trendinggallaries-carousel .carousel-inner').slick('unslick');
			homeSvc.selectCategory(category);
			initSlider();
			// $timeout(function(){
			// 	$('.trendinggallaries-carousel .carousel-inner').slick(self.slickConfig);
			// },2000);
		}

        function startUpload(){
            if(!self.loginUser){
                return;
            } else {
                uploadPhotoSvc.showUploadModal();
            }
        }
    }
})();

(function () {
  'use strict';

  angular
    .module('pixerf')
    .directive('signatureSection', signatureSection);

    signatureSection.$inject = ['$rootScope', '$interval'];
    function signatureSection($rootScope, $interval) {

    var directive = {
      scope: {
          context: "="
        },
        restrict: 'E',
        templateUrl: 'app/components/signature-section/signature-section.html',
        controller: 'signatureGallariesSectionCtrl',
        controllerAs: 'vm',
        replace: true
      };
      return directive;
    }

})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('signatureGalleryBtnCtrl', signatureGalleryBtnCtrl);

        signatureGalleryBtnCtrl.$inject = ['$scope', 'pixerfApiMediaSvc', 'pixerfApiGallerySvc', 'toastr', 'sessionManagerSvc', 'translationSvc'];

    function signatureGalleryBtnCtrl($scope, pixerfApiMediaSvc, pixerfApiGallerySvc, toastr, sessionManagerSvc, translationSvc) {

        var self = this;
        self.onSignatureBtnClicked = onSignatureBtnClicked;
        self.loginnedUser = sessionManagerSvc.getCurrentLoginUser().data;
        self.isWorking = false;

        function onSignatureBtnClicked(target){
            var action = "toggle_signature";
            if(self.isWorking) return;
            self.isWorking = true;
            var service = pixerfApiMediaSvc;
            if($scope.targetType === "gallery"){
                service = pixerfApiGallerySvc;
            }
            service[action]({id: target.id}, {}).$promise.then(function(){
                self.isWorking = false;
                target.is_signature = !target.is_signature;
            }, function(){
                self.isWorking = false;
                toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
            });
        }
    }
})();

(function () {
  'use strict';

  angular
    .module('pixerf')
    .directive('signatureGalleryBtn', signatureGalleryBtn);

  function signatureGalleryBtn() {

    var directive = {
      scope: {
        "target" : "=",
        "targetType": "=",
        "onButtonToggled": "&",
        "hoverShowNumber" : "=",
        "isShowTooltip": "=?"
      },
      restrict: 'E',
      templateUrl: 'app/components/signature-gallery-btn/signature-gallery-btn.html',
      controller: 'signatureGalleryBtnCtrl',
      controllerAs: 'vm',
      replace: true
    };
    return directive;
  }

})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.factory('signInUserSvc', signInUserSvc);
	signInUserSvc.$inject = ['messageAccountConst', '$translate'];

	function signInUserSvc(messageAccountConst, $translate) {
		var mUser = {
			data: null
		};
		var mIsShowPassword = {
			data: false
		};
		function validateUser(form) {
			form.$setDirty();
			var errMsg = ''
			if (form.email.$error.required) {
				errMsg = $translate.instant("input-email") + "!";
			} else if (form.password.$error.required) {
				errMsg = $translate.instant("input-password") + "!";
			} else if (form.password.$error.pattern) {
				errMsg = messageAccountConst.error.validation.password.format;
			}

			return errMsg;
		}
		function reset() {
			mUser.data = null;
			mIsShowPassword.data = false;
		}
		return {
			user: mUser,
			reset: reset,
			validateUser: validateUser,
			isShowPassword: mIsShowPassword,
		};
	}
})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('signInUserCtrl', signInUserCtrl);

	signInUserCtrl.$inject = ['$scope', '$state', 'signInUserSvc', 'resetPasswordSvc', 'authenticationConst', '$stateParams', 'welcomePopupSvc', 'referralsIntroPopoverSvc', 
		'auth0AuthenticationSvc', 'toastr', '$translate', 'sessionManagerSvc', 'translationSvc', 'pixerfApiUserSvc', 'selectSignUpTypePopupSvc'];

	function signInUserCtrl($scope, $state, signInUserSvc, resetPasswordSvc, authenticationConst, $stateParams, welcomePopupSvc, referralsIntroPopoverSvc, 
			auth0AuthenticationSvc, toastr, $translate, sessionManagerSvc, translationSvc, pixerfApiUserSvc, selectSignUpTypePopupSvc) {

		var self = this;
		self.onSignInBtnClicked = onSignInBtnClicked;
		self.showNotBizAccError = false;
		
		self.isShowPassword = signInUserSvc.isShowPassword;

		self.showSignUpModal = function(){
			if($scope.options.customSignupAction){
				return $scope.options.customSignupAction();
			}
			selectSignUpTypePopupSvc.showPopup();
        }
        self.showResetPasswordModal = function(){
            resetPasswordSvc.showResetPasswordModal();
        }
		function onSignInBtnClicked(type, signUpForm){
            if(self.isWorking) return;
            self.isWorking = true;
			if(type === authenticationConst.AUTH0_CONNECTION_TYPE.FACEBOOK ||
				type === authenticationConst.AUTH0_CONNECTION_TYPE.GOOGLE){
                if($stateParams && $stateParams.callback){
                    sessionManagerSvc.setCallbackURL($stateParams.callback);
				}
				if($scope.options.beforeSignin) {
					// sessionManagerSvc.setCallbackURL($state.current.name);
				}
				auth0AuthenticationSvc.signInViaSocialConnection(type).promise.then(function(loginedUser){
					if(!mCallback){
						$state.go("user-home-page.personal.home", {id: loginedUser.id, userName: (loginedUser.displayName | toSnakeCase)});
					}
					if($scope.options.beforeSignin) {
						store.set(accountConst.TOKEN.CREDIT_PLAN_AFTER_SIGNED_PAGE, $state.current.name);
						$scope.options.beforeSignin(loginedUser);
					}
					var welcome = welcomePopupSvc.showPopup(loginedUser);
					welcome.closed.then(function(){
						if(!systemUtils.isMobile()){
							referralsIntroPopoverSvc.showOverlay();
						}
					});
				}, function(err){
					console.log(err);
				});
			} else {
				var errMsg = signInUserSvc.validateUser(signUpForm);
				if (errMsg) {
					toastr.error(errMsg);
					self.isWorking = false;
					return false;
				}
				if ($stateParams.callback) {
					sessionManagerSvc.setCallbackURL($stateParams.callback);
				}
				if ($scope.options.beforeSignin) {
					pixerfApiUserSvc.showUser({email: self.user.data.email}).$promise.then(
						function success(data) {
							if (data.isBiz) {
								$scope.options.beforeSignin({ user: self.user });
								signin();
							} else {
								self.isWorking = false;
								showErrorForNotBusinessAcc();
							}
						}, function error(err) {
							toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
						}
					);

					return;
				}
				signin();

			}
		}
		function showErrorForNotBusinessAcc(){
			self.showNotBizAccError = true;
			self.user.data.email = '';
			self.user.data.password = '';
		}

		function signin(){
			auth0AuthenticationSvc.signInByUserNamePassword(self.user.data).promise.then(function (loginedUser) {
			}, function (err) {
				console.log(err);
				self.isWorking = false;
				toastr.error($translate.instant('oops-entered-wrong-email-password'));
			});
		}

        signInUserSvc.reset();
    }
})();
(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('signInUser', signInUser);

	signInUser.$inject = [];

	function signInUser() {
		return {
			scope: {
				"customSignupText": "@?",
				"customSignupHeaderText": "@?",
				"hiddenLoginBySocial": "=?",
				"options": "="
			},
			restrict: 'E',
			replace: true,
			templateUrl: 'app/components/sign-in-user/sign-in-user.html',
			controller: "signInUserCtrl",
            controllerAs: 'vm'
		};
	}
})();
(function(){
  'use strict';
  angular
    .module('pixerf')
    .factory('signInSvc', signInSvc);
    signInSvc.$inject = ['toastr', '$uibModalStack', '$uibModal', 'messageAccountConst', '$translate'];

    function signInSvc(toastr, $uibModalStack, $uibModal, messageAccountConst, $translate){
		var mUser = {
            data: null
        };
		var mMessage = {
			data: null
		};
        var mPixerfAlert = {data: null};

        function getPixerfAlert(){
        	return mPixerfAlert;
        }
		function getMessage(){
			return mMessage;
		}
		function setMessage(message){
			mMessage.data = message;
		}
		function showSignInModal(data){
			$uibModalStack.dismissAll();
	    	$uibModal.open({
				templateUrl: 'app/components/sign-in/sign-in.html',
				controller: 'signInModalCtrl',
				controllerAs: 'vm',
				animation: true,
				windowClass: 'sign-in-screen',
				resolve: {
					data: function () {
						return data;
					}
				}
		    }).rendered.then(function(){
		    	if(!data) return;
				if(data.message){
					toastr.info(data.message);
				}
		    });

    	}
		function validateUser(form){
			form.$setDirty();
			var errMsg = ''
			if(form.email.$error.required){
				errMsg = $translate.instant("input-email") + "!";
			} else if(form.password.$error.required){
				errMsg = $translate.instant("input-password") + "!";
			} else if(form.password.$error.pattern){
                errMsg =  messageAccountConst.error.validation.password.format;
            }

			return errMsg;
		}
		function reset(){
			mUser.data = null;
			mMessage.data = null;
		}
		return {
			user : mUser,
			getPixerfAlert: getPixerfAlert,
			showSignInModal: showSignInModal,
			reset: reset,
			validateUser: validateUser,
			setMessage: setMessage,
			getMessage: getMessage
		};
    }
})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('signInModalCtrl', signInModalCtrl);

    signInModalCtrl.$inject = ['$stateParams', '$state', 'sessionManagerSvc','$scope', 'signInSvc', '$uibModalInstance', 'resetPasswordSvc', 'auth0AuthenticationSvc', 'welcomePopupSvc', 'authenticationConst', '$translate', 'toastr', 'signUpPersonalPopupSvc'];

    function signInModalCtrl($stateParams, $state, sessionManagerSvc, $scope, signInSvc, $uibModalInstance, resetPasswordSvc, auth0AuthenticationSvc, welcomePopupSvc, authenticationConst, $translate, toastr, signUpPersonalPopupSvc) {

        var self = this;
        self.user = signInSvc.user;
        self.userValidation = signInSvc.userValidation;
        self.onSignInBtnClicked = onSignInBtnClicked;
        self.isWorking = false;
        self.pixerfAlert = signInSvc.getPixerfAlert();
        var mCallback = $stateParams.callback;

        signInSvc.reset();

        self.showSignUpModal = function(){
            $uibModalInstance.dismiss('cancel');
            signUpPersonalPopupSvc.showPopup();
        }
        self.showResetPasswordModal = function(){
            $uibModalInstance.dismiss('cancel');
            resetPasswordSvc.showResetPasswordModal();
        }
        self.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
        $scope.$watch("vm.pixerfAlert.data", function(){
            var message = signInSvc.getMessage().data;
            if(message){
                toastr.error(message);
                signInSvc.setMessage(null);
            }
        });
        function onSignInBtnClicked(type, signUpForm){
            console.log($stateParams);
            if(self.isWorking) return;
            self.isWorking = true;
            if(type === authenticationConst.AUTH0_CONNECTION_TYPE.FACEBOOK ||
                type === authenticationConst.AUTH0_CONNECTION_TYPE.GOOGLE){
                if($stateParams && $stateParams.callback){
                    sessionManagerSvc.setCallbackURL($stateParams.callback);
                }
				auth0AuthenticationSvc.signInViaSocialConnection(type).promise.then(function(loginedUser){
					$uibModalInstance.close();
                    if(!mCallback){
                        $state.go("user-home-page.personal.home", {id: loginedUser.id, userName: (loginedUser.displayName | toSnakeCase)});
                    }
                    var welcome = welcomePopupSvc.showPopup(loginedUser);
                    welcome.closed.then(function(){
                        if(!systemUtils.isMobile()){
                            referralsIntroPopoverSvc.showOverlay();
                        }
                    });
				}, function(err){
					console.log(err);
				});
			} else {
				var errMsg = signInSvc.validateUser(signUpForm);
				if(errMsg){
                    toastr.error(errMsg);
                    self.isWorking = false;
					return false;
				}
                if($stateParams.callback){
                    sessionManagerSvc.setCallbackURL($stateParams.callback);
                }
				auth0AuthenticationSvc.signInByUserNamePassword(self.user.data).promise.then(function(loginedUser){
				}, function(err){
                    self.isWorking = false;
					console.log(err);
                    toastr.error($translate.instant('oops-entered-wrong-email-password'));
				});

			}
		}

        signInSvc.reset();
    }
})();
(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('signIn1Ctrl', signIn1Ctrl);

    signIn1Ctrl.$inject = ['signInSvc'];

    function signIn1Ctrl(signInSvc) {

        var self = this;
        
        self.showSignInModal = function(){
            signInSvc.showSignInModal();
        }
        self.showSignInModal();
    }
})();
(function() {
  'use strict';

  angular
    .module('pixerf')
    .config(routerConfig);

  routerConfig.$inject = ['$stateProvider'];

  function routerConfig($stateProvider) {
    'ngInject';
    $stateProvider
      .state('login', {
        url: '/login',
        controller: 'signInModalCtrl',
        controllerAs: 'vm'
      });
  }

})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('showcasedGalleryBtnCtrl', showcasedGalleryBtnCtrl);

	showcasedGalleryBtnCtrl.$inject = ['$scope', 'pixerfApiMediaSvc', 'pixerfApiGallerySvc', 'toastr', 'messageConst', 'pixerfConfirmPopupSvc', 'stringUtils'];

	function showcasedGalleryBtnCtrl($scope, pixerfApiMediaSvc, pixerfApiGallerySvc, toastr, messageConst, pixerfConfirmPopupSvc, stringUtils) {

		var self = this;
		self.onShowcasedGalleryBtnClicked = onShowcasedGalleryBtnClicked;
		self.isWorking = false;

		function onShowcasedGalleryBtnClicked(gallery) {
			if (self.isWorking) return;
			var textShowConfirm = gallery.is_showcase ? "remove" : "add";
			pixerfConfirmPopupSvc.showPopup({
				hideTitle: true,
				hideConfirmText: true,
                message: "Are you sure you want to " + textShowConfirm + " <span class='text--bold'>" + stringUtils.toTitleCase(gallery.title) + "</span> as a showcase gallery?",
                okFn: function(){
					self.isWorking = true;
					var action = gallery.is_showcase ? 'remove_showcased_gallery' : 'set_showcased_gallery';
					return pixerfApiMediaSvc[action]({id: gallery.id}, {}).$promise;
                },
                okFnCallback: function(){
					gallery.is_showcase = !gallery.is_showcase;
					self.isWorking = false;
					var textShow = gallery.is_showcase ? "added" : "removed";
					toastr.success("Success! <span class='text--bold'>" + stringUtils.toTitleCase(gallery.title) + "</span> has been " +  textShow + " as a showcase gallery.");
					$scope.onShowcasedGallerySelected({ gallery: gallery });
                }

            })
		}
	}
})();
(function () {
  'use strict';

  angular
    .module('pixerf')
    .directive('showcasedGalleryBtn', showcasedGalleryBtn);

  function showcasedGalleryBtn() {

    var directive = {
      scope: {
		"gallery": "=",
        "onShowcasedGallerySelected": "&?",
      },
      restrict: 'E',
      templateUrl: 'app/components/showcased-gallery-btn/showcased-gallery-btn.html',
      controller: 'showcasedGalleryBtnCtrl',
      controllerAs: 'vm',
      replace: true
    };
    return directive;
  }

})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('shortcutCtrl', shortcutCtrl);

	shortcutCtrl.$inject = ['$scope', 'sessionManagerSvc'];

	function shortcutCtrl($scope, sessionManagerSvc) {

		var self = this;
		var deafaultData = {
			"owner": {
				"icon": null,
				"title": null
			},
			"guest": {
				"icon": null,
				"title": null
			}
		}
		self.dataBinding = {};
		self.user = $scope.user;
		self.data = $scope.data ? $scope.data : deafaultData;
		self.isMine = self.user ? sessionManagerSvc.isMine(self.user) : false;

		genTextAsContext();

		function genTextAsContext() {
			if (self.isMine && self.data.owner) {
				Object.assign(self.dataBinding, self.data.owner);
			} else if (!self.isMine && self.data.guest) {
				Object.assign(self.dataBinding, self.data.guest);
			} else {
				Object.assign(self.dataBinding, self.data);
			}
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('shortcut', shortcut);

	function shortcut() {

		var directive = {
			scope: {
				user: "=?",
				data: "=",
				onButtonClicked: "&",
				tipsRoute: "@?",
				context: "@?"
			},
			templateUrl: 'app/components/shortcut/shortcut.html',
			restrict: 'E',
			controller: 'shortcutCtrl',
			controllerAs: 'vm',
			replace: true
		};
		return directive;
	}

})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('shoppingCartMyCreditBalanceReviewCtrl', shoppingCartMyCreditBalanceReviewCtrl);

	shoppingCartMyCreditBalanceReviewCtrl.$inject = ['$scope', 'numberUtils', 'sessionManagerSvc', 'messageConst', '$rootScope'];

	function shoppingCartMyCreditBalanceReviewCtrl($scope, numberUtils, sessionManagerSvc, messageConst, $rootScope) {
		var self = this;
		self.loginUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.currentBalance = self.loginUser.user_credit_plan ? parseFloat(self.loginUser.user_credit_plan.balance) : 0;
		$scope.$watch('totalToPay', function (totalToPay) {
			self.totalToPay = totalToPay ? parseFloat(totalToPay) : 0;
		});

        $rootScope.$on(messageConst.BROADCAST.USER_DATA_CHANGE, function(){
            if(self.loginUser.id === sessionManagerSvc.getCurrentLoginUser().data.id){
				self.loginUser = sessionManagerSvc.getCurrentLoginUser().data;
				self.currentBalance = self.loginUser.user_credit_plan ? parseFloat(self.loginUser.user_credit_plan.balance) : 0;
			}
		});
	}
})();

(function () {
  'use strict';

  angular
    .module('pixerf')
    .directive('shoppingCartMyCreditBalanceReview', shoppingCartMyCreditBalanceReview);

  function shoppingCartMyCreditBalanceReview() {

    var directive = {
      scope:{
        addCreditBtn: '=',
        totalToPay: '='
      },
      restrict: 'E',
      templateUrl: 'app/components/shopping-cart-my-credit-balance-review/shopping-cart-my-credit-balance-review.html',
      controller: 'shoppingCartMyCreditBalanceReviewCtrl',
      controllerAs: 'vm',
      replace: true
    };
    return directive;
  }

})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .factory('shareSvc', shareSvc);

     shareSvc.$inject = [];

    function shareSvc() {

        return {
          
        };
    }
})();
(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('shareCtrl', shareCtrl);

    shareCtrl.$inject = ['$scope','shareSvc'];

    function shareCtrl( $scope, shareSvc) {
        var self = this;
        self.popoverClass = $scope.settings && $scope.settings.appendToBody ?  'pixerf-share' : '';
        self.popoverClass += $scope.setting && $scope.settings.popoverClass ? ' ' + $scope.settings.popoverClass : '';
        $scope.$watch("contentWillBeShared", function(newValue, oldValue){
            if(newValue != oldValue)
                $scope.contentWillBeShared.url = $scope.contentWillBeShared.url.replace("#/", "#!/");
        });
    }
})();
(function () {
  'use strict';

  angular
    .module('pixerf')
    .directive('share', share);

  function share() {

    var directive = {
      scope: {
        "contentWillBeShared": "=",
        "settings": "=",
        "displayVertical": "="
      },
      restrict: 'E',
      templateUrl: 'app/components/share/share.html',
      controller: 'shareCtrl',
      controllerAs: 'vm',
      replace: true
    };
    return directive;
  }

})();

/**
 * Controller for home module
 */
(function(){
  'use strict';
  angular
    .module('pixerf')
    .factory('addRoleSvc', addRoleSvc);
    addRoleSvc.$inject = ['pixerfApiUserSvc', 'toastr', 'sessionManagerSvc', 'messageAccountConst', 'accountConst', '$uibModal'];

    function addRoleSvc(pixerfApiUserSvc, toastr, sessionManagerSvc, messageAccountConst, accountConst, $uibModal){
		
        var PersonRole = {
            'email': null,
            'role': null
        };
        var mPersonRoles = {
            data: []
        };
        var mRoles = {
            data: accountConst.ROLES()
        };

        function getPersonRoles(user){
            var totalArr = [];
            for (var i = 0; i < accountConst.ROLES.length; i ++ ){
                var roleName = accountConst.ROLES[i].toLowerCase() + "s";
                totalArr.concat(buildPersonRoles(user.organization[roleName], roleName));
            }
            return totalArr;
        }
        function buildPersonRoles(userRoles, role){
            var arr = [];
            for (var i = 0; i < userRoles.length; i ++){
                arr.push({
                    'email': userRoles[i],
                    'role': role
                })
            }
            return arr;
        }
        function validate(personRoles, form){
            for (var i = 0 ; i < personRoles.length; i ++){
                if(form["email_" + i].$error.required){
                    return "Please fill in email";    
                }
                if(form["email_" + i].$error.email){
                    return messageAccountConst.error.validation.email.invalid_format;    
                }
                if(form["role_" + i].$error.required){
                    return "Please fill in role";    
                }
            }
            return "";
        }
        function getPersonRoleByRole(personRoles, role){
            var arrResult = [];
            for (var i = 0; i < personRoles.length; i ++){
                if(personRoles[i].role === role){
                    arrResult.push(personRoles[i].email);
                }
            }
            return arrResult;
        }
        function addPersonRole(personRoles){
            personRoles.data.push({
                'email': '',
                'role': ''
            })
        }
        function removePersonRole(personRoles, index){
            personRoles.data.splice(index, 1);
        }
        function reset(){
        }
        function showPopup(data){

            $uibModal.open({
                size: "lg",
                templateUrl: 'app/components/add-role/add-role-popup.html',
                controller: 'addRoleCtrl',
                controllerAs: 'vm',
                openedClass: 'add-role-modal',
                resolve: {
                    popupData: function(){
                        return data;
                    }
                }
            });
        }
        function buildSavingData(user, savingRoles){
            user.organization.advertisers = getPersonRoleByRole(savingRoles, accountConst.ACCOUNT_ROLE.ADVERTISER);
            user.organization.curator = getPersonRoleByRole(savingRoles, accountConst.ACCOUNT_ROLE.CURATOR);
            user.organization.marketers = getPersonRoleByRole(savingRoles, accountConst.ACCOUNT_ROLE.MARKETER);
        }
		return {
			getPersonRoles: getPersonRoles,
            roles: mRoles,
            addPersonRole: addPersonRole,
            removePersonRole: removePersonRole,
            showPopup: showPopup,
            buildSavingData: buildSavingData
		};
    }
})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('addRoleCtrl', addRoleCtrl);

    addRoleCtrl.$inject = ['$scope', 'addRoleSvc', 'toastr'];

    function addRoleCtrl($scope, addRoleSvc, toastr) {

        var self = this;
        
        self.onSaveBtnClicked = addRoleSvc.save;
        self.roles = addRoleSvc.roles;
        self.personRoles = addRoleSvc.getPersonRoles();
        self.onAddPersonRole = addRoleSvc.addPersonRole;
        self.removePersonRole = addRoleSvc.removePersonRole;

        function save(user, savingRoles, form){
            form.$setDirty();
            var errMsg = addRoleSvc.validate(savingRoles, form);
            if(errMsg){
                toastr.error(errMsg);
                return false;
            }
            buildSavingData(user, savingRoles);
            pixerfApiUserSvc.put(user, function(result){
                $scope.onSuccess();
            }, function(){
                $scope.onError();
                
            })
            
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('setAmbassadorBtnCtrl', setAmbassadorBtnCtrl);

    setAmbassadorBtnCtrl.$inject = ['$scope','pixerfApiUserSvc', 'sessionManagerSvc', 'toastr', '$q', 'pixerfConfirmPopupSvc', 'accountUtils', 'stringUtils', 'badgeUtils', 'translationSvc'];

    function setAmbassadorBtnCtrl( $scope, pixerfApiUserSvc, sessionManagerSvc, toastr, $q, pixerfConfirmPopupSvc, accountUtils, stringUtils, badgeUtils, translationSvc) {

        var self = this;
        self.ambassadorship = null;
        self.isWorking = false;
        self.onClicked = onClicked;
        self.btnLabel = "";

        self.onMouseOver = onMouseOver;
        self.onMouseLeave = onMouseLeave;
        self.isHovering = false;

        var mLoginnedUser = sessionManagerSvc.getCurrentLoginUser().data;

        self.isMine = mLoginnedUser ? mLoginnedUser.id === $scope.user.id : false;

        $scope.$watch('user.ambassadorship', function(newValue, oldValue){
            if($scope.user){
                self.ambassadorship = newValue;
                setBtnLabel();
            }
        });

        function onClicked(){
            if(self.isWorking) return;
            self.isWorking = true;
            var assignConfirmationMessage = "Please choose Ambassadorship type: <div ng-class=\"{'ambassadorship-type-selection-form--submitted': vm.isSubmmited}\" class=\"ambassadorship-type-selection-wrapper\"><div><pixerf-radio-btn is-required=true model=\"vm.resolveData.model\" property=\"ambassadorship\" value=\"'pro'\"></pixerf-radio-btn><span>Pro</span></div><div><pixerf-radio-btn model=\"vm.resolveData.model\" property=\"ambassadorship\" value=\"'maestro'\" is-required=true></pixerf-radio-btn><span>Maestro</span></div></div>";
            var warningMessage = !!self.ambassadorship ? "Are you sure you want to unassign this user as Ambassador?" : assignConfirmationMessage;

            setBtnLabel();//this is for issue: mouseoleave not fire due to the modal backdrop
            var pixerfConfirmPopup = pixerfConfirmPopupSvc.showPopup({
                hideTitle: true,
                hideConfirmText: true,
                message: warningMessage,
                windowClass: 'set-ambassador-btn-confirmation-popup',
                model: self,
                okFn: function(form){
                    var def = $q.defer();
                    if(!self.ambassadorship){
                        toastr.error("Please choose Ambassadorship type");
                        def.reject();
                        return def.promise;
                    }
                    pixerfApiUserSvc.toogle_ambassadorship({id: $scope.user.id, type: self.ambassadorship}, null).$promise.then(function(response){
                        if(!response.status){
                            self.ambassadorship = null;
                        }
                        def.resolve();
                    }, function(){
                        toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
                        def.reject;
                    });
                    return def.promise;
                },
                okFnCallback: function(){
                    self.isWorking = false;
                    $scope.user.ambassadorship = self.ambassadorship;
                    setBtnLabel();
                    var successfulMesage = !self.ambassadorship ? "This user profile has been successfully unassigned as Ambassador!" : ("This user profile has been successfully set as Ambassador " +  stringUtils.toTitleCase(self.ambassadorship)  + "!");
                    toastr.success(successfulMesage);
                    self.isHovering = false;
                    $scope.user.badges = badgeUtils.updateBadgesByAmbassadorship($scope.user.badges, self.ambassadorship);
                    if(self.isMine){
                        updateCurrentLoginUser();
                    }
                    if($scope.onAmbassadorshipChanged){
                        $scope.onAmbassadorshipChanged({"ambassadorship": self.ambassadorship});
                    }
                }
            })
            pixerfConfirmPopup.result.then(function(){},function(){
                self.isWorking = false;
                self.ambassadorship = $scope.user.ambassadorship;
            });

        }
        function setBtnLabel(){
            self.btnLabel = self.ambassadorship ? ("Ambassador " + stringUtils.toTitleCase(self.ambassadorship))  : "Set as Ambassador";
        }
        function onMouseOver(){
            if(!self.ambassadorship) return;
            self.isHovering = true;
            self.btnLabel =  "Unassign as Ambassador";
        }
        function updateCurrentLoginUser(ambassadorship){
            mLoginnedUser = sessionManagerSvc.getCurrentLoginUser().data;
            mLoginnedUser.ambassadorship = $scope.user.ambassadorship;
            mLoginnedUser.badges = $scope.user.badges;
            accountUtils.transformUserData(mLoginnedUser);
            sessionManagerSvc.setCurrentLoginUser(mLoginnedUser);
        }
        function onMouseLeave(){
            self.isHovering = false;
            if(!self.ambassadorship) return;
            self.btnLabel =  "Ambassador " + stringUtils.toTitleCase(self.ambassadorship);
        }
    }
})();

(function () {
  'use strict';

  angular
    .module('pixerf')
    .directive('setAmbassadorBtn', setAmbassadorBtn);

  function setAmbassadorBtn() {

    var directive = {
      scope: {
        "user" : "=",
        "visibility": "=",
        "loginUser": "=",
        "onAmbassadorshipChanged": "&"
      },
      restrict: 'E',
      templateUrl: 'app/components/set-ambassador-btn/set-ambassador-btn.html',
      controller: 'setAmbassadorBtnCtrl',
      controllerAs: 'vm',
      replace: true
    };
    return directive;
  }

})();

/**
 * Controller for resend verification email popup module
 */
(function(){
  'use strict';
  angular
    .module('pixerf')
    .factory('sendReleaseFormEmailPopupSvc', sendReleaseFormEmailPopupSvc);
    sendReleaseFormEmailPopupSvc.$inject = ['$uibModalStack', '$uibModal', 'sessionManagerSvc', 'pixerfApiMediaSvc', 'toastr'];

    function sendReleaseFormEmailPopupSvc($uibModalStack, $uibModal, sessionManagerSvc, pixerfApiMediaSvc, toastr){
        var mPixerfAlert = {data: null};
        function showPopup(){
            return $uibModal.open({
                templateUrl: 'app/components/send-release-form-email-popup/send-release-form-email-popup.html',
                controller: 'sendReleaseFormEmailPopupCtrl',
                controllerAs: 'vm',
                animation: true,
                windowClass: 'zindex send-release-form-email-popup-modal',
                backdrop: false
            });
        }
        function getPixerfAlert(){
        	return mPixerfAlert;
        }
        return {
            showPopup: showPopup,
            getPixerfAlert: getPixerfAlert
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('sendReleaseFormEmailPopupCtrl', sendReleaseFormEmailPopupCtrl);

    sendReleaseFormEmailPopupCtrl.$inject = ['$uibModalInstance', 'sendReleaseFormEmailPopupSvc', 'pixerfApiMediaSvc', '$timeout', 'toastr', 'translationSvc'];

    function sendReleaseFormEmailPopupCtrl($uibModalInstance, sendReleaseFormEmailPopupSvc, pixerfApiMediaSvc, $timeout, toastr, translationSvc) {

        var self = this;
        self.isWorking = false;
        self.pixerfAlert = sendReleaseFormEmailPopupSvc.getPixerfAlert();
        self.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
        self.onSendEmailBtnClicked = onSendEmailBtnClicked;
        function onSendEmailBtnClicked(){
            self.isWorking = true;
            pixerfApiMediaSvc.send_release_form().$promise.then(function(){
                self.isWorking = false;
                toastr.success("The release forms have been sent to your registered email address. <br/> Please fill up and upload the relevant release form(s).");
                $timeout(function(){
                    self.cancel();
                }, 3000)
            }, function(){
                self.isWorking = false;
                toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
            })
        }
    }
})();

(function () {
  'use strict';
  angular
    .module('pixerf')
    .factory('selectTypeRejectPhotoPopupSvc', selectTypeRejectPhotoPopupSvc);
  selectTypeRejectPhotoPopupSvc.$inject = ['$uibModal'];

  function selectTypeRejectPhotoPopupSvc($uibModal) {

    function showPopup(data) {
      return $uibModal.open({
        templateUrl: 'app/components/select-type-reject-photo-popup/select-type-reject-photo-popup.html',
        controller: 'selectTypeRejectPhotoPopupCtrl',
        controllerAs: 'vm',
        animation: true,
        windowClass: 'select-type-reject-photo-popup',
        resolve: {
          'resolveData': function () {
            return data;
          }
        }
      });
    }

    return {
      showPopup: showPopup
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('pixerf')
    .controller('selectTypeRejectPhotoPopupCtrl', selectTypeRejectPhotoPopupCtrl);

  selectTypeRejectPhotoPopupCtrl.$inject = ['$uibModalInstance', 'resolveData', 'pixerfCuratorRejectPhotoPopupSvc'];

  function selectTypeRejectPhotoPopupCtrl($uibModalInstance, resolveData, pixerfCuratorRejectPhotoPopupSvc) {

    var self = this;

    self.file = resolveData.file;
    self.onRejectClicked = onRejectClicked;
    self.closePopup = closePopup;

    function onRejectClicked(type) {
      pixerfCuratorRejectPhotoPopupSvc.showPopup({ file: self.file, type: type });
      closePopup();
    }

    function closePopup() {
      $uibModalInstance.close();
    }
  }
})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.factory('selectNewExistCoverPopupSvc', selectNewExistCoverPopupSvc);
	selectNewExistCoverPopupSvc.$inject = ['$uibModal'];

	function selectNewExistCoverPopupSvc($uibModal) {

		function showPopup(data) {
			return $uibModal.open({
				templateUrl: 'app/components/select-new-exist-cover-popup/select-new-exist-cover-popup.html',
				controller: 'selectNewExistCoverPopupCtrl',
				controllerAs: 'vm',
				animation: true,
				windowClass: 'select-new-exist-cover-popup__screen',
				resolve: {
					'resolveData': function () {
						return data;
					}
				}
			});
		}

		return {
			showPopup: showPopup
		};
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('selectNewExistCoverPopupCtrl', selectNewExistCoverPopupCtrl);

	selectNewExistCoverPopupCtrl.$inject = ['$uibModalInstance', 'resolveData', 'uploadProfilePhotoSvc', 'pixerfApiUserSvc', 'settingSvc', 'sessionManagerSvc', 'selectExistPhotosPopupSvc'];

	function selectNewExistCoverPopupCtrl($uibModalInstance, resolveData, uploadProfilePhotoSvc, pixerfApiUserSvc, settingSvc, sessionManagerSvc, selectExistPhotosPopupSvc) {

		var self = this;

		self.onUploadNewPhotoBtnClicked = onUploadNewPhotoBtnClicked;
		self.onUploadFromMineBtnClicked = onUploadFromMineBtnClicked;
		self.closePopup = closePopup;
		self.user = sessionManagerSvc.getCurrentLoginUser().data;

		function onUploadNewPhotoBtnClicked() {
			var modal = uploadProfilePhotoSvc.showPopup({
				'type': 'cover'
			});
			modal.result.then(function (data) {
				var userImage = {
					cover_image: data.thumbnails["1200x"]
				};
				if (self.user.isBiz && self.user.isAdmin) {
					pixerfApiUserSvc.put({}, userImage).$promise.then(function () {
						settingSvc.updateUserProfilePhotos(self.user, 'cover', data.thumbnails);
						closePopup(data.thumbnails);
					})
				} else {
					settingSvc.updateUserProfilePhotos(self.user, 'cover', data.thumbnails);
					closePopup(data.thumbnails);
				}
			});
		}

		function onUploadFromMineBtnClicked() {
			var existPhotoPopup = selectExistPhotosPopupSvc.showPopup({
				type: 'user_photo',
				userId: self.user.id,
				options: {
					title: 'Select existing photos'
				}
			});

			existPhotoPopup.result.then(function (data) {
				var cover_image = data.thumbnails["1200x"];
				pixerfApiUserSvc.update_cover({}, {
					url: cover_image
				}).$promise.then(function () {
					settingSvc.updateUserProfilePhotos(self.user, 'cover', data.thumbnails);
					closePopup(data.thumbnails);
				})
			})
		}

		function closePopup() {
			$uibModalInstance.close();
		}
	}
})();

(function(){

	angular
		.module('pixerf')
		.factory('selectMyPhotoPopupSvc', selectMyPhotoPopupSvc);

	selectMyPhotoPopupSvc.$inject = ['$uibModal', 'pixerfApiMissionSvc', '$q', 'sessionManagerSvc', 'resendVerificationEmailPopupSvc'];

	function selectMyPhotoPopupSvc($uibModal, pixerfApiMissionSvc, $q, sessionManagerSvc, resendVerificationEmailPopupSvc) {

		function showPopup(data){
			var loginUser = sessionManagerSvc.getCurrentLoginUser().data;
			$uibModal.open({
				templateUrl: 'app/components/select-my-photo-popup/select-my-photo-popup.html',
				controller: 'selectMyPhotoPopupCtrl',
				controllerAs: 'vm',
				size: "lg",
				animation: true,
				windowClass: 'zindex select-my-photo',
				backdrop: 'static',
				resolve: {
					popupData: function(){
						var def = $q.defer();
						if(!data.excludes){
							pixerfApiMissionSvc.get_participations({id: data.mission.id, type: 'self'}).$promise.then(function(response){
								data.excludes = response.data;
								def.resolve(data);
							}, function(){
								def.reject(data);
								toastr.error("Failed to get your submitted entries! Please try again!");
							});
						} else{
							def.resolve(data);
						}
						return def.promise;
					}
				}
			});
		}

		return {
			showPopup: showPopup
		};
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('selectMyPhotoPopupCtrl', selectMyPhotoPopupCtrl);

	selectMyPhotoPopupCtrl.$inject = ['fileConst', '$timeout', 'popupData', '$scope', '$uibModalInstance', 'searchInputSvc', 'sessionManagerSvc', '$state', 'toastr', 'messageConst', 'pixerfApiMissionSvc', '$translate', 'commonConst', 'translationSvc', '$rootScope', 'confirmPopupSvc'];

	function selectMyPhotoPopupCtrl(fileConst, $timeout, popupData, $scope, $uibModalInstance, searchInputSvc, sessionManagerSvc, $state, toastr, messageConst, pixerfApiMissionSvc, $translate, commonConst, translationSvc, $rootScope, confirmPopupSvc) {

		var self = this;
		var submissionErrors = [];
		self.photoGrid = null;
		self.tags = {
			data: []
		};
		self.search = search;
		self.loginnedUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.closePopup = closePopup;
		self.onSearchBtnClicked = onSearchBtnClicked;
		self.onPhotoSelected = onPhotoSelected;
		self.onSubmitPhotoToMissionClicked = onSubmitPhotoToMissionClicked;
		self.selectedPhotos = [];
		self.onBeforeGridRender = onBeforeGridRender;
		self.mission = popupData.mission;
		self.manualProcess = popupData.manualProcess;
		self.isSingleSelect = self.mission && self.mission.is_multi_frame;
		self.selectPhotoTitle = self.mission.is_ioa ? '10 entries across the <span class="text--style-italic">Images of Asia</span> Missions.' : '6 photos per Mission.'
		self.isWorking = false;
		self.keyWordsFormatted = "";

		function closePopup() {
			if (self.isSingleSelect && self.selectedPhotos.length) {
				var indexSelectedPhoto = _.findIndex(popupData.excludes, function (p) {
					return p.id === self.selectedPhotos[0].id;
				})
				popupData.excludes.splice(indexSelectedPhoto, 1);
			}
			$uibModalInstance.close();
		}

		init();

		function init() {
			$scope.$watch("vm.photoGrid", function () {
				if (self.photoGrid) {
					self.search();
				}
			})
		}

		function onSearchBtnClicked() {
			search();
		}

		function search() {
			var param = {};
			param.keywords = '';
			if (self.tags.data.length > 0) {
				param.keywords = searchInputSvc.buildKeywords(self.tags.data);
			}
			if (self.photoGrid) {
				var params = buildSearchParams(param.keywords);
				self.keyWordsFormatted = param.keywords;
				self.isSearching = true;
				self.photoGrid.fetchPhotos(params, true).then(function () {
					self.isSearching = false;
				});
			}
		}

		function onBeforeGridRender(photos) {
			for (var i = photos.length - 1; i >= 0; i--) {
				var isExisted = _.find(popupData.excludes, function (p) {
					return p.id === photos[i].id;
				})
				if (isExisted) {
					photos.splice(i, 1);
				}
			}
		}

		function buildSearchParams(keywords) {
			var params = {
				page: 1,
				pageSize: 50,
				keywords: keywords,
				username: self.loginnedUser.username,
				sort: ["inserted_at,desc"]
			};
			return params;
		}

		function onPhotoSelected(file) {
			var limitSubmissions = popupData.mission && popupData.mission.user_participation_limit ? popupData.mission.user_participation_limit : fileConst.UPLOAD_PHOTO_VALIDATION.MISSION_LIMIT;
			if (!file.isSelected && !self.mission.is_multi_frame) {
				var balance =  limitSubmissions - (popupData.excludes.length + self.selectedPhotos.length);
				if (popupData.mission.is_ioa) {
					if (popupData.mission.is_ioa && popupData.mission.ioaSubscriber.free_balance) {
						balance = popupData.mission.ioaSubscriber.free_balance - self.selectedPhotos.length;
					} else if (popupData.mission.is_ioa) {
						balance = popupData.mission.ioaSubscriber.total_balance - self.selectedPhotos.length;
					}
				}
				if (balance <= 0 && popupData.mission.is_ioa) {
					toastr.error($translate.instant(messageConst.error.YOU_SELECTED_MAXIMUM_PHOTOS_ALLOWED));
					return;
				} else if (balance <= 0) {
					toastr.error("Hi, " + $translate.instant(messageConst.error.SUBMIT_PER_MISSION, {
						number: limitSubmissions
					}));
					return;
				}
			} else if (!file.isSelected && self.mission.is_multi_frame && self.selectedPhotos.length) {
				return;
			} else if (!file.isSelected && self.mission.is_multi_frame) {
				var balance = self.mission.number_of_frames - (self.mission.my_submissions + self.selectedPhotos.length);
				if (balance <= 0) {
					toastr.error("Hi, " + $translate.instant(messageConst.error.SUBMIT_PER_MISSION, {
						number: self.mission.number_of_frames
					}));
					return;
				}
				popupData.excludes = popupData.excludes.concat(file);
			} else if (file.isSelected && self.mission.is_multi_frame) {
				var indexSelectedPhoto = _.findIndex(popupData.excludes, function (p) {
					return p.id === file.id;
				})
				popupData.excludes.splice(indexSelectedPhoto, 1);
			}
			file.isSelected = !file.isSelected;
			if (file.isSelected) {
				var isExisted = _.find(self.selectedPhotos, function (f) {
					return f.id === file.id;
				})
				if (!isExisted) {
					self.selectedPhotos.push(file);
				}
			} else {
				self.selectedPhotos = _.reject(self.selectedPhotos, function (f) {
					return f.id === file.id
				})
			}
		}

		function buildSavedData(photos, missionId) {
			var participations = _.reduce(photos, function (memo, item) {
				memo.push({
					media_id: item.id,
					mission_id: missionId
				});
				return memo;
			}, []);
			return {
				"participations": participations
			};
		}

		function onSubmitPhotoToMissionClicked() {
			if (self.isWorking) return;
			self.isWorking = true;
			var savedData = buildSavedData(self.selectedPhotos, popupData.mission.id);
			if (self.manualProcess) {
				$rootScope.$broadcast("uploadPhoto", {
					fileIds: savedData,
					mission: popupData.mission,
					medias: self.selectedPhotos
				});
				$uibModalInstance.close();
				return;
			}
			if (popupData.mission.is_ioa) {
				for (var i = 0; i < savedData.participations.length; i++) {
					savedData.participations[i].ioa_subscriber_type = popupData.mission.ioaSubscriber.ioa_subscriber_type;
					savedData.participations[i].ioa_submission_type = popupData.mission.ioaSubscriber.ioa_submission_type;
					savedData.participations[i].ioa_subscriber_email = popupData.mission.ioaSubscriber.ioa_subscriber_email;
				}
			}
			pixerfApiMissionSvc.submit_participations({
				id: popupData.mission.id
			}, savedData).$promise.then(function (response) {
				submissionErrors = filterData(response, 'ERROR');
				if (submissionErrors.length) {
					var descriptionError = submissionErrors.length ? "<div class='description-header'>This photo is already entered in another active mission:</div>" : "<div class='description-header'>These photos are already entered in another active mission:</div>";
					var listNameError = _.pluck(submissionErrors, 'title');
					if (listNameError.length) {
						descriptionError += "</br><span>- "
						descriptionError += listNameError.join("</span></br><span>- ");
					}
					confirmPopupSvc.showPopup({
						windowClass: 'block-submission-submitted-popup',
						hideCloseBtn: true,
						hideSubmitBtn: true,
						message: descriptionError,
						cancelBtnText: 'OK'
					})
				} else {
					toastr.success($translate.instant(messageConst.success.YOUR_PHOTO_SUBMITTED_TO_MISSION));
				}
				$timeout(function () {
					$uibModalInstance.close();
				}, 1500);
			}).catch(function (response) {
				self.isWorking = false;
				var errorMsg = translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true);
				if (response.data && response.data.data && response.data.data.key === 'participation_limit_exceeded') {
					errorMsg = "Hi, " + $translate.instant(messageConst.error.SUBMIT_PER_MISSION, {
						number: self.mission && self.mission.user_participation_limit ? self.mission.user_participation_limit : fileConst.UPLOAD_PHOTO_VALIDATION.MISSION_LIMIT
					});
				}
				toastr.error(errorMsg);
			});
			$uibModalInstance.closed.then(function () {
				if ($state.current.name === commonConst.STATE.MISSION_SUBMISSIONS) {
					$state.reload();
				} else {
					$state.go(commonConst.STATE.MISSION_SUBMISSIONS, null, {
						reload: true
					});
				}
			})
		}

		function filterData(datas, status) {
			var data = _.filter(datas, function (data) {
				return data.status.toUpperCase() === status;
			});
			return data;
		}
	}
})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.factory('selectExistPhotosPopupSvc', selectExistPhotosPopupSvc);
	selectExistPhotosPopupSvc.$inject = ['$uibModal'];

	function selectExistPhotosPopupSvc($uibModal) {

		function showPopup(data) {
			return $uibModal.open({
				templateUrl: 'app/components/select-exist-photos-popup/select-exist-photos-popup.html',
				controller: 'selectExistPhotosPopupCtrl',
				controllerAs: 'vm',
				animation: true,
				backdrop: 'static',
				windowClass: 'select-exist-photos-popup__screen',
				resolve: {
					'resolveData': function () {
						return data;
					}
				}
			});
		}

		return {
			showPopup: showPopup
		};
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('selectExistPhotosPopupCtrl', selectExistPhotosPopupCtrl);

	selectExistPhotosPopupCtrl.$inject = ['$scope', '$uibModalInstance', 'resolveData', 'pagingUtils', 'pixerfApiGallerySvc', 'pixerfApiUserSvc'];

	function selectExistPhotosPopupCtrl($scope, $uibModalInstance, resolveData, pagingUtils, pixerfApiGallerySvc, pixerfApiUserSvc) {

		var self = this;

		self.type = resolveData.type;
		self.objectParams = resolveData.data;
		self.closePopup = closePopup;
		self.onPhotoSelected = onPhotoSelected;
		self.fetchMorePhotos = fetchMorePhotos;
		self.options = resolveData.options || {};
		self.photos = [];
		self.spinner = {
			isVisible: false
		};

		self.searchParams = {
			page: 1
		}

		init();

		function init() {
			fetchPhotos(self.searchParams, true);
		}

		function fetchPhotos(searchParams, isRefresh) {
			if (self.spinner.isVisible) {
				return;
			}
			self.searchParams = searchParams || {};
			self.spinner.isVisible = true;
			self.isNoMorePhotoToLoad = false;

			if (self.type === 'user_photo') {
				self.searchParams.id = resolveData.userId;
				pixerfApiUserSvc.get_medias(self.searchParams, {}).$promise.then(function (response) {
					if (isRefresh) {
						self.photos = [];
					}

					self.spinner.isVisible = false;
					self.photos = self.photos.concat(response.data);
					self.isNoMorePageToLoad = pagingUtils.isNoMorePageToLoad(self.searchParams.page, response);
					self.searchParams.page = searchParams.page;
				}).catch(function (err) {
					console.log(err);
					self.spinner.isVisible = false;
				});
			} else {
				self.searchParams.id = self.objectParams.id;
				pixerfApiGallerySvc.get_medias(self.searchParams).$promise.then(function (response) {
					if (isRefresh) {
						self.photos = [];
					}

					self.spinner.isVisible = false;
					self.photos = self.photos.concat(response.data);
					self.isNoMorePageToLoad = pagingUtils.isNoMorePageToLoad(self.searchParams.page, response);
					self.searchParams.page = searchParams.page;
				}).catch(function (err) {
					console.log(err);
					self.spinner.isVisible = false;
				});
			}
		}

		function fetchMorePhotos() {
			if (self.spinner.isVisible) {
				return;
			}
			self.searchParams.page++;
			fetchPhotos(self.searchParams);
		}

		function closePopup(data) {
			$uibModalInstance.close(data);
		}

		function onPhotoSelected(file) {
			closePopup(file);
		}
	}
})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .service('searchInputSvc', searchInputSvc);

    function searchInputSvc() {
        var mTags={
            data: []
        }
        function getTags(){
            return mTags;
        }
        function setTags(value){
            mTags.data = value;
        }
        function buildKeywords(tags){
            var keywords="";
            for (var i = 0; i < tags.length; i ++){
                keywords+=tags[i].text;
                if(i!== tags.length - 1){
                    keywords+=',';
                }

            }
            return keywords;
        }
        return {
            getTags: getTags,
            setTags: setTags,
            buildKeywords: buildKeywords
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('searchInputCtrl', searchInputCtrl);

    searchInputCtrl.$inject = ['$rootScope', '$scope','$state', 'searchInputSvc', '$timeout'];

    function searchInputCtrl($rootScope, $scope, $state, searchInputSvc, $timeout) {
        var vm = this;
        if($scope.instance){
            $scope.instance = vm;
        }

        vm.tags = angular.isDefined($scope.tags) ? $scope.tags : searchInputSvc.getTags();

        var onTagChangedDebounced = _.debounce(onTagChanged, 300);

        init();
        function init(){
            $rootScope.$on('$stateChangeSuccess', function(event, toState, toParams, fromState, fromParams){
                if(fromState.name === "buy-stock-page.search-result-page" && fromState.name !== toState.name){
                    searchInputSvc.setTags([]);
                }
            });
        }
        function onTagChanged(){
            if($scope.onValueChanged){
                $scope.onValueChanged();
            } else {
                if(vm.tags.data.length !== 0) {
                    $state.go('buy-stock-page.search-result-page',{keywords: searchInputSvc.buildKeywords(vm.tags.data), type: $scope.type}, {"reload": true});
                }
                else if( $scope.onClearTags){
                    $scope.onClearTags()
                }
                $timeout(function(){
                    $(window).trigger('resize.ScrollToFixed');

                })
            }
        }
        vm.tagAdded = function(tag) {
            onTagChangedDebounced();
        };

        vm.tagRemoved = function(tag) {
            onTagChangedDebounced();
        }
        vm.onEnterKeyPressed = function(){
			vm.tagAdded();
        }
        vm.onFilterChanged = function () {
            if ($scope.onValueChanged) {
                $scope.onValueChanged();
            } else if (vm.tags.data.length > 0) {
                $state.go('buy-stock-page.buy-stock-page.search-result-page', { keywords: searchInputSvc.buildKeywords(vm.tags.data), type: $scope.type }, { "reload": true });
            }
            $timeout(function () {
                $(window).trigger('resize.ScrollToFixed');
            }, 300)
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .directive('searchInput', searchInput);

    searchInput.$inject = [];

    function searchInput() {
        var directive = {
            scope: {
                onValueChanged: "&?",
                onClearTags: "=",
                tags: "=",
                instance: "=?",
                placeholder: "=",
                type: "="
            },
            restrict: 'E',
            templateUrl: 'app/components/search-input/search-input.html',
            controller: "searchInputCtrl",
            controllerAs: 'vm'
        };

        return directive;

    }

})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .directive('scrollToTopModal', scrollToTopModal);

    scrollToTopModal.$inject = [];

    function scrollToTopModal($timeout) {
        return {
            restrict: 'A',
            scope: {
                'scrollToTopModal': "=",
                'scrollToTopModalTarget': '@'
            },
            link: function(scope, element, attrs) {
                scope.$watch('scrollToTopModal', function(newValue){
                    if(newValue){
                        $(".modal" + scope.scrollToTopModalTarget).scrollTop(0);
                    }
                });
            }
        };
    }
})();
(function() {
    'use strict';

    angular
        .module('pixerf')
        .directive('scrollToTop', scrollToTop);

    scrollToTop.$inject = [];

    function scrollToTop($timeout, toastr) {
        return {
            restrict: 'E',
            replace: true,
            templateUrl: 'app/components/scroll-to-top/scroll-to-top.html',
            scope: {
            },
            link: function(scope, element) {

                function init() {
                    var $element = $(element);
                    var $body = $("html, body");
                    $element.click(function() {
                        $body.stop().animate({ scrollTop: 0 }, '500', 'swing');
                    })
                    window.addEventListener('scroll', function() {
                        if (window.pageYOffset > 1*$(window).innerHeight()) {
                          element.addClass('scroll-to-top-btn--show');
                        } else {
                          element.removeClass('scroll-to-top-btn--show');
                        }
                    })
                }
                init();
            }
        };


    }
})();
(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('scrollToHide', scrollToHide);

	scrollToHide.$inject = ['$window'];

	function scrollToHide($window) {
		return {
			restrict: 'A',
			scope: {
				scrollSpacing: '@?',
				animateOut: '@?',
				animateIn: '@?'
			},
			link: function (scope, element) {
				var animateFadeIn = scope.animateIn ? scope.animateIn : 'fadeInRight';
				var animateOut = scope.animateOut ? scope.animateOut : 'fadeOutRight';
				$window = angular.element($window);

				init();
				$window.on('scroll.scrollAnimate', handler);

				function init() {
					if (!element.hasClass("animated")) {
						element.addClass("animated");
					}
					if (!element.hasClass(animateFadeIn)) {
						element.addClass(animateFadeIn);
					}
				}

				function handler() {
					if (element[0].getBoundingClientRect().top - parseInt(scope.scrollSpacing) < 0) {
						element.addClass(animateOut);
					} else {
						element.removeClass(animateOut);
					}
				};

				scope.$on('$destroy', function () {
					$window.off('scroll.scrollAnimate', handler);
				});
			}
		};
	}
})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .directive('scrollTo', scrollTo);

    scrollTo.$inject = ['systemUtils'];

    function scrollTo(systemUtils) {
        return {
            restrict: 'E',
            replace: true,
            templateUrl: 'app/components/scroll-to/scroll-to.html',
            scope: {
                howFar: '=',
                direction: '=',
                target: '=',
				color : '=',
				text: '='
            },
            link: function(scope, element) {

                function init() {
                    var $element = $(element);
                    $element.click(function() {
                        systemUtils.scrollTo(scope);
                    })
                }
                init();
            }
        };


    }
})();
(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('scrollPagingCtrl', scrollPagingCtrl);

    scrollPagingCtrl.$inject = ['pagingUtils', '$scope'];

    function scrollPagingCtrl(pagingUtils, $scope) {

        var self = this;
        self.scrollToSection = scrollToSection;

        function scrollToSection(sectionId, offsetTop){
            if ($scope.scrollElement) {
                pagingUtils.scrollElementToTop($scope.scrollElement);
            } else {
                if (!sectionId) {
                    pagingUtils.scrollToTop();
                } else {
                    pagingUtils.scrollToSection('#' + sectionId, offsetTop);
                }
            }
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('pixerf')
        .directive('scrollPaging', scrollPaging);
    scrollPaging.$inject = [];
    function scrollPaging() {
        return {
            restrict: 'E',
            scope: {
                "message": '@',
                'spinner': '=',
                'isLastPage': '=',
                'showMessage': '=',
                'hideBackToTop': '=',
                'sectionId': '@',
                'offsetTop': '@',
                'scrollElement': '@'
            },
            templateUrl: "app/components/scroll-paging/scroll-paging.html",
            replace: true,
            controller: 'scrollPagingCtrl',
            controllerAs: 'vm'
        };
    }
})();
(function(){
  'use strict';
  angular
    .module('pixerf')
    .factory('resetPasswordSvc', resetPasswordSvc);
    resetPasswordSvc.$inject = ['auth0AuthenticationSvc', '$uibModal', '$q', 'translationSvc'];

    function resetPasswordSvc(auth0AuthenticationSvc, $uibModal, $q, translationSvc){

    	var mEmail = {
    		data: null
    	}
		function showResetPasswordModal(){
	    	$uibModal.open({
				templateUrl: 'app/components/reset-password/reset-password.html',
				controller: 'resetPasswordCtrl',
				controllerAs: 'vm',
				animation: true
		    });
    	}
        function validate(form){
            var def = $q.defer();
            if(form.email.$error.required){
                def.reject("Please input your email");
            } else if(form.email.$error.email ){
                def.reject("Invalid email address");
            } else {
                auth0AuthenticationSvc.isUserExisted(mEmail.data).then(function(response){
                    if(response.data && !response.data.existing){
                        def.reject("This email doesn't exist. Please make sure you key in a registered email address.");
                    } else {
                        def.resolve();
                    }
                }, function(){
                    def.reject(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
                })
            }
            return def.promise;
        }
        function resetPassword(email, form){
    		return auth0AuthenticationSvc.resetPassword(email);
    	}
        function reset(){
            mEmail.data = null;
        }
		return {
			showResetPasswordModal: showResetPasswordModal,
			resetPassword: resetPassword,
			email: mEmail,
            reset: reset,
            validate: validate
		};
    }
})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('resetPasswordCtrl', resetPasswordCtrl);

    resetPasswordCtrl.$inject = ['resetPasswordSvc', '$uibModalInstance', 'signInSvc', 'toastr', '$uibModalStack', 'translationSvc'];

    function resetPasswordCtrl(resetPasswordSvc, $uibModalInstance, signInSvc, toastr, $uibModalStack, translationSvc) {

        var self = this;
        self.email = resetPasswordSvc.email;
        self.pixerfAlert = {};
        self.isWorking = false;
        self.onSendBtnClicked = function(email, form){
            if(self.isWorking) return;
            self.isWorking = true;
            resetPasswordSvc.validate(form).then(function(){
                resetPasswordSvc.resetPassword(email, form).promise.then(function(){
                    self.isWorking = false;
                    $uibModalStack.dismissAll();
                    signInSvc.showSignInModal({
                        message: 'A link to reset your password has been sent to your email.'
                    });
                }, function(err){
                    self.isWorking = false;
                    if(err && err.data && err.data.data && err.data.data.message){
                        toastr.error(err.data.data.message);
                    } else {
                        toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
                    }
                });
            }, function(errMsg){
                self.isWorking = false;
                if(errMsg) {
                    toastr.error(errMsg);
                }
            })
        }
        self.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
        resetPasswordSvc.reset();
    }
})();

(function(){
  'use strict';
  angular
    .module('pixerf')
    .factory('resendVerificationEmailPopupSvc', resendVerificationEmailPopupSvc);
    resendVerificationEmailPopupSvc.$inject = ['$uibModalStack', '$uibModal', 'sessionManagerSvc', 'pixerfApiMailSvc', 'toastr', 'translationSvc'];

    function resendVerificationEmailPopupSvc($uibModalStack, $uibModal, sessionManagerSvc, pixerfApiMailSvc, toastr, translationSvc){
        var mPixerfAlert = {data: null};
        function showPopup(data){
            return $uibModal.open({
                templateUrl: 'app/components/resend-verification-email-popup/resend-verification-email-popup.html',
                controller: 'resendVerificationEmailPopupCtrl',
                controllerAs: 'vm',
                animation: true,
                windowClass: 'zindex signup-screen',
                resolve: {
                    'resolveData': function(){
                        return data;
                    }
                }
            });
        }
        function showSignupCompletedPopup(){
            var mLoginUser = sessionManagerSvc.getCurrentLoginUser().data;
            return showPopup({
                messages: {
                    m1: "Hi, "  + mLoginUser.displayName,
                    m2: "Thank you for signing up!",
                    m3: "A verification email has been sent to your email account to verify your email and complete the sign up process."
                },
                cancelBtnTxt: "OK"
            })
        }
        function showVerifyEmailPopup(){
            var mLoginUser = sessionManagerSvc.getCurrentLoginUser().data;
            return showPopup({
                messages: {
                    m1: "Hi, "  + mLoginUser.displayName,
                    m2: "You need to verify your email to use this function!",
                    m3: "A verification email has been sent to your email account to verify your email and complete the sign up process."
                }
            })
        }
        function resendEmail(){
            var mLoginUser = sessionManagerSvc.getCurrentLoginUser().data;
            if(!mLoginUser.is_email_verified){
                pixerfApiMailSvc.resend({email: mLoginUser.email}).$promise.then(function(response){
                    toastr.success("A verification email has been sent to " + mLoginUser.email + ", please check your email!");
                    $uibModalStack.dismissAll();
                }, function(){
                    toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
                });
            } else {
                toastr.warning(mLoginUser.email + " is verified");
            }
        }
        function getPixerfAlert(){
        	return mPixerfAlert;
        }
        return {
            showPopup: showPopup,
            showSignupCompletedPopup: showSignupCompletedPopup,
            showVerifyEmailPopup: showVerifyEmailPopup,
            resendEmail: resendEmail,
            getPixerfAlert: getPixerfAlert
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('resendVerificationEmailPopupCtrl', resendVerificationEmailPopupCtrl);

    resendVerificationEmailPopupCtrl.$inject = ['$uibModalInstance','resolveData','accountUtils', 'resendVerificationEmailPopupSvc'];

    function resendVerificationEmailPopupCtrl($uibModalInstance, resolveData, accountUtils, resendVerificationEmailPopupSvc) {

        var self = this;

        self.pixerfAlert = resendVerificationEmailPopupSvc.getPixerfAlert();
        self.messages = resolveData.messages;
        self.resendBtnTxt = resolveData.resendBtnTxt ? resolveData.resendBtnTxt : "Resend email";
        self.cancelBtnTxt = resolveData.cancelBtnTxt ? resolveData.cancelBtnTxt : "Cancel";
        self.isHideResendBtn = resolveData.isHideResendBtn;
        self.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
        self.onResendBtnClicked = resendVerificationEmailPopupSvc.resendEmail;
    }
})();
/**
 * Controller for resend verification email popup module
 */
(function(){
  'use strict';
  angular
    .module('pixerf')
    .factory('resendResetPasswordPopupSvc', resendResetPasswordPopupSvc);
    resendResetPasswordPopupSvc.$inject = ['$uibModal'];

    function resendResetPasswordPopupSvc($uibModal){
        var mData= null;
        function showPopup(data){
            mData = data;
            return $uibModal.open({
                templateUrl: 'app/components/resend-reset-password-popup/resend-reset-password-popup.html',
                controller: 'resendResetPasswordPopupCtrl',
                controllerAs: 'vm',
                animation: true,
                windowClass: 'zindex signup-screen',
                resolve: {
                    'resolveData': function(){
                        return data;
                    }
                }
            });
        }
        return {
            showPopup: showPopup,
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('resendResetPasswordPopupCtrl', resendResetPasswordPopupCtrl);

    resendResetPasswordPopupCtrl.$inject = ['$uibModalInstance','resolveData','auth0AuthenticationSvc', 'signInSvc', 'toastr', 'translationSvc'];

    function resendResetPasswordPopupCtrl($uibModalInstance, resolveData, auth0AuthenticationSvc, signInSvc, toastr, translationSvc) {

        var self = this;

        self.messages = resolveData.messages;
        self.resendEmail = "Resend email";
        self.isWorking = false;
        self.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
        self.onResendBtnClicked = onResendBtnClicked;

        function onResendBtnClicked(){
            if(self.isWorking) return;
            auth0AuthenticationSvc.resetPassword(resolveData.email).promise.then(function(){
                self.isWorking = false;
                $uibModalInstance.close();
                signInSvc.showSignInModal({
                    message: 'A link to reset your password has been sent to your email.'
                });
            }, function(err){
                self.isWorking = false;
                if(err && err.data && err.data.data && err.data.data.message){
                    toastr.error(err.data.data.message);
                } else {
                    toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
                }
            });

        }
    }
})();

(function () {
	angular
		.module("pixerf")
		.controller("requestToJoinCommunityCtrl", requestToJoinCommunityCtrl);
	requestToJoinCommunityCtrl.$inject = ['pixerfApiCommunitySvc', 'toastr', '$scope', 'pixerfConfirmPopupSvc', 'translationSvc', 'commonConst'];

	function requestToJoinCommunityCtrl(pixerfApiCommunitySvc, toastr, $scope, pixerfConfirmPopupSvc, translationSvc, commonConst) {
		var self = this;
		self.onWithdrawBtnClicked = onWithdrawBtnClicked;
		self.commonConst = commonConst;

		function onWithdrawBtnClicked(community) {
			if (self.isWorking) return;
			var confirmMessage = 'Do you want to withdraw your request to join the Community <span class="text--bold text--color-black">' + self.community.name + '</span>?';
			var modal = pixerfConfirmPopupSvc.showPopup({
				hideTitle: true,
				hideConfirmText: true,
				message: confirmMessage
			});
			modal.result.then(function () {
				self.isWorking = true;
				pixerfApiCommunitySvc.withdraw_request({
					community_ids: [community.id]
				}).$promise.then(function () {
					self.isWorking = false;
					toastr.success("You have withdrawn your request to join the Community " + self.community.name);
					$scope.vm.onCommunityStatusChanged({
						communityChanged: community.id
					});
				}, function () {
					self.isWorking = false;
					toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
				})
			})
		}
	}
})();

(function(){
    'use strict';
    angular
      .module("pixerf")
      .component("requestToJoinCommunity", {
          bindings: {
              "community" : "=",
              "onCommunityStatusChanged": "&?",
              "onSelectedChanged": "&?"
          },
          controller: "requestToJoinCommunityCtrl",
          controllerAs: "vm",
          templateUrl: "app/components/request-to-join-community/request-to-join-community.html"
      })
})();
(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('requestPayoutBtnCtrl', requestPayoutBtnCtrl);

	requestPayoutBtnCtrl.$inject = ['pixerfConfirmPopupSvc', 'bankUtils', 'systemUtils', 'pixerfApiPayoutMethodSvc', '$q', 'pixerfMessagePopupSvc', '$scope', 'toastr', '$translate', 'translationSvc', 'confirmPopupSvc'];

	function requestPayoutBtnCtrl(pixerfConfirmPopupSvc, bankUtils, systemUtils, pixerfApiPayoutMethodSvc, $q, pixerfMessagePopupSvc, $scope, toastr, $translate, translationSvc, confirmPopupSvc) {

		var self = this;
		self.isWorking = false;

		self.onRequestPayoutBtnClicked = onRequestPayoutBtnClicked;

		function buildConfirmMessage(payoutMethod) {
			var str = "<table class=\"table-bordered table\">";
			if (payoutMethod.code === "PAYPAL") {
				str += "<tr>"
				str += ("<th>" + "Email" + "</th>");
				str += ("<td>" + payoutMethod.details.email + " </td>");
				str += "</tr>";
				str += "</table>";
				return str;
			}
			var keyBuff = [];
			var bankCode;
			for (var key in payoutMethod.details) {
				if (key === "swiftCode" || key === "bankCode") {
					if (key === "swiftCode") {
						bankCode = key;
					} else if (key === "bankCode") {
						bankCode = key;
					}
				}
				if (typeof payoutMethod.details[key] !== "undefined" && payoutMethod.details[key] !== null) {
					keyBuff.push(key);
				}
			}
			var bankInfoData = systemUtils.clone(payoutMethod.details);
			var bankName = bankUtils.getBankNameFromCode(payoutMethod.details[bankCode], payoutMethod.details.currency);
			if (bankName) {
				bankInfoData.bankName = bankName;
				keyBuff.push("bankName");
			}
			keyBuff.sort();

			for (var i = 0; i < keyBuff.length; i++) {
				var fieldName = keyBuff[i];
				str += "<tr>"
				str += ("<th>" + bankUtils.getLabelFromKey(fieldName, payoutMethod.details.currency) + "</th>");
				str += ("<td><%=" + fieldName + "%></td>");
				str += "</tr>";
			}
			str += "</table>"

			return _.template(str)(bankInfoData);
		}

		function payout(earnings) {
			var def = $q.defer();
			pixerfApiPayoutMethodSvc.request_payouts().$promise.then(function () {
				earnings.pending_payout += earnings.available_payout;
				earnings.available_payout = 0;
				self.isWorking = false;
				if ($scope.onSucess) $scope.onSucess({
					earnings: earnings
				});
				def.resolve();

			}, function () {
				self.isWorking = false;
				toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
				def.reject();
			});
			return def.promise;
		}

		function fetchPayoutMethods() {
			var def = $q.defer();
			pixerfApiPayoutMethodSvc.get().$promise.then(function (response) {
				self.payoutMethods = response;
				if (self.payoutMethods && self.payoutMethods.length > 0) {
					var preferreMethod = _.find(self.payoutMethods, function (p) {
						return p.is_default;
					});
					if (!preferreMethod) {
						def.reject();
					} else {
						def.resolve(preferreMethod)
					}
				} else {
					def.reject({
						code: 'no-payout-method'
					});
				}
			}, function (error) {
				def.reject(error);
			})
			return def.promise;
		}

		function confirmAndRequest(earnings, payoutMethod) {
			if (payoutMethod.code == 'BANK_TRANSFER' && earnings.available_payout <= 100) {
				return toastr.error($translate.instant('bank-transfer-withdrawal-at-least', {
					'unit': 'SGD',
					'value': 100
				}));
			}
			pixerfConfirmPopupSvc.showPopup({
				hideTitle: true,
				message: "Your payout request will be processed via <span class='text--semibold'>" + payoutMethod.name + "</span>. The details are as follows: " + buildConfirmMessage(payoutMethod),
				okFn: function () {
					return payout(earnings);
				},
				okFnCallback: function () {
					pixerfMessagePopupSvc.showPopup({
						showBtn: true,
						bntText: 'OK',
						autoClose: false,
						message: "Hi, your payout request has been received. PIXERF will process payout request with: <span class='text--semibold'>" + payoutMethod.name + "</span>. The details are as follows: " + buildConfirmMessage(payoutMethod) + "</span>",
						btnClass: "btn btn-submit pixerf-btn-sm",
						cssClass: 'payout-method-confirm-popup'
					})
				},
				windowClass: 'payout-method-confirm-popup'

			})
		}

		function onRequestPayoutBtnClicked(earnings, payoutMethod) {
			if (!payoutMethod) {
				fetchPayoutMethods().then(function (response) {
					payoutMethod = response;
					confirmAndRequest(earnings, payoutMethod)
				}, function (err) {
					console.log(err);
					if (err.code === 'no-payout-method') {
						confirmPopupSvc.showPopup({
                            windowClass: 'payout-method-wraning-popup',
                            message: 'Please add a payout method!',
                            hideSubmitBtn: true,
                            cancelBtnText: 'Close'
                        });
					} else {
						toastr.error("Please choose a payout method you prefered.");
					}
					return;
				})
			} else {
				confirmAndRequest(earnings, payoutMethod)
			}

		}

	}
})();

(function () {
  'use strict';

  angular
    .module('pixerf')
    .directive('requestPayoutBtn', requestPayoutBtn);

  function requestPayoutBtn() {

    var directive = {
      scope: {
        "earnings" : "=",
        "payoutMethod": "@?",
        "onSucess": "&?"
      },
      restrict: 'E',
      templateUrl: 'app/components/request-payout-btn/request-payout-btn.html',
      controller: 'requestPayoutBtnCtrl',
      controllerAs: 'vm',
      replace: true
    };
    return directive;
  }

})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .factory('editCartBtnSvc', editCartBtnSvc);

     editCartBtnSvc.$inject = ['cartSvc', 'cartUtils', '$q', 'toastr', 'messageConst', 'messageSvc', 'translationSvc', 'sessionManagerSvc', 'store', 'accountConst'];

    function editCartBtnSvc(cartSvc, cartUtils, $q, toastr, messageConst, messageSvc, translationSvc, sessionManagerSvc, store, accountConst) {

        function buildSavedCartItem(cartItem){
            var savedCartItemData = {
                "size": null,
                "is_unlimited_print": false,
                "is_multi_seat": false,
                "is_for_resale": false,
                "id": cartItem.id
            };
            for (var i = 0; i < cartItem.media.extendedLicenses.length; i ++){
                savedCartItemData[cartItem.media.extendedLicenses[i].key] = cartItem.media.extendedLicenses[i].isSelected;
            }
            for (var i = 0; i < cartItem.media.price.range.length; i ++){
                if(cartItem.media.price.range[i].isSelected){
                    savedCartItemData.size = cartItem.media.price.range[i].size;
                }
            }
            return savedCartItemData;

        }
        function validate(cartItemData){
            var errMsg = "";
            if(!cartItemData.size) errMsg = "Size is not set";
            return errMsg;
        }
        function editCartItem(cartItem){
            var def = $q.defer();
            var savedCartItemData = buildSavedCartItem(cartItem);
            console.log(savedCartItemData);
            var errMsg = validate(savedCartItemData);
            if(errMsg) toastr.error(errMsg);
            var mLoginnedUser = sessionManagerSvc.getCurrentLoginUser().data;
            if(!mLoginnedUser){
                var guestUserToken = store.get(accountConst.TOKEN.GUEST_USER_TOKEN);
            }

            cartSvc.updateItemInCart(savedCartItemData, guestUserToken).then(function(response){
                def.resolve();
                var updatedCartItem = cartSvc.getCartItemById(response.data, cartItem.id);
                cartItem.sub_total = updatedCartItem.sub_total;
                cartItem.is_unlimited_print = updatedCartItem.is_unlimited_print;
                cartItem.is_multi_seat = updatedCartItem.is_multi_seat;
                cartItem.is_for_resale = updatedCartItem.is_for_resale;
                cartItem.size = updatedCartItem.size;
            }, function(err){
                def.reject();

                cartUtils.updateCartSelectedVariant(cartItem, cartItem);
                var message = translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true);
                if(err.data.error === "MEDIA_UNAVAILABLE"){
                    message = messageSvc.compile(messageConst.error.CART_ITEM_REMOVED, {photo_name: ": " + cartItem.media.title, quantity: 1, action: 'update'});
                    cartSvc.removeItem(cartItem);
                }
                toastr.error(message);
            });
            return def.promise;
        }
        return {
           buildSavedCartItem: buildSavedCartItem,
           validate: validate,
           editCartItem: editCartItem
        };
    }
})();

/**
 * Controller for home module
 */
(function(){
  'use strict';
  angular
    .module('pixerf')
    .factory('requestLicensePopupSvc', requestLicensePopupSvc);
    requestLicensePopupSvc.$inject = ['$uibModalStack', '$uibModal'];

    function requestLicensePopupSvc($uibModalStack, $uibModal){
        function showPopup(data){
            return $uibModal.open({
                templateUrl: 'app/components/request-license-popup/request-license-popup.html',
                controller: 'requestLicensePopupCtrl',
                controllerAs: 'vm',
                animation: true,
                windowClass: 'request-license-popup-modal',
                resolve: {
                    'resolveData': function(){
                        return data;
                    }
                }
            });

        }
        
        return {
            showPopup: showPopup
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('requestLicensePopupCtrl', requestLicensePopupCtrl);

    requestLicensePopupCtrl.$inject = ['$uibModalInstance','resolveData','pixerfApiMailSvc', '$timeout', 'toastr', 'translationSvc'];

    function requestLicensePopupCtrl($uibModalInstance, resolveData, pixerfApiMailSvc, $timeout, toastr, translationSvc) {

        var self = this;
        self.pixerfAlert = {};
        self.onRequestLicenseBtnClicked = onRequestLicenseBtnClicked;
        self.close = close;

        function onRequestLicenseBtnClicked(){
            pixerfApiMailSvc.request_license({id: resolveData.id}, {}).$promise.then(function(){
                toastr.success("A request for license is sent to our curator. We will get back to you as soon as possible");
                $timeout(function(){
                    $uibModalInstance.close();
                }, 3500);
            }, function(){
                toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
            })
        }
        function close() {
            $uibModalInstance.dismiss('cancel');
        };

    }
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('requestLicenseBtnCtrl', requestLicenseBtnCtrl);

	requestLicenseBtnCtrl.$inject = ['$scope', 'requestLicensePopupSvc', 'sessionManagerSvc', 'pixerfUrl', 'pixerfApiMediaSvc'];

	function requestLicenseBtnCtrl($scope, requestLicensePopupSvc, sessionManagerSvc, pixerfUrl, pixerfApiMediaSvc) {

		var self = this;
		self.loginnedUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.onRequestLicenseBtnClicked = onRequestLicenseBtnClicked;

		function onRequestLicenseBtnClicked(media) {
			if ($scope.media.license === "commercial" && self.loginnedUser && self.loginnedUser.canCurate && $scope.media.releases && $scope.media.releases.length) {
				onDownloadLicense(media);
			} else if($scope.media.license === "editorial" && self.loginnedUser) {
				requestLicensePopupSvc.showPopup(media);
			}
		}

		function onDownloadLicense(photo) {
			if (photo && photo.releases && photo.releases.length) {
				for (var i = 0; i < photo.releases.length; i++) {
					pixerfApiMediaSvc.download_release_by_id({
						id: photo.releases[i].id
					}).$promise.then(function (response) {
						if (response && response.token) {
							window.location.href = pixerfUrl.full + 'api/media/releases/download?token=' + response.token;
						}
					});
				}
			}
		}
	}
})();

(function () {
  'use strict';

  angular
    .module('pixerf')
    .directive('requestLicenseBtn', requestLicenseBtn);

  function requestLicenseBtn() {

    var directive = {
      scope: {
        "media" : "=",
      },
      restrict: 'E',
      templateUrl: 'app/components/request-license-btn/request-license-btn.html',
      controller: 'requestLicenseBtnCtrl',
      controllerAs: 'vm',
      replace: true,
      transclude: true
    };
    return directive;
  }

})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.factory('requestHiresPopupSvc', requestHiresPopupSvc);
	requestHiresPopupSvc.$inject = ['$uibModal'];

	function requestHiresPopupSvc($uibModal) {
		function showPopup(data) {
			return $uibModal.open({
				templateUrl: 'app/components/request-hires-popup/request-hires-popup.html',
				controller: 'requestHiresPopupCtrl',
				controllerAs: 'vm',
				animation: true,
				windowClass: 'zindex request-hires-popup',
				resolve: {
					'resolveData': function () {
						return data;
					}
				}
			});
		}
		return {
			showPopup: showPopup
		};
	}
})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('requestHiresPopupCtrl', requestHiresPopupCtrl);

    requestHiresPopupCtrl.$inject = ['$scope', '$uibModalInstance', 'resolveData', 'pixerfApiCustomCommssionsSvc'];

    function requestHiresPopupCtrl($scope, $uibModalInstance, resolveData, pixerfApiCustomCommssionsSvc) {

        var self = this;
        self.closePopup = closePopup;
        self.dismiss = dismiss;
        self.requestDownload = requestDownload;
        self.data = resolveData;

        function closePopup(){
            $uibModalInstance.close();
        }
        function dismiss(){
            $uibModalInstance.dismiss();
        }
        function requestDownload(){
            pixerfApiCustomCommssionsSvc.requestToDownload({id: self.data.data.id}, {user_id: self.data.author, content: "request to download"}).$promise.then(function(respone){
                closePopup();
            })
        }
    }
})();
(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('reportItemCtrl', reportItemCtrl);

		reportItemCtrl.$inject = ['$scope', 'confirmPopupSvc', '$q', 'pixerfApiCommunitySvc', 'createDiscussionTopicPopupSvc', 'sessionManagerSvc', '$state', 
			'commonConst', 'toastr', '$window', 'peopleListPopupSvc', 'pixerfDiscussionReportPopupSvc', 'accountConst', 'dateUtils'];

	function reportItemCtrl($scope, confirmPopupSvc, $q, pixerfApiCommunitySvc, createDiscussionTopicPopupSvc, sessionManagerSvc, $state, 
			commonConst, toastr, $window, peopleListPopupSvc, pixerfDiscussionReportPopupSvc, accountConst, dateUtils) {

		var self = this;
		self.loginUser = sessionManagerSvc.getCurrentLoginUser().data;
		if(!$scope.report.discussion){
			return //TODO: show implement for discussion_reply later

		}
		self.discussion = $scope.report.item_type == 'discussion' ? $scope.report.discussion : $scope.report.discussion;
		self.community = $scope.report.community;
		self.isLiked = false;
		self.reason = $scope.report.reason;
		self.isBookmarked = false;
		self.commonConst = commonConst;
		self.user = $scope.report.user;
		self.onEditDiscussion = onEditDiscussion;
		self.onRemoveDiscussion = onRemoveDiscussion;
		self.goDetailDiscussion = goDetailDiscussion;
		self.onShowListLike = onShowListLike;
		self.onShowListReply = onShowListReply;
		self.onReportDiscussion = onReportDiscussion;
		self.onManageRights = onManageRights;
		self.controls = [];
		self.onRemoveFromCommunity = onRemoveFromCommunity;
		self.onBlockFromCommunity = onBlockFromCommunity;
		self.showKeepPostBtn = true;
		self.showRemovePostBtn = true;
		self.onRemovePost = onRemovePost;
		self.onKeepPost = onKeepPost;

		init();

		function init() {
			self.inserted_at = self.discussion && self.discussion.inserted_at ? getPreciseDiff(moment(self.discussion.inserted_at)) : "";
			buildlControl();
			self.discussionAvatar = buildUserAvatar(self.discussion.user);
		}

		function buildUserAvatar(member) {
			var userAvatar = {
				avatar: { profileImage: (member.profile_image_media && member.profile_image_media['100x']) ? member.profile_image_media['100x'] : member.profile_image },
				displayName: member.displayName,
				account_type: member.account_type
			}
			return userAvatar;
		}

		function buildlControl(){
			self.controls = [{
				label: 'Remove from Community',
				cta: self.onRemoveFromCommunity,
				showControl: true
			}, {
				label: 'Block from Community',
				cta: self.onBlockFromCommunity,
				showControl: true
			}];
		}

		function onRemoveFromCommunity(){
			$scope.onRemoveFromCommunity(self.discussion.user);
		}

		function onBlockFromCommunity(){
			$scope.onBlockFromCommunity(self.discussion.user);
		}

		function onRemovePost(){
			$scope.onRemovePost(self.discussion);
		}

		function onKeepPost(){
			$scope.onKeepPost(self.discussion);
		}

		function onEditDiscussion(e) {
			window.event.stopPropagation()
			self.community.discussion = self.discussion;
			var popup = createDiscussionTopicPopupSvc.showPopup({
				community: self.community,
				discussion: self.discussion

			});

			popup.result.then(function (res) {
				if (!res) {
					$scope.onRemoved({
						data: self.discussion
					});
				}
			})
		}

		function getPreciseDiff(date){
			var today = moment.utc();
			return dateUtils.preciseDiff(today, moment(date))
		}

		function onRemoveDiscussion(e) {
			window.event.stopPropagation()
			var popup = confirmPopupSvc.showPopup({
				windowClass: 'remove-discussion-confirm-popup',
				title: 'Are you sure you want to delete this post?',
				message: 'You will lose all the engagements and comments from this post.',
				submitBtnText: 'Yes, delete it',
				cancelBtnText: 'No, keep it',
				submit: function () {
					var def = $q.defer();
					pixerfApiCommunitySvc.remove_disscussion({
						id: self.discussion.id
					}).$promise.then(function (res) {
						toastr.success("Discussion: " + self.discussion.subject + " has been deleted!");
						def.resolve(res);
					}).catch(function (err) {
						def.reject(err);
					})
					return def.promise;
				},
				submitCallback: function (res) {
					$scope.onRemoved(res);
				}
			});

			return popup;
		}

		
		function goDetailDiscussion(discussion) {
			$state.go(self.commonConst.STATE.DISCUSSION_DETAIL, {
				id: discussion.id,
				subject: discussion.subject.replace(/ /g, '-'),
				order: $scope.arrangeBy
			});
		}

		function onShowListLike() {
			$window.event.stopPropagation();
			if(self.discussion.like_count < 1) return;

			peopleListPopupSvc.showPopup({
				type: accountConst.INTERACT_TYPE.LIKE_DISCUSSION.toLowerCase(),
				user: self.loginUser,
				discussionId: self.discussion.id,
				options: {
					hideSeeAll: true
				}
			});
		}

		function onShowListReply() {
			$window.event.stopPropagation();
			if(self.discussion.reply_count < 1) return;

			peopleListPopupSvc.showPopup({
				type: accountConst.INTERACT_TYPE.REPLY_DISCUSSION.toLowerCase(),
				user: self.loginUser,
				discussionId: self.discussion.id,
				options: {
					hideSeeAll: true
				}
			});
		}

		function onReportDiscussion() {
			pixerfDiscussionReportPopupSvc.showPopup({ id: self.discussion.id, target: 'report_discussion' });
		}

		function onManageRights() {
			$state.go(self.commonConst.STATE.MANAGE_COMMUNITIES_BRIEF, {
				id: self.discussion.community.id,
				name: self.discussion.community.name,
				manage: true,
				status: 'members'
			});
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('reportItem', reportItem);

	function reportItem() {

		var directive = {
			scope: {
				"report": "=",
				"onRemoved": "&",
				"arrangeBy": "@",
				"onRemoveFromCommunity": "&",
				"onBlockFromCommunity": "&",
				"onRemovePost": "&",
				"onKeepPost": "&"
			},
			restrict: 'E',
			templateUrl: 'app/components/report-item/report-item.html',
			controller: 'reportItemCtrl',
			controllerAs: 'vm',
			replace: true
		};
		return directive;
	}

})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('reportDetailCompileTemplateCtrl', reportDetailCompileTemplateCtrl);

	reportDetailCompileTemplateCtrl.$inject = ['$scope', 'sessionManagerSvc', '$window', 'commonConst', 'ISO3166', 'communityRemoveReportPopupSvc', 'communityValidateReportPopupSvc', 'communityResolveReportPopupSvc'];

	function reportDetailCompileTemplateCtrl($scope, sessionManagerSvc, $window, commonConst, ISO3166, communityRemoveReportPopupSvc, communityValidateReportPopupSvc, communityResolveReportPopupSvc) {

		var USER_CONTROL_ADMINDASHBOARD = ['curator_internal', 'admin_internal', 'marketer_internal'];
		var self = this;
		self.loginedUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.isAdmin = self.loginedUser && (USER_CONTROL_ADMINDASHBOARD.includes(self.loginedUser.role) || self.loginedUser.email === 'marcom@pixerf.com');
		self.report = $scope.report;
		self.onClosed = onClosed;
		self.appentToBody = $scope.appentToBody;
		self.onToggleReportReason = onToggleReportReason;
		self.maxStrikes = commonConst.REPORT.NO_IF_STRIKE;
		self.onResolveReport = onResolveReport;
		self.onRemoveReport = onRemoveReport;
		self.onValidateReport = onValidateReport;
		self.subDataInfo = {};

		init()

		function init() {
			convertReportTemplateDate();
			if (self.isAdmin && $scope.context === 'pending') {
				generateAdminPendingLayout(self.report.item_type);
			} else if (self.isAdmin && $scope.context === 'past') {
				generateAdminPastLayout(self.report.item_type);
			} else if ($scope.context === 'pending') {
				generateUserPendingLayout(self.report.item_type);
			} else {
				generateUserPastLayout(self.report.item_type);
			}
		}

		function generateAdminPendingLayout(type) {
			self.showReportReasonMessage = true;
			switch (type) {
				case 'event':
					self.isShowResolveButton = true;
					self.isShowValidateButton = true;
					self.isShowStrike = true;
					self.reportType = 'event';
					self.removeText = 'remove-event';
					self.event = self.report.event;
					if (self.event) {
						transformEventGeneralDisplayData(self.event);
					}
					if (self.event && self.event.event_datetimes && self.event.event_datetimes.length) {
						self.eventSchedules = transformEventSchedule(self.event.event_datetimes);
					}
					break;
				case 'community':
					self.isShowResolveButton = true;
					self.isShowValidateButton = true;
					self.isShowStrike = true;
					self.reportType = 'community';
					self.removeText = 'remove-community';
					self.community = self.report.community;
					break;
				case 'discussion':
					self.reportType = 'post';
					self.removeText = 'remove-post';
					self.isShowStatusLabel = true;
					self.discussion = self.report.discussion;
					if (self.discussion && self.discussion.inserted_at) {
						convertDiscussionCreatedDate(self.discussion.inserted_at);
					}
					break;
				case 'discussion_reply':
					self.reportType = 'comment';
					self.removeText = 'remove-comment';
					self.isShowStatusLabel = true;
					self.comment = self.report.discussion_reply;
					if (self.comment && self.comment.inserted_at) {
						convertCommentCreatedDate(self.comment.inserted_at);
					}
					break;
				default:
					self.reportType = type;
					self.removeText = 'remove';
			}
		}

		function generateAdminPastLayout(type) {
			self.isShowStrike = true;
			self.showReportReasonMessage = true;
			self.isShowStatusLabel = true;
			switch (type) {
				case 'event':
					self.reportType = 'event';
					self.removeText = 'remove-event';
					self.event = self.report.event;
					if (self.event) {
						transformEventGeneralDisplayData(self.event);
					}
					if (self.event && self.event.event_datetimes && self.event.event_datetimes.length) {
						self.eventSchedules = transformEventSchedule(self.event.event_datetimes);
					}
					break;
				case 'community':
					self.reportType = 'community';
					self.removeText = 'remove-community';
					self.community = self.report.community;
					break;
				case 'discussion':
					self.reportType = 'post';
					self.removeText = 'remove-post';
					self.discussion = self.report.discussion;
					if (self.discussion && self.discussion.inserted_at) {
						convertDiscussionCreatedDate(self.discussion.inserted_at);
					}
					break;
				case 'discussion_reply':
					self.reportType = 'comment';
					self.removeText = 'remove-comment';
					self.discussionReply = self.report.discussion_reply;
					self.comment = self.report.discussion_reply;
					if (self.comment && self.comment.inserted_at) {
						convertCommentCreatedDate(self.comment.inserted_at);
					}
					break;
				default:
					self.reportType = type;
					self.removeText = 'remove';
			}
		}

		function generateUserPendingLayout(type) {
			self.isShowResolveButton = true;
			self.isShowRemoveButton = true;
			self.showReportReasonMessage = true;
			switch (type) {
				case 'discussion':
					self.reportType = 'post';
					self.removeText = 'remove-post';
					self.discussion = self.report.discussion;
					if (self.discussion && self.discussion.inserted_at) {
						convertDiscussionCreatedDate(self.discussion.inserted_at);
					}
					break;
				case 'discussion_reply':
					self.reportType = 'comment';
					self.removeText = 'remove-comment';
					self.comment = self.report.discussion_reply;
					if (self.comment && self.comment.inserted_at) {
						convertCommentCreatedDate(self.comment.inserted_at);
					}
					break;
				default:
					self.reportType = type;
					self.removeText = 'remove';
			}
		}

		function generateUserPastLayout(type) {
			self.isShowResolveButton = true;
			self.isShowRemoveButton = true;
			switch (type) {
				case 'discussion':
					self.reportType = 'post';
					self.discussion = self.report.discussion;
					break;
				case 'discussion_reply':
					self.reportType = 'comment';
					self.comment = self.report.discussion_reply;
					break;
				default:
					self.reportType = type;
			}
		}

		function convertReportTemplateDate() {
			self.communityFomatedDate = moment(self.report.community.inserted_at).format("MMMM DD, YYYY");
			self.reportFomatedDate = moment(self.report.inserted_at).format("MMM DD, YYYY");
		}

		function onClosed() {
			$scope.onClosed({
				community: self.community
			});
		}

		function prevenPubbleClick() {
			$window.event.stopPropagation();
		}

		function onToggleReportReason(isOpen) {
			if (!self.report.description) return;
			self.isOpenReportReason = !isOpen;
		}

		function transformEventSchedule(arrTime) {
			var schedulesArr = [];

			for (var i = 0; i < arrTime.length; i++) {
				schedulesArr.push({
					date: moment(arrTime[i].start_datetime).format('dddd, MMMM DD, YYYY'),
					time: moment(arrTime[i].start_datetime).format('h:mmA') + ' to ' + moment(arrTime[i].end_datetime).format('h:mmA')
				});
			}

			return schedulesArr;
		}

		function convertDiscussionCreatedDate(time) {
			self.discussionFomatedDate = moment(time).format("D MMM YYYY, h:mma");
		}

		function convertCommentCreatedDate(time) {
			self.commentFomatedDate = moment(time).format("D MMM YYYY, h:mma");
		}

		function transformEventGeneralDisplayData(event) {
			switch (event.admission_type) {
				case 'free':
					self.admission_type_show = 'Free';
					break;
				case 'ticketed_external':
					self.admission_type_show = 'Ticketed external';
					break;
			}
			if (!event.max_attendees) {
				self.max_attendees_show = 'No limit';
			} else {
				self.max_attendees_show = event.max_attendees;
			}
		}

		function onResolveReport() {
			var resolveReport = communityResolveReportPopupSvc.showPopup({
				data: self.report,
				target: self.report.item_type
			})

			resolveReport.result.then(function (data) {
				if ($scope.onStatusChanged) {
					$scope.onStatusChanged({
						data: [data]
					});
				}
			})
		}

		function onRemoveReport() {
			var removeReport = communityRemoveReportPopupSvc.showPopup({
				data: self.report,
				target: self.report.item_type
			})

			removeReport.result.then(function (data) {
				if ($scope.onStatusChanged) {
					$scope.onStatusChanged({
						data: [data]
					});
				}
			})
		}

		function onValidateReport() {
			var validateReport = communityValidateReportPopupSvc.showPopup({
				data: self.report,
				target: self.report.item_type
			})

			validateReport.result.then(function (data) {
				if (data && data.community && data.community.strike_count) {
					self.report.community.strike_count = data.community.strike_count;
				}
				if ($scope.onStatusChanged) {
					$scope.onStatusChanged({
						data: [data]
					});
				}
			})
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('reportDetailCompileTemplate', reportDetailCompileTemplate);
	reportDetailCompileTemplate.$inject = [];

	function reportDetailCompileTemplate() {

		var directive = {
			scope: {
				report: "=",
				onClosed: "&",
				onStatusChanged: "&?",
				context: "@",
				appendToBody: "@?"
			},
			restrict: 'E',
			templateUrl: 'app/components/report-detail-compile-template/report-detail-compile-template.html',
			controller: 'reportDetailCompileTemplateCtrl',
			controllerAs: 'vm',
			replace: true
		};
		return directive;
	}

})();

(function () {
    'use strict';
    angular
      .module('pixerf')
      .factory('removeMemberPopupSvc', removeMemberPopupSvc);
    removeMemberPopupSvc.$inject = ['$uibModal'];
  
    function removeMemberPopupSvc($uibModal) {
  
      var mReasons = {
        data: [
          { id: 1, title: 'Spam' },
          { id: 2, title: 'Unauthorised sales' },
          { id: 3, title: 'Intellectual property' },
          { id: 4, title: 'Fake news' },
          { id: 5, title: 'Hacked' },
          { id: 6, title: 'Hate speech' },
          { id: 7, title: 'Harassment or threat' },
          { id: 8, title: 'Inappropriate conduct' },
          { id: 9, title: 'Violation of rights' },
          { id: 10, title: 'Adult content' },
          { id: 11, title: 'Violence or abuse' },
          { id: 12, title: 'Suicide or self-injury' },
          { id: 13, title: 'Invasion of privacy' },
          { id: 14, title: 'Scam or fraud' },
          { id: 15, title: "Others" }
        ]
      }
      function setReasons(value) {
        mReasons.data = value;
      }
      function getReasons() {
        return mReasons;
      }
      function showPopup(popupData) {
        return $uibModal.open({
          templateUrl: 'app/components/remove-member-popup/remove-member-popup.html',
          controller: 'removeMemberPopupCtrl',
          controllerAs: 'vm',
          animation: true,
          windowClass: 'remove-member-popup__screen',
          resolve: {
            'resolveData': function () {
              return popupData;
            }
          }
        });
      }
  
      return {
        setReasons: setReasons,
        getReasons: getReasons,
        showPopup: showPopup
      };
    }
  })();
  
(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('removeMemberPopupCtrl', removeMemberPopupCtrl);

	removeMemberPopupCtrl.$inject = ['$scope', 'systemUtils', '$uibModalInstance', 'removeMemberPopupSvc', 'resolveData', 'toastr', 'pixerfApiCommunitySvc', 'contextConst'];

	function removeMemberPopupCtrl($scope, systemUtils, $uibModalInstance, removeMemberPopupSvc, resolveData, toastr, pixerfApiCommunitySvc, contextConst) {

		var self = this;
		self.state = 'r';
		self.community = resolveData.community;
		self.onReasonChange = onReasonChange;
		self.user = resolveData.user;
		self.isMissionReject = false;
		self.isDeletePost = false;
		self.isDeclinePending = false;
		self.isBlock = false;
		self.onRejectBtnClicked = onRejectBtnClicked;
		self.onConfirm = onConfirm;
		self.closePopup = closePopup;
		self.onDeletePostsComments = onDeletePostsComments;
		self.onDeclinePending = onDeclinePending;
		self.onBlock = onBlock;
		self.isDisabledConfirmBtn = true;
		self.blockOptions = {};
		self.blockPostLabel = "Delete all of " + self.user.displayName + "'s posts and comments.";
		self.declinePendingLabel = "Decline any pending members invited by " + self.user.displayName + ".";
		self.blockHintLabel = self.user.displayName + " will no longer be able to find, see, or join this community.";

		self.selectedReason = null;
		self.selectionSettings = null;
		self.selectionSettings = {
			defaultText: 'What’s the reason? ',
			modelNamePropertyName: 'title',
			modelKeyPropertyName: 'id'
		}

		init();

		function init() {
			self.selectionSettings.items = removeMemberPopupSvc.getReasons().data;
			systemUtils.digest($scope);
		}

		function onReasonChange(){
			self.isDisabledConfirmBtn = false;
		}

		function onRejectBtnClicked() {
			if (self.working) return;
			if (!self.selectedReason) {
				toastr.error("Please select 1 reason!");
				return;
			}
		}

		function closePopup(user, context) {
			var result = {
				user: user,
				context: context
			}
			$uibModalInstance.close(result);
		}

		function onDeletePostsComments(item) {
			self.isDeletePost = item;
		}

		function onDeclinePending(item) {
			self.isDeclinePending = item;
		}

		function onBlock(item) {
			self.isBlock = item;
		}

		function onConfirm() {
			if (self.isDeletePost) {
				pixerfApiCommunitySvc.delete_all_posts_comments({ id: self.community.id }, { 'user_ids': [self.user.id] }).$promise.then(function (res) {
					closePopup(self.user);
				}).catch(function (err) {
					console.log(err);
				})
			}
			if (self.isDeclinePending) {
				pixerfApiCommunitySvc.decline_pending_invited_by({ id: self.community.id }, { 'user_ids': [self.user.id] }).$promise.then(function (res) {
					closePopup(self.user);
				}).catch(function (err) {
					console.log(err);
				})
			}
			if (self.isBlock) {
				if(self.selectedReason){
					self.reason = self.selectedReason;
				}
				pixerfApiCommunitySvc.block_member({ id: self.community.id }, { 'id': self.community.id, 'user_ids': [self.user.id], 'status': 'banned', 'reason': self.reason}).$promise.then(function (res) {
					var context = contextConst.COMMUNITY_BLOCKED_MEMBER;
					closePopup(self.user, context);
				}).catch(function (err) {
					console.log(err);
				})
			} else {
				pixerfApiCommunitySvc.remove({ id: self.community.id }, { 'id': self.community.id, 'user_ids': [self.user.id], 'emails': [] }).$promise.then(function (res) {
					closePopup(self.user);
				}).catch(function (err) {
					console.log(err);
				})
			}
		}
	}
})();

(function(){
    'use strict';
    angular
        .module('pixerf')
        .factory("registerBankInfoPopupSvc", registerBankInfoPopupSvc);
    registerBankInfoPopupSvc.$inject = ['$uibModal', 'pixerfApiFileSvc', '$q', 'bankConst', 'systemUtils'];
    function registerBankInfoPopupSvc($uibModal, pixerfApiFileSvc, $q, bankConst, systemUtils){
        var mRecipentAddress = {
            "fieldGroup": [
                {
                    "template": "<div class='register-bank-info-popup__currency-select__field-group-label'><label> Recipient's Address</label> <div class='devider'></div></div>"
                },
                {
                    "key": "addressCountryCode",
                    "template": "<label class=\"control-label\">Country</label><country-select cs-required class=\"form-control form-group\" required name=\"country\" ng-model=\"model.addressCountryCode\" placeholder=\"Country\"></country-select>"
                },
                {
                    "key": "addressCity",
                    "type": "input",
                    "templateOptions": {
                        "type": "text",
                        "label": "City",
                        "placeholder": "City",
                        "required": true
                    }
                },
                {
                    "key": "addressFirstLine",
                    "type": "input",
                    "templateOptions": {
                        "type": "text",
                        "label": "Address",
                        "placeholder": "Address",
                        "required": true
                    }
                },
                {
                    "key": "addressPostCode",
                    "type": "input",
                    "hideExpression": "model.addressCountryCode === \"US\"",
                    "templateOptions": {
                        "type": "text",
                        "label": "Postal code",
                        "placeholder": "Postal code",
                        "required": true
                    }
                },
                {
                    "key": "addressPostCode",
                    "type": "input",
                    "hideExpression": "model.addressCountryCode !== \"US\"",
                    "templateOptions": {
                        "type": "text",
                        "label": "Zip code",
                        "placeholder": "Zip code",
                        "required": true
                    }
                },
                {
                    "hideExpression": "model.addressCountryCode !== \"US\"",
                    "type": "usStateSelect",
                    "key": "addressState",
                    "templateOptions": {
                        "type": "usStateSelect",
                        "label": "State",
                        "required": true
                    }
                }
            ]
        }
        var mCommonBanksConfiguations = [
            {
                "type": "pixerfRadioGroup",
                "key": "receiverType",
                "className": "pixerf-radio-group",
                "templateOptions": {
                    "label": "Receiver Type",
                    "required": true,
                    "radios": [{
                        "id": "receiver_type_private",
                        "radioLabel": "Private",
                        "type": "pixerfRadio",
                        "radioValue": "PRIVATE"
                    },{
                        "id": "receiver_type_business",
                        "radioLabel": "Business",
                        "type": "pixerfRadio",
                        "radioValue": "BUSINESS"
                    }]
                }
            },
            {
                key: 'recipientEmail',
                type: 'input',

                templateOptions: {
                    type: 'email',
                    label: 'Email',
                    placeholder: 'john@mail.com'
                }
            }
            // {
            //     "type": "pixerfRadioGroup",
            //     "key": "receiverType",
			// 	"className": "pixerf-radio-group pixerf-radio-group--vertical",
            //     "templateOptions": {
            //         "label": "Select recipient type",
            //         "required": true,
            //         "radios": [{
			// 			"id": "recipient_personal",
            //             "radioLabel": "Personal",
            //             "type": "pixerfRadio",
            //             "radioValue": "PRIVATE"
            //         },{
			// 			"id": "recipient_business",
            //             "radioLabel": "Business",
            //             "type": "pixerfRadio",
            //             "radioValue": "BUSINESS"
            //         }]
            //     }
            // }
        ];
        var mSupportingCurrencyCodes = [
            "SGD",
            "INR",
            "IDR",
            "MYR",
            "VND",
            "THB",
            "PHP",
            "JPY",
            "HKD",
            "KRW",
            "AED",
            "CNY",
            "PKR",
            "BDT",
            "USD",
            "EUR",
            "AUD",
            "CAD"
        ];
        var requiredAddressCurrencyCountryMapping = {
            "USD" : "US",
            "THB": "TH",
            "PHP": "PH"
        }
        var mPopup;
        function sortCurrencies(currencies){
            currencies.sort(function(a, b){
                return a > b;
            });
            return currencies;
        }
        function isRequiredCountryAddress(feilds){
            return !!_.find(feilds, function(f){
                return !!_.find(f.fieldGroup, function(fg){
                    return fg.key === "addressCountryCode";
                })
            });
        }
        function buildFormFields(currencyCode){
            var def = $q.defer();
            pixerfApiFileSvc.query({path: 'app/components/register-bank-info-popup/i18n-bank-info/' + currencyCode.toLowerCase() + ".json"}).$promise.then(function(response){
                var feilds = response;
                for(var i  = 0; i < feilds.length; i ++){
                    if(feilds[i].name === "recipientAddress"){
                        feilds[i] = mRecipentAddress;
                    }
                }
                feilds = mCommonBanksConfiguations.concat(feilds);
                // if(isRequiredCountryAddress(currencyCode)){
                //     feilds.unshift(mRecipentAddress);
                // }
                def.resolve(feilds);
            }, function(err){
                def.reject(err);
                console.log(err)
            });
            return def.promise;
        }
        function getCurrencies(){
           return mSupportingCurrencyCodes;
        }
        function getCountryByCurrency(currencyCode){
           return requiredAddressCurrencyCountryMapping[currencyCode];
        }
        function showPoup(popupData){
            mPopup = $uibModal.open({
                templateUrl: 'app/components/register-bank-info-popup/register-bank-info-popup.html',
                controller: 'registerBankInfoPopupCtrl',
                controllerAs: 'vm',
                animation: true,
                windowClass: 'register-bank-info-popup-modal',
                backdrop: 'static',
                resolve: {
                    popupData: function(){
                        return popupData;
                    }
                }
            });
            return mPopup;
        }
        function closePopup(){
            mPopup.close();
        }
        function resetBankInfoData(bankInfo){
            return {
                email: bankInfo.email,
                targetCurrency: bankInfo.targetCurrency
            }
        }
        function validateBankInfo(bankInfo) {
            if ((bankInfo.targetCurrency === "USD" || bankInfo.targetCurrency === "JPY" || bankInfo.targetCurrency === "CAD") && !bankInfo.accountType) {
                return false;
            }
            return true;
        }

        return {
            showPoup: showPoup,
            buildFormFields: buildFormFields,
            getCurrencies: getCurrencies,
            getCountryByCurrency: getCountryByCurrency,
            closePopup: closePopup,
            isRequiredCountryAddress: isRequiredCountryAddress,
            resetBankInfoData: resetBankInfoData,
            validateBankInfo: validateBankInfo
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('pixerf')
        .controller('registerBankInfoPopupCtrl', registerBankInfoPopupCtrl);

    registerBankInfoPopupCtrl.$inject = ["$scope", 'toastr', 'registerBankInfoPopupSvc', 'popupData', 'bankUtils', 'translationSvc'];

    function registerBankInfoPopupCtrl($scope, toastr, registerBankInfoPopupSvc, popupData, bankUtils, translationSvc) {

        var self = this;
        self.user = {};

        self.selectedCurrency = 'SGD';
        self.onCurrentSelectionChanged = onCurrentSelectionChanged;
        self.currencyCodeExtractor = currencyCodeExtractor;
        self.currencyCodeMapper = currencyCodeMapper;
        self.onSaveBtnClicked = onSaveBtnClicked;
        self.close = close;
        self.currencies = registerBankInfoPopupSvc.getCurrencies();
        self.bankInfo = {
            targetCurrency: 'SGD'
        };

        self.banksConfiguration = null;

        init();

        function currencyCodeExtractor(item){
            return item.code;
        }
        function currencyCodeMapper(code){
            return bankUtils.getCurrencyByCode(code);
        }
        function init(){
            if(popupData.bankInfo){
                self.bankInfo = popupData.bankInfo;
            }
            self.selectedCurrency = self.bankInfo.targetCurrency;

            onCurrentSelectionChanged(true);
        }
        function onCurrentSelectionChanged(isInit) {
            console.log(isInit);
            if(self.form){
                self.form.$submitted = false;
            }
            registerBankInfoPopupSvc.buildFormFields(self.bankInfo.targetCurrency).then(function(feilds){
                self.banksConfiguration = feilds;
                if(!isInit){
                    self.bankInfo = registerBankInfoPopupSvc.resetBankInfoData(self.bankInfo);
                    if(registerBankInfoPopupSvc.isRequiredCountryAddress(feilds)){
                        self.bankInfo.addressCountryCode =  registerBankInfoPopupSvc.getCountryByCurrency(self.bankInfo.targetCurrency);
                    }
                }
            }, function(){
                toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
            });

        }
        function close(){
            registerBankInfoPopupSvc.closePopup();
        }

        function onSaveBtnClicked(form){
            console.log(form);
            form.$setDirty();
            form.$submitted = true;
            if(form.$invalid || !registerBankInfoPopupSvc.validateBankInfo(self.bankInfo)){
                toastr.error("All fields are required. Please fill in all information");
                return;
            }
            if(self.isWorking) return;
            self.isWorking = true;
            popupData.onSaveHandler(self.bankInfo).then(function(){
                self.isWorking = false;
            }, function(){
                self.isWorking = false;
            });
        }
    }
})();

(function () {
  'use strict';

  angular
    .module('pixerf')
    .directive('registerBankInfoPopup', registerBankInfoPopup);

  function registerBankInfoPopup() {

    var directive = {
      scope: {
          alert: '='
      },
      restrict: 'E',
      templateUrl: 'app/components/register-bank-info-popup/register-bank-info-popup.html',
      controller: 'registerBankInfoPopupCtrl',
      controllerAs: 'vm',
      replace: true
    };
    return directive;
  }

})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.factory('referralsIntroPopoverSvc', referralsIntroPopoverSvc);
	referralsIntroPopoverSvc.$inject = ['$timeout'];

	function referralsIntroPopoverSvc($timeout) {
		function showOverlay() {
			$timeout(function () {
				$(".referrals-intro-popover__icon").trigger("click");
				$timeout(function () {
					var $featurePopover = $(".new-feature-coming");
					if ($featurePopover) {
						$featurePopover.after("<div class='overlay-body'></div>");
					}
				}, 300);
			})
		}

		return {
			showOverlay: showOverlay
		};
	}
})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('referralsIntroPopoverCtrl', referralsIntroPopoverCtrl);

    referralsIntroPopoverCtrl.$inject = ['$timeout'];

    function referralsIntroPopoverCtrl($timeout) {

		var self = this;
		self.onCloseBtnClicked = onCloseBtnClicked;
		self.closePopover = closePopover;

        function onCloseBtnClicked(){
			$timeout(function(){
				$("#header-navbar-btn").trigger("click");
            });
		}
		function closePopover(){
			$("body").trigger("click");
		}
    }
})();
(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('referralsIntroPopover', referralsIntroPopover);

	referralsIntroPopover.$inject = [];

	function referralsIntroPopover() {
		var directive = {
			scope: {},
			restrict: 'E',
			templateUrl: 'app/components/referrals-intro-popover/referrals-intro-popover.html',
			replace: true,
			controller: 'referralsIntroPopoverCtrl',
			controllerAs: 'vm'
		};
		return directive;
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('referralProgramInviteSectionCtrl', referralProgramInviteSectionCtrl);

	referralProgramInviteSectionCtrl.$inject = ['$scope', 'sessionManagerSvc', 'toastr', 'pixerfApiCampaignSvc', 'translationSvc'];

	function referralProgramInviteSectionCtrl($scope, sessionManagerSvc, toastr, pixerfApiCampaignSvc, translationSvc) {

		var self = this;
		self.user = $scope.user;
		self.isMine = self.user ? sessionManagerSvc.isMine(self.user) : false;
		self.emails = [];

		self.onValidateTag = onValidateTag;
		self.onInviteClicked = onInviteClicked;

		function onValidateTag($tag){
			if(isEmailExist($tag)){
				toastr.error($tag.text + " has already been invited!");
				return false;
			}
			return true;
		}
		function isEmailExist(newUser){
			var isExistEmail = _.find(self.friends, function(friend){
				return friend.email === newUser.text;
			});
			if(isExistEmail){
				return true;
			} else {
				return false;
			}
		}
		function onInviteClicked(){
			if (!self.emails) return;

			var tmpEmails = [];
			for (var i = 0; i < self.emails.length; i++) {
				if(!isEmailExist(self.emails[i].text)){
					tmpEmails.push(self.emails[i].text);
				}
			}

			pixerfApiCampaignSvc.invite({"invitees": tmpEmails}).$promise.then(function(res){
				toastr.success("Your invitations have been succesfully sent to your friends!")
			},function (err){
				var errMsg = translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true);
				if(err.data && err.data.message === "ALREADY_SIGNED_UP"){
					errMsg = "Failed to send invitations. Some of your friends are already Pixerf users: ";
					for(var i = 0; i < err.data.emails.length; i ++){
						errMsg += err.data.emails[i];
						if(i !== err.data.emails.length){
							errMsg += ", "
						}
					}
				} else if(err.data && err.data.message === "ALREADY_INVITED"){
					errMsg = "Failed to send invitations. Some of your friends are already invited: ";
					for(var i = 0; i < err.data.emails.length; i ++){
						errMsg += err.data.emails[i];
						if(i !== err.data.emails.length){
							errMsg += ", "
						}
					}
				}
				toastr.error(errMsg);
			})

			self.emails = [];
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('referralProgramInviteSection', referralProgramInviteSection);

	function referralProgramInviteSection() {

		var directive = {
			scope: {
				user: "=?",
				data: "=",
				onButtonClicked: "&"
			},
			templateUrl: 'app/components/referral-program-invite-section/referral-program-invite-section.html',
			restrict: 'E',
			controller: 'referralProgramInviteSectionCtrl',
			controllerAs: 'vm',
			replace: true
		};
		return directive;
	}

})();

(function () {

	angular
		.module('pixerf')
		.controller('referralProgramCtrl', referralProgramCtrl);

	referralProgramCtrl.$inject = ['$scope', 'sessionManagerSvc'];


	function referralProgramCtrl($scope, sessionManagerSvc) {

		var self = this;
		self.user = sessionManagerSvc.getCurrentLoginUser().data;
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.config(routerConfig);

	routerConfig.$inject = ['$stateProvider'];

	function routerConfig($stateProvider) {
		'ngInject';
		$stateProvider
			.state('setting.referral_program', {
				url: '/invite-friends',
				templateUrl: 'app/components/referral-program/referral-program.html',
				controller: 'referralProgramCtrl',
				controllerAs: 'vm',
				data: {
					pageTitle: "PIXERF - Invite Friends",
					permissions: {
						only: ['REFERRAL_MANAGER']
					}
				},
				abstract: true
			})
			.state('setting.referral_program.track', {
				url: '/track',
				templateUrl: 'app/components/referral-program/components/referral-program-track/referral-program-track.html',
				data: {
					pageTitle: "PIXERF - Track",
				},
				controller: 'referralProgramTrackCtrl',
				controllerAs: 'vm'
			})
			.state('setting.referral_program.invite', {
				url: '',
				templateUrl: 'app/components/referral-program/components/referral-program-invite/referral-program-invite.html',
				data: {
					pageTitle: "PIXERF - Invite Friends",
				},
				controller: 'referralProgramInviteCtrl',
				controllerAs: 'vm'
			});
	}

})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('purchaseSoldHistoryItemCtrl', purchaseSoldHistoryItemCtrl);

	purchaseSoldHistoryItemCtrl.$inject = ['$scope', 'pixerfApiDownloadSvc', '$timeout', 'pixerfUrl', 'toastr', 'translationSvc'];

	function purchaseSoldHistoryItemCtrl($scope, pixerfApiDownloadSvc, $timeout, pixerfUrl, toastr, translationSvc) {

		var self = this;

		self.onDownloadBtnClicked = onDownloadBtnClicked;
		self.isWorking = false;
		self.isCollapsed = true;
		self.NUM_PHOTO_COLLAPSE_LIMIT = 3;
		self.onSelectedItem = onSelectedItem;

		function onDownloadBtnClicked(evt, item, type) {
			var service = type ? type : "download";
			if (self.isWorking) {
				return;
			}
			self.isWorking = true;
			// 'payment_ids': [item.id],
			pixerfApiDownloadSvc.order_receipt({}, {
				payment_ids: item.download_id ? [item.download_id] : [item.id],
				type: 'orders'
			}).$promise.then(function (response) {
				item.downloadLink = pixerfUrl.full + "api/" + service + "?token=" + response.data.token;
				$timeout(function () {
					$(evt.target).next("a")[0].click();
					$timeout(function () {
						self.isWorking = false;
					})
				})
			}, function () {
				self.isWorking = false;
				toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
			})
		}

		function onSelectedItem(item){
			$scope.onSelected({data: item});
		}
	}
})();

(function () {
  'use strict';

  angular
    .module('pixerf')
    .directive('purchaseSoldHistoryItem', purchaseSoldHistoryItem);

  function purchaseSoldHistoryItem() {

    var directive = {
      scope: {
        type: "=",
        item: "=",
        onSelected: "&"
      },
      restrict: 'E',
      templateUrl: 'app/components/purchase-sold-history-item/purchase-sold-history-item.html',
      controller: 'purchaseSoldHistoryItemCtrl',
      controllerAs: 'vm',
      replace: true
    };
    return directive;
  }

})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.factory('purchaseHistorySvc', purchaseHistorySvc);

	purchaseHistorySvc.$inject = ['dateUtils'];

	function purchaseHistorySvc(dateUtils) {

		var mFilters = {
			fromMonth: '',
			fromYear: '',
			toMonth: '',
			toYear: '',
		};
		var mItems = [];
		var mTotalMedia = 0;
		var mSearchParams = {
			page: 1,
			start_date: null,
			end_date: null
		};

		function getFilters() {
			return mFilters;
		}

		function setFilters(filters) {
			mFilters = filters;
		}

		function getItems() {
			return mItems;
		}

		function setItems(items) {
			mItems = items;
		}

		function getSearchParams() {
			return mSearchParams;
		}

		function setTotalMedia(totalMedia) {
			mTotalMedia = totalMedia;
		}

		function getTotalMedia() {
			return mTotalMedia;
		}

		function setSearchParams(searchParams) {
			mSearchParams = searchParams;
		}

		function getTimeRange(filter) {
			var timeRange = {
				start_date: null,
				end_date: null
			};

			if (filter.type === "MOST_RECENT") {
				timeRange = null;
			} else if (filter.type === "DURATION") {
				timeRange.start_date = moment(filter.fromDate).valueOf();
				timeRange.end_date = moment(filter.toDate).valueOf();
			}

			return timeRange;
		}

		function buildMonthFilters() {
			var monthlyFilters = [{
				"name": "All",
				"value": "all"
			}, {
				"name": "January",
				"value": 1
			}, {
				"name": "February",
				"value": 2
			}, {
				"name": "March",
				"value": 3
			}, {
				"name": "April",
				"value": 4
			}, {
				"name": "May",
				"value": 5
			}, {
				"name": "June",
				"value": 6
			}, {
				"name": "July",
				"value": 7
			}, {
				"name": "August",
				"value": 8
			}, {
				"name": "September",
				"value": 9
			}, {
				"name": "October",
				"value": 10
			}, {
				"name": "November",
				"value": 11
			}, {
				"name": "December",
				"value": 12
			}];

			return monthlyFilters;
		}

		function buildYearFilters() {
			var recentYears = dateUtils.getRecentYears(3);
			var yearlyFilters = [];
			yearlyFilters.push({
				"name": "All",
				"value": "all"
			});
			for (var i = 0; i < recentYears.length; i++) {
				yearlyFilters.push({
					name: recentYears[i],
					value: recentYears[i]
				})
			}

			return yearlyFilters;
		}

		return {
			getFilters: getFilters,
			setFilters: setFilters,
			getItems: getItems,
			setItems: setItems,
			getSearchParams: getSearchParams,
			setSearchParams: setSearchParams,
			setTotalMedia: setTotalMedia,
			getTotalMedia: getTotalMedia,
			getTimeRange: getTimeRange,
			buildMonthFilters: buildMonthFilters,
			buildYearFilters: buildYearFilters
		};
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('purchaseHistoryCtrl', purchaseHistoryCtrl);

	purchaseHistoryCtrl.$inject = ['$scope', 'sessionManagerSvc', 'purchaseHistorySvc'];

	function purchaseHistoryCtrl($scope, sessionManagerSvc, purchaseHistorySvc) {
		var self = this;

		$scope.$parent.vm.contextPage = "purchase-history";
		self.loginedUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.hideHeaderBar = false;

		self.filtersFromMonth = {
			"items": purchaseHistorySvc.buildMonthFilters(),
			'defaultText': 'Month'
		};
		self.filtersFromYear = {
			"items": purchaseHistorySvc.buildYearFilters(),
			'defaultText': 'Year'
		};
		self.filtersToMonth = {
			"items": purchaseHistorySvc.buildMonthFilters(),
			'defaultText': 'Month'
		};
		self.filtersToYear = {
			"items": purchaseHistorySvc.buildYearFilters(),
			'defaultText': 'Year'
		};

		$scope.altInputFormats = ['M!/yyyy'];

		self.navigation = {
			context: self.subContextPage,
			items: [
				{
					name: 'custom-content-assignments',
					redirectTo: 'setting.purchase-history.custom-content-assignment',
					permissions: [
						'business',
						'admin',
						'marketer'
					]
				},
				{
					name: 'community-challenges',
					redirectTo: 'setting.purchase-history.mission-list',
					permissions: [
						'business',
						'admin',
						'marketer'
					]
				},
				{
					name: 'stock',
					redirectTo: 'setting.purchase-history.order-list'
				},
				{
					name: 'credit-plans',
					redirectTo: 'setting.purchase-history.credit-list',
					permissions: [
						'business',
						'admin',
						'marketer'
					]
				}
			]
		}

		self.navigationOptions = {
			hideBorder: true
		}
	}
})();

(function () {
	'use strict';

	angular
	.module('pixerf')
	.config(routerDefaultConfig)
	.config(routerConfig);

	routerDefaultConfig.$inject = ['$urlRouterProvider'];

	function routerDefaultConfig($urlRouterProvider) {
		'ngInject';
	}

	routerConfig.$inject = ['$stateProvider'];

	function routerConfig($stateProvider) {
	  'ngInject';
	  $stateProvider
		.state('setting.purchase-history', {
			url: '/purchase-history',
			templateUrl: 'app/components/purchase-history/purchase-history.html',
			controller: 'purchaseHistoryCtrl',
			abstract: true,
			controllerAs: 'vm',
			data: {
				pageTitle: "PIXERF - Transaction History"
			}
		})
		.state('setting.purchase-history.order-list', {
			url: '',
			params: {'orderId': null},
			templateUrl: 'app/components/purchase-history/order-list/order-list.html',
			controller: 'orderListCtrl',
			controllerAs: 'vm',
			data: {
				pageTitle: "PIXERF - Transaction History Marketplace"
			}
		})
		.state('setting.purchase-history.order-details', {
			url: '/order-details/:orderId',
			templateUrl: 'app/components/purchase-history/order-details/order-details.html',
			controller: 'orderDetailsCtrl',
			controllerAs: 'vm',
			data: {
				pageTitle: "PIXERF - Order Details"
			}
		})
		.state('setting.purchase-history.mission-list', {
			url: '/mission',
			params: {'transactionId': null},
			templateUrl: 'app/components/purchase-history/mission-list/mission-list.html',
			controller: 'missionListCtrl',
			controllerAs: 'vm',
			data: {
				pageTitle: "PIXERF - Transaction History Missions"
			}
		})
		.state('setting.purchase-history.purchase-history-mission-details', {
			url: '/mission/:orderId',
			templateUrl: 'app/components/purchase-history/purchase-history-mission-details/purchase-history-mission-details.html',
			controller: 'purchaseHistoryMissionDetailsCtrl',
			controllerAs: 'vm',
			data: {
				pageTitle: "PIXERF - Transaction History Missions"
			}
		})
		.state('setting.purchase-history.credit-list', {
			url: '/credit-plans',
			params: {'transactionId': null},
			templateUrl: 'app/components/purchase-history/credit-list/credit-list.html',
			controller: 'creditListCtrl',
			controllerAs: 'vm',
			data: {
				pageTitle: "PIXERF - Transaction History"
			}
		})
		.state('setting.purchase-history.custom-content-assignment', {
			url: '/custom-content-assignment',
			params: {'transactionId': null},
			templateUrl: 'app/components/purchase-history/custom-content-assignment/custom-content-assignment.html',
			controller: 'customContentAssignmentCtrl',
			controllerAs: 'vm',
			data: {
				pageTitle: "PIXERF - Custom Content Assignment"
			}
		});
	}
  })();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('profilesGridCtrl', profilesGridCtrl);

	profilesGridCtrl.$inject = ['$scope', 'removeMemberPopupSvc', 'pagingUtils', 'toastr', '$state', 'contextConst'];

	function profilesGridCtrl($scope, removeMemberPopupSvc, pagingUtils, toastr, $state, contextConst) {

		var self = this;
		self.fetch = fetch;
		self.fetchMore = fetchMore;
		self.onRemoveBtnClick = onRemoveBtnClick;
		self.onShowMoreBtnClicked = onShowMoreBtnClicked;
		self.spinner = {
			isVisible: false
		};
		self.profiles = null;
		self.searchParams = {
			page: 1,
			page_size: 8
		}
		self.options = $.extend(true, {
			confirmMessage: "Are you sure to remove user: <%=user%>"
		}, $scope.options);

		function getter(param) {
			return $scope.options.getter(param).$promise;
		}

		function deleter(param) {
			return $scope.options.deleter(param).$promise;
		}

		function init() {
			if (self.options.onInit) {
				self.options.onInit(self);
			}
		}

		init();

		function fetch(searchParams, isFresh) {
			if (self.spinner.isVisible) return;
			self.spinner.isVisible = true;
			if (isFresh) {
				self.searchParams = searchParams;
			}
			getter(searchParams).then(function (response) {
				if (isFresh) {
					self.profiles = [];
				}
				if (response.data && response.data.length > 0) {
					self.profiles = self.profiles.concat(response.data);
				}
				self.isLastPage = pagingUtils.isNoMorePageToLoad(self.searchParams.page, response);
				self.spinner.isVisible = false;
				self.searchParams.page = searchParams.page;
			}, function (err) {
				toastr.error('Failed to get suggested profiles! Please try again.');
			});
		}

		function onShowMoreBtnClicked() {
			if ($scope.options.navigateOnShowAll) {
				$state.go($scope.options.navigateOnShowAll);
			} else {
				fetchMore();
			}
		}

		function fetchMore() {
			if (self.spinner.isVisible) {
				return;
			}
			var param = $.extend(true, {}, self.searchParams);
			param.page++;
			fetch(param);
		}

		function onRemoveBtnClick(profile) {
			var removePopup = removeMemberPopupSvc.showPopup({
				community: $scope.community,
				user: profile
			})
			removePopup.result.then(function(data){
				if(data.user){
					self.profiles = _.reject(self.profiles, function (p) {
						return p.id === data.user.id;
					})
					$scope.community.member_count--;
					if(data.context === contextConst.COMMUNITY_BLOCKED_MEMBER){
						$scope.community.blocked_count++;
					}
				}
			})
		}
	}
})();

(function () {
  'use strict';

  angular
    .module('pixerf')
    .directive('profilesGrid', profilesGrid);

  function profilesGrid() {

    var directive = {
      scope: {
        contextView: "=",
        options: "=",
        community: "="
      },
      restrict: 'E',
      templateUrl: 'app/components/profiles-grid/profiles-grid.html',
      controller: 'profilesGridCtrl',
      controllerAs: 'vm',
      replace: true,
      transclude: true
    };
    return directive;
  }

})();

(function () {

    angular
        .module('pixerf')
        .factory('preventSubmitMissionPopupSvc', preventSubmitMissionPopupSvc);

    preventSubmitMissionPopupSvc.$inject = ['$uibModal'];

    function preventSubmitMissionPopupSvc($uibModal) {

        function showPopup(data) {
            $uibModal.open({
                templateUrl: 'app/components/prevent-submit-mission-popup/prevent-submit-mission-popup.html',
                controller: 'preventSubmitMissionPopupCtrl',
                controllerAs: 'vm',
                animation: true,
                windowClass: 'zindex prevent-submit-mission-popup',
                resolve: {
                    data: function(){
                        return data;
                    }
                }
            });
        }

        return {
            showPopup: showPopup
        };
    }
})();

(function () {
    'use strict';

    angular
        .module('pixerf')
        .controller('preventSubmitMissionPopupCtrl', preventSubmitMissionPopupCtrl);

    preventSubmitMissionPopupCtrl.$inject = ['$scope', 'data', '$state', '$uibModalInstance', 'ISO3166', ];

    function preventSubmitMissionPopupCtrl($scope, data, $state, $uibModalInstance, ISO3166) {

        var self = this;
        self.countries = [];
        self.nationality =  ISO3166.getCountryNames(data.countries);
        self.closePopup = closePopup;
        self.onBrowseClicked = onBrowseClicked;

        init();

        function closePopup(){
            $uibModalInstance.close();
        }

        function init(){
            self.countries = getSupportedCountries(data.countries).join(", ");
            self.nationality = getNationlity(data.countries).join(", ");
        }

        function getSupportedCountries(countryCodes){
            return Object.values(ISO3166.getCountryNames(countryCodes));
        }

        function getNationlity(countryCodes){
            return Object.values(ISO3166.getNationality(countryCodes));
        }

        function onBrowseClicked(){
            $state.go("run-a-challenge-page.live-challenges");
            closePopup();
        }
    }
})();

(function(){
	'use strict';
	angular
	  .module('pixerf')
	  .factory('portfolioWelcomePopupSvc', portfolioWelcomePopupSvc);
	  portfolioWelcomePopupSvc.$inject = ['$uibModalStack', '$uibModal'];

	  function portfolioWelcomePopupSvc($uibModalStack, $uibModal){
		  function showPopup(data){
			  return $uibModal.open({
				  templateUrl: 'app/components/portfolio-welcome-popup/portfolio-welcome-popup.html',
				  controller: 'portfolioWelcomePopupCtrl',
				  controllerAs: 'vm',
				  animation: true,
				  windowClass: 'zindex portfolio-welcome-screen',
				  resolve: {
					  'resolveData': function(){
						  return data;
					  }
				  }
			  });

		  }

		  return {
			  showPopup: showPopup
		  };
	  }
  })();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('portfolioWelcomePopupCtrl', portfolioWelcomePopupCtrl);

    portfolioWelcomePopupCtrl.$inject = ['$uibModalInstance','resolveData','accountUtils'];

    function portfolioWelcomePopupCtrl($uibModalInstance, resolveData, accountUtils) {

        var self = this;

        self.person = resolveData;
        self.greetingMessage = "Hi, " + accountUtils.buildUserDisplayName(resolveData);
        self.welcomeMessage = "Your portfolio created successfully!<br/>Let's upload photo to portfolio!";

        self.ok = function () {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('portfolioTileCtrl', portfolioTileCtrl);

	portfolioTileCtrl.$inject = ['$scope', 'sessionManagerSvc'];

	function portfolioTileCtrl($scope, sessionManagerSvc) {

		var self = this;
		self.imgCoverLayout = 0;
		self.loginnedUser = sessionManagerSvc.getCurrentLoginUser().data;
		if($scope.portfolio && $scope.portfolio.thumbnailPath){
			self.imgCoverLayout = $scope.portfolio.thumbnailPath.length > 2 ? 3 : $scope.portfolio.thumbnailPath.length;
		}
	}
})();
(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('portfolioTile', portfolioTile);

	function portfolioTile() {

		var directive = {
			scope: {
				speciality: "@",
				portfolio: "=",
				onPortfolioClicked: "&",
				isSmallSize: "@?"
			},
			templateUrl: 'app/components/portfolio-tile/portfolio-tile.html',
			restrict: 'E',
			controller: 'portfolioTileCtrl',
			controllerAs: 'vm',
			replace: true
		};
		return directive;
	}

})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.factory('portfolioPhotoGridSvc', portfolioPhotoGridSvc);

	portfolioPhotoGridSvc.$inject = ['pixerfApiGallerySvc', 'fileConst'];

	function portfolioPhotoGridSvc(pixerfApiGallerySvc, fileConst) {
		function fetchPhotos(searchParam) {
			var urlParams = {page: searchParam.page, page_size: fileConst.PHOTO_GRID_PAGE_SIZE};
			var galleryIds = typeof searchParam.galleryIds === "string" ? searchParam.galleryIds.split(",") : searchParam.galleryIds;
			urlParams.id = galleryIds[0];
			return pixerfApiGallerySvc.get_medias(urlParams).$promise
		}
		return {
			fetchPhotos: fetchPhotos
		};
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('portfolioPhotoGridCtrl', portfolioPhotoGridCtrl);

	portfolioPhotoGridCtrl.$inject = ['$timeout', '$rootScope', '$scope', 'portfolioPhotoGridSvc', 'uploadPhotoDetailSvc', 'fileUtils', 'toastr', 'addToGallerySvc', 'pagingUtils', 'sessionManagerSvc', 'accountUtils', 'galleryUtils', '$q', 'pixerfApiGallerySvc', 'arrayUtils', 'numberUtils', 'gallerySvc', 'photoDetailSvc'];

	function portfolioPhotoGridCtrl($timeout, $rootScope, $scope, portfolioPhotoGridSvc, uploadPhotoDetailSvc, fileUtils, toastr, addToGallerySvc, pagingUtils, sessionManagerSvc, accountUtils, galleryUtils, $q, pixerfApiGallerySvc, arrayUtils, numberUtils, gallerySvc, photoDetailSvc) {

		var self = this;
		self.containerClass = $scope.container ? $scope.container + " .photo-grid__photos-container" : '';
		self.getFile = getFile;
		self.onFileRemoved = onFileRemoved;
		self.fetchMorePhotos = fetchMorePhotos;
		self.fetchPhotos = fetchPhotos;
		self.render = render;
		self.spinner = { isVisible: false };
		self.photos = null;
		self.totalPhotos = 0;
		self.totalPage = 0;
		self.failedToLoadImages = [];
		self.searchParams = null;
		self.firstPageNumber = -1;
		self.isNoMorePhotoToLoad = true;
		self.onPortfolioPhotoRemoved = onPortfolioPhotoRemoved;
		self.onPhotoPopupSaved = onPhotoPopupSaved;
		$scope.instance = self;
		self.onWindowResize = _.debounce(reRender, 300);
		self.onOrientationChange = _.debounce(reRenderOrientationChange, 300);
		self.isFresh = false;
		var mLoginnedUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.isMobile = photoDetailSvc.isMobile();


		function getFile(fileId) {
			var found = fileUtils.findFileById(self.photos, fileId);

			return found;
		}
		function fetchPhotos(searchParams, isRefresh) {
			var def = $q.defer();
			if (self.spinner.isVisible) {
				def.resolve([]);
				return def.promise;
			}
			self.searchParams = searchParams || {};
			if (!self.searchParams.page) self.searchParams.page = 1;


			self.spinner.isVisible = true;
			self.isNoMorePhotoToLoad = false;
			if (isRefresh) {
				reset();
			}

			if (self.firstPageNumber === -1) self.firstPageNumber = self.searchParams.page;

			self.isFresh = isRefresh;
			portfolioPhotoGridSvc.fetchPhotos(self.searchParams).then(function (response) {
				self.spinner.isVisible = false;
				if (self.searchParams.page === 1) {
					self.failedToLoadImages = [];
					self.photos = [];
				}
				if (response.data && response.data.length > 0) {
					if (angular.isDefined($scope.onBeforeRender)) {
						$scope.onBeforeRender({ photos: response.data });
					}
					self.photos = self.photos.concat(response.data);
					render(response.data);
				}
				self.isNoMorePhotoToLoad = pagingUtils.isNoMorePageToLoad(self.searchParams.page, response);
				self.totalPhotos = pagingUtils.getTotalCount(response);
				self.totalPage = pagingUtils.getTotalPage(response);
				def.resolve(self);
			}, function () {
				self.isFresh = false;
				self.spinner.isVisible = false;
				def.reject(self);
			});

			return def.promise;
		}
		function registerScrollSpy(photos) {
			for (var i = 0; i < photos.length; i++) {
				var photo = photos[i];
				photo.onScrollTo = '';
				photo.scrollSpyId = undefined;
				photo.pixerfScrollSpyDirection = undefined;
				photo.isFirstPhoto = undefined;
				photo.isLastPhoto = undefined;
				if (i === 0) {
					photo.scrollSpyId = new Date().getTime() + "-" + photo.id;
					photo.onScrollTo = 'onScrollToPhoto({page:' + self.searchParams.page + '})';
					photo.pixerfScrollSpyDirection = 'down';
					if (self.searchParams.page === self.firstPageNumber) {
						photo.pixerfScrollSpyDirection = 'both';
						photo.isFirstPhoto = true;
					}
				}
				if (i === photos.length - 1) {
					photo.scrollSpyId = new Date().getTime() + "-" + photo.id;
					photo.onScrollTo = 'onScrollToPhoto({page:' + self.searchParams.page + '})';
					photo.pixerfScrollSpyDirection = 'up';
					if (self.isNoMorePhotoToLoad) {
						photo.isLastPhoto = true;
						photo.pixerfScrollSpyDirection = 'both';
					}
				}
			}
		}
		function fetchMorePhotos() {
			if (self.spinner.isVisible) {
				return;
			}
			self.searchParams.page++;
			if ($scope.onLoadMorePage) $scope.onLoadMorePage({ page: self.searchParams.page });
			fetchPhotos(self.searchParams);
		}
		function startRendering(photos, failedToLoadImages) {
			photos = removeSpoilPhotos(photos, failedToLoadImages);
			if (angular.isDefined($scope.shuffle)) {
				var shuffleRange = numberUtils.parseInt($scope.shuffle);
				if (self.searchParams.page <= shuffleRange) {
					photos = arrayUtils.shuffle(photos);
				}
			}
			if (angular.isDefined($scope.onScrollToPhoto)) {
				registerScrollSpy(photos);
			}
			$scope.grid.generate(photos);
		}
		function redraw() {
			startRendering(self.photos, self.failedToLoadImages);
		}
		function render(photos) {
			if (photos.length <= 0) return;
			self.spinner.isVisible = true;
			var imageElements = [];
			var loadedImage = 0;
			for (var i = 0; i < photos.length; i++) {
				imageElements[i] = new Image();
				imageElements[i].setAttribute("class", "image" + i);
				imageElements[i].onload = (function (idx) {
					return function () {
						loadedImage++;
						photos[idx].w = this.width;
						photos[idx].h = this.height;
						photos[idx].ar = this.width / this.height;
						if (loadedImage === photos.length) {
							self.spinner.isVisible = false;
							self.isFresh = false;
							startRendering(photos, self.failedToLoadImages);
						}
					}
				})(i)
				imageElements[i].onerror = (function (idx) {
					return function () {
						loadedImage++;
						self.failedToLoadImages.push(photos[idx].id);
						if (loadedImage === photos.length) {
							self.spinner.isVisible = false;
							self.isFresh = false;
							startRendering(photos, self.failedToLoadImages);
						}
					}
				})(i)
				var photo = photos[i];
				imageElements[i].src = photo.urlSmall;
			}
		}
		function removeSpoilPhotos(photos, spoilPhotoIds) {
			for (var i = 0; i < spoilPhotoIds.length; i++) {
				photos = _.reject(photos, function (item) {
					return item.id === spoilPhotoIds[i];
				});
			}
			return photos;
		}
		function reRender() {
			if ($rootScope.mobileAndTabletcheck) return;
			if (self.photos.length === 0 || self.spinner.isVisible) return;
			$scope.grid.reset();
			redraw();
		}
		function reRenderOrientationChange() {
			if ($rootScope.mobileAndTabletcheck) {
				$scope.grid.reset();
				redraw();
			}
		}
		function reset() {
			self.photos = [];
			$scope.grid.reset();
			self.firstPageNumber = -1;
		}
		function onPortfolioPhotoRemoved(file, extraParams) {
			self.photos = _.reject(self.photos, function (f) {
				return f.id === file.id;
			});
			$scope.grid.reset();
			if (self.photos.length > 0) {
				render(self.photos);
			} else {
				self.spinner.isVisible = false;
			}
			if ($scope.gallery) {
				gallerySvc.updateGalleryCover($scope.gallery);
			}
			if ($scope.onPortfolioPhotoRemoved) {
				$scope.onPortfolioPhotoRemoved({ file: file, extraParams: extraParams });
			}

		}
		function onPhotoPopupSaved(oldPhoto, newPhoto) {
			if (oldPhoto.rotate_by !== newPhoto.rotate_by) {
				oldPhoto.urlSmall = oldPhoto.urlSmall.split('?')[0] + "?" + new Date().getTime();
				reRender();
			}
			if ($scope.onPhotoPopupSaved) {
				$scope.onPhotoPopupSaved.apply(arguments);
			}
		}

		function onFileRemoved(file, extraParams) {
			self.photos = _.reject(self.photos, function (f) {
				return f.id === file.id;
			});
			$scope.grid.reset();
			if (self.photos.length > 0) {
				render(self.photos);
			} else {
				self.spinner.isVisible = false;
			}
			if ($scope.gallery) {
				gallerySvc.updateGalleryCover($scope.gallery);
			}
			if ($scope.onFileRemoved) {
				$scope.onFileRemoved({ file: file, extraParams: extraParams });
			}

		}
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('portfolioPhotoGrid', portfolioPhotoGrid);
	portfolioPhotoGrid.$inject = ["$compile"];
	function portfolioPhotoGrid($compile) {

		var directive = {
			scope: {
				photos: "=",
				onPortfolioPhotoRemoved: "&?",
				morePhotos: "=",
				instance: "=?",
				portfolioGallery: "=",
				context: '=',
				idealHeight: '=',
				isIgnoreBodyScroll: '=',
				onScrollToPhoto: '&?',
				shuffle: '@',
				onLoadMorePage: '&',
				onBeforeRender: '&?',
				onFileRemoved: '&?',
				container: '@?',
				onInit: '&?',
				template: '=',
				height: '@'
			},
			transclude: true,
			restrict: 'E',
			templateUrl: 'app/components/portfolio-photo-grid/portfolio-photo-grid.html',
			controller: 'portfolioPhotoGridCtrl',
			controllerAs: 'vm',
			replace: true,
			link: function (scope, element, attrs, ctrl) {
				function buildItemTemplate() {
					if (attrs.template) {
						return scope.template;
					}
					var str = '<portfolio-photo file="vm.getFile(<%=id%>)" on-remove-portfolio-photo-clicked="vm.onPortfolioPhotoRemoved(file)" portfolio-gallery="portfolioGallery" on-file-removed="vm.onFileRemoved(file)" >';
					str += '</portfolio-photo>';
					return str;
				}
				scope.grid = new PhotoGrid({
					idealHeight: ctrl.isMobile ? Math.max(150, parseInt(window.innerHeight / 4)) : (scope.idealHeight ? scope.idealHeight : Math.max(350, parseInt(window.innerHeight / 3))),
					$container: $(element).find(".photo-grid__photos-container"),
					$parent: scope.container ? $(scope.container + " .photo-grid__photos-container") : $("body"),
					itemTmpl: buildItemTemplate(),
					height: scope.height,
					isIgnoreBodyScroll: scope.isIgnoreBodyScroll,
					events: {
						beforeItemRendered: function (item, photo) {
							$compile(item)(scope);
						}
					}
				});
				if (attrs.onInit) {
					scope.onInit({ portfolioPhotoGrid: ctrl });
				}
			}
		};
		return directive;
	}

})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.factory('portfolioPhotoSvc', portfolioPhotoSvc);

	portfolioPhotoSvc.$inject = ['pixerfApiMediaSvc', '$q'];

	function portfolioPhotoSvc(pixerfApiMediaSvc, $q) {
		function updateFileGalleriesInfo(file, portfolioGallery) {
			if (!file.galleries) {
				file.galleries = [];
			}
			if (portfolioGallery.isSelected) {
				file.galleries.push(portfolioGallery);
			} else {
				file.galleries = _.reject(file.galleries, function (gal) {
					return gal.id === portfolioGallery.id;
				})
			}
		}

		function removePhotoFromPortfolioGallery(file, portfolioGallery) {
			var def = $q.defer();
			pixerfApiMediaSvc.remove_from_gallery({
				id: file.id,
				gallery_id: portfolioGallery.id
			}, {}).$promise.then(function () {
				def.resolve();
				updateFileGalleriesInfo(file, portfolioGallery);
			}, function () {
				// portfolioGallery.isSelected = !portfolioGallery.isSelected;
				def.reject();
			});
			return def.promise;
		}
		return {
			removePhotoFromPortfolioGallery: removePhotoFromPortfolioGallery,
			updateFileGalleriesInfo: updateFileGalleriesInfo
		};
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('portfolioPhotoCtrl', portfolioPhotoCtrl);

	portfolioPhotoCtrl.$inject = ['$scope', 'pixerfConfirmPopupSvc', 'portfolioPhotoSvc', 'toastr', 'sessionManagerSvc'];

	function portfolioPhotoCtrl($scope, pixerfConfirmPopupSvc, portfolioPhotoSvc, toastr, sessionManagerSvc) {
		var self = this;
		self.onRemovePortfolioPhotoClicked = onRemovePortfolioPhotoClicked;
		self.displaySize = $scope.displaySize ? $scope.file.thumbnails[scope.displaySize] : $scope.file.thumbnails['x400'];
		self.isLogined =  !!sessionManagerSvc.getCurrentLoginUser().data;
        self.loginUser = sessionManagerSvc.getCurrentLoginUser().data;

		self.isMine = sessionManagerSvc.isMine($scope.file.user);

		function onRemovePortfolioPhotoClicked(file, portfolioGallery) {
			var modal = pixerfConfirmPopupSvc.showPopup({ message: 'Hi, This photo will be removed from this portfolio gallery.' });
			modal.result.then(function () {
				portfolioPhotoSvc.removePhotoFromPortfolioGallery(file, portfolioGallery).then(function () {
					file.portfolios = _.reject(file.portfolios, function (gl) {
						return gl.id === portfolioGallery.id;
					})
					$scope.onFileRemoved({ file: file });
				}, function () {
					toastr.error("Cannot remove this photo from this portfolio gallery. Please try again.");
				})
			});
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('portfolioPhoto', portfolioPhoto);

	function portfolioPhoto() {

		var directive = {
			scope: {
				displaySize: "@",
				file: "=",
				portfolioGallery: "=",
				onFileRemoved: "&",
				onRemovePortfolioPhotoClicked: "&?"
			},
			restrict: 'E',
			templateUrl: 'app/components/portfolio-photo/portfolio-photo.html',
			controller: 'portfolioPhotoCtrl',
			controllerAs: 'vm',
			replace: true
		};
		return directive;
	}

})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('portfolioListSliderCtrl', portfolioListSliderCtrl);

	portfolioListSliderCtrl.$inject = ['$scope', 'sessionManagerSvc', '$timeout', 'systemUtils', '$q', 'toastr', 'pixerfApiPortfolioSvc', 'pagingUtils', 'accountUtils', 'uploadPortfolioPhotoSvc'];

	function portfolioListSliderCtrl($scope, sessionManagerSvc, $timeout, systemUtils, $q, toastr, pixerfApiPortfolioSvc, pagingUtils, accountUtils, uploadPortfolioPhotoSvc) {

		var self = this;

		self.loginUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.portfolio = $scope.portfolio;
		self.user = $scope.owner;
		self.isMine = sessionManagerSvc.isMine(self.user);
		self.userDisplayName = accountUtils.buildUserDisplayName(self.user);
		self.fetchPortfolios = fetchPortfolios;
		self.onUploadPortfolioPhoto = onUploadPortfolioPhoto;
		self.spinner = { isVisible: false };
		self.currentIndex = 0;
		self.portfolios = [];
		self.searchParams = null;

		$scope.instance = self;

		$timeout(function () {
			self.slickReady = true;
		});

		genTextAsContext();

		self.carouselConfig = {
			slidesToShow: 3,
			slidesToScroll: 3,
			responsive: [{
				breakpoint: 1024,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2
				}
			}, {
				breakpoint: 480,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1
				}
			}]
		};

		self.slickConfig = {
			responsive: [{
				breakpoint: 1200,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 3
				}
			}, {
				breakpoint: 1024,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2
				}
			}, {
				breakpoint: 480,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1
				}
			}],
			event: {
				afterChange: function (event) {
					self.currentSlide = Math.ceil(event.currentSlide / event.slick.options.slidesToShow) + 1;
					systemUtils.digest($scope);
				},
				init: function(event){
					self.slideToShow = event.slick.options.slidesToShow;
					self.totalSlideShow = Math.ceil(event.slick.slideCount / event.slick.options.slidesToShow);
					self.currentSlide = Math.ceil(event.slick.currentSlide / event.slick.options.slidesToShow) + 1;
				},
				breakpoint: function(event){
					self.slideToShow = event.slick.options.slidesToShow;
					self.totalSlideShow = Math.ceil(event.slick.slideCount / event.slick.options.slidesToShow);
					systemUtils.digest($scope);
				}
			}
		};

		function genTextAsContext() {
			self.portfolioContext = $scope.portfolio.grid;
		}

		function fetchPortfolios(params, isFresh) {
			var def = $q.defer();

			if (isFresh) {
				reset();
			}
			self.searchParams = params;
			if (self.firstPageNumber === -1) self.firstPageNumber = self.searchParams.page;

			self.spinner.isVisible = true;
			pixerfApiPortfolioSvc["getUserPortfolios"](self.searchParams).$promise.then(function (response) {
				def.resolve(response);
				if (isFresh) self.portfolios = [];
				if (response && response.data.length > 0) {
					response.data = attachPortfolioIdForGallery(response.data, self.portfolio.id);
					self.portfolios = self.portfolios.concat(response.data);
				}
				self.isLastPage = pagingUtils.isNoMorePageToLoad(self.searchParams.page, response);
				self.totalPage = pagingUtils.getTotalPage(response);
				self.totalCount = pagingUtils.getTotalCount(response);
				$timeout(function(){
					self.spinner.isVisible = false;
					self.showSlick = true;
				});
			}, function (err) {
				def.reject(err);
				toastr.error('Failed to get portfolios');
			});
			return def.promise;
		}

		function reset() {
			self.firstPageNumber = -1;
		}

		function attachPortfolioIdForGallery(galleries, portfolioId){
			for(var i = 0; i < galleries.length; i++){
				galleries[i].portfolioId = portfolioId;
			}
			return galleries;
		}

		function onUploadPortfolioPhoto(portfolioId) {
			uploadPortfolioPhotoSvc.showUploadModal({portfolioId: portfolioId});
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('portfolioListSlider', portfolioListSlider);

	function portfolioListSlider() {

		var directive = {
			scope: {
				owner: "=",
				portfolio: "=",
				instance: "=",
				onPortfolioClicked: "&",
				hideName: "@",
				hideUpload: "@",
				isSmallSize: "@?",
				minShowList: "@?"
			},
			restrict: 'E',
			templateUrl: 'app/components/portfolio-list-slider/portfolio-list-slider.html',
			controller: 'portfolioListSliderCtrl',
			controllerAs: 'vm',
			replace: true
		};
		return directive;
	}

})();

(function () {
    'use strict';

    angular
        .module('pixerf')
        .controller('portfolioGridCtrl', portfolioGridCtrl);

    portfolioGridCtrl.$inject = ['$scope', 'pixerfApiPortfolioSvc', 'pagingUtils', 'toastr', '$q', 'sessionManagerSvc', 'pixerfApiMediaSvc', 'systemUtils'];

    function portfolioGridCtrl($scope, pixerfApiPortfolioSvc, pagingUtils, toastr, $q, sessionManagerSvc, pixerfApiMediaSvc, systemUtils) {

        var self = this;
        self.portfolios = null;
        self.spinner = { isVisible: false };
        self.isLastPage = false;
        self.searchParams = null;

        self.fetchPortfolios = fetchPortfolios;
        self.fetchMorePortfolios = fetchMorePortfolios;
        self.addPortfolio = addPortfolio;
        self.loginUser = sessionManagerSvc.getCurrentLoginUser().data;

        $scope.instance = self;

        function fetchPortfolios(params, isFresh) {
            var def = $q.defer();

            if (isFresh) {
                reset();
            }
            self.searchParams = params;
            if (self.firstPageNumber === -1) self.firstPageNumber = self.searchParams.page;
            var action = "getUserPortfolios";
            self.spinner.isVisible = true;
            pixerfApiPortfolioSvc[action](params).$promise.then(function (response) {
                def.resolve(response);
                if (isFresh) self.portfolios = [];
                if (response && response.data && response.data.length > 0) {
                    self.portfolios = self.portfolios.concat(response.data);
                }
                if(self.portfolios.length % 3 === 1){
                    self.virstualTile1 = true;
                    self.virstualTile2 = true;
                } else if(self.portfolios.length % 3 === 2){
                    self.virstualTile1 = true;
                    self.virstualTile2 = false;
                } else {
                    self.virstualTile1 = false;
                    self.virstualTile2 = false;
                }
                self.isLastPage = pagingUtils.isNoMorePageToLoad(self.searchParams.page, response);
                self.totalPage = pagingUtils.getTotalPage(response);
                self.spinner.isVisible = false;
            }, function (err) {
                def.reject(err);
                toastr.error('Failed to get portfolios');
                self.spinner.isVisible = false;
            });
            return def.promise;
        }
        function fetchMorePortfolios() {
            if (self.spinner.isVisible) return;
            if (self.isLastPage) return;
            self.searchParams.page++;
            fetchPortfolios(self.searchParams);
            if ($scope.onLoadMorePage) {
                $scope.onLoadMorePage({ page: self.searchParams.page });
            }
        }
        function addPortfolio(portfolio) {
            self.portfolios.unshift(portfolio);
        }
        function reset() {
            self.firstPageNumber = -1;
        }
    }
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('portfolioGrid', portfolioGrid);
	portfolioGrid.$inject = ['$location']
	function portfolioGrid($location) {

		var directive = {
			scope: {
				owner: "=",
				instance: "=",
				onLoadMorePage: '&?',
				onScrollToGallery: '&?',
				onScrollToSectionId: '@',
				onScrollOffsetTop: '@',
				onPortfolioClicked: '&'
			},
			restrict: 'E',
			transclude: true,
			templateUrl: 'app/components/portfolio-grid/portfolio-grid.html',
			controller: 'portfolioGridCtrl',
			controllerAs: 'vm',
			replace: true
		};
		return directive;
	}

})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.factory('portfolioGalleriesListSvc', portfolioGalleriesListSvc);

	portfolioGalleriesListSvc.$inject = ['pixerfApiPortfolioSvc', 'toastr'];

	function portfolioGalleriesListSvc(pixerfApiPortfolioSvc, toastr) {

		var mPortfolioGalleries = {
			data: null
		};
		var mCurrentPage = {
			data: 0
		};
		var mTotalPage = {
			data: 0
		};
		var mIsLastPage = {
			data: false
		};
		function getPortfolioGalleries(type) {
			return mPortfolioGalleries;
		}
		function setPortfolioGalleries(value) {
			mPortfolioGalleries.data = value;
		}

		function getCurrentPage() {
			return mCurrentPage;
		}
		function getTotalPage() {
			return mTotalPage;
		}
		function setTotalPage(value) {
			mTotalPage.data = value;
		}
		function fetchPortfolioGallaries(param) {
			return pixerfApiPortfolioSvc.getUserPortfolios(param).$promise;
		}

		function setIsLastPage(value) {
			return mIsLastPage.data = value;
		}
		function isLastPage() {
			return mIsLastPage;
		}
		function checkPortfolioGalleries(portfolioGalleries, checkedPortfolioGalleries) {
			var addedPortfolioGallery;
			console.log(checkedPortfolioGalleries);
			for (var i = 0; i < portfolioGalleries.length; i++) {
				var portfolioGallery = portfolioGalleries[i];
				addedPortfolioGallery = _.find(checkedPortfolioGalleries, function (gl) {
					return gl.id === portfolioGallery.id;
				});
				portfolioGallery.isSelected = !!addedPortfolioGallery;
			}
		}
		function reset() {
			mPortfolioGalleries.data = null;
			mCurrentPage.data = 0;
		}
		return {
			getPortfolioGalleries: getPortfolioGalleries,
			setPortfolioGalleries: setPortfolioGalleries,
			getCurrentPage: getCurrentPage,
			fetchPortfolioGallaries: fetchPortfolioGallaries,
			checkPortfolioGalleries: checkPortfolioGalleries,
			getTotalPage: getTotalPage,
			setTotalPage: setTotalPage,
			setIsLastPage: setIsLastPage,
			isLastPage: isLastPage

		}
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('portfolioGalleriesListCtrl', portfolioGalleriesListCtrl);

	portfolioGalleriesListCtrl.$inject = ['$scope', 'portfolioGalleriesListSvc', 'pagingUtils', 'toastr', 'galleryConst'];

	function portfolioGalleriesListCtrl($scope, portfolioGalleriesListSvc, pagingUtils, toastr, galleryConst) {

		var self = this;

		$scope.instance = self;

		self.onPortfolioGalleryItemClicked = onPortfolioGalleryItemClicked;
		self.spinner = { isVisible: false };
		self.portfolios = portfolioGalleriesListSvc.getPortfolioGalleries();
		self.currentPage = portfolioGalleriesListSvc.getCurrentPage();
		self.isLastPage = portfolioGalleriesListSvc.isLastPage();
		self.fetchMorePortfolioGallaries = fetchMorePortfolioGallaries;
		self.onWindowScroll = onWindowScroll;
		self.searchParams = {};
		$scope.$watch("vm.portfolios.data", function (newPortfolioGalleries, portfolios) {
			if ($scope.onPortfolioGalleriesChanged && newPortfolioGalleries && newPortfolioGalleries.length > 0) {
				$scope.onPortfolioGalleriesChanged({galleries: newPortfolioGalleries});
			}
		})
		$scope.$watch("portfolioGalleryType", _.debounce(function (newType) {
			$scope.$apply(function () {
				fetchPortfolioGallaries({
					speciality: $scope.portfolioId,
					userid: $scope.user.id
				}, true);
			})
		}, 300))
		function onWindowScroll() {
			$("body").trigger("click");
		}
		function onPortfolioGalleryItemClicked(evt, portfolioGallery) {
			if ($scope.onPortfolioGalleryItemClicked) {
				$scope.onPortfolioGalleryItemClicked({ evt: evt, portfolioGallery: portfolioGallery });
			}
		}
		function fetchPortfolioGallaries(params, isFresh) {
			self.searchParams = params;
			if (self.spinner.isVisible) return;
			self.spinner.isVisible = true;
			portfolioGalleriesListSvc.fetchPortfolioGallaries(params).then(function (response) {
				if (isFresh) self.portfolios.data = [];
				self.spinner.isVisible = false;
				self.portfolios.data = self.portfolios.data.concat(response.data);
				self.isLastPage.data = pagingUtils.isNoMorePageToLoad(self.searchParams.page ? self.searchParams.page : 1, response);
			}, function () {
				self.spinner.isVisible = false;
				toastr.error('failed to get galleries');
			});
		}
		function fetchMorePortfolioGallaries() {
			if (self.spinner.isVisible) return;
			if (self.isLastPage.data) return;
			if (self.searchParams && !self.searchParams.page) self.searchParams.page = 1;
			self.searchParams.page++;
			fetchPortfolioGallaries(self.searchParams);
		}
	}
})();
(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('portfolioGalleriesList', portfolioGalleriesList);

	function portfolioGalleriesList() {

		var directive = {
			scope: {
				'onPortfolioGalleryItemClicked': '&',
				'onPortfolioGalleriesChanged': '&',
				'portfolioId': '@',
				'user': '=',
				'instance': '='
			},
			templateUrl: 'app/components/portfolio-galleries-list/portfolio-galleries-list.html',
			restrict: 'E',
			controller: 'portfolioGalleriesListCtrl',
			controllerAs: 'vm',
			replace: true
		};
		return directive;
	}

})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('popoverSelectionBtnCtrl', popoverSelectionBtnCtrl);

    popoverSelectionBtnCtrl.$inject = ['$scope', '$timeout'];

    function popoverSelectionBtnCtrl( $scope, $timeout) {

        var self = this;
        self.onItemClicked = onItemClicked;

        var items = [];


        if($scope.settings &&  $scope.settings.items) items = $scope.settings.items;

        //self.options =  buildOptions(items);

        $scope.$watch("settings.items", function(newValue){
            if(newValue){
                self.options = buildOptions(newValue);
            }
        }, true);

        $scope.$watch("selectedModel", function(newValue){
            if(newValue){
                var found = _.find(self.options, function(it){
                    return it.value === $scope.selectedModel[$scope.settings.modelKeyPropertyName ? $scope.settings.modelKeyPropertyName : 'value'];
                })
                if(found){
                    selectItem(found);
                } else {
                    var index = $scope.selectedDefaultIndex ? $scope.selectedDefaultIndex : 0 ;
                    selectItem(self.options[index]);
                }
            }
        }, true);

        function buildOptions(items){
            var arr = [];
            for (var i = 0; i < items.length; i ++){
                arr.push({
                    name: typeof items[i] === 'string' ? items[i] : items[i][$scope.settings.modelNamePropertyName ? $scope.settings.modelNamePropertyName : 'name'],
                    value: typeof items[i] === 'string' ? items[i] : items[i][$scope.settings.modelKeyPropertyName ? $scope.settings.modelKeyPropertyName : 'value'],
                    data: items[i],
                    isSelected: false,
                    isDefault: i === 0
                })
                if(typeof items[i] === 'object' && $scope.settings.modelKeyPropertyName){
                    arr[i].id = items[i][$scope.settings.modelKeyPropertyName];
                }
            }
            if($scope.selectedModel){
                var found = _.find(arr, function(it){
                    return it.value === $scope.selectedModel[$scope.settings.modelKeyPropertyName ? $scope.settings.modelKeyPropertyName : 'value'];
                })
                if(found){
                    selectItem(found);
                } else {
                    var index = $scope.selectedDefaultIndex ? $scope.selectedDefaultIndex : 0 ;
                    selectItem(arr[index]);
                }
            } else if(!$scope.settings.defaultText) {
                selectItem(arr[0]);
            }
            return arr;
        }

        function resetSelectedItem(){
            if(!self.options) return;
            for (var i = 0; i < self.options.length; i ++){
                self.options[i].isSelected = false;
            }
        }

        function selectItem(item){
            if($scope.selectedModel) $scope.selectedModel.isSelected = false;
            resetSelectedItem();
            item.isSelected = true;
            $scope.selectedModel = item;
        }

        function onItemClicked(item){
            selectItem(item);
            (_.debounce(function(){
                $timeout(function(){
                    $scope.onSelectionChanged({item: item});
                })
            }, 300))();
            if($scope.closeOnClick){
                $("body").trigger("click");
                event.stopPropagation();
            }
        }
    }
})();
(function () {
  'use strict';

  angular
    .module('pixerf')
    .directive('popoverSelectionBtn', popoverSelectionBtn);

  function popoverSelectionBtn() {

    var directive = {
      scope: {
        "selectedModel": "=",
        "settings": "=",
        "onSelectionChanged": "&",
        "closeOnClick": "@",
        "popoverClass": "=",
        "selectedDefaultIndex": "@",
        "appendParent": "@"
      },
      restrict: 'E',
      templateUrl: 'app/components/popover-selection-btn/popover-selection-btn.html',
      controller: 'popoverSelectionBtnCtrl',
      controllerAs: 'vm',
      replace: true
    };
    return directive;
  }

})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .factory('popoverCartSvc', popoverCartSvc);

     popoverCartSvc.$inject = ['$rootScope', 'messageConst'];

    function popoverCartSvc($rootScope, messageConst) {

        
        var mIsOpen = {
            data : false
        };
        function isOpen(){
            return mIsOpen;
        }

        function toogle(status){
            $rootScope.$broadcast(messageConst.BROADCAST.TOOGLE_CART_POPUP, {status: status});
        }
        return {
           toogle: toogle,
           isOpen: isOpen
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('pixerf')
        .controller('popoverCartCtrl', popoverCartCtrl);

    popoverCartCtrl.$inject = ['$scope', 'messageConst', '$state', 'cartSvc', '$uibModalStack', '$timeout', 'sessionManagerSvc'];

    function popoverCartCtrl($scope, messageConst, $state, cartSvc, $uibModalStack, $timeout, sessionManagerSvc) {

        var self = this;
        self.viewCartList = viewCartList;
        self.cart = cartSvc.getCart();
        self.isOpen = false;
        self.onCartItemRemoved = onCartItemRemoved;
        self.onCartItemClicked = onCartItemClicked;
        self.onContinueXerfingBtnClicked = onContinueXerfingBtnClicked;
		self.isDisablePopup = isDisablePopup;
		self.onCloseBtnClicked = onCloseBtnClicked;
		self.spinner = {
			isVisible: false
        };
        self.isAuthenticated = function () {
			return !!sessionManagerSvc.getCurrentLoginUser().data;
		};
        $scope.$on(messageConst.BROADCAST.TOOGLE_CART_POPUP, function(event, args) {
            if(typeof args.status !== 'undefined'){
                self.isOpen = !!args.status;
            } else{
                self.isOpen = !self.isOpen;
            }
            
        });
		function onCloseBtnClicked(){
			$timeout(function(){
				$("#header-navbar-btn").trigger("click");
            });
		}
        function viewCartList(){
            $state.go("checkout.shopping-cart");
        }
        function onCartItemRemoved(){
            if(self.cart.data.cart_items.length === 0){
                self.isOpen = false;
            }
        }
        function onCartItemClicked(cartItem){
            $state.go('photo', {id: cartItem.media.id});
        }
        function onContinueXerfingBtnClicked(){
            if($state.current.name === "checkout.shopping-cart"){
                $uibModalStack.dismissAll();
                $timeout(function(){
                     window.history.back();
                })
            }
        }
        function isDisablePopup(){
            return self.cart.data.cart_items.length === 0 || $state.current.name === 'checkout.shopping-cart';
        }
    }
})();
(function () {
  'use strict';

  angular
    .module('pixerf')
    .directive('popoverCart', popoverCart);

  function popoverCart() {

    var directive = {
      scope: {},
      restrict: 'E',
      templateUrl: 'app/components/popover-cart/popover-cart.html',
      controller: 'popoverCartCtrl',
      controllerAs: 'vm',
      replace: true
    };
    return directive;
  }

})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('placeholderEventExploreTile', placeholderEventExploreTile);
	placeholderEventExploreTile.$inject = []

	function placeholderEventExploreTile() {

		var directive = {
			scope: {
                type: '@?'
            },
			restrict: 'E',
			templateUrl: 'app/components/placeholder-event-explore-tile/placeholder-event-explore-tile.html',
			replace: true
		};
		return directive;
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('pixerfUserAvatar', pixerfUserAvatar);

	pixerfUserAvatar.$inject = ['pixerfUrl'];

	function pixerfUserAvatar(pixerfUrl) {

		var directive = {
			scope: {
				userData: '=',
				tooltip: '=',
				lazy: '=',
			},
			restrict: 'E',
			templateUrl: 'app/components/pixerf-user-avatar/pixerf-user-avatar.html',
			replace: true,
			link: function ($scope, element, $attrs) {
				if ($scope.userData && $scope.userData.displayName) {
					$scope.defaultAvatar = pixerfUrl.full + 'api/avatar?name=' + $scope.userData.displayName;
				} else {
					$scope.defaultAvatar = 'assets/images/default/default-profile.png';
				}
			}
		};
		return directive;
	}

})();

(function () {

	angular
		.module('pixerf')
		.controller('pixerfUserCtrl', pixerfUserCtrl);

	pixerfUserCtrl.$inject = ['$scope', 'sessionManagerSvc', 'systemUtils'];

	function pixerfUserCtrl($scope, sessionManagerSvc, systemUtils) {

		var self = this;
		self.loginUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.isMyProfile = self.loginnedUser && self.loginnedUser.id === $scope.userData.id;

		init()

		function init() {
			self.photo = $scope.userData.cover_image_media && $scope.userData.cover_image_media.length && $scope.userData.cover_image_media['1200x'] ? $scope.userData.cover_image_media['1200x'] : $scope.userData.avatar.coverImage;
			systemUtils.digest($scope);
			console.log(self.photo);
		}
	}
})();

(function () {
  'use strict';

  angular
    .module('pixerf')
    .directive('pixerfUser', pixerfUser);

    pixerfUser.$inject = ['$rootScope', '$interval'];
    function pixerfUser($rootScope, $interval) {

    var directive = {
      scope: {
        userData: "=",
        onRemoveBtnClick: "&?",
        onFollowStatusChanged: "&?",
        isHideRemoveBtn: "=",
        isHideFollowers: "@?",
        options: "="
      },
        restrict: 'E',
        templateUrl: 'app/components/pixerf-user/pixerf-user.html',
        controller: 'pixerfUserCtrl',
        controllerAs: 'vm',
        replace: true
      };
      return directive;
    }

})();

(function () {

	angular
		.module('pixerf')
		.controller('pixerfTvCarouselCtrl', pixerfTvCarouselCtrl);

	pixerfTvCarouselCtrl.$inject = ['$scope', 'systemUtils', 'videoPopupSvc', '$timeout'];

	function pixerfTvCarouselCtrl($scope, systemUtils, videoPopupSvc, $timeout) {

		var self = this;
		self.photographers = [{
				"id": 0,
				"photo": "../assets/images/about-contributor/Group.jpg",
				"videoFull": "https://s3-ap-southeast-1.amazonaws.com/pixerf-bucket/videos/v10_What's_In_Your_Camera_Bag-1.mp4",
				"url": "../assets/videos/What’s in your camera bag.mp4",
				"description": "pixerf-tv-1"
			},
			{
				"id": 1,
				"photo": "../assets/images/about-contributor/Group2.jpg",
				"videoFull": "https://s3-ap-southeast-1.amazonaws.com/pixerf-bucket/videos/Travelling To 193 Countries With Sal Lavallo-1.mp4",
				"url": "../assets/videos/Travelling to 193 countries with Sal Lavallo.mp4",
				"description": "pixerf-tv-2"
			},
			{
				"id": 2,
				"photo": "../assets/images/about-contributor/Group3.jpg",
				"videoFull": "https://s3-ap-southeast-1.amazonaws.com/pixerf-bucket/videos/V3 Pixerf Bestofpixerf Q4 28Jan2019 (Oct To Dec)-1.mp4",
				"url": "../assets/videos/Best of PIXERF series - October to December 2018.mp4",
				"description": "pixerf-tv-3"
			},
			{
				"id": 3,
				"photo": "../assets/images/about-contributor/Group4.jpg",
				"videoFull": "https://s3-ap-southeast-1.amazonaws.com/pixerf-bucket/videos/From The Hip- Iphone Photography With Brendan.mp4",
				"url": "../assets/videos/From the hip- iPhone photography with Brendan.mp4",
				"description": "pixerf-tv-4"
			},
			{
				"id": 4,
				"photo": "../assets/images/about-contributor/Group5.jpg",
				"videoFull": "https://s3-ap-southeast-1.amazonaws.com/pixerf-bucket/videos/V07 Pixerf KL Connect Bts-1.mp4",
				"url": "../assets/videos/PIXERF Connects - Kuala Lumpur - Full Behind the Scenes Video.mp4",
				"description": "pixerf-tv-5"
			},
			{
				"id": 5,
				"photo": "../assets/images/about-contributor/Group6.jpg",
				"videoFull": "https://s3-ap-southeast-1.amazonaws.com/pixerf-bucket/videos/V5 Pixerf Bestofpixerf Q3 07Nov2018 (July To Sep)-1.mp4",
				"url": "../assets/videos/Best of PIXERF series - July to September 2018.mp4",
				"description": "pixerf-tv-6"
			},
			{
				"id": 6,
				"photo": "../assets/images/about-contributor/Group7.jpg",
				"videoFull": "https://s3-ap-southeast-1.amazonaws.com/pixerf-bucket/videos/V4 Pixerf Bestofpixerf Q2 01Aug2018 (April To June)-1.mp4",
				"url": "../assets/videos/Best-Of April to June 2018.mp4",
				"description": "pixerf-tv-7"
			},
			{
				"id": 7,
				"photo": "../assets/images/about-contributor/Group8.jpg",
				"videoFull": "https://s3-ap-southeast-1.amazonaws.com/pixerf-bucket/videos/V09 Pixerf Sapa Ep2-1.mp4",
				"url": "../assets/videos/PIXERF x SGTREKKER - Colour and magic in Sapa-Episode 2.mp4",
				"description": "pixerf-tv-8"
			},
			{
				"id": 8,
				"photo": "../assets/images/about-contributor/Group9.jpg",
				"videoFull": "https://s3-ap-southeast-1.amazonaws.com/pixerf-bucket/videos/V12 Pixerf Sapa Ep1-1.mp4",
				"url": "../assets/videos/PIXERF x SGTREKKER - Colour and magic in Sapa-Episode 1.mp4",
				"description": "pixerf-tv-9"
			},
			{
				"id": 9,
				"photo": "../assets/images/about-contributor/Group10.jpg",
				"videoFull": "https://s3-ap-southeast-1.amazonaws.com/pixerf-bucket/videos/V05 Pixerf Re-Visualising Asia-1.mp4",
				"url": "../assets/videos/Re-Visualising Asia.mp4",
				"description": "pixerf-tv-10"
			},
			{
				"id": 10,
				"photo": "../assets/images/about-contributor/Group11.jpg",
				"videoFull": "https://s3-ap-southeast-1.amazonaws.com/pixerf-bucket/videos/Guess These Photography Terms (Part 1)-1.mp4",
				"url": "../assets/videos/Guess these photography terms.mp4",
				"description": "pixerf-tv-11"
			}
		];
		self.onVideoClicked = onVideoClicked;
		self.onHover = onHover;
		self.slidesInit = 2;
		self.targetSlide = 1;

		self.slickConfig = {
			responsive: [{
				breakpoint: 1200,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 3
				}
			}, {
				breakpoint: 1024,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2
				}
			}, {
				breakpoint: 480,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1
				}
			}]
		};

		function onHover(videoId, mouseHover) {
			if (systemUtils.isMobile()) return;
			self.onVideoPlay = mouseHover;
			if (self.onVideoPlay) {
				if ($("#" + videoId)[0]) {
					$("#" + videoId)[0].play();
				}
			} else {
				$("#" + videoId)[0].pause();
			}
		}

		function onVideoClicked(video) {
			videoPopupSvc.showPopup({
				data: video
			});
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('pixerfTvCarousel', pixerfTvCarousel);

	pixerfTvCarousel.$inject = ['$rootScope', '$interval'];
	function pixerfTvCarousel($rootScope, $interval) {

		var directive = {
			scope: {
				instance: '@'
			},
			restrict: 'E',
			templateUrl: 'app/components/pixerf-tv-carousel/pixerf-tv-carousel.html',
			controller: 'pixerfTvCarouselCtrl',
			controllerAs: 'vm',
			replace: true
		};
		return directive;
	}

})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .directive('pixerfRadioBtn', pixerfRadioBtn);

    pixerfRadioBtn.$inject = ['$timeout', 'toastr', 'systemUtils'];

    function pixerfRadioBtn($timeout, toastr, systemUtils) {
        return {
            restrict: 'E',
            replace: false,
            templateUrl: 'app/components/pixerf-radio-btn/pixerf-radio-btn.html',
            scope: {
                model : "=",
                label: "@",
                property: "@",
                onChanged: '&',
                isDisabled : '=',
                value: '=',
                authenticationCheck: '=',
                isRequired: '='
            },
            link: function(scope, element) {
                $timeout(function(){
                    var toogleName = $(element).attr("data-radio-id");
                    var $toogleElemt = $('[pixerf-radio-btn-data-toogle=' + toogleName + ']');
                    if($toogleElemt.length > 0){
                        $toogleElemt.click(function(evt){
                            scope.toogle(evt);
                            systemUtils.digest(scope);
                        });
                    }
                })
                scope.toogle = function(evt){
                    if(scope.isDisabled) return;
                    if(scope.isRequired && scope.model[scope.property] === scope.value) return;
                    if(scope.model[scope.property] !== scope.value){
                        scope.model[scope.property] = scope.value;
                    } else {
                        scope.model[scope.property] = null;
                    }
                    scope.onChanged({evt: evt});
                }
               
            }
        };


    }
})();
(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('pixerfQuillEditorCtrl', pixerfQuillEditorCtrl);

    pixerfQuillEditorCtrl.$inject = ['$scope', 'ngQuillConfig'];

    function pixerfQuillEditorCtrl( $scope, ngQuillConfig) {

        var self = this;
        ngQuillConfig.placeholder = $scope.options.placeholder;
        ngQuillConfig.modules = $scope.options.modules;
        self.onContentChanged = function(editor, html, text, delta, oldDelta, source){
            if($scope.options.maxLength){
                if(text.length-1 > $scope.options.maxLength){
					editor.deleteText($scope.options.maxLength, text.length - 1 - $scope.options.maxLength);
				}
            }
            if($scope.options.onContentChanged){
                $scope.options.onContentChanged(editor, html, text, delta, oldDelta, source);
            }
        }

    }
})();
(function () {
  'use strict';

  angular
    .module('pixerf')
    .directive('pixerfQuillEditor', pixerfQuillEditor);
  pixerfQuillEditor.$inject = ['ngQuillConfig'];
  function pixerfQuillEditor() {

    var directive = {
      scope: {
        "options" : "=",
        "model": "="
      },
      restrict: 'E',
      templateUrl: 'app/components/pixerf-quill-editor/pixerf-quill-editor.html',
      controller: 'pixerfQuillEditorCtrl',
      controllerAs: 'vm',
      replace: true,
    };
    return directive;
  }

})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .directive('pixerfPlaceholder', pixerfPlaceholder);

    pixerfPlaceholder.$inject = ['systemUtils'];

    function pixerfPlaceholder(systemUtils) {
        return {
            restrict: 'E',
            replace: true,
            templateUrl: 'app/components/pixerf-placeholder/pixerf-placeholder.html',
            scope: {
               "isVisible": "=",
               "text": "@"
            },
            link: function(scope, element, attrs){
                var $element = $(element);
                var $parent = $element.parent();
                var $input = $parent.find("input").length > 0 ?  $parent.find("input") : $parent;
                $input.on("focus", function(evt){
                    scope.isForceHide = true;
                    systemUtils.digest(scope);
                })
                $input.on("blur", function(){
                    console.log($input.val());
                    if(!$input.val()){
                        scope.isForceHide = false;
                    }
                    systemUtils.digest(scope);
                })
            }
        };


    }
})();
(function () {
  'use strict';

  angular
    .module('pixerf')
    .controller('pixerfPhotoStateBtnCtrl', pixerfPhotoStateBtnCtrl);

  pixerfPhotoStateBtnCtrl.$inject = ['$scope', 'photoSvc', 'sessionManagerSvc', 'toastr', 'selectTypeRejectPhotoPopupSvc', '$q', 'systemUtils', 'pixerfConfirmPopupSvc', 'translationSvc', 'pixerfCuratorRejectPhotoPopupSvc'];

  function pixerfPhotoStateBtnCtrl($scope, photoSvc, sessionManagerSvc, toastr, selectTypeRejectPhotoPopupSvc, $q, systemUtils, pixerfConfirmPopupSvc, translationSvc, pixerfCuratorRejectPhotoPopupSvc) {

    var self = this;
    self.onBtnClicked = onBtnClicked;
    self.convertStateToShow = convertStateToShow;
    self.updateState = updateState;
    self.isPinkHighlight = false;
    self.isBlackHighlight = false;
    self.highlightBtn = highlightBtn;

    function convertStateToShow(state) {
      if (state === 'h') return 'P';
      return state.toUpperCase();
    }

    function highlightBtn() {
      if ($scope.options && $scope.options.isRejectedState) {
        if ($scope.pixerfPhotoStateBtnState === 'r') {
          self.isPinkHighlight = true;
        } else {
          self.isBlackHighlight = ($scope.pixerfPhotoStateBtnMedia.state === $scope.pixerfPhotoStateBtnState);
        }
      } else if ($scope.pixerfPhotoStateBtnMedia && $scope.pixerfPhotoStateBtnMedia.in_mission && $scope.pixerfPhotoStateBtnMedia.participation && ($scope.pixerfPhotoStateBtnMedia.participation.is_curated === false)) {
        if ($scope.pixerfPhotoStateBtnState === 'h') {
          self.isPinkHighlight = true;
        } else {
          self.isBlackHighlight = ($scope.pixerfPhotoStateBtnMedia && $scope.pixerfPhotoStateBtnMedia.state === $scope.pixerfPhotoStateBtnState);
        }

      } else {
        self.isPinkHighlight = ($scope.pixerfPhotoStateBtnMedia && $scope.pixerfPhotoStateBtnMedia.state === $scope.pixerfPhotoStateBtnState);
        self.isBlackHighlight = false;
      }
      return {
        isPinkHighlight: self.isPinkHighlight,
        isBlackHighlight: self.isBlackHighlight
      };
    }

    function updateState(photo) {
      if ($scope.bulkPhotoState && $scope.bulkPhotoState.length) {
        var bulkStateArr = [];
        for (var i = 0; i < $scope.bulkPhotoState.length; i++) {
          bulkStateArr.push(callUpdateState($scope.bulkPhotoState[i]));
        }
        return $q.all(bulkStateArr);
      } else if (photo.in_mission || ($scope.options && $scope.options.isRejectedState)) {
        return processForCurationMission(photo);
      }
      return callUpdateState(photo);
    }

    function callUpdateState(photo) {
      var defer = $q.defer();
      var shouldShowMessage = $scope.needReviewLicense && (photo.state === 'h' || photo.state === 'r');
      photoSvc.transitState(photo, $scope.pixerfPhotoStateBtnState, photo.mission_id).then(function (response) {
        photo.state = response.state;
        self.isWorking = false;
        if (shouldShowMessage) {
          toastr.success("This photo has been successfully curated!");
        }
        defer.resolve();
      }).catch(function () {
        defer.reject();
        toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
        self.isWorking = false;
      });
      return defer;
    }
    function processForCurationMission(photo) {
      var defer = $q.defer();
      if (!photo.mission_id && !photo.mission) {
        toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
        self.isWorking = false;
        return;
      }
      var missionId = photo.mission_id || photo.mission.id;
      var participationsId = photo.participation.id;
      var rejectionTimes = false;
      var action = ($scope.options && $scope.options.isRejectedState) ? 'unreject' : 'approve';
      var reason = null;
      photoSvc.curationMission(action, reason, rejectionTimes, missionId, participationsId).then(function (response) {
        photo.participation.is_curated = response.participation.is_curated;
        if ($scope.options) {
          $scope.options.isRejectedState = false;
        }
        return callUpdateState(photo);
      }, function () {
        toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
        self.isWorking = false;
        defer.reject();
      })

      return defer;
    }
    function showConfirm() {
      var warningMessage = "Are you sure to set this photo as Editor's Pick?";
      var pixerfConfirmPopup = pixerfConfirmPopupSvc.showPopup({
        hideTitle: true,
        hideConfirmText: true,
        message: warningMessage
      })
      return pixerfConfirmPopup;
    }
    function btnHandler(photo) {
      systemUtils.triggerBodyClicked();
      if (photo.in_mission && $scope.pixerfPhotoStateBtnState === 'r') {
        selectTypeRejectPhotoPopupSvc.showPopup({ file: $scope.pixerfPhotoStateBtnMedia });
        return;
      } else if ($scope.pixerfPhotoStateBtnState === 'r') {
        pixerfCuratorRejectPhotoPopupSvc.showPopup({ file: $scope.pixerfPhotoStateBtnMedia, bulkFiles: $scope.bulkPhotoState });
        return;
      }

      if (self.isWorking) return;
      self.isWorking = true;
      return updateState(photo).promise;
    }
    function onBtnClicked(photo) {
      if (!sessionManagerSvc.getCurrentLoginUser().data.canCurate) {
        return;
      }
      if ((photo.state === $scope.pixerfPhotoStateBtnState) && !($scope.options && $scope.options.isRejectedState) && (!$scope.pixerfPhotoStateBtnMedia.in_mission || ($scope.pixerfPhotoStateBtnMedia.in_mission && $scope.pixerfPhotoStateBtnMedia.participation && $scope.pixerfPhotoStateBtnMedia.participation.is_curated))) return;
      if ($scope.isNeedConfirm) {
        showConfirm().result.then(function () {
          btnHandler(photo);
        })
      } else {
        btnHandler(photo);
      }
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('pixerf')
    .directive('pixerfPhotoStateBtn', pixerfPhotoStateBtn);

  function pixerfPhotoStateBtn() {

    var directive = {
      scope: {
        "pixerfPhotoStateBtnMedia" : "=",
        "pixerfPhotoStateBtnState": '@',
        "needReviewLicense": "=",
        "isNeedConfirm": '=',
        "options": "=",
        "bulkPhotoState": "="
      },
      restrict: 'E',
      templateUrl: 'app/components/pixerf-photo-state-btn/pixerf-photo-state-btn.html',
      controller: 'pixerfPhotoStateBtnCtrl',
      controllerAs: 'vm',
      replace: true
    };
    return directive;
  }

})();

/**
 * Controller for home module
 */
(function(){
  'use strict';
  angular
    .module('pixerf')
    .factory('pixerfMessagePopupSvc', pixerfMessagePopupSvc);
    pixerfMessagePopupSvc.$inject = ['$uibModalStack', '$uibModal'];

    function pixerfMessagePopupSvc($uibModalStack, $uibModal){
        function showPopup(data){
            return $uibModal.open({
                templateUrl: 'app/components/pixerf-message-popup/pixerf-message-popup.html',
                controller: 'pixerfMessagePopupCtrl',
                controllerAs: 'vm',
                animation: true,
                backdrop: data.backdrop ? data.backdrop : true,
                windowClass: 'zindex pixerf-message-popup-screen ' + (data.cssClass ? data.cssClass : ''),
                resolve: {
                    'resolveData': function(){
                        return data;
                    }
                }
            });

        }
        
        return {
            showPopup: showPopup
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('pixerfMessagePopupCtrl', pixerfMessagePopupCtrl);

    pixerfMessagePopupCtrl.$inject = ['$uibModalInstance','resolveData','accountUtils'];

    function pixerfMessagePopupCtrl($uibModalInstance, resolveData, accountUtils) {

        var self = this;
        self.close = close;

        function close(){
            $uibModalInstance.close();
        }
        self.setting = $.extend(true, {
            showBtn: false,
            bntText: 'OK',
            autoClose: true
        }, resolveData);
        if(self.setting.autoClose){
            setTimeout(function(){ close();}, 5000);
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('pixerf')
        .directive('pixerfLoadingIndicator', pixerfLoadingIndicator);
    pixerfLoadingIndicator.$inject = ['$rootScope', '$interval'];
    function pixerfLoadingIndicator() {
        return {
            templateUrl : 'app/components/pixerf-loading-indicator/pixerf-loading-indicator.html',
            restrict: 'E',
            replace: true
		};
    }
})();                                                                  
(function() {
    'use strict';

    angular
        .module('pixerf')
        .directive('pixerfIosToggleBtn', pixerfIosToggleBtn);

    pixerfIosToggleBtn.$inject = [];

    function pixerfIosToggleBtn($timeout, toastr) {
        return {
            restrict: 'E',
            replace: true,
            templateUrl: 'app/components/pixerf-ios-toggle-btn/pixerf-ios-toggle-btn.html',
            scope: {
                model : "=",
                modelProperty: "@",
                onChanged: '&',
                isDisabled : '=',
                error: '=',
                options: '='
            },
            link: function(scope, element) {
                scope.toogle = function(evt){
                    if(scope.isDisabled) return;
                    console.log(scope.model[scope.modelProperty]);
                    scope.onChanged({evt: evt});
                }

            }
        };


    }
})();
(function() {
    'use strict';

    angular
        .module('pixerf')
        .factory('pixerfInputAutoCompleteSvc', pixerfInputAutoCompleteSvc);

     pixerfInputAutoCompleteSvc.$inject = [];

    function pixerfInputAutoCompleteSvc() {

        
        return {
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('pixerf')
        .controller('pixerfInputAutoCompleteCtrl', pixerfInputAutoCompleteCtrl);

    pixerfInputAutoCompleteCtrl.$inject = [];

    function pixerfInputAutoCompleteCtrl() {

        var self = this;

        

    }
})();
(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('pixerfInputAutoComplete', pixerfInputAutoCompleteCtrl);

	function pixerfInputAutoCompleteCtrl() {

		var directive = {
			scope: {
				onChanged: "&?",
				model: '=',
				data: '=',
				options: "=",
				isRequired: "@?",
				name: "@?",
				dropdownClass: "@?"
			},
			restrict: 'E',
			templateUrl: 'app/components/pixerf-input-auto-complete/pixerf-input-auto-complete.html',
			controller: 'pixerfInputAutoCompleteCtrl',
			controllerAs: 'vm',
			replace: true
		};
		return directive;
	}

})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('pixerfGroupSelectionBtnCtrl', pixerfGroupSelectionBtnCtrl);

	pixerfGroupSelectionBtnCtrl.$inject = ['$scope'];

	function pixerfGroupSelectionBtnCtrl($scope) {

		var self = this;
		self.group = $scope.group;
		self.items = $scope.items;
		self.onItemSelected = onItemSelected;
		self.onCustomValueSet = onCustomValueSet;
		self.onCustonFieldClicked = onCustonFieldClicked;
		self.isCustomFieldActived = false;
		self.customValue = {"id": 0, "label": "", "isSelected": false, "isCustom": true};

		initItemSelected(self.group);

		function initItemSelected(group) {
			for (var i = 0; i < self.items.length; i++) {
				if(self.items[i].options[self.items[i].options.length - 1].id == 0 && self.items[i].options[self.items[i].options.length - 1].isSelected){
					self.isCustomFieldActived = true;
					self.customValue.label = self.items[i].options[self.items[i].options.length - 1].label;
				}
				for (var j = 0; j < self.items[i].options.length; j++) {
					var proName = self.items[i].value;
					var option = self.items[i].options[j];
					var comparedValue = typeof option.value !== 'undefined' ? option.value : option.label;
					option.isSelected = comparedValue ===  group[proName];
				}
			}
		}

		function onItemSelected(items, itemSelected) {
			deselectAll(items.options);
			if(itemSelected && self.isCustomFieldActived && itemSelected.id && itemSelected.id != 0){
				self.isCustomFieldActived = false;
			}
			if(self.isCustomFieldActived && itemSelected){
				self.group[items.value] = itemSelected;
				itemSelected.isSelected = true;
			} else {
				itemSelected.isSelected = true;
				self.group[items.value] = typeof(itemSelected.value) != 'undefined' ? itemSelected.value : itemSelected.label;
			}
			$scope.onItemSelected({item: itemSelected});
		}

		function deselectAll(items) {
			for (var i = 0; i < items.length; i++) {
				items[i].isSelected = false;
			}
		}

		function onCustomValueSet(items, itemSelected){
			onItemSelected(items, itemSelected);
		}

		function onCustonFieldClicked(items, itemSelected){
			self.isCustomFieldActived = true;
		}

	}
})();
(function () {
  'use strict';

  angular
    .module('pixerf')
    .directive('pixerfGroupSelectionBtn', pixerfGroupSelectionBtn);

  function pixerfGroupSelectionBtn() {

    var directive = {
      scope: {
        group: '=',
        items: '=',
        customField: "@",
        onItemSelected: '&'
      },
      restrict: 'E',
      templateUrl: 'app/components/pixerf-group-selection-btn/pixerf-group-selection-btn.html',
      controller: 'pixerfGroupSelectionBtnCtrl',
      controllerAs: 'vm',
      replace: true
    };
    return directive;
  }

})();

(function() {
    'use strict';

    // TODO: replace this with uday's

    angular
        .module('pixerf')
        .directive('pixerfDropzone', dropZone);

    dropZone.$inject = ['$rootScope'];

    function dropZone($rootScope) {
        return {
            scope: {
                dropzone: '=',
                dropzoneConfig: '=',
                eventHandlers: '=',
                superDropzone: '=',
                pixerfDropzoneCropper: '='
            },
            restrict: 'A',
            link: function(scope, element, attrs) {
                try { Dropzone } catch (error) {
                    throw new Error('Dropzone.js not loaded.');
                }

                var dropzone = new Dropzone(element[0], scope.dropzoneConfig);

                if (scope.eventHandlers) {
                    Object.keys(scope.eventHandlers).forEach(function(eventName) {
                        if(scope.pixerfDropzoneCropper){
                            if(eventName === 'thumbnail'){
                                dropzone.on(eventName, function(file, dataUrl){
                                    if(scope.eventHandlers[eventName](file, dataUrl)){
                                        onThumbnailGenerated(file, dataUrl);
                                    }
                                });
                            } else {
                                dropzone.on(eventName, scope.eventHandlers[eventName]);
                            }
                        } else {
                            dropzone.on(eventName, scope.eventHandlers[eventName]);
                        }
                    });
                }

                scope.dropzone = dropzone;

                var $element = $(element);
                scope.$watch("superDropzone", function(){
                    if(scope.superDropzone){
                        $element.css("marginLeft", -$element.offset().left);
                        $element.css("marginTop", -$element.offset().top + $(window).scrollTop());
                        $element.addClass("super-dropzone");
                    } else {
                        $element.css("marginLeft", 0);
                        $element.css("marginTop", 0);
                        $element.removeClass("super-dropzone");
                    }

                });
                function onThumbnailGenerated(file, dataUrl){
                    // dropzone.removeAllFiles();
                    var $cropImage = $element.find("#crop-image");
                    var defaultCropOptions = {
                        viewport: {
                            width: 145,
                            height: 145,
                            type: 'circle'
                        },
                        zoom: 0
                    };
                    var cropOtions = $.extend(defaultCropOptions, true, scope.pixerfDropzoneCropper.options);
                    setTimeout(function(){
                        if(!scope.pixerfDropzoneCropper.instance || scope.pixerfDropzoneCropper.instance.croppie){
                            scope.pixerfDropzoneCropper.instance = $cropImage.croppie(cropOtions);
                        } 
                        cropOtions.url = dataUrl;
                        scope.pixerfDropzoneCropper.instance.croppie("bind", cropOtions);
                        
                        $cropImage.css('opacity', 1);
                    },0)
                }

            }
        }
    }

})();

(function () {
  'use strict';
  angular
    .module('pixerf')
    .factory('pixerfDiscussionReportPopupSvc', pixerfDiscussionReportPopupSvc);
    pixerfDiscussionReportPopupSvc.$inject = ['$uibModal'];

  function pixerfDiscussionReportPopupSvc($uibModal) {

    var mReasons = {
      data: [
        {id: 1, name: 'Spam'},
        {id: 2, name: 'Unauthorised sales'},
        {id: 3, name: 'Intellectual property'},
        {id: 4, name: 'Fake news'},
        {id: 5, name: 'Hacked'},
        {id: 6, name: 'Hate speech'},
        {id: 7, name: 'Harassment or threat'},
        {id: 8, name: 'Inappropriate conduct'},
        {id: 9, name: 'Violation of rights'},
        {id: 10, name: 'Adult content'},
        {id: 11, name: 'Violence or abuse'},
        {id: 12, name: 'Suicide or self-injury'},
        {id: 13, name: 'Invasion of privacy'},
        {id: 14, name: 'Scam or fraud'},
        {id: 15, name: "Others"}
      ],
    }

    var reasonList = {
      event: [
        {id: 1, name: 'Fraudulent or unauthorised event '},
        {id: 2, name: 'Canceled event'},
        {id: 3, name: 'Inaccurate details'},
        {id: 4, name: 'Harassment or Bullying'},
        {id: 5, name: 'Hate speech'},
        {id: 6, name: 'Inappropriate conduct'},
        {id: 7, name: 'Illegal or harmful activities'}
      ],
      community: [
        {id: 1, name: 'Spam'},
        {id: 2, name: 'Unauthorised Sales'},
        {id: 3, name: 'Fake news'},
        {id: 4, name: 'Fraud or scam'},
        {id: 5, name: 'Hate speech'},
        {id: 6, name: 'Harassment or bullying'},
        {id: 7, name: 'Illegal or harmful activities'},
        {id: 8, name: 'Explicit content (sex, violence or nudity)'},
        {id: 9, name: 'Inappropriate conduct'},
        {id: 10, name: 'Violation of rights'},
        {id: 11, name: 'Others '}
      ],
      discussion: [
        {id: 1, name: 'Spam'},
        {id: 2, name: 'Unauthorised sales'},
        {id: 3, name: 'Intellectual property'},
        {id: 4, name: 'Fake news'},
        {id: 5, name: 'Hacked'},
        {id: 6, name: 'Hate speech'},
        {id: 7, name: 'Harassment or threat'},
        {id: 8, name: 'Inappropriate conduct'},
        {id: 9, name: 'Violation of rights'},
        {id: 10, name: 'Adult content'},
        {id: 11, name: 'Violence or abuse'},
        {id: 12, name: 'Suicide or self-injury'},
        {id: 13, name: 'Invasion of privacy'},
        {id: 14, name: 'Scam or fraud'},
        {id: 15, name: "Others"}
      ]
    }

    function setReasons(value) {
      mReasons.data = value;
    }
    function getReasons(context) {
      switch (context) {
				case 'report_community_event':
          setReasons(reasonList['event']);
					break;
				case 'report_community':
					setReasons(reasonList['community']);
          break;
        case 'report_comment':
          setReasons(reasonList['discussion']);
          break;
        case 'report_discussion':
          setReasons(reasonList['discussion']);
          break;
				default:
					setReasons(reasonList['discussion']);
			}
      return mReasons;
    }

    function showPopup(popupData) {
      return $uibModal.open({
        templateUrl: 'app/components/pixerf-discussion-report-popup/pixerf-discussion-report-popup.html',
        controller: 'pixerfDiscussionReportPopupCtrl',
        controllerAs: 'vm',
        animation: true,
        windowClass: 'pixerf-discussion-report-modal',
        backdrop: 'static',
        resolve: {
          'resolveData': function () {
            return popupData;
          }
        }
      });
    }

    return {
      setReasons: setReasons,
      getReasons: getReasons,
      showPopup: showPopup
    };
  }
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('pixerfDiscussionReportPopupCtrl', pixerfDiscussionReportPopupCtrl);

	pixerfDiscussionReportPopupCtrl.$inject = ['pixerfApiCommunitySvc', '$uibModalInstance', 'pixerfDiscussionReportPopupSvc', 'resolveData', 'toastr', '$timeout', 'translationSvc', '$translate'];

	function pixerfDiscussionReportPopupCtrl(pixerfApiCommunitySvc, $uibModalInstance, pixerfDiscussionReportPopupSvc, resolveData, toastr, $timeout, translationSvc, $translate) {

		var self = this;
		self.onReportBtnClicked = onReportBtnClicked;
		self.closePopup = closePopup;

		self.selectedReason = null;
		self.description = '';
		self.showDescription = false;
		self.stateSuccess = false;
		var selectDefaultText=  $translate.instant('please-select-reason');
		self.defaultOptions = {
            "container": "body", "title": selectDefaultText, "customAll": false, "dropupAuto": false, "noneSelectedText": selectDefaultText, "maxOptions": 1
        }
		var reportId = resolveData.id;

		init();

		function init() {
			if (!reportId) {
				toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
			}
			
			self.selectionSettings = pixerfDiscussionReportPopupSvc.getReasons(resolveData.target);
			switch (resolveData.target){
				case "report_community_event":
					self.typeReport = 'event';
					self.showDescription = true;
					break;
				case "report_community":
					self.typeReport = 'community';
					self.showDescription = true;
					break;
				case "report_comment":
					self.typeReport = 'comment';
					self.showDescription = true;
					break;
				case "report_discussion":
					self.typeReport = 'post';
					self.showDescription = true;
					break;
				default: 
					self.typeReport = 'post';
			}
		}

		function onReportBtnClicked() {
			if (!self.selectedReason) {
				toastr.error("Please select 1 reason!");
				return;
			}
			report(self.selectedReason[0].name, resolveData.target, self.description);
		}

		function report(reason, typeApi, description){
			var postData = {
				reason: reason
			};
			if(description && (description.trim() != '')){
				postData.description = description;
			}
			pixerfApiCommunitySvc[typeApi]({
				id: reportId
			}, postData).$promise.then(function () {
				toastr.success("You've successfully reported");
				self.stateSuccess = true;
				showSuccessText();
			}).catch(function (err) {
				toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
			})
		}

		function showSuccessText() {
			$timeout(function () {
				closePopup();
			}, 2000);
		}

		function closePopup() {
			$uibModalInstance.close();
		}

	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('pixerfDeleteMediaBtnCtrl', pixerfDeleteMediaBtnCtrl);

	pixerfDeleteMediaBtnCtrl.$inject = ['$scope', 'pixerfConfirmPopupSvc', 'sessionManagerSvc', 'toastr', '$translate', 'pixerfApiMediaSvc', '$timeout', 'photoSvc', 'translationSvc', 'pixerfApiMissionSvc'];

	function pixerfDeleteMediaBtnCtrl($scope, pixerfConfirmPopupSvc, sessionManagerSvc, toastr, $translate, pixerfApiMediaSvc, $timeout, photoSvc, translationSvc, pixerfApiMissionSvc) {

		var self = this;
		self.isWorking = false;
		self.onDeletePhotoBtnClicked = onDeletePhotoBtnClicked;
		self.loginnedUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.isMissionContext = $scope.context ? $scope.context.split("-")[0] === 'mission' : false;
		self.isMultiframeMissionContext = $scope.context ? $scope.context.split("-")[0] === 'multiframemission' : false;
		self.missionId = $scope.context ? $scope.context.split("-")[1] : null;
		self.participationId = $scope.context && $scope.context.split("-").length > 2 ? $scope.context.split("-")[2] : null;
		self.participations = [];

		function onDeletePhotoBtnClicked() {
			var message = null;
			if ($scope.pixerfDeleteMediaBtnMedia && $scope.pixerfDeleteMediaBtnMedia.in_mission) {
				message = 'This photo is currently part of a Mission. Deleting it will remove your entry to the Mission.';
			} else {
				message = translationSvc.ARE_YOU_SURE_TO_DO_SOMETHING("DELETE_THIS_PHOTO");
			}
			var modal = pixerfConfirmPopupSvc.showPopup({
				hideTitle: true,
				hideConfirmText: true,
				message: message,
				windowClass: 'pixerf-delete-media-btn__popup remove-selected-photos',
			});
			var rejected = false;
			modal.result.then(function () {
				if (self.isMultiframeMissionContext) {
					var participationIds = [];
					pixerfApiMissionSvc.get_participations({
						id: self.missionId,
						type: 'self'
					}).$promise.then(function (res) {
						if (res && res.data) {
							for (var i = 0; i < res.data.length; i++) {
								participationIds.push(res.data[i].participation.id)
							}
						}
						return pixerfApiMissionSvc.delete_many({
							id: self.missionId
						}, {
							ids: participationIds
						}).$promise;
					}).then(function () {
						$timeout(function () {
							$scope.pixerfDeleteMediaBtnOnMediaDeleted({
								media: $scope.pixerfDeleteMediaBtnMedia
							});
						});
					}).catch(function (err) {
						console.log(err);
					})
				} else if (self.isMissionContext) {
					pixerfApiMissionSvc.delete({
						id: self.missionId,
						action: 'participations',
						participation_id: self.participationId
					}).$promise.then(function (res) {
						$timeout(function () {
							$scope.pixerfDeleteMediaBtnOnMediaDeleted({
								media: $scope.pixerfDeleteMediaBtnMedia
							});
						});
					}).catch(function (err) {
						console.log(err);
					})
				} else {
					pixerfApiMediaSvc.delete({
						id: $scope.pixerfDeleteMediaBtnMedia.id
					}).$promise.then(function () {
						var photoName = $scope.pixerfDeleteMediaBtnMedia.title ? $scope.pixerfDeleteMediaBtnMedia.title : $scope.pixerfDeleteMediaBtnMedia.id;
						toastr.success($translate.instant("photo-is-deleted", {
							photo: photoName
						}));
						$timeout(function () {
							$scope.pixerfDeleteMediaBtnOnMediaDeleted({
								media: $scope.pixerfDeleteMediaBtnMedia
							});
							if (photoSvc.isUploadedThisWeek($scope.pixerfDeleteMediaBtnMedia)) {
								self.loginnedUser = sessionManagerSvc.getCurrentLoginUser().data;
								self.loginnedUser.stats.weekly_upload_balance++;

								if (typeof $scope.pixerfDeleteMediaBtnMedia.reject_reason !== 'undefined' && $scope.pixerfDeleteMediaBtnMedia.reject_reason !== null) {
									rejected = true;
								}
								if (rejected) {
									self.loginnedUser.stats.rejected_media_count--;
								} else {
									self.loginnedUser.stats.inreview_media_count--;
								}
								sessionManagerSvc.setCurrentLoginUser(self.loginnedUser);
							}
						})
					}, function (err) {
						var errMsg = $translate.instant("failed-delete-photo");
						if (err.data && err.data.error.indexOf("MEDIA_IN_LINE_ITEM") !== -1) {
							errMsg = $translate.instant("someone-has-been-added-photo-to-cart");
						} else if (err.data && err.data.error.indexOf("MEDIA_IS_MISSION_WINNER") !== -1) {
							var missionBadge = _.find($scope.pixerfDeleteMediaBtnMedia.badges, function (badge) {
								return badge.code === "M" || badge.code === "MC";
							});
							if (!missionBadge) {
								errMsg = $translate.instant("failed-delete-photo");
							} else {
								var missionWinnerType = missionBadge.code === "M" ? $translate.instant("a-mission-winner") : $translate.instant("a-mission-special-mention-winner");
								errMsg = $translate.instant("cannot-delete-photo-because-winner", {
									winner_type: missionWinnerType
								});
							}
						} else if (err.data && err.data.error.indexOf("MEDIA_IS_EDITORS_PICK") !== -1) {
							errMsg = $translate.instant("cannot-delete-photo-because-of-editor-pick");
						} else if (err.data && err.data.error.indexOf("MEDIA_HAS_AWARDS") !== -1) {
							errMsg = $translate.instant("cannot-delete-photo-because-awarded");
						}
						toastr.error(errMsg);
					})
				}
			}, function () {
				//do nothing
			})
		}

		function buildSavedFilesData(files) {
			var arr = [];
			for (var i = 0; i < files.length; i++) {
				arr.push({
					id: files[i].id,
					in_mission: false
				});
			}
			return arr;
		}
	}
})();

(function () {
  'use strict';

  angular
    .module('pixerf')
    .directive('pixerfDeleteMediaBtn', pixerfDeleteMediaBtn);

  function pixerfDeleteMediaBtn() {

    var directive = {
      scope: {
        "context": "=",
        "pixerfDeleteMediaBtnMedia" : "=",
        "pixerfDeleteMediaBtnBtnLabel": "@",
        "pixerfDeleteMediaBtnOnMediaDeleted": "&"
      },
      restrict: 'E',
      templateUrl: 'app/components/pixerf-delete-media-btn/pixerf-delete-media-btn.html',
      controller: 'pixerfDeleteMediaBtnCtrl',
      controllerAs: 'vm',
      replace: true
    };
    return directive;
  }

})();

(function () {
  'use strict';
  angular
    .module('pixerf')
    .factory('pixerfCuratorRejectPhotoPopupSvc', pixerfCuratorRejectPhotoPopupSvc);
  pixerfCuratorRejectPhotoPopupSvc.$inject = ['$uibModal'];

  function pixerfCuratorRejectPhotoPopupSvc($uibModal) {

    var mReasons = {
      data: []
    }
    function setReasons(value) {
      mReasons.data = value;
    }
    function getReasons() {
      return mReasons;
    }
    function showPopup(popupData) {
      return $uibModal.open({
        templateUrl: 'app/components/pixerf-curator-reject-photo-popup/pixerf-curator-reject-photo-popup.html',
        controller: 'pixerfCuratorRejectPhotoPopupCtrl',
        controllerAs: 'vm',
        animation: true,
        windowClass: '',
        resolve: {
          'resolveData': function () {
            return popupData;
          }
        }
      });
    }

    return {
      setReasons: setReasons,
      getReasons: getReasons,
      showPopup: showPopup
    };
  }
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('pixerfCuratorRejectPhotoPopupCtrl', pixerfCuratorRejectPhotoPopupCtrl);

	pixerfCuratorRejectPhotoPopupCtrl.$inject = ['photoSvc', '$uibModalInstance', 'pixerfCuratorRejectPhotoPopupSvc', 'resolveData', 'toastr', '$timeout', 'pixerfApiMediaSvc', 'translationSvc', 'licenseReviewPopupSvc'];

	function pixerfCuratorRejectPhotoPopupCtrl(photoSvc, $uibModalInstance, pixerfCuratorRejectPhotoPopupSvc, resolveData, toastr, $timeout, pixerfApiMediaSvc, translationSvc, licenseReviewPopupSvc) {

		var self = this;
		self.file = resolveData.file;
		self.type = resolveData.type ? resolveData.type : 'all';
		self.bulkFiles = resolveData.bulkFiles || [];
		self.state = 'r';
		self.isMissionReject = false;
		self.onRejectBtnClicked = onRejectBtnClicked;
		self.closePopup = closePopup;

		self.selectedReason = null;
		self.selectionSettings = null;
		self.selectionSettings = {
			defaultText: 'Choose the reason why you reject this photo',
			modelNamePropertyName: 'title',
			modelKeyPropertyName: 'id'
		}

		init();

		function init() {
			if (pixerfCuratorRejectPhotoPopupSvc.getReasons().data.length === 0) {
				pixerfApiMediaSvc.reject_reasons().$promise.then(function (response) {
					pixerfCuratorRejectPhotoPopupSvc.setReasons(response);
					self.selectionSettings.items = pixerfCuratorRejectPhotoPopupSvc.getReasons().data;
				}, function (err) {
					toastr.error("Failed to get the rejected reasons list");
				})
			} else {
				self.selectionSettings.items = pixerfCuratorRejectPhotoPopupSvc.getReasons().data;
			}
		}

		function onRejectBtnClicked() {
			if (self.working) return;
			if (!self.selectedReason) {
				toastr.error("Please select 1 reason!");
				return;
			}
			if(resolveData.file && resolveData.file.in_mission){
				return processForCurationMission()
			}
			processTransitState()
		}

		function processTransitState() {
			if (self.type === 'mission' && resolveData.file && resolveData.file.state === 'h') {
				self.working = true;
				pixerfApiMediaSvc.get({
					id: resolveData.file.id
				}).$promise.then(function (res) {
					self.working = false;
					var licensePopup = licenseReviewPopupSvc.showPopup(res.data);
					licensePopup.result.then(function () {
						self.state = 'g';
						self.isMissionReject = true;
						transitState(res.data);
					})
				}).catch(function (err) {
					self.working = false;
				});
			} else if (self.type === 'mission') {
				self.state = resolveData.file.state != 'h' ? resolveData.file.state : 'g';
				self.isMissionReject = true;
				transitState();
			} else {
				for(var i = 0; i < self.bulkFiles.length; i++){
					transitState(self.bulkFiles[i]);
				}
			}
		}

		function processForCurationMission(){
			if(self.type == 'mission'){
				return rejectForCurationMission('reject_from_mission_only');
			}else{
				return rejectForCurationMission('reject');
			}
		}

		function rejectForCurationMission(action){
			var missionId = resolveData.file.mission_id || resolveData.file.mission.id;
			var participationsId = resolveData.file.participation.id;
			var rejectionTimes = true;
			photoSvc.curationMission(action, self.selectedReason.data.id, rejectionTimes, missionId, participationsId).then(function (response) {
				resolveData.file.participation.is_curated = response.participation.is_curated;
				processTransitState();
			}, function () {
				toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
				self.working = false;
			})
		}

		function transitState(media) {
			var file = media;
			var missionId = media.mission ? media.mission.id : media.mission_id;
			photoSvc.transitState(file, self.state, self.selectedReason.data.id, self.isMissionReject, missionId).then(function () {
				media.state = self.state;
				media.reject_reason = self.selectedReason.data.title;
				self.working = false;
				toastr.success("This photo is rejected!");
				$timeout(function () {
					closePopup();
				}, 1000);
			}, function () {
				toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
				self.working = false;
			})
		}

		function closePopup() {
			$uibModalInstance.close();
		}

	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.component('pixerfCropImage', {

			bindings: {
				src: '<',
				ngModel: '=',
				options: '<'
			},
			controller: ['$scope', '$element', 'systemUtils', function ($scope, $element, systemUtils) {
				var self = this;

				this.$onInit = function () {
					var options = angular.extend({
						viewport: {
							width: 200,
							height: 200
						}
					}, self.options);

					options.update = function () {
						croppedImg.result('canvas').then(function (img) {
							$scope.$apply(function () {
								self.ngModel = img;
							});
						});
					};

					var croppedImg = new Croppie($element[0], options);

					self.$onChanges = function (changesObj) {
						var imgSrc = changesObj.src && changesObj.src.currentValue;
						if (imgSrc) {
							croppedImg.bind({
								url: imgSrc
							});
							systemUtils.digest($scope);
						}
					};
				};
			}]
		});

})();

/**
 * Controller for home module
 */
(function(){
  'use strict';
  angular
    .module('pixerf')
    .factory('pixerfCreditCardPopupSvc', pixerfCreditCardPopupSvc);
    pixerfCreditCardPopupSvc.$inject = ['$uibModalStack', '$uibModal'];

    function pixerfCreditCardPopupSvc($uibModalStack, $uibModal){
        function showPopup(data){
            return $uibModal.open({
                templateUrl: 'app/components/pixerf-credit-card-popup/pixerf-credit-card-popup.html',
                controller: 'pixerfCreditCardPopupCtrl',
                controllerAs: 'vm',
                animation: true,
                backdrop: 'static',
                windowClass: data.windowClass,
                resolve: {
                    'resolveData': function(){
                        return data;
                    }
                }
            });

        }
        
        return {
            showPopup: showPopup
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('pixerfCreditCardPopupCtrl', pixerfCreditCardPopupCtrl);

    pixerfCreditCardPopupCtrl.$inject = ['$uibModalInstance','resolveData', '$timeout', '$q'];

    function pixerfCreditCardPopupCtrl($uibModalInstance, resolveData, $timeout, $q) {

        var self = this;
        self.onPayBtnClick = onPayBtnClick;
        self.close = close;
        self.settings = resolveData;
        self.isWorking = false;

        $uibModalInstance.rendered.then(function(){
            self.focusField = 'cardnumber';
        })

        function onPayBtnClick(){
            var def = $q.defer();
            self.isWorking = true;
            self.settings.onPayBtnClick({
                popupCtrl: self
            }).then(function(response){
                def.resolve(response);
                self.isWorking = false;
            }, function(err){
                onError(err);
                self.isWorking = false;
                def.reject(err);
                
            });
            
            return def.promise;
        }
        function onError(err){
            var popupClass = '.pixerf-credit-card-popup__wrapper';
            var $modal = $(popupClass + ' .modal-dialog ');
            $modal.addClass('animated shake');
            $timeout(function(){
                $modal.removeClass('animated shake');
            },1000);
        }
        function close(){
            $uibModalInstance.close();
        }
    }
})();

(function(){
  'use strict';
  angular
    .module('pixerf')
    .factory('pixerfConfirmPopupSvc', pixerfConfirmPopupSvc);
    pixerfConfirmPopupSvc.$inject = ['$uibModalStack', '$uibModal'];

    function pixerfConfirmPopupSvc($uibModalStack, $uibModal){
        function showPopup(data){
            return $uibModal.open({
                templateUrl: 'app/components/pixerf-confirm-popup/pixerf-confirm-popup.html',
                controller: 'pixerfConfirmPopupCtrl',
                controllerAs: 'vm',
                animation: true,
                windowClass: 'zindex ' + data.windowClass,
                resolve: {
                    'resolveData': function(){
                        return data;
                    }
                }
            });

        }

        return {
            showPopup: showPopup
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('pixerfConfirmPopupCtrl', pixerfConfirmPopupCtrl);

    pixerfConfirmPopupCtrl.$inject = ['$uibModalInstance','resolveData', '$translate'];

    function pixerfConfirmPopupCtrl($uibModalInstance, resolveData, $translate) {

        var self = this;
        self.resolveData = resolveData;
        self.message = resolveData.message;
        self.hideConfirmText = resolveData.hideConfirmText;
        self.hideCancelBtn = resolveData.hideCancelBtn;
        self.cancelBtnText = resolveData.cancelBtnText ? resolveData.cancelBtnText : $translate.instant('no');
        self.okBtnText = resolveData.okBtnText ? resolveData.okBtnText : $translate.instant('yes');
        self.confirmText = resolveData.confirmText;
        self.hideTitle = resolveData.hideTitle;
        self.hideCloseBtn = !resolveData.showCloseBtn;
        self.htmlConfirmText = resolveData.htmlConfirmText || '';

        self.ok = function () {
            if(resolveData.okFn){
                if(self.isWorking) return;
                self.isWorking = true;
                self.isSubmmited = true;
                resolveData.okFn().then(function(){
                    $uibModalInstance.close();

                    if(resolveData.okFnCallback){
                        resolveData.okFnCallback();
                    }
                }, function(){
                    self.isWorking = false;
                })
            } else {
                $uibModalInstance.close();
            }
        };
        $uibModalInstance.closed.then(function(){
            self.isWorking = false;
        })

        self.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        self.close = function () {
            $uibModalInstance.close();
            $uibModalInstance.dismiss('close');
        };
    }
})();

(function(){
    'use strict';
    angular
        .module('pixerf')
        .controller('pixerfComboboxCtrl', pixerfComboboxCtrl);

        pixerfComboboxCtrl.$inject= ['$scope'];

        function pixerfComboboxCtrl($scope){
            var self = this;
            self.onChange = onChange;
            var settings = angular.fromJson(self.settings);
            self.configs  = $.extend(true, {"propName": "name", "key": "id"}, settings);
            
            self.setDefaultValue = setDefaultValue;
            init();

            function init(){
                if(self.onInit) self.onInit({instance: self});
                self.options = _.map(self.options, function(item){
                    item.label = item[self.configs.propName]
                    return item;
                })
                self.selectedItem = getDefaultValue(self.model);
            }
            function getDefaultValue(value){
                return _.find(self.options, function(item){
                    if(typeof value === 'object'){
                        return item[self.configs.propName] === value[self.configs.propName]
                    }
                    if(typeof item.value !== 'undefined') {
                        return item.value === value;    
                    }
                    item.value = item.label;
                    return item.label === value;
                })
            }
            function setDefaultValue(value){
                self.selectedItem = getDefaultValue(value);
            }
            function onChange(){
                if(typeof self.model !== 'object'){
                    self.model = typeof self.selectedItem.value !== 'undefined' ? self.selectedItem["value"]  : self.selectedItem["label"];
                } else{
                    self.model = self.selectedItem;
                }
                if(self.onChanged){
                    self.onChanged({selectedItem: self.selectedItem});
                }
            }

        }
})();
(function() {
    'use strict';

    angular
        .module('pixerf')
        .component('pixerfCombobox',  {
            templateUrl: 'app/components/pixerf-combobox/pixerf-combobox.html',
            controller: 'pixerfComboboxCtrl as vm',
            bindings: {
                options : "=",
                model: "=",
                settings: "=",
                isEditing: "=",
                onInit: '&?',
                onChanged: '&?'
            }
        });

})();
(function () {
    'use strict';

    angular
        .module('pixerf')
        .controller('pixerfClientsCtrl', pixerfClientsCtrl);

    pixerfClientsCtrl.$inject = ['$scope'];

    function pixerfClientsCtrl($scope) {

        var self = this;

        self.clientSlideConfig = {
			responsive: [{
				breakpoint: 1200,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 3
				}
			}, {
				breakpoint: 992,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1
				}
			}]
        };

        self.clients = [
            {
                "id": 1,
                "url": "../assets/images/homepage/clients/CDG.png"
            },
            {
                "id": 2,
                "url": "../assets/images/homepage/clients/Blackmores.png"
            },
            {
                "id": 3,
                "url": "../assets/images/homepage/clients/AsianGeo.png"
            },
            {
                "id": 4,
                "url": "../assets/images/homepage/clients/GCW.png"
            },
            {
                "id": 5,
                "url": "../assets/images/homepage/clients/RDI.png"
            },
            {
                "id": 6,
                "url": "../assets/images/homepage/clients/Xroad.png"
            },
            {
                "id": 7,
                "url": "../assets/images/homepage/clients/FMDS.png"
            },
            {
                "id": 8,
                "url": "../assets/images/homepage/clients/MCI.png"
            },
            {
                "id": 9,
                "url": "../assets/images/homepage/clients/Ademco.png"
            },
            {
                "id": 10,
                "url": "../assets/images/homepage/clients/Bitmap.png"
            },
            {
                "id": 11,
                "url": "../assets/images/homepage/clients/Cellini.png"
            },
            {
                "id": 12,
                "url": "../assets/images/homepage/clients/NEA.png"
            },
            {
                "id": 13,
                "url": "../assets/images/homepage/clients/Si.png"
            },
            {
                "id": 14,
                "url": "../assets/images/homepage/clients/Salam.png"
            },
            {
                "id": 15,
                "url": "../assets/images/homepage/clients/MsEarth.png"
            }
        ];
    }
})();

(function () {
    'use strict';
  
    angular
      .module('pixerf')
      .directive('pixerfClients', pixerfClients);
  
    function pixerfClients() {
  
      var directive = {
        scope: {
          "options" : "="
        },
        restrict: 'E',
        templateUrl: 'app/components/pixerf-clients/pixerf-clients.html',
        controller: 'pixerfClientsCtrl',
        controllerAs: 'vm',
        replace: true
      };
      return directive;
    }
  
  })();
  
(function() {
    'use strict';

    angular
        .module('pixerf')
        .directive('pixerfCheckbox', pixerfCheckbox);

    pixerfCheckbox.$inject = [];

    function pixerfCheckbox($timeout, toastr) {
        return {
            restrict: 'E',
            replace: true,
            templateUrl: 'app/components/pixerf-checkbox/pixerf-checkbox.html',
            scope: {
                model : "=",
                modelProperty: "@",
                onChanged: '&',
                isDisabled : '=',
                error: '=',
                authenticationCheck: '=',
                isReversed: '='
            },
            link: function(scope, element) {
                scope.toogle = function(evt){
                    evt.stopPropagation();
                    if(scope.isDisabled) return;
                    if(typeof scope.model[scope.modelProperty] !== 'boolean' && scope.isReversed){
                        scope.model[scope.modelProperty] = false;    
                    }else{
                        scope.model[scope.modelProperty] = !scope.model[scope.modelProperty];
                    }
                    scope.onChanged({evt: evt});
                }
               
            }
        };


    }
})();
(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('pixerfCarouselCtrl', pixerfCarouselCtrl);

	pixerfCarouselCtrl.$inject = ['$scope', 'systemUtils', '$timeout'];

	function pixerfCarouselCtrl($scope, systemUtils, $timeout) {
		var self = this;

	}
})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.directive('pixerfCarousel', pixerfCarousel);
	pixerfCarousel.$inject = ['$timeout'];
	function pixerfCarousel($timeout) {
		return {
			restrict: 'E',
			terminal: true,
			scope: {
				items: "=",
				carouselScrollFixed: "=",
				itemsSpacing: "=",
				variableWidth: "=",
				fixedWidth: "=",
				instance : "="
			},
			templateUrl: 'app/components/pixerf-carousel/pixerf-carousel.html',
			controller: 'pixerfCarouselCtrl',
			controllerAs: 'vm',
			link: function($scope, element, attrs){
				$scope.vm = $scope.instance || {};
				$scope.vm.init = init;
				$scope.onPrevClicked = onPrevClicked;
				$scope.onNextClicked = onNextClicked;
				$scope.onElementResize = _.debounce(onElementResize, 300);

				var itemsSpacing = $scope.itemsSpacing || 20;
				var fixedWidth = $scope.fixedWidth || 300;

				var slide = angular.element(element[0].firstElementChild);
				var self = this;
				var $slide = $(slide);
				var widthSlide = slide[0].clientWidth;
				self.currentPhotoIndex = 0;
				self.scrollLeft  = 0;
				var loaded = 0;
				

				if($scope.fixedWidth){
					init();
				}

				function calFixedWitdh($items, width){
					var totalWidth = 0;
					totalWidth = $items.length * width;
					return totalWidth;
				}
				function calDynamicWidth($items, spacing){
					var totalWidth = 0;
					for(var i = 0; i < $items.length; i++){
						totalWidth += $($items[i]).width() + spacing;
					}
					return totalWidth;
				}
				function isShowNavigation(){
					if($scope.variableWidth){
						self.totalWidthItem = calDynamicWidth($slide.find("img"), itemsSpacing);
					} else {
						self.totalWidthItem = calFixedWitdh($scope.items, fixedWidth);
					}
					if(!self.totalWidthItem){
						return;
					}
					self.isScrollToRight = (self.totalWidthItem - self.scrollLeft) > widthSlide;
					if(self.totalWidthItem  <= widthSlide){
						$scope.showIndicateButton = false;
					} else {
						$scope.showIndicateButton = true;
						$scope.disableInspirationNextBtn = false;
						$scope.disableInspirationPrevBtn = true;
					}
				}
				function onPrevClicked(){
					if(self.currentPhotoIndex <= 0){
						return;
					} else {
						self.currentPhotoIndex--;
					}
					var items = $slide.find("img");
					var $prevItem = $(items[self.currentPhotoIndex]);			
					if(($prevItem.width() || fixedWidth) && self.scrollLeft > 0){
						$scope.disableInspirationNextBtn = false;
						$scope.disableInspirationPrevBtn = false;
						self.scrollLeft -= fixedWidth || ($prevItem.width() + self.itemsSpacing);
						$slide.animate({scrollLeft: self.scrollLeft}, 'slow');
						if(self.scrollLeft <= 0){
							self.scrollLeft = 0;
							$scope.disableInspirationPrevBtn = true;
						}
					}
				}
				function onNextClicked(){
					if(self.totalWidthItem - self.scrollLeft < widthSlide){
						return;
					}
					if(self.currentPhotoIndex >= $scope.items.length - 1){
						return;
					}
					var items = $slide.find("img");
					var $nextItem = $(items[self.currentPhotoIndex + 1]);
					var $currentItem = $(items[self.currentPhotoIndex]);
					if(($nextItem.width() || fixedWidth) && self.isScrollToRight){
						$scope.disableInspirationPrevBtn = false;
						$scope.disableInspirationNextBtn = false;
						self.scrollLeft += fixedWidth || ($currentItem.width() + self.itemsSpacing);
						$slide.animate({scrollLeft: self.scrollLeft}, 'slow');
						self.currentPhotoIndex++;
						if((self.totalWidthItem - self.scrollLeft) < widthSlide){
							$scope.disableInspirationNextBtn = true;	
						}
					}
				}
				
				function onElementResize(){
					self.currentPhotoIndex = 0;
					self.scrollLeft = 0;
					widthSlide = slide[0].clientWidth;
					$slide.animate({scrollLeft: self.scrollLeft}, 'slow');
					isShowNavigation();
				}
				function init(listImg){
					if($scope.fixedWidth){
						isShowNavigation();
					} else {
						$timeout(function(){
							loaded ++;
							if($scope.items.length === loaded){
								isShowNavigation();
							}
						})
					}
					$scope.$watch("items", function(newValue, oldValue){
						if((newValue.length < oldValue.length) || (!newValue && oldValue)){
							isShowNavigation();
						}
					})
				}

				
			},
			replace: true,
			transclude: true
		}
	}
})();

/**
 * Controller for home module
 */
(function(){
  'use strict';
  angular
    .module('pixerf')
    .factory('pixerfBadgesPopupSvc', pixerfBadgesPopupSvc);
    pixerfBadgesPopupSvc.$inject = ['$uibModalStack', '$uibModal'];

    function pixerfBadgesPopupSvc($uibModalStack, $uibModal){
        function showPopup(data){
            return $uibModal.open({
                templateUrl: 'app/components/pixerf-badges-popup/pixerf-badges-popup.html',
                controller: 'pixerfBadgesPopupCtrl',
                controllerAs: 'vm',
                size: "lg",
                animation: true,
                windowClass: 'zindex pixerf-badges-popup-screen',
                resolve: {
                    'resolveData': function(){
                        return data;
                    }
                }
            });

        }
        
        return {
            showPopup: showPopup
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('pixerfBadgesPopupCtrl', pixerfBadgesPopupCtrl);

    pixerfBadgesPopupCtrl.$inject = ['$uibModalInstance','resolveData','accountUtils'];

    function pixerfBadgesPopupCtrl($uibModalInstance, resolveData, accountUtils) {

        var self = this;
        self.closePopup = closePopup;
        self.badges = resolveData.badges;

        function closePopup(){
            $uibModalInstance.close();
        }
       
    }
})();
(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('pixerfBadgesCtrl', pixerfBadgesCtrl);

    pixerfBadgesCtrl.$inject = ['$scope', 'pixerfBadgesPopupSvc'];

    function pixerfBadgesCtrl( $scope, pixerfBadgesPopupSvc) {

        var self = this;
        self.onBadgeClicked = onBadgeClicked;

        function onBadgeClicked(){
            if($scope.popupDetail){
                pixerfBadgesPopupSvc.showPopup({
                    badges: $scope.badges
                });
            }
        }
       
    }
})();
(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('pixerfBadges', pixerfBadges);

	function pixerfBadges() {

		var directive = {
			scope: {
				badges: '=',
				excludes: '=',
				only: '=',
				showDescription: '=',
				popupDetail: '='
			},
			restrict: 'E',
			templateUrl: 'app/components/pixerf-badges/pixerf-badges.html',
			controller: 'pixerfBadgesCtrl',
			controllerAs: 'vm',
			replace: true
		};
		return directive;
	}

})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('pixerfAvatarCtrl', pixerfAvatarCtrl);

    pixerfAvatarCtrl.$inject = ['uploadAvatarPopupSvc', '$scope'];

    function pixerfAvatarCtrl(uploadAvatarPopupSvc, $scope) {

        var self = this;
        self.showUploadAvatarPopup = showUploadAvatarPopup;

        function showUploadAvatarPopup(){
            if($scope.options && $scope.options.canEdit){
                var popup = uploadAvatarPopupSvc.showPopup($scope.options);

                popup.result.then(function(instance){
                    if(!$scope.avatar){
                        $scope.avatar = {};
                        $scope.avatar.url = instance.thumbnail;
                    }
                    if($scope.onInit){
                        $scope.onInit({dropzone: instance.dropzone});
                    }
                })
            }
        }

    }
})();
(function () {
  'use strict';

  angular
    .module('pixerf')
    .directive('pixerfAvatar', pixerfAvatar);

  function pixerfAvatar() {

    var directive = {
      scope: {
        "options" : "=",
        "avatar": "=",
        "onInit": "&?"
      },
      restrict: 'E',
      templateUrl: 'app/components/pixerf-avatar/pixerf-avatar.html',
      controller: 'pixerfAvatarCtrl',
      controllerAs: 'vm',
      replace: true
    };
    return directive;
  }

})();

(function () {

	angular
		.module('pixerf')
		.controller('pixerfAnimationCarouselCtrl', pixerfAnimationCarouselCtrl);

	pixerfAnimationCarouselCtrl.$inject = ['$scope', 'imageUtils'];

	function pixerfAnimationCarouselCtrl($scope, imageUtils) {

		var self = this;
		self.datas = $scope.data || [];
		self.datas = setDefaultCovers(self.datas);
		self.config = {
			slidesToShow: $scope.config && $scope.config.slidesToShow ? $scope.config.slidesToShow : 4,
			slidesToScroll: $scope.config && $scope.config.slidesToScroll ? $scope.config.slidesToScroll : 4,
			infinite: $scope.config && $scope.config.infinite ? $scope.config.infinite : false,
			dots: $scope.config && $scope.config.dots ? $scope.config.dots : true,
			responsive: $scope.config && $scope.config.responsive && $scope.config.responsive.length ? $scope.config.responsive : [{
				breakpoint: 1200,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 3
				}
			}, {
				breakpoint: 1024,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2
				}
			}, {
				breakpoint: 480,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1
				}
			}]
		};

		function setDefaultCovers(data){
			var defaultPhotoColorArray = imageUtils.getDefaultPhotoColorArray();
			var count = 0;
			for(var i =0; i < data.length; i++){
				if( !data[i].cover_media || !data[i].cover_media.thumbnails || !data[i].cover_media.thumbnails['x400']){
					data[i].defaultBackgroundColor = defaultPhotoColorArray[count];
					count = (count >= (defaultPhotoColorArray.length - 1)) ? 0 : (count + 1);
				}
			}
			return data;
		}
	};
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('pixerfAnimationCarousel', pixerfAnimationCarousel);

	pixerfAnimationCarousel.$inject = [];

	function pixerfAnimationCarousel() {
		var directive = {
			scope: {
				instance: '@',
				data: '=',
				config: '=',
				limit: '@?'
			},
			restrict: 'E',
			templateUrl: 'app/components/pixerf-animation-carousel/pixerf-animation-carousel.html',
			controller: 'pixerfAnimationCarouselCtrl',
			controllerAs: 'vm',
			transclude: {
				"itemTemplate": "itemTemplate"
			},
			replace: true
		};
		return directive;
	}
})();

(function(){
    'use strict';
    angular
        .module('pixerf')
        .controller('photographerTileCtrl', photographerTileCtrl);

        photographerTileCtrl.$inject= ['$scope', 'sessionManagerSvc'];

        function photographerTileCtrl($scope, sessionManagerSvc){
            var self = this;
            self.loginnedUser = sessionManagerSvc.getCurrentLoginUser().data;
        }
})();
(function() {
    'use strict';

    angular
        .module('pixerf')
        .directive('photographerTile', photographerTile);

    photographerTile.$inject = [];

    function photographerTile() {
        var directive = {
            scope: {
                item: '='
			},
            restrict: 'E',
            templateUrl: 'app/components/photographer-tile/photographer-tile.html',
            controller: 'photographerTileCtrl',
            controllerAs: 'vm',
			replace: true
        };
        return directive;
    }
})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('photographerGridCtrl', photographerGridCtrl);

    photographerGridCtrl.$inject = ['pixerfApiUserSvc', '$scope', 'pagingUtils', 'toastr', '$q', 'numberUtils', 'translationSvc'];

    function photographerGridCtrl(pixerfApiUserSvc, $scope, pagingUtils, toastr, $q, numberUtils, translationSvc) {

		var self = this;

        $scope.instance = self;
        self.getPhotographers = getPhotographers;
        self.spinner = {isVisible: false};
        self.isLastPage = false;
        self.photographers = null;
        self.fetchMore = fetchMore;
        self.searchParams = {
			page: 0
		};

        function getPhotographers(params, isFresh){
            var def = $q.defer();
            self.spinner.isVisible = true;
            self.searchParams = params || {};
			pixerfApiUserSvc.search(self.searchParams).$promise.then(function(response){
                if(isFresh){
                    self.photographers = [];
                }
                self.photographers = self.photographers.concat(response.data);
                self.isLastPage = pagingUtils.isNoMorePageToLoad(params.page, response);
                self.spinner.isVisible = false;
                self.searchParams.page = numberUtils.parseInt(params.page);
                def.resolve();
            }, function(){
                self.spinner.isVisible = false;
                toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
                def.reject();
            });
            return def.promise;
        }
        function fetchMore(){
            if(self.spinner.isVisible){
                return;
            }
            self.searchParams.page++;
            getPhotographers(self.searchParams).then(function(){
                if($scope.onPaging){
                    $scope.onPaging({page: self.searchParams.page});
                }
            });
        }
    }
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('photographerGrid', photographerGrid);
	photographerGrid.$inject = [];
	function photographerGrid() {
		return {
			restrict: 'E',
			replace: true,
			templateUrl: 'app/components/photographer-grid/photographer-grid.html',
			controller: 'photographerGridCtrl',
			controllerAs: "vm",
			scope: {
				page: '@',
				instance: '=',
				onPaging: '&',
				endingMessage: '@?'
			}
		};
	}
})();
(function(){
    'use strict';
    angular
        .module('pixerf')
        .controller('photographerCtrl', photographerCtrl);

        photographerCtrl.$inject= ['$scope', 'sessionManagerSvc'];

        function photographerCtrl($scope, sessionManagerSvc){
            var self = this;

            self.onPhotoPopupClosed = onPhotoPopupClosed;
            self.loginUser = sessionManagerSvc.getCurrentLoginUser().data;

            function onPhotoPopupClosed(originalPhoto, newPhoto){
                $scope.item.is_followed = newPhoto.user.is_followed;
            }

        }
})();
(function() {
    'use strict';

    angular
        .module('pixerf')
        .directive('photographer', photographer);

    photographer.$inject = ['$window', 'systemUtils'];

    function photographer($window, systemUtils) {
        var directive = {
            scope: {
                item: '=',
                rank: '@',
                unit: '@',
                number: '@',
                highlightTop: '=',
				isHideRanking: '=',
				layout: '@'
			},
            restrict: 'E',
            template: '<div ng-include="templateUrl" class="photographer-item"></div>',
            controller: 'photographerCtrl',
            controllerAs: 'vm',
			replace: true,
			link: function($scope) {

				$scope.$watch('layout', function(){
					changeTemplate();
				});

				function changeTemplate() {
					if ($scope.layout === 'grid') {
						$scope.templateUrl = 'app/components/photographer/photographer-grid-styles/photographer-grid-styles.html';
					} else {
						$scope.templateUrl = 'app/components/photographer/photographer.html';
					}
				}
			}
        };
        return directive;
    }
})();

(function(){
  'use strict';
  angular
    .module('pixerf')
    .factory('photoViewerSvc', photoViewerSvc);
    photoViewerSvc.$inject = ['$rootScope'];

    function photoViewerSvc($rootScope){
        var mCurrentList = [];
        var mSearch = {};

        function removeDataOnStateChanged(){
            var listener = $rootScope.$on('$stateChangeStart', 
                function(){ 
                    removeListPhoto();
                    listener();// remove listener
                }
            )
            $rootScope.$on('$destroy', function(){
                listener();// remove listener
            });
        }

        function setListPhoto(currentList, unWatchingChangeState){
            mCurrentList = currentList;
            if(!unWatchingChangeState){
                removeDataOnStateChanged();
            }
        }

        function removeListPhoto(){
            setListPhoto([])
        }
        
        function getListPhoto(){
            return mCurrentList;
        }
        
        function setSearchParams(search){
            mSearch = search;
        }

        function getSearchParams(){
            return mSearch;
        }

        function isShouldGetMoreNavigation(currentPosition, navigationListLength, direction){
            if(direction === "next") return navigationListLength - currentPosition < 3;
            if(direction === "prev") return currentPosition < 3;
        }
        function getNextPhoto(direction, currentPosition, navigationList){
            var step = direction === "next" ? 1 : -1;
            return  navigationList[currentPosition + step];   
        }
        return {
            isShouldGetMoreNavigation: isShouldGetMoreNavigation,
            getNextPhoto: getNextPhoto,
            setListPhoto: setListPhoto,
            getListPhoto: getListPhoto,
            getSearchParams: getSearchParams,
            setSearchParams: setSearchParams
        };
    }
})();

(function () {
    'use strict';

    angular
        .module('pixerf')
        .controller('photoViewerCtrl', photoViewerCtrl);

    photoViewerCtrl.$inject = ['$scope', 'photoViewerSvc', 'pixerfApiMediaSvc', 'toastr', 'sessionManagerSvc', 'translationSvc', 'photoGridSvc', '$q'];

    function photoViewerCtrl($scope, photoViewerSvc, pixerfApiMediaSvc, toastr, sessionManagerSvc, translationSvc, photoGridSvc, $q) {
        var self = this;
        $scope.instance = self;
        self.rotatePhoto = rotatePhoto;
        self.navigationList = [];
        self.isLastPrev = false;
        self.isLastNext = false;
        self.loginUser = sessionManagerSvc.getCurrentLoginUser().data;
        self.originalRotation = $scope.photo.rotate_by;
        self.navigate = navigate;
        self.saveRotation = saveRotation;
        self.resetRotation = resetRotation;
        self.isRotationDirty = false;
        self.rotateStep = 0;
        self.originRotateStep = 0;
        self.photoRotate = $scope.photo.rotate_by;
        self.searchParams = {};
        self.logKey = logKey;
        self.showNavigateBtn = true;

        init();

        function init(){
            getNavigationList();
        }

        function logKey(e){
            if(e.code === 'ArrowLeft' && self.isLastPrev) {

                navigate('prev');
            } else if (e.code === 'ArrowRight' && self.isLastNext){
                navigate('next');
            }
        }

        function checkNavigatable(navigationList, photoid) {
            var currentPosition = _.indexOf(navigationList, photoid);
            if(currentPosition < 0){
                self.isLastPrev = false;
                self.isLastNext = false;
                return;
            }
            self.isLastPrev = currentPosition !== 0;
            self.isLastNext = currentPosition !== navigationList.length - 1;
        }

        function getNavigationList() {
            self.navigationList = photoViewerSvc.getListPhoto();
            if(self.navigationList.length <= 1){
                self.showNavigateBtn = false;
            }
            checkNavigatable(self.navigationList, $scope.photo.id);
        }

        function navigate(direction) {
            var currentPosition = _.indexOf(self.navigationList, $scope.photo.id);
            var nextPhotoId = photoViewerSvc.getNextPhoto(direction, currentPosition, self.navigationList);

            if (!nextPhotoId) {
                loadMorePhotos().then(function (mediaId) {
                    getPhotoDetails(mediaId);
                });
            } else {
                getPhotoDetails(nextPhotoId);
            }
        }
        function rotatePhoto() {
            var step = self.rotateStep;
            step += 90;
            self.photoRotate = self.photoRotate === null ? 90 : (self.photoRotate + 90);
            if (self.photoRotate >= 360) {
                self.photoRotate = null;
            }
            if (step >= 360) {
                step = 0;
            }
            self.rotateStep = step;
        }
        function resetRotation() {
            self.rotateStep = self.originRotateStep;
            self.photoRotate = self.originalRotation;
        }
        function saveRotation() {
            if (self.isWorking) return;
            self.isWorking = true;
            if (self.photoRotate === 0 || self.photoRotate >= 360) self.photoRotate = null;
            pixerfApiMediaSvc.update({ id: $scope.photo.id }, { rotate_by: self.photoRotate }).$promise.then(function () {
                self.isWorking = false;
                self.originalRotation = self.photoRotate;
                self.originRotateStep = self.rotateStep;
                $scope.photo.rotate_by = self.photoRotate;
                toastr.success("This photo has been successfully updated!");
                $scope.onPhotoSaved($scope.photo);
            }, function () {
                self.isWorking = false;
                toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
            });
        }
        function loadMorePhotos() {
            var def = $q.defer();
            var tempIds = [];
            self.searchParams = photoViewerSvc.getSearchParams();
            if (self.searchParams) {
                self.searchParams.page++;
                photoViewerSvc.setSearchParams(self.searchParams);
            }
            photoGridSvc.fetchPhotos(self.searchParams).then(function (response) {
                tempIds = _.pluck(response.data, "id");
                self.navigationList = self.navigationList.concat(tempIds);
                photoViewerSvc.setListPhoto(self.navigationList, true);
                def.resolve(tempIds[0]);
            }).catch(function () {
                def.reject();
            })

            return def.promise;
        }
        function getPhotoDetails(nextPhotoId) {
            pixerfApiMediaSvc.get({ id: nextPhotoId }).$promise.then(function (response) {
                var nextPhoto = response.data;
                $scope.photo = nextPhoto;
                checkNavigatable(self.navigationList, nextPhoto.id);
                $scope.onNavigate({ photo: nextPhoto });
            }, function (err) {
                toastr.error("Failed to get photo detail. Please try again.");
            })
        }
    }
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('photoViewer', photoViewer);

	function photoViewer() {

		var directive = {
			scope: {
				'photo': '=',
				'onNavigate': '&',
				'photoLoaded': "=",
				'onPhotoSaved': '&',
				'instance': '='
			},
			restrict: 'E',
			templateUrl: 'app/components/photo-viewer/photo-viewer.html',
			controller: 'photoViewerCtrl',
			controllerAs: 'vm',
			replace: true
		};
		return directive;
	}

})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('photoUsageCtrl', photoUsageCtrl);

    photoUsageCtrl.$inject = ['$scope', '$timeout'];

    function photoUsageCtrl($scope, $timeout) {

            
        var self = this;
        self.onItemClicked = onItemClicked;
        self.selectedItem;
        function setSelectedItem(){
            if(!$scope.file) return;
            self.selectedItem = _.find(self.photoUsages, function(item){
                return item.id === $scope.file.license;
            });
            if(self.selectedItem) self.selectedItem.isSelected = true;
        }
        function selectItem(item){
            if(self.selectedItem){
                self.selectedItem.isSelected = false;
            }
            self.selectedItem = item;
           item.isSelected = true;
           $scope.file.license = item.id;
        }
        self.photoUsages = [{
            id: 'editorial',
            name: 'Editorial',
            description: 'This photo is allowed for editorial use only. It can be used for media articles, blog posts, and social media.  <span>Learn more</span>'
        },{
            id: 'commercial',
            name: 'Commercial',
            description: 'This photo is allowed for both commercial and editorial use. It comes with a signed model or property release. There are also no logos, trademarks or branding in my image. <span>Learn more</span>'
        }]
        function onItemClicked(item, $event){
            selectItem(item);
            (_.debounce(function(){
                $timeout(function(){
                    $scope.onSelectionChanged({item: item});
                })
            }, 300))();
        }
        setSelectedItem();
    }
})();
(function () {
  'use strict';

  angular
    .module('pixerf')
    .directive('photoUsage', photoUsage);

  function photoUsage() {

    var directive = {
      scope: {
        "isDisabled" : "=",
        "file": "=",
        "onSelectionChanged": "&"
      },
      restrict: 'E',
      templateUrl: 'app/components/photo-usage/photo-usage.html',
      controller: 'photoUsageCtrl',
      controllerAs: 'vm',
      replace: true
    };
    return directive;
  }

})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('photoReleaseFormSelectionCtrl', photoReleaseFormSelectionCtrl);

    photoReleaseFormSelectionCtrl.$inject = ['fileUtils', '$scope', '$timeout', 'pixerfApiMediaSvc', 'pixerfUrl', 'sessionManagerSvc', 'toastr', 'systemUtils'];

    function photoReleaseFormSelectionCtrl(fileUtils, $scope, $timeout, pixerfApiMediaSvc, pixerfUrl, sessionManagerSvc, toastr, systemUtils) {
        var self = this;
        self.onUploadFormBtnClicked = onUploadFormBtnClicked;
        self.releaseFromType = null;
        self.selectedReleaseForms = [];
        self.userReleaseForms = {model: [], property: []};
        self.onRemoveBtnClick = onRemoveBtnClick;
        self.onItemClicked = onItemClicked;
        self.isCollapsed = {
            model: false,
            property: false
        }

        fetchUserReleaseForms();

        self.dropzoneConfig = {
            'instance' : {},
            'options': {
                url: pixerfUrl.full + 'api/media/releases',
                maxFilesize: 15,
                paramName: 'file',
                parallelUploads: 10,
                autoProcessQueue: true,
                previewsContainer: '#photo-release-form-previews',
                clickable: ".photo-release-form-selection__photo-release-btns .btn",
                method: "post",
                headers: {
                    "Authorization": "Bearer " + sessionManagerSvc.getToken()
                },
                dictFileTooBig: "Size of this file is {{filesize}} MB file. The maximum size is {{maxFilesize}} MB.",
            },
            'eventHandlers': {
                'sending': function(file, xhr, formData){
                    formData.append('type', self.releaseFromType);
                },
                'addedfile': function(file) {
                    file.filename = file.name;
                    var errMsg = duplicatedFileCheck(self.userReleaseForms['model'].concat(self.userReleaseForms['property']), file.name);
                    if(!errMsg) {
                        errMsg = validateFileExtension(file.name);
                    }
                    if(errMsg){
                        toastr.error(errMsg);
                        //reject and cancel all uploading progress
                        this.removeAllFiles(true);
                        systemUtils.digest($scope);
                        return ;
                    }
                    file.filename = file.name;
                    file.isSelected = true;
                    self.userReleaseForms[self.releaseFromType].push(file);
                    setReleaseFormSelectedStatus(file, true);
                    systemUtils.digest($scope);
                    
                },
                'uploadprogress': function(file, progress){
                    updateReleaseFormInfo(file);
                },
                'success': function(file, response){
                   file.id = response.id;
                   updateReleaseFormInfo(file);
                   systemUtils.digest($scope);
                },
                'error': function(file, errMsg){    
                    toastr.error("Failed to upload release form. " + errMsg);
                    self.userReleaseForms[self.releaseFromType] = _.reject(self.userReleaseForms[self.releaseFromType], function(item){
                        return item.filename === file.name && !item.id;
                    });
                    $scope.file.releases = _.reject($scope.file.releases, function(item){
                        return item.filename === file.name && !item.id;
                    });
                    systemUtils.digest($scope);
                }
            }

        };
        function duplicatedFileCheck(files, filename){
             if(isFilenameExisted(files, filename)){
                return "The file: " + filename + " already exists. Please choose another file name";
            }
        }
        function validateFileExtension(filename){
            var fileExtension = fileUtils.getFileExtension(filename);
            if (fileExtension.toLowerCase() !== "png" && 
               fileExtension.toLowerCase() !== "jpg" &&
               fileExtension.toLowerCase() !== "jpeg" &&
               fileExtension.toLowerCase() !== "pdf") {
                return "Sorry, we only accept JPEG or PNG or PDF files only";
            }
        }
        function isFilenameExisted(files, filename){
            var found = _.find(files, function(file){
                return file.filename === filename;
            })
            return !!found;
        }
        function setReleaseFormSelectedStatus(form, status){
            if(!$scope.file.releases) $scope.file.releases = [];
            form.isSelected = status;
            if(status){
                if(isFilenameExisted($scope.file.releases, form.filename)){
                    return ;
                }
                var upload = {
                    progress: form.upload ? form.upload.progress : 100
                }
                $scope.file.releases.push({id: form.id, filename: form.filename, upload: upload});
            } else {
                findAndSetSelectedStatus(form, self.userReleaseForms, false);
                $scope.file.releases = _.reject($scope.file.releases, function(file){
                    return file.id === form.id;
                })
                var willBeDeleted = _.find(self.dropzoneConfig.instance.getUploadingFiles(), function(file){
                    return file.name === form.filename;
                });
                if(willBeDeleted) self.dropzoneConfig.instance.removeFile(willBeDeleted);

            }
            $scope.onSelectionChanged();
        }
        function findAndSetSelectedStatus(form, releaseFormLibrary, status){
            var found = _.find(releaseFormLibrary['model'], function(f){
                return f.id === form.id;
            })
            if(found){
                found.isSelected = status;
            } else{
                found = _.find(releaseFormLibrary['property'], function(f){
                    return f.id === form.id;
                })
                if(found){
                    found.isSelected = status;
                } 
            }
        }
        function updateReleaseFormsSelectedStatus(fileReleaseForms, releaseFormLibrary){
            for(var i =0; i < fileReleaseForms.length; i ++){
                findAndSetSelectedStatus(fileReleaseForms[i], releaseFormLibrary, true);
            }
        }
        function updateReleaseFormInfo(info){
            var willBeUpdatedForm = _.find($scope.file.releases, function(item){
                return item.filename === info.name && !item.id ;
            })
            if(willBeUpdatedForm) {
                willBeUpdatedForm.upload.progress = info.upload.progress;
                willBeUpdatedForm.id = info.id;
                $scope.onSelectionChanged();
            }
        }
        function onItemClicked(releaseForm, $event){
            if($scope.file.status && $scope.file.status === 'approved') return;
            $event.stopPropagation();
            setReleaseFormSelectedStatus(releaseForm, !releaseForm.isSelected);
        }
        function fetchUserReleaseForms(){
            
            pixerfApiMediaSvc.get_release_form().$promise.then(function(response){
                self.userReleaseForms = response;
                updateReleaseFormsSelectedStatus($scope.file.releases, self.userReleaseForms);
            }, function(){

            })
        }
        function onUploadFormBtnClicked(type){
            self.releaseFromType = type;
            self.dropzoneConfig.instance.processQueue();
        }
        function onRemoveBtnClick(file){
            setReleaseFormSelectedStatus(file, false);
        }
    }
})();
(function () {
  'use strict';

  angular
    .module('pixerf')
    .directive('photoReleaseFormSelection', photoReleaseFormSelection);

  function photoReleaseFormSelection() {

    var directive = {
      scope: {
        "isDisabled" : "=",
        "file": "=",
        "onSelectionChanged": "&",
        "isShown": "=",
        "alert": "="
      },
      restrict: 'E',
      templateUrl: 'app/components/photo-release-form-selection/photo-release-form-selection.html',
      controller: 'photoReleaseFormSelectionCtrl',
      controllerAs: 'vm',
      replace: true
    };
    return directive;
  }

})();

(function(){
  'use strict';
  angular
    .module('pixerf')
    .factory('photoPriceSizeSelectionSvc', photoPriceSizeSelectionSvc);

    photoPriceSizeSelectionSvc.$inject = ['sessionManagerSvc'];

    function photoPriceSizeSelectionSvc(sessionManagerSvc){
       
        return {
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('photoPriceSizeSelectionCtrl', photoPriceSizeSelectionCtrl);

    photoPriceSizeSelectionCtrl.$inject = ['$scope', '$translate', 'sessionManagerSvc', 'accountConst', '$state', '$uibModalStack'];

    function photoPriceSizeSelectionCtrl($scope, $translate, sessionManagerSvc, accountConst, $state, $uibModalStack) {
        var self = this;
		self.mloginnedUser = sessionManagerSvc.getCurrentLoginUser().data;
        self.layoutHorizontal = $scope.layoutHorizontal;
        self.onPriceItemClicked = _.debounce(function(evt, price){
            $scope.$apply(function(){
                onPriceItemClicked(evt, price);
            })
        }, 300);
        self.selectedPrice = null;
        self.toolTips = [
            {
                "size": "XS",
                "toolTips": $translate.instant('tool-tip-xsmall'),
            },
            {
                "size": "S",
                "toolTips": $translate.instant('tool-tip-small'),
            },
            {
                "size": "M",
                "toolTips": $translate.instant('tool-tip-medium'),
            },
            {
                "size": "L",
                "toolTips": $translate.instant('tool-tip-large'),
            },
            {
                "size": "XL",
                "toolTips": $translate.instant('tool-tip-xlarge')
            },
            {
                "size": "XXL",
                "toolTips": $translate.instant('tool-tip-xxlarge')
            }
        ];

        $scope.$watch("photo.price", function(){
            if($scope.photo && $scope.photo.price && $scope.photo.price.range && $scope.photo.price.range.length > 0){
                onPriceItemClicked(null, getDefaultValue());
                buildLicenseToolTips();
            }
        })
        function buildLicenseToolTips(){
            var priceRange = $scope.photo.price.range;
            for(var i = 0; i < priceRange.length; i++){
                for(var j = 0; j < self.toolTips.length; j++){
                    if(priceRange[i].size === self.toolTips[j].size){
                        priceRange[i].toolTips = self.toolTips[j].toolTips;
                        break;
                    }
                }
            }
        }
        function getDefaultValue(){
            var priceRange = $scope.photo.price.range;
            for (var i  = 0; i < priceRange.length; i ++){
                if(priceRange[i].isSelected){
                    return priceRange[i];
                }
            }
            return priceRange[0];
        }
        function deselectAll(priceRange){
            for (var i = 0; i < priceRange.length; i ++){
                priceRange[i].isSelected = false;
            }
        }
        function onPriceItemClicked(evt, price){
            if($scope.isDisabled) return;
            deselectAll($scope.photo.price.range);
            price.isSelected = true;
            self.selectedPrice = price;
            $scope.onItemSelectedChanged({evt: evt, price: self.selectedPrice});

        }
    }
})();
(function () {
  'use strict';

  angular
    .module('pixerf')
    .directive('photoPriceSizeSelection', photoPriceSizeSelection);

  function photoPriceSizeSelection() {

    var directive = {
      scope: {
        "layoutHorizontal": "=",
        "photo" : "=",
        'onItemSelectedChanged': '&',
        'isReadonly': '=',
        'isDisabled': '='
      },
      restrict: 'E',
      templateUrl: 'app/components/photo-price-size-selection/photo-price-size-selection.html',
      controller: 'photoPriceSizeSelectionCtrl',
      controllerAs: 'vm',
      replace: true
    };
    return directive;
  }

})();

/**
 * Controller for home module
 */
(function(){
  'use strict';
  angular
    .module('pixerf')
    .factory('photoPriceSelectionSvc', photoPriceSelectionSvc);

    photoPriceSelectionSvc.$inject = ['sessionManagerSvc'];

    function photoPriceSelectionSvc(sessionManagerSvc){
        
        function buildPriceListItem(rawData){
            rawData.displayValue = 'SGD ' + rawData.value;
            return rawData;
        }
        function buildPricesList(options){
            for (var i = 0; i < options.length; i ++){
                buildPriceListItem(options[i]);
            }
            return options;
        }
        function setAvailablePrice(pricesList){
            pricesList[0].isAvailable = true;
        }
        return {
            buildPricesList: buildPricesList,
            setAvailablePrice: setAvailablePrice,
            buildPriceListItem: buildPriceListItem
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('photoPriceSelectionCtrl', photoPriceSelectionCtrl);

    photoPriceSelectionCtrl.$inject = ['$scope','photoPriceSelectionSvc', '$timeout', 'priceUtils'];

    function photoPriceSelectionCtrl($scope, photoPriceSelectionSvc, $timeout, priceUtils) {

        var self = this;
        self.onItemClicked = onItemClicked;
        
        
        $scope.$watch("settings.options", function(newValue, oldValue){
            self.pricesList = photoPriceSelectionSvc.buildPricesList($scope.settings.options);
            setDefaultSelectedItem(self.pricesList);
        })
        function setDefaultSelectedItem(pricesList){
            // var skeletonItem = priceUtils.createSkeletonPriceStructure(pricesList[0]);
            if($scope.selectedModel){
                var find = _.find(pricesList, function(it){
                    return it.value == $scope.selectedModel.value;
                });
                if(find) {
                    $scope.selectedModel = find;    
                } else if($scope.selectedModel.id){
                    insertPriceByOrder(self.pricesList, photoPriceSelectionSvc.buildPriceListItem($scope.selectedModel));
                }
            } else {
                $scope.selectedModel = pricesList[0];
            }
            

        }
        function insertPriceByOrder(pricesList, price, asc){
            for(var i = pricesList.length - 1; i >= 0; i --){
                if(price.value > pricesList[i].value){
                    pricesList.splice(i+1, 0, price);
                    return;
                }
            }
        }
        function selectItem(item){
            $scope.selectedModel = item;
        }

        function onItemClicked(item, $event){
            selectItem(item);
            (_.debounce(function(){
                $timeout(function(){
                    $scope.onSelectionChanged({item: item});
                })
            }, 300))();
        }
    }
})();
(function () {
  'use strict';

  angular
    .module('pixerf')
    .directive('photoPriceSelection', photoPriceSelection);

  function photoPriceSelection() {

    var directive = {
      scope: {
        "isDisabled" : "=",
        "selectedModel": "=",
        "settings": "=",
        "onSelectionChanged": "&"
      },
      restrict: 'E',
      templateUrl: 'app/components/photo-price-selection/photo-price-selection.html',
      controller: 'photoPriceSelectionCtrl',
      controllerAs: 'vm',
      replace: true
    };
    return directive;
  }

})();

(function(){
  'use strict';
  angular
    .module('pixerf')
    .factory('photoPriceExtendedLicenseSelectionSvc', photoPriceExtendedLicenseSelectionSvc);

    photoPriceExtendedLicenseSelectionSvc.$inject = ['sessionManagerSvc'];

    function photoPriceExtendedLicenseSelectionSvc(sessionManagerSvc){
       
        return {
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('photoPriceExtendedLicenseSelectionCtrl', photoPriceExtendedLicenseSelectionCtrl);

    photoPriceExtendedLicenseSelectionCtrl.$inject = ['$scope', 'priceConst', 'cartUtils'];

    function photoPriceExtendedLicenseSelectionCtrl($scope, priceConst, cartUtils) {
        var self = this;

        $scope.$watch("photo", function(newValue, oldValue){
            if(!newValue) return;
            setDefaultSelection(newValue);
        })
        self.onLicenseItemSelectionChanged = onLicenseItemSelectionChanged;

        function setDefaultSelection(photo){
            if(!photo.extendedLicenses){
                photo.extendedLicenses = $.extend(true, [], priceConst.EXTENDED_LICENSES);
            }
        }
        function setSelectedItem(license){
            license.isSelected = true;
            onLicenseItemSelectionChanged(null, license);
        }

        function getLicenseById(extendedLicenses, id){
            return _.find(extendedLicenses, function(item){
                return item.id === id;
            });
        }
        function onLicenseItemSelectionChanged(evt, license){
            cartUtils.setSelectedLicense($scope.photo.extendedLicenses, license);
            $scope.onItemSelectedChanged({evt: evt, license: license});
        }


    }
})();
(function () {
  'use strict';

  angular
    .module('pixerf')
    .directive('photoPriceExtendedLicenseSelection', photoPriceExtendedLicenseSelection);

  function photoPriceExtendedLicenseSelection() {

    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/photo-price-extended-license-selection/photo-price-extended-license-selection.html',
      controller: 'photoPriceExtendedLicenseSelectionCtrl',
      controllerAs: 'vm',
      replace: true,
      scope: {
          'onItemSelectedChanged': '&',
          'photo': '=',
          'isDisabled': '='
      }
    };
    return directive;
  }

})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('photoOriginalSizeCtrl', photoOriginalSizeCtrl);

    photoOriginalSizeCtrl.$inject = ['$scope', '$translate'];

    function photoOriginalSizeCtrl($scope, $translate) {
        var self = this;

        self.toolTips = [
            {
                "size": "XS",
                "toolTips": $translate.instant('tool-tip-small'),
            },
            {
                "size": "S",
                "toolTips": $translate.instant('tool-tip-small'),
            },
            {
                "size": "M",
                "toolTips": $translate.instant('tool-tip-medium'),
            },
            {
                "size": "L",
                "toolTips": $translate.instant('tool-tip-large'),
            },
            {
                "size": "XL",
                "toolTips": $translate.instant('tool-tip-xlarge')
            },
            {
                "size": "XXL",
                "toolTips": $translate.instant('tool-tip-xxlarge')
            }
        ];

        $scope.$watch("photo", function(){
            if($scope.photo && $scope.photo.price.range && $scope.photo.price.range.length > 0){
                buildLicenseToolTips();
            }
        })
        function buildLicenseToolTips(){
            var priceRange = $scope.photo.price.range;
            for(var i = 0; i < priceRange.length; i++){
                for(var j = 0; j < self.toolTips.length; j++){
                    if(priceRange[i].size === self.toolTips[j].size){
                        $.extend(true, priceRange[i], self.toolTips[j]);
                        break;
                    }
                }
            }
        }
    }
})();
(function () {
  'use strict';

  angular
    .module('pixerf')
    .directive('photoOriginalSize', photoOriginalSize);

  function photoOriginalSize() {

    var directive = {
      scope: {
        "photo" : "=",
      },
      restrict: 'E',
      templateUrl: 'app/components/photo-original-size/photo-original-size.html',
      controller: 'photoOriginalSizeCtrl',
      controllerAs: 'vm',
      replace: true
    };
    return directive;
  }

})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('photoLicenseInfoCtrl', photoLicenseInfoCtrl);

	photoLicenseInfoCtrl.$inject = ['$scope', 'translationSvc', 'toastr', 'sessionManagerSvc', 'pixerfApiMediaSvc', '$translate', 'pixerfApiUserSvc'];

	function photoLicenseInfoCtrl($scope, translationSvc, toastr, sessionManagerSvc, pixerfApiMediaSvc, $translate, pixerfApiUserSvc) {

		var self = this;
		self.loginnedUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.onRequestReleaseFormBrnclicked = onRequestReleaseFormBrnclicked;
		self.getCommercialStatus = getCommercialStatus;
		self.showDownloadRelease = showDownloadRelease;
		self.isMultipleLicense = isMultipleLicense;
		self.hasModelProperty = hasModelProperty;

		function onRequestReleaseFormBrnclicked(photo) {
			var pixerfAPIUrlConfigurer = new PixerfAPIUrlConfigurer();
			var baseUrl = pixerfAPIUrlConfigurer.getBaseUrl();
			var fullUrl = pixerfAPIUrlConfigurer.URL_PRFIX + baseUrl + pixerfAPIUrlConfigurer.URL_AFFIX + '#/';

			if (baseUrl.startsWith("localhost")) {
				fullUrl = pixerfAPIUrlConfigurer.URL_LOCAL_PRFIX + baseUrl + pixerfAPIUrlConfigurer.URL_AFFIX + '#/';
			}
			var photoUrl = fullUrl + 'photo/' + photo.id + '/' + photo.title;

			if (!photo.user || !photo.user.id) {
				return toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
			}
			if (!photo.user.email) {
				return getUserInfoAndCallRequest(photoUrl, photo.user.id);
			}

			callRequestReleaseFormApi(photo.user.email, photoUrl);
		}

		function callRequestReleaseFormApi(email, photoUrl){
			pixerfApiMediaSvc.request_release_form({
				email: email,
				url: photoUrl
			}).$promise.then(
				function success(res) {
					toastr.success('Successfully requested!');
				},
				function error(err) {
					console.log(err);
					toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
				}
			);
		}

		function isMultipleLicense(license){
			return license == 'Multiple licenses';
		}

		function getUserInfoAndCallRequest(photoUrl, userId){
			return pixerfApiUserSvc.get({
				id: userId,
				action: 'profile'
			}).$promise.then(
				function success(userData) {
					callRequestReleaseFormApi(userData.email, photoUrl);
				},
				function error(err) {
					console.log(err);
					toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
				}
			);
		}

		function getCommercialStatus() {
			if(!$scope.photo) return 'no';
			if ($scope.photo.license === 'editorial') {
				return 'no';
			} else if (($scope.photo.status === 'approved') || ($scope.photo.has_model_property == false)) {
                return 'yes';
			}
            return 'pending';
		}

		function hasModelProperty(property){
			return ((property == true) || (property == false) || (((property) && property.replace(/^\s+|\s+$/gm,'').length > 0)))
		}

		function showDownloadRelease() {
			return $scope.photo && $scope.photo.license === "commercial" && self.loginnedUser && self.loginnedUser.canCurate && $scope.photo.releases && $scope.photo.releases.length;
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('photoLicenseInfo', photoLicenseInfo);

	function photoLicenseInfo() {

		var directive = {
			scope: {
				'photo': '=',
				'showMultipleLincense': '='
			},
			restrict: 'E',
			templateUrl: 'app/components/photo-license-info/photo-license-info.html',
			controller: 'photoLicenseInfoCtrl',
			controllerAs: 'vm',
			replace: true
		};
		return directive;
	}

})();

(function () {
  'use strict';

  angular
    .module('pixerf')
    .directive('photoLicenseDeternimationQuestions', photoLicenseDeternimationQuestions);

  function photoLicenseDeternimationQuestions() {

    var directive = {
      scope: {
          media: '=',
          curateMode: '=',
          onQuestionAnswered: '&',
          isRequired: '='
      },
      restrict: 'E',
      templateUrl: 'app/components/photo-license-deternimation-questions/photo-license-deternimation-questions.html',
      replace: true
    };
    return directive;
  }

})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .directive('photoInfoLink', photoInfoLink);
    photoInfoLink.$inject = ['$rootScope', '$interval'];
    function photoInfoLink($rootScope, $interval) {
        return {
            scope: {
              photo: "="
            },
            templateUrl : 'app/components/photo-info-link/photo-info-link.html',
            restrict: 'E',
            replace: true
		};
    }
})();                                                                  
(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('photoGridPagerCtrl', photoGridPagerCtrl);

    photoGridPagerCtrl.$inject = ['$scope'];

    function photoGridPagerCtrl( $scope) {

        var self = this;
        self.pageNumber = 1;
        $scope.instance = self;

    }
})();
(function () {
  'use strict';

  angular
    .module('pixerf')
    .directive('photoGridPager', photoGridPager);

  function photoGridPager() {

    var directive = {
      scope: {
        photoGridInstance: "=",
        totalPhotoText: '@',
        isShownNumPhotos: '=',
        unit: '@',
        page: "=",
        totalPage: '=',
        totalPhotos: '=',
        onCurrentPageChanged: "&",
        isShowPageText: '@'
      },
      restrict: 'E',
      templateUrl: 'app/components/photo-grid-pager/photo-grid-pager.html',
      controller: 'photoGridPagerCtrl',
      controllerAs: 'vm',
      replace: true
    };
    return directive;
  }

})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.factory('photoGridSvc', photoGridSvc);

	photoGridSvc.$inject = ['pixerfApiGallerySvc', 'pixerfApiUserSvc', 'pixerfApiMediaSvc', 'fileConst', 'pixerfApiMissionSvc', 'sessionManagerSvc'];

	function photoGridSvc(pixerfApiGallerySvc, pixerfApiUserSvc, pixerfApiMediaSvc, fileConst, pixerfApiMissionSvc, sessionManagerSvc) {
		
		self.loginedUser = sessionManagerSvc.getCurrentLoginUser().data;

		function fetchPhotos(searchParam) {
			var urlParams = {
				page: searchParam.page,
				page_size: fileConst.PHOTO_GRID_PAGE_SIZE
			};
			if (searchParam.pageSize) {
				urlParams.page_size = searchParam.pageSize;
			}
			if (searchParam.type === 'pending_missions') {
				return pixerfApiMissionSvc.get_pending_in_missions().$promise;
			}
			if (searchParam.mission) {
				urlParams.id = searchParam.mission.id;
				if (searchParam.status === 'pending') {
					return pixerfApiMissionSvc.pending_submission_mission(urlParams).$promise;
				}
				if (searchParam.status === 'rejected') {
					return pixerfApiMissionSvc.rejected_submission_mission(urlParams).$promise;
				}
				if (searchParam.type) {
					urlParams.type = searchParam.type;
				}
				return pixerfApiMissionSvc.get_participations(urlParams).$promise;
			}
			if (searchParam.userId) {
				urlParams.id = searchParam.userId;
				if (searchParam.type) {
					urlParams.type = searchParam.type;
				}
				return pixerfApiUserSvc.get_medias(urlParams, buildSearchParam(searchParam)).$promise;
			}
			if (searchParam.galleryIds) {
				var galleryIds = typeof searchParam.galleryIds === "string" ? searchParam.galleryIds.split(",") : searchParam.galleryIds;
				urlParams.id = galleryIds[0];
				return pixerfApiGallerySvc.get_medias(urlParams).$promise;
			}
			if (searchParam.action === "more") {
				urlParams.id = searchParam.mediaid;
				return pixerfApiMediaSvc.getSimilar(urlParams).$promise;
			}
			return pixerfApiMediaSvc.search(urlParams, buildSearchParam(searchParam)).$promise;
		}

		function getPhotoSizeContraint(sizeName) {
			for (var i = 0; i < fileConst.SIZE_DEFINITION.length; i++) {
				if (fileConst.SIZE_DEFINITION[i].name === sizeName) {
					if (i === fileConst.SIZE_DEFINITION.length - 1) {
						return "gte-" + fileConst.SIZE_DEFINITION[i].value;
					}
					return "gte-" + fileConst.SIZE_DEFINITION[i].value + "," + "lte-" + fileConst.SIZE_DEFINITION[i + 1].value;
				}
			}
		}

		function buildSearchParam(searchParam, isTemporary) {
			var param = {};
			if (searchParam.username) {
				param.username = searchParam.username;
			}
			if (searchParam.sort) param.sort = searchParam.sort
			else if(self.loginedUser && ['saat@pixerf.com', 'suzette@pixerf.com', 'whiskerscao@gmail.com'].includes(self.loginedUser.email)){
				param.sort = ["inserted_at,desc"];
			}
			if (searchParam.state && !isTemporary) {
				param.state = searchParam.state
			}
			if (typeof searchParam.in_mission !== 'undefined') param.in_mission = searchParam.in_mission;
			if (searchParam.keywords) param.keywords = searchParam.keywords;
			if (searchParam.galleryIds) param.gallery_ids = typeof searchParam.galleryIds === "string" ? searchParam.galleryIds.split(",") : searchParam.galleryIds;
			if (searchParam.megapixels) param.megapixels = getPhotoSizeContraint(searchParam.megapixels.toUpperCase());
			if (searchParam.orientation) param.orientation = searchParam.orientation;
			if (searchParam.categoryIds) param.category_ids = typeof searchParam.categoryIds === "string" ? searchParam.categoryIds.split(",") : searchParam.categoryIds;
			if (searchParam.license) param.license = searchParam.license.toUpperCase();
			if (searchParam.price) param.price = searchParam.price;
			if (searchParam.more_type) param.more_type = searchParam.more_type;
			if (searchParam.type) param.type = searchParam.type;
			if (searchParam.states && searchParam.states.length) {
				param.states = searchParam.states;
			}
			if(searchParam.status){
				param.status = searchParam.status;
				param.has_model_property = true;
			}

			return param;
		}

		function fetchTemporaryPhotos(searchParam){
			var isTemporary = true;
			var urlParams = {
				page: searchParam.page,
				page_size: fileConst.PHOTO_GRID_PAGE_SIZE
			};
			if (searchParam.pageSize) {
				urlParams.page_size = searchParam.pageSize;
			}
			if (searchParam.type === 'pending_missions') {
				return pixerfApiMissionSvc.get_pending_in_missions().$promise;
			}
			if (searchParam.mission) {
				urlParams.id = searchParam.mission.id;
				if (searchParam.status === 'pending') {
					return pixerfApiMissionSvc.pending_submission_mission(urlParams).$promise;
				}
				if (searchParam.status === 'rejected') {
					return pixerfApiMissionSvc.rejected_submission_mission(urlParams).$promise;
				}
				if (searchParam.type) {
					urlParams.type = searchParam.type;
				}
				return pixerfApiMissionSvc.get_participations(urlParams).$promise;
			}
			if (searchParam.userId) {
				urlParams.id = searchParam.userId;
				if (searchParam.type) {
					urlParams.type = searchParam.type;
				}
				return pixerfApiUserSvc.get_medias(urlParams, buildSearchParam(searchParam, isTemporary)).$promise;
			}
			if (searchParam.galleryIds) {
				var galleryIds = typeof searchParam.galleryIds === "string" ? searchParam.galleryIds.split(",") : searchParam.galleryIds;
				urlParams.id = galleryIds[0];
				return pixerfApiMediaSvc.getTemporary(urlParams).$promise;
			}
			if (searchParam.action === "more") {
				urlParams.id = searchParam.mediaid;
				return pixerfApiMediaSvc.getSimilar(urlParams).$promise;
			}
			return pixerfApiMediaSvc.getTemporary(urlParams, buildSearchParam(searchParam, isTemporary)).$promise;
		}

		return {
			fetchPhotos: fetchPhotos,
			fetchTemporaryPhotos: fetchTemporaryPhotos
		};
	}
})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('photoGridCtrl', photoGridCtrl);

    photoGridCtrl.$inject = ['$rootScope', '$scope', 'photoGridSvc', 'fileUtils', 'pagingUtils', 'sessionManagerSvc', 'photoGridUtils', '$q', 'arrayUtils', 'numberUtils', 
        'gallerySvc', 'photoDetailSvc', 'photoViewerSvc', 'pixerfApiUserSvc'];

    function photoGridCtrl($rootScope, $scope, photoGridSvc,  fileUtils, pagingUtils, sessionManagerSvc, photoGridUtils, $q, arrayUtils, numberUtils, 
        gallerySvc, photoDetailSvc, photoViewerSvc, pixerfApiUserSvc) {

        var self = this;
        var photoIds = [];
        self.containerClass = $scope.container ? $scope.container + " .photo-grid__photos-container" : '';
        self.getFile = getFile;
        self.fetchMorePhotos = fetchMorePhotos;
        self.fetchPhotos = fetchPhotos;
        self.render = render;
        self.reRender = reRender;
        self.spinner = {isVisible: false};
        self.photos = null;
        self.totalPhotos = 0;
        self.totalPage = 0;
        self.failedToLoadImages = [];
        self.searchParams = null;
        self.firstPageNumber = -1;
        self.isNoMorePhotoToLoad = true;
        self.onFileRemoved = onFileRemoved;
        self.onAddedOrRemovedFromGallery = onAddedOrRemovedFromGallery;
        self.onPhotoPopupSaved = onPhotoPopupSaved;
        $scope.instance = self;
        self.onWindowResize = _.debounce(reRender, 300);
        self.onOrientationChange = _.debounce(reRenderOrientationChange, 300);
        self.isFresh = false;
        var mLoginnedUser = sessionManagerSvc.getCurrentLoginUser().data;
        self.isMobile = photoDetailSvc.isMobile();
        self.isTemporaryType = false;
        self.flaggedUsers = [];


        function getFile(fileId){
            var found = fileUtils.findFileById(self.photos, fileId);
            if(found){
                // found.isMine = mLoginnedUser ? mLoginnedUser.username === found.person.username : false;
                // found.person = accountUtils.transformUserData(found.person);
                // found.path = window.location.protocol + "//" + window.location.host + "/photo/" + fileId;
            }

            return found;
        }
        function fetchPhotos(searchParams, isRefresh){
            var def =  $q.defer();
            if(self.spinner.isVisible){
                def.resolve([]);
                return def.promise;
            }
            self.searchParams = searchParams || {};
            if(!self.searchParams.page) self.searchParams.page = 1;


            self.spinner.isVisible = true;
            self.isNoMorePhotoToLoad = false;
            if(isRefresh) {
                reset();
            }

            if(self.firstPageNumber === -1) self.firstPageNumber = self.searchParams.page;

            self.isFresh = isRefresh;

            if(self.isTemporaryType){
                return fetchTemporaryPhotos(def);
            }
            photoGridSvc.fetchPhotos(self.searchParams).then(function(response){
                self.spinner.isVisible = false;
                if (self.searchParams.page === 1) {
                    self.failedToLoadImages = [];
                    self.photos = [];
                }
                if(response.data && response.data.length > 0){
                    if($scope.isPendingCommercialCustom){
                        response.data = _.reject(response.data, function (pt) {
                            return !pt.has_model_property;
                        });
                        response.data = _.reject(response.data, function (pt) {
                            return pt.is_releasable;
                        });
                    }
                    if(angular.isDefined($scope.onBeforeRender)){
                        $scope.onBeforeRender({photos: response.data});
                    }
                    self.photos = self.photos.concat(response.data);
                    if(!self.searchParams.action || self.searchParams.action != "more"){
                        photoIds = _.pluck(self.photos, "id");
                        photoViewerSvc.setSearchParams(self.searchParams);
                        photoViewerSvc.setListPhoto(photoIds);
                    }
                    render(response.data);
                }
                self.isNoMorePhotoToLoad = pagingUtils.isNoMorePageToLoad(self.searchParams.page, response);
                self.totalPhotos = pagingUtils.getTotalCount(response);
                self.totalPage = pagingUtils.getTotalPage(response);
                def.resolve(self);
            }, function(){
                self.isFresh = false;
                self.spinner.isVisible = false;
                def.reject(self);
            });

            return def.promise;
        }

        function fetchTemporaryPhotos(def){
            photoGridSvc.fetchTemporaryPhotos(self.searchParams).then(
                function success(response){
                    self.spinner.isVisible = false;
                    if (self.searchParams.page === 1) {
                        self.failedToLoadImages = [];
                        self.photos = [];
                    }
                    if (response.data && response.data.length > 0) {
                        if (angular.isDefined($scope.onBeforeRender)) {
                            $scope.onBeforeRender({ photos: response.data });
                        }
                        self.photos = self.photos.concat(response.data);
                        if (!self.searchParams.action || self.searchParams.action != "more") {
                            photoIds = _.pluck(self.photos, "id");
                            photoViewerSvc.setSearchParams(self.searchParams);
                            photoViewerSvc.setListPhoto(photoIds);
                        }
                        render(response.data);
                    }
                    self.isNoMorePhotoToLoad = pagingUtils.isNoMorePageToLoad(self.searchParams.page, response);
                    self.totalPhotos = pagingUtils.getTotalCount(response);
                    self.totalPage = pagingUtils.getTotalPage(response);
                    def.resolve(self);
                },
                function error(err){
                    self.isFresh = false;
                    self.spinner.isVisible = false;
                    def.reject(self);
                }
            );

            return def.promise;
        }

        function registerScrollSpy(photos, isRedraw){
            for (var i = 0; i < photos.length; i ++){
                var photo = photos[i];
                photo.onScrollTo = '';
                photo.scrollSpyId = undefined;
                photo.pixerfScrollSpyDirection = undefined;
                photo.isFirstPhoto = undefined;
                photo.isLastPhoto = undefined;
                if(i === 0){
                    photo.scrollSpyId = new Date().getTime() + "-" + photo.id;
                    photo.onScrollTo = 'onScrollToPhoto({page:' + photo.pageNumber + '})';
                    photo.pixerfScrollSpyDirection = 'down';
                    if(self.searchParams.page === self.firstPageNumber){
                        photo.pixerfScrollSpyDirection = 'both';
                        photo.isFirstPhoto = true;
                    }
                }
                if(i === photos.length - 1) {
                    photo.scrollSpyId = new Date().getTime() + "-" + photo.id;
                    photo.onScrollTo = 'onScrollToPhoto({page:' +  photo.pageNumber + '})';
                    if(isRedraw){
                        photo.pixerfScrollSpyDirection = 'both';
                    } else {
                        photo.pixerfScrollSpyDirection = 'up';
                    }
                    if(self.isNoMorePhotoToLoad){
                        photo.isLastPhoto = true;
                        photo.pixerfScrollSpyDirection = 'both';
                    }
                }
            }
        }
        function fetchMorePhotos(){
            if(self.spinner.isVisible){
                return;
            }
            self.searchParams.page ++;
            if($scope.onLoadMorePage) $scope.onLoadMorePage({page: self.searchParams.page});
            fetchPhotos(self.searchParams);
        }
        function startRendering(photos, failedToLoadImages, isRedraw){
            photos = removeSpoilPhotos(photos, failedToLoadImages);
            if (angular.isDefined($scope.shuffle)) {
                var shuffleRange = numberUtils.parseInt($scope.shuffle);
                if(self.searchParams.page <= shuffleRange){
                    photos = arrayUtils.shuffle(photos);
                }
            }
            if (angular.isDefined($scope.onScrollToPhoto)) {
                registerScrollSpy(photos, isRedraw);
            }
            $scope.grid.generate(photos);
        }
        function redraw(){
            var photoPages = Object.values(_.groupBy(self.photos, "pageNumber"));
            for( var i = 0; i < photoPages.length; i++){
                startRendering(photoPages[i], self.failedToLoadImages, true);
            }
        }
        function render(photos){
            if(photos.length <= 0) return;
            self.spinner.isVisible = true;
            var imageElements = [];
            var loadedImage = 0;
            for(var i=0; i< photos.length; i++){
                if(self.searchParams){
                    photos[i].pageNumber = self.searchParams.page;
                }
                imageElements[i] = new Image();
                imageElements[i].setAttribute("class", "image"+i);
                imageElements[i].onload = (function(idx){
                    return function(){
                        loadedImage ++;
                        photos[idx].w = this.width;
                        photos[idx].h = this.height;
                        photos[idx].ar = this.width / this.height;
                        if(loadedImage === photos.length){
                            self.spinner.isVisible = false;
                            self.isFresh = false;
                            startRendering(photos, self.failedToLoadImages);
                        }
                    }
                })(i)
                imageElements[i].onerror = (function(idx){
                    return function(){
                        loadedImage ++;
                        self.failedToLoadImages.push(photos[idx].id);
                        if(loadedImage === photos.length){
                            self.spinner.isVisible = false;
                            self.isFresh = false;
                            startRendering(photos, self.failedToLoadImages);
                        }
                    }
                })(i)
                var photo = photos[i];
                imageElements[i].src = photo.urlSmall;
            }
        }
        function removeSpoilPhotos(photos, spoilPhotoIds){
            for (var i  = 0; i < spoilPhotoIds.length; i ++){
                photos = _.reject(photos, function(item){
                    return item.id === spoilPhotoIds[i];
                });
            }
            return photos;
        }
        function reRender(){
			      if($rootScope.mobileAndTabletcheck && !($scope.options && $scope.options.bulkEditPhoto)) return;
            if(self.photos.length === 0 || self.spinner.isVisible) return;
            $scope.grid.reset();
            // render(self.photos);
            redraw();
        }
        function reRenderOrientationChange(){
            if($rootScope.mobileAndTabletcheck){
                $scope.grid.reset();
                redraw();
            }
        }
        function reset(){
            self.photos = [];
            $scope.grid.reset();
            self.firstPageNumber = -1;
        }
        function onFileRemoved(file, extraParams){
            self.photos = _.reject(self.photos, function(f){
                return f.id === file.id;
            });
            $scope.grid.reset();
            if(self.photos.length > 0){
                render(self.photos);
            } else {
                self.spinner.isVisible = false;
            }
            if($scope.gallery){
                gallerySvc.updateGalleryCover($scope.gallery);
            }
            if($scope.onFileRemoved){
                $scope.onFileRemoved({file: file, extraParams: extraParams});
            }

        }
        function onAddedOrRemovedFromGallery(file){
            if(!$scope.gallery) return;
            var isExisted = _.find(self.photos, function(it){return it.id === file.id});
            var isGalleryExisted = _.find(file.galleries, function(it){return it.id === $scope.gallery.id});
            if(isGalleryExisted && !isExisted){
                self.photos.push(file);
                $scope.grid.reset();
                if(self.photos.length > 0){
                    render(self.photos);
                } else {
                    self.spinner.isVisible = false;
                }
                if($scope.gallery && !$scope.gallery.cover_media ){
                    gallerySvc.updateGalleryCover($scope.gallery);
                }
            } else if(!isGalleryExisted && isExisted){
                onFileRemoved(file)
            }
        }
        function onPhotoPopupSaved(oldPhoto, newPhoto){
            if(oldPhoto.rotate_by !== newPhoto.rotate_by){
                oldPhoto.urlSmall = oldPhoto.urlSmall.split('?')[0] + "?" + new Date().getTime();
                reRender();
            }
            if($scope.onPhotoPopupSaved){
                $scope.onPhotoPopupSaved.apply(arguments);
            }
        }

        function getFlaggedUser() {
            if (mLoginnedUser && (mLoginnedUser.isAdminInternal || mLoginnedUser.isCurator)){

                self.isWorking = true;
                pixerfApiUserSvc.getFlaggedUser().$promise.then(function (data) {
                    self.flaggedUsers = data;
                }).catch(function (err) {
                    console.log(err);
                })
            }
		}
        function init(){
            getFlaggedUser();
        }

        init();
    }
})();

(function () {
  'use strict';

  angular
    .module('pixerf')
    .directive('photoGrid', photoGrid);
  photoGrid.$inject = ["$compile"];
  function photoGrid($compile) {

    var directive = {
      scope: {
          mission: '=',
          photos: "=",
          morePhotos : "=",
          hideNoMoreMessage: "=",
          spinner: "=",
          isNoMorePhotoToLoad: "=",
          user: "=",
          instance: "=?",
          gallery: "=",
          context: '=',
          idealHeight: '=',
          isIgnoreBodyScroll: '=',
          onScrollToPhoto: '&?',
          shuffle: '@',
          onLoadMorePage: '&',
          onPhotoClicked: '&?',
          onPhotoClickedCallback: '&?',
          simpleSelectMode: '=',
          overlayMode: '=',
          onBeforeRender: '&?',
          container: '@?',
		      onFileRemoved: '&?',
          onPhotoPopupSaved: '&',
          onPhotoPopupClosed: '&',
          onInit: '&?',
          options: '=?',
          onRemoveBtnClick: '&?',
          template: '=',
          height: '@',
          isPendingCommercialCustom: '@?'
      },
      transclude: true,
      restrict: 'E',
      templateUrl: 'app/components/photo-grid/photo-grid.html',
      controller: 'photoGridCtrl',
      controllerAs: 'vm',
      replace: true,
      link: function(scope, element, attrs, ctrl){
          function buildItemTemplate(){
              if(attrs.template){
                  return scope.template;
              }
              var str = '<photo ';
              if(attrs.onScrollToPhoto){
                str += 'scroll-spy-id="<%=scrollSpyId%>" is-first-spy-item="<%=isFirstPhoto%>" is-last-spy-item="<%=isLastPhoto%>" pixerf-scroll-spy="<%=onScrollTo%>" pixerf-scroll-spy-direction="<%=pixerfScrollSpyDirection%>"';
              }
              if(attrs.onPhotoClicked){
                str += ' on-photo-clicked="onPhotoClicked({file: file})"';
              }
              if(attrs.onPhotoClickedCallback){
                str += ' on-photo-clicked-callback="onPhotoClickedCallback({file: file})"';
              }
              if(attrs.simpleSelectMode){
                str += ' simple-select-mode="simpleSelectMode"';
              }
              if(attrs.overlayMode){
                str += ' overlay-mode="overlayMode"';
              }
              if(attrs.options){
                str += ' options="options"';
              }
              if(attrs.onRemoveBtnClick){
                str += ' on-remove-btn-click="onRemoveBtnClick({file: file})"';
              }
              if(attrs.onPhotoPopupClosed){
                str += ' on-photo-popup-closed="onPhotoPopupClosed({originalFile: originalFile , newFile: newFile})"';
              }
              str += ' context="context" on-added-or-removed-from-gallery="vm.onAddedOrRemovedFromGallery(file)" on-file-removed="vm.onFileRemoved(file)" gallery="gallery" file="vm.getFile(<%=id%>)" flagged-users="vm.flaggedUsers">';
              str += '</photo>';
              return str;
          }
          scope.grid = new PhotoGrid({
              idealHeight: ctrl.isMobile ? Math.max(150, parseInt(window.innerHeight / 4)) :  (scope.idealHeight ? scope.idealHeight : Math.max(350, parseInt(window.innerHeight / 3))),
              $container: $(element).find(".photo-grid__photos-container"),
              $parent: scope.container ? $(scope.container + " .photo-grid__photos-container") : $("body"),
              itemTmpl: buildItemTemplate(),
              height: scope.height,
              isIgnoreBodyScroll: scope.isIgnoreBodyScroll,
              events: {
                  beforeItemRendered: function(item, photo){
                       $compile(item)(scope);
                  }
              }
          });
          //notifiy grid initialize done
          if(attrs.onInit){
              scope.onInit({photoGrid: ctrl});
          }
      }
    };
    return directive;
  }

})();

// Generated by CoffeeScript 1.6.3
var linear_partition, min;

min = function(arr) {
  var computed, result, x, _i, _len;
  for (_i = 0, _len = arr.length; _i < _len; _i++) {
    x = arr[_i];
    computed = x[0];
    if (!result || computed < result.computed) {
      result = {
        value: x,
        computed: computed
      };
    }
  }
  return result.value;
};

linear_partition = function(seq, k) {
  var ans, i, j, m, n, solution, table, x, y, _i, _j, _k, _l;
  n = seq.length;
  if (k <= 0) {
    return [];
  }
  if (k > n) {
    return seq.map(function(x) {
      return [x];
    });
  }
  table = (function() {
    var _i, _results;
    _results = [];
    for (y = _i = 0; 0 <= n ? _i < n : _i > n; y = 0 <= n ? ++_i : --_i) {
      _results.push((function() {
        var _j, _results1;
        _results1 = [];
        for (x = _j = 0; 0 <= k ? _j < k : _j > k; x = 0 <= k ? ++_j : --_j) {
          _results1.push(0);
        }
        return _results1;
      })());
    }
    return _results;
  })();
  solution = (function() {
    var _i, _ref, _results;
    _results = [];
    for (y = _i = 0, _ref = n - 1; 0 <= _ref ? _i < _ref : _i > _ref; y = 0 <= _ref ? ++_i : --_i) {
      _results.push((function() {
        var _j, _ref1, _results1;
        _results1 = [];
        for (x = _j = 0, _ref1 = k - 1; 0 <= _ref1 ? _j < _ref1 : _j > _ref1; x = 0 <= _ref1 ? ++_j : --_j) {
          _results1.push(0);
        }
        return _results1;
      })());
    }
    return _results;
  })();
  for (i = _i = 0; 0 <= n ? _i < n : _i > n; i = 0 <= n ? ++_i : --_i) {
    table[i][0] = seq[i] + (i ? table[i - 1][0] : 0);
  }
  for (j = _j = 0; 0 <= k ? _j < k : _j > k; j = 0 <= k ? ++_j : --_j) {
    table[0][j] = seq[0];
  }
  for (i = _k = 1; 1 <= n ? _k < n : _k > n; i = 1 <= n ? ++_k : --_k) {
    for (j = _l = 1; 1 <= k ? _l < k : _l > k; j = 1 <= k ? ++_l : --_l) {
      m = min((function() {
        var _m, _results;
        _results = [];
        for (x = _m = 0; 0 <= i ? _m < i : _m > i; x = 0 <= i ? ++_m : --_m) {
          _results.push([Math.max(table[x][j - 1], table[i][0] - table[x][0]), x]);
        }
        return _results;
      })());
      table[i][j] = m[0];
      solution[i - 1][j - 1] = m[1];
    }
  }
  n = n - 1;
  k = k - 2;
  ans = [];
  while (k >= 0) {
    ans = [
      (function() {
        var _m, _ref, _ref1, _results;
        _results = [];
        for (i = _m = _ref = solution[n - 1][k] + 1, _ref1 = n + 1; _ref <= _ref1 ? _m < _ref1 : _m > _ref1; i = _ref <= _ref1 ? ++_m : --_m) {
          _results.push(seq[i]);
        }
        return _results;
      })()
    ].concat(ans);
    n = solution[n - 1][k];
    k = k - 1;
  }
  return [
    (function() {
      var _m, _ref, _results;
      _results = [];
      for (i = _m = 0, _ref = n + 1; 0 <= _ref ? _m < _ref : _m > _ref; i = 0 <= _ref ? ++_m : --_m) {
        _results.push(seq[i]);
      }
      return _results;
    })()
  ].concat(ans);
};

part = function (seq, k) {
  if (k <= 0) {
    return [];
  }
  while (k) {
    try {
      return linear_partition(seq, k--);
    } catch (_error) {}
  }
};
function PhotoGrid(options){
	var defaultOptions = {
		idealHeight: parseInt(window.innerHeight / 3),
		spacer: 2,
		itemClass: 'photo',
		itemTmpl: '<div></div>',
		$container: $('.photo-grid__photos-container'),
		isExcludeScrollBar: true,
		isIgnoreBodyScroll: false,
		$parent: $("body"),
		events: {}
	}
	this.options = $.extend(true,defaultOptions, options);
}
PhotoGrid.prototype = (function(){
	function getScrollBarWidth () {
		var $outer = $('<div>').css({visibility: 'hidden', width: 100, overflow: 'scroll'}).appendTo('body'),
			widthWithScroll = $('<div>').css({width: '100%'}).appendTo($outer).outerWidth();
		$outer.remove();
		return 100 - widthWithScroll;
	};
	var V_SCROLL_BAR_WIDTH = getScrollBarWidth();
	function createItem(imageInfo){
		var imgHtml = _.template(this.options.itemTmpl)(imageInfo);
		var $item = $(imgHtml);
		// $item.css("background-image", 'url(' + imageInfo.urlSmall + ')');
		$item.width(imageInfo.w);
		$item.height(imageInfo.h);
		$item.css("margin", this.options.spacer);
		$item.addClass(this.options.itemClass);
		return $item.get(0);
	}
	function isScrollBarVisible($elmt){
		if(this.options.$parent.is("body")){
			return $(document).height() > $(window).height();
		}
		return $elmt.get(0).scrollHeight > $elmt.get(0).clientHeight ;
	}
	function renderItem(photo, viewportWidth, summedRatios, rows){
		var imageInfo = {};
		var respect = rows < 1 ? 'height' : undefined;
		var dimension = calculateImageDimension.call(this, viewportWidth, this.options.idealHeight, summedRatios, photo.ar, respect);
		photo.w = dimension.w;
		photo.h = dimension.h;

		var elem =  createItem.call(this, photo);

		if(this.options.events.beforeItemRendered){
			this.options.events.beforeItemRendered(elem, photo);
		}
		this.options.$container.get(0).appendChild(elem);
	}
	function calculateImageDimension(viewportWidth, idealHeight, summedRatios, ar, respect){
		var dimension = {};
		if(respect === "height"){

			dimension.h = idealHeight;
			dimension.w = parseInt(idealHeight * ar - 2*this.options.spacer);
		} else {
			dimension.w = parseInt(viewportWidth/ summedRatios * ar - 2*this.options.spacer);
			dimension.h = parseInt(viewportWidth / summedRatios - 2*this.options.spacer);
		}
		return dimension;
		
	}
	function reset(){
		if(this.options.height){
			this.options.$container.css("height", "auto");
		}
		this.options.$container.empty();
		
	}
	function calculateViewportWidth(photos){
		var self = this;
		var padding = 0;
		try{
			var paddingLeft = self.options.$container.css("padding-left").split("px")[0];
			var paddingRight = self.options.$container.css("padding-right").split("px")[0];
	 		padding = (paddingLeft ? parseInt(paddingLeft) : 0) + (paddingRight ? parseInt(paddingRight) : 0);
		}catch(ex){
			padding = 0;
		}
		var viewportWidth = self.options.$container[0].getBoundingClientRect().width - padding;
		if(viewportWidth < 0 ) return;
		if(isScrollBarVisible.call(this, self.options.$container)){
			if($("body").css("over-flow") === "hidden"){
				return viewportWidth - V_SCROLL_BAR_WIDTH;
			}
			return viewportWidth ;
		}
		var summedRatios;
		var sumHeight = 0;
		var summed_width = photos.reduce((function(sum, p) {
	  		return sum += p.ar * self.options.idealHeight;
		}), 0);
		var rows = Math.round(summed_width / viewportWidth);

		summedRatios = photos.reduce((function(sum, p) {
	  		return sum += p.ar;
		}), 0);
		if(rows < 1){
			sumHeight = parseInt(viewportWidth / summedRatios - 2*this.options.spacer);
		} else{
			var weights = photos.map(function(p) {
				return parseInt(p.ar * 100);
			});
			var partition = part(weights, rows);

			var index = 0;
			var rowBuffer = [];
			var imageInfo = {};
			var rowHeight = 0;
			for (var i = 0; i < partition.length; i++) {
				rowBuffer = [];
				for (var j = 0; j<partition[i].length; j++) {
					rowBuffer.push(photos[index++])
				}
				summedRatios = rowBuffer.reduce((function(sum, p) {
					return sum += p.ar;
				}), 0);
				rowHeight = parseInt(viewportWidth / summedRatios - 2*this.options.spacer) + 2*this.options.spacer;
				sumHeight += rowHeight;
			}
		}
		this.options.$container.append('<div id="pixerf-photo-grid" style="height: ' +  sumHeight  +  'px">' + '</div>');
		if(this.options.height && photos.length > 0){
			this.options.$container.css("height", this.options.height);
		}
		if(isScrollBarVisible.call(this, this.options.$container)){
			$("#pixerf-photo-grid").remove();
			return viewportWidth - V_SCROLL_BAR_WIDTH;
		}
		$("#pixerf-photo-grid").remove();
		// setTimeout(function(){
		// })
		
		return viewportWidth ;
	}
	function generate(photos){
		var self = this;
		var viewportWidth = calculateViewportWidth.call(this, photos);
		var summedRatios;
		var summed_width = photos.reduce((function(sum, p) {
	  		return sum += p.ar * self.options.idealHeight;
		}), 0);
		var rows = Math.round(summed_width / viewportWidth);

		summedRatios = photos.reduce((function(sum, p) {
	  		return sum += p.ar;
		}), 0);
		if(rows < 1){
			// rows = 1;
			for (var i  = 0; i < photos.length; i ++){
				renderItem.call(this, photos[i], viewportWidth, summedRatios, rows);
			}
			return ;
		} 
		var weights = photos.map(function(p) {
			return parseInt(p.ar * 100);
		});
		var partition = part(weights, rows);

		var index = 0;
		var rowBuffer = [];
		var imageInfo = {};
		for (var i = 0; i < partition.length; i++) {
			rowBuffer = [];
			for (var j = 0; j<partition[i].length; j++) {
				rowBuffer.push(photos[index++])
			}
			summedRatios = rowBuffer.reduce((function(sum, p) {
		  		return sum += p.ar;
			}), 0);
			for (var k = 0; k<rowBuffer.length; k++) {
				var photo = rowBuffer[k];
				renderItem.call(this, photo,  viewportWidth, summedRatios, rows);
		  	}
		}
		// setTimeout(function(){
		// 	self.options.$container.css("min-height", '');
		// },0);
	}
	return {
		generate: generate,
		reset: reset
	}
})();
(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('photoExifInfoCtrl', photoExifInfoCtrl);

	photoExifInfoCtrl.$inject = ['$rootScope', '$scope', 'photoDetailSvc'];

	function photoExifInfoCtrl($rootScope, $scope, photoDetailSvc) {

		var self = this;
		self.buildPhotoReleaseInfo = photoDetailSvc.buildPhotoReleaseInfo;

		init();

		$scope.$on('builtCameraInfo', function () {
			init();
		});

		function init() {
			self.showInfoCamera = !!$scope.media.camera.cameraFormated || !!$scope.media.camera.lens_model || !!$scope.media.camera.takenInfo;
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('photoExifInfo', photoExifInfo);

	function photoExifInfo() {

		var directive = {
			scope: {
				"media": "="
			},
			restrict: 'E',
			templateUrl: 'app/components/photo-exif-info/photo-exif-info.html',
			controller: 'photoExifInfoCtrl',
			controllerAs: 'vm',
			replace: true
		};
		return directive;
	}
})();

/**
 * Controller for home module
 */
(function(){
  'use strict';
  angular
    .module('pixerf')
    .factory('photoDetailPopupSvc', photoDetailPopupSvc);
    photoDetailPopupSvc.$inject = ['pixerfApiMediaSvc', 'pixerfApiCategorySvc', '$uibModal', '$uibModalStack'];

    function photoDetailPopupSvc(pixerfApiMediaSvc, pixerfApiCategorySvc, $uibModal, $uibModalStack){
        
        var mIsPopupShowing = false;
        var mData = {
            photo: null
        }
        var mOriginalData = {
            photo: null
        }
        var mShouldScrollTop = {
            data: false
        }
        
        function isShouldScrollTop(){
            return mShouldScrollTop;
        }
        function setShouldSrollTop(value){
            mShouldScrollTop.data = value
        }
        function isPopupShowing(){
            return mIsPopupShowing;
        }
        function setPopupShowing(value){
            mIsPopupShowing = value;
        }
        function setData(data){
            mData.photo = $.extend(true, {}, data.photo);
            mOriginalData.photo = data.photo;
        }
        function getData(){
            if(!mData.photo) return mData;
            // mData.photo = buildPhotoDetail(mData.photo);
            return mData;
        }
        function getOriginalData(){
            return mOriginalData;
        }
        function showPopup(data) {
            setData(data);
            mIsPopupShowing = true;
            var uploadModal = $uibModal.open({
                size: 'full',
                templateUrl: 'app/components/photo-detail-popup/photo-detail-popup.html',
                controller: 'photoDetailPopupCtrl',
                controllerAs: 'vm',
                windowClass : 'modal-margin photo-detail-modal',
                resolve: {
                    data: function(){
                        return data;
                    }
                }
            });
            return uploadModal;
        }
        function updateUI(data){
            setData(data);
        }
        return {
            showPopup: showPopup,
            isPopupShowing: isPopupShowing,
            setPopupShowing: setPopupShowing,
            updateUI: updateUI,
            getData: getData,
            getOriginalData: getOriginalData,
            setShouldSrollTop: setShouldSrollTop,
            isShouldScrollTop: isShouldScrollTop,
        };
    }
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('photoDetailPopupCtrl', photoDetailPopupCtrl);

	photoDetailPopupCtrl.$inject = ['$scope', 'photoDetailPopupSvc', 'sessionManagerSvc', '$uibModalInstance', 'commonConst', '$timeout', 'data', 'photoDetailSvc', 'messageSvc', '$translate'];

	function photoDetailPopupCtrl($scope, photoDetailPopupSvc, sessionManagerSvc, $uibModalInstance, commonConst, $timeout, data, photoDetailSvc, messageSvc, $translate) {
		var self = this;
		self.photoViewer = {};
		self.context = data.context;
		self.closePopup = closePopup;
		self.onDeletePhotoBtnClicked = onDeletePhotoBtnClicked;
		self.loginnedUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.data = photoDetailPopupSvc.getData();
		self.originalData = photoDetailPopupSvc.getOriginalData();
		self.isEditing = {
			data: data.isEditing || false
		};
		self.onSaved = onSaved;
		self.shouldScrollTop = photoDetailPopupSvc.isShouldScrollTop();
		$scope.$on('modal.closing', closeConfirm);

		function onDeletePhotoBtnClicked(photo) {
			$timeout(function () {
				$uibModalInstance.close({
					'action': commonConst.ACTION.DELETE,
					'photo': photo
				}, 2000);
			})
		}

		function onSaved(savedPhoto) {
			if (data.onPhotoPopupSaved) {
				data.onPhotoPopupSaved({
					originalFile: self.originalData.photo,
					newFile: savedPhoto
				});
			}
			self.originalData.photo.title = savedPhoto.title;
			self.originalData.photo.tags = savedPhoto.tags;
			self.originalData.photo.galleries = savedPhoto.galleries;
			self.originalData.photo.categories = savedPhoto.categories;
			self.originalData.photo.price = savedPhoto.price;
			self.originalData.photo.license = savedPhoto.license;
			self.originalData.photo.description = savedPhoto.description;
			self.originalData.photo.location = savedPhoto.location;
			self.originalData.photo.has_model_property = savedPhoto.has_model_property;
			self.originalData.photo.releases = savedPhoto.releases;
			self.originalData.photo.is_releasable = savedPhoto.is_releasable;
			self.originalData.photo.status = savedPhoto.status;
			self.originalData.photo.state = savedPhoto.state;
			self.originalData.photo.rotate_by = savedPhoto.rotate_by;
			self.originalData.photo.user_selection = savedPhoto.user_selection;
		}

		function closePopup() {
			$uibModalInstance.close('close button click');
		}

		function updateInstanceUpdateField() {
			var fields = ["star_count", "is_liked", "is_starred", "state", "status"];
			for (var i = 0; i < fields.length; i++) {
				if (self.originalData.photo[fields[i]] !== self.data.photo[fields[i]]) {
					self.originalData.photo[fields[i]] = self.data.photo[fields[i]];
				}
			}
			if (self.originalData.photo && self.originalData.photo.mission && self.data.photo && self.data.photo.mission) {
				self.originalData.photo.mission.prizes_grouped = self.data.photo.mission.prizes_grouped;
			}
		}

		function closeConfirm(uploadPhotoClosingEvent, reason, closed) {
			if (reason === 'close button click' || reason === 'backdrop click') {
				uploadPhotoClosingEvent.preventDefault();
				if (photoDetailSvc.isEdited(self.originalData.photo, self.data.photo, self.photoViewer, self.isEditing.data)) {
					var modal = messageSvc.warnLeavingWithoutSaving();
					modal.result.then(function () {
						window.removeEventListener("beforeunload", beforeUnloadHandler);
						$uibModalInstance.dismiss();
						modal.close();
					})
				} else {
					$uibModalInstance.dismiss();
				}
			}
		}

		function beforeUnloadHandler(event) {
			var confirmationMessage = $translate.instant("are-you-sure");
			if (photoDetailSvc.isEdited(self.originalData.photo, self.data.photo, self.photoViewer, self.isEditing.data)) {
				event.returnValue = confirmationMessage; // Gecko, Trident, Chrome 34+
				return confirmationMessage;
			}
		}
		window.addEventListener("beforeunload", beforeUnloadHandler);
		$uibModalInstance.result.then(function () {
			window.removeEventListener("beforeunload", beforeUnloadHandler);
			updateInstanceUpdateField();
			photoDetailPopupSvc.setPopupShowing(false);
			photoDetailPopupSvc.setShouldSrollTop(false);
			if (data.onPhotoPopupClosed) {
				data.onPhotoPopupClosed({
					originalFile: self.originalData.photo,
					newFile: self.data.photo
				});
			}
		}, function () {
			window.removeEventListener("beforeunload", beforeUnloadHandler);
			updateInstanceUpdateField();
			photoDetailPopupSvc.setShouldSrollTop(false);
			photoDetailPopupSvc.setPopupShowing(false);
			if (data.onPhotoPopupClosed) {
				data.onPhotoPopupClosed({
					originalFile: self.originalData.photo,
					newFile: self.data.photo
				});
			}
		})
	}
})();

/**
 * Controller for home module
 */
(function(){
  'use strict';
  angular
    .module('pixerf')
    .factory('photoDetailSvc', photoDetailSvc);
    photoDetailSvc.$inject = ['stringUtils', 'tagUtils', 'numberUtils', 'arrayUtils', 'systemUtils', '$translate'];

    function photoDetailSvc(stringUtils, tagUtils, numberUtils, arrayUtils, systemUtils, $translate){
        
        var PHOTO_DETAIL_MOBILE_SCREEN =  768;
        function buildTakenInfo(cameraDetails){
            if(cameraDetails){
                if(cameraDetails.model && cameraDetails.model.indexOf(cameraDetails.make) === -1){
                    cameraDetails.cameraFormated = cameraDetails.make + " " + cameraDetails.model;
                } else {
                    cameraDetails.cameraFormated = cameraDetails.model;
                }
                cameraDetails.takenInfo = "";
                if(cameraDetails.focal_length){
                    cameraDetails.takenInfo += (' ' + stringUtils.buildString(numberUtils.fraction2Decimal(cameraDetails.focal_length)) + " mm");
                }
                if(cameraDetails.f_number){
                    cameraDetails.takenInfo += (' f/' + stringUtils.buildString(numberUtils.fraction2Decimal(cameraDetails.f_number)));
                }
                if(cameraDetails.exposure_time){
                    cameraDetails.takenInfo += (' ' + stringUtils.buildString(cameraDetails.exposure_time) + ' sec') ;
                }
                if(cameraDetails.iso){
                    cameraDetails.takenInfo += (' ISO ' + stringUtils.buildString(cameraDetails.iso));
                }
            }

        }
        function buildPhotoReleaseInfo(photo){
            if(photo.license === "editorial" || (photo.license === "commercial" && !photo.has_model_property)){
                return $translate.instant('no-release-required');
            } else if(photo.license === "commercial" && photo.has_model_property && photo.status === "approved"){
                return $translate.instant('model-property-released');
            } else if(photo.license === "commercial" && photo.has_model_property && photo.status !== "approved"){
                return $translate.instant("pending-approval");
            }
            return $translate.instant("no-release-information");
        }
        function buildPhotoDetail(photo){
            if(!photo) return photo;
            if(photo.tags && photo.tags.length > 0 && typeof photo.tags[0] !== 'object'){
                photo.tags = tagUtils.text2TagObject(photo.tags);
            }
            if(photo.location){
                photo.location = photo.location ? photo.location : $translate.instant('not-available');
            }
            if(photo.camera){
                photo.camera.imageCapturedDateFormated = photo.camera.date_taken ? moment(photo.camera.date_taken).format('DD MMMM YYYY') : $translate.instant('not-available');
                photo.createdAtFormated = photo.inserted_at ? moment(photo.inserted_at).format('DD MMMM YYYY') : $translate.instant('not-available');
                buildTakenInfo(photo.camera);
            }
            return photo;
        }
        function buildSocialShareContent(photo){
            return {'url': photo.path, 'description': photo.description, 'title': photo.title, 'media': photo.url };
        }
        function calculateSubTotal(photo){
            var subTotal = 0;
            for (var i = 0; i < photo.price.range.length; i ++){
                if(photo.price.range[i].isSelected){
                    subTotal += parseInt(photo.price.range[i].price);
                }
            }
            if(photo.extendedLicenses){
                for (var i = 0; i < photo.extendedLicenses.length; i ++){
                    if(photo.extendedLicenses[i].isSelected){
                        subTotal += parseInt(photo.extendedLicenses[i].price);
                    }
                }
            }
            return subTotal;
        }
        function isEdited(originalPhoto, editingPhoto, photoViewer, isEditing){
            if(!originalPhoto && !editingPhoto) return false;
            if(photoViewer && photoViewer.originRotateStep != photoViewer.rotateStep) return true;
            if(isEditing){
                return isPhotoDirty(originalPhoto, editingPhoto);
            }
            return false;
        }
        function isTagsEdited(originalPhoto, editingPhoto){
            editingPhoto.clarifai = editingPhoto.clarifai || [];
            if(!originalPhoto.tags || originalPhoto.tags.length === 0){
                return !arrayUtils.isEqual(editingPhoto.clarifai, editingPhoto.tags, "text", "text");
            }
            return !arrayUtils.isEqual(originalPhoto.tags, editingPhoto.tags, "text", "text");
        }
        function isPhotoDirty(originalPhoto, editingPhoto){
            return  !stringUtils.isEqual(originalPhoto.title, editingPhoto.title) ||
            isTagsEdited(originalPhoto, editingPhoto) ||
            originalPhoto.license != editingPhoto.license ||
            !stringUtils.isEqual(originalPhoto.description, editingPhoto.description) ||
            !stringUtils.isEqual(originalPhoto.location, editingPhoto.location) ||
            originalPhoto.has_model_property != editingPhoto.has_model_property ||
            !arrayUtils.isEqual(originalPhoto.releases, editingPhoto.releases, "id", "id") ||
            originalPhoto.rotate_by != editingPhoto.rotate_by ||
            !arrayUtils.isEqual(originalPhoto.galleries, editingPhoto.galleries, "id", "id") ||
            !arrayUtils.isEqual(originalPhoto.categories, editingPhoto.categories, "id", "id") ||
            (originalPhoto.price.id !== editingPhoto.price.id && originalPhoto.price.value !== editingPhoto.price.value);
        }
        var mOriginalPhoto = {
            data: null
        };
        var mPhoto = {
            data: null
        }
        function setOriginalPhoto(value) {
            mOriginalPhoto.data = value;
        }
        function getOriginalPhoto() {
            return mOriginalPhoto;
        }
        function setPhoto(value) {
            mPhoto.data = value;
        }
        function getPhoto() {
            return mPhoto;
        }
        function discardChanges(photo, originalPhoto){
            photo = originalPhoto;
            setPhoto(originalPhoto);
        }
        function reset(){
            setPhoto(null);
            setOriginalPhoto(null);
        }
        function buildPhotoKeyword(file, clarifai){
            file.tags = file.tags || [];
            file.suggestedKeywords = [];
            file.originalSuggestedKeywords = clarifai;
            var nNumberTags = file.tags.length;
            for(var i = 0; i < clarifai.length; i++){
                if(nNumberTags > 0){
                    var isExisted = _.find(file.tags, function(t){
                        return t.text === clarifai[i];
                    })
                    if(!isExisted){
                        file.suggestedKeywords.push(clarifai[i]);
                    }
                } else {
                    file.tags.push({text: clarifai[i]});
                }
                
            }
        }
        function isMobile(){
            return systemUtils.getViewportDimension().width  < PHOTO_DETAIL_MOBILE_SCREEN;
        }
		return {
            buildPhotoDetail: buildPhotoDetail,
            buildSocialShareContent: buildSocialShareContent,
            calculateSubTotal: calculateSubTotal,
            buildPhotoReleaseInfo: buildPhotoReleaseInfo,
            isPhotoDirty: isPhotoDirty,
            isEdited: isEdited,
            getOriginalPhoto: getOriginalPhoto,
            setOriginalPhoto: setOriginalPhoto,
            setPhoto: setPhoto,
            getPhoto: getPhoto,
            discardChanges: discardChanges,
            reset: reset,
            buildPhotoKeyword: buildPhotoKeyword,
            isMobile: isMobile
		};
    }
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('photoDetailCtrl', photoDetailCtrl);

	photoDetailCtrl.$inject = ['$state', 'photoSvc', 'editCartBtnSvc', 'gallerySvc', 'cartUtils', 'cartSvc', 'messageConst', 'pixerfApiUserSvc', 'uploadPhotoDetailSvc', 
		'photoDetailSvc', '$scope', 'sessionManagerSvc', 'pixerfApiMediaSvc', 'pixerfApiCategorySvc', 'toastr', '$timeout', 'fileUtils', '$uibModalStack', 
		'messageSvc', '$translate', 'translationSvc', '$rootScope', 'pixerfApiDownloadSvc', '$http', 'addToCartBtnSvc', 'store', 'accountConst', 'pixerfApiClarifaiSvc'];

	function photoDetailCtrl($state, photoSvc, editCartBtnSvc, gallerySvc, cartUtils, cartSvc, messageConst, pixerfApiUserSvc, uploadPhotoDetailSvc, 
			photoDetailSvc, $scope, sessionManagerSvc, pixerfApiMediaSvc, pixerfApiCategorySvc, toastr, $timeout, fileUtils, $uibModalStack, 
			messageSvc, $translate, translationSvc, $rootScope, pixerfApiDownloadSvc, $http, addToCartBtnSvc, store, accountConst, pixerfApiClarifaiSvc) {
		var self = this;
		self.originalPhoto = photoDetailSvc.getOriginalPhoto();
		self.onSaveChangesBtnClicked = onSaveChangesBtnClicked;
		self.onNominateBtnClicked = onNominateBtnClicked;
		self.onEditBtnClicked = onEditBtnClicked;
		self.loginnedUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.formError = null;
		self.isSaving = false;
		self.socialShareContent = photoDetailSvc.buildSocialShareContent($scope.photo);
		self.onCancelPhotoBtnClicked = onCancelPhotoBtnClicked;
		self.photoGrid = null;
		self.onPhotoGridInit = onPhotoGridInit;
		self.callToActionMesages = [];
		self.onGalleryItemClicked = onGalleryItemClicked;
		self.formatLicenseString = formatLicenseString;
		self.privateToolTip = "You haven't set price for this photo. Without prices, your photos won't be discoverable on the Marketplace.";
		self.onVariantSelected = onVariantSelected;
		self.onAddedToCart = onAddedToCart;
		self.onTagClicked = onTagClicked;
		self.onPhotoRotated = onPhotoRotated;
		self.onDownloadComp = onDownloadComp;
		self.cartItem = {};
		self.cart = cartSvc.getCart();
		self.isWorking = false;
		self.context = $scope.context;
		self.categories = {
			data: []
		};
		self.showAddToCart = !($scope.photo.type === 'portfolio' || $scope.photo.type === 5 || $scope.photo.isMine || $scope.photo.in_mission);
        self.onAddToCartBtnClicked = onAddToCartBtnClicked;
        self.isAddedToCart = cartSvc.getCartItemByMediaId(self.cart.data, $scope.photo.id) ? true: false;
		self.showShareBtn = (!self.loginnedUser || (self.loginnedUser && !self.loginnedUser.isBiz));

		init();
		getCategories();
		buildToolTipsText();

		self.onItemImageLoadHandler = {
			sucess: function (element) {
				var $img = $(".content-wrapper").find("img");
				self.originalPhotoDemission = {
					width: $img.width(),
					height: $img.height(),
				};
				overlayScale(self.originalPhotoDemission.width, self.originalPhotoDemission.height);
			}
		}

		$scope.$watchCollection("vm.cart.data.cart_items", function (newValue) {
			var foundItem = _.find(newValue, function (item) {
				return item.media.id === self.cartItem.media.id;
			})
			if (!foundItem) {
				delete self.cartItem.id;
			} else {
				self.cartItem.id = foundItem.id;
			}
		})

		function onTagClicked(tag) {
			var param = {};
			if (tag) {
				$uibModalStack.dismissAll("link clicked");
				$timeout(function () {
					param.keywords = '' + tag.text;
					param.type = 'images';
					$state.go('buy-stock-page.search-result-page', param);
				})
			}
		}

		function buildToolTipsText() {
			if (self.loginnedUser) {
				if (self.loginnedUser.stats.daily_nomination_balance === 1) {
					self.tooltips = {
						nomination: $translate.instant('have-one-nomination-remaning')
					}
				} else {
					self.tooltips = {
						nomination: $translate.instant('have-more-nominations-remaning', {
							number: self.loginnedUser.stats.daily_nomination_balance
						})
					}
				}
			}

			if ($scope.photo.is_nominated) {
				self.tooltips.nomination = $translate.instant('you-have-nominated') + '<br/>' + self.tooltips.nomination;
			}
		}

		function getCategories() {
			pixerfApiCategorySvc.get(function (response) {
				self.categories.data = response;
			}, function () {
				toastr.error($translate.instant('failed-to-get-categories'));
			});
		}

		function fetchPhotos(isRefresh) {
			self.photoGrid.fetchPhotos({
				mediaid: $scope.photo.id,
				action: 'more'
			}, isRefresh);
		}

		function onCancelPhotoBtnClicked() {
			setPhoto(self.originalPhoto.data);
			$scope.isEditMode.data = false;
		}

		function onGalleryItemClicked(file, gallery) {
			self.isSaving = true;
			var action = gallery.isSelected ? "addPhotoToGallery" : "removePhotoToGallery";
			photoSvc[action](file, gallery).then(function (response) {
				gallerySvc.updateGalleryCover(gallery);
				var message = messageSvc.compile(messageConst.success.PHOTO_GALLERY_ADDED_REMOVED, {
					action: action,
					gallery_name: gallery.title
				});
				toastr.success(message);
				photoDetailSvc.setOriginalPhoto($.extend(true, {}, $scope.photo));
				$timeout(function () {
					self.isSaving = false;
					$scope.onSaved({
						savedPhoto: $scope.photo
					});
				}, 2000);
			}, function () {
				self.isSaving = false;
			})
		}

		function onPhotoRotated() {
			$scope.onSaved({
				savedPhoto: $scope.photo
			});
		}

		function onDownloadComp(item) {
			if (self.isWorking) {
				return;
			}
			self.isWorking = true;
			pixerfApiDownloadSvc.record_biz_download({}, {
				media_id: item.id
			}).$promise.then(function () {
				self.isWorking = false;
				var urlImage = item.thumbnails['w/866x'].replace("http", "https");
				return $http.get(urlImage, {
					responseType: 'blob'
				});
			}).then(function (response) {
				self.isWorking = false;
				var getFile = item.filename.split(".");
				var filename = item.user.displayName + "-" + item.id + "-" + item.license + "-license." + getFile[1];
				saveAs(response.data, filename);
			}).catch(function () {
				self.isWorking = false;
			})
		}

		function updatePhoto() {
			return pixerfApiMediaSvc.update({
				id: $scope.photo.id
			}, fileUtils.buildSavedFileObject($scope.photo)).$promise;
		}

		function overlayScale(width, height) {
			var $overlay = $(".photo-detail__overlay");
			$overlay.width(width);
			$overlay.height(height);
			self.isWorking = false;
		}

		function onSaveChangesBtnClicked() {
			self.isFormDirty = true;
			if (self.formError) {
				toastr.error(self.formError);
				return false;
			}
			var errorMsg = uploadPhotoDetailSvc.validate([$scope.photo]);

			if (errorMsg) {
				//self.pixerfAlert.error(errorMsg);
				toastr.error(errorMsg);
				return false;
			}
			self.isSaving = true;
			updatePhoto().then(function (response) {
				photoDetailSvc.setOriginalPhoto($.extend(true, {}, $scope.photo));
				$timeout(function () {
					self.isSaving = false;
					$scope.photo.location = response.location;
					$scope.photo.is_releasable = response.is_releasable;
					$scope.photo.status = response.status;
					$scope.isEditMode.data = false;
					self.socialShareContent = photoDetailSvc.buildSocialShareContent($scope.photo);
					self.callToActionMesages = uploadPhotoDetailSvc.buildCallToActionMessages($scope.photo);
					$scope.onSaved({
						savedPhoto: $scope.photo
					});
					toastr.success("This photo has been successfully updated!");
					updateUI($scope.photo, $scope.photo);
				}, 2000);
			}, function (response) {
				self.isSaving = false;
				var msg = translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true);
				if (response.data.errors && response.data.errors.length > 0) {
					var mappedMessage = messageConst.error[response.data.errors[0]];
					if (mappedMessage) {
						msg = mappedMessage;
					}
				}
				toastr.error(msg);
			})
		}

		function getFollowingStatus(photo) {
			pixerfApiUserSvc.isFollowed({
				id: photo.user.id
			}).$promise.then(function (response) {
				photo.user.is_followed = response.data
			}, function () {

			})
		}

		function setSelectedVariant(photo, cartItem) {
			if (cartItem) {
				self.cartItem = cartItem;
				self.cartItem.media.data = photo;
			} else {
				self.cartItem = {
					media: {
						id: photo.id,
						price: $.extend(true, {}, photo.price),
						data: photo
					}
				};
				self.cartItem.sub_total = 0;
				cartUtils.updateCartSelectedVariant(self.cartItem, {})
			}
		}

		function onPhotoGridInit(photoGridIntance) {
			self.photoGrid = photoGridIntance;
			if (self.photoGrid) {
				fetchPhotos(true);
			}
		}

		function updateUI(newValue, oldValue) {
			if (!$scope.photo) return;
			if (!oldValue) return;
			var isRefresh = true;

			var cartItem = cartSvc.getCartItemByMediaId(self.cart.data, newValue.id);
			setSelectedVariant(newValue, cartItem);

			photoDetailSvc.setPhoto($scope.photo);
			photoDetailSvc.setOriginalPhoto($.extend(true, {}, newValue));
			photoDetailSvc.buildPhotoDetail($scope.photo);
			$rootScope.$broadcast('builtCameraInfo');
			self.callToActionMesages = uploadPhotoDetailSvc.buildCallToActionMessages($scope.photo);
			if (!$scope.photo.isMine && self.loginnedUser) {
				getFollowingStatus($scope.photo);
			}
			if (self.photoGrid) {
				fetchPhotos(isRefresh);
			}
		}

		function init() {
			$scope.$watch("photo", function (newValue, oldValue) {
				updateUI(newValue, oldValue);
			})
			if ($scope.photo && $scope.photo.participation) {
				self.context += "-" + $scope.photo.participation.id;
			}
		}

		function onNominateBtnClicked() {
			if (self.loginnedUser.stats.daily_nomination_balance <= 0 || $scope.photo.isNominating || $scope.photo.is_nominated) {
				return;
			}
			$scope.photo.isNominating = true;
			pixerfApiMediaSvc.nominate({
				id: $scope.photo.id
			}).$promise.then(function (response) {
				self.loginnedUser = sessionManagerSvc.getCurrentLoginUser().data;
				delete $scope.photo.isNominating;
				$scope.photo.is_nominated = true;
				$scope.photo.nomination_count++;
				self.loginnedUser.stats.daily_nomination_balance--;
				sessionManagerSvc.setCurrentLoginUser(self.loginnedUser);
				buildToolTipsText();
			}, function (response) {
				delete $scope.photo.isNominating;
				if (response.data && response.data.message) {
					toastr.error(response.data.message);
				} else {

					toastr.error("Failed to nominate photo!");
				}
			})
		}

		function formatLicenseString(license) {
			if (!license) return 'Editorial';
			return license.charAt(0).toUpperCase() + license.substr(1);
		}

		function onVariantSelected(evt, price) {
			self.cartItem.sub_total = photoDetailSvc.calculateSubTotal(self.cartItem.media);

			if (self.cartItem.id && evt) {
				editCartBtnSvc.editCartItem(self.cartItem).then(function () {
					self.isCartItemDisabled = false;
				}, function () {
					self.isCartItemDisabled = false;
				});
			}
		}

		function onAddedToCart(addedCartItem) {
			self.cartItem.id = addedCartItem.id;
		}

		function setPhoto(value) {
			$scope.photo = value;
			photoDetailSvc.setPhoto(value);
		}
		
		function onEditBtnClicked() {
			$scope.isEditMode.data = !$scope.isEditMode.data;
			photoDetailSvc.setOriginalPhoto($.extend(true, {}, $scope.photo));
			if (!$scope.photo.clarifai || ($scope.photo.clarifai && $scope.photo.clarifai.length === 0)) {
				if (self.isLoadingClarifai) return;
				self.isLoadingClarifai = true;
				
				pixerfApiClarifaiSvc.genKeywordsPhoto($scope.photo.thumbnails['x400'], 'url').then(function (response) {
					$scope.photo.clarifai = _.map(response.data.outputs[0].data.concepts, function (result) { return result.name });
					photoDetailSvc.buildPhotoKeyword($scope.photo, $scope.photo.clarifai);
					self.isLoadingClarifai = false;
				}).catch(function(){
					self.isLoadingClarifai = false;
				});
			} else {
				photoDetailSvc.buildPhotoKeyword($scope.photo, $scope.photo.clarifai);
			}
		}
		function onAddToCartBtnClicked(media){
			if(self.isWorking || self.isAddedToCart) return;
            self.isWorking = true;

			(self.loginnedUser) ? onAddToCartForLoggedUser(media) :  onAddToCartForGuestUser(media);
		}
		function onAddToCartForLoggedUser(media){
            var savedCartItemData = addToCartBtnSvc.buildSavedCartItem(media);
            console.log(savedCartItemData);
            var errMsg = addToCartBtnSvc.validate(savedCartItemData);
            if(errMsg){
                toastr.error(errMsg)
            };

            var action = "addItemToCart";
            cartSvc[action](savedCartItemData).then(function(response){
                self.isWorking = false;
                self.isAddedToCart = true;
                var addedCartItem = cartSvc.getCartItemByMediaId(response.data, media.id);
                self.cartItem.id = addedCartItem.id
            }).catch(function(err){
                self.isWorking = false;
                var message = translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true);
                if(err.data && err.data.message === "MEDIA_IN_MISSION"){
                    message = messageSvc.compile(messageConst.error.MISSION_CART, {photo_name: ": " + media.data.title , quantity: 1});
                    media.data.in_mission = true;
                }
                toastr.error(message);
            });
        }

		function onAddToCartForGuestUser(media) {
            var guestUserToken = store.get(accountConst.TOKEN.GUEST_USER_TOKEN);
            if(guestUserToken){
                processAddToCard(guestUserToken, media);
            }else{
                cartSvc.generateUUID(10, processAddToCard, media);
            }

            function processAddToCard(uuid, media) {
                if( !store.get(accountConst.TOKEN.GUEST_USER_TOKEN)){
                    store.set(accountConst.TOKEN.GUEST_USER_TOKEN, uuid);
                }
                
                var savedCartItemData = addToCartBtnSvc.buildSavedCartItem(media);
                console.log(savedCartItemData);
                var errMsg = addToCartBtnSvc.validate(savedCartItemData);
                if (errMsg) toastr(errMsg);

                var action = "addItemToCart";
                cartSvc[action](savedCartItemData, uuid).then(function (response) {
                    self.isWorking = false;
                    self.isAddedToCart = true;
                    var addedCartItem = cartSvc.getCartItemByMediaId(response.data, media.id);
                    self.cartItem.id = addedCartItem.id
                }).catch(function (err) {
                    self.isWorking = false;
                    var message = translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true);
                    if (err.data && err.data.message === "MEDIA_IN_MISSION") {
                        message = messageSvc.compile(messageConst.error.MISSION_CART, { photo_name: ": " + media.data.title, quantity: 1 });
                        media.data.in_mission = true;
                    }
                    toastr.error(message);
                });
            }
        }
	}
})();

(function () {
  'use strict';

  angular
    .module('pixerf')
    .directive('photoDetail', photoDetail);
  photoDetail.$inject = ['systemUtils', 'photoDetailSvc']
  function photoDetail(systemUtils, photoDetailSvc) {

    var directive = {
      scope: {
          'onPhotoDeleted' :'&',
          'photo': '=',
          'context': '=',
          'onSaved' : '&',
          'nextPhoto': '=',
          'prevPhoto': '=',
          'alert': "=",
          "isEditMode": "=",
          "photoViewer": "="
      },
      restrict: 'E',
      templateUrl: 'app/components/photo-detail/photo-detail.html',
      controller: 'photoDetailCtrl',
      controllerAs: 'vm',
      replace: true,
      link: function($scope, $element){
        $scope.isMobile = photoDetailSvc.isMobile();
      }
    };
    return directive;
  }

})();

(function () {
  'use strict';
  angular
    .module('pixerf')
    .factory('photoSvc', photoSvc);

  photoSvc.$inject = ['pixerfApiMediaSvc', '$q', 'toastr', 'dateUtils', 'translationSvc', 'pixerfApiMissionSvc'];

  function photoSvc(pixerfApiMediaSvc, $q, toastr, dateUtils, translationSvc, pixerfApiMissionSvc) {
    function updateFileGalleriesInfo(file, gallery) {
      if (!file.galleries) {
        file.galleries = [];
      }
      if (gallery.isSelected) {
        file.galleries.push(gallery);
      } else {
        file.galleries = _.reject(file.galleries, function (gal) {
          return gal.id === gallery.id;
        })
      }
    }
    function isUploadedThisWeek(photo) {
      return dateUtils.isInWeek(photo.inserted_at);
    }
    function addPhotoToGallery(file, gallery) {
      var def = $q.defer();
      pixerfApiMediaSvc.add_to_gallery({
        id: file.id,
        gallery_id: gallery.id
      }, {}).$promise.then(function () {
        def.resolve();
        updateFileGalleriesInfo(file, gallery);
      }, function (err) {
        gallery.isSelected = !gallery.isSelected;
        def.reject(err);
        if (err.data.message) {
          toastr.error(err.data.message);
        } else {
          toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
        }
      });
      return def.promise;

    }
    function removePhotoToGallery(file, gallery) {
      var def = $q.defer();
      pixerfApiMediaSvc.remove_from_gallery({
        id: file.id,
        gallery_id: gallery.id
      }, {}).$promise.then(function () {
        def.resolve();
        updateFileGalleriesInfo(file, gallery);
      }, function () {
        gallery.isSelected = !gallery.isSelected;
        def.reject();
      });
      return def.promise;
    }
    function likePhoto(file) {
      var action = file.is_liked ? 'delete' : 'save';
      return pixerfApiMediaSvc[action]({ id: file.id, action: 'likes' }, {}).$promise;
    }
    function transitState(file, state, reason, rejectionTimes, missionId) {
      var params = {
        'state': state,
        'reason': reason
      };
      if(rejectionTimes){
        params.rejected_at = moment().unix();
      }
      if(file.in_mission && missionId){
        params.mission_id = missionId || file.mission_id;
      }
      return pixerfApiMediaSvc.update({ id: file.id, action: 'state' }, params).$promise;
    }

    function curationMission(action, reason, rejectionTimes, missionId, participationsId){
      var params = {
        'action': action
      };
      if(reason){
        params.reason = reason;
      }
      if(rejectionTimes){
        params.rejected_at = moment().unix();
      }
      return pixerfApiMissionSvc.curation_mission({ mission_id: missionId, participations_id: participationsId }, params).$promise;
    }

    function updatePhotoInfo(photo, override) {
      var defer = $q.defer();
      pixerfApiMediaSvc.get({ id: photo.id }).$promise.then(function (response) {
        for (var key in response.data) {
          photo[key] = response.data[key];
        }
        defer.resolve();
      }, function (err) {
        if (err.status === 404) {
          toastr.error("Sorry, we cannot find this photo. It may not exist any more.");
        } else {
          toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('FAILED_PHOTO_DETAILS', false, true));
        }
        defer.reject();
      })
      return defer.promise;
    }
    return {
      addPhotoToGallery: addPhotoToGallery,
      removePhotoToGallery: removePhotoToGallery,
      likePhoto: likePhoto,
      transitState: transitState,
      curationMission: curationMission,
      updatePhotoInfo: updatePhotoInfo,
      updateFileGalleriesInfo: updateFileGalleriesInfo,
      isUploadedThisWeek: isUploadedThisWeek
    };
  }
})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('photoCtrl', photoCtrl);

    photoCtrl.$inject = ['messageConst', 'gallerySvc', 'photoDetailSvc','$scope', 'photoSvc', 'toastr', 'pixerfApiGallerySvc', 'pixerfConfirmPopupSvc', 'sessionManagerSvc', 'photoDetailPopupSvc', 
        'commonConst', '$state', 'messageSvc', 'translationSvc', 'pixerfApiMediaSvc', '$translate', 'addToCartBtnSvc', 'cartSvc', 'popoverCartSvc', 'store', 'cartUtils', 'accountConst'];

    function photoCtrl(messageConst, gallerySvc, photoDetailSvc, scope, photoSvc, toastr, pixerfApiGallerySvc, pixerfConfirmPopupSvc, sessionManagerSvc, photoDetailPopupSvc, 
            commonConst, $state, messageSvc, translationSvc, pixerfApiMediaSvc, $translate, addToCartBtnSvc, cartSvc, popoverCartSvc, store, cartUtils, accountConst ) {
        var self = this;
        self.displaySize = scope.displaySize ? scope.displaySize : 'urlSmall';
        self.imageUrl = '"' + scope.file.thumbnails['x400'] + '"';
        self.onGalleryItemClicked = onGalleryItemClicked;
        self.likePhotoBtnClick = likePhotoBtnClick;
        self.setPhotoAsCover = setPhotoAsCover;
        self.removePhotoFromGallery = removePhotoFromGallery;
        self.isLogined =  !!sessionManagerSvc.getCurrentLoginUser().data;
        self.loginUser = sessionManagerSvc.getCurrentLoginUser().data;
        self.guestUser = self.loginUser && !self.loginUser.account_type;
        self.adminInternal = self.loginUser && (self.loginUser.isAdminInternal || self.loginUser.isCurator);
        self.onPhotoClicked = onPhotoClicked;
        self.socialShareContent = scope.file ? photoDetailSvc.buildSocialShareContent(scope.file) : {};
        self.clickOutSide = clickOutSide;
        self.isPortfolioPhoto = (scope.file.type === 'portfolio' || scope.file.type === 5);
        self.onDeletePhoto = onDeletePhoto;
        self.isDeletedPhoto = false;
        self.showAddToCart =  !(scope.file.type === 'portfolio' || scope.file.type === 5 || scope.file.isMine || scope.file.in_mission);
        self.onAddToCartBtnClicked = onAddToCartBtnClicked;
        self.cart = cartSvc.getCart();
        self.isAddedToCart = cartSvc.getCartItemByMediaId(self.cart.data, scope.file.id) ? true: false;
        self.isFlaggedUser = isFlaggedUser;
        self.isBulkEditPhotoSelected = isBulkEditPhotoSelected;
        self.isBulkEditPhoto = scope.options && scope.options.bulkEditPhoto || false;
		self.bulkSelectedPhoto = scope.options && scope.options.bulkSelectedPhoto || [];
        self.photoStateBtnOptions = {isRejectedState: (scope.options ? scope.options.isRejectedState : null)};

        function isBulkEditPhotoSelected(id){
            if(!self.isBulkEditPhoto) return false;
            var result = false;
            for( var i = 0; i < self.bulkSelectedPhoto.length; i++){
                if(self.bulkSelectedPhoto[i].id == scope.file.id){
                    result = true;
                }
            }
            self.isBulkEditPhotoSelectedItem = result;
            return result;
        }

        function isFlaggedUser(){
            var result = false;

            if( !self.adminInternal || !(scope.flaggedUsers && scope.flaggedUsers.length) || !scope || !scope.file || !scope.file.user){
                return result;
            }
            var flaggedUserIds = _.pluck(scope.flaggedUsers, "id");
            result = _.contains(flaggedUserIds, scope.file.user.id);
            return result;
        }

        function onGalleryItemClicked(file, gallery){
            if(!file) return;
            self.isSaving = true;
            var action = gallery.isSelected ? "addPhotoToGallery" : "removePhotoToGallery";
            photoSvc[action](file, gallery).then(function(response){
                var message = messageSvc.compile(messageConst.success.PHOTO_GALLERY_ADDED_REMOVED, {action: action , gallery_name: gallery.title});
                toastr.success(message);
                gallerySvc.updateGalleryCover(gallery);
            }, function(){
                toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
            })
        }

        function clickOutSide($event){
            $("body").trigger("click");
            $event.stopPropagation();
        }
        function likePhotoBtnClick(file){
            if(file.isLiking) return ;
            file.isLiking = true;
            photoSvc.likePhoto(file).then(function(response){
                delete file.isLiking;
                file.is_liked = !file.is_liked;
            }, function(){
                delete file.isLiking;
                toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
            })
        }
        function setPhotoAsCover(){
            var originalCoverImage;
            if(!scope.gallery.cover_media){
                originalCoverImage = scope.gallery.cover_image;
            } else{
                originalCoverImage = scope.gallery.cover_media.handle;
            }
            scope.gallery.cover_media_id = scope.file.id;
            pixerfApiGallerySvc.put({
                id: scope.gallery.id,
            }, scope.gallery).$promise.then(function(response){
                scope.gallery.coverImagePath = response.data.coverImagePath;
                toastr.success("This photo has been set as cover of gallery");
            }, function(err){
                console.log(err)
                scope.gallery.cover_media.handle = originalCoverImage; //rollback if failure
                toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
            })
        }
        function removePhotoFromGallery(file, gallery){
            var modal = pixerfConfirmPopupSvc.showPopup({message: 'Hi, This photo will be removed from this gallery.'});
            modal.result.then(function(){
                photoSvc.removePhotoToGallery(file, gallery).then(function(){
                    file.galleries = _.reject(file.galleries, function(gl){
                        return gl.id === gallery.id;
                    })
                    scope.onFileRemoved({file: file});
                }, function(){
                    toastr.error("Cannot "  + (isRemove ? 'remove' : 'add') +  " this photo to gallery. Please try again.");
                })
            }, function(){
                //do nothing
            })
        }

        function onDeletePhoto(){
            var message = translationSvc.ARE_YOU_SURE_TO_DO_SOMETHING("DELETE_THIS_PHOTO");
			var modal = pixerfConfirmPopupSvc.showPopup({
				hideTitle: true,
				hideConfirmText: true,
				message: message
			});
            
            modal.result.then(function () {
                pixerfApiMediaSvc.delete({
                    id: scope.file.id
                }).$promise.then(function success (res) {
                    // scope.onFileRemoved({file: scope.file});
                    self.isDeletedPhoto = true;
                    toastr.success($translate.instant("successfully-deleted"));
                },
                function error(err){
                    var errMsg = $translate.instant("failed-delete-photo");
                    toastr.error(errMsg);
                })
            })
        }

        function setSelectedVariant(photo, cartItem) {
			if (cartItem) {
				self.cartItem = cartItem;
				self.cartItem.media.data = photo;
			} else {
				self.cartItem = {
					media: {
						id: photo.id,
						price: $.extend(true, {}, photo.price),
						data: photo
					}
				};
				self.cartItem.sub_total = 0;
				cartUtils.updateCartSelectedVariant(self.cartItem, {})
			}
		}

        function onAddToCartBtnClicked(media){
            if(self.isWorking || self.isAddedToCart) return;
            self.isWorking = true;

            photoSvc.updatePhotoInfo(media).then(function(){
                self.isWorking = false;
                var cartItem = cartSvc.getCartItemByMediaId(self.cart.data, media.id);
                setSelectedVariant(media, cartItem);
                (self.loginUser) ? onAddToCartForLoggedUser(media) :  onAddToCartForGuestUser(media);

            }, function(){
                self.isWorking = false;
            });
		}

        function onAddToCartForLoggedUser(media){
            var savedCartItemData = addToCartBtnSvc.buildSavedCartItem(media, true);
            console.log(savedCartItemData);
            var errMsg = addToCartBtnSvc.validate(savedCartItemData);
            if(errMsg){
                toastr.error(errMsg)
            };

            var action = "addItemToCart";
            cartSvc[action](savedCartItemData).then(function(response){
                self.isWorking = false;
                self.isAddedToCart = true;
                var addedCartItem = cartSvc.getCartItemByMediaId(response.data, media.id);
                self.cartItem.id = addedCartItem.id
            }).catch(function(err){
                self.isWorking = false;
                var message = translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true);
                if(err.data && err.data.message === "MEDIA_IN_MISSION"){
                    message = messageSvc.compile(messageConst.error.MISSION_CART, {photo_name: ": " + media.data.title , quantity: 1});
                    media.data.in_mission = true;
                }
                toastr.error(message);
            });
        }

		function onAddToCartForGuestUser(media) {
            var guestUserToken = store.get(accountConst.TOKEN.GUEST_USER_TOKEN);
            if(guestUserToken){
                processAddToCard(guestUserToken, media);
            }else{
                cartSvc.generateUUID(10, processAddToCard, media);
            }

            function processAddToCard(uuid, media) {
                if( !store.get(accountConst.TOKEN.GUEST_USER_TOKEN)){
                    store.set(accountConst.TOKEN.GUEST_USER_TOKEN, uuid);
                }
                
                var savedCartItemData = addToCartBtnSvc.buildSavedCartItem(media, true);
                console.log(savedCartItemData);
                var errMsg = addToCartBtnSvc.validate(savedCartItemData);
                if (errMsg) toastr(errMsg);

                var action = "addItemToCart";
                cartSvc[action](savedCartItemData, uuid).then(function (response) {
                    self.isWorking = false;
                    self.isAddedToCart = true;
                    var addedCartItem = cartSvc.getCartItemByMediaId(response.data, media.id);
                    self.cartItem.id = addedCartItem.id
                }).catch(function (err) {
                    self.isWorking = false;
                    var message = translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true);
                    if (err.data && err.data.message === "MEDIA_IN_MISSION") {
                        message = messageSvc.compile(messageConst.error.MISSION_CART, { photo_name: ": " + media.data.title, quantity: 1 });
                        media.data.in_mission = true;
                    }
                    toastr.error(message);
                });
            }
        }
        function removeFileFromBulkEditPhotoList(fileId){
			var index = -1;
			for( var i = 0; i < self.bulkSelectedPhoto.length; i++){
				if(self.bulkSelectedPhoto[i].id == scope.file.id){
					index = i;
				}
			}

			if(index >= 0){
				self.bulkSelectedPhoto.splice(index, 1);
			}
		}
        function onPhotoClicked(file){
            if(self.isBulkEditPhoto){
				if(self.isBulkEditPhotoSelected()){
					removeFileFromBulkEditPhotoList(file.id)
				}else{
					self.bulkSelectedPhoto.push(file);
				}
                if(scope.options && scope.options.onBulkEditChanged){
                    scope.options.onBulkEditChanged(self.bulkSelectedPhoto);
                }
				return;
			}

           if(self.isWorking || file.type === 'portfolio' || file.type === 5) {
               return false;
           };
           self.isWorking = true;
           if(angular.isDefined(scope.onPhotoClicked)){
               scope.onPhotoClicked({file: scope.file});
               self.isWorking = false;
           } else {
                photoSvc.updatePhotoInfo(scope.file).then(function(){
                    self.isWorking = false;
                    if(scope.context === "photo-page"){
                        $state.go("photo", {id: scope.file.id});
                    } else{
                        photoDetailPopupSvc.setShouldSrollTop(new Date().getTime());
                        if(photoDetailPopupSvc.isPopupShowing()){
                            photoDetailPopupSvc.updateUI({
                                photo: scope.file
                            });

                        } else {
                            var modal = photoDetailPopupSvc.showPopup({
                                photo: scope.file,
                                onPhotoPopupSaved: scope.onPhotoPopupSaved,
                                onPhotoPopupClosed: scope.onPhotoPopupClosed
                            });
                            modal.result.then(function(response){
                                self.isAddedToCart = cartSvc.getCartItemByMediaId(self.cart.data, scope.file.id) ? true: false;
                                if(response.action === commonConst.ACTION.DELETE){
                                    scope.onFileRemoved({file: response.photo});
                                } else{
                                    scope.onAddedOrRemovedFromGallery({file: scope.file});
                                }
                            }, function(response){
                                self.isAddedToCart = cartSvc.getCartItemByMediaId(self.cart.data, scope.file.id) ? true: false;
                                scope.onAddedOrRemovedFromGallery({file: scope.file});
                            });
                        }
                    }

                }, function(){
                    self.isWorking = false;
                });
                if(scope.onPhotoClickedCallback){
                    scope.onPhotoClickedCallback({file: scope.file});
                }
           }

        }
    }
})();

(function () {
  'use strict';

  angular
    .module('pixerf')
    .directive('photo', photo);

  function photo() {

    var directive = {
      scope: {
          displaySize: "@",
          file: "=",
          gallery: "=",
          onFileRemoved: "&",
          onAddedOrRemovedFromGallery: "&",
          context: '=',
          onPhotoClicked: '&?',
          onPhotoClickedCallback: '&?',
          simpleSelectMode: '=',
          overlayMode: '=',
          onPhotoPopupSaved: '&',
          onPhotoPopupClosed: '&',
          options: '=',
          onRemoveBtnClick: '&?',
          flaggedUsers: '=?'
      },
      restrict: 'E',
      templateUrl: 'app/components/photo/photo.html',
      controller: 'photoCtrl',
      controllerAs: 'vm',
      replace: true
    };
    return directive;
  }

})();

(function () {

	angular
		.module('pixerf')
		.controller('personSelectionCtrl', personSelectionCtrl);

	personSelectionCtrl.$inject = [];

	function personSelectionCtrl() {

		var self = this;
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('personSelection', personSelection);

	personSelection.$inject = [];

	function personSelection() {

		var directive = {
			scope: {
				person: "=",
				options: '=',
				mode: "@",
				onSelected: "&?",
				onRemoved: "&?"
			},
			restrict: 'E',
			templateUrl: 'app/components/person-selection/person-selection.html',
			controller: 'personSelectionCtrl',
			controllerAs: 'vm',
			replace: true
		};
		return directive;
	}

})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .factory('personListSelectionSvc', personListSelectionSvc);

     personListSelectionSvc.$inject = [];

    function personListSelectionSvc() {

        
        return {
        };
    }
})();
(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('personListSelectionCtrl', personListSelectionCtrl);

	personListSelectionCtrl.$inject = ['$scope', 'toastr', 'pagingUtils', 'pixerfApiCommunitySvc', 'pixerfApiUserSvc', '$translate'];

	function personListSelectionCtrl($scope, toastr, pagingUtils, pixerfApiCommunitySvc, pixerfApiUserSvc, $translate) {

		var self = this;

		self.getPeopleList = getPeopleList;
		self.fetchMorePeoples = fetchMorePeoples;
		self.onSearchStringChanged = _.debounce(onSearchStringChanged, 300);
		self.peoples = null;
		self.searchParams = null;
		self.isLastPage = false;
		self.spinner = {
			isVisible: false
		};
		if ($scope.onInit) {
			$scope.onInit({
				instance: self
			});
		}

		function getter(params) {
			if ($scope.getter) {
				return $scope.getter();
			}
			params.community_id = $scope.$parent.vm.popupData && $scope.$parent.vm.popupData.community ? $scope.$parent.vm.popupData.community.id : $scope.$parent.vm.community.id;
			if (params.type === "all") {
				return pixerfApiUserSvc.search_all_users(params).$promise;
			} else {
				return pixerfApiCommunitySvc.get_invitable_list(params).$promise;
			}
		}

		function getPeopleList(params, isFresh, callback) {
			if (!self.searchParams || isFresh) self.searchParams = params;
			if (self.searchString) self.searchParams.keywords = self.searchString;
			self.spinner.isVisible = true;
			getter(params).then(function (response) {
				if (!self.peoples || isFresh) self.peoples = [];

				self.peoples = self.peoples.concat(response.data);
				self.isLastPage = pagingUtils.isNoMorePageToLoad(params.page, response);
				self.spinner.isVisible = false;
				self.searchParams.page = params.page;
				if(callback){
					callback();
				}
			}, function () {
				toastr.error($translate.instant('failed-to-get-peoples-list'));
				self.spinner.isVisible = false;
			});
		}

		function fetchMorePeoples() {
			if (self.spinner.isVisible) {
				return;
			}
			var searchParms = $.extend(true, {}, self.searchParams);
			searchParms.page++;
			getPeopleList(searchParms);
		}

		function onSearchStringChanged() {
			if (!self.searchString && self.searchParams && self.searchParams.keywords) {
				delete self.searchParams['keywords'];
			} else if (self.searchString) {
				self.searchParams.keywords = self.searchString;
			}
			var isFresh = true;
			getPeopleList(self.searchParams, isFresh);
		}

	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('personListSelection', personListSelectionCtrl);

	function personListSelectionCtrl() {

		var directive = {
			scope: {
				onInit: "&?",
				options: '=',
				getter: '&?',
				onSelectedStatusChanged: "&?"
			},
			restrict: 'E',
			templateUrl: 'app/components/person-list-selection/person-list-selection.html',
			controller: 'personListSelectionCtrl',
			controllerAs: 'vm',
			replace: true,
			transclude: true
		};
		return directive;
	}

})();

(function(){

	angular
	  .module('pixerf')
	  .controller('peopleWithSelectionCtrl', peopleWithSelectionCtrl);

	  peopleWithSelectionCtrl.$inject = [];

	  function peopleWithSelectionCtrl(){

		  var self = this;
	  }
  })();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('peopleWithSelection', peopleWithSelection);

	peopleWithSelection.$inject = ['$rootScope', '$interval'];
	function peopleWithSelection($rootScope, $interval) {

		var directive = {
			scope: {
				people: "=",
				onSelectedStatusChanged: "&?"
			},
			restrict: 'E',
			templateUrl: 'app/components/people-with-selection/people-with-selection.html',
			controller: 'peopleWithSelectionCtrl',
			controllerAs: 'vm',
			replace: true
		};
		return directive;
	}

})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.factory('peopleListPopupSvc', peopleListPopupSvc);
	peopleListPopupSvc.$inject = ['pixerfApiUserSvc', 'pixerfApiMediaSvc', '$uibModal'];

	function peopleListPopupSvc(pixerfApiUserSvc, pixerfApiMediaSvc, $uibModal) {
		function showPopup(data) {
			return $uibModal.open({
				templateUrl: 'app/components/people-list/people-list-popup.html',
				controller: 'peopleListPopupCtrl',
				controllerAs: 'vm',
				animation: true,
				resolve: {
					'resolveData': function () {
						return data;
					}
				}
			});

		}

		function getInteractivePeoples(param) {
			return pixerfApiUserSvc.query({
				id: param.personId,
				action: param.action,
				page: param.page,
				page_size: param.page_size
			}).$promise;
		}

		function getLikesPeople(param) {
			return pixerfApiMediaSvc.getLikes({
				id: param.photoid,
				page: param.page
			}).$promise;
		}

		function getPeopleList(param) {
			if (param.action === "followings" ||
				param.action === "followers") {
				return getInteractivePeoples(param);
			} else {
				return getLikesPeople(param);
			}
		}
		return {
			showPopup: showPopup,
			getInteractivePeoples: getInteractivePeoples,
			getLikesPeople: getLikesPeople,
			getPeopleList: getPeopleList
		};
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('peopleListPopupCtrl', peopleListPopupCtrl);

	peopleListPopupCtrl.$inject = ['peopleListPopupSvc', '$uibModalInstance', 'pagingUtils', 'accountConst', 'resolveData', 'toastr', 'sessionManagerSvc', '$translate', 'pixerfApiCommunitySvc'];

	function peopleListPopupCtrl(peopleListPopupSvc, $uibModalInstance, pagingUtils, accountConst, resolveData, toastr, sessionManagerSvc, $translate, pixerfApiCommunitySvc) {

		var self = this;

		self.closePopup = closePopup;
		self.searchString = "";
		self.loginUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.peoples = [];
		self.onSearchStringChanged = _.debounce(searchPeople, 300);
		self.spinner = {
			isVisible: false
		};
		self.isLastPage = false;
		self.fetchMorePeoples = fetchMorePeoples;
		self.currentPage = 0;
		self.searchParams = {
			page: 1,
			type: resolveData.type
		};
		self.options = resolveData.options;
		self.user = self.loginUser && self.loginUser.id === resolveData.user.id ? resolveData.user : null;

		getPeopleList(self.searchParams);

		function closePopup(reason) {
			$uibModalInstance.dismiss(reason);
		}

		function getPeopleList(params) {
			self.spinner.isVisible = true;
			switch (resolveData.type.toUpperCase()) {
				case accountConst.INTERACT_TYPE.LIKE_REPLY_DISCUSSION:
					self.popupTitle = 'likes';
					makeRequest(params, 'list_like_reply');
					break;
				case accountConst.INTERACT_TYPE.LIKE_DISCUSSION:
					self.popupTitle = 'likes';
					self.searchParams.id = resolveData.discussionId;
					makeRequest(params, 'list_like_discussion');
					break;
				case accountConst.INTERACT_TYPE.LIKE:
					self.popupTitle = 'likes';
					self.searchParams.photoid = resolveData.mediaid;
					makeDefaultRequest(params);
					break;
				case accountConst.INTERACT_TYPE.LIKE_EVENT_POST:
					self.popupTitle = 'likes';
					self.searchParams.id = resolveData.eventPostId;
					makeRequest(params, 'list_like_event_post');
					break;
				case accountConst.INTERACT_TYPE.REPLY_DISCUSSION:
					self.popupTitle = 'replies';
					self.searchParams.id = resolveData.discussionId;
					makeRequest(params, 'list_reply_discussion');
					break;
				case accountConst.INTERACT_TYPE.REPLY_EVENT_POST:
					self.popupTitle = 'replies';
					self.searchParams.id = resolveData.eventPostId;
					makeRequest(params, 'list_reply_event_post');
					break;
				case accountConst.INTERACT_TYPE.FOLLOWING:
					self.popupTitle = 'following';
					self.searchParams.personId = resolveData.user.id;
					self.searchParams.action = 'followings';
					makeDefaultRequest(params);
					break
				case accountConst.INTERACT_TYPE.FOLLOWER:
					self.popupTitle = 'followers';
					self.searchParams.personId = resolveData.user.id;
					self.searchParams.action = 'followers';
					makeDefaultRequest(params);
					break;
				case accountConst.INTERACT_TYPE.LIST_INTERESTED_EVENT:
					self.popupTitle = 'interested';
					self.searchParams.id = resolveData.eventId;
					self.searchParams.status = 'interested';
					makeRequest(params, 'list_interested_event');
					break;
				case accountConst.INTERACT_TYPE.LIST_JOINED_EVENT:
					self.popupTitle = 'joined';
					self.searchParams.id = resolveData.eventId;
					self.searchParams.status = 'joined';
					makeRequest(params, 'list_joined_event');
					break;
				case accountConst.INTERACT_TYPE.LIST_INVITED_EVENT:
					self.popupTitle = 'invited';
					self.searchParams.community_event_id = resolveData.eventId;
					makeRequest(params, 'list_invited_event');
					break;
			}
		}

		function fetchMorePeoples() {
			if (self.spinner.isVisible) {
				return;
			}
			self.searchParams.page++;
			getPeopleList(self.searchParams);
		}

		function makeRequest(params, services) {
			pixerfApiCommunitySvc[services](params).$promise.then(function (response) {
				switch (resolveData.type.toUpperCase()) {
					case accountConst.INTERACT_TYPE.REPLY_DISCUSSION:
					case accountConst.INTERACT_TYPE.REPLY_EVENT_POST:
					case accountConst.INTERACT_TYPE.LIST_INTERESTED_EVENT:
					case accountConst.INTERACT_TYPE.LIST_JOINED_EVENT:
						self.peoples = self.peoples.concat(extractPeopleList(response.data));
						break;
					default:
						self.peoples = self.peoples.concat(response.data);
				}
				self.isLastPage = pagingUtils.isNoMorePageToLoad(params.page, response);
				self.spinner.isVisible = false;
			}, function () {
				toastr.error($translate.instant('failed-to-get-peoples-list'));
				self.spinner.isVisible = false;
			});
		}

		function makeDefaultRequest(params) {
			peopleListPopupSvc.getPeopleList(params).then(function (response) {
				self.peoples = self.peoples.concat(response.data);
				self.isLastPage = pagingUtils.isNoMorePageToLoad(params.page, response);
				self.spinner.isVisible = false;
			}, function () {
				toastr.error($translate.instant('failed-to-get-peoples-list'));
				self.spinner.isVisible = false;
			});
		}

		function extractPeopleList(data) {
			var people = [];
			for (var i = 0; i < data.length; i++) {
				if (!people.includes(data[i].user)) {
					people.push(data[i].user);
				}
			}
			return people;
		}

		function searchPeople() {
			console.log(self.searchString);
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('pendingDiscussionDetailTileCtrl', pendingDiscussionDetailTileCtrl);

	pendingDiscussionDetailTileCtrl.$inject = ['$scope', 'pixerfApiCommunityDiscussionSvc', 'confirmPopupSvc', '$q', 'pixerfApiCommunitySvc'];

	function pendingDiscussionDetailTileCtrl($scope, pixerfApiCommunityDiscussionSvc, confirmPopupSvc, $q, pixerfApiCommunitySvc) {
		var self = this;
		self.discussion = $scope.discussion;
		self.onRejectDiscussion = onRejectDiscussion;
		self.onApproveDiscussion = onApproveDiscussion;

		init();

		function init() {
			self.postedDate = moment(self.discussion.updated_at).format('D MMM YYYY, H:mma');
		}

		function onRejectDiscussion(discussion) {
			confirmPopupSvc.showPopup({
				windowClass: 'reject-discussion-popup',
				title: "You're about to reject this post.",
				message: 'Rejected post will be permanently deleted and the member will be notified. Are you sure?',
				submitBtnText: 'Confirm',
				cancelBtnText: 'Cancel',
				submit: function () {
					var def = $q.defer();
					pixerfApiCommunityDiscussionSvc.move_status({
						id: discussion.id,
						action: 'reject'
					}, {}).$promise.then(function (respone) {
						self.discussion.status = "rejected";
						$scope.onStatusChanged({
							data: self.discussion
						});
						def.resolve(respone);
					}).catch(function (err) {
						def.reject(err);
					})
					return def.promise;
				}
			});
		}

		function onApproveDiscussion(discussion) {
			pixerfApiCommunityDiscussionSvc.move_status({
				id: discussion.id,
				action: 'approve'
			}, {}).$promise.then(function (respone) {
				return pixerfApiCommunitySvc.update_discussion({
					id: self.discussion.id
				}, {
					status: 'published'
				}).$promise;
			}).then(function (respone) {
				self.discussion.status = "published";
				$scope.onStatusChanged({
					data: self.discussion
				})
			}).catch(function (err) {
				console.log(err);
			});
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('pendingDiscussionDetailTile', pendingDiscussionDetailTile);

	function pendingDiscussionDetailTile() {

		var directive = {
			scope: {
				discussion: "=",
				onStatusChanged: "&"
			},
			restrict: 'E',
			templateUrl: 'app/components/pending-discussion-detail-tile/pending-discussion-detail-tile.html',
			controller: 'pendingDiscussionDetailTileCtrl',
			controllerAs: 'vm',
			replace: true
		};
		return directive;
	}

})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .factory('paypalCheckoutBtnSvc', paypalCheckoutBtnSvc);

     paypalCheckoutBtnSvc.$inject = [];

    function paypalCheckoutBtnSvc() {

        
        return {
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('pixerf')
        .controller('paypalCheckoutBtnCtrl', paypalCheckoutBtnCtrl);

    paypalCheckoutBtnCtrl.$inject = ['googleAnalyticSvc', 'pixerfUrl', '$scope', 'sessionManagerSvc', 'verifiedBusinessUserPopupSvc', 'cartSvc', 'systemUtils', 'resendVerificationEmailPopupSvc', 'contextConst', 'stringUtils', 'creditPlansSvc', 'toastr'];

    function paypalCheckoutBtnCtrl(googleAnalyticSvc, pixerfUrl, $scope, sessionManagerSvc, verifiedBusinessUserPopupSvc, cartSvc, systemUtils, resendVerificationEmailPopupSvc, contextConst, stringUtils, creditPlansSvc, toastr) {

        var self = this;
        self.user = sessionManagerSvc.getCurrentLoginUser().data;
        self.style = {
            shape: 'rect',
            size: 'medium',
            color: 'blue'
        };
        self.isWorking = false;

        var mode = new PixerfEnv().getEnv();
        self.env = mode === "PRODUCTION" ? null : 'sandbox';

        self.payment = createPayment;
        self.payment = createPayment;

        self.onAuthorize = executePayment;

        function createPayment(resolve, reject) {
            if (!self.user.is_email_verified && self.user.isBiz && $scope.skipCheckVerifiedEmail) {
                verifiedBusinessUserPopupSvc.showPopup();
                return false;
            } else if (!self.user.is_email_verified && $scope.skipCheckVerifiedEmail) {
                resendVerificationEmailPopupSvc.showVerifyEmailPopup();
                return false;
            }
            googleAnalyticSvc.trackBtnClick("PayPal Checkout");
            var CREATE_PAYMENT_URL = pixerfUrl.full + 'api/payment/paypal/create';
            var params = {};
            if ($scope.context === contextConst.CHECKOUT_CART) {
                var lineItemsIds = _.reduce(cartSvc.getCart().data.cart_items, function (memo, it) {
                    memo.push(it.id);
                    return memo;
                }, []);
                params = { ids: lineItemsIds };
            } else if ($scope.context === contextConst.TOPUP_CREDIT_PLANS) {
                params = { credit_plan_id: creditPlansSvc.getCreditPlan().data.id }
            }
            paypal.request({ url: CREATE_PAYMENT_URL, method: "post", headers: { 'Authorization': 'Bearer ' + sessionManagerSvc.getToken() }, json: params })
                .then(function (data) {
                    if ($scope.onValidationPassed) {
                        $scope.onValidationPassed();
                        systemUtils.digest($scope);
                    }
                    resolve(data.paymentID);
                })
                .catch(function (err) {
                    console.log(err);
                    reject(err);
                    validateErrorHandler(err);
                    systemUtils.digest($scope);
                });
        }
        function validateErrorHandler(error) {
            var pixerfPaymentErrorObject = stringUtils.extractJSON(error.message);
            $scope.onError({ pixerfPaymentErrorObject: pixerfPaymentErrorObject });
        }
        function executePayment(data) {
            $scope.onPaypalDone();
            systemUtils.digest($scope);
            // Note: you can display a confirmation page before executing

            var EXECUTE_PAYMENT_URL = pixerfUrl.full + 'api/payment/paypal/execute';
            var params = {
                payment_id: data.paymentID,
                payer_id: data.payerID
            }
            if ($scope.context === contextConst.TOPUP_CREDIT_PLANS) {
                params.credit_plan_id = creditPlansSvc.getCreditPlan().data.id;
            }
            self.isWorking = true;
            paypal.request({ url: EXECUTE_PAYMENT_URL, method: "post", data: params, headers: { 'Authorization': 'Bearer ' + sessionManagerSvc.getToken() } })

                .then(function (data) {
                    if(!self.user.user_credit_plan){
                        self.user.user_credit_plan = {};
                    }

                    self.user.user_credit_plan.balance = parseFloat(data.total);
                    self.user.user_credit_plan.total = parseFloat(data.total);
                    sessionManagerSvc.setCurrentLoginUser(self.user);

                    if ($scope.context === contextConst.TOPUP_CREDIT_PLANS) {
                        toastr.success("You've topped up successfully");
                    }
                    self.isWorking = false;
                    $scope.onComplete({ data: data });
                    systemUtils.digest($scope);
                    /* Go to a success page */

                }).catch(function (err) {
                    $scope.onError();
                    self.isWorking = false;
                });
        }

    }
})();
(function () {
  'use strict';

  angular
    .module('pixerf')
    .directive('paypalCheckoutBtn', paypalCheckoutBtn);

  function paypalCheckoutBtn() {

    var directive = {
      scope: {
          'onComplete': '&',
          'onPaypalDone': '&',
          'onError': '&',
          'onValidationPassed': '&?',
          'paypalCheckoutBtnDisabled': '=',
          'validator': '&?',
          'context': '@',
          'skipCheckVerifiedEmail':'@'
      },
      restrict: 'E',
      templateUrl: 'app/components/paypal-checkout-btn/paypal-checkout-btn.html',
      controller: 'paypalCheckoutBtnCtrl',
      controllerAs: 'vm',
      replace: true
    };
    return directive;
  }

})();

(function () {
    'use strict';

    angular
        .module('pixerf')
        .controller('paymentPannelCtrl', paymentPannelCtrl);

    paymentPannelCtrl.$inject = ['toastr', '$translate', '$scope', 'sessionManagerSvc', 'contextConst', 'messageConst', 'store', 'accountConst'];

    function paymentPannelCtrl(toastr, $translate, $scope, sessionManagerSvc, contextConst, messageConst, store, accountConst) {

        var self = this;

        self.onPaymentMethodClicked = onPaymentMethodClicked;
        self.onBtnCoverClicked = onBtnCoverClicked;
        self.selectedPaymentMethod = null;
        self.isAgreedTnC = !!$scope.skipsToAgree;
        self.isFormDirty = false;
        self.customCreditPlan = false;
        self.loginUser = sessionManagerSvc.getCurrentLoginUser().data;
        self.onCheckboxAgreedTncChanged = onCheckboxAgreedTncChanged;
        self.omisePaymentShowCreaditPopup = $scope.processBeforePay ? false : true;
        self.skipCheckVerifiedEmail = $scope.processBeforePay ? 'true' : '';
        self.errorMessageBuilder = errorMessageBuilder;
        $scope.$watch("amountToPay", function (newValue, oldValue) {
            if (!newValue) {
                self.customCreditPlan = true;
            } else {
                self.customCreditPlan = false;
            }
        })
        self.paymentAmountToPayTitle = $translate.instant($scope.isGuestPayment ? 'order-total' : 'amount-to-pay');
        self.cardInfo = {};
        self.onCheckboxSubscribleNewsLetterChanged = onCheckboxSubscribleNewsLetterChanged;
        self.subcribleNewsLetter = $scope.subcribleNewsLetter;
        $scope.$on(messageConst.BROADCAST.PAYMENT_CARD_INFO, function(event, args) {
            saveCardInfoToLocal();
        });

        $scope.$on(messageConst.BROADCAST.PAYMENT_CARD_INFO_REFILL, function(event, args) {
            refillCardIfo();
        });

        var allPaymentMethods = [{
            id: 'MY_CREDIT',
            name: 'Use My Credit',
            is_default: false,
            // isDisabled  : function(){
            // var credit = self.loginUser.user_credit_plan ? parseFloat(self.loginUser.user_credit_plan.balance) : 0;
            // var isDisabled = $scope.amountToPay > credit;
            // if(isDisabled) setDefaultPaymentMethod();
            // return isDisabled;
            // }
        }, {
            id: 'PAYPAL',
            name: 'Checkout with PayPal',
            is_default: false,
            link: 'https://www.paypal.com'
        }, {
            id: 'OMISE',
            name: 'Pay with Credit/Debit Card',
            is_default: true,
            link: 'https://www.omise.co/'
        }];

        // , {
        //     id: 'WIRE_TRANSFER',
        //     name: 'Pay via Cheque/Wire Transfer',
        //     is_default: false
        // }

        function init() {
            if (!self.loginUser || (self.loginUser && !self.loginUser.canBuyCreditPlan)) {
                allPaymentMethods.shift();
            }
            if ($scope.context === contextConst.CHECKOUT_CART) {
                allPaymentMethods = allPaymentMethods.filter(function (obj) {
                    return obj.id !== 'WIRE_TRANSFER';
                });
            }
            self.paymentMethods = $scope.notAllowedList ? buildPaymentMethods(allPaymentMethods, $scope.notAllowedList) : allPaymentMethods;
            setDefaultPaymentMethod();
        }

        function onCheckboxSubscribleNewsLetterChanged(){
            $scope.subcribleNewsLetter = self.subcribleNewsLetter;
        }

        function saveCardInfoToLocal(){
            store.set(accountConst.TOKEN.PAYMENT_INFO, self.cardInfo);
            store.set(accountConst.TOKEN.PAYMENT_MENTHOD, self.selectedPaymentMethod);
        }

        function refillCardIfo(){
            self.cardInfo = store.get(accountConst.TOKEN.PAYMENT_INFO);
            self.isAgreedTnC = true;
            var lastedPaymentMenthod = store.get(accountConst.TOKEN.PAYMENT_MENTHOD);
            if(lastedPaymentMenthod && lastedPaymentMenthod.id){
                updateSelectedPaymentMethod(lastedPaymentMenthod.id);
            }
        }

        function buildPaymentMethods(allPaymentMethods, notAllowedList) {
            var allowedPaymentMethods = [];
            for (var i = 0; i < allPaymentMethods.length; i++) {
                var paymentMethod = allPaymentMethods[i];
                var isNotAllowed = _.find(notAllowedList, function (item) {
                    return item === paymentMethod.id;
                })

                if (!isNotAllowed) {
                    allowedPaymentMethods.push(paymentMethod);
                }
            }
            return allowedPaymentMethods;
        }
        function setDefaultPaymentMethod() {
            for (var i = 0; i < self.paymentMethods.length; i++) {
                if (self.paymentMethods[i].is_default) {
                    setSelectedPaymentMethod(self.paymentMethods[i]);
                }
            }
        }
        function updateSelectedPaymentMethod(selectedId) {
            for (var i = 0; i < self.paymentMethods.length; i++) {
                if (self.paymentMethods[i].id == selectedId) {
                    setSelectedPaymentMethod(self.paymentMethods[i]);
                }
            }
        }
        function setSelectedPaymentMethod(paymentMethod) {
            if (self.selectedPaymentMethod) self.selectedPaymentMethod.isSelected = false;
            paymentMethod.isSelected = true;
            self.selectedPaymentMethod = paymentMethod;
            if ($scope.onPaymentMethodSelected) {
                $scope.onPaymentMethodSelected({ paymentMethodSelected: paymentMethod });
            }
            processPaypalSignIn();
        }
        function onPaymentMethodClicked(paymentMethod) {
            if (typeof paymentMethod.isDisabled === 'function' && paymentMethod.isDisabled()) {
                return;
            }
            if (self.selectedPaymentMethod && paymentMethod.id === self.selectedPaymentMethod.id) return;
            setSelectedPaymentMethod(paymentMethod);
            resetTncBtn();
        }
         
        function resetTncBtn(){
            self.isAgreedTnC = !!$scope.skipsToAgree;;
        }

        function onBtnCoverClicked() {
            if (!self.customCreditPlan) {
                self.isFormDirty = true;
                toastr.error($translate.instant("please-accept-license-agreement"));
            }
        }

        function onCheckboxAgreedTncChanged(){
            if(self.isAgreedTnC && $scope.onCheckboxAgreedTncChecked){
                var canProcessPaypalSignin = $scope.onCheckboxAgreedTncChecked();
                self.isAgreedTnC = canProcessPaypalSignin;
                processPaypalSignIn(canProcessPaypalSignin);
            }
        }

        function processPaypalSignIn(canSignin) {
            if($scope.isGuestPayment && self.selectedPaymentMethod && self.selectedPaymentMethod.id == 'PAYPAL' && self.isAgreedTnC && canSignin)
            $scope.processBeforePay();
        }

        function errorMessageBuilder(err) {
            return (err.err.code === "missing_card" && err.err.message.indexOf("not supported") === -1) ? "Missing card information" : err.err.message;
        }

        init();

    }
})();
(function () {
  'use strict';

  angular
    .module('pixerf')
    .directive('paymentPannel', paymentPannel);

  function paymentPannel() {

    var directive = {
      scope: {
        type: '=',
        amountToPay: '=',
        onComplete: '&',
        onPaypalDone: '&',
        onError: '&',
        onValidationPassed: '&?',
        validator: '&?',
        notAllowedList: '=',
        onPaymentMethodSelected: '&?',
        context: '@',
        skipsToAgree: '@',
        showPriceHint: '@',
        displayHorizontal: '=',
        disablePayBtn: '=',
        processBeforePay: '&?',
        isGuestPayment:'=?',
        onCheckboxAgreedTncChecked: '&?',
        subcribleNewsLetter: '='
      },
      restrict: 'E',
      templateUrl: 'app/components/payment-pannel/payment-pannel.html',
      replace: true,
      controller: 'paymentPannelCtrl',
      controllerAs: 'vm'
    };
    return directive;
  }

})();

(function () {
  'use strict';

  angular
    .module('pixerf')
    .directive('paymentAmountToPay', paymentAmountToPay);

  paymentAmountToPay.$inject = ['numberUtils'];
  function paymentAmountToPay(numberUtils) {

    var directive = {
      scope: {
        amount: "=",
        amountDiscounted: "=",
        title: '@',
        showUnit: '@'
      },
      restrict: 'E',
      templateUrl: 'app/components/payment-amount-to-pay/payment-amount-to-pay.html',
      replace: true
    };
    return directive;
  }

})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.factory('organizationDetailPopupSvc', organizationDetailPopupSvc);
	organizationDetailPopupSvc.$inject = ['$uibModal'];

	function organizationDetailPopupSvc($uibModal) {

		function showPopup(data) {
			return $uibModal.open({
				templateUrl: 'app/components/organization-detail-popup/organization-detail-popup.html',
				controller: 'organizationDetailPopupCtrl',
				controllerAs: 'vm',
				animation: true,
				windowClass: 'zindex organization-detail-screen',
				resolve: {
					'resolveData': function () {
						return data;
					}
				}
			});
		}

		return {
			showPopup: showPopup
		};
	}
})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('organizationDetailPopupCtrl', organizationDetailPopupCtrl);

    organizationDetailPopupCtrl.$inject = ['$uibModalInstance', '$state', 'resolveData'];

    function organizationDetailPopupCtrl($uibModalInstance, $state, resolveData) {

		var self = this;
		self.close = close;
		self.info = resolveData;

		function close(){
            $uibModalInstance.close();
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('pixerf')
        .factory('paypalCheckoutBtnSvc', paypalCheckoutBtnSvc);

     paypalCheckoutBtnSvc.$inject = [];

    function paypalCheckoutBtnSvc() {

        
        return {
        };
    }
})();
(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('omiseCheckoutBtnCtrl', omiseCheckoutBtnCtrl);

	omiseCheckoutBtnCtrl.$inject = ['$scope', 'pixerfCreditCardPopupSvc', '$http', '$q', 'cartSvc', 'googleAnalyticSvc', 'pixerfApiCreditPlansSvc',
		'creditPlansSvc', 'contextConst', 'sessionManagerSvc', 'toastr', '$rootScope', 'messageConst', '$stateParams', 'pixerfApiTracking'
	];

	function omiseCheckoutBtnCtrl($scope, pixerfCreditCardPopupSvc, $http, $q, cartSvc, googleAnalyticSvc, pixerfApiCreditPlansSvc,
		creditPlansSvc, contextConst, sessionManagerSvc, toastr, $rootScope, messageConst, $stateParams, pixerfApiTracking) {

		var self = this;

		var mPopupClass = 'pixerf-credit-card-popup__wrapper';
		var userData = sessionManagerSvc.getCurrentLoginUser().data;
		self.onCheckoutBtnClicked = onCheckoutBtnClicked;
		self.card = $scope.card;
		self.isWorking = false;
		$scope.$on(messageConst.BROADCAST.ACTION_PAY_AFTER_SIGNED, function (event, args) {
			onCheckoutBtnClicked();
		});

		init();
		// old omise key prod: pkey_5a6gmyq6v3mbogw6w1o
		function init() {
			var mode = new PixerfEnv().getEnv();
			var publicKey = mode === "PRODUCTION" ? 'pkey_5uqj7uvd5ri8luiwk8f' : 'pkey_test_59r6tcsuvog3evlmh3f';
            Omise.setPublicKey(publicKey);
            if($stateParams && $stateParams.id){
                self.buttonId = "pcredit_" + $stateParams.id;
            }
		}

		function onPayBtnClick(data) {
			var def = $q.defer();
			var params = {};
			if ($scope.validator) {
				createToken($scope.card).then(function (token) {
					if ($scope.context === contextConst.CHECKOUT_CART) {
						var lineItemsIds = _.reduce(cartSvc.getCart().data.cart_items, function (memo, it) {
							memo.push(it.id);
							return memo;
						}, []);
						params = {
							omiseToken: token,
							ids: lineItemsIds
						};
						googleAnalyticSvc.trackBtnClick("Omise Checkout");
						$http({
							method: 'POST',
							url: 'https://qa2.pixerf.com/api/v2/payment/charge',
							headers: {
								"Authorization": "Bearer " + sessionManagerSvc.getToken()
							},
							data: params
						  }).then(function (response) {
							console.log("response");
							console.log(response);
							def.resolve();
							onComplete({
								data: {
									order_id: response.data.order_id
								}
							});
							cartSvc.reset();
						}, function (pixerfPaymentErrorObject) {
							onError(pixerfPaymentErrorObject.data);
							def.reject(pixerfPaymentErrorObject.data);
						});
					} else if ($scope.context === contextConst.TOPUP_CREDIT_PLANS) {
						params = {
							omiseToken: token,
							credit_plan_id: creditPlansSvc.getCreditPlan().data.id
						};
						pixerfApiCreditPlansSvc.post(params).$promise.then(function (response) {
							if (!userData.user_credit_plan) {
								userData.user_credit_plan = {};
							}
							userData.user_credit_plan.balance = response.data.total;
							userData.user_credit_plan.total = response.data.total;
							sessionManagerSvc.setCurrentLoginUser(userData);
							toastr.success("You've topped up successfully");
							def.resolve();
							onComplete({
								data: {
									balance: response.data.total
								}
							});
						}, function (pixerfPaymentErrorObject) {
							onError(pixerfPaymentErrorObject.data);
							def.reject(pixerfPaymentErrorObject.data);
						});
					} else if ($scope.context === contextConst.CHECKOUT_EVENT) {
						googleAnalyticSvc.trackBtnClick("PayPal Checkout");
						def.resolve();
						onComplete({
							data: {
								order_id: 'TicketedEvent'
							}
						},function (pixerfPaymentErrorObject) {
							Sentry.captureException(pixerfPaymentErrorObject);
							Sentry.captureException(userData);
							onError(pixerfPaymentErrorObject.data);
						});
					}

				}, function (err) {
					err.pixerf_type = "TOKEN_FAILURE";
					def.reject(err);
				})
			}
			return def.promise;
		}

		function errorMessageBuilder(err, form) {
			return (err.code === "missing_card" && err.message.indexOf("not supported") === -1) ? "Missing card information" : err.message;
		}

		function onError(pixerfPaymentErrorObject) {
			if ($scope.onError) {
				$scope.onError({
					pixerfPaymentErrorObject: pixerfPaymentErrorObject
				});
			}
		}

		function onComplete(data) {
			if (self.popup) {
				self.popup.close();
			}
			if ($scope.onComplete) {
				$scope.onComplete(data);
			}
		}

		function onCheckoutBtnClicked() {
            trackButtonClick();
			if ($scope.isGuestPayment) {
				return $scope.processBeforePay().then(function (params) {
					if ($scope.validator()) {
						if (self.isWorking) return;
						self.isWorking = true;
						$scope.validator().then(function () {
							self.isWorking = false;
							onPayBtnClick().then(
								function (response) {},
								function (err) {
									$rootScope.$broadcast(messageConst.BROADCAST.OMISE_CHECKOUT_ERROR, {
										err: err
									});
								}
							)
						}, function (pixerfPaymentErrorObject) {
							onError(pixerfPaymentErrorObject.data);
							self.isWorking = false;
						})
					} else {
						showCreditPopup();
					}
				})
			}
			if ($scope.canShowCreditPopup == 'false') {
				if ($scope.validator()) {
					self.isWorking = true;
					$scope.validator().then(function () {
						onPayBtnClick().then(
							function (response) {},
							function (err) {
								$rootScope.$broadcast(messageConst.BROADCAST.OMISE_CHECKOUT_ERROR, {
									err: err
								});
							}
						)
						self.isWorking = false;
					}, function (pixerfPaymentErrorObject) {
						onError(pixerfPaymentErrorObject.data);
						self.isWorking = false;
					})
				} else {
					onPayBtnClick();
				}
				return;
			}
			if ($scope.validator()) {
				if (self.isWorking) return;
				self.isWorking = true;
				$scope.validator().then(function () {
					showCreditPopup();
					self.isWorking = false;
				}, function (pixerfPaymentErrorObject) {
					onError(pixerfPaymentErrorObject.data);
					self.isWorking = false;
				})
			} else {
				showCreditPopup();
			}
		}

		function trackButtonClick() {
			var params = {
				button_id: self.buttonId,
                button_text: "Pay",
                description: "Pay button #" + self.buttonId
			};

			if (userData) {
				params.user_id = userData.id;
			}

			pixerfApiTracking.action_tracking({
				tracking: params
			})
		}

		function showCreditPopup() {
			$scope.card = {};
			self.popup = pixerfCreditCardPopupSvc.showPopup({
				vendor: {
					logo: 'https://assets.omise.co/assets/omise-logo-a86debcb438f41aa395a868ff43fe67090e277d44dea080cd2d51baec405ea71.svg',
					link: 'https://www.omise.co/'
				},
				amountToPay: 'SGD' + cartSvc.getCart().data.total,
				onPayBtnClick: onPayBtnClick,
				windowClass: mPopupClass,
				card: $scope.card,
				errorMessageBuilder: errorMessageBuilder
			});
		}

		function createToken(card) {
			var def = $q.defer();

			Omise.createToken('card', {
				name: card.fullname,
				number: card.number,
				expiration_month: card.expMonth,
				expiration_year: card.expYear,
				security_code: card.sercurityCode
			}, function (statusCode, response) {
				if (statusCode === 200) {
					def.resolve(response.id);
				} else {
					def.reject(response);
				}
				console.log(response);
			});
			return def.promise;
		}

	}
})();

(function () {
  'use strict';

  angular
    .module('pixerf')
    .directive('omiseCheckoutBtn', omiseCheckoutBtn);

  function omiseCheckoutBtn() {

    var directive = {
      scope: {
          'onComplete': '&',
          'onError': '&',
          'validator': '&?',
          'onValidationPassed': '&?',
          'isDisabled': '=',
          'amount': '@',
          'context': '@',
          'processBeforePay': '&?',
          'isGuestPayment':'=?',
          'card': "=",
          'canShowCreditPopup': '@'
      },
      restrict: 'E',
      templateUrl: 'app/components/omise-checkout-btn/omise-checkout-btn.html',
      controller: 'omiseCheckoutBtnCtrl',
      controllerAs: 'vm',
      replace: true
    };
    return directive;
  }

})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.factory('notifyTopupCreditPopupSvc', notifyTopupCreditPopupSvc);
	notifyTopupCreditPopupSvc.$inject = ['$uibModal'];

	function notifyTopupCreditPopupSvc($uibModal) {

		function showPopup(data) {
			return $uibModal.open({
				templateUrl: 'app/components/notify-topup-credit-popup/notify-topup-credit-popup.html',
				controller: 'notifyTopupCreditPopupCtrl',
				controllerAs: 'vm',
				animation: true,
				windowClass: 'zindex notify-topup-credit-screen',
				resolve: {
					'resolveData': function () {
						return data;
					}
				}
			});
		}

		return {
			showPopup: showPopup
		};
	}
})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('notifyTopupCreditPopupCtrl', notifyTopupCreditPopupCtrl);

    notifyTopupCreditPopupCtrl.$inject = ['$uibModalInstance', '$state'];

    function notifyTopupCreditPopupCtrl($uibModalInstance, $state) {

		var self = this;
        self.onPurchaseBtnClicked = onPurchaseBtnClicked;
        self.close = close;

		self.message = {
			content: "Unlock the full potential of your Business Account with Credit Plans"
		};

		function close(){
            $uibModalInstance.close();
        }

        function onPurchaseBtnClicked(){
            $uibModalInstance.close();
            $state.go("checkout.credit-plan.credit-plan-list");
        }
    }
})();
(function () {
	'use strict';
	angular
		.module('pixerf')
		.factory('notifyFeatureNotAvailablePopupSvc', notifyFeatureNotAvailablePopupSvc);
	notifyFeatureNotAvailablePopupSvc.$inject = ['$uibModal'];

	function notifyFeatureNotAvailablePopupSvc($uibModal) {

		function showPopup(data) {
			return $uibModal.open({
				templateUrl: 'app/components/notify-feature-not-available-popup/notify-feature-not-available-popup.html',
				controller: 'notifyFeatureNotAvailablePopupCtrl',
				controllerAs: 'vm',
				animation: true,
				windowClass: 'zindex notify-feature-not-available-screen',
				resolve: {
					'resolveData': function () {
						return data;
					}
				}
			});
		}

		return {
			showPopup: showPopup
		};
	}
})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('notifyFeatureNotAvailablePopupCtrl', notifyFeatureNotAvailablePopupCtrl);

    notifyFeatureNotAvailablePopupCtrl.$inject = ['$uibModalInstance'];

    function notifyFeatureNotAvailablePopupCtrl($uibModalInstance) {

		var self = this;
		self.close = close;

		self.message = {
			header: "Coming soon!",
			content: "We're working hard to get Community ready for you to invite and grow your own network of visual artists. Stay tuned."
		};

		function close(){
            $uibModalInstance.close();
        }
    }
})();
(function () {
	'use strict';
	angular
		.module('pixerf')
		.factory('notifyBusinessPendingPopupSvc', notifyBusinessPendingPopupSvc);
	notifyBusinessPendingPopupSvc.$inject = ['$uibModal'];

	function notifyBusinessPendingPopupSvc($uibModal) {

		function showPopup(data) {
			return $uibModal.open({
				templateUrl: 'app/components/notify-business-pending-popup/notify-business-pending-popup.html',
				controller: 'notifyBusinessPendingPopupCtrl',
				controllerAs: 'vm',
				animation: true,
				windowClass: 'zindex notify-business-pending-popup__screen',
				resolve: {
					'resolveData': function () {
						return data;
					}
				}
			});
		}

		return {
			showPopup: showPopup
		};
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('notifyBusinessPendingPopupCtrl', notifyBusinessPendingPopupCtrl);

	notifyBusinessPendingPopupCtrl.$inject = ['$uibModalInstance'];

	function notifyBusinessPendingPopupCtrl($uibModalInstance) {

		var self = this;
		self.onNextBtnClicked = onNextBtnClicked;
		self.close = close;

		self.message = {
			title: "Thank you for signing up for a PIXERF Business Account!",
			content: "Our team will review your application and send you a confirmation email once your Business Account is fully activated in about 7 working days.",
			btnText: "Next"
		};

		function close() {
			$uibModalInstance.close();
		}

		function onNextBtnClicked() {
			if (self.finalStep) close();
			self.message = {
				title: "What you can do next",
				content: "<ul><li>Complete your profile to let the Community get to know you better; and</li><li>Check out the exciting features on our platform</li></ul>",
				btnText: "Explore our platform"
			};
			self.finalStep = true;
		}
	}
})();

/**
 * Controller for home module
 */
(function(){
  'use strict';
  angular
    .module('pixerf')
    .factory('notificationPopupSvc', notificationPopupSvc);
    notificationPopupSvc.$inject = ['$uibModalStack', '$uibModal'];

    function notificationPopupSvc($uibModalStack, $uibModal){
        function showPopup(data){
            return $uibModal.open({
                templateUrl: 'app/components/notification-popup/notification-popup.html',
                controller: 'notificationPopupCtrl',
                controllerAs: 'vm',
                animation: true,
                windowClass: 'zindex notification-screen',
                resolve: {
                    'resolveData': function(){
                        return data;
                    }
                }
            });

        }
        
        return {
            showPopup: showPopup
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('notificationPopupCtrl', notificationPopupCtrl);

        notificationPopupCtrl.$inject = ['$uibModalInstance','resolveData','accountUtils'];

    function notificationPopupCtrl($uibModalInstance, resolveData, accountUtils) {

        var self = this;

        self.data = resolveData;
        self.header = self.data.title;
        self.message = self.data.message;
        setTimeout(function(){ $uibModalInstance.close();}, 2000);
    }
})();
(function() {
    'use strict';

    angular
        .module('pixerf')
        .service('notificationListSvc', notificationListSvc);
    notificationListSvc.$inject = ['pixerfApiActivitiesSvc', '$q', '$rootScope'];
    function notificationListSvc(pixerfApiActivitiesSvc, $q, $rootScope) {

        var mActivities = {
            data: null
        };
        var mNumUnreadActivities = {
            data: 0
        }
        function getActivities(){
            return mActivities;
        }
        function getNumUnreadActivities(){
            return mNumUnreadActivities;
        }
        function markAllNotificationsAsRead(notifications){
            if(!notifications) notifications = mActivities.data;
            var def = $q.defer();
            pixerfApiActivitiesSvc.mark_all_as_read().$promise.then(function(){
                for(var i = 0; i < notifications.length; i ++){
                    notifications[i].is_read = true;
                }
                mNumUnreadActivities.data = 0;
                updatePageTitle($rootScope.title);
                def.resolve();
            }, function(){
                def.reject();
            })
            return def.promise;
        }
        function markNotificationAsRead(item){
            var def = $q.defer();
            pixerfApiActivitiesSvc.mark_as_read({id: item.id}, {}).$promise.then(function(response){
                item.is_read = true;
                mNumUnreadActivities.data --;
                updatePageTitle();
                $rootScope.$broadcast('NOTIFICATION_READ');
                def.resolve();
            }, function(){
                def.reject();
            })
            return def.promise;
        }
        function addNotification(notification){
            if(!mActivities.data) mActivities.data = [];
            mActivities.data.unshift(notification);
        }
        function updatePageTitle(pageTitle, numUnreadActivities){
            if(!numUnreadActivities) numUnreadActivities = mNumUnreadActivities.data;
            if(!pageTitle) pageTitle = $rootScope.title;
            var originalPageTitle = pageTitle;
            if(pageTitle.indexOf(")") !== -1){
                originalPageTitle = originalPageTitle.substr(originalPageTitle.indexOf(")") + 1) ;
            }
            if(!numUnreadActivities){
                pageTitle =  originalPageTitle;
            } else {
                pageTitle = "(" + numUnreadActivities + ") "  + originalPageTitle;
            }
            $rootScope.title =  pageTitle;
        }
        function reset(){
            mActivities.data = null;
            mNumUnreadActivities.data = null;
        }
        return {
            markNotificationAsRead: markNotificationAsRead,
            markAllNotificationsAsRead: markAllNotificationsAsRead,
            getNumUnreadActivities: getNumUnreadActivities,
            getActivities: getActivities,
            addNotification: addNotification,
            updatePageTitle: updatePageTitle,
            reset: reset
        }
    }

})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('notificationListCtrl', notificationListCtrl);

	notificationListCtrl.$inject = ['$rootScope', '$q', 'pixerfApiActivitiesSvc', 'toastr', 'activityUtils', '$scope', 'systemUtils', 'pagingUtils', 'notificationListSvc', '$state', 'translationSvc', '$timeout'];

	function notificationListCtrl($rootScope, $q, pixerfApiActivitiesSvc, toastr, activityUtils, $scope, systemUtils, pagingUtils, notificationListSvc, $state, translationSvc, $timeout) {

		var self = this;

		self.isWorking = false;
		self.activities = notificationListSvc.getActivities();
		self.numUnreadActivities = notificationListSvc.getNumUnreadActivities();
		self.onNotificationClicked = onNotificationClicked;
		self.fetchMoreActivities = fetchMoreActivities;
		self.init = init;
		self.isNoMoreActivitiesToLoad = false;
		self.type = $scope.type ? $scope.type : 'me';
		self.onSeeAllActivitiesBtnClicked = onSeeAllActivitiesBtnClicked;
		self.spinner = {
			isVisible: false
		}
		self.fetchParams = {
			page: 0
		}
		self.seenItems = {};
		var updateSroolSpyList = false;
		self.hideActorAvatar = false;
		self.hideActorList = ['created_community', 'requested_changes_community', 'approved_community', 'reported_community'];

		init();

		function init() {
			return fetchActivities(self.type, 1, true);
			refreshScrollSpy();
		}

		function fetchActivities(type, page, isFresh) {
			if (self.spinner.isVisible) {
				return;
			}
			var def = $q.defer();
			self.spinner.isVisible = true;
			if (isFresh) {
				notificationListSvc.reset();
				page = 1;
			}
			self.spinner.isVisible = true;
			pixerfApiActivitiesSvc.get({
				type: type,
				page: page
			}).$promise.then(function (response) {
				if (isFresh) {
					self.activities.data = [];
				}
				self.spinner.isVisible = false;
				self.activities.data = self.activities.data.concat(response.data.activities);
				self.isNoMoreActivitiesToLoad = pagingUtils.isNoMorePageToLoad(page, response);
				self.fetchParams.page++;
				if ($scope.onListLoaded && isFresh) {
					$scope.onListLoaded({
						response: response
					});
				}
				if (isFresh) {
					self.numUnreadActivities.data = activityUtils.getTotalUnreadActivities(response);
				}
				refreshScrollSpy();
				def.resolve(response);
			}, function (err) {
				def.reject(err);
				refreshScrollSpy();
				toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
				self.spinner.isVisible = false;
			})
			return def.promise;
		}

		function fetchMoreActivities() {
			if (self.spinner.isVisible) {
				return;
			}
			var page = self.fetchParams.page + 1;
			fetchActivities(self.type, page)
		}

		function onNotificationClicked(item, $event) {
			systemUtils.triggerBodyClicked();
			if (!item.is_read) {
				if (self.isWorking) return;
				self.isWorking = true;
				notificationListSvc.markNotificationAsRead(item).then(function () {
					self.isWorking = false;
					if ($scope.onMarkedAsRead) {
						$scope.onMarkedAsRead();
					}
				}, function () {
					self.isWorking = false;
				});
			}
			if ($event) $event.stopPropagation();
			if (!$event || ($event && $event.target === $event.currentTarget)) {
				$state.go(item.link.state.name, item.link.state.params, {
					reload: true,
					notify: true
				})
			}
		}

		if ($scope.onInit) {
			$scope.onInit({
				instance: self
			});
		}

		function onSeeAllActivitiesBtnClicked() {
			systemUtils.triggerBodyClicked();
		}

		function markNotificationAsRead(item) {
			notificationListSvc.markNotificationAsRead(item).then(function () {
				if ($scope.onMarkedAsRead) {
					$scope.onMarkedAsRead();
				}
				var noti = _.findWhere(self.activities.data, {
					id: item.id
				})
				noti.is_read = true;
			}, function () {
				toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
			});
		}

		function refreshScrollSpy() {
			$timeout(function () {
				$($scope.parentClass + ' .notification-list').scrollspy({
					target: '#navbarNotificationList',
					offset: parseInt($scope.scrollSpyOffset) || 450
				})
				$(window).on('activate.bs.scrollspy', function (event) {

					if (event && event.target && event.target.dataset && event.target.dataset.id && !self.seenItems[event.target.dataset.id]) {
						var item = _.findWhere(self.activities.data, {
							id: parseInt(event.target.dataset.id)
						})
						if (item && !item.is_read) {
							self.seenItems[event.target.dataset.id] = item;
							markNotificationAsRead(item);
						}
					}
					if (event && event.target && event.target.dataset && event.target.dataset.id && !updateSroolSpyList) {
						var index = _.findIndex(self.activities.data, {
							id: parseInt(event.target.dataset.id)
						}) || 0;
						for (var i = 0; i < index; i++) {
							if (!self.activities.data[i].is_read) {
								self.seenItems[event.target.dataset.id] = item;
								markNotificationAsRead(self.activities.data[i]);
							}
						}
						updateSroolSpyList = true;
					}
				})
			}, 200)
		}
	}

})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .directive('notificationList', notificationList);

    notificationList.$inject = [];

    function notificationList() {
        var directive = {
            scope: {
                onListLoaded: '&?',
                onMarkedAllAsRead: '&?',
                onMarkedAsRead: '&?',
                onNewNotificationAdded: '&?',
                onInit: '&?',
                container: '=',
                type: '@',
                parentClass:'@',
                scrollSpyOffset:'@'
            },
            restrict: 'E',
            templateUrl: 'app/components/notification-list/notification-list.html',
            controller: "notificationListCtrl",
            controllerAs: 'vm',
            replace: true
        };
        return directive;
    }
})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .factory('notificationFlashMessageSvc', notificationFlashMessageSvc);

     notificationFlashMessageSvc.$inject = ['$timeout', 'modalUtils'];

    function notificationFlashMessageSvc($timeout, modalUtils) {

        var DEFAULT_AUTO_CLOSE_TIME = 3500;
        var mQueue = [];
        var mMessage = {
            data: null
        }
        var mSounder = null;
        var mIsVisible = {
            data: false
        }
        function isVisible(){
            return mIsVisible;
        }
        function getMessage(){
            return mMessage;
        }
        function setMessage(value){
            mMessage.data = value;
        }
        function show(message, isNotAutoClose, noPush){
            if(!noPush && mQueue.length > 0){
                mQueue.push(message);
            }
            mIsVisible.data = true;
            mSounder.play();
            setMessage(message);
            if(!isNotAutoClose){
                message.timeoutId =  $timeout(function(){
                    mIsVisible.data = false;
                    if(mQueue.length > 0){
                        show(mQueue.pop(), false, true);
                    }
                }, DEFAULT_AUTO_CLOSE_TIME);
                
            }
        }
        function hide(message){
             mIsVisible.data = false;
             message.isClosedFast = true;
             $timeout.cancel(message.timeoutId);
        }
        function pauseTimeout(message){
            mIsVisible.data = true;
            $timeout.cancel(message.timeoutId);
        }
        function resumeTimeout(message){
            console.log(mQueue);
            message.timeoutId =  $timeout(function(){
                mIsVisible.data = false;
                if(mQueue.length > 0){
                    show(mQueue.pop(), false, true);
                }
            }, DEFAULT_AUTO_CLOSE_TIME);
        }
        function setSounder(value){
            mSounder = value;
        }
        return {
            setMessage: setMessage,
            getMessage: getMessage,
            show: show,
            isVisible: isVisible,
            hide: hide,
            resumeTimeout: resumeTimeout,
            pauseTimeout: pauseTimeout,
            setSounder: setSounder
        };
    }
})();
(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('notificationFlashMessageCtrl', notificationFlashMessageCtrl);

    notificationFlashMessageCtrl.$inject = ['notificationFlashMessageSvc', 'notificationListSvc', '$state', '$uibModalStack'];

    function notificationFlashMessageCtrl(notificationFlashMessageSvc, notificationListSvc, $state, $uibModalStack) {

        var self = this;
        self.message = notificationFlashMessageSvc.getMessage();
        self.isVisible = notificationFlashMessageSvc.isVisible();
        self.onMouserHover = onMouserHover;
        self.onMouseLeave = onMouseLeave;
        self.close = close;
        self.onNotificationClicked = onNotificationClicked;
        self.isWorking = false;

        function close(message, $event){
            notificationFlashMessageSvc.hide(message);
            if($event) $event.stopPropagation();
        }
        function onMouserHover(message){
            notificationFlashMessageSvc.pauseTimeout(message.data);
        }
        function onMouseLeave(message){
            notificationFlashMessageSvc.resumeTimeout(message.data);
        }
        function onNotificationClicked(item, $event){
            if($event) $event.stopPropagation();
            close(item, $event);
            if(!item.is_read){
                if(self.isWorking) return;
                self.isWorking = true;
                notificationListSvc.markNotificationAsRead(item).then(function(){
                    self.isWorking = false;
                }, function(){
                    self.isWorking = false;
                });
            }
            if(!$event || ($event && $event.target === $event.currentTarget)) {
                $state.go(item.link.state.name, item.link.state.params, {reload: true, notify: true});
            }
            $uibModalStack.dismissAll();
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('pixerf')
        .directive('notificationFlashMessage', notificationFlashMessage);

    notificationFlashMessage.$inject = ['notificationFlashMessageSvc'];

    function notificationFlashMessage(notificationFlashMessageSvc) {
        var directive = {
            scope: {},
            restrict: 'E',
            templateUrl: 'app/components/notification-flash-message/notification-flash-message.html',
            controller: "notificationFlashMessageCtrl",
            controllerAs: 'vm',
            replace: true,
            link: function($scope, element, attrs){
               notificationFlashMessageSvc.setSounder($(element).find("audio")[0]);
            }
        };
        return directive;
    }
})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('notificationBtnCtrl', notificationBtnCtrl);

    notificationBtnCtrl.$inject = ['toastr', '$rootScope', 'notificationListSvc', 'activityUtils', 'pixerfApiActivitiesSvc', '$timeout', 'socketSvc', 'systemUtils', 'notificationFlashMessageSvc', '$scope', 'translationSvc'];

    function notificationBtnCtrl(toastr, $rootScope, notificationListSvc, activityUtils, pixerfApiActivitiesSvc, $timeout, socketSvc, systemUtils, notificationFlashMessageSvc, $scope, translationSvc) {

        var self = this;

        self.numUnreadActivities = notificationListSvc.getNumUnreadActivities();
        var mIsSubscribed = false;
        self.onListLoaded = onListLoaded;
        self.onNotificationListInit = onNotificationListInit;
        self.onNewNotificationAdded = onNewNotificationAdded;
        self.notificationListInstance = null;
        var tooltipTemplate = 'You have <%=howmany%>';
        self.tooltip = 'You have <%=howmany%>';
        self.isHover = false;
        self.onMarkAllAsReadBtnClicked = onMarkAllAsReadBtnClicked;
		self.onMarkedAsRead = onMarkedAsRead;
		self.onCloseBtnClicked = onCloseBtnClicked;
        init();

        function init(){
            $rootScope.$on('NOTIFICATION_READ', function(){
                buildLabel(self.numUnreadActivities.data);
            });
            getUnreadActivities();
            $timeout(function(){
                subscribeChannel();
            }, 3000);
        }
        function onNotificationListInit(instance){
            // self.notificationListInstance = instance;
            // self.notificationListInstance.init();
        }
        function subscribeChannel(){
            var channel = socketSvc.getPrivateChannel();
            if(channel && channel.state === "joined" && !mIsSubscribed){
                mIsSubscribed = true;
                channel.off(socketSvc.PIXERF_TOPICS.NOTIFICATIONS);
                channel.on(socketSvc.PIXERF_TOPICS.NOTIFICATIONS, function(msg){
                    console.log(msg);
                    var activity = activityUtils.transform(msg);
                    notificationListSvc.addNotification(activity)
                    notificationFlashMessageSvc.show(activity);
                    onNewNotificationAdded();
                    systemUtils.digest($scope);
                })
                channel.onClose(socketSvc.PIXERF_TOPICS.NOTIFICATIONS, function(msg){
                    mIsSubscribed = false;
                })
                channel.onError(socketSvc.PIXERF_TOPICS.NOTIFICATIONS, function(msg){
                    mIsSubscribed = false;
                })
            }
        }
        function onNewNotificationAdded(){
            self.numUnreadActivities.data++;
            updateNumUnreadNotifications(self.numUnreadActivities.data++);
            buildLabel(self.numUnreadActivities.data);
            self.isHover = true;
            $timeout(function(){
                self.isHover = false;
            }, 3000);
            notificationListSvc.updatePageTitle();
        }
        function updateNumUnreadNotifications(value){
            self.numUnreadActivities.data = value;
        }
        function buildLabel(numUnreadActivities){
            self.tooltip = _.template(tooltipTemplate)({'howmany': numUnreadActivities+ ( numUnreadActivities=== 1 ? ' notification' : ' notifications') });
        }
        function onListLoaded(response){
            updateNumUnreadNotifications(activityUtils.getTotalUnreadActivities(response));
            buildLabel(self.numUnreadActivities.data);
            notificationListSvc.updatePageTitle($rootScope.title);
        }
        function getUnreadActivities(){
            var page = 1;
            var type = "me";
            pixerfApiActivitiesSvc.get({type: type, page: page}).$promise.then(function(response){
                updateNumUnreadNotifications(activityUtils.getTotalUnreadActivities(response));
                buildLabel(self.numUnreadActivities.data);
                notificationListSvc.updatePageTitle($rootScope.title);
            }, function(err){
                toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
            })
        }
        function onMarkAllAsReadBtnClicked(){
            self.isWorking = true;
            notificationListSvc.markAllNotificationsAsRead().then(function(){
                self.isWorking = false;
                updateNumUnreadNotifications(0);
                buildLabel(self.numUnreadActivities.data);
            }, function(err){
                self.isWorking = false;
                toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
            });
        }
        function onMarkedAsRead(){
            buildLabel(self.numUnreadActivities.data);
        }
        function onCloseBtnClicked(){
			$timeout(function(){
				$("#header-navbar-btn").trigger("click");
            });
		}
    }
})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .directive('notificationBtn', notificationBtn);

    notificationBtn.$inject = ['numberUtils', 'pagingUtils'];

    function notificationBtn(numberUtils, pagingUtils) {
        var directive = {
            scope: {},
            restrict: 'E',
            templateUrl: 'app/components/notification-btn/notification-btn.html',
            replace: true,
            controller: 'notificationBtnCtrl',
            controllerAs: 'vm'
           
        };
        return directive;
    }
})();

(function () {
  'use strict';

  angular
    .module('pixerf')
    .directive('noticeSmallScreenPopup', noticeSmallScreenPopup);

  function noticeSmallScreenPopup() {

    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/notice-small-screen-popup/notice-small-screen-popup.html',
      replace: true
    };
    return directive;
  }

})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('nominationBadgeCtrl', nominationBadgeCtrl);

    nominationBadgeCtrl.$inject = ['$scope'];

    function nominationBadgeCtrl($scope) {

        var BADGES = [
            {
                nominationCount: 20,
                name: 'nominated'
            }
        ]
        var self = this;
        self.badges = [];

        $scope.$watch('nominationCount', function(newValue, oldValue){
            buildBadges(newValue);
        })

        function getBiggestBadge(nominationCount){
            for (var i  = BADGES.length - 1 ; i >= 0; i --){
                if(nominationCount > BADGES[i].nominationCount){
                    return BADGES[i];
                }
            }  
        }
        function buildBadges(nominationCount){
            self.badges = [];
            var badge = getBiggestBadge(nominationCount);
            if(!badge) return;
            self.badges.push(badge);
                
        }

    }
})();
(function () {
  'use strict';

  angular
    .module('pixerf')
    .directive('nominationBadge', nominationBadge);

  function nominationBadge() {

    var directive = {
      scope: {
        "nominationCount" : "="
      },
      restrict: 'E',
      templateUrl: 'app/components/nomination-badge/nomination-badge.html',
      controller: 'nominationBadgeCtrl',
      controllerAs: 'vm',
      replace: true
    };
    return directive;
  }

})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('newsfeedListCtrl', newsfeedListCtrl);

    newsfeedListCtrl.$inject = ['$rootScope', '$q', 'pixerfApiActivitiesSvc', 'toastr', '$scope', 'pagingUtils', '$state', 'translationSvc'];

    function newsfeedListCtrl($rootScope, $q, pixerfApiActivitiesSvc, toastr, $scope, pagingUtils, $state, translationSvc) {

        var self = this;
        self.activities = []
        self.fetchMoreActivities = fetchMoreActivities;
        self.onNotificationClicked = onNotificationClicked;
        self.type = "following"
        self.init = init;
        self.isNoMoreActivitiesToLoad = false;
        self.spinner = {
            isVisible: false
        }
        self.fetchParams = {
            page: 0
        }

        init();

        function init(){
            return fetchActivities(self.type, 1, true);
        }
        function fetchActivities(type, page, isFresh){
            if(self.spinner.isVisible){
                return;
            }
            var def = $q.defer();
            self.spinner.isVisible = true;
            if(isFresh){
                page = 1;
                self.activities = [];
            }
            self.spinner.isVisible = true;
            pixerfApiActivitiesSvc.get({type: type, page: page}).$promise.then(function(response){
                self.spinner.isVisible = false;
                self.activities = self.activities.concat(response.data.activities);
                self.isNoMoreActivitiesToLoad = pagingUtils.isNoMorePageToLoad(page, response);
                self.fetchParams.page++;
                if($scope.onListLoaded && isFresh){
                    $scope.onListLoaded({response: response});
                }
                def.resolve(response);
            }, function(err){
                def.reject(err);
                toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
                self.spinner.isVisible = false;
            })
            return def.promise;
        }
        function fetchMoreActivities(){
            if(self.spinner.isVisible){
                return;
            }
            var page = self.fetchParams.page + 1;
            fetchActivities(self.type, page)
        }
        function onNotificationClicked(item, $event){
            if($event) $event.stopPropagation();
            if(!$event || ($event && $event.target === $event.currentTarget)) {
                $state.go(item.object.link.state.name, item.object.link.state.params, {reload: true, notify: true})
            }
        }

        if($scope.onInit){
            $scope.onInit({instance: self});
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .directive('newsfeedList', notificationList);

    notificationList.$inject = [];

    function notificationList() {
        var directive = {
            scope: {
                onListLoaded: '&?',
                onMarkedAllAsRead: '&?',
                onMarkedAsRead: '&?',
                onNewNotificationAdded: '&?',
                onInit: '&?',
                container: '=',
                type: '@'
            },
            restrict: 'E',
            templateUrl: 'app/components/newsfeed-list/newsfeed-list.html',
            controller: "newsfeedListCtrl",
            controllerAs: 'vm',
            replace: true
        };
        return directive;
    }
})();

/**
 * Controller for home module
 */
(function(){
  'use strict';
  angular
    .module('pixerf')
    .factory('navigationStepSvc', navigationStepSvc);

    function navigationStepSvc(){
        function findStep (steps, name){
            for(var i = 0; i < steps.length ;i ++){
                if(steps[i].name === name){
                    return steps[i];
                }
            }
        }
        function resetHightLightedStep(steps){
            for(var i = 0; i < steps.length ;i ++){
                steps[i].isActive = false;
            }   
        }
        function highlightStep(steps, step){
            resetHightLightedStep(steps);
            var workingStep = findStep(steps, step);
            workingStep ? workingStep.isActive = true : steps[0].isActive = true;
        }
        function highlightSteps(steps, step){
            for(var i = 0; i < steps.length ;i ++){
                steps[i].isActive = true;
                if(steps[i].name === name){
                    steps[i].isActive = true;
                    return;
                }
            }
        }
        return {
                highlightStep: highlightStep
            }
    }
})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .directive('navigationStep', navigationStep);
    function navigationStep() {
        return {
            restrict: 'E',
            replace: true,
            templateUrl: 'app/components/navigation-step/navigation-step.html',
            scope: {
                'steps': '=',
                'onStepClicked' : '&'
            },
        };
    }
})();
(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('navigationHorizontalCtrl', navigationHorizontalCtrl);

	navigationHorizontalCtrl.$inject = ['$scope', 'moment', 'sessionManagerSvc'];

	function navigationHorizontalCtrl($scope, moment, sessionManagerSvc) {

		var self = this;
		self.loginedUser = sessionManagerSvc.getCurrentLoginUser().data;

		init();

		function init() {
			if (!$scope.collapseId) {
				$scope.collapseId = "navigation-" + moment().unix();
			}
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('navigationHorizontal', navigationHorizontal);

	navigationHorizontal.$inject = [];

	function navigationHorizontal() {
		var directive = {
			scope: {
				instance: '=',
				activeClass: '@',
				collapseId: '@',
				options: '='
			},
			restrict: 'E',
			templateUrl: 'app/components/navigation-horizontal/navigation-horizontal.html',
			controller: "navigationHorizontalCtrl",
			controllerAs: 'vm',
			replace: true
		};
		return directive;
	}
})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .factory('myCreditCheckoutBtnSvc', myCreditCheckoutBtnSvc);

     myCreditCheckoutBtnSvc.$inject = [];

    function myCreditCheckoutBtnSvc() {
        var error = {
            "INSUFFICIENT_FUNDS": "INSUFFICIENT_FUNDS"
        }
        
        return {
            error: error
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('pixerf')
        .controller('myCreditCheckoutBtnCtrl', myCreditCheckoutBtnCtrl);

    myCreditCheckoutBtnCtrl.$inject = ['$scope', 'pixerfConfirmPopupSvc', 'pixerfApiPaymentSvc', '$q', '$timeout', 
        'myCreditCheckoutBtnSvc', 'cartSvc', 'googleAnalyticSvc', 'sessionManagerSvc', 'messageConst'];

    function myCreditCheckoutBtnCtrl($scope, pixerfConfirmPopupSvc, pixerfApiPaymentSvc, $q, $timeout, 
            myCreditCheckoutBtnSvc, cartSvc, googleAnalyticSvc, sessionManagerSvc, messageConst) {

        var self = this;

        var mPopupClass = 'pixerf-credit-card-popup__wrapper';
        self.onCheckoutBtnClicked = onCheckoutBtnClicked;
        self.card = {};
        self.isWorking = false;
        $scope.$on(messageConst.BROADCAST.ACTION_PAY_AFTER_SIGNED, function(event, args) {
            onCheckoutBtnClicked();
        });

        init();

        function init(){
            // var mode = new PixerfEnv().getEnv();
        }
        function pay(data) {
            var def = $q.defer();
            var lineItemsIds = _.reduce(cartSvc.getCart().data.cart_items, function(memo, it){
                memo.push(it.id);
                return memo;
            }, []);
            googleAnalyticSvc.trackBtnClick("Checkout Using My Credit Option");
            pixerfApiPaymentSvc.save({action: 'charge'},{ids: lineItemsIds}).$promise.then(function(response){
                def.resolve();
                onComplete(response);
                cartSvc.reset();
                updateCreditBalance(response);
            }, function(pixerfPaymentErrorObject){
                onError(pixerfPaymentErrorObject.data);
                def.reject(pixerfPaymentErrorObject.data);
            });
            return def.promise;
        }
        function updateCreditBalance(creditData){
            var loginnedUser = sessionManagerSvc.getCurrentLoginUser().data;
            loginnedUser.user_credit_plan.balance = creditData.balance;
            sessionManagerSvc.setCurrentLoginUser(loginnedUser);
        }
        function onError(pixerfPaymentErrorObject){
            if($scope.onError){
                $scope.onError({pixerfPaymentErrorObject: pixerfPaymentErrorObject});
            }
        }
        function onComplete(data){
            self.popup.close();
            if($scope.onComplete){
                $scope.onComplete({data: {order_id: data.order_id}});
            }
        }
        function onCheckoutBtnClicked() {
            if ($scope.isGuestPayment) {
                $scope.processBeforePay().then(function (params) {
                    if(self.isWorking) return;
                    self.isWorking = true;
                    self.card = {};
                    self.popup = pixerfConfirmPopupSvc.showPopup({
                        message: "<div>Checkout using your credit.</div>",
                        windowClass: mPopupClass,
                        okFn: pay
                    });
                    self.isWorking = false;
                })
                return;
            }
            
            if(self.isWorking) return;
            self.isWorking = true;
            self.card = {};
            self.popup = pixerfConfirmPopupSvc.showPopup({
                message: "<div>Checkout using your credit.</div>",
                windowClass: mPopupClass,
                okFn: pay
            });
            self.isWorking = false;
        }
    }
})();
(function () {
  'use strict';

  angular
    .module('pixerf')
    .directive('myCreditCheckoutBtn', myCreditCheckoutBtn);

  function myCreditCheckoutBtn() {

    var directive = {
      scope: {
          'onComplete': '&',
          'onError': '&',
          'validator': '&?',
          'onValidationPassed': '&?',
          'isDisabled': '=',
          'amount': '@',
          'processBeforePay': '&?',
          'isGuestPayment':'=?'
      },
      restrict: 'E',
      templateUrl: 'app/components/my-credit-checkout-btn/my-credit-checkout-btn.html',
      controller: 'myCreditCheckoutBtnCtrl',
      controllerAs: 'vm',
      replace: true
    };
    return directive;
  }

})();

/**
 * Controller for my credit module
 */
(function () {
	'use strict';
	angular
		.module('pixerf')
		.factory('myCreditSvc', myCreditSvc);
	myCreditSvc.$inject = ['pixerfApiSalesSvc', '$q', 'toastr'];

	function myCreditSvc(pixerfApiSalesSvc, $q, toastr) {
		function fetchCredits() {
			var def = $q.defer();
			pixerfApiSalesSvc.get_credits().$promise.then(function (response) {
				def.resolve(response);
			}, function (err) {
				toastr.error("Failed to get your credits information. Please try again");
				def.reject(err);
			})
			return def.promise;
		}
		return {
			fetchCredits: fetchCredits
		};
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('myCreditCtrl', myCreditCtrl);

	myCreditCtrl.$inject = ['$scope', 'sessionManagerSvc'];

	function myCreditCtrl($scope, sessionManagerSvc) {
		var self = this;
		self.today = moment().format('DD MMMM YYYY');
		$scope.$parent.vm.contextPage = "My Credit";
		self.loginUser	= sessionManagerSvc.getCurrentLoginUser().data;
		var credit_plans = self.loginUser.user_credit_plan ? self.loginUser.user_credit_plan.balance : 0;
		self.credit = self.loginUser.credit_balance ? self.loginUser.credit_balance : credit_plans;
		self.guestUser = self.loginUser && !self.loginUser.account_type;
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('mutilineDropdownCtrl', mutilineDropdownCtrl);

	mutilineDropdownCtrl.$inject = ['$scope'];

	function mutilineDropdownCtrl($scope) {

		var self = this;
		self.onSelectedItem = onSelectedItem;
		self.items = $scope.items;
		self.selected = $scope.selected;

		$scope.$watch("selected", function (newVal, oldVal) {
			if ($scope.isMultiChoice) {
				buildSelectedItems();
			} else {
				buildSelectedItem();
			}
		})

		init();

		function init() {
			if ($scope.isMultiChoice) {
				self.selectedItem = [];
				buildSelectedItems();
			} else {
				self.selectedItem = {};
				buildSelectedItem()
			}
		}

		function buildSelectedItem() {
			var result = false;
			for (var i = 0; i < self.items.length; i++) {
				if (self.items[i].value === $scope.selected) {
					self.items[i].isSelected = true;
					self.selectedItem = self.items[i];
					result = true;
				} else {
					self.items[i].isSelected = false;
				}
			}
			if (!result) {
				self.items[0].isSelected = true;
				self.selectedItem = self.items[0];
			}
		}

		function buildSelectedItems() {
			for (var i = 0; i < self.items.length; i++) {
				if ($scope.selected.includes(self.items[i].value)) {
					self.items[i].isSelected = true;
					self.selectedItem = _.uniq(self.selectedItem.concat(self.items[i]));
				} else {
					self.items[i].isSelected = false;
				}
			}
		}

		function onSelectedItem(item) {
			selectItem(item, self.selectedItem);
			if (!$scope.isMultiChoice) {
				self.selectedItem = item;
			} else if (!item.isSelected) {
				self.selectedItem = _.reject(self.selectedItem, function (it) {
					return it.value === item.value;
				})
			} else {
				self.selectedItem = self.selectedItem.concat(item);
			}
			$scope.onChanged({
				data: self.selectedItem
			});
		}

		function selectItem(item, selectedItem) {
			if (!$scope.isMultiChoice) {
				item.isSelected = true;
				if (selectedItem && item.value != selectedItem.value) {
					for (var i = 0; i < self.items.length; i++) {
						if (self.items[i].value === selectedItem.value) {
							self.items[i].isSelected = false;
							break;
						}
					}
				}
			} else {
				item.isSelected = !item.isSelected;
			}
		}
	}
})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .directive('mutilineDropdown', mutilineDropdown);

    mutilineDropdown.$inject = [];

    function mutilineDropdown() {
        var directive = {
            scope: {
                items: "=",
                onChanged: "&",
                selected: "=",
                isMultiChoice: "@",
                hideCheckIcon: "@"
            },
            restrict: 'E',
            templateUrl: 'app/components/mutiline-dropdown/mutiline-dropdown.html',
            replace: true,
            controller: 'mutilineDropdownCtrl',
            controllerAs: 'vm'
           
        };
        return directive;
    }
})();

(function () {

	angular
		.module('pixerf')
		.factory('mobileMainMenuSvc', mobileMainMenuSvc);

	mobileMainMenuSvc.$inject = [];

	function mobileMainMenuSvc() {

		var mChallengeNav = [
			{name: 'Explore Challenges', route:"", href: '#/run-a-challenge-page'},
			{name: 'Live Challenges', route:"", href: '#/run-a-challenge-page/live-challenges'},
			{name: 'Past Challenges', route:"", href: '#/run-a-challenge-page/past-challenges'},
			{name: 'Challenge Agreement', route: "", href: '#/run-a-challenge-page/community-challenge-agreement'}
		]

		var mBuyStockNav = [ 
			{name: 'Explore Stock', route: "buy-stock-page.about-stock", href: '#/buy-stock-page'},
			{name: 'Trending', route: "buy-stock-page.trending", href: '#/buy-stock-page/trending'},
			{name: 'Discover', route: "buy-stock-page.discover", href: '#/buy-stock-page/discover'},
			{name: 'Editors\' Pick', route: "buy-stock-page.editor-pick", href: '#/buy-stock-page/editor-pick'},
			{name: 'Galleries', route: "buy-stock-page.galleries.signature-galleries", href: '#/buy-stock-page/galleries'}
		]

		var mBusinessNav = [ 
			{name: 'Explore Business', route: "about-business-page.about-business", href: '#/explore-business'},
			{name: 'Case Studies', route: "", href: '#/explore-business/case-studies'},
			{name: 'Pricing', route: "", href: '#/explore-business/pricing'}
		]

		var mNewsNav = [
			{name: 'XEEK - Visual. Culture. Tech.', route:"", href: 'https://xerfie.pixerf.com'},
			{name: 'Media', route:"media-page", href: '#/media'}
		]

		var mCreatorsNav = [
			{name: 'Explore Creators', route: "explore-creators-page.explore-communnity-hub", href: '#/explore-creators-page'},
			{name: 'Live Challenges', route: "run-a-challenge-page.live-challenges", href: '#/run-a-challenge-page/live-challenges'},
			{name: 'About Community', route: "for-creator-page.about-community", href: '#/for-creator-page'},
		]

		var mCreatorsContributorsNav = [
			{name: 'Explore Creators', route: "explore-creators-page.explore-communnity-hub", href: '#/explore-creators-page'},
			{name: 'Live Challenges', route: "run-a-challenge-page.live-challenges", href: '#/run-a-challenge-page/live-challenges'},
			{name: 'Creator Agreement', route: "explore-creators-page.creator-agreement", href: '#/explore-creators-page/creator-agreement'},
			{name: 'Payout and Pricing', route: "explore-creators-page.payout-and-pricing", href: '#/explore-creators-page/payout-and-pricing'},
			{name: 'About Community', route: "for-creator-page.about-community", href: '#/for-creator-page'},
		]

		function getChallengeNav(){
            return mChallengeNav;
        }

        function getBuyStockNav(){
            return mBuyStockNav;
        }

        function getBusinessNav(){
            return mBusinessNav;
        }

        function getNewsNav(){
            return mNewsNav;
        }

        function getCreatorsNav(){
            return mCreatorsNav;
        }

		function getCreatorsContributorNav(){
            return mCreatorsContributorsNav;
        }

		return {
			getChallengeNav: getChallengeNav,
			getBuyStockNav: getBuyStockNav,
            getBusinessNav: getBusinessNav,
            getNewsNav: getNewsNav,
            getCreatorsNav: getCreatorsNav,
			getCreatorsContributorNav: getCreatorsContributorNav
		};
	}
})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('mobileMainMenuCtrl', mobileMainMenuCtrl);

    mobileMainMenuCtrl.$inject = ['$scope', '$state', '$location', 'sessionManagerSvc', '$timeout', 'systemUtils', 'authSvc', '$translate', 'mobileMainMenuSvc', 'selectSignUpTypePopupSvc', 'signInPopupSvc', '$rootScope', 'messageConst'];

    function mobileMainMenuCtrl($scope, $state, $location, sessionManagerSvc, $timeout, systemUtils, authSvc, $translate, mobileMainMenuSvc, selectSignUpTypePopupSvc, signInPopupSvc, $rootScope, messageConst) {

        var self = this;
        var env = new PixerfEnv();

		self.onCloseBtnClicked = onCloseBtnClicked;
        self.onMarketplaceBtnClicked = onMarketplaceBtnClicked;
        self.onChangeLanguageClicked = onChangeLanguageClicked;
        self.user = authSvc.getUser().data;
        self.loginnedUser = sessionManagerSvc.getCurrentLoginUser().data;
        self.challengeNav = mobileMainMenuSvc.getChallengeNav();
		self.buyStockNav = mobileMainMenuSvc.getBuyStockNav();
        self.businessNav = mobileMainMenuSvc.getBusinessNav();
		self.creatorsNav = mobileMainMenuSvc.getCreatorsNav();
		self.newsNav = mobileMainMenuSvc.getNewsNav();
        self.onSignUpBtnClicked = onSignUpBtnClicked;
        self.onSignInBtnClicked = onSignInBtnClicked;
        self.onLogoClicked = onLogoClicked;

        self.linkToBlog = "http://feed-qa.pixerf.com";
        if(env.getEnv() === env.ENV.PRODUCTION){
            self.linkToBlog = "http://xerfie.pixerf.com";
        }

        $rootScope.$on(messageConst.BROADCAST.USER_DATA_CHANGE, function () {
			self.loginnedUser = sessionManagerSvc.getCurrentLoginUser().data;
            genCreatorsNav();
		})

        init();

        function init(){
            genCreatorsNav();
        }
        
        function genCreatorsNav(){
            if(self.loginnedUser && self.loginnedUser.isContributor){
                self.creatorsNav = mobileMainMenuSvc.getCreatorsContributorNav();
            } else {
                self.creatorsNav = mobileMainMenuSvc.getCreatorsNav();
            }
        }

        function onMarketplaceBtnClicked(){
			onCloseBtnClicked();
            if($state.current.name.indexOf("marketplace") == -1){
                var path = sessionManagerSvc.getMarketplaceTabHistory();
                var index = path.indexOf("?");
                var page='';
                if(index !== -1){
                    page = systemUtils.getURLParameter(path, "page");
                    path = path.substr(0, index);
                    $location.path(path).search({'page': page});
                } else {
                    $location.path(path);
                }
            }
		}

		function onCloseBtnClicked(){
			$timeout(function(){
				$("#header-navbar-btn").trigger("click");
            });
        }
        
        function onChangeLanguageClicked(lang){
            $translate.use(lang);
            onCloseBtnClicked();
        }

        function onSignUpBtnClicked() {
			onCloseBtnClicked();
			selectSignUpTypePopupSvc.showPopup();
		}

		function onSignInBtnClicked() {
			onCloseBtnClicked();
			signInPopupSvc.showPopup();
		}

        function onLogoClicked(){
            onCloseBtnClicked();
            $state.go("home");
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('pixerf')
        .directive('mobileMainMenu', mobileMainMenu);
    mobileMainMenu.$inject = ['$timeout'];
    function mobileMainMenu($timeout) {
        return {
            restrict: 'E',
            replace: true,
            templateUrl: 'app/components/mobile-main-menu/mobile-main-menu.html',
            controller: 'mobileMainMenuCtrl',
            controllerAs: "vm",
            scope: {
            }
        };
    }
})();                                                                  
(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('missionStatusListCtrl', missionStatusListCtrl);

	missionStatusListCtrl.$inject = ['$scope', '$filter'];

	function missionStatusListCtrl($scope, $filter) {

		var self = this;
		// self.missions = $scope.missions;
		// self.missions = [
		// 	{ id: 1178, title: 'Marimekko Shoot', type: 'draft', start_date: '03/04/2018' },
		// 	{ id: 1345, title: 'Art in Motion', type: 'revise', start_date: '29/03/2018' },
		// 	{ id: 1256, title: 'Spring/Summer Collection', type: 'approved', start_date: '29/03/2018' }
		// ];

	}
})();
(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('missionStatusList', missionStatusList);
	missionStatusList.$inject = [];
	function missionStatusList() {
		return {
			restrict: 'E',
			replace: true,
			templateUrl: 'app/components/mission-status-list/mission-status-list.html',
			controller: 'missionStatusListCtrl',
			controllerAs: "vm",
			scope: {
				missions: "="
			}
		};
	}
})();
(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('missionStatusItemCtrl', missionStatusItemCtrl);

	missionStatusItemCtrl.$inject = ['$scope', 'pixerfApiMissionSvc', 'toastr', 'pixerfConfirmPopupSvc', '$state', 'sessionManagerSvc'];

	function missionStatusItemCtrl($scope, pixerfApiMissionSvc, toastr, pixerfConfirmPopupSvc, $state, sessionManagerSvc) {
		var self = this;
		self.mission = $scope.mission;
		self.spinner = { isVisible: false };
		self.onMissionDeleted = onMissionDeleted;
		self.isWorking = false;
		self.isLastPage = false;
		self.items = null;
		self.searchParams = {
			page: 1,
			page_size: 20
		};
		self.isDraft = $scope.mission.process_state === 'draft';
		self.isPendingApproval = $scope.mission.process_state === 'pending_approval';
		self.isPendingPayment = $scope.mission.process_state === 'pending_payment';
		self.isRejected = $scope.mission.process_state === 'rejected';
		self.isReadyToLaunch = $scope.mission.process_state === 'ready_to_launch';
		self.isActionRequired = $scope.mission.process_state === 'to_revise';
		self.isLaunched = $scope.mission.process_state === 'launched';
		self.user = sessionManagerSvc.getCurrentLoginUser().data;
		self.isMyMision = sessionManagerSvc.isMyMission(self.mission);

		init();

		function generateByStatus() {
			if (self.isDraft) {
				self.statusLabel = 'Draft';
				self.linkToAction = "setting.manage-missions.create-mission.review({id:" + self.mission.id + "})";
			} else if (self.isRejected) {
				self.statusLabel = 'Rejected';
				self.descriptionText = 'Your Mission did not meet our guidelines and has been rejected. To find out more, you can contact us <a href="mailto:business@pixerf.com" class="text--bold text--color-black">here</a>';
				self.actionButtonText = '';
				self.linkToAction = "";
			} else if (self.isPendingApproval) {
				self.descriptionText = 'Your Mission is being reviewed by our team. Approvals usually take 3-5 working days from the date the brief is submitted.';
				self.statusLabel = 'In Review';
				self.linkToAction = "setting.mission-pending-detail-page({id:" + self.mission.id + "})";
			} else if (self.isPendingPayment) {
				self.descriptionText = 'Your Mission has been reviewed! Please make payment to launch.';
				self.statusLabel = 'Approved';
				self.actionButtonText = 'Payment';
				self.linkToAction = "setting.mission-pending-detail-page({id:" + self.mission.id + "})";
			} else if (self.isActionRequired) {
				self.statusLabel = 'Action Required';
				self.descriptionText = 'Your Mission cannot launch. Ensure you have made all recommended changes before we can approve your brief.';
				self.actionButtonText = 'Edit';
				self.linkToAction = "setting.manage-missions.create-mission.review({id:" + self.mission.id + "})";
			} else if (self.isReadyToLaunch) {
				self.statusLabel = 'Ready to Launch';
				self.descriptionText = '';
				self.actionButtonText = 'Launch';
				self.linkToAction = "setting.mission-pending-detail-page({id:" + self.mission.id + "})";
			} else if (self.isLaunched) {
				self.statusLabel = 'Launched';
				self.descriptionText = '';
			}
			if(self.user.isMaketerInternal && (self.isRejected || self.isPendingPayment)){
				self.actionButtonText = '';
			}
		}

		function init() {
			generateByStatus();
		}

		function onMissionDeleted(missionId) {
			if (self.isWorking) return;
			var modal = pixerfConfirmPopupSvc.showPopup({ message: 'Are you sure you want to delete this Mission?', hideConfirmText: true, hideTitle: true });
			modal.result.then(function () {
				self.isWorking = true;
				pixerfApiMissionSvc.delete({ id: missionId }).$promise.then(function (response) {
					self.isWorking = false;
					$scope.onMissionDeleted({ mission: $scope.mission });
					toastr.success("Mission has been deleted!");
				}, function () {
					self.isWorking = false;
					toastr.error("Failed to delete this Mission!");
				});
			});
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('missionStatusItem', missionStatusItem);
	missionStatusItem.$inject = [];
	function missionStatusItem() {
		return {
			restrict: 'E',
			replace: true,
			templateUrl: 'app/components/mission-status-item/mission-status-item.html',
			controller: 'missionStatusItemCtrl',
			controllerAs: "vm",
			scope: {
				mission: "=",
				onMissionDeleted: "&"
			}
		};
	}
})();
(function () {
  'use strict';

  angular
    .module('pixerf')
    .controller('missionSponsorLogoCtrl', missionSponsorLogoCtrl);

  missionSponsorLogoCtrl.$inject = ['$scope', 'pixerfUrl', 'uploadProfilePhotoSvc']

  function missionSponsorLogoCtrl($scope, pixerfUrl, uploadProfilePhotoSvc) {

    var self = this;
    self.onUploadBtnClicked = onUploadBtnClicked;
    function onUploadBtnClicked() {
      var modal = uploadProfilePhotoSvc.showPopup({
        type: 'profile', url: pixerfUrl.full + 'api/missions/' + self.mission.id + '/sponsor',
        headline: 'Update Mission\'s sponsor logo',
        hideIcon: true
      });
      modal.result.then(function (data) {
        if (!self.mission.sponsor) {
          self.mission.sponsor = {};
        }
        self.mission.sponsor.profile_image = data.thumbnails["300x"];
        self.mission.sponsor.logoUrl = data.thumbnails["300x"];
      });
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('pixerf')
    .component('missionSponsorLogo',  {
      bindings: {
        "mission" : "=",
        "context": "@",
        "onInit": "&?"
      },
      templateUrl: 'app/components/mission-sponsor-logo/mission-sponsor-logo.html',
      controller: 'missionSponsorLogoCtrl',
      controllerAs: 'vm'
    });

})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('missionRewardCtrl', missionRewardCtrl);

    missionRewardCtrl.$inject = ['createMissionSvc', 'badgeUtils', 'priceUtils'];

    function missionRewardCtrl(createMissionSvc, badgeUtils, priceUtils) {

        var self = this;
		self.isWorking = false;
        self.onRewardChanged = onRewardChanged;
        self.onMissionPriceChanged = onMissionPriceChanged;
		self.prizeRuleSet = createMissionSvc.getPrizeRuleSet();
		init();
		function buildPrize(){
			var prizes_grouped = badgeUtils.compactPrizes(self.mission.prizes);
			if(prizes_grouped["WINNER"].value == 0){
				prizes_grouped["WINNER"].value = self.prizeRuleSet[self.mission.price.name]["WINNER"].value.min;
			}
			return prizes_grouped;
		}
		function init(){
			self.mission.prizes_grouped = buildPrize();
            onRewardChanged();
            if(self.onInit){
                self.onInit({instance: self});
            }
		}
		function onMissionPriceChanged(selectedPrice){
            self.mission.price = selectedPrice;
            self.mission.bill.totalToPay = selectedPrice.service_fee ? self.mission.prizes_grouped.totalReward + priceUtils.calculatePriceAfterDiscount(selectedPrice.service_fee, selectedPrice.discounts) : self.mission.prizes_grouped.totalReward;
        }
		function onRewardChanged() {
			if(!self.mission.bill) self.mission.bill = {};
			if(self.mission.prizes_grouped["WINNER"].quantity > 10000 || (self.mission.prizes_grouped["CONSOLATION"] && self.mission.prizes_grouped["CONSOLATION"].quantity > 10000)) return;
			self.mission.prizes_grouped["WINNER"].total = self.mission.prizes_grouped["WINNER"].value * self.mission.prizes_grouped["WINNER"].quantity;
			if(self.mission.prizes_grouped["CONSOLATION"]){
				self.mission.prizes_grouped["CONSOLATION"].total = self.mission.prizes_grouped["CONSOLATION"].value * self.mission.prizes_grouped["CONSOLATION"].quantity;
				self.mission.prizes_grouped.totalReward = self.mission.prizes_grouped["WINNER"].total + self.mission.prizes_grouped["CONSOLATION"].total;
			} else {
				self.mission.prizes_grouped.totalReward = self.mission.prizes_grouped["WINNER"].total;
			}			
			self.mission.bill.totalToPay = self.mission.price.service_fee ? self.mission.prizes_grouped.totalReward + priceUtils.calculatePriceAfterDiscount(self.mission.price.service_fee, self.mission.price.discounts) : self.mission.prizes_grouped.totalReward;
			self.mission.prizes = badgeUtils.extractPrizes(self.mission.prizes_grouped);
        }
    }
})();
(function () {
  'use strict';

  angular
    .module('pixerf')
    .component('missionReward',  {
      bindings: {
        "mission" : "=",
        "onInit": "&?"
      },
      templateUrl: 'app/components/mission-reward/mission-reward.html',
      controller: 'missionRewardCtrl',
      controllerAs: 'vm'
    });

})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('missionReviewCtrl', missionReviewCtrl);

    missionReviewCtrl.$inject = ['sessionManagerSvc'];

    function missionReviewCtrl(sessionManagerSvc) {
        var self = this;
		self.loginUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.isMine = sessionManagerSvc.isMine(self.loginUser);
    }
})();
(function () {
  'use strict';

  angular
    .module('pixerf')
    .component('missionReview', {
      templateUrl: 'app/components/mission-review/mission-review.html',
      bindings: {
        mission: '=',
        isEditable: '=',
        onPay: '&?'
      },
      controller: 'missionReviewCtrl as vm'
    });

})();

(function () {
  'use strict';

  angular
    .module('pixerf')
    .controller('missionMoveStateBtnCtrl', missionMoveStateBtnCtrl);

  missionMoveStateBtnCtrl.$inject = ['pixerfConfirmPopupSvc', 'pixerfApiMissionSvc', 'messageConst', 'pixerfApiPaymentSvc', 'createMissionSvc', 'toastr', '$state', 'sessionManagerSvc', 'missionPreviewSvc', 'translationSvc'];

  function missionMoveStateBtnCtrl(pixerfConfirmPopupSvc, pixerfApiMissionSvc, messageConst, pixerfApiPaymentSvc, createMissionSvc, toastr, $state, sessionManagerSvc, missionPreviewSvc, translationSvc) {

    var self = this;
    self.onApproveMissionClicked = onApproveMissionClicked;
    self.onRejectMissionClicked = onRejectMissionClicked;
    self.onPayClicked = onPayClicked;
    self.onLaunchMissionBtnClicked = onLaunchMissionBtnClicked;
    self.onToReviseMissionClicked = onToReviseMissionClicked;
    self.onSaveDraftBtnClicked = onSaveDraftBtnClicked;
    self.onSubmitBtnClicked = onSubmitBtnClicked;
    self.onPreviewClicked = onPreviewClicked;
    self.loginUser = sessionManagerSvc.getCurrentLoginUser().data;
    self.isWorking = false;

    function curateMission(mission, action) {
      if (self.isWorking) return;
      var actionText = transformActionText(action);
      var confirmMessage = 'Are you sure you want to ' + actionText + ' this Mission?';
      var modal = pixerfConfirmPopupSvc.showPopup({ hideTitle: true, hideConfirmText: true, message: confirmMessage });
      modal.result.then(function () {
        self.isWorking = true;
        pixerfApiMissionSvc.review_process({ id: self.mission.id, action: action }).$promise.then(function (response) {
          if (action == 'approve') {
            toastr.success("This mission has been successfully approved");
          } else if (action == 'reject') {
            toastr.success("This mission has been successfully rejected");
          } else if (action == 'to_revise') {
            toastr.success("This mission has been successfully revised");
          }
          $state.go("setting.manage-missions.draft.list-mission-draft");
          self.isWorking = false;
        }, function (err) {
          self.isWorking = false;
          toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
        });
      })
    }
    function onApproveMissionClicked() {
      curateMission(self.mission, 'approve');
    }
    function onRejectMissionClicked() {
      curateMission(self.mission, 'reject');
    }
    function onToReviseMissionClicked() {
      curateMission(self.mission, 'to_revise');
    }
    function transformActionText(action) {
      if (action === 'to_revise') {
        return "make revisions to";
      }
      return action;
    }
    function onPayClicked() {
      if (self.isWorking) return;

      var confirmMessage = translationSvc.ARE_YOU_SURE_TO_DO_SOMETHING("PAY_THIS_MISSION");
      var modal = pixerfConfirmPopupSvc.showPopup({ hideTitle: true, hideConfirmText: true, message: confirmMessage });
      modal.result.then(function () {
        self.isWorking = true;
        pixerfApiPaymentSvc.save({ action: 'charge' }, { mission_id: self.mission.id }).$promise.then(function (response) {
          toastr.success("Your payment has been successfully processed!");
          self.mission.process_state = "ready_to_launch";
          self.loginUser.user_credit_plan.balance = parseFloat(response.balance);
          sessionManagerSvc.setCurrentLoginUser(self.loginUser);
          $state.go("setting.payment-successful", { id: self.mission.id });
          self.isWorking = false;
          if (self.onPay) self.onPay({ detail: response });
        }, function (err) {
          self.isWorking = false;
          if (err.data.message === errorConst.CHECKOUT_MY_CREDIT_INSUFFICIENT_FUNDS) {
            toastr.error(messageConst.error.MY_CREDIT_INSUFFICIENT_FUNDS);
          } else {
            toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
          }
        });
      })
    }
    function onLaunchMissionBtnClicked() {
      var successMessage = "Your Mission has been successfully launched!";
      var confirmMessage =  translationSvc.ARE_YOU_SURE_TO_DO_SOMETHING("LAUNCH_THIS_MISSION");
      var modal = pixerfConfirmPopupSvc.showPopup({ hideTitle: true, hideConfirmText: true, message: confirmMessage });
      modal.result.then(function () {
        pixerfApiMissionSvc.review_process({ id: self.mission.id, action: 'launch' }).$promise.then(function (response) {
          toastr.success(successMessage);
          $state.go("setting.mission-launched", { id: self.mission.id });
        }, function () {
          toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
        })
      })
    }
    function onSubmitBtnClicked() {
      if (self.isWorking) return;
      var action = "submit";
      var successMessage = "Your Mission has been successfully submitted!";
      var confirmMessage = translationSvc.ARE_YOU_SURE_TO_DO_SOMETHING("SUBMIT_THIS_MISSION");
      var modal = pixerfConfirmPopupSvc.showPopup({ hideTitle: true, hideConfirmText: true, message: confirmMessage });
      modal.result.then(function () {
        var errMsg = createMissionSvc.validateMission(self.mission);
        if (errMsg) {
          toastr.error(errMsg);
          return;
        }
        self.isWorking = true;
        pixerfApiMissionSvc.review_process({ id: self.mission.id, action: action }).$promise.then(function (response) {
          self.isWorking = false;
          toastr.success(successMessage);
          $state.go("setting.mission-pending-detail-page", { id: self.mission.id });
        }, function () {
          self.isWorking = false;
          toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
        })
      })
    }
    function onSaveDraftBtnClicked() {
      if (self.isWorking) return;
      self.isWorking = true;
      createMissionSvc.saveDraft(self.mission).then(function () {
        self.isWorking = false;
      }, function () {
        self.isWorking = false;
      });
    }

    function onPreviewClicked(mission) {
      missionPreviewSvc.showPopup(mission);
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('pixerf')
    .component('missionMoveStateBtn', {
        bindings: {
          "mission" : "=",
          "onPay": "&?"
        },
        templateUrl: 'app/components/mission-move-state-btn/mission-move-state-btn.html',
        controller: 'missionMoveStateBtnCtrl',
        controllerAs: 'vm'
    });


})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.factory('missionLaunchSuccessfullyPopupSvc', missionLaunchSuccessfullyPopupSvc);
	missionLaunchSuccessfullyPopupSvc.$inject = ['$uibModal'];

	function missionLaunchSuccessfullyPopupSvc($uibModal) {

		function showPopup(data) {
			return $uibModal.open({
				templateUrl: 'app/components/mission-launch-successfully-popup/mission-launch-successfully-popup.html',
				controller: 'missionLaunchSuccessfullyPopupCtrl',
				controllerAs: 'vm',
				animation: true,
				windowClass: 'zindex mission-launch-successfully-screen',
				resolve: {
					'resolveData': function () {
						return data;
					}
				}
			});
		}

		return {
			showPopup: showPopup
		};
	}
})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('missionLaunchSuccessfullyPopupCtrl', missionLaunchSuccessfullyPopupCtrl);

    missionLaunchSuccessfullyPopupCtrl.$inject = ['$uibModalInstance', '$state', 'resolveData'];

    function missionLaunchSuccessfullyPopupCtrl($uibModalInstance, $state, resolveData) {

		var self = this;
		self.close = close;
		self.mission = resolveData;

		self.message = {
			header: "Mission " + self.mission.title,
			content: "is successfully launched and out the door! Now sit back and wait for submissions to come in."
		};

		function close(){
			$uibModalInstance.close();
			$state.go("mission-detail-page.brief", {id: self.mission.id});
		}
    }
})();
(function() {
    'use strict';

    angular
        .module('pixerf')
        .service('missionInspirationPhotosSvc', missionInspirationPhotosSvc);
    missionInspirationPhotosSvc.$inject = ['pixerfApiMissionSvc', 'galleryUtils', 'toastr', 'translationSvc'];
    function missionInspirationPhotosSvc(pixerfApiMissionSvc, galleryUtils, toastr, translationSvc) {

        function getCurrentSelectedMediaCover(mission){
            return _.find(mission.media, function(m){
                return m.isSelected;
            });
        }
        function setAsMissionCover(media, mission){
            if(!media.isSelected){
                var currentSelectedMedia = getCurrentSelectedMediaCover(mission);
                if(currentSelectedMedia && media.id !== currentSelectedMedia.id){
                    currentSelectedMedia.isSelected = false;
                }
            }
            media.isSelected = !media.isSelected;
            pixerfApiMissionSvc.update({"id": mission.id}, {"mission": {"cover_media_id": media.isSelected ? media.id : null}}).$promise.then(function(response){
                mission.cover_media = response.mission.cover_media;
                galleryUtils.updateThumnailPath(mission);
                if(media.isSelected){
                    toastr.success("You have selected this as the Mission cover photo!");
                } else {
                    toastr.success("Please select another photo as the Mission cover photo!");
                }
            }, function(){
                toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
            })

        }
        function updateMissionCover(mission, mediaId){
            var candidate = _.find(mission.media, function(m){
                return m.id === mediaId;
            })
            if(candidate){
                mission.cover_media = candidate;
                candidate.isSelected = true;
            }
        }
        return {
            setAsMissionCover: setAsMissionCover,
            updateMissionCover: updateMissionCover
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('pixerf')
        .controller('missionInspirationPhotosCtrl', missionInspirationPhotosCtrl);

    missionInspirationPhotosCtrl.$inject = ['pixerfConfirmPopupSvc', 'fileConst', 'uploadPhotoSvc', 'missionInspirationPhotosSvc', 'galleryUtils', '$scope', 'pixerfApiMediaSvc', '$timeout', 'sessionManagerSvc', 'pixerfUrl', 'systemUtils', 'pathUtils', 'toastr', '$translate'];

    function missionInspirationPhotosCtrl(pixerfConfirmPopupSvc, fileConst, uploadPhotoSvc, missionInspirationPhotosSvc, galleryUtils, $scope, pixerfApiMediaSvc, $timeout, sessionManagerSvc, pixerfUrl, systemUtils, pathUtils, toastr, $translate) {
        var self = this;

        self.onSetCoverCheckboxClicked = onSetCoverCheckboxClicked;
        self.onRemoveImageBtnClicked = onRemoveImageBtnClicked;
        self.selectedCoverMedia = null;
        self.isWorking = false;
        self.errors = [];
        self.files = [];
        var errorHandlerFn = _.debounce(errorHandler, 1500);
        self.dropzoneConfig = {
            'instance': {},
            'options': {
                maxFilesize: 40,
                // maxFiles: 15,
                autoQueue: false,
                paramName: 'media',
                // accept: ['.jpeg', '.jpg'],
                dictDefaultMessage: '',
                parallelUploads: 10,
                dictCancelUploadConfirmation: "dfdfs",
                autoProcessQueue: false,
                thumbnailWidth: 155,
                thumbnailHeight: 155,
                maxThumbnailFilesize: 40,
                addRemoveLinks: false,
                dictRemoveFile: "Remove",
                dictCancelUpload: null,
                previewsContainer: '#mission-inspiration-photos-previews',
                method: "post",
                headers: {
                    "Authorization": "Bearer " + sessionManagerSvc.getToken()
                },
                dictFileTooBig: "File is too big ({{filesize}} MB). Max file size is: {{maxFilesize}} MB."
            }
        }
        self.dropzoneConfig.options.url = pixerfUrl.full + 'api/missions/' + $scope.mission.id + '/inspiration';
        // self.dropzoneConfig.options.accept = function (file, done) {
        //     var errMsg = fileTypeValidation(file);
        //     if (errMsg) {
        //         toastr.error(errMsg);
        //     }
        //     done(errMsg);
        // }
        // function fileTypeValidation(file) {
        //     if (file.type !== "image/jpeg") {
        //         return "Sorry, we only accept JPEG file.";
        //     }
        // }
        self.dropzoneConfig.eventHandlers = {
            addedfile: function(file){
                var error = "";
                error = validateFileType(file);
                if(error){
                    file.isPixerfError = true;
                    setErrors(error);
                    errorHandlerFn();
                    this.removeFile(file);
                }
                systemUtils.digest($scope);
            },
            'success': function (file, response) {
                $timeout(function () {
                    file.id = response.id;
					file.urlSmall = pathUtils.buildFilePath(file.id, "x400");
					file.url = pathUtils.buildFilePath(file.id, "1024x");
                    if(!$scope.mission.cover_media) {
                        $scope.mission.cover_media = file;
                        file.isSelected = true;
                        galleryUtils.updateThumnailPath($scope.mission);
                    }
                }, 1500);
                systemUtils.digest($scope);
            },
            'error': function (file, err) {
                if(err && err.data & err.data.key === "media_exceeds_size_limit"){
                    setErrors({code: fileConst.UPLOAD_PHOTO_VALIDATION.ERROR_CODE.INVALID_MAX_INSPIRATION_RESOLUTION, file: file});
                    errorHandlerFn();
                    return;
                } else if(err && err.data & err.data.key === "media_under_size_limit"){
                    setErrors({code: fileConst.UPLOAD_PHOTO_VALIDATION.ERROR_CODE.INVALID_MIN_INSPIRATION_RESOLUTION, file: file});
                    errorHandlerFn();
                    return;
                }
                if (err && err !== 'Upload canceled.') {
                    toastr.error(err);
                    this.removeFile(file);
                }
                $scope.mission.media = _.reject($scope.mission.media, function(f){
                    return f.name === file.name && !f.id;
                })
                systemUtils.digest($scope);
            },
            'canceled': function(file){
                toastr.error("Upload canceled");
            },
            'queuecomplete': function () {
                $scope.numProcessingFile = 0;
                systemUtils.digest($scope);
            },
            uploadprogress: function(file, progress){
                if(progress === 100) return;
                updateProgress(file, Math.round(progress));
                systemUtils.digest($scope);
            },
            'thumbnail': function (file, dataUrl) {
                if(file.isPixerfError) return;

                var error = validateUploadLimitation(file);
                if(!error){
                    error = validateFileExisted(file);
                }
                // if(!error){
                //     error = validateResolution(file);
                // }
                if(error){
                   try{
                        this.removeFile(file);
                    }catch(ex){
                    }
                    setErrors(error);
                    errorHandlerFn();
                } else {
                    $scope.numProcessingFile ++;
                    file.thumbnail = dataUrl;
                    $scope.mission.media.push(file);
                    this.enqueueFile(file);
                    this.processQueue();
                    self.hadInspirationImages = true;
                }
                $scope.$apply();
            }
        };
         function updateThumbnail(file, thumbnail){
            var updatingFile = _.find($scope.mission.media, function(itFile){
                return itFile.name === file.name && !itFile.id;
            })
            if(updatingFile){
                updatingFile.thumbnail = thumbnail;
            }
        }
        function updateProgress(file, progress){
            var updatingFile = _.find($scope.mission.media, function(itFile){
                return itFile.name === file.name && !itFile.id;
            })
            if(updatingFile){
                updatingFile.upload.progress = progress;
            }
        }
        function setErrors(error){
            self.errors.push(error);
        }
        function isExisted(uploadedFiles, file){
            return _.find(uploadedFiles, function(f){
                return uploadPhotoSvc.isSameFile(f, file);
            })
        }
        function validateResolution(validatedFile){
            if(uploadPhotoSvc.isAboveMaxResolution(validatedFile, fileConst.UPLOAD_PHOTO_VALIDATION.PHOTO_SIZE.MAX_INSPIRATION_RESOLUTION*1000*1000)){
                return {code: fileConst.UPLOAD_PHOTO_VALIDATION.ERROR_CODE.INVALID_MAX_INSPIRATION_RESOLUTION, file: validatedFile};
            }
            if(uploadPhotoSvc.isBelowMinResolution(validatedFile, fileConst.UPLOAD_PHOTO_VALIDATION.PHOTO_SIZE.MIN_INSPIRATION_RESOLUTION*1000*1000)){
                return {code: fileConst.UPLOAD_PHOTO_VALIDATION.ERROR_CODE.INVALID_MIN_INSPIRATION_RESOLUTION, file: validatedFile};
            }
        }
        function validateFileExisted(validatedFile){
            if(isExisted($scope.mission.media, validatedFile)){
                return {code: fileConst.UPLOAD_PHOTO_VALIDATION.ERROR_CODE.DUPLICATED, file: validatedFile};
            }
        }
        function validateUploadLimitation(validatedFile){
            if(isExceedNumberOfUpload($scope.mission.media, [validatedFile], $scope.mission.inspiration_limit)){
                return {code: fileConst.UPLOAD_PHOTO_VALIDATION.ERROR_CODE.EXCEED_NUMBER_OF_INSPIRATION_UPLOAD_PER_MISSION, file: validatedFile};
            }
        }
        function validateFileType(validatedFile){
            if (!uploadPhotoSvc.isValidFileType(validatedFile)) {
                return {code: fileConst.UPLOAD_PHOTO_VALIDATION.ERROR_CODE.INVALID_FILETYPE, file: validatedFile};
            }
        }
        function isExceedNumberOfUpload(fileUploaded, filesWillBeUploaded, limit){
            return fileUploaded.length + filesWillBeUploaded.length > limit;
        }
        function buildErrorFilename(files){
            var errMsg = '';
            for (var i = 0; i < files.length; i ++){
                errMsg += ("<div class='upload-photo__invalid-file text--truncate'> - " + files[i].file.name + "</div>");
            }
            return errMsg;
        }
        function errorHandler(errors){
            if(!errors) errors = self.errors;
            if(errors.length === 0) return;
            var errMsg = '';
            var callToActionMsg = '';
            var groupedError = _.groupBy(errors, function(item){
                return item.code;
            });
            for(var key in groupedError){
                callToActionMsg = '';
                if(key === fileConst.UPLOAD_PHOTO_VALIDATION.ERROR_CODE.DUPLICATED){
                    errMsg += "<p>" + $translate.instant("the-following-photos-uploaded-before") + "</p>";
                    callToActionMsg += "<p class='upload-photo__validation-popup__call-to-action-msg'>" + $translate.instant("try-uploading-new-ones") + "!</p>";
                }
                if(key === fileConst.UPLOAD_PHOTO_VALIDATION.ERROR_CODE.INVALID_MIN_INSPIRATION_RESOLUTION){
                    errMsg += "<p>" + $translate.instant("photos-too-small-uploaded") + "</p>";
                    callToActionMsg += ("<p class='upload-photo__validation-popup__call-to-action-msg'>" + $translate.instant("upload-photos-at-least-megapixels", {number: fileConst.UPLOAD_PHOTO_VALIDATION.PHOTO_SIZE.MIN_INSPIRATION_RESOLUTION}) + "</p>");
                }
                if(key === fileConst.UPLOAD_PHOTO_VALIDATION.ERROR_CODE.INVALID_MAX_INSPIRATION_RESOLUTION){
                    errMsg += "<p>The following photos were too large to be uploaded: </p>";
                    callToActionMsg += ("<p class='upload-photo__validation-popup__call-to-action-msg'>" + $translate.instant("upload-photos-at-most-megapixels", {number: fileConst.UPLOAD_PHOTO_VALIDATION.PHOTO_SIZE.MAX_INSPIRATION_RESOLUTION}) + "</p>");
                }
                if(key === fileConst.UPLOAD_PHOTO_VALIDATION.ERROR_CODE.EXCEED_NUMBER_OF_INSPIRATION_UPLOAD_PER_MISSION){
                    errMsg += "<p>The following photos could not be uploaded because you have exceeded your limit of " + $scope.mission.inspiration_limit +  " inspiration photos per mission:</p>";
                    callToActionMsg += ("<p class='upload-photo__validation-popup__call-to-action-msg'>Please remove some photos from your upload!</p>");
                }
                if(key === fileConst.UPLOAD_PHOTO_VALIDATION.ERROR_CODE.INVALID_FILETYPE){
                    errMsg += "<p>" + $translate.instant("upload-photos-wrong-format") + "</p>";
                    callToActionMsg += "<p class='upload-photo__validation-popup__call-to-action-msg'>" + $translate.instant("type-photo-allowed-upload", {type_1: 'JPG', type_2: 'JPEG'}) + "</p>";
                }
                errMsg += buildErrorFilename(groupedError[key]);
                errMsg += callToActionMsg;
            }
            pixerfConfirmPopupSvc.showPopup({
                hideCancelBtn: true,
                hideConfirmText: true,
                hideTitle: true,
                message: errMsg,
                windowClass: 'upload-photo__validation-popup',
                okBtnText: 'OK'
            });
            self.errors = [];
        }
        function onSetCoverCheckboxClicked(media){
            missionInspirationPhotosSvc.setAsMissionCover(media, $scope.mission);

        }
        function onRemoveImageDeleted(mediaId){
			$scope.mission.media = _.reject($scope.mission.media, function(item){
				return item.id === mediaId;
			})
		}
        function onRemoveImageBtnClicked(media){
            if(!media.id) {
                $scope.mission.media = _.reject($scope.mission.media, function(f){
                    return f.name === media.name;
                });
                self.dropzoneConfig.instance.removeFile(media);
                return;
            }
            if(self.isWorking) return;
            self.isWorking = true;
			pixerfApiMediaSvc.delete({id: media.id}).$promise.then(function(response){
                self.isWorking = false;
				onRemoveImageDeleted(media.id);
                if($scope.mission.cover_media && media.id === $scope.mission.cover_media.id){
                    $scope.mission.cover_media = null;
                    missionInspirationPhotosSvc.updateMissionCover( $scope.mission, response.cover_media_id);
                    galleryUtils.updateThumnailPath($scope.mission);
                }

				systemUtils.digest($scope);
			}, function(err){
                self.isWorking = false;
				toastr.error("Failed to delete this photo!");
				systemUtils.digest($scope);
			})
        }
        function init(){
            if($scope.mission && $scope.mission.media){
                for(var i = 0; i < $scope.mission.media.length; i++){
                    if($scope.mission.media[i].id === $scope.mission.cover_media.id){
                        $scope.mission.media[i].isSelected = true;
                    }
                }
            }

        }
        init();
    }
})();
(function() {
    'use strict';

    angular
        .module('pixerf')
        .directive('missionInspirationPhotos', missionInspirationPhotos);

    missionInspirationPhotos.$inject = [];

    function missionInspirationPhotos() {
        var directive = {
            scope: {
                mission: "=",
                numProcessingFile: "="
            },
            restrict: 'E',
            templateUrl: 'app/components/mission-inspiration-photos/mission-inspiration-photos.html',
            controller: "missionInspirationPhotosCtrl",
            controllerAs: 'vm'
        };

        return directive;

    }

})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .service('missionInspirationPhotoSvc', missionInspirationPhotoSvc);
    missionInspirationPhotoSvc.$inject = ['pixerfApiMissionSvc', 'galleryUtils', 'toastr', 'translationSvc'];
    function missionInspirationPhotoSvc(pixerfApiMissionSvc, galleryUtils, toastr, translationSvc) {

        function setAsMissionCover(media, mission){
            pixerfApiMissionSvc.update({"id": mission.id}, {"mission": {"cover_media_id": media.id}}).$promise.then(function(response){
                mission.cover_media = response.mission.cover_media;
                galleryUtils.updateThumnailPath(mission);
                toastr.success("This photo is set as cover for this mission!");
            }, function(){
                toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
            })

        }
        return {
            setAsMissionCover: setAsMissionCover
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('pixerf')
        .controller('missionInspirationPhotoCtrl', missionInspirationPhotoCtrl);

    missionInspirationPhotoCtrl.$inject = ['missionInspirationPhotoSvc', '$scope', 'sessionManagerSvc'];

    function missionInspirationPhotoCtrl(missionInspirationPhotoSvc, $scope, sessionManagerSvc) {
        var self = this;
        self.loginnedUser = sessionManagerSvc.getCurrentLoginUser().data;
        self.onSetMissionCoverClicked = onSetMissionCoverClicked;
        self.clickOutSide = clickOutSide;
		
        function clickOutSide(evt){
            $("body").trigger("click");
            evt.stopPropagation();
        }
        function onSetMissionCoverClicked(media){
            missionInspirationPhotoSvc.setAsMissionCover(media, $scope.mission);
            
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('pixerf')
        .directive('missionInspirationPhoto', missionInspirationPhoto);

    missionInspirationPhoto.$inject = [];

    function missionInspirationPhoto() {
        var directive = {
            scope: {
                media: "=",
                mission: "=",
                photoLoaded: "="
            },
            restrict: 'E',
            templateUrl: 'app/components/mission-inspiration-photo/mission-inspiration-photo.html',
            controller: "missionInspirationPhotoCtrl",
            controllerAs: 'vm',
            replace: true
        };

        return directive;

    }

})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('missionGridCtrl', missionGridCtrl);

    missionGridCtrl.$inject = ['$scope', 'missionSvc', 'pagingUtils', 'toastr'];

    function missionGridCtrl($scope, missionSvc, pagingUtils, toastr) {

        var self = this;

        self.missions = null;
        self.spinner = {isVisible: false};
        self.searchParams = null;

        init();

		function init(){
            var searchParams = {page: 1};
			fetchItems(searchParams, true);
		}

		function fetchItems(searchParams, isFresh){
			self.spinner.isVisible = true;
			searchParams.type = 'current';
            searchParams.sort = ["inserted_at,desc"];
            if(isFresh) self.searchParams = searchParams;
			missionSvc.fetchMissions(searchParams).then(function(response){
				if(searchParams.page === 1 || isFresh) self.missions = [];
                self.spinner.isVisible = false;
                if(response && response.data && response.data.missions && response.data.missions.length > 0){
                    var missions = self.missions.concat(response.data.missions);
                    if($scope.options.limit){
                       self.missions = missions.slice(0, $scope.options.limit);
                    }
                }
                self.isLastPage = pagingUtils.isNoMorePageToLoad(searchParams.page, response);

			}, function(){
				self.spinner.isVisible = false;
				toastr.error('Failed to get missions!');
			})
		}
		function fetchMoreItems(){
			 if(self.spinner.isVisible){
                return;
            }
            self.searchParams.page ++;
			fetchItems(self.searchParams);
		}
    }
})();

(function () {
  'use strict';

  angular
    .module('pixerf')
    .directive('missionGrid', missionGrid);
  missionGrid.$inject = [];
  function missionGrid() {

    var directive = {
      scope: {
          onInit: '&?',
          options: "="
      },
      restrict: 'E',
      transclude: true,
      templateUrl: 'app/components/mission-grid/mission-grid.html',
      controller: 'missionGridCtrl',
      controllerAs: 'vm',
      replace: true
    };
    return directive;
  }

})();

(function(){

  angular
    .module('pixerf')
    .controller('missionGalleryCtrl', missionGalleryCtrl);

    missionGalleryCtrl.$inject = ["$scope", "$location", "missionConst"];

    function missionGalleryCtrl($scope, $location, missionConst){
        var self = this;
        self.onMissionClicked = onMissionClicked;
        self.getSubmissionsCount = getSubmissionsCount;

		function onMissionClicked(mission){
            $location.path('/mission-detail-page/' + mission.id);
        }

        function getSubmissionsCount(photoNumber){
            return photoNumber > 999 ? (photoNumber/1000).toFixed(1) + 'K' : photoNumber;
        }
    }
})();

(function () {
  'use strict';

  angular
    .module('pixerf')
    .directive('missionGallery', missionGallery);

  function missionGallery() {

    var directive = {
      scope: {
        mission: "=",
        hideFooter: "@?",
        showBadge: "@?"
      },
      restrict: 'E',
      templateUrl: 'app/components/mission-gallery/mission-gallery.html',
      controller: 'missionGalleryCtrl',
      controllerAs: 'vm',
      replace: true
    };
    return directive;
  }

})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('missionDraftItemCtrl', missionDraftItemCtrl);

	missionDraftItemCtrl.$inject = ['$scope', 'pixerfApiMissionSvc', '$location', 'toastr'];

	function missionDraftItemCtrl($scope, pixerfApiMissionSvc, $location, toastr) {

		var self = this;
		self.isWorking  = false;
		self.onMissionDeleted = onMissionDeleted;
		self.onEditBtnClicked = onEditBtnClicked;

		function onEditBtnClicked(missionId){
			$location.path("/setting/manage-missions/draft/" + missionId);
		}

		function onMissionDeleted(missionId){
			if(self.isWorking) return ;
			self.isWorking = true;
			pixerfApiMissionSvc.delete({id: missionId}).$promise.then(function (response) {
				self.isWorking = false;
				$scope.onMissionDeleted({mission: $scope.mission});
				toastr.success("Mission has been deleted!");
			}, function () {
				self.isWorking = false;
				toastr.error("Failed to delete this Mission!");
			});
		}
	}
})();

(function () {
  'use strict';

  angular
    .module('pixerf')
    .directive('missionDraftItem', missionDraftItem);

  function missionDraftItem() {

    var directive = {
      scope: {
        mission: "=",
        onMissionDeleted: "&"
      },
      restrict: 'E',
      templateUrl: 'app/components/mission-draft-item/mission-draft-item.html',
      controller: 'missionDraftItemCtrl',
      controllerAs: 'vm',
      replace: true
    };
    return directive;
  }

})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('missionBillCtrl', missionBillCtrl);

    missionBillCtrl.$inject = ['priceUtils'];

    function missionBillCtrl(priceUtils) {

        var self = this;

        init()
        function init(){
            if(!self.mission.bill) self.mission.bill = {};
			if(self.mission.prizes_grouped["WINNER"].quantity > 10000 || (self.mission.prizes_grouped["CONSOLATION"] && self.mission.prizes_grouped["CONSOLATION"].quantity > 10000)) return;
            self.mission.prizes_grouped["WINNER"].total = self.mission.prizes_grouped["WINNER"].value * self.mission.prizes_grouped["WINNER"].quantity;
            if(self.mission.prizes_grouped["CONSOLATION"]){
                self.mission.prizes_grouped["CONSOLATION"].total = self.mission.prizes_grouped["CONSOLATION"].value * self.mission.prizes_grouped["CONSOLATION"].quantity;
                self.mission.prizes_grouped.totalReward = self.mission.prizes_grouped["WINNER"].total + self.mission.prizes_grouped["CONSOLATION"].total;
            } else {
                self.mission.prizes_grouped.totalReward = self.mission.prizes_grouped["WINNER"].total;
            }
			self.mission.bill.totalToPay = calculateTotalAmount();  
        }
        function calculateTotalAmount(){
            if(self.showAwardOnly){
                return self.mission.price.service_fee ? self.mission.prizes_grouped.totalReward + parseFloat(self.mission.price.service_fee) : self.mission.prizes_grouped.totalReward;
            }
            return self.mission.price.service_fee ? self.mission.prizes_grouped.totalReward + priceUtils.calculatePriceAfterDiscount(self.mission.price.service_fee, self.mission.price.discounts) : self.mission.prizes_grouped.totalReward;
        }
        
        
    }
})();
(function () {
  'use strict';

  angular
    .module('pixerf')
    .component('missionBill',  {
      bindings: {
        "mission" : "=",
        "showAwardOnly": "="
      },
      templateUrl: 'app/components/mission-bill/mission-bill.html',
      controller: 'missionBillCtrl',
      controllerAs: 'vm'
    });

})();

(function () {
  'use strict';

  angular
    .module('pixerf')
    .controller('missionAwardsRowCtrl', missionAwardsRowCtrl);

  missionAwardsRowCtrl.$inject = ['$scope', 'numberUtils', 'pixerfApiMediaSvc', 'photoDetailPopupSvc'];

  function missionAwardsRowCtrl($scope, numberUtils, pixerfApiMediaSvc, photoDetailPopupSvc) {

    var self = this;
    self.mission = $scope.mission;
    self.isClaimed = self.mission.state === 'claimed';
    self.prize = numberUtils.formatNumber(self.mission.value, ',', 3);
    self.onPhotoCLick = onPhotoCLick;

    function onPhotoCLick(photoId) {
      pixerfApiMediaSvc.get({ id: photoId }).$promise.then(function (response) {
        photoDetailPopupSvc.showPopup({
          photo: response.data
        });
      })
    }
  }
})();

(function () {
    'use strict';
  
    angular
      .module('pixerf')
      .directive('missionAwardsRow', missionAwardsRow);
  
    function missionAwardsRow() {
  
      var directive = {
        scope: {
          mission: "="
        },
        restrict: 'E',
        templateUrl: 'app/components/mission-awards-row/mission-awards-row.html',
        controller: 'missionAwardsRowCtrl',
        controllerAs: 'vm',
        replace: true
      };
      return directive;
    }
  
  })();
  
(function () {

	angular
		.module('pixerf')
		.controller('mediaPostTileCtrl', mediaPostTileCtrl);

	mediaPostTileCtrl.$inject = ['$scope', 'pixerfApiNewsSvc', 'confirmWithinIconPopupSvc', '$state', '$q', 'sessionManagerSvc', 'pixerfUrl', 'systemUtils', '$timeout'];

	function mediaPostTileCtrl($scope, pixerfApiNewsSvc, confirmWithinIconPopupSvc, $state, $q, sessionManagerSvc, pixerfUrl, systemUtils, $timeout) {
		var self = this;
		$scope.$parent.vm.subContextPage = "Published";
		self.onDeletePost = onDeletePost;
		self.onEditPost = onEditPost;
		self.cancelEdit = cancelEdit;
		self.savePost = savePost;
		self.post = $scope.data;
		self.newPost = {};

		self.dropzoneConfig = {
			'instance': {},
			'options': {
				url: pixerfUrl.full + 'api/blog_posts/',
				maxFiles: 1,
				paramName: 'photo',
				acceptedFiles: "image/jpeg,image/jpg",
				addRemoveLinks: true,
				autoProcessQueue: false,
				dictRemoveFile: "X",
				thumbnailWidth: null,
				thumbnailHeight: null,
				method: "put",
				previewsContainer: '#preview',
				clickable: ['.media-post-tile__content__col-left__dropzone'],
				headers: {
					"Authorization": "Bearer " + sessionManagerSvc.getToken()
				}
			},
			'eventHandlers': {
				addedfile: function (file, xhr, form) {
					isShowAttachPhotoBtn();
					if (this.files.length > 1) {
						this.removeFile(this.files[0]);
					}
				},
				removedfile: function (file) {
					isShowAttachPhotoBtn();
				},
				success: function (file, responsedFile) {
					self.post.photo = {};
					$timeout(function () {
						self.post = _.clone(responsedFile);
						formatDate();
					}, 400);
					systemUtils.digest($scope);
				}
			},
		};

		init();

		function init() {
			formatDate();
		}

		function formatDate() {
			self.post.formattedDate = moment(self.post.posted_at).format('MMMM DD, YYYY');
		}

		function onDeletePost(id) {
			confirmWithinIconPopupSvc.showPopup({
				icon: "icon-attention",
				title: "You are about to delete a Media Post.",
				description: "Please confirm if you want to delete the Media Post.",
				cancelBtnText: "No - keep post",
				submitBtnText: "Yes - delete post",
				submit: function () {
					return pixerfApiNewsSvc.delete({
						id: id
					}).$promise;
				},
				submitCallback: function () {
					$scope.onDeleteItem({
						id: id
					});

					confirmWithinIconPopupSvc.showPopup({
						icon: "icon-checked_full_circle",
						title: "You have successfully deleted the Media Post.",
						cancelBtnText: "Back to Manage Media",
						submitBtnText: "View Media Page",
						submit: function () {
							var def = $q.defer();
							$state.go("media-page");
							def.resolve();
							return def.promise;
						},
					})
				}
			})
		}

		function onEditPost() {
			self.isEditMode = !self.isEditMode;
			if (self.isEditMode) {
				self.newPost = _.clone(self.post);
				self.newPost.posted_at = new Date(self.newPost.posted_at);
			}
		}

		function savePost(id) {
			confirmWithinIconPopupSvc.showPopup({
				icon: "icon-attention",
				title: "You are about to publish a Media Post.",
				description: "Please confirm if you want to proceed.<br/>If you say yes, the Media Post will be published to the Media page of the live site.",
				cancelBtnText: "No - return to manage media",
				submitBtnText: "Yes - publish post",
				submit: function () {
					if (self.newPost.posted_at) {
						self.newPost.posted_at = moment(self.newPost.posted_at).format("YYYY-MM-DD");
					}
					return pixerfApiNewsSvc.update({
						id: id
					}, {
						posted_at: self.newPost.posted_at,
						url_text: self.newPost.url_text,
						url: self.newPost.url,
						name: self.newPost.name,
						description: self.newPost.description
					}).$promise;
				},
				submitCallback: function (res) {
					self.dropzoneConfig.instance.options.url += id;
					self.dropzoneConfig.instance.processQueue();

					self.isEditMode = false;
					self.post = _.clone(res);
					formatDate();
					self.newPost = {};
				}
			})
		}

		function cancelEdit() {
			confirmWithinIconPopupSvc.showPopup({
				icon: "icon-attention",
				title: "You are about to cancel the edits to a Media Post.",
				description: "Please confirm if you want to cancel the edits.",
				cancelBtnText: "No - keep edits",
				submitBtnText: "Yes - cancel edits",
				submit: function () {
					var def = $q.defer();
					def.resolve();
					return def.promise;
				},
				submitCallback: function () {
					self.isEditMode = false;
					self.newPost = {};
				}
			})
		}

		function isShowAttachPhotoBtn() {
			if (self.dropzoneConfig.instance.files && self.dropzoneConfig.instance.files.length) {
				self.showAttachPhotoBtn = false;
			} else {
				self.showAttachPhotoBtn = true;
			}
			systemUtils.digest($scope);
		}
	}
})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .directive('mediaPostTile', mediaPostTile);

    mediaPostTile.$inject = [];

    function mediaPostTile() {
        var directive = {
            scope: {
                editMode: "@?",
                data: '=',
                onDeleteItem: "&?",
                onEditItem: "&?"
            },
            restrict: 'E',
            templateUrl: 'app/components/media-post-tile/media-post-tile.html',
            controller: "mediaPostTileCtrl",
            controllerAs: 'vm',
            replace: true
        };
        return directive;
    }
})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.factory('maxPhotosCommissionsCopupSvc', maxPhotosCommissionsCopupSvc);
	maxPhotosCommissionsCopupSvc.$inject = ['$uibModal'];

	function maxPhotosCommissionsCopupSvc($uibModal) {
		function showPopup(data) {
			return $uibModal.open({
				templateUrl: 'app/components/max-photos-commissions-popup/max-photos-commissions-popup.html',
				controller: 'maxPhotosCommissionsCopupCtrl',
				controllerAs: 'vm',
				animation: true,
				windowClass: 'zindex max-photos-commissions-popup',
				resolve: {
					'resolveData': function () {
						return data;
					}
				}
			});
		}
		return {
			showPopup: showPopup
		};
	}
})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('maxPhotosCommissionsCopupCtrl', maxPhotosCommissionsCopupCtrl);

    maxPhotosCommissionsCopupCtrl.$inject = ['$scope', '$uibModalInstance', 'resolveData', '$window'];

    function maxPhotosCommissionsCopupCtrl($scope, $uibModalInstance, resolveData, $window) {

        var self = this;
        self.closePopup = closePopup;
        self.requestDownload = requestDownload;
        self.data = resolveData;

        function closePopup(){
            $uibModalInstance.close();
        }

        function requestDownload(){
            $window.open('mailto: business@pixerf.com', '_self');
            closePopup();
        }
    }
})();
(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('managerMemberListViewCtrl', managerMemberListViewCtrl);

	managerMemberListViewCtrl.$inject = ['$scope', '$window', 'pixerfApiCommunitySvc', 'sessionManagerSvc', 'actionReqruiedCommunityPopupSvc', '$q', 'alertMessagePopupSvc',
		'$translate', 'confirmPopupSvc', 'pixerfApiUserSvc', 'toastr', 'translationSvc', 'removeMemberPopupSvc', 'confirmSuccessPopupSvc', 'communityConst', 'accountUtils', 'blockMemberPopupSvc'];

	function managerMemberListViewCtrl($scope, $window, pixerfApiCommunitySvc, sessionManagerSvc, actionReqruiedCommunityPopupSvc, $q, alertMessagePopupSvc,
		$translate, confirmPopupSvc, pixerfApiUserSvc, toastr, translationSvc, removeMemberPopupSvc, confirmSuccessPopupSvc, communityConst, accountUtils, blockMemberPopupSvc) {

		var USER_CONTROL_ADMINDASHBOARD = ['curator_internal', 'admin_internal', 'marketer_internal'];
		var self = this;
		self.loginedUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.isAdmin = self.loginedUser && (USER_CONTROL_ADMINDASHBOARD.includes(self.loginedUser.role) || self.loginedUser.email === 'marcom@pixerf.com');
		self.member = $scope.member;
		self.members = $scope.members;
		self.community = $scope.community;
		self.type = $scope.type;
		self.canSetManager = $scope.canSetManager;
		self.showMoreControl = false;
		self.moreList = [];
		self.onFollow = onFollow;
		self.onMakeManager = onMakeManager;
		self.onRemoveFromCommunity = onRemoveFromCommunity;
		self.onBlockFromCommunity = onBlockFromCommunity;
		self.onRemoveAdminRights = onRemoveAdminRights;
		self.joinDate = ''
		self.showAdmin = false;
		self.onApproveMember = onApproveMember;
		self.onRejectMember = onRejectMember;
		self.onWithdrawMember = onWithdrawMember;
		self.onUnblockMember = onUnblockMember;
		self.showApproveBtn = false;
		self.showRejectBtn = false;
		self.showUnblockBtn = false;
		self.showWithdrawtBtn = false;
		self.showMoreListBtn = false
		self.CONSTANT = {
			ACCEPT: communityConst.ACTION.ACCEPT,
			REJECT: communityConst.ACTION.REJECT,
			REMOVE: communityConst.ACTION.REMOVE,
			UNINVITE: communityConst.ACTION.UNINVITE,
			UNBLOCK: communityConst.ACTION.UNBLOCK,
		}
		self.isManager = false
		self.isOwner = false
		self.role = '';
		self.timeText = 'Member Since';
		self.accountType = '';

		function init() {
			self.isManager = (self.member.status == 'manager');
			self.isOwner = (self.member.status == 'owner');
			self.memberAvatar = buildUserAvatar(self.member);
			self.inviterAvatar = ( self.member && self.member.inviter ) ? {avatar: {profileImage:self.member.inviter['100x']}} : buildUserAvatar(self.community.owner);
			self.role = (self.isOwner ? 'Owner' : (self.isManager ? 'Manager' : ''));
			if (self.isAdmin) {
				setAdminLayout();
			} else {
				setUserLayout();
			}
			if(!self.joinDate){
				self.joinDate = new Date();
			}
			self.specialities = accountUtils.getSpecialities(self.member.specialities);
			self.accountType = genArchivement(self.member);
		}

		function buildUserAvatar(member){
			var userAvatar = {
				avatar: {profileImage: (member.profile_image_media && member.profile_image_media['100x'] )? member.profile_image_media['100x'] : member.profile_image},
				displayName: member.displayName,
				account_type: member.account_type
			}
			return userAvatar;
		}

		function setAdminLayout() {
			switch (self.type) {
				case 'members':
					self.showManageButton = true;
					self.showMoreControl = true;
					self.showPermission = true;
					self.showPrivacy = true;
					self.joinDate = self.member.membership_joined_at
					self.showAdmin = false;
					self.showApproveBtn = false;
					self.showRejectBtn = false;
					self.showUnblockBtn = false;
					self.showInvitationFrom = false;
					self.showWithdrawtBtn = false;
					self.showMoreListBtn = true;
					self.timeText = 'Member Since';
					self.moreList = [{
						label: self.member.is_followed ? 'Unfollow' : 'Follow',
						cta: self.onFollow,
						hideItem: self.member.id == self.loginedUser.id
					}, {
						label: 'Make Manager',
						cta: self.onMakeManager
					}, {
						label: 'Remove from community',
						cta: self.onRemoveFromCommunity
					}, {
						label: 'Block from community',
						cta: self.onBlockFromCommunity
					}];

					if(self.canSetManager){
						self.moreList.splice(1, 1);
					}
					break;
				case 'requested':
					self.showManageButton = true;
					self.showMoreControl = true;
					self.showPermission = true;
					self.showPrivacy = true;
					self.showActionRequired = true;
					self.joinDate = self.member.membership_joined_at
					self.showAdmin = false;
					self.showApproveBtn = true;
					self.showRejectBtn = true;
					self.showUnblockBtn = false;
					self.showWithdrawtBtn = false;;
					self.showInvitationFrom = false;
					self.showMoreListBtn = true;
					self.timeText = 'Date Requested';
					self.moreList = [{
						label: 'Block from community',
						cta: self.onBlockFromCommunity
					}];
					break;
				case 'invited':
					self.showManageButton = true;
					self.showMoreControl = true;
					self.showMemberCount = true;
					self.showEventCount = true;
					self.showPostCount = true;
					self.showStrike = true;
					self.showPrivacy = true;
					self.joinDate = self.member.membership_joined_at
					self.showAdmin = false;
					self.showApproveBtn = false;
					self.showRejectBtn = false;
					self.showUnblockBtn = false;
					self.showWithdrawtBtn = true;
					self.showInvitationFrom = true;
					self.showMoreListBtn = false;
					self.timeText = 'Date Invited';
					self.moreList = [{
						label: self.member.is_followed ? 'Unfollow' : 'Follow',
						cta: self.onFollow,
						hideItem: self.member.id == self.loginedUser.id
					}, {
						label: 'Make Manager',
						cta: self.onMakeManager
					}, {
						label: 'Remove from community',
						cta: self.onRemoveFromCommunity
					}, {
						label: 'Block from community',
						cta: self.onBlockFromCommunity
					}];
					break;
				case 'blocked':
					self.showMemberCount = true;
					self.showEventCount = true;
					self.showPostCount = true;
					self.showStrike = true;
					self.showPrivacy = true;
					self.joinDate = self.member.membership_banned_at
					self.showAdmin = false;
					self.showApproveBtn = false;
					self.showRejectBtn = false;
					self.showUnblockBtn = true;
					self.showWithdrawtBtn = false;
					self.showInvitationFrom = false;
					self.showMoreListBtn = false;
					self.timeText = 'Date Blocked';
					self.moreList = [{
						label: self.member.is_followed ? 'Unfollow' : 'Follow',
						cta: self.onFollow,
						hideItem: self.member.id == self.loginedUser.id
					}, {
						label: 'Make Manager',
						cta: self.onMakeManager
					}, {
						label: 'Remove from community',
						cta: self.onRemoveFromCommunity
					}, {
						label: 'Block from community',
						cta: self.onBlockFromCommunity
					}];
					break;
				case 'admin':
					self.showMemberCount = true;
					self.showEventCount = true;
					self.showPostCount = true;
					self.showStrike = true;
					self.showPrivacy = true;
					self.joinDate = self.member.membership_joined_at
					self.showAdmin = true;
					self.showApproveBtn = false;
					self.showRejectBtn = false;
					self.showUnblockBtn = false;
					self.showWithdrawtBtn = false;
					self.showMoreListBtn = true;
					self.showInvitationFrom = false;
					self.timeText = 'Member Since';
					self.moreList = [{
						label: 'Remove Admin Rights',
						cta: self.onRemoveAdminRights
					}, {
						label: 'Remove from community',
						cta: self.onRemoveFromCommunity
					}, {
						label: 'Block from community',
						cta: self.onBlockFromCommunity
					}];

					if(self.canSetManager){
						self.moreList.splice(0, 1);
					}
					if(self.isOwner){
						self.moreList = [];
						self.showMoreListBtn = false;
					}
					break;
			}
		}

		function setUserLayout() {
			switch (self.type) {
				case 'members':
					self.showManageButton = true;
					self.showMoreControl = true;
					self.showPermission = true;
					self.showPrivacy = true;
					self.joinDate = self.member.membership_joined_at
					self.showAdmin = false;
					self.showApproveBtn = false;
					self.showRejectBtn = false;
					self.showUnblockBtn = false;
					self.showWithdrawtBtn = false;;
					self.showMoreListBtn = true;
					self.timeText = 'Member Since';
					self.showInvitationFrom = false;
					self.moreList = [{
						label: self.member.is_followed ? 'Unfollow' : 'Follow',
						cta: self.onFollow,
						hideItem: self.member.id == self.loginedUser.id
					}, {
						label: 'Make Manager',
						cta: self.onMakeManager
					}, {
						label: 'Remove from community',
						cta: self.onRemoveFromCommunity
					}, {
						label: 'Block from community',
						cta: self.onBlockFromCommunity
					}];

					if(self.canSetManager){
						self.moreList.splice(1, 1);
					}
					break;
				case 'viewMembers':
					self.showManageButton = true;
					self.showMoreControl = true;
					self.showPermission = true;
					self.showPrivacy = true;
					self.joinDate = self.member.membership_joined_at
					self.showAdmin = true;
					self.showApproveBtn = false;
					self.showRejectBtn = false;
					self.showUnblockBtn = false;
					self.showWithdrawtBtn = false;
					self.showMoreListBtn = true;
					self.timeText = 'Member Since';
					self.showInvitationFrom = false;
					self.moreList = [{
						label: self.member.is_followed ? 'Unfollow' : 'Follow',
						cta: self.onFollow,
						hideItem: self.member.id == self.loginedUser.id
					}];
					if(self.member.id == self.loginedUser.id){
						self.moreList = [];
						self.showMoreListBtn = false;
					}
					break;
				case 'requested':
					self.showManageButton = true;
					self.showMoreControl = true;
					self.showPermission = true;
					self.showPrivacy = true;
					self.showActionRequired = true;
					self.joinDate = self.member.membership_joined_at 
					self.showAdmin = false;
					self.showApproveBtn = true;
					self.showRejectBtn = true;
					self.showUnblockBtn = false;
					self.showWithdrawtBtn = false;
					self.timeText = 'Date Requested';
					self.showMoreListBtn = true;
					self.showInvitationFrom = false;
					self.moreList = [{
						label: 'Block from community',
						cta: self.onBlockFromCommunity
					}];
					break;
				case 'invited':
					self.showManageButton = true;
					self.showMoreControl = true;
					self.showMemberCount = true;
					self.showEventCount = true;
					self.showPostCount = true;
					self.showStrike = true;
					self.showPrivacy = true;
					self.joinDate = self.member.membership_joined_at
					self.showAdmin = false;
					self.showApproveBtn = false;
					self.showRejectBtn = false;
					self.showUnblockBtn = false;
					self.showWithdrawtBtn = true;
					self.showMoreListBtn = false;
					self.showInvitationFrom = true;
					self.timeText = 'Date Invited';
					self.moreList = [{
						label: self.member.is_followed ? 'Unfollow' : 'Follow',
						cta: self.onFollow,
						hideItem: self.member.id == self.loginedUser.id
					}, {
						label: 'Make Manager',
						cta: self.onMakeManager
					}, {
						label: 'Remove from community',
						cta: self.onRemoveFromCommunity
					}, {
						label: 'Block from community',
						cta: self.onBlockFromCommunity
					}];
					break;
				case 'blocked':
					self.showMemberCount = true;
					self.showEventCount = true;
					self.showPostCount = true;
					self.showStrike = true;
					self.showPrivacy = true;
					self.joinDate = self.member.membership_banned_at
					self.showAdmin = false;
					self.showApproveBtn = false;
					self.showRejectBtn = false;
					self.showUnblockBtn = true;
					self.showWithdrawtBtn = false;
					self.showMoreListBtn = false;
					self.showInvitationFrom = false;
					self.timeText = 'Date Blocked';
					self.moreList = [{
						label: self.member.is_followed ? 'Unfollow' : 'Follow',
						cta: self.onFollow,
						hideItem: self.member.id == self.loginedUser.id
					}, {
						label: 'Make Manager',
						cta: self.onMakeManager
					}, {
						label: 'Remove from community',
						cta: self.onRemoveFromCommunity
					}, {
						label: 'Block from community',
						cta: self.onBlockFromCommunity
					}];
					break;
				case 'admin':
					self.showMemberCount = true;
					self.showEventCount = true;
					self.showPostCount = true;
					self.showStrike = true;
					self.showPrivacy = true;
					self.joinDate = self.member.membership_joined_at
					self.showAdmin = true;
					self.showApproveBtn = false;
					self.showRejectBtn = false;
					self.showUnblockBtn = false;
					self.showWithdrawtBtn = false;
					self.showMoreListBtn = true;
					self.showInvitationFrom = false;
					self.timeText = 'Member Since';
					self.moreList = [{
						label: 'Remove Admin Rights',
						cta: self.onRemoveAdminRights
					}, {
						label: 'Remove from community',
						cta: self.onRemoveFromCommunity
					}, {
						label: 'Block from community',
						cta: self.onBlockFromCommunity
					}];
					if(self.canSetManager){
						self.moreList.splice(0, 1);
					}
					if(self.isOwner){
						self.moreList = [];
						self.showMoreListBtn = false;
					}
					break;
			}
		}

		function genArchivement(user) {
			if (user.account_type === 'business') {
				return 'Business';
			} else if (user.ambassadorship === 'pro') {
				return 'Ambassador Pro';
			} else if (user.ambassadorship === 'maestro') {
				return 'Ambassador Maestro';
			} else {
				return 'Personal';
			}
		}

		function onFollow() {
			var action = self.member.is_followed ? 'delete' : 'save';
			pixerfApiUserSvc[action]({ id: self.member.id, action: 'followings' }, {}).$promise.then(function (respone) {
				self.member.is_followed = !self.member.is_followed;
				var message = self.member.is_followed ? 'Following' : 'Unfollow';
				_.each(self.moreList, function(item, idx) { 
					if ((item.label === 'Follow' || item.label === 'Unfollow')) {
						self.moreList[idx].label = self.member.is_followed ? 'Unfollow' : 'Follow';
					   return;
					}
				 });
				toastr.success(message);
			}, function () {
				toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
			})
		}

		function onRemoveAdminRights() {
			var confirmMessage = (self.member.displayName || self.member.email) + ' will no longer have admin rights but will still be a member of this community.';
			var popupConfig = {
				windowClass: 'confirm-action-popup',
				title: 'Remove admin rights',
				message: confirmMessage,
				cancelBtnText: 'Cancel'
			};
			var modal = confirmPopupSvc.showPopup(popupConfig);
			modal.result.then(function () {
				pixerfApiCommunitySvc.remove_manager(
					{ id: self.community.id },
					{ 'id': self.community.id, 'user_ids': [self.member.id], 'status': 'accepted' }).$promise.then(function (res) {
						if ($scope.onStatusChanged) {
							$scope.onStatusChanged(self.member);
						}
						showConfirmSuccessPopupMessage('<strong>' + (self.member.displayName || self.member.email) + '</strong> is no longer a manager of your Community.');
					}).catch(function (err) {
						toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
					})
			});
		}

		function onMakeManager() {

			var confirmMessage = 'As a community manager, the appointed member will be able to manage members and discussions of the community.';
			var popupConfig = {
				windowClass: 'confirm-action-popup',
				title: 'Make Community Manager',
				message: confirmMessage,
				cancelBtnText: 'Cancel'
			};
			var modal = confirmPopupSvc.showPopup(popupConfig);
			modal.result.then(function () {
				pixerfApiCommunitySvc.make_manager(
					{ id: self.community.id },
					{ 'id': self.community.id, 'user_ids': [self.member.id], 'status': 'manager' }).$promise.then(function (res) {
						if ($scope.onStatusChanged) {
							$scope.onStatusChanged(self.member);
						}
						showConfirmSuccessPopupMessage('<strong>' + (self.member.displayName || self.member.email) + '</strong> is now a Manager of your Community');
					}).catch(function (err) {
						toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
					})
			});
		}

		function showConfirmSuccessPopupMessage(message, isWarning) {
			confirmSuccessPopupSvc.showPopup({
				windowClass: 'manager-member-list-view__confirm-success-popup',
				message: message,
				isWarning: isWarning
			});
		}

		function onRemoveFromCommunity() {
			var removePopup = removeMemberPopupSvc.showPopup({
				community: self.community,
				user: self.member
			})
			removePopup.result.then(function (data) {
				if(data && data.user){
					$scope.onRemoved(self.member);
					showConfirmSuccessPopupMessage('<strong>' + (self.member.displayName || self.member.email) + '</strong> has been removed from your Community.');
				}
			})
		}
		
		function onBlockFromCommunity() {

			var blockPopup = blockMemberPopupSvc.showPopup({
				community: self.community,
				user: self.member
			})
			blockPopup.result.then(function (data) {
				if(data && data.user){
					$scope.onRemoved(self.member);
				showConfirmSuccessPopupMessage('<strong>' + (self.member.displayName || self.member.email) + '</strong> has been blocked from your Community.');
				}
			}).catch(function (err) {
				console.log(err);
			})
		}

		function genAlertMessage(action, person) {
			if (action === self.CONSTANT.REJECT) {
				return "You have rejected " + person.displayName + "'s request to join the Community.";
			} else if (action === self.CONSTANT.ACCEPT) {
				return "You have accepted " + person.displayName + "’s request to join the Community!";
			} else if (action === self.CONSTANT.REMOVE) {
				return "You have removed " + person.displayName + " from the Community.";
			} else if (action === self.CONSTANT.UNINVITE) {
				return "You have uninvited " + person.displayName + " from the Community.";
			} else if (action === self.CONSTANT.UNBLOCK) {
				return "You have unblocked " + person.displayName + " from the Community.";
			} else {
				return "";
			}
		}

		function onActionActived(action, person, onCallbackMessage) {
			var toastMessage = genAlertMessage(action, person);
			var params = {
				user_ids: [],
				emails: []
			}
			if (person.username) {
				params.user_ids.push(person.id);
			} else {
				params.emails.push(person.email);
			}
			pixerfApiCommunitySvc[action]({
				id: self.community.id
			}, params).$promise.then(function (response) {
				if(onCallbackMessage){
					onCallbackMessage();
				}else{
					toastr.success(toastMessage);
				}
				$scope.onStatusChanged(person);
				self.isWorking = false;
			}, function (err) {
				console.log(err);
				toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
				self.isWorking = false;
			});
		}
		function genConfirmMessage(action, person) {
			if (action === self.CONSTANT.REJECT) {
				return "Do you want to reject " + person.displayName + "'s request to join the Community?";
			} else if (action === self.CONSTANT.REMOVE) {
				return "Do you want to remove " + person.displayName + " from the Community?";
			} else if (action === self.CONSTANT.UNINVITE) {
				return "Do you want to uninvite " + person.displayName + " from the Community?";
			} else if (action === self.CONSTANT.UNBLOCK) {
				return "Do you want to unblock " + person.displayName + " from the Community?";
			} else if (action === self.CONSTANT.ACCEPT) {
				return "Do you want to approve " + person.displayName + "'s  to join the Community?";
			}else {
				return "";
			}
		}

		function onConfirmAction(action, person, onCallbackMessage) {
			var confirmMessage = genConfirmMessage(action, person);
			var popupConfig = {
				windowClass: 'confirm-action-popup',
				hideTitle: true,
				hideConfirmText: true,
				title: confirmMessage
			};
			if(action === self.CONSTANT.UNBLOCK || action === self.CONSTANT.UNINVITE){
				popupConfig.cancelBtnText = 'Cancel';
			}
			var modal = confirmPopupSvc.showPopup(popupConfig);
			modal.result.then(function () {
				self.isWorking = true;
				onActionActived(action, person, onCallbackMessage);
			});
		}

		function onApproveMember(){
			var successMessage = 'You have accepted <strong>' + (self.member.displayName || self.member.email) + '</strong>’s request to join the Community!';
			onConfirmAction(self.CONSTANT.ACCEPT, self.member, showConfirmSuccessPopupMessage.bind(this, successMessage))
		}

		function onRejectMember(){
			var isWarning = true;
			var message = 'You have declined <strong>' + (self.member.displayName || self.member.email) + '</strong>’s request to join the Community.';
			onConfirmAction(self.CONSTANT.REJECT, self.member, showConfirmSuccessPopupMessage.bind(this, message, isWarning))
		}

		function onUnblockMember(){
			onConfirmAction(self.CONSTANT.UNBLOCK, self.member)
		}

		function onWithdrawMember(){
			var isWarning = true;
			var successMessage = 'You have declined <strong>' + (self.member.displayName || self.member.email) + '</strong>’s request to join the Community.';
			onConfirmAction(self.CONSTANT.UNINVITE, self.member, showConfirmSuccessPopupMessage.bind(this, successMessage, isWarning))
		}

		function showActionRequiredPopup() {
			alertMessagePopupSvc.showPopup({
				windowClass: 'community-list-view__alert-message',
				title: "Comment sent! What do you want to do next?",
				description: "You can find this community under <span class='text--bold text--color-pixerf-theme'>Action Required</span>. You can still edit your commment if owner has not edited and resubmitted their form."
			});
		}

		function prevenPubbleClick() {
			$window.event.stopPropagation();
		}

		init();
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('managerMemberListView', managerMemberListView);
		managerMemberListView.$inject = []

	function managerMemberListView() {

		var directive = {
			scope: {
				member: "=",
				onRemoved: "&",
				community: '=',
				onToggleSelected: "&?",
				onMemberClicked: "&?",
				onStatusChanged: "&?",
				onManageClicked: "&?",
				type: "@",
				canSetManager: "="
			},
			restrict: 'E',
			templateUrl: 'app/components/manager-member-list-view/manager-member-list-view.html',
			controller: 'managerMemberListViewCtrl',
			controllerAs: 'vm',
			replace: true
		};
		return directive;
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('managerEventMemberListViewCtrl', managerEventMemberListViewCtrl);

		managerEventMemberListViewCtrl.$inject = ['$scope', '$window', 'pixerfApiCommunitySvc', 'sessionManagerSvc', 'pixerfApiEventSvc', '$q', 'alertMessagePopupSvc',
		'$translate', 'confirmPopupSvc', 'pixerfApiUserSvc', 'toastr', 'translationSvc', 'inviteUserPopupSvc', 'confirmSuccessPopupSvc', 'communityConst', 'accountUtils', 'blockMemberPopupSvc'];

	function managerEventMemberListViewCtrl($scope, $window, pixerfApiCommunitySvc, sessionManagerSvc, pixerfApiEventSvc, $q, alertMessagePopupSvc,
		$translate, confirmPopupSvc, pixerfApiUserSvc, toastr, translationSvc, inviteUserPopupSvc, confirmSuccessPopupSvc, communityConst, accountUtils, blockMemberPopupSvc) {

		var USER_CONTROL_ADMINDASHBOARD = ['curator_internal', 'admin_internal', 'marketer_internal'];
		var self = this;
		self.loginedUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.isAdmin = self.loginedUser && (USER_CONTROL_ADMINDASHBOARD.includes(self.loginedUser.role) || self.loginedUser.email === 'marcom@pixerf.com');
		self.member = $scope.member;
		self.members = $scope.members;
		self.community = $scope.community;
		self.event = $scope.event;
		self.type = $scope.type;
		self.showMoreControl = false;
		self.moreList = [];
		self.onRemove = onRemove;
		self.onBlockFromCommunity = onBlockFromCommunity;
		self.onFollow = onFollow;
		self.joinDate = ''
		self.showAdmin = false;
		self.showStatus = false;
		self.onInviteMember = onInviteMember;
		self.onWithdrawMember = onWithdrawMember;
		self.showInviteBtn = false;
		self.showRejectBtn = false;
		self.showUnblockBtn = false;
		self.showWithdrawtBtn = false;
		self.showMoreListBtn = false
		self.CONSTANT = {
			ACCEPT: communityConst.ACTION.ACCEPT,
			REJECT: communityConst.ACTION.REJECT,
			REMOVE: communityConst.ACTION.REMOVE,
			UNINVITE: communityConst.ACTION.UNINVITE,
			UNBLOCK: communityConst.ACTION.UNBLOCK,
			INVITE: communityConst.ACTION.INVITE,
		}
		self.accountType = '';

		function init() {
			if (self.isAdmin) {
				setAdminLayout();
			} else {
				setUserLayout();
			}

			self.specialities = accountUtils.getSpecialities(self.member.specialities);
			self.accountType = genArchivement(self.member);
		}


		function setAdminLayout() {
			switch (self.type) {
				case 'attendees':
					self.showManageButton = true;
					self.showMoreControl = true;
					self.showPermission = true;
					self.showPrivacy = true;
					self.joinDate = self.member.joined_at
					self.showAdmin = true;
					self.showInviteBtn = false;
					self.showRejectBtn = false;
					self.showUnblockBtn = false;
					self.showWithdrawtBtn = false;;
					self.showMoreListBtn = true;
					self.showInvitationFrom = false;
					self.showStatus = false;
					self.moreList = [{
						label: 'Remove',
						cta: self.onRemove
					}, {
						label: 'Block from community',
						cta: self.onBlockFromCommunity
					}];
					break;
				case 'interested':
					self.showManageButton = true;
					self.showMoreControl = true;
					self.showPermission = true;
					self.showPrivacy = true;
					self.showActionRequired = true;
					self.joinDate = self.member.joined_at
					self.showAdmin = false;
					self.showInviteBtn = true;
					self.showRejectBtn = true;
					self.showUnblockBtn = false;
					self.showWithdrawtBtn = false;
					self.showMoreListBtn = false;
					self.showInvitationFrom = false;
					self.showStatus = false;
					self.moreList = [];
					break;
				case 'invited':
					self.showManageButton = true;
					self.showMoreControl = true;
					self.showMemberCount = true;
					self.showEventCount = true;
					self.showPostCount = true;
					self.showStrike = true;
					self.showPrivacy = true;
					self.joinDate = self.member.joined_at
					self.showAdmin = false;
					self.showInviteBtn = false;
					self.showRejectBtn = false;
					self.showUnblockBtn = false;
					self.showWithdrawtBtn = true;
					self.showMoreListBtn = false;
					self.showInvitationFrom = true;
					self.showStatus = true;
					self.moreList = [];
					break;
				
			}
		}

		function setUserLayout() {
			switch (self.type) {
				case 'attendees':
					self.showManageButton = true;
					self.showMoreControl = true;
					self.showPermission = true;
					self.showPrivacy = true;
					self.joinDate = self.member.joined_at
					self.showAdmin = true;
					self.showInviteBtn = false;
					self.showRejectBtn = false;
					self.showUnblockBtn = false;
					self.showWithdrawtBtn = false;;
					self.showMoreListBtn = true;
					self.showInvitationFrom = false;
					self.showStatus = false;
					self.moreList = [{
						label: 'Remove',
						cta: self.onRemove
					}, {
						label: 'Block from community',
						cta: self.onBlockFromCommunity
					}];
					break;
				case 'interested':
					self.showManageButton = true;
					self.showMoreControl = true;
					self.showPermission = true;
					self.showPrivacy = true;
					self.showActionRequired = true;
					self.joinDate = self.member.joined_at
					self.showAdmin = false;
					self.showInviteBtn = true;
					self.showRejectBtn = true;
					self.showUnblockBtn = false;
					self.showWithdrawtBtn = false;
					self.showMoreListBtn = false;
					self.showInvitationFrom = false;
					self.showStatus = false;
					self.moreList = [];
					break;
				case 'viewEvent':
					self.showManageButton = true;
					self.showMoreControl = true;
					self.showPermission = true;
					self.showPrivacy = true;
					self.joinDate = self.member.joined_at
					self.showAdmin = true;
					self.showInviteBtn = false;
					self.showRejectBtn = false;
					self.showUnblockBtn = false;
					self.showWithdrawtBtn = false;;
					self.showMoreListBtn = true;
					self.showInvitationFrom = false;
					self.showStatus = false;
					self.moreList = [{
						label: self.member.is_followed ? 'Unfollow' : 'Follow Creator',
						cta: self.onFollow,
						hideItem: self.member.id == self.loginedUser.id
					}];
					if(self.member.id == self.loginedUser.id){
						self.moreList = [];
						self.showMoreListBtn = false;
					}
					break;
				case 'invited':
					self.showManageButton = true;
					self.showMoreControl = true;
					self.showMemberCount = true;
					self.showEventCount = true;
					self.showPostCount = true;
					self.showStrike = true;
					self.showPrivacy = true;
					self.joinDate = self.member.joined_at
					self.showAdmin = false;
					self.showInviteBtn = false;
					self.showRejectBtn = false;
					self.showUnblockBtn = false;
					self.showWithdrawtBtn = true;
					self.showMoreListBtn = false;
					self.showInvitationFrom = true;
					self.showStatus = true;
					self.moreList = [];
					break;
				
			}
		}

		function onFollow(){
			var action = self.member.is_followed ? 'delete' : 'save';
			pixerfApiUserSvc[action]({ id: self.member.id, action: 'followings' }, {}).$promise.then(function (respone) {
				self.member.is_followed = !self.member.is_followed;
				var message = self.member.is_followed ? 'Following' : 'Unfollow';
				_.each(self.moreList, function(item, idx) { 
					if ((item.label === 'Follow' || item.label === 'Unfollow')) {
						self.moreList[idx].label = self.member.is_followed ? 'Unfollow' : 'Follow';
					   return;
					}
				 });
				toastr.success(message);
			}, function () {
				toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
			})
		}

		function showConfirmSuccessPopupMessage(message) {
			confirmSuccessPopupSvc.showPopup({
				windowClass: 'manager-member-list-view__confirm-success-popup',
				message: message
			});
		}
		
		function onBlockFromCommunity() {

			var blockPopup = blockMemberPopupSvc.showPopup({
				community: self.community,
				user: self.member
			})
			blockPopup.result.then(function (data) {
				if(data && data.user){
					$scope.onRemoved(self.member);
				showConfirmSuccessPopupMessage('<strong>' + (self.member.displayName || self.member.email) + '</strong> has been blocked from your Community.');
				}
			}).catch(function (err) {
				console.log(err);
			})
		}

		

		function genAlertMessage(action, person) {
			if (action === self.CONSTANT.REJECT) {
				return "You have rejected " + person.displayName + "'s request to join the Event.";
			} else if (action === self.CONSTANT.ACCEPT) {
				return "You have accepted " + person.displayName + "'s request to join the Event.";
			} else if (action === self.CONSTANT.REMOVE) {
				return "You have removed " + person.displayName + " from the Event.";
			} else if (action === self.CONSTANT.UNINVITE) {
				return "You have uninvited " + person.displayName + " from the Event.";
			} else if (action === self.CONSTANT.UNBLOCK) {
				return "You have unblocked " + person.displayName + " from the Community.";
			} else {
				return "";
			}
		}
		function genConfirmMessage(action, person) {
			if (action === self.CONSTANT.REJECT) {
				return "Do you want to reject " + person.displayName + "'s request to join the Community?";
			} else if (action === self.CONSTANT.REMOVE) {
				return "Do you want to remove " + person.displayName + " from the Event?";
			} else if (action === self.CONSTANT.UNINVITE) {
				return "Do you want to withdraw your invitation to " + person.displayName + '?';
			} else if (action === self.CONSTANT.UNBLOCK) {
				return "Do you want to unblock " + person.displayName + " from the Community?";
			} else if (action === self.CONSTANT.INVITE) {
				return "Do you want to invite " + person.displayName + " to join the event?";
			} else {
				return "";
			}
		}

		function uninviteMemberToEvent(action, person){
			var toastMessage = genAlertMessage(action, person);
			self.isWorking = true;
			pixerfApiEventSvc.deleteEventMemberInvite({
				event_id: self.event.id,
				id: person.id
			}).$promise.then(function () {
				toastr.success(toastMessage);
				$scope.onStatusChanged(person);
				self.isWorking = false;
			}, function (err) {
				console.log(err);
				toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
				self.isWorking = false;
			});
		}

		function inviteMemberToEvent(action, person){
			var toastMessage = genAlertMessage(action, person);
			self.isWorking = true;
			pixerfApiEventSvc.invite({
				id: self.event.id
			}, {
				"recipients": [person.email]
			}).$promise.then(function () {
				toastr.success(toastMessage);
				$scope.onStatusChanged(person);
				self.isWorking = false;
			}, function (err) {
				console.log(err);
				toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
				self.isWorking = false;
			});

			
		}

		function removeMemberFromEvent(action, person){
			var toastMessage = genAlertMessage(action, person);
			self.isWorking = true;
			var memberList ={'user_ids': [person.id]}; 
			pixerfApiEventSvc.removeMembers({
				event_id: self.event.id
			}, memberList).$promise.then(function () {
				toastr.success(toastMessage);
				$scope.onStatusChanged(person);
				self.isWorking = false;
			}, function (err) {
				console.log(err);
				toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
				self.isWorking = false;
			});
		}

		function onInviteMember(){
			var popup = inviteUserPopupSvc.showPopup({
				options: {
					title: "Invite members to Event"
				},
				community: {
					id: self.event.community_id,
				},
				event: {
					id: self.event.id,
					short_code: self.event.short_code
				},
				defaultSearchCondition: {
					isDirectoryChecked: true,
					isEmailChecked: false,
					country: "",
					speciality: "",
				}
			});
		}

		function onWithdrawMember(){
			var confirmMessage = genConfirmMessage(self.CONSTANT.UNINVITE, self.member);
			var popupConfig = {
				windowClass: 'confirm-action-popup',
				hideTitle: true,
				hideConfirmText: true,
				title: confirmMessage
			};
			popupConfig.cancelBtnText = 'Cancel';
			var modal = confirmPopupSvc.showPopup(popupConfig);
			modal.result.then(function () {
				uninviteMemberToEvent(self.CONSTANT.UNINVITE, self.member)
			});
		}

		function onRemove() {
			var confirmMessage = genConfirmMessage(self.CONSTANT.REMOVE, self.member);
			var popupConfig = {
				windowClass: 'confirm-action-popup',
				hideTitle: true,
				hideConfirmText: true,
				title: confirmMessage
			};
			popupConfig.cancelBtnText = 'Cancel';
			var modal = confirmPopupSvc.showPopup(popupConfig);
			modal.result.then(function () {
				removeMemberFromEvent(self.CONSTANT.REMOVE, self.member)
			});
		}

		function genArchivement(user) {
			if (user.account_type === 'business') {
				return 'Business';
			} else if (user.ambassadorship === 'pro') {
				return 'Ambassador Pro';
			} else if (user.ambassadorship === 'maestro') {
				return 'Ambassador Maestro';
			} else {
				return 'Personal';
			}
		}

		function prevenPubbleClick() {
			$window.event.stopPropagation();
		}

		init();
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('managerEventMemberListView', managerEventMemberListView);
		managerEventMemberListView.$inject = []

	function managerEventMemberListView() {

		var directive = {
			scope: {
				member: "=",
				onRemoved: "&",
				community: '=',
				event: '=',
				onToggleSelected: "&?",
				onMemberClicked: "&?",
				onStatusChanged: "&?",
				onManageClicked: "&?",
				type: "@"
			},
			restrict: 'E',
			templateUrl: 'app/components/manager-event-member-list-view/manager-event-member-list-view.html',
			controller: 'managerEventMemberListViewCtrl',
			controllerAs: 'vm',
			replace: true
		};
		return directive;
	}
})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.factory('manageRightCommunityPopupSvc', manageRightCommunityPopupSvc);
	manageRightCommunityPopupSvc.$inject = ['$uibModal'];

	function manageRightCommunityPopupSvc($uibModal) {

		function showPopup(data) {
			return $uibModal.open({
				templateUrl: 'app/components/manage-right-community-popup/manage-right-community-popup.html',
				controller: 'manageRightCommunityPopupCtrl',
				controllerAs: 'vm',
				animation: true,
				windowClass: 'manage-right-community-popup__wrapper',
				backdrop: 'static',
				resolve: {
					'data': function () {
						return data;
					}
				}
			});
		}

		return {
			showPopup: showPopup
		};
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('manageRightCommunityPopupCtrl', manageRightCommunityPopupCtrl);

	manageRightCommunityPopupCtrl.$inject = ['$uibModalInstance', 'data', '$timeout'];

	function manageRightCommunityPopupCtrl($uibModalInstance, data, $timeout) {

		var self = this;
		self.close = close;
		$timeout(function () {
			init();
		}, 0);

		function init() {
			var x, i, j, selElmnt, a, b, c;
			/*look for any elements with the class "custom-select":*/
			x = document.getElementsByClassName("custom-select");
			for (i = 0; i < x.length; i++) {
				selElmnt = x[i].getElementsByTagName("select")[0];
				/*for each element, create a new DIV that will act as the selected item:*/
				a = document.createElement("DIV");
				a.setAttribute("class", "select-selected");
				a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;
				x[i].appendChild(a);
				/*for each element, create a new DIV that will contain the option list:*/
				b = document.createElement("DIV");
				b.setAttribute("class", "select-items select-hide");
				for (j = 1; j < selElmnt.length; j++) {
					/*for each option in the original select element,
					create a new DIV that will act as an option item:*/
					c = document.createElement("DIV");
					c.innerHTML = selElmnt.options[j].innerHTML;
					c.addEventListener("click", function (e) {
						/*when an item is clicked, update the original select box,
						and the selected item:*/
						var y, i, k, s, h;
						s = this.parentNode.parentNode.getElementsByTagName("select")[0];
						h = this.parentNode.previousSibling;
						for (i = 0; i < s.length; i++) {
							if (s.options[i].innerHTML == this.innerHTML) {
								s.selectedIndex = i;
								h.innerHTML = this.innerHTML;
								y = this.parentNode.getElementsByClassName("same-as-selected");
								for (k = 0; k < y.length; k++) {
									y[k].removeAttribute("class");
								}
								this.setAttribute("class", "same-as-selected");
								break;
							}
						}
						h.click();
					});
					b.appendChild(c);
				}
				x[i].appendChild(b);
				a.addEventListener("click", function (e) {
					/*when the select box is clicked, close any other select boxes,
					and open/close the current select box:*/
					e.stopPropagation();
					closeAllSelect(this);
					this.nextSibling.classList.toggle("select-hide");
					this.classList.toggle("select-arrow-active");
				});
			}

		}

		function closeAllSelect(elmnt) {
			/*a function that will close all select boxes in the document,
			except the current select box:*/
			var x, y, i, arrNo = [];
			x = document.getElementsByClassName("select-items");
			y = document.getElementsByClassName("select-selected");
			for (i = 0; i < y.length; i++) {
				if (elmnt == y[i]) {
					arrNo.push(i)
				} else {
					y[i].classList.remove("select-arrow-active");
				}
			}
			for (i = 0; i < x.length; i++) {
				if (arrNo.indexOf(i)) {
					x[i].classList.add("select-hide");
				}
			}
		}
		/*if the user clicks anywhere outside the select box,
		then close all select boxes:*/
		document.addEventListener("click", closeAllSelect);

		function close() {
			$uibModalInstance.close(self.discussion);
		}

	}
})();

(function () {

	angular
		.module('pixerf')
		.factory('manageReportsSvc', manageReportsSvc);

	manageReportsSvc.$inject = [];

	function manageReportsSvc() {

		var mCustomPagingOptions = {
			label: "Rows per page:",
			showValues: [30, 50, 100]
		}

		function getCustomPagingOptions() {
			return mCustomPagingOptions;
		}

		return {
			getCustomPagingOptions: getCustomPagingOptions
		}
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('manageReportsCtrl', manageReportsCtrl);

	manageReportsCtrl.$inject = ['$scope', 'sessionManagerSvc', 'commonConst'];


	function manageReportsCtrl($scope, sessionManagerSvc, commonConst) {

		var USER_CONTROL_ADMINDASHBOARD = ['curator_internal', 'admin_internal', 'marketer_internal'];
		var self = this;
		self.user = sessionManagerSvc.getCurrentLoginUser().data;
		self.isAdmin = self.user && (USER_CONTROL_ADMINDASHBOARD.includes(self.user.role) || self.user.email === 'marcom@pixerf.com');
        self.subContextPage = "reports";
		self.commonConst = commonConst;
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.config(routerConfig);

	routerConfig.$inject = ['$stateProvider'];

	function routerConfig($stateProvider) {
		'ngInject';

		$stateProvider
			.state('setting.manage-reports', {
				url: '/manage-reports',
				templateUrl: 'app/components/manage-reports/manage-reports.html',
				controller: 'manageReportsCtrl',
				controllerAs: 'vm',
				abstract: true,
				data: {
					permissions: {
						only: ['AUTHORIZED'],
						redirectTo: function () {
							return "404";
						}
					},
					pageTitle: "PIXERF - Manage Reports"
				}
			})
			.state('setting.manage-reports.manage-pending-reports', {
				url: '/pending-reports',
				templateUrl: 'app/components/manage-reports/manage-pending-reports/manage-pending-reports.html',
				controller: 'managePendingReportsCtrl',
				controllerAs: 'vm',
				data: {
					pageTitle: "PIXERF - Manage pending reports"
				}
			})
			.state('setting.manage-reports.manage-past-reports', {
				url: '/past-reports',
				templateUrl: 'app/components/manage-reports/manage-past-reports/manage-past-reports.html',
				controller: 'managePastReportsCtrl',
				controllerAs: 'vm',
				data: {
					pageTitle: "PIXERF - Manage past reports"
				}
			});
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('manageReportDetailCompileTemplate', manageReportDetailCompileTemplate);
		manageReportDetailCompileTemplate.$inject = [];

	function manageReportDetailCompileTemplate() {

		var directive = {
			scope: {
				report: "=",
				onClosed: "&",
				onStatusChanged: "&?",
				context: "@",
				appendToBody: "@?"
			},
			restrict: 'E',
			templateUrl: 'app/components/manage-report-detail-compile-template/manage-report-detail-compile-template.html',
			controller: 'ManageReportDetailCompileTemplateCtrl',
			controllerAs: 'vm',
			replace: true
		};
		return directive;
	}

})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('ManageReportDetailCompileTemplateCtrl', ManageReportDetailCompileTemplateCtrl);

		ManageReportDetailCompileTemplateCtrl.$inject = ['$scope', 'sessionManagerSvc', '$window', 'commonConst', 'dateUtils', 'communityRemoveReportPopupSvc', 'communityValidateReportPopupSvc', 'communityResolveReportPopupSvc'];

	function ManageReportDetailCompileTemplateCtrl($scope, sessionManagerSvc, $window, commonConst, dateUtils, communityRemoveReportPopupSvc, communityValidateReportPopupSvc, communityResolveReportPopupSvc) {

		var USER_CONTROL_ADMINDASHBOARD = ['curator_internal', 'admin_internal', 'marketer_internal'];
		var self = this;
		self.loginedUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.isAdmin = self.loginedUser && (USER_CONTROL_ADMINDASHBOARD.includes(self.loginedUser.role) || self.loginedUser.email === 'marcom@pixerf.com');
		self.report = $scope.report;
		self.onClosed = onClosed;
		self.appentToBody = $scope.appentToBody;
		self.onToggleReportReason = onToggleReportReason;
		self.maxStrikes = commonConst.REPORT.NO_IF_STRIKE;
		self.subDataInfo = {};
		self.status = 'validated';
		self.getPreciseDiff = getPreciseDiff;
		self.headerText = '';
		self.replyItems = []
		self.hideDiscussion = false;

		init()

		function init() {
			convertReportTemplateDate();
			generateUserPastLayout(self.report.item_type);
			generateHeaderText(self.report);
		}

		function getPreciseDiff(date){
			var today = moment.utc();
			return dateUtils.preciseDiff(today, moment(date))
		}

		function generateUserPastLayout(type) {
			self.isShowResolveButton = true;
			self.isShowRemoveButton = true;
			switch (type) {
				case 'discussion':
					self.reportType = 'post';
					self.discussion = self.report.discussion;
					break;
				case 'discussion_reply':
					self.reportType = 'comment';
					self.comment = self.report.discussion_reply;
					self.replyItems.push(self.report);
					break;
				default:
					self.reportType = type;
			}
		}

		function generateHeaderText(report) {
			switch (report.status) {
				case "open":
					self.headerText = "In Review";
					self.status = 'open';
					break;
				case "validated":
					self.headerText = "Report Validated - Comment Removed";
					self.status = 'validated';
					self.hideDiscussion = true;
					break;
				case "resolved":
					self.headerText = "Report Resolved - Post Kept";
					self.status = 'resolved';
					break;
				default:
					self.headerText = "In Review";
			}
		}

		function convertReportTemplateDate() {
			self.communityFomatedDate = moment(self.report.community.inserted_at).format("MMMM DD, YYYY");
			self.reportFomatedDate = moment(self.report.inserted_at).format("MMM DD, YYYY");
		}

		function onClosed() {
			$scope.onClosed({
				community: self.community
			});
		}

		function prevenPubbleClick() {
			$window.event.stopPropagation();
		}

		function onToggleReportReason(isOpen) {
			if (!self.report.description) return;
			self.isOpenReportReason = !isOpen;
		}
		
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('managePhotosStatusCtrl', managePhotosStatusCtrl);

	managePhotosStatusCtrl.$inject = ['$scope', 'photoDetailPopupSvc', 'pixerfApiMediaSvc', 'systemUtils'];

	function managePhotosStatusCtrl($scope, photoDetailPopupSvc, pixerfApiMediaSvc, systemUtils) {

		var self = this;
		self.isWorking = false;
		self.onEditPhotoClicked = onEditPhotoClicked;
		self.onPhotoPopupSaved = onPhotoPopupSaved;

		function onEditPhotoClicked(media) {
			pixerfApiMediaSvc.get({
				id: media.id
			}).$promise.then(function (response) {
				photoDetailPopupSvc.showPopup({
					photo: response.data,
					onPhotoPopupSaved: self.onPhotoPopupSaved,
					isEditing: true
				});
			}).catch(function (err) {
				console.log(err);
			})
		}

		function onPhotoPopupSaved(media) {
			if (media && media.newFile) {
				$scope.media.title = media.newFile.title;
			}
		}
	}
})();

(function () {
  'use strict';

  angular
    .module('pixerf')
    .directive('managePhotosStatus', managePhotosStatus);

  function managePhotosStatus() {

    var directive = {
      scope: {
        label: "@",
        status: "=",
        media: "=",
        onMediaDeleted: "&"
      },
      restrict: 'E',
      templateUrl: 'app/components/manage-photos-status/manage-photos-status.html',
      controller: 'managePhotosStatusCtrl',
      controllerAs: 'vm',
      replace: true
    };
    return directive;
  }

})();

(function () {

    angular
        .module('pixerf')
        .factory('manageEventsSvc', manageEventsSvc);

        manageEventsSvc.$inject = ['pixerfApiUserSvc', '$q', 'sessionManagerSvc'];

    function manageEventsSvc(pixerfApiUserSvc, $q, sessionManagerSvc) {
        function getUserInfoAfterLogin() {
			var def = $q.defer();
			pixerfApiUserSvc.me(function (pixerfUserInfo) {
				def.resolve(pixerfUserInfo);
			}, function (error) {
				def.reject(error);
			});
			return def.promise;
        }
        var mCustomPagingOptions = {
			label: "Rows per page:",
			showValues: [30, 50, 100]
		}

		function getCustomPagingOptions() {
			return mCustomPagingOptions;
		}
        
        return {
            getUserInfoAfterLogin: getUserInfoAfterLogin,
			getCustomPagingOptions: getCustomPagingOptions
        }

    }


})();

(function () {

	angular
		.module('pixerf')
		.controller('manageEventsCtrl', manageEventsCtrl);

	manageEventsCtrl.$inject = ['$scope', 'sessionManagerSvc'];


	function manageEventsCtrl($scope, sessionManagerSvc) {

		var USER_CONTROL_ADMINDASHBOARD = ['curator_internal', 'admin_internal', 'marketer_internal'];
		var self = this;
		self.user = sessionManagerSvc.getCurrentLoginUser().data;
		self.isAdmin = self.user && (USER_CONTROL_ADMINDASHBOARD.includes(self.user.role) || self.user.email === 'marcom@pixerf.com');
		self.subContextPage = "events";
		self.isMyProfile = true;
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.config(routerConfig);

	routerConfig.$inject = ['$stateProvider'];

	function routerConfig($stateProvider) {
		'ngInject';

		$stateProvider
			.state('setting.manage-events', {
				url: '/manage-events',
				templateUrl: 'app/components/manage-events/manage-events.html',
				controller: 'manageEventsCtrl',
				controllerAs: 'vm',
				abstract: true,
				data: {
					permissions: {
						only: ['AUTHORIZED'],
						redirectTo: function () {
							return "404";
						}
					},
					pageTitle: "PIXERF - Manage Events"
				}
			})
			.state('setting.manage-events.events', {
				url: '/all',
				templateUrl: 'app/components/manage-events/manage-my-events/manage-my-events.html',
				controller: 'manageMyEventsCtrl',
				controllerAs: 'vm',
				data: {
					pageTitle: "PIXERF - Manage my events"
				}
			})
			.state('setting.manage-events.manage-joined-events', {
				url: '/joined-events',
				templateUrl: 'app/components/manage-events/manage-joined-events/manage-joined-events.html',
				controller: 'manageJoinedEventsCtrl',
				controllerAs: 'vm',
				data: {
					pageTitle: "PIXERF - Manage joined events"
				}
			})
			.state('setting.manage-events.manage-events-invitation', {
				url: '/manage-events-invitation',
				templateUrl: 'app/components/manage-events/manage-events-invitation/manage-events-invitation.html',
				controller: 'manageEventsInvitationCtrl',
				controllerAs: 'vm',
				data: {
					pageTitle: "PIXERF - Manage invitation to join events"
				}
			})
			.state('setting.manage-events.manage-requested-events', {
				url: '/manage-requested-events',
				templateUrl: 'app/components/manage-events/manage-requested-events/manage-requested-events.html',
				controller: 'manageRequestedEventsCtrl',
				controllerAs: 'vm',
				data: {
					pageTitle: "PIXERF - Manage requested events"
				}
			})
			.state('setting.manage-events.event-detail', {
				url: '/:id?name&manage',
				abstract: true,
				templateUrl: 'app/event-detail-page/event-detail-page.html',
				controller: 'eventDetailPageCtrl',
				controllerAs: 'vm',
				data: {
					pageTitle: "PIXERF - Events Detail",
					permissions: {
						only: ['EVERY_ONE']
					}
				},
				params: {
					"id": {
						squash: true,
						value: null
					},
					"name": {
						squash: true,
						value: null
					},
					"manage": {
						squash: true,
						value: null
					}
				},
				resolve: {
					communityData: function ($stateParams, pixerfApiCommunitySvc, $q, $state, toastr, messageConst) {
						var defer = $q.defer();
						var self = this;
						var communityId = parseInt($stateParams.id);
						if (!$stateParams.id || ($stateParams.id && isNaN(communityId))) {
							$state.go('404');
							defer.reject();
						} else {
							pixerfApiCommunitySvc.get({
								id: communityId
							}).$promise.then(function (response) {
								var community = response.data;
								self.data.pageTitle = "PIXERF - Community: " + community.name;
								defer.resolve(community);
							}, function (err) {
								console.log(err);
								$state.go('404');
								defer.reject();
							})
						}
						return defer.promise;
					}
				}
			})
			.state('setting.manage-events.manage-going-events', {
				url: '/going-events',
				templateUrl: 'app/components/manage-events/manage-going-events/manage-going-events.html',
				controller: 'manageGoingEventsCtrl',
				controllerAs: 'vm',
				data: {
					pageTitle: "PIXERF - Manage going events"
				}
			})
			.state('setting.manage-events.manage-hosting-events', {
				url: '/hosting-events',
				templateUrl: 'app/components/manage-events/manage-hosting-events/manage-hosting-events.html',
				controller: 'manageHostingEventsCtrl',
				controllerAs: 'vm',
				data: {
					pageTitle: "PIXERF - Manage hosting events"
				}
			})
			.state('setting.manage-events.manage-invited-events', {
				url: '/invited-events',
				templateUrl: 'app/components/manage-events/manage-invited-events/manage-invited-events.html',
				controller: 'manageInvitedEventsCtrl',
				controllerAs: 'vm',
				data: {
					pageTitle: "PIXERF - Manage invited events"
				}
			})
			.state('setting.manage-events.manage-interested-events', {
				url: '/interested-events',
				templateUrl: 'app/components/manage-events/manage-interested-events/manage-interested-events.html',
				controller: 'manageInterestedEventsCtrl',
				controllerAs: 'vm',
				data: {
					pageTitle: "PIXERF - Manage interested events"
				}
			})
			.state('setting.manage-events.manage-draft-events', {
				url: '/draft-events',
				templateUrl: 'app/components/manage-events/manage-draft-events/manage-draft-events.html',
				controller: 'manageDraftEventsCtrl',
				controllerAs: 'vm',
				data: {
					pageTitle: "PIXERF - Manage draft events"
				}
			})
			.state('setting.manage-events.manage-past-events', {
				url: '/past-events',
				templateUrl: 'app/components/manage-events/manage-past-events/manage-past-events.html',
				controller: 'managePastEventsCtrl',
				controllerAs: 'vm',
				data: {
					pageTitle: "PIXERF - Manage past events"
				}
			})
			.state('setting.manage-events.manage-in-review-events', {
				url: '/in-review-events',
				templateUrl: 'app/components/manage-events/manage-in-review-events/manage-in-review-events.html',
				controller: 'manageInReviewEventsCtrl',
				controllerAs: 'vm',
				data: {
					pageTitle: "PIXERF - Manage in review events"
				}
			}
		);
	}
})();

(function () {

	angular
		.module('pixerf')
		.factory('manageEventSvc', manageEventSvc);

		manageEventSvc.$inject = [];

	function manageEventSvc() {

		var mCustomPagingOptions = {
			label: "Rows per page:",
			showValues: [30, 50, 100]
		}

		function getCustomPagingOptions() {
			return mCustomPagingOptions;
		}

		return {
			getCustomPagingOptions: getCustomPagingOptions
		}
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('manageEventCtrl', manageEventCtrl);

		manageEventCtrl.$inject = ['$rootScope', 'sessionManagerSvc', 'eventData', '$state', '$timeout', 'pixerfApiCommunitySvc'];


	function manageEventCtrl($rootScope, sessionManagerSvc, eventData, $state, $timeout, pixerfApiCommunitySvc) {

		var USER_CONTROL_ADMINDASHBOARD = ['curator_internal', 'admin_internal', 'marketer_internal'];
		var self = this;
		self.user = sessionManagerSvc.getCurrentLoginUser().data;
		self.isAdmin = self.user && (USER_CONTROL_ADMINDASHBOARD.includes(self.user.role) || self.user.email === 'marcom@pixerf.com');
		self.subContextPage = "communities";
		self.isMyProfile = true;
		self.event = eventData;
		self.isTypeClass = eventData && eventData.event_type == 'class';
		self.community = {};
		self.showTopCountMember = ($state.current.name == 'manage-event.members');
		self.showReportsNav = ($state.current.name == 'manage-event.reports');
		self.managerList = [];
		self.isOwner = self.user && (self.user.id === self.event.owner.id);
		self.loading = false;


		self.isScreenMobile = $rootScope.isScreenMobile;
        $(window).resize(function(){
            self.isScreenMobile = $rootScope.isScreenMobile;
        })

		$rootScope.$on('$stateChangeSuccess', function(event, toState){
            $timeout(function() {
                self.showTopCountMember = (toState.name == 'manage-event.members');
                self.showReportsNav = (toState.name == 'manage-event.reports');
            });
        });

		function isManager(){
			var result = true;
			var selectedUser = _.filter(self.managerList, function (item) {
				return item.id === self.user.id;
			});
			if(!selectedUser || !selectedUser.length){
				result = false;
			}
			return result;
		}

		function getCommunity(communityId){
			self.loading = true;
			pixerfApiCommunitySvc.get({
				id: communityId
			}).$promise.then(function (response) {
				self.community = response.data;
				self.managerList = _.filter(self.community.members, function (item) {
					return item.status === 'manager';
				})

				if(!self.isOwner && !isManager()){
					$state.go("404");
				}
				self.loading = false;
			}, function (err) {
				console.log(err);
				self.loading = false;
			})
		}
		
		function init(){
			getCommunity(self.event.community_id);
		}

		init();

	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.config(routerConfig);

	routerConfig.$inject = ['$stateProvider'];

	function routerConfig($stateProvider) {
		'ngInject';

		$stateProvider
			.state('manage-event', {
				url: '/manage-event/:id/:name',
				templateUrl: 'app/components/manage-event/manage-event.html',
				controller: 'manageEventCtrl',
				controllerAs: 'vm',
				abstract: true,
				data: {
					permissions: {
						only: ['AUTHORIZED'],
						redirectTo: function () {
							return "404";
						}
					},
					pageTitle: "PIXERF - Manage Event/Class"
				},
				params: {
					"id": {
						squash: true,
						value: null
					},
					"name": {
						squash: true,
						value: null
					}
				},
				resolve: {
					eventData: function ($stateParams, pixerfApiEventSvc, $q, $state, commonConst) {
						var defer = $q.defer();
						var self = this;
						var eventId = parseInt($stateParams.id);
						if (!$stateParams.id || ($stateParams.id && isNaN(eventId))) {
							$state.go('404');
							defer.reject();
						} else {
							pixerfApiEventSvc.get({
								id: eventId
							}).$promise.then(function (response) {
								var event = response.data;
								self.data.pageTitle = "PIXERF - Event: " + event.name;
								defer.resolve(event);
							}, function (err) {
								console.log(err);
								defer.reject();
							})
						}
						return defer.promise;
					}
				}
			})
			.state('manage-event.members', {
				url: '/attendees/:status',
				templateUrl: 'app/components/manage-event/manage-event-members/manage-event-members.html',
				controller: 'manageEventMembersCtrl',
				controllerAs: 'vm',
				data: {
					pageTitle: "PIXERF - Manage Event Attendees"
				}
			})
			.state('manage-event.pending-posts', {
				url: '/pending-posts',
				templateUrl: 'app/components/manage-event/pending-posts/pending-posts.html',
				controller: 'manageEventPendingPostsCtrl',
				controllerAs: 'vm',
				data: {
					pageTitle: "PIXERF - Manage event Pending Posts"
				}
			})
			.state('manage-event.reports', {
				url: '/reports/:status',
				templateUrl: 'app/components/manage-event/manage-event-reports/manage-event-reports.html',
				controller: 'manageEventReportsCtrl',
				controllerAs: 'vm',
				data: {
					pageTitle: "PIXERF - Manage event Reports"
				}
			})
			.state('manage-event.edit-event', {
				url: '/edit-event',
				templateUrl: 'app/components/manage-event/edit-event/edit-event.html',
				controller: 'editEventCtrl',
				controllerAs: 'vm',
				data: {
					pageTitle: "PIXERF - Edit Event"
				}
			})
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('manageCommunityReportListViewCtrl', manageCommunityReportListViewCtrl);

	manageCommunityReportListViewCtrl.$inject = ['$scope', 'sessionManagerSvc', '$window', 'commonConst', 'communityResolveReportPopupSvc', 'communityValidateReportPopupSvc', 'communityRemoveReportPopupSvc'];

	function manageCommunityReportListViewCtrl($scope, sessionManagerSvc, $window, commonConst, communityResolveReportPopupSvc, communityValidateReportPopupSvc, communityRemoveReportPopupSvc) {

		var USER_CONTROL_ADMINDASHBOARD = ['curator_internal', 'admin_internal', 'marketer_internal'];
		var self = this;
		self.loginedUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.onToggleSelected = onToggleSelected;
		self.onReportClicked = onReportClicked;
		self.prevenPubbleClick = prevenPubbleClick;
		self.onViewPostBtnClicked = onViewPostBtnClicked;
		self.isAdmin = self.loginedUser && (USER_CONTROL_ADMINDASHBOARD.includes(self.loginedUser.role) || self.loginedUser.email === 'marcom@pixerf.com');
		self.report = $scope.report;
		self.disabledCheckbox = disabledCheckbox;

		init();

		function init() {
			convertCreatedDate();
			convertTypeOfReport();
			self.reportAvatar = buildUserAvatar(self.report.user);
		}

		function buildUserAvatar(member) {
			var userAvatar = {
				avatar: { profileImage: (member.profile_image_media && member.profile_image_media['100x']) ? member.profile_image_media['100x'] : member.profile_image },
				displayName: member.displayName,
				account_type: member.account_type
			}
			return userAvatar;
		}

		function onToggleSelected(report) {
			$scope.onToggleSelected({
				report: report
			});
		}

		function disabledCheckbox(){
			var result = false;
			if((self.report.community.previous_deactivation_count && self.report.community.previous_deactivation_count >= 3) || (self.report.item_type == 'discussion') || (self.report.item_type == 'discussion_reply')){
				result = true;
			}
			return result;
		}

		function convertCreatedDate() {
			self.fomatedDate = moment(self.report.inserted_at).format("MMM DD, YYYY");
		}

		function convertTypeOfReport() {
			var isShowResoleButton = true;
			if(self.report.community && self.report.community.previous_deactivation_count && self.report.community.previous_deactivation_count >= 3){
				isShowResoleButton = false;
			};
			var resolveReportControl = {
				label: 'Resolve',
				cta: self.onResolve
			};
			switch (self.report.item_type) {
				case "event":
					self.isShowStrikeList = true;
					self.typeOfReport = "Event";
					self.report.typeOfReport = "Event";
					self.moreList = [{
							label: 'Validate event',
							cta: self.onValidate
						}
					];

					if(isShowResoleButton){
						self.moreList.push(resolveReportControl);
					}

					break;
				case "discussion":
					self.typeOfReport = "Post";
					self.report.typeOfReport = "Post";
					if (self.isAdmin) {
						self.isHideMoreControl = true;
					} else {
						self.moreList = [{
								label: 'Remove post',
								cta: self.onRemove
							}
						];

						if(isShowResoleButton){
							self.moreList.push(resolveReportControl);
						}
					}
					break;
				case "discussion_reply":
					self.typeOfReport = "Comment";
					self.report.typeOfReport = "Comment";
					if (self.isAdmin) {
						self.isHideMoreControl = true;
					} else {
						self.moreList = [{
								label: 'Remove comment',
								cta: self.onRemove
							}
						];

						if(isShowResoleButton){
							self.moreList.push(resolveReportControl);
						}
					}
					break;
				case "community":
					self.isShowStrikeList = true;
					self.typeOfReport = "Community";
					self.report.typeOfReport = "Community";
					self.moreList = [{
							label: 'Validate community',
							cta: self.onValidate
						}
					];

					if(isShowResoleButton){
						self.moreList.push(resolveReportControl);
					}
					break;
			}
		}

		function prevenPubbleClick() {
			$window.event.stopPropagation();
		}

		function onReportClicked(report) {
			self.isActived = true;
			$scope.onReportClicked({
				report: report
			});
		}
		function onViewPostBtnClicked() {
			prevenPubbleClick();
			
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('manageCommunityReportListView', manageCommunityReportListView);
		manageCommunityReportListView.$inject = []

	function manageCommunityReportListView() {

		var directive = {
			scope: {
				report: "=",
				onToggleSelected: "&?",
				onReportClicked: "&?",
				onStatusChanged: "&?",
				type: "@"
			},
			restrict: 'E',
			templateUrl: 'app/components/manage-community-report-list-view/manage-community-report-list-view.html',
			controller: 'manageCommunityReportListViewCtrl',
			controllerAs: 'vm',
			replace: true
		};
		return directive;
	}
})();

(function () {

	angular
		.module('pixerf')
		.factory('manageCommunitySvc', manageCommunitySvc);

		manageCommunitySvc.$inject = [];

	function manageCommunitySvc() {

		var mCustomPagingOptions = {
			label: "Rows per page:",
			showValues: [30, 50, 100]
		}

		function getCustomPagingOptions() {
			return mCustomPagingOptions;
		}

		return {
			getCustomPagingOptions: getCustomPagingOptions
		}
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('manageCommunityCtrl', manageCommunityCtrl);

		manageCommunityCtrl.$inject = ['$rootScope', 'sessionManagerSvc', 'communityData', '$state', '$timeout'];


	function manageCommunityCtrl($rootScope, sessionManagerSvc, communityData, $state, $timeout) {

		var USER_CONTROL_ADMINDASHBOARD = ['curator_internal', 'admin_internal', 'marketer_internal'];
		var self = this;
		self.user = sessionManagerSvc.getCurrentLoginUser().data;
		self.isAdmin = self.user && (USER_CONTROL_ADMINDASHBOARD.includes(self.user.role) || self.user.email === 'marcom@pixerf.com');
		self.subContextPage = "communities";
		self.isMyProfile = true;
		self.community = communityData;
		self.showTopCountMember = ($state.current.name == 'manage-community.members');
		self.showReportsNav = ($state.current.name == 'manage-community.reports');
		self.managerList = _.filter(self.community.members, function (item) {
			return item.status === 'manager';
		})
		self.isOwner = self.user && (self.user.id === self.community.owner.id);
		self.isManager = isManager;


		self.isScreenMobile = $rootScope.isScreenMobile;
        $(window).resize(function(){
            self.isScreenMobile = $rootScope.isScreenMobile;
        })

		$rootScope.$on('$stateChangeSuccess', function(event, toState){
            $timeout(function() {
                self.showTopCountMember = (toState.name == 'manage-community.members');
                self.showReportsNav = (toState.name == 'manage-community.reports');
            });
        });

		function isManager(){
			var result = true;
			var selectedUser = _.filter(self.managerList, function (item) {
				return item.id === self.user.id;
			});
			if(!selectedUser || !selectedUser.length){
				result = false;
			}
			return result;
		}
		
		function init(){
			if(!self.isOwner && !isManager()){
				$state.go("404");
			}
		}

		init();

	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.config(routerConfig);

	routerConfig.$inject = ['$stateProvider'];

	function routerConfig($stateProvider) {
		'ngInject';

		$stateProvider
			.state('manage-community', {
				url: '/manage-community/:id/:name',
				templateUrl: 'app/components/manage-community/manage-community.html',
				controller: 'manageCommunityCtrl',
				controllerAs: 'vm',
				abstract: true,
				data: {
					permissions: {
						only: ['AUTHORIZED'],
						redirectTo: function () {
							return "404";
						}
					},
					pageTitle: "PIXERF - Manage community"
				},
				params: {
					"id": {
						squash: true,
						value: null
					},
					"name": {
						squash: true,
						value: null
					}
				},
				resolve: {
					communityData: function ($stateParams, pixerfApiCommunitySvc, $q, $state, commonConst) {
						var defer = $q.defer();
						var self = this;
						var communityId = parseInt($stateParams.id);
						if (!$stateParams.id || ($stateParams.id && isNaN(communityId))) {
							$state.go('404');
							defer.reject();
						} else {
							pixerfApiCommunitySvc.get({
								id: communityId
							}).$promise.then(function (response) {
								var community = response.data;
								self.data.pageTitle = "PIXERF - Community: " + community.name;
								defer.resolve(community);
							}, function (err) {
								console.log(err);
								$state.go(commonConst.STATE.COMMUNITY_NOT_FOUND);
								defer.reject();
							})
						}
						return defer.promise;
					}
				}
			})
			.state('manage-community.members', {
				url: '/members/:status',
				templateUrl: 'app/components/manage-community/manage-community-members/manage-community-members.html',
				controller: 'manageCommunityMembersCtrl',
				controllerAs: 'vm',
				data: {
					pageTitle: "PIXERF - Manage community members"
				}
			})
			.state('manage-community.pending-posts', {
				url: '/pending-posts',
				templateUrl: 'app/components/manage-community/pending-posts/pending-posts.html',
				controller: 'manageCommunityPendingPostsCtrl',
				controllerAs: 'vm',
				data: {
					pageTitle: "PIXERF - Manage community Pending Posts"
				}
			})
			.state('manage-community.reports', {
				url: '/reports/:status',
				templateUrl: 'app/components/manage-community/manage-community-reports/manage-community-reports.html',
				controller: 'manageCommunityReportsCtrl',
				controllerAs: 'vm',
				data: {
					pageTitle: "PIXERF - Manage community Reports"
				}
			})
			.state('manage-community.edit-community', {
				url: '/edit-community',
				templateUrl: 'app/components/manage-community/edit-community/edit-community.html',
				controller: 'editCommunityCtrl',
				controllerAs: 'vm',
				data: {
					pageTitle: "PIXERF - Manage community edit"
				}
			})
	}
})();

(function () {

	angular
		.module('pixerf')
		.factory('manageCommunitiesSvc', manageCommunitiesSvc);

	manageCommunitiesSvc.$inject = [];

	function manageCommunitiesSvc() {

		var mCustomPagingOptions = {
			label: "Rows per page:",
			showValues: [30, 50, 100]
		}

		function getCustomPagingOptions() {
			return mCustomPagingOptions;
		}

		return {
			getCustomPagingOptions: getCustomPagingOptions
		}
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('manageCommunitiesCtrl', manageCommunitiesCtrl);

		manageCommunitiesCtrl.$inject = ['$scope', 'sessionManagerSvc'];


	function manageCommunitiesCtrl($scope, sessionManagerSvc) {

		var USER_CONTROL_ADMINDASHBOARD = ['curator_internal', 'admin_internal', 'marketer_internal'];
		var self = this;
		self.user = sessionManagerSvc.getCurrentLoginUser().data;
		self.isAdmin = self.user && (USER_CONTROL_ADMINDASHBOARD.includes(self.user.role) || self.user.email === 'marcom@pixerf.com');
		self.subContextPage = "communities";
		self.isMyProfile = true;
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.config(routerConfig);

	routerConfig.$inject = ['$stateProvider'];

	function routerConfig($stateProvider) {
		'ngInject';

		$stateProvider
			.state('setting.manage-communities', {
				url: '/manage-communities',
				templateUrl: 'app/components/manage-communities/manage-communities.html',
				controller: 'manageCommunitiesCtrl',
				controllerAs: 'vm',
				abstract: true,
				data: {
					permissions: {
						only: ['AUTHORIZED'],
						redirectTo: function () {
							return "404";
						}
					},
					pageTitle: "PIXERF - Manage Communities"
				}
			})
			.state('setting.manage-communities.communities', {
				url: '/all',
				templateUrl: 'app/components/manage-communities/manage-my-communities/manage-my-communities.html',
				controller: 'manageMyCommunitiesCtrl',
				controllerAs: 'vm',
				data: {
					pageTitle: "PIXERF - Manage your communities"
				}
			})
			.state('setting.manage-communities.manage-invited-communities', {
				url: '/manage-invited-communities',
				templateUrl: 'app/components/manage-communities/manage-invited-communities/manage-invited-communities.html',
				controller: 'manageInvitedCommunitiesCtrl',
				controllerAs: 'vm',
				data: {
					pageTitle: "PIXERF - Manage your communities invited"
				}
			})
			.state('setting.manage-communities.manage-requested-communities', {
				url: '/manage-requested-communities',
				templateUrl: 'app/components/manage-communities/manage-requested-communities/manage-requested-communities.html',
				controller: 'manageRequestedCommunitiesCtrl',
				controllerAs: 'vm',
				data: {
					pageTitle: "PIXERF - Manage requested communities"
				}
			})
			.state('setting.manage-communities.community-detail', {
				url: '/:id?name&manage',
				abstract: true,
				templateUrl: 'app/community-detail-page/community-detail-page.html',
				controller: 'communityDetailPageCtrl',
				controllerAs: 'vm',
				data: {
					pageTitle: "PIXERF - Community Detail",
					permissions: {
						only: ['EVERY_ONE']
					}
				},
				params: {
					"id": {
						squash: true,
						value: null
					},
					"name": {
						squash: true,
						value: null
					},
					"manage": {
						squash: true,
						value: null
					}
				},
				resolve: {
					communityData: function ($stateParams, pixerfApiCommunitySvc, $q, $state, toastr, messageConst) {
						var defer = $q.defer();
						var self = this;
						var communityId = parseInt($stateParams.id);
						if (!$stateParams.id || ($stateParams.id && isNaN(communityId))) {
							$state.go('404');
							defer.reject();
						} else {
							pixerfApiCommunitySvc.get({
								id: communityId
							}).$promise.then(function (response) {
								var community = response.data;
								self.data.pageTitle = "PIXERF - Community: " + community.name;
								defer.resolve(community);
							}, function (err) {
								console.log(err);
								$state.go('404');
								defer.reject();
							})
						}
						return defer.promise;
					}
				}
			})
			.state('setting.manage-communities.manage-pending-communities', {
				url: '/pending-communities',
				templateUrl: 'app/components/manage-communities/manage-pending-communities/manage-pending-communities.html',
				controller: 'managePendingCommunitiesCtrl',
				controllerAs: 'vm',
				data: {
					pageTitle: "PIXERF - Manage pending communities"
				}
			})
			.state('setting.manage-communities.manage-pending-approval-communities', {
				url: '/pending-approval-communities',
				templateUrl: 'app/components/manage-communities/manage-pending-approval-communities/manage-pending-approval-communities.html',
				controller: 'managePendingApprovalCommunitiesCtrl',
				controllerAs: 'vm',
				data: {
					pageTitle: "PIXERF - Manage pending approval communities"
				}
			})
			.state('setting.manage-communities.manage-action-required-communities', {
				url: '/action-required-communities',
				templateUrl: 'app/components/manage-communities/manage-action-required-communities/manage-action-required-communities.html',
				controller: 'manageActionRequiredCommunitiesCtrl',
				controllerAs: 'vm',
				data: {
					pageTitle: "PIXERF - Manage action required communities"
				}
			})
			.state('setting.manage-communities.manage-active-communities', {
				url: '/active-communities',
				templateUrl: 'app/components/manage-communities/manage-active-communities/manage-active-communities.html',
				controller: 'manageActiveCommunitiesCtrl',
				controllerAs: 'vm',
				data: {
					pageTitle: "PIXERF - Manage active communities"
				}
			})
			.state('setting.manage-communities.manage-inreview-communities', {
				url: '/inreview-communities',
				templateUrl: 'app/components/manage-communities/manage-inreview-communities/manage-inreview-communities.html',
				controller: 'manageInreviewCommunitiesCtrl',
				controllerAs: 'vm',
				data: {
					pageTitle: "PIXERF - Manage in review communities"
				}
			})
			.state('setting.manage-communities.manage-deactivated-communities', {
				url: '/deactivated-communities',
				templateUrl: 'app/components/manage-communities/manage-deactivated-communities/manage-deactivated-communities.html',
				controller: 'manageDeactivatedCommunitiesCtrl',
				controllerAs: 'vm',
				data: {
					pageTitle: "PIXERF - Manage deactivated communities"
				}
			});
	}
})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('listPaymentMethodPopupCtrl', listPaymentMethodPopupCtrl);

    listPaymentMethodPopupCtrl.$inject = ['$scope'];

    function listPaymentMethodPopupCtrl($scope) {

        var self = this;
        self.onPaymentMethodClicked = onPaymentMethodClicked;
        self.paymentMethods = [{
            code: 'PAYPAL',
            name: 'PayPal',
            fee: 'Fees will apply.',
            details: 'Connect your existing PayPal account',
        }
        ,{
            code: 'BANK_TRANSFER',
            name: 'Wire Transfer',
            fee: 'Transfer fees in respective countries will apply.'
            // details: 'Business day processing only; weekends and banking holidays may cause delays.'
        },{
            code: 'CHEQUE',
            name: 'Cheque',
            fee: 'A SGD 2.00 fee will apply for each cheque. Cheque payments will only be offered in Singapore.'
            // details: 'Business day processing only; weekends and banking holidays may cause delays.'
        }];

        function selectPaymentMethod(paymentMethod){
            if($scope.selectedPaymentMethod){
                $scope.selectedPaymentMethod.isSelected = false;
            }
            paymentMethod.isSelected = true;
            $scope.selectedPaymentMethod = paymentMethod;
        }
        function onPaymentMethodClicked(paymentMethod){
            selectPaymentMethod(paymentMethod);
        }
    }
})();
(function () {
  'use strict';

  angular
    .module('pixerf')
    .directive('listPaymentMethodPopup', listPaymentMethodPopup);

  function listPaymentMethodPopup() {

    var directive = {
      scope: {
          selectedPaymentMethod: '=',
          alert: '='
      },
      restrict: 'E',
      templateUrl: 'app/components/list-payment-method-popup/list-payment-method-popup.html',
      controller: 'listPaymentMethodPopupCtrl',
      controllerAs: 'vm',
      replace: true
    };
    return directive;
  }

})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('linkMobileAppCtrl', linkMobileAppCtrl);

    linkMobileAppCtrl.$inject = ['systemUtils'];

    function linkMobileAppCtrl(systemUtils) {

		var self = this;
		self.mobileOS = systemUtils.getMobileOS();
		mobileOSCheck();
		function mobileOSCheck() {
			if(self.mobileOS === 'iOS') {
				self.isIOS = true;
			} else if(self.mobileOS === 'Android') {
				self.isAndroid = true;
			}
		}
    }
})();
(function() {
    'use strict';

    angular
        .module('pixerf')
        .directive('linkMobileApp', linkMobileApp);

    linkMobileApp.$inject = [];

    function linkMobileApp() {
        return {
            restrict: 'E',
            scope: {},
            templateUrl: 'app/components/link-mobile-app/link-mobile-app.html',
            controller: 'linkMobileAppCtrl',
            controllerAs: 'vm',
            replace: true
        };
    }
})();
(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('likeBtnCtrl', likeBtnCtrl);

	likeBtnCtrl.$inject = ['$scope', 'photoSvc', 'sessionManagerSvc', 'toastr', 'peopleListPopupSvc', 'accountConst', 'numberUtils', '$translate', 'translationSvc'];

	function likeBtnCtrl($scope, photoSvc, sessionManagerSvc, toastr, peopleListPopupSvc, accountConst, numberUtils, $translate, translationSvc) {

		var self = this;

		self.loginnedUser = sessionManagerSvc.getCurrentLoginUser().data;
		$scope.media.isMine = self.loginnedUser ? self.loginnedUser.id === $scope.media.user.id : false;

		self.onLikePhotoBtnClick = onLikePhotoBtnClick;
		self.onShowLikedListBtnClick = onShowLikedListBtnClick;
		self.getLikeCount = getLikeCount;
		self.getLikeBtnTitle = getLikeBtnTitle;


		function onLikePhotoBtnClick(photo) {
			if (!self.loginnedUser || self.loginnedUser.isBiz) {
				return;
			}
			if (photo.isLiking) return;
			photo.isLiking = true;
			photoSvc.likePhoto(photo).then(function (response) {
				delete photo.isLiking;
				photo.is_liked = !photo.is_liked;
				var step = photo.is_liked ? 1 : -1;
				photo.like_count += step;
			}, function () {
				delete photo.isLiking;
				toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG_WHEN_LIKE_PHOTO', true, true));
			})
		}

		function getLikeBtnTitle(media) {
			return self.loginnedUser && (media.isMine || self.loginnedUser.canManageMission) ? $translate.instant('number-of-likes') : (media.is_liked ? $translate.instant('unlike-this-photo') : $translate.instant('like-this-photo'));
		}

		function onShowLikedListBtnClick() {
			if ($scope.media.like_count === 0) {
				return;
			}
			peopleListPopupSvc.showPopup({
				type: accountConst.INTERACT_TYPE.LIKE.toLowerCase(),
				mediaid: $scope.media.id,
				user: self.loginnedUser
			});
		}

		function getLikeCount(likeNumber) {
			return numberUtils.formatNumberByK(likeNumber);
		}

	}
})();

(function () {
  'use strict';

  angular
    .module('pixerf')
    .directive('likeBtn', likeBtn);

  function likeBtn() {

    var directive = {
      scope: {
        "media" : "=",
        "hoverShowNumber" : "="
      },
      restrict: 'E',
      templateUrl: 'app/components/like-btn/like-btn.html',
      controller: 'likeBtnCtrl',
      controllerAs: 'vm',
      replace: true
    };
    return directive;
  }

})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.factory('licenseReviewPopupSvc', licenseReviewPopupSvc);
	licenseReviewPopupSvc.$inject = ['$uibModal'];

	function licenseReviewPopupSvc($uibModal) {

		function showPopup(data) {
			return $uibModal.open({
				templateUrl: 'app/components/license-review-popup/license-review-popup.html',
				controller: 'licenseReviewPopupCtrl',
				controllerAs: 'vm',
				animation: true,
				windowClass: 'zindex license-review-popup__screen',
				backdrop: 'static',
				resolve: {
					popupData: function () {
						return data;
					}
				}
			});
		}

		return {
			showPopup: showPopup
		};
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('licenseReviewPopupCtrl', licenseReviewPopupCtrl);

	licenseReviewPopupCtrl.$inject = ['$scope', 'popupData', 'pixerfApiMediaSvc', 'toastr', 'systemUtils', 'photoSvc', 'translationSvc', '$uibModalInstance'];

	function licenseReviewPopupCtrl($scope, popupData, pixerfApiMediaSvc, toastr, systemUtils, photoSvc, translationSvc, $uibModalInstance) {

		var self = this;
		self.onQuestionAnswered = onQuestionAnswered;
		self.onApproveBtnClicked = onApproveBtnClicked;
		self.onCloseBtnClicked = onCloseBtnClicked;
		self.isWorking = false;
		self.file = popupData
		self.spinner = {
			isVisible: false
		}
		self.savedData = {}

		init();

		function init() {
			if (self.isWorking) {
				return;
			};
			self.isWorking = true;
			self.spinner.isVisible = true;
			photoSvc.updatePhotoInfo(self.file).then(function () {
				self.spinner.isVisible = false;
				self.isWorking = false;
				self.savedData = {
					'license': self.file.license,
					'has_model_property': self.file.has_model_property,
					'releases': self.file.releases,
					'user_selection': self.file.user_selection,
					'status': self.file.status,

				}
			}, function () {
				self.isWorking = false;
				self.spinner.isVisible = false;
			})
		}

		function onApproveBtnClicked() {
			if (self.isWorking) return;
			self.isWorking = true;
			pixerfApiMediaSvc.update({
				id: self.file.id
			}, self.savedData).$promise.then(function () {
				self.isWorking = false;
				self.file.license = self.savedData.license;
				self.file.has_model_property = self.savedData.has_model_property;
				self.file.releases = self.savedData.releases;
				$uibModalInstance.close('approved');
			}, function () {
				self.isWorking = false;
				toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
			});
		}

		function onQuestionAnswered(question) {
			if (question === 'COMMERCIAL?' ||
				question === 'NO_NEED_RELEASE?') {
				self.savedData.license = 'commercial';
			} else if (question === 'NOT_COMMERCIAL?') {
				self.savedData.license = 'editorial';
				self.savedData.has_model_property = null;
				self.savedData.releases = [];
			}
		}

		function onCloseBtnClicked(data) {
			$uibModalInstance.dismiss(data);
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.factory('licenseReviewSvc', licenseReviewSvc);

	licenseReviewSvc.$inject = ['$uibModal'];

	function licenseReviewSvc($uibModal) {

		function showPopup(data) {
			return $uibModal.open({
				templateUrl: 'app/components/license-review/license-review-popover.html',
				controller: 'licenseReviewCtrl',
				controllerAs: 'vm',
				animation: true,
				windowClass: 'license-review__screen',
				backdrop: 'static',
				resolve: {
					'data': function () {
						return data;
					}
				}
			});
		}

		return {
			showPopup: showPopup
		};
	}
})();

(function () {
    'use strict';

    angular
        .module('pixerf')
        .controller('licenseReviewCtrl', licenseReviewCtrl);

    licenseReviewCtrl.$inject = ['$scope', 'pixerfApiMediaSvc', 'toastr', 'systemUtils', 'photoSvc', 'translationSvc'];

    function licenseReviewCtrl($scope, pixerfApiMediaSvc, toastr, systemUtils, photoSvc, translationSvc) {

        var self = this;
        self.onQuestionAnswered = onQuestionAnswered;
        self.onApproveBtnClicked = onApproveBtnClicked;
        self.onCloseBtnClicked = onCloseBtnClicked;
        self.onPopoverOpenned = onPopoverOpenned;
        self.isWorking = false;
        self.bulkFiles = $scope.bulkFiles || [];
        self.spinner = {
            isVisible: false
        }
        self.savedData = {};

        function onPopoverOpenned() {
            if (self.isWorking) {
                return;
            };
            self.isWorking = true;
            self.spinner.isVisible = true;
            systemUtils.triggerBodyClicked();
            var participation = $scope.file.participation;
            photoSvc.updatePhotoInfo($scope.file).then(function () {
                self.spinner.isVisible = false;
                self.isWorking = false;
                $scope.file.participation = participation;
                self.savedData = {
                    'license': $scope.file.license,
                    'has_model_property': $scope.file.has_model_property,
                    'releases': $scope.file.releases,
                    'user_selection': $scope.file.user_selection,
                    'status': $scope.file.status,

                }
            }, function () {
                self.isWorking = false;
                self.spinner.isVisible = false;
            })
        }

        function onApproveBtnClicked() {
            if (self.isWorking) return;
            self.isWorking = true;
            if (self.bulkFiles.length) {
                onApproveBulkPhoto();
            } else {
                onApprovePhoto();
            }
        }

        function onQuestionAnswered(question) {
            if (question === 'COMMERCIAL?' ||
                question === 'NO_NEED_RELEASE?') {
                self.savedData.license = 'commercial';
            } else if (question === 'NOT_COMMERCIAL?') {
                self.savedData.license = 'editorial';
                self.savedData.has_model_property = null;
                self.savedData.releases = [];
            }
        }

        function onCloseBtnClicked() {
            systemUtils.triggerBodyClicked();
        }

        function onApproveBulkPhoto() {
            for (var i = 0; i < self.bulkFiles.length; i++) {
                pixerfApiMediaSvc.update({ id: self.bulkFiles[i].id }, self.savedData).$promise.then(function (respone) {
                    self.isWorking = false;
                    _.map(self.bulkFiles, function (result) {
                        if(result.id === respone.id){
                            result.license = respone.license;
                            result.has_model_property = respone.has_model_property;
                            result.releases = respone.releases;
                        }
                        return result;
                    })
                    $scope.onApproved();
                }, function () {
                    self.isWorking = false;
                    toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
                });
            }
        }

        function onApprovePhoto() {
            pixerfApiMediaSvc.update({ id: $scope.file.id }, self.savedData).$promise.then(function () {
                self.isWorking = false;
                $scope.file.license = self.savedData.license;
                $scope.file.has_model_property = self.savedData.has_model_property;
                $scope.file.releases = self.savedData.releases;
                $scope.onApproved();
            }, function () {
                self.isWorking = false;
                toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
            });
        }
    }
})();

(function () {
  'use strict';

  angular
    .module('pixerf')
    .directive('licenseReview', licenseReview);

  function licenseReview() {

    var directive = {
      scope: {
        'isDisabled': '=',
        'onGalleryItemClicked': '&',
        'file': '=',
        'onOpen': '&',
        'onClose': '&',
        'spinner': '=',
        'loadMoreGalleries': '&',
        'onApproved': '&',
        'closeOnClick': '@',
        'bulkFiles': "="
      },
      restrict: 'E',
      controller: 'licenseReviewCtrl',
      templateUrl: 'app/components/license-review/license-review.html',
      controllerAs: 'vm',
      replace: true,
      transclude: true
    };
    return directive;
  }

})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('leaderBoardCtrl', leaderBoardCtrl);

    leaderBoardCtrl.$inject = ['pixerfApiPhotographerSvc', '$scope', 'pagingUtils', 'toastr', '$q', 'numberUtils', 'systemUtils', '$window', 'translationSvc'];

    function leaderBoardCtrl(pixerfApiPhotographerSvc, $scope, pagingUtils, toastr, $q, numberUtils, systemUtils, $window, translationSvc) {

        var self = this;
		var screenWidth = $window.innerWidth;
		var breakpointChangeLayout = 992;

		$scope.instance = self;
		$scope.layoutPhotogarpher = screenWidth < breakpointChangeLayout ? 'grid' : 'list';
        self.getLeaders = getLeaders;
        self.onWindowResize = _.debounce(function(){
            switchLayout();
        },300);
        self.spinner = {isVisible: false};
        self.isLastPage = false;
        self.photographers = null;
        self.fetchMore = fetchMore;
        self.unit = null;
        var defaulSearch = {
            page: 0,
            action: $scope.type,
            order: $scope.order
        };
        self.searchParams = defaulSearch;
		getLeaders(buildParams(numberUtils.parseInt($scope.page)), true);

        function switchLayout(){
            screenWidth = $window.innerWidth;
            $scope.layoutPhotogarpher = screenWidth < breakpointChangeLayout ? 'grid' : 'list';
            systemUtils.digest($scope);
        }
        function buildRank(photographers, page, pageSize){
            if(!pageSize) pageSize = 10;
            for(var i = 0; i < photographers.length; i++){
                photographers[i].leaderboard.rank =  i+1 + (page-1)*pageSize;
            }
        }
        function getLeaders(params, isFresh){
            var def = $q.defer();
            self.spinner.isVisible = true;
            pixerfApiPhotographerSvc.get(params).$promise.then(function(response){
                if(isFresh){
                    self.photographers = [];
                }
                self.unit = params.order;
                if($scope.displayOrderNotRanking){
                    buildRank(response.data, params.page, params.page_size);
                }
                self.photographers = self.photographers.concat(response.data);
                self.isLastPage = pagingUtils.isNoMorePageToLoad(params.page, response);
                self.spinner.isVisible = false;
                self.searchParams.page = numberUtils.parseInt(params.page);
                self.searchParams.order = params.order;
                def.resolve();
            }, function(){
                self.spinner.isVisible = false;
                toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
                def.reject();
            });
            return def.promise;
        }
        function fetchMore(){
            if(self.spinner.isVisible){
                return;
            }
            getLeaders(buildParams(self.searchParams.page + 1)).then(function(){
                if($scope.onPaging){
                    $scope.onPaging({page: self.searchParams.page});
                }
            });
        }
        function buildParams(pageNumber){
            var params = {
                page: pageNumber,
                action: self.searchParams.action,
                order: self.searchParams.order
            }
            if(self.searchParams && self.searchParams.countries){
                params.countries = self.searchParams.countries;
            }
            if(self.searchParams && self.searchParams.specialities){
                params.specialities = self.searchParams.specialities;
            }
            return params;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .directive('leaderBoard', leaderBoard);
    leaderBoard.$inject = ['$timeout'];
    function leaderBoard($timeout) {
        return {
            restrict: 'E',
            replace: true,
            templateUrl: 'app/components/leader-board/leader-board.html',
            controller: 'leaderBoardCtrl',
            controllerAs: "vm",
            scope: {
                type: '@',
                page: '@',
                order: '@',
                instance: '=',
                onPaging: '&?',
                endingMessage: '@',
                highlightTop: '=',
                isHideRanking: '=',
                displayOrderNotRanking: '@',
                searchParams: '=?'
            }
        };
    }
})();
(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('joinCommunityBtnCtrl', joinCommunityBtnCtrl);

    joinCommunityBtnCtrl.$inject = ['$scope','pixerfApiCommunitySvc', 'sessionManagerSvc', 'toastr', '$state', 'communityConst', '$q', 'pixerfConfirmPopupSvc', 'translationSvc'];

    function joinCommunityBtnCtrl( $scope, pixerfApiCommunitySvc, sessionManagerSvc, toastr, $state, communityConst, $q, pixerfConfirmPopupSvc, translationSvc) {

        var self = this;
        self.isWorking = false;
        self.onBtnClicked = onBtnClicked;
        self.btnLabel = "";

        self.onMouseOver = onMouseOver;
        self.onMouseLeave = onMouseLeave;
        self.isHovering = false;
        var defaultOptions = {
            joinedText: "You're a member",
            leaveText: "Leave",
            notJoinedText: "Join Community",
            pendingApprovalText: "Requested",
            cancelRequestText: "Withdraw request",
            invitedText: "Waiting for your response"
        };
        self.STATUS = {
			ACCEPTED: communityConst.MEMBERSHIP.ACCEPTED,
			INVITED: communityConst.MEMBERSHIP.INVITED,
			REQUESTED: communityConst.MEMBERSHIP.REQUESTED,
        }
        self.ACTION = {
            ACCEPT: communityConst.ACTION.ACCEPT,
            REJECT: communityConst.ACTION.REJECT,
            JOIN: communityConst.ACTION.JOIN,
            LEAVE: communityConst.ACTION.LEAVE,
            CANCEL: communityConst.ACTION.CANCEL
        }
        self.options = $.extend(true, defaultOptions, $scope.options)

        self.mLoginnedUser = sessionManagerSvc.getCurrentLoginUser().data;

        if($scope.community) self.isMine = self.mLoginnedUser ? self.mLoginnedUser.id === $scope.community.id : false;

        $scope.$watch('community.membership_status', function(newValue, oldValue){
            if($scope.community){
                setBtnLabel();
            }
        });

        function getAction(membershipStatus){
            if(!membershipStatus) {
                return self.ACTION.JOIN;
            }
            if(membershipStatus === self.STATUS.ACCEPTED){
                return self.ACTION.LEAVE;
            }
            if(membershipStatus === self.STATUS.INVITED){
                return "choose_from_list";
            }
            if(membershipStatus === self.STATUS.REQUESTED){
                return self.ACTION.CANCEL;
            }
        }
        function reponseToInvitation(response){
            var action = response === self.ACTION.ACCEPT ? 'accept_invitations' : 'reject_invitations';
            if(action === 'reject_invitations'){
				onConfirmAction(action);
			} else {
				onActionActived(action);
			}
        }
        function onActionActived(action){
            pixerfApiCommunitySvc[action]({community_ids: [$scope.community.id]}).$promise.then(function(respone){
                self.isWorking = false;
                $scope.community.invited_count--;
                if(action === 'reject_invitations'){
                    toastr.success("You have declined to join this community!");
                    $scope.community.membership_status = null;
                } else {
                    toastr.success("You have accepted to join this community!");
                    $scope.community.membership_status = respone.data[0].status;
                    $scope.community.member_count++;
                    updateMemberStatus($scope.community.members, respone.data[0]);
                }
                if($scope.onChanged) $scope.onChanged({community: $scope.community});
                setBtnLabel();
                self.isHovering = false;
                if(action === 'reject_invitations' && $scope.community.is_private){
                    $state.reload();
                }
            }, function(){
                self.isWorking = false;
                toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
            })
        }
        function updateMemberStatus(listMembers, member){
            for(var i = 0; i < listMembers.length; i++){
                if(listMembers[i].id === member.id) {
                    listMembers[i].status = member.status;
                }
            }
        }
        function onConfirmAction(action){
            var confirmMessage = 'Do you wish to decline the invitation to join the Community <span class="text--bold text--color-black">' + $scope.community.name + '</span>?';
            var modal = pixerfConfirmPopupSvc.showPopup({ hideTitle: true, hideConfirmText: true, message: confirmMessage });
            modal.result.then(function () {
                self.isWorking = true;
                onActionActived(action);
            });
        }
        function requestUpdateStatus(action){
            var def = $q.defer();
            pixerfApiCommunitySvc.withdraw_request({community_ids: [$scope.community.id]}).$promise.then(function(respone){
                self.isWorking = false;
                $scope.community.membership_status = null;
                if(action === self.ACTION.LEAVE) {
                    $scope.community.member_count--;
                }
                if($scope.onChanged) $scope.onChanged({communityId: $scope.community.id, status: $scope.community.membership_status, community: $scope.community});
                setBtnLabel();
                def.resolve();
                if(action === self.ACTION.LEAVE && $scope.community.is_private){
                    $state.reload();
                }
            }, function(){
                self.isWorking = false;
                toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
                def.reject();
            })
            return def.promise;
        }
        function requestToJoin(action){
            var def = $q.defer();
            pixerfApiCommunitySvc[action]({id: $scope.community.id}, {}).$promise.then(function(respone){
                self.isWorking = false;
                $scope.community.membership_status = respone.data.status;
                if($scope.onChanged) $scope.onChanged({status: $scope.community.membership_status, community: $scope.community});
                setBtnLabel();
                def.resolve();
            }, function(){
                self.isWorking = false;
                toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
                def.reject();
            })
            return def.promise;
        }
        function onBtnClicked(action){
            if(self.isWorking) return;
            action = action ? action : getAction($scope.community.membership_status);
            if($scope.community.membership_status){
                if(action === self.ACTION.LEAVE){
                    var confirmMessage = 'Are you sure you want to leave the Community <span class="text--bold text--color-black">' + $scope.community.name + '</span>?';
                    var modal = pixerfConfirmPopupSvc.showPopup({ hideTitle: true, hideConfirmText: true, message: confirmMessage });
                    modal.result.then(function () {
                        self.isWorking = true;
                        requestUpdateStatus(action).then(function(){
                            toastr.success("You will no longer receive notifications from the Community " + $scope.community.name);
                            self.isHovering = false;
                        })
                    })

                    // })
                } else if(action === self.ACTION.CANCEL){
                    requestUpdateStatus(action).then(function(){
                        toastr.success("Your request has been withdrawn!");
                        self.isHovering = false;
                    })
                } else if(action === self.ACTION.ACCEPT || action === self.ACTION.REJECT){
                    reponseToInvitation(action);
                } else if(action === "choose_from_list"){
                    return false;
                }
            } else {
                requestToJoin(action).then(function(){
                    toastr.success("You have requested to join this community");
                    self.isHovering = false;
                })
            }
        }
        function setBtnLabel(){
            if($scope.community.membership_status === self.STATUS.REQUESTED){
                self.btnLabel = self.options.pendingApprovalText;
            } else if($scope.community.membership_status === self.STATUS.INVITED){
                self.btnLabel = self.options.invitedText;
            } else if($scope.community.membership_status === self.STATUS.ACCEPTED){
                self.btnLabel = self.options.joinedText;
            } else {
                self.isHideBtnWithBizAcc = true;
                self.btnLabel = self.options.notJoinedText;
            }
        }
        function setBtnMouseHoverLabel(){
            if(!$scope.community.membership_status){
                self.btnLabel = self.options.notJoinedText;
            } else if($scope.community.membership_status === self.STATUS.ACCEPTED){
                self.btnLabel = self.options.leaveText;
            } else if($scope.community.membership_status === self.STATUS.REQUESTED){
                self.btnLabel = self.options.cancelRequestText;
            }
        }

        function onMouseOver(){
            self.isHovering = true;
            setBtnMouseHoverLabel();
        }
        function onMouseLeave(){
            self.isHovering = false;
            setBtnLabel()
        }
    }
})();

(function () {
  'use strict';

  angular
    .module('pixerf')
    .directive('joinCommunityBtn', joinCommunityBtn);

  function joinCommunityBtn() {

    var directive = {
      scope: {
        community: "=",
        onChanged: "&?",
        options: "="
      },
      restrict: 'E',
      templateUrl: 'app/components/join-community-btn/join-community-btn.html',
      controller: 'joinCommunityBtnCtrl',
      controllerAs: 'vm',
      replace: true
    };
    return directive;
  }

})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.factory('inviteUserPopupSvc', inviteUserPopupSvc);
	inviteUserPopupSvc.$inject = ['$uibModal'];

	function inviteUserPopupSvc($uibModal) {
		function showPopup(data) {
			return $uibModal.open({
				templateUrl: 'app/components/invite-user-popup/invite-user-popup.html',
				controller: 'inviteUserPopupCtrl',
				controllerAs: 'vm',
				animation: true,
				windowClass: 'invite-user-popup-window-class',
				resolve: {
					'resolveData': function () {
						return data;
					}
				}
			});
		}

		return {
			showPopup: showPopup
		};
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('inviteUserPopupCtrl', inviteUserPopupCtrl);

	inviteUserPopupCtrl.$inject = ['$q', 'resolveData', 'communityInviteEmailPopupSvc', '$timeout', 'systemUtils', 'sessionManagerSvc', '$uibModalInstance', 'toastr', 'pixerfApiEventSvc', 'communityMemberFilterSvc', 'googleContactSvc', 'outlookContactSvc', 'translationSvc'];

	function inviteUserPopupCtrl($q, resolveData, communityInviteEmailPopupSvc, $timeout, systemUtils, sessionManagerSvc, $uibModalInstance, toastr, pixerfApiEventSvc, communityMemberFilterSvc, googleContactSvc, outlookContactSvc, translationSvc) {

		var self = this;

		self.popupData = resolveData || {};

		self.options = self.popupData.options;
		self.copyToClipboard = systemUtils.copyStringToClipboard;
		self.closePopup = closePopup;
		self.onCloseBtnClicked = onCloseBtnClicked;
		self.onCancelBtnClicked = onCancelBtnClicked;
		self.onPersonListInit = onPersonListInit;
		self.onSelectedPersonListInit = onSelectedPersonListInit;
		self.onSearchConditionChanged = onSearchConditionChanged;
		self.onContactRemove = onContactRemove;
		self.onGmailClicked = onGmailClicked;
		self.onOutlookClicked = onOutlookClicked;
		self.onSendBtnClicked = onSendBtnClicked;
		self.onSendListEmailsClicked = onSendListEmailsClicked;
		self.sharedTextChanged = sharedTextChanged;
		self.onAddToInviteList = onAddToInviteList;
		self.onPersonSelected = onPersonSelected;
		self.onRemoveFromSelectedPeople = onRemoveFromSelectedPeople;
		self.onRemoveSelectedPeople = onRemoveSelectedPeople;
		self.invitedList = [];
		self.emailList = [];
		self.selectedPeople = [];
		self.successMessage = "Invitations have been successfully sent."
		self.loginUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.isWorking = false;
		self.numSelected = 0;
		self.searchFilterOptions = {
			parentClass: ".invite-user-popup",
			defaultSearchCondition: self.popupData.defaultSearchCondition
		}
		self.selectedPeopleOptions = {
			showLevel: false
		};
		self.listEmailOptions = {
			showEmail: true,
			showLevel: false
		};
		
		self.link = window.location.origin +( window.location.pathname || '') + '#/ce/' + self.popupData.event.short_code;
		self.defaultShareText =self.popupData.shareText || "Hi there! I would like to invite you to join the event on PIXERF. " + self.link;

		var mPersonListInstancePromise = $q.defer();

		$timeout(function () {
			bindShareText();
		});

		function sharedTextChanged() {
			changeContentShare('whatsapp', self.defaultShareText);
		}

		function bindShareText() {
			var whatsappLink = "whatsapp://send?text=" + encodeURIComponent(self.defaultShareText);
			appendShareLink("whatsappComShare", whatsappLink);
		}

		function appendShareLink(elementIdSelector, shareLink) {
			var h = document.getElementById(elementIdSelector);
			var s = document.createElement("a");
			var link = shareLink;
			s.setAttribute('href', link);
			h.appendChild(s);
		}

		function changeContentShare(selector, content) {
			if (selector === 'whatsapp') {
				var whatsappLink = "whatsapp://send?text=" + encodeURIComponent(content);
				$("#whatsappComShare a")[0].setAttribute('href', whatsappLink);
			}
		}

		function onPersonListInit(instance) {
			self.personListInstance = instance;
			mPersonListInstancePromise.resolve(instance);
		}

		function onSelectedPersonListInit(instance) {
			self.selectedPersonListInstance = instance;
			$q.defer().resolve(instance);
		}

		function onCloseBtnClicked() {
			dismiss();
		}

		function onCancelBtnClicked() {
			if (self.isWorking) return;
			dismiss();
		}

		function onSendBtnClicked(skipSelection, dataList) {
			if ((!skipSelection && self.numSelected === 0) || self.isWorking) return;
			var recipients = [];
			recipients = communityInviteEmailPopupSvc.getSelectedContacts(self.selectedPeople, "email");
			console.log(recipients);
			self.isWorking = true;
			pixerfApiEventSvc.invite({
				id: self.popupData.event.id
			}, {
				"recipients": recipients
			}).$promise.then(function () {
				self.isWorking = false;
				$timeout(function () {
					closePopup(communityInviteEmailPopupSvc.getSelectedPeople(self.personListInstance.peoples));
				}, 2000);
				onInvitationSent();
			}, function (err) {
				toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
				self.isWorking = false;

				$timeout(function () {
					closePopup(communityInviteEmailPopupSvc.getSelectedPeople(self.personListInstance.peoples));
				}, 2000);
			})
		}

		function onSearchConditionChanged(searchCondition) {
			self.numSelected = 0;
			if (searchCondition.isDirectoryChecked) {
				self.layout = 'directory';
			} else if (searchCondition.isEmailChecked) {
				self.layout = 'email';
				return;
			} else if (searchCondition.isLinkChecked) {
				self.layout = 'link';
				return;
			}
			var searchParms = communityMemberFilterSvc.buildSearchParams(searchCondition, self.loginUser);
			if (self.personListInstance) {
				self.personListInstance.getPeopleList(searchParms, true, updateSelectedPeople);
			} else {
				mPersonListInstancePromise.promise.then(function () {
					self.personListInstance.getPeopleList(searchParms, true, updateSelectedPeople);
				})
			}
		}

		function onInvitationSent(data) {
			$timeout(function () {
				if (self.popupData.route) {
					$state.go(self.popupData.route);
				}
				closePopup(data);
			}, 2000);
		}

		function dismiss() {
			$uibModalInstance.dismiss();
		}

		function closePopup(data) {
			$uibModalInstance.close(data);
		}

		function getUserWithEmail(contactList){
			var result = [];
			for(var i = 0; i < contactList.length; i++){
				if(contactList[i].email){
					result.push(contactList[i]);
				}
			}
			return result;
		}

		function onGmailClicked() {
			var contactList = [];
			googleContactSvc.auth(function () {
				googleContactSvc.getContacts().then(function (res) {
					contactList = getUserWithEmail(res.data)
					var existEmails = _.intersection(self.invitedList, contactList);
					if (existEmails && existEmails.length) {
						var newEmails = _.difference(contactList, existEmails);
						self.invitedList = self.invitedList.concat(newEmails);
						var errMsg = "Failed to send invitations. Some of your friends are already invited: ";
						for (var i = 0; i < existEmails.length; i++) {
							errMsg += existEmails[i];
							if (i !== existEmails.length) {
								errMsg += ", "
							}
						}
						toastr.error(errMsg);
					} else {
						self.invitedList = self.invitedList.concat(contactList);
					}
				});
			});
		}

		function onOutlookClicked() {
			var contactList = [];
			outlookContactSvc.auth(function () {
				outlookContactSvc.getContacts().then(function (res) {
					contactList = getUserWithEmail(res.data)
					var existEmails = _.intersection(self.invitedList, contactList);
					if (existEmails && existEmails.length) {
						var newEmails = _.difference(res.data, existEmails);
						self.invitedList = self.invitedList.concat(newEmails);
						var errMsg = "Failed to send invitations. Some of your friends are already invited: ";
						for (var i = 0; i < existEmails.length; i++) {
							errMsg += existEmails[i];
							if (i !== existEmails.length) {
								errMsg += ", "
							}
						}
						toastr.error(errMsg);
					} else {
						self.invitedList = self.invitedList.concat(contactList);
					}
				})
			});
		}

		function onContactRemove(contact) {
			self.invitedList = _.reject(self.invitedList, function (mem) {
				return contact === mem;
			});
		}

		function onAddToInviteList(email) {
			if (!isExistEmail(email)) {
				var contact = {email: email, displayName: email}
				self.invitedList.push(contact);
				self.newEmail = "";
			} else {
				toastr.error("Failed to send invitation. Your friend is already invited.")
			}
		}

		function isExistEmail(email) {
			return _.contains(self.invitedList, email);
		}

		function onSendListEmailsClicked() {
			var data = _.map(self.invitedList, function (email) {
				return email;
			})
			onSendBtnClicked(true, data);
			onInvitationSent(data);
		}

		function onPersonSelected(people) {
			if (people.isSelected) {
				self.selectedPeople.push(people);
				self.numSelected++;
			} else {
				onRemoveFromSelectedPeople(people);
				self.numSelected--;
			}
		}

		function updateSelectedPeople(){
			if(self.layout != 'directory' || !self.selectedPeople || !self.personListInstance || !self.personListInstance.peoples || self.selectedPeople.loginUser ==0){
				return;
			}
			for(var i =0; i < self.selectedPeople.length; i++){
				var existEmails = _.filter(self.personListInstance.peoples, function(pp) { 
					return pp.email == self.selectedPeople[i].email ;
				}) ;
				if(existEmails.length > 0){
					existEmails = _.map(existEmails, function (ppl) {
						ppl.isSelected = true;
						return ppl;
					})
				}
			}
		}

		function onRemoveFromSelectedPeople(people) {
			self.selectedPeople = _.reject(self.selectedPeople, function (ppl) {
				return people.email === ppl.email;
			})

			self.personListInstance.peoples = _.map(self.personListInstance.peoples, function (ppl) {
				if (ppl.id === people.id) {
					ppl.isSelected = false;
				}
				return ppl;
			})
			self.invitedList = _.map(self.invitedList, function (ppl) {
				if (ppl.email === people.email) {
					ppl.isSelected = false;
				}
				return ppl;
			})
		}

		function onRemoveSelectedPeople() {
			self.selectedPeople = [];

			self.personListInstance.peoples = _.map(self.personListInstance.peoples, function (ppl) {
				ppl.isSelected = false;
				return ppl;
			})
			self.invitedList = _.map(self.invitedList, function (ppl) {
				ppl.isSelected = false;
				return ppl;
			})
		}
	}
})();

/**
 * Controller for inviteUserByLinkCtrl
 */
(function () {

  angular
    .module('pixerf')
    .controller('inviteUserToCommunityByLinkCtrl', inviteUserToCommunityByLinkCtrl);

    inviteUserToCommunityByLinkCtrl.$inject = ['$scope', '$state', 'sessionManagerSvc', 'toastr', 'translationSvc', 'signInSvc', '$uibModalStack', 'pixerfApiEventSvc', 'stringUtils', 'pixerfApiCommunitySvc',
    '$translate', 'communityConst', 'messageConst', 'store', 'confirmInviteByLinkPopupCtrlSvc'];

  function inviteUserToCommunityByLinkCtrl($scope, $state, sessionManagerSvc, toastr, translationSvc, signInSvc, $uibModalStack, pixerfApiEventSvc, stringUtils, pixerfApiCommunitySvc,
    $translate, communityConst, messageConst, store, confirmInviteByLinkPopupCtrlSvc) {
    var self = this;
    self.state = $state;
    self.spinner = { isVisible: true };
    self.shortCode = null;
    self.event = null;
    self.community = null;

    function init() {
      $uibModalStack.dismissAll();
      self.shortCode = $state.params.short_code;
      if (!self.shortCode) {
        toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
      }
      self.loginnedUser = sessionManagerSvc.getCurrentLoginUser().data;
      if(!self.loginnedUser){
       return processLoginFirst();
      }
      getCommunityDetail();
      store.remove('csc');
    }

    function hideAllPopup(callback, param) {
      setTimeout(function () {
        $uibModalStack.dismissAll();
        if (callback) {
          callback(param);
        }
      });
    }

    function getCommunityDetail() {
      self.spinner.isVisible = true;
      hideAllPopup();
      pixerfApiCommunitySvc.get({
        id: self.shortCode,
        type: 'short_code'
      }).$promise.then(function (response) {
        self.community = response.data;
        if (self.loginnedUser && !self.loginnedUser.isBiz && !self.community.isMine && (!self.community.membership_status || (!self.community.membership_status === communityConst.MEMBERSHIP.ACCEPTED && !self.community.membership_status === communityConst.MEMBERSHIP.REQUESTED))) {
          joinCommunity(self.community);
        }else{
          $state.go('community-detail-page.community-detail-events', { id: self.community.id, name: self.community.name });
        }
      }, function (err) {
        toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
      })
    }

    var processLoginFirst = function () {
      var shortCode = self.shortCode;
      var callbackURL = '/c/' + shortCode;
      store.set('csc', shortCode);
      toastr.info("Hi, You need to login to continue!");
      self.spinner.isVisible = false;
      sessionManagerSvc.setCallbackURL(callbackURL);
      signInSvc.showSignInModal();
      // $state.go('sign-up.sign-up-personal-info');
    };

    var joinCommunity = function (community, callback) {
      pixerfApiCommunitySvc.join({
        id: community.id
      }, null).$promise.then(function (respone) {
        toastr.success($translate.instant('requested-join-community'));
        if(callback){
          return callback();
        }
        $state.go('community-detail-page.community-detail-events', { id: community.id, name: community.name });
      }, function (err) {
        if(err && err.data && err.data.memberships && err.data.memberships[0] == "has already been taken"){
          if (callback) {
              return callback();
          }
          $state.go('community-detail-page.community-detail-events', { id: community.id, name: community.name });
          return ;
      }
        toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
        $state.go('community-detail-page.community-detail-events', { id: community.id, name: community.name });
      })
    }

    init();
  }
})();

/**
 * Controller for inviteUserByLinkCtrl
 */
(function () {

  angular
    .module('pixerf')
    .controller('inviteUserByLinkCtrl', inviteUserByLinkCtrl);

  inviteUserByLinkCtrl.$inject = ['$scope', '$state', 'sessionManagerSvc', 'toastr', 'translationSvc', 'signInSvc', '$uibModalStack', 'pixerfApiEventSvc', 'stringUtils', 'pixerfApiCommunitySvc',
    '$translate', 'communityConst', 'messageConst', 'store', 'confirmInviteByLinkPopupCtrlSvc', 'ISO3166', 'confirmPopupSvc'];

  function inviteUserByLinkCtrl($scope, $state, sessionManagerSvc, toastr, translationSvc, signInSvc, $uibModalStack, pixerfApiEventSvc, stringUtils, pixerfApiCommunitySvc,
    $translate, communityConst, messageConst, store, confirmInviteByLinkPopupCtrlSvc, ISO3166, confirmPopupSvc) {
    var self = this;
    self.state = $state;
    self.spinner = { isVisible: true };
    self.shortCode = null;
    self.event = null;
    self.community = null;

    function init() {
      $uibModalStack.dismissAll();
      self.shortCode = $state.params.short_code;
      if (!self.shortCode) {
        toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
      }
      self.loginnedUser = sessionManagerSvc.getCurrentLoginUser().data;
      if(!self.loginnedUser){
       return processLoginFirst();
      }
      getEventDetail();
      store.remove('cesc');
    }

    function hideAllPopup(callback, param) {
      setTimeout(function () {
        $uibModalStack.dismissAll();
        if (callback) {
          callback(param);
        }
      });
    }

    function getEventDetail() {
      self.spinner.isVisible = true;
      hideAllPopup();
      pixerfApiEventSvc.get({
        id: self.shortCode,
        type: 'short_code'
      }).$promise.then(function (response) {
        self.event = response.data;
        getCommunityDetail();
      }, function (err) {
        if (err.data && err.data.key && (err.data.key == 'community_permission_deny')) {
          // return processPrivateEvent();
          toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
        }
        self.event = err.data;
        if (!self.event.id || !self.event.community_id) {
          toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
          return;
        } else {
          getCommunityDetail();
        }
      })
    }

    function getCommunityDetail() {
      pixerfApiCommunitySvc.get({
        id: self.event.community_id
      }).$promise.then(function (response) {
        self.community = response.data;
        processAction();
      }, function (err) {
        console.log(err);
        $state.go('404');
      })

    }

    // function processAction() {
    //   if (self.community.is_private) { //private community
    //     processPrivateEvent();

    //   } else { //public community
    //     processPublicEvent();
    //   }
    // }

    function processAction() {
      self.spinner.isVisible = false;
      if (self.event.is_community_member) { // joined community
        joinEvent();

      } else { //not join community
        if (self.community.is_private) {//private community
          //show popup, yes > reques to join community then join event -> show request to join popup
          var popupData = {
            event: self.event,
            community: self.community,
            is_private: true,
            isFinish: false
          }
          $uibModalStack.dismissAll();
          var confirmPopup = confirmInviteByLinkPopupCtrlSvc.showPopup(popupData);
          confirmPopup.closed.then(function () {
            if(popupData.isFinish){
              $state.go('setting.manage-communities.manage-requested-communities');
            }else{
              $state.go('community-detail-page.community-detail-discussions', { id: self.community.id, name: self.community.name });
            }

          });
        } else {//public community
          //show popup, yes -> join community then join event
          var popupData = {
            event: self.event,
            community: self.community,
            is_private: false,
            isFinish : false
          }
          $uibModalStack.dismissAll();
          var confirmPopup = confirmInviteByLinkPopupCtrlSvc.showPopup(popupData);
          confirmPopup.closed.then(function () {
            if(popupData.isFinish){
              if(popupData.community.membership_status != 'accepted'){
                $state.go('setting.manage-communities.manage-requested-communities');
              }
            }else{
              $state.go('community-detail-page.community-detail-discussions', { id: self.community.id, name: self.community.name });
            }
          });
        }
      }
    }

    var processLoginFirst = function () {
      var shortCode = self.shortCode;
      store.set('cesc', shortCode);
      var callbackURL = '/ce/' + shortCode;
      toastr.info("Hi, You need to login to continue!");
      self.spinner.isVisible = false;
      sessionManagerSvc.setCallbackURL(callbackURL);
      signInSvc.showSignInModal();
      // $state.go('sign-up.sign-up-personal-info');
    };

    var joinCommunity = function (community, callback) {
      pixerfApiCommunitySvc.join({
        id: community.id
      }, null).$promise.then(function (respone) {
        toastr.success($translate.instant('requested-join-community'));
        if(callback){
          return callback();
        }
        $state.go('community-detail-page.community-detail-events', { id: community.id, name: community.name });
      }, function () {
        toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
        $state.go('community-detail-page.community-detail-events', { id: community.id, name: community.name });
      })
    }

    function processPublicEvent() {
      if(self.event.is_community_member){
        joinEvent();
      }else{
        joinCommunity(self.community, joinEvent);
      }
    }

    function processPrivateEvent() {
      if (!self.loginnedUser) {
        return processLoginFirst()();
      }
      else if (self.event.is_community_member) {
        joinEvent();
      } else {
        if (self.loginnedUser && !self.loginnedUser.isBiz && !self.community.isMine && (!self.community.membership_status || (!self.community.membership_status === communityConst.MEMBERSHIP.ACCEPTED && !self.community.membership_status === communityConst.MEMBERSHIP.REQUESTED))) {
          joinCommunity(self.community);
        }
        else {
          $state.go('community-detail-page.community-detail-events', { id: self.community.id, name: self.community.name });
        }
      }
    }

    function joinEvent() {
      if ((self.event.capacity_type === 'limited' && self.event.stats && self.event.stats.available && self.event.stats.available >0) || self.event.has_joined) {
        $state.go('event-detail-page.event-feed', { id: self.event.id, name: stringUtils.toSnakeCase(self.event.name) });
        return;//joined
      } else {
        pixerfApiEventSvc.toggleJoin({
          id: self.event.id
        }, {}).$promise.then(function (res) {
          self.event = res.data;
          $state.go('event-detail-page.event-feed', { id: self.event.id, name: stringUtils.toSnakeCase(self.event.name) });
        }).catch(function (err) {
          $state.go('community-detail-page.community-detail-events', { id: self.community.id, name: self.community.name });
          console.log(err);
        })
      }
    }

    init();
  }
})();


(function () {
	'use strict';

	angular
		.module('pixerf')
		.config(routerConfig);

	routerConfig.$inject = ['$stateProvider'];

	function routerConfig($stateProvider) {
		'ngInject';
		$stateProvider
			// .state('invite-users', {
			// 	url: '',
			// 	abstract: true,
			// 	templateUrl: 'app/components/invite-user-by-link/invite-user-by-link.html',
            //     controller: 'inviteUserCtrl',
			// 	controllerAs: 'vm',
			// 	data: {
			// 		pageTitle: "PIXERF - Invite Users",
			// 		hideFooter: true
			// 	}
			// })
			// .state('invite-users.event', {
			// 	url: '',
			// 	controllerAs: 'vm',
			// 	data: {
			// 		pageTitle: "PIXERF - Invite Users Event",
			// 		permissions: {
            //             only: ['EVERY_ONE']
            //         }
			// 	}
            // })
            .state('invite-users-join-event', {
				url: '/ce/:short_code',
				templateUrl: 'app/components/invite-user-by-link/invite-user-by-link.html',
                controller: 'inviteUserByLinkCtrl',
				controllerAs: 'vm',
				data: {
					pageTitle: "PIXERF - Invite Users Join Event",
					permissions: {
                        only: ['EVERY_ONE']
                    }
				}
			})
			.state('invite-users-join-community', {
				url: '/c/:short_code',
				templateUrl: 'app/components/invite-user-by-link/invite-user-to-community-by-link.html',
                controller: 'inviteUserToCommunityByLinkCtrl',
				controllerAs: 'vm',
				data: {
					pageTitle: "PIXERF - Invite Users Join Community",
					permissions: {
                        only: ['EVERY_ONE']
                    }
				}
            })
            ;
	}
})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.factory('inviteToCommunitysPopupSvc', inviteToCommunitysPopupSvc);
		inviteToCommunitysPopupSvc.$inject = ['$uibModal'];

	function inviteToCommunitysPopupSvc($uibModal) {
		function showPopup(data) {
			return $uibModal.open({
				templateUrl: 'app/components/invite-to-community-popup/invite-to-community-popup.html',
				controller: 'inviteToCommunitysPopupCtrl',
				controllerAs: 'vm',
				animation: true,
				windowClass: 'invite-to-community-popup-window-class',
				resolve: {
					'resolveData': function () {
						return data;
					}
				}
			});
		}

		return {
			showPopup: showPopup
		};
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('inviteToCommunitysPopupCtrl', inviteToCommunitysPopupCtrl);

		inviteToCommunitysPopupCtrl.$inject = ['$q', 'resolveData', '$timeout', '$uibModalInstance', 'commonConst', 'toastr', '$translate', 'pixerfApiCommunitySvc', 
			'pagingUtils', 'translationSvc', 'sessionManagerSvc', 'createCommunityPopupSvc'];

	function inviteToCommunitysPopupCtrl($q, resolveData, $timeout, $uibModalInstance, commonConst, toastr, $translate, pixerfApiCommunitySvc, pagingUtils, 
			translationSvc, sessionManagerSvc, createCommunityPopupSvc) {

		var self = this;
		self.user = resolveData.user;
		self.communities = resolveData.communities;
		self.onCloseBtnClicked = onCloseBtnClicked;
		self.getCommunityLogo = getCommunityLogo;
		self.isInvitedCommunivty = isInvitedCommunivty;
		self.onInviteBtnclicked = onInviteBtnclicked;
		self.commonConst = commonConst;
		self.searchParams = {};
		self.invitedCommunity = [];
		self.spinner = {
			isVisible: false
		};
		self.currentLoginUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.onCreateCommunityClicked = onCreateCommunityClicked;

		function getCommunityLogo(community){
			return community.cover && community.cover.thumbnail ? community.cover.thumbnail : '/assets/images/default/community-default-avatar.png';
		}

		function onCloseBtnClicked() {
			dismiss();
		}

		function dismiss() {
			$uibModalInstance.dismiss();
		}

		function isInvitedCommunivty(community){
			if(self.spinner.isVisible)return;

			var items = _.find(self.invitedCommunity, function(item) {
				return item.id == community.id; 
			});
			var result = items && items.id ? true : false;
			return result;
		}

		function onInviteBtnclicked(community){
			self.spinner.isVisible = true;
			inviteMembers(community).then(
				function success(res){
					self.invitedCommunity.push(community);
					self.spinner.isVisible = false;
				},
				function error(err){
					self.spinner.isVisible = false;
					toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
				}
			)
		}

		function inviteMembers(community) {
			var recipients = [self.user.email];
			return pixerfApiCommunitySvc.invite({
				id: community.id
			}, {
				"recipients": recipients, 
				"sender_id": self.user.id
			}).$promise;
		}
		function getCommunitiesList(params, isFresh){
            if(isFresh) {
				self.searchParams = params;
			}
            pixerfApiCommunitySvc.list(self.searchParams).$promise.then(function(response){
                if(!self.invitedCommunity || isFresh) self.invitedCommunity = [];

                self.invitedCommunity = self.invitedCommunity.concat(response.data);
                self.isLastPage = pagingUtils.isNoMorePageToLoad(params.page, response);
				self.searchParams.page = params.page;
				getInvitedCommunities();
            }, function(){
                toastr.error($translate.instant("failed-to-get-communities-list"));
                self.spinner.isVisible = false;
            });
        }
        function getInvitedCommunities(){
			if(self.isLastPage){
				return self.spinner.isVisible = false;
			}
            self.spinner.isVisible = true
            var searchParms = $.extend(true, {}, self.searchParams);
			searchParms.page++;
            getCommunitiesList(searchParms);
		}
		
		function init(){
			self.searchParams = {
                page: 1,
                membership: 'invited',
                user_id: self.user.id
			};
			getInvitedCommunities();
		}
		function onCreateCommunityClicked() {
			dismiss();
			createCommunityPopupSvc.showPopup();
		}

		init();

	}
})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.factory('inviteCommunityMembersPopupSvc', inviteCommunityMembersPopupSvc);
	inviteCommunityMembersPopupSvc.$inject = ['$uibModal'];

	function inviteCommunityMembersPopupSvc($uibModal) {
		function showPopup(data) {
			return $uibModal.open({
				templateUrl: 'app/components/invite-community-members-popup/invite-community-members-popup.html',
				controller: 'inviteCommunityMembersPopupCtrl',
				controllerAs: 'vm',
				animation: true,
				windowClass: 'invite-community-members-popup-window-class',
				resolve: {
					'resolveData': function () {
						return data;
					}
				}
			});
		}

		return {
			showPopup: showPopup
		};
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('inviteCommunityMembersPopupCtrl', inviteCommunityMembersPopupCtrl);

	inviteCommunityMembersPopupCtrl.$inject = ['$q', 'resolveData', 'communityInviteEmailPopupSvc', '$timeout', 'systemUtils', 'sessionManagerSvc', '$uibModalInstance', 'toastr', 'pixerfApiCommunitySvc', 'communityMemberFilterSvc', 'googleContactSvc', 'outlookContactSvc', 'translationSvc'];

	function inviteCommunityMembersPopupCtrl($q, resolveData, communityInviteEmailPopupSvc, $timeout, systemUtils, sessionManagerSvc, $uibModalInstance, toastr, pixerfApiCommunitySvc, communityMemberFilterSvc, googleContactSvc, outlookContactSvc, translationSvc) {

		var self = this;
		var pixerfEnv = new PixerfEnv().getEnv();

		self.popupData = resolveData || {};
		self.shareLink = pixerfEnv === "PRODUCTION" ? 'https://pixerf.com/#/c/' + self.popupData.community.short_code : 'https://qa.pixerf.com/#/c/' + self.popupData.community.short_code;
		self.copyToClipboard = systemUtils.copyStringToClipboard;
		self.closePopup = closePopup;
		self.onCloseBtnClicked = onCloseBtnClicked;
		self.onCancelBtnClicked = onCancelBtnClicked;
		self.onPersonSelected = onPersonSelected;
		self.onPersonListInit = onPersonListInit;
		self.onSearchConditionChanged = onSearchConditionChanged;
		self.onContactRemove = onContactRemove;
		self.onGmailClicked = onGmailClicked;
		self.onOutlookClicked = onOutlookClicked;
		self.onSendBtnClicked = onSendBtnClicked;
		self.onSendListEmailsClicked = onSendListEmailsClicked;
		self.sharedTextChanged = sharedTextChanged;
		self.onAddToInviteList = onAddToInviteList;
		self.invitedList = [];
		self.successMessage = "Invitations have been successfully sent."
		self.loginUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.isWorking = false;
		self.numSelected = 0;
		self.searchFilterOptions = {
			parentClass: ".invite-community-members-popup",
			defaultSearchCondition: self.popupData.defaultSearchCondition
		}
		self.defaultShareText = "Hi there! I would like to invite you to join my Community, \"" + self.popupData.community.name + "\" on PIXERF. " + self.shareLink;

		var mPersonListInstancePromise = $q.defer();

		$timeout(function () {
			bindShareText();
		});

		function sharedTextChanged() {
			changeContentShare('whatsapp', self.defaultShareText);
			// changeContentShare('messenger', self.defaultShareText);
		}

		function bindShareText() {
			var whatsappLink = "whatsapp://send?text=" + encodeURIComponent(self.defaultShareText);
			appendShareLink("whatsappComShare", whatsappLink);
			// var messengerLink = "fb-messenger://share?link=Hi%20there%21%20I%20would%20like%20to%20invite%20you%20to%20join%20my%20Community%2C%20%22" + self.popupData.community.name + "%22%20on%20PIXERF.%0A%0A" + self.shareLink + "&app_id=1966386400291087";
			// appendShareLink("messengerComShare", messengerLink);
		}

		function appendShareLink(elementIdSelector, shareLink) {
			var h = document.getElementById(elementIdSelector);
			var s = document.createElement("a");
			var link = shareLink;
			s.setAttribute('href', link);
			h.appendChild(s);
		}

		function changeContentShare(selector, content) {
			if (selector === 'whatsapp') {
				var whatsappLink = "whatsapp://send?text=" + encodeURIComponent(content);
				$("#whatsappComShare a")[0].setAttribute('href', whatsappLink);
			}
			// else if (selector === 'messenger') {
			// 	var messengerLink = "fb-messenger://share?link=" + encodeURIComponent(content) + "&app_id=1966386400291087";
			// 	$("#messengerComShare a")[0].setAttribute('href', messengerLink);
			// }
		}

		init();

		function init(user, steps) {
			setSubmitBtnLabel(0);
		}

		function onPersonSelected() {
			var numSelected = communityInviteEmailPopupSvc.getNumSelectedContacts(self.personListInstance.peoples);
			self.numSelected = numSelected;
			setSubmitBtnLabel(numSelected);
		}

		function setSubmitBtnLabel(numSelected) {
			self.submitBtnLabel = communityInviteEmailPopupSvc.updateSendBtnLabel(numSelected)
		}

		function onPersonListInit(instance) {
			self.personListInstance = instance;
			mPersonListInstancePromise.resolve(instance);
		}

		function onCloseBtnClicked() {
			dismiss();
		}

		function onCancelBtnClicked() {
			if (self.isWorking) return;
			dismiss();
		}

		function onSendBtnClicked(skipSelection, dataList) {
			if ((!skipSelection && self.numSelected === 0) || self.isWorking) return;
			var recipients = [];
			if (dataList) {
				recipients = dataList;
			} else {
				recipients = communityInviteEmailPopupSvc.getSelectedContacts(self.personListInstance.peoples, "email");
			}
			self.isWorking = true;
			pixerfApiCommunitySvc.invite({
				id: self.popupData.community.id
			}, {
				"recipients": recipients,
				"sender_id": self.loginUser.id
			}).$promise.then(function () {
				self.isWorking = false;
				$timeout(function () {
					closePopup(communityInviteEmailPopupSvc.getSelectedPeople(self.personListInstance.peoples));
				}, 2000);
				onInvitationSent();
			}, function (err) {
				toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
				self.isWorking = false;

				$timeout(function () {
					closePopup(communityInviteEmailPopupSvc.getSelectedPeople(self.personListInstance.peoples));
				}, 2000);
			})
		}

		function onSearchConditionChanged(searchCondition) {
			self.numSelected = 0;
			setSubmitBtnLabel(0);
			if (searchCondition.isDirectoryChecked) {
				self.layout = 'listPeople';
			} else if (searchCondition.isEmailChecked) {
				self.layout = 'listEmail';
				return;
			} else if (searchCondition.isLinkChecked) {
				self.layout = 'shareLink';
				return;
			}
			var searchParms = communityMemberFilterSvc.buildSearchParams(searchCondition, self.loginUser);
			if (self.personListInstance) {
				self.personListInstance.getPeopleList(searchParms, true);
			} else {
				mPersonListInstancePromise.promise.then(function () {
					self.personListInstance.getPeopleList(searchParms, true);
				})
			}
		}

		function onInvitationSent(data) {
			// onSendBtnClicked(true, data);
			$timeout(function () {
				if (self.popupData.route) {
					$state.go(self.popupData.route);
				}
				closePopup(data);
			}, 2000);
		}

		function dismiss() {
			$uibModalInstance.dismiss();
		}

		function closePopup(data) {
			$uibModalInstance.close(data);
		}

		function onGmailClicked() {
			googleContactSvc.auth(function () {
				var googleAuth = communityInviteEmailPopupSvc.showPopup({
					getter: googleContactSvc.getContacts,
					getSelectedPersons: true
				});

				googleAuth.result.then(function (data) {
					var existEmails = _.intersection(self.invitedList, data.invited);
					if (existEmails && existEmails.length) {
						var newEmails = _.difference(data.invited, existEmails);
						self.invitedList = self.invitedList.concat(newEmails);
						var errMsg = "Failed to send invitations. Some of your friends are already invited: ";
						for (var i = 0; i < existEmails.length; i++) {
							errMsg += existEmails[i];
							if (i !== existEmails.length) {
								errMsg += ", "
							}
						}
						toastr.error(errMsg);
					} else {
						self.invitedList = self.invitedList.concat(data.invited);
					}
				});
			});
		}

		function onOutlookClicked() {
			outlookContactSvc.auth(function () {
				var outlookAuth = communityInviteEmailPopupSvc.showPopup({
					getter: outlookContactSvc.getContacts,
					getSelectedPersons: true
				})

				outlookAuth.result.then(function (data) {
					var existEmails = _.intersection(self.invitedList, data.invited);
					if (existEmails && existEmails.length) {
						var newEmails = _.difference(data.invited, existEmails);
						self.invitedList = self.invitedList.concat(newEmails);
						var errMsg = "Failed to send invitations. Some of your friends are already invited: ";
						for (var i = 0; i < existEmails.length; i++) {
							errMsg += existEmails[i];
							if (i !== existEmails.length) {
								errMsg += ", "
							}
						}
						toastr.error(errMsg);
					} else {
						self.invitedList = self.invitedList.concat(data.invited);
					}
				});
			});
		}

		function onContactRemove(contact) {
			self.invitedList = _.reject(self.invitedList, function (mem) {
				return contact === mem;
			});
		}

		function onAddToInviteList(email) {
			if (!isExistEmail(email)) {
				self.invitedList.push(email);
				self.newEmail = "";
			} else {
				toastr.error("Failed to send invitation. Your friend is already invited.")
			}
		}

		function isExistEmail(email) {
			return _.contains(self.invitedList, email);
		}

		function onSendListEmailsClicked() {
			var data = _.map(self.invitedList, function (email) {
				return email;
			})
			onSendBtnClicked(true, data);
			onInvitationSent(data);
		}
	}
})();

(function () {
	angular
		.module("pixerf")
		.controller("invitationToJoinCommunityCtrl", invitationToJoinCommunityCtrl);
	invitationToJoinCommunityCtrl.$inject = ['pixerfApiCommunitySvc', 'toastr', 'sessionManagerSvc', 'pixerfConfirmPopupSvc', '$scope', 'translationSvc', 'commonConst', '$translate'];

	function invitationToJoinCommunityCtrl(pixerfApiCommunitySvc, toastr, sessionManagerSvc, pixerfConfirmPopupSvc, $scope, translationSvc, commonConst, $translate) {

		var self = this;
		self.commonConst = commonConst;
		self.onDenyBtnClicked = onDenyBtnClicked;
		self.onAcceptBtnClicked = onAcceptBtnClicked;
		self.loginUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.isWorking = false;
		self.publicText = 'This community is visible and open to all, including all content and members.';
		self.privateText = 'Only members of this community can see its full content, including details about its members';
		self.unlistedText = $translate.instant("unlisted-community-text-descriptions");

		function onAction(action) {
			pixerfApiCommunitySvc.accept_invitations({
				community_ids: [self.community.id]
			}).$promise.then(function () {
				toastr.success("You have " + action + "ed to join the community " + self.community.name);
				$scope.vm.onCommunityStatusChanged({
					communityChanged: self.community.id
				});
			}, function () {
				toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
			})
		}

		function onDenyBtnClicked() {
			if (self.isWorking) return;
			var confirmMessage = 'Do you wish to decline the invitation to join the Community <span class="text--bold text--color-black">' + self.community.name + '</span>?';
			var modal = pixerfConfirmPopupSvc.showPopup({
				hideTitle: true,
				hideConfirmText: true,
				message: confirmMessage
			});
			modal.result.then(function () {
				self.isWorking = true;
				pixerfApiCommunitySvc.reject_invitations({
					community_ids: [self.community.id]
				}).$promise.then(function () {
					toastr.success("You have declined to join the Community " + self.community.name);
					self.isWorking = false;
					$scope.vm.onCommunityStatusChanged({
						communityChanged: self.community.id
					});
				}, function () {
					toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
					self.isWorking = false;
				})
			})
		}

		function onAcceptBtnClicked() {
			onAction("accept");
		}
	}
})();

(function(){
    'use strict';
    angular
      .module("pixerf")
      .component("invitationToJoinCommunity", {
          bindings: {
              "community" : "=",
              "onCommunityStatusChanged": "&?",
              "onSelectedChanged": "&?"
          },
          controller: "invitationToJoinCommunityCtrl",
          controllerAs: "vm",
          templateUrl: "app/components/invitation-to-join-community/invitation-to-join-community.html"
      })
})();
(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('inputWithNumberControlCtrl', inputWithNumberControlCtrl);

    inputWithNumberControlCtrl.$inject = ['$scope'];

    function inputWithNumberControlCtrl($scope) {

        var self = this;
        self.onControlClicked = onControlClicked

        self.settings = $.extend(true, {step: 1, isDisabled: false, min: 0, placeholder: 0, propName: "quantity"}, self.options);
        $scope.$watch("vm.options", function(newValue, oldValue){
            self.settings = $.extend(true, {step: 1, isDisabled: false, min: 0, placeholder: 0, propName: "quantity"}, self.options);
        })
        self.controlsEnable = {
            minus: true,
            plus: true
        }
        updateControlBtnStatus(self.model[self.settings.propName]);
        function updateControlBtnStatus(newValue){
            self.controlsEnable.minus = !(newValue <= self.settings.min  && typeof self.settings.min !== 'undefined');
            self.controlsEnable.plus = !(newValue >= self.settings.max && typeof self.settings.max !== 'undefined');
        }
        function onControlClicked(type){
            var value = self.model[self.settings.propName];
            var newValue = type==="minus" ?  value-self.settings.step : value+self.settings.step;
            if(newValue > self.settings.max || newValue < self.settings.min) return;
            
            updateControlBtnStatus(newValue);

            self.model[self.settings.propName] = newValue;
            self.onChanged();
        }
        
    }
})();
(function () {
  'use strict';

  angular
    .module('pixerf')
    .component('inputWithNumberControl',  {
      bindings: {
        "model" : "=",
        "options": "=",
        "onChanged": "&"
      },
      templateUrl: 'app/components/input-with-number-control/input-with-number-control.html',
      controller: 'inputWithNumberControlCtrl',
      controllerAs: 'vm'
    });

})();

(function () {
  'use strict';
  angular
    .module('pixerf')
    .factory('infoRequirePopupSvc', infoRequirePopupSvc);
  infoRequirePopupSvc.$inject = ['$uibModal', 'pixerfApiUserSvc', 'sessionManagerSvc', 'accountConst', 'accountUtils', '$translate'];

  function infoRequirePopupSvc($uibModal, pixerfApiUserSvc, sessionManagerSvc, accountConst, accountUtils, $translate) {
    var mIshowing = false;
    var mPopup = null;
    function showPopup(data) {
      mIshowing = true;
      mPopup = $uibModal.open({
        templateUrl: 'app/components/info-require-popup/info-require-popup.html',
        controller: 'infoRequirePopupCtrl',
        controllerAs: 'vm',
        size: "lg",
        animation: true,
        backdrop: 'static',
        keyboard: false,
        windowClass: 'zindex info-require-popup',
        resolve: {
          'resolveData': function () {
            return data;
          }
        }
      });
      mPopup.result.then(function () {
        mIshowing = false;
      }, function () {
        mIshowing = false;
      })
      return mPopup;
    }

    function getPopup() {
      return mPopup;
    }
    function isShowing() {
      return mIshowing;
    }

    function validateDOB(user, form) {
      var errMsg = '';
      var loginUser = sessionManagerSvc.getCurrentLoginUser().data;
      if (loginUser && moment(user.date_of_birth).diff(moment(loginUser.date_of_birth)) === 0) {
        return;
      }
      if (form.date_of_birth.$error.required) {
        errMsg = $translate.instant('please-input-date-of-birth');
      } else if (form.date_of_birth.$error.date) {
        errMsg = "Sorry, Your date of birth is not in valid format. The valid format is DD/MM/YYYY";
      } else if (form.date_of_birth.$error.validationUnderMinAge) {
        errMsg = "Uh oh! You have to be at least 18 to sign up as a Pixerfer. Don’t worry, time flies when you’re having fun. Keep doing what you love, and we’ll be waiting for you.";
      } else if (form.date_of_birth.$error.validationOverMaxAge) {
        errMsg = "Woah! Your birth date puts you at over 100 years old - that's either amazing or you've entered the wrong date by accident. Please check again.";
      }
      return errMsg;

    }

    function validateProfile(user, form) {
      form.$setDirty();
      var errMsg = ''
      if (form.email && form.email.$error.required) {
        errMsg = "Please input your email!";
      } else if (form.email && form.email.$error.email) {
        errMsg = "Invalid email address!";
      } else if (form.bio && form.bio.$error.required) {
        errMsg = "Please input your description!";
      } else if (form.first_name && form.first_name.$error.required) {
        errMsg = $translate.instant('please-input-first-name');
      } else if (form.first_name && form.first_name.$error.maxlength) {
        errMsg = "Sorry, Your first name cannot exceed 20 characters.";
      } else if (form.last_name && form.last_name.$error.required) {
        errMsg = $translate.instant('please-input-last-name');
      } else if (form.last_name && form.last_name.$error.maxlength) {
        errMsg = "Sorry, Your last name cannot exceed 20 characters.";
      } else if (form.country && form.country.$error.required) {
        errMsg = "Please input your country!";
      } else if (form.location && form.location.$error.required) {
        errMsg = "Please input your location!";
      } else if (form.first_name && (form.first_name.$error.validationNoNumber || form.first_name.$error.validationNoHyperlink)) {
        errMsg = "Sorry, Your first name cannot contain link or number.";
      } else if (form.last_name && (form.last_name.$error.validationNoNumber || form.last_name.$error.validationNoHyperlink)) {
        errMsg = "Sorry, Your last name cannot contain link or number.";
      } else if (form.bio && (form.bio.$error.validationNoNumber || form.bio.$error.validationNoHyperlink)) {
        errMsg = "Sorry, Your description cannot contain link or number.";
      }
      if (!errMsg) {
        errMsg = validateDOB(user, form);
      }

      return errMsg;
    }

    function validateServiceData(user, form) {
      form.$setDirty();
      var errMsg = '';
      if (form.specialities && form.specialities.$error && form.specialities.$error.required) {
        errMsg = "Please input your specialities!";
      } else if (form.years_of_experience && form.years_of_experience.$error && form.years_of_experience.$error.required) {
        errMsg = "Please input your experience!";
      } else if (form.years_of_experience && form.years_of_experience.$error && form.years_of_experience.$error.min) {
        errMsg = $translate.instant("please-key-in-whole-number");
      } else if (form.years_of_experience && form.years_of_experience.$error && form.years_of_experience.$error.maxlength) {
        errMsg = "Please enter a single or double digit number";
      } else if (form.years_of_experience && form.years_of_experience.$error && (form.years_of_experience.$error.pattern || form.years_of_experience.$error.number)) {
        errMsg = $translate.instant("please-key-in-whole-number");
      } else if (form.service_rates && form.service_rates_unit && form.service_rates_unit.$error && (form.service_rates_unit.$error.min || form.service_rates_unit.$error.max)) {
        errMsg = "Please enter a figure between " + accountConst.PROFILE.SERVICES_RATE_MIN + " and " + accountConst.PROFILE.SERVICES_RATE_MAX + ".";
      }

      return errMsg;
    }

    function buildSavedPersonalUser(user) {
      var userInfo = "";
      user.location = accountUtils.getUserGoogleLocation(user.location);
      var dayConvert = user.date_of_birth.getDate();
      var monthConvert = (user.date_of_birth.getMonth() + 1);
      if (user.date_of_birth.getMonth() < 9)
        monthConvert = "0" + (user.date_of_birth.getMonth() + 1);
      if (user.date_of_birth.getDate() < 10)
        dayConvert = "0" + user.date_of_birth.getDate();
      userInfo = $.extend(true, {}, user);
      userInfo.date_of_birth = user.date_of_birth.getFullYear() + "-" + monthConvert + "-" + dayConvert;
      return userInfo;
    }

    function updateUserInfo(userData) {
      var updatedInfo = buildSavedPersonalUser(userData);
      return pixerfApiUserSvc.put(updatedInfo).$promise;
    }

    return {
      showPopup: showPopup,
      updateUserInfo: updateUserInfo,
      validateProfile: validateProfile,
      validateServiceData: validateServiceData,
      isShowing: isShowing,
      getPopup: getPopup
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('pixerf')
    .controller('infoRequirePopupCtrl', infoRequirePopupCtrl);

  infoRequirePopupCtrl.$inject = ['$scope', '$uibModalInstance', 'resolveData', 'accountUtils', 'infoRequirePopupSvc', 'sessionManagerSvc', 'toastr', 'settingSvc', 'uploadPhotoSvc', 'arrayUtils', '$q', '$timeout', 'uploadProfilePhotoSvc', 'editProfileSvc', 'pixerfApiUserSvc', 'stringUtils', 'systemUtils', 'accountConst', 'portfolioConst'];

  function infoRequirePopupCtrl($scope, $uibModalInstance, resolveData, accountUtils, infoRequirePopupSvc, sessionManagerSvc, toastr, settingSvc, uploadPhotoSvc, arrayUtils, $q, $timeout, uploadProfilePhotoSvc, editProfileSvc, pixerfApiUserSvc, stringUtils, systemUtils, accountConst, portfolioConst) {

    var self = this;

    self.popupData = resolveData;
    self.showUploadUserProfilePhotos = showUploadUserProfilePhotos;
    self.showUploadModal = showUploadModal;
    self.closePopup = closePopup;
    self.navigate = navigate;
    self.isMissingField = {};
    self.isLastSlide = false;
    self.isFirstSlide = true;
    self.isWorking = false;
    self.onSpecialitiesSelected = onSpecialitiesSelected;
    self.buildServiceData = buildServiceData;
    self.isServiceDataValid = isServiceDataValid;
    self.buildSpecialitiesDropdown = buildSpecialitiesDropdown;
    self.onAvailabilityChanged = onAvailabilityChanged;
    self.serviceData = {};
    self.availability_weekdays = {};
    self.availability_weekends = {};
    self.onServiceRatesSelected = onServiceRatesSelected;
    self.serviceRates = [{ "name": "Hourly rate", "id": 1 }];
    self.maxSpecialitiesSelected = portfolioConst.LIMIT_SPECIALITIES;
    self.dopdownOpts = {
      "container": "body",
      "maxOptions": self.maxSpecialitiesSelected,
      "maxOptionsText": "Please select up to a maximum of " + self.maxSpecialitiesSelected + " specialities",
      "noneSelectedText": "Select up to five specialities"
    };
    self.CONST = {
      SERVICES_RATE_MIN: accountConst.PROFILE.SERVICES_RATE_MIN,
      SERVICES_RATE_MAX: accountConst.PROFILE.SERVICES_RATE_MAX
    }

    self.slickSetting = {
      prevArrow: '.info-require-popup__navigation-btn-prev',
      nextArrow: '.info-require-popup__navigation-btn-next',
      appendArrows: '.info-require-control',
      appendDots: '.info-require-control__slide-dots',
      onBeforeChange: function (event, slick, currentSlide, nextSlide) {
        self.isLastSlide = nextSlide === slick.slideCount - 1;
        self.isFirstSlide = (nextSlide === 0) || (currentSlide === 1 && currentSlide > nextSlide);
        self.currentStep = getStepByIndex(nextSlide);
        $timeout(function () {
          self.slick.setHeight();
        }, 0);
      },
      onAfterChange: function (event) {
        $timeout(function () {
          self.slick.setHeight();
        }, 0);
      },
      onInit: function (slick) {
        self.slick = slick;
        self.isFirstSlide = true;
        self.isLastSlide = self.slick.slideCount === 1;
        $timeout(function () {
          self.slick.setHeight();
        }, 0);
      }
    }
    self.steps = resolveData.steps;
    self.userData = resolveData.user;

    init();

    function init(user, steps) {
      self.currentStep = getStepByIndex(0);
      self.requiredFields = self.steps.BASIC_INFO ? checkUserInfo(self.userData, self.steps.BASIC_INFO.requiredFields) : [];
      if (!self.userData.isBiz) {
        extractServiceData(self.userData.profile);
        self.requiredFields = self.steps.SPECIALITIES_INFO ? $.extend(self.requiredFields, checkUserSpecialitiesInfo(self.userData, self.steps.SPECIALITIES_INFO.requiredFields)) : self.requiredFields;
      }
      self.nSteps = getNSteps(self.steps);
      buildSpecialitiesDropdown();
    }

    function extractServiceData(serviceData) {
      if (!serviceData) return;
      self.serviceData.years_of_experience = serviceData.years_of_experience;
      self.serviceData.services_rate_amount = serviceData.services_rate_amount;
      self.serviceData.specialitiesSelected = serviceData.specialities;

      if (serviceData.availability_weekdays) {
        extractAvailability(serviceData, 'availability_weekdays');
      }
      if (serviceData.availability_weekends) {
        extractAvailability(serviceData, 'availability_weekends');
      }
      if (serviceData.cameras && serviceData.cameras.length) {
        if (!self.serviceData.camerasSelected) {
          self.serviceData.camerasSelected = [];
        }
        for (var i = 0; i < serviceData.cameras.length; i++) {
          self.serviceData.camerasSelected.push({ 'index': i, 'value': serviceData.cameras[i] });
        }
      }
      if (serviceData.services_rate_type) {
        if (!self.serviceData.serviceRatesSelected) {
          self.serviceData.serviceRatesSelected = [];
        }
        for (var i = 0; i < self.serviceRates.length; i++) {
          if (serviceData.services_rate_type === self.serviceRates[i].name) {
            self.serviceData.serviceRatesSelected.push(self.serviceRates[i]);
          }
        }
      }
    }

    function extractAvailability(serviceData, timeDuration) {
      for (var i = 0; i < serviceData[timeDuration].length; i++) {
        if (serviceData[timeDuration][i] === "day") {
          self[timeDuration].day = true;
        }
        if (serviceData[timeDuration][i] === "evening") {
          self[timeDuration].evening = true;
        }
        if (i === serviceData[timeDuration].length - 1) {
          onAvailabilityChanged(timeDuration);
        }
      }
    }

    function onAvailabilityChanged(timeDuration) {
      if (!self.serviceData[timeDuration]) {
        self.serviceData[timeDuration] = [];
      }
      if (self[timeDuration].day && self[timeDuration].evening) {
        self.serviceData[timeDuration] = ['day', 'evening'];
      } else if (self[timeDuration].day) {
        self.serviceData[timeDuration] = ['day'];
      } else if (self[timeDuration].evening) {
        self.serviceData[timeDuration] = ['evening'];
      } else {
        self.serviceData[timeDuration] = [];
      }
    }

    function updateInfo(userData, form) {
      var def = $q.defer();
      infoRequirePopupSvc.updateUserInfo(userData, form).then(function (userInfo) {
        accountUtils.transformUserData(userInfo)
        sessionManagerSvc.setCurrentLoginUser(userInfo);
        def.resolve();
      }, function () {
        def.reject();
      });
      return def.promise;
    }
    function getStepByIndex(index) {
      var i = 0;
      for (var key in self.steps) {
        if (self.steps.hasOwnProperty(key)) {
          if (i === index) {
            return self.steps[key];
          }
          i++;
        }
      }
    }
    function getNSteps(steps) {
      var i = 0;
      for (var key in steps) {
        if (steps.hasOwnProperty(key)) {
          i++;
        }
      }
      return i;
    }
    function navigate(direction) {
      var def = $q.defer();
      var currentSlideIndex = self.slick.slickCurrentSlide();
      var currentStep = getStepByIndex(currentSlideIndex);
      var formSelected = currentStep.name === "BASIC_INFO" ? self.profileForm : self.specialitiesForm;

      if (direction === "next") {
        var validator = currentStep.validator;
        if (validator && !currentStep.canSkip) {
          var errMsg = validator(self.userData, formSelected);
          if (errMsg) {
            toastr.error(errMsg);
            def.resolve();
            return false;
          }
        }
        if (currentStep.name === "SPECIALITIES_INFO") {
          buildServiceData(self.serviceData);
          var errMsg = infoRequirePopupSvc.validateServiceData(self.serviceData, formSelected);
          if (errMsg) {
            toastr.error(errMsg);
            def.resolve();
            return false;
          }
          self.userData.profile = self.serviceData;
        }
        if (currentStep.name === "BASIC_INFO" || currentStep.name === "SPECIALITIES_INFO") {
          if (!self.isWorking) {
            self.isWorking = true;
            updateInfo(self.userData, formSelected).then(function () {
              self.isWorking = false;
              def.resolve();
              if (self.isLastSlide) {
                toastr.success("Your information has been successfully updated!");
                closePopup();
              } else {
                self.slick.slickNext();
              }
            }, function () {
              def.resolve();
              self.isWorking = false;
            });
          }
        } else {
          def.resolve();
          if (self.isLastSlide) {
            closePopup();
            toastr.success("Your information has been successfully updated!");
          } else {
            self.slick.slickNext();
          }
        }
      } else {
        def.resolve();
        self.slick.slickPrev();
      }
      return def.promise;
    }
    function showUploadModal() {
      closePopup();

      uploadPhotoSvc.showUploadModal({
        parent: 'COMPLETE_INFO_POPUP'
      });
    }
    function showUploadUserProfilePhotos(type) {
      var modal = uploadProfilePhotoSvc.showPopup({
        'type': type
      });
      modal.result.then(function (data) {
        var userImage = {};
        if (self.userData.isBiz && self.userData.isAdmin) {
          if (type == 'profile') {
            userImage.profile_image = data.response.handle ? data.response.handle  : data.thumbnails["300x"];
          } else if (type == 'cover') {
            userImage.cover_image = data.thumbnails["1200x"];
          }
          pixerfApiUserSvc.put({}, userImage).$promise.then(function () {
            settingSvc.updateUserProfilePhotos(self.userData, type, data.thumbnails);
          })
        } else {
          settingSvc.updateUserProfilePhotos(self.userData, type, data.thumbnails);
        }
      }, function () {
      });
    }
    function closePopup() {
      $uibModalInstance.close();
    }

    function checkUserInfo(userInfo, fields) {
      var requiredFields = {};
      for (var i = 0; i < fields.length; i++) {
        requiredFields[fields[i]] = !userInfo[fields[i]];
      }

      requiredFields["country"] = (userInfo["address"] && !userInfo["address"]["country"]) || !userInfo["address"];
      return requiredFields;
    }

    function checkUserSpecialitiesInfo(userInfo, fields) {
      var specialityFields = {};
      specialityFields["specialities"] = !userInfo["profile"] || !arrayUtils.isValueArr(userInfo["profile"]["specialities"]);
      specialityFields["years_of_experience"] = !userInfo["profile"] || !stringUtils.isValueString(userInfo["profile"]["years_of_experience"]);
      specialityFields["cameras"] = !userInfo["profile"] || !arrayUtils.isValueArr(userInfo["profile"]["cameras"]);
      specialityFields["service_rates"] = !userInfo["profile"] || !userInfo["profile"]["services_rate_type"] || userInfo["profile"]["services_rate_amount"] == null;
      specialityFields["availability"] = !userInfo["profile"] || (!arrayUtils.isValueArr(userInfo["profile"]["availability_weekdays"]) && !arrayUtils.isValueArr(userInfo["profile"]["availability_weekends"]));
      return specialityFields;
    }

    function onSpecialitiesSelected(spectialitiesSelected) {
      if (!self.serviceData.specialities) {
        self.serviceData.specialities = [];
      }
      if (!spectialitiesSelected) {
        toastr.error("Please input your specialities!");
        return;
      }
      self.serviceData.specialities = spectialitiesSelected;
    }

    function buildServiceData(serviceData) {
      self.serviceData.services_rate_type = serviceData.serviceRatesSelected && serviceData.serviceRatesSelected[0] && serviceData.serviceRatesSelected[0].name ? serviceData.serviceRatesSelected[0].name : "";
      self.serviceData.cameras = serviceData.camerasSelected ? buildArrayByProp(serviceData.camerasSelected, "value") : "";
      self.serviceData.specialities = serviceData.specialitiesSelected ? serviceData.specialitiesSelected : null;
    }

    function buildArrayByProp(arrayObj, prop) {
      var arrStr = [];
      for (var i = 0; i < arrayObj.length; i++) {
        if (arrayObj[i][prop]) {
          arrStr.push(arrayObj[i][prop]);
        }
      }
      return arrStr;
    }

    function isServiceDataValid(form) {
      var errMsg = "";
      errMsg = editProfileSvc.validateServiceData(form);
      if (errMsg) {
        toastr.error(errMsg);
        return false;
      }
      return true;
    }

    function buildSpecialitiesDropdown() {
      pixerfApiUserSvc.getSpecialities().$promise.then(function (response) {
        self.specialities = response.data;
      });
    }

    function onServiceRatesSelected(serviceRatesSelected) {
      if (!serviceRatesSelected) {
        toastr.error("Please input your service rates!");
        return;
      }
      self.serviceData.services_rate_type = serviceRatesSelected[0] ? serviceRatesSelected[0].name : "";
      if (!self.serviceData.services_rate_type) {
        self.serviceData.services_rate_amount = null;
        systemUtils.digest($scope);
      }
    }
  }
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('infoColIntroCtrl', infoColIntroCtrl);

	infoColIntroCtrl.$inject = ['$scope', 'customCommissionBasicFormPopupSvc', '$timeout', '$location', 'emailUsPopupSvc', 'signUpPersonalPopupSvc', 'uploadPhotoSvc', 'sessionManagerSvc', '$state', 'alertMessagePopupSvc', 'toastr'];

	function infoColIntroCtrl($scope, customCommissionBasicFormPopupSvc, $timeout, $location, emailUsPopupSvc, signUpPersonalPopupSvc, uploadPhotoSvc, sessionManagerSvc, $state, alertMessagePopupSvc, toastr) {

		var self = this;
		self.context = $scope.context;
		self.infoCols = [];
		self.loginnedUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.isBusinessAcc = self.loginnedUser && self.loginnedUser.account_type === 'business';

		init();

		function init() {
			generateContent(self.context);
		}

		function generateContent(context) {
			switch (context) {
				case 'quick-booking':
					self.isSpaceBetween = false;
					self.infoCols = [{
						theme: 'organge-1',
						icon: "icon-bestfit-thick",
						content: "Choose from local specialists for hire in all major cities in Asia."
					}, {
						theme: 'organge-2',
						icon: "icon-letter-email-square",
						content: "Send in your booking request online."
					}, {
						theme: 'organge-3',
						icon: "icon-clock-square",
						content: "Book a photographer or videographer for your shoot and get a response within 24 hours."
					}]
					break;
				case 'creating-perfect-images':
					self.isSpaceBetween = false;
					self.infoCols = [{
						theme: 'blue-1',
						icon: "photo-no-first dark-mode",
						content: "Fill up the booking request form."
					}, {
						theme: 'blue-2',
						icon: "photo-no-second dark-mode",
						content: "Get matched to a photographer or videographer in 24 hours."
					}, {
						theme: 'blue-3',
						icon: "photo-no-third dark-mode",
						content: "Confirm your booking."
					}, {
						theme: 'blue-4',
						icon: "photo-no-fourth dark-mode",
						content: "Select and download final photos or videos on one easy-to-use platform."
					}]
					break;
				case 'about-challenges':
					self.isSpaceBetween = false;
					self.infoCols = [{
						theme: 'dark-blue-1',
						icon: "photo-no-first",
						contentTheme: "light",
						content: "Complete the request form with your brief for our team’s review."
					}, {
						theme: 'dark-blue-2',
						icon: "photo-no-second",
						contentTheme: "light",
						content: "Launch your challenge on our platform and share it with the PIXERF community."
					}, {
						theme: 'dark-blue-3',
						icon: "photo-no-third",
						contentTheme: "light",
						content: "Select the winning entries from the curated submissions."
					}, {
						theme: 'dark-blue-4',
						icon: "photo-no-fourth",
						contentTheme: "light",
						content: "Download the winning images immediately."
					}]
					break;
				case 'about-business':
					self.isSpaceBetween = true;
					self.infoCols = [{
						theme: 'brown-1',
						paddingStyle: 'padding--45',
						content: "Book a shoot anywhere in Asia and get customised photos or videos for your brand. Manage multiple shoots in any city right from your desk.",
						btnTheme: 'black-theme',
						styleContent: 'text--bold',
						button: 'Book a Shoot',
						cta: bookShoot
					}, {
						theme: 'brown-2',
						paddingStyle: 'padding--45',
						content: "Run community challenges and choose from a wide selection of fresh and authentic photo submissions.",
						btnTheme: 'black-theme',
						styleContent: 'text--bold',
						button: 'Run a Challenge',
						cta: runChallenge
					}, {
						theme: 'brown-3',
						paddingStyle: 'padding--45',
						content: "Buy unique and authentic stock that represent Asia at attractive prices.",
						btnTheme: 'black-theme',
						styleContent: 'text--bold',
						button: 'Buy Credit Plans',
						cta: byCreditPlans
					}]
					break;
				case 'about-community':
					self.infoCols = [{
						theme: 'dark-yellow-1',
						icon: 'icon-Join-Community',
						styleIcon: 'font-size--62 light',
						paddingStyle: 'padding--23-28-16-23',
						content: "Get invited to workshops, talks and photo walks led by professionals in our community.",
						styleContent: 'font-size--20',
					}, {
						theme: 'dark-yellow-2',
						icon: 'icon-buy-photo',
						styleIcon: 'font-size--62 light',
						paddingStyle: 'padding--23-28-16-23',
						content: "Get access to opportunities to shoot and earn from Community Challenges and photo and video assignments.",
						styleContent: 'font-size--20',
					}, {
						theme: 'dark-yellow-3',
						icon: 'icon-find-people',
						styleIcon: 'font-size--62 light',
						paddingStyle: 'padding--23-28-16-23',
						content: "Get discovered and recognised by brands and peers.",
						styleContent: 'font-size--20',
					}, {
						theme: 'dark-yellow-4',
						icon: 'icon-people-discussion',
						styleIcon: 'font-size--62 light',
						paddingStyle: 'padding--23-28-16-23',
						content: "Get involved in discussions and forums on what’s trending and making waves in the global visual content landscape.",
						styleContent: 'font-size--20',
					}]
					break;
				case 'explore-communnity-hub':
					self.infoCols = [{
						theme: 'light-yellow-1',
						icon: "photo-no-icon-bold photo-no-first dark-mode",
						styleContent: 'font-size--18 text--bold',
						content: "Get invited to workshops, talks and photo walks led by professionals in our community.",
						button: 'Join now',
						cta: onCreatorFirstBoxClick
					}, {
						theme: 'light-yellow-2',
						icon: "photo-no-icon-bold photo-no-second dark-mode",
						styleContent: 'font-size--18 text--bold',
						content: "Win attractive prizes of S$150 and more by joining any Community Challenges.",
						button: 'Join now',
						cta: onCreatorSecondBoxClick
					}, {
						theme: 'light-yellow-3',
						icon: "photo-no-icon-bold photo-no-third dark-mode",
						styleContent: 'font-size--18 text--bold',
						content: "Sell your photos on the Visual Marketplace and earn royalties with each sale.",
						button: 'Upload Now',
						cta: onCreatorThirdBoxClick
					}, {
						theme: 'light-yellow-4',
						icon: "photo-no-icon-bold photo-no-fourth dark-mode",
						styleContent: 'font-size--18 text--bold',
						content: "Showcase your talent and influence and get discovered for collaborations.",
						button: 'Join now',
						cta: onCreatorFourthBoxClick
					}]
					break;
				default:
					self.isSpaceBetween = false;
					self.infoCols = [{
						theme: '#D5A57D',
						icon: "../assets/images/homepage/contact-form-background.png",
						content: "Choose from local specialists for hire in all major cities in Asia."
					}, {
						theme: '#CA8F5C',
						icon: "../assets/images/homepage/contact-form-background.png",
						content: "Send in your booking request online."
					}, {
						theme: '#B57C52',
						icon: "../assets/images/homepage/contact-form-background.png",
						content: "Book a photographer or videographer for your shoot and get a response within 24 hours."
					}]
			}

			function byCreditPlans() {
				$state.go('about-business-page.pricing');
			}

			function bookShoot() {
				customCommissionBasicFormPopupSvc.showPopup();
			}

			function runChallenge() {
				if(!(self.loginnedUser && self.loginnedUser.id)){
					// var state = $state.href('setting.manage-missions.on-going', {}, {absolute: false});
					// state = state.replace('#/', "/");
					// sessionManagerSvc.setCallbackURL(state);
					// return signUpBusinessPopupSvc.showPopup();
					
					emailUsPopupSvc.showPopup();
					return;
				}
				if(self.isBusinessAcc){
					// $state.go("setting.manage-missions.on-going");
					emailUsPopupSvc.showPopup();
					return;
				}else{
					toastr.info('Challenges are only open to business account users.');
				}
			}

			function onCreatorFirstBoxClick() {
				if (!self.loginnedUser || !self.loginnedUser.isContributor) {
					signUpPersonalPopupSvc.showPopup();
				} else {
					alertMessagePopupSvc.showPopup({
						title: "Watch this space – we’ll be launching the Community Page soon!"
					});
				}
			}

			function onCreatorSecondBoxClick() {
				if (!self.loginnedUser || !self.loginnedUser.isContributor) {
					signUpPersonalPopupSvc.showPopup();
				} else {
					$state.go('run-a-challenge-page.live-challenges');
				}
			}

			function onCreatorThirdBoxClick() {
				if (self.loginnedUser && self.loginnedUser.canUploadPhotos) {
					uploadPhotoSvc.showUploadModal();
				} else {
					signUpPersonalPopupSvc.showPopup();
				}
			}

			function onCreatorFourthBoxClick() {
				if (!self.loginnedUser || !self.loginnedUser.isContributor) {
					signUpPersonalPopupSvc.showPopup();
				} else {
					$state.go('user-home-page.personal.portfolio.carousel');
				}
			}
		}
	}
})();

(function () {
	'use strict';

	angular
	  .module('pixerf')
	  .directive('infoColIntro', infoColIntro);

	function infoColIntro() {

	  var directive = {
		scope: {
            context: "@?"
		},
		restrict: 'E',
		templateUrl: 'app/components/info-col-intro/info-col-intro.html',
		controller: 'infoColIntroCtrl',
		controllerAs: 'vm',
		replace: true
	  };
	  return directive;
	}

  })();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('homeMobileCtrl', homeMobileCtrl);

    homeMobileCtrl.$inject = ['$state', 'signInSvc', 'selectSignUpTypePopupSvc'];

    function homeMobileCtrl($state, signInSvc, selectSignUpTypePopupSvc) {

        var self = this;

        self.onSignUpClicked = onSignUpClicked;
		self.onLoginClicked = signInSvc.showSignInModal;

        document.getElementById('pixerfViewport').setAttribute('content','width=device-width');
        hideHeaderAndFooter();
        function hideHeaderAndFooter(){
            $('com-header').hide();
            $('com-footer').hide();
        }
        function onSignUpClicked(){
            selectSignUpTypePopupSvc.showPopup();
        }
    }
})();
(function () {
  'use strict';

  angular
    .module('pixerf')
    .directive('homeMobile', homeMobile);

  function homeMobile() {

    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/home-mobile/home-mobile.html',
      controller: 'homeMobileCtrl',
      controllerAs: 'vm',
      replace: true
    };
    return directive;
  }

})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('highlightContentColumnCtrl', highlightContentColumnCtrl);

	highlightContentColumnCtrl.$inject = ['$scope', 'selectSignUpTypePopupSvc'];

	function highlightContentColumnCtrl($scope, selectSignUpTypePopupSvc) {

		var self = this;
		self.yourLendsHover = false;
		self.yourSpaceHover = false;
		self.yourCommunityHover = false;

		self.onSignUpClicked = onSignUpClicked;

		function onSignUpClicked(){
            selectSignUpTypePopupSvc.showPopup();
        }
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('highlightContentColumn', highlightContentColumn);

	function highlightContentColumn() {

		var directive = {
			scope: {
				data: "="
			},
			restrict: 'E',
			templateUrl: 'app/components/highlight-content-column/highlight-content-column.html',
			controller: 'highlightContentColumnCtrl',
			controllerAs: 'vm',
			replace: true
		};
		return directive;
	}
})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('hideCameraCtrl', hideCameraCtrl);

    hideCameraCtrl.$inject = ['fileUtils','$scope', 'pixerfApiMediaSvc', 'sessionManagerSvc', 'toastr', 'peopleListPopupSvc', 'accountConst'];

    function hideCameraCtrl(fileUtils, $scope, pixerfApiMediaSvc, sessionManagerSvc, toastr, peopleListPopupSvc, accountConst) {

        var self = this;

        self.loginnedUser = sessionManagerSvc.getCurrentLoginUser().data;
        $scope.media.isMine = self.loginnedUser ? self.loginnedUser.id === $scope.media.user.id : false;
        // self.isDoingHidden = (!$scope.media.is_camera_model_hidden && $scope.media.camera.model) ? true : false;
        // self.btnLabel = $scope.media.is_camera_model_hidden ? "Show camera model" : "Hide camera model";
        self.onHideCameraBtnClick = onHideCameraBtnClick;
        self.isWorking = false;
        
        function onHideCameraBtnClick(photo) {
            if(self.isWorking) return ;
            self.isWorking = true;
            try{
                var savedFile = fileUtils.buildSavedFileObject($scope.media);

            }catch(ex){
                self.isWorking = false;
            }
            try{
                $scope.media.is_camera_model_hidden = !$scope.media.is_camera_model_hidden;
                pixerfApiMediaSvc.update({id: $scope.media.id}, savedFile).$promise.then(function(){
                    self.isWorking = false;
                }, function(){
                    $scope.media.is_camera_model_hidden = !$scope.media.is_camera_model_hidden;
                    self.isWorking = false;
                })
            } catch(ex){
                self.isWorking = false;
            }
            // setBtnLabel();
        }

        // function setBtnLabel(){
        //     self.btnLabel = $scope.media.is_camera_model_hidden ? "Show camera model" : "Hide camera model";
        // }
    }
})();
(function() {
    'use strict';

    angular
        .module('pixerf')
        .directive('hideCamera', hideCamera);

    function hideCamera() {

        var directive = {
            scope: {
                "media": "="
            },
            restrict: 'E',
            templateUrl: 'app/components/hide-camera/hide-camera.html',
            controller: 'hideCameraCtrl',
            controllerAs: 'vm',
            replace: true
        };
        return directive;
    }

})();
(function () {
	'use strict';

	angular
		.module('pixerf')
		.factory('headerSvc', headerSvc);

	headerSvc.$inject = ['$state', 'signInSvc', 'selectSignUpTypePopupSvc'];

	function headerSvc($state, signInSvc, selectSignUpTypePopupSvc) {
		var isTransformHeaderStyle = {
			data: false
		}

		function scrollHandler() {
			var $window = $(window);
			isTransformHeaderStyle.data = $window.scrollTop() > 30;
		}

		function showSignUpModal() {
			selectSignUpTypePopupSvc.showPopup();
		}

		function showSignInModal() {
			signInSvc.showSignInModal();
		}

		function showUploadModal() {

			$log.debug('Open file upload modal');

			var uploadModal = $uibModal.open({
				size: 'full',
				templateUrl: 'app/componentss/upload/upload-modal.html',
				controller: 'UploadController',
				controllerAs: 'vm'
			});

			uploadModal.result.then(function () {}, function () {
				$log.info('Upload modal dismissed');
			});

		}

		function getFixedByHeaderSetting() {
			return {
				marginTop: _.debounce(function () {
					return $(".main-header").height();
				}, 500),
				dontSetWidth: true
			}
		}
		return {
			showUploadModal: showUploadModal,
			scrollHandler: scrollHandler,
			isTransformHeaderStyle: isTransformHeaderStyle,
			showSignUpModal: showSignUpModal,
			showSignInModal: showSignInModal,
			getFixedByHeaderSetting: getFixedByHeaderSetting
		};
	}
})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('headerCtrl', headerCtrl);

    headerCtrl.$inject = ['systemUtils', '$stateParams', '$rootScope', '$scope', 'headerSvc', '$state', '$location', 'sessionManagerSvc', '$timeout', '$translate', 'messageConst'];

    function headerCtrl(systemUtils, $stateParams, $rootScope, $scope, headerSvc, $state, $location, sessionManagerSvc, $timeout, $translate, messageConst) {
        var self = this;
        var env = new PixerfEnv();
		self.scrollHandler = headerSvc.scrollHandler;
        self.isTransformHeaderStyle = headerSvc.isTransformHeaderStyle;
        self.onFilteredClicked = onFilteredClicked;
        self.onLogoClicked = onLogoClicked;
        self.onSearchBtnClicked = onSearchBtnClicked;
		self.onMarketplaceBtnClicked = onMarketplaceBtnClicked;
		self.onToggleMenuHeader = onToggleMenuHeader;
        self.onMenuBtnClicked = onMenuBtnClicked;
        self.onLanguagesSelected = onLanguagesSelected;
        self.language = {};
        self.languagesSetting = {
            "items": [
				{"name": "English","value": "en" },
				{"name": "Indonesia","value": "id" }
			]
        };
        self.searchInput = {};
        self.filterSetting = {
            "items":  [
                {"name":"images","value":"images","stateMapped":"buy-stock-page.trending"}
            ]
        };

        $rootScope.$on(messageConst.BROADCAST.USER_DATA_CHANGE, function(){
            self.loginUser = sessionManagerSvc.getCurrentLoginUser().data;
            if(self.loginUser && (self.loginUser.role === 'curator_internal' || self.loginUser.role === 'admin_internal')){
                self.filterSetting = {
                    "items":  [
                        {"name":"images","value":"images","stateMapped":"buy-stock-page.trending"},
                        {"name":"photographers","value":"photographer","stateMapped":"marketplace.photographers.featuredPhotographer"}
                    ]
                };
            } else {
                self.filterSetting = {
                    "items":  [
                        {"name":"images","value":"images","stateMapped":"buy-stock-page.trending"}
                    ]
                };
            }
        })

        self.linkToBlog = "http://feed-qa.pixerf.com";
        if(env.getEnv() === env.ENV.PRODUCTION){
            self.linkToBlog = "http://xerfie.pixerf.com";
        }

        self.onClearTags = onClearTags;

        $scope.$on('$stateChangeSuccess', function(event, toState){
            var nextState = toState.name;
            if($state && $state.params && $state.params.hashtag == 'creditplan'){
                $timeout(function(){
                    showCreditPlanPopup();
                }, 500);
            }
            if($stateParams && $stateParams.type && self.filterSetting && self.filterSetting.items && self.filterSetting.items.length){
                self.filterSetting.items[0].changeState = !self.filterSetting.items[0].changeState;
                self.selectedFilterItem = {
                    "value": $stateParams.type,
                    "name": $stateParams.type.charAt(0).toUpperCase() + $stateParams.type.slice(1)
                };
                $timeout(function(){
                    $('.header-search-bar input').attr("placeholder", 'Search ' + self.filterSetting.items[0].name);
                }, 500);
            }else if(self.filterSetting && self.filterSetting.items){
                $timeout(function () {
                    for(var i = 0; i < self.filterSetting.items.length; i++){
                        if(self.filterSetting.items[i].stateMapped && self.filterSetting.items[i].stateMapped == nextState) {
                            self.selectedFilterItem = {
                                "value": self.filterSetting.items[i].value,
                                "name": self.filterSetting.items[i].name
                            }
                            $('.header-search-bar input').attr("placeholder", 'Search ' + self.filterSetting.items[i].name);
                        }
                    }
                }, 0)
            }
        });

        function onClearTags(){
            if(self.filterSetting && self.filterSetting.items && self.selectedFilterItem && self.selectedFilterItem.value){
                $timeout(function () {
                    for(var i = 0; i < self.filterSetting.items.length; i++){
                        if(self.filterSetting.items[i].value && self.filterSetting.items[i].value == self.selectedFilterItem.value) {
                            $state.go(self.filterSetting.items[i].stateMapped);
                            $('.header-search-bar input').attr("placeholder", 'Search ' + self.filterSetting.items[i].name);
                        }
                    }
                }, 0)
            }
            else{
                $state.go("buy-stock-page.trending");
            }
        }

        $scope.isScreenMobile = $rootScope.isScreenMobile;
        $(window).resize(function(){
            $scope.isScreenMobile = $rootScope.isScreenMobile;
        })
        function onSearchBtnClicked(){
            self.searchInput.onEnterKeyPressed();
        }
        function onLogoClicked(){
            $state.go("home");
        }
        function onMarketplaceBtnClicked(){
			onToggleMenuHeader();
            if($state.current.name.indexOf("marketplace") == -1){
                var path = sessionManagerSvc.getMarketplaceTabHistory();
                var index = path.indexOf("?");
                var page='';
                if(index !== -1){
                    page = systemUtils.getURLParameter(path, "page");
                    path = path.substr(0, index);
                    $location.path(path).search({'page': page});
                } else {
                    $location.path(path);
                }
            }
		}
		function onMenuBtnClicked(){
			onToggleMenuHeader();
		}

		$(".mask-content div").on("click.pixerfMenu", function(event) {
			onCloseMenuHeader();
		});

		function onToggleMenuHeader(){
			var $headerNavbar = $("#mobile-pixerf-main-navbar");
			var $headerNavbarBtn = $("#header-navbar-btn");
			var $body = $("body");
			var $maskContent = $(".mask-content");
			$headerNavbar.toggleClass('menu-opened');
			$headerNavbarBtn.toggleClass('active');
			$body.toggleClass("pixerf-main-menu");
			$maskContent.toggleClass("show");
		}

		function onCloseMenuHeader(){
			var $headerNavbar = $("#mobile-pixerf-main-navbar");
			var $headerNavbarBtn = $("#header-navbar-btn");
			var $body = $("body");
			var $maskContent = $(".mask-content");
			$headerNavbar.removeClass('menu-opened');
			$headerNavbarBtn.removeClass('active');
			$body.removeClass("pixerf-main-menu");
			$maskContent.toggleClass("show");
        }

        function onFilteredClicked(item){
            self.searchInput.onFilterChanged();
            self.selectedFilterItem.placeholder = $translate.instant('search') + ' ' + $translate.instant(item.value.toLowerCase()).toLowerCase();
        }

        function onLanguagesSelected(language){
            $translate.use(language.value);
        }

        function showCreditPlanPopup(){
            $('.collapse').collapse('show');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .directive('comHeader', comHeader);
    comHeader.$inject = ['$timeout'];
    function comHeader($timeout) {
        return {
            restrict: 'ACE',
            replace: false,
            templateUrl: 'app/components/header/header.html',
            controller: 'headerCtrl',
            controllerAs: "vm",
            scope: {},
            transclude: true,
            link: function($scope){
                var listener = function(event, toState) {

                    $timeout(function() {
                        $scope.isVisible = !(toState.data && toState.data.hideHeader);
                        $scope.cssClass = toState.data && toState.data.headerClass;
                    });
                };

                $scope.$on('$stateChangeSuccess', listener);
            }
        };
    }
})();                                                                  
(function () {

	angular
		.module('pixerf')
		.controller('gridFilterSortCtrl', gridFilterSortCtrl);

		gridFilterSortCtrl.$inject = ['$scope'];

	function gridFilterSortCtrl($scope) {
        var self = this;
        self.options = $scope.options || [];
        self.title = $scope.title;
        self.onItemClicked = onItemClicked;
        self.isSelectedItem = isSelectedItem;
        self.onSelectAllBtnClicked = onSelectAllBtnClicked;
        self.isSelectAll = false;
        self.selectedValue = {};
        self.sortProperty =  $scope.sortProperty;
        self.sortDirection = {'sortReverse': !!$scope.reverse, 'straight': !$scope.reverse};
        self.onSortChange = onSortChange;
        self.selectedItems = $scope.selected || [];

        $scope.$watch("options", function(newValue, oldValue){
            if(newValue != oldValue){
                self.options = newValue;
                self.isSelectAll = (self.selectedItems.length > 0 ) && (self.selectedItems.length == self.options.length) ? true : false;
            }
        })

        $scope.$watch("selectedItems", function(newValue, oldValue){
            if(newValue != oldValue){
                $scope.selectedItem = newValue || [];
                self.isSelectAll = (self.selectedItems.length > 0 ) && (self.selectedItems.length == self.options.length) ? true : false;
            }
        })

        function init(){
            self.selectedItems = $scope.selected || [];
            self.options = $scope.options || [];
            self.isSelectAll = (self.selectedItems.length > 0 ) && (self.selectedItems.length == self.options.length) ? true : false;
        }
        init();

        function onSortChange(){
            $scope.reverse = !$scope.reverse;
            self.sortDirection['sortReverse'] =  $scope.reverse;
            self.sortDirection['straight'] = !self.sortDirection['sortReverse'];
        }

        function isSelectedItem(item){
            var result = false
            self.selectedItems.forEach( function(i){
                if(i.value == item.value){
                    result = true;
                }
            });
            return result;
        }

        function onItemClicked(item){
            if ($scope.multiSelect) {
                if (isSelectedItem(item)) {
                    var index = self.selectedItems.map(
                        function (x) {
                            return x.value;
                        }
                    ).indexOf(item.value);

                    self.selectedItems.splice(index, 1);
                    self.isSelectAll = false;
                    self.selectedValue['selectAll'] = false;
                    self.selectedValue[item.value] = false;

                } else {
                    self.selectedItems.push(item)
                    self.selectedValue[item.value] = true;
                    self.isSelectAll = (self.selectedItems.length == self.options.length);
                    self.selectedValue['selectAll'] = self.isSelectAll;
                }
            }else{
                if(isSelectedItem(item)){
                    $scope.selectedItem = [];
                    self.selectedValue = {};
                }else{
                    $scope.selectedItem[0] = item;
                    self.selectedValue[item.value] = true;
                }
            }
            
            $scope.onChanged({items: self.selectedItems});
        }

        function onSelectAllBtnClicked(){
            if(!$scope.multiSelect){
                return;
            }
            if(self.selectedItems.length == self.options.length){
                self.selectedItems = [];
                self.selectedValue = [];
                self.isSelectAll = false;
            }else{
                self.selectedItems = _.map(self.options, _.clone)
                _.map(self.options, function (num, key) {
                    self.selectedValue[num.value] = true;
                });
                self.selectedValue['selectAll'] = true;
                self.isSelectAll = true;
            }
            $scope.onChanged({items: self.selectedItems});
        }
		
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('gridFilterSort', gridFilterSort);

		gridFilterSort.$inject = [];

	function gridFilterSort() {

		var directive = {
			scope: {
				title: "@",
                options: "=",
                onChanged: "&",
                selected: "=",
				isOpenDll: "=",
				multiSelect: "=",
				sortProperty: "@",
				reverse: "="
			},
			restrict: 'E',
			templateUrl: 'app/components/grid-filter-sort/grid-filter-sort.html',
			controller: 'gridFilterSortCtrl',
			controllerAs: 'vm',
			replace: true
		};
		return directive;
	}

})();

(function () {

	angular
		.module('pixerf')
		.controller('gridFilterCtrl', gridFilterCtrl);

		gridFilterCtrl.$inject = ['$scope'];

	function gridFilterCtrl($scope) {
        var self = this;
        self.options = $scope.options;
        self.title = $scope.title;
        self.onItemClicked = onItemClicked;
        self.selectedItem = []
        self.isSelectedItem = isSelectedItem;
        self.onSelectAllBtnClicked = onSelectAllBtnClicked;
        self.isSelectAll = false;

        $scope.$watch("options", function(newValue){
            self.options = newValue;
            init();
        })

        $scope.$watch("selected", function(newValue){
            self.selectedItem = newValue || [];
            init();
        })

        function init(){
            self.selectedItem = $scope.selected || [];
            self.isSelectAll = (self.selectedItem.length > 0 ) && (self.selectedItem.length == self.options.length) ? true : false;
        }
        init();

        function isSelectedItem(item){
            var result = false
            self.selectedItem.forEach( function(i){
                if(i.value == item.value){
                    result = true;
                }
            });
            return result;
        }

        function onItemClicked(item){
            if ($scope.multiSelect) {
                if (isSelectedItem(item)) {
                    var index = self.selectedItem.map(
                        function (x) {
                            return x.value;
                        }
                    ).indexOf(item.value);

                    self.selectedItem.splice(index, 1);

                } else {
                    self.selectedItem.push(item)
                }
            }else{
                if(isSelectedItem(item)){
                    self.selectedItem = [];
                }else{
                    self.selectedItem[0] = item;
                }
            }
            
            $scope.onChanged({items: self.selectedItem});
        }

        function onSelectAllBtnClicked(){
            if(!$scope.multiSelect){
                return;
            }
            if(self.selectedItem.length == self.options.length){
                self.selectedItem = [];
                self.isSelectAll = false;
            }else{
                self.selectedItem = _.map(self.options, _.clone)
                self.isSelectAll = true;
            }
        }
		
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('gridFilter', gridFilter);

		gridFilter.$inject = [];

	function gridFilter() {

		var directive = {
			scope: {
				title: "@",
                options: "=",
                onChanged: "&",
                selected: "=",
				isOpenDll: "=",
				multiSelect: "="
			},
			restrict: 'E',
			templateUrl: 'app/components/grid-filter/grid-filter.html',
			controller: 'gridFilterCtrl',
			controllerAs: 'vm',
			replace: true
		};
		return directive;
	}

})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('googleLocationPickerCtrl', googleLocationPickerCtrl);

    googleLocationPickerCtrl.$inject = ['$scope'];

    function googleLocationPickerCtrl($scope) {

        var self = this;
        self.isOpen = {data: false};
        self.locationPickerOptions = function(){
            return {
                location: $scope.location,
                inputBinding: {
                    locationNameInput: $('.google-location-picker__location-input'),
                    latitudeInput: $('#us3-lat'),
                    longitudeInput: $('#us3-lon'),
                },
                radius: 300,
                enableAutocomplete: true,
                autocompleteOptions: {},
                onchanged: function(currentLocation, radius, isMarkerDropped){
                    console.log(arguments);
                    $scope.location = {};
                    $scope.location.latitude = currentLocation.latitude;
                    $scope.location.longitude = currentLocation.longitude;
                    $scope.location.reverse = $('.google-location-picker__location-input').val();
                    $scope.$apply();
                    
                    if($scope.onChanged) $scope.onChanged(currentLocation, radius, isMarkerDropped);
                    console.log($scope.location);

                }
            }
        }
    }
})();
(function () {
  'use strict';

  angular
    .module('pixerf')
    .directive('googleLocationPicker', googleLocationPicker);

  function googleLocationPicker() {

    var directive = {
      scope: {
        'btnClass': '@',
        'location': '=',
        'isDisabled': '=',
        'onChanged': '&'
      },
      restrict: 'E',
      templateUrl: 'app/components/google-location-picker/google-location-picker.html',
      controller: 'googleLocationPickerCtrl',
      controllerAs: 'vm',
      replace: true
    };
    return directive;
  }

})();

/*! jquery-locationpicker - v0.1.15 - 2016-09-26 */
"use strict";

angular.module("angular-jquery-locationpicker", []).constant("angularJQueryLocationpickerDefaultValue", {
    css: {
        width: "360px",
        height: "280px",
        "float": "left"
    }
}).service("angularJQueryLocationpickerService", [ "angularJQueryLocationpickerDefaultValue", function(defaultValue) {
    var service = {};
    service.callAutosizeOnInit = function(element, initCb) {
        var cb = initCb;
        if (!!cb) {
            initCb = function() {
                $(element).locationpicker("autosize");
                cb();
            };
        } else {
            initCb = function() {
                $(element).locationpicker("autosize");
            };
        }
    };
    service.checkDefaultStyles = function(element) {
        var elementStyle = element[0].style;
        element.css({
            width: elementStyle.width || defaultValue.css.width,
            height: elementStyle.height || defaultValue.css.height,
            "float": elementStyle.float || defaultValue.css.float,
            overflow: "hidden"
        });
    };
    return service;
} ]).directive("locationpicker", [ "angularJQueryLocationpickerService", function(service) {
    return {
        restrict: "EA",
        replace: true,
        scope: {
            options: "&"
        },
        link: function(scope, element, attrs) {
            var options = scope.options()
            service.checkDefaultStyles(element);
            service.callAutosizeOnInit(element, options.oninitialized);
            $(element).locationpicker(options);
        }
    };
} ]);
(function () {

	angular
		.module('pixerf')
		.factory('gojekAgreementPopupSvc', gojekAgreementPopupSvc);

	gojekAgreementPopupSvc.$inject = ['$uibModal'];

	function gojekAgreementPopupSvc($uibModal) {

		function showPopup(data) {
			$uibModal.open({
				templateUrl: 'app/components/gojek-agreement-popup/gojek-agreement-popup.html',
				controller: 'gojekAgreementPopupCtrl',
				controllerAs: 'vm',
				animation: true,
				windowClass: 'zindex gojek-agreement-popup',
				backdrop: 'static',
				resolve: {
					popupData: function () {
						return data;
					}
				}
			});
		}

		return {
			showPopup: showPopup
		};
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('gojekAgreementPopupCtrl', gojekAgreementPopupCtrl);

	gojekAgreementPopupCtrl.$inject = ['pixerfApiMissionSvc', '$uibModalInstance', 'uploadPhotoSvc', 'toastr', 'missionConst', '$state', 'translationSvc'];

	function gojekAgreementPopupCtrl(pixerfApiMissionSvc, $uibModalInstance, uploadPhotoSvc, toastr, missionConst, $state, translationSvc) {

		var self = this;
		self.closePopup = closePopup;
		self.onSubmitClicked= onSubmitClicked;
		self.dismiss = dismiss;
		self.checkAgreeAgreement = checkAgreeAgreement;
		self.onMissionAgreed = onMissionAgreed;
		self.isFormDirty = false;

		init();

		function closePopup() {
			$uibModalInstance.close();
		}

		function checkAgreeAgreement(){
            var errMsg = "";
            if(!self.mission.is_agreement_accepted){
                self.isFormDirty = true;
                errMsg = "Please agree to the Missions Agreement!";
            }
            return errMsg;
        }

		function onMissionAgreed() {
			pixerfApiMissionSvc.agree_agreement({ id: missionConst.GOJEK.MISSION_ID}, {}).$promise.then(function () {
				self.mission.is_agreement_accepted = true;
			}, function () {
				self.mission.is_agreement_accepted = false;
				toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
			})
		}

		function onSubmitClicked(){
			closePopup();
			uploadPhotoSvc.showUploadModal(self.mission);
			$state.go("mission-detail-page.brief", {id: missionConst.GOJEK.MISSION_ID});
		}

		function init(){
			pixerfApiMissionSvc.get({id: missionConst.GOJEK.MISSION_ID}).$promise.then(function(response){
				self.mission = response;
			});
		}

		function dismiss(){
			$uibModalInstance.dismiss();
		}
	}
})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('getReleaseFormBtnCtrl', getReleaseFormBtnCtrl);

    getReleaseFormBtnCtrl.$inject = ['$scope', 'sendReleaseFormEmailPopupSvc'];

    function getReleaseFormBtnCtrl($scope, sendReleaseFormEmailPopupSvc) {

        var self = this;
        self.onClicked = onClicked;

        function onClicked(){
            sendReleaseFormEmailPopupSvc.showPopup();
        }
    }
})();
(function () {
  'use strict';

  angular
    .module('pixerf')
    .directive('getReleaseFormBtn', getReleaseFormBtn);

  function getReleaseFormBtn() {

    var directive = {
      scope: {
          text: '@'
      },
      restrict: 'E',
      templateUrl: 'app/components/get-release-form-btn/get-release-form-btn.html',
      controller: 'getReleaseFormBtnCtrl',
      controllerAs: 'vm',
      replace: true
    };
    return directive;
  }

})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('generalContactFormCtrl', generalContactFormCtrl);

	generalContactFormCtrl.$inject = ['$scope', 'pixerfApiSubscribeSvc', 'toastr', 'pixerfApiCustomCommissionSvc', 'customCommissionBasicFormPopupSvc', 'ISO3166', 'translationSvc', 'sessionManagerSvc',
		'signUpPersonalPopupSvc', '$state', '$window'];

	function generalContactFormCtrl($scope, pixerfApiSubscribeSvc, toastr, pixerfApiCustomCommissionSvc, customCommissionBasicFormPopupSvc, ISO3166, translationSvc, sessionManagerSvc,
		signUpPersonalPopupSvc, $state, $window) {

		var self = this;
		self.context = $scope.context;
		self.user = {};
		self.agreement = {};
		self.isFormValid = isFormValid;
		self.onSubmit = onSubmit;
		self.spinner = {
			isVisible: false
		};
		self.defaultCountryCode = 'sg';
		self.onAgreeChanged = onAgreeChanged;
		self.onCountrySelected = onCountrySelected;
		self.onSelectFile = onSelectFile;
		self.onRemoveFile = onRemoveFile;
		self.onBookAShootClicked = onBookAShootClicked;
		self.showMobileSelect = true;
		self.file = null;
		self.formBtnText = 'Book a Shoot';
		self.formBtnClicked = onBookAShootClicked;

		self.countriesOpts = {
			"maxOptions": 1,
			'noneSelectedText': 'Select your country',
			"container": "body",
			"customAll": false,
			"dropupAuto": false
		};
		self.loginedUser = sessionManagerSvc.getCurrentLoginUser().data;

		init();

		function init() {
			generateContent(self.context);
			self.countries = buildCountries();
		}

		function buildCountries() {
			var arr = [];
			for (var key in ISO3166.codeToCountry) {
				arr.push({
					id: key,
					name: ISO3166.codeToCountry[key]
				})
			}
			return arr;
		}

		function generateContent(context) {
			switch (context) {
				case 'home-page':
					self.formTheme = 'black-theme';
					self.box = {
                        id: "93514",
						photo: "assets/images/general-contact-form/contact-form-background-1.jpg",
						header: "Still looking and can't find what you're looking for?",
						content: "Tell us about your business and your photo or video requirements and we'll get back to you shortly."
					}
					self.formBtnClicked = homepageBookAShootClicked;
					break;
				case 'about-custom-cotnent':
					self.formTheme = 'blue-theme';
					self.box = {
						photo: "assets/images/general-contact-form/contact-form-background-2.jpg",
						header: "Still looking and can't find what you're looking for?",
						content: "Tell us about your business and your photo or video requirements and we'll get back to you shortly."
					}
					self.formBtnClicked = ccapageBookAShootClicked;
					break;
				case 'about-challenges-page':
					self.formTheme = 'dark-blue-theme';
					self.box = {
                        id: "238813",
						photo: "assets/images/general-contact-form/contact-form-background-3.jpg",
						header: "Still looking and can't find what you're looking for?",
						content: "Tell us about your business and your photo or video requirements and we'll get back to you shortly."
					}
					self.formBtnText = 'Launch a Challenge';
					self.formBtnClicked = onLaunchAChallenge;
					break;
				case 'about-business':
					self.formTheme = 'black-theme';
					self.box = {
                        id: "159731",
						photo: "assets/images/general-contact-form/contact-form-background-4.jpg",
						header: "Still looking and can't find what you're looking for?",
						content: "Tell us about your business and your photo or video requirements and we'll get back to you shortly."
					}
					break;
				case 'explore-communnity-hub':
					self.formTheme = 'light-yellow';
					self.box = {
                        id: "95813",
						photo: "assets/images/general-contact-form/contact-form-background-5.jpg",
						header: "Still looking and can't find what you're looking for?",
						content: "Tell us about your business and your photo or video requirements and we'll get back to you shortly.",
						btnnStyle: "font-size--20"
					}
					self.formBtnText = self.loginedUser && self.loginedUser.isContributor ? 'Manage your profile' : 'Sign Up for Creator Account';
					self.formBtnClicked = onLaunchAChallenge;
					break;
				case 'payout-and-pricing':
					self.formTheme = 'light-yellow';
					self.box = {
                        id: "212447",
						photo: "assets/images/general-contact-form/contact-form-background-6.jpg",
						header: "Still looking and can't find what you're looking for?",
						content: "Tell us about your business and your photo or video requirements and we'll get back to you shortly.",
						btnnStyle: "font-size--20"
					}
					self.formBtnText = self.loginedUser && self.loginedUser.isContributor ? 'Manage your profile' : 'Sign Up for Creator Account';
					self.formBtnClicked = onSignUpCreator;
					break;
				default:
				case 'black-theme':
					self.formTheme = 'black-theme';
					self.box = {
                        id: "212447",
						photo: "assets/images/general-contact-form/contact-form-background-1.jpg",
						header: "Still looking and can't find what you're looking for?",
						content: "Tell us about your business and your photo or video requirements and we'll get back to you shortly."
					}
			}
		}

		function onAgreeChanged() {}

		function onCountrySelected(country, form) {
			if (form.mobile.$dirty || !form.$invalid) {
				return;
			}
			self.defaultCountryCode = country[0].id;
		}

		function isFormValid(form) {
			$scope.s = 0;
			var result = true;
			if (!form.$dirty || form.$invalid) {
				return false
			}

			return result;

		}

		function subsribleNewsLetter(email) {
			if (!self.agreement.isAgree) return;
			pixerfApiSubscribeSvc.subscribe({
				"email_subscriber": {
					topic: 'newsLetter',
					email: email
				}
			}).$promise.then(
				function (res) {},
				function (error) {
					toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
				});
		}

		const inputElement = document.getElementById("attachFile");
		inputElement.addEventListener("change", onSelectedFile, false);

		function onSelectedFile(file) {
			self.file = this.files[0];
		}

		function onRemoveFile() {
			self.file = null;
		}

		function onSelectFile() {
			const inputElement = document.getElementById("attachFile");
			inputElement.click();
		}

		function convertDataForSendEmail() {
			var data = new FormData();
			data.append('full_name', self.user.full_name);
			data.append('company_name', self.user.company);
			data.append('email', self.user.email);
			data.append('country', ((self.user.country && self.user.country[0]) ? (self.user.country[0].id).toString() : self.defaultCountryCode));
			data.append('mobile', self.user.mobile);
			data.append('enquiry', self.user.message);

			if (self.file) {
				data.append('file', self.file);
			}

			return data;
		}

		function clearContactForm() {
			self.user = {
				full_name: null,
				company: null,
				email: null,
				mobile: null,
				enquiry: null
			};
			self.file = null;

		}

		function onSubmit(form) {
			self.spinner.isVisible = true;
			var data = convertDataForSendEmail();
			pixerfApiCustomCommissionSvc.contact_us(data).$promise.then(
				function success(data) {
					self.spinner.isVisible = false;
					subsribleNewsLetter(self.user.email);
					clearContactForm();
					form.$setPristine();
					toastr.success("Your information has been successfully sent!");
				},
				function error(err) {
					self.spinner.isVisible = false;
					toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
				}
			)
		}

		function onBookAShootClicked() {
			customCommissionBasicFormPopupSvc.showPopup();
		}

		function homepageBookAShootClicked(from){
			customCommissionBasicFormPopupSvc.showPopup({fromPage: 'home'});
		}

		function ccapageBookAShootClicked(from){
			customCommissionBasicFormPopupSvc.showPopup({fromPage: 'book-a-shoot-page.about-custom-content'});
		}

		function onLaunchAChallenge() {
			$scope.onCtaBtnClicked();
		}

		function onSignUpCreator() {
            $window.event.stopPropagation();
			if (self.loginedUser && self.loginedUser.isContributor ) {
				$state.go("user-home-page.personal.home", {
					id: self.loginedUser.id
				});
			} else {
				signUpPersonalPopupSvc.showPopup();
			}
		}

	}
})();

(function () {
	'use strict';

	angular
	  .module('pixerf')
	  .directive('generalContactForm', generalContactForm);

	function generalContactForm() {

	  var directive = {
		scope: {
            context: "@?",
            onSubmitted: "&?",
			onCtaBtnClicked: "&?"
		},
		restrict: 'E',
		templateUrl: 'app/components/general-contact-form/general-contact-form.html',
		controller: 'generalContactFormCtrl',
		controllerAs: 'vm',
		replace: true
	  };
	  return directive;
	}

  })();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('galleryTileCtrl', galleryTileCtrl);

    galleryTileCtrl.$inject = ['$scope', 'sessionManagerSvc', '$state', 'pathUtils'];

    function galleryTileCtrl($scope, sessionManagerSvc, $state, pathUtils) {

        var self = this;
        self.loginUser = sessionManagerSvc.getCurrentLoginUser().data;
        self.onShowcasedGalleryBtnClicked = onShowcasedGalleryBtnClicked;
        self.galleries = $scope.galleries;
        self.onGalleryClicked = onGalleryClicked;

        generateFakeImgs();

        function generateFakeImgs(){
            self.galleryThumbnails = [];
            var thumbnailsLength = $scope.gallery.media.length < 3 ? $scope.gallery.media.length : 3;
            for(var i = 0; i < thumbnailsLength; i++){
                if (!$scope.gallery.media[i].id || /\s/.test($scope.gallery.media[i].id)) {
                    //null id or it has any kind of whitespace
                    Sentry.captureException($scope.gallery);
                }
                self.galleryThumbnails.push({id: i, photo: pathUtils.buildFilePath($scope.gallery.media[i].id, "x400")});
            }
            if(!self.galleryThumbnails.length){
                self.galleryThumbnails.push({id: 0});
            }
        }

        function onShowcasedGalleryBtnClicked(gallery){
			deselectShowcaseGallery(gallery);
		}

		function deselectShowcaseGallery(showcaseGallery){
			for(var i = 0; i < self.galleries.length; i++){
				if(self.galleries[i].id != showcaseGallery.id){
					self.galleries[i].is_showcase = false;
				}
			}
        }

        function onGalleryClicked(gallery) {
			$state.go('gallery', { id: gallery.id })
		}
    }
})();
(function () {
	'use strict';

	angular
	  .module('pixerf')
	  .directive('galleryTile', galleryTile);

	function galleryTile() {

	  var directive = {
		scope: {
			gallery: "=",
			onStaredToggled: '&',
			onGalleryClicked: '&',
			galleries: "=",
			options: "="
		},
		templateUrl: 'app/components/gallery-tile/gallery-tile.html',
		restrict: 'E',
		controller: 'galleryTileCtrl',
		controllerAs: 'vm',
		replace: true
	  };
	  return directive;
	}

  })();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('galleryGridCtrl', galleryGridCtrl);

    galleryGridCtrl.$inject = ['$scope', 'pixerfApiGallerySvc', 'pagingUtils', 'toastr', '$q', 'sessionManagerSvc', 'pixerfApiMediaSvc', 
        'systemUtils', 'imageUtils'];

    function galleryGridCtrl($scope, pixerfApiGallerySvc, pagingUtils, toastr, $q, sessionManagerSvc, pixerfApiMediaSvc, 
        systemUtils, imageUtils) {

        var self = this;
        self.galleries =  null;
        self.spinner = {isVisible: false};
        self.isLastPage = false;
        self.searchParams = null;

        self.fetchGalleries = fetchGalleries;
		self.fetchMoreGalleries = fetchMoreGalleries;
		self.onShowcasedGalleryBtnClicked = onShowcasedGalleryBtnClicked;
		self.addGallery = addGallery;
        self.loginUser = sessionManagerSvc.getCurrentLoginUser().data;

        $scope.instance = self;

		function onShowcasedGalleryBtnClicked(gallery){
			deselectShowcaseGallery(gallery);
		}

		function deselectShowcaseGallery(showcaseGallery){
			for(var i = 0; i < self.galleries.length; i++){
				if(self.galleries[i].id != showcaseGallery.id){
					self.galleries[i].is_showcase = false;
				}
			}
		}

        function fetchGalleries(params, isFresh){
            var def = $q.defer();

            if(isFresh){
                reset();
            }
            self.searchParams = params;
            if(self.firstPageNumber === -1) self.firstPageNumber = self.searchParams.page;
            var action = "getUserGalleries";
            if(self.searchParams.type === "pixerf" || self.searchParams.type === "signature"){
                action = "query";
            }
            if(self.searchParams.type === "similar"){
                delete self.searchParams.type;
                action = "getMoreLikeThis";
                self.searchParams.id = params.id;
            }
            self.spinner.isVisible = true;
            pixerfApiGallerySvc[action](params).$promise.then(function(response){
                if(angular.isDefined($scope.onScrollToGallery)){
                    registerScrollSpy(response.data);
                }
                def.resolve(response);
                if(isFresh) self.galleries = [];
                if(response && response.data && response.data.length > 0){
                    self.galleries = self.galleries.concat(response.data);
                    self.galleries = setDefaultCovers(self.galleries);
                }
                self.isLastPage = pagingUtils.isNoMorePageToLoad(self.searchParams.page, response);
                self.totalPage = pagingUtils.getTotalPage(response);
                self.spinner.isVisible = false;
            }, function(err){
                def.reject(err);
                toastr.error('Failed to get galleries');
                self.spinner.isVisible = false;
            });
            return def.promise;
        }

        function setDefaultCovers(data){
			var defaultPhotoColorArray = imageUtils.getDefaultPhotoColorArray();
			var count = 0;
			for(var i =0; i < data.length; i++){
                data[i].showThumbnail = true;
				if( !data[i].thumbnailPath || data[i].thumbnailPath == '""'){
                    data[i].showThumbnail = false;
					data[i].defaultBackgroundColor = defaultPhotoColorArray[count];
					count = (count >= (defaultPhotoColorArray.length - 1)) ? 0 : (count + 1);
				}
			}
			return data;
		} 
        function fetchMoreGalleries(){
            if(self.spinner.isVisible) return;
            if(self.isLastPage) return;
            self.searchParams.page ++;
            fetchGalleries(self.searchParams);
            if($scope.onLoadMorePage){
                $scope.onLoadMorePage({page: self.searchParams.page});
            }
        }
        function addGallery(gallery){
            self.galleries.unshift(gallery);
        }
        function registerScrollSpy(galleries){
            for (var i = 0; i < galleries.length; i ++){
                var gallery = galleries[i];
                gallery.onScrollTo = '';
                gallery.scrollSpyId = undefined;
                gallery.pixerfScrollSpyDirection = undefined;
                gallery.isFirstSpyItem = undefined;
                gallery.isLastSpyItem = undefined;
                if(i === 0){
                    gallery.scrollSpyId = new Date().getTime() + "-" + gallery.id;
                    gallery.onScrollTo =(function(page){
                        var px = page;
                        return function(){
                            $scope.onScrollToGallery({page: px});
                        }
                    })(self.searchParams.page);
                    gallery.pixerfScrollSpyDirection = 'down';
                    if(self.searchParams.page === self.firstPageNumber){
                        gallery.pixerfScrollSpyDirection = 'both';
                        gallery.isFirstSpyItem = true;
                    }
                }
                if(i === galleries.length - 1) {
                    gallery.scrollSpyId = new Date().getTime() + "-" + gallery.id;
                    gallery.onScrollTo =(function(page){
                        var px = page;
                        return function(){
                        $scope.onScrollToGallery({page: px});
                        }
                    })(self.searchParams.page);
                    gallery.pixerfScrollSpyDirection = 'up';
                    if(self.isNoMorePhotoToLoad){
                        gallery.isLastSpyItem = true;
                        gallery.pixerfScrollSpyDirection = 'both';
                    }
                }
            }
        }
        function reset(){
            self.firstPageNumber = -1;
        }
    }
})();

(function () {
  'use strict';

  angular
    .module('pixerf')
    .directive('galleryGrid', galleryGrid);
  galleryGrid.$inject = ['$location']
  function galleryGrid($location) {

    var directive = {
      scope: {
          owner: "=",
          instance: "=",
          context: '=',
          onGalleryClicked: "&",
          onStaredToggled: '&',
          onLoadMorePage: '&?',
          onScrollToGallery: '&?',
          onScrollToSectionId: '@',
          onScrollOffsetTop: '@',
          showOnRow: "@?"
      },
      restrict: 'E',
      transclude: true,
      templateUrl: 'app/components/gallery-grid/gallery-grid.html',
      controller: 'galleryGridCtrl',
      controllerAs: 'vm',
      replace: true,
      link: function(scope, attr){
          if(!angular.isDefined(attr.onGalleryClicked)) {
              scope.onGalleryClicked = function(param){
                  $location.path('/gallery/' + param.gallery.id);
              }
          }
      }
    };
    return directive;
  }

})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('galleriesListSliderCtrl', galleriesListSliderCtrl);

	galleriesListSliderCtrl.$inject = ['$scope', 'createGallerySvc', '$timeout', 'toastr', '$q', 
		'pixerfApiGallerySvc', 'sessionManagerSvc', 'pagingUtils', 'systemUtils', '$state', 'imageUtils'];

	function galleriesListSliderCtrl($scope, createGallerySvc, $timeout, toastr, $q, 
		pixerfApiGallerySvc, sessionManagerSvc, pagingUtils, systemUtils, $state, imageUtils) {

		var self = this;
		self.onCreateGalleryBtnClicked = onCreateGalleryBtnClicked;
		self.loginUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.galleryType = $scope.galleryType;
		self.isMine = $scope.isMine;
		self.fetchGalleries = fetchGalleries;
		self.spinner = {isVisible: false};
		self.currentIndex = 0;
		self.galleries = [];
		self.searchParams = null;
		self.owner = $scope.owner;
		self.showSlick = false;

		$scope.galleryGrid = self;

		$timeout(function() {
			self.slickReady = true;
		});

		genTextAsContext();

		self.carouselConfig = {
			slidesToShow: 3,
			slidesToScroll: 3,
			responsive: [{
				breakpoint: 992,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2
				}
			}, {
				breakpoint: 480,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1
				}
			}]
		};

		self.slickConfig = {
			responsive: [{
				breakpoint: 1200,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 3
				}
			}, {
				breakpoint: 1024,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2
				}
			}, {
				breakpoint: 480,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1
				}
			}],
			event: {
				afterChange: function (event) {
					self.currentSlide = Math.ceil(event.currentSlide / event.slick.options.slidesToShow) + 1;
					systemUtils.digest($scope);
				},
				init: function(event){
					self.slideToShow = event.slick.options.slidesToShow;
					self.totalSlideShow = Math.ceil(event.slick.slideCount / event.slick.options.slidesToShow);
					self.currentSlide = Math.ceil(event.slick.currentSlide / event.slick.options.slidesToShow) + 1;
				},
				breakpoint: function(event){
					self.slideToShow = event.slick.options.slidesToShow;
					self.totalSlideShow = Math.ceil(event.slick.slideCount / event.slick.options.slidesToShow);
					systemUtils.digest($scope);
				}
			}
		};

		function genTextAsContext() {
			if ($scope.galleryType === 'default') {
				self.galleriesTitle = self.isMine ? 'my-galleries' : 'galleries';
				self.navSliderClass = 'galleries';
				self.createGalleryTitle = 'create-new-gallery';
				self.emptyText = {
					heading: 'Get sorted now',
					description: 'create-new-gallery-description',
					guestHeading: self.owner.displayName + " hasn't created any Galleries yet.",
					guestDescription: 'Follow ' + self.owner.displayName + ' and get notified when they create a new Gallery.'
				};
			} else if ($scope.galleryType === 'curated') {
				self.galleriesTitle = 'curated-galleries';
				self.navSliderClass = 'curated';
				self.createGalleryTitle = 'curate-new-gallery';
				self.emptyText = {
					heading: 'Be discovered in the Marketplace',
					description: 'curate-new-gallery-description',
					guestHeading: self.owner.displayName + " hasn't curated any Galleries yet.",
					guestDescription: 'Follow ' + self.owner.displayName + ' and get notified when they curate a new Gallery.'
				};
			} else if ($scope.galleryType === 'following') {
				self.galleriesTitle = 'following-galleries';
				self.navSliderClass = 'following';
				self.createGalleryTitle = 'discover-gallery';
				self.emptyText = {
					heading: 'Check out other Pixerfers',
					description: 'discover-gallery-description',
					guestHeading: self.owner.displayName + " hasn't followed any Galleries yet.",
					guestDescription: 'Follow ' + self.owner.displayName + ' and get notified when they follow a new Gallery.'
				};
			}
		}

		function onCreateGalleryBtnClicked(galleryType) {
			if(galleryType === 'following'){
				return	$state.go('buy-stock-page.galleries.pixerfer-galleries');
			}
			var modal = createGallerySvc.showCreateGalleryModal({
				type: self.galleryType,
				overridSuccessMsg: true
			});
			modal.result.then(function (newCreatedGallery) {
				self.slickReady = false;
				self.totalCount++;
				self.galleries.unshift(newCreatedGallery);
				$timeout(function() {
					self.slickReady = true;
				});
			});
		}

		function fetchGalleries(params, isFresh) {
			var def = $q.defer();
			if(isFresh){
                reset();
            }
            self.searchParams = params;
			if (self.firstPageNumber === -1) self.firstPageNumber = self.searchParams.page;

			self.spinner.isVisible = true;
			pixerfApiGallerySvc["getUserGalleries"](self.searchParams).$promise.then(function (response) {
				def.resolve(response);
				if (isFresh) self.galleries = [];
				if (response && response.data && response.data.length > 0) {
					self.galleries = self.galleries.concat(response.data);
					self.galleries = setDefaultCovers(self.galleries);
				}
				self.isLastPage = pagingUtils.isNoMorePageToLoad(self.searchParams.page, response);
				self.totalPage = pagingUtils.getTotalPage(response);
				self.totalCount = pagingUtils.getTotalCount(response);
				$timeout(function(){
					self.showSlick = true;
					self.spinner.isVisible = false;
				});
			}, function (err) {
				def.reject(err);
				toastr.error('Failed to get galleries');
			});
			return def.promise;
		}

		function setDefaultCovers(data){
			var defaultPhotoColorArray = imageUtils.getDefaultPhotoColorArray();
			var count = 0;
			for(var i =0; i < data.length; i++){
					data[i].showThumbnail = true;
				if( !data[i].thumbnailPath || data[i].thumbnailPath == '""'){
					data[i].defaultBackgroundColor = defaultPhotoColorArray[count];
					data[i].showThumbnail = false;
					count = (count >= (defaultPhotoColorArray.length - 1)) ? 0 : (count + 1);
				}
			}
			return data;
		}

		function reset(){
            self.firstPageNumber = -1;
		}
	}
})();

(function () {
	'use strict';

	angular
	  .module('pixerf')
	  .directive('galleriesListSlider', galleriesListSlider);

	function galleriesListSlider() {

	  var directive = {
		scope: {
			galleryGrid: "=",
			galleryType: "@",
			isMine: "=",
			owner: "=",
			onGalleryClicked: "&"
		},
		templateUrl: 'app/components/galleries-list-slider/galleries-list-slider.html',
		restrict: 'E',
		controller: 'galleriesListSliderCtrl',
		controllerAs: 'vm',
		replace: true
	  };
	  return directive;
	}

  })();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .factory('galleriesListSvc', galleriesListSvc);

    galleriesListSvc.$inject = ['pixerfApiGallerySvc', 'toastr'];

    function galleriesListSvc(pixerfApiGallerySvc, toastr) {

        var mGalleries = {
           data: null
        };
        var mCurrentPage = {
            data: 0
        };
        var mTotalPage = {
            data: 0
        };
        var mIsLastPage = {
            data: false
        };
        function getGalleries(type) {
            return mGalleries;
        }
        function setGalleries(value){
            mGalleries.data = value;
        }

        function getCurrentPage() {
            return mCurrentPage;
        }
        function getTotalPage(){
            return mTotalPage;
        }
        function setTotalPage(value){
            mTotalPage.data = value;
        }
        function fetchGallaries(param) {
            return pixerfApiGallerySvc.getUserGalleries(param).$promise;
        }

        function setIsLastPage(value){
            return mIsLastPage.data = value;
        }
        function isLastPage(){
            return mIsLastPage;
        }
        function checkGalleries(galleries, checkedGalleries){
            var addedGallery;
            console.log(checkedGalleries);
            for(var i = 0; i < galleries.length; i ++){
                var gallery = galleries[i];
                addedGallery = _.find(checkedGalleries, function(gl){
                    return gl.id === gallery.id;
                });
                gallery.isSelected  = !!addedGallery ;
            }
        }
        function reset() {
            mGalleries.data = null;
            mCurrentPage.data = 0;
        }
        return {
            getGalleries: getGalleries,
            setGalleries: setGalleries,
            getCurrentPage: getCurrentPage,
            fetchGallaries: fetchGallaries,
            checkGalleries: checkGalleries,
            getTotalPage : getTotalPage,
            setTotalPage : setTotalPage,
            setIsLastPage: setIsLastPage,
            isLastPage: isLastPage

        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('galleriesListCtrl', galleriesListCtrl);

    galleriesListCtrl.$inject = ['$scope', 'galleriesListSvc', 'pagingUtils', 'toastr', 'galleryConst'];

    function galleriesListCtrl( $scope, galleriesListSvc, pagingUtils, toastr, galleryConst) {

        var self = this;

        $scope.instance = self;

        self.onGalleryItemClicked = onGalleryItemClicked;
        self.spinner = {isVisible: false};
        self.galleries = galleriesListSvc.getGalleries();
        self.currentPage = galleriesListSvc.getCurrentPage();
        self.isLastPage = galleriesListSvc.isLastPage();
        self.fetchMoreGallaries = fetchMoreGallaries;
        self.onWindowScroll = onWindowScroll;
        self.searchParams = {};
        self.filterFn = filterFn;
        $scope.$watch("vm.galleries.data", function(newGalleries, galleries){
            if($scope.onGalleriesChanged && newGalleries && newGalleries.length > 0){
                $scope.onGalleriesChanged({galleries: newGalleries});
            }
        })
        $scope.$watch("galleryType", _.debounce(function (newType) {
            $scope.$apply(function(){
                fetchGallaries({
                    type: newType,
                    userid: $scope.user.id
                }, true);
            })
        }, 300))
        function onWindowScroll(){
            $("body").trigger("click");
        }
        function onGalleryItemClicked(evt, gallery){
            if($scope.onGalleryItemClicked){
                $scope.onGalleryItemClicked({evt: evt, gallery: gallery});
            }
        }
        function fetchGallaries(params, isFresh){
            self.searchParams = params;
            if(self.spinner.isVisible) return;
            self.spinner.isVisible = true;
            galleriesListSvc.fetchGallaries(params).then(function(response){
                if(isFresh) self.galleries.data = [];
                self.spinner.isVisible = false;
                self.galleries.data = self.galleries.data.concat(response.data);
                self.isLastPage.data = pagingUtils.isNoMorePageToLoad(self.searchParams.page  ? self.searchParams.page : 1, response);
            }, function(){
                self.spinner.isVisible = false;
                toastr.error('failed to get galleries');
            });
        }
        function fetchMoreGallaries(){
            if(self.spinner.isVisible) return;
            if(self.isLastPage.data) return;
            if(self.searchParams && !self.searchParams.page) self.searchParams.page = 1;
            self.searchParams.page ++;
            fetchGallaries(self.searchParams);
        }
        function filterFn(value, index, array){
            if(!self.galleryType) return true;
            if(self.galleryType === galleryConst.GALLERY_TYPE.CURATED && value.is_curated){
                return true;
            } else if(self.galleryType === galleryConst.GALLERY_TYPE.DEFAULT && !value.is_curated) {
                return true;
            }
            return false;
        }
    }
})();
(function () {
  'use strict';

  angular
    .module('pixerf')
    .directive('galleriesList', galleriesList);

  function galleriesList() {

    var directive = {
      scope: {
        'onGalleryItemClicked': '&',
        'onGalleriesChanged': '&',
        'galleryType': '=',
        'user': '=',
        'instance': '='
      },
      templateUrl: 'app/components/galleries-list/galleries-list.html',
      restrict: 'E',
      controller: 'galleriesListCtrl',
      controllerAs: 'vm',
      replace: true
    };
    return directive;
  }

})();

(function () {

	angular
		.module('pixerf')
		.factory('footerSvc', footerSvc);

	footerSvc.$inject = [];

	function footerSvc() {

		var mNonLoginedChallengeNav = [
			{name: 'Explore Challenges', route:"", href: '#/run-a-challenge-page', className: 'circled-item'},
			{name: 'Live Challenges', route:"", href: '#/run-a-challenge-page/live-challenges'},
			{name: 'Past Challenges', route:"", href: '#/run-a-challenge-page/past-challenges'},
			{name: 'Challenge Agreement', route: "", href: '#/run-a-challenge-page/community-challenge-agreement', className: 'circled-item'}
		]

		var mChallengeContributorNav = [
			{name: 'Explore Challenges', route:"", href: '#/run-a-challenge-page', className: 'circled-item'},
			{name: 'Live Challenges', route:"", href: '#/run-a-challenge-page/live-challenges'},
			{name: 'Joined Challenges',	route: "", href: '#/run-a-challenge-page/joined-challenges'},
			{name: 'Past Challenges', route:"", href: '#/run-a-challenge-page/past-challenges'},
			{name: 'Challenge Agreement', route: "", href: '#/run-a-challenge-page/community-challenge-agreement', className: 'circled-item'}
		]

		var mChallengeBizNav = [
			{name: 'Explore Challenges', route:"", href: '#/run-a-challenge-page', className: 'circled-item'},
			{name: 'Live Challenges', route:"", href: '#/run-a-challenge-page/live-challenges'},
			{name: 'Past Challenges', route:"", href: '#/run-a-challenge-page/past-challenges'},
			{name: 'Challenge Sponsor Agreement', route: "", href: '#/run-a-challenge-page/challenge-sponsor-agreement', className: 'circled-item'}
		]

		var mBuyStockNav = [
			{name: 'Explore Stock', route:"", href: '#/buy-stock-page'},
			{name: 'Trending', route:"", href: '#/buy-stock-page/trending'},
			{name: 'Discover', route:"", href: '#/buy-stock-page/discover'},
			{name: 'Editors\' Pick', route:"", href: '#/buy-stock-page/editor-pick'},
			{name: 'Galleries', route:"", href: '#/buy-stock-page/galleries'}
		]

		var mBusinessNav = [
			{name: 'Explore Business', route:"", href: '#/explore-business'},
			{name: 'Case Studies', route:"", href: '#/explore-business/case-studies'},
			{name: 'Pricing', route:"", href: '#/explore-business/pricing'}
		]

		var mNewsNav = [
			{name: 'XEEK -<br/>Visual. Culture. Tech.', route:"", href: 'https://xerfie.pixerf.com'},
			{name: 'Media', route:"media-page", href: '#/media'}
		]

		var mCreatorsNav = [
			{name: 'Explore Creators', route:"", href: '#/explore-creators-page'},
			{name: 'Live Challenges', route:"", href: '#/run-a-challenge-page/live-challenges'},
			{name: 'About Community', route:"", href: '#/for-creator-page'}
		]

		var mCreatorsContributorsNav = [
			{name: 'Explore Creators', route: "", href: '#/explore-creators-page'},
			{name: 'Live Challenges', route: "", href: '#/run-a-challenge-page/live-challenges'},
			{name: 'Creator Agreement', route: "", href: '#/explore-creators-page/creator-agreement'},
			{name: 'Payout and Pricing', route: "", href: '#/explore-creators-page/payout-and-pricing'}
		]

		var mCompanyNav = [
			{name: 'About', route: "", href: '#/about-pixerf'},
			{name: 'Terms of Use', route: "", href: '#/introduction/company/terms'},
			{name: 'Privacy', route: "", href: '#/introduction/company/privacy'},
			{name: 'License Agreement', route: "", href: '#/introduction/company/license', className: 'circled-item'},
			{name: 'Careers', route: "", href: '#/careers'}
		]

		var mSupportNav = [
			{name: 'FAQs', route: "", href: '#/introduction/support/faq/'},
			{name: 'Releases', route: "", href: '#/introduction/support/releases'},
			{name: 'Email Us', route: "", href: '#/email-us'}
		]

		var mBookaShootNav = [
			{name: 'Explore Custom Content', route:"", href: '#/book-a-shoot-page', className: 'circled-item'}
		]

		function getChallengeNav(){
            return mNonLoginedChallengeNav;
        }

		function getBookaShootNav(){
            return mBookaShootNav;
        }

		function getChallengeContributorNav(){
            return mChallengeContributorNav;
        }

		function getChallengeBizNav(){
            return mChallengeBizNav;
        }

		function getBuyStockNav(){
            return mBuyStockNav;
        }

        function getBusinessNav(){
            return mBusinessNav;
        }

        function getNewsNav(){
            return mNewsNav;
        }

        function getCreatorsNav(){
            return mCreatorsNav;
        }

		function getCreatorsContributorsNav(){
			return mCreatorsContributorsNav;
		}

        function getCompanyNav(){
            return mCompanyNav;
        }

        function getSupportNav(){
            return mSupportNav;
        }

		return {
			getChallengeNav: getChallengeNav,
			getChallengeContributorNav: getChallengeContributorNav,
			getChallengeBizNav: getChallengeBizNav,
			getBuyStockNav: getBuyStockNav,
            getBusinessNav: getBusinessNav,
            getNewsNav: getNewsNav,
            getCreatorsNav: getCreatorsNav,
			getCreatorsContributorsNav: getCreatorsContributorsNav,
            getCompanyNav: getCompanyNav,
            getSupportNav: getSupportNav,
			getBookaShootNav: getBookaShootNav
		};
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('footerCtrl', footerCtrl);

	footerCtrl.$inject = ['footerSvc', 'sessionManagerSvc', '$rootScope', 'messageConst'];

	function footerCtrl(footerSvc, sessionManagerSvc, $rootScope, messageConst) {
		var self = this;
		self.loginUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.challengeNav = footerSvc.getChallengeNav();
		self.buyStockNav = footerSvc.getBuyStockNav();
		self.businessNav = footerSvc.getBusinessNav();
		self.newsNav = footerSvc.getNewsNav();
		self.creatorsNav = footerSvc.getCreatorsNav();
		self.companyNav = footerSvc.getCompanyNav();
		self.supportNav = footerSvc.getSupportNav();
		self.bookaShootNav = footerSvc.getBookaShootNav();

		$rootScope.$on(messageConst.BROADCAST.USER_DATA_CHANGE, function () {
			self.loginUser = sessionManagerSvc.getCurrentLoginUser().data;
			genFooterNav();
			genCreatorsNav();
		})

		init();

		function init(){
			genFooterNav();
			genCreatorsNav();
		}

		function genFooterNav() {
			if (self.loginUser && self.loginUser.isBiz) {
				self.challengeNav = footerSvc.getChallengeBizNav();
			} else if (self.loginUser) {
				self.challengeNav = footerSvc.getChallengeContributorNav();
			} else {
				self.challengeNav = footerSvc.getChallengeNav();
			}
		}

		function genCreatorsNav(){
            if(self.loginUser && self.loginUser.isContributor){
                self.creatorsNav = footerSvc.getCreatorsContributorsNav();
            } else {
                self.creatorsNav = footerSvc.getCreatorsNav();
            }
        }
	}
})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .directive('comFooter', comFooter);

    comFooter.$inject = ['$timeout'];

    function comFooter($timeout) {
        return {
            restrict: 'ACE',
            templateUrl: 'app/components/footer/footer.html',
            controller: 'footerCtrl',
            controllerAs: 'vm',
            link: function($scope){
                var listener = function(event, toState) {

                    $timeout(function() {
                        $scope.isVisible = !(toState.data && toState.data.hideFooter);
                    });
                };

                $scope.$on('$stateChangeSuccess', listener);
            }

        };
    }
})();                                                                                                                                
(function(){

	angular
	  .module('pixerf')
	  .controller('followingTileCtrl', followingTileCtrl);

	  followingTileCtrl.$inject = ['$scope', 'sessionManagerSvc'];

	  function followingTileCtrl($scope, sessionManagerSvc){

		  var self = this;
		  self.loginUser = sessionManagerSvc.getCurrentLoginUser().data;
		  self.isMyProfile =  self.loginnedUser && self.loginnedUser.id === $scope.userData.id;
	  }
  })();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('followingTile', followingTile);

	followingTile.$inject = ['$rootScope', '$interval'];

	function followingTile($rootScope, $interval) {

		var directive = {
			scope: {
				gallery: "=",
				onStaredToggled: '&',
				onGalleryClicked: '&'
			},
			restrict: 'E',
			templateUrl: 'app/components/following-tile/following-tile.html',
			controller: 'followingTileCtrl',
			controllerAs: 'vm',
			replace: true
		};
		return directive;
	}

})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('followGalleryBtnCtrl', followGalleryBtnCtrl);

    followGalleryBtnCtrl.$inject = ['$scope','pixerfApiGallerySvc', 'sessionManagerSvc', 'toastr', 'messageConst', '$translate', '$rootScope', 'translationSvc'];

    function followGalleryBtnCtrl( $scope, pixerfApiGallerySvc, sessionManagerSvc, toastr, messageConst, $translate, $rootScope, translationSvc) {

        var self = this;
        self.isDoingFollow = false;
        self.onFollowClicked = onFollowClicked;

        self.btnLabel = "";

        self.onMouseOver = onMouseOver;
        self.onMouseLeave = onMouseLeave;
        self.isHovering = false;
        self.loginnedUser = sessionManagerSvc.getCurrentLoginUser().data;
        $scope.$watch('gallery', function(newValue, oldValue){
            if(newValue){
                setBtnLabel();
            }
        })

        function updateUserStat(gallery){
            var step = gallery.is_followed ? 1 : -1;
            self.loginnedUser = sessionManagerSvc.getCurrentLoginUser().data;
            self.loginnedUser.stats.following_gallery_count += step;
            sessionManagerSvc.setCurrentLoginUser(self.loginnedUser);
        }
        function onFollowClicked(mGallery){
            var mGallery = $scope.gallery;
            self.isDoingFollow = true;
            var action = mGallery.is_followed ? 'delete' : 'save';
            pixerfApiGallerySvc[action]({id: mGallery.id, action: messageConst.FOLLOWINGS}, {}).$promise.then(function(respone){
                mGallery.is_followed = !mGallery.is_followed;
                updateUserStat(mGallery);
                self.isDoingFollow = false;
                setBtnLabel();
                self.isHovering = false;
            }, function(){
                toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
                self.isDoingFollow = false;
            })
        }
        function setBtnLabel(){
            self.btnLabel = $scope.gallery.is_followed ? $translate.instant(messageConst.FOLLOWING) : $translate.instant(messageConst.FOLLOW);
        }
        function onMouseOver(){
            if(!$scope.gallery || !$scope.gallery.is_followed) return;
            self.isHovering = true;
            self.btnLabel =  $translate.instant(messageConst.UNFOLLOW);
        }
        function onMouseLeave(){
            self.isHovering = false;
            if(!$scope.gallery || !$scope.gallery.is_followed) return;
            self.btnLabel =  $translate.instant(messageConst.FOLLOWING);
        }
    }
})();

(function () {
  'use strict';

  angular
    .module('pixerf')
    .directive('followGalleryBtn', followGalleryBtn);

  function followGalleryBtn() {

    var directive = {
      scope: {
        "gallery" : "=",
      },
      restrict: 'E',
      templateUrl: 'app/components/follow-gallery-btn/follow-gallery-btn.html',
      controller: 'followGalleryBtnCtrl',
      controllerAs: 'vm',
      replace: true
    };
    return directive;
  }

})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('followBtnCtrl', followBtnCtrl);

    followBtnCtrl.$inject = ['$scope','pixerfApiUserSvc', 'sessionManagerSvc', 'toastr', 'messageConst', '$translate', '$rootScope', 'translationSvc'];

    function followBtnCtrl( $scope, pixerfApiUserSvc, sessionManagerSvc, toastr, messageConst, $translate, $rootScope, translationSvc) {

        var self = this;
        self.isDoingFollow = false;
        self.onFollowClicked = onFollowClicked;
        self.btnLabel = "";

        self.onMouseOver = onMouseOver;
        self.onMouseLeave = onMouseLeave;
        self.isHovering = false;

        var mLoginnedUser = sessionManagerSvc.getCurrentLoginUser().data;
        self.loginUser = mLoginnedUser;

        self.isMine = mLoginnedUser ? mLoginnedUser.id === $scope.user.id : false;

        $scope.$watch('user.is_followed', function(newValue, oldValue){
            if($scope.user){
                setBtnLabel();
            }
        });

        function onFollowClicked(){
            if(self.isDoingFollow) return;
            self.isDoingFollow = true;
            var action = $scope.user.is_followed ? 'delete' : 'save';
            pixerfApiUserSvc[action]({id: $scope.user.id, action: 'followings'}, {}).$promise.then(function(respone){
                self.isDoingFollow = false;
                var loginUser = $scope.loginUser ? $scope.loginUser : mLoginnedUser;
                $scope.user.is_followed = !$scope.user.is_followed;
                var step = $scope.user.is_followed ? 1 : -1
                if($scope.user.stats) $scope.user.stats.follower_count += step;
                if(loginUser) loginUser.stats.following_count += step;
                sessionManagerSvc.setCurrentLoginUser(loginUser);
                if($scope.onFollowStatusChanged) $scope.onFollowStatusChanged({status: $scope.user.is_followed});
                setBtnLabel();
                self.isHovering = false;
            }, function(){
                self.isDoingFollow = false;
                toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
            })
        }
        function setBtnLabel(){
            self.btnLabel = $scope.user.is_followed ? $translate.instant(messageConst.FOLLOWING_BTN) : $translate.instant(messageConst.FOLLOW);
        }
        function onMouseOver(){
            if(!$scope.user.is_followed) return;
            self.isHovering = true;
            self.btnLabel =  $translate.instant(messageConst.UNFOLLOW);
        }
        function onMouseLeave(){
            self.isHovering = false;
            if(!$scope.user.is_followed) return;
            self.btnLabel =  $translate.instant(messageConst.FOLLOWING_BTN);
        }
    }
})();

(function () {
  'use strict';

  angular
    .module('pixerf')
    .directive('followBtn', followBtn);

  function followBtn() {

    var directive = {
      scope: {
        "user" : "=",
        "visibility": "=",
        "loginUser": "=",
        "onFollowStatusChanged": "&",
        "isIconMode": "="
      },
      restrict: 'E',
      templateUrl: 'app/components/follow-btn/follow-btn.html',
      controller: 'followBtnCtrl',
      controllerAs: 'vm',
      replace: true
    };
    return directive;
  }

})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('flexGrid', flexGrid);

	flexGrid.$inject = ['$timeout'];

	function flexGrid($timeout) {
		var directive = {
			restrict: 'AE',
			require: "?ngModel",
			link: function ($scope, element, attrs) {
				var ele = element;
				var genGrid = _.debounce(genPhotoGrid, 100);
				$scope.$watch(attrs['ngModel'], function (newVal, oldVal) {
					if (!Array.isArray(newVal) || (Array.isArray(newVal) && newVal.length)) {
						genGrid();
					}
				}, true);

				function genPhotoGrid(){
					ele.justifiedGallery({
						rowHeight: attrs.rowheight ? attrs.rowheight : 150,
						margins: attrs.margins ? attrs.margins : 10,
						lastRow: attrs.lastrow ? attrs.lastrow : 'nojustify',
						refreshSensitivity: attrs.sensitivity ? attrs.sensitivity : 20,
						border: attrs.borderStyle ? attrs.borderStyle : 0,
					})
				}
			}
		};
		return directive;
	}
})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('flagBtnCtrl', flagBtnCtrl);

		flagBtnCtrl.$inject = ['$scope','pixerfApiUserSvc', 'toastr', 'sessionManagerSvc', 'pixerfConfirmPopupSvc', 'translationSvc'];

    function flagBtnCtrl( $scope, pixerfApiUserSvc, toastr, sessionManagerSvc, pixerfConfirmPopupSvc, translationSvc) {

		var self = this;
		self.isLoginedUser = sessionManagerSvc.getCurrentLoginUser();
        self.isWorking = false;
        self.onSuggestClicked = onSuggestClicked;
        self.btnLabel = "";

        self.onMouseOver = onMouseOver;
        self.onMouseLeave = onMouseLeave;
        self.isHovering = false;

        $scope.$watch('user.is_flagged', function(newValue, oldValue){
            if($scope.user){
                setBtnLabel();
            }
        });

        function onSuggestClicked(){
			if(self.isWorking) return;
			self.isWorking = true;
			if($scope.user.is_flagged){
				var pixerfConfirmPopup = pixerfConfirmPopupSvc.showPopup({
					hideTitle: true,
					hideConfirmText: true,
					message: "Are you sure you want to unflag this user?",
					okFn: function(){
						return pixerfApiUserSvc.toogle_flag({id: $scope.user.id}, {}).$promise.then(
							function success(){
								$scope.user.is_flagged = false;
							},
							function err(){
								toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
							}
						);
					},
					okFnCallback: function(){
						self.isWorking = false;
						if($scope.onStatusChanged) $scope.onStatusChanged({status: $scope.user.is_flagged});
						setBtnLabel();
						toastr.success("This user has been successfully unflag");
						self.isHovering = false;
					}
				})

				pixerfConfirmPopup.result.then(function(){},function(){
					self.isWorking = false;
				});

			} else {
				pixerfApiUserSvc.toogle_flag({id: $scope.user.id}, {}).$promise.then(function(respone){
					self.isWorking = false;
					$scope.user.is_flagged = true;
					if($scope.onStatusChanged) $scope.onStatusChanged({status: $scope.user.is_flagged});
					setBtnLabel();
					toastr.success("This user has been successfully flagged!");
					self.isHovering = false;
				}, function(){
					self.isWorking = false;
					toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
				})
			}
        }
        function setBtnLabel(){
            self.btnLabel = $scope.user.is_flagged ? "Flagged User" : "Flag User";
        }
        function onMouseOver(){
            if(!$scope.user.is_flagged) return;
            self.isHovering = true;
            self.btnLabel =  "Unflag User";
        }
        function onMouseLeave(){
            self.isHovering = false;
            if(!$scope.user.is_flagged) return;
            self.btnLabel =  "Flagged User";
        }
    }
})();

(function () {
  'use strict';

  angular
    .module('pixerf')
    .directive('flagBtn', flagBtn);

  function flagBtn() {

    var directive = {
      scope: {
        "user" : "=",
        "onStatusChanged": "&"
      },
      restrict: 'E',
      templateUrl: 'app/components/flag-btn/flag-btn.html',
      controller: 'flagBtnCtrl',
      controllerAs: 'vm',
      replace: true
    };
    return directive;
  }

})();

(function () {

	angular
		.module('pixerf')
		.controller('feedTileGridCtrl', feedTileGridCtrl);

	feedTileGridCtrl.$inject = ['$scope'];

	function feedTileGridCtrl($scope) {

		var self = this;
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('feedTileGrid', feedTileGrid);

	feedTileGrid.$inject = [];
	function feedTileGrid() {

		var directive = {
			scope: {
				feeds: "="
			},
			restrict: 'E',
			templateUrl: 'app/components/feed-tile-grid/feed-tile-grid.html',
			controller: 'feedTileGridCtrl',
			controllerAs: 'vm',
			replace: true
		};
		return directive;
	}

})();

(function () {

	angular
		.module('pixerf')
		.controller('feedTileCtrl', feedTileCtrl);

	feedTileCtrl.$inject = ['$scope'];

	function feedTileCtrl($scope) {

		var self = this;
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('feedTile', feedTile);

	feedTile.$inject = [];
	function feedTile() {

		var directive = {
			scope: {
				feed: "=",
				layoutCover: "@"
			},
			restrict: 'E',
			templateUrl: 'app/components/feed-tile/feed-tile.html',
			controller: 'feedTileCtrl',
			controllerAs: 'vm',
			replace: true
		};
		return directive;
	}

})();

(function(){

	angular
	  .module('pixerf')
	  .controller('featuredPhotographersCarouselCtrl', featuredPhotographersCarouselCtrl);

	  featuredPhotographersCarouselCtrl.$inject = ['$scope', 'systemUtils'];

	  function featuredPhotographersCarouselCtrl($scope, systemUtils){

		var self = this;
		self.photographers = $scope.data || [];
		self.nextBtnClicked = nextBtnClicked;
		self.prevBtnClicked = prevBtnClicked;
		self.slickConfig = {
			responsive: [{
				breakpoint: 1200,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 3
				}
			}, {
				breakpoint: 1024,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2
				}
			}, {
				breakpoint: 480,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1
				}
			}],
			event: {
				afterChange: function (event) {
					// self.currentSlide = Math.ceil(event.currentSlide / event.slick.options.slidesToShow) + 1;
					self.currentSlide = event.currentSlide;
					systemUtils.digest($scope);
				},
				beforeChange: function(event, slick, currentSlide, nextSlide){

				},
				init: function(event){
					self.slideToShow = event.slick.options.slidesToShow;
					self.totalSlideShow = event.slick.slideCount - event.slick.options.slidesToShow;
					// self.currentSlide = Math.ceil(event.slick.currentSlide / event.slick.options.slidesToShow) + 1;
					self.currentSlide = event.currentSlide || 2;
				},
				breakpoint: function(event){
					self.slideToShow = event.slick.options.slidesToShow;
					self.totalSlideShow = Math.ceil(event.slick.slideCount / event.slick.options.slidesToShow);
					systemUtils.digest($scope);
				}
			}
		};

		function nextBtnClicked(){
			$('.featured-photographers-carousel__slick').slick('slickGoTo', self.currentSlide + parseInt(4));
		}

		function prevBtnClicked(){
			$('.featured-photographers-carousel__slick').slick('slickGoTo', self.currentSlide - parseInt(4));
		}
	  }
  })();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('featuredPhotographersCarousel', featuredPhotographersCarousel);

	featuredPhotographersCarousel.$inject = ['$rootScope', '$interval'];
	function featuredPhotographersCarousel($rootScope, $interval) {

		var directive = {
			scope: {
				data: "="
			},
			restrict: 'E',
			templateUrl: 'app/components/featured-photographers-carousel/featured-photographers-carousel.html',
			controller: 'featuredPhotographersCarouselCtrl',
			controllerAs: 'vm',
			replace: true
		};
		return directive;
	}

})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('featuredPhotographerGridCtrl', featuredPhotographerGridCtrl);

    featuredPhotographerGridCtrl.$inject = ['pixerfApiPhotographerSvc', '$scope', 'pagingUtils', 'toastr', '$q', 'numberUtils', 'translationSvc'];

    function featuredPhotographerGridCtrl(pixerfApiPhotographerSvc, $scope, pagingUtils, toastr, $q, numberUtils, translationSvc) {

		var self = this;

        $scope.instance = self;
        self.getPhotographers = getPhotographers;
        self.spinner = {isVisible: false};
        self.isLastPage = false;
        self.photographers = null;
        self.fetchMore = fetchMore;
        self.unit = null;
        var defaultSearch = {
            page: 0,
            action: $scope.type,
            order: $scope.order
		};
        self.searchParams = $scope.searchParams ? $scope.searchParams : defaultSearch;

		getPhotographers(buildParams(numberUtils.parseInt($scope.page)), true);

        function getPhotographers(params, isFresh){
            var def = $q.defer();
            self.spinner.isVisible = true;
            pixerfApiPhotographerSvc.get(params).$promise.then(function(response){
                if(isFresh){
                    self.photographers = [];
                }
                self.unit = params.order;
                self.photographers = self.photographers.concat(response.data);
                self.isLastPage = pagingUtils.isNoMorePageToLoad(params.page, response);
                self.spinner.isVisible = false;
                self.searchParams.page = numberUtils.parseInt(params.page);
                self.searchParams.order = params.order;
                def.resolve();
            }, function(){
                self.spinner.isVisible = false;
                toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
                def.reject();
            });
            return def.promise;
        }
        function fetchMore(){
            if(self.spinner.isVisible){
                return;
            }
            getPhotographers(buildParams(self.searchParams.page + 1)).then(function(){
                if($scope.onPaging){
                    $scope.onPaging({page: self.searchParams.page});
                }
            });
        }
        function buildParams(pageNumber){
            var params = {
                page: pageNumber,
                action: self.searchParams.action,
                order: self.searchParams.order
            }
            if(self.searchParams && self.searchParams.countries){
                params.countries = self.searchParams.countries;
            }
            if(self.searchParams && self.searchParams.specialities){
                params.specialities = self.searchParams.specialities;
            }
            return params;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .directive('featuredPhotographerGrid', featuredPhotographerGrid);
    featuredPhotographerGrid.$inject = ['$timeout'];
    function featuredPhotographerGrid($timeout) {
        return {
            restrict: 'E',
            replace: true,
            templateUrl: 'app/components/featured-photographer-grid/featured-photographer-grid.html',
            controller: 'featuredPhotographerGridCtrl',
            controllerAs: "vm",
            scope: {
                type: '@',
                page: '@',
                order: '@',
                instance: '=',
                onPaging: '&?',
                endingMessage: '@',
                searchParams: '=?'
            }
        };
    }
})();
(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('exploreCreatorsGridCarouselCtrl', exploreCreatorsGridCarouselCtrl);

	exploreCreatorsGridCarouselCtrl.$inject = ['$scope', 'systemUtils', 'carouselPhotoPopupSvc', '$timeout'];

	function exploreCreatorsGridCarouselCtrl($scope, systemUtils, carouselPhotoPopupSvc, $timeout) {


		var self = this;
		self.onNextSlide = onNextSlide;
		self.onPreviousSlide = onPreviousSlide;
		self.showPhotoPopup = showPhotoPopup;
		self.onNavClicked = onNavClicked;
		self.mobileData = [];
		self.activeIndex = 0;
		self.isActive = isActive;
		self.slideDatas = [{
			id: 1,
			logo: "assets/images/custom-commission-ad/slides/slide-1-logo.jpg",
			indexShowInfo: 5,
			infoLast: false,
			themeColor: "#dbb688",
			slideInfo: {
				logoUrl: "assets/images/explore-creators-grid-carousel/slides/definer-black-logo.png",
				logoUrlMobile: "assets/images/explore-creators-grid-carousel/slides/definer-black-logo-mobile.png",
				header: "The Definer",
				desc: "The Definer Series traces the stories of influential and extraordinary visual creators who have found their true calling through creativity. They are the voice of a generation; the advocate for the invisible; turning craft into purpose.",
			},
			photos: [
				{
					url: "assets/images/explore-creators-grid-carousel/slides/slide-1-1-photo.jpg",
					urlMobile: "assets/images/explore-creators-grid-carousel/slides/slide-1-1-photo-mobile.jpg",
					name: 'MATHIAS HENG',
					country:'AUSTRALIA'
				},
				{
					url: "assets/images/explore-creators-grid-carousel/slides/slide-1-2-photo.jpg",
					urlMobile: "assets/images/explore-creators-grid-carousel/slides/slide-1-2-photo-mobile.jpg",
					name: 'TOM POTISIT',
					country:'THAILAND',
				},
				{
					url: "assets/images/explore-creators-grid-carousel/slides/slide-1-3-photo.jpg",
					urlMobile: "assets/images/explore-creators-grid-carousel/slides/slide-1-3-photo-mobile.jpg",
					name: 'NADIRAH ZAKARIYAH',
					country:'MALAYSIA',
				},
				{
					url: "assets/images/explore-creators-grid-carousel/slides/slide-1-4-photo.jpg",
					urlMobile: "assets/images/explore-creators-grid-carousel/slides/slide-1-4-photo-mobile.jpg",
					name: 'YAMAN IBRAHIM',
					country:'MALAYSIA',
				},
			]
		},
		{
			id: 2,
			logo: "assets/images/custom-commission-ad/slides/slide-2-logo.jpg",
			indexShowInfo: 5,
			infoLast: true,
			themeColor: "#a4d9ea",
			slideInfo: {
				logoUrl: "assets/images/explore-creators-grid-carousel/slides/ci-logo.svg",
				logoUrlMobile: "assets/images/explore-creators-grid-carousel/slides/ci-logo-mobile.svg",
				header: "Community Leader",
				desc: "Do you represent your local community of photographers, videographers and illustrators? Do you seek activities, training, workshops, gatherings, merchandise, and partnerships for your members to participate?",
			},
			photos: [
				{
					url: "assets/images/explore-creators-grid-carousel/slides/slide-2-1-photo.jpg",
					urlMobile: "assets/images/explore-creators-grid-carousel/slides/slide-2-1-photo-mobile.jpg",
				},
				{
					url: "assets/images/explore-creators-grid-carousel/slides/slide-2-2-photo.jpg",
					urlMobile: "assets/images/explore-creators-grid-carousel/slides/slide-2-2-photo-mobile.jpg",
				},
				{
					url: "assets/images/explore-creators-grid-carousel/slides/slide-2-3-photo.jpg",
					urlMobile: "assets/images/explore-creators-grid-carousel/slides/slide-2-3-photo-mobile.jpg",
				},
				{
					url: "assets/images/explore-creators-grid-carousel/slides/slide-2-4-photo.jpg",
					urlMobile: "assets/images/explore-creators-grid-carousel/slides/slide-2-4-photo.jpg",
				},
				{
					url: "assets/images/explore-creators-grid-carousel/slides/slide-2-5-photo.jpg",
					urlMobile: "assets/images/explore-creators-grid-carousel/slides/slide-2-5-photo.jpg",
				},
				{
					url: "assets/images/explore-creators-grid-carousel/slides/slide-2-6-photo.jpg",
					urlMobile: "assets/images/explore-creators-grid-carousel/slides/slide-2-6-photo.jpg",
				}
			]
		},
		{
			id: 3,
			logo: "assets/images/custom-commission-ad/slides/slide-3-logo.jpg",
			indexShowInfo: 5,
			infoLast: true,
			themeColor: "#ccc96b",
			slideInfo: {
				logoUrl: "assets/images/explore-creators-grid-carousel/slides/am-logo.svg",
				logoUrlMobile: "assets/images/explore-creators-grid-carousel/slides/am-logo-mobile.svg",
				header: "Ambassador",
				desc: "We are seeking passionate and outstanding Asian creators to fly the flag with PIXERF. With our combined experience, network and hunger, we can elevate the status and value of the visual industry for the next generation.",
			},
			photos: [
				{
					url: "assets/images/explore-creators-grid-carousel/slides/slide-3-1-photo.jpg",
					urlMobile: "assets/images/explore-creators-grid-carousel/slides/slide-3-1-photo-mobile.jpg",
					name: 'SHAVONNE WONG',
					country:'SINGAPORE',
				},
				{
					url: "assets/images/explore-creators-grid-carousel/slides/slide-3-2-photo.jpg",
					urlMobile: "assets/images/explore-creators-grid-carousel/slides/slide-3-4-photo-mobile.jpg",
					name: 'SILVA ANDRIANI',
					country:'INDONESIA',
				},
				{
					url: "assets/images/explore-creators-grid-carousel/slides/slide-3-3-photo.jpg",
					urlMobile: "assets/images/explore-creators-grid-carousel/slides/slide-3-3-photo-mobile.jpg",
					name: 'CK NG',
					country:'MALAYSIA',
				},
				{
					url: "assets/images/explore-creators-grid-carousel/slides/slide-3-4-photo.jpg",
					urlMobile: "assets/images/explore-creators-grid-carousel/slides/slide-3-4-photo-mobile.jpg",
					name: 'INDRA SUPRIADI',
					country:'INDONESIA',
				},
				{
					url: "assets/images/explore-creators-grid-carousel/slides/slide-3-5-photo.jpg",
					urlMobile: "assets/images/explore-creators-grid-carousel/slides/slide-3-5-photo.jpg",
					name: 'SHAFIQ SALEH',
					country:'MALAYSIA',
				},
				{
					url: "assets/images/explore-creators-grid-carousel/slides/slide-3-6-photo.jpg",
					urlMobile: "assets/images/explore-creators-grid-carousel/slides/slide-3-6-photo.jpg",
					name: 'YIK KEAT LEE',
					country:'SINGAPORE',
				}
			]
		},
		{
			id: 4,
			logo: "assets/images/custom-commission-ad/slides/under-exposed-logo.svg",
			indexShowInfo: 5,
			infoLast: true,
			themeColor: "#ccc96b",
			slideInfo: {
				logoUrl: "assets/images/explore-creators-grid-carousel/slides/under-exposed-logo.svg",
				logoUrlMobile: "assets/images/explore-creators-grid-carousel/slides/under-exposed-logo-mobile.svg",
				header: "UnderExposed",
				desc: "UnderExposed is an ongoing program to search, discover, nurture and expose hidden individuals with a great eye, skill and imagination. It’s not about the follower count; the only thing that matters is your talent.",
			},
			photos: [
				{
					url: "assets/images/explore-creators-grid-carousel/slides/slide-4-1-photo.jpg",
					urlMobile: "assets/images/explore-creators-grid-carousel/slides/slide-4-1-photo-mobile.jpg",
				},
				{
					url: "assets/images/explore-creators-grid-carousel/slides/slide-4-2-photo.jpg",
					urlMobile: "assets/images/explore-creators-grid-carousel/slides/slide-4-2-photo-mobile.jpg",
				},
				{
					url: "assets/images/explore-creators-grid-carousel/slides/slide-4-3-photo.jpg",
					urlMobile: "assets/images/explore-creators-grid-carousel/slides/slide-4-3-photo-mobile.jpg",
				},
				{
					url: "assets/images/explore-creators-grid-carousel/slides/slide-4-4-photo.jpg",
					urlMobile: "assets/images/explore-creators-grid-carousel/slides/slide-4-4-photo.jpg",
				},
				{
					url: "assets/images/explore-creators-grid-carousel/slides/slide-4-5-photo.jpg",
					urlMobile: "assets/images/explore-creators-grid-carousel/slides/slide-4-5-photo.jpg",
				},
				{
					url: "assets/images/explore-creators-grid-carousel/slides/slide-4-6-photo.jpg",
					urlMobile: "assets/images/explore-creators-grid-carousel/slides/slide-4-6-photo.jpg",
				}
			]
		},
		];
		self.slickSetting = {
			onInit: function (slick) {
				self.slick = slick;
				systemUtils.digest($scope);
			}
		}

		function onNextSlide() {
			self.slick.slickNext();
		}

		function onPreviousSlide() {
			self.slick.slickPrev();
		}

		function buildMobileData() {
			self.mobileData = [];
			for (var i = 0; i < self.slideDatas.length; i++) {
				for (var j = 0; j < (self.slideDatas[i].photos).length; j++) {
					self.mobileData.push(self.slideDatas[i].photos[j])
				}
			}
		}

		function showPhotoPopup(photo) {
			carouselPhotoPopupSvc.showPopup({
				windowClass: 'stay-home-stay-creative',
				data: photo
			});
		}

		function onNavClicked(index){
			$('.explore-creators-grid-carousel__slick').slick('slickGoTo', index);
			self.activeIndex = index;
		}

		function isActive(index){
			return index == self.activeIndex;
		}

		init();

		function init() {
			buildMobileData();

			$timeout(function(){
				onNavClicked(0);
			}, 100)

			$('.explore-creators-grid-carousel__slick').on('afterChange', function(event, slick, currentSlide, nextSlide){
				self.activeIndex = currentSlide;
				$scope.$apply()
			  });
		}



	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('exploreCreatorsGridCarousel', exploreCreatorsGridCarousel);

	function exploreCreatorsGridCarousel() {

		var directive = {
			scope: {
				data: "="
			},
			templateUrl: 'app/components/explore-creators-grid-carousel/explore-creators-grid-carousel.html',
			restrict: 'E',
			controller: 'exploreCreatorsGridCarouselCtrl',
			controllerAs: 'vm',
			replace: true
		};
		return directive;
	}

})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('eventPostTileCtrl', eventPostTileCtrl);

	eventPostTileCtrl.$inject = ['$scope', 'confirmPopupSvc', '$q', 'pixerfApiCommunitySvc', 'sessionManagerSvc', 'systemUtils', 'commonConst', 'toastr', 'createEventPostPopupSvc', 'peopleListPopupSvc', 'accountConst', 'pagingUtils'];

	function eventPostTileCtrl($scope, confirmPopupSvc, $q, pixerfApiCommunitySvc, sessionManagerSvc, systemUtils, commonConst, toastr, createEventPostPopupSvc, peopleListPopupSvc, accountConst, pagingUtils) {

		var self = this;
		self.loginUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.post = $scope.post;
		self.isOwner = self.loginUser && self.post.user.id === self.loginUser.id;
		self.isAdmin = self.post.owner.id == self.post.user.id;
		self.isMember = $scope.isMember;
		self.isLiked = false;
		self.isBookmarked = false;
		self.commonConst = commonConst;
		self.fetchMoreEventPostComments = fetchMoreEventPostComments;
		self.onCommentEventPost = onCommentEventPost;
		self.onCommentRemoved = onCommentRemoved;
		self.onLikeToggle = onLikeToggle;
		self.onShowListLike = onShowListLike;
		self.onEditPost = onEditPost;
		self.onRemovePost = onRemovePost;
		self.searchEventPostComments = {
			id: self.post.id,
			page: 1,
			page_size: 5
		}
		self.spinnerComment = {
			isVisible: false
		}

		init();

		function init() {
			self.showAdminLabel = self.isAdmin;
			if (self.post && self.post.inserted_at) {
				self.inserted_at = genDurationText(self.post.inserted_at);
			}
			if (self.loginUser) {
				getEventPostComments(self.searchEventPostComments, true);
			}
		}

		function genDurationText(time) {
			var now = moment.utc().format('DD/MM/YYYY, HH:mm:ss');
			var then = moment(time).format('DD/MM/YYYY, HH:mm:ss');
			var ms = moment(now, "DD/MM/YYYY HH:mm:ss").diff(moment(then, "DD/MM/YYYY HH:mm:ss"));
			var d = moment.duration(ms);

			if (d.days() < 1 && d.hours() < 1 && d.minutes() < 1) {
				return d.seconds() + 'second';
			} else if (d.days() < 1 && d.hours() < 1) {
				return d.minutes() + 'min';
			} else if (d.days() < 1) {
				return d.hours() + 'hrs';
			} else if (d.days() < 30) {
				return d.days() + 'd';
			} else {
				return moment(then).format('DD MMM YYYY');
			}
		}

		function getEventPostComments(params, isFresh) {
			self.searchEventPostComments = params;
			self.isWorking = true;
			self.spinnerComment.isVisible = true;
			pixerfApiCommunitySvc.get_event_post_comments(self.searchEventPostComments).$promise.then(function (res) {
				self.spinnerComment.isVisible = false;
				if (!self.eventPostComments || isFresh) self.eventPostComments = [];
				self.eventPostComments = self.eventPostComments.concat(res.data);
				self.isLastEventPostComments = pagingUtils.isNoMorePageToLoad(self.searchEventPostComments.page, res);
				self.searchEventPostComments.page = params.page + 1;
				self.isWorking = false;
			}).catch(function (err) {
				self.spinnerComment.isVisible = false;
				self.isWorking = false;
				console.log(err);
			})
		}

		function fetchMoreEventPostComments(params) {
			self.searchEventPostComments = params;
			self.isWorking = true;
			self.spinnerComment.isVisible = true;
			pixerfApiCommunitySvc.get_event_post_comments(self.searchEventPostComments).$promise.then(function (res) {
				self.spinnerComment.isVisible = false;
				self.eventPostComments = self.eventPostComments.concat(res.data);
				self.isLastEventPostComments = pagingUtils.isNoMorePageToLoad(self.searchEventPostComments.page, res);
				self.searchEventPostComments.page = params.page + 1;
				self.isWorking = false;
			}).catch(function (err) {
				self.spinnerComment.isVisible = false;
				self.isWorking = false;
				console.log(err);
			})
		}

		function onCommentEventPost(comment) {
			pixerfApiCommunitySvc.comment_event_post({
				id: self.post.id
			}, {
				text: comment
			}).$promise.then(function (res) {
				self.post.reply_count++;
				$('#comment-section-' + self.post.id).collapse('show');
				self.commentText = null;
				self.eventPostComments.push(res.data);
				systemUtils.digest($scope);
			}).catch(function (err) {
				console.log(err);
			})
		}

		function onCommentRemoved(data) {
			self.post.reply_count--;
			self.eventPostComments = _.reject(self.eventPostComments, function (comment) {
				return comment.id === data.id;
			});
			systemUtils.digest($scope);
		}

		function onLikeToggle() {
			var service = self.post.is_liked ? 'unlike_event_post' : 'like_event_post';
			pixerfApiCommunitySvc[service]({
				id: self.post.id
			}).$promise.then(function (res) {
				self.post.is_liked = !self.post.is_liked;
				self.post.like_count += self.post.is_liked ? 1 : -1;
			}).catch(function (err) {
				console.log(err);
			})
		}

		function onShowListLike() {
			if (self.post.like_count < 1) return;
			peopleListPopupSvc.showPopup({
				type: accountConst.INTERACT_TYPE.LIKE_EVENT_POST.toLowerCase(),
				user: self.loginUser,
				eventPostId: self.post.id,
				options: {
					hideSeeAll: true
				}
			});
		}

		function onRemovePost() {
			var popup = confirmPopupSvc.showPopup({
				windowClass: 'remove-discussion-confirm-popup',
				title: 'Are you sure you want to delete your post?',
				message: 'You will lose all the engagements and comments from this post.',
				submitBtnText: 'Yes, delete it',
				cancelBtnText: 'No, keep it',
				submit: function () {
					var def = $q.defer();
					pixerfApiCommunitySvc.remove_disscussion({
						id: self.post.id
					}).$promise.then(function (res) {
						toastr.success("Post has been deleted!");
						def.resolve(res);
					}).catch(function (err) {
						def.reject(err);
					})
					return def.promise;
				},
				submitCallback: function (res) {
					$scope.onRemoved(res);
				}
			});

			return popup;
		}

		function onEditPost() {
			var popup = createEventPostPopupSvc.showPopup({
				eventPost: self.post
			});

			popup.result.then(function (eventpost) {
				if (eventpost) {
					self.post = eventpost;
					systemUtils.digest($scope);
				}
			});
		}

		function onRemovePost() {
			var popup = confirmPopupSvc.showPopup({
				windowClass: 'remove-discussion-confirm-popup',
				title: 'Are you sure you want to delete this post?',
				message: 'You will lose all the engagements and comments from this post.',
				submitBtnText: 'Yes, delete it',
				cancelBtnText: 'No, keep it',
				submit: function () {
					var def = $q.defer();
					pixerfApiCommunitySvc.remove_event_post({
						id: self.post.id
					}).$promise.then(function (res) {
						toastr.success("Event post has been deleted!");
						def.resolve(res);
					}).catch(function (err) {
						def.reject(err);
					})
					return def.promise;
				},
				submitCallback: function (res) {
					$scope.onRemoved(res);
				}
			});

			return popup;
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('eventPostTile', eventPostTile);

	function eventPostTile() {

		var directive = {
			scope: {
				"post": "=",
				"community": "=",
				"onRemoved": "&",
				"isAdmin": "=",
				"isMember": "=",
				"arrangeBy": "@"
			},
			restrict: 'E',
			templateUrl: 'app/components/event-post-tile/event-post-tile.html',
			controller: 'eventPostTileCtrl',
			controllerAs: 'vm',
			replace: true
		};
		return directive;
	}

})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('eventPostItemCtrl', eventPostItemCtrl);

		eventPostItemCtrl.$inject = ['$scope', 'confirmPopupSvc', '$q', 'pixerfApiCommunitySvc', 'createDiscussionTopicPopupSvc', 'sessionManagerSvc', '$state', 
			'commonConst', 'toastr', '$window', 'peopleListPopupSvc', 'pixerfDiscussionReportPopupSvc', 'accountConst', 'dateUtils'];

	function eventPostItemCtrl($scope, confirmPopupSvc, $q, pixerfApiCommunitySvc, createDiscussionTopicPopupSvc, sessionManagerSvc, $state, 
			commonConst, toastr, $window, peopleListPopupSvc, pixerfDiscussionReportPopupSvc, accountConst, dateUtils) {

		var self = this;
		self.loginUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.post = $scope.post;
		self.community = $scope.community;
		self.event =  $scope.event;
		self.isOwner = self.loginUser && self.post.user.id === self.loginUser.id;
		self.isMember = self.loginUser && (self.community.membership_status === 'accepted' || self.community.membership_status === 'owner');
		self.isLiked = false;
		self.isBookmarked = false;
		self.commonConst = commonConst;
		self.onComment = onComment;
		self.goDetailDiscussion = goDetailDiscussion;
		self.onShowListLike = onShowListLike;
		self.onShowListReply = onShowListReply;
		self.controls = [];
		self.onRemoveFromCommunity = onRemoveFromCommunity;
		self.onBlockFromCommunity = onBlockFromCommunity;
		self.showRejectBtn = true;
		self.showApproveBtn = true;
		self.onApproveDiscussion = onApproveDiscussion;
		self.onRejectDiscussion = onRejectDiscussion;

		init();

		function init() {
			self.inserted_at = self.post.inserted_at ? getPreciseDiff(moment(self.post.inserted_at)) : "";
			buildlControl();
		}

		function buildlControl(){
			self.controls = [{
				label: 'Remove from Community',
				cta: self.onRemoveFromCommunity,
				showControl: true
			}, {
				label: 'Block from Community',
				cta: self.onBlockFromCommunity,
				showControl: true
			}];
		}

		function onRemoveFromCommunity(){
			$scope.onRemoveFromCommunity(self.post.user);
		}

		function onBlockFromCommunity(){
			$scope.onBlockFromCommunity(self.post.user);
		}

		function onApproveDiscussion(){
			$scope.onApproveDiscussion(self.post);
		}

		function onRejectDiscussion(){
			$scope.onRejectDiscussion(self.post);
		}

		function getPreciseDiff(date){
			var today = moment.utc();
			return dateUtils.preciseDiff(today, moment(date))
		}

		function onComment(discussion) {
			goDetailDiscussion(discussion);
		}

		function goDetailDiscussion(discussion) {
			$state.go(self.commonConst.STATE.EVENT_FEED, {
				id: self.event.id,
				name: self.event.name
			});
		}

		function onShowListLike() {
			$window.event.stopPropagation();
			if(self.post.like_count < 1) return;

			peopleListPopupSvc.showPopup({
				type: accountConst.INTERACT_TYPE.LIKE_EVENT_POST.toLowerCase(),
				user: self.loginUser,
				eventPostId: self.post.id,
				options: {
					hideSeeAll: true
				}
			});
		}

		function onShowListReply() {
			$window.event.stopPropagation();
			if(self.post.reply_count < 1) return;

			peopleListPopupSvc.showPopup({
				type: accountConst.INTERACT_TYPE.REPLY_EVENT_POST.toLowerCase(),
				user: self.loginUser,
				eventPostId: self.post.id,
				options: {
					hideSeeAll: true
				}
			});
		}

	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('eventPostItem', eventPostItem);

	function eventPostItem() {

		var directive = {
			scope: {
				"post": "=",
				"community": "=",
				"event": "=",
				"onRemoved": "&",
				"arrangeBy": "@",
				"onRemoveFromCommunity": "&",
				"onBlockFromCommunity": "&",
				"onApproveDiscussion": "&",
				"onRejectDiscussion": "&"
			},
			restrict: 'E',
			templateUrl: 'app/components/event-post-item/event-post-item.html',
			controller: 'eventPostItemCtrl',
			controllerAs: 'vm',
			replace: true
		};
		return directive;
	}

})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('eventPostCommentCtrl', eventPostCommentCtrl);

	eventPostCommentCtrl.$inject = ['$scope', 'sessionManagerSvc', 'pixerfApiCommunitySvc', 'systemUtils', '$timeout', 'peopleListPopupSvc', 'pixerfDiscussionReportPopupSvc', 'accountConst'];

	function eventPostCommentCtrl($scope, sessionManagerSvc, pixerfApiCommunitySvc, systemUtils, $timeout, peopleListPopupSvc, pixerfDiscussionReportPopupSvc, accountConst) {

		var self = this;
		self.comment = $scope.comment;
		self.onLikeComment = onLikeComment;
		self.onReplyInput = onReplyInput;
		self.onReplyCommentEventPost = onReplyCommentEventPost;
		self.onToggleReplyDropdown = onToggleReplyDropdown;
		self.loginUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.isOwner = self.loginUser && self.loginUser.id === self.comment.user.id;
		self.replyCommentShow = false;
		self.onRemoveComment = onRemoveComment;
		self.onReportComment = onReportComment;
		self.scrollToThis = false;
		self.onShowListLike = onShowListLike;

		init();

		function init() {
			self.time = genDurationText(self.comment.updated_at);
			getLayout($scope.styleLayout);
			self.comment.likeLabel = genLikeLabel(self.comment);
			self.userAvatar = self.comment.user.profile_image_media && self.comment.user.profile_image_media.length ? self.comment.user.profile_image_media['100x'] : "";
			$timeout(function () {
				self.scrollToThis = $scope.scrollToThis;
			}, 2000)
		}

		function onLikeComment(comment) {
			var service = comment.is_liked ? 'unlike_comment' : 'like_comment';
			pixerfApiCommunitySvc[service]({
				id: comment.id
			}, {}).$promise.then(function (res) {
				comment.is_liked = !comment.is_liked;
				comment.like_count += comment.is_liked ? 1 : -1;
				comment.likeLabel = genLikeLabel(comment);
				genLikeLabel(comment);
			}).catch(function (err) {
				console.log(err);
			})
		}

		function onReplyInput() {
			self.replyCommentShow = true;
			systemUtils.digest($scope);
		}

		function onReplyCommentEventPost(comment) {
			pixerfApiCommunitySvc.reply_nested_event_post({
				id: self.comment.id
			}, {
				text: comment
			}).$promise.then(function (res) {
				self.replyCommentShow = false;
				if (!self.subComments) self.subComments = [];
				res.data.time = genDurationText(res.data.updated_at);
				res.data.isOwner = true;
				self.subComments.push(res.data);
			}).catch(function (err) {
				console.log(err);
			})
		}

		function genDurationText(time) {
			var now = moment.utc().format('DD/MM/YYYY, HH:mm:ss');
			var then = moment(time).format('DD/MM/YYYY, HH:mm:ss');
			var ms = moment(now, "DD/MM/YYYY HH:mm:ss").diff(moment(then, "DD/MM/YYYY HH:mm:ss"));
			var d = moment.duration(ms);

			if (d.days() < 1 && d.hours() < 1 && d.minutes() < 1) {
				return d.seconds() + 's';
			} else if (d.days() < 1 && d.hours() < 1) {
				return d.minutes() + 'm';
			} else if (d.days() < 1) {
				return d.hours() + 'h';
			} else {
				return d.days() + 'd';
			}
		}

		function getLayout(style) {
			switch (style) {
				case 'author-inline':
					self.layout = "author-inline";
					break;
				case 'author-block':
					self.layout = "author-block";
					break;
				default:
					self.layout = "author-inline";
			}
		}

		function onToggleReplyDropdown() {
			self.isRepliedOpen = !self.isRepliedOpen;
			getReplies(self.comment);
		}

		function getReplies(comment) {
			if (self.subComments && self.subComments.length) return;
			pixerfApiCommunitySvc.get_nested_event_post_reply({
				id: comment.id
			}).$promise.then(function (res) {
				if (!self.subComments) self.subComments = [];
				self.subComments = res.data;
				for (var i = 0; i < self.subComments.length; i++) {
					self.subComments[i].time = genDurationText(self.subComments[i].updated_at);
					self.subComments[i].likeLabel = genLikeLabel(self.subComments[i]);
					self.subComments[i].isOwner = self.loginUser && self.subComments[i].user.id === self.loginUser.id;
				}
				systemUtils.digest($scope);
			}).catch(function (err) {
				console.log(err);
			})
		}

		function genLikeLabel(comment) {
			return comment.is_liked ? 'Liked' : 'Like';
		}

		function onRemoveComment(comment, subComment) {
			pixerfApiCommunitySvc.remove_event_post_reply({
				id: comment.id
			}).$promise.then(function (res) {
				if (subComment) {
					self.subComments = _.reject(self.subComments, function (item) {
						return item.id === comment.id;
					})
				} else {
					$scope.onRemoved({
						data: comment
					});
				}
			}).catch(function (err) {
				console.log(err);
			})
		}

		function onReportComment(comment) {
			pixerfDiscussionReportPopupSvc.showPopup({id: comment.id, target: 'report_comment'});
		}

		function onShowListLike(subComment) {
			peopleListPopupSvc.showPopup({
				type: accountConst.INTERACT_TYPE.LIKE_REPLY_DISCUSSION.toLowerCase(),
				user: self.loginUser,
				replyId: subComment ? subComment.id : self.comment.id,
				options: {
					hideSeeAll: true
				}
			});
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('eventPostComment', eventPostComment);

	function eventPostComment() {

		var directive = {
			scope: {
				"comment": "=",
				"styleLayout": "=",
				"canReply": "=",
				"canLike": "=",
				"onGetReplies": "&",
				"onRemoved": "&",
				"scrollToThis": '='
			},
			restrict: 'E',
			templateUrl: 'app/components/event-post-comment/event-post-comment.html',
			controller: 'eventPostCommentCtrl',
			controllerAs: 'vm',
			replace: true
		};
		return directive;
	}

})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('eventListViewTileCtrl', eventListViewTileCtrl);

	eventListViewTileCtrl.$inject = ['$scope', 'sessionManagerSvc', 'pixerfApiEventSvc', '$state', 'confirmPopupSvc'];

	function eventListViewTileCtrl($scope, sessionManagerSvc, pixerfApiEventSvc, $state, confirmPopupSvc) {

		var self = this;

		self.event = $scope.data;
		self.loginedUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.isOwner = self.loginedUser && self.event.owner.id === self.loginedUser.id;
		self.eventStartDate = {
			month: null,
			day: null,
			year: null
		};
		self.onInterested = onInterested;
		self.onGoing = onGoing;

		init()

		function init() {
			if (self.event.event_datetimes.length) {
				self.schedules = transformDateTime(self.event.event_datetimes);
			}
		}

		function transformDateTime(arrTime) {
			self.eventStartDate = {
				day: moment(arrTime[0].start_datetime).format('DD'),
				month: moment(arrTime[0].start_datetime).format('MMM'),
				year: moment(arrTime[0].start_datetime).format('YYYY')
			};
		}

		function onInterested() {
			pixerfApiEventSvc.toggleInterest({
				id: self.event.id
			}, {}).$promise.then(function (res) {
				self.event = res.data;
			}).catch(function (err) {
				console.log(err);
			})
		}

		function onGoing() {
			if(self.event.capacity_type === 'limited' && !self.event.stats.available) return;
			else if(!self.event.has_joined && self.event.admission_type == 'ticketed_pixerf'){
				return processPaymentEvent();
			}else if(self.event.has_joined && self.event.admission_type == 'ticketed_pixerf'){
				return ;
			}
			pixerfApiEventSvc.toggleJoin({
				id: self.event.id
			}, {}).$promise.then(function (res) {
				self.event = res.data;
			}).catch(function (err) {
				console.log(err);
			})
		}

		function processPaymentEvent(){
			setInterestedEvent();
			$state.go('checkout.event-payment', {
				id: self.event.id
			});
		}

		function setInterestedEvent(){
			if(!self.event.has_interest){
				onInterested();
			}
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('eventListViewTile', eventListViewTile);

	eventListViewTile.$inject = [];

	function eventListViewTile() {

		var directive = {
			scope: {
				data: "="
			},
			restrict: 'E',
			templateUrl: 'app/components/event-list-view-tile/event-list-view-tile.html',
			controller: 'eventListViewTileCtrl',
			controllerAs: 'vm',
			replace: true
		};
		return directive;
	}

})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('eventListViewCtrl', eventListViewCtrl);

	eventListViewCtrl.$inject = ['$scope', '$window', 'pixerfApiCommunitySvc', 'sessionManagerSvc', 'actionReqruiedCommunityPopupSvc', '$q', 'alertMessagePopupSvc', '$translate', 'confirmPopupSvc', 'pixerfApiEventSvc', 'toastr',
		'translationSvc', 'pixerfDiscussionReportPopupSvc', 'inviteUserPopupSvc', '$state', 'stringUtils'
	];

	function eventListViewCtrl($scope, $window, pixerfApiCommunitySvc, sessionManagerSvc, actionReqruiedCommunityPopupSvc, $q, alertMessagePopupSvc, $translate, confirmPopupSvc, pixerfApiEventSvc, toastr, translationSvc, pixerfDiscussionReportPopupSvc, inviteUserPopupSvc, $state, stringUtils) {

		var USER_CONTROL_ADMINDASHBOARD = ['curator_internal', 'admin_internal', 'marketer_internal'];
		var self = this;
		self.loginedUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.isAdmin = self.loginedUser && (USER_CONTROL_ADMINDASHBOARD.includes(self.loginedUser.role) || self.loginedUser.email === 'marcom@pixerf.com');
		self.maxStrikes = 3;
		self.event = $scope.event;
		self.type = $scope.type;
		self.isMine = (self.loginedUser && self.loginedUser.id === self.event.owner.id);
		self.onToggleSelected = onToggleSelected;
		self.onToggleActionRequired = onToggleActionRequired;
		self.onEventClicked = onEventClicked;
		self.prevenPubbleClick = prevenPubbleClick;
		self.onEditComments = onEditComments;
		self.onMoveToInReview = onMoveToInReview;
		self.onActionRequiredEvent = onActionRequiredEvent;
		self.onApproveEvent = onApproveEvent;
		self.onManageEvent = onManageEvent;
		self.prevenPubbleClick = prevenPubbleClick;
		self.onToggleGoingEvent = onToggleGoingEvent;
		self.onReportEvent = onReportEvent;
		self.onInviteFriends = onInviteFriends;
		self.onAcceptEvent = onAcceptEvent;
		self.onDeclineEvent = onDeclineEvent;
		self.onCreateEvent = onCreateEvent;
		self.onEditEvent = onEditEvent;
		self.showPermission = false;
		self.showMemberCount = false;
		self.showEventCount = false;
		self.showPostCount = false;
		self.showStrike = false;
		self.showCurationControl = false;
		self.showMoreControl = false;
		self.showAdmin = false;
		self.moreList = [];
		self.coverImage = self.event.cover.original;
		self.link = window.location.origin + (window.location.pathname || '') + '#/ce/' + self.event.short_code;
		self.defaultShareText = "Hi there! I would like to invite you to join the event \"" + self.event.name + "\" on PIXERF. " + self.link;
		self.SocialShareContent = buildSocialShareContent();
		self.getMoreList = getMoreList;
		self.showShareEventBtn = false;

		self.showStatus = false;

		self.colsOrder = {
			selectBox: 1,
			eventName: 2,
			communityName: 3,
			admin: 3,
			privacy: 4,
			status: 5,
			eventTime: 6,
			attendees: 7,
			statGoing: 8,
			interested: 9,
			invited: 10,
			actions: 11
		};

		init();

		function init() {
			setLayout();
			convertCreatedDate();
			self.moreList = getMoreList(self.event);
			self.schedules = transformDateTime(self.event.event_datetimes);
		}

		function transformDateTime(arrTime) {
			var arrFormatedTime = [];
			var tmp;

			for (var i = 0; i < arrTime.length; i++) {
				tmp = moment(arrTime[i].start_datetime).format('MMM DD, YYYY');

				arrFormatedTime.push({
					start_datetime: arrTime[i].start_datetime,
					text: tmp
				});
			}

			return arrFormatedTime;
		}

		function convertCreatedDate() {
			self.fomatedDate = moment(self.event.inserted_at).format("MMM DD, YYYY");
		}

		function getMoreList(event) {
			var moreList = [];
			switch (self.type) {
				case 'ongoing':
					moreList = [{
							label: 'Edit Event details',
							cta: onEditEventDetail
						},
						{
							label: 'Manage Attendees',
							cta: manageAttendees
						},
						{
							label: 'Cancel Event',
							cta: cancelEvent,
							disable: true
						}
					];
					break;
				case 'upcoming':
					moreList = [{
							label: 'Edit Event details',
							cta: onEditEventDetail
						},
						{
							label: 'Manage Attendees',
							cta: manageAttendees
						},
						{
							label: 'Cancel Event',
							cta: cancelEvent
						}
					];
					break;
				case 'past':
					moreList = [{
							label: 'View Event details',
							cta: onViewEventDetail
						},
						{
							label: 'View attendees',
							cta: manageAttendees
						},
						{
							label: 'Delete Event',
							cta: deleteEvent
						}
					];
					break;
				case 'unpublished':
					switch (self.event.status) {
						case 'draft':
							self.showMoreControl = true;
							moreList = [{
									label: 'View',
									cta: onViewEventDetail
								},
								{
									label: 'Publish',
									cta: publishEvent
								},
								{
									label: 'Edit',
									cta: onEditEventDetail
								},
								{
									label: 'Delete',
									cta: deleteEvent
								}
							];
							break;
						case 'cancelled':
							self.showMoreControl = true;
							moreList = [{
									label: 'View Event details',
									cta: onViewEventDetail
								},
								{
									label: 'View attendees',
									cta: manageAttendees
								},
								{
									label: 'Delete Event',
									cta: deleteEvent
								}
							];
							break;

						case 'rejected':
							self.showMoreControl = true;
							moreList = [{
									label: 'View Event details',
									cta: onViewEventDetail
								},
								{
									label: 'View attendees',
									cta: manageAttendees
								},
								{
									label: 'Delete Event',
									cta: deleteEvent
								}
							];
							break;
						case 'deleted':
							self.showMoreControl = false;
							moreList = [];
							break;

					}

					break;
				case 'inReview':
					if (self.isAdmin) {
						self.showMoreControl = true;
						moreList = [{
								label: 'View Event',
								cta: onViewEventDetail
							},
							{
								label: 'Resolve',
								cta: approveEvent
							},
							{
								label: 'Reject',
								cta: onRejectEvent
							}
						];
					} else {

						self.showMoreControl = false;
						moreList = [];
					}
					break;
			}
			return moreList;
		}

		function setLayout() {
			switch (self.type) {
				case 'going':
					convertStatus('going');
					self.showCheckbox = true;
					self.showCommunityName = true;
					self.showEventDate = true;
					self.showPrivacy = true;
					self.showStatus = true;
					self.showGoing = true;
					self.showInviteBtn = true;
					self.showActionList = true;
					if (['cancelled'].includes(self.event.status)) {
						self.actionList = [{
							label: 'Delete Event',
							cta: deleteEvent
						}];
					} else {
						self.actionList = [{
								label: 'Not Going',
								cta: self.onToggleGoingEvent
							},
							{
								label: 'Report Event',
								cta: self.onReportEvent
							}
						];
					}
					break;
				case 'invited':
					self.showCheckbox = true;
					self.showCommunityName = true;
					self.showEventDate = true;
					self.showPrivacy = true;
					self.showInterested = true;
					self.showGoing = true;
					self.showDeclineBtn = true;
					self.showAcceptBtn = true;
					self.showActionList = true;
					self.actionList = [{
						label: 'Report Event',
						cta: self.onReportEvent
					}];
					break;
				case 'interested':
					self.showCheckbox = true;
					self.showCommunityName = true;
					self.showEventDate = true;
					self.showPrivacy = true;
					self.showCapacity = true;
					self.showInterested = true;
					self.showGoing = true;
					self.showActionList = true;
					self.showGoingBtn = true;
					self.actionList = [{
						label: 'Report Event',
						cta: self.onReportEvent
					}];
					break;
				case 'hosting':
					self.showCheckbox = true;
					self.showCommunityName = true;
					self.showEventDate = true;
					self.showPrivacy = true;
					self.showStatus = true;
					self.showGoing = true;
					self.showActionList = true;
					self.showInviteBtn = true;
					self.actionList = [{
						label: 'Report Event',
						cta: self.onReportEvent
					}];
					switch (self.event.status) {
						case 'cancelled':
							self.actionList = [{
								label: 'Delete Event',
								cta: deleteEvent
							}];
							break;
						case 'rejected':
							self.actionList = [{
								label: 'Delete Event',
								cta: deleteEvent
							}];
							break;
						case 'reported':
							self.actionList = [{
								label: 'Edit Event details',
								cta: self.onEditEvent
							}, {
								label: 'Manage Attendees',
								cta: self.onEditEvent
							}, {
								label: 'Cancel Event',
								cta: cancelEvent
							}];
							break;
						case 'active':
							self.actionList = [{
								label: 'Edit Event details',
								cta: self.onEditEvent
							}, {
								label: 'Manage Attendees',
								cta: self.onEditEvent
							}, {
								label: 'Cancel Event',
								cta: cancelEvent
							}];
							break;
					}
					break;
				case 'past-events':
					self.showCommunityName = true;
					self.showEventDate = true;
					self.showPrivacy = true;
					self.showStatus = true;
					self.showGoing = true;
					self.showIsHost = true;
					convertStatus('past');
					break;
				case 'draft':
					self.showCheckbox = true;
					self.showCommunityName = true;
					self.showEventDate = true;
					self.showEditBtn = true;
					self.showCreateBtn = true;
					self.showActionList = true;
					self.actionList = [{
						label: 'Delete Event',
						cta: deleteEvent
					}];
					break;
				case 'ongoing':
					self.showManageButton = true;
					self.showMoreControl = true;
					self.showPermission = true;
					self.showShareEventBtn = true;
					break;
				case 'upcoming':
					self.showManageButton = true;
					self.showMoreControl = true;
					self.showPermission = true;
					self.showShareEventBtn = true;
					self.colsOrder.eventTime = 4;
					self.colsOrder.privacy = 6;
					break;
				case 'past':
					self.showManageButton = true;
					self.showMoreControl = true;
					self.showPermission = true;
					self.showShareEventBtn = false;
					self.colsOrder.eventTime = 4;
					self.colsOrder.privacy = 6;
					break;
				case 'unpublished':
					self.showCheckbox = true;
					self.showManageButton = true;
					self.showPermission = true;
					self.showShareEventBtn = false
					self.showStatus = true;
					self.colsOrder.status = 4;
					self.colsOrder.eventTime = 5;
					self.colsOrder.privacy = 6;
					break;
				case 'inReview':
					self.showCheckbox = true;
					self.showCommunityName = true;
					self.showAdmin = true;
					self.showManageButton = true;
					self.showMoreControl = false;
					self.showPrivacy = true;
					self.showCapacity = true;
					self.showEventDate = true;
					self.showStatus = true;
					self.showActionList = true;
					self.actionList = [{
							label: 'View Event',
							cta: onViewEventDetail
						},
						{
							label: 'Resolve',
							cta: approveEvent
						},
						{
							label: 'Reject',
							cta: onRejectEvent
						}
					];
					self.colsOrder.status = 4;
					self.colsOrder.eventTime = 5;
					self.colsOrder.privacy = 6;
					break;
			}
		}

		function cancelEvent() {

			confirmPopupSvc.showPopup({
				windowClass: 'cancel-event-confirm-popup',
				title: $translate.instant("you-are-about-to-cancel-this-event"),
				message: $translate.instant("if-you-cancel-this-event"),
				submitBtnText: 'Yes',
				cancelBtnText: 'Cancel',
				submit: function () {
					var def = $q.defer();
					pixerfApiCommunitySvc.cancel_community_event({
						id: self.event.id
					}).$promise.then(
						function success(res) {
							self.event.status = res.data.status;
							self.actionList = [{
								label: 'Delete Event',
								cta: deleteEvent
							}];
							if ($scope.onStatusChanged) {
								$scope.onStatusChanged({
									event: self.event
								});
							}
							toastr.success("this event has been successfully canceled");
							def.resolve(res);
						},
						function error(err) {
							toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
							console.log(err);
							def.reject(err);
						}
					);
					return def.promise;
				},
				submitCallback: function () {
					if ($scope.onStatusChanged) {
						$scope.onStatusChanged({
							event: event
						});
					}
				}
			});
		}

		function onViewEventDetail(event) {
			$scope.onEventClicked({
				event: event,
				action: 'viewEventDetail'
			});
		}

		function onEditEventDetail(event) {
			$scope.onEventClicked({
				event: event,
				action: 'editEventDetail'
			});
		}

		function manageAttendees(event) {
			$scope.onEventClicked({
				event: event,
				action: 'manageAttendees'
			});
		}

		function deleteEvent() {
			var event = self.event;
			confirmPopupSvc.showPopup({
				windowClass: 'delete-event-confirm-popup',
				title: $translate.instant("you-are-about-to-delete-this-event"),
				message: $translate.instant("deleting-your-Event-will-remove-it"),
				submitBtnText: 'Yes',
				cancelBtnText: 'Cancel',
				submit: function () {
					var def = $q.defer();
					pixerfApiEventSvc.deleteEvent({
						id: event.id
					}).$promise.then(
						function (res) {
							self.event.status = 'deleted';
							if ($scope.onStatusChanged) {
								$scope.onStatusChanged({
									event: self.event
								});
							}
							toastr.success("Your event deleted successfully");
							def.resolve(res);
						}).catch(function (err) {
						def.reject(err);
					});
					return def.promise;
				}
			});
		}

		function publishEvent(event) {
			updateEventStatus(event, 'active');
		}

		function approveEvent(event) {
			updateEventStatus(event, 'active');
		}

		function onRejectEvent() {
			confirmPopupSvc.showPopup({
				windowClass: 'reject-event-confirm-popup',
				title: $translate.instant("you-are-about-to-reject-this-event"),
				message: $translate.instant("reject-your-Event-will-remove-it"),
				submitBtnText: 'Yes',
				cancelBtnText: 'Cancel',
				submit: function () {
					var def = $q.defer();
					updateEventStatus(self.event, 'rejected').then(
						function (res) {
							def.resolve(res);
						},
						function (err) {
							def.reject(err);
						}
					);
					return def.promise;
				}
			});
		}

		function onToggleSelected(event) {
			$scope.onToggleSelected({
				event: event
			});
		}

		function onToggleActionRequired(isToggle) {
			prevenPubbleClick();
			self.isOpenActionRequiredHint = !isToggle;
		}

		function onEventClicked(event) {
			$scope.onEventClicked({
				event: event
			});
		}

		function buildSocialShareContent() {
			return {
				'url': self.link,
				'description': self.defaultShareText,
				'title': self.event.name,
				'media': self.coverImage
			};
		}

		function updateEventStatus(eventToSave, newStatus) {
			var status = eventToSave.status;
			eventToSave.status = newStatus;
			delete eventToSave.cover;
			var def = $q.defer();
			pixerfApiEventSvc.update({
				id: eventToSave.id
			}, {
				status: newStatus
			}).$promise.then(function (res) {
				if ($scope.onStatusChanged) {
					$scope.onStatusChanged({
						event: self.event
					});
				}
				toastr.success("Your event updated successfully");
				def.resolve(res);
			}).catch(function (err) {
				eventToSave.status = status;
				console.log(err);
				def.reject(err);
			})
			return def.promise;
		}

		function onEditComments() {
			prevenPubbleClick();

			actionReqruiedCommunityPopupSvc.showPopup({
				event: self.event,
				submit: function (data) {
					var def = $q.defer();
					pixerfApiCommunitySvc.update_action_required_community({
						id: self.event.community_reject_comments[0].id
					}, data).$promise.then(function (res) {
						def.resolve(res.data)
					}).catch(function (err) {
						def.reject(err);
					})
					return def.promise;
				},
				submitCallback: function (res) {
					showActionRequiredPopup();
				}
			})
		}

		function onMoveToInReview() {
			prevenPubbleClick();
			pixerfApiCommunitySvc.move_to_in_review({
				id: self.event.id
			}, {
				status: 'in_review'
			}).$promise.then(function (res) {
				console.log("Move to in review");
				self.event = res.data;
				if ($scope.onStatusChanged) {
					$scope.onStatusChanged({
						event: self.event
					});
				}
			}).catch(function (err) {
				console.log(err);
			})
		}

		function onApproveEvent() {
			prevenPubbleClick();

			pixerfApiCommunitySvc.approve_community({
				id: self.event.id
			}, {
				status: 'active'
			}).$promise.then(function (res) {
				alertMessagePopupSvc.showPopup({
					windowClass: 'event-list-view__alert-message',
					title: "Event approved!",
					description: "You can find this event under <span class='text--bold text--color-pixerf-theme'>Active Communities</span>."
				});
				self.event = res.data;
				if ($scope.onStatusChanged) {
					$scope.onStatusChanged({
						event: self.event
					});
				}
			}).catch(function (err) {
				console.log(err);
			})
		}

		function onActionRequiredEvent() {
			prevenPubbleClick();

			actionReqruiedEventPopupSvc.showPopup({
				submit: function (data) {
					data.status = "approve_requỉed";
					var def = $q.defer();
					pixerfApiCommunitySvc.action_required_community({
						id: self.event.id
					}, data).$promise.then(function (res) {
						self.event = res.data;
						def.resolve(res.data)
					}).catch(function (err) {
						def.reject(err);
					})
					return def.promise;
				},
				submitCallback: function (res) {
					showActionRequiredPopup();
					if ($scope.onStatusChanged) {
						$scope.onStatusChanged({
							event: res
						});
					}
				}
			})
		}

		function showActionRequiredPopup() {
			alertMessagePopupSvc.showPopup({
				windowClass: 'event-list-view__alert-message',
				title: "Comment sent! What do you want to do next?",
				description: "You can find this event under <span class='text--bold text--color-pixerf-theme'>Action Required</span>. You can still edit your commment if owner has not edited and resubmitted their form."
			});
		}

		function prevenPubbleClick() {
			$window.event.stopPropagation();
		}

		function onManageEvent() {
			prevenPubbleClick();

			if ($scope.onManageClicked) {
				$scope.onManageClicked({
					event: self.event
				});
			}
		}

		function onToggleGoingEvent() {

			if(!self.event.has_joined && self.event.admission_type == 'ticketed_pixerf'){
				return processPaymentEvent();
			}
			else if (self.event.has_joined  && ( self.event.admission_type === 'ticketed_pixerf')) return;

			pixerfApiEventSvc.toggleJoin({
				id: self.event.id
			}, {}).$promise.then(function (res) {
				self.event = res.data;
				if ($scope.onStatusChanged) {
					$scope.onStatusChanged({
						event: self.event
					});
				}
			}).catch(function (err) {
				console.log(err);
			})
		}

		function onReportEvent() {
			pixerfDiscussionReportPopupSvc.showPopup({
				id: self.event.id,
				target: 'report_community_event'
			});
		}

		function onInviteFriends() {
			if (['cancelled', 'rejected'].includes(self.event.status)) return;
			inviteUserPopupSvc.showPopup({
				options: {
					title: "Invite members to Event"
				},
				community: {
					id: self.event.community_id,
				},
				event: {
					id: self.event.id,
					short_code: self.event.short_code
				},
				defaultSearchCondition: {
					isDirectoryChecked: true,
					isEmailChecked: false,
					country: "",
					speciality: "",
				}
			});
		}

		function onAcceptEvent() {
			if(!self.event.has_joined && self.event.admission_type == 'ticketed_pixerf'){
				return processPaymentEvent();
			}
			else if (self.event.has_joined  && ( self.event.admission_type === 'ticketed_pixerf')) return;
			
			pixerfApiEventSvc.toggleJoin({
				id: self.event.id
			}, {}).$promise.then(function (res) {
				self.event = res.data;
				if ($scope.onStatusChanged) {
					$scope.onStatusChanged({
						event: self.event
					});
				}
			}).catch(function (err) {
				console.log(err);
			})
		}

		function onDeclineEvent() {
			pixerfApiEventSvc.decline_invitation({
				id: self.event.id
			}, {}).$promise.then(function (res) {
				self.event = res.data;
				if ($scope.onStatusChanged) {
					$scope.onStatusChanged({
						event: self.event
					});
				}
			}).catch(function (err) {
				console.log(err);
			})
		}

		function onCreateEvent() {
			pixerfApiEventSvc.update({
				id: self.event.id
			}, {
				status: 'active'
			}).$promise.then(function (res) {
				self.event = res.data;
				if ($scope.onStatusChanged) {
					$scope.onStatusChanged({
						event: self.event
					});
				}
			}).catch(function (err) {
				console.log(err);
			})
		}

		function onEditEvent() {
			$state.go('event-detail-page.event-feed', {
				id: self.event.id,
				name: stringUtils.toSnakeCase(self.event.name)
			});
		}

		function convertStatus(type) {
			switch (type) {
				case 'past':
					if (self.event.status === 'active') self.convetedStatus = 'past';
					break;
				case 'going':
					if (self.event.status === 'reported') self.convetedStatus = 'active';
					break;
			}
		}

		function processPaymentEvent(){
			setInterestedEvent();
			$state.go('checkout.event-payment', {
				id: self.event.id
			});
		}

		function setInterestedEvent(){
			if(!self.event.has_interest){
				onInterested();
			}
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('eventListView', eventListView);
		eventListView.$inject = []

	function eventListView() {

		var directive = {
			scope: {
				event: "=",
				onToggleSelected: "&?",
				onEventClicked: "&?",
				onStatusChanged: "&?",
				onManageClicked: "&?",
				type: "@"
			},
			restrict: 'E',
			templateUrl: 'app/components/event-list-view/event-list-view.html',
			controller: 'eventListViewCtrl',
			controllerAs: 'vm',
			replace: true
		};
		return directive;
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('eventListTileCtrl', eventListTileCtrl);

	eventListTileCtrl.$inject = ['$scope'];

	function eventListTileCtrl($scope) {

		var self = this;

		self.data = $scope.data;
		self.eventDate = {
			month: null,
			day: null
		};

		init()

		function init() {
			if (self.data.event_datetimes.length) {
				self.schedules = transformDateTime(self.data.event_datetimes);
			}
		}

		function transformDateTime(arrTime) {
			var arrFormatedTime = [];
			var tmp;

			self.eventDate = {
				day: moment(arrTime[0].start_datetime).format('DD'),
				month: moment(arrTime[0].start_datetime).format('MMM')
			};

			for (var i = 0; i < arrTime.length; i++) {
				tmp = moment(arrTime[i].start_datetime).format('DD MMM YYYY');
				tmp += ", ";
				tmp += moment(arrTime[i].start_datetime).format('h:mm A');
				tmp += " - ";
				tmp += moment(arrTime[i].end_datetime).format('h:mm A');
				arrFormatedTime.push(tmp);
			}

			return arrFormatedTime;
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('eventListTile', eventListTile);

	eventListTile.$inject = [];

	function eventListTile() {

		var directive = {
			scope: {
				data: "="
			},
			restrict: 'E',
			templateUrl: 'app/components/event-list-tile/event-list-tile.html',
			controller: 'eventListTileCtrl',
			controllerAs: 'vm',
			replace: true
		};
		return directive;
	}

})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('eventExploreTileCtrl', eventExploreTileCtrl);

	eventExploreTileCtrl.$inject = ['$scope', 'pixerfApiEventSvc', 'systemUtils', '$state', 'commonConst', '$window', 'sessionManagerSvc', '$timeout'];

	function eventExploreTileCtrl($scope, pixerfApiEventSvc, systemUtils, $state, commonConst, $window, sessionManagerSvc, $timeout) {

		var self = this;
		self.loginedUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.onInterested = onInterested;
		self.onGoEventDetails = onGoEventDetails;
		self.selected = true;
		self.commonConst = commonConst;
		self.membershipStatus = '';
		self.admissionType = '';
		self.event = $scope.event;
		self.spotsAvailable = 0;
		self.rateSpotsLeft = 0;
		self.isOwner = self.loginedUser && self.loginedUser.id === self.event.owner.id;

		init();

		function init() {
			if (self.event) {
				genTextMembershipStatus(self.event);
				genAdmissionType(self.event.info);
				transformDateTime(self.event.info.event_datetimes[0]);
				self.spotsAvailable = getSpotsLeft();
				self.rateSpotsLeft = getRateSpotsLeft(self.event.member_count, self.event.info.max_attendees);
				genIntroInviteText(self.event.info);
				getInteracUsers(self.event.info);
				$timeout(function(){
					adjustTextTile('title');
				})
			}

            if (self.event && self.event.info && self.event.info.booking_date) {
				var today = moment();
				today.diff(self.event.info.booking_date, "days")
				self.noBookingYet = today.diff(self.event.info.booking_date, "days") < 0;
			}
		}

		function genTextMembershipStatus(event) {
			switch (event.membership_status) {
				case 'joined':
					self.membershipStatus = 'going';
					break;
				case 'interested':
					self.membershipStatus = 'interested';
					break;
				default:
					if (self.isOwner) {
						self.membershipStatus = ($scope.type) && ($scope.type == 'class'|| $scope.event.event_type == 'class') ? 'edit-my-class' :'edit-my-event';
					} else if (self.loginedUser && self.loginedUser.account_type === 'business' && event.is_private) {
						self.membershipStatus = 'find-out-more';
					} else if (self.loginedUser && self.loginedUser.account_type === 'business') {
						self.membershipStatus = ($scope.type) && ($scope.type == 'class'|| $scope.event.event_type == 'class') ? 'view-this-class' :'view-this-event';
					} else {
						self.membershipStatus = 'interested';
					}
			}
		}

		function genAdmissionType(eventInfo) {
			switch (eventInfo.admission_type) {
				case 'ticketed_pixerf':
				case 'ticketed_external':
					self.admissionType = eventInfo.event_type == 'class' ? 'Ticketed class' : 'Ticketed event';
					break;
				default:
					self.admissionType = eventInfo.event_type == 'class' ? 'Free class' : 'Free event';
			}
		}

		function transformDateTime(timer) {
			if (timer && timer.start_datetime) {
				self.eventDate = moment(timer.start_datetime).format('ddd, DD MMM');
			}

			if (timer && timer.start_datetime && timer.end_datetime) {
				self.eventTimes = " at " + moment(timer.start_datetime).format('h:mm A');
			}
		}

		function getSpotsLeft() {
			return self.event.info.max_attendees - self.event.member_count;
		}

		function getRateSpotsLeft(available, full) {
			return ((full - available) / full) * 100;
		}

		function adjustTextTile(element) {
			switch (element) {
				case 'title':
					var $title = $('.event-explore-tile__content__info__title.' + self.event.id);
					$title.dotdotdot();
					break;
				case 'location':
					var $location = $('.event-explore-tile__content__info__general-info__location.' + self.event.id);
					$location.dotdotdot({
						keep: ".event-explore-tile__content__info__general-info__admission-type"
					});
			}
		}

		function genIntroInviteText(users) {
			var joinedUserIds = _.pluck(users.members, 'id');
			var interestedUserIds = _.pluck(users.interested_members, 'id');
			var totalAttendees = _.union(joinedUserIds, interestedUserIds).length;
			if (joinedUserIds.length > 2 || (joinedUserIds.length === 2 && totalAttendees > 2)) {
				self.introInvitedText = "<span class='highlight-name'>" + users.members[0].first_name + "</span> and <span class='highlight-name'>" + (totalAttendees - 1) + "</span> friends are interested or will be going.";
			} else if (joinedUserIds.length === 2 && !interestedUserIds.length) {
				self.introInvitedText = "<span class='highlight-name'>" + users.members[0].first_name + "</span> and <span class='highlight-name'>" + users.members[1].first_name + "</span> are going.";
			} else if (joinedUserIds.length === 1 && !interestedUserIds.length) {
				self.introInvitedText = "<span class='highlight-name'>" + users.members[0].first_name + "</span> is going.";
			} else if (joinedUserIds.length === 1 && interestedUserIds.length > 1) {
				self.introInvitedText = "<span class='highlight-name'>" + users.members[0].first_name + "</span> and <span class='highlight-name'>" + (totalAttendees - 1) + "</span> friends are interested or will be going.";
			} else if (joinedUserIds.length === 1 && interestedUserIds.length === 1) {
				self.introInvitedText = "<span class='highlight-name'>" + users.members[0].first_name + "</span> and <span class='highlight-name'>" + users.interested_members[0].first_name + "</span> are interested or will be going.";
			} else if (!joinedUserIds.length && interestedUserIds.length > 2) {
				self.introInvitedText = "<span class='highlight-name'>" + users.interested_members[0].first_name + "</span> and <span class='highlight-name'>" + (totalAttendees - 1) + "</span> friends are interested.";
			} else if (!joinedUserIds.length && interestedUserIds.length === 1) {
				self.introInvitedText = "<span class='highlight-name'>" + users.interested_members[0].first_name + "</span> is interested.";
			} else if (!joinedUserIds.length && interestedUserIds.length === 2) {
				self.introInvitedText = "<span class='highlight-name'>" + users.interested_members[0].first_name + "</span> and <span class='highlight-name'>" + users.interested_members[1].first_name + "</span> are interested.";
			} else {
				self.introInvitedText = "";
			}
			systemUtils.digest($scope);
		}

		function onInterested() {
			$window.event.stopPropagation();
			if (self.event.info.has_interest || self.event.info.has_joined) return;
			pixerfApiEventSvc.toggleInterest({
				id: self.event.id
			}, {}).$promise.then(function (res) {
				if (res && res.data) {
					self.event.info.has_interest = res.data.has_interest;
					self.event.info.interested_members = res.data.interested_users;
					self.event.info.members = res.data.joined_users;
					self.event.info.member_count = res.data.stats.going;
					getInteracUsers(self.event.info);
					genIntroInviteText(self.event.info);
					systemUtils.digest($scope);
				}
			}).catch(function (err) {
				console.log(err);
			})
		}

		function getInteracUsers(event) {
			self.interactiveUsers = [];
			self.interactiveUsers = _.union(event.members, event.interested_members);
			systemUtils.digest($scope);
		}

		function onGoEventDetails(event) {
			$state.go(self.commonConst.STATE.EVENT_PHOTOS, {
				id: event.id,
				name: event.name
			});
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('eventExploreTile', eventExploreTile);
	eventExploreTile.$inject = []

	function eventExploreTile() {

		var directive = {
			scope: {
				event: "=",
				type: "@",
				onEdited: "&?",
				onMembershipChanged: "&?"
			},
			restrict: 'E',
			templateUrl: 'app/components/event-explore-tile/event-explore-tile.html',
			controller: 'eventExploreTileCtrl',
			controllerAs: 'vm',
			replace: true
		};
		return directive;
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('eventDetailTileCtrl', eventDetailTileCtrl);

	eventDetailTileCtrl.$inject = ['$scope', '$timeout', 'sessionManagerSvc', 'pixerfApiEventSvc', 'confirmPopupSvc', '$q', '$state', 'pixerfDiscussionReportPopupSvc'];

	function eventDetailTileCtrl($scope, $timeout, sessionManagerSvc, pixerfApiEventSvc, confirmPopupSvc, $q, $state, pixerfDiscussionReportPopupSvc) {

		var self = this;

		self.data = $scope.data;
		self.loginUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.availableTicketLabel = self.data.stats.available;
		self.isFewSpotsLeft = (self.data && self.data.stats && self.data.stats.available && self.data.max_attendees && (self.data.stats.available > 0)) ? (10 * (self.data.stats.available / self.data.max_attendees) < 2) : false;
		self.typeEvent = 'Free event';
		self.isLimitedCapacity = self.data.capacity_type === 'limited';
		self.isMine = self.loginUser && self.data.owner.id === self.loginUser.id;
		self.onInterested = onInterested;
		self.onGoing = onGoing;
		self.onReportEvent = onReportEvent;
		self.eventDate = {
			month: null,
			day: null
		};
		self.onToggleFullDescription = onToggleFullDescription;
		self.elementClassname = "event-" + self.data.id;

		var isTruncatedEventDesc = null;

		init()

		function init() {
			if (self.data.event_datetimes.length) {
				self.schedules = transformDateTime(self.data.event_datetimes);
			}

			calAvailableSpot();

			switch (self.data.admission_type) {
				case 'free':
					self.typeEvent = 'Free event';
					break;
				case 'ticketed_external':
                case 'ticketed_pixerf':
					self.typeEvent = 'Ticketed event';
					break;
				default:
					self.typeEvent = 'Free event';
			}


			$timeout(function () {
				$(".event-detail-tile__info__description." + self.elementClassname + " .event-detail-tile__info__description-text").dotdotdot({
					keep: ".event-detail-tile__info__description__read-more",
					height: 40,
					callback: function (isTruncated) {
						isTruncatedEventDesc = isTruncated;
						if (isTruncated) {
							$(this).parent().find('.event-detail-tile__info__description__read-more').show();
						} else {
							$(this).parent().find('.event-detail-tile__info__description__read-more').hide();
						}
					}
				});
			}, 0)
		}

		function onToggleFullDescription() {
			if (!isTruncatedEventDesc) {
				return;
			}
			self.isProcessinDescription = true;
			self.isFullDescription = !self.isFullDescription;
			$timeout(function () {
				self.isProcessinDescription = false;
			}, 200)
			$timeout(function () {
				var $aboutElement = $(".event-detail-tile__info__description." + self.elementClassname + " .event-detail-tile__info__description-text");
				if (self.isFullDescription) {
					$aboutElement[0].style.maxHeight = "200px";
					$timeout(function () {
						$aboutElement.dotdotdot({
							keep: ".event-detail-tile__info__description__read-more",
							height: 200
						});
					}, 200)

				} else {
					$timeout(function () {
						$aboutElement.dotdotdot({
							keep: ".event-detail-tile__info__description__read-more",
							height: 40
						});
					}, 200)
				}
			}, 300)
		}

		function transformDateTime(arrTime) {
			var arrFormatedTime = [];
			var tmp;

			self.eventDate = {
				day: moment(arrTime[0].start_datetime).format('DD'),
				month: moment(arrTime[0].start_datetime).format('MMM')
			};

			for (var i = 0; i < arrTime.length; i++) {
				tmp = moment(arrTime[i].start_datetime).format('llll');
				tmp += " - ";
				tmp += moment(arrTime[i].end_datetime).format('h:mm A');
				arrFormatedTime.push(tmp);
			}

			return arrFormatedTime;
		}

		function calAvailableSpot() {
			if (self.data.stats.available) {
				self.availableTicketLabel = self.data.stats.available + ' spots left';
				self.isFewSpotsLeft = (self.data && self.data.stats && self.data.stats.available && self.data.max_attendees && (self.data.stats.available > 0)) ? (10 * (self.data.stats.available / self.data.max_attendees) < 2) : false;
			} else {
				self.availableTicketLabel = 'Full';
			}
		}

		function onInterested() {
			if (self.data.stats.available && self.data.has_joined) {
				confirmPopupSvc.showPopup({
					windowClass: 'change-status-event-popup',
					title: 'Changing your event status?',
					message: 'The event has limited capacity. You will not be able to attend the event once it’s fully booked.',
					submitBtnText: 'continue',
					cancelBtnText: 'cancel',
					submit: function () {
						var def = $q.defer();
						pixerfApiEventSvc.toggleInterest({
							id: self.data.id
						}, {}).$promise.then(function (res) {
							self.data = res.data;
							calAvailableSpot();
							def.resolve(res);
						}).catch(function (err) {
							console.log(err);
							def.reject(err);
						})
						return def.promise;
					}
				});
			} else {
				pixerfApiEventSvc.toggleInterest({
					id: self.data.id
				}, {}).$promise.then(function (res) {
					self.data = res.data;
					calAvailableSpot();
				}).catch(function (err) {
					console.log(err);
				})
			}
		}

		function onGoing() {
			if (self.data.has_joined) {
				if(self.data.admission_type == 'ticketed_pixerf'){
					return;
				}
				confirmPopupSvc.showPopup({
					windowClass: 'change-status-event-popup',
					title: 'Changing your event status?',
					message: 'The event has limited capacity. You will not be able to attend the event once it’s fully booked.',
					submitBtnText: 'continue',
					cancelBtnText: 'cancel',
					submit: function () {
						var def = $q.defer();
						pixerfApiEventSvc.toggleJoin({
							id: self.data.id
						}, {}).$promise.then(function (res) {
							self.data = res.data;
							calAvailableSpot();
							def.resolve(res);
						}).catch(function (err) {
							console.log(err);
							def.reject(err);
						})
						return def.promise;
					}
				});
			} else if(self.data.capacity_type === 'limited' && self.data.stats.available){

				if(!self.data.has_joined && self.data.admission_type == 'ticketed_pixerf'){
					return processPaymentEvent();
				}
				pixerfApiEventSvc.toggleJoin({
					id: self.data.id
				}, {}).$promise.then(function (res) {
					self.data = res.data;
					calAvailableSpot();
				}).catch(function (err) {
					console.log(err);
				})
			}
		}

		function processPaymentEvent(){
			setInterestedEvent();
			$state.go('checkout.event-payment', {
				id: self.data.id
			});
		}

		function setInterestedEvent(){
			if(!self.data.has_interest){
				onInterested();
			}
		}

		function onReportEvent() {
			pixerfDiscussionReportPopupSvc.showPopup({
				id: self.data.id,
				target: 'report_community_event'
			});
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('eventDetailTile', eventDetailTile);

	eventDetailTile.$inject = [];

	function eventDetailTile() {

		var directive = {
			scope: {
				data: "="
			},
			restrict: 'E',
			templateUrl: 'app/components/event-detail-tile/event-detail-tile.html',
			controller: 'eventDetailTileCtrl',
			controllerAs: 'vm',
			replace: true
		};
		return directive;
	}

})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('eventDetailCompileTemplateCtrl', eventDetailCompileTemplateCtrl);

		eventDetailCompileTemplateCtrl.$inject = ['$scope', '$q', 
			'confirmPopupSvc', 'pixerfApiCommunitySvc', 'sessionManagerSvc', '$window', 'messageConst', '$translate', 'ISO3166', 
			'pixerfApiEventSvc', 'pixerfUrl', 'uploadCoverPopupSvc', 'systemUtils', 'accountUtils', 'toastr', 'inviteUserPopupSvc', 'translationSvc'];

	function eventDetailCompileTemplateCtrl($scope, $q,
			confirmPopupSvc, pixerfApiCommunitySvc, sessionManagerSvc, $window, messageConst, $translate, ISO3166, 
			 pixerfApiEventSvc, pixerfUrl, uploadCoverPopupSvc, systemUtils, accountUtils, toastr, inviteUserPopupSvc, translationSvc) {

		var USER_CONTROL_ADMINDASHBOARD = ['curator_internal', 'admin_internal', 'marketer_internal'];
		var self = this;
		self.loginedUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.isAdmin = self.loginedUser && (USER_CONTROL_ADMINDASHBOARD.includes(self.loginedUser.role) || self.loginedUser.email === 'marcom@pixerf.com');
		self.event = Object.assign({}, $scope.event);
		self.eventBackup = Object.assign({}, $scope.event);
		self.onClosed = onClosed;
		self.viewStates = {
			eventDetail: 'EVENT_DETAIL',
			attendees: 'ATTENDEES'
		}
		self.editMode = false;
		self.state = self.viewStates.eventDetail;
		self.onEditEventBtnClicked = onEditEventBtnClicked;
		self.onShareEventBtnClicked = onShareEventBtnClicked;
		self.onSaveEventBtnClicked = onSaveEventBtnClicked;
		self.onCancelSaveEventBtnClicked = onCancelSaveEventBtnClicked;
		self.onRemoveDateTime = onRemoveDateTime;
		self.canCancelEvent = false;
		self.showEventHasEndedBtn = false;
		self.showInreviewMessage = false;
		self.showInreviewMessageBottom = false;
		self.onShowInreviewMessage = onShowInreviewMessage;
		self.onShowInreviewMessagebottom = onShowInreviewMessagebottom;
		self.timerOptions = {
			hideSecondLabel: true,
			noSecond: true,
			showPm: true
		};
		self.onAddDateTime = onAddDateTime;
		self.eventTypes = [{
					value: 'free',
					title: "Free Event",
					description: "Do not need to issue tickets to attendees."
				},
				{
					value: 'ticketed_external',
					title: "Ticketed Event via External Link",
					description: "Event goers require a ticket to join the event. Tickets sold through an external link."
				},
					// {
					// 	value: 3,
					// 	title: "Ticketed Event via PIXERF",
					// 	description: "Event goers require a ticket to join the event. Tickets are sold via PIXERF."
					// }
			];
		self.onEventTypeChanged = onEventTypeChanged;
		self.onCapacityTypeChanged = onCapacityTypeChanged;
		self.onAdmissionTypesChanged = onAdmissionTypesChanged;
		self.capacityTypes = [{
				value: 'unlimited',
				title: "Unlimited Capacity",
				description: "Do not set a limit to the number of guests."
			},
			{
				value: 'limited',
				title: "Limited Capacity",
				description: "Event is limited to a fixed number of guests."
			}
		];
		
		self.admissionTypes = [{
				value: false,
				title: "Public Event",
				description: "Allow anyone to attend."
			},
			{
				value: true,
				title: "Private Event",
				description: "Only members of the Community can join the event"
			}
		];
		self.uploadEventCoverOptions = {
			dropzoneConfig: {
				'options': {
					url: pixerfUrl.full + 'api/community_events/',
					method: 'put',
					paramName: 'cover',
					autoProcessQueue: false,
				},
				eventHandlers: {
					"success": function (file, respone) {
						self.event = respone;
						$scope.onClosed({
							event: self.event
						});
					}
				}
			},
			isManual: true,
			introText: "Choose a photo as your event cover",
			canEdit: true,
			editText: "Change event cover",
			cropper: {
				options: {
					viewport: {
						type: 'square'
					},
					boundary: {
						width: 500,
						height: 160
					},
					showZoomer: false
				}
			}
		};
		self.eventStatFilterBy = [];
		self.defaultEventStatFilterBy = "going";

		self.defaultEventType = self.eventTypes[0].value;
		self.defaultCapacityType = self.capacityTypes[0].value;
		self.defaultAdmissionTypes = self.admissionTypes[0].value;
		self.commnunityCover = '/assets/images/default/community-default-avatar.png';
		self.eventCover = {};
		self.showUploadAvatarPopup = showUploadAvatarPopup;
		self.onEventStatFilterByChanged = onEventStatFilterByChanged;

		self.eventInvitedList = [];
		self.eventAttendees = [];
		self.getAttendees = getAttendees;
		self.showUserControl = showUserControl;
		self.onInviteMembers = onInviteMembers;
		self.onPublishBtnClicked = onPublishBtnClicked;
		self.onSaveAndPublishBtnClicked = onSaveAndPublishBtnClicked;
		self.onDeleteThisDraftBtnClicked = onDeleteThisDraftBtnClicked;
		self.showAttendeesTab = showAttendeesTab;
		
		self.isShowInviteButton = false;
		self.coverImage = (self.event.cover && self.event.cover.original) ? self.event.cover.original : null;;
		self.link = window.location.origin +( window.location.pathname || '') + '#/ce/' + self.event.short_code;
		self.defaultShareText = "Hi there! I would like to invite you to join the event \"" + self.event.name + "\" on PIXERF. " + self.link;
		self.SocialShareContent = buildSocialShareContent();
		self.onRemovedUser = onRemovedUser;
		self.onCancelThisEventBtnClicked = cancelEvent
		self.onDeleteEventBtnClicked = onDeleteEventBtnClicked;
		self.onApproveEventBtnClicked = onApproveEventBtnClicked;
		self.onRejectEventBtnClicked = onRejectEventBtnClicked;

		self.showShareBtn = false;
		self.showEditEventBtn = false;
		self.showCancelBtn = false;
		self.showSaveBtn = false;
		self.showTitleBottomCancelThisEvent = false;
		self.showCancelBtnBottom = false;
		self.showCancelBtn = false;
		self.showEditDraftBtn = false;
		self.showPublishBtn = false;
		self.showSaveAndPublishBtn = false;
		self.showSaveDraftBtn = false;
		self.showSaveDraftBtnBottom = false;
		self.showSaveAndPublishBtnBottom = false;
		self.showTitleBottomDeleteThisDraft = false;
		self.showDeleteBtn = false;
		self.showEventCancelledBtn = false;
		self.showEventRejectedBtn = false;
		self.showEventDeletedBtn = false;
		self.showEventInReviewBtn = false;
		self.showEventInReviewBtnBottom = false;
		self.showApproveBtn = false;
		self.showRejectBtn = false;
		
		function init() {
			generateUserLayout($scope.context);

			generateEventStatsCount();
			self.statsFilter = self.eventStatFilterBy[0];
			self.dateTimes = reTransformDateTime( self.event.event_datetimes);
			self.defaultAdmissionTypes = self.event.is_private;
			self.eventCover.url = (self.event.cover && self.event.cover.original) ? self.event.cover.original : null;
			getCommunity();
			getEventInvited();
			getEventAttendees();
			getEventInterestedList();
			self.userContext = 'going';
			if($scope.options && $scope.options.editEventDetail){
				self.editMode = true;
			}
			if($scope.options && $scope.options.manageAttendees){
				self.state = self.viewStates.attendees;
			}

			self.schedules = transformSchedules(self.event.event_datetimes);
			transformDisplayData();
		}

		function onRemoveDateTime(index) {
			self.dateTimes.splice(index, 1);
		}

		function generateUserLayout(context) {
			switch (context) {
				case 'ongoing':
					self.isShowInviteButton = true;
					self.showShareBtn = true;
					self.showEditEventBtn = true;
					self.showCancelBtn = true;
					self.showSaveBtn = true;
					self.showSaveBtnBottom = true;
					self.showTitleBottomCancelThisEvent = true;
					self.showCancelBtnBottom = true;
					self.canCancelEvent = false;
					self.showCancelBtn = true;
					break;
				case 'upcoming':
					self.isShowInviteButton = true;
					self.showShareBtn = true;
					self.showEditEventBtn = true;
					self.showCancelBtn = true;
					self.showSaveBtn = true;
					self.showTitleBottomCancelThisEvent = true;
					self.showCancelBtnBottom = true;
					self.showCancelBtn = true;
					self.canCancelEvent = true;
					self.showSaveBtnBottom = true;
					break;
				case 'past':
					self.showCancelBtn = true;
					self.showSaveBtn = true;
					self.showEventHasEndedBtn = true;
					self.showCancelBtnBottom = true;
					self.showCancelBtn = true;
					break;
				case 'unpublished':
					switch (self.event.status) {
						case 'draft':
							self.showEditDraftBtn = true;
							self.showPublishBtn = true;
							self.showSaveAndPublishBtn = true;
							self.showSaveDraftBtn = true;
							self.showSaveDraftBtnBottom = true;
							self.showSaveAndPublishBtnBottom = true;
							self.showTitleBottomDeleteThisDraft = true;
							break;
						case 'cancelled':
							self.showDeleteBtn = true;
							self.showEventCancelledBtn = true;
							break;
						case 'rejected':
							self.showDeleteBtn = true;
							self.showEventRejectedBtn = true;
							break;
						case 'deleted':
							self.showEventDeletedBtn = true;
							break;
					}
					break;
				case 'inReview':
					self.showEventInReviewBtn = true;
					self.showEventInReviewBtnBottom = true;
					if(self.isAdmin){
						self.showApproveBtn = true;
						self.showRejectBtn = true;
						self.showEventInReviewBtn = false;
						self.showEventInReviewBtnBottom = false;
					}
					break;
			}
		}

		function onShowInreviewMessage(){
			self.showEventInReviewBtn = false;
			self.showInreviewMessage = true;
		}

		function onShowInreviewMessagebottom(){
			self.showEventInReviewBtnBottom = false;
			self.showInreviewMessageBottom = true;
		}

		function onClosed() {
			$scope.onClosed({
				community: self.event
			});
		}

		function prevenPubbleClick() {
			$window.event.stopPropagation();
		}

		if (self.schedules && self.schedules[0] && self.schedules[0].date) {
			self.date = {
				day: moment(self.schedules[0].date).format("DD"),
				month: moment(self.schedules[0].date).format("MMM")
			}
		}

		function transformSchedules(schedules) {
			var schedulesArr = [];

			for (var i = 0; i < schedules.length; i++) {
				schedulesArr.push({
					date: moment(schedules[i].start_datetime).format('dddd, MMMM DD, YYYY'),
					time: moment(schedules[i].start_datetime).format('h:mmA') + ' to ' + moment(schedules[i].end_datetime).format('h:mmA')
				});
			}

			return schedulesArr;
		}

		function onEditEventBtnClicked(){
			self.editMode = true;
			self.defaultEventType = self.event.admission_type;
		}	

		function onShareEventBtnClicked(){

		
		}

		function onSaveEventBtnClicked(notChangStatus){
			if(!validate()) return;
			// self.event.is_private = true;//TODO
			var eventToSave = Object.assign({}, self.event);
			notChangStatus ? '' : (eventToSave.status = 'active');
			delete eventToSave.cover;
			var convertData = transformEventObject(self.event);
			eventToSave.event_datetimes = convertData.event_datetimes;
			eventToSave.location = convertData.location;
			pixerfApiEventSvc.update({
				id: eventToSave.id
			}, eventToSave).$promise.then(function (res) {
				$scope.event = res.data;
				self.event = Object.assign({}, $scope.event);
				self.eventBackup = Object.assign({}, $scope.event);
				self.dateTimes = reTransformDateTime(res.data.event_datetimes);
				if (self.dropzoneInstance) {
					self.dropzoneInstance.options.url = pixerfUrl.full + 'api/community_events/' + self.event.id;
					self.dropzoneInstance.processQueue();
				} else {
					$scope.onClosed({
						event: self.event
					});
				}
				toastr.success("Your event updated successfully");
				systemUtils.digest($scope);
				self.editMode = false;
			}).catch(function (err) {
				console.log(err);
			})
		}

		function validate(eventData){
			var result = true;
			for (var i = 0; i < self.dateTimes.length; i++) {
				var formattedDate = transformTime(self.dateTimes[i]);
				if (! self.dateTimes[i].date || _.isEmpty(formattedDate)) {
					result = false;
					toastr.error("Invalid time ");
				}
			}
			return result;
		}

		function transformTime(date) {
			var formattedStartDate = moment(date.date.getDate() + "/" + (date.date.getMonth() + 1) + "/" + date.date.getFullYear() + " " + date.start_time, "DD/MM/YYYY HH:mm:ss");
			var formattedEndDate = moment(date.date.getDate() + "/" + (date.date.getMonth() + 1) + "/" + date.date.getFullYear() + " " + date.end_time, "DD/MM/YYYY HH:mm:ss");
			var isValidDuration = moment(formattedEndDate, "DD/MM/YYYY HH:mm:ss").diff(moment(formattedStartDate, "DD/MM/YYYY HH:mm:ss")) >= 0;

			if (!isValidDuration) {
				return {};
			}

			return {
				start_datetime: formattedStartDate.format(),
				end_datetime: formattedEndDate.format()
			};
		}

		function transformEventObject(eventData) {
			var transformedEvent = {
				event_datetimes: []
			};
			if(eventData.id){
				transformedEvent.id = self.event.id;
			}

			transformedEvent.name = self.event.name;
			transformedEvent.description = self.event.description;
			transformedEvent.is_private = self.event.is_private;
			transformedEvent.capacity_type = self.event.capacity_type;
			transformedEvent.admission_type = self.event.admission_type;
			transformedEvent.ticket_url = self.event.ticket_url;
			transformedEvent.max_attendees = self.event.max_attendees;

			if (eventData.location) {
				transformedEvent.location = accountUtils.getUserGoogleLocation(eventData.location);
			}

			for (var i = 0; i < self.dateTimes.length; i++) {
				var formattedDate = transformTime(self.dateTimes[i]);
				if (self.dateTimes[i].date && !_.isEmpty(formattedDate)) {
					transformedEvent.event_datetimes.push(formattedDate);
				}
			}

			return transformedEvent;
		}

		function onCancelSaveEventBtnClicked(){
			self.event = Object.assign({}, self.eventBackup);
			self.editMode = false;
		}

		function reTransformDateTime(dateTimes){
			var result = [];
			for (var i = 0; i < dateTimes.length; i++) {

				var formattedDate = {
					date: new Date(dateTimes[i].start_datetime)
				};

				if(parseInt(moment(new Date(dateTimes[i].start_datetime)).format("HH")) > 12){
					formattedDate.start_time = {
						hour: parseInt(moment(new Date(dateTimes[i].start_datetime)).format("HH")) - 12,
						min: parseInt(moment(new Date(dateTimes[i].start_datetime)).format("mm")),
						second: parseInt(moment(new Date(dateTimes[i].start_datetime)).format("ss")),
						options: "PM"
					}
				} else {
					formattedDate.start_time = {
						hour: parseInt(moment(new Date(dateTimes[i].start_datetime)).format("HH")),
						min: parseInt(moment(new Date(dateTimes[i].start_datetime)).format("mm")),
						second: parseInt(moment(new Date(dateTimes[i].start_datetime)).format("ss")),
						options: "AM"
					}
				}

				if(formattedDate.start_time.hour < 10){
					formattedDate.start_time.hour = "0" + formattedDate.start_time.hour;
				}
				if(formattedDate.start_time.min < 10){
					formattedDate.start_time.min = "0" + formattedDate.start_time.min;
				}

				if(parseInt(moment(new Date(dateTimes[i].end_datetime)).format("HH")) > 12){
					formattedDate.end_time = {
						hour: parseInt(moment(new Date(dateTimes[i].end_datetime)).format("HH")) - 12,
						min: parseInt(moment(new Date(dateTimes[i].end_datetime)).format("mm")),
						second: parseInt(moment(new Date(dateTimes[i].end_datetime)).format("ss")),
						options: "PM"
					}
				} else {
					formattedDate.end_time = {
						hour: parseInt(moment(new Date(dateTimes[i].end_datetime)).format("HH")),
						min: parseInt(moment(new Date(dateTimes[i].end_datetime)).format("mm")),
						second: parseInt(moment(new Date(dateTimes[i].end_datetime)).format("ss")),
						options: "AM"
					}
				}

				if(formattedDate.end_time.hour < 10){
					formattedDate.end_time.hour = "0" + formattedDate.end_time.hour;
				}
				if(formattedDate.end_time.min < 10){
					formattedDate.end_time.min = "0" + formattedDate.end_time.min;
				}

				if (formattedDate.date && !_.isEmpty(formattedDate)) {
					result.push(formattedDate);
				}
			}

			return result;

		}
		
		function onAddDateTime() {
			self.dateTimes.push({
				date: null,
				start_time: null,
				end_time: null
			});
		}

		function onEventTypeChanged(item) {
			self.event.admission_type = item.value;
		}

		function onCapacityTypeChanged(item) {
			self.isLimitedCapacity = item.value === 'limited';
			self.event.capacity_type = item.value;
		}

		function onAdmissionTypesChanged(item) {
			self.event.is_private = item.value;
		}

		function getCommunity() {
			var defer = $q.defer();
			var communityId = self.event.community_id;
			if(!communityId){
				return defer.reject();
			}
			pixerfApiCommunitySvc.get({
				id: communityId
			}).$promise.then(function (response) {
				self.community = response.data;
				self.commnunityCover = (self.community && self.community.cover && self.community.cover.thumbnail) ? self.community.cover.thumbnail : '/assets/images/default/community-default-avatar.png';
				defer.resolve(self.community);
			}, function (err) {
				console.log(err);
				defer.reject(err);
			})
			return defer.promise;
		}

		function getEventAttendees() {
			var defer = $q.defer();
			var eventId = self.event.id;
			if(!eventId){
				return defer.reject();
			}
			pixerfApiEventSvc.getEventAttendees({
				id: eventId
			}).$promise.then(function (response) {
				self.eventAttendees.going = filterEventAttendees(response.data);
				defer.resolve(self.eventAttendees.going);
			}, function (err) {
				console.log(err);
				defer.reject(err);
			})
			return defer.promise;
		}

		function transformedUser(data){
			return (data.user ? data.user : data);
		}

		function transformedUserList(data){
			var people = [];
			for (var i = 0; i < data.length; i++) {
				people.push(transformedUser(data[i]));
			}
			return people;
		}

		function filterEventAttendees(users){
			var goingList = [];
			var interestedList = [];
			for(var i =0; i < users.length; i++){
				if(users[i].status == 'going' || users[i].status == "joined"){
					goingList.push(transformedUser(users[i]));
				}else{
					interestedList.push(transformedUser(users[i]));
				}
			}
			return goingList;
		}

		function getEventInvited() {
			var defer = $q.defer();
			var eventId = self.event.id;
			if(!eventId){
				return defer.reject();
			}
			pixerfApiEventSvc.getEventInvited({
				id: eventId
			}).$promise.then(function (response) {
				self.eventInvitedList = transformedUserList(response.data);
				defer.resolve(self.eventInvitedList);
			}, function (err) {
				console.log(err);
				defer.reject(err);
			})
			return defer.promise;
		}

		function getEventInterestedList() {
			var defer = $q.defer();
			var eventId = self.event.id;
			if(!eventId){
				return defer.reject();
			}
			pixerfApiCommunitySvc['list_interested_event']({
				id: eventId,
				status: 'interested',
				type: 'list-interested-event'
			}).$promise.then(function (response) {
				self.eventAttendees.interested = transformedUserList(response.data);
				defer.resolve(self.eventAttendees.interested);
			}, function (err) {
				console.log(err);
				defer.reject(err);
			})
			return defer.promise;
		}

		function onEventStatFilterByChanged(data){
			self.statsFilter = data;
			self.userContext = self.statsFilter.value;
		}

		function showUploadAvatarPopup() {
			if (self.uploadEventCoverOptions && self.uploadEventCoverOptions.canEdit) {
				var popup = uploadCoverPopupSvc.showPopup(self.uploadEventCoverOptions);

				popup.result.then(function (instance) {
					self.eventCover.url = instance.thumbnail;
					systemUtils.digest($scope);

					self.dropzoneInstance = instance.dropzone;
				})
			}
		}

		function generateEventStatsCount() {
			self.eventStatFilterBy = [{
				value: "going",
				users: self.event.stats.going,
				title: "Going (" + self.event.stats.going + ")",
				desc: "confirmed attendees"
			},
			{
				value: "invited",
				users: self.event.stats.invited,
				title: "Invited (" + self.event.stats.invited + ")",
				desc: "pending invitations",
				note: "Note: Only users invited from the Directory are listed."
			},
			{
				value: "interested",
				users: self.event.stats.interested,
				title: "Interested (" + self.event.stats.interested + ")",
				desc: "interested attendees"
			}];
		}

		function showUserControl(){
			if(self.event.status == 'cancelled'){
				return false;
			}
			return true;
		}

		function getAttendees(){
			var result = [];
			switch (self.statsFilter.value) {
				case 'going':
					result = genDisplayName(self.eventAttendees.going);
					break;
				case 'invited':
					result = genDisplayName(self.eventInvitedList);
					break;
				case 'interested':
					result = genDisplayName(self.eventAttendees.interested);
					break;
				default:
					result = genDisplayName(self.eventAttendees.going);
					break;
			}
			return result;
		}

		function genDisplayName(datas) {
			if (datas && datas.length) {
				for (var i = 0; i < datas.length; i++) {
					datas[i].displayName = accountUtils.buildUserDisplayName(datas[i]);
					datas[i].avatar = accountUtils.buildUserAvatarPhotoUrl(datas[i]);
				}
			}

			return datas;
		}

		function onInviteMembers() {
			var popup = inviteUserPopupSvc.showPopup({
				options: {
					title: "Invite members to Event"
				},
				community: {
					id: self.event.community_id,
				},
				event: {
					id: self.event.id,
					short_code: self.event.short_code
				},
				defaultSearchCondition: {
					isDirectoryChecked: true,
					isEmailChecked: false,
					speciality: "",
				}
			});
			popup.result.then(function (invitedPeoples) {
				console.log(invitedPeoples);
				// invitationSentHandler(invitedPeoples);
			});
		}

		function updateEventStatus( status){
			var eventToSave = Object.assign({}, self.event);
			eventToSave.status = status;
			delete eventToSave.cover;
			var convertData = transformEventObject(self.event);
			eventToSave.event_datetimes = convertData.event_datetimes;
			eventToSave.location = convertData.location;
			var def = $q.defer();
			pixerfApiEventSvc.update({
				id: eventToSave.id
			}, eventToSave).$promise.then(function (res) {
				$scope.event = res.data;
				self.event = Object.assign({}, $scope.event);
				self.eventBackup = Object.assign({}, $scope.event);
				self.dateTimes = reTransformDateTime(res.data.event_datetimes);
				$scope.onClosed({
					event: self.event
				});
				toastr.success("Your event updated successfully");
				systemUtils.digest($scope);
				def.resolve(res);
			}).catch(function (err) {
				console.log(err);
				def.reject(err);
			})

			return def.promise;
		}

		function onPublishBtnClicked(){
			self.event = Object.assign({}, self.eventBackup);
			updateEventStatus('active');
		}

		function onDeleteEventBtnClicked(){
			confirmPopupSvc.showPopup({
				windowClass: 'delete-event-confirm-popup',
				title: $translate.instant("you-are-about-to-delete-this-event"),
				message: $translate.instant("deleting-your-Event-will-remove-it"),
				submitBtnText: 'Yes',
				cancelBtnText: 'Cancel',
				submit: function () {
					var def = $q.defer();
					updateEventStatus('deleted').then(
						function(res){
							def.resolve(res);
						},
						function(err){
							def.reject(err);
						}
					);
					return def.promise;
				},
				submitCallback: function () {
					systemUtils.digest($scope);
				}
			});
		}

		function onApproveEventBtnClicked(){
			updateEventStatus('active');
		}

		function onRejectEventBtnClicked(){
			confirmPopupSvc.showPopup({
				windowClass: 'reject-event-confirm-popup',
				title: $translate.instant("you-are-about-to-reject-this-event"),
				message: $translate.instant("reject-your-Event-will-remove-it"),
				submitBtnText: 'Yes',
				cancelBtnText: 'Cancel',
				submit: function () {
					var def = $q.defer();
					updateEventStatus('rejected').then(
						function(res){
							def.resolve(res);
						},
						function(err){
							def.reject(err);
						}
					);
					return def.promise;
				},
				submitCallback: function () {
					systemUtils.digest($scope);
				}
			});
		}

		function onSaveAndPublishBtnClicked(){
			self.event.status = 'active';
			onSaveEventBtnClicked();
		}

		function onDeleteThisDraftBtnClicked(){
			confirmPopupSvc.showPopup({
				windowClass: 'delete-draft-event-confirm-popup',
				title: $translate.instant("you-are-about-to-delete-this-draft"),
				message: $translate.instant("you-cannot-undo-this-action"),
				submitBtnText: 'Yes',
				cancelBtnText: 'Cancel',
				submit: function () {
					self.event = Object.assign({}, self.eventBackup);
					var def = $q.defer();
					updateEventStatus('deleted').then(
						function(res){
							def.resolve(res);
						},
						function(err){
							def.reject(err);
						}
					);
					return def.promise;
				},
				submitCallback: function () {
					systemUtils.digest($scope);
				}
			});
		}

		function cancelEvent(event){
			confirmPopupSvc.showPopup({
				windowClass: 'cancel-event-confirm-popup',
				title: $translate.instant("you-are-about-to-cancel-this-event"),
				message: $translate.instant("if-you-cancel-this-event"),
				submitBtnText: 'Yes',
				cancelBtnText: 'Cancel',
				submit: function () {
					var def = $q.defer();
					pixerfApiCommunitySvc.cancel_community_event({ id: event.id }).$promise.then(
						function success(res) {
							self.event.status = res.data.status;
							
							toastr.success("this event has been successfully canceled");
							def.resolve(res);
						},
						function error(err) {
							toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
							console.log(err);
							def.reject(err);
						}
					);
					return def.promise;
				},
				submitCallback: function () {
					$scope.onClosed({
						event: event
					});
					systemUtils.digest($scope);
				}
			});
		}

		function buildSocialShareContent(){
			return {'url': self.link, 'description': self.defaultShareText, 'title': self.event.name, 'media': self.coverImage};
		}

		function showAttendeesTab(){
			return (self.event.status != 'draft') || ($scope.context == 'inReview' && self.isAdmin);
		}
		
		function onRemovedUser(user){
			switch (self.statsFilter.value) {
				case 'going':
					self.eventAttendees.going = _.without(self.eventAttendees.going, _.findWhere(aself.eventAttendees.goingrr, {id: user.id }));
					break;
				case 'invited':
					self.eventInvitedList = _.without(self.eventInvitedList, _.findWhere(self.eventInvitedList, {id: user.id }));
					break;
				case 'interested':
					self.eventAttendees.interested = _.without(self.eventAttendees.interested, _.findWhere(self.eventAttendees.interested, {id: user.id }));
					break;
			}
		}

		function transformDisplayData(){
			switch (self.event.admission_type){
				case 'free':
					self.event.admission_type_show = 'Free';
					break;
				case 'ticketed_external':
					self.event.admission_type_show = 'Ticketed external';
					break;
			}
			if(!self.event.max_attendees){
				self.event.max_attendees_show = 'No limit';
				self.defaultCapacityType = self.capacityTypes[0].value;
				self.isLimitedCapacity = false;
			} else {
				self.event.max_attendees_show = self.event.max_attendees;
				self.defaultCapacityType = self.capacityTypes[1].value;
				self.isLimitedCapacity = true;
			}
		}
		
		init();
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('eventDetailCompileTemplate', eventDetailCompileTemplate);
		eventDetailCompileTemplate.$inject = [];

	function eventDetailCompileTemplate() {

		var directive = {
			scope: {
				event: "=",
				onClosed: "&",
				options:"=",
				onStatusChanged: "&?",
				context: "@",
				appendToBody: "@?"
			},
			restrict: 'E',
			templateUrl: 'app/components/event-detail-compile-template/event-detail-compile-template.html',
			controller: 'eventDetailCompileTemplateCtrl',
			controllerAs: 'vm',
			replace: true
		};
		return directive;
	}

})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('emptySectionCtrl', emptySectionCtrl);

	emptySectionCtrl.$inject = ['$scope'];

	function emptySectionCtrl($scope) {

		var self = this;
		self.onAction = onAction;
		self.content = $scope.content;

		function onAction() {
			$scope.onSubmit();
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('emptySection', emptySection);

	emptySection.$inject = [];

	function emptySection() {

		var directive = {
			scope: {
                content: "=",
                onSubmit: "&"
			},
			restrict: 'E',
			templateUrl: 'app/components/empty-section/empty-section.html',
			controller: 'emptySectionCtrl',
			controllerAs: 'vm',
			replace: true
		};
		return directive;
	}

})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('emptyProfileLandingPageCtrl', emptyProfileLandingPageCtrl);

		emptyProfileLandingPageCtrl.$inject = ['$scope', 'sessionManagerSvc', 'accountConst', '$translate', '$timeout', 'uploadPhotoSvc', 'uploadPortfolioPhotoSvc', '$state'
			,'createGallerySvc', 'createCommunityPopupSvc', '$rootScope', 'messageConst', 'customCommissionBasicFormPopupSvc', 'alertMessagePopupSvc'];

	function emptyProfileLandingPageCtrl($scope, sessionManagerSvc, accountConst, $translate, $timeout, uploadPhotoSvc, uploadPortfolioPhotoSvc, $state
			,createGallerySvc, createCommunityPopupSvc, $rootScope, messageConst, customCommissionBasicFormPopupSvc, alertMessagePopupSvc) {

		var self = this;
		self.dataToShow = {};
		self.footerText = $translate('use-galleries-to-curate');
		self.loginedUser = sessionManagerSvc.getCurrentLoginUser().data;

		$rootScope.$on(messageConst.BROADCAST.USER_DATA_CHANGE, function () {
			self.loginedUser = sessionManagerSvc.getCurrentLoginUser().data;
			buildData();
		});

		function buildData(){
			
			switch (self.loginedUser.account_type) {
				case accountConst.ACCOUNT_TYPE.BUSINESS:
					self.dataToShow = {
						buyImages: {
							action: buyImagesClicked,
							desc: 'Buy images',
							icon: 'buy-images'
						},
						viewCreditPlans: {
							action: viewCreditPlansClicked,
							desc: 'View credit plans',
							icon: 'credit-plans'
						},
						createAcommunity: {
							action: createAcommunityClicked,
							desc: 'Create a community',
							icon: 'create-community'
						},
						bookAShoot: {
							action: bookAShootClicked,
							desc: 'Book a Shoot',
							icon: 'create-custom-commission'
						}
					};
					self.numberOfDataShow = Object.keys(self.dataToShow).length;
					self.footerText = "";
					break;
				case accountConst.ACCOUNT_TYPE.PERSONAL:
					self.dataToShow = {
						uploadAphoto: {
							action: uploadAphotoClicked,
							desc: 'Upload a photo',
							icon: 'upload-a-photo'
						},
						createAportfolio: {
							hidden: (!self.loginedUser.profile || !self.loginedUser.profile.specialities || !self.loginedUser.profile.specialities.length),
							action: createAportfolioClicked,
							desc: 'Create a portfolio*',
							icon: 'create-portfolio'
						},
						joinAcommunity: {
							action: joinAcommunityClicked,
							desc: 'Join a community',
							icon: 'join-community'
						},
						createAgallery: {
							action: createAgalleryClicked,
							desc: 'Create a gallery*',
							icon: 'create-gallery'
						},
						buyImages: {
							action: buyImagesClicked,
							desc: 'Buy images',
							icon: 'buy-images'
						}
					};
					if(!self.loginedUser.profile || !self.loginedUser.profile.specialities || !self.loginedUser.profile.specialities.length){
						self.numberOfDataShow = Object.keys(self.dataToShow).length - 1;
					} else {
						self.numberOfDataShow = Object.keys(self.dataToShow).length;
					}
					self.footerText = $translate.instant('creator-use-galleries-to-curate');
					break;
				default:
					self.dataToShow = {
						buyImagesNow: {
							action: buyImagesClicked,
							desc: 'Buy images now',
							icon: 'buy-images'
						},
						createAgallery: {
							action: createAgalleryClicked,
							desc: 'Create a gallery*',
							icon: 'create-gallery'
						}
					};
					self.numberOfDataShow = Object.keys(self.dataToShow).length;
					self.footerText = $translate.instant('use-galleries-to-curate');
					break;
			}
		}

		function onCloseBtnClicked() {
			$timeout(function () {
				$("body").trigger("click");
			});
		}

		function uploadAphotoClicked(){
			onCloseBtnClicked();
			uploadPhotoSvc.showUploadModal();
		}

		function buyImagesClicked(){
			$state.go('buy-stock-page.galleries.signature-galleries');
		}

		function createAgalleryClicked(){
			createGallerySvc.showCreateGalleryModal({
				type: 'default',
				overridSuccessMsg: true
			});
		}

		function createAcommunityClicked(){
			createCommunityPopupSvc.showPopup();
		}

		function createAportfolioClicked(){
			uploadPortfolioPhotoSvc.showUploadModal({
				portfolioId: null
			});
		}

		function joinAcommunityClicked(){
			alertMessagePopupSvc.showPopup({
				title: "Watch this space – we’ll be launching the Community Page soon!"
			});
			// $state.go("for-creator-page.about-community");
		}

		function viewCreditPlansClicked(){
			$state.go("checkout.credit-plan.credit-plan-list", {
				hashtag: "creditplan"
			});
		}

		function init() {
			if(self.loginedUser){
				buildData();
			}
		}

		function bookAShootClicked(){
			customCommissionBasicFormPopupSvc.showPopup();
		}

		init();
	}
})();

(function () {
  'use strict';

  angular
    .module('pixerf')
    .directive('emptyProfileLandingPage', emptyProfileLandingPage);

  function emptyProfileLandingPage() {

    var directive = {
      scope: {
      },
      restrict: 'E',
      templateUrl: 'app/components/empty-profile-landing-page/empty-profile-landing-page.html',
      replace: true,
      controller: 'emptyProfileLandingPageCtrl',
      controllerAs: 'vm'
    };
    return directive;
  }

})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.factory('emailUsPopupSvc', emailUsPopupSvc);
	emailUsPopupSvc.$inject = ['$uibModal', '$translate'];

	function emailUsPopupSvc($uibModal, $translate) {

        function validateForm(data, form){
            form.$setDirty();
            var errMsg = '';
            if(form.name.$error.required){
                errMsg = $translate.instant('please-input-first-name');
            } else if(form.email.$error.required){
                errMsg = "Please input your email!";
            } else if(form.email.$error.email ){
                errMsg = "Invalid email address";
            } else if(!data.topic){
                errMsg = "Please input your topic!";
            } else if(form.name.$error.validationNoNumber || form.name.$error.validationNoHyperlink){
                errMsg = "Sorry, your first name cannot contain a link or number.";
            } else if(form.description.$error.required){
                errMsg = "Please input your description!";
            } else if(form.description.$error.minlength){
                errMsg = "Description must be at least 50 characters long.";
            }
            return errMsg;
        }

		function showPopup(data) {
			return $uibModal.open({
				templateUrl: 'app/components/email-us-popup/email-us-popup.html',
				controller: 'emailUsPopupCtrl',
				controllerAs: 'vm',
				animation: true,
				windowClass: 'email-us-popup__screen',
				resolve: {
					'resolveData': function () {
						return data;
					}
				}
			});
		}

		return {
            validateForm: validateForm,
			showPopup: showPopup
		};
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('emailUsPopupCtrl', emailUsPopupCtrl);

	emailUsPopupCtrl.$inject = ['$uibModalInstance', '$scope', 'pixerfApiMailSvc', 'emailUsPopupSvc', 'toastr', 'translationSvc', 'sessionManagerSvc', 'resolveData'];

	function emailUsPopupCtrl($uibModalInstance, $scope, pixerfApiMailSvc, emailUsPopupSvc, toastr, translationSvc, sessionManagerSvc, resolveData) {

		var self = this;
		self.close = close;
		var mLoginUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.inquiry = {};
		self.sendEnquire = sendEnquire;
		self.onTopicChanged = onTopicChanged;
		self.isWorking = false;
		self.topicOptions = {
			"dropupAuto": false,
			"noneSelectedText": "Select a topic",
			"maxOptions": 1
		};
		self.selectedTopicId = (resolveData && resolveData.topicId) ? resolveData.topicId : null;
		self.topicTypes = [
			{
				id: 11,
				name: 'Apply as Community Leader'
			},
			{
				id: 6,
				name: 'Billings and getting paid'
			},
			{
				id: 1,
				name: 'Booking a shoot'
			},
			{
				id: 5,
				name: 'Collaborating or partnering with PIXERF'
			},
			{
				id: 12,
				name: 'Credit Plan Purchase (Assignments)'
			},
			{
				id: 13,
				name: 'Credit Plan Purchase (Stock Images)'
			},
			{
				id: 9,
				name: 'Feedback'
			},
			{
				id: 7,
				name: 'My account'
			},
			{
				id: 2,
				name: 'Running a Community Challenge'
			},
			{
				id: 4,
				name: 'Sales enquiries'
			},
			{
				id: 3,
				name: 'Sourcing images'
			},
			{
				id: 8,
				name: 'Technical support'
			},
			{
				id: 10,
				name: 'Others'
			},
		];

		function close() {
			$uibModalInstance.close();
		}

		function sendEnquire(data, form) {
			if (self.isWorking) return;
			var errMsg = emailUsPopupSvc.validateForm(data, form);
			if (errMsg) {
				toastr.error(errMsg);
				return false;
			}
			self.isWorking = true;
			pixerfApiMailSvc.enquire(data).$promise.then(function (respone) {
				self.inquiry = {};
				self.isWorking = false;
				toastr.success("Thanks for your submission, we'll get back to you soon!");
				close();
			}, function () {
				self.isWorking = false;
				toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
			});
		}

		function onTopicChanged(selectedTopic) {
			if (!selectedTopic || !selectedTopic.length) return;
			self.inquiry.topic = selectedTopic[0].name;
		}

		function getTopicName(topicId){
			var result = {};
			if(!topicId) return result;

			for(var index = 0; index < self.topicTypes.length; index++){
				if(self.topicTypes[index].id == topicId){
					result = self.topicTypes[index];
				}
			}

			return result;
		}

		function updateUserInfo(){
			if(!mLoginUser){
				return;
			}

			self.inquiry.name = mLoginUser.displayName;
			self.inquiry.email = mLoginUser.email;
		}
		function updateTopicInfo(){
			self.targetTopic = getTopicName(self.selectedTopicId)
			if(self.targetTopic.id){
				self.topicOptions.noneSelectedText = self.targetTopic.name;
				self.inquiry.topic = self.targetTopic.name;
			}
		}

		function init(){
			updateUserInfo();
			updateTopicInfo();
		}

		init();
	}
})();

(function(){

	angular
	  .module('pixerf')
	  .controller('emailContactPersonCtrl', emailContactPersonCtrl);

	  emailContactPersonCtrl.$inject = [];

	  function emailContactPersonCtrl(){

		  var self = this;
	  }
  })();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('emailContactPerson', emailContactPerson);

	emailContactPerson.$inject = ['$rootScope', '$interval'];
	function emailContactPerson($rootScope, $interval) {

		var directive = {
			scope: {
				contact: "=",
				onSelected: "&?",
				hideSelect: "@?"
			},
			restrict: 'E',
			templateUrl: 'app/components/email-contact-person/email-contact-person.html',
			controller: 'emailContactPersonCtrl',
			controllerAs: 'vm',
			replace: true
		};
		return directive;
	}

})();

/**
 * Controller for home module
 */
(function(){
  'use strict';
  angular
    .module('pixerf')
    .factory('editSubscriptionSvc', editSubscriptionSvc);
    editSubscriptionSvc.$inject = ['pixerfApiUserSvc', 'toastr'];

    function editSubscriptionSvc(pixerfApiUserSvc, toastr){
		
        var mFaqs= {
            data: [
                {
                    'question': 'Nam porttitor blandit accumsan. Ut vel dictum sem, a pretium?',
                    'answer': 'Nam porttitor blandit accumsan. Ut vel dictum sem, a pretium?',
                    'isCollapsed': true

                },
                {
                    'question': 'Nam porttitor blandit accumsan. Ut vel dictum sem, a pretium?',
                    'answer': 'Nam porttitor blandit accumsan. Ut vel dictum sem, a pretium?',
                    'isCollapsed': true

                },
                {
                    'question': 'Nam porttitor blandit accumsan. Ut vel dictum sem, a pretium?',
                    'answer': 'Nam porttitor blandit accumsan. Ut vel dictum sem, a pretium?',
                    'isCollapsed': true

                }
            ]
        }
	 	function save(user){
            var willBeSavedData = {
                "first_name": user.profile.first_name,
                "last_name": user.profile.last_name,
                "bio": user.profile.bio,
                "address.street1": user.contact.addressLine1,
                "address.street2": user.contact.addressLine2,
                "address.city": user.contact.city,
                "address.country": user.contact.country,
                "address.postal_code": user.contact.postal_code,
                "state": user.contact.state,
                "date_of_birth": user.contact.dob,
                "contact": user.contact.mobileNo,
                "username": user.username,
                "company": user.profile.company,
                "email": user.contact.email,
                "gender": user.contact.gender
            }
            pixerfApiUserSvc.patch(willBeSavedData).done(function(){
                toastr.success("User updated!");
            }).fail(function(){
                toastr.error("Failed to update user information!");
            });
        }
		return {
			save: save,
            faqs: mFaqs
		};
    }
})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('editSubscriptionCtrl', editSubscriptionCtrl);

    editSubscriptionCtrl.$inject = ['editSubscriptionSvc'];

    function editSubscriptionCtrl( editSubscriptionSvc) {

        var self = this;
        self.faqs = editSubscriptionSvc.faqs;
        self.onSaveBtnClicked = editSubscriptionSvc.save;

        self.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
(function () {
	'use strict';
	angular
		.module('pixerf')
		.factory('editProfileSvc', editProfileSvc);
	editProfileSvc.$inject = ['pixerfApiUserSvc', 'toastr', 'sessionManagerSvc', 'signUpPersonalInfoSvc', 'signUpBusinessInfoSvc', 'settingSvc', 'accountConst', 'arrayUtils', '$state', 'accountUtils', 'messageConst', '$translate', 'translationSvc', 'auth0AuthenticationSvc', 'messageAccountConst'];

	function editProfileSvc(pixerfApiUserSvc, toastr, sessionManagerSvc, signUpPersonalInfoSvc, signUpBusinessInfoSvc, settingSvc, accountConst, arrayUtils, $state, accountUtils, messageConst, $translate, translationSvc, auth0AuthenticationSvc, messageAccountConst) {

		var mOfficeTypes = {
			data: accountConst.OFFICE_TYPE
		}
		var mUser = {
			data: sessionManagerSvc.getCurrentLoginUser().data
		}
		var mSaveUser = {};

		function getUser() {
			mUser.data = sessionManagerSvc.getCurrentLoginUser().data;
			return mUser;
		}

		function buildSavedPersonalUser(user) {
			user.location = accountUtils.getUserGoogleLocation(user.location);
			var dayConvert = user.date_of_birth.getDate();
			var monthConvert = (user.date_of_birth.getMonth() + 1);
			if (user.date_of_birth.getMonth() < 9)
				monthConvert = "0" + (user.date_of_birth.getMonth() + 1);
			if (user.date_of_birth.getDate() < 10)
				dayConvert = "0" + user.date_of_birth.getDate();
			mSaveUser = $.extend(true, {}, user);
			mSaveUser.date_of_birth = user.date_of_birth.getFullYear() + "-" + monthConvert + "-" + dayConvert;
		}

		function buildSavedBusinessUser(user) {
			user.location = accountUtils.getUserGoogleLocation(user.organization.address.city);
			user.organization.address.city = accountUtils.getUserGoogleLocation(user.organization.address.city);
			mSaveUser = $.extend(true, {}, user);
			return user;
		}

		function save(user, profileForm) {
			var errMsg = '';
			var service = null;
			if (user.account_type === accountConst.ACCOUNT_TYPE.PERSONAL) {
				service = signUpPersonalInfoSvc;
			} else {
				service = signUpBusinessInfoSvc;
			}
			errMsg = service.validateProfile(user, profileForm);
			if (!errMsg) {
				var currentLoginedUser = sessionManagerSvc.getCurrentLoginUser().data;
				if (user.email !== currentLoginedUser.email) {
					errMsg = "Email is read only! Please don't try to hack us!";
				}
			}
			if (errMsg) {
				toastr.error(errMsg);
				return false;
			}
			if (user.account_type === accountConst.ACCOUNT_TYPE.PERSONAL) {
				buildSavedPersonalUser(user);
				delete mSaveUser.avatar;
				delete mSaveUser.profile_image;
				delete mSaveUser.profile_image_media;
				delete mSaveUser.cover_image;
				delete mSaveUser.cover_image_media;
				saveData(mSaveUser);
			} else {
				buildSavedBusinessUser(user);
				delete mSaveUser.avatar;
				delete mSaveUser.organization.profile_image;
				delete mSaveUser.organization.profile_image_media;
				delete mSaveUser.organization.cover_image;
				delete mSaveUser.cover_image;
				delete mSaveUser.cover_image_media;
				saveData(mSaveUser);
			}
		}

		function saveData(willBeSavedData, callback) {
			pixerfApiUserSvc.put(willBeSavedData).$promise.then(function (savedUserData) {
				toastr.success($translate.instant(messageConst.success.USER_INFO_UPDATED));
				mUser.data = savedUserData;
				var currentLoginedUser = sessionManagerSvc.getCurrentLoginUser().data;
				savedUserData.cover_image = currentLoginedUser.isBiz && currentLoginedUser.isAdmin && currentLoginedUser.organization ? currentLoginedUser.organization.cover_image : currentLoginedUser.cover_image;
				savedUserData.profile_image = currentLoginedUser.isBiz && currentLoginedUser.isAdmin && currentLoginedUser.organization ? currentLoginedUser.organization.profile_image : currentLoginedUser.profile_image;
				sessionManagerSvc.setCurrentLoginUser(savedUserData);
				settingSvc.setUser(sessionManagerSvc.getCurrentLoginUser().data);
                if(currentLoginedUser.isBiz && currentLoginedUser.verification_status == 'changes_requested'){
                    pixerfApiUserSvc.transit_verification_status({id: currentLoginedUser.id, action: 'submit_changes'}, null)
                }
				if (typeof callback == 'function') {
					return callback();
				}
				$state.go("user-home-page." + savedUserData.account_type, {
					id: savedUserData.id,
					userName: savedUserData.displayName.replace(/ /g, '-')
				});
			}).then(function () {
				if (typeof callback == 'function') {
					return callback();
				}
				$state.go("user-home-page." + willBeSavedData.account_type, {
					id: willBeSavedData.id,
					userName: willBeSavedData.displayName.replace(/ /g, '-')
				});
			}).catch(function () {
				toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
			});
		}

		function updateUser(userData) {
			var willBeSaved = accountUtils.buildSavedUserData(userData);
			return pixerfApiUserSvc.put(willBeSaved).$promise;
		}

		function buildServiceData(serviceData) {
			var savedData = {};
			savedData.specialities = serviceData.specialities;
			savedData.cameras = serviceData.cameras;
			savedData.years_of_experience = serviceData.years_of_experience;
			savedData.services_rate_type = serviceData.serviceRatesSelected && serviceData.serviceRatesSelected[0] ? serviceData.serviceRatesSelected[0].name : "";
			savedData.services_rate_amount = serviceData.services_rate_amount;
			savedData.availability_weekdays = serviceData.availability_weekdays || [];
			savedData.availability_weekends = serviceData.availability_weekends || [];

			return savedData;
		}

		function validateServiceData(userProfile, form) {
			form.$setDirty();
			var errMsg = '';
			if (form.yearOfExp.$error && form.yearOfExp.$error.required) {
				errMsg = "Please input your experience!";
			} else if (!arrayUtils.isValueArr(userProfile.specialities)) {
				errMsg = "Please input your specialities!";
			} else if (form.yearOfExp.$error && form.yearOfExp.$error.min) {
				errMsg = $translate.instant("please-key-in-whole-number");
			} else if (form.yearOfExp.$error && (form.yearOfExp.$error.pattern || form.yearOfExp.$error.number)) {
				errMsg = $translate.instant("please-key-in-whole-number");
			} else if (form.yearOfExp.$error && form.yearOfExp.$error.maxlength) {
				errMsg = "Please enter a single or double digit number";
			} else if (form.service_rates_unit.$error && (form.service_rates_unit.$error.pattern || form.service_rates_unit.$error.number)) {
				errMsg = $translate.instant("please-key-in-whole-number");
			} else if (form.service_rates_unit.$error && (form.service_rates_unit.$error.min || form.service_rates_unit.$error.max)) {
				errMsg = "Please enter a figure between " + accountConst.PROFILE.SERVICES_RATE_MIN + " and " + accountConst.PROFILE.SERVICES_RATE_MAX + ".";
			}
			return errMsg;
		}

		function validatePassword(form) {
			if (form.currentPassword.$error.required) {
				return "Please enter your current password";
			}
			if (form.newPassword.$error.required) {
				return "Please enter your new password";
			}
			if (form.newPassword.$error.pattern) {
				return messageAccountConst.error.validation.password.format;
			}
			if (form.newPasswordAgain.$error.required) {
				return "Please re-type your new password";
			}
            if (form.newPassword.$modelValue !== form.newPasswordAgain.$modelValue) {
				return "Your re-typed password does not match your new password.";
			}
			if (form.newPasswordAgain.$error.pattern) {
				return messageAccountConst.error.validation.password.format;
			}

			return "";
		}

		return {
			save: save,
			officeTypes: mOfficeTypes,
			getUser: getUser,
			updateUser: updateUser,
			buildServiceData: buildServiceData,
			validateServiceData: validateServiceData,
			validatePassword: validatePassword,
			saveData: saveData
		};
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('editProfileCtrl', editProfileCtrl);

	editProfileCtrl.$inject = ['$rootScope', 'editProfileSvc', '$scope', 'signUpBusinessInfoSvc', 'pixerfApiUserSvc', 'arrayUtils', 'toastr', 'systemUtils', 'accountConst', 'portfolioConst', 'settingSvc', 'uploadProfilePhotoSvc', '$window', 'selectNewExistCoverPopupSvc', 'sessionManagerSvc', 'messageConst', '$timeout'];

	function editProfileCtrl($rootScope, editProfileSvc, $scope, signUpBusinessInfoSvc, pixerfApiUserSvc, arrayUtils, toastr, systemUtils, accountConst, portfolioConst, settingSvc, uploadProfilePhotoSvc, $window, selectNewExistCoverPopupSvc, sessionManagerSvc, messageConst, $timeout) {

		var self = this;

		$scope.$parent.vm.contextPage = "edit-profile";
		self.user = editProfileSvc.getUser();
		self.onSaveBtnClicked = onSaveBtnClicked;
		self.officeTypes = editProfileSvc.officeTypes;
		self.officeFormatter = officeFormatter;
		self.officeParser = signUpBusinessInfoSvc.officeParser;
		self.onItemClicked = onItemClicked;
		self.onAvailabilityChanged = onAvailabilityChanged;
		self.onServiceRatesSelected = onServiceRatesSelected;
		self.onAvailabilityShowed = onAvailabilityShowed;
		self.showUploadUserProfilePhotos = showUploadUserProfilePhotos;
		self.onCountrySelected = onCountrySelected;
		self.onItemChanged = onItemChanged;
		self.onBusinessTypeChanged = onBusinessTypeChanged;
		self.serviceData = {};
		self.availability_weekdays = {};
		self.availability_weekends = {};
		self.businessType = {};

		self.gplacesOptions = {
			types: ['(cities)']
		}

		self.serviceRates = [{
				"name": "Hourly rate",
				"id": 1
			},
			{
				"name": "Half-day",
				"id": 2
			},
			{
				"name": "Full Day",
				"id": 3
			},
			{
				"name": "Upon Request",
				"id": 4
			},
		];
		self.CONST = {
			SERVICES_RATE_MIN: accountConst.PROFILE.SERVICES_RATE_MIN,
			SERVICES_RATE_MAX: accountConst.PROFILE.SERVICES_RATE_MAX
		}
		self.maxSpecialitiesSelected = portfolioConst.LIMIT_SPECIALITIES;
		self.dopdownOpts = {
			"container": "body",
			"maxOptions": self.maxSpecialitiesSelected,
			"maxOptionsText": "Please select up to a maximum of " + self.maxSpecialitiesSelected + " specialities",
			"noneSelectedText": "Select up to five specialities"
		};
		var mLoginnedUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.guestUser = mLoginnedUser && !mLoginnedUser.account_type;
		self.businessTypeOptions = {
			props: "selected",
			selections: [{
					label: 'Agency',
					value: 'agency'
				},
				{
					label: 'Brand',
					value: 'brand'
				},
				{
					label: 'Institution',
					value: 'institution'
				},
				{
					label: 'Media',
					value: 'media'
				},
				{
					label: 'Studio',
					value: 'studio'
				},
                {
					label: 'Nonprofit',
					value: 'nonprofit'
				}
			]
		};

		$scope.altInputFormats = ['d!/M!/yyyy'];

		$rootScope.$on(messageConst.BROADCAST.USER_DATA_CHANGE, function () {
			self.user = sessionManagerSvc.getCurrentLoginUser();
			self.updatingProfile = true;
			$timeout(function () {
				self.updatingProfile = false;
			}, 500)
		})

		init();

		function onItemClicked(time, availabilitiesSelected) {
			deselectAll(time);
			for (var i = 0; i < self[time].length; i++) {
				if (self[time][i].value === availabilitiesSelected) {
					self[time][i].isSelected = true;
				}
			}
		}

		function onItemChanged(result) {
			if (!self.serviceData.specialities) {
				self.serviceData.specialities = [];
			}
			self.serviceData.specialities = _.map(result.items, function (item) {
				return {
					id: item.id,
					description: item.description,
					name: item.name
				};
			});
		}

		function deselectAll(time) {
			for (var i = 0; i < self[time].length; i++) {
				self[time][i].isSelected = false;
			}
		}

		function onSaveBtnClicked(user, form) {
			if (!user.isBiz) {
				buildServiceData();
			}
			if (!user.isBiz && isServiceDataValid(self.serviceData, form)) {
				user.profile = editProfileSvc.buildServiceData(self.serviceData);
				user.is_available_for_cc = self.serviceData.availability;
				editProfileSvc.save(user, form);
			} else if (user.isBiz) {
				editProfileSvc.save(user, form);
			}
		}

		function isServiceDataValid(user, form) {
			var errMsg = "";
			errMsg = editProfileSvc.validateServiceData(user, form);
			if (errMsg) {
				toastr.error(errMsg);
				return false;
			}

			if (errMsg) {
				toastr.error(errMsg);
				return false;
			}

			return true;
		}

		function officeFormatter(val) {
			return signUpBusinessInfoSvc.officeFormatter(self.officeTypes.data, val);
		}

		function init() {
			buildSpecialitiesDropdown();
			if (!self.user.data.isBiz) {
				self.serviceData.availability = self.user.data.is_available_for_cc || false;
				extractServiceData(self.user.data.profile);
			} else if (self.user && self.user.data && self.user.data.organization && self.user.data.organization.address && self.user.data.organization.address.country) {
				self.gplacesOptions.componentRestrictions = {
					country: self.user.data.organization.address.country
				};
			}
			if (self.user && self.user.data && self.user.data.address && self.user.data.address.country) {
				self.gplacesOptions.componentRestrictions = {
					country: self.user.data.address.country
				};
			}
			if (self.user.data.isBiz && self.user.data.verification_status === 'changes_requested') {
				initInvalidBizInfo();
			}
		}

		function extractServiceData(serviceData) {
			if (!serviceData) return;
			self.serviceData.years_of_experience = serviceData.years_of_experience;
			self.serviceData.serviceRatesSelected = serviceData ? _.filter(self.serviceRates, function (obj) {
				return obj.name === serviceData.services_rate_type;
			}) : null;
			self.serviceData.services_rate_amount = serviceData ? serviceData.services_rate_amount : null;
			self.serviceData.specialities = serviceData ? serviceData.specialities : null;
			self.serviceData.cameras = serviceData ? serviceData.cameras : null;

			if (serviceData && arrayUtils.isValueArr(serviceData.availability_weekdays)) {
				extractAvailability(serviceData, 'availability_weekdays');
			}
			if (serviceData && arrayUtils.isValueArr(serviceData.availability_weekends)) {
				extractAvailability(serviceData, 'availability_weekends');
			}
		}

		function extractAvailability(serviceData, timeDuration) {
			for (var i = 0; i < serviceData[timeDuration].length; i++) {
				if (serviceData[timeDuration][i] === "day") {
					self[timeDuration].day = true;
				}
				if (serviceData[timeDuration][i] === "evening") {
					self[timeDuration].evening = true;
				}
				if (i === serviceData[timeDuration].length - 1) {
					onAvailabilityChanged(timeDuration);
				}
			}
		}

		function buildSpecialitiesDropdown() {
			pixerfApiUserSvc.getSpecialities().$promise.then(function (response) {
				self.specialities = response.data;
			});
		}

		function onAvailabilityChanged(timeDuration) {
			if (!self.serviceData[timeDuration]) {
				self.serviceData[timeDuration] = [];
			}
			if (self[timeDuration].day && self[timeDuration].evening) {
				self.serviceData[timeDuration] = ['day', 'evening'];
			} else if (self[timeDuration].day) {
				self.serviceData[timeDuration] = ['day'];
			} else if (self[timeDuration].evening) {
				self.serviceData[timeDuration] = ['evening'];
			} else {
				self.serviceData[timeDuration] = [];
			}
		}

		function onServiceRatesSelected(serviceRatesSelected) {
			if (!serviceRatesSelected) {
				toastr.error("Please input your service rates!");
				return;
			}
			self.serviceData.services_rate_type = serviceRatesSelected[0] ? serviceRatesSelected[0].name : "";
			if (!self.serviceData.services_rate_type) {
				self.serviceData.services_rate_amount = null;
				systemUtils.digest($scope);
			}
		}

		function buildServiceData() {
			self.user.profile = self.serviceData;
			self.user.profile.cameras = self.user.profile.cameras ? _.map(self.user.profile.cameras, function (obj) {
				return obj.text;
			}) : null;
		}

		function onAvailabilityShowed(isAvailability) {
			if (!isAvailability) {
				self.serviceData.availability_weekdays = [];
				self.serviceData.availability_weekends = [];
				self.availability_weekdays = {};
				self.availability_weekends = {};
			}
		}

		function showUploadUserProfilePhotos(type) {
			$window.event.stopPropagation();
			if (type == 'cover') {
				var modal = selectNewExistCoverPopupSvc.showPopup();
				modal.result.then(function () {
					self.user.data = sessionManagerSvc.getCurrentLoginUser().data;
				})
			} else {
				var modal = uploadProfilePhotoSvc.showPopup({
					'type': type
				});
				modal.result.then(function (data) {
					var userImage = {};
					if (self.user.data.isBiz && self.user.data.isAdmin) {
						if (type == 'profile') {
							userImage.profile_image = data.response.handle ? data.response.handle : data.thumbnails["300x"];
						}
						pixerfApiUserSvc.put({}, userImage).$promise.then(function () {
							settingSvc.updateUserProfilePhotos(self.user.data, type, data.thumbnails);
						})
					} else {
						settingSvc.updateUserProfilePhotos(self.user.data, type, data.thumbnails);
					}
				}, function () {});
			}
		}

		function onCountrySelected(country) {
			self.gplacesOptions.componentRestrictions = {
				country: country
			};
		}

		function onBusinessTypeChanged(type) {
			self.user.data.business_type = type.selected;
		}

		function initInvalidBizInfo() {
			self.invalidBizInfo = {
				first_name: self.user.data.verification_comment.unverified_fields.includes('first_name'),
				email: self.user.data.verification_comment.unverified_fields.includes('email'),
				telephone: self.user.data.verification_comment.unverified_fields.includes('telephone'),
				name: self.user.data.verification_comment.unverified_fields.includes('name'),
				registration_no: self.user.data.verification_comment.unverified_fields.includes('registration_no'),
				office_type: self.user.data.verification_comment.unverified_fields.includes('office_type'),
				country: self.user.data.verification_comment.unverified_fields.includes('country'),
				city: self.user.data.verification_comment.unverified_fields.includes('city')
			}
		}
	}
})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.factory('editPasswordPopupSvc', editPasswordPopupSvc);
	editPasswordPopupSvc.$inject = ['$uibModal'];

	function editPasswordPopupSvc($uibModal) {
		function showPopup(data) {
			return $uibModal.open({
				templateUrl: 'app/components/edit-password-popup/edit-password-popup.html',
				controller: 'editPasswordPopupCtrl',
				controllerAs: 'vm',
				animation: true,
				windowClass: 'zindex edit-password-screen',
				resolve: {
					'resolveData': function () {
						return data;
					}
				}
			});
		}

		return {
			showPopup: showPopup
		};
	}
})();

(function () {
    'use strict';

    angular
        .module('pixerf')
        .controller('editPasswordPopupCtrl', editPasswordPopupCtrl);

    editPasswordPopupCtrl.$inject = ['$scope', 'editPasswordPopupSvc', 'sessionManagerSvc', 'toastr', 'messageAccountConst', 'auth0AuthenticationSvc', '$uibModalInstance'];

    function editPasswordPopupCtrl($scope, editPasswordPopupSvc, sessionManagerSvc, toastr, messageAccountConst, auth0AuthenticationSvc, $uibModalInstance) {

        var self = this;

        $scope.$parent.vm.contextPage = "Password";
        self.onSaveBtnClicked = onSaveBtnClicked;
        self.onCancelBtnClicked = onCancelBtnClicked;
        self.user = editPasswordPopupSvc.user;

        var mUser = {
            data: sessionManagerSvc.getCurrentLoginUser().data
        };

        reset();

        function validate(user, form) {
            if (form.newPassword.$error.required) {
                return "Please enter your current password";
            }
            if (form.newPassword.$error.pattern) {
                return messageAccountConst.error.validation.password.format;
            }
            if (form.newPasswordAgain.$error.required) {
                return "Please re-type your new password";
            }
            if (form.newPasswordAgain.$error.pattern) {
                return messageAccountConst.error.validation.password.format;
            }
            if (user.newPassword !== user.newPasswordAgain) {
                return "Your re-typed password does not match your new password.";
            }

            return "";
        }

        function onSaveBtnClicked(user, form) {
            form.$setDirty();

            var errMsg = validate(user, form);
            if (errMsg) {
                toastr.error(errMsg);
                return false;
            }
            var willBeSavedData = {
                "password": user.newPassword
            }
            auth0AuthenticationSvc.changePassword(willBeSavedData).then(function (result) {
                toastr.success("Your password has been changed!");
                $uibModalInstance.dismiss();
            }, function () {
                toastr.error("Oops, failed to change your password. Please try again!");
            });

        }

        function onCancelBtnClicked(){
            $uibModalInstance.dismiss();
        }

        function reset() {
            mUser.data = sessionManagerSvc.getCurrentLoginUser().data;
        }
    }
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.factory('editCartBtnSvc', editCartBtnSvc);

	editCartBtnSvc.$inject = ['cartSvc', 'cartUtils', '$q', 'toastr', 'messageConst', 'messageSvc', 'translationSvc', 'sessionManagerSvc', 'store', 'accountConst'];

	function editCartBtnSvc(cartSvc, cartUtils, $q, toastr, messageConst, messageSvc, translationSvc, sessionManagerSvc, store, accountConst) {

		function buildSavedCartItem(cartItem) {
			var savedCartItemData = {
				"size": null,
				"is_unlimited_print": false,
				"is_multi_seat": false,
				"is_for_resale": false,
				"id": cartItem.id
			};
			for (var i = 0; i < cartItem.media.extendedLicenses.length; i++) {
				savedCartItemData[cartItem.media.extendedLicenses[i].key] = cartItem.media.extendedLicenses[i].isSelected;
			}
			for (var i = 0; i < cartItem.media.price.range.length; i++) {
				if (cartItem.media.price.range[i].isSelected) {
					savedCartItemData.size = cartItem.media.price.range[i].size;
				}
			}
			return savedCartItemData;

		}

		function validate(cartItemData) {
			var errMsg = "";
			if (!cartItemData.size) errMsg = "Size is not set";
			return errMsg;
		}

		function editCartItem(cartItem) {
			var def = $q.defer();
			var savedCartItemData = buildSavedCartItem(cartItem);
			var errMsg = validate(savedCartItemData);
			if (errMsg) toastr.error(errMsg);
			var mLoginnedUser = sessionManagerSvc.getCurrentLoginUser().data;
            if(!mLoginnedUser){
                var guestUserToken = store.get(accountConst.TOKEN.GUEST_USER_TOKEN);
            }

			cartSvc.updateItemInCart(savedCartItemData, guestUserToken).then(function (response) {
				def.resolve();
				var updatedCartItem = cartSvc.getCartItemById(response.data, cartItem.id);
				cartItem.sub_total = updatedCartItem.sub_total;
				cartItem.is_unlimited_print = updatedCartItem.is_unlimited_print;
				cartItem.is_multi_seat = updatedCartItem.is_multi_seat;
				cartItem.is_for_resale = updatedCartItem.is_for_resale;
				cartItem.size = updatedCartItem.size;
				cartItem.discounts = updatedCartItem.discounts;
			}, function (err) {
				def.reject();
				cartUtils.updateCartSelectedVariant(cartItem, cartItem);
				var message = translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true);
				if (err.data.error === "MEDIA_UNAVAILABLE") {
					message = messageSvc.compile(messageConst.error.CART_ITEM_REMOVED, {
						photo_name: ": " + cartItem.media.title,
						quantity: 1,
						action: 'update'
					});
					cartSvc.removeItem(cartItem);
				}
				toastr.error(message);
			});
			return def.promise;
		}
		return {
			buildSavedCartItem: buildSavedCartItem,
			validate: validate,
			editCartItem: editCartItem
		};
	}
})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('editCartBtnCtrl', editCartBtnCtrl);

    editCartBtnCtrl.$inject = ['$scope', 'popoverCartSvc', '$uibModalStack', 'toastr', 'editCartBtnSvc', 'cartSvc', 'cartUtils'];

    function editCartBtnCtrl( $scope, popoverCartSvc, $uibModalStack, toastr, editCartBtnSvc, cartSvc, cartUtils) {

        var self = this;
        self.onEditCartBtnClicked = onEditCartBtnClicked;

        function onEditCartBtnClicked(cartItem){

            editCartBtnSvc.editCartItem(cartItem).then(function(){
                $uibModalStack.dismissAll();
                popoverCartSvc.toogle();
            });
        }
    }
})();
(function () {
  'use strict';

  angular
    .module('pixerf')
    .directive('editCartBtn', editCartBtn);

  function editCartBtn() {

    var directive = {
      scope: {
        "cartItem" : "=",
      },
      restrict: 'E',
      templateUrl: 'app/components/edit-cart-btn/edit-cart-btn.html',
      controller: 'editCartBtnCtrl',
      controllerAs: 'vm',
      replace: true
    };
    return directive;
  }

})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.factory('earningsPopupPopupSvc', earningsPopupPopupSvc);
		earningsPopupPopupSvc.$inject = ['$uibModal'];

	function earningsPopupPopupSvc($uibModal) {
		function showPopup(data) {
			return $uibModal.open({
				templateUrl: 'app/components/earnings-popup/earnings-popup.html',
				controller: 'earningsPopupCtrl',
				controllerAs: 'vm',
				animation: true,
				windowClass: 'zindex earnings-popup-modal',
				resolve: {
					'resolveData': function () {
						return data;
					}
				}
			});
		}

		return {
			showPopup: showPopup
		};
	}
})();

(function () {
    'use strict';

    angular
        .module('pixerf')
        .controller('earningsPopupCtrl', earningsPopupCtrl);

    earningsPopupCtrl.$inject = ['$scope', 'earningsPopupPopupSvc', '$uibModalInstance', 'resolveData', '$state'];

    function earningsPopupCtrl($scope, earningsPopupPopupSvc, $uibModalInstance, resolveData, $state) {

        var self = this;

        self.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        self.showUploadModal = function () {
            $uibModalInstance.dismiss('cancel');
            setTimeout(function () {
                resolveData.onShowUploadModal();
            }, 500);
        }

        self.onLearnMoreClicked = function () {
            $uibModalInstance.dismiss('cancel');
            setTimeout(function () {
                var url = $state.href("introduction-support.faq.personal", { section: 'contributor' });
                window.open(url,'_blank');
            }, 500);
        }
    }
})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.factory('earningsSvc', earningsSvc);
	earningsSvc.$inject = ['pixerfApiSalesSvc', '$q', 'toastr'];

	function earningsSvc(pixerfApiSalesSvc, $q, toastr) {
		function fetchEarnings() {
			var def = $q.defer();
			pixerfApiSalesSvc.get_earnings().$promise.then(function (response) {
				def.resolve(response);
			}, function (err) {
				toastr.error("Failed to get your eanings information. Please try again");
				def.reject(err);
			})
			return def.promise;
		}
		return {
			fetchEarnings: fetchEarnings
		};
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('earningsCtrl', earningsCtrl);

	earningsCtrl.$inject = ['$scope', 'sessionManagerSvc'];

	function earningsCtrl($scope, sessionManagerSvc) {

		var self = this;
		$scope.$parent.vm.contextPage = 'earnings';
		var mLoginnedUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.guestUser = mLoginnedUser && !mLoginnedUser.account_type;

	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.config(routerDefaultConfig)
		.config(routerConfig);

	routerDefaultConfig.$inject = ['$urlRouterProvider'];

	function routerDefaultConfig($urlRouterProvider) {
		'ngInject';
		$urlRouterProvider.when("/setting/edit/earnings", "/setting/edit/earnings/my-earnings");
	}

	routerConfig.$inject = ['$stateProvider'];

	function routerConfig($stateProvider) {
		'ngInject';
		$stateProvider
			.state('setting.earnings', {
				url: '/edit/earnings',
				templateUrl: 'app/components/earnings/earnings.html',
				controller: 'earningsCtrl',
				controllerAs: 'vm',
				data: {
					pageTitle: "PIXERF - Earnings"
				}
			})
			.state('setting.earnings.my_earnings', {
				url: '/my-earnings',
				templateUrl: 'app/components/earnings/my-earnings/my-earnings.html',
				controller: 'myEarningCtrl',
				controllerAs: 'vm',
				data: {
					pageTitle: "PIXERF - My Earnings",
				},
				abstract: true
			})
			.state('setting.earnings.my_earnings.images_sold', {
				url: '/images-sold',
				templateUrl: 'app/components/earnings/my-earnings/components/images-sold/images-sold.html',
				controller: 'myEarningImagesSoldCtrl',
				controllerAs: 'vm',
				data: {
					pageTitle: "PIXERF - My Earnings",
				}
			})
			.state('setting.earnings.my_earnings.referrals', {
				url: '/referrals',
				templateUrl: 'app/components/earnings/my-earnings/components/referrals/referrals.html',
				controller: 'myEarningReferralsCtrl',
				controllerAs: 'vm',
				data: {
					pageTitle: "PIXERF - My Earnings",
				}
			})
			.state('setting.earnings.payout_method', {
				url: '/payout-method',
				templateUrl: 'app/components/earnings/payout-method/payout-method.html',
				controller: 'payoutMethodCtrl',
				controllerAs: 'vm',
				data: {
					pageTitle: "PIXERF - Payout Method",
				}
			})
			.state('setting.earnings.transaction_history', {
				url: '/transaction-history',
				templateUrl: 'app/components/earnings/transaction-history/transaction-history.html',
				controller: 'transactionHistoryCtrl',
				controllerAs: 'vm',
				data: {
					pageTitle: "PIXERF - Transaction History",
				}
			});
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('earnings', earnings);
	earnings.$inject = ['$location']

	function earnings($location) {

		var directive = {
			scope: {},
			restrict: 'E',
			templateUrl: 'app/components/earnings/earnings.html',
			replace: true
		};
		return directive;
	}

})();

(function () {

	angular
		.module('pixerf')
		.controller('dropdownTagCtrl', dropdownTagCtrl);

	dropdownTagCtrl.$inject = ['$scope'];

	function dropdownTagCtrl($scope) {

		var self = this;
		self.onItemSelected = onItemSelected;
		self.onItemRemoved = onItemRemoved;
		self.itemsSelected = [];

		onInit();

		function onInit(){
			if($scope.onInit){
				self.itemsSelected = $scope.onInit;
			}
		}

		function onItemRemoved(item){
			if($scope.onItemRemoved){
				$scope.onItemRemoved({items: self.itemsSelected, item: item});
			}
		}

		function onItemSelected(item){
			if($scope.maxSelected && self.itemsSelected.length > $scope.maxSelected){
				self.itemsSelected = _.filter(self.itemsSelected, function(spec) {
					return spec.id != item.id;
				});
				if($scope.onExceedLimit){
					$scope.onExceedLimit();
				}
				return;
			}

			if($scope.onItemSelected){
				$scope.onItemSelected({items: self.itemsSelected, item: item});
			}
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('dropdownTag', dropdownTag);

	function dropdownTag() {

		var directive = {
			scope: {
				data: "=",
				onInit: "=?",
				maxSelected: '@?',
				onItemRemoved: "&?",
				onItemSelected: "&?",
				onExceedLimit: "&?"
			},
			restrict: 'E',
			templateUrl: 'app/components/dropdown-tag/dropdown-tag.html',
			replace: true,
			controller: 'dropdownTagCtrl',
			controllerAs: 'vm'
		};
		return directive;
	}

})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('discussionTopicDraftCtrl', discussionTopicDraftCtrl);

	discussionTopicDraftCtrl.$inject = ['$scope', 'pixerfApiCommunitySvc', 'createDiscussionTopicPopupSvc', 'sessionManagerSvc', 'commonConst', 'toastr'];

	function discussionTopicDraftCtrl($scope, pixerfApiCommunitySvc, createDiscussionTopicPopupSvc, sessionManagerSvc, commonConst, toastr) {

		var self = this;
		self.loginUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.discussion = $scope.discussion;
		self.community = $scope.community;
		self.commonConst = commonConst;

		self.onEditDiscussion = onEditDiscussion;
		self.onPublishDiscussion = onPublishDiscussion;

		init();

		function init() {
			self.updated_at = self.discussion.updated_at ? moment(self.discussion.updated_at).format('DD MMM YYYY, hh:mma') : "";
		}

		function onEditDiscussion(e) {
			window.event.stopPropagation()
			self.community.discussion = self.discussion;
			var popup = createDiscussionTopicPopupSvc.showPopup({
				community: self.community,
				discussion: self.discussion,
				createdCallback: function (discussion) {
					$scope.onPublished({
						data: discussion
					});
				}
			});

			popup.result.then(function (res) {
				if (!res) {
					$scope.onRemoved({
						data: self.discussion
					});
				}
			})
		}

		function onPublishDiscussion(e) {
			window.event.stopPropagation()
			self.discussion.status = 'published';
			pixerfApiCommunitySvc.update_discussion({
				id: self.discussion.id
			}, self.discussion).$promise.then(function (res) {
				toastr.success("Discussion created!");
				$scope.onPublished({
					data: res.data
				});
			}).catch(function (err) {
				console.log(err);
			})
		}

		function validateDiscussion(data) {
			if (!data || !data.subject) {
				return "Please input subject for discussion";
			}
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('discussionTopicDraft', discussionTopicDraft);

	function discussionTopicDraft() {

		var directive = {
			scope: {
				"discussion": "=",
				"community": "=",
				"onRemoved": "&",
				"onPublished": "&"
			},
			restrict: 'E',
			templateUrl: 'app/components/discussion-topic-draft/discussion-topic-draft.html',
			controller: 'discussionTopicDraftCtrl',
			controllerAs: 'vm',
			replace: true
		};
		return directive;
	}

})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('discussionTileCtrl', discussionTileCtrl);

	discussionTileCtrl.$inject = ['$scope', 'confirmPopupSvc', '$q', 'pixerfApiCommunitySvc', 'createDiscussionTopicPopupSvc', 'sessionManagerSvc', '$state', 'commonConst', 'toastr', '$window', 'peopleListPopupSvc', 'pixerfDiscussionReportPopupSvc', 'accountConst', 'pagingUtils', 'systemUtils'];

	function discussionTileCtrl($scope, confirmPopupSvc, $q, pixerfApiCommunitySvc, createDiscussionTopicPopupSvc, sessionManagerSvc, $state, commonConst, toastr, $window, peopleListPopupSvc, pixerfDiscussionReportPopupSvc, accountConst, pagingUtils, systemUtils) {

		var self = this;
		self.loginUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.discussion = $scope.discussion;
		self.community = $scope.community;
		self.isMoreControlOwner = self.loginUser && self.loginUser.id === self.community.owner.id;
		self.isOwner = self.loginUser && self.discussion.user.id === self.loginUser.id;
		self.isMember = self.loginUser && (self.community.membership_status === 'accepted' || self.community.membership_status === 'owner');
		self.isLiked = false;
		self.isBookmarked = false;
		self.commonConst = commonConst;
		self.searchDiscussionComments = {
			id: self.discussion.id,
			page: 1
		}
		self.spinnerComment = {
			isVisible: false
		}

		self.onEditDiscussion = onEditDiscussion;
		self.onRemoveDiscussion = onRemoveDiscussion;
		self.onBookmarkToggle = onBookmarkToggle;
		self.onLikeToggle = onLikeToggle;
		self.goDetailDiscussion = goDetailDiscussion;
		self.onShowListLike = onShowListLike;
		self.onReportDiscussion = onReportDiscussion;
		self.onManageRights = onManageRights;
		self.fetchMoreDiscussionComments = fetchMoreDiscussionComments;
		self.onCommentDiscussion = onCommentDiscussion;
		self.onCommentRemoved = onCommentRemoved;

		init();

		function init() {
			if (self.loginUser && self.discussion) {
				getDiscussionComments(self.searchDiscussionComments, true);
			}
			if (self.discussion && self.discussion.inserted_at) {
				self.inserted_at = genDurationText(self.discussion.inserted_at);
			}
			if (self.community && self.discussion) {
				self.showAdminLabel = self.community.owner.id === self.discussion.user.id;
			}
		}

		function genDurationText(time) {
			var now = moment.utc().format('DD/MM/YYYY, HH:mm:ss');
			var then = moment(time).format('DD/MM/YYYY, HH:mm:ss');
			var ms = moment(now, "DD/MM/YYYY HH:mm:ss").diff(moment(then, "DD/MM/YYYY HH:mm:ss"));
			var d = moment.duration(ms);

			if (d.days() < 1 && d.hours() < 1 && d.minutes() < 1) {
				return d.seconds() + 'second';
			} else if (d.days() < 1 && d.hours() < 1) {
				return d.minutes() + 'min';
			} else if (d.days() < 1) {
				return d.hours() + 'hrs';
			} else if (d.days() < 30) {
				return d.days() + 'd';
			} else {
				return moment(then).format('DD MMM YYYY');
			}
		}

		function onEditDiscussion(e) {
			window.event.stopPropagation()
			self.community.discussion = self.discussion;
			var popup = createDiscussionTopicPopupSvc.showPopup({
				community: self.community,
				discussion: self.discussion

			});

			popup.result.then(function (res) {
				if (!res) {
					$scope.onRemoved({
						data: self.discussion
					});
				} else {
					self.discussion = res;
					self.community.discussion = res;
					systemUtils.digest($scope);
				}
			})
		}

		function onRemoveDiscussion(e) {
			window.event.stopPropagation()
			var popup = confirmPopupSvc.showPopup({
				windowClass: 'remove-discussion-confirm-popup',
				title: 'Are you sure you want to delete this post?',
				message: 'You will lose all the engagements and comments from this post.',
				submitBtnText: 'Yes, delete it',
				cancelBtnText: 'No, keep it',
				submit: function () {
					var def = $q.defer();
					pixerfApiCommunitySvc.remove_disscussion({
						id: self.discussion.id
					}).$promise.then(function (res) {
						toastr.success("Discussion: " + self.discussion.subject + " has been deleted!");
						def.resolve(res);
					}).catch(function (err) {
						def.reject(err);
					})
					return def.promise;
				},
				submitCallback: function (res) {
					$scope.onRemoved(res);
				}
			});

			return popup;
		}

		function onBookmarkToggle(e) {
			window.event.stopPropagation()
			pixerfApiCommunitySvc.toggle_bookmark_discussion({
				id: self.discussion.id
			}, {}).$promise.then(function (res) {
				self.discussion.is_bookmarked = !self.discussion.is_bookmarked;
			}).catch(function (err) {
				console.log(err);
			})
		}

		function onLikeToggle(e) {
			window.event.stopPropagation()
			var service = self.discussion.is_liked ? 'unlike_discussion' : 'like_discussion';
			pixerfApiCommunitySvc[service]({
				id: self.discussion.id
			}).$promise.then(function (res) {
				self.discussion.is_liked = !self.discussion.is_liked;
				self.discussion.like_count += self.discussion.is_liked ? 1 : -1;
			}).catch(function (err) {
				console.log(err);
			})
		}

		function goDetailDiscussion(discussion) {
			$state.go(self.commonConst.STATE.DISCUSSION_DETAIL, {
				id: discussion.id,
				subject: discussion.subject.replace(/ /g, '-'),
				order: $scope.arrangeBy
			});
		}

		function onShowListLike() {
			$window.event.stopPropagation();
			if (self.discussion.like_count < 1) return;

			peopleListPopupSvc.showPopup({
				type: accountConst.INTERACT_TYPE.LIKE_DISCUSSION.toLowerCase(),
				user: self.loginUser,
				discussionId: self.discussion.id,
				options: {
					hideSeeAll: true
				}
			});
		}

		function onReportDiscussion() {
			pixerfDiscussionReportPopupSvc.showPopup({
				id: self.discussion.id,
				target: 'report_discussion'
			});
		}

		function onManageRights() {
			$state.go(self.commonConst.STATE.MANAGE_COMMUNITIES_BRIEF, {
				id: self.discussion.community.id,
				name: self.discussion.community.name,
				manage: true,
				status: 'members'
			});
		}

		function getDiscussionComments(params, isFresh) {
			self.searchDiscussionComments = params;
			self.isWorking = true;
			self.spinnerComment.isVisible = true;
			pixerfApiCommunitySvc.get_discussion_comments(self.searchDiscussionComments).$promise.then(function (res) {
				self.spinnerComment.isVisible = false;
				if (!self.discussionComments || isFresh) self.discussionComments = [];
				self.discussionComments = self.discussionComments.concat(res.data);
				self.isLastDiscussionComments = pagingUtils.isNoMorePageToLoad(self.searchDiscussionComments.page, res);
				self.searchDiscussionComments.page = params.page;
				self.isWorking = false;
			}).catch(function (err) {
				self.spinnerComment.isVisible = false;
				self.isWorking = false;
				console.log(err);
			})
		}

		function getReplies(comment) {
			pixerfApiCommunitySvc.get_sub_replies({
				id: comment.id
			}).$promise.then(function (res) {
				if (!comment.replies) comment.replies = [];
				self.discussionComments.replies = res;
				systemUtils.digest($scope);
			}).catch(function (err) {
				console.log(err);
			})
		}

		function fetchMoreDiscussionComments() {
			if (self.isLastDiscussionComments || self.spinnerComment.isVisible) return;
			var searchParms = $.extend(true, {}, self.searchDiscussionComments);
			searchParms.page++;
			getDiscussionComments(searchParms);
		}

		function onCommentDiscussion(comment) {
			pixerfApiCommunitySvc.comment_discussion({
				id: self.discussion.id
			}, {
				text: comment
			}).$promise.then(function (res) {
				self.discussion.reply_count++;
				$('#comment-section-' + self.discussion.id).collapse('show');
				self.commentText = null;
				self.discussionComments.push(res.data);
				systemUtils.digest($scope);
			}).catch(function (err) {
				console.log(err);
			})
		}

		function onCommentRemoved(data) {
			self.discussionComments = _.reject(self.discussionComments, function (comment) {
				return comment.id === data.id;
			});
			self.discussion.reply_count--;
			systemUtils.digest($scope);
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('discussionTile', discussionTile);

	function discussionTile() {

		var directive = {
			scope: {
				"discussion": "=",
				"community": "=",
				"onRemoved": "&",
				"arrangeBy": "@"
			},
			restrict: 'E',
			templateUrl: 'app/components/discussion-tile/discussion-tile.html',
			controller: 'discussionTileCtrl',
			controllerAs: 'vm',
			replace: true
		};
		return directive;
	}

})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('discussionItemCtrl', discussionItemCtrl);

		discussionItemCtrl.$inject = ['$scope', 'confirmPopupSvc', '$q', 'pixerfApiCommunitySvc', 'createDiscussionTopicPopupSvc', 'sessionManagerSvc', '$state', 
			'commonConst', 'toastr', '$window', 'peopleListPopupSvc', 'pixerfDiscussionReportPopupSvc', 'accountConst', 'dateUtils'];

	function discussionItemCtrl($scope, confirmPopupSvc, $q, pixerfApiCommunitySvc, createDiscussionTopicPopupSvc, sessionManagerSvc, $state, 
			commonConst, toastr, $window, peopleListPopupSvc, pixerfDiscussionReportPopupSvc, accountConst, dateUtils) {

		var self = this;
		self.loginUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.discussion = $scope.discussion;
		self.community = $scope.community;
		self.isOwner = self.loginUser && self.discussion.user.id === self.loginUser.id;
		self.isMember = self.loginUser && (self.community.membership_status === 'accepted' || self.community.membership_status === 'owner');
		self.isLiked = false;
		self.isBookmarked = false;
		self.commonConst = commonConst;
		self.type = $scope.type;;

		self.onEditDiscussion = onEditDiscussion;
		self.onRemoveDiscussion = onRemoveDiscussion;
		self.onBookmarkToggle = onBookmarkToggle;
		self.onLikeToggle = onLikeToggle;
		self.onComment = onComment;
		self.goDetailDiscussion = goDetailDiscussion;
		self.onShowListLike = onShowListLike;
		self.onShowListReply = onShowListReply;
		self.onReportDiscussion = onReportDiscussion;
		self.onManageRights = onManageRights;
		self.controls = [];
		self.onRemoveFromCommunity = onRemoveFromCommunity;
		self.onBlockFromCommunity = onBlockFromCommunity;
		self.onApproveDiscussion = onApproveDiscussion;
		self.onRejectDiscussion = onRejectDiscussion;
		self.onDeleteDiscussion = onDeleteDiscussion;

		init();

		function init() {
			self.inserted_at = self.discussion.inserted_at ? getPreciseDiff(moment(self.discussion.inserted_at)) : "";
			buildlControl();
		}

		function buildlControl(){
			switch (self.type) {
				case 'viewPendingPost':
					self.controls=[];
					self.showRejectBtn = false;
					self.showApproveBtn = false;
					self.showEditBtn = true;
					self.showDeleteBtn = true;
					break;
				default:
					self.showRejectBtn = true;
					self.showApproveBtn = true;
					self.showEditBtn = false;
					self.showDeleteBtn = false;
					self.controls = [{
						label: 'Remove from Community',
						cta: self.onRemoveFromCommunity,
						showControl: true
					}, {
						label: 'Block from Community',
						cta: self.onBlockFromCommunity,
						showControl: true
					}];
					break;
			}
		}

		function onRemoveFromCommunity(){
			$scope.onRemoveFromCommunity(self.discussion.user);
		}

		function onBlockFromCommunity(){
			$scope.onBlockFromCommunity(self.discussion.user);
		}

		function onApproveDiscussion(){
			$scope.onApproveDiscussion(self.discussion);
		}

		function onDeleteDiscussion(){
			$scope.onDeleteDiscussion(self.discussion);		
		}

		function onRejectDiscussion(){
			$scope.onRejectDiscussion(self.discussion);
		}

		function onEditDiscussion(e) {
			window.event.stopPropagation()
			self.community.discussion = self.discussion;
			var popup = createDiscussionTopicPopupSvc.showPopup({
				community: self.community,
				discussion: self.discussion

			});

			popup.result.then(function (res) {
				if (res) {
					self.discussion = res;
					toastr.success("Updated!");
				}
			})
		}

		function getPreciseDiff(date){
			var today = moment.utc();
			return dateUtils.preciseDiff(today, moment(date))
		}

		function onRemoveDiscussion(e) {
			window.event.stopPropagation()
			var popup = confirmPopupSvc.showPopup({
				windowClass: 'remove-discussion-confirm-popup',
				title: 'Are you sure you want to delete this post?',
				message: 'You will lose all the engagements and comments from this post.',
				submitBtnText: 'Yes, delete it',
				cancelBtnText: 'No, keep it',
				submit: function () {
					var def = $q.defer();
					pixerfApiCommunitySvc.remove_disscussion({
						id: self.discussion.id
					}).$promise.then(function (res) {
						toastr.success("Discussion: " + self.discussion.subject + " has been deleted!");
						def.resolve(res);
					}).catch(function (err) {
						def.reject(err);
					})
					return def.promise;
				},
				submitCallback: function (res) {
					$scope.onRemoved(res);
				}
			});

			return popup;
		}

		function onBookmarkToggle(e) {
			window.event.stopPropagation()
			pixerfApiCommunitySvc.toggle_bookmark_discussion({
				id: self.discussion.id
			}, {}).$promise.then(function (res) {
				self.discussion.is_bookmarked = !self.discussion.is_bookmarked;
			}).catch(function (err) {
				console.log(err);
			})
		}

		function onLikeToggle(e) {
			window.event.stopPropagation()
			var service = self.discussion.is_liked ? 'unlike_discussion' : 'like_discussion';
			pixerfApiCommunitySvc[service]({
				id: self.discussion.id
			}).$promise.then(function (res) {
				self.discussion.is_liked = !self.discussion.is_liked;
				self.discussion.like_count += self.discussion.is_liked ? 1 : -1;
			}).catch(function (err) {
				console.log(err);
			})
		}

		function onComment(discussion) {
			goDetailDiscussion(discussion);
		}

		function goDetailDiscussion(discussion) {
			$state.go(self.commonConst.STATE.DISCUSSION_DETAIL, {
				id: discussion.id,
				subject: discussion.subject.replace(/ /g, '-'),
				order: $scope.arrangeBy
			});
		}

		function onShowListLike() {
			$window.event.stopPropagation();
			if(self.discussion.like_count < 1) return;

			peopleListPopupSvc.showPopup({
				type: accountConst.INTERACT_TYPE.LIKE_DISCUSSION.toLowerCase(),
				user: self.loginUser,
				discussionId: self.discussion.id,
				options: {
					hideSeeAll: true
				}
			});
		}

		function onShowListReply() {
			$window.event.stopPropagation();
			if(self.discussion.reply_count < 1) return;

			peopleListPopupSvc.showPopup({
				type: accountConst.INTERACT_TYPE.REPLY_DISCUSSION.toLowerCase(),
				user: self.loginUser,
				discussionId: self.discussion.id,
				options: {
					hideSeeAll: true
				}
			});
		}

		function onReportDiscussion() {
			pixerfDiscussionReportPopupSvc.showPopup({ id: self.discussion.id, target: 'report_discussion' });
		}

		function onManageRights() {
			$state.go(self.commonConst.STATE.MANAGE_COMMUNITIES_BRIEF, {
				id: self.discussion.community.id,
				name: self.discussion.community.name,
				manage: true,
				status: 'members'
			});
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('discussionItem', discussionItem);

	function discussionItem() {

		var directive = {
			scope: {
				"discussion": "=",
				"community": "=",
				"onRemoved": "&",
				"arrangeBy": "@",
				"onRemoveFromCommunity": "&",
				"onBlockFromCommunity": "&",
				"onApproveDiscussion": "&",
				"onRejectDiscussion": "&",
				"onDeleteDiscussion": "&",
				"type": "@"
			},
			restrict: 'E',
			templateUrl: 'app/components/discussion-item/discussion-item.html',
			controller: 'discussionItemCtrl',
			controllerAs: 'vm',
			replace: true
		};
		return directive;
	}

})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('discussionCommentCtrl', discussionCommentCtrl);

	discussionCommentCtrl.$inject = ['$scope', 'sessionManagerSvc', 'pixerfApiCommunitySvc', 'systemUtils', '$timeout', 'peopleListPopupSvc', 'pixerfDiscussionReportPopupSvc', 'accountConst'];

	function discussionCommentCtrl($scope, sessionManagerSvc, pixerfApiCommunitySvc, systemUtils, $timeout, peopleListPopupSvc, pixerfDiscussionReportPopupSvc, accountConst) {

		var self = this;
		self.comment = $scope.comment;
		self.onLikeComment = onLikeComment;
		self.onReplyInput = onReplyInput;
		self.onReplyCommentDiscussion = onReplyCommentDiscussion;
		self.onToggleReplyDropdown = onToggleReplyDropdown;
		self.loginUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.isOwner = self.loginUser && self.loginUser.id === self.comment.user.id;
		self.replyCommentShow = false;
		self.onRemoveComment = onRemoveComment;
		self.onReportComment = onReportComment;
		self.scrollToThis = false;
		self.onShowListLike = onShowListLike;
		self.isWorking = false;

		init();

		function init() {
			self.time = genDurationText(self.comment.updated_at);
			getLayout($scope.styleLayout);
			self.comment.likeLabel = genLikeLabel(self.comment);
			self.userAvatar = self.comment.user.profile_image_media && self.comment.user.profile_image_media.length ? self.comment.user.profile_image_media['100x'] : "";
			$timeout(function () {
				self.scrollToThis = $scope.scrollToThis;
			}, 2000)
		}

		function onLikeComment(comment) {
			var service = comment.is_liked ? 'unlike_comment' : 'like_comment';
			pixerfApiCommunitySvc[service]({
				id: comment.id
			}, {}).$promise.then(function (res) {
				comment.is_liked = !comment.is_liked;
				comment.like_count += comment.is_liked ? 1 : -1;
				comment.likeLabel = genLikeLabel(comment);
				genLikeLabel(comment);
			}).catch(function (err) {
				console.log(err);
			})
		}

		function onReplyInput() {
			self.replyCommentShow = true;
			systemUtils.digest($scope);
		}

		function onReplyCommentDiscussion(comment) {
			self.isWorking = true;
			pixerfApiCommunitySvc.reply_comment({
				id: self.comment.id
			}, {
				text: comment
			}).$promise.then(function (res) {
				self.comment.reply_count++;
				self.replyComment = "";
				self.isWorking = false;
				self.replyCommentShow = false;
				if (!self.subComments) self.subComments = [];
				res.data.time = genDurationText(res.data.updated_at);
				res.data.isOwner = true;
				self.isRepliedOpen = true;
				self.subComments.push(res.data);
			}).catch(function (err) {
				self.isWorking = false;
				console.log(err);
			})
		}

		function genDurationText(time) {
			var now = moment.utc().format('DD/MM/YYYY, HH:mm:ss');
			var then = moment(time).format('DD/MM/YYYY, HH:mm:ss');
			var ms = moment(now, "DD/MM/YYYY HH:mm:ss").diff(moment(then, "DD/MM/YYYY HH:mm:ss"));
			var d = moment.duration(ms);

			if (d.days() < 1 && d.hours() < 1 && d.minutes() < 1) {
				return d.seconds() + 's';
			} else if (d.days() < 1 && d.hours() < 1) {
				return d.minutes() + 'm';
			} else if (d.days() < 1) {
				return d.hours() + 'h';
			} else {
				return d.days() + 'd';
			}
		}

		function getLayout(style) {
			switch (style) {
				case 'author-inline':
					self.layout = "author-inline";
					break;
				case 'author-block':
					self.layout = "author-block";
					break;
				default:
					self.layout = "author-inline";
			}
		}

		function onToggleReplyDropdown() {
			self.isRepliedOpen = !self.isRepliedOpen;
			getReplies(self.comment);
		}

		function getReplies(comment) {
			pixerfApiCommunitySvc.get_sub_replies({
				id: comment.id
			}).$promise.then(function (res) {
				if (!self.subComments) self.subComments = [];
				self.subComments = res.data;
				for (var i = 0; i < self.subComments.length; i++) {
					self.subComments[i].time = genDurationText(self.subComments[i].updated_at);
					self.subComments[i].likeLabel = genLikeLabel(self.subComments[i]);
					self.subComments[i].isOwner = self.loginUser && self.subComments[i].user.id === self.loginUser.id;
				}
				systemUtils.digest($scope);
			}).catch(function (err) {
				console.log(err);
			})
		}

		function genLikeLabel(comment) {
			return comment.is_liked ? 'Liked' : 'Like';
		}

		function onRemoveComment(comment, subComment) {
			pixerfApiCommunitySvc.remove_reply({
				id: comment.id
			}).$promise.then(function (res) {
				if (subComment) {
					self.subComments = _.reject(self.subComments, function (item) {
						return item.id === comment.id;
					})
					self.comment.reply_count--;
				} else {
					$scope.onRemoved({
						data: comment
					});
				}
			}).catch(function (err) {
				console.log(err);
			})
		}

		function onReportComment(comment) {
			pixerfDiscussionReportPopupSvc.showPopup({id: comment.id, target: 'report_comment'});
		}

		function onShowListLike(subComment) {
			peopleListPopupSvc.showPopup({
				type: accountConst.INTERACT_TYPE.LIKE_REPLY_DISCUSSION.toLowerCase(),
				user: self.loginUser,
				replyId: subComment ? subComment.id : self.comment.id,
				options: {
					hideSeeAll: true
				}
			});
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('discussionComment', discussionComment);

	function discussionComment() {

		var directive = {
			scope: {
				"comment": "=",
				"styleLayout": "=",
				"canReply": "=",
				"canLike": "=",
				"onGetReplies": "&",
				"onRemoved": "&",
				"scrollToThis": '='
			},
			restrict: 'E',
			templateUrl: 'app/components/discussion-comment/discussion-comment.html',
			controller: 'discussionCommentCtrl',
			controllerAs: 'vm',
			replace: true
		};
		return directive;
	}

})();

(function () {

	angular
		.module('pixerf')
		.controller('detailUserViewCtrl', detailUserViewCtrl);

	detailUserViewCtrl.$inject = ['$scope', 'sessionManagerSvc', 'systemUtils', 'accountUtils'];

	function detailUserViewCtrl($scope, sessionManagerSvc, systemUtils, accountUtils) {

		var self = this;
		self.loginnedUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.isMyProfile = self.loginnedUser && self.loginnedUser.id === $scope.user.id;
		self.onRemoveMember = onRemoveMember;

		init()

		function init() {
			self.photo = accountUtils.getUserAvatar($scope.user);
			systemUtils.digest($scope);
			self.user = transformData($scope.user);
		}

		function onRemoveMember(user) {
			$scope.onRemoved({
				user: user
			});
		}

		function transformData(user) {
			var formattedData = user;
			formattedData.formattedJoinedAt = moment(user.joined_at).format("D MMM YYYY");
			return formattedData;
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('detailUserView', detailUserView);

	detailUserView.$inject = [];

	function detailUserView() {

		var directive = {
			scope: {
				user: "=",
				onRemoved: "&?",
				options: "=",
				owner: "="
			},
			restrict: 'E',
			templateUrl: 'app/components/detail-user-view/detail-user-view.html',
			controller: 'detailUserViewCtrl',
			controllerAs: 'vm',
			replace: true
		};
		return directive;
	}

})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('datetimeDropdownCtrl', datetimeDropdownCtrl);

	datetimeDropdownCtrl.$inject = ['$scope'];

	function datetimeDropdownCtrl($scope) {

		var self = this;
		self.date = {};
		self.days = [];
		self.months = [];
		self.years = [];
		self.dateFormat = $scope.dateFormat ? $scope.dateFormat : 'DD/MM/YYYY';

		init();

		$scope.$watch('vm.date', function (newDate) {
			genDays(newDate.month, newDate.year);
			if(!_.isEmpty(newDate)){
				$scope.model = newDate.day && newDate.month && newDate.year ? moment(Date.parse(newDate.month + " " + newDate.day + " " + newDate.year)).toDate() : '';
			}
			$scope.invalid = !$scope.model;
		}, true)

		function init() {
			genDays();
			genMonths();
			genYears();
			if($scope.model){
				self.date.day = moment($scope.model).get('date');
				self.date.month = self.months[moment($scope.model).get('month')];
				self.date.year = moment($scope.model).get('year');
			}
		}
		function genDays(month, year) {
			if (month) {
				self.days = [];
				year = year ? year : 4;
				for (var i = 1; i < moment().year(year).month(month).daysInMonth() + 1; i++) {
					self.days.push(i);
				}
			} else {
				for (var i = 1; i < 32; i++) {
					self.days.push(i);
				}
			}
		}
		function genMonths() {
			self.months = moment.months();
		}
		function genYears() {
			var minAge = ($scope.minAge ? $scope.minAge : 0) - 1;
			var maxAge = $scope.maxAge ? $scope.maxAge : 100;
			var maxYear = moment().year() - minAge;
			if($scope.options && $scope.options.bufferYear){
				maxYear = moment().year() + $scope.options.bufferYear + 1;
			}
			var fromYear = moment().year() - maxAge;
			var toYear = maxYear;
			if($scope.options && $scope.options.fromYear){
				fromYear = $scope.options.fromYear;
			}
			if($scope.options && $scope.options.toYear){
				toYear = $scope.options.toYear;
			}
			for (var i = fromYear; i < toYear; i++) {
				self.years.unshift(i);
			}
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('datetimeDropdown', datetimeDropdown);

	function datetimeDropdown() {

		var directive = {
			scope: {
				model: "=",
				maxAge: '@?',
				minAge: '@?',
				dateFormat: '@?',
				invalid: "=",
				options: "="
			},
			restrict: 'E',
			templateUrl: 'app/components/datetime-dropdown/datetime-dropdown.html',
			replace: true,
			controller: 'datetimeDropdownCtrl',
			controllerAs: 'vm'
		};
		return directive;
	}

})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('customRadioButtonCtrl', customRadioButtonCtrl);

	customRadioButtonCtrl.$inject = ['$scope', '$rootScope'];

	function customRadioButtonCtrl($scope, $rootScope) {

		var self = this;
		self.model = $scope.model;
		self.selectedProps = $scope.modelProperty;
		self.value = $scope.value;
		self.onRadioClicked = onRadioClicked;
		self.isSelected = false;
		
		$scope.$watch('model', function (data) {
			self.model = data;
		}, true)

		init();

		$rootScope.$on("radioGroup" + self.selectedProps, function (event, data) {
			self.isSelected = data === self.value;
		})

		function init() {
			if ($scope.default == 'true') {
				self.model[self.selectedProps] = self.value;
				self.isSelected = true;
			} else {
				self.model[self.selectedProps] = null;
			}
		}

		function onRadioClicked() {
			if ($scope.isDisabled) return;
			if (self.model[self.selectedProps] !== self.value) {
				self.model[self.selectedProps] = self.value;
			} else {
				self.isSelected = true;
				return;
			}
			self.isSelected = self.model[self.selectedProps] === self.value;
			$scope.$emit("radioGroup" + self.selectedProps, self.model[self.selectedProps]);
			$scope.onChanged({
				data: self.model
			});
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('customRadioButton', customRadioButton);

	customRadioButton.$inject = [];

	function customRadioButton() {
		return {
			restrict: 'E',
			replace: true,
			templateUrl: 'app/components/custom-radio-button/custom-radio-button.html',
			controller: 'customRadioButtonCtrl',
			controllerAs: 'vm',
			scope: {
				model: "=",
				label: "=",
				value: "=",
				modelProperty: "@",
				onChanged: '&',
				isDisabled: '=',
				isReversed: "=",
				options: "=",
				default: "@"
			},
		};
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('customPagingStyleCtrl', customPagingStyleCtrl);

	customPagingStyleCtrl.$inject = ['$scope'];

	function customPagingStyleCtrl($scope) {

		var self = this;
		self.rangePageInfo = {
			firstIndex: 0,
			lastIndex: 0,
			noOfShowedItems: 0,
			currentPage: $scope.currentPage || 1
		};
		self.data = $scope.data;
		self.options = $scope.options;
		self.totalItems = $scope.totalItems;
		self.totalPages = $scope.totalPages;
		self.isFirstPage = false;
		self.isLastPage = false;
		self.onItemClicked = onItemClicked;
		self.onGoFirstPage = onGoFirstPage;
		self.onGoPreviousPage = onGoPreviousPage;
		self.onGoNextPage = onGoNextPage;
		self.onGoLastPage = onGoLastPage;

		init();

		function init() {
			self.totalItems = $scope.totalItems;
			genOptions();
			genCurrentItems();
		}

		function genCurrentItems() {
			if (Number.isNaN(self.rangePageInfo.currentPage)) return;
			if (self.totalPages == self.rangePageInfo.currentPage && self.rangePageInfo.currentPage > 1) {
				self.rangePageInfo.firstIndex = (self.rangePageInfo.currentPage - 1) * self.rangePageInfo.noOfShowedItems;
				self.rangePageInfo.lastIndex = self.totalItems - 1;
			} else if (self.totalPages == self.rangePageInfo.currentPage) {
				self.rangePageInfo.firstIndex = 0;
				self.rangePageInfo.lastIndex = self.totalItems - 1;
			} else {
				self.rangePageInfo.firstIndex = (self.rangePageInfo.currentPage - 1) * self.rangePageInfo.noOfShowedItems;
				self.rangePageInfo.lastIndex = self.rangePageInfo.firstIndex + (self.rangePageInfo.noOfShowedItems - 1);
			}
			self.currentRange = (self.rangePageInfo.firstIndex + 1) + "-" + (self.rangePageInfo.lastIndex + 1);

			if (self.rangePageInfo.firstIndex === 0) {
				self.isFirstPage = true;
			} else {
				self.isFirstPage = false;
			}
			if ((self.rangePageInfo.lastIndex + 1) === self.totalItems) {
				self.isLastPage = true;
			} else {
				self.isLastPage = false;
			}
		}

		function genOptions() {
			if (!self.options) return;
			if (self.options.label) {
				self.label = self.options.label;
			}
			if (self.options.showValues) {
				self.listOptions = self.options.showValues;
			}
			if ($scope.showItems) {
				self.rangePageInfo.noOfShowedItems = $scope.showItems;
			} else {
				self.rangePageInfo.noOfShowedItems = self.listOptions[0];
			}
		}

		function onItemClicked(item) {
			self.rangePageInfo.noOfShowedItems = item;
			self.isOpenDll = false;
			if ($scope.onPageSizeChanged) {
				$scope.onPageSizeChanged({
					data: self.rangePageInfo.noOfShowedItems
				})
			}
		}

		function onPageChanged() {
			if ($scope.onPageChanged) {
				$scope.onPageChanged({
					data: self.rangePageInfo
				})
			}
		}

		function onGoFirstPage() {
			if (self.isFirstPage) return;
			self.rangePageInfo.currentPage = 1;
			genCurrentItems();
			onPageChanged();
			if ($scope.onFirstClicked) {
				$scope.onFirstClicked({
					data: self.rangePageInfo
				});
			}
		}

		function onGoPreviousPage() {
			if (self.isFirstPage) return;
			self.rangePageInfo.currentPage--;
			genCurrentItems();
			onPageChanged();
			if ($scope.onPreviousClicked) {
				$scope.onPreviousClicked({
					data: self.rangePageInfo
				});
			}
		}

		function onGoNextPage() {
			if (self.isLastPage) return;
			self.rangePageInfo.currentPage++;
			genCurrentItems();
			onPageChanged();
			if ($scope.onNextClicked) {
				$scope.onNextClicked({
					data: self.rangePageInfo
				});
			}
		}

		function onGoLastPage() {
			if (self.isLastPage) return;
			self.rangePageInfo.currentPage = self.totalPages;
			genCurrentItems();
			onPageChanged();
			if ($scope.onLastClicked) {
				$scope.onLastClicked({
					data: self.rangePageInfo
				});
			}
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('customPagingStyle', customPagingStyle);

	function customPagingStyle() {

		var directive = {
			scope: {
				showItems: "=?",
				currentPage: "=",
				totalItems: "=",
				totalPages: "=",
				options: "=",
				customClass: "@?",
				onFirstClicked: "&?",
				onLastClicked: "&?",
				onPreviousClicked: "&?",
				onNextClicked: "&?",
				onPageChanged: "&?",
				onPageSizeChanged: "&?"
			},
			templateUrl: 'app/components/custom-paging-style/custom-paging-style.html',
			restrict: 'E',
			controller: 'customPagingStyleCtrl',
			controllerAs: 'vm',
			replace: true
		};
		return directive;
	}

})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('customHomepageGridCarouselCtrl', customHomepageGridCarouselCtrl);

		customHomepageGridCarouselCtrl.$inject = ['$scope', 'systemUtils', 'carouselPhotoPopupSvc'];

	function customHomepageGridCarouselCtrl($scope, systemUtils, carouselPhotoPopupSvc) {


		var self = this;
		self.onNextSlide = onNextSlide;
		self.onPreviousSlide = onPreviousSlide;
		self.showPhotoPopup = showPhotoPopup;
		self.mobileData = [];
		self.slideDatas = [{
			id: 1,
			logo: "assets/images/custom-commission-ad/slides/slide-1-logo.jpg",
			indexShowInfo: 5,
			infoLast: false,
			themeColor: "#dbb688",
			slideInfo: {
				photoShoot: "1,600",
				days: 4,
				models: 40,
				licensed: 400
			},
			photos: [
				{
					url: "assets/images/custom-carousel/slides/slide-1-1-photo.jpg",
					urlMobile: "assets/images/custom-carousel/slides/slide-1-1-photo-mobile.jpg",
					name: 'SHAVONNE WONG',
					country: 'SINGAPORE',
					desc: 'Fashion photographer and one of Forbes Asia’s 30 under 30 in 2020.',
					infoPosition: 'bottom-right'
				},
				{
					url: "assets/images/custom-carousel/slides/slide-1-2-photo.jpg",
					urlMobile: "assets/images/custom-carousel/slides/slide-1-2-photo-mobile.jpg",
					name: 'TOM POTISIT',
					country: 'THAILAND',
					desc: 'Fashion photographer and activist who exhibited at Saatchi London and Art Basel Miami.',
					infoPosition: 'bottom-right'
				},
				{
					url: "assets/images/custom-carousel/slides/slide-1-3-photo.jpg",
					urlMobile: "assets/images/custom-carousel/slides/slide-1-3-photo-mobile.jpg",
					name: 'LOUIS AMAL',
					country: 'AUSTRALIA',
					desc: 'Street and wedding photographer with contemporary flair, based in Melbourne and Indonesia.',
					infoPosition: 'top-left'
				},
				{
					url: "assets/images/custom-carousel/slides/slide-1-4-photo.jpg",
					urlMobile: "assets/images/custom-carousel/slides/slide-1-4-photo-mobile.jpg",
					name: 'SILVA ANDRIANI',
					country: 'INDONESIA',
					desc: 'Indonesian still life photographer specialising in food and product shots.',
					infoPosition: 'bottom-left'
				},
				{
					url: "assets/images/custom-carousel/slides/slide-1-5-photo.jpg",
					urlMobile: "assets/images/custom-carousel/slides/slide-1-5-photo-mobile.jpg",
					name: 'YIK KEAT LEE',
					country: 'SINGAPORE',
					desc: 'KOL and urban street photographer with over 1.2m followers on Instagram.',
					infoPosition: 'bottom-left'
				}
			]
		},
		{
			id: 2,
			logo: "assets/images/custom-commission-ad/slides/slide-2-logo.jpg",
			indexShowInfo: 5,
			infoLast: true,
			themeColor: "#a4d9ea",
			slideInfo: {
				photoShoot: "1154",
				days: 11,
				models: 81,
				licensed: 342
			},
			photos: [
				{
					url: "assets/images/custom-carousel/slides/slide-2-1-photo.jpg",
					urlMobile: "assets/images/custom-carousel/slides/slide-2-1-photo-mobile.jpg",
					name: 'Nadirah Zakariyah',
					country: 'Malaysia',
					desc: 'Multi-disciplinary visual artist featured in Vice, Vogue Italia and New York Times.',
					infoPosition: 'bottom-right'
				},
				{
					url: "assets/images/custom-carousel/slides/slide-2-2-photo.jpg",
					urlMobile: "assets/images/custom-carousel/slides/slide-2-2-photo-mobile.jpg",
					name: 'SOMRAJ SAHU',
					country: 'INDIA',
					desc: 'Based in Kolkata, the multiple award winner captures life and the human soul beautifully.',
					infoPosition: 'bottom-right'
				},
				{
					url: "assets/images/custom-carousel/slides/slide-2-3-photo.jpg",
					urlMobile: "assets/images/custom-carousel/slides/slide-2-3-photo-mobile.jpg",
					name: 'Nhiem Hoang',
					country: 'VIETNAM',
					desc: 'Freelance and landscape photographer and Sony Image Ambassador based in Vietnam.',
					infoPosition: 'bottom-right'
				},
				{
					url: "assets/images/custom-carousel/slides/slide-2-4-photo.jpg",
					urlMobile: "assets/images/custom-carousel/slides/slide-2-4-photo-mobile.jpg",
					name: 'GEOFF ANG',
					country: 'SINGAPORE',
					desc: 'Regional photographer and TVC director specialising in fashion, lifestyle and beauty.',
					infoPosition: 'top-left'
				},
				{
					url: "assets/images/custom-carousel/slides/slide-2-5-photo.jpg",
					urlMobile: "assets/images/custom-carousel/slides/slide-2-5-photo-mobile.jpg",
					name: 'KL Chong',
					country: 'Malaysia',
					desc: 'A Travel, People and Culture expert and a top global award winner in 2016 and 2020.',
					infoPosition: 'top-left'
				},
				{
					url: "assets/images/custom-carousel/slides/slide-2-6-photo.jpg",
					urlMobile: "assets/images/custom-carousel/slides/slide-2-6-photo-mobile.jpg",
					name: 'Sutipond Somnam',
					country: 'THAILAND',
					desc: 'Thailand-based photographer capturing travel and news shots across Southeast Asia.',
					infoPosition: 'top-left'
				}
			]
		},
		{
			id: 3,
			logo: "assets/images/custom-commission-ad/slides/slide-3-logo.jpg",
			indexShowInfo: 5,
			infoLast: true,
			themeColor: "#ccc96b",
			slideInfo: {
				photoShoot: "1,300",
				days: 6,
				licensed: 342
			},
			photos: [
				{
					url: "assets/images/custom-carousel/slides/slide-3-1-photo.jpg",
					urlMobile: "assets/images/custom-carousel/slides/slide-3-1-photo-mobile.jpg",
					name: 'MYA MIN DIN',
					country: 'MYANMAR',
					desc: 'A full time travel photo guide turned travel and landscape photographer.',
					infoPosition: 'bottom-right'
				},
				{
					url: "assets/images/custom-carousel/slides/slide-3-2-photo.jpg",
					urlMobile: "assets/images/custom-carousel/slides/slide-3-2-photo-mobile.jpg",
					name: 'CK NG',
					country: 'MALAYSIA',
					desc: 'Travel & aerial photographer capturing the world’s most stunning spots.',
					infoPosition: 'bottom-right'
				},
				{
					url: "assets/images/custom-carousel/slides/slide-3-3-photo.jpg",
					urlMobile: "assets/images/custom-carousel/slides/slide-3-3-photo-mobile.jpg",
					name: 'INDRA SUPRIADI',
					country: 'INDONESIA',
					desc: 'Known for lush landscapes, he is proficient in beauty, fashion and luxury photography.',
					infoPosition: 'bottom-right'
				},
				{
					url: "assets/images/custom-carousel/slides/slide-3-4-photo.jpg",
					urlMobile: "assets/images/custom-carousel/slides/slide-3-4-photo-mobile.jpg",
					name: 'ATHENA TAN',
					country: 'SINGAPORE',
					desc: 'Big on travel photography as reflected in her images of architecture, landscapes and people.',
					infoPosition: 'bottom-right'
				},
				{
					url: "assets/images/custom-carousel/slides/slide-3-5-photo.jpg",
					urlMobile: "assets/images/custom-carousel/slides/slide-3-5-photo-mobile.jpg",
					name: 'DONELL GUMIRAN',
					country: 'PHILIPPINES',
					desc: 'Based in Dubai, Donell is known for his emotive portraits and evocative travel images.',
					infoPosition: 'top-left'
				}
			]
		}
		];
		self.slickSetting = {
			onInit: function (slick) {
				self.slick = slick;
				systemUtils.digest($scope);
			}
		}

		function onNextSlide() {
			self.slick.slickNext();
		}

		function onPreviousSlide() {
			self.slick.slickPrev();
		}

		function buildMobileData(){
			self.mobileData = [];
			for(var i = 0; i < self.slideDatas.length; i++){
				for(var j = 0; j < (self.slideDatas[i].photos).length; j++){
					self.mobileData.push(self.slideDatas[i].photos[j])
				}
			}
		}

		function showPhotoPopup(photo){
			carouselPhotoPopupSvc.showPopup({
				windowClass: 'stay-home-stay-creative',
				data: photo
			});
		}

		init();

		function init() {
			buildMobileData();
		}



	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('customHomepageGridCarousel', customHomepageGridCarousel);

	function customHomepageGridCarousel() {

		var directive = {
			scope: {
				data: "="
			},
			templateUrl: 'app/components/custom-homepage-grid-carousel/custom-homepage-grid-carousel.html',
			restrict: 'E',
			controller: 'customHomepageGridCarouselCtrl',
			controllerAs: 'vm',
			replace: true
		};
		return directive;
	}

})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('customCommissionsTileCtrl', customCommissionsTileCtrl);

	customCommissionsTileCtrl.$inject = ['$scope'];

	function customCommissionsTileCtrl($scope) {

		var self = this;
		self.data = $scope.data;

		init();

		function init() {
			self.data.time = moment(self.data.inserted_at).format('DD MMM YYYY');
			genOwnerLogo();
		}

		function tranformCustomCCLogo() {
			if ([2, 35].includes(self.data.id)) {
				self.owerLogo = "assets/images/custom-commissions/honda_logo.png?t=" + moment().unix();
			} else if ([5, 6].includes(self.data.id)) {
				self.owerLogo = "assets/images/custom-commissions/Grab_Food.jpg?t=" + moment().unix();
			} else if (self.data.id === 7) {
				self.owerLogo = "assets/images/custom-commissions/PA.jpg?t=" + moment().unix();
			} else if ([8, 13, 16, 24, 25, 28, 32].includes(self.data.id)) {
				self.owerLogo = "assets/images/custom-commissions/esing-logo.jpg?t=" + moment().unix();
			} else if ([9, 18].includes(self.data.id)) {
				self.owerLogo = "assets/images/custom-commissions/AIC-LOGO-on-transparent-background.jpg?t=" + moment().unix();
			} else if ([10, 11].includes(self.data.id)) {
				self.owerLogo = "assets/images/custom-commissions/skill-future.jpg?t=" + moment().unix();
			} else if (self.data.id === 12) {
				self.owerLogo = "assets/images/custom-commissions/shield_logo_square.jpg?t=" + moment().unix();
			} else if (self.data.id === 14) {
				self.owerLogo = "assets/images/custom-commissions/WSHC-logo_new-bf4b93613b.jpg?t=" + moment().unix();
			} else if (self.data.id === 15) {
				self.owerLogo = "assets/images/custom-commissions/cnb-logo.jpg?t=" + moment().unix();
			} else if (self.data.id === 17) {
				self.owerLogo = "assets/images/custom-commissions/singapore-police-force.jpg?t=" + moment().unix();
			} else if ([19, 20, 21, 22, 23, 30].includes(self.data.id)) {
				self.owerLogo = "assets/images/custom-commissions/petronas.jpg?t=" + moment().unix();
			} else if (self.data.id === 27) {
				self.owerLogo = "assets/images/custom-commissions/land-transport-authority.png?t=" + moment().unix();
			} else if (self.data.id === 29) {
				self.owerLogo = "assets/images/custom-commissions/pmo-sg.png?t=" + moment().unix();
			} else if (self.data.id === 31) {
				self.owerLogo = "assets/images/custom-commissions/republic-polytechnic.png?t=" + moment().unix();
			} else if (self.data.id === 33) {
				self.owerLogo = "assets/images/custom-commissions/ademco-logo.png?t=" + moment().unix();
			} else if (self.data.id === 34) {
				self.owerLogo = "assets/images/custom-commissions/PIL.png?t=" + moment().unix();
			} else if (self.data.id === 36) {
				self.owerLogo = "assets/images/custom-commissions/Storytel_PrimaryLogo.jpg?t=" + moment().unix();
			}
		}

		function genOwnerLogo() {
			self.owerLogo = self.data.organization && self.data.organization.profile_image_media && self.data.organization.profile_image_media['x200'] ? self.data.organization.profile_image_media['x200'] : '';
			tranformCustomCCLogo();
		}

	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('customCommissionsTile', customCommissionsTile);

	function customCommissionsTile() {

		var directive = {
			scope: {
				data: "="
			},
			templateUrl: 'app/components/custom-commissions-tile/custom-commissions-tile.html',
			restrict: 'E',
			controller: 'customCommissionsTileCtrl',
			controllerAs: 'vm',
			replace: true
		};
		return directive;
	}

})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('customCommissionsSquareTileCtrl', customCommissionsSquareTileCtrl);

	customCommissionsSquareTileCtrl.$inject = ['$scope', 'customCommissionsPhotoPopupSvc', 'pixerfApiCustomCommssionsSvc', 'pixerfConfirmPopupSvc', 'toastr', 'translationSvc', 'customCommissionsDetailPageSvc'];

	function customCommissionsSquareTileCtrl($scope, customCommissionsPhotoPopupSvc, pixerfApiCustomCommssionsSvc, pixerfConfirmPopupSvc, toastr, translationSvc, customCommissionsDetailPageSvc) {

		var self = this;

		self.onChanged = onChanged;
		self.item = $scope.item;
		self.onPhotoDetailsClicked = onPhotoDetailsClicked;
		self.onRemoveSubmissionClicked = onRemoveSubmissionClicked;
		self.onDownloadPhoto = onDownloadPhoto;
		self.onToggleEnableDownload = onToggleEnableDownload;

		$scope.$watch('vm.item', function (newVal) {
			self.item = newVal;
		}, true)

		function onChanged(data, event) {
			if (data.isSelected) {
				self.item.isSelected = true;
				$scope.onSelected({
					data: data,
					event: event
				});
			} else {
				self.item.isSelected = false;
				$scope.onDeselected({
					data: data
				});
			}
			$scope.onChanged({
				data: data
			});
		}

		function onPhotoDetailsClicked(data) {
			var params = data;
			params.shoot = $scope.shoot;
			params.canSelect = $scope.options.canSelect;
			params.noComment = $scope.options.noComment;
			params.listId = _.pluck($scope.list, 'id');
			params.canToggleStatus = $scope.options.canToggleStatus;
			params.downloadButton = $scope.options.showDownloadButton;
			params.showDisableDownload = $scope.options.showDisableDownload;
			params.canDisableDownload = $scope.options.canDisableDownload;
			customCommissionsPhotoPopupSvc.showPopup({
				data: params
			});
		}

		function onRemoveSubmissionClicked() {
			var modal = pixerfConfirmPopupSvc.showPopup({
				hideTitle: true,
				hideConfirmText: true,
				message: translationSvc.ARE_YOU_SURE_TO_DO_SOMETHING("DELETE_THIS_PHOTO")
			});
			modal.result.then(function () {
				return pixerfApiCustomCommssionsSvc.removeSubmission({
					shoot_id: $scope.shoot.id,
					submission_id: self.item.id
				}).$promise;
			}).then(function (res) {
				toastr.success(translationSvc.SOMETHING_HAS_BEEN_DONE("THIS_PHOTO", "SUCCESSFULLY_DELETED") + "!");
				$scope.onDeleted({
					data: self.item
				});
			}).catch(function (err) {
				console.log(err);
			})
		}

		function onDownloadPhoto(submission) {
			customCommissionsDetailPageSvc.downloadPhotos($scope.shoot, [submission]).then(function (respone) {
				window.location.href = respone;
			}).catch(function (err) {
				console.log(err);
			});
		}

		function onToggleEnableDownload(isEnabled) {
			if (!$scope.options.canDisableDownload) return;
			pixerfApiCustomCommssionsSvc.updateSubmission({
				shoot_id: $scope.shoot.id,
				submission_id: self.item.id
			}, {
				'is_download_enabled': !isEnabled
			}).$promise.then(function (res) {
				self.item.is_download_enabled = res.is_download_enabled;
			}).catch(function (err) {
				console.log(err);
			})
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('customCommissionsSquareTile', customCommissionsSquareTile);

	function customCommissionsSquareTile() {

		var directive = {
			scope: {
				item: "=",
				list: "=",
				shoot: "=",
				customCommissions: "=",
				onSelected: "&",
				onDeselected: "&",
				onChanged: "&",
				onDeleted: "&",
				options: "="
			},
			templateUrl: 'app/components/custom-commissions-square-tile/custom-commissions-square-tile.html',
			restrict: 'E',
			controller: 'customCommissionsSquareTileCtrl',
			controllerAs: 'vm',
			replace: true
		};
		return directive;
	}

})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('customCommissionsSelectionTileCtrl', customCommissionsSelectionTileCtrl);

	customCommissionsSelectionTileCtrl.$inject = ['$scope', 'customCommissionsPhotoPopupSvc'];

	function customCommissionsSelectionTileCtrl($scope, customCommissionsPhotoPopupSvc) {

		var self = this;
		self.onPhotoDetailsClicked = onPhotoDetailsClicked;
		self.data = $scope.data;
		self.datas = $scope.datas || [];
		self.isGroup = $scope.isGroup;
		self.settings = $scope.settings || {};
		self.selected = self.settings.defaultSelected;

		function onPhotoDetailsClicked(data) {
			customCommissionsPhotoPopupSvc.showPopup({
				data: data,
				datas: self.datas,
				isGroup: self.isGroup,
				customCommissionId: $scope.customCommissionsId
			});
		}

	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('customCommissionsSelectionTile', customCommissionsSelectionTile);

	function customCommissionsSelectionTile() {

		var directive = {
			scope: {
				data: "=",
				onChanged: "&",
				settings: "=",
				datas: "=?",
				isGroup: "@?",
				customCommissionsId: "@?",
				uncheckedCheckboxTooltip: '@',
				checkedCheckboxTooltip: '@'
			},
			templateUrl: 'app/components/custom-commissions-selection-tile/custom-commissions-selection-tile.html',
			restrict: 'E',
			controller: 'customCommissionsSelectionTileCtrl',
			controllerAs: 'vm',
			replace: true
		};
		return directive;
	}

})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('customCommissionsPublicTileCtrl', customCommissionsPublicTileCtrl);

    customCommissionsPublicTileCtrl.$inject = ['$scope'];

    function customCommissionsPublicTileCtrl($scope) {

		var self = this;
		self.data = $scope.data;

		self.data.time = moment(self.data.created_at).format('DD MMM YYYY');
    }
})();
(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('customCommissionsPublicTile', customCommissionsPublicTile);

	function customCommissionsPublicTile() {

		var directive = {
			scope: {
				data: "="
			},
			templateUrl: 'app/components/custom-commissions-public-tile/custom-commissions-public-tile.html',
			restrict: 'E',
			controller: 'customCommissionsPublicTileCtrl',
			controllerAs: 'vm',
			replace: true
		};
		return directive;
	}

})();

(function () {

	angular
		.module('pixerf')
		.factory('customCommissionsPhotoPopupSvc', customCommissionsPhotoPopupSvc);

	customCommissionsPhotoPopupSvc.$inject = ['$uibModal'];

	function customCommissionsPhotoPopupSvc($uibModal) {

		function showPopup(data) {
			return $uibModal.open({
				templateUrl: 'app/components/custom-commissions-photo-popup/custom-commissions-photo-popup.html',
				controller: 'customCommissionsPhotoPopupCtrl',
				controllerAs: 'vm',
				animation: true,
				windowClass: 'zindex custom-commissions-photo-popup',
				backdrop: 'static',
				resolve: {
					popupData: function () {
						return data;
					}
				}
			});
		}

		return {
			showPopup: showPopup
		};
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('customCommissionsPhotoPopupCtrl', customCommissionsPhotoPopupCtrl);

	customCommissionsPhotoPopupCtrl.$inject = ['$scope', 'popupData', '$uibModalInstance', 'pixerfApiCustomCommssionsSvc', 'customCommissionsDetailPageSvc', '$timeout', 'systemUtils', 'confirmPopupSvc'];

	function customCommissionsPhotoPopupCtrl($scope, popupData, $uibModalInstance, pixerfApiCustomCommssionsSvc, customCommissionsDetailPageSvc, $timeout, systemUtils, confirmPopupSvc) {

		var self = this;
		self.data = popupData.data;
		self.shoot = self.data.shoot;
		self.canSelect = popupData.data.canSelect;
		self.noComment = popupData.data.noComment;
		self.onCommentAdded = onCommentAdded;
		self.onCommentDeleted = onCommentDeleted;
		self.closePopup = closePopup;
		self.onFullScreenClicked = onFullScreenClicked;
		self.onNextBtnClicked = onNextBtnClicked;
		self.onPreviousBtnClicked = onPreviousBtnClicked;
		self.submissionIds = self.data.listId;
		self.onShortListChanged = onShortListChanged;
		self.onDownloadPhotoClicked = onDownloadPhotoClicked;
		self.onToggleEnableDownload = onToggleEnableDownload;
		self.logKey = logKey;
		self.isWorking = false;
		self.isLastPrev = false;
        self.isLastNext = false;
		var mShoot = customCommissionsDetailPageSvc.getShoot();
		checkNavigatable();

		function logKey(e) {
			switch (e.which) {
				case 37:
					onPreviousBtnClicked();
					break;
				case 39:
					onNextBtnClicked();
					break;
					// case 32:
					// 	e.preventDefault();
					// 	toggleApproval();
					// 	break;
			}
		}

		function toggleApproval() {
			self.data.isSelected = !self.data.isSelected;
			onShortListChanged(self.data);
			systemUtils.digest($scope);
		}

		function onCommentAdded(comment) {
			self.data.comment_count++;
		}

		function onCommentDeleted(comment) {
			self.data.comment_count--;
		}

		function closePopup() {
			$uibModalInstance.close();
		}

		function onFullScreenClicked() {
			self.isFullScreenMode = !self.isFullScreenMode;
			if (self.isFullScreenMode) {
				$(".modal-dialog").attr("style", "vertical-align: middle;");
			} else {
				$(".modal-dialog").removeAttr("style");
			}
		}

		function onPreviousBtnClicked() {
			var currentIndex = getCurrentIndexPhoto(self.data.id);
			var prevIndex = currentIndex - 1;
			var prevPhotoId = currentIndex > 0 ? self.submissionIds[prevIndex] : -1;
			if (prevPhotoId > -1) {
				getInfoById(prevPhotoId);
			}
		}

		function checkNavigatable() {
            var currentIndex = getCurrentIndexPhoto(self.data.id);
            self.isLastPrev = currentIndex !== 0;
            self.isLastNext = currentIndex !== self.submissionIds.length - 1;
        }

		function onNextBtnClicked() {
			var currentIndex = getCurrentIndexPhoto(self.data.id);
			var nextIndex = currentIndex + 1;
			var nextPhotoId = currentIndex < (self.submissionIds.length - 1) ? self.submissionIds[nextIndex] : -1;
			if (nextPhotoId > -1) {
				getInfoById(nextPhotoId);
			}
		}

		function getCurrentIndexPhoto(photoId) {
			return self.submissionIds.indexOf(photoId);
		}

		function getInfoById(photoId) {
			self.isWorking = true;
			pixerfApiCustomCommssionsSvc.getPhotoById({
				shoot_id: self.shoot.id,
				submission_id: photoId
			}).$promise.then(function (res) {
				self.data = res.data.shoot_submission;
				checkNavigatable();
				$timeout(function () {
					self.data.listId = self.submissionIds;
					self.data.noComment = self.noComment;
					self.data.isSelected = res.data.shoot_submission.is_shortlisted;
					self.data.canSelect = self.canSelect;
					self.isWorking = false;
				}, 0);
			}).catch(function (err) {
				self.isWorking = false;
				console.log(err);
			})
		}

		function onShortListChanged(data) {
			var submissionIds = [];
			if (!mShoot && !mShoot.stats) {
				mShoot = data.shoot;
			}
			submissionIds.push(data.id);
			if (popupData.data && popupData.data.canToggleStatus) {
				pixerfApiCustomCommssionsSvc.approveSubmission({
					shoot_id: self.shoot.id
				}, {
					"submission_ids": submissionIds
				}).$promise.then(function (res) {
					mShoot.stats.selected_submission_count += data.isSelected ? 1 : -1;
					mShoot.isSelected = data.isSelected;
					customCommissionsDetailPageSvc.setShoot(mShoot);
					$scope.$emit("loadedApprovedSubmissions", mShoot);
					$scope.$emit("submissionStatusChanged", data);
					checkNavigatable();
				}).catch(function (err) {
					console.log(err);
					if (err.data && (err.data.key === 'selection_limit_exceeded' || err.data.data.key === 'selection_limit_exceeded')) {
						alertExceedPhotoSelection();
						customCommissionsDetailPageSvc.setShoot(mShoot);
						self.data.isSelected = false;
					}
				})
			} else {
				$scope.$emit("submissionStatusChanged", data);
			}
		}

		function onDownloadPhotoClicked() {
			customCommissionsDetailPageSvc.downloadPhotos(self.shoot, [self.data]).then(function (respone) {
				window.location.href = respone;
			}).catch(function (err) {
				console.log(err);
			});
		}

		function onToggleEnableDownload(isEnabled) {
			if (!self.data.canDisableDownload) return;
			pixerfApiCustomCommssionsSvc.updateSubmission({
				shoot_id: self.shoot.id,
				submission_id: self.data.id
			}, {
				'is_download_enabled': !isEnabled
			}).$promise.then(function (res) {
				self.data.is_download_enabled = res.is_download_enabled;
			}).catch(function (err) {
				console.log(err);
			})
		}

		function alertExceedPhotoSelection() {
			confirmPopupSvc.showPopup({
				windowClass: 'exceed-photo-selection-popup',
				title: 'Your selections have exceeded the designated number of images!',
				message: 'Please deselect the excess number of images. If you require more images, you may change your brief requirements or contact PIXERF.',
				hideSubmitBtn: true,
				cancelBtnText: 'Got it'
			});
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('customCommissionSelectionListCtrl', customCommissionSelectionListCtrl);

	customCommissionSelectionListCtrl.$inject = ['$scope'];

	function customCommissionSelectionListCtrl($scope) {

		var self = this;
		self.items = $scope.data;
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('customCommissionSelectionList', customCommissionSelectionList);

	function customCommissionSelectionList() {

		var directive = {
			scope: {
				data: "="
			},
			templateUrl: 'app/components/custom-commission-selection-list/custom-commission-selection-list.html',
			restrict: 'E',
			controller: 'customCommissionSelectionListCtrl',
			controllerAs: 'vm',
			replace: true
		};
		return directive;
	}

})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('customCheckboxCtrl', customCheckboxCtrl);

	customCheckboxCtrl.$inject = ['$scope'];

	function customCheckboxCtrl($scope) {

		var self = this;
		self.model = $scope.model;
		self.selectedProps = $scope.modelProperty;
		self.toggle = toggle;

		$scope.$watch('vm.model', function (data) {
			self.model = data;
			self.isSelected = data.isSelected;
		}, true)

		init();

		function init() {
			if (self.model[$scope.modelProperty]) {
				self.model[$scope.modelProperty] = self.model[$scope.modelProperty];
			} else {
				self.model[$scope.modelProperty] = false;
			}
		}

		function toggle($event) {
			if ($scope.isDisabled) return;
			if (typeof self.model[$scope.modelProperty] !== 'boolean' && $scope.isReversed) {
				self.model[$scope.modelProperty] = false;
			} else {
				self.model[$scope.modelProperty] = !self.model[$scope.modelProperty];
			}
			self.isSelected = self.model[$scope.modelProperty];
			$scope.onChanged({
				data: self.model,
				event: $event
			});
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('customCheckbox', customCheckbox);

	customCheckbox.$inject = [];

	function customCheckbox() {
		return {
			restrict: 'E',
			replace: true,
			templateUrl: 'app/components/custom-checkbox/custom-checkbox.html',
			controller: 'customCheckboxCtrl',
			controllerAs: 'vm',
			scope: {
				model: "=",
				modelProperty: "@",
				onChanged: '&',
				isDisabled: '=',
				isReversed: "=",
				eventCallback: "@"
			}
		};
	}
})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.factory('curatorStarPopupSvc', curatorStarPopupSvc);
	curatorStarPopupSvc.$inject = ['$uibModal'];

	function curatorStarPopupSvc($uibModal) {

		var mPopup;

		function showPopup(data) {
			mPopup = $uibModal.open({
				templateUrl: 'app/components/curator-star-popup/curator-star-popup.html',
				controller: 'curatorStarPopupCtrl',
				controllerAs: 'vm',
				animation: true,
				resolve: {
					'resolveData': function () {
						return data;
					}
				}
			});
			return mPopup;
		}

		function closePopup(){
            mPopup.close();
        }
		return {
			showPopup: showPopup,
			closePopup: closePopup
		};
	}
})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('curatorStarPopupCtrl', curatorStarPopupCtrl);

    curatorStarPopupCtrl.$inject = ['$scope', 'curatorStarPopupSvc', '$uibModalInstance', 'pagingUtils', 'resolveData', 'toastr', 'sessionManagerSvc', 'pixerfApiMediaSvc', 'pixerfApiGallerySvc'];

    function curatorStarPopupCtrl($scope, curatorStarPopupSvc, $uibModalInstance, pagingUtils, resolveData, toastr, sessionManagerSvc, pixerfApiMediaSvc, pixerfApiGallerySvc) {

        var self = this;

        self.closePopup = closePopup;
        self.loginUser = sessionManagerSvc.getCurrentLoginUser().data;
        self.stars = [];
        self.spinner = {isVisible: false};
        self.target = resolveData.target;
        self.onStarRemoved = onStarRemoved;
        self.targetType = resolveData.type;
        self.searchParams = {
            id: self.target.id,
            page: 1
		};

        getStars(self.searchParams);

        function closePopup(reason){
            $uibModalInstance.dismiss(reason);
        }
        
        function onStarRemoved(star){
            self.target.star_count --;
            if(self.loginUser.id === star.user.id){
                self.target.is_starred = false;
            }
            if(self.target.star_count === 0){
                curatorStarPopupSvc.closePopup();
            }
            self.stars =  _.reject(self.stars, function(item){
                return item.user.id === star.user.id;
            });
            if(resolveData.onStaredToggled){
                resolveData.onStaredToggled({target: self.target})
            }
        }
        
        function getStars(params){
            self.spinner.isVisible = true;
            
            var service = self.targetType === "gallery" ? pixerfApiGallerySvc:  pixerfApiMediaSvc;
            service.get_stars(params).$promise.then(function(response){
                // for(var i=0; i < response.data.length; i++){
                //     var starData = response.data[i];
                //     if(self.loginUser.id === response.data[i].user.id){
                //         starData.user.displayName = "You";
                //     }
                // }
                self.stars = response.data;
                self.spinner.isVisible = false;
            }, function(){
                toastr.error("Failed to get curator list");
                self.spinner.isVisible = false;
            });
		}

    }
})();
(function () {
  'use strict';

  angular
    .module('pixerf')
    .factory('creditPlansSvc', creditPlansSvc);

  creditPlansSvc.$inject = ['pixerfApiCreditPlansSvc', 'messageSvc', 'creditPlanConst', 'numberUtils', '$q'];

  function creditPlansSvc(pixerfApiCreditPlansSvc, messageSvc, creditPlanConst, numberUtils, $q) {

    var mCreditPlan = {
      data: {
        id: null,
        name: null,
        value: null,
        price: null
      }
    };

    function getCreditPlan() {
      return mCreditPlan;
    }

    function setCreditPlan(value) {
      mCreditPlan.data = value;
    }

    function getCreditPlanById(id) {
      var listPlans = [];
      var def = $q.defer();
      pixerfApiCreditPlansSvc.get().$promise.then(function (res) {
        var creditPlans = res.data.data;
        mCreditPlan = creditPlans;
        for (var i = 0; i < creditPlans.length; i++) {
          var tempCredit = {};
          tempCredit.id = messageSvc.compile(creditPlanConst.PLANS[0].id, { id: creditPlans[i].id });
          tempCredit.name = messageSvc.compile(creditPlanConst.PLANS[0].name, { name: creditPlans[i].name });
          tempCredit.value = numberUtils.formatNumber(messageSvc.compile(creditPlanConst.PLANS[0].value, { value: creditPlans[i].value }), ",", 3);
          tempCredit.price = numberUtils.formatNumber(messageSvc.compile(creditPlanConst.PLANS[0].price, { price: creditPlans[i].price }), ",", 3);
          tempCredit.hint = messageSvc.compile(creditPlanConst.PLANS[0].hint, { discount_percentage: creditPlans[i].discount_percentage, discount_amount: creditPlans[i].discount_amount });
          tempCredit.hiDesc = creditPlanConst.PLANS[0].hiDesc;
          tempCredit.desc = messageSvc.compile(creditPlanConst.PLANS[0].desc, { desc: creditPlans[i].desc });
          tempCredit.discount = messageSvc.compile(creditPlanConst.PLANS[0].discount, { discount_amount: creditPlans[i].discount_amount });
          tempCredit.directly = true;
          listPlans.push(tempCredit);
        }
        var plans = listPlans.filter(function (plan) {
          return plan.id == id;
        });
        setCreditPlan(plans[0]);
        def.resolve(plans[0]);
      }, function () {
        def.reject();
      });

      return def.promise;
    }

    return {
      getCreditPlan: getCreditPlan,
      setCreditPlan: setCreditPlan,
      getCreditPlanById: getCreditPlanById
    }
  }
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('creditPlansCtrl', creditPlansCtrl);

    creditPlansCtrl.$inject = ['$scope', 'numberUtils', 'creditPlansSvc', 'pixerfApiCreditPlansSvc', '$state', 'creditPlanConst', 'messageSvc', 'sessionManagerSvc', 'signUpBusinessPopupSvc', 
		'emailUsPopupSvc'];

    function creditPlansCtrl($scope, numberUtils, creditPlansSvc, pixerfApiCreditPlansSvc, $state, creditPlanConst, messageSvc, sessionManagerSvc, signUpBusinessPopupSvc,
			emailUsPopupSvc) {

		var self = this;

		self.loginedUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.onCreditPlanClicked = onCreditPlanClicked;
		self.onCreditPlanSelected = onCreditPlanSelected;
		self.onCantFindWhat = onCantFindWhat;
		self.creditPlans = [];
		self.onGetInTouchClicked = $scope.onGetInTouchClicked
		var mSelectedPlan = null;

		init();

		function onCreditPlanClicked(creditPlan) {
			onCreditPlanSelected(creditPlan);
			if (self.loginedUser && self.loginedUser.canBuyCreditPlan) {
				$state.go('checkout.credit-plan.credit-plan-checkout', {
					id: creditPlan.id
				});
			} else {
				signUpBusinessPopupSvc.showPopup({isBiz: true});
			}
		}

		function onCreditPlanSelected(creditPlan) {
			if (creditPlan.isSelected) return;
			creditPlan.isSelected = true;
			if (mSelectedPlan) {
				mSelectedPlan.isSelected = false;
			}
			mSelectedPlan = creditPlan;
			if ($scope.onPlanSelected) {
				$scope.onPlanSelected({
					plan: creditPlan
				});
			}
			creditPlansSvc.setCreditPlan(creditPlan);
		}

		function getMoreDesc(type){
			var result = [];
			switch (type) {
				case 'Essential':
					result = [
						{ icon: 'icon-money-circle', value: ' to spend on images from all collections', itemValue:  '300 credits'}
					]
					break;
				case 'Sweet Spot':
					result = [
						{ icon: 'icon-money-circle', value: 'to spend on images from all collections', itemValue:  '600 credits '},
						{ icon: 'icon-single-photo', value: 'to get you started', itemValue:  '5 free XS images '}
					]
					break;
				case 'Premium':
					result = [
						{ icon: 'icon-money-circle', value: ' to spend on images from all collections', itemValue:  '1,500 credits'},
						{ icon: 'icon-single-photo', value: 'to get you started', itemValue:  '10 free XS images '}
					]
					break; 
			}
			return result;
		}

		function getCreditPlanes() {
            self.creditPlans = [{
				id: 16,
				name: 'Starter',
				value: 300,
				price: 270,
				discount_percentage: 10,
				hint: 'save-percent-credit-plan-package',
				moreDescription: [
                    { icon: 'icon-money-circle', value: 'to spend on images from all collections', itemValue:  '300 credits '}
                ],
				directly: true,
			},
            {
				id: 17,
				name: 'Essential',
				value: 600,
				price: 510,
				discount_percentage: 15,
				hint: 'save-percent-credit-plan-package',
				moreDescription: [
                    { icon: 'icon-money-circle', value: 'to spend on images from all collections', itemValue:  '600 credits '},
                    { icon: 'icon-single-photo', value: 'to get you started', itemValue:  '5 free XS images '}
                ],
				directly: true,
			},
            {
				id: 18,
				name: 'Sweet Spot',
				value: 1200,
				price: 960,
				discount_percentage: 20,
				hint: 'save-percent-credit-plan-package',
				moreDescription: [
                    { icon: 'icon-money-circle', value: 'to spend on images from all collections', itemValue:  '1200 credits '},
                    { icon: 'icon-single-photo', value: 'to get you started', itemValue:  '10 free XS images '}
                ],
				directly: true,
			},
            {
				id: 19,
				name: 'Premium',
				value: 3000,
				price: 2250,
				discount_percentage: 25,
				hint: 'save-percent-credit-plan-package',
				moreDescription: [
                    { icon: 'icon-money-circle', value: 'to spend on images from all collections', itemValue:  '3000 credits '},
                    { icon: 'icon-single-photo', value: 'to get you started', itemValue:  '5 free L images '}
                ],
				directly: true,
			},
            {
				id: 999,
				name: 'Enterprise',
                whatuget: 'What you get:',
				entDesc: [
					{ icon: 'icon-icon-percent', value: 'Special corporate rates' },
					{ icon: 'icon-cart-2', value: 'Bulk purchase packages' },
					{ icon: 'icon-icon-search-2', value: 'Personalised image search' },
					{ icon: 'icon-icon-insert', value: 'Tailored image curation' },
					{ icon: 'icon-icon-deal', value: '10 free L images to get you started' }
				],
				directly: false,
				mailTo: 'business@pixerf.com?Subject=I\'m%20interested%20to%20purchase%20an%20Enterprise%20PIXERF%20Credit%20Package'
			}]
			// pixerfApiCreditPlansSvc.get().$promise.then(function (res) {
			// 	var creditPlans = res.data.data;
			// 	for (var i = 0; i < creditPlans.length; i++) {
			// 		var tempCredit = {};
			// 		tempCredit.id = messageSvc.compile(creditPlanConst.PLANS[0].id, {
			// 			id: creditPlans[i].id
			// 		});
			// 		tempCredit.name = messageSvc.compile(creditPlanConst.PLANS[0].name, {
			// 			name: creditPlans[i].name
			// 		});
			// 		tempCredit.value = numberUtils.formatNumber(messageSvc.compile(creditPlanConst.PLANS[0].value, {
			// 			value: creditPlans[i].value
			// 		}), ",", 3);
			// 		tempCredit.price = numberUtils.formatNumber(messageSvc.compile(creditPlanConst.PLANS[0].price, {
			// 			price: creditPlans[i].price
			// 		}), ",", 3);
			// 		tempCredit.hint = creditPlanConst.PLANS[0].hint;
			// 		tempCredit.discount_percentage = creditPlans[i].discount_percentage;
			// 		tempCredit.discount_amount = creditPlans[i].discount_amount;
			// 		tempCredit.hiDesc = creditPlanConst.PLANS[0].hiDesc;
			// 		tempCredit.desc = messageSvc.compile(creditPlanConst.PLANS[0].desc, {
			// 			desc: creditPlans[i].desc
			// 		});
			// 		tempCredit.discount = messageSvc.compile(creditPlanConst.PLANS[0].discount, {
			// 			discount_amount: creditPlans[i].discount_amount
			// 		});
			// 		tempCredit.directly = true;
			// 		tempCredit.moreDescription = getMoreDesc(tempCredit.name);
			// 		self.creditPlans.push(tempCredit);
			// 	}
			// 	self.creditPlans.push(creditPlanConst.PLANS[creditPlanConst.PLANS.length - 1]);
			// })
		}

		function onCantFindWhat(){
			emailUsPopupSvc.showPopup();
		}

		function init() {
			getCreditPlanes();
		}
	}
})();

(function () {
  'use strict';

  angular
    .module('pixerf')
    .directive('creditPlans', creditPlans);

  function creditPlans() {

    var directive = {
      scope: {
          'context': '@?',
          'onPlanSelected': '&',
          'onGetInTouchClicked': '&'
      },
      restrict: 'E',
      templateUrl: 'app/components/credit-plans/credit-plans.html',
      replace: true,
      controller: 'creditPlansCtrl',
      controllerAs: 'vm'
    };
    return directive;
  }

})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .factory('creditCardFormSvc', creditCardFormSvc);

     creditCardFormSvc.$inject = [];

    function creditCardFormSvc() {

        
        return {
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('pixerf')
        .controller('creditCardFormCtrl', creditCardFormCtrl);

    creditCardFormCtrl.$inject = ['$scope', 'messageConst', 'confirmPopupSvc'];

    function creditCardFormCtrl($scope, messageConst, confirmPopupSvc) {

        var self = this;
        self.onSubmitBtnClick = onSubmitBtnClick;
        self.isWorking = false;

        $scope.$on(messageConst.BROADCAST.OMISE_CHECKOUT_ERROR, function(event, args) {
            if(args.err) errorHandler(args.err, creditCardForm);
            
        });

        function isValid(form){
            form.$setDirty();
            if($scope.onValidate){
                $scope.onValidate({result: form.$valid});
            }
            return form.$valid;
        }
        function errorHandler(err, form){
            if(err.pixerf_type === "TOKEN_FAILURE" && $scope.errorMessageBuilder){
                self.errorMsg = $scope.errorMessageBuilder({err: err, form: form});
            }
            if(['brand not supported (american express)'].includes(self.errorMsg)){
                confirmPopupSvc.showPopup({
                    windowClass: 'restriction-payment-method-popup',
                    message: 'We regret to inform you that Amex are not supported by Omise.',
                    hideSubmitBtn: true,
                    cancelBtnText: 'Close'
                });
            }
            if(err.message === 'name is invalid'){
                form.fullname.$setValidity("required", false);
            }
            if(err.message === 'expiration year is invalid'){
                form.expYear.$setValidity("required", false);
            }
        }
        function onSubmitBtnClick(form){
            if(isValid(form)){
                if(self.isWorking) return;
                self.isWorking = true;
                $scope.onSubmit().then(function(data){
                    self.errorMsg = "";
                    self.isWorking = false;
                }, function(err){
                    self.isWorking = false;
                    errorHandler(err, form);
                });
            }
            
        }
        
    }
})();
(function () {
  'use strict';

  angular
    .module('pixerf')
    .directive('creditCardForm', creditCardForm);

  function creditCardForm() {

    var directive = {
      scope: {
        card: "=",
        amountToPay: '@',
        focusField: '=',
        onValidate: '&?',
        onSubmit: "&",
        hideSubmitBtn: "@",
        errorMessageBuilder: '&'
      },
      restrict: 'E',
      templateUrl: 'app/components/credit-card-form/credit-card-form.html',
      controller: 'creditCardFormCtrl',
      controllerAs: 'vm',
      replace: true
    };
    return directive;
  }

})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.factory('createPortfolioGallerySvc', createPortfolioGallerySvc);
	createPortfolioGallerySvc.$inject = ['pixerfApiPortfolioGallerySvc', 'galleryUtils', '$uibModal', 'commonConst'];

	function createPortfolioGallerySvc(pixerfApiPortfolioGallerySvc, galleryUtils, $uibModal, commonConst) {
		var mPortfolioGallery = {
			data: {
				title: '',
				description: '',
				is_private: true,
				is_curated: true,
				type: '',
				speciality_id: ''
			}
		};
		var mMode = {
			data: null
		};
		function getPortfolioGallery() {
			return mPortfolioGallery;
		}
		function getMode() {
			return mMode;
		}

		function showCreatePortfolioGalleryModal(data) {
			return $uibModal.open({
				templateUrl: 'app/components/create-portfolio-gallery/create-portfolio-gallery.html',
				controller: 'createPortfolioGalleryCtrl',
				controllerAs: 'vm',
				animation: true,
				windowClass: 'create-gallery-popup',
				resolve: {
					'resolveData': function () {
						return data;
					}
				}
			});

		}
		function validate(form) {
			form.$setDirty();
			var errMsg = ''
			if (form.title.$error.required) {
				errMsg = "Please fill in Title of portfolio gallery!";
			}
			return errMsg;
		}
		function save(portfolioGallery, mode) {
			return mode === commonConst.ACTION.EDIT ? pixerfApiPortfolioGallerySvc.put({ id: portfolioGallery.id }, portfolioGallery).$promise : pixerfApiPortfolioGallerySvc.save(portfolioGallery).$promise;
		}
		function deletePortfolioGallery(portfolioGalleryId) {
			return pixerfApiPortfolioGallerySvc.delete({ id: portfolioGalleryId }).$promise;
		}
		function reset() {
			mPortfolioGallery.data = galleryUtils.getInstance();
			mMode.data = commonConst.ACTION.CREATE;
		}
		return {
			getPortfolioGallery: getPortfolioGallery,
			getMode: getMode,
			save: save,
			deletePortfolioGallery: deletePortfolioGallery,
			validate: validate,
			reset: reset,
			showCreatePortfolioGalleryModal: showCreatePortfolioGalleryModal
		};
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('createPortfolioGalleryCtrl', createPortfolioGalleryCtrl);

	createPortfolioGalleryCtrl.$inject = ['$scope', '$rootScope', 'sessionManagerSvc', 'pixerfConfirmPopupSvc', 'createPortfolioGallerySvc', '$uibModalInstance', '$timeout', 'commonConst', 'resolveData', 'translationConst', 'toastr', 'translationSvc', '$translate', 'selectExistPhotosPopupSvc', 'systemUtils'];

	function createPortfolioGalleryCtrl($scope, $rootScope, sessionManagerSvc, pixerfConfirmPopupSvc, createPortfolioGallerySvc, $uibModalInstance, $timeout, commonConst, resolveData, translationConst, toastr, translationSvc, $translate, selectExistPhotosPopupSvc, systemUtils) {

		var self = this;

		createPortfolioGallerySvc.reset();

		self.portfolioGallery = (resolveData && resolveData.portfolioGallery && resolveData.mode) ? {
			data: $.extend(true, {}, resolveData.portfolioGallery)
		} : createPortfolioGallerySvc.getPortfolioGallery();
		self.onSaveBtnClicked = save;
		self.onCancelBtnClicked = close;
		self.alertSvc = {};
		self.mode = resolveData && resolveData.mode ? resolveData.mode : commonConst.ACTION.CREATE;
		self.onDeletePortfolioGalleryBtnClicked = onDeletePortfolioGalleryBtnClicked;
		self.isWorking = false;
		self.loginnedUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.popupTitle = getPopUpTitle();
		self.onEditCoverImage = onEditCoverImage;

		init()

		function init() {
			self.coverMedia = self.portfolioGallery.data && self.portfolioGallery.data.cover_media && self.portfolioGallery.data.cover_media.thumbnails ? self.portfolioGallery.data.cover_media.thumbnails['x400'] : null;
		}

		function getPopUpTitle() {
			if (self.mode === commonConst.ACTION.CREATE) {
				return $translate.instant(translationConst.ADD_NEW_PORTFOLIO_GALLERY);
			}
			return translationSvc.EDIT_SOMETHING("PORTFOLIO_GALLERY");
		}

		function close(reason) {
			$uibModalInstance.dismiss(reason);
		}

		function applyChanges(originalGallery, updatedGallery) {
			originalGallery.title = updatedGallery.title;
			originalGallery.cover_media = updatedGallery.cover_media;
		}

		function updateUserStat() {
			var step = self.mode === commonConst.ACTION.CREATE ? 1 : -1
			self.loginnedUser = sessionManagerSvc.getCurrentLoginUser().data;
			self.loginnedUser.stats.portfolio_gallery_count += step;
			sessionManagerSvc.setCurrentLoginUser(self.loginnedUser);
		}

		function save(portfolioGallery, formData) {
			if (self.isWorking) return;
			if (!portfolioGallery.speciality_id) {
				portfolioGallery.speciality_id = resolveData.speciality_id;
			}
			var errMsg = createPortfolioGallerySvc.validate(formData);
			if (errMsg) {
				toastr.error(errMsg);
				return;
			}
			self.isWorking = true;
			createPortfolioGallerySvc.save(portfolioGallery, self.mode).then(function (response) {
				if (self.mode === commonConst.ACTION.CREATE) {
					updateUserStat();
				}
				var message = self.mode === commonConst.ACTION.CREATE ? translationConst.PORTFOLIO_GALLERY_CREATED : translationSvc.SOMETHING_HAS_BEEN_DONE("PORTFOLIO_GALLERY", "SUCCESSFULLY_UPDATED") + "!";
				if (!resolveData.overridSuccessMsg) {
					toastr.success(message);
				}
				$timeout(function () {
					self.isWorking = false;
					if (self.mode !== commonConst.ACTION.CREATE) {
						applyChanges(resolveData.portfolioGallery, response.data);
					}
					createPortfolioGallerySvc.reset();
					$uibModalInstance.close(response);
				}, 1000);

			}, function () {
				self.isWorking = false;
				var action = self.mode === commonConst.ACTION.CREATE ? "create" : "edit"
				toastr.error("Oops! Failed to " + action + "portfolio gallery. Please try again.");
			});
		}

		function onDeletePortfolioGalleryBtnClicked(portfolioGallery) {
			if (self.isWorking) return;
			self.isWorking = true;
			var modal = pixerfConfirmPopupSvc.showPopup({
				message: translationSvc.ARE_YOU_SURE_TO_DO_SOMETHING("DELETE_THIS_PORTFOLIO_GALLERY"),
				hideConfirmText: true,
				hideTitle: true
			});
			modal.result.then(function () {
				createPortfolioGallerySvc.deletePortfolioGallery(portfolioGallery.id).then(function (response) {
					updateUserStat();
					toastr.success(translationSvc.SOMETHING_HAS_BEEN_DONE("PORTFOLIO_GALLERY", "SUCCESSFULLY_DELETED") + "!");
					$timeout(function () {
						self.isWorking = false;
						createPortfolioGallerySvc.reset();
						$uibModalInstance.close({
							mode: commonConst.ACTION.DELETE
						});
					}, 1000);

				}, function () {
					self.isWorking = false;
					toastr.error("Oops! Failed to delete portfolio gallery. Please try again.");
				});
			}, function () {
				self.isWorking = false;
			})
		}

		function onEditCoverImage() {
			var existPhotoPopup = selectExistPhotosPopupSvc.showPopup({
				type: 'portfolio',
				data: self.portfolioGallery.data,
				options: {
					title: 'Select Portfolio Cover'
				}
			});

			existPhotoPopup.result.then(function (data) {
				self.coverMedia = data && data.thumbnails ? data.thumbnails['x400'] : null;
				self.portfolioGallery.data.cover_media_id = data.id;
				systemUtils.digest($scope);
			})
		}
	}
})();

/**
 * Controller for home module
 */
(function(){
  'use strict';
  angular
    .module('pixerf')
    .factory('createGallerySvc', createGallerySvc);
    createGallerySvc.$inject = ['pixerfApiGallerySvc', 'galleryUtils', '$uibModal', 'commonConst'];

    function createGallerySvc(pixerfApiGallerySvc, galleryUtils, $uibModal, commonConst){
		var mGallery = {
            data: galleryUtils.getInstance()
        };
        var mMode = {
            data: null
        };
        function getGallery(){
        	return mGallery;
        }
        function getMode(){
            return mMode;
        }

		function showCreateGalleryModal(data){
	    	return $uibModal.open({
				templateUrl: 'app/components/create-gallery/create-gallery.html',
				controller: 'createGalleryCtrl',
				controllerAs: 'vm',
				animation: true,
				windowClass: 'create-gallery-popup',
                resolve: {
                    'resolveData': function(){
                        return data;
                    }
                }
		    });

    	}
		function validate(form){
			form.$setDirty();
			var errMsg = ''
			if(form.title.$error.required){
				errMsg = "Please fill in Title of gallery!";
			} else if(form.description.$error.validationNoHyperlink){
                errMsg = "Sorry, Gallery's description cannot contain link or email.";
            }
			return errMsg;
		}
		function save(gallery, mode){
			return mode === commonConst.ACTION.EDIT ?  pixerfApiGallerySvc.put({id: gallery.id}, gallery).$promise : pixerfApiGallerySvc.save(gallery).$promise;
		}
        function deleteGallery(galleryId){
            return pixerfApiGallerySvc.delete({id: galleryId}).$promise;
        }
		function reset(){
			mGallery.data = galleryUtils.getInstance();
            mMode.data = commonConst.ACTION.CREATE;
		}
		return {
			getGallery : getGallery,
            getMode: getMode,
			save: save,
            deleteGallery: deleteGallery,
			validate: validate,
			reset: reset,
			showCreateGalleryModal: showCreateGalleryModal
		};
    }
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('createGalleryCtrl', createGalleryCtrl);

	createGalleryCtrl.$inject = ['$rootScope', '$scope', 'sessionManagerSvc', 'pixerfConfirmPopupSvc', 'createGallerySvc', '$uibModalInstance', '$timeout', 'commonConst', 'resolveData', 'galleryConst', 'toastr', '$translate', 'translationSvc', 'selectExistPhotosPopupSvc', 'systemUtils'];

	function createGalleryCtrl($rootScope, $scope, sessionManagerSvc, pixerfConfirmPopupSvc, createGallerySvc, $uibModalInstance, $timeout, commonConst, resolveData, galleryConst, toastr, $translate, translationSvc, selectExistPhotosPopupSvc, systemUtils) {

		var self = this;

		createGallerySvc.reset();

		self.gallery = (resolveData && resolveData.gallery && resolveData.mode) ? {
			data: $.extend(true, {}, resolveData.gallery)
		} : createGallerySvc.getGallery();
		self.onSaveBtnClicked = save;
		self.onCancelBtnClicked = close;
		self.alertSvc = {};
		self.mode = resolveData && resolveData.mode ? resolveData.mode : commonConst.ACTION.CREATE;
		self.type = resolveData && resolveData.type ? resolveData.type : galleryConst.GALLERY_TYPE.NORMAL;
		self.onDeleteGalleryBtnClicked = onDeleteGalleryBtnClicked;
		self.isWorking = false;
		self.loginnedUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.popupTitle = getPopUpTitle();
		self.onEditCoverImage = onEditCoverImage;

		init()

		function init() {
			self.coverMedia = self.gallery.data && self.gallery.data.cover_media && self.gallery.data.cover_media.thumbnails ? self.gallery.data.cover_media.thumbnails['x400'] : null;
		}

		function getPopUpTitle() {
			if (self.mode === commonConst.ACTION.CREATE) {
				if (self.type === galleryConst.GALLERY_TYPE.CURATED) {
					return $translate.instant('add-new-curated-gallery');
				} else {
					return $translate.instant('add-new-gallery');
				}
			}
			return $translate.instant('edit', {
				name: $translate.instant('gallery')
			});
		}

		function close(reason) {
			$uibModalInstance.dismiss(reason);
		}

		function applyChanges(originalGallery, updatedGallery) {
			originalGallery.title = updatedGallery.title;
			originalGallery.description = updatedGallery.description;
			originalGallery.is_private = updatedGallery.is_private;
			originalGallery.cover_media = updatedGallery.cover_media;
		}

		function updateUserStat(gallery) {
			var step = self.mode === commonConst.ACTION.CREATE ? 1 : -1
			self.loginnedUser = sessionManagerSvc.getCurrentLoginUser().data;
			if (gallery.is_curated) {
				self.loginnedUser.stats.curated_gallery_count += step;
			} else {
				self.loginnedUser.stats.default_gallery_count += step;
			}
			sessionManagerSvc.setCurrentLoginUser(self.loginnedUser);
		}

		function save(gallery, formData) {
			if (self.isWorking) return;
			var errMsg = createGallerySvc.validate(formData);
			if (errMsg) {
				toastr.error(errMsg);
				return;
			}
			if (self.mode === commonConst.ACTION.CREATE) {
				gallery.is_curated = self.type === galleryConst.GALLERY_TYPE.CURATED;
			}
			self.isWorking = true;
			createGallerySvc.save(gallery, self.mode).then(function (response) {
				if (self.mode === commonConst.ACTION.CREATE) {
					updateUserStat(gallery);
				}
				var message = self.mode === commonConst.ACTION.CREATE ? "Gallery created!" : "Gallery has been successfully updated!";
				if (!resolveData.overridSuccessMsg) {
					toastr.success(message);
				}
				$timeout(function () {
					self.isWorking = false;
					if (self.mode !== commonConst.ACTION.CREATE) {
						applyChanges(resolveData.gallery, response.data);
					}
					createGallerySvc.reset();
					$uibModalInstance.close(response);
				}, 1000);

			}, function () {
				self.isWorking = false;
				var action = self.mode === commonConst.ACTION.CREATE ? "create" : "edit"
				toastr.error("Oops! Failed to " + action + " gallery. Please try again.");
			});
		}

		function onDeleteGalleryBtnClicked(gallery) {
			if (self.isWorking) return;
			self.isWorking = true;
			var modal = pixerfConfirmPopupSvc.showPopup({
				message: translationSvc.ARE_YOU_SURE_TO_DO_SOMETHING("DELETE_THIS_GALLERY"),
				hideConfirmText: true,
				hideTitle: true
			});
			modal.result.then(function () {
				createGallerySvc.deleteGallery(gallery.id).then(function (response) {
					updateUserStat(gallery);
					console.log(response);
					toastr.success("Gallery has been successfully deleted!");
					$timeout(function () {
						self.isWorking = false;
						createGallerySvc.reset();
						$uibModalInstance.close({
							mode: commonConst.ACTION.DELETE
						});
					}, 1000);

				}, function () {
					self.isWorking = false;
					toastr.error("Oops! Failed to delete gallery. Please try again.");
				});
			}, function () {
				self.isWorking = false;
			})
		}

		function onEditCoverImage() {
			var existPhotoPopup = selectExistPhotosPopupSvc.showPopup({
				type: 'gallery',
				data: self.gallery.data,
				options: {
					title: 'Select Gallery Cover'
				}
			});

			existPhotoPopup.result.then(function (data) {
				self.coverMedia = data && data.thumbnails ? data.thumbnails['x400'] : null;
				self.gallery.data.cover_media_id = data.id;
				systemUtils.digest($scope);
			})
		}
	}
})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.factory('createEventPostPopupSvc', createEventPostPopupSvc);
	createEventPostPopupSvc.$inject = ['$uibModal'];

	function createEventPostPopupSvc($uibModal) {

		function showPopup(data) {
			return $uibModal.open({
				templateUrl: 'app/components/create-event-post-popup/create-event-post-popup.html',
				controller: 'createEventPostPopupCtrl',
				controllerAs: 'vm',
				animation: true,
				windowClass: 'create-event-post-popup__wrapper',
				backdrop: 'static',
				resolve: {
					'data': function () {
						return data;
					}
				}
			});
		}

		return {
			showPopup: showPopup
		};
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('createEventPostPopupCtrl', createEventPostPopupCtrl);

	createEventPostPopupCtrl.$inject = ['$scope', '$uibModalInstance', 'pixerfApiCommunitySvc', 'data', 'sessionManagerSvc', 'pixerfUrl', 'systemUtils', 'communityConst'];

	function createEventPostPopupCtrl($scope, $uibModalInstance, pixerfApiCommunitySvc, data, sessionManagerSvc, pixerfUrl, systemUtils, communityConst) {

		var self = this;
		var LIMIT_PHOTO_ATTACHMENT = communityConst.EVENT_POST.LIMIT_PHOTO_ATTACHMENT;
		self.loginUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.popupHeader = 'create-a-new-post';
		self.event = data.event;
		self.showAttachPhotoBtn = true;
		self.isUpdateMode = false;
		self.eventPost = {};
		self.errors = [];
		self.responsedData = {};
		self.onCreateEventPost = onCreateEventPost;
		self.close = close;
		self.dismiss = dismiss;
		self.dropzoneConfig = {
			'instance': {},
			'options': {
				url: pixerfUrl.full + 'api/community_event_posts/',
				maxFilesize: 40,
				maxFiles: 3,
				parallelUploads: 3,
				paramName: 'event_post_photo[]',
				acceptedFiles: ".jpeg, .jpg",
				autoProcessQueue: false,
				thumbnailWidth: 155,
				thumbnailHeight: 155,
				maxThumbnailFilesize: 40,
				dictCancelUpload: "X",
				dictRemoveFile: "X",
				addRemoveLinks: true,
				uploadMultiple: true,
				previewsContainer: '#create-event-post-popup__attach-photos-section',
				clickable: ['#create-event-post-popup__attach-photo-button', '.create-event-post-popup__attach-more'],
				method: "put",
				headers: {
					"Authorization": "Bearer " + sessionManagerSvc.getToken()
				},
				dictFileTooBig: "File is too big ({{filesize}} MB). Max file size is: {{maxFilesize}} MB.",
			},
			'eventHandlers': {
				addedfile: function (file, xhr, form) {
					self.eventPost.photos = [];
					isShowAttachPhotoBtn();
				},
				removedfile: function (file) {
					isShowAttachPhotoBtn();
				},
				processing: function (file) {
					self.isAttachmentUploading = true;
				},
				success: function (file, responsedFile) {
					self.responsedData = responsedFile;
				},
				complete: function (file) {
					self.dropzoneConfig.instance.previewsContainer.remove();
					self.dropzoneConfig.instance.removeFile(file);
					self.isShowAttachPhotoBtn = true;
					self.isAttachmentUploading = false;
					if (self.responsedData.id && data.createdCallback) {
						data.createdCallback(self.responsedData);
					}
					if (self.responsedData.id) {
						$uibModalInstance.close(self.responsedData);
					}
				}
			}
		}

		init();

		function init() {
			if (data.eventPost) {
				self.isUpdateMode = true;
				self.eventPost = systemUtils.clone(data.eventPost);
				self.popupHeader = 'Edit event post';
				self.showAttachPhotoBtn = (self.eventPost.photos && self.eventPost.photos.length) ? self.eventPost.photos.length < LIMIT_PHOTO_ATTACHMENT : true;
				delete data.eventPost;
			}
		}

		function isShowAttachPhotoBtn() {
			if (self.dropzoneConfig.instance.files && self.dropzoneConfig.instance.files.length && self.eventPost.photos && self.eventPost.photos.length) {
				self.showAttachPhotoBtn = (self.dropzoneConfig.instance.files.length + self.eventPost.photos.length) < LIMIT_PHOTO_ATTACHMENT;
			} else if (self.dropzoneConfig.instance.files && self.dropzoneConfig.instance.files.length) {
				self.showAttachPhotoBtn = self.dropzoneConfig.instance.files.length < LIMIT_PHOTO_ATTACHMENT;
			} else {
				self.showAttachPhotoBtn = self.eventPost.photos.length < LIMIT_PHOTO_ATTACHMENT;
			}
			systemUtils.digest($scope);
		}

		function onCreateEventPost() {
			if (self.isUpdateMode) {
				pixerfApiCommunitySvc.edit_event_post({
					id: self.eventPost.id
				}, {
					description: self.eventPost.description
				}).$promise.then(function (res) {
					self.dropzoneConfig.instance.options.url += res.data.id;
					self.dropzoneConfig.instance.processQueue();
					if (!self.isAttachmentUploading && data.createdCallback) {
						data.createdCallback(res.data);
						close();
					} else if (!self.isAttachmentUploading) {
						close();
					} else {
						self.responsedData = res.data;
					}
				}).catch(function (err) {
					console.log(err);
				})
			} else {
				self.eventPost.status = 'published';
				pixerfApiCommunitySvc.create_event_post({
					id: self.event.id
				}, {
					description: self.eventPost.description
				}).$promise.then(function (res) {
					self.dropzoneConfig.instance.options.url += res.data.id;
					self.dropzoneConfig.instance.processQueue();
					if (!self.isAttachmentUploading && data.createdCallback) {
						data.createdCallback(res.data);
						close();
					} else if (!self.isAttachmentUploading) {
						close();
					} else {
						self.responsedData = res.data;
					}
				}).catch(function (err) {
					console.log(err);
				})
			}
		}

		function close() {
			$uibModalInstance.close(self.eventPost);
		}

		function dismiss(){
			$uibModalInstance.dismiss();
		}
	}
})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.factory('createEventPopupSvc', createEventPopupSvc);
	createEventPopupSvc.$inject = ['$uibModal'];

	function createEventPopupSvc($uibModal) {

		function showPopup(data) {

			return $uibModal.open({
				templateUrl: 'app/components/create-event-popup/create-event-popup.html',
				controller: 'createEventPopupCtrl',
				controllerAs: 'vm',
				animation: true,
				backdrop: 'static',
				windowClass: 'create-event-popup__wrapper',
				resolve: {
					'data': function () {
						return data;
					}
				}
			});
		}

		return {
			showPopup: showPopup
		};
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('createEventPopupCtrl', createEventPopupCtrl);

	createEventPopupCtrl.$inject = ['$scope', 'data', 'pixerfUrl', 'uploadCoverPopupSvc', 'systemUtils', '$uibModalInstance', 'pixerfApiEventSvc', 'toastr', 'accountUtils', 'pixerfApiCommunitySvc', 'sessionManagerSvc', 'waitingEventLaunchPopupSvc'];

	function createEventPopupCtrl($scope, data, pixerfUrl, uploadCoverPopupSvc, systemUtils, $uibModalInstance, pixerfApiEventSvc, toastr, accountUtils, pixerfApiCommunitySvc, sessionManagerSvc, waitingEventLaunchPopupSvc) {

		var self = this;

		self.community = data.community;
		self.itemType = data.type == 'class' || (self.event && self.event.event_type == 'class') || self.defaultEventType == 'class' ? 'class' : 'event';
		self.loginedUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.calendar = {};
		self.eventCover = {};
		self.event = {
			is_private: true,
			capacity_type: 'unlimited',
			admission_type: 'free'
		};
		self.onCreateEvent = onCreateEvent;
		self.onCancelCreateEvent = onCancelCreateEvent;
		self.onSaveAsDraftEvent = onSaveAsDraftEvent;
		self.onModerationTypeChanged = onModerationTypeChanged;
		self.onPostingTypeChanged = onPostingTypeChanged;
		self.canConfigmoderation = true;
		self.timerOptions = {
			hideSecondLabel: true,
			noSecond: true,
			showPm: true
		};
		self.dateTimes = [{
			date: null,
			start_time: null,
			end_time: null
		}];
		self.admissionTypes = [{
				value: 'free',
				title: "Free Event/Class",
				description: "Event goers do not require a ticket to join the event/class."
			},
			{
				value: 'ticketed_pixerf',
				title: "Ticketed Event/Class by PIXERF",
				description: "Event/Class goers require a ticket to join the event/Class. Tickets sold through PIXERF."
			},
			{
				value: 'ticketed_external',
				title: "Ticketed Event/Class via External Link",
				description: "Event goers require a ticket to join the event/class. Tickets sold through an external link."
			}
		]

		self.postingTypes = [{
				value: 'anyone',
				title: "Anyone in the Community",
				description: "Any member in the Community can start a discussion and reply to the threads."
			},
			{
				value: 'only_admin',
				title: "Only Admin",
				description: "Only admins can create a new discussion topic."
			}
		];

		self.moderationType = [{
				value: true,
				title: "Approval required",
				description: "Admin must approve all posts before they are published."
			},
			{
				value: false,
				title: "No approval required",
				description: "Admin does not need to approve posts before they are published."
			}
		];

		self.capacityTypes = [{
				value: 'unlimited',
				title: "Unlimited Capacity",
				description: "Event/Class has no maximum number of guests."
			},
			{
				value: 'limited',
				title: "Limited Capacity",
				description: "Event/Class is limited to a fixed number of guests."
			}
		]

		self.privacyTypes = [{
				value: false,
				title: "Public Event/Class",
				description: "Anyone can join the event/class"
			},
			{
				value: true,
				title: "Private Event/Class",
				description: "Only members of the Community can join the event/class"
			}
		]

		self.eventTypes = [{
				value: 'standard',
				title: "Events",
				description: "Meetings, networking events and talks"
			},
			{
				value: 'class',
				title: "Classes",
				description: "Courses, Trainings or workshops"
			}
		];

		self.defaultAdmission = self.admissionTypes[0].value;
		self.defaultCapacityType = self.capacityTypes[0].value;
		self.defaultPrivacyType = self.privacyTypes[1].value;
		self.defaultPostingType = self.postingTypes[1].value;
		self.defaultModerationType = self.moderationType[0].value;
		self.defaultEventType = self.itemType == 'class'? self.eventTypes[1].value :self.eventTypes[0].value;

		self.uploadEventCoverOptions = {
			dropzoneConfig: {
				'options': {
					url: pixerfUrl.full + 'api/community_events/',
					method: 'put',
					paramName: 'cover',
					autoProcessQueue: false,
				},
				eventHandlers: {
					"success": function (file, respone) {
						self.event = respone;
						$uibModalInstance.close(self.event);
					}
				}
			},
			isManual: true,
			introText: "Choose a photo as your event/class cover",
			canEdit: true,
			editText: "Change event/class cover",
			cropper: {
				options: {
					viewport: {
						type: 'square'
					},
					boundary: {
						width: 500,
						height: 160
					},
					showZoomer: false
				}
			}
		};
		self.saleStart = {
			date: null,
			options:{
				minDate: new Date(),
			}
		};
		self.saleEnd = {
			date: null,
			options:{
				minDate: new Date(),
			}
		};

		$scope.$watch("vm.saleStart.date", function (newVal, oldVal) {
			self.saleEnd.options = {
				minDate: new Date(newVal)
			}
			if(self.saleEnd.date < self.saleStart.date){
				self.saleEnd.date = self.saleStart.date;
			}
		});
		self.communities = [];
		self.onAddDateTime = onAddDateTime;
		self.onRemoveDateTime = onRemoveDateTime;
		self.showUploadAvatarPopup = showUploadAvatarPopup;
		self.onAdmissionTypeChanged = onAdmissionTypeChanged;
		self.onCapacityTypeChanged = onCapacityTypeChanged;
		self.onPrivacyTypeChanged = onPrivacyTypeChanged;
		self.onEventTypeChanged = onEventTypeChanged;
		self.onCheckboxPaidEventChanged = onCheckboxPaidEventChanged;
		self.onStartSaleTimechanged = onStartSaleTimechanged;

		init();

		function init() {
			
			if (data.event) {
				self.event = Object.assign({}, data.event);
				self.eventCover.url = (data.event.cover && data.event.cover.original) ? data.event.cover.original : null;
				self.dateTimes = reTransformDateTime(self.event.event_datetimes);
				self.defaultPrivacyType = data.event.is_private;
				self.defaultCapacityType = self.event.capacity_type;
				self.defaultAdmission = self.event.admission_type;
				self.isLimitedCapacity = self.event.capacity_type === 'limited';
				self.defaultEventType = self.event.event_type;
				if (!self.event.community_id) {
					getCommunity();
				}
				if (self.event.start_discussion_permission === 'anyone') {
					self.canConfigmoderation = true;
				}
				if(self.event.admission_type == 'ticketed_pixerf'){
					self.event.paid_event = (self.event.ticket_price && !((self.event.ticket_price  == 0) || (!self.event.ticket_price)) ? true : false);
				}
			} else {
				self.event.event_type = self.defaultEventType

				if (self.event.event_type === 'standard') {
					self.disableOnlineEvent = true;
					self.event.is_online = false;
				} else {
					self.disableOnlineEvent = false;
				}
			}
		}

		function getCommunity() {
			pixerfApiCommunitySvc.list({
				user_id: self.loginedUser.id,
				membership: 'owner'
			}).$promise.then(function (response) {
				self.communities = response.data.splice(0, 2);
			});
		}

		function onCheckboxPaidEventChanged(value){
			if(!value){
				self.event.ticket_price = null;
			}
		}

		function onStartSaleTimechanged(){
		}

		function onAddDateTime() {
			self.dateTimes.push({
				date: null,
				start_time: null,
				end_time: null
			});
		}

		function onModerationTypeChanged(item) {
			self.event.moderate_event_posts = item.value;
		}

		function onPostingTypeChanged(item) {
			self.event.start_discussion_permission = item.value;
			if (self.event.start_discussion_permission === 'anyone') {
				self.canConfigmoderation = true;
			} else {
				self.canConfigmoderation = false;
			}
		}

		function onRemoveDateTime(index) {
			self.dateTimes.splice(index, 1);
		}

		function showUploadAvatarPopup() {
			if (self.uploadEventCoverOptions && self.uploadEventCoverOptions.canEdit) {
				var popup = uploadCoverPopupSvc.showPopup(self.uploadEventCoverOptions);

				popup.result.then(function (instance) {
					self.eventCover.url = instance.thumbnail;
					systemUtils.digest($scope);

					self.dropzoneInstance = instance.dropzone;
				})
			}
		}

		function onAdmissionTypeChanged(item) {
			self.event.admission_type = item.value;
		}

		function onCapacityTypeChanged(item) {
			self.isLimitedCapacity = item.value === 'limited';
			self.event.capacity_type = item.value;
		}

		function onPrivacyTypeChanged(item) {
			self.event.is_private = item.value;
		}

		function onEventTypeChanged(item) {
			self.event.event_type = item.value;
			if (self.event.event_type && self.event.event_type === 'standard') {
				self.disableOnlineEvent = true;
				self.event.is_online = false;
			} else {
				self.disableOnlineEvent = false;
			}
		}

		function onCreateEvent() {
			if (!validate()) return;
			if (self.event.id) {
				return updateEvent();
			}
			self.event = transformEventObject(self.event);
			self.event.status = 'active';
			var timeCreatePopup = waitingEventLaunchPopupSvc.showPopup({eventDateTime: self.dateTimes[0], eventType: getItemType(self.event.event_type)});
			timeCreatePopup.result.then(function (respone) {
				if (!respone) return;
				if (respone != 'now') {
					self.event.booking_date = respone;
				}
				pixerfApiEventSvc.create({
					community_id: self.community.id
				}, self.event).$promise.then(function (res) {
					self.event = res.data
					data.event = self.event;
					if (self.dropzoneInstance) {
						self.dropzoneInstance.options.url = pixerfUrl.full + 'api/community_events/' + self.event.id;
						self.dropzoneInstance.processQueue();
					} else {
						$uibModalInstance.close(self.event);
					}
					var successMessage = 'Your ' + getItemType(self.event.event_type) + ' was created successfully';
					toastr.success(successMessage);
				}).catch(function (err) {
					console.log(err);
				})
			})
		}

		function updateEvent() {
			if (!validate()) return;
			var eventToSave = Object.assign({}, self.event);
			delete eventToSave.cover;
			var convertData = transformEventObject(self.event);
			eventToSave.event_datetimes = convertData.event_datetimes;
			eventToSave.location = convertData.location;
			pixerfApiEventSvc.update({
				id: eventToSave.id
			}, eventToSave).$promise.then(function (res) {
				self.event = res.data;
				data.event = self.event;
				self.dateTimes = reTransformDateTime(res.data.event_datetimes);
				if (self.dropzoneInstance) {
					self.dropzoneInstance.options.url = pixerfUrl.full + 'api/community_events/' + self.event.id;
					self.dropzoneInstance.processQueue();
				} else {
					$uibModalInstance.close(self.event);
				}
				var successMessage = 'Your ' + getItemType(eventToSave.event_type) + ' updated successfully';
				toastr.success(successMessage);
				systemUtils.digest($scope);
			}).catch(function (err) {
				console.log(err);
			})
		}

		function getItemType(type){
			if(!type){
				return 'event/class';
			}else if(type == 'class'){
				return 'class';
			}else {
				return 'event';
			}
		}

		function onSaveAsDraftEvent() {
			self.event = transformEventObject(self.event);
			pixerfApiEventSvc.create({
				community_id: self.community.id
			}, self.event).$promise.then(function (res) {
				self.event = res.data
				data.event = self.event;
				if (self.dropzoneInstance) {
					self.dropzoneInstance.options.url = pixerfUrl.full + 'api/community_events/' + self.event.id;
					self.dropzoneInstance.processQueue();
				} else {
					$uibModalInstance.close(self.event);
				}
				var successMessage = 'Your ' + getItemType(self.event.event_type) + ' has been successfully saved as draft';
				toastr.success(successMessage);
			}).catch(function (err) {
				console.log(err);
			})
		}

		function onCancelCreateEvent() {
			$uibModalInstance.dismiss('cancel');
		}

		function transformEventObject(eventData) {
			var transformedEvent = {
				event_datetimes: []
			};
			if (eventData.id) {
				transformedEvent.id = self.event.id;
			}

			transformedEvent.name = self.event.name;
			transformedEvent.description = self.event.description;
			transformedEvent.is_private = self.event.is_private;
			transformedEvent.capacity_type = self.event.capacity_type;
			transformedEvent.admission_type = self.event.admission_type;
			transformedEvent.ticket_url = self.event.ticket_url;
			transformedEvent.max_attendees = self.event.max_attendees;
			transformedEvent.venue = self.event.venue;
			transformedEvent.is_online = self.event.is_online;
			transformedEvent.moderate_event_posts = self.event.moderate_event_posts;
			transformedEvent.start_discussion_permission = self.event.start_discussion_permission;
			transformedEvent.event_type = eventData.event_type;

			if (eventData.location) {
				transformedEvent.location = accountUtils.getUserGoogleLocation(eventData.location);
			}

			for (var i = 0; i < self.dateTimes.length; i++) {
				var formattedDate = transformTime(self.dateTimes[i]);
				if (self.dateTimes[i].date && !_.isEmpty(formattedDate)) {
					transformedEvent.event_datetimes.push(formattedDate);
				}
			}

			if(transformedEvent.admission_type == 'ticketed_pixerf'){
				transformedEvent.ticket_price = self.event.ticket_price;
			}

			return transformedEvent;
		}

		function transformTime(date) {
			var formattedStartDate = moment(date.date.getDate() + "/" + (date.date.getMonth() + 1) + "/" + date.date.getFullYear() + " " + date.start_time, "DD/MM/YYYY HH:mm:ss");
			var formattedEndDate = moment(date.date.getDate() + "/" + (date.date.getMonth() + 1) + "/" + date.date.getFullYear() + " " + date.end_time, "DD/MM/YYYY HH:mm:ss");
			var isValidDuration = moment(formattedEndDate, "DD/MM/YYYY HH:mm:ss").diff(moment(formattedStartDate, "DD/MM/YYYY HH:mm:ss")) >= 0;

			if (!isValidDuration) {
				return {};
			}

			return {
				start_datetime: formattedStartDate.format(),
				end_datetime: formattedEndDate.format()
			};
		}

		function validate(eventData) {
			var result = true;
			for (var i = 0; i < self.dateTimes.length; i++) {
				var formattedDate = transformTime(self.dateTimes[i]);
				if (!self.dateTimes[i].date || _.isEmpty(formattedDate)) {
					result = false;
					toastr.error("Invalid time ");
				}
			}
			return result;
		}

		function reTransformDateTime(dateTimes) {
			var result = [];
			for (var i = 0; i < dateTimes.length; i++) {

				var formattedDate = {
					date: new Date(dateTimes[i].start_datetime)
				};

				if (parseInt(moment(new Date(dateTimes[i].start_datetime)).format("HH")) > 12) {
					formattedDate.start_time = {
						hour: parseInt(moment(new Date(dateTimes[i].start_datetime)).format("HH")) - 12,
						min: parseInt(moment(new Date(dateTimes[i].start_datetime)).format("mm")),
						second: parseInt(moment(new Date(dateTimes[i].start_datetime)).format("ss")),
						options: "PM"
					}
				} else {
					formattedDate.start_time = {
						hour: parseInt(moment(new Date(dateTimes[i].start_datetime)).format("HH")),
						min: parseInt(moment(new Date(dateTimes[i].start_datetime)).format("mm")),
						second: parseInt(moment(new Date(dateTimes[i].start_datetime)).format("ss")),
						options: "AM"
					}
				}

				if (formattedDate.start_time.hour < 10) {
					formattedDate.start_time.hour = "0" + formattedDate.start_time.hour;
				}
				if (formattedDate.start_time.min < 10) {
					formattedDate.start_time.min = "0" + formattedDate.start_time.min;
				}

				if (parseInt(moment(new Date(dateTimes[i].end_datetime)).format("HH")) > 12) {
					formattedDate.end_time = {
						hour: parseInt(moment(new Date(dateTimes[i].end_datetime)).format("HH")) - 12,
						min: parseInt(moment(new Date(dateTimes[i].end_datetime)).format("mm")),
						second: parseInt(moment(new Date(dateTimes[i].end_datetime)).format("ss")),
						options: "PM"
					}
				} else {
					formattedDate.end_time = {
						hour: parseInt(moment(new Date(dateTimes[i].end_datetime)).format("HH")),
						min: parseInt(moment(new Date(dateTimes[i].end_datetime)).format("mm")),
						second: parseInt(moment(new Date(dateTimes[i].end_datetime)).format("ss")),
						options: "AM"
					}
				}

				if (formattedDate.end_time.hour < 10) {
					formattedDate.end_time.hour = "0" + formattedDate.end_time.hour;
				}
				if (formattedDate.end_time.min < 10) {
					formattedDate.end_time.min = "0" + formattedDate.end_time.min;
				}
				if (formattedDate.date && !_.isEmpty(formattedDate)) {
					result.push(formattedDate);
				}
			}

			return result;
		}
	}
})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.factory('createDiscussionTopicPopupSvc', createDiscussionTopicPopupSvc);
	createDiscussionTopicPopupSvc.$inject = ['$uibModal'];

	function createDiscussionTopicPopupSvc($uibModal) {

		function showPopup(data) {
			return $uibModal.open({
				templateUrl: 'app/components/create-discussion-topic-popup/create-discussion-topic-popup.html',
				controller: 'createDiscussionTopicPopupCtrl',
				controllerAs: 'vm',
				animation: true,
				windowClass: 'create-discussion-topic-popup__wrapper',
				backdrop: 'static',
				resolve: {
					'data': function () {
						return data;
					}
				}
			});
		}

		return {
			showPopup: showPopup
		};
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('createDiscussionTopicPopupCtrl', createDiscussionTopicPopupCtrl);

	createDiscussionTopicPopupCtrl.$inject = ['$scope', '$uibModalInstance', 'pixerfApiCommunitySvc', 'data', 'toastr', 'sessionManagerSvc', 'pixerfUrl', 'fileConst', 'systemUtils', 'pixerfConfirmPopupSvc', '$translate', 'communityConst', 'alertMessagePopupSvc', 'confirmPopupSvc', '$q', 'translationSvc'];

	function createDiscussionTopicPopupCtrl($scope, $uibModalInstance, pixerfApiCommunitySvc, data, toastr, sessionManagerSvc, pixerfUrl, fileConst, systemUtils, pixerfConfirmPopupSvc, $translate, communityConst, alertMessagePopupSvc, confirmPopupSvc, $q, translationSvc) {

		var self = this;
		var LIMIT_PHOTO_ATTACHMENT = communityConst.DISSCUSSION.LIMIT_PHOTO_ATTACHMENT;
		self.loginUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.popupHeader = 'create-post';
		self.community = data.community;
		self.isOwner = self.loginUser && self.loginUser.id === self.community.owner.id;
		self.showAttachPhotoBtn = true;
		self.discussion = {};
		self.errors = [];
		self.responsedData = {};
		self.onUpdateDiscussion = onUpdateDiscussion;
		self.onCreateDiscussion = onCreateDiscussion;
		self.onRemoveDiscussion = onRemoveDiscussion;
		self.close = close;
		self.dismiss = dismiss;
		self.saveDraftDiscussion = saveDraftDiscussion;
		self.updateDraftDiscussion = updateDraftDiscussion;
		self.isUpdateMode = false;
		self.isDraftDiscussion = false;
		var errorHandlerFn = _.debounce(errorHandler, 1000);
		self.dropzoneConfig = {
			'instance': {},
			'options': {
				url: pixerfUrl.full + 'api/discussions/',
				maxFilesize: 40,
				maxFiles: 3,
				parallelUploads: 3,
				paramName: 'photos[]',
				acceptedFiles: ".jpeg, .jpg",
				autoProcessQueue: false,
				thumbnailWidth: 155,
				thumbnailHeight: 155,
				maxThumbnailFilesize: 40,
				dictCancelUpload: "X",
				dictRemoveFile: "X",
				addRemoveLinks: true,
				uploadMultiple: true,
				previewsContainer: '#create-discussion-topic-popup__attach-photos-section',
				clickable: ['#create-discussion-topic-popup__attach-photo-button', '.create-discussion-topic-popup__attach-more'],
				method: "put",
				headers: {
					"Authorization": "Bearer " + sessionManagerSvc.getToken()
				},
				dictFileTooBig: "File is too big ({{filesize}} MB). Max file size is: {{maxFilesize}} MB.",
			},
			'eventHandlers': {
				addedfile: function (file, xhr, form) {
					var error = validateBeforeUploading(file);
					if (error) {
						setErrors(error);
						errorHandlerFn();
						this.removeFile(file);
					}
					self.discussion.photos = [];
					isShowAttachPhotoBtn();
				},
				removedfile: function (file) {
					isShowAttachPhotoBtn();
				},
				processing: function (file) {
					self.isAttachmentUploading = true;
				},
				success: function (file, responsedFile) {
					self.responsedData = responsedFile;
				},
				completemultiple: function (file) {
					self.dropzoneConfig.instance.previewsContainer.remove();
					self.dropzoneConfig.instance.removeFile(file);
					self.isShowAttachPhotoBtn = true;
					self.isAttachmentUploading = false;
					if (self.responsedData.id && data.createdCallback) {
						data.createdCallback(self.responsedData);
					}
					if (self.responsedData.id) {
						$uibModalInstance.close(self.responsedData);
					}
				}
			}
		}

		init();

		function init() {
			if (data.discussion) {
				self.isUpdateMode = true;
				self.discussion = systemUtils.clone(data.discussion);
				self.isDraftDiscussion = data.discussion.status === 'draft';
				self.popupHeader = self.isDraftDiscussion ? 'edit-discussion-topic-draft' : 'edit-discussion-topic';
				self.showAttachPhotoBtn = (self.discussion.photos && self.discussion.photos.length) ? self.discussion.photos.length < LIMIT_PHOTO_ATTACHMENT : true;
				delete data.discussion;
			}

		}

		function isShowAttachPhotoBtn() {
			if (self.dropzoneConfig.instance.files && self.dropzoneConfig.instance.files.length && self.discussion.photos && self.discussion.photos.length) {
				self.showAttachPhotoBtn = (self.dropzoneConfig.instance.files.length + self.discussion.photos.length) < LIMIT_PHOTO_ATTACHMENT;
			} else if (self.dropzoneConfig.instance.files && self.dropzoneConfig.instance.files.length) {
				self.showAttachPhotoBtn = self.dropzoneConfig.instance.files.length < LIMIT_PHOTO_ATTACHMENT;
			} else {
				self.showAttachPhotoBtn = self.discussion.photos.length < LIMIT_PHOTO_ATTACHMENT;
			}
			systemUtils.digest($scope);
		}

		function onUpdateDiscussion(isPublished, form) {
			var errorMsg = validateDiscussion(self.discussion, form);
			if (errorMsg) {
				toastr.error(errorMsg);
				return;
			}
			if (isPublished) {
				self.discussion.status = 'published';
			}
			var params = buildParamDiscussion(self.discussion);
			pixerfApiCommunitySvc.update_discussion({
				id: self.discussion.id
			}, params).$promise.then(function (res) {
				self.dropzoneConfig.instance.options.url += res.data.id;
				self.dropzoneConfig.instance.processQueue();
				if (!self.isAttachmentUploading) {
					$uibModalInstance.close(self.discussion);
				} else {
					self.responsedData = res.data;
				}
			}).catch(function (err) {
				console.log(err);
			})
		}

		function buildParamDiscussion(dicussion) {
			return {
				subject: dicussion.subject,
				description: dicussion.description,
				status: dicussion.status
			}
		}

		function validateBeforeUploading(file) {
			var validToUploadFiles = [];
			if (self.dropzoneConfig.instance && self.dropzoneConfig.instance.files) {
				validToUploadFiles = _.reject(self.dropzoneConfig.instance.files, function (f) {
					return f.status === "added";
				})
			}
			if (isDuplicateFile(validToUploadFiles, file)) {
				return {
					code: fileConst.UPLOAD_PHOTO_VALIDATION.ERROR_CODE.DUPLICATED,
					file: file
				};
			}
		}

		function isDuplicateFile(validFiles, file) {
			var isExisted = _.find(validFiles, function (f) {
				return isSameFile(f, file);
			})
			return isExisted;
		}

		function isExceedNumberOfUpload(validFiles, limit) {
			return validFiles.length > limit;
		}

		function isSameFile(fileOne, fileTwo) {
			return fileOne.name === fileTwo.name &&
				fileOne.size === fileTwo.size;

		}

		function setErrors(error) {
			error.file.pixerfError = error.code;
			self.errors.push(error);
		}

		function errorHandler(errors) {
			if (!errors) errors = self.errors;
			if (errors.length === 0) return;
			var errMsg = '';
			var callToActionMsg = '';
			var groupedError = _.groupBy(errors, function (item) {
				return item.code;
			});
			for (var key in groupedError) {
				callToActionMsg = '';
				if (key === fileConst.UPLOAD_PHOTO_VALIDATION.ERROR_CODE.DUPLICATED) {
					errMsg += "<p>" + $translate.instant("the-following-photos-uploaded-before") + "</p>";
					callToActionMsg += "<p class='upload-photo__validation-popup__call-to-action-msg'>" + $translate.instant("try-uploading-new-ones") + "!</p>";
				}
				errMsg += buildErrorFilename(groupedError[key]);
				errMsg += callToActionMsg;
			}
			pixerfConfirmPopupSvc.showPopup({
				hideCancelBtn: true,
				hideConfirmText: true,
				hideTitle: true,
				message: errMsg,
				windowClass: 'upload-photo__validation-popup',
				okBtnText: 'OK'
			});
			self.errors = [];
		}

		function buildErrorFilename(files) {
			var errMsg = '';
			for (var i = 0; i < files.length; i++) {
				errMsg += ("<div class='upload-photo__invalid-file text--truncate'> - " + files[i].file.name + "</div>");
			}
			return errMsg;
		}

		function onCreateDiscussion(form) {
			var errorMsg = validateDiscussion(self.discussion, form);
			if (errorMsg) {
				toastr.error(errorMsg);
				return;
			}
			var params = buildParamDiscussion(self.discussion);
			if (!self.isOwner && self.community.moderate_discussions) {
				pixerfApiCommunitySvc.create_discussion({
					id: self.community.id
				}, params).$promise.then(function (res) {
					self.dropzoneConfig.instance.options.url += res.data.id;
					self.dropzoneConfig.instance.processQueue();
                    if (!self.isAttachmentUploading) {
                        $uibModalInstance.close(self.discussion);
                    } else {
                        self.responsedData = res.data;
                    }
					alertMessagePopupSvc.showPopup({
						title: "Thanks for submitting your post!",
						description: "Once approved, your post will appear on the page."
					});
				}).catch(function (err) {
					toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
					console.log(err);
				})
			} else {
				pixerfApiCommunitySvc.create_discussion({
					id: self.community.id
				}, params).$promise.then(function (res) {
					self.dropzoneConfig.instance.options.url += res.data.id;
					self.dropzoneConfig.instance.processQueue();
					toastr.success("Your post was created successfully");
					if (!self.isAttachmentUploading && data.createdCallback) {
						data.createdCallback(res.data);
						$uibModalInstance.close(self.discussion);
					} else if (!self.isAttachmentUploading) {
						$uibModalInstance.close(self.discussion);
					} else {
						self.responsedData = res.data;
					}
				}).catch(function (err) {
					toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
					console.log(err);
				})
			}
		}

		function validateDiscussion(data, form) {
			form.$setDirty();
			if (!data || !data.subject) {
				return "Please input subject for discussion";
			} else if (!data || !data.description) {
				return "Please input description for discussion";
			}
		}

		function close() {
			if (self.isDraftDiscussion) {
				confirmPopupSvc.showPopup({
					windowClass: 'remove-discussion-confirm-popup',
					title: "You haven't posted this draft.",
					message: "Are you sure you want to leave this page?",
					submitBtnText: 'Yes',
					cancelBtnText: 'No',
					submit: function () {
						var def = $q.defer();
						def.resolve();
						return def.promise;
					},
					submitCallback: function () {
						$uibModalInstance.close(self.discussion);
					}
				});
			} else {
				$uibModalInstance.close(self.discussion);
			}
		}

		function saveDraftDiscussion() {
			pixerfApiCommunitySvc.create_discussion({
				id: self.community.id
			}, self.discussion).$promise.then(function (res) {
				self.dropzoneConfig.instance.options.url += res.data.id;
				self.dropzoneConfig.instance.processQueue();
				if (!self.isAttachmentUploading) {
					$uibModalInstance.close(res.data);
				} else {
					self.responsedData = res.data;
				}
			}).catch(function (err) {
				console.log(err);
				toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
			});
		}

		function updateDraftDiscussion() {
			self.discussion.status = 'draft';
			onUpdateDiscussion();
		}

		function onRemoveDiscussion() {
			if (!self.discussion || !self.discussion.id) {
				$uibModalInstance.close();
				return;
			} else {
				var confirmText = {
					title: self.isDraftDiscussion ? 'Are you sure you want to delete this draft?' : 'Are you sure you want to delete this post?',
					message: self.isDraftDiscussion ? 'You will not be able to undo this action.' : 'You will lose all the engagements and comments from this post.'
				}
				confirmPopupSvc.showPopup({
					windowClass: 'remove-discussion-confirm-popup',
					title: confirmText.title,
					message: confirmText.message,
					submitBtnText: 'Yes, delete it',
					cancelBtnText: 'No, keep it',
					submit: function () {
						var def = $q.defer();
						pixerfApiCommunitySvc.remove_disscussion({
							id: self.discussion.id
						}).$promise.then(function (res) {
							toastr.success("Discussion: " + self.discussion.subject + " has been deleted!");
							def.resolve(res.data)
						}).catch(function (err) {
							def.reject();
						})
						return def.promise;
					},
					submitCallback: function (res) {
						$uibModalInstance.close(res);
					}
				});
			}
		}

		function dismiss(){
			$uibModalInstance.dismiss();
		}
	}
})();

(function(){
  'use strict';
  angular
    .module('pixerf')
    .factory('createCommunityPopupSvc', createCommunityPopupSvc);
    createCommunityPopupSvc.$inject = ['pixerfApiGallerySvc', '$uibModal', 'commonConst', 'createCommunitySvc', 'communityConst', '$translate'];

    function createCommunityPopupSvc(pixerfApiGallerySvc, $uibModal, commonConst, createCommunitySvc, communityConst, $translate){

		var mSteps = [{
			name: communityConst.CREATE_STEP.BASIC_INFO,
			title: "Create Community",
			requiredFeilds: ["community_name"],
			validator: function(community){
				return createCommunitySvc.validate(community);
			},
			cancelBtnLabel: "Cancel"

		},{
			name: communityConst.CREATE_STEP.INVITE_MEMBERS,
			title: "Community Members",
			cancelBtnLabel: "Skip, I will add members later"
		}]
        function getGallery(){
        	return mGallery;
        }
        function getMode(){
            return mMode;
		}
		function buildSavedData(rawData){
			return {
				id: rawData.id,
				name: rawData.name,
				description: rawData.description,
				rules: rawData.rules,
				start_discussion_permission: rawData.start_discussion_permission,
				is_private: rawData.is_private,
				is_unlisted: rawData.is_unlisted,
				moderate_discussions: rawData.moderate_discussions,
				countries: rawData.countries
			}
		}
		function getSteps(mode, step){
			step = step || communityConst.CREATE_STEP.BASIC_INFO;
			if(mode === commonConst.ACTION.EDIT && step){
				return [_.find(mSteps, function(item){
					if(item.name === communityConst.CREATE_STEP.BASIC_INFO){
						item.title = $translate.instant("edit", {name: $translate.instant("commnity")});
					}
					return item.name === step;
				})]
			} else {
				if(step === communityConst.CREATE_STEP.BASIC_INFO){
					_.find(mSteps, function(item){
						if(item.name === communityConst.CREATE_STEP.BASIC_INFO){
							item.title = $translate.instant("create-community");
						}
					});
				}
			}
			return mSteps;
		}
		function showPopup(data){
	    	return $uibModal.open({
				templateUrl: 'app/components/create-community-popup/create-community-popup.html',
				controller: 'createCommunityPopupCtrl',
				controllerAs: 'vm',
				animation: true,
                backdrop: 'static',
				windowClass: 'create-community-popup-window-class',
                resolve: {
                    'resolveData': function(){
                        return data;
                    }
                }
		    });

    	}
		function save(gallery, mode){
			return mode === commonConst.ACTION.EDIT ?  pixerfApiGallerySvc.put({id: gallery.id}, gallery).$promise : pixerfApiGallerySvc.save(gallery).$promise;
		}
        function deleteGallery(galleryId){
            return pixerfApiGallerySvc.delete({id: galleryId}).$promise;
        }
		function reset(){
            mMode.data = commonConst.ACTION.CREATE;
		}

		return {
			getGallery : getGallery,
			getMode: getMode,
			getSteps: getSteps,
			save: save,
            deleteGallery: deleteGallery,
			reset: reset,
			showPopup: showPopup,
			buildSavedData: buildSavedData
		};
    }
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('createCommunityPopupCtrl', createCommunityPopupCtrl);

	createCommunityPopupCtrl.$inject = ['$state', '$scope', 'sessionManagerSvc', 'communityConst', '$uibModalInstance', '$timeout', 'commonConst', 'resolveData', 'outlookContactSvc', 'toastr', 'createCommunityPopupSvc', 'systemUtils', 'pixerfUrl', 'googleContactSvc', 'pixerfApiCommunitySvc', '$q', 'communityMemberFilterSvc', 'communityInviteEmailPopupSvc', 'translationSvc', 'inviteCommunityMembersPopupSvc'];

	function createCommunityPopupCtrl($state, $scope, sessionManagerSvc, communityConst, $uibModalInstance, $timeout, commonConst, resolveData, outlookContactSvc, toastr, createCommunityPopupSvc, systemUtils, pixerfUrl, googleContactSvc, pixerfApiCommunitySvc, $q, communityMemberFilterSvc, communityInviteEmailPopupSvc, translationSvc, inviteCommunityMembersPopupSvc) {

		var self = this;

		self.community = {
			name: '',
			description: '',
			thumbnail: '',
			is_private: true,
			start_discussion_permission: 'anyone',
			moderate_discussions: true,
			rules: "1.  Avoid verbal abuse.\n2.  Don’t spam.\n3.  Respond politely to other comments.\n4.  Community Admins also have the rights to remove and ban users who violate group policy and rules."
		};

		self.avatar = {
			url: null
		};

		self.popupData = resolveData || {};
		self.showUploadAvatarModal = showUploadAvatarModal;
		self.closePopup = closePopup;
		self.onCloseBtnClicked = onCloseBtnClicked;
		self.onCancelBtnClicked = onCancelBtnClicked;
		self.onPersonListInit = onPersonListInit;
		self.onSearchConditionChanged = onSearchConditionChanged;
		self.onAvatarChanged = onAvatarChanged;
		self.onContactRemove = onContactRemove;
		self.onGmailClicked = onGmailClicked;
		self.onOutlookClicked = onOutlookClicked;
		self.onSendListEmailsClicked = onSendListEmailsClicked;
		self.onAddToInviteList = onAddToInviteList;
		self.invitedList = [];
		self.navigate = navigate;
		self.onNextBtnClicked = onNextBtnClicked;
		self.loginUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.maximumCommunitiesCanCreate = self.loginUser.isBiz ? 10 : 3;
		self.avatar = {};
		self.isMissingField = {};
		self.isLastSlide = false;
		self.isFirstSlide = true;
		self.isWorking = false;
		self.formOnChange = formOnChange;
		self.searchFilterOptions = {
			parentClass: ".create-community-popup"
		}
		self.isAgreedTnC = false;
		self.isSelectedLocation = false;
		self.slickSetting = {
			onBeforeChange: function (event, slick, currentSlide, nextSlide) {
				self.isLastSlide = nextSlide === slick.slideCount - 1;
				self.isFirstSlide = (nextSlide === 0) || (currentSlide === 1 && currentSlide > nextSlide);
				self.currentStep = getStepByIndex(nextSlide);
				self.submitBtnLabel = self.isLastSlide ? "Invite" : "Next";
				systemUtils.digest($scope);
			},
			onInit: function (slick) {
				self.slick = slick;
				self.isFirstSlide = true;
				self.isLastSlide = self.slick.slideCount === 1;
				systemUtils.digest($scope);
			},
			customPaging: function (slider, i) {
				return (i + 1) + '/' + slider.slideCount;
			}
		}
		self.steps = createCommunityPopupSvc.getSteps(self.popupData.mode);

		init();

		$scope.$on('modal.closing', closeAll);

		function closeAll() {
			var child = $('.create-community-form__country-dropdown.open');
			child.remove();
		}

		function init(user, steps) {

			self.successMessage = "Your community has been successfully ";
			self.currentStep = getStepByIndex(0);
			self.requiredFields = self.steps.BASIC_INFO ? checkUserInfo(self.userData, self.steps.BASIC_INFO.requiredFields) : void 0;
			if (self.popupData.mode === commonConst.ACTION.EDIT) {
				self.community = self.popupData.community;
				self.successMessage += "updated!";
				self.submitBtnLabel = self.popupData.mode === commonConst.ACTION.EDIT ? "Save" : self.isLastSlide ? "Invite" : "Next";
			} else {
				self.successMessage += "created!";
				self.submitBtnLabel = self.isLastSlide ? "Invite" : "Next";
				self.nSteps = getNSteps(self.steps);
			}
		}

		function onPersonListInit(instance) {
			self.personListInstance = instance;
		}

		function onCloseBtnClicked() {
			dismiss();
		}

		function onCancelBtnClicked() {
			if (self.isWorking) return;
			if (self.currentStep.name === communityConst.CREATE_STEP.INVITE_MEMBERS && self.isLastSlide) {
				navigate("next");
			} else {
				dismiss();
			}
		}

		function onNextBtnClicked() {
			navigate("next");
		}

		function buildSearchParams(searchCondition) {
			return communityMemberFilterSvc.buildSearchParams(searchCondition, self.loginUser);
		}

		function onSearchConditionChanged(searchCondition) {
			if (searchCondition.isDirectoryChecked) {
				self.layout = 'listPeople';
			} else if (searchCondition.isEmailChecked) {
				self.layout = 'listEmail';
			} else if (searchCondition.isLinkChecked) {
				self.layout = 'listEmail';
			}

			if (!searchCondition.isEmailChecked && !searchCondition.isDirectoryChecked) return;

			self.personListInstance.getPeopleList(buildSearchParams(searchCondition), true);
		}

		function onAvatarChanged(dropzone) {
			self.dropzoneInstance = dropzone;
		}

		function createCommunity(community, form) {
			var def = $q.defer();
			var saveData = createCommunityPopupSvc.buildSavedData(community);
			var action = self.popupData.mode === commonConst.ACTION.EDIT ? "update" : "create";
			pixerfApiCommunitySvc[action](saveData).$promise.then(function (responseCommunity) {
				self.community.id = responseCommunity.id;
				def.resolve(self.community);
			}, function (err) {
				if (err && err.data && err.data.data) {
					toastr.error(err.data.data.message);
				} else {
					toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
				}
				def.reject();
			})
			return def.promise;
		}

		function getStepByIndex(index) {

			return self.steps[index];
		}

		function getNSteps(steps) {
			var i = 0;
			for (var key in steps) {
				if (steps.hasOwnProperty(key)) {
					i++;
				}
			}
			return i;
		}

		function onCommunityCreated() {
			toastr.success(self.successMessage);
			$timeout(function () {
				var route = self.popupData.route ? self.popupData.route : 'user-home-page.' + self.loginUser.account_type + '.communities.grid';
				if (self.popupData.route !== "no-navigate") {
					if ($state.current && $state.current.name === 'user-home-page.' + self.loginUser.account_type + '.communities.grid') {
						$state.reload();
					} else {
						$state.go(route);
					}
				}
				closePopup();
				if ((self.popupData.mode !== commonConst.ACTION.EDIT) && (self.community.status && self.community.status == 'active')) {
					showInviteFriendsPopup(self.community);
				}
			}, 2000);
		}

		function showInviteFriendsPopup(community) {
			var popup = inviteCommunityMembersPopupSvc.showPopup({
				community: community,
				defaultSearchCondition: {
					isDirectoryChecked: true,
					isEmailChecked: false,
					isLinkChecked: false,
					country: "",
					speciality: "",
					showSkipBtn: true
				}
			});
			popup.result.then(function (invitedPeoples) {
				// invitationSentHandler(invitedPeoples);
			});
		}

		function navigate(direction) {
			var def = $q.defer();
			var currentSlideIndex = self.slick.slickCurrentSlide();
			var currentStep = getStepByIndex(currentSlideIndex);
			if (direction === "next") {
				var validator = currentStep.validator;
				if (validator && !currentStep.canSkip) {
					self.createCommunityForm.$setDirty();
					var errMsg = validator(self.community);
					if (errMsg) {
						toastr.error(errMsg);
						def.resolve();
						return false;
					}
				}
				if (currentStep.name === "BASIC_INFO") {
					if (!self.isWorking) {
						self.isWorking = true;
						createCommunity(self.community).then(function (respone) {
							if (self.dropzoneInstance) {
								self.dropzoneInstance.options.url = pixerfUrl.full + 'api/communities/' + respone.id;
								self.dropzoneInstance.processQueue();
								self.dropzoneInstance.on("complete", function () {
									onCommunityCreated()
								})
							} else {
								onCommunityCreated();
							}
							self.isWorking = false;
							def.resolve();
						}, function () {
							def.reject();
							self.isWorking = false;
							closePopup();
						});
					}
				} else {

					if (self.isLastSlide) {
						inviteMembers().then(function () {
							def.resolve();
							onCommunityCreated();
						}, function () {
							def.reject();
						})
					} else {
						def.resolve();
						self.slick.slickNext();
					}
				}
			} else {
				def.resolve();
				self.slick.slickPrev();
			}
			return def.promise;
		}

		function inviteMembers() {
			var recipients = _.reduce(self.personListInstance.peoples, function (memo, item) {
				if (item.isSelected) {
					memo.push(item.id)
				}
				return memo;
			}, []);
			return pixerfApiCommunitySvc.invite({
				id: self.community.id
			}, {
				"recipients": recipients,
				"sender_id": self.loginUser.id
			}).$promise;
		}

		function showUploadAvatarModal(type) {
			var modal = settingSvc.showUploadModal({
				'type': type
			});
			modal.result.then(function (handle) {
				settingSvc.updateUserProfilePhotos(self.userData, type, handle);
			}, function () {});
		}

		function dismiss() {
			$uibModalInstance.dismiss();
		}

		function closePopup(data) {
			$uibModalInstance.close(data);
		}

		function checkUserInfo(userInfo, feilds) {
			var requiredFields = {};
			for (var i = 0; i < feilds.length; i++) {
				requiredFields[feilds[i]] = !userInfo[feilds[i]];
			}
			requiredFields["country"] = (userInfo["address"] && !userInfo["address"]["country"]) || !userInfo["address"];
			return requiredFields;
		}

		function onGmailClicked() {
			googleContactSvc.auth(function () {
				var googleAuth = communityInviteEmailPopupSvc.showPopup({
					getter: googleContactSvc.getContacts,
					getSelectedPersons: true
				});

				googleAuth.result.then(function (data) {
					var existEmails = _.intersection(self.invitedList, data.invited);
					if (existEmails && existEmails.length) {
						var newEmails = _.difference(data.invited, existEmails);
						self.invitedList = self.invitedList.concat(newEmails);
						var errMsg = "Failed to send invitations. Some of your friends are already invited: ";
						for (var i = 0; i < existEmails.length; i++) {
							errMsg += existEmails[i];
							if (i !== existEmails.length) {
								errMsg += ", "
							}
						}
						toastr.error(errMsg);
					} else {
						self.invitedList = self.invitedList.concat(data.invited);
					}
				});
			});
		}

		function onOutlookClicked() {
			outlookContactSvc.auth(function () {
				var outlookAuth = communityInviteEmailPopupSvc.showPopup({
					getter: outlookContactSvc.getContacts,
					getSelectedPersons: true
				})

				outlookAuth.result.then(function (data) {
					var existEmails = _.intersection(self.invitedList, data.invited);
					if (existEmails && existEmails.length) {
						var newEmails = _.difference(data.invited, existEmails);
						self.invitedList = self.invitedList.concat(newEmails);
						var errMsg = "Failed to send invitations. Some of your friends are already invited: ";
						for (var i = 0; i < existEmails.length; i++) {
							errMsg += existEmails[i];
							if (i !== existEmails.length) {
								errMsg += ", "
							}
						}
						toastr.error(errMsg);
					} else {
						self.invitedList = self.invitedList.concat(data.invited);
					}
				});
			});
		}

		function onContactRemove(contact) {
			self.invitedList = _.reject(self.invitedList, function (mem) {
				return contact === mem;
			});
		}

		function onAddToInviteList(email) {
			if (!isExistEmail(email)) {
				self.invitedList.push(email);
				self.newEmail = "";
			} else {
				toastr.error("Failed to send invitation. Your friend is already invited.")
			}
		}

		function isExistEmail(email) {
			return _.contains(self.invitedList, email);
		}

		function onSendListEmailsClicked() {
			var data = _.map(self.invitedList, function (email) {
				return {
					'email': email
				};
			})
			closePopup(data);
		}

		function formOnChange(modelName) {
			if (modelName && modelName == 'countries') {
				self.isSelectedLocation = true;
			}
		}
	}
})();

(function () {
  'use strict';
  angular
    .module('pixerf')
    .factory('createCommunitySvc', createCommunitySvc);
  createCommunitySvc.$inject = ['pixerfUrl', '$translate'];
  function createCommunitySvc(pixerfUrl, $translate) {
    function getUploadCommunityAvatarOptions(community, callbacks) {
      return {
        dropzoneConfig: {
          'options': {
            url: pixerfUrl.full + 'api/communities/' + community.id,
            method: 'put',
            paramName: 'cover'
          }
        },
        onSuccess: function (file, response) {
          callbacks.onSuccess(response.cover);
        },
        introText: "Choose a photo as your community avatar ",
        rulesText: "<h6>Tips:</h6>"
          + "<p>Photo can be in any of the following formats: JPG or PNG.</p>"
          + "<p>Your photo should be square, 400 x 400</p>"
          + "<p>Maximum file size is 10MB</p>",
        canEdit: community.cover.canEdit,
        hoverEditText: "Change community avatar",
        editText: "Change avatar",
        hideText: true
      };
    }
    function validate(community, withoutCoverCheck) {
      var errMsg = ''
      if (!community.name) {
        errMsg = $translate.instant('please-fill-in-the-name-of-community');
      } else if (!community.description) {
        errMsg = $translate.instant('please-fill-in-the-description-of-community');
      } else if (!community.thumbnail && !withoutCoverCheck) {
        errMsg = 'Please add cover community!';
      }
      return errMsg;
    }
    return {
      getUploadCommunityAvatarOptions: getUploadCommunityAvatarOptions,
      validate: validate
    }
  }
})();

(function () {
	'use stricts';
	angular
		.module("pixerf")
		.controller("createCommunityFormCtrl", createCommunityFormCtrl);
	createCommunityFormCtrl.$inject = ['pixerfUrl', '$scope', 'uploadCoverPopupSvc', 'systemUtils', 'ISO3166', 'countryUtils', '$translate', '$timeout']

	function createCommunityFormCtrl(pixerfUrl, $scope, uploadCoverPopupSvc, systemUtils, ISO3166, countryUtils, $translate, $timeout) {
		var self = this;
		self.showUploadAvatarPopup = showUploadAvatarPopup;
		self.communityCover = {};
		self.uploading = false;
		self.canConfigmoderation = false;
		self.onPrivacyTypeChanged = onPrivacyTypeChanged;
		self.onPostingTypeChanged = onPostingTypeChanged;
		self.onModerationTypeChanged = onModerationTypeChanged;
		self.onCountriesSelected = onCountriesSelected;
		self.onChangeModel = onChangeModel;
		self.maxCountries = 15;
		self.countriesOpts = {
			"maxOptions": self.maxCountries,
			'noneSelectedText': 'Countries (select up to 15)',
			"container": "body",
			"customAll": true,
			"dropupAuto": false,
			"maxOptionsText": "Please select up to a maximum of " + self.maxCountries + " countries",
			"showPriority": true,
			"noneSelectedHtml": '<div>Countries <span class="countries-maxoptions-desc"> (select up to 15)</span><div>'
		};
		self.regionOptions = {
			props: "region",
			selections: countryUtils.regions
		};
		self.countryRegion = {
			selectedCountry: false,
			selectedRegion: false,
			selected: null
		};
		self.countryRegionOptions = {
			props: "selected",
			selections: [
				{
					label: 'Select a region',
					value: 'region'
				},
				{
					label: 'Select countries',
					value: 'country'
				},
			]
		};
		self.region = {}
		self.defaultRegionOption = [];
		self.uploadEventCoverOptions = {
			dropzoneConfig: {
				'options': {
					url: pixerfUrl.full + 'api/communities/' + self.community.id,
					method: 'put',
					paramName: 'cover',
					autoProcessQueue: false,
					maxFilesize: 40,
					parallelUploads: 10,
					dictFileTooBig: "File is too big ({{filesize}} MB). Max file size is: {{maxFilesize}} MB.",
				},
				eventHandlers: {
					processing: function (file) {
						self.uploading = true;
					},
					success: function (file, respone) {
						self.uploading = false;
						self.community = respone;
					}
				}
			},
			isManual: true,
			introText: "Choose a photo as your community cover",
			canEdit: true,
			editText: "Change community cover",
			cropper: {
				options: {
					viewport: {
						type: 'square'
					},
					boundary: {
						width: 500,
						height: 160
					},
					showZoomer: false
				}
			}
		};

		self.privacyTypes = [{
				value: "public",
				title: "public",
				description: "anyone-can-find-the-group"
			},
			{
				value: "private",
				title: "private",
				description: "only-members-can-find-the-group"
			},
			{
				value: "unlisted",
				title: "Unlisted",
				description: "unlisted-community-text-descriptions"
			}
		];

		self.postingTypes = [{
				value: 'anyone',
				title: "Anyone in the Community",
				description: "Any member in the Community can start a discussion and reply to the threads."
			},
			{
				value: 'only_admin',
				title: "Only Admin",
				description: "Only admins can start a discussion. Members will only be allowed to reply."
			}
		];

		self.moderationType = [{
				value: true,
				title: "Approval required",
				description: "Admin must approve all posts before they are published."
			},
			{
				value: false,
				title: "No approval required",
				description: "Admin does not need to review posts before they are published."
			}
		];

		self.defaultPrivacyType = self.privacyTypes[1].value;
		self.defaultPostingType = self.postingTypes[1].value;
		self.defaultModerationType = self.moderationType[0].value;
		self.onArrageChanged = onArrageChanged;
		self.onselectedRegionChanged = onselectedRegionChanged;
		self.onselectedCountryChanged = onselectedCountryChanged;

		var priorityCountry = ['SG', 'IN', 'PH', 'MY', 'ID', 'TH', 'VN', 'AE', 'BN', 'KH', 'TL', 'LA', 'MM', 'AU', 'CN', 'HK'];

		function onPrivacyTypeChanged(item) {
			self.community.is_private = (item.value == 'private');
			self.community.is_unlisted = (item.value == 'unlisted');
			onChangeModel();
		}

		function onChangeModel(modelName){
			if(self.highlight && self.highlight[modelName]){
				delete self.highlight[modelName];
			}
			if(self.onChange){
				self.onChange({name: modelName});
			}
		}

		function onselectedRegionChanged(){
			self.countryRegion.selectedCountry = false;
			self.countryRegion.selectedRegion = true;
			self.countryRegion.selected = 'region';
			var ddl= $(".bootstrap-select.create-community-form__country-dropdown.open");
			for( var i = 0; i < ddl.length; i++){
				ddl[i].remove();
			}
		}

		function onselectedCountryChanged(){
			self.countryRegion.selectedRegion = false;
			self.countryRegion.selectedCountry = true;
			self.countryRegion.selected = 'country';
		}

		function onPostingTypeChanged(item) {
			self.community.start_discussion_permission = item.value;
			if (self.community.start_discussion_permission === 'anyone') {
				self.canConfigmoderation = true;
			} else {
				self.canConfigmoderation = false;
			}
			onChangeModel();
		}

		function onModerationTypeChanged(item) {
			self.community.moderate_discussions = item.value;
			onChangeModel();
		}

		function buildCountries() {
			var arr = [];
			for (var key in ISO3166.codeToCountry) {
				arr.push({
					id: key,
					name: ISO3166.codeToCountry[key]
				})
			}
			return arr;
		}

		init();

		function init() {
			self.countries = buildCountries();
			self.countries = countryUtils.sortByPriority(priorityCountry, self.countries);
			if (self.community) {
				self.defaultPrivacyType = self.community.is_unlisted ? 'unlisted' : self.community.is_private ? 'private' : 'public';
				self.defaultPostingType = self.community.start_discussion_permission;
				self.defaultModerationType = self.community.moderate_discussions;
			}
			if (self.community && self.community.cover && self.community.cover['original']) {
				self.communityCover.url = self.community.cover['original'];
			}
			if (self.community.start_discussion_permission === 'anyone') {
				self.canConfigmoderation = true;
			}
			self.community.countries = self.community.countries ? self.community.countries : [];
			self.selectedCountries = countryUtils.getCountryArrObjectFromArrId(self.community.countries, self.countries)
			self.region = countryUtils.getRegion(self.community.countries);
			self.defaultRegionOption = ((self.region && self.region.value && self.community.id) ? self.region : []);
			if(self.community && self.community.id){
				self.countryRegion.selectedRegion = (self.region && self.region.value) ? true : false;
				self.countryRegion.selectedCountry = !self.countryRegion.selectedRegion;
				self.countryRegion.selected = (self.region && self.region.value) ? 'region' : 'country';
			}
			if(self.region && self.region.value){
				self.selectedCountries = [];
				self.community.countries = [];
			}
		}

		function showUploadAvatarPopup() {
			if (self.uploadEventCoverOptions && self.uploadEventCoverOptions.canEdit) {
				var popup = uploadCoverPopupSvc.showPopup(self.uploadEventCoverOptions);

				popup.result.then(function (instance) {
					self.communityCover.url = instance.thumbnail;
					self.community.thumbnail = instance.thumbnail;
					systemUtils.digest($scope);
					self.dropzoneInstance = instance.dropzone;
					onChangeModel('coverimage');
				})
			}
		}

		function onCountriesSelected(countriesSelected) {
			if (!self.selectedCountries || !self.selectedCountries.length) {
				delete self.community.countries;
				self.selectedCountries = [];
			} else {
				self.community.countries = _.pluck(self.selectedCountries, 'id');
			}
			
			onChangeModel('countries');
			self.region = {};
			clearSelectedRegion('radioGroupregion');
		}

		function clearSelectedRegion(data){
			setTimeout(function () {
				$scope.$emit(data, {});
			}, 0);
		}

		function onArrageChanged(data){
			self.selectedCountries = [];
			self.community.countries = [];
			self.region = data;
			self.community.countries = ((self.region && self.region.region) ? countryUtils.getCountryIdsFromRegion(self.region.region): []);
			onChangeModel('countries');
		}
	}
})();

(function(){
    'use strict';
    angular
        .module("pixerf")
        .component("createCommunityForm", {
            bindings: {
                community: "=",
                mode: "<",
                options: "=",
                form: '=',
                onInit: "&?",
                dropzoneInstance: "=",
                uploading: "=",
                highlight: "=",
                onChange: "&?"
            },
            templateUrl: 'app/components/create-community-form/create-community-form.html',
            controller: "createCommunityFormCtrl",
            controllerAs: "vm",

        })
})();
(function(){
    'use strict';
    angular
      .module('pixerf')
      .factory('createCommunityAlbumPopupSvc', createCommunityAlbumPopupSvc);
      createCommunityAlbumPopupSvc.$inject = ['$uibModal'];
  
      function createCommunityAlbumPopupSvc($uibModal){
  
          function showPopup(data){
              return $uibModal.open({
                  templateUrl: 'app/components/create-community-album-popup/create-community-album-popup.html',
                  controller: 'createCommunityAlbumPopupCtrl',
                  controllerAs: 'vm',
                  animation: true,
                  windowClass: 'create-community-album-screen',
                  resolve: {
                      'resolveData': function(){
                          return data;
                      }
                  }
              });
  
          }
  
          return {
              showPopup: showPopup
          };
      }
  })();
  
(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('createCommunityAlbumPopupCtrl', createCommunityAlbumPopupCtrl);

	createCommunityAlbumPopupCtrl.$inject = ['$scope', 'resolveData', '$uibModalInstance', 'pixerfApiCommunitySvc', '$state', 'toastr'];

	function createCommunityAlbumPopupCtrl($scope, resolveData, $uibModalInstance, pixerfApiCommunitySvc, $state, toastr) {

		var self = this;
		self.close = close;
		self.onCreateCommunityAlbum = onCreateCommunityAlbum;
		self.albumId = resolveData.albumId;
		self.communityId = resolveData.communityId;

		init();

		function init() {
			if (resolveData && resolveData.albumId) {
				getAlbumDetails(resolveData.albumId);
			}
		}

		function close(result) {
			$uibModalInstance.close(result);
		}

		function onCreateCommunityAlbum() {
			if (!self.communityId || !self.album.name) return;
			if (self.album.id && self.album.name) {
				updateCommunityAlbum(self.album);
			} else {
				pixerfApiCommunitySvc.create_album({
					community_id: self.communityId
				}, {
					name: self.album.name
				}).$promise.then(function (result) {
					toastr.success('Your album was created successfully!');
					$state.go('community-detail-page.community-detail-album-detail', {
						albumId: result.id,
						albumName: result.name.replace(/ /g, '-')
					})
					close();
				}).catch(function (err) {
					console.log(err);
				})
			}
		}

		function getAlbumDetails(albumId) {
			pixerfApiCommunitySvc.show_community_album({
				album_id: albumId
			}).$promise.then(function (respone) {
				self.album = respone;
			}).catch(function (err) {
				console.log(err);
			})
		}

		function updateCommunityAlbum(param) {
			var savedParams = buildSaveParams(param);
			pixerfApiCommunitySvc.update_community_album({
				album_id: param.id
			}, savedParams).$promise.then(function (respone) {
				toastr.success('This album has been successfully updated!');
				self.album = respone;
				close(self.album);
			}).catch(function (err) {
				console.log(err);
			})
		}

		function buildSaveParams(param){
			return {
				name: param.name
			};
		}
	}
})();

(function () {
    'use strict';

    angular
        .module('pixerf')
        .controller('countriesDropdownCtrl', countriesDropdownCtrl);

    countriesDropdownCtrl.$inject = ['$scope', 'ISO3166'];

    function countriesDropdownCtrl($scope, ISO3166) {

		var self = this;
		self.countries = buildCountries();
        $scope.model = self;

        self.defaultOptions = {
            "container": "body", "customAll": true, "dropupAuto": false, "noneSelectedText": "All Countries", "maxOptions": 1
        }

        self.options = $scope.options ? $.extend(true, {}, self.defaultOptions, $scope.options) : self.defaultOptions;

		function buildCountries(){
            var arr = [{id: 'all', name: 'All Countries'}];
            for (var key in ISO3166.codeToCountry){
                arr.push({
                    id: key,
                    name: ISO3166.codeToCountry[key]
                })
            }
            return arr;
        }
    }
})();
(function () {
	'use strict';

	angular
	  .module('pixerf')
	  .directive('countriesDropdown', countriesDropdown);
	countriesDropdown.$inject = []
	function countriesDropdown() {

	  var directive = {
		scope: {
			onChanged: "&?",
			model: '=',
			data: '=',
			options: "=",
			name: "@?",
			dropdownClass: "@?"
		},
		restrict: 'E',
		transclude: true,
		templateUrl: 'app/components/countries-dropdown/countries-dropdown.html',
		controller: 'countriesDropdownCtrl',
		controllerAs: 'vm',
		replace: true
	  };
	  return directive;
	}

  })();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.factory('confirmWithinIconPopupSvc', confirmWithinIconPopupSvc);
	confirmWithinIconPopupSvc.$inject = ['$uibModal'];

	function confirmWithinIconPopupSvc($uibModal) {
		function showPopup(data) {
			return $uibModal.open({
				templateUrl: 'app/components/confirm-within-icon-popup/confirm-within-icon-popup.html',
				controller: 'confirmWithinIconPopupCtrl',
				controllerAs: 'vm',
				animation: true,
				windowClass: 'confirm-within-icon-popup__screen zindex ' + data.windowClass,
				resolve: {
					'data': function () {
						return data;
					}
				}
			});
		}

		return {
			showPopup: showPopup
		};
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('confirmWithinIconPopupCtrl', confirmWithinIconPopupCtrl);

	confirmWithinIconPopupCtrl.$inject = ['$uibModalInstance', 'data', '$state'];

	function confirmWithinIconPopupCtrl($uibModalInstance, data, $state) {

		var self = this;
		self.icon = data.icon;
		self.title = data.title;
		self.description = data.description;
		self.cancelBtnText = data.cancelBtnText || "No";
		self.submitBtnText = data.submitBtnText || "Yes";

		self.onSubmit = onSubmit;
		self.onCancel = onCancel;

		init();

		function init() {}

		$uibModalInstance.closed.then(function () {
			self.isWorking = false;
		})

		function onSubmit() {
			if (self.isWorking) return;
			if (data.submit) {
				self.isWorking = true;
				self.isSubmmited = true;
				data.submit().then(function (res) {
					$uibModalInstance.close();
					if (data.submitCallback) {
						data.submitCallback(res);
					}
				}).catch(function (err) {
					self.isWorking = false;
				})
			} else {
				$uibModalInstance.close();
			}
		};

		function onCancel() {
            if(data.backToState) {
                $state.go(data.backToState);
            }
			$uibModalInstance.dismiss('cancel');
		};
	}
})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.factory('confirmSuccessPopupSvc', confirmSuccessPopupSvc);
		confirmSuccessPopupSvc.$inject = ['$uibModal'];

	function confirmSuccessPopupSvc($uibModal) {
		function showPopup(data) {
			return $uibModal.open({
				templateUrl: 'app/components/confirm-success-popup/confirm-success-popup.html',
				controller: 'confirmSuccessPopupCtrl',
				controllerAs: 'vm',
				animation: true,
				windowClass: 'zindex ' + data.windowClass,
				resolve: {
					'data': function () {
						return data;
					}
				}
			});
		}

		return {
			showPopup: showPopup
		};
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('confirmSuccessPopupCtrl', confirmSuccessPopupCtrl);

		confirmSuccessPopupCtrl.$inject = ['$uibModalInstance', 'data', '$translate'];

	function confirmSuccessPopupCtrl($uibModalInstance, data, $translate) {

		var self = this;
		self.data = data;

		self.onSubmit = onSubmit;
		self.onCancel = onCancel;

		init();

		function init() {
			self.hideCloseBtn = self.data.hideCloseBtn;
			self.hideSubmitBtn = self.data.hideSubmitBtn;
			self.cancelBtnText = self.data.cancelBtnText ? $translate.instant(self.data.cancelBtnText) : $translate.instant('no');
			self.submitBtnText = self.data.submitBtnText ? $translate.instant(self.data.submitBtnText) : $translate.instant('yes');
			self.title = self.data.title;
			self.message = self.data.message;
			self.isWarning = self.data.isWarning;
		}

		$uibModalInstance.closed.then(function () {
			self.isWorking = false;
		})

		function onSubmit() {
			if (self.isWorking) return;
			if (data.submit) {
				self.isWorking = true;
				self.isSubmmited = true;
				data.submit().then(function () {
					$uibModalInstance.close();
					if (data.submitCallback) {
						data.submitCallback();
					}
				}).catch(function (err) {
					console.log(err);
					self.isWorking = false;
				})
			} else {
				$uibModalInstance.close();
			}
		};

		function onCancel() {
			$uibModalInstance.dismiss('cancel');
		};
	}
})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.factory('confirmPopupDownloadHiresSvc', confirmPopupDownloadHiresSvc);
	confirmPopupDownloadHiresSvc.$inject = ['$uibModal'];

	function confirmPopupDownloadHiresSvc($uibModal) {
		function showPopup(data) {
			return $uibModal.open({
				templateUrl: 'app/components/confirm-popup-download-hires/confirm-popup-download-hires.html',
				controller: 'confirmPopupDownloadHiresCtrl',
				controllerAs: 'vm',
				animation: true,
				windowClass: 'zindex confirm-popup-download-hires',
				resolve: {
					'resolveData': function () {
						return data;
					}
				}
			});
		}
		return {
			showPopup: showPopup
		};
	}
})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('confirmPopupDownloadHiresCtrl', confirmPopupDownloadHiresCtrl);

    confirmPopupDownloadHiresCtrl.$inject = ['$scope', '$uibModalInstance', 'resolveData'];

    function confirmPopupDownloadHiresCtrl($scope, $uibModalInstance, resolveData) {

        var self = this;
        self.closePopup = closePopup;
        self.onDownloadClicked = onDownloadClicked;
        self.data = resolveData;

        function closePopup(){
            $uibModalInstance.close();
        }

        function onDownloadClicked(){
            closePopup();
        }
    }
})();
(function () {
	'use strict';
	angular
		.module('pixerf')
		.factory('confirmPopupSvc', confirmPopupSvc);
	confirmPopupSvc.$inject = ['$uibModal'];

	function confirmPopupSvc($uibModal) {
		function showPopup(data) {
			return $uibModal.open({
				templateUrl: 'app/components/confirm-popup/confirm-popup.html',
				controller: 'confirmPopupCtrl',
				controllerAs: 'vm',
				animation: true,
				windowClass: 'zindex ' + data.windowClass,
				resolve: {
					'data': function () {
						return data;
					}
				}
			});
		}

		return {
			showPopup: showPopup
		};
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('confirmPopupCtrl', confirmPopupCtrl);

	confirmPopupCtrl.$inject = ['$uibModalInstance', 'data', '$translate'];

	function confirmPopupCtrl($uibModalInstance, data, $translate) {

		var self = this;
		self.data = data;

		self.onSubmit = onSubmit;
		self.onCancel = onCancel;

		init();

		function init() {
			self.hideCloseBtn = self.data.hideCloseBtn;
			self.hideSubmitBtn = self.data.hideSubmitBtn;
			self.hideCancelBtn = self.data.hideCancelBtn;
			self.cancelBtnText = self.data.cancelBtnText ? $translate.instant(self.data.cancelBtnText) : $translate.instant('no');
			self.submitBtnText = self.data.submitBtnText ? $translate.instant(self.data.submitBtnText) : $translate.instant('yes');
			self.title = self.data.title;
			self.message = self.data.message;
		}

		$uibModalInstance.closed.then(function () {
			self.isWorking = false;
		})

		function onSubmit() {
			if (self.isWorking) return;
			if (data.submit) {
				self.isWorking = true;
				self.isSubmmited = true;
				data.submit().then(function () {
					$uibModalInstance.close();
					if (data.submitCallback) {
						data.submitCallback();
					}
				}).catch(function (err) {
					console.log(err);
					self.isWorking = false;
				})
			} else {
				$uibModalInstance.close();
			}
		};

		function onCancel() {
			$uibModalInstance.dismiss('cancel');
		};
	}
})();

(function () {
    'use strict';
    angular
        .module('pixerf')
        .factory('confirmInviteByLinkPopupCtrlSvc', confirmInviteByLinkPopupCtrlSvc);
        confirmInviteByLinkPopupCtrlSvc.$inject = ['$uibModal'];

    function confirmInviteByLinkPopupCtrlSvc($uibModal) {
        function showPopup(data) {
            return $uibModal.open({
                templateUrl: 'app/components/confirm-invite-by-link-popup/confirm-invite-by-link-popup.html',
                controller: 'confirmInviteByLinkPopupCtrl',
                controllerAs: 'vm',
                animation: true,
                // windowClass: 'zindex confirm-invite-by-link-popup-modal',
                windowClass: 'confirm-invite-by-link-popup-modal',
                resolve: {
                    'resolveData': function () {
                        return data;
                    }
                }
            });
        }

        var mUser = {};

        function setUser(user) {
            mUser.data = user;
        }

        return {
            showPopup: showPopup,
            user: mUser,
            setUser: setUser
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('pixerf')
        .controller('confirmInviteByLinkPopupCtrl', confirmInviteByLinkPopupCtrl);

        confirmInviteByLinkPopupCtrl.$inject = ['$scope', 'pixerfApiCommunitySvc', '$uibModalInstance', 'resolveData', '$state', 'translationSvc', 'accountConst',
        'editProfileSvc', 'toastr', '$translate', 'commonConst', 'accountUtils', 'sessionManagerSvc', 'pixerfApiEventSvc', 'communityConst', 'stringUtils', 'ISO3166', 'confirmPopupSvc'];

    function confirmInviteByLinkPopupCtrl($scope, pixerfApiCommunitySvc, $uibModalInstance, resolveData, $state, translationSvc, accountConst, editProfileSvc,
        toastr, $translate, commonConst, accountUtils, sessionManagerSvc, pixerfApiEventSvc, communityConst, stringUtils, ISO3166, confirmPopupSvc) {

        var self = this;
        self.currentState = {
            state: 1,
            actor: '',
            step: 1
        }
        self.loginnedUser = sessionManagerSvc.getCurrentLoginUser().data;
        self.isShowConfirmEvent = resolveData.event ? true : false;
        self.community = resolveData.community;
        self.spinner = {
            isVisible: false
        };
        self.commonConst = commonConst;
        var diplayName = accountUtils.buildUserDisplayName(resolveData.event.owner);
        self.StateData = {
            1: {
                1: {
                    name: 'Confirm join',
                    title: (diplayName || 'User') + ' has invited you to join his event <br>' + '"' + (resolveData.event.name || 'Event') + '"',
                    desc: "This event is organised by <a class=\"text--bold text--color-pixerf-theme\">"+ resolveData.community.name + "</a>. By joining the event, you agree to join this community.",
                }
            },
            3:{
                1:{
                    name: 'Request to Join',
                    title: "Request sent!",
                    desc: "You can view the community and event once your request is approved by the admin.",
                }
            }
            
        }
        self.currentStep = self.StateData[1][1];

        self.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        self.canNext = function(){
            return true;
        }

        self.canBack = function(){
            return true;
        }

        self.onBackBtnClicked = function(){
            self.cancel();
        }
        self.hidePopup = function(){
            $uibModalInstance.dismiss('cancel');
        }

        function showRequestSent(){
            self.currentState = {
                state: 3,
                actor: '',
                step: 1
            }
            self.currentStep = self.StateData[3][1];
        }

        self.onNextBtnClicked = function () {
            if(resolveData.is_private){//private community
                //show popup, yes > reques to join community then join event -> show request to join popup
                joinCommunity(resolveData.community, showRequestSent)

            }else{//public community
                //show popup, yes -> join community then join event
                joinCommunity(resolveData.community, joinEvent);

            }
        }

        var joinCommunity = function (community, callback) {
            if (self.loginnedUser && !self.loginnedUser.isBiz && !community.isMine && (!community.membership_status || (!community.membership_status === communityConst.MEMBERSHIP.ACCEPTED && !community.membership_status === communityConst.MEMBERSHIP.REQUESTED))) {
                pixerfApiCommunitySvc.join({
                    id: community.id
                }, null).$promise.then(function (respone) {
                    resolveData.community = respone.data;
                    toastr.success($translate.instant('requested-join-community'));
                    resolveData.isFinish = true;

                    if (callback) {
                        return callback();
                    }
                }, function (err) {
                    if(err && err.data && err.data.memberships && err.data.memberships[0] == "has already been taken"){
                        resolveData.isFinish = true;
                        if (callback) {
                            return callback();
                        }
                        return ;
                    }
                    toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
                    $state.go('buy-stock-page.trending');
                })
              }
              else if(callback) {
                resolveData.isFinish = true;
                return callback();
              }
        }

        function joinEvent() {
            if(resolveData.community.membership_status != 'accepted'){
                return showRequestSent();
            }
            if (( resolveData.event.stats &&  resolveData.event.stats.available &&  resolveData.event.stats.available > 0) ||  resolveData.event.has_joined) {
                $state.go('event-detail-page.event-feed', { id:  resolveData.event.id, name: stringUtils.toSnakeCase( resolveData.event.name) });
                self.cancel();
            } else {
                pixerfApiEventSvc.toggleJoin({
                    id:  resolveData.event.id
                }, {}).$promise.then(function (res) {
                    resolveData.event = res.data;
                    $state.go('event-detail-page.event-feed', { id:  resolveData.event.id, name: stringUtils.toSnakeCase( resolveData.event.name) });
                    self.cancel();
                }).catch(function (err) {
                    console.log(err);
                    $state.go('buy-stock-page.trending');
                    self.cancel();
                })
            }
        }

        function init() {
          
            self.currentState = {
                state: 1,
                actor: '',
                step: 1
            }
            if(resolveData.event){
                self.currentState = {
                    state: 1,
                    actor: '',
                    step: 1
                }
            }
        }

        init();
    }
})();
(function () {
  'use strict';
  angular
    .module('pixerf')
    .factory('composePostPopupSvc', composePostPopupSvc);
  composePostPopupSvc.$inject = ['$uibModalStack', '$uibModal'];

  function composePostPopupSvc($uibModalStack, $uibModal) {
    function showPopup(data) {
      return $uibModal.open({
        templateUrl: 'app/components/compose-post-popup/compose-post-popup.html',
        controller: 'composePostPopupCtrl',
        controllerAs: 'vm',
        animation: true,
        windowClass: 'zindex compose-post-screen'
      });
    }

    return {
	  showPopup: showPopup
    };
  }
})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('composePostPopupCtrl', composePostPopupCtrl);

    composePostPopupCtrl.$inject = ['$uibModalInstance'];

    function composePostPopupCtrl($uibModalInstance) {

		var self = this;
		self.closePopup = closePopup;

        self.postData = {
            avatar: "assets/images/demo-business-user/uniqlo-avatar.jpg",
            author: "Uniqlo Singapore"
        };

		function closePopup() {
			$uibModalInstance.dismiss();
		}
    }
})();
(function () {
	'use strict';
	angular
		.module('pixerf')
		.factory('completeProfilePopupSvc', completeProfilePopupSvc);
		completeProfilePopupSvc.$inject = ['$uibModal'];

	function completeProfilePopupSvc($uibModal) {
		function showPopup(data) {
			return $uibModal.open({
				templateUrl: 'app/components/complete-profile-popup/complete-profile-popup.html',
				controller: 'completeProfilePopupCtrl',
				controllerAs: 'vm',
				animation: true,
				backdrop: 'static',
				windowClass: 'complete-profile-popup-modal',
				resolve: {
					'resolveData': function () {
						return data;
					}
				}
			});
		}

		var mUser = {};

		function setUser(user) {
			mUser.data = user;
		}

		return {
			showPopup: showPopup,
			user: mUser,
			setUser: setUser
		};
	}
})();

(function () {
    'use strict';

    angular
        .module('pixerf')
        .controller('completeProfilePopupCtrl', completeProfilePopupCtrl);

    completeProfilePopupCtrl.$inject = ['$scope', 'completeProfilePopupSvc', '$uibModalInstance', 'resolveData', '$state', 'sessionManagerSvc', 'accountConst',
        'editProfileSvc', 'toastr', '$translate', 'portfolioConst', 'pixerfApiUserSvc', 'signUpBusinessInfoSvc', 'accountUtils', 'uploadPhotoSvc'];

    function completeProfilePopupCtrl($scope, completeProfilePopupSvc, $uibModalInstance, resolveData, $state, sessionManagerSvc, accountConst, editProfileSvc,
        toastr, $translate, portfolioConst, pixerfApiUserSvc, signUpBusinessInfoSvc, accountUtils, uploadPhotoSvc) {

        var self = this;
        self.currentState = {
            state: 1,
            actor: '',
            step: 1
        }
        self.maxSpecialitiesSelected = portfolioConst.LIMIT_SPECIALITIES;
        self.serviceData = {
            specialities: null
        };
        self.processing = false;
        self.buildSpecialitiesDropdown = buildSpecialitiesDropdown;
        self.onItemChanged = onItemChanged;
        self.spinner = {
			isVisible: false
        };
        self.gplacesOptions = {
			types: ['(cities)']
		}
        self.officeTypes = signUpBusinessInfoSvc.officeTypes;
        self.officeFormatter = officeFormatter;
        self.officeParser = signUpBusinessInfoSvc.officeParser;
        self.authenticationFor = '';
        self.loginnedUser = sessionManagerSvc.getCurrentLoginUser().data;
        self.processGuestUser = true;
        self.getSteps = getSteps;
        self.isBusinessType = isBusinessType;
        self.StateData = {
            1: {
                1: {
                    name: 'selectUserType',
                    title: $translate.instant("what-type-of-user-are-you") + '?',
                    desc:  $translate.instant("let-us-know-if-youre-a-creator-or-a-business"),
                    data: {
                        contributor: {
                            title: $translate.instant('creator'),
                            desc: $translate.instant("showcase-and-license-your-original-images"),
                            key: accountConst.ACCOUNT_TYPE.PERSONAL
                        },
                        business: {
                            title: $translate.instant('business'),
                            desc: $translate.instant("for-brands-agencies-and-media-experience"),
                            key: accountConst.ACCOUNT_TYPE.BUSINESS
                        }
                    }
                }
            },
            2: {
                Contributor: {
                    1: {
                        name: 'Names',
                        title: $translate.instant('complete-your-profile'),
                        desc: $translate.instant("youre-just-a-few-steps"),
                    },
                    2: {
                        name: 'Country',
                        title: $translate.instant('complete-your-profile'),
                        desc: $translate.instant("youre-just-a-few-steps"),
                    },
                    3: {
                        name: 'City',
                        title: $translate.instant('complete-your-profile'),
                        desc: $translate.instant("youre-just-a-few-steps"),
                    },
                    4: {
                        name: 'Birthday',
                        title: $translate.instant('complete-your-profile'),
                        desc: $translate.instant("youre-just-a-few-steps"),
                    },
                    5: {
                        name: 'Photography',
                        title: $translate.instant('complete-your-profile'),
                        desc: $translate.instant("youre-just-a-few-steps"),
                    }


                },
                Business: {
                    1: {
                        name: 'Fullname',
                        title: $translate.instant("verify-your-business"),
                        desc: $translate.instant("youre-just-a-few-steps"),
                    },
                    2: {
                        name: 'CompanyName',
                        title: $translate.instant("verify-your-business"),
                        desc: $translate.instant("youre-just-a-few-steps"),
                    },
                    3: {
                        name: 'OfficeType',
                        title: $translate.instant("verify-your-business"),
                        desc: $translate.instant("youre-just-a-few-steps"),
                    },
                    4: {
                        name: 'CompanyRegistrationNo',
                        title: $translate.instant("verify-your-business"),
                        desc: $translate.instant("youre-just-a-few-steps"),
                    },
                    5: {
                        name: 'Country',
                        title: $translate.instant("verify-your-business"),
                        desc: $translate.instant("youre-just-a-few-steps"),
                    },
                    6: {
                        name: 'City',
                        title: $translate.instant("verify-your-business"),
                        desc: $translate.instant("youre-just-a-few-steps"),
                    }
                },
                User: {
                    Contributor: {
                        1: {
                            name: 'Names',
                            title: $translate.instant('hi-again'),
                            desc: $translate.instant("please-take-a-few-minutes-to-update-your-profile"),
                        },
                        2: {
                            name: 'Country',
                            title: $translate.instant('hi-again'),
                            desc: $translate.instant("please-take-a-few-minutes-to-update-your-profile"),
                        },
                        3: {
                            name: 'City',
                            title: $translate.instant('hi-again'),
                            desc: $translate.instant("please-take-a-few-minutes-to-update-your-profile"),
                        },
                        4: {
                            name: 'Birthday',
                            title: $translate.instant('hi-again'),
                            desc: $translate.instant("please-take-a-few-minutes-to-update-your-profile"),
                        },
                        5: {
                            name: 'Photography',
                            title: $translate.instant('hi-again'),
                            desc: $translate.instant("please-take-a-few-minutes-to-update-your-profile"),
                        }
    
    
                    },
                    Business: {
                        4: {
                            name: 'CompanyRegistrationNo',
                            title: $translate.instant("verify-your-business"),
                            desc: $translate.instant("youre-just-a-few-steps"),
                        },
                        5: {
                            name: 'Country',
                            title: $translate.instant("verify-your-business"),
                            desc: $translate.instant("youre-just-a-few-steps"),
                        },
                        6: {
                            name: 'City',
                            title: $translate.instant("verify-your-business"),
                            desc: $translate.instant("youre-just-a-few-steps"),
                        }
                    }
                }
            },
            3: {
                Contributor: {
                    name: 'ContributorComplete',
                    title: $translate.instant("youre-all-set") + '!',
                    desc: $translate.instant("showcase-your-works-and")
                },
                Business: {
                    name: 'businessComplete',
                    title: $translate.instant("youre-on-your-way") + '!',
                    desc: $translate.instant("your-account-details-are-being")
                },
                User: {
                    Contributor: {
                        name: 'ContributorComplete',
                        title: $translate.instant("awesome-youre-all-set") + '!',
                        desc: $translate.instant("thank-you-for-your-time")
                    },
                    Business: {
                        name: 'businessComplete',
                        title: $translate.instant("awesome") + '!',
                        desc: $translate.instant("your-account-details-are-being-verified")
                    }
                }
            },
            4:{
                1:{
                    name: 'BeforeSelectUserType',
                    title:  $translate.instant("you-can-access-this-feature"),
                    desc:  $translate.instant("to-begin-please-select-user-type")
                },
                2:{
                    name: 'BeforeSelectUserTypeContributor',
                    title: $translate.instant("you-can-access-this-feature-once-you-have-a-contributor"),
                    desc:  $translate.instant("simply-complete-your-profile")
                },
                3:{
                    name: 'BeforeSelectUserTypeBusiness',
                    title: $translate.instant("you-can-access-this-feature-once-you-have-a-business"),
                    desc:  $translate.instant("simply-complete-your-profile")
                }
            }
        }

        self.isSaveingStep = function () {
            return (self.currentState.state == 2) && (self.currentState.step == Object.keys(self.StateData[2][self.currentState.actor]).length);
        }

        self.currentStep = self.StateData[1][1];

        self.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        function officeFormatter(val) {
			signUpBusinessInfoSvc.officeFormatter(self.officeTypes.data, val);
		}

        function updateCurrentStep() {
            if (self.currentState.state == 2) {
                if(!self.processGuestUser){
                    var actor = 'User';
                    self.currentStep = self.StateData[self.currentState.state][actor][self.currentState.actor][self.currentState.step];
                }else{
                    self.currentStep = self.StateData[self.currentState.state][self.currentState.actor][self.currentState.step];
                }
            } else if(self.currentState.state == 4){
                self.currentStep = self.StateData[self.currentState.state][self.currentState.step];
            } else if(self.currentState.state == 1){
                self.currentStep = self.StateData[self.currentState.state][self.currentState.step];
            } else if(self.currentState.state == 3 && !self.processGuestUser){
                var actor = 'User';
                self.currentStep = self.StateData[self.currentState.state][actor][self.currentState.actor];
            }else {
                self.currentStep = self.StateData[self.currentState.state][self.currentState.actor];
            }
        }

        self.onNextBtnClicked = function () {

            if (self.currentState.state == 4) {
                self.currentState.state = 1;
                self.currentState.actor = '';
                self.currentState.step = 1;
                if(self.authenticationFor){
                    self.currentState.actor = (self.authenticationFor == accountConst.ACCOUNT_TYPE.BUSINESS ? 'Business' : 'Contributor');
                    self.currentState.state = 2;
                    self.currentState.step = 1;
                }
                updateCurrentStep();
            } else if (self.currentState.state == 1) {
                self.currentState.state = 2;
                self.currentState.actor = (self.loginnedUser.account_type == accountConst.ACCOUNT_TYPE.BUSINESS) ? 'Business' : 'Contributor';
                self.currentState.step = 1;
                updateCurrentStep();
            } else if (self.currentState.state == 2) {
                if (self.currentState.step < Object.keys(self.StateData[2][self.currentState.actor]).length) {
                    self.currentState.step++;
                } else if (self.isSaveingStep()) {
                    saveUserInfo();
                    self.processing = true;
                }
                setDefaultOfficeType();
            }
        }
        self.onBackBtnClicked = function () {
            if ((self.currentState.state == 1) || (self.currentState.state == 3)) {
                return;
            }
            if (self.currentState.step > 1) self.currentState.step--;
        }

        self.onUserTypeClicked = function (userType) {
            self.StateData[1][1].data.contributor.selected = false;
            self.StateData[1][1].data.business.selected = false;
            self.loginnedUser.account_type = userType.key;
            userType.selected = true;
        }

        self.canNext = function (profileForm, profileFormBiz) {
            if (self.currentState.state == 1) {
                return self.StateData[1][1].data.contributor.selected || self.StateData[1][1].data.business.selected;
            } else if(self.currentState.state == 2) {
                return (((self.currentState.actor == 'Contributor') && profileForm && profileForm.$valid) || ((self.currentState.actor == 'Business') && profileFormBiz && profileFormBiz.$valid)) && (self.currentState.step <= Object.keys(self.StateData[2][self.currentState.actor]).length);
            } else if(self.currentState.state == 4){
                return true;
            }
            else if(self.processing || self.currentState.state == 3){
                return false;
            }
        }
        self.canBack = function (profileForm, profileFormBiz) {
            if ((self.currentState.state == 1) || (self.currentState.state == 3) || (self.currentState.state == 4)) {
                return false;
            }
            else if (self.processing){
                return false;
            }
            return self.currentState.step > 1;
        }

        self.validateDOB = function (profileForm) {
            var errMsg = '';
            var userAge = moment(self.loginnedUser.date_of_birth);
            var now = moment(moment()._d);
            var age = now.diff(userAge, 'years', true);
            if (self.loginnedUser && moment(self.loginnedUser.date_of_birth).diff(moment(sessionManagerSvc.getCurrentLoginUser().data.date_of_birth)) === 0) {
                profileForm.birthday.$setValidity("validateAge", true);
                return;
            }
            if (!self.loginnedUser.date_of_birth) {
                profileForm.birthday.$setValidity("validateAge", false)
            } else if (age < 18) {
                profileForm.birthday.$setValidity("validateAge", false)
                errMsg = "Uh oh! You have to be at least 18 to sign up as a Pixerfer. Don’t worry, time flies when you’re having fun. Keep doing what you love, and we’ll be waiting for you.";
                toastr.error(errMsg);
            } else if (age > 100) {
                profileForm.birthday.$setValidity("validateAge", false)
                errMsg = "Woah! Your birth date puts you at over 100 years old - that's either amazing or you've entered the wrong date by accident. Please check again.";
                toastr.error(errMsg);
            }
            errMsg ? '' : profileForm.birthday.$setValidity("validateAge", true);
            return errMsg;
        }

        self.onUploadYourPhotosBtnClicked = function(){
            $state.go("user-home-page.personal.home", {id: self.loginnedUser.id});
            self.cancel();
            setTimeout(function () {
                uploadPhotoSvc.showUploadModal();
            }, 500);
        }
        self.onUploadYourPorfolioBtnClicked = function(){
            $state.go("user-home-page.personal.portfolio", {id: self.loginnedUser.id});
            self.cancel();
        }

        self.hidePopup = function(){
            self.cancel();
        }

        function setDefaultOfficeType(){
            if(self.loginnedUser.organization && self.loginnedUser.organization.officeTypes){
                return;
            }
            if(!self.loginnedUser.organization){
                self.loginnedUser.organization = {
                    'office_type' : self.officeTypes.data[0].id
                }
            }else if(self.loginnedUser.organization && !self.loginnedUser.organization.office_type){
                self.loginnedUser.organization.office_type = self.officeTypes.data[0].id;
            }
        }

        function saveUserInfo() {
            self.spinner.isVisible = true;
            if(self.serviceData && !self.loginnedUser.profile){
                self.loginnedUser.profile = {};
            }
            if(self.loginnedUser.location){
                self.loginnedUser.location = accountUtils.getUserGoogleLocation(self.loginnedUser.location);
            }
            if(self.serviceData && self.loginnedUser.profile){
                
                self.loginnedUser.profile.specialities = self.serviceData.specialities;
            }
            if(self.currentState.actor == 'Contributor'){
                self.loginnedUser.is_email_verified = true;
            }
            editProfileSvc.saveData(self.loginnedUser, saveUserInfosucccess);
        }

        function saveUserInfosucccess(){
            self.spinner.isVisible = false;
            self.currentState.state = 3;
            updateCurrentStep();
        }

        function buildSpecialitiesDropdown() {
			pixerfApiUserSvc.getSpecialities().$promise.then(function (response) {
				self.specialities = response.data;
			});
        }

        function onItemChanged(result){
			if(!self.serviceData.specialities){
				self.serviceData.specialities = [];
			}
			self.serviceData.specialities = _.map(result.items, function(item) {
				return {id: item.id, description: item.description, name: item.name};
            });
        }
        
        function getSteps(){
            var result = {};
            if(self.currentState.state != 2){
                return {};
            }
            if(!self.processGuestUser){
                var actor = 'User';
                result = self.StateData[2][actor][self.currentState.actor]
            }else{
                result = self.StateData[2][self.currentState.actor]
            }
            return result
        }

        function isBusinessType(){
           return (self.loginnedUser && self.loginnedUser.account_type == accountConst.ACCOUNT_TYPE.BUSINESS);
        }

        function init() {
            self.loginnedUser = sessionManagerSvc.getCurrentLoginUser().data;
            completeProfilePopupSvc.setUser(self.loginnedUser);
            self.serviceData.specialities = self.loginnedUser.profile ? self.loginnedUser.profile.specialities : null;
            buildSpecialitiesDropdown();
            self.currentState = {
                state: 4,
                actor: '',
                step: 1
            }
            if(resolveData && resolveData.referredBy){
                self.loginnedUser.referred_by = resolveData.referredBy;
            }
            if(resolveData && resolveData.authenticationFor){
                self.loginnedUser.account_type = resolveData.authenticationFor;
                self.authenticationFor = (resolveData.authenticationFor == accountConst.ACCOUNT_TYPE.BUSINESS) ? 'business' : 'contributor';
                self.currentState.step = (resolveData.authenticationFor == accountConst.ACCOUNT_TYPE.BUSINESS) ? 3 : 2;
            }
            if(self.loginnedUser && self.loginnedUser.account_type){
                self.processGuestUser = false;
                self.currentState = {
                    state: 2,
                    actor: '',
                    step: 1
                }
                self.currentState.actor = (self.loginnedUser.account_type ==accountConst.ACCOUNT_TYPE.BUSINESS) ? 'Business' : 'Contributor';
                self.currentState.step = (self.loginnedUser.account_type ==accountConst.ACCOUNT_TYPE.BUSINESS) ? 4 : 1;
            }else{
                self.processGuestUser = true;
            }

            updateCurrentStep();
        }

        init();
    }
})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.factory('communityValidateReportPopupSvc', communityValidateReportPopupSvc);
	communityValidateReportPopupSvc.$inject = ['$uibModal'];

	function communityValidateReportPopupSvc($uibModal) {

		var mReasons = {
			data: []
		}

		var reasonList = {
			event: [
				{id: 1,	name: 'Fraudulent or unauthorised event '},
				{id: 2,	name: 'Canceled event'},
				{id: 3,	name: 'Inaccurate details'},
				{id: 4,	name: 'Harassment or Bullying'},
				{id: 5,	name: 'Hate speech'},
				{id: 6,	name: 'Inappropriate conduct'},
				{id: 7,	name: 'Illegal or harmful activities'}
			],
			community: [
				{id: 1,	name: 'Spam'},
				{id: 2,	name: 'Unauthorised Sales'},
				{id: 3,	name: 'Fake news'},
				{id: 4,	name: 'Fraud or scam'},
				{id: 5,	name: 'Hate speech'},
				{id: 6,	name: 'Harassment or bullying'},
				{id: 7,	name: 'Illegal or harmful activities'},
				{id: 8,	name: 'Explicit content (sex, violence or nudity)'},
				{id: 9,	name: 'Inappropriate conduct'},
				{id: 10, name: 'Violation of rights'},
				{id: 11, name: 'Others'}
			]
		}

		function setReasons(value) {
			mReasons.data = value;
		}

		function getReasons(context) {
			switch (context) {
				case 'event':
					setReasons(reasonList['event']);
					break;
				case 'community':
					setReasons(reasonList['community']);
					break;
				default:
					setReasons(reasonList['community']);
			}
			return mReasons;
		}

		function showPopup(popupData) {
			return $uibModal.open({
				templateUrl: 'app/components/community-validate-report-popup/community-validate-report-popup.html',
				controller: 'communityValidateReportPopupCtrl',
				controllerAs: 'vm',
				animation: true,
				windowClass: 'community-validate-report-popup__screen',
				backdrop: 'static',
				resolve: {
					'resolveData': function () {
						return popupData;
					}
				}
			});
		}

		return {
			setReasons: setReasons,
			getReasons: getReasons,
			showPopup: showPopup
		};
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('communityValidateReportPopupCtrl', communityValidateReportPopupCtrl);

	communityValidateReportPopupCtrl.$inject = ['$scope', 'pixerfApiCommunitySvc', '$uibModalInstance', 'communityValidateReportPopupSvc', 'resolveData', 'toastr', '$timeout', 'translationSvc', '$translate', 'commonConst', 'systemUtils'];

	function communityValidateReportPopupCtrl($scope, pixerfApiCommunitySvc, $uibModalInstance, communityValidateReportPopupSvc, resolveData, toastr, $timeout, translationSvc, $translate, commonConst, systemUtils) {

		var self = this;
		self.onConfirmClicked = onConfirmClicked;
		self.closePopup = closePopup;
		self.selectionSettings = communityValidateReportPopupSvc.getReasons(resolveData.target);
		var selectDefaultText = $translate.instant('please-select-reason');
		self.maxStrikes = commonConst.REPORT.NO_IF_STRIKE;
		self.strike_count = resolveData.data.community.strike_count || 0;
		self.confirmButtonText = "Confirm";
		self.defaultOptions = {
			"container": "body",
			"title": selectDefaultText,
			"customAll": false,
			"dropupAuto": false,
			"noneSelectedText": selectDefaultText,
			"maxOptions": 1
		}
		self.stateSuccess = false;
		self.selectedReason = null;
		var reportId = resolveData.data.id;

		init();

		function init() {
			transformAsType(resolveData.target);
			self.popupTitle = "Validate this report?";
			if (self.strike_count > 2) {
				self.desciption = "validate-report-description-last-time";
				self.confirmButtonText = "Confirm de-activation";
			} else {
				self.desciption = "validate-report-description";
			}
		}

		function onConfirmClicked() {
			if (!self.selectedReason) {
				toastr.error("Please select 1 reason!");
				return;
			}
			validate(self.selectedReason[0].name, resolveData.target);
		}

		function validate(reason) {
			pixerfApiCommunitySvc.validate_community_report({
				id: reportId
			}, {
				reason: reason
			}).$promise.then(function (respone) {
				self.stateSuccess = true;
				if (respone.data && respone.data.community) {
					self.strike_count = respone.data.community.strike_count;
					resolveData.data.community.strike_count = respone.data.community.strike_count;
				}
				if (respone.data.community && respone.data.community.strike_count > 2) {
					self.popupTitle = "validate-report-title-deactivated";
					self.desciption = "validate-report-description-deactivated";
				} else {
					self.popupTitle = "validate-report-title-successful";
					self.desciption = "validate-report-description-successful";
				}
				systemUtils.digest($scope);
			}).catch(function (err) {
				toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
			})
		}

		function transformAsType(type) {
			switch (type) {
				case "event":
					self.reportType = "event";
					self.owner = resolveData.data.event.name;
					self.subName = resolveData.data.community.name;
					self.avatar = resolveData.data.event.cover.thumbnail;
					break;
				case "community":
					self.reportType = "community";
					self.owner = resolveData.data.community.name;
					self.avatar = resolveData.data.community.cover.thumbnail;
					break;
			}
		}

		function closePopup() {
			if (self.stateSuccess) {
				$uibModalInstance.close(resolveData.data);
			} else {
				$uibModalInstance.close();
			}
		}

	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('communityTileListDetailsCtrl', communityTileListDetailsCtrl);

	communityTileListDetailsCtrl.$inject = ['$scope', 'commonConst', 'communityConst', '$state', 'translationSvc', 'toastr', 'pixerfApiCommunitySvc', '$translate', 'pixerfConfirmPopupSvc'];

	function communityTileListDetailsCtrl($scope, commonConst, communityConst, $state, translationSvc, toastr, pixerfApiCommunitySvc, $translate, pixerfConfirmPopupSvc) {

		var self = this;
		self.commonConst = commonConst;
		self.context = $scope.context;
		self.community = $scope.community;
		self.onControlClicked = onControlClicked;
		self.communityConst = communityConst;
		self.communityLogo = self.community.cover && self.community.cover.thumbnail ? self.community.cover.thumbnail : '/assets/images/default/community-default-avatar.png';

		init();

		function init() {
			genTemplateAsContext(self.context);
		}

		function onControlClicked() {
			switch (self.context) {
				case communityConst.CONTEXT.MANAGE:
					onManageCommunity();
					break;
				case communityConst.CONTEXT.JOINED:
					onLeaveCommunity();
					break;
				case communityConst.CONTEXT.REQUESTED:
					onWithdrawRequest();
					break;
				default:
					self.controlBtnLabel = 'manage-community';
					self.label = "Owner";
			}
		}

		function onManageCommunity() {
			$state.go(commonConst.STATE.MANAGE_COMMUNITIES_BRIEF, {
				id: self.community.id,
				name: self.community.name,
				manage: true,
				status: 'members'
			});
		}

		function onLeaveCommunity() {
			var confirmMessage = translationSvc.ARE_YOU_SURE_TO_DO_SOMETHING("LEAVE_THE_COMMUNITY", {
				community: self.community.name
			});
			var modal = pixerfConfirmPopupSvc.showPopup({
				hideTitle: true,
				hideConfirmText: true,
				message: confirmMessage
			});

			modal.result.then(function () {
				pixerfApiCommunitySvc.withdraw_request({
					community_ids: [self.community.id]
				}).$promise.then(function (respone) {
					$scope.onCommunityMembershipChanged({
						communityId: self.community.id
					});
					toastr.success($translate.instant('no-longer-receive-notifications-from-community', {
						community: self.community.name
					}));
				}).catch(function (err) {
					console.log(err);
					toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
				});
			});
		}

		function onWithdrawRequest() {
			var confirmMessage = translationSvc.ARE_YOU_SURE_TO_DO_SOMETHING("WITHDRAW_REQUEST_JOIN_THE_COMMUNITY", {
				community: self.community.name
			});
			var modal = pixerfConfirmPopupSvc.showPopup({
				hideTitle: true,
				hideConfirmText: true,
				message: confirmMessage
			});

			modal.result.then(function () {
				pixerfApiCommunitySvc.withdraw_request({
					community_ids: [self.community.id]
				}).$promise.then(function (respone) {
					$scope.onCommunityMembershipChanged({
						communityId: self.community.id
					});
					toastr.success($translate.instant('you-have-withdrawn-successfully'));
				}).catch(function (err) {
					console.log(err);
					toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
				})
			})
		}

		function genTemplateAsContext(context) {
			switch (context) {
				case communityConst.CONTEXT.MANAGE:
					self.controlBtnLabel = 'manage-community';
					self.label = "Owner";
					break;
				case communityConst.CONTEXT.JOINED:
					self.controlBtnLabel = 'leave-community';
					break;
				case communityConst.CONTEXT.REQUESTED:
					self.controlBtnLabel = 'withdraw-request';
					break;
				default:
					self.controlBtnLabel = 'manage-community';
					self.label = "Owner";
			}
		}

	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('communityTileListDetails', communityTileListDetails);
	communityTileListDetails.$inject = []

	function communityTileListDetails() {

		var directive = {
			scope: {
				community: "=",
				context: "@?",
				onEdited: "&?",
				onCommunityMembershipChanged: "&?"
			},
			restrict: 'E',
			transclude: true,
			templateUrl: 'app/components/community-tile-list-details/community-tile-list-details.html',
			controller: 'communityTileListDetailsCtrl',
			controllerAs: 'vm',
			replace: true
		};
		return directive;
	}

})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('communityTileCtrl', communityTileCtrl);

	communityTileCtrl.$inject = ['$scope', 'communityConst', 'commonConst', '$state', 'pixerfApiCommunitySvc', 'toastr', '$translate', 'translationSvc', 'confirmPopupSvc', '$q', 'sessionManagerSvc'];

	function communityTileCtrl($scope, communityConst, commonConst, $state, pixerfApiCommunitySvc, toastr, $translate, translationSvc, confirmPopupSvc, $q, sessionManagerSvc) {

		var self = this;
		self.loginedUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.communityConst = communityConst;
		self.commonConst = commonConst;
		self.communityLogo = $scope.community.cover && $scope.community.cover.medium ? $scope.community.cover.medium : ($scope.community.cover && $scope.community.cover.original ? $scope.community.cover.original : '/assets/images/default/community-default-avatar.png');
		self.onRedirectToCommunity = onRedirectToCommunity;

		function onRedirectToCommunity(community) {
			switch (community.type) {
				case 'CommunityEvent':
					$state.go(self.commonConst.STATE.EVENT_FEED, {
						id: community.id,
						name: community.name
					});
					break;
				default:
					if (community.is_private && community.membership_status != 'requested' && community.membership_status != 'owner' && self.loginedUser.account_type === 'personal') {
						confirmPopupSvc.showPopup({
							windowClass: 'request-to-join-private-community-popup',
							message: 'This is a private community. You can request to join to view it.',
							submitBtnText: 'Request to Join',
							cancelBtnText: 'Cancel',
							submit: function () {
								var def = $q.defer();
								pixerfApiCommunitySvc.join({
									id: community.id
								}, null).$promise.then(function (respone) {
									toastr.success($translate.instant('requested-join-community'));
									def.resolve(respone)
								}, function (err) {
									toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
									def.reject(err)
								})
								return def.promise;
							},
							submitCallback: function () {
								$state.go(self.commonConst.STATE.COMMUNITIES_DETAILS_DISCUSSIONS, {
									id: community.id,
									name: community.name
								});
							}
						});
					} else {
						$state.go(self.commonConst.STATE.COMMUNITIES_DETAILS_DISCUSSIONS, {
							id: community.id,
							name: community.name
						});
					}
					break;
			}
		}
	}
})();

(function () {
  'use strict';

  angular
    .module('pixerf')
    .directive('communityTile', communityTile);
  communityTile.$inject = ['$location']
  function communityTile($location) {

    var directive = {
      scope: {
          community: "=",
          onEdited: "&?",
          onCommunityMembershipChanged: "&?"
      },
      restrict: 'E',
      transclude: true,
      templateUrl: 'app/components/community-tile/community-tile.html',
      controller: 'communityTileCtrl',
      controllerAs: 'vm',
      replace: true
    };
    return directive;
  }

})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('communityTagCtrl', communityTagCtrl);

	communityTagCtrl.$inject = ['$scope', 'inviteCommunityMembersPopupSvc', 'createCommunityPopupSvc', 'commonConst', 'sessionManagerSvc'];

	function communityTagCtrl($scope, inviteCommunityMembersPopupSvc, createCommunityPopupSvc, commonConst, sessionManagerSvc) {

		var self = this;
		self.commonConst = commonConst;
		self.routeOnNavigate = self.commonConst.STATE.COMMUNITIES_DETAILS_DISCUSSIONS + '({id: ' + $scope.community.id + '})';
		self.onInviteBtnClicked = onInviteBtnClicked;
		self.onEditBtnClicked = onEditBtnClicked;
		self.memberAccepted = memberAccepted;
		self.loginUser = sessionManagerSvc.getCurrentLoginUser().data;

		self.joinBtnOptions = {
			joinedText: "Leave",
			notJoinedText: "Ask to Join",
			pendingApprovalText: "Request sent"
		}

		function onEditBtnClicked() {
			var editedCommunity = $.extend(true, {}, $scope.community);
			var popup = createCommunityPopupSvc.showPopup({
				mode: commonConst.ACTION.EDIT,
				route: 'no-navigate',
				community: editedCommunity
			});
			popup.result.then(function () {
				$scope.community.name = editedCommunity.name;
				$scope.community.description = editedCommunity.description;
				$scope.community.is_private = editedCommunity.is_private;
				$scope.community.is_unlisted = editedCommunity.is_unlisted;
			})
		}

		function invitationSentHandler() {}

		function onInviteBtnClicked() {
			var popup = inviteCommunityMembersPopupSvc.showPopup({
				defaultSearchCondition: {
					isDirectoryChecked: false,
					isEmailChecked: true,
					country: "",
					speciality: ""
				},
				community: $scope.community,
			});
			popup.result.then(function () {
				invitationSentHandler()
			})
		}

		function memberAccepted(member) {
			return member.status === 'accepted';
		}
	}
})();

(function () {
	'use strict';

	angular
	  .module('pixerf')
	  .directive('communityTag', communityTag);

	function communityTag() {

	  var directive = {
		scope: {
			community: "="
		},
		templateUrl: 'app/components/community-tag/community-tag.html',
		restrict: 'E',
		controller: 'communityTagCtrl',
      	controllerAs: 'vm',
		replace: true
	  };
	  return directive;
	}

  })();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.factory('communityResolveReportPopupSvc', communityResolveReportPopupSvc);
	communityResolveReportPopupSvc.$inject = ['$uibModal'];

	function communityResolveReportPopupSvc($uibModal) {

		function showPopup(popupData) {
			return $uibModal.open({
				templateUrl: 'app/components/community-resolve-report-popup/community-resolve-report-popup.html',
				controller: 'communityResolveReportPopupCtrl',
				controllerAs: 'vm',
				animation: true,
				windowClass: 'community-resolve-report-popup__screen',
				backdrop: 'static',
				resolve: {
					'resolveData': function () {
						return popupData;
					}
				}
			});
		}

		return {
			showPopup: showPopup
		};
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('communityResolveReportPopupCtrl', communityResolveReportPopupCtrl);

	communityResolveReportPopupCtrl.$inject = ['$uibModalInstance', 'resolveData', 'pixerfApiCommunitySvc'];

	function communityResolveReportPopupCtrl($uibModalInstance, resolveData, pixerfApiCommunitySvc) {

		var self = this;
		self.onConfirmClicked = onConfirmClicked;
		self.closePopup = closePopup;
		var dataMessage = {
			single: {
				popupTitle:"Resolve this report?",
				popupDescription: "resolve-report-description",
				successTile: "This report has been resolved.",
				successDescription: "resolve-report-description-successful"
			},
			many: {
				popupTitle:"Resolve these reports?",
				popupDescription: "resolve-report-description",
				successTile: "These reports have been resolved.",
				successDescription: "resolve-report-description-successful"
			}
		}
		var resolveType = 'single';

		init();

		function init() {
			resolveType = (resolveData.target == 'many') ? 'many' : 'single';
			transformAsType(resolveData.target);
			self.popupTitle = resolveData.popupTitle ? resolveData.popupTitle : dataMessage[resolveType].popupTitle;
			self.desciption = resolveData.popupDescription ? resolveData.popupDescription : dataMessage[resolveType].popupDescription;
		}

		function onConfirmClicked() {
			(resolveType == 'single') ? resolveSingle() : resolveMany();
		}
		function resolveSingle(){
			pixerfApiCommunitySvc.resolve_community_report({
				id: resolveData.data.id
			}, null).$promise.then(function (respone) {
				self.stateSuccess = true;
				self.popupTitle = dataMessage[resolveType].successTile;
				self.desciption = resolveData.successDescription ? resolveData.successDescription : dataMessage[resolveType].successDescription;
			}).catch(function (error) {
				console.log(error);
			})
		}

		function resolveMany(){
			pixerfApiCommunitySvc.resolve_many_community_reports(null, {report_ids : resolveData.data}).$promise.then(function (respone) {
				self.stateSuccess = true;
				self.popupTitle = dataMessage[resolveType].successTile;
				self.desciption = dataMessage[resolveType].successDescription;
				self.desciption = resolveData.successDescription ? resolveData.successDescription : dataMessage[resolveType].successDescription;
			}).catch(function (error) {
				console.log(error);
			})
		}

		function transformAsType(type) {
			switch (type) {
				case "event":
					self.reportType = "event";
					break;
				case "community":
					self.reportType = "community";
					break;
				case "discussion":
					self.reportType = "post";
					break;
				case "discussion_reply":
					self.reportType = "comment";
					break;
			}
		}

		function closePopup() {
			if (self.stateSuccess) {
				$uibModalInstance.close(resolveData.data);
			} else {
				$uibModalInstance.close();
			}
		}

	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('communityReportListViewCtrl', communityReportListViewCtrl);

	communityReportListViewCtrl.$inject = ['$scope', 'sessionManagerSvc', '$window', 'commonConst', 'communityResolveReportPopupSvc', 'communityValidateReportPopupSvc', 'communityRemoveReportPopupSvc'];

	function communityReportListViewCtrl($scope, sessionManagerSvc, $window, commonConst, communityResolveReportPopupSvc, communityValidateReportPopupSvc, communityRemoveReportPopupSvc) {

		var USER_CONTROL_ADMINDASHBOARD = ['curator_internal', 'admin_internal', 'marketer_internal'];
		var self = this;
		self.loginedUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.onToggleSelected = onToggleSelected;
		self.onReportClicked = onReportClicked;
		self.prevenPubbleClick = prevenPubbleClick;
		self.onValidate = onValidate;
		self.onResolve = onResolve;
		self.onRemove = onRemove;
		self.isAdmin = self.loginedUser && (USER_CONTROL_ADMINDASHBOARD.includes(self.loginedUser.role) || self.loginedUser.email === 'marcom@pixerf.com');
		self.maxStrikes = commonConst.REPORT.NO_IF_STRIKE;
		self.report = $scope.report;
		self.type = $scope.type;
		self.disabledCheckbox = disabledCheckbox;

		init();

		function init() {
			convertCreatedDate();
			convertTypeOfReport();
			convertStatus();
		}

		function onToggleSelected(report) {
			$scope.onToggleSelected({
				report: report
			});
		}

		function disabledCheckbox(){
			var result = false;
			if((self.report.community.previous_deactivation_count && self.report.community.previous_deactivation_count >= 3) || (self.report.item_type == 'discussion') || (self.report.item_type == 'discussion_reply')){
				result = true;
			}
			return result;
		}

		function convertCreatedDate() {
			self.fomatedDate = moment(self.report.inserted_at).format("MMM DD, YYYY");
		}

		function convertTypeOfReport() {
			var isShowResoleButton = true;
			if(self.report.community && self.report.community.previous_deactivation_count && self.report.community.previous_deactivation_count >= 3){
				isShowResoleButton = false;
			};
			var resolveReportControl = {
				label: 'Resolve',
				cta: self.onResolve
			};
			switch (self.report.item_type) {
				case "event":
					self.isShowStrikeList = true;
					self.typeOfReport = "Event";
					self.report.typeOfReport = "Event";
					self.moreList = [{
							label: 'Validate event',
							cta: self.onValidate
						}
					];

					if(isShowResoleButton){
						self.moreList.push(resolveReportControl);
					}

					break;
				case "discussion":
					self.typeOfReport = "Post";
					self.report.typeOfReport = "Post";
					if (self.isAdmin) {
						self.isHideMoreControl = true;
					} else {
						self.moreList = [{
								label: 'Remove post',
								cta: self.onRemove
							}
						];

						if(isShowResoleButton){
							self.moreList.push(resolveReportControl);
						}
					}
					break;
				case "discussion_reply":
					self.typeOfReport = "Comment";
					self.report.typeOfReport = "Comment";
					if (self.isAdmin) {
						self.isHideMoreControl = true;
					} else {
						self.moreList = [{
								label: 'Remove comment',
								cta: self.onRemove
							}
						];

						if(isShowResoleButton){
							self.moreList.push(resolveReportControl);
						}
					}
					break;
				case "community":
					self.isShowStrikeList = true;
					self.typeOfReport = "Community";
					self.report.typeOfReport = "Community";
					self.moreList = [{
							label: 'Validate community',
							cta: self.onValidate
						}
					];

					if(isShowResoleButton){
						self.moreList.push(resolveReportControl);
					}
					break;
			}
		}

		function convertStatus() {
			switch (self.report.status) {
				case "open":
					self.status = "In Review";
					break;
				case "validated":
					self.status = "Validated";
					break;
				case "resolved":
					self.status = "Resolved";
					break;
				default:
					self.status = self.report.status;
			}
		}

		function prevenPubbleClick() {
			$window.event.stopPropagation();
		}

		function onReportClicked(report) {
			self.isActived = true;
			$scope.onReportClicked({
				report: report
			});
		}

		function onResolve() {
			prevenPubbleClick();
			var resolveReport = communityResolveReportPopupSvc.showPopup({
				data: self.report,
				target: self.report.item_type
			})

			resolveReport.result.then(function (data) {
				if ($scope.onStatusChanged) {
					$scope.onStatusChanged({
						data: [data]
					});
				}
			})
		}

		function onRemove() {
			prevenPubbleClick();
			var removeReport = communityRemoveReportPopupSvc.showPopup({
				data: self.report,
				target: self.report.item_type
			})

			removeReport.result.then(function (data) {
				if ($scope.onStatusChanged) {
					$scope.onStatusChanged({
						data: [data]
					});
				}
			})
		}

		function onValidate() {
			prevenPubbleClick();
			var validateReport = communityValidateReportPopupSvc.showPopup({
				data: self.report,
				target: self.report.item_type
			})

			validateReport.result.then(function (data) {
				if (data && data.community && data.community.strike_count) {
					self.report.community.strike_count = data.community.strike_count;
				}
				if ($scope.onStatusChanged) {
					$scope.onStatusChanged({
						data: [data]
					});
				}
			})
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('communityReportListView', communityReportListView);
	communityReportListView.$inject = []

	function communityReportListView() {

		var directive = {
			scope: {
				report: "=",
				onToggleSelected: "&?",
				onReportClicked: "&?",
				onStatusChanged: "&?",
				type: "@"
			},
			restrict: 'E',
			templateUrl: 'app/components/community-report-list-view/community-report-list-view.html',
			controller: 'communityReportListViewCtrl',
			controllerAs: 'vm',
			replace: true
		};
		return directive;
	}
})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.factory('communityRemoveReportPopupSvc', communityRemoveReportPopupSvc);
	communityRemoveReportPopupSvc.$inject = ['$uibModal'];

	function communityRemoveReportPopupSvc($uibModal) {

		var mReasons = {
			data: []
		}

		var reasonList = {
			discussion: [
				{id: 1,	name: 'Spam'},
				{id: 2,	name: 'Unauthorised sales'},
				{id: 3,	name: 'Intellectual property'},
				{id: 4,	name: 'Fake news'},
				{id: 5,	name: 'Hacked'},
				{id: 6,	name: 'Hate speech'},
				{id: 7,	name: 'Harassment or threat'},
				{id: 8,	name: 'Inappropriate conduct'},
				{id: 9,	name: 'Violation of rights'},
				{id: 10, name: 'Adult content'},
				{id: 11, name: 'Violence or abuse'},
				{id: 12, name: 'Suicide or self-injury'},
				{id: 13, name: 'Invasion of privacy'},
				{id: 14, name: 'Scam or fraud'},
				{id: 15, name: "Others"}
			],
			discussion_reply: [
				{id: 1,	name: 'Spam'},
				{id: 2,	name: 'Unauthorised sales'},
				{id: 3,	name: 'Intellectual property'},
				{id: 4,	name: 'Fake news'},
				{id: 5,	name: 'Hacked'},
				{id: 6,	name: 'Hate speech'},
				{id: 7,	name: 'Harassment or threat'},
				{id: 8,	name: 'Inappropriate conduct'},
				{id: 9,	name: 'Violation of rights'},
				{id: 10, name: 'Adult content'},
				{id: 11, name: 'Violence or abuse'},
				{id: 12, name: 'Suicide or self-injury'},
				{id: 13, name: 'Invasion of privacy'},
				{id: 14, name: 'Scam or fraud'},
				{id: 15, name: "Others"}
			]
		}

		function setReasons(value) {
			mReasons.data = value;
		}

		function getReasons(context) {
			switch (context) {
				case 'discussion_reply':
					setReasons(reasonList['discussion_reply']);
					break;
				case 'discussion':
					setReasons(reasonList['discussion']);
					break;
				default:
					setReasons(reasonList['discussion']);
			}
			return mReasons;
		}

		function showPopup(popupData) {
			return $uibModal.open({
				templateUrl: 'app/components/community-remove-report-popup/community-remove-report-popup.html',
				controller: 'communityRemoveReportPopupCtrl',
				controllerAs: 'vm',
				animation: true,
				windowClass: 'community-remove-report-popup__screen',
				backdrop: 'static',
				resolve: {
					'resolveData': function () {
						return popupData;
					}
				}
			});
		}

		return {
			setReasons: setReasons,
			getReasons: getReasons,
			showPopup: showPopup
		};
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('communityRemoveReportPopupCtrl', communityRemoveReportPopupCtrl);

	communityRemoveReportPopupCtrl.$inject = ['pixerfApiCommunitySvc', '$uibModalInstance', 'communityValidateReportPopupSvc', 'resolveData', 'toastr', '$timeout', 'translationSvc', '$translate', 'commonConst'];

	function communityRemoveReportPopupCtrl(pixerfApiCommunitySvc, $uibModalInstance, communityValidateReportPopupSvc, resolveData, toastr, $timeout, translationSvc, $translate, commonConst) {

		var self = this;
		self.onConfirmClicked = onConfirmClicked;
		self.closePopup = closePopup;
		self.selectionSettings = communityValidateReportPopupSvc.getReasons(resolveData.target);
		var selectDefaultText = $translate.instant('please-select-reason');
		self.maxStrikes = commonConst.REPORT.NO_IF_STRIKE;
		self.strike_count = resolveData.data.strike_count;
		self.defaultOptions = {
			"container": "body",
			"title": selectDefaultText,
			"customAll": false,
			"dropupAuto": false,
			"noneSelectedText": selectDefaultText,
			"maxOptions": 1
		}
		self.stateSuccess = false;
		self.selectedReason = null;
		var reportId = resolveData.data.id;

		init();

		function init() {
			transformAsType(resolveData.target);
			self.desciption = resolveData.popupDescription ? resolveData.popupDescription : $translate.instant("the-thing-has-been-taken-down-description", {type: self.reportType});
		}

		function onConfirmClicked() {
			if (!self.selectedReason) {
				toastr.error("Please select 1 reason!");
				return;
			}
			removeReport(self.selectedReason[0].name, resolveData.target);
		}

		function removeReport(reason) {
			pixerfApiCommunitySvc.validate_community_report({
				id: reportId
			}, {
				reason: reason
			}).$promise.then(function (respone) {
				if (self.reportType === 'post') {
					return pixerfApiCommunitySvc.remove_disscussion({
						id: resolveData.data.item_id
					}).$promise;
				} else {
					return pixerfApiCommunitySvc.remove_reply({
						id: resolveData.data.item_id
					}).$promise;
				}
			}).then(function () {
				self.stateSuccess = true;
				self.popupTitle = "the-thing-has-been-taken-down";
				self.desciption =  resolveData.successDescription ?  resolveData.successDescription : $translate.instant('the-thing-has-been-taken-down-description-succesful', {type: self.reportType});
			}).catch(function (err) {
				toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
			})
		}

		function transformAsType(type) {
			switch (type) {
				case "discussion":
					self.reportType = "post";
					self.popupTitle = "Remove post?";
					break;
				case "discussion_reply":
					self.reportType = "comment";
					self.popupTitle = "Remove comment?";
					break;
			}
		}

		function closePopup() {
			if (self.stateSuccess) {
				$uibModalInstance.close(resolveData.data);
			} else {
				$uibModalInstance.close();
			}
		}

	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('communityPendingInvitationsListCtrl', communityPendingInvitationsListCtrl);

	communityPendingInvitationsListCtrl.$inject = ['pixerfApiCommunitySvc', 'pagingUtils', '$translate', '$scope'];

	function communityPendingInvitationsListCtrl(pixerfApiCommunitySvc, pagingUtils, $translate, $scope) {

		var self = this;
        
        self.fetch = fetch;
        self.fetchMore = fetchMore;
        self.peoples = null;
        self.searchParams = null;
        self.isLastPage = false;
        self.spinner = {
            isVisible: false
		};
		
		init();

		function init(){
			self.searchParams = {
                status: "invited",
                id: $scope.community.id
            }
            if($scope.onInit) $scope.onInit({instance: self});
			fetch(self.searchParams);
		}
        function getter(params){
			return pixerfApiCommunitySvc.get_members(params).$promise;
        }
        function fetch(params, isFresh){
            if(!self.searchParams || isFresh) self.searchParams = params;
            self.spinner.isVisible = true;
            getter(params).then(function(response){
                if(!self.peoples || isFresh) self.peoples = [];

                self.peoples = self.peoples.concat(response.data);
                self.isLastPage = pagingUtils.isNoMorePageToLoad(params.page, response);
                self.spinner.isVisible = false;
                self.searchParams.page = params.page;
            }, function(){
                toastr.error($translate.instant('failed-to-get-peoples-list'));
                self.spinner.isVisible = false;
            });
        }
        function fetchMore(){
            if(self.spinner.isVisible){
                return;
            }
            var searchParms = $.extend(true, {}, self.searchParams);
            searchParms.page++;
            fetch(searchParms);           
        }

	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('communityPendingInvitationsList', communityPendingInvitationsList);

	communityPendingInvitationsList.$inject = [];
	function communityPendingInvitationsList() {

		var directive = {
			scope: {
				community: "=",
				onInit: "&?"
			},
			restrict: 'E',
			templateUrl: 'app/components/community-pending-invitations-list/community-pending-invitations-list.html',
			controller: 'communityPendingInvitationsListCtrl',
			controllerAs: 'vm',
			replace: true,
			transclude: true
		};
		return directive;
	}

})();

(function () {

	angular
		.module('pixerf')
		.controller('communityPendingInvitationCtrl', communityPendingInvitationCtrl);

	communityPendingInvitationCtrl.$inject = [];

	function communityPendingInvitationCtrl() {

		var self = this;
		self.onIgnoreBtnClicked = onIgnoreBtnClicked;
		self.onAcceptBtnClicked = onAcceptBtnClicked;

		function onAcceptBtnClicked(){

		}
		function onIgnoreBtnClicked(){
			
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('communityPendingInvitation', communityPendingInvitation);

	communityPendingInvitation.$inject = [];
	function communityPendingInvitation() {

		var directive = {
			scope: {
				userData: "="
			},
			restrict: 'E',
			templateUrl: 'app/components/community-pending-invitation/community-pending-invitation.html',
			controller: 'communityPendingInvitationCtrl',
			controllerAs: 'vm',
			replace: true
		};
		return directive;
	}

})();

(function () {
    'use strict';

    angular
        .module('pixerf')
        .directive('communityMembersLabel', communityMembersLabel);

    function communityMembersLabel() {

        var directive = {
            scope: {
                community: "="
            },
            restrict: 'E',
            templateUrl: 'app/components/community-members-label/community-members-label.html',
            replace: true
        };
        return directive;
    }

})();

(function () {

	angular
		.module('pixerf')
		.controller('communityMemberListCtrl', communityMemberListCtrl);

	communityMemberListCtrl.$inject = ['pixerfApiCommunitySvc', 'pagingUtils', 'toastr', '$scope', 'contextConst', 'communityConst', 'confirmPopupSvc', 'translationSvc', '$translate', 'systemUtils', 'pixerfApiUserSvc', '$state', 'commonConst', 'accountUtils'];

	function communityMemberListCtrl(pixerfApiCommunitySvc, pagingUtils, toastr, $scope, contextConst, communityConst, confirmPopupSvc, translationSvc, $translate, systemUtils, pixerfApiUserSvc, $state, commonConst, accountUtils) {

		var self = this;

		self.fetch = fetch;
		self.fetchMore = fetchMore;
		self.onSelectAllToogle = onSelectAllToogle;
		self.onActionClicked = onActionClicked;
		self.onMembersChanged = onMembersChanged;
		self.onMembersSelectedChanged = onMembersSelectedChanged;
		self.onUserDataClicked = onUserDataClicked;
		self.onViewProfileClicked = onViewProfileClicked;
		self.onSearchStringChanged = _.debounce(onSearchStringChanged, 300);
		self.peoples = null;
		self.searchParams = null;
		self.isLastPage = false;
		self.isSelectAll = false;
		self.numberMembersSelected = 0;
		self.CONSTANT = {
			ACCEPT: communityConst.ACTION.ACCEPT,
			REJECT: communityConst.ACTION.REJECT,
			REMOVE: communityConst.ACTION.REMOVE,
			UNINVITE: communityConst.ACTION.UNINVITE,
			UNBLOCK: communityConst.ACTION.UNBLOCK
		}
		self.isContextPending = $scope.context === contextConst.COMMUNITY_PENDING_MEMBER;
		self.isContextBlockedMember = $scope.context === contextConst.COMMUNITY_BLOCKED_MEMBER;
		self.isContextMember = $scope.context === contextConst.COMMUNITY_MEMBER;
		self.isContextInvitedMember = $scope.context === contextConst.COMMUNITY_INVITED_MEMBER;
		self.spinner = {
			isVisible: false
		};
		self.actiedInfoId = -1;
		self.selectedUser = {};
		self.isWorking = false;

		init();

		function init() {
			self.searchParams = {
				id: $scope.community.id,
				page: 1
			}
			if (self.isContextPending) {
				self.searchParams.membership = communityConst.MEMBERSHIP.REQUESTED;
			} else if (self.isContextInvitedMember) {
				self.searchParams.membership = communityConst.MEMBERSHIP.INVITED;
			} else if (self.isContextMember) {
				self.searchParams.membership = communityConst.MEMBERSHIP.ACCEPTED;
			} else if (self.isContextBlockedMember) {
				self.searchParams.membership = communityConst.MEMBERSHIP.BLOCKED;
			}
			if ($scope.onInit) {
				$scope.onInit({
					instance: self
				});
			}
			fetch(self.searchParams);
		}

		function getter(params) {
			return pixerfApiCommunitySvc.get_members(params).$promise;
		}

		function fetch(params, isFresh) {
			if (!self.searchParams || isFresh) self.searchParams.page = 1;
			self.spinner.isVisible = true;
			getter(params).then(function (response) {
				if (!self.peoples || isFresh) self.peoples = [];

				self.peoples = self.peoples.concat(response.data);
				self.isLastPage = pagingUtils.isNoMorePageToLoad(params.page, response);
				if (!params.keywords) {
					self.totalCount = pagingUtils.getTotalCount(response);
				}
				self.spinner.isVisible = false;
				self.searchParams.page = params.page;
				if (self.isLastPage && params.membership === 'invited') {
					pixerfApiCommunitySvc.invites({
						id: $scope.community.id
					}).$promise.then(function (res) {
						self.peoples = self.peoples.concat(res.data);
						self.totalCount += pagingUtils.getTotalCount(res);
					})
				}
			}, function () {
				toastr.error($translate.instant('failed-to-get-peoples-list'));
				self.spinner.isVisible = false;
			});
		}

		function fetchMore() {
			if (self.spinner.isVisible) {
				return;
			}
			var searchParms = $.extend(true, {}, self.searchParams);
			searchParms.page++;
			fetch(searchParms);
		}

		function onSelectAllToogle() {
			for (var i = 0; i < self.peoples.length; i++) {
				self.peoples[i].isSelected = self.isSelectAll;
			}
			self.isActionForMultiActived = self.isSelectAll;
			self.multiSelectText = self.isSelectAll ? "All" : '';
		}

		function onSearchStringChanged() {
			var searchParams = buildSearchParams();
			var isFresh = true;
			fetch(searchParams, isFresh);
		}

		function buildSearchParams() {
			var searchParams = {
				id: $scope.community.id,
				page: 1
			};
			if (self.searchString) searchParams.keywords = self.searchString;
			if (self.isContextMember) {
				searchParams.membership = communityConst.MEMBERSHIP.ACCEPTED;
			}
			return searchParams;
		}

		function onActionClicked(action) {
			if (typeof pixerfApiCommunitySvc[action] == 'undefined' || self.isWorking) {
				return;
			}

			if (action === self.CONSTANT.REJECT || action === self.CONSTANT.REMOVE || action === self.CONSTANT.UNINVITE || action === self.CONSTANT.UNBLOCK) {
				onConfirmAction(action);
			} else {
				onActionActived(action)
			}
		}

		function onActionActived(action) {
			var toastMessage = genAlertMessage(action);
			var peopleInAction = getListPeopleInAction();
			pixerfApiCommunitySvc[action]({
				id: $scope.community.id
			}, peopleInAction).$promise.then(function (response) {
				toastr.success(toastMessage);
				removePeopleFromList(peopleInAction, action);
				self.isWorking = false;
			}, function (err) {
				console.log(err);
				toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
				self.isWorking = false;
			});
		}

		function onConfirmAction(action) {
			var confirmMessage = genConfirmMessage(action);
			var popupConfig = {
				windowClass: 'confirm-action-popup',
				hideTitle: true,
				hideConfirmText: true,
				title: confirmMessage
			};
			if (action === self.CONSTANT.UNBLOCK || action === self.CONSTANT.UNINVITE) {
				popupConfig.cancelBtnText = 'Cancel';
			}
			var modal = confirmPopupSvc.showPopup(popupConfig);
			modal.result.then(function () {
				self.isWorking = true;
				onActionActived(action);
			});
		}

		function getListPeopleInAction() {
			var people = {
				user_ids: [],
				emails: []
			};
			for (var i = 0; i < self.peoples.length; i++) {
				if (self.peoples[i].isSelected && self.peoples[i].username) {
					people.user_ids.push(self.peoples[i].id);
				} else if (self.peoples[i].isSelected) {
					people.emails.push(self.peoples[i].email);
				}
			}
			return people;
		}

		function onMembersChanged(personId, action, context) {
			self.totalCount--;
			if (action === 'accept' && context === contextConst.COMMUNITY_INVITED_MEMBER) {
				$scope.community.member_count++;
				$scope.community.invited_count--;
			} else if (action === 'reject' && context === contextConst.COMMUNITY_PENDING_MEMBER) {
				$scope.community.requested_count--;
			} else if (action === 'accept' && context === contextConst.COMMUNITY_PENDING_MEMBER) {
				$scope.community.member_count++;
				$scope.community.requested_count--;
			} else if (action === 'unblock') {
				$scope.community.member_count++;
				$scope.community.blocked_count--;
			}
			for (var i = 0; i < self.peoples.length; i++) {
				if (self.peoples[i].id == personId) {
					removePersonFromList(self.peoples[i].id);
				}
			}
		}

		function removePeopleFromList(people, action) {
			for (var i = 0; i < people.user_ids.length; i++) {
				removePersonFromList(people.user_ids[i], action);
			}
			for (var i = 0; i < people.emails.length; i++) {
				removeExternalPersonFromList(people.emails[i], action);
			}
		}

		function removeExternalPersonFromList(email) {
			if (self.isContextInvitedMember) {
				$scope.community.invited_count--;
			}
			self.peoples.emails = _.reject(self.peoples.emails, function (people) {
				return people.emails === email;
			});
			onMembersSelectedChanged();
		}

		function removePersonFromList(personId, action) {
			self.peoples = _.reject(self.peoples, function (people) {
				return people.id === personId;
			});
			onMembersSelectedChanged();
		}

		function onMembersSelectedChanged() {
			self.numberMembersSelected = 0;
			for (var i = 0; i < self.peoples.length; i++) {
				if (self.peoples[i].isSelected) {
					self.numberMembersSelected++;
				}
			}
			self.isActionForMultiActived = self.numberMembersSelected ? true : false;
			if (self.peoples.length == self.numberMembersSelected) {
				self.multiSelectText = "All";
				self.isSelectAll = true;
			} else if (self.numberMembersSelected == 1) {
				self.multiSelectText = self.numberMembersSelected + ' Member';
				self.isSelectAll = false;
			} else if (self.numberMembersSelected > 1) {
				self.multiSelectText = self.numberMembersSelected + ' Members';
				self.isSelectAll = false;
			} else {
				self.multiSelectText = '';
				self.isSelectAll = false;
			}
		}

		function genAlertMessage(action) {
			if (action === self.CONSTANT.REJECT) {
				return "You have rejected user requests to join the Community.";
			} else if (action === self.CONSTANT.ACCEPT) {
				return "You have accepted user requests to join the Community.";
			} else if (action === self.CONSTANT.REMOVE) {
				return "You have removed users from the Community.";
			} else if (action === self.CONSTANT.UNINVITE) {
				return "You have uninvited users from the Community.";
			} else if (action === self.CONSTANT.UNBLOCK) {
				return "You have unblocked users from the Community.";
			} else {
				return "";
			}
		}

		function genConfirmMessage(action) {
			if (action === self.CONSTANT.REJECT) {
				return "Do you want to reject these users' requests to join the Community?";
			} else if (action === self.CONSTANT.REMOVE) {
				return "Do you want to remove these users from the Community?";
			} else if (action === self.CONSTANT.UNINVITE) {
				return "Are you sure you want to un-invite the selected?";
			} else if (action === self.CONSTANT.UNBLOCK) {
				return "Do you want to unblock these users from the Community?";
			} else {
				return "";
			}
		}

		function onUserDataClicked(user) {
			self.isWorking = true;
			pixerfApiUserSvc.get({
				id: user.id,
				action: 'profile'
			}).$promise.then(function (data) {
				self.isWorking = false;
				self.selectedUser = data;
				if (self.selectedUser.profile && self.selectedUser.profile.specialities) {
					self.selectedUser.profile.specialities = accountUtils.getSpecialities(self.selectedUser.profile.specialities);
				}
				self.actiedInfoId = data.id;
				systemUtils.digest($scope);
			}).catch(function (err) {
				self.isWorking = false;
				console.log(err);
			})
		}

		function onViewProfileClicked(profile) {
			$state.go(commonConst.STATE.USER_PROFILE_HOME, {
				id: profile.id
			});
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('communityMemberList', communityMemberList);

	communityMemberList.$inject = [];
	function communityMemberList() {

		var directive = {
			scope: {
				community: "=",
				onInit: "&?",
				canSearch: "&?",
				context: "@?",
				showDetail: "="
			},
			restrict: 'E',
			templateUrl: 'app/components/community-member-list/community-member-list.html',
			controller: 'communityMemberListCtrl',
			controllerAs: 'vm',
			replace: true,
			transclude: true
		};
		return directive;
	}

})();

(function () {

	angular
		.module('pixerf')
		.controller('communityMemberItemCtrl', communityMemberItemCtrl);

	communityMemberItemCtrl.$inject = ['$scope', 'contextConst', 'toastr', 'pixerfApiCommunitySvc', 'confirmPopupSvc', 'communityConst', 'translationSvc'];

	function communityMemberItemCtrl($scope, contextConst, toastr, pixerfApiCommunitySvc, confirmPopupSvc, communityConst, translationSvc) {

		var self = this;
		self.onActionBtnClicked = onActionBtnClicked;

		self.isContextPending = $scope.context === contextConst.COMMUNITY_PENDING_MEMBER;
		self.isContextMember = $scope.context === contextConst.COMMUNITY_MEMBER;
		self.isContextInvitedMember = $scope.context === contextConst.COMMUNITY_INVITED_MEMBER;
		self.isContextBlockedMember = $scope.context === contextConst.COMMUNITY_BLOCKED_MEMBER;
		self.communityId = $scope.$parent.$parent.community.id;
		self.CONSTANT = {
			ACCEPT: communityConst.ACTION.ACCEPT,
			REJECT: communityConst.ACTION.REJECT,
			REMOVE: communityConst.ACTION.REMOVE,
			UNINVITE: communityConst.ACTION.UNINVITE,
			UNBLOCK: communityConst.ACTION.UNBLOCK,
		}
		self.isWorking = false;

		function onActionBtnClicked(action, person, $event) {
			$event.stopPropagation();
			if (self.isWorking) {
				return;
			}

			if (action === self.CONSTANT.REJECT || action === self.CONSTANT.REMOVE || action === self.CONSTANT.UNINVITE || action === self.CONSTANT.UNBLOCK) {
				onConfirmAction(action, person);
			} else {
				onActionActived(action, person)
			}
		}

		function onActionActived(action, person) {
			var toastMessage = genAlertMessage(action, person);
			var params = {
				user_ids: [],
				emails: []
			}
			if (person.username) {
				params.user_ids.push(person.id);
			} else {
				params.emails.push(person.email);
			}
			pixerfApiCommunitySvc[action]({
				id: self.communityId
			}, params).$promise.then(function (response) {
				toastr.success(toastMessage);
				$scope.onUserStatusChanged({
					memberChanged: person.id,
					action: action,
					context: $scope.context
				});
				self.isWorking = false;
			}, function (err) {
				console.log(err);
				toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
				self.isWorking = false;
			});
		}

		function onConfirmAction(action, person) {
			var confirmMessage = genConfirmMessage(action, person);
			var popupConfig = {
				windowClass: 'confirm-action-popup',
				hideTitle: true,
				hideConfirmText: true,
				title: confirmMessage
			};
			if(action === self.CONSTANT.UNBLOCK || action === self.CONSTANT.UNINVITE){
				popupConfig.cancelBtnText = 'Cancel';
			}
			var modal = confirmPopupSvc.showPopup(popupConfig);
			modal.result.then(function () {
				self.isWorking = true;
				onActionActived(action, person);
			});
		}

		function genAlertMessage(action, person) {
			if (action === self.CONSTANT.REJECT) {
				return "You have rejected " + person.displayName + "'s request to join the Community.";
			} else if (action === self.CONSTANT.ACCEPT) {
				return "You have accepted " + person.displayName + "'s request to join the Community.";
			} else if (action === self.CONSTANT.REMOVE) {
				return "You have removed " + person.displayName + " from the Community.";
			} else if (action === self.CONSTANT.UNINVITE) {
				return "You have uninvited " + person.displayName + " from the Community.";
			} else if (action === self.CONSTANT.UNBLOCK) {
				return "You have unblocked " + person.displayName + " from the Community.";
			} else {
				return "";
			}
		}

		function genConfirmMessage(action, person) {
			if (action === self.CONSTANT.REJECT) {
				return "Do you want to reject " + person.displayName + "'s request to join the Community?";
			} else if (action === self.CONSTANT.REMOVE) {
				return "Do you want to remove " + person.displayName + " from the Community?";
			} else if (action === self.CONSTANT.UNINVITE) {
				return "Do you want to uninvite " + person.displayName + " from the Community?";
			} else if (action === self.CONSTANT.UNBLOCK) {
				return "Do you want to unblock " + person.displayName + " from the Community?";
			}else {
				return "";
			}
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('communityMemberItem', communityMemberItem);

	communityMemberItem.$inject = [];
	function communityMemberItem() {

		var directive = {
			scope: {
				userData: "=",
				context: "@",
				onUserStatusChanged: "&?",
				onSelectedChanged: "&?"
			},
			restrict: 'E',
			templateUrl: 'app/components/community-member-item/community-member-item.html',
			controller: 'communityMemberItemCtrl',
			controllerAs: 'vm',
			replace: true
		};
		return directive;
	}

})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.factory('communityMemberFilterSvc', communityMemberFilterSvc);

	communityMemberFilterSvc.$inject = [];

	function communityMemberFilterSvc() {
		function buildSearchParams(searchCondition, loginUser) {
			var searchParms = {};
			if (searchCondition.isDirectoryChecked) {
				searchParms = {
					personId: loginUser.id,
					type: "directory",
					page: 1
				}
			} else if (searchCondition.isEmailChecked) {
				searchParms = {
					personId: loginUser.id,
					type: "all",
					page: 1
				}
			}
			if (searchCondition.country && searchCondition.country.length > 0) {
				searchParms.countries = _.reduce(searchCondition.country, function (memo, item) {
					memo.push(item.id);
					return memo;
				}, []).join();
			}
			if (searchCondition.speciality && searchCondition.speciality.length > 0) {
				searchParms.specialities = _.reduce(searchCondition.speciality, function (memo, item) {
					memo.push(item.id);
					return memo;
				}, []).join();
			}
			return searchParms;
		}

		return {
			buildSearchParams: buildSearchParams
		};
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('communityMemberFilterCtrl', communityMemberFilterCtrl);

	communityMemberFilterCtrl.$inject = ['ISO3166', '$scope', 'sessionManagerSvc', 'pixerfApiUserSvc'];

	function communityMemberFilterCtrl(ISO3166, $scope, sessionManagerSvc, pixerfApiUserSvc) {

		var self = this;
		self.loginUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.countries = [];
		self.specialities = [];
		self.onDirectoryCheckChanged = onDirectoryCheckChanged;
		self.onFollowerCheckChanged = onFollowerCheckChanged;
		self.onSearchConditionChanged = onSearchConditionChanged;
		self.onLinkCheckChanged = onLinkCheckChanged;
		self.searchCondition = {
			isDirectoryChecked: false,
			isEmailChecked: false,
			isLinkChecked: false,
			country: "",
			speciality: ""
		}
		self.bootstrapSelectOptions = {
			country: {
				"customAll": true,
				"container": $scope.options.parentClass,
				"liveSearch": true,
				"dropupAuto": false,
				"noneSelectedText": "All Countries",
				"liveSearchPlaceholder": "Search for Country..."
			},
			speciality: {
				"customAll": true,
				"container": $scope.options.parentClass,
				"liveSearch": true,
				"dropupAuto": false,
				"noneSelectedText": "All Specialities",
				"liveSearchPlaceholder": "Search for Speciality..."
			},
		}
		init();

		function buildCountries() {
			var arr = [{
				id: 'all',
				name: 'All Countries'
			}];
			for (var key in ISO3166.codeToCountry) {
				arr.push({
					id: key,
					name: ISO3166.codeToCountry[key]
				})
			}
			return arr;
		}

		function buildSpecialities() {
			return pixerfApiUserSvc.getSpecialities().$promise;
		}

		function init() {
			self.countries = buildCountries();
			buildSpecialities().then(function (respone) {
				self.specialities = respone.data;
				self.specialities.unshift({
					id: 'all',
					name: 'All Specialities'
				});
			});
			if ($scope.options.defaultSearchCondition) {
				self.searchCondition = $scope.options.defaultSearchCondition;
				if ($scope.options.defaultSearchCondition.isDirectoryChecked) {
					onDirectoryCheckChanged();
				}
				if ($scope.options.defaultSearchCondition.isEmailChecked) {
					onFollowerCheckChanged();
				}
				if ($scope.options.defaultSearchCondition.isLinkChecked) {
					onLinkCheckChanged();
				}
				if ($scope.options.defaultSearchCondition.country || $scope.options.defaultSearchCondition.speciality) {
					onSearchConditionChanged();
				}
			}
		}

		function onFollowerCheckChanged() {
			self.searchCondition.isDirectoryChecked = false;
			self.searchCondition.isLinkChecked = false;
			$scope.onChanged({
				searchCondition: self.searchCondition
			});
		}

		function onDirectoryCheckChanged() {
			self.searchCondition.isEmailChecked = false;
			self.searchCondition.isLinkChecked = false;
			$scope.onChanged({
				searchCondition: self.searchCondition
			});
		}

		function onLinkCheckChanged() {
			self.searchCondition.isEmailChecked = false;
			self.searchCondition.isDirectoryChecked = false;
			$scope.onChanged({
				searchCondition: self.searchCondition
			});
		}

		function onSearchConditionChanged() {
			var indexAllSpecialities = _.findIndex(self.searchCondition.speciality, {
				id: 'all'
			});
			var indexAllCountries = _.findIndex(self.searchCondition.country, {
				id: 'all'
			});
			if (self.searchCondition.speciality && self.searchCondition.speciality.length && indexAllSpecialities >= 0) {
				self.searchCondition.speciality.splice(indexAllSpecialities, 1);
			}
			if (self.searchCondition.country && self.searchCondition.country.length && indexAllCountries >= 0) {
				self.searchCondition.country.splice(indexAllCountries, 1);
			}
			$scope.onChanged({
				searchCondition: self.searchCondition
			});
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('communityMemberFilter', communityMemberFilterCtrl);

	function communityMemberFilterCtrl() {

		var directive = {
			scope: {
				onChanged: "&",
				options: "=",
				showSearchButton: "@?"
			},
			restrict: 'E',
			templateUrl: 'app/components/community-member-filter/community-member-filter.html',
			controller: 'communityMemberFilterCtrl',
			controllerAs: 'vm',
			replace: true
		};
		return directive;
	}

})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('communityListViewCtrl', communityListViewCtrl);

	communityListViewCtrl.$inject = ['$scope', '$window', 'pixerfApiCommunitySvc', 'sessionManagerSvc', 'actionReqruiedCommunityPopupSvc', '$q', 'alertMessagePopupSvc', '$translate', 'confirmPopupSvc', 'systemUtils', 'pixerfUrl', 'translationSvc', 'toastr', 'pixerfDiscussionReportPopupSvc'];

	function communityListViewCtrl($scope, $window, pixerfApiCommunitySvc, sessionManagerSvc, actionReqruiedCommunityPopupSvc, $q, alertMessagePopupSvc, $translate, confirmPopupSvc, systemUtils, pixerfUrl, translationSvc, toastr, pixerfDiscussionReportPopupSvc) {

		var USER_CONTROL_ADMINDASHBOARD = ['curator_internal', 'admin_internal', 'marketer_internal'];
		var self = this;
		self.loginedUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.isAdmin = self.loginedUser && (USER_CONTROL_ADMINDASHBOARD.includes(self.loginedUser.role) || self.loginedUser.email === 'marcom@pixerf.com');
		self.maxStrikes = 3;
		self.community = $scope.community;
		self.isMine = (self.loginedUser && self.loginedUser.id === self.community.owner.id);
		self.type = $scope.type;
		self.onToggleSelected = onToggleSelected;
		self.onToggleActionRequired = onToggleActionRequired;
		self.onCommunityClicked = onCommunityClicked;
		self.prevenPubbleClick = prevenPubbleClick;
		self.onEditComments = onEditComments;
		self.onReactivate = onReactivate;
		self.onDeactivate = onDeactivate;
		self.onMoveToInReview = onMoveToInReview;
		self.onActionRequiredCommunity = onActionRequiredCommunity;
		self.onApproveCommunity = onApproveCommunity;
		self.onEditCommunity = onEditCommunity;
		self.onDeleteCommunity = onDeleteCommunity;
		self.prevenPubbleClick = prevenPubbleClick;
		self.onCopyLinkToCommunity = onCopyLinkToCommunity;
		self.onWithdrawCommunity = onWithdrawCommunity;
		self.onAcceptClicked = onAcceptClicked;
		self.onDenyClicked = onDenyClicked;
		self.onLeaveCommunity = onLeaveCommunity;
		self.onReportCommunity = onReportCommunity;
		self.showPermission = false;
		self.showMemberCount = false;
		self.showEventCount = false;
		self.showPostCount = false;
		self.showActionRequired = false;
		self.showStrike = false;
		self.showCurationControl = false;
		self.showActionList = false;
		self.showStatus = false;
		self.actionList = [];

		init();

		function init() {
			setLayout();
			convertCreatedDate();
			convertJoinedDate();
			convertInvitedDate();
			convertRequestedDate();
			convertStatus();
		}

		function convertCreatedDate() {
			if (!self.community || !self.community.inserted_at) return;
			self.formattedCreatedDate = moment(self.community.inserted_at).format("MMM DD, YYYY");
		}

		function convertJoinedDate() {
			if (!self.community || !self.community.membership_inserted_at) return;
			self.formattedJoinedDate = moment(self.community.membership_inserted_at).format("MMM DD, YYYY");
		}

		function convertInvitedDate() {
			if (!self.community || !self.community.membership_inserted_at) return;
			self.formattedInvitedDate = moment(self.community.membership_inserted_at).format("MMM DD, YYYY");
		}

		function convertRequestedDate() {
			if (!self.community || !self.community.membership_inserted_at) return;
			self.formattedRequestedDate = moment(self.community.membership_inserted_at).format("MMM DD, YYYY");
		}

		function convertStatus() {
			if (!self.community || !self.community.status) return;
			switch (self.community.status) {
				case 'in_review':
					if (["my-communities"].includes(self.type)) {
						self.formattedStatus = 'Active';
					}
					break;
				case 'approve_required':
					self.formattedStatus = 'Action Required';
					break;
				case 'pending':
					self.formattedStatus = 'Pending Pixerf Approval';
					break;
				default:
					self.formattedStatus = self.community.status;
			}
		}


		function setLayout() {
			switch (self.type) {
				case 'active':
					self.showCheckbox = true;
					self.showPrivacy = true;
					self.showActionList = true;
					self.showMemberCount = true;
					self.showEventCount = true;
					self.showPostCount = true;
					self.showDateCreated = true;
					self.showOwner = true;
					self.showStrike = true;
					self.actionList = [{
						label: 'Move to in Review',
						cta: self.onMoveToInReview
					}, {
						label: 'Deactivate',
						cta: self.onDeactivate
					}];
					break;
				case 'pending-approval':
					self.showCheckbox = true;
					self.showPrivacy = true;
					self.showPermission = true;
					self.showDateCreated = true;
					self.showOwner = true;
					self.showCurationControl = true;
					break;
				case 'action-required':
					self.showCheckbox = true;
					self.showActionList = true;
					self.showPrivacy = true;
					self.showPermission = true;
					self.showDateCreated = true;
					self.showOwner = true;
					self.showActionRequired = true;
					self.actionList = [{
						label: 'Edit comments',
						cta: self.onEditComments
					}];
					break;
				case 'in-review':
					self.showCheckbox = true;
					self.showPrivacy = true;
					self.showActionList = true;
					self.showMemberCount = true;
					self.showEventCount = true;
					self.showPostCount = true;
					self.showDateCreated = true;
					self.showOwner = true;
					self.showStrike = true;
					self.actionList = [{
						label: 'Reactivate',
						cta: self.onReactivate
					}, {
						label: 'Deactivate',
						cta: self.onDeactivate
					}];
					break;
				case 'deactivate':
					self.showCheckbox = true;
					self.showPrivacy = true;
					self.showActionList = true;
					self.showMemberCount = true;
					self.showEventCount = true;
					self.showPostCount = true;
					self.showOwner = true;
					self.showDateCreated = true;
					self.showStrike = true;
					self.actionList = [{
						label: 'Reactivate',
						cta: self.onReactivate
					}];
					break;
				case 'pending':
					self.showEditBtn = true;
					self.showCheckbox = true;
					self.showDateCreated = true;
					self.showStatus = true;
					self.showReasonApproveRequired = true;
					self.showCombineAction = true;
					self.showEditBtn = true;
					if (self.isMine) {
						self.actionList = [{
							label: 'Delete Community',
							cta: self.onDeleteCommunity
						}];
					}
					break;
				case 'requested':
					self.showOwner = true;
					self.showCheckbox = true;
					self.showDateRequested = true;
					self.showActionButton = true;
					self.showWithdrawBtn = true;
					break;
				case 'invited':
					self.showOwner = true;
					self.showCheckbox = true;
					self.showDateInvited = true;
					self.showActionButton = true;
					self.showDeclineBtn = true;
					self.showAcceptBtn = true;
					break;
				case 'my-communities':
					self.showOwner = true;
					self.showCheckbox = true;
					self.showLabel = true;
					self.showStatus = true;
					self.showStrike = true;
					self.showActionList = true;
					self.showDateJoined = true;
					self.actionList = [{
						label: 'Copy Link to Community',
						cta: self.onCopyLinkToCommunity
					}];
					if (self.isMine) {
						self.actionList = self.actionList.concat([{
								label: 'Edit Community',
								cta: self.onEditCommunity
							},
							{
								label: 'Delete Community',
								cta: self.onDeleteCommunity
							}
						]);
					} else {
						self.actionList = self.actionList.concat([{
								label: 'Leave Community',
								cta: self.onLeaveCommunity
							},
							{
								label: 'Report Community',
								cta: self.onReportCommunity
							}
						])
					}
					break;
			}
		}

		function onToggleSelected(community) {
			$scope.onToggleSelected({
				community: community
			});
		}

		function onToggleActionRequired(isToggle) {
			prevenPubbleClick();
			self.isOpenActionRequiredHint = !isToggle;
		}

		function onCommunityClicked(community) {
			$scope.onCommunityClicked({
				community: community
			});
		}

		function onEditComments() {
			prevenPubbleClick();

			actionReqruiedCommunityPopupSvc.showPopup({
				community: self.community,
				submit: function (data) {
					var def = $q.defer();
					data.community_ids = [self.community.id];
					pixerfApiCommunitySvc.action_required_community(null, data).$promise.then(function (res) {
						def.resolve(res.data)
					}).catch(function (err) {
						def.reject(err);
					})
					return def.promise;
				},
				submitCallback: function (res) {
					showActionRequiredPopup();
				}
			})
		}

		function onReactivate() {
			prevenPubbleClick();
			pixerfApiCommunitySvc.reactivate_community(null, {
				community_ids: [self.community.id]
			}).$promise.then(function (res) {
				self.community = res.data;
				if ($scope.onStatusChanged) {
					$scope.onStatusChanged({
						community: self.community
					});
				}
			}).catch(function (err) {
				console.log(err);
			})
		}

		function onDeactivate() {
			prevenPubbleClick();
			pixerfApiCommunitySvc.deactivate_community(null, {
				community_ids: [self.community.id]
			}).$promise.then(function (res) {
				self.community = res.data;
				if ($scope.onStatusChanged) {
					$scope.onStatusChanged({
						community: self.community
					});
				}
			}).catch(function (err) {
				console.log(err);
			})
		}

		function onMoveToInReview() {
			prevenPubbleClick();
			pixerfApiCommunitySvc.move_to_in_review(null, {
				community_ids: [self.community.id]
			}).$promise.then(function (res) {
				self.community = res.data;
				if ($scope.onStatusChanged) {
					$scope.onStatusChanged({
						community: self.community
					});
				}
			}).catch(function (err) {
				console.log(err);
			})
		}

		function onApproveCommunity() {
			prevenPubbleClick();

			pixerfApiCommunitySvc.approve_community(null, {
				community_ids: [self.community.id]
			}).$promise.then(function (res) {
				alertMessagePopupSvc.showPopup({
					windowClass: 'community-list-view__alert-message',
					title: "Community approved!",
					description: "You can find this community under <span class='text--bold text--color-pixerf-theme'>Active Communities</span>."
				});
				self.community = res.data;
				if ($scope.onStatusChanged) {
					$scope.onStatusChanged({
						community: self.community
					});
				}
			}).catch(function (err) {
				console.log(err);
			})
		}

		function onActionRequiredCommunity() {
			prevenPubbleClick();

			actionReqruiedCommunityPopupSvc.showPopup({
				submit: function (data) {
					var def = $q.defer();
					data.community_ids = [self.community.id];
					pixerfApiCommunitySvc.action_required_community(null, data).$promise.then(function (res) {
						self.community = res.data;
						def.resolve(res.data)
					}).catch(function (err) {
						def.reject(err);
					})
					return def.promise;
				},
				submitCallback: function (res) {
					showActionRequiredPopup();
					if ($scope.onStatusChanged) {
						$scope.onStatusChanged({
							community: res
						});
					}
				}
			})
		}

		function showActionRequiredPopup() {
			alertMessagePopupSvc.showPopup({
				windowClass: 'community-list-view__alert-message',
				title: "Comment sent! What do you want to do next?",
				description: "You can find this community under <span class='text--bold text--color-pixerf-theme'>Action Required</span>. You can still edit your commment if owner has not edited and resubmitted their form."
			});
		}

		function prevenPubbleClick() {
			$window.event.stopPropagation();
		}

		function onEditCommunity() {
			prevenPubbleClick();

			if ($scope.onManageClicked) {
				$scope.onManageClicked({
					community: self.community
				});
			}
		}

		function onDeleteCommunity() {
			prevenPubbleClick();
			self.isMoreListOpen = false;

			var confirmMessage = $translate.instant("delete-community-confirm");
			var modal = confirmPopupSvc.showPopup({
				windowClass: 'confirm-action-popup',
				hideTitle: true,
				hideConfirmText: true,
				cancelBtnText: 'Cancel',
				title: confirmMessage
			});
			modal.result.then(function () {
				pixerfApiCommunitySvc.delete({
					id: self.community.id
				}).$promise.then(function (response) {
					if ($scope.onStatusChanged) {
						$scope.onStatusChanged({
							community: self.community
						});
					}
				}, function (err) {
					console.log(err);
					toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
				});
			})
		}

		function onCopyLinkToCommunity() {
			prevenPubbleClick();
			self.isMoreListOpen = false;

			var communityDetails = pixerfUrl.full + '#/community-detail-page/' + self.community.id;
			systemUtils.copyStringToClipboard(communityDetails, 'Your link has been successfully copied');
		}

		function onWithdrawCommunity() {
			prevenPubbleClick();

			var confirmMessage = translationSvc.ARE_YOU_SURE_TO_DO_SOMETHING("WITHDRAW_REQUEST_JOIN_THE_COMMUNITY", {
				community: self.community.name
			});
			var modal = confirmPopupSvc.showPopup({
				windowClass: 'confirm-withdraw-request-to-join-community-popup',
				title: "Withdraw joining request?",
				hideConfirmText: true,
				cancelBtnText: 'Cancel',
				submitBtnText: 'Confirm',
				message: confirmMessage
			});

			modal.result.then(function () {
				pixerfApiCommunitySvc.withdraw_request({
					community_ids: [self.community.id]
				}).$promise.then(function () {
					if ($scope.onStatusChanged) {
						$scope.onStatusChanged({
							community: self.community
						});
					}
					toastr.success($translate.instant('you-have-withdrawn-successfully'));
				}).catch(function (err) {
					console.log(err);
					toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
				})
			})
		}

		function onAcceptClicked() {
			prevenPubbleClick();

			pixerfApiCommunitySvc.accept_invitations({
				community_ids: [self.community.id]
			}).$promise.then(function () {
				toastr.success("You have accepted to join the community " + self.community.name);
				if ($scope.onStatusChanged) {
					$scope.onStatusChanged({
						community: self.community
					});
				}
			}, function () {
				toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
			})
		}

		function onDenyClicked() {
			prevenPubbleClick();

			var confirmMessage = 'Do you wish to decline the invitation to join the Community <span class="text--bold text--color-black">' + self.community.name + '</span>?';
			var modal = confirmPopupSvc.showPopup({
				windowClass: 'confirm-decline-invitation-to-join-community-popup',
				hideTitle: true,
				hideConfirmText: true,
				cancelBtnText: 'Cancel',
				submitBtnText: 'Confirm',
				message: confirmMessage
			});
			modal.result.then(function () {
				pixerfApiCommunitySvc.reject_invitations({
					community_ids: [self.community.id]
				}).$promise.then(function () {
					toastr.success("You have declined to join the Community " + self.community.name);
					if ($scope.onStatusChanged) {
						$scope.onStatusChanged({
							community: self.community
						});
					}
				}, function () {
					toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
				})
			})
		}

		function onLeaveCommunity() {
			prevenPubbleClick();

			var confirmMessage = translationSvc.ARE_YOU_SURE_TO_DO_SOMETHING("LEAVE_THE_COMMUNITY", {
				community: self.community.name
			});
			var modal = confirmPopupSvc.showPopup({
				windowClass: 'confirm-leave-community-popup',
				hideTitle: true,
				hideConfirmText: true,
				cancelBtnText: 'Cancel',
				submitBtnText: 'Confirm',
				message: confirmMessage
			});

			modal.result.then(function () {
				pixerfApiCommunitySvc.withdraw_request({
					community_ids: [self.community.id]
				}).$promise.then(function (respone) {
					toastr.success($translate.instant('no-longer-receive-notifications-from-community', {
						community: self.community.name
					}));
					if ($scope.onStatusChanged) {
						$scope.onStatusChanged({
							community: self.community
						});
					}
				}).catch(function (err) {
					console.log(err);
					toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
				});
			});
		}

		function onReportCommunity() {
			prevenPubbleClick();

			pixerfDiscussionReportPopupSvc.showPopup({
				id: self.community.id,
				target: 'report_community'
			});
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('communityListView', communityListView);
	communityListView.$inject = []

	function communityListView() {

		var directive = {
			scope: {
				community: "=",
				onToggleSelected: "&?",
				onCommunityClicked: "&?",
				onStatusChanged: "&?",
				onManageClicked: "&?",
				type: "@"
			},
			restrict: 'E',
			templateUrl: 'app/components/community-list-view/community-list-view.html',
			controller: 'communityListViewCtrl',
			controllerAs: 'vm',
			replace: true
		};
		return directive;
	}
})();

/**
 * Controller for home module
 */
(function(){
  'use strict';
  angular
    .module('pixerf')
    .factory('communityLeavingFeedbackPopupSvc', communityLeavingFeedbackPopupSvc);
    communityLeavingFeedbackPopupSvc.$inject = ['$uibModal'];

    function communityLeavingFeedbackPopupSvc($uibModal){

		function showPopup(data){
	    	return $uibModal.open({
				templateUrl: 'app/components/community-leaving-feedback-popup/community-leaving-feedback-popup.html',
				controller: 'communityLeavingFeedbackPopupCtrl',
				controllerAs: 'vm',
				animation: true,
				windowClass: 'community-leaving-feedback-popup-popup',
                resolve: {
                    'resolveData': function(){
                        return data;
                    }
                }
		    });

    	}
		function validate(content){
			var errMsg = ''
			if(!content){
				errMsg = "Please fill in the reason";
            }
			return errMsg;
		}
		
		return {
			validate: validate,
			showPopup: showPopup
		};
    }
})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('communityLeavingFeedbackPopupCtrl', communityLeavingFeedbackPopupCtrl);

    communityLeavingFeedbackPopupCtrl.$inject = ['messageConst', 'communityLeavingFeedbackPopupSvc', 'toastr', '$uibModalInstance'];

    function communityLeavingFeedbackPopupCtrl(messageConst,  communityLeavingFeedbackPopupSvc, toastr, $uibModalInstance) {

        var self = this;


        self.onSaveBtnClicked = onSaveBtnClicked;
        self.onCancelBtnClicked = close;
        self.isWorking = false;

        function close(reason){
            $uibModalInstance.dismiss(reason);
        }
        function onSaveBtnClicked(content, formData){
            if(self.isWorking) return;
            formData.$setDirty();

            var errMsg = communityLeavingFeedbackPopupSvc.validate(content);
            if(errMsg){
                toastr.error(errMsg);
                return;
            }
            $uibModalInstance.close();

        }
    }
})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.factory('communityInviteEmailPopupSvc', communityInviteEmailPopupSvc);
	communityInviteEmailPopupSvc.$inject = ['$uibModal'];

	function communityInviteEmailPopupSvc($uibModal) {

		var btnSendInvitationLabelTemplate = "Send <%=number%> Invitation<%=plural%>";

		function showPopup(data) {
			return $uibModal.open({
				templateUrl: 'app/components/community-invite-email-popup/community-invite-email-popup.html',
				controller: 'communityInviteEmailPopupCtrl',
				controllerAs: 'vm',
				animation: true,
				windowClass: 'community-invite-email-popup-window-class',
				resolve: {
					'resolveData': function () {
						return data;
					}
				}
			});

		}

		function getSelectedContacts(contacts, property) {
			return _.reduce(contacts, function (memo, item) {
				if (item.isSelected) {
					if (property === "id") {
						memo.push(item.id);
					} else if (item.email) {
						memo.push(item.email.address ? item.email.address : item.email);
					}
				}
				return memo;
			}, [])
		}

		function getSelectedPeople(peoples) {
			return _.reduce(peoples, function (memo, item) {
				if (item.isSelected) {
					memo.push(item);
				}
				return memo;
			}, [])
		}

		function getNumSelectedContacts(contacts) {
			return _.countBy(contacts, function (item) {
				return item.isSelected;
			})[true];
		}

		function updateSendBtnLabel(numSelectedContact) {
			return _.template(btnSendInvitationLabelTemplate)({
				number: numSelectedContact > 0 ? numSelectedContact : '',
				plural: numSelectedContact > 1 ? 's' : ''
			});
		}
		return {
			showPopup: showPopup,
			getNumSelectedContacts: getNumSelectedContacts,
			updateSendBtnLabel: updateSendBtnLabel,
			getSelectedContacts: getSelectedContacts,
			getSelectedPeople: getSelectedPeople
		};
	}
})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('communityInviteEmailPopupCtrl', communityInviteEmailPopupCtrl);

    communityInviteEmailPopupCtrl.$inject = ['resolveData', '$uibModalInstance', 'communityInviteEmailPopupSvc', '$timeout', 'toastr', 'pixerfApiCampaignSvc', 'pagingUtils', 'translationSvc'];

    function communityInviteEmailPopupCtrl(resolveData, $uibModalInstance, communityInviteEmailPopupSvc, $timeout, toastr, pixerfApiCampaignSvc, pagingUtils, translationSvc) {

        var self = this;

        if(resolveData.getSelectedPersons){
            self.dontSendInvite = true;
        }
        self.popupData = resolveData;
        self.closePopup = closePopup;
        self.onSendInvitationBtnClicked = onSendInvitationBtnClicked;
        self.onAddToList = onAddToList;
        self.onCloseBtnClicked = onCloseBtnClicked;
        self.onCancelBtnClicked = onCancelBtnClicked;
        self.onSelectAllToogle = onSelectAllToogle;
        self.onContactSelected = onContactSelected;
        self.fetchMore = fetchMore;
        self.filteredArray = [];

        self.btnSendInvitationLabel = "Send Invitation";
        self.isWorking = false;
        self.isSelectAll = false;
        self.isLastPage = false;
        self.spinner = {
            isVisible: false
        };
        self.personListOptions = {
            disableScroll: true
        }
        self.selectedEmails = [];
        self.searchParams = {
            page: 1
        };

        init();
        function getContacts(params){
            if(params.page == 1) {
                self.contacts = [];
            }
            self.popupData.getter(params).then(function(response){

                self.contacts = self.contacts.concat(response.data);
                self.isLastPage = pagingUtils.isNoMorePageToLoad(params.page, response);
                self.searchParams.page = params.page;
                self.spinner.isVisible = false;

            }, function(err){
                self.spinner.isVisible = false;
            })
        }
        function fetchMore(){

            var params = $.extend(true, {}, self.searchParams)
            params.page = self.searchParams.page + 1;
            getContacts(params);
        }

        function onCloseBtnClicked(){
            dismiss();
        }
        function onCancelBtnClicked(){
            dismiss();
        }

        function onSendInvitationBtnClicked(){
            if(self.selectedEmails.length === 0) return;
            if(self.isWorking) return;
            self.isWorking = true;
            pixerfApiCampaignSvc.invite({"invitees": self.selectedEmails}).$promise.then(function(res){
                toastr.success("Invitations have been successfully sent");
                self.isWorking = false;
                $timeout(function(){
                    closePopup(self.selectedEmails, res.data);
                },2000);
            }, function(err){
                var errMsg = translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true);
                if(err.message == "ALREADY_INVITED"){
                    errMsg = "Hi, You cannot send invitation to those email because you sent already: "  +  errMsg.emails.join(", ");
                }
                toastr.error(errMsg);
                self.isWorking = false;
            })
        }

        function onAddToList(){
            closePopup(self.selectedEmails);
        }

        function onSelectAllToogle(){
            for(var i = 0; i < self.filteredArray.length; i ++){
                self.filteredArray[i].isSelected = self.isSelectAll;
            }
            self.btnSendInvitationLabel = communityInviteEmailPopupSvc.updateSendBtnLabel(self.isSelectAll ? self.filteredArray.length : 0);
            self.selectedEmails = communityInviteEmailPopupSvc.getSelectedContacts(self.filteredArray);
        }
        function onContactSelected(){
            self.selectedEmails = communityInviteEmailPopupSvc.getSelectedContacts(self.filteredArray);
            var numSelected = self.selectedEmails.length;
            self.btnSendInvitationLabel = communityInviteEmailPopupSvc.updateSendBtnLabel(numSelected);
            self.isSelectAll =  numSelected === self.filteredArray.length;
        }
        function init(user, steps){
            getContacts(self.searchParams);
        }
		function dismiss(){
            $uibModalInstance.dismiss();
        }
		function closePopup(invited, data){
			$uibModalInstance.close({invited: invited, data: data});
        }

    }
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('communityGridCtrl', communityGridCtrl);

	communityGridCtrl.$inject = ['$scope', 'pixerfApiCommunitySvc', 'pagingUtils', 'toastr', '$translate', 'communityConst', '$state', 'commonConst'];

	function communityGridCtrl($scope, pixerfApiCommunitySvc, pagingUtils, toastr, $translate, communityConst, $state, commonConst) {

		var self = this;
		self.communities = null;
		self.communityConst = communityConst;
		self.searchParams = {};
		self.getCommunitiesList = getCommunitiesList;
		self.onSeeMoreBtnClicked = onSeeMoreBtnClicked;
		self.removeCommunityFromList = removeCommunityFromList;
		self.onCommunityMembershipChanged = onCommunityMembershipChanged;
		self.isMine = $scope.options && $scope.options.isMyProfile;
		self.onEmptyStateBtnClicked = onEmptyStateBtnClicked;
		self.spinner = {
			isVisible: false
		}

		init();

		function init() {
			if ($scope.onInit) {
				$scope.onInit({
					instance: self
				});
			}
			self.searchParams = $.extend(true, {
				page: 1
			}, $scope.searchParams)
			getCommunitiesList(self.searchParams, true);
		}

		function getter() {
			if ($scope.getter) return $scope.getter();
			if ($scope.context === 'explore') {
				return pixerfApiCommunitySvc.explore;
			} else {
				return pixerfApiCommunitySvc.list;
			}
		}

		function onSeeMoreBtnClicked() {
			fetchMoreCommunities();
		}

		function getCommunitiesList(params, isFresh) {
			self.searchParams = params;
			self.spinner.isVisible = true;
			getter()(self.searchParams).$promise.then(function (response) {
				if (!self.communities || isFresh) self.communities = [];

				self.communities = self.communities.concat(response.data);
				self.isLastPage = pagingUtils.isNoMorePageToLoad(params.page, response);
				self.spinner.isVisible = false;
				self.searchParams.page = params.page;
			}, function () {
				toastr.error($translate.instant("failed-to-get-communities-list"));
				self.spinner.isVisible = false;
			});
		}

		function fetchMoreCommunities() {
			if (self.isLastPage || self.spinner.isVisible) return;

			var searchParms = $.extend(true, {}, self.searchParams);
			searchParms.page++;
			getCommunitiesList(searchParms);
		}

		function removeCommunityFromList(communityId) {
			self.communities = _.reject(self.communities, function (community) {
				return community.id === communityId;
			});
		}

		function onCommunityMembershipChanged(communityId) {
			if (self.isMine) {
				removeCommunityFromList(communityId);
			}
		}

		function onEmptyStateBtnClicked() {
			$state.go(commonConst.STATE.EXPLORE_COMMUNITY);
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('communityGrid', communityGrid);
	communityGrid.$inject = []

	function communityGrid() {

		var directive = {
			scope: {
				onInit: '&?',
				options: "=",
				getter: "&?",
				searchParams: "=?",
				context: '@?',
				layout: '@'
			},
			restrict: 'E',
			transclude: true,
			templateUrl: 'app/components/community-grid/community-grid.html',
			controller: 'communityGridCtrl',
			controllerAs: 'vm',
			replace: true
		};
		return directive;
	}

})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('communityExploreTileCtrl', communityExploreTileCtrl);

	communityExploreTileCtrl.$inject = ['$scope', 'commonConst', '$state', 'toastr', 'translationSvc', '$translate', 'pixerfApiCommunitySvc', 'sessionManagerSvc', '$window', 'systemUtils', '$timeout', 'pixerfConfirmPopupSvc', 'countryUtils', 'ISO3166'];

	function communityExploreTileCtrl($scope, commonConst, $state, toastr, translationSvc, $translate, pixerfApiCommunitySvc, sessionManagerSvc, $window, systemUtils, $timeout, pixerfConfirmPopupSvc, countryUtils, ISO3166) {

		var self = this;
		self.membershipStatus = '';
		self.loginedUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.community = $scope.community;
		self.commonConst = commonConst;
		self.onGoCommunityDetails = onGoCommunityDetails;
		self.requestJoinCommunity = requestJoinCommunity;
		self.onManageCommunity = onManageCommunity;
		self.onManageBtnHovered = onManageBtnHovered;
		self.onManageBtnLeft = onManageBtnLeft;
		self.onWithdrawRequest = onWithdrawRequest;
		self.countryList = {
			countryListName: [],
			countryNamebrief: '',
			countryListTooltipContentHtml: ''
		}

		init();

		function init() {
			if (self.community) {
				var userCountry = '';
				if(self.loginedUser){
					userCountry = self.loginedUser.isBiz? self.loginedUser.organization.address.country : self.loginedUser.address.country;
				}
				var coutries = countryUtils.sortCountries(self.community.countries, userCountry);
				self.tooltipId = 'communityExploreTile'+ self.community.id;
				self.region = countryUtils.getRegion(coutries);
				buildCommunityList(coutries, self.region)
				genTextMembershipStatus(self.community.membership_status);
				$timeout(function () {
					adjustTextTile('title');
				})
			}
		}

		function buildCommunityList(countriesArr, region){
			self.countryList.countryListName =  Object.values(ISO3166.getCountryNames(countriesArr));
			if(region && region.value){
				self.countryList.countryNamebrief = region.label;
				return;
			}
			switch (self.countryList.countryListName.length) {
				case 0:
					self.countryList.countryNamebrief = 'All Countries';
					break;
				case 1:
					self.countryList.countryNamebrief = self.countryList.countryListName[0];
					break;
				default:
					self.countryList.countryNamebrief = self.countryList.countryListName[0] + ' & ' + (self.countryList.countryListName.length - 1) + ' more';
					var showCountryArr = Object.assign(self.countryList.countryListName, {});
					showCountryArr.shift();
					buildCountryListTooltipContent(showCountryArr);
			}
		}

		function buildCountryListTooltipContent(countryListName){
			var template = '<div><div class=\"community-explore-tile__country-tooltip__title\">Countries targeted</div><%=countryList%></div>';
			var countryItemTemplate = '<div class=\"community-explore-tile__country-tooltip__item\"><%=countryItem%></div>';
			var countryList = '';
			for(var i = 0; i< countryListName.length; i++){
				countryList  = countryList + _.template(countryItemTemplate)({
					countryItem: countryListName[i]
				});
			}
			
			self.countryList.countryListTooltipContentHtml = _.template(template)({
				countryList: countryList
			});
			
			$timeout(function () {
				var tooltipEle = $('[rel="' + self.tooltipId + '"]');
				tooltipEle.tooltip();
				tooltipEle.attr('data-original-title',self.countryList.countryListTooltipContentHtml);
			}, 200)
		}

		function genTextMembershipStatus(status) {
			switch (status) {
				case 'accepted':
					self.membershipStatus = 'you-are-a-member';
					break;
				case 'owner':
					self.membershipStatus = 'edit-my-community';
					break;
				case 'manager':
					self.membershipStatus = 'you-are-the-manager';
					break;
				case 'requested':
					self.membershipStatus = 'requested';
					break;
				default:
					if (self.loginedUser && self.loginedUser.account_type === 'business' && self.community.is_private) {
						self.membershipStatus = 'find-out-more';
					} else if (self.loginedUser && self.loginedUser.account_type === 'business') {
						self.membershipStatus = 'view-this-community';
					} else {
						self.membershipStatus = 'join-community';
					}
			}
		}

		function adjustTextTile(element) {
			switch (element) {
				case 'title':
					var $title = $('.community-explore-tile__content__info__title.' + self.community.id);
					$title.dotdotdot();
					break;
			}
		}

		function onGoCommunityDetails(community) {
			$state.go(self.commonConst.STATE.COMMUNITIES_DETAILS_DISCUSSIONS, {
				id: community.id,
				name: community.name
			});
		}

		function onManageCommunity(community) {
			$window.event.stopPropagation();
			$state.go(self.commonConst.STATE.MANAGE_COMMUNITIES_BRIEF, {
				id: community.id,
				name: community.name,
				manage: true,
				status: 'members'
			});
		}

		function requestJoinCommunity(community) {
			$window.event.stopPropagation();
			if (community.membership_status === 'accepted' || community.membership_status === 'requested') return;

			if (community.membership_status === 'invited') {
				pixerfApiCommunitySvc.accept_invitations({
					community_ids: [community.id]
				}).$promise.then(function (respone) {
					self.community.membership_status = respone.data.status;
					genTextMembershipStatus(self.community.status);
					systemUtils.digest($scope);
					toastr.success($translate.instant('requested-join-community'));
				}).catch(function (err) {
					if (err && err.data && err.data.data && err.data.data.message) {
						toastr.error(err.data.data.message);
					} else {
						toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
					}
				})
			} else {
				pixerfApiCommunitySvc.join({
					id: community.id
				}, null).$promise.then(function (respone) {
					self.community.membership_status = respone.data.status;
					genTextMembershipStatus(self.community.status);
					systemUtils.digest($scope);
					toastr.success($translate.instant('requested-join-community'));
				}).catch(function (err) {
					if (err && err.data && err.data.data && err.data.data.message) {
						toastr.error(err.data.data.message);
					} else {
						toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
					}
				})
			}
		}

		function onWithdrawRequest(community) {
			$window.event.stopPropagation();
			var confirmMessage = translationSvc.ARE_YOU_SURE_TO_DO_SOMETHING("WITHDRAW_REQUEST_JOIN_THE_COMMUNITY", {
				community: community.name
			});
			var modal = pixerfConfirmPopupSvc.showPopup({
				hideTitle: true,
				hideConfirmText: true,
				message: confirmMessage
			});

			modal.result.then(function () {
				pixerfApiCommunitySvc.withdraw_request({
					community_ids: [community.id]
				}).$promise.then(function (respone) {
					self.community.membership_status = null;
					genTextMembershipStatus(self.community.membership_status);
					systemUtils.digest($scope);
					toastr.success($translate.instant('you-have-withdrawn-successfully'));
				}).catch(function (err) {
					console.log(err);
					toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
				})
			})
		}

		function onManageBtnHovered() {
			self.isHovering = true;
		}

		function onManageBtnLeft() {
			self.isHovering = false;
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('communityExploreTile', communityExploreTile);
	communityExploreTile.$inject = []

	function communityExploreTile() {

		var directive = {
			scope: {
				community: "=",
				onEdited: "&?",
				onMembershipChanged: "&?"
			},
			restrict: 'E',
			templateUrl: 'app/components/community-explore-tile/community-explore-tile.html',
			controller: 'communityExploreTileCtrl',
			controllerAs: 'vm',
			replace: true
		};
		return directive;
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('communityDetailEditCompileTemplateCtrl', communityDetailEditCompileTemplateCtrl);

	communityDetailEditCompileTemplateCtrl.$inject = ['$scope', '$q', 'ISO3166', 'pixerfApiCommunitySvc', 'pixerfUrl', 'uploadCoverPopupSvc', 'systemUtils', 'translationSvc', 'toastr'];

	function communityDetailEditCompileTemplateCtrl($scope, $q, ISO3166, pixerfApiCommunitySvc, pixerfUrl, uploadCoverPopupSvc, systemUtils, translationSvc, toastr) {

		var self = this;
		self.communityCover = {};
		self.community = $scope.community;
		self.newCommunity = {
			id: self.community.id,
			name: self.community.name,
			countries: self.community.countries,
			description: self.community.description,
			rules: self.community.rules,
		};
		self.actionRequiredFields = [];
		self.onClosed = onClosed;
		self.onDescriptionChanged = onDescriptionChanged;
		self.onPrivacyTypeChanged = onPrivacyTypeChanged;
		self.onPostingTypeChanged = onPostingTypeChanged;
		self.onModerationTypeChanged = onModerationTypeChanged;
		self.showUploadCoverPopup = showUploadCoverPopup;
		self.onCancel = onCancel;
		self.onSubmitCommunity = onSubmitCommunity;
		self.onToggleActionRequired = onToggleActionRequired;
		self.onCountriesSelected = onCountriesSelected;
		self.canEditCommunity = self.community.status != 'pending' || (self.community.community_reject_comments && self.community.community_reject_comments.length);
		self.showActionRequiredMessage = self.community.status === 'approve_required';
		self.maxCountries = 3;
		self.uploadCoverOptions = {
			dropzoneConfig: {
				'options': {
					url: pixerfUrl.full + 'api/communities/' + self.community.id,
					method: 'put',
					paramName: 'cover',
					autoProcessQueue: false,
					maxFilesize: 40,
					parallelUploads: 10,
					dictFileTooBig: "File is too big ({{filesize}} MB). Max file size is: {{maxFilesize}} MB.",
				},
				eventHandlers: {
					processing: function (file) {
						self.uploading = true;
					},
					success: function (file, respone) {
						self.uploading = false;
					}
				}
			},
			isManual: true,
			introText: "Choose a photo as your community cover",
			canEdit: true,
			editText: "Change community cover",
			cropper: {
				options: {
					viewport: {
						type: 'square'
					},
					boundary: {
						width: 500,
						height: 160
					},
					showZoomer: false
				}
			}
		};
		self.privacyTypes = [{
				value: false,
				title: "public",
				description: "anyone-can-find-the-group"
			},
			{
				value: true,
				title: "private",
				description: "only-members-can-find-the-group"
			}
		];

		self.postingTypes = [{
				value: 'anyone',
				title: "Anyone in the Community",
				description: "Any member in the Community can start a discussion and reply to the threads."
			},
			{
				value: 'only_admin',
				title: "Only Admin",
				description: "Only admins can start a discussion. Members will only be allowed to reply."
			}
		];

		self.moderationType = [{
				value: true,
				title: "Approval required",
				description: "Admin must approve all posts before they are published. "
			},
			{
				value: false,
				title: "No approval required ",
				description: "Admin does not need to review posts before they are published. "
			}
		];

		self.countriesOpts = {
			"maxOptions": self.maxCountries,
			'noneSelectedText': 'All Countries',
			"container": ".community-detail-edit-compile-template__content__country__dropdown",
			"customAll": true,
			"dropupAuto": false,
			"maxOptionsText": "Please select up to a maximum of " + self.maxCountries + " countries",
		};

		self.defaultPrivacyType = self.privacyTypes[1].value;
		self.defaultPostingType = self.postingTypes[1].value;
		self.defaultModerationType = self.moderationType[0].value;
		self.countries = buildCountries();

		init()

		function init() {
			generateLayout($scope.context);
			convertCreatedDate();
			if (self.community) {
				self.defaultPrivacyType = self.community.is_private;
				self.defaultPostingType = self.community.start_discussion_permission;
				self.defaultModerationType = self.community.moderate_discussions;
			}
			if (self.community && self.community.cover && self.community.cover['original']) {
				self.communityCover.url = self.community.cover['original'];
			}
			if (self.community.start_discussion_permission === 'anyone') {
				self.canConfigmoderation = true;
			}
			if (self.community && self.community.community_reject_comments && self.community.community_reject_comments.length) {
				extractRequiredField();
			}
		}

		function extractRequiredField() {
			self.actionRequiredFields = self.community.community_reject_comments[0].reason.split(",");
			for (var i = 0; i < self.actionRequiredFields.length; i++) {
				self.actionRequiredFields[i] = self.actionRequiredFields[i].trim();
			}
		}

		function generateLayout(context) {
			switch (context) {
				case 'manage':
					self.isShowCancelButton = true;
					self.isShowSubmitButton = true;
					break;
			}
		}

		function convertCreatedDate() {
			self.fomatedDate = moment(self.community.inserted_at).format("MMMM DD, YYYY");
		}

		function onClosed() {
			$scope.onClosed({
				community: self.newCommunity
			});
		}

		function onCancel() {
			self.newCommunity = {};
			onClosed();
		}

		function onSubmitCommunity() {
			self.working = true;
			if (self.dropzoneInstance) {
				self.dropzoneInstance.options.url = pixerfUrl.full + 'api/communities/' + self.community.id;
				self.dropzoneInstance.processQueue();
				self.dropzoneInstance.on("complete", function () {
					updateCommunity();
				})
			} else {
				updateCommunity();
			}
		}

		function updateCommunity() {
			pixerfApiCommunitySvc.update({
				id: self.newCommunity.id
			}, self.newCommunity).$promise.then(function () {
				self.working = false;
				self.community = $.extend(true, self.community, self.newCommunity);
				onClosed();
			}).catch(function (err) {
				self.working = false;
				var errMessage = translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true);
				toastr.error(errMessage);
			})
		}

		function onDescriptionChanged() {}

		function onPrivacyTypeChanged(item) {
			self.newCommunity.is_private = item.value;
		}

		function onPostingTypeChanged(item) {
			self.newCommunity.start_discussion_permission = item.value;
			if (self.newCommunity.start_discussion_permission === 'anyone') {
				self.canConfigmoderation = true;
			} else {
				self.canConfigmoderation = false;
			}
		}

		function onModerationTypeChanged(item) {
			self.newCommunity.moderate_discussions = item.value;
		}

		function showUploadCoverPopup() {
			var popup = uploadCoverPopupSvc.showPopup(self.uploadCoverOptions);

			popup.result.then(function (instance) {
				self.communityCover.url = instance.thumbnail;
				systemUtils.digest($scope);
				self.dropzoneInstance = instance.dropzone;
			})
		}

		function onToggleActionRequired(isOpen) {
			self.isOpenActionRequired = !isOpen;
		}

		function buildCountries() {
			var arr = [{
				id: 'all',
				name: 'All Countries'
			}];
			for (var key in ISO3166.codeToCountry) {
				arr.push({
					id: key,
					name: ISO3166.codeToCountry[key]
				})
			}
			return arr;
		}

		function onCountriesSelected(countriesSelected) {
			if (!self.selectedCountries || !self.selectedCountries.length) {
				delete self.newCommunity.countries;
				self.selectedCountries = [{
					id: 'all',
					name: 'All Countries'
				}];
			} else {
				self.newCommunity.countries = _.pluck(self.selectedCountries, 'id');
			}
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('communityDetailEditCompileTemplate', communityDetailEditCompileTemplate);
	communityDetailEditCompileTemplate.$inject = [];

	function communityDetailEditCompileTemplate() {

		var directive = {
			scope: {
				community: "=",
				onClosed: "&",
				onStatusChanged: "&?",
				context: "@",
				appendToBody: "@?"
			},
			restrict: 'E',
			templateUrl: 'app/components/community-detail-edit-compile-template/community-detail-edit-compile-template.html',
			controller: 'communityDetailEditCompileTemplateCtrl',
			controllerAs: 'vm',
			replace: true
		};
		return directive;
	}

})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('communityDetailCompileTemplateCtrl', communityDetailCompileTemplateCtrl);

	communityDetailCompileTemplateCtrl.$inject = ['$scope', 'actionReqruiedCommunityPopupSvc', '$q', 'alertMessagePopupSvc', 'pixerfApiCommunitySvc', 'sessionManagerSvc', '$window', 'confirmPopupSvc', '$translate', 'ISO3166'];

	function communityDetailCompileTemplateCtrl($scope, actionReqruiedCommunityPopupSvc, $q, alertMessagePopupSvc, pixerfApiCommunitySvc, sessionManagerSvc, $window, confirmPopupSvc, $translate, ISO3166) {

		var USER_CONTROL_ADMINDASHBOARD = ['curator_internal', 'admin_internal', 'marketer_internal'];
		var self = this;
		self.loginedUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.community = $scope.community;
		self.isAdmin = self.loginedUser && (USER_CONTROL_ADMINDASHBOARD.includes(self.loginedUser.role) || self.loginedUser.email === 'marcom@pixerf.com');
		self.isOwner = self.loginedUser && self.loginedUser.id === self.community.owner.id;
		self.onClosed = onClosed;
		self.onActionRequiredCommunity = onActionRequiredCommunity;
		self.onReactivate = onReactivate;
		self.onDeactivate = onDeactivate
		self.onMoveToInReview = onMoveToInReview;
		self.onEditComments = onEditComments;
		self.onDeleteCommunity = onDeleteCommunity;
		self.onApproveCommunity = onApproveCommunity;
		self.communityCountries = 'All';

		init()

		function init() {
			if (self.isAdmin) {
				generateAdminLayout($scope.context);
			} else {
				generateUserLayout($scope.context);
			}

			if(self.community && self.community.countries && self.community.countries.length){
				convertCountries(self.community.countries);
			}
			
			convertCreatedDate();
		}

		function generateAdminLayout(context) {
			switch (context) {
				case 'pending':
					self.isShowActionRequiredButton = true;
					self.isShowAprroveButton = true;
					break;
				case 'action-required':
					self.isShowMoreButton = true;
					self.moreList = [{
						label: 'Edit comments',
						cta: self.onEditComments
					}];
					break;
				case 'active':
					self.isShowMoreButton = true;
					self.moreList = [{
						label: 'Move to in Review',
						cta: self.onMoveToInReview
					}, {
						label: 'Deactivate',
						cta: self.onDeactivate
					}];
					break;
				case 'in-review':
					self.isShowMoreButton = true;
					self.moreList = [{
						label: 'Reactivate',
						cta: self.onReactivate
					}, {
						label: 'Deactivate',
						cta: self.onDeactivate
					}];
					break;
				case 'deactivate':
					self.isShowMoreButton = true;
					self.moreList = [{
						label: 'Reactivate',
						cta: self.onReactivate
					}];
					break;
			}
		}

		function generateUserLayout(context) {
			switch (context) {
				case 'pending':
					self.isShowMoreButton = true;
					self.moreList = [];
					if(self.isOwner){
						self.moreList = [{
							label: 'Delete Community',
							cta: self.onDeleteCommunity
						}];
					}
					break;
				case 'action-required':
					self.isShowMoreButton = true;
					self.moreList = [];
					if(self.isOwner){
						self.moreList = [{
							label: 'Delete Community',
							cta: self.onDeleteCommunity
						}];
					}
					break;
				case 'active':
					self.isShowMoreButton = true;
					self.moreList = [];
					if(self.isOwner){
						self.moreList = [{
							label: 'Delete Community',
							cta: self.onDeleteCommunity
						}];
					}
					break;
			}
		}

		function convertCreatedDate() {
			self.fomatedDate = moment(self.community.inserted_at).format("MMMM DD, YYYY");
		}

		function onClosed() {
			$scope.onClosed({
				community: self.community
			});
		}

		function convertCountries(countries){
			self.communityCountries = Object.values(ISO3166.getCountryNames(countries)).join(", ");
		}

		function onActionRequiredCommunity() {
			actionReqruiedCommunityPopupSvc.showPopup({
				submit: function (data) {
					var def = $q.defer();
					data.community_ids = [self.community.id];
					pixerfApiCommunitySvc.action_required_community(null, data).$promise.then(function (res) {
						self.community = res.data;
						def.resolve(res.data)
					}).catch(function (err) {
						def.reject(err);
					})
					return def.promise;
				},
				submitCallback: function (res) {
					showActionRequiredPopup();
					if ($scope.onStatusChanged) {
						$scope.onStatusChanged({
							community: res
						});
					}
				}
			})
		}

		function onReactivate() {
			prevenPubbleClick();
			pixerfApiCommunitySvc.reactivate_community(null, {
				community_ids: [self.community.id]
			}).$promise.then(function (res) {
				self.community = res.data;
				if ($scope.onStatusChanged) {
					$scope.onStatusChanged({
						community: self.community
					});
				}
			}).catch(function (err) {
				console.log(err);
			})
		}

		function onDeactivate() {
			prevenPubbleClick();
			pixerfApiCommunitySvc.deactivate_community(null, {
				community_ids: [self.community.id]
			}).$promise.then(function (res) {
				self.community = res.data;
				if ($scope.onStatusChanged) {
					$scope.onStatusChanged({
						community: self.community
					});
				}
			}).catch(function (err) {
				console.log(err);
			})
		}

		function onMoveToInReview() {
			prevenPubbleClick();
			pixerfApiCommunitySvc.move_to_in_review(null, {
				community_ids: [self.community.id]
			}).$promise.then(function (res) {
				self.community = res.data;
				if ($scope.onStatusChanged) {
					$scope.onStatusChanged({
						community: self.community
					});
				}
			}).catch(function (err) {
				console.log(err);
			})
		}

		function onEditComments() {
			actionReqruiedCommunityPopupSvc.showPopup({
				community: self.community,
				submit: function (data) {
					var def = $q.defer();
					data.community_ids = [self.community.id];
					pixerfApiCommunitySvc.action_required_community(null, data).$promise.then(function (res) {
						def.resolve(res.data)
					}).catch(function (err) {
						def.reject(err);
					})
					return def.promise;
				},
				submitCallback: function (res) {
					showActionRequiredPopup();
				}
			})
		}

		function showActionRequiredPopup() {
			alertMessagePopupSvc.showPopup({
				windowClass: 'community-list-view__alert-message',
				title: "Comment sent! What do you want to do next?",
				description: "You can find this community under <span class='text--bold text--color-pixerf-theme'>Action Required</span>. You can still edit your commment if owner has not edited and resubmitted their form."
			});
		}

		function prevenPubbleClick() {
			$window.event.stopPropagation();
		}

		function onDeleteCommunity() {
			prevenPubbleClick();

			var confirmMessage = $translate.instant("delete-community-confirm");
			var modal = confirmPopupSvc.showPopup({
				windowClass: 'confirm-action-popup',
				hideTitle: true,
				hideConfirmText: true,
				cancelBtnText: 'Cancel',
				title: confirmMessage
			});
			modal.result.then(function () {
				pixerfApiCommunitySvc.delete({
					id: self.community.id
				}).$promise.then(function (response) {
					if ($scope.onStatusChanged) {
						$scope.onStatusChanged({
							community: self.community
						});
					}
				}, function (err) {});
			})
		}

		function onApproveCommunity() {
			prevenPubbleClick();

			pixerfApiCommunitySvc.approve_community(null, {
				community_ids: [self.community.id]
			}).$promise.then(function (res) {
				alertMessagePopupSvc.showPopup({
					windowClass: 'community-list-view__alert-message',
					title: "Community approved!",
					description: "You can find this community under <span class='text--bold text--color-pixerf-theme'>Active Communities</span>."
				});
				self.community = res.data;
				if ($scope.onStatusChanged) {
					$scope.onStatusChanged({
						community: self.community
					});
				}
			}).catch(function (err) {
				console.log(err);
			})
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('communityDetailCompileTemplate', communityDetailCompileTemplate);
	communityDetailCompileTemplate.$inject = [];

	function communityDetailCompileTemplate() {

		var directive = {
			scope: {
				community: "=",
				onClosed: "&",
				onStatusChanged: "&?",
				context: "@",
				appendToBody: "@?"
			},
			restrict: 'E',
			templateUrl: 'app/components/community-detail-compile-template/community-detail-compile-template.html',
			controller: 'communityDetailCompileTemplateCtrl',
			controllerAs: 'vm',
			replace: true
		};
		return directive;
	}

})();

(function () {

	angular
		.module('pixerf')
		.controller('communityDetailCtrl', communityDetailCtrl);

	communityDetailCtrl.$inject = ['pixerfUrl', 'pixerfApiCommunitySvc', '$scope'];

	function communityDetailCtrl(pixerfUrl, pixerfApiCommunitySvc, $scope) {
		var self = this;
		self.onCommunityMembershipChanged = onCommunityMembershipChanged;
		self.onFilteredClicked = onFilteredClicked;
		self.onSearchStringChanged = _.debounce(onSearchStringChanged, 300);
		self.avatar = {
			url: null
		};
		self.filterSetting = {
			"items": [{
					name: "All",
					value: ""
				},
				{
					name: "Pixerfer",
					value: "pixerfer"
				},
				{
					name: "Ambassador Pro",
					value: "pro"
				},
				{
					name: "Ambassador Maestro",
					value: "maestro"
				}
			]
		};

		self.uploadCommunityAvatarOptions = {
			dropzoneConfig: {
				'options': {
					url: pixerfUrl.full + 'api/users/cover',
				}
			},
			onSuccess: onAvatarUploadSuccess,
			introText: "Choose a photo as your community avatar",
			rulesText: "<h6>Tips:</h6>" +
				"<p>Photo can be in any of the following formats: JPG or PNG.</p>" +
				"<p>Your photo should be square, 400 x 400</p>" +
				"<p>Maximum file size is 10MB</p>"
		};
		if (self.options) {
			self.profileGridOptions = {
				canRemove: self.isManager,
				navigateOnShowAll: self.options.navigateOnShowAll,
				scrollToPaging: self.options.scrollToPaging,
				getter: getMembers,
				onInit: onProfileGridInit,
				deleter: deleteMember
			}
		}

		function buildSearchParams() {
			var searchParams = {
				id: self.community.id,
				page: 1,
				page_size: 8
			};
			if (self.searchString) {
				searchParams.keywords = self.searchString;
			}
			if (self.selectedFilter && self.selectedFilter.value) {
				searchParams.ambassadorship = self.selectedFilter.value;
			}
			return searchParams;
		}

		function onProfileGridInit(instance) {
			self.profileGrid = instance;
			var isFresh = true;
			self.profileGrid.fetch(buildSearchParams(), isFresh);
		}

		function getMembers(param) {
			param.membership = 'accepted';
			return pixerfApiCommunitySvc.get_members(param);
		}

		function deleteMember(userInfo) {
			var param = {
				id: self.community.id,
				user_ids: [],
				emails: []
			}
			param.user_ids.push(userInfo.id);
			return pixerfApiCommunitySvc.remove(param);
		}

		function onAvatarUploadSuccess() {

		}

		function onCommunityMembershipChanged() {

		}

		function onSearchStringChanged() {
			var searchParams = buildSearchParams();
			var isFresh = true;
			self.profileGrid.fetch(searchParams, isFresh);
		}

		function onFilteredClicked() {
			var searchParams = buildSearchParams();
			var isFresh = true;
			self.profileGrid.fetch(searchParams, isFresh);
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.component('communityDetail', {

            bindings: {
                isManager: "=",
                community: '=',
                options: "="
            },
            templateUrl: 'app/components/community-detail/community-detail.html',
            controller: 'communityDetailCtrl as vm',
        });

})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('communityChallengesCarouselCtrl', communityChallengesCarouselCtrl);

	communityChallengesCarouselCtrl.$inject = ['$scope', 'systemUtils'];

	function communityChallengesCarouselCtrl($scope, systemUtils) {

		var self = this;
		self.missions = $scope.missions || [];
		self.onNextSlide = onNextSlide;
		self.onPreviousSlide = onPreviousSlide;

		self.responsive = [{
				breakpoint: 992,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2
				}
			},
			{
				breakpoint: 480,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1
				}
			}
		];

		self.slickSetting = {
			onInit: function (slick) {
				self.slick = slick;
				self.totalSlide = Math.ceil(self.missions.length / self.slick.options.slidesToScroll);
				systemUtils.digest($scope);
			},
			onAfterChange: function (event, slick, currentSlide) {
				self.currentSlide = (currentSlide / slick.options.slidesToScroll + 1);
				if (slick.$slides.length == currentSlide + slick.options.slidesToScroll) {
					self.isLastmissionsSlide = true;
				} else {
					self.isLastmissionsSlide = false;
				}
				systemUtils.digest($scope);
			},
			breakpoint: function(event){
				self.totalSlide = Math.ceil(self.missions.length / self.slick.options.slidesToScroll);
				systemUtils.digest($scope);
			}
		}

		function onNextSlide() {
			self.slick.slickNext();
		}

		function onPreviousSlide() {
			self.slick.slickPrev();
		}
	}
})();

(function () {
	'use strict';

	angular
	  .module('pixerf')
	  .directive('communityChallengesCarousel', communityChallengesCarousel);

	function communityChallengesCarousel() {

	  var directive = {
		scope: {
            missions: "="
		},
		restrict: 'E',
		templateUrl: 'app/components/community-challenges-carousel/community-challenges-carousel.html',
		controller: 'communityChallengesCarouselCtrl',
		controllerAs: 'vm',
		replace: true
	  };
	  return directive;
	}

  })();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('communityChallengeTileCtrl', communityChallengeTileCtrl);

	communityChallengeTileCtrl.$inject = ['$scope', '$state', 'stringUtils'];

	function communityChallengeTileCtrl($scope, $state, stringUtils) {

		var self = this;
		self.mission = $scope.mission;
		self.onChallengeClicked = onChallengeClicked;

		init();

		function init() {
			self.coverPhoto = self.mission ? self.mission.thumbnailPath : 'assets/images/about-challenges/empty-challange.png';
		}

		function onChallengeClicked() {
			if (!self.mission || !self.mission.id) return;

			$state.go('mission-detail-page.brief', {
				id: self.mission.id,
				name: stringUtils.toSnakeCase(self.mission.title)
			});
		}
	}
})();

(function () {
	'use strict';

	angular
	  .module('pixerf')
	  .directive('communityChallengeTile', communityChallengeTile);

	function communityChallengeTile() {

	  var directive = {
		scope: {
            mission: "="
		},
		restrict: 'E',
		templateUrl: 'app/components/community-challenge-tile/community-challenge-tile.html',
		controller: 'communityChallengeTileCtrl',
		controllerAs: 'vm',
		replace: true
	  };
	  return directive;
	}

  })();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.factory('commisionNotAvailablePopupSvc', commisionNotAvailablePopupSvc);
	commisionNotAvailablePopupSvc.$inject = ['$uibModal'];

	function commisionNotAvailablePopupSvc($uibModal) {

		function showPopup(data) {
			return $uibModal.open({
				templateUrl: 'app/components/commision-not-available-popup/commision-not-available-popup.html',
				controller: 'commisionNotAvailablePopupCtrl',
				controllerAs: 'vm',
				animation: true,
				windowClass: 'zindex commision-not-available-screen',
				resolve: {
					'resolveData': function () {
						return data;
					}
				}
			});
		}

		return {
			showPopup: showPopup
		};
	}
})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('commisionNotAvailablePopupCtrl', commisionNotAvailablePopupCtrl);

    commisionNotAvailablePopupCtrl.$inject = ['$uibModalInstance'];

    function commisionNotAvailablePopupCtrl($uibModalInstance) {

		var self = this;
		self.close = close;

		self.message = {
			content: "Interested to launch a Custom Commission? Drop us an email with your contact number at <a href=\"mailto:ask@pixerf.com\" class=\"text--color-black text--bold \">business@pixerf.com</a> and we will get in touch with you!"
		};

		function close(){
            $uibModalInstance.close();
        }
    }
})();
(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('commentListCtrl', commentListCtrl);

	commentListCtrl.$inject = ['$scope', 'pixerfApiMediaSvc', 'toastr', 'pagingUtils', 'sessionManagerSvc', 'translationSvc', 'pixerfApiCustomCommssionsSvc'];

	function commentListCtrl($scope, pixerfApiMediaSvc, toastr, pagingUtils, sessionManagerSvc, translationSvc, pixerfApiCustomCommssionsSvc) {

		var self = this;
		self.comments = null;
		self.newComment = {
			user: sessionManagerSvc.getCurrentLoginUser().data,
			text: ''
		}
		self.settings = {
			'hideIcon': true,
			'hidePerson': $scope.context === 'CUSTOM_COMMISSIONS_PHOTO_POPUP',
			'showPostBtn': $scope.context === 'CUSTOM_COMMISSIONS_PHOTO_POPUP',
			'hideBlankComment': $scope.context === 'CUSTOM_COMMISSIONS_PHOTO_POPUP'
		};
		self.spinner = {
			isVisible: false
		};
		self.isLastPage = true;
		self.page = 1;

		self.onCommentCreated = onCommentCreated;
		self.onCommentDeleted = onCommentDeleted;
		self.getMoreComments = getMoreComments;

		$scope.$watch("targetId", function (newVal, oldVal) {
			var isRefresh = false;
			isRefresh = oldVal && (newVal !== oldVal);
			getComments({
				id: $scope.targetId
			}, isRefresh);
		});

		function getComments(param, isRefresh) {
			self.spinner.isVisible = true;
			if (isRefresh) self.comments = [];
			if ($scope.isCustomCommissions) {
				getCustomCommissionComments(param);
			} else {
				getMediaComments(param);
			}
		}

		function getMoreComments() {
			if (self.spinner.isVisible) {
				return;
			}
			self.page++;
			getComments({
				id: $scope.targetId,
				page: self.page
			});
		}

		function onCommentCreated(newComment) {
			self.comments.unshift(newComment);
			if ($scope.onCommentAdded) $scope.onCommentAdded(newComment);
		}

		function onCommentDeleted(deletedComment) {
			self.comments = _.reject(self.comments, function (cmt) {
				return deletedComment.id === cmt.id;
			});
			if ($scope.onCommentDeleted) $scope.onCommentDeleted(deletedComment);
		}

		function getMediaComments(param) {
			pixerfApiMediaSvc.getComment(param).$promise.then(function (response) {
				self.spinner.isVisible = false;
				if (!self.comments) self.comments = [];
				self.comments = self.comments.concat(response.data);
				self.isLastPage = pagingUtils.isNoMorePageToLoad(self.page, response);
			}).catch(function () {
				self.spinner.isVisible = false;
				toastr.error(translationSvc.FAILED_TO_DO_SOMETHING('FAILED_GET_COMMENTS'));
			})
		}

		function getCustomCommissionComments(param) {
			pixerfApiCustomCommssionsSvc.getCommentsBySubmissionId({
				shoot_id: $scope.shootId,
				id: param.id
			}).$promise.then(function (response) {
				self.spinner.isVisible = false;
				if (!self.comments) self.comments = [];
				self.comments = self.comments.concat(response.data);
				self.isLastPage = pagingUtils.isNoMorePageToLoad(self.page, response);
			}).catch(function () {
				self.spinner.isVisible = false;
				toastr.error(translationSvc.FAILED_TO_DO_SOMETHING('FAILED_GET_COMMENTS'));
			})
		}

	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('commentList', commentList);

	function commentList() {

		var directive = {
			scope: {
				targetId: "=",
				context: "=",
				hideEmptyState: "@?",
				listLabel: "@?",
				isCustomCommissions: "@?",
				shootId: "=?",
				onCommentAdded: '&?',
				onCommentDeleted: '&?',
				inputPlaceholderText: '@',
				noComment: '='
			},
			restrict: 'E',
			templateUrl: 'app/components/comment-list/comment-list.html',
			controller: 'commentListCtrl',
			controllerAs: 'vm',
			replace: true
		};
		return directive;
	}

})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('colBoxIconTextCtrl', colBoxIconTextCtrl);

	colBoxIconTextCtrl.$inject = ['$scope'];

	function colBoxIconTextCtrl($scope) {

		var self = this;
		self.data = $scope.data;
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('colBoxIconText', colBoxIconText);

	function colBoxIconText() {

		var directive = {
			scope: {
				data: "=",
			},
			templateUrl: 'app/components/col-box-icon-text/col-box-icon-text.html',
			restrict: 'E',
			controller: 'colBoxIconTextCtrl',
			controllerAs: 'vm',
			replace: true
		};
		return directive;
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('clientCarouselCtrl', clientCarouselCtrl);

	clientCarouselCtrl.$inject = ['$scope'];

	function clientCarouselCtrl($scope) {

		var self = this;
		self.clients = $scope.data;
	}
})();

(function () {
	'use strict';

	angular
	  .module('pixerf')
	  .directive('clientCarousel', clientCarousel);

	function clientCarousel() {

	  var directive = {
		scope: {
            data: "="
		},
		restrict: 'E',
		templateUrl: 'app/components/client-carousel/client-carousel.html',
		controller: 'clientCarouselCtrl',
		controllerAs: 'vm',
		replace: true
	  };
	  return directive;
	}

  })();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('circleBrandCtrl', circleBrandCtrl);

	circleBrandCtrl.$inject = ['$scope', '$timeout', '$state'];

	function circleBrandCtrl($scope, $timeout, $state) {

		var self = this;
		var mIsCloseBtn = $scope.closeBtn;
		var mRedirectToState = $scope.redirectToState;
		self.onBtnClicked = onBtnClicked;
		self.animationIn = "fadeInRight";
		self.animationOut = "fadeOutRight";

		function onBtnClicked(){
			if(mIsCloseBtn){
				$('.circle-brand__wrapper').addClass(self.animationOut);
				$timeout(function(){
					$('.circle-brand__wrapper').addClass('dont-show');
				}, 1000);
			} else if (mRedirectToState){
				$state.go(mRedirectToState);
			}
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('circleBrand', circleBrand);

	function circleBrand() {

		var directive = {
			scope: {
				data: "=",
				scrollToHide: "@?",
				closeBtn: "@?",
				redirectToState: "@?",
				noHide: "@?",
				ngHref: "@?"
			},
			templateUrl: 'app/components/circle-brand/circle-brand.html',
			restrict: 'E',
			controller: 'circleBrandCtrl',
			controllerAs: 'vm',
			replace: true
		};
		return directive;
	}
})();

(function () {
    'use strict';

    angular
        .module('pixerf')
        .controller('chequeCheckoutBtnCtrl', chequeCheckoutBtnCtrl);

    chequeCheckoutBtnCtrl.$inject = ['$scope', 'pixerfApiCreditPlansSvc', 'creditPlansSvc', 'sessionManagerSvc', '$q', 'messageConst'];

    function chequeCheckoutBtnCtrl($scope, pixerfApiCreditPlansSvc, creditPlansSvc, sessionManagerSvc, $q, messageConst) {

        var self = this;

        var userData = sessionManagerSvc.getCurrentLoginUser().data;
        self.onCheckoutBtnClicked = onCheckoutBtnClicked;
        self.isWorking = false;
        $scope.$on(messageConst.BROADCAST.ACTION_PAY_AFTER_SIGNED, function(event, args) {
            onCheckoutBtnClicked();
        });

        function onError(pixerfPaymentErrorObject) {
            if ($scope.onError) {
                $scope.onError({ pixerfPaymentErrorObject: pixerfPaymentErrorObject });
            }
        }
        function onComplete(data) {
            if ($scope.onComplete) {
                $scope.onComplete(data);
            }
        }
        function onCheckoutBtnClicked() {
            if ($scope.isGuestPayment) {
                $scope.processBeforePay().then(function (params) {
                    var def = $q.defer();
                    var params = { credit_plan_id: creditPlansSvc.getCreditPlan().data.id, by_cheque: true };
                    pixerfApiCreditPlansSvc.post(params).$promise.then(function (response) {
                        def.resolve();
                        onComplete({ data: { balance: response.data.total } });
                    }, function (pixerfPaymentErrorObject) {
                        onError(pixerfPaymentErrorObject.data);
                        def.reject(pixerfPaymentErrorObject.data);
                    });
                    return def.promise;
                })
            }
            var def = $q.defer();
            var params = { credit_plan_id: creditPlansSvc.getCreditPlan().data.id, by_cheque: true };
            pixerfApiCreditPlansSvc.post(params).$promise.then(function (response) {
                def.resolve();
                onComplete({ data: { balance: response.data.total } });
            }, function (pixerfPaymentErrorObject) {
                onError(pixerfPaymentErrorObject.data);
                def.reject(pixerfPaymentErrorObject.data);
            });
            return def.promise;
        }
    }
})();
(function () {
	'use strict';

	angular
	  .module('pixerf')
	  .directive('chequeCheckoutBtn', chequeCheckoutBtn);

	function chequeCheckoutBtn() {

	  var directive = {
		scope: {
			'onComplete': '&',
			'onError': '&',
			'isDisabled': '=',
			'amount': '@',
			'context': '@',
			'processBeforePay': '&?',
			'isGuestPayment':'=?'
		},
		restrict: 'E',
		templateUrl: 'app/components/cheque-checkout-btn/cheque-checkout-btn.html',
		controller: 'chequeCheckoutBtnCtrl',
		controllerAs: 'vm',
		replace: true
	  };
	  return directive;
	}

  })();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('changePasswordCtrl', changePasswordCtrl);

	changePasswordCtrl.$inject = ['$scope', 'editProfileSvc', 'auth0AuthenticationSvc', 'toastr', 'messageAccountConst'];

	function changePasswordCtrl($scope, editProfileSvc, auth0AuthenticationSvc, toastr, messageAccountConst) {

		var self = this;

		$scope.$parent.vm.contextPage = "change-password";
		self.onSaveBtnClicked = onSaveBtnClicked;
        self.onInfoChange = onInfoChange;
		self.changePassword = {
			currentPassword: "",
			newPassword: "",
			newPasswordAgain: ""
		};
        self.currentPasswordError = "no";
        self.newPasswordError = "no";
        self.newPasswordAgainError = "no";

		function onSaveBtnClicked(form) {
			if (!isValidPassword(form)) return;
			auth0AuthenticationSvc.changePassword(self.changePassword).then(function () {
				toastr.success("Your password has been changed!");
				clearAllFields(form);
			}).catch(function () {
				self.currentPasswordError = "Your password is not correct!";
			});
		}

		function isValidPassword(form) {
			form.$setDirty();
			var errMsg = editProfileSvc.validatePassword(form);

			if (form.currentPassword.$error.required) {
				self.currentPasswordError = "Please enter your current password";
			} else {
				self.currentPasswordError = "no";
			}

			if (form.newPassword.$error.required) {
				self.newPasswordError = "Please enter your new password";
			} else if (form.newPassword.$error.pattern) {
				self.newPasswordError = messageAccountConst.error.validation.password.format;
			} else {
				self.newPasswordError = "no";
			}

			if (form.newPasswordAgain.$error.required) {
				self.newPasswordAgainError = "Please re-type your new password";
			} else if (form.newPassword.$modelValue !== form.newPasswordAgain.$modelValue) {
				self.newPasswordAgainError = "Your re-typed password does not match your new password.";
			} else if (form.newPasswordAgain.$error.pattern) {
				self.newPasswordAgainError = messageAccountConst.error.validation.password.format;
			} else {
				self.newPasswordAgainError = "no";
			}

			if (errMsg) return false;

			return true;
		}

		function clearAllFields(form) {
			self.changePassword = {
				currentPassword: "",
				newPassword: "",
				newPasswordAgain: ""
			}
            form.$setPristine();
		}

		function onInfoChange(form) {
            isValidPassword(form);
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.factory('challengePlanSvc', challengePlanSvc);

	challengePlanSvc.$inject = [];

	function challengePlanSvc() {

		var mChallengePlan = {
			data: {
				id: null,
				name: null,
				value: null
			}
		};

		function getChallengePlan() {
			return mChallengePlan;
		}

		function setChallengePlan(value) {
			mChallengePlan.data = value;
		}

		return {
			getChallengePlan: getChallengePlan,
			setChallengePlan: setChallengePlan
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('challengePlanCtrl', challengePlanCtrl);

	challengePlanCtrl.$inject = ['$scope', 'challengePlanSvc', '$state', 'sessionManagerSvc', 'signUpBusinessPopupSvc'];

	function challengePlanCtrl($scope, challengePlanSvc, $state, sessionManagerSvc, signUpBusinessPopupSvc) {

		var self = this;

		self.loginedUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.onChallengePlanClicked = onChallengePlanClicked;
		self.onChallengePlanSelected = onChallengePlanSelected;
		self.onOfferClicked = onOfferClicked;
		self.onBookNow = onBookNow;
		self.onGetAQoute = onGetAQoute;
		self.challengePlans = [];
		self.onGetInTouchClicked = $scope.onGetInTouchClicked;
		var mSelectedPlan = null;

		self.plans = [{
            id: 0,
            name: 'Gold',
            value: '$2,500',
            generalDescription: 'Fully automated and no frills option',
            description: [
                    {icon: 'icon-thin-calendar', value: '30-day contest challenge for photo submissions'},
                    {icon: 'icon-pencil-write', value: '1 challenge theme'},
                    {icon: 'icon-prize', value: 'Award 1 cash prize for best photo'},
                    {icon: 'icon-single-photo', value: 'Licensing of 15 additional photos for editorial or commercial use'},
                    {icon: 'icon-speaker', value: 'Social media promotions'},
                    {icon: 'icon-column-chart', value: 'Post-Challenge performance report'}
                ],
                directly: true,
            },
			{
				id: 1,
				name: 'Platinum',
				value: '$5,000',
				isRecommended: true,
                generalDescription: 'Assisted by account manager and includes social media boosts',
				description: [
                    {icon: 'icon-thin-calendar', value: '45-day contest challenge for photo submissions'},
                    {icon: 'icon-pencil-write', value: '1 challenge theme'},
                    {icon: 'icon-prize', value: 'Award up to 100 cash prizes for best photos'},
                    {icon: 'icon-single-photo', value: 'Licensing of 30 additional photos for editorial or commercial use'},
                    {icon: 'icon-speaker', value: 'Social media promotions with ad spend'},
                    {icon: 'icon-column-chart', value: 'Post-Challenge performance report'},
                    {icon: 'icon-email-active', value: 'Email blasts'},
                    {icon: 'icon-icon-filter', value: 'Curation Support'}
                ],
				directly: true,
			},
			{
				id: 999,
				name: 'Enterprise',
				customDescription: 'Fully customised to fit your campaign needs',
				directly: false,
				isCustom: true,
				mailTo: 'business@pixerf.com?Subject=I\'m%20interested%20to%20purchase%20an%20Enterprise%20PIXERF%20Challenge%20Package',
				description: [
					{icon: 'icon-icon-award-badges', value: 'Exclusive licensing of photo submissions'},
					{icon: 'icon-icon-crown', value: 'Priority ad placements on landing pages'},
					{icon: 'icon-manage-list', value: 'Dedicated account management'}
				]
			}
		]

		function onChallengePlanClicked(challengePlan) {
			onChallengePlanSelected(challengePlan);
			if (self.loginedUser && self.loginedUser.canBuyChallengePlan) {
				$state.go('checkout.challenge-plan.challenge-plan-checkout', {
					id: challengePlan.id
				});
			} else {
				signUpBusinessPopupSvc.showPopup({
					isBiz: true
				});
			}
		}

		function onChallengePlanSelected(challengePlan) {
			if (challengePlan.isSelected) return;
			challengePlan.isSelected = true;
			if (mSelectedPlan) {
				mSelectedPlan.isSelected = false;
			}
			mSelectedPlan = challengePlan;
			if ($scope.onPlanSelected) {
				$scope.onPlanSelected({
					plan: challengePlan
				});
			}
			challengePlanSvc.setChallengePlan(challengePlan);
		}

		function onBookNow(){
			$scope.onButtonClicked();
		}

		function onGetAQoute(){
			$scope.onGetInTouchClicked();
		}

		function onOfferClicked(){
			$scope.onRecommendedClicked();
		}
	}
})();

(function () {
    'use strict';
  
    angular
      .module('pixerf')
      .directive('challengePlan', challengePlan);
  
    function challengePlan() {
  
      var directive = {
        scope: {
            'context': '@?',
            'onPlanSelected': '&',
            'onGetInTouchClicked': '&',
            'onButtonClicked': '&',
            'onRecommendedClicked': '&'
        },
        restrict: 'E',
        templateUrl: 'app/components/challenge-plan/challenge-plan.html',
        replace: true,
        controller: 'challengePlanCtrl',
        controllerAs: 'vm'
      };
      return directive;
    }
  
  })();
  
(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('categorySelectionBtnCtrl', categorySelectionBtnCtrl);

    categorySelectionBtnCtrl.$inject = ['$scope', 'pixerfApiCategorySvc'];

    function categorySelectionBtnCtrl( $scope, pixerfApiCategorySvc) {

        var self = this;
        self.categories = [];
        self.selectedGalleries = [];
        getCategories();

        function getCategories(){
            pixerfApiCategorySvc.get(function(response){
                self.categories = buildCategory(response);
                if($scope.selectedModel){
                    var arr = [];
                    for (var i = 0; i < $scope.selectedModel.length; i ++){
                        var found = _.find(self.categories, function(c){
                            return c.id === $scope.selectedModel[i].id;
                        })
                        if(found) arr.push(found);
                    }
                    $scope.selectedModel = arr;
                }
            });
        }

        self.categoryDropdownSettings = {
            displayProp: 'name', 
            idProp: 'id',
            showCheckAll : false,
            showUncheckAll: true,
            smartButtonMaxItems: 3,
            scrollable: true,
            scrollableHeight: 600,
            buttonClasses: 'multiple-dropdown-selection__btn-dropdown text--truncate text-left'
        };

        self.categoryDropdownSettings = $.extend(true, self.categoryDropdownSettings, $scope.settings);
        function buildCategory(categories){
            var col4 = buildCols(4, categories);
            var col3 = buildCols(3, categories);
            var col2 = buildCols(2, categories);
            var result = col4.concat(col3, col2);
            return result;
        }

        function buildCols(numOfCol, categories){
            var result = [];
            var numberOfItemPerCol = Math.floor(categories.length/numOfCol);
            var remnant = categories.length % numOfCol;
            var builColIdex = 1;
            var numberOfCurrentCol = numberOfItemPerCol;
            if(remnant > 0){
                numberOfCurrentCol++;
                remnant--;
            }
            var rowIndex = builColIdex;
            for(var i = 0; i < categories.length; i++){
                result[i] = Object.assign({}, categories[i])
                result[i].index = rowIndex;
                result[i].itemId = (numOfCol * 10000) + i;
                result[i].class = 'item-col-' + numOfCol;
                result[i].colCount =  numOfCol;
                numberOfCurrentCol--;
                if(numberOfCurrentCol == 0){
                    numberOfCurrentCol = (remnant <= 0) ? numberOfItemPerCol : (numberOfItemPerCol + 1);
                    remnant--;
                    builColIdex++;
                    rowIndex = builColIdex;

                }else{
                    rowIndex = rowIndex + numOfCol;
                }
            }

            return result;
        }
    }
})();
(function () {
  'use strict';

  angular
    .module('pixerf')
    .directive('categorySelectionBtn', categorySelectionBtn);

  function categorySelectionBtn() {

    var directive = {
      scope: {
        "isDisabled" : "=",
        "selectedModel": "=",
        "settings": "="
      },
      restrict: 'E',
      templateUrl: 'app/components/category-selection-btn/category-selection-btn.html',
      controller: 'categorySelectionBtnCtrl',
      controllerAs: 'vm',
      replace: true
    };
    return directive;
  }

})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('caseStudyTileCtrl', caseStudyTileCtrl);

    caseStudyTileCtrl.$inject = ['$scope'];

    function caseStudyTileCtrl($scope) {

        var self = this;
    }
})();

(function () {
	'use strict';

	angular
	  .module('pixerf')
	  .directive('caseStudyTile', caseStudyTile);

	function caseStudyTile() {

	  var directive = {
		scope: {
			"data": "=",
		  "isHoverStyle": "@?"
		},
		restrict: 'E',
		templateUrl: 'app/components/case-study-tile/case-study-tile.html',
		controller: 'caseStudyTileCtrl',
		controllerAs: 'vm',
		replace: true
	  };
	  return directive;
	}

  })();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('caseStudyIntroCtrl', caseStudyIntroCtrl);

	caseStudyIntroCtrl.$inject = ['$scope', 'systemUtils'];

	function caseStudyIntroCtrl($scope, systemUtils) {

		var self = this;
		self.context = $scope.context;
		self.caseStudies = $scope.data;
		self.onNextSlide = onNextSlide;
		self.onPreviousSlide = onPreviousSlide;

		self.slickSetting = {
			onInit: function (slick) {
				self.slick = slick;
				systemUtils.digest($scope);
			},
			onAfterChange: function(){
				systemUtils.digest($scope);
			}
		}

		function onNextSlide() {
			self.slick.slickNext();
		}

		function onPreviousSlide() {
			self.slick.slickPrev();
		}
	}
})();

(function () {
	'use strict';

	angular
	  .module('pixerf')
	  .directive('caseStudyIntro', caseStudyIntro);

	function caseStudyIntro() {

	  var directive = {
		scope: {
            data: "="
		},
		restrict: 'E',
		templateUrl: 'app/components/case-study-intro/case-study-intro.html',
		controller: 'caseStudyIntroCtrl',
		controllerAs: 'vm',
		replace: true
	  };
	  return directive;
	}

  })();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('caseStudyCarouselCtrl', caseStudyCarouselCtrl);

    caseStudyCarouselCtrl.$inject = ['$scope', 'systemUtils'];

    function caseStudyCarouselCtrl($scope, systemUtils) {

		var self = this;
		self.caseStudies = $scope.data || [];

		self.slickConfig = {
			responsive: [{
				breakpoint: 1200,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 3
				}
			}, {
				breakpoint: 1024,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2
				}
			}, {
				breakpoint: 480,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1
				}
			}],
			event: {
				afterChange: function (event) {
					self.currentSlide = Math.ceil(event.currentSlide / event.slick.options.slidesToShow) + 1;
					systemUtils.digest($scope);
				},
				init: function(event){
					self.slideToShow = event.slick.options.slidesToShow;
					self.totalSlideShow = Math.ceil(event.slick.slideCount / event.slick.options.slidesToShow);
					self.currentSlide = Math.ceil(event.slick.currentSlide / event.slick.options.slidesToShow) + 1;
				},
				breakpoint: function(event){
					self.slideToShow = event.slick.options.slidesToShow;
					self.totalSlideShow = Math.ceil(event.slick.slideCount / event.slick.options.slidesToShow);
					systemUtils.digest($scope);
				}
			}
		};
    }
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('caseStudyCarousel', caseStudyCarousel);

	function caseStudyCarousel() {

		var directive = {
			scope: {
				"data": "=",
				"isHoverStyle": "@?",
				"hideDots": "@?"
			},
			restrict: 'E',
			templateUrl: 'app/components/case-study-carousel/case-study-carousel.html',
			controller: 'caseStudyCarouselCtrl',
			controllerAs: 'vm',
			replace: true
		};
		return directive;
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('caseStudiesGridCarouselCtrl', caseStudiesGridCarouselCtrl);

		caseStudiesGridCarouselCtrl.$inject = ['$scope', 'systemUtils', 'carouselPhotoPopupSvc', '$timeout'];

	function caseStudiesGridCarouselCtrl($scope, systemUtils, carouselPhotoPopupSvc, $timeout) {


		var self = this;
		self.onNextSlide = onNextSlide;
		self.onPreviousSlide = onPreviousSlide;
		self.showPhotoPopup = showPhotoPopup;
		self.isActive = isActive;
		self.onNavClicked = onNavClicked;
		self.activeIndex = 0;
		self.mobileData = [];
		self.slideDatas = [{
			id: 1,
			logo: "assets/images/custom-commission-ad/slides/slide-1-logo.png",
			indexShowInfo: 5,
			infoLast: false,
			themeColor: "#dbb688",
			slideInfo: {
				logoUrl: "assets/images/case-studies-grid-carousel/slides/cellini-logo.png",
				header: "Product & Lifestyle Photography",
				desc: "Images to launch a new collection of furniture and furnishings on social media and other promotional collaterals.",
				days: 5,
				PhotosLicensed: 100
			},
			photos: [
				{
					url: "assets/images/case-studies-grid-carousel/slides/slide-1-1-photo.jpg",
					urlMobile: "assets/images/case-studies-grid-carousel/slides/slide-1-1-photo-mobile.jpg",
					name: 'Niharika Iyengar',
					jobDesc: 'Assistant, Digital Engagement',
					desc: 'The process was well planned and executed, and we are happy with the quality of photos delivered.',
					infoPosition: 'bottom-right'
				},
				{
					url: "assets/images/case-studies-grid-carousel/slides/slide-1-2-photo.jpg",
					urlMobile: "assets/images/case-studies-grid-carousel/slides/slide-1-2-photo-mobile.jpg",
				},
				{
					url: "assets/images/case-studies-grid-carousel/slides/slide-1-3-photo.jpg",
					urlMobile: "assets/images/case-studies-grid-carousel/slides/slide-1-3-photo-mobile.jpg",
				},
				{
					url: "assets/images/case-studies-grid-carousel/slides/slide-1-4-photo.jpg",
					urlMobile: "assets/images/case-studies-grid-carousel/slides/slide-1-4-photo-mobile.jpg",
				}
			]
		},
		{
			id: 2,
			logo: "assets/images/custom-commission-ad/slides/slide-2-logo.png",
			indexShowInfo: 5,
			infoLast: true,
			themeColor: "#a4d9ea",
			slideInfo: {
				logoUrl: "assets/images/case-studies-grid-carousel/slides/blackmores-logo.png",
				header: "Product & Lifestyle Photography",
				desc: "Images for a marketing campaign to promote the wellness brand’s new Vitamin E products.",
				days: 2,
				PhotosLicensed: 21
			},
			photos: [
				{
					url: "assets/images/case-studies-grid-carousel/slides/slide-2-1-photo.jpg",
					urlMobile: "assets/images/case-studies-grid-carousel/slides/slide-2-1-photo-mobile.jpg",
				},
				{
					url: "assets/images/case-studies-grid-carousel/slides/slide-2-2-photo.jpg",
					urlMobile: "assets/images/case-studies-grid-carousel/slides/slide-2-2-photo-mobile.jpg",
				},
				{
					url: "assets/images/case-studies-grid-carousel/slides/slide-2-3-photo.jpg",
					urlMobile: "assets/images/case-studies-grid-carousel/slides/slide-2-3-photo-mobile.jpg",
				},
				{
					url: "assets/images/case-studies-grid-carousel/slides/slide-2-4-photo.jpg",
					urlMobile: "assets/images/case-studies-grid-carousel/slides/slide-2-4-photo-mobile.jpg",
				},
				{
					url: "assets/images/case-studies-grid-carousel/slides/slide-2-5-photo.jpg",
					urlMobile: "assets/images/case-studies-grid-carousel/slides/slide-2-5-photo.jpg",
				},
				{
					url: "assets/images/case-studies-grid-carousel/slides/slide-2-2-photo.jpg",
					urlMobile: "assets/images/case-studies-grid-carousel/slides/slide-2-2-photo.jpg",
				}
			]
		},
		{
			id: 3,
			logo: "assets/images/custom-commission-ad/slides/slide-3-logo.png",
			indexShowInfo: 5,
			infoLast: true,
			themeColor: "#ccc96b",
			slideInfo: {
				logoUrl: "assets/images/case-studies-grid-carousel/slides/gurobu-logo.png",
				header: "PROdUCT & BRANDING PHOTOSHOOT",
				desc: "Creating a fresh image library for the branding and marketing of sporting goods brand, Gurobu.",
				days: 4,
				PhotosLicensed: 800
			},
			photos: [
				{
					url: "assets/images/case-studies-grid-carousel/slides/slide-3-1-photo.jpg",
					urlMobile: "assets/images/case-studies-grid-carousel/slides/slide-3-1-photo-mobile.jpg",
				},
				{
					url: "assets/images/case-studies-grid-carousel/slides/slide-3-2-photo.jpg",
					urlMobile: "assets/images/case-studies-grid-carousel/slides/slide-3-2-photo-mobile.jpg",
				},
				{
					url: "assets/images/case-studies-grid-carousel/slides/slide-3-3-photo.jpg",
					urlMobile: "assets/images/case-studies-grid-carousel/slides/slide-3-3-photo-mobile.jpg",
				},
				{
					url: "assets/images/case-studies-grid-carousel/slides/slide-3-4-photo.jpg",
					urlMobile: "assets/images/case-studies-grid-carousel/slides/slide-3-4-photo-mobile.jpg",
				},
				{
					url: "assets/images/case-studies-grid-carousel/slides/slide-3-5-photo.jpg",
					urlMobile: "assets/images/case-studies-grid-carousel/slides/slide-3-5-photo.jpg",
				},
				{
					url: "assets/images/case-studies-grid-carousel/slides/slide-3-6-photo.jpg",
					urlMobile: "assets/images/case-studies-grid-carousel/slides/slide-3-6-photo.jpg",
				}
			]
		},
		{
			id: 4,
			logo: "assets/images/custom-commission-ad/slides/slide-3-logo.png",
			indexShowInfo: 5,
			infoLast: true,
			themeColor: "#ccc96b",
			slideInfo: {
				logoUrl: "assets/images/case-studies-grid-carousel/slides/peoples-association-logo.png",
				header: "LIFESTYLE & BRANDING SHOOT",
				desc: "Video shoots for a series of virtual courses and multi-location photoshoots for images for use in the brand’s app and website.",
				days: 11,
				PhotosLicensed: 342
			},
			photos: [
				{
					url: "assets/images/case-studies-grid-carousel/slides/slide-4-1-photo.jpg",
					urlMobile: "assets/images/case-studies-grid-carousel/slides/slide-4-1-photo-mobile.jpg",
				},
				{
					url: "assets/images/case-studies-grid-carousel/slides/slide-4-2-photo.jpg",
					urlMobile: "assets/images/case-studies-grid-carousel/slides/slide-4-2-photo-mobile.jpg",
				},
				{
					url: "assets/images/case-studies-grid-carousel/slides/slide-4-3-photo.jpg",
					urlMobile: "assets/images/case-studies-grid-carousel/slides/slide-4-3-photo-mobile.jpg",
				},
				{
					url: "assets/images/case-studies-grid-carousel/slides/slide-4-4-photo.jpg",
					urlMobile: "assets/images/case-studies-grid-carousel/slides/slide-4-4-photo-mobile.jpg",
				},
				{
					url: "assets/images/case-studies-grid-carousel/slides/slide-4-5-photo.jpg",
					urlMobile: "assets/images/case-studies-grid-carousel/slides/slide-4-5-photo.jpg",
				},
				{
					url: "assets/images/case-studies-grid-carousel/slides/slide-4-6-photo.jpg",
					urlMobile: "assets/images/case-studies-grid-carousel/slides/slide-4-6-photo.jpg",
				},
				{
					url: "assets/images/case-studies-grid-carousel/slides/slide-4-7-photo.jpg",
					urlMobile: "assets/images/case-studies-grid-carousel/slides/slide-4-7-photo.jpg",
				},
				{
					url: "assets/images/case-studies-grid-carousel/slides/slide-4-8-photo.jpg",
					urlMobile: "assets/images/case-studies-grid-carousel/slides/slide-4-8-photo.jpg",
				},
				{
					url: "assets/images/case-studies-grid-carousel/slides/slide-4-9-photo.jpg",
					urlMobile: "assets/images/case-studies-grid-carousel/slides/slide-4-9-photo.jpg",
				},
				{
					url: "assets/images/case-studies-grid-carousel/slides/slide-4-10-photo.jpg",
					urlMobile: "assets/images/case-studies-grid-carousel/slides/slide-4-10-photo.jpg",
				}
			]
		},
		{
			id: 5,
			logo: "assets/images/custom-commission-ad/slides/slide-3-logo.png",
			indexShowInfo: 5,
			infoLast: true,
			themeColor: "#ccc96b",
			slideInfo: {
				logoUrl: "assets/images/case-studies-grid-carousel/slides/petronas-logo.png",
				header: "COMMERCIAL, OUT-OF-HOME PHOTOSHOOT",
				desc: "Multi-state, multi-creator photoshoot for a national campaign capturing images across Malaysia.",
				days: 8,
				PhotosLicensed: 83
			},
			photos: [
				{
					url: "assets/images/case-studies-grid-carousel/slides/slide-5-1-photo.jpg",
					urlMobile: "assets/images/case-studies-grid-carousel/slides/slide-5-1-photo-mobile.jpg",
				},
				{
					url: "assets/images/case-studies-grid-carousel/slides/slide-5-2-photo.jpg",
					urlMobile: "assets/images/case-studies-grid-carousel/slides/slide-5-2-photo-mobile.jpg",
				},
				{
					url: "assets/images/case-studies-grid-carousel/slides/slide-5-3-photo.jpg",
					urlMobile: "assets/images/case-studies-grid-carousel/slides/slide-5-3-photo-mobile.jpg",
				},
				{
					url: "assets/images/case-studies-grid-carousel/slides/slide-5-4-photo.jpg",
					urlMobile: "assets/images/case-studies-grid-carousel/slides/slide-5-4-photo-mobile.jpg",
				},
				{
					url: "assets/images/case-studies-grid-carousel/slides/slide-5-5-photo.jpg",
					urlMobile: "assets/images/case-studies-grid-carousel/slides/slide-5-5-photo.jpg",
				},
				{
					url: "assets/images/case-studies-grid-carousel/slides/slide-5-6-photo.jpg",
					urlMobile: "assets/images/case-studies-grid-carousel/slides/slide-5-6-photo.jpg",
				}
			]
		}
		];
		self.slickSetting = {
			onInit: function (slick) {
				self.slick = slick;
				systemUtils.digest($scope);
			}
		}

		function onNextSlide() {
			self.slick.slickNext();
		}

		function onPreviousSlide() {
			self.slick.slickPrev();
		}

		function buildMobileData(){
			self.mobileData = [];
			for(var i = 0; i < self.slideDatas.length; i++){
				for(var j = 0; j < (self.slideDatas[i].photos).length; j++){
					self.mobileData.push(self.slideDatas[i].photos[j])
				}
			}
		}

		function showPhotoPopup(photo){
			carouselPhotoPopupSvc.showPopup({
				windowClass: 'stay-home-stay-creative',
				data: photo
			});
		}

		function isActive(index){
			return index == self.activeIndex;
		}

		function onNavClicked(index){
			$('.case-Studies-grid-carousel__slick').slick('slickGoTo', index);
			self.activeIndex = index;
		}

		init();

		function init() {
			buildMobileData();
			$timeout(function(){
				onNavClicked(0);
			}, 100)
			$('.case-Studies-grid-carousel__slick').on('afterChange', function(event, slick, currentSlide, nextSlide){
				self.activeIndex = currentSlide;
				$scope.$apply()
			  });
		}



	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('caseStudiesGridCarousel', caseStudiesGridCarousel);

	function caseStudiesGridCarousel() {

		var directive = {
			scope: {
				data: "="
			},
			templateUrl: 'app/components/case-Studies-grid-carousel/case-Studies-grid-carousel.html',
			restrict: 'E',
			controller: 'caseStudiesGridCarouselCtrl',
			controllerAs: 'vm',
			replace: true
		};
		return directive;
	}

})();

(function () {
    'use strict';

    angular
        .module('pixerf')
        .controller('cartItemCtrl', cartItemCtrl);

    cartItemCtrl.$inject = ['$scope', '$filter'];

    function cartItemCtrl($scope, $filter) {
        var self = this;
        self.onVariantSelected = onVariantSelected;
        self.getReleaseInfo = getReleaseInfo;
        self.getLicenseType = getLicenseType;

        function onVariantSelected(evt, variant) {
            if ($scope.onCartItemModified) {
                $scope.onCartItemModified({ evt: evt, item: $scope.item });
            }
        }
        function getReleaseInfo(media) {
            if (media.license === "commercial" && media.has_model_property && media.status === "approved") {
                return $filter("translate")('model-property-released');
            }
            return $filter("translate")('no-release-required');

        }
        function getLicenseType(media) {
            return media.license === "commercial" && ((media.has_model_property && media.status === "approved") || !media.has_model_property) ? 'Commercial' : 'Editorial';
        }

    }
})();

(function () {
  'use strict';

  angular
    .module('pixerf')
    .directive('cartItem', cartItem);

  function cartItem() {

    var directive = {
      scope: {
        item: '=',
        onRemoveCartBtnClicked: '&',
        onCartItemModified: '&',
        isDisabled: '='
      },
      restrict: 'E',
      templateUrl: 'app/components/cart-item/cart-item.html',
      controller: 'cartItemCtrl',
      controllerAs: 'vm',
      replace: true
    };
    return directive;
  }

})();

(function () {
  'use strict';

  angular
    .module('pixerf')
    .factory('cartSvc', cartSvc);

  cartSvc.$inject = ['pixerfApiCartSvc', 'toastr', '$q', '$translate' , 'translationSvc', 'sessionManagerSvc', 'store', 'accountConst'];

  function cartSvc(pixerfApiCartSvc, toastr, $q, $translate, translationSvc, sessionManagerSvc, store, accountConst) {

    var mCart = {
        data: {
            cart_items: [],
            total: 0
        }
    };

    function getCart() {
      return mCart;
    }

    function setCart(value) {
      mCart.data = value;
    }

    function fetchCart(guestUserToken) {
        var def = $q.defer();
        var guestUserTokenFromStore = store.get(accountConst.TOKEN.GUEST_USER_TOKEN);
        if(!guestUserToken && guestUserTokenFromStore) {
            guestUserToken = store.get(accountConst.TOKEN.GUEST_USER_TOKEN);
        }

        pixerfApiCartSvc.get(buildGuestUuidParam(guestUserToken)).$promise.then(function(response){
            mCart.data = response.data;
            def.resolve(response);
        }, function(error){
            def.reject(error);
        });
        return def.promise;
    }

    function removeItem(cartItem){
        mCart.data.cart_items = _.reject(mCart.data.cart_items, function(item){
            return item.id === cartItem.id;
        });
        mCart.data.total -= cartItem.sub_total;

    }
    function removeItemFromCart(cartItem) {
        var def = $q.defer();
        var mLoginnedUser = sessionManagerSvc.getCurrentLoginUser().data;
        var guestUserToken = null;
        var queryParam = {'id': cartItem.id};
        if (!mLoginnedUser) {
            guestUserToken = store.get(accountConst.TOKEN.GUEST_USER_TOKEN);
            queryParam = Object.assign({}, queryParam, buildGuestUuidParam(guestUserToken));
        }

        pixerfApiCartSvc.delete(queryParam).$promise.then(function (response) {
            removeItem(cartItem);
            toastr.success($translate.instant("photo-successful-remove-from-cart", {name: cartItem.media.title}));
            def.resolve(response);
        }, function (err) {
            if(err.status !== 404){
                console.log(err);
                toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
            } else {
                removeItem(cartItem);
            }
            def.reject(err);
        })
        return def.promise;
    }
    function buildGuestUuidParam(uuid){

        return uuid ? {'guest_id': uuid} : {};
    }

    function addItemToCart(savedCartItemData, guestUserId){
        var def = $q.defer();
        
        pixerfApiCartSvc.post(buildGuestUuidParam(guestUserId), savedCartItemData).$promise.then(function(response){
            var justAddedItem = _.find(response.data.cart_items, function(item){
                return item.media.id === savedCartItemData.media_id;
            });
            mCart.data.cart_items.unshift(justAddedItem);
            mCart.data.total = response.data.total;
            def.resolve(justAddedItem);
        }, function(err){
            def.reject(err);
        });
        return def.promise;
    }
    function getCartItemById(cart, id){
        if(!cart) cart = mCart.data;
        return _.find(cart.cart_items, function(item){
            return item.id === id;
        })
    }
    function getCartItemByMediaId(cart, id){
        if(!cart) cart = mCart.data;
        return _.find(cart.cart_items, function(item){
            return item.media.id === id;
        })
    }
    function updateItemInCart(cartItem, guestUserId){
        var def = $q.defer();

        pixerfApiCartSvc.put(buildGuestUuidParam(guestUserId), cartItem).$promise.then(function(response){
            mCart.data.total = response.data.total;
            def.resolve(response);
        }, function(err){
            def.reject(err);
        });
        return def.promise;
    }

    function reset() {
        mCart.data = {
            cart_items: [],
            total: 0
        };
    }
    function resetCartValidity(items){
        for(var i = 0; i < items.length; i ++){
            items[i].is_invalid = false;
        }
    }
    function checkGuestUserId(uuid) {
        var def = $q.defer();
        pixerfApiCartSvc.checkGuestUserId({ uuid: uuid }).$promise.then(
            function (response) {
                def.resolve();
            }, function (err) {
                def.reject(err);
            }
        )
        return def.promise;
    }
    function generateUUID( count, callback, param) {
        if(count <= 0){
            return;
        }
        var uuid = sessionManagerSvc.uuid();
        checkGuestUserId(uuid).then(
            function(response) {
                console.log(uuid);
                if(callback) callback(uuid, param);
            },
            function(err) {
                generateUUID(--count, callback, param)
            }
        )
    }
    return {
        getCart: getCart,
        setCart: setCart,
        fetchCart: fetchCart,
        removeItem: removeItem,
        removeItemFromCart: removeItemFromCart,
        updateItemInCart: updateItemInCart,
        addItemToCart: addItemToCart,
        getCartItemById: getCartItemById,
        getCartItemByMediaId: getCartItemByMediaId,
        reset: reset,
        resetCartValidity: resetCartValidity,
        checkGuestUserId: checkGuestUserId,
        generateUUID: generateUUID
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('pixerf')
    .controller('cartCtrl', cartCtrl);

  cartCtrl.$inject = ['$scope', 'cartSvc', 'pagingUtils', 'toastr'];

  function cartCtrl($scope, cartSvc, pagingUtils, toastr) {

    var self = this;

    self.onCartItemClicked = onCartItemClicked;
    self.onRemoveItemClicked = onRemoveItemClicked;
    self.isWorking = false;
    self.spinner = {
      isVisible: false
    };
    self.cart = cartSvc.getCart();

    function onCartItemClicked(params) {
      if ($scope.onCartItemClicked) {
        $scope.onCartItemClicked(params);
      }
    }

    function fetchCart(isFresh) {
      self.spinner.isVisible = true;
      if (isFresh) self.cart.data.cart_items = [];
      cartSvc.fetchCart().then(function (response) {
        self.spinner.isVisible = false;
      }, function () {
        toastr.error('failed to get cart item list');
        self.spinner.isVisible = false;
      });
    }

    function onRemoveItemClicked($event, cartItem) {
        if(self.isWorking) return;
        var isExist = cartSvc.getCartItemById(self.cart.data, cartItem.id);
        if(!isExist) return;
        self.isWorking = true;
        cartSvc.removeItemFromCart(cartItem).then(function(response){
            self.isWorking = false;
            if($scope.onCartItemRemoved) $scope.onCartItemRemoved();
        }, function(){
            self.isWorking = false;
        });
        $event.stopPropagation();
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('pixerf')
    .directive('cart', cart);

  function cart() {

    var directive = {
      scope: {
        'items': '=',
        'onCartItemClicked': '&',
        'onCartItemRemoved': '&?'
      },
      templateUrl: 'app/components/cart/cart.html',
      restrict: 'E',
      controller: 'cartCtrl',
      controllerAs: 'vm',
      replace: true
    };
    return directive;
  }

})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.factory('carouselPhotoPopupSvc', carouselPhotoPopupSvc);
		carouselPhotoPopupSvc.$inject = ['$uibModal'];

	function carouselPhotoPopupSvc($uibModal) {

		function showPopup(data) {
			return $uibModal.open({
				templateUrl: 'app/components/carousel-photo-popup/carousel-photo-popup.html',
				controller: 'carouselPhotoPopupCtrl',
				controllerAs: 'vm',
				animation: true,
				windowClass: 'zindex carousel-photo-popup ' + data.windowClass,
				backdropClass:'carousel-photo-popup-backdrop',
				resolve: {
					'resolveData': function () {
						return data;
					}
				}
			});
		}

		return {
			showPopup: showPopup
		};
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('carouselPhotoPopupCtrl', carouselPhotoPopupCtrl);

		carouselPhotoPopupCtrl.$inject = ['$uibModalInstance', 'resolveData', '$timeout', '$rootScope'];

	function carouselPhotoPopupCtrl($uibModalInstance, resolveData, $timeout, $rootScope) {

		var self = this;
		self.close = close;
		self.photo = resolveData.data;

		function close() {
			$uibModalInstance.close();
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('canCreateCommunityBtnCtrl', canCreateCommunityBtnCtrl);

	canCreateCommunityBtnCtrl.$inject = ['$scope', 'pixerfApiUserSvc', 'toastr', 'sessionManagerSvc', 'pixerfConfirmPopupSvc', 'translationSvc'];

	function canCreateCommunityBtnCtrl($scope, pixerfApiUserSvc, toastr, sessionManagerSvc, pixerfConfirmPopupSvc, translationSvc) {

		var self = this;
		self.isLoginedUser = sessionManagerSvc.getCurrentLoginUser();
		self.isWorking = false;
		self.onSuggestClicked = onSuggestClicked;
		self.onMouseOver = onMouseOver;
		self.onMouseLeave = onMouseLeave;
		self.isHovering = false;
		self.btnLabel = "Can Create Community";

		function onSuggestClicked() {
			if (self.isWorking) return;
			self.isWorking = true;
			if (!$scope.user.can_create_community) {
				var pixerfConfirmPopup = pixerfConfirmPopupSvc.showPopup({
					hideTitle: true,
					hideConfirmText: true,
					message: "Are you sure you want to set this user can create community?",
					okFn: function () {
						return pixerfApiUserSvc.toogle_can_create_community({
							id: $scope.user.id,
						}, null).$promise.then(
							function success() {
								$scope.user.can_create_community = true;
							},
							function err() {
								toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
							}
						);
					},
					okFnCallback: function () {
						self.isWorking = false;
						if ($scope.onStatusChanged) $scope.onStatusChanged({
							status: $scope.user.can_create_community
						});
						toastr.success("This user can create community!");
						self.isHovering = false;
					}
				})

				pixerfConfirmPopup.result.then(function () {}, function () {
					self.isWorking = false;
				});

			} else {
				pixerfApiUserSvc.toogle_can_create_community({
					id: $scope.user.id
				}, null).$promise.then(function (respone) {
					self.isWorking = false;
					$scope.user.can_create_community = false;
					if ($scope.onStatusChanged) $scope.onStatusChanged({
						status: $scope.user.can_create_community
					});
					toastr.success("This user cannot create community!");
					self.isHovering = false;
				}, function () {
					self.isWorking = false;
					toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
				})
			}
		}

		function onMouseOver() {
			if (!$scope.user.can_create_community) return;
			self.isHovering = true;
		}

		function onMouseLeave() {
			self.isHovering = false;
			if (!$scope.user.can_create_community) return;
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('canCreateCommunityBtn', canCreateCommunityBtn);

	function canCreateCommunityBtn() {

		var directive = {
			scope: {
				"user": "=",
				"onStatusChanged": "&"
			},
			restrict: 'E',
			templateUrl: 'app/components/can-create-community-btn/can-create-community-btn.html',
			controller: 'canCreateCommunityBtnCtrl',
			controllerAs: 'vm',
			replace: true
		};
		return directive;
	}

})();

(function () {
  'use strict';

  angular
    .module('pixerf')
    .directive('callToActionMessages', callToActionMessages);

  function callToActionMessages() {

    var directive = {
      scope: {
        "messages" : "="
      },
      restrict: 'E',
      templateUrl: 'app/components/call-to-action-messages/call-to-action-messages.html',
      replace: true
    };
    return directive;
  }

})();

(function () {
  'use strict';

  angular
    .module('pixerf')
    .directive('bulkEditPhotoPreview', bulkEditPhotoPreview);

  function bulkEditPhotoPreview() {

    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/bulk-edit-photo-preview/bulk-edit-photo-preview.html',
      controllerAs: 'vm',
      replace: true
    };
    return directive;
  }

})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .directive('uploadPhotoPreviewSwapDimension', uploadPhotoPreviewSwapDimension);
    uploadPhotoPreviewSwapDimension.$inject = ['$parse', 'pathUtils'];

    function uploadPhotoPreviewSwapDimension($parse, pathUtils) {
        return function(scope, element, attrs) {
            scope.$watch(attrs.uploadPhotoPreviewSwapDimension, function (rotateDegrees) {
                var $element = $(element);
                var $overlay = $element.find(".upload-photo-preview__overlay");
                var width = $overlay.width();
                var height = $overlay.height();
                $overlay.width(height);
                $overlay.height(width);
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .directive('uploadPhotoPreviewScale', uploadPhotoPreviewScale);
    uploadPhotoPreviewScale.$inject = ['$parse', 'pathUtils'];

    function uploadPhotoPreviewScale($parse, pathUtils) {
        return function(scope, element, attrs) {
            var $element = $(element);
            var $img = $element.find("img");
            var $overlay = $element.find(".upload-photo-preview__overlay");

            $img.on('bestfit', function() {
                $overlay.width($img.width());
                $overlay.height($img.height());
            }).on('load', function() {
                $(this).trigger('bestfit');
            }).trigger('bestfit');
        }
    }
})();

(function(){
  'use strict';
  angular
    .module('pixerf')
    .factory('bulkEditPhotoPopupSvc', bulkEditPhotoPopupSvc);
    bulkEditPhotoPopupSvc.$inject = ['toastr', 'pixerfApiMissionSvc', 'arrayUtils','numberUtils', '$window', '$q','resendVerificationEmailPopupSvc','editProfileSvc','agreementPopupSvc','sessionManagerSvc', 'pixerfApiMediaSvc', 'pixerfApiCategorySvc', 'verifiedBusinessUserPopupSvc', 'fileUtils', '$uibModal', 'translationSvc'];

    function bulkEditPhotoPopupSvc(toastr, pixerfApiMissionSvc, arrayUtils, numberUtils, $window, $q, resendVerificationEmailPopupSvc, editProfileSvc, agreementPopupSvc, sessionManagerSvc, pixerfApiMediaSvc, pixerfApiCategorySvc, verifiedBusinessUserPopupSvc, fileUtils, $uibModal, translationSvc){

        var mFiles = {
            data: []
        };
        var mAddedBufferFiles = {
            data: []
        };
        var mSelectedFiles = {
            data: []
        };
        var mCategories = {data: []};

        var isFullscreenDropzone = {
            data: false
        };

        var mOverlay = {
            data: false
        };
        var mUploadModal = {data: null};

        var dragPhotoEvent = {

            over: function(overlay){
                //mOverlay.data = overlay;
                if(!mUploadModal.data) return;
                //setOverlay(true)
                isFullscreenDropzone.data = true;
            },
            leave: function(overlay){
                isFullscreenDropzone.data = false;
                //setOverlay(false);
            }
        };
        function setOverlay(status){
            mOverlay.data.visible = status;
        }
        function getUploadModal(){
            return mUploadModal;
        }

        function getCategories(){
            pixerfApiCategorySvc.get(function(response){
                mCategories.data = response;
            }, function(){

            });
        }
        function getSelectedFiles(){
            return mSelectedFiles;
        }
        function showPopup(data){

            mUploadModal.data = $uibModal.open({
                size: 'full',
                templateUrl: 'app/components/bulk-edit-photo-popup/bulk-edit-photo-popup.html',
                controller: 'bulkEditPhotoPopupCtrl',
                controllerAs: 'vm',
                openedClass: 'bulk-edit-photo-popup-modal',
                resolve: {
                    popupData: function(){
                        var def = $q.defer();
                        if(data && data.mission){
                            pixerfApiMissionSvc.get_participations({id: data.mission.id, type: 'self'}).$promise.then(function(response){
                                data.mission.submittedPhotos = response.data;
                                def.resolve(data);
                            }, function(){
                                def.reject(data);
                                toastr.error("Failed to get your submitted entries! Please try again!");
                            });
                        } else{
                            def.resolve(data);
                        }
                        return def.promise;
                    }
                }
            });

            mUploadModal.data.result.then(function() {

            }, function() {

            });
        }
        function runFakeProgress(file){

            file.fakeProgressInterval = $window.setInterval(function(){
                if(file.upload.progress >= 99){
                    $window.clearInterval(file.fakeProgressInterval);
                    delete file.fakeProgressInterval;
                    return;
                }
                var leftleft  = 99 - file.upload.progress;
                var step = numberUtils.getRandomInRange(1, leftleft);
                var progress = step + file.upload.progress;
                updateProgress(file, progress);
            }, 1000);

        }
        function showUploadModal(data) {
            var loginUser = sessionManagerSvc.getCurrentLoginUser().data;
            if(loginUser.is_email_verified){
                if(!loginUser.is_contributor_agreement_accepted){
                    var modal = agreementPopupSvc.showPopup({
                        message: 'i-agree-contributor-agreement',
                        okFn: function(isAgree, isWorking){
                            var def = $q.defer();
                            loginUser = sessionManagerSvc.getCurrentLoginUser().data;
                            loginUser.is_contributor_agreement_accepted = true;
                            sessionManagerSvc.setCurrentLoginUser(loginUser);
                            editProfileSvc.updateUser(loginUser).then(function(){
                                modal.close();
                                def.resolve(showPopup(data));
                            }, function(){
                                toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
                                def.reject();
                            });
                            return def.promise;
                        }
                    })
                } else {
                    showPopup(data);
                }
            } else {
                if(loginUser.isBiz){
                    verifiedBusinessUserPopupSvc.showPopup();
                } else {
                    resendVerificationEmailPopupSvc.showVerifyEmailPopup();
                }
            }

        }
        function showGoogleMapPicker(){
            $("#location-picker").locationpicker({
                location: {
                        latitude: 46.15242437752303,
                        longitude: 2.7470703125
                },
                inputBinding: {
                    locationNameInput: $('#location-input')
                },
                radius: 300,
                enableAutocomplete: true,
                autocompleteOptions: {

                }
            })
        }
        function showExitConfirmModal(callbackFn){
            var exitUploadConfirmModal = $uibModal.open({
              size: 'small',
              templateUrl: 'app/components/upload-photo-exit-confirm/upload-photo-exit-confirm.html',
              controller: 'uploadPhotoExitConfirmCtrl',
              controllerAs: 'vm',
              openedClass: 'confirm-exit-popup'
            });
            return exitUploadConfirmModal;
        }
        function getUploadPhotoSvc(){
            return mFiles;
        }
        function updateProgress(file, progress){
            var updatingFile = _.find(mFiles.data, function(itFile){
                return itFile.filename === file.filename;
            })
            if(updatingFile){
                updatingFile.upload.progress = progress;
            }
        }
        function updateThumbnail(file, thumbnail){
            var updatingFile = _.find(mFiles.data, function(itFile){
                return itFile.filename === file.filename;
            })
            if(updatingFile){
                updatingFile.thumbnail = thumbnail;
            }
        }
        function isFileDirty(file){
            return file.license ||
                file.location ||
                file.description ||
                (file.categories && file.categories.length > 0) ||
                (file.tags &&
                file.tags.length > 0) ||
                (file.galleries &&
                file.galleries.length > 0);
        }
        function updateFileInfo(updatingFile, fileInfo){
            if(updatingFile){
                updatingFile.key = fileInfo.key;
                updatingFile.username = fileInfo.username;
                updatingFile.inserted_at = fileInfo.inserted_at;
                updatingFile.title = fileInfo.filename;
                updatingFile.handle = fileInfo.handle;
                updatingFile.license = fileInfo.license;
            }
        }
         function setThumbnail(files){
            for (var i = 0; i < files.length; i ++){
                files[i].thumbnail = files.url;
            }
        }
        function removeFileFromSelectedFiles(fileName){
            mSelectedFiles.data = _.reject(mSelectedFiles.data, function(file){
                if(file.filename === fileName){
                    file.isSelected = false;
                    return true;
                }
            });
        }
        function getFileByName(pixerfFile){
            return _.find(mFiles.data, function(f){
                return f.filename === pixerfFile.filename;
            });
        }
        function removeUploadedFile(index){
            deletePhoto(mFiles.data[index]);
            removeFileFromSelectedFiles(mFiles.data[index].filename);
            mFiles.data.splice(index, 1);
        }
        function deletePhoto(photo){
			pixerfApiMediaSvc.delete({id: photo.id});
		}
        function removeFileByName(fileName){
            removeFileFromSelectedFiles(fileName);
            mFiles.data = _.reject(mFiles.data, function(file){
                return file.filename === fileName;
            })
        }
        function replaceFileByName(fileName, newElement){
            var index = arrayUtils.indexOf(mFiles.data, function(it){
                return it.filename === fileName;
            });
            mFiles.data[index] = newElement;

        }
        function setSelectedFiles(files, isSelected){
            for (var i = 0; i < files.length; i ++){
                files[i].isSelected = isSelected;
            }
        }
        function isSameFile(fileOne, fileTwo){
            return fileOne.filename === fileTwo.filename &&
                fileOne.size === fileTwo.size ;

        }
        function isFileExisted(files, file, isInclusiveErrorFile){
            var isExisted = _.find(files, function(f){
                return isInclusiveErrorFile ? isSameFile(f, file) : !f.pixerfError && isSameFile(f, file) ;
            })
            return isExisted;
        }
        function isPriceSet(files){
            var isExisted = _.find(files, function(f){
                return f.price && f.price.id ;
            })
            return isExisted;
        }
        function addFile(file){
            var isExisted = isFileExisted(mFiles.data, file, true);
            if(isExisted) {
                if(!isExisted.pixerfError){
                    return isExisted;
                } else {
                    replaceFileByName(isExisted.filename, file);
                }
            } else {
                mFiles.data.unshift(file);
            }
        }
        function getDuplicatedFiles(exisingFiles, willBeAddedFiles){
            var arr = [];
            for (var i = 0; i < willBeAddedFiles.length; i ++){
                if(isFileExisted(exisingFiles, willBeAddedFiles[i])){
                    arr.push(willBeAddedFiles[i]);
                }
            }
            return arr;
        }
        function addFiles(files){
            mFiles.data = files;
        }
        function selectAllFiles(){
            var selectedFiles = [];
            for (var i = 0; i < mFiles.data.length; i ++){
                var file = mFiles.data[i];
                file.isSelected = true;
                selectedFiles.push(file);
            }
            mSelectedFiles.data = selectedFiles;
        }
        function deselectAllFiles(){
            for (var i = 0; i < mFiles.data.length; i ++){
                mFiles.data[i].isSelected = false;
            }
            mSelectedFiles.data = [];
        }
        function deSelectFile(file){
            if(!file.isSelected) return;
            file.isSelected = false;
            mSelectedFiles.data = _.reject(mSelectedFiles.data, function(f){
                return f.id === file.id;
            })
        }
        function selectFiles(files){
            mSelectedFiles.data = files;
        }
        function selectFile(file){
            if(!file) return;
            if(file.isSelected) return;
            var isExisted = _.find(mSelectedFiles.data, function(itFile){
                return itFile.filename === file.filename;
            })
            if(isExisted) return;
            file.isSelected = true;
            mSelectedFiles.data.push(file);
        }
        function toggleFileSelection(file, isSelected){
            if(typeof isSelected === 'undefined'){
                isSelected = !file.isSelected;
            }
            if(isSelected){
                selectFile(file);
            } else {
                deSelectFile(file);
            }
        }
        function onFileClicked(evt, file){
            if(evt && evt.shiftKey){
                return;
            } else if(evt && (evt.ctrlKey || evt.metaKey)){
                toggleFileSelection(file);
            } else{
                // for (var i = 0; i < mSelectedFiles.data.length; i ++){
                //     mSelectedFiles.data[i].isSelected = false;
                // }
                // file.isSelected = true;
                // mSelectedFiles.data = [file];
            }
        }
        function buildSavedFilesData(files){
            var arr = [];
            for (var i = 0; i < files.length; i ++){
                var file = files[i];
                arr.push(fileUtils.buildSavedFileObject(file));
            }
            return arr;
        }
        function buildSavedMissionData(photos, missionId) {
			var participations = _.reduce(photos, function (memo, item) {
				memo.push({
					media_id: item.id,
					mission_id: missionId
				});
				return memo;
			}, []);
			return {
				"participations": participations
			};
		}
        function isValidFileType (file){
            var fileExtension = fileUtils.getFileExtension(file.filename);
            return fileExtension.toLowerCase() === "jpeg" || fileExtension.toLowerCase() === "jpg";
        }
        function isValidFileThreeType (file){
            var fileExtension = fileUtils.getFileExtension(file.filename);
            return fileExtension.toLowerCase() === "jpeg" || fileExtension.toLowerCase() === "jpg" || fileExtension.toLowerCase() === "tiff" || fileExtension.toLowerCase() === "tif";
        }
        function isExceedMaxSize(file, maxSize){
            return file.size > maxSize;
        }
        function isExceedNumberOfUpload(filesWillBeUploaded, limit){
            var validToUploadFiles = _.reject(mFiles.data, function(f){
                return f.pixerfError;
            })
            return validToUploadFiles.length + filesWillBeUploaded.length > limit;
        }
        function isBelowMinResolution(file, minRes){
            var resolution = file.width * file.height;
            return resolution < minRes;
        }
        function isAboveMaxResolution(file, maxRes){
            var resolution = file.width * file.height;
            return resolution >= maxRes;
        }
        function publish(files, mission){
            var savedData = buildSavedFilesData(files);
            if(mission) {
                var savedData = buildSavedMissionData(files);
                if(mission.is_ioa){
                    for(var i = 0; i < savedData.length; i++){
                        savedData[i].ioa_subscriber_type = mission.ioaSubscriber.ioa_subscriber_type;
                        savedData[i].ioa_submission_type = mission.ioaSubscriber.ioa_submission_type,
                        savedData[i].ioa_subscriber_email = mission.ioaSubscriber.ioa_subscriber_email;
                    }
                }
                return pixerfApiMissionSvc.submit_participations({id : mission.id},savedData);
            }
            return pixerfApiMediaSvc.multipleUpdate({'api_version': 'new'}, savedData);
        }

        function reset(){

            mFiles.data = [];
            mSelectedFiles.data = [];
        }
		return {
            setOverlay: setOverlay,
            isFullscreenDropzone: isFullscreenDropzone,
            dragPhotoEvent: dragPhotoEvent,
            getUploadModal: getUploadModal,
            showUploadModal: showUploadModal,
            showGoogleMapPicker: showGoogleMapPicker,
            showExitConfirmModal: showExitConfirmModal,
            getUploadPhotoSvc: getUploadPhotoSvc,
            updateProgress: updateProgress,
            updateThumbnail: updateThumbnail,
            removeUploadedFile: removeUploadedFile,
            removeFileByName: removeFileByName,
            addFile: addFile,
            addFiles: addFiles,
            isFileExisted: isFileExisted,
            onFileClicked: onFileClicked,
            selectFile: selectFile,
            selectFiles: selectFiles,
            toggleFileSelection: toggleFileSelection,
            selectAllFiles: selectAllFiles,
            getSelectedFiles: getSelectedFiles,
            publish: publish,
            getCategories: getCategories,
            categories: mCategories,
            updateFileInfo: updateFileInfo,
            reset: reset,
            setThumbnail: setThumbnail,
            isValidFileType: isValidFileType,
            isValidFileThreeType: isValidFileThreeType,
            isBelowMinResolution: isBelowMinResolution,
            isAboveMaxResolution: isAboveMaxResolution,
            isExceedMaxSize: isExceedMaxSize,
            deselectAllFiles: deselectAllFiles,
            deSelectFile: deSelectFile,
            getDuplicatedFiles: getDuplicatedFiles,
            isExceedNumberOfUpload: isExceedNumberOfUpload,
            runFakeProgress: runFakeProgress,
            getFileByName: getFileByName,
            isSameFile: isSameFile,
            isPriceSet: isPriceSet

		};
    }
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('bulkEditPhotoPopupCtrl', bulkEditPhotoPopupCtrl);

		bulkEditPhotoPopupCtrl.$inject = ['popupData', 'fileConst', '$uibModalStack', '$scope', 'toastr', 'sessionManagerSvc', 'systemUtils', '$uibModalInstance', 'pixerfUrl', '$uibModal', 'bulkEditPhotoPopupSvc', 'messageConst', '$state', '$timeout', 'filePickerSvc', 'fileUtils', 'pixerfConfirmPopupSvc', '$q', 'pixerfApiMediaSvc', 'tagUtils', 'imageUtils', 'priceUtils', '$translate', 'commonConst', 'translationSvc', 'translationConst', '$rootScope',
		'bulkEditPhotoDetailSvc'];

	function bulkEditPhotoPopupCtrl(popupData, fileConst, $uibModalStack, $scope, toastr, sessionManagerSvc, systemUtils, $uibModalInstance, pixerfUrl, $uibModal, bulkEditPhotoPopupSvc, messageConst, $state, $timeout, filePickerSvc, fileUtils, pixerfConfirmPopupSvc, $q, pixerfApiMediaSvc, tagUtils, imageUtils, priceUtils, $translate, commonConst, translationSvc, translationConst, $rootScope,
		bulkEditPhotoDetailSvc) {

		var self = this;

		bulkEditPhotoPopupSvc.reset();
		self.onSaveChangesBtnClicked =onSaveChangesBtnClicked;
		self.mission = popupData ? popupData.mission : null;
		self.isHideFooter = popupData ? popupData.isHideFooter : false;
		self.noMorePhotos = popupData ? popupData.noMorePhotos : false;
		self.manualProcess = popupData ? popupData.manualProcess : false;
		self.loginUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.uploadedFiles = bulkEditPhotoPopupSvc.getUploadPhotoSvc();
		self.removeUploadedFile = bulkEditPhotoPopupSvc.removeUploadedFile;
		self.onFileClicked = bulkEditPhotoPopupSvc.onFileClicked;
		self.toggleFileSelection = bulkEditPhotoPopupSvc.toggleFileSelection;
		self.selectAllFiles = bulkEditPhotoPopupSvc.selectAllFiles;
		self.onPublishBtnClicked = onPublishBtnClicked;
		self.categories = bulkEditPhotoPopupSvc.categories;
		self.reset = reset;
		self.onAddLocationBtnClicked = bulkEditPhotoPopupSvc.showGoogleMapPicker;
		self.closeUploadModal = closeUploadModal;
		self.uploadModal = bulkEditPhotoPopupSvc.getUploadModal();
		self.isFullscreenDropzone = bulkEditPhotoPopupSvc.isFullscreenDropzone;
		self.showFilePickerPopup = showFilePickerPopup;
		self.selection = {};
		self.pixerfAlert = {};
		self.removeSelectedPhotos = removeSelectedPhotos;
		self.rotatePhoto = rotatePhoto;
		self.publishing = false;
		self.masterTags = [];
		self.dragCounter = 0;
		self.numProcessingFile = 0;
		self.updateMasterFile = updateMasterFile;
		self.onCancelPhotoBtnClicked = onCancelPhotoBtnClicked;
		self.onDeletePhoto = onDeletePhoto;
		self.navigateTo = navigateTo;
		self.isCancelUpload = false;
		self.mergedTags = [];
		self.errors = [];
		if (self.mission && self.mission.is_ioa) {
			self.footerText = 'You can submit up to a maximum of 10 entries across the Images of Asia Missions.';
		} else {
			self.footerText = $translate.instant('submit-this-mission', {
				number: self.mission && self.mission.user_participation_limit ? self.mission.user_participation_limit : fileConst.UPLOAD_PHOTO_VALIDATION.MISSION_LIMIT
			});
		}
		var errorHandlerFn = _.debounce(errorHandler, 1000);
        var gridOptions = {
            lastRow: 'justify',
            margins: 4,
            rowHeight: 240
          }
        $timeout(function () {
			// $(".upload-photo-preview").justifiedGallery(gridOptions);
			// $(".upload-photo-preview").justifiedGallery(mobileGridOptions);
        }, 1000)

		function beforeUnloadHandler(event) {
			if (self.uploadedFiles.data.length > 0) {
				var confirmationMessage = $translate.instant("are-you-sure");
				event.returnValue = confirmationMessage;
				return confirmationMessage;
			}
		}
		window.addEventListener("beforeunload", beforeUnloadHandler);
		var mFileStackSocaialHandler = {
			onSuccess: function (responsedFiles) {
				var promises = [];
				if (!Array.isArray(responsedFiles)) {
					responsedFiles = [responsedFiles];
				}
				bulkEditPhotoPopupSvc.deselectAllFiles();
				var pixerfBlobs = fileUtils.createPixerfBlob(responsedFiles.length);
				convertToPixerfFiles(pixerfBlobs, responsedFiles);
				for (var i = 0; i < pixerfBlobs.length; i++) {
					(function (index) {
						var pixerfFile = pixerfBlobs[index];
						var filestackFile = responsedFiles[index];
						var error = validateBeforeUploading(pixerfFile);
						if (error) {
							var def = $q.defer();
							setErrors(error);
							def.resolve();
							promises.push(def.promise);
						} else {
							var def2 = $q.defer();
							self.numProcessingFile++;
							bulkEditPhotoPopupSvc.addFile(pixerfFile);
							bulkEditPhotoPopupSvc.runFakeProgress(pixerfFile);
							systemUtils.digest($scope);
							var uploader = self.mission ? pixerfApiMediaSvc.upload_to_mission({
								"mission_id": self.mission.id
							}, {
								"url": filestackFile.url
							}) : pixerfApiMediaSvc.upload({
								"url": filestackFile.url
							});
							uploader.$promise.then(function (uploadResponse) {
								var isRemoved = !bulkEditPhotoPopupSvc.getFileByName(pixerfFile);
								if (isRemoved) {
									self.numProcessingFile--;
									def2.resolve();
									return;
								}
								if (uploadResponse.price_ranges) {
									var priceSet = uploadResponse.price_ranges.length > 1 ? priceUtils.createSkeletonPriceStructure(uploadResponse.price_ranges[0]) : uploadResponse.price_ranges[0];
									pixerfFile.price = priceSet;
								}
								pixerfFile.price_ranges = uploadResponse.price_ranges;
								pixerfFile.id = uploadResponse.id;
								pixerfFile.title = uploadResponse.title;
								pixerfFile.description = uploadResponse.description;
								pixerfFile.tags = tagUtils.stringsToTag(uploadResponse.tags || uploadResponse.clarifai);
								pixerfFile.originalSuggestedKeywords = uploadResponse.clarifai;
								if (!uploadResponse.tags || (uploadResponse.tags && uploadResponse.tags.length === 0)) {
									pixerfApiMediaSvc.get_clarifai({
										id: uploadResponse.id
									}).$promise.then(function (response) {
										pixerfFile.clarifai = response.data;
										pixerfFile.tags = tagUtils.stringsToTag(response.data);
										pixerfFile.originalSuggestedKeywords = response.data;
										self.numProcessingFile--; //done
										bulkEditPhotoPopupSvc.selectFile(pixerfFile);
										pixerfFile.upload.progress = 100;
										systemUtils.digest($scope);
										def2.resolve();
									}, function (err) {
										self.numProcessingFile--; //done
										bulkEditPhotoPopupSvc.selectFile(pixerfFile);
										pixerfFile.upload.progress = 100;
										systemUtils.digest($scope);
										def2.resolve();
									})
								} else {
									self.numProcessingFile--; //done
									bulkEditPhotoPopupSvc.selectFile(pixerfFile);
									pixerfFile.upload.progress = 100;
									systemUtils.digest($scope);
									def2.resolve();
								}
							}, function (errorResponse) {
								self.numProcessingFile--;
								var pixerfBlob = _.find(self.uploadedFiles.data, function (f) {
									return f.name === pixerfFile.name;
								});
								pixerfBlob.upload.progress = 0;
								if (errorResponse.data && errorResponse.data.error) {
									setErrors({
										code: fileConst.UPLOAD_PHOTO_VALIDATION.ERROR_CODE.INVALID_MIN_RESOLUTION,
										file: pixerfBlob
									});
								} else {
									setErrors({
										code: fileConst.UPLOAD_PHOTO_VALIDATION.ERROR_CODE.FAILED_TO_UPLOAD,
										file: pixerfBlob
									});
								}
								uploadErrorHandler(pixerfFile);
								def2.resolve();
								promises.push(def2.promise);
							});
						}
					})(i)
					systemUtils.digest($scope);
				}
				$q.all(promises).then(function () {
					errorHandlerFn(self.errors);
				})
			},
			onError: function (filesFailed) {
				for (var i = 0; i < filesFailed.length; i++) {
					setErrors({
						code: fileConst.UPLOAD_PHOTO_VALIDATION.ERROR_CODE.FAILED_TO_UPLOAD,
						file: filesFailed[i]
					});
				}
				errorHandlerFn(self.errors);
				console.log(filesFailed);
			}
		};
		self.dropzoneConfig = {
			'methods': {},
			'instance': {},
			'options': {
				url: pixerfUrl.full + 'api/media/store',
				dictDefaultMessage: '',
				autoProcessQueue: true,
				maxFiles: self.noMorePhotos ? 1 : 500,
				maxThumbnailFilesize: fileConst.UPLOAD_PHOTO_VALIDATION.PHOTO_SIZE.MAX_FILE_SIZE,
				paramName: 'media',
				parallelUploads: 10,
				previewsContainer: '.upload-photo__upload-area__dropzone__main-content__preview',
				method: "post",
				clickable: ".upload-photo__upload-area__dropzone__main-content__browse-btn",
				thumbnailWidth: 300,
				thumbnailHeight: 300,
				headers: {
					"Authorization": "Bearer " + sessionManagerSvc.getToken()
				},
				dictFileTooBig: "Size of this photo is {{filesize}} MB file. The maximum size is {{maxFilesize}} MB",
				createImageThumbnails: false
			},
			'eventHandlers': {
				sending: function (file, xhr, formData) {
					if (self.mission && self.mission.is_ioa) {
						formData.append('ioa_subscriber_type', self.mission.ioaSubscriber.ioa_subscriber_type);
						formData.append('ioa_submission_type', self.mission.ioaSubscriber.ioa_submission_type);
						formData.append('ioa_subscriber_email', self.mission.ioaSubscriber.ioa_subscriber_email);
					}
					formData.append('title', file.name);
				},

				thumbnail: function (file, dataUrl) {

					if (!file.pixerfError) {
						bulkEditPhotoPopupSvc.updateThumbnail(file, dataUrl);
						systemUtils.digest($scope);
					}
				},
				drop: function (file, errMsg) {
					self.isFullscreenDropzone.data = false;
					bulkEditPhotoPopupSvc.dragPhotoEvent.leave();
					systemUtils.digest($scope);
				},
				dragover: function () {
					self.dragCounter++;
					bulkEditPhotoPopupSvc.dragPhotoEvent.over();
					systemUtils.digest($scope);
				},
				addedfile: function (file) {
					imageUtils.customDropzoneThumbnail(file, this);
					var error = "";
					error = validateBeforeUploading(file);
					if (error) {
						setErrors(error);
						errorHandlerFn();
						this.removeFile(file);
					} else {
						self.numProcessingFile++;
						var pixerfBlob = fileUtils.convertFromFileObject2PixerfBlob(file);
						bulkEditPhotoPopupSvc.addFile(pixerfBlob);
					}
					systemUtils.digest($scope);
				},
				uploadprogress: function (file, progress) {
					var roundProgress = Math.round(progress);
					if (roundProgress === 100) return;
					bulkEditPhotoPopupSvc.updateProgress(file, roundProgress);
					systemUtils.digest($scope);
				},
				success: function (file, responsedFile) {
					var pixerfBlob = _.find(self.uploadedFiles.data, function (f) {
						return f.name === file.name;
					});
					//if uploading prgress is cancelled.
					if (!pixerfBlob) {
						self.numProcessingFile--; // done
						return;
					}

					if (responsedFile.price_ranges) {
						var priceSet = responsedFile.price_ranges.length > 1 ? priceUtils.createSkeletonPriceStructure(responsedFile.price_ranges[0]) : responsedFile.price_ranges[0];
						pixerfBlob.price = priceSet;
					}
					pixerfBlob.price_ranges = responsedFile.price_ranges;
					pixerfBlob.id = responsedFile.id;
					if (responsedFile.title) {
						pixerfBlob.title = responsedFile.title;
					}
					if (responsedFile.description) {
						pixerfBlob.description = responsedFile.description;
					}
					pixerfBlob.tags = tagUtils.stringsToTag(responsedFile.tags || responsedFile.clarifai);
					pixerfBlob.originalSuggestedKeywords = responsedFile.clarifai;
					if (!responsedFile.tags || (responsedFile.tags && responsedFile.tags.length === 0)) {
						pixerfApiMediaSvc.get_clarifai({
							id: responsedFile.id
						}).$promise.then(function (response) {
							self.numProcessingFile--; // done
							pixerfBlob.clarifai = response.data;
							pixerfBlob.tags = tagUtils.stringsToTag(response.data);
							pixerfBlob.originalSuggestedKeywords = response.data;
							bulkEditPhotoPopupSvc.selectFile(pixerfBlob);
							pixerfBlob.upload.progress = 100;
							systemUtils.digest($scope);
						}, function (err) {
							self.numProcessingFile--; // done
							bulkEditPhotoPopupSvc.selectFile(pixerfBlob);
							pixerfBlob.upload.progress = 100;
							systemUtils.digest($scope);
						})
					} else {
						self.numProcessingFile--; // done
						bulkEditPhotoPopupSvc.selectFile(pixerfBlob);
						pixerfBlob.upload.progress = 100;
						systemUtils.digest($scope);
					}
				},
				error: function (file, errorResponse) {
					self.numProcessingFile--;
					var pixerfBlob = _.find(self.uploadedFiles.data, function (f) {
						return f.name === file.name;
					});
					if (!pixerfBlob) pixerfBlob = file;
					if (errorResponse && errorResponse.data && errorResponse.data.message === 'Image resolution is too low') {
						toastr.error(errorResponse.data.message);
						setErrors({
							code: fileConst.UPLOAD_PHOTO_VALIDATION.ERROR_CODE.INVALID_MIN_RESOLUTION,
							file: pixerfBlob
						});
					} else if (errorResponse && errorResponse.data && errorResponse.data.key === 'participation_limit_exceeded') {
						toastr.error(errorResponse.data.message);
						setErrors({
							code: fileConst.UPLOAD_PHOTO_VALIDATION.ERROR_CODE.EXCEED_NUMBER_OF_UPLOAD_THIS_MISSION,
							file: pixerfBlob
						});
					} else {
						setErrors({
							code: fileConst.UPLOAD_PHOTO_VALIDATION.ERROR_CODE.FAILED_TO_UPLOAD,
							file: pixerfBlob
						});
					}
					pixerfBlob.upload.progress = 0;
					uploadErrorHandler(pixerfBlob);
					systemUtils.digest($scope);
				}
			}
		};
		self.dropzoneConfigSmall = $.extend(true, {}, self.dropzoneConfig);
		self.dropzoneConfigSmall.options.clickable = ".upload-photo-preview--add-more__dropzone__content__browse-btn--small";
		bulkEditPhotoPopupSvc.getCategories();
		$scope.$on('modal.closing', closeConfirm);

		function updateMasterFile(file, property) {
			var selectedFile = self.selectedFiles.data[0];
			if (self.selectedFiles.data.length === 1 && masterFile && masterFile.name === selectedFile.name && file.name === selectedFile.name) {
				bulkEditPhotoPopupSvc.updateMasterFile(self.masterFile, property, file[property]);
			}
		}

		function setErrors(error) {
			error.file.pixerfError = error.code;
			self.errors.push(error);
		}

		function validateBeforeUploading(validatedFile) {
			if (!self.mission || !self.mission.is_ioa) {
				if (bulkEditPhotoPopupSvc.isExceedNumberOfUpload([validatedFile], self.loginUser.stats.weekly_upload_balance)) {
					return {
						code: fileConst.UPLOAD_PHOTO_VALIDATION.ERROR_CODE.EXCEED_NUMBER_OF_UPLOAD_PER_WEEK,
						file: validatedFile
					};
				}
			}
			if (self.mission) {
				var limitSubmission = self.mission.user_participation_limit ? self.mission.user_participation_limit : fileConst.UPLOAD_PHOTO_VALIDATION.MISSION_LIMIT;
				var limit = self.mission.submittedPhotos ? limitSubmission - self.mission.submittedPhotos.length : 0;
				if (self.mission.is_ioa) {
					limit = self.mission.ioaSubscriber.free_balance ? self.mission.ioaSubscriber.free_balance : self.mission.ioaSubscriber.total_balance;
				} else if (self.mission.is_goJek) {
					limit = self.mission.submittedPhotos ? limitSubmission - self.mission.submittedPhotos.length : 0;
				}
				if (bulkEditPhotoPopupSvc.isExceedNumberOfUpload([validatedFile], limit)) {
					return {
						code: fileConst.UPLOAD_PHOTO_VALIDATION.ERROR_CODE.EXCEED_NUMBER_OF_UPLOAD_THIS_MISSION,
						file: validatedFile
					};
				}
			}
			if (!bulkEditPhotoPopupSvc.isValidFileType(validatedFile)) {
				return {
					code: fileConst.UPLOAD_PHOTO_VALIDATION.ERROR_CODE.INVALID_FILETYPE,
					file: validatedFile
				};
			}
			if (bulkEditPhotoPopupSvc.isExceedMaxSize(validatedFile, fileConst.UPLOAD_PHOTO_VALIDATION.PHOTO_SIZE.MAX_FILE_SIZE * 1024 * 1024)) {
				return {
					code: fileConst.UPLOAD_PHOTO_VALIDATION.ERROR_CODE.INVALID_MAX_FILESIZE,
					file: validatedFile
				};
			}
			if (bulkEditPhotoPopupSvc.isFileExisted(self.uploadedFiles.data, validatedFile)) {
				return {
					code: fileConst.UPLOAD_PHOTO_VALIDATION.ERROR_CODE.DUPLICATED,
					file: validatedFile
				};
			}
		}

		function buildErrorFilename(files) {
			var errMsg = '';
			for (var i = 0; i < files.length; i++) {
				errMsg += ("<li class='upload-photo__invalid-file text--truncate'><span>" + files[i].file.name + "</span></li>");
			}
			return errMsg;
		}

		function errorHandler(errors) {
			if (!errors) errors = self.errors;
			if (errors.length === 0) return;
			var errMsg = '';
			var callToActionMsg = '';
			var okBtnText = 'OK';
			var windowClass = '';
			var groupedError = _.groupBy(errors, function (item) {
				return item.code;
			});
			for (var key in groupedError) {
				callToActionMsg = '';
				if (key === fileConst.UPLOAD_PHOTO_VALIDATION.ERROR_CODE.DUPLICATED) {
					windowClass = key.toLocaleLowerCase();
					errMsg += "<p class='error-message'>" + $translate.instant("the-following-photos-uploaded-before") + "</p>";
					callToActionMsg += "<p class='upload-photo__validation-popup__call-to-action-msg'>" + $translate.instant("try-uploading-new-ones") + "!</p>";
				}
				if (key === fileConst.UPLOAD_PHOTO_VALIDATION.ERROR_CODE.INVALID_MIN_RESOLUTION) {
					windowClass = key.toLocaleLowerCase();
					errMsg += "<p class='error-message'>" + $translate.instant("photos-too-small-uploaded") + "</p>";
					callToActionMsg += ("<p class='upload-photo__validation-popup__call-to-action-msg'>" + $translate.instant("upload-photos-at-least-megapixels", {
						number: fileConst.UPLOAD_PHOTO_VALIDATION.PHOTO_SIZE.MIN_RESOLUTION
					}) + "</p>");
				}
				if (key === fileConst.UPLOAD_PHOTO_VALIDATION.ERROR_CODE.INVALID_FILETYPE) {
					windowClass = key.toLocaleLowerCase();
					errMsg += "<p class='error-message'>" + $translate.instant("upload-photos-wrong-format") + "</p>";
					callToActionMsg += "<p class='upload-photo__validation-popup__call-to-action-msg'>" + $translate.instant("type-photo-allowed-upload", {
						type_1: 'JPG',
						type_2: 'JPEG'
					}) + "</p>";
				}
				if (key === fileConst.UPLOAD_PHOTO_VALIDATION.ERROR_CODE.INVALID_MAX_FILESIZE) {
					windowClass = key.toLocaleLowerCase();
					errMsg += "<p class='error-message'>" + $translate.instant("upload-photos-too-large") + "</p>";
					callToActionMsg += ("<p class='upload-photo__validation-popup__call-to-action-msg'>" + $translate.instant("upload-files-smaller-than", {
						value: fileConst.UPLOAD_PHOTO_VALIDATION.PHOTO_SIZE.MAX_FILE_SIZE,
						unit: 'MB'
					}) + "</p>");

				}
				if (key === fileConst.UPLOAD_PHOTO_VALIDATION.ERROR_CODE.EXCEED_NUMBER_OF_UPLOAD_PER_WEEK) {
					windowClass = key.toLocaleLowerCase();
					errMsg += "<p class='error-message'>" + $translate.instant("upload-photos-exceeded-limit-per-week", {
						number: 50
					}) + "</p>";
					callToActionMsg += ("<p class='upload-photo__validation-popup__call-to-action-msg'>" + $translate.instant("try-uploading-next-week") + "</p>");
				}
				if (key === fileConst.UPLOAD_PHOTO_VALIDATION.ERROR_CODE.EXCEED_NUMBER_OF_UPLOAD_THIS_MISSION && self.mission.ioaSubscriber) {
					windowClass = key.toLocaleLowerCase();
					if (self.mission.ioaSubscriber.free_balance) {
						errMsg += "<p class='error-message'>The following photos could not be uploaded because you have exceeded your limit of " + self.mission.ioaSubscriber.free_balance + " free submission(s) this mission:</p>";
					} else {
						errMsg += "<p class='error-message'>The following photos could not be uploaded because you have exceeded your limit of " + self.mission.ioaSubscriber.total_balance + " submission(s) this mission:</p>";
					}
					callToActionMsg += ("<p class='upload-photo__validation-popup__call-to-action-msg'>" + $translate.instant("please-remove-photos-from-submissions") + "</p>");
				} else if (key === fileConst.UPLOAD_PHOTO_VALIDATION.ERROR_CODE.EXCEED_NUMBER_OF_UPLOAD_THIS_MISSION) {
					windowClass = key.toLocaleLowerCase();
					errMsg += "<p class='error-message'>" + $translate.instant("upload-photos-exceeded-limit-this-mission", {
						number: self.mission && self.mission.user_participation_limit ? self.mission.user_participation_limit : fileConst.UPLOAD_PHOTO_VALIDATION.MISSION_LIMIT
					}) + "</p>";
					callToActionMsg += ("<p class='upload-photo__validation-popup__call-to-action-msg'>" + $translate.instant("please-remove-photos-from-submissions") + "</p>");
				}
				if (key === fileConst.UPLOAD_PHOTO_VALIDATION.ERROR_CODE.FAILED_TO_UPLOAD) {
					windowClass = key.toLocaleLowerCase();
					errMsg += "<p class='error-message'>" + $translate.instant("upload-photos-failed") + "</p>";
					callToActionMsg += ("<p class='upload-photo__validation-popup__call-to-action-msg'>" + $translate.instant("try-uploading-them-again") + "!</p>");
				}
				errMsg += buildErrorFilename(groupedError[key]);
				errMsg += callToActionMsg;
			}
			pixerfConfirmPopupSvc.showPopup({
				hideCancelBtn: true,
				hideConfirmText: true,
				hideTitle: true,
				message: errMsg,
				windowClass: 'upload-photo__validation-popup ' + windowClass,
				okBtnText: okBtnText,
				showCloseBtn: true
			});
			self.errors = [];
		}

		function updateUserUploadBalance(numJustUploaded) {
			try {
				self.loginUser = sessionManagerSvc.getCurrentLoginUser().data;
				self.loginUser.stats.weekly_upload_balance -= numJustUploaded;
				self.loginUser.stats.inreview_media_count += numJustUploaded;
				sessionManagerSvc.setCurrentLoginUser(self.loginUser);
			} catch (ex) {}
		}

		function upload(files) {
			self.publishing = true;
			bulkEditPhotoPopupSvc.publish(files).$promise.then(function (response) {
				$timeout(function () {
					updateUserUploadBalance(files.length);
					self.publishing = false;
					$uibModalInstance.dismiss();

					if ($state.current.name === commonConst.STATE.MANAGE_PHOTO_PENDING) {
						$state.reload();
					} else {
						$state.go(commonConst.STATE.MANAGE_PHOTO_PENDING);
					}
				}, 2000);
			}).catch(function (error) {
				self.publishing = false;
				Sentry.captureException(error);
				var errorMsg = '';
				if (error.data && error.data.data && error.data.data.key === 'weekly_upload_limit_reached') {
					errorMsg = $translate.instant('you-have-limit-upload-this-time', {
						number: self.loginUser.stats.weekly_upload_balance
					});
					errorMsg += $translate.instant('please-remove-photo-from-upload');
					toastr.error(errorMsg);
				}
			})
		}

		function uploadToMission(files, ioaGuest) {
			self.publishing = true;
			if (self.mission.is_ioa) {
				self.mission.ioa_subscriber_type = ioaGuest.ioaSubscriber.ioa_subscriber_type;
				self.mission.ioa_submission_type = ioaGuest.ioaSubscriber.ioa_submission_type;
				self.mission.ioa_subscriber_email = ioaGuest.ioaSubscriber.ioa_subscriber_email;
			}
			if (self.manualProcess) {
				$rootScope.$broadcast("uploadPhoto", {
					files: files,
					dropzone: self.dropzoneConfig.instance,
					mission: self.mission
				});

				$rootScope.$broadcast(messageConst.BROADCAST.BULK_SELECTED_PHOTO_CANCEL);
				$uibModalInstance.dismiss();
				return;
			}
			bulkEditPhotoPopupSvc.publish(files, self.mission).$promise.then(function () {
				$timeout(function () {
					if (!self.mission.is_ioa) {
						updateUserUploadBalance(files.length);
					}
					self.publishing = false;
					$uibModalInstance.dismiss();

					toastr.success($translate.instant(translationConst.SUBMISSION_WAIT_FOR_CURATION));
					if ($state.current.name === commonConst.STATE.MISSION_SUBMISSIONS) {
						$state.reload();
					} else {
						$state.go(commonConst.STATE.MISSION_SUBMISSIONS, null, {
							reload: true
						});
					}

				}, 2000);
			}).catch(function (error) {
				var exception = error.data.data || error.data;
				Sentry.captureException(exception);
				self.publishing = false;
				var limitPhoto = self.mission && self.mission.user_participation_limit ? self.mission.user_participation_limit : fileConst.UPLOAD_PHOTO_VALIDATION.MISSION_LIMIT;
				var errorMsg = '';
				if (error.data && error.data.data && error.data.data.message === 'LIMIT_EXCEEDED') {
					errorMsg = $translate.instant('hi') + ", " + $translate.instant('submit-this-mission', {
						number: limitPhoto
					});
				}else if (error.data && error.data.data && error.data.data.key === 'participation_limit_exceeded' && error.data.data.message.includes("0")){
					errorMsg = 'You have reached your ' + limitPhoto + ' photo submission limit.';
				}else if (error.data && error.data.data && error.data.data.key === 'participation_limit_exceeded' && error.data.data.message) {
					errorMsg = error.data.data.message;
				}

				if (errorMsg) {
					toastr.error(errorMsg);
				}
			})
		}

		function onPublishBtnClicked(files) {
			if(self.selectedFiles && self.selectedFiles.data && self.selectedFiles.data.length === 0){
				return toastr.warning($translate.instant('no-photo-is-selected'));
			}
			self.isFormDirty = true;
			var validToUploadFiles = _.reject(files, function (f) {
				return f.pixerfError;
			})
			if (validToUploadFiles.length === 0) {
				return;
			}
			var errorMsg = '';
			if (!self.mission || (!self.mission.is_ioa && !self.mission.is_goJek)) {
				if (validToUploadFiles.length - self.loginUser.stats.weekly_upload_balance > 0) {
					errorMsg = $translate.instant('you-have-limit-upload-this-time', {
						number: self.loginUser.stats.weekly_upload_balance
					});
				} else if (self.mission) {
					var balance = self.mission.user_participation_limit - (self.mission.submittedPhotos ? self.mission.submittedPhotos.length : 0);
					if (validToUploadFiles.length - balance > 0) {
						errorMsg = "You have " + self.mission.user_participation_limit + " uploads this mission.";
					}
				}
			}
			if (errorMsg) {
				errorMsg += $translate.instant('please-remove-photo-from-upload');
			}
			if (!errorMsg) {
				errorMsg = bulkEditPhotoDetailSvc.validate(validToUploadFiles);
			}
			if (errorMsg) {
				toastr.error(errorMsg);
				return false;
			}
			if (self.mission) {
				uploadToMission(validToUploadFiles, self.mission);
			} else {

				upload(validToUploadFiles);
			}
		}

		function closeConfirm(uploadPhotoClosingEvent, reason, closed) {
			if (reason && self.uploadedFiles.data.length > 0) {
				uploadPhotoClosingEvent.preventDefault();
				// var exitUploadConfirmModal = bulkEditPhotoPopupSvc.showExitConfirmModal();
				// exitUploadConfirmModal.result.then(function () {
				// 	window.removeEventListener("beforeunload", beforeUnloadHandler);
				// 	if (self.manualProcess) {
				// 		$timeout(function () {
				// 			self.uploadModal.data.dismiss();
				// 		});
				// 	} else {
				// 		$uibModalStack.dismissAll();
				// 	}
				// }, function () {
				// 	window.removeEventListener("beforeunload", beforeUnloadHandler);
				// });
				window.removeEventListener("beforeunload", beforeUnloadHandler);
				$rootScope.$broadcast(messageConst.BROADCAST.BULK_SELECTED_PHOTO_CANCEL);
				$uibModalStack.dismissAll();
			} else {
				if(self.isCancelUpload){
					// deletePhotos(self.uploadedFiles.data);
				}
				window.removeEventListener("beforeunload", beforeUnloadHandler);
				self.uploadModal.data = null;
			}
		}

		function navigate(path) {
			uibModalInstance.dismiss("cancel")
		}

		function closeUploadModal() {
			self.isCancelUpload = true;
			$uibModalInstance.dismiss("cancel");
		}

		function deletePhotos(photos){
			if(photos && photos.length){
				for(var i = 0; i < photos.length; i++){
					pixerfApiMediaSvc.delete({id: photos[i].id});
				}
			}
		}

		function navigateTo(path) {
			// var exitUploadConfirmModal = bulkEditPhotoPopupSvc.showExitConfirmModal();
			// exitUploadConfirmModal.result.then(function () {
			// 	window.removeEventListener("beforeunload", beforeUnloadHandler);
			// 	$uibModalStack.dismissAll();
			// 	$location.path(path);
			// }, function () {
			// 	window.removeEventListener("beforeunload", beforeUnloadHandler);
			// });

			$rootScope.$broadcast(messageConst.BROADCAST.BULK_SELECTED_PHOTO_CANCEL);
			$uibModalStack.dismissAll();
		}

		function reset() {
			self.dropzoneConfig.instance.removeAllFiles();
			self.dropzoneConfigSmall.instance.removeAllFiles();
			bulkEditPhotoPopupSvc.reset();

		}

		function uploadErrorHandler(pixerfFileBlob) {
			errorHandlerFn();
			systemUtils.digest($scope);
		}

		function convertToPixerfFile(pixerfFileBlob, filestackBlob) {
			fileUtils.fromFilestackBlob2PixerfBlob(pixerfFileBlob, filestackBlob);
			pixerfFileBlob.title = fileUtils.getFileNameWithoutExtension(pixerfFileBlob.name);
		}

		function convertToPixerfFiles(pixerfFileBlobs, filestackBlobs) {
			var length = Math.min(pixerfFileBlobs.length, filestackBlobs.length);
			for (var i = 0; i < length; i++) {
				(function (index) {
					var pixerfFileBlob = pixerfFileBlobs[index];
					var filestackBlob = filestackBlobs[index];
					convertToPixerfFile(pixerfFileBlob, filestackBlob);
				})(i)
			}
		}

		function showFilePickerPopup(defaultService) {
			filePickerSvc.pickMultiple({
				callbacks: mFileStackSocaialHandler,
				defaultService: defaultService
			});
		}
		function removeSelectedPhotos(photos) {
			if (photos.length === self.uploadedFiles.data.length) {
				var modal = pixerfConfirmPopupSvc.showPopup({
					message: '',
					htmlConfirmText: $translate.instant('all-photos-will-be-removed') + '</br>'+ $translate.instant('are-you-sure-you-want-to-continue') ,
					hideTitle: true,
					hideConfirmText: true,
					windowClass: 'upload-photo__validation-popup remove-selected-photos',
					okBtnText: 'Yes',
					showCloseBtn: true
				});
				modal.result.then(function () {
					self.reset();
				}, function () {
					//do nothing
				})
			} else {

				for (var i = 0; i < photos.length; i++) {
					bulkEditPhotoPopupSvc.removeFileByName(photos[i].name);
				}
			}
		}

		function rotatePhoto(file) {
			if (!file.rotate_by) file.rotate_by = 0;
			file.rotate_by += 90;
			if (file.rotate_by === 360) {
				file.rotate_by = 0;
			}
		}

		function selectedAllFile(files){
			for(var i = 0; i < files.length; i++){
				files[i].isSelected = true;
			}
		}

		function updateTags(photo) {
			if(photo && !photo.tags){
				photo.tags = [];
				return;
			}
			var tags = [];
			for(var i = 0; i< photo.tags.length; i++){
				if( typeof photo.tags[i] == 'object'){
					tags.push(photo.tags[i]);
				}else if( typeof photo.tags[i] == 'string'){
					var tag = {'text': photo.tags[i]};
					tags.push(tag);
				}
			}

			photo.tags = tags;
		}
		function updatePhotoListTags(photos){
			for(var i = 0; i< photos.length; i++){
				updateTags(photos[i]);
			}
		}

		function isContainTag(key, tags){
			var result = false;
			for(var i = 0; i < tags.length; i++){
				if(key && key.text == tags[i].text){
					result = true;
					return result
				}
			}

			return result;
		}
		function buildTags(photos){
			for(var i = 0; i< photos.length; i++){
				if(!isContainTag(photos[i], self.mergedTags)){
					self.mergedTags.push(photos[i]);
				}
			}
			
		}

		function init(){
			if(popupData && popupData.photos && popupData.photos.length){
				updatePhotoListTags(popupData.photos);
				bulkEditPhotoPopupSvc.selectFiles(popupData.photos);
				selectedAllFile(popupData.photos);
				bulkEditPhotoPopupSvc.addFiles(popupData.photos)
				self.mergedTags = [];
				buildTags(popupData.photos);

			}
			self.selectedFiles = bulkEditPhotoPopupSvc.getSelectedFiles();

		}

		function updatePhoto(photo) {
			return pixerfApiMediaSvc.update({
				id: photo.id
			}, fileUtils.buildSavedFileObject(photo)).$promise;
		}

		function onSaveChangesBtnClicked(){
			var selectedPhoto = _.filter(popupData.photos, function (p) {
				return p.isSelected == true;
			})


			var errorMsg = bulkEditPhotoDetailSvc.validate(selectedPhoto);

			if (errorMsg) {
				toastr.error(errorMsg);
				return false;
			}
			self.isSaving = true;
			var errorCount = 0;
			for(var i = 0; i < selectedPhoto.length; i++){
				selectedPhoto[i].tags = self.masterTags;
				updatePhoto(selectedPhoto[i]).then(function (response) {
					// photoDetailSvc.setOriginalPhoto($.extend(true, {}, $scope.photo));
					
				}, function (response) {
					self.isSaving = false;
					errorCount ++;
					var msg = translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true);
					if (response.data && response.data.errors && response.data.errors.length > 0) {
						var mappedMessage = messageConst.error[response.data.errors[0]];
						if (mappedMessage) {
							msg = mappedMessage;
						}
					}
					toastr.error(msg);
				})
			}
			
			self.isSaving = false;
			if(errorCount > 0){
				toastr.warning("successfully updated :" + ((selectedPhoto.length  || 0 ) - errorCount) + ", false: " + (errorCount || 0 ));
			}else{
				toastr.success("This photo(s) has been successfully updated!");
			}
			closeUploadModal();
		}

		function onDeletePhoto(){
            var message = translationSvc.ARE_YOU_SURE_TO_DO_SOMETHING("DELETE_THIS_PHOTOS");
			var modal = pixerfConfirmPopupSvc.showPopup({
				hideTitle: true,
				hideConfirmText: true,
				message: message
			});

			var selectedPhoto = _.filter(popupData.photos, function (p) {
				return p.isSelected == true;
			})

			var successCount = []
			var errorCount = []
            
            modal.result.then(function () {

				for(var i = 0; i < selectedPhoto.length; i++){
					pixerfApiMediaSvc.delete({
						id: selectedPhoto[i].id
					}).$promise.then(function success (res) {
						// toastr.success($translate.instant("successfully-deleted"));
						successCount.push(selectedPhoto[i]);
						showResult(errorCount, successCount, selectedPhoto);
					},
					function error(err){
						// var errMsg = $translate.instant("failed-delete-photo");
						errorCount.push(selectedPhoto[i]);
						showResult(errorCount, successCount, selectedPhoto)

						// toastr.error(errMsg);
					})
				}
            })

			function showResult(errorCount, successCount, selectedPhoto){
				if((selectedPhoto.length - errorCount.length - successCount.length) > 0 ) return
				if(errorCount.length == 0){
					toastr.success($translate.instant("successfully-deleted"));
				}else{
					toastr.warning("successfully updated :" + (successCount.length || 0 ) + ", false: " + (errorCount.length || 0 ));
				}
			}
        }

		function onCancelPhotoBtnClicked(){
			closeUploadModal();
		}

		init();

	}
})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.factory('bulkEditPhotoDetailSvc', bulkEditPhotoDetailSvc);

		bulkEditPhotoDetailSvc.$inject = ['addToGallerySvc', 'pixerfApiKeywordSvc', '$q', 'accountUtils', 'sessionManagerSvc', '$translate'];

	function bulkEditPhotoDetailSvc(addToGallerySvc, pixerfApiKeywordSvc, $q, accountUtils, sessionManagerSvc, $translate) {

		function isMultipleValue(files, property) {
			var firstFile = files[0];
			return !_.every(files, function (f) {
				return _.isEqual(firstFile[property], f[property]);
			})
		}

		function buildKeywords(keywords, max) {
			var firstNine = [];
			for (var i = 0; i < keywords.length; i++) {
				if (firstNine.length === max) return firstNine;
				var keyword = keywords[i];
				if (!_.contains(firstNine, keyword) && validateKeyword(keyword)) {
					firstNine.push(keyword);
				}
			}
			return firstNine;
		}

		function validateKeyword(keyword) {
			return keyword.length > 2;

		}

		function buildCallToActionMessages(file) {
			var messages = [];
			if (!file) return messages;
			var loginUser = sessionManagerSvc.getCurrentLoginUser().data;
			if (!loginUser) return messages;
			if (!loginUser.canCurate && !file.isMine) return messages;
			if (!file.price) {
				messages.push("- Please set a price before this photo can be featured in the Marketplace.");
			}

			if (!file.releases) file.releases = [];
			if (file.license === 'commercial' && file.has_model_property && file.releases.length === 0) {
				messages.push('<div>- Please upload photo release form(s) </div><get-release-form-btn class="pixerf-link--color-blue text--bold" text="You can download the forms here."></get-release-form-btn>');
			}
			return messages;
		}

		function loadTags(query) {
			var deferred = $q.defer();
			pixerfApiKeywordSvc.query({
				'word': query
			}, function (response) {
				var firstNine = buildKeywords(response, 10);
				deferred.resolve(firstNine);
			}, function (error) {
				deferred.reject(error);
			});
			return deferred.promise;
		}

		function validate(files) {
			for (var i = 0; i < files.length; i++) {
				var file = files[i];
				var photoName = "Photo " + (file.title ? file.title : file.name);
				if ((file.license === "commercial" && file.has_model_property == null) || !file.license) {
					return $translate.instant("photo-apply-commercial-license", {
						name: photoName
					});
				}
				if (!file.title) {
					return photoName + ": Please input the title of this photo!";
				}
				// if (!file.categories || !file.categories.length) {
				// 	return $translate.instant("photo-select-category", {
				// 		name: photoName
				// 	});
				// }
				// if (!file.price || (file.price && !file.price.id)) {
				// 	return photoName + ": Please select the price of this photo!";
				// }
				var valid = !(accountUtils.isContainsLink(file.description));
				if (!valid) return "Sorry, " + photoName + ": description cannot contain link or email.";
				valid = !accountUtils.isContainsFileExtension(file.title);
				if (!valid) return "Sorry, " + "Photo title cannot contain extension.";
			}
		}

		function isPriceSet(files) {
			for (var i = 0; i < files.length; i++) {
				var file = files[i];
				if (!file.price) return false;
			}
			return true;
		}

		function synchonizeSuggestedKeywords(action, $tag, files) {

			for (var i = 0; i < files.length; i++) {
				var file = files[i];
				if (!file.suggestedKeywords) file.suggestedKeywords = [];
				var isInSuggestedKeyword = _.find(file.originalSuggestedKeywords, function (t) {
					return t === $tag.text;
				});
				if (action === "add") {
					if (isInSuggestedKeyword) {
						file.suggestedKeywords = _.reject(file.suggestedKeywords, function (t) {
							return $tag.text && t === $tag.text;
						});
					}
				} else if (action === "remove") {
					var isExisted = _.find(file.suggestedKeywords, function (t) {
						return t === $tag.text;
					});

					if (!isExisted && isInSuggestedKeyword) file.suggestedKeywords.push($tag.text);
				}
			}
		}

		function synchonizeKeywords(action, $tag, files) {

			for (var i = 0; i < files.length; i++) {
				var file = files[i];
				if (!file.tags) file.tags = [];
				var isExisted = _.find(file.tags, function (t) {
					return t.text === $tag.text;
				});
				if (action === "add") {
					if (!isExisted) {
						file.tags.push($tag);
					}
				} else if (action === "remove") {
					file.tags = _.reject(file.tags, function (t) {
						return t.text === $tag.text;
					});
				}
			}
		}

		function synchonizedFilesInfo(files, property, value) {
			for (var i = 0; i < files.length; i++) {
				if (typeof value === 'object') {
					if (Array.isArray(value)) {
						files[i][property] = $.extend(true, [], value);
					} else {
						files[i][property] = $.extend(true, {}, value);
					}
				} else {
					files[i][property] = value;
				}
			}
		}

		function synchonizePrice(files, price) {
			for (var i = 0; i < files.length; i++) {
				var file = files[i];
				var isExisted = _.find(file.price_ranges, function (p) {
					return p.id === price.id;
				})
				if (isExisted) {
					file.price = isExisted;
				}
			}
		}

		function updateMasterFile(masterFile, property, value) {
			masterFile.data[property] = value;
		}

		function buildMasterFileKeywords(files) {
			var arrays = [];
			for (var i = 0; i < files.length; i++) {
				arrays.push(files[i].tags);
			}
			var buff = [];
			var i, all, shortest, nShortest, n, len, ret = [],
				obj = {},
				nOthers, isExisted;
			nOthers = arrays.length - 1;
			nShortest = arrays[0].length;
			shortest = 0;
			for (i = 0; i <= nOthers; i++) {
				n = arrays[i].length;
				if (n < nShortest) {
					shortest = i;
					nShortest = n;
				}
			}
			for (i = 0; i <= nOthers; i++) {
				n = (i === shortest) ? 0 : (i || shortest);
				len = arrays[n].length;
				for (var j = 0; j < len; j++) {
					var tag = arrays[n][j];
					// tag.isSameKeyword = false;
					isExisted = _.find(buff, function (t) {
						return t.text === tag.text;
					})
					if (!isExisted) {
						buff.push(tag);
					}
					var elem = tag['text'];
					if (obj[elem] === i - 1) {
						if (i === nOthers) {
							ret.push(tag);
							isExisted = _.find(buff, function (t) {
								return t.text === tag.text;
							})
							if (isExisted && (typeof isExisted != 'string')) {
								isExisted.isSameKeyword = true;
							}
							obj[elem] = 0;
						} else {
							obj[elem] = i;
						}
					} else if (i === 0) {
						obj[elem] = 0;
					}
				}
			}
			return buff;
		}

		function resetKeyworkd(tags) {
			for (var i = 0; i < tags.length; i++) {
				tags[i].isSameKeyword = false;
			}
			return tags;
		}

		function buildMasterFileReleases(files) {
			var arr = _.reduce(files, function (memo, item) {
				if (item.releases && item.releases.length > 0) {
					memo = memo.concat(item.releases);
				}
				return memo;
			}, []);
			return _.uniq(arr, function (item) {
				return item.id;
			});
		}

		function buildMasterFileGalleries(files) {
			var arr = _.reduce(files, function (memo, item) {
				if (item.galleries && item.galleries.length > 0) {
					memo = memo.concat(item.galleries);
				}
				return memo;
			}, []);
			return _.uniq(arr, function (item) {
				return item.id;
			});
		}

		function buildPriceRanges(files) {
			var maxPriceRanges = files[0].price_ranges;
			for (var i = 1; i < files.length; i++) {
				var file = files[i];
				if (file.price_ranges && file.price_ranges[file.price_ranges.length - 1].value > maxPriceRanges[maxPriceRanges.length - 1].value) {
					maxPriceRanges = file.price_ranges;
				}
			}
			return maxPriceRanges;
		}

		function buildMasterFile(masterFile, files, synchronizable, categories) {

			var firstFile = files[0];
			if (!synchronizable) {
				masterFile.data = firstFile;
			} else {

				masterFile.data = {
					name: '',
					title: '',
					license: '',
					categories: [],
					description: '',
					location: '',
					galleries: [],
					tags: [],
					suggestedKeywords: [],
					originalSuggestedKeywords: [],
					price: null,
					releases: [],
					has_model_property: false,
					price_ranges: [],
					user: null
				};
			}
			if (!firstFile) {
				masterFile.data = null;
				return;
			}
			masterFile.data.name = firstFile.name;
			for (var property in masterFile.data) {
				if (property === "user") {
					masterFile.data.user = firstFile.user;
				} else if (property === "categories") {
					if (files.length > 1 && isMultipleValue(files, property)) {
						var multiple = {
							id: -1,
							name: 'Multiple categories'
						};
						if (categories.data[0].id !== -1) {
							categories.data.unshift(multiple);
						}
						masterFile.data.categories = [multiple];
					} else {
						masterFile.data.categories = firstFile.categories || [];
						if (categories.data[0] && categories.data[0].id && categories.data[0].id === -1) {
							categories.data.shift(multiple);
						}
					}

				} else if (property === "tags") {
					firstFile.tags = firstFile.tags || [];
					masterFile.data.tags = files.length > 1 ? buildMasterFileKeywords(files) : resetKeyworkd(firstFile.tags);
				} else if (property === "releases") {
					if (!firstFile.releases) firstFile.releases = [];
					masterFile.data.releases = files.length > 1 && isMultipleValue(files, property) ? buildMasterFileReleases(files) : firstFile.releases;
				} else if (property === "suggestedKeywords") {
					masterFile.data.suggestedKeywords = files.length > 1 ? [] : (firstFile.suggestedKeywords || []);
				} else if (property === "originalSuggestedKeywords") {
					masterFile.data.originalSuggestedKeywords = files.length > 1 ? [] : (firstFile.originalSuggestedKeywords || []);
				} else if (property === "galleries") {
					masterFile.data.galleries = files.length > 1 && isMultipleValue(files, property) ? buildMasterFileGalleries(files) : firstFile.galleries;
					masterFile.data.galleriesName = addToGallerySvc.buildGalleriesNames(masterFile.data.galleries);
				} else if (property === "price_ranges") {
					masterFile.data.price_ranges = files.length > 1 ? buildPriceRanges(files) : firstFile.price_ranges;
				} else {
					if (Array.isArray(masterFile.data[property])) {
						masterFile.data[property] = files.length > 1 && isMultipleValue(files, property) ? 'Multiple ' + property + "s" : firstFile[property];
					} else if (typeof masterFile.data[property] === "object") {
						masterFile.data[property] = files.length > 1 && isMultipleValue(files, property) ? 'Multiple ' + property + "s" : firstFile[property] ? firstFile[property] : undefined;
					} else {
						masterFile.data[property] = files.length > 1 && isMultipleValue(files, property) ? 'Multiple ' + property + "s" : firstFile[property];
					}
				}
			}
		}
		return {
			synchonizedFilesInfo: synchonizedFilesInfo,
			loadTags: loadTags,
			synchonizeSuggestedKeywords: synchonizeSuggestedKeywords,
			validate: validate,
			isPriceSet: isPriceSet,
			buildMasterFile: buildMasterFile,
			updateMasterFile: updateMasterFile,
			buildCallToActionMessages: buildCallToActionMessages,
			synchonizeKeywords: synchonizeKeywords,
			synchonizePrice: synchonizePrice
		};
	}
})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('bulkEditPhotoDetailCtrl', bulkEditPhotoDetailCtrl);

        bulkEditPhotoDetailCtrl.$inject = ['photoSvc', 'sessionManagerSvc', 'sendReleaseFormEmailPopupSvc', 'categoryUtils','$scope', 'bulkEditPhotoDetailSvc', '$q', 'toastr', '$timeout', 'pagingUtils', 'galleryUtils', 'addToGallerySvc', 'pixerfApiMediaSvc', 'pixerfMessagePopupSvc', 'fileUtils'];

    function bulkEditPhotoDetailCtrl(photoSvc, sessionManagerSvc, sendReleaseFormEmailPopupSvc, categoryUtils, scope, bulkEditPhotoDetailSvc, $q, toastr, $timeout, pagingUtils, galleryUtils, addToGallerySvc, pixerfApiMediaSvc, pixerfMessagePopupSvc, fileUtils) {

        var self = this;
        self.onGallerySelected = onGallerySelected;
        self.synchonizedFilesInfo = synchonizedFilesInfo;
        self.synchonizePrice = synchonizePrice;
        self.loadTags = loadTags;
        self.addTag = addTag;
        self.onTagRemoved = onTagRemoved;
        self.onInvalidTag = onInvalidTag;
        self.loginUser = sessionManagerSvc.getCurrentLoginUser().data;
        self.onTagAdded = onTagAdded;
        self.masterFile = {data: null};
        self.onRequiredReleaseRadioBtnClicked = onRequiredReleaseRadioBtnClicked;
        self.onPhotoUsageItemClicked = onPhotoUsageItemClicked;
        self.onQuestionAnswered = onQuestionAnswered;
        self.getTagClass = getTagClass;
        self.callToActionMesages = [];
        self.categoryDropdownSettings = {
            displayProp: 'name',
            idProp: 'id',
            smartButtonMaxItems: 3,
            selectionLimit: 3,
            showCheckAll : false,
            showUncheckAll: false,
            scrollable: true,
            scrollableHeight: "275px",
            buttonClasses: 'multiple-dropdown-selection__btn-dropdown text--truncate text-left',
            events: {
                onSelectionChanged: function(){
                    var files = scope.files;
                    if(scope.categories.data[0] && scope.categories.data[0].id === -1){
                        self.masterFile.data.categories.shift();
                        scope.categories.data.shift();
                    }
                    synchonizedFilesInfo(files, "categories", self.masterFile.data.categories);
                },
                onMaxSelectionReached: function(){
                    toastr.error("Please select up to a maximum of three categories only.");
                }
            }
        };
        function synchonizedFilesInfo(){
            if(scope.synchronizable){
                bulkEditPhotoDetailSvc.synchonizedFilesInfo.apply(bulkEditPhotoDetailSvc, arguments);
            } else {//editphoto mode
                self.callToActionMesages = bulkEditPhotoDetailSvc.buildCallToActionMessages(self.masterFile.data);
            }
            scope.formError = bulkEditPhotoDetailSvc.validate(scope.files);
        }
        scope.$watchCollection("files",function(newFiles, oldValue){
            bulkEditPhotoDetailSvc.buildMasterFile(self.masterFile, newFiles, scope.synchronizable, scope.categories);
            self.callToActionMesages = bulkEditPhotoDetailSvc.buildCallToActionMessages(self.masterFile.data);
            scope.masterTags = (self.masterFile &&self.masterFile.data && self.masterFile.data.tags ) ? self.masterFile.data.tags : [];
        });
        function getTagClass($tag){
            // return $tag.isSameKeyword ? 'tag-item--bolder' : '';
            return $tag.isSameKeyword ? '' : '';
        }
        function onTagAdded($tag){
            var files = scope.files;
            $tag.isSameKeyword = files.length > 1;
            $timeout(function(){
                var isInSuggestedKeyword = _.find(self.masterFile.data.originalSuggestedKeywords, function(t){
                    return t === $tag.text;
                });
                if(isInSuggestedKeyword){
                    self.masterFile.data.suggestedKeywords = _.reject(self.masterFile.data.suggestedKeywords, function(t){
                        return t === $tag.text;
                    });
                }
                if(scope.synchronizable){
                    bulkEditPhotoDetailSvc.synchonizeKeywords("add", $tag, files);
                    bulkEditPhotoDetailSvc.synchonizeSuggestedKeywords("add", $tag, files);
                }
            }, 300);
        }
        function onInvalidTag($tag, tiScope){
            var files = scope.files;
            var isExisted = _.find(self.masterFile.data.tags, function(t){
                return t.text === $tag.text;
            });
            if(isExisted && !isExisted.isSameKeyword && files.length > 1){
                isExisted.isSameKeyword = true;
                tiScope.newTag.text('');
            }
            if(scope.synchronizable){
                bulkEditPhotoDetailSvc.synchonizeKeywords("add", $tag, files);
                bulkEditPhotoDetailSvc.synchonizeSuggestedKeywords("add", $tag, files);
            }
        }
        function onTagRemoved($tag){
            var files = scope.files;
            var isExisted = _.find(self.masterFile.data.suggestedKeywords, function(t){
                return t === $tag.text;
            });
            var isInSuggestedKeyword = _.find(self.masterFile.data.originalSuggestedKeywords, function(t){
                return t === $tag.text;
            });
            if(!isExisted && isInSuggestedKeyword) self.masterFile.data.suggestedKeywords.push($tag.text);
            if(scope.synchronizable){
                bulkEditPhotoDetailSvc.synchonizeKeywords("remove", $tag, files);
                bulkEditPhotoDetailSvc.synchonizeSuggestedKeywords("remove", $tag, files);
            }
        }
        function addTag(tags, tagText){
            var files = scope.files;
            if(!tags) tags = [];
            var isExisted = _.find(tags, function(t){
                return t.text === tagText;
            })
            if(!isExisted) {
                tags.push({text: tagText});
                onTagAdded({text: tagText});
            }

        }
        function loadTags(query){
            var files = scope.files;
            var deferred = $q.defer();
            bulkEditPhotoDetailSvc.loadTags(query).then(function(tags){
                deferred.resolve(tags);
                // self.masterFile.data.suggestedKeywords = tags;
            }, function(error){
                deferred.reject(error);
                toastr.error("Failed to get tags.");
            })
            return deferred.promise;
        }
        function onGallerySelected(gallery){
            photoSvc.updateFileGalleriesInfo(self.masterFile.data, gallery);
            self.masterFile.data.galleriesName = addToGallerySvc.buildGalleriesNames(self.masterFile.data.galleries);
        }
        function showSendReleaseFormPopup(){
            sendReleaseFormEmailPopupSvc.showPopup();
        }
        function onPhotoUsageItemClicked(usage){
            self.masterFile.data.license = usage;
            self.masterFile.data.has_model_property = null;
            self.masterFile.data.releases = [];
        }
        function onRequiredReleaseRadioBtnClicked(){
            self.synchonizedFilesInfo(scope.files, 'has_model_property', self.masterFile.data.has_model_property)
            if(self.masterFile.data.has_model_property){
                showSendReleaseFormPopup();
            } else {
                self.masterFile.data.releases = [];
            }

        }
        function synchonizePrice(){
            bulkEditPhotoDetailSvc.synchonizePrice.apply(null,arguments);
        }
        function onQuestionAnswered(question){
            if(question === 'COMMERCIAL?'){
                self.onPhotoUsageItemClicked('commercial');
                self.synchonizedFilesInfo(scope.files, 'license', 'commercial');
            } else if(question === 'NO_NEED_RELEASE?' || question==='NEED_RELEASE_FORM?'){
                self.onRequiredReleaseRadioBtnClicked();
            }
            else if(question === 'NOT_COMMERCIAL?') {
                self.onPhotoUsageItemClicked('editorial');
                self.synchonizedFilesInfo(scope.files, 'license', 'editorial')
            }
        }
    }
})();

(function () {
  'use strict';

  angular
    .module('pixerf')
    .directive('bulkEditPhotoDetail', bulkEditPhotoDetail);

  function bulkEditPhotoDetail() {

    var directive = {
      scope: {
          files: "=",
          categories : '=',
          synchronizable: '=',
          formError: "=",
          isFormDirty: "=",
          masterTags: "=",
          alert: "=",
          isLoadingClarifai: '='
      },
      restrict: 'E',
      templateUrl: 'app/components/bulk-edit-photo-detail/bulk-edit-photo-detail.html',
      controller: 'bulkEditPhotoDetailCtrl',
      controllerAs: 'vm',
      replace: true
    };
    return directive;
  }

})();


(function () {
    'use strict';
  
    angular
      .module('pixerf')
      .directive('breadCrumbsStyleOne', breadCrumbsStyleOne);
  
    function breadCrumbsStyleOne() {
  
      var directive = {
        scope: {
          "currentIndex": "=",
          "items": "=",
          "onBreadCrubmClicked": "&",
          "onInit": "&?"
        },
        restrict: 'E',
        controller: 'breadCrumbsStyleOneCtrl',
        controllerAs: 'vm',
        templateUrl: 'app/components/bread-crumbs/bread-crumbs.html',
        replace: true
      };
      return directive;
    }
  
  })();
  
(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('breadCrumbsCtrl', breadCrumbsCtrl);

	breadCrumbsCtrl.$inject = ['$scope', 'cartSvc', 'pagingUtils', 'toastr'];

	function breadCrumbsCtrl($scope, cartSvc, pagingUtils, toastr) {

		var self = this;
		self.currentIndex = 0;
		self.setCurrentIndex = setCurrentIndex;
		self.onBreadCrubmClicked = onBreadCrubmClicked;
		self.itemWidth = 'calc(' + Math.floor(100 / 3).toFixed(0) + '%' + ' - 17.5px)';
		
		if($scope.onInit) {
			$scope.onInit({instance: self});
		}
		function setCurrentIndex(index) {
			self.currentIndex = index;
		}
		function onBreadCrubmClicked(step){
			if(step.index > self.currentIndex ) return;
			$scope.onBreadCrubmClicked({step: step});
		}

	}
})();

(function () {
  'use strict';

  angular
    .module('pixerf')
    .directive('breadCrumbs', breadCrumbs);

  function breadCrumbs() {

    var directive = {
      scope: {
        "currentIndex": "=",
        "items": "=",
        "onBreadCrubmClicked": "&",
        "onInit": "&?"
      },
      restrict: 'E',
      controller: 'breadCrumbsCtrl',
      controllerAs: 'vm',
      templateUrl: 'app/components/bread-crumbs/bread-crumbs.html',
      replace: true
    };
    return directive;
  }

})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('brandsSayColumnCtrl', brandsSayColumnCtrl);

	brandsSayColumnCtrl.$inject = ['$scope', 'systemUtils'];

	function brandsSayColumnCtrl($scope, systemUtils) {

		var self = this;
		self.brands = $scope.data;
		self.onNextSlide = onNextSlide;
		self.onPreviousSlide = onPreviousSlide;

		self.responsive = [{
				breakpoint: 992,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1
				}
			},
			{
				breakpoint: 480,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1
				}
			}
		];

		self.slickSetting = {
			onInit: function (slick) {
				self.slick = slick;
				self.totalSlide = Math.ceil(self.brands.length / self.slick.options.slidesToScroll);
				systemUtils.digest($scope);
			},
			onAfterChange: function (event, slick, currentSlide) {
				self.currentSlide = (currentSlide / slick.options.slidesToScroll) + 1;
				if (slick.$slides.length == currentSlide + slick.options.slidesToScroll) {
					self.isLastBrandsSlide = true;
				} else {
					self.isLastBrandsSlide = false;
				}
				systemUtils.digest($scope);
			},
			breakpoint: function(event){
				self.totalSlide = Math.ceil(self.brands.length / self.slick.options.slidesToScroll);
				systemUtils.digest($scope);
			}
		}

		function onNextSlide() {
			self.slick.slickNext();
		}

		function onPreviousSlide() {
			self.slick.slickPrev();
		}
	}
})();

(function () {
	'use strict';

	angular
	  .module('pixerf')
	  .directive('brandsSayColumn', brandsSayColumn);

	function brandsSayColumn() {

	  var directive = {
		scope: {
            data: "="
		},
		restrict: 'E',
		templateUrl: 'app/components/brands-say-column/brands-say-column.html',
		controller: 'brandsSayColumnCtrl',
		controllerAs: 'vm',
		replace: true
	  };
	  return directive;
	}

  })();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('brandCommentPhotoTileCtrl', brandCommentPhotoTileCtrl);

	brandCommentPhotoTileCtrl.$inject = ['$scope', 'pixerfApiCustomCommssionsSvc'];

	function brandCommentPhotoTileCtrl($scope, pixerfApiCustomCommssionsSvc) {

		var self = this;
		self.onRemoveClicked = onRemoveClicked;

		function onRemoveClicked(item) {
			pixerfApiCustomCommssionsSvc.deleteCommentOnSubmissions({
				submission_id: $scope.item.shoot_submission_id,
				shoot_id: $scope.shootId,
				comment_id: $scope.item.id
			}).$promise.then(function () {
				$scope.onItemRemoved({
					data: item
				})
			}).catch(function (err) {
				console.log(err);
			})
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('brandCommentPhotoTile', brandCommentPhotoTile);

	function brandCommentPhotoTile() {

		var directive = {
			scope: {
				"item": "=",
				"options": "=",
				"submissionId": "=",
				"shootId": "=",
				"onItemRemoved": "&"
			},
			restrict: 'E',
			controller: 'brandCommentPhotoTileCtrl',
			controllerAs: 'vm',
			templateUrl: 'app/components/brand-comment-photo-tile/brand-comment-photo-tile.html',
			replace: true
		};
		return directive;
	}

})();

(function () {
    'use strict';
    angular
      .module('pixerf')
      .factory('blockMemberPopupSvc', blockMemberPopupSvc);
    blockMemberPopupSvc.$inject = ['$uibModal'];
  
    function blockMemberPopupSvc($uibModal) {
  
      var mReasons = {
        data: [
          {id: 1,	title: 'Violated community rules'},
          {id: 2,	title: 'Does not meet community requirements'},
          {id: 3,	title: 'Others'}
        ]
      }
      function setReasons(value) {
        mReasons.data = value;
      }
      function getReasons() {
        return mReasons;
      }
      function showPopup(popupData) {
        return $uibModal.open({
          templateUrl: 'app/components/block-member-popup/block-member-popup.html',
          controller: 'blockMemberPopupCtrl',
          controllerAs: 'vm',
          animation: true,
          windowClass: 'block-member-popup__screen',
          resolve: {
            'resolveData': function () {
              return popupData;
            }
          }
        });
      }
  
      return {
        setReasons: setReasons,
        getReasons: getReasons,
        showPopup: showPopup
      };
    }
  })();
  
(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('blockMemberPopupCtrl', blockMemberPopupCtrl);

		blockMemberPopupCtrl.$inject = ['$scope', 'systemUtils', '$uibModalInstance', 'removeMemberPopupSvc', 'resolveData', 'toastr', 'pixerfApiCommunitySvc', 'contextConst'];

	function blockMemberPopupCtrl($scope, systemUtils, $uibModalInstance, removeMemberPopupSvc, resolveData, toastr, pixerfApiCommunitySvc, contextConst) {

		var self = this;
		self.state = 'r';
		self.community = resolveData.community;
		self.user = resolveData.user;
		self.isMissionReject = false;
		self.isDeletePost = false;
		self.isDeclinePending = false;
		self.isBlock = false;
		self.onConfirm = onConfirm;
		self.closePopup = closePopup;
		self.onDeletePostsComments = onDeletePostsComments;
		self.blockOptions = {};
		self.blockPostLabel = "Delete all of " + self.user.displayName + "'s posts and comments.";

		init();

		function init() {
			systemUtils.digest($scope);
		}

		function closePopup(user, context) {
			var result = {
				user: user,
				context: context
			}
			$uibModalInstance.close(result);
		}

		function onDeletePostsComments(item) {
			self.isDeletePost = item;
		}

		function onConfirm() {
			pixerfApiCommunitySvc.block_member({ id: self.community.id }, { 'id': self.community.id, 'user_ids': [self.user.id], 'status': 'banned', 'reason': self.reason}).$promise.then(function (res) {
				var context = contextConst.COMMUNITY_BLOCKED_MEMBER;
				closePopup(self.user, context);
			}).catch(function (err) {
				console.log(err);
			})

			if (self.isDeletePost) {
				pixerfApiCommunitySvc.delete_all_posts_comments({ id: self.community.id }, { 'user_ids': [self.user.id] }).$promise.then(function (res) {
					closePopup(self.user);
				}).catch(function (err) {
					console.log(err);
				})
			}
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('billingInformationCtrl', billingInformationCtrl);

	billingInformationCtrl.$inject = ['$scope', 'sessionManagerSvc'];

	function billingInformationCtrl($scope, sessionManagerSvc) {
		var self = this;
		self.user = sessionManagerSvc.getCurrentLoginUser().data;
	}
})();

(function () {
  'use strict';

  angular
    .module('pixerf')
    .directive('billingInformation', billingInformation);

  function billingInformation() {

    var directive = {
      restrict: 'E',
      scope: {},
      templateUrl: 'app/components/billing-information/billing-information.html',
      controller: 'billingInformationCtrl',
      controllerAs: 'vm',
      replace: true
    };
    return directive;
  }

})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('bgChanger', bgChanger);
	bgChanger.$inject = ['$rootScope', '$interval', 'pixerfApiMediaSvc', 'pathUtils', '$timeout'];
	function bgChanger($rootScope, $interval, pixerfApiMediaSvc, pathUtils, $timeout) {
		return {
			scope: {
				noWatermark: "=",
				photos: "=",
				timer: "@",
				hideAuthor: "@",
				customPhotos: "@?",
				noOverlay: "@?",
				useSequence: "@",
				onChanged: "&?"
			},
			templateUrl: 'app/components/bg-changer/bg-changer.html',
			restrict: 'E',
			replace: true,
			link: function (scope, elem, attrs) {
				var mIntervalID;
				var $photos = $(".bg-changer__photos");
				unifyData(scope.photos);
				for(var i = 0; i < scope.photos.length; i++){
					var tmp = _.template("<div class=\"bg-changer__bg\ bg-changer__bg<%=index%>\" style=\"background-image: url('<%=url%>')\"></div>")({
						index: i,
						url: scope.photos[i].url
					});
					$photos.append(tmp);
				}
				$timeout(function(){
					generateBackground(scope.photos);
				},0)

				function unifyData(photos){
					for(var i = 0; i < photos.length; i++){
						photos[i].url = photos[i].url || photos[i].thumbnails["x300"];
					}
				}

				function setTypePhotosUrl(items) {
					for (var i = 0; i < items.data.length; i++) {
						items.data[i].url = items.data[i].thumbnails["x1440"];
					}
					return items;
				}

				function convertToShowObject(items) {
					for (var i = 0; i < items.data.length; i++) {
						items.data[i].user.name = items.data[i].user.displayName;
					}
					return items;
				}

				function getCurrentIndex(photos){
					return scope.useSequence ? 0 : Math.floor(Math.random() * (photos.length));
				}
				function getNextIndex(currentIndex, photos){
					if(scope.useSequence){
						if(currentIndex === photos.length - 1){
							return 0;
						}
						return ++currentIndex;
					}
					return Math.floor(Math.random() * (photos.length));
				}

				function changeBg($elmt, currentIndex){
					var nextIndex = getNextIndex(currentIndex, scope.photos);
					if(currentIndex == nextIndex) return nextIndex;
					var transforms = ["top left", "bottom left", "top right", "bottom right"];

					var transformsOrigin = transforms[Math.floor(Math.random() * (transforms.length))];
					var $currentBg = $elmt.find(".bg-changer__bg" + currentIndex);
					var $nextBg = $elmt.find(".bg-changer__bg" + nextIndex);


					$nextBg.css({visibility: "visible"});
					$nextBg.stop( true, true ).animate({ opacity: 1 }, 1000,function () {
						$(this).css({"transform": "scale(1.3)", "transition": "transform 30s linear", "transform-origin": transformsOrigin})
					});
					$currentBg.stop( true, true ).animate({ opacity: 0 }, 1000,function () {
						$(this).css({transform: 'scale(1)', transition: ''});
						$(this)
							.css({visibility: "hidden"});
					});
					scope.photo = scope.photos[nextIndex];
					if(scope.onChanged){
						scope.onChanged({curentPhoto: scope.photo});
					}
					return nextIndex;

				}
				function generateBackground(photos) {
					var timer = parseInt(scope.timer);
					var currentIndex = 0;

					currentIndex = getCurrentIndex(photos)
					scope.photo = scope.photos[currentIndex];
					
					var $elmt = $(elem);
					changeBg($elmt, -1);
					mIntervalID = $interval(function () {
						
						currentIndex = changeBg($elmt, currentIndex);
						
					}, timer);
				}
				scope.$on('$destroy', function() {
					if(mIntervalID) $interval.cancel(mIntervalID);
				});

			}
		};
	}
})();

(function() {
    'use strict';
    angular
        .module('pixerf')
        .controller('bannerHoverChangeCtrl', bannerHoverChangeCtrl);

    bannerHoverChangeCtrl.$inject = [];

    function bannerHoverChangeCtrl() {

        var self = this;
    }
})();
(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('bannerHoverChange', bannerHoverChange);

	function bannerHoverChange() {

		var directive = {
			scope: {
			},
			restrict: 'E',
			templateUrl: 'app/components/banner-hover-change/banner-hover-change.html',
			controller: 'bannerHoverChangeCtrl',
			controllerAs: 'vm',
			replace: true
		};
		return directive;
	}

})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.controller('bannerBoxIntroCtrl', bannerBoxIntroCtrl);

	bannerBoxIntroCtrl.$inject = ['$scope'];

	function bannerBoxIntroCtrl($scope) {

		var self = this;
		self.data = $scope.data;
		self.onBtnClicked = onBtnClicked;

		function onBtnClicked() {
			$scope.onBtnClicked();
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('bannerBoxIntro', bannerBoxIntro);

	function bannerBoxIntro() {

		var directive = {
			scope: {
				data: "=",
				onBtnClicked: "&?",
				isTranscluded: "@?"
			},
			restrict: 'E',
			templateUrl: 'app/components/banner-box-intro/banner-box-intro.html',
			controller: 'bannerBoxIntroCtrl',
			controllerAs: 'vm',
			transclude: true,
			replace: true
		};
		return directive;
	}

})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.factory('bannedUserPopupSvc', bannedUserPopupSvc);
		bannedUserPopupSvc.$inject = ['$uibModal', '$translate'];

	function bannedUserPopupSvc($uibModal, $translate) {

        function validateForm(data, form){
            form.$setDirty();
            var errMsg = '';
            if(form.name.$error.required){
                errMsg = $translate.instant('please-input-first-name');
            } else if(form.email.$error.required){
                errMsg = "Please input your email!";
            } else if(form.email.$error.email ){
                errMsg = "Invalid email address";
            } else if(form.source.$error.required){
                errMsg = "Please input source of your photos!";
            }
            return errMsg;
        }

		function showPopup(data) {
			return $uibModal.open({
				templateUrl: 'app/components/banned-user-popup/banned-user-popup.html',
				controller: 'bannedUserPopupCtrl',
				controllerAs: 'vm',
				animation: true,
				backdrop: 'static',
				keyboard: false,
				windowClass: 'banned-user-popup__screen',
				resolve: {
					'resolveData': function () {
						return data;
					}
				}
			});
		}

		return {
            validateForm: validateForm,
			showPopup: showPopup
		};
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('bannedUserPopupCtrl', bannedUserPopupCtrl);

	bannedUserPopupCtrl.$inject = ['$uibModalInstance', '$state', 'pixerfApiMailSvc', 'bannedUserPopupSvc', 'toastr', 'translationSvc', 'resolveData'];

	function bannedUserPopupCtrl($uibModalInstance, $state, pixerfApiMailSvc, bannedUserPopupSvc, toastr, translationSvc, resolveData) {

		var self = this;
		self.close = close;
		self.inquiry = {};
		self.sendEnquire = sendEnquire;
		self.state = 2;
		self.onEmailAdminBtnClicked = onEmailAdminBtnClicked;
		self.onLogoutBtnClicked = onLogoutBtnClicked;
		self.spinner = {
			isVisible: false
		};
		var isLoggingOut = false;
		

		function close() {
			$uibModalInstance.close();
		}

		function sendEnquire(data, form) {
			if (self.isWorking) return;
			var errMsg = bannedUserPopupSvc.validateForm(data, form);
			if (errMsg) {
				toastr.error(errMsg);
				return false;
			}
			self.isWorking = true;
			pixerfApiMailSvc.enquire(data).$promise.then(function (respone) {
				self.inquiry = {};
				self.isWorking = false;
				self.state = 1;
				toastr.success("Thanks for your submission, we'll get back to you soon!");
			}, function () {
				self.isWorking = false;
				toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
			});
		}

		function onEmailAdminBtnClicked(){

			// self.state = 2;
		}

		function onLogoutBtnClicked(){
			self.spinner.isVisible = true;
			isLoggingOut = true;
			self.isWorking = true;
			$state.go('logout');
		}

		function init(){
		}

		init();
	}
})();

(function () {
  'use strict';

  angular
    .module('pixerf')
    .directive('bannedUserBtn', bannedUserBtn);

  function bannedUserBtn() {

    var directive = {
      scope: {
        "user" : "=",
        "onSuggestStatusChanged": "&"
      },
      restrict: 'E',
      templateUrl: 'app/components/banned-user-btn/banned-user-btn.html',
      controller: 'BannedUserBtnCtrl',
      controllerAs: 'vm',
      replace: true
    };
    return directive;
  }

})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('BannedUserBtnCtrl', BannedUserBtnCtrl);

		BannedUserBtnCtrl.$inject = ['$scope','pixerfApiUserSvc', 'toastr', 'sessionManagerSvc', 'pixerfConfirmPopupSvc', 'translationSvc', '$q'];

    function BannedUserBtnCtrl( $scope, pixerfApiUserSvc, toastr, sessionManagerSvc, pixerfConfirmPopupSvc, translationSvc, $q) {

		var self = this;
		self.isLoginedUser = sessionManagerSvc.getCurrentLoginUser();
        self.onBanClicked = onBanClicked;
        self.btnLabel = "";

        self.onMouseOver = onMouseOver;
        self.onMouseLeave = onMouseLeave;
        self.isHovering = false;

        $scope.$watch('user.is_banned', function(newValue, oldValue){
            if($scope.user){
                setBtnLabel();
            }
        });

        function onBanClicked(){
			var pixerfConfirmPopup = pixerfConfirmPopupSvc.showPopup({
				hideTitle: true,
				hideConfirmText: true,
				message: !$scope.user.is_banned ? "Are you sure you want to ban this user profile?": "Are you sure you want to unban this user profile?",
				okFn: function(){
					var def = $q.defer();
					pixerfApiUserSvc.toogle_ban({id: $scope.user.id}, {}).$promise.then(function(response){
						$scope.user.is_banned = !$scope.user.is_banned;
						def.resolve();
					}, function(){
						toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
						def.reject;
					});
					return def.promise;
				},
				okFnCallback: function(){
					self.isWorking = false;
					setBtnLabel();
					var successfulMesage = !!$scope.user.is_banned ? "This user profile has been successfully banned!" : ("This user profile has been successfully unban!");
					toastr.success(successfulMesage);
					self.isHovering = false;
					if(self.isMine){
						updateCurrentLoginUser();
					}
				}
			})

			pixerfConfirmPopup.result.then(function(){},function(){
			});
        }

		function updateCurrentLoginUser(){
            mLoginnedUser = sessionManagerSvc.getCurrentLoginUser().data;
            mLoginnedUser.is_banned = $scope.user.is_banned;
            accountUtils.transformUserData(mLoginnedUser);
            sessionManagerSvc.setCurrentLoginUser(mLoginnedUser);
        }
        function setBtnLabel(){
            self.btnLabel = $scope.user.is_banned ? "Profile banned" : "Ban Profile";
        }
        function onMouseOver(){
            if(!$scope.user.is_banned) return;
            self.isHovering = true;
            self.btnLabel =  "Unban Profile";
        }
        function onMouseLeave(){
            self.isHovering = false;
            if(!$scope.user.is_banned) return;
            self.btnLabel =  "Profile banned";
        }
    }
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('backgroundSlider', backgroundSlider);
	backgroundSlider.$inject = [];
	function backgroundSlider() {
		return {
			scope: {
				noWatermark: "=",
				photos: "=",
				timer: "@",
				hideAuthor: "@",
				onSubbgChanged: "&?"
			},
			templateUrl: 'app/components/background-slider/background-slider.html',
			restrict: 'E',
			replace: true
		};
	}
})();
(function () {
	'use strict';

	angular
		.module('pixerf')
		.factory('authSvc', authSvc);

	authSvc.$inject = ['messageConst', 'accountConst', '$state', 'signInSvc', 'sessionManagerSvc', '$rootScope', 'commonConst', 'selectSignUpTypePopupSvc'];

	function authSvc(messageConst, accountConst, $state, signInSvc, sessionManagerSvc, $rootScope, commonConst, selectSignUpTypePopupSvc) {

		$rootScope.$on(messageConst.BROADCAST.USER_DATA_CHANGE, function () {
			updateUserInfo(sessionManagerSvc.getCurrentLoginUser().data);
		});

		var mUser = {
			data: null
		}

		function getUser() {
			var userData = sessionManagerSvc.getCurrentLoginUser().data;
			updateUserInfo(userData);
			return mUser;
		}

		function updateUserInfo(newData) {
			if (newData) {
				mUser.data = newData;
			}
		}

		function showSignUpModal() {
			selectSignUpTypePopupSvc.showPopup();
		}

		function showSignInModal() {
			signInSvc.showSignInModal();
		}

		function navigateTo() {
			var loginedUser = sessionManagerSvc.getCurrentLoginUser().data;
			switch (loginedUser.account_type) {
				case accountConst.ACCOUNT_TYPE.BUSINESS:
					$state.go(commonConst.STATE.EDIT_BUSINESS_PROFILE);
					break;
				default:
					$state.go(commonConst.STATE.EDIT_PERSONAL_PROFILE);
			}
		}

		return {
			getUser: getUser,
			showSignUpModal: showSignUpModal,
			showSignInModal: showSignInModal,
			navigateTo: navigateTo,
			updateUserInfo: updateUserInfo
		};
	}
})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.controller('authCtrl', authCtrl);

	authCtrl.$inject = ['authSvc', '$scope', '$state', 'sessionManagerSvc', 'uploadPhotoSvc', '$timeout', '$translate', 'commonConst', '$rootScope', 'messageConst', 'selectSignUpTypePopupSvc', 'signInPopupSvc', 'settingSvc'];

	function authCtrl(authSvc, $scope, $state, sessionManagerSvc, uploadPhotoSvc, $timeout, $translate, commonConst, $rootScope, messageConst, selectSignUpTypePopupSvc, signInPopupSvc, settingSvc) {

		var self = this;
		self.user = authSvc.getUser();
		self.onSignUpBtnClicked = onSignUpBtnClicked;
		self.onSignInBtnClicked = onSignInBtnClicked;
		self.isAuthenticated = function () {
			return !!sessionManagerSvc.getCurrentLoginUser().data;
		};
		self.showUploadModal = showUploadModal;
		self.selectedDefaultIndex = 0;
		self.onSettingClicked = authSvc.navigateTo;
		self.onCloseBtnClicked = onCloseBtnClicked;
		self.onManageMissionClicked = onManageMissionClicked;
		self.onManageCommissionClicked = onManageCommissionClicked;
		self.onManageCommunityClicked = onManageCommunityClicked;
		self.onManageEventClicked = onManageEventClicked;
		self.onManageReportsClicked = onManageReportsClicked;
        self.onManageMediaPostClicked = onManageMediaPostClicked;
		self.onProfileMenuToggle = onProfileMenuToggle;
		self.isViewMoreActived = isViewMoreActived;
        self.isAbleToChangePassword = settingSvc.isAbleToChangePassword();
		self.isWorking = false;
		self.selectedLanguage = 'en';
		self.onLanguagesSelected = onLanguagesSelected;
		self.loginedUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.guestUser = self.loginedUser && !self.loginedUser.account_type;
		$rootScope.$on(messageConst.BROADCAST.USER_DATA_CHANGE, function () {
			self.loginedUser = sessionManagerSvc.getCurrentLoginUser().data;
			self.updatingdAvatar = true;
			self.guestUser = self.loginedUser && !self.loginedUser.account_type;
			$timeout(function () {
				self.updatingdAvatar = false;
			}, 500)
		});

		$rootScope.$on('initLang', function(event, language){
			self.selectedLanguage = language || 'en';
		})

		function showUploadModal() {
			onCloseBtnClicked();
			uploadPhotoSvc.showUploadModal();
		}

		function onSignUpBtnClicked() {
			onCloseBtnClicked();
			selectSignUpTypePopupSvc.showPopup();
		}

		function onSignInBtnClicked() {
			onCloseBtnClicked();
			signInPopupSvc.showPopup();
		}

		function onCloseBtnClicked() {
			$timeout(function () {
				$("body").trigger("click");
			});
		}

		function onManageMissionClicked() {
			if (self.user && self.user.data && self.user.data.canCreateMission) {
				// $state.go("setting.manage-missions.create-mission.getting-started");
				$state.go("setting.manage-missions.on-going");
			}
			onCloseBtnClicked();
		}

		function onManageCommissionClicked() {
			$state.go("setting.manage-custom-commissions.on-going");
		}

		function onProfileMenuToggle(open) {
			self.isProfileMenuOpen = open;
		}

		function onLanguagesSelected(language) {
			$translate.use(language.value);
			$rootScope.lang = language.value;
			moment.locale(language.value);
			self.selectedLanguage = language.value;
		}

		function onManageCommunityClicked() {
			$state.go('setting.manage-communities.communities');
			onCloseBtnClicked();
		}

		function onManageEventClicked() {
			if (self.user && self.user.data && self.user.data.canManageCommunity) {
				$state.go(commonConst.STATE.MANAGE_EVENTS);
			} else {
				$state.go(commonConst.STATE.MANAGE_JOINED_COMMUNITIES);
			}
			onCloseBtnClicked();
		}

		function onManageReportsClicked() {
			if (self.user && self.user.data && self.user.data.canManageCommunity) {
				$state.go(commonConst.STATE.MANAGE_REPORTS);
			} else {
				$state.go(commonConst.STATE.MANAGE_JOINED_COMMUNITIES);
			}
			onCloseBtnClicked();
		}

		function isViewMoreActived(){
			if (!$state || !$state.current) return;

			var currentStateName = $state.current.name;
			var viewMoreStates = ['buy-stock-page.temporary-photos', 'buy-stock-page.photographers.featuredPhotographer', 'buy-stock-page.pending-photos', 'buy-stock-page.pending-portfolio', 'buy-stock-page.rejected-photos', 'buy-stock-page.general-photos'];
			return viewMoreStates.includes(currentStateName);
		}

        function onManageMediaPostClicked(){
            $state.go("setting.manage-media-post.create-post");
        }
	}
})();

(function () {
  'use strict';

  angular
    .module('pixerf')
    .directive('pixerfAuth', pixerfAuth);

  function pixerfAuth() {

    var directive = {
      scope: {},
      restrict: 'E',
      templateUrl: 'app/components/auth/auth.html',
      controller: 'authCtrl',
      controllerAs: 'vm',
      replace: true
    };
    return directive;
  }

})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('approveRejectReleaseFormCtrl', approveRejectReleaseFormCtrl);

    approveRejectReleaseFormCtrl.$inject = ['$scope', 'sessionManagerSvc', 'pixerfApiMediaSvc', 'toastr', 'translationSvc'];

    function approveRejectReleaseFormCtrl($scope, sessionManagerSvc, pixerfApiMediaSvc, toastr, translationSvc) {

        var self = this;
        self.loginUser = sessionManagerSvc.getCurrentLoginUser().data;
        self.review = review;
        self.onMouseOver = onMouseOver;
        self.onMouseLeave = onMouseLeave;
        self.isWorking = false;
        var mOriginalBtnLabel = ''

        setBtnLabel($scope.file);

        function buildReviewAction(action){
            var reviewAction = {"rejected": [],"approved": []};
            if(action === "pend") return reviewAction;
            action = action === "approve" ? "approved" : "rejected";
            reviewAction[action] = _.reduce($scope.file.releases, function(memo, item){
                memo.push(item.id);
                return memo;
            }, []);
            return reviewAction;
        }

        function getReviewAction(photo){
            if(photo.status === "rejected"){
                return "approve";
            }
            if(photo.status === "approved"){
                return "reject";
            }
        }
        function review(action){
            if(!action) action = getReviewAction($scope.file);
            self.isWorking = true;
            pixerfApiMediaSvc.review({id: $scope.file.id}, buildReviewAction(action)).$promise.then(function(response){
                self.isWorking = false;
                $scope.file.status = response.status;
				setBtnLabel($scope.file);
				if(action === 'approve'){
					toastr.success("Commercial licensing has been approved!");
				} else if (action === 'reject'){
					toastr.success("Commercial licensing has been rejected!");
				}
            }, function(){
                self.isWorking = false;
                toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
            })
        }
        function setBtnLabel(photo){
            self.btnLabel = photo.status === "approved" ? "Approved" : "Rejected";
            mOriginalBtnLabel = self.btnLabel;
        }
        function onMouseOver(photo){
            if(photo.status === "rejected"){
                self.btnLabel =  "Approve For Commercial";
            } else {
                self.btnLabel =  "Reject";
            }
        }
        function onMouseLeave(){
            self.btnLabel =  mOriginalBtnLabel;
        }
    }
})();

(function () {
  'use strict';

  angular
    .module('pixerf')
    .directive('approveRejectReleaseForm', approveRejectReleaseForm);

  function approveRejectReleaseForm() {

    var directive = {
      scope: {
        "file" : "=",
        "alert": "="
      },
      restrict: 'E',
      templateUrl: 'app/components/approve-reject-release-form/approve-reject-release-form.html',
      controller: 'approveRejectReleaseFormCtrl',
      controllerAs: 'vm',
      replace: true
    };
    return directive;
  }

})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.factory('alertMessagePopupSvc', alertMessagePopupSvc);
	alertMessagePopupSvc.$inject = ['$uibModal'];

	function alertMessagePopupSvc($uibModal) {
		function showPopup(data) {
			return $uibModal.open({
				templateUrl: 'app/components/alert-message-popup/alert-message-popup.html',
				controller: 'alertMessagePopupCtrl',
				controllerAs: 'vm',
				animation: true,
				windowClass: 'zindex alert-message-popup__screen ' + (data.windowClass || ''),
				resolve: {
					'resolveData': function () {
						return data;
					}
				}
			});
		}

		return {
			showPopup: showPopup
		};
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('alertMessagePopupCtrl', alertMessagePopupCtrl);

	alertMessagePopupCtrl.$inject = ['$uibModalInstance', 'resolveData', '$state'];

	function alertMessagePopupCtrl($uibModalInstance, resolveData, $state) {

		var self = this;
		self.title = resolveData.title;
		self.description = resolveData.description;
		self.close = close;
		self.isPaymentSuccessContex = resolveData.paymentSuccessContex;

		self.close = function () {
			$uibModalInstance.dismiss('close');
		};

		self.onContinue = function(){
			$state.go('for-creator-page.about-community');
			self.close();;
		}
	}
})();

/**
 * Controller for home module
 */
(function(){
  'use strict';
  angular
    .module('pixerf')
    .factory('alertSvc', alertSvc);

    alertSvc.$inject = ['$timeout'];

    function alertSvc($timeout){
        function Alert(){
            this.isVisible = false;
            this.message = '';
        }
        Alert.prototype = (function(){
            function showMsg(){
                var self = this;
                self.isVisible = true;
                $timeout(function(){
                    close.call(self);        
                }, 3000);
            }
            function error(msg){
                if(this.isVisible) return;
                this.type = 'danger';
                this.msg = msg;
                showMsg.call(this);
                
            }
            function info(msg){
                if(this.isVisible) return;
                this.type = 'info';
                this.msg = msg;
                showMsg.call(this);
            }
            function success(msg){
                if(this.isVisible) return;
                this.type = 'success';
                this.msg = msg;
                showMsg.call(this);
            }

            function close(){
                this.isVisible = false;
            }
            function reset(){
                this.isVisible = false;
                this.msg = "";
            }
            return {
                error: error,
                info: info,
                success: success,
                reset: reset
            }
        })();
        return Alert;
    }
})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('alertCtrl', alertCtrl);

    alertCtrl.$inject = ['$scope','alertSvc'];

    function alertCtrl(scope, alertSvc) {
        var self = this;
        scope.instance = new alertSvc();
        scope.instance.reset();
    }
})();
(function () {
  'use strict';

  angular
    .module('pixerf')
    .directive('pixerfAlert', pixerfAlert);

  function pixerfAlert() {

    var directive = {
      scope: {
          "instance": "="
      },
      restrict: 'E',
      templateUrl: 'app/components/alert/alert.html',
      controller: 'alertCtrl',
      controllerAs: 'vm',
      replace: true
    };
    return directive;
  }

})();

/**
 * Controller for home module
 */
(function(){
  'use strict';
  angular
    .module('pixerf')
    .factory('agreementPopupSvc', agreementPopupSvc);
    agreementPopupSvc.$inject = ['$uibModalStack', '$uibModal'];

    function agreementPopupSvc($uibModalStack, $uibModal){
        function showPopup(data){
            return $uibModal.open({
                templateUrl: 'app/components/agreement-popup/agreement-popup.html',
                controller: 'agreementPopupCtrl',
                controllerAs: 'vm',
                animation: true,
                windowClass: 'zindex ' + data.windowClass,
                resolve: {
                    'resolveData': function(){
                        return data;
                    }
                }
            });

        }
        
        return {
            showPopup: showPopup
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('agreementPopupCtrl', agreementPopupCtrl);

    agreementPopupCtrl.$inject = ['$uibModalInstance','resolveData'];

    function agreementPopupCtrl($uibModalInstance, resolveData) {

        var self = this;
        self.message = resolveData.message;
        self.okBtnText = resolveData.okBtnText ? resolveData.okBtnText : 'OK';
        self.cancelBtnText = resolveData.cancelBtnText ? resolveData.cancelBtnText : 'No, thanks!';
        self.isAgree = false;
        self.isWorking = false;
        self.ok = function () {
            if(resolveData.okFn){
                if(self.isWorking) return;
                self.isWorking = true;
                resolveData.okFn(self.isAgree).then(function(){
                    self.isWorking = false;
                }, function(){
                    self.isWorking = false;
                });
            } else {
                $uibModalInstance.close();
            }
        };

        self.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();

(function () {
  'use strict';

  angular
    .module('pixerf')
    .directive('adultContentOverlay', adultContentOverlay);

  function adultContentOverlay() {

    var directive = {
      restrict: 'E',
      scope: {
        buttonShow: '='
      },
      templateUrl: 'app/components/adult-content-overlay/adult-content-overlay.html',
      controllerAs: 'vm',
      replace: true
    };
    return directive;
  }

})();

(function () {

	angular
		.module('pixerf')
		.factory('additionalEntriesPopupSvc', additionalEntriesPopupSvc);

	additionalEntriesPopupSvc.$inject = ['$uibModal'];

	function additionalEntriesPopupSvc($uibModal) {

		function showPopup(data) {
			return $uibModal.open({
				templateUrl: 'app/components/additional-entries-popup/additional-entries-popup.html',
				controller: 'additionalEntriesPopupCtrl',
				controllerAs: 'vm',
				animation: true,
				windowClass: 'zindex additional-entries-screen',
				backdrop: 'static',
				resolve: {
					popupData: function () {
						return data;
					}
				}
			});
		}

		return {
			showPopup: showPopup
		};
	}
})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('additionalEntriesPopupCtrl', additionalEntriesPopupCtrl);

    additionalEntriesPopupCtrl.$inject = ['popupData', '$uibModalInstance', 'systemUtils', '$scope'];

    function additionalEntriesPopupCtrl(popupData, $uibModalInstance, systemUtils, $scope) {

        var self = this;
        self.popupData = popupData;
        self.onCancelClicked = onCancelClicked;
        self.onSubmitClicked = onSubmitClicked;
        self.onQuantityChanged = onQuantityChanged;
        self.isFormDirty = false;
        self.geoGraphicInstance = {};
        self.quantities = [];
        self.isDisabledUloadbtn = true;

        self.bootstrapSelectOptions = {"dropupAuto": false, "noneSelectedText": "", "maxOptions": 1};

        self.quantities = initDropdownList();
        function initDropdownList(){
            var noOfItems = self.popupData.ioaSubscriber.total_balance - self.popupData.ioaSubscriber.free_balance;
            var remainArr = [];
            for(var i = 0; i < noOfItems; i++){
                remainArr.push({id: i, name: (i + 1)});
            }
            return remainArr;
        }
		function onCancelClicked(){
            $uibModalInstance.dismiss();
        }
        function onSubmitClicked(form){
            self.popupData.ioaSubscriber.total_balance = self.geoGraphicInstance.additionalEntries[0].name;
            $uibModalInstance.close(self.popupData);
        }
        function onQuantityChanged(quantity){
            if(quantity && quantity.length > 0){
                self.isDisabledUloadbtn = false;
            } else {
                self.isDisabledUloadbtn = true;
            }
            systemUtils.digest($scope);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .factory('addToPortfolioGallerySvc', addToPortfolioGallerySvc);

     addToPortfolioGallerySvc.$inject = ['pixerfApiCategorySvc', 'portfolioUtils'];

    function addToPortfolioGallerySvc(pixerfApiCategorySvc, portfolioUtils) {

        var mScope = null;
        function getScope(){
            return mScope;
        }
        function setScope(value){
            return mScope = value;
        }
        var mIsOpen = null;
        function turnOffOthers(isOpen){
			if(mIsOpen){
				mIsOpen.data = false;
			}
			mIsOpen = isOpen;
        }

        function buildPortfolioGalleriesNames(portfolioGalleries){
            var names = portfolioUtils.extractGalleriesName(portfolioGalleries);
            return (names.length > 0 ? names.join(', ') : 'choose-portfolio-gallery');
        }
        return {
            getScope: getScope,
            setScope: setScope,
            buildPortfolioGalleriesNames: buildPortfolioGalleriesNames,
            turnOffOthers: turnOffOthers
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('addToPortfolioGalleryCtrl', addToPortfolioGalleryCtrl);

    addToPortfolioGalleryCtrl.$inject = ['$rootScope','$scope', 'createPortfolioGallerySvc', 'addToGallerySvc', 'portfolioGalleriesListSvc', 'sessionManagerSvc', 'portfolioConst', 'pixerfApiMediaSvc', '$q', 'toastr', 'systemUtils', '$translate'];

    function addToPortfolioGalleryCtrl($rootScope, $scope, createPortfolioGallerySvc, addToGallerySvc, portfolioGalleriesListSvc, sessionManagerSvc, portfolioConst, pixerfApiMediaSvc, $q, toastr, systemUtils, $translate) {

        var self = this;

        self.galleryListInstance = null;
        self.isOpen = {data: false};
        self.isEnable = true;
        self.onCreatePortfolioGalleryBtnClicked = onCreatePortfolioGalleryBtnClicked;
        self.onPortfolioGalleryItemClicked = onPortfolioGalleryItemClicked;
        self.onPortfolioGalleriesChanged = onPortfolioGalleriesChanged;
        self.loginUser =  sessionManagerSvc.getCurrentLoginUser().data;
        self.clickOutSide = clickOutSide;
        self.portfolioId = $scope.portfolioId;
        $scope.$watch("portfolioId", function(){
            self.portfolioId = $scope.portfolioId;
        });
        $scope.$watch("vm.isOpen.data", function(){
            if(!self.loginUser) {
                self.isEnable = false;
                return;
            }
            if(self.isOpen.data){
                if($scope.file && $scope.file.id){
                    if(!$scope.file.galleries){
                        getMediaDetail($scope.file.id).then(function(response){
                            $scope.file.galleries = response.data.galleries;
                        }, function(){
                            toastr.error("Failed to get photo information");
                        });
                    }
                }
                onOpen();
            } else {
                onClose();
            }
        });
        function clickOutSide(){
            $("body").trigger("click");
        }
        function getMediaDetail(mediaid){
            var def = $q.defer();

            pixerfApiMediaSvc.get({id: $scope.file.id}).$promise.then(function(response){
                def.resolve(response);
            }, function(err){
                def.reject(err);
            })
            return def.promise;
        }
        function onPortfolioGalleriesChanged(galleries){
            if($scope.file && $scope.file.galleries && $scope.file.galleries.length > 0){
                portfolioGalleriesListSvc.checkPortfolioGalleries(galleries,  $scope.file.galleries);
            }
        }
        function onPortfolioGalleryItemClicked(evt, portfolioGallery){
            portfolioGallery.isSelected  = !portfolioGallery.isSelected;
            if($scope.onPortfolioGalleryItemClicked){
                $scope.onPortfolioGalleryItemClicked({file: $scope.file, portfolioGallery: portfolioGallery});
            }
            if($scope.closeOnClick && evt && !evt.shiftKey){
                $("body").trigger("click");
                evt.stopPropagation();
            } else {
                systemUtils.preventTextSelection();
            }
        }
        function onClose(){
            if($scope.onClose && !self.isOpen.data){
                $scope.onClose({file:  $scope.file});
            }
        }
        function onOpen(){
            if($scope.onOpen && self.isOpen.data){
                $scope.onOpen({file:  $scope.file});
            }
        }
        function onCreatePortfolioGalleryBtnClicked(){
            if(self.portfolioGalleryListInstance && self.portfolioGalleryListInstance.portfolios && self.portfolioGalleryListInstance.portfolios.data
                && !!self.portfolioGalleryListInstance.portfolios.data.length && self.portfolioGalleryListInstance.portfolios.data.length >= portfolioConst.MAX_GALLERY ){
                $translate('create-maximum-portfolio-galleries').then(function(data){
                    toastr.error(data);
                });
            } else {
                var modal = createPortfolioGallerySvc.showCreatePortfolioGalleryModal({overridSuccessMsg: true, speciality_id: self.portfolioId});
                modal.result.then(function(newCreatedPortfolioGallery){
                    if($scope.addWhenGalleryCreated){
                        self.onPortfolioGalleryItemClicked(null, newCreatedPortfolioGallery);
                    }
                }, function(){

                })
            }
        }
    }
})();
(function () {
	'use strict';

	angular
	  .module('pixerf')
	  .directive('addToPortfolioGallery', addToPortfolioGallery);

	function addToPortfolioGallery() {

	  var directive = {
		scope: {
		  'isDisabled': '=',
			'onPortfolioGalleryItemClicked': '&',
			'portfolioId': '@',
		  'file': '=',
		  'onOpen': '&',
		  'onClose': '&',
		  'spinner': '=',
		  'isLastPage': '=',
		  'closeOnClick': '@',
		  'addWhenGalleryCreated': '='
		},
		restrict: 'E',
		controller: 'addToPortfolioGalleryCtrl',
		controllerAs: 'vm',
		replace: false,
		transclude: true,
		link: function(scope, element, attrs, ctrl, transclude){
			transclude(scope, function(clone, scope) {
			  element.append(clone);
			});
		}
	  };
	  return directive;
	}

  })();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .factory('addToGallerySvc', addToGallerySvc);

     addToGallerySvc.$inject = ['galleryUtils'];

    function addToGallerySvc(galleryUtils) {

        var mScope = null;
        function getScope(){
            return mScope;
        }
        function setScope(value){
            return mScope = value;
        }
        var mIsOpen = null;
        function turnOffOthers(isOpen){
            if(mIsOpen){
                mIsOpen.data = false;
            }
            mIsOpen = isOpen;
        }
        
        function buildGalleriesNames(galleries){
            var names = galleryUtils.extractGalleriesName(galleries);
            return (names.length > 0 ? names.join(', ') : 'Choose Gallery');
        }
        return {
            getScope: getScope,
            setScope: setScope,
            buildGalleriesNames: buildGalleriesNames,
            turnOffOthers: turnOffOthers
        };
    }
})();
(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('addToGalleryCtrl', addToGalleryCtrl);

    addToGalleryCtrl.$inject = ['$rootScope','$scope', 'createGallerySvc', 'addToGallerySvc', 'galleriesListSvc', 'sessionManagerSvc', 'galleryConst', 'pixerfApiMediaSvc', '$q', 'toastr', 'systemUtils'];

    function addToGalleryCtrl($rootScope, $scope, createGallerySvc, addToGallerySvc, galleriesListSvc, sessionManagerSvc, galleryConst, pixerfApiMediaSvc, $q, toastr, systemUtils) {

        var self = this;

        self.galleryListInstance = null;
        self.isOpen = {data: false};
        self.isEnable = true;
        self.onCreateGalleryBtnClicked = onCreateGalleryBtnClicked;
        self.onGalleryItemClicked = onGalleryItemClicked;
        self.onGalleriesChanged = onGalleriesChanged;
        self.galleryType = null;
        self.loginUser =  sessionManagerSvc.getCurrentLoginUser().data;
        self.clickOutSide = clickOutSide;
        self.isCuratedGalleryChecked = true;
        self.isMyGalleryChecked = true;
        self.onGalleryCheckboxCheck = onGalleryCheckboxCheck;
        $scope.$watch("vm.isOpen.data", function(){
            if(!self.loginUser) {
                self.isEnable = false;
                return;
            }

            setGalleryType();
            if(self.isOpen.data){
                if($scope.file && $scope.file.id){
                    if(!$scope.file.galleries  || !$scope.file.categories){
                        getMediaDetail($scope.file.id).then(function(response){
                            $scope.file.galleries = response.data.galleries;
                            $scope.file.categories = response.data.categories;
                        }, function(){
                            toastr.error("Failed to get photo information");
                        })
                    }
                }
                onOpen();
            } else {
                onClose();
            }
        });
        function onGalleryCheckboxCheck(){
            if(self.isMyGalleryChecked && self.isCuratedGalleryChecked ||
               (!self.isMyGalleryChecked && !self.isCuratedGalleryChecked)){
                    self.galleryType = null;
            } else {
                self.galleryType = self.isMyGalleryChecked ? galleryConst.GALLERY_TYPE.DEFAULT : galleryConst.GALLERY_TYPE.CURATED;
            }
        }
        function clickOutSide(){
            $("body").trigger("click");
        }
        function getMediaDetail(mediaid){
            var def = $q.defer();

            pixerfApiMediaSvc.get({id: $scope.file.id}).$promise.then(function(response){
                def.resolve(response);
            }, function(err){
                def.reject(err);
            })
            return def.promise;
        }
        function setGalleryType(){
            if(!$scope.file) return;
            var isMyPhoto = sessionManagerSvc.isMyPhoto($scope.file);
            $scope.file.isMine = isMyPhoto;
            if(isMyPhoto){
                self.isMyGalleryChecked = true;
                self.isCuratedGalleryChecked = false;
                self.galleryType = galleryConst.GALLERY_TYPE.DEFAULT;
            } else {
                self.galleryType = galleryConst.GALLERY_TYPE.CURATED;
            }
        }
        function onGalleriesChanged(galleries){
            if($scope.file && $scope.file.galleries && $scope.file.galleries.length > 0){
                galleriesListSvc.checkGalleries(galleries,  $scope.file.galleries);
            }
        }
        function onGalleryItemClicked(evt, gallery){
            if($scope.file && $scope.file.state==="r"){
                toastr.error("Hi, this photo cannot be added to gallery because it's rejected photo!");
                return;
            }
            gallery.isSelected  = !gallery.isSelected;
            if($scope.onGalleryItemClicked){
                $scope.onGalleryItemClicked({file: $scope.file, gallery: gallery});
            }
            if($scope.closeOnClick && evt && !evt.shiftKey){
                $("body").trigger("click");
                evt.stopPropagation();
            } else {
                systemUtils.preventTextSelection();
            }
        }
        function onClose(){
            if($scope.onClose && !self.isOpen.data){
                $scope.onClose({file:  $scope.file});
            }
        }
        function onOpen(){
            if($scope.onOpen && self.isOpen.data){
                $scope.onOpen({file:  $scope.file});
            }
        }
        function onCreateGalleryBtnClicked(){
            var modal = createGallerySvc.showCreateGalleryModal({type: self.galleryType, overridSuccessMsg: true});
            modal.result.then(function(newCreatedGallery){
                if($scope.addWhenGalleryCreated){
                    self.onGalleryItemClicked(null, newCreatedGallery);
                }
            }, function(){

            })
        }
    }
})();
(function () {
  'use strict';

  angular
    .module('pixerf')
    .directive('addToGallery', addToGallery);

  function addToGallery() {

    var directive = {
      scope: {
        'isDisabled': '=',
        'onGalleryItemClicked': '&',
        'file': '=',
        'onOpen': '&',
        'onClose': '&',
        'spinner': '=',
        'loadMoreGalleries': '&',
        'isLastPage': '=',
        'closeOnClick': '@',
        'addWhenGalleryCreated': '='
      },
      restrict: 'E',
      controller: 'addToGalleryCtrl',
      controllerAs: 'vm',
      replace: false,
      transclude: true,
      link: function(scope, element, attrs, ctrl, transclude){
          transclude(scope, function(clone, scope) {
            element.append(clone);
          });
      }
    };
    return directive;
  }

})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .factory('addToCartBtnSvc', addToCartBtnSvc);

     addToCartBtnSvc.$inject = [];

    function addToCartBtnSvc() {

        function buildSavedCartItem(media, isSelectLowestPrice){
            var savedCartItemData = {
                "size": null,
                "is_unlimited_print": false,
                "is_multi_seat": false,
                "is_for_resale": false,
                "media_id": media.id
            };
            if(media && media.extendedLicenses && media.extendedLicenses.length){
                for (var i = 0; i < media.extendedLicenses.length; i ++){
                    savedCartItemData[media.extendedLicenses[i].key] = media.extendedLicenses[i].isSelected;
                }
            }
            for (var i = 0; i < media.price.range.length; i ++){
                if(media.price.range[i].isSelected){
                    savedCartItemData.size = media.price.range[i].size;
                }
            }

            if(isSelectLowestPrice){
                savedCartItemData.size = media.price.range[0].size;
            }
            return savedCartItemData;

        }
        function validate(cartItemData){
            var errMsg = "";
            if(!cartItemData.size) errMsg = "Size is not set";
            return errMsg;
        }
        return {
           buildSavedCartItem: buildSavedCartItem,
           validate: validate
        };
    }
})();
(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('addToCartBtnCtrl', addToCartBtnCtrl);

    addToCartBtnCtrl.$inject = ['$scope', 'popoverCartSvc', '$uibModalStack', 'toastr', 'addToCartBtnSvc', 'cartSvc', 'commonConst', 'messageConst', 'messageSvc',
     'translationSvc', 'sessionManagerSvc', 'store', 'accountConst'];

    function addToCartBtnCtrl( $scope, popoverCartSvc, $uibModalStack, toastr, addToCartBtnSvc, cartSvc, commonConst, messageConst, messageSvc, translationSvc
        , sessionManagerSvc, store, accountConst) {

        var self = this;
        self.onAddToCartClicked = onAddToCartClicked;
        self.onRequestLicenseBtnClicked = onRequestLicenseBtnClicked;

        self.isWorking = false;
        function onAddToCartClicked(media){
            if(self.isWorking) return;
            self.isWorking = true;
            var mLoginnedUser = sessionManagerSvc.getCurrentLoginUser().data;
            if(!mLoginnedUser){
                return onAddToCartForGuestUser(media);
            }
            var savedCartItemData = addToCartBtnSvc.buildSavedCartItem(media);
            console.log(savedCartItemData);
            var errMsg = addToCartBtnSvc.validate(savedCartItemData);
            if(errMsg) toastr(errMsg);

            var action = $scope.mode === commonConst.ACTION.EDIT ? "updateItemInCart" : "addItemToCart";
            cartSvc[action](savedCartItemData).then(function(response){
                self.isWorking = false;
                $uibModalStack.dismissAll();
                if($scope.onAdded){
                    var addedCartItem = cartSvc.getCartItemByMediaId(response.data, media.id);
                    $scope.onAdded({'addedCartItem': addedCartItem});
                }
            }).catch(function(err){
                self.isWorking = false;
                var message = translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true);
                if(err.data && err.data.message === "MEDIA_IN_MISSION"){
                    message = messageSvc.compile(messageConst.error.MISSION_CART, {photo_name: ": " + media.data.title , quantity: 1});
                    media.data.in_mission = true;
                }
                toastr.error(message);
            });
        }
        function onAddToCartForGuestUser(media) {
            var guestUserToken = store.get(accountConst.TOKEN.GUEST_USER_TOKEN);
            if(guestUserToken){
                processAddToCard(guestUserToken, media);
            }else{
                cartSvc.generateUUID(10, processAddToCard, media);
            }

            function processAddToCard(uuid, media) {
                if( !store.get(accountConst.TOKEN.GUEST_USER_TOKEN)){
                    store.set(accountConst.TOKEN.GUEST_USER_TOKEN, uuid);
                }
                
                var savedCartItemData = addToCartBtnSvc.buildSavedCartItem(media);
                console.log(savedCartItemData);
                var errMsg = addToCartBtnSvc.validate(savedCartItemData);
                if (errMsg) toastr(errMsg);

                var action = $scope.mode === commonConst.ACTION.EDIT ? "updateItemInCart" : "addItemToCart";
                cartSvc[action](savedCartItemData, uuid).then(function (response) {
                    self.isWorking = false;
                    $uibModalStack.dismissAll();
                    if ($scope.onAdded) {
                        var addedCartItem = cartSvc.getCartItemByMediaId(response.data, media.id);
                        $scope.onAdded({ 'addedCartItem': addedCartItem });
                    }
                }).catch(function (err) {
                    self.isWorking = false;
                    var message = translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true);
                    if (err.data && err.data.message === "MEDIA_IN_MISSION") {
                        message = messageSvc.compile(messageConst.error.MISSION_CART, { photo_name: ": " + media.data.title, quantity: 1 });
                        media.data.in_mission = true;
                    }
                    toastr.error(message);
                });
            }
        }
        function onRequestLicenseBtnClicked(media){

        }
    }
})();

(function () {
  'use strict';

  angular
    .module('pixerf')
    .directive('addToCartBtn', addToCartBtn);

  function addToCartBtn() {

    var directive = {
      scope: {
        "media" : "=",
        "mode": '@',
        "onAdded": '&?',
        "isDisabled": "="
      },
      restrict: 'E',
      templateUrl: 'app/components/add-to-cart-btn/add-to-cart-btn.html',
      controller: 'addToCartBtnCtrl',
      controllerAs: 'vm',
      replace: true
    };
    return directive;
  }

})();

/**
 * Controller for home module
 */
(function(){
  'use strict';
  angular
    .module('pixerf')
    .factory('addRoleSvc', addRoleSvc);
    addRoleSvc.$inject = ['pixerfApiUserSvc', 'toastr', 'sessionManagerSvc', 'messageAccountConst', 'accountConst', '$uibModal'];

    function addRoleSvc(pixerfApiUserSvc, toastr, sessionManagerSvc, messageAccountConst, accountConst, $uibModal){
        var mPersonRoles = {
            data: []
        };
        var mRoles = {
            data: accountConst.ROLES()
        };

        function getPersonRoles(user){
            var totalArr = [];
            for (var i = 0; i < accountConst.ROLES.length; i ++ ){
                var roleName = accountConst.ROLES[i].toLowerCase() + "s";
                totalArr.concat(buildPersonRoles(user.organization[roleName], roleName));
            }
            return totalArr;
        }
        function getRoles(){
            return mRoles;
        }
        function buildPersonRoles(userRoles, role){
            var arr = [];
            for (var i = 0; i < userRoles.length; i ++){
                arr.push({
                    'email': userRoles[i],
                    'role': role
                })
            }
            return arr;
        }
        function validate(personRoles, form){
            for (var i = 0 ; i < personRoles.length; i ++){
                if(form["email_" + i].$error.required){
                    return "Please fill in email";    
                }
                if(form["email_" + i].$error.email){
                    return messageAccountConst.error.validation.email.invalid_format;    
                }
                if(form["role_" + i].$error.required){
                    return "Please fill in role";    
                }
            }
            return "";
        }
        function getPersonRoleByRole(personRoles, role){
            var arrResult = [];
            for (var i = 0; i < personRoles.length; i ++){
                if(personRoles[i].role === role){
                    arrResult.push(personRoles[i].email);
                }
            }
            return arrResult;
        }
        function addPersonRole(personRoles){
            personRoles.push({
                'email': '',
                'role': ''
            })
        }
        function removePersonRole(personRoles, index){
            personRoles.splice(index, 1);
        }
        function showPopup(data){

            $uibModal.open({
                size: "lg",
                templateUrl: 'app/components/add-role/add-role-popup.html',
                controller: 'addRoleCtrl',
                controllerAs: 'vm',
                openedClass: 'add-role-modal',
                resolve: {
                    popupData: function(){
                        return data;
                    }
                }
            });
        }
        function buildSavingData(user, savingRoles){
            user.organization.advertisers = getPersonRoleByRole(savingRoles, accountConst.ACCOUNT_ROLE.ADVERTISER);
            user.organization.curator = getPersonRoleByRole(savingRoles, accountConst.ACCOUNT_ROLE.CURATOR);
            user.organization.marketers = getPersonRoleByRole(savingRoles, accountConst.ACCOUNT_ROLE.MARKETER);
        }
		return {
			getPersonRoles: getPersonRoles,
            getRoles: getRoles,
            addPersonRole: addPersonRole,
            removePersonRole: removePersonRole,
            showPopup: showPopup,
            buildSavingData: buildSavingData
		};
    }
})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('addRoleCtrl', addRoleCtrl);

    addRoleCtrl.$inject = ['$scope', 'addRoleSvc', 'toastr', 'pixerfApiUserSvc'];

    function addRoleCtrl($scope, addRoleSvc, toastr, pixerfApiUserSvc) {

        var self = this;
        
        self.roles = addRoleSvc.getRoles();
        self.personRoles = addRoleSvc.getPersonRoles($scope.user);

        self.onAddPersonRoleBtnClicked = onAddPersonRoleBtnClicked;
        self.removePersonRoleBtnClicked = removePersonRoleBtnClicked;
        self.onSaveBtnClicked = onSaveBtnClicked;

        function onSaveBtnClicked(user, savingRoles, form){
            form.$setDirty();
            var errMsg = addRoleSvc.validate(savingRoles, form);
            if(errMsg){
                toastr.error(errMsg);
                return false;
            }
            addRoleSvc.buildSavingData(user, savingRoles);
            pixerfApiUserSvc.put(user, function(result){
                $scope.onSuccess();
            }, function(){
                $scope.onError();
                
            })
        }
        function onAddPersonRoleBtnClicked(personRoles){
            addRoleSvc.addPersonRole(personRoles);
        }
        function removePersonRoleBtnClicked(personRoles, index){
            addRoleSvc.removePersonRole(personRoles, index);
        }   
    }
})();
(function () {
    'use strict';

    angular
        .module('pixerf')
        .directive('addRole', addRole);

    function addRole() {

        var directive = {
            scope: {
                user: "="
            },
            restrict: 'E',
            controller: 'addRoleCtrl',
            controllerAs: 'vm',
            templateUrl: 'app/components/add-role/add-role.html',
            replace: true
        };
        return directive;
    }

})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('addPaypalMethodPopupCtrl', addPaypalMethodPopupCtrl);

    addPaypalMethodPopupCtrl.$inject = ["$scope", "$window", "socketSvc", "pixerfUrl", "sessionManagerSvc", "systemUtils", "translationSvc", "toastr"];

    function addPaypalMethodPopupCtrl($scope, $window, socketSvc, pixerfUrl, sessionManagerSvc, systemUtils, translationSvc, toastr) {

        var self = this;
        var mPayPalLoginPopup = null;
        var mIsSubscribed = false;
        $scope.payPalData = {
            code: 'PAYPAL',
            name: 'PayPal',
        };

        self.onConnectPayPalBtnClicked = onConnectPayPalBtnClicked;

        function subscribeChannel(){
            var channel = socketSvc.getPrivateChannel();
            if(channel && channel.state === "joined" && !mIsSubscribed){
                mIsSubscribed = true;
                channel.off(socketSvc.PIXERF_TOPICS.PAYPAL);
                channel.on(socketSvc.PIXERF_TOPICS.PAYPAL, function(msg){
                    console.log(msg);
                    if(msg.status === "success"){
                        $scope.payPalData.details = msg.data;
                    } else {
                        toastr.error(msg.data === "Already connected" ? "You already have a payout method connected to this PayPal account." : translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
                    }
                    systemUtils.digest($scope);
                    mPayPalLoginPopup.close();
                })
                channel.onClose(socketSvc.PIXERF_TOPICS.PAYPAL, function(msg){
                    mIsSubscribed = false;
                })
                channel.onError(socketSvc.PIXERF_TOPICS.PAYPAL, function(msg){
                    mIsSubscribed = false;
                })
            }
        }
        function onConnectPayPalBtnClicked(){
            subscribeChannel();
            var popupW = 400;
            var popupH = 600;
            var left = window.innerWidth/2 - popupW/2;
            var top = window.innerHeight/2 - popupH/2;
            var options = "toolbar=yes,scrollbars=yes,resizable=yes,top=";
            options += top;
            options += (",left=" + left);
            options += (",width=" + popupW);
            options += (",height=" + popupH);
            mPayPalLoginPopup = $window.open(pixerfUrl.full + "auth/paypal?state=" +  sessionManagerSvc.getToken(), "_blank", options);
        }
    }
})();

(function () {
  'use strict';

  angular
    .module('pixerf')
    .directive('addPaypalMethodPopup', addPaypalMethodPopup);

  function addPaypalMethodPopup() {

    var directive = {
      scope: {
          alert: '=',
          payPalData: '='
      },
      restrict: 'E',
      templateUrl: 'app/components/add-paypal-method-popup/add-paypal-method-popup.html',
      controller: 'addPaypalMethodPopupCtrl',
      controllerAs: 'vm',
      replace: true
    };
    return directive;
  }

})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.factory('addPayoutMethodPopupSvc', addPayoutMethodPopupSvc);
	addPayoutMethodPopupSvc.$inject = ['$uibModalStack', '$uibModal', 'pixerfApiPayoutMethodSvc'];

	function addPayoutMethodPopupSvc($uibModalStack, $uibModal, pixerfApiPayoutMethodSvc) {
		function showPopup(data) {
			return $uibModal.open({
				templateUrl: 'app/components/add-payout-method-popup/add-payout-method-popup.html',
				controller: 'addPayoutMethodPopupCtrl',
				controllerAs: 'vm',
				animation: true,
				windowClass: 'add-payout-method-popup-screen',
				backdrop: 'static',
				resolve: {
					popupData: function () {
						return data;
					}
				}
			});
		}

		function savePaymentMethod(paymentMethod) {
			var savedPaymentMethod = {
				"id": paymentMethod.id,
				"code": paymentMethod.code,
				"name": paymentMethod.name,
				"details": customTransformDetails(paymentMethod.details),
				"is_default": paymentMethod.is_default
			};
			if (savedPaymentMethod.details.addressCountryCode === "US") {
				savedPaymentMethod.details.addressState = savedPaymentMethod.details.addressState;
			}
			var verb = paymentMethod.id ? "put" : "save";
			return pixerfApiPayoutMethodSvc[verb](savedPaymentMethod).$promise;
		}

		function customTransformDetails(details) {
			var temp = [];
			temp = details.bankCode ? details.bankCode.split(" - ") : [];
			if (temp.length > 1) {
				details.bankCode = temp[0];
				details.swiftCode = temp[1];
			}
			return details;
		}
		return {
			showPopup: showPopup,
			savePaymentMethod: savePaymentMethod
		};
	}
})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('addPayoutMethodPopupCtrl', addPayoutMethodPopupCtrl);

    addPayoutMethodPopupCtrl.$inject = ['$uibModalInstance','$scope', '$timeout', 'toastr', 'registerBankInfoPopupSvc', 'addPayoutMethodPopupSvc', '$q', 'popupData', 'translationSvc'];

    function addPayoutMethodPopupCtrl($uibModalInstance, $scope, $timeout, toastr, registerBankInfoPopupSvc, addPayoutMethodPopupSvc, $q, popupData, translationSvc) {

        var self = this;
        self.closePopup = closePopup;
        self.onBackBtnClicked = onBackBtnClicked;
        self.onNextBtnClicked = onNextBtnClicked;
        self.onFinishBtnClicked = onFinishBtnClicked;
        self.selectedPaymentMethod = null;
        self.addedPayoutMethod = {};
        self.pixerfAlert = null;
        self.isWorking = false;
        $scope.step = 1;

        function closePopup(data){
            $uibModalInstance.close(data);
        }

        function onBackBtnClicked(){
            var firstStep = 1;
            if($scope.step > firstStep){
                $scope.step--;
            } else {
                closePopup();
            }
        }
        function savePaymentMethod(paymentMethod){
            if(self.isWorking) return;
            self.isWorking = true;
            var def = $q.defer();
            paymentMethod.is_default = popupData.isSetAsDefault;
            addPayoutMethodPopupSvc.savePaymentMethod(paymentMethod).then(function(responseData){
                self.isWorking = false;
                toastr.success(responseData.name + " is added as your payout method.");
                $timeout(function(){
                    closePopup(responseData);
                    if(paymentMethod.code === "BANK_TRANSFER"){
                        registerBankInfoPopupSvc.closePopup();
                        def.resolve();
                    }
                }, 2000);
            }, function(){
                def.reject();
                self.isWorking = false;
                toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
            });
            return def.promise;
        }
        function onFinishBtnClicked(){
            if(self.selectedPaymentMethod.code === "PAYPAL" ||
                self.selectedPaymentMethod.code === 'BANK_TRANSFER'){
                savePaymentMethod(self.addedPayoutMethod);
            } else {
                closePopup();
            }
        }
        function onNextBtnClicked(){
            if(!self.selectedPaymentMethod) return;
            self.addedPayoutMethod = {
                code: self.selectedPaymentMethod.code,
                name: self.selectedPaymentMethod.name
            }
            var finalStep = 2;
            if(self.selectedPaymentMethod.code === 'BANK_TRANSFER'){
                registerBankInfoPopupSvc.showPoup({
                    onSaveHandler: function(bankInfo){
                        self.addedPayoutMethod.details = bankInfo;
                        return savePaymentMethod(self.addedPayoutMethod);
                    }
                });
            } else{
                if($scope.step < finalStep){
                    $scope.step++;
                }
            }
        }
    }
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('addInputfieldBtnCtrl', addInputfieldBtnCtrl);

	addInputfieldBtnCtrl.$inject = ['$scope'];

	function addInputfieldBtnCtrl($scope) {

		var self = this;
		var fieldIndex = 0;
		self.addfield = addfield;
		self.removefield = removefield;
		self.maxCount = $scope.maxCount;
		self.minCount = $scope.minCount;
		self.isMinCount = isMinCount;
		self.isMaxCount = isMaxCount;
		if(!$scope.model){
			$scope.model = [];
		}

		if(self.minCount && $scope.model.length < self.minCount && $scope.model.length === 0){
			for(var i = 0; i < self.minCount; i++){
				addfield();
			}
		}

		function addfield() {
			if(isMaxCount()){
				return;
			}
			$scope.model.push({ 'index': fieldIndex });
			fieldIndex++;
			if($scope.onSizeChange){
				onSizeChange();
			}
		}
		function onSizeChange(){
			$scope.onSizeChange();
		}
		function removefield(index) {
			if(isMinCount()){
				return;
			}
			$scope.model = $scope.model.filter(function(inputs){ return inputs.index !== index});
			if($scope.onSizeChange){
				onSizeChange();
			}
		}

		function isMaxCount(){
			return self.maxCount ? $scope.model.length >= parseInt(self.maxCount) : false;
		}

		function isMinCount(){
			return self.minCount ? $scope.model.length <= parseInt(self.minCount) : false;
		}
	}
})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .directive('addInputfieldBtn', addInputfieldBtn);
    addInputfieldBtn.$inject = [];
    function addInputfieldBtn() {
        return {
			scope: {
                model: "=",
                text: "@?",
                placeholder: "@?",
                validate: "=?",
                maxCount: "@?",
                minCount: "@?",
                name: "@?",
                onSizeChange: "&?"
			},
			restrict: 'E',
			controller: 'addInputfieldBtnCtrl',
            controllerAs: 'vm',
            templateUrl: 'app/components/add-inputfield-btn/add-inputfield-btn.html',
            replace: true
        };
    }
})();
(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('addChequeMethodPopupCtrl', addChequeMethodPopupCtrl);

    addChequeMethodPopupCtrl.$inject = ["$scope"];

    function addChequeMethodPopupCtrl($scope) {

        var self = this;
    }
})();
(function () {
  'use strict';

  angular
    .module('pixerf')
    .directive('addChequeMethodPopup', addChequeMethodPopup);

  function addChequeMethodPopup() {

    var directive = {
      scope: {
          alert: '='
      },
      restrict: 'E',
      templateUrl: 'app/components/add-cheque-method-popup/add-cheque-method-popup.html',
      controller: 'addChequeMethodPopupCtrl',
      controllerAs: 'vm',
      replace: true
    };
    return directive;
  }

})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('addBankTransferMethodPopupCtrl', addBankTransferMethodPopupCtrl);

    addBankTransferMethodPopupCtrl.$inject = ["$scope"];

    function addBankTransferMethodPopupCtrl($scope) {

        var self = this;
    }
})();
(function () {
  'use strict';

  angular
    .module('pixerf')
    .directive('addBankTransferMethodPopup', addBankTransferMethodPopup);

  function addBankTransferMethodPopup() {

    var directive = {
      scope: {
          bankInfo: '='
      },
      restrict: 'E',
      templateUrl: 'app/components/add-bank-transfer-method-popup/add-bank-transfer-method-popup.html',
      controller: 'addBankTransferMethodPopupCtrl',
      controllerAs: 'vm',
      replace: true
    };
    return directive;
  }

})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.factory('actionReqruiedCommunityPopupSvc', actionReqruiedCommunityPopupSvc);
	actionReqruiedCommunityPopupSvc.$inject = ['$uibModal'];

	function actionReqruiedCommunityPopupSvc($uibModal) {
		function showPopup(data) {
			return $uibModal.open({
				templateUrl: 'app/components/action-reqruied-community-popup/action-reqruied-community-popup.html',
				controller: 'actionReqruiedCommunityPopupCtrl',
				controllerAs: 'vm',
				animation: true,
				windowClass: 'action-reqruied-community-popup-screen',
				backdrop: 'static',
				resolve: {
					data: function () {
						return data;
					}
				}
			});
		}

		return {
			showPopup: showPopup,
		};
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('actionReqruiedCommunityPopupCtrl', actionReqruiedCommunityPopupCtrl);

	actionReqruiedCommunityPopupCtrl.$inject = ['$uibModalInstance', 'data'];

	function actionReqruiedCommunityPopupCtrl($uibModalInstance, data) {

		var self = this;
		self.data = data;
		self.community = self.data ? self.data.community : null;
		self.isWorking = false;
		self.close = close;
		self.onSubmit = onSubmit;
		self.onActionRequiredChanged = onActionRequiredChanged;
		self.defaultActionRequired = [];

		self.actionRequiredList = [{
				value: "cover_image",
				title: "Cover image"
			},
			{
				value: "community_name",
				title: "Community name"
			},
			{
				value: "description",
				title: "Description"
			},
			{
				value: "community_rules",
				title: "Community rules"
			},
			{
				value: "others",
				title: "Others"
			}
		];

		init();

		function init() {
			addExistContent();
		}

		function addExistContent() {
			if (self.community && self.community.community_reject_comments && self.community.community_reject_comments.length) {
				var selectedReasons = self.community.community_reject_comments[0].reason.split(", ");
				_.map(self.actionRequiredList, function (item) {
					if (selectedReasons.includes(item.title)) {
						self.defaultActionRequired.push(item.value);
					}
					return item;
				})
				self.comment = self.community.community_reject_comments[0].comment;
				self.reason = self.community.community_reject_comments[0].reason;
			}
		}

		function onSubmit() {
			if (self.isWorking) return;
			if (data.submit) {
				self.isWorking = true;
				self.isSubmmited = true;
				data.submit({
					comment: self.comment,
					reason: self.reason
				}).then(function (respone) {
					self.isWorking = false;
					$uibModalInstance.close(respone);
					if (data.submitCallback) {
						data.submitCallback(respone);
					}
				}).catch(function (err) {
					self.isWorking = false;
				})
			} else {
				$uibModalInstance.close();
			}
		};

		function close() {
			$uibModalInstance.dismiss('cancel');
		};

		function onActionRequiredChanged(data) {
			if (data && data.length) {
				self.reason = _.pluck(data, 'title').join(", ");
			} else {
				self.reason = null;
			}
		}
	}
})();

(function () {

	angular
		.module('pixerf')
		.factory('actionPopupSvc', actionPopupSvc);

	actionPopupSvc.$inject = ['$uibModal'];

	function actionPopupSvc($uibModal) {

		function showPopup(data) {
			return $uibModal.open({
				templateUrl: 'app/components/action-popup/action-popup.html',
				controller: 'actionPopupCtrl',
				controllerAs: 'vm',
				animation: true,
				windowClass: 'zindex action-screen',
				backdrop: 'static',
				resolve: {
					popupData: function () {
						return data;
					}
				}
			});
		}

		return {
			showPopup: showPopup
		};
	}
})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('actionPopupCtrl', actionPopupCtrl);

    actionPopupCtrl.$inject = ['popupData', '$uibModalInstance', '$scope'];

    function actionPopupCtrl(popupData, $uibModalInstance, $scope) {

        var self = this;
        self.onCancelClicked = onCancelClicked;
        self.onBtnClicked = onBtnClicked;
        self.data = popupData;

		function onCancelClicked(){
            $uibModalInstance.dismiss();
        }
        function onBtnClicked(canBuyMoreSubmissions){
            if(canBuyMoreSubmissions){
                self.data.ioa_submission_type = "paid";
            } else {
                self.data = null;
            }
            $uibModalInstance.close(self.data);
        }
    }
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('aboutCommunityCaseStudiesGridCarouselCtrl', aboutCommunityCaseStudiesGridCarouselCtrl);

		aboutCommunityCaseStudiesGridCarouselCtrl.$inject = ['$scope', 'systemUtils', 'carouselPhotoPopupSvc', '$timeout'];

	function aboutCommunityCaseStudiesGridCarouselCtrl($scope, systemUtils, carouselPhotoPopupSvc, $timeout) {


		var self = this;
		self.onNextSlide = onNextSlide;
		self.onPreviousSlide = onPreviousSlide;
		self.showPhotoPopup = showPhotoPopup;
		self.onNavClicked = onNavClicked;
		self.isActive = isActive;
		self.activeIndex = 0;
		self.mobileData = [];
		self.slideDatas = [{
			id: 1,
			logo: "assets/images/custom-commission-ad/slides/slide-1-logo.png",
			indexShowInfo: 5,
			infoLast: false,
			themeColor: "#dbb688",
			slideInfo: {
				logoUrl: "assets/images/about-community-case-Studies-grid-carousel/slides/gojek-logo.png",
				logoUrlMobile: "assets/images/about-community-case-Studies-grid-carousel/slides/gojek-logo-mobile.png",
				header: "PIXERF ENTERS INDONESIA WITH GO-JEK PARTNERSHIP",
				subHeader: 'Jakarta, Indonesia',
				desc: "PIXERF collaborated with Gojek to roll out the Museum of Hacks, an exhibition that captures the lifehacks of Indonesians in vivid images. The winning images from the PIXERF's contest platform were also used in Gojek's nation-wide #pastiadajalan social media campaign.",
			},
			photos: [
				{
					url: "assets/images/about-community-case-Studies-grid-carousel/slides/slide-1-1-photo.jpg",
					urlMobile: "assets/images/about-community-case-Studies-grid-carousel/slides/slide-1-1-photo-mobile.jpg",
				},
				{
					url: "assets/images/about-community-case-Studies-grid-carousel/slides/slide-1-2-photo.jpg",
					urlMobile: "assets/images/about-community-case-Studies-grid-carousel/slides/slide-1-2-photo-mobile.jpg",
				},
				{
					url: "assets/images/about-community-case-Studies-grid-carousel/slides/slide-1-3-photo.jpg",
					urlMobile: "assets/images/about-community-case-Studies-grid-carousel/slides/slide-1-3-photo-mobile.jpg",
				},
				{
					url: "assets/images/about-community-case-Studies-grid-carousel/slides/slide-1-4-photo.jpg",
					urlMobile: "assets/images/about-community-case-Studies-grid-carousel/slides/slide-1-4-photo-mobile.jpg",
				},
				{
					url: "assets/images/about-community-case-Studies-grid-carousel/slides/slide-1-5-photo.jpg",
					urlMobile: "assets/images/about-community-case-Studies-grid-carousel/slides/slide-1-5-photo-mobile.jpg",
				},
				{
					url: "assets/images/about-community-case-Studies-grid-carousel/slides/slide-1-6-photo.jpg",
					urlMobile: "assets/images/about-community-case-Studies-grid-carousel/slides/slide-1-6-photo-mobile.jpg",
				},
				{
					url: "assets/images/about-community-case-Studies-grid-carousel/slides/slide-1-7-photo.jpg",
					urlMobile: "assets/images/about-community-case-Studies-grid-carousel/slides/slide-1-7-photo-mobile.jpg",
				}
			]
		},
		{
			id: 2,
			logo: "assets/images/custom-commission-ad/slides/slide-2-logo.png",
			indexShowInfo: 5,
			infoLast: true,
			themeColor: "#a4d9ea",
			slideInfo: {
				logoUrl: "assets/images/about-community-case-Studies-grid-carousel/slides/cooler-lumpur-logo.png",
				logoUrlMobile: "assets/images/about-community-case-Studies-grid-carousel/slides/cooler-lumpur-logo-mobile.png",
				header: "PIXERF AT COOLER LUMPUR FESTIVAL",
				subHeader: 'KL, Malaysia',
				desc: "PIXERF made its debut in Malaysia at The Cooler Lumpur Festival with an exhibition showcasing the works of PIXERF's four Definers followed by a photo walk led by them. Brands and agencies attended the exhibition and learnt more about PIXERF's plans in the city state and Malaysia.",
			},
			photos: [
				{
					url: "assets/images/about-community-case-Studies-grid-carousel/slides/slide-2-1-photo.jpg",
					urlMobile: "assets/images/about-community-case-Studies-grid-carousel/slides/slide-2-1-photo-mobile.jpg",
				},
				{
					url: "assets/images/about-community-case-Studies-grid-carousel/slides/slide-2-2-photo.jpg",
					urlMobile: "assets/images/about-community-case-Studies-grid-carousel/slides/slide-2-2-photo-mobile.jpg",
				},
				{
					url: "assets/images/about-community-case-Studies-grid-carousel/slides/slide-2-3-photo.jpg",
					urlMobile: "assets/images/about-community-case-Studies-grid-carousel/slides/slide-2-3-photo-mobile.jpg",
				},
				{
					url: "assets/images/about-community-case-Studies-grid-carousel/slides/slide-2-4-photo.jpg",
					urlMobile: "assets/images/about-community-case-Studies-grid-carousel/slides/slide-2-4-photo-mobile.jpg",
				},
				{
					url: "assets/images/about-community-case-Studies-grid-carousel/slides/slide-2-5-photo.jpg",
					urlMobile: "assets/images/about-community-case-Studies-grid-carousel/slides/slide-2-5-photo-mobile.jpg",
				},
				{
					url: "assets/images/about-community-case-Studies-grid-carousel/slides/slide-2-6-photo.jpg",
					urlMobile: "assets/images/about-community-case-Studies-grid-carousel/slides/slide-2-6-photo-mobile.jpg",
				},
				{
					url: "assets/images/about-community-case-Studies-grid-carousel/slides/slide-2-7-photo.jpg",
					urlMobile: "assets/images/about-community-case-Studies-grid-carousel/slides/slide-2-7-photo-mobile.jpg",
				},
				{
					url: "assets/images/about-community-case-Studies-grid-carousel/slides/slide-2-8-photo.jpg",
					urlMobile: "assets/images/about-community-case-Studies-grid-carousel/slides/slide-2-8-photo-mobile.jpg",
				},
				{
					url: "assets/images/about-community-case-Studies-grid-carousel/slides/slide-2-9-photo.jpg",
					urlMobile: "assets/images/about-community-case-Studies-grid-carousel/slides/slide-2-9-photo.jpg",
				},
				{
					url: "assets/images/about-community-case-Studies-grid-carousel/slides/slide-2-10-photo.jpg",
					urlMobile: "assets/images/about-community-case-Studies-grid-carousel/slides/slide-2-10-photo.jpg",
				}
			]
		},
		{
			id: 3,
			logo: "assets/images/custom-commission-ad/slides/slide-3-logo.png",
			indexShowInfo: 5,
			infoLast: true,
			themeColor: "#ccc96b",
			slideInfo: {
				logoUrl: "assets/images/about-community-case-Studies-grid-carousel/slides/collusion-logo.png",
				logoUrlMobile: "assets/images/about-community-case-Studies-grid-carousel/slides/collusion-logo-mobile.png",
				header: "PIXERF X AMBASSADORS PRESENTS COLLUSION",
				subHeader: 'Singapore',
				desc: "COLLUSION marked the first collaboration between PIXERF and our Ambassadors to create a one-of-a-kind photography event in Asia. Each of our 15 ambassador photographers were challenged to translate 'COLLUSION' into a single image and their extraordinary talent signalled them as the names to watch in Asia.",
			},
			photos: [
				{
					url: "assets/images/about-community-case-Studies-grid-carousel/slides/slide-3-1-photo.jpg",
					urlMobile: "assets/images/about-community-case-Studies-grid-carousel/slides/slide-3-1-photo-mobile.jpg",
				},
				{
					url: "assets/images/about-community-case-Studies-grid-carousel/slides/slide-3-2-photo.jpg",
					urlMobile: "assets/images/about-community-case-Studies-grid-carousel/slides/slide-3-2-photo-mobile.jpg",
				},
				{
					url: "assets/images/about-community-case-Studies-grid-carousel/slides/slide-3-3-photo.jpg",
					urlMobile: "assets/images/about-community-case-Studies-grid-carousel/slides/slide-3-3-photo-mobile.jpg",
				},
				{
					url: "assets/images/about-community-case-Studies-grid-carousel/slides/slide-3-4-photo.jpg",
					urlMobile: "assets/images/about-community-case-Studies-grid-carousel/slides/slide-3-4-photo-mobile.jpg",
				},
				{
					url: "assets/images/about-community-case-Studies-grid-carousel/slides/slide-3-5-photo.jpg",
					urlMobile: "assets/images/about-community-case-Studies-grid-carousel/slides/slide-3-5-photo-mobile.jpg",
				},
				{
					url: "assets/images/about-community-case-Studies-grid-carousel/slides/slide-3-6-photo.jpg",
					urlMobile: "assets/images/about-community-case-Studies-grid-carousel/slides/slide-3-6-photo-mobile.jpg",
				},
				{
					url: "assets/images/about-community-case-Studies-grid-carousel/slides/slide-3-7-photo.jpg",
					urlMobile: "assets/images/about-community-case-Studies-grid-carousel/slides/slide-3-7-photo-mobile.jpg",
				},
				{
					url: "assets/images/about-community-case-Studies-grid-carousel/slides/slide-3-8-photo.jpg",
					urlMobile: "assets/images/about-community-case-Studies-grid-carousel/slides/slide-3-8-photo-mobile.jpg",
				},
				{
					url: "assets/images/about-community-case-Studies-grid-carousel/slides/slide-3-9-photo.jpg",
					urlMobile: "assets/images/about-community-case-Studies-grid-carousel/slides/slide-3-9-photo.jpg",
				}
			]
		},
		{
			id: 4,
			logo: "assets/images/custom-commission-ad/slides/slide-3-logo.png",
			indexShowInfo: 5,
			infoLast: true,
			themeColor: "#ccc96b",
			slideInfo: {
				logoUrl: "assets/images/about-community-case-Studies-grid-carousel/slides/revisualising-asia-logo.png",
				logoUrlMobile: "assets/images/about-community-case-Studies-grid-carousel/slides/revisualising-asia-logo-mobile.png",
				header: "PIXERF PRESENTS RE:VISUALISING ASIA",
				subHeader: 'Singapore',
				desc: "PIXERF’s launch party featured a media presentation on RE:VISUALISING ASIA by our founders, Sa’at Ismail and Michele Lee, and fireside chats with guests from brands, creative agencies and media. We took guests on a visual journey of images that are changing the face of Asia from our online marketplace.",
			},
			photos: [
				{
					url: "assets/images/about-community-case-Studies-grid-carousel/slides/slide-4-1-photo.jpg",
					urlMobile: "assets/images/about-community-case-Studies-grid-carousel/slides/slide-4-1-photo-mobile.jpg",
				},
				{
					url: "assets/images/about-community-case-Studies-grid-carousel/slides/slide-4-2-photo.jpg",
					urlMobile: "assets/images/about-community-case-Studies-grid-carousel/slides/slide-4-2-photo-mobile.jpg",
				},
				{
					url: "assets/images/about-community-case-Studies-grid-carousel/slides/slide-4-3-photo.jpg",
					urlMobile: "assets/images/about-community-case-Studies-grid-carousel/slides/slide-4-3-photo-mobile.jpg",
				},
				{
					url: "assets/images/about-community-case-Studies-grid-carousel/slides/slide-4-4-photo.jpg",
					urlMobile: "assets/images/about-community-case-Studies-grid-carousel/slides/slide-4-4-photo-mobile.jpg",
				},
				{
					url: "assets/images/about-community-case-Studies-grid-carousel/slides/slide-4-5-photo.jpg",
					urlMobile: "assets/images/about-community-case-Studies-grid-carousel/slides/slide-4-5-photo-mobile.jpg",
				},
				{
					url: "assets/images/about-community-case-Studies-grid-carousel/slides/slide-4-6-photo.jpg",
					urlMobile: "assets/images/about-community-case-Studies-grid-carousel/slides/slide-4-6-photo-mobile.jpg",
				},
				{
					url: "assets/images/about-community-case-Studies-grid-carousel/slides/slide-4-7-photo.jpg",
					urlMobile: "assets/images/about-community-case-Studies-grid-carousel/slides/slide-4-7-photo-mobile.jpg",
				},
				{
					url: "assets/images/about-community-case-Studies-grid-carousel/slides/slide-4-8-photo.jpg",
					urlMobile: "assets/images/about-community-case-Studies-grid-carousel/slides/slide-4-8-photo-mobile.jpg",
				}
			]
		},
		{
			id: 5,
			logo: "assets/images/custom-commission-ad/slides/slide-3-logo.png",
			indexShowInfo: 5,
			infoLast: true,
			themeColor: "#ccc96b",
			slideInfo: {
				logoUrl: "assets/images/about-community-case-Studies-grid-carousel/slides/pixerf-connects.svg",
				logoUrlMobile: "assets/images/about-community-case-Studies-grid-carousel/slides/pixerf-connects-mobile.svg",
				header: "",
				subHeader: 'Bangkok, Bandar Seri Begawan, Ho Chi Minh, Jakarta, Yogyakarta, Kuala Lumpur, Manila, Singapore.',
				desc: "We visited 8 cities over 24 days meeting over 500 invited photographers across the region. We shared our vision for images of Asia and its creators and ran photography challenges in each city. The result was growth to 32,000 users within 5 months of PIXERF’s launch.",
			},
			photos: [
				{
					url: "assets/images/about-community-case-Studies-grid-carousel/slides/slide-5-1-photo.jpg",
					urlMobile: "assets/images/about-community-case-Studies-grid-carousel/slides/slide-5-1-photo-mobile.jpg",
					location:'Jakarta',
					team: 'PIXERF X INDONESIA'
				},
				{
					url: "assets/images/about-community-case-Studies-grid-carousel/slides/slide-5-2-photo.jpg",
					urlMobile: "assets/images/about-community-case-Studies-grid-carousel/slides/slide-5-2-photo-mobile.jpg",
					location:'Bandar Seri Begawan',
					team: 'PIXERF X BRUNEI'
				},
				{
					url: "assets/images/about-community-case-Studies-grid-carousel/slides/slide-5-3-photo.jpg",
					urlMobile: "assets/images/about-community-case-Studies-grid-carousel/slides/slide-5-3-photo-mobile.jpg",
					location:'Manila',
					team: 'PIXERF X PHILIPPINES'
				},
				{
					url: "assets/images/about-community-case-Studies-grid-carousel/slides/slide-5-4-photo.jpg",
					urlMobile: "assets/images/about-community-case-Studies-grid-carousel/slides/slide-5-4-photo-mobile.jpg",
					location:'Yogyakarta',
					team: 'PIXERF X INDONESIA'
				},
				{
					url: "assets/images/about-community-case-Studies-grid-carousel/slides/slide-5-5-photo.jpg",
					urlMobile: "assets/images/about-community-case-Studies-grid-carousel/slides/slide-5-5-photo-mobile.jpg",
					location:'Kuala Lumpur',
					team: 'PIXERF X MALAYSIA'
				},
				{
					url: "assets/images/about-community-case-Studies-grid-carousel/slides/slide-5-6-photo.jpg",
					urlMobile: "assets/images/about-community-case-Studies-grid-carousel/slides/slide-5-6-photo-mobile.jpg",
					location:'Ho Chi Minh',
					team: 'PIXERF X VIETNAM'
				},
				{
					url: "assets/images/about-community-case-Studies-grid-carousel/slides/slide-5-7-photo.jpg",
					urlMobile: "assets/images/about-community-case-Studies-grid-carousel/slides/slide-5-7-photo-mobile.jpg",
					location:'Bangkok',
					team: 'PIXERF X THAILAND'
				},
				{
					url: "assets/images/about-community-case-Studies-grid-carousel/slides/slide-5-8-photo.jpg",
					urlMobile: "assets/images/about-community-case-Studies-grid-carousel/slides/slide-5-8-photo-mobile.jpg",
				}
			]
		},
		{
			id: 6,
			logo: "assets/images/custom-commission-ad/slides/slide-3-logo.png",
			indexShowInfo: 5,
			infoLast: true,
			themeColor: "#ccc96b",
			slideInfo: {
				photoShoot: "1,300",
				logoUrl:'assets/images/about-community-case-Studies-grid-carousel/slides/pixerf-connects-logo-pc.png',
				logoUrlMobile: "assets/images/about-community-case-Studies-grid-carousel/slides/pixerf-connects-logo-mobile.png",
				days: 6,
				licensed: 342
			},
			photos: [
				{
					url: "assets/images/about-community-case-Studies-grid-carousel/slides/slide-6-1-photo.jpg",
					urlMobile: "assets/images/about-community-case-Studies-grid-carousel/slides/slide-6-1-photo-mobile.jpg",
				},
				{
					url: "assets/images/about-community-case-Studies-grid-carousel/slides/slide-6-2-photo.jpg",
					urlMobile: "assets/images/about-community-case-Studies-grid-carousel/slides/slide-6-2-photo-mobile.jpg",
					locationMobile:'Indonesia'
				},
				{
					url: "assets/images/about-community-case-Studies-grid-carousel/slides/slide-6-3-photo.jpg",
					urlMobile: "assets/images/about-community-case-Studies-grid-carousel/slides/slide-6-3-photo-mobile.jpg",
					location:'Malaysia',
					locationMobile:'Malaysia'
				},
				{
					url: "assets/images/about-community-case-Studies-grid-carousel/slides/slide-6-4-photo.jpg",
					urlMobile: "assets/images/about-community-case-Studies-grid-carousel/slides/slide-6-4-photo-mobile.jpg",
				},
				{
					url: "assets/images/about-community-case-Studies-grid-carousel/slides/slide-6-5-photo.jpg",
					urlMobile: "assets/images/about-community-case-Studies-grid-carousel/slides/slide-6-5-photo-mobile.jpg",
					location:'Vietnam'
				},
				{
					url: "assets/images/about-community-case-Studies-grid-carousel/slides/slide-6-6-photo.jpg",
					urlMobile: "assets/images/about-community-case-Studies-grid-carousel/slides/slide-6-6-photo-mobile.jpg",
					location:'Singapore',
					locationMobile:'Thailand'
				},
				{
					url: "assets/images/about-community-case-Studies-grid-carousel/slides/slide-6-7-photo.jpg",
					urlMobile: "assets/images/about-community-case-Studies-grid-carousel/slides/slide-6-7-photo-mobile.jpg",
					location:'Brunei',
				},
				{
					url: "assets/images/about-community-case-Studies-grid-carousel/slides/slide-6-8-photo.jpg",
					urlMobile: "assets/images/about-community-case-Studies-grid-carousel/slides/slide-6-8-photo-mobile.jpg",
					location:'Philippines',
					locationMobile:'Vietnam'
				},
				{
					url: "assets/images/about-community-case-Studies-grid-carousel/slides/slide-6-9-photo.jpg",
					urlMobile: "assets/images/about-community-case-Studies-grid-carousel/slides/slide-6-9-photo-mobile.jpg",
					locationMobile:'Singapore'
				},
				{
					url: "assets/images/about-community-case-Studies-grid-carousel/slides/slide-6-10-photo.jpg",
					urlMobile: "assets/images/about-community-case-Studies-grid-carousel/slides/slide-6-10-photo-mobile.jpg",
					location:'Indonesia'
				},
				{
					url: "assets/images/about-community-case-Studies-grid-carousel/slides/slide-6-11-photo.jpg",
					urlMobile: "assets/images/about-community-case-Studies-grid-carousel/slides/slide-6-11-photo-mobile.jpg",
					location:'Thailand',
					locationMobile:'Brunei'
				},
				{
					url: "assets/images/about-community-case-Studies-grid-carousel/slides/slide-6-11-photo.jpg",
					urlMobile: "assets/images/about-community-case-Studies-grid-carousel/slides/slide-6-12-photo-mobile.jpg",
					location:'Thailand'
				}
			]
		}
		];
		self.slickSetting = {
			onInit: function (slick) {
				self.slick = slick;
				systemUtils.digest($scope);
			}
		}

		function onNextSlide() {
			self.slick.slickNext();
		}

		function onPreviousSlide() {
			self.slick.slickPrev();
		}

		function buildMobileData(){
			self.mobileData = [];
			for(var i = 0; i < self.slideDatas.length; i++){
				for(var j = 0; j < (self.slideDatas[i].photos).length; j++){
					self.mobileData.push(self.slideDatas[i].photos[j])
				}
			}
		}

		function showPhotoPopup(photo){
			carouselPhotoPopupSvc.showPopup({
				windowClass: 'stay-home-stay-creative',
				data: photo
			});
		}

		function isActive(index){
			return index == self.activeIndex;
		}

		function onNavClicked(index){
			$('.about-community-case-Studies-grid-carousel__slick').slick('slickGoTo', index);
			self.activeIndex = index;
		}

		init();

		function init() {
			buildMobileData();
			$timeout(function(){
				onNavClicked(0);
			}, 100)
			$('.about-community-case-Studies-grid-carousel__slick').on('afterChange', function(event, slick, currentSlide, nextSlide){
				self.activeIndex = currentSlide;
				$scope.$apply()
			  });
		}



	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('aboutCommunityCaseStudiesGridCarousel', aboutCommunityCaseStudiesGridCarousel);

	function aboutCommunityCaseStudiesGridCarousel() {

		var directive = {
			scope: {
				data: "="
			},
			templateUrl: 'app/components/about-community-case-Studies-grid-carousel/about-community-case-Studies-grid-carousel.html',
			restrict: 'E',
			controller: 'aboutCommunityCaseStudiesGridCarouselCtrl',
			controllerAs: 'vm',
			replace: true
		};
		return directive;
	}

})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('aboutChallengesCaseStudiesGridCarouselCtrl', aboutChallengesCaseStudiesGridCarouselCtrl);

		aboutChallengesCaseStudiesGridCarouselCtrl.$inject = ['$scope', 'systemUtils', 'carouselPhotoPopupSvc', '$timeout'];

	function aboutChallengesCaseStudiesGridCarouselCtrl($scope, systemUtils, carouselPhotoPopupSvc, $timeout) {


		var self = this;
		self.onNextSlide = onNextSlide;
		self.onPreviousSlide = onPreviousSlide;
		self.showPhotoPopup = showPhotoPopup;
		self.isActive = isActive;
		self.onNavClicked = onNavClicked;
		self.activeIndex = 0;
		self.mobileData = [];
		self.slideDatas = [{
			id: 1,
			logo: "assets/images/custom-commission-ad/slides/slide-1-logo.png",
			indexShowInfo: 5,
			infoLast: false,
			themeColor: "#dbb688",
			slideInfo: {
				logoUrl: "assets/images/about-challenges-case-Studies-grid-carousel/slides/straits-city-logo.png",
				logoUrlMobile: "assets/images/about-challenges-case-Studies-grid-carousel/slides/straits-city-logo-mobile.png",
				header: "TOGETHER AT HOME & FLASH BACK TO PENANG CHALLENGES",
				desc: "Two photo challenges to promote an integrated development in Penang-Butterworth: a nostalgic call to recapture the region’s past and another that focuses on moments of bonding at home.",
				submissions: 235,
				winners: 10
			},
			photos: [
				{
					url: "assets/images/about-challenges-case-Studies-grid-carousel/slides/slide-1-1-photo.jpg",
					urlMobile: "assets/images/about-challenges-case-Studies-grid-carousel/slides/slide-1-1-photo-mobile.jpg",
				},
				{
					url: "assets/images/about-challenges-case-Studies-grid-carousel/slides/slide-1-2-photo.jpg",
					urlMobile: "assets/images/about-challenges-case-Studies-grid-carousel/slides/slide-1-2-photo-mobile.jpg",
				},
				{
					url: "assets/images/about-challenges-case-Studies-grid-carousel/slides/slide-1-3-photo.jpg",
					urlMobile: "assets/images/about-challenges-case-Studies-grid-carousel/slides/slide-1-3-photo-mobile.jpg",
				},
				{
					url: "assets/images/about-challenges-case-Studies-grid-carousel/slides/slide-1-4-photo.jpg",
					urlMobile: "assets/images/about-challenges-case-Studies-grid-carousel/slides/slide-1-4-photo-mobile.jpg",
				},
				{
					url: "assets/images/about-challenges-case-Studies-grid-carousel/slides/slide-1-5-photo.jpg",
					urlMobile: "assets/images/about-challenges-case-Studies-grid-carousel/slides/slide-1-5-photo-mobile.jpg",
				},
				{
					url: "assets/images/about-challenges-case-Studies-grid-carousel/slides/slide-1-6-photo.jpg",
					urlMobile: "assets/images/about-challenges-case-Studies-grid-carousel/slides/slide-1-6-photo-mobile.jpg",
				},
				{
					url: "assets/images/about-challenges-case-Studies-grid-carousel/slides/slide-1-7-photo.jpg",
					urlMobile: "assets/images/about-challenges-case-Studies-grid-carousel/slides/slide-1-7-photo-mobile.jpg",
				}
			]
		},
		{
			id: 2,
			logo: "assets/images/custom-commission-ad/slides/slide-2-logo.png",
			indexShowInfo: 5,
			infoLast: true,
			themeColor: "#a4d9ea",
			slideInfo: {
				logoUrl: "assets/images/about-challenges-case-Studies-grid-carousel/slides/wwf-logo-pc.png",
				logoUrlMobile: "assets/images/about-challenges-case-Studies-grid-carousel/slides/wwf-logo.png",
				header: "youth in <br> urban nature ",
				desc: "A photo challenge that doubled as a non-traditional digital campaign to encourage Asia’s ‘social media generation’ to appreciate the presence of nature in their urban surroundings.",
				submissions: 218,
				winners: 3
			},
			photos: [
				{
					url: "assets/images/about-challenges-case-Studies-grid-carousel/slides/slide-2-1-photo.jpg",
					urlMobile: "assets/images/about-challenges-case-Studies-grid-carousel/slides/slide-2-1-photo-mobile.jpg",
				},
				{
					url: "assets/images/about-challenges-case-Studies-grid-carousel/slides/slide-2-2-photo.jpg",
					urlMobile: "assets/images/about-challenges-case-Studies-grid-carousel/slides/slide-2-2-photo-mobile.jpg",
				},
				{
					url: "assets/images/about-challenges-case-Studies-grid-carousel/slides/slide-2-3-photo.jpg",
					urlMobile: "assets/images/about-challenges-case-Studies-grid-carousel/slides/slide-2-3-photo-mobile.jpg",
				},
				{
					url: "assets/images/about-challenges-case-Studies-grid-carousel/slides/slide-2-4-photo.jpg",
					urlMobile: "assets/images/about-challenges-case-Studies-grid-carousel/slides/slide-2-4-photo-mobile.jpg",
				},
				{
					url: "assets/images/about-challenges-case-Studies-grid-carousel/slides/slide-2-5-photo.jpg",
					urlMobile: "assets/images/about-challenges-case-Studies-grid-carousel/slides/slide-2-5-photo-mobile.jpg",
				},
				{
					url: "assets/images/about-challenges-case-Studies-grid-carousel/slides/slide-2-6-photo.jpg",
					urlMobile: "assets/images/about-challenges-case-Studies-grid-carousel/slides/slide-2-6-photo-mobile.jpg",
				},
				{
					url: "assets/images/about-challenges-case-Studies-grid-carousel/slides/slide-2-7-photo.jpg",
					urlMobile: "assets/images/about-challenges-case-Studies-grid-carousel/slides/slide-2-7-photo-mobile.jpg",
				}
			]
		},
		{
			id: 3,
			logo: "assets/images/custom-commission-ad/slides/slide-3-logo.png",
			indexShowInfo: 5,
			infoLast: true,
			themeColor: "#ccc96b",
			slideInfo: {
				logoUrl: "assets/images/about-challenges-case-Studies-grid-carousel/slides/cooler-lumpur-logo.png",
				logoUrlMobile: "assets/images/about-challenges-case-Studies-grid-carousel/slides/cooler-lumpur-logo.png",
				header: "super canggih",
				desc: "In collaboration with the annual Cooler Lumpur festival, this challenge asked Malaysian photographers to show us something cool and extraordinary through their lens.",
				submissions: 131,
				winners: 4
			},
			photos: [
				{
					url: "assets/images/about-challenges-case-Studies-grid-carousel/slides/slide-3-1-photo.jpg",
					urlMobile: "assets/images/about-challenges-case-Studies-grid-carousel/slides/slide-3-1-photo-mobile.jpg",
				},
				{
					url: "assets/images/about-challenges-case-Studies-grid-carousel/slides/slide-3-2-photo.jpg",
					urlMobile: "assets/images/about-challenges-case-Studies-grid-carousel/slides/slide-3-2-photo-mobile.jpg",
				},
				{
					url: "assets/images/about-challenges-case-Studies-grid-carousel/slides/slide-3-3-photo.jpg",
					urlMobile: "assets/images/about-challenges-case-Studies-grid-carousel/slides/slide-3-3-photo-mobile.jpg",
				},
				{
					url: "assets/images/about-challenges-case-Studies-grid-carousel/slides/slide-3-4-photo.jpg",
					urlMobile: "assets/images/about-challenges-case-Studies-grid-carousel/slides/slide-3-4-photo-mobile.jpg",
				},
				{
					url: "assets/images/about-challenges-case-Studies-grid-carousel/slides/slide-3-5-photo.jpg",
					urlMobile: "assets/images/about-challenges-case-Studies-grid-carousel/slides/slide-3-5-photo-mobile.jpg",
				},
				{
					url: "assets/images/about-challenges-case-Studies-grid-carousel/slides/slide-3-6-photo.jpg",
					urlMobile: "assets/images/about-challenges-case-Studies-grid-carousel/slides/slide-3-6-photo-mobile.jpg",
				},
				{
					url: "assets/images/about-challenges-case-Studies-grid-carousel/slides/slide-3-7-photo.jpg",
					urlMobile: "assets/images/about-challenges-case-Studies-grid-carousel/slides/slide-3-7-photo-mobile.jpg",
				}
			]
		},
		{
			id: 4,
			logo: "assets/images/custom-commission-ad/slides/slide-3-logo.png",
			indexShowInfo: 5,
			infoLast: true,
			themeColor: "#ccc96b",
			slideInfo: {
				logoUrl: "assets/images/about-challenges-case-Studies-grid-carousel/slides/gojek-logo.png",
				logoUrlMobile: "assets/images/about-challenges-case-Studies-grid-carousel/slides/gojek-logo.png",
				header: "MUSEUM OF HACKS",
				desc: "Activating the community to be part of GOJEK’s rebranding.",
				submissions: 631,
				winners: 30
			},
			photos: [
				{
					url: "assets/images/about-challenges-case-Studies-grid-carousel/slides/slide-4-1-photo.jpg",
					urlMobile: "assets/images/about-challenges-case-Studies-grid-carousel/slides/slide-4-1-photo-mobile.jpg",
				},
				{
					url: "assets/images/about-challenges-case-Studies-grid-carousel/slides/slide-4-2-photo.jpg",
					urlMobile: "assets/images/about-challenges-case-Studies-grid-carousel/slides/slide-4-2-photo-mobile.jpg",
				},
				{
					url: "assets/images/about-challenges-case-Studies-grid-carousel/slides/slide-4-3-photo.jpg",
					urlMobile: "assets/images/about-challenges-case-Studies-grid-carousel/slides/slide-4-3-photo-mobile.jpg",
				},
				{
					url: "assets/images/about-challenges-case-Studies-grid-carousel/slides/slide-4-4-photo.jpg",
					urlMobile: "assets/images/about-challenges-case-Studies-grid-carousel/slides/slide-4-4-photo-mobile.jpg",
				},
				{
					url: "assets/images/about-challenges-case-Studies-grid-carousel/slides/slide-4-5-photo.jpg",
					urlMobile: "assets/images/about-challenges-case-Studies-grid-carousel/slides/slide-4-5-photo-mobile.jpg",
				},
				{
					url: "assets/images/about-challenges-case-Studies-grid-carousel/slides/slide-4-6-photo.jpg",
					urlMobile: "assets/images/about-challenges-case-Studies-grid-carousel/slides/slide-4-6-photo-mobile.jpg",
				}
			]
		},
		{
			id: 5,
			logo: "assets/images/custom-commission-ad/slides/slide-3-logo.png",
			indexShowInfo: 5,
			infoLast: true,
			themeColor: "#ccc96b",
			slideInfo: {
				logoUrl: "assets/images/about-challenges-case-Studies-grid-carousel/slides/asia-image-logo.png",
				logoUrlMobile: "assets/images/about-challenges-case-Studies-grid-carousel/slides/asia-image-logo.png",
				header: "IMAGES OF ASIA",
				desc: "Elevating a traditional photo contest through tech and community.",
				submissions: 667,
				winners: 5
			},
			photos: [
				{
					url: "assets/images/about-challenges-case-Studies-grid-carousel/slides/slide-5-1-photo.jpg",
					urlMobile: "assets/images/about-challenges-case-Studies-grid-carousel/slides/slide-5-1-photo-mobile.jpg",
				},
				{
					url: "assets/images/about-challenges-case-Studies-grid-carousel/slides/slide-5-2-photo.jpg",
					urlMobile: "assets/images/about-challenges-case-Studies-grid-carousel/slides/slide-5-2-photo-mobile.jpg",
				},
				{
					url: "assets/images/about-challenges-case-Studies-grid-carousel/slides/slide-5-3-photo.jpg",
					urlMobile: "assets/images/about-challenges-case-Studies-grid-carousel/slides/slide-5-3-photo-mobile.jpg",
				},
				{
					url: "assets/images/about-challenges-case-Studies-grid-carousel/slides/slide-5-4-photo.jpg",
					urlMobile: "assets/images/about-challenges-case-Studies-grid-carousel/slides/slide-5-4-photo-mobile.jpg",
				},
				{
					url: "assets/images/about-challenges-case-Studies-grid-carousel/slides/slide-5-5-photo.jpg",
					urlMobile: "assets/images/about-challenges-case-Studies-grid-carousel/slides/slide-5-5-photo-mobile.jpg",
				},
				{
					url: "assets/images/about-challenges-case-Studies-grid-carousel/slides/slide-5-6-photo.jpg",
					urlMobile: "assets/images/about-challenges-case-Studies-grid-carousel/slides/slide-5-6-photo-mobile.jpg",
				},
				{
					url: "assets/images/about-challenges-case-Studies-grid-carousel/slides/slide-5-7-photo.jpg",
					urlMobile: "assets/images/about-challenges-case-Studies-grid-carousel/slides/slide-5-7-photo-mobile.jpg",
				},
				{
					url: "assets/images/about-challenges-case-Studies-grid-carousel/slides/slide-5-8-photo.jpg",
					urlMobile: "assets/images/about-challenges-case-Studies-grid-carousel/slides/slide-5-8-photo-mobile.jpg",
				},
				{
					url: "assets/images/about-challenges-case-Studies-grid-carousel/slides/slide-5-9-photo.jpg",
					urlMobile: "assets/images/about-challenges-case-Studies-grid-carousel/slides/slide-5-9-photo-mobile.jpg",
				}
			]
		}
		];
		self.slickSetting = {
			onInit: function (slick) {
				self.slick = slick;
				systemUtils.digest($scope);
			}
		}

		function onNextSlide() {
			self.slick.slickNext();
		}

		function onPreviousSlide() {
			self.slick.slickPrev();
		}

		function buildMobileData(){
			self.mobileData = [];
			for(var i = 0; i < self.slideDatas.length; i++){
				for(var j = 0; j < (self.slideDatas[i].photos).length; j++){
					self.mobileData.push(self.slideDatas[i].photos[j])
				}
			}
		}

		function showPhotoPopup(photo){
			carouselPhotoPopupSvc.showPopup({
				windowClass: 'stay-home-stay-creative',
				data: photo
			});
		}

		function isActive(index){
			return index == self.activeIndex;
		}

		function onNavClicked(index){
			$('.about-challenges-case-Studies-grid-carousel__slick').slick('slickGoTo', index);
			self.activeIndex = index;
		}
		init();

		function init() {
			buildMobileData();
			$timeout(function(){
				onNavClicked(0);
			}, 100)
			$('.about-challenges-case-Studies-grid-carousel__slick').on('afterChange', function(event, slick, currentSlide, nextSlide){
				self.activeIndex = currentSlide;
				$scope.$apply()
			  });
		}



	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('aboutChallengesCaseStudiesGridCarousel', aboutChallengesCaseStudiesGridCarousel);

	function aboutChallengesCaseStudiesGridCarousel() {

		var directive = {
			scope: {
				data: "="
			},
			templateUrl: 'app/components/about-challenges-case-Studies-grid-carousel/about-challenges-case-Studies-grid-carousel.html',
			restrict: 'E',
			controller: 'aboutChallengesCaseStudiesGridCarouselCtrl',
			controllerAs: 'vm',
			replace: true
		};
		return directive;
	}

})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.factory('webSocketUtils', webSocketUtils);

	webSocketUtils.$inject = ['$timeout'];

	function webSocketUtils($timeout) {

		return {

		};
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.factory('translationUtils', translationUtils);

	translationUtils.$inject = [];

	function translationUtils() {

		function canTranslate(model, language, field) {
			return model &&
				model[language] &&
				model[language][field];
		}

		return {
			canTranslate: canTranslate
		};
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.factory('tagUtils', tagUtils);

	tagUtils.$inject = [];

	function tagUtils() {

		function text2TagObject(texts) {
			if (!texts) return texts;
			var arr = [];
			for (var i = 0; i < texts.length; i++) {
				arr.push({
					text: texts[i]
				})

			}
			return arr;
		}

		function extractTagsText(tags) {
			return _.reduce(tags, function (memo, tag) {
				memo.push(tag.text);
				return memo;
			}, []);
		}

		function stringsToTag(arrString) {
			return _.reduce(arrString, function (memo, tag) {
				memo.push({
					text: tag
				});
				return memo;
			}, []);
		}

		function tagsToString(tags) {
			return _.reduce(tags, function (memo, tag) {
				memo += tag.text;
				return memo;
			}, []);
		}

		return {
			text2TagObject: text2TagObject,
			extractTagsText: extractTagsText,
			tagsToString: tagsToString,
			stringsToTag: stringsToTag
		};
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.factory('systemUtils', systemUtils);

	systemUtils.$inject = ['$timeout', 'commonConst', '$sce', 'toastr', '$http', '$q'];

	function systemUtils($timeout, commonConst, $sce, toastr, $http, $q) {
		function digest(scope) {
			$timeout(function () {
				scope.$apply();
			})
		}

		function string2Array(str, delimiter) {
			return str.split("delimiter")
		}

		function trustSrc(src) {
			return $sce.trustAsResourceUrl(src);
		}

		function preventTextSelection() {
			if (document.selection && document.selection.empty) {
				document.selection.empty();
			} else if (window.getSelection) {
				var sel = window.getSelection();
				sel.removeAllRanges();
			}
		}

		function getInputSelectionText(textComponent) {
			var selectedText;
			// IE version
			if (document.selection != undefined) {
				textComponent.focus();
				var sel = document.selection.createRange();
				selectedText = sel.text;
			}
			// Mozilla version
			else if (textComponent.selectionStart != undefined) {
				var startPos = textComponent.selectionStart;
				var endPos = textComponent.selectionEnd;
				selectedText = textComponent.value.substring(startPos, endPos)
			}
			return selectedText;
		}

		function getURLParameter(url, name) {
			return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(url) || [null, ''])[1].replace(/\+/g, '%20')) || null;
		}

		function clone(obj) {
			var source = typeof obj === "object" ? {} : [];
			return $.extend(true, source, obj);
		}

		function isObjectEqual(one, two, property) {
			if ((!one && two) || (one && !two)) return false;
			return one[property] === two[property]
		}

		function getMobileOS() {
			var userAgent = navigator.userAgent || navigator.vendor || window.opera;
			// Windows Phone must come first because its UA also contains "Android"
			if (/windows phone/i.test(userAgent)) {
				return "Other";
			} else if (/android/i.test(userAgent)) {
				return "Android";
			} else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
				return "iOS";
			} else {
				return "Other";
			}
		}

		function triggerBodyClicked() {
			$("body").click();
		}

		function getViewportDimension() {
			return {
				width: Math.max(document.documentElement.clientWidth, window.innerWidth || 0),
				height: Math.max(document.documentElement.clientHeight, window.innerHeight || 0)
			}
		}

		function scrollTo(options) {
			var body = $("html, body");
			var $window = $(window);
			var direction = options.direction;
			var deltaX = 0;
			if (options.howFar) {

				var howFar = options.howFar === 'vh' ? $window.height() : options.howFar;
				deltaX = direction === 'up' ? $window.scrollTop() - howFar : $window.scrollTop() + howFar;
			} else if (options.target) {
				var $targetElemt = $(options.target + ":visible");
				deltaX = $targetElemt.offset().top - 60;
			}
			body.stop().animate({
				scrollTop: deltaX
			}, '500', 'swing');
		}

		function isMobile() {
			return getViewportDimension().width <= commonConst.SCREEN.MOBILE;
		}

		function exportAngularObject(obj) {
			var jsonString = angular.toJson(obj);
			return angular.fromJson(jsonString);
		}

		function isReferralCodeValidFormat(code) {
			if (!code) return;
			var charsArr = ["X", "W", "U", "T", "R", "Q", "P", "N", "M", "L", "K", "J", "Z", "I", "H", "G", "F", "E", "D", "C", "B", "A"];
			var numberPart = code.substring(0, 6);
			var charPart = code.substring(6);
			if (numberPart.match(/^[0-9]{6,6}$/) && charsArr.indexOf(charPart) >= 0 && charPart === mapReferralCode(numberPart, charsArr)) {
				return true;
			} else {
				return false;
			}
		}

		function mapReferralCode(number, charsArr) {
			var index = parseInt(number) % 22;
			return charsArr[index];
		}

		function copyStringToClipboard(str, msg) {
			var el = document.createElement('textarea');
			el.value = str;
			el.setAttribute('readonly', '');
			el.style = {
				position: 'absolute',
				left: '-9999px'
			};
			document.body.appendChild(el);
			el.select();
			document.execCommand('copy');
			document.body.removeChild(el);
			if (msg) {
				toastr.success(msg);
			}
		}

		function getLocationUser(index) {
			var def = $q.defer();
			var apiKey = commonConst.IPGEOLOCATION.API_KEYS;
			var i = index ? index : 0;
			$http.get(commonConst.IPGEOLOCATION.URL + apiKey[i])
				.then(function (response) {
					def.resolve(response.data.country_code2);
				}).catch(function (err) {
					i++;
					if (i > apiKey.length - 1) {
						def.reject(err);
					} else {
						def.resolve(getLocationUser(i));
					}
				});

			return def.promise;
		}

		function wrapQuotes(url) {
			if (url.startsWith('"'))
				return url;
			else
				return '"' + url + '"';
		}

		return {
			digest: digest,
			string2Array: string2Array,
			preventTextSelection: preventTextSelection,
			getInputSelectionText: getInputSelectionText,
			clone: clone,
			getURLParameter: getURLParameter,
			isObjectEqual: isObjectEqual,
			getMobileOS: getMobileOS,
			triggerBodyClicked: triggerBodyClicked,
			getViewportDimension: getViewportDimension,
			scrollTo: scrollTo,
			isMobile: isMobile,
			exportAngularObject: exportAngularObject,
			trustSrc: trustSrc,
			isReferralCodeValidFormat: isReferralCodeValidFormat,
			copyStringToClipboard: copyStringToClipboard,
			getLocationUser: getLocationUser,
			wrapQuotes: wrapQuotes
		};
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.factory('stringUtils', stringUtils);

	stringUtils.$inject = ['$sce'];

	function stringUtils($sce) {
		function buildString(value, fallback) {
			if (value) return value;
			return fallback ? fallback : '';
		}

		function arrayToString(array) {
			var str = null;
			if (array && array.length > 0) {
				str = array.join(",");
			}
			return str;
		}

		function capitalizeChar(str, index) {
			return str.charAt(index).toUpperCase() + str.substr(index + 1);
		}

		function camelCaseToTitleCase(input) {
			return input.replace(/([A-Z])/g, ' $1')
				.replace(/^./, function (str) {
					return str.toUpperCase();
				})
		}

		function toTitleCase(input) {
			input = input || '';
			input = input.toLowerCase();
			var smallWords = /^(a|an|and|as|at|but|by|en|for|if|in|nor|of|on|or|per|the|to|vs?\.?|via)$/i;
			return input.replace(/[A-Za-z0-9\u00C0-\u00FF]+[^\s-]*/g, function (match, index, title) {
				if (index > 0 && index + match.length !== title.length &&
					match.search(smallWords) > -1 && title.charAt(index - 2) !== ":" &&
					(title.charAt(index + match.length) !== '-' || title.charAt(index - 1) === '-') &&
					title.charAt(index - 1).search(/[^\s-]/) < 0) {
					return match.toLowerCase();
				}

				if (match.substr(1).search(/[A-Z]|\../) > -1) {
					return match;
				}

				return match.charAt(0).toUpperCase() + match.substr(1);
			});
		}

		function toSnakeCase(input) {
			if (!input) return;
			return input.replace(/ /g, '-');
		}

		function extractNumberFromString(str) {
			return str.match(/\d+/)[0];
		}

		function replaceAt(string, index, replacement) {
			return string.substr(0, index) + replacement + string.substr(index + replacement.length);
		}

		function htmlToPlaintext(text) {
			return text ? String(text).replace(/<[^>'"]+>/gm, '') : '';
		}

		function removeSpecialChar(text) {
			return text ? String(text).replace(/[^\w\s]/gi, '') : '';
		}

		function convertToTrustHtml(text) {
			return $sce.getTrustedHtml(text);
		}

		function isEqual(str1, str2) {
			if (str1 && str2) return str1 === str2;
			if (!str1 && !str2) return true;
			return false;
		}

		function extractJSON(str) {
			var firstOpen, firstClose, candidate;
			firstOpen = str.indexOf('{', firstOpen + 1);
			do {
				firstClose = str.lastIndexOf('}');
				if (firstClose <= firstOpen) {
					return null;
				}
				do {
					candidate = str.substring(firstOpen, firstClose + 1);
					try {
						var res = JSON.parse(candidate);
						return res;
					} catch (e) {
						console.log('...failed');
					}
					firstClose = str.substr(0, firstClose).lastIndexOf('}');
				} while (firstClose > firstOpen);
				firstOpen = str.indexOf('{', firstOpen + 1);
			} while (firstOpen != -1);
		}

		function removeDashAndCamelCase(string) {
			return string.replace(/-([a-z])/ig, function (all, letter) {
				return letter.toUpperCase();
			});
		}

		function replaceDashBySpace(string) {
			return string.replace(/-/g, ' ');
		}

		function isValueString(ele) {
			if (ele == null) {
				return false;
			} else {
				return true;
			}
		}

		function cutStringByCount(string, index, replacement) {
			return string.substr(0, index) + replacement;
		}

		return {
			buildString: buildString,
			arrayToString: arrayToString,
			capitalizeChar: capitalizeChar,
			extractNumberFromString: extractNumberFromString,
			toTitleCase: toTitleCase,
			replaceAt: replaceAt,
			htmlToPlaintext: htmlToPlaintext,
			convertToTrustHtml: convertToTrustHtml,
			isEqual: isEqual,
			extractJSON: extractJSON,
			camelCaseToTitleCase: camelCaseToTitleCase,
			toSnakeCase: toSnakeCase,
			removeDashAndCamelCase: removeDashAndCamelCase,
			replaceDashBySpace: replaceDashBySpace,
			isValueString: isValueString,
			cutStringByCount: cutStringByCount,
			removeSpecialChar: removeSpecialChar
		};
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.factory('priceUtils', priceUtils);

	priceUtils.$inject = ['systemUtils'];

	function priceUtils(systemUtils) {
		function createSkeletonPriceStructure(price) {
			var result = systemUtils.clone(price);
			result.id = null;
			result.value = 0;
			result.displayValue = "Select Large photo price";
			for (var i = 0; i < result.range.length; i++) {
				result.range[i].value = 0;
				result.range[i].price = 0;
				result.range[i].id = null;
			}
			return result;
		}

		function calculateDiscountAmount(price, discount) {
			return parseFloat(price) * parseFloat(discount.rate_amount);
		}

		function calculatePriceAfterDiscount(price, discounts) {
			return parseFloat(price) - _.reduce(discounts, function (memo, discount) {
				memo += calculateDiscountAmount(price, discount);
				return memo;
			}, 0)
		}

		return {
			createSkeletonPriceStructure: createSkeletonPriceStructure,
			calculateDiscountAmount: calculateDiscountAmount,
			calculatePriceAfterDiscount: calculatePriceAfterDiscount
		};
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.factory('portfolioUtils', portfolioUtils);

	portfolioUtils.$inject = ['pathUtils'];

	function portfolioUtils(pathUtils) {

		function getInstance() {
			return {
				title: '',
				description: '',
				privateOnly: false,
				type: 'portfolio'
			}
		}

		function extractIdsFromGalleries(galleries) {
			return _.reduce(galleries, function (memo, gallery) {
				memo.push(gallery.id);
				return memo;
			}, []);
		}

		function buildGalleriesFromIds(galleryIds) {
			return _.reduce(galleryIds, function (memo, id) {
				memo.push({
					id: id
				});
				return memo;
			}, []);
		}

		function extractGalleriesName(galleries) {
			var arr = _.reduce(galleries, function (memo, gallery) {
				memo.push(gallery.title);
				return memo;
			}, []);
			return _.uniq(arr);
		}

		function updateThumnailPath(gallery) {
			if (!gallery.media.length) return;
			if (!gallery.media[0].id || /\s/.test(gallery.media[0].id)) {
				//null id or it has any kind of whitespace
				Sentry.captureException(gallery);
			}
			gallery.coverPath = gallery.media[0].id ? pathUtils.buildFilePath(gallery.media[0].id, "600x") : '';
			gallery.thumbnailPath = [];
			for (var i = 0; i < gallery.media.length; i++) {
				var thumbnailPath = pathUtils.buildFilePath(gallery.media[i].id, "600x");
				gallery.thumbnailPath.push(thumbnailPath);
			}
		}

		return {
			getInstance: getInstance,
			extractIdsFromGalleries: extractIdsFromGalleries,
			buildGalleriesFromIds: buildGalleriesFromIds,
			extractGalleriesName: extractGalleriesName,
			updateThumnailPath: updateThumnailPath
		};
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.factory('photoGridUtils', photoGridUtils);

	photoGridUtils.$inject = ['galleryUtils', 'sessionManagerSvc', 'accountUtils'];

	function photoGridUtils(galleryUtils, sessionManagerSvc, accountUtils) {
		function transformMedia(photo) {
			var mLoginnedUser = sessionManagerSvc.getCurrentLoginUser().data;

			photo.url = photo.thumbnails["w/1024x"];
			photo.urlSmall = photo.thumbnails["x400"];
			photo.urlMedium = photo.thumbnails["x650"];
			photo.thumbnail = photo.thumbnails["160x"];
			photo.path = window.location.protocol + "//" + window.location.host + "/#!/photo/" + photo.id;
			photo.isMine = (mLoginnedUser && photo.user) ? mLoginnedUser.id === photo.user.id : false;
			photo.price = photo.price == -1 ? null : photo.price;
			if (photo.user) accountUtils.transformUserData(photo.user);
			if (!photo.galleries && photo.gallery_ids || (photo.galleries && photo.gallery_ids && photo.gallery_ids.length !== photo.galleries.length)) {
				photo.galleries = galleryUtils.buildGalleriesFromIds(photo.gallery_ids);
			}
		}

		function transformMedias(photos) {
			for (var i = 0; i < photos.length; i++) {
				transformMedia(photos[i]);
			}
		}

		return {
			transformMedias: transformMedias,
			transformMedia: transformMedia
		};
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.factory('pathUtils', pathUtils);

	pathUtils.$inject = ['fileConst', 'pixerfUrl'];

	function pathUtils(fileConst, pixerfUrl) {

		function buildMissionLogoUrl(profileImage) {
			return buildFilePath(profileImage, "x200", "h");
		}

		function getWebrootUrl() {
			return window.location.protocol + "//" + window.location.host;
		}

		function getFallbackFileUrl() {
			return getWebrootUrl() + "/assets/images/icon-market.png";
		}

		function buildFilePath(fileId, size, type) {
			if (!fileId) {
				return getFallbackFileUrl();
			}
			return type ? pixerfUrl.full + 'thumbnail/' + type + '/' + fileId + '/' + size : pixerfUrl.full + 'thumbnail/' + fileId + '/' + size;
		}

		function buildUserProfilePath(userId, size, noCache) {
			if (!size) size = '300x';
			return pixerfUrl.full + 'api/users/' + userId + '/profile/' + size + (noCache ? '?' + new Date().getTime() : '');
		}

		function buildUserCoverPath(userId, size, noCache) {
			if (!size) size = '1200x';
			return pixerfUrl.full + 'api/users/' + userId + '/cover/' + size + (noCache ? '?' + new Date().getTime() : '');
		}

		function buildFilestackPath(fileId, size) {
			if (!fileId) {
				return getFallbackFileUrl();
			}
			return fileConst.PATH.FILESTACK + size + '/' + fileId;
		}

		function isFromFilestack(file) {
			if (!file.handle) return false;
			return file.handle.indexOf("-") === -1;
		}

		return {
			buildMissionLogoUrl: buildMissionLogoUrl,
			getWebrootUrl: getWebrootUrl,
			buildFilePath: buildFilePath,
			buildFilestackPath: buildFilestackPath,
			isFromFilestack: isFromFilestack,
			buildUserProfilePath: buildUserProfilePath,
			buildUserCoverPath: buildUserCoverPath

		};
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.factory('pagingUtils', pagingUtils);

	pagingUtils.$inject = [];

	function pagingUtils() {
		function isNoMorePageToLoad(currentPage, response) {
			var totalPage = getTotalPage(response);
			if (typeof currentPage !== "number") currentPage = parseInt(currentPage);
			if (totalPage <= 1) return true;
			return currentPage >= totalPage;
		}

		function scrollToTop() {
			var $target = $("html, body");
			$target.stop().animate({
				scrollTop: 0
			}, '500', 'swing');
		}

		function scrollToSection(section, offsetTop) {
			var $target = $("html, body");
			$target.stop().animate({
				scrollTop: $(section).offset().top - offsetTop
			}, '500', 'swing');
		}

		function scrollElementToTop(element){
			var $target = $(element);
			$target.stop().animate({
				scrollTop: 0
			}, '500', 'swing');
		}

		function getTotalPage(response) {
			var pageNum = response.headers("total-pages");
			if (!pageNum) pageNum = response.headers("Total-Pages");
			if (!pageNum) return 0;
			return parseInt(pageNum);
		}

		function getTotalCount(response) {
			var totalCount = response.headers("total");
			if (!totalCount) totalCount = response.headers("Total");
			if (!totalCount) return 0;
			return parseInt(totalCount);
		}

		return {
			isNoMorePageToLoad: isNoMorePageToLoad,
			scrollToTop: scrollToTop,
			scrollToSection: scrollToSection,
			getTotalPage: getTotalPage,
			getTotalCount: getTotalCount,
			scrollElementToTop: scrollElementToTop
		};
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.factory('numberUtils', numberUtils);

	numberUtils.$inject = [];

	function numberUtils() {
		function fraction2Decimal(value) {
			try {
				return eval(value);
			} catch (ex) {
				return null;
			}
		}

		function parseInt(str) {
			try {
				return window.parseInt(str);
			} catch (ex) {
				return null;
			}
		}

		function formatNumber(number, separtor, numCharacter) {
			separtor = separtor ? separtor : ",";
			numCharacter = numCharacter ? numCharacter : 3;
			if (!number) return "0";
			var re = new RegExp('\\B(?=(\\d{' + numCharacter + '})+(?!\\d))', 'g');
			return number.toString().replace(re, separtor);
		}

		function getRandomInRange(start, end) {
			return Math.floor(Math.random() * end) + start;
		}

		function formatNumberByK(number) {
			var thousand = 1000;
			if (number < thousand) return number;
			var mod = number % thousand;
			if (mod === 0) {
				return (number / thousand) + "K";
			}
			if (mod < thousand * 0.1) {
				return (number / thousand).toFixed(0) + 'K';
			}
			return (number / thousand).toFixed(1) + 'K';
		}

		function getRandomInt(min, max) {
			min = Math.ceil(min);
			max = Math.floor(max);
			return Math.floor(Math.random() * (max - min)) + min;
		}

		return {
			fraction2Decimal: fraction2Decimal,
			parseInt: parseInt,
			formatNumber: formatNumber,
			getRandomInRange: getRandomInRange,
			formatNumberByK: formatNumberByK,
			getRandomInt: getRandomInt
		};
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.factory('modalUtils', modalUtils);

	modalUtils.$inject = ['$uibModalStack'];

	function modalUtils($uibModalStack) {

		function modalsExist() {
			return !!$uibModalStack.getTop();
		}

		function closeAllModals() {
			$uibModalStack.dismissAll();
		}

		return {
			modalsExist: modalsExist,
			closeAllModals: closeAllModals
		};
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.factory('imageUtils', imageUtils);

	imageUtils.$inject = ['$q'];

	function imageUtils($q) {

		function generateCanvasFromName(canvas, name, options) {
			options = options || {};
			var colours = ["#AAA4B6"];

			var nameSplit = name.split(" ");
			var initials = _.reduce(nameSplit, function (memo, item) {
				memo = memo + item.charAt(0).toUpperCase();
				return memo;
			}, "");

			var colourIndex = 0;

			var context = canvas.getContext("2d");

			var canvasWidth = $(canvas).attr("width"),
				canvasHeight = $(canvas).attr("height"),
				canvasCssWidth = canvasWidth,
				canvasCssHeight = canvasHeight;

			if (window.devicePixelRatio) {
				$(canvas).attr("width", canvasWidth * window.devicePixelRatio);
				$(canvas).attr("height", canvasHeight * window.devicePixelRatio);
				$(canvas).css("width", canvasCssWidth);
				$(canvas).css("height", canvasCssHeight);
				context.scale(window.devicePixelRatio, window.devicePixelRatio);
			}
			context.fillStyle = colours[colourIndex];
			context.fillRect(0, 0, canvas.width, canvas.height);
			context.font = options.font ? options.font : "14px 'open sans semibold'";
			context.font = "26px opensanssemibold";
			context.textAlign = "center";
			context.fillStyle = "#FFF";
			context.fillText(initials, canvasCssWidth / 2, canvasCssHeight / 2);
		}

		function generateCanvasFromImage(canvas, src, options) {
			var ctx = canvas.getContext("2d");
			var img = new Image();
			img.onload = function () {
				ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
			}
			img.src = src;
		}

		function customDropzoneThumbnail(file, dropzone) {
			window.loadImage.parseMetaData(file, function (data) {
				if (data.exif) {
					var orientation = data.exif.get('Orientation');
				}
				window.loadImage(file, function (img) {
					file.width = img.width;
					file.height = img.height;
					dropzone.emit('thumbnail', file, img.toDataURL ? img.toDataURL() : img);
				}, {
					orientation: orientation,
					maxWidth: dropzone.options.thumbnailWidth,
					maxHeight: dropzone.options.thumbnailHeight,
					canvas: true
				});
				return;
			});
		}

		function loadImageViaUrl(url) {
			var def = $q.defer();
			window.loadImage(url, function (img) {
				if (img.type === "error") {
					def.reject();
				} else {
					def.resolve(img);
				}
			});
			return def.promise;
		}

		function loadImageViaBlob(file) {
			var def = $q.defer();
			window.loadImage(file, function (img) {
				if (img.type === "error") {
					def.reject();
				} else {
					def.resolve(img);
				}
			});
			return def.promise;
		}

		function getDefaultPhotoColorArray(){
			return ['#a4d8ea', '#9ccbd8', '#93bfc9', '#86b0b7'];
		}

		return {
			generateCanvasFromName: generateCanvasFromName,
			generateCanvasFromImage: generateCanvasFromImage,
			customDropzoneThumbnail: customDropzoneThumbnail,
			loadImageViaUrl: loadImageViaUrl,
			loadImageViaBlob: loadImageViaBlob,
			getDefaultPhotoColorArray: getDefaultPhotoColorArray,
		};
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.factory('galleryUtils', galleryUtils);

	galleryUtils.$inject = ['pathUtils', 'galleryConst', 'systemUtils'];

	function galleryUtils(pathUtils, galleryConst, systemUtils) {

		function getInstance() {
			return {
				title: '',
				description: '',
				privateOnly: false
			}
		}

		function extractIdsFromGalleries(galleries) {
			return _.reduce(galleries, function (memo, gallery) {
				memo.push(gallery.id);
				return memo;
			}, []);
		}

		function buildGalleriesFromIds(galleryIds) {
			return _.reduce(galleryIds, function (memo, id) {
				memo.push({
					id: id
				});
				return memo;
			}, []);
		}

		function extractGalleriesName(galleries) {
			var arr = _.reduce(galleries, function (memo, gallery) {
				memo.push(gallery.title);
				return memo;
			}, []);
			return _.uniq(arr);
		}

		function updateThumnailPath(gallery, getOriginal) {
			if(getOriginal && gallery.cover_media){
				gallery.thumbnailPath = systemUtils.wrapQuotes(gallery.cover_media.thumbnails["x400"]);
				gallery.coverImagePath = gallery.cover_media.thumbnails["original"] ? systemUtils.wrapQuotes(gallery.cover_media.thumbnails["original"]) : systemUtils.wrapQuotes(gallery.cover_media.thumbnails["1440x"]);
			} else if (!gallery.cover_media) {
				gallery.thumbnailPath = systemUtils.wrapQuotes(gallery.cover_image ? pathUtils.buildFilestackPath(gallery.cover_image, "resize=height:600") : '');
				gallery.coverImagePath = systemUtils.wrapQuotes(gallery.cover_image ? pathUtils.buildFilestackPath(gallery.cover_image, "resize=width:1440") : '');
			} else {
				gallery.thumbnailPath = systemUtils.wrapQuotes(gallery.cover_media.thumbnails["x400"]);
				gallery.coverImagePath = systemUtils.wrapQuotes(gallery.cover_media.thumbnails["1440x"]);
			}
		}

		function getGalleryType(gallery, user) {
			if (gallery.is_curated) return galleryConst.GALLERY_TYPE.CURATED;
			if (gallery.user.id !== user.id) return galleryConst.GALLERY_TYPE.FOLLOWING;
			return galleryConst.GALLERY_TYPE.DEFAULT;
		}

		return {
			getInstance: getInstance,
			extractIdsFromGalleries: extractIdsFromGalleries,
			buildGalleriesFromIds: buildGalleriesFromIds,
			extractGalleriesName: extractGalleriesName,
			updateThumnailPath: updateThumnailPath,
			getGalleryType: getGalleryType
		};
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.factory('fileUtils', fileUtils);

	fileUtils.$inject = ['galleryUtils', 'tagUtils', 'pathUtils', 'sessionManagerSvc', 'accountUtils', 'badgeUtils', 'stringUtils'];

	function fileUtils(galleryUtils, tagUtils, pathUtils, sessionManagerSvc, accountUtils, badgeUtils, stringUtils) {
		function findFileById(files, id) {
			if (typeof id !== "number") id = parseInt(id);
			return _.find(files, function (p) {
				return p.id === id;
			});

		}

		function createPixerfBlob(howmany) {
			var arr = [];
			for (var i = 0; i < howmany; i++) {
				arr.push({
					title: '',
					name: '',
					thumbnail: '',
					size: 0,
					upload: {
						progress: 0
					}
				})
			}
			return arr;
		}

		function getFileStackMid(filestackBlob) {
			if (filestackBlob.url) {
				return _.last(filestackBlob.url.split("/"));
			}
			return '';
		}

		function fromFilestackBlob2PixerfBlob(pixerfFileBlob, filestackBlob) {
			pixerfFileBlob.title = filestackBlob.filename;
			pixerfFileBlob.name = filestackBlob.filename;
			pixerfFileBlob.thumbnail = pathUtils.buildFilestackPath(getFileStackMid(filestackBlob), "resize=height:300");
			pixerfFileBlob.handle = getFileStackMid(filestackBlob);
			pixerfFileBlob.key = filestackBlob.key;
			pixerfFileBlob.size = filestackBlob.size;
			pixerfFileBlob.upload = {
				progress: 0
			};
			return pixerfFileBlob;
		}

		function convertFromFileObject2PixerfBlob(file) {
			return {
				title: getFileNameWithoutExtension(file.name),
				name: file.name,
				thumbnail: '',
				size: file.size,
				upload: {
					progress: 0
				}
			}
		}

		function convertFileStackFilesToPixerfFiles(pixerfFileBlobs, filestackBlobs) {
			var length = Math.min(pixerfFileBlobs.length, filestackBlobs.length);
			for (var i = 0; i < length; i++) {
				fromFilestackBlob2PixerfBlob(pixerfFileBlobs[i], filestackBlobs[i]);
			}

		}

		function setFileProperty(file, property, value) {
			file[property] = value;
		}

		function getFileNameWithoutExtension(filename) {
			return filename.replace(/\.[^/.]+$/, "");
		}

		function getFileNameFromUrl(url, isIncludeExtension) {
			var fileName = url.split('/').pop();
			return isIncludeExtension ? fileName : getFileNameWithoutExtension(fileName);
		}

		function getFileExtension(filename) {
			try {
				return filename.split('.').pop();
			} catch (ex) {
				return '';
			}
		}

		function getLocation(location) {
			var retLocation = {
				latitude: 0,
				longitude: 0,
				reverse: ''
			};
			try {
				if (location && typeof location === 'object') {
					retLocation.latitude = location.geometry.location.lat();
					retLocation.longitude = location.geometry.location.lng();
					retLocation.reverse = location.formatted_address;
				} else {
					retLocation.reverse = location;
				}
				return retLocation.reverse;
			} catch (ex) {
				return null;
			}
		}

		function buildSavedFileObject(file) {
			return {
				key: file.key,
				id: file.id,
				handle: file.handle,
				title: file.title,
				license: file.license ? file.license : undefined,
				type: file.type ? file.type : 'default',
				categories: file.categories,
				description: file.description,
				location: getLocation(file.location),
				is_camera_model_hidden: file.is_camera_model_hidden ? true : false,
				galleries: file.galleries,
				tags: tagUtils.extractTagsText(file.tags),
				price_id: file.price ? file.price.id : undefined,
				rotate_by: file.rotate_by,
				has_model_property: file.has_model_property,
				releases: file.releases,
				is_releasable: file.is_releasable
			}
		}

		function extractHandleFromFiles(files) {
			//TODO
			// files = [files[0]];
			var handles = _.reduce(files, function (memo, item) {
				memo.push(item.handle);
				return memo;
			}, []);
			return handles.join(',');
		}

		function extractIdsFromFiles(files) {
			var handles = _.reduce(files, function (memo, item) {
				memo.push(item.id);
				return memo;
			}, []);
			return handles;
		}

		function transform(photo, freshImage) {
			var mLoginnedUser = sessionManagerSvc.getCurrentLoginUser().data;
			var fingerPrint = freshImage ? ("?" + new Date().getTime()) : '';
			photo.badges = badgeUtils.transformBadges(photo.badges);

			photo.url = photo.thumbnails["w/1500x"];
			photo.urlSmall = photo.thumbnails["x400"];
			photo.thumbnailBig = photo.thumbnails["x300"];
			photo.thumbnail = photo.thumbnails["160x"];

			photo.isMine = (mLoginnedUser && photo.user) ? mLoginnedUser.id === photo.user.id : false;
			photo.price = photo.price == -1 ? null : photo.price;
			if (photo.user) accountUtils.transformUserData(photo.user);
			photo.path = window.location.protocol + "//" + window.location.host + "/#/photo/" + photo.id + "/" + buildFileSeoTitle(photo);
			if (!photo.galleries && photo.gallery_ids || (photo.galleries && photo.gallery_ids && photo.gallery_ids.length !== photo.galleries.length)) {
				photo.galleries = galleryUtils.buildGalleriesFromIds(photo.gallery_ids);
			}
		}

		function transforms(photos) {
			for (var i = 0; i < photos.length; i++) {
				transform(photos[i]);
			}
		}

		function buildFileSeoTitle(file) {
			if (!file) return '';
			return stringUtils.toSnakeCase(file.title + " by" + " " + (file.user ? file.user.displayName : ''));
		}

		return {
			findFileById: findFileById,
			fromFilestackBlob2PixerfBlob: fromFilestackBlob2PixerfBlob,
			convertFileStackFilesToPixerfFiles: convertFileStackFilesToPixerfFiles,
			getFileNameFromUrl: getFileNameFromUrl,
			getFileExtension: getFileExtension,
			buildSavedFileObject: buildSavedFileObject,
			createPixerfBlob: createPixerfBlob,
			convertFromFileObject2PixerfBlob: convertFromFileObject2PixerfBlob,
			getFileNameWithoutExtension: getFileNameWithoutExtension,
			getFileStackMid: getFileStackMid,
			extractHandleFromFiles: extractHandleFromFiles,
			extractIdsFromFiles: extractIdsFromFiles,
			transforms: transforms,
			transform: transform,
			buildFileSeoTitle: buildFileSeoTitle
		};
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.factory('dateUtils', dateUtils);

	dateUtils.$inject = ['numberUtils'];

	function dateUtils(numberUtils) {
		function getRecentYears(howManyYears) {
			var currentYear = new Date().getFullYear();
			var result = [];
			for (var i = 0; i < howManyYears; i++) {
				result.push(currentYear - i);
			}

			return result;
		}

		function formatToString(value, formatPattern) {
			if (!formatPattern) formatPattern = 'DD MMMM YYYY';
			return moment(value).format(formatPattern);
		}

		function getDateFrom(fromDate, howMany, unit) {
			return fromDate.subtract(numberUtils.parseInt(howMany), unit).valueOf();
		}

		function getStartOfYear(year) {
			return moment("01/01/" + year, "DD/MM/YYYY").valueOf();
		}

		function getEndOfYear(year) {
			return moment("31/12/" + year, "DD/MM/YYYY").valueOf();
		}

		function getMonthDateRange(month, year) {
			var startDate = moment([year, month - 1]).valueOf();
			var endDate = moment(startDate).endOf('month').valueOf();
			return {
				start: startDate,
				end: endDate
			};
		}

		function now(format) {
			if (!format) return moment().valueOf();
			return moment().format(format);
		}

		function isInWeek(time) {
			var today = moment();
			return today.diff(moment.utc(time).local(), "days") <= 7;
		}

		function countDown(deadline, step) {
			if (!moment.isMoment(deadline)) return "Not momment object";
			var diff = deadline.diff(moment(), "milliseconds");
			var duration = moment.duration(diff, 'milliseconds');
			return duration - step; //step in ms
		}

		function preciseDiff(from, to){
			var result = []
			var duration = moment.duration(from.diff(to));

			var years = duration.years();
			if(years) result.push(years + 'y');

			var months = duration.months();
			if(months) result.push(months+ 'm');

			var days = duration.days();
			if(days || !result.length) result.push(days+ 'd');

			return result.join(' ');
		}

		return {
			formatToString: formatToString,
			getRecentYears: getRecentYears,
			getDateFrom: getDateFrom,
			getStartOfYear: getStartOfYear,
			getEndOfYear: getEndOfYear,
			getMonthDateRange: getMonthDateRange,
			now: now,
			isInWeek: isInWeek,
			countDown: countDown,
			preciseDiff: preciseDiff
		};
	}
})();

(function () {
    'use strict';

    angular
        .module('pixerf')
        .factory('countryUtils', countryUtils);

    countryUtils.$inject = ['$translate'];

    function countryUtils($translate) {
        var aseanCountries = [
            'BN', 'KH', 'CX', 'CC', 'ID', 'LA', 'MY', 'MM', 'PH', 'SG', 'TH', 'TL', 'VN'
        ];
        var asiaCountries = [
            'CN', 'HK', 'MO', 'JP', 'MN', 'KP', 'KR', 'TW', 'BD', 'BT', 'IO', 'IN', 'MV', 'NP', 'PK', 'LK', 'BN', 'KH', 'CX', 'CC', 'ID', 'LA', 'MY', 'MM', 'PH', 'SG', 'TH', 'TL', 'VN'
        ];
        var apacCountries = [
            'CN', 'HK', 'MO', 'JP', 'MN', 'KP', 'KR', 'TW', 'BD', 'BT', 'IO', 'IN', 'MV', 'NP', 'PK', 'LK', 'BN', 'KH', 'CX', 'CC', 'ID', 'LA', 'MY', 'MM', 'PH', 'SG', 'TH', 'TL', 'VN', 'AU', 'NZ', 'FJ', 'NC', 'PG', 'SB', 'VU', 'GU', 'KI', 'MH', 'FM', 'NR', 'MP', 'PW', 'AS', 'CK', 'PF', 'NU', 'NF', 'PN', 'WS', 'TK', 'TO', 'TV', 'WF'
        ];

        var regions = [
            {
                label: $translate.instant("south-east-asia"),
                value: 'south_east_asia',
                countries: aseanCountries
            },
            {
                label: $translate.instant("asia"),
                value: 'asia',
                countries: asiaCountries
            },
            {
                label: $translate.instant("asia-pacific"),
                value: 'asia_pacific',
                countries: apacCountries
            },
            {
                label: $translate.instant("all-countries"),
                value: 'all_countries',
                countries: []
            }
        ]

        function sortByPriority(priorityCountryCodeList, countries) {
            var result = [];
            for (var i = 0; i < priorityCountryCodeList.length; i++) {
                var index = countries.findIndex(function (o) { return priorityCountryCodeList[i] === o.id; })
                if (index >= 0) {
                    var country = { id: countries[index].id + 'FAKE', name: countries[index].name }
                    result.push(country);
                }
            }
            if (countries.length) {
                result.push({
                    id: 'lineBreak',
                    name: ''
                });
            }
            return result.concat(countries);
        }

        function getCountryArrObjectFromArrId(arrIds, countries) {
            var result = [];
            if (!arrIds) return result;
            for (var i = 0; i <= arrIds.length; i++) {
                var countryObject = _.find(countries, function (o) { return arrIds[i] === o.id });
                if (countryObject && countryObject.id) {
                    result.push(countryObject);
                }
            }
            return result;
        }

        function sortCountries(countryArrIds, priorityCountry){
            var result = [];
            if(!countryArrIds || !countryArrIds.length){
                return result;
            }
            if(!priorityCountry ){
                priorityCountry = 'SG';
            }
            if(!_.contains(countryArrIds, priorityCountry)){
                return countryArrIds;
            }
            result.push(priorityCountry);
            countryArrIds = _.without(countryArrIds, priorityCountry);
            return result.concat(countryArrIds);
        }

        function getRegion(countryArrIds) {
            var searchCount = countryArrIds.length;
            var isMatchLength = false;
            var matchIndex = [];
            var result = {};
            for (var i = 0; i < regions.length; i++) {
                if (searchCount == regions[i].countries.length) {
                    isMatchLength = true;
                    matchIndex.push(i);
                }
            }
            if (!isMatchLength) {
                return result;
            }

            for (var index = 0; index < matchIndex.length; index++) {
                var isUnmatch = false;
                for (var countryIndex = 0; countryIndex < countryArrIds.length; countryIndex++) {
                    var isInclude = (regions[matchIndex[index]].countries).includes(countryArrIds[countryIndex]);
                    if (!isInclude) {
                        isUnmatch = true;
                        break;
                    }
                }
                if(!isUnmatch){
                    result = regions[matchIndex[index]];
                }
            }

            return result;
        }

        function getCountryIdsFromRegion(regionId) {
            var result = [];
            var region = _.find(regions, function (o) { return regionId === o.value });
            if (!region) return result;
            result = (region ? region.countries : []);
            return result;
        }

        return {
            sortByPriority: sortByPriority,
            getCountryArrObjectFromArrId: getCountryArrObjectFromArrId,
            regions: regions,
            getRegion: getRegion,
            getCountryIdsFromRegion: getCountryIdsFromRegion,
            sortCountries: sortCountries
        };
    }
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.factory('communityUtils', communityUtils);

	communityUtils.$inject = ['sessionManagerSvc', 'accountUtils', 'accountConst'];

	function communityUtils(sessionManagerSvc, accountUtils, accountConst) {

		var mLoginnedUser = sessionManagerSvc.getCurrentLoginUser().data;

		function transform(rawData) {
			rawData.isMine = (mLoginnedUser && rawData.owner) ? mLoginnedUser.id === rawData.owner.id : false;
            rawData.isManager = mLoginnedUser && ['manager'].includes(rawData.membership_status);
			if (rawData.owner) {
				rawData.owner.avatar = accountUtils.buildUserAvatarPhotoUrl(rawData.owner);
				rawData.owner.displayName = accountUtils.buildUserDisplayName(rawData.owner);
				rawData.owner.isBiz = rawData.owner.account_type === accountConst.ACCOUNT_TYPE.BUSINESS;
				rawData.owner.isMine = sessionManagerSvc.isMine(rawData.owner);
			}
			if (rawData.avatar) {
				rawData.avatar.url = rawData.avatar.thumbnails["150x"];
				rawData.avatar.url400 = rawData.avatar.thumbnails["400x"];
			}
			if (rawData.members && rawData.members.length) {
				transformMembers(rawData.members);
			}
			if(rawData.info && rawData.info.members && rawData.info.members.length){
				transformMembers(rawData.info.members);
			}
			if(rawData.info && rawData.info.interested_members && rawData.info.interested_members.length){
				transformMembers(rawData.info.interested_members);
			}
			if(rawData.cover && rawData.cover.large){
				rawData.cover.large += '?t' + moment().unix();
			}
			if(rawData.cover && rawData.cover.medium){
				rawData.cover.medium += '?t' + moment().unix();
			}
			if(rawData.cover && rawData.cover.original){
				rawData.cover.original += '?t' + moment().unix();
			}
			if(rawData.cover && rawData.cover.thumbnail){
				rawData.cover.thumbnail += '?t' + moment().unix();
			}
		}

		function transformMultiple(rawDatas) {
			for (var i = 0; i < rawDatas.length; i++) {
				transform(rawDatas[i]);
			}
		}

		function transformMembers(members) {
			for (var i = 0; i < members.length; i++) {
				members[i].displayName = accountUtils.buildUserDisplayName(members[i]);
				members[i].avatar = accountUtils.buildUserAvatarPhotoUrl(members[i]);
			}
		}

		return {
			transform: transform,
			transformMultiple: transformMultiple
		};
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.factory('categoryUtils', categoryUtils);

	categoryUtils.$inject = [];

	function categoryUtils() {

		function extractIdsFromCategories(categories) {
			return _.reduce(categories, function (memo, category) {
				memo.push(category.id);
				return memo;
			}, []);
		}

		function buildCategoriesFromIds(ids) {
			return _.reduce(ids, function (memo, id) {
				memo.push({
					id: id
				});
				return memo;
			}, []);
		}

		return {
			extractIdsFromCategories: extractIdsFromCategories,
			buildCategoriesFromIds: buildCategoriesFromIds
		};
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.factory('cartUtils', cartUtils);

	cartUtils.$inject = ['priceConst'];

	function cartUtils(priceConst) {
		function getLicenseById(extendedLicenses, id) {
			return _.find(extendedLicenses, function (item) {
				return item.id === id;
			});
		}

		function setSelectedLicense(extendedLicenses, license) {
			if (license.id === "UNLIMITED_PRINT" && license.isSelected) {
				var relatedLicense = getLicenseById(extendedLicenses, "MULTI_SEAT");
				relatedLicense.isSelected = !license.isSelected;
			} else if (license.id === "MULTI_SEAT" && license.isSelected) {
				var relatedLicense = getLicenseById(extendedLicenses, "UNLIMITED_PRINT");
				relatedLicense.isSelected = !license.isSelected;
			}
		}

		function updateCartSelectedVariant(cartItem, rawData) {
			if (!cartItem.media.extendedLicenses) {
				cartItem.media.extendedLicenses = $.extend(true, [], priceConst.EXTENDED_LICENSES);
			}

			for (var i = 0; i < cartItem.media.extendedLicenses.length; i++) {
				var license = cartItem.media.extendedLicenses[i];
				license.isSelected = !!rawData[license.key];
				setSelectedLicense(cartItem.media.extendedLicenses, license);
			}

			var priceRange = cartItem.media.price.range;
			for (var i = 0; i < priceRange.length; i++) {
				priceRange[i].isSelected = priceRange[i].size === rawData.size;
			}
		}

		function getPhotoByLineId(items, lineId) {
			var item = _.find(items, function (it) {
				return it.id === lineId;
			});
			if (item) return item.media;
		}

		return {
			updateCartSelectedVariant: updateCartSelectedVariant,
			setSelectedLicense: setSelectedLicense,
			getPhotoByLineId: getPhotoByLineId
		};
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.factory('bankUtils', bankUtils);

	bankUtils.$inject = ['bankConst'];

	function bankUtils(bankConst) {
		function getCurrencyByCode(code) {
			var currency = bankConst.COUNTRY_CURRENCY_MAP[code];
			return {
				code: currency.code,
				name: currency.name
			}
		}

		function getLabelFromKey(key, currency) {
			if (key === "addressPostCode") {
				if (currency === "USD") {
					key += "_US";
				}
			}
			return bankConst.BANK_KEY_LABEL_MAPPING[key];

		}

		function getBankNameFromCode(swiftCode, currency) {
			var found = _.find(bankConst.BANKS[currency], function (bank) {
				return bank.code === swiftCode;
			});
			if (found) {
				return found.title;
			}
		}

		return {
			getCurrencyByCode: getCurrencyByCode,
			getLabelFromKey: getLabelFromKey,
			getBankNameFromCode: getBankNameFromCode
		};
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.factory('badgeUtils', badgeUtils);

	badgeUtils.$inject = ['accountConst', 'stringUtils'];

	function badgeUtils(accountConst, stringUtils) {

		var mBadgeDescriptionMapping = {
			"ABM": "Exceptional Pixerfers who are internationally recognised, awarded and established in their respective fields. Ambassadors Maestro are brand allies that help build and strengthen the PIXERF community by providing guidance, inspiration, and brand advocacy in the visual creative community.",
			"ABP": "Outstanding Pixerfers who have impressive portfolios, and who advocate the PIXERF brand. Ambassadors Pro are usually professionals, enthusiasts, and influencers in the visual creative community.",
			"PC": "Popular Pixerfers as nominated by other Pixerfers and our team of Curators."
		}

		function getBadgeDescription(badgeCode) {
			return mBadgeDescriptionMapping[badgeCode];
		}

		function createNewBadge(data) {
			return {
				"code": data.code,
				"id": null,
				"title": data.title,
				"type": data.type,
				"class": "icon-icons-badge-" + data.code,
				"description": data.description
			}
		}

		function transformBadges(badges) {
			if (!badges) return;
			badges = badges.sort(function (b1, b2) {
				return b1.code > b2.code;
			})
			for (var i = 0; i < badges.length; i++) {
				var badge = badges[i];
				transformBadge(badge);
			}
			return badges;
		}

		function transformBadge(badge) {
			badge.class = 'icon-icons-badge-' + badge.code;
			badge.link = buildBadgeLink(badge);
			badge.description = getBadgeDescription(badge.code)
		}

		function getAmbassadorBadgeCode(ambassadorship) {
			return ambassadorship === accountConst.AMBASSADORSHIP.MAESTRO ? "ABM" : "ABP";
		}

		function buildBadgeLink(badge) {
			if (badge.code === "MC" || badge.code === "M" || badge.code === "MGW" || badge.code === "MG" || badge.code === "MS" || badge.code === "MB") {
				return _.template("/mission-detail-page/<%=id%>")(badge);
			}
		}

		function getAmbassadorBadge(ambassadorship) {
			var badgeCode = getAmbassadorBadgeCode(ambassadorship);
			return createNewBadge({
				code: badgeCode,
				title: "Ambassador",
				type: "user",
				description: getBadgeDescription(badgeCode)
			})
		}

		function updateBadgesByAmbassadorship(badges, ambassadorship) {
			if (!ambassadorship) {
				badges = _.reject(badges, function (b) {
					return b.code === "ABM" || b.code === "ABP";
				});
			} else {
				var ambassadorBadge = _.find(badges, function (b) {
					return b.code === "ABM" || b.code === "ABP";
				});
				if (ambassadorBadge) {
					ambassadorBadge.code = getAmbassadorBadgeCode(ambassadorship);
					ambassadorBadge.title = "Ambassador " + stringUtils.toTitleCase(ambassadorship);
					ambassadorBadge.class = "icon-icons-badge-" + ambassadorBadge.code;
				} else {
					badges.push(getAmbassadorBadge(ambassadorship));
				}
			}
			return badges;
		}

		function compactPrizes(prizes) {
			var totalReward = 0;
			var prizes_grouped = _.groupBy(prizes, function (p) {
				return p.type;
			});
			var madatoryTypes = Object.keys(prizes_grouped);
			for (var i = 0; i < madatoryTypes.length; i++) {
				var type = madatoryTypes[i];
				if (!prizes_grouped[type]) {
					var prizes = [];
					prizes.quantity = 0;
					prizes.total = 0;
					prizes.value = 0;
					prizes_grouped[type] = prizes;
				} else {
					prizes_grouped[type].quantity = prizes_grouped[type].length;
					prizes_grouped[type].value = prizes_grouped[type][0].value;
					prizes_grouped[type].total = prizes_grouped[type].quantity * prizes_grouped[type].value;
				}
				totalReward += prizes_grouped[type].total;
			}
			prizes_grouped.totalReward = totalReward;
			return prizes_grouped;
		}

		function extractPrizes(prizes_grouped) {
			var prizes = [];
			for (var type in prizes_grouped) {
				if (type === "CONSOLATION" || type === "WINNER" || type === "SPECIAL_MENTION") {
					for (var i = 0; i < prizes_grouped[type].quantity; i++) {
						prizes.push({
							type: type,
							value: prizes_grouped[type].value,
							name: ["CONSOLATION","SPECIAL_MENTION"].includes(type) ? "Special Mention" : "Winner",
							is_cash: true
						})
					}
				}
			}
			return prizes;
		}

		function multiTierPrizeAnalyze(prizes) {
			var prize = compactPrizes(prizes);
			var multiTier = {};

			if (prize['GRAND_WINNER']) {
				multiTier.grandWinner = {
					quantity: prize['GRAND_WINNER'].quantity,
					value: prize['GRAND_WINNER'].value
				}
			}
			if (prize['RUNNER_UP_1']) {
				multiTier.secondWinner = {
					quantity: prize['RUNNER_UP_1'].quantity,
					value: prize['RUNNER_UP_1'].value
				}
			}
			if (prize['RUNNER_UP_2']) {
				multiTier.thirdWinner = {
					quantity: prize['RUNNER_UP_2'].quantity,
					value: prize['RUNNER_UP_2'].value
				}
			}
			if (prize['WINNER'] && multiTier.secondWinner) {
				multiTier.firstWinner = {
					quantity: prize['WINNER'].quantity,
					value: prize['WINNER'].value
				}
			} else if (prize['WINNER']) {
				multiTier.winner = {
					quantity: prize['WINNER'].quantity,
					value: prize['WINNER'].value,
					name: prize['WINNER'][0].name
				}
			}
			if (prize['CONSOLATION'] && multiTier.firstWinner) {
				multiTier.winner = {
					quantity: prize['CONSOLATION'].quantity,
					value: prize['CONSOLATION'].value
				}
			} else if (prize['CONSOLATION']) {
				multiTier.consolation = {
					quantity: prize['CONSOLATION'].quantity,
					value: prize['CONSOLATION'].value,
					name: prize['CONSOLATION'][0].name
				}
			}

			return multiTier;
		}

		return {
			transformBadges: transformBadges,
			getAmbassadorBadge: getAmbassadorBadge,
			updateBadgesByAmbassadorship: updateBadgesByAmbassadorship,
			compactPrizes: compactPrizes,
			extractPrizes: extractPrizes,
			multiTierPrizeAnalyze: multiTierPrizeAnalyze
		};
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.factory('arrayUtils', arrayUtils);

	arrayUtils.$inject = [];

	function arrayUtils() {
		function shuffle(array) {
			var currentIndex = array.length,
				temporaryValue, randomIndex;

			// While there remain elements to shuffle...
			while (0 !== currentIndex) {

				// Pick a remaining element...
				randomIndex = Math.floor(Math.random() * currentIndex);
				currentIndex -= 1;

				// And swap it with the current element.
				temporaryValue = array[currentIndex];
				array[currentIndex] = array[randomIndex];
				array[randomIndex] = temporaryValue;
			}

			return array;
		}

		function indexOf(array, iterator) {
			for (var i = 0; i < array.length; i++) {
				if (iterator(array[i])) return i;
			}
			return -1;
		}

		function swapElement(array, one, two) {
			var indexOne = _.indexOf(array, one);
			var indexTwo = _.indexOf(array, two);
			if (indexOne !== -1 && indexTwo !== -1) {
				var temp = array[indexOne];
				array[indexOne] = array[indexTwo];
				array[indexTwo] = temp;
			}
		}

		function isEqual(one, two, propertyOne, propertyTwo) {
			if ((!one && two) || (one && !two)) return false;
			if (one.length !== two.length) return false;
			for (var i = 0; i < one.length; i++) {
				var found = _.find(two, function (gl) {
					var oneValue = one[i].hasOwnProperty(propertyOne) ? one[i][propertyOne] : one[i];
					var twoValue = gl.hasOwnProperty(propertyTwo) ? gl[propertyTwo] : gl;

					return oneValue === twoValue;

				})
				if (!found) return false;
			}
			return true;
		}

		function getIntersection(arrays, comparedProperty) {
			var i, all, shortest, nShortest, n, len, ret = [],
				obj = {},
				nOthers;
			nOthers = arrays.length - 1;
			nShortest = arrays[0].length;
			shortest = 0;
			for (i = 0; i <= nOthers; i++) {
				n = arrays[i].length;
				if (n < nShortest) {
					shortest = i;
					nShortest = n;
				}
			}

			for (i = 0; i <= nOthers; i++) {
				n = (i === shortest) ? 0 : (i || shortest); //Read the shortest array first. Read the first array instead of the shortest
				len = arrays[n].length;
				for (var j = 0; j < len; j++) {
					var elem = arrays[n][j][comparedProperty];
					if (obj[elem] === i - 1) {
						if (i === nOthers) {
							ret.push(arrays[n][j]);
							obj[elem] = 0;
						} else {
							obj[elem] = i;
						}
					} else if (i === 0) {
						obj[elem] = 0;
					}
				}
			}
			return ret;
		}

		function isValueArr(ele) {
			if (!ele || !ele.length) {
				return false;
			} else {
				return true;
			}
		}

		return {
			shuffle: shuffle,
			indexOf: indexOf,
			swapElement: swapElement,
			isEqual: isEqual,
			getIntersection: getIntersection,
			isValueArr: isValueArr
		};
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.factory('activityUtils', activityUtils);

	activityUtils.$inject = ['accountUtils', 'sessionManagerSvc', 'stringUtils', '$translate', 'commonConst'];

	function activityUtils(accountUtils, sessionManagerSvc, stringUtils, $translate, commonConst) {

		var self = this;
		self.commonConst = commonConst;
		var mObjectHumnanTextMapping = {
			'media': 'photo',
			'user': 'you',
			'comment': 'comment',
			'community': 'community'
		}
		var mVerbHumnanTextMapping = {
			'invited_community': 'invited <%=user%> to join community',
			'requested_community': 'notification-requested-join-community',
			'accepted_community_request': 'accepted <%=user%> request to join community',
			'accepted_community_invitation': 'notification-joined-community',
			'rejected': 'notification-has-curated',
			'approved': 'notification-has-curated',
			'commented': 'notification-commented-on',
			'rejected_discussion': 'notification-rejected-discussion',
			'invited_community_event': 'invited <%=user%> to join community event',
			'accepted_community_event_invitation': 'notification-accepted-community-event-invitation',
			'joined_community_event': 'notification-joined-community-event',
			'resolved_community_report': 'notification-resolved-community-report',
			'validated_community_report': 'notification-validated-community-report',
			'rejected_event_post': 'notification-rejected-event-post',
			'updated_community_event': 'notification-updated-community-event',
			'updated_community': 'notification-updated-community',
			'deactivated_community': 'notification-deactivated-community',
			'created_community': 'notification-created-community',
			'created_event_post': 'created_event_post',
			'requested_changes_community': 'notification-requested-changes-community',
			'approved_community': 'notification-approved-community',
			'rejected_community_invitation': 'notification-rejected-community-invitation',
			'set_as_manager': 'notification-set-as-manager',
			'removed_as_manager': 'notification-removed-as-manager',
			'interested_in_community_event': 'interested_in_community_event',
			'created_community_event': 'created_community_event',
			'bookmarked_discussion': 'bookmarked_discussion'
		}

		var mClickableObject = ["user", "media", "community", "discussion", "discussion_reply", "created_discussion", "community_event", "community_report"];

		function buildObjectLink(activity) {
			var objectLink = {};

			switch (activity.object.type) {
				case "media":
					objectLink = buildMediaObjectLink(activity);
					break;
				case "user":
					objectLink = buildUserObjectLink(activity);
					break;
				case "community":
					objectLink = buildCommunityObjectLink(activity.object);
					break;
				case "community_event":
					objectLink = buildCommunityEventObjectLink(activity.object);
					break;
				case "discussion":
				case "discussion_reply":
				case "created_discussion":
					objectLink = buildDiscussionObjectLink(activity.object);
					break;
				case "community_report":
					if (activity.object.item_type === "community") {
						objectLink = buildCommunityObjectLink(activity.object, true);
					} else if (activity.object.item_type === "event") {
						objectLink = buildCommunityEventObjectLink(activity.object, true);
					} else if (["discussion", "discussion_reply"].includes(activity.object.item_type)) {
						objectLink = buildDiscussionObjectLink(activity.object, true);
					}
					break;
			}

			return objectLink;
		}

		function getActivityObjectHumanText(activity) {
			var str = activity.verb;
			var loginUser = sessionManagerSvc.getCurrentLoginUser().data;

			switch (activity.verb) {
				case "followed":
					str = loginUser.id !== activity.object.id ? activity.object.content : "you";
					str = $translate.instant(str);
					break;
				case "nominated":
				case "liked":
				case "commented":
				case "approved":
				case "rejected":
					var ownerName = activity.owner ? activity.owner.first_name + ' ' + activity.owner.last_name : null;
					str = activity.owner && loginUser.id !== activity.owner.id ? 'someone-' : 'your-';
					str += mObjectHumnanTextMapping[activity.object.type];
					str = $translate.instant(str, {
						someone: ownerName
					});
					break;
				default:
					str = activity.object.content;
			}

			if (mClickableObject.indexOf(activity.object.type) === -1) return str;

			var template = "<a ui-sref=<%=link.uisref%> ui-sref-opts='{reload: true, notify: true}' title=\"<%=tootip_text%>\" class='text--semibold pixerf-link--color-theme notification-object-name'><%=inner_text%></a>";
			if (loginUser && (loginUser.account_type !== 'business') && !loginUser.isMaketerInternal && (activity.verb === "deactivated_community")) {
				template = "<a title=\"<%=tootip_text%>\" class='text--semibold pixerf-link--color-theme notification-object-name no-link'><%=inner_text%></a>";
			}

			return _.template(template)({
				inner_text: str,
				tootip_text: activity.object.content,
				link: buildObjectLink(activity)
			});
		}

		function buildMediaObjectLink(activity) {
			if (activity.verb === "rejected") {
				return getManagePhotoSref("rejected");
			} else {
				return getPhotoSref({
					id: activity.object.id,
					photoTitle: stringUtils.toSnakeCase(activity.object.content)
				});
			}
		}

		function buildUserObjectLink(activity) {
			if (activity.owner) {
				var ownerName = activity.owner.first_name + ' ' + activity.owner.last_name;
				return getUserSref({
					id: activity.object.id,
					userName: stringUtils.toSnakeCase(ownerName)
				});
			} else {
				return getUserSref({
					id: activity.object.id,
					userName: stringUtils.toSnakeCase(activity.object.content)
				});
			}
		}

		function buildCommunityObjectLink(activityObj, isItemId) {
			return {
				uisref: _.template(self.commonConst.STATE.COMMUNITIES_DETAILS_DISCUSSIONS + "({id:<%=id%>,name:\"<%=content%>\"})")({
					id: isItemId ? activityObj.item_id : activityObj.id,
					content: stringUtils.toSnakeCase(activityObj.content)
				}),
				state: {
					name: self.commonConst.STATE.COMMUNITIES_DETAILS_DISCUSSIONS,
					params: {
						id: isItemId ? activityObj.item_id : activityObj.id,
						name: activityObj.content
					}
				}
			}
		}

		function buildCommunityEventObjectLink(activityObj, isItemId) {
			var uisrefParams = {
				id: isItemId ? activityObj.item_id : activityObj.id,
				content: stringUtils.toSnakeCase(activityObj.content)
			}
			var stateParams = {
				id: isItemId ? activityObj.item_id : activityObj.id,
				name: activityObj.content
			}

			if (activityObj.short_code) {
				uisrefParams.shortCode = activityObj.short_code;
				stateParams.shortCode = activityObj.short_code;
			}

			return {
				uisref: _.template(self.commonConst.STATE.EVENT_FEED + "({id:<%=id%>,name:\"<%=content%>\",shortCode:\"<%=shortCode%>\"})")(uisrefParams),
				state: {
					name: self.commonConst.STATE.EVENT_FEED,
					params: stateParams
				}
			}
		}

		function buildDiscussionObjectLink(activityObj, isItemId) {
			return {
				uisref: _.template(self.commonConst.STATE.DISCUSSION_DETAIL + "({id:<%=id%>,subject:\"<%=content%>\"})")({
					id: isItemId ? activityObj.item_id : activityObj.id,
					content: stringUtils.toSnakeCase(stringUtils.removeSpecialChar(activityObj.content))
				}),
				state: {
					name: self.commonConst.STATE.DISCUSSION_DETAIL,
					params: {
						id: isItemId ? activityObj.item_id : activityObj.id,
						name: stringUtils.removeSpecialChar(activityObj.content)
					}
				}
			}
		}

		function getActivityActorHumanText(activity) {
			var template = "<span title=\"<%=person_name%>\" class='text--semibold'><%=person_name%></span>";
			if (activity.actor && activity.actor.type !== "system") {
				var loginUser = sessionManagerSvc.getCurrentLoginUser().data;
				var isShowLinkToProfile = (loginUser.account_type === 'business') || (loginUser.isMaketerInternal) || (activity.actor.detail.account_type === "personal");
				var templateWithoutLink = "<a class='text--semibold pixerf-link--color-theme notification-actor-name no-link' title=\"<%=person_name%>\"><%=person_name%></a>";
				var templateContainLink = "<a ui-sref=<%=link.uisref%> ui-sref-opts='{reload: true, notify: true}' class='text--semibold pixerf-link--color-theme notification-actor-name' title=\"<%=person_name%>\"><%=person_name%></a>";
				template = isShowLinkToProfile ? templateContainLink : templateWithoutLink;
			}
			return getPersonObject(template, activity, "actor", true);
		}

		function getPersonObject(template, activity, type, isOwned) {
			var loginUser = sessionManagerSvc.getCurrentLoginUser().data;
			var personObj = {};

			switch (type) {
				case "actor":
					personObj = _.template(template)({
						person_id: activity.actor.id,
						person_name: activity.actor.content,
						link: getUserSref({
							id: activity.actor.id,
							userName: stringUtils.toSnakeCase(activity.actor.content)
						})
					});
					break;
				case "target":
					var personName = activity.target.id == loginUser.id ? 'you' : activity.target.content;
					if (isOwned) {
						personName = activity.target.id == loginUser.id ? 'your' : activity.target.content + "'s";
					}
					personObj = _.template(template)({
						person_id: activity.target.id,
						person_name: personName,
						link: getUserSref({
							id: activity.target.id,
							userName: stringUtils.toSnakeCase(activity.target.content)
						})
					})
					break;
			}
			return personObj;
		}

		function getActivityVerbHumanText(activity) {
			var hummanVerb = mVerbHumnanTextMapping[activity.verb];
			var loginUser = sessionManagerSvc.getCurrentLoginUser().data;
			var template = "<a ui-sref=<%=link.uisref%> ui-sref-opts='{reload: true, notify: true}' class='text--semibold pixerf-link--color-theme notification-actor-name' title=\"<%=person_name%>\"><%=person_name%></a>";

			switch (activity.verb) {
				case "accepted_community_request":
					var user = "";
					if (activity.target) {
						user = getPersonObject(template, activity, "target", true);
						hummanVerb = _.template(hummanVerb)({
							user: user
						})
					}
					break;
				case "invited_community":
				case "invited_community_event":
					var user = "";
					if (activity.target) {
						user = getPersonObject(template, activity, "target");
						hummanVerb = _.template(hummanVerb)({
							user: user
						})
					}
					break;
				case "deactivated_community":
					var templateContainLink = "<a ui-sref=<%=link.uisref%> ui-sref-opts='{reload: true, notify: true}' class='notification-verb'><%=human_verb%></a>";
					var templateWithoutLink = "<a class='notification-verb no-link'><%=human_verb%></a>";
					var isShowLinkToCommunity = (loginUser.account_type === 'business') || (loginUser && loginUser.isMaketerInternal);
					template = isShowLinkToCommunity ? templateContainLink : templateWithoutLink;
					return _.template(template)({
						link: buildActivityLink(activity.object, activity.verb),
						human_verb: $translate.instant(hummanVerb)
					});
					break;
			}

			if (!hummanVerb) hummanVerb = activity.verb;

			return _.template("<a ui-sref=<%=link.uisref%> ui-sref-opts='{reload: true, notify: true}' class='notification-verb'><%=human_verb%></a>")({
				link: buildActivityLink(activity.object, activity.verb),
				human_verb: $translate.instant(hummanVerb)
			});

		}

		function buildHumanText(activity) {
			var notifiSentence = "";
			switch (activity.verb) {
				case "created_community":
					notifiSentence = "1 new community pending: " + getActivityActorHumanText(activity) + " " + getActivityVerbHumanText(activity) + " " + getActivityObjectHumanText(activity);
					break;
				case "requested_changes_community":
					notifiSentence = "Your community " + getActivityObjectHumanText(activity) + " is almost ready. There are just a few actions you need to do. View comments.";
					break;
				case "approved_community":
					notifiSentence = "Congrats! " + getActivityObjectHumanText(activity) + " has been approved. You can start setting up your community.";
					break;
				case "set_as_manager":
					notifiSentence = getActivityActorHumanText(activity) + " has appointed you as a Manager of " + getActivityObjectHumanText(activity);
					break;
				case "removed_as_manager":
					notifiSentence = getActivityActorHumanText(activity) + " has removed your admin rights in " + getActivityObjectHumanText(activity);
					break;
				case "reported_community":
					notifiSentence = "Your community, " + getActivityObjectHumanText(activity) + ", has been reported for violating <a ui-sref='community-guidelines' target='_blank' href='#/community/guidelines' class='text--bold text--color-pixerf-theme'>Community Guidelines</a>. You will be informed of the review outcome. There is no impact to your community in the meantime.";
					break;
				case "validated_community_report":
					notifiSentence = "Your community " + getActivityObjectHumanText(activity) + " was reported for violating our <a ui-sref='community-guidelines' target='_blank' href='#/community/guidelines' class='text--bold text--color-pixerf-theme'>Community Guidelines</a>. This report has been validated and your community will be given a warning strike. A Community will be deactivated after receiving their 3rd strike.";
					break;
				default:
					notifiSentence = getActivityActorHumanText(activity) + " " + getActivityVerbHumanText(activity) + " " + getActivityObjectHumanText(activity);
			}
			return notifiSentence;
		}

		function getUserSref(userData) {
			return {
				uisref: _.template("user-home-page.personal.home({id:<%=id%>,userName:'<%=userName%>'})")(userData),
				state: {
					name: 'user-home-page.personal.home',
					params: userData
				}
			}
		}

		function getPhotoSref(photoData) {
			return {
				uisref: _.template("photo({id:<%=id%>,photoTitle:\"<%=photoTitle%>\"})")(photoData),
				state: {
					name: 'photo',
					params: photoData
				}
			};
		}

		function getManagePhotoSref(routeType) {
			return {
				uisref: 'manage-photos.' + routeType,
				state: {
					name: 'manage-photos.' + routeType,
					params: {}
				}
			}
		}

		function buildActivityLink(object, verb, owner) {
			var activityLinkObj = {};
			switch (object.type) {
				case "media":
					if (["rejected"].includes(verb)) {
						activityLinkObj = getManagePhotoSref("rejected");
					} else {
						activityLinkObj = getPhotoSref({
							id: object.id,
							photoTitle: stringUtils.toSnakeCase(object.content)
						});
					}
					break;
				case "user":
					if (owner) {
						var ownerName = owner.first_name + ' ' + owner.last_name;
						activityLinkObj = getUserSref({
							id: object.id,
							userName: stringUtils.toSnakeCase(ownerName)
						});
					} else {
						activityLinkObj = getUserSref({
							id: object.id,
							userName: stringUtils.toSnakeCase(object.content)
						});
					}
					break;
				case "community":
					activityLinkObj = buildCommunityObjectLink(object);
					break
				case "community_report":
					if (["community"].includes(object.item_type)) {
						activityLinkObj = buildCommunityObjectLink(object, true);
					} else if (["event"].includes(object.item_type)) {
						activityLinkObj = buildCommunityEventObjectLink(object, true);
					} else if (["discussion", "discussion_reply"].includes(object.item_type)) {
						activityLinkObj = buildDiscussionObjectLink(object, true);
					}
					break;
				case "discussion":
					activityLinkObj = buildDiscussionObjectLink(object);
					break
				case "community_event":
					activityLinkObj = buildCommunityEventObjectLink(object);
					break;

			}

			return activityLinkObj;
		}

		function buildActivityDefaultLink(activity) {
			var loginUser = sessionManagerSvc.getCurrentLoginUser().data;
			var activityLinkObj = {};

			switch (activity.object.type) {
				case "media":
					if (["rejected"].includes(activity.verb)) {
						activityLinkObj = getManagePhotoSref("rejected");
					} else if (["approved"].includes(activity.verb)) {
						activityLinkObj = getUserSref({
							id: loginUser.id,
							userName: loginUser.displayName
						});
					} else {
						activityLinkObj = getPhotoSref({
							id: activity.object.id,
							photoTitle: stringUtils.toSnakeCase(activity.object.content)
						});
					}
					break;
				case "user":
					activityLinkObj = getUserSref({
						id: activity.object.id,
						userName: ''
					});
					break;
				case "community":
					activityLinkObj = buildCommunityObjectLink(activity.object);
					break;
				case "community_event":
					activityLinkObj = buildCommunityEventObjectLink(activity.object);
					break;
				case "discussion":
				case "discussion_reply":
				case "created_discussion":
					activityLinkObj = buildDiscussionObjectLink(activity.object);
					break;
			}

			return activityLinkObj;
		}

		function transform(activity) {
			activity.text = buildHumanText(activity);
			// activity.plainText = $(activity.text).text();

			switch (activity.actor.type) {
				case "user":
					activity.actor.account_type = activity.actor.detail.account_type;
					activity.actor.displayName = activity.actor.content;
					activity.actor.avatar = accountUtils.buildUserAvatarPhotoUrl({
						profile_image_media: activity.actor.thumbnails || activity.actor.media,
						id: activity.actor.id,
						username: activity.actor.detail.username,
						displayName: activity.actor.content,
						profile_image: activity.actor.thumbnails || activity.actor.media
					});
					activity.actor.link = buildActivityLink({
						type: "user",
						id: activity.actor.id,
						content: activity.actor.content
					});
					break;
				case "system":
					activity.actor.thumbnail = 'assets/images/pixerf-50.png';
					break;
			}

			switch (activity.object.type) {
				case "user":
					activity.object.thumbnail = (activity.object.thumbnails && activity.object.thumbnails["160x"]) ? activity.object.thumbnails && activity.object.thumbnails["160x"] : activity.object.thumbnails && activity.object.thumbnails["100x"];
					activity.object.avatar = { profileImage : activity.object.thumbnail}
					activity.object.avatar = accountUtils.buildUserAvatarPhotoUrl({
						profile_image_media: activity.object.thumbnails,
						id: activity.object.id,
						username: activity.object.detail.username,
						displayName: activity.object.content,
						profile_image: activity.object.thumbnail
					});
					break;
			}
			
			activity.object.thumbnail = (activity.object.thumbnails && activity.object.thumbnails["160x"]) ? activity.object.thumbnails && activity.object.thumbnails["160x"] : activity.object.thumbnails && activity.object.thumbnails["100x"];
			if (!activity.object.thumbnail && ["community", "community_report", "community_event"].includes(activity.object.type)) {
				activity.object.thumbnail = 'assets/images/community.svg';
			};
			activity.insertedAtFormatted = moment.utc(activity.updated_at);
			activity.object.link = buildActivityLink(activity.object, activity.verb, activity.owner);
			activity.link = buildActivityDefaultLink(activity);

			return activity;
		}

		function transforms(activities) {
			for (var i = 0; i < activities.length; i++) {
				transform(activities[i]);
			}
		}

		function getTotalUnreadActivities(response) {
			var totalCount = response.headers("unread");
			if (!totalCount) totalCount = response.headers("unread");
			if (!totalCount) return 1;
			return parseInt(totalCount);
		}

		return {
			buildHumanText: buildHumanText,
			buildActivityLink: buildActivityLink,
			transforms: transforms,
			transform: transform,
			getTotalUnreadActivities: getTotalUnreadActivities
		};
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.factory('accountUtils', accountUtils);

	accountUtils.$inject = ['accountConst', 'pixerfUrl', 'badgeUtils', 'stringUtils', 'arrayUtils', 'pathUtils'];

	function accountUtils(accountConst, pixerfUrl, badgeUtils, stringUtils, arrayUtils, pathUtils) {
		var mode = new PixerfEnv().getEnv();

		function buildUserDisplayName(loginedUser) {
			if (!loginedUser) return '';
			var username = '';

			if (loginedUser.organization && loginedUser.organization.name && loginedUser.id != 3) {
				username = loginedUser.organization.name;
			} else if (loginedUser.first_name || loginedUser.last_name) {
				var first_name = loginedUser.first_name ? loginedUser.first_name : '';
				var last_name = loginedUser.last_name ? loginedUser.last_name : '';
				username = first_name + ' ' + last_name;
			}
			if (!username) {
				username = "User #" + loginedUser.id;
			}
			return username;
		}

		function buildWelcomeText(loginedUser) {
			return "Welcome back, " + buildUserDisplayName(loginedUser);
		}

		function isSocialAccount(loginedUser) {
			var cheatedUsers = ['gvp_photoworks@yahoo.com'];
			if (loginedUser && loginedUser.email && cheatedUsers.includes(loginedUser.email)) return false;
			if (loginedUser && loginedUser.social_id) return true;
			if (!loginedUser || !loginedUser.username) return false;
			return loginedUser.username.indexOf("auth0|") === -1;
		}

		function getTypeOfSocialAcc(user) {
			if (!user || !user.username) return false;
			if (user.username.indexOf("facebook|") != -1) {
				return accountConst.SOCIAL_TYPE.FACEBOOK;
			} else if (user.username.indexOf("google-oauth2|") != -1) {
				return accountConst.SOCIAL_TYPE.GOOGLE;
			}
		}

		function getUserDefaultAvatarUrl(user) {
			var isSocial = isSocialAccount(user);
			var isFacebookAcc = getTypeOfSocialAcc(user) === accountConst.SOCIAL_TYPE.FACEBOOK;
			var userId = "";

			if (isSocial) {
				userId = user.social_id ? user.social_id : user.username.split("|")[1];
			}

			var avatar = {
				coverImage: 'assets/images/default/default-cover.png'
			};

			if (isFacebookAcc) {
				avatar.profileImage = "http://graph.facebook.com/" + userId + "/picture?type=large";
				avatar.profileImageBig = "http://graph.facebook.com/" + userId + "/picture?type=large";
				avatar.profileImageSmall = "http://graph.facebook.com/" + userId + "/picture?type=large";
			} else if (user.displayName) {
				avatar.profileImage = pixerfUrl.full + 'api/avatar?name=' + user.displayName;
				avatar.profileImageBig = pixerfUrl.full + 'api/avatar?name=' + user.displayName;
				avatar.profileImageSmall = pixerfUrl.full + 'api/avatar?name=' + user.displayName;
			} else {
				avatar.profileImage = pixerfUrl.full + 'api/avatar?name=';
				avatar.profileImageBig = pixerfUrl.full + 'api/avatar?name=';
				avatar.profileImageSmall = pixerfUrl.full + 'api/avatar?name=';
			}
			return avatar;

		}

		function buildUserAvatarPhotoUrl(user, noCache) {
			if (!user) return {};
			var avatarUrl = getUserDefaultAvatarUrl(user);
			if (user.cover_image) {
				avatarUrl.coverImage = buildUserCoverPhotoUrl(user, noCache);
			}
			if (user.isBiz && user.organization && user.organization.profile_image) {
				avatarUrl.profileImageSmall = user.organization.profile_image_media && user.organization.profile_image_media["100x"];
				avatarUrl.profileImage = user.organization.profile_image_media && user.organization.profile_image_media["300x"];
				avatarUrl.profileImageBig = user.organization.profile_image_media && user.organization.profile_image_media["800x"];
			} else if (user.profile_image) {
				var paths = buildUserProfilePhotoUrl(user, noCache);
				avatarUrl.profileImageSmall = paths.profileImageSmall;
				avatarUrl.profileImage = paths.profileImage;
				avatarUrl.profileImageBig = paths.profileImageBig;
			} else if (user.profile_image_media) {
				avatarUrl.profileImageSmall = user.profile_image_media['100x'];
				avatarUrl.profileImage = user.profile_image_media['300x'];
				avatarUrl.profileImageBig = user.profile_image_media['800x'];
			}
			return avatarUrl;
		}

		function buildUserCoverPhotoUrl(user, thumbnail) {
			if (thumbnail) {
				return thumbnail["1200x"];
			} else if (user.cover_image_media && user.cover_image_media["1200x"]) {
				return user.cover_image_media["1200x"];
			} else {
				return user.cover_image;
			}
		}

		function buildUserProfilePhotoUrl(user, thumbnail) {
			if (thumbnail) {
				return {
					profileImageSmall: thumbnail["100x"],
					profileImage: thumbnail["300x"],
					profileImageBig: thumbnail["800x"]
				}
			} else {
				return {
					profileImageSmall: user.profile_image_media && user.profile_image_media["100x"] ? user.profile_image_media["100x"] : user.profile_image,
					profileImage: user.profile_image_media && user.profile_image_media["300x"] ? user.profile_image_media["300x"] : user.profile_image,
					profileImageBig: user.profile_image_media && user.profile_image_media["800x"] ? user.profile_image_media["800x"] : user.profile_image
				}
			}
		}

		function isFreeEmail(email) {
			return email.match(accountConst.FREE_EMAIL_LIST);
		}

		function getUserLocation(loginedUser) {
			if (loginedUser.account_type === accountConst.ACCOUNT_TYPE.PERSONAL && loginedUser.location) {
				return loginedUser.location;
			} else {
				if (loginedUser.organization && loginedUser.organization.address && loginedUser.organization.address.street1) {
					return loginedUser.organization.address.street1;
				} else {
					return loginedUser.location;
				}
			}
		}

		function getBio(loginedUser) {
			try {
				return loginedUser.account_type === accountConst.ACCOUNT_TYPE.PERSONAL ? loginedUser.bio : (loginedUser.organization ? loginedUser.organization.description : '');
			} catch (ex) {
				console.log(ex);
				return "";
			}
		}

		function transformUserData(rawData, response) {
			var tempCCIdsProd = [51746, 49114, 67835];
			var organizationIds = [187, 51, 211];
			if (rawData) {
				rawData.isHondaCC = (mode == 'PRODUCTION' ? tempCCIdsProd.indexOf(rawData.id) != -1 : rawData.id == 2221) || (rawData.organization && (mode == 'PRODUCTION' ? organizationIds.indexOf(rawData.organization.id) != -1 : rawData.organization.id == 66));
				rawData.isTrialUser = rawData.credit_total > 0;
				rawData.isVIP = !!rawData.ambassadorship;
				rawData.isPersonalPaidAcc = !!rawData.ambassadorship;
				rawData.isBiz = rawData.account_type === accountConst.ACCOUNT_TYPE.BUSINESS;
				rawData.isContributor = rawData.account_type === accountConst.ACCOUNT_TYPE.PERSONAL;
				rawData.isGuest = !rawData.account_type;
				rawData.isBuyer = rawData.isBiz;
				rawData.badges = badgeUtils.transformBadges(rawData.badges);
				rawData.isNoNeedSubscribe = !!rawData.ambassadorship;
				rawData.isCurator = rawData.role === "curator_internal";
				rawData.isAdminInternal = rawData.role === "admin_internal";
				rawData.isFinanceInternal = rawData.role === "finance_internal" || rawData.isAdminInternal;
				rawData.isMaketerInternal = rawData.role === "marketer_internal" || ['marcom@pixerf.com', 'marketing-qa@pixerf.com'].includes(rawData.email);
				rawData.isAdmin = rawData.role === "admin";
				rawData.isMaketer = rawData.role === "marketer";
				rawData.isLeadCurator = rawData.role === "lead_curator";
				rawData.isPrivatedProfile = rawData.isBiz;
				rawData.canFollow = !rawData.isBiz;
				rawData.canBeFollowed = !rawData.isBiz;
				rawData.canReviewMission = rawData.isMaketerInternal;
				rawData.canManageCommunity = (rawData.isBiz && ['institution', 'nonprofit'].includes(rawData.business_type) ) || !!rawData.ambassadorship || rawData.can_create_community;
				rawData.canVerifyBusinessUser = rawData.isMaketerInternal || rawData.isAdminInternal;
				rawData.canConfigureSystem = rawData.isAdminInternal;
				rawData.canCurate = rawData.isCurator || rawData.isAdminInternal || rawData.isLeadCurator;
				rawData.canOverrideCuration = rawData.isAdminInternal || rawData.isLeadCurator;
				rawData.canUploadPhotos = !rawData.isBiz;
				rawData.canManagePhotos = !rawData.isBiz;
				rawData.canJoinMission = !rawData.isBiz;
				rawData.canManageMission = rawData.isBiz || rawData.isMaketer || rawData.isAdmin;
				rawData.canCreateMission = rawData.canManageMission || rawData.isMaketerInternal;
				rawData.canManageCustomCommissions = rawData.isBiz || rawData.isMaketer || rawData.isAdmin;
				rawData.canManageGalleries = rawData.isContributor || rawData.isBiz;
				rawData.canManageEarning = !rawData.isBiz;
				rawData.canManagePortfolios = !rawData.isBiz;
				rawData.canBuyCreditPlan = rawData.isBiz;
				rawData.canSeeDirectory = rawData.canCurate || rawData.isMaketerInternal;
				rawData.canDownloadComp = rawData.isBiz && rawData.user_credit_plan;
				rawData.canReferral = !!rawData.ambassadorship || rawData.is_suggested;
				rawData.canRemoveReplyDiscussion = rawData.isMaketerInternal || rawData.isCurator || rawData.isAdminInternal || rawData.isLeadCurator;
				rawData.canCreateMediaPixerf = rawData.isMaketerInternal || rawData.isAdminInternal;
                rawData.haveFeed = rawData.isBiz || rawData.isPersonalPaidAcc;
				rawData.canChangeAvatar = !rawData.isBiz || rawData.isAdminInternal || rawData.isAdmin;
				rawData.date_of_birth = rawData.date_of_birth ? moment(rawData.date_of_birth).toDate() : rawData.date_of_birth;
				rawData.contact = parseInt(rawData.contact);
				rawData.displayName = buildUserDisplayName(rawData);
				rawData.location = getUserLocation(rawData);
				rawData.bio = getBio(rawData);
				rawData.avatar = buildUserAvatarPhotoUrl(rawData);
				rawData.path = window.location.protocol + "//" + window.location.host + "/#/user-home-page/" + rawData.id + "/" + stringUtils.toSnakeCase(rawData.displayName) + "/" + rawData.account_type;
			}
			if(response && response.headers){
				rawData.freeOrderId = response.headers('free-order-id');
			}
			return rawData;
		}

		function transformFromOutlookContacts(rawData) {
			return {
				avatar: buildUserAvatarPhotoUrl(rawData),
				displayName: rawData.displayName,
				email: rawData.emailAddresses ? rawData.emailAddresses[0] : null
			}
		}

		function transformFromGoogleContacts(rawData) {
			return {
				avatar: buildUserAvatarPhotoUrl(rawData),
				displayName: rawData.gd$name ? rawData.gd$name.gd$fullName.$t : rawData.gd$email[0].address,
				email: rawData.gd$email ? rawData.gd$email[0] : null
			}
		}

		function isContainsLink(str) {
			if (!str) return false;
			var expression = /(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,4}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g;
			var regex = new RegExp(expression);
			return str.match(regex);
		}

		function isContainsNumber(str) {
			if (!str) return false;
			return str.match(/\d+/g);
		}

		function isContainsFileExtension(str) {
			if (!str) return false;
			return str.match(/^.*\./ig);
		}

		function isOverMaxAge(dateOfBirth, maxAge) {
			if (dateOfBirth && dateOfBirth !== 0) {
				if (typeof dateOfBirth === "string") {
					var format = "DD/MM/YYYY";
				}
				var formatDOB = moment(dateOfBirth, format);
				var formatNow = moment();
				var age = formatNow.diff(formatDOB, 'years', true);
				var overMaxAge = Math.floor(age) > maxAge ? true : false;
				return overMaxAge;
			} else {
				return false;
			}
		}

		function isUnderMinAge(dateOfBirth, minAge) {
			if (dateOfBirth && dateOfBirth !== 0) {
				if (typeof dateOfBirth === "string") {
					var format = "DD/MM/YYYY";
				}
				var formatDOB = moment(dateOfBirth, format);
				var formatNow = moment();
				var age = formatNow.diff(formatDOB, 'years', true);
				var underMinAge = Math.floor(age) < minAge ? true : false;
				return underMinAge;
			} else {
				return false;
			}
		}

		function extractPayoutMethodNames(payoutMethods) {
			return _.reduce(payoutMethods, function (memo, item) {
				memo.push(item.code.toLowerCase());
				return memo;
			}, []);
		}

		function buildSavedUserData(user) {
			var saveUserData = {};
			saveUserData.account_type = user.account_type;
			saveUserData.email = user.email;
			saveUserData.first_name = user.first_name;
			saveUserData.last_name = user.last_name;
			saveUserData.location = user.location;
			saveUserData.password = user.password;
			saveUserData.username = user.username;
			saveUserData.connection = user.connection;
			saveUserData.payout_method = extractPayoutMethodNames(user.payout_method);
			saveUserData.id = user.id;
			saveUserData.is_contributor_agreement_accepted = user.is_contributor_agreement_accepted;
			return saveUserData;
		}

		function getUserGoogleLocation(googleLocationObject) {
			if (!googleLocationObject) return "";
			if (typeof googleLocationObject === "string") {
				return googleLocationObject;
			} else {
				return googleLocationObject.formatted_address;
			}
			return "";
		}

		function refineUserGoogleLocation(googleLocationObject) {
			if (!googleLocationObject) return "";
			if (typeof googleLocationObject === "string") {
				var temp = googleLocationObject.split(",");
				if (temp.length > 2) {
					return temp[temp.length - 2] + " ," + temp[temp.length - 1];
				}
				return googleLocationObject;
			} else {
				var allowedComponents = ["administrative_area_level_1", "country"];
				var temp = '';
				for (var i = 0; i < allowedComponents.length; i++) {
					for (var j = 0; j < googleLocationObject.address_components.length; j++) {
						if (googleLocationObject.address_components[j].types.indexOf(allowedComponents[i]) !== -1) {
							temp += googleLocationObject.address_components[j].long_name;
							if (i == 0) {
								temp += ", ";
							}
						}
					}
				}
				return temp;
			}
		}

		function getSpecialities(specialitiesArray) {
			if (!arrayUtils.isValueArr(specialitiesArray)) return "";
			var specialities = [];
			for (var i = 0; i < specialitiesArray.length; i++) {
				specialities.push(specialitiesArray[i].name);
			}
			return specialities.join(", ");
		}

		function getUserAvatar(user) {
			if (user.cover_image_media && user.cover_image_media.length) {
				return user.cover_image_media['1200x'] || user.cover_image_media[0];
			} else {
				return user.avatar.coverImage;
			}
		}

		return {
			buildUserDisplayName: buildUserDisplayName,
			buildWelcomeText: buildWelcomeText,
			isSocialAccount: isSocialAccount,
			buildUserAvatarPhotoUrl: buildUserAvatarPhotoUrl,
			isFreeEmail: isFreeEmail,
			getUserLocation: getUserLocation,
			getBio: getBio,
			transformUserData: transformUserData,
			isContainsLink: isContainsLink,
			isContainsNumber: isContainsNumber,
			isContainsFileExtension: isContainsFileExtension,
			isUnderMinAge: isUnderMinAge,
			isOverMaxAge: isOverMaxAge,
			buildSavedUserData: buildSavedUserData,
			buildUserCoverPhotoUrl: buildUserCoverPhotoUrl,
			buildUserProfilePhotoUrl: buildUserProfilePhotoUrl,
			transformFromOutlookContacts: transformFromOutlookContacts,
			transformFromGoogleContacts: transformFromGoogleContacts,
			refineUserGoogleLocation: refineUserGoogleLocation,
			getUserGoogleLocation: getUserGoogleLocation,
			getSpecialities: getSpecialities,
			getUserAvatar: getUserAvatar
		};
	}
})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.service('translationSvc', translationSvc);
	translationSvc.$inject = ['$translate', 'translationConst'];

	function translationSvc($translate, translationConst) {

		this.OOPS_DO_SOMETHING_WRONG = function (activity, oops, tryAgain) {
			var message = "";
			if (oops) {
				message = $translate.instant(translationConst.OOPS) + " ";
			}
			message += $translate.instant(translationConst[activity]);
			if (tryAgain) {
				message += " " + $translate.instant(translationConst.PLEASE_TRY_AGAIN);
			}

			return message;
		};

		this.SOMETHING_HAS_BEEN_DONE = function (something, status) {
			var message = "";
			var subj = $translate.instant(translationConst[something]);
			var stat = $translate.instant(translationConst[status]);
			message = $translate.instant(translationConst.SOMETHING_HAS_BEEN_DONE, {
				something: subj,
				done: stat
			});

			return message;
		}

		this.EDIT_SOMETHING = function (something) {
			var message = "";
			var subj = $translate.instant(translationConst[something]);
			message = $translate.instant(translationConst.EDIT, {
				name: subj
			});

			return message;
		}

		this.ARE_YOU_SURE_TO_DO_SOMETHING = function (doSomething, obj) {
			var message = "";
			var doSubj = $translate.instant(translationConst[doSomething], obj);
			message = $translate.instant(translationConst.ARE_YOU_SURE_TO_DO_SOMETHING, {
				do_something: doSubj
			});

			return message;
		}

		this.FAILED_TO_DO_SOMETHING = function (obj, isTry) {
			var message = "";
			message = $translate.instant(translationConst[obj]);
			if (isTry) {
				message += " " + $translate.instant(translationConst.PLEASE_TRY_AGAIN);
			}

			return message;
		}
	}
})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.factory('socketSvc', socketSvc);

	socketSvc.$inject = ['pixerfUrl', '$log'];

	function socketSvc(pixerfUrl, $log) {
		var PIXERF_TOPICS = {
			PAYPAL: "paypal",
			NOTIFICATIONS: 'notifications'
		};
		var mSocket = null;
		var mGeneralChannel = null;
		var mPrivateChannel = null;

		function connect() {
			if (!mSocket) {
				mSocket = new Phoenix.Socket('wss://' + pixerfUrl.domainOnly + '/socket', {});
				mSocket.connect();
			}
			mSocket.onOpen(function () {
				$log.info("Socket Open");
			})
			mSocket.onError(function () {
				mSocket = null;
				$log.error("Socket error");
			})
			mSocket.onClose(function () {
				mSocket = null;
				$log.info("Socket close");
			})
		}

		function joinPublicChannel() {
			if (mSocket) return;
			connect();
			mGeneralChannel = mSocket.channel("room:general", {});
			mGeneralChannel.join();
			return mGeneralChannel;
		}

		function joinPrivateChannel(username, token) {
			if (mSocket) return;
			connect();
			mPrivateChannel = mSocket.channel("room:" + username, {
				guardian_token: token
			});
			mPrivateChannel.join();
		}

		function close() {
			mSocket.close();
		}

		function getPrivateChannel() {
			return mPrivateChannel;
		}

		function getPublicChannel() {
			return mGeneralChannel;
		}


		return {
			joinPrivateChannel: joinPrivateChannel,
			joinPublicChannel: joinPublicChannel,
			getPrivateChannel: getPrivateChannel,
			getPublicChannel: getPublicChannel,
			PIXERF_TOPICS: PIXERF_TOPICS
		};
	}
})();

(function () {

	angular
		.module('pixerf')
		.factory('sessionManagerSvc', sessionManagerSvc);

	sessionManagerSvc.$inject = ['store', '$rootScope', 'messageConst'];

	function sessionManagerSvc(store, $rootScope, messageConst) {
		var CALLBACK_URL = "PIXERF.CALLBACK_URL";
		var TOKEN = "PIXERF.TOKEN";
		var EXPIRED_AT = "PIXERF.EXPIRED_AT";
		var PROFILE = "PIXERF.PROFILE";
		var SIGNING_UP_USER = "PIXERF.SIGNING_UP_USER";
		var FIRST_TIME_LOGIN = "PIXERF.FIRST_TIME_LOGIN";
		var RESET_PASSOWRD_REDIRECT = "PIXERF.RESET_PASSOWRD_REDIRECT";
		var MARKETPLACE_HISTORY = "PIXERF.LAST_MARKETPLACE_TAB";

		var mCurrentLoginUser = {
			data: null
		};

		function uuid() {
			return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
				var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
				return v.toString(16);
			  });
		}

		function setCurrentLoginUser(user) {
			var cloned = null;
			if (user) {
				cloned = $.extend(true, {}, user);
			}
			mCurrentLoginUser.data = cloned;
			if (user) {
				$rootScope.$broadcast(messageConst.BROADCAST.USER_DATA_CHANGE);
			}
		}

		function getCurrentLoginUser() {
			if (!mCurrentLoginUser.data) return mCurrentLoginUser;
			var cloned = $.extend(true, {}, mCurrentLoginUser);
			return cloned;
		}

		function setToken(token) {
			store.set(TOKEN, token);
		}

		function getToken() {
			return store.get(TOKEN);
		}

		function setResetPasswordRedirect(data) {
			store.set(RESET_PASSOWRD_REDIRECT, data);
		}

		function getResetPasswordRedirect() {
			return store.get(RESET_PASSOWRD_REDIRECT);
		}

		function setProfile(profile) {
			store.set(PROFILE, profile);
		}

		function getProfile() {
			return store.get(PROFILE);
		}

		function setSigningUpUser(user) {
			store.set(SIGNING_UP_USER, user);
		}

		function getSigningUpUser() {
			return store.get(SIGNING_UP_USER);
		}

		function setFirstTimeLogin(value) {
			store.set(FIRST_TIME_LOGIN, value);
		}

		function getFirstTimeLogin() {
			return store.get(FIRST_TIME_LOGIN);
		}

		function clearSession() {
			setToken(null);
			setCurrentLoginUser(null);
			setProfile(null);
			setExpiredTime(null);
		}

		function setSession(authResult) {
			// Set the time that the Access Token will expire at
			var expiresAt = JSON.stringify((authResult.expiresIn * 1000) + new Date().getTime());
			setToken(authResult.idToken);
			setExpiredTime(expiresAt);
			setProfile(authResult.idToken);
		}

		function isTokenExpired() {
			var expiresAt = JSON.parse(getExpiredTime());
			return new Date().getTime() >= expiresAt;
		}

		function setCallbackURL(value) {
			store.set(CALLBACK_URL, value);
		}

		function getCallbackURL(value) {
			return store.get(CALLBACK_URL, value);
		}

		function setExpiredTime(value) {
			store.set(EXPIRED_AT, value);
		}

		function getExpiredTime(value) {
			return store.get(EXPIRED_AT, value);
		}

		function isMine(owner) {
			return mCurrentLoginUser.data && mCurrentLoginUser.data.id === owner.id;
		}

		function isMyMission(mission) {
			return mCurrentLoginUser.data && mCurrentLoginUser.data.organization && mCurrentLoginUser.data.organization.id === mission.organization.id;
		}

		function isMyPhoto(photo) {
			if (!photo.user) return true;
			return mCurrentLoginUser.data && mCurrentLoginUser.data.id === photo.user.id;
		}

		function setMarketplaceTabHistory(value) {
			store.set(MARKETPLACE_HISTORY, value);
		}

		function getMarketplaceTabHistory() {
			return store.get(MARKETPLACE_HISTORY);
		}

		return {
			setCurrentLoginUser: setCurrentLoginUser,
			getCurrentLoginUser: getCurrentLoginUser,
			setProfile: setProfile,
			getProfile: getProfile,
			setSigningUpUser: setSigningUpUser,
			getSigningUpUser: getSigningUpUser,
			getToken: getToken,
			setToken: setToken,
			clearSession: clearSession,
			setSession: setSession,
			isMine: isMine,
			isMyMission: isMyMission,
			isMyPhoto: isMyPhoto,
			setFirstTimeLogin: setFirstTimeLogin,
			getFirstTimeLogin: getFirstTimeLogin,
			getResetPasswordRedirect: getResetPasswordRedirect,
			setResetPasswordRedirect: setResetPasswordRedirect,
			setCallbackURL: setCallbackURL,
			getCallbackURL: getCallbackURL,
			setMarketplaceTabHistory: setMarketplaceTabHistory,
			getMarketplaceTabHistory: getMarketplaceTabHistory,
			isTokenExpired: isTokenExpired,
			uuid: uuid
		};
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.factory('permissionManagerSvc', permissionManagerSvc);

	permissionManagerSvc.$inject = ['PermRoleStore', '$q', 'sessionManagerSvc', 'auth0AuthenticationSvc', 'accountUtils'];

	function permissionManagerSvc(PermRoleStore, $q, sessionManagerSvc, auth0AuthenticationSvc, accountUtils) {

		function everyOneCheck() {
			var def = $q.defer();
			var checkLogin = auth0AuthenticationSvc.authenticationCheck();
			checkLogin.then(function (result) {
				def.resolve();
			}, function (result) {
				auth0AuthenticationSvc.handleAuthenticationCheck(result);
				def.resolve();
			})
			return def.promise;
		}

		function noneSocialNetworkUser() {
			var def = $q.defer();
			var checkLogin = auth0AuthenticationSvc.authenticationCheck();
			checkLogin.then(function () {
				var isNotSocialUser = !accountUtils.isSocialAccount(sessionManagerSvc.getCurrentLoginUser().data);
				if (isNotSocialUser) {
					def.resolve();
				} else {
					def.reject();
				}
			}, function () {
				def.reject();
			})
			return def.promise;
		}

		function anonymousCheck() {
			var def = $q.defer();
			var checkLogin = auth0AuthenticationSvc.authenticationCheck();
			checkLogin.then(function (result) {
				console.log(result);
				def.reject(result);
			}, function (result) {
				def.resolve();
			})
			return def.promise;
		}

		function isCuratorCheck() {
			var def = $q.defer();
			auth0AuthenticationSvc.authenticationCheck().then(function () {
				var isCurator = sessionManagerSvc.getCurrentLoginUser().data.canCurate;
				if (isCurator) {
					def.resolve();
				} else {
					def.reject();
				}
			}, function () {
				def.reject();
			})
			return def.promise;
		}

		function isAdminCheck() {
			var def = $q.defer();
			auth0AuthenticationSvc.authenticationCheck().then(function () {
				var isAdmin = sessionManagerSvc.getCurrentLoginUser().data.isAdminInternal;
				if (isAdmin) {
					def.resolve();
				} else {
					def.reject();
				}
			}, function () {
				def.reject();
			})
			return def.promise;
		}

		function isMissionManagerCheck() {
			var def = $q.defer();
			auth0AuthenticationSvc.authenticationCheck().then(function () {
				var canManageMission = sessionManagerSvc.getCurrentLoginUser().data.canManageMission;
				if (canManageMission) {
					def.resolve();
				} else {
					def.reject();
				}
			}, function () {
				def.reject();
			})
			return def.promise;
		}

		function isCustomCommissionsManagerCheck() {
			var def = $q.defer();
			auth0AuthenticationSvc.authenticationCheck().then(function () {
				var canManageCustomCommissions = sessionManagerSvc.getCurrentLoginUser().data.canManageCustomCommissions;
				if (canManageCustomCommissions) {
					def.resolve();
				} else {
					def.reject();
				}
			}, function () {
				def.reject();
			})
			return def.promise;
		}

		function isCommunityManagerCheck() {
			var def = $q.defer();
			auth0AuthenticationSvc.authenticationCheck().then(function () {
				var canManageCommunity = sessionManagerSvc.getCurrentLoginUser().data.canManageCommunity;
				if (canManageCommunity) {
					def.resolve();
				} else {
					def.reject();
				}
			}, function () {
				def.reject();
			})
			return def.promise;
		}

		function isTrialUser() {
			var def = $q.defer();
			auth0AuthenticationSvc.authenticationCheck().then(function () {
				var user = sessionManagerSvc.getCurrentLoginUser().data;
				if (user && user.isTrialUser) {
					def.resolve();
				} else {
					def.reject();
				}
			}, function () {
				def.reject();
			})
			return def.promise;
		}

		function isBusinessUser() {
			var def = $q.defer();
			auth0AuthenticationSvc.authenticationCheck().then(function () {
				var user = sessionManagerSvc.getCurrentLoginUser().data;
				if (user && user.isBiz) {
					def.resolve();
				} else {
					def.reject();
				}
			}, function () {
				def.reject();
			})
			return def.promise;
		}

		function isInternalMaketer() {
			var def = $q.defer();
			auth0AuthenticationSvc.authenticationCheck().then(function () {
				var user = sessionManagerSvc.getCurrentLoginUser().data;
				if (user && user.isMaketerInternal) {
					def.resolve();
				} else {
					def.reject();
				}
			}, function () {
				def.reject();
			})
			return def.promise;
		}

		function canReferralCheck() {
			var def = $q.defer();
			auth0Utils.authenticationCheck().then(function () {
				var user = sessionManagerSvc.getCurrentLoginUser().data;
				if (user && (!!user.ambassadorship || user.is_suggested)) {
					def.resolve();
				} else {
					def.reject();
				}
			}, function () {
				def.reject();
			})
			return def.promise;
		}

		function isFinanceInternal() {
			var def = $q.defer();
			auth0AuthenticationSvc.authenticationCheck().then(function () {
				var user = sessionManagerSvc.getCurrentLoginUser().data;
				if (user && user.isFinanceInternal) {
					def.resolve();
				} else {
					def.reject();
				}
			}, function () {
				def.reject();
			})
			return def.promise;
		}

		function authorized(){
			var def = $q.defer();
			var checkLogin = auth0AuthenticationSvc.authenticationCheck();
			checkLogin.then(function (result) {
				def.resolve();
				
			}, function (result) {
				auth0AuthenticationSvc.handleAuthenticationCheck(result);
				def.resolve();
			})
			return def.promise;
		}
		PermRoleStore
			.defineManyRoles({
				'AUTHORIZED': function () {
					return authorized();
				},
				'EVERY_ONE': function () {
					return everyOneCheck();
				},
				'CURATOR': function () {
					return isCuratorCheck();
				},
				'ADMIN': function () {
					return isAdminCheck();
				},
				'MISSION_MANAGER': function () {
					return isMissionManagerCheck();
				},
				'CUSTOM_COMMISSIONS_MANAGER': function () {
					return isCustomCommissionsManagerCheck();
				},
				'COMMUNITY_MANAGER': function () {
					return isCommunityManagerCheck();
				},
				'ANONYMOUS': function () {
					return anonymousCheck();
				},
				'NONE_SOCIAL_NETWORK_USER': function () {
					return noneSocialNetworkUser();
				},
				'IS_TRIAL_USER': function () {
					return isTrialUser();
				},
				'BUSINESS_USER': function () {
					return isBusinessUser();
				},
				'INTERNAL_MARKETER': function () {
					return isInternalMaketer();
				},
				'FINANCE_INTERNAL': function () {
					return isFinanceInternal();
				}
			});
		return {};
	}
})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.factory('outlookContactSvc', outlookContactSvc);
	outlookContactSvc.$inject = ['$q', '$resource', 'accountUtils'];

	function outlookContactSvc($q, $resource, accountUtils) {
		var pixerfEnv = new PixerfEnv().getEnv();
		var redirectUri = "http://localhost:3000";
		var appId = '936c2d25-86d2-4706-8b91-d2e350ed697c';
		if (pixerfEnv === "PRODUCTION") {
			redirectUri = 'https://pixerf.com';
			// appId = "Will be provided TODO";
		}
		var authEndpoint = 'https://login.microsoftonline.com/common/oauth2/v2.0/authorize?';
		var scopes = 'openid Contacts.Read';
		var mAccessToken = null;

		function resourceFactory(token) {

			return $resource("https://graph.microsoft.com/v1.0/me/contacts", {}, {
				'get': {
					interceptor: {
						response: function (response) {
							var arr = [];
							for (var i = 0; i < response.data.value.length; i++) {
								arr.push(accountUtils.transformFromOutlookContacts(response.data.value[i]));
							}
							response.data = arr;
							return response;
						}
					},
					headers: {
						'Authorization': 'Bearer ' + token
					}
				}
			});
		}
		// Check for browser support for crypto.getRandomValues
		var cryptObj = window.crypto || window.msCrypto; // For IE11
		if (cryptObj === undefined || cryptObj.getRandomValues === 'undefined') {
			alert('This brower is not supported');
		}

		function parseHashParams(hash) {
			hash = hash.replace("/", "");
			var params = hash.slice(1).split('&');

			var paramarray = {};
			params.forEach(function (param) {
				param = param.split('=');
				paramarray[param[0]] = param[1];
			});

			return paramarray;
		}

		function guid() {
			var buf = new Uint16Array(8);
			cryptObj.getRandomValues(buf);

			function s4(num) {
				var ret = num.toString(16);
				while (ret.length < 4) {
					ret = '0' + ret;
				}
				return ret;
			}
			return s4(buf[0]) + s4(buf[1]) + '-' + s4(buf[2]) + '-' + s4(buf[3]) + '-' +
				s4(buf[4]) + '-' + s4(buf[5]) + s4(buf[6]) + s4(buf[7]);
		}

		function auth(callback) {
			window.outlookAuth = true;
			window.authCallback = function (token) {
				mAccessToken = token;
				callback(token);
			}
			var width = (window.innerWidth - 330) / 2;
			var height = (window.innerHeight - 550) / 2;
			window.pixerf_outlookAuth = true;
			window.open(buildAuthUrl(), "", "width=330,height=550,left=" + width + ",top= " + height + ",toolbar=1,status=1");
		}

		function getContacts() {
			return resourceFactory(mAccessToken).get().$promise;
		}

		function buildAuthUrl() {
			// Generate random values for state and nonce
			sessionStorage.authState = guid();
			sessionStorage.authNonce = guid();

			var authParams = {
				response_type: 'id_token token',
				client_id: appId,
				redirect_uri: redirectUri,
				scope: scopes,
				state: sessionStorage.authState,
				nonce: sessionStorage.authNonce,
				response_mode: 'fragment'
			};

			return authEndpoint + $.param(authParams);
		}

		function getAccessTokenFormHash() {
			var hash = window.location.hash;
			var action = hash.split('=')[0];
			console.log(hash);
			return parseHashParams(hash).access_token;
		}

		return {
			buildAuthUrl: buildAuthUrl,
			auth: auth,
			getAccessTokenFormHash: getAccessTokenFormHash,
			getContacts: getContacts

		};
	}
})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.factory('messageSvc', messageSvc);
	messageSvc.$inject = ['pixerfConfirmPopupSvc'];

	function messageSvc(pixerfConfirmPopupSvc) {
		var mLanguage = "en";
		var messageFormatter = new MessageFormat(mLanguage);

		function setLanguage(value) {
			mLanguage = value;
			messageFormatter = new MessageFormat(mLanguage);
		}

		function compile(message, data) {
			return messageFormatter.compile(message)(data);
		}

		function warnLeavingWithoutSaving() {
			return pixerfConfirmPopupSvc.showPopup({
				hideTitle: true,
				message: '<h4 class="text--bold">Hang on!</h4>Your changes have not been saved yet. If you exit now, they will be lost.',
				okBtnText: 'Yes',
				cancelBtnText: 'No'
			});
		}

		return {
			setLanguage: setLanguage,
			compile: compile,
			warnLeavingWithoutSaving: warnLeavingWithoutSaving
		};
	}
})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.factory('gtmSvc', gtmSvc);
	gtmSvc.$inject = [];

	function gtmSvc() {
		function gtag_report_conversion(url) {
			var pixerfEnv = new PixerfEnv().getEnv();
			var env = (pixerfEnv === "PRODUCTION") ? 'prod' : 'qa';
			var sentTo = 'AW-527523890/yCSICI-PnOMBELLAxfsB';
			if (env === 'prod') {
				sentTo = 'AW-954560595/YT2mCL73tOMBENjglccD';
			}
			var callback = function () {
				if (typeof (url) != 'undefined') {
					window.location = url;
				}
			};
			gtag('event', 'conversion', {
				'send_to': sentTo,
				'event_callback': callback
			});
			return false;
		}

		return {
			gtag_report_conversion: gtag_report_conversion
		};
	}
})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.factory('googleContactSvc', googleContactSvc);
	googleContactSvc.$inject = ['$q', 'accountUtils', '$resource'];

	function googleContactSvc($q, accountUtils, $resource) {

		var mAccessToken = null;
		var mConfiguration = {
			clientId: '235326345290-5kl8djavjuf5dbameb4ps8momd4d5el8.apps.googleusercontent.com',
			apiKey: 'AIzaSyAMoiaFP06ww9Q-An6XM15tokUSkO3O16k',
			scopes: 'https://www.googleapis.com/auth/contacts.readonly',
		}

		init();

		function init() {

			var pixerfEnv = new PixerfEnv().getEnv();
			if (pixerfEnv === "PRODUCTION") {
				mConfiguration.clientId = '6319052919-abnt04kue3rluhh02r7uk2thuc0as94i.apps.googleusercontent.com';
				mConfiguration.apiKey = "AIzaSyAxB3-SK4IS5RhYV8ABLitxdN328vOgNDM";
			}
			gapi.client.setApiKey(mConfiguration.apiKey);
		}

		function resourceFactory(accessToken) {

			return $resource("https://www.google.com/m8/feeds/contacts/default/thin?alt=json&access_token=" + accessToken + "&max-results=500&v=3.0", {}, {
				'get': {
					interceptor: {
						response: function (response) {
							console.log(response);
							var arr = [];
							for (var i = 0; i < response.data.feed.entry.length; i++) {
								arr.push(accountUtils.transformFromGoogleContacts(response.data.feed.entry[i]));
							}
							response.data = arr;
							return response;
						}
					}
				}
			});
		}

		function auth(callback) {
			gapi.auth.authorize({
				client_id: mConfiguration.clientId,
				scope: mConfiguration.scopes,
				immediate: false
			}, function (authorizationResult) {
				if (authorizationResult && !authorizationResult.error) {
					mAccessToken = authorizationResult.access_token;
					callback(mAccessToken);
				} else {

				}
			});
		}

		function getContacts() {
			return resourceFactory(mAccessToken).get().$promise;
		}

		return {
			init: init,
			getContacts: getContacts,
			auth: auth

		};
	}
})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.factory('googleAnalyticSvc', googleAnalyticSvc);
	googleAnalyticSvc.$inject = ['$location', '$window'];

	function googleAnalyticSvc($location, $window) {
		function init() {
			var pixerfEnv = new PixerfEnv().getEnv();
			var uid = 'UA-162697973-1';
			if (pixerfEnv === "PRODUCTION") {
				uid = 'UA-98276176-1';
			}
			$window.ga('create', uid, 'auto');
		}

		function trackPageView(pageName) {
			$window.ga('send', 'pageview', pageName ? pageName : $location.path());
		}

		function trackBtnClick(btnName) {
			$window.ga('send', 'event', 'buttons', 'click', btnName);
		}


		return {
			init: init,
			trackPageView: trackPageView,
			trackBtnClick: trackBtnClick

		};
	}
})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.factory('filePickerSvc', filePickerSvc);

	filePickerSvc.$inject = ['fileConst', 'arrayUtils', 'toastr'];
	var mClient = null;

	function getKey() {
		var pixerfFilestackConfigurer = new PixerfFilestackConfigurer();
		return pixerfFilestackConfigurer.getEnv();
	}

	function filePickerSvc(fileConst, arrayUtils, toastr) {
		mClient = filestack.init(getKey());
		// mClient.setKey(getKey()); //staging
		var mOptions = {
			// multiple: true,
			maxSize: 1024 * 1024 * fileConst.UPLOAD_PHOTO_VALIDATION.PHOTO_SIZE.MAX_FILE_SIZE,
			maxFiles: 100,
			accept: ['.jpeg', '.jpg'],
			// backgroundUpload: false,
			// container: 'window',
			// close: false,
			preferLinkOverStore: true,
			disableTransformer: true,
			// hideWhenUploading: true,
			onFileSelected: function (file) {
				console.log(file);
			},
			onFileUploadStarted: function (file) {
				console.log(file)
			},
			onFileUploadProgress: function (file, progressEvent) {
				console.log(progressEvent);
			},
			onFileUploadFinished: function (file) {
				console.log(file);
				if (file.source === "flickr" && file.size > mOptions.maxSize) {
					toastr.error("File: " + file.filename + " is too big. Maximum file size is 40MB! Please choose another file.");
				}
			},
			onFileUploadFailed: function (file) {
				console.log(file);
			},
			fromSources: ['flickr', 'googledrive', 'dropbox']
		}

		function pickMultiple(options) {
			arrayUtils.swapElement(mOptions.fromSources, options.defaultService, mOptions.fromSources[0]);
			mClient.pick(mOptions).then(function (result) {
				if (result.filesUploaded.length > 0 && options.callbacks.onSuccess) options.callbacks.onSuccess(result.filesUploaded);
				if (result.filesFailed.length > 0 && options.callbacks.onError) options.callbacks.onError(result.filesFailed);
			}, function (FPError) {
				if (options.callbacks.onError) options.callbacks.onError(result.filesFailed);
			});
		}

		function store(options) {
			mClient.store(options.input, options.option,
				function (Blob) {
					if (options.callbacks.onSuccess) options.callbacks.onSuccess(Blob);
				},
				function (FPError) {
					if (options.callbacks.onError) options.callbacks.onError(FPError);
				},
				function (FPProgress) {
					if (options.callbacks.onProgress) options.callbacks.onProgress(FPProgress);
				}
			);
		}

		function getMeta(handle) {
			return mClient.metadata(handle, {
				height: true,
				width: true
			});
		}

		return {
			pickMultiple: pickMultiple,
			store: store,
			getMeta: getMeta
		}
	}
})();

(function () {
	angular.module('pixerf').factory('auth0Utils', auth0Utils);
	auth0Utils.$inject = ['$q', 'jwtHelper', 'arrayUtils', 'angularAuth0', '$cookies', 'accountConst', 'sessionManagerSvc', 'authenticationConst', 'auth0AuthenticationSvc', 'signUpPageSvc', 'welcomePopupSvc', '$location', 'signUpPersonalInfoSvc', 'store', 'stringUtils', 'referralsIntroPopoverSvc', 'systemUtils', '$state', 'pixerfApiUserSvc', 'commonConst', 'cartSvc', 'completeProfilePopupSvc', 'notifyBusinessPendingPopupSvc', '$timeout'];

	function auth0Utils($q, jwtHelper, arrayUtils, angularAuth0, $cookies, accountConst, sessionManagerSvc, authenticationConst, auth0AuthenticationSvc, signUpPageSvc, welcomePopupSvc, $location, signUpPersonalInfoSvc, store, stringUtils, referralsIntroPopoverSvc, systemUtils, $state, pixerfApiUserSvc, commonConst, cartSvc, completeProfilePopupSvc, notifyBusinessPendingPopupSvc, $timeout) {
		function handleAuthentication() {
			angularAuth0.parseHash(function (err, authResult) {
				var verificationResult = $cookies.get(accountConst.VERIFICATION_COOKIE + "success");
				var email = $cookies.get(accountConst.VERIFICATION_COOKIE + "email");
				//user is logining in and get redirectd with url parameters
				if (authResult && authResult.accessToken && authResult.idToken) {
					store.set("signin", true);
					var profile = authResult.idTokenPayload;
					sessionManagerSvc.setSession(authResult);

					/**
					 * check for interuption when signing up
					 */
					var signingUpUser = sessionManagerSvc.getSigningUpUser();
					var communitySchortCode = store.get('csc');
					var eventShortCode = store.get('cesc');
					var paymentForEventAfterSigned = store.get(accountConst.TOKEN.PAYMENT_EVENT_AFTER_SIGNED);
					// if signing up is in progress
					if (signingUpUser) {
						if (signingUpUser.email !== profile.email) {
							//not valid
							sessionManagerSvc.setSigningUpUser(null);
						}else if(signingUpUser.email == store.get(accountConst.TOKEN.PAY_AFTER_SIGNED)){
							var isPayAfterSignin = true;
							signUpPageSvc.finaliseSignupProgress(isPayAfterSignin).then(function (userData) {
								$state.go(commonConst.STATE.CHECKOUT_PAYMENT);
							}, function () {
								$state.go(commonConst.STATE.CHECKOUT_PAYMENT);
							});
							//call payment after signed in
						}else if(store.get(accountConst.TOKEN.CREDIT_PLAN_AFTER_SIGNED_EMAIL)){
							if (signingUpUser.email == store.get(accountConst.TOKEN.CREDIT_PLAN_AFTER_SIGNED_EMAIL) && (signingUpUser.account_type === accountConst.ACCOUNT_TYPE.BUSINESS)) {
								var isGoToCreditPageAfterSigned = true;
								signUpPageSvc.finaliseSignupProgress(isGoToCreditPageAfterSigned).then(
									function (userData) {
										goToCreditPlanState();
									}, function () {
										goToCreditPlanState();
									})
							}
							else {
								removeCreditPlanStore();
							}
						} else if (communitySchortCode || eventShortCode) {
							signUpPageSvc.finaliseSignupProgress(true).then(
								function () {
									if (eventShortCode) {
										$state.go('invite-users-join-event', {
											short_code: eventShortCode
										});
										return;
									}

									if (communitySchortCode) {
										$state.go('invite-users-join-community', {
											short_code: communitySchortCode
										});
										return;
									}
								}, function (err) {
									if (eventShortCode) {
										$state.go('invite-users-join-event', {
											short_code: eventShortCode
										});
										return;
									}

									if (communitySchortCode) {
										$state.go('invite-users-join-community', {
											short_code: communitySchortCode
										});
										return;
									}
								});

						}else if(paymentForEventAfterSigned){
							signUpPageSvc.finaliseSignupProgress(true).then(
								function success(){
									$timeout(function () {
										$state.go('checkout.event-payment', {
											id: paymentForEventAfterSigned
										});
									}, 3000);
									
									return;
								},
								function err(){
									$timeout(function () {
										$state.go('checkout.event-payment', {
											id: paymentForEventAfterSigned
										});
									}, 3000);
									return;
								}
							);
						} else {
							signUpPageSvc.finaliseSignupProgress().then(function (userData) {
								if (signingUpUser.account_type === accountConst.ACCOUNT_TYPE.BUSINESS) {
                                    notifyBusinessPendingPopupSvc.showPopup();
								}
							}, function () {
								auth0AuthenticationSvc.signout();
							});
						}
					} else {
						auth0AuthenticationSvc.getUserInfoAfterLogin({}).promise.then(function (userData) {
							// removePaymentInfo();
							sessionManagerSvc.setCurrentLoginUser(userData);
							if(userData.email == store.get(accountConst.TOKEN.PAY_AFTER_SIGNED)){
								signUpPersonalInfoSvc.setUser(userData);
								return $state.go(commonConst.STATE.CHECKOUT_PAYMENT);
								//call payment after signed in
							}
							if(userData.email == store.get(accountConst.TOKEN.CREDIT_PLAN_AFTER_SIGNED_EMAIL) && (userData.account_type === accountConst.ACCOUNT_TYPE.BUSINESS)){
								signUpPersonalInfoSvc.setUser(userData);
								return goToCreditPlanState();
							}

							removeCreditPlanStore();

							if(paymentForEventAfterSigned){
								$state.go('checkout.event-payment', {
									id: paymentForEventAfterSigned
								});
							} else if (!userData.account_type) {
								signUpPersonalInfoSvc.setUser(userData);
								// var popup = completeProfilePopupSvc.showPopup();
								// popup.result.then(function (data) {
								// 	$state.go(commonConst.STATE.USER_HOMEPAGE);
								// });
								$state.go(commonConst.STATE.USER_HOMEPAGE);
							} else {
								var callbackURL = sessionManagerSvc.getCallbackURL();
								if (callbackURL) {
									$location.path(callbackURL);
									sessionManagerSvc.setCallbackURL(null);
								} else {
									$state.go(commonConst.STATE.USER_HOMEPAGE);
								}
								if (userData.account_type != accountConst.ACCOUNT_TYPE.BUSINESS) {
									if (isSocialConnectionSigningup(userData)) {
										signUpPersonalInfoSvc.setUser(userData);
										completeProfilePopupSvc.showPopup({referredBy: userData.referred_by});
										$state.go(commonConst.STATE.USER_HOMEPAGE);
									} else {
										if (auth0AuthenticationSvc.isProfileFaulty(userData)) {
											if (store.get("userCountry") && store.get("userCountry").toUpperCase() === "ID" && !userData.is_contributor_agreement_accepted) {
												userData.is_contributor_agreement_accepted = true;
												pixerfApiUserSvc.put(userData, function (response) {
													sessionManagerSvc.setCurrentLoginUser(response);
													$state.go("mission-intro-page");
												});
											} else {
												// $state.go("complete-profile-page");
												signUpPersonalInfoSvc.setUser(userData);
												$state.go(commonConst.STATE.USER_HOMEPAGE);
											}
										} else {
											if (!userData.is_banned) {
												var welcome = welcomePopupSvc.showPopup(userData);
												welcome.closed.then(function () {
													if (!systemUtils.isMobile()) {
														referralsIntroPopoverSvc.showOverlay();
													}
												});
											}
										}
									}
								} else {
									if (userData.is_email_verified && !userData.is_banned) {
										var welcome = welcomePopupSvc.showPopup(userData);
										welcome.closed.then(function () {
											if (!systemUtils.isMobile()) {
												referralsIntroPopoverSvc.showOverlay();
											}
										});
									} else if (!userData.is_email_verified && !userData.is_banned) {
                                        notifyBusinessPendingPopupSvc.showPopup();
                                    }
								}
							}
						}, function () {
							auth0AuthenticationSvc.signout();
						})
					}
				} else if (verificationResult) {
					auth0AuthenticationSvc.handleEmailVerifiedClicked();
				} else if (err) {
					$location.path('/');
					console.log(err);
				}else if(store.get(accountConst.TOKEN.GUEST_USER_TOKEN)){
					cartSvc.fetchCart();
				}
			})
		}
		// function removePaymentInfo(){
		// 	store.remove(accountConst.TOKEN.PAY_AFTER_SIGNED);
		// 	store.remove(accountConst.TOKEN.PAYMENT_INFO);
        //     store.remove(accountConst.TOKEN.PAYMENT_MENTHOD);
		// 	store.remove(accountConst.TOKEN.GUEST_USER_TOKEN);
		// 	store.remove(accountConst.TOKEN.SUBCRIBLE_NEWS_LETTER);
		// }

		function goToCreditPlanState(){
			if(store.get(accountConst.TOKEN.CREDIT_PLAN_AFTER_SIGNED_PAGE) == commonConst.STATE.MARKETPLACE_SIGNATURE_GALLERIES){
				$state.go(commonConst.STATE.MARKETPLACE_SIGNATURE_GALLERIES, {hashtag: "creditplan"});
			}else if(store.get(accountConst.TOKEN.CREDIT_PLAN_AFTER_SIGNED_PAGE) == commonConst.STATE.CHECKOUT_CREADIT_PALN_LIST){
				$state.go(commonConst.STATE.CHECKOUT_CREADIT_PALN_LIST, {hashtag: "creditplan"});
			}else{
				$state.go(store.get(accountConst.TOKEN.CREDIT_PLAN_AFTER_SIGNED_PAGE));
			}
			removeCreditPlanStore();
		}

		function removeCreditPlanStore(){
			store.remove(accountConst.TOKEN.CREDIT_PLAN_AFTER_SIGNED_PAGE);
			store.remove(accountConst.TOKEN.CREDIT_PLAN_AFTER_SIGNED_EMAIL);
		}

		function isSocialConnectionSigningup(user) {
			return user.account_type === accountConst.ACCOUNT_TYPE.PERSONAL && (!user.first_name &&
				!user.last_name && !user.date_of_birth &&
				(!user.address || (user.address && !user.address.country)) && (!user.profile || (user.profile &&
					!arrayUtils.isValueArr(user.profile.specialities) && !stringUtils.isValueString(user.profile.years_of_experience))));
		}

		function authenticationCheck() {
			var def = $q.defer();
			var param = auth0AuthenticationSvc.getParamterFromURL(window.location.href);
			if (typeof param.success !== "undefined") {
				def.reject();
				auth0AuthenticationSvc.signout();
				return def.promise;
			}
			if (sessionManagerSvc.getCurrentLoginUser().data) {
				def.resolve(sessionManagerSvc.getCurrentLoginUser().data);
			} else {
				var token = sessionManagerSvc.getToken();
				if (token) {
					if (!jwtHelper.isTokenExpired(token)) {
						var profile = sessionManagerSvc.getProfile();
						auth0AuthenticationSvc.getUserInfoAfterLogin({}).promise.then(function (userData) {
							sessionManagerSvc.setCurrentLoginUser(userData);
							if (!userData.account_type) {
								signUpPersonalInfoSvc.setUser(userData);
								completeProfilePopupSvc.showPopup();
								$state.go(commonConst.STATE.USER_HOMEPAGE);
							} else if (isSocialConnectionSigningup(userData)) {
								signUpPersonalInfoSvc.setUser(userData);
								completeProfilePopupSvc.showPopup();
								$state.go(commonConst.STATE.USER_HOMEPAGE);
							} else if (auth0AuthenticationSvc.isProfileFaulty(userData)) {
								// $state.go('complete-profile-page');
							}
							def.resolve(userData);
						}, function () {
							def.reject(authenticationConst.AUTHENTICATION_STATE.FAILED_RETREIVE_ACCOUNT_INTO);
						});
					} else {
						def.reject(authenticationConst.AUTHENTICATION_STATE.TOKEN_EXPIRED);
					}
				} else {
					def.reject(authenticationConst.AUTHENTICATION_STATE.NOT_LOGIN);
				}
			}
			return def.promise;
		}

		return {
			handleAuthentication: handleAuthentication,
			isSocialConnectionSigningup: isSocialConnectionSigningup,
			authenticationCheck: authenticationCheck
		}
	}
})();

(function () {

	angular
		.module('pixerf')
		.factory('auth0AuthenticationSvc', auth0AuthenticationSvc);

	auth0AuthenticationSvc.$inject = ['bannedUserPopupSvc', 'socketSvc', 'accountConst', 'cartSvc', 'verifiedEmailPopupSvc', '$cookies', 'resendVerificationEmailPopupSvc', 'accountUtils', 'arrayUtils', 'angularAuth0', 'store', '$q', 'pixerfApiUserSvc', 'sessionManagerSvc', 'authenticationConst', 'jwtHelper', '$location', 'toastr', '$timeout', 'infoRequirePopupSvc', 'gtmSvc', 'stringUtils', "$state", 'commonConst', '$uibModalStack'];

	function auth0AuthenticationSvc(bannedUserPopupSvc, socketSvc, accountConst, cartSvc, verifiedEmailPopupSvc, $cookies, resendVerificationEmailPopupSvc, accountUtils, arrayUtils, angularAuth0, store, $q, pixerfApiUserSvc, sessionManagerSvc, authenticationConst, jwtHelper, $location, toastr, $timeout, infoRequirePopupSvc, gtmSvc, stringUtils, $state, commonConst, $uibModalStack) {

		var mSignout = false;

		var callbackURL = window.location.href;
		var mLoginDefferd = {
			data: $q.defer()
		};

		function getParamterFromURL(url) {
			// This function is anonymous, is executed immediately and
			// the return value is assigned to QueryString!
			var query_string = {};
			var query = window.location.search.substring(1);
			var vars = query.split("&");
			for (var i = 0; i < vars.length; i++) {
				var pair = vars[i].split("=");
				// If first entry with this name
				if (typeof query_string[pair[0]] === "undefined") {
					query_string[pair[0]] = decodeURIComponent(pair[1]);
					// If second entry with this name
				} else if (typeof query_string[pair[0]] === "string") {
					var arr = [query_string[pair[0]], decodeURIComponent(pair[1])];
					query_string[pair[0]] = arr;
					// If third or later entry with this name
				} else {
					query_string[pair[0]].push(decodeURIComponent(pair[1]));
				}
			}
			return query_string;
		}

		function getUserInfoAfterLogin() {
			var def = $q.defer();
			pixerfApiUserSvc.me(function (pixerfUserInfo) {
				if (!pixerfUserInfo.cover_image || pixerfUserInfo.profile_image) {
					sessionManagerSvc.setCurrentLoginUser(pixerfUserInfo);
					var avatarUrl = accountUtils.buildUserAvatarPhotoUrl(pixerfUserInfo);
					pixerfUserInfo.avatar = avatarUrl;
				}
				if(pixerfUserInfo.is_banned){
					showBannedUserPopup(pixerfUserInfo);
				}

				// showBannedUserPopup(pixerfUserInfo);//Todo

				cartSvc.fetchCart().then(function () {
					def.resolve(pixerfUserInfo);
				}, function (error) {
					def.reject(error);
				});
				sessionManagerSvc.setCurrentLoginUser(pixerfUserInfo);
				socketSvc.joinPrivateChannel(pixerfUserInfo.username, sessionManagerSvc.getToken());

			}, function (error) {
				def.reject(error);
			});
			return def;
		}

		function buildMetaData(user) {
			if (user.account_type == accountConst.ACCOUNT_TYPE.BUSINESS) {
				return {
					account_type: user.account_type,
					first_name: user.first_name,
					organization: angular.toJson(user.organization)
				}
			}
			return {
				account_type: user.account_type,
				referred_by: user.referred_by,
				from_ad_campaign: user.from_ad_campaign
			}
		}

		function customSignUp(user) {
			var def = $q.defer();
			var data = $.extend({
				connection: authenticationConst.AUTH0_CONNECTION_TYPE.USERNAME_PASSWORD,
				email_verified: false
			}, {
				email: user.email,
				password: user.password,
				user_metadata: buildMetaData(user)
			});
			angularAuth0.signup(data, function (err) {
				if (err) {
					def.reject(err);
				} else {
					def.resolve(arguments);
				}
			});
			return def;
		}

		function signUpViaSocialConnection(type) {
			return signInViaSocialConnection(type);

		}

		function signInViaSocialConnection(type) {
			mSignout = false;
			var def = $q.defer();
			angularAuth0.authorize({
				connection: type,
				redirectUri: window.location.href,
				scope: 'openid email'
			});
			return def;

		}

		function signInByUserNamePassword(user) {
			var def = $q.defer();
			angularAuth0.login({
				username: user.email,
				password: user.password,
				realm: authenticationConst.AUTH0_CONNECTION_TYPE.USERNAME_PASSWORD,
				redirectUri: window.location.href
			}, function (error) {
				console.log('loginned');
				if (error) {
					def.reject(error);
				}
			});
			return def;

		}

		function resetPassword(email) {
			var def = $q.defer();
			pixerfApiUserSvc.reset_password({
				email: email
			}).$promise.then(function () {
				def.resolve();
			}, function (error) {
				console.log(error);
				def.reject(error);
			});


			return def;
		}

		function changePassword(user) {
			return pixerfApiUserSvc.change_password({
				current_password: user.currentPassword,
				new_password: user.newPassword,
				new_password_repeat: user.newPasswordAgain
			}).$promise;
		}

		function isUserExisted(email) {
			return pixerfApiUserSvc.isUserExisted({
				"email": email
			}).$promise;
		}

		function signout() {
			angularAuth0.logout();
			store.set("signout", true);
			removeGuestUserId();
			sessionManagerSvc.clearSession();
			sessionManagerSvc.setMarketplaceTabHistory("/buy-stock-page/trending");
			mSignout = true;
			window.location.href = "/";
		}

		function removeGuestUserId(){
			store.remove(accountConst.TOKEN.GUEST_USER_TOKEN);
		}

		function authenticationCheck() {
			var def = $q.defer();
			var param = getParamterFromURL(window.location.href);
			if (typeof param.success !== "undefined") {
				def.reject();
				signout();
				return def.promise;
			}
			if (sessionManagerSvc.getCurrentLoginUser().data) {
				def.resolve(sessionManagerSvc.getCurrentLoginUser().data);
			} else {
				var token = sessionManagerSvc.getToken();
				if (token) {
					if (!jwtHelper.isTokenExpired(token)) {
						getUserInfoAfterLogin({}).promise.then(function (userData) {
							sessionManagerSvc.setCurrentLoginUser(userData);
							// if (isProfileFaulty(userData)) {
							// 	$state.go(commonConst.STATE.COMPLETE_PROFILE_SKILL);
							// }
							def.resolve(userData);
						}, function () {
							def.reject(authenticationConst.AUTHENTICATION_STATE.FAILED_RETREIVE_ACCOUNT_INTO);
						});
					} else {
						def.reject(authenticationConst.AUTHENTICATION_STATE.TOKEN_EXPIRED);
					}
				} else {
					def.reject(authenticationConst.AUTHENTICATION_STATE.NOT_LOGIN);
				}
			}
			return def.promise;
		}

		function authenticationErrHandler(errMsg) {
			toastr.error(errMsg);
			sessionManagerSvc.clearSession();
			$timeout(function () {
				$location.path('/');

			}, 3000);
		}

		function handleAuthenticationCheck(result) {

			if (result === authenticationConst.AUTHENTICATION_STATE.TOKEN_EXPIRED) {
				authenticationErrHandler("Session timeout!");
				signout();
			} else if (result === authenticationConst.AUTHENTICATION_STATE.FAILED_RE_AUTHENTICATE) {
				authenticationErrHandler("Failed to re-authenticate!");
				signout();
			} else if (result === authenticationConst.AUTHENTICATION_STATE.FAILED_RETREIVE_ACCOUNT_INTO) {
				authenticationErrHandler("Failed to retrieve user information!");
				signout();
			} else if (result === authenticationConst.AUTHENTICATION_STATE.FAILED_SIGNUP) {
				signout();
			}
		}

		function handleEmailVerifiedClicked() {
			var loginUser = sessionManagerSvc.getCurrentLoginUser().data;
			var verificationResult = $cookies.get(accountConst.VERIFICATION_COOKIE + "success");
			var email = $cookies.get(accountConst.VERIFICATION_COOKIE + "email");
			if (verificationResult === "true") {
				if (!loginUser.isBiz) {
					verifiedEmailPopupSvc.showPopup();
				} else {
					verifiedBusinessEmailPopupSvc.showPopup();
				}
				gtmSvc.gtag_report_conversion();
			} else if (verificationResult === "false") {
				var reason = $cookies.get(accountConst.VERIFICATION_COOKIE + "reason");
				if (reason === "already-verified") {
					resendVerificationEmailPopupSvc.showPopup({
						isHideResendBtn: true,
						cancelBtnTxt: 'Ok thanks',
						messages: {
							m1: "Hi, " + (loginUser ? loginUser.displayName : ''),
							m2: "Your email has already been verified!"
						}
					});
				} else if (reason === "token-expired") {
					resendVerificationEmailPopupSvc.showPopup({
						email: email,
						cancelBtnTxt: 'No thanks',
						resendBtnTxt: "Yes, please",
						messages: {
							m1: "Hi, " + (loginUser ? loginUser.displayName : ''),
							m2: "This link to verify your email has expired!",
							m3: "Let us send you a new one."
						}
					});
				} else {
					resendVerificationEmailPopupSvc.showPopup({
						isHideResendBtn: true,
						cancelBtnTxt: 'Ok thanks',
						messages: {
							m2: "Invalid verification link!"
						}
					});
				}
			}
		}

		function isProfileFaulty(userInfo) {
			return  (userInfo.account_type === accountConst.ACCOUNT_TYPE.PERSONAL && (!userInfo.email || !userInfo.first_name ||
				!userInfo.last_name || !userInfo.location || !userInfo.date_of_birth ||
				!userInfo.address || !userInfo.address.country || !userInfo.profile ||
				!arrayUtils.isValueArr(userInfo.profile.specialities)));
		}

		function showBannedUserPopup(userInfo){
			$uibModalStack.dismissAll();
			bannedUserPopupSvc.showPopup(userInfo);
		}

		function showProfileFaultyPopup(userInfo) {
			var steps = {};
			if (!userInfo.isBiz && (!userInfo.first_name || !userInfo.last_name || !userInfo.email || !userInfo.location || !userInfo.address || !userInfo.address.country || !userInfo.date_of_birth)) {
				steps["BASIC_INFO"] = {
					name: "BASIC_INFO",
					title: "Fill in required information",
					requiredFields: ["first_name", "last_name", "email", "location", "country", "date_of_birth"],
					validator: function (user, form) {
						return infoRequirePopupSvc.validateProfile(user, form);
					}
				};
			}
			if (!userInfo.isBiz && (!userInfo.profile || !arrayUtils.isValueArr(userInfo.profile.specialities) ||
					!stringUtils.isValueString(userInfo.profile.years_of_experience) || !stringUtils.isValueString(userInfo.profile.services_rate_amount) ||
					!userInfo.profile.services_rate_type || !arrayUtils.isValueArr(userInfo.profile.cameras) ||
					(!arrayUtils.isValueArr(userInfo.profile.availability_weekdays) && !arrayUtils.isValueArr(userInfo.profile.availability_weekends)))) {
				steps["SPECIALITIES_INFO"] = {
					name: "SPECIALITIES_INFO",
					title: "Fill in required information",
					requiredFields: ["specialities", "years_of_experience", "cameras", "service_rates", "availability"],
					validator: function (user, form) {
						return infoRequirePopupSvc.validateServiceData(user, form);
					}
				};
			}
			if (!userInfo.profile_image && !accountUtils.isSocialAccount(userInfo)) {
				var title = "Choose your profile photo";
				if (userInfo.isBiz) {
					title = "Choose a Profile Photo";
				}
				steps["PROFILE_IMAGE"] = {
					name: "PROFILE_IMAGE",
					title: title,
					requiredFields: ["profile_image"],
					validator: function (user) {
						return !user.profile_image ? "Please choose your profile photo!" : "";
					},
					canSkip: true
				};
			}
			if (!userInfo.cover_image) {
				steps["COVER_IMAGE"] = {
					name: "COVER_IMAGE",
					title: "Choose a Cover Photo",
					requiredFields: ["cover_image"],
					validator: function (user) {
						return !user.cover_image ? "Please choose your cover photo!" : "";
					},
					canSkip: true
				};
			}
			if (userInfo.canUploadPhotos && userInfo.stats.media_count < 20) {
				steps["UPLOADS"] = {
					name: "UPLOADS",
					title: "Upload your photos",
					requiredFields: ["media_counts"],
					canSkip: true
				};
			}

			infoRequirePopupSvc.showPopup({
				user: userInfo,
				steps: steps
			});
		}

		return {
			loginDefferd: mLoginDefferd,
			customSignUp: customSignUp,
			signUpViaSocialConnection: signUpViaSocialConnection,
			signInViaSocialConnection: signInViaSocialConnection,
			signInByUserNamePassword: signInByUserNamePassword,
			getParamterFromURL: getParamterFromURL,
			resetPassword: resetPassword,
			changePassword: changePassword,
			isUserExisted: isUserExisted,
			signout: signout,
			getUserInfoAfterLogin: getUserInfoAfterLogin,
			handleAuthenticationCheck: handleAuthenticationCheck,
			isProfileFaulty: isProfileFaulty,
			showProfileFaultyPopup: showProfileFaultyPopup,
			authenticationCheck: authenticationCheck,
			handleEmailVerifiedClicked: handleEmailVerifiedClicked
		}
	}
})();

function PixerfImage(url, callbacks) {
	this.imgElt = new Image();
	this.imgElt.src = url;
	this.imgElt.onload = callbacks.onload;
	this.imgElt.onerror = callbacks.onerror;
}

(function () {

	angular
		.module('pixerf')
		.factory('responseInterceptor', responseInterceptor);

	responseInterceptor.$inject = ['$location'];

	function responseInterceptor($location) {
		return {
			'response': function (response) {
				// do something on success
				return response;
			},

			// optional method
			'responseError': function (error) {
				if (error.status >= 400 && error.status < 500) {
					$location.path("/400");
				} else if (error.status >= 500 && error.status < 600) {
					$location.path("/500");
				}
				return error;

			}
		};
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.filter('number', number);

	number.$inject = [];

	function number() {
		return function (input) {
			input = parseFloat(input);
			input = input.toFixed(input % 1 === 0 ? 0 : 2);
			return input.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
		};
	}
})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.constant('priceConst', {
			FREE_USER: [
				10, 20, 30, 40, 50
			],
			EXTENDED_LICENSES: [{
				"id": "PRODUCTS_FOR_RESALE",
				"title": "products-for-resale",
				"price": 500,
				"key": "is_for_resale",
				"tooltips": "tool-tip-products-for-resale"
			}, {
				"id": "UNLIMITED_PRINT",
				"title": "unlimited-print",
				"price": 300,
				"key": "is_unlimited_print",
				"tooltips": "tool-tip-unlimited-print"
			}, {
				"id": "MULTI_SEAT",
				"title": "Multi-seat",
				"price": 100,
				"key": "is_multi_seat",
				"tooltips": "tool-tip-multiseat"
			}]
		});
})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.constant('portfolioConst', {
			MAX_GALLERY: 3,
			MAX_PHOTO_GALLERY: 10,
			UPLOAD_PHOTO_VALIDATION: {
				PHOTO_SIZE: {
					MIN_RESOLUTION: 0.5,
					MAX_RESOLUTION: 4,
					MAX_FILE_SIZE: 2
				},
				ERROR_CODE: {
					FAILED_TO_UPLOAD: "FAILED_TO_UPLOAD",
					INVALID_FILETYPE: "UPLOAD_VALIDATION_INVALID_FILETYPE",
					DUPLICATED: "UPLOAD_VALIDATION_DUPLICATED",
					PORTFOLIO_INVALID_MIN_RESOLUTION: "UPLOAD_PORTFOLIO_VALIDATION_INVALID_MIN_RESOLUTION",
					INVALID_MAX_RESOLUTION: "UPLOAD_VALIDATION_INVALID_MAX_RESOLUTION",
					EXCEED_NUMBER_OF_UPLOAD_PER_TIMES: "EXCEED_NUMBER_OF_UPLOAD_PER_TIMES",
					PORTFOLIO_INVALID_MAX_FILESIZE: "UPLOAD_PORTFOLIO_VALIDATION_INVALID_MAX_FILESIZE"
				}
			},
			LIMIT_SPECIALITIES: 5
		});
})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.constant('missionConst', {
			GOJEK: {
				MISSION_ID: 72
			},
			INDONESIA: {
				MISSION_ID: [72, 77]
			},
			MALAYSIA: {
				MISSION_ID: [81, 92, 103, 104, 105, 106]
			},
			MISSION_RANKING_ORDER: {
				MISSION_ID: [72, 1490]
			},
			TYPES: {
				CLIENT: ["GRAND_WINNER", "WINNER", "RUNNER_UP_1", "RUNNER_UP_2", "CONSOLATION", "SPECIAL_MENTION"]
			},
			TYPE: {
				GRAND_WINNER: "GRAND_WINNER",
				WINNER: "WINNER",
				RUNNER_UP_1: "RUNNER_UP_1",
				RUNNER_UP_2: "RUNNER_UP_2",
				CONSOLATION: "CONSOLATION",
				SPECIAL_MENTION: "SPECIAL_MENTION"
			},
			PAIR_TYPE: [{
					LABEL: "GRAND_WINNER",
					NAME: "Grand Prize",
					TYPE: "WINNER",
				},
				{
					LABEL: "RUNNER_UP_1",
					NAME: "First Runner-up",
					TYPE: "RUNNER_UP",
				},
				{
					LABEL: "RUNNER_UP_2",
					NAME: "Second Runner-up",
					TYPE: "RUNNER_UP",
				}
			],
			ASIA_GEO: {
				MISSION_IDS: [1036],
				PRINT_SUBSCRIBER: {
					LABEL: "PRINT_SUBSCRIBER",
					ENTRIES_FREE_SLOT: 6,
					ENTRIES_FEE: 10
				},
				E_SUBSCRIBER: {
					LABEL: "E_SUBSCRIBER",
					ENTRIES_FREE_SLOT: 4,
					ENTRIES_FEE: 10
				},
				NOT_SUBSCRIBER: {
					LABEL: "NOT_SUBSCRIBER",
					ENTRIES_FREE_SLOT: 1,
					ENTRIES_FEE: 10
				},
				ENTRIES_SLOT: 10,
				ERROR_CODE: {
					EXCEED_NUMBER_OF_UPLOAD: "EXCEED_NUMBER_OF_UPLOAD"
				}
			}
		});
})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.constant('galleryConst', {
			TOP_PIXERFER_GALLERY: 5,
			GALLERY_TYPE: {
				CURATED: "curated",
				DEFAULT: "default",
				FOLLOWING: "following",
				PIXERF: 'pixerf'
			}
		});
})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.constant('fileConst', function () {
			var conObj = {
				SIZE: {
					BIG: "1200x",
					MEDIUM: "x400"
				},
				PATH: {
					UNSAFE: "http://52.76.226.116/unsafe/",
					FILESTACK: "https://process.filestackapi.com/"
				},
				FILESTACK_CONTAINER: {
					USER_PROFILE: "pixerf-filepicker-profile",
					USER_COVER: "pixerf-filepicker-cover",
				},
				SIZE_DEFINITION: [{
						name: "SMALL",
						value: 1
					},
					{
						name: "MEDIUM",
						value: 3
					},
					{
						name: "LARGE",
						value: 4
					},
					{
						name: "X-LARGE",
						value: 12
					},
					{
						name: "XX-LARGE",
						value: 24
					}
				],
				FILE_STATE_NAME: {
					'TRENDING': 'trending',
					'PENDING_MISSIONS': 'missions',
					'PENDING_PORTFOLIO': 'portfolio',
					'GENERAL': 'general',
					'REJECTED': 'rejected',
					'PENDING': 'pending',
					'DISCOVER': 'discover',
					'EDITOR_PICK': "editor's-pick",
					'TEMPORARY': "temporary",
				},
				BADGES: {
					CODES: {
						MISSION_WINNER: "M",
						MISSION_CONSOLATION: "MC",
						EDITOR_PICK: "PC"
					}
				},
				UPLOAD_PHOTO_VALIDATION: {
					ERROR_CODE: {
						FAILED_TO_UPLOAD: "FAILED_TO_UPLOAD",
						INVALID_FILETYPE: "UPLOAD_VALIDATION_INVALID_FILETYPE",
						INVALID_THREE_FILETYPE: "UPLOAD_VALIDATION_INVALID_THREE_FILETYPE",
						DUPLICATED: "UPLOAD_VALIDATION_DUPLICATED",
						INVALID_MIN_RESOLUTION: "UPLOAD_VALIDATION_INVALID_MIN_RESOLUTION",
						INVALID_MIN_INSPIRATION_RESOLUTION: "INVALID_MIN_INSPIRATION_RESOLUTION",
						INVALID_MAX_INSPIRATION_RESOLUTION: "INVALID_MAX_INSPIRATION_RESOLUTION",
						INVALID_MAX_FILESIZE: "UPLOAD_VALIDATION_INVALID_MAX_FILESIZE",
						INVALID_MAX_TIFF_FILE_SIZE: "UPLOAD_VALIDATION_INVALID_MAX_TIFF_FILE_SIZE",
						INVALID_MIN_FILESIZE: "UPLOAD_VALIDATION_INVALID_MIN_FILESIZE",
						EXCEED_NUMBER_OF_UPLOAD_PER_WEEK: "EXCEED_NUMBER_OF_UPLOAD_PER_WEEK",
						EXCEED_NUMBER_OF_UPLOAD_THIS_MISSION: "EXCEED_NUMBER_OF_UPLOAD_THIS_MISSION",
						EXCEED_NUMBER_OF_INSPIRATION_UPLOAD_PER_MISSION: "EXCEED_NUMBER_OF_INSPIRATION_UPLOAD_PER_MISSION",
						EXCEED_NUMBER_OF_UPLOAD_PER_TIMES: "EXCEED_NUMBER_OF_UPLOAD_PER_TIMES"
					},
					PHOTO_SIZE: {
						MIN_RESOLUTION: 5,
						MIN_INSPIRATION_RESOLUTION: 0.5,
						MAX_INSPIRATION_RESOLUTION: 4,
						MAX_FILE_SIZE: 40,
						MAX_TIFF_FILE_SIZE: 1024
					},
					MISSION_LIMIT: 10,
					MISSION_INSPIRATIONLIMIT: 15,
				},
				GOJEK: {
					UPLOAD_PHOTO_VALIDATION: {
						MISSION_LIMIT: 10
					}
				},
				PHOTO_GRID_PAGE_SIZE: 17
			};
			conObj.FILE_STATE_DEFINITION = function () {
				var obj = {};
				for (var key in conObj.FILE_STATE_NAME) {
					if (key === 'PENDING' || key === 'PENDING_PORTFOLIO') {
						obj[conObj.FILE_STATE_NAME[key]] = 'h';
					}else if (key === 'TEMPORARY') {
						obj[conObj.FILE_STATE_NAME[key]] = 'p';
					} else {
						obj[conObj.FILE_STATE_NAME[key]] = conObj.FILE_STATE_NAME[key][0].toLowerCase();
					}
				}
				return obj;
			}();
			return conObj;
		}());
})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.constant('eventConst', {
			"TYPE": {
                "UPCOMING": "upcoming",
                "PAST": "past"
            }
		});
})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.constant('errorConst', {
			"CHECKOUT_MY_CREDIT_INSUFFICIENT_FUNDS": "INSUFFICIENT_FUNDS"
		});
})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.constant('customCommissionsConst', {
			MAX_PHOTO_TO_RELEASE: 100,
			MODE: {
				ACROSS_CC: 'across_cc',
				PER_SHOOT: 'per_shoot'
			}
		});
})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.constant('creditPlanConst', {
			"PLANS": [{
				id: '{id}',
				name: '{name}',
				value: '{value}',
				price: '{price}',
				discount: '${discount_amount}',
				hint: 'save-percent-credit-plan-package',
				hiDesc: 'get-number-image-credit-plan-package',
				desc: 'image-credits-1',
				directly: true,
			}, {
				id: 999,
				name: 'Enterprise',
				entDesc: [
					{ icon: 'icon-icon-percent', value: 'Special corporate rates' },
					{ icon: 'icon-cart-2', value: 'Bulk purchase packages' },
					{ icon: 'icon-icon-search-2', value: 'Personalised image search' },
					{ icon: 'icon-icon-insert', value: 'Tailored image curation' },
					{ icon: 'icon-icon-deal', value: '10 free L images to get you started' }
				],
				directly: false,
				mailTo: 'business@pixerf.com?Subject=I\'m%20interested%20to%20purchase%20an%20Enterprise%20PIXERF%20Credit%20Package'
			}
		]
		});
})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.constant('contextConst', {
			CHECKOUT_CART: "CHECKOUT_CART",
			TOPUP_CREDIT_PLANS: "TOPUP_CREDIT_PLANS",
			COMMUNITY_PENDING_MEMBER: "COMMUNITY_PENDING_MEMBER",
			COMMUNITY_MEMBER: "COMMUNITY_MEMBER",
			COMMUNITY_INVITED_MEMBER: "COMMUNITY_INVITED_MEMBER",
			COMMUNITY_BLOCKED_MEMBER: "COMMUNITY_BLOCKED_MEMBER",
			CHECKOUT_EVENT: "CHECKOUT_EVENT"
		});
})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.constant('communityConst', {
			MEMBERSHIP: {
				REJECTED: "rejected",
				ACCEPTED: "accepted",
				REQUESTED: "requested",
				BLOCKED: "banned",
				INVITED: "invited",
				OWNER: "owner",
				MANAGER: "manager"
			},
			ERROR: {
				COMMUNITY_OWNERSHIP_LIMIT: "community_ownership_limit"
			},
			CREATE_STEP: {
				BASIC_INFO: "BASIC_INFO",
				INVITE_MEMBERS: "INVITE_MEMBERS"
			},
			LAYOUT: {
				LIST_VIEW: "list-details-view",
				GRID_VIEW: "grid-view"
			},
			CONTEXT: {
				MANAGE: "MANAGE",
				JOINED: "JOINED",
				REQUESTED: "REQUESTED",
				INVITED: "INVITED"
			},
			ACTION: {
				REJECT: 'reject',
				ACCEPT: 'accept',
				REMOVE: 'remove',
				UNINVITE: 'uninvite',
				WITHDRAW: 'withdraw',
				LEAVE: 'leave',
				CANCEL: 'cancel',
				JOIN: 'join',
				UNBLOCK: 'unblock',
				INVITE: 'invite'
			},
			DISSCUSSION: {
				LIMIT_PHOTO_ATTACHMENT: 3
			},
			EVENT_POST:{
				LIMIT_PHOTO_ATTACHMENT: 3
			}
		});
})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.constant('commonConst', {
			ACTION: {
				CREATE: "CREATE",
				EDIT: "EDIT",
				DELETE: "DELETE"
			},
			SCREEN: {
				MOBILE: 1023
			},
			IPGEOLOCATION: {
				URL: "https://api.ipgeolocation.io/ipgeo?apiKey=",
				API_KEYS: [
					'65ea095f88204515986b0e02d8c12a23',
					'dbf2391a8382456d815df7e7c796cac4',
					'cd2226c85ce8495fb1bcfb7ffc442bbf',
					'4f739a3c42ea443294ab80a1a93145de',
					'a80274d346274c9b991feedc79d887e4'
				]
			},
			REPORT:{
				NO_IF_STRIKE: 3
			},
			STATE: {
				USER_HOMEPAGE: "user-home-page.homepage",
				SIGN_UP_PERSONAL_INFO: "sign-up.sign-up-personal-info",
				CHECKOUT_PAYMENT: "checkout.payment",
				COMPLETE_PROFILE_SKILL: "complete-profile-skills",
				SELECT_ACCOUNT_TYPE: "sign-up.select-account-type",
				EXPLORE_COMMUNITY: "for-creator-page.about-community",
				ABOUT_CUSTOM_COMMISSION: "about-custom-commissions-page",
				ABOUT_MISSION: "run-a-challenge-page.about-challenge",
				MARKETPLACE_PHOTOS: "buy-stock-page.trending",
				FEATURED_PHOTOGRAPHER: "marketplace.photographers.featuredPhotographer",
				PHOTO_BY_TYPE: "marketplace.photosByType",
				RELEASES: "introduction-support.releases",
				LET_TALK: "email-us-page",
				FAQ_PERSONAL: "introduction-support.faq.personal",
				FAQ_BUSINESS: "introduction-support.faq.business",
				TERMS: "introduction-company.terms",
				PRIVACY: "introduction-company.privacy",
				ABOUT_PIXERF: "about-pixerf",
				JOBS: "jobs",
				GALLERY_BY_TYPE: "marketplace.galleries",
				CASE_STUDIES: "case-studies",
				MISSION_JOINED: "run-a-challenge-page.joined-challenges",
				MISSION_CLOSED: "run-a-challenge-page.past-challenges",
				MISSION_ONGOING: "run-a-challenge-page.live-challenges",
				MISSION_SUBMISSIONS: "mission-detail-page.submissions",
				MANAGE_PHOTO_PENDING: "setting.manage-photos.pending-review",
				MANAGE_COMMUNITIES: "setting.manage-communities.communities",
				MANAGE_EVENTS: "setting.manage-events.manage-going-events",
				MANAGE_EVENT: "manage-event.edit-event",
				MANAGE_REPORTS: "setting.manage-reports.manage-pending-reports",
				JOINED_COMMUNITIES: "setting.manage-communities.joined-communities",
				PORTFOLIO_PHOTOS: "user-home-page.personal.portfolio.portfolio-detail.portfolio-photos",
				USER_PROFILE_PHOTO: "user-home-page.personal.photos",
				USER_PROFILE_HOME: "user-home-page.personal.home",
				CUSTOMCOMMISSIONS_DETAIL_APPROVAL: "custom-commissions-detail-page.approval",
				CUSTOMCOMMISSIONS_DETAIL_DELIVERY: "custom-commissions-detail-page.delivery",
				MANAGE_COMMUNITIES_BRIEF: "manage-community.edit-community",
				MANAGE_COMMUNITIES_INVITED_MEMBERS: 'manage-detail-community.manage-detail-community-members.manage-detail-community-invited-members',
				MANAGE_COMMUNITIES_REQUESTED_MEMBERS: 'manage-detail-community.manage-detail-community-members.manage-detail-community-requested-members',
				MANAGE_COMMUNITIES_PENDING_DISCUSSIONS: 'manage-detail-community.manage-detail-community-discussions.manage-detail-community-pending-discussions',
				MANAGE_COMMUNITIES_UNPUBLISHED_DISCUSSIONS: 'manage-detail-community.manage-detail-community-discussions.manage-detail-community-unpublished-discussions',
				MANAGE_COMMUNITIES_CURRENT_MEMBERS: 'manage-detail-community.manage-detail-community-members.manage-detail-community-current-members',
				MANAGE_COMMUNITIES_BLOCKED_MEMBERS: 'manage-detail-community.manage-detail-community-members.manage-detail-community-blocked-members',
				MANAGE_JOINED_COMMUNITIES: "setting.manage-communities.manage-joined-communities",
				MANAGE_COMMUNITIES_INVITATION: "setting.manage-communities.manage-invited-communities",
				MANAGE_REQUESTED_COMMUNITIES: "setting.manage-communities.manage-requested-communities",
				MANAGE_PENDING_COMMUNITIES: "setting.manage-communities.manage-pending-communities",
				MANAGE_PENDING_APPROVAL_COMMUNITIES: "setting.manage-communities.manage-pending-approval-communities",
				MANAGE_ACTION_REQUIRED_COMMUNITIES: "setting.manage-communities.manage-action-required-communities",
				MANAGE_ACTIVE_COMMUNITIES: "setting.manage-communities.manage-active-communities",
				MANAGE_INREVIEW_COMMUNITIES: "setting.manage-communities.manage-inreview-communities",
				MANAGE_DEACTIVATED_COMMUNITIES: "setting.manage-communities.manage-deactivated-communities",
				COMMUNITIES_DETAILS_BRIEF: "community-detail-page.community-detail-page-brief",
				COMMUNITIES_DETAILS_MEMBERS: "community-detail-page.community-detail-page-members",
				COMMUNITIES_DETAILS_DISCUSSIONS: "community-detail-page.community-detail-discussions",
				COMMUNITIES_DETAILS_EVENTS: "community-detail-page.community-detail-events",
                COMMUNITIES_DETAILS_CLASSES: "community-detail-page.community-detail-classes",
				COMMUNITIES_DETAILS_PHOTOS: "community-detail-page.community-detail-photos",
				MANAGE_COMMUNITIES_MEMBERS: "manage-detail-community.manage-detail-community-members",
				MANAGE_GOING_EVENTS: "setting.manage-events.manage-going-events",
				MANAGE_PAST_EVENTS: "setting.manage-events.manage-past-events",
				MANAGE_DRAFT_EVENTS: "setting.manage-events.manage-draft-events",
				MANAGE_INREVIEW_EVENTS: "setting.manage-events.manage-in-review-events",
				COMMUNITY_NOT_FOUND: 'community-not-found',
				DISCUSSION_DETAIL: 'discussion-detail-page',
				EVENT_FEED: 'event-detail-page.event-feed',
				EVENT_SCHEDULE: 'event-detail-page.event-schedule',
				EVENT_PHOTOS: 'event-detail-page.event-photos',
				MARKETPLACE_SIGNATURE_GALLERIES: 'buy-stock-page.galleries.signature-galleries',
				CHECKOUT_CREADIT_PALN_LIST: 'checkout.credit-plan.credit-plan-list',
				EDIT_PERSONAL_PROFILE: 'setting.edit_profile_personal',
				EDIT_BUSINESS_PROFILE: 'setting.edit_profile_business',
				MANAGE_PENDING_REPORTS: "setting.manage-reports.manage-pending-reports",
				MANAGE_PAST_REPORTS: "setting.manage-reports.manage-past-reports"
			}
		});
})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.constant('bankConst', {
			COUNTRY_CURRENCY_MAP: {
				"AED": {
					"symbol": "AED",
					"name": "United Arab Emirates Dirham",
					"symbol_native": "د.إ.\u200F",
					"decimal_digits": 2,
					"rounding": 0.0,
					"code": "AED",
					"name_plural": "UAE dirhams"
				},
				"AFN": {
					"symbol": "AFN",
					"name": "Afghan Afghani",
					"symbol_native": "؋",
					"decimal_digits": 0,
					"rounding": 0.0,
					"code": "AFN",
					"name_plural": "Afghan Afghanis"
				},
				"ALL": {
					"symbol": "ALL",
					"name": "Albanian Lek",
					"symbol_native": "Lek",
					"decimal_digits": 0,
					"rounding": 0.0,
					"code": "ALL",
					"name_plural": "Albanian lekë"
				},
				"AMD": {
					"symbol": "AMD",
					"name": "Armenian Dram",
					"symbol_native": "դր.",
					"decimal_digits": 0,
					"rounding": 0.0,
					"code": "AMD",
					"name_plural": "Armenian drams"
				},
				"AOA": {
					"symbol": "AOA",
					"name": "Angolan Kwanza",
					"symbol_native": "Kz",
					"decimal_digits": 2,
					"rounding": 0.0,
					"code": "AOA",
					"name_plural": "Angolan kwanzas"
				},
				"ARS": {
					"symbol": "ARS",
					"name": "Argentine Peso",
					"symbol_native": "$",
					"decimal_digits": 2,
					"rounding": 0.0,
					"code": "ARS",
					"name_plural": "Argentine pesos"
				},
				"AUD": {
					"symbol": "AU$",
					"name": "Australian Dollar",
					"symbol_native": "$",
					"decimal_digits": 2,
					"rounding": 0.0,
					"code": "AUD",
					"name_plural": "Australian dollars"
				},
				"AWG": {
					"symbol": "AWG",
					"name": "Aruban Florin",
					"symbol_native": "Afl.",
					"decimal_digits": 2,
					"rounding": 0.0,
					"code": "AWG",
					"name_plural": "Aruban florin"
				},
				"AZN": {
					"symbol": "AZN",
					"name": "Azerbaijani Manat",
					"symbol_native": "ман.",
					"decimal_digits": 2,
					"rounding": 0.0,
					"code": "AZN",
					"name_plural": "Azerbaijani manats"
				},
				"BAM": {
					"symbol": "BAM",
					"name": "Bosnia-Herzegovina Convertible Mark",
					"symbol_native": "KM",
					"decimal_digits": 2,
					"rounding": 0.0,
					"code": "BAM",
					"name_plural": "Bosnia-Herzegovina convertible marks"
				},
				"BBD": {
					"symbol": "BBD",
					"name": "Barbadian Dollar",
					"symbol_native": "$",
					"decimal_digits": 2,
					"rounding": 0.0,
					"code": "BBD",
					"name_plural": "Barbadian dollars"
				},
				"BDT": {
					"symbol": "BDT",
					"name": "Bangladeshi Taka",
					"symbol_native": "৳",
					"decimal_digits": 2,
					"rounding": 0.0,
					"code": "BDT",
					"name_plural": "Bangladeshi takas"
				},
				"BGN": {
					"symbol": "BGN",
					"name": "Bulgarian Lev",
					"symbol_native": "лв.",
					"decimal_digits": 2,
					"rounding": 0.0,
					"code": "BGN",
					"name_plural": "Bulgarian leva"
				},
				"BHD": {
					"symbol": "BHD",
					"name": "Bahraini Dinar",
					"symbol_native": "د.ب.\u200F",
					"decimal_digits": 3,
					"rounding": 0.0,
					"code": "BHD",
					"name_plural": "Bahraini dinars"
				},
				"BIF": {
					"symbol": "BIF",
					"name": "Burundian Franc",
					"symbol_native": "FBu",
					"decimal_digits": 0,
					"rounding": 0.0,
					"code": "BIF",
					"name_plural": "Burundian francs"
				},
				"BMD": {
					"symbol": "BMD",
					"name": "Bermudan Dollar",
					"symbol_native": "$",
					"decimal_digits": 2,
					"rounding": 0.0,
					"code": "BMD",
					"name_plural": "Bermudan dollars"
				},
				"BND": {
					"symbol": "BND",
					"name": "Brunei Dollar",
					"symbol_native": "$",
					"decimal_digits": 2,
					"rounding": 0.0,
					"code": "BND",
					"name_plural": "Brunei dollars"
				},
				"BOB": {
					"symbol": "BOB",
					"name": "Bolivian Boliviano",
					"symbol_native": "Bs",
					"decimal_digits": 2,
					"rounding": 0.0,
					"code": "BOB",
					"name_plural": "Bolivian bolivianos"
				},
				"BRL": {
					"symbol": "R$",
					"name": "Brazilian Real",
					"symbol_native": "R$",
					"decimal_digits": 2,
					"rounding": 0.0,
					"code": "BRL",
					"name_plural": "Brazilian reals"
				},
				"BWP": {
					"symbol": "BWP",
					"name": "Botswanan Pula",
					"symbol_native": "P",
					"decimal_digits": 2,
					"rounding": 0.0,
					"code": "BWP",
					"name_plural": "Botswanan pulas"
				},
				"BYR": {
					"symbol": "BYR",
					"name": "Belarusian Ruble",
					"symbol_native": "BYR",
					"decimal_digits": 0,
					"rounding": 0.0,
					"code": "BYR",
					"name_plural": "Belarusian rubles"
				},
				"BZD": {
					"symbol": "BZD",
					"name": "Belize Dollar",
					"symbol_native": "$",
					"decimal_digits": 2,
					"rounding": 0.0,
					"code": "BZD",
					"name_plural": "Belize dollars"
				},
				"CAD": {
					"symbol": "CA$",
					"name": "Canadian Dollar",
					"symbol_native": "$",
					"decimal_digits": 2,
					"rounding": 0.0,
					"code": "CAD",
					"name_plural": "Canadian dollars"
				},
				"CDF": {
					"symbol": "CDF",
					"name": "Congolese Franc",
					"symbol_native": "CDF",
					"decimal_digits": 2,
					"rounding": 0.0,
					"code": "CDF",
					"name_plural": "Congolese francs"
				},
				"CHF": {
					"symbol": "CHF",
					"name": "Swiss Franc",
					"symbol_native": "CHF",
					"decimal_digits": 2,
					"rounding": 0.05,
					"code": "CHF",
					"name_plural": "Swiss francs"
				},
				"CLP": {
					"symbol": "CLP",
					"name": "Chilean Peso",
					"symbol_native": "$",
					"decimal_digits": 0,
					"rounding": 0.0,
					"code": "CLP",
					"name_plural": "Chilean pesos"
				},
				"CNY": {
					"symbol": "CN¥",
					"name": "Chinese Yuan",
					"symbol_native": "￥",
					"decimal_digits": 2,
					"rounding": 0.0,
					"code": "CNY",
					"name_plural": "Chinese yuan"
				},
				"COP": {
					"symbol": "COP",
					"name": "Colombian Peso",
					"symbol_native": "$",
					"decimal_digits": 0,
					"rounding": 0.0,
					"code": "COP",
					"name_plural": "Colombian pesos"
				},
				"CRC": {
					"symbol": "CRC",
					"name": "Costa Rican Colón",
					"symbol_native": "\u20A1",
					"decimal_digits": 0,
					"rounding": 0.0,
					"code": "CRC",
					"name_plural": "Costa Rican colóns"
				},
				"CVE": {
					"symbol": "CVE",
					"name": "Cape Verdean Escudo",
					"symbol_native": "CVE",
					"decimal_digits": 2,
					"rounding": 0.0,
					"code": "CVE",
					"name_plural": "Cape Verdean escudos"
				},
				"CZK": {
					"symbol": "CZK",
					"name": "Czech Republic Koruna",
					"symbol_native": "Kč",
					"decimal_digits": 2,
					"rounding": 0.0,
					"code": "CZK",
					"name_plural": "Czech Republic korunas"
				},
				"DJF": {
					"symbol": "DJF",
					"name": "Djiboutian Franc",
					"symbol_native": "Fdj",
					"decimal_digits": 0,
					"rounding": 0.0,
					"code": "DJF",
					"name_plural": "Djiboutian francs"
				},
				"DKK": {
					"symbol": "DKK",
					"name": "Danish Krone",
					"symbol_native": "kr",
					"decimal_digits": 2,
					"rounding": 0.0,
					"code": "DKK",
					"name_plural": "Danish kroner"
				},
				"DOP": {
					"symbol": "DOP",
					"name": "Dominican Peso",
					"symbol_native": "$",
					"decimal_digits": 2,
					"rounding": 0.0,
					"code": "DOP",
					"name_plural": "Dominican pesos"
				},
				"DZD": {
					"symbol": "DZD",
					"name": "Algerian Dinar",
					"symbol_native": "د.ج.\u200F",
					"decimal_digits": 2,
					"rounding": 0.0,
					"code": "DZD",
					"name_plural": "Algerian dinars"
				},
				"EGP": {
					"symbol": "EGP",
					"name": "Egyptian Pound",
					"symbol_native": "ج.م.\u200F",
					"decimal_digits": 2,
					"rounding": 0.0,
					"code": "EGP",
					"name_plural": "Egyptian pounds"
				},
				"ERN": {
					"symbol": "ERN",
					"name": "Eritrean Nakfa",
					"symbol_native": "Nfk",
					"decimal_digits": 2,
					"rounding": 0.0,
					"code": "ERN",
					"name_plural": "Eritrean nakfas"
				},
				"ETB": {
					"symbol": "ETB",
					"name": "Ethiopian Birr",
					"symbol_native": "ብር",
					"decimal_digits": 2,
					"rounding": 0.0,
					"code": "ETB",
					"name_plural": "Ethiopian birrs"
				},
				"EUR": {
					"symbol": "\u20AC",
					"name": "Euro",
					"symbol_native": "\u20AC",
					"decimal_digits": 2,
					"rounding": 0.0,
					"code": "EUR",
					"name_plural": "euros"
				},
				"GBP": {
					"symbol": "£",
					"name": "British Pound Sterling",
					"symbol_native": "£",
					"decimal_digits": 2,
					"rounding": 0.0,
					"code": "GBP",
					"name_plural": "British pounds sterling"
				},
				"GEL": {
					"symbol": "GEL",
					"name": "Georgian Lari",
					"symbol_native": "GEL",
					"decimal_digits": 2,
					"rounding": 0.0,
					"code": "GEL",
					"name_plural": "Georgian laris"
				},
				"GHS": {
					"symbol": "GHS",
					"name": "Ghanaian Cedi",
					"symbol_native": "GHS",
					"decimal_digits": 2,
					"rounding": 0.0,
					"code": "GHS",
					"name_plural": "Ghanaian cedis"
				},
				"GNF": {
					"symbol": "GNF",
					"name": "Guinean Franc",
					"symbol_native": "FG",
					"decimal_digits": 0,
					"rounding": 0.0,
					"code": "GNF",
					"name_plural": "Guinean francs"
				},
				"GTQ": {
					"symbol": "GTQ",
					"name": "Guatemalan Quetzal",
					"symbol_native": "Q",
					"decimal_digits": 2,
					"rounding": 0.0,
					"code": "GTQ",
					"name_plural": "Guatemalan quetzals"
				},
				"GYD": {
					"symbol": "GYD",
					"name": "Guyanaese Dollar",
					"symbol_native": "GYD",
					"decimal_digits": 0,
					"rounding": 0.0,
					"code": "GYD",
					"name_plural": "Guyanaese dollars"
				},
				"HKD": {
					"symbol": "HK$",
					"name": "Hong Kong Dollar",
					"symbol_native": "$",
					"decimal_digits": 2,
					"rounding": 0.0,
					"code": "HKD",
					"name_plural": "Hong Kong dollars"
				},
				"HNL": {
					"symbol": "HNL",
					"name": "Honduran Lempira",
					"symbol_native": "L",
					"decimal_digits": 2,
					"rounding": 0.0,
					"code": "HNL",
					"name_plural": "Honduran lempiras"
				},
				"HRK": {
					"symbol": "HRK",
					"name": "Croatian Kuna",
					"symbol_native": "kn",
					"decimal_digits": 2,
					"rounding": 0.0,
					"code": "HRK",
					"name_plural": "Croatian kunas"
				},
				"HUF": {
					"symbol": "HUF",
					"name": "Hungarian Forint",
					"symbol_native": "Ft",
					"decimal_digits": 0,
					"rounding": 0.0,
					"code": "HUF",
					"name_plural": "Hungarian forints"
				},
				"IDR": {
					"symbol": "IDR",
					"name": "Indonesian Rupiah",
					"symbol_native": "Rp",
					"decimal_digits": 0,
					"rounding": 0.0,
					"code": "IDR",
					"name_plural": "Indonesian rupiahs"
				},
				"ILS": {
					"symbol": "\u20AA",
					"name": "Israeli New Sheqel",
					"symbol_native": "\u20AA",
					"decimal_digits": 2,
					"rounding": 0.0,
					"code": "ILS",
					"name_plural": "Israeli new sheqels"
				},
				"INR": {
					"symbol": "\u20B9",
					"name": "Indian Rupee",
					"symbol_native": "\u20B9",
					"decimal_digits": 2,
					"rounding": 0.0,
					"code": "INR",
					"name_plural": "Indian rupees"
				},
				"IQD": {
					"symbol": "IQD",
					"name": "Iraqi Dinar",
					"symbol_native": "د.ع.\u200F",
					"decimal_digits": 0,
					"rounding": 0.0,
					"code": "IQD",
					"name_plural": "Iraqi dinars"
				},
				"IRR": {
					"symbol": "IRR",
					"name": "Iranian Rial",
					"symbol_native": "﷼",
					"decimal_digits": 0,
					"rounding": 0.0,
					"code": "IRR",
					"name_plural": "Iranian rials"
				},
				"ISK": {
					"symbol": "ISK",
					"name": "Icelandic Króna",
					"symbol_native": "kr",
					"decimal_digits": 0,
					"rounding": 0.0,
					"code": "ISK",
					"name_plural": "Icelandic krónur"
				},
				"JMD": {
					"symbol": "JMD",
					"name": "Jamaican Dollar",
					"symbol_native": "$",
					"decimal_digits": 2,
					"rounding": 0.0,
					"code": "JMD",
					"name_plural": "Jamaican dollars"
				},
				"JOD": {
					"symbol": "JOD",
					"name": "Jordanian Dinar",
					"symbol_native": "د.أ.\u200F",
					"decimal_digits": 3,
					"rounding": 0.0,
					"code": "JOD",
					"name_plural": "Jordanian dinars"
				},
				"JPY": {
					"symbol": "¥",
					"name": "Japanese Yen",
					"symbol_native": "￥",
					"decimal_digits": 0,
					"rounding": 0.0,
					"code": "JPY",
					"name_plural": "Japanese yen"
				},
				"KES": {
					"symbol": "KES",
					"name": "Kenyan Shilling",
					"symbol_native": "Ksh",
					"decimal_digits": 2,
					"rounding": 0.0,
					"code": "KES",
					"name_plural": "Kenyan shillings"
				},
				"KHR": {
					"symbol": "KHR",
					"name": "Cambodian Riel",
					"symbol_native": "៛",
					"decimal_digits": 2,
					"rounding": 0.0,
					"code": "KHR",
					"name_plural": "Cambodian riels"
				},
				"KMF": {
					"symbol": "KMF",
					"name": "Comorian Franc",
					"symbol_native": "CF",
					"decimal_digits": 0,
					"rounding": 0.0,
					"code": "KMF",
					"name_plural": "Comorian francs"
				},
				"KRW": {
					"symbol": "\u20A9",
					"name": "South Korean Won",
					"symbol_native": "\u20A9",
					"decimal_digits": 0,
					"rounding": 0.0,
					"code": "KRW",
					"name_plural": "South Korean won"
				},
				"KWD": {
					"symbol": "KWD",
					"name": "Kuwaiti Dinar",
					"symbol_native": "د.ك.\u200F",
					"decimal_digits": 3,
					"rounding": 0.0,
					"code": "KWD",
					"name_plural": "Kuwaiti dinars"
				},
				"KZT": {
					"symbol": "KZT",
					"name": "Kazakhstani Tenge",
					"symbol_native": "\u20B8",
					"decimal_digits": 2,
					"rounding": 0.0,
					"code": "KZT",
					"name_plural": "Kazakhstani tenges"
				},
				"LBP": {
					"symbol": "LBP",
					"name": "Lebanese Pound",
					"symbol_native": "ل.ل.\u200F",
					"decimal_digits": 0,
					"rounding": 0.0,
					"code": "LBP",
					"name_plural": "Lebanese pounds"
				},
				"LKR": {
					"symbol": "LKR",
					"name": "Sri Lankan Rupee",
					"symbol_native": "රු.",
					"decimal_digits": 2,
					"rounding": 0.0,
					"code": "LKR",
					"name_plural": "Sri Lankan rupees"
				},
				"LRD": {
					"symbol": "LRD",
					"name": "Liberian Dollar",
					"symbol_native": "$",
					"decimal_digits": 2,
					"rounding": 0.0,
					"code": "LRD",
					"name_plural": "Liberian dollars"
				},
				"LTL": {
					"symbol": "LTL",
					"name": "Lithuanian Litas",
					"symbol_native": "Lt",
					"decimal_digits": 2,
					"rounding": 0.0,
					"code": "LTL",
					"name_plural": "Lithuanian litai"
				},
				"LVL": {
					"symbol": "LVL",
					"name": "Latvian Lats",
					"symbol_native": "Ls",
					"decimal_digits": 2,
					"rounding": 0.0,
					"code": "LVL",
					"name_plural": "Latvian lati"
				},
				"LYD": {
					"symbol": "LYD",
					"name": "Libyan Dinar",
					"symbol_native": "د.ل.\u200F",
					"decimal_digits": 3,
					"rounding": 0.0,
					"code": "LYD",
					"name_plural": "Libyan dinars"
				},
				"MAD": {
					"symbol": "MAD",
					"name": "Moroccan Dirham",
					"symbol_native": "د.م.\u200F",
					"decimal_digits": 2,
					"rounding": 0.0,
					"code": "MAD",
					"name_plural": "Moroccan dirhams"
				},
				"MDL": {
					"symbol": "MDL",
					"name": "Moldovan Leu",
					"symbol_native": "MDL",
					"decimal_digits": 2,
					"rounding": 0.0,
					"code": "MDL",
					"name_plural": "Moldovan lei"
				},
				"MGA": {
					"symbol": "MGA",
					"name": "Malagasy Ariary",
					"symbol_native": "MGA",
					"decimal_digits": 0,
					"rounding": 0.0,
					"code": "MGA",
					"name_plural": "Malagasy Ariaries"
				},
				"MKD": {
					"symbol": "MKD",
					"name": "Macedonian Denar",
					"symbol_native": "MKD",
					"decimal_digits": 2,
					"rounding": 0.0,
					"code": "MKD",
					"name_plural": "Macedonian denari"
				},
				"MMK": {
					"symbol": "MMK",
					"name": "Myanma Kyat",
					"symbol_native": "K",
					"decimal_digits": 0,
					"rounding": 0.0,
					"code": "MMK",
					"name_plural": "Myanma kyats"
				},
				"MOP": {
					"symbol": "MOP",
					"name": "Macanese Pataca",
					"symbol_native": "MOP",
					"decimal_digits": 2,
					"rounding": 0.0,
					"code": "MOP",
					"name_plural": "Macanese patacas"
				},
				"MUR": {
					"symbol": "MUR",
					"name": "Mauritian Rupee",
					"symbol_native": "MUR",
					"decimal_digits": 0,
					"rounding": 0.0,
					"code": "MUR",
					"name_plural": "Mauritian rupees"
				},
				"MXN": {
					"symbol": "MX$",
					"name": "Mexican Peso",
					"symbol_native": "$",
					"decimal_digits": 2,
					"rounding": 0.0,
					"code": "MXN",
					"name_plural": "Mexican pesos"
				},
				"MYR": {
					"symbol": "MYR",
					"name": "Malaysian Ringgit",
					"symbol_native": "RM",
					"decimal_digits": 2,
					"rounding": 0.0,
					"code": "MYR",
					"name_plural": "Malaysian ringgits"
				},
				"MZN": {
					"symbol": "MZN",
					"name": "Mozambican Metical",
					"symbol_native": "MTn",
					"decimal_digits": 2,
					"rounding": 0.0,
					"code": "MZN",
					"name_plural": "Mozambican meticals"
				},
				"NAD": {
					"symbol": "NAD",
					"name": "Namibian Dollar",
					"symbol_native": "$",
					"decimal_digits": 2,
					"rounding": 0.0,
					"code": "NAD",
					"name_plural": "Namibian dollars"
				},
				"NGN": {
					"symbol": "NGN",
					"name": "Nigerian Naira",
					"symbol_native": "\u20A6",
					"decimal_digits": 2,
					"rounding": 0.0,
					"code": "NGN",
					"name_plural": "Nigerian nairas"
				},
				"NIO": {
					"symbol": "NIO",
					"name": "Nicaraguan Córdoba",
					"symbol_native": "C$",
					"decimal_digits": 2,
					"rounding": 0.0,
					"code": "NIO",
					"name_plural": "Nicaraguan córdobas"
				},
				"NOK": {
					"symbol": "NOK",
					"name": "Norwegian Krone",
					"symbol_native": "kr",
					"decimal_digits": 2,
					"rounding": 0.0,
					"code": "NOK",
					"name_plural": "Norwegian kroner"
				},
				"NPR": {
					"symbol": "NPR",
					"name": "Nepalese Rupee",
					"symbol_native": "नेरू",
					"decimal_digits": 2,
					"rounding": 0.0,
					"code": "NPR",
					"name_plural": "Nepalese rupees"
				},
				"NZD": {
					"symbol": "NZ$",
					"name": "New Zealand Dollar",
					"symbol_native": "$",
					"decimal_digits": 2,
					"rounding": 0.0,
					"code": "NZD",
					"name_plural": "New Zealand dollars"
				},
				"OMR": {
					"symbol": "OMR",
					"name": "Omani Rial",
					"symbol_native": "ر.ع.\u200F",
					"decimal_digits": 3,
					"rounding": 0.0,
					"code": "OMR",
					"name_plural": "Omani rials"
				},
				"PAB": {
					"symbol": "PAB",
					"name": "Panamanian Balboa",
					"symbol_native": "B\/.",
					"decimal_digits": 2,
					"rounding": 0.0,
					"code": "PAB",
					"name_plural": "Panamanian balboas"
				},
				"PEN": {
					"symbol": "PEN",
					"name": "Peruvian Nuevo Sol",
					"symbol_native": "S\/.",
					"decimal_digits": 2,
					"rounding": 0.0,
					"code": "PEN",
					"name_plural": "Peruvian nuevos soles"
				},
				"PHP": {
					"symbol": "PHP",
					"name": "Philippine Peso",
					"symbol_native": "\u20B1",
					"decimal_digits": 2,
					"rounding": 0.0,
					"code": "PHP",
					"name_plural": "Philippine pesos"
				},
				"PKR": {
					"symbol": "PKR",
					"name": "Pakistani Rupee",
					"symbol_native": "\u20A8",
					"decimal_digits": 0,
					"rounding": 0.0,
					"code": "PKR",
					"name_plural": "Pakistani rupees"
				},
				"PLN": {
					"symbol": "PLN",
					"name": "Polish Zloty",
					"symbol_native": "zł",
					"decimal_digits": 2,
					"rounding": 0.0,
					"code": "PLN",
					"name_plural": "Polish zlotys"
				},
				"PYG": {
					"symbol": "PYG",
					"name": "Paraguayan Guarani",
					"symbol_native": "\u20B2",
					"decimal_digits": 0,
					"rounding": 0.0,
					"code": "PYG",
					"name_plural": "Paraguayan guaranis"
				},
				"QAR": {
					"symbol": "QAR",
					"name": "Qatari Rial",
					"symbol_native": "ر.ق.\u200F",
					"decimal_digits": 2,
					"rounding": 0.0,
					"code": "QAR",
					"name_plural": "Qatari rials"
				},
				"RON": {
					"symbol": "RON",
					"name": "Romanian Leu",
					"symbol_native": "RON",
					"decimal_digits": 2,
					"rounding": 0.0,
					"code": "RON",
					"name_plural": "Romanian lei"
				},
				"RSD": {
					"symbol": "RSD",
					"name": "Serbian Dinar",
					"symbol_native": "дин.",
					"decimal_digits": 0,
					"rounding": 0.0,
					"code": "RSD",
					"name_plural": "Serbian dinars"
				},
				"RUB": {
					"symbol": "RUB",
					"name": "Russian Ruble",
					"symbol_native": "руб.",
					"decimal_digits": 2,
					"rounding": 0.0,
					"code": "RUB",
					"name_plural": "Russian rubles"
				},
				"RWF": {
					"symbol": "RWF",
					"name": "Rwandan Franc",
					"symbol_native": "FR",
					"decimal_digits": 0,
					"rounding": 0.0,
					"code": "RWF",
					"name_plural": "Rwandan francs"
				},
				"SAR": {
					"symbol": "SAR",
					"name": "Saudi Riyal",
					"symbol_native": "ر.س.\u200F",
					"decimal_digits": 2,
					"rounding": 0.0,
					"code": "SAR",
					"name_plural": "Saudi riyals"
				},
				"SDG": {
					"symbol": "SDG",
					"name": "Sudanese Pound",
					"symbol_native": "SDG",
					"decimal_digits": 2,
					"rounding": 0.0,
					"code": "SDG",
					"name_plural": "Sudanese pounds"
				},
				"SEK": {
					"symbol": "SEK",
					"name": "Swedish Krona",
					"symbol_native": "kr",
					"decimal_digits": 2,
					"rounding": 0.0,
					"code": "SEK",
					"name_plural": "Swedish kronor"
				},
				"SGD": {
					"symbol": "SGD",
					"name": "Singapore Dollar",
					"symbol_native": "SGD",
					"decimal_digits": 2,
					"rounding": 0.0,
					"code": "SGD",
					"name_plural": "Singapore dollars"
				},
				"SOS": {
					"symbol": "SOS",
					"name": "Somali Shilling",
					"symbol_native": "SOS",
					"decimal_digits": 0,
					"rounding": 0.0,
					"code": "SOS",
					"name_plural": "Somali shillings"
				},
				"STD": {
					"symbol": "STD",
					"name": "São Tomé and Príncipe Dobra",
					"symbol_native": "Db",
					"decimal_digits": 0,
					"rounding": 0.0,
					"code": "STD",
					"name_plural": "São Tomé and Príncipe dobras"
				},
				"SYP": {
					"symbol": "SYP",
					"name": "Syrian Pound",
					"symbol_native": "ل.س.\u200F",
					"decimal_digits": 0,
					"rounding": 0.0,
					"code": "SYP",
					"name_plural": "Syrian pounds"
				},
				"THB": {
					"symbol": "฿",
					"name": "Thai Baht",
					"symbol_native": "฿",
					"decimal_digits": 2,
					"rounding": 0.0,
					"code": "THB",
					"name_plural": "Thai baht"
				},
				"TND": {
					"symbol": "TND",
					"name": "Tunisian Dinar",
					"symbol_native": "د.ت.\u200F",
					"decimal_digits": 3,
					"rounding": 0.0,
					"code": "TND",
					"name_plural": "Tunisian dinars"
				},
				"TOP": {
					"symbol": "TOP",
					"name": "Tongan Paʻanga",
					"symbol_native": "T$",
					"decimal_digits": 2,
					"rounding": 0.0,
					"code": "TOP",
					"name_plural": "Tongan paʻanga"
				},
				"TRY": {
					"symbol": "TRY",
					"name": "Turkish Lira",
					"symbol_native": "TL",
					"decimal_digits": 2,
					"rounding": 0.0,
					"code": "TRY",
					"name_plural": "Turkish Lira"
				},
				"TTD": {
					"symbol": "TTD",
					"name": "Trinidad and Tobago Dollar",
					"symbol_native": "$",
					"decimal_digits": 2,
					"rounding": 0.0,
					"code": "TTD",
					"name_plural": "Trinidad and Tobago dollars"
				},
				"TWD": {
					"symbol": "NT$",
					"name": "New Taiwan Dollar",
					"symbol_native": "NT$",
					"decimal_digits": 2,
					"rounding": 0.0,
					"code": "TWD",
					"name_plural": "New Taiwan dollars"
				},
				"TZS": {
					"symbol": "TZS",
					"name": "Tanzanian Shilling",
					"symbol_native": "TSh",
					"decimal_digits": 0,
					"rounding": 0.0,
					"code": "TZS",
					"name_plural": "Tanzanian shillings"
				},
				"UAH": {
					"symbol": "UAH",
					"name": "Ukrainian Hryvnia",
					"symbol_native": "\u20B4",
					"decimal_digits": 2,
					"rounding": 0.0,
					"code": "UAH",
					"name_plural": "Ukrainian hryvnias"
				},
				"UGX": {
					"symbol": "UGX",
					"name": "Ugandan Shilling",
					"symbol_native": "USh",
					"decimal_digits": 0,
					"rounding": 0.0,
					"code": "UGX",
					"name_plural": "Ugandan shillings"
				},
				"USD": {
					"symbol": "$",
					"name": "US Dollar",
					"symbol_native": "$",
					"decimal_digits": 2,
					"rounding": 0.0,
					"code": "USD",
					"name_plural": "US dollars"
				},
				"UYU": {
					"symbol": "UYU",
					"name": "Uruguayan Peso",
					"symbol_native": "$",
					"decimal_digits": 2,
					"rounding": 0.0,
					"code": "UYU",
					"name_plural": "Uruguayan pesos"
				},
				"UZS": {
					"symbol": "UZS",
					"name": "Uzbekistan Som",
					"symbol_native": "UZS",
					"decimal_digits": 0,
					"rounding": 0.0,
					"code": "UZS",
					"name_plural": "Uzbekistan som"
				},
				"VEF": {
					"symbol": "VEF",
					"name": "Venezuelan Bolívar",
					"symbol_native": "Bs.F.",
					"decimal_digits": 2,
					"rounding": 0.0,
					"code": "VEF",
					"name_plural": "Venezuelan bolívars"
				},
				"VND": {
					"symbol": "\u20AB",
					"name": "Vietnamese Dong",
					"symbol_native": "\u20AB",
					"decimal_digits": 0,
					"rounding": 0.0,
					"code": "VND",
					"name_plural": "Vietnamese dong"
				},
				"XAF": {
					"symbol": "FCFA",
					"name": "CFA Franc BEAC",
					"symbol_native": "FCFA",
					"decimal_digits": 0,
					"rounding": 0.0,
					"code": "XAF",
					"name_plural": "CFA francs BEAC"
				},
				"XOF": {
					"symbol": "CFA",
					"name": "CFA Franc BCEAO",
					"symbol_native": "CFA",
					"decimal_digits": 0,
					"rounding": 0.0,
					"code": "XOF",
					"name_plural": "CFA francs BCEAO"
				},
				"YER": {
					"symbol": "YER",
					"name": "Yemeni Rial",
					"symbol_native": "ر.ي.\u200F",
					"decimal_digits": 0,
					"rounding": 0.0,
					"code": "YER",
					"name_plural": "Yemeni rials"
				},
				"ZAR": {
					"symbol": "ZAR",
					"name": "South African Rand",
					"symbol_native": "R",
					"decimal_digits": 2,
					"rounding": 0.0,
					"code": "ZAR",
					"name_plural": "South African rand"
				},
				"ZMK": {
					"symbol": "ZMK",
					"name": "Zambian Kwacha",
					"symbol_native": "ZK",
					"decimal_digits": 0,
					"rounding": 0.0,
					"code": "ZMK",
					"name_plural": "Zambian kwachas"
				}
			},
			BANK_KEY_LABEL_MAPPING: {
				"name": "Account Holder's Full Name",
				"receiverType": "Receiver Type",
				"bankCode": "Bank Code",
				"bankName": "Bank Name",
				"branchCode": "Branch Code",
				"accountNumber": "Account Number",
				"bsbCode": "BSB code",
				"institutionNumber": "Institution No",
				"transitNumber": "Transit Number",
				"accountType": "Account Type",
				"IBAN": "IBAN",
				"swiftCode": "Swift Code",
				"ifscCode": "IFSC Code",
				"routingNumber": "Routing Number",
				"abartn": "Routing Number",
				"recipientEmail": "Email",
				"targetCurrency": "Currency",
				"addressCountryCode": "Country",
				"addressCity": "City",
				"addressFirstLine": "Address",
				"addressPostCode": "Postal code",
				"addressPostCode_US": "Zip code",
				"addressState": "State",
				"cardNumber": "Card Number"
			},
			BANKS: {
				"PHP": [{
						"title": "AMA Bank",
						"code": "AMA"
					},
					{
						"title": "ANZ Bank",
						"code": "ANZ"
					},
					{
						"title": "Allied Bank",
						"code": "AB"
					},
					{
						"title": "Allied Savings Bank",
						"code": "ASB"
					},
					{
						"title": "Asia United Bank",
						"code": "AUB"
					},
					{
						"title": "BDO (Banco De Oro) Unibank",
						"code": "BDO"
					},
					{
						"title": "BPI Family Savings Bank",
						"code": "BPIF"
					},
					{
						"title": "Bangkok Bank",
						"code": "BANGK"
					},
					{
						"title": "Bank Of China",
						"code": "BCH"
					},
					{
						"title": "Bank One Savings and Trust Corp",
						"code": "BONE"
					},
					{
						"title": "Bank of Commerce",
						"code": "BOC"
					},
					{
						"title": "Bank of Tokyo",
						"code": "BOT"
					},
					{
						"title": "Bank of the Philippine Islands",
						"code": "BPI"
					},
					{
						"title": "CTBC",
						"code": "CTB"
					},
					{
						"title": "China Bank Savings",
						"code": "CBS"
					},
					{
						"title": "China Banking Corporation",
						"code": "CB"
					},
					{
						"title": "CitiBank Savings",
						"code": "CITIS"
					},
					{
						"title": "Citibank",
						"code": "CITI"
					},
					{
						"title": "City Estate Savings Bank",
						"code": "CITE"
					},
					{
						"title": "City Savings Bank",
						"code": "CITY"
					},
					{
						"title": "Deutsche Bank",
						"code": "DB"
					},
					{
						"title": "Development Bank of the Philippines",
						"code": "DBP"
					},
					{
						"title": "East West Bank",
						"code": "EWB"
					},
					{
						"title": "Equicom Savings Bank",
						"code": "EQSB"
					},
					{
						"title": "Far Eastern Bank",
						"code": "FEB"
					},
					{
						"title": "Filipino Savers Bank (A Rural Bank)",
						"code": "PILSB"
					},
					{
						"title": "First Allied Bank",
						"code": "FAB"
					},
					{
						"title": "First Consolidated Bank",
						"code": "FCB"
					},
					{
						"title": "First Macro Bank",
						"code": "FMB"
					},
					{
						"title": "Guagua Savers Bank",
						"code": "GSB"
					},
					{
						"title": "HSBC Savings",
						"code": "HSBCS"
					},
					{
						"title": "Hongkong & Shanghai Bank",
						"code": "HSBC"
					},
					{
						"title": "International Exchange Bank",
						"code": "IBANK"
					},
					{
						"title": "Islamic Bank (Al-Amanah Islamic Investment Bank)",
						"code": "ISLAM"
					},
					{
						"title": "Land Bank of the Philippines",
						"code": "LBP"
					},
					{
						"title": "Luzon Development Bank",
						"code": "LDB"
					},
					{
						"title": "Malayan Bank",
						"code": "MAL"
					},
					{
						"title": "MayBank Phils",
						"code": "MAY"
					},
					{
						"title": "Metropolitan Bank and Trust Company",
						"code": "MBTC"
					},
					{
						"title": "One Network Bank",
						"code": "ONB"
					},
					{
						"title": "Pen Bank",
						"code": "PBANK"
					},
					{
						"title": "Phil Business Bank",
						"code": "PBB"
					},
					{
						"title": "Phil National Bank",
						"code": "PNB"
					},
					{
						"title": "Philippine Bank of Communications",
						"code": "PBCOM"
					},
					{
						"title": "Philippine Savings Bank",
						"code": "PSB"
					},
					{
						"title": "Philippine Trust Company",
						"code": "PTB"
					},
					{
						"title": "Philippine Veterans Bank",
						"code": "PVB"
					},
					{
						"title": "Planters Bank",
						"code": "PLB"
					},
					{
						"title": "Postal Bank",
						"code": "POB"
					},
					{
						"title": "Premiere Bank",
						"code": "PRB"
					},
					{
						"title": "RCBC Savings",
						"code": "RCBCS"
					},
					{
						"title": "Rizal Commercial Banking Corp.",
						"code": "RCBC"
					},
					{
						"title": "Robinson Savings Bank",
						"code": "RSB"
					},
					{
						"title": "Security Bank Corporation",
						"code": "SB"
					},
					{
						"title": "Security Bank Savings",
						"code": "SBS"
					},
					{
						"title": "Standard Chartered Bank",
						"code": "SCB"
					},
					{
						"title": "Sterling Bank",
						"code": "STRBK"
					},
					{
						"title": "Summit Bank",
						"code": "SMB"
					},
					{
						"title": "Tong Yang Savings Bank",
						"code": "TYB"
					},
					{
						"title": "UCPB Savings Bank",
						"code": "UCPBS"
					},
					{
						"title": "Union Bank of the Philippines",
						"code": "UB"
					},
					{
						"title": "United Coconut Planters Bank",
						"code": "UCPB"
					},
					{
						"title": "United Overseas Bank",
						"code": "UOB"
					},
					{
						"title": "University Savings Bank",
						"code": "USB"
					}
				],
				"VND": [{
						"title": "Vietcombank - NGÂN HÀNG TMCP NGOẠI THƯƠNG VIỆT NAM [BFTVVNVX]",
						"code": "BFTVVNVX"
					},
					{
						"title": "NGÂN HÀNG TMCP AN BÌNH [ABBKVNVX]",
						"code": "ABBKVNVX"
					},
					{
						"title": "ACB - NGÂN HÀNG TMCP Á CHÂU [ASCBVNVX]",
						"code": "ASCBVNVX"
					},
					{
						"title": "VietinBank -  NGÂN HÀNG TMCP CÔNG THƯƠNG VIỆT NAM[SBITVNVX]",
						"code": "ICBVVNVX"
					},
					{
						"title": "TechcomBank -  NGÂN HÀNG TMCP KỸ THƯƠNG VIỆT NAM [VTCBVNVX]",
						"code": "VTCBVNVX"
					},
					{
						"title": "Agribank - NGÂN HÀNG NN & PHÁT TRIỂN NÔNG THÔN VIỆT NAM [VBAAVNVXXXX]",
						"code": "VBAAVNVXXXX"
					},
					{
						"title": "Sacombank - NGÂN HÀNG TMCP SÀI GÒN THƯƠNG TÍN [SGTTVNVX]",
						"code": "SGTTVNVX"
					},
					{
						"title": "BIDV - NGÂN HÀNG ĐẦU TƯ VÀ PHÁT TRIỂN VIỆT NAM [BIDVVNVX]",
						"code": "BIDVVNVX"
					},
					{
						"title": "EximBank NGÂN HÀNG TMCP XUẤT NHẬP KHẨU VIỆT NAM [EBVIVNVX]",
						"code": "EBVIVNVX"
					},
					{
						"title": "SCB - NGÂN HÀNG TMCP SÀI GÒN [SACLVNVX]",
						"code": "SACLVNVX"
					},
					{
						"title": "VIB - NGÂN HÀNG TMCP QUỐC TẾ VIỆT NAM [VNIBVNVX]",
						"code": "VNIBVNVX"
					},
					{
						"title": "Petrolimex -  TỔNG CÔNG TY TÀI CHÍNH CỔ PHẦN DẦU KHÍ VIỆT NAM [PGBLVNVX]",
						"code": "PGBLVNVX"
					},
					{
						"title": "MB - NGÂN HÀNG TMCP QUÂN ĐỘI [MSCBVNVX]",
						"code": "MSCBVNVX"
					},
					{
						"title": "SeABank - NGÂN HÀNG TMCP ĐÔNG NAM Á [SEAVVNVX]",
						"code": "SEAVVNVX"
					},
					{
						"title": "HSBC BANK - CHI NHÁNH HÀ NỘI [HSBCVNVH]",
						"code": "HSBCVNVH"
					},
					{
						"title": "HSBC BANK - CHI NHÁNH HỒ CHÍ MINH [HSBCVNVX]",
						"code": "HSBCVNVX"
					},
					{
						"title": "VPBank -  NGÂN HÀNG TMCP CÁC DN NGOÀI QUỐC DOANH VIỆT NAM [VPBKVNVX]",
						"code": "VPBKVNVX"
					},
					{
						"title": "Maritime Bank - Ngân hàng TMCP Hàng Hải Việt Nam [MCOBVNVX]",
						"code": "MCOBVNVX"
					},
					{
						"title": "DongA Bank - NGÂN HÀNG TMCP ĐÔNG Á [EACBVNVX]",
						"code": "EACBVNVX"
					},
					{
						"title": "ANZ BANK(VIETNAM) LIMITED [ANZBVNVX]",
						"code": "ANZBVNVX"
					},
					{
						"title": "BANGKOK BANK PCL [BKKBVNVX]",
						"code": "BKKBVNVX"
					},
					{
						"title": "BANK OF CHINA [BKCHVNVX]",
						"code": "BKCHVNVX"
					},
					{
						"title": "BANK OF COMMUNICATIONS CO.,LTDH [COMMVNVX]",
						"code": "COMMVNVX"
					},
					{
						"title": "BANK OF TOKYO-MITSUBISHI UFJ, LTD., THE [BOTKVNVX]",
						"code": "BOTKVNVX"
					},
					{
						"title": "BAOVIET JOINT STOCK COMMERCIAL BANK [BVBVVNVX]",
						"code": "BVBVVNVX"
					},
					{
						"title": "BNP PARIBAS VIETNAM [BNPAVNVN]",
						"code": "BNPAVNVN"
					},
					{
						"title": "CHINA CONSTRUCTION BANK CORPORATION [PCBCVNVX]",
						"code": "PCBCVNVX"
					},
					{
						"title": "CITIBANK N.A. [CITIVNVX]",
						"code": "CITIVNVX"
					},
					{
						"title": "COMMONWEALTH BANK OF AUSTRALIA HO CHI MINH CITY [CTBAVNVX]",
						"code": "CTBAVNVX"
					},
					{
						"title": "CREDIT AGRICOLE CIB [CAINVNVX]",
						"code": "CAINVNVX"
					},
					{
						"title": "CTBC BANK CO., LTD [CTCBVNVX]",
						"code": "CTCBVNVX"
					},
					{
						"title": "DBS BANK LTD [DBSSVNVX]",
						"code": "DBSSVNVX"
					},
					{
						"title": "DEUTSCHE BANK [DEUTVNVX]",
						"code": "DEUTVNVX"
					},
					{
						"title": "FAR EAST NATIONAL BANK [FENBVNVX]",
						"code": "FENBVNVX"
					},
					{
						"title": "FIRST COMMERCIAL BANK [FCBKVNVX]",
						"code": "FCBKVNVX"
					},
					{
						"title": "GLOBAL PETRO COMMERCIAL JOINT STOCK BANK [GBNKVNVX]",
						"code": "GBNKVNVX"
					},
					{
						"title": "HANA BANK HO CHI MINH CITY BRANCH [HNBNVNVX]",
						"code": "HNBNVNVX"
					},
					{
						"title": "HOCHIMINH CITY DEVELOPMENT JOINT STOCK COMMERCIAL BANK [HDBCVNVX]",
						"code": "HDBCVNVX"
					},
					{
						"title": "HONG LEONG BANK VIETNAM LIMITED [HLBBVNVX]",
						"code": "HLBBVNVX"
					},
					{
						"title": "HUA NAN COMMERCIAL BANK, LTD [HNBKVNVX]",
						"code": "HNBKVNVX"
					},
					{
						"title": "ICBC HANOI BRANCH [ICBKVNVN]",
						"code": "ICBKVNVN"
					},
					{
						"title": "INDOVINA BANK LTD. [IABBVNVX]",
						"code": "IABBVNVX"
					},
					{
						"title": "INDUSTRIAL BANK OF KOREA, VIETNAM [IBKOVNVX]",
						"code": "IBKOVNVX"
					},
					{
						"title": "JPMORGAN CHASE BANK, N.A. [CHASVNVX]",
						"code": "CHASVNVX"
					},
					{
						"title": "KIEN LONG COMMERCIAL JOINT STOCK BANK [KLBKVNVX]",
						"code": "KLBKVNVX"
					},
					{
						"title": "KOOKMIN BANK [CZNBVNVX]",
						"code": "CZNBVNVX"
					},
					{
						"title": "KOREA EXCHANGE BANKBRANCH [KOEXVNVX]",
						"code": "KOEXVNVX"
					},
					{
						"title": "LIEN VIET POST JOINT STOCK COMMERCIAL BANK [LVBKVNVX]",
						"code": "LVBKVNVX"
					},
					{
						"title": "MALAYAN BANKING BERHAD [MBBEVNVX]",
						"code": "MBBEVNVX"
					},
					{
						"title": "MEGA INTERNATIONAL COMMERCIAL BANK CO., LTD. [ICBCVNVX]",
						"code": "ICBCVNVX"
					},
					{
						"title": "MERCEDES-BENZ VIETNAM LTD. [DABEVNVX]",
						"code": "DABEVNVX"
					},
					{
						"title": "MIZUHO BANK, LTD. [MHCBVNVX]",
						"code": "MHCBVNVX"
					},
					{
						"title": "NAM A COMMERCIAL JOINT STOCK BANK [NAMAVNVX]",
						"code": "NAMAVNVX"
					},
					{
						"title": "NATIONAL CITIZEN COMMERCIAL JOINT STOCK BANK [NVBAVNVX]",
						"code": "NVBAVNVX"
					},
					{
						"title": "NATIXIS BRANCH IN HOCHIMINH CITY [BFCEVNVX]",
						"code": "BFCEVNVX"
					},
					{
						"title": "NORTH ASIA COMMERCIAL JOINT - STOCK BANK [NASCVNVX]",
						"code": "NASCVNVX"
					},
					{
						"title": "OCEAN COMMERCIAL JOINT STOCK BANK [OJBAVNVX]",
						"code": "OJBAVNVX"
					},
					{
						"title": "ORIENT COMMERCIAL JOINT STOCK BANK [ORCOVNVX]",
						"code": "ORCOVNVX"
					},
					{
						"title": "OVERSEA-CHINESE BANKING CORPORATION LIMITED [OCBCVNVX]",
						"code": "OCBCVNVX"
					},
					{
						"title": "SAI GON-HA NOI COMMERCIAL JOINT STOCK BANK [SHBAVNVX]",
						"code": "SHBAVNVX"
					},
					{
						"title": "SHINHAN BANK VIETNAM [SHBKVNVX]",
						"code": "SHBKVNVX"
					},
					{
						"title": "STANDARD CHARTERED BANK (VIETNAM) LIMITED [SCBLVNVX]",
						"code": "SCBLVNVX"
					},
					{
						"title": "STANDARD CHARTERED BANK [SCBLVNVH]",
						"code": "SCBLVNVH"
					},
					{
						"title": "SUMITOMO MITSUI BANKING CORPORATION [SMBCVNVX]",
						"code": "SMBCVNVX"
					},
					{
						"title": "SAIGON BANK FOR INDUSTRY AND TRADE THE in HO CHI MINH CITY",
						"code": "SBITVNVX"
					},
					{
						"title": "TAIPEI FUBON COMMERCIAL BANK [TPBKVNVX]",
						"code": "TPBKVNVX"
					},
					{
						"title": "THE BANK OF TOKYO-MITSUBISHI UFJ, LTD. [BOTKVNV5]",
						"code": "BOTKVNV5"
					},
					{
						"title": "THE SHANGHAI COMMERCIAL AND SAVINGS BANK, LTD [SCSBVNVX]",
						"code": "SCSBVNVX"
					},
					{
						"title": "TIENPHONG COMMERCIAL JOINT STOCK BANK [TPBVVNVX]",
						"code": "TPBVVNVX"
					},
					{
						"title": "UNITED OVERSEAS BANK LTD. [UOVBVNVX]",
						"code": "UOVBVNVX"
					},
					{
						"title": "VID PUBLIC BANK [VIDPVNV5]",
						"code": "VIDPVNV5"
					},
					{
						"title": "VIET CAPITAL COMMERCIAL JOINT STOCK BANK [VCBCVNVX]",
						"code": "VCBCVNVX"
					},
					{
						"title": "VIET NAM THUONG TIN COMMERCIAL JOINT STOCK BANK [VNTTVNVX]",
						"code": "VNTTVNVX"
					},
					{
						"title": "VIETNAM ASIA COMMERCIAL JOINT-STOCK BANK [VNACVNVX]",
						"code": "VNACVNVX"
					},
					{
						"title": "VIETNAM CONSTRUCTION JOINT STOCK COMMERCIAL BANK [GTBAVNVX]",
						"code": "GTBAVNVX"
					},
					{
						"title": "VIETNAM PUBLIC JOINT STOCK COMMERCIAL BANK (PVCOMBANK) [WBVNVNVX]",
						"code": "WBVNVNVX"
					},
					{
						"title": "VIETNAM RUSSIA JOINT VENTURE BANK [VRBAVNVX]",
						"code": "VRBAVNVX"
					},
					{
						"title": "VINASIAM BANK HOCHIMINH CITY [VNBKVNVX]",
						"code": "VNBKVNVX"
					},
					{
						"title": "WOORI BANK, HANOI [HVBKVNVX]",
						"code": "HVBKVNVX"
					},
					{
						"title": "WOORIBANK HOCHIMINH [HVBKVN2X]",
						"code": "HVBKVN2X"
					}
				],
				"BDT": [{
						"title": "AB BANK LTD.",
						"code": "020"
					},
					{
						"title": "AGRANI BANK LTD.",
						"code": "010"
					},
					{
						"title": "AL-ARAFAH ISLAMI BANK LTD.",
						"code": "015"
					},
					{
						"title": "BANGLADESH BANK",
						"code": "025"
					},
					{
						"title": "BANGLADESH COMMERCE BANK LTD.",
						"code": "030"
					},
					{
						"title": "BANGLADESH DEVELOPMENT BANK LTD.",
						"code": "047"
					},
					{
						"title": "BANGLADESH KRISHI BANK",
						"code": "035"
					},
					{
						"title": "BANGLADESH SAMABAYA BANK LTD.",
						"code": "040"
					},
					{
						"title": "BANK AL-FALAH LTD",
						"code": "065"
					},
					{
						"title": "BANK ASIA LTD.",
						"code": "070"
					},
					{
						"title": "BASIC BANK LTD.",
						"code": "055"
					},
					{
						"title": "BRAC BANK LTD.",
						"code": "060"
					},
					{
						"title": "CITI BANK N A",
						"code": "075"
					},
					{
						"title": "COMMERCIAL BANK OF CYLON",
						"code": "080"
					},
					{
						"title": "DHAKA BANK LTD.",
						"code": "085"
					},
					{
						"title": "DUTCH-BANGLA BANK LTD",
						"code": "090"
					},
					{
						"title": "EASTERN BANK LTD.",
						"code": "095"
					},
					{
						"title": "EXIM BANK LTD.",
						"code": "100"
					},
					{
						"title": "FIRST SECURITY ISLAMI BANK LTD.",
						"code": "105"
					},
					{
						"title": "HABIB BANK LTD.",
						"code": "110"
					},
					{
						"title": "HONGKONG & SHANGHAI BANKING CORP.",
						"code": "115"
					},
					{
						"title": "ICB ISLAMIC BANK LTD",
						"code": "230"
					},
					{
						"title": "IFIC BANK LTD.",
						"code": "120"
					},
					{
						"title": "ISLAMI BANK BANGLDESH LTD.",
						"code": "125"
					},
					{
						"title": "JAMUNA BANK LTD.",
						"code": "130"
					},
					{
						"title": "JANATA BANK LTD.",
						"code": "135"
					},
					{
						"title": "MEGHNA BANK LIMITED",
						"code": "275"
					},
					{
						"title": "MERCANTILE BANK LTD.",
						"code": "140"
					},
					{
						"title": "MIDLAND BANK LIMITED",
						"code": "285"
					},
					{
						"title": "MODHUMOTI BANK LIMITED",
						"code": "295"
					},
					{
						"title": "MUTUAL TRUST BANK LTD.",
						"code": "145"
					},
					{
						"title": "NATIONAL BANK LTD.",
						"code": "150"
					},
					{
						"title": "NATIONAL BANK OF PAKISTAN",
						"code": "155"
					},
					{
						"title": "NATIONAL CREDIT & COMMERCE BANK LTD.",
						"code": "160"
					},
					{
						"title": "NRB BANK LIMITED",
						"code": "290"
					},
					{
						"title": "NRB COMMERCIAL BANK LTD.",
						"code": "260"
					},
					{
						"title": "NRB GLOBAL BANK LIMITED",
						"code": "300"
					},
					{
						"title": "ONE BANK LTD.",
						"code": "165"
					},
					{
						"title": "PRIME BANK LTD.",
						"code": "170"
					},
					{
						"title": "PUBALI BANK LTD.",
						"code": "175"
					},
					{
						"title": "RAJSHAHI KRISHI UNNAYAN BANK",
						"code": "180"
					},
					{
						"title": "RUPALI BANK LTD.",
						"code": "185"
					},
					{
						"title": "SBAC BANK LIMITED",
						"code": "270"
					},
					{
						"title": "SHAHJALAL ISLAMI BANK LTD.",
						"code": "190"
					},
					{
						"title": "SOCIAL ISLAMI BANK LTD",
						"code": "195"
					},
					{
						"title": "SONALI BANK LTD.",
						"code": "200"
					},
					{
						"title": "SOUTHEAST BANK LTD.",
						"code": "205"
					},
					{
						"title": "STANDARD BANK LTD.",
						"code": "210"
					},
					{
						"title": "STANDARD CHARTERED BANK",
						"code": "215"
					},
					{
						"title": "STATE BANK OF INDIA",
						"code": "220"
					},
					{
						"title": "THE CITY BANK LTD.",
						"code": "225"
					},
					{
						"title": "THE FARMERS BANK LIMITED",
						"code": "280"
					},
					{
						"title": "THE PREMIER BANK LTD.",
						"code": "235"
					},
					{
						"title": "TRUST BANK LTD.",
						"code": "240"
					},
					{
						"title": "UNION BANK LTD.",
						"code": "265"
					},
					{
						"title": "UNITED COMMERCIAL BANK LTD.",
						"code": "245"
					},
					{
						"title": "UTTARA BANK LTD.",
						"code": "250"
					},
					{
						"title": "WOORI BANK",
						"code": "255"
					}
				],
				"HKD": [{
						"title": "AAREAL BANK AG, WIESBADEN, GERMANY [552]",
						"code": "552"
					},
					{
						"title": "ABN AMRO BANK N.V. [307]",
						"code": "307"
					},
					{
						"title": "AGRICULTURAL BANK OF CHINA LIMITED FRANKFURT BRANCH [A10]",
						"code": "A10"
					},
					{
						"title": "AGRICULTURAL BANK OF CHINA LIMITED [222]",
						"code": "222"
					},
					{
						"title": "AGRICULTURAL BANK OF CHINA LIMITED, SINGAPORE BRANCH [340]",
						"code": "340"
					},
					{
						"title": "AGRICULTURAL BANK OF CHINA, BEIJING [400]",
						"code": "400"
					},
					{
						"title": "ALLAHABAD BANK [256]",
						"code": "256"
					},
					{
						"title": "ALLIED BANKING CORPORATION (HK) LTD. [402]",
						"code": "402"
					},
					{
						"title": "AUSTRALIA AND NEW ZEALAND BANKING GROUP LTD [152]",
						"code": "152"
					},
					{
						"title": "AUTORIDADE MONETARIA DE MACAU, MACAU [404]",
						"code": "404"
					},
					{
						"title": "AXIS BANK LIMITED [261]",
						"code": "261"
					},
					{
						"title": "BANCA MONTE DEI PASCHI DI SIENA S.P.A. - HONG KONG BRANCH [234]",
						"code": "234"
					},
					{
						"title": "BANCO BILBAO VIZCAYA ARGENTARIA, S.A. [147]",
						"code": "147"
					},
					{
						"title": "BANCO DO BRASIL S. A., TOKYO BRANCH [356]",
						"code": "356"
					},
					{
						"title": "BANCO NACIONAL ULTRAMARINO S.A. MACAU BRANCH [406]",
						"code": "406"
					},
					{
						"title": "BANCO SANTANDER, S.A. [267]",
						"code": "267"
					},
					{
						"title": "BANGKOK BANK PUBLIC COMPANY LTD [049]",
						"code": "049"
					},
					{
						"title": "BANK FOR FOREIGN TRADE OF VIETNAM [553]",
						"code": "553"
					},
					{
						"title": "BANK J. SAFRA SARASIN LTD [278]",
						"code": "278"
					},
					{
						"title": "BANK JULIUS BAER & CO. LTD. [320]",
						"code": "320"
					},
					{
						"title": "BANK OF AMERICA, NATIONAL ASSOCIATION [055]",
						"code": "055"
					},
					{
						"title": "BANK OF BARODA  [259]",
						"code": "259"
					},
					{
						"title": "BANK OF CHINA (AUSTRALIA) LIMITED [315]",
						"code": "315"
					},
					{
						"title": "BANK OF CHINA (BRASIL) S.A. [326]",
						"code": "326"
					},
					{
						"title": "BANK OF CHINA (CANADA) [310]",
						"code": "310"
					},
					{
						"title": "BANK OF CHINA (ELUOSI) [283]",
						"code": "283"
					},
					{
						"title": "BANK OF CHINA (HK) LTD. RMB FIDUCIARY ACCOUNT [833]",
						"code": "833"
					},
					{
						"title": "BANK OF CHINA (HONG KONG) LIMITED - RMB CLEARING BANK [838]",
						"code": "838"
					},
					{
						"title": "BANK OF CHINA (HONG KONG) LIMITED [012]",
						"code": "012"
					},
					{
						"title": "BANK OF CHINA (HONG KONG) LIMITED [014]",
						"code": "014"
					},
					{
						"title": "BANK OF CHINA (HONG KONG) LIMITED [019]",
						"code": "019"
					},
					{
						"title": "BANK OF CHINA (HONG KONG) LIMITED [026]",
						"code": "026"
					},
					{
						"title": "BANK OF CHINA (HONG KONG) LIMITED [030]",
						"code": "030"
					},
					{
						"title": "BANK OF CHINA (HONG KONG) LIMITED [031]",
						"code": "031"
					},
					{
						"title": "BANK OF CHINA (HONG KONG) LIMITED [033]",
						"code": "033"
					},
					{
						"title": "BANK OF CHINA (HONG KONG) LIMITED [036]",
						"code": "036"
					},
					{
						"title": "BANK OF CHINA (HONG KONG) LIMITED [064]",
						"code": "064"
					},
					{
						"title": "BANK OF CHINA (HONG KONG) LIMITED [070]",
						"code": "070"
					},
					{
						"title": "BANK OF CHINA (HUNGARY) CLOSE LIMITED [290]",
						"code": "290"
					},
					{
						"title": "BANK OF CHINA (MALAYSIA) BERHAD [282]",
						"code": "282"
					},
					{
						"title": "BANK OF CHINA (NEW ZEALAND) LIMITED [A14]",
						"code": "A14"
					},
					{
						"title": "BANK OF CHINA (THAI) PUBLIC COMPANY LIMITED  [289]",
						"code": "289"
					},
					{
						"title": "BANK OF CHINA (UK) LIMITED [314]",
						"code": "314"
					},
					{
						"title": "BANK OF CHINA (ZAMBIA) LIMITED [306]",
						"code": "306"
					},
					{
						"title": "BANK OF CHINA INTERNATIONAL LIMITED [321]",
						"code": "321"
					},
					{
						"title": "BANK OF CHINA LIMITED FRANKFURT BRANCH [287]",
						"code": "287"
					},
					{
						"title": "BANK OF CHINA LIMITED GRAND CAYMAN BRANCH [302]",
						"code": "302"
					},
					{
						"title": "BANK OF CHINA LIMITED HUNGARIAN BRANCH [A15]",
						"code": "A15"
					},
					{
						"title": "BANK OF CHINA LIMITED JAKARTA BRANCH [284]",
						"code": "284"
					},
					{
						"title": "BANK OF CHINA LIMITED JOHANNESBURG BRANCH [298]",
						"code": "298"
					},
					{
						"title": "BANK OF CHINA LIMITED LUXEMBOURG BRANCH [301]",
						"code": "301"
					},
					{
						"title": "BANK OF CHINA LIMITED MACAU BRANCH [420]",
						"code": "420"
					},
					{
						"title": "BANK OF CHINA LIMITED MANILA BRANCH [279]",
						"code": "279"
					},
					{
						"title": "BANK OF CHINA LIMITED MILAN BRANCH [291]",
						"code": "291"
					},
					{
						"title": "BANK OF CHINA LIMITED NEW YORK BRANCH [304]",
						"code": "304"
					},
					{
						"title": "BANK OF CHINA LIMITED PARIS BRANCH [303]",
						"code": "303"
					},
					{
						"title": "BANK OF CHINA LIMITED PHNOM PENH BRANCH [327]",
						"code": "327"
					},
					{
						"title": "BANK OF CHINA LIMITED SEOUL BRANCH [285]",
						"code": "285"
					},
					{
						"title": "BANK OF CHINA LIMITED SINGAPORE BRANCH [286]",
						"code": "286"
					},
					{
						"title": "BANK OF CHINA LIMITED SYDNEY BRANCH [288]",
						"code": "288"
					},
					{
						"title": "BANK OF CHINA LIMITED TAIPEI BRANCH [A00]",
						"code": "A00"
					},
					{
						"title": "BANK OF CHINA LIMITED TOKYO BRANCH [280]",
						"code": "280"
					},
					{
						"title": "BANK OF CHINA LIMITED, HEAD OFFICE [414]",
						"code": "414"
					},
					{
						"title": "BANK OF CHINA LIMITED, HONG KONG BRANCH [338]",
						"code": "338"
					},
					{
						"title": "BANK OF CHINA LIMITED, PANAMA BRANCH [311]",
						"code": "311"
					},
					{
						"title": "BANK OF CHINA LONDON BRANCH [292]",
						"code": "292"
					},
					{
						"title": "BANK OF CHINA LTD. - ABU DHABI [A12]",
						"code": "A12"
					},
					{
						"title": "BANK OF CHINA MIDDLE EAST (DUBAI) LIMITED [369]",
						"code": "369"
					},
					{
						"title": "BANK OF CHINA, HO CHI MINH CITY BRANCH [348]",
						"code": "348"
					},
					{
						"title": "BANK OF CHINA, LUXEMBOURG S.A. [300]",
						"code": "300"
					},
					{
						"title": "BANK OF COMMUNICATIONS CO., LTD. HEAD OFFICE, SHANGHAI [428]",
						"code": "428"
					},
					{
						"title": "BANK OF COMMUNICATIONS CO., LTD. SHENZHEN BRANCH [429]",
						"code": "429"
					},
					{
						"title": "BANK OF COMMUNICATIONS CO., LTD. [027]",
						"code": "027"
					},
					{
						"title": "BANK OF COMMUNICATIONS SEOUL BRANCH [349]",
						"code": "349"
					},
					{
						"title": "BANK OF HANGZHOU, HANGZHOU [555]",
						"code": "555"
					},
					{
						"title": "BANK OF INDIA [058]",
						"code": "058"
					},
					{
						"title": "BANK OF JIANGSU CO. LTD., NANJING [506]",
						"code": "506"
					},
					{
						"title": "BANK OF MONTREAL [086]",
						"code": "086"
					},
					{
						"title": "BANK OF MONTREAL, GUANGZHOU BRANCH [542]",
						"code": "542"
					},
					{
						"title": "BANK OF NINGBO CO. LTD., ZHEJIANG [478]",
						"code": "478"
					},
					{
						"title": "BANK OF SHANGHAI (HONG KONG) LIMITED [372]",
						"code": "372"
					},
					{
						"title": "BANK OF SINGAPORE LIMITED [272]",
						"code": "272"
					},
					{
						"title": "BANK OF TAIWAN [201]",
						"code": "201"
					},
					{
						"title": "BANK SINOPAC [241]",
						"code": "241"
					},
					{
						"title": "BANK SINOPAC [244]",
						"code": "244"
					},
					{
						"title": "BANK SINOPAC, LOS ANGELES BRANCH [355]",
						"code": "355"
					},
					{
						"title": "BANK SINOPAC, TAIPEI [431]",
						"code": "431"
					},
					{
						"title": "BARCLAYS BANK PLC [074]",
						"code": "074"
					},
					{
						"title": "BDO UNIBANK, INC. [067]",
						"code": "067"
					},
					{
						"title": "BNP PARIBAS SECURITIES SERVICES [275]",
						"code": "275"
					},
					{
						"title": "BNP PARIBAS WEALTH MANAGEMENT [240]",
						"code": "240"
					},
					{
						"title": "BNP PARIBAS [056]",
						"code": "056"
					},
					{
						"title": "BOC CREDIT CARD (INTERNATIONAL) LIMITED [252]",
						"code": "252"
					},
					{
						"title": "BSI LTD [350]",
						"code": "350"
					},
					{
						"title": "CAMBODIA MEKONG BANK PUBLIC LIMITED [351]",
						"code": "351"
					},
					{
						"title": "CANADIAN IMPERIAL BANK OF COMMERCE [092]",
						"code": "092"
					},
					{
						"title": "CANADIAN IMPERIAL BANK OF COMMERCE, CANADA [366]",
						"code": "366"
					},
					{
						"title": "CANARA BANK [262]",
						"code": "262"
					},
					{
						"title": "CATHAY BANK  [263]",
						"code": "263"
					},
					{
						"title": "CATHAY UNITED BANK COMPANY, LIMITED [236]",
						"code": "236"
					},
					{
						"title": "CHANG HWA COMMERCIAL BANK LTD [206]",
						"code": "206"
					},
					{
						"title": "CHANGSHA CITY COMMERCIAL BANK [529]",
						"code": "529"
					},
					{
						"title": "CHINA CITIC BANK INTERNATIONAL LIMITED [018]",
						"code": "018"
					},
					{
						"title": "CHINA CITIC BANK INTERNATIONAL LIMITED [051]",
						"code": "051"
					},
					{
						"title": "CHINA CITIC BANK, BEIJING [437]",
						"code": "437"
					},
					{
						"title": "CHINA CONSTRUCTION BANK (ASIA) CORPORATION LIMITED [009]",
						"code": "009"
					},
					{
						"title": "CHINA CONSTRUCTION BANK CORPORATION [221]",
						"code": "221"
					},
					{
						"title": "CHINA CONSTRUCTION BANK SEOUL BRANCH [358]",
						"code": "358"
					},
					{
						"title": "CHINA DEVELOPMENT BANK CORPORATION [276]",
						"code": "276"
					},
					{
						"title": "CHINA EVERBRIGHT BANK CO., LTD [368]",
						"code": "368"
					},
					{
						"title": "CHINA EVERBRIGHT BANK, BEIJING  [434]",
						"code": "434"
					},
					{
						"title": "CHINA GUANGFA BANK CO. LTD, BEIJING [447]",
						"code": "447"
					},
					{
						"title": "CHINA GUANGFA BANK CO., LTD. GUANGZHOU [549]",
						"code": "549"
					},
					{
						"title": "CHINA MERCHANTS BANK CO., LTD, SINGAPORE BRANCH [A09]",
						"code": "A09"
					},
					{
						"title": "CHINA MERCHANTS BANK CO., LTD. [238]",
						"code": "238"
					},
					{
						"title": "CHINA MERCHANTS BANK, HEAD OFFICE, SHENZHEN [435]",
						"code": "435"
					},
					{
						"title": "CHINA MINSHENG BANKING CORP., LTD. [353]",
						"code": "353"
					},
					{
						"title": "CHINA MINSHENG BANKING CORPORATION LTD., BEIJING [436]",
						"code": "436"
					},
					{
						"title": "CHINA RESOURCES BANK OF ZHUHAI CO LTD., ZHUHAI [507]",
						"code": "507"
					},
					{
						"title": "CHIYU BANKING CORPORATION LTD [039]",
						"code": "039"
					},
					{
						"title": "CHONG HING BANK LTD [041]",
						"code": "041"
					},
					{
						"title": "CIMB BANK BERHAD [374]",
						"code": "374"
					},
					{
						"title": "CIMB THAI BANK PUBLIC COMPANY LIMITED [343]",
						"code": "343"
					},
					{
						"title": "CITIBANK (CHINA) CO LTD, SHENZHEN BRANCH [531]",
						"code": "531"
					},
					{
						"title": "CITIBANK (HONG KONG) LIMITED [250]",
						"code": "250"
					},
					{
						"title": "CITIBANK N.A. [006]",
						"code": "006"
					},
					{
						"title": "COMMERZBANK AG [097]",
						"code": "097"
					},
					{
						"title": "COMMONWEALTH BANK OF AUSTRALIA [153]",
						"code": "153"
					},
					{
						"title": "CONCORD BANK LTD., NINGBO [524]",
						"code": "524"
					},
					{
						"title": "CONTINUOUS LINKED SETTLEMENT BANK INTERNATIONAL [868]",
						"code": "868"
					},
					{
						"title": "COOPERATIEVE CENTRALE RAIFFEISEN-BOERENLEENBANK B.A.  [183]",
						"code": "183"
					},
					{
						"title": "COOPERATIEVE CENTRALE RAIFFEISEN-BOERENLEENBANK B.A. (TRADIN [323]",
						"code": "323"
					},
					{
						"title": "COOPERATIEVE CENTRALE RAIFFEISEN-BOERENLEENBANK B.A.(TRADING [319]",
						"code": "319"
					},
					{
						"title": "COUTTS & CO LTD [205]",
						"code": "205"
					},
					{
						"title": "COUTTS AND CO. LTD., SINGAPORE [513]",
						"code": "513"
					},
					{
						"title": "CREDIT AGRICOLE (SUISSE) S.A. [339]",
						"code": "339"
					},
					{
						"title": "CREDIT AGRICOLE CORPORATE AND INVESTMENT BANK [005]",
						"code": "005"
					},
					{
						"title": "CREDIT SUISSE AG [233]",
						"code": "233"
					},
					{
						"title": "CTBC BANK CO., LTD. [229]",
						"code": "229"
					},
					{
						"title": "DAH SING BANK LTD [040]",
						"code": "040"
					},
					{
						"title": "DBS BANK (HONG KONG) LIMITED [016]",
						"code": "016"
					},
					{
						"title": "DBS BANK (HONG KONG) LIMITED [032]",
						"code": "032"
					},
					{
						"title": "DBS BANK (HONG KONG) LIMITED [052]",
						"code": "052"
					},
					{
						"title": "DBS BANK LTD, HONG KONG BRANCH [185]",
						"code": "185"
					},
					{
						"title": "DEUTSCHE BANK AG [054]",
						"code": "054"
					},
					{
						"title": "DNB NOR BANK ASA, SINGAPORE BRANCH [328]",
						"code": "328"
					},
					{
						"title": "DONGGUAN RURAL CREDIT COOPERATIVES UNION, DONGGUAN [439]",
						"code": "439"
					},
					{
						"title": "DZ BANK AG DEUTSCHE ZENTRAL-GENOSSENSCHAFTSBANK [113]",
						"code": "113"
					},
					{
						"title": "E.SUN COMMERCIAL BANK, LTD [243]",
						"code": "243"
					},
					{
						"title": "E.SUN COMMERCIAL BANK, LTD., TAIPEI [557]",
						"code": "557"
					},
					{
						"title": "EAST WEST BANK [258]",
						"code": "258"
					},
					{
						"title": "EDMOND DE ROTHSCHILD (SUISSE) S.A. [346]",
						"code": "346"
					},
					{
						"title": "EFG BANK AG [237]",
						"code": "237"
					},
					{
						"title": "ERSTE GROUP BANK AG [227]",
						"code": "227"
					},
					{
						"title": "EXPORT-IMPORT BANK OF THAILAND, BANGKOK [440]",
						"code": "440"
					},
					{
						"title": "FALCON PRIVATE BANK LTD. [253]",
						"code": "253"
					},
					{
						"title": "FAR EASTERN INTERNATIONAL BANK [260]",
						"code": "260"
					},
					{
						"title": "FINABANK N.V. [362]",
						"code": "362"
					},
					{
						"title": "FIRST COMMERCIAL BANK [203]",
						"code": "203"
					},
					{
						"title": "FUBON BANK (HONG KONG) LIMITED [128]",
						"code": "128"
					},
					{
						"title": "GRANIT BANK ZRT [325]",
						"code": "325"
					},
					{
						"title": "GUIYANG COMMERCIAL BANK, GUIYANG [540]",
						"code": "540"
					},
					{
						"title": "HABIB BANK ZURICH (HONG KONG) LIMITED [322]",
						"code": "322"
					},
					{
						"title": "HANA BANK [112]",
						"code": "112"
					},
					{
						"title": "HANG SENG BANK LTD [024]",
						"code": "024"
					},
					{
						"title": "HDFC BANK LTD. [308]",
						"code": "308"
					},
					{
						"title": "HONG KONG MONETARY AUTHORITY [888]",
						"code": "888"
					},
					{
						"title": "HONG LEONG BANK BERHAD [248]",
						"code": "248"
					},
					{
						"title": "HSBC - THE HONGKONG AND SHANGHAI BANKING CORPORATION LTD [004]",
						"code": "004"
					},
					{
						"title": "HSBC BANGLADESH [450]",
						"code": "450"
					},
					{
						"title": "HSBC BANK (CHINA) COMPANY LIMITED [461]",
						"code": "461"
					},
					{
						"title": "HSBC BANK (TAIWAN) LIMITED [464]",
						"code": "464"
					},
					{
						"title": "HSBC BANK MALAYSIA BERHAD [457]",
						"code": "457"
					},
					{
						"title": "HSBC BANK PLC [347]",
						"code": "347"
					},
					{
						"title": "HSBC BANK USA, NATIONAL ASSOCIATION [106]",
						"code": "106"
					},
					{
						"title": "HSBC BANK VIETNAM LTD [466]",
						"code": "466"
					},
					{
						"title": "HSBC BRUNEI [451]",
						"code": "451"
					},
					{
						"title": "HSBC INDIA [452]",
						"code": "452"
					},
					{
						"title": "HSBC INDONESIA [453]",
						"code": "453"
					},
					{
						"title": "HSBC JAPAN [454]",
						"code": "454"
					},
					{
						"title": "HSBC MACAU [456]",
						"code": "456"
					},
					{
						"title": "HSBC MANILA [458]",
						"code": "458"
					},
					{
						"title": "HSBC PRIVATE BANK (SUISSE) SA [235]",
						"code": "235"
					},
					{
						"title": "HSBC SEOUL BRANCH [460]",
						"code": "460"
					},
					{
						"title": "HSBC SINGAPORE [462]",
						"code": "462"
					},
					{
						"title": "HSBC SRI LANKA [463]",
						"code": "463"
					},
					{
						"title": "HSBC THAILAND [465]",
						"code": "465"
					},
					{
						"title": "HUA NAN COMMERCIAL BANK LTD [198]",
						"code": "198"
					},
					{
						"title": "HUA NAN COMMERCIAL BANK LTD., TAIPEI [550]",
						"code": "550"
					},
					{
						"title": "HUA XIA BANK, BEIJING [468]",
						"code": "468"
					},
					{
						"title": "ICBC STANDARD BANK PLC [341]",
						"code": "341"
					},
					{
						"title": "ICICI BANK LIMITED [251]",
						"code": "251"
					},
					{
						"title": "INDIAN OVERSEAS BANK [050]",
						"code": "050"
					},
					{
						"title": "INDUSTRIAL AND COMMERCIAL BANK OF CHINA (ASIA) LTD  [029]",
						"code": "029"
					},
					{
						"title": "INDUSTRIAL AND COMMERCIAL BANK OF CHINA (ASIA) LTD  [072]",
						"code": "072"
					},
					{
						"title": "INDUSTRIAL AND COMMERCIAL BANK OF CHINA (MACAU) LIMITED, MAC [483]",
						"code": "483"
					},
					{
						"title": "INDUSTRIAL AND COMMERCIAL BANK OF CHINA (MALAYSIA) BERHAD [330]",
						"code": "330"
					},
					{
						"title": "INDUSTRIAL AND COMMERCIAL BANK OF CHINA LIMITED [214]",
						"code": "214"
					},
					{
						"title": "INDUSTRIAL AND COMMERCIAL BANK OF CHINA, BEIJING [469]",
						"code": "469"
					},
					{
						"title": "INDUSTRIAL BANK CO., LTD. [377]",
						"code": "377"
					},
					{
						"title": "INDUSTRIAL BANK COMPANY LTD., FUZHOU [445]",
						"code": "445"
					},
					{
						"title": "INDUSTRIAL BANK OF KOREA [271]",
						"code": "271"
					},
					{
						"title": "INDUSTRIAL BANK OF TAIWAN CO., LTD. [274]",
						"code": "274"
					},
					{
						"title": "INDUSTRIAL BANK OF TAIWAN, TAIPEI [470]",
						"code": "470"
					},
					{
						"title": "ING BANK N.V. [145]",
						"code": "145"
					},
					{
						"title": "INTESA SANPAOLO S.P.A. [161]",
						"code": "161"
					},
					{
						"title": "J.P. MORGAN SECURITIES (ASIA PACIFIC) LIMITED [375]",
						"code": "375"
					},
					{
						"title": "JIANG YIN RURAL COMMERCIAL BANK, JIANG YIN CITY, JIANG SU  [541]",
						"code": "541"
					},
					{
						"title": "JOINT STOCK COMMERCIAL BANK \"LANTA-BANK\" (CJSC) [317]",
						"code": "317"
					},
					{
						"title": "JOINT STOCK COMMERCIAL BANK FOR INVESTMENT AND DEVELOPMENT O [407]",
						"code": "407"
					},
					{
						"title": "JPMORGAN CHASE BANK [007]",
						"code": "007"
					},
					{
						"title": "JSC AB (BANK OF CHINA KAZAKHSTAN) [305]",
						"code": "305"
					},
					{
						"title": "JSC CAPITAL BANK [A06]",
						"code": "A06"
					},
					{
						"title": "KASIKORNBANK PUBLIC COMPANY LIMITED [380]",
						"code": "380"
					},
					{
						"title": "KBC BANK N.V. [178]",
						"code": "178"
					},
					{
						"title": "KDB ASIA LIMITED [318]",
						"code": "318"
					},
					{
						"title": "KEB ASIA FINANCE LIMITED [363]",
						"code": "363"
					},
					{
						"title": "KOREA EXCHANGE BANK [046]",
						"code": "046"
					},
					{
						"title": "KOREA EXCHANGE BANK, KOREA [A02]",
						"code": "A02"
					},
					{
						"title": "LAND BANK OF TAIWAN CO., LTD. [264]",
						"code": "264"
					},
					{
						"title": "LGT BANK AG [342]",
						"code": "342"
					},
					{
						"title": "LUSO INTERNATIONAL BANKING LIMITED, MACAU [473]",
						"code": "473"
					},
					{
						"title": "MACQUARIE BANK LIMITED [344]",
						"code": "344"
					},
					{
						"title": "MASHREQ BANK - PUBLIC SHAREHOLDING COMPANY [379]",
						"code": "379"
					},
					{
						"title": "MASHREQBANK PSC [352]",
						"code": "352"
					},
					{
						"title": "MAYBANK (MALAYAN BANKING BERHAD) [063]",
						"code": "063"
					},
					{
						"title": "MEGA INTERNATIONAL COMMERCIAL BANK CO., LTD. [242]",
						"code": "242"
					},
					{
						"title": "MELLI BANK PLC [254]",
						"code": "254"
					},
					{
						"title": "METROPOLITAN BANK & TRUST COMPANY [295]",
						"code": "295"
					},
					{
						"title": "MITSUBISHI UFJ TRUST AND BANKING CORPORATION [138]",
						"code": "138"
					},
					{
						"title": "MIZUHO BANK, LTD. [109]",
						"code": "109"
					},
					{
						"title": "NANYANG COMMERCIAL BANK LTD [043]",
						"code": "043"
					},
					{
						"title": "NATIONAL AUSTRALIA BANK LTD [150]",
						"code": "150"
					},
					{
						"title": "NATIONAL BANK OF ABU DHABI [277]",
						"code": "277"
					},
					{
						"title": "NATIONAL BANK OF CANADA [331]",
						"code": "331"
					},
					{
						"title": "NATIONAL BANK OF PAKISTAN [060]",
						"code": "060"
					},
					{
						"title": "NATIXIS [210]",
						"code": "210"
					},
					{
						"title": "OCBC WING HANG BANK LIMITED [035]",
						"code": "035"
					},
					{
						"title": "OCBC WING HANG BANK LIMITED [044]",
						"code": "044"
					},
					{
						"title": "ORIENT EXPRESS BANK [367]",
						"code": "367"
					},
					{
						"title": "ORIX ASIA LIMITED [373]",
						"code": "373"
					},
					{
						"title": "OVERSEA-CHINESE BANKING CORPORATION LTD [022]",
						"code": "022"
					},
					{
						"title": "PHILIPPINE NATIONAL BANK [119]",
						"code": "119"
					},
					{
						"title": "PICTET & CIE (EUROPE) S.A. [357]",
						"code": "357"
					},
					{
						"title": "PING AN BANK CO., LTD, SHENZHEN [485]",
						"code": "485"
					},
					{
						"title": "PORTIGON AG [218]",
						"code": "218"
					},
					{
						"title": "PT BANK CENTRAL ASIA TBK, INDONESIA [281]",
						"code": "281"
					},
					{
						"title": "PT. BANK MANDIRI (PERSERO) TBK, HONG KONG BRANCH [480]",
						"code": "480"
					},
					{
						"title": "PT. BANK NEGARA INDONESIA (PERSERO) TBK. [066]",
						"code": "066"
					},
					{
						"title": "PUBLIC BANK (HONG KONG) LIMITED [028]",
						"code": "028"
					},
					{
						"title": "PUNJAB NATIONAL BANK [266]",
						"code": "266"
					},
					{
						"title": "RAIFFEISEN BANK INTERNATIONAL AG [370]",
						"code": "370"
					},
					{
						"title": "RAIFFEISEN BANK INTERNATIONAL AG, SINGAPORE BRANCH [354]",
						"code": "354"
					},
					{
						"title": "ROYAL BANK OF CANADA [080]",
						"code": "080"
					},
					{
						"title": "ROYAL BANK OF CANADA, LONDON BRANCH [333]",
						"code": "333"
					},
					{
						"title": "ROYAL BANK OF CANADA, SINGAPORE BRANCH [334]",
						"code": "334"
					},
					{
						"title": "ROYAL BANK OF CANADA, SYDNEY BRANCH [332]",
						"code": "332"
					},
					{
						"title": "ROYAL BANK OF CANADA, TOKYO BRANCH [335]",
						"code": "335"
					},
					{
						"title": "ROYAL BANK OF CANADA, TORONTO [336]",
						"code": "336"
					},
					{
						"title": "SAIGON THUONG TIN COMMERCIAL JOINT STOCK BANK [296]",
						"code": "296"
					},
					{
						"title": "SHANGHAI COMMERCIAL BANK LTD [025]",
						"code": "025"
					},
					{
						"title": "SHANGHAI PUDONG DEVELOPMENT BANK CO., LTD [345]",
						"code": "345"
					},
					{
						"title": "SHANGHAI PUDONG DEVELOPMENT BANK, SHANGHAI [484]",
						"code": "484"
					},
					{
						"title": "SHENZHEN DEVELOPMENT BANK, SHENZHEN [486]",
						"code": "486"
					},
					{
						"title": "SHENZHEN RURAL COMMERCIAL BANK [509]",
						"code": "509"
					},
					{
						"title": "SHINHAN BANK [273]",
						"code": "273"
					},
					{
						"title": "SKANDINAVISKA ENSKILDA BANKEN AB [316]",
						"code": "316"
					},
					{
						"title": "SOCIETE GENERALE BANK & TRUST [255]",
						"code": "255"
					},
					{
						"title": "SOCIETE GENERALE [081]",
						"code": "081"
					},
					{
						"title": "STANDARD CHARTERED BANK (HONG KONG) LIMITED - EURO CLEARING  [818]",
						"code": "818"
					},
					{
						"title": "STANDARD CHARTERED BANK (HONG KONG) LIMITED [003]",
						"code": "003"
					},
					{
						"title": "STANDARD CHARTERED BANK HONG KONG BRANCH [249]",
						"code": "249"
					},
					{
						"title": "STANDARD CHARTERED BANK PLC, LONDON [536]",
						"code": "536"
					},
					{
						"title": "STANDARD CHARTERED BANK, BANGKOK [521]",
						"code": "521"
					},
					{
						"title": "STANDARD CHARTERED BANK, BEIJING BRANCH [489]",
						"code": "489"
					},
					{
						"title": "STANDARD CHARTERED BANK, JAKARTA BRANCH [515]",
						"code": "515"
					},
					{
						"title": "STANDARD CHARTERED BANK, MALAYSIA BERHAD [519]",
						"code": "519"
					},
					{
						"title": "STANDARD CHARTERED BANK, NANJING BRANCH [490]",
						"code": "490"
					},
					{
						"title": "STANDARD CHARTERED BANK, PHILIPPINES BRANCH [517]",
						"code": "517"
					},
					{
						"title": "STANDARD CHARTERED BANK, SEOUL KOREA [518]",
						"code": "518"
					},
					{
						"title": "STANDARD CHARTERED BANK, SHANGHAI BRANCH [491]",
						"code": "491"
					},
					{
						"title": "STANDARD CHARTERED BANK, SHENZHEN BRANCH [492]",
						"code": "492"
					},
					{
						"title": "STANDARD CHARTERED BANK, SINGAPORE BRANCH [516]",
						"code": "516"
					},
					{
						"title": "STANDARD CHARTERED BANK, SRI LANKA [522]",
						"code": "522"
					},
					{
						"title": "STANDARD CHARTERED BANK, TAIWAN [520]",
						"code": "520"
					},
					{
						"title": "STANDARD CHARTERED BANK, TIANJIN BRANCH [493]",
						"code": "493"
					},
					{
						"title": "STANDARD CHARTERED BANK, TOKYO [A07]",
						"code": "A07"
					},
					{
						"title": "STANDARD CHARTERED BANK, XIAMEN BRANCH [494]",
						"code": "494"
					},
					{
						"title": "STANDARD CHARTERED BANK, ZHUHAI BRANCH [495]",
						"code": "495"
					},
					{
						"title": "STATE BANK OF INDIA [082]",
						"code": "082"
					},
					{
						"title": "STATE STREET BANK AND TRUST COMPANY [220]",
						"code": "220"
					},
					{
						"title": "SUMITOMO MITSUI BANKING CORPORATION [065]",
						"code": "065"
					},
					{
						"title": "SUMITOMO MITSUI TRUST BANK, LIMITED [371]",
						"code": "371"
					},
					{
						"title": "SUNNY BANK, TAIPEI [496]",
						"code": "496"
					},
					{
						"title": "SVENSKA HANDELSBANKEN AB (PUBL) [165]",
						"code": "165"
					},
					{
						"title": "TA CHONG BANK, LTD. [378]",
						"code": "378"
					},
					{
						"title": "TAI SANG BANK LTD [061]",
						"code": "061"
					},
					{
						"title": "TAI YAU BANK LTD [038]",
						"code": "038"
					},
					{
						"title": "TAICHUNG COMMERCIAL BANK, TAICHUNG [498]",
						"code": "498"
					},
					{
						"title": "TAIPEI FUBON COMMERCIAL BANK CO., LTD. [239]",
						"code": "239"
					},
					{
						"title": "TAISHIN INTERNATIONAL BANK CO., LTD [245]",
						"code": "245"
					},
					{
						"title": "TAISHIN INTERNATIONAL BANK, TAIPEI [499]",
						"code": "499"
					},
					{
						"title": "TAIWAN BUSINESS BANK HONG KONG BRANCH [230]",
						"code": "230"
					},
					{
						"title": "TAIWAN COOPERATIVE BANK, LTD. [265]",
						"code": "265"
					},
					{
						"title": "TAIWAN SHIN KONG COMMERCIAL BANK CO., LTD. [337]",
						"code": "337"
					},
					{
						"title": "TAIWAN SHIN KONG COMMERCIAL BANK COMPANY LIMITED, TAIPEI [474]",
						"code": "474"
					},
					{
						"title": "THE BANK OF BERMUDA LIMITED, HONG KONG BRANCH [502]",
						"code": "502"
					},
					{
						"title": "THE BANK OF EAST ASIA, LTD [015]",
						"code": "015"
					},
					{
						"title": "THE BANK OF NEW YORK MELLON [139]",
						"code": "139"
					},
					{
						"title": "THE BANK OF NOVA SCOTIA [076]",
						"code": "076"
					},
					{
						"title": "THE BANK OF NOVA SCOTIA, SINGAPORE [329]",
						"code": "329"
					},
					{
						"title": "THE BANK OF TOKYO-MITSUBISHI UFJ, LTD. [047]",
						"code": "047"
					},
					{
						"title": "THE CHIBA BANK LTD [170]",
						"code": "170"
					},
					{
						"title": "THE CHUGOKU BANK LTD [202]",
						"code": "202"
					},
					{
						"title": "THE HACHIJUNI BANK, LTD [188]",
						"code": "188"
					},
					{
						"title": "THE HONGKONG AND SHANGHAI BANKING CORPORATION LTD - USD CLEA [828]",
						"code": "828"
					},
					{
						"title": "THE HOUSING BANK FOR TRADE AND FINANCE, JORDAN [554]",
						"code": "554"
					},
					{
						"title": "THE IYO BANK LTD [224]",
						"code": "224"
					},
					{
						"title": "THE MACAU CHINESE BANK LTD, MACAU [538]",
						"code": "538"
					},
					{
						"title": "THE ROYAL BANK OF SCOTLAND N.V. [360]",
						"code": "360"
					},
					{
						"title": "THE ROYAL BANK OF SCOTLAND PLC [008]",
						"code": "008"
					},
					{
						"title": "THE RURAL CREDIT COOPERATIVES UNION OF SHUNDE [528]",
						"code": "528"
					},
					{
						"title": "THE SHANGHAI COMMERCIAL & SAVINGS BANK LTD [269]",
						"code": "269"
					},
					{
						"title": "THE SHIGA BANK, LTD. [199]",
						"code": "199"
					},
					{
						"title": "THE SHIZUOKA BANK, LTD [186]",
						"code": "186"
					},
					{
						"title": "THE SIAM COMMERCIAL BANK PUBLIC COMPANY LIMITED [487]",
						"code": "487"
					},
					{
						"title": "THE TORONTO-DOMINION BANK [085]",
						"code": "085"
					},
					{
						"title": "TMB BANK PUBLIC COMPANY LIMITED, BANGKOK [500]",
						"code": "500"
					},
					{
						"title": "TMB BANK PUBLIC COMPANY LIMITED, HONG KONG [501]",
						"code": "501"
					},
					{
						"title": "TURK EKONOMI BANKASI A.S. [312]",
						"code": "312"
					},
					{
						"title": "UBS AG, HONG KONG [103]",
						"code": "103"
					},
					{
						"title": "UCO BANK [045]",
						"code": "045"
					},
					{
						"title": "UNICREDIT BANK AG [164]",
						"code": "164"
					},
					{
						"title": "UNION BANK OF INDIA [268]",
						"code": "268"
					},
					{
						"title": "UNITED OVERSEAS BANK LTD [071]",
						"code": "071"
					},
					{
						"title": "UNITED SUBURBAN AND RURAL CREDIT COOPERATIVE WUXI, WUXI [504]",
						"code": "504"
					},
					{
						"title": "VIETNAM JOINT STOCK COMMERCIAL BANK FOR INDUSTRY AND TRADE [293]",
						"code": "293"
					},
					{
						"title": "VIETNAM TECHNOLOGICAL AND COMMERCIAL JOINT STOCK BANK, HANOI [505]",
						"code": "505"
					},
					{
						"title": "WELLS FARGO BANK, N.A. [180]",
						"code": "180"
					},
					{
						"title": "WELLS FARGO BANK, N.A., LONDON BRANCH [297]",
						"code": "297"
					},
					{
						"title": "WESTPAC BANKING CORPORATION [151]",
						"code": "151"
					},
					{
						"title": "WING LUNG BANK LTD [020]",
						"code": "020"
					},
					{
						"title": "WOORI BANK  [118]",
						"code": "118"
					},
					{
						"title": "WOORI BANK, KOREA [A05]",
						"code": "A05"
					},
					{
						"title": "XIAMEN BANK CO., LTD., XIAMEN [547]",
						"code": "547"
					},
					{
						"title": "ZAO INDUSTRIAL AND COMMERCIAL BANK OF CHINA (MOSCOW) [A04]",
						"code": "A04"
					},
					{
						"title": "ZIBO CITY COMMERCIAL BANK, SHANDONG [525]",
						"code": "525"
					}
				],
				"IDR": [{
						"title": "Anglomas Bank Kantor Pusat [LOMAIDJ1]",
						"code": "LOMAIDJ1"
					},
					{
						"title": "Anz Indonesia Kantor Pusat [ANZBIDJX]",
						"code": "ANZBIDJX"
					},
					{
						"title": "BANK TABUNGAN PENSIUNAN NASIONAL PT [BTPNIDJA]",
						"code": "BTPNIDJA"
					},
					{
						"title": "BANK WOORI SAUDARA INDONESIA 1906 [BSDRIDJA]",
						"code": "BSDRIDJA"
					},
					{
						"title": "BCA Kantor Pusat Operasional [CENAIDJA]",
						"code": "CENAIDJA"
					},
					{
						"title": "BCA Syariah Kantor Pusat [SYCAIDJ1]",
						"code": "SYCAIDJ1"
					},
					{
						"title": "BNP Paribas Kantor Pusat [BNPAIDJA]",
						"code": "BNPAIDJA"
					},
					{
						"title": "BPD Bali PT. BPD Bali Kantor Pusat [ABALIDBS]",
						"code": "ABALIDBS"
					},
					{
						"title": "BPD Bengkulu [PDBKIDJ1]",
						"code": "PDBKIDJ1"
					},
					{
						"title": "BPD Diy [PDYKIDJ1]",
						"code": "PDYKIDJ1"
					},
					{
						"title": "BPD Jabar Kantor Pusat [PDJBIDJA]",
						"code": "PDJBIDJA"
					},
					{
						"title": "BPD Jambi [PDJMIDJ1]",
						"code": "PDJMIDJ1"
					},
					{
						"title": "BPD Jateng Kcs Semarang [PDJTIDJ1]",
						"code": "PDJTIDJ1"
					},
					{
						"title": "BPD Jateng Kcs Semarang [SYJGIDJ1]",
						"code": "SYJGIDJ1"
					},
					{
						"title": "BPD Jawa Tengah [PDJGIDJ1]",
						"code": "PDJGIDJ1"
					},
					{
						"title": "BPD Kalbar Kp Syariah Pontianak [SYKBIDJ1]",
						"code": "SYKBIDJ1"
					},
					{
						"title": "BPD Kalbar [PDKBIDJ1]",
						"code": "PDKBIDJ1"
					},
					{
						"title": "BPD Kalsel BPD Kalsel Cabang Utama [PDKSIDJ1]",
						"code": "PDKSIDJ1"
					},
					{
						"title": "BPD Kalsel Kp Syariah Banjarmasin [SYKSIDJ1]",
						"code": "SYKSIDJ1"
					},
					{
						"title": "BPD Kalteng [PDKGIDJ1]",
						"code": "PDKGIDJ1"
					},
					{
						"title": "BPD Kaltim Kcu Samarinda [PDKTIDJ1]",
						"code": "PDKTIDJ1"
					},
					{
						"title": "BPD Lampung [PDLPIDJ1]",
						"code": "PDLPIDJ1"
					},
					{
						"title": "BPD Maluku [PDMLIDJ1]",
						"code": "PDMLIDJ1"
					},
					{
						"title": "BPD Papua [PDIJIDJ1]",
						"code": "PDIJIDJ1"
					},
					{
						"title": "BPD Riau [PDRIIDJA]",
						"code": "PDRIIDJA"
					},
					{
						"title": "BPD Sulawesi Tenggara [PDWRIDJ1]",
						"code": "PDWRIDJ1"
					},
					{
						"title": "BPD Sulselbar [PDWSIDJ1]",
						"code": "PDWSIDJ1"
					},
					{
						"title": "BPD Sulut [PDWUIDJ1]",
						"code": "PDWUIDJ1"
					},
					{
						"title": "BPD Sumsel Dan Babel [BSSPIDSP]",
						"code": "BSSPIDSP"
					},
					{
						"title": "BPD Sumselbabel Kc Syariah Palemban [SYSSIDJ1]",
						"code": "SYSSIDJ1"
					},
					{
						"title": "BPD Sumut [PDSUIDJ1]",
						"code": "PDSUIDJ1"
					},
					{
						"title": "BPD NTT Kantor Cabang Utama [PDNTIDJ1]",
						"code": "PDNTIDJ1"
					},
					{
						"title": "BPD Sulteng KCU Palu [PDWGIDJ1]",
						"code": "PDWGIDJ1"
					},
					{
						"title": "BPD Sumut KC Syariah Medan [SYSUIDJ1]",
						"code": "SYSUIDJ1"
					},
					{
						"title": "BPD jateng kcu semarang [PDJGIDJ1]",
						"code": "PDJGIDJ1"
					},
					{
						"title": "BPD ntb Kantor Pusat [PDNBIDJ1]",
						"code": "PDNBIDJ1"
					},
					{
						"title": "BRI Kantor Pusat [BRINIDJA]",
						"code": "BRINIDJA"
					},
					{
						"title": "BTN Kantor Pusat [BTANIDJA]",
						"code": "BTANIDJA"
					},
					{
						"title": "BTN Kc Syariah Jakarta [SYBTIDJ1]",
						"code": "SYBTIDJ1"
					},
					{
						"title": "BTPN Syariah Kc Semarang [PUBAIDJ1]",
						"code": "PUBAIDJ1"
					},
					{
						"title": "Bank Agris Kantor Pusat Operasional [AGSSIDJA]",
						"code": "AGSSIDJA"
					},
					{
						"title": "Bank Agroniaga Kantor Pusat Operasi [AGTBIDJA]",
						"code": "AGTBIDJA"
					},
					{
						"title": "Bank Andara Kantor Pusat [RIPAIDJ1]",
						"code": "RIPAIDJ1"
					},
					{
						"title": "Bank Antar Daerah Kantor Pusat [ANTDIDJD]",
						"code": "ANTDIDJD"
					},
					{
						"title": "Bank Artha Graha Kpo Sudirman [ARTGIDJA]",
						"code": "ARTGIDJA"
					},
					{
						"title": "Bank Artos Indonesia Kantor Pusat [ATOSIDJ1]",
						"code": "ATOSIDJ1"
					},
					{
						"title": "Bank Bisnis Internasional Kantor Pusat [BUSTIDJ1]",
						"code": "BUSTIDJ1"
					},
					{
						"title": "Bank Bukopin Kantor Pusat Operasi [BBUKIDJA]",
						"code": "BBUKIDJA"
					},
					{
						"title": "Bank Bumi Arta Kantor Pusat [BBAIIDJA]",
						"code": "BBAIIDJA"
					},
					{
						"title": "Bank Bumiputera Kantor Pusat [BUMIIDJA]",
						"code": "BUMIIDJA"
					},
					{
						"title": "Bank CTBC Indonesia [CTCBIDJA]",
						"code": "CTCBIDJA"
					},
					{
						"title": "Bank Capital Kantor Pusat [BCIAIDJA]",
						"code": "BCIAIDJA"
					},
					{
						"title": "Bank Dki Kantor Pusat [BDKIIDJA]",
						"code": "BDKIIDJA"
					},
					{
						"title": "Bank Dki Kc Syariah Wahid Hasyim [SYDKIDJ1]",
						"code": "SYDKIDJ1"
					},
					{
						"title": "Bank Fama Kc Tanah Abang Jakarta [FAMAIDJ1]",
						"code": "FAMAIDJ1"
					},
					{
						"title": "Bank Ganesha Kpo [GNESIDJA]",
						"code": "GNESIDJA"
					},
					{
						"title": "Bank HSBC Indonesia Kantor Pusat [EKONIDJA]",
						"code": "EKONIDJA"
					},
					{
						"title": "Bank Harda Kantor Pusat [HRDAIDJ1]",
						"code": "HRDAIDJ1"
					},
					{
						"title": "Bank Hs 1908 Kc Jakarta [BSDRIDJA]",
						"code": "BSDRIDJA"
					},
					{
						"title": "Bank ICBC Indonesia Kc The City Tow [ICBKIDJA]",
						"code": "ICBKIDJA"
					},
					{
						"title": "Bank Ina Perdana Kantor Pusat [INPBIDJ1]",
						"code": "INPBIDJ1"
					},
					{
						"title": "Bank Index Selindo Kantor Pusat [BIDXIDJA]",
						"code": "BIDXIDJA"
					},
					{
						"title": "Bank JTrust Indonesia Kantor Pusat [CICTIDJA]",
						"code": "CICTIDJA"
					},
					{
						"title": "Bank Jasa Jakarta Kantor Pusat Oper [JSABIDJ1]",
						"code": "JSABIDJ1"
					},
					{
						"title": "Bank Kesawan Kantor Pusat Operasion [AWANIDJA]",
						"code": "AWANIDJA"
					},
					{
						"title": "Bank Kesejahteraan Ekonomi Kantor C [KSEBIDJ1]",
						"code": "KSEBIDJ1"
					},
					{
						"title": "Bank Maspion Kantor Pusat [MASDIDJ1]",
						"code": "MASDIDJ1"
					},
					{
						"title": "Bank Mayapada Kantor Pusat [MAYAIDJA]",
						"code": "MAYAIDJA"
					},
					{
						"title": "Bank Maybank Indonesia Kantor Pusat [IBBKIDJA]",
						"code": "IBBKIDJA"
					},
					{
						"title": "Bank Mayora Indonesia Kantor Pusat [MAYOIDJA]",
						"code": "MAYOIDJA"
					},
					{
						"title": "Bank Mega Kc Jakarta Tendean [MEGAIDJA]",
						"code": "MEGAIDJA"
					},
					{
						"title": "Bank Mestika Kantor Pusat [MEDHIDS1]",
						"code": "MEDHIDS1"
					},
					{
						"title": "Bank Mitraniaga Kc Wisma 77 [MGABIDJ1]",
						"code": "MGABIDJ1"
					},
					{
						"title": "Bank Muamalat Kantor Pusat [MUABIDJA]",
						"code": "MUABIDJA"
					},
					{
						"title": "Bank Multiarta Sentosa Kantor Pusat [MASBIDJ1]",
						"code": "MASBIDJ1"
					},
					{
						"title": "Bank Nagari Kantor Pusat [PDSBIDJ1]",
						"code": "PDSBIDJ1"
					},
					{
						"title": "Bank Nationalnobu Kantor Pusat [LFIBIDJ1]",
						"code": "LFIBIDJ1"
					},
					{
						"title": "Bank Nusantara Parahyangan Kantor P [NUPAIDJ6]",
						"code": "NUPAIDJ6"
					},
					{
						"title": "Bank Of America Na Kc Jakarta [BOFAID2X]",
						"code": "BOFAID2X"
					},
					{
						"title": "Bank Of China Kantor Pusat [BKCHIDJA]",
						"code": "BKCHIDJA"
					},
					{
						"title": "Bank Of Tokyo Mitsubishi Ufj Kc Uta [BOTKIDJX]",
						"code": "BOTKIDJX"
					},
					{
						"title": "Bank Panin Syariah Kpo Jakarta [ARFAIDJ1]",
						"code": "ARFAIDJ1"
					},
					{
						"title": "Bank Pundi Indonesia Kantor [EKSTIDJ1]",
						"code": "EKSTIDJ1"
					},
					{
						"title": "Bank Rabobank Kantor Pusat [RABOIDJA]",
						"code": "RABOIDJA"
					},
					{
						"title": "Bank Royal Kantor Pusat [ROYBIDJ1]",
						"code": "ROYBIDJ1"
					},
					{
						"title": "Bank Sahabat Sampoerna Pusat [BDIPIDJ1]",
						"code": "BDIPIDJ1"
					},
					{
						"title": "Bank Shinhan Indonesia Kantor Pusat [MEEKIDJ1]",
						"code": "MEEKIDJ1"
					},
					{
						"title": "Bank Sinar Harapan Bali Kantor Pusa [SIHBIDJ1]",
						"code": "SIHBIDJ1"
					},
					{
						"title": "Bank Sinarmas Kantor Pusat [SBJKIDJA]",
						"code": "SBJKIDJA"
					},
					{
						"title": "Bank Sumitomo Mitsui Kc Jakarta [SUNIIDJA]",
						"code": "SUNIIDJA"
					},
					{
						"title": "Bank Syariah Bri Kantor Pusat [BRISIDJA]",
						"code": "BRISIDJA"
					},
					{
						"title": "Bank Syariah Mandiri Kantor Pusat [BSMDIDJA]",
						"code": "BSMDIDJA"
					},
					{
						"title": "Bank Syariah Mega Kc Utama [BUTGIDJ1]",
						"code": "BUTGIDJ1"
					},
					{
						"title": "Bank Victoria Kantor Pusat [BVICIDJAX]",
						"code": "BVICIDJAX"
					},
					{
						"title": "Bank Woori Kantor Pusat [HVBKIDJA]",
						"code": "HVBKIDJA"
					},
					{
						"title": "Bank Yudha Bhakti Kantor Pusat [YUDBIDJ1]",
						"code": "YUDBIDJ1"
					},
					{
						"title": "Bank of India Indonesia [SWBAIDJ1]",
						"code": "SWBAIDJ1"
					},
					{
						"title": "Bii kc syariah thamrin [SYBKIDJ1]",
						"code": "SYBKIDJ1"
					},
					{
						"title": "Bni Kantor Pusat Operasional [BNINIDJA]",
						"code": "BNINIDJA"
					},
					{
						"title": "Cimb Niaga Kantor Pusat Operasional [BNIAIDJA]",
						"code": "BNIAIDJA"
					},
					{
						"title": "Citibank Kc Jakarta [CITIIDJX]",
						"code": "CITIIDJX"
					},
					{
						"title": "Commonwealth Bank Kantor Pusat [BICNIDJA]",
						"code": "BICNIDJA"
					},
					{
						"title": "Danamon Kc Jkt-Sudirman [BDINIDJA]",
						"code": "BDINIDJA"
					},
					{
						"title": "Danamon Kc Syariah Jakarta-Ciracas [SYBDIDJ1]",
						"code": "SYBDIDJ1"
					},
					{
						"title": "Dbs Bank Kantor Pusat Operasional [DBSBIDJA]",
						"code": "DBSBIDJA"
					},
					{
						"title": "Deutsche Bank Kc Jakarta [DEUTIDJA]",
						"code": "DEUTIDJA"
					},
					{
						"title": "HSBC Kc Jakarta [HSBCIDJA]",
						"code": "HSBCIDJA"
					},
					{
						"title": "JP Morgan Chase Bank Na Kc Jakarta [CHASIDJX]",
						"code": "CHASIDJX"
					},
					{
						"title": "Keb Hana Indonesia Kantor Pusat [HNBNIDJA]",
						"code": "HNBNIDJA"
					},
					{
						"title": "Mandiri Kantor Pusat Operasional [BMRIIDJA]",
						"code": "BMRIIDJA"
					},
					{
						"title": "Mizuho Kantor Pusat [MHCCIDJA]",
						"code": "MHCCIDJA"
					},
					{
						"title": "OCBC NISP KANTOR PUSAT [NISPIDJA]",
						"code": "NISPIDJA"
					},
					{
						"title": "OCBC NISP Syariah [SYONIDJ1]",
						"code": "SYONIDJ1"
					},
					{
						"title": "PT BANK OCBC NISP TBK [NISPIDJA]",
						"code": "NISPIDJA"
					},
					{
						"title": "PT Bank Aceh Syariah  [SYACIDJ1]",
						"code": "SYACIDJ1"
					},
					{
						"title": "PT Bank Bni Syariah [SYNIIDJ1]",
						"code": "SYNIIDJ1"
					},
					{
						"title": "PT. Bank Jabar Banten Syariah [SYJBIDJ1]",
						"code": "SYJBIDJ1"
					},
					{
						"title": "PT. Bank Maybank Syariah Indonesia [MBBEIDJA]",
						"code": "MBBEIDJA"
					},
					{
						"title": "PT. Bank Sbi Indonesia Kp Operasion [IDMOIDJ1]",
						"code": "IDMOIDJ1"
					},
					{
						"title": "PT.Bank Syariah Bukopin Kc Salemba [SDOBIDJ1]",
						"code": "SDOBIDJ1"
					},
					{
						"title": "Panin Kantor Pusat Operasional [PINBIDJA]",
						"code": "PINBIDJA"
					},
					{
						"title": "Permata Kc Sudirman - Jakarta [BBBAIDJA]",
						"code": "BBBAIDJA"
					},
					{
						"title": "Permata Kc Syariah Arteri Pdk Indah [SYBBIDJ1]",
						"code": "SYBBIDJ1"
					},
					{
						"title": "Prima Master Bank Kantor Pusat [PMASIDJ1]",
						"code": "PMASIDJ1"
					},
					{
						"title": "Resona Perdania Kantor Pusat [BPIAIDJA]",
						"code": "BPIAIDJA"
					},
					{
						"title": "Royal Bank Scotland Kc Jakarta [ABNAIDJA]",
						"code": "ABNAIDJA"
					},
					{
						"title": "Standard Chartered Bank Kc Jakarta [SCBLIDJX]",
						"code": "SCBLIDJX"
					},
					{
						"title": "UOB Indonesia Kc Wahid Hasyim [BBIJIDJA]",
						"code": "BBIJIDJA"
					},
					{
						"title": "Victoria Syariah Kantor Pusat Opera [SWAGIDJ1]",
						"code": "SWAGIDJ1"
					},
					{
						"title": "Windu Kentjana Int Kp Sudirman [MCORIDJA]",
						"code": "MCORIDJA"
					}
				],
				"JPY": [{
						"title": "アイエヌジ－　バンク　エヌ・ヴイ [0482]",
						"code": "0482"
					},
					{
						"title": "アイオイシノウキヨウ [7316]",
						"code": "7316"
					},
					{
						"title": "アイオ－シンキン [1206]",
						"code": "1206"
					},
					{
						"title": "アイチ [0542]",
						"code": "0542"
					},
					{
						"title": "アイチアマノウキヨウ [6514]",
						"code": "6514"
					},
					{
						"title": "アイチキタノウキヨウ [6470]",
						"code": "6470"
					},
					{
						"title": "アイチケンイシシンクミ [2447]",
						"code": "2447"
					},
					{
						"title": "アイチケンイリヨウシンクミ [2446]",
						"code": "2446"
					},
					{
						"title": "アイチケンケイサツシンクミ [2443]",
						"code": "2443"
					},
					{
						"title": "アイチケンシンギヨレン [9471]",
						"code": "9471"
					},
					{
						"title": "アイチケンシンレン [3022]",
						"code": "3022"
					},
					{
						"title": "アイチケンチユウオウシンクミ [2451]",
						"code": "2451"
					},
					{
						"title": "アイチシヨウギンシンクミ [2442]",
						"code": "2442"
					},
					{
						"title": "アイチシンキン [1550]",
						"code": "1550"
					},
					{
						"title": "アイチチタノウキヨウ [6531]",
						"code": "6531"
					},
					{
						"title": "アイチチユウオウノウキヨウ [6552]",
						"code": "6552"
					},
					{
						"title": "アイチトヨタノウキヨウ [6582]",
						"code": "6582"
					},
					{
						"title": "アイチニシノウキヨウ [6483]",
						"code": "6483"
					},
					{
						"title": "アイチヒガシノウキヨウ [6591]",
						"code": "6591"
					},
					{
						"title": "アイチビトウノウキヨウ [6466]",
						"code": "6466"
					},
					{
						"title": "アイチミカワノウキヨウ [6572]",
						"code": "6572"
					},
					{
						"title": "アイチミナミノウキヨウ [6615]",
						"code": "6615"
					},
					{
						"title": "アイヅイイデノウキヨウ [4160]",
						"code": "4160"
					},
					{
						"title": "アイヅシヨウコウシンクミ [2096]",
						"code": "2096"
					},
					{
						"title": "アイヅシンキン [1181]",
						"code": "1181"
					},
					{
						"title": "アイヅノウキヨウ [4148]",
						"code": "4148"
					},
					{
						"title": "アイヅミドリノウキヨウ [4175]",
						"code": "4175"
					},
					{
						"title": "アイヅミナミノウキヨウ [4189]",
						"code": "4189"
					},
					{
						"title": "アイライズノウキヨウ [6342]",
						"code": "6342"
					},
					{
						"title": "アイラノウキヨウ [9319]",
						"code": "9319"
					},
					{
						"title": "アオイモリシンキン [1105]",
						"code": "1105"
					},
					{
						"title": "アオキシンキン [1252]",
						"code": "1252"
					},
					{
						"title": "アオゾラ [0398]",
						"code": "0398"
					},
					{
						"title": "アオゾラシンタク [0310]",
						"code": "0310"
					},
					{
						"title": "アオゾラノウキヨウ [9338]",
						"code": "9338"
					},
					{
						"title": "アオバノウキヨウ [5895]",
						"code": "5895"
					},
					{
						"title": "アオモリ [0117]",
						"code": "0117"
					},
					{
						"title": "アオモリケンシンギヨレン [9451]",
						"code": "9451"
					},
					{
						"title": "アオモリケンシンクミ [2030]",
						"code": "2030"
					},
					{
						"title": "アオモリノウキヨウ [3373]",
						"code": "3373"
					},
					{
						"title": "アカギシンクミ [2143]",
						"code": "2143"
					},
					{
						"title": "アカギタチバナノウキヨウ [4540]",
						"code": "4540"
					},
					{
						"title": "アカシノウキヨウ [7239]",
						"code": "7239"
					},
					{
						"title": "アカンノウキヨウ [3338]",
						"code": "3338"
					},
					{
						"title": "アガツマノウキヨウ [4626]",
						"code": "4626"
					},
					{
						"title": "アキガワノウキヨウ [5039]",
						"code": "5039"
					},
					{
						"title": "アキタ [0119]",
						"code": "0119"
					},
					{
						"title": "アキタオバコノウキヨウ [3855]",
						"code": "3855"
					},
					{
						"title": "アキタキタノウキヨウ [3764]",
						"code": "3764"
					},
					{
						"title": "アキタケンシンクミ [2075]",
						"code": "2075"
					},
					{
						"title": "アキタコトウノウキヨウ [3798]",
						"code": "3798"
					},
					{
						"title": "アキタシラカミノウキヨウ [3784]",
						"code": "3784"
					},
					{
						"title": "アキタシンキン [1120]",
						"code": "1120"
					},
					{
						"title": "アキタシンセイノウキヨウ [3825]",
						"code": "3825"
					},
					{
						"title": "アキタフルサトノウキヨウ [3878]",
						"code": "3878"
					},
					{
						"title": "アキタホクオウノウキヨウ [3773]",
						"code": "3773"
					},
					{
						"title": "アキタミナミノウキヨウ [3805]",
						"code": "3805"
					},
					{
						"title": "アキタヤマモトノウキヨウ [3795]",
						"code": "3795"
					},
					{
						"title": "アキノウキヨウ [7916]",
						"code": "7916"
					},
					{
						"title": "アサカノノウキヨウ [4730]",
						"code": "4730"
					},
					{
						"title": "アサヒカワシンキン [1020]",
						"code": "1020"
					},
					{
						"title": "アサヒカワノウキヨウ [3210]",
						"code": "3210"
					},
					{
						"title": "アサヒシンキン [1303]",
						"code": "1303"
					},
					{
						"title": "アサヒシンブンシンクミ [2580]",
						"code": "2580"
					},
					{
						"title": "アサヒナノウキヨウ [3664]",
						"code": "3664"
					},
					{
						"title": "アシカガ [0129]",
						"code": "0129"
					},
					{
						"title": "アシカガオヤマシンキン [1221]",
						"code": "1221"
					},
					{
						"title": "アシカガシノウキヨウ [4533]",
						"code": "4533"
					},
					{
						"title": "アシキタノウキヨウ [9043]",
						"code": "9043"
					},
					{
						"title": "アシヨロチヨウノウキヨウ [3289]",
						"code": "3289"
					},
					{
						"title": "アシンノウキヨウ [7847]",
						"code": "7847"
					},
					{
						"title": "アスカシンクミ [2060]",
						"code": "2060"
					},
					{
						"title": "アソノウキヨウ [8964]",
						"code": "8964"
					},
					{
						"title": "アダチセイワシンキン [1327]",
						"code": "1327"
					},
					{
						"title": "アダチノノウキヨウ [4726]",
						"code": "4726"
					},
					{
						"title": "アツギシノウキヨウ [5152]",
						"code": "5152"
					},
					{
						"title": "アヅマシンクミ [2226]",
						"code": "2226"
					},
					{
						"title": "アヅミノウキヨウ [5466]",
						"code": "5466"
					},
					{
						"title": "アナンシンキン [1803]",
						"code": "1803"
					},
					{
						"title": "アナンノウキヨウ [8268]",
						"code": "8268"
					},
					{
						"title": "アバシリシンキン [1031]",
						"code": "1031"
					},
					{
						"title": "アブクマイシカワノウキヨウ [4104]",
						"code": "4104"
					},
					{
						"title": "アブクマシンキン [1188]",
						"code": "1188"
					},
					{
						"title": "アブランドハギノウキヨウ [8223]",
						"code": "8223"
					},
					{
						"title": "アマガサキシンキン [1688]",
						"code": "1688"
					},
					{
						"title": "アマクサシンキン [1955]",
						"code": "1955"
					},
					{
						"title": "アマクサノウキヨウ [9070]",
						"code": "9070"
					},
					{
						"title": "アマヒガシノウキヨウ [6503]",
						"code": "6503"
					},
					{
						"title": "アマミオオシマシンキン [1993]",
						"code": "1993"
					},
					{
						"title": "アマミシンクミ [2895]",
						"code": "2895"
					},
					{
						"title": "アマミノウキヨウ [9363]",
						"code": "9363"
					},
					{
						"title": "アマルメマチノウキヨウ [4022]",
						"code": "4022"
					},
					{
						"title": "アメリカ [0403]",
						"code": "0403"
					},
					{
						"title": "アヤチヨウノウキヨウ [9177]",
						"code": "9177"
					},
					{
						"title": "アユミノノウキヨウ [4693]",
						"code": "4693"
					},
					{
						"title": "アライシンキン [1377]",
						"code": "1377"
					},
					{
						"title": "アリダノウキヨウ [7559]",
						"code": "7559"
					},
					{
						"title": "アルプスチユウオウシンキン [1396]",
						"code": "1396"
					},
					{
						"title": "アルプスノウキヨウ [5888]",
						"code": "5888"
					},
					{
						"title": "アワ [0172]",
						"code": "0172"
					},
					{
						"title": "アワグントウブノウキヨウ [8301]",
						"code": "8301"
					},
					{
						"title": "アワジシマノウキヨウ [7373]",
						"code": "7373"
					},
					{
						"title": "アワジシンキン [1691]",
						"code": "1691"
					},
					{
						"title": "アワジヒノデノウキヨウ [7363]",
						"code": "7363"
					},
					{
						"title": "アワチヨウノウキヨウ [8296]",
						"code": "8296"
					},
					{
						"title": "アワノウキヨウ [4876]",
						"code": "4876"
					},
					{
						"title": "アワミヨシノウキヨウ [8323]",
						"code": "8323"
					},
					{
						"title": "イイダシンキン [1394]",
						"code": "1394"
					},
					{
						"title": "イイヅカシンキン [1910]",
						"code": "1910"
					},
					{
						"title": "イオシンクミ [2471]",
						"code": "2471"
					},
					{
						"title": "イオン [0040]",
						"code": "0040"
					},
					{
						"title": "イガナンブノウキヨウ [6762]",
						"code": "6762"
					},
					{
						"title": "イガホクブノウキヨウ [6758]",
						"code": "6758"
					},
					{
						"title": "イキシノウキヨウ [8905]",
						"code": "8905"
					},
					{
						"title": "イケダセンシユウ [0161]",
						"code": "0161"
					},
					{
						"title": "イシカリシノウキヨウ [3142]",
						"code": "3142"
					},
					{
						"title": "イシカワカホクノウキヨウ [6062]",
						"code": "6062"
					},
					{
						"title": "イシカワケンイシシンクミ [2417]",
						"code": "2417"
					},
					{
						"title": "イシカワケンシンギヨレン [9468]",
						"code": "9468"
					},
					{
						"title": "イシカワケンシンレン [3019]",
						"code": "3019"
					},
					{
						"title": "イシノマキシヨウコウシンクミ [2061]",
						"code": "2061"
					},
					{
						"title": "イシノマキシンキン [1172]",
						"code": "1172"
					},
					{
						"title": "イシノマキノウキヨウ [3731]",
						"code": "3731"
					},
					{
						"title": "イスミノウキヨウ [4893]",
						"code": "4893"
					},
					{
						"title": "イスルギシンキン [1413]",
						"code": "1413"
					},
					{
						"title": "イズタイヨウノウキヨウ [6328]",
						"code": "6328"
					},
					{
						"title": "イズノクニノウキヨウ [6338]",
						"code": "6338"
					},
					{
						"title": "イズミノノウキヨウ [7092]",
						"code": "7092"
					},
					{
						"title": "イセノウキヨウ [6731]",
						"code": "6731"
					},
					{
						"title": "イセハラシノウキヨウ [5139]",
						"code": "5139"
					},
					{
						"title": "イタウ・ウニバンコ [0626]",
						"code": "0626"
					},
					{
						"title": "イタノグンノウキヨウ [8252]",
						"code": "8252"
					},
					{
						"title": "イチイシンキン [1553]",
						"code": "1553"
					},
					{
						"title": "イチカワシノウキヨウ [4959]",
						"code": "4959"
					},
					{
						"title": "イチシトウブノウキヨウ [6678]",
						"code": "6678"
					},
					{
						"title": "イチノセキシンキン [1153]",
						"code": "1153"
					},
					{
						"title": "イチハラシノウキヨウ [4949]",
						"code": "4949"
					},
					{
						"title": "イチバチヨウノウキヨウ [8300]",
						"code": "8300"
					},
					{
						"title": "イトイガワシンクミ [2366]",
						"code": "2366"
					},
					{
						"title": "イトシマノウキヨウ [8635]",
						"code": "8635"
					},
					{
						"title": "イナシキノウキヨウ [4322]",
						"code": "4322"
					},
					{
						"title": "イナバノウキヨウ [5932]",
						"code": "5932"
					},
					{
						"title": "イバラキアサヒムラノウキヨウ [4295]",
						"code": "4295"
					},
					{
						"title": "イバラキカスミノウキヨウ [4324]",
						"code": "4324"
					},
					{
						"title": "イバラキケンシンギヨレン [9457]",
						"code": "9457"
					},
					{
						"title": "イバラキケンシンクミ [2101]",
						"code": "2101"
					},
					{
						"title": "イバラキケンシンレン [3008]",
						"code": "3008"
					},
					{
						"title": "イバラキシノウキヨウ [7032]",
						"code": "7032"
					},
					{
						"title": "イバラキミナミノウキヨウ [4378]",
						"code": "4378"
					},
					{
						"title": "イバラキムツミノウキヨウ [4422]",
						"code": "4422"
					},
					{
						"title": "イビガワノウキヨウ [6198]",
						"code": "6198"
					},
					{
						"title": "イブスキノウキヨウ [9251]",
						"code": "9251"
					},
					{
						"title": "イマガネチヨウノウキヨウ [3058]",
						"code": "3058"
					},
					{
						"title": "イマヅチヨウノウキヨウ [6932]",
						"code": "6932"
					},
					{
						"title": "イマバリタチバナノウキヨウ [8401]",
						"code": "8401"
					},
					{
						"title": "イマリシノウキヨウ [8771]",
						"code": "8771"
					},
					{
						"title": "イマリシンキン [1932]",
						"code": "1932"
					},
					{
						"title": "イミズノノウキヨウ [5911]",
						"code": "5911"
					},
					{
						"title": "イヨ [0174]",
						"code": "0174"
					},
					{
						"title": "イルマノノウキヨウ [4735]",
						"code": "4735"
					},
					{
						"title": "イワイノウキヨウ [4425]",
						"code": "4425"
					},
					{
						"title": "イワキシノウキヨウ [4196]",
						"code": "4196"
					},
					{
						"title": "イワキシンクミ [2092]",
						"code": "2092"
					},
					{
						"title": "イワキチユウブノウキヨウ [4197]",
						"code": "4197"
					},
					{
						"title": "イワクニシノウキヨウ [8102]",
						"code": "8102"
					},
					{
						"title": "イワタシンキン [1511]",
						"code": "1511"
					},
					{
						"title": "イワテ [0123]",
						"code": "0123"
					},
					{
						"title": "イワテエサシノウキヨウ [3579]",
						"code": "3579"
					},
					{
						"title": "イワテケンイシシンクミ [2049]",
						"code": "2049"
					},
					{
						"title": "イワテケンシンギヨレン [9452]",
						"code": "9452"
					},
					{
						"title": "イワテケンシンレン [3003]",
						"code": "3003"
					},
					{
						"title": "イワテチユウオウノウキヨウ [3541]",
						"code": "3541"
					},
					{
						"title": "イワテチユウオウラクノウキヨウ [3539]",
						"code": "3539"
					},
					{
						"title": "イワテヒライズミノウキヨウ [3590]",
						"code": "3590"
					},
					{
						"title": "イワテフルサトノウキヨウ [3572]",
						"code": "3572"
					},
					{
						"title": "イワデヤマノウキヨウ [3717]",
						"code": "3717"
					},
					{
						"title": "イワヌマシノウキヨウ [3647]",
						"code": "3647"
					},
					{
						"title": "イワミザワノウキヨウ [3156]",
						"code": "3156"
					},
					{
						"title": "インテ－ザ・サンパオロ [0623]",
						"code": "0623"
					},
					{
						"title": "インド [0424]",
						"code": "0424"
					},
					{
						"title": "インドステイト [0468]",
						"code": "0468"
					},
					{
						"title": "ウエダシンキン [1392]",
						"code": "1392"
					},
					{
						"title": "ウエルズ・フア－ゴ [0608]",
						"code": "0608"
					},
					{
						"title": "ウオヅシノウキヨウ [5885]",
						"code": "5885"
					},
					{
						"title": "ウオヌマミナミノウキヨウ [5707]",
						"code": "5707"
					},
					{
						"title": "ウゴシンキン [1123]",
						"code": "1123"
					},
					{
						"title": "ウゴノウキヨウ [3917]",
						"code": "3917"
					},
					{
						"title": "ウサカノウキヨウ [5905]",
						"code": "5905"
					},
					{
						"title": "ウスイアンナカノウキヨウ [4613]",
						"code": "4613"
					},
					{
						"title": "ウチウラマチノウキヨウ [6121]",
						"code": "6121"
					},
					{
						"title": "ウツノミヤノウキヨウ [4445]",
						"code": "4445"
					},
					{
						"title": "ウニクレデイト [0463]",
						"code": "0463"
					},
					{
						"title": "ウマジムラノウキヨウ [8511]",
						"code": "8511"
					},
					{
						"title": "ウマノウキヨウ [8389]",
						"code": "8389"
					},
					{
						"title": "ウラホロチヨウノウキヨウ [3287]",
						"code": "3287"
					},
					{
						"title": "ウリイ [0477]",
						"code": "0477"
					},
					{
						"title": "ウリシンクミ [2014]",
						"code": "2014"
					},
					{
						"title": "ウワジマシンキン [1862]",
						"code": "1862"
					},
					{
						"title": "エイワシンキン [1643]",
						"code": "1643"
					},
					{
						"title": "エサシシンキン [1014]",
						"code": "1014"
					},
					{
						"title": "エスエムビ－シ－シンタク [0300]",
						"code": "0300"
					},
					{
						"title": "エスビ－ジエ－ [0472]",
						"code": "0472"
					},
					{
						"title": "エチゴオヂヤノウキヨウ [5690]",
						"code": "5690"
					},
					{
						"title": "エチゴサントウノウキヨウ [5685]",
						"code": "5685"
					},
					{
						"title": "エチゴジヨウエツノウキヨウ [5768]",
						"code": "5768"
					},
					{
						"title": "エチゴチユウオウノウキヨウ [5600]",
						"code": "5600"
					},
					{
						"title": "エチゴナガオカノウキヨウ [5666]",
						"code": "5666"
					},
					{
						"title": "エチゼンシンキン [1475]",
						"code": "1475"
					},
					{
						"title": "エチゼンタケフノウキヨウ [6853]",
						"code": "6853"
					},
					{
						"title": "エチゼンニユウノウキヨウ [6841]",
						"code": "6841"
					},
					{
						"title": "エヒメ [0576]",
						"code": "0576"
					},
					{
						"title": "エヒメケンシンギヨレン [9487]",
						"code": "9487"
					},
					{
						"title": "エヒメケンシンレン [3038]",
						"code": "3038"
					},
					{
						"title": "エヒメシンキン [1860]",
						"code": "1860"
					},
					{
						"title": "エヒメタイキノウキヨウ [8457]",
						"code": "8457"
					},
					{
						"title": "エヒメチユウオウノウキヨウ [8500]",
						"code": "8500"
					},
					{
						"title": "エヒメミナミノウキヨウ [8482]",
						"code": "8482"
					},
					{
						"title": "エビノシノウキヨウ [9197]",
						"code": "9197"
					},
					{
						"title": "エンガルシンキン [1033]",
						"code": "1033"
					},
					{
						"title": "エンシユウシンキン [1517]",
						"code": "1517"
					},
					{
						"title": "エンシユウチユウオウノウキヨウ [6391]",
						"code": "6391"
					},
					{
						"title": "エンシユウユメサキノウキヨウ [6387]",
						"code": "6387"
					},
					{
						"title": "エンユウノウキヨウ [3306]",
						"code": "3306"
					},
					{
						"title": "オイラセノウキヨウ [3474]",
						"code": "3474"
					},
					{
						"title": "オウミフジノウキヨウ [6888]",
						"code": "6888"
					},
					{
						"title": "オウメシンキン [1358]",
						"code": "1358"
					},
					{
						"title": "オウラタテバヤシノウキヨウ [4677]",
						"code": "4677"
					},
					{
						"title": "オエグンノウキヨウ [8305]",
						"code": "8305"
					},
					{
						"title": "オオイガワノウキヨウ [6377]",
						"code": "6377"
					},
					{
						"title": "オオイタ [0183]",
						"code": "0183"
					},
					{
						"title": "オオイタオオヤママチノウキヨウ [9145]",
						"code": "9145"
					},
					{
						"title": "オオイタケンギヨキヨウ [9493]",
						"code": "9493"
					},
					{
						"title": "オオイタケンシンクミ [2870]",
						"code": "2870"
					},
					{
						"title": "オオイタケンシンレン [3044]",
						"code": "3044"
					},
					{
						"title": "オオイタケンノウキヨウ [9104]",
						"code": "9104"
					},
					{
						"title": "オオイタシンキン [1960]",
						"code": "1960"
					},
					{
						"title": "オオイタミライシンキン [1962]",
						"code": "1962"
					},
					{
						"title": "オオカワシンキン [1917]",
						"code": "1917"
					},
					{
						"title": "オオガキキヨウリツ [0152]",
						"code": "0152"
					},
					{
						"title": "オオガキシンキン [1531]",
						"code": "1531"
					},
					{
						"title": "オオガタムラノウキヨウ [3929]",
						"code": "3929"
					},
					{
						"title": "オオサカキヨウエイシンクミ [2543]",
						"code": "2543"
					},
					{
						"title": "オオサカコウセイシンキン [1633]",
						"code": "1633"
					},
					{
						"title": "オオサカシテイシンキン [1635]",
						"code": "1635"
					},
					{
						"title": "オオサカシノウキヨウ [7200]",
						"code": "7200"
					},
					{
						"title": "オオサカシヨウコウシンキン [1636]",
						"code": "1636"
					},
					{
						"title": "オオサカシンキン [1630]",
						"code": "1630"
					},
					{
						"title": "オオサカセンシユウノウキヨウ [7087]",
						"code": "7087"
					},
					{
						"title": "オオサカチヨチクシンクミ [2548]",
						"code": "2548"
					},
					{
						"title": "オオサカトウブノウキヨウ [7184]",
						"code": "7184"
					},
					{
						"title": "オオサカナカカワチノウキヨウ [7164]",
						"code": "7164"
					},
					{
						"title": "オオサカフイシシンクミ [2560]",
						"code": "2560"
					},
					{
						"title": "オオサカフケイサツシンクミ [2566]",
						"code": "2566"
					},
					{
						"title": "オオサカフシンレン [3027]",
						"code": "3027"
					},
					{
						"title": "オオサカホクブノウキヨウ [7041]",
						"code": "7041"
					},
					{
						"title": "オオサカミナミノウキヨウ [7139]",
						"code": "7139"
					},
					{
						"title": "オオゾラノウキヨウ [6113]",
						"code": "6113"
					},
					{
						"title": "オオタシノウキヨウ [4665]",
						"code": "4665"
					},
					{
						"title": "オオタワラシンキン [1225]",
						"code": "1225"
					},
					{
						"title": "オオツマツシゲノウキヨウ [8261]",
						"code": "8261"
					},
					{
						"title": "オオフナトシノウキヨウ [3598]",
						"code": "3598"
					},
					{
						"title": "オオムタヤナガワシンキン [1908]",
						"code": "1908"
					},
					{
						"title": "オカザキシンキン [1552]",
						"code": "1552"
					},
					{
						"title": "オカヤマシノウキヨウ [7755]",
						"code": "7755"
					},
					{
						"title": "オカヤマシヨウギンシンクミ [2673]",
						"code": "2673"
					},
					{
						"title": "オカヤマシンキン [1732]",
						"code": "1732"
					},
					{
						"title": "オカヤマニシノウキヨウ [7794]",
						"code": "7794"
					},
					{
						"title": "オカヤマヒガシノウキヨウ [7768]",
						"code": "7768"
					},
					{
						"title": "オキナワ [0188]",
						"code": "0188"
					},
					{
						"title": "オキナワカイホウ [0596]",
						"code": "0596"
					},
					{
						"title": "オキナワケンシンギヨレン [9496]",
						"code": "9496"
					},
					{
						"title": "オキナワケンノウキヨウ [9375]",
						"code": "9375"
					},
					{
						"title": "オキナワケンロウキン [2997]",
						"code": "2997"
					},
					{
						"title": "オシマシンキン [1013]",
						"code": "1013"
					},
					{
						"title": "オスズノウキヨウ [9203]",
						"code": "9203"
					},
					{
						"title": "オタルシンキン [1016]",
						"code": "1016"
					},
					{
						"title": "オダワラダイイチシンクミ [2315]",
						"code": "2315"
					},
					{
						"title": "オチイマバリノウキヨウ [8400]",
						"code": "8400"
					},
					{
						"title": "オトフケチヨウノウキヨウ [3278]",
						"code": "3278"
					},
					{
						"title": "オノミチシノウキヨウ [8029]",
						"code": "8029"
					},
					{
						"title": "オバマシンキン [1473]",
						"code": "1473"
					},
					{
						"title": "オビヒロシカワニシノウキヨウ [3264]",
						"code": "3264"
					},
					{
						"title": "オビヒロシンキン [1026]",
						"code": "1026"
					},
					{
						"title": "オビヒロタイシヨウノウキヨウ [3265]",
						"code": "3265"
					},
					{
						"title": "オホ－ツクアバシリノウキヨウ [3326]",
						"code": "3326"
					},
					{
						"title": "オホ－ツクハマナスノウキヨウ [3301]",
						"code": "3301"
					},
					{
						"title": "オヤマノウキヨウ [4490]",
						"code": "4490"
					},
					{
						"title": "オリツクス [0307]",
						"code": "0307"
					},
					{
						"title": "オロロンノウキヨウ [3202]",
						"code": "3202"
					},
					{
						"title": "オワリチユウオウノウキヨウ [6451]",
						"code": "6451"
					},
					{
						"title": "オンガシンキン [1920]",
						"code": "1920"
					},
					{
						"title": "オ－ストラリア・コモンウエルス [0487]",
						"code": "0487"
					},
					{
						"title": "オ－バ－シ－・チヤイニ－ズ [0444]",
						"code": "0444"
					},
					{
						"title": "カイフノウキヨウ [8288]",
						"code": "8288"
					},
					{
						"title": "カガノウキヨウ [5943]",
						"code": "5943"
					},
					{
						"title": "カガワ [0573]",
						"code": "0573"
					},
					{
						"title": "カガワケンシンギヨレン [9486]",
						"code": "9486"
					},
					{
						"title": "カガワケンシンクミ [2721]",
						"code": "2721"
					},
					{
						"title": "カガワケンシンレン [3037]",
						"code": "3037"
					},
					{
						"title": "カガワケンノウキヨウ [8332]",
						"code": "8332"
					},
					{
						"title": "カケガワシノウキヨウ [6386]",
						"code": "6386"
					},
					{
						"title": "カケガワシンキン [1513]",
						"code": "1513"
					},
					{
						"title": "カコガワシミナミノウキヨウ [7274]",
						"code": "7274"
					},
					{
						"title": "カゴシマ [0185]",
						"code": "0185"
					},
					{
						"title": "カゴシマイズミノウキヨウ [9302]",
						"code": "9302"
					},
					{
						"title": "カゴシマキモツキノウキヨウ [9341]",
						"code": "9341"
					},
					{
						"title": "カゴシマケンイシシンクミ [2891]",
						"code": "2891"
					},
					{
						"title": "カゴシマケンシンギヨレン [9495]",
						"code": "9495"
					},
					{
						"title": "カゴシマケンシンレン [3046]",
						"code": "3046"
					},
					{
						"title": "カゴシマコウギヨウシンクミ [2890]",
						"code": "2890"
					},
					{
						"title": "カゴシマシンキン [1990]",
						"code": "1990"
					},
					{
						"title": "カゴシマソウゴシンキン [1991]",
						"code": "1991"
					},
					{
						"title": "カゴシマチユウオウノウキヨウ [9229]",
						"code": "9229"
					},
					{
						"title": "カサオカシンクミ [2674]",
						"code": "2674"
					},
					{
						"title": "カシワザキシンキン [1375]",
						"code": "1375"
					},
					{
						"title": "カシワザキノウキヨウ [5720]",
						"code": "5720"
					},
					{
						"title": "カスヤノウキヨウ [8626]",
						"code": "8626"
					},
					{
						"title": "カヅノノウキヨウ [3762]",
						"code": "3762"
					},
					{
						"title": "カトリノウキヨウ [5000]",
						"code": "5000"
					},
					{
						"title": "カナガワ [0530]",
						"code": "0530"
					},
					{
						"title": "カナガワケンイシシンクミ [2304]",
						"code": "2304"
					},
					{
						"title": "カナガワケンシカイシシンクミ [2305]",
						"code": "2305"
					},
					{
						"title": "カナガワケンシンレン [3014]",
						"code": "3014"
					},
					{
						"title": "カナガワシンキン [1281]",
						"code": "1281"
					},
					{
						"title": "カナガワセイシヨウノウキヨウ [5147]",
						"code": "5147"
					},
					{
						"title": "カナザワシノウキヨウ [6025]",
						"code": "6025"
					},
					{
						"title": "カナザワシンキン [1440]",
						"code": "1440"
					},
					{
						"title": "カナザワチユウオウシンクミ [2411]",
						"code": "2411"
					},
					{
						"title": "カナザワチユウオウノウキヨウ [6024]",
						"code": "6024"
					},
					{
						"title": "カナダロイヤル [0471]",
						"code": "0471"
					},
					{
						"title": "カヌマソウゴシンキン [1223]",
						"code": "1223"
					},
					{
						"title": "カネヤマノウキヨウ [3987]",
						"code": "3987"
					},
					{
						"title": "カミイナノウキヨウ [5384]",
						"code": "5384"
					},
					{
						"title": "カミカワチユウオウノウキヨウ [3225]",
						"code": "3225"
					},
					{
						"title": "カミシホロチヨウノウキヨウ [3280]",
						"code": "3280"
					},
					{
						"title": "カミツガノウキヨウ [4456]",
						"code": "4456"
					},
					{
						"title": "カミハヤシノウキヨウ [5815]",
						"code": "5815"
					},
					{
						"title": "カミマシキノウキヨウ [8982]",
						"code": "8982"
					},
					{
						"title": "カミヨツバノウキヨウ [3710]",
						"code": "3710"
					},
					{
						"title": "カメアリシンキン [1323]",
						"code": "1323"
					},
					{
						"title": "カモシンキン [1380]",
						"code": "1380"
					},
					{
						"title": "カモトノウキヨウ [8941]",
						"code": "8941"
					},
					{
						"title": "カラスヤマシンキン [1227]",
						"code": "1227"
					},
					{
						"title": "カラツシンキン [1930]",
						"code": "1930"
					},
					{
						"title": "カラツノウキヨウ [8766]",
						"code": "8766"
					},
					{
						"title": "カワグチシノウキヨウ [4691]",
						"code": "4691"
					},
					{
						"title": "カワグチシンキン [1251]",
						"code": "1251"
					},
					{
						"title": "カワサキシンキン [1283]",
						"code": "1283"
					},
					{
						"title": "カワノエシンキン [1866]",
						"code": "1866"
					},
					{
						"title": "カンオンジシンキン [1833]",
						"code": "1833"
					},
					{
						"title": "カンコクサンギヨウ [0603]",
						"code": "0603"
					},
					{
						"title": "カンサイア－バン [0554]",
						"code": "0554"
					},
					{
						"title": "カンラトミオカノウキヨウ [4608]",
						"code": "4608"
					},
					{
						"title": "ガマゴオリシノウキヨウ [6606]",
						"code": "6606"
					},
					{
						"title": "ガマゴオリシンキン [1562]",
						"code": "1562"
					},
					{
						"title": "キクチチイキノウキヨウ [8949]",
						"code": "8949"
					},
					{
						"title": "キサラヅシノウキヨウ [4902]",
						"code": "4902"
					},
					{
						"title": "キシユウノウキヨウ [7565]",
						"code": "7565"
					},
					{
						"title": "キソノウキヨウ [5441]",
						"code": "5441"
					},
					{
						"title": "キタイシカリノウキヨウ [3145]",
						"code": "3145"
					},
					{
						"title": "キタイセウエノシンキン [1581]",
						"code": "1581"
					},
					{
						"title": "キタイブキノウキヨウ [3188]",
						"code": "3188"
					},
					{
						"title": "キタウオヌマノウキヨウ [5693]",
						"code": "5693"
					},
					{
						"title": "キタエチゴノウキヨウ [5554]",
						"code": "5554"
					},
					{
						"title": "キタオオサカシンキン [1645]",
						"code": "1645"
					},
					{
						"title": "キタオオサカノウキヨウ [7025]",
						"code": "7025"
					},
					{
						"title": "キタオホ－ツクノウキヨウ [3297]",
						"code": "3297"
					},
					{
						"title": "キタカミシンキン [1154]",
						"code": "1154"
					},
					{
						"title": "キタカワチノウキヨウ [7193]",
						"code": "7193"
					},
					{
						"title": "キタカンミナミノウキヨウ [5541]",
						"code": "5541"
					},
					{
						"title": "キタキユウシユウ [0191]",
						"code": "0191"
					},
					{
						"title": "キタキユウシユウノウキヨウ [8692]",
						"code": "8692"
					},
					{
						"title": "キタグンシブカワノウキヨウ [4593]",
						"code": "4593"
					},
					{
						"title": "キタグンシンクミ [2083]",
						"code": "2083"
					},
					{
						"title": "キタグンマシンキン [1210]",
						"code": "1210"
					},
					{
						"title": "キタサツマノウキヨウ [9296]",
						"code": "9296"
					},
					{
						"title": "キタソウヤノウキヨウ [3257]",
						"code": "3257"
					},
					{
						"title": "キタソラチシンキン [1010]",
						"code": "1010"
					},
					{
						"title": "キタソラチノウキヨウ [3189]",
						"code": "3189"
					},
					{
						"title": "キタツクバノウキヨウ [4397]",
						"code": "4397"
					},
					{
						"title": "キタニツポン [0509]",
						"code": "0509"
					},
					{
						"title": "キタハルカノウキヨウ [3248]",
						"code": "3248"
					},
					{
						"title": "キタヒビキノウキヨウ [3238]",
						"code": "3238"
					},
					{
						"title": "キタヒヤマチヨウノウキヨウ [3056]",
						"code": "3056"
					},
					{
						"title": "キタビワコノウキヨウ [6924]",
						"code": "6924"
					},
					{
						"title": "キタフジノウキヨウ [5284]",
						"code": "5284"
					},
					{
						"title": "キタミシンキン [1030]",
						"code": "1030"
					},
					{
						"title": "キタミライノウキヨウ [3317]",
						"code": "3317"
					},
					{
						"title": "キナンノウキヨウ [7576]",
						"code": "7576"
					},
					{
						"title": "キノクニシンキン [1674]",
						"code": "1674"
					},
					{
						"title": "キノサトノウキヨウ [7543]",
						"code": "7543"
					},
					{
						"title": "キノノウキヨウ [3277]",
						"code": "3277"
					},
					{
						"title": "キビシンキン [1741]",
						"code": "1741"
					},
					{
						"title": "キホクカワカミノウキヨウ [7550]",
						"code": "7550"
					},
					{
						"title": "キホクシンキン [1585]",
						"code": "1585"
					},
					{
						"title": "キミツシノウキヨウ [4909]",
						"code": "4909"
					},
					{
						"title": "キミツシンクミ [2190]",
						"code": "2190"
					},
					{
						"title": "キモツキアイラチヨウノウキヨウ [9347]",
						"code": "9347"
					},
					{
						"title": "キユウシユウコウギンシンクミ [2840]",
						"code": "2840"
					},
					{
						"title": "キユウシユウヒゼンシンキン [1933]",
						"code": "1933"
					},
					{
						"title": "キユウシユウロウキン [2990]",
						"code": "2990"
					},
					{
						"title": "キヨウ [0163]",
						"code": "0163"
					},
					{
						"title": "キヨウエイシンクミ [2360]",
						"code": "2360"
					},
					{
						"title": "キヨウト [0158]",
						"code": "0158"
					},
					{
						"title": "キヨウトシノウキヨウ [6941]",
						"code": "6941"
					},
					{
						"title": "キヨウトシンキン [1610]",
						"code": "1610"
					},
					{
						"title": "キヨウトチユウオウシンキン [1611]",
						"code": "1611"
					},
					{
						"title": "キヨウトチユウオウノウキヨウ [6956]",
						"code": "6956"
					},
					{
						"title": "キヨウトニノクニノウキヨウ [6996]",
						"code": "6996"
					},
					{
						"title": "キヨウトノウキヨウ [6990]",
						"code": "6990"
					},
					{
						"title": "キヨウトフシンギヨレン [9475]",
						"code": "9475"
					},
					{
						"title": "キヨウトフシンレン [3026]",
						"code": "3026"
					},
					{
						"title": "キヨウトホクトシンキン [1620]",
						"code": "1620"
					},
					{
						"title": "キヨウトヤマシロノウキヨウ [6961]",
						"code": "6961"
					},
					{
						"title": "キヨウリツシンクミ [2241]",
						"code": "2241"
					},
					{
						"title": "キヨウワノウキヨウ [3087]",
						"code": "3087"
					},
					{
						"title": "キヨサトチヨウノウキヨウ [3330]",
						"code": "3330"
					},
					{
						"title": "キラヤカ [0508]",
						"code": "0508"
					},
					{
						"title": "キリユウシンキン [1204]",
						"code": "1204"
					},
					{
						"title": "キンキオオサカ [0159]",
						"code": "0159"
					},
					{
						"title": "キンキサンギヨウシンクミ [2567]",
						"code": "2567"
					},
					{
						"title": "キンキロウキン [2978]",
						"code": "2978"
					},
					{
						"title": "ギフケンイシシンクミ [2473]",
						"code": "2473"
					},
					{
						"title": "ギフケンシンレン [3020]",
						"code": "3020"
					},
					{
						"title": "ギフシヨウコウシンクミ [2470]",
						"code": "2470"
					},
					{
						"title": "ギフシンキン [1530]",
						"code": "1530"
					},
					{
						"title": "ギフノウキヨウ [6129]",
						"code": "6129"
					},
					{
						"title": "クカシヨウノウキヨウ [7191]",
						"code": "7191"
					},
					{
						"title": "クサツシノウキヨウ [6883]",
						"code": "6883"
					},
					{
						"title": "クシマシオオツカノウキヨウ [9181]",
						"code": "9181"
					},
					{
						"title": "クシロオオタノウキヨウ [3334]",
						"code": "3334"
					},
					{
						"title": "クシロシンキン [1027]",
						"code": "1027"
					},
					{
						"title": "クシロシンクミ [2025]",
						"code": "2025"
					},
					{
						"title": "クシロタンチヨウノウキヨウ [3339]",
						"code": "3339"
					},
					{
						"title": "クスココノエノウキヨウ [9137]",
						"code": "9137"
					},
					{
						"title": "クマガヤシヨウコウシンクミ [2165]",
						"code": "2165"
					},
					{
						"title": "クマガヤノウキヨウ [4808]",
						"code": "4808"
					},
					{
						"title": "クマチイキノウキヨウ [9048]",
						"code": "9048"
					},
					{
						"title": "クマモト [0587]",
						"code": "0587"
					},
					{
						"title": "クマモトウキノウキヨウ [9010]",
						"code": "9010"
					},
					{
						"title": "クマモトケンイシシンクミ [2842]",
						"code": "2842"
					},
					{
						"title": "クマモトケンシンクミ [2845]",
						"code": "2845"
					},
					{
						"title": "クマモトシノウキヨウ [8916]",
						"code": "8916"
					},
					{
						"title": "クマモトシンキン [1951]",
						"code": "1951"
					},
					{
						"title": "クマモトダイイチシンキン [1952]",
						"code": "1952"
					},
					{
						"title": "クマモトチユウオウシンキン [1954]",
						"code": "1954"
					},
					{
						"title": "クラシキカサヤノウキヨウ [7825]",
						"code": "7825"
					},
					{
						"title": "クラヨシシンキン [1703]",
						"code": "1703"
					},
					{
						"title": "クリツコノウキヨウ [3702]",
						"code": "3702"
					},
					{
						"title": "クルメシノウキヨウ [8660]",
						"code": "8660"
					},
					{
						"title": "クレインノウキヨウ [5272]",
						"code": "5272"
					},
					{
						"title": "クレシンキン [1752]",
						"code": "1752"
					},
					{
						"title": "クレデイ・アグリコル [0421]",
						"code": "0421"
					},
					{
						"title": "クレデイ・スイス [0460]",
						"code": "0460"
					},
					{
						"title": "クレノウキヨウ [7913]",
						"code": "7913"
					},
					{
						"title": "クロベシシンヨウノウキヨウ [5884]",
						"code": "5884"
					},
					{
						"title": "クロベノウキヨウ [5883]",
						"code": "5883"
					},
					{
						"title": "クワナシンキン [1583]",
						"code": "1583"
					},
					{
						"title": "グリ－ンオウミノウキヨウ [6897]",
						"code": "6897"
					},
					{
						"title": "グリ－ンオオサカノウキヨウ [7156]",
						"code": "7156"
					},
					{
						"title": "グリ－ンカゴシマノウキヨウ [9234]",
						"code": "9234"
					},
					{
						"title": "グリ－ンナガノノウキヨウ [5477]",
						"code": "5477"
					},
					{
						"title": "グンマ [0128]",
						"code": "0128"
					},
					{
						"title": "グンマケンイシシンクミ [2151]",
						"code": "2151"
					},
					{
						"title": "グンマケンシンクミ [2146]",
						"code": "2146"
					},
					{
						"title": "グンマミライシンクミ [2149]",
						"code": "2149"
					},
					{
						"title": "ケイシチヨウシヨクインシンクミ [2271]",
						"code": "2271"
					},
					{
						"title": "ケイジシンクミ [2526]",
						"code": "2526"
					},
					{
						"title": "ケイヨウ [0522]",
						"code": "0522"
					},
					{
						"title": "ケセンヌマシンキン [1175]",
						"code": "1175"
					},
					{
						"title": "ケネベツノウキヨウ [3350]",
						"code": "3350"
					},
					{
						"title": "ケンオウアイカワノウキヨウ [5153]",
						"code": "5153"
					},
					{
						"title": "ゲイナンノウキヨウ [8011]",
						"code": "8011"
					},
					{
						"title": "コウエイシンクミ [2356]",
						"code": "2356"
					},
					{
						"title": "コウカノウキヨウ [6889]",
						"code": "6889"
					},
					{
						"title": "コウサンシンキン [1305]",
						"code": "1305"
					},
					{
						"title": "コウシシンクミ [2272]",
						"code": "2272"
					},
					{
						"title": "コウチ [0578]",
						"code": "0578"
					},
					{
						"title": "コウチケンシンギヨレン [9488]",
						"code": "9488"
					},
					{
						"title": "コウチケンシンレン [3039]",
						"code": "3039"
					},
					{
						"title": "コウチシノウキヨウ [8551]",
						"code": "8551"
					},
					{
						"title": "コウチシンキン [1881]",
						"code": "1881"
					},
					{
						"title": "コウチハタノウキヨウ [8610]",
						"code": "8610"
					},
					{
						"title": "コウチハルノノウキヨウ [8559]",
						"code": "8559"
					},
					{
						"title": "コウトウシンクミ [2229]",
						"code": "2229"
					},
					{
						"title": "コウノウシンキン [1448]",
						"code": "1448"
					},
					{
						"title": "コウノスシノウキヨウ [4714]",
						"code": "4714"
					},
					{
						"title": "コウフシノウキヨウ [5222]",
						"code": "5222"
					},
					{
						"title": "コウフシンキン [1385]",
						"code": "1385"
					},
					{
						"title": "コウベシシヨクインシンクミ [2610]",
						"code": "2610"
					},
					{
						"title": "コウベシンキン [1680]",
						"code": "1680"
					},
					{
						"title": "コオリヤマシノウキヨウ [4076]",
						"code": "4076"
					},
					{
						"title": "コオリヤマシンキン [1182]",
						"code": "1182"
					},
					{
						"title": "コクミン [0624]",
						"code": "0624"
					},
					{
						"title": "ココノエマチハンダノウキヨウ [9140]",
						"code": "9140"
					},
					{
						"title": "コザシンキン [1996]",
						"code": "1996"
					},
					{
						"title": "コシガヤシノウキヨウ [4847]",
						"code": "4847"
					},
					{
						"title": "コシミズチヨウノウキヨウ [3328]",
						"code": "3328"
					},
					{
						"title": "コスモスノウキヨウ [8582]",
						"code": "8582"
					},
					{
						"title": "コトウシンキン [1604]",
						"code": "1604"
					},
					{
						"title": "コトウノウキヨウ [6911]",
						"code": "6911"
					},
					{
						"title": "コバヤシノウキヨウ [9193]",
						"code": "9193"
					},
					{
						"title": "コマチノウキヨウ [3913]",
						"code": "3913"
					},
					{
						"title": "コマツガワシンキン [1326]",
						"code": "1326"
					},
					{
						"title": "コマツシノウキヨウ [5962]",
						"code": "5962"
					},
					{
						"title": "コマノノウキヨウ [5243]",
						"code": "5243"
					},
					{
						"title": "コメルツ [0461]",
						"code": "0461"
					},
					{
						"title": "コユノウキヨウ [9200]",
						"code": "9200"
					},
					{
						"title": "ゴシヨツガルノウキヨウ [3442]",
						"code": "3442"
					},
					{
						"title": "ゴテンバノウキヨウ [6351]",
						"code": "6351"
					},
					{
						"title": "ゴトウノウキヨウ [8893]",
						"code": "8893"
					},
					{
						"title": "サイカツノウキヨウ [4864]",
						"code": "4864"
					},
					{
						"title": "サイキチユウオウノウキヨウ [7938]",
						"code": "7938"
					},
					{
						"title": "サイキヨウ [0570]",
						"code": "0570"
					},
					{
						"title": "サイキヨウシンキン [1336]",
						"code": "1336"
					},
					{
						"title": "サイジヨウシノウキヨウ [8395]",
						"code": "8395"
					},
					{
						"title": "サイタマオカベノウキヨウ [4820]",
						"code": "4820"
					},
					{
						"title": "サイタマケンイシシンクミ [2162]",
						"code": "2162"
					},
					{
						"title": "サイタマケンシンキン [1250]",
						"code": "1250"
					},
					{
						"title": "サイタマケンシンレン [3011]",
						"code": "3011"
					},
					{
						"title": "サイタマシンクミ [2167]",
						"code": "2167"
					},
					{
						"title": "サイタマチユウオウノウキヨウ [4780]",
						"code": "4780"
					},
					{
						"title": "サイタマノウキヨウ [4682]",
						"code": "4682"
					},
					{
						"title": "サイタマヒビキノノウキヨウ [4802]",
						"code": "4802"
					},
					{
						"title": "サイタマミズホノウキヨウ [4859]",
						"code": "4859"
					},
					{
						"title": "サイタマリソナ [0017]",
						"code": "0017"
					},
					{
						"title": "サイトノウキヨウ [9205]",
						"code": "9205"
					},
					{
						"title": "サカイシノウキヨウ [7111]",
						"code": "7111"
					},
					{
						"title": "サカタシソデウラノウキヨウ [4036]",
						"code": "4036"
					},
					{
						"title": "サガ [0179]",
						"code": "0179"
					},
					{
						"title": "サガエニシムラヤマノウキヨウ [3943]",
						"code": "3943"
					},
					{
						"title": "サガキヨウエイ [0583]",
						"code": "0583"
					},
					{
						"title": "サガケンイシシンクミ [2802]",
						"code": "2802"
					},
					{
						"title": "サガケンシンギヨレン [9490]",
						"code": "9490"
					},
					{
						"title": "サガケンシンレン [3041]",
						"code": "3041"
					},
					{
						"title": "サガケンノウキヨウ [8762]",
						"code": "8762"
					},
					{
						"title": "サガシチユウオウノウキヨウ [8740]",
						"code": "8740"
					},
					{
						"title": "サガシンキン [1931]",
						"code": "1931"
					},
					{
						"title": "サガニシシンクミ [2808]",
						"code": "2808"
					},
					{
						"title": "サガヒガシシンクミ [2803]",
						"code": "2803"
					},
					{
						"title": "サガミシンキン [1288]",
						"code": "1288"
					},
					{
						"title": "サガミノウキヨウ [5131]",
						"code": "5131"
					},
					{
						"title": "サガミハラシノウキヨウ [5159]",
						"code": "5159"
					},
					{
						"title": "サクアサマノウキヨウ [5335]",
						"code": "5335"
					},
					{
						"title": "サクラノマチシンクミ [2358]",
						"code": "2358"
					},
					{
						"title": "ササカミノウキヨウ [5542]",
						"code": "5542"
					},
					{
						"title": "サセボチユウオウシンクミ [2826]",
						"code": "2826"
					},
					{
						"title": "サツナイノウキヨウ [3281]",
						"code": "3281"
					},
					{
						"title": "サツポロシノウキヨウ [3133]",
						"code": "3133"
					},
					{
						"title": "サツポロシンキン [1001]",
						"code": "1001"
					},
					{
						"title": "サツポロチユウオウシンクミ [2013]",
						"code": "2013"
					},
					{
						"title": "サツマヒオキノウキヨウ [9270]",
						"code": "9270"
					},
					{
						"title": "サツラクノウキヨウ [3154]",
						"code": "3154"
					},
					{
						"title": "サトウラノウキヨウ [8263]",
						"code": "8263"
					},
					{
						"title": "サドノウキヨウ [5832]",
						"code": "5832"
					},
					{
						"title": "サノシンキン [1224]",
						"code": "1224"
					},
					{
						"title": "サノノウキヨウ [4523]",
						"code": "4523"
					},
					{
						"title": "サラベツムラノウキヨウ [3267]",
						"code": "3267"
					},
					{
						"title": "サロマチヨウノウキヨウ [3303]",
						"code": "3303"
					},
					{
						"title": "サワイセサキノウキヨウ [4652]",
						"code": "4652"
					},
					{
						"title": "サワヤカシンキン [1310]",
						"code": "1310"
					},
					{
						"title": "サワラシンキン [1267]",
						"code": "1267"
					},
					{
						"title": "サワラノウキヨウ [5002]",
						"code": "5002"
					},
					{
						"title": "サンインゴウドウ [0167]",
						"code": "0167"
					},
					{
						"title": "サンジヨウシンキン [1373]",
						"code": "1373"
					},
					{
						"title": "サンジヨウシンクミ [2361]",
						"code": "2361"
					},
					{
						"title": "サンブグンシノウキヨウ [4929]",
						"code": "4929"
					},
					{
						"title": "シオサイノウキヨウ [4301]",
						"code": "4301"
					},
					{
						"title": "シオザワシンクミ [2365]",
						"code": "2365"
					},
					{
						"title": "シオザワノウキヨウ [5706]",
						"code": "5706"
					},
					{
						"title": "シオジリシノウキヨウ [5449]",
						"code": "5449"
					},
					{
						"title": "シオノヤノウキヨウ [4497]",
						"code": "4497"
					},
					{
						"title": "シカオイチヨウノウキヨウ [3276]",
						"code": "3276"
					},
					{
						"title": "シカノウキヨウ [6084]",
						"code": "6084"
					},
					{
						"title": "シガ [0157]",
						"code": "0157"
					},
					{
						"title": "シガ [0157]",
						"code": "0157"
					},
					{
						"title": "シガガモウチヨウノウキヨウ [6900]",
						"code": "6900"
					},
					{
						"title": "シガケンシンクミ [2505]",
						"code": "2505"
					},
					{
						"title": "シガケンシンレン [3025]",
						"code": "3025"
					},
					{
						"title": "シガケンミンシンクミ [2504]",
						"code": "2504"
					},
					{
						"title": "シガコウゲンノウキヨウ [5493]",
						"code": "5493"
					},
					{
						"title": "シガチユウオウシンキン [1602]",
						"code": "1602"
					},
					{
						"title": "シコク [0175]",
						"code": "0175"
					},
					{
						"title": "シコクロウキン [2987]",
						"code": "2987"
					},
					{
						"title": "シサンカンリサ－ビスシンタク [0325]",
						"code": "0325"
					},
					{
						"title": "シズオカ [0149]",
						"code": "0149"
					},
					{
						"title": "シズオカケンイシシンクミ [2332]",
						"code": "2332"
					},
					{
						"title": "シズオカケンシンギヨレン [9470]",
						"code": "9470"
					},
					{
						"title": "シズオカケンシンレン [3021]",
						"code": "3021"
					},
					{
						"title": "シズオカケンロウキン [2968]",
						"code": "2968"
					},
					{
						"title": "シズオカシノウキヨウ [6373]",
						"code": "6373"
					},
					{
						"title": "シズオカシンキン [1501]",
						"code": "1501"
					},
					{
						"title": "シズオカチユウオウ [0538]",
						"code": "0538"
					},
					{
						"title": "シズナイノウキヨウ [3125]",
						"code": "3125"
					},
					{
						"title": "シチジユウシチ [0125]",
						"code": "0125"
					},
					{
						"title": "シチトウシンクミ [2243]",
						"code": "2243"
					},
					{
						"title": "シテイバンク [0401]",
						"code": "0401"
					},
					{
						"title": "シノノメシンキン [1211]",
						"code": "1211"
					},
					{
						"title": "シバシンキン [1319]",
						"code": "1319"
					},
					{
						"title": "シバタシンキン [1374]",
						"code": "1374"
					},
					{
						"title": "シベチヤチヨウノウキヨウ [3336]",
						"code": "3336"
					},
					{
						"title": "シベツチヨウノウキヨウ [3348]",
						"code": "3348"
					},
					{
						"title": "シホロチヨウノウキヨウ [3279]",
						"code": "3279"
					},
					{
						"title": "シマダシンキン [1509]",
						"code": "1509"
					},
					{
						"title": "シマナミシンキン [1756]",
						"code": "1756"
					},
					{
						"title": "シマネ [0565]",
						"code": "0565"
					},
					{
						"title": "シマネケンノウキヨウ [7708]",
						"code": "7708"
					},
					{
						"title": "シマネシンキン [1710]",
						"code": "1710"
					},
					{
						"title": "シマネチユウオウシンキン [1712]",
						"code": "1712"
					},
					{
						"title": "シマネマスダシンクミ [2661]",
						"code": "2661"
					},
					{
						"title": "シマバラウンゼンノウキヨウ [8829]",
						"code": "8829"
					},
					{
						"title": "シマントノウキヨウ [8593]",
						"code": "8593"
					},
					{
						"title": "シミズ [0151]",
						"code": "0151"
					},
					{
						"title": "シミズノウキヨウ [6363]",
						"code": "6363"
					},
					{
						"title": "シモツケノウキヨウ [4478]",
						"code": "4478"
					},
					{
						"title": "シモノセキノウキヨウ [8181]",
						"code": "8181"
					},
					{
						"title": "シヤリチヨウノウキヨウ [3329]",
						"code": "3329"
					},
					{
						"title": "シユウソウノウキヨウ [8398]",
						"code": "8398"
					},
					{
						"title": "シユウナンノウキヨウ [8134]",
						"code": "8134"
					},
					{
						"title": "シヨウエイノウキヨウ [7889]",
						"code": "7889"
					},
					{
						"title": "シヨウカシヨウギヨウ [0607]",
						"code": "0607"
					},
					{
						"title": "シヨウコウチユウキン [2004]",
						"code": "2004"
					},
					{
						"title": "シヨウナイ [0121]",
						"code": "0121"
					},
					{
						"title": "シヨウナイタガワノウキヨウ [4013]",
						"code": "4013"
					},
					{
						"title": "シヨウナイミドリノウキヨウ [4027]",
						"code": "4027"
					},
					{
						"title": "シヨウナンシンキン [1282]",
						"code": "1282"
					},
					{
						"title": "シヨウナンノウキヨウ [5137]",
						"code": "5137"
					},
					{
						"title": "シヨウバラノウキヨウ [8076]",
						"code": "8076"
					},
					{
						"title": "シヨウワシンキン [1345]",
						"code": "1345"
					},
					{
						"title": "シラカワシンキン [1184]",
						"code": "1184"
					},
					{
						"title": "シラカワノウキヨウ [4130]",
						"code": "4130"
					},
					{
						"title": "シンアキタノウキヨウ [3810]",
						"code": "3810"
					},
					{
						"title": "シンアサヒチヨウノウキヨウ [6933]",
						"code": "6933"
					},
					{
						"title": "シンイワテノウキヨウ [3517]",
						"code": "3517"
					},
					{
						"title": "シンエイシンクミ [2357]",
						"code": "2357"
					},
					{
						"title": "シンオタルノウキヨウ [3094]",
						"code": "3094"
					},
					{
						"title": "シンキンシンタク [0309]",
						"code": "0309"
					},
					{
						"title": "シンキンチユウオウキンコ [1000]",
						"code": "1000"
					},
					{
						"title": "シンギンコウトウキヨウ [0322]",
						"code": "0322"
					},
					{
						"title": "シングウシンキン [1671]",
						"code": "1671"
					},
					{
						"title": "シンシノツムラノウキヨウ [3147]",
						"code": "3147"
					},
					{
						"title": "シンシユウウエダノウキヨウ [5348]",
						"code": "5348"
					},
					{
						"title": "シンシユウスワノウキヨウ [5372]",
						"code": "5372"
					},
					{
						"title": "シンジヨウシノウキヨウ [3971]",
						"code": "3971"
					},
					{
						"title": "シンジヨウシンキン [1143]",
						"code": "1143"
					},
					{
						"title": "シンジヨウモガミノウキヨウ [3973]",
						"code": "3973"
					},
					{
						"title": "シンスナガワノウキヨウ [3175]",
						"code": "3175"
					},
					{
						"title": "シンセイ [0397]",
						"code": "0397"
					},
					{
						"title": "シンセイシンタク [0320]",
						"code": "0320"
					},
					{
						"title": "シントクチヨウノウキヨウ [3275]",
						"code": "3275"
					},
					{
						"title": "シンハコダテノウキヨウ [3068]",
						"code": "3068"
					},
					{
						"title": "シンヒタチノノウキヨウ [4394]",
						"code": "4394"
					},
					{
						"title": "シンフクシマノウキヨウ [4047]",
						"code": "4047"
					},
					{
						"title": "シンミナトシンキン [1404]",
						"code": "1404"
					},
					{
						"title": "シンワ [0181]",
						"code": "0181"
					},
					{
						"title": "ジエ－ピ－モルガン [0402]",
						"code": "0402"
					},
					{
						"title": "ジブン [0039]",
						"code": "0039"
					},
					{
						"title": "ジヤパンネツト [0033]",
						"code": "0033"
					},
					{
						"title": "ジユウハチ [0180]",
						"code": "0180"
					},
					{
						"title": "ジユウロク [0153]",
						"code": "0153"
					},
					{
						"title": "ジヨウエツシンキン [1376]",
						"code": "1376"
					},
					{
						"title": "ジヨウソウヒカリノウキヨウ [4413]",
						"code": "4413"
					},
					{
						"title": "ジヨウナンシンキン [1344]",
						"code": "1344"
					},
					{
						"title": "ジヨウホクシンキン [1351]",
						"code": "1351"
					},
					{
						"title": "ジヨウヨウ [0130]",
						"code": "0130"
					},
					{
						"title": "スカガワイワセノウキヨウ [4091]",
						"code": "4091"
					},
					{
						"title": "スカガワシンキン [1185]",
						"code": "1185"
					},
					{
						"title": "スガモシンキン [1356]",
						"code": "1356"
					},
					{
						"title": "スクモシヨウギンシンクミ [2741]",
						"code": "2741"
					},
					{
						"title": "スコウノウキヨウ [5485]",
						"code": "5485"
					},
					{
						"title": "スズカノウキヨウ [6665]",
						"code": "6665"
					},
					{
						"title": "スズシノウキヨウ [6122]",
						"code": "6122"
					},
					{
						"title": "スタンダ－ドチヤ－タ－ド [0413]",
						"code": "0413"
					},
					{
						"title": "ステ－ト・ストリ－ト [0495]",
						"code": "0495"
					},
					{
						"title": "ステ－ト・ストリ－トシンタク [0299]",
						"code": "0299"
					},
					{
						"title": "スミシンエスビ－アイネツト [0038]",
						"code": "0038"
					},
					{
						"title": "スルガ [0150]",
						"code": "0150"
					},
					{
						"title": "スワシンキン [1393]",
						"code": "1393"
					},
					{
						"title": "セイキヨウシンクミ [2541]",
						"code": "2541"
					},
					{
						"title": "セイシンシンキン [1502]",
						"code": "1502"
					},
					{
						"title": "セイノウシンキン [1540]",
						"code": "1540"
					},
					{
						"title": "セイブシンキン [1341]",
						"code": "1341"
					},
					{
						"title": "セイリカイシユウキコウ [2213]",
						"code": "2213"
					},
					{
						"title": "セイワシンクミ [2231]",
						"code": "2231"
					},
					{
						"title": "セキシンキン [1534]",
						"code": "1534"
					},
					{
						"title": "セタガヤシンキン [1348]",
						"code": "1348"
					},
					{
						"title": "セタガヤメグロノウキヨウ [5095]",
						"code": "5095"
					},
					{
						"title": "セトシンキン [1554]",
						"code": "1554"
					},
					{
						"title": "セバノウキヨウ [5462]",
						"code": "5462"
					},
					{
						"title": "セブン [0034]",
						"code": "0034"
					},
					{
						"title": "セレサカワサキノウキヨウ [5123]",
						"code": "5123"
					},
					{
						"title": "センダイ [0512]",
						"code": "0512"
					},
					{
						"title": "センダイノウキヨウ [3636]",
						"code": "3636"
					},
					{
						"title": "センナンシンキン [1174]",
						"code": "1174"
					},
					{
						"title": "センポクシンクミ [2063]",
						"code": "2063"
					},
					{
						"title": "ゼンシンクミレン [2010]",
						"code": "2010"
					},
					{
						"title": "ゼントウエイシンクミ [2202]",
						"code": "2202"
					},
					{
						"title": "ソウアイシンクミ [2318]",
						"code": "2318"
					},
					{
						"title": "ソウソウゴジヨウシンクミ [2095]",
						"code": "2095"
					},
					{
						"title": "ソウマノウキヨウ [4230]",
						"code": "4230"
					},
					{
						"title": "ソウマムラノウキヨウ [3390]",
						"code": "3390"
					},
					{
						"title": "ソウヤミナミノウキヨウ [3261]",
						"code": "3261"
					},
					{
						"title": "ソオカゴシマノウキヨウ [9332]",
						"code": "9332"
					},
					{
						"title": "ソシエテ・ジエネラル [0445]",
						"code": "0445"
					},
					{
						"title": "ソニ－ [0035]",
						"code": "0035"
					},
					{
						"title": "ソラチシヨウコウシンクミ [2019]",
						"code": "2019"
					},
					{
						"title": "ソラチシンキン [1004]",
						"code": "1004"
					},
					{
						"title": "ソラチミナミノウキヨウ [3172]",
						"code": "3172"
					},
					{
						"title": "タイキチヨウノウキヨウ [3269]",
						"code": "3269"
					},
					{
						"title": "タイコウ [0532]",
						"code": "0532"
					},
					{
						"title": "タイシヨウ [0555]",
						"code": "0555"
					},
					{
						"title": "タイセツノウキヨウ [3214]",
						"code": "3214"
					},
					{
						"title": "タイナイシノウキヨウ [5568]",
						"code": "5568"
					},
					{
						"title": "タイワン [0612]",
						"code": "0612"
					},
					{
						"title": "タカオカシノウキヨウ [5916]",
						"code": "5916"
					},
					{
						"title": "タカオカシンキン [1402]",
						"code": "1402"
					},
					{
						"title": "タカサキシノウキヨウ [4563]",
						"code": "4563"
					},
					{
						"title": "タカサキシンキン [1203]",
						"code": "1203"
					},
					{
						"title": "タカチホチクノウキヨウ [9221]",
						"code": "9221"
					},
					{
						"title": "タカツキシノウキヨウ [7029]",
						"code": "7029"
					},
					{
						"title": "タカナベシンキン [1985]",
						"code": "1985"
					},
					{
						"title": "タカノスマチノウキヨウ [3771]",
						"code": "3771"
					},
					{
						"title": "タカマツシンキン [1830]",
						"code": "1830"
					},
					{
						"title": "タカヤマシンキン [1532]",
						"code": "1532"
					},
					{
						"title": "タガワシンキン [1913]",
						"code": "1913"
					},
					{
						"title": "タガワノウキヨウ [8715]",
						"code": "8715"
					},
					{
						"title": "タキカワノウキヨウ [3177]",
						"code": "3177"
					},
					{
						"title": "タキグンノウキヨウ [6697]",
						"code": "6697"
					},
					{
						"title": "タキノガワシンキン [1352]",
						"code": "1352"
					},
					{
						"title": "タケフシンキン [1472]",
						"code": "1472"
					},
					{
						"title": "タコマチノウキヨウ [5011]",
						"code": "5011"
					},
					{
						"title": "タジマ [0164]",
						"code": "0164"
					},
					{
						"title": "タジマシンキン [1692]",
						"code": "1692"
					},
					{
						"title": "タジマノウキヨウ [7338]",
						"code": "7338"
					},
					{
						"title": "タチバナシンキン [1942]",
						"code": "1942"
					},
					{
						"title": "タテバヤシシンキン [1209]",
						"code": "1209"
					},
					{
						"title": "タテヤマシンキン [1264]",
						"code": "1264"
					},
					{
						"title": "タネヤクノウキヨウ [9353]",
						"code": "9353"
					},
					{
						"title": "タノフジオカノウキヨウ [4594]",
						"code": "4594"
					},
					{
						"title": "タマシマシンキン [1738]",
						"code": "1738"
					},
					{
						"title": "タマシンキン [1360]",
						"code": "1360"
					},
					{
						"title": "タマナシオオハママチノウキヨウ [8934]",
						"code": "8934"
					},
					{
						"title": "タマナノウキヨウ [8926]",
						"code": "8926"
					},
					{
						"title": "タムラノウキヨウ [4125]",
						"code": "4125"
					},
					{
						"title": "タンバササヤマノウキヨウ [7362]",
						"code": "7362"
					},
					{
						"title": "タンバヒカミノウキヨウ [7353]",
						"code": "7353"
					},
					{
						"title": "タンヨウシンキン [1696]",
						"code": "1696"
					},
					{
						"title": "ダイイチカンギヨウシンクミ [2254]",
						"code": "2254"
					},
					{
						"title": "ダイイチシヨウギヨウ [0611]",
						"code": "0611"
					},
					{
						"title": "ダイサン [0546]",
						"code": "0546"
					},
					{
						"title": "ダイシ [0140]",
						"code": "0140"
					},
					{
						"title": "ダイチミライシンキン [1028]",
						"code": "1028"
					},
					{
						"title": "ダイトウ [0514]",
						"code": "0514"
					},
					{
						"title": "ダイトウキヨウシンクミ [2248]",
						"code": "2248"
					},
					{
						"title": "ダイドウシンクミ [2540]",
						"code": "2540"
					},
					{
						"title": "ダイホクノウキヨウ [5470]",
						"code": "5470"
					},
					{
						"title": "ダイワネクスト [0041]",
						"code": "0041"
					},
					{
						"title": "ダテシノウキヨウ [3107]",
						"code": "3107"
					},
					{
						"title": "ダテシンキン [1009]",
						"code": "1009"
					},
					{
						"title": "ダテミライノウキヨウ [4064]",
						"code": "4064"
					},
					{
						"title": "ダンヨウシンクミ [2616]",
						"code": "2616"
					},
					{
						"title": "チクゴシンキン [1909]",
						"code": "1909"
					},
					{
						"title": "チクシノウキヨウ [8636]",
						"code": "8636"
					},
					{
						"title": "チクゼンアサクラノウキヨウ [8645]",
						"code": "8645"
					},
					{
						"title": "チクホウ [0178]",
						"code": "0178"
					},
					{
						"title": "チクマノウキヨウ [5483]",
						"code": "5483"
					},
					{
						"title": "チタシンキン [1556]",
						"code": "1556"
					},
					{
						"title": "チチブノウキヨウ [4792]",
						"code": "4792"
					},
					{
						"title": "チバ [0134]",
						"code": "0134"
					},
					{
						"title": "チバケンシンギヨレン [9461]",
						"code": "9461"
					},
					{
						"title": "チバコウギヨウ [0135]",
						"code": "0135"
					},
					{
						"title": "チバシンキン [1260]",
						"code": "1260"
					},
					{
						"title": "チバトウカツノウキヨウ [4975]",
						"code": "4975"
					},
					{
						"title": "チバミドリノウキヨウ [5016]",
						"code": "5016"
					},
					{
						"title": "チバミライノウキヨウ [4954]",
						"code": "4954"
					},
					{
						"title": "チユウエイシンキン [1289]",
						"code": "1289"
					},
					{
						"title": "チユウオウシンクミ [2556]",
						"code": "2556"
					},
					{
						"title": "チユウオウロウキン [2963]",
						"code": "2963"
					},
					{
						"title": "チユウキヨウ [0544]",
						"code": "0544"
					},
					{
						"title": "チユウゴク [0168]",
						"code": "0168"
					},
					{
						"title": "チユウゴク [0489]",
						"code": "0489"
					},
					{
						"title": "チユウゴクケンセツ [0625]",
						"code": "0625"
					},
					{
						"title": "チユウゴクコウシヨウ [0619]",
						"code": "0619"
					},
					{
						"title": "チユウゴクシンタクシヨウギヨウ [0621]",
						"code": "0621"
					},
					{
						"title": "チユウゴクノウギヨウ [0630]",
						"code": "0630"
					},
					{
						"title": "チユウゴクロウキン [2984]",
						"code": "2984"
					},
					{
						"title": "チユウシヨウキギヨウ [0498]",
						"code": "0498"
					},
					{
						"title": "チユウナンシンキン [1290]",
						"code": "1290"
					},
					{
						"title": "チユウニチシンキン [1565]",
						"code": "1565"
					},
					{
						"title": "チユウルイノウキヨウ [3268]",
						"code": "3268"
					},
					{
						"title": "チヨウギンニシシンクミ [2672]",
						"code": "2672"
					},
					{
						"title": "チヨウシシヨウコウシンクミ [2184]",
						"code": "2184"
					},
					{
						"title": "チヨウシシンキン [1261]",
						"code": "1261"
					},
					{
						"title": "チヨウセイノウキヨウ [4916]",
						"code": "4916"
					},
					{
						"title": "チヨウホウコクサイシヨウギヨウ [0425]",
						"code": "0425"
					},
					{
						"title": "チヨクアンノウキヨウ [8694]",
						"code": "8694"
					},
					{
						"title": "ツアゲノウキヨウ [6673]",
						"code": "6673"
					},
					{
						"title": "ツガルニシキタノウキヨウ [3421]",
						"code": "3421"
					},
					{
						"title": "ツガルヒロサキノウキヨウ [3387]",
						"code": "3387"
					},
					{
						"title": "ツガルミライノウキヨウ [3407]",
						"code": "3407"
					},
					{
						"title": "ツキガタチヨウノウキヨウ [3168]",
						"code": "3168"
					},
					{
						"title": "ツクイグンノウキヨウ [5162]",
						"code": "5162"
					},
					{
						"title": "ツクバ [0131]",
						"code": "0131"
					},
					{
						"title": "ツクバシノウキヨウ [4363]",
						"code": "4363"
					},
					{
						"title": "ツクバシヤタベノウキヨウ [4371]",
						"code": "4371"
					},
					{
						"title": "ツシマノウキヨウ [8906]",
						"code": "8906"
					},
					{
						"title": "ツシンキン [1580]",
						"code": "1580"
					},
					{
						"title": "ツチウラノウキヨウ [4357]",
						"code": "4357"
					},
					{
						"title": "ツナンマチノウキヨウ [5719]",
						"code": "5719"
					},
					{
						"title": "ツノヤマノウキヨウ [8592]",
						"code": "8592"
					},
					{
						"title": "ツベツチヨウノウキヨウ [3319]",
						"code": "3319"
					},
					{
						"title": "ツマゴイムラノウキヨウ [4628]",
						"code": "4628"
					},
					{
						"title": "ツヤマシンキン [1735]",
						"code": "1735"
					},
					{
						"title": "ツヤマノウキヨウ [7868]",
						"code": "7868"
					},
					{
						"title": "ツルオカシノウキヨウ [4000]",
						"code": "4000"
					},
					{
						"title": "ツルオカシンキン [1142]",
						"code": "1142"
					},
					{
						"title": "ツルガシンキン [1471]",
						"code": "1471"
					},
					{
						"title": "ツルガミカタノウキヨウ [6860]",
						"code": "6860"
					},
					{
						"title": "ツルギシンキン [1445]",
						"code": "1445"
					},
					{
						"title": "ツルシンクミ [2378]",
						"code": "2378"
					},
					{
						"title": "テシオチヨウノウキヨウ [3206]",
						"code": "3206"
					},
					{
						"title": "テラルエチゼンノウキヨウ [6832]",
						"code": "6832"
					},
					{
						"title": "テンドウシノウキヨウ [3938]",
						"code": "3938"
					},
					{
						"title": "テンパクシンヨウノウキヨウ [6436]",
						"code": "6436"
					},
					{
						"title": "デイ－ビ－エス [0458]",
						"code": "0458"
					},
					{
						"title": "デプフア・バンク・ピ－エルシ－ [0620]",
						"code": "0620"
					},
					{
						"title": "トウエイシンキン [1321]",
						"code": "1321"
					},
					{
						"title": "トウオウシンキン [1104]",
						"code": "1104"
					},
					{
						"title": "トウカイロウキン [2972]",
						"code": "2972"
					},
					{
						"title": "トウカツチユウオウノウキヨウ [4965]",
						"code": "4965"
					},
					{
						"title": "トウカツフタバノウキヨウ [4962]",
						"code": "4962"
					},
					{
						"title": "トウキヨウアオバノウキヨウ [5097]",
						"code": "5097"
					},
					{
						"title": "トウキヨウコウセイシンクミ [2224]",
						"code": "2224"
					},
					{
						"title": "トウキヨウサンキヨウシンキン [1333]",
						"code": "1333"
					},
					{
						"title": "トウキヨウシテイシンキン [1311]",
						"code": "1311"
					},
					{
						"title": "トウキヨウシヨウケンシンクミ [2215]",
						"code": "2215"
					},
					{
						"title": "トウキヨウシヨウボウシンクミ [2274]",
						"code": "2274"
					},
					{
						"title": "トウキヨウシンキン [1349]",
						"code": "1349"
					},
					{
						"title": "トウキヨウスタ－ [0526]",
						"code": "0526"
					},
					{
						"title": "トウキヨウスマイルノウキヨウ [5100]",
						"code": "5100"
					},
					{
						"title": "トウキヨウチユウオウノウキヨウ [5094]",
						"code": "5094"
					},
					{
						"title": "トウキヨウトウシヨノウキヨウ [5111]",
						"code": "5111"
					},
					{
						"title": "トウキヨウトシヨクインシンクミ [2276]",
						"code": "2276"
					},
					{
						"title": "トウキヨウトシンギヨレン [9462]",
						"code": "9462"
					},
					{
						"title": "トウキヨウトシンレン [3013]",
						"code": "3013"
					},
					{
						"title": "トウキヨウトミン [0137]",
						"code": "0137"
					},
					{
						"title": "トウキヨウヒガシシンキン [1320]",
						"code": "1320"
					},
					{
						"title": "トウキヨウベイシンキン [1262]",
						"code": "1262"
					},
					{
						"title": "トウキヨウミドリノウキヨウ [5072]",
						"code": "5072"
					},
					{
						"title": "トウキヨウミナミノウキヨウ [5055]",
						"code": "5055"
					},
					{
						"title": "トウキヨウミライノウキヨウ [5077]",
						"code": "5077"
					},
					{
						"title": "トウキヨウムサシノウキヨウ [5087]",
						"code": "5087"
					},
					{
						"title": "トウザイシラカワノウキヨウ [4132]",
						"code": "4132"
					},
					{
						"title": "トウシユンシンキン [1566]",
						"code": "1566"
					},
					{
						"title": "トウチノウキヨウ [8536]",
						"code": "8536"
					},
					{
						"title": "トウトシンヨウノウキヨウ [6265]",
						"code": "6265"
					},
					{
						"title": "トウノウシンキン [1533]",
						"code": "1533"
					},
					{
						"title": "トウブノウキヨウ [9240]",
						"code": "9240"
					},
					{
						"title": "トウホウ [0126]",
						"code": "0126"
					},
					{
						"title": "トウホク [0124]",
						"code": "0124"
					},
					{
						"title": "トウホクロウキン [2954]",
						"code": "2954"
					},
					{
						"title": "トウマノウキヨウ [3223]",
						"code": "3223"
					},
					{
						"title": "トウヤコノウキヨウ [3103]",
						"code": "3103"
					},
					{
						"title": "トウヨクシンクミ [2210]",
						"code": "2210"
					},
					{
						"title": "トウヨシンキン [1864]",
						"code": "1864"
					},
					{
						"title": "トウワ [0516]",
						"code": "0516"
					},
					{
						"title": "トオカマチノウキヨウ [5714]",
						"code": "5714"
					},
					{
						"title": "トカチイケダチヨウノウキヨウ [3283]",
						"code": "3283"
					},
					{
						"title": "トカチシミズチヨウノウキヨウ [3273]",
						"code": "3273"
					},
					{
						"title": "トカチシンクミ [2024]",
						"code": "2024"
					},
					{
						"title": "トカチタカシマノウキヨウ [3285]",
						"code": "3285"
					},
					{
						"title": "トクシマ [0572]",
						"code": "0572"
					},
					{
						"title": "トクシマキタノウキヨウ [8257]",
						"code": "8257"
					},
					{
						"title": "トクシマケンシンギヨレン [9485]",
						"code": "9485"
					},
					{
						"title": "トクシマケンシンレン [3036]",
						"code": "3036"
					},
					{
						"title": "トクシマシノウキヨウ [8231]",
						"code": "8231"
					},
					{
						"title": "トクシマシンキン [1801]",
						"code": "1801"
					},
					{
						"title": "トコロチヨウノウキヨウ [3322]",
						"code": "3322"
					},
					{
						"title": "トサアキノウキヨウ [8512]",
						"code": "8512"
					},
					{
						"title": "トサカミノウキヨウ [8514]",
						"code": "8514"
					},
					{
						"title": "トサクロシオノウキヨウ [8589]",
						"code": "8589"
					},
					{
						"title": "トサシノウキヨウ [8575]",
						"code": "8575"
					},
					{
						"title": "トサシンクミ [2740]",
						"code": "2740"
					},
					{
						"title": "トサレイホクノウキヨウ [8544]",
						"code": "8544"
					},
					{
						"title": "トダシノウキヨウ [4688]",
						"code": "4688"
					},
					{
						"title": "トチギ [0517]",
						"code": "0517"
					},
					{
						"title": "トチギシンキン [1222]",
						"code": "1222"
					},
					{
						"title": "トツトリ [0166]",
						"code": "0166"
					},
					{
						"title": "トツトリイナバノウキヨウ [7601]",
						"code": "7601"
					},
					{
						"title": "トツトリケンシンギヨレン [9480]",
						"code": "9480"
					},
					{
						"title": "トツトリケンシンレン [3031]",
						"code": "3031"
					},
					{
						"title": "トツトリシンキン [1701]",
						"code": "1701"
					},
					{
						"title": "トツトリセイブノウキヨウ [7641]",
						"code": "7641"
					},
					{
						"title": "トツトリチユウオウノウキヨウ [7625]",
						"code": "7625"
					},
					{
						"title": "トナミシンキン [1412]",
						"code": "1412"
					},
					{
						"title": "トナミノノウキヨウ [5921]",
						"code": "5921"
					},
					{
						"title": "トネグンシンキン [1208]",
						"code": "1208"
					},
					{
						"title": "トネヌマタノウキヨウ [4632]",
						"code": "4632"
					},
					{
						"title": "トバシマノウキヨウ [6741]",
						"code": "6741"
					},
					{
						"title": "トビウメシンクミ [2778]",
						"code": "2778"
					},
					{
						"title": "トピアハママツノウキヨウ [6403]",
						"code": "6403"
					},
					{
						"title": "トマコマイコウイキノウキヨウ [3112]",
						"code": "3112"
					},
					{
						"title": "トマコマイシンキン [1006]",
						"code": "1006"
					},
					{
						"title": "トマト [0566]",
						"code": "0566"
					},
					{
						"title": "トママエチヨウノウキヨウ [3201]",
						"code": "3201"
					},
					{
						"title": "トミサトシノウキヨウ [4993]",
						"code": "4993"
					},
					{
						"title": "トヤマ [0145]",
						"code": "0145"
					},
					{
						"title": "トヤマケンイシシンクミ [2402]",
						"code": "2402"
					},
					{
						"title": "トヤマケンシンギヨレン [9467]",
						"code": "9467"
					},
					{
						"title": "トヤマケンシンクミ [2404]",
						"code": "2404"
					},
					{
						"title": "トヤマシノウキヨウ [5897]",
						"code": "5897"
					},
					{
						"title": "トヤマシンキン [1401]",
						"code": "1401"
					},
					{
						"title": "トヤマダイイチ [0534]",
						"code": "0534"
					},
					{
						"title": "トヨカワシンキン [1557]",
						"code": "1557"
					},
					{
						"title": "トヨコロチヨウノウキヨウ [3286]",
						"code": "3286"
					},
					{
						"title": "トヨサカノウキヨウ [5550]",
						"code": "5550"
					},
					{
						"title": "トヨタシンキン [1559]",
						"code": "1559"
					},
					{
						"title": "トヨハシシヨウコウシンクミ [2448]",
						"code": "2448"
					},
					{
						"title": "トヨハシシンキン [1551]",
						"code": "1551"
					},
					{
						"title": "トヨハシノウキヨウ [6618]",
						"code": "6618"
					},
					{
						"title": "トリヨウシンクミ [2045]",
						"code": "2045"
					},
					{
						"title": "トワダオイラセノウキヨウ [3455]",
						"code": "3455"
					},
					{
						"title": "ドイツ [0430]",
						"code": "0430"
					},
					{
						"title": "ドウオウノウキヨウ [3139]",
						"code": "3139"
					},
					{
						"title": "ドウトウアサヒノウキヨウ [3354]",
						"code": "3354"
					},
					{
						"title": "ドウホクナヨロノウキヨウ [3244]",
						"code": "3244"
					},
					{
						"title": "ナカコマトウブノウキヨウ [5234]",
						"code": "5234"
					},
					{
						"title": "ナカサツナイムラノウキヨウ [3266]",
						"code": "3266"
					},
					{
						"title": "ナカシベツチヨウノウキヨウ [3349]",
						"code": "3349"
					},
					{
						"title": "ナカシユンベツノウキヨウ [3358]",
						"code": "3358"
					},
					{
						"title": "ナカトンベツチヨウノウキヨウ [3260]",
						"code": "3260"
					},
					{
						"title": "ナカノゴウシンクミ [2235]",
						"code": "2235"
					},
					{
						"title": "ナカノシノウキヨウ [5491]",
						"code": "5491"
					},
					{
						"title": "ナカヒヨウゴシンキン [1695]",
						"code": "1695"
					},
					{
						"title": "ナガオカシンキン [1371]",
						"code": "1371"
					},
					{
						"title": "ナガオカノウキヨウ [8528]",
						"code": "8528"
					},
					{
						"title": "ナガサキ [0585]",
						"code": "0585"
					},
					{
						"title": "ナガサキケンイシシンクミ [2821]",
						"code": "2821"
					},
					{
						"title": "ナガサキケンオウノウキヨウ [8813]",
						"code": "8813"
					},
					{
						"title": "ナガサキケンシンギヨレン [9491]",
						"code": "9491"
					},
					{
						"title": "ナガサキケンミンシンクミ [2825]",
						"code": "2825"
					},
					{
						"title": "ナガサキサイカイノウキヨウ [8857]",
						"code": "8857"
					},
					{
						"title": "ナガサキセイヒノウキヨウ [8794]",
						"code": "8794"
					},
					{
						"title": "ナガサキミツビシシンクミ [2820]",
						"code": "2820"
					},
					{
						"title": "ナガトオオツノウキヨウ [8200]",
						"code": "8200"
					},
					{
						"title": "ナガヌマノウキヨウ [3170]",
						"code": "3170"
					},
					{
						"title": "ナガノ [0533]",
						"code": "0533"
					},
					{
						"title": "ナガノケンシンクミ [2390]",
						"code": "2390"
					},
					{
						"title": "ナガノケンシンレン [3016]",
						"code": "3016"
					},
					{
						"title": "ナガノケンロウキン [2966]",
						"code": "2966"
					},
					{
						"title": "ナガノシンキン [1390]",
						"code": "1390"
					},
					{
						"title": "ナガノノウキヨウ [5499]",
						"code": "5499"
					},
					{
						"title": "ナガノヤツガタケノウキヨウ [5311]",
						"code": "5311"
					},
					{
						"title": "ナガハマシンキン [1603]",
						"code": "1603"
					},
					{
						"title": "ナガミネノウキヨウ [7541]",
						"code": "7541"
					},
					{
						"title": "ナゴヤ [0543]",
						"code": "0543"
					},
					{
						"title": "ナゴヤセイカブツシンクミ [2444]",
						"code": "2444"
					},
					{
						"title": "ナゴヤノウキヨウ [6430]",
						"code": "6430"
					},
					{
						"title": "ナシヨナル・オ－ストラリア [0484]",
						"code": "0484"
					},
					{
						"title": "ナスシンクミ [2125]",
						"code": "2125"
					},
					{
						"title": "ナスノノウキヨウ [4507]",
						"code": "4507"
					},
					{
						"title": "ナスミナミノウキヨウ [4518]",
						"code": "4518"
					},
					{
						"title": "ナトリイワヌマノウキヨウ [3652]",
						"code": "3652"
					},
					{
						"title": "ナノハナノウキヨウ [5898]",
						"code": "5898"
					},
					{
						"title": "ナメガタノウキヨウ [4310]",
						"code": "4310"
					},
					{
						"title": "ナラケンノウキヨウ [7387]",
						"code": "7387"
					},
					{
						"title": "ナラシンキン [1666]",
						"code": "1666"
					},
					{
						"title": "ナラチユウオウシンキン [1668]",
						"code": "1668"
					},
					{
						"title": "ナリタシノウキヨウ [4992]",
						"code": "4992"
					},
					{
						"title": "ナルサワムラノウキヨウ [5287]",
						"code": "5287"
					},
					{
						"title": "ナンゴウシンキン [1986]",
						"code": "1986"
					},
					{
						"title": "ナンゴクシノウキヨウ [8524]",
						"code": "8524"
					},
					{
						"title": "ナンサイノウキヨウ [4848]",
						"code": "4848"
					},
					{
						"title": "ナンスンノウキヨウ [6345]",
						"code": "6345"
					},
					{
						"title": "ナント [0162]",
						"code": "0162"
					},
					{
						"title": "ナントノウキヨウ [5927]",
						"code": "5927"
					},
					{
						"title": "ナンポロチヨウノウキヨウ [3161]",
						"code": "3161"
					},
					{
						"title": "ニイカツプチヨウノウキヨウ [3124]",
						"code": "3124"
					},
					{
						"title": "ニイカワシンキン [1405]",
						"code": "1405"
					},
					{
						"title": "ニイガタイワフネノウキヨウ [5823]",
						"code": "5823"
					},
					{
						"title": "ニイガタケンシンギヨレン [9466]",
						"code": "9466"
					},
					{
						"title": "ニイガタケンシンクミ [2351]",
						"code": "2351"
					},
					{
						"title": "ニイガタケンシンレン [3017]",
						"code": "3017"
					},
					{
						"title": "ニイガタケンロウキン [2965]",
						"code": "2965"
					},
					{
						"title": "ニイガタシノウキヨウ [5864]",
						"code": "5864"
					},
					{
						"title": "ニイガタシンキン [1370]",
						"code": "1370"
					},
					{
						"title": "ニイガタダイエイシンクミ [2363]",
						"code": "2363"
					},
					{
						"title": "ニイガタテツドウシンクミ [2354]",
						"code": "2354"
					},
					{
						"title": "ニイガタナンカンノウキヨウ [5631]",
						"code": "5631"
					},
					{
						"title": "ニイガタミライノウキヨウ [5577]",
						"code": "5577"
					},
					{
						"title": "ニイツサツキノウキヨウ [5585]",
						"code": "5585"
					},
					{
						"title": "ニイハマシノウキヨウ [8397]",
						"code": "8397"
					},
					{
						"title": "ニシインバノウキヨウ [4996]",
						"code": "4996"
					},
					{
						"title": "ニシウワノウキヨウ [8463]",
						"code": "8463"
					},
					{
						"title": "ニシオシンキン [1561]",
						"code": "1561"
					},
					{
						"title": "ニシカスガイノウキヨウ [6456]",
						"code": "6456"
					},
					{
						"title": "ニシタマノウキヨウ [5037]",
						"code": "5037"
					},
					{
						"title": "ニシチユウゴクシンキン [1781]",
						"code": "1781"
					},
					{
						"title": "ニシトウキヨウノウキヨウ [5030]",
						"code": "5030"
					},
					{
						"title": "ニシニツポンシテイ [0190]",
						"code": "0190"
					},
					{
						"title": "ニシヒヨウゴシンキン [1694]",
						"code": "1694"
					},
					{
						"title": "ニシビワコノウキヨウ [6935]",
						"code": "6935"
					},
					{
						"title": "ニシミカワノウキヨウ [6560]",
						"code": "6560"
					},
					{
						"title": "ニシミノノウキヨウ [6175]",
						"code": "6175"
					},
					{
						"title": "ニシヤツシログンノウキヨウ [5207]",
						"code": "5207"
					},
					{
						"title": "ニジノウキヨウ [8653]",
						"code": "8653"
					},
					{
						"title": "ニツシヨウキンシンタク [0321]",
						"code": "0321"
					},
					{
						"title": "ニツシンシンキン [1689]",
						"code": "1689"
					},
					{
						"title": "ニツタミドリノウキヨウ [4664]",
						"code": "4664"
					},
					{
						"title": "ニツポン [0000]",
						"code": "0000"
					},
					{
						"title": "ニホンカイシンキン [1711]",
						"code": "1711"
					},
					{
						"title": "ニホントラステイサ－ビスシン [0324]",
						"code": "0324"
					},
					{
						"title": "ニホンマスタ－トラストシンタク [0297]",
						"code": "0297"
					},
					{
						"title": "ニホンマツシンキン [1189]",
						"code": "1189"
					},
					{
						"title": "ニユ－ヨ－クメロン [0442]",
						"code": "0442"
					},
					{
						"title": "ニユ－ヨ－クメロンシンタク [0295]",
						"code": "0295"
					},
					{
						"title": "ヌマヅシンキン [1505]",
						"code": "1505"
					},
					{
						"title": "ネアガリノウキヨウ [5980]",
						"code": "5980"
					},
					{
						"title": "ノウチユウシンタク [0311]",
						"code": "0311"
					},
					{
						"title": "ノウリンチユウキン [3000]",
						"code": "3000"
					},
					{
						"title": "ノゾミシンクミ [2549]",
						"code": "2549"
					},
					{
						"title": "ノトキヨウエイシンキン [1442]",
						"code": "1442"
					},
					{
						"title": "ノトワカバノウキヨウ [6094]",
						"code": "6094"
					},
					{
						"title": "ノノイチノウキヨウ [6010]",
						"code": "6010"
					},
					{
						"title": "ノベオカシンキン [1982]",
						"code": "1982"
					},
					{
						"title": "ノベオカノウキヨウ [9208]",
						"code": "9208"
					},
					{
						"title": "ノミノウキヨウ [5982]",
						"code": "5982"
					},
					{
						"title": "ノムラシンタク [0304]",
						"code": "0304"
					},
					{
						"title": "ハイナンノウキヨウ [6382]",
						"code": "6382"
					},
					{
						"title": "ハガノノウキヨウ [4463]",
						"code": "4463"
					},
					{
						"title": "ハギヤマグチシンキン [1780]",
						"code": "1780"
					},
					{
						"title": "ハクイノウキヨウ [6076]",
						"code": "6076"
					},
					{
						"title": "ハクサンノウキヨウ [6012]",
						"code": "6012"
					},
					{
						"title": "ハグクミノウキヨウ [4567]",
						"code": "4567"
					},
					{
						"title": "ハコダテシカメダノウキヨウ [3066]",
						"code": "3066"
					},
					{
						"title": "ハコダテシヨウコウシンクミ [2017]",
						"code": "2017"
					},
					{
						"title": "ハコダテシンキン [1012]",
						"code": "1012"
					},
					{
						"title": "ハタシンキン [1880]",
						"code": "1880"
					},
					{
						"title": "ハダノシノウキヨウ [5140]",
						"code": "5140"
					},
					{
						"title": "ハチオウジシノウキヨウ [5050]",
						"code": "5050"
					},
					{
						"title": "ハチジユウニ [0143]",
						"code": "0143"
					},
					{
						"title": "ハチノヘノウキヨウ [3488]",
						"code": "3488"
					},
					{
						"title": "ハチマンシンキン [1538]",
						"code": "1538"
					},
					{
						"title": "ハナ [0423]",
						"code": "0423"
					},
					{
						"title": "ハナサキフクイノウキヨウ [6810]",
						"code": "6810"
					},
					{
						"title": "ハナシンクミ [2277]",
						"code": "2277"
					},
					{
						"title": "ハナゾノノウキヨウ [4823]",
						"code": "4823"
					},
					{
						"title": "ハナマキシンキン [1155]",
						"code": "1155"
					},
					{
						"title": "ハナマキノウキヨウ [3553]",
						"code": "3553"
					},
					{
						"title": "ハマナカチヨウノウキヨウ [3335]",
						"code": "3335"
					},
					{
						"title": "ハママツシンキン [1503]",
						"code": "1503"
					},
					{
						"title": "ハマユウノウキヨウ [9178]",
						"code": "9178"
					},
					{
						"title": "ハモチノウキヨウ [5847]",
						"code": "5847"
					},
					{
						"title": "ハリマノウキヨウ [7326]",
						"code": "7326"
					},
					{
						"title": "ハルエノウキヨウ [6823]",
						"code": "6823"
					},
					{
						"title": "ハンザワノウキヨウ [4821]",
						"code": "4821"
					},
					{
						"title": "ハンダシンキン [1555]",
						"code": "1555"
					},
					{
						"title": "ハンノウシンキン [1253]",
						"code": "1253"
					},
					{
						"title": "バンクネガラインドネシア [0429]",
						"code": "0429"
					},
					{
						"title": "バンコツク [0426]",
						"code": "0426"
					},
					{
						"title": "バンシユウシンキン [1686]",
						"code": "1686"
					},
					{
						"title": "バ－クレイズ [0414]",
						"code": "0414"
					},
					{
						"title": "パキスタン・ナシヨナル [0459]",
						"code": "0459"
					},
					{
						"title": "ヒガシアサヒカワノウキヨウ [3220]",
						"code": "3220"
					},
					{
						"title": "ヒガシウワノウキヨウ [8477]",
						"code": "8477"
					},
					{
						"title": "ヒガシカグラノウキヨウ [3219]",
						"code": "3219"
					},
					{
						"title": "ヒガシカワチヨウノウキヨウ [3227]",
						"code": "3227"
					},
					{
						"title": "ヒガシソウヤノウキヨウ [3259]",
						"code": "3259"
					},
					{
						"title": "ヒガシトクシマノウキヨウ [8234]",
						"code": "8234"
					},
					{
						"title": "ヒガシニツポン [0525]",
						"code": "0525"
					},
					{
						"title": "ヒガシネシノウキヨウ [3962]",
						"code": "3962"
					},
					{
						"title": "ヒガシノトガワノウキヨウ [6909]",
						"code": "6909"
					},
					{
						"title": "ヒガシビワコノウキヨウ [6912]",
						"code": "6912"
					},
					{
						"title": "ヒガシミノノウキヨウ [6287]",
						"code": "6287"
					},
					{
						"title": "ヒガシヤマグチシンキン [1789]",
						"code": "1789"
					},
					{
						"title": "ヒゴ [0182]",
						"code": "0182"
					},
					{
						"title": "ヒスイノウキヨウ [5797]",
						"code": "5797"
					},
					{
						"title": "ヒタシンキン [1968]",
						"code": "1968"
					},
					{
						"title": "ヒタチシタガノウキヨウ [4294]",
						"code": "4294"
					},
					{
						"title": "ヒタチノウキヨウ [4263]",
						"code": "4263"
					},
					{
						"title": "ヒダカシンキン [1011]",
						"code": "1011"
					},
					{
						"title": "ヒダカヒガシノウキヨウ [3129]",
						"code": "3129"
					},
					{
						"title": "ヒダシンクミ [2476]",
						"code": "2476"
					},
					{
						"title": "ヒダノウキヨウ [6313]",
						"code": "6313"
					},
					{
						"title": "ヒナセシンキン [1742]",
						"code": "1742"
					},
					{
						"title": "ヒマワリシンキン [1186]",
						"code": "1186"
					},
					{
						"title": "ヒマワリノウキヨウ [6612]",
						"code": "6612"
					},
					{
						"title": "ヒミシノウキヨウ [5920]",
						"code": "5920"
					},
					{
						"title": "ヒミフシキシンキン [1406]",
						"code": "1406"
					},
					{
						"title": "ヒメジシンキン [1685]",
						"code": "1685"
					},
					{
						"title": "ヒヤクゴ [0155]",
						"code": "0155"
					},
					{
						"title": "ヒヤクジユウシ [0173]",
						"code": "0173"
					},
					{
						"title": "ヒユウガノウキヨウ [9213]",
						"code": "9213"
					},
					{
						"title": "ヒヨウゴケンイリヨウシンクミ [2605]",
						"code": "2605"
					},
					{
						"title": "ヒヨウゴケンケイサツシンクミ [2602]",
						"code": "2602"
					},
					{
						"title": "ヒヨウゴケンシンギヨレン [9477]",
						"code": "9477"
					},
					{
						"title": "ヒヨウゴケンシンクミ [2606]",
						"code": "2606"
					},
					{
						"title": "ヒヨウゴケンシンレン [3028]",
						"code": "3028"
					},
					{
						"title": "ヒヨウゴシンキン [1687]",
						"code": "1687"
					},
					{
						"title": "ヒヨウゴニシノウキヨウ [7288]",
						"code": "7288"
					},
					{
						"title": "ヒヨウゴヒマワリシンクミ [2620]",
						"code": "2620"
					},
					{
						"title": "ヒヨウゴミナミノウキヨウ [7240]",
						"code": "7240"
					},
					{
						"title": "ヒヨウゴミライノウキヨウ [7264]",
						"code": "7264"
					},
					{
						"title": "ヒヨウゴロツコウノウキヨウ [7213]",
						"code": "7213"
					},
					{
						"title": "ヒラカタシンキン [1656]",
						"code": "1656"
					},
					{
						"title": "ヒラツカシンキン [1286]",
						"code": "1286"
					},
					{
						"title": "ヒロオチヨウノウキヨウ [3270]",
						"code": "3270"
					},
					{
						"title": "ヒロシマ [0169]",
						"code": "0169"
					},
					{
						"title": "ヒロシマケンシンギヨレン [9483]",
						"code": "9483"
					},
					{
						"title": "ヒロシマケンシンクミ [2681]",
						"code": "2681"
					},
					{
						"title": "ヒロシマケンシンレン [3034]",
						"code": "3034"
					},
					{
						"title": "ヒロシマシシンクミ [2680]",
						"code": "2680"
					},
					{
						"title": "ヒロシマシノウキヨウ [7909]",
						"code": "7909"
					},
					{
						"title": "ヒロシマシヨウギンシンクミ [2684]",
						"code": "2684"
					},
					{
						"title": "ヒロシマシンキン [1750]",
						"code": "1750"
					},
					{
						"title": "ヒロシマチユウオウノウキヨウ [7994]",
						"code": "7994"
					},
					{
						"title": "ヒロシマホクブノウキヨウ [7981]",
						"code": "7981"
					},
					{
						"title": "ヒロシマミドリシンキン [1758]",
						"code": "1758"
					},
					{
						"title": "ヒロシマユタカノウキヨウ [8019]",
						"code": "8019"
					},
					{
						"title": "ビエイチヨウノウキヨウ [3228]",
						"code": "3228"
					},
					{
						"title": "ビサイシンキン [1563]",
						"code": "1563"
					},
					{
						"title": "ビゼンシンキン [1743]",
						"code": "1743"
					},
					{
						"title": "ビバイシノウキヨウ [3164]",
						"code": "3164"
					},
					{
						"title": "ビホクシンキン [1740]",
						"code": "1740"
					},
					{
						"title": "ビホクノウキヨウ [7837]",
						"code": "7837"
					},
					{
						"title": "ビホロチヨウノウキヨウ [3320]",
						"code": "3320"
					},
					{
						"title": "ビラトリノウキヨウ [3120]",
						"code": "3120"
					},
					{
						"title": "ビルバオ・ビスカヤ・アルヘンタリア [0627]",
						"code": "0627"
					},
					{
						"title": "ビンゴシンクミ [2696]",
						"code": "2696"
					},
					{
						"title": "ビ－エヌピ－パリバ [0443]",
						"code": "0443"
					},
					{
						"title": "ピツプチヨウノウキヨウ [3224]",
						"code": "3224"
					},
					{
						"title": "ピンネノウキヨウ [3181]",
						"code": "3181"
					},
					{
						"title": "フイリピン・ナシヨナル・バンク [0617]",
						"code": "0617"
					},
					{
						"title": "フエフキノウキヨウ [5199]",
						"code": "5199"
					},
					{
						"title": "フカヤノウキヨウ [4874]",
						"code": "4874"
					},
					{
						"title": "フクイ [0147]",
						"code": "0147"
					},
					{
						"title": "フクイイケダチヨウノウキヨウ [6838]",
						"code": "6838"
					},
					{
						"title": "フクイケンイシシンクミ [2435]",
						"code": "2435"
					},
					{
						"title": "フクイケンシンギヨレン [9473]",
						"code": "9473"
					},
					{
						"title": "フクイケンシンレン [3024]",
						"code": "3024"
					},
					{
						"title": "フクイシナンブノウキヨウ [6789]",
						"code": "6789"
					},
					{
						"title": "フクイシノウキヨウ [6785]",
						"code": "6785"
					},
					{
						"title": "フクイシンキン [1470]",
						"code": "1470"
					},
					{
						"title": "フクイタンナンノウキヨウ [6836]",
						"code": "6836"
					},
					{
						"title": "フクエシンクミ [2833]",
						"code": "2833"
					},
					{
						"title": "フクオカ [0177]",
						"code": "0177"
					},
					{
						"title": "フクオカオオキノウキヨウ [8667]",
						"code": "8667"
					},
					{
						"title": "フクオカカホノウキヨウ [8701]",
						"code": "8701"
					},
					{
						"title": "フクオカケイチクノウキヨウ [8730]",
						"code": "8730"
					},
					{
						"title": "フクオカケンイシシンクミ [2753]",
						"code": "2753"
					},
					{
						"title": "フクオカケンシンギヨレン [9489]",
						"code": "9489"
					},
					{
						"title": "フクオカケンシンレン [3040]",
						"code": "3040"
					},
					{
						"title": "フクオカケンチユウオウシンクミ [2773]",
						"code": "2773"
					},
					{
						"title": "フクオカケンチヨウシンクミ [2751]",
						"code": "2751"
					},
					{
						"title": "フクオカケンナンブシンクミ [2763]",
						"code": "2763"
					},
					{
						"title": "フクオカシトウブノウキヨウ [8632]",
						"code": "8632"
					},
					{
						"title": "フクオカシノウキヨウ [8633]",
						"code": "8633"
					},
					{
						"title": "フクオカシンキン [1901]",
						"code": "1901"
					},
					{
						"title": "フクオカチユウオウ [0582]",
						"code": "0582"
					},
					{
						"title": "フクオカヒビキシンキン [1903]",
						"code": "1903"
					},
					{
						"title": "フクオカヤメノウキヨウ [8668]",
						"code": "8668"
					},
					{
						"title": "フクシマ [0513]",
						"code": "0513"
					},
					{
						"title": "フクシマケンシヨウコウシンクミ [2090]",
						"code": "2090"
					},
					{
						"title": "フクシマケンシンギヨレン [9456]",
						"code": "9456"
					},
					{
						"title": "フクシマシンキン [1190]",
						"code": "1190"
					},
					{
						"title": "フクセンシンクミ [2430]",
						"code": "2430"
					},
					{
						"title": "フクホウ [0537]",
						"code": "0537"
					},
					{
						"title": "フクミツノウキヨウ [5935]",
						"code": "5935"
					},
					{
						"title": "フクヤマシノウキヨウ [8047]",
						"code": "8047"
					},
					{
						"title": "フジカワノウキヨウ [5209]",
						"code": "5209"
					},
					{
						"title": "フジシノウキヨウ [6355]",
						"code": "6355"
					},
					{
						"title": "フジシンキン [1515]",
						"code": "1515"
					},
					{
						"title": "フジノミヤシンキン [1507]",
						"code": "1507"
					},
					{
						"title": "フジノミヤノウキヨウ [6357]",
						"code": "6357"
					},
					{
						"title": "フタバノウキヨウ [4220]",
						"code": "4220"
					},
					{
						"title": "フラノノウキヨウ [3231]",
						"code": "3231"
					},
					{
						"title": "フルカワシンクミ [2062]",
						"code": "2062"
					},
					{
						"title": "フルカワノウキヨウ [3704]",
						"code": "3704"
					},
					{
						"title": "フル－ツヤマナシノウキヨウ [5169]",
						"code": "5169"
					},
					{
						"title": "ブンカサンギヨウシンクミ [2211]",
						"code": "2211"
					},
					{
						"title": "ヘキカイシンキン [1560]",
						"code": "1560"
					},
					{
						"title": "ベツプヒジノウキヨウ [9103]",
						"code": "9103"
					},
					{
						"title": "ホウフトクヂノウキヨウ [8143]",
						"code": "8143"
					},
					{
						"title": "ホウワ [0590]",
						"code": "0590"
					},
					{
						"title": "ホクエツ [0141]",
						"code": "0141"
					},
					{
						"title": "ホクオウシンクミ [2011]",
						"code": "2011"
					},
					{
						"title": "ホクサイノウキヨウ [4828]",
						"code": "4828"
					},
					{
						"title": "ホクセイシンキン [1024]",
						"code": "1024"
					},
					{
						"title": "ホクト [0120]",
						"code": "0120"
					},
					{
						"title": "ホクブシンクミ [2266]",
						"code": "2266"
					},
					{
						"title": "ホクモンシンキン [1008]",
						"code": "1008"
					},
					{
						"title": "ホクヨウ [0501]",
						"code": "0501"
					},
					{
						"title": "ホクリク [0144]",
						"code": "0144"
					},
					{
						"title": "ホクリクシンキン [1444]",
						"code": "1444"
					},
					{
						"title": "ホクリクロウキン [2970]",
						"code": "2970"
					},
					{
						"title": "ホコタノウキヨウ [4296]",
						"code": "4296"
					},
					{
						"title": "ホツカイシンキン [1018]",
						"code": "1018"
					},
					{
						"title": "ホツカイドウ [0116]",
						"code": "0116"
					},
					{
						"title": "ホツカイドウシンギヨレン [9450]",
						"code": "9450"
					},
					{
						"title": "ホツカイドウシンレン [3001]",
						"code": "3001"
					},
					{
						"title": "ホツカイドウロウキン [2951]",
						"code": "2951"
					},
					{
						"title": "ホツコク [0146]",
						"code": "0146"
					},
					{
						"title": "ホロノベチヨウノウキヨウ [3208]",
						"code": "3208"
					},
					{
						"title": "ホンコンシヤンハイ [0411]",
						"code": "0411"
					},
					{
						"title": "ホンドイツワノウキヨウ [9069]",
						"code": "9069"
					},
					{
						"title": "ホンベツチヨウノウキヨウ [3288]",
						"code": "3288"
					},
					{
						"title": "ボウソウシンクミ [2180]",
						"code": "2180"
					},
					{
						"title": "マイニチシンクミ [2581]",
						"code": "2581"
					},
					{
						"title": "マインズノウキヨウ [5070]",
						"code": "5070"
					},
					{
						"title": "マエバシシノウキヨウ [4544]",
						"code": "4544"
					},
					{
						"title": "マキシンクミ [2362]",
						"code": "2362"
					},
					{
						"title": "マキノチヨウノウキヨウ [6931]",
						"code": "6931"
					},
					{
						"title": "マクベツチヨウノウキヨウ [3282]",
						"code": "3282"
					},
					{
						"title": "マシタシンクミ [2481]",
						"code": "2481"
					},
					{
						"title": "マシユウコノウキヨウ [3337]",
						"code": "3337"
					},
					{
						"title": "マチダシノウキヨウ [5060]",
						"code": "5060"
					},
					{
						"title": "マチノマチノウキヨウ [6117]",
						"code": "6117"
					},
					{
						"title": "マツサカノウキヨウ [6690]",
						"code": "6690"
					},
					{
						"title": "マツトウシノウキヨウ [5997]",
						"code": "5997"
					},
					{
						"title": "マツモトシノウキヨウ [5447]",
						"code": "5447"
					},
					{
						"title": "マツモトシンキン [1391]",
						"code": "1391"
					},
					{
						"title": "マツモトハイランドノウキヨウ [5448]",
						"code": "5448"
					},
					{
						"title": "マツヤマシノウキヨウ [8425]",
						"code": "8425"
					},
					{
						"title": "マニワノウキヨウ [7859]",
						"code": "7859"
					},
					{
						"title": "マムロガワマチノウキヨウ [3986]",
						"code": "3986"
					},
					{
						"title": "マルハチシンクミ [2440]",
						"code": "2440"
					},
					{
						"title": "ミイノウキヨウ [8656]",
						"code": "8656"
					},
					{
						"title": "ミウラシノウキヨウ [5130]",
						"code": "5130"
					},
					{
						"title": "ミエ [0154]",
						"code": "0154"
					},
					{
						"title": "ミエキタノウキヨウ [6649]",
						"code": "6649"
					},
					{
						"title": "ミエケンシンギヨレン [9472]",
						"code": "9472"
					},
					{
						"title": "ミエケンシンレン [3023]",
						"code": "3023"
					},
					{
						"title": "ミエシンキン [1582]",
						"code": "1582"
					},
					{
						"title": "ミエチユウオウノウキヨウ [6677]",
						"code": "6677"
					},
					{
						"title": "ミエナンキノウキヨウ [6770]",
						"code": "6770"
					},
					{
						"title": "ミカタハラカイタクノウキヨウ [6426]",
						"code": "6426"
					},
					{
						"title": "ミカワシンクミ [2452]",
						"code": "2452"
					},
					{
						"title": "ミクマノノウキヨウ [7591]",
						"code": "7591"
					},
					{
						"title": "ミシマカンナミノウキヨウ [6333]",
						"code": "6333"
					},
					{
						"title": "ミシマシンキン [1506]",
						"code": "1506"
					},
					{
						"title": "ミズサワシンキン [1156]",
						"code": "1156"
					},
					{
						"title": "ミズシマシンキン [1734]",
						"code": "1734"
					},
					{
						"title": "ミズホ [0001]",
						"code": "0001"
					},
					{
						"title": "ミズホシンタク [0289]",
						"code": "0289"
					},
					{
						"title": "ミズママチノウキヨウ [8664]",
						"code": "8664"
					},
					{
						"title": "ミチノク [0118]",
						"code": "0118"
					},
					{
						"title": "ミチノクアダチノウキヨウ [4069]",
						"code": "4069"
					},
					{
						"title": "ミチノクムラヤマノウキヨウ [3960]",
						"code": "3960"
					},
					{
						"title": "ミツイシノウキヨウ [3126]",
						"code": "3126"
					},
					{
						"title": "ミツイスミトモ [0009]",
						"code": "0009"
					},
					{
						"title": "ミツイスミトモシンタク [0294]",
						"code": "0294"
					},
					{
						"title": "ミツカビチヨウノウキヨウ [6423]",
						"code": "6423"
					},
					{
						"title": "ミツビシトウキヨウＵＦＪ [0005]",
						"code": "0005"
					},
					{
						"title": "ミツビシＵＦＪシンタク [0288]",
						"code": "0288"
					},
					{
						"title": "ミトシンキン [1240]",
						"code": "1240"
					},
					{
						"title": "ミトノウキヨウ [4238]",
						"code": "4238"
					},
					{
						"title": "ミドリシンヨウノウキヨウ [6443]",
						"code": "6443"
					},
					{
						"title": "ミドリノノウキヨウ [3721]",
						"code": "3721"
					},
					{
						"title": "ミナト [0562]",
						"code": "0562"
					},
					{
						"title": "ミナホノウキヨウ [5877]",
						"code": "5877"
					},
					{
						"title": "ミナミサツマノウキヨウ [9257]",
						"code": "9257"
					},
					{
						"title": "ミナミサンリクノウキヨウ [3682]",
						"code": "3682"
					},
					{
						"title": "ミナミシンシユウノウキヨウ [5405]",
						"code": "5405"
					},
					{
						"title": "ミナミスオウノウキヨウ [8118]",
						"code": "8118"
					},
					{
						"title": "ミナミチクゴノウキヨウ [8689]",
						"code": "8689"
					},
					{
						"title": "ミナミニツポン [0594]",
						"code": "0594"
					},
					{
						"title": "ミナミルモイノウキヨウ [3200]",
						"code": "3200"
					},
					{
						"title": "ミネノブノウキヨウ [3165]",
						"code": "3165"
					},
					{
						"title": "ミノリノウキヨウ [7249]",
						"code": "7249"
					},
					{
						"title": "ミハラノウキヨウ [8027]",
						"code": "8027"
					},
					{
						"title": "ミマノウキヨウ [8312]",
						"code": "8312"
					},
					{
						"title": "ミヤギケンギヨキヨウ [9453]",
						"code": "9453"
					},
					{
						"title": "ミヤギセンナンノウキヨウ [3751]",
						"code": "3751"
					},
					{
						"title": "ミヤギダイイチシンキン [1171]",
						"code": "1171"
					},
					{
						"title": "ミヤギトメノウキヨウ [3665]",
						"code": "3665"
					},
					{
						"title": "ミヤギワタリノウキヨウ [3653]",
						"code": "3653"
					},
					{
						"title": "ミヤコシンキン [1152]",
						"code": "1152"
					},
					{
						"title": "ミヤコノジヨウシンキン [1981]",
						"code": "1981"
					},
					{
						"title": "ミヤコノジヨウノウキヨウ [9184]",
						"code": "9184"
					},
					{
						"title": "ミヤザキ [0184]",
						"code": "0184"
					},
					{
						"title": "ミヤザキケンシンギヨレン [9494]",
						"code": "9494"
					},
					{
						"title": "ミヤザキケンシンレン [3045]",
						"code": "3045"
					},
					{
						"title": "ミヤザキケンナンブシンクミ [2884]",
						"code": "2884"
					},
					{
						"title": "ミヤザキシンキン [1980]",
						"code": "1980"
					},
					{
						"title": "ミヤザキタイヨウ [0591]",
						"code": "0591"
					},
					{
						"title": "ミヤザキチユウオウノウキヨウ [9169]",
						"code": "9169"
					},
					{
						"title": "ミヨウザイグンノウキヨウ [8242]",
						"code": "8242"
					},
					{
						"title": "ミヨシノウキヨウ [8069]",
						"code": "8069"
					},
					{
						"title": "ミレシンクミ [2582]",
						"code": "2582"
					},
					{
						"title": "ムカワノウキヨウ [3114]",
						"code": "3114"
					},
					{
						"title": "ムサシノ [0133]",
						"code": "0133"
					},
					{
						"title": "ムナカタノウキヨウ [8621]",
						"code": "8621"
					},
					{
						"title": "ムラカミシンキン [1379]",
						"code": "1379"
					},
					{
						"title": "ムロランシンキン [1003]",
						"code": "1003"
					},
					{
						"title": "メグミノノウキヨウ [6242]",
						"code": "6242"
					},
					{
						"title": "メグロシンキン [1346]",
						"code": "1346"
					},
					{
						"title": "メトロポリタン [0616]",
						"code": "0616"
					},
					{
						"title": "メマンベツチヨウノウキヨウ [3321]",
						"code": "3321"
					},
					{
						"title": "メムロチヨウノウキヨウ [3271]",
						"code": "3271"
					},
					{
						"title": "モオカシンクミ [2122]",
						"code": "2122"
					},
					{
						"title": "モミジ [0569]",
						"code": "0569"
					},
					{
						"title": "モリオカシンキン [1150]",
						"code": "1150"
					},
					{
						"title": "モリノミヤコシンキン [1170]",
						"code": "1170"
					},
					{
						"title": "モンベツチヨウノウキヨウ [3122]",
						"code": "3122"
					},
					{
						"title": "ヤイヅシンキン [1512]",
						"code": "1512"
					},
					{
						"title": "ヤサトノウキヨウ [4387]",
						"code": "4387"
					},
					{
						"title": "ヤチヨ [0597]",
						"code": "0597"
					},
					{
						"title": "ヤチヨシノウキヨウ [4955]",
						"code": "4955"
					},
					{
						"title": "ヤツシロチイキノウキヨウ [9017]",
						"code": "9017"
					},
					{
						"title": "ヤナガワノウキヨウ [8680]",
						"code": "8680"
					},
					{
						"title": "ヤマガタ [0122]",
						"code": "0122"
					},
					{
						"title": "ヤマガタオキタマノウキヨウ [3989]",
						"code": "3989"
					},
					{
						"title": "ヤマガタシノウキヨウ [3931]",
						"code": "3931"
					},
					{
						"title": "ヤマガタシンキン [1140]",
						"code": "1140"
					},
					{
						"title": "ヤマガタダイイチシンクミ [2085]",
						"code": "2085"
					},
					{
						"title": "ヤマガタチユウオウシンクミ [2084]",
						"code": "2084"
					},
					{
						"title": "ヤマガタノウキヨウ [3932]",
						"code": "3932"
					},
					{
						"title": "ヤマガタモガミノウキヨウ [3980]",
						"code": "3980"
					},
					{
						"title": "ヤマグチ [0170]",
						"code": "0170"
					},
					{
						"title": "ヤマグチウベノウキヨウ [8166]",
						"code": "8166"
					},
					{
						"title": "ヤマグチオオシマノウキヨウ [8096]",
						"code": "8096"
					},
					{
						"title": "ヤマグチケンギヨキヨウ [9484]",
						"code": "9484"
					},
					{
						"title": "ヤマグチケンシンクミ [2703]",
						"code": "2703"
					},
					{
						"title": "ヤマグチケンシンレン [3035]",
						"code": "3035"
					},
					{
						"title": "ヤマグチチユウオウノウキヨウ [8153]",
						"code": "8153"
					},
					{
						"title": "ヤマグチヒガシノウキヨウ [8103]",
						"code": "8103"
					},
					{
						"title": "ヤマグチミネノウキヨウ [8197]",
						"code": "8197"
					},
					{
						"title": "ヤマダムラノウキヨウ [5906]",
						"code": "5906"
					},
					{
						"title": "ヤマトシンキン [1667]",
						"code": "1667"
					},
					{
						"title": "ヤマナシケンシンレン [3015]",
						"code": "3015"
					},
					{
						"title": "ヤマナシケンミンシンクミ [2377]",
						"code": "2377"
					},
					{
						"title": "ヤマナシシンキン [1386]",
						"code": "1386"
					},
					{
						"title": "ヤマナシチユウオウ [0142]",
						"code": "0142"
					},
					{
						"title": "ユウキアオモリノウキヨウ [3469]",
						"code": "3469"
					},
					{
						"title": "ユウキシンキン [1242]",
						"code": "1242"
					},
					{
						"title": "ユウチヨ [9900]",
						"code": "9900"
					},
					{
						"title": "ユウバリシノウキヨウ [3173]",
						"code": "3173"
					},
					{
						"title": "ユウベツチヨウノウキヨウ [3305]",
						"code": "3305"
					},
					{
						"title": "ユナイテツド・オ－バ－シ－ズ [0438]",
						"code": "0438"
					},
					{
						"title": "ユバフ－アラブ・フランスレンゴウ [0456]",
						"code": "0456"
					},
					{
						"title": "ユ－ビ－エスエイジ－ [0439]",
						"code": "0439"
					},
					{
						"title": "ヨイチチヨウノウキヨウ [3095]",
						"code": "3095"
					},
					{
						"title": "ヨウテイノウキヨウ [3086]",
						"code": "3086"
					},
					{
						"title": "ヨコスカハヤマノウキヨウ [5128]",
						"code": "5128"
					},
					{
						"title": "ヨコハマ [0138]",
						"code": "0138"
					},
					{
						"title": "ヨコハマ [0138]",
						"code": "0138"
					},
					{
						"title": "ヨコハマカギンシンクミ [2307]",
						"code": "2307"
					},
					{
						"title": "ヨコハマシンキン [1280]",
						"code": "1280"
					},
					{
						"title": "ヨコハマチユウオウシンクミ [2306]",
						"code": "2306"
					},
					{
						"title": "ヨコハマノウキヨウ [5114]",
						"code": "5114"
					},
					{
						"title": "ヨシダグンノウキヨウ [6805]",
						"code": "6805"
					},
					{
						"title": "ヨナゴシンキン [1702]",
						"code": "1702"
					},
					{
						"title": "ヨネザワシンキン [1141]",
						"code": "1141"
					},
					{
						"title": "ラクテン [0036]",
						"code": "0036"
					},
					{
						"title": "リクベツチヨウノウキヨウ [3290]",
						"code": "3290"
					},
					{
						"title": "リソナ [0010]",
						"code": "0010"
					},
					{
						"title": "リツトウシノウキヨウ [6885]",
						"code": "6885"
					},
					{
						"title": "リホクノウキヨウ [5260]",
						"code": "5260"
					},
					{
						"title": "リユウガサキノウキヨウ [4344]",
						"code": "4344"
					},
					{
						"title": "リユウキユウ [0187]",
						"code": "0187"
					},
					{
						"title": "リヨウビシンクミ [2690]",
						"code": "2690"
					},
					{
						"title": "ルモイシンキン [1022]",
						"code": "1022"
					},
					{
						"title": "レイホクマチノウキヨウ [9072]",
						"code": "9072"
					},
					{
						"title": "レ－クイブキノウキヨウ [6919]",
						"code": "6919"
					},
					{
						"title": "レ－クオオツノウキヨウ [6874]",
						"code": "6874"
					},
					{
						"title": "ロイヤルバンク・オブ・スコツトランド・ピ－エルシ－ [0415]",
						"code": "0415"
					},
					{
						"title": "ロウキンレン [2950]",
						"code": "2950"
					},
					{
						"title": "ワカサノウキヨウ [6863]",
						"code": "6863"
					},
					{
						"title": "ワカヤマケンイシシンクミ [2634]",
						"code": "2634"
					},
					{
						"title": "ワカヤマケンシンギヨレン [9479]",
						"code": "9479"
					},
					{
						"title": "ワカヤマケンシンレン [3030]",
						"code": "3030"
					},
					{
						"title": "ワカヤマノウキヨウ [7532]",
						"code": "7532"
					},
					{
						"title": "ワツカナイシンキン [1021]",
						"code": "1021"
					},
					{
						"title": "ワツカナイノウキヨウ [3254]",
						"code": "3254"
					},
					{
						"title": "ＪＦシマネギヨキヨウ [9481]",
						"code": "9481"
					},
					{
						"title": "Bank of Japan",
						"code": "0000"
					},
					{
						"title": "日本銀行",
						"code": "0000"
					},
					{
						"title": "Mizuho Bank",
						"code": "0001"
					},
					{
						"title": "みずほ銀行",
						"code": "0001"
					},
					{
						"title": "三菱東京ＵＦＪ銀行",
						"code": "0005"
					},
					{
						"title": "Bank of Tokyo-Mitsubishi UFJ Ltd.",
						"code": "0005"
					},
					{
						"title": "三井住友銀行",
						"code": "0009"
					},
					{
						"title": "Sumitomo Mitsui Banking Corporation (SMBC)",
						"code": "0009"
					},
					{
						"title": "Resona Bank",
						"code": "0010"
					},
					{
						"title": "りそな銀行",
						"code": "0010"
					},
					{
						"title": "埼玉りそな銀行",
						"code": "0017"
					},
					{
						"title": "Saitama Resona Bank",
						"code": "0017"
					},
					{
						"title": "Japan Net Bank",
						"code": "0033"
					},
					{
						"title": "ジャパンネット銀行",
						"code": "0033"
					},
					{
						"title": "セブン銀行",
						"code": "0034"
					},
					{
						"title": "Seven Bank",
						"code": "0034"
					},
					{
						"title": "Sony Bank",
						"code": "0035"
					},
					{
						"title": "ソニー銀行",
						"code": "0035"
					},
					{
						"title": "Rakuten Bank",
						"code": "0036"
					},
					{
						"title": "楽天銀行",
						"code": "0036"
					},
					{
						"title": "Sumitomo Trust SBI net bank",
						"code": "0038"
					},
					{
						"title": "住信ＳＢＩネット銀行",
						"code": "0038"
					},
					{
						"title": "じぶん銀行",
						"code": "0039"
					},
					{
						"title": "Jibun",
						"code": "0039"
					},
					{
						"title": "Ion Bank",
						"code": "0040"
					},
					{
						"title": "イオン銀行",
						"code": "0040"
					},
					{
						"title": "大和ネクスト銀行",
						"code": "0041"
					},
					{
						"title": "Daiwa Next Bank",
						"code": "0041"
					},
					{
						"title": "Hokkaido Bank Ltd.",
						"code": "0116"
					},
					{
						"title": "北海道銀行",
						"code": "0116"
					},
					{
						"title": "Hokkaido Bank, Ltd.",
						"code": "0116"
					},
					{
						"title": "青森銀行",
						"code": "0117"
					},
					{
						"title": "Aomori Bank Ltd.",
						"code": "0117"
					},
					{
						"title": "Aomori Bank, Ltd.",
						"code": "0117"
					},
					{
						"title": "みちのく銀行",
						"code": "0118"
					},
					{
						"title": "Michinoku Bank Ltd.",
						"code": "0118"
					},
					{
						"title": "Michinoku Bank, Ltd.",
						"code": "0118"
					},
					{
						"title": "秋田銀行",
						"code": "0119"
					},
					{
						"title": "Akita Bank",
						"code": "0119"
					},
					{
						"title": "北都銀行",
						"code": "0120"
					},
					{
						"title": "Hokuto Bank",
						"code": "0120"
					},
					{
						"title": "Shonai Bank",
						"code": "0121"
					},
					{
						"title": "荘内銀行",
						"code": "0121"
					},
					{
						"title": "山形銀行",
						"code": "0122"
					},
					{
						"title": "Yamagata",
						"code": "0122"
					},
					{
						"title": "Bank of Iwate Ltd.",
						"code": "0123"
					},
					{
						"title": "岩手銀行",
						"code": "0123"
					},
					{
						"title": "Bank of Iwate, Ltd.",
						"code": "0123"
					},
					{
						"title": "Tohoku Bank",
						"code": "0124"
					},
					{
						"title": "東北銀行",
						"code": "0124"
					},
					{
						"title": "77 Bank Ltd.",
						"code": "0125"
					},
					{
						"title": "七十七銀行",
						"code": "0125"
					},
					{
						"title": "77 Bank, Ltd.",
						"code": "0125"
					},
					{
						"title": "東邦銀行",
						"code": "0126"
					},
					{
						"title": "Toho Bank Ltd.",
						"code": "0126"
					},
					{
						"title": "Toho Bank, Ltd.",
						"code": "0126"
					},
					{
						"title": "群馬銀行",
						"code": "0128"
					},
					{
						"title": "Gunma Bank Ltd.",
						"code": "0128"
					},
					{
						"title": "Gunma Bank, Ltd.",
						"code": "0128"
					},
					{
						"title": "足利銀行",
						"code": "0129"
					},
					{
						"title": "Ashikaga Bank",
						"code": "0129"
					},
					{
						"title": "Joyo Bank Ltd.",
						"code": "0130"
					},
					{
						"title": "常陽銀行",
						"code": "0130"
					},
					{
						"title": "Tsukuba Bank",
						"code": "0131"
					},
					{
						"title": "筑波銀行",
						"code": "0131"
					},
					{
						"title": "Musashino Bank Ltd.",
						"code": "0133"
					},
					{
						"title": "武蔵野銀行",
						"code": "0133"
					},
					{
						"title": "Musashino Bank, Ltd.",
						"code": "0133"
					},
					{
						"title": "Chiba Bank Ltd.",
						"code": "0134"
					},
					{
						"title": "千葉銀行",
						"code": "0134"
					},
					{
						"title": "Chiba Bank, Ltd.",
						"code": "0134"
					},
					{
						"title": "Chiba Kogyo Bank",
						"code": "0135"
					},
					{
						"title": "千葉興業銀行",
						"code": "0135"
					},
					{
						"title": "東京都民銀行",
						"code": "0137"
					},
					{
						"title": "Tokyo Tomin Bank Limited",
						"code": "0137"
					},
					{
						"title": "Tokyo Tomin Bank, Limited",
						"code": "0137"
					},
					{
						"title": "Bank of Yokohama Ltd.",
						"code": "0138"
					},
					{
						"title": "横浜銀行",
						"code": "0138"
					},
					{
						"title": "横浜銀行",
						"code": "0138"
					},
					{
						"title": "Bank of Yokohama, Ltd.",
						"code": "0138"
					},
					{
						"title": "第四銀行",
						"code": "0140"
					},
					{
						"title": "Daishi Bank Ltd.",
						"code": "0140"
					},
					{
						"title": "Daishi Bank, Ltd.",
						"code": "0140"
					},
					{
						"title": "北越銀行",
						"code": "0141"
					},
					{
						"title": "Hokuetsuginko",
						"code": "0141"
					},
					{
						"title": "Yamanashi Chuo Bank",
						"code": "0142"
					},
					{
						"title": "山梨中央銀行",
						"code": "0142"
					},
					{
						"title": "Hachijuni",
						"code": "0143"
					},
					{
						"title": "八十二銀行",
						"code": "0143"
					},
					{
						"title": "北陸銀行",
						"code": "0144"
					},
					{
						"title": "Hokuriku Bank Ltd.",
						"code": "0144"
					},
					{
						"title": "Hokuriku Bank, Ltd.",
						"code": "0144"
					},
					{
						"title": "Toyamaginko",
						"code": "0145"
					},
					{
						"title": "富山銀行",
						"code": "0145"
					},
					{
						"title": "Hokkokuginko",
						"code": "0146"
					},
					{
						"title": "北國銀行",
						"code": "0146"
					},
					{
						"title": "Fukuiginko",
						"code": "0147"
					},
					{
						"title": "福井銀行",
						"code": "0147"
					},
					{
						"title": "静岡銀行",
						"code": "0149"
					},
					{
						"title": "Shizuoka Bank Ltd.",
						"code": "0149"
					},
					{
						"title": "Suruga Bank",
						"code": "0150"
					},
					{
						"title": "スルガ銀行",
						"code": "0150"
					},
					{
						"title": "清水銀行",
						"code": "0151"
					},
					{
						"title": "Shimizuginko",
						"code": "0151"
					},
					{
						"title": "大垣共立銀行",
						"code": "0152"
					},
					{
						"title": "Ogaki Kyoritsu Bank Ltd.",
						"code": "0152"
					},
					{
						"title": "Ogaki Kyoritsu Bank, Ltd.",
						"code": "0152"
					},
					{
						"title": "十六銀行",
						"code": "0153"
					},
					{
						"title": "Juroku",
						"code": "0153"
					},
					{
						"title": "三重銀行",
						"code": "0154"
					},
					{
						"title": "Mie Bank",
						"code": "0154"
					},
					{
						"title": "百五銀行",
						"code": "0155"
					},
					{
						"title": "Hyakugo Bank Ltd.",
						"code": "0155"
					},
					{
						"title": "Hyakugo Bank, Ltd.",
						"code": "0155"
					},
					{
						"title": "Shiga Bank Ltd.",
						"code": "0157"
					},
					{
						"title": "滋賀銀行",
						"code": "0157"
					},
					{
						"title": "滋賀銀行",
						"code": "0157"
					},
					{
						"title": "Shiga Bank, Ltd.",
						"code": "0157"
					},
					{
						"title": "京都銀行",
						"code": "0158"
					},
					{
						"title": "Bank of Kyoto Ltd.",
						"code": "0158"
					},
					{
						"title": "Bank of Kyoto, Ltd.",
						"code": "0158"
					},
					{
						"title": "近畿大阪銀行",
						"code": "0159"
					},
					{
						"title": "Kinki Osaka Bank",
						"code": "0159"
					},
					{
						"title": "池田泉州銀行",
						"code": "0161"
					},
					{
						"title": "Ikeda Senshu",
						"code": "0161"
					},
					{
						"title": "Nanto Bank Ltd.",
						"code": "0162"
					},
					{
						"title": "南都銀行",
						"code": "0162"
					},
					{
						"title": "Nanto Bank, Ltd.",
						"code": "0162"
					},
					{
						"title": "Kiyo Bank",
						"code": "0163"
					},
					{
						"title": "紀陽銀行",
						"code": "0163"
					},
					{
						"title": "Tajimaginko",
						"code": "0164"
					},
					{
						"title": "但馬銀行",
						"code": "0164"
					},
					{
						"title": "Tottori",
						"code": "0166"
					},
					{
						"title": "鳥取銀行",
						"code": "0166"
					},
					{
						"title": "山陰合同銀行",
						"code": "0167"
					},
					{
						"title": "San-in Godo Bank Ltd.",
						"code": "0167"
					},
					{
						"title": "San-in Godo Bank, Ltd.",
						"code": "0167"
					},
					{
						"title": "Chugoku Bank",
						"code": "0168"
					},
					{
						"title": "中国銀行",
						"code": "0168"
					},
					{
						"title": "Hiroshima Bank",
						"code": "0169"
					},
					{
						"title": "広島銀行",
						"code": "0169"
					},
					{
						"title": "Yamaguchi Bank",
						"code": "0170"
					},
					{
						"title": "山口銀行",
						"code": "0170"
					},
					{
						"title": "Awaginko",
						"code": "0172"
					},
					{
						"title": "阿波銀行",
						"code": "0172"
					},
					{
						"title": "百十四銀行",
						"code": "0173"
					},
					{
						"title": "Hyakujushiginko",
						"code": "0173"
					},
					{
						"title": "伊予銀行",
						"code": "0174"
					},
					{
						"title": "Iyo Bank Ltd.",
						"code": "0174"
					},
					{
						"title": "Iyo Bank, Ltd.",
						"code": "0174"
					},
					{
						"title": "Shikoku Bank Ltd.",
						"code": "0175"
					},
					{
						"title": "四国銀行",
						"code": "0175"
					},
					{
						"title": "Bank of Fukuoka Ltd.",
						"code": "0177"
					},
					{
						"title": "福岡銀行",
						"code": "0177"
					},
					{
						"title": "Bank of Fukuoka, Ltd.",
						"code": "0177"
					},
					{
						"title": "Chikuhoginko",
						"code": "0178"
					},
					{
						"title": "筑邦銀行",
						"code": "0178"
					},
					{
						"title": "佐賀銀行",
						"code": "0179"
					},
					{
						"title": "Bank of Saga Ltd.",
						"code": "0179"
					},
					{
						"title": "Eighteenth Bank Limited",
						"code": "0180"
					},
					{
						"title": "十八銀行",
						"code": "0180"
					},
					{
						"title": "Eighteenth Bank, Limited",
						"code": "0180"
					},
					{
						"title": "Shinwa Bank Ltd.",
						"code": "0181"
					},
					{
						"title": "親和銀行",
						"code": "0181"
					},
					{
						"title": "Shinwa Bank, Ltd.",
						"code": "0181"
					},
					{
						"title": "Higo Bank",
						"code": "0182"
					},
					{
						"title": "肥後銀行",
						"code": "0182"
					},
					{
						"title": "大分銀行",
						"code": "0183"
					},
					{
						"title": "Oita Bank Ltd.",
						"code": "0183"
					},
					{
						"title": "Oita Bank, Ltd.",
						"code": "0183"
					},
					{
						"title": "宮崎銀行",
						"code": "0184"
					},
					{
						"title": "Miyazakiginko",
						"code": "0184"
					},
					{
						"title": "Kagoshima Bank",
						"code": "0185"
					},
					{
						"title": "鹿児島銀行",
						"code": "0185"
					},
					{
						"title": "琉球銀行",
						"code": "0187"
					},
					{
						"title": "Bank of The Ryukyus Limited",
						"code": "0187"
					},
					{
						"title": "Bank of The Ryukyus, Limited",
						"code": "0187"
					},
					{
						"title": "沖縄銀行",
						"code": "0188"
					},
					{
						"title": "Okinawaginko",
						"code": "0188"
					},
					{
						"title": "西日本シティ銀行",
						"code": "0190"
					},
					{
						"title": "Nishi-Nippon City Bank",
						"code": "0190"
					},
					{
						"title": "Kitakyushu Bank",
						"code": "0191"
					},
					{
						"title": "北九州銀行",
						"code": "0191"
					},
					{
						"title": "Mitsubishi UFJ Trust and Banking",
						"code": "0288"
					},
					{
						"title": "三菱ＵＦＪ信託銀行",
						"code": "0288"
					},
					{
						"title": "Mizuho Trust & Banking Co. Ltd.",
						"code": "0289"
					},
					{
						"title": "みずほ信託銀行",
						"code": "0289"
					},
					{
						"title": "Mizuho Trust & Banking Co., Ltd.",
						"code": "0289"
					},
					{
						"title": "三井住友信託銀行",
						"code": "0294"
					},
					{
						"title": "Sumitomo Mitsui Trust Bank",
						"code": "0294"
					},
					{
						"title": "ニューヨークメロン信託銀行",
						"code": "0295"
					},
					{
						"title": "New York Mellon Trust and Banking",
						"code": "0295"
					},
					{
						"title": "日本マスタートラスト信託銀行",
						"code": "0297"
					},
					{
						"title": "The Master Trust Bank of Japan",
						"code": "0297"
					},
					{
						"title": "The Master Trust Bank of Japan,",
						"code": "0297"
					},
					{
						"title": "State Street Trust and Banking",
						"code": "0299"
					},
					{
						"title": "ステート・ストリート信託銀行",
						"code": "0299"
					},
					{
						"title": "ＳＭＢＣ信託銀行",
						"code": "0300"
					},
					{
						"title": "SMBC Bank",
						"code": "0300"
					},
					{
						"title": "野村信託銀行",
						"code": "0304"
					},
					{
						"title": "The Nomura Trust and Banking",
						"code": "0304"
					},
					{
						"title": "オリックス銀行",
						"code": "0307"
					},
					{
						"title": "ORIX Bank",
						"code": "0307"
					},
					{
						"title": "Shinkin Bank",
						"code": "0309"
					},
					{
						"title": "しんきん信託銀行",
						"code": "0309"
					},
					{
						"title": "あおぞら信託銀行",
						"code": "0310"
					},
					{
						"title": "Aozora Trust Bank",
						"code": "0310"
					},
					{
						"title": "農中信託銀行",
						"code": "0311"
					},
					{
						"title": "Norinchukin Trust & Banking",
						"code": "0311"
					},
					{
						"title": "新生信託銀行",
						"code": "0320"
					},
					{
						"title": "Shinsei Trust Bank",
						"code": "0320"
					},
					{
						"title": "Japan Securities Finance Co. Ltd. Trust and Banking",
						"code": "0321"
					},
					{
						"title": "日証金信託銀行",
						"code": "0321"
					},
					{
						"title": "Japan Securities Finance Co., Ltd. Trust and Banking",
						"code": "0321"
					},
					{
						"title": "新銀行東京",
						"code": "0322"
					},
					{
						"title": "New Bank Tokyo",
						"code": "0322"
					},
					{
						"title": "Japan Trustee Services Bank",
						"code": "0324"
					},
					{
						"title": "日本トラスティ・サービス信託銀行",
						"code": "0324"
					},
					{
						"title": "Japan Trustee Services Bank,",
						"code": "0324"
					},
					{
						"title": "Trust & Custody Services Bank",
						"code": "0325"
					},
					{
						"title": "資産管理サービス信託銀行",
						"code": "0325"
					},
					{
						"title": "新生銀行",
						"code": "0397"
					},
					{
						"title": "Shinsei Bank",
						"code": "0397"
					},
					{
						"title": "Aozora Bank",
						"code": "0398"
					},
					{
						"title": "あおぞら銀行",
						"code": "0398"
					},
					{
						"title": "シティバンク銀行",
						"code": "0401"
					},
					{
						"title": "Citibank",
						"code": "0401"
					},
					{
						"title": "ジェー・ピー・モルガン・チェース・バンク・ナショナル・アソシエーション",
						"code": "0402"
					},
					{
						"title": "JPMorgan Chase Bank National Association",
						"code": "0402"
					},
					{
						"title": "JPMorgan Chase Bank, National Association",
						"code": "0402"
					},
					{
						"title": "バンク・オブ・アメリカ・エヌ・エイ",
						"code": "0403"
					},
					{
						"title": "Bank of America NA",
						"code": "0403"
					},
					{
						"title": "Bank of America, NA",
						"code": "0403"
					},
					{
						"title": "Hongkong and Shanghai Banking Corporation Limited",
						"code": "0411"
					},
					{
						"title": "香港上海銀行",
						"code": "0411"
					},
					{
						"title": "スタンダードチャータード銀行",
						"code": "0413"
					},
					{
						"title": "Standard Chartered Bank",
						"code": "0413"
					},
					{
						"title": "Barclays Bank",
						"code": "0414"
					},
					{
						"title": "バークレイズ銀行",
						"code": "0414"
					},
					{
						"title": "ロイヤルバンク・オブ・スコットランド・ピーエルシー",
						"code": "0415"
					},
					{
						"title": "Royal Bank of Scotland plc",
						"code": "0415"
					},
					{
						"title": "クレディ・アグリコル銀行",
						"code": "0421"
					},
					{
						"title": "Credit Agricole Bank",
						"code": "0421"
					},
					{
						"title": "Hana Bank",
						"code": "0423"
					},
					{
						"title": "ハナ銀行",
						"code": "0423"
					},
					{
						"title": "印度銀行",
						"code": "0424"
					},
					{
						"title": "Indian Bank",
						"code": "0424"
					},
					{
						"title": "兆豐國際商業銀行",
						"code": "0425"
					},
					{
						"title": "Trillion commercial banks when 豐國",
						"code": "0425"
					},
					{
						"title": "バンコック銀行",
						"code": "0426"
					},
					{
						"title": "Bangkok Bank",
						"code": "0426"
					},
					{
						"title": "バンクネガラインドネシア",
						"code": "0429"
					},
					{
						"title": "Bank Negara Indonesia",
						"code": "0429"
					},
					{
						"title": "Deutsche Bank AG",
						"code": "0430"
					},
					{
						"title": "ドイツ銀行",
						"code": "0430"
					},
					{
						"title": "ユナイテッド・オーバーシーズ銀行",
						"code": "0438"
					},
					{
						"title": "United Overseas Bank",
						"code": "0438"
					},
					{
						"title": "UBS AG",
						"code": "0439"
					},
					{
						"title": "ユービーエス・エイ・ジー",
						"code": "0439"
					},
					{
						"title": "Bank of New York Mellon",
						"code": "0442"
					},
					{
						"title": "ニューヨークメロン銀行",
						"code": "0442"
					},
					{
						"title": "ビー・エヌ・ピー・パリバ銀行",
						"code": "0443"
					},
					{
						"title": "BNP Paribas Bank",
						"code": "0443"
					},
					{
						"title": "Oversea-Chinese Banking Corporation",
						"code": "0444"
					},
					{
						"title": "オーバーシー・チャイニーズ銀行",
						"code": "0444"
					},
					{
						"title": "Societe Generale bank",
						"code": "0445"
					},
					{
						"title": "ソシエテ・ジェネラル銀行",
						"code": "0445"
					},
					{
						"title": "ユバフーアラブ・フランス連合銀行",
						"code": "0456"
					},
					{
						"title": "Yubafuarabu France Union Bank",
						"code": "0456"
					},
					{
						"title": "ＤＢＳ銀行",
						"code": "0458"
					},
					{
						"title": "DBS Bank",
						"code": "0458"
					},
					{
						"title": "パキスタン・ナショナル銀行",
						"code": "0459"
					},
					{
						"title": "Pakistan National Bank",
						"code": "0459"
					},
					{
						"title": "Credit Suisse Bank",
						"code": "0460"
					},
					{
						"title": "クレディ・スイス銀行",
						"code": "0460"
					},
					{
						"title": "コメルツ銀行",
						"code": "0461"
					},
					{
						"title": "Commerzbank AG",
						"code": "0461"
					},
					{
						"title": "ウニクレディト銀行",
						"code": "0463"
					},
					{
						"title": "Unicredit Bank",
						"code": "0463"
					},
					{
						"title": "インドステイト銀行",
						"code": "0468"
					},
					{
						"title": "State Bank of India",
						"code": "0468"
					},
					{
						"title": "インドステイト銀行",
						"code": "0468"
					},
					{
						"title": "State Bank of India",
						"code": "0468"
					},
					{
						"title": "Royal Bank of Canada",
						"code": "0471"
					},
					{
						"title": "カナダロイヤル銀行",
						"code": "0471"
					},
					{
						"title": "ＳＢＪ銀行",
						"code": "0472"
					},
					{
						"title": "SBJ Bank",
						"code": "0472"
					},
					{
						"title": "Woori Bank",
						"code": "0477"
					},
					{
						"title": "ウリィ銀行",
						"code": "0477"
					},
					{
						"title": "ING Bank NV",
						"code": "0482"
					},
					{
						"title": "アイエヌジー　バンク　エヌ・ヴイ",
						"code": "0482"
					},
					{
						"title": "National Australia Bank",
						"code": "0484"
					},
					{
						"title": "ナショナル・オーストラリア銀行",
						"code": "0484"
					},
					{
						"title": "オーストラリア・コモンウェルス銀行",
						"code": "0487"
					},
					{
						"title": "Commonwealth Bank of Australia",
						"code": "0487"
					},
					{
						"title": "中國銀行（ＢＡＮＫ　ＯＦ　ＣＨＩＮＡ）",
						"code": "0489"
					},
					{
						"title": "Chinese Bank (BANK OF CHINA)",
						"code": "0489"
					},
					{
						"title": "State Street Bank and Trust Company",
						"code": "0495"
					},
					{
						"title": "ステート・ストリート銀行",
						"code": "0495"
					},
					{
						"title": "中小企業銀行",
						"code": "0498"
					},
					{
						"title": "SME Bank",
						"code": "0498"
					},
					{
						"title": "North Pacific Bank Ltd.",
						"code": "0501"
					},
					{
						"title": "北洋銀行",
						"code": "0501"
					},
					{
						"title": "Kirayaka Bank",
						"code": "0508"
					},
					{
						"title": "きらやか銀行",
						"code": "0508"
					},
					{
						"title": "北日本銀行",
						"code": "0509"
					},
					{
						"title": "Kita-Nippon Bank Ltd.",
						"code": "0509"
					},
					{
						"title": "Kita-Nippon Bank, Ltd.",
						"code": "0509"
					},
					{
						"title": "Sendaiginko",
						"code": "0512"
					},
					{
						"title": "仙台銀行",
						"code": "0512"
					},
					{
						"title": "福島銀行",
						"code": "0513"
					},
					{
						"title": "Fukushimaginko",
						"code": "0513"
					},
					{
						"title": "Daitoginko",
						"code": "0514"
					},
					{
						"title": "大東銀行",
						"code": "0514"
					},
					{
						"title": "東和銀行",
						"code": "0516"
					},
					{
						"title": "Towa Bank",
						"code": "0516"
					},
					{
						"title": "栃木銀行",
						"code": "0517"
					},
					{
						"title": "Tochigiginko",
						"code": "0517"
					},
					{
						"title": "京葉銀行",
						"code": "0522"
					},
					{
						"title": "Keiyo Bank",
						"code": "0522"
					},
					{
						"title": "東日本銀行",
						"code": "0525"
					},
					{
						"title": "Higashinipponginko",
						"code": "0525"
					},
					{
						"title": "東京スター銀行",
						"code": "0526"
					},
					{
						"title": "Tokyo Star Bank",
						"code": "0526"
					},
					{
						"title": "Kanagawa Bank",
						"code": "0530"
					},
					{
						"title": "神奈川銀行",
						"code": "0530"
					},
					{
						"title": "大光銀行",
						"code": "0532"
					},
					{
						"title": "Taikoginko",
						"code": "0532"
					},
					{
						"title": "Nagano Bank",
						"code": "0533"
					},
					{
						"title": "長野銀行",
						"code": "0533"
					},
					{
						"title": "Toyamadaiichiginko",
						"code": "0534"
					},
					{
						"title": "富山第一銀行",
						"code": "0534"
					},
					{
						"title": "福邦銀行",
						"code": "0537"
					},
					{
						"title": "Fukuhoginko",
						"code": "0537"
					},
					{
						"title": "Shizuokachuoginko",
						"code": "0538"
					},
					{
						"title": "静岡中央銀行",
						"code": "0538"
					},
					{
						"title": "Aichi Bank",
						"code": "0542"
					},
					{
						"title": "愛知銀行",
						"code": "0542"
					},
					{
						"title": "Bank of Nagoya Ltd.",
						"code": "0543"
					},
					{
						"title": "名古屋銀行",
						"code": "0543"
					},
					{
						"title": "Bank of Nagoya, Ltd.",
						"code": "0543"
					},
					{
						"title": "Chukyo Bank",
						"code": "0544"
					},
					{
						"title": "中京銀行",
						"code": "0544"
					},
					{
						"title": "Daisan Bank",
						"code": "0546"
					},
					{
						"title": "第三銀行",
						"code": "0546"
					},
					{
						"title": "Kansai Urban Bank",
						"code": "0554"
					},
					{
						"title": "関西アーバン銀行",
						"code": "0554"
					},
					{
						"title": "大正銀行",
						"code": "0555"
					},
					{
						"title": "Taisho Bank",
						"code": "0555"
					},
					{
						"title": "みなと銀行",
						"code": "0562"
					},
					{
						"title": "Minato Bank",
						"code": "0562"
					},
					{
						"title": "島根銀行",
						"code": "0565"
					},
					{
						"title": "Shimaneginko",
						"code": "0565"
					},
					{
						"title": "トマト銀行",
						"code": "0566"
					},
					{
						"title": "Tomato Bank",
						"code": "0566"
					},
					{
						"title": "もみじ銀行",
						"code": "0569"
					},
					{
						"title": "Momiji Bank",
						"code": "0569"
					},
					{
						"title": "西京銀行",
						"code": "0570"
					},
					{
						"title": "Saikyo Bank",
						"code": "0570"
					},
					{
						"title": "徳島銀行",
						"code": "0572"
					},
					{
						"title": "Tokushimaginko",
						"code": "0572"
					},
					{
						"title": "Kagawa Bank Ltd.",
						"code": "0573"
					},
					{
						"title": "香川銀行",
						"code": "0573"
					},
					{
						"title": "Kagawa Bank, Ltd.",
						"code": "0573"
					},
					{
						"title": "Ehime",
						"code": "0576"
					},
					{
						"title": "愛媛銀行",
						"code": "0576"
					},
					{
						"title": "高知銀行",
						"code": "0578"
					},
					{
						"title": "Kochiginko",
						"code": "0578"
					},
					{
						"title": "福岡中央銀行",
						"code": "0582"
					},
					{
						"title": "Fukuokachuoginko",
						"code": "0582"
					},
					{
						"title": "Saga Kyoei Bank",
						"code": "0583"
					},
					{
						"title": "佐賀共栄銀行",
						"code": "0583"
					},
					{
						"title": "Nagasakiginko",
						"code": "0585"
					},
					{
						"title": "長崎銀行",
						"code": "0585"
					},
					{
						"title": "熊本銀行",
						"code": "0587"
					},
					{
						"title": "Kumamoto Bank",
						"code": "0587"
					},
					{
						"title": "Howaginko",
						"code": "0590"
					},
					{
						"title": "豊和銀行",
						"code": "0590"
					},
					{
						"title": "宮崎太陽銀行",
						"code": "0591"
					},
					{
						"title": "Miyazakitaiyoginko",
						"code": "0591"
					},
					{
						"title": "南日本銀行",
						"code": "0594"
					},
					{
						"title": "Minaminipponginko",
						"code": "0594"
					},
					{
						"title": "Okinawakaihoginko",
						"code": "0596"
					},
					{
						"title": "沖縄海邦銀行",
						"code": "0596"
					},
					{
						"title": "Yachiyo",
						"code": "0597"
					},
					{
						"title": "八千代銀行",
						"code": "0597"
					},
					{
						"title": "Korea Development Bank",
						"code": "0603"
					},
					{
						"title": "韓国産業銀行",
						"code": "0603"
					},
					{
						"title": "彰化商業銀行",
						"code": "0607"
					},
					{
						"title": "Changhua Commercial Bank",
						"code": "0607"
					},
					{
						"title": "ウェルズ・ファーゴ銀行",
						"code": "0608"
					},
					{
						"title": "Wells Fargo Bank",
						"code": "0608"
					},
					{
						"title": "First Commercial Bank",
						"code": "0611"
					},
					{
						"title": "第一商業銀行",
						"code": "0611"
					},
					{
						"title": "Taiwan Bank",
						"code": "0612"
					},
					{
						"title": "台湾銀行",
						"code": "0612"
					},
					{
						"title": "メトロポリタン銀行",
						"code": "0616"
					},
					{
						"title": "Metropolitan Bank",
						"code": "0616"
					},
					{
						"title": "フィリピン・ナショナル・バンク",
						"code": "0617"
					},
					{
						"title": "Philippine National Bank",
						"code": "0617"
					},
					{
						"title": "中国工商銀行",
						"code": "0619"
					},
					{
						"title": "Industrial and Commercial Bank of China",
						"code": "0619"
					},
					{
						"title": "デプファ・バンク・ピーエルシー（銀行）",
						"code": "0620"
					},
					{
						"title": "Depufa Bank PLC (Bank)",
						"code": "0620"
					},
					{
						"title": "中國信託商業銀行",
						"code": "0621"
					},
					{
						"title": "Chinese trust commercial banks",
						"code": "0621"
					},
					{
						"title": "Intesa Sanpaolo",
						"code": "0623"
					},
					{
						"title": "インテーザ・サンパオロ",
						"code": "0623"
					},
					{
						"title": "國民銀行（Ｋｏｏｋｍｉｎ　Ｂａｎｋ）",
						"code": "0624"
					},
					{
						"title": "Kokumin Bank (Kookmin Bank)",
						"code": "0624"
					},
					{
						"title": "CHINA CONSTRUCTION BANK",
						"code": "0625"
					},
					{
						"title": "中国建設銀行",
						"code": "0625"
					},
					{
						"title": "イタウ・ウニバンコ銀行",
						"code": "0626"
					},
					{
						"title": "Itau Unibanco Bank",
						"code": "0626"
					},
					{
						"title": "Banco Bilbao Vizcaya Argentaria",
						"code": "0627"
					},
					{
						"title": "ビルバオ・ビスカヤ・アルヘンタリア銀行",
						"code": "0627"
					},
					{
						"title": "Agricultural Bank of China",
						"code": "0630"
					},
					{
						"title": "中国農業銀行",
						"code": "0630"
					},
					{
						"title": "信金中央金庫",
						"code": "1000"
					},
					{
						"title": "Shinkin Central Bank",
						"code": "1000"
					},
					{
						"title": "札幌信用金庫",
						"code": "1001"
					},
					{
						"title": "Sapporo credit union",
						"code": "1001"
					},
					{
						"title": "Muroranshin'yokinko",
						"code": "1003"
					},
					{
						"title": "室蘭信用金庫",
						"code": "1003"
					},
					{
						"title": "Sorachishin'yokinko",
						"code": "1004"
					},
					{
						"title": "空知信用金庫",
						"code": "1004"
					},
					{
						"title": "Tomakomaishin'yokinko",
						"code": "1006"
					},
					{
						"title": "苫小牧信用金庫",
						"code": "1006"
					},
					{
						"title": "Hokumonshin'yokinko",
						"code": "1008"
					},
					{
						"title": "北門信用金庫",
						"code": "1008"
					},
					{
						"title": "伊達信用金庫",
						"code": "1009"
					},
					{
						"title": "Dateshin'yokinko",
						"code": "1009"
					},
					{
						"title": "Kitasorachishin'yokinko",
						"code": "1010"
					},
					{
						"title": "北空知信用金庫",
						"code": "1010"
					},
					{
						"title": "日高信用金庫",
						"code": "1011"
					},
					{
						"title": "Hidakashin'yokinko",
						"code": "1011"
					},
					{
						"title": "Hakodateshin'yokinko",
						"code": "1012"
					},
					{
						"title": "函館信用金庫",
						"code": "1012"
					},
					{
						"title": "渡島信用金庫",
						"code": "1013"
					},
					{
						"title": "Oshimashin'yokinko",
						"code": "1013"
					},
					{
						"title": "江差信用金庫",
						"code": "1014"
					},
					{
						"title": "Esashishin'yokinko",
						"code": "1014"
					},
					{
						"title": "小樽信用金庫",
						"code": "1016"
					},
					{
						"title": "Otaru credit union",
						"code": "1016"
					},
					{
						"title": "北海信用金庫",
						"code": "1018"
					},
					{
						"title": "Hokkaishin'yokinko",
						"code": "1018"
					},
					{
						"title": "Asahikawashin'yokinko",
						"code": "1020"
					},
					{
						"title": "旭川信用金庫",
						"code": "1020"
					},
					{
						"title": "Wakkanaishin'yokinko",
						"code": "1021"
					},
					{
						"title": "稚内信用金庫",
						"code": "1021"
					},
					{
						"title": "Rumoishin'yokinko",
						"code": "1022"
					},
					{
						"title": "留萌信用金庫",
						"code": "1022"
					},
					{
						"title": "Hokusei credit union",
						"code": "1024"
					},
					{
						"title": "北星信用金庫",
						"code": "1024"
					},
					{
						"title": "帯広信用金庫",
						"code": "1026"
					},
					{
						"title": "Obihiroshin'yokinko",
						"code": "1026"
					},
					{
						"title": "Kushiro credit union",
						"code": "1027"
					},
					{
						"title": "釧路信用金庫",
						"code": "1027"
					},
					{
						"title": "Mirai Ochi credit union",
						"code": "1028"
					},
					{
						"title": "大地みらい信用金庫",
						"code": "1028"
					},
					{
						"title": "北見信用金庫",
						"code": "1030"
					},
					{
						"title": "Kitamishin'yokinko",
						"code": "1030"
					},
					{
						"title": "網走信用金庫",
						"code": "1031"
					},
					{
						"title": "Abashirishin'yokinko",
						"code": "1031"
					},
					{
						"title": "Engarushin'yokinko",
						"code": "1033"
					},
					{
						"title": "遠軽信用金庫",
						"code": "1033"
					},
					{
						"title": "東奥信用金庫",
						"code": "1104"
					},
					{
						"title": "Higashioku credit union",
						"code": "1104"
					},
					{
						"title": "Blue forest credit union",
						"code": "1105"
					},
					{
						"title": "青い森信用金庫",
						"code": "1105"
					},
					{
						"title": "秋田信用金庫",
						"code": "1120"
					},
					{
						"title": "Akita credit union",
						"code": "1120"
					},
					{
						"title": "Ugoshin'yokinko",
						"code": "1123"
					},
					{
						"title": "羽後信用金庫",
						"code": "1123"
					},
					{
						"title": "Yamagata credit union",
						"code": "1140"
					},
					{
						"title": "山形信用金庫",
						"code": "1140"
					},
					{
						"title": "Yonezawashin'yokinko",
						"code": "1141"
					},
					{
						"title": "米沢信用金庫",
						"code": "1141"
					},
					{
						"title": "Tsuruokashin'yokinko",
						"code": "1142"
					},
					{
						"title": "鶴岡信用金庫",
						"code": "1142"
					},
					{
						"title": "Shinjo credit union",
						"code": "1143"
					},
					{
						"title": "新庄信用金庫",
						"code": "1143"
					},
					{
						"title": "盛岡信用金庫",
						"code": "1150"
					},
					{
						"title": "Moriokashin'yokinko",
						"code": "1150"
					},
					{
						"title": "宮古信用金庫",
						"code": "1152"
					},
					{
						"title": "Miyako credit union",
						"code": "1152"
					},
					{
						"title": "One Sekishin'yokinko",
						"code": "1153"
					},
					{
						"title": "一関信用金庫",
						"code": "1153"
					},
					{
						"title": "北上信用金庫",
						"code": "1154"
					},
					{
						"title": "North credit union",
						"code": "1154"
					},
					{
						"title": "Hanamaki credit union",
						"code": "1155"
					},
					{
						"title": "花巻信用金庫",
						"code": "1155"
					},
					{
						"title": "Mizusawa credit union",
						"code": "1156"
					},
					{
						"title": "水沢信用金庫",
						"code": "1156"
					},
					{
						"title": "Capital credit union Mori",
						"code": "1170"
					},
					{
						"title": "杜の都信用金庫",
						"code": "1170"
					},
					{
						"title": "宮城第一信用金庫",
						"code": "1171"
					},
					{
						"title": "Miyagi first credit union",
						"code": "1171"
					},
					{
						"title": "石巻信用金庫",
						"code": "1172"
					},
					{
						"title": "Ishinomaki credit union",
						"code": "1172"
					},
					{
						"title": "Sen'nanshin'yokinko",
						"code": "1174"
					},
					{
						"title": "仙南信用金庫",
						"code": "1174"
					},
					{
						"title": "Kesennuma Shinkin Bank",
						"code": "1175"
					},
					{
						"title": "気仙沼信用金庫",
						"code": "1175"
					},
					{
						"title": "会津信用金庫",
						"code": "1181"
					},
					{
						"title": "Aizu credit union",
						"code": "1181"
					},
					{
						"title": "郡山信用金庫",
						"code": "1182"
					},
					{
						"title": "Koriyamashin'yokinko",
						"code": "1182"
					},
					{
						"title": "Shirakawashin'yokinko",
						"code": "1184"
					},
					{
						"title": "白河信用金庫",
						"code": "1184"
					},
					{
						"title": "須賀川信用金庫",
						"code": "1185"
					},
					{
						"title": "Sukagawa credit union",
						"code": "1185"
					},
					{
						"title": "ひまわり信用金庫",
						"code": "1186"
					},
					{
						"title": "Sunflower credit union",
						"code": "1186"
					},
					{
						"title": "あぶくま信用金庫",
						"code": "1188"
					},
					{
						"title": "Abukuma credit union",
						"code": "1188"
					},
					{
						"title": "Nihonmatsu credit union",
						"code": "1189"
					},
					{
						"title": "二本松信用金庫",
						"code": "1189"
					},
					{
						"title": "Fukushimashin'yokinko",
						"code": "1190"
					},
					{
						"title": "福島信用金庫",
						"code": "1190"
					},
					{
						"title": "Takasakishin'yokinko",
						"code": "1203"
					},
					{
						"title": "高崎信用金庫",
						"code": "1203"
					},
					{
						"title": "桐生信用金庫",
						"code": "1204"
					},
					{
						"title": "Kiryushin'yokinko",
						"code": "1204"
					},
					{
						"title": "アイオー信用金庫",
						"code": "1206"
					},
					{
						"title": "Ior credit union",
						"code": "1206"
					},
					{
						"title": "Tone-gun credit union",
						"code": "1208"
					},
					{
						"title": "利根郡信用金庫",
						"code": "1208"
					},
					{
						"title": "Tatebayashishin'yokinko",
						"code": "1209"
					},
					{
						"title": "館林信用金庫",
						"code": "1209"
					},
					{
						"title": "北群馬信用金庫",
						"code": "1210"
					},
					{
						"title": "Kitagunmashin'yokinko",
						"code": "1210"
					},
					{
						"title": "しののめ信用金庫",
						"code": "1211"
					},
					{
						"title": "Shinonome credit union",
						"code": "1211"
					},
					{
						"title": "Ashikaga Oyama credit union",
						"code": "1221"
					},
					{
						"title": "足利小山信用金庫",
						"code": "1221"
					},
					{
						"title": "栃木信用金庫",
						"code": "1222"
					},
					{
						"title": "Tochigi credit union",
						"code": "1222"
					},
					{
						"title": "鹿沼相互信用金庫",
						"code": "1223"
					},
					{
						"title": "Kanuma mutual credit union",
						"code": "1223"
					},
					{
						"title": "Sanoshin'yokinko",
						"code": "1224"
					},
					{
						"title": "佐野信用金庫",
						"code": "1224"
					},
					{
						"title": "大田原信用金庫",
						"code": "1225"
					},
					{
						"title": "Otawara credit union",
						"code": "1225"
					},
					{
						"title": "Osan credit union",
						"code": "1227"
					},
					{
						"title": "烏山信用金庫",
						"code": "1227"
					},
					{
						"title": "Mito credit union",
						"code": "1240"
					},
					{
						"title": "水戸信用金庫",
						"code": "1240"
					},
					{
						"title": "結城信用金庫",
						"code": "1242"
					},
					{
						"title": "Yukishin'yokinko",
						"code": "1242"
					},
					{
						"title": "埼玉縣信用金庫",
						"code": "1250"
					},
					{
						"title": "Saitama Agata credit union",
						"code": "1250"
					},
					{
						"title": "川口信用金庫",
						"code": "1251"
					},
					{
						"title": "Kawaguchishin'yokinko",
						"code": "1251"
					},
					{
						"title": "Aoki credit union",
						"code": "1252"
					},
					{
						"title": "青木信用金庫",
						"code": "1252"
					},
					{
						"title": "飯能信用金庫",
						"code": "1253"
					},
					{
						"title": "Hanno Shinkin Bank",
						"code": "1253"
					},
					{
						"title": "千葉信用金庫",
						"code": "1260"
					},
					{
						"title": "Chiba credit union",
						"code": "1260"
					},
					{
						"title": "Choshi credit union",
						"code": "1261"
					},
					{
						"title": "銚子信用金庫",
						"code": "1261"
					},
					{
						"title": "Tokyo Bay credit union",
						"code": "1262"
					},
					{
						"title": "東京ベイ信用金庫",
						"code": "1262"
					},
					{
						"title": "Tateyama credit union",
						"code": "1264"
					},
					{
						"title": "館山信用金庫",
						"code": "1264"
					},
					{
						"title": "Sawarashin'yokinko",
						"code": "1267"
					},
					{
						"title": "佐原信用金庫",
						"code": "1267"
					},
					{
						"title": "Yokohama credit union",
						"code": "1280"
					},
					{
						"title": "横浜信用金庫",
						"code": "1280"
					},
					{
						"title": "Kanagawa credit union",
						"code": "1281"
					},
					{
						"title": "かながわ信用金庫",
						"code": "1281"
					},
					{
						"title": "湘南信用金庫",
						"code": "1282"
					},
					{
						"title": "Shonanshin'yokinko",
						"code": "1282"
					},
					{
						"title": "川崎信用金庫",
						"code": "1283"
					},
					{
						"title": "Kawasaki credit union",
						"code": "1283"
					},
					{
						"title": "平塚信用金庫",
						"code": "1286"
					},
					{
						"title": "Hiratsuka Shinkin Bank",
						"code": "1286"
					},
					{
						"title": "さがみ信用金庫",
						"code": "1288"
					},
					{
						"title": "Sagami credit union",
						"code": "1288"
					},
					{
						"title": "中栄信用金庫",
						"code": "1289"
					},
					{
						"title": "Medium Sakae credit union",
						"code": "1289"
					},
					{
						"title": "中南信用金庫",
						"code": "1290"
					},
					{
						"title": "Zhongnan credit union",
						"code": "1290"
					},
					{
						"title": "朝日信用金庫",
						"code": "1303"
					},
					{
						"title": "Asahi Shinkin Bank",
						"code": "1303"
					},
					{
						"title": "Kosan Shinkin Bank",
						"code": "1305"
					},
					{
						"title": "興産信用金庫",
						"code": "1305"
					},
					{
						"title": "さわやか信用金庫",
						"code": "1310"
					},
					{
						"title": "Refreshing credit union",
						"code": "1310"
					},
					{
						"title": "Tokyo City credit union",
						"code": "1311"
					},
					{
						"title": "東京シティ信用金庫",
						"code": "1311"
					},
					{
						"title": "芝信用金庫",
						"code": "1319"
					},
					{
						"title": "Shiba Shinkin Bank",
						"code": "1319"
					},
					{
						"title": "Tokyo Higashi credit union",
						"code": "1320"
					},
					{
						"title": "東京東信用金庫",
						"code": "1320"
					},
					{
						"title": "東栄信用金庫",
						"code": "1321"
					},
					{
						"title": "Toeishin'yokinko",
						"code": "1321"
					},
					{
						"title": "Kamearishin'yokinko",
						"code": "1323"
					},
					{
						"title": "亀有信用金庫",
						"code": "1323"
					},
					{
						"title": "小松川信用金庫",
						"code": "1326"
					},
					{
						"title": "Komatsugawashin'yokinko",
						"code": "1326"
					},
					{
						"title": "足立成和信用金庫",
						"code": "1327"
					},
					{
						"title": "Seiwa Adachi credit union",
						"code": "1327"
					},
					{
						"title": "Tokyo Sankyo credit union",
						"code": "1333"
					},
					{
						"title": "東京三協信用金庫",
						"code": "1333"
					},
					{
						"title": "西京信用金庫",
						"code": "1336"
					},
					{
						"title": "Xijing credit union",
						"code": "1336"
					},
					{
						"title": "Seibu Shinkin Bank",
						"code": "1341"
					},
					{
						"title": "西武信用金庫",
						"code": "1341"
					},
					{
						"title": "城南信用金庫",
						"code": "1344"
					},
					{
						"title": "Johnan Shinkin Bank",
						"code": "1344"
					},
					{
						"title": "昭和信用金庫",
						"code": "1345"
					},
					{
						"title": "Showashin'yokinko",
						"code": "1345"
					},
					{
						"title": "目黒信用金庫",
						"code": "1346"
					},
					{
						"title": "Meguroshin'yokinko",
						"code": "1346"
					},
					{
						"title": "世田谷信用金庫",
						"code": "1348"
					},
					{
						"title": "Setagaya credit union",
						"code": "1348"
					},
					{
						"title": "東京信用金庫",
						"code": "1349"
					},
					{
						"title": "Tokyo Shinkin Bank",
						"code": "1349"
					},
					{
						"title": "Johoku credit union",
						"code": "1351"
					},
					{
						"title": "城北信用金庫",
						"code": "1351"
					},
					{
						"title": "瀧野川信用金庫",
						"code": "1352"
					},
					{
						"title": "Takinogawashin'yokinko",
						"code": "1352"
					},
					{
						"title": "Sugamoshin'yokinko",
						"code": "1356"
					},
					{
						"title": "巣鴨信用金庫",
						"code": "1356"
					},
					{
						"title": "Omeshin'yokinko",
						"code": "1358"
					},
					{
						"title": "青梅信用金庫",
						"code": "1358"
					},
					{
						"title": "Tama credit union",
						"code": "1360"
					},
					{
						"title": "多摩信用金庫",
						"code": "1360"
					},
					{
						"title": "Nigatashin'yokinko",
						"code": "1370"
					},
					{
						"title": "新潟信用金庫",
						"code": "1370"
					},
					{
						"title": "長岡信用金庫",
						"code": "1371"
					},
					{
						"title": "Nagaokashin'yokinko",
						"code": "1371"
					},
					{
						"title": "三条信用金庫",
						"code": "1373"
					},
					{
						"title": "Sanjoshin'yokinko",
						"code": "1373"
					},
					{
						"title": "Shibata credit union",
						"code": "1374"
					},
					{
						"title": "新発田信用金庫",
						"code": "1374"
					},
					{
						"title": "柏崎信用金庫",
						"code": "1375"
					},
					{
						"title": "Kashiwazaki credit union",
						"code": "1375"
					},
					{
						"title": "Joetsu Shinkin Bank",
						"code": "1376"
					},
					{
						"title": "上越信用金庫",
						"code": "1376"
					},
					{
						"title": "新井信用金庫",
						"code": "1377"
					},
					{
						"title": "Araishin'yokinko",
						"code": "1377"
					},
					{
						"title": "村上信用金庫",
						"code": "1379"
					},
					{
						"title": "Murakamishin'yokinko",
						"code": "1379"
					},
					{
						"title": "Kamo credit union",
						"code": "1380"
					},
					{
						"title": "加茂信用金庫",
						"code": "1380"
					},
					{
						"title": "Kofushin'yokinko",
						"code": "1385"
					},
					{
						"title": "甲府信用金庫",
						"code": "1385"
					},
					{
						"title": "山梨信用金庫",
						"code": "1386"
					},
					{
						"title": "Yamanashi credit union",
						"code": "1386"
					},
					{
						"title": "Naganoshin'yokinko",
						"code": "1390"
					},
					{
						"title": "長野信用金庫",
						"code": "1390"
					},
					{
						"title": "Matsumoto credit union",
						"code": "1391"
					},
					{
						"title": "松本信用金庫",
						"code": "1391"
					},
					{
						"title": "上田信用金庫",
						"code": "1392"
					},
					{
						"title": "Uedashin'yokinko",
						"code": "1392"
					},
					{
						"title": "諏訪信用金庫",
						"code": "1393"
					},
					{
						"title": "Suwashin'yokinko",
						"code": "1393"
					},
					{
						"title": "飯田信用金庫",
						"code": "1394"
					},
					{
						"title": "Idashin'yokinko",
						"code": "1394"
					},
					{
						"title": "Alps center credit union",
						"code": "1396"
					},
					{
						"title": "アルプス中央信用金庫",
						"code": "1396"
					},
					{
						"title": "富山信用金庫",
						"code": "1401"
					},
					{
						"title": "Toyama credit union",
						"code": "1401"
					},
					{
						"title": "高岡信用金庫",
						"code": "1402"
					},
					{
						"title": "Takaokashin'yokinko",
						"code": "1402"
					},
					{
						"title": "新湊信用金庫",
						"code": "1404"
					},
					{
						"title": "Shinminatoshin'yokinko",
						"code": "1404"
					},
					{
						"title": "にいかわ信用金庫",
						"code": "1405"
					},
					{
						"title": "Shinkawa credit union",
						"code": "1405"
					},
					{
						"title": "Himifushikishin'yokinko",
						"code": "1406"
					},
					{
						"title": "氷見伏木信用金庫",
						"code": "1406"
					},
					{
						"title": "砺波信用金庫",
						"code": "1412"
					},
					{
						"title": "Tonami credit union",
						"code": "1412"
					},
					{
						"title": "石動信用金庫",
						"code": "1413"
					},
					{
						"title": "Isurugi credit union",
						"code": "1413"
					},
					{
						"title": "Kanazawashin'yokinko",
						"code": "1440"
					},
					{
						"title": "金沢信用金庫",
						"code": "1440"
					},
					{
						"title": "Of the mutual prosperity Shinkin Bank",
						"code": "1442"
					},
					{
						"title": "のと共栄信用金庫",
						"code": "1442"
					},
					{
						"title": "北陸信用金庫",
						"code": "1444"
					},
					{
						"title": "Hokurikushin'yokinko",
						"code": "1444"
					},
					{
						"title": "Tsurugishin'yokinko",
						"code": "1445"
					},
					{
						"title": "鶴来信用金庫",
						"code": "1445"
					},
					{
						"title": "興能信用金庫",
						"code": "1448"
					},
					{
						"title": "Konoshin'yokinko",
						"code": "1448"
					},
					{
						"title": "福井信用金庫",
						"code": "1470"
					},
					{
						"title": "Fukuishin'yokinko",
						"code": "1470"
					},
					{
						"title": "敦賀信用金庫",
						"code": "1471"
					},
					{
						"title": "Tsurugashin'yokinko",
						"code": "1471"
					},
					{
						"title": "武生信用金庫",
						"code": "1472"
					},
					{
						"title": "Takeo credit union",
						"code": "1472"
					},
					{
						"title": "Obamashin'yokinko",
						"code": "1473"
					},
					{
						"title": "小浜信用金庫",
						"code": "1473"
					},
					{
						"title": "Echizenshin'yokinko",
						"code": "1475"
					},
					{
						"title": "越前信用金庫",
						"code": "1475"
					},
					{
						"title": "静岡信用金庫",
						"code": "1501"
					},
					{
						"title": "Shizuoka credit union",
						"code": "1501"
					},
					{
						"title": "静清信用金庫",
						"code": "1502"
					},
					{
						"title": "ShizuKiyoshi credit union",
						"code": "1502"
					},
					{
						"title": "浜松信用金庫",
						"code": "1503"
					},
					{
						"title": "Hamamatsushin'yokinko",
						"code": "1503"
					},
					{
						"title": "Numazushin'yokinko",
						"code": "1505"
					},
					{
						"title": "沼津信用金庫",
						"code": "1505"
					},
					{
						"title": "三島信用金庫",
						"code": "1506"
					},
					{
						"title": "Mishimashin'yokinko",
						"code": "1506"
					},
					{
						"title": "Fujinomiyashin'yokinko",
						"code": "1507"
					},
					{
						"title": "富士宮信用金庫",
						"code": "1507"
					},
					{
						"title": "Shimadashin'yokinko",
						"code": "1509"
					},
					{
						"title": "島田信用金庫",
						"code": "1509"
					},
					{
						"title": "磐田信用金庫",
						"code": "1511"
					},
					{
						"title": "Iwata Shinkin Bank",
						"code": "1511"
					},
					{
						"title": "焼津信用金庫",
						"code": "1512"
					},
					{
						"title": "Yaizushin'yokinko",
						"code": "1512"
					},
					{
						"title": "掛川信用金庫",
						"code": "1513"
					},
					{
						"title": "Kakegawashin'yokinko",
						"code": "1513"
					},
					{
						"title": "富士信用金庫",
						"code": "1515"
					},
					{
						"title": "Fujishin'yokinko",
						"code": "1515"
					},
					{
						"title": "遠州信用金庫",
						"code": "1517"
					},
					{
						"title": "Enshushin'yokinko",
						"code": "1517"
					},
					{
						"title": "Gifu credit union",
						"code": "1530"
					},
					{
						"title": "岐阜信用金庫",
						"code": "1530"
					},
					{
						"title": "Ogaki Shinkin Bank",
						"code": "1531"
					},
					{
						"title": "大垣信用金庫",
						"code": "1531"
					},
					{
						"title": "高山信用金庫",
						"code": "1532"
					},
					{
						"title": "Takayamashin'yokinko",
						"code": "1532"
					},
					{
						"title": "東濃信用金庫",
						"code": "1533"
					},
					{
						"title": "Tono credit union",
						"code": "1533"
					},
					{
						"title": "関信用金庫",
						"code": "1534"
					},
					{
						"title": "Sekishin'yokinko",
						"code": "1534"
					},
					{
						"title": "Hachimanshin'yokinko",
						"code": "1538"
					},
					{
						"title": "八幡信用金庫",
						"code": "1538"
					},
					{
						"title": "西濃信用金庫",
						"code": "1540"
					},
					{
						"title": "Seinoshin'yokinko",
						"code": "1540"
					},
					{
						"title": "愛知信用金庫",
						"code": "1550"
					},
					{
						"title": "Aichi credit union",
						"code": "1550"
					},
					{
						"title": "豊橋信用金庫",
						"code": "1551"
					},
					{
						"title": "Toyohashishin'yokinko",
						"code": "1551"
					},
					{
						"title": "岡崎信用金庫",
						"code": "1552"
					},
					{
						"title": "Okazakishin'yokinko",
						"code": "1552"
					},
					{
						"title": "いちい信用金庫",
						"code": "1553"
					},
					{
						"title": "Yew credit union",
						"code": "1553"
					},
					{
						"title": "Seto credit union",
						"code": "1554"
					},
					{
						"title": "瀬戸信用金庫",
						"code": "1554"
					},
					{
						"title": "Handashin'yokinko",
						"code": "1555"
					},
					{
						"title": "半田信用金庫",
						"code": "1555"
					},
					{
						"title": "知多信用金庫",
						"code": "1556"
					},
					{
						"title": "Chita credit union",
						"code": "1556"
					},
					{
						"title": "Toyokawashin'yokinko",
						"code": "1557"
					},
					{
						"title": "豊川信用金庫",
						"code": "1557"
					},
					{
						"title": "Toyotashin'yokinko",
						"code": "1559"
					},
					{
						"title": "豊田信用金庫",
						"code": "1559"
					},
					{
						"title": "碧海信用金庫",
						"code": "1560"
					},
					{
						"title": "Hekikaishin'yokinko",
						"code": "1560"
					},
					{
						"title": "Nishioshin'yokinko",
						"code": "1561"
					},
					{
						"title": "西尾信用金庫",
						"code": "1561"
					},
					{
						"title": "蒲郡信用金庫",
						"code": "1562"
					},
					{
						"title": "Gamagori credit union",
						"code": "1562"
					},
					{
						"title": "尾西信用金庫",
						"code": "1563"
					},
					{
						"title": "Bisaishin'yokinko",
						"code": "1563"
					},
					{
						"title": "Sino-Japanese credit union",
						"code": "1565"
					},
					{
						"title": "中日信用金庫",
						"code": "1565"
					},
					{
						"title": "東春信用金庫",
						"code": "1566"
					},
					{
						"title": "Higashiharu credit union",
						"code": "1566"
					},
					{
						"title": "津信用金庫",
						"code": "1580"
					},
					{
						"title": "Tsu credit union",
						"code": "1580"
					},
					{
						"title": "Ueno north Ise credit union",
						"code": "1581"
					},
					{
						"title": "北伊勢上野信用金庫",
						"code": "1581"
					},
					{
						"title": "Mieshin'yokinko",
						"code": "1582"
					},
					{
						"title": "三重信用金庫",
						"code": "1582"
					},
					{
						"title": "桑名信用金庫",
						"code": "1583"
					},
					{
						"title": "Kuwanashin'yokinko",
						"code": "1583"
					},
					{
						"title": "紀北信用金庫",
						"code": "1585"
					},
					{
						"title": "Kihoku credit union",
						"code": "1585"
					},
					{
						"title": "滋賀中央信用金庫",
						"code": "1602"
					},
					{
						"title": "Shiga central credit union",
						"code": "1602"
					},
					{
						"title": "長浜信用金庫",
						"code": "1603"
					},
					{
						"title": "Nagahamashin'yokinko",
						"code": "1603"
					},
					{
						"title": "Koto credit union",
						"code": "1604"
					},
					{
						"title": "湖東信用金庫",
						"code": "1604"
					},
					{
						"title": "京都信用金庫",
						"code": "1610"
					},
					{
						"title": "Kyoto Shinkin Bank",
						"code": "1610"
					},
					{
						"title": "Kyoto Chuo Shinkin Bank",
						"code": "1611"
					},
					{
						"title": "京都中央信用金庫",
						"code": "1611"
					},
					{
						"title": "Kyoto Hokuto credit union",
						"code": "1620"
					},
					{
						"title": "京都北都信用金庫",
						"code": "1620"
					},
					{
						"title": "Osaka credit union",
						"code": "1630"
					},
					{
						"title": "大阪信用金庫",
						"code": "1630"
					},
					{
						"title": "Osaka Welfare credit union",
						"code": "1633"
					},
					{
						"title": "大阪厚生信用金庫",
						"code": "1633"
					},
					{
						"title": "大阪シティ信用金庫",
						"code": "1635"
					},
					{
						"title": "Osaka City Shinkin Bank",
						"code": "1635"
					},
					{
						"title": "Osaka Chamber of Commerce and Industry credit union",
						"code": "1636"
					},
					{
						"title": "大阪商工信用金庫",
						"code": "1636"
					},
					{
						"title": "Yonghe credit union",
						"code": "1643"
					},
					{
						"title": "永和信用金庫",
						"code": "1643"
					},
					{
						"title": "North Osaka credit union",
						"code": "1645"
					},
					{
						"title": "北おおさか信用金庫",
						"code": "1645"
					},
					{
						"title": "枚方信用金庫",
						"code": "1656"
					},
					{
						"title": "Hirakata credit union",
						"code": "1656"
					},
					{
						"title": "Narashin'yokinko",
						"code": "1666"
					},
					{
						"title": "奈良信用金庫",
						"code": "1666"
					},
					{
						"title": "大和信用金庫",
						"code": "1667"
					},
					{
						"title": "Yamatoshin'yokinko",
						"code": "1667"
					},
					{
						"title": "奈良中央信用金庫",
						"code": "1668"
					},
					{
						"title": "Narachuoshin'yokinko",
						"code": "1668"
					},
					{
						"title": "新宮信用金庫",
						"code": "1671"
					},
					{
						"title": "Shingu credit union",
						"code": "1671"
					},
					{
						"title": "Kinokunishin'yokinko",
						"code": "1674"
					},
					{
						"title": "きのくに信用金庫",
						"code": "1674"
					},
					{
						"title": "神戸信用金庫",
						"code": "1680"
					},
					{
						"title": "Kobeshin'yokinko",
						"code": "1680"
					},
					{
						"title": "姫路信用金庫",
						"code": "1685"
					},
					{
						"title": "Himejishin'yokinko",
						"code": "1685"
					},
					{
						"title": "播州信用金庫",
						"code": "1686"
					},
					{
						"title": "Banshushin'yokinko",
						"code": "1686"
					},
					{
						"title": "兵庫信用金庫",
						"code": "1687"
					},
					{
						"title": "Hyogoshin'yokinko",
						"code": "1687"
					},
					{
						"title": "Amagasaki credit union",
						"code": "1688"
					},
					{
						"title": "尼崎信用金庫",
						"code": "1688"
					},
					{
						"title": "Nisshin credit union",
						"code": "1689"
					},
					{
						"title": "日新信用金庫",
						"code": "1689"
					},
					{
						"title": "Awaji credit union",
						"code": "1691"
					},
					{
						"title": "淡路信用金庫",
						"code": "1691"
					},
					{
						"title": "但馬信用金庫",
						"code": "1692"
					},
					{
						"title": "Tajimashin'yokinko",
						"code": "1692"
					},
					{
						"title": "Nishihyogoshin'yokinko",
						"code": "1694"
					},
					{
						"title": "西兵庫信用金庫",
						"code": "1694"
					},
					{
						"title": "Nakahyogoshin'yokinko",
						"code": "1695"
					},
					{
						"title": "中兵庫信用金庫",
						"code": "1695"
					},
					{
						"title": "但陽信用金庫",
						"code": "1696"
					},
					{
						"title": "Tan'yoshin'yokinko",
						"code": "1696"
					},
					{
						"title": "Tottorishin'yokinko",
						"code": "1701"
					},
					{
						"title": "鳥取信用金庫",
						"code": "1701"
					},
					{
						"title": "米子信用金庫",
						"code": "1702"
					},
					{
						"title": "Yonagoshin'yokinko",
						"code": "1702"
					},
					{
						"title": "倉吉信用金庫",
						"code": "1703"
					},
					{
						"title": "Kurayoshishin'yokinko",
						"code": "1703"
					},
					{
						"title": "Shimane credit union",
						"code": "1710"
					},
					{
						"title": "しまね信用金庫",
						"code": "1710"
					},
					{
						"title": "日本海信用金庫",
						"code": "1711"
					},
					{
						"title": "Sea of ??Japan credit union",
						"code": "1711"
					},
					{
						"title": "Sea of ​​Japan credit union",
						"code": "1711"
					},
					{
						"title": "Shimane center Shinkin Bank",
						"code": "1712"
					},
					{
						"title": "島根中央信用金庫",
						"code": "1712"
					},
					{
						"title": "おかやま信用金庫",
						"code": "1732"
					},
					{
						"title": "Okayama credit union",
						"code": "1732"
					},
					{
						"title": "Mizushimashin'yokinko",
						"code": "1734"
					},
					{
						"title": "水島信用金庫",
						"code": "1734"
					},
					{
						"title": "津山信用金庫",
						"code": "1735"
					},
					{
						"title": "Tsuyama credit union",
						"code": "1735"
					},
					{
						"title": "玉島信用金庫",
						"code": "1738"
					},
					{
						"title": "Tamashimashin'yokinko",
						"code": "1738"
					},
					{
						"title": "Bihoku credit union",
						"code": "1740"
					},
					{
						"title": "備北信用金庫",
						"code": "1740"
					},
					{
						"title": "吉備信用金庫",
						"code": "1741"
					},
					{
						"title": "Kibishin'yokinko",
						"code": "1741"
					},
					{
						"title": "日生信用金庫",
						"code": "1742"
					},
					{
						"title": "Hinaseshin'yokinko",
						"code": "1742"
					},
					{
						"title": "Bizenshin'yokinko",
						"code": "1743"
					},
					{
						"title": "備前信用金庫",
						"code": "1743"
					},
					{
						"title": "Hiroshimashin'yokinko",
						"code": "1750"
					},
					{
						"title": "広島信用金庫",
						"code": "1750"
					},
					{
						"title": "Kureshin'yokinko",
						"code": "1752"
					},
					{
						"title": "呉信用金庫",
						"code": "1752"
					},
					{
						"title": "しまなみ信用金庫",
						"code": "1756"
					},
					{
						"title": "Shimanami credit union",
						"code": "1756"
					},
					{
						"title": "広島みどり信用金庫",
						"code": "1758"
					},
					{
						"title": "Hiroshima green credit union",
						"code": "1758"
					},
					{
						"title": "萩山口信用金庫",
						"code": "1780"
					},
					{
						"title": "Hagi Yamaguchi credit union",
						"code": "1780"
					},
					{
						"title": "西中国信用金庫",
						"code": "1781"
					},
					{
						"title": "West China credit union",
						"code": "1781"
					},
					{
						"title": "東山口信用金庫",
						"code": "1789"
					},
					{
						"title": "Higashiyamaguchishin'yokinko",
						"code": "1789"
					},
					{
						"title": "徳島信用金庫",
						"code": "1801"
					},
					{
						"title": "Tokushima credit union",
						"code": "1801"
					},
					{
						"title": "Anan credit union",
						"code": "1803"
					},
					{
						"title": "阿南信用金庫",
						"code": "1803"
					},
					{
						"title": "高松信用金庫",
						"code": "1830"
					},
					{
						"title": "Takamatsushin'yokinko",
						"code": "1830"
					},
					{
						"title": "Temple credit union",
						"code": "1833"
					},
					{
						"title": "観音寺信用金庫",
						"code": "1833"
					},
					{
						"title": "Ehimeshin'yokinko",
						"code": "1860"
					},
					{
						"title": "愛媛信用金庫",
						"code": "1860"
					},
					{
						"title": "宇和島信用金庫",
						"code": "1862"
					},
					{
						"title": "Uwajima credit union",
						"code": "1862"
					},
					{
						"title": "Toyoshin'yokinko",
						"code": "1864"
					},
					{
						"title": "東予信用金庫",
						"code": "1864"
					},
					{
						"title": "川之江信用金庫",
						"code": "1866"
					},
					{
						"title": "Kawanoe Shinkin Bank",
						"code": "1866"
					},
					{
						"title": "幡多信用金庫",
						"code": "1880"
					},
					{
						"title": "Hata credit union",
						"code": "1880"
					},
					{
						"title": "Kochi credit union",
						"code": "1881"
					},
					{
						"title": "高知信用金庫",
						"code": "1881"
					},
					{
						"title": "福岡信用金庫",
						"code": "1901"
					},
					{
						"title": "Fukuoka credit union",
						"code": "1901"
					},
					{
						"title": "Fukuoka sound credit union",
						"code": "1903"
					},
					{
						"title": "福岡ひびき信用金庫",
						"code": "1903"
					},
					{
						"title": "Omuta Yanagawa credit union",
						"code": "1908"
					},
					{
						"title": "大牟田柳川信用金庫",
						"code": "1908"
					},
					{
						"title": "筑後信用金庫",
						"code": "1909"
					},
					{
						"title": "Chikugo credit union",
						"code": "1909"
					},
					{
						"title": "飯塚信用金庫",
						"code": "1910"
					},
					{
						"title": "Izukashin'yokinko",
						"code": "1910"
					},
					{
						"title": "Tagawa credit union",
						"code": "1913"
					},
					{
						"title": "田川信用金庫",
						"code": "1913"
					},
					{
						"title": "Okawa credit union",
						"code": "1917"
					},
					{
						"title": "大川信用金庫",
						"code": "1917"
					},
					{
						"title": "Ongashin'yokinko",
						"code": "1920"
					},
					{
						"title": "遠賀信用金庫",
						"code": "1920"
					},
					{
						"title": "Karatsu credit union",
						"code": "1930"
					},
					{
						"title": "唐津信用金庫",
						"code": "1930"
					},
					{
						"title": "佐賀信用金庫",
						"code": "1931"
					},
					{
						"title": "Saga credit union",
						"code": "1931"
					},
					{
						"title": "Imari credit union",
						"code": "1932"
					},
					{
						"title": "伊万里信用金庫",
						"code": "1932"
					},
					{
						"title": "Kyushu Hizen credit union",
						"code": "1933"
					},
					{
						"title": "九州ひぜん信用金庫",
						"code": "1933"
					},
					{
						"title": "たちばな信用金庫",
						"code": "1942"
					},
					{
						"title": "Tachibana credit union",
						"code": "1942"
					},
					{
						"title": "熊本信用金庫",
						"code": "1951"
					},
					{
						"title": "Kumamotoshin'yokinko",
						"code": "1951"
					},
					{
						"title": "Kumamotodaiichishin'yokinko",
						"code": "1952"
					},
					{
						"title": "熊本第一信用金庫",
						"code": "1952"
					},
					{
						"title": "熊本中央信用金庫",
						"code": "1954"
					},
					{
						"title": "Kumamoto Central credit union",
						"code": "1954"
					},
					{
						"title": "Amakusa credit union",
						"code": "1955"
					},
					{
						"title": "天草信用金庫",
						"code": "1955"
					},
					{
						"title": "大分信用金庫",
						"code": "1960"
					},
					{
						"title": "Oita credit union",
						"code": "1960"
					},
					{
						"title": "大分みらい信用金庫",
						"code": "1962"
					},
					{
						"title": "Oitamiraishin'yokinko",
						"code": "1962"
					},
					{
						"title": "Hita credit union",
						"code": "1968"
					},
					{
						"title": "日田信用金庫",
						"code": "1968"
					},
					{
						"title": "宮崎信用金庫",
						"code": "1980"
					},
					{
						"title": "Miyazakishin'yokinko",
						"code": "1980"
					},
					{
						"title": "都城信用金庫",
						"code": "1981"
					},
					{
						"title": "Miyakonojo credit union",
						"code": "1981"
					},
					{
						"title": "Nobeoka credit union",
						"code": "1982"
					},
					{
						"title": "延岡信用金庫",
						"code": "1982"
					},
					{
						"title": "高鍋信用金庫",
						"code": "1985"
					},
					{
						"title": "Takanabeshin'yokinko",
						"code": "1985"
					},
					{
						"title": "南郷信用金庫",
						"code": "1986"
					},
					{
						"title": "Nango credit union",
						"code": "1986"
					},
					{
						"title": "Kagoshimashin'yokinko",
						"code": "1990"
					},
					{
						"title": "鹿児島信用金庫",
						"code": "1990"
					},
					{
						"title": "鹿児島相互信用金庫",
						"code": "1991"
					},
					{
						"title": "Kagoshimasogoshin'yokinko",
						"code": "1991"
					},
					{
						"title": "Amami Oshima credit union",
						"code": "1993"
					},
					{
						"title": "奄美大島信用金庫",
						"code": "1993"
					},
					{
						"title": "Koza credit union",
						"code": "1996"
					},
					{
						"title": "コザ信用金庫",
						"code": "1996"
					},
					{
						"title": "商工組合中央金庫",
						"code": "2004"
					},
					{
						"title": "Shoko Chukin Bank",
						"code": "2004"
					},
					{
						"title": "全国信用協同組合連合会",
						"code": "2010"
					},
					{
						"title": "Nationwide credit cooperatives Federation",
						"code": "2010"
					},
					{
						"title": "Hokuo credit union",
						"code": "2011"
					},
					{
						"title": "北央信用組合",
						"code": "2011"
					},
					{
						"title": "札幌中央信用組合",
						"code": "2013"
					},
					{
						"title": "Sapporochuoshin'yokumiai",
						"code": "2013"
					},
					{
						"title": "ウリ信用組合",
						"code": "2014"
					},
					{
						"title": "Uri credit union",
						"code": "2014"
					},
					{
						"title": "函館商工信用組合",
						"code": "2017"
					},
					{
						"title": "Hakodate Chamber of credit union",
						"code": "2017"
					},
					{
						"title": "空知商工信用組合",
						"code": "2019"
					},
					{
						"title": "Sorachi Chamber of credit union",
						"code": "2019"
					},
					{
						"title": "Tokachi credit union",
						"code": "2024"
					},
					{
						"title": "十勝信用組合",
						"code": "2024"
					},
					{
						"title": "Kushiro credit union",
						"code": "2025"
					},
					{
						"title": "釧路信用組合",
						"code": "2025"
					},
					{
						"title": "Aomori Prefecture credit union",
						"code": "2030"
					},
					{
						"title": "青森県信用組合",
						"code": "2030"
					},
					{
						"title": "Moriryou credit union",
						"code": "2045"
					},
					{
						"title": "杜陵信用組合",
						"code": "2045"
					},
					{
						"title": "Iwate Prefecture doctor credit union",
						"code": "2049"
					},
					{
						"title": "岩手県医師信用組合",
						"code": "2049"
					},
					{
						"title": "Asuka credit union",
						"code": "2060"
					},
					{
						"title": "あすか信用組合",
						"code": "2060"
					},
					{
						"title": "石巻商工信用組合",
						"code": "2061"
					},
					{
						"title": "Ishinomaki Chamber of credit union",
						"code": "2061"
					},
					{
						"title": "Furukawa credit union",
						"code": "2062"
					},
					{
						"title": "古川信用組合",
						"code": "2062"
					},
					{
						"title": "Semboku credit union",
						"code": "2063"
					},
					{
						"title": "仙北信用組合",
						"code": "2063"
					},
					{
						"title": "秋田県信用組合",
						"code": "2075"
					},
					{
						"title": "Akita Prefecture credit union",
						"code": "2075"
					},
					{
						"title": "北郡信用組合",
						"code": "2083"
					},
					{
						"title": "North County Credit Union",
						"code": "2083"
					},
					{
						"title": "山形中央信用組合",
						"code": "2084"
					},
					{
						"title": "Yamagata central credit union",
						"code": "2084"
					},
					{
						"title": "山形第一信用組合",
						"code": "2085"
					},
					{
						"title": "Yamagata first credit union",
						"code": "2085"
					},
					{
						"title": "Fukushima Prefecture Chamber of credit unions",
						"code": "2090"
					},
					{
						"title": "福島県商工信用組合",
						"code": "2090"
					},
					{
						"title": "いわき信用組合",
						"code": "2092"
					},
					{
						"title": "Iwaki credit union",
						"code": "2092"
					},
					{
						"title": "Aiso Gojo credit union",
						"code": "2095"
					},
					{
						"title": "相双五城信用組合",
						"code": "2095"
					},
					{
						"title": "Aizu Chamber of credit union",
						"code": "2096"
					},
					{
						"title": "会津商工信用組合",
						"code": "2096"
					},
					{
						"title": "Ibaraki Prefecture credit union",
						"code": "2101"
					},
					{
						"title": "茨城県信用組合",
						"code": "2101"
					},
					{
						"title": "真岡信用組合",
						"code": "2122"
					},
					{
						"title": "Moka credit union",
						"code": "2122"
					},
					{
						"title": "那須信用組合",
						"code": "2125"
					},
					{
						"title": "Nasu credit union",
						"code": "2125"
					},
					{
						"title": "Akagi credit union",
						"code": "2143"
					},
					{
						"title": "あかぎ信用組合",
						"code": "2143"
					},
					{
						"title": "Gunma credit union",
						"code": "2146"
					},
					{
						"title": "群馬県信用組合",
						"code": "2146"
					},
					{
						"title": "ぐんまみらい信用組合",
						"code": "2149"
					},
					{
						"title": "Gunma future credit union",
						"code": "2149"
					},
					{
						"title": "群馬県医師信用組合",
						"code": "2151"
					},
					{
						"title": "Gunma Prefecture doctor credit union",
						"code": "2151"
					},
					{
						"title": "埼玉県医師信用組合",
						"code": "2162"
					},
					{
						"title": "Saitama Prefecture doctor credit union",
						"code": "2162"
					},
					{
						"title": "熊谷商工信用組合",
						"code": "2165"
					},
					{
						"title": "Kumagai Chamber of credit union",
						"code": "2165"
					},
					{
						"title": "Saitama credit union",
						"code": "2167"
					},
					{
						"title": "埼玉信用組合",
						"code": "2167"
					},
					{
						"title": "房総信用組合",
						"code": "2180"
					},
					{
						"title": "Boso credit union",
						"code": "2180"
					},
					{
						"title": "Choshi Chamber of credit union",
						"code": "2184"
					},
					{
						"title": "銚子商工信用組合",
						"code": "2184"
					},
					{
						"title": "君津信用組合",
						"code": "2190"
					},
					{
						"title": "Kimitsu credit union",
						"code": "2190"
					},
					{
						"title": "All Toei credit union",
						"code": "2202"
					},
					{
						"title": "全東栄信用組合",
						"code": "2202"
					},
					{
						"title": "東浴信用組合",
						"code": "2210"
					},
					{
						"title": "Toyoku credit union",
						"code": "2210"
					},
					{
						"title": "文化産業信用組合",
						"code": "2211"
					},
					{
						"title": "Cultural industry credit union",
						"code": "2211"
					},
					{
						"title": "Resolution and Collection Corporation",
						"code": "2213"
					},
					{
						"title": "整理回収機構",
						"code": "2213"
					},
					{
						"title": "東京証券信用組合",
						"code": "2215"
					},
					{
						"title": "Tokyo securities credit union",
						"code": "2215"
					},
					{
						"title": "Tokyo welfare credit union",
						"code": "2224"
					},
					{
						"title": "東京厚生信用組合",
						"code": "2224"
					},
					{
						"title": "Higashi credit union",
						"code": "2226"
					},
					{
						"title": "東信用組合",
						"code": "2226"
					},
					{
						"title": "Koto credit union",
						"code": "2229"
					},
					{
						"title": "江東信用組合",
						"code": "2229"
					},
					{
						"title": "青和信用組合",
						"code": "2231"
					},
					{
						"title": "AoKazu credit union",
						"code": "2231"
					},
					{
						"title": "Nakanogo credit union",
						"code": "2235"
					},
					{
						"title": "中ノ郷信用組合",
						"code": "2235"
					},
					{
						"title": "Kyoritsu credit union",
						"code": "2241"
					},
					{
						"title": "共立信用組合",
						"code": "2241"
					},
					{
						"title": "七島信用組合",
						"code": "2243"
					},
					{
						"title": "Shichito credit union",
						"code": "2243"
					},
					{
						"title": "Daitokyoshin'yokumiai",
						"code": "2248"
					},
					{
						"title": "大東京信用組合",
						"code": "2248"
					},
					{
						"title": "DKB credit union",
						"code": "2254"
					},
					{
						"title": "第一勧業信用組合",
						"code": "2254"
					},
					{
						"title": "北部信用組合",
						"code": "2266"
					},
					{
						"title": "Northern Credit Union",
						"code": "2266"
					},
					{
						"title": "警視庁職員信用組合",
						"code": "2271"
					},
					{
						"title": "Metropolitan Police Department officials credit unions",
						"code": "2271"
					},
					{
						"title": "Koshi credit union",
						"code": "2272"
					},
					{
						"title": "甲子信用組合",
						"code": "2272"
					},
					{
						"title": "東京消防信用組合",
						"code": "2274"
					},
					{
						"title": "Tokyo Fire credit union",
						"code": "2274"
					},
					{
						"title": "東京都職員信用組合",
						"code": "2276"
					},
					{
						"title": "Tokyo officials credit unions",
						"code": "2276"
					},
					{
						"title": "Hana credit union",
						"code": "2277"
					},
					{
						"title": "ハナ信用組合",
						"code": "2277"
					},
					{
						"title": "神奈川県医師信用組合",
						"code": "2304"
					},
					{
						"title": "Kanagawa Prefecture doctor credit union",
						"code": "2304"
					},
					{
						"title": "Kanagawa dentist credit union",
						"code": "2305"
					},
					{
						"title": "神奈川県歯科医師信用組合",
						"code": "2305"
					},
					{
						"title": "Yokohama central credit union",
						"code": "2306"
					},
					{
						"title": "横浜中央信用組合",
						"code": "2306"
					},
					{
						"title": "横浜華銀信用組合",
						"code": "2307"
					},
					{
						"title": "Yokohama Hanagin credit union",
						"code": "2307"
					},
					{
						"title": "小田原第一信用組合",
						"code": "2315"
					},
					{
						"title": "Odawara first credit union",
						"code": "2315"
					},
					{
						"title": "Soai credit union",
						"code": "2318"
					},
					{
						"title": "相愛信用組合",
						"code": "2318"
					},
					{
						"title": "Shizuoka Prefecture doctor credit union",
						"code": "2332"
					},
					{
						"title": "静岡県医師信用組合",
						"code": "2332"
					},
					{
						"title": "新潟縣信用組合",
						"code": "2351"
					},
					{
						"title": "Niigata Agata credit union",
						"code": "2351"
					},
					{
						"title": "Niigata railroad credit union",
						"code": "2354"
					},
					{
						"title": "新潟鉄道信用組合",
						"code": "2354"
					},
					{
						"title": "Xingrong credit union",
						"code": "2356"
					},
					{
						"title": "興栄信用組合",
						"code": "2356"
					},
					{
						"title": "新栄信用組合",
						"code": "2357"
					},
					{
						"title": "Xin Rong credit union",
						"code": "2357"
					},
					{
						"title": "Sakura city credit union of",
						"code": "2358"
					},
					{
						"title": "さくらの街信用組合",
						"code": "2358"
					},
					{
						"title": "協栄信用組合",
						"code": "2360"
					},
					{
						"title": "Kyoeishin'yokumiai",
						"code": "2360"
					},
					{
						"title": "三條信用組合",
						"code": "2361"
					},
					{
						"title": "Sanjo credit union",
						"code": "2361"
					},
					{
						"title": "巻信用組合",
						"code": "2362"
					},
					{
						"title": "Winding credit union",
						"code": "2362"
					},
					{
						"title": "新潟大栄信用組合",
						"code": "2363"
					},
					{
						"title": "Nigatadaieishin'yokumiai",
						"code": "2363"
					},
					{
						"title": "塩沢信用組合",
						"code": "2365"
					},
					{
						"title": "Shiozawa credit union",
						"code": "2365"
					},
					{
						"title": "糸魚川信用組合",
						"code": "2366"
					},
					{
						"title": "Itoigawa credit union",
						"code": "2366"
					},
					{
						"title": "山梨県民信用組合",
						"code": "2377"
					},
					{
						"title": "Yamanashi prefecture credit union",
						"code": "2377"
					},
					{
						"title": "都留信用組合",
						"code": "2378"
					},
					{
						"title": "Tsuru credit union",
						"code": "2378"
					},
					{
						"title": "Nagano credit union",
						"code": "2390"
					},
					{
						"title": "長野県信用組合",
						"code": "2390"
					},
					{
						"title": "富山県医師信用組合",
						"code": "2402"
					},
					{
						"title": "Toyama Prefecture doctor credit union",
						"code": "2402"
					},
					{
						"title": "富山県信用組合",
						"code": "2404"
					},
					{
						"title": "Toyama Prefecture credit union",
						"code": "2404"
					},
					{
						"title": "Kanazawa central credit union",
						"code": "2411"
					},
					{
						"title": "金沢中央信用組合",
						"code": "2411"
					},
					{
						"title": "Ishikawa Prefecture doctor credit union",
						"code": "2417"
					},
					{
						"title": "石川県医師信用組合",
						"code": "2417"
					},
					{
						"title": "福泉信用組合",
						"code": "2430"
					},
					{
						"title": "Fukusen credit union",
						"code": "2430"
					},
					{
						"title": "福井県医師信用組合",
						"code": "2435"
					},
					{
						"title": "Fukui Prefecture doctor credit union",
						"code": "2435"
					},
					{
						"title": "Maruhachi credit union",
						"code": "2440"
					},
					{
						"title": "丸八信用組合",
						"code": "2440"
					},
					{
						"title": "愛知商銀信用組合",
						"code": "2442"
					},
					{
						"title": "Aichi Shogin credit union",
						"code": "2442"
					},
					{
						"title": "Aichi Prefectural Police credit union",
						"code": "2443"
					},
					{
						"title": "愛知県警察信用組合",
						"code": "2443"
					},
					{
						"title": "名古屋青果物信用組合",
						"code": "2444"
					},
					{
						"title": "Nagoya fruit and vegetables credit union",
						"code": "2444"
					},
					{
						"title": "Aichi Medical credit union",
						"code": "2446"
					},
					{
						"title": "愛知県医療信用組合",
						"code": "2446"
					},
					{
						"title": "愛知県医師信用組合",
						"code": "2447"
					},
					{
						"title": "Aichi Prefecture doctor credit union",
						"code": "2447"
					},
					{
						"title": "豊橋商工信用組合",
						"code": "2448"
					},
					{
						"title": "Toyohashi Chamber of credit union",
						"code": "2448"
					},
					{
						"title": "Aichi Prefecture central credit union",
						"code": "2451"
					},
					{
						"title": "愛知県中央信用組合",
						"code": "2451"
					},
					{
						"title": "Aichi Prefecture, central credit union",
						"code": "2451"
					},
					{
						"title": "三河信用組合",
						"code": "2452"
					},
					{
						"title": "Mikawa credit union",
						"code": "2452"
					},
					{
						"title": "Gifu Chamber of credit union",
						"code": "2470"
					},
					{
						"title": "岐阜商工信用組合",
						"code": "2470"
					},
					{
						"title": "イオ信用組合",
						"code": "2471"
					},
					{
						"title": "Io credit union",
						"code": "2471"
					},
					{
						"title": "岐阜県医師信用組合",
						"code": "2473"
					},
					{
						"title": "Gifu Prefecture doctor credit union",
						"code": "2473"
					},
					{
						"title": "Hida credit union",
						"code": "2476"
					},
					{
						"title": "飛騨信用組合",
						"code": "2476"
					},
					{
						"title": "Masuda credit union",
						"code": "2481"
					},
					{
						"title": "益田信用組合",
						"code": "2481"
					},
					{
						"title": "滋賀県民信用組合",
						"code": "2504"
					},
					{
						"title": "Shiga prefecture credit union",
						"code": "2504"
					},
					{
						"title": "Shiga Prefecture credit union",
						"code": "2505"
					},
					{
						"title": "滋賀県信用組合",
						"code": "2505"
					},
					{
						"title": "京滋信用組合",
						"code": "2526"
					},
					{
						"title": "Keiji credit union",
						"code": "2526"
					},
					{
						"title": "大同信用組合",
						"code": "2540"
					},
					{
						"title": "Datong credit union",
						"code": "2540"
					},
					{
						"title": "Narukyo credit union",
						"code": "2541"
					},
					{
						"title": "成協信用組合",
						"code": "2541"
					},
					{
						"title": "大阪協栄信用組合",
						"code": "2543"
					},
					{
						"title": "Osaka Kyoeishin'yokumiai",
						"code": "2543"
					},
					{
						"title": "大阪貯蓄信用組合",
						"code": "2548"
					},
					{
						"title": "Osaka credit union savings",
						"code": "2548"
					},
					{
						"title": "のぞみ信用組合",
						"code": "2549"
					},
					{
						"title": "Nozomi credit union",
						"code": "2549"
					},
					{
						"title": "中央信用組合",
						"code": "2556"
					},
					{
						"title": "Central Credit Union",
						"code": "2556"
					},
					{
						"title": "大阪府医師信用組合",
						"code": "2560"
					},
					{
						"title": "Osaka doctor credit union",
						"code": "2560"
					},
					{
						"title": "Osaka police credit union",
						"code": "2566"
					},
					{
						"title": "大阪府警察信用組合",
						"code": "2566"
					},
					{
						"title": "近畿産業信用組合",
						"code": "2567"
					},
					{
						"title": "Kinki industry credit union",
						"code": "2567"
					},
					{
						"title": "朝日新聞信用組合",
						"code": "2580"
					},
					{
						"title": "Asahi Shimbun credit union",
						"code": "2580"
					},
					{
						"title": "Daily credit union",
						"code": "2581"
					},
					{
						"title": "毎日信用組合",
						"code": "2581"
					},
					{
						"title": "Millet credit union",
						"code": "2582"
					},
					{
						"title": "ミレ信用組合",
						"code": "2582"
					},
					{
						"title": "兵庫県警察信用組合",
						"code": "2602"
					},
					{
						"title": "Hyogo Prefectural Police credit union",
						"code": "2602"
					},
					{
						"title": "Hyogo Prefecture medical credit union",
						"code": "2605"
					},
					{
						"title": "兵庫県医療信用組合",
						"code": "2605"
					},
					{
						"title": "Hyogo credit union",
						"code": "2606"
					},
					{
						"title": "兵庫県信用組合",
						"code": "2606"
					},
					{
						"title": "Hyogo Prefecture credit union",
						"code": "2606"
					},
					{
						"title": "Kobe City officials credit unions",
						"code": "2610"
					},
					{
						"title": "神戸市職員信用組合",
						"code": "2610"
					},
					{
						"title": "Dan'yoshin'yokumiai",
						"code": "2616"
					},
					{
						"title": "淡陽信用組合",
						"code": "2616"
					},
					{
						"title": "兵庫ひまわり信用組合",
						"code": "2620"
					},
					{
						"title": "Hyogo sunflower credit union",
						"code": "2620"
					},
					{
						"title": "和歌山県医師信用組合",
						"code": "2634"
					},
					{
						"title": "Wakayama Prefecture doctor credit union",
						"code": "2634"
					},
					{
						"title": "Shimane Masuda credit union",
						"code": "2661"
					},
					{
						"title": "島根益田信用組合",
						"code": "2661"
					},
					{
						"title": "朝銀西信用組合",
						"code": "2672"
					},
					{
						"title": "Asagin'nishi credit union",
						"code": "2672"
					},
					{
						"title": "岡山商銀信用組合",
						"code": "2673"
					},
					{
						"title": "Okayama commercial banks credit unions",
						"code": "2673"
					},
					{
						"title": "笠岡信用組合",
						"code": "2674"
					},
					{
						"title": "Kasaoka credit union",
						"code": "2674"
					},
					{
						"title": "広島市信用組合",
						"code": "2680"
					},
					{
						"title": "Hiroshima credit union",
						"code": "2680"
					},
					{
						"title": "Hiroshima credit union",
						"code": "2681"
					},
					{
						"title": "広島県信用組合",
						"code": "2681"
					},
					{
						"title": "広島商銀信用組合",
						"code": "2684"
					},
					{
						"title": "Hiroshimasho silver credit union",
						"code": "2684"
					},
					{
						"title": "両備信用組合",
						"code": "2690"
					},
					{
						"title": "Ryobi credit union",
						"code": "2690"
					},
					{
						"title": "備後信用組合",
						"code": "2696"
					},
					{
						"title": "Bingo credit union",
						"code": "2696"
					},
					{
						"title": "Yamaguchi Prefecture credit union",
						"code": "2703"
					},
					{
						"title": "山口県信用組合",
						"code": "2703"
					},
					{
						"title": "Kagawa Prefecture credit union",
						"code": "2721"
					},
					{
						"title": "香川県信用組合",
						"code": "2721"
					},
					{
						"title": "Tosa credit union",
						"code": "2740"
					},
					{
						"title": "土佐信用組合",
						"code": "2740"
					},
					{
						"title": "宿毛商銀信用組合",
						"code": "2741"
					},
					{
						"title": "Sukumo commercial banks credit unions",
						"code": "2741"
					},
					{
						"title": "Fukuoka prefectural government credit union",
						"code": "2751"
					},
					{
						"title": "福岡県庁信用組合",
						"code": "2751"
					},
					{
						"title": "福岡県医師信用組合",
						"code": "2753"
					},
					{
						"title": "Fukuoka Prefecture doctor credit union",
						"code": "2753"
					},
					{
						"title": "Fukuoka Prefecture in southern credit union",
						"code": "2763"
					},
					{
						"title": "福岡県南部信用組合",
						"code": "2763"
					},
					{
						"title": "福岡県中央信用組合",
						"code": "2773"
					},
					{
						"title": "Fukuoka Prefecture central credit union",
						"code": "2773"
					},
					{
						"title": "Fukuoka Prefecture, central credit union",
						"code": "2773"
					},
					{
						"title": "とびうめ信用組合",
						"code": "2778"
					},
					{
						"title": "Plum credit union jump",
						"code": "2778"
					},
					{
						"title": "Saga doctor credit union",
						"code": "2802"
					},
					{
						"title": "佐賀県医師信用組合",
						"code": "2802"
					},
					{
						"title": "Saga Higashi credit union",
						"code": "2803"
					},
					{
						"title": "佐賀東信用組合",
						"code": "2803"
					},
					{
						"title": "佐賀西信用組合",
						"code": "2808"
					},
					{
						"title": "Saga west credit union",
						"code": "2808"
					},
					{
						"title": "長崎三菱信用組合",
						"code": "2820"
					},
					{
						"title": "Nagasaki Mitsubishi credit union",
						"code": "2820"
					},
					{
						"title": "Nagasaki Prefecture doctor credit union",
						"code": "2821"
					},
					{
						"title": "長崎県医師信用組合",
						"code": "2821"
					},
					{
						"title": "長崎県民信用組合",
						"code": "2825"
					},
					{
						"title": "Nagasaki prefecture credit union",
						"code": "2825"
					},
					{
						"title": "Sasebo Chuo credit union",
						"code": "2826"
					},
					{
						"title": "佐世保中央信用組合",
						"code": "2826"
					},
					{
						"title": "Fukue credit union",
						"code": "2833"
					},
					{
						"title": "福江信用組合",
						"code": "2833"
					},
					{
						"title": "Kyushu Saiwaigin credit union",
						"code": "2840"
					},
					{
						"title": "九州幸銀信用組合",
						"code": "2840"
					},
					{
						"title": "熊本県医師信用組合",
						"code": "2842"
					},
					{
						"title": "Kumamoto Prefecture doctor credit union",
						"code": "2842"
					},
					{
						"title": "Kumamoto Prefecture credit union",
						"code": "2845"
					},
					{
						"title": "熊本県信用組合",
						"code": "2845"
					},
					{
						"title": "大分県信用組合",
						"code": "2870"
					},
					{
						"title": "Oita Prefecture credit union",
						"code": "2870"
					},
					{
						"title": "Miyazaki Prefecture in southern credit union",
						"code": "2884"
					},
					{
						"title": "宮崎県南部信用組合",
						"code": "2884"
					},
					{
						"title": "Kagoshima Kogyo credit union",
						"code": "2890"
					},
					{
						"title": "鹿児島興業信用組合",
						"code": "2890"
					},
					{
						"title": "Kagoshima Prefecture doctor credit union",
						"code": "2891"
					},
					{
						"title": "鹿児島県医師信用組合",
						"code": "2891"
					},
					{
						"title": "Amami credit union",
						"code": "2895"
					},
					{
						"title": "奄美信用組合",
						"code": "2895"
					},
					{
						"title": "労働金庫連合会",
						"code": "2950"
					},
					{
						"title": "Rokinren",
						"code": "2950"
					},
					{
						"title": "Hokkaidorodokinko",
						"code": "2951"
					},
					{
						"title": "北海道労働金庫",
						"code": "2951"
					},
					{
						"title": "東北労働金庫",
						"code": "2954"
					},
					{
						"title": "Tohoku labor safe",
						"code": "2954"
					},
					{
						"title": "中央労働金庫",
						"code": "2963"
					},
					{
						"title": "Central Labor safe",
						"code": "2963"
					},
					{
						"title": "Niigata Prefecture Labor safe",
						"code": "2965"
					},
					{
						"title": "新潟県労働金庫",
						"code": "2965"
					},
					{
						"title": "Nagano Labor safe",
						"code": "2966"
					},
					{
						"title": "長野県労働金庫",
						"code": "2966"
					},
					{
						"title": "静岡県労働金庫",
						"code": "2968"
					},
					{
						"title": "Shizuokakenrodokinko",
						"code": "2968"
					},
					{
						"title": "北陸労働金庫",
						"code": "2970"
					},
					{
						"title": "Hokuriku workers safe",
						"code": "2970"
					},
					{
						"title": "東海労働金庫",
						"code": "2972"
					},
					{
						"title": "Tokai Labour Bank",
						"code": "2972"
					},
					{
						"title": "Kinki Labour Bank",
						"code": "2978"
					},
					{
						"title": "近畿労働金庫",
						"code": "2978"
					},
					{
						"title": "中国労働金庫",
						"code": "2984"
					},
					{
						"title": "China Labor safe",
						"code": "2984"
					},
					{
						"title": "四国労働金庫",
						"code": "2987"
					},
					{
						"title": "Shikoku labor safe",
						"code": "2987"
					},
					{
						"title": "九州労働金庫",
						"code": "2990"
					},
					{
						"title": "Kyushu labor safe",
						"code": "2990"
					},
					{
						"title": "Okinawa Prefecture Labor safe",
						"code": "2997"
					},
					{
						"title": "沖縄県労働金庫",
						"code": "2997"
					},
					{
						"title": "Norinchukin Bank",
						"code": "3000"
					},
					{
						"title": "農林中央金庫",
						"code": "3000"
					},
					{
						"title": "北海道信用農業協同組合連合会",
						"code": "3001"
					},
					{
						"title": "Hokkaido credit Federation of Agricultural Cooperatives",
						"code": "3001"
					},
					{
						"title": "岩手県信用農業協同組合連合会",
						"code": "3003"
					},
					{
						"title": "Iwate Prefecture credit Federation of Agricultural Cooperatives",
						"code": "3003"
					},
					{
						"title": "茨城県信用農業協同組合連合会",
						"code": "3008"
					},
					{
						"title": "Ibaraki Prefecture credit Federation of Agricultural Cooperatives",
						"code": "3008"
					},
					{
						"title": "Saitama Prefecture credit Federation of Agricultural Cooperatives",
						"code": "3011"
					},
					{
						"title": "埼玉県信用農業協同組合連合会",
						"code": "3011"
					},
					{
						"title": "東京都信用農業協同組合連合会",
						"code": "3013"
					},
					{
						"title": "Tokyo credit Federation of Agricultural Cooperatives",
						"code": "3013"
					},
					{
						"title": "Kanagawa Prefecture credit Federation of Agricultural Cooperatives",
						"code": "3014"
					},
					{
						"title": "神奈川県信用農業協同組合連合会",
						"code": "3014"
					},
					{
						"title": "Yamanashi Prefecture credit Federation of Agricultural Cooperatives",
						"code": "3015"
					},
					{
						"title": "山梨県信用農業協同組合連合会",
						"code": "3015"
					},
					{
						"title": "Nagano Prefecture credit Federation of Agricultural Cooperatives",
						"code": "3016"
					},
					{
						"title": "長野県信用農業協同組合連合会",
						"code": "3016"
					},
					{
						"title": "新潟県信用農業協同組合連合会",
						"code": "3017"
					},
					{
						"title": "Niigata Prefecture credit Federation of Agricultural Cooperatives",
						"code": "3017"
					},
					{
						"title": "Ishikawa Prefecture credit Federation of Agricultural Cooperatives",
						"code": "3019"
					},
					{
						"title": "石川県信用農業協同組合連合会",
						"code": "3019"
					},
					{
						"title": "Gifu credit Federation of Agricultural Cooperatives",
						"code": "3020"
					},
					{
						"title": "岐阜県信用農業協同組合連合会",
						"code": "3020"
					},
					{
						"title": "静岡県信用農業協同組合連合会",
						"code": "3021"
					},
					{
						"title": "Shizuoka Prefecture credit Federation of Agricultural Cooperatives",
						"code": "3021"
					},
					{
						"title": "愛知県信用農業協同組合連合会",
						"code": "3022"
					},
					{
						"title": "Aichi Prefecture credit Federation of Agricultural Cooperatives",
						"code": "3022"
					},
					{
						"title": "Mie Prefecture credit Federation of Agricultural Cooperatives",
						"code": "3023"
					},
					{
						"title": "三重県信用農業協同組合連合会",
						"code": "3023"
					},
					{
						"title": "Fukui Prefecture credit Federation of Agricultural Cooperatives",
						"code": "3024"
					},
					{
						"title": "福井県信用農業協同組合連合会",
						"code": "3024"
					},
					{
						"title": "Shiga Prefecture credit Federation of Agricultural Cooperatives",
						"code": "3025"
					},
					{
						"title": "滋賀県信用農業協同組合連合会",
						"code": "3025"
					},
					{
						"title": "Kyoto credit Federation of Agricultural Cooperatives",
						"code": "3026"
					},
					{
						"title": "京都府信用農業協同組合連合会",
						"code": "3026"
					},
					{
						"title": "大阪府信用農業協同組合連合会",
						"code": "3027"
					},
					{
						"title": "Osaka credit Federation of Agricultural Cooperatives",
						"code": "3027"
					},
					{
						"title": "Hyogo Prefecture credit Federation of Agricultural Cooperatives",
						"code": "3028"
					},
					{
						"title": "兵庫県信用農業協同組合連合会",
						"code": "3028"
					},
					{
						"title": "和歌山県信用農業協同組合連合会",
						"code": "3030"
					},
					{
						"title": "Wakayama Prefecture credit Federation of Agricultural Cooperatives",
						"code": "3030"
					},
					{
						"title": "Tottori Prefecture credit Federation of Agricultural Cooperatives",
						"code": "3031"
					},
					{
						"title": "鳥取県信用農業協同組合連合会",
						"code": "3031"
					},
					{
						"title": "広島県信用農業協同組合連合会",
						"code": "3034"
					},
					{
						"title": "Hiroshima credit Federation of Agricultural Cooperatives",
						"code": "3034"
					},
					{
						"title": "山口県信用農業協同組合連合会",
						"code": "3035"
					},
					{
						"title": "Yamaguchi Prefecture credit Federation of Agricultural Cooperatives",
						"code": "3035"
					},
					{
						"title": "徳島県信用農業協同組合連合会",
						"code": "3036"
					},
					{
						"title": "Tokushima Prefecture credit Federation of Agricultural Cooperatives",
						"code": "3036"
					},
					{
						"title": "香川県信用農業協同組合連合会",
						"code": "3037"
					},
					{
						"title": "Kagawa Prefecture credit Federation of Agricultural Cooperatives",
						"code": "3037"
					},
					{
						"title": "愛媛県信用農業協同組合連合会",
						"code": "3038"
					},
					{
						"title": "Ehime Prefecture credit Federation of Agricultural Cooperatives",
						"code": "3038"
					},
					{
						"title": "高知県信用農業協同組合連合会",
						"code": "3039"
					},
					{
						"title": "Kochi Prefecture credit Federation of Agricultural Cooperatives",
						"code": "3039"
					},
					{
						"title": "福岡県信用農業協同組合連合会",
						"code": "3040"
					},
					{
						"title": "Fukuoka Prefecture credit Federation of Agricultural Cooperatives",
						"code": "3040"
					},
					{
						"title": "佐賀県信用農業協同組合連合会",
						"code": "3041"
					},
					{
						"title": "Saga credit Federation of Agricultural Cooperatives",
						"code": "3041"
					},
					{
						"title": "Oita Prefecture credit Federation of Agricultural Cooperatives",
						"code": "3044"
					},
					{
						"title": "大分県信用農業協同組合連合会",
						"code": "3044"
					},
					{
						"title": "Miyazaki Prefecture credit Federation of Agricultural Cooperatives",
						"code": "3045"
					},
					{
						"title": "宮崎県信用農業協同組合連合会",
						"code": "3045"
					},
					{
						"title": "鹿児島県信用農業協同組合連合会",
						"code": "3046"
					},
					{
						"title": "Kagoshima Prefecture credit Federation of Agricultural Cooperatives",
						"code": "3046"
					},
					{
						"title": "北檜山町農業協同組合",
						"code": "3056"
					},
					{
						"title": "Kitahiyama Agricultural Cooperatives",
						"code": "3056"
					},
					{
						"title": "Imakane Agricultural Cooperatives",
						"code": "3058"
					},
					{
						"title": "今金町農業協同組合",
						"code": "3058"
					},
					{
						"title": "Hakodate Kameda agricultural cooperatives",
						"code": "3066"
					},
					{
						"title": "函館市亀田農業協同組合",
						"code": "3066"
					},
					{
						"title": "新函館農業協同組合",
						"code": "3068"
					},
					{
						"title": "New Hakodate Agricultural Cooperatives",
						"code": "3068"
					},
					{
						"title": "Essence Agricultural Cooperatives",
						"code": "3086"
					},
					{
						"title": "ようてい農業協同組合",
						"code": "3086"
					},
					{
						"title": "Republic of Agricultural Cooperatives",
						"code": "3087"
					},
					{
						"title": "きょうわ農業協同組合",
						"code": "3087"
					},
					{
						"title": "新おたる農業協同組合",
						"code": "3094"
					},
					{
						"title": "New Otaru Agricultural Cooperatives",
						"code": "3094"
					},
					{
						"title": "余市町農業協同組合",
						"code": "3095"
					},
					{
						"title": "Yoichi-cho agricultural cooperatives",
						"code": "3095"
					},
					{
						"title": "Yoichi-cho, agricultural cooperatives",
						"code": "3095"
					},
					{
						"title": "とうや湖農業協同組合",
						"code": "3103"
					},
					{
						"title": "Toya Lake Agricultural Cooperatives",
						"code": "3103"
					},
					{
						"title": "伊達市農業協同組合",
						"code": "3107"
					},
					{
						"title": "Date City Agricultural Cooperatives",
						"code": "3107"
					},
					{
						"title": "とまこまい広域農業協同組合",
						"code": "3112"
					},
					{
						"title": "Tomakomai wide area agricultural cooperatives",
						"code": "3112"
					},
					{
						"title": "Mukawa Agricultural Cooperatives",
						"code": "3114"
					},
					{
						"title": "鵡川農業協同組合",
						"code": "3114"
					},
					{
						"title": "びらとり農業協同組合",
						"code": "3120"
					},
					{
						"title": "Biratori Agricultural Cooperatives",
						"code": "3120"
					},
					{
						"title": "Monbetsu-cho Agricultural Cooperatives",
						"code": "3122"
					},
					{
						"title": "門別町農業協同組合",
						"code": "3122"
					},
					{
						"title": "新冠町農業協同組合",
						"code": "3124"
					},
					{
						"title": "Niikappu Agricultural Cooperatives",
						"code": "3124"
					},
					{
						"title": "しずない農業協同組合",
						"code": "3125"
					},
					{
						"title": "Shizunai Agricultural Cooperatives",
						"code": "3125"
					},
					{
						"title": "Mitsuishi Agricultural Cooperatives",
						"code": "3126"
					},
					{
						"title": "みついし農業協同組合",
						"code": "3126"
					},
					{
						"title": "ひだか東農業協同組合",
						"code": "3129"
					},
					{
						"title": "Hidaka east Agricultural Cooperatives",
						"code": "3129"
					},
					{
						"title": "札幌市農業協同組合",
						"code": "3133"
					},
					{
						"title": "Sapporo Agricultural Cooperatives",
						"code": "3133"
					},
					{
						"title": "道央農業協同組合",
						"code": "3139"
					},
					{
						"title": "Central Hokkaido agricultural cooperatives",
						"code": "3139"
					},
					{
						"title": "Ishikari City Agricultural Cooperatives",
						"code": "3142"
					},
					{
						"title": "石狩市農業協同組合",
						"code": "3142"
					},
					{
						"title": "North Ishikari Agricultural Cooperatives",
						"code": "3145"
					},
					{
						"title": "北石狩農業協同組合",
						"code": "3145"
					},
					{
						"title": "Shinshinotsu Agricultural Cooperatives",
						"code": "3147"
					},
					{
						"title": "新篠津村農業協同組合",
						"code": "3147"
					},
					{
						"title": "Satsuraku Agricultural Cooperatives",
						"code": "3154"
					},
					{
						"title": "サツラク農業協同組合",
						"code": "3154"
					},
					{
						"title": "いわみざわ農業協同組合",
						"code": "3156"
					},
					{
						"title": "Iwamizawa Agricultural Cooperatives",
						"code": "3156"
					},
					{
						"title": "南幌町農業協同組合",
						"code": "3161"
					},
					{
						"title": "Nanporo Agricultural Cooperatives",
						"code": "3161"
					},
					{
						"title": "美唄市農業協同組合",
						"code": "3164"
					},
					{
						"title": "Bibai Agricultural Cooperatives",
						"code": "3164"
					},
					{
						"title": "Minenobu Agricultural Cooperatives",
						"code": "3165"
					},
					{
						"title": "峰延農業協同組合",
						"code": "3165"
					},
					{
						"title": "Tsukigata Agricultural Cooperatives",
						"code": "3168"
					},
					{
						"title": "月形町農業協同組合",
						"code": "3168"
					},
					{
						"title": "ながぬま農業協同組合",
						"code": "3170"
					},
					{
						"title": "Naganuma Agricultural Cooperatives",
						"code": "3170"
					},
					{
						"title": "そらち南農業協同組合",
						"code": "3172"
					},
					{
						"title": "Minami Sorachi Agricultural Cooperatives",
						"code": "3172"
					},
					{
						"title": "夕張市農業協同組合",
						"code": "3173"
					},
					{
						"title": "Yubari agricultural cooperatives",
						"code": "3173"
					},
					{
						"title": "Shinsuna River Agricultural Cooperatives",
						"code": "3175"
					},
					{
						"title": "新砂川農業協同組合",
						"code": "3175"
					},
					{
						"title": "Takigawa Agricultural Cooperatives",
						"code": "3177"
					},
					{
						"title": "たきかわ農業協同組合",
						"code": "3177"
					},
					{
						"title": "Pin'ne Agricultural Cooperatives",
						"code": "3181"
					},
					{
						"title": "ピンネ農業協同組合",
						"code": "3181"
					},
					{
						"title": "North Ibuki Agricultural Cooperatives",
						"code": "3188"
					},
					{
						"title": "北いぶき農業協同組合",
						"code": "3188"
					},
					{
						"title": "きたそらち農業協同組合",
						"code": "3189"
					},
					{
						"title": "Kitasorachi Agricultural Cooperatives",
						"code": "3189"
					},
					{
						"title": "南るもい農業協同組合",
						"code": "3200"
					},
					{
						"title": "South Rumoi Agricultural Cooperatives",
						"code": "3200"
					},
					{
						"title": "苫前町農業協同組合",
						"code": "3201"
					},
					{
						"title": "Tomamae Agricultural Cooperatives",
						"code": "3201"
					},
					{
						"title": "オロロン農業協同組合",
						"code": "3202"
					},
					{
						"title": "Oloron Agricultural Cooperatives",
						"code": "3202"
					},
					{
						"title": "天塩町農業協同組合",
						"code": "3206"
					},
					{
						"title": "Teshio Agricultural Cooperatives",
						"code": "3206"
					},
					{
						"title": "幌延町農業協同組合",
						"code": "3208"
					},
					{
						"title": "Horonobe Agricultural Cooperatives",
						"code": "3208"
					},
					{
						"title": "あさひかわ農業協同組合",
						"code": "3210"
					},
					{
						"title": "Asahikawa Agricultural Cooperatives",
						"code": "3210"
					},
					{
						"title": "Important agricultural cooperatives",
						"code": "3214"
					},
					{
						"title": "たいせつ農業協同組合",
						"code": "3214"
					},
					{
						"title": "東神楽農業協同組合",
						"code": "3219"
					},
					{
						"title": "Higashikagura Agricultural Cooperatives",
						"code": "3219"
					},
					{
						"title": "Higashiasahikawa Agricultural Cooperatives",
						"code": "3220"
					},
					{
						"title": "東旭川農業協同組合",
						"code": "3220"
					},
					{
						"title": "Toma Agricultural Cooperatives",
						"code": "3223"
					},
					{
						"title": "当麻農業協同組合",
						"code": "3223"
					},
					{
						"title": "Pippu Agricultural Cooperatives",
						"code": "3224"
					},
					{
						"title": "比布町農業協同組合",
						"code": "3224"
					},
					{
						"title": "上川中央農業協同組合",
						"code": "3225"
					},
					{
						"title": "Kamikawa National Agricultural Cooperatives",
						"code": "3225"
					},
					{
						"title": "Higashikawa Agricultural Cooperatives",
						"code": "3227"
					},
					{
						"title": "東川町農業協同組合",
						"code": "3227"
					},
					{
						"title": "Biei-cho Agricultural Cooperatives",
						"code": "3228"
					},
					{
						"title": "美瑛町農業協同組合",
						"code": "3228"
					},
					{
						"title": "Furano Agricultural Cooperatives",
						"code": "3231"
					},
					{
						"title": "ふらの農業協同組合",
						"code": "3231"
					},
					{
						"title": "北ひびき農業協同組合",
						"code": "3238"
					},
					{
						"title": "North sound agricultural cooperatives",
						"code": "3238"
					},
					{
						"title": "道北なよろ農業協同組合",
						"code": "3244"
					},
					{
						"title": "Dohoku Nayoro Agricultural Cooperatives",
						"code": "3244"
					},
					{
						"title": "北はるか農業協同組合",
						"code": "3248"
					},
					{
						"title": "Haruka Kita Agricultural Cooperatives",
						"code": "3248"
					},
					{
						"title": "Wakkanai Agricultural Cooperatives",
						"code": "3254"
					},
					{
						"title": "稚内農業協同組合",
						"code": "3254"
					},
					{
						"title": "North Soya Agricultural Cooperatives",
						"code": "3257"
					},
					{
						"title": "北宗谷農業協同組合",
						"code": "3257"
					},
					{
						"title": "East Soya Agricultural Cooperatives",
						"code": "3259"
					},
					{
						"title": "東宗谷農業協同組合",
						"code": "3259"
					},
					{
						"title": "中頓別町農業協同組合",
						"code": "3260"
					},
					{
						"title": "Nakatonbetsu Agricultural Cooperatives",
						"code": "3260"
					},
					{
						"title": "Minami Soya Agricultural Cooperatives",
						"code": "3261"
					},
					{
						"title": "宗谷南農業協同組合",
						"code": "3261"
					},
					{
						"title": "帯広市川西農業協同組合",
						"code": "3264"
					},
					{
						"title": "Obihiro Kawanishi agriculture cooperatives",
						"code": "3264"
					},
					{
						"title": "Obihiro Taisho Agricultural Cooperatives",
						"code": "3265"
					},
					{
						"title": "帯広大正農業協同組合",
						"code": "3265"
					},
					{
						"title": "Nakasatsunai Agricultural Cooperatives",
						"code": "3266"
					},
					{
						"title": "中札内村農業協同組合",
						"code": "3266"
					},
					{
						"title": "更別村農業協同組合",
						"code": "3267"
					},
					{
						"title": "Sarabetsu Agricultural Cooperatives",
						"code": "3267"
					},
					{
						"title": "忠類農業協同組合",
						"code": "3268"
					},
					{
						"title": "Churui Agricultural Cooperatives",
						"code": "3268"
					},
					{
						"title": "Taiki Agricultural Cooperatives",
						"code": "3269"
					},
					{
						"title": "大樹町農業協同組合",
						"code": "3269"
					},
					{
						"title": "広尾町農業協同組合",
						"code": "3270"
					},
					{
						"title": "Hiroo-cho Agricultural Cooperatives",
						"code": "3270"
					},
					{
						"title": "芽室町農業協同組合",
						"code": "3271"
					},
					{
						"title": "Memuro Agricultural Cooperatives",
						"code": "3271"
					},
					{
						"title": "十勝清水町農業協同組合",
						"code": "3273"
					},
					{
						"title": "Tokachi Shimizu-cho Agricultural Cooperatives",
						"code": "3273"
					},
					{
						"title": "Shintoku-cho Agricultural Cooperatives",
						"code": "3275"
					},
					{
						"title": "新得町農業協同組合",
						"code": "3275"
					},
					{
						"title": "鹿追町農業協同組合",
						"code": "3276"
					},
					{
						"title": "Shikaoi Agricultural Cooperatives",
						"code": "3276"
					},
					{
						"title": "Kino Agricultural Cooperatives",
						"code": "3277"
					},
					{
						"title": "木野農業協同組合",
						"code": "3277"
					},
					{
						"title": "音更町農業協同組合",
						"code": "3278"
					},
					{
						"title": "Otofuke Agricultural Cooperatives",
						"code": "3278"
					},
					{
						"title": "士幌町農業協同組合",
						"code": "3279"
					},
					{
						"title": "Shihoro Agricultural Cooperatives",
						"code": "3279"
					},
					{
						"title": "Kamishihoro Agricultural Cooperatives",
						"code": "3280"
					},
					{
						"title": "上士幌町農業協同組合",
						"code": "3280"
					},
					{
						"title": "札内農業協同組合",
						"code": "3281"
					},
					{
						"title": "Satsunai Agricultural Cooperatives",
						"code": "3281"
					},
					{
						"title": "幕別町農業協同組合",
						"code": "3282"
					},
					{
						"title": "Makubetsu Agricultural Cooperatives",
						"code": "3282"
					},
					{
						"title": "Tokachi Ikeda Agricultural Cooperatives",
						"code": "3283"
					},
					{
						"title": "十勝池田町農業協同組合",
						"code": "3283"
					},
					{
						"title": "Tokachi Takashima Agricultural Cooperatives",
						"code": "3285"
					},
					{
						"title": "十勝高島農業協同組合",
						"code": "3285"
					},
					{
						"title": "Toyokoro Agricultural Cooperatives",
						"code": "3286"
					},
					{
						"title": "豊頃町農業協同組合",
						"code": "3286"
					},
					{
						"title": "浦幌町農業協同組合",
						"code": "3287"
					},
					{
						"title": "Urahoro Agricultural Cooperatives",
						"code": "3287"
					},
					{
						"title": "Honbetsu Agricultural Cooperatives",
						"code": "3288"
					},
					{
						"title": "本別町農業協同組合",
						"code": "3288"
					},
					{
						"title": "Ashoro Agricultural Cooperatives",
						"code": "3289"
					},
					{
						"title": "足寄町農業協同組合",
						"code": "3289"
					},
					{
						"title": "Rikubetsu Agricultural Cooperatives",
						"code": "3290"
					},
					{
						"title": "陸別町農業協同組合",
						"code": "3290"
					},
					{
						"title": "North Okhotsk Agricultural Cooperatives",
						"code": "3297"
					},
					{
						"title": "北オホーツク農業協同組合",
						"code": "3297"
					},
					{
						"title": "Okhotsk Hamanasu Agricultural Cooperatives",
						"code": "3301"
					},
					{
						"title": "オホーツクはまなす農業協同組合",
						"code": "3301"
					},
					{
						"title": "Saroma Agricultural Cooperatives",
						"code": "3303"
					},
					{
						"title": "佐呂間町農業協同組合",
						"code": "3303"
					},
					{
						"title": "湧別町農業協同組合",
						"code": "3305"
					},
					{
						"title": "Yubetsu Agricultural Cooperatives",
						"code": "3305"
					},
					{
						"title": "えんゆう農業協同組合",
						"code": "3306"
					},
					{
						"title": "En'yu Agricultural Cooperatives",
						"code": "3306"
					},
					{
						"title": "Future agricultural cooperatives who came",
						"code": "3317"
					},
					{
						"title": "きたみらい農業協同組合",
						"code": "3317"
					},
					{
						"title": "津別町農業協同組合",
						"code": "3319"
					},
					{
						"title": "Tsubetsu Agricultural Cooperatives",
						"code": "3319"
					},
					{
						"title": "美幌町農業協同組合",
						"code": "3320"
					},
					{
						"title": "Bihoro Agricultural Cooperatives",
						"code": "3320"
					},
					{
						"title": "Memanbetsu Agricultural Cooperatives",
						"code": "3321"
					},
					{
						"title": "女満別町農業協同組合",
						"code": "3321"
					},
					{
						"title": "常呂町農業協同組合",
						"code": "3322"
					},
					{
						"title": "Tokoro-cho agricultural cooperatives",
						"code": "3322"
					},
					{
						"title": "Tokoro-cho, agricultural cooperatives",
						"code": "3322"
					},
					{
						"title": "オホーツク網走農業協同組合",
						"code": "3326"
					},
					{
						"title": "Okhotsk Abashiri Agricultural Cooperatives",
						"code": "3326"
					},
					{
						"title": "Koshimizu-cho Agricultural Cooperatives",
						"code": "3328"
					},
					{
						"title": "小清水町農業協同組合",
						"code": "3328"
					},
					{
						"title": "Shari-cho Agricultural Cooperatives",
						"code": "3329"
					},
					{
						"title": "斜里町農業協同組合",
						"code": "3329"
					},
					{
						"title": "Kiyosato Agricultural Cooperatives",
						"code": "3330"
					},
					{
						"title": "清里町農業協同組合",
						"code": "3330"
					},
					{
						"title": "釧路太田農業協同組合",
						"code": "3334"
					},
					{
						"title": "Kushiro Ota agricultural cooperatives",
						"code": "3334"
					},
					{
						"title": "浜中町農業協同組合",
						"code": "3335"
					},
					{
						"title": "Hamanaka Agricultural Cooperatives",
						"code": "3335"
					},
					{
						"title": "標茶町農業協同組合",
						"code": "3336"
					},
					{
						"title": "Shibecha Agricultural Cooperatives",
						"code": "3336"
					},
					{
						"title": "Lake Mashu Agricultural Cooperatives",
						"code": "3337"
					},
					{
						"title": "摩周湖農業協同組合",
						"code": "3337"
					},
					{
						"title": "阿寒農業協同組合",
						"code": "3338"
					},
					{
						"title": "Akan Agricultural Cooperatives",
						"code": "3338"
					},
					{
						"title": "釧路丹頂農業協同組合",
						"code": "3339"
					},
					{
						"title": "Kushiro Tancho Agricultural Cooperatives",
						"code": "3339"
					},
					{
						"title": "標津町農業協同組合",
						"code": "3348"
					},
					{
						"title": "Shibetsu Agricultural Cooperatives",
						"code": "3348"
					},
					{
						"title": "中標津町農業協同組合",
						"code": "3349"
					},
					{
						"title": "Nakashibetsu Agricultural Cooperatives",
						"code": "3349"
					},
					{
						"title": "計根別農業協同組合",
						"code": "3350"
					},
					{
						"title": "Kenebetsu Agricultural Cooperatives",
						"code": "3350"
					},
					{
						"title": "Eastern Asahi Agricultural Cooperatives",
						"code": "3354"
					},
					{
						"title": "道東あさひ農業協同組合",
						"code": "3354"
					},
					{
						"title": "中春別農業協同組合",
						"code": "3358"
					},
					{
						"title": "Nakashunbetsu Agricultural Cooperatives",
						"code": "3358"
					},
					{
						"title": "青森農業協同組合",
						"code": "3373"
					},
					{
						"title": "Aomori Agricultural Cooperatives",
						"code": "3373"
					},
					{
						"title": "Tsugaru Hirosaki Agricultural Cooperatives",
						"code": "3387"
					},
					{
						"title": "つがる弘前農業協同組合",
						"code": "3387"
					},
					{
						"title": "Soma village agricultural cooperatives",
						"code": "3390"
					},
					{
						"title": "相馬村農業協同組合",
						"code": "3390"
					},
					{
						"title": "津軽みらい農業協同組合",
						"code": "3407"
					},
					{
						"title": "Tsugaru future agricultural cooperatives",
						"code": "3407"
					},
					{
						"title": "つがるにしきた農業協同組合",
						"code": "3421"
					},
					{
						"title": "Tsugaru northwest Agricultural Cooperatives",
						"code": "3421"
					},
					{
						"title": "Imperial Palace One wants agricultural cooperatives",
						"code": "3442"
					},
					{
						"title": "ごしょつがる農業協同組合",
						"code": "3442"
					},
					{
						"title": "Towada Oirase Agricultural Cooperatives",
						"code": "3455"
					},
					{
						"title": "十和田おいらせ農業協同組合",
						"code": "3455"
					},
					{
						"title": "ゆうき青森農業協同組合",
						"code": "3469"
					},
					{
						"title": "Yuki Aomori Agricultural Cooperatives",
						"code": "3469"
					},
					{
						"title": "おいらせ農業協同組合",
						"code": "3474"
					},
					{
						"title": "Oirase Agricultural Cooperatives",
						"code": "3474"
					},
					{
						"title": "八戸農業協同組合",
						"code": "3488"
					},
					{
						"title": "Hachinohe Agricultural Cooperatives",
						"code": "3488"
					},
					{
						"title": "New Iwate Agricultural Cooperatives",
						"code": "3517"
					},
					{
						"title": "新岩手農業協同組合",
						"code": "3517"
					},
					{
						"title": "岩手中央酪農業協同組合",
						"code": "3539"
					},
					{
						"title": "Iwate central dairy cooperative",
						"code": "3539"
					},
					{
						"title": "岩手中央農業協同組合",
						"code": "3541"
					},
					{
						"title": "Iwate National Agricultural Cooperatives",
						"code": "3541"
					},
					{
						"title": "花巻農業協同組合",
						"code": "3553"
					},
					{
						"title": "Hanamaki Agricultural Cooperatives",
						"code": "3553"
					},
					{
						"title": "岩手ふるさと農業協同組合",
						"code": "3572"
					},
					{
						"title": "Iwate Furusato Agricultural Cooperatives",
						"code": "3572"
					},
					{
						"title": "岩手江刺農業協同組合",
						"code": "3579"
					},
					{
						"title": "Iwate Esashi Agricultural Cooperatives",
						"code": "3579"
					},
					{
						"title": "Iwate Hiraizumi Agricultural Cooperatives",
						"code": "3590"
					},
					{
						"title": "いわて平泉農業協同組合",
						"code": "3590"
					},
					{
						"title": "Ofunato Agricultural Cooperatives",
						"code": "3598"
					},
					{
						"title": "大船渡市農業協同組合",
						"code": "3598"
					},
					{
						"title": "仙台農業協同組合",
						"code": "3636"
					},
					{
						"title": "Sendai Agricultural Cooperatives",
						"code": "3636"
					},
					{
						"title": "岩沼市農業協同組合",
						"code": "3647"
					},
					{
						"title": "Iwanuma Agricultural Cooperatives",
						"code": "3647"
					},
					{
						"title": "Natori Iwanuma Agricultural Cooperatives",
						"code": "3652"
					},
					{
						"title": "名取岩沼農業協同組合",
						"code": "3652"
					},
					{
						"title": "Miyagi Watari Agricultural Cooperatives",
						"code": "3653"
					},
					{
						"title": "みやぎ亘理農業協同組合",
						"code": "3653"
					},
					{
						"title": "Asahina Agricultural Cooperatives",
						"code": "3664"
					},
					{
						"title": "あさひな農業協同組合",
						"code": "3664"
					},
					{
						"title": "Miyagi Tome Agricultural Cooperatives",
						"code": "3665"
					},
					{
						"title": "みやぎ登米農業協同組合",
						"code": "3665"
					},
					{
						"title": "Minami Sanriku Agricultural Cooperatives",
						"code": "3682"
					},
					{
						"title": "南三陸農業協同組合",
						"code": "3682"
					},
					{
						"title": "Kurikko Agricultural Cooperatives",
						"code": "3702"
					},
					{
						"title": "栗っこ農業協同組合",
						"code": "3702"
					},
					{
						"title": "古川農業協同組合",
						"code": "3704"
					},
					{
						"title": "Furukawa Agricultural Cooperatives",
						"code": "3704"
					},
					{
						"title": "加美よつば農業協同組合",
						"code": "3710"
					},
					{
						"title": "Kami Yotsubanogyo cooperative",
						"code": "3710"
					},
					{
						"title": "いわでやま農業協同組合",
						"code": "3717"
					},
					{
						"title": "Iwadeyama Agricultural Cooperatives",
						"code": "3717"
					},
					{
						"title": "Agricultural Cooperatives of green",
						"code": "3721"
					},
					{
						"title": "みどりの農業協同組合",
						"code": "3721"
					},
					{
						"title": "Ishinomaki Agricultural Cooperatives",
						"code": "3731"
					},
					{
						"title": "いしのまき農業協同組合",
						"code": "3731"
					},
					{
						"title": "Miyagi Sennan Agricultural Cooperatives",
						"code": "3751"
					},
					{
						"title": "みやぎ仙南農業協同組合",
						"code": "3751"
					},
					{
						"title": "Kazuno Agricultural Cooperatives",
						"code": "3762"
					},
					{
						"title": "かづの農業協同組合",
						"code": "3762"
					},
					{
						"title": "あきた北農業協同組合",
						"code": "3764"
					},
					{
						"title": "Akitakita Agricultural Cooperatives",
						"code": "3764"
					},
					{
						"title": "鷹巣町農業協同組合",
						"code": "3771"
					},
					{
						"title": "Takanosu Agricultural Cooperatives",
						"code": "3771"
					},
					{
						"title": "Akita Hokuo Agricultural Cooperatives",
						"code": "3773"
					},
					{
						"title": "あきた北央農業協同組合",
						"code": "3773"
					},
					{
						"title": "あきた白神農業協同組合",
						"code": "3784"
					},
					{
						"title": "Akita Shirakami Agricultural Cooperatives",
						"code": "3784"
					},
					{
						"title": "秋田やまもと農業協同組合",
						"code": "3795"
					},
					{
						"title": "Akita Yamamoto Agricultural Cooperatives",
						"code": "3795"
					},
					{
						"title": "あきた湖東農業協同組合",
						"code": "3798"
					},
					{
						"title": "Akita Koto Agricultural Cooperatives",
						"code": "3798"
					},
					{
						"title": "秋田みなみ農業協同組合",
						"code": "3805"
					},
					{
						"title": "Minami Akita Agricultural Cooperatives",
						"code": "3805"
					},
					{
						"title": "新あきた農業協同組合",
						"code": "3810"
					},
					{
						"title": "New autumn agricultural cooperatives",
						"code": "3810"
					},
					{
						"title": "秋田しんせい農業協同組合",
						"code": "3825"
					},
					{
						"title": "Akita nascent agricultural cooperatives",
						"code": "3825"
					},
					{
						"title": "秋田おばこ農業協同組合",
						"code": "3855"
					},
					{
						"title": "Akita lass Agricultural Cooperatives",
						"code": "3855"
					},
					{
						"title": "Akita Furusato Agricultural Cooperatives",
						"code": "3878"
					},
					{
						"title": "秋田ふるさと農業協同組合",
						"code": "3878"
					},
					{
						"title": "こまち農業協同組合",
						"code": "3913"
					},
					{
						"title": "Komachi Agricultural Cooperatives",
						"code": "3913"
					},
					{
						"title": "うご農業協同組合",
						"code": "3917"
					},
					{
						"title": "Ugo Agricultural Cooperatives",
						"code": "3917"
					},
					{
						"title": "大潟村農業協同組合",
						"code": "3929"
					},
					{
						"title": "Ogata agricultural cooperatives",
						"code": "3929"
					},
					{
						"title": "山形市農業協同組合",
						"code": "3931"
					},
					{
						"title": "Yamagata agricultural cooperatives",
						"code": "3931"
					},
					{
						"title": "Yamagata agricultural cooperatives",
						"code": "3932"
					},
					{
						"title": "山形農業協同組合",
						"code": "3932"
					},
					{
						"title": "天童市農業協同組合",
						"code": "3938"
					},
					{
						"title": "Tendo Agricultural Cooperatives",
						"code": "3938"
					},
					{
						"title": "さがえ西村山農業協同組合",
						"code": "3943"
					},
					{
						"title": "Sagae Nishimurayama Agricultural Cooperatives",
						"code": "3943"
					},
					{
						"title": "みちのく村山農業協同組合",
						"code": "3960"
					},
					{
						"title": "Michinoku Murayama Agricultural Cooperatives",
						"code": "3960"
					},
					{
						"title": "Higashine Agricultural Cooperatives",
						"code": "3962"
					},
					{
						"title": "東根市農業協同組合",
						"code": "3962"
					},
					{
						"title": "Shinjo Agricultural Cooperatives",
						"code": "3971"
					},
					{
						"title": "新庄市農業協同組合",
						"code": "3971"
					},
					{
						"title": "新庄もがみ農業協同組合",
						"code": "3973"
					},
					{
						"title": "Shinjo top agricultural cooperatives",
						"code": "3973"
					},
					{
						"title": "山形もがみ農業協同組合",
						"code": "3980"
					},
					{
						"title": "Yamagata top agricultural cooperatives",
						"code": "3980"
					},
					{
						"title": "真室川町農業協同組合",
						"code": "3986"
					},
					{
						"title": "Mamurogawa Agricultural Cooperatives",
						"code": "3986"
					},
					{
						"title": "Jinshan Agricultural Cooperatives",
						"code": "3987"
					},
					{
						"title": "金山農業協同組合",
						"code": "3987"
					},
					{
						"title": "山形おきたま農業協同組合",
						"code": "3989"
					},
					{
						"title": "Yamagata Okitama Agricultural Cooperatives",
						"code": "3989"
					},
					{
						"title": "鶴岡市農業協同組合",
						"code": "4000"
					},
					{
						"title": "Tsuruoka Agricultural Cooperatives",
						"code": "4000"
					},
					{
						"title": "Shonai Tagawa agricultural cooperatives",
						"code": "4013"
					},
					{
						"title": "庄内たがわ農業協同組合",
						"code": "4013"
					},
					{
						"title": "余目町農業協同組合",
						"code": "4022"
					},
					{
						"title": "Amarume Agricultural Cooperatives",
						"code": "4022"
					},
					{
						"title": "庄内みどり農業協同組合",
						"code": "4027"
					},
					{
						"title": "Shonai green agricultural cooperatives",
						"code": "4027"
					},
					{
						"title": "Sakata sleeve Ura agricultural cooperatives",
						"code": "4036"
					},
					{
						"title": "酒田市袖浦農業協同組合",
						"code": "4036"
					},
					{
						"title": "Shin Fukushima Agricultural Cooperatives",
						"code": "4047"
					},
					{
						"title": "新ふくしま農業協同組合",
						"code": "4047"
					},
					{
						"title": "伊達みらい農業協同組合",
						"code": "4064"
					},
					{
						"title": "Mirai Date agricultural cooperatives",
						"code": "4064"
					},
					{
						"title": "みちのく安達農業協同組合",
						"code": "4069"
					},
					{
						"title": "Michinoku Adachi Agricultural Cooperatives",
						"code": "4069"
					},
					{
						"title": "郡山市農業協同組合",
						"code": "4076"
					},
					{
						"title": "Koriyama Agricultural Cooperatives",
						"code": "4076"
					},
					{
						"title": "Sukagawa Iwase Agricultural Cooperatives",
						"code": "4091"
					},
					{
						"title": "すかがわ岩瀬農業協同組合",
						"code": "4091"
					},
					{
						"title": "あぶくま石川農業協同組合",
						"code": "4104"
					},
					{
						"title": "Abukuma Ishikawa Agricultural Cooperatives",
						"code": "4104"
					},
					{
						"title": "たむら農業協同組合",
						"code": "4125"
					},
					{
						"title": "Tamura Agricultural Cooperatives",
						"code": "4125"
					},
					{
						"title": "白河農業協同組合",
						"code": "4130"
					},
					{
						"title": "Shirakawa agricultural cooperatives",
						"code": "4130"
					},
					{
						"title": "東西しらかわ農業協同組合",
						"code": "4132"
					},
					{
						"title": "East-West Shirakawa agricultural cooperatives",
						"code": "4132"
					},
					{
						"title": "あいづ農業協同組合",
						"code": "4148"
					},
					{
						"title": "Aizu Agricultural Cooperatives",
						"code": "4148"
					},
					{
						"title": "会津いいで農業協同組合",
						"code": "4160"
					},
					{
						"title": "Aizu Iide Agricultural Cooperatives",
						"code": "4160"
					},
					{
						"title": "Midori Aizu agricultural cooperatives",
						"code": "4175"
					},
					{
						"title": "会津みどり農業協同組合",
						"code": "4175"
					},
					{
						"title": "会津みなみ農業協同組合",
						"code": "4189"
					},
					{
						"title": "Minami Aizu Agricultural Cooperatives",
						"code": "4189"
					},
					{
						"title": "いわき市農業協同組合",
						"code": "4196"
					},
					{
						"title": "Iwaki City Agricultural Cooperatives",
						"code": "4196"
					},
					{
						"title": "いわき中部農業協同組合",
						"code": "4197"
					},
					{
						"title": "Iwaki Central Agricultural Cooperatives",
						"code": "4197"
					},
					{
						"title": "Futaba Agricultural Cooperatives",
						"code": "4220"
					},
					{
						"title": "ふたば農業協同組合",
						"code": "4220"
					},
					{
						"title": "Soma Agricultural Cooperatives",
						"code": "4230"
					},
					{
						"title": "そうま農業協同組合",
						"code": "4230"
					},
					{
						"title": "水戸農業協同組合",
						"code": "4238"
					},
					{
						"title": "Mito Agricultural Cooperatives",
						"code": "4238"
					},
					{
						"title": "常陸農業協同組合",
						"code": "4263"
					},
					{
						"title": "Hitachi agricultural cooperatives",
						"code": "4263"
					},
					{
						"title": "日立市多賀農業協同組合",
						"code": "4294"
					},
					{
						"title": "Hitachi Taga agricultural cooperatives",
						"code": "4294"
					},
					{
						"title": "茨城旭村農業協同組合",
						"code": "4295"
					},
					{
						"title": "Ibaraki Asahimura Agricultural Cooperatives",
						"code": "4295"
					},
					{
						"title": "Hokota Agricultural Cooperatives",
						"code": "4296"
					},
					{
						"title": "ほこた農業協同組合",
						"code": "4296"
					},
					{
						"title": "しおさい農業協同組合",
						"code": "4301"
					},
					{
						"title": "Shiosai Agricultural Cooperatives",
						"code": "4301"
					},
					{
						"title": "なめがた農業協同組合",
						"code": "4310"
					},
					{
						"title": "Whereabouts of Agricultural Cooperatives",
						"code": "4310"
					},
					{
						"title": "Inashiki Agricultural Cooperatives",
						"code": "4322"
					},
					{
						"title": "稲敷農業協同組合",
						"code": "4322"
					},
					{
						"title": "茨城かすみ農業協同組合",
						"code": "4324"
					},
					{
						"title": "Ibaraki Kasumi Agricultural Cooperatives",
						"code": "4324"
					},
					{
						"title": "Ryugasaki Agricultural Cooperatives",
						"code": "4344"
					},
					{
						"title": "竜ケ崎農業協同組合",
						"code": "4344"
					},
					{
						"title": "Tsuchiura Agricultural Cooperatives",
						"code": "4357"
					},
					{
						"title": "土浦農業協同組合",
						"code": "4357"
					},
					{
						"title": "つくば市農業協同組合",
						"code": "4363"
					},
					{
						"title": "Tsukuba Japan Agricultural Cooperatives",
						"code": "4363"
					},
					{
						"title": "Tsukuba, Japan Agricultural Cooperatives",
						"code": "4363"
					},
					{
						"title": "つくば市谷田部農業協同組合",
						"code": "4371"
					},
					{
						"title": "Tsukuba Japan Yatabe agricultural cooperatives",
						"code": "4371"
					},
					{
						"title": "Tsukuba, Japan Yatabe agricultural cooperatives",
						"code": "4371"
					},
					{
						"title": "茨城みなみ農業協同組合",
						"code": "4378"
					},
					{
						"title": "Ibaraki Minami Agricultural Cooperatives",
						"code": "4378"
					},
					{
						"title": "Yasato Agricultural Cooperatives",
						"code": "4387"
					},
					{
						"title": "やさと農業協同組合",
						"code": "4387"
					},
					{
						"title": "New Hitachino Agricultural Cooperatives",
						"code": "4394"
					},
					{
						"title": "新ひたち野農業協同組合",
						"code": "4394"
					},
					{
						"title": "北つくば農業協同組合",
						"code": "4397"
					},
					{
						"title": "North Tsukuba Agricultural Cooperatives",
						"code": "4397"
					},
					{
						"title": "Joso Hikari Agricultural Cooperatives",
						"code": "4413"
					},
					{
						"title": "常総ひかり農業協同組合",
						"code": "4413"
					},
					{
						"title": "茨城むつみ農業協同組合",
						"code": "4422"
					},
					{
						"title": "Ibaraki Mutsumi Agricultural Cooperatives",
						"code": "4422"
					},
					{
						"title": "Iwai Agricultural Cooperatives",
						"code": "4425"
					},
					{
						"title": "岩井農業協同組合",
						"code": "4425"
					},
					{
						"title": "Utsunomiya Agricultural Cooperatives",
						"code": "4445"
					},
					{
						"title": "宇都宮農業協同組合",
						"code": "4445"
					},
					{
						"title": "上都賀農業協同組合",
						"code": "4456"
					},
					{
						"title": "Kamitsuga Agricultural Cooperatives",
						"code": "4456"
					},
					{
						"title": "はが野農業協同組合",
						"code": "4463"
					},
					{
						"title": "Hagano Agricultural Cooperatives",
						"code": "4463"
					},
					{
						"title": "下野農業協同組合",
						"code": "4478"
					},
					{
						"title": "Shimono Agricultural Cooperatives",
						"code": "4478"
					},
					{
						"title": "小山農業協同組合",
						"code": "4490"
					},
					{
						"title": "Koyama Agricultural Cooperatives",
						"code": "4490"
					},
					{
						"title": "Shionoya Agricultural Cooperatives",
						"code": "4497"
					},
					{
						"title": "塩野谷農業協同組合",
						"code": "4497"
					},
					{
						"title": "Nasuno Agricultural Cooperatives",
						"code": "4507"
					},
					{
						"title": "那須野農業協同組合",
						"code": "4507"
					},
					{
						"title": "Minami Nasu Agricultural Cooperatives",
						"code": "4518"
					},
					{
						"title": "那須南農業協同組合",
						"code": "4518"
					},
					{
						"title": "Sano Agricultural Cooperatives",
						"code": "4523"
					},
					{
						"title": "佐野農業協同組合",
						"code": "4523"
					},
					{
						"title": "Ashikaga Agricultural Cooperatives",
						"code": "4533"
					},
					{
						"title": "足利市農業協同組合",
						"code": "4533"
					},
					{
						"title": "赤城橘農業協同組合",
						"code": "4540"
					},
					{
						"title": "Tachibana Akagi Agricultural Cooperatives",
						"code": "4540"
					},
					{
						"title": "前橋市農業協同組合",
						"code": "4544"
					},
					{
						"title": "Maebashi Agricultural Cooperatives",
						"code": "4544"
					},
					{
						"title": "Takasaki Agricultural Cooperatives",
						"code": "4563"
					},
					{
						"title": "高崎市農業協同組合",
						"code": "4563"
					},
					{
						"title": "Cultivate agricultural cooperatives",
						"code": "4567"
					},
					{
						"title": "はぐくみ農業協同組合",
						"code": "4567"
					},
					{
						"title": "Kitagun Shibukawa Agricultural Cooperatives",
						"code": "4593"
					},
					{
						"title": "北群渋川農業協同組合",
						"code": "4593"
					},
					{
						"title": "Tano Fujioka Agricultural Cooperatives",
						"code": "4594"
					},
					{
						"title": "多野藤岡農業協同組合",
						"code": "4594"
					},
					{
						"title": "甘楽富岡農業協同組合",
						"code": "4608"
					},
					{
						"title": "Kanratomiokanogyo cooperative",
						"code": "4608"
					},
					{
						"title": "碓氷安中農業協同組合",
						"code": "4613"
					},
					{
						"title": "Usui Annaka Agricultural Cooperatives",
						"code": "4613"
					},
					{
						"title": "Agatsumanogyo cooperative",
						"code": "4626"
					},
					{
						"title": "あがつま農業協同組合",
						"code": "4626"
					},
					{
						"title": "嬬恋村農業協同組合",
						"code": "4628"
					},
					{
						"title": "Tsumagoimura Agricultural Cooperatives",
						"code": "4628"
					},
					{
						"title": "利根沼田農業協同組合",
						"code": "4632"
					},
					{
						"title": "Tone Numata Agricultural Cooperatives",
						"code": "4632"
					},
					{
						"title": "佐波伊勢崎農業協同組合",
						"code": "4652"
					},
					{
						"title": "Saba Isesaki Agricultural Cooperatives",
						"code": "4652"
					},
					{
						"title": "新田みどり農業協同組合",
						"code": "4664"
					},
					{
						"title": "Midori Nitta agricultural cooperatives",
						"code": "4664"
					},
					{
						"title": "Ota City Agricultural Cooperatives",
						"code": "4665"
					},
					{
						"title": "太田市農業協同組合",
						"code": "4665"
					},
					{
						"title": "邑楽館林農業協同組合",
						"code": "4677"
					},
					{
						"title": "Oura Tatebayashi Agricultural Cooperatives",
						"code": "4677"
					},
					{
						"title": "Saitama Agricultural Cooperatives",
						"code": "4682"
					},
					{
						"title": "さいたま農業協同組合",
						"code": "4682"
					},
					{
						"title": "戸田市農業協同組合",
						"code": "4688"
					},
					{
						"title": "Toda City Agricultural Cooperatives",
						"code": "4688"
					},
					{
						"title": "川口市農業協同組合",
						"code": "4691"
					},
					{
						"title": "Kawaguchi Agricultural Cooperatives",
						"code": "4691"
					},
					{
						"title": "あゆみ野農業協同組合",
						"code": "4693"
					},
					{
						"title": "Ayumino Agricultural Cooperatives",
						"code": "4693"
					},
					{
						"title": "Konosu Agricultural Cooperatives",
						"code": "4714"
					},
					{
						"title": "鴻巣市農業協同組合",
						"code": "4714"
					},
					{
						"title": "あだち野農業協同組合",
						"code": "4726"
					},
					{
						"title": "Adachi field Agricultural Cooperatives",
						"code": "4726"
					},
					{
						"title": "あさか野農業協同組合",
						"code": "4730"
					},
					{
						"title": "Asaka field Agricultural Cooperatives",
						"code": "4730"
					},
					{
						"title": "Iruma field Agricultural Cooperatives",
						"code": "4735"
					},
					{
						"title": "いるま野農業協同組合",
						"code": "4735"
					},
					{
						"title": "埼玉中央農業協同組合",
						"code": "4780"
					},
					{
						"title": "Saitama National Agricultural Cooperatives",
						"code": "4780"
					},
					{
						"title": "ちちぶ農業協同組合",
						"code": "4792"
					},
					{
						"title": "Chichibu Agricultural Cooperatives",
						"code": "4792"
					},
					{
						"title": "Agricultural Cooperatives of Saitama sound",
						"code": "4802"
					},
					{
						"title": "埼玉ひびきの農業協同組合",
						"code": "4802"
					},
					{
						"title": "Kumagai Agricultural Cooperatives",
						"code": "4808"
					},
					{
						"title": "くまがや農業協同組合",
						"code": "4808"
					},
					{
						"title": "埼玉岡部農業協同組合",
						"code": "4820"
					},
					{
						"title": "Saitama Okabe Agricultural Cooperatives",
						"code": "4820"
					},
					{
						"title": "榛沢農業協同組合",
						"code": "4821"
					},
					{
						"title": "Hanzawa Agricultural Cooperatives",
						"code": "4821"
					},
					{
						"title": "Garden Agricultural Cooperatives",
						"code": "4823"
					},
					{
						"title": "花園農業協同組合",
						"code": "4823"
					},
					{
						"title": "ほくさい農業協同組合",
						"code": "4828"
					},
					{
						"title": "Hokusai Agricultural Cooperatives",
						"code": "4828"
					},
					{
						"title": "Koshigaya Agricultural Cooperatives",
						"code": "4847"
					},
					{
						"title": "越谷市農業協同組合",
						"code": "4847"
					},
					{
						"title": "南彩農業協同組合",
						"code": "4848"
					},
					{
						"title": "MinamiAya Agricultural Cooperatives",
						"code": "4848"
					},
					{
						"title": "埼玉みずほ農業協同組合",
						"code": "4859"
					},
					{
						"title": "Saitama Mizuho Agricultural Cooperatives",
						"code": "4859"
					},
					{
						"title": "さいかつ農業協同組合",
						"code": "4864"
					},
					{
						"title": "Sai and Agricultural Cooperatives",
						"code": "4864"
					},
					{
						"title": "ふかや農業協同組合",
						"code": "4874"
					},
					{
						"title": "Fukaya Agricultural Cooperatives",
						"code": "4874"
					},
					{
						"title": "安房農業協同組合",
						"code": "4876"
					},
					{
						"title": "Awa Agricultural Cooperatives",
						"code": "4876"
					},
					{
						"title": "Isumi Agricultural Cooperatives",
						"code": "4893"
					},
					{
						"title": "いすみ農業協同組合",
						"code": "4893"
					},
					{
						"title": "木更津市農業協同組合",
						"code": "4902"
					},
					{
						"title": "Kisarazu Agricultural Cooperatives",
						"code": "4902"
					},
					{
						"title": "Kimitsu Agricultural Cooperatives",
						"code": "4909"
					},
					{
						"title": "君津市農業協同組合",
						"code": "4909"
					},
					{
						"title": "Chosei Agricultural Cooperatives",
						"code": "4916"
					},
					{
						"title": "長生農業協同組合",
						"code": "4916"
					},
					{
						"title": "山武郡市農業協同組合",
						"code": "4929"
					},
					{
						"title": "Yamatake County City Agricultural Cooperative",
						"code": "4929"
					},
					{
						"title": "Ichihara Agricultural Cooperatives",
						"code": "4949"
					},
					{
						"title": "市原市農業協同組合",
						"code": "4949"
					},
					{
						"title": "千葉みらい農業協同組合",
						"code": "4954"
					},
					{
						"title": "Chiba future agricultural cooperatives",
						"code": "4954"
					},
					{
						"title": "Yachiyo Agricultural Cooperatives",
						"code": "4955"
					},
					{
						"title": "八千代市農業協同組合",
						"code": "4955"
					},
					{
						"title": "市川市農業協同組合",
						"code": "4959"
					},
					{
						"title": "Ichikawa City Agricultural Cooperatives",
						"code": "4959"
					},
					{
						"title": "東葛ふたば農業協同組合",
						"code": "4962"
					},
					{
						"title": "Tokatsu Futaba Agricultural Cooperatives",
						"code": "4962"
					},
					{
						"title": "Governing National Agricultural Cooperatives",
						"code": "4965"
					},
					{
						"title": "とうかつ中央農業協同組合",
						"code": "4965"
					},
					{
						"title": "ちば東葛農業協同組合",
						"code": "4975"
					},
					{
						"title": "Chibahigashikuzu Agricultural Cooperatives",
						"code": "4975"
					},
					{
						"title": "成田市農業協同組合",
						"code": "4992"
					},
					{
						"title": "Narita Agricultural Cooperatives",
						"code": "4992"
					},
					{
						"title": "富里市農業協同組合",
						"code": "4993"
					},
					{
						"title": "Tomisato Agricultural Cooperatives",
						"code": "4993"
					},
					{
						"title": "West Inba agricultural cooperatives",
						"code": "4996"
					},
					{
						"title": "西印旛農業協同組合",
						"code": "4996"
					},
					{
						"title": "かとり農業協同組合",
						"code": "5000"
					},
					{
						"title": "Katori Agricultural Cooperatives",
						"code": "5000"
					},
					{
						"title": "佐原農業協同組合",
						"code": "5002"
					},
					{
						"title": "Sahara Agricultural Cooperatives",
						"code": "5002"
					},
					{
						"title": "多古町農業協同組合",
						"code": "5011"
					},
					{
						"title": "Tako-cho Agricultural Cooperatives",
						"code": "5011"
					},
					{
						"title": "ちばみどり農業協同組合",
						"code": "5016"
					},
					{
						"title": "ChibaMidori Agricultural Cooperatives",
						"code": "5016"
					},
					{
						"title": "West Tokyo Agricultural Cooperatives",
						"code": "5030"
					},
					{
						"title": "西東京農業協同組合",
						"code": "5030"
					},
					{
						"title": "西多摩農業協同組合",
						"code": "5037"
					},
					{
						"title": "Nishitama Agricultural Cooperatives",
						"code": "5037"
					},
					{
						"title": "秋川農業協同組合",
						"code": "5039"
					},
					{
						"title": "Akigawa Agricultural Cooperatives",
						"code": "5039"
					},
					{
						"title": "Hachioji Agricultural Cooperatives",
						"code": "5050"
					},
					{
						"title": "八王子市農業協同組合",
						"code": "5050"
					},
					{
						"title": "Tokyo Southern Agricultural Cooperatives",
						"code": "5055"
					},
					{
						"title": "東京南農業協同組合",
						"code": "5055"
					},
					{
						"title": "Machida Agricultural Cooperatives",
						"code": "5060"
					},
					{
						"title": "町田市農業協同組合",
						"code": "5060"
					},
					{
						"title": "マインズ農業協同組合",
						"code": "5070"
					},
					{
						"title": "Mines Agricultural Cooperatives",
						"code": "5070"
					},
					{
						"title": "東京みどり農業協同組合",
						"code": "5072"
					},
					{
						"title": "Tokyo green agricultural cooperatives",
						"code": "5072"
					},
					{
						"title": "Tokyo Future Agricultural Cooperatives",
						"code": "5077"
					},
					{
						"title": "東京みらい農業協同組合",
						"code": "5077"
					},
					{
						"title": "Tokyo Musashi Agricultural Cooperatives",
						"code": "5087"
					},
					{
						"title": "東京むさし農業協同組合",
						"code": "5087"
					},
					{
						"title": "東京中央農業協同組合",
						"code": "5094"
					},
					{
						"title": "Tokyo National Agricultural Cooperatives",
						"code": "5094"
					},
					{
						"title": "世田谷目黒農業協同組合",
						"code": "5095"
					},
					{
						"title": "Setagaya Meguro Agricultural Cooperatives",
						"code": "5095"
					},
					{
						"title": "東京あおば農業協同組合",
						"code": "5097"
					},
					{
						"title": "Tokyo Aoba Agricultural Cooperatives",
						"code": "5097"
					},
					{
						"title": "Tokyo Smile Agricultural Cooperatives",
						"code": "5100"
					},
					{
						"title": "東京スマイル農業協同組合",
						"code": "5100"
					},
					{
						"title": "東京島しょ農業協同組合",
						"code": "5111"
					},
					{
						"title": "Tokyo island Agricultural Cooperatives",
						"code": "5111"
					},
					{
						"title": "横浜農業協同組合",
						"code": "5114"
					},
					{
						"title": "Yokohama Agricultural Cooperatives",
						"code": "5114"
					},
					{
						"title": "Selesa Kawasaki agricultural cooperatives",
						"code": "5123"
					},
					{
						"title": "セレサ川崎農業協同組合",
						"code": "5123"
					},
					{
						"title": "よこすか葉山農業協同組合",
						"code": "5128"
					},
					{
						"title": "Yokosuka Hayama Agricultural Cooperatives",
						"code": "5128"
					},
					{
						"title": "三浦市農業協同組合",
						"code": "5130"
					},
					{
						"title": "Miura agricultural cooperatives",
						"code": "5130"
					},
					{
						"title": "さがみ農業協同組合",
						"code": "5131"
					},
					{
						"title": "Sagami Agricultural Cooperatives",
						"code": "5131"
					},
					{
						"title": "Shonan agricultural cooperatives",
						"code": "5137"
					},
					{
						"title": "湘南農業協同組合",
						"code": "5137"
					},
					{
						"title": "伊勢原市農業協同組合",
						"code": "5139"
					},
					{
						"title": "Isehara Agricultural Cooperatives",
						"code": "5139"
					},
					{
						"title": "Hadano Agricultural Cooperatives",
						"code": "5140"
					},
					{
						"title": "秦野市農業協同組合",
						"code": "5140"
					},
					{
						"title": "かながわ西湘農業協同組合",
						"code": "5147"
					},
					{
						"title": "Kanagawa west 湘農 industry cooperatives",
						"code": "5147"
					},
					{
						"title": "厚木市農業協同組合",
						"code": "5152"
					},
					{
						"title": "Atsugi Agricultural Cooperatives",
						"code": "5152"
					},
					{
						"title": "県央愛川農業協同組合",
						"code": "5153"
					},
					{
						"title": "KenHisashi Aikawa Agricultural Cooperatives",
						"code": "5153"
					},
					{
						"title": "Sagamihara Agricultural Cooperatives",
						"code": "5159"
					},
					{
						"title": "相模原市農業協同組合",
						"code": "5159"
					},
					{
						"title": "津久井郡農業協同組合",
						"code": "5162"
					},
					{
						"title": "Tsukui County Agricultural Cooperatives",
						"code": "5162"
					},
					{
						"title": "フルーツ山梨農業協同組合",
						"code": "5169"
					},
					{
						"title": "Fruit Yamanashi Agricultural Cooperatives",
						"code": "5169"
					},
					{
						"title": "笛吹農業協同組合",
						"code": "5199"
					},
					{
						"title": "Whistling Agricultural Cooperatives",
						"code": "5199"
					},
					{
						"title": "Nishiyatsushiro Agricultural Cooperatives",
						"code": "5207"
					},
					{
						"title": "西八代郡農業協同組合",
						"code": "5207"
					},
					{
						"title": "ふじかわ農業協同組合",
						"code": "5209"
					},
					{
						"title": "Fujikawa Agricultural Cooperatives",
						"code": "5209"
					},
					{
						"title": "Kofu Agricultural Cooperatives",
						"code": "5222"
					},
					{
						"title": "甲府市農業協同組合",
						"code": "5222"
					},
					{
						"title": "中巨摩東部農業協同組合",
						"code": "5234"
					},
					{
						"title": "Nakakoma Eastern Agricultural Cooperatives",
						"code": "5234"
					},
					{
						"title": "Koma field Agricultural Cooperatives",
						"code": "5243"
					},
					{
						"title": "巨摩野農業協同組合",
						"code": "5243"
					},
					{
						"title": "梨北農業協同組合",
						"code": "5260"
					},
					{
						"title": "Nashikita Agricultural Cooperatives",
						"code": "5260"
					},
					{
						"title": "クレイン農業協同組合",
						"code": "5272"
					},
					{
						"title": "Crane Agricultural Cooperatives",
						"code": "5272"
					},
					{
						"title": "North Fuji Agricultural Cooperatives",
						"code": "5284"
					},
					{
						"title": "北富士農業協同組合",
						"code": "5284"
					},
					{
						"title": "鳴沢村農業協同組合",
						"code": "5287"
					},
					{
						"title": "Narusawa Agricultural Cooperatives",
						"code": "5287"
					},
					{
						"title": "長野八ヶ岳農業協同組合",
						"code": "5311"
					},
					{
						"title": "Nagano Yatsugatake Agricultural Cooperatives",
						"code": "5311"
					},
					{
						"title": "Saku Asama Agricultural Cooperatives",
						"code": "5335"
					},
					{
						"title": "佐久浅間農業協同組合",
						"code": "5335"
					},
					{
						"title": "信州うえだ農業協同組合",
						"code": "5348"
					},
					{
						"title": "Shinshu Ueda Agricultural Cooperatives",
						"code": "5348"
					},
					{
						"title": "Shinshu Suwa Agricultural Cooperatives",
						"code": "5372"
					},
					{
						"title": "信州諏訪農業協同組合",
						"code": "5372"
					},
					{
						"title": "上伊那農業協同組合",
						"code": "5384"
					},
					{
						"title": "Kamiina Agricultural Cooperatives",
						"code": "5384"
					},
					{
						"title": "みなみ信州農業協同組合",
						"code": "5405"
					},
					{
						"title": "Minami Shinshu Agricultural Cooperatives",
						"code": "5405"
					},
					{
						"title": "Kiso Agricultural Cooperatives",
						"code": "5441"
					},
					{
						"title": "木曽農業協同組合",
						"code": "5441"
					},
					{
						"title": "Matsumoto Agricultural Cooperatives",
						"code": "5447"
					},
					{
						"title": "松本市農業協同組合",
						"code": "5447"
					},
					{
						"title": "Matsumoto Highland Agricultural Cooperatives",
						"code": "5448"
					},
					{
						"title": "松本ハイランド農業協同組合",
						"code": "5448"
					},
					{
						"title": "Shiojiri Agricultural Cooperatives",
						"code": "5449"
					},
					{
						"title": "塩尻市農業協同組合",
						"code": "5449"
					},
					{
						"title": "Seba Agricultural Cooperatives",
						"code": "5462"
					},
					{
						"title": "洗馬農業協同組合",
						"code": "5462"
					},
					{
						"title": "あづみ農業協同組合",
						"code": "5466"
					},
					{
						"title": "Azumi Agricultural Cooperatives",
						"code": "5466"
					},
					{
						"title": "Okita Agricultural Cooperatives",
						"code": "5470"
					},
					{
						"title": "大北農業協同組合",
						"code": "5470"
					},
					{
						"title": "グリーン長野農業協同組合",
						"code": "5477"
					},
					{
						"title": "Green Nagano Agricultural Cooperatives",
						"code": "5477"
					},
					{
						"title": "Chikuma Agricultural Cooperatives",
						"code": "5483"
					},
					{
						"title": "ちくま農業協同組合",
						"code": "5483"
					},
					{
						"title": "須高農業協同組合",
						"code": "5485"
					},
					{
						"title": "須高 Agricultural Cooperatives",
						"code": "5485"
					},
					{
						"title": "中野市農業協同組合",
						"code": "5491"
					},
					{
						"title": "Nakano City Agricultural Cooperatives",
						"code": "5491"
					},
					{
						"title": "Shiga Kogen Agricultural Cooperatives",
						"code": "5493"
					},
					{
						"title": "志賀高原農業協同組合",
						"code": "5493"
					},
					{
						"title": "Nagano Agricultural Cooperatives",
						"code": "5499"
					},
					{
						"title": "ながの農業協同組合",
						"code": "5499"
					},
					{
						"title": "KitaKabano South Agricultural Cooperatives",
						"code": "5541"
					},
					{
						"title": "北蒲みなみ農業協同組合",
						"code": "5541"
					},
					{
						"title": "Sasakami Agricultural Cooperatives",
						"code": "5542"
					},
					{
						"title": "ささかみ農業協同組合",
						"code": "5542"
					},
					{
						"title": "Toyosaka Agricultural Cooperatives",
						"code": "5550"
					},
					{
						"title": "豊栄農業協同組合",
						"code": "5550"
					},
					{
						"title": "北越後農業協同組合",
						"code": "5554"
					},
					{
						"title": "North Echigo Agricultural Cooperatives",
						"code": "5554"
					},
					{
						"title": "胎内市農業協同組合",
						"code": "5568"
					},
					{
						"title": "Tainai Agricultural Cooperatives",
						"code": "5568"
					},
					{
						"title": "Niigata future agricultural cooperatives",
						"code": "5577"
					},
					{
						"title": "新潟みらい農業協同組合",
						"code": "5577"
					},
					{
						"title": "Satsuki Niitsu Agricultural Cooperatives",
						"code": "5585"
					},
					{
						"title": "新津さつき農業協同組合",
						"code": "5585"
					},
					{
						"title": "Echigo National Agricultural Cooperatives",
						"code": "5600"
					},
					{
						"title": "越後中央農業協同組合",
						"code": "5600"
					},
					{
						"title": "にいがた南蒲農業協同組合",
						"code": "5631"
					},
					{
						"title": "Niigata Minamikaba Agricultural Cooperatives",
						"code": "5631"
					},
					{
						"title": "越後ながおか農業協同組合",
						"code": "5666"
					},
					{
						"title": "Echigo Nagaoka Agricultural Cooperatives",
						"code": "5666"
					},
					{
						"title": "Echigo Shandong Agricultural Cooperatives",
						"code": "5685"
					},
					{
						"title": "越後さんとう農業協同組合",
						"code": "5685"
					},
					{
						"title": "越後おぢや農業協同組合",
						"code": "5690"
					},
					{
						"title": "Echigo Ojiya Agricultural Cooperatives",
						"code": "5690"
					},
					{
						"title": "北魚沼農業協同組合",
						"code": "5693"
					},
					{
						"title": "Kitauonuma Agricultural Cooperatives",
						"code": "5693"
					},
					{
						"title": "Shiozawa Agricultural Cooperatives",
						"code": "5706"
					},
					{
						"title": "しおざわ農業協同組合",
						"code": "5706"
					},
					{
						"title": "Uonuma Minami Agricultural Cooperatives",
						"code": "5707"
					},
					{
						"title": "魚沼みなみ農業協同組合",
						"code": "5707"
					},
					{
						"title": "十日町農業協同組合",
						"code": "5714"
					},
					{
						"title": "Tokamachi Agricultural Cooperatives",
						"code": "5714"
					},
					{
						"title": "Tsunan Agricultural Cooperatives",
						"code": "5719"
					},
					{
						"title": "津南町農業協同組合",
						"code": "5719"
					},
					{
						"title": "柏崎農業協同組合",
						"code": "5720"
					},
					{
						"title": "Kashiwazaki Agricultural Cooperatives",
						"code": "5720"
					},
					{
						"title": "えちご上越農業協同組合",
						"code": "5768"
					},
					{
						"title": "Echigo Joetsu Agricultural Cooperatives",
						"code": "5768"
					},
					{
						"title": "Jade agricultural cooperatives",
						"code": "5797"
					},
					{
						"title": "ひすい農業協同組合",
						"code": "5797"
					},
					{
						"title": "Kambayashi Agricultural Cooperatives",
						"code": "5815"
					},
					{
						"title": "かみはやし農業協同組合",
						"code": "5815"
					},
					{
						"title": "Niigata Iwafune Agricultural Cooperatives",
						"code": "5823"
					},
					{
						"title": "にいがた岩船農業協同組合",
						"code": "5823"
					},
					{
						"title": "佐渡農業協同組合",
						"code": "5832"
					},
					{
						"title": "Sado Agricultural Cooperatives",
						"code": "5832"
					},
					{
						"title": "羽茂農業協同組合",
						"code": "5847"
					},
					{
						"title": "Hamo Agricultural Cooperatives",
						"code": "5847"
					},
					{
						"title": "新潟市農業協同組合",
						"code": "5864"
					},
					{
						"title": "Niigata Agricultural Cooperatives",
						"code": "5864"
					},
					{
						"title": "Mina ear Agricultural Cooperatives",
						"code": "5877"
					},
					{
						"title": "みな穂農業協同組合",
						"code": "5877"
					},
					{
						"title": "Kurobe Agricultural Cooperatives",
						"code": "5883"
					},
					{
						"title": "黒部農業協同組合",
						"code": "5883"
					},
					{
						"title": "黒部市信用農業協同組合",
						"code": "5884"
					},
					{
						"title": "Kurobe credit Agricultural Cooperatives",
						"code": "5884"
					},
					{
						"title": "Uozu Agricultural Cooperatives",
						"code": "5885"
					},
					{
						"title": "魚津市農業協同組合",
						"code": "5885"
					},
					{
						"title": "アルプス農業協同組合",
						"code": "5888"
					},
					{
						"title": "Alps Agricultural Cooperatives",
						"code": "5888"
					},
					{
						"title": "あおば農業協同組合",
						"code": "5895"
					},
					{
						"title": "Aoba Agricultural Cooperatives",
						"code": "5895"
					},
					{
						"title": "Toyama Agricultural Cooperatives",
						"code": "5897"
					},
					{
						"title": "富山市農業協同組合",
						"code": "5897"
					},
					{
						"title": "なのはな農業協同組合",
						"code": "5898"
					},
					{
						"title": "Nanohana Agricultural Cooperatives",
						"code": "5898"
					},
					{
						"title": "Usaka Agricultural Cooperatives",
						"code": "5905"
					},
					{
						"title": "鵜坂農業協同組合",
						"code": "5905"
					},
					{
						"title": "山田村農業協同組合",
						"code": "5906"
					},
					{
						"title": "Yamada village agricultural cooperatives",
						"code": "5906"
					},
					{
						"title": "いみず野農業協同組合",
						"code": "5911"
					},
					{
						"title": "Imizu field Agricultural Cooperatives",
						"code": "5911"
					},
					{
						"title": "Takaoka Agricultural Cooperatives",
						"code": "5916"
					},
					{
						"title": "高岡市農業協同組合",
						"code": "5916"
					},
					{
						"title": "Himi Agricultural Cooperatives",
						"code": "5920"
					},
					{
						"title": "氷見市農業協同組合",
						"code": "5920"
					},
					{
						"title": "Tonami field Agricultural Cooperatives",
						"code": "5921"
					},
					{
						"title": "となみ野農業協同組合",
						"code": "5921"
					},
					{
						"title": "なんと農業協同組合",
						"code": "5927"
					},
					{
						"title": "What agricultural cooperatives",
						"code": "5927"
					},
					{
						"title": "いなば農業協同組合",
						"code": "5932"
					},
					{
						"title": "Inaba Agricultural Cooperatives",
						"code": "5932"
					},
					{
						"title": "福光農業協同組合",
						"code": "5935"
					},
					{
						"title": "Fukumitsu Agricultural Cooperatives",
						"code": "5935"
					},
					{
						"title": "加賀農業協同組合",
						"code": "5943"
					},
					{
						"title": "Kaga Agricultural Cooperatives",
						"code": "5943"
					},
					{
						"title": "Komatsu agricultural cooperatives",
						"code": "5962"
					},
					{
						"title": "小松市農業協同組合",
						"code": "5962"
					},
					{
						"title": "根上農業協同組合",
						"code": "5980"
					},
					{
						"title": "Negami Agricultural Cooperatives",
						"code": "5980"
					},
					{
						"title": "能美農業協同組合",
						"code": "5982"
					},
					{
						"title": "Nomi Agricultural Cooperatives",
						"code": "5982"
					},
					{
						"title": "Matto City Agricultural Cooperatives",
						"code": "5997"
					},
					{
						"title": "松任市農業協同組合",
						"code": "5997"
					},
					{
						"title": "Nonoichi Agricultural Cooperatives",
						"code": "6010"
					},
					{
						"title": "野々市農業協同組合",
						"code": "6010"
					},
					{
						"title": "白山農業協同組合",
						"code": "6012"
					},
					{
						"title": "Hakusan Agricultural Cooperatives",
						"code": "6012"
					},
					{
						"title": "Kanazawa Central Agricultural Cooperatives",
						"code": "6024"
					},
					{
						"title": "金沢中央農業協同組合",
						"code": "6024"
					},
					{
						"title": "Kanazawa Agricultural Cooperatives",
						"code": "6025"
					},
					{
						"title": "金沢市農業協同組合",
						"code": "6025"
					},
					{
						"title": "石川かほく農業協同組合",
						"code": "6062"
					},
					{
						"title": "Ishikawa Hebei Agricultural Cooperatives",
						"code": "6062"
					},
					{
						"title": "はくい農業協同組合",
						"code": "6076"
					},
					{
						"title": "Hakui Agricultural Cooperatives",
						"code": "6076"
					},
					{
						"title": "Shiga Agricultural Cooperatives",
						"code": "6084"
					},
					{
						"title": "志賀農業協同組合",
						"code": "6084"
					},
					{
						"title": "能登わかば農業協同組合",
						"code": "6094"
					},
					{
						"title": "Noto Wakaba Agricultural Cooperatives",
						"code": "6094"
					},
					{
						"title": "Firmament Agricultural Cooperatives",
						"code": "6113"
					},
					{
						"title": "おおぞら農業協同組合",
						"code": "6113"
					},
					{
						"title": "町野町農業協同組合",
						"code": "6117"
					},
					{
						"title": "Machino-cho Agricultural Cooperatives",
						"code": "6117"
					},
					{
						"title": "Uchiura Agricultural Cooperatives",
						"code": "6121"
					},
					{
						"title": "内浦町農業協同組合",
						"code": "6121"
					},
					{
						"title": "珠洲市農業協同組合",
						"code": "6122"
					},
					{
						"title": "Suzu Agricultural Cooperatives",
						"code": "6122"
					},
					{
						"title": "ぎふ農業協同組合",
						"code": "6129"
					},
					{
						"title": "Gifu Agricultural Cooperatives",
						"code": "6129"
					},
					{
						"title": "West Mino Agricultural Cooperatives",
						"code": "6175"
					},
					{
						"title": "西美濃農業協同組合",
						"code": "6175"
					},
					{
						"title": "Ibi Agricultural Cooperatives",
						"code": "6198"
					},
					{
						"title": "いび川農業協同組合",
						"code": "6198"
					},
					{
						"title": "Agricultural Cooperatives of grace",
						"code": "6242"
					},
					{
						"title": "めぐみの農業協同組合",
						"code": "6242"
					},
					{
						"title": "Pottery Metropolitan credit Agricultural Cooperatives",
						"code": "6265"
					},
					{
						"title": "陶都信用農業協同組合",
						"code": "6265"
					},
					{
						"title": "東美濃農業協同組合",
						"code": "6287"
					},
					{
						"title": "East Mino Agricultural Cooperatives",
						"code": "6287"
					},
					{
						"title": "Hidanogyo cooperative",
						"code": "6313"
					},
					{
						"title": "飛騨農業協同組合",
						"code": "6313"
					},
					{
						"title": "伊豆太陽農業協同組合",
						"code": "6328"
					},
					{
						"title": "Izutaiyonogyo cooperative",
						"code": "6328"
					},
					{
						"title": "三島函南農業協同組合",
						"code": "6333"
					},
					{
						"title": "Mishima Kannami Agricultural Cooperatives",
						"code": "6333"
					},
					{
						"title": "伊豆の国農業協同組合",
						"code": "6338"
					},
					{
						"title": "Country agricultural cooperatives of Izu",
						"code": "6338"
					},
					{
						"title": "あいら伊豆農業協同組合",
						"code": "6342"
					},
					{
						"title": "Aira Izu Agricultural Cooperatives",
						"code": "6342"
					},
					{
						"title": "MinamiShun Agricultural Cooperatives",
						"code": "6345"
					},
					{
						"title": "南駿農業協同組合",
						"code": "6345"
					},
					{
						"title": "Gotemba Agricultural Cooperatives",
						"code": "6351"
					},
					{
						"title": "御殿場農業協同組合",
						"code": "6351"
					},
					{
						"title": "富士市農業協同組合",
						"code": "6355"
					},
					{
						"title": "Fuji City Agricultural Cooperatives",
						"code": "6355"
					},
					{
						"title": "富士宮農業協同組合",
						"code": "6357"
					},
					{
						"title": "Fujinomiya Agricultural Cooperatives",
						"code": "6357"
					},
					{
						"title": "清水農業協同組合",
						"code": "6363"
					},
					{
						"title": "Shimizu Agricultural Cooperatives",
						"code": "6363"
					},
					{
						"title": "Shizuoka Agricultural Cooperatives",
						"code": "6373"
					},
					{
						"title": "静岡市農業協同組合",
						"code": "6373"
					},
					{
						"title": "大井川農業協同組合",
						"code": "6377"
					},
					{
						"title": "Oigawa Agricultural Cooperatives",
						"code": "6377"
					},
					{
						"title": "Hainan Agricultural Cooperatives",
						"code": "6382"
					},
					{
						"title": "ハイナン農業協同組合",
						"code": "6382"
					},
					{
						"title": "Kakegawa Agricultural Cooperatives",
						"code": "6386"
					},
					{
						"title": "掛川市農業協同組合",
						"code": "6386"
					},
					{
						"title": "Enshuyumesaki Agricultural Cooperatives",
						"code": "6387"
					},
					{
						"title": "遠州夢咲農業協同組合",
						"code": "6387"
					},
					{
						"title": "Enshu National Agricultural Cooperatives",
						"code": "6391"
					},
					{
						"title": "遠州中央農業協同組合",
						"code": "6391"
					},
					{
						"title": "とぴあ浜松農業協同組合",
						"code": "6403"
					},
					{
						"title": "Topia Hamamatsu Agricultural Cooperatives",
						"code": "6403"
					},
					{
						"title": "三ヶ日町農業協同組合",
						"code": "6423"
					},
					{
						"title": "Mikkabi Agricultural Cooperatives",
						"code": "6423"
					},
					{
						"title": "Mikatahara develop agricultural cooperatives",
						"code": "6426"
					},
					{
						"title": "三方原開拓農業協同組合",
						"code": "6426"
					},
					{
						"title": "なごや農業協同組合",
						"code": "6430"
					},
					{
						"title": "Nagoya Agricultural Cooperatives",
						"code": "6430"
					},
					{
						"title": "天白信用農業協同組合",
						"code": "6436"
					},
					{
						"title": "Tempaku credit Agricultural Cooperatives",
						"code": "6436"
					},
					{
						"title": "緑信用農業協同組合",
						"code": "6443"
					},
					{
						"title": "Green credit Agricultural Cooperatives",
						"code": "6443"
					},
					{
						"title": "尾張中央農業協同組合",
						"code": "6451"
					},
					{
						"title": "Conclusion National Agricultural Cooperatives",
						"code": "6451"
					},
					{
						"title": "西春日井農業協同組合",
						"code": "6456"
					},
					{
						"title": "Nishikasugai Agricultural Cooperatives",
						"code": "6456"
					},
					{
						"title": "Aichi Ohigashi Agricultural Cooperatives",
						"code": "6466"
					},
					{
						"title": "あいち尾東農業協同組合",
						"code": "6466"
					},
					{
						"title": "愛知北農業協同組合",
						"code": "6470"
					},
					{
						"title": "Aichi Northern Agricultural Cooperatives",
						"code": "6470"
					},
					{
						"title": "愛知西農業協同組合",
						"code": "6483"
					},
					{
						"title": "Aichi west agricultural cooperatives",
						"code": "6483"
					},
					{
						"title": "Kaifu east Agricultural Cooperatives",
						"code": "6503"
					},
					{
						"title": "海部東農業協同組合",
						"code": "6503"
					},
					{
						"title": "あいち海部農業協同組合",
						"code": "6514"
					},
					{
						"title": "Aichi Kaifu Agricultural Cooperatives",
						"code": "6514"
					},
					{
						"title": "Aichi Chita Agricultural Cooperatives",
						"code": "6531"
					},
					{
						"title": "あいち知多農業協同組合",
						"code": "6531"
					},
					{
						"title": "Aichichuonogyo cooperative",
						"code": "6552"
					},
					{
						"title": "あいち中央農業協同組合",
						"code": "6552"
					},
					{
						"title": "西三河農業協同組合",
						"code": "6560"
					},
					{
						"title": "Nishi Mikawa agricultural cooperatives",
						"code": "6560"
					},
					{
						"title": "Aichi Mikawa agricultural cooperatives",
						"code": "6572"
					},
					{
						"title": "あいち三河農業協同組合",
						"code": "6572"
					},
					{
						"title": "あいち豊田農業協同組合",
						"code": "6582"
					},
					{
						"title": "Aichi Toyota Agricultural Cooperatives",
						"code": "6582"
					},
					{
						"title": "愛知東農業協同組合",
						"code": "6591"
					},
					{
						"title": "Aichi east Agricultural Cooperatives",
						"code": "6591"
					},
					{
						"title": "Gamagori Agricultural Cooperatives",
						"code": "6606"
					},
					{
						"title": "蒲郡市農業協同組合",
						"code": "6606"
					},
					{
						"title": "ひまわり農業協同組合",
						"code": "6612"
					},
					{
						"title": "Sunflower Agricultural Cooperatives",
						"code": "6612"
					},
					{
						"title": "Minami Aichi Agricultural Cooperatives",
						"code": "6615"
					},
					{
						"title": "愛知みなみ農業協同組合",
						"code": "6615"
					},
					{
						"title": "Toyohashi Agricultural Cooperatives",
						"code": "6618"
					},
					{
						"title": "豊橋農業協同組合",
						"code": "6618"
					},
					{
						"title": "三重北農業協同組合",
						"code": "6649"
					},
					{
						"title": "Miekita Agricultural Cooperatives",
						"code": "6649"
					},
					{
						"title": "Suzuka Agricultural Cooperatives",
						"code": "6665"
					},
					{
						"title": "鈴鹿農業協同組合",
						"code": "6665"
					},
					{
						"title": "津安芸農業協同組合",
						"code": "6673"
					},
					{
						"title": "Tsu Aki Agricultural Cooperatives",
						"code": "6673"
					},
					{
						"title": "三重中央農業協同組合",
						"code": "6677"
					},
					{
						"title": "Triple central agricultural cooperatives",
						"code": "6677"
					},
					{
						"title": "Kazushi Eastern Agricultural Cooperatives",
						"code": "6678"
					},
					{
						"title": "一志東部農業協同組合",
						"code": "6678"
					},
					{
						"title": "松阪農業協同組合",
						"code": "6690"
					},
					{
						"title": "Matsusaka Agricultural Cooperatives",
						"code": "6690"
					},
					{
						"title": "Taki District Agricultural Cooperatives",
						"code": "6697"
					},
					{
						"title": "多気郡農業協同組合",
						"code": "6697"
					},
					{
						"title": "伊勢農業協同組合",
						"code": "6731"
					},
					{
						"title": "Ise Agricultural Cooperatives",
						"code": "6731"
					},
					{
						"title": "鳥羽志摩農業協同組合",
						"code": "6741"
					},
					{
						"title": "Toba Shima Agricultural Cooperatives",
						"code": "6741"
					},
					{
						"title": "伊賀北部農業協同組合",
						"code": "6758"
					},
					{
						"title": "Iga northern agricultural cooperatives",
						"code": "6758"
					},
					{
						"title": "Iga southern agricultural cooperatives",
						"code": "6762"
					},
					{
						"title": "伊賀南部農業協同組合",
						"code": "6762"
					},
					{
						"title": "Triple Nanki Agricultural Cooperatives",
						"code": "6770"
					},
					{
						"title": "三重南紀農業協同組合",
						"code": "6770"
					},
					{
						"title": "Fukui Agricultural Cooperatives",
						"code": "6785"
					},
					{
						"title": "福井市農業協同組合",
						"code": "6785"
					},
					{
						"title": "Fukui southern agricultural cooperatives",
						"code": "6789"
					},
					{
						"title": "福井市南部農業協同組合",
						"code": "6789"
					},
					{
						"title": "吉田郡農業協同組合",
						"code": "6805"
					},
					{
						"title": "Yoshida District Agricultural Cooperatives",
						"code": "6805"
					},
					{
						"title": "花咲ふくい農業協同組合",
						"code": "6810"
					},
					{
						"title": "Hanasaki Fukui Agricultural Cooperatives",
						"code": "6810"
					},
					{
						"title": "Harue Agricultural Cooperatives",
						"code": "6823"
					},
					{
						"title": "春江農業協同組合",
						"code": "6823"
					},
					{
						"title": "テラル越前農業協同組合",
						"code": "6832"
					},
					{
						"title": "Literal Echizen Agricultural Cooperatives",
						"code": "6832"
					},
					{
						"title": "福井丹南農業協同組合",
						"code": "6836"
					},
					{
						"title": "Fukui Tannan Agricultural Cooperatives",
						"code": "6836"
					},
					{
						"title": "福井池田町農業協同組合",
						"code": "6838"
					},
					{
						"title": "Fukui Ikeda Agricultural Cooperatives",
						"code": "6838"
					},
					{
						"title": "Echizen Niu Agricultural Cooperatives",
						"code": "6841"
					},
					{
						"title": "越前丹生農業協同組合",
						"code": "6841"
					},
					{
						"title": "Echizen Takeo Agricultural Cooperatives",
						"code": "6853"
					},
					{
						"title": "越前たけふ農業協同組合",
						"code": "6853"
					},
					{
						"title": "敦賀美方農業協同組合",
						"code": "6860"
					},
					{
						"title": "Tsuruga Mikata Agricultural Cooperatives",
						"code": "6860"
					},
					{
						"title": "若狭農業協同組合",
						"code": "6863"
					},
					{
						"title": "Wakasa Agricultural Cooperatives",
						"code": "6863"
					},
					{
						"title": "Lake Otsu Agricultural Cooperatives",
						"code": "6874"
					},
					{
						"title": "レーク大津農業協同組合",
						"code": "6874"
					},
					{
						"title": "Kusatsu Agricultural Cooperatives",
						"code": "6883"
					},
					{
						"title": "草津市農業協同組合",
						"code": "6883"
					},
					{
						"title": "栗東市農業協同組合",
						"code": "6885"
					},
					{
						"title": "Ritto Agricultural Cooperatives",
						"code": "6885"
					},
					{
						"title": "Omi Fuji Agricultural Cooperatives",
						"code": "6888"
					},
					{
						"title": "おうみ冨士農業協同組合",
						"code": "6888"
					},
					{
						"title": "甲賀農業協同組合",
						"code": "6889"
					},
					{
						"title": "Koga Agricultural Cooperatives",
						"code": "6889"
					},
					{
						"title": "Green Omi Agricultural Cooperatives",
						"code": "6897"
					},
					{
						"title": "グリーン近江農業協同組合",
						"code": "6897"
					},
					{
						"title": "Shiga Kamou Agricultural Cooperatives",
						"code": "6900"
					},
					{
						"title": "滋賀蒲生町農業協同組合",
						"code": "6900"
					},
					{
						"title": "東能登川農業協同組合",
						"code": "6909"
					},
					{
						"title": "East Notogawa Agricultural Cooperatives",
						"code": "6909"
					},
					{
						"title": "Koto Agricultural Cooperatives",
						"code": "6911"
					},
					{
						"title": "湖東農業協同組合",
						"code": "6911"
					},
					{
						"title": "East Lake Biwa Agricultural Cooperatives",
						"code": "6912"
					},
					{
						"title": "東びわこ農業協同組合",
						"code": "6912"
					},
					{
						"title": "Lake Ibuki Agricultural Cooperatives",
						"code": "6919"
					},
					{
						"title": "レーク伊吹農業協同組合",
						"code": "6919"
					},
					{
						"title": "North Lake Biwa Agricultural Cooperatives",
						"code": "6924"
					},
					{
						"title": "北びわこ農業協同組合",
						"code": "6924"
					},
					{
						"title": "マキノ町農業協同組合",
						"code": "6931"
					},
					{
						"title": "Makino-cho Agricultural Cooperatives",
						"code": "6931"
					},
					{
						"title": "Imazu Agricultural Cooperatives",
						"code": "6932"
					},
					{
						"title": "今津町農業協同組合",
						"code": "6932"
					},
					{
						"title": "Shin'asahi Agricultural Cooperatives",
						"code": "6933"
					},
					{
						"title": "新旭町農業協同組合",
						"code": "6933"
					},
					{
						"title": "西びわこ農業協同組合",
						"code": "6935"
					},
					{
						"title": "West Lake Biwa Agricultural Cooperatives",
						"code": "6935"
					},
					{
						"title": "京都市農業協同組合",
						"code": "6941"
					},
					{
						"title": "Kyoto agricultural cooperatives",
						"code": "6941"
					},
					{
						"title": "京都中央農業協同組合",
						"code": "6956"
					},
					{
						"title": "Kyoto National Agricultural Cooperatives",
						"code": "6956"
					},
					{
						"title": "京都やましろ農業協同組合",
						"code": "6961"
					},
					{
						"title": "Kyoto Yamashiro Agricultural Cooperatives",
						"code": "6961"
					},
					{
						"title": "Kyoto agricultural cooperatives",
						"code": "6990"
					},
					{
						"title": "京都農業協同組合",
						"code": "6990"
					},
					{
						"title": "京都丹の国農業協同組合",
						"code": "6996"
					},
					{
						"title": "Country agricultural cooperatives of Kyoto red",
						"code": "6996"
					},
					{
						"title": "北大阪農業協同組合",
						"code": "7025"
					},
					{
						"title": "Northern Osaka Agricultural Cooperatives",
						"code": "7025"
					},
					{
						"title": "Takatsuki Agricultural Cooperatives",
						"code": "7029"
					},
					{
						"title": "高槻市農業協同組合",
						"code": "7029"
					},
					{
						"title": "Ibaraki Agricultural Cooperatives",
						"code": "7032"
					},
					{
						"title": "茨木市農業協同組合",
						"code": "7032"
					},
					{
						"title": "大阪北部農業協同組合",
						"code": "7041"
					},
					{
						"title": "Osaka northern agricultural cooperatives",
						"code": "7041"
					},
					{
						"title": "大阪泉州農業協同組合",
						"code": "7087"
					},
					{
						"title": "Osaka Quanzhou Agricultural Cooperatives",
						"code": "7087"
					},
					{
						"title": "Agricultural Cooperatives of Izumi",
						"code": "7092"
					},
					{
						"title": "いずみの農業協同組合",
						"code": "7092"
					},
					{
						"title": "堺市農業協同組合",
						"code": "7111"
					},
					{
						"title": "Sakai City Agricultural Cooperatives",
						"code": "7111"
					},
					{
						"title": "Osaka Minami Agricultural Cooperatives",
						"code": "7139"
					},
					{
						"title": "大阪南農業協同組合",
						"code": "7139"
					},
					{
						"title": "グリーン大阪農業協同組合",
						"code": "7156"
					},
					{
						"title": "Green Osaka Agricultural Cooperatives",
						"code": "7156"
					},
					{
						"title": "大阪中河内農業協同組合",
						"code": "7164"
					},
					{
						"title": "Osaka Nakagochi Agricultural Cooperatives",
						"code": "7164"
					},
					{
						"title": "Osaka Eastern Agricultural Cooperatives",
						"code": "7184"
					},
					{
						"title": "大阪東部農業協同組合",
						"code": "7184"
					},
					{
						"title": "九個荘農業協同組合",
						"code": "7191"
					},
					{
						"title": "Nine Zhuang Agricultural Cooperatives",
						"code": "7191"
					},
					{
						"title": "北河内農業協同組合",
						"code": "7193"
					},
					{
						"title": "Kitagawachi Agricultural Cooperatives",
						"code": "7193"
					},
					{
						"title": "大阪市農業協同組合",
						"code": "7200"
					},
					{
						"title": "Osaka City Agricultural Cooperatives",
						"code": "7200"
					},
					{
						"title": "Hyogo Rokko Agricultural Cooperatives",
						"code": "7213"
					},
					{
						"title": "兵庫六甲農業協同組合",
						"code": "7213"
					},
					{
						"title": "Akashi Agricultural Cooperatives",
						"code": "7239"
					},
					{
						"title": "あかし農業協同組合",
						"code": "7239"
					},
					{
						"title": "Hyogominami Agricultural Cooperatives",
						"code": "7240"
					},
					{
						"title": "兵庫南農業協同組合",
						"code": "7240"
					},
					{
						"title": "みのり農業協同組合",
						"code": "7249"
					},
					{
						"title": "Minori Agricultural Cooperatives",
						"code": "7249"
					},
					{
						"title": "Hyogo future agricultural cooperatives",
						"code": "7264"
					},
					{
						"title": "兵庫みらい農業協同組合",
						"code": "7264"
					},
					{
						"title": "Kakogawa South Agricultural Cooperatives",
						"code": "7274"
					},
					{
						"title": "加古川市南農業協同組合",
						"code": "7274"
					},
					{
						"title": "Hyogo west agricultural cooperatives",
						"code": "7288"
					},
					{
						"title": "兵庫西農業協同組合",
						"code": "7288"
					},
					{
						"title": "Aioi Agricultural Cooperatives",
						"code": "7316"
					},
					{
						"title": "相生市農業協同組合",
						"code": "7316"
					},
					{
						"title": "ハリマ農業協同組合",
						"code": "7326"
					},
					{
						"title": "Harima Agricultural Cooperatives",
						"code": "7326"
					},
					{
						"title": "Tajima Agricultural Cooperatives",
						"code": "7338"
					},
					{
						"title": "たじま農業協同組合",
						"code": "7338"
					},
					{
						"title": "丹波ひかみ農業協同組合",
						"code": "7353"
					},
					{
						"title": "Tamba Nichiue Agricultural Cooperatives",
						"code": "7353"
					},
					{
						"title": "Tamba Sasayama Agricultural Cooperatives",
						"code": "7362"
					},
					{
						"title": "丹波ささやま農業協同組合",
						"code": "7362"
					},
					{
						"title": "Awaji sunrise Agricultural Cooperatives",
						"code": "7363"
					},
					{
						"title": "淡路日の出農業協同組合",
						"code": "7363"
					},
					{
						"title": "Awaji Island Agricultural Cooperatives",
						"code": "7373"
					},
					{
						"title": "あわじ島農業協同組合",
						"code": "7373"
					},
					{
						"title": "奈良県農業協同組合",
						"code": "7387"
					},
					{
						"title": "Nara Prefecture Agricultural Cooperatives",
						"code": "7387"
					},
					{
						"title": "わかやま農業協同組合",
						"code": "7532"
					},
					{
						"title": "Wakayama Agricultural Cooperatives",
						"code": "7532"
					},
					{
						"title": "ながみね農業協同組合",
						"code": "7541"
					},
					{
						"title": "Nagamine Agricultural Cooperatives",
						"code": "7541"
					},
					{
						"title": "紀の里農業協同組合",
						"code": "7543"
					},
					{
						"title": "Kinosato Agricultural Cooperatives",
						"code": "7543"
					},
					{
						"title": "紀北川上農業協同組合",
						"code": "7550"
					},
					{
						"title": "Kihoku Kawakami Agricultural Cooperatives",
						"code": "7550"
					},
					{
						"title": "There's agricultural cooperatives",
						"code": "7559"
					},
					{
						"title": "ありだ農業協同組合",
						"code": "7559"
					},
					{
						"title": "Kishu Agricultural Cooperatives",
						"code": "7565"
					},
					{
						"title": "紀州農業協同組合",
						"code": "7565"
					},
					{
						"title": "紀南農業協同組合",
						"code": "7576"
					},
					{
						"title": "Kinan Agricultural Cooperatives",
						"code": "7576"
					},
					{
						"title": "みくまの農業協同組合",
						"code": "7591"
					},
					{
						"title": "Agricultural cooperatives Sankuma",
						"code": "7591"
					},
					{
						"title": "Tottori Inaba Agricultural Cooperatives",
						"code": "7601"
					},
					{
						"title": "鳥取いなば農業協同組合",
						"code": "7601"
					},
					{
						"title": "鳥取中央農業協同組合",
						"code": "7625"
					},
					{
						"title": "Tottori National Agricultural Cooperatives",
						"code": "7625"
					},
					{
						"title": "Tottori western agricultural cooperatives",
						"code": "7641"
					},
					{
						"title": "鳥取西部農業協同組合",
						"code": "7641"
					},
					{
						"title": "Shimane Prefecture Agricultural Cooperatives",
						"code": "7708"
					},
					{
						"title": "島根県農業協同組合",
						"code": "7708"
					},
					{
						"title": "Okayama Agricultural Cooperatives",
						"code": "7755"
					},
					{
						"title": "岡山市農業協同組合",
						"code": "7755"
					},
					{
						"title": "Okayamahigashi Agricultural Cooperatives",
						"code": "7768"
					},
					{
						"title": "岡山東農業協同組合",
						"code": "7768"
					},
					{
						"title": "岡山西農業協同組合",
						"code": "7794"
					},
					{
						"title": "Okayama west agricultural cooperatives",
						"code": "7794"
					},
					{
						"title": "倉敷かさや農業協同組合",
						"code": "7825"
					},
					{
						"title": "Kurashiki umbrella and agricultural cooperatives",
						"code": "7825"
					},
					{
						"title": "びほく農業協同組合",
						"code": "7837"
					},
					{
						"title": "Bihoku Agricultural Cooperatives",
						"code": "7837"
					},
					{
						"title": "阿新農業協同組合",
						"code": "7847"
					},
					{
						"title": "New agricultural cooperatives Asin",
						"code": "7847"
					},
					{
						"title": "真庭農業協同組合",
						"code": "7859"
					},
					{
						"title": "Maniwa Agricultural Cooperatives",
						"code": "7859"
					},
					{
						"title": "Tsuyama Agricultural Cooperatives",
						"code": "7868"
					},
					{
						"title": "津山農業協同組合",
						"code": "7868"
					},
					{
						"title": "勝英農業協同組合",
						"code": "7889"
					},
					{
						"title": "Katsuhide Agricultural Cooperatives",
						"code": "7889"
					},
					{
						"title": "Hiroshima City Agricultural Cooperatives",
						"code": "7909"
					},
					{
						"title": "広島市農業協同組合",
						"code": "7909"
					},
					{
						"title": "Wu Agricultural Cooperatives",
						"code": "7913"
					},
					{
						"title": "呉農業協同組合",
						"code": "7913"
					},
					{
						"title": "安芸農業協同組合",
						"code": "7916"
					},
					{
						"title": "Aki Agricultural Cooperatives",
						"code": "7916"
					},
					{
						"title": "Saeki National Agricultural Cooperatives",
						"code": "7938"
					},
					{
						"title": "佐伯中央農業協同組合",
						"code": "7938"
					},
					{
						"title": "広島北部農業協同組合",
						"code": "7981"
					},
					{
						"title": "Hiroshima northern agricultural cooperatives",
						"code": "7981"
					},
					{
						"title": "広島中央農業協同組合",
						"code": "7994"
					},
					{
						"title": "Hiroshima National Agricultural Cooperatives",
						"code": "7994"
					},
					{
						"title": "芸南農業協同組合",
						"code": "8011"
					},
					{
						"title": "Geiminami Agricultural Cooperatives",
						"code": "8011"
					},
					{
						"title": "Hiroshima rich agricultural cooperatives",
						"code": "8019"
					},
					{
						"title": "広島ゆたか農業協同組合",
						"code": "8019"
					},
					{
						"title": "三原農業協同組合",
						"code": "8027"
					},
					{
						"title": "Mihara Agricultural Cooperatives",
						"code": "8027"
					},
					{
						"title": "尾道市農業協同組合",
						"code": "8029"
					},
					{
						"title": "Onomichi Agricultural Cooperatives",
						"code": "8029"
					},
					{
						"title": "Fukuyama Agricultural Cooperatives",
						"code": "8047"
					},
					{
						"title": "福山市農業協同組合",
						"code": "8047"
					},
					{
						"title": "三次農業協同組合",
						"code": "8069"
					},
					{
						"title": "Miyoshinogyo cooperative",
						"code": "8069"
					},
					{
						"title": "庄原農業協同組合",
						"code": "8076"
					},
					{
						"title": "Shobara Agricultural Cooperatives",
						"code": "8076"
					},
					{
						"title": "山口大島農業協同組合",
						"code": "8096"
					},
					{
						"title": "Yamaguchi Oshima agricultural cooperatives",
						"code": "8096"
					},
					{
						"title": "Iwakuni Agricultural Cooperatives",
						"code": "8102"
					},
					{
						"title": "岩国市農業協同組合",
						"code": "8102"
					},
					{
						"title": "Yamaguchi east Agricultural Cooperatives",
						"code": "8103"
					},
					{
						"title": "山口東農業協同組合",
						"code": "8103"
					},
					{
						"title": "Minamisuo Agricultural Cooperatives",
						"code": "8118"
					},
					{
						"title": "南すおう農業協同組合",
						"code": "8118"
					},
					{
						"title": "Shunan Agricultural Cooperatives",
						"code": "8134"
					},
					{
						"title": "周南農業協同組合",
						"code": "8134"
					},
					{
						"title": "Hofu solving Dji Agricultural Cooperatives",
						"code": "8143"
					},
					{
						"title": "防府とくぢ農業協同組合",
						"code": "8143"
					},
					{
						"title": "山口中央農業協同組合",
						"code": "8153"
					},
					{
						"title": "Yamaguchi National Agricultural Cooperatives",
						"code": "8153"
					},
					{
						"title": "Yamaguchi Ube Agricultural Cooperatives",
						"code": "8166"
					},
					{
						"title": "山口宇部農業協同組合",
						"code": "8166"
					},
					{
						"title": "下関農業協同組合",
						"code": "8181"
					},
					{
						"title": "Shimonoseki Agricultural Cooperatives",
						"code": "8181"
					},
					{
						"title": "山口美祢農業協同組合",
						"code": "8197"
					},
					{
						"title": "Yamaguchi Mine Agricultural Cooperatives",
						"code": "8197"
					},
					{
						"title": "長門大津農業協同組合",
						"code": "8200"
					},
					{
						"title": "Nagato Otsu Agricultural Cooperatives",
						"code": "8200"
					},
					{
						"title": "Aburando Hagi Agricultural Cooperatives",
						"code": "8223"
					},
					{
						"title": "あぶらんど萩農業協同組合",
						"code": "8223"
					},
					{
						"title": "徳島市農業協同組合",
						"code": "8231"
					},
					{
						"title": "Tokushima Agricultural Cooperatives",
						"code": "8231"
					},
					{
						"title": "East Tokushima Agricultural Cooperatives",
						"code": "8234"
					},
					{
						"title": "東とくしま農業協同組合",
						"code": "8234"
					},
					{
						"title": "名西郡農業協同組合",
						"code": "8242"
					},
					{
						"title": "My?zai District Agricultural Cooperatives",
						"code": "8242"
					},
					{
						"title": "Myōzai District Agricultural Cooperatives",
						"code": "8242"
					},
					{
						"title": "Itano County Agricultural Cooperatives",
						"code": "8252"
					},
					{
						"title": "板野郡農業協同組合",
						"code": "8252"
					},
					{
						"title": "徳島北農業協同組合",
						"code": "8257"
					},
					{
						"title": "Tokushima North Agricultural Cooperatives",
						"code": "8257"
					},
					{
						"title": "Otsu Matsushige Agricultural Cooperatives",
						"code": "8261"
					},
					{
						"title": "大津松茂農業協同組合",
						"code": "8261"
					},
					{
						"title": "里浦農業協同組合",
						"code": "8263"
					},
					{
						"title": "Satonoura Agricultural Cooperatives",
						"code": "8263"
					},
					{
						"title": "Anan Agricultural Cooperatives",
						"code": "8268"
					},
					{
						"title": "阿南農業協同組合",
						"code": "8268"
					},
					{
						"title": "かいふ農業協同組合",
						"code": "8288"
					},
					{
						"title": "Kaifu Agricultural Cooperatives",
						"code": "8288"
					},
					{
						"title": "Awa-cho Agricultural Cooperatives",
						"code": "8296"
					},
					{
						"title": "阿波町農業協同組合",
						"code": "8296"
					},
					{
						"title": "市場町農業協同組合",
						"code": "8300"
					},
					{
						"title": "Market town Agricultural Cooperatives",
						"code": "8300"
					},
					{
						"title": "Awa County Eastern Agricultural Cooperatives",
						"code": "8301"
					},
					{
						"title": "阿波郡東部農業協同組合",
						"code": "8301"
					},
					{
						"title": "麻植郡農業協同組合",
						"code": "8305"
					},
					{
						"title": "Oe County Agricultural Cooperatives",
						"code": "8305"
					},
					{
						"title": "Mima Agricultural Cooperatives",
						"code": "8312"
					},
					{
						"title": "美馬農業協同組合",
						"code": "8312"
					},
					{
						"title": "阿波みよし農業協同組合",
						"code": "8323"
					},
					{
						"title": "Awa Miyoshi Agricultural Cooperatives",
						"code": "8323"
					},
					{
						"title": "香川県農業協同組合",
						"code": "8332"
					},
					{
						"title": "Kagawa Prefecture Agricultural Cooperatives",
						"code": "8332"
					},
					{
						"title": "Horse Agricultural Cooperatives",
						"code": "8389"
					},
					{
						"title": "うま農業協同組合",
						"code": "8389"
					},
					{
						"title": "Saijo Agricultural Cooperatives",
						"code": "8395"
					},
					{
						"title": "西条市農業協同組合",
						"code": "8395"
					},
					{
						"title": "Niihama Agricultural Cooperatives",
						"code": "8397"
					},
					{
						"title": "新居浜市農業協同組合",
						"code": "8397"
					},
					{
						"title": "Shuso Agricultural Cooperatives",
						"code": "8398"
					},
					{
						"title": "周桑農業協同組合",
						"code": "8398"
					},
					{
						"title": "Ochi Imabari Agricultural Cooperatives",
						"code": "8400"
					},
					{
						"title": "越智今治農業協同組合",
						"code": "8400"
					},
					{
						"title": "今治立花農業協同組合",
						"code": "8401"
					},
					{
						"title": "Imabari Tachibana Agricultural Cooperatives",
						"code": "8401"
					},
					{
						"title": "Matsuyama Agricultural Cooperatives",
						"code": "8425"
					},
					{
						"title": "松山市農業協同組合",
						"code": "8425"
					},
					{
						"title": "Ehime atmosphere Agricultural Cooperatives",
						"code": "8457"
					},
					{
						"title": "愛媛たいき農業協同組合",
						"code": "8457"
					},
					{
						"title": "西宇和農業協同組合",
						"code": "8463"
					},
					{
						"title": "Nishiuwa Agricultural Cooperatives",
						"code": "8463"
					},
					{
						"title": "Higashiuwa Agricultural Cooperatives",
						"code": "8477"
					},
					{
						"title": "東宇和農業協同組合",
						"code": "8477"
					},
					{
						"title": "えひめ南農業協同組合",
						"code": "8482"
					},
					{
						"title": "Ehime south Agricultural Cooperatives",
						"code": "8482"
					},
					{
						"title": "えひめ中央農業協同組合",
						"code": "8500"
					},
					{
						"title": "Ehime National Agricultural Cooperatives",
						"code": "8500"
					},
					{
						"title": "馬路村農業協同組合",
						"code": "8511"
					},
					{
						"title": "Umaji Agricultural Cooperatives",
						"code": "8511"
					},
					{
						"title": "土佐あき農業協同組合",
						"code": "8512"
					},
					{
						"title": "Aki Tosa Agricultural Cooperatives",
						"code": "8512"
					},
					{
						"title": "Kami Tosa Agricultural Cooperatives",
						"code": "8514"
					},
					{
						"title": "土佐香美農業協同組合",
						"code": "8514"
					},
					{
						"title": "南国市農業協同組合",
						"code": "8524"
					},
					{
						"title": "Nankoku Agricultural Cooperatives",
						"code": "8524"
					},
					{
						"title": "長岡農業協同組合",
						"code": "8528"
					},
					{
						"title": "Nagaoka Agricultural Cooperatives",
						"code": "8528"
					},
					{
						"title": "Ten City Agricultural Cooperatives",
						"code": "8536"
					},
					{
						"title": "十市農業協同組合",
						"code": "8536"
					},
					{
						"title": "土佐れいほく農業協同組合",
						"code": "8544"
					},
					{
						"title": "Tosa Reihoku Agricultural Cooperatives",
						"code": "8544"
					},
					{
						"title": "高知市農業協同組合",
						"code": "8551"
					},
					{
						"title": "Kochi Agricultural Cooperatives",
						"code": "8551"
					},
					{
						"title": "Kochi Haruno Agricultural Cooperatives",
						"code": "8559"
					},
					{
						"title": "高知春野農業協同組合",
						"code": "8559"
					},
					{
						"title": "Tosa Agricultural Cooperatives",
						"code": "8575"
					},
					{
						"title": "土佐市農業協同組合",
						"code": "8575"
					},
					{
						"title": "コスモス農業協同組合",
						"code": "8582"
					},
					{
						"title": "Cosmos Agricultural Cooperatives",
						"code": "8582"
					},
					{
						"title": "土佐くろしお農業協同組合",
						"code": "8589"
					},
					{
						"title": "Tosa Kuroshio Agricultural Cooperatives",
						"code": "8589"
					},
					{
						"title": "Tsuno Mountain Agricultural Cooperatives",
						"code": "8592"
					},
					{
						"title": "津野山農業協同組合",
						"code": "8592"
					},
					{
						"title": "四万十農業協同組合",
						"code": "8593"
					},
					{
						"title": "Shimanto agricultural cooperatives",
						"code": "8593"
					},
					{
						"title": "Kochi was agricultural cooperatives",
						"code": "8610"
					},
					{
						"title": "高知はた農業協同組合",
						"code": "8610"
					},
					{
						"title": "Munakata Agricultural Cooperatives",
						"code": "8621"
					},
					{
						"title": "宗像農業協同組合",
						"code": "8621"
					},
					{
						"title": "Kasuya Agricultural Cooperatives",
						"code": "8626"
					},
					{
						"title": "粕屋農業協同組合",
						"code": "8626"
					},
					{
						"title": "福岡市東部農業協同組合",
						"code": "8632"
					},
					{
						"title": "Fukuoka Eastern Agricultural Cooperatives",
						"code": "8632"
					},
					{
						"title": "福岡市農業協同組合",
						"code": "8633"
					},
					{
						"title": "Fukuoka Agricultural Cooperatives",
						"code": "8633"
					},
					{
						"title": "Itoshima Agricultural Cooperatives",
						"code": "8635"
					},
					{
						"title": "糸島農業協同組合",
						"code": "8635"
					},
					{
						"title": "筑紫農業協同組合",
						"code": "8636"
					},
					{
						"title": "Tsukushi Agricultural Cooperatives",
						"code": "8636"
					},
					{
						"title": "筑前あさくら農業協同組合",
						"code": "8645"
					},
					{
						"title": "Chikuzen Asakura Agricultural Cooperatives",
						"code": "8645"
					},
					{
						"title": "Rainbow Agricultural Cooperatives",
						"code": "8653"
					},
					{
						"title": "にじ農業協同組合",
						"code": "8653"
					},
					{
						"title": "Mii Agricultural Cooperatives",
						"code": "8656"
					},
					{
						"title": "みい農業協同組合",
						"code": "8656"
					},
					{
						"title": "Kurume Agricultural Cooperatives",
						"code": "8660"
					},
					{
						"title": "久留米市農業協同組合",
						"code": "8660"
					},
					{
						"title": "三潴町農業協同組合",
						"code": "8664"
					},
					{
						"title": "Mizuma-cho Agricultural Cooperatives",
						"code": "8664"
					},
					{
						"title": "福岡大城農業協同組合",
						"code": "8667"
					},
					{
						"title": "Fukuoka Oshiro Agricultural Cooperatives",
						"code": "8667"
					},
					{
						"title": "Fukuoka Yame Agricultural Cooperatives",
						"code": "8668"
					},
					{
						"title": "福岡八女農業協同組合",
						"code": "8668"
					},
					{
						"title": "Yanagawa Agricultural Cooperatives",
						"code": "8680"
					},
					{
						"title": "柳川農業協同組合",
						"code": "8680"
					},
					{
						"title": "South Chikugo Agricultural Cooperatives",
						"code": "8689"
					},
					{
						"title": "南筑後農業協同組合",
						"code": "8689"
					},
					{
						"title": "北九州農業協同組合",
						"code": "8692"
					},
					{
						"title": "Kitakyushu Agricultural Cooperatives",
						"code": "8692"
					},
					{
						"title": "Straight saddle Agricultural Cooperatives",
						"code": "8694"
					},
					{
						"title": "直鞍農業協同組合",
						"code": "8694"
					},
					{
						"title": "Fukuoka Kaho Agricultural Cooperatives",
						"code": "8701"
					},
					{
						"title": "福岡嘉穂農業協同組合",
						"code": "8701"
					},
					{
						"title": "田川農業協同組合",
						"code": "8715"
					},
					{
						"title": "Tagawa agricultural cooperatives",
						"code": "8715"
					},
					{
						"title": "Fukuoka KyoTsuki Agricultural Cooperatives",
						"code": "8730"
					},
					{
						"title": "福岡京築農業協同組合",
						"code": "8730"
					},
					{
						"title": "佐賀市中央農業協同組合",
						"code": "8740"
					},
					{
						"title": "Saga National Agricultural Cooperatives",
						"code": "8740"
					},
					{
						"title": "佐賀県農業協同組合",
						"code": "8762"
					},
					{
						"title": "Saga Prefecture Agricultural Cooperatives",
						"code": "8762"
					},
					{
						"title": "唐津農業協同組合",
						"code": "8766"
					},
					{
						"title": "Karatsu Agricultural Cooperatives",
						"code": "8766"
					},
					{
						"title": "Imari Agricultural Cooperatives",
						"code": "8771"
					},
					{
						"title": "伊万里市農業協同組合",
						"code": "8771"
					},
					{
						"title": "Nagasaki Seihi Agricultural Cooperatives",
						"code": "8794"
					},
					{
						"title": "長崎西彼農業協同組合",
						"code": "8794"
					},
					{
						"title": "長崎県央農業協同組合",
						"code": "8813"
					},
					{
						"title": "Nagasaki Prefecture central agricultural cooperatives",
						"code": "8813"
					},
					{
						"title": "Nagasaki Prefecture, central agricultural cooperatives",
						"code": "8813"
					},
					{
						"title": "島原雲仙農業協同組合",
						"code": "8829"
					},
					{
						"title": "Shimabara Unzen Agricultural Cooperatives",
						"code": "8829"
					},
					{
						"title": "Nagasaki West Sea Agricultural Cooperatives",
						"code": "8857"
					},
					{
						"title": "ながさき西海農業協同組合",
						"code": "8857"
					},
					{
						"title": "ごとう農業協同組合",
						"code": "8893"
					},
					{
						"title": "Goto Agricultural Cooperatives",
						"code": "8893"
					},
					{
						"title": "壱岐市農業協同組合",
						"code": "8905"
					},
					{
						"title": "Iki Agricultural Cooperatives",
						"code": "8905"
					},
					{
						"title": "対馬農業協同組合",
						"code": "8906"
					},
					{
						"title": "Tsushima Agricultural Cooperatives",
						"code": "8906"
					},
					{
						"title": "熊本市農業協同組合",
						"code": "8916"
					},
					{
						"title": "Kumamoto Agricultural Cooperatives",
						"code": "8916"
					},
					{
						"title": "玉名農業協同組合",
						"code": "8926"
					},
					{
						"title": "Tamana Agricultural Cooperatives",
						"code": "8926"
					},
					{
						"title": "Tamana Ohama-cho agricultural cooperatives",
						"code": "8934"
					},
					{
						"title": "玉名市大浜町農業協同組合",
						"code": "8934"
					},
					{
						"title": "Tamana Ohama-cho, agricultural cooperatives",
						"code": "8934"
					},
					{
						"title": "Kamoto Agricultural Cooperatives",
						"code": "8941"
					},
					{
						"title": "鹿本農業協同組合",
						"code": "8941"
					},
					{
						"title": "菊池地域農業協同組合",
						"code": "8949"
					},
					{
						"title": "Kikuchi local agriculture cooperative",
						"code": "8949"
					},
					{
						"title": "阿蘇農業協同組合",
						"code": "8964"
					},
					{
						"title": "Aso Agricultural Cooperatives",
						"code": "8964"
					},
					{
						"title": "上益城農業協同組合",
						"code": "8982"
					},
					{
						"title": "Kamimashiki Agricultural Cooperatives",
						"code": "8982"
					},
					{
						"title": "Kumamoto Uki Agricultural Cooperatives",
						"code": "9010"
					},
					{
						"title": "熊本宇城農業協同組合",
						"code": "9010"
					},
					{
						"title": "八代地域農業協同組合",
						"code": "9017"
					},
					{
						"title": "Yashiro local agriculture cooperative",
						"code": "9017"
					},
					{
						"title": "Ashikita Agricultural Cooperatives",
						"code": "9043"
					},
					{
						"title": "あしきた農業協同組合",
						"code": "9043"
					},
					{
						"title": "球磨地域農業協同組合",
						"code": "9048"
					},
					{
						"title": "Kuma local agriculture cooperative",
						"code": "9048"
					},
					{
						"title": "本渡五和農業協同組合",
						"code": "9069"
					},
					{
						"title": "Hondo Goka Agricultural Cooperatives",
						"code": "9069"
					},
					{
						"title": "Amakusa Agricultural Cooperatives",
						"code": "9070"
					},
					{
						"title": "あまくさ農業協同組合",
						"code": "9070"
					},
					{
						"title": "苓北町農業協同組合",
						"code": "9072"
					},
					{
						"title": "Reihoku Agricultural Cooperatives",
						"code": "9072"
					},
					{
						"title": "べっぷ日出農業協同組合",
						"code": "9103"
					},
					{
						"title": "Beppu Hiji Agricultural Cooperatives",
						"code": "9103"
					},
					{
						"title": "大分県農業協同組合",
						"code": "9104"
					},
					{
						"title": "Oita Prefecture Agricultural Cooperatives",
						"code": "9104"
					},
					{
						"title": "Kusu Kokonoe Agricultural Cooperatives",
						"code": "9137"
					},
					{
						"title": "玖珠九重農業協同組合",
						"code": "9137"
					},
					{
						"title": "Kokonoe-cho Iida Agricultural Cooperatives",
						"code": "9140"
					},
					{
						"title": "九重町飯田農業協同組合",
						"code": "9140"
					},
					{
						"title": "Kokonoe-cho, Iida Agricultural Cooperatives",
						"code": "9140"
					},
					{
						"title": "大分大山町農業協同組合",
						"code": "9145"
					},
					{
						"title": "Oita Oyama Agricultural Cooperatives",
						"code": "9145"
					},
					{
						"title": "宮崎中央農業協同組合",
						"code": "9169"
					},
					{
						"title": "Miyazaki National Agricultural Cooperatives",
						"code": "9169"
					},
					{
						"title": "Aya-cho Agricultural Cooperatives",
						"code": "9177"
					},
					{
						"title": "綾町農業協同組合",
						"code": "9177"
					},
					{
						"title": "はまゆう農業協同組合",
						"code": "9178"
					},
					{
						"title": "Hamayu Agricultural Cooperatives",
						"code": "9178"
					},
					{
						"title": "Kushima Daitaba agricultural cooperatives",
						"code": "9181"
					},
					{
						"title": "串間市大束農業協同組合",
						"code": "9181"
					},
					{
						"title": "Miyakonojo Agricultural Cooperatives",
						"code": "9184"
					},
					{
						"title": "都城農業協同組合",
						"code": "9184"
					},
					{
						"title": "こばやし農業協同組合",
						"code": "9193"
					},
					{
						"title": "Kobayashi Agricultural Cooperatives",
						"code": "9193"
					},
					{
						"title": "えびの市農業協同組合",
						"code": "9197"
					},
					{
						"title": "Ebino Agricultural Cooperatives",
						"code": "9197"
					},
					{
						"title": "Koyu Agricultural Cooperatives",
						"code": "9200"
					},
					{
						"title": "児湯農業協同組合",
						"code": "9200"
					},
					{
						"title": "尾鈴農業協同組合",
						"code": "9203"
					},
					{
						"title": "Osuzu Agricultural Cooperatives",
						"code": "9203"
					},
					{
						"title": "Saito Agricultural Cooperatives",
						"code": "9205"
					},
					{
						"title": "西都農業協同組合",
						"code": "9205"
					},
					{
						"title": "Nobeoka Agricultural Cooperatives",
						"code": "9208"
					},
					{
						"title": "延岡農業協同組合",
						"code": "9208"
					},
					{
						"title": "Hinata Agricultural Cooperatives",
						"code": "9213"
					},
					{
						"title": "日向農業協同組合",
						"code": "9213"
					},
					{
						"title": "Takachiho district agricultural cooperatives",
						"code": "9221"
					},
					{
						"title": "高千穂地区農業協同組合",
						"code": "9221"
					},
					{
						"title": "Kagoshima Chuo Agricultural Cooperatives",
						"code": "9229"
					},
					{
						"title": "かごしま中央農業協同組合",
						"code": "9229"
					},
					{
						"title": "Green Kagoshima Agricultural Cooperatives",
						"code": "9234"
					},
					{
						"title": "グリーン鹿児島農業協同組合",
						"code": "9234"
					},
					{
						"title": "東部農業協同組合",
						"code": "9240"
					},
					{
						"title": "Eastern Agricultural Cooperatives",
						"code": "9240"
					},
					{
						"title": "いぶすき農業協同組合",
						"code": "9251"
					},
					{
						"title": "Ibusuki Agricultural Cooperatives",
						"code": "9251"
					},
					{
						"title": "南さつま農業協同組合",
						"code": "9257"
					},
					{
						"title": "South Satsuma Agricultural Cooperatives",
						"code": "9257"
					},
					{
						"title": "さつま日置農業協同組合",
						"code": "9270"
					},
					{
						"title": "Satsuma Hioki Agricultural Cooperatives",
						"code": "9270"
					},
					{
						"title": "北さつま農業協同組合",
						"code": "9296"
					},
					{
						"title": "North Satsuma Agricultural Cooperatives",
						"code": "9296"
					},
					{
						"title": "鹿児島いずみ農業協同組合",
						"code": "9302"
					},
					{
						"title": "Kagoshima Izumi Agricultural Cooperatives",
						"code": "9302"
					},
					{
						"title": "あいら農業協同組合",
						"code": "9319"
					},
					{
						"title": "Aira Agricultural Cooperatives",
						"code": "9319"
					},
					{
						"title": "Soo Kagoshima Agricultural Cooperatives",
						"code": "9332"
					},
					{
						"title": "そお鹿児島農業協同組合",
						"code": "9332"
					},
					{
						"title": "Blue sky Agricultural Cooperatives",
						"code": "9338"
					},
					{
						"title": "あおぞら農業協同組合",
						"code": "9338"
					},
					{
						"title": "鹿児島きもつき農業協同組合",
						"code": "9341"
					},
					{
						"title": "Kagoshima Kimotsuki Agricultural Cooperatives",
						"code": "9341"
					},
					{
						"title": "Kimotsuki Aira Kagoshima Agricultural Cooperatives",
						"code": "9347"
					},
					{
						"title": "肝付吾平町農業協同組合",
						"code": "9347"
					},
					{
						"title": "Kimotsuki Aira, Kagoshima Agricultural Cooperatives",
						"code": "9347"
					},
					{
						"title": "Seed Yaku Agricultural Cooperatives",
						"code": "9353"
					},
					{
						"title": "種子屋久農業協同組合",
						"code": "9353"
					},
					{
						"title": "あまみ農業協同組合",
						"code": "9363"
					},
					{
						"title": "Amami Agricultural Cooperatives",
						"code": "9363"
					},
					{
						"title": "Okinawa Prefectural Agricultural Cooperatives",
						"code": "9375"
					},
					{
						"title": "沖縄県農業協同組合",
						"code": "9375"
					},
					{
						"title": "北海道信用漁業協同組合連合会",
						"code": "9450"
					},
					{
						"title": "Hokkaido credit Federation of Fisheries Cooperative Associations",
						"code": "9450"
					},
					{
						"title": "Aomori Prefecture credit Federation of Fisheries Cooperative Associations",
						"code": "9451"
					},
					{
						"title": "青森県信用漁業協同組合連合会",
						"code": "9451"
					},
					{
						"title": "岩手県信用漁業協同組合連合会",
						"code": "9452"
					},
					{
						"title": "Iwate Prefecture credit Federation of Fisheries Cooperative Associations",
						"code": "9452"
					},
					{
						"title": "宮城県漁業協同組合",
						"code": "9453"
					},
					{
						"title": "Miyagi Fisheries Cooperative Association",
						"code": "9453"
					},
					{
						"title": "福島県信用漁業協同組合連合会",
						"code": "9456"
					},
					{
						"title": "Fukushima Prefecture credit Federation of Fisheries Cooperative Associations",
						"code": "9456"
					},
					{
						"title": "茨城県信用漁業協同組合連合会",
						"code": "9457"
					},
					{
						"title": "Ibaraki Prefecture credit Federation of Fisheries Cooperative Associations",
						"code": "9457"
					},
					{
						"title": "千葉県信用漁業協同組合連合会",
						"code": "9461"
					},
					{
						"title": "Chiba credit Federation of Fisheries Cooperative Associations",
						"code": "9461"
					},
					{
						"title": "東京都信用漁業協同組合連合会",
						"code": "9462"
					},
					{
						"title": "Tokyo credit Federation of Fisheries Cooperative Associations",
						"code": "9462"
					},
					{
						"title": "新潟県信用漁業協同組合連合会",
						"code": "9466"
					},
					{
						"title": "Niigata Prefecture credit Federation of Fisheries Cooperative Associations",
						"code": "9466"
					},
					{
						"title": "Toyama Prefecture credit Federation of Fisheries Cooperative Associations",
						"code": "9467"
					},
					{
						"title": "富山県信用漁業協同組合連合会",
						"code": "9467"
					},
					{
						"title": "石川県信用漁業協同組合連合会",
						"code": "9468"
					},
					{
						"title": "Ishikawa Prefecture credit Federation of Fisheries Cooperative Associations",
						"code": "9468"
					},
					{
						"title": "静岡県信用漁業協同組合連合会",
						"code": "9470"
					},
					{
						"title": "Shizuoka Prefecture credit Federation of Fisheries Cooperative Associations",
						"code": "9470"
					},
					{
						"title": "愛知県信用漁業協同組合連合会",
						"code": "9471"
					},
					{
						"title": "Aichi Prefecture credit Federation of Fisheries Cooperative Associations",
						"code": "9471"
					},
					{
						"title": "Mie Prefecture credit Federation of Fisheries Cooperative Associations",
						"code": "9472"
					},
					{
						"title": "三重県信用漁業協同組合連合会",
						"code": "9472"
					},
					{
						"title": "Fukui Prefecture credit Federation of Fisheries Cooperative Associations",
						"code": "9473"
					},
					{
						"title": "福井県信用漁業協同組合連合会",
						"code": "9473"
					},
					{
						"title": "Kyoto credit Federation of Fisheries Cooperative Associations",
						"code": "9475"
					},
					{
						"title": "京都府信用漁業協同組合連合会",
						"code": "9475"
					},
					{
						"title": "兵庫県信用漁業協同組合連合会",
						"code": "9477"
					},
					{
						"title": "Hyogo Prefecture credit Federation of Fisheries Cooperative Associations",
						"code": "9477"
					},
					{
						"title": "和歌山県信用漁業協同組合連合会",
						"code": "9479"
					},
					{
						"title": "Wakayama Prefecture credit Federation of Fisheries Cooperative Associations",
						"code": "9479"
					},
					{
						"title": "鳥取県信用漁業協同組合連合会",
						"code": "9480"
					},
					{
						"title": "Tottori Prefecture credit Federation of Fisheries Cooperative Associations",
						"code": "9480"
					},
					{
						"title": "JF Shimane fishery cooperatives",
						"code": "9481"
					},
					{
						"title": "ＪＦしまね漁業協同組合",
						"code": "9481"
					},
					{
						"title": "Hiroshima credit Federation of Fisheries Cooperative Associations",
						"code": "9483"
					},
					{
						"title": "広島県信用漁業協同組合連合会",
						"code": "9483"
					},
					{
						"title": "Yamaguchi Prefecture fishing cooperative",
						"code": "9484"
					},
					{
						"title": "山口県漁業協同組合",
						"code": "9484"
					},
					{
						"title": "Tokushima Prefecture credit Federation of Fisheries Cooperative Associations",
						"code": "9485"
					},
					{
						"title": "徳島県信用漁業協同組合連合会",
						"code": "9485"
					},
					{
						"title": "香川県信用漁業協同組合連合会",
						"code": "9486"
					},
					{
						"title": "Kagawa Prefecture credit Federation of Fisheries Cooperative Associations",
						"code": "9486"
					},
					{
						"title": "Ehime Prefecture credit Federation of Fisheries Cooperative Associations",
						"code": "9487"
					},
					{
						"title": "愛媛県信用漁業協同組合連合会",
						"code": "9487"
					},
					{
						"title": "高知県信用漁業協同組合連合会",
						"code": "9488"
					},
					{
						"title": "Kochi Prefecture credit Federation of Fisheries Cooperative Associations",
						"code": "9488"
					},
					{
						"title": "福岡県信用漁業協同組合連合会",
						"code": "9489"
					},
					{
						"title": "Fukuoka Prefecture credit Federation of Fisheries Cooperative Associations",
						"code": "9489"
					},
					{
						"title": "Saga credit Federation of Fisheries Cooperative Associations",
						"code": "9490"
					},
					{
						"title": "佐賀県信用漁業協同組合連合会",
						"code": "9490"
					},
					{
						"title": "長崎県信用漁業協同組合連合会",
						"code": "9491"
					},
					{
						"title": "Nagasaki Prefecture credit Federation of Fisheries Cooperative Associations",
						"code": "9491"
					},
					{
						"title": "Oita Prefecture fishing cooperative",
						"code": "9493"
					},
					{
						"title": "大分県漁業協同組合",
						"code": "9493"
					},
					{
						"title": "Miyazaki Prefecture credit Federation of Fisheries Cooperative Associations",
						"code": "9494"
					},
					{
						"title": "宮崎県信用漁業協同組合連合会",
						"code": "9494"
					},
					{
						"title": "鹿児島県信用漁業協同組合連合会",
						"code": "9495"
					},
					{
						"title": "Kagoshima Prefecture credit Federation of Fisheries Cooperative Associations",
						"code": "9495"
					},
					{
						"title": "Okinawa Prefecture credit Federation of Fisheries Cooperative Associations",
						"code": "9496"
					},
					{
						"title": "沖縄県信用漁業協同組合連合会",
						"code": "9496"
					},
					{
						"title": "ゆうちょ銀行",
						"code": "9900"
					},
					{
						"title": "Japan Post Bank",
						"code": "9900"
					}
				],
				"HKR": [{
						"title": "Bookook Securities (부국증권) [290]",
						"code": "BOOKOOK_290"
					},
					{
						"title": "Busan Bank (부산) [032]",
						"code": "BUSAN_032"
					},
					{
						"title": "Citibank Korea (한국씨티) [027]",
						"code": "CITY_027"
					},
					{
						"title": "Community Credit Cooperative (새마을금고) [045]",
						"code": "SAEMAEULGEUMGO_045"
					},
					{
						"title": "Credit Union (신협) [048]",
						"code": "SINHYUB_048"
					},
					{
						"title": "Daegu Bank (대구) [031]",
						"code": "DAEGU_031"
					},
					{
						"title": "Daewoo Securities (대우증권) [238]",
						"code": "DAEWOO_238"
					},
					{
						"title": "Daishin Securities (대신증권) [267]",
						"code": "DAESHIN_267"
					},
					{
						"title": "Dongbu Securities (동부증권) [279]",
						"code": "DONGBU_279"
					},
					{
						"title": "Ebest Investment & Securities (이베스트투자증권) [265]",
						"code": "EBEST_265"
					},
					{
						"title": "Eugene Investment & Securities (유진투자증권) [280]",
						"code": "EUGENE_280"
					},
					{
						"title": "HI Investment & Securities (하이투자증권) [262]",
						"code": "HI_262"
					},
					{
						"title": "HMC Investment & Securities (투자증권) [263]",
						"code": "HMC_263"
					},
					{
						"title": "HSBC [054]",
						"code": "HSBC_054"
					},
					{
						"title": "Hana Financial Investment (하나금융투자) [270]",
						"code": "HANA_270"
					},
					{
						"title": "Hanhwa Investment & Securities (한화투자증권) [269]",
						"code": "HANHWA_269"
					},
					{
						"title": "Hyundai Securities (현대증권) [218]",
						"code": "HYUNDAI_218"
					},
					{
						"title": "Iam Investment & Securities (아이엠투자증권) [268]",
						"code": "IAM_268"
					},
					{
						"title": "Industrial Bank of Korea (기업) [003]",
						"code": "KIUP_003"
					},
					{
						"title": "Jeju Bank (제주) [035]",
						"code": "JEJU_035"
					},
					{
						"title": "Jeonbuk Bank (전북) [037]",
						"code": "JEONBUK_037"
					},
					{
						"title": "KEB Hana Bank (하나은행) [005]",
						"code": "KEB_005"
					},
					{
						"title": "Kiwoom Securities (키움증권) [264]",
						"code": "KIWOOM_264"
					},
					{
						"title": "Kookmin Bank (국민) [004]",
						"code": "KUKMIN_004"
					},
					{
						"title": "Korea Development Bank (산업) [002]",
						"code": "SANUP_002"
					},
					{
						"title": "Korea Eximbank (수출입) [008]",
						"code": "SUCHULIB_008"
					},
					{
						"title": "Korea Investment & Securities (한국투자증권) [243]",
						"code": "KOREA_243"
					},
					{
						"title": "Korea Postbank (우체국) [071]",
						"code": "POSTOFFICE_071"
					},
					{
						"title": "Kwangju Bank (광주) [034]",
						"code": "KWANGJU_034"
					},
					{
						"title": "Kyobo Securities (교보증권) [261]",
						"code": "KYOBO_261"
					},
					{
						"title": "Kyongnam Bank (경남) [039]",
						"code": "KYONGNAM_039"
					},
					{
						"title": "LIG Investment & Securities (엘아이지투자증권) [292]",
						"code": "LIG_292"
					},
					{
						"title": "Meritz Securities (메리츠종합금융증권) [287]",
						"code": "MERITZ_287"
					},
					{
						"title": "Mirae Asset Securities (미래에셋증권) [230]",
						"code": "MIRAEASSET_230"
					},
					{
						"title": "NH Investment & Securities (투자증권) [247]",
						"code": "NH_247"
					},
					{
						"title": "NongHyup Bank (농협은행) [011]",
						"code": "NONGHYUP_011"
					},
					{
						"title": "SK Securities (에스케이증권) [266]",
						"code": "SK_266"
					},
					{
						"title": "Samsung Securities (삼성증권) [240]",
						"code": "SAMSUNG_240"
					},
					{
						"title": "Savings Bank (상호저축은행) [050]",
						"code": "SB_050"
					},
					{
						"title": "Shinhan Bank (신한) [088]",
						"code": "SHINHAN_088"
					},
					{
						"title": "Shinhan Investment Corp (신한금융투자) [278]",
						"code": "SHINHAN_278"
					},
					{
						"title": "Shinyoung Securities (신영증권) [291]",
						"code": "SHINYOUNG_291"
					},
					{
						"title": "Standard Chartered Korea [023]",
						"code": "SC_023"
					},
					{
						"title": "Suhyup Bank (수협) [007]",
						"code": "SUHYUP_007"
					},
					{
						"title": "Woori Bank (우리) [020]",
						"code": "WOORI_020"
					},
					{
						"title": "Yuanta Securities Korea (유안타증권) [209]",
						"code": "YUANTA_209"
					}
				],
				"MYR": [{
						"title": " MAYBANK INTERNATIONAL (L) LTD [MBBEMYKA]",
						"code": "MBBEMYKA"
					},
					{
						"title": " THE ROYAL BANK OF SCOTLAND BERHAD [ ABNAMYKL]",
						"code": " ABNAMYKL"
					},
					{
						"title": "AFFIN BANK BERHAD  [PHBMMYKL]",
						"code": "PHBMMYKL"
					},
					{
						"title": "AFFIN ISLAMIC BANK BERHAD  [AIBBMYKL]",
						"code": "AIBBMYKL"
					},
					{
						"title": "AGRO BANK (pka BANK PERTANIAN MALAYSIA BERHAD) [AGISMYK1]",
						"code": "AGISMYK1"
					},
					{
						"title": "AL RAJHI BANKING AND INVESTMENT CORPORATION (MALAYSIA) BHD  [RJHIMYKL]",
						"code": "RJHIMYKL"
					},
					{
						"title": "ALLIANCE BANK MALAYSIA BERHAD  [MFBBMYKL]",
						"code": "MFBBMYKL"
					},
					{
						"title": "ALLIANCE ISLAMIC BANK [ALSRMYK1]",
						"code": "ALSRMYK1"
					},
					{
						"title": "AMBANK BERHAD  [ARBKMYKL]",
						"code": "ARBKMYKL"
					},
					{
						"title": "AMINVESTMENT BANK BERHAD [AMMBMYKL]",
						"code": "AMMBMYKL"
					},
					{
						"title": "AMISLAMIC BANK BERHAD  [AISLMYKL]",
						"code": "AISLMYKL"
					},
					{
						"title": "AMISLAMIC BANK BERHAD [AISLMYKL]",
						"code": "AISLMYKL"
					},
					{
						"title": "ASIAN FINANCE BANK BERHAD [AFBQMYKL]",
						"code": "AFBQMYKL"
					},
					{
						"title": "BANK ISLAM MALAYSIA BERHAD  [BIMBMYKL]",
						"code": "BIMBMYKL"
					},
					{
						"title": "BANK ISLAM MALAYSIA BERHAD LABUAN OFFSHORE BRANCH  [BISLMYKA]",
						"code": "BISLMYKA"
					},
					{
						"title": "BANK KERJASAMA RAKYAT MALAYSIA BERHAD (BANK RAKYAT)  [BKRMMYKL]",
						"code": "BKRMMYKL"
					},
					{
						"title": "BANK MUAMALAT MALAYSIA BERHAD (6175 W)  [BMMBMYKL]",
						"code": "BMMBMYKL"
					},
					{
						"title": "BANK OF AMERICA MALAYSIA BERHAD  [BOFAMY2X]",
						"code": "BOFAMY2X"
					},
					{
						"title": "BANK OF CHINA (MALAYSIA) BERHAD [BKCHMYKL ]",
						"code": "BKCHMYKL "
					},
					{
						"title": "BANK OF NOVA SCOTIA BERHAD [NOSCMYKL]",
						"code": "NOSCMYKL"
					},
					{
						"title": "BANK OF TOKYO MITSUBISHI UFJ (MALAYSIA) BERHAD  [BOTKMYKX]",
						"code": "BOTKMYKX"
					},
					{
						"title": "BANK OF TOKYO MITSUBISHI UFJ LTD. THE  [BOTKMYKA]",
						"code": "BOTKMYKA"
					},
					{
						"title": "BANK SIMPANAN NASIONAL [BSNAMYK1]",
						"code": "BSNAMYK1"
					},
					{
						"title": "BNP PARIBAS  [BNPAMYKA]",
						"code": "BNPAMYKA"
					},
					{
						"title": "BNP PARIBAS MALAYSIA BERHAD  [BNPAMYKL]",
						"code": "BNPAMYKL"
					},
					{
						"title": "CIMB BANK (L) LIMITED  [CIBBMYKA]",
						"code": "CIBBMYKA"
					},
					{
						"title": "CIMB BANK BERHAD  [CIBBMYKL]",
						"code": "CIBBMYKL"
					},
					{
						"title": "CIMB BANK BERHAD LABUAN OFFSHORE BRANCH  [CIBBMY2L]",
						"code": "CIBBMY2L"
					},
					{
						"title": "CIMB INVESTMENT BANK BERHAD  [COIMMYKL]",
						"code": "COIMMYKL"
					},
					{
						"title": "CIMB ISLAMIC BANK BERHAD  [CTBBMYKL]",
						"code": "CTBBMYKL"
					},
					{
						"title": "CIMB PRINCIPAL ASSET MANAGEMENT BERHAD  [CANHMYKL]",
						"code": "CANHMYKL"
					},
					{
						"title": "CITIBANK BERHAD  [CITIMYKL]",
						"code": "CITIMYKL"
					},
					{
						"title": "DEUTSCHE BANK (MALAYSIA) BERHAD  [DEUTMYKL]",
						"code": "DEUTMYKL"
					},
					{
						"title": "HONG LEONG BANK BERHAD  [HLBBMYKL]",
						"code": "HLBBMYKL"
					},
					{
						"title": "HONG LEONG INVESTMENT BANK BERHAD  [HLIVMYKL]",
						"code": "HLIVMYKL"
					},
					{
						"title": "HONG LEONG ISLAMIC BANK BERHAD  [HLIBMYKL]",
						"code": "HLIBMYKL"
					},
					{
						"title": "HSBC (MALAYSIA) TRUSTEE BERHAD  [HSTMMYKL]",
						"code": "HSTMMYKL"
					},
					{
						"title": "HSBC AMANAH MALAYSIA BERHAD  [HMABMYKL]",
						"code": "HMABMYKL"
					},
					{
						"title": "HSBC BANK MALAYSIA BERHAD [HBMBMYKL]",
						"code": "HBMBMYKL"
					},
					{
						"title": "INDUSTRIAL AND COMMERCIAL BANK OF CHINA (MALAYSIA) BERHAD.  [ICBKMYKL]",
						"code": "ICBKMYKL"
					},
					{
						"title": "J.P.MORGAN CHASE BANK BERHAD KUALA LUMPUR  [CHASMYKX]",
						"code": "CHASMYKX"
					},
					{
						"title": "JALAN SEMANTAN, DAMANSARA HEIGHTSBANGUNAN CIMB [CIBBMYKL]",
						"code": "CIBBMYKL"
					},
					{
						"title": "JP MORGAN CHASE BANK NA LABUAN BRANCH  [CHASMY2A]",
						"code": "CHASMY2A"
					},
					{
						"title": "KUWAIT FINANCE HOUSE (MALAYSIA) BERHAD  [KFHOMYKL]",
						"code": "KFHOMYKL"
					},
					{
						"title": "MALAYAN BANKING BERHAD (MAYBANK) [MBBEMYKL]",
						"code": "MBBEMYKL"
					},
					{
						"title": "MAYBANK INTERNATIONAL (L) LTD.  [MBBEMYKA]",
						"code": "MBBEMYKA"
					},
					{
						"title": "MAYBANK INTERNATIONAL LABUAN BRANCH  [MBBEMY2L]",
						"code": "MBBEMY2L"
					},
					{
						"title": "MAYBANK ISLAMIC BERHAD [MBISMYK1]",
						"code": "MBISMYK1"
					},
					{
						"title": "MAYBANK ISLAMIC BERHAD [MBISMYKL]",
						"code": "MBISMYKL"
					},
					{
						"title": "MIZUHO BANK (MALAYSIA) BERHAD  [MHCBMYKA]",
						"code": "MHCBMYKA"
					},
					{
						"title": "OCBC AL AMIN BANK BERHAD  [OABBMYKL]",
						"code": "OABBMYKL"
					},
					{
						"title": "OCBC BANK BERHAD  [OCBCMYKL]",
						"code": "OCBCMYKL"
					},
					{
						"title": "OVERSEA CHINESE BANKING CORP. LTD LABUAN BRANCH  [OCBCMYKA]",
						"code": "OCBCMYKA"
					},
					{
						"title": "PUBLIC BANK (L) LTD  [PBLLMYKA]",
						"code": "PBLLMYKA"
					},
					{
						"title": "PUBLIC BANK BERHAD  [PBBEMYKL]",
						"code": "PBBEMYKL"
					},
					{
						"title": "PUBLIC ISLAMIC BANK BERHAD  [PIBEMYK1]",
						"code": "PIBEMYK1"
					},
					{
						"title": "RHB BANK (L) LTD  [RHBBMYKA]",
						"code": "RHBBMYKA"
					},
					{
						"title": "RHB BANK BERHAD  [RHBBMYKL]",
						"code": "RHBBMYKL"
					},
					{
						"title": "RHB BANK BERHAD [RHBBMYK1KKB]",
						"code": "RHBBMYK1KKB"
					},
					{
						"title": "RHB INVESTMENT BANK BERHAD  [OSKIMYKL]",
						"code": "OSKIMYKL"
					},
					{
						"title": "RHB ISLAMIC BANK BERHAD  [RHBAMYKL]",
						"code": "RHBAMYKL"
					},
					{
						"title": "STANDARD CHARTERED BANK MALAYSIA BERHAD  [SCBLMYKX]",
						"code": "SCBLMYKX"
					},
					{
						"title": "STANDARD CHARTERED SAADIQ BERHAD [SCSRMYK1]",
						"code": "SCSRMYK1"
					},
					{
						"title": "SUMITOMO MITSUI BANKING CORPORATION  [SMBCMYKA]",
						"code": "SMBCMYKA"
					},
					{
						"title": "SUMITOMO MITSUI BANKING CORPORATION MALAYSIA BERHAD  [SMBCMYKL]",
						"code": "SMBCMYKL"
					},
					{
						"title": "UNITED OVERSEAS BANK  [UOVBMYKL]",
						"code": "UOVBMYKL"
					},
					{
						"title": "UNITED OVERSEAS BANK LIMITED LABUAN BRANCH  [UOVBMY2L]",
						"code": "UOVBMY2L"
					}
				],
				"THB": [{
						"title": "BNP Paribas [BNPATHBK]",
						"code": "045"
					},
					{
						"title": "Bangkok Bank Public Company Ltd. [BKKBTHBK]",
						"code": "002"
					},
					{
						"title": "Bank For Agriculture And Agricultural Cooperatives [BAABTHBK]",
						"code": "034"
					},
					{
						"title": "Bank Of America, National Association [BOFATH2X]",
						"code": "027"
					},
					{
						"title": "Bank Of Ayudhya (Krungsri bank) [AYUDTHBK]",
						"code": "025"
					},
					{
						"title": "Bank Of China Limited [BKCHTHBK]",
						"code": "052"
					},
					{
						"title": "CIMB Thai Bank Public Company Limited [UBOBTHBK]",
						"code": "022"
					},
					{
						"title": "Citibank, N.A. [CITITHBX]",
						"code": "017"
					},
					{
						"title": "Deutsche Bank Ag. [DEUTTHBK]",
						"code": "032"
					},
					{
						"title": "HSBC [HSBCTHBK]",
						"code": "031"
					},
					{
						"title": "ICBC Thai [ICBKTHBK]",
						"code": "070"
					},
					{
						"title": "Islamic Bank Of Thailand [TIBTTHBK]",
						"code": "066"
					},
					{
						"title": "JPMorgan Chase Bank, National Association [CHASTHBX]",
						"code": "008"
					},
					{
						"title": "Kasikornbank Public Company Ltd. [KASITHBK]",
						"code": "004"
					},
					{
						"title": "Kiatnakin Bank Public Company Limited [KKPBTHBK]",
						"code": "069"
					},
					{
						"title": "Krung Thai Bank Public Company Ltd. [KRTHTHBK]",
						"code": "006"
					},
					{
						"title": "Land And Houses Retail Bank Public Company Limited [LAHRTHB1]",
						"code": "073"
					},
					{
						"title": "Mega International Commercial Bank Public Co. Ltd. [ICBCTHBK]",
						"code": "026"
					},
					{
						"title": "Mizuho Corporate Bank, Ltd. [MHCBTHBK]",
						"code": "039"
					},
					{
						"title": "Siam Commercial Bank Public Company Ltd. (SCB) [SICOTHBK]",
						"code": "014"
					},
					{
						"title": "Standard Chartered Bank (Thai) Public Co. Ltd. [SCBLTHBX]",
						"code": "020"
					},
					{
						"title": "Sumitomo Mitsui Banking Corporation [SMBCTHBK]",
						"code": "018"
					},
					{
						"title": "TISCO Bank Public Company Limited [TFPCTHB1]",
						"code": "067"
					},
					{
						"title": "TMB Bank Public Company Limited [TMBKTHBK]",
						"code": "011"
					},
					{
						"title": "Thanachart Bank Public Company Ltd. [THBKTHBK]",
						"code": "065"
					},
					{
						"title": "The Bank Of Tokyo-Mitsubishi Ufj, Ltd. [BOTKTHBX]",
						"code": "010"
					},
					{
						"title": "The Government Housing Bank [GOHUTHB1]",
						"code": "033"
					},
					{
						"title": "The Government Savings Bank [GSBATHBK]",
						"code": "030"
					},
					{
						"title": "The Royal Bank Of Scotland Plc, Bangkok Branch [ABNATHBK]",
						"code": "005"
					},
					{
						"title": "The Thai Credit Retail Bank Public Company Limited [THCETHB1]",
						"code": "071"
					},
					{
						"title": "United Overseas Bank (Thai) Public Company Limited [UOVBTHBK]",
						"code": "024"
					}
				]
			}
		});
})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.constant('authenticationConst', {
			AUTHENTICATION_STATE: {
				NOT_LOGIN: "NOT_LOGIN",
				TOKEN_EXPIRED: "TOKEN_EXPIRED",
				FAILED_RETREIVE_ACCOUNT_INTO: "FAILED_RETREIVE_ACCOUNT_INTO",
				FAILED_RE_AUTHENTICATE: "FAILED_RE_AUTHENTICATE",
				FAILED_SIGNUP: "FAILED_SIGNUP"
			},
			AUTH0_CONNECTION_TYPE: {
				FACEBOOK: "facebook",
				GOOGLE: "google-oauth2",
				USERNAME_PASSWORD: "Username-Password-Authentication"
			}
		});
})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.constant('accountConst', {
			ACCOUNT_TYPE: {
				PERSONAL: "personal",
				BUSINESS: "business",
				GUEST: "guest"
			},
			SOCIAL_TYPE: {
				FACEBOOK: "facebook",
				GOOGLE: "google"
			},
			ACCOUNT_ROLE: {
				CURATOR: "curator",
				CURATOR_INTERNAL: "curator_internal",
				MARKETER: "marketer",
				ADVERTISER: "advertiser"
			},
			AMBASSADORSHIP: {
				PRO: "pro",
				MAESTRO: "maestro"
			},
			BADGES: {
				CODES: {
					AMBASSADOR_PRO: "ABP",
					AMBASSADOR_MAESTRO: "ABM"
				}
			},
			FREE_EMAIL_LIST: /yahoo.com|gmail.com|facebook.com|outlook.com|aol.com|icloud.com/gi,
			OFFICE_TYPE: [{
					name: 'Head Office',
					id: 'head'
				},
				{
					name: 'Asia Pacific Office',
					id: 'flagship'
				},
				{
					name: 'Country Office',
					id: 'country'
				}
			],
			COMMISSION_RATE: {
				PIXERFER: 50,
				AMBASSADOR_PRO: 60,
				AMBASSADOR_MAESTRO: 70
			},
			INTERACT_TYPE: {
				LIKE: 'LIKE',
				FOLLOWING: 'FOLLOWING',
				FOLLOWER: 'FOLLOWER',
				LIKE_EVENT_POST: 'LIKE-EVENT-POST',
				LIKE_DISCUSSION: 'LIKE-DISCUSSION',
				REPLY_DISCUSSION: 'REPLY-DISCUSSION',
				REPLY_EVENT_POST: 'REPLY-EVENT-POST',
				LIKE_REPLY_DISCUSSION: 'LIKE-REPLY-DISCUSSION',
				LIST_INTERESTED_EVENT: 'LIST-INTERESTED-EVENT',
				LIST_JOINED_EVENT: 'LIST-JOINED-EVENT',
				LIST_INVITED_EVENT: 'LIST-INVITED-EVENT'
			},
			VERIFICATION_COOKIE: "email-verification-",
			ROLES: function () {
				return [{
						name: 'Marketer',
						id: this.ACCOUNT_ROLE.MARKETER
					},
					{
						name: 'Curator',
						id: this.ACCOUNT_ROLE.CURATOR
					},
					{
						name: 'Advertiser',
						id: this.ACCOUNT_ROLE.ADVERTISER
					}
				]
			},
			PROFILE: {
				SERVICES_RATE_MIN: 30,
				SERVICES_RATE_MAX: 15000
			},
			AGE: {
				MIN_AGE: 18,
				MAX_AGE: 100
			},
			TOKEN:{
				GUEST_USER_TOKEN: 'PIXERF.GUEST_USER_TOKEN',
				PAYMENT_INFO: "PAYMENT_INFO",
				PAYMENT_MENTHOD: "PAYMENT_MENTHOD",
				PAY_AFTER_SIGNED: "PAY_AFTER_SIGNED",
				SUBCRIBLE_NEWS_LETTER: "SUBCRIBLE_NEWS_LETTER",
				CREDIT_PLAN_AFTER_SIGNED_EMAIL: "CREDIT_PLAN_AFTER_SIGNED_EMAIL",
				CREDIT_PLAN_AFTER_SIGNED_PAGE: "CREDIT_PLAN_AFTER_SIGNED_PAGE",
				PAYMENT_EVENT_AFTER_SIGNED: "PAYMENT_EVENT_AFTER_SIGNED"
			}
		});
})();

(function () {

	angular
		.module('pixerf')
		.factory('pixerfBaseApiService', pixerfBaseApiService);

	pixerfBaseApiService.$inject = [];

	function pixerfBaseApiService() {
		var BaseSvc = function (apiName) {

		};
		BaseSvc.prototype = (function () {
			return {};
		})();
		return BaseSvc;
	}
})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.factory('pixerfApiUserSvc', pixerfApiUserSvc);

	pixerfApiUserSvc.$inject = ['$resource', 'pixerfUrl', 'accountUtils', 'photoGridUtils', 'fileUtils'];

	function pixerfApiUserSvc($resource, pixerfUrl, accountUtils, photoGridUtils, fileUtils) {
		return $resource(pixerfUrl.full + 'api/users/:id/:action', {}, {
			'me': {
				url: pixerfUrl.full + 'api/me',
				method: 'GET',
				params: {},
				interceptor: {
					response: function (response) {
						return accountUtils.transformUserData(response.data, response);
					}
				}
			},
			'get': {
				method: 'GET',
				params: {},
				interceptor: {
					response: function (response) {
						return accountUtils.transformUserData(response.data);
					}
				}
			},
			'getFlaggedUser': {
				url: pixerfUrl.full + 'api/users/flagged',
				method: 'GET',
				isArray: true,
				params: {},
				interceptor: {
					response: function (response) {
						return accountUtils.transformUserData(response.data);
					}
				}
			},
			'showUser': {
				url: pixerfUrl.full + 'api/users/exists',
				method: 'GET',
				params: {},
				interceptor: {
					response: function (response) {
						return accountUtils.transformUserData(response.data);
					}
				}
			},
			'update_cover': {
				method: 'POST',
				params: {
					action: 'cover'
				}
			},
			'search': {
				url: pixerfUrl.full + 'api/users/search',
				method: 'POST',
				isArray: true,
				params: {},
				interceptor: {
					response: function (response) {
						for (var i = 0; i < response.data.length; i++) {
							fileUtils.transforms(response.data[i].media);
							accountUtils.transformUserData(response.data[i]);
						}
						return response;
					}
				}
			},
			'isUserExisted': {
				method: 'GET',
				params: {
					action: 'exists'
				},
				interceptor: {
					response: function (response) {
						return response;
					}
				}
			},
			'getSuggestedProfiles': {
				method: 'GET',
				url: pixerfUrl.full + 'api/suggested_profiles',
				isArray: true,
				params: {},
				interceptor: {
					response: function (response) {
						for (var i = 0; i < response.data.length; i++) {
							accountUtils.transformUserData(response.data[i]);
						}
						return response;
					}
				}
			},
			'suggestedProfiles': {
				method: 'POST',
				url: pixerfUrl.full + 'api/suggested_profiles'
			},
			'unSuggestedProfiles': {
				method: 'DELETE',
				url: pixerfUrl.full + 'api/suggested_profiles/:id',
				interceptor: {
					response: function (response) {
						return response.data;
					}
				}
			},
			'get_medias': {
				method: "POST",
				isArray: true,
				params: {
					action: "media"
				},
				interceptor: {
					response: function (response) {
						photoGridUtils.transformMedias(response.data);
						return response;
					}
				}
			},
			'query': {
				isArray: true,
				interceptor: {
					response: function (response) {
						for (var i = 0; i < response.data.length; i++) {
							accountUtils.transformUserData(response.data[i]);
						}
						return response;
					}
				}
			},
			'patch': {
				method: 'PATCH',
				params: {},
				interceptor: {
					response: function (response) {
						return accountUtils.transformUserData(response.data);
					}
				}
			},
			'put': {
				method: 'PUT',
				params: {},
				interceptor: {
					response: function (response) {
						return accountUtils.transformUserData(response.data);
					}
				}
			},
			'isFollowed': {
				method: 'GET',
				params: {
					'action': 'is_followed'
				},
				interceptor: {
					response: function (response) {
						return response;
					}
				}
			},
			'change_password': {
				url: pixerfUrl.full + 'api/change_password',
				method: 'PUT'
			},
			'reset_password': {
				url: pixerfUrl.full + 'api/reset_password',
				method: 'PUT'
			},
			'toogle_ambassadorship': {
				method: 'PUT',
				url: pixerfUrl.full + 'api/users/:id/ambassador/:type',
				interceptor: {
					response: function (response) {
						return accountUtils.transformUserData(response.data);
					}
				}
			},
			'toogle_ban': {
				method: 'PUT',
				url: pixerfUrl.full + 'api/users/:id/toggle_ban',
			},
			'toogle_flag': {
				method: 'PUT',
				url: pixerfUrl.full + 'api/users/:id/toggle_flag',
				interceptor: {
					response: function (response) {
						return accountUtils.transformUserData(response.data);
					}
				}
			},
            'toogle_can_create_community': {
				method: 'PUT',
				url: pixerfUrl.full + 'api/users/:id/toggle_can_create_community',
				interceptor: {
					response: function (response) {
						return accountUtils.transformUserData(response.data);
					}
				}
			},
			'searchUserAffectionByName': {
				method: 'GET',
				url: pixerfUrl.full + 'api/users/:id/:action',
				params: {
					'keywords': '@keywords'
				},
				isArray: true,
				interceptor: {
					response: function (response) {
						for (var i = 0; i < response.data.length; i++) {
							accountUtils.transformUserData(response.data[i]);
						}
						return response;
					}
				}
			},
			'getSpecialities': {
				method: 'GET',
				url: pixerfUrl.full + 'api/resources/specialities',
				interceptor: {
					response: function (response) {
						return response.data;
					}
				}
			},
			'applyProfileService': {
				url: pixerfUrl.full + 'api/users/high_profile/:action',
				method: 'POST'
			},
			'approveProfileService': {
				url: pixerfUrl.full + 'api/users/:id/high_profile/:action',
				method: 'POST'
			},
			'rejectProfileService': {
				url: pixerfUrl.full + 'api/users/:id/high_profile/:action',
				method: 'POST'
			},
			'verify_user': {
				url: pixerfUrl.full + 'api/manage/send_email_verification',
				method: 'POST'
			},
			'search_all_users': {
				url: pixerfUrl.full + 'api/users/search',
				method: 'POST',
				isArray: true,
				interceptor: {
					response: function (response) {
						for (var i = 0; i < response.data.length; i++) {
							accountUtils.transformUserData(response.data[i]);
						}
						return response;
					}
				}
			},
            'transit_verification_status': {
                url: pixerfUrl.full + 'api/users/:id/transit_verification_status/:action',
				method: 'POST',
				interceptor: {
					response: function (response) {
						return accountUtils.transformUserData(response.data);
					}
				}
            }
		});
	}
})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.factory('pixerfApiTracking', pixerfApiTracking);

	pixerfApiTracking.$inject = ['$resource', 'pixerfUrl'];

	function pixerfApiTracking($resource, pixerfUrl) {
		return $resource(pixerfUrl.full + 'api/users/click_tracking', {}, {
			'action_tracking':{
				method: 'POST'
			}
		});
	}
})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.factory('pixerfApiSubscribeSvc', pixerfApiSubscribeSvc);

	pixerfApiSubscribeSvc.$inject = ['$resource', 'pixerfUrl'];

	function pixerfApiSubscribeSvc($resource, pixerfUrl) {
		return $resource(pixerfUrl.full + 'api/email_subscribers', {}, {
			'subscribe': {
				method: 'POST'
			}
		});
	}
})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.factory('pixerfApiSalesSvc', pixerfApiSalesSvc);

	pixerfApiSalesSvc.$inject = ['$resource', 'pixerfUrl', 'moment', 'pathUtils', 'stringUtils'];

	function pixerfApiSalesSvc($resource, pixerfUrl, moment, pathUtils, stringUtils) {
		function transform(item) {
			for (var i = 0; i < item.media.length; i++) {
				item.purchasedDateFormatted = moment(item.purchased_date).format("MMM D, YYYY");
				var media = item.media[i];
				if (!media.id || /\s/.test(media.id)) {
					//null id or it has any kind of whitespace
					Sentry.captureException(media);
				}
				media.url = pathUtils.buildFilePath(media.id, "x575", 'w');
				media.thumbnail = pathUtils.buildFilePath(media.id, "x150");
				media.license = stringUtils.capitalizeChar(media.license, 0);
				media.user.displayName = media.user.first_name + ' ' + media.user.last_name;
			}
		}

		function transforms(items) {
			for (var i = 0; i < items.length; i++) {
				transform(items[i]);
			}
		}

		return $resource(pixerfUrl.full + 'api/sales', {}, {
			'post': {
				method: 'POST',
				isArray: true,
				interceptor: {
					response: function (response) {
						transforms(response.data);
						return response;
					},
					responseError: function (response) {
						transforms(response.data);
						return response;
					}
				}
			},
			'get_earnings': {
				url: pixerfUrl.full + 'api/earnings',
				method: 'GET'
			},
			'getById': {
				url: pixerfUrl.full + 'api/sales/:orderId',
				method: 'GET',
				params: {},
				interceptor: {
					response: function (response) {
						transform(response.data);
						return response;
					}
				}
			},
			'get_credits': {
				url: pixerfUrl.full + 'api/credits',
				method: 'GET'
			}
		});
	}
})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.factory('pixerfApiPortfolioSvc', pixerfApiPortfolioSvc);

	pixerfApiPortfolioSvc.$inject = ['$resource', 'pixerfUrl', 'portfolioUtils'];

	function pixerfApiPortfolioSvc($resource, pixerfUrl, portfolioUtils) {

		function transformGalleriesData(galleries) {
			var gallery;
			for (var i = 0; i < galleries.length; i++) {
				gallery = galleries[i];
				transformGalleryData(gallery);
			}
			return galleries;
		}

		function transformGalleryData(gallery) {
			portfolioUtils.updateThumnailPath(gallery);
		}

		return $resource(pixerfUrl.full + 'api/portfolios/:id/:action/:photoid', {
			id: '@id'
		}, {
			'get': {
				method: 'GET',
				params: {},
				interceptor: {
					response: function (response) {
						return response;
					}
				}
			},
			'getById': {
				url: pixerfUrl.full + 'api/users/:userid/portfolios/:portfoliosid',
				method: 'GET',
				params: {},
				interceptor: {
					response: function (response) {
						return response;
					}
				}
			},
			'getUserPortfolios': {
				method: 'GET',
				url: pixerfUrl.full + 'api/users/:userid/portfolios',
				isArray: true,
				params: {},
				interceptor: {
					response: function (response) {
						response.data = transformGalleriesData(response.data);
						return response;
					}
				}
			}
		});
	}
})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.factory('pixerfApiPortfolioGallerySvc', pixerfApiPortfolioGallerySvc);

	pixerfApiPortfolioGallerySvc.$inject = ['$resource', 'pixerfUrl', 'portfolioUtils'];

	function pixerfApiPortfolioGallerySvc($resource, pixerfUrl, portfolioUtils) {

		return $resource(pixerfUrl.full + 'api/galleries/:id/:action/:photoid', {
			id: '@id'
		}, {
			'put': {
				url: pixerfUrl.full + 'api/galleries/:id',
				method: 'PUT',
				params: {},
				interceptor: {
					response: function (response) {
						return response;
					}
				}
			},
			'delete': {
				url: pixerfUrl.full + 'api/galleries/:id',
				method: 'DELETE',
				params: {},
				interceptor: {
					response: function (response) {
						return response;
					}
				}
			},
			'save': {
				url: pixerfUrl.full + 'api/galleries',
				method: 'POST',
				params: {
					type: 'portfolio'
				},
				interceptor: {
					response: function (response) {
						return response.data;
					}
				}
			}
		});
	}
})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.factory('pixerfApiPhotographerSvc', pixerfApiPhotographerSvc);

	pixerfApiPhotographerSvc.$inject = ['$resource', 'pixerfUrl', 'fileUtils', 'accountUtils'];

	function pixerfApiPhotographerSvc($resource, pixerfUrl, fileUtils, accountUtils) {
		function transforms(photographers) {
			for (var i = 0; i < photographers.length; i++) {
				fileUtils.transforms(photographers[i].media);
				accountUtils.transformUserData(photographers[i]);
			}
		}
		return $resource(pixerfUrl.full + 'api/users/:action', {}, {
			'get': {
				method: 'GET',
				params: {
					page_size: 10
				},
				isArray: true,
				interceptor: {
					response: function (response) {
						transforms(response.data);
						return response;
					}
				}
			}
		});
	}
})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.factory('pixerfApiPayoutMethodSvc', pixerfApiPayoutMethodSvc);

	pixerfApiPayoutMethodSvc.$inject = ['$resource', 'pixerfUrl', 'moment'];

	function pixerfApiPayoutMethodSvc($resource, pixerfUrl, moment) {
		function transform(item) {
			item.purchasedDateFormatted = moment(item.date).format("MMM D, YYYY");
			if (item.description && item.description.accountNumber) {
				item.description.bankAccount = transformBankAcc(item.description.accountNumber, 3, 3);
			}
		}

		function transformBankAcc(text, numberFirstLetter, numberLastLetter) {
			if (text.length > (numberFirstLetter + numberLastLetter)) {
				var firstText = text.substr(0, numberFirstLetter);
				var lastText = text.substr(text.length - numberLastLetter);
				var textReplaced = text.substr(numberFirstLetter, text.length - (numberFirstLetter + numberLastLetter)).replace(/[^\-]/g, '*');
				return firstText + textReplaced + lastText;
			} else {
				return text;
			}
		}

		function transforms(items) {
			for (var i = 0; i < items.length; i++) {
				transform(items[i]);
			}
		}

		return $resource(pixerfUrl.full + 'api/payout_methods/:id', {
			id: '@id'
		}, {
			'get': {
				method: 'GET',
				isArray: true
			},
			'put': {
				method: 'PUT',
				params: {}
			},
			'getTransactionHistory': {
				url: pixerfUrl.full + 'api/payouts/history',
				method: 'POST',
				isArray: true,
				interceptor: {
					response: function (response) {
						transforms(response.data);
						return response;
					}
				}
			},
			'request_payouts': {
				url: pixerfUrl.full + 'api/payouts',
				method: 'POST'
			},
		});
	}
})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.factory('pixerfApiPaymentSvc', pixerfApiPaymentSvc);

	pixerfApiPaymentSvc.$inject = ['$resource', 'pixerfUrl'];

	function pixerfApiPaymentSvc($resource, pixerfUrl) {
		return $resource(pixerfUrl.full + 'api/payment/:action', {}, {});
	}
})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.factory('pixerfApiOrdersSvc', pixerfApiOrdersSvc);

	pixerfApiOrdersSvc.$inject = ['$resource', 'pixerfUrl', 'moment', 'pathUtils', 'stringUtils'];

	function pixerfApiOrdersSvc($resource, pixerfUrl, moment, pathUtils, stringUtils) {
		function transform(item) {
			item.purchasedDateFormatted = moment(item.purchased_date).format("D MMM YYYY");
			if (!item.media || !item.media.length) return;
			for (var i = 0; i < item.media.length; i++) {
				if (item.payment && item.payment.payment_method) {
					item.payment.payment_method = transformPaymentMethod(item.payment.payment_method);
				}
				var media = item.media[i];
				if (!media.id || /\s/.test(media.id)) {
					//null id or it has any kind of whitespace
					Sentry.captureException(media);
				}
				media.url = pathUtils.buildFilePath(media.id, "x575", 'w');
				media.thumbnail = pathUtils.buildFilePath(media.id, "x150");
				media.license = stringUtils.capitalizeChar(media.license, 0);
				media.user.displayName = media.user.first_name + ' ' + media.user.last_name;
			}
		}

		function transforms(items) {
			for (var i = 0; i < items.length; i++) {
				transform(items[i]);
			}
		}

		function transformTransaction(item) {
			item.purchasedDateFormatted = moment(item.purchased_date).format("D MMM YYYY");
			item.payment_method = transformPaymentMethod(item.payment_method);
		}

		function transformPaymentMethod(method) {
			if (method == 'omise') {
				return 'Credit/Debit Card';
			} else if (method == 'paypal') {
				return 'PayPal';
			} else if (method == 'credit') {
				return 'Credit Plan';
			}
			return method;
		}

		function transformsTransactions(items) {
			for (var i = 0; i < items.length; i++) {
				transformTransaction(items[i]);
			}
		}

		return $resource(pixerfUrl.full + 'api/orders', {}, {
			'post': {
				method: 'POST',
				isArray: true,
				interceptor: {
					response: function (response) {
						transforms(response.data);
						return response;
					}
				}
			},
			'createFreeOrder': {
				url: pixerfUrl.full + 'api/orders/create_free_order',
				method: 'POST',
				interceptor: {
					response: function (response) {
						transforms(response.data);
						return response;
					}
				}
			},
			'getById': {
				url: pixerfUrl.full + 'api/orders/:orderId',
				method: 'GET',
				params: {},
				interceptor: {
					response: function (response) {
						transform(response.data);
						return response;
					}
				}
			},
			'getTransactionItems': {
				url: pixerfUrl.full + 'api/transactions',
				method: 'POST',
				isArray: true,
				interceptor: {
					response: function (response) {
						transformsTransactions(response.data);
						return response;
					}
				}
			},
		});
	}
})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.factory('pixerfApiNewsSvc', pixerfApiNewsSvc);

	pixerfApiNewsSvc.$inject = ['$resource', 'pixerfUrl'];

	function pixerfApiNewsSvc($resource, pixerfUrl) {

		return $resource(pixerfUrl.full + 'api/blog_posts', {}, {
			'get': {
				isArray: true,
				method: 'GET',
				interceptor: {
					response: function (response) {
						return response;
					}
				}
			},
			'save': {
				method: 'POST',
				interceptor: {
					response: function (response) {
						return response.data;
					}
				}
			},
			'delete': {
				url: pixerfUrl.full + 'api/blog_posts/:id',
				method: 'DELETE',
			},
			'update': {
				url: pixerfUrl.full + 'api/blog_posts/:id',
				method: 'PUT',
				interceptor: {
					response: function (response) {
						return response.data;
					}
				}
			}
		});
	}
})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.factory('pixerfApiMissionSvc', pixerfApiMissionSvc);

	pixerfApiMissionSvc.$inject = ['$resource', 'pixerfUrl', 'moment', 'pathUtils', 'accountUtils', 'galleryUtils', 'fileUtils', 'badgeUtils', 'priceUtils', 'missionConst'];

	function pixerfApiMissionSvc($resource, pixerfUrl, moment, pathUtils, accountUtils, galleryUtils, fileUtils, badgeUtils, priceUtils, missionConst) {
		function transformMedia(media) {
			if (media.user) accountUtils.transformUserData(media.user);

			media.url = media.thumbnails["360x"];
			media.urlSmall = media.thumbnails["x400"];
			media.urlMedium = media.thumbnails["x300"];
			media.thumbnail = media.thumbnails["w/1024x"];
			media.thumbnailX = media.thumbnails["1200x"];

			media.path = window.location.protocol + "//" + window.location.host + "/#/photo/" + media.id + "/" + fileUtils.buildFileSeoTitle(media);
		}

		function transformsMedias(medias) {
			for (var i = 0; i < medias.length; i++) {
				transformMedia(medias[i]);
			}
		}

		function transformParticipations(participations) {
			for (var i = 0; i < participations.length; i++) {
				transformMedia(participations[i]);
			}
		}

		function transformPrizes(prizes) {
			if (!prizes) return;
			for (var i = 0; i < prizes.length; i++) {
				var prize = prizes[i];

				var foundCustomPrize = missionConst.PAIR_TYPE.find(function (pair) {
					return pair.TYPE === prize.type && pair.NAME === prize.name;
				});

				if (foundCustomPrize) {
					prize.type = foundCustomPrize.LABEL;
				} else if (prize.type !== missionConst.TYPE.WINNER && prize.type !== missionConst.TYPE.CONSOLATION && prize.type !== missionConst.TYPE.SPECIAL_MENTION) {
					prize.type = missionConst.TYPE.WINNER;
				}

				if (prize.winner) {
					transformMedia(prizes[i].winner.media);
				}
				prize.value = parseFloat(prize.value);
			}
		}

		function transformPrice(price) {
			if (!price || !price.discounts) return;
			for (var i = 0; i < price.discounts.length; i++) {
				price.discounts[i].amount = priceUtils.calculateDiscountAmount(price.service_fee, price.discounts[i]);
			}
		}

		function transformPrices(prices) {
			if (!prices) return;
			for (var i = 0; i < prices.length; i++) {
				transformPrice(prices[i]);
			}
		}

		function transform(mission) {
			galleryUtils.updateThumnailPath(mission, true);
			if (mission.created_at) {
				mission.created_at = moment(mission.created_at).format("D MMM YYYY");
			}
			if (mission.media) {
				transformsMedias(mission.media);
			}
			if (mission.id === missionConst.GOJEK.MISSION_ID) {
				mission.is_goJek = true;
			}
			if (mission.id === 87) {
				mission.description_detect_language = 'en';
				mission.art_direction_detect_language = 'en';
				if(!mission.translations['id'] || !mission.translations['id'].description || !mission.translations['id'].art_direction){
					mission.translations = {
						'id': {
							description: '<p>Inisiatif baru kami yang bertajuk Tetap di Rumah, Tetap Kreatif mengajak para kreator untuk tetap melakukan hal yang paling mereka cintai &#8211;&#160;<em>memotret</em>, meski saat harus berdiam di rumah saja dalam upaya memutus mata rantai penularan virus Covid-19 sekalipun. Caranya mudah – dapatkan inspirasi dari benda-benda yang ada di sekitar Anda, gunakan kamera atau perangkat mobile, serta aplikasi digital favorit Anda, dan kerahkan segala kemampuan kreatif Anda.</p><p><br></p><p><strong>Misi foto yang pertama adalah #OutsideMyWindow! </strong>Kami menantang Anda untuk berkreasi dengan memotret pemandangan yang Anda lihat dari jendela atau pintu rumah Anda &#8211; untuk keamanan, pastikan Anda tetap berada di dalam rumah. Anda akan dinilai berdasarkan penyampaian cerita, komposisi dan editing yang Anda tampilkan. 20 karya yang paling ekspresif dan kreatif dalam misi #OutsideMyWindow ini berkesempatan memenangkan SGD 50 untuk masing-masing foto!</p><p><br></p><p>Pelajari lebih lanjut tentang inisiatif <strong>"Stay Home Stay Creative"</strong> dan misi mendatang lainnya disini: <a href="http://www.pixerf.com/#/stayhomestaycreative" class="text--color-pixerf-theme text--bold" style="color:#D50F67;" target="_blank">http://www.pixerf.com/#/stayhomestaycreative</a></p>',
							art_direction: '<p>Buatlah kami terpukau dengan kreativitas Anda!</p>'
						}
					}
				} else {
					mission.translations['id'].description = '<p>Inisiatif baru kami yang bertajuk Tetap di Rumah, Tetap Kreatif mengajak para kreator untuk tetap melakukan hal yang paling mereka cintai &#8211;&#160;<em>memotret</em>, meski saat harus berdiam di rumah saja dalam upaya memutus mata rantai penularan virus Covid-19 sekalipun. Caranya mudah – dapatkan inspirasi dari benda-benda yang ada di sekitar Anda, gunakan kamera atau perangkat mobile, serta aplikasi digital favorit Anda, dan kerahkan segala kemampuan kreatif Anda.</p><p><br></p><p><strong>Misi foto yang pertama adalah #OutsideMyWindow! </strong>Kami menantang Anda untuk berkreasi dengan memotret pemandangan yang Anda lihat dari jendela atau pintu rumah Anda &#8211; untuk keamanan, pastikan Anda tetap berada di dalam rumah. Anda akan dinilai berdasarkan penyampaian cerita, komposisi dan editing yang Anda tampilkan. 20 karya yang paling ekspresif dan kreatif dalam misi #OutsideMyWindow ini berkesempatan memenangkan SGD 50 untuk masing-masing foto!</p><p><br></p><p>Pelajari lebih lanjut tentang inisiatif <strong>"Stay Home Stay Creative"</strong> dan misi mendatang lainnya disini: <a href="http://www.pixerf.com/#/stayhomestaycreative" class="text--color-pixerf-theme text--bold" style="color:#D50F67;" target="_blank">http://www.pixerf.com/#/stayhomestaycreative</a></p>';
					mission.translations['id'].art_direction = '<p>Buatlah kami terpukau dengan kreativitas Anda!</p>'
				}

			}
			if([121, 122].includes(mission.id)){
				mission.environment = "Indoor and Outdoor";
				mission.orientation = "Landscape and Square";
			}
			if(mission.id === 121){
				mission.total_rewards = 898;
			}
			if(mission.id === 122){
				mission.total_rewards = 200;
			}
			if (mission.id === 88) {
				mission.description_detect_language = 'en';
				mission.art_direction_detect_language = 'en';
				if(!mission.translations['id'] || !mission.translations['id'].description || !mission.translations['id'].art_direction){
					mission.translations = {
						'id': {
							description: '<p>Makanan dapat menjadi sumber kenyamanan di masa sulit. Terlebih saat harus berdiam di rumah untuk menekan angka penyebaran Covid-19 seperti sekarang ini, kami yakin tak sedikit dari Anda yang mendokumentasikan beragam kreasi kuliner lezat ke dalam akun media sosial Anda. Mulai dari resep makanan tradisional favorit hingga menu kopi Dalgona yang kekinian, Anda dapat menunjukkan bahwa hidangan masakan rumah dapat terlihat senikmat rasanya!</p><p><br></p><p>Maka, untuk bagian ketiga dari program Stay Home, Stay Creative ini, kami menghadirkan tantangan #SuddenlyChef. Caranya mudah: abadikan sajian masakan rumah Anda yang paling impresif ke dalam sebuah foto. Tak masalah jika Anda tidak handal di dapur, Anda tetap dapat menampilkan hasil masakan teman, orang tua, atau saudara, pokoknya siapapun yang tinggal serumah dengan Anda!&#160;</p><p><br></p><p>Karena tak bisa mencicipi rasa makanan yang Anda hidangkan, kami akan menilai foto kiriman Anda berdasarkan aspek kreativitas, komposisi dan editing. Ini kiat agar foto Anda menonjol dari yang lain: beri tahu kami nama atau asal makanan yang Anda tampilkan di judul dan deskripsi foto. 20 foto terbaik berkesempatan memenangkan hadiah masing-masing sebesar SGD50! Siapkan alat masak Anda dan buatlah kami terpukau.&#160;</p><p><br></p><p>Untuk info lebih lanjut tentang program <strong>Stay Home Stay Creative</strong> atau tantangan seru berikutnya, kunjungi&#160;<a href="http://www.pixerf.com/#/stayhomestaycreative" class="text--color-pixerf-theme text--bold" style="color:#D50F67;" target="_blank">http://www.pixerf.com/#/stayhomestaycreative</a></p>',
							art_direction: '<p>Sajikan potret kreatif dan sedap dipandang mata yang akan menggoda selera kami.</p><p><br></p><p>·&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Hindari foto dengan pencahayaan yang buruk</p><p>·&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Jangan menggunakan terlalu banyak filter</p><p>·&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Pilih foto tanpa bingkai atau <i>watermark</i></p><p>·&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Pastikan foto yang Anda kirim relevan dengan Brief Misi, Arahan Kreatif dan Inspirasi Visual</p>'
						}
					}
				} else {
					mission.translations['id'].description = '<p>Makanan dapat menjadi sumber kenyamanan di masa sulit. Terlebih saat harus berdiam di rumah untuk menekan angka penyebaran Covid-19 seperti sekarang ini, kami yakin tak sedikit dari Anda yang mendokumentasikan beragam kreasi kuliner lezat ke dalam akun media sosial Anda. Mulai dari resep makanan tradisional favorit hingga menu kopi Dalgona yang kekinian, Anda dapat menunjukkan bahwa hidangan masakan rumah dapat terlihat senikmat rasanya!</p><p><br></p><p>Maka, untuk bagian ketiga dari program Stay Home, Stay Creative ini, kami menghadirkan tantangan #SuddenlyChef. Caranya mudah: abadikan sajian masakan rumah Anda yang paling impresif ke dalam sebuah foto. Tak masalah jika Anda tidak handal di dapur, Anda tetap dapat menampilkan hasil masakan teman, orang tua, atau saudara, pokoknya siapapun yang tinggal serumah dengan Anda!&#160;</p><p><br></p><p>Karena tak bisa mencicipi rasa makanan yang Anda hidangkan, kami akan menilai foto kiriman Anda berdasarkan aspek kreativitas, komposisi dan editing. Ini kiat agar foto Anda menonjol dari yang lain: beri tahu kami nama atau asal makanan yang Anda tampilkan di judul dan deskripsi foto. 20 foto terbaik berkesempatan memenangkan hadiah masing-masing sebesar SGD50! Siapkan alat masak Anda dan buatlah kami terpukau.&#160;</p><p><br></p><p>Untuk info lebih lanjut tentang program <strong>Stay Home Stay Creative</strong> atau tantangan seru berikutnya, kunjungi&#160;<a href="http://www.pixerf.com/#/stayhomestaycreative" class="text--color-pixerf-theme text--bold" style="color:#D50F67;" target="_blank">http://www.pixerf.com/#/stayhomestaycreative</a></p>';
					mission.translations['id'].art_direction = '<p>Sajikan potret kreatif dan sedap dipandang mata yang akan menggoda selera kami.</p><p><br></p><p>·&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Hindari foto dengan pencahayaan yang buruk</p><p>·&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Jangan menggunakan terlalu banyak filter</p><p>·&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Pilih foto tanpa bingkai atau <i>watermark</i></p><p>·&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Pastikan foto yang Anda kirim relevan dengan Brief Misi, Arahan Kreatif dan Inspirasi Visual</p>'
				}
			}
			if (mission.id === 89) {
				mission.description_detect_language = 'en';
				mission.art_direction_detect_language = 'en';
				if(!mission.translations['id'] || !mission.translations['id'].description || !mission.translations['id'].art_direction){
					mission.translations = {
						'id': {
							description: '<p>Pernahkah Anda menceritakan sebuah kisah yang membuat seseorang terus tertawa atau menangis saat mengingatnya? Kini, Anda dapat melakukannya tanpa memerlukan kata-kata!</p><p>&#160;</p><p>Sebagai misi keempat dan terakhir dalam program #StayHomeStayCreative, kami menantang Anda untuk menampilkan 4 foto yang dirangkum dalam sebuah seri #4framestories. Anda boleh memanfaatkan foto lama dari portofolio, mengambil gambar baru, atau menggabungkan keduanya. Anda ditantang untuk menyampaikan sebuah alur cerita yang menarik dengan 4 foto ini. Bayangkan saja seperti membuat storyboard untuk sebuah film pendek, di mana gambarnya terdiri dari foto-foto!</p><p>&#160;</p><p>Apa yang akan kami nilai? Tentu saja kemampuan Anda bercerita secara visual! Dapatkah kisah Anda memikat hati publik? Apakah cerita tersebut seru, mengejutkan, atau memberi kesan yang dalam? Semakin kreatif karya Anda, semakin besar kesempatan yang Anda miliki untuk menarik perhatian para juri.</p><p>&#160;</p><p>Berikut hadiah yang dapat Anda menangkan.</p><p>&#160;</p><p>Juara 1: SGD 400</p><p>Juara 2: SGD 250</p>Juara 3: SGD 150&#160;</p><p>&#160;</p><p>Empat finalis beruntung lainnya dengan karya yang menonjol juga akan menerima hadiah masing-masing sebesar $50.</p><p>&#160;</p><p>Sudah tak sabar untuk memenuhi tantangan ini? Perhatikan hal-hal berikut:&#160;</p><p>&#183;&#160;&#160;&#160;&#160;&#160;&#160;Satu peserta hanya dapat mengirimkan 1 seri yang terdiri dari 4 foto. Ini yang akan menjadi cerita Anda.&#160;</p><p>&#183;&#160;&#160;&#160;&#160;&#160;&#160;Setiap &#8216;seri cerita&#8217; harus terdiri dari 4 foto.&#160;</p><p>&#183;&#160;&#160;&#160;&#160;&#160;&#160;Tonjolkan daya imajinasi dan kreativitas Anda untuk menarik perhatian para juri!</p><p><br></p><p>Untuk info lebih lanjut tentang program <strong>Stay Home Stay Creative</strong> kunjungi <a href="http://www.pixerf.com/#/stayhomestaycreative" class="text--color-pixerf-theme text--bold" target="_blank">http://www.pixerf.com/#/stayhomestaycreative</a></p>',
							art_direction: '<p>Mulailah dengan membayangkan alur cerita yang ingin Anda sampaikan, lalu susun rencana dan pilih 4 foto yang dapat membantu Anda menuangkan kisah tersebut. Ingat, keberhasilan cerita Anda akan ditentukan oleh foto-foto ini!&nbsp;</p><p><br></p><p>·&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Hindari foto dengan pencahayaan yang buruk</p><p>·&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Jangan menggunakan terlalu banyak filter</p><p>·&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Pilih foto tanpa bingkai atau watermark</p><p>·&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Pastikan foto yang Anda kirim relevan dengan Brief Misi, Arahan Kreatif dan Inspirasi Visual</p>'
						}
					}
				} else {
					mission.translations['id'].description = '<p>Pernahkah Anda menceritakan sebuah kisah yang membuat seseorang terus tertawa atau menangis saat mengingatnya? Kini, Anda dapat melakukannya tanpa memerlukan kata-kata!</p><p>&#160;</p><p>Sebagai misi keempat dan terakhir dalam program #StayHomeStayCreative, kami menantang Anda untuk menampilkan 4 foto yang dirangkum dalam sebuah seri #4framestories. Anda boleh memanfaatkan foto lama dari portofolio, mengambil gambar baru, atau menggabungkan keduanya. Anda ditantang untuk menyampaikan sebuah alur cerita yang menarik dengan 4 foto ini. Bayangkan saja seperti membuat storyboard untuk sebuah film pendek, di mana gambarnya terdiri dari foto-foto!</p><p>&#160;</p><p>Apa yang akan kami nilai? Tentu saja kemampuan Anda bercerita secara visual! Dapatkah kisah Anda memikat hati publik? Apakah cerita tersebut seru, mengejutkan, atau memberi kesan yang dalam? Semakin kreatif karya Anda, semakin besar kesempatan yang Anda miliki untuk menarik perhatian para juri.</p><p>&#160;</p><p>Berikut hadiah yang dapat Anda menangkan.</p><p>&#160;</p><p>Juara 1: SGD 400</p><p>Juara 2: SGD 250</p>Juara 3: SGD 150&#160;</p><p>&#160;</p><p>Empat finalis beruntung lainnya dengan karya yang menonjol juga akan menerima hadiah masing-masing sebesar $50.</p><p>&#160;</p><p>Sudah tak sabar untuk memenuhi tantangan ini? Perhatikan hal-hal berikut:&#160;</p><p>&#183;&#160;&#160;&#160;&#160;&#160;&#160;Satu peserta hanya dapat mengirimkan 1 seri yang terdiri dari 4 foto. Ini yang akan menjadi cerita Anda.&#160;</p><p>&#183;&#160;&#160;&#160;&#160;&#160;&#160;Setiap &#8216;seri cerita&#8217; harus terdiri dari 4 foto.&#160;</p><p>&#183;&#160;&#160;&#160;&#160;&#160;&#160;Tonjolkan daya imajinasi dan kreativitas Anda untuk menarik perhatian para juri!</p><p><br></p><p>Untuk info lebih lanjut tentang program <strong>Stay Home Stay Creative</strong> kunjungi <a href="http://www.pixerf.com/#/stayhomestaycreative" class="text--color-pixerf-theme text--bold" target="_blank">http://www.pixerf.com/#/stayhomestaycreative</a></p>';
					mission.translations['id'].art_direction = '<p>Mulailah dengan membayangkan alur cerita yang ingin Anda sampaikan, lalu susun rencana dan pilih 4 foto yang dapat membantu Anda menuangkan kisah tersebut. Ingat, keberhasilan cerita Anda akan ditentukan oleh foto-foto ini!&nbsp;</p><p><br></p><p>·&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Hindari foto dengan pencahayaan yang buruk</p><p>·&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Jangan menggunakan terlalu banyak filter</p><p>·&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Pilih foto tanpa bingkai atau watermark</p><p>·&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Pastikan foto yang Anda kirim relevan dengan Brief Misi, Arahan Kreatif dan Inspirasi Visual</p>';
				}
			}
			transformPrizes(mission.prizes);

			mission.prizes_grouped = badgeUtils.compactPrizes(mission.prizes);

			if (mission.price && mission.price.id == -1) {
				mission.price.duration = mission.duration;
			}
			transformPrices(mission.prices);
			transformPrice(mission.price);

			mission.bill = buildMissionBill(mission);
			if (mission.organization) {
				if (mission.organization.profile_image || mission.organization.profile_image_list) {
					var profileImageUrl = "";
					var profileImageListUrl = "";
					if (!mission.organization.profile_image || /\s/.test(mission.organization.profile_image)) {
						//null id or it has any kind of whitespace
						Sentry.captureException(mission);
					}
					if (mission.organization.profile_image_media) {
						profileImageUrl = mission.organization.profile_image_media["x200"];
					} else if (mission.organization.profile_image) {
						profileImageUrl = pathUtils.buildFilePath(mission.organization.profile_image, "x200", "h");
					}
					if (mission.organization.profile_image_list) {
						profileImageListUrl = pathUtils.buildFilePath(mission.organization.profile_image_list, "x60", "h");
					}
					mission.organization.profileImageUrl = profileImageUrl ? profileImageUrl : profileImageListUrl;
					mission.organization.profileImageListUrl = profileImageListUrl ? profileImageListUrl : profileImageUrl;
				}
			}
			if (mission.sponsor) {
				var logoUrlList = mission.sponsor_profile_image_media && mission.sponsor_profile_image_media["x200"] ? mission.sponsor_profile_image_media["x200"] : mission.sponsor.profile_image_list;
				var logoUrl = mission.sponsor_profile_image_media && mission.sponsor_profile_image_media["x200"] ? mission.sponsor_profile_image_media["x200"] : mission.sponsor.profile_image;

				mission.sponsor.logoUrlList = logoUrlList ? logoUrlList : logoUrl;
				mission.sponsor.logoUrl = logoUrl ? logoUrl : logoUrlList;
			}
		}

		function buildMissionBill(mission) {
			if (!mission.price) {
				mission.price = {};
			}
			return {
				totalToPay: mission.prizes_grouped.totalReward + (mission.price.service_fee ? priceUtils.calculatePriceAfterDiscount(mission.price.service_fee, mission.price.discounts) : 0)
			}
		}

		function transforms(missions) {
			for (var i = 0; i < missions.length; i++) {
				transform(missions[i]);
			}
		}

		function transformMissionAward(mission) {
			mission.winner.url = mission.winner.thumbnails["360x"];
			mission.winner.urlSmall = mission.winner.thumbnails["x400"];
			mission.winner.urlMedium = mission.winner.thumbnails["x300"];
			mission.winner.thumbnail = mission.winner.thumbnails["w/1024x"];
			mission.winner.badges = badgeUtils.transformBadges(mission.winner.badges);
		}

		return $resource(pixerfUrl.full + 'api/missions/:id/:action/:participation_id', {}, {
			'get': {
				method: 'GET',
				interceptor: {
					response: function (response) {
						transform(response.data.mission);
						return response.data;
					}
				}
			},
			'get_manage_mission': {
				url: pixerfUrl.full + 'api/missions/manage',
				interceptor: {
					response: function (response) {
						transforms(response.data.missions);
						return response;
					}
				}
			},
			'query': {
				method: 'GET',
				interceptor: {
					response: function (response) {
						transforms(response.data.missions);
						return response;
					}
				}
			},
			'get_participations': {
				method: 'GET',
				isArray: true,
				params: {
					action: 'participations'
				},
				interceptor: {
					response: function (response) {
						transformParticipations(response.data);
						return response;
					}
				}
			},
			'submit_participations': {
				isArray: true,
				method: 'POST',
				params: {
					action: 'participations',
					participation_id: 'many'
				}
			},
			'update_participations': {
				isArray: true,
				method: 'PUT',
				params: {
					action: 'participations',
					participation_id: 'many'
				}

			},
			'create': {
				method: 'POST',
				interceptor: {
					response: function (response) {
						if (response.data.mission) {
							transform(response.data.mission);
						}
						return response.data;
					}
				}
			},
			'curation_mission': {
				url: pixerfUrl.full + 'api/missions/:mission_id/participations/:participations_id/curate',
				method: 'PUT',
				interceptor: {
					response: function (response) {
						return response.data;
					}
				}
			},
			'update': {
				method: 'PUT',
				params: {},
				interceptor: {
					response: function (response) {
						if (response.data.mission) {
							transform(response.data.mission);
						}
						return response.data;
					}
				}
			},
			'launch': {
				method: 'PUT',
				params: {
					id: '@id',
					action: 'launch'
				},
				interceptor: {
					response: function (response) {
						return response.data;
					}
				}
			},
			'submit_process': {
				url: pixerfUrl.full + 'api/missions/:id/launching_process/submit',
				method: 'PUT',
				params: {
					id: '@id'
				},
				interceptor: {
					response: function (response) {
						return response.data;
					}
				}
			},
			'review_process': {
				url: pixerfUrl.full + 'api/missions/:id/launching_process/:action',
				method: 'PUT',
				params: {
					id: '@id',
					action: '@action'
				},
				interceptor: {
					response: function (response) {
						return response.data;
					}
				}
			},
			'addInspirationImages': {
				params: {
					action: 'inspiration'
				},
				method: 'POST'
			},
			'agree_agreement': {
				params: {
					action: 'agree'
				},
				method: 'POST'
			},
			'winner': {
				params: {
					action: 'winner'
				},
				method: 'POST',
				interceptor: {
					response: function (response) {
						transform(response.data.mission);
						return response.data;
					}
				}
			},
			'remove_winner': {
				url: pixerfUrl.full + 'api/missions/:id/winner/:prize_id',
				method: 'DELETE',
				interceptor: {
					response: function (response) {
						transform(response.data.mission);
						return response.data;
					}
				}
			},
			'finalize': {
				url: pixerfUrl.full + 'api/missions/:id/finalize',
				method: 'PUT',
				interceptor: {
					response: function (response) {
						transform(response.data.mission);
						return response.data;
					}
				}
			},
			'get_prices': {
				url: pixerfUrl.full + 'api/mission_prices',
				method: 'GET',
				isArray: true,
				interceptor: {
					response: function (response) {
						transformPrices(response.data);
						return response.data;
					}
				}
			},
			'get_maximum_uploads': {
				url: pixerfUrl.full + 'api/missions/:id/participations/submissions_balance',
				method: 'GET',
				interceptor: {
					response: function (response) {
						return response.data;
					}
				}
			},
			'pending_submission_mission': {
				url: pixerfUrl.full + 'api/missions/:id/participations/pending',
				isArray: true,
				method: 'GET',
				interceptor: {
					response: function (response) {
						transformParticipations(response.data);
						return response;
					}
				}
			},
			'rejected_submission_mission': {
				url: pixerfUrl.full + 'api/missions/:id/participations/rejected_from_mission',
				isArray: true,
				method: 'GET',
				interceptor: {
					response: function (response) {
						transformParticipations(response.data);
						return response;
					}
				}
			},
			'pending_photo_mission': {
				url: pixerfUrl.full + 'api/users/:userId/participations',
				isArray: true,
				method: 'GET',
				interceptor: {
					response: function (response) {
						transformParticipations(response.data);
						return response;
					}
				}
			},
			'manage_award_photo_mission': {
				url: pixerfUrl.full + 'api/users/:userId/prizes',
				isArray: true,
				method: 'GET',
				interceptor: {
					response: function (response) {
						for (var i = 0; i < response.data.length; i++) {
							transformMissionAward(response.data[i]);
						}
						return response;
					}
				}
			},
			'get_pending_in_missions': {
				url: pixerfUrl.full + 'api/participations/pending',
				isArray: true,
				method: 'GET',
				interceptor: {
					response: function (response) {
						transformParticipations(response.data);
						return response;
					}
				}
			},
			'get_rejected_in_missions': {
				url: pixerfUrl.full + 'api/participations/rejected',
				isArray: true,
				method: 'GET',
				interceptor: {
					response: function (response) {
						transformParticipations(response.data);
						return response;
					}
				}
			},
			'delete':{
				method: 'DELETE'
			},
			'delete_many':{
				url: pixerfUrl.full + 'api/missions/:id/participations/delete_many',
				method: 'POST'
			}
		});
	}
})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.factory('pixerfApiMediaSvc', pixerfApiMediaSvc);

	pixerfApiMediaSvc.$inject = ['$resource', 'pixerfUrl', 'accountUtils', 'fileUtils', 'sessionManagerSvc'];

	function pixerfApiMediaSvc($resource, pixerfUrl, accountUtils, fileUtils, sessionManagerSvc) {

		return $resource(pixerfUrl.full + 'api/media/:id/:action/:commentid/:api_version', {
			id: '@id'
		}, {
			'get_clarifai': {
				method: 'GET',
				params: {
					action: 'clarifai'
				}
			},
			'delete_by_handles': {
				url: pixerfUrl.full + 'api/media/handles/:handles',
				method: 'DELETE',
				interceptor: {
					response: function (response) {
						return response;
					}
				}
			},
			'get': {
				method: 'GET',
				interceptor: {
					response: function (response) {
						fileUtils.transform(response.data);
						return response;
					}
				}
			},
			'update': {
				method: 'PUT'
			},
			'multipleUpdate': {
				params: {
					action: 'many'
				},
				method: 'PUT',
				isArray: true
			},
			'getComment': {
				url: pixerfUrl.full + 'api/media/:id/:action/:commentid',
				params: {
					action: 'comments'
				},
				method: 'GET',
				isArray: true,
				interceptor: {
					response: function (response) {
						if (response.data.length > 0) {
							for (var i = 0; i < response.data.length; i++) {
								accountUtils.transformUserData(response.data[i].user);
							}
						}
						return response;
					}
				}
			},
			'createComment': {
				url: pixerfUrl.full + 'api/media/:id/:action/:commentid',
				params: {
					action: 'comments'
				},
				method: 'POST'
			},
			'editComment': {
				params: {
					action: 'comments'
				},
				method: 'PUT'
			},
			'deleteComment': {
				params: {
					action: 'comments'
				},
				method: 'DELETE'
			},
			'getLikes': {
				params: {
					action: 'likes'
				},
				method: 'GET',
				isArray: true,
				interceptor: {
					response: function (response) {
						if (response.data.length > 0) {
							for (var i = 0; i < response.data.length; i++) {
								accountUtils.transformUserData(response.data[i]);
							}
						}
						return response;
					}
				}
			},
			'nominate': {
				params: {
					action: 'nominations'
				},
				method: 'POST'
			},
			'star': {
				params: {
					action: 'stars'
				},
				method: 'POST'
			},
			'delete_star': {
				params: {
					action: 'stars'
				},
				method: 'DELETE'
			},
			'search': {
				method: 'POST',
				params: {
					action: 'search'
				},
				isArray: true,
				interceptor: {
					response: function (response) {
						fileUtils.transforms(response.data);
						return response;
					}
				}
			},
			'getTemporary': {
				method: 'GET',
				url: pixerfUrl.full + 'api/media/temporary',
				isArray: true,
				interceptor: {
					response: function (response) {
						fileUtils.transforms(response.data);
						return response;
					}
				}
			},
			'getSimilar': {
				method: 'GET',
				params: {
					action: 'more_like_this'
				},
				isArray: true,
				interceptor: {
					response: function (response) {
						fileUtils.transforms(response.data);
						return response;
					}
				}
			},
			'send_release_form': {
				url: pixerfUrl.full + 'api/release',
				method: 'POST'
			},
			'upload_release_form': {
				url: pixerfUrl.full + 'api/media/release',
				method: 'POST'
			},
			'upload': {
				url: 'https://qa2.pixerf.com/api/v2/media/store',
				method: 'POST',
				headers: {
					"Authorization": "Bearer " + sessionManagerSvc.getToken()
				},
			},
			'upload_to_mission': {
				url: pixerfUrl.full + 'api/missions/:mission_id/participations/upload',
				method: 'POST'
			},
			'get_release_form': {
				url: pixerfUrl.full + 'api/media/releases',
				method: 'GET'
			},
			'request_release_form': {
				url: pixerfUrl.full + 'api/media/releases/reminder',
				method: 'POST',
				interceptor: {
					responseError: function (response) {
						return response.data;
					}
				}
			},
            'download_release_by_id':{
                url: pixerfUrl.full + 'api/media/releases/:id/prepare_download',
				method: 'POST',
                interceptor: {
					responseError: function (response) {
						return response.data;
					}
				}
            },
			'review': {
				method: 'PUT',
				params: {
					action: 'review'
				}
			},
			'price_range': {
				url: pixerfUrl.full + 'api/media/:handle/price_range',
				method: 'GET',
				isArray: true
			},
			'add_to_gallery': {
				url: pixerfUrl.full + 'api/media/:id/add_to_gallery/:gallery_id',
				method: 'PUT'
			},
			'remove_from_gallery': {
				url: pixerfUrl.full + 'api/media/:id/remove_from_gallery/:gallery_id',
				method: 'DELETE'
			},
			'removeFromPortfolioGallery': {
				url: pixerfUrl.full + 'api/media/:id/remove_from_portfolio_gallery/:portfolio_gallery_id',
				method: 'DELETE',
				interceptor: {
					responseError: function (response) {
						return response;
					}
				}
			},
			'reject_reasons': {
				url: pixerfUrl.full + 'api/media/reject_reasons',
				method: 'GET',
				isArray: true
			},
			'get_showcased_gallery': {
				url: pixerfUrl.full + 'api/showcased_gallery',
				method: 'GET',
				isArray: true,
				interceptor: {
					response: function (response) {
						fileUtils.transforms(response.data);
						return response;
					}
				}
			},
			'set_showcased_gallery': {
				url: pixerfUrl.full + 'api/showcased_gallery',
				method: 'PUT'
			},
			'remove_showcased_gallery': {
				url: pixerfUrl.full + 'api/showcased_gallery',
				method: 'DELETE'
			},
			'overrideUnstar': {
				url: pixerfUrl.full + 'api/media/:media_id/stars/:id',
				method: 'DELETE'
			},
			'get_stars': {
				url: pixerfUrl.full + 'api/media/:id/stars',
				method: 'GET',
				isArray: true,
				interceptor: {
					response: function (response) {
						for (var i = 0; i < response.data.length; i++) {
							accountUtils.transformUserData(response.data[i].user);
						}
						return response;
					}
				}
			},
		});
	}
})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.factory('pixerfApiMailSvc', pixerfApiMailSvc);

	pixerfApiMailSvc.$inject = ['$resource', 'pixerfUrl'];

	function pixerfApiMailSvc($resource, pixerfUrl) {
		return $resource(pixerfUrl.full + 'api/send_email_verification', {}, {
			'resend': {
				method: 'POST'
			},
			'enquire': {
				url: pixerfUrl.full + 'api/enquire',
				method: 'POST'
			},
			'request_license': {
				url: pixerfUrl.full + 'api/media/:id/request_license',
				params: {
					id: '@id'
				},
				method: 'POST'
			}
		});
	}
})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.factory('pixerfApiKeywordSvc', pixerfApiKeywordSvc);

	pixerfApiKeywordSvc.$inject = ['$resource', 'pixerfUrl'];

	function pixerfApiKeywordSvc($resource, pixerfUrl) {
		function transform(keywords) {
			return _.reduce(keywords, function (memo, keyword) {
				memo.push(keyword.trim());
				return memo;
			}, []);
		}
		return $resource(pixerfUrl.full + 'api/thesaurus', {}, {
			'query': {
				interceptor: {
					response: function (response) {
						return transform(response.data.data);
					}
				},
				isArray: false
			}
		});
	}
})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.factory('pixerfApiGallerySvc', pixerfApiGallerySvc);

	pixerfApiGallerySvc.$inject = ['$resource', 'pixerfUrl', 'accountUtils', 'galleryUtils', 'photoGridUtils'];

	function pixerfApiGallerySvc($resource, pixerfUrl, accountUtils, galleryUtils, photoGridUtils) {
		function transformGalleriesData(galleries) {
			var gallery;
			for (var i = 0; i < galleries.length; i++) {
				gallery = galleries[i];
				transformGalleryData(gallery);
			}
			return galleries;
		}

		function transformGalleryData(gallery) {
			galleryUtils.updateThumnailPath(gallery);
			accountUtils.transformUserData(gallery.user);
		}
		return $resource(pixerfUrl.full + 'api/galleries/:id/:action/:photoid', {
			id: '@id'
		}, {
			'query': {
				method: 'GET',
				isArray: true,
				params: {},
				interceptor: {
					response: function (response) {
						if (response.data.length > 0) {
							response.data = transformGalleriesData(response.data);
						}
						return response;
					}
				}
			},
			'get_medias': {
				isArray: true,
				params: {
					action: "media"
				},
				interceptor: {
					response: function (response) {
						photoGridUtils.transformMedias(response.data);
						return response;
					}
				}
			},
			'getUserGalleries': {
				method: 'GET',
				url: pixerfUrl.full + 'api/users/:userid/galleries',
				isArray: true,
				params: {},
				interceptor: {
					response: function (response) {
						if (response.data.length > 0) {
							response.data = transformGalleriesData(response.data);
						}
						return response;
					}
				}
			},
			'get': {
				method: 'GET',
				params: {},
				interceptor: {
					response: function (response) {
						if (response.data) {
							transformGalleryData(response.data);
						}
						return response;
					}
				}
			},
			'put': {
				method: 'PUT',
				params: {},
				interceptor: {
					response: function (response) {
						if (response.data) {
							transformGalleryData(response.data);
						}
						return response;
					}
				}
			},
			'save': {
				method: 'POST',
				params: {},
				interceptor: {
					response: function (response) {
						if (response.data) {
							transformGalleryData(response.data);
						}
						return response.data;
					}
				}
			},
			'star': {
				params: {
					action: 'stars'
				},
				method: 'POST'
			},
			'delete_star': {
				params: {
					action: 'stars'
				},
				method: 'DELETE'
			},
			'get_stars': {
				url: pixerfUrl.full + 'api/galleries/:id/stars',
				method: 'GET',
				isArray: true,
				interceptor: {
					response: function (response) {
						for (var i = 0; i < response.data.length; i++) {
							accountUtils.transformUserData(response.data[i].user);
						}
						return response;
					}
				}
			},
			'toggle_signature': {
				url: pixerfUrl.full + 'api/galleries/:id/toggle_signature',
				params: {},
				method: 'POST'
			},
			'overrideUnstar': {
				url: pixerfUrl.full + 'api/galleries/:gallery_id/stars/:id',
				method: 'DELETE'
			},
			'getMoreLikeThis': {
				url: pixerfUrl.full + 'api/galleries/:id/more_like_this',
				method: 'GET',
				isArray: true,
				interceptor: {
					response: function (response) {
						for (var i = 0; i < response.data.length; i++) {
							accountUtils.transformUserData(response.data[i].user);
							galleryUtils.updateThumnailPath(response.data[i]);
						}
						return response;
					}
				}
			}
		});
	}
})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.factory('pixerfApiFinanceSvc', pixerfApiFinanceSvc);

	pixerfApiFinanceSvc.$inject = ['$resource', 'pixerfUrl'];

	function pixerfApiFinanceSvc($resource, pixerfUrl) {

		function transformTransaction(item) {
			item.request_date = moment(item.request_date).format("D MMM YYYY");
		}

		function transformTransactions(items) {
			for (var i = 0; i < items.length; i++) {
				transformTransaction(items[i]);
			}
		}

		return $resource(pixerfUrl.full + 'api/payouts/:id/:action', {}, {
			'list_payouts': {
				method: 'GET',
				isArray: true,
				interceptor: {
					response: function (response) {
						transformTransactions(response.data);
						return response;
					}
				}
			},
			'mark_as_complete': {
				method: 'PUT',
				params: {
					action: 'toggle_complete'
				},
				interceptor: {
					response: function (response) {
						return response;
					}
				}
			}
		});
	}
})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.factory('pixerfApiFileSvc', pixerfApiFileSvc);

	pixerfApiFileSvc.$inject = ['$resource'];

	function pixerfApiFileSvc($resource) {
		return $resource('/:path', {}, {

		});
	}
})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.factory('pixerfApiEventSvc', pixerfApiEventSvc);

	pixerfApiEventSvc.$inject = ['$resource', 'pixerfUrl', 'accountUtils'];

	function pixerfApiEventSvc($resource, pixerfUrl, accountUtils) {

		function genDisplayName(datas) {
			if (datas && datas.length) {
				for (var i = 0; i < datas.length; i++) {
					datas[i].displayName = accountUtils.buildUserDisplayName(datas[i]);
					datas[i].avatar = accountUtils.buildUserAvatarPhotoUrl(datas[i]);
				}
			} else {
                datas.displayName = accountUtils.buildUserDisplayName(datas);
				datas.avatar = accountUtils.buildUserAvatarPhotoUrl(datas);
            }

			return datas;
		}

		return $resource(pixerfUrl.full + 'api/community_events/:id/:action', {
			id: '@id'
		}, {
			'get': {
				method: 'GET',
				interceptor: {
					response: function (response) {
						response.data.joined_users = genDisplayName(response.data.joined_users);
						response.data.interested_users = genDisplayName(response.data.interested_users);
						response.data.owner = genDisplayName(response.data.owner);
						return response;
					}
				}
			},
			'create': {
				url: pixerfUrl.full + 'api/communities/:community_id/community_events',
				method: 'POST',
				interceptor: {
					response: function (response) {
						return response;
					}
				}
			},
			'removeMembers': {
				url: pixerfUrl.full + 'api/community_events/:event_id/remove_members',
				method: 'POST',
				interceptor: {
					response: function (response) {
						return response;
					}
				}
			},
			'update': {
				url: pixerfUrl.full + 'api/community_events/:id',
				method: 'PUT',
				interceptor: {
					response: function (response) {
						return response;
					}
				}
			},
			'update_many': {
				url: pixerfUrl.full + 'api/community_events/update_many',
				method: 'POST',
				isArray: true,
				interceptor: {
					response: function (response) {
						return response;
					}
				}
			},
			'getEvents': {
				url: pixerfUrl.full + 'api/communities/:community_id/community_events',
				method: 'GET',
				isArray: true,
				interceptor: {
					response: function (response) {
						return response;
					}
				}
			},
			'getAllEvent': {
				url: pixerfUrl.full + 'api/community/all_events',
				method: 'GET',
				isArray: true,
				interceptor: {
					response: function (response) {
						if (response && response.data && response.data.length) {
							for (var i = 0; i < response.data.length; i++) {
								response.data[i].owner.displayName = accountUtils.buildUserDisplayName(response.data[i].owner);
							}
						}
						return response;
					}
				}
			},
			'getEventAttendees': {
				url: pixerfUrl.full + 'api/community_events/:id/responses',
				method: 'GET',
				isArray: true,
				interceptor: {
					response: function (response) {
						return response;
					}
				}
			},
			'getEventInvited': {
				url: pixerfUrl.full + 'api/community_events/:id/invites',
				method: 'GET',
				isArray: true,
				interceptor: {
					response: function (response) {
						return response;
					}
				}
			},
			'toggleJoin': {
				url: pixerfUrl.full + 'api/community_events/:id/toggle_join',
				method: 'POST',
				interceptor: {
					response: function (response) {
						response.data.joined_users = genDisplayName(response.data.joined_users);
						response.data.interested_users = genDisplayName(response.data.interested_users);
						response.data.owner.displayName = accountUtils.buildUserDisplayName(response.data.owner);
						return response;
					}
				}
			},
			'toggleInterest': {
				url: pixerfUrl.full + 'api/community_events/:id/toggle_interest',
				method: 'POST',
				interceptor: {
					response: function (response) {
						response.data.joined_users = genDisplayName(response.data.joined_users);
						response.data.interested_users = genDisplayName(response.data.interested_users);
						response.data.owner.displayName = accountUtils.buildUserDisplayName(response.data.owner);
						return response;
					}
				}
			},
			'invite': {
				method: 'POST',
				params: {
					action: 'invite'
				},
				interceptor: {
					response: function (response) {
						return response;
					}
				}
			},
			'deleteEventInvite': {
				url: pixerfUrl.full + 'api/community_events/:community_id/invites/:event_id',
				method: 'DELETE',
				interceptor: {
					response: function (response) {
						return response;
					}
				}
			},
			'deleteEventMemberInvite': {
				url: pixerfUrl.full + 'api/community_events/:event_id/invites/:id',
				method: 'DELETE',
				interceptor: {
					response: function (response) {
						return response;
					}
				}
			},
			'decline_invitation': {
				url: pixerfUrl.full + 'api/community_events/:id/decline_invitation ',
				method: 'POST',
				interceptor: {
					response: function (response) {
						return response;
					}
				}
			},
			'get_hosting_events': {
				url: pixerfUrl.full + 'api/users/:id/events',
				method: 'GET',
				params: {
					type: 'hosting'
				},
				isArray: true,
				interceptor: {
					response: function (response) {
						for (var i = 0; i < response.data.length; i++) {
							response.data[i].owner.displayName = accountUtils.buildUserDisplayName(response.data[i].owner);
						}
						return response;
					}
				}
			},
			'get_joined_events': {
				url: pixerfUrl.full + 'api/users/:id/events',
				method: 'GET',
				params: {
					membership_status: 'joined'
				},
				isArray: true,
				interceptor: {
					response: function (response) {
						for (var i = 0; i < response.data.length; i++) {
							response.data[i].owner.displayName = accountUtils.buildUserDisplayName(response.data[i].owner);
						}
						return response;
					}
				}
			},
			'get_invited_events': {
				url: pixerfUrl.full + 'api/users/:id/events',
				method: 'GET',
				params: {
					membership_status: 'invited'
				},
				isArray: true,
				interceptor: {
					response: function (response) {
						return response;
					}
				}
			},
			'get_interested_events': {
				url: pixerfUrl.full + 'api/users/:id/events',
				method: 'GET',
				params: {
					membership_status: 'interested'
				},
				isArray: true,
				interceptor: {
					response: function (response) {
						return response;
					}
				}
			},
			'get_drafts_events': {
				url: pixerfUrl.full + 'api/users/:id/events',
				method: 'GET',
				params: {
					event_statuses: 'draft'
				},
				isArray: true,
				interceptor: {
					response: function (response) {
						return response;
					}
				}
			},
			'get_past_events': {
				url: pixerfUrl.full + 'api/users/:id/events',
				method: 'GET',
				params: {
					membership_status: 'joined'
				},
				isArray: true,
				interceptor: {
					response: function (response) {
						return response;
					}
				}
			},
			'delete_photo_community_event':{
				url: pixerfUrl.full + 'api/community_events/photos/:id',
				method: 'DELETE',
				interceptor: {
					response: function (response) {
						return response.data;
					}
				}	
			},
			'getEventPhotos': {
				url: pixerfUrl.full + 'api/community_events/:id/all_photos',
				method: 'GET',
				isArray: true,
				interceptor: {
					response: function (response) {
						return response;
					}
				}
			},
			'deleteEvent': {
				url: pixerfUrl.full + 'api/community_events/:id',
				method: 'DELETE',
				interceptor: {
					response: function (response) {
						return response;
					}
				}
			}
		});
	}
})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.factory('pixerfApiDownloadSvc', pixerfApiDownloadSvc);

	pixerfApiDownloadSvc.$inject = ['$resource', 'pixerfUrl'];

	function pixerfApiDownloadSvc($resource, pixerfUrl) {
		return $resource(pixerfUrl.full + 'api/prepare_download', {}, {
			'order_receipt': {
				method: 'POST',
				interceptor: {
					response: function (response) {
						return response;
					}
				}
			},
			'transaction_receipt': {
				url: pixerfUrl.full + 'api/prepare_download_transaction_receipt',
				method: 'POST',
				interceptor: {
					response: function (response) {
						return response;
					}
				}
			},
			'record_biz_download':{
				url: pixerfUrl.full + 'api/media/create_comp_download',
				method: 'POST',
				interceptor: {
					response: function (response) {
						return response;
					}
				}
			}
		});
	}
})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.factory('pixerfApiCustomCommssionsSvc', pixerfApiCustomCommssionsSvc);

	pixerfApiCustomCommssionsSvc.$inject = ['$resource', 'pixerfUrl', 'accountUtils'];

	function pixerfApiCustomCommssionsSvc($resource, pixerfUrl, accountUtils) {

		return $resource(pixerfUrl.full + 'api/custom_commissions/:id/:action', {
			id: '@id'
		}, {
			'getCustomCommissionById': {
				method: 'GET',
				params: {},
				interceptor: {
					response: function (response) {
						return response;
					}
				}
			},
			'getListShoots': {
				method: 'GET',
				isArray: true,
				params: {},
				interceptor: {
					response: function (response) {
						return response;
					}
				}
			},
			'getPhotosByShootId': {
				url: pixerfUrl.full + 'api/shoots/:shoot_id/submissions',
				method: 'GET',
				params: {},
				isArray: true,
				interceptor: {
					response: function (response) {
						return response;
					}
				}
			},
			'getPhotosByAllShoot': {
				url: pixerfUrl.full + 'api/custom_commissions/:id/all_submissions',
				method: 'GET',
				params: {},
				isArray: true,
				interceptor: {
					response: function (response) {
						return response;
					}
				}
			},
			'getApprovedPhotoByShootId': {
				url: pixerfUrl.full + 'api/shoots/:shoot_id/submissions',
				method: 'GET',
				params: {
					type: 'shortlisted_submissions_by_me'
				},
				isArray: true,
				interceptor: {
					response: function (response) {
						return response;
					}
				}
			},
			'getApprovedContactSheetByShootId': {
				url: pixerfUrl.full + 'api/shoots/:shoot_id/download_contact_sheet?token=:token',
				method: 'GET',
				isArray: true,
				interceptor: {
					response: function (response) {
						return response;
					}
				}
			},
			'prepareDownloadContactSheetByShootId': {
				url: pixerfUrl.full + 'api/shoots/:id/prepare_download',
				method: 'POST',
				interceptor: {
					response: function (response) {
						return response;
					}
				}
			},
			'removeAllApprovedPhotoByShootId': {
				url: pixerfUrl.full + 'api/custom_commissions_shoot/:id',
				method: 'DELETE',
				interceptor: {
					response: function (response) {
						response.data = [];
						return response;
					}
				}
			},
			'getCommentsByShootId': {
				url: pixerfUrl.full + 'api/shoots/:shoot_id/comments',
				method: 'GET',
				params: {},
				isArray: true,
				interceptor: {
					response: function (response) {
						for (var i = 0; i < response.data.length; i++) {
							response.data[i].user = accountUtils.transformUserData(response.data[i].user);
						}
						return response;
					}
				}
			},
			'removeAllCommentsByShootId': {
				url: pixerfUrl.full + 'api/custom_commissions_shoot/:id',
				method: 'DELETE',
				interceptor: {
					response: function (response) {
						response.data = [];
						return response;
					}
				}
			},
			'getCommentsBySubmissionId': {
				url: pixerfUrl.full + 'api/shoots/:shoot_id/submissions/:id/comments',
				method: 'GET',
				isArray: true,
				interceptor: {
					response: function (response) {
						if (response.data.length > 0) {
							for (var i = 0; i < response.data.length; i++) {
								accountUtils.transformUserData(response.data[i].user);
							}
						}
						return response;
					}
				}
			},
			'setViewed': {
				url: pixerfUrl.full + 'api/shoots/:shoot_id',
				method: 'PUT',
				params: {
					is_viewed: true
				},
				interceptor: {
					response: function (response) {
						return response;
					}
				}
			},
			'getListOngoing': {
				method: 'GET',
				isArray: true,
				interceptor: {
					response: function (response) {
						return response;
					}
				}
			},
			'commentOnSubmissions': {
				url: pixerfUrl.full + 'api/shoots/:shoot_id/submissions/:submission_id/comments',
				method: 'POST',
			},
			'editCommentOnSubmissions': {
				url: pixerfUrl.full + 'api/shoots/:shoot_id/submissions/:submission_id/comments/:comment_id',
				method: 'PUT'
			},
			'deleteCommentOnSubmissions': {
				url: pixerfUrl.full + 'api/shoots/:shoot_id/submissions/:submission_id/comments/:comment_id',
				method: 'DELETE'
			},
			'uploadToSubmission': {
				url: pixerfUrl.full + 'api/shoots/:shoot_id/submissions',
				method: 'POST',
				isArray: true
			},
			'updateSubmission': {
				url: pixerfUrl.full + 'api/shoots/:shoot_id/submissions/:submission_id',
				method: 'PUT'
			},
			'approveSubmission': {
				url: pixerfUrl.full + 'api/shoots/:shoot_id/shortlist_submissions',
				method: 'POST',
				isArray: true
			},
			'getPhotoById': {
				url: pixerfUrl.full + 'api/shoots/:shoot_id/submissions/:submission_id',
				method: 'GET',
				params: {},
				interceptor: {
					response: function (response) {
						return response;
					}
				}
			},
			'get': {
				method: 'GET',
				params: {},
				isArray: true,
				interceptor: {
					response: function (response) {
						return response;
					}
				}
			},
			'requestToDownload': {
				url: pixerfUrl.full + 'api/shoots/:id/request_download',
				method: 'POST'
			},
			'release': {
				url: pixerfUrl.full + 'api/shoots/:id/release_for_download',
				method: 'POST'
			},
			'getDownloadLink': {
				url: pixerfUrl.full + 'api/shoots/:id/download_tickets',
				method: 'GET',
				isArray: true
			},
			'removeSubmission': {
				url: pixerfUrl.full + 'api/shoots/:shoot_id/submissions/:submission_id',
				method: 'DELETE'
			},
			'downloadPhotoById': {
				url: pixerfUrl.full + 'api/shoots/:shoot_id/submissions/download_tickets',
				method: 'POST'
			},
			'update': {
				method: 'PUT'
			}
		});
	}
})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.factory('pixerfApiCustomCommissionSvc', pixerfApiCustomCommissionSvc);

		pixerfApiCustomCommissionSvc.$inject = ['$resource', 'pixerfUrl', 'accountUtils', 'fileUtils'];

	function pixerfApiCustomCommissionSvc($resource, pixerfUrl, accountUtils, fileUtils) {

		return $resource(pixerfUrl.full + 'api/media/:id/:action/:commentid/:api_version', {
			id: '@id'
		}, {
			'commentCustomCommissions': {
				url: pixerfUrl.full + 'api/custom_commissions/:custom_commission_id/submissions/:id/comments',
				method: 'POST'
			},
			'editCommentCustomCommissions': {
				url: pixerfUrl.full + 'api/custom_commissions/:custom_commission_id/submissions/:id/comments/:commentid',
				method: 'PUT'
			},
			'contact_us': {
				params: {},
				url: pixerfUrl.full + 'api/custom_commissions/book_cc',
				method: 'POST',
				transformRequest: angular.identity,
				headers: {
				   "Content-Type": undefined
				},
				interceptor: {
					response: function (response) {
						return response.data;
					}
				}
			},
			'book_cc': {
				params: {},
				url: pixerfUrl.full + 'api/custom_commissions/book_cc',
				method: 'POST',
				interceptor: {
					response: function (response) {
						return response.data;
					}
				}
			},
			'getCustomCommissionsComment': {
				url: pixerfUrl.full + 'api/shoot/:shoot_id/submissions/:id/comments',
				method: 'GET',
				isArray: true,
				interceptor: {
					response: function (response) {
						if (response.data.length > 0) {
							for (var i = 0; i < response.data.length; i++) {
								accountUtils.transformUserData(response.data[i].user);
							}
						}
						return response;
					}
				}
			},
			'deleteCommentCustomCommissions': {
				url: pixerfUrl.full + 'api/custom_commissions/:custom_commission_id/submissions/:custom_commission_submission_id/comments/:id',
				method: 'DELETE'
			}
		});
	}
})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.factory('pixerfApiCreditPlansSvc', pixerfApiCreditPlansSvc);

	pixerfApiCreditPlansSvc.$inject = ['$resource', 'pixerfUrl'];

	function pixerfApiCreditPlansSvc($resource, pixerfUrl) {

		return $resource(pixerfUrl.full + 'api/user_credit_plan/top_up', {}, {
			'get': {
				url: pixerfUrl.full + 'api/credit_plan',
				method: 'GET',
				interceptor: {
					response: function (response) {
						return response;
					}
				}
			},
			'post': {
				method: 'POST',
				interceptor: {
					response: function (response) {
						return response;
					}
				}
			}
		});
	}
})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.factory('pixerfApiCommunitySvc', pixerfApiCommunitySvc);

	pixerfApiCommunitySvc.$inject = ['$resource', 'pixerfUrl', 'communityUtils', 'accountUtils'];

	function pixerfApiCommunitySvc($resource, pixerfUrl, communityUtils, accountUtils) {

		function genDisplayName(datas) {
			if (datas && datas.length) {
				for (var i = 0; i < datas.length; i++) {
					datas[i].user.displayName = accountUtils.buildUserDisplayName(datas[i].user);
					datas[i].user.avatar = accountUtils.buildUserAvatarPhotoUrl(datas[i].user);
				}
			}

			return datas;
		}

		return $resource(pixerfUrl.full + 'api/communities/:id/:action', {
			id: '@id'
		}, {
			'get': {
				method: 'GET',
				params: {},
				interceptor: {
					response: function (response) {
						communityUtils.transform(response.data);
						return response;
					}
				}
			},
			'list': {
				method: 'GET',
				isArray: true,
				params: {},
				interceptor: {
					response: function (response) {
						communityUtils.transformMultiple(response.data);
						return response;
					}
				}
			},
			'get_user_communities': {
				url: pixerfUrl.full + 'api/users/community/memberships',
				method: 'GET',
				isArray: true,
				params: {},
				interceptor: {
					response: function (response) {
						communityUtils.transformMultiple(response.data);
						return response;
					}
				}
			},
			'get_communities_with_events': {
				url: pixerfUrl.full + 'api/community/communities_with_events',
				method: 'GET',
				isArray: true,
				interceptor: {
					response: function (response) {
						communityUtils.transformMultiple(response.data);
						return response;
					}
				}
			},
			'get_communities_with_reports': {
				url: pixerfUrl.full + 'api/community/communities_with_reports',
				method: 'GET',
				isArray: true,
				interceptor: {
					response: function (response) {
						communityUtils.transformMultiple(response.data);
						return response;
					}
				}
			},
			'get_reasons_with_reports': {
				url: pixerfUrl.full + 'api/community_reports/reasons',
				method: 'GET',
				isArray: true,
				interceptor: {
					response: function (response) {
						communityUtils.transformMultiple(response.data);
						return response;
					}
				}
			},
			'get_report_types': {
				url: pixerfUrl.full + 'api/community_reports/report_types',
				method: 'GET',
				isArray: true,
				interceptor: {
					response: function (response) {
						communityUtils.transformMultiple(response.data);
						return response;
					}
				}
			},
			'get_unpublished_statuses': {
				url: pixerfUrl.full + 'api/community_events/statuses',
				method: 'GET',
				isArray: true,
				interceptor: {
					response: function (response) {
						communityUtils.transformMultiple(response.data);
						return response;
					}
				}
			},
			'update': {
				method: 'PUT',
				params: {},
				interceptor: {
					response: function (response) {
						return response;
					}
				}
			},
			'create': {
				method: 'POST',
				params: {},
				interceptor: {
					response: function (response) {
						return response.data;
					}
				}
			},
			'join': {
				method: 'POST',
				params: {
					action: 'join'
				},
				interceptor: {
					response: function (response) {
						communityUtils.transformMultiple(response.data);
						return response;
					}
				}
			},
			'invite': {
				method: 'POST',
				params: {
					action: 'invite'
				},
				interceptor: {
					response: function (response) {
						communityUtils.transformMultiple(response.data);
						return response;
					}
				}
			},
			'change_privacy': {
				method: 'POST',
				params: {
					action: 'change_privacy'
				},
				interceptor: {
					response: function (response) {
						communityUtils.transformMultiple(response.data);
						return response;
					}
				}
			},
			'invites': {
				url: pixerfUrl.full + 'api/communities/:id/invites',
				isArray: true,
				method: 'GET',
				interceptor: {
					response: function (response) {
						communityUtils.transformMultiple(response.data);
						return response;
					}
				}
			},
			'reject': {
				method: 'PUT',
				isArray: true,
				params: {
					action: 'reject'
				},
				interceptor: {
					response: function (response) {
						communityUtils.transformMultiple(response.data);
						return response;
					}
				}
			},
			'accept': {
				method: 'PUT',
				isArray: true,
				params: {
					action: 'accept'
				},
				interceptor: {
					response: function (response) {
						communityUtils.transformMultiple(response.data);
						return response;
					}
				}
			},
			'get_members': {
				method: 'GET',
				isArray: true,
				params: {
					action: 'memberships'
				},
				interceptor: {
					response: function (response) {
						for (var i = 0; i < response.data.length; i++) {
							accountUtils.transformUserData(response.data[i]);
						}
						return response;
					}
				}
			},
			'remove': {
				method: 'POST',
				params: {
					action: 'delete_membership'
				},
				interceptor: {
					response: function (response) {
						return response;
					}
				}
			},
			'uninvite': {
				method: 'POST',
				params: {
					action: 'delete_membership'
				},
				interceptor: {
					response: function (response) {
						return response;
					}
				}
			},
			'withdraw_request': {
				url: pixerfUrl.full + 'api/users/community/memberships',
				method: 'POST',
				params: {},
				interceptor: {
					response: function (response) {
						return response.data;
					}
				}
			},
			'reject_invitations': {
				url: pixerfUrl.full + 'api/users/community/memberships',
				method: 'PUT',
				isArray: true,
				params: {
					action: 'reject'
				},
				interceptor: {
					response: function (response) {
						communityUtils.transformMultiple(response.data);
						return response;
					}
				}
			},
			'accept_invitations': {
				url: pixerfUrl.full + 'api/users/community/memberships',
				method: 'PUT',
				isArray: true,
				params: {
					action: 'accept'
				},
				interceptor: {
					response: function (response) {
						communityUtils.transformMultiple(response.data);
						return response;
					}
				}
			},
			'make_manager': {
				url: pixerfUrl.full + 'api/communities/:id/update_membership',
				method: 'PUT',
				params: {
					action: 'manager'
				},
				interceptor: {
					response: function (response) {
						return response;
					}
				}
			},
			'remove_manager': {
				url: pixerfUrl.full + 'api/communities/:id/update_membership',
				method: 'PUT',
				params: {
					status: 'accepted'
				},
				interceptor: {
					response: function (response) {
						return response;
					}
				}
			},
			'get_invitable_list': {
				url: pixerfUrl.full + 'api/users/community/invitable_list',
				method: 'GET',
				params: {},
				isArray: true,
				interceptor: {
					response: function (response) {
						for (var i = 0; i < response.data.length; i++) {
							accountUtils.transformUserData(response.data[i]);
						}
						return response;
					}
				}
			},
			'getSpecialitiesCount': {
				url: pixerfUrl.full + 'api/communities/:id/memberships/specialities',
				method: 'GET',
				params: {},
				isArray: true,
				interceptor: {
					response: function (response) {
						return response;
					}
				}
			},
			'explore': {
				url: pixerfUrl.full + 'api/community/search',
				method: 'GET',
				isArray: true,
				params: {},
				interceptor: {
					response: function (response) {
						communityUtils.transformMultiple(response.data);
						return response;
					}
				}
			},
			'send_referral_code': {
				url: pixerfUrl.full + 'api/communities/:code/join',
				method: 'POST',
				params: {
					type: 'short_code'
				}
			},
			'create_discussion': {
				url: pixerfUrl.full + 'api/communities/:id/discussions',
				method: 'POST',
				interceptor: {
					response: function (response) {
						if (response.data && response.data.user) {
							response.data.user.displayName = accountUtils.buildUserDisplayName(response.data.user);
							response.data.user.avatar = accountUtils.buildUserAvatarPhotoUrl(response.data.user);
						}
						return response;
					}
				}
			},
			'update_discussion': {
				url: pixerfUrl.full + 'api/discussions/:id',
				method: 'PUT',
				interceptor: {
					response: function (response) {
						if (response.data && response.data.user) {
							response.data.user.displayName = accountUtils.buildUserDisplayName(response.data.user);
							response.data.user.avatar = accountUtils.buildUserAvatarPhotoUrl(response.data.user);
						}
						return response;
					}
				}
			},
			'get_discussions_by_community_id': {
				url: pixerfUrl.full + 'api/communities/:id/discussions',
				method: 'GET',
				isArray: true,
				interceptor: {
					response: function (response) {
						response.data = genDisplayName(response.data);
						return response;
					}
				}
			},
			'get_draft_discussions_by_community_id': {
				url: pixerfUrl.full + 'api/communities/:id/discussions',
				method: 'GET',
				isArray: true,
				params: {
					status: 'draft'
				},
				interceptor: {
					response: function (response) {
						response.data = genDisplayName(response.data);
						return response;
					}
				}
			},
			'remove_disscussion': {
				url: pixerfUrl.full + 'api/discussions/:id',
				method: 'DELETE',
				interceptor: {
					response: function (response) {
						return response;
					}
				}
			},
			'arrange_by': {
				url: pixerfUrl.full + 'api/discussions/:id',
				method: 'GET',
				interceptor: {
					response: function (response) {
						return response;
					}
				}
			},
			'like_discussion': {
				url: pixerfUrl.full + 'api/discussions/:id/likes',
				method: 'POST',
				interceptor: {
					response: function (response) {
						return response;
					}
				}
			},
			'unlike_discussion': {
				url: pixerfUrl.full + 'api/discussions/:id/likes',
				method: 'DELETE',
				interceptor: {
					response: function (response) {
						return response;
					}
				}
			},
			'toggle_bookmark_discussion': {
				url: pixerfUrl.full + 'api/discussions/:id/toggle_bookmark',
				method: 'POST',
				interceptor: {
					response: function (response) {
						return response;
					}
				}
			},
			'comment_discussion': {
				url: pixerfUrl.full + 'api/discussions/:id/replies',
				method: 'POST',
				interceptor: {
					response: function (response) {
						if (response.data && response.data.user) {
							response.data.user.displayName = accountUtils.buildUserDisplayName(response.data.user);
							response.data.user.avatar = accountUtils.buildUserAvatarPhotoUrl(response.data.user);
						}
						return response;
					}
				}
			},
			'reply_comment': {
				url: pixerfUrl.full + 'api/replies/:id/nested',
				method: 'POST',
				interceptor: {
					response: function (response) {
						if (response.data && response.data.user) {
							response.data.user.displayName = accountUtils.buildUserDisplayName(response.data.user);
							response.data.user.avatar = accountUtils.buildUserAvatarPhotoUrl(response.data.user);
						}
						return response;
					}
				}
			},
			'get_discussion_by_id': {
				url: pixerfUrl.full + 'api/discussions/:id',
				method: 'GET',
				interceptor: {
					response: function (response) {
						if (response.data && response.data.user) {
							response.data.user.displayName = accountUtils.buildUserDisplayName(response.data.user);
							response.data.user.avatar = accountUtils.buildUserAvatarPhotoUrl(response.data.user);
						}
						return response;
					}
				}
			},
			'get_discussion_comments': {
				url: pixerfUrl.full + 'api/discussions/:id/replies',
				method: 'GET',
				isArray: true,
				interceptor: {
					response: function (response) {
						response.data = genDisplayName(response.data);
						return response;
					}
				}
			},
			'like_comment': {
				url: pixerfUrl.full + 'api/replies/:id/likes',
				method: 'POST',
				interceptor: {
					response: function (response) {
						return response;
					}
				}
			},
			'unlike_comment': {
				url: pixerfUrl.full + 'api/replies/:id/likes',
				method: 'DELETE',
				interceptor: {
					response: function (response) {
						return response;
					}
				}
			},
			'get_sub_replies': {
				url: pixerfUrl.full + 'api/replies/:id/nested',
				method: 'GET',
				isArray: true,
				interceptor: {
					response: function (response) {
						response.data = genDisplayName(response.data);
						return response;
					}
				}
			},
			'remove_reply': {
				url: pixerfUrl.full + 'api/replies/:id',
				method: 'DELETE',
				interceptor: {
					response: function (response) {
						return response;
					}
				}
			},
			'report_discussion': {
				url: pixerfUrl.full + 'api/discussions/:id/report',
				method: 'POST',
				interceptor: {
					response: function (response) {
						return response;
					}
				}
			},
			'report_comment': {
				url: pixerfUrl.full + 'api/replies/:id/report',
				method: 'POST',
				interceptor: {
					response: function (response) {
						return response;
					}
				}
			},
			'report_community_event': {
				url: pixerfUrl.full + 'api/community_events/:id/report',
				method: 'POST',
				interceptor: {
					response: function (response) {
						return response;
					}
				}
			},
			'cancel_community_event': {
				url: pixerfUrl.full + 'api/community_events/:id/cancel',
				method: 'POST',
				interceptor: {
					response: function (response) {
						return response;
					}
				}
			},
			'cancel_many_community_event': {
				url: pixerfUrl.full + 'api/community_events/cancel_many',
				method: 'POST',
				isArray: true,
				interceptor: {
					response: function (response) {
						return response;
					}
				}
			},
			'report_community': {
				url: pixerfUrl.full + 'api/communities/:id/report',
				method: 'POST',
				interceptor: {
					response: function (response) {
						return response;
					}
				}
			},
			'list_like_discussion': {
				url: pixerfUrl.full + 'api/discussions/:id/likes',
				method: 'GET',
				isArray: true,
				interceptor: {
					response: function (response) {
						if (response.data && response.data.length) {
							for (var i = 0; i < response.data.length; i++) {
								response.data[i].displayName = accountUtils.buildUserDisplayName(response.data[i]);
								response.data[i].avatar = accountUtils.buildUserAvatarPhotoUrl(response.data[i]);
							}
						}
						return response;
					}
				}
			},
			'list_reply_discussion': {
				url: pixerfUrl.full + 'api/discussions/:id/replies',
				method: 'GET',
				isArray: true,
				interceptor: {
					response: function (response) {
						if (response.data && response.data.length) {
							for (var i = 0; i < response.data.length; i++) {
								response.data[i].user.displayName = accountUtils.buildUserDisplayName(response.data[i].user);
								response.data[i].user.avatar = accountUtils.buildUserAvatarPhotoUrl(response.data[i].user);
							}
						}
						return response;
					}
				}
			},
			'list_reply_event_post': {
				url: pixerfUrl.full + 'api/community_event_posts/:id/replies',
				method: 'GET',
				isArray: true,
				interceptor: {
					response: function (response) {
						if (response.data && response.data.length) {
							for (var i = 0; i < response.data.length; i++) {
								response.data[i].user.displayName = accountUtils.buildUserDisplayName(response.data[i].user);
								response.data[i].user.avatar = accountUtils.buildUserAvatarPhotoUrl(response.data[i].user);
							}
						}
						return response;
					}
				}
			},
			'list_like_reply': {
				url: pixerfUrl.full + 'api/replies/:id/likes',
				method: 'GET',
				isArray: true,
				interceptor: {
					response: function (response) {
						if (response.data && response.data.length) {
							for (var i = 0; i < response.data.length; i++) {
								response.data[i].displayName = accountUtils.buildUserDisplayName(response.data[i]);
								response.data[i].avatar = accountUtils.buildUserAvatarPhotoUrl(response.data[i]);
							}
						}
						return response;
					}
				}
			},
			'get_similar_discussions': {
				url: pixerfUrl.full + 'api/discussions/:id/more_like_this',
				method: 'GET',
				isArray: true,
				interceptor: {
					response: function (response) {
						response.data = genDisplayName(response.data);
						return response;
					}
				}
			},
			'get_similar_events': {
				url: pixerfUrl.full + 'api/community_events/:id/more_like_this',
				method: 'GET',
				isArray: true,
				interceptor: {
					response: function (response) {
						return response;
					}
				}
			},
			'update_reply': {
				url: pixerfUrl.full + 'api/reply/:id',
				method: 'PUT',
				interceptor: {
					response: function (response) {
						if (response.data && response.data.user) {
							response.data.user.displayName = accountUtils.buildUserDisplayName(response.data.user);
							response.data.user.avatar = accountUtils.buildUserAvatarPhotoUrl(response.data.user);
						}
					}
				}
			},
			'delete_all_posts_comments': {
				url: pixerfUrl.full + 'api/communities/:id/remove_content',
				method: 'PUT',
				interceptor: {
					response: function (response) {
						return response;
					}
				}
			},
			'decline_pending_invited_by': {
				url: pixerfUrl.full + 'api/communities/:id/remove_pending_invites',
				method: 'PUT',
				interceptor: {
					response: function (response) {
						return response;
					}
				}
			},
			'block_member': {
				url: pixerfUrl.full + 'api/communities/:id/update_membership',
				method: 'PUT',
				interceptor: {
					response: function (response) {
						return response;
					}
				}
			},
			'unblock': {
				url: pixerfUrl.full + 'api/communities/:id/update_membership',
				method: 'PUT',
				params: {
					status: 'accepted'
				},
				interceptor: {
					response: function (response) {
						return response;
					}
				}
			},
			'create_event_post': {
				url: pixerfUrl.full + 'api/community_events/:id/posts',
				method: 'POST',
				interceptor: {
					response: function (response) {
						if (response.data && response.data.owner) {
							response.data.owner.displayName = accountUtils.buildUserDisplayName(response.data.owner);
							response.data.owner.avatar = accountUtils.buildUserAvatarPhotoUrl(response.data.owner);
						}
						return response;
					}
				}
			},
			'get_post_by_event_id': {
				url: pixerfUrl.full + 'api/community_events/:id/posts',
				method: 'GET',
				isArray: true,
				interceptor: {
					response: function (response) {
						if (response.data && response.data.length) {
							for (var i = 0; i < response.data.length; i++) {
								response.data[i].owner.displayName = accountUtils.buildUserDisplayName(response.data[i].owner);
								response.data[i].owner.avatar = accountUtils.buildUserAvatarPhotoUrl(response.data[i].owner);
								response.data[i].user.displayName = accountUtils.buildUserDisplayName(response.data[i].user);
								response.data[i].user.avatar = accountUtils.buildUserAvatarPhotoUrl(response.data[i].user);
							}
						}
						return response;
					}
				}
			},
			'get_event_post_comments': {
				url: pixerfUrl.full + 'api/community_event_posts/:id/replies',
				method: 'GET',
				isArray: true,
				interceptor: {
					response: function (response) {
						response.data = genDisplayName(response.data);
						return response;
					}
				}
			},
			'comment_event_post': {
				url: pixerfUrl.full + 'api/community_event_posts/:id/replies',
				method: 'POST',
				interceptor: {
					response: function (response) {
						if (response.data && response.data.user) {
							response.data.user.displayName = accountUtils.buildUserDisplayName(response.data.user);
							response.data.user.avatar = accountUtils.buildUserAvatarPhotoUrl(response.data.user);
						}
						return response;
					}
				}
			},
			'like_event_post': {
				url: pixerfUrl.full + 'api/community_event_posts/:id/likes',
				method: 'POST',
				interceptor: {
					response: function (response) {
						return response;
					}
				}
			},
			'unlike_event_post': {
				url: pixerfUrl.full + 'api/community_event_posts/:id/likes',
				method: 'DELETE'
			},
			'like_reply_event_post': {
				url: pixerfUrl.full + 'api/community_event_post_replies/:id/likes',
				method: 'POST',
				interceptor: {
					response: function (response) {
						return response;
					}
				}
			},
			'reply_nested_event_post': {
				url: pixerfUrl.full + 'api/community_event_post_replies/:id/nested',
				method: 'POST',
				interceptor: {
					response: function (response) {
						return response;
					}
				}
			},
			'get_nested_event_post_reply': {
				url: pixerfUrl.full + 'api/community_event_post_replies/:id/nested',
				method: 'GET',
				isArray: true,
				interceptor: {
					response: function (response) {
						response.data = genDisplayName(response.data);
						return response;
					}
				}
			},
			'remove_event_post_reply': {
				url: pixerfUrl.full + 'api/community_event_post_replies/:id',
				method: 'DELETE',
				interceptor: {
					response: function (response) {
						return response;
					}
				}
			},
			'list_like_event_post': {
				url: pixerfUrl.full + 'api/community_event_posts/:id/likes',
				method: 'GET',
				isArray: true,
				interceptor: {
					response: function (response) {
						if (response.data && response.data.length) {
							for (var i = 0; i < response.data.length; i++) {
								response.data[i].displayName = accountUtils.buildUserDisplayName(response.data[i]);
								response.data[i].avatar = accountUtils.buildUserAvatarPhotoUrl(response.data[i]);
							}
						}
						return response;
					}
				}
			},
			'list_interested_event': {
				url: pixerfUrl.full + 'api/community_events/:id/responses',
				method: 'GET',
				isArray: true,
				interceptor: {
					response: function (response) {
						if (response.data && response.data.length) {
							for (var i = 0; i < response.data.length; i++) {
								response.data[i].user.displayName = accountUtils.buildUserDisplayName(response.data[i].user);
								response.data[i].user.avatar = accountUtils.buildUserAvatarPhotoUrl(response.data[i].user);
							}
						}
						return response;
					}
				}
			},
			'list_joined_event': {
				url: pixerfUrl.full + 'api/community_events/:id/responses',
				method: 'GET',
				isArray: true,
				interceptor: {
					response: function (response) {
						if (response.data && response.data.length) {
							for (var i = 0; i < response.data.length; i++) {
								response.data[i].user.displayName = accountUtils.buildUserDisplayName(response.data[i].user);
								response.data[i].user.avatar = accountUtils.buildUserAvatarPhotoUrl(response.data[i].user);
							}
						}
						return response;
					}
				}
			},
			'list_invited_event': {
				url: pixerfUrl.full + 'api/community_events/:community_event_id/invites',
				method: 'GET',
				isArray: true,
				interceptor: {
					response: function (response) {
						if (response.data && response.data.length) {
							for (var i = 0; i < response.data.length; i++) {
								response.data[i].displayName = accountUtils.buildUserDisplayName(response.data[i]);
								response.data[i].avatar = accountUtils.buildUserAvatarPhotoUrl(response.data[i]);
							}
						}
						return response;
					}
				}
			},
			'get_pending_communities': {
				url: pixerfUrl.full + 'api/communities?status=pending',
				method: 'GET',
				isArray: true,
				interceptor: {
					response: function (response) {
						if (response.data && response.data.length) {
							for (var i = 0; i < response.data.length; i++) {
								response.data[i].displayName = accountUtils.buildUserDisplayName(response.data[i]);
								response.data[i].avatar = accountUtils.buildUserAvatarPhotoUrl(response.data[i]);
								if (response.data[i].owner) {
									response.data[i].owner.displayName = accountUtils.buildUserDisplayName(response.data[i].owner);
								}
							}
						}
						return response;
					},
				}
			},
			'get_action_required_communities': {
				url: pixerfUrl.full + 'api/communities?status=approve_required',
				method: 'GET',
				isArray: true,
				interceptor: {
					response: function (response) {
						if (response.data && response.data.length) {
							for (var i = 0; i < response.data.length; i++) {
								response.data[i].displayName = accountUtils.buildUserDisplayName(response.data[i]);
								response.data[i].avatar = accountUtils.buildUserAvatarPhotoUrl(response.data[i]);
								if (response.data[i].owner) {
									response.data[i].owner.displayName = accountUtils.buildUserDisplayName(response.data[i].owner);
								}
							}
						}
						return response;
					}
				}
			},
			'approve_community': {
				url: pixerfUrl.full + 'api/communities/move_status/active',
				method: 'POST',
				isArray: true,
				interceptor: {
					response: function (response) {
						if (response.data && response.data.length) {
							for (var i = 0; i < response.data.length; i++) {
								response.data[i].displayName = accountUtils.buildUserDisplayName(response.data[i]);
								response.data[i].avatar = accountUtils.buildUserAvatarPhotoUrl(response.data[i]);
								if (response.data[i].owner) {
									response.data[i].owner.displayName = accountUtils.buildUserDisplayName(response.data[i].owner);
								}
							}
						}
						return response;
					}
				}
			},
			'action_required_community': {
				url: pixerfUrl.full + 'api/communities/move_status/approve_required',
				method: 'POST',
				isArray: true,
				interceptor: {
					response: function (response) {
						if (response.data && response.data.length) {
							for (var i = 0; i < response.data.length; i++) {
								response.data[i].displayName = accountUtils.buildUserDisplayName(response.data[i]);
								response.data[i].avatar = accountUtils.buildUserAvatarPhotoUrl(response.data[i]);
								if (response.data[i].owner) {
									response.data[i].owner.displayName = accountUtils.buildUserDisplayName(response.data[i].owner);
								}
							}
						}
						return response;
					}
				}
			},
			'deactivate_community': {
				url: pixerfUrl.full + 'api/communities/move_status/deactivated',
				method: 'POST',
				isArray: true,
				interceptor: {
					response: function (response) {
						if (response.data && response.data.length) {
							for (var i = 0; i < response.data.length; i++) {
								response.data[i].displayName = accountUtils.buildUserDisplayName(response.data[i]);
								response.data[i].avatar = accountUtils.buildUserAvatarPhotoUrl(response.data[i]);
								if (response.data[i].owner) {
									response.data[i].owner.displayName = accountUtils.buildUserDisplayName(response.data[i].owner);
								}
							}
						}
						return response;
					}
				}
			},
			'reactivate_community': {
				url: pixerfUrl.full + 'api/communities/move_status/active',
				method: 'POST',
				isArray: true,
				interceptor: {
					response: function (response) {
						if (response.data && response.data.length) {
							for (var i = 0; i < response.data.length; i++) {
								response.data[i].displayName = accountUtils.buildUserDisplayName(response.data[i]);
								response.data[i].avatar = accountUtils.buildUserAvatarPhotoUrl(response.data[i]);
								if (response.data[i].owner) {
									response.data[i].owner.displayName = accountUtils.buildUserDisplayName(response.data[i].owner);
								}
							}
						}
						return response;
					}
				}
			},
			'move_to_in_review': {
				url: pixerfUrl.full + 'api/communities/move_status/in_review',
				method: 'POST',
				isArray: true,
				interceptor: {
					response: function (response) {
						if (response.data && response.data.length) {
							for (var i = 0; i < response.data.length; i++) {
								response.data[i].displayName = accountUtils.buildUserDisplayName(response.data[i]);
								response.data[i].avatar = accountUtils.buildUserAvatarPhotoUrl(response.data[i]);
								if (response.data[i].owner) {
									response.data[i].owner.displayName = accountUtils.buildUserDisplayName(response.data[i].owner);
								}
							}
						}
						return response;
					}
				}
			},
			'get_pending_reports': {
				url: pixerfUrl.full + 'api/community_reports',
				method: 'GET',
				isArray: true,
				interceptor: {
					response: function (response) {
						if (response.data && response.data.length) {
							for (var i = 0; i < response.data.length; i++) {
								if (response.data[i].user) {
									response.data[i].user.displayName = accountUtils.buildUserDisplayName(response.data[i].user);
								}
								if (response.data[i].community.owner) {
									response.data[i].community.owner.displayName = accountUtils.buildUserDisplayName(response.data[i].community.owner);
								}
								if (response.data[i].discussion_reply) {
									response.data[i].discussion_reply.user.displayName = accountUtils.buildUserDisplayName(response.data[i].discussion_reply.user);
								}
								if (response.data[i].discussion) {
									response.data[i].discussion.user.displayName = accountUtils.buildUserDisplayName(response.data[i].discussion.user);
								}
							}
						}
						return response;
					}
				}
			},
			'get_past_reports': {
				url: pixerfUrl.full + 'api/community_reports',
				method: 'GET',
				isArray: true,
				interceptor: {
					response: function (response) {
						if (response.data && response.data.length) {
							for (var i = 0; i < response.data.length; i++) {
								if (response.data[i].user) {
									response.data[i].user.displayName = accountUtils.buildUserDisplayName(response.data[i].user);
								}
								if (response.data[i].community.owner) {
									response.data[i].community.owner.displayName = accountUtils.buildUserDisplayName(response.data[i].community.owner);
								}
							}
						}
						return response;
					}
				}
			},
			'resolve_community_report': {
				url: pixerfUrl.full + 'api/community_reports/:id/resolve_report',
				method: 'POST',
				interceptor: {
					response: function (response) {
						if (response.data && response.data.length) {
							for (var i = 0; i < response.data.length; i++) {
								response.data[i].displayName = accountUtils.buildUserDisplayName(response.data[i]);
								response.data[i].avatar = accountUtils.buildUserAvatarPhotoUrl(response.data[i]);
								if (response.data[i].owner) {
									response.data[i].owner.displayName = accountUtils.buildUserDisplayName(response.data[i].owner);
								}
							}
						}
						return response;
					}
				}
			},
			'resolve_many_community_reports': {
				url: pixerfUrl.full + 'api/community_reports/resolve_reports',
				method: 'POST',
				isArray: true,
				interceptor: {
					response: function (response) {
						if (response.data && response.data.length) {
							for (var i = 0; i < response.data.length; i++) {
								response.data[i].displayName = accountUtils.buildUserDisplayName(response.data[i]);
								response.data[i].avatar = accountUtils.buildUserAvatarPhotoUrl(response.data[i]);
								if (response.data[i].owner) {
									response.data[i].owner.displayName = accountUtils.buildUserDisplayName(response.data[i].owner);
								}
							}
						}
						return response;
					}
				}
			},
			'validate_community_report': {
				url: pixerfUrl.full + 'api/community_reports/:id/validate_report',
				method: 'POST',
				interceptor: {
					response: function (response) {
						if (response.data && response.data.length) {
							for (var i = 0; i < response.data.length; i++) {
								response.data[i].displayName = accountUtils.buildUserDisplayName(response.data[i]);
								response.data[i].avatar = accountUtils.buildUserAvatarPhotoUrl(response.data[i]);
								if (response.data[i].owner) {
									response.data[i].owner.displayName = accountUtils.buildUserDisplayName(response.data[i].owner);
								}
							}
						}
						return response;
					}
				}
			},
			'edit_event_post': {
				url: pixerfUrl.full + 'api/community_event_posts/:id',
				method: 'PUT',
				interceptor: {
					response: function (response) {
						if (response.data && response.data.owner) {
							response.data.owner.displayName = accountUtils.buildUserDisplayName(response.data.owner);
							response.data.owner.avatar = accountUtils.buildUserAvatarPhotoUrl(response.data.owner);
						}
						return response;
					}
				}
			},
			'remove_event_post': {
				url: pixerfUrl.full + 'api/community_event_posts/:id',
				method: 'DELETE',
				interceptor: {
					response: function (response) {
						return response;
					}
				}
			},
			'update_event_post_status': {
				url: pixerfUrl.full + 'api/community_event_posts/:id/:action',
				method: 'PUT',
				interceptor: {
					response: function (response) {
						return response;
					}
				}
			},
			'get_list_albums': {
				url: pixerfUrl.full + 'api/communities/:community_id/community_albums',
				method: 'GET',
				isArray: true,
				interceptor: {
					response: function (response) {
						return response;
					}
				}
			},
			'create_album': {
				url: pixerfUrl.full + 'api/communities/:community_id/community_albums',
				method: 'POST',
				interceptor: {
					response: function (response) {
						return response.data;
					}
				}	
			},
			'upload_community_album_photo_many': {
				url: pixerfUrl.full + 'api/community_albums/:album_id/photos/create_many',
				method: 'POST',
				interceptor: {
					response: function (response) {
						return response.data;
					}
				}	
			},
			'upload_community_album_photo': {
				url: pixerfUrl.full + 'api/community_albums/:album_id/photos',
				method: 'POST',
				interceptor: {
					response: function (response) {
						return response.data;
					}
				}	
			},
			'show_community_album':{
				url: pixerfUrl.full + 'api/community_albums/:album_id',
				method: 'GET',
				interceptor: {
					response: function (response) {
						return response.data;
					}
				}	
			},
			'update_community_album':{
				url: pixerfUrl.full + 'api/community_albums/:album_id',
				method: 'PUT',
				interceptor: {
					response: function (response) {
						return response.data;
					}
				}	
			},
			'delete_photo_community_album':{
				url: pixerfUrl.full + 'api/community_album_photos/:id',
				method: 'DELETE',
				interceptor: {
					response: function (response) {
						return response.data;
					}
				}	
			},
			'set_as_cover':{
				url: pixerfUrl.full + 'api/community_albums/:id',
				method: 'PUT',
				interceptor: {
					response: function (response) {
						return response.data;
					}
				}	
			},
			'delete_community_album':{
				url: pixerfUrl.full + 'api/community_albums/:id',
				method: 'DELETE',
				interceptor: {
					response: function (response) {
						return response.data;
					}
				}
			}
		});
	}
})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.factory('pixerfApiCommunityDiscussionSvc', pixerfApiCommunityDiscussionSvc);

	pixerfApiCommunityDiscussionSvc.$inject = ['$resource', 'pixerfUrl', 'accountUtils'];

	function pixerfApiCommunityDiscussionSvc($resource, pixerfUrl, accountUtils) {

		function genDisplayName(datas) {
			if (datas && datas.length) {
				for (var i = 0; i < datas.length; i++) {
					datas[i].user.displayName = accountUtils.buildUserDisplayName(datas[i].user);
					datas[i].user.avatar = accountUtils.buildUserAvatarPhotoUrl(datas[i].user);
				}
			}

			return datas;
		}

		return $resource(pixerfUrl.full + 'api/discussions/:id/:action', {
			id: '@id'
		}, {
			'get_list_pending': {
				url: pixerfUrl.full + 'api/communities/:id/discussions',
				method: 'GET',
				params: {
					status: 'pending'
				},
				isArray: true,
				interceptor: {
					response: function (response) {
						response.data = genDisplayName(response.data);
						return response;
					}
				}
			},
			'move_status': {
				method: 'PUT',
				params: {
					action: '@action'
				},
				interceptor: {
					response: function (response) {
						response.data = genDisplayName(response.data);
						return response;
					}
				}
			},
		});
	}
})();

(function () {
    'use strict';
    angular
        .module('pixerf')
        .factory('pixerfApiClarifaiSvc', pixerfApiClarifaiSvc);

    pixerfApiClarifaiSvc.$inject = ['$q', '$http'];

    function pixerfApiClarifaiSvc($q, $http) {
        var PAT = '3450d724d88a496d819281eb515c885d';
        var USER_ID = '753wtice9l84';
        var APP_ID = 'Pixerf';
        var MODEL_ID = 'general-image-recognition';
        var MODEL_VERSION_ID = 'aa7f35c01e0642fda5cf400f543e7c40';

        function genKeywordsPhoto(photoSrc, inputType) {
            var def = $q.defer();
            var requestOptions = {
                headers: {
                    'Accept': 'application/json',
                    'Authorization': 'Key ' + PAT
                }
            };

            var data = getInputType(photoSrc, inputType);

            $http.post("https://api.clarifai.com/v2/models/" + MODEL_ID + "/versions/" + MODEL_VERSION_ID + "/outputs", data, requestOptions)
                .then(function (response) {
                    def.resolve(response);
                })
                .catch(function (err) {
                    def.reject(err);
                });

            return def.promise;
        }

        function getInputType(photoSrc, imageType) {
            switch (imageType) {
                case 'url':
                    return JSON.stringify({
                        "user_app_id": {
                            "user_id": USER_ID,
                            "app_id": APP_ID
                        },
                        "inputs": [
                            {
                                "data": {
                                    "image": {
                                        "url": photoSrc
                                    }
                                }
                            }
                        ]
                    });
                    break;
                case 'base64':
                    return JSON.stringify({
                        "user_app_id": {
                            "user_id": USER_ID,
                            "app_id": APP_ID
                        },
                        "inputs": [
                            {
                                "data": {
                                    "image": {
                                        "base64": photoSrc.split('base64,')[1]
                                    }
                                }
                            }
                        ]
                    });
                    break;
                default:
                    return JSON.stringify({
                        "user_app_id": {
                            "user_id": USER_ID,
                            "app_id": APP_ID
                        },
                        "inputs": [
                            {
                                "data": {
                                    "image": {
                                        "base64": photoSrc.split('base64,')[1]
                                    }
                                }
                            }
                        ]
                    });
            }
        }

        return {
            genKeywordsPhoto: genKeywordsPhoto
        };
    }
})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.factory('pixerfApiCategorySvc', pixerfApiCategorySvc);

	pixerfApiCategorySvc.$inject = ['$resource', 'pixerfUrl'];

	function pixerfApiCategorySvc($resource, pixerfUrl) {
		return $resource(pixerfUrl.full + 'api/categories/:id/:categoryProperty', {}, {
			'get': {
				isArray: true
			}
		});
	}
})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.factory('pixerfApiCartSvc', pixerfApiCartSvc);

	pixerfApiCartSvc.$inject = ['$resource', 'pixerfUrl', 'pathUtils', 'cartUtils'];

	function pixerfApiCartSvc($resource, pixerfUrl, pathUtils, cartUtils) {

		function transform(data) {
			for (var i = 0; i < data.cart_items.length; i++) {
				var cartItem = data.cart_items[i];
				cartItem.media.thumbnail = pathUtils.buildFilePath(cartItem.media.id, "x500");
				cartItem.media.user.displayName = cartItem.media.user.first_name + ' ' + cartItem.media.user.last_name;

				cartUtils.updateCartSelectedVariant(cartItem, cartItem);
			}
		}
		return $resource(pixerfUrl.full + 'api/cart/:id/:photoid', {
			id: '@id'
		}, {
			'get': {
				method: 'GET',
				params: {},
				interceptor: {
					response: function (response) {
						transform(response.data);
						return response;
					}
				}
			},
			'put': {
				method: 'PUT',
				params: {},
				interceptor: {
					response: function (response) {
						transform(response.data);
						return response;
					}
				}
			},
			'post': {
				method: 'POST',
				params: {},
				interceptor: {
					response: function (response) {
						transform(response.data);
						return response;
					}
				}
			},
			'delete': {
				params: {},
				method: 'DELETE',
				interceptor: {
					response: function (response) {
						transform(response.data);
						return response;
					}
				}
			},
			'validate': {
				url: pixerfUrl.full + 'api/cart/validate',
				method: 'POST'
			},
			'checkGuestUserId': {
				url: pixerfUrl.full + 'api/cart/check_guest_id?id=:uuid',
				method: 'GET'
			}
		});
	}
})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.factory('pixerfApiCampaignSvc', pixerfApiCampaignSvc);

	pixerfApiCampaignSvc.$inject = ['$resource', 'pixerfUrl'];

	function transformReferrals(referrals) {
		for (var i = 0; i < referrals.length; i++) {
			referrals[i].statusDisplay = referrals[i].status === "signed_up" ? "Signed Up" : (referrals[i].status === "not_signed_up" ? "Invite Sent" : "Referral Code Not Used");
		}
		return referrals;
	}

	function pixerfApiCampaignSvc($resource, pixerfUrl) {
		return $resource(pixerfUrl.full + 'api/users/referrals/:id/:action', {
			id: '@id'
		}, {
			'referrals': {
				method: 'GET',
				isArray: true,
				interceptor: {
					response: function (response) {
						response.data = transformReferrals(response.data);
						return response;
					}
				}
			},
			'invite': {
				url: pixerfUrl.full + 'api/users/invite_to_pixerf',
				method: 'POST',
				interceptor: {
					response: function (response) {
						return response;
					}
				}
			},
			'valid_code': {
				url: pixerfUrl.full + 'api/validate_referral_code',
				method: 'GET',
				interceptor: {
					response: function (response) {
						return response;
					}
				}
			}
		});
	}
})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.factory('pixerfApiActivitiesSvc', pixerfApiActivitiesSvc);

	pixerfApiActivitiesSvc.$inject = ['$resource', 'pixerfUrl', 'activityUtils'];

	function pixerfApiActivitiesSvc($resource, pixerfUrl, activityUtils) {
		return $resource(pixerfUrl.full + 'api/activities/:id/:action', {}, {
			'get': {
				url: pixerfUrl.full + 'api/activities/:type',
				method: 'GET',
				interceptor: {
					response: function (response) {
						activityUtils.transforms(response.data.activities);
						return response;
					}
				}
			},
			'mark_as_read': {
				method: 'PUT',
				params: {
					action: 'mark_as_read'
				},
				interceptor: {
					response: function (response) {
						activityUtils.transform(response.data);
						return response;
					}
				}
			},
			'mark_all_as_read': {
				url: pixerfUrl.full + 'api/activities/mark_all_as_read',
				method: 'PUT',
				params: {
					action: 'mark_all_as_read'
				}
			},

		});
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('shoppingCartPageCtrl', shoppingCartPageCtrl);

	shoppingCartPageCtrl.$inject = ['$scope', 'cartSvc', 'editCartBtnSvc', 'toastr', 'messageConst', '$state', 'pixerfConfirmPopupSvc', 'cartUtils', 'sessionManagerSvc', '$uibModalStack', 'pixerfApiCartSvc', '$q', 'errorConst', 'translationSvc'];

	function shoppingCartPageCtrl($scope, cartSvc, editCartBtnSvc, toastr, messageConst, $state, pixerfConfirmPopupSvc, cartUtils, sessionManagerSvc, $uibModalStack, pixerfApiCartSvc, $q, errorConst, translationSvc) {
		var self = this;
		$scope.$parent.vm.contextPage = "Shopping cart";
		self.cart = cartSvc.getCart();
		resetCartValidity();
		self.spinner = {
			isVisible: false
		};
		self.onRemoveCartBtnClicked = removeItemFromCart;
		self.onCartItemModified = onCartItemModified;
		self.onPaymentComplete = onPaymentComplete;
		self.onPaypalDone = onPaypalDone;
		self.onError = onError;
		self.onValidationPassed = onValidationPassed;
		self.validateCart = validateCart;
		self.onContinueXerfingBtnClicked = onContinueXerfingBtnClicked;
		self.onGoToPaymentBtnClicked = onGoToPaymentBtnClicked;
		self.isCartItemDisabled = false;
		self.isWorking = false;
		self.loginUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.onPaymentMethodSelected = onPaymentMethodSelected;
		self.numberDiscounted = 0;

		function init(){
			calTotalToPay(self.cart.data, self.isDiscounted);
		}

		function onCartItemModified(evt, item) {
			if (evt) {
				self.isCartItemDisabled = true;
				editCartBtnSvc.editCartItem(item).then(function () {
					calTotalToPay(self.cart.data, self.isDiscounted);
					self.isCartItemDisabled = false;
				}, function () {
					self.isCartItemDisabled = false;
				});
			}
		}

		function resetCartValidity() {
			cartSvc.resetCartValidity(self.cart.data.cart_items);
		}

		function removeItemFromCart(evt, cartItem) {
			if (self.isWorking) return;
			var isExist = cartSvc.getCartItemById(self.cart.data, cartItem.id);
			if (!isExist) {
				return;
			};
			self.isWorking = true;
			cartSvc.removeItemFromCart(cartItem).then(function () {
				calTotalToPay(self.cart.data, self.isDiscounted);
				self.isWorking = false;
			}, function () {
				self.isWorking = false;
			});
		}

		function onPaymentComplete(data) {
			$state.go('setting.purchase-history.order-list', {
				orderId: data.order_id
			});
			cartSvc.reset();
			self.spinner.isVisible = false;
		}

		function onPaypalDone() {
			self.spinner.isVisible = true;
		}

		function showErrorPopup(message) {
			$uibModalStack.dismissAll();
			pixerfConfirmPopupSvc.showPopup({
				hideCancelBtn: true,
				hideConfirmText: true,
				hideTitle: true,
				message: message,
				windowClass: 'shopping-cart-page__validation-popup',
				okBtnText: 'OK'
			});
		}

		function buildErorrMesssage(items) {
			var firstName = "<span class='text--bold shopping-cart-page__validation-popup__user-name'>" + sessionManagerSvc.getCurrentLoginUser().data.first_name + "</span>";
			var message = "<p>Hey " + firstName + "! The following photo(s) could not be processed for checkout: <span class='icon-icons-info' tooltip-append-to-body='true' tooltip-class='shopping-cart-page__validation-popup__tooltip' tooltip-placement='top' uib-tooltip-template=" + "\"'shopping-cart-page__validation-popup__tooltip-template'\"" + "></span> </p>";
			var cartItems = cartSvc.getCart().data.cart_items;
			for (var i = 0; i < items.length; i++) {
				var photo = cartUtils.getPhotoByLineId(cartItems, items[i]);
				if (photo) {
					message += ("<div class='shopping-cart-page__validation-popup__invalid-file text--semibold'> - " + photo.title + "</div>");
				}
			}
			message += ("<p class='shopping-cart-page__validation-popup__call-to-action-msg'>" + messageConst.error.CALL_TO_ACTION_REMOVE_ITEM_TO_CHECKOUT + "</p>");
			return message;
		}

		function onError(pixerfPaymentErrorObject) {
			self.spinner.isVisible = false;
			if (pixerfPaymentErrorObject && pixerfPaymentErrorObject.error === 'CART_ITEMS_CHANGED') {
				var message = buildErorrMesssage(pixerfPaymentErrorObject.items);
				showErrorPopup(message);
				if (pixerfPaymentErrorObject.items) {
					for (var i = 0; i < self.cart.data.cart_items.length; i++) {
						var cartItem = self.cart.data.cart_items[i];
						var found = _.find(pixerfPaymentErrorObject.items, function (it) {
							return it === cartItem.id;
						})
						cartItem.is_invalid = !!found;
					}
				}
			} else if (errorConst.CHECKOUT_MY_CREDIT_INSUFFICIENT_FUNDS === pixerfPaymentErrorObject.message) {
				toastr.error(messageConst.error.MY_CREDIT_INSUFFICIENT_FUNDS);
			} else {
				toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
			}
		}

		function onValidationPassed() {
			for (var i = 0; i < self.cart.data.cart_items.length; i++) {
				self.cart.data.cart_items[i].is_invalid = false;
			}
		}

		function onContinueXerfingBtnClicked() {
			if ($state.current.name === "checkout.shopping-cart") {
				window.history.back();
			}
		}

		function onGoToPaymentBtnClicked(){
			$state.go('checkout.payment');
		}

		function validateCart() {
			var def = $q.defer();
			var lineItemsIds = _.reduce(cartSvc.getCart().data.cart_items, function (memo, it) {
				memo.push(it.id);
				return memo;
			}, []);
			pixerfApiCartSvc.validate({
				ids: lineItemsIds
			}).$promise.then(function (response) {
				def.resolve();
			}, function (err) {
				def.reject(err);
			})
			return def.promise;
		}

		function calTotalToPay(items, isDiscounted) {
			self.totalToPay = 0;
			self.originPrice = items.total;
			if (!items || !items.cart_items) return;
			var totalDiscounts = 0;
			for (var i = 0; i < items.cart_items.length; i++) {
				if (isDiscounted) {
					totalDiscounts = 0;
					for (var j = 0; j < items.cart_items[i].discounts.length; j++) {
						totalDiscounts += parseFloat(items.cart_items[i].discounts[j].rate_amount);
					}
					totalDiscounts = totalDiscounts.toFixed(4) * 1;
				}
				self.totalToPay += parseFloat(items.cart_items[i].sub_total) * (1 - totalDiscounts);
				self.numberDiscounted = self.originPrice - self.totalToPay;
			}
		}

		function onPaymentMethodSelected(methodSelected) {
			if (methodSelected.id === 'MY_CREDIT') {
				self.isDiscounted = true;
				calTotalToPay(self.cart.data, self.isDiscounted);
			} else {
				self.numberDiscounted = 0;
				self.totalToPay = self.cart.data.total;
				self.isDiscounted = false;
			}
		}

		init();
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('paymentMenthodPageCtrl', paymentMenthodPageCtrl);

	paymentMenthodPageCtrl.$inject = ['$scope', 'cartSvc', 'editCartBtnSvc', 'toastr', 'messageConst', '$state', 'pixerfConfirmPopupSvc', 'cartUtils', 'sessionManagerSvc',
		'$uibModalStack', 'pixerfApiCartSvc', '$q', 'errorConst', 'translationSvc', 'signUpPersonalEmailSvc', 'auth0AuthenticationSvc', 'systemUtils', 'signUpPersonalInfoSvc',
		'addToCartBtnSvc', 'messageSvc', 'accountConst', 'store', '$rootScope', 'pagingUtils', 'notificationPopupSvc', 'pixerfApiSubscribeSvc'
	];

	function paymentMenthodPageCtrl($scope, cartSvc, editCartBtnSvc, toastr, messageConst, $state, pixerfConfirmPopupSvc, cartUtils, sessionManagerSvc,
		$uibModalStack, pixerfApiCartSvc, $q, errorConst, translationSvc, signUpPersonalEmailSvc, auth0AuthenticationSvc, systemUtils, signUpPersonalInfoSvc,
		addToCartBtnSvc, messageSvc, accountConst, store, $rootScope, pagingUtils, notificationPopupSvc, pixerfApiSubscribeSvc) {
		var self = this;
		$scope.$parent.vm.contextPage = "Shopping cart";
		self.cart = cartSvc.getCart();
		resetCartValidity();
		self.spinner = {
			isVisible: false
		};
		self.onRemoveCartBtnClicked = removeItemFromCart;
		self.onCartItemModified = onCartItemModified;
		self.onPaymentComplete = onPaymentComplete;
		self.onPaypalDone = onPaypalDone;
		self.onError = onError;
		self.onValidationPassed = onValidationPassed;
		self.validateCart = validateCart;
		self.onContinueXerfingBtnClicked = onContinueXerfingBtnClicked;
		self.isCartItemDisabled = false;
		self.isWorking = false;
		self.loginUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.onPaymentMethodSelected = onPaymentMethodSelected;
		self.numberDiscounted = 0;
		self.onCheckoutBtnClicked = onCheckoutBtnClicked;
		self.errorEmailMessage = "";
		self.user = {
			data: {
				email: '',
				password: ''
			}
		}
		self.onPasswordBlur = onPasswordBlur;
		self.isPasswordPrivacyTooltipShown = false;
		self.onPasswordFocus = onPasswordFocus;
		self.onPasswordKeyup = onPasswordKeyup;
		self.isShowPassword = signUpPersonalEmailSvc.isShowPassword;
		self.onCheckEmailExist = onCheckEmailExist;
		self.disablePayBtn = disablePayBtn;
		self.signUpForGuestUser = signUpForGuestUser;
		self.isGuestPayment = !self.loginUser;
		self.onAgreedTncChecked = onAgreedTncChecked;
		self.onInputEmailChanged = onInputEmailChanged;
		self.isLoginState = false;
		self.onLoginBtnClicked = onLoginBtnClicked;
		self.subcribleNewsLetter = false;

		var agreedTncChecked = false;

		function init() {
			calTotalToPay(self.cart.data, self.isDiscounted);
			checkPayAfterSigned();
		}

		function onLoginBtnClicked(email, signUpForm) {
			self.isLoginState = !self.isLoginState;
			if (self.isLoginState) {
				setEmailExistErr(true);
				self.errorEmailMessage = "";
			} else {
				self.onPasswordBlur();
				self.onInputEmailChanged(email, signUpForm);
			}
		}

		function onCartItemModified(evt, item) {
			if (evt) {
				self.isCartItemDisabled = true;
				editCartBtnSvc.editCartItem(item).then(function () {
					calTotalToPay(self.cart.data, self.isDiscounted);
					self.isCartItemDisabled = false;
				}, function () {
					self.isCartItemDisabled = false;
				});
			}
		}

		function resetCartValidity() {
			cartSvc.resetCartValidity(self.cart.data.cart_items);
		}

		function removeItemFromCart(evt, cartItem) {
			if (self.isWorking) return;
			var isExist = cartSvc.getCartItemById(self.cart.data, cartItem.id);
			if (!isExist) {
				return;
			};
			self.isWorking = true;
			cartSvc.removeItemFromCart(cartItem).then(function () {
				calTotalToPay(self.cart.data, self.isDiscounted);
				self.isWorking = false;
			}, function () {
				self.isWorking = false;
			});
		}

		function onPaymentComplete(data) {
			$state.go('setting.purchase-history.order-details', {
				orderId: data.order_id
			});
			cartSvc.reset();
			self.spinner.isVisible = false;
			removePaymentInfo();
		}

		function onPaypalDone() {
			self.spinner.isVisible = true;
		}

		function showErrorPopup(message) {
			$uibModalStack.dismissAll();
			pixerfConfirmPopupSvc.showPopup({
				hideCancelBtn: true,
				hideConfirmText: true,
				hideTitle: true,
				message: message,
				windowClass: 'shopping-cart-page__validation-popup',
				okBtnText: 'OK'
			});
		}

		function buildErorrMesssage(items) {
			var firstName = "<span class='text--bold shopping-cart-page__validation-popup__user-name'>" + sessionManagerSvc.getCurrentLoginUser().data.first_name + "</span>";
			var message = "<p>Hey " + firstName + "! The following photo(s) could not be processed for checkout: <span class='icon-icons-info' tooltip-append-to-body='true' tooltip-class='shopping-cart-page__validation-popup__tooltip' tooltip-placement='top' uib-tooltip-template=" + "\"'shopping-cart-page__validation-popup__tooltip-template'\"" + "></span> </p>";
			var cartItems = cartSvc.getCart().data.cart_items;
			for (var i = 0; i < items.length; i++) {
				var photo = cartUtils.getPhotoByLineId(cartItems, items[i]);
				if (photo) {
					message += ("<div class='shopping-cart-page__validation-popup__invalid-file text--semibold'> - " + photo.title + "</div>");
				}
			}
			message += ("<p class='shopping-cart-page__validation-popup__call-to-action-msg'>" + messageConst.error.CALL_TO_ACTION_REMOVE_ITEM_TO_CHECKOUT + "</p>");
			return message;
		}

		function onError(pixerfPaymentErrorObject) {
			removePaymentInfo();
			self.spinner.isVisible = false;
			if (pixerfPaymentErrorObject && pixerfPaymentErrorObject.error === 'CART_ITEMS_CHANGED') {
				var message = buildErorrMesssage(pixerfPaymentErrorObject.items);
				showErrorPopup(message);
				if (pixerfPaymentErrorObject.items) {
					for (var i = 0; i < self.cart.data.cart_items.length; i++) {
						var cartItem = self.cart.data.cart_items[i];
						var found = _.find(pixerfPaymentErrorObject.items, function (it) {
							return it === cartItem.id;
						})
						cartItem.is_invalid = !!found;
					}
				}
			} else if (pixerfPaymentErrorObject && errorConst.CHECKOUT_MY_CREDIT_INSUFFICIENT_FUNDS === pixerfPaymentErrorObject.message) {
				toastr.error(messageConst.error.MY_CREDIT_INSUFFICIENT_FUNDS);
			} else {
				toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
			}
		}

		function onValidationPassed() {
			for (var i = 0; i < self.cart.data.cart_items.length; i++) {
				self.cart.data.cart_items[i].is_invalid = false;
			}
		}

		function onContinueXerfingBtnClicked() {
			if ($state.current.name === "checkout.payment") {
				$state.go('buy-stock-page.trending');
			}
		}

		function validateCart() {
			var def = $q.defer();
			var lineItemsIds = _.reduce(cartSvc.getCart().data.cart_items, function (memo, it) {
				memo.push(it.id);
				return memo;
			}, []);
			pixerfApiCartSvc.validate({
				ids: lineItemsIds
			}).$promise.then(function (response) {
				def.resolve();
			}, function (err) {
				def.reject(err);
			})
			return def.promise;
		}

		function calTotalToPay(items, isDiscounted) {
			self.totalToPay = 0;
			self.originPrice = items.total;
			if (!items || !items.cart_items) return;
			var totalRateDiscounts = 0;
			var totalFixedDiscounts = 0;
			for (var i = 0; i < items.cart_items.length; i++) {
				if (isDiscounted && items.cart_items[i].discounts.length) {
					totalRateDiscounts = 0;
					for (var j = 0; j < items.cart_items[i].discounts.length; j++) {
						if (items.cart_items[i].discounts[j].rate_amount) {
							totalRateDiscounts += parseFloat(items.cart_items[i].discounts[j].rate_amount);
						} else if (items.cart_items[i].discounts[j].fixed_amount) {
							totalFixedDiscounts += parseFloat(items.cart_items[i].discounts[j].fixed_amount);
						}
					}
					if (totalRateDiscounts) {
						totalRateDiscounts = totalRateDiscounts.toFixed(4) * 1;
					}
				}
				if (!isNaN(totalRateDiscounts)) {
					self.totalToPay += parseFloat(items.cart_items[i].sub_total) * (1 - totalRateDiscounts);
				} else if (!isNaN(totalFixedDiscounts)) {
					self.totalToPay += parseFloat(items.cart_items[i].sub_total) - totalFixedDiscounts;
				}
				self.numberDiscounted = self.originPrice - self.totalToPay;
			}
		}

		function onPaymentMethodSelected(methodSelected) {
			if (methodSelected.id === 'MY_CREDIT') {
				self.isDiscounted = false;
				calTotalToPay(self.cart.data, self.isDiscounted);
			} else {
				self.numberDiscounted = 0;
				self.totalToPay = self.cart.data.total;
				self.isDiscounted = false;
				if (methodSelected.id === 'PAYPAL') {
					onPaymentMenthodPaypalSelected();
				}
			}
		}

		function onCheckoutBtnClicked() {

		}
		var handleEmailInput;

		function onInputEmailChanged(email, signUpForm) {
			if (self.isLoginState) return;
			if (handleEmailInput) {
				clearTimeout(handleEmailInput);
				handleEmailInput = null;
			}
			handleEmailInput = setTimeout(function () {
				onCheckEmailExist(email, signUpForm);
			}, 1000);
		}

		function onCheckEmailExist(email, signUpForm) {
			if (self.isLoginState) return;
			self.isChecking = true;
			var errMsg = signUpPersonalEmailSvc.validateBriefUser(signUpForm)
			if (errMsg && signUpForm.email.$invalid) {
				self.isChecking = false;
				self.isEmailValid = false;
				self.errorEmailMessage = errMsg;
				return;
			}
			auth0AuthenticationSvc.isUserExisted(email).then(function (response) {
				self.isChecking = false;
				if (response.data && !response.data.existing) {
					setEmailExistErr(true);
				} else {
					setEmailExistErr(false);
					self.errorEmailMessage = "Email has already been taken";
				}
			}, function (err) {
				self.isChecking = false;
				console.log(err);
			});
		}

		function setEmailExistErr(value) {
			if (self.isLoginState) {
				value = true;
			}
			self.emailNotExist = value;
			self.isEmailValid = value;
		}

		function onPasswordBlur(evt) {
			self.isPasswordPrivacyTooltipShown = false;
			systemUtils.digest($scope);
		}

		function onPasswordFocus(evt) {
			self.isPasswordPrivacyTooltipShown = !$(evt.currentTarget).val();
			systemUtils.digest($scope);
		}

		function onPasswordKeyup(evt) {
			self.isPasswordPrivacyTooltipShown = !$(evt.currentTarget).val();
			systemUtils.digest($scope);
		}

		function isSignUpFormValid() {
			if (self.loginUser) {
				return true;
			}
			var result = false;
			var signUpFormScope = angular.element(document.getElementById('signUpForm')).scope();
			if (!signUpFormScope.signUpForm.$pristine && !signUpFormScope.signUpForm.email.$invalid && self.emailNotExist && self.isEmailValid && !signUpFormScope.signUpForm.password.$invalid && !self.isWorking) {
				result = true;
			}
			return result;
		}

		function disablePayBtn() {
			return !self.loginUser && !self.isEmailValid;
		}

		function saveCardInfoToLocal() {
			$rootScope.$broadcast(messageConst.BROADCAST.PAYMENT_CARD_INFO);
		}

		function refillCardInfoToForm() {
			$rootScope.$broadcast(messageConst.BROADCAST.PAYMENT_CARD_INFO_REFILL);
		}

		function saveCurrentUserId() {
			store.set(accountConst.TOKEN.PAY_AFTER_SIGNED, self.user.data.email);
			if (self.subcribleNewsLetter) {
				store.set(accountConst.TOKEN.SUBCRIBLE_NEWS_LETTER, self.user.data.email);
			}
		}

		function removePaymentInfo() {
			store.remove(accountConst.TOKEN.PAY_AFTER_SIGNED);
			store.remove(accountConst.TOKEN.PAYMENT_INFO);
			store.remove(accountConst.TOKEN.PAYMENT_MENTHOD);
			store.remove(accountConst.TOKEN.GUEST_USER_TOKEN);
			store.remove(accountConst.TOKEN.SUBCRIBLE_NEWS_LETTER);
		}

		function checkPayAfterSigned() {
			var lastPaymentUsername = store.get(accountConst.TOKEN.PAY_AFTER_SIGNED);
			if (lastPaymentUsername && self.loginUser && lastPaymentUsername == self.loginUser.email) {
				setTimeout(function () { //wait html binding
					payAfterSigned()
				}, 100);
			};
		}

		function actionPay() {
			var lastestPaymentMenthod = store.get(accountConst.TOKEN.PAYMENT_MENTHOD);
			var lastestPaymentInfo = store.get(accountConst.TOKEN.PAYMENT_INFO);
			if (lastestPaymentMenthod && (lastestPaymentMenthod.id != 'PAYPAL') && lastestPaymentInfo) {
				setTimeout(function () { //wait html binding
					$rootScope.$broadcast(messageConst.BROADCAST.ACTION_PAY_AFTER_SIGNED);
				}, 2000);
			} else if (lastestPaymentMenthod && (lastestPaymentMenthod.id == 'PAYPAL')) {
				self.spinner.isVisible = false;
			}
			subsribleNewsLetter();
		}

		function subsribleNewsLetter() {
			var emailToSubscrible = store.get(accountConst.TOKEN.SUBCRIBLE_NEWS_LETTER);
			if (emailToSubscrible && (emailToSubscrible == self.loginUser.email)) {
				pixerfApiSubscribeSvc.subscribe({
					"email_subscriber": {
						topic: 'newsLetter',
						email: emailToSubscrible
					}
				}).$promise.then(
					function (res) {},
					function (error) {
						toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
					});
			}
		}

		function onPaymentMenthodPaypalSelected() {
			if (self.loginUser) {
				return;
			}
			if (!isSignUpFormValid()) {
				toastr.warning(translationSvc.EDIT_SOMETHING('ALL_FIELDS_REQUIRED'));
				pagingUtils.scrollToTop();
			}
		}

		function onAgreedTncChecked() {
			agreedTncChecked = true;
			if (!isSignUpFormValid()) {
				toastr.warning(translationSvc.EDIT_SOMETHING('ALL_FIELDS_REQUIRED'));
				pagingUtils.scrollToTop();
				agreedTncChecked = false;
			}
			return agreedTncChecked;
		}

		function payAfterSigned() {
			var def = $q.defer();
			self.spinner.isVisible = true;
			var guestUserId = store.get(accountConst.TOKEN.GUEST_USER_TOKEN);
			cartSvc.fetchCart(guestUserId).then(function (response) {
				refillCardInfoToForm();
				self.cart = cartSvc.getCart();
				removeGuestUserId();
				calTotalToPay(self.cart.data, self.isDiscounted);
				actionPay();
				return def.resolve();
			}, function (error) {
				def.reject(error);
				self.spinner.isVisible = false;
			});
		}

		function removeGuestUserId(){
			store.remove(accountConst.TOKEN.GUEST_USER_TOKEN);
		}

		function signUpForGuestUser() {
			if (self.isLoginState) {
				return loginThenPay();
			}
			self.spinner.isVisible = true;
			var def = $q.defer();
			if (self.loginUser) {
				return def.resolve();
			}
			auth0AuthenticationSvc.isUserExisted(self.user.data.email).then(function (response) {
				if (response.data && !response.data.existing) {
					saveCardInfoToLocal();
					self.spinner.isVisible = true;
					var messageWhenLogin = {
						title: self.isLoginState ? 'log-in' : 'sign-up-an-account',
						message: 'processing...'
					};
					var signUpNewUserPopup = notificationPopupSvc.showPopup(messageWhenLogin);
					signUpNewUserPopup.closed.then(function () {
						signUpPersonalInfoSvc.signupBrief(self.user, saveCurrentUserId).then(
							function (response) {},
							function (error) {
								def.reject(error);
							}
						);
					});
				} else {
					setEmailExistErr(false);
					self.errorEmailMessage = "Email has already been taken";
					self.spinner.isVisible = false;
					def.reject();
				}
			}, function () {
				self.spinner.isVisible = false;
				toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
				def.reject();
			})

			return def.promise;
		}

		function loginThenPay() {
			self.spinner.isVisible = true;
			var def = $q.defer();
			if (self.loginUser) {
				return def.resolve();
			}
			saveCardInfoToLocal();
			var messageWhenLogin = {
				title: self.isLoginState ? 'log-in' : 'sign-up-an-account',
				message: 'processing...'
			};
			var signUpNewUserPopup = notificationPopupSvc.showPopup(messageWhenLogin);
			saveCurrentUserId();
			signUpNewUserPopup.closed.then(function () {
				auth0AuthenticationSvc.signInByUserNamePassword(self.user.data).promise.then(
					function (loginedUser) {
						return def.resolve(loginedUser);
					},
					function (err) {
						console.log(err);
						self.isWorking = false;
						toastr.error($translate.instant('oops-entered-wrong-email-password'));
						return def.reject(err);
					});
			});

			return def.promise;
		}


		init();
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('eventPaymentMenthodPageCtrl', eventPaymentMenthodPageCtrl);

		eventPaymentMenthodPageCtrl.$inject = ['$scope', 'toastr', 'alertMessagePopupSvc', '$state','sessionManagerSvc',
		'pixerfApiEventSvc',  '$q', 'translationSvc', 'signUpPersonalEmailSvc', 'eventData', 'pagingUtils', 'confirmPopupSvc', 'ISO3166'
	];

	function eventPaymentMenthodPageCtrl($scope, toastr, alertMessagePopupSvc, $state, sessionManagerSvc,
		pixerfApiEventSvc,  $q, translationSvc, signUpPersonalEmailSvc, eventData, pagingUtils, confirmPopupSvc, ISO3166) {
		var self = this;
		$scope.$parent.vm.contextPage = "Ticketed event payment";
		self.event = eventData;
		self.spinner = {
			isVisible: false
		};
		self.onPaymentComplete = onPaymentComplete;
		self.onPaypalDone = onPaypalDone;
		self.onError = onError;
		self.validateCart = validateCart;
		self.onContinueXerfingBtnClicked = onContinueXerfingBtnClicked;
		self.isCartItemDisabled = false;
		self.isWorking = false;
		self.loginUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.onPaymentMethodSelected = onPaymentMethodSelected;
		self.numberDiscounted = 0;
		self.onCheckoutBtnClicked = onCheckoutBtnClicked;
		self.errorEmailMessage = "";
		self.user = {
			data: {
				email: '',
				password: ''
			}
		}
		self.isPasswordPrivacyTooltipShown = false;
		self.isShowPassword = signUpPersonalEmailSvc.isShowPassword;
		self.disablePayBtn = disablePayBtn;
		self.isGuestPayment = !self.loginUser;
		self.onAgreedTncChecked = onAgreedTncChecked;
		self.isLoginState = false;
		self.subcribleNewsLetter = false;

		var agreedTncChecked = false;

		function init() {
			calTotalToPay(self.event, self.isDiscounted);
		}

		function onPaymentComplete(data) {
			self.spinner.isVisible = false;
			removeInterested();
			onGoing();
		}

		function removeInterested(){
			if(self.event && self.event.has_interest){
				pixerfApiEventSvc.toggleInterest({
					id: self.event.id
				}, {}).$promise.then(function (res) {
					self.event = res.data;
				}).catch(function (err) {
					console.log(err);
				})
			}
		}

		function onGoing(callback){
			pixerfApiEventSvc.toggleJoin({
				id: self.event.id
			}, {}).$promise.then(function (res) {
				self.event = res.data;
				$state.go('event-detail-page.event-feed', {
					id: self.event.id,
					name: self.event.name.replace(/ /g, '-')
				});
				showSuccessPaymentPopup();
				if(callback){
					callback();
				}
			}).catch(function (err) {
				if (self.event.countries && err && err.data && err.data.data && err.data.data.key && (err.data.data.key == 'cannot_join_event')) {
					showRestrictedCountry(self.event.countries);
				}
				console.log(err);
			})
		}

        function showRestrictedCountry(countries){
			var countryMsg = '';
			if(!countries || countries.length == 0){
				return;
			}else if(countries.length == 1){
				countryMsg = Object.values(ISO3166.getCountryNames(countries));
			}else if(countries.length == 2){
				countryMsg = Object.values(ISO3166.getCountryNames(countries)).join(" and ");
			}else{
				var countryNames = Object.values(ISO3166.getCountryNames(countries));
				countryMsg = (countryNames.splice(0, countryNames.length - 2)).join(', ') + ' and ' + countryNames[countryNames.length -1];
			}
			confirmPopupSvc.showPopup({
				windowClass: 'restriction-country-popup',
				message: 'This event is restricted to users from ' + countryMsg + ' only.',
				hideSubmitBtn: true,
				cancelBtnText: 'Close'
			});
		}

		function showSuccessPaymentPopup() {
			alertMessagePopupSvc.showPopup({
				paymentSuccessContex: true,
				windowClass: 'event-payment-menthod-page__alert-message',
				title: "Transaction Successfull!",
				description: "Your ticket purchase has been processed. Please check your email for your ticket confirmation."
			});
		}

		function onPaypalDone() {
			self.spinner.isVisible = true;
		}

		function onError(pixerfPaymentErrorObject) {
			toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
		}

		function onValidationPassed() {
		}

		function onContinueXerfingBtnClicked() {
			if ($state.current.name === "checkout.payment") {
				$state.go('buy-stock-page.trending');
			}
		}

		function validateCart() {
			var def = $q.defer();
			def.resolve();
			return def.promise;
		}

		function calTotalToPay(event, isDiscounted) {
			self.totalToPay = 0;
			self.originPrice = event.ticket_price;
			if (!event || !event.ticket_price) return;
			self.numberDiscounted = 0;
			self.totalToPay = event.ticket_price;
		}

		function onPaymentMethodSelected(methodSelected) {
			if (methodSelected.id === 'MY_CREDIT') {
				self.isDiscounted = false;
				calTotalToPay(self.event, self.isDiscounted);
			} else {
				self.numberDiscounted = 0;
				self.totalToPay = self.event.ticket_price;
				self.isDiscounted = false;
				if (methodSelected.id === 'PAYPAL') {
					onPaymentMenthodPaypalSelected();
				}
			}
		}

		function onCheckoutBtnClicked() {

		}

		function isSignUpFormValid() {
			if (self.loginUser) {
				return true;
			}
			var result = false;
			var signUpFormScope = angular.element(document.getElementById('signUpForm')).scope();
			if (!signUpFormScope.signUpForm.$pristine && !signUpFormScope.signUpForm.email.$invalid && self.emailNotExist && self.isEmailValid && !signUpFormScope.signUpForm.password.$invalid && !self.isWorking) {
				result = true;
			}
			return result;
		}

		function disablePayBtn() {
			return !self.loginUser && !self.isEmailValid;
		}

		function onPaymentMenthodPaypalSelected() {
			if (self.loginUser) {
				return;
			}
			if (!isSignUpFormValid()) {
				toastr.warning(translationSvc.EDIT_SOMETHING('ALL_FIELDS_REQUIRED'));
				pagingUtils.scrollToTop();
			}
		}

		function onAgreedTncChecked() {
			agreedTncChecked = true;
			if (!isSignUpFormValid()) {
				toastr.warning(translationSvc.EDIT_SOMETHING('ALL_FIELDS_REQUIRED'));
				pagingUtils.scrollToTop();
				agreedTncChecked = false;
			}
			return agreedTncChecked;
		}

		init();
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('creditPlanPageCtrl', creditPlanPageCtrl);

	creditPlanPageCtrl.$inject = ['$scope'];

	function creditPlanPageCtrl($scope) {
		var self = this;
		$scope.$parent.vm.contextPage = "Credit Plans";
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.config(routerConfig);

	routerConfig.$inject = ['$stateProvider'];

	function routerConfig($stateProvider) {
		'ngInject';
		$stateProvider
			.state('credit-plan', {
				url: '/checkout/credit-plan',
				templateUrl: 'app/checkout/credit-plan/credit-plan-page.html',
				controller: 'creditPlanPageCtrl',
				controllerAs: 'vm',
				abstract: true,
				data: {
					permissions: {
						redirectTo: function () {
							return "404";
						}
					},
					pageTitle: "PIXERF - Credit Plans"
				}
			})
			.state('checkout.credit-plan.credit-plan-payment-successful', {
				url: '/credit-plan-payment-successful',
				templateUrl: 'app/checkout/credit-plan/components/credit-plan-payment-successful/credit-plan-payment-successful.html',
				controller: 'creditPlanPaymentSuccessfulCtrl',
				controllerAs: 'vm',
				params: {
					"credit": {
						squash: true,
						value: null
					},
				},
				resolve: {
					credit: function ($stateParams) {
						return $stateParams.credit;
					}
				}
			})
			.state('checkout.credit-plan.credit-plan-payment-wire-transfer', {
				url: '/credit-plan-payment-wire-transfer',
				templateUrl: 'app/checkout/credit-plan/components/credit-plan-payment-wire-transfer/credit-plan-payment-wire-transfer.html',
				controller: 'creditPlanPaymentWireTransferCtrl',
				controllerAs: 'vm'
			})
			.state('checkout.credit-plan.credit-plan-list', {
				url: '/plans/:hashtag',
				templateUrl: 'app/checkout/credit-plan/components/credit-plan-list/credit-plan-list.html',
				controller: 'creditPlanListCtrl',
				controllerAs: 'vm'
			})
			.state('checkout.credit-plan.credit-plan-checkout', {
				url: '/credit-plan-checkout/:id',
				templateUrl: 'app/checkout/credit-plan/components/credit-plan-checkout/credit-plan-checkout.html',
				controller: 'creditPlanCheckoutCtrl',
				controllerAs: 'vm'
			});
	}

})();

/**
 * Controller for home module
 */
(function(){
  'use strict';
  angular
    .module('pixerf')
    .factory('billingInformationPageSvc', billingInformationPageSvc);
    billingInformationPageSvc.$inject = ['pixerfApiUserSvc', 'toastr', '$q', 'sessionManagerSvc'];

    function billingInformationPageSvc(pixerfApiUserSvc, toastr, $q, sessionManagerSvc){

        function validate(billingInformation, form){
            form.$setDirty();
			var errMsg = '';

			if(form.first_name.$error.validationNoNumber || form.first_name.$error.validationNoHyperlink){
                errMsg = "Sorry, Your first name cannot contain link or number.";
            } else if(form.last_name.$error.validationNoNumber || form.last_name.$error.validationNoHyperlink){
                errMsg = "Sorry, Your last name cannot contain link or number.";
            } else if(form.address.$error.validationNoNumber || form.address.$error.validationNoHyperlink){
                errMsg = "Sorry, Your address cannot contain link or number.";
            } else if(form.state.$error.validationNoHyperlink){
                errMsg = "Sorry, Your state cannot contain link.";
            } else if(form.city.$error.validationNoHyperlink || form.city.$error.validationNoNumber){
                errMsg = "Sorry, Your city cannot contain link  or number.";
            } else if(form.postal_code.$error.validationNoHyperlink){
                errMsg = "Sorry, Your postal code cannot contain link.";
            }

            return errMsg;
        }
	 	function save(billingInformation, form){
            var def = $q.defer();
            var errMsg = validate(billingInformation, form);
            if(errMsg){
                toastr.error(errMsg);
                def.reject();
                return def.promise;
            }

            pixerfApiUserSvc.put(billingInformation, function(result){
                sessionManagerSvc.setCurrentLoginUser(result);
                toastr.success("Billing's information updated!");
                def.resolve(result);
            }, function(err){
                toastr.error("Oops, failed to update billing's information. Please try again!");
                def.reject();
            })
            return def.promise;
        }
		return {
            save: save
		};
    }
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('billingInformationPageCtrl', billingInformationPageCtrl);

	billingInformationPageCtrl.$inject = ['$scope', 'billingInformationPageSvc', 'sessionManagerSvc'];

	function billingInformationPageCtrl($scope, billingInformationPageSvc, sessionManagerSvc) {
		var self = this;
		$scope.$parent.vm.contextPage = "Billing information";
		self.user = sessionManagerSvc.getCurrentLoginUser().data;
		self.onDoneBtnClicked = onDoneBtnClicked;
		self.onBackBtnClicked = onBackBtnClicked;

		function onDoneBtnClicked(user, billingInformationForm){
			billingInformationPageSvc.save(user, billingInformationForm).then(function(result){
				self.user = result;
			}, function(err){

			});
		}

		function onBackBtnClicked(){
			window.history.go(-1);
		}
	}
})();

﻿(function () {

	angular
		.module('pixerf')
		.factory('userHomePageSvc', userHomePageSvc);

	userHomePageSvc.$inject = ['pixerfApiMediaSvc', 'sessionManagerSvc', 'pixerfApiUserSvc', 'accountUtils', '$q', 'stringUtils', 'accountConst', 'arrayUtils'];

	function userHomePageSvc(pixerfApiMediaSvc, sessionManagerSvc, pixerfApiUserSvc, accountUtils, $q, stringUtils, accountConst, arrayUtils) {

		var mCurrentPage = {
			data: 0
		};

		var mPhotos = {
			data: []
		};
		var mBufferPhotos = {
			data: []
		};

		function getCurrentPhotoPage() {
			return mCurrentPage;
		}

		function getPhotos() {
			return mPhotos;
		}

		function getBufferPhotos() {
			return mBufferPhotos;
		}

		function reset() {
			mPhotos.data = [];
			mBufferPhotos.data = [];
			mCurrentPage.data = 0;
		}

		function fetchPhotos(searchParam) {
			return pixerfApiMediaSvc.search({
				page: searchParam.page
			}, {
				user: {
					username: searchParam.username
				}
			}).$promise;
		}

		function fetchMorePhotos(searchParam) {
			mCurrentPage.data++;
			searchParam.page = mCurrentPage.data;
			return fetchPhotos(searchParam);
		}

		function getUser(id) {
			return pixerfApiUserSvc.get({
				id: id,
				action: 'profile'
			}).$promise;
		}

		function getUserInfoAfterLogin() {
			var def = $q.defer();
			pixerfApiUserSvc.me(function (pixerfUserInfo) {
				sessionManagerSvc.setCurrentLoginUser(pixerfUserInfo);
				def.resolve(pixerfUserInfo);
			}, function (error) {
				def.reject(error);
			});
			return def.promise;
		}

		function updateAmbassadorship(user, photos, ambassadorship) {
			for (var i = 0; i < photos.length; i++) {
				photos[i].user.ambassadorship = ambassadorship;
			}
		}

		function isProfileNotCompleted(userInfo) {
			var isNotCompletedPersonal = userInfo.account_type === accountConst.ACCOUNT_TYPE.PERSONAL && (!userInfo.email || !userInfo.first_name ||
				!userInfo.last_name || !userInfo.location || !userInfo.date_of_birth ||
				!userInfo.address || !userInfo.address.country || !userInfo.profile || !stringUtils.isValueString(userInfo.profile) ||
				!arrayUtils.isValueArr(userInfo.profile.specialities));
			var isNotCompletedBusiness = (userInfo.account_type === accountConst.ACCOUNT_TYPE.BUSINESS && (!userInfo.organization || !userInfo.organization.registration_no || !userInfo.organization.address ||
				!userInfo.organization.address.country || !userInfo.organization.address.city || !userInfo.organization.address.street1 || !userInfo.bio || !userInfo.cover_image || !userInfo.cover_image ||
                !userInfo.business_type));

			return !userInfo.account_type || (isNotCompletedPersonal || isNotCompletedBusiness);
		}

		function isNotEnoughUploads(userInfo) {
			if (!userInfo.canUploadPhotos) {
				return false;
			}
			return userInfo.stats.media_count < 20;
		}

		function getCommunityBtnLabel(loginUser, viewingProfile) {
			if (loginUser.canManageCommunity && loginUser.id === viewingProfile) return "Create community";
		}

		function getSidebarFixedPosition(selector) {
			return {
				marginTop: function () {
					var marginTop = $(window).height() - $(selector).outerHeight(true) - 20;
					if (marginTop >= 0) return -marginTop;
					return marginTop;
				}
			}
		}

		return {
			getPhotos: getPhotos,
			getBufferPhotos: getBufferPhotos,
			fetchPhotos: fetchPhotos,
			reset: reset,
			getUser: getUser,
			fetchMorePhotos: fetchMorePhotos,
			getCurrentPhotoPage: getCurrentPhotoPage,
			getUserInfoAfterLogin: getUserInfoAfterLogin,
			updateAmbassadorship: updateAmbassadorship,
			isProfileNotCompleted: isProfileNotCompleted,
			isNotEnoughUploads: isNotEnoughUploads,
			getSidebarFixedPosition: getSidebarFixedPosition
		};
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('userHomePageCtrl', userHomePageCtrl);

	userHomePageCtrl.$inject = ['$rootScope', 'messageConst', 'headerSvc', '$scope', 'userHomePageSvc', 'sessionManagerSvc', 'authSvc', '$stateParams',
		'arrayUtils', 'peopleListPopupSvc', 'accountConst', 'stringUtils', 'settingSvc', '$state', 'userPromise', 'infoRequirePopupSvc', '$timeout',
		'uploadPhotoSvc', 'createCommunityPopupSvc', 'uploadProfilePhotoSvc', 'pixerfApiCommunitySvc', 'notifyTopupCreditPopupSvc', 'pixerfApiMissionSvc',
		'pixerfApiUserSvc', 'commisionNotAvailablePopupSvc', 'organizationDetailPopupSvc', 'toastr', '$filter', 'selectNewExistCoverPopupSvc', 'inviteToCommunitysPopupSvc',
		'completeProfilePopupSvc', 'translationSvc', 'pagingUtils'];

	function userHomePageCtrl($rootScope, messageConst, headerSvc, $scope, userHomePageSvc, sessionManagerSvc, authSvc, $stateParams, arrayUtils, peopleListPopupSvc,
		accountConst, stringUtils, settingSvc, $state, userPromise, infoRequirePopupSvc, $timeout, uploadPhotoSvc, createCommunityPopupSvc, uploadProfilePhotoSvc,
		pixerfApiCommunitySvc, notifyTopupCreditPopupSvc, pixerfApiMissionSvc, pixerfApiUserSvc, commisionNotAvailablePopupSvc, organizationDetailPopupSvc, toastr,
		$filter, selectNewExistCoverPopupSvc, inviteToCommunitysPopupSvc, completeProfilePopupSvc, translationSvc, pagingUtils) {
		var self = this;
		self.loginnedUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.canManageCommunity = self.loginnedUser && self.loginnedUser.data && self.loginnedUser.data.canManageCommunity;
		self.isRightPanelShown = true;
		$stateParams.id = parseInt($stateParams.id);
		self.user = userPromise;
		self.contextPage = "Photos";
		self.coverImage = {
			url: self.user.avatar.coverImage
		};
		self.showUploadUserProfilePhotos = showUploadUserProfilePhotos;
		self.onEditProfileClicked = authSvc.navigateTo;
		self.onAmbassadorshipChanged = onAmbassadorshipChanged;
		self.onInviteToComunityClicked = onInviteToComunityClicked;
		self.onFollowersBtnClicked = onFollowersBtnClicked;
		self.onFollowingsBtnClicked = onFollowingsBtnClicked;
		self.onUserProfilePhotoClicked = onUserProfilePhotoClicked;
		self.onCompleteProfileClicked = onCompleteProfileClicked;
		self.onCreateCommunityBtnClicked = onCreateCommunityBtnClicked;
		self.onCreditPlansBtnClicked = onCreditPlansBtnClicked;
		self.showUploadPhotoPopup = showUploadPhotoPopup;
		self.socialShareContent = buildSocialShareContent(self.user);
		self.isMyProfile = (self.loginnedUser && self.loginnedUser.id === $stateParams.id) || (!$stateParams.id && self.loginnedUser);
		self.banner = buildBannerMessage();
		self.searchFilterBarSettings = headerSvc.getFixedByHeaderSetting();
		self.onScrollToPage = onScrollToPage;
		self.onLoadMorePage = onLoadMorePage;
		self.onCurrentPageChanged = onCurrentPageChanged;
		self.isProfileServiceStatus = self.user.high_profile_application_status ? self.user.high_profile_application_status : "";
		self.onCreateComissionShootClicked = onCreateComissionShootClicked;
		self.onRunMissionClicked = onRunMissionClicked;
		self.onLearnMoreClicked = onLearnMoreClicked;
		self.missions = null;
		self.searchParams = null;
		self.onOrgDetailClicked = onOrgDetailClicked;
		self.loginUserCommunities = [];
		self.isTransformHeaderStyle = headerSvc.isTransformHeaderStyle;
		self.shortcutCommission = {
			"icon": "icon-icons-gallery",
			"title": "Commission a shoot",
			"btnText": "Create",
			"tips": "Learn more",
			"tipsRoute": "introduction-support.faq.business({section: 'customCommissions'})"
		};
		self.shortcutMission = {
			"icon": "icon-icons_mission",
			"title": "Run a Mission",
			"btnText": "Create",
			"tips": "Learn more",
			"tipsRoute": "introduction-support.faq.business({section: 'missions'})"
		};
		self.shortcutCreditPlans = {
			"icon": "icon-icons_files",
			"title": "Credit Plans",
			"btnText": "Buy"
		};
		self.shortcutCommunity = {
			"owner": {
				"icon": "icon-community_2",
				"title": "Create Community",
				"btnText": "Create",
				"tips": "Learn more",
				"tipsRoute": "introduction-support.faq.business({section: 'community'})"
			},
			"guest": {
				"icon": "icon-community_2",
				"title": "Join Community?",
				"btnText": "Join Community",
				"tips": "Learn more",
				"tipsRoute": "introduction-support.faq.business({section: 'community'})"
			},
		}
		self.submissionPagination = {
			'pagerText': "",
			'totalPage': 0,
			'page': 1
		}
		self.rightSidePanel = {
			isShown: false
		}

		self.personalSidebarScrollToFixed = {
			marginTop: function () {
				var marginTop = $('.user-home-page__sidebar__brief').outerHeight(true) - 150;
				if (marginTop >= 0) return -marginTop;
				return marginTop;
			}
		};
		self.managePageLeftSideMenuScrollToFixed = {
			marginTop: function () {
				return 120;
			}
		};
		self.businessUserScrollToFixed = {
			marginTop: function () {
				var marginTop = $(window).height() - $('#business-user-main-menu').outerHeight(true) - 120;
				if (marginTop >= 0) return 120;
				return marginTop;
			}
		};
		self.sidebarContentScrollToFixed = {
			marginTop: function () {
				var distance = $('#business-user-main-menu').outerHeight(true) + 60;
				var marginTop = $(window).height() - $('#sidebar-content').outerHeight(true) - distance;
				if (marginTop >= 0) return distance;
				return marginTop;
			}
		};

		$rootScope.$on(messageConst.BROADCAST.USER_DATA_CHANGE, function () {
			self.loginnedUser = sessionManagerSvc.getCurrentLoginUser().data;
			if (self.loginnedUser && self.user.id === self.loginnedUser.id) {
				self.updatingdAvatar = true;
				self.user = self.loginnedUser;
				self.isProfileNotCompleted = userHomePageSvc.isProfileNotCompleted(self.user);
				if (self.user.profile) {
					buildUserServiceData(self.user.profile);
				}
				self.banner = buildBannerMessage();
				$timeout(function () {
					self.updatingdAvatar = false;
				}, 500)
			}
		});

		$rootScope.$on('$stateChangeSuccess', function (event, toState) {
			$timeout(function () {
				self.isShowNavHeader = !(toState.data && toState.data.hideHeader);
			});
		});

		function requireInfoPoupHandler(popup) {
			if (popup) {
				popup.result.then(function () {
					self.banner = buildBannerMessage();
				}, function () {
					self.banner = buildBannerMessage();
				})
			}
		}

		function getCommunities() {
			pixerfApiCommunitySvc.list({
				user_id: self.user.id,
				membership: 'owner'
			}).$promise.then(function (response) {
				self.communities = response.data.splice(0, 2);
			})
		}

		function getLoginUserCommunities() {
			pixerfApiCommunitySvc.list({
				user_id: self.loginnedUser.id,
				membership: 'owner'
			}).$promise.then(function (response) {
				self.loginUserCommunities = response.data;
			})
		}

		function getUserInfo() {
			userHomePageSvc.getUserInfoAfterLogin().then(function (userData) {
				sessionManagerSvc.setCurrentLoginUser(userData);
				self.loginnedUser = sessionManagerSvc.getCurrentLoginUser().data;
			}, function () {
				toastr.error(translationSvc.FAILED_TO_DO_SOMETHING('FAILED_ORDER_LIST', true));
			});
		}

		function init() {
			if (self.loginnedUser) {
				getUserInfo();
			}
			var popup = infoRequirePopupSvc.getPopup();
			if (popup) {
				requireInfoPoupHandler(popup);
			}
			getCommunities();
			if (self.loginnedUser) {
				getLoginUserCommunities();
			}
			if (self.user.isBiz) {
				getOngoingMissions(true);
			}
			if (self.user.profile) {
				buildUserServiceData(self.user.profile);
			}

			pagingUtils.scrollToTop();
		}

		function showUploadPhotoPopup() {
			uploadPhotoSvc.showUploadModal();
		}

		function buildBannerMessage() {
			self.isProfileNotCompleted = userHomePageSvc.isProfileNotCompleted(self.user);
			if (infoRequirePopupSvc.isShowing() || !self.isMyProfile) {
				return "";
			}
			// if(self.user && self.user.canReferral){
			//     return "Unlock cash rewards for you and your friend with our new referral programme! <a ui-sref=\"setting.referral_program.invite\" class=\"text--bold user-homepage__profile-incomplete-alert__complete-link\">Join now.</a>"
			// }
			if (self.isProfileNotCompleted) {
				return "complete-profile";
			}
			if (userHomePageSvc.isNotEnoughUploads(self.user)) {
				return "Have at least 20 photo uploads in our Marketplace to ensure more buyers notice your work! <a ng-click=\"vm.showUploadPhotoPopup()\" class=\"text--bold user-homepage__profile-incomplete-alert__complete-link\">Upload now.</a>"
			}

		}

		function showUploadUserProfilePhotos(type) {
			if (type == 'cover') {
				var modal = selectNewExistCoverPopupSvc.showPopup();
				modal.result.then(function () {
					self.user = sessionManagerSvc.getCurrentLoginUser().data;
				})
			} else {
				var modal = uploadProfilePhotoSvc.showPopup({
					'type': type
				});
				modal.result.then(function (data) {
					var userImage = {};
					if (self.user.isBiz && self.user.isAdmin) {
						if (type == 'profile') {
							userImage.profile_image = data.response.handle ? data.response.handle : data.thumbnails["300x"];
						}
						pixerfApiUserSvc.put({}, userImage).$promise.then(function () {
							settingSvc.updateUserProfilePhotos(self.user, type, data.thumbnails);
						})
					} else {
						settingSvc.updateUserProfilePhotos(self.user, type, data.thumbnails);
					}
				}, function () { });
			}
		}

		function onFollowersBtnClicked() {
			if (self.user.stats.follower_count === 0) {
				return;
			}
			peopleListPopupSvc.showPopup({
				type: accountConst.INTERACT_TYPE.FOLLOWER.toLowerCase(),
				user: self.user
			});
		}

		function onFollowingsBtnClicked() {
			if (self.user.stats.following_count === 0) {
				return;
			}
			peopleListPopupSvc.showPopup({
				type: accountConst.INTERACT_TYPE.FOLLOWING.toLowerCase(),
				user: self.user
			});
		}

		function buildSocialShareContent(user) {
			return {
				'url': user.path,
				'description': user.bio,
				'title': user.displayName,
				'media': user.avatar.profileImage
			};
		}

		function onScrollToPage(page) {
			self.submissionPagination.page = page;
		}

		function onLoadMorePage(page) {
			self.submissionPagination.page = page;
		}

		function onCurrentPageChanged(pageNumber) {
			var params = {
				id: self.user.id,
				page: pageNumber
			};
			self.userProfilePhotosCtrl.fetchPhotos(params, true);
		}

		function onUserProfilePhotoClicked() {
			self.showUploadUserProfilePhotos('profile');
		}

		function onAmbassadorshipChanged(ambassadorship) {
			userHomePageSvc.updateAmbassadorship(self.user, self.userProfilePhotosCtrl.photoGrid.photos, ambassadorship);
		}

		function onCompleteProfileClicked() {
			if (self.user.isBiz) {
				$state.go("setting.edit_profile_business");
				return;
			}
			var steps = {};
			if (!self.user.account_type || (self.user.account_type === accountConst.ACCOUNT_TYPE.PERSONAL && (!self.user.email || !self.user.first_name ||
				!self.user.last_name || !self.user.location || !self.user.date_of_birth ||
				!self.user.address || !self.user.address.country || !self.user.profile || !stringUtils.isValueString(self.user.profile) ||
				!arrayUtils.isValueArr(self.user.profile.specialities))) || (self.user.account_type === accountConst.ACCOUNT_TYPE.BUSINESS && (!self.user.organization || !self.user.organization.registration_no || !self.user.organization.address ||
					!self.user.organization.address.country || !self.user.location))) {
				var authenticationFor = self.user.account_type;
				completeProfilePopupSvc.showPopup({ 'authenticationFor': authenticationFor });
			} else {
				if (self.user.isBiz && !self.user.profile_image) {
					var title = "Choose a Profile Photo";
					steps["PROFILE_IMAGE"] = {
						name: "PROFILE_IMAGE",
						title: title,
						requiredFields: ["profile_image"],
						validator: function (user) {
							return !user.profile_image ? "Please choose your profile photo!" : "";
						},
						canSkip: true
					};
				}
				if (!self.user.cover_image) {
					steps["COVER_IMAGE"] = {
						name: "COVER_IMAGE",
						title: "Choose a Cover Photo",
						requiredFields: ["cover_image"],
						validator: function (user) {
							return !user.cover_image ? "Please choose your cover photo!" : "";
						},
						canSkip: true
					};
				}
				if (self.user.canUploadPhotos && self.user.stats.media_count < 20) {
					steps["UPLOADS"] = {
						name: "UPLOADS",
						title: "Upload your photos",
						requiredFields: ["media_counts"],
						canSkip: true
					};
				}
				var popup = infoRequirePopupSvc.showPopup({
					user: self.user,
					steps: steps
				});
				self.isProfileNotCompleted = false;
				self.banner = "";
				requireInfoPoupHandler(popup);
			}
		}

		function onCreateCommunityBtnClicked() {
			var message = $filter("translate")('login-or-sign-up-to-use-function');
			if (!self.loginnedUser) {
				toastr.info(message);
			} else {
				if (self.isMyProfile) {
					createCommunityPopupSvc.showPopup();
				} else if (self.user.canManageCommunity) {
					$state.go('.communities.grid');
				} else {
					$state.go('for-creator-page.about-community');
				}
			}
		}

		function onLearnMoreClicked(section) {
			$state.go('introduction-support.faq.business', {
				section: section
			});
		}

		function buildUserServiceData(serviceData) {
			self.serviceData = {};
			self.serviceData.specialities = buildSpecialities(serviceData.specialities);
			self.serviceData.years_of_experience = serviceData.years_of_experience;
			self.serviceData.availability_weekdays = arrayUtils.isValueArr(serviceData.availability_weekdays) ? buildAvailabilityText(serviceData.availability_weekdays) : "";
			self.serviceData.availability_weekends = arrayUtils.isValueArr(serviceData.availability_weekends) ? buildAvailabilityText(serviceData.availability_weekends) : "";
			self.serviceData.cameras = arrayUtils.isValueArr(serviceData.cameras) ? serviceData.cameras.join(", ") : "";
		}

		function buildAvailabilityText(time) {
			if (!time || !time.length) return "";
			if (time.length === 2) {
				return "day-and-evening";
			} else if (time[0] === "day") {
				return "day-only";
			} else {
				return "evening-only";
			}
		}

		function buildSpecialities(specialitiesArray) {
			if (!arrayUtils.isValueArr(specialitiesArray)) return "";
			var specialities = [];
			for (var i = 0; i < specialitiesArray.length; i++) {
				specialities.push(specialitiesArray[i].name);
			}
			return specialities.join(", ");
		}

		function onCreateComissionShootClicked() {
			// commisionNotAvailablePopupSvc.showPopup();
			if (self.loginnedUser.isHondaCC) {
				$state.go("setting.manage-custom-commissions.on-going");
			} else {
				commisionNotAvailablePopupSvc.showPopup();
			}
		}

		function onRunMissionClicked() {
			if (self.loginnedUser && self.loginnedUser.canCreateMission) {
				$state.go("setting.manage-missions.on-going");
				// $state.go("setting.manage-missions.create-mission.getting-started");
			}
		}

		function getOngoingMissions(isFresh) {
			var action = "get_manage_mission";
			var searchParams = {};
			searchParams.page_size = 2;
			searchParams.type = 'current';
			if (!self.isMyProfile) {
				searchParams.user_id = self.user.id;
				action = "query";
			}
			searchParams.sort = ["inserted_at,desc"];
			if (isFresh) self.searchParams = searchParams;
			pixerfApiMissionSvc[action](searchParams).$promise.then(function (response) {
				if (isFresh) self.missions = [];
				if (response && response.data && response.data.missions && response.data.missions.length > 0) {
					var missions = self.missions.concat(response.data.missions);
					self.missions = missions.slice(0, 2);
				}
			}, function (err) {
				console.log(err);
			})
		}

		function onCreditPlansBtnClicked() {
			$state.go("checkout.credit-plan.credit-plan-list");
		}

		function onOrgDetailClicked(businessInfo) {
			organizationDetailPopupSvc.showPopup(businessInfo);
		}

		function onInviteToComunityClicked() {
			var modal = inviteToCommunitysPopupSvc.showPopup({
				user: self.user,
				communities: self.loginUserCommunities
			});
		}
		init();
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.config(routerConfig);

	routerConfig.$inject = ['$stateProvider'];

	function routerConfig($stateProvider) {
		'ngInject';
		$stateProvider
			.state('user-home-page', {
				abstract: true,
				url: '/user-home-page/:id/:userName',
				templateUrl: 'app/user-home-page/user-home-page.html',
				controller: 'userHomePageCtrl',
				controllerAs: 'vm',
				data: {
					pageTitle: "PIXERF - Your profile",
					hideFooter: true,
					preventScrollToTop: true
				},
				params: {
					"id": {
						squash: true,
						value: null
					},
					"userName": {
						squash: true,
						value: null
					}
				},
				resolve: {
					userPromise: function ($stateParams, userHomePageSvc, sessionManagerSvc, $q, $state) {
						var self = this;
						var defer = $q.defer();
						var loginUser = sessionManagerSvc.getCurrentLoginUser().data;
						var userid = parseInt($stateParams.id);
						var handlers = [function (userData) {
							if (!userData || (userData.isPrivatedProfile && loginUser && userid != loginUser.id && !loginUser.isMaketerInternal && !loginUser.isAdminInternal)) {
								$state.go('404');
								defer.reject();
							} else {
								var profileName = loginUser && userid === loginUser.id ? 'Your Profile' : userData.displayName + "'s Profile";
								self.data.pageTitle = "PIXERF - " + profileName;
								defer.resolve(userData);

							}
						}, function (err) {
							if (err.status === 500 || err.status === 404) {
								$state.go(err.status + '');
							}
							defer.reject();
						}]
						if (loginUser) {
							if (!userid || (userid == loginUser.id)) {
								defer.resolve(loginUser);
							} else {
								var promise = userHomePageSvc.getUser(userid);
								promise.then.apply(promise, handlers);
							}
						} else {
							if (!userid) {
								defer.reject();
								$state.go('404');
							} else {
								var promise = userHomePageSvc.getUser(userid);
								promise.then.apply(promise, handlers);
							}
						}
						return defer.promise;
					}
				}
			})
			.state('user-home-page.business', {
				url: '/business',
				views: {
					'': {
						templateUrl: 'app/user-home-page/components/business/business-profile/business-profile.html',
						controller: 'businessProfileCtrl',
						controllerAs: 'vm',
					},
					'sidebarBusiness@user-home-page.business': {
						templateUrl: 'app/user-home-page/components/business/sidebar-business-profile/sidebar-business-profile.html',
						controller: 'sidebarBusinessProfileCtrl',
						controllerAs: 'vm',
					},
					'mainBusiness@user-home-page.business': {
						templateUrl: 'app/user-home-page/components/user-profile-communities/user-profile-communities-grid/user-profile-communities-grid.html',
						controller: 'userProfileCommunitiesGridCtrl',
						controllerAs: 'vm',
					}
				},
				data: {
					permissions: {
						only: ['EVERY_ONE']
					}
				},
				resolve: {
					userPromise: function ($state, sessionManagerSvc, $q, $stateParams, userPromise, verifiedBusinessUserPopupSvc) {
						var loginUser = sessionManagerSvc.getCurrentLoginUser().data;
						var isMine = sessionManagerSvc.isMine(userPromise);
						var defer = $q.defer();
						if ((userPromise.account_type === 'business' && isMine) || (loginUser && loginUser.isMaketerInternal) || (loginUser && loginUser.isAdminInternal)) {
							// if (loginUser && loginUser.isBiz && !loginUser.is_email_verified) {
							// 	verifiedBusinessUserPopupSvc.showPopup();
							// 	sessionManagerSvc.clearSession();
							// 	$state.go("about-business");
							// 	defer.reject();
							// } else {
								defer.resolve(userPromise);
							// }
						} else {
							defer.reject();
							$state.go("user-home-page.personal", {
								id: userPromise.id,
								userName: userPromise.displayName.replace(/ /g, '-')
							});
						}
						return defer.promise;
					}
				}
			})
			.state('user-home-page.personal', {
				url: '/personal',
				views: {
					'': {
						templateUrl: 'app/user-home-page/components/personal/personal-profile/personal-profile.html',
						controller: 'personalProfileCtrl',
						controllerAs: 'vm',
					},
					'sidebarPersonal@user-home-page.personal': {
						templateUrl: 'app/user-home-page/components/personal/sidebar-personal-profile/sidebar-personal-profile.html',
						controller: 'sidebarPersonalProfileCtrl',
						controllerAs: 'vm',
					},
					'mainPersonal@user-home-page.personal': {
						templateUrl: 'app/user-home-page/components/personal-home-page/personal-home-page.html',
						controller: 'personalHomePageCtrl',
						controllerAs: 'vm',
					}
				},
				data: {
					permissions: {
						only: ['EVERY_ONE']
					}
				}
			}).state('user-home-page.guest', {
				url: '/guest',
				views: {
					'': {
						templateUrl: 'app/user-home-page/components/guest/guest-profile/guest-profile.html',
						controller: 'guestProfileCtrl',
						controllerAs: 'vm',
					},
					'sidebarPersonal@user-home-page.guest': {
						templateUrl: 'app/user-home-page/components/guest/sidebar-guest-profile/sidebar-guest-profile.html',
						controller: 'sidebarGuestProfileCtrl',
						controllerAs: 'vm',
					},
					'mainPersonal@user-home-page.guest': {
						templateUrl: 'app/user-home-page/components/guest-home-page/guest-home-page.html',
						controller: 'guestHomePageCtrl',
						controllerAs: 'vm',
					}
				},
				data: {
					permissions: {
						only: ['EVERY_ONE']
					}
				}
			})
			.state('user-home-page.homepage', {
				url: '',
				data: {
					permissions: {
						only: ['EVERY_ONE']
					}
				},
				resolve: {
					userPromise: function ($state, userPromise, accountConst, $q, store, pixerfApiCommunitySvc, userHomePageSvc) {
						var defer = $q.defer();
						if(store.get('PIXERF.CALLBACK_ROUTE') == 'trend-report-landing-page'){
							store.remove('PIXERF.CALLBACK_ROUTE');
							$state.go('trends-report-download-page');
							return;
						}

						if (userPromise.account_type === accountConst.ACCOUNT_TYPE.PERSONAL) {
							var communitySchortCode = store.get('csc');
							var eventShortCode = store.get('cesc');

							if(eventShortCode){
								$state.go('invite-users-join-event', {
									short_code: eventShortCode
								});
								return;
							}

							if (communitySchortCode) {
								// pixerfApiCommunitySvc.send_referral_code({
								// 	code: communitySchortCode
								// }, {}).$promise.then(function () {
								// 	store.remove('csc');
								// }).catch(function () {
								// 	store.remove('csc');
								// })
								$state.go('invite-users-join-community', {
									short_code: communitySchortCode
								});
								return;
							}

							$state.go("user-home-page.personal.home", {
								id: userPromise.id,
								userName: userPromise.displayName.replace(/ /g, '-')
							});

						} else if (userPromise.account_type === accountConst.ACCOUNT_TYPE.BUSINESS) {
							$state.go("user-home-page.business.communities.grid", {
								id: userPromise.id,
								userName: userPromise.displayName.replace(/ /g, '-')
							});
						} else if (userPromise){
							$state.go("user-home-page.guest.home", {
								id: userPromise.id,
								userName: userPromise.displayName.replace(/ /g, '-')
							});
						}
						defer.resolve(userPromise);
						return defer.promise;
					}
				}
			});
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('trendsReportDownloadPageCtrl', trendsReportDownloadPageCtrl);

		trendsReportDownloadPageCtrl.$inject = ['$state', 'sessionManagerSvc', 'systemUtils', 'store'];

	function trendsReportDownloadPageCtrl($state, sessionManagerSvc, systemUtils, store) {

		var self = this;
		self.mloginnedUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.socialShareContent = buildSocialShareContent();
		self.copyToClipboard = systemUtils.copyStringToClipboard;
		self.onDownloadReport = onDownloadReport;
		self.onDownloadTrendSpotting = onDownloadTrendSpotting;
		self.onDownloadGoodBye = onDownloadGoodBye;
		self.shareLink = $state.href('trend-report-landing-page', {}, {absolute: true});
		function buildSocialShareContent(){
			var desc = 'Not just another trend report. Preview Asia’s creative future. Download and get two in one. For free.';
			var title = 'Trend Report landing page ';
			var media = window.location.origin + '/assets/images/trend-report/GB2020image@2x.jpg';
			var url = $state.href('trend-report-landing-page', {}, {absolute: true});
            return {'url': url, 'description': desc, 'title': title, 'media': media};
		}

		function onDownloadTrendSpotting() {
			SaveToDisk('https://pixerf-bucket.s3-ap-southeast-1.amazonaws.com/trend_reports/Trend+Spotting+2021_Final.pdf', 'Trend+Spotting+2021_Final.pdf');
		}

		function onDownloadGoodBye(){
			SaveToDisk('https://pixerf-bucket.s3-ap-southeast-1.amazonaws.com/trend_reports/Goodbye+2020%2C+Hello+2021_Final.pdf', 'Goodbye+2020%2C+Hello+2021_Final.pdf');
		}

		function SaveToDisk(fileURL, fileName) {
			var oReq = new XMLHttpRequest();
			var URLToPDF = fileURL;
			oReq.open("GET", URLToPDF, true);

			oReq.responseType = "blob";

			oReq.onload = function () {
				var file = new Blob([oReq.response], {
					type: 'application/pdf'
				});
				saveAs(file, fileName);
			};

			oReq.send();
		}

		function onDownloadReport(){
			store.set('splashPopupShowFlag_909', true);
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.config(routerConfig);

	routerConfig.$inject = ['$stateProvider'];

	function routerConfig($stateProvider) {
		'ngInject';
		$stateProvider
			.state('trends-report-download-page', {
				url: '/trend-report-download',
				templateUrl: 'app/trends-report-download-page/trends-report-download-page.html',
				controller: 'trendsReportDownloadPageCtrl',
				controllerAs: 'vm',
				data: {
					pageTitle: "PIXERF - Trend Report Download",
					hideFooter: true
				}
			});
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('trendReportLandingPageCtrl', trendReportLandingPageCtrl);

	trendReportLandingPageCtrl.$inject = ['$state', 'signInPopupSvc', 'selectSignUpTypePopupSvc', 'store', '$location', '$anchorScroll', '$timeout', 'sessionManagerSvc', 'pixerfApiSubscribeSvc', 'toastr', 'translationSvc', 'pixerfApiTracking'];

	function trendReportLandingPageCtrl($state, signInPopupSvc, selectSignUpTypePopupSvc, store, $location, $anchorScroll, $timeout, sessionManagerSvc, pixerfApiSubscribeSvc, toastr, translationSvc, pixerfApiTracking) {

		var self = this;
		self.socialShareContent = buildSocialShareContent();
		self.onLoginBtnClicked = onLoginBtnClicked;
		self.onSignupBtnClicked = onSignupBtnClicked;
		self.email = '';
		self.isInputEmailFormvalid = isInputEmailFormvalid;
		self.onSubmitEmail = onSubmitEmail;
		self.scrollToSubmitForm = scrollToSubmitForm;

		self.mloginnedUser = sessionManagerSvc.getCurrentLoginUser().data;

		function hideHeaderAndFooter() {
			$('com-header').hide();
			$('com-footer').hide();
		}

		function isInputEmailFormvalid() {
			if (self.mloginnedUser) {
				return false;
			}
			var result = false;
			var inputEmailForm = angular.element(document.getElementById('inputEmailForm')).scope();
			if (self.email && !inputEmailForm.inputEmailForm.$pristine && !inputEmailForm.inputEmailForm.email.$invalid) {
				result = true;
			}
			return result;
		}

		function init() {
			if (self.mloginnedUser) {
				$state.go('trends-report-download-page');
			}
			hideHeaderAndFooter();
		}

		function onSubmitEmail() {
			pixerfApiSubscribeSvc.subscribe({
				"email_subscriber": {
					topic: 'trendReport',
					email: self.email 
				}
			}).$promise.then(function (res) {
				var params = {
					button_id: 'estr_001',
					button_text: 'Submit',
					description: 'Email subscriber from trend report landing page'
				}

				pixerfApiTracking.action_tracking({
					tracking: params
				})
				$state.go('trends-report-download-page');
			}).catch(function (error) {
				toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
			});
		}

		function scrollToSubmitForm() {
			$timeout(function () {
				$location.hash("pixerf-submit-form");
				$anchorScroll();
			}, 100);
		}

		function buildSocialShareContent() {
			var desc = 'Not just another trend report. Preview Asia’s creative future. Download and get two in one. For free.';
			var title = 'Trend Report landing page ';
			var media = window.location.origin + '/assets/images/trend-report/GB2020image@2x.jpg';
			var url = $state.href('trend-report-landing-page', {}, {
				absolute: true
			});
			return {
				'url': url,
				'description': desc,
				'title': title,
				'media': media
			};
		}

		function onLoginBtnClicked() {
			store.set('PIXERF.CALLBACK_ROUTE', 'trend-report-landing-page');
			signInPopupSvc.showPopup();
		}

		function onSignupBtnClicked() {
			store.set('PIXERF.CALLBACK_ROUTE', 'trend-report-landing-page');
			selectSignUpTypePopupSvc.showPopup({emailSubscriberTopic: 'trendReport'});
		}

		init();
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.config(routerConfig);

	routerConfig.$inject = ['$stateProvider'];

	function routerConfig($stateProvider) {
		'ngInject';
		$stateProvider
			.state('trend-report-landing-page', {
				url: '/trend-report-landing-page',
				templateUrl: 'app/trend-report-landing-page/trend-report-landing-page.html',
				controller: 'trendReportLandingPageCtrl',
				controllerAs: 'vm',
				params: {
					"section": {
						squash: true,
						value: null
					}
				},
				data: {
					pageTitle: "PIXERF - Trend Report landing page",
					headerClass: 'homepage trend-report-landing-page',
					permissions: {
						only: ['EVERY_ONE']
						// only: ['ANONYMOUS'],
						// redirectTo: function (user, param) {
						// 	return {//TODO:go to Trend Report download page
						// 		'state': "trend-report-landing-page"
						// 	}

						// }
					}
				}
			});
	}
})();

﻿/*
 * Service handler for Home module
 * We will implement all business logic for "home" module here
 */
/**
 * Controller for home module
 */
(function(){

  angular
    .module('pixerf')
    .factory('termPolicySvc', termPolicySvc);

    termPolicySvc.$inject = ['authSvc'];

    function termPolicySvc(authSvc){

    	

		/*
		 * exports public methods
		 */
		return {
		};
    }
})();

/**
 * Controller for home module
 */
(function(){

  angular
    .module('pixerf')
    .controller('termPolicyCtrl', termPolicyCtrl);

    termPolicyCtrl.$inject = ['termPolicySvc'];

    function termPolicyCtrl(termPolicySvc){
    	var self = this;
    }
})();

(function() {
  'use strict';

  angular
    .module('pixerf')
    .config(routerConfig);

  routerConfig.$inject = ['$stateProvider'];

  function routerConfig($stateProvider) {
    'ngInject';
    $stateProvider
      .state('term-policy', {
        url: '/term-policy',
        templateUrl: 'app/term-policy/term-policy.html',
        controller: 'termPolicyCtrl',
        controllerAs: 'vm',
        data: {
          permissions: {
            only: ['EVERY_ONE']
          },
          pageTitle: "PIXERF - Term and Policy" 
        }
      })
      .state('term-policy.term', {
        url: '/term',
        templateUrl: 'app/term-policy/term.html',
        controller: 'termPolicyCtrl',
        controllerAs: 'vm'
      })
      .state('term-policy.policy', {
        url: '/policy',
        templateUrl: 'app/term-policy/policy.html',
        controller: 'termPolicyCtrl',
        controllerAs: 'vm'
      });
  }

})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('signatureGalleriesDetailsPageCtrl', signatureGalleriesDetailsPageCtrl);

	signatureGalleriesDetailsPageCtrl.$inject = ['$scope', '$stateParams', '$state', 'toastr', 'pixerfApiCategorySvc', 'pixerfApiMediaSvc', 'photoDetailPopupSvc', 'stringUtils', 'sessionManagerSvc', '$location', 'numberUtils', 'systemUtils'];

	function signatureGalleriesDetailsPageCtrl($scope, $stateParams, $state, toastr, pixerfApiCategorySvc, pixerfApiMediaSvc, photoDetailPopupSvc, stringUtils, sessionManagerSvc, $location, numberUtils, systemUtils) {

		var self = this;
		self.photoGrid = null;
		self.params = {
			states: ['t', 'd', 'e'],
			categoryIds: [$stateParams.id]
		};
		self.onBackBtnClicked = onBackBtnClicked;
		self.onGalleriesChanged = onGalleriesChanged;
		self.onCurrentPageChanged = onCurrentPageChanged;
		self.onLoadMorePage = onLoadMorePage;
		self.onScrollToPhoto = onScrollToPhoto;
		self.category = $stateParams;
		self.galleries = [];
		self.fromExplore = ($state && $state.params && $state.params.fromExplore && ($state.params.fromExplore == 'explore')) ? true : false;
		self.pagingBarSetting = {
			zIndex: 550,
			marginTop: _.debounce(function () {
				return $(".signature-galleries-details-page__sub-navigate").height() + $(".main-header").height();
			}, 500),
			preFixed: function () {
				$(this).addClass('paging-bar-fixed');
			},
			postFixed: function () {
				$(this).removeClass('paging-bar-fixed');
			},
			dontSetWidth: true
		}


		init();

		function init() {
			self.params.states = self.fromExplore ? ['t', 'd', 'g'] : ['e', 't', 'd', 'g'];
			sessionManagerSvc.setMarketplaceTabHistory($location.$$url);
			getCategories();
			self.defaultGalleries = parseInt($stateParams.id);
			$scope.$watch("vm.photoGrid", function () {
				if (self.photoGrid && $scope.$parent) {
					extractSearchParam();
 					self.pagerText = stringUtils.toTitleCase($state.params.type).replace(/-/g, " ");
 					self.mobileBreadcrumb = self.pagerText;
 					self.page = self.params.page;
 					self.pagerUnit = null;
					self.photoGrid.fetchPhotos(self.params, true).then(function () {
						if ($scope.$parent && self) {
							self.totalPage = self.photoGrid.totalPage;
							self.totalPhotos = self.photoGrid.totalPhotos;
						}
					});
				}
			})
		}

		function onCurrentPageChanged(pageNumber) {
			var route = $state.current;
			self.params.page = pageNumber;
			self.page = pageNumber;

			$state.go(route, {
				page: pageNumber
			});
		}

		function updateUrlParams(page) {
			self.page = page;
			$state.params.page = page;
		   if (!systemUtils.isMobile()) {
			   $state.go($state.current.name, $state.params, {
				   notify: false
			   });
		   }
		}

		function onLoadMorePage(page) {
			updateUrlParams(page);
		}

		function onScrollToPhoto(page) {
			updateUrlParams(page);
		}

		function extractSearchParam() {
			self.params.page = 1;
			if ($state.params.page) {
				self.params.page = numberUtils.parseInt($state.params.page);
			}
			self.page = self.params.page ? self.params.page : 1;
		}

		function getCategories() {
			pixerfApiCategorySvc.get(function (response) {
				self.galleries = _.map(response, function (res) {
					return {
						title: res.name,
						value: res.id
					};
				});
			}, function () {
				toastr.error($translate.instant('failed-to-get-categories'));
			});
		}

		function onBackBtnClicked() {
			if(self.fromExplore){
			$state.go("buy-stock-page.about-stock");
			}else{
				$state.go("buy-stock-page.galleries.signature-galleries");
			}
		}

		function onGalleriesChanged(data) {
			self.category = data;
			self.params.page = 1;
			self.page = 1;
			self.params.categoryIds = [data.value];
			$state.go($state.current.name, {id: data.value, title: data.title, page: self.page}, {
				notify: false
			});
			self.photoGrid.fetchPhotos(self.params, true).then(function () {
				if ($scope.$parent && self) {
					self.totalPage = self.photoGrid.totalPage;
					self.totalPhotos = self.photoGrid.totalPhotos;
				}
			});
		}

		function onPhotoCLick(photoId) {
			pixerfApiMediaSvc.get({
				id: photoId
			}).$promise.then(function (response) {
				photoDetailPopupSvc.showPopup({
					photo: response.data
				});
			})
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.config(routerConfig);

	routerConfig.$inject = ['$stateProvider'];

	function routerConfig($stateProvider) {
		'ngInject';
		$stateProvider
			.state('signature-galleries-details-page', {
				url: '/signature-galleries/:id/:title/:fromExplore?page',
				templateUrl: 'app/signature-galleries-details-page/signature-galleries-details-page.html',
				controller: 'signatureGalleriesDetailsPageCtrl',
				controllerAs: 'vm',
				data: {
					pageTitle: "PIXERF - Signature galleries details",
					permissions: {
						only: ['EVERY_ONE']
					}
				}
			});
	}
})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.factory('signUpPageSvc', signUpPageSvc);
	signUpPageSvc.$inject = ['sessionManagerSvc', 'pixerfApiUserSvc', 'resendVerificationEmailPopupSvc', '$state', 'accountConst', 'toastr', '$q', 'accountUtils', 'store', 'translationSvc'];

	function signUpPageSvc(sessionManagerSvc, pixerfApiUserSvc, resendVerificationEmailPopupSvc, $state, accountConst, toastr, $q, accountUtils, store, translationSvc) {

		function finaliseSignupProgress(isPayAfterSignin) {
			var def = $q.defer();
			var signingUpUser = sessionManagerSvc.getSigningUpUser();
			signingUpUser.username = sessionManagerSvc.getProfile().user_id;
			registerUser(signingUpUser, isPayAfterSignin, def);
			sessionManagerSvc.setSigningUpUser(null);
			sessionManagerSvc.setFirstTimeLogin(null);
            def.resolve();
			return def.promise;

		}

		function buildSavedData(userData) {
			if (userData.account_type === accountConst.ACCOUNT_TYPE.PERSONAL) {
				userData = buildPersonalData(userData);
			} else if (userData.account_type === accountConst.ACCOUNT_TYPE.BUSINESS) {
				userData = buildBusinessData(userData);
			}
		}

		function buildPersonalData(userData) {
			var location = "";
			if (userData && userData.location) {
				location = accountUtils.getUserGoogleLocation(userData.location);
			}
			userData.location = location;

			return userData;
		}

		function buildBusinessData(userData) {
			var location = "";
			if (userData.organization && userData.organization.address && userData.organization.address.street1) {
				location = accountUtils.getUserGoogleLocation(userData.organization.address.street1);
			}
			userData.organization.address.street1 = location;

			return userData;
		}

		function registerUser(user, isPayAfterSignin, defer) {
			var def = $q.defer();
			buildSavedData(user)
			createUser(user).then(function (response) {
				def.resolve(response);
				sessionManagerSvc.setCurrentLoginUser(response);
				if(isPayAfterSignin){
					defer.resolve(response);
					return def.promise;
				}
				if (!response.isBiz) {
					user.is_contributor_agreement_accepted = true;
					pixerfApiUserSvc.put(user, function (response) {
						sessionManagerSvc.setCurrentLoginUser(response);
						if (!response.is_email_verified) {
							resendVerificationEmailPopupSvc.showSignupCompletedPopup();
						}
						if(store.get('PIXERF.CALLBACK_ROUTE') == 'trend-report-landing-page'){
							store.remove('PIXERF.CALLBACK_ROUTE');
							$state.go('trends-report-download-page');
							return;
						}
						if(!response.account_type){
							$state.go("user-home-page.guest.home", {id: response.id});
						}else{
							$state.go("complete-profile-page");
						}
					});
				} else {
					if(store.get('PIXERF.CALLBACK_ROUTE') == 'trend-report-landing-page'){
						store.remove('PIXERF.CALLBACK_ROUTE');
						$state.go('trends-report-download-page');
						return;
					}
					$state.go("user-home-page.business");
				}
			}, function (err) {
				def.reject(err);
				toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
			});
			return def.promise;
		}

		function createUser(user) {
			console.log(user);
			if (user.account_type === accountConst.ACCOUNT_TYPE.BUSINESS) {
				delete user.organization;
			}
			return pixerfApiUserSvc.put(user).$promise;
		}

		return {
			finaliseSignupProgress: finaliseSignupProgress
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.config(routerConfig);

	routerConfig.$inject = ['$stateProvider'];

	function routerConfig($stateProvider) {
		'ngInject';
		$stateProvider
			.state('sign-up', {
				url: '/sign-up?code',
				abstract: true,
				templateUrl: 'app/sign-up-page/sign-up-page.html',
				data: {
					pageTitle: "PIXERF - Sign Up",
					hideFooter: true
				}
			})
			.state('sign-up.sign-up-personal-email', {
				url: '/sign-up-personal-email',
				templateUrl: 'app/sign-up-page/components/sign-up-personal-email/sign-up-personal-email.html',
				controller: 'signUpPersonalEmailCtrl',
				controllerAs: 'vm',
				data: {
					pageTitle: "PIXERF - Sign Up Personal",
					permissions: {
                        only: ['EVERY_ONE']
                    }
				}
			})
			.state('sign-up.sign-up-personal-info', {
				url: '/sign-up-personal-info',
				templateUrl: 'app/sign-up-page/components/sign-up-personal-info/sign-up-personal-info.html',
				controller: 'signUpPersonalInfoCtrl',
				controllerAs: 'vm',
				data: {
					pageTitle: "PIXERF - Sign Up Personal",
					permissions: {
                        only: ['EVERY_ONE']
                    }
				},
				resolve: {
					userPromise: function (signUpPersonalInfoSvc, $state, $q) {
						var defer = $q.defer();
						if (!signUpPersonalInfoSvc.user || !signUpPersonalInfoSvc.user.data) {
							$state.go('sign-up.sign-up-personal-email');
							defer.reject();
						} else {
							defer.resolve(signUpPersonalInfoSvc.user);
						}
						return defer.promise;
					}
				}
			})
			.state('sign-up.sign-up-business-email', {
				url: '/sign-up-business-email',
				templateUrl: 'app/sign-up-page/components/sign-up-business-email/sign-up-business-email.html',
				controller: 'signUpBusinessEmailCtrl',
				controllerAs: 'vm',
				data: {
					pageTitle: "PIXERF - Sign Up Business",
					permissions: {
                        only: ['EVERY_ONE']
                    }
				}
			})
			.state('sign-up.sign-up-business-info', {
				url: '/sign-up-business-info',
				templateUrl: 'app/sign-up-page/components/sign-up-business-info/sign-up-business-info.html',
				controller: 'signUpBusinessInfoCtrl',
				controllerAs: 'vm',
				data: {
					pageTitle: "PIXERF - Sign Up Business",
					permissions: {
                        only: ['EVERY_ONE']
                    }
				},
				resolve: {
					userPromise: function (signUpBusinessInfoSvc, $state, $q) {
						var defer = $q.defer();
						if (!signUpBusinessInfoSvc.user || !signUpBusinessInfoSvc.user.data) {
							$state.go('sign-up.sign-up-business-email');
							defer.reject();
						} else {
							defer.resolve(signUpBusinessInfoSvc.user);
						}
						return defer.promise;
					}
				}
			})
			.state('sign-up.select-account-type', {
				url: '',
				templateUrl: 'app/sign-up-page/components/select-sign-up-type/select-sign-up-type.html',
				controller: 'selectSignUpTypeCtrl',
				controllerAs: 'vm',
				data: {
					pageTitle: "PIXERF - Select Account Type",
					permissions: {
                        only: ['EVERY_ONE']
                    }
				}
			});
	}
})();

(function () {

	angular
		.module('pixerf')
		.factory('signInPopupSvc', signInPopupSvc);

		signInPopupSvc.$inject = ['$uibModal'];

	function signInPopupSvc( $uibModal) {
		function showPopup(data) {

			return $uibModal.open({
				templateUrl: 'app/sign-in-popup/sign-in-popup.html',
				controller: 'signInPopupCtrl',
				controllerAs: 'vm',
				animation: true,
				windowClass: 'sign-in-popup__modal',
				backdrop: 'static',
				resolve: {
					'resolveData': function () {
						return data;
					}
				}
			});
		}

		return {
			showPopup: showPopup
		};
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('signInPopupCtrl', signInPopupCtrl);

		signInPopupCtrl.$inject = ['$scope', '$uibModalInstance', 'signUpBusinessPopupSvc', 'store', 'accountConst', '$state', 'resolveData'];

	function signInPopupCtrl($scope, $uibModalInstance, signUpBusinessPopupSvc, store, accountConst, $state, resolveData) {
		var self = this;
		self.userType = resolveData && resolveData.userType;
		self.isBiz = (self.userType === accountConst.ACCOUNT_TYPE.BUSINESS);
		self.cancel = function () {
            $uibModalInstance.dismiss('cancel');
		};

		self.showSignupPopup = function(){
			$uibModalInstance.dismiss('cancel');
			signUpBusinessPopupSvc.showPopup({});
		}
		self.options = {
			'isBiz' : self.isBiz,
			'customSignupAction': self.isBiz ? self.showSignupPopup : '',
			'hiddenLoginBySocial': self.isBiz,
			'beforeSignin':  self.isBiz ? self.beforeSignin : ''
		}

		self.beforeSignin = function(user){
			store.set(accountConst.TOKEN.CREDIT_PLAN_AFTER_SIGNED_EMAIL, user.data.email);
			store.set(accountConst.TOKEN.CREDIT_PLAN_AFTER_SIGNED_PAGE, $state.current.name);
		}
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('signInPageCtrl', signInPageCtrl);

	signInPageCtrl.$inject = ['$scope'];

	function signInPageCtrl($scope) {
		var self = this;
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.config(routerConfig);

	routerConfig.$inject = ['$stateProvider'];

	function routerConfig($stateProvider) {
		'ngInject';
		$stateProvider
			.state('sign-in-page', {
				url: '/sign-in',
				templateUrl: 'app/sign-in-page/sign-in-page.html',
				data: {
					pageTitle: "PIXERF - Sign In",
					hideFooter: true
				},
				controller: 'signInPageCtrl',
				controllerAs: 'vm'
			});
	}

})();

(function () {

	angular
		.module('pixerf')
		.factory('settingSvc', settingSvc);

	settingSvc.$inject = ['$uibModal', 'accountConst', 'accountUtils', 'sessionManagerSvc'];

	function settingSvc($uibModal, accountConst, accountUtils, sessionManagerSvc) {

		var mUserAvatar = {
			data: null
		};
		var mUser = {
			data: null
		}
		var mEditProfileRoute = {
			data: null
		};
		var mUsername = {
			data: null
		};

		function setUser(user) {
			mUser.data = user;
		}

		function getUser() {
			mUser.data = sessionManagerSvc.getCurrentLoginUser().data;
			return mUser;
		}

		function getUserAvatar(user) {
			mUserAvatar.data = accountUtils.buildUserAvatarPhotoUrl(user);
			return mUserAvatar;
		}

		function showUploadModal(params) {
			var uploadModal = $uibModal.open({
				size: 'lg',
				openedClass: 'upload-profile-photo-popup',
				templateUrl: 'app/components/upload-profile-photo/upload-profile-photo.html',
				controller: 'uploadProfilePhotoCtrl',
				controllerAs: 'vm',
				resolve: {
					data: function () {
						return params;
					}
				}
			});

			return uploadModal;
		}

		function updateUserProfilePhotos(userData, type, thumbnail) {

			if (type === "cover") {
				userData.cover_image = thumbnail['1200x'];
				userData.avatar.coverImage = accountUtils.buildUserCoverPhotoUrl(userData.id, thumbnail);
			} else {
				userData.profile_image = thumbnail['300x'];
				var avatarUrl = accountUtils.buildUserProfilePhotoUrl(userData.id, thumbnail);
				userData.avatar.profileImageSmall = avatarUrl.profileImageSmall;
				userData.avatar.profileImage = avatarUrl.profileImage;
				userData.avatar.profileImageBig = avatarUrl.profileImageBig;
				if(userData.profile_image_media){
					userData.profile_image_media['100x'] = (thumbnail && thumbnail['100x']) ? thumbnail['100x'] : userData.profile_image_media['100x'];
					userData.profile_image_media['300x'] = (thumbnail && thumbnail['300x']) ? thumbnail['300x'] : userData.profile_image_media['300x'];
					userData.profile_image_media['800x'] = (thumbnail && thumbnail['800x']) ? thumbnail['800x'] : userData.profile_image_media['800x'];
				}
			}
			sessionManagerSvc.setCurrentLoginUser(userData);
		}

		function getEditProfileRoute(user) {
			if (user.account_type === accountConst.ACCOUNT_TYPE.PERSONAL) {
				mEditProfileRoute.data = ".edit_profile_personal";
			} else if (user.account_type === accountConst.ACCOUNT_TYPE.BUSINESS) {
				mEditProfileRoute.data = ".edit_profile_business";
			}else{
				mEditProfileRoute.data = ".edit_profile_business";
			}
			return mEditProfileRoute
		}

		function isAbleToChangePassword() {
			return !accountUtils.isSocialAccount(sessionManagerSvc.getCurrentLoginUser().data);
		}

		return {
			getUser: getUser,
			showUploadModal: showUploadModal,
			getUserAvatar: getUserAvatar,
			getEditProfileRoute: getEditProfileRoute,
			setUser: setUser,
			isAbleToChangePassword: isAbleToChangePassword,
			updateUserProfilePhotos: updateUserProfilePhotos
		};
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('settingCtrl', settingCtrl);

	settingCtrl.$inject = ['settingSvc', 'uploadProfilePhotoSvc', '$state', 'notifyTopupCreditPopupSvc', 'notifyFeatureNotAvailablePopupSvc', 'pixerfApiUserSvc',
		'sessionManagerSvc', '$rootScope', 'messageConst', '$scope', '$timeout'
	];

	function settingCtrl(settingSvc, uploadProfilePhotoSvc, $state, notifyTopupCreditPopupSvc, notifyFeatureNotAvailablePopupSvc, pixerfApiUserSvc,
		sessionManagerSvc, $rootScope, messageConst, $scope, $timeout) {
		var USER_CONTROL_ADMINDASHBOARD = ['curator_internal', 'admin_internal', 'marketer_internal'];
		var self = this;
		$scope.$state = $state;
		self.contextPage = 'edit-profile';
		self.user = settingSvc.getUser().data;
		self.showUploadUserProfilePhotos = showUploadUserProfilePhotos;
		self.onEditProfileClicked = settingSvc.navigate;
		self.editProfileRoute = settingSvc.getEditProfileRoute(self.user);
		self.isAbleToChangePassword = settingSvc.isAbleToChangePassword();
		self.onManageMissionClicked = onManageMissionClicked;
		self.onManageCommunityBtnClicked = onManageCommunityBtnClicked;
		self.onManageCommussionsBtnClicked = onManageCommussionsBtnClicked;
		self.onContributorChallengesClicked = onContributorChallengesClicked;
        self.onUserVerificationClicked = onUserVerificationClicked;
        self.onManageMediaPostClicked = onManageMediaPostClicked;
		self.loginedUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.isAdmin = self.loginedUser && (USER_CONTROL_ADMINDASHBOARD.includes(self.loginedUser.role) || self.loginedUser.email === 'marcom@pixerf.com');
		self.canCreateMission = self.loginedUser && (self.loginedUser.isMaketerInternal || self.loginedUser.isAdminInternal || (self.loginedUser.email === 'marcom@pixerf.com'));
		self.guestUser = self.loginedUser && !self.loginedUser.account_type;
		self.dashboardNavigationOptions = {
			marginTop: _.debounce(function () {
				return 58;
			}, 500),
			limit: _.debounce(function () {
				return $(".setting__col-right").height();
			}, 500),
			dontSetWidth: false,
			zIndex: 100
		}

		$rootScope.$on(messageConst.BROADCAST.USER_DATA_CHANGE, function () {
			self.loginedUser = sessionManagerSvc.getCurrentLoginUser().data;
			self.guestUser = self.loginedUser && !self.loginedUser.account_type;
			self.updatingdAvatar = true;
			self.user = settingSvc.getUser().data;
			$timeout(function () {
				self.updatingdAvatar = false;
				console.log(self.loginedUser.profile_image_media['100x'])
			}, 500)
		});

		function showUploadUserProfilePhotos(type) {
			var modal = uploadProfilePhotoSvc.showPopup({
				'type': type
			});
			modal.result.then(function (data) {
				var userImage = {};
				if (self.user.isBiz && self.user.isAdmin) {
					if (type == 'profile') {
						userImage.profile_image = data.response.handle ? data.response.handle : data.thumbnails["300x"];
					} else if (type == 'cover') {
						userImage.cover_image = data.thumbnails['1200x'];
					}
					pixerfApiUserSvc.put({}, userImage).$promise.then(function () {
						settingSvc.updateUserProfilePhotos(self.user, type, data.thumbnails);
					})
				} else {
					settingSvc.updateUserProfilePhotos(self.user, type, data.thumbnails);
				}
			}, function () {});
		}

		function onManageMissionClicked() {
			if (self.user && self.user.canCreateMission) {
				$state.go("setting.manage-missions.on-going");
				// $state.go("setting.manage-missions.create-mission.getting-started");
			}
		}

		function onManageCommunityBtnClicked() {
			notifyFeatureNotAvailablePopupSvc.showPopup();
		}

		function onManageCommussionsBtnClicked() {
			$state.go("setting.manage-custom-commissions.on-going");
		}

		function onContributorChallengesClicked(){
			$state.go("setting.manage-photos-mission.pending");
		}

        function onUserVerificationClicked(){
            $state.go("setting.user-verification.sign-up");
        }

        function onManageMediaPostClicked(){
            $state.go("setting.manage-media-post.create-post");
        }
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.config(routerConfig);

	routerConfig.$inject = ['$stateProvider'];

	function routerConfig($stateProvider) {
		'ngInject';
		$stateProvider

			.state('setting', {
				url: '/setting',
				templateUrl: 'app/setting/setting.html',
				controller: 'settingCtrl',
				controllerAs: 'vm',
				data: {
					permissions: {
						only: ['AUTHORIZED'],
						redirectTo: function () {
							return {
								state: 'home',
								params: {
									callback: location.hash.replace("#", '')
								}
							}
						}
					},
					hideFooter: true,
					pageTitle: "PIXERF - Setting your profile"
				}
			})
			.state('setting.edit_password', {
				url: '/edit/password',
				templateUrl: 'app/components/edit-password/edit-password.html',
				controller: 'editPasswordCtrl',
				controllerAs: 'vm',
				data: {
					permissions: {
						only: ['NONE_SOCIAL_NETWORK_USER']
					},
					pageTitle: "PIXERF - Edit your password"
				}
			})
			.state('setting.add_role', {
				url: '/edit/role',
				templateUrl: 'app/components/add-role/add-role.html',
				controller: 'addRoleCtrl',
				controllerAs: 'vm',
				data: {
					permissions: {
						only: ['NONE_SOCIAL_NETWORK_USER']
					},
					pageTitle: "PIXERF - Assign roles"
				}
			})
			.state('setting.edit_subscription', {
				url: '/edit/subscription',
				templateUrl: 'app/components/edit-subscription/edit-subscription.html',
				controller: 'editSubscriptionCtrl',
				controllerAs: 'vm',
				data: {
					pageTitle: "PIXERF - Edit subscription"
				}
			})
			.state('setting.edit_profile_personal', {
				url: '/edit/profile_personal',
				templateUrl: 'app/components/edit-profile/edit-profile-personal.html',
				controller: 'editProfileCtrl',
				controllerAs: 'vm',
				data: {
					pageTitle: "PIXERF - Edit your profile"
				}
			})
			.state('setting.edit_profile_business', {
				url: '/edit/profile_business',
				templateUrl: 'app/components/edit-profile/edit-profile-business.html',
				controller: 'editProfileCtrl',
				controllerAs: 'vm',
				data: {
					pageTitle: "PIXERF - Edit your profile"
				}
			})
            .state('setting.change-password', {
				url: '/edit/change-password',
				templateUrl: 'app/components/change-password/change-password.html',
				controller: 'changePasswordCtrl',
				controllerAs: 'vm',
				data: {
					pageTitle: "PIXERF - Change Password"
				}
			})
			.state('setting.my_credit', {
				url: '/edit/my-credit',
				templateUrl: 'app/components/my-credit/my-credit.html',
				controller: 'myCreditCtrl',
				controllerAs: 'vm',
				data: {
					pageTitle: "PIXERF - My credit"
				}
			})
			.state('setting.manage-missions', {
				url: '/manage-missions',
				templateUrl: 'app/manage-missions/manage-missions.html',
				controller: 'manageMissionsCtrl',
				controllerAs: 'vm',
				data: {
					pageTitle: "PIXERF - Manage missions"
				}
			})
			.state('setting.manage-custom-commissions', {
				url: '/manage-custom-commissions',
				templateUrl: 'app/manage-custom-commissions/manage-custom-commissions.html',
				controller: 'manageCustomCommissionsCtrl',
				controllerAs: 'vm',
				data: {
					pageTitle: "PIXERF - Manage Custom Commissions"
				}
			});
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('sendVerifyEmailPageCtrl', sendVerifyEmailPageCtrl);

	sendVerifyEmailPageCtrl.$inject = ['$scope', 'sessionManagerSvc', 'pixerfApiMailSvc', 'toastr', 'translationSvc'];

	function sendVerifyEmailPageCtrl($scope, sessionManagerSvc, pixerfApiMailSvc, toastr, translationSvc) {

		var self = this;

		self.isWorking = false;
		self.onResendEmailClicked = onResendEmailClicked;
		self.loginnedUser = sessionManagerSvc.getCurrentLoginUser().data;

		function onResendEmailClicked() {
			if (self.isWorking) return;
			self.isWorking = true;
			var mLoginUser = sessionManagerSvc.getCurrentLoginUser().data;
			if (!mLoginUser.is_email_verified) {
				pixerfApiMailSvc.resend({ email: mLoginUser.email }).$promise.then(function (response) {
					self.isWorking = false;
					toastr.success("A verification email has been sent to " + mLoginUser.email + ", please check your email!");
				}, function (err) {
					self.isWorking = false;
					console.log(err);
					toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
				});
			} else {
				self.isWorking = false;
				toastr.warning(mLoginUser.email + " is verified");
			}
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.config(routerConfig);

	routerConfig.$inject = ['$stateProvider'];

	function routerConfig($stateProvider) {
		'ngInject';
		$stateProvider
			.state('send-verify-email-page', {
				url: '/send-verify-email',
				templateUrl: 'app/send-verify-email-page/send-verify-email-page.html',
				data: {
					pageTitle: "PIXERF - Send Verify Email",
				},
				controller: 'sendVerifyEmailPageCtrl',
				controllerAs: 'vm'
			});
	}

})();

(function () {

	angular
		.module('pixerf')
		.controller('runAChallengePageCtrl', runAChallengePageCtrl);

	runAChallengePageCtrl.$inject = ['sessionManagerSvc'];

	function runAChallengePageCtrl(sessionManagerSvc) {

		var self = this;
		self.contextPage = "Explore Challenges";
		self.loginnedUser = sessionManagerSvc.getCurrentLoginUser().data;
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.config(routerConfig);

	routerConfig.$inject = ['$stateProvider'];

	function routerConfig($stateProvider) {
		'ngInject';
		$stateProvider
			.state('run-a-challenge-page', {
				abstract: true,
				url: '/run-a-challenge-page',
				templateUrl: 'app/run-a-challenge-page/run-a-challenge-page.html',
				controller: 'runAChallengePageCtrl',
				controllerAs: 'vm',
				data: {
					pageTitle: "PIXERF - Run A Challenge",
					permissions: {
						only: ['EVERY_ONE']
					},
					headerClass: 'run-a-challenge-highlight'
				}
			})
			.state('run-a-challenge-page.live-challenges', {
				url: '/live-challenges',
				templateUrl: 'app/run-a-challenge-page/components/live-challenges/live-challenges.html',
				controller: 'liveChallengesCtrl',
				controllerAs: 'vm',
                data: {
					pageTitle: "PIXERF - Live Challenges"
                }
			})
			.state('run-a-challenge-page.joined-challenges', {
				url: '/joined-challenges',
				templateUrl: 'app/run-a-challenge-page/components/joined-challenges/joined-challenges.html',
				controller: 'joinedChallengesCtrl',
				controllerAs: 'vm',
                data: {
					pageTitle: "PIXERF - Joined Challenges"
                }
			})
			.state('run-a-challenge-page.past-challenges', {
				url: '/past-challenges',
				templateUrl: 'app/run-a-challenge-page/components/past-challenges/past-challenges.html',
				controller: 'pastChallengesCtrl',
				controllerAs: 'vm',
                data: {
					pageTitle: "PIXERF - Past Challenges"
                }
			})
			.state('run-a-challenge-page.community-challenge-agreement', {
				url: '/community-challenge-agreement',
				templateUrl: 'app/run-a-challenge-page/components/community-challenge-agreement/community-challenge-agreement.html',
				controller: 'communityChallengeAgreementCtrl',
				controllerAs: 'vm',
                data: {
					pageTitle: "PIXERF - Community Challenge Agreement"
                }
			})
			.state('run-a-challenge-page.community-challenge-agreement-gojek', {
				url: '/community-challenge-agreement-gojek',
				templateUrl: 'app/run-a-challenge-page/components/community-challenge-agreement-gojek/community-challenge-agreement-gojek.html',
				controller: 'communityChallengeAgreementGojekCtrl',
				controllerAs: 'vm',
                data: {
					pageTitle: "PIXERF - Community Challenge Agreement Gojek"
                }
			})
			.state('run-a-challenge-page.challenge-sponsor-agreement', {
				url: '/challenge-sponsor-agreement',
				templateUrl: 'app/run-a-challenge-page/components/challenge-sponsor-agreement/challenge-sponsor-agreement.html',
				controller: 'challengeSponsorAgreementCtrl',
				controllerAs: 'vm',
                data: {
					pageTitle: "PIXERF - Challenge Sponsor Agreement"
                }
			})
			.state('run-a-challenge-page.about-challenge', {
				url: '',
				templateUrl: 'app/run-a-challenge-page/components/about-challenge/about-challenge.html',
				controller: 'aboutChallengeCtrl',
				controllerAs: 'vm',
                data: {
					pageTitle: "PIXERF - About Challenge"
                }
			});
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('referralStartEarningCtrl', referralStartEarningCtrl);

	referralStartEarningCtrl.$inject = ['$stateParams', '$state', 'selectSignUpTypePopupSvc'];

	function referralStartEarningCtrl($stateParams, $state, selectSignUpTypePopupSvc) {

		var self = this;
		self.onSignupClicked = onSignupClicked;

		function onSignupClicked(){
			selectSignUpTypePopupSvc.showPopup({referredBy: $stateParams.code});
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.config(routerConfig);

	routerConfig.$inject = ['$stateProvider'];

	function routerConfig($stateProvider) {
		'ngInject';
		$stateProvider
			.state('referral-start-earning-page', {
				url: '/referral-start-earning-page?code',
				templateUrl: 'app/referral-start-earning-page/referral-start-earning-page.html',
				controller: 'referralStartEarningCtrl',
				controllerAs: 'vm',
				data: {
					pageTitle: "PIXERF - Referral Start Earning",
				}
			});
	}

})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('referralProgramPageCtrl', referralProgramPageCtrl);

	referralProgramPageCtrl.$inject = ['$scope', 'signInSvc', 'sessionManagerSvc', '$state', 'selectSignUpTypePopupSvc'];

	function referralProgramPageCtrl($scope, signInSvc, sessionManagerSvc, $state, selectSignUpTypePopupSvc) {

		var self = this;
		self.loginUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.onSignUpClicked = onSignUpClicked;
		self.onSigninClicked = onSigninClicked;
		self.brandingPhoto = {
			"id": 93225,
			"title": "Woman taking Selfie outdoor_02",
			"user": {
				"name": "Geoff Ang",
				"id": 34885
			}
		};

		function onSigninClicked(){
			if(self.loginUser){
				$state.go('setting.referral_program.invite');
			} else {
				sessionManagerSvc.setCallbackURL("/setting/invite-friends");
				signInSvc.showSignInModal();
			}
		}
		function onSignUpClicked(){
			selectSignUpTypePopupSvc.showPopup();
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.config(routerConfig);

	routerConfig.$inject = ['$stateProvider'];

	function routerConfig($stateProvider) {
		'ngInject';
		$stateProvider
			.state('referral-program', {
				url: '/about-referral',
				templateUrl: 'app/referral-program-landing-page/referral-program-landing-page.html',
				controller: 'referralProgramLandingPageCtrl',
				controllerAs: 'vm',
				data: {
					pageTitle: "PIXERF - Referral"
				}
			});
	}

})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('referralProgramLandingPageCtrl', referralProgramLandingPageCtrl);

	referralProgramLandingPageCtrl.$inject = ['$scope', 'sessionManagerSvc', 'signInSvc', '$state'];

	function referralProgramLandingPageCtrl($scope, sessionManagerSvc, signInSvc, $state) {

		var self = this;
		self.onSectionClicked = onSectionClicked;
		self.loginUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.onSigninClicked = onSigninClicked;
		self.brandingPhoto = {
			"id": 93225,
			"title": "Woman taking Selfie outdoor_02",
			"user": {
				"name": "Geoff Ang",
				"id": 34885
			}
		};

		function onSigninClicked(){
			if(self.loginUser){
				$state.go('setting.referral_program.invite');
			} else {
				sessionManagerSvc.setCallbackURL("/setting/invite-friends");
				signInSvc.showSignInModal();
			}
		}

		function onSectionClicked(target){
            if(target === self.targetSection){
                self.targetSection = null;
            } else {
                self.targetSection = target;
            }
        }
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.config(routerConfig);

	routerConfig.$inject = ['$stateProvider'];

	function routerConfig($stateProvider) {
		'ngInject';
		$stateProvider
			.state('referral-program-landing-page', {
				url: '/about-referral-landing',
				templateUrl: 'app/referral-program-page/referral-program-page.html',
				controller: 'referralProgramPageCtrl',
				controllerAs: 'vm',
				data: {
					pageTitle: "PIXERF - About Referral",
					permissions: {
						only: ['REFERRAL_MANAGER']
					}
				}
			});
	}

})();

(function () {

	angular
		.module('pixerf')
		.controller('referralCongratPageCtrl', referralCongratPageCtrl);

	referralCongratPageCtrl.$inject = ['$scope', '$state', '$stateParams', 'signUpPersonalPopupSvc'];

	function referralCongratPageCtrl($scope, $state, $stateParams, signUpPersonalPopupSvc) {
		var self = this;
		self.onNextBtnClicked = onNextBtnClicked;

		function onNextBtnClicked(){
			signUpPersonalPopupSvc.showPopup({referredBy: $stateParams.code});
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.config(routerConfig);

	routerConfig.$inject = ['$stateProvider'];

	function routerConfig($stateProvider) {
		'ngInject';
		$stateProvider
			.state('referral-congrat-page', {
				url: '/referral-congrat-page?code',
				templateUrl: 'app/referral-congrat-page/referral-congrat-page.html',
				controller: 'referralCongratPageCtrl',
				controllerAs: 'vm',
				data: {
					pageTitle: "PIXERF - Referral Congratulations",
				}
			});
	}

})();

/**
 * Controller for home module
 */
(function () {

	angular
		.module('pixerf')
		.controller('portfolioDetailPageCtrl', portfolioDetailPageCtrl);

	portfolioDetailPageCtrl.$inject = ['$scope'];

	function portfolioDetailPageCtrl($scope) {
		var self = this;
		$scope.$parent.vm.contextPage = "Portfolio";
	}
})();

(function () {
    'use strict';

    angular
        .module('pixerf')
        .config(routerConfig);

    routerConfig.$inject = ['$stateProvider'];

    function routerConfig($stateProvider) {
        'ngInject';
        $stateProvider
            .state('portfolio-detail-page', {
                url: '/portfolio-detail-page/:id/:name',
                abstract: true,
                templateUrl: 'app/portfolio-detail-page/portfolio-detail-page.html',
                controller: 'portfolioDetailPageCtrl',
                controllerAs: 'vm',
                data: {
                    pageTitle: "PIXERF - Portfolio Detail",
                    perPortfolios: {
                        only: ['EVERY_ONE']
                    }
                },
                resolve: {
                    portfolioData: function ($stateParams, pixerfApiPortfolioSvc, $q, $state, toastr, messageConst) {
                        var defer = $q.defer();
                        var self = this;
                        var id = parseInt($stateParams.id);
                        if (!id || (id && isNaN(id))) {
                            $state.go('404');
                            defer.reject();
                        } else {
                            pixerfApiPortfolioSvc.getUserPortfolios({ id: id }).$promise.then(function (response) {
                                var portfolio = response.data;
                                self.data.pageTitle = "PIXERF - Portfolio: " + portfolio.name;
                                defer.resolve(portfolio);
                            }, function () {
                                $state.go('404');
                                defer.reject();
                            })
                        }
                        return defer.promise;
                    }
                }
            })
            .state('portfolio-detail-page.portfolio-photos', {
                url: '',
                templateUrl: 'app/portfolio-detail-page/portfolio-detail-page-photos/portfolio-detail-page-photos.html',
                controller: 'portfolioDetailPagePhotosCtrl',
                controllerAs: 'vm'
            });
    }

})();

(function () {

	angular
    .module('pixerf')
    .controller('photographerPageCtrl', photographerPageCtrl);

	photographerPageCtrl.$inject = ['$scope', 'sessionManagerSvc'];

	function photographerPageCtrl($scope, sessionManagerSvc) {
		var self = this;

		self.loginUser = sessionManagerSvc.getCurrentLoginUser().data;
		$scope.$parent.vm.mobileBreadcrumb = "Photographers";

	}
})();

﻿/*
 * Service handler for Home module
 * We will implement all business logic for "photoPage" module here
 */
/**
 * Controller for photoPage module
 */
(function () {

  angular
    .module('pixerf')
    .factory('photoPageSvc', photoPageSvc);

  photoPageSvc.$inject = ['fileUtils'];

  function photoPageSvc(fileUtils) {

    var mOriginalPhoto = {
      data: null
    }
    var mPhoto = {
      data: null
    }
    function setOriginalPhoto(value) {
      mOriginalPhoto.data = value;
    }
    function getOriginalPhoto() {
      return mOriginalPhoto;
    }
    function setPhoto(value) {
      mPhoto.data = value;
    }
    function getPhoto() {
      return mPhoto;
    }
		/*
		 * exports public methods
		 */
    return {
      setOriginalPhoto: setOriginalPhoto,
      getOriginalPhoto: getOriginalPhoto,
      setPhoto: setPhoto,
      getPhoto: getPhoto

    };
  }
})();

(function(){

  angular
    .module('pixerf')
    .controller('photoPageCtrl', photoPageCtrl);

    photoPageCtrl.$inject = ['photoPageSvc', '$state', 'toastr', 'photoPromise', '$timeout', '$rootScope', 'photoDetailSvc', 'messageSvc', '$translate'];

    function photoPageCtrl(photoPageSvc, $state, toastr, photoPromise, $timeout, $rootScope, photoDetailSvc, messageSvc, $translate){
        var self = this;

        self.photo = photoPromise;
        self.isEditing = {data: false};
        self.photoViewer = {};
        self.modal = null;
        self.onDeletePhotoBtnClicked = onDeletePhotoBtnClicked;
        var listenerID =  $rootScope.$on('$stateChangeStart', function(event, toState, toParams, fromState, fromParams, options){
            if(fromState.name === 'photo'){
                //need to do this because there is a bug with stateChangeStart get called twice
                if(self.modal){
                    event.preventDefault();
                    return false;
                }
                if(photoDetailSvc.isEdited(photoDetailSvc.getOriginalPhoto().data, photoDetailSvc.getPhoto().data, self.photoViewer, self.isEditing.data)){
                    event.preventDefault();
                    self.modal =  messageSvc.warnLeavingWithoutSaving();
                    self.modal.result.then(function(){
                        window.removeEventListener("beforeunload", beforeUnloadHandler); // unregister when leaving Photo Page to another page.
                        listenerID(); //cancel listener
                        self.modal.close();
                        self.modal = null;
                        // //leave the Photo Page
                        $state.go(toState.name, toParams, {reload: true});
                    }, function(){
                        self.modal = null;
                    })
                } else {// if nothing changes on photo ,just cancel listener and do the navigation.
                    listenerID();
                }
            }
        })

        function isDifferentRoute(toState, toParams, fromState, fromParams){
            return fromState.name !== toState.name || (fromState.name === toState.name && fromParams.id !== toParams.id);
        }
        function beforeUnloadHandler(event){
            var confirmationMessage = $translate.instant("are-you-sure");
            if(photoDetailSvc.isEdited(photoDetailSvc.getOriginalPhoto().data, photoDetailSvc.getPhoto().data, self.photoViewer, self.isEditing.data)){
                event.returnValue = confirmationMessage;     // Gecko, Trident, Chrome 34+
                return confirmationMessage;
            }
        }
        window.removeEventListener("beforeunload", beforeUnloadHandler);
        window.addEventListener("beforeunload", beforeUnloadHandler);
        function onDeletePhotoBtnClicked(photo){
            photoDetailSvc.setOriginalPhoto(null);
            photoDetailSvc.setPhoto(null);
            $timeout(function(){
               window.history.go(-1);
            })
        }
    }
})();

(function() {
  'use strict';

  angular
    .module('pixerf')
    .config(routerConfig);

  routerConfig.$inject = ['$stateProvider'];

  function routerConfig($stateProvider) {
    'ngInject';
    $stateProvider
      .state('photo', {
        url: '/photo/:id/:photoTitle',
        templateUrl: 'app/photo-page/photo-page.html',
        controller: 'photoPageCtrl',
        controllerAs: 'vm',
        data: {
                permissions: {
                only: ['EVERY_ONE']
            },
            pageTitle: "PIXERF - Photo",
            hideFooter: true
        },
        params: {
          photo: null,
          "id": { squash: true, value: null },
          "photoTitle": { squash: true, value: null }
        },
        resolve: {
          photoPromise: function($stateParams, pixerfApiMediaSvc, sessionManagerSvc, $q, $location, $state, cartSvc, fileUtils){
            var self = this;
            var defer = $q.defer();
            var loginUser = sessionManagerSvc.getCurrentLoginUser().data;
            var photoid = parseInt($stateParams.id);
            if($stateParams.photo){
              defer.resolve($stateParams.photo);
            } else {
              pixerfApiMediaSvc.get({id: photoid}).$promise.then(function(response){
                  if(!response.data) {
                      $state.go('404');
                      defer.reject(response.data);
                      return;
                  }
                  self.data.pageTitle = "PIXERF - " + fileUtils.buildFileSeoTitle(response.data);
                  defer.resolve(response.data);
              }, function(err){
                  if(err.status === 500 || err.status === 404){
                    $state.go(err.status + '');
                  }
                  defer.reject(err);
              })
            }
            return defer.promise;
          }
        }
      });
  }

})();

(function(){

  angular
    .module('pixerf')
    .controller('peoplesPageCtrl', peoplesPageCtrl);

    peoplesPageCtrl.$inject = ['peopleListPopupSvc', '$state', 'pagingUtils', 'toastr', 'sessionManagerSvc', 'headerSvc', 'userHomePageSvc', '$q', 'pixerfApiUserSvc', 'translationSvc'];

    function peoplesPageCtrl(peopleListPopupSvc, $state, pagingUtils, toastr, sessionManagerSvc, headerSvc, userHomePageSvc, $q, pixerfApiUserSvc, translationSvc){
        var self = this;
        self.peoples = null;
        self.onFollowStatusChanged = onFollowStatusChanged;
        self.onSearchStringChanged = _.debounce(onSearchStringChanged, 300);
        self.fetchPeopleList = fetchPeopleList;
        self.fetchMorePeoples = fetchMorePeoples;
        self.totalPeoples = 0;
        self.pageTitle = '';
        self.isMine = false;
        self.isLastPage = false;
        self.isEmptyState = false;
        self.spinner = {
            isVisible: false
        }
        self.searchParams = {page: 1, page_size: 24};
        self.searchUserAffection = {page: 1, page_size: 24};
        self.searchFilterBarSettings = headerSvc.getFixedByHeaderSetting();
        self.loginUser = sessionManagerSvc.getCurrentLoginUser().data;

        init();

        function extractParams(){
            self.searchParams.action = $state.params.affectionType;
            self.searchParams.personId =  $state.params.userId;
        }
        function init(){
            self.initilizing = true;
            extractParams();
            self.isMine = self.loginUser && self.loginUser.id == self.searchParams.personId;
            getUserInfo().then(function(user){
                self.user = user;
                getPeopleList(self.searchParams, true);
            }, function(err){
                if(err.status === 500 || err.status === 404){
                    $state.go(err.status + '');
                }
            })
        }
        function fetchPeopleList(){
            self.searchString = "";
            extractParams();
            getPeopleList(self.searchParams, true);
        }
        function buidEmptyMessage(){
            var sentence = self.searchParams.action === "followings" ? "<b><%=userName%></b> <%=verb%> followed any photographers yet." : "<b><%=userName%></b> <%=verb%> had any followers yet.</b> ";
            var verb = (self.isMine ? "haven't" : "hasn't")
            var displayName = self.loginUser && self.loginUser.id == self.searchParams.personId ? 'You' : self.user.displayName;
            return _.template(sentence)({userName: displayName , numPeople: self.totalPeoples, verb: verb});
        }
        function getUserInfo(){
            var def = $q.defer();
            if(self.loginUser && self.loginUser.id == self.searchParams.personId){
                def.resolve(self.loginUser)
            } else {
                userHomePageSvc.getUser(self.searchParams.personId).then(function(userData){
                    def.resolve(userData);
                }, function(err){
                    def.reject(err);
                });
            }
            return def.promise;
        }
        function getPeopleList(params, isFresh){
            self.spinner.isVisible = true;
            peopleListPopupSvc.getPeopleList(params).then(function(response){
                if(isFresh){
                    self.peoples = [];
                }
                self.peoples = self.peoples.concat(response.data);
                self.isLastPage = pagingUtils.isNoMorePageToLoad(params.page, response);
                self.totalPeoples = pagingUtils.getTotalCount(response);
                self.spinner.isVisible = false;
                self.isEmptyState = self.peoples.length === 0;
                self.searchParams.page = params.page;
                self.emptyMessage = buidEmptyMessage();
            }, function(){
                toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
                self.spinner.isVisible = false;
            });
        }
        function fetchMorePeoples(){
            if(self.spinner.isVisible){
                return;
            }
            if(!self.searchString){
                getPeopleList({
                    page: self.searchParams.page + 1,
                    page_size: self.searchParams.page_size,
                    personId: self.searchParams.personId,
                    action: self.searchParams.action
                });
            } else {
                searchPeople({
                    id: self.searchParams.personId,
                    page: self.searchUserAffection.page  + 1,
                    page_size: self.searchUserAffection.page_size,
                    action: self.searchParams.action,
                    keywords: self.searchString
                });
            }
        }
        function searchPeople(params, isFresh){
            if(self.isEmptyState){
                return;
            }
            if(!self.searchString){
                self.searchParams.page = 1;
                getPeopleList(self.searchParams, true);
                return;
            }
            self.spinner.isVisible = true;
            pixerfApiUserSvc.searchUserAffectionByName( params, function(response){
                if(isFresh){
                    self.peoples = [];
                }
                self.peoples = self.peoples.concat(response.data);
                self.isLastPage = pagingUtils.isNoMorePageToLoad(params.page, response);
                self.spinner.isVisible = false;
                self.searchUserAffection.page = params.page;
            }, function(){
                toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
                self.spinner.isVisible = false;
            });
        }
        function onFollowStatusChanged(status){
            var step = status ? 1: -1;
            if(self.searchParams.action === "followings"){
                self.totalPeoples += step;
            }
            self.emptyMessage = buidEmptyMessage();
            if(self.loginUser && self.loginUser.id == self.searchParams.personId){
                self.user.stats.following_count += step;
                sessionManagerSvc.setCurrentLoginUser(self.user);
            }
        }
        function onSearchStringChanged(){
            searchPeople({
                id: self.searchParams.personId,
                page: self.searchUserAffection.page,
                page_size: self.searchUserAffection.page_size,
                action: self.searchParams.action,
                keywords: self.searchString
            },true);
        }
    }
})();

(function() {
  'use strict';

  angular
    .module('pixerf')
    .config(routerConfig);

  routerConfig.$inject = ['$stateProvider'];

  function routerConfig($stateProvider) {
    'ngInject';
    $stateProvider
      .state('peoples-page', {
        url: '/connection/:userId',
        isAbstract: true,
        templateUrl: 'app/peoples-page/peoples-page.html',
        controller: 'peoplesPageCtrl',
        controllerAs: 'vm'
      })
      .state('peoples-page.byAffections', {
        url: '/:affectionType',
        isAbstract: true,
        templateUrl: 'app/peoples-page/peoples-page-by-affections/peoples-page-by-affections.html',
        controller: 'peoplesPageByAffectionsCtrl',
        controllerAs: 'vm',
        data: {
          permissions: {
              only: ['EVERY_ONE']
          }
        },
        resolve: {
          promises: function($stateParams, $q){
            var def = $q.defer();
            def.resolve(this.data.pageTitle = "Pixerf - " + $stateParams.affectionType);
            return def.promise;
          }
        }
      })

  }

})();

(function () {

	angular
		.module('pixerf')
		.controller('payoutRequestsPageCtrl', payoutRequestsPageCtrl);

	payoutRequestsPageCtrl.$inject = ['$scope', 'pixerfApiFinanceSvc', 'systemUtils', 'pagingUtils'];

	function payoutRequestsPageCtrl($scope, pixerfApiFinanceSvc, systemUtils, pagingUtils) {

		var self = this;
		self.onMarkCompleteClicked = onMarkCompleteClicked;
		self.fetchMorePayouts = fetchMorePayouts;
		self.searchParams = {
			page: 1,
			page_size: 40
		}
		self.spinner = {
			isVisible: false
		}
		self.payouts = [];

		init();

		function init() {
			getListPayouts(self.searchParams, true);
		}

		function getListPayouts(params, isFresh) {
			pixerfApiFinanceSvc.list_payouts(params).$promise.then(function (response) {
				if (!self.payouts || isFresh) self.payouts = [];

				self.payouts = self.payouts.concat(response.data);
				self.isLastPage = pagingUtils.isNoMorePageToLoad(params.page, response);
				self.spinner.isVisible = false;
				self.searchParams.page = params.page;
			}).catch(function (err) {
				console.log(err);
			})
		}

		function onMarkCompleteClicked(payout) {
			pixerfApiFinanceSvc.mark_as_complete({
				id: payout.id
			}, {}).$promise.then(function (res) {
				payout.state = res.data.state;
				systemUtils.digest($scope);
			}).catch(function (err) {
				console.log(err);
			})
		}

		function fetchMorePayouts() {
			if (self.isLastPage || self.spinner.isVisible) return;

			var searchParms = $.extend(true, {}, self.searchParams);
			searchParms.page++;
			getListPayouts(searchParms);
		}
	}
})();

(function () {
  'use strict';

  angular
    .module('pixerf')
    .config(routerConfig);

  routerConfig.$inject = ['$stateProvider'];

  function routerConfig($stateProvider) {
    'ngInject';
    $stateProvider
      .state('payout-requests-page', {
        url: '/payout-requests',
        templateUrl: 'app/payout-requests-page/payout-requests-page.html',
        controller: 'payoutRequestsPageCtrl',
        controllerAs: 'vm',
        data: {
          pageTitle: "PIXERF - Payout Requests",
          permissions: {
            only: ['FINANCE_INTERNAL']
          },
          hideFooter: true
        }
      });
  }
})();

(function () {

	angular
		.module('pixerf')
		.controller('paymentSuccessfulPageCtrl', paymentSuccessfulPageCtrl);

	paymentSuccessfulPageCtrl.$inject = ['badgeUtils', '$scope', 'toastr', 'mission', 'sessionManagerSvc', 'pixerfApiMissionSvc', 'pixerfConfirmPopupSvc', 'messageConst', '$state'];

	function paymentSuccessfulPageCtrl(badgeUtils, $scope, toastr, mission, sessionManagerSvc, pixerfApiMissionSvc, pixerfConfirmPopupSvc, messageConst, $state) {
		var self = this;
		self.isWorking = false;
		self.loginUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.today = moment().format('DD MMMM YYYY');
		self.mission = mission;
		self.credit_balance = 0;
		self.total_prize = self.mission && self.mission.prizes_grouped ? self.mission.prizes_grouped.totalReward : "TBD";
		self.userCurrentBalance = self.loginUser.user_credit_plan ? self.loginUser.user_credit_plan.balance : 0;
		self.service_fee = mission.price && mission.price.service_fee ? parseFloat(mission.price.service_fee) : 0;
		self.discount =  self.service_fee * calDiscounts(self.mission.price);

		genPriceMission();

		function genPriceMission() {
			self.credit_balance = parseFloat(self.userCurrentBalance) + parseFloat(self.total_prize) + self.service_fee - self.discount;
		}

		function calDiscounts(price){
			var rateDiscount = 0;
			if(price.discounts && price.discounts.length){
				for(var i = 0; i < price.discounts.length; i++){
					rateDiscount += parseFloat(price.discounts[i].rate_amount);
				}
			}
			return rateDiscount;
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.config(routerConfig);

	routerConfig.$inject = ['$stateProvider'];

	function routerConfig($stateProvider) {
		'ngInject';
		function fetchMission($q, $stateParams, $state, pixerfApiMissionSvc) {
			var defer = $q.defer();
			var missionId = parseInt($stateParams.id);

			if (!$stateParams.id || ($stateParams.id && isNaN(missionId))) {
				$state.go('404');
				defer.reject();
			} else {
				pixerfApiMissionSvc.get({ id: missionId }).$promise.then(function (response) {
					defer.resolve(response.mission);
				}, function () {
					$state.go('404');
					defer.reject();
				})
			}
			return defer.promise;
		}
		$stateProvider
			.state('setting.payment-successful', {
				url: '/:id/payment-successful',
				templateUrl: 'app/payment-successful-page/payment-successful-page.html',
				controller: 'paymentSuccessfulPageCtrl',
				controllerAs: 'vm',
				data: {
					permissions: {
						only: ['AUTHORIZED']
					},
					hideFooter: true,
					pageTitle: "PIXERF - Mission payment successful"
				},
				resolve: {
					mission: function ($q, $stateParams, $state, pixerfApiMissionSvc, sessionManagerSvc) {
						var defer = $q.defer();
						var user = sessionManagerSvc.getCurrentLoginUser().data;
						fetchMission($q, $stateParams, $state, pixerfApiMissionSvc).then(function (mission) {
							defer.resolve(mission);
						}, function(){
							defer.reject();
						})
						return defer.promise;
					}
				}
			});
	}

})();

/**
 * Controller for notificationPage module
 */
(function(){

  angular
    .module('pixerf')
    .controller('notificationPageCtrl', notificationPageCtrl);
    notificationPageCtrl.$inject = ['headerSvc']
    function notificationPageCtrl(headerSvc){
        var self = this;
        self.searchFilterBarSettings = headerSvc.getFixedByHeaderSetting();
        self.onNotificationListInit = onNotificationListInit;
        function onNotificationListInit(instance){
            self.notificationListInstance = instance;
            self.notificationListInstance.init();
        }

     
    }
})();

(function() {
  'use strict';

  angular
    .module('pixerf')
    .config(routerConfig);

  routerConfig.$inject = ['$stateProvider'];

  function routerConfig($stateProvider) {
    'ngInject';
    $stateProvider
      .state('notification', {
        url: '/notification',
        abstract: true,
        templateUrl: 'app/notification-page/notification-page.html',
        controller: 'notificationPageCtrl',
        controllerAs: 'vm',
        data: {
                permissions: {
                only: ['AUTHORIZED']
            },
            hideFooter: true
        }
      });
  }

})();

(function () {

	angular
		.module('pixerf')
		.factory('modelAndPopertyReleasesSvc', modelAndPopertyReleasesSvc);

        modelAndPopertyReleasesSvc.$inject = [];

	function modelAndPopertyReleasesSvc() {

		var pixerfEnv = new PixerfEnv().getEnv();

		var mBannerBox = {
			style: {
				styleBackgroundBox: 'black--02'
			},
			title: 'Why and When Do I Need <br>a Model or Property Release?',
			titleMobile: 'Why and When <br>Do I Need <br>a Model or <br>Property Release?',
			// description: 'Unique, royalty-free photos for all your creative projects.',
			buttonText: 'Model Release',
			button2ndText: 'Property Release'
		};
		var mModelRelease = [
			{
				category: 'Posed Shots',
				items: [
					{
						id: '114928',
						imageDesktop: "assets/images/model-and-property-releases/model-release-01.png",
						imageMobile: "assets/images/model-and-property-releases/model-release-mobile-01.png",
						name: 'Required',
						description: 'Person’s face is clearly visible'
					},
					{
						id: '288475',
						imageDesktop: "assets/images/model-and-property-releases/model-release-02.png",
						imageMobile: "assets/images/model-and-property-releases/model-release-mobile-02.png",
						name: 'Not Required',
						description: 'A body part is visible, but the person is not identifiable'
					}
				]
			},
			{
				category: 'Silhouette',
				items: [
					{
						id: '128250',
						imageDesktop: "assets/images/model-and-property-releases/model-release-03.png",
						imageMobile: "assets/images/model-and-property-releases/model-release-mobile-03.png",
						name: 'Required',
						description: 'While these are silhouettes, the features are clearly visible'
					},
					{
						id: '110381',
						imageDesktop: "assets/images/model-and-property-releases/model-release-04.png",
						imageMobile: "assets/images/model-and-property-releases/model-release-mobile-04.png",
						name: 'Not Required',
						description: 'No visible features, no specific context as to where or when the photo was taken'
					}
				]
			},
			{
				category: 'Back View',
				items: [
					{
						id: '189253',
						imageDesktop: "assets/images/model-and-property-releases/model-release-05.png",
						imageMobile: "assets/images/model-and-property-releases/model-release-mobile-05.png",
						name: 'Required',
						description: 'Even if no features are visible, the person is recognisable based on the location and outfit'
					},
					{
						id: '46175',
						imageDesktop: "assets/images/model-and-property-releases/model-release-06.png",
						imageMobile: "assets/images/model-and-property-releases/model-release-mobile-06.png",
						name: 'Not Required',
						description: 'No visible features, no specific context as to where or when the photo was taken'
					}
				]
			},
			{
				category: 'Body Parts And Tattoos',
				items: [
					{
						id: '198122',
						imageDesktop: "assets/images/model-and-property-releases/model-release-07.png",
						imageMobile: "assets/images/model-and-property-releases/model-release-mobile-07.png",
						name: 'Required',
						description: 'Tattoos are considered distinct markers, so even with no facial feature or location context given, this person is still recognisable'
					},
					{
						id: '7',
						imageDesktop: "assets/images/model-and-property-releases/model-release-08.png",
						imageMobile: "assets/images/model-and-property-releases/model-release-mobile-08.png",
						name: 'Not Required',
						description: 'Although a body part is visible, there are no distinct markings'
					}
				]
			}
		];

		var mModelReleaseQa = [
			{
				category: 'Posed Shots',
				items: [
					{
						id: '6764',
						imageDesktop: "assets/images/model-and-property-releases/model-release-01.png",
						imageMobile: "assets/images/model-and-property-releases/model-release-mobile-01.png",
						name: 'Required',
						description: 'Person’s face is clearly visible'
					},
					{
						id: '2623',
						imageDesktop: "assets/images/model-and-property-releases/model-release-02.png",
						imageMobile: "assets/images/model-and-property-releases/model-release-mobile-02.png",
						name: 'Not Required',
						description: 'A body part is visible, but the person is not identifiable'
					}
				]
			},
			{
				category: 'Silhouette',
				items: [
					{
						id: '2793',
						imageDesktop: "assets/images/model-and-property-releases/model-release-03.png",
						imageMobile: "assets/images/model-and-property-releases/model-release-mobile-03.png",
						name: 'Required',
						description: 'While these are silhouettes, the features are clearly visible'
					},
					{
						id: '26815',
						imageDesktop: "assets/images/model-and-property-releases/model-release-04.png",
						imageMobile: "assets/images/model-and-property-releases/model-release-mobile-04.png",
						name: 'Not Required',
						description: 'No visible features, no specific context as to where or when the photo was taken'
					}
				]
			},
			{
				category: 'Back View',
				items: [
					{
						id: '18084',
						imageDesktop: "assets/images/model-and-property-releases/model-release-05.png",
						imageMobile: "assets/images/model-and-property-releases/model-release-mobile-05.png",
						name: 'Required',
						description: 'Even if no features are visible, the person is recognisable based on the location and outfit'
					},
					{
						id: '4400',
						imageDesktop: "assets/images/model-and-property-releases/model-release-06.png",
						imageMobile: "assets/images/model-and-property-releases/model-release-mobile-06.png",
						name: 'Not Required',
						description: 'No visible features, no specific context as to where or when the photo was taken'
					}
				]
			},
			{
				category: 'Body Parts And Tattoos',
				items: [
					{
						id: '20706',
						imageDesktop: "assets/images/model-and-property-releases/model-release-07.png",
						imageMobile: "assets/images/model-and-property-releases/model-release-mobile-07.png",
						name: 'Required',
						description: 'Tattoos are considered distinct markers, so even with no facial feature or location context given, this person is still recognisable'
					},
					{
						id: '120',
						imageDesktop: "assets/images/model-and-property-releases/model-release-08.png",
						imageMobile: "assets/images/model-and-property-releases/model-release-mobile-08.png",
						name: 'Not Required',
						description: 'Although a body part is visible, there are no distinct markings'
					}
				]
			}
		];


		var mPropertyRelease = [
			{
				category: 'Interior And Exterior',
				items: [
					{
						id: '334326',
						imageDesktop: "assets/images/model-and-property-releases/property-release-01.png",
						imageMobile: "assets/images/model-and-property-releases/property-release-mobile-01.png",
						name: 'Required',
						description: 'The photo was taken from the interior of a private property'
					},
					{
						id: '231494',
						imageDesktop: "assets/images/model-and-property-releases/property-release-02.png",
						imageMobile: "assets/images/model-and-property-releases/property-release-mobile-02.png",
						name: 'Not Required',
						description: 'Even though the image is of the exterior of a private house, the photographer was standing on public property when it was taken'
					}
				]
			},
			{
				category: 'Design And Structure',
				items: [
					{
						id: '23357',
						imageDesktop: "assets/images/model-and-property-releases/property-release-03.png",
						imageMobile: "assets/images/model-and-property-releases/property-release-mobile-03.png",
						name: 'Required',
						description: 'The photo was taken from the interior of a privately-owned structure'
					},
					{
						id: '23357',
						imageDesktop: "assets/images/model-and-property-releases/property-release-04.png",
						imageMobile: "assets/images/model-and-property-releases/property-release-mobile-04.png",
						name: 'Not Required',
						description: 'The photo contains the exterior of a public building, taken from a public space'
					}
				]
			}
		];

		var mPropertyReleaseQa = [
			{
				category: 'Interior And Exterior',
				items: [
					{
						id: '591',
						imageDesktop: "assets/images/model-and-property-releases/property-release-01.png",
						imageMobile: "assets/images/model-and-property-releases/property-release-mobile-01.png",
						name: 'Required',
						description: 'The photo was taken from the interior of a private property'
					},
					{
						id: '4653',
						imageDesktop: "assets/images/model-and-property-releases/property-release-02.png",
						imageMobile: "assets/images/model-and-property-releases/property-release-mobile-02.png",
						name: 'Not Required',
						description: 'Even though the image is of the exterior of a private house, the photographer was standing on public property when it was taken'
					}
				]
			},
			{
				category: 'Design And Structure',
				items: [
					{
						id: '2237',
						imageDesktop: "assets/images/model-and-property-releases/property-release-03.png",
						imageMobile: "assets/images/model-and-property-releases/property-release-mobile-03.png",
						name: 'Required',
						description: 'The photo was taken from the interior of a privately-owned structure'
					},
					{
						id: '734',
						imageDesktop: "assets/images/model-and-property-releases/property-release-04.png",
						imageMobile: "assets/images/model-and-property-releases/property-release-mobile-04.png",
						name: 'Not Required',
						description: 'The photo contains the exterior of a public building, taken from a public space'
					}
				]
			}
		];


		function getModelRelease() {
			return (pixerfEnv !== "PRODUCTION") ? mModelReleaseQa : mModelRelease;
		}

		function getPropertyRelease() {
			return (pixerfEnv !== "PRODUCTION") ? mPropertyReleaseQa : mPropertyRelease;
		}

		function getBannerBox() {
			return mBannerBox;
		}

		return {
			getBannerBox: getBannerBox,
			getModelRelease: getModelRelease,
			getPropertyRelease: getPropertyRelease
		};
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('modelAndPopertyReleasesCtrl', modelAndPopertyReleasesCtrl);

		modelAndPopertyReleasesCtrl.$inject = ['$scope', 'modelAndPopertyReleasesSvc', 'sessionManagerSvc', 'pixerfApiMediaSvc', 'photoDetailPopupSvc'];

	function modelAndPopertyReleasesCtrl($scope, modelAndPopertyReleasesSvc, sessionManagerSvc, pixerfApiMediaSvc, photoDetailPopupSvc) {

		var self = this;
		self.contextPage = " Model and Property Releases";
		self.loginedUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.bannerBox = modelAndPopertyReleasesSvc.getBannerBox();
		self.modelReleaseData = modelAndPopertyReleasesSvc.getModelRelease();
		self.propertyReleaseData = modelAndPopertyReleasesSvc.getPropertyRelease();
		self.onPhotoCLick = onPhotoCLick;

		self.spinner = {
			isVisible: false
		};

		function onPhotoCLick(photoId) {
			self.spinner.isVisible = true;
			pixerfApiMediaSvc.get({
				id: photoId
			}).$promise.then(function (response) {
				self.spinner.isVisible = false;
				photoDetailPopupSvc.showPopup({
					photo: response.data
				});
			}, function error(){
				self.spinner.isVisible = false;
			})
		}

	
	}
})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.factory('missionPendingDetailPageSvc', missionPendingDetailPageSvc);
	missionPendingDetailPageSvc.$inject = ['toastr', '$q', 'pixerfApiMissionSvc', '$location', 'messageConst', 'stringUtils'];

	function missionPendingDetailPageSvc(toastr, $q, pixerfApiMissionSvc, $location, messageConst, stringUtils) {

		
		var mCurrentStepIndex = 0;
		var mListSteps = [];


		function buildStepsList() {
			for (var i = 0; i < mListSteps.length; i++) {
				mListSteps[i].index = i;
			}
		}
		function init() {
			mListSteps = [
				{ "id": "REVIEW", "label": "Review", "state": "pending_approval"},
				{ "id": "PAYMENT", "label": "Payment", "state": "pending_payment"},
				{ "id": "LAUNCH", "label": "Launch", "state": "ready_to_launch" }
			];
			buildStepsList();
		}
		
		function getStepByState(state){
			return _.find(mListSteps, function(step){
				return step.state === state;
			})
		}

		function reset() {
			mCurrentStepIndex = 0;
		}

		function setCurrentStepIndex(index) {
			mCurrentStepIndex.data = index;
		}

		function getCurrentStepIndex() {
			return mCurrentStepIndex;
		}

		function getListStep() {
			return mListSteps;
		}
		
		init();


		return {
			setCurrentStepIndex: setCurrentStepIndex,
			getCurrentStepIndex: getCurrentStepIndex,
			getListStep: getListStep,
			getStepByState: getStepByState,
			reset: reset
		};
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('missionPendingDetailPageCtrl', missionPendingDetailPageCtrl);

	missionPendingDetailPageCtrl.$inject = ['$scope', 'missionPendingDetailPageSvc', '$state', 'missionData', 'badgeUtils'];

	function missionPendingDetailPageCtrl($scope, missionPendingDetailPageSvc, $state, missionData, badgeUtils) {
		var self = this;
		self.isWorking = false;
		self.onBreadCrumInit = onBreadCrumInit;
		self.mission = missionData;
		self.mission.prizes_grouped = badgeUtils.compactPrizes(self.mission.prizes);	
		self.breadCrum = null;

		self.listSteps = missionPendingDetailPageSvc.getListStep();
		self.onPay = onPay;
		self.onBackBtnClicked = onBackBtnClicked;


		function onBreadCrumInit(instance){
			self.breadCrum = instance;
			var currentStepIndex = missionPendingDetailPageSvc.getStepByState(self.mission.process_state);
			self.breadCrum.setCurrentIndex(currentStepIndex.index);
		}
		function onPay(){
			var currentStepIndex = missionPendingDetailPageSvc.getStepByState(self.mission.process_state);
			self.breadCrum.setCurrentIndex(currentStepIndex.index);
		}

		function onBackBtnClicked(){
			$state.go("setting.manage-missions.draft.list-mission-draft");
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.config(routerConfig);

	routerConfig.$inject = ['$stateProvider'];

	function routerConfig($stateProvider) {
		'ngInject';

		function fetchMission(missionPendingDetailPageSvc, $q, $stateParams, $state, pixerfApiMissionSvc) {
			var defer = $q.defer();
			var missionId = parseInt($stateParams.id);
			
			if (!$stateParams.id || ($stateParams.id && isNaN(missionId))) {
				$state.go('404');
				defer.reject();
			} else {
				pixerfApiMissionSvc.get({ id: missionId }).$promise.then(function (response) {
					defer.resolve(response.mission);
				}, function () {
					$state.go('404');
					defer.reject();
				})
			}
			return defer.promise;
		}
		$stateProvider
			.state('setting.mission-pending-detail-page', {
				url: '/mission-pending-detail-page/:id',
				templateUrl: 'app/mission-pending-detail-page/mission-pending-detail-page.html',
				controller: 'missionPendingDetailPageCtrl',
				controllerAs: 'vm',
				resolve: {
					missionData: function (missionPendingDetailPageSvc, $q, $stateParams, $state, pixerfApiMissionSvc) {
						return fetchMission(missionPendingDetailPageSvc, $q, $stateParams, $state, pixerfApiMissionSvc)
					}
				}
			})
	}

})();

(function () {

	angular
		.module('pixerf')
		.controller('missionLaunchedPageCtrl', missionLaunchedPageCtrl);

	missionLaunchedPageCtrl.$inject = ['mission', '$state'];

	function missionLaunchedPageCtrl(mission, $state) {
		var self = this;
		self.onViewClicked = onViewClicked;
		self.mission = mission;

		function onViewClicked(){
			$state.go("mission-detail-page.brief", { id: self.mission.id });
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.config(routerConfig);

	routerConfig.$inject = ['$stateProvider'];

	function routerConfig($stateProvider) {
		'ngInject';
		function fetchMission($q, $stateParams, $state, pixerfApiMissionSvc) {
			var defer = $q.defer();
			var missionId = parseInt($stateParams.id);

			if (!$stateParams.id || ($stateParams.id && isNaN(missionId))) {
				$state.go('404');
				defer.reject();
			} else {
				pixerfApiMissionSvc.get({ id: missionId }).$promise.then(function (response) {
					defer.resolve(response.mission);
				}, function () {
					$state.go('404');
					defer.reject();
				})
			}
			return defer.promise;
		}
		$stateProvider
			.state('setting.mission-launched', {
				url: '/:id/mission-launched',
				templateUrl: 'app/mission-launched-page/mission-launched-page.html',
				controller: 'missionLaunchedPageCtrl',
				controllerAs: 'vm',
				data: {
					permissions: {
						only: ['AUTHORIZED']
					},
					hideFooter: true,
					pageTitle: "PIXERF - Mission launched"
				},
				resolve: {
					mission: function ($q, $stateParams, $state, pixerfApiMissionSvc, sessionManagerSvc) {
						var defer = $q.defer();
						var user = sessionManagerSvc.getCurrentLoginUser().data;
						fetchMission($q, $stateParams, $state, pixerfApiMissionSvc).then(function (mission) {
							defer.resolve(mission);
						}, function () {
							defer.reject();
						})
						return defer.promise;
					}
				}
			});
	}

})();

(function () {

	angular
		.module('pixerf')
		.controller('missionDetailPageCtrl', missionDetailPageCtrl);

	missionDetailPageCtrl.$inject = ["$timeout", "stringUtils", "sessionManagerSvc", "missionData", "submitMissionPhotoPopupSvc", 'headerSvc', 'systemUtils', '$scope', 'subscriptionTypePopupSvc', 'actionPopupSvc', 'additionalEntriesPopupSvc', '$state', 'preventSubmitMissionPopupSvc', 'translationUtils', 
		'$rootScope', 'commonConst', 'submitFrameMissionPopupSvc', 'alertMessagePopupSvc', 'ISO3166'];

	function missionDetailPageCtrl($timeout, stringUtils, sessionManagerSvc, missionData, submitMissionPhotoPopupSvc, headerSvc, systemUtils, $scope, subscriptionTypePopupSvc, actionPopupSvc, additionalEntriesPopupSvc, $state, preventSubmitMissionPopupSvc, translationUtils, 
			$rootScope, commonConst, submitFrameMissionPopupSvc, alertMessagePopupSvc, ISO3166) {
		var self = this;
		self.onSubmitPhotoClicked = onSubmitPhotoClicked;
		self.mission = missionData;
		self.tmpTranslatedTitle = self.mission.title;
		self.onBackbtnClicked = onBackbtnClicked;
		self.loginnedUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.isAwardVisible = isAwardVisible;
		self.onScrollToPage = onScrollToPage;
		self.onLoadMorePage = onLoadMorePage;
		self.onCurrentPageChanged = onCurrentPageChanged;
		self.isMyMision = sessionManagerSvc.isMyMission(self.mission);
		self.fixedSetting = headerSvc.getFixedByHeaderSetting();
		self.contextPage = 'Brief';
		self.translateTitleBtnText = "translate";
		self.submissionPagination = {
			'pagerText': "",
			'page': 1
		}
		self.isAwardsPage = false;
		self.countriesName = '';

		var pixerfEnv = new PixerfEnv().getEnv();
		self.isCustomMission124 = pixerfEnv === "PRODUCTION" ? [124].includes(self.mission.id) : [1641].includes(self.mission.id);
		self.isCustomMission127 = [127].includes(self.mission.id);

		init();

		function showTranslateBtn() {
			if ($rootScope.lang != self.mission.title_detect_language && translationUtils.canTranslate(self.mission.translations, $rootScope.lang, 'title')) {
				self.showTranslateTitle = true;
			} else {
				self.showTranslateTitle = false;
			}
		}

		function onBackbtnClicked() {
			if(!self.mission.is_closed){
				$state.go(commonConst.STATE.MISSION_ONGOING);
			}else if (self.mission.has_joined) {
				$state.go(commonConst.STATE.MISSION_JOINED);
			} else if (self.mission.is_closed) {
				$state.go(commonConst.STATE.MISSION_CLOSED);
			} else {
				$state.go(commonConst.STATE.MISSION_ONGOING);
			}
		}

		function isAwardVisible() {
			if (self.mission.is_closed) {
				if (self.mission.is_awarded) return true;
				if ((self.loginnedUser && self.loginnedUser.canManageMission && self.isMyMision) || (self.loginnedUser && self.loginnedUser.isMaketerInternal)) {
					return true;
				}
			}
			return false;
		}

		function init() {
			$timeout(function () {
				updateSocialShareContent();
			}, 0)
			$scope.$on('$stateChangeSuccess', function (event, toState) {
				$timeout(function () {
					updateSocialShareContent();
					self.isAwardsPage = ((toState.name.indexOf('mission-detail-page.awards') !== -1) ? true : false);
				}, 300)
			});

			if(self.isCustomMission127){
				self.mission.coverImagePath = 'assets/images/custom-challanges/custom-banner-127.jpg';
			}

			showTranslateBtn()
			self.countriesName = buildRequirementNote();
		}

		function buildRequirementNote(){
			if(!self.mission.countries || (self.mission.countries.length <= 0)){
				return '';
			}

			var countriesName = getCountries(self.mission.countries).join(", ");;

			return ('For Photographers in ' + countriesName + ' only');

		}

		function getCountries(countryCodes){
            return Object.values(ISO3166.getCountryNames(countryCodes));
        }

		function updateSocialShareContent() {
			self.socialShareContent = buildSocialShareContent(self.mission);
		}

		function buildSocialShareContent(mission) {
			return {
				'url': window.location.href,
				'description': stringUtils.htmlToPlaintext(mission.description),
				'title': mission.title,
				'media': mission.sponsor ? mission.sponsor.logoUrl : mission.organization.profileImageUrl
			};
		}

		function onSubmitPhotoClicked() {
			if (self.mission.is_multi_frame && self.mission.number_of_frames <= self.mission.my_submissions) {
				alertMessagePopupSvc.showPopup({
					description: "You've reached the quota of " + self.mission.number_of_frames + " photos for this mission."
				});
				return;
			}
			if (self.loginnedUser && self.loginnedUser.address &&
				self.mission.countries && self.mission.countries.length && !self.mission.countries.includes(self.loginnedUser.address.country)) {
				preventSubmitMissionPopupSvc.showPopup({
					countries: self.mission.countries
				});
				return;
			}
			if (self.mission.is_ioa) {
				var entriesSectionTypePopup = subscriptionTypePopupSvc.showPopup({
					mission: self.mission
				});

				entriesSectionTypePopup.result.then(function (res) {
					self.mission.ioaSubscriber = res;
					if (res.free_balance > 0) {
						submitMissionPhotoPopupSvc.showPopup({
							mission: self.mission
						});
					} else {
						actionPopupSvc.showPopup(res).result.then(function (res) {
							if (res) {
								self.mission.ioaSubscriber = res;
								additionalEntriesPopupSvc.showPopup(self.mission).result.then(function (respone) {
									submitMissionPhotoPopupSvc.showPopup({
										mission: self.mission
									});
								});
							}
						});
					}
				});
			} else if (self.mission.is_multi_frame) {
				var submitFramePopup = submitFrameMissionPopupSvc.showPopup({
					mission: self.mission
				});
				submitFramePopup.result.then(function (res) {
					self.mission.my_submissions = res.numberPhoto;
				})
			} else {
				submitMissionPhotoPopupSvc.showPopup({
					mission: self.mission
				});
			}
		}

		function onScrollToPage(page) {
			self.submissionPagination.page = page;
		}

		function onLoadMorePage(page) {
			self.submissionPagination.page = page;
		}

		function onCurrentPageChanged(pageNumber) {
			var params = {
				mission: self.mission,
				page: pageNumber
			};
			if (self.loginnedUser && !self.loginnedUser.canManageMission) {
				params.type = 'others';
			}
			self.submissionsCtrl.isScrollToPixerferSubmission = new Date().getTime();
			$timeout(function () {
				self.submissionsCtrl.search(params);
			})
		}

	}
})();

(function() {
  'use strict';

  angular
    .module('pixerf')
    .config(routerConfig);

  routerConfig.$inject = ['$stateProvider'];

  function routerConfig($stateProvider) {
    'ngInject';
    $stateProvider
      .state('mission-detail-page', {
        abstract: true,
        url: '/mission-detail-page/:id/:name',
        templateUrl: 'app/mission-detail-page/mission-detail-page.html',
        controller: 'missionDetailPageCtrl',
        controllerAs: 'vm',
        data: {
          pageTitle: "PIXERF - Mission Detail" ,
          permissions: {
              only: ['EVERY_ONE']
          }
        },
        params: {
          "id": { squash: true, value: null },
          "name": { squash: true, value: null }
        },
        resolve: {
          missionData: function($stateParams, pixerfApiMissionSvc, $q, $state, pagingUtils){
            var defer = $q.defer();
            var self = this;
            var missionId = parseInt($stateParams.id);
            if(!$stateParams.id || ($stateParams.id && isNaN(missionId))){
              $state.go('404');
              defer.reject();
            } else {
              var mission = {};
              pixerfApiMissionSvc.get({id: missionId}).$promise.then(function(response){
                self.data.pageTitle = "PIXERF - Mission: "  + response.mission.title;
                mission = response.mission;
                return pixerfApiMissionSvc.get_participations({id: mission.id}).$promise;
              }).then(function (response) {
                mission.submissions = pagingUtils.getTotalCount(response);
                defer.resolve(mission);
              }).catch(function(){
                $state.go('404');
                defer.reject();
              });
            }
            return defer.promise;
          }
        }
      })
      .state('mission-detail-page.visual-inspiration', {
        url: '/visual-inspiration',
        templateUrl: 'app/mission-detail-page/components/visual-inspiration/visual-inspiration.html',
        controller: 'visualInspirationCtrl',
        controllerAs: 'vm'
      })
	  .state('mission-detail-page.submissions', {
        url: '/submissions',
        templateUrl: 'app/mission-detail-page/components/submissions/submissions.html',
        controller: 'submissionsCtrl',
        controllerAs: 'vm'
      })
	  .state('mission-detail-page.awards', {
        url: '/awards',
        templateUrl: 'app/mission-detail-page/components/awards/awards.html',
        controller: 'awardsCtrl',
        controllerAs: 'vm'
      })
      .state('mission-detail-page.pending-submissions-mission', {
        url: '/pending',
        templateUrl: 'app/mission-detail-page/components/pending-submissions-mission/pending-submissions-mission.html',
        controller: 'pendingSubmissionsMissionCtrl',
        controllerAs: 'vm'
      })
      .state('mission-detail-page.rejected-submissions-mission', {
        url: '/rejected',
        templateUrl: 'app/mission-detail-page/components/rejected-submissions-mission/rejected-submissions-mission.html',
        controller: 'rejectedSubmissionsMissionCtrl',
        controllerAs: 'vm'
      })
      .state('mission-detail-page.brief', {
        url: '',
        templateUrl: 'app/mission-detail-page/components/brief/brief.html',
        controller: 'briefCtrl',
        controllerAs: 'vm'
      });
  }

})();

/**
 * Controller for home module
 */
(function(){
  'use strict';
  angular
    .module('pixerf')
    .factory('missionSvc', missionSvc);

    missionSvc.$inject = ['pixerfApiMissionSvc'];

    function missionSvc(pixerfApiMissionSvc){
        function fetchMissions(searchParam){
            var urlParams = {page: searchParam.page, page_size: 17};
            if(searchParam.type){
                urlParams.type = searchParam.type;
            }
            return pixerfApiMissionSvc.query(urlParams).$promise;
        }
		return {
            fetchMissions: fetchMissions
		};
    }
})();

(function () {

	angular
		.module('pixerf')
		.controller('missionCtrl', missionCtrl);

	missionCtrl.$inject = ['$scope', 'sessionManagerSvc', '$state', 'notifyTopupCreditPopupSvc', 'headerSvc', '$timeout'];

	function missionCtrl($scope, sessionManagerSvc, $state, notifyTopupCreditPopupSvc, headerSvc, $timeout) {
		var self = this;
		self.contextPage = 'About Missions';
		self.loginnedUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.onManageMissionClicked = onManageMissionClicked;
		self.fixedSetting = headerSvc.getFixedByHeaderSetting();

		function onManageMissionClicked(){
			if(self.loginnedUser && self.loginnedUser.canCreateMission){
				// $state.go("setting.manage-missions.create-mission.getting-started");
				$state.go("setting.manage-missions.on-going");
			}
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.config(routerConfig);

	routerConfig.$inject = ['$stateProvider'];

	function routerConfig($stateProvider) {
		'ngInject';
		$stateProvider
			.state('mission', {
				url: '/mission',
				templateUrl: 'app/mission/mission.html',
				controller: 'missionCtrl',
				controllerAs: 'vm',
				data: {
					pageTitle: "PIXERF - Mission Introduction",
                    permissions: {
                        only: ['EVERY_ONE']
					},
					headerClass: 'submenu-style'
				},
				abstract: true
			})
			.state('mission.on-going', {
				url: '',
				templateUrl: 'app/mission/components/on-going/on-going.html',
				data: {
					pageTitle: "PIXERF - Ongoing Missions",
				},
				controller: 'onGoingCtrl',
				controllerAs: 'vm'
			})
			.state('mission.mission-closed', {
				url: '/mission-closed',
				templateUrl: 'app/mission/components/mission-closed/mission-closed.html',
				data: {
					pageTitle: "PIXERF - Closed Community Challenges",
				},
				controller: 'missionClosedCtrl',
				controllerAs: 'vm'
			})
			.state('mission.mission-joined', {
				url: '/mission-joined',
				templateUrl: 'app/mission/components/mission-joined/mission-joined.html',
				data: {
					pageTitle: "PIXERF - Mission joined",
				},
				controller: 'missionJoinedCtrl',
				controllerAs: 'vm'
			})
			.state('mission.mission-agreement', {
				url: '/mission-agreement',
				templateUrl: 'app/mission/components/mission-agreement/mission-agreement.html',
				data: {
					pageTitle: "PIXERF - Missions Agreement",
				},
				controller: 'missionAgreementCtrl',
				controllerAs: 'vm'
			})
			.state('mission.mission-agreement-gojek', {
				url: '/mission-agreement-gojek',
				templateUrl: 'app/mission/components/mission-agreement-gojek/mission-agreement.html',
				data: {
					pageTitle: "PIXERF - Missions Agreement",
				},
				controller: 'missionAgreementCtrl',
				controllerAs: 'vm'
			})
			.state('mission.mission-sponsor-agreement', {
				url: '/mission-sponsor-agreement',
				templateUrl: 'app/mission/components/mission-sponsor-agreement/mission-sponsor-agreement.html',
				data: {
					pageTitle: "PIXERF - Mission Sponsor Agreement",
				},
				controller: 'missionSponsorAgreementCtrl',
				controllerAs: 'vm'
			});
	}

})();

(function () {

	angular
		.module('pixerf')
		.controller('mediaPageCtrl', mediaPageCtrl);

	mediaPageCtrl.$inject = ['$scope', 'pixerfApiNewsSvc', 'pagingUtils'];

	function mediaPageCtrl($scope, pixerfApiNewsSvc, pagingUtils) {

		var self = this;
		self.fetchMoreNews = fetchMoreNews;
		self.posts = [];
		self.searchParams = {
			page: 1
		}

		self.spinner = {
			isVisible: false
		}

		init();

		function init() {
			getMediaPosts(self.searchParams);
		}

		function formatDate() {
			for (var i = 0; i < self.posts.length; i++) {
				self.posts[i].formattedDate = moment(self.posts[i].posted_at).format('MMMM DD, YYYY');
			}
		}

		function getMediaPosts(params) {
			self.spinner.isVisible = true;
			pixerfApiNewsSvc.get(params).$promise.then(function (res) {
				self.posts = self.posts.concat(res.data);
				self.isLastPage = pagingUtils.isNoMorePageToLoad(self.searchParams.page, res);
				self.spinner.isVisible = false;
				self.searchParams.page = params.page;
				formatDate();
			}).catch(function () {
				self.spinner.isVisible = false;
			})
		}

		function fetchMoreNews() {
			if (self.isLastPage || self.spinner.isVisible) return;
			var searchParms = $.extend(true, {}, self.searchParams);
			searchParms.page++;
			getMediaPosts(searchParms);
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.config(routerConfig);

	routerConfig.$inject = ['$stateProvider'];

	function routerConfig($stateProvider) {
		'ngInject';
		$stateProvider
			.state('media-page', {
				url: '/media',
				templateUrl: 'app/media-page/media-page.html',
				data: {
					pageTitle: "PIXERF - PIXERF in the news",
				},
				controller: 'mediaPageCtrl',
				controllerAs: 'vm'
			});
	}

})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('marketplaceAdPageCtrl', marketplaceAdPageCtrl);

	marketplaceAdPageCtrl.$inject = ['$scope', 'sessionManagerSvc', '$state', 'pixerfApiMediaSvc', 'photoDetailPopupSvc', 'selectSignUpTypePopupSvc', 'signUpBusinessPopupSvc'];

	function marketplaceAdPageCtrl($scope, sessionManagerSvc, $state, pixerfApiMediaSvc, photoDetailPopupSvc, selectSignUpTypePopupSvc, signUpBusinessPopupSvc) {

		var self = this;
		var mloginnedUser = sessionManagerSvc.getCurrentLoginUser().data;
		var pixerfEnv = new PixerfEnv().getEnv();
		self.onSignatureGalleries = onSignatureGalleries;
		self.onPhotoClicked = onPhotoClicked;
		self.onRegister = onRegister;
		var env = (pixerfEnv === "PRODUCTION") ? 'prod' : 'qa';
		self.photos = [];
		var topic = {
			prod: {
				food: {
					link: {
						id: 5,
						name: "Food"
					},
					image: {
						id: 13661,
						name: "Food"
					}
				},
				asianFaces: {
					link: {
						id: 24,
						name: "Asian Faces"
					},
					image: {
						id: 91908,
						name: "Asian Faces"
					}
				},
				lifestyle: {
					link: {
						id: 1,
						name: "Lifestyle"
					},
					image: {
						id: 147796,
						name: "Lifestyle"
					}
				},
				industrial: {
					link: {
						id: 38,
						name: "Industrial"
					},
					image: {
						id: 38,
						name: "Industrial"
					}
				},
				city: {
					link: {
						id: 14,
						name: "City"
					},
					image: {
						id: 155683,
						name: "City"
					}
				},
				culture: {
					link: {
						id: 23,
						name: "Culture"
					},
					image: {
						id: 175970,
						name: "Culture"
					}
				},
				travel: {
					link: {
						id: 2,
						name: "Travel"
					},
					image: {
						id: 167375,
						name: "Travel"
					}
				}
			},
			qa: {
				food: {
					link: {
						id: 5,
						name: "Food"
					},
					image: {
						id: 13661,
						name: "Food"
					}
				},
				asianFaces: {
					link: {
						id: 24,
						name: "Asian Faces"
					},
					image: {
						id: 91908,
						name: "Asian Faces"
					}
				},
				lifestyle: {
					link: {
						id: 1,
						name: "Lifestyle"
					},
					image: {
						id: 147796,
						name: "Lifestyle"
					}
				},
				industrial: {
					link: {
						id: 43,
						name: "Industrial"
					},
					image: {
						id: 38,
						name: "Industrial"
					}
				},
				city: {
					link: {
						id: 14,
						name: "City"
					},
					image: {
						id: 155683,
						name: "City"
					}
				},
				culture: {
					link: {
						id: 23,
						name: "Culture"
					},
					image: {
						id: 175970,
						name: "Culture"
					}
				},
				travel: {
					link: {
						id: 2,
						name: "Travel"
					},
					image: {
						id: 167375,
						name: "Travel"
					}
				}
			}
		}

		$scope.$parent.vm.contextPage = "Marketplace Ad";
		self.brandingPhoto = {
			"id": 82142,
			"title": "Smoggy sunrise",
			"user": {
				"name": "Yik Keat Lee",
				"id": 36084
			}
		};

		init();

		function init(){
			switch(env){
				case 'qa':
					self.photos = [
						{id: 16651, thumbnails: {'local': '../assets/images/signature-galleries/photo-1.jpg'}},
						{id: 1007, thumbnails: {'local': '../assets/images/signature-galleries/photo-2.jpg'}},
						{id: 591, thumbnails: {'local': '../assets/images/signature-galleries/photo-3.jpg'}},
						{id: 1255, thumbnails: {'local': '../assets/images/signature-galleries/photo-4.jpg'}},
						{id: 3064, thumbnails: {'local': '../assets/images/signature-galleries/photo-5.jpg'}},
						{id: 2324, thumbnails: {'local': '../assets/images/signature-galleries/photo-6.jpg'}},
						{id: 18325, thumbnails: {'local': '../assets/images/signature-galleries/photo-7.jpg'}},
						{id: 1993, thumbnails: {'local': '../assets/images/signature-galleries/photo-8.jpg'}},
						{id: 4031, thumbnails: {'local': '../assets/images/signature-galleries/photo-9.jpg'}},
						{id: 2477, thumbnails: {'local': '../assets/images/signature-galleries/photo-10.jpg'}},
						{id: 5213, thumbnails: {'local': '../assets/images/signature-galleries/photo-11.jpg'}}
					]
					break;
				case 'prod':
					self.photos = [
						{id: 147986, thumbnails: {'local': '../assets/images/signature-galleries/photo-1.jpg'}},
						{id: 169515, thumbnails: {'local': '../assets/images/signature-galleries/photo-2.jpg'}},
						{id: 147795, thumbnails: {'local': '../assets/images/signature-galleries/photo-3.jpg'}},
						{id: 216211, thumbnails: {'local': '../assets/images/signature-galleries/photo-4.jpg'}},
						{id: 97053, thumbnails: {'local': '../assets/images/signature-galleries/photo-5.jpg'}},
						{id: 158071, thumbnails: {'local': '../assets/images/signature-galleries/photo-6.jpg'}},
						{id: 101926, thumbnails: {'local': '../assets/images/signature-galleries/photo-7.jpg'}},
						{id: 157077, thumbnails: {'local': '../assets/images/signature-galleries/photo-8.jpg'}},
						{id: 16301, thumbnails: {'local': '../assets/images/signature-galleries/photo-9.jpg'}},
						{id: 135392, thumbnails: {'local': '../assets/images/signature-galleries/photo-10.jpg'}},
						{id: 169230, thumbnails: {'local': '../assets/images/signature-galleries/photo-11.jpg'}}
					]
					break;
			}
		}

		function onSignatureGalleries() {
			$state.go("buy-stock-page.galleries.signature-galleries");
		}

		self.goToCreditPage = function () {
			if (!mloginnedUser || (mloginnedUser && mloginnedUser.isBiz)) {
				$state.go("checkout.credit-plan.credit-plan-list", {
					hashtag: "creditplan"
				});
			} else {
				signUpBusinessPopupSvc.showPopup();
			}
		}
		self.goToTopic = function (topicName) {
			var link = topic[env][topicName].link;
			$state.go("signature-galleries-details-page", {
				id: link.id,
				title: link.name
			});
		}
		self.goToTopicImage = function (topicName) {
			var link = topic[env][topicName].link;
			var imageDetail = topic[env][topicName].image;
			$state.go("signature-galleries-details-page", {
				id: link.id,
				title: link.name,
				imageid: imageDetail.id
			});
		}

		function onPhotoClicked(photoId){
			pixerfApiMediaSvc.get({
				id: photoId
			}).$promise.then(function (response) {
				photoDetailPopupSvc.showPopup({
					photo: response.data
				});
			})
		}

		function onRegister(){
			selectSignUpTypePopupSvc.showPopup();
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.config(routerConfig);

	routerConfig.$inject = ['$stateProvider'];

	function routerConfig($stateProvider) {
		'ngInject';
		$stateProvider
			.state('creativeMarketplaceAd', {
				url: '/2020/09/creative-marketplace/discover-the-real-asia',
				templateUrl: 'app/marketplace-ad-page/marketplace-ad-page.html',
				controller: 'marketplaceAdPageCtrl',
				controllerAs: 'vm',
				params: {
					"section": {
						squash: true,
						value: null
					}
				},
				data: {
					pageTitle: "PIXERF - Creative Marketplace Ad",
					headerClass: 'homepage marketplace-ad-page',
					permissions: {
						only: ['EVERY_ONE']
					},
					hideFooter: true
				}
			});
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.config(routerConfig);

	routerConfig.$inject = ['$stateProvider', '$urlRouterProvider', 'fileConst'];

	function routerConfig($stateProvider, $urlRouterProvider, fileConst) {
		'ngInject';
		$urlRouterProvider.when('/marketplace', '/marketplace/photos');
		$stateProvider
			.state('marketplace', {
				abstract: true,
				url: '/marketplace',
				templateUrl: 'app/marketplace/marketplace.html',
				controller: 'marketPlaceCtrl',
				controllerAs: 'vm',
				data: {
					pageTitle: "PIXERF - Marketplace",
					hideFooter: true,
					headerClass: "navigation-search-bar"
				}
			})
			.state('marketplace.photos', {
				url: '/photos?categoryIds&page',
				templateUrl: 'app/marketplace/components/marketplace-photos/marketplace-photos.html',
				controller: 'marketplacePhotosCtrl',
				controllerAs: 'vm',
				data: {
					permissions: {
						only: ['EVERY_ONE']
					}
				}
			})
			.state('marketplace.photosByType', {
				url: '/photos/:type?categoryIds&page',
				templateUrl: 'app/marketplace/components/marketplace-photos/marketplace-photos.html',
				controller: 'marketplacePhotosCtrl',
				controllerAs: 'vm',
				data: {
					permissions: {
						only: function (transitionProperties) {
							if (transitionProperties.toParams.type === fileConst.FILE_STATE_NAME.PENDING ||
								transitionProperties.toParams.type === fileConst.FILE_STATE_NAME.REJECTED ||
								transitionProperties.toParams.type === fileConst.FILE_STATE_NAME.GENERAL ||
								transitionProperties.toParams.type === fileConst.FILE_STATE_NAME.TRENDING_PORTFOLIO) {
								return ['CURATOR'];
							} else if (transitionProperties.toParams.type === fileConst.FILE_STATE_NAME.TEMPORARY) {
								return ['EVERY_ONE'];
							} else {
								return ['EVERY_ONE'];
							}
						},
						redirectTo: function () {
							return "404";
						}
					},
				}
			})
			.state('marketplace.pending-submissions', {
				url: '/pending-submissions?page',
				templateUrl: 'app/marketplace/components/pending-submissions/pending-submissions.html',
				controller: 'pendingSubmissionsCtrl',
				controllerAs: 'vm',
				data: {
					permissions: {
						only: ['CURATOR'],
						redirectTo: function () {
							return "404";
						}
					}
				}
			})
			.state('marketplace.rejected-submissions', {
				url: '/rejected-submissions?page',
				templateUrl: 'app/marketplace/components/pending-submissions/pending-submissions.html',
				controller: 'rejectedSubmissionsCtrl',
				controllerAs: 'vm',
				data: {
					permissions: {
						only: ['CURATOR'],
						redirectTo: function () {
							return "404";
						}
					}
				}
			})
			.state('marketplace.galleries', {
				url: '/galleries',
				templateUrl: 'app/marketplace/components/marketplace-galleries/marketplace-galleries.html',
				controller: 'marketplaceGalleriesCtrl',
				controllerAs: 'vm',
				abstract: true,
				data: {
					permissions: {
						only: ['EVERY_ONE']
					}
				}
			})
			.state('marketplace.galleries.signature-galleries', {
				url: '/signature-galleries/:hashtag',
				templateUrl: 'app/marketplace/components/marketplace-galleries/marketplace-signature-galleries/marketplace-signature-galleries.html',
				controller: 'marketplaceSignatureGalleriesCtrl',
				controllerAs: 'vm',
				data: {
					permissions: {
						only: ['EVERY_ONE']
					}
				}
			})
			.state('marketplace.galleries.followed-galleries', {
				url: '/galleries-you-follow',
				templateUrl: 'app/marketplace/components/marketplace-galleries/marketplace-followed-galleries/marketplace-followed-galleries.html',
				controller: 'marketplaceFollowedGalleriesCtrl',
				controllerAs: 'vm',
				data: {
					permissions: {
						only: ['EVERY_ONE']
					}
				}
			})
			.state('marketplace.galleries.pixerfer-galleries', {
				url: '/pixerfer-galleries',
				templateUrl: 'app/marketplace/components/marketplace-galleries/marketplace-pixerfer-galleries/marketplace-pixerfer-galleries.html',
				controller: 'marketplacePixerferGalleriesCtrl',
				controllerAs: 'vm',
				data: {
					permissions: {
						only: ['EVERY_ONE']
					}
				}
			})
			.state('marketplace.galleries.curated-galleries', {
				url: '/curated-galleries',
				templateUrl: 'app/marketplace/components/marketplace-galleries/marketplace-curated-galleries/marketplace-curated-galleries.html',
				controller: 'marketplaceCuratedGalleriesCtrl',
				controllerAs: 'vm',
				data: {
					permissions: {
						only: ['ADMIN']
					}
				}
			})
			.state('marketplace.photographers', {
				abstract: true,
				url: '/photographers',
				templateUrl: 'app/photographer-page/photographer-page.html',
				controller: 'photographerPageCtrl',
				controllerAs: 'vm',
				data: {
					permissions: {
						only: ['EVERY_ONE']
					},
					pageTitle: "PIXERF - Top Photographers",
					hideFooter: true
				}
			})
			.state('marketplace.photographers.leaderboard', {
				url: '/leaderboard?order',
				templateUrl: 'app/photographer-page/components/leaderboard-page/leaderboard-page.html',
				controller: 'leaderboardPageCtrl',
				controllerAs: 'vm',
				data: {
					pageTitle: "PIXERF - Leaderboard",
				}
			})
			.state('marketplace.photographers.featuredPhotographer', {
				url: '/featured-photographers?order',
				templateUrl: 'app/photographer-page/components/featured-photographer-page/featured-photographer-page.html',
				controller: 'featuredPhotographerPageCtrl',
				controllerAs: 'vm',
				data: {
					pageTitle: "PIXERF - Featured Photographers",
				}
			});
	}
})();

﻿(function() {

    angular
        .module('pixerf')
        .factory('marketPlaceSvc', marketPlaceSvc);

    marketPlaceSvc.$inject = ['pixerfApiMediaSvc', 'toastr'];

    function marketPlaceSvc(pixerfApiMediaSvc, toastr) {


        var mSpinner = {
            visible: false
        };
        var mPhotos = { data: [] };
        var mBufferPhotos = {data: []};
        function getPhotos() {
            return mPhotos;
        }

        function getBufferPhotos(){
          return mBufferPhotos;
        }
        function getSpinner() {
            return mSpinner;
        }
        function reset() {
            mPhotos.data = [];
        }

        function fetchPhotos(searchParam) {
            pixerfApiMediaSvc.search({
            }, function(response) {
                mPhotos.data = response.data;
                console.log(mPhotos.data);
            }, function() {
                toastr.error("Failed to retrieve photos. Please try again.");
            })
        }
        
        return {
            getSpinner: getSpinner,
            getPhotos: getPhotos,
            fetchPhotos: fetchPhotos,
            reset: reset,
            getBufferPhotos: getBufferPhotos
        };
    }
})();

(function(){

  angular
    .module('pixerf')
    .controller('marketPlaceCtrl', marketPlaceCtrl);

    marketPlaceCtrl.$inject = ['$scope', '$state', 'pixerfMessagePopupSvc', 'stringUtils', 'categoryUtils', 'headerSvc', 'sessionManagerSvc'];

    function marketPlaceCtrl($scope, $state, pixerfMessagePopupSvc, stringUtils, categoryUtils, headerSvc, sessionManagerSvc){
    	var self = this;
        self.selectedCategories = [];
        self.photoPager = null;

        self.onSearchConditionClicked = _.debounce(onSearchConditionClicked, 300);
        self.loginUser = sessionManagerSvc.getCurrentLoginUser().data;
        self.page = 1;
        self.pagerUnit = null;
        self.mobileBreadcrumb = "Trending";
		self.pagerText = 'Trending';
		self.state = $state;
        self.totalPage = 0;
        self.onCurrentPageChanged = onCurrentPageChanged;
        self.onSignatureClicked = onSignatureClicked;
        self.categoryBtnSettings = {
            dropdownClass: 'gallery-categoryIds-dropdown-menu',
            dynamicButtonTextSuffix: ' Categories Selected',
            smartButtonMaxItems: 3,
            closeOnClick: true,
            singleClick: true,
            uncheckCustomText :'All categories',
            caretClass: 'icon-icons_chevron-down',
            buttonClasses: 'multiple-dropdown-selection__btn-dropdown',
            events: {
                onSelectionChanged: function(){
                    self.onSearchConditionClicked();
                }
            }
        }
        init();
        function init(){
            $scope.$watch("vm.photoPager", function(){
                if(self.photoPager){
                    self.photoPager.pageNumber = $state.params.page;
                }
            })
        }
        self.searchFilterBarSettings = headerSvc.getFixedByHeaderSetting();
        function onSignatureClicked(){
            return pixerfMessagePopupSvc.showPopup({
				message: 'Our Signature Galleries are still being curated, and will be ready for their big reveal soon. Stay tuned for our official launch!',
				autoClose: false,
                showBtn: true,
                btnClass: 'btn btn-submit pixerf-btn-sm'
			})
        }
        function onSearchConditionClicked(){
            var params = buildSearchParams($state.params.type);
            params.type = $state.params.type;
            params.page = 1;
            $state.go($state.current.name, params);
        }
        function buildSearchParams(contextCurrent){
            var params = {categoryIds: null};
            var ids = categoryUtils.extractIdsFromCategories(self.selectedCategories);
            params.categoryIds = stringUtils.arrayToString(ids);
            return params;
        }
        function onCurrentPageChanged(pageNumber){
            route = $state.current;
            $state.go(route, {page: pageNumber});
        }

    }
})();

(function(){

    angular
      .module('pixerf')
      .controller('managePhotosMissionCtrl', managePhotosMissionCtrl);
  
      managePhotosMissionCtrl.$inject = ['headerSvc', 'sessionManagerSvc'];
  
      function managePhotosMissionCtrl(headerSvc, sessionManagerSvc){
          var self = this;
          self.contextPage = 'in-review';
          self.searchFilterBarSettings = headerSvc.getFixedByHeaderSetting();
          self.loginnedUser = sessionManagerSvc.getCurrentLoginUser().data;
          self.numberPhotosApproved = self.loginnedUser.stats.approved_mission_media_count;
          self.numberPhotosReviewing = self.loginnedUser.stats.inreview_mission_media_count;
          self.numberPhotosRejected = self.loginnedUser.stats.rejected_mission_media_count;
          self.guestUser = self.loginnedUser && !self.loginnedUser.account_type;
      }
  })();
  
(function () {
    'use strict';

    angular
        .module('pixerf')
        .config(routerConfig);

    routerConfig.$inject = ['$stateProvider'];

    function routerConfig($stateProvider) {
        'ngInject';
        $stateProvider
            .state('setting.manage-photos-mission', {
                templateUrl: 'app/manage-photos-mission/manage-photos-mission.html',
                data: {
                    permissions: {
                        only: ['AUTHORIZED'],
                        redirectTo: function () {
                            return {
                                state: 'home',
                                params: {
                                    callback: location.hash.replace("#", '')
                                }
                            }
                        }
                    },
                    pageTitle: "PIXERF - Manage missions"
                },
                controller: 'managePhotosMissionCtrl',
                controllerAs: 'vm',
                abstract: true
            })
            .state('setting.manage-photos-mission.pending', {
                url: '/manage-submission-missions/pending',
                templateUrl: 'app/manage-photos-mission/pending/manage-pending-photos-mission.html',
                controller: 'managePendingPhotosMissionCtrl',
                controllerAs: 'vm',
                data: {
                    pageTitle: "PIXERF - Pending review",
                    hideFooter: true
                }
            })
            .state('setting.manage-photos-mission.rejected', {
                url: '/manage-submission-missions/rejected',
                templateUrl: 'app/manage-photos-mission/rejected/manage-rejected-photos-mission.html',
                controller: 'manageRejectedPhotosMissionCtrl',
                controllerAs: 'vm',
                data: {
                    pageTitle: "PIXERF - Rejected",
                    hideFooter: true
                }
            })
            .state('setting.manage-photos-mission.approved', {
                url: '/manage-submission-missions/approved',
                templateUrl: 'app/manage-photos-mission/approved/manage-approved-photos-mission.html',
                controller: 'manageApprovedPhotosMissionCtrl',
                controllerAs: 'vm',
                data: {
                    pageTitle: "PIXERF - Approved",
                    hideFooter: true
                }
            })
            .state('setting.manage-photos-mission.awards', {
                url: '/manage-submission-missions/awards',
                templateUrl: 'app/manage-photos-mission/awards/manage-awards-photos-mission.html',
                controller: 'manageAwardsPhotosMissionCtrl',
                controllerAs: 'vm',
                data: {
                    pageTitle: "PIXERF - Awards",
                    hideFooter: true
                }
            });
    }
})();

(function(){

  angular
    .module('pixerf')
    .controller('managePhotosCtrl', managePhotosCtrl);

    managePhotosCtrl.$inject = ['headerSvc', 'sessionManagerSvc'];

    function managePhotosCtrl(headerSvc, sessionManagerSvc){
        var self = this;
        self.contextPage = 'In review';
        self.searchFilterBarSettings = headerSvc.getFixedByHeaderSetting();
        self.loginnedUser = sessionManagerSvc.getCurrentLoginUser().data;
        self.numberPhotosApproved = self.loginnedUser.stats.approved_media_count;
        self.numberPhotosReviewing = self.loginnedUser.stats.inreview_media_count;
        self.numberPhotosRejected = self.loginnedUser.stats.rejected_media_count;
        self.guestUser = self.loginnedUser && !self.loginnedUser.account_type;
    }
})();

(function () {
  'use strict';

  angular
    .module('pixerf')
    .config(routerConfig);

  routerConfig.$inject = ['$stateProvider'];

  function routerConfig($stateProvider) {
    'ngInject';
    $stateProvider
      .state('setting.manage-photos', {
        templateUrl: 'app/manage-photos/manage-photos.html',
        data: {
          permissions: {
              only: ['AUTHORIZED'],
              redirectTo: function(){
                  return {
                      state: 'home',
                      params: {
                          callback: location.hash.replace("#", '')
                      }
                  }
              }
          },
          pageTitle: "PIXERF - Manage photos"
        },
        controller: 'managePhotosCtrl',
        controllerAs: 'vm',
        abstract: true
      })
      .state('setting.manage-photos.rejected', {
        url: '/manage-photos/rejected',
        templateUrl: 'app/manage-photos/components/photos-rejected/photos-rejected.html',
        controller: 'photosRejectedCtrl',
        controllerAs: 'vm',
        data: {
          pageTitle: "PIXERF - Rejected",
          hideFooter: true
        }
      })
      .state('setting.manage-photos.approved', {
        url: '/manage-photos/approved',
        templateUrl: 'app/manage-photos/components/photos-approved/photos-approved.html',
        controller: 'photosApprovedCtrl',
        controllerAs: 'vm',
        data: {
          pageTitle: "PIXERF - Approved",
          hideFooter: true
        }
      })
      .state('setting.manage-photos.pending-review', {
        url: '/manage-photos/pending-review',
        templateUrl: 'app/manage-photos/components/photos-pending-review/photos-pending-review.html',
        controller: 'photosPendingReviewCtrl',
        controllerAs: 'vm',
        data: {
          pageTitle: "PIXERF - Pending Review",
          hideFooter: true
        }
      });
  }
})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.factory('manageMissionsSvc', manageMissionsSvc);
	manageMissionsSvc.$inject = ['sessionManagerSvc', '$translate'];

	function manageMissionsSvc(sessionManagerSvc, $translate) {

		function getDurationList() {
			var durationList = [{ "time": 30, "reward": "150" }, { "time": 45, "reward": "300" }];
			return durationList;
		}

		function getAdditionRequirement() {
			var requirement = {};
			requirement.orientation = [{ "label": "Any", "value": "any", "isSelected": false }, { "label": "Portrait", "value": "portrait", "isSelected": false }, { "label": "Landscape", "value": "landscape", "isSelected": false }, { "label": "Square", "value": "square", "isSelected": false }];
			requirement.license_usage = [{ "label": "Editorial", "value": "editorial", "isSelected": false }, { "label": "Commercial & Editorial", "value": "commercial", "isSelected": false }];
			requirement.environment = [{ "label": "Any", "value": "any", "isSelected": false }, { "label": "Indoor", "value": "indoor", "isSelected": false }, { "label": "Outdoor", "value": "outdoor", "isSelected": false }, { "label": "Studio", "value": "studio", "isSelected": false }];
			requirement.lighting = [{ "label": "Any", "value": "any", "isSelected": false }, { "label": "Natural", "value": "natural", "isSelected": false }, { "label": "Artificial", "value": "artificial", "isSelected": false }];
			requirement.output = [{ "label": "Any", "value": "any", "isSelected": false }, { "label": "Colour Only", "value": "color_only", "isSelected": false }, { "label": "Black & White Only", "value": "black_and_white_only", "isSelected": false }];
			requirement.space_for_copy = [{ "label": "No", "value": false, "isSelected": false }, { "label": "Yes", "value": true, "isSelected": false }];
			return requirement;
		}

		function getRequirementString(requirement, value) {
			var requirementArr = getAdditionRequirement();
			for (var i = 0; i < requirementArr[requirement].length; i++) {
				if (requirementArr[requirement][i].value === value) {
					return requirementArr[requirement][i].label;
				}
			}
			return false;
		}

		function validateSpecifications(mission){
			var listImages = mission.media;
			var errMsg = "";
			if(listImages.length < 3) {
				return $translate.instant("please-upload-at-least-number-photos", {number: 3});
			}
			if(listImages.length > mission.inspiration_limit) {
				return $translate.instant("only-can-upload-number-photos", {number: mission.inspiration_limit});
			}
			return errMsg;
		}

		function validateReward(mission){
			var errMsg = '';
			if (!mission.duration) {
				errMsg = $translate.instant("please-input-duration");
			} else if (isNaN(mission.duration) || mission.duration < 1) {
				errMsg = $translate.instant("please-key-in-whole-number");
			} else if (!mission.winners) {
				errMsg = $translate.instant("please-input-number-winners");
			}
			return errMsg;
		}

		function validateMissionBeforeSave(mission) {
			var errMsg = '';
			if (!mission.title) {
				errMsg = $translate.instant("please-input-mission-name");
			} else if (!mission.description) {
				errMsg = $translate.instant("please-input-art-direction");
			} else if (!mission.duration) {
				errMsg = $translate.instant("please-input-duration");
			} else if (mission.description > 1500) {
				errMsg = $translate.instant("maximum-art-direction-characters", {number: 1500});
			}
			return errMsg;
		}

		function getDropzoneConfig() {
			var dropzoneConfig = {
				'instance': {},
				'options': {
					maxFilesize: 40,
					maxFiles: 15,
					paramName: 'media',
					accept: ['.jpeg', '.jpg'],
					thumbnailWidth: null,
					thumbnailHeight: 155,
					dictDefaultMessage: '',
					parallelUploads: 15,
					autoProcessQueue: true,
					maxThumbnailFilesize: 40,
					addRemoveLinks: true,
					dictRemoveFile: "Remove",
					dictCancelUpload: "Cancel",
					previewsContainer: '#previews',
					method: "post",
					headers: {
						"Authorization": "Bearer " + sessionManagerSvc.getToken()
					},
					dictFileTooBig: "File is too big ({{filesize}} MB). Max file size is: {{maxFilesize}} MB."
				}
			};
			return dropzoneConfig;
		}
		function countDecodedString(text) {
			var parser = new DOMParser;
			var dom = parser.parseFromString(
				'<!doctype html><body>' + text,
				'text/html');
			var decodedString = dom.body.textContent;
			return decodedString.length;
		}

		return {
			getDropzoneConfig: getDropzoneConfig,
			getDurationList: getDurationList,
			getAdditionRequirement: getAdditionRequirement,
			getRequirementString: getRequirementString,
			countDecodedString: countDecodedString,
			validateSpecifications: validateSpecifications,
			validateReward: validateReward,
			validateMissionBeforeSave: validateMissionBeforeSave
		};
	}
})();

(function(){

  angular
    .module('pixerf')
    .controller('manageMissionsCtrl', manageMissionsCtrl);

    manageMissionsCtrl.$inject = ['headerSvc', 'sessionManagerSvc'];

    function manageMissionsCtrl(headerSvc, sessionManagerSvc){
        var self = this;
		self.goBackBtnClicked = goBackBtnClicked;
        self.contextPage = 'Create mission';
        function goBackBtnClicked(){
            window.history.go(-1);
        }
		self.loginedUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.guestUser = self.loginedUser && !self.loginedUser.account_type;
        self.canCreateMission = self.loginedUser && (self.loginedUser.isMaketerInternal || self.loginedUser.isAdminInternal || (self.loginedUser.email === 'marcom@pixerf.com'));
    }
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.config(routerConfig);

	routerConfig.$inject = ['$stateProvider'];

	function routerConfig($stateProvider) {
		'ngInject';

		function fetchMission(createMissionSvc, $q, $stateParams, $state, pixerfApiMissionSvc){
			var def = $q.defer();
			var mission = createMissionSvc.getMission();
			if(mission.id) {
				def.resolve(mission);
				return def.promise;
			}
			pixerfApiMissionSvc.get_prices().$promise.then(function(pricesReponse){
				if($stateParams.id){
					pixerfApiMissionSvc.get({id: $stateParams.id}).$promise.then(function(response){
						mission = response.mission;
						mission.prices = pricesReponse;
						def.resolve(mission);
					}, function(){
						def.reject();
					})	
				} else{
					mission.prices = pricesReponse;
					def.resolve(mission);
				}
			}, function(){
				def.reject();
			})
			
			return def.promise;
		}
		$stateProvider
			.state('manage-missions', {
				url: '/manage-missions',
				templateUrl: 'app/manage-missions/manage-missions.html',
				controller: 'manageMissionsCtrl',
				controllerAs: 'vm',
				abstract: true,
				data: {
					permissions: {
						only: ['MISSION_MANAGER'],
						redirectTo: function () {
							return "404";
						}
					},
					pageTitle: "PIXERF - Manage Missions"
				}
			})
			.state('setting.manage-missions.create-mission', {
				url: '/create-mission/:id',
				templateUrl: 'app/manage-missions/create-mission/create-mission.html',
				controller: 'createMissionCtrl',
				controllerAs: 'vm',
				abstract: true,
				data: {
					permissions: {
						only: ['MISSION_MANAGER'],
						redirectTo: function () {
							return "404";
						}
					},
					pageTitle: "PIXERF - Create Mission"
				},
				resolve: {
					missionData: function(createMissionSvc, $q, $stateParams, $state, pixerfApiMissionSvc){
						return fetchMission(createMissionSvc, $q, $stateParams, $state, pixerfApiMissionSvc);
					}
				}
			})
			.state('setting.manage-missions.create-mission.getting-started', {
				url: '/getting-started',
				templateUrl: 'app/manage-missions/create-mission/create-mission-step-getting-started/create-mission-step-getting-started.html',
				controller: 'createMissionStepGettingStartedCtrl',
				controllerAs: 'vm'
			})
			.state('setting.manage-missions.create-mission.reward', {
				url: '/reward',
				templateUrl: 'app/manage-missions/create-mission/create-mission-step-reward/create-mission-step-reward.html',
				controller: 'createMissionStepRewardCtrl',
				controllerAs: 'vm'
			})
			.state('setting.manage-missions.create-mission.brief', {
				url: '/brief',
				templateUrl: 'app/manage-missions/create-mission/create-mission-step-brief/create-mission-step-brief.html',
				controller: 'createMissionStepBriefCtrl',
				controllerAs: 'vm'
			})
			.state('setting.manage-missions.create-mission.sponsor', {
				url: '/sponsor',
				templateUrl: 'app/manage-missions/create-mission/create-mission-step-sponsor/create-mission-step-sponsor.html',
				controller: 'createMissionStepSponsorCtrl',
				controllerAs: 'vm'
			})
			.state('setting.manage-missions.create-mission.sponsor-options', {
				url: '/sponsor-options',
				templateUrl: 'app/manage-missions/create-mission/create-mission-step-sponsor-options/create-mission-step-sponsor-options.html',
				controller: 'createMissionStepSponsorOptionsCtrl',
				controllerAs: 'vm'
			})
			.state('setting.manage-missions.create-mission.visual-inspiration', {
				url: '/visual-inspiration',
				templateUrl: 'app/manage-missions/create-mission/create-mission-step-visual-inspiration/create-mission-step-visual-inspiration.html',
				controller: 'createMissionStepVisualInspirationCtrl',
				controllerAs: 'vm'
			})
			.state('setting.manage-missions.create-mission.specification', {
				url: '/specification',
				templateUrl: 'app/manage-missions/create-mission/create-mission-step-specification/create-mission-step-specification.html',
				controller: 'createMissionStepSpecificationCtrl',
				controllerAs: 'vm'
			})
			.state('setting.manage-missions.create-mission.specification-one', {
				url: '/specification-one',
				templateUrl: 'app/manage-missions/create-mission/create-mission-step-specification-one/create-mission-step-specification-one.html',
				controller: 'createMissionStepSpecificationOneCtrl',
				controllerAs: 'vm'
			})
			.state('setting.manage-missions.create-mission.review', {
				url: '/review',
				templateUrl: 'app/manage-missions/create-mission/create-mission-step-review/create-mission-step-review.html',
				controller: 'createMissionStepReviewCtrl',
				controllerAs: 'vm'
			})
			.state('setting.manage-missions.draft', {
				url: '/unpublished-missions',
				templateUrl: 'app/manage-missions/mission-draft/mission-draft.html',
				abstract: true,
				data: {
					permissions: {
						only: ['MISSION_MANAGER'],
						redirectTo: function () {
							return "404";
						}
					},
					pageTitle: "PIXERF - Unpublished Mission"
				}
			})
			.state('setting.manage-missions.draft.list-mission-draft', {
				url: '',
				templateUrl: 'app/manage-missions/mission-draft/list-missions-draft/list-missions-draft.html',
				controller: 'listMissionsDraftCtrl',
				controllerAs: 'vm'
			})
			.state('setting.manage-missions.pending', {
				url: '/pending',
				templateUrl: 'app/manage-missions/mission-pending/mission-pending.html',
				controller: 'missionPendingCtrl',
				controllerAs: 'vm'
			})
			.state('setting.manage-missions.on-going', {
				url: '/on-going',
				templateUrl: 'app/mission/components/on-going/on-going.html',
				controller: 'onGoingCtrl',
				controllerAs: 'vm'
			})
			.state('setting.manage-missions.mission-closed', {
				url: '/mission-closed',
				templateUrl: 'app/mission/components/mission-closed/mission-closed.html',
				controller: 'missionClosedCtrl',
				controllerAs: 'vm'
			});
	}

})();

(function () {

	angular
		.module('pixerf')
		.controller('manageMediaPostCtrl', manageMediaPostCtrl);

	manageMediaPostCtrl.$inject = [];

	function manageMediaPostCtrl() {
		var self = this;
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.config(routerConfig);

	routerConfig.$inject = ['$stateProvider'];

	function routerConfig($stateProvider) {
		'ngInject';
		$stateProvider
			.state('setting.manage-media-post', {
				url: '/manage-media-post',
				templateUrl: 'app/manage-media-post/manage-media-post.html',
				controller: 'manageMediaPostCtrl',
				controllerAs: 'vm',
				data: {
					pageTitle: "PIXERF - Manage media"
				}
			})
			.state('setting.manage-media-post.create-post', {
				url: '/create-post',
				templateUrl: 'app/manage-media-post/create-media-post/create-media-post.html',
				controller: 'createMediaPostCtrl',
				controllerAs: 'vm',
				data: {
					pageTitle: "PIXERF - Create post"
				}
			})
			.state('setting.manage-media-post.published', {
				url: '/published',
				templateUrl: 'app/manage-media-post/published-media-post/published-media-post.html',
				controller: 'publishedMediaPostCtrl',
				controllerAs: 'vm',
				data: {
					pageTitle: "PIXERF - Published"
				}
			});
	}
})();

(function(){

  angular
    .module('pixerf')
    .controller('manageHubPageCtrl', manageHubPageCtrl);

    manageHubPageCtrl.$inject = ['$scope', 'sessionManagerSvc'];

    function manageHubPageCtrl($scope, sessionManagerSvc){
        var self = this;
		
		$scope.$parent.vm.isRightPanelShown = false;
		$scope.$parent.vm.isManagePage = true;
    self.user = $scope.$parent.vm.user;
    self.parent = $scope.$parent.vm;
       
        
    }
})();



(function () {

	angular
		.module('pixerf')
		.controller('manageDetailCommunityPageCtrl', manageDetailCommunityPageCtrl);

	manageDetailCommunityPageCtrl.$inject = ['$stateParams', 'sessionManagerSvc', 'headerSvc', 'createCommunityPopupSvc', 'commonConst', 'communityData', 'communityConst', '$state', 'inviteCommunityMembersPopupSvc', '$scope', '$rootScope'];

	function manageDetailCommunityPageCtrl($stateParams, sessionManagerSvc, headerSvc, createCommunityPopupSvc, commonConst, communityData, communityConst, $state, inviteCommunityMembersPopupSvc, $scope, $rootScope) {

		var self = this;
		self.onEditBtnClicked = onEditBtnClicked;
		self.goBackBtnClicked = goBackBtnClicked;
		self.onInviteMembers = onInviteMembers;
		self.community = communityData;
		self.commonConst = commonConst;
		self.isManageMode = !!$stateParams.manage;
		self.loginUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.isManager = self.loginUser && ['manager'].includes(self.community.membership_status);
        self.isMine = self.loginUser && self.community.owner.id === self.loginUser.id;
		self.onCommunityMembershipChanged = onCommunityMembershipChanged;
		self.fixedSetting = headerSvc.getFixedByHeaderSetting();
		self.onBackBtnClicked = onBackBtnClicked;
		self.uploadCommunityAvatarOptions = {};
		self.memberGrid = {};
		self.joinBtnOptions = {
			notJoinedText: 'Join Community',
			joinedText: 'Leave'
		}
		self.contextPage = "Community Details";
		self.publicText = 'This community is visible and open to all, including all content and members.';
		self.privateText = 'Only members of this community can see its full content, including details about its members';

		$rootScope.$on('updatedCoverCommunity', function(event, cover){
			self.community.cover =  $.extend(true, self.community.cover, cover);
		})

		init();

		function init() {
			isContentShowed();
			self.communityAvatar = {
				url: self.community.owner && self.community.owner.profile_image_media && self.community.owner.profile_image_media['100x'] ? self.community.owner.profile_image_media['100x'] : '/assets/images/default/community-default-avatar.png'
			}
		}

		function goBackBtnClicked() {
			window.history.back();
		}

		function onEditBtnClicked() {
			var editedCommunity = $.extend(true, {}, self.community);
			var popup = createCommunityPopupSvc.showPopup({
				mode: commonConst.ACTION.EDIT,
				route: 'no-navigate',
				community: editedCommunity
			});
			popup.result.then(function () {
				self.community.name = editedCommunity.name;
				self.community.description = editedCommunity.description;
			})
		}

		function buildSocialShareContent(community) {
			return {
				'url': window.location.href,
				'description': community.description,
				'title': community.title,
				'media': community.coverImagePath
			};
		}

		function onCommunityMembershipChanged(community) {
			self.community = community;
			isContentShowed();
			if (!community.membership_status) {
				onBackBtnClicked();
			} else {
				$state.reload();
			}
		}

		function isContentShowed() {
			self.isPrivateContentCommunity = self.community.is_private && self.community.membership_status != communityConst.MEMBERSHIP.ACCEPTED && self.community.membership_status != communityConst.MEMBERSHIP.OWNER;
			self.isInvited = self.community.membership_status === communityConst.MEMBERSHIP.INVITED;
		}

		function onBackBtnClicked() {
			$state.go(commonConst.STATE.MANAGE_COMMUNITIES);
		}

		function onInviteMembers() {
			var popup = inviteCommunityMembersPopupSvc.showPopup({
				community: self.community,
				defaultSearchCondition: {
					isDirectoryChecked: true,
					isEmailChecked: false,
					country: "",
					speciality: ""
				}
			});
			popup.result.then(function (invitedPeoples) {
				invitationSentHandler(invitedPeoples);
			});
		}

		function invitationSentHandler(invitedPeoples) {
			var array = invitedPeoples.concat(self.memberGrid.peoples);
			$scope.vm.community.invited_count = array.length;
			self.memberGrid.peoples = array;
			transformMembers(self.memberGrid.peoples);
		}

		function transformMembers(members) {
			if (!members.length) return;
			for (var i = 0; i < members.length; i++) {
				transformMember(members[i]);
			}
		}

		function transformMember(member) {
			member.isSelected = false;
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.config(routerConfig);

	routerConfig.$inject = ['$stateProvider'];

	function routerConfig($stateProvider) {
		'ngInject';
		$stateProvider
			.state('manage-detail-community', {
				abstract: true,
				url: '/manage-detail-community/:id/:name',
				templateUrl: 'app/manage-detail-community-page/manage-detail-community-page.html',
				controller: 'manageDetailCommunityPageCtrl',
				controllerAs: 'vm',
				data: {
					pageTitle: "PIXERF - Manage Community",
					permissions: {
						only: ['AUTHORIZED'],
						redirectTo: function () {
							return "404";
						}
					}
				},
				params: {
					"id": {
						squash: true,
						value: null
					},
					"name": {
						squash: true,
						value: null
					}
				},
				resolve: {
					communityData: function ($stateParams, pixerfApiCommunitySvc, $q, $state, commonConst, sessionManagerSvc) {
						var defer = $q.defer();
						var self = this;
						var loginedUser = sessionManagerSvc.getCurrentLoginUser().data;
						var communityId = parseInt($stateParams.id);
						if (!$stateParams.id || ($stateParams.id && isNaN(communityId))) {
							$state.go('404');
							defer.reject();
						} else {
							pixerfApiCommunitySvc.get({
								id: communityId
							}).$promise.then(function (response) {
								var community = response.data;
								self.managerList = _.filter(community.members, function (item) {
									return item.status === 'manager';
								})
								self.isManager = loginedUser ? _.pluck(self.managerList, "id").includes(loginedUser.id) : false;
								if (loginedUser && (community.owner.id === loginedUser.id || self.isManager)) {
									self.data.pageTitle = "PIXERF - Manage Community: " + community.name;
									defer.resolve(community);
								} else {
									$state.go("404");
									defer.reject();
								}
							}, function (err) {
								console.log(err);
								$state.go(commonConst.STATE.COMMUNITY_NOT_FOUND);
								defer.reject();
							})
						}
						return defer.promise;
					}
				}
			})
			.state('manage-detail-community.manage-detail-community-brief', {
				url: '',
				templateUrl: 'app/manage-detail-community-page/components/manage-detail-community-brief/manage-detail-community-brief.html',
				controller: 'manageDetailCommunityBriefCtrl',
				controllerAs: 'vm'
			});
	}
})();


(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('manageCustomCommissionsCtrl', manageCustomCommissionsCtrl);

	manageCustomCommissionsCtrl.$inject = ['$scope', 'sessionManagerSvc'];

	function manageCustomCommissionsCtrl($scope, sessionManagerSvc) {

		var self = this;
		self.contextPage = "Ongoing";
		self.loginedUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.guestUser = self.loginedUser && !self.loginedUser.account_type;
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.config(routerConfig);

	routerConfig.$inject = ['$stateProvider'];

	function routerConfig($stateProvider) {
		'ngInject';

		$stateProvider
			.state('manage-custom-commissions', {
				url: '/manage-custom-commissions',
				templateUrl: 'app/manage-custom-commissions/manage-custom-commissions.html',
				controller: 'manageCustomCommissionsCtrl',
				controllerAs: 'vm',
				abstract: true,
				data: {
					permissions: {
						only: ['CUSTOM_COMMISSIONS_MANAGER'],
						redirectTo: function () {
							return "404";
						}
					},
					pageTitle: "PIXERF - Manage Custom Commissions"
				}
			})
			.state('setting.manage-custom-commissions.on-going', {
				url: '/on-going',
				templateUrl: 'app/manage-custom-commissions/on-going/custom-commissions-on-going.html',
				controller: 'customCommissionsOnGoingCtrl',
				controllerAs: 'vm'
			})
			.state('setting.manage-custom-commissions.completed', {
				url: '/completed',
				templateUrl: 'app/manage-custom-commissions/custom-commissions-completed/custom-commissions-completed.html',
				controller: 'customCommissionsCompletedCtrl',
				controllerAs: 'vm'
			});
	}

})();

(function() {
  'use strict';

  angular
    .module('pixerf')
    .controller('MainController', MainController);

    MainController.$inject = ['$timeout', 'toastr'];

  function MainController($timeout, toastr) {

    var vm = this;

    vm.awesomeThings = [];
    vm.classAnimation = '';
    vm.creationDate = 1466479174456;
    vm.showToastr = showToastr;

    activate();

    function activate() {
      $timeout(function() {
        vm.classAnimation = 'rubberBand';
      }, 4000);
    }

    function showToastr() {
      toastr.info('Fork <a href="https://github.com/Swiip/generator-gulp-angular" target="_blank"><b>generator-gulp-angular</b></a>');
      vm.classAnimation = '';
    }

  }
})();

/**
 * Controller for logout module
 */
(function(){

  angular
    .module('pixerf')
    .controller('logoutCtrl', logoutCtrl);

    logoutCtrl.$inject = ['auth0AuthenticationSvc'];
    function logoutCtrl(auth0AuthenticationSvc ){
        var self = this;
        auth0AuthenticationSvc.signout();
    }
})();

        

(function() {
  'use strict';

  angular
    .module('pixerf')
    .config(routerConfig);

  routerConfig.$inject = ['$stateProvider'];

  function routerConfig($stateProvider) {
    'ngInject';
    $stateProvider
      .state('logout', {
        url: '/logout',
        controller: 'logoutCtrl',
        controllerAs: 'vm',
      });
  }
})();

(function () {

	angular
		.module('pixerf')
		.controller('jobsCtrl', jobsCtrl);

	jobsCtrl.$inject = ['$scope', 'jobSvc', '$state'];

	function jobsCtrl($scope, jobSvc, $state) {

		var self = this;
		self.jobs = jobSvc.getOpenedJobs();
		self.onDetailJob = onDetailJob;

		function onDetailJob(jobId){
			$state.go("job-detail-page", {id: jobId});
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.config(routerConfig);

	routerConfig.$inject = ['$stateProvider'];

	function routerConfig($stateProvider) {
		'ngInject';
		$stateProvider
			.state('jobs', {
				url: '/careers',
				templateUrl: 'app/jobs/jobs.html',
				controller: 'jobsCtrl',
				controllerAs: 'vm',
				data: {
					pageTitle: "PIXERF - Careers",
                    permissions: {
                        only: ['EVERY_ONE']
                    }
				}
			});
	}

})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.factory('jobSvc', jobSvc);
	jobSvc.$inject = [];

	function jobSvc() {

		var mOpenedJobs = [
            {
                id: 1,
                title: "Senior UI/UX Designer (Remote)",
                description: "Working remotely but closely within a small team, you will be responsible for designing and shaping unique, user-centric products and experiences for the brand. You will make design decisions and translate any given user-experience journey into smooth and intuitive interactions.",
            },
            {
                id: 2,
                title: "Social Media Manager (Remote)",
                description: "Working remotely but closely within a small team, you will be responsible for growing our social media presence, increasing engagement and driving organic traffic to our website.",
            }
            // {
            //     id: 3,
            //     title: "Tech Lead, Backend",
            //     description: "We are looking for a Tech Lead with a strong technical vision and who is hands on with code.",
            // },
            // {
            //     id: 4,
            //     title: "Senior Android Developer",
            //     description: "We are looking for a developer who lives, breathes and loves everything mobile, specialising in Android application development."
            // },
            // {
            //     id: 5,
            //     title: "QA / QC Engineer Mobility",
            //     description: "We are looking for a QA / QC Engineer with the right skills and attitude, specialising in mobile application testing (iOS, Android)."
            // }
        ];

        function getOpenedJobs(){
            return mOpenedJobs;
        }

		return {
			getOpenedJobs: getOpenedJobs
		};
	}
})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.factory('jobDetailPageSvc', jobDetailPageSvc);
	jobDetailPageSvc.$inject = [];

	function jobDetailPageSvc() {

		var mSocialMediaPosition = {
            id: 2,
            title: "Social Media Manager (Remote)",
            subTitle: "Working remotely but closely within a small team, you will be responsible for growing our social media presence, increasing engagement and driving organic traffic to our website.",
            description: [
				{"label": "Responsibilities", "descriptions": [
					"Developing the social media strategy to significantly increase our reach, the engagement of our content and the top of the funnel traffic to our website.",
					"Managing the brand’s content schedule for social media - LinkedIn, Twitter, Instagram and Facebook, Youtube and Telegram and digital channels.",
					"Executing and optimising marketing campaigns end-to-end with minimal supervision.",
					"Working with writers and content creators and also contributing to writing impactful content for the brand’s audiences.",
					"Maintain brand and channel standards with meticulous attention to detail.",
					"Rigorously applying test and learn methodology to continually improve social performance Reviewing our current social media management tools and implementing new tools and processes if necessary",
					"Identifying growth opportunities across the marketing funnel by finding new ways to acquire and engage our customers",
					"Working with the team to build customer acquisition strategies and convert more followers to paying customers",
					"Helping the team understand the content performance across social media channels"
				]},
				{"label": "Requirements:", "descriptions": [
					"Experience in social media marketing and management, preferably in tech companies",
					"Creative with a flair for writing impactful and punchy copy with proven results.",
					"Strong understanding of the strategies and tactics required to leverage social traffic",
					"Demonstrate the ability to analyse and understand important performance drivers against findings.",
					"Excellent communication and writing skills in English.",
					"A test, validate and learn outlook to optimise content performance.",
					"An eye for good UX, UI and design as well as marketing.",
					"Meticulous and organized",
					"Ability to work independently in a fully remote position with teams in various countries."
				]}
			],
            emailSubject: "Application for Social Media Manager (Remote)"
        };

		var mUIUXPosition = {
            id: 1,
            title: "Senior UI/UX Designer (Remote)",
            subTitle: "Working remotely but closely within a small team, you will be responsible for designing and shaping unique, user-centric products and experiences for the brand. You will make design decisions and translate any given user-experience journey into smooth and intuitive interactions.",
            description: [
				{"label": "Responsibilities", "descriptions": [
					"Gather and evaluate user requirements in collaboration with internal and external stakeholders",
					"Be a great team player by working with remote teams and collaborating closely with developers, copywriter and other designers.",
					"Conceptualise, create, improve and use wireframes, prototypes, style guides, user flows, and effectively communicate interactive ideas.",
					"Present and defend design decisions, ensuring they support the overall roadmap as well as good design fundamentals.",
					"Ensure that the product interface aligns with the company’s overall vision and style.",
					"Understand and conduct usability testing and troubleshoot UX problems.",
					"Keep up to speed with the latest trends, standards, and updates in the UI/UX industry."
				]},
				{"label": "Requirements:", "descriptions": [
					"5 years of experience in a similar role and experience working for technology companies preferred.",
					"A strong portfolio and proven track record with confidence in explaining design concepts and ideation.",
					"Hands-on experience creating wireframes, prototypes, storyboards, user flows qnd more.",
					"Familiar with tools such as Figma, Photoshop, Sketch, Illustrator, InVision and other software.",
					"Creative with a design thinking and problem-solving mindset.",
					"Experience working in an agile/scrum development process.",
					"Great communication skills and capable of explaining decisions.",
					"Good knowledge and skilled in layouts and design as well as UI/UX design systems.",
					"A strong grasp of user-centred design, planning and conducting user research, user testing, rapid prototyping, heuristic, usability and accessibility analysis.",
					"Excellent understanding and experience in building B2B applications and dashboards on both desktop and mobile.",
					"Ability to work independently in a fully remote position with teams in various countries."
				]}
			],
            emailSubject: "Application for Senior UI/UX Designer (Remote)"
        };

		var mTechLeachPosition = {
            id: 3,
            title: "Tech Lead",
            subTitle: "We are looking for a Tech Lead with a strong technical vision and who is hands on with code.",
            description: [
				{"label": "Responsibilities", "descriptions": [
					"Provide expertise and support to the development team",
					"Make effective architectural decisions",
					"Work closely with Product Manager to advise on product development decisions",
					"Operate in an Agile/Scrum environment",
					"Maintain high coding standards with extensive test coverage"
				]},
				{"label": "Qualifications and Skills:", "descriptions": [
					"Have 6+ years of web development experience",
					"Have 1+ year experience leading a team",
					"Proficiency with Ruby/Rails or Python/Django",
					"Production experience with Elixir and Phoenix will be a huge plus",
					"Excellent problem solving and analytical skills",
					"PostgreSQL, Elasticsearch and DevOps experience",
					"Experience with ecommerce integration / implementation will be a bonus"
				]}
			],
            emailSubject: "Application for Tech Lead"
        };

        var mAndroidPosition = {
            id: 4,
            title: "Senior Android Developer",
            subTitle: "We are looking for a developer who lives, breathes and loves everything mobile, specialising in Android application development.",
            description: [
				{"label": "Responsibilities", "descriptions": [
					"Native Android application development and converting ideas, designs and requirements to concrete stable production builds",
					"Able to work independently on compressed schedules in a fast-paced environment to meet demands",
					"Conduct analysis of organisational needs and goals for the development and implementation of the product",
					"Coordinate and collaborate with the Product and Engineering team to understand problems, propose creative solutions, and help with tracking and delivering within the release plan",
					"Understand and implement Android specific design patterns",
					"Collaborate with Engineering and QA to resolve defects",
					"Good communication skills, easy to work with, able to work independently, passionate about Android mobile devices/applications"
				]},
				{"label": "Qualifications and Skills:", "descriptions": [
					"BS or MS Computer Science with 5+ years of relevant work experience",
					"5+ years' experience in database design and data structures",
					"5+ years' experience in building Android applications",
					"Demonstrate strong skills in programming using any JVM language, preferably Kotlin",
					"Experience with any lambda language",
					"Knowledge about multi-threading, memory management, caching and profiling",
					"Development of Human Interfaces by strictly following Google Material Design Guidelines",
					"An Android application that you have developed, available in Google Play Store"
				]},
				{"label": "Good to have:", "descriptions": [
					"Experience with Android Biometric API, Direct Share API, Camera API, Camera Reprocessing API, Localization(i18n)",
					"Experience in TDD",
					"Knowledge about CI/CD",
					"Knowledge about Scrum and/or Agile development methodologies"
				]}
			],
            emailSubject: "Senior Android Developer"
        };

        var mQAPosition = {
            id: 5,
            title: "QA/QC Engineer Mobility",
            subTitle: "We are looking for a QA/QC Engineer with the right skills and attitude, specialising in mobile application testing (iOS, Android).",
            description: [
				{"label": "Responsibilities", "descriptions": [
					"Evaluate and test cutting edge mobile applications (iOS, Android)",
					"Perform software testing on both existing software and new features",
					"Assist the software engineers in delivering better quality software to the integration teams and end customers",
					"Develop feature functionality and customer use cases",
					"Define requirements and performance measures",
					"Ability to assist with feature plan implementation",
					"Ability to work in a remote environment yet deliver beyond expectations",
					"Ability to work independently with minimal assistance, while also a great team player"
				]},
				{"label": "Qualifications and Skills:", "descriptions": [
					"BS/MS Computer Science with 2+ years of relevant work experience",
					"At least 2+ years of experience with mobile application testing (iOS, Android)",
					"Knowledge of mobile middleware design, development, and testing processes, tools and methodologies, including understanding and practical knowledge of backend integration",
					"Practical working knowledge of mobile application platforms, technologies, and ecosystem pertaining to mobile application development (Apple iOS, Google Android, Microsoft Windows Phone)",
					"Exceptional analytical skills, good communication skills, ability to suggest new ideas that provide a different perspective for product evolution",
					"Excellent bug detection capabilities"
				]},
				{"label": "Good to have:", "descriptions": [
					"Knowledge of Scrum and/or Agile",
					"Knowledge of RAD/RUP",
					"Knowledge of CI/CD"
				]}
			],
            emailSubject: "QA/QC Engineer Mobility"
        };

        function getDescriptionByJobId(jobId){
			var jobDetails;

            switch(jobId.toString()){
				case "1":
					jobDetails = mUIUXPosition;
					break;
				case "2":
                    jobDetails = mSocialMediaPosition;
					break;
                // case "3":
                //     jobDetails = mTechLeachPosition;
                //     break;
                // case "4":
                //     jobDetails = mAndroidPosition;
                //     break;
                // case "5":
                //     jobDetails = mQAPosition;
                //     break;
            }

			return jobDetails;
        }

		return {
			getDescriptionByJobId: getDescriptionByJobId
		};
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('jobDetailPageCtrl', jobDetailPageCtrl);

	jobDetailPageCtrl.$inject = ['$scope', '$stateParams', '$state', 'jobDetailPageSvc'];

	function jobDetailPageCtrl($scope, $stateParams, $state, jobDetailPageSvc) {
		var self = this;
		self.job = jobDetailPageSvc.getDescriptionByJobId($stateParams.id);
		$state.current.data.pageTitle = "PIXERF - " + self.job.title;
		self.onBackBtnClicked = onBackBtnClicked;

		function onBackBtnClicked(){
			$state.go("jobs");
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.config(routerConfig);

	routerConfig.$inject = ['$stateProvider'];

	function routerConfig($stateProvider) {
		'ngInject';
		$stateProvider
			.state('job-detail-page', {
				url: '/job-detail-page/:id',
				templateUrl: "app/job-detail-page/job-detail-page.html",
				controller: 'jobDetailPageCtrl',
				controllerAs: 'vm',
				data: {
					pageTitle: "PIXERF - Position Details",
				}
			});
	}

})();

﻿(function () {

	angular
		.module('pixerf')
		.factory('homeSvc', homeSvc);

	homeSvc.$inject = [];

	function homeSvc() {

		var mCaseStudies = [{
			coverPhoto: 'assets/images/casestudy-carousel/honda-cover.jpg',
			logo: 'assets/images/casestudy-carousel/honda-logo.png',
			label: 'Engaged PIXERF for custom content:',
			name: 'Honda customer story shoot',
			intro: 'It was a pleasant experience working with PIXERF, They were very responsive and helpful. Despite the Covid Pandemic, we were still able to achieve quality images from the team. Overall, we’re satisfied with the deliverables.',
			author: 'Honda Malaysia',
			role: 'Brand Communication Team',
			company: ''
		}, {
			coverPhoto: 'assets/images/casestudy-carousel/geo-cover.jpg',
			logo: 'assets/images/casestudy-carousel/geo-logo.png',
			label: 'Engaged PIXERF for photo challenge:',
			name: 'Images of Asia',
			intro: 'Bringing PIXERF onboard as our tech partner allowed us to leverage their platform and community of contributors to increase outreach efforts for our Images of Asia 2018 Photo Competition. The partnership enhanced the submissions received and we gained useful data from it.',
			author: 'John Thet',
			role: 'CEO',
			company: 'Asian Geographic'
		}, {
			coverPhoto: 'assets/images/casestudy-carousel/ensemble-cover.jpg',
			logo: 'assets/images/casestudy-carousel/ensemble-logo.png',
			label: 'Engaged PIXERF for custom content:',
			name: 'Petronas Campaign Shoot',
			intro: 'For this campaign, we needed photographers with experience in non-conventional shoot portfolios. The designated photographers for each shoot project were agile and executed the work professionally.',
			author: 'Creative Team at Ensemble',
			role: 'Creative Agency for Petronas',
			company: ''
		}, {
			coverPhoto: 'assets/images/casestudy-carousel/gojek-cover.jpg',
			logo: 'assets/images/casestudy-carousel/gojek-logo.png',
			label: 'Engaged PIXERF for photo challenge:',
			name: 'Museum of Hacks',
			intro: 'PIXERF has been super cool to work with. Very reactive and experimental. What we wanted was a wildly niche solution... but PIXERF came in with an interesting solution to gamify it.',
			author: 'VJ Anand',
			role: 'VP Creative, Gojek Indonesia',
			company: ''
		}, {
			coverPhoto: 'assets/images/casestudy-carousel/wwf-cover.jpg',
			logo: 'assets/images/casestudy-carousel/wwf-logo.png',
			label: 'Engaged PIXERF for Photo challenge:',
			name: 'Youth in Urban Nature',
			intro: 'We wanted to capture the relationship between young people and their natural environment through fresh, authentic, relatable images. PIXERF’s photo contest more than met our expectations by giving us diverse yet unique shots. And the whole process was smooth!',
			author: 'Niharika Iyengar',
			role: 'Assistant, Digital Engagement',
			company: ''
		}];

		var mBannerCarousel = [{
				id: "147795",
				theme: 'slide--1',
				photo: 'assets/images/homepage/banner-slide-1.jpg',
				photoMobile: 'assets/images/homepage/banner-slide-1-mobile.jpg',
				title: 'From local shoots to global video and photo productions.',
				description: 'Our one-stop photo and video platform helps brands deliver visual content fast and at scale.',
				style: {
					styleText: 'text--white',
				},
				button: {
					text: 'Book a Shoot Now',
					cta: self.bookShoot,
					actionName: 'bookShoot'
				}
			},
			{
				id: "16301",
				theme: 'slide--2',
				photo: 'assets/images/homepage/banner-slide-2.jpg',
				photoMobile: 'assets/images/homepage/banner-slide-2.jpg',
				title: 'Run a photo challenge for localised and culturally relevant photos.',
				description: 'Get photos from our global community of creators with a simple brief.',
				style: {
					styleText: 'text--white',
				},
				button: {
					text: 'Run a Challenge',
					cta: self.runChallenge,
					actionName: 'runChallenge'
				}
			},
			{
				id: "135392",
				theme: 'slide--3',
				photo: 'assets/images/homepage/banner-slide-3.jpg',
				photoMobile: 'assets/images/homepage/banner-slide-3-mobile.png',
				title: 'Buy authentic photos from the best Asian stock marketplace.',
				description: 'Fresh photos released every day. Choose a plan and save up to 30%!',
				style: {
					styleText: 'text--white max-width--300',
				},
				button: {
					text: 'Buy a credit plan',
					cta: self.buyCreditPlan,
					actionName: 'buyCreditPlan'
				}
			},
		];

		var mCategories = {

			data: {
				expanded: [{
						name: 'Faces of Asia',
						galleries: [{
								title: 'Visions Of</br>Beauty',
								url: 'assets/images/homepage_signature_galleries/faces_of_asia/faces_of_asia_01.jpg',
								description: 'Faces of Asia'
							},
							{
								title: 'Joy In</br>Motion',
								url: 'assets/images/homepage_signature_galleries/faces_of_asia/faces_of_asia_02.jpg',
								description: 'Faces of Asia'
							},
							{
								title: 'Modern</br>Asian</br>Women',
								url: 'assets/images/homepage_signature_galleries/faces_of_asia/faces_of_asia_03.jpg',
								description: 'Faces of Asia'
							},
							{
								title: 'Millennials',
								url: "assets/images/homepage_signature_galleries/faces_of_asia/faces_of_asia_04.jpg",
								description: 'Faces of Asia'
							}
						],
						isSelected: true
					},
					{
						name: 'Fashion',
						galleries: [{
								title: 'Urban</br>Style',
								url: 'assets/images/homepage_signature_galleries/fashion/fashion_01.jpg',
								description: 'Fashion'
							},
							{
								title: 'Fashion</br>Fantasy',
								url: 'assets/images/homepage_signature_galleries/fashion/fashion_02.jpg',
								description: 'Fashion'
							},
							{
								title: 'Fabulous</br>Runway',
								url: 'assets/images/homepage_signature_galleries/fashion/fashion_03.jpg',
								description: 'Fashion'
							},
							{
								title: "Avant</br>Garde",
								url: 'assets/images/homepage_signature_galleries/fashion/fashion_04.jpg',
								description: 'Fashion'
							}
						]
					},
					{
						name: 'Food',
						galleries: [{
								title: 'Minimalist</br>Beauty',
								url: 'assets/images/homepage_signature_galleries/food/food_01.jpg',
								description: 'Food'
							},
							{
								title: "Mod Asian</br>Kitchen",
								url: 'assets/images/homepage_signature_galleries/food/food_02.jpg',
								description: 'Food'
							},
							{
								title: 'A Taste</br>Of Luxury',
								url: 'assets/images/homepage_signature_galleries/food/food_03.jpg',
								description: 'Food'
							},
							{
								title: 'Sweet</br>Celebrations',
								url: "assets/images/homepage_signature_galleries/food/food_04.jpg",
								description: 'Food'
							}
						]
					},
					{
						name: 'Culture',
						galleries: [{
								title: 'Colourful</br>Festivities',
								url: 'assets/images/homepage_signature_galleries/culture/culture_01.jpg',
								description: 'Culture'
							},
							{
								title: 'Keeping</br>Traditions</br>Alive',
								url: 'assets/images/homepage_signature_galleries/culture/culture_02.jpg',
								description: 'Culture'
							},
							{
								title: 'Carnival!',
								url: 'assets/images/homepage_signature_galleries/culture/culture_03.jpg',
								description: 'Culture'
							},
							{
								title: 'Rural</br>Beauty',
								url: "assets/images/homepage_signature_galleries/culture/culture_04.jpg",
								description: 'Culture'
							}
						]
					},
					{
						name: 'Travel',
						galleries: [{
								title: 'Adrenaline</br>Pumping</br>Thrills',
								url: 'assets/images/homepage_signature_galleries/travel/travel_01.jpg',
								description: 'Travel'
							},
							{
								title: 'The People</br>You Meet',
								url: 'assets/images/homepage_signature_galleries/travel/travel_02.jpg',
								description: 'Travel'
							},
							{
								title: 'Like The</br>Locals Do',
								url: 'assets/images/homepage_signature_galleries/travel/travel_03.jpg',
								description: 'Travel'
							},
							{
								title: "Iconic</br>Sights",
								url: "assets/images/homepage_signature_galleries/travel/travel_04.jpg",
								description: 'Travel'
							}
						]
					},
					{
						name: 'Architecture',
						galleries: [{
								title: 'View From</br>The Top',
								url: 'assets/images/homepage_signature_galleries/architecture/architecture_01.jpg',
								description: 'Architecture'
							},
							{
								title: 'The Perfect</br>Frame',
								url: 'assets/images/homepage_signature_galleries/architecture/architecture_02.jpg',
								description: 'Architecture'
							},
							{
								title: "It's All In</br>The Details",
								url: 'assets/images/homepage_signature_galleries/architecture/architecture_03.jpg',
								description: 'Architecture'
							},
							{
								title: 'Brand New</br>Perspectives',
								url: 'assets/images/homepage_signature_galleries/architecture/architecture_04.jpg',
								description: 'Architecture'
							}
						],
						description: 'Architecture'
					}
				],

				collapsed: [{
						name: 'Arts',
						photos: []
					},
					{
						name: 'Sports',
						photos: []
					},
					{
						name: 'Natural',
						photos: []
					}

				]
			}

		}

		var mBrandLogos = [{
				id: 1,
				photo: ['assets/images/homepage/slide-1-1.png', 'assets/images/homepage/slide-1-2.png'],
				photoMobile: ['assets/images/homepage/slide-1-1-mobile.png', 'assets/images/homepage/slide-1-2-mobile.png']
			},
			{
				id: 2,
				photo: ['assets/images/homepage/slide-2-1.png', 'assets/images/homepage/slide-2-2.png'],
				photoMobile: ['assets/images/homepage/slide-2-1-mobile.png', 'assets/images/homepage/slide-2-2-mobile.png']
			},
			{
				id: 3,
				photo: ['assets/images/homepage/slide-3-1.png', 'assets/images/homepage/slide-3-2.png'],
				photoMobile: ['assets/images/homepage/slide-3-1-mobile.png', 'assets/images/homepage/slide-3-2-mobile.png']
			},
			{
				id: 4,
				photo: ['assets/images/homepage/slide-4-1.png', 'assets/images/homepage/slide-4-2.png'],
				photoMobile: ['assets/images/homepage/slide-4-1-mobile.png', 'assets/images/homepage/slide-4-2-mobile.png']
			},
			{
				id: 5,
				photo: ['assets/images/homepage/slide-5-1.png', 'assets/images/homepage/slide-5-2.png'],
				photoMobile: ['assets/images/homepage/slide-5-1-mobile.png', 'assets/images/homepage/slide-5-2-mobile.png']
			},
			{
				id: 6,
				photo: ['assets/images/homepage/slide-6-1.png', 'assets/images/homepage/slide-6-2.png'],
				photoMobile: ['assets/images/homepage/slide-6-1-mobile.png', 'assets/images/homepage/slide-6-2-mobile.png']
			},
			{
				id: 7,
				photo: ['assets/images/homepage/slide-7-1.png', 'assets/images/homepage/slide-7-2.png'],
				photoMobile: ['assets/images/homepage/slide-7-1-mobile.png', 'assets/images/homepage/slide-7-2-mobile.png']
			},
			{
				id: 8,
				photo: ['assets/images/homepage/slide-8-1.png', 'assets/images/homepage/slide-8-2.png'],
				photoMobile: ['assets/images/homepage/slide-8-1-mobile.png', 'assets/images/homepage/slide-8-2-mobile.png']
			},
			{
				id: 9,
				photo: ['assets/images/homepage/slide-9-1.png', 'assets/images/homepage/slide-9-2.svg'],
				photoMobile: ['assets/images/homepage/slide-9-1-mobile.png', 'assets/images/homepage/slide-9-2-mobile.svg']
			},
			{
				id: 10,
				photo: ['assets/images/homepage/slide-10-1.png', 'assets/images/homepage/slide-10-2.png'],
				photoMobile: ['assets/images/homepage/slide-10-1-mobile.png', 'assets/images/homepage/slide-10-2-mobile.png']
			},
			{
				id: 11,
				photo: ['assets/images/homepage/slide-11-1.png', 'assets/images/homepage/slide-11-2.png'],
				photoMobile: ['assets/images/homepage/slide-11-1-mobile.png', 'assets/images/homepage/slide-11-2-mobile.png']
			},
			{
				id: 12,
				photo: ['assets/images/homepage/slide-12-1.png', 'assets/images/homepage/slide-12-2.png'],
				photoMobile: ['assets/images/homepage/slide-12-1-mobile.png', 'assets/images/homepage/slide-12-2-mobile.png']
			},
		];

		mCategories.data.expanded[0].selectedGallery = mCategories.data.expanded[0].galleries[0];

		var mSelectedCategory = {
			data: mCategories.data.expanded[0]
		}

		function selectCategory(category) {
			mSelectedCategory.data.isSelected = false;
			category.isSelected = true;
			mSelectedCategory.data = category;
			selectGallery(category.galleries[0]);
		}

		function selectGallery(gallery) {
			mSelectedCategory.data.selectedGallery ? mSelectedCategory.data.selectedGallery.isSelected = false : '';
			gallery.isSelected = true;
			mSelectedCategory.data.selectedGallery = gallery;
		}

		function getCategories() {
			for (var i = 0; i < mCategories.data.expanded.length; i++) {
				var category = mCategories.data.expanded[i];
				for (var j = 0; j < category.galleries.length; j++) {
					category.galleries[j].url = category.galleries[j].url.replace(/ /g, '%20');
				}
			}
			return mCategories;
		}

		function getCaseStudies() {
			return mCaseStudies;
		}

		function getSelectedCategory() {
			return mSelectedCategory;
		}

		function getBannerCarousel() {
			return mBannerCarousel;
		}

		function getBrandLogos() {
			return mBrandLogos;
		}

		return {
			selectCategory: selectCategory,
			selectGallery: selectGallery,
			getCategories: getCategories,
			getSelectedCategory: getSelectedCategory,
			getCaseStudies: getCaseStudies,
			getBannerCarousel: getBannerCarousel,
			getBrandLogos: getBrandLogos
		};
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('homeCtrl', homeCtrl);

	homeCtrl.$inject = ['$scope', 'customCommissionBasicFormPopupSvc', '$timeout', '$location', 'homeSvc', '$anchorScroll', 'systemUtils', '$state', 'sessionManagerSvc', 'emailUsPopupSvc', 'toastr', '$window'];

	function homeCtrl($scope, customCommissionBasicFormPopupSvc, $timeout, $location, homeSvc, $anchorScroll, systemUtils, $state, sessionManagerSvc, emailUsPopupSvc, toastr, $window) {
		var self = this;
		self.bookShoot = bookShoot;
		self.runChallenge = runChallenge;
        self.buyCreditPlan = buyCreditPlan;
		self.navigateNext = navigateNext;
		self.navigateRight = navigateRight;
		self.bookADemo = bookADemo;
		self.banners = homeSvc.getBannerCarousel();
		self.caseStudies = homeSvc.getCaseStudies();
		self.brands = homeSvc.getBrandLogos();
		self.loginUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.isBusinessAcc = self.loginUser && self.loginUser.account_type === 'business';

		self.responsive = [{
			breakpoint: 1400,
			settings: {
				slidesToShow: 5,
				slidesToScroll: 5
			}
		}, {
			breakpoint: 992,
			settings: {
				slidesToShow: 4,
				slidesToScroll: 4
			}
		}, {
			breakpoint: 768,
			settings: {
				slidesToShow: 3,
				slidesToScroll: 3
			}
		}];

		self.slickSetting = {
			onInit: function (slick) {
				self.slick = slick;
				systemUtils.digest($scope);
			},
			onAfterChange: function (event, slick, currentSlide) {
				if (slick.$slides.length == currentSlide + slick.options.slidesToScroll) {
					self.isLastBrandsSlide = true;
				} else {
					self.isLastBrandsSlide = false;
				}
				systemUtils.digest($scope);
			}
		}

		function bookShoot() {
            $window.event.stopPropagation();
			customCommissionBasicFormPopupSvc.showPopup({fromPage:'home'});
		}

		function runChallenge() {

			if(!(self.loginUser && self.loginUser.id)){
				// var state = $state.href('setting.manage-missions.on-going', {}, {absolute: false});
				// state = state.replace('#/', "/");
				// sessionManagerSvc.setCallbackURL(state);
				// return signUpBusinessPopupSvc.showPopup();
				
				emailUsPopupSvc.showPopup();
				return;
			}
			if(self.isBusinessAcc){
				// $state.go("setting.manage-missions.on-going");
				emailUsPopupSvc.showPopup();
				return;
			}else{
				toastr.info('Challenges are only open to business account users.');
			}
		}

		function bindingEventToBannerCarousel() {
			if (!self.banners || !self.banners.length) return;
			for (var i = 0; i < self.banners.length; i++) {
				if (self.banners[i].button.actionName == 'bookShoot') {
					self.banners[i].button.cta = bookShoot;
				} else if (self.banners[i].button.actionName == 'runChallenge') {
					self.banners[i].button.cta = runChallenge;
				} else if (self.banners[i].button.actionName == 'buyCreditPlan') {
					self.banners[i].button.cta = buyCreditPlan;
				}
			}
		}

		function navigateNext() {
			self.slick.slickNext();
		}

		function navigateRight() {
			self.slick.slickPrev();
		}

		function bookADemo() {
            $window.event.stopPropagation();
			emailUsPopupSvc.showPopup();
		}

        function buyCreditPlan(){
            $window.event.stopPropagation();
            $state.go('about-business-page.pricing');
        }

		function init() {
			bindingEventToBannerCarousel();
			self.targetSection = $state.params.section ? $state.params.section : null;
			if (self.targetSection) {
				$location.hash(self.targetSection);
				$anchorScroll();
			}
		}

		init();
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.config(routerConfig);

	routerConfig.$inject = ['$stateProvider'];

	function routerConfig($stateProvider) {
		'ngInject';
		$stateProvider
			.state('home', {
				url: '/?callback:section',
				templateUrl: 'app/home/home.html',
				controller: 'homeCtrl',
				controllerAs: 'vm',
				params: {
					"section": {
						squash: true,
						value: null
					}
				},
				data: {
					permissions: {
						only: ['EVERY_ONE']
					},
					// permissions: {
					// 	only: ['ANONYMOUS'],
					// 	redirectTo: function (user, param) {
					// 		return {
					// 			'state': "user-home-page.homepage",
					// 			params: {
					// 				id: user ? user.id : undefined
					// 			}
					// 		}

					// 	}
					// },
					pageTitle: "PIXERF: Asia’s fastest-growing Asian stock photo site",
					headerClass: 'homepage'
				}
			})
			// .state('invite-community', {
			// 	url: '/c/:code',
			// 	resolve: {
			// 		data: function ($stateParams, $q, $state, store, sessionManagerSvc) {
			// 			var user = sessionManagerSvc.getCurrentLoginUser().data;
			// 			if ($stateParams.code) {
			// 				store.set('csc', $stateParams.code);
			// 				if (user) {
			// 					$state.go('user-home-page.homepage');
			// 				} else {
			// 					$state.go('sign-up.sign-up-personal-info');
			// 				}
			// 			}
			// 			else {
			// 				$state.go('404');
			// 			}
			// 		}
			// 	},
			// 	data: {
			// 		permissions: {
			// 			only: ['EVERY_ONE']
			// 		}
			// 	}
			// })
			;
	}
})();

﻿/*
 * Service handler for User Home Page module
 * We will implement all business logic for "home" module here
 */
/**
 * Controller for home module
 */
(function(){

  angular
    .module('pixerf')
    .factory('gallerySvc', gallerySvc);

    gallerySvc.$inject = ['pixerfApiMediaSvc', 'toastr', 'sessionManagerSvc', 'pixerfApiGallerySvc', 'galleryUtils'];

    function gallerySvc(pixerfApiMediaSvc, toastr, sessionManagerSvc, pixerfApiGallerySvc, galleryUtils){
    	
        var mCurrentPage = {
            data: 0
        };

        var mPhotos = {data: []};
    	var mBufferPhotos = {data: []};

        function getCurrentPhotoPage(){
            return mCurrentPage;
        }
    	function getPhotos(){
            return mPhotos;
        }
        function getBufferPhotos(){
    		return mBufferPhotos;
    	}
        function reset(){
            mPhotos.data = [];
            mBufferPhotos.data = [];
            mCurrentPage.data = 0;
        }
    	function fetchPhotos(searchParam){
    		return pixerfApiMediaSvc.search({
                    page: searchParam.page
                }, {
                user:{
                    username: searchParam.username
                }
            }).$promise;
    	}
        function fetchMorePhotos(searchParam){
            console.log('fetchPhotos');
            mCurrentPage.data++;
            searchParam.page = mCurrentPage.data;
            return fetchPhotos(searchParam);
        }
        function updateGalleryCover(gallery){
            pixerfApiGallerySvc.get({id: gallery.id}).$promise.then(function(response){
                gallery.cover_media = response.data.cover_media;
                galleryUtils.updateThumnailPath(gallery);
            });
        }
		/*
		 * exports public methods
		 */
		return {
			getPhotos: getPhotos,
            getBufferPhotos: getBufferPhotos,
			fetchPhotos: fetchPhotos,
            reset: reset,
            fetchMorePhotos: fetchMorePhotos,
            getCurrentPhotoPage: getCurrentPhotoPage,
            updateGalleryCover: updateGalleryCover
		};
    }
})();

(function(){

  angular
    .module('pixerf')
    .controller('galleryCtrl', galleryCtrl);

    galleryCtrl.$inject = ['$scope', 'sessionManagerSvc', 'headerSvc', '$stateParams', 'toastr', 'createGallerySvc', 'commonConst', 'galleryConst', '$state', 'pixerfApiGallerySvc', '$q', '$translate', 'translationSvc', '$rootScope'];

    function galleryCtrl($scope, sessionManagerSvc, headerSvc, $stateParams, toastr, createGallerySvc, commonConst, galleryConst, $state, pixerfApiGallerySvc, $q, $translate, translationSvc, $rootScope){
        console.log($stateParams);

        var self = this;
        self.gallery = {data: null};
        self.photoGrid = null;
        self.user = null;
        self.showEditGalleryPopup = showEditGalleryPopup;
        self.onBackbtnClicked = onBackbtnClicked;
        self.loginnedUser = sessionManagerSvc.getCurrentLoginUser().data;
        self.isDoingFollow = false;
        self.isMine =  false;
        self.type = 'default';
        self.onFileRemoved = onFileRemoved;
        self.scrollToFixedHeaderSettings = headerSvc.getFixedByHeaderSetting();

        init();

        $rootScope.$on('$translateChangeSuccess', function(event, current) {
          genEmptyText();
        })

        function init(){
          genEmptyText();
        }

        function genEmptyText(){
          self.emptyText={
            default: $translate.instant("start-your-own-catalogue-of-photos"),
            curated: $translate.instant("start-curating-a-gallery-of-your-favourite-photos"),
          };
        }

        $scope.$watch("vm.photoGrid", function(){
            if(!$stateParams.gallery && !$stateParams.id){
                $state.go("404");
                return;
            }
            if(self.photoGrid){
                fetchData().then(function(gallery){
                    if(!gallery){
                        toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('CANNOT_GET_GALLERY_DETAIL', false, true));
                        return;
                    }
                    self.type = gallery.is_curated ? galleryConst.GALLERY_TYPE.CURATED : galleryConst.GALLERY_TYPE.DEFAULT;
                    gallery.isMine = sessionManagerSvc.isMine(gallery.user);
                    self.gallery.data = gallery;
                    self.socialShareContent = buildSocialShareContent(self.gallery.data);
                    self.user = gallery.user;
                    updatePermision();
                    fetchPhotos();
                }, function(){
                    toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('CANNOT_GET_GALLERY_DETAIL', false, true));
                })
            }
        })

        $scope.$watch("vm.galleryGrid", function(){
            if(self.galleryGrid){
                self.galleryGrid.fetchGalleries({
                    type: 'similar',
                    id: $state.params.id,
                    page: $state.params.page ? $state.params.page : 1
                }, true).then(function(){
                }, function(){

                })
            }
        })

        function updatePermision(){
            self.isMine =  (self.loginnedUser && self.loginnedUser.id === self.gallery.data.user.id);
        }

        function fetchPhotos(){
            self.photoGrid.fetchPhotos({
                galleryIds: self.gallery.data.id + ""
            });
        }
        function fetchData(){
            var def = $q.defer();
            if($stateParams.gallery){
                def.resolve($stateParams.gallery);
            } else {
                fetchGallery({
                    id: $stateParams.id
                }).then(function(response){
                    def.resolve(response.data);
                }, function(){
                    def.reject();
                });
            }
            return def.promise;
        }
        function fetchGallery(param){
            return pixerfApiGallerySvc.get(param).$promise;
        }
        function showEditGalleryPopup(){
            var modal = createGallerySvc.showCreateGalleryModal({mode: commonConst.ACTION.EDIT, gallery: self.gallery.data});
            modal.result.then(function(response){
                if(response.mode === commonConst.ACTION.DELETE){
                    onBackbtnClicked();
                }
                self.socialShareContent = buildSocialShareContent(self.gallery.data);
            }, function(){

            })
        }
        function onBackbtnClicked(){
            window.history.back();

        }
        function buildSocialShareContent(gallery){
            return {'url': window.location.href, 'description': gallery.description, 'title': gallery.title, 'media': gallery.coverImagePath};
        }
        function onFileRemoved(file){
            self.gallery.data.media_count -= 1;
            if(file.isMine){
                self.loginnedUser = sessionManagerSvc.getCurrentLoginUser().data;
                self.loginnedUser.stats.media_count --;
                sessionManagerSvc.setCurrentLoginUser(self.loginnedUser);
            }
        }
    }
})();

(function() {
  'use strict';

  angular
    .module('pixerf')
    .config(routerConfig);

  routerConfig.$inject = ['$stateProvider'];

  function routerConfig($stateProvider) {
    'ngInject';
    $stateProvider
      .state('gallery', {
        url: '/gallery/:id',
        templateUrl: 'app/gallery/gallery.html',
        controller: 'galleryCtrl',
        controllerAs: 'vm',
        data: {
          permissions: {
              only: ['EVERY_ONE']
          },
          pageTitle: "PIXERF - Gallery" ,
          hideFooter: true
        },
        params: {
            gallery: null
        }
      })
      
  }

})();

(function () {

	angular
		.module('pixerf')
		.controller('forCreatorPageCtrl', forCreatorPageCtrl);

	forCreatorPageCtrl.$inject = ['$scope', 'systemUtils', '$timeout', 'searchInputSvc', '$state'];

	function forCreatorPageCtrl($scope, systemUtils, $timeout, searchInputSvc, $state) {

		var self = this;
		self.contextPage = "Explore Community";
		self.onSearchTypeChange = onSearchTypeChange;
		self.tagAdded = tagAdded;
		self.tagRemoved = tagRemoved;
		self.selecetedType = 'all';
		var $searchInput;
		self.tags = {
			data: []
		};
		self.searchParams = {
			order: 'mostEngagement',
			page: 1
		};
		self.keywords = [];

		function onSearchTypeChange(type) {
			$timeout(function () {
				$searchInput = $('.for-creator-page__top-navigation__search-bar__input input');
			});
			self.selecetedType = type;
			switch (type) {
				case 'communities':
					if ($searchInput) {
						$searchInput.attr("placeholder", 'Search communities');
					}
					break;
				case 'classes':
					if ($searchInput) {
						$searchInput.attr("placeholder", 'Search classes');
					}
					break;
				case 'events':
					if ($searchInput) {
						$searchInput.attr("placeholder", 'Search events');
					}
					break;
				default:
					if ($searchInput) {
						$searchInput.attr("placeholder", 'Search communities and events');
					}
					self.selecetedType = 'all';
			}
			systemUtils.digest($scope);
		}

		function tagAdded($tag) {
			if (self.searchParams.alphabet) {
				self.arrangeBy = {
					mostEngagement: true
				};
				delete self.searchParams.alphabet;
			}
			self.showContextLabel = false;
			self.searchParams.page = 1;
			self.keywords.push($tag.text);
			self.searchParams.keywords = self.keywords.join();
			self.showKeywords = self.keywords.join(", ");
			self.inSearchContext = true;
			onSearchChanged(self.tags.data);
		}

		function tagRemoved($tag) {
			if (!self.tags.data || !self.tags.data.length) {
				self.inSearchContext = false;
			}
			if ((!self.tags.data || !self.tags.data.length) && (self.selecetedType === 'all' || !self.selecetedType)) {
				self.showContextLabel = true;
				delete self.searchParams.type;
				delete self.searchParams.event_type;
			}
			self.searchParams.page = 1;
			self.keywords = _.reject(self.keywords, function (k) {
				return k === $tag.text;
			})
			if (self.keywords.length) {
				self.searchParams.keywords = self.keywords.join();
			} else {
				delete self.searchParams.keywords;
			}
			self.showKeywords = self.keywords.join(", ");
			onSearchChanged(self.tags.data);
		}

		function onSearchChanged(tagLength) {
			self.isFullSearchBar = !!(tagLength && tagLength.length);

			if (self.isFullSearchBar) {
				var searchParams = {
					keywords: searchInputSvc.buildKeywords(tagLength),
					type: self.selecetedType
				}
				$state.go('for-creator-page.search-result-page', searchParams);
			} else if (!['communities', 'classes', 'events'].includes(self.selecetedType)) {
				$state.go('for-creator-page.about-community');
			} else {
				$state.go('for-creator-page.' + self.selecetedType);
			}
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.config(routerConfig);

	routerConfig.$inject = ['$stateProvider'];

	function routerConfig($stateProvider) {
		'ngInject';
		$stateProvider
			.state('for-creator-page', {
				abstract: true,
				url: '/for-creator-page',
				templateUrl: 'app/for-creator-page/for-creator-page.html',
				controller: 'forCreatorPageCtrl',
				controllerAs: 'vm',
				data: {
					pageTitle: "PIXERF - For Creators",
					permissions: {
						only: ['EVERY_ONE']
					}
				}
			})
			.state('for-creator-page.communities', {
				url: '/explore-communities',
				templateUrl: 'app/for-creator-page/components/explore-communities/explore-communities.html',
				controller: 'exploreCommunitiesCtrl',
				controllerAs: 'vm',
				data: {
					pageTitle: "PIXERF - Explore Communities"
				}
			})
			.state('for-creator-page.events', {
				url: '/explore-events',
				templateUrl: 'app/for-creator-page/components/explore-events/explore-events.html',
				controller: 'exploreEventsCtrl',
				controllerAs: 'vm',
				data: {
					pageTitle: "PIXERF - Explore Events"
				}
			})
            .state('for-creator-page.classes', {
				url: '/explore-classes',
				templateUrl: 'app/for-creator-page/components/explore-classes/explore-classes.html',
				controller: 'exploreClassesCtrl',
				controllerAs: 'vm',
				data: {
					pageTitle: "PIXERF - Explore Classes"
				}
			})
            .state('for-creator-page.search-result-page', {
				url: '/search-result?keywords&page&type',
				templateUrl: 'app/for-creator-page/components/search-communities-events-results/search-communities-events-results.html',
				controller: 'searchCommunitiesEventsResultsCtrl',
				controllerAs: 'vm',
				data: {
					pageTitle: "PIXERF - Search results"
				}
			})
			.state('for-creator-page.about-community', {
				url: '',
				templateUrl: 'app/for-creator-page/components/about-community/about-community.html',
				controller: 'aboutCommunityCtrl',
				controllerAs: 'vm',
				data: {
					pageTitle: "PIXERF - About Community"
				}
			});
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('exploreCreatorsPageCtrl', exploreCreatorsPageCtrl);

	exploreCreatorsPageCtrl.$inject = ['sessionManagerSvc'];

	function exploreCreatorsPageCtrl(sessionManagerSvc) {

		var self = this;
		self.contextPage = "Explore Creators";
		self.loginnedUser = sessionManagerSvc.getCurrentLoginUser().data;
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.config(routerConfig);

	routerConfig.$inject = ['$stateProvider'];

	function routerConfig($stateProvider) {
		'ngInject';
		$stateProvider
			.state('explore-creators-page', {
				abstract: true,
				url: '/explore-creators-page',
				templateUrl: 'app/explore-creators-page/explore-creators-page.html',
				controller: 'exploreCreatorsPageCtrl',
				controllerAs: 'vm',
				data: {
					pageTitle: "PIXERF - Explore Creators",
					permissions: {
						only: ['EVERY_ONE']
					},
					headerClass: 'for-creator-highlight'
				}
			})
			.state('explore-creators-page.creator-agreement', {
				url: '/creator-agreement',
				templateUrl: 'app/explore-creators-page/components/creator-agreement/creator-agreement.html',
				controller: 'creatorAgreementCtrl',
				controllerAs: 'vm',
				data: {
					pageTitle: "PIXERF - Creator Agreement"
				}
			})
			.state('explore-creators-page.payout-and-pricing', {
				url: '/payout-and-pricing',
				templateUrl: 'app/explore-creators-page/components/payout-and-pricing/payout-and-pricing.html',
				controller: 'payoutAndPricingCtrl',
				controllerAs: 'vm',
				data: {
					pageTitle: "PIXERF - Payout & Pricing"
				}
			})
			.state('explore-creators-page.explore-communnity-hub', {
				url: '',
				templateUrl: 'app/explore-creators-page/components/explore-communnity-hub/explore-communnity-hub.html',
				controller: 'exploreCommunnityHubCtrl',
				controllerAs: 'vm',
				data: {
					pageTitle: "PIXERF - Community Hub"
				}
			});
	}
})();

﻿(function () {

	angular
		.module('pixerf')
		.factory('exploreCommunityPageSvc', exploreCommunityPageSvc);

	exploreCommunityPageSvc.$inject = [];

	function exploreCommunityPageSvc() {
		var mTags = {
			data: []
		}

		function getTags() {
			return mTags;
		}

		function setTags(value) {
			mTags.data = value;
		}

		function buildKeywords(tags) {
			var keywords = "";
			for (var i = 0; i < tags.length; i++) {
				keywords += tags[i].text;
				if (i !== tags.length - 1) {
					keywords += ',';
				}
			}
			return keywords;
		}

		return {
			getTags: getTags,
			setTags: setTags,
			buildKeywords: buildKeywords
		};
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('exploreCommunityPageCtrl', exploreCommunityPageCtrl);

	exploreCommunityPageCtrl.$inject = ['$scope', 'exploreCommunityPageSvc', 'pagingUtils', 'pixerfApiCommunitySvc', '$translate', 'toastr', '$timeout'];

	function exploreCommunityPageCtrl($scope, exploreCommunityPageSvc, pagingUtils, pixerfApiCommunitySvc, $translate, toastr, $timeout) {

		var self = this;
		var LIMIT_TILE_LOADED = 3;
		self.contextPage = "Explore All";
		self.tags = angular.isDefined($scope.tags) ? $scope.tags : exploreCommunityPageSvc.getTags();
		self.selectionTypeSearch = selectionTypeSearch;
		self.onArrangeChanged = onArrangeChanged;
		self.onFilteredClicked = onFilteredClicked;
		self.tagAdded = tagAdded;
		self.tagRemoved = tagRemoved;
		self.onSeeMoreCommunities = onSeeMoreCommunities;
		self.onSeeMoreEvents = onSeeMoreEvents;
		self.fetchMoreCommunities = fetchMoreCommunities;
		self.maxCommunitiesLoaded = LIMIT_TILE_LOADED;
		self.maxEventsLoaded = LIMIT_TILE_LOADED;
		self.maxWorkshopsLoaded = LIMIT_TILE_LOADED;
		self.onFilterByLetter = onFilterByLetter;
		self.keywords = [];
		self.communities = [];
		self.events = [];
        self.workshops = [];
		self.noOfCommunities = 0;
		self.noOfEvents = 0;
		self.noOfWorkshops = 0;
		self.typeSearch = '';
		self.showSeeMore = true;
		self.spinner = {
			isVisible: false
		};
		self.arrangeBy = {};
		self.tags = {
			data: []
		}
		self.letters = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
		self.inSearchContext = false;
		self.showContextLabel = true;
		self.searchContext = {
			"items": [{
					"name": "all",
					"value": "all"
				}, {
					"name": "communities",
					"value": "community"
				},
				{
					"name": "events",
					"value": "event"
				},
				{
					"name": "workshops",
					"value": "workshop"
				}
			]
		};
		self.searchParams = {
			order: 'mostEngagement',
			page: 1
		};

		init();

		function init() {
			self.arrangeBy.mostEngagement = true
			getCommunitiesEventsList(self.searchParams, true);
		}

		function selectionTypeSearch(type) {
			self.tags.data = [];
			self.keywords = [];
			self.showKeywords = "";
			self.inSearchContext = false;
			delete self.searchParams.keywords;
			delete self.searchParams.alphabet;
			self.isLettedSelected = null;
			if (['community', 'event', 'workshop'].includes(type)) {
				self.showContextLabel = false;
				self.showSeeMore = false;
				self.maxCommunitiesLoaded = null;
				self.maxEventsLoaded = null;
			} else {
				self.showContextLabel = true;
				self.showSeeMore = true;
				self.maxCommunitiesLoaded = LIMIT_TILE_LOADED;
				self.maxEventsLoaded = LIMIT_TILE_LOADED;
				self.maxWorkshopsLoaded = LIMIT_TILE_LOADED;
			}
			self.typeSearch = type;
			self.searchParams.page = 1;
			if (['event', 'workshop'].includes(type)) {
                self.searchParams.type = 'event';
                self.searchParams.event_type = type === 'event' ? 'standard' : 'class';
			} else {
				self.searchParams.type = type;
			}
			getCommunitiesEventsList(self.searchParams, true);
			$timeout(function () {
				genPlaceholderForSearchInput(type);
			});
			switch (type) {
				case 'community':
					self.selectedFilterItem = {
						"value": type,
						"name": 'Communities'
					};
					self.contextPage = 'Communities';
					break;
				case 'event':
					self.selectedFilterItem = {
						"value": type,
						"name": 'Events'
					};
					self.contextPage = 'Events';
					break;
				case 'workshop':
					self.selectedFilterItem = {
						"value": type,
						"name": 'Workshops'
					};
					self.contextPage = 'Workshops';
					break;
				default:
					self.selectedFilterItem = {
						"value": type,
						"name": 'all'
					};
					self.contextPage = "Explore All";
			}
		}

		function getCommunitiesEventsList(params, isFresh) {
			self.searchParams = params;
			self.spinner.isVisible = true;
			pixerfApiCommunitySvc.explore(self.searchParams).$promise.then(function (response) {
				if (isFresh) {
					self.communities = [];
					self.events = [];
				}
				distributeItem(response.data);
				self.isLastPage = pagingUtils.isNoMorePageToLoad(params.page, response);
				self.totalPage = pagingUtils.getTotalPage(response);
				self.noOfCommunities = getNoOfSearches(response, 'communities');
				self.noOfEvents = getNoOfSearches(response, 'events');
				self.noOfWorkshops = getNoOfSearches(response, 'workshops');
				self.spinner.isVisible = false;
				self.searchParams.page = params.page;
			}, function () {
				toastr.error($translate.instant("failed-to-get-communities-list"));
				self.spinner.isVisible = false;
			});
		}

		function getNoOfSearches(response, type) {
			var noOfSearches = response.headers(type);
			if (!noOfSearches) return 0;
			return parseInt(noOfSearches);
		}

		function fetchMoreCommunities() {
			if (self.maxCommunitiesLoaded && self.maxEventsLoaded) return;
			if (self.isLastPage || self.spinner.isVisible) return;

			var searchParams = $.extend(true, {}, self.searchParams);
			searchParams.page++;
			getCommunitiesEventsList(searchParams);
		}

		function distributeItem(data) {
			var communities = _.filter(data, function (item) {
				return item.type === 'Community';
			});
			var events = _.filter(data, function (item) {
				return item.type === 'CommunityEvent' && item.event_type === 'standard';
			});
			var workshops = _.filter(data, function (item) {
				return item.type === 'CommunityEvent' && item.event_type === 'class';
			});
			self.communities = self.communities.concat(communities);
			self.events = self.events.concat(events);
			self.workshops = self.workshops.concat(workshops);
		}

		function onArrangeChanged(data) {
			self.searchParams.page = 1;
			if (!data.name) {
				delete self.searchParams.alphabet;
			}
			for (key in data) {
				if (data[key]) {
					self.searchParams.order = key;
				}
			}
			getCommunitiesEventsList(self.searchParams, true);
		}

		function tagAdded($tag) {
			if (self.searchParams.alphabet) {
				self.arrangeBy = {
					mostEngagement: true
				};
				delete self.searchParams.alphabet;
			}
			self.showSeeMore = false;
			self.maxEventsLoaded = null;
			self.maxCommunitiesLoaded = null;
            self.maxWorkshopsLoaded = null;
			self.showContextLabel = false;
			self.searchParams.page = 1;
			self.keywords.push($tag.text);
			self.searchParams.keywords = self.keywords.join();
			self.showKeywords = self.keywords.join(", ");
			self.inSearchContext = true;
			getCommunitiesEventsList(self.searchParams, true);
		}

		function tagRemoved($tag) {
			if (!self.tags.data || !self.tags.data.length) {
				self.inSearchContext = false;
			}
			if ((!self.tags.data || !self.tags.data.length) && (self.typeSearch === 'all' || !self.typeSearch)) {
				self.showContextLabel = true;
				self.showSeeMore = true;
				self.maxEventsLoaded = LIMIT_TILE_LOADED;
				self.maxCommunitiesLoaded = LIMIT_TILE_LOADED;
                self.maxWorkshopsLoaded = LIMIT_TILE_LOADED;
				delete self.searchParams.type;
                delete self.searchParams.event_type;
			}
			self.searchParams.page = 1;
			self.keywords = _.reject(self.keywords, function (k) {
				return k === $tag.text;
			})
			if (self.keywords.length) {
				self.searchParams.keywords = self.keywords.join();
			} else {
				delete self.searchParams.keywords;
			}
			self.showKeywords = self.keywords.join(", ");
			getCommunitiesEventsList(self.searchParams, true);
		}

		function onFilteredClicked(item) {
			genPlaceholderForSearchInput(item.value);
			if (item.value && item.value === 'all') {
				delete self.searchParams.type;
			} else {
				self.searchParams.type = item.value;
			}
			if (self.keywords.length) {
				getCommunitiesEventsList(self.searchParams, true);
			}
		}

		function genPlaceholderForSearchInput(type) {
			var $searchInput = $('.explore-community-page__search-input input');
			switch (type) {
				case 'community':
					$searchInput.attr("placeholder", 'Search communities');
					break;
				case 'event':
					$searchInput.attr("placeholder", 'Search events');
					break;
				case 'workshop':
					$searchInput.attr("placeholder", 'Search workshops');
					break;
				default:
					$searchInput.attr("placeholder", 'Search communities and events');
			}
		}

		function onSeeMoreEvents() {
			self.maxEventsLoaded = null;
		}

		function onSeeMoreCommunities() {
			self.maxCommunitiesLoaded = null;
		}

		function onFilterByLetter(letter) {
			self.isLettedSelected = letter;
			delete self.searchParams.keywords;
			self.searchParams.page = 1;
			self.searchParams.alphabet = letter;
			getCommunitiesEventsList(self.searchParams, true);
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.config(routerConfig);

	routerConfig.$inject = ['$stateProvider'];

	function routerConfig($stateProvider) {
		'ngInject';
		$stateProvider
			.state('community-guidelines', {
				url: '/community/guidelines',
				templateUrl: 'app/introduction/company/community-guidelines/community-guidelines.html',
				controller: 'communityGuidelinesCtrl',
				controllerAs: 'vm',
				data: {
					pageTitle: "PIXERF - Community Guidelines",
					permissions: {
						only: ['EVERY_ONE']
					}
				}
			})
			;
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('eventDetailPageCtrl', eventDetailPageCtrl);

	eventDetailPageCtrl.$inject = ['$scope', 'eventData', '$timeout', 'pixerfApiEventSvc', 'sessionManagerSvc', 'commonConst', 'inviteUserPopupSvc', 'toastr', 'signUpPersonalPopupSvc', 'store',
		'sucessfullyActionPopupSvc', '$state', 'createEventPopupSvc', '$q', 'ISO3166', 'confirmPopupSvc', 'peopleListPopupSvc', 'accountConst', 'pixerfDiscussionReportPopupSvc', 'pixerfApiCommunitySvc', 'translationSvc', '$translate', 'systemUtils'
	];

	function eventDetailPageCtrl($scope, eventData, $timeout, pixerfApiEventSvc, sessionManagerSvc, commonConst, inviteUserPopupSvc, toastr, signUpPersonalPopupSvc, store,
		sucessfullyActionPopupSvc, $state, createEventPopupSvc, $q, ISO3166, confirmPopupSvc, peopleListPopupSvc, accountConst, pixerfDiscussionReportPopupSvc, pixerfApiCommunitySvc, translationSvc, $translate, systemUtils) {

		var self = this;
		self.commonConst = commonConst;
		self.loginedUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.event = eventData;
		self.isTypeClass = eventData && eventData.event_type == 'class';
		self.itemType = self.isTypeClass ? 'Class' : 'Event';
		self.itemTypeLowercase = self.isTypeClass ? 'class' : 'event';
		self.onToggleFullDescription = onToggleFullDescription;
		self.coverImage = self.event.cover.original;
		self.onInterested = onInterested;
		self.onGoing = onGoing;
		self.onInviteMembers = onInviteMembers;
		self.ticketAvailabeLable = self.event.stats.available;
		self.isFewSpotsLeft = (self.event && self.event.stats && self.event.stats.available && self.event.max_attendees && (self.event.stats.available > 0)) ? (10 * (self.event.stats.available / self.event.max_attendees) < 2) : false;
		self.isLimitedCapacity = self.event.capacity_type === 'limited';
		self.isMine = self.loginedUser && self.event.owner.id === self.loginedUser.id;
		self.canInviteFriends = (self.loginedUser && self.event.has_joined) || self.isMine;
		self.seeMore = seeMore;
		self.introInvitedText = "";
		self.onSendInviteEmail = onSendInviteEmail;
		self.onSendInviteLink = onSendInviteLink;
		self.onReportEvent = onReportEvent;
		self.onCancelEventClicked = onCancelEventClicked;
		self.onDeleteEventClicked = onDeleteEventClicked;
		self.onCreateEvent = onCreateEvent;
		self.onGoingEvent = onGoingEvent;
		self.membershipEvent = {
			isGoing: self.event.has_joined,
			isInterested: self.event.has_interest
		}
		self.date = {
			day: null,
			month: null
		};
		self.yourEvents = [];
		self.joinedEvents = [];
		self.interactUsers = [];
		self.searchParamsEvents = {};
		self.searchParamsJoinedEvents = {};
		self.description = [];
		self.onManageEventClicked = onManageEventClicked;
		self.link = window.location.origin + (window.location.pathname || '') + '#/ce/' + self.event.short_code;
		self.defaultShareText = "Hi there! I would like to invite you to join the " + (self.isTypeClass ? "class \"" : "event \"") + self.event.name + "\" on PIXERF. " + self.link;
		self.badgeEvent = "icon-community_2";
		self.SocialShareContent = buildSocialShareContent();
		self.onInterestedList = onInterestedList;
		self.onGoingList = onGoingList;
		self.onInvitedList = onInvitedList;
		self.onManageAttendeesClicked = onManageAttendeesClicked;
		self.shareSettings = {
			circle: true
		};
		self.onMembershipEventChanged = onMembershipEventChanged;
		self.onUnloginClicked = onUnloginClicked;
		var isTruncatedEventDesc = null;

		init();

		function init() {
			$timeout(function () {
				var session = $(".about-section__description");
				session.dotdotdot({
					keep: ".about-section__toggle-more",
					height: 100,
					callback: function (isTruncated) {
						isTruncatedEventDesc = isTruncated;
						if (isTruncated) {
							$('.about-section__toggle-more').show();
						} else {
							$('.about-section__toggle-more').hide();
						}
					}
				});
				// if (self.isMine) {
				// 	bindShareText();
				// 	self.SocialShareContent = buildSocialShareContent();
				// }
			})

			if (self.event.booking_date) {
				var today = moment();
				today.diff(self.event.booking_date, "days")
				self.noBookingYet = today.diff(self.event.booking_date, "days") < 0;
			}

			if (self.event.event_datetimes.length) {
				self.headerSchedules = transformDateTime(self.event.event_datetimes);
				self.schedules = transformDateTime(self.event.event_datetimes);
			}
			if (self.loginedUser) {
				self.searchParamsEvents = {
					event_statuses: 'active,reported',
					id: self.loginedUser.id,
					user_id: self.loginedUser.id,
					page: 1,
					page_size: 3,
					event_type: self.isTypeClass ? 'class' : 'standard',
				};
				var member = _.find(self.event.joined_users, function (user) {
					return user.id === self.loginedUser.id;
				});
				self.isMember = (member && member.id);

				getYourEvents();
			}

			if (self.loginedUser && !self.loginedUser.isBiz) {
				self.searchParamsJoinedEvents = {
					event_statuses: 'active,reported',
					id: self.loginedUser.id,
					user_id: self.loginedUser.id,
					page: 1,
					page_size: 3,
					event_type: self.isTypeClass ? 'class' : 'standard',
				};

				getJoinedEvents();
			}

			getCountriesEvent();
			updateSlotAvailable(self.event);
			getInteracUsers(self.event);
			genIntroInviteText(self.event);
			generateBadge();
			processDescription();
			self.admissionType = transformAdmission(self.event);
			manuallyTriggerEventClosed();
		}

		function manuallyTriggerEventClosed(){
			if (self.event && self.event.id === 3){
				self.isEventClosed = true;
				systemUtils.digest($scope);
			}
		}

		function generateBadge() {
			if (self.event.is_unlisted) {
				self.badgeEvent = "icon-icons_hide-password";
			} else if (self.event.is_private) {
				self.badgeEvent = "icon-lock";
			} else {
				self.badgeEvent = "icon-community_2";
			}
		}

		function bindShareText() {
			var whatsappLink = "whatsapp://send?text=" + encodeURIComponent(self.defaultShareText);
			appendShareLink("whatsappComShare", whatsappLink);
		}

		function appendShareLink(elementIdSelector, shareLink) {
			// var h = document.getElementById(elementIdSelector);
			// var s = document.createElement("a");
			// var link = shareLink;
			// s.setAttribute('href', link);
			// h.appendChild(s);
		}

		function onMembershipEventChanged(data) {
			if (data.isGoing != self.event.has_joined) {
				onGoing();
			}
			if (data.isInterested != self.event.has_interest) {
				onInterested();
			}
		}

		function buildSocialShareContent() {
			return {
				'url': self.link,
				'description': self.defaultShareText,
				'title': self.event.name,
				'media': self.coverImage
			};
		}

		function onToggleFullDescription(isFull) {
			if (!isTruncatedEventDesc) {
				return;
			}
			self.isProcessinDescription = true;
			self.isFullDescription = !isFull;
			$timeout(function () {
				self.isProcessinDescription = false;
			}, 200)
			$timeout(function () {
				var $aboutElement = $(".about-section__description");
				if (isFull) {
					$aboutElement[0].style.maxHeight = "100px";
					$aboutElement.dotdotdot({
						keep: ".about-section__toggle-more",
						callback: function (isTruncated) {
							if (isTruncated) {
								$('.about-section__toggle-more').show();
							} else {
								$('.about-section__toggle-more').hide();
							}
						}
					});
				} else {
					$aboutElement[0].style.maxHeight = "none";
				}
			}, 300)
		}

		function transformSchedules(schedules) {
			var schedulesArr = [];

			for (var i = 0; i < schedules.length; i++) {
				schedulesArr.push({
					date: moment(schedules[i].start_datetime).format('dddd, MMMM DD, YYYY'),
					time: moment(schedules[i].start_datetime).format('h:mmA') + ' to ' + moment(schedules[i].end_datetime).format('h:mmA')
				});
			}

			return schedulesArr;
		}

		function onInterested() {
			pixerfApiEventSvc.toggleInterest({
				id: self.event.id
			}, {}).$promise.then(function (res) {
				self.event = res.data;
				getInteracUsers(self.event);
				genIntroInviteText(self.event);
			}).catch(function (err) {
				console.log(err);
			})
		}

		function onGoing() {
			if (self.event.capacity_type === 'limited' && !self.event.stats.available) return;
			else if (!self.event.has_joined && self.event.admission_type == 'ticketed_pixerf') {
				return processPaymentEvent();
			}else if (self.event.has_joined && self.event.admission_type == 'ticketed_pixerf') {
				return ;
			}
			pixerfApiEventSvc.toggleJoin({
				id: self.event.id
			}, null).$promise.then(function (res) {
				self.event = res.data;
				updateSlotAvailable(self.event);
				getInteracUsers(self.event);
				genIntroInviteText(self.event);
			}).catch(function (err) {
				console.log(err);
			})
		}

		function onManageAttendeesClicked(){
			$state.go("manage-event.members", {
				id: self.event.id,
				name: self.event.name,
				status: 'attendees'
			});
		}

		function genIntroInviteText(users) {
			var joinedUserIds = _.pluck(users.joined_users, 'id');
			var interestedUserIds = _.pluck(users.interested_users, 'id');
			var totalAttendees = _.union(joinedUserIds, interestedUserIds).length;
			if (users.joined_users.length && users.interested_users.length && totalAttendees > 3) {
				self.introInvitedText = "<span class='highlight-name'>" + users.joined_users[0].displayName + "</span> and " + (totalAttendees - 1) + " others are interested or will be going.";
			} else if (users.joined_users.length && users.interested_users.length && totalAttendees > 2) {
				self.introInvitedText = "<span class='highlight-name'>" + users.joined_users[0].displayName + "</span>, <span class='highlight-name'>" + (users.joined_users[1] ? users.joined_users[1].displayName : users.interested_users[1].displayName) + "</span> and <span class='highlight-name'>" + users.interested_users[0].displayName + "</span> are interested or will be going.";
			} else if (users.joined_users.length && users.interested_users.length && totalAttendees > 1) {
				self.introInvitedText = "<span class='highlight-name'>" + users.joined_users[0].displayName + "</span> and <span class='highlight-name'>" + users.interested_users[0].displayName + "</span> are interested or will be going.";
			} else if (users.joined_users.length === 1) {
				self.introInvitedText = "<span class='highlight-name'>" + users.joined_users[0].displayName + "</span> will be going.";
			} else if (users.joined_users.length === 2) {
				self.introInvitedText = "<span class='highlight-name'>" + users.joined_users[0].displayName + "</span> and <span class='highlight-name'>" + users.joined_users[1].displayName + "</span> will be going.";
			} else if (users.joined_users.length) {
				self.introInvitedText = "<span class='highlight-name'>" + users.joined_users[0].displayName + "</span>, <span class='highlight-name'>" + users.joined_users[1].displayName + "</span> and <span class='highlight-name'>" + users.joined_users[2].displayName + "</span> will be going.";
			} else if (users.interested_users.length === 1) {
				self.introInvitedText = "<span class='highlight-name'>" + users.interested_users[0].displayName + "</span> is interested.";
			} else if (users.interested_users.length === 2) {
				self.introInvitedText = "<span class='highlight-name'>" + users.interested_users[0].displayName + "</span> and <span class='highlight-name'>" + users.interested_users[1].displayName + "</span> are interested.";
			} else if (users.interested_users.length) {
				self.introInvitedText = "<span class='highlight-name'>" + users.interested_users[0].displayName + "</span>, <span class='highlight-name'>" + users.interested_users[1].displayName + "</span> and <span class='highlight-name'>" + users.interested_users[2].displayName + "</span> are interested.";
			} else {
				self.introInvitedText = "";
			}
		}

		function getItemType(type) {
			if (!type) {
				return 'Event/Class';
			} else if (type == 'class') {
				return 'Class';
			} else {
				return 'Event';
			}
		}

		function onInviteMembers(event) {
			var inviteEvent = event || self.event;
			var inviteText = "Invite members to " + getItemType(inviteEvent.event_type);
			inviteUserPopupSvc.showPopup({
				options: {
					title: inviteText
				},
				community: {
					id: inviteEvent ? inviteEvent.community_id : self.event.community_id,
				},
				event: {
					id: inviteEvent ? inviteEvent.id : self.event.id,
					short_code: inviteEvent ? inviteEvent.short_code : self.event.short_code
				},
				defaultSearchCondition: {
					isDirectoryChecked: true,
					isEmailChecked: false,
					speciality: "",
				},
				shareText: self.defaultShareText
			});
		}

		function getYourEvents() {
			pixerfApiEventSvc.get_hosting_events(self.searchParamsEvents).$promise.then(function (response) {
				self.yourEvents = response.data;
			}).catch(function (error) {
				console.log(error);
			})
		}

		function getJoinedEvents(params, isFresh) {
			pixerfApiEventSvc.get_joined_events(self.searchParamsJoinedEvents).$promise.then(function (response) {
				self.joinedEvents = response.data;
			}).catch(function (error) {
				console.log(error);
			})
		}

		function seeMore(page) {
			switch (page) {
				case 'events':
					$state.go(self.commonConst.STATE.COMMUNITIES_DETAILS_EVENTS, {
						id: self.event.community_id
					});
			}
		}

		function getInteracUsers(event) {
			self.interactUsers = [];

			var interestedUserIds = _.pluck(event.interested_users, "id");
			self.interactUsers = _.reject(event.joined_users, function (user) {
				return interestedUserIds.includes(user.id);
			});

			self.interactUsers = self.interactUsers.concat(event.interested_users);
		}

		function updateSlotAvailable(event) {
			if (event.stats && event.stats.available) {
				self.ticketAvailabeLable = event.stats.available + ' spots left';
				self.isFewSpotsLeft = (event.stats && event.stats.available && event.max_attendees && (event.stats.available > 0)) ? (10 * (event.stats.available / event.max_attendees) < 2) : false;
			} else {
				self.ticketAvailabeLable = 'Full';
			}
		}

		function updateMembershipStatus() {
			self.membershipEvent = {
				isGoing: self.event.has_joined,
				isInterested: self.event.has_interest
			}
		}

		function onManageEventClicked() {
			$state.go(self.commonConst.STATE.MANAGE_EVENT, {
				id: self.event.id,
				name: self.event.name,
				status: 'attendees'
			});
		}

		function onSendInviteEmail() {
			var email = '?body=' + self.defaultShareText;
			window.open('mailto:' + email);
		}

		function onSendInviteLink() {
			var popup = inviteUserPopupSvc.showPopup({
				options: {
					title: "Invite members to " + self.itemType
				},
				community: {
					id: self.event.community_id,
				},
				event: {
					id: self.event.id,
					short_code: self.event.short_code
				},
				defaultSearchCondition: {
					isDirectoryChecked: false,
					isEmailChecked: false,
					isLinkChecked: true,
					speciality: "",
				},
				shareText: self.defaultShareText
			});
		}

		function onInterestedList() {
			if(!self.loginedUser) return;
			peopleListPopupSvc.showPopup({
				type: accountConst.INTERACT_TYPE.LIST_INTERESTED_EVENT.toLowerCase(),
				eventId: self.event.id,
				user: self.loginedUser,
				options: {
					hideSeeAll: true
				}
			});
		}

		function onGoingList() {
			if(!self.loginedUser) return;
			peopleListPopupSvc.showPopup({
				type: accountConst.INTERACT_TYPE.LIST_JOINED_EVENT.toLowerCase(),
				eventId: self.event.id,
				user: self.loginedUser,
				options: {
					hideSeeAll: true
				}
			});
		}

		function onInvitedList() {
			if(!self.loginedUser) return;
			if (!self.isMine) return;
			peopleListPopupSvc.showPopup({
				type: accountConst.INTERACT_TYPE.LIST_INVITED_EVENT.toLowerCase(),
				eventId: self.event.id,
				user: self.loginedUser,
				options: {
					hideSeeAll: true
				}
			});
		}

		function getCountriesEvent() {
			self.eventCountries = [];
			var countries = ISO3166.getCountryNames(self.event.countries)
			for (country in countries) {
				self.eventCountries.push(countries[country]);
			}
			self.eventCountries = self.eventCountries.join(", ");
			if (!self.eventCountries.length) {
				self.eventCountries = ["All"].join(", ");
			}
		}

		function transformDateTime(arrTime) {
			var arrFormatedTime = [];
			var tmp;

			self.eventDate = {
				day: moment(arrTime[0].start_datetime).format('DD'),
				month: moment(arrTime[0].start_datetime).format('MMM')
			};

			for (var i = 0; i < arrTime.length; i++) {
				tmp = {
					date: moment(arrTime[i].start_datetime).format('dddd, MMM DD YYYY'),
					start: moment(arrTime[i].start_datetime).format('h:mm A'),
					end: moment(arrTime[i].end_datetime).format('h:mm A')
				}
				arrFormatedTime.push(tmp);
			}

			return arrFormatedTime;
		}

		function transformAdmission(eventInfo) {
			switch (eventInfo.admission_type) {
				case 'ticketed_external':
				case 'ticketed_pixerf':
					return eventInfo.event_type == 'class' ? 'Ticketed class' : 'Ticketed event';
					break;
				default:
					return eventInfo.event_type == 'class' ? 'Free class' : 'Free event';
			}
		}

		function onInterested() {
			if (self.event.has_joined) {
				if (self.event.admission_type == 'ticketed_pixerf') return;
				confirmPopupSvc.showPopup({
					windowClass: 'change-status-event-popup',
					title: 'Changing your ' + self.itemTypeLowercase + ' status?',
					message: 'The ' + self.itemTypeLowercase + ' has limited capacity. You will not be able to attend the ' + self.itemTypeLowercase + ' once it’s fully booked.',
					submitBtnText: 'continue',
					cancelBtnText: 'cancel',
					submit: function () {
						var def = $q.defer();
						pixerfApiEventSvc.toggleInterest({
							id: self.event.id
						}, {}).$promise.then(function (res) {
							self.event = res.data;
							toastr.success('This ' + self.itemTypeLowercase + ' has been successfully interested!');
							getInteracUsers(self.event);
							genIntroInviteText(self.event);
							updateSlotAvailable(self.event);
							updateMembershipStatus();
							def.resolve(res);
						}).catch(function (err) {
							if (self.event.countries && err && err.data && err.data.data && err.data.data.key && (err.data.data.key == 'cannot_join_event')) {
								showRestrictedCountry(self.event.countries);
							}
							console.log(err);
							def.reject(err);
						})
						return def.promise;
					}
				});
			} else {
				pixerfApiEventSvc.toggleInterest({
					id: self.event.id
				}, {}).$promise.then(function (res) {
					self.event = res.data;
					toastr.success('This ' + self.itemTypeLowercase + ' has been successfully interested!');
					getInteracUsers(self.event);
					genIntroInviteText(self.event);
					updateSlotAvailable(self.event);
					updateMembershipStatus();
				}).catch(function (err) {
					if (self.event.countries && err && err.data && err.data.data && err.data.data.key && (err.data.data.key == 'cannot_join_event')) {
						showRestrictedCountry(self.event.countries);
					}
					console.log(err);
				})
			}
		}

		function onGoing() {
			if (self.event.has_joined) {
				if (self.event.admission_type == 'ticketed_pixerf') return;
				confirmPopupSvc.showPopup({
					windowClass: 'change-status-event-popup',
					title: 'Changing your ' + self.itemTypeLowercase + ' status?',
					message: 'The ' + self.itemTypeLowercase + ' has limited capacity. You will not be able to attend the ' + self.itemTypeLowercase + ' once it’s fully booked.',
					submitBtnText: 'continue',
					cancelBtnText: 'cancel',
					submit: function () {
						var def = $q.defer();
						pixerfApiEventSvc.toggleJoin({
							id: self.event.id
						}, {}).$promise.then(function (res) {
							self.event = res.data;
							getInteracUsers(self.event);
							genIntroInviteText(self.event);
							updateSlotAvailable(self.event);
							updateMembershipStatus();
							def.resolve(res);
						}).catch(function (err) {
							console.log(err);
							if (self.event.countries && err && err.data && err.data.data && err.data.data.key && (err.data.data.key == 'cannot_join_event')) {
								showRestrictedCountry(self.event.countries);
							}
							def.reject(err);
						})
						return def.promise;
					}
				});
			} else {
				if (self.event.capacity_type === 'limited' && !self.event.stats.available) return;

				if (!self.event.has_joined && self.event.admission_type == 'ticketed_pixerf') {
					return processPaymentEvent();
				}
				pixerfApiEventSvc.toggleJoin({
					id: self.event.id
				}, {}).$promise.then(function (res) {
					self.event = res.data;
					getInteracUsers(self.event);
					genIntroInviteText(self.event);
					updateSlotAvailable(self.event);
					updateMembershipStatus();
				}).catch(function (err) {
					if (self.event.countries && err && err.data && err.data.data && err.data.data.key && (err.data.data.key == 'cannot_join_event')) {
						showRestrictedCountry(self.event.countries);
					}
					console.log(err);
				})
			}
		}

		function onUnloginClicked(){
			store.set(accountConst.TOKEN.PAYMENT_EVENT_AFTER_SIGNED, self.event.id);
			signUpPersonalPopupSvc.showPopup();
		}

		function processPaymentEvent() {
			setInterestedEvent();
			$state.go('checkout.event-payment', {
				id: self.event.id
			});
		}

		function setInterestedEvent() {
			if (!self.membershipEvent.isInterested) {
				onInterested();
			}
		}

		function onReportEvent() {
			pixerfDiscussionReportPopupSvc.showPopup({
				id: self.event.id,
				target: 'report_community_event'
			});
		}

		function onCancelEventClicked() {
			confirmPopupSvc.showPopup({
				windowClass: 'cancel-event-confirm-popup',
				title: $translate.instant("you-are-about-to-cancel-this-event"),
				message: $translate.instant("if-you-cancel-this-event"),
				submitBtnText: 'Yes',
				cancelBtnText: 'Cancel',
				submit: function () {
					var def = $q.defer();
					pixerfApiCommunitySvc.cancel_community_event({
						id: self.event.id
					}, null).$promise.then(
						function success(res) {
							self.event.status = res.data.status;
							toastr.success('this ' + self.itemTypeLowercase + ' has been successfully canceled');
							def.resolve(res);
						},
						function error(err) {
							if (err && err.data && err.data.data && err.data.data.message) {
								toastr.error(err.data.data.message);
							} else {
								toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
							}
							def.reject(err);
						}
					);
					return def.promise;
				}
			});
		}

		function onDeleteEventClicked() {
			confirmPopupSvc.showPopup({
				windowClass: 'delete-event-confirm-popup',
				title: $translate.instant("you-are-about-to-delete-this-event"),
				message: $translate.instant("deleting-your-Event-will-remove-it"),
				submitBtnText: 'Yes',
				cancelBtnText: 'Cancel',
				submit: function () {
					var def = $q.defer();
					pixerfApiEventSvc.update({
						id: self.event.id
					}, {
						status: 'deleted'
					}).$promise.then(function (res) {
							self.event.status = res.data.status;
							toastr.success('Your ' + self.itemTypeLowercase + ' deleted successfully');
							def.resolve(res);
						},
						function (err) {
							if (err && err.data && err.data.data && err.data.data.message) {
								toastr.error(err.data.data.message);
							} else {
								toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
							}
							def.reject(err);
						}
					);
					return def.promise;
				}
			});
		}

		function onCreateEvent() {
			var popupData = {
				community: {
					id: self.event.community_id
				},
				type: self.isTypeClass ? 'class' : 'event'
			}
			var eventPopup = createEventPopupSvc.showPopup(popupData);

			eventPopup.result.then(function (event) {
				if (event.status === 'active') {
					self.yourEvents.unshift(event);
					onInviteMembers(event);
				}
			})
		}

		function processDescription() {
			var regex = /\d{1,2}[\,\.]/g;
			var description = [];
			if (self.event && self.event.description) {
				description = self.event.description.split("\n");
			}
			for (var i = 0; i < description.length; i++) {
				self.description = self.description.concat({
					text: description[i],
					isLineItem: !!(description[i].match(regex) && description[i].match(regex).length)
				});
			}
		}

		function showRestrictedCountry(countries) {
			var countryMsg = '';
			if (!countries || countries.length == 0) {
				return;
			} else if (countries.length == 1) {
				countryMsg = Object.values(ISO3166.getCountryNames(countries));
			} else if (countries.length == 2) {
				countryMsg = Object.values(ISO3166.getCountryNames(countries)).join(" and ");
			} else {
				var countryNames = Object.values(ISO3166.getCountryNames(countries));
				countryMsg = (countryNames.splice(0, countryNames.length - 2)).join(', ') + ' and ' + countryNames[countryNames.length - 1];
			}
			confirmPopupSvc.showPopup({
				windowClass: 'restriction-country-popup',
				message: 'This event is restricted to users from ' + countryMsg + ' only.',
				hideSubmitBtn: true,
				cancelBtnText: 'Close'
			});
		}

		function onGoingEvent() {
			if (self.event.capacity_type === 'limited' && !self.event.stats.available) return;
			if (!self.event.has_joined && self.event.admission_type == 'ticketed_pixerf') {
				return processPaymentEvent();
			}
			if (self.event.has_joined && self.event.admission_type == 'ticketed_pixerf') {
				return ;
			}
			pixerfApiEventSvc.toggleJoin({
				id: self.event.id
			}, null).$promise.then(function (res) {
				self.event = res.data;
				self.membershipEvent.isGoing = true;
				self.membershipEvent.isInterested = false;
				updateSlotAvailable(self.event);
				getInteracUsers(self.event);
				genIntroInviteText(self.event);
				sucessfullyActionPopupSvc.showPopup({
					title: "Sign Up Successful!",
					message: "We have signed you up for a free class. Please check your email to retrieve your ticket confirmation.",
					leftBtnSubmit: function () {
						return;
					},
					rightBtnSubmit: function () {
						$state.go("community-detail-page.community-detail-events", ({
							id: self.event.community_id,
							name: self.event.community_name
						}));
					}
				});
			}).catch(function (err) {
				console.log(err);
			})
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.config(routerConfig);

	routerConfig.$inject = ['$stateProvider'];

	function routerConfig($stateProvider) {
		'ngInject';
		$stateProvider
			.state('event-detail-page', {
				abstract: true,
				url: '/community-event/:id/:name',
				templateUrl: 'app/event-detail-page/event-detail-page.html',
				controller: 'eventDetailPageCtrl',
				controllerAs: 'vm',
				data: {
					permissions: {
						only: ['EVERY_ONE']
					},
					pageTitle: "PIXERF - Event",
					hideFooter: true
				},
				params: {
					"id": {
						squash: true,
						value: null
					},
					"name": {
						squash: true,
						value: null
					},
					"shortCode":{
						squash: true,
						value: null
					}
				},
				resolve: {
					eventData: function ($stateParams, pixerfApiEventSvc, $q, $state, toastr) {
						var defer = $q.defer();
						var self = this;
						var eventId = parseInt($stateParams.id);
						if (!$stateParams.id || ($stateParams.id && isNaN(eventId))) {
							$state.go('404');
							defer.reject();
						} else {
							var params = {
								id: eventId
							};
							if($stateParams.shortCode){
								params.id = $stateParams.shortCode;
								params.type = 'short_code';
							}
							pixerfApiEventSvc.get(params).$promise.then(function (response) {
								var event = response.data;
								self.data.pageTitle = "PIXERF - Event: " + event.name;
								defer.resolve(event);
							}, function (err) {
                                if(err.data && err.data.data && err.data.data.key){
                                    toastr.error(err.data.data.message);
                                }
								defer.reject(err);
							})
						}

						return defer.promise;
					}
				}
			})
			.state('event-detail-page.event-schedule', {
				url: '/schedule',
				templateUrl: 'app/event-detail-page/components/event-schedule/event-schedule.html',
				controller: 'eventScheduleCtrl',
				controllerAs: 'vm'
			})
			.state('event-detail-page.event-photos', {
				url: '/photos',
				templateUrl: 'app/event-detail-page/components/event-photos/event-photos.html',
				controller: 'eventPhotosCtrl',
				controllerAs: 'vm'
			})
			.state('event-detail-page.event-feed', {
				url: '',
				templateUrl: 'app/event-detail-page/components/event-feed/event-feed.html',
				controller: 'eventFeedCtrl',
				controllerAs: 'vm'
			});
	}
})();

(function(){
    'use strict';
    angular
      .module('pixerf')
      .factory('emailUsSvc', emailUsSvc);
      emailUsSvc.$inject = ['$translate'];
  
      function emailUsSvc($translate){
  
          function validateForm(data, form){
              form.$setDirty();
              var errMsg = '';
              if(form.name.$error.required){
                  errMsg = $translate.instant('please-input-first-name');
              } else if(form.email.$error.required){
                  errMsg = "Please input your email!";
              } else if(form.email.$error.email ){
                  errMsg = "Invalid email address";
              } else if(!data.topic){
                  errMsg = "Please input your topic!";
              } else if(form.name.$error.validationNoNumber || form.name.$error.validationNoHyperlink){
                  errMsg = "Sorry, your first name cannot contain a link or number.";
              } else if(form.description.$error.required){
                  errMsg = "Please input your description!";
              } else if(form.description.$error.minlength){
                  errMsg = "Description must be at least 50 characters long.";
              }
              return errMsg;
          }
          return {
              validateForm: validateForm
          };
      }
  })();
  
(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('emailUsPageCtrl', emailUsPageCtrl);

	emailUsPageCtrl.$inject = ['$scope', 'pixerfApiMailSvc', 'emailUsSvc', 'toastr', 'translationSvc', 'sessionManagerSvc'];

	function emailUsPageCtrl($scope, pixerfApiMailSvc, emailUsSvc, toastr, translationSvc, sessionManagerSvc) {

		var self = this;
		self.inquiry = {};
		var mLoginUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.sendEnquire = sendEnquire;
		self.onTopicChanged = onTopicChanged;
		self.isWorking = false;
		$scope.$parent.vm.contextPage = "Support";
		self.topicOptions = {
			"dropupAuto": false,
			"noneSelectedText": "Select a topic",
			"maxOptions": 1
		};
		self.topicTypes = [
			{
				id: 11,
				name: 'Apply as Community Leader'
			},
			{
				id: 6,
				name: 'Billings and getting paid'
			},
			{
				id: 1,
				name: 'Booking a shoot'
			},
			{
				id: 5,
				name: 'Collaborating or partnering with PIXERF'
			},
			{
				id: 12,
				name: 'Credit Plan Purchase (Assignments)'
			},
			{
				id: 13,
				name: 'Credit Plan Purchase (Stock Images)'
			},
			{
				id: 9,
				name: 'Feedback'
			},
			{
				id: 7,
				name: 'My account'
			},
			{
				id: 2,
				name: 'Running a Community Challenge'
			},
			{
				id: 4,
				name: 'Sales enquiries'
			},
			{
				id: 3,
				name: 'Sourcing images'
			},
			{
				id: 8,
				name: 'Technical support'
			},
			{
				id: 10,
				name: 'Others'
			},
		];

		function sendEnquire(data, form) {
			if (self.isWorking) return;
			var errMsg = emailUsSvc.validateForm(data, form);
			if (errMsg) {
				toastr.error(errMsg);
				return false;
			}
			self.isWorking = true;
			pixerfApiMailSvc.enquire(data).$promise.then(function (respone) {
				self.inquiry = {};
				self.isWorking = false;
				toastr.success("Thanks for your submission, we'll get back to you soon!");
			}, function () {
				self.isWorking = false;
				toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
			});
		}

		function onTopicChanged(selectedTopic) {
			if (!selectedTopic || !selectedTopic.length) return;
			self.inquiry.topic = selectedTopic[0].name;
		}

		function updateUserInfo(){
			if(!mLoginUser){
				return;
			}

			self.inquiry.name = mLoginUser.displayName;
			self.inquiry.email = mLoginUser.email;
		}

		function init(){
			updateUserInfo();
		}

		init();
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.config(routerConfig);

	routerConfig.$inject = ['$stateProvider'];

	function routerConfig($stateProvider) {
		'ngInject';
		$stateProvider
			.state('email-us-page', {
				url: '/email-us',
				templateUrl: 'app/email-us-page/email-us-page.html',
				controller: 'emailUsPageCtrl',
				controllerAs: 'vm',
				data: {
					pageTitle: "PIXERF - Email Us",
					permissions: {
						only: ['EVERY_ONE']
					}
				}
			});
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('discussionDetailPageCtrl', discussionDetailPageCtrl);

	discussionDetailPageCtrl.$inject = ['discussionData', '$scope', 'sessionManagerSvc', 'confirmPopupSvc', 'commonConst', '$state', '$q', 'pixerfApiCommunitySvc', 'createDiscussionTopicPopupSvc', 'pagingUtils', 'systemUtils', 'toastr', 'peopleListPopupSvc', '$window', 'pixerfUrl', 'fileConst', 'communityConst', 'pixerfConfirmPopupSvc', 'pixerfDiscussionReportPopupSvc', '$translate', 'accountUtils', 'accountConst'];

	function discussionDetailPageCtrl(discussionData, $scope, sessionManagerSvc, confirmPopupSvc, commonConst, $state, $q, pixerfApiCommunitySvc, createDiscussionTopicPopupSvc, pagingUtils, systemUtils, toastr, peopleListPopupSvc, $window, pixerfUrl, fileConst, communityConst, pixerfConfirmPopupSvc, pixerfDiscussionReportPopupSvc, $translate, accountUtils, accountConst) {

		var self = this;
		self.loginUser = sessionManagerSvc.getCurrentLoginUser().data;
		var LIMIT_PHOTO_ATTACHMENT = communityConst.DISSCUSSION.LIMIT_PHOTO_ATTACHMENT;
		self.commonConst = commonConst;
		self.discussion = discussionData;
		self.isOwner = self.loginUser && (self.loginUser.id === self.discussion.user.id);
		self.isCommunityOwner = self.loginUser && (self.loginUser.id === self.discussion.community.owner.id);
		self.isLiked = false;
		self.isBookmarked = false;
		self.isLastDiscussionComments = false;
		self.discussionComments = [];
		self.errors = [];
		self.searchDiscussionComments = {
			id: self.discussion.id,
			page: 1
		}
		self.searchSimilarDiscussion = {
			id: self.discussion.id,
			page: 1
		};
		self.spinnerComment = {
			isVisible: false
		}
		self.spinnerSimilarDiscussions = {
			isVisible: false
		}

		self.onBookmarkToggle = onBookmarkToggle;
		self.showAttachPhotoBtn = true;
		self.onLikeToggle = onLikeToggle;
		self.onBackbtnClicked = onBackbtnClicked;
		self.onDiscussionRemoved = onDiscussionRemoved;
		self.onEditDiscussion = onEditDiscussion;
		self.onRemoveDiscussion = onRemoveDiscussion;
		self.onCommentDiscussion = onCommentDiscussion;
		self.getReplies = getReplies;
		self.onSearchSimilarDiscussion = _.debounce(onSearchSimilarDiscussion, 400);
		self.onCommentRemoved = onCommentRemoved;
		self.onManageRights = onManageRights;
		self.onPrevDiscussion = onPrevDiscussion;
		self.onNextDiscussion = onNextDiscussion;
		self.onReportDiscussion = onReportDiscussion;
		self.onShowListLike = onShowListLike;
		self.onShowListReply = onShowListReply;
		self.fetchMoreSimilarDiscussions = fetchMoreSimilarDiscussions;
		self.fetchMoreDiscussionComments = fetchMoreDiscussionComments;
		var errorHandlerFn = _.debounce(errorHandler, 1000);
		self.dropzoneConfig = {
			'instance': {},
			'options': {
				url: pixerfUrl.full + 'api/replies/',
				maxFilesize: 40,
				maxFiles: 3,
				parallelUploads: 3,
				paramName: 'photos[]',
				acceptedFiles: ".jpeg, .jpg",
				autoProcessQueue: false,
				thumbnailWidth: 155,
				thumbnailHeight: 155,
				maxThumbnailFilesize: 40,
				dictCancelUpload: "X",
				dictRemoveFile: "X",
				addRemoveLinks: true,
				uploadMultiple: true,
				previewsContainer: '#comment-attach-photos',
				clickable: '.comment-attach-photos-button',
				method: "put",
				headers: {
					"Authorization": "Bearer " + sessionManagerSvc.getToken()
				},
				dictFileTooBig: "File is too big ({{filesize}} MB). Max file size is: {{maxFilesize}} MB.",
			},
			'eventHandlers': {
				sending: function (file, xhr, formData) {},
				addedfile: function (file, xhr, form) {
					var error = validateBeforeUploading(file);
					if (error) {
						setErrors(error);
						errorHandlerFn();
						this.removeFile(file);
					}
					isShowAttachPhotoBtn();
				},
				removedfile: function (file) {
					isShowAttachPhotoBtn();
				},
				processing: function (file, a, v) {
					self.isAttachmentUploading = true;
				},
				success: function (file, responsedFile) {
					var existedComment = _.find(self.discussionComments, function (comment) {
						return comment.id === responsedFile.id;
					})
					if (!existedComment) {
						if (responsedFile && responsedFile.user) {
							responsedFile.user.displayName = accountUtils.buildUserDisplayName(responsedFile.user);
							responsedFile.user.avatar = accountUtils.buildUserAvatarPhotoUrl(responsedFile.user);
						}
						self.discussionComments.push(responsedFile);
					}
					systemUtils.digest($scope);
				},
				completemultiple: function (file, responsedFile) {
					self.dropzoneConfig.instance.removeAllFiles();
					self.commentText = null;
					self.isShowAttachPhotoBtn = true;
					self.isAttachmentUploading = false;
					systemUtils.digest($scope);
				}
			}
		}
		self.discussions = [];
		self.searchDiscussionParams = {
			id: self.discussion.community.id,
			page: 0,
			sort: $state.params.order
		};

		init();

		function init() {
			self.inserted_at = self.discussion.inserted_at ? moment(self.discussion.inserted_at).format('DD MMM YYYY') : "";
			getDiscussionComments(self.searchDiscussionComments, true);
			getSimilarDiscussions(self.searchSimilarDiscussion, true);
			checkOwner();
			gotoAnchor();
			isShowAttachPhotoBtn();
			getAllDiscussions();
		}

		function getCurrentIndexDiscussion() {
			self.currentIndexDiscussion = _.findIndex(self.discussions, {
				id: self.discussion.id
			});
		}

		function onBackbtnClicked() {
			window.history.go(-1);
		}

		function onDiscussionRemoved() {}

		function isShowAttachPhotoBtn() {
			if (self.dropzoneConfig.instance.files) {
				self.showAttachPhotoBtn = self.dropzoneConfig.instance.files.length < LIMIT_PHOTO_ATTACHMENT;
			}
			systemUtils.digest($scope);
		}

		function setErrors(error) {
			error.file.pixerfError = error.code;
			self.errors.push(error);
		}

		function getDiscussions(params, callback) {
			self.searchDiscussionParams = params;
			pixerfApiCommunitySvc.get_discussions_by_community_id(self.searchDiscussionParams).$promise.then(function (res) {
				self.discussions = self.discussions.concat(res.data);
				self.isLastPage = pagingUtils.isNoMorePageToLoad(self.searchDiscussionParams.page, res);
				self.searchDiscussionParams.page = params.page;
				if (callback) {
					callback();
				}
			}).catch(function (err) {
				console.log(err);
			})
		}

		function getAllDiscussions() {
			if (self.isLastPage) {
				getCurrentIndexDiscussion();
				return;
			}
			var searchParms = $.extend(true, {}, self.searchDiscussionParams);
			searchParms.page++;
			getDiscussions(searchParms, getAllDiscussions);
		}

		function errorHandler(errors) {
			if (!errors) errors = self.errors;
			if (errors.length === 0) return;
			var errMsg = '';
			var callToActionMsg = '';
			var groupedError = _.groupBy(errors, function (item) {
				return item.code;
			});
			for (var key in groupedError) {
				callToActionMsg = '';
				if (key === fileConst.UPLOAD_PHOTO_VALIDATION.ERROR_CODE.DUPLICATED) {
					errMsg += "<p>" + $translate.instant("the-following-photos-uploaded-before") + "</p>";
					callToActionMsg += "<p class='upload-photo__validation-popup__call-to-action-msg'>" + $translate.instant("try-uploading-new-ones") + "!</p>";
				}
				errMsg += buildErrorFilename(groupedError[key]);
				errMsg += callToActionMsg;
			}
			pixerfConfirmPopupSvc.showPopup({
				hideCancelBtn: true,
				hideConfirmText: true,
				hideTitle: true,
				message: errMsg,
				windowClass: 'upload-photo__validation-popup',
				okBtnText: 'OK'
			});
			self.errors = [];
		}

		function buildErrorFilename(files) {
			var errMsg = '';
			for (var i = 0; i < files.length; i++) {
				errMsg += ("<div class='upload-photo__invalid-file text--truncate'> - " + files[i].file.name + "</div>");
			}
			return errMsg;
		}

		function validateBeforeUploading(file) {
			var validToUploadFiles = [];
			if (self.dropzoneConfig.instance && self.dropzoneConfig.instance.files) {
				validToUploadFiles = _.reject(self.dropzoneConfig.instance.files, function (f) {
					return f.status === "added";
				})
			}
			if (isDuplicateFile(validToUploadFiles, file)) {
				return {
					code: fileConst.UPLOAD_PHOTO_VALIDATION.ERROR_CODE.DUPLICATED,
					file: file
				};
			}
		}

		function isDuplicateFile(validFiles, file) {
			var isExisted = _.find(validFiles, function (f) {
				return isSameFile(f, file);
			})
			return isExisted;
		}

		function isExceedNumberOfUpload(validFiles, limit) {
			return validFiles.length > limit;
		}

		function isSameFile(fileOne, fileTwo) {
			return fileOne.name === fileTwo.name &&
				fileOne.size === fileTwo.size;

		}

		function onEditDiscussion() {
			var updateDiscussionPopup = createDiscussionTopicPopupSvc.showPopup({
				community: self.discussion.community,
				discussion: self.discussion,
			});
			updateDiscussionPopup.result.then(function (data) {
				if (data) {
					self.discussion = data;
					systemUtils.digest($scope);
				}
			})
		}

		function onRemoveDiscussion() {
			confirmPopupSvc.showPopup({
				windowClass: 'remove-discussion-confirm-popup',
				title: 'Are you sure you want to delete this post?',
				message: 'You will lose all the engagements and comments from this post.',
				submitBtnText: 'Yes, delete it',
				cancelBtnText: 'No, keep it',
				submit: function () {
					var def = $q.defer();
					pixerfApiCommunitySvc.remove_disscussion({
						id: self.discussion.id
					}).$promise.then(function (res) {
						def.resolve(res);
					}).catch(function (err) {
						def.reject(err);
					})
					return def.promise;
				},
				submitCallback: function () {
					$state.go(self.commonConst.STATE.COMMUNITIES_DETAILS_BRIEF, {
						id: self.discussion.community.id,
						name: self.discussion.community.name
					});
				}
			});
		}

		function onCommentDiscussion(comment) {
			pixerfApiCommunitySvc.comment_discussion({
				id: self.discussion.id
			}, {
				text: comment
			}).$promise.then(function (res) {
				self.dropzoneConfig.instance.options.url = pixerfUrl.full + 'api/replies/' + res.data.id;
				self.dropzoneConfig.instance.processQueue();
				if (!self.isAttachmentUploading) {
					self.commentText = null;
					self.discussionComments.push(res.data);
				}
				systemUtils.digest($scope);
			}).catch(function (err) {
				console.log(err);
			})
		}

		function getDiscussionComments(params, isFresh) {
			self.searchDiscussionComments = params;
			self.isWorking = true;
			self.spinnerComment.isVisible = true;
			pixerfApiCommunitySvc.get_discussion_comments(self.searchDiscussionComments).$promise.then(function (res) {
				self.spinnerComment.isVisible = false;
				if (!self.discussionComments || isFresh) self.discussionComments = [];
				self.discussionComments = self.discussionComments.concat(res.data);
				self.isLastDiscussionComments = pagingUtils.isNoMorePageToLoad(self.searchDiscussionComments.page, res);
				self.searchDiscussionComments.page = params.page;
				self.isWorking = false;
			}).catch(function (err) {
				self.spinnerComment.isVisible = false;
				self.isWorking = false;
				console.log(err);
			})
		}

		function getReplies(comment) {
			pixerfApiCommunitySvc.get_sub_replies({
				id: comment.id
			}).$promise.then(function (res) {
				if (!comment.replies) comment.replies = [];
				self.discussionComments.replies = res;
				systemUtils.digest($scope);
			}).catch(function (err) {
				console.log(err);
			})
		}

		function onBookmarkToggle(e) {
			window.event.stopPropagation()
			pixerfApiCommunitySvc.toggle_bookmark_discussion({
				id: self.discussion.id
			}, {}).$promise.then(function (res) {
				self.discussion.is_bookmarked = !self.discussion.is_bookmarked;
			}).catch(function (err) {
				console.log(err);
			})
		}

		function onLikeToggle(e) {
			window.event.stopPropagation()
			var service = self.discussion.is_liked ? 'unlike_discussion' : 'like_discussion';
			pixerfApiCommunitySvc[service]({
				id: self.discussion.id
			}).$promise.then(function (res) {
				self.discussion.is_liked = !self.discussion.is_liked;
				self.discussion.like_count += self.discussion.is_liked ? 1 : -1;
			}).catch(function (err) {
				console.log(err);
			})
		}

		function fetchMoreDiscussionComments() {
			if (self.isLastDiscussionComments || self.spinnerComment.isVisible) return;
			var searchParms = $.extend(true, {}, self.searchDiscussionComments);
			searchParms.page++;
			getDiscussionComments(searchParms);
		}

		function onSearchSimilarDiscussion() {
			self.similarDiscussions = [];
			self.searchSimilarDiscussion.page = 1;
			if (self.searchSimilarDiscussionsString) {
				self.searchSimilarDiscussion = {
					id: self.discussion.community.id,
                    keywords: self.searchSimilarDiscussionsString,
					page: 1
				};
				onSearchDiscussion(self.searchSimilarDiscussion, true);
			} else {
				self.searchSimilarDiscussion = {
					id: self.discussion.id,
					page: 1
				};
				getSimilarDiscussions(self.searchSimilarDiscussion, true);
			}
		}

		function onSearchDiscussion(params, isFresh) {
			self.searchSimilarDiscussion = params;
			self.isWorking = true;
			self.spinnerSimilarDiscussions.isVisible = true;
			pixerfApiCommunitySvc.get_discussions_by_community_id(self.searchSimilarDiscussion).$promise.then(function (res) {
				self.spinnerSimilarDiscussions.isVisible = false;
				if (!self.similarDiscussions || isFresh) self.similarDiscussions = [];
				self.similarDiscussions = self.similarDiscussions.concat(res.data);
				self.isLastSimilarDiscussionPage = pagingUtils.isNoMorePageToLoad(self.searchSimilarDiscussion.page, res);
				self.searchSimilarDiscussion.page = params.page;
				self.isWorking = false;
			}).catch(function (err) {
				self.spinnerSimilarDiscussions.isVisible = false;
				self.isWorking = false;
				console.log(err);
			})
		}

		function getSimilarDiscussions(params, isFresh) {
			self.searchSimilarDiscussion = params;
			self.isWorking = true;
			self.spinnerSimilarDiscussions.isVisible = true;
			pixerfApiCommunitySvc.get_similar_discussions(self.searchSimilarDiscussion).$promise.then(function (res) {
				self.spinnerSimilarDiscussions.isVisible = false;
				if (!self.similarDiscussions || isFresh) self.similarDiscussions = [];
				self.similarDiscussions = self.similarDiscussions.concat(res.data);
				self.isLastSimilarDiscussionPage = pagingUtils.isNoMorePageToLoad(self.searchSimilarDiscussion.page, res);
				self.searchSimilarDiscussion.page = params.page;
				self.isWorking = false;
			}).catch(function (err) {
				self.spinnerSimilarDiscussions.isVisible = false;
				self.isWorking = false;
				console.log(err);
			})
		}

		function fetchMoreSimilarDiscussions() {
			if (self.isLastSimilarDiscussionPage || self.spinnerSimilarDiscussions.isVisible) return;
			var searchParms = $.extend(true, {}, self.searchSimilarDiscussion);
			searchParms.page++;
			getSimilarDiscussions(searchParms);
		}

		function onCommentRemoved(data) {
			self.discussionComments = _.reject(self.discussionComments, function (comment) {
				return comment.id === data.id;
			});
			systemUtils.digest($scope);
		}

		function onManageRights() {
			$state.go(self.commonConst.STATE.MANAGE_COMMUNITIES_BRIEF, {
				id: self.discussion.community.id,
				name: self.discussion.community.name,
				manage: true,
				status: 'members'
			});
		}

		function onNextDiscussion() {
			if (self.currentIndexDiscussion >= (self.discussions.length - 1) || self.discussions.length == 0) return;
			self.currentIndexDiscussion++;
			$state.go(self.commonConst.STATE.DISCUSSION_DETAIL, {
				id: self.discussions[self.currentIndexDiscussion].id,
				subject: self.discussions[self.currentIndexDiscussion].subject.replace(/ /g, '-')
			});
		}

		function onPrevDiscussion() {
			if (self.currentIndexDiscussion < 1 || self.discussions.length == 0) return;
			self.currentIndexDiscussion--;
			$state.go(self.commonConst.STATE.DISCUSSION_DETAIL, {
				id: self.discussions[self.currentIndexDiscussion].id,
				subject: self.discussions[self.currentIndexDiscussion].subject.replace(/ /g, '-')
			});
		}

		function onReportDiscussion() {
			pixerfDiscussionReportPopupSvc.showPopup({
				id: self.discussion.id,
				target: 'report_discussion'
			});
		}

		function gotoAnchor() {
			self.scrollToElement = parseInt(location.hash.split('#')[2]);
		};

		function checkOwner() {
			var statusValid = ['owner', 'accepted'];
			pixerfApiCommunitySvc.get({
				id: self.discussion.community.id
			}).$promise.then(function (res) {
				if (res.data && statusValid.includes(res.data.status)) {
					self.isMember = true;
				}
				if (res.data && res.data.owner) {
					self.discussion.community.owner = res.data.owner;
				}
			}).catch(function (err) {
				console.log(err);
			})
		}

		function onShowListLike() {
			$window.event.stopPropagation();
			if (self.discussion.like_count < 1) return;

			peopleListPopupSvc.showPopup({
				type: accountConst.INTERACT_TYPE.LIKE_DISCUSSION.toLowerCase(),
				user: self.loginUser,
				discussionId: self.discussion.id,
				options: {
					hideSeeAll: true
				}
			});
		}

		function onShowListReply() {
			$window.event.stopPropagation();
			if (self.discussion.reply_count < 1) return;

			peopleListPopupSvc.showPopup({
				type: accountConst.INTERACT_TYPE.REPLY_DISCUSSION.toLowerCase(),
				user: self.loginUser,
				discussionId: self.discussion.id,
				options: {
					hideSeeAll: true
				}
			});
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.config(routerConfig);

	routerConfig.$inject = ['$stateProvider'];

	function routerConfig($stateProvider) {
		'ngInject';
		$stateProvider
			.state('discussion-detail-page', {
				url: '/discussion/:id/:subject',
				templateUrl: 'app/discussion-detail-page/discussion-detail-page.html',
				controller: 'discussionDetailPageCtrl',
				controllerAs: 'vm',
				data: {
					pageTitle: "PIXERF - Discussion detail",
					permissions: {
						only: ['AUTHORIZED'],
						redirectTo: function () {
							return ".sign-in-page";
						}
					}
				},
				params: {
					"id": {
						squash: true,
						value: null
					},
					"subject": {
						squash: true,
						value: null
					},
					"order":{
						squash: true,
						value: 'inserted_at'
					}
				},
				resolve: {
					discussionData: function ($stateParams, pixerfApiCommunitySvc, $q, $state) {
						var defer = $q.defer();
						var self = this;
						var discussionId = parseInt($stateParams.id);
						var discussion = {};
						if (!$stateParams.id || ($stateParams.id && isNaN(discussionId))) {
							$state.go('404');
							defer.reject();
						} else {
							pixerfApiCommunitySvc.get_discussion_by_id({
								id: discussionId
							}).$promise.then(function (response) {
								discussion = response.data;
								self.data.pageTitle = "PIXERF - Discussion: " + discussion.subject;
								return pixerfApiCommunitySvc.get({
									id: discussion.community.id
								}).$promise;
							}).then(function(response){
								if(discussion && discussion.community && response.data){
									discussion.community.owner = response.data.owner;
								}
								defer.resolve(discussion);
							}).catch(function (err) {
								defer.reject(err);
							})
						}

						return defer.promise;
					}
				}
			});
	}
})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.factory('customCommissionsDetailPageSvc', customCommissionsDetailPageSvc);
	customCommissionsDetailPageSvc.$inject = ['customCommissionDetailPageService', 'pixerfApiCustomCommssionsSvc', '$q'];

	function customCommissionsDetailPageSvc(customCommissionDetailPageService, pixerfApiCustomCommssionsSvc, $q) {

		var mCustomCommission = {
			stats: {}
		};

		var mShoot = {
			stats: {}
		}

		function getShoot() {
			return mShoot;
		}

		function setShoot(shoot, customProp) {
			if (customProp) {
				mShoot[customProp] = shoot[customProp];
			} else {
				mShoot = shoot;
			}
		}

		function getCustomComission(prop) {
			return prop ? mCustomCommission[prop] : mCustomCommission;
		}

		function setCustomComission(customCommission, customProp) {
			if (customProp) {
				mCustomCommission[customProp] = shoot[customProp];
			} else {
				mCustomCommission = customCommission;
			}
		}

		function downloadPhotos(shoot, selectedMedias, isLowres) {
			var def = $q.defer();
			var isHires = isLowres ? 'false' : 'true';
			var mediaIds = [];
			if (selectedMedias.length) {
				for (var i = 0; i < selectedMedias.length; i++) {
					mediaIds.push(selectedMedias[i].media.id);
				}
			}
			pixerfApiCustomCommssionsSvc.release({
				id: shoot.id
			}, {
				media_ids: mediaIds, 
				hires: isHires
			}).$promise.then(function (response) {
				return customCommissionDetailPageService.formatTicket(shoot, response, isLowres);
			}).then(function (response) {
				def.resolve(response.downloadLink);
			}).catch(function (err) {
				def.reject(err);
			});

			return def.promise;
		}

		return {
			getShoot: getShoot,
			setShoot: setShoot,
			getCustomComission: getCustomComission,
			setCustomComission: setCustomComission,
			downloadPhotos: downloadPhotos
		};
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('customCommissionsDetailPageCtrl', customCommissionsDetailPageCtrl);

	customCommissionsDetailPageCtrl.$inject = ['customCommissionsData', '$scope', 'headerSvc', 'sessionManagerSvc', 'commonConst'];

	function customCommissionsDetailPageCtrl(customCommissionsData, $scope, headerSvc, sessionManagerSvc, commonConst) {

		var self = this;
		self.fixedSetting = headerSvc.getFixedByHeaderSetting();
		self.customCommissions = customCommissionsData;
		self.logo = "";
		self.loginedUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.isManager = self.loginedUser.isBiz || (self.customCommissions.shoots.length && (self.customCommissions.shoots[0].role === 'administrator' || self.customCommissions.shoots[0].role === 'owner'));
		self.contextPage = "Brief";

		init();

		function init() {
			genLogo();
			self.navigation = {
				context: 'approval',
				items: [{
						name: 'approval',
						redirectTo: commonConst.STATE.CUSTOMCOMMISSIONS_DETAIL_APPROVAL
					},
					{
						name: 'delivery',
						redirectTo: commonConst.STATE.CUSTOMCOMMISSIONS_DETAIL_DELIVERY
					}
				]
			}
		}

		function genLogo() {
			if (self.customCommissions.organization && self.customCommissions.organization.profile_image_media) {
				self.logo = self.customCommissions.organization.profile_image_media['1255px'] ? self.customCommissions.organization.profile_image_media['1255px'] : self.customCommissions.organization.profile_image_media[Object.keys(self.customCommissions.organization.profile_image_media)[0]];
				tranformCustomCCLogo();
			}
		}

		function tranformCustomCCLogo() {
			if ([2, 35].includes(self.customCommissions.id)) {
				self.logo = "assets/images/custom-commissions/honda_logo.png?t=" + moment().unix();
			} else if (self.customCommissions.id === 5 || self.customCommissions.id === 6) {
				self.logo = "assets/images/custom-commissions/Grab_Food.jpg?t=" + moment().unix();
			} else if (self.customCommissions.id === 7) {
				self.logo = "assets/images/custom-commissions/PA.jpg?t=" + moment().unix();
			} else if ([8, 13, 16, 24, 25, 28, 32].includes(self.customCommissions.id)) {
				self.logo = "assets/images/custom-commissions/esing-logo.jpg?t=" + moment().unix();
			} else if ([9, 18].includes(self.customCommissions.id)) {
				self.logo = "assets/images/custom-commissions/AIC-LOGO-on-transparent-background.jpg?t=" + moment().unix();
			} else if ([10, 11].includes(self.customCommissions.id)) {
				self.logo = "assets/images/custom-commissions/skill-future.jpg?t=" + moment().unix();
			} else if (self.customCommissions.id === 12) {
				self.logo = "assets/images/custom-commissions/shield_logo_square.jpg?t=" + moment().unix();
			} else if (self.customCommissions.id === 14) {
				self.logo = "assets/images/custom-commissions/WSHC-logo_new-bf4b93613b.jpg?t=" + moment().unix();
			} else if (self.customCommissions.id === 15) {
				self.logo = "assets/images/custom-commissions/cnb-logo.jpg?t=" + moment().unix();
			} else if (self.customCommissions.id === 17) {
				self.logo = "assets/images/custom-commissions/singapore-police-force.jpg?t=" + moment().unix();
			} else if ([19, 20, 21, 22, 23, 30].includes(self.customCommissions.id)) {
				self.logo = "assets/images/custom-commissions/petronas.jpg?t=" + moment().unix();
			} else if (self.customCommissions.id === 27) {
				self.logo = "assets/images/custom-commissions/land-transport-authority.png?t=" + moment().unix();
			} else if (self.customCommissions.id === 29) {
				self.logo = "assets/images/custom-commissions/pmo-sg.png?t=" + moment().unix();
			} else if (self.customCommissions.id === 31) {
				self.logo = "assets/images/custom-commissions/republic-polytechnic.png?t=" + moment().unix();
			} else if (self.customCommissions.id === 33) {
				self.logo = "assets/images/custom-commissions/ademco-logo.png?t=" + moment().unix();
			} else if (self.customCommissions.id === 34) {
				self.logo = "assets/images/custom-commissions/PIL.png?t=" + moment().unix();
			} else if (self.customCommissions.id === 36){
                self.logo = "assets/images/custom-commissions/Storytel_PrimaryLogo.jpg?t=" + moment().unix();
            }
		}

	}
})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.factory('customCommissionDetailPageService', customCommissionDetailPageService);

	customCommissionDetailPageService.$inject = ['pixerfUrl', 'dateUtils'];

	function customCommissionDetailPageService(pixerfUrl, dateUtils) {
		function buildFileSizeForHumanRead(size) {
			var OneGbInBytes = 1024 * 1024 * 1024;
			if (size > OneGbInBytes) return Math.floor(size / OneGbInBytes) + 'GB';
			return Math.floor(1024 * size / OneGbInBytes) + 'MB';
		}

		function formatTickets(tickets, isAll, isLowres) {
			for (var i = 0; i < tickets.length; i++) {
				if (!tickets[i].metadata) continue;
				formatTicket(tickets[i], isAll, isLowres);
			}
			return tickets;
		}

		function formatTicket(shoot, ticket, isLowres) {
			var isHiresQuery = isLowres  ? 'false' : 'true'; 
			ticket.downloadLink = pixerfUrl.full + "api/shoots/" + shoot.id + "/download_images/" + ticket.token + "?is_hires=" + isHiresQuery;
			return ticket;
		}

		function removeItemFromSubmissionsList(items, itemByGroup, removedIds) {
			for (obj in itemByGroup) {
				for (var i = 0; i < itemByGroup[obj].data.length; i++) {
					itemByGroup[obj].data[i].data = itemByGroup[obj].data[i].data.filter(function (obj) {
						return !removedIds.includes(obj.id);
					});
					if (!itemByGroup[obj].data[i].data.length) {
						itemByGroup[obj].data.splice(i, 1);
					}
					items = _.reject(items, function (obj) {
						return removedIds.includes(obj.id);
					});
				}
			}
		}

		return {
			formatTickets: formatTickets,
			formatTicket: formatTicket,
			removeItemFromSubmissionsList: removeItemFromSubmissionsList
		};
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.config(routerConfig);

	routerConfig.$inject = ['$stateProvider'];

	function routerConfig($stateProvider) {
		'ngInject';
		$stateProvider
			.state('custom-commissions-detail-page', {
				abstract: true,
				url: '/custom-commissions-detail/:id/:name',
				templateUrl: 'app/custom-commissions-detail-page/custom-commissions-detail-page.html',
				controller: 'customCommissionsDetailPageCtrl',
				controllerAs: 'vm',
				data: {
					pageTitle: "PIXERF - Custom Commissions Detail",
					permissions: {
						only: ['AUTHORIZED'],
						redirectTo: function () {
							return ".sign-in-page";
						}
					}
				},
				params: {
					"id": {
						squash: true,
						value: null
					},
					"name": {
						squash: true,
						value: null
					}
				},
				resolve: {
					customCommissionsData: function ($stateParams, pixerfApiCustomCommssionsSvc, $q, $state) {
						var defer = $q.defer();
						var self = this;
						var customCommissionsId = parseInt($stateParams.id);
						if (!$stateParams.id || ($stateParams.id && isNaN(customCommissionsId))) {
							$state.go('404');
							defer.reject();
						} else {
							pixerfApiCustomCommssionsSvc.getCustomCommissionById({
								id: customCommissionsId
							}).$promise.then(function (response) {
								var customCommissions = response.data;
								self.data.pageTitle = "PIXERF - Custom Commissions: " + customCommissions.name;
								defer.resolve(customCommissions);
							}, function (err) {
								defer.reject(err);
							})
						}

						return defer.promise;
					}
				}
			})
			.state('custom-commissions-detail-page.approval', {
				url: '/approval',
				views: {
					'leftCol@custom-commissions-detail-page.approval': {
						templateUrl: 'app/custom-commissions-detail-page/components/custom-commissions-detail-page-approval/shoot-list/custom-commissions-approval-shoot-list.html',
						controller: 'customCommissionsApprovalShootListCtrl',
						controllerAs: 'vm',
					},
					'mainContent@custom-commissions-detail-page.approval': {
						templateUrl: 'app/custom-commissions-detail-page/components/custom-commissions-detail-page-approval/main-content/custom-commissions-approval-main-content.html',
						controller: 'customCommissionsApprovalMainContentCtrl',
						controllerAs: 'vm',
					},
					'rightCol@custom-commissions-detail-page.approval': {
						templateUrl: 'app/custom-commissions-detail-page/components/custom-commissions-detail-page-approval/confirm-approval/custom-commissions-approval-confirm-approval.html',
						controller: 'customCommissionsApprovalConfirmApprovalCtrl',
						controllerAs: 'vm',
					},
					'': {
						templateUrl: 'app/custom-commissions-detail-page/components/custom-commissions-detail-page-approval/custom-commissions-detail-page-approval.html',
						controller: 'customCommissionsDetailPageApprovalCtrl',
						controllerAs: 'vm',
					}
				},
				data: {
					pageTitle: "PIXERF - Custom Commissions Approval",
					hideFooter: true
				}
			})
			.state('custom-commissions-detail-page.delivery', {
				url: '/delivery',
				views: {
					'leftCol@custom-commissions-detail-page.delivery': {
						templateUrl: 'app/custom-commissions-detail-page/components/custom-commissions-detail-page-delivery/shoot-list/custom-commissions-delivery-shoot-list.html',
						controller: 'customCommissionsDeliveryShootListCtrl',
						controllerAs: 'vm',
					},
					'mainContent@custom-commissions-detail-page.delivery': {
						templateUrl: 'app/custom-commissions-detail-page/components/custom-commissions-detail-page-delivery/main-content/custom-commissions-delivery-main-content.html',
						controller: 'customCommissionsDeliveryMainContentCtrl',
						controllerAs: 'vm',
					},
					'': {
						templateUrl: 'app/custom-commissions-detail-page/components/custom-commissions-detail-page-delivery/custom-commissions-detail-page-delivery.html',
						controller: 'customCommissionsDetailPageDeliveryCtrl',
						controllerAs: 'vm',
					}
				},
				data: {
					pageTitle: "PIXERF - Custom Commissions Delivery",
					hideFooter: true
				}
			});
	}
})();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.factory('customCommissionBasicFormPopupSvc', customCommissionBasicFormPopupSvc);
		customCommissionBasicFormPopupSvc.$inject = ['$uibModal'];

	function customCommissionBasicFormPopupSvc($uibModal) {
		function showPopup(data) {
			return $uibModal.open({
				templateUrl: 'app/custom-commission-basic-form-popup/custom-commission-basic-form-popup.html',
				controller: 'customCommissionBasicFormPopupCtrl',
				controllerAs: 'vm',
				animation: true,
				// windowClass: 'zindex complete-profile-popup-modal',
				windowClass: 'custom-commission-basic-form-popup-modal',
				backdrop: 'static',
				resolve: {
					'resolveData': function () {
						return data;
					}
				}
			});
		}

		return {
			showPopup: showPopup
		};
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('customCommissionBasicFormPopupCtrl', customCommissionBasicFormPopupCtrl);

	customCommissionBasicFormPopupCtrl.$inject = ['$scope', 'pixerfApiSubscribeSvc', '$uibModalInstance', 'ISO3166', '$state',
		'toastr', '$translate', 'pixerfApiCustomCommissionSvc', 'translationSvc', 'sessionManagerSvc', 'systemUtils', 'resolveData',
		'$timeout', '$anchorScroll', '$location'];

	function customCommissionBasicFormPopupCtrl($scope, pixerfApiSubscribeSvc, $uibModalInstance, ISO3166, $state,
		toastr, $translate, pixerfApiCustomCommissionSvc, translationSvc, sessionManagerSvc, systemUtils, resolveData,
		$timeout, $anchorScroll, $location) {

		var self = this;
		var mLoginUser = sessionManagerSvc.getCurrentLoginUser().data;
		var selectedCategory = resolveData ? resolveData.category : null;
		self.fromPage = resolveData ? resolveData.fromPage : null;
		self.currentState = 1;
		self.highestState = self.currentState;
		self.spinner = {
			isVisible: false
		};
		self.invalidDeliveryTime = true;
		self.showErrorDeliveryTime = false;
		self.categories = [];
		self.formData = {
			category: null,
			budgetFrom: 1000,
			budgetTo: 1000,
			deliveryTime: null,
			fullName: null,
			countries: [],
			email: null,
			mobile: null
		}
		self.subcribleNewsLetter = false;
		self.isValidBugetTo = isValidBugetTo;
		self.isValidBugetFrom = isValidBugetFrom;
		self.onSelectCategory = onSelectCategory;
		self.onCountriesSelected = onCountriesSelected;
		self.onBrowseSignatureGalleriesBrnClicked = onBrowseSignatureGalleriesBrnClicked;
		self.onContactUsBtnClicked = onContactUsBtnClicked;
		self.isSaveingStep = function () {
			return (self.currentState == 5);
		}
		self.countriesOpts = {
			"maxOptions": 1,
			'noneSelectedText': 'Please select country',
			"container": "body",
			"customAll": false,
			"dropupAuto": false
		};
		self.gplacesOptions = {
			types: ['(cities)']
		}

		self.StateData = {
			1: {
				name: 'selectType',
				title: $translate.instant("select-the-type-of-shoot"),
				desc: $translate.instant("pick-a-category-and-PIXERF")
			},
			2: {
				name: 'SetBudget',
				title: $translate.instant('set-your-budget'),
				desc: $translate.instant("got-a-budget-in-mind"),
			},
			3: {
				name: 'SetTheLocation',
				title: $translate.instant('set-the-location'),
				desc: $translate.instant("where-do-you-want-to-conduct-your-photo-shoot"),
			},
			4: {
				name: 'SetExpectedDelivery',
				title: $translate.instant('when-is-your-expected-delivery'),
				desc: $translate.instant("urgent-deadlines"),
			},
			5: {
				name: 'inputContactDetail',
				title: $translate.instant('fill-in-your-contact-details'),
				desc: $translate.instant("our-team-will-be-in-touch"),
			},
			6: {
				name: 'thankYou',
				title: $translate.instant('thank-you-We-ll-get-in-touch-soon'),
				desc: $translate.instant("in-the-meantime-you-can-view"),
			}
		}

		self.deliveryTimeOptions = {
			fromYear: moment().year(),
			toYear: moment().year() + 5
		}

		self.arraySteps = Object.keys(self.StateData);
		self.arraySteps.pop(); //remove Thanks you step

		self.categoriesList = [{
				name: "Portrait",
				thumbnails: "assets/images/categories/Portrait.jpg"
			},
			{
				name: "Lifestyle",
				thumbnails: "assets/images/categories/Lifestyle.jpg"
			},
			{
				name: "Corporate",
				thumbnails: "assets/images/categories/Corporate.jpg"
			},
			{
				name: "Food & Beverages",
				thumbnails: "assets/images/categories/Food&Beverages.jpg"
			},
			{
				name: "Product",
				thumbnails: "assets/images/categories/Product.jpg"
			},
			{
				name: "Architecture & Interior Design",
				thumbnails: "assets/images/categories/Architecture&Interior.jpg"
			},
			{
				name: "Aerial",
				thumbnails: "assets/images/categories/Aerial.jpg"
			},
			{
				name: "Events",
				thumbnails: "assets/images/categories/Events.jpg"
			}

		];

		$scope.$watch('vm.formData.deliveryTime', function (newDate) {
			if (!self.invalidDeliveryTime && (moment(self.formData.deliveryTime) <= moment())) {
				self.showErrorDeliveryTime = true;
			} else {
				self.showErrorDeliveryTime = false;
			}
		}, true)

		self.cancel = function () {
			$uibModalInstance.dismiss('cancel');
		};

		self.onNextBtnClicked = function () {
			if (self.currentState == 5) {
				sendData();
			} else {
				self.currentState++;
				self.highestState = self.currentState;
			}
		}
		self.onBackBtnClicked = function (toState) {
			if (self.highestState < toState) {
				return;
			}
			self.currentState = toState;
		}

		self.canBack = function (toState) {
			if (self.highestState <= toState) {
				return false;
			}
			return true;
		}

		self.canNext = function (contactDetailForm) {
			if (self.currentState == 1) {
				return (self.formData.category != null);
			} else if (self.currentState == 2) {
				return (self.formData.budgetFrom && self.formData.budgetTo && (self.formData.budgetFrom <= self.formData.budgetTo))
			} else if (self.currentState == 3) {
				return self.formData.country && self.formData.city;
			} else if (self.currentState == 4) {
				return (moment(self.formData.deliveryTime) > moment());
			} else if (self.currentState == 5) {
				return (contactDetailForm && contactDetailForm.$valid);
			} else if (self.processing) {
				return false;
			}
		}

		self.canJump = function (contactDetailForm) {
			return ((self.currentState != self.highestState) && self.canNext(contactDetailForm)) || ((self.currentState == self.highestState));
		}

		function onSelectCategory(name) {
			self.formData.category = name;
		}

		function sendData() {
			self.spinner.isVisible = true;
			var emailData = convertDataForSendEmail();
			pixerfApiCustomCommissionSvc.book_cc(emailData).$promise.then(
				function success(data) {
					self.spinner.isVisible = false;
					subcribeNewsLetter();
					self.currentState = 6;
				},
				function error(err) {
					self.spinner.isVisible = false;
					toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
				}
			)
		}

		function convertDataForSendEmail() {
			var format = "D MMMM YYYY";
			var sendEmailData = {
				category: self.formData.category,
				budget_from: new Intl.NumberFormat('en-US', {
					style: 'currency',
					currency: 'SGD'
				}).format(self.formData.budgetFrom),
				budget_to: new Intl.NumberFormat('en-US', {
					style: 'currency',
					currency: 'SGD'
				}).format(self.formData.budgetTo),
				delivery_date: moment(self.formData.deliveryTime).format(format),
				full_name: self.formData.fullName,
				email: self.formData.email,
				country: self.formData.country.toString(),
				address: self.formData.address,
				city: self.formData.city.name,
				mobile: self.formData.mobile
			}
			return sendEmailData;
		}

		function subcribeNewsLetter() {
			if (!self.subcribleNewsLetter) {
				return;
			}
			var emailToSubscrible = self.formData.email;
			pixerfApiSubscribeSvc.subscribe({
				"email_subscriber": {
					topic: 'newsLetter',
					email: emailToSubscrible
				}
			}).$promise.then(
				function (res) {},
				function (error) {
					toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
				});
		}

		function isValidBugetTo() {
			if (self.formData.budgetTo && (self.formData.budgetFrom <= self.formData.budgetTo)) {
				return true
			}
			return false
		}

		function isValidBugetFrom() {
			if (self.formData.budgetFrom && (self.formData.budgetFrom <= self.formData.budgetTo)) {
				return true
			}
			return false
		}

		function onBrowseSignatureGalleriesBrnClicked() {
			$uibModalInstance.dismiss('cancel');
			$state.go("buy-stock-page.galleries.signature-galleries");
		}

		function init() {
			self.currentState = 1;
			self.countries = buildCountries();
			updateUserInfo();
			if(selectedCategory){
				self.formData.category = selectedCategory;
				self.currentState = 2;
			}
		}

		function updateUserInfo(){
			if(!mLoginUser){
				return;
			}

			self.formData.fullName = mLoginUser.displayName;
			self.formData.email = mLoginUser.email;
			self.formData.mobile = (mLoginUser.isBiz && mLoginUser.organization) ? mLoginUser.organization.telephone : null;
		}

		function buildCountries() {
			var arr = [];
			for (var key in ISO3166.codeToCountry) {
				arr.push({
					id: key,
					name: ISO3166.codeToCountry[key]
				})
			}
			return arr;
		}

		function onCountriesSelected(countriesSelected) {
			if (!self.selectedCountries || !self.selectedCountries.length) {
				delete self.countryIds;
				delete self.formData.country;
				self.selectedCountries = [{
					id: 'all',
					name: 'All Countries'
				}];
			} else {
				self.formData.country = _.pluck(self.selectedCountries, 'name');
				self.countryIds = _.pluck(self.selectedCountries, 'id');
				self.gplacesOptions = {
					types: ['(cities)'],
					componentRestrictions: {
						country: self.countryIds
					}
				}
				systemUtils.digest($scope);
			}
		}

		function onContactUsBtnClicked(){
			$uibModalInstance.dismiss('cancel');

			switch (self.fromPage) {
				case 'home':
					$location.hash('generalContactFormSection');
					$anchorScroll();
					break;
				case 'book-a-shoot-page.about-custom-content':
					$location.hash('generalContactFormSection');
					$anchorScroll();
					break;
				default:
					$state.go('book-a-shoot-page.about-custom-content', {
						section: 'generalContactFormSection'
					});
			}
		}

		init();
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('customCommissionAdCtrl', customCommissionAdCtrl);

	customCommissionAdCtrl.$inject = ['$scope', 'sessionManagerSvc', 'systemUtils', 'customCommissionBasicFormPopupSvc'];

	function customCommissionAdCtrl($scope, sessionManagerSvc, systemUtils, customCommissionBasicFormPopupSvc) {

		var self = this;
		var mloginnedUser = sessionManagerSvc.getCurrentLoginUser().data;
		var pixerfEnv = new PixerfEnv().getEnv();
		self.onPreviousSlide = onPreviousSlide;
		self.onNextSlide = onNextSlide;
		self.onBookCcBtnClicked = onBookCcBtnClicked;
		var env = (pixerfEnv === "PRODUCTION") ? 'prod' : 'qa';
		self.brandingPhoto = {
			"id": 228590,
			"title": "Nevermind The Botox3",
			"user": {
				"name": "Nazir Azhari",
				"id": 22505
			}
		};
		self.slideDatas = [{
				id: 1,
				logo: "assets/images/custom-commission-ad/slides/slide-1-logo.jpg",
				indexShowInfo: 5,
				infoLast: false,
				themeColor: "#dbb688",
				slideInfo: {
					photoShoot: "1,600",
					days: 4,
					models: 40,
					licensed: 400
				},
				photos: [
					"assets/images/custom-commission-ad/slides/slide-1-first-photo.jpg",
					"assets/images/custom-commission-ad/slides/slide-1-second-photo.jpg",
					"assets/images/custom-commission-ad/slides/slide-1-third-photo.jpg",
					"assets/images/custom-commission-ad/slides/slide-1-fourth-photo.jpg",
					"assets/images/custom-commission-ad/slides/slide-1-fifth-photo.jpg",
					"assets/images/custom-commission-ad/slides/slide-1-sixth-photo.jpg"
				]
			},
			{
				id: 2,
				logo: "assets/images/custom-commission-ad/slides/slide-2-logo.jpg",
				indexShowInfo: 5,
				infoLast: true,
				themeColor: "#a4d9ea",
				slideInfo: {
					photoShoot: "1154",
					days: 11,
					models: 81,
					licensed: 342
				},
				photos: [
					"assets/images/custom-commission-ad/slides/slide-2-first-photo.jpg",
					"assets/images/custom-commission-ad/slides/slide-2-second-photo.jpg",
					"assets/images/custom-commission-ad/slides/slide-2-third-photo.jpg",
					"assets/images/custom-commission-ad/slides/slide-2-fourth-photo.jpg",
					"assets/images/custom-commission-ad/slides/slide-2-fifth-photo.jpg",
					"assets/images/custom-commission-ad/slides/slide-2-sixth-photo.jpg",
					"assets/images/custom-commission-ad/slides/slide-2-seventh-photo.jpg"
				]
			},
			{
				id: 3,
				logo: "assets/images/custom-commission-ad/slides/slide-3-logo.jpg",
				indexShowInfo: 5,
				infoLast: true,
				themeColor: "#ccc96b",
				slideInfo: {
					photoShoot: "1,300",
					days: 6,
					licensed: 342
				},
				photos: [
					"assets/images/custom-commission-ad/slides/slide-3-first-photo.jpg",
					"assets/images/custom-commission-ad/slides/slide-3-second-photo.jpg",
					"assets/images/custom-commission-ad/slides/slide-3-third-photo.jpg",
					"assets/images/custom-commission-ad/slides/slide-3-fourth-photo.jpg",
					"assets/images/custom-commission-ad/slides/slide-3-fifth-photo.jpg",
					"assets/images/custom-commission-ad/slides/slide-3-sixth-photo.jpg",
					"assets/images/custom-commission-ad/slides/slide-3-seventh-photo.jpg"
				]
			},
			{
				id: 4,
				indexShowInfo: 4,
				infoLast: false,
				themeColor: "#f1c474",
				slideInfo: {
					photoShoot: "174",
					days: 3,
					hawkers: 4,
					licensed: 12
				},
				logo: "assets/images/custom-commission-ad/slides/slide-4-logo.jpg",
				photos: [
					"assets/images/custom-commission-ad/slides/slide-4-first-photo.jpg",
					"assets/images/custom-commission-ad/slides/slide-4-second-photo.jpg",
					"assets/images/custom-commission-ad/slides/slide-4-third-photo.jpg",
					"assets/images/custom-commission-ad/slides/slide-4-fourth-photo.jpg",
					"assets/images/custom-commission-ad/slides/slide-4-fifth-photo.jpg"
				]
			}
		];
		self.slickSetting = {
			onInit: function (slick) {
				self.slick = slick;
				systemUtils.digest($scope);
			}
		}

		function onPreviousSlide() {
			self.slick.slickPrev();
		}

		function onNextSlide() {
			self.slick.slickNext();
		}

		function onBookCcBtnClicked(){
			customCommissionBasicFormPopupSvc.showPopup();
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.config(routerConfig);

	routerConfig.$inject = ['$stateProvider'];

	function routerConfig($stateProvider) {
		'ngInject';
		$stateProvider
			.state('custom-commission-ad', {
				url: '/2020/09/custom-commissions/hire-asias-best-photographers',
				templateUrl: 'app/custom-commission-ad/custom-commission-ad.html',
				controller: 'customCommissionAdCtrl',
				controllerAs: 'vm',
				params: {
					"section": {
						squash: true,
						value: null
					}
				},
				data: {
					pageTitle: "PIXERF - Custom Commission Ad",
					headerClass: 'homepage custom-commission-ad',
					permissions: {
						only: ['EVERY_ONE']
					},
					hideFooter: true
				}
			});
	}
})();

function PixerfFilestackConfigurer(){
    this.ENV = {
        "PRODUCTION": "AfdXh5FiXRHarDcaQ3mw5z",
        "STAGING": "AZdFpmnENRB2u19zNIbXoz",
        "TESTING": "A3d2yvXnxTg2CgShXIr1kz",
        "DEVELOPING": "A3d2yvXnxTg2CgShXIr1kz"
    }
}
PixerfFilestackConfigurer.prototype = (function(){
    function getEnv(){
        var pixerfEnv = new PixerfEnv();
        return this.ENV[pixerfEnv.getEnv()];
    }
    return {
        getEnv: getEnv
    }
})();
function PixerfEnv(){
    this.ENV = {
        PRODUCTION : "PRODUCTION",
        STAGING: "STAGING",
        TESTING: "TESTING",
        DEVELOPING: "DEVELOPING"
    }
}
PixerfEnv.prototype = (function(){
    function getEnv(){
        var URL_PRFIX = "https://";
        if (!String.prototype.startsWith) {
            String.prototype.startsWith = function(searchString, position) {
                position = position || 0;
                return this.indexOf(searchString, position) === position;
            };
        }
        if(location.href.startsWith(URL_PRFIX + "pixerf.com")){
            return this.ENV.PRODUCTION;
        }
        else if (location.href.startsWith(URL_PRFIX + 'staging.pixerf.com')){
            return this.ENV.STAGING;
        }
        else if (location.href.startsWith(URL_PRFIX + 'qa.pixerf.com')){
            return this.ENV.TESTING;
        }
        else if (location.href.startsWith('http://localhost:5000')){
            return this.ENV.DEVELOPING;
        }
        return this.ENV.TESTING;
    }
    return {
        getEnv: getEnv
    }
})();

function PixerfAuth0Configurer(){
    this.ENV = {
        "PRODUCTION": {
            clientID: "CX71vZ6A5B2CRUWycgcwSjqRJomeQL1n",
            domain: "auth.pixerf.com"
        },
        "STAGING": {
            clientID: "Qtn7RYBZ4tpP35pXDBj9PR0zYIEDPv4N",
            domain: "pixerf-staging.au.auth0.com"
        },
        "TESTING": {
            clientID: "d5Ehkv7aRKGthnC6l8AgHZmU2GaNK7K4",
            domain: "auth-qa.pixerf.com"
        },
        "DEVELOPING": {
            clientID: "d5Ehkv7aRKGthnC6l8AgHZmU2GaNK7K4",
            domain: "auth-qa.pixerf.com"
        }
    }
}
PixerfAuth0Configurer.prototype = (function(){
    function getEnv(){
        var pixerfEnv = new PixerfEnv();
        return this.ENV[pixerfEnv.getEnv()];
    }
    return {
        getEnv: getEnv
    }
})();
function PixerfAPIUrlConfigurer(){
    this.URL_PRFIX = "https://";
    this.URL_LOCAL_PRFIX = "http://";
    this.URL_AFFIX = "/";
    this.ENV = {
        // DEVELOPING: "phoenix.pixerf.com",
        DEVELOPING: "qa.pixerf.com",
        PRODUCTION : "pixerf.com",
        STAGING: "staging.pixerf.com",
        TESTING: "qa.pixerf.com"
    }
}
PixerfAPIUrlConfigurer.prototype = (function(){
    function getBaseUrl(){
        var pixerfEnv = new PixerfEnv();
        return this.ENV[pixerfEnv.getEnv()];
    }
    return {
        getBaseUrl: getBaseUrl
    }
})();

(function () {
    'use strict';

    angular
        .module('pixerf')
        .directive('uiSrefActiveIf', uiSrefActiveIf);
    uiSrefActiveIf.$inject = ['$state'];
    function uiSrefActiveIf($state) {
        return {
            restrict: "A",
            controller: ['$scope', '$element', '$attrs', function ($scope, $element, $attrs) {
                var state = $attrs.uiSrefActiveIf;
                var activeClass = $attrs.uiSrefActiveClass;

                function update() {
                    if ($state.includes(state) || $state.is(state)) {
                        $element.addClass(activeClass);
                    } else {
                        $element.removeClass(activeClass);
                    }
                }

                $scope.$on('$stateChangeSuccess', update);
                update();
            }]
        }
    }
})();                                                                  
(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('trackingElement', trackingElement);
	trackingElement.$inject = ['pixerfApiTracking', 'sessionManagerSvc', '$timeout'];

	function trackingElement(pixerfApiTracking, sessionManagerSvc, $timeout) {
		return {
			restrict: 'A',
			link: function ($scope, $element, $attrs) {
                $timeout(function(){
				var mloginnedUser = sessionManagerSvc.getCurrentLoginUser().data;
				var params = {
					button_id: $attrs.id,
					button_text: $element[0].innerText.replace(/(\r\n|\n|\r)/gm, " ")
				};

				if ($attrs.description) {
					params.description = $attrs.description;
				}

				if (mloginnedUser) {
					params.user_id = mloginnedUser.id;
				}

				$element.bind('click', function (event) {
					pixerfApiTracking.action_tracking({
						tracking: params
					})
                })
            })
			}
		};
	}
})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .filter('toTitleCase', toTitleCase);

    toTitleCase.$inject = ['stringUtils'];
    function toTitleCase(stringUtils) {
       	return function(input) {
			return stringUtils.toTitleCase(input)
		};
    }
})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .filter('toSnakeCase', toSnakeCase);

    toSnakeCase.$inject = ['stringUtils'];
    function toSnakeCase(stringUtils) {
       	return function(input) {
			return stringUtils.toSnakeCase(input)
		};
    }
})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .directive('title', title);
    title.$inject = ['$rootScope', '$timeout', 'notificationListSvc'];
    function title ($rootScope, $timeout, notificationListSvc) {
        return {
            link: function() {

                var listener = function(event, toState) {

                    $timeout(function() {
                        var title = (toState.data && toState.data.pageTitle) ? toState.data.pageTitle : 'Default title';
                        notificationListSvc.updatePageTitle(title);
                    });
                };

                $rootScope.$on('$stateChangeSuccess', listener);
            }
        };
    }
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('textareaAutoExpand', textareaAutoExpand);

	textareaAutoExpand.$inject = ['$timeout'];

	function textareaAutoExpand($timeout) {
		return {
			restrict: 'A',
			link: function (scope, element, attrs) {
				var $selectElement = $(element)[0];
				$selectElement.addEventListener('keydown', autosize);

				function autosize() {
					var el = this;
					$timeout(function () {
						el.style.cssText = 'height:' + el.scrollHeight + 'px';
					}, 0);
				}
			}
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('stepsNavigator', stepsNavigator);

	stepsNavigator.$inject = ['$timeout'];
	function stepsNavigator($timeout) {
		return {
			restrict: 'A',
			link: function (scope, element, attrs) {
				var $selectElement = $(element).find('select');
				var delay = attrs.delay ? parseInt(attrs.delay) : 0;
                $timeout(function() {
                    $selectElement.selectpicker();
                }, delay);
			}
		}
	}
})();

'use strict';
angular.module('slick', []).directive('slick', [
  '$timeout',
  function ($timeout) {
    return {
      restrict: 'AEC',
      scope: {
        initOnload: '@',
        data: '=',
        currentIndex: '=',
        accessibility: '@',
        adaptiveHeight: '@',
        arrows: '@',
        asNavFor: '@',
        appendArrows: '@',
        appendDots: '@',
        autoplay: '@',
        autoplaySpeed: '@',
        centerMode: '@',
        centerPadding: '@',
        cssEase: '@',
        customPaging: '&',
        dots: '@',
        draggable: '@',
        easing: '@',
        fade: '@',
        focusOnSelect: '@',
        infinite: '@',
        initialSlide: '@',
        lazyLoad: '@',
        onBeforeChange: '&?',
        onAfterChange: '&',
        onInit: '&',
        onBreakpoint: '&',
        onReInit: '&',
        onSetPosition: '&',
        pauseOnHover: '@',
        pauseOnDotsHover: '@',
        responsive: '=',
        rtl: '@',
        slide: '@',
        slidesToShow: '@',
        slidesToScroll: '@',
        speed: '@',
        swipe: '@',
        swipeToSlide: '@',
        touchMove: '@',
        touchThreshold: '@',
        useCSS: '@',
        variableWidth: '@',
        vertical: '@',
        verticalSwiping: '@',
        prevArrow: '@',
        nextArrow: '@',
        disable: "="
      },
      link: function (scope, element, attrs) {
        if(scope.disable) return;
        var destroySlick, initializeSlick, isInitialized;
        destroySlick = function () {
          return $timeout(function () {
            var slider;
            slider = $(element);
            slider.slick('unslick');
            slider.find('.slick-list').remove();
            return slider;
          });
        };
        initializeSlick = function () {
          return $timeout(function () {
            var currentIndex, customPaging, slider;
            slider = $(element);
            if (scope.currentIndex != null) {
              currentIndex = scope.currentIndex;
            }
            customPaging = function (slick, index) {
              return scope.customPaging({
                slick: slick,
                index: index
              });
            };
            slider.on('init', function (event, slick) {
              if (attrs.onInit) {
                scope.onInit({
                  slick: slick
                });
              }
              if (currentIndex != null) {
                return sl.slideHandler(currentIndex);
              }
            });

            slider.slick({
              accessibility: scope.accessibility !== 'false',
              adaptiveHeight: scope.adaptiveHeight === 'true',
              arrows: scope.arrows !== 'false',
              asNavFor: scope.asNavFor ? scope.asNavFor : void 0,
              appendArrows: scope.appendArrows ? $(scope.appendArrows) : $(element),
              appendDots: scope.appendDots ? $(scope.appendDots) : $(element),
              autoplay: scope.autoplay === 'true',
              autoplaySpeed: scope.autoplaySpeed != null ? parseInt(scope.autoplaySpeed, 10) : 3000,
              centerMode: scope.centerMode === 'true',
              centerPadding: scope.centerPadding || '50px',
              cssEase: scope.cssEase || 'ease',
              customPaging: attrs.customPaging ? customPaging : void 0,
              dots: scope.dots === 'true',
              draggable: scope.draggable !== 'false',
              easing: scope.easing || 'linear',
              fade: scope.fade === 'true',
              focusOnSelect: scope.focusOnSelect === 'true',
              infinite: scope.infinite !== 'false',
              initialSlide: scope.initialSlide || 0,
              lazyLoad: scope.lazyLoad || 'ondemand',
              beforeChange: attrs.onBeforeChange ? scope.onBeforeChange : void 0,
              onReInit: attrs.onReInit ? scope.onReInit : void 0,
              onSetPosition: attrs.onSetPosition ? scope.onSetPosition : void 0,
              pauseOnHover: scope.pauseOnHover !== 'false',
              responsive: scope.responsive || void 0,
              rtl: scope.rtl === 'true',
              slide: scope.slide || 'div',
              slidesToShow: scope.slidesToShow != null ? parseInt(scope.slidesToShow, 10) : 1,
              slidesToScroll: scope.slidesToScroll != null ? parseInt(scope.slidesToScroll, 10) : 1,
              speed: scope.speed != null ? parseInt(scope.speed, 10) : 300,
              swipe: scope.swipe !== 'false',
              swipeToSlide: scope.swipeToSlide === 'true',
              touchMove: scope.touchMove !== 'false',
              touchThreshold: scope.touchThreshold ? parseInt(scope.touchThreshold, 10) : 5,
              useCSS: scope.useCSS !== 'false',
              variableWidth: scope.variableWidth === 'true',
              vertical: scope.vertical === 'true',
              verticalSwiping: scope.verticalSwiping === 'true',
              prevArrow: scope.prevArrow ? $(scope.prevArrow) : void 0,
              nextArrow: scope.nextArrow ? $(scope.nextArrow) : void 0
            });
            slider.on('afterChange', function (event, slick, currentSlide) {
              if (scope.onAfterChange) {
                scope.onAfterChange({event: event, slick: slick, currentSlide: currentSlide});
              }
              if (currentIndex != null) {
                return scope.$apply(function () {
                  currentIndex = currentSlide;
                  return scope.currentIndex = currentSlide;
                });
              }
            });
            slider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
              if (scope.onBeforeChange) {
                scope.onBeforeChange({event: event, slick: slick, currentSlide: currentSlide, nextSlide: nextSlide});
              }
            });
            slider.on('breakpoint', function (event, slick, breakpoint) {
              if (scope.onBreakpoint) {
                scope.onBreakpoint({event: event, slick: slick, breakpoint: breakpoint});
              }
            });
            $(scope.appendDots).find('.slick-dots li button').on('click', function(e){
              e.stopPropagation(); // use this
            });
            return scope.$watch('currentIndex', function (newVal, oldVal) {
              if (currentIndex != null && newVal != null && newVal !== currentIndex) {
                return slider.slick('slickGoTo', newVal);
              }
            });
          });
        };
        if (scope.initOnload) {
          isInitialized = false;
          return scope.$watch('data', function (newVal, oldVal) {
            if (newVal != null) {
              if (isInitialized) {
                destroySlick();
              }
              initializeSlick();
              return isInitialized = true;
            }
          });
        } else {
          return initializeSlick();
        }
      }
    };
  }
]);
(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('signUpDirectly', signUpDirectly);
	signUpDirectly.$inject = ['$state', 'accountConst', 'signUpPersonalPopupSvc', 'signUpBusinessPopupSvc', 'signUpGuestPopupSvc'];

	function signUpDirectly($state, accountConst, signUpPersonalPopupSvc, signUpBusinessPopupSvc, signUpGuestPopupSvc) {
		return {
			restrict: 'A',
			scope: {
				signUpDirectly: '@'
			},
			priority: 100,
			link: function (scope, element, attrs) {
				element.bind('click', function (event) {
					if (scope.signUpDirectly === accountConst.ACCOUNT_TYPE.BUSINESS) {
						signUpBusinessPopupSvc.showPopup();
					} else if (scope.signUpDirectly === accountConst.ACCOUNT_TYPE.PERSONAL) {
						signUpPersonalPopupSvc.showPopup();
					} else {
						signUpGuestPopupSvc.showPopup(data);
					}
				})
			}
		}
	}
})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .directive('selection', selection);
    selection.$inject = ['$rootScope', '$timeout', 'systemUtils'];
    function selection($rootScope, $timeout, systemUtils) {
        return {
            scope: {
                method: '@',
                selection: "=",
                onSelected: '&',
                items: '=',
                selectionClick: '&'
            },
			link : function(scope, elem, attrs) {
                scope.selection = {};
                function selectFileInRange(elems, $start, $end, onSelectFn, startIndex, evt){
                    var model;
                    // var model;
                    //onSelectFn({evt: null, f: model.file,  isShiftHold: true});
                    var modelStart = angular.element($start).scope();
                    var modelEnd = angular.element($end).scope();
                    var isSelected = true;
                    if(modelStart.file.isSelected && modelEnd.file.isSelected) {
                        isSelected = false;
                    }
                    for (var k = startIndex ; k < elems.length; k ++){
                        model = angular.element(elems[k]).scope();
                        if($(elems[k]).attr("id") === $end.attr("id")){
                            onSelectFn({f: model.file, isSelected: isSelected});
                            return;   
                        }
                        onSelectFn({f: model.file, isSelected: isSelected});
                    }
                }
                scope.$watchCollection("items", function(){
                    $timeout(function(){
                    
                        var $elem = $(elem);
                        var elems = $elem.find("[data-selection-member]");
                        elems.off("click.pixerf.selection");
                        for (var i =0; i < elems.length; i ++){
                            (function(index){
                                $(elems[index]).on("click.pixerf.selection", function(evt){
                                    if(!evt.shiftKey || evt.ctrlKey) {
                                        scope.selection.$start = $(this);
                                    } else {
                                        systemUtils.preventTextSelection();
                                        scope.selection.$end = $(this);  
                                        var model;

                                        if(scope.selection.$start.attr("id") === scope.selection.$end.attr("id")){
                                            return;
                                        }
                                        for (var j = 0; j < elems.length; j ++){
                                            var $elmtJ = $(elems[j]);
                                            if($elmtJ.attr("id") === scope.selection.$start.attr("id")){
                                                selectFileInRange(elems, $elmtJ, scope.selection.$end, scope.onSelected, j, evt);
                                                break;
                                            }
                                            if($elmtJ.attr("id") === scope.selection.$end.attr("id")){
                                                selectFileInRange(elems, $elmtJ, scope.selection.$start, scope.onSelected, j, evt);
                                                break;
                                            }
                                        }
                                        scope.selection.$start = $(this);
                                    }
                                })
                            })(i)
                        }
                    })
                })

			}
		};
    }
})();                                                                  
(function () {
    'use strict';

    angular
        .module('pixerf')
        .filter('searchStringFilter', searchStringFilter);

    searchStringFilter.$inject = [];
    function searchStringFilter() {
        return function (items, searchText, comparedProperty) {
            var filtered = [];
            if(searchText){
                angular.forEach(items, function (item) {
                    if (item[comparedProperty].indexOf(searchText) >= 0) filtered.push(item);
                });
                return filtered;
            }
            return items;
        };
    }
})();

(function (angular) {
    'use strict';
    function updateScrollToFix(scope, $element, shouldFix, scrollToFixedOptions){
        if ($.isScrollToFixed($element) && !shouldFix){
            $element.trigger('detach.ScrollToFixed');
            $element.attr("style","");
        } else if(!$.isScrollToFixed($element) &&  shouldFix){
            $element.scrollToFixed(scope.$eval(scrollToFixedOptions));
        }
    }
    function scrollToFixed($rootScope, $timeout, systemUtils) {
        return {
            'require': '?ngModel',
            'restrict': 'A',
            'link': function link(scope, element, attrs) {
                var $element = $(element);
                var shouldFix = !$rootScope.isScreenMobile;
                if(attrs.scrollToFixedWhen){
                    var responsive = scope.$eval(attrs.scrollToFixedWhen);
                    shouldFix = systemUtils.getViewportDimension().width >= responsive.minWidth;
                }
                if(shouldFix){
                    $element.scrollToFixed(scope.$eval(attrs.scrollToFixed));
                }

                $(window).on("resize.pixerfScrollToFixed", (function () {
                    $element = $(element);
                    shouldFix = !$rootScope.isScreenMobile;
                    if(attrs.scrollToFixedWhen){
                        var responsive = scope.$eval(attrs.scrollToFixedWhen);
                        shouldFix = systemUtils.getViewportDimension().width >= responsive.minWidth;
                    }
                    updateScrollToFix(scope, $element, shouldFix, attrs.scrollToFixed);
                }));

                if (attrs.ngModel) {
                    scope.$watch(attrs.ngModel, function watchNgModel() {
                        $element.trigger('resize.ScrollToFixed');
                    }, true);
                }

                $element.bind('update', function update() {
                    $element.trigger('resize.ScrollToFixed');
                });

                $element.bind('$destroy', function destroy() {
                    $element.trigger('detach.ScrollToFixed');
                });
            },
        };
    }

    angular
        .module('scrollToFixed', [])
        .directive('scrollToFixed', scrollToFixed);
})(window.angular);

(function() {
    'use strict';

    angular
        .module('pixerf')
        .directive('scroll', scroll);
    scroll.$inject = ['$rootScope'];
    function scroll($rootScope) {
        return {
			link : function(scope, elem, attrs) {
				var $window = $(window);
				var handler = function(){
					if ($rootScope.$$phase) {
						return scope.$eval(attrs.scroll);
					} else {
						return scope.$apply(attrs.scroll);
					}
				};
				var destroyedHandler = function(){
					if ($rootScope.$$phase) {
						return scope.$eval(attrs.scrollDestroyed);
					} else {
						return scope.$apply(attrs.scrollDestroyed);
					}
				};

				var eventName = 'scroll.pixerf-scroll' + new Date().getTime();

				$window.on(eventName, function(){
					handler();
				});
				
				scope.$on('$destroy', function() {
					destroyedHandler();
					$window.off(eventName);
					//return $window.off('scroll');
				});
				
			}
		};
    }
})();                                                                  
(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('scrollToElement', scrollToElement);

	scrollToElement.$inject = [];

	function scrollToElement($timeout, toastr) {
		return {
			restrict: 'A',
			scope: {
				scrollToElement: "="
			},
			link: function (scope, element, attr) {
				scope.$watch("scrollToElement", function (newValue, oldValue) {
					if (newValue !== oldValue) {
						var scrollTop = $(element).offset().top;
						var $naviBar = $(".pixerf-navigation-bar");
						var $headerBar = $(".header");
						var naviBarHeight = $naviBar.is(":visible") && scrollTop > $naviBar.offset().top ? $naviBar.height() : 0;
						var headerBarHeight = $headerBar.height();
						if (attr.offsetTop) {
							$("html, body").stop().animate({
								scrollTop: $(element).offset().top - parseInt(attr.offsetTop)
							}, '500', 'swing');
						} else {
							$("html, body").stop().animate({
								scrollTop: $(element).offset().top - naviBarHeight - headerBarHeight
							}, '500', 'swing');
						}
					}
				})
			}
		};
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('scrollSpy', scrollSpy);
	scrollSpy.$inject = ['$timeout'];

	function scrollSpy($timeout) {
		return {
			restrict: "AC",
			link: function (scope, element, attr) {
				var menuItems = [];
				var config = {
					offset: 0,
					duration: 500
				};
				var userConfig = scope.$eval(attr.scrollSpy);
				var namespace = "scroll-" + moment().unix();
				angular.extend(config, userConfig);


				var scrollTo = function (event) {
					event.preventDefault();
					var target = $(event.target.hash);

					$('body').animate({
						scrollTop: target.offset().top - Number(config.offset) + 1
					}, config.duration);
				}

				//bind click events of menu items
				var setup = function () {
					angular.forEach(element.find('a'), function (el) {
						var self = $(el);
						var target = $(self.attr('href'));
						if (target.length) {
							self.click(scrollTo);
							menuItems.push({
								self: self,
								target: target
							});
						}
					});
				}

				$timeout(setup, 0);

				// Bind to scroll
				$(window).on('scroll.' + namespace, function () {
					var winTop = $(self).scrollTop() + Number(config.offset);
					var current = menuItems[0];

					angular.forEach(menuItems, function (item) {
						item.fromTop = item.target.offset().top - winTop;
						if (item.fromTop < 0)
							current = item;
					});

					angular.forEach(menuItems, function (item) {
						if (item === current) {
							item.self.addClass('active');
							if(attr.scrollSpyId){
								scope.$emit(attr.scrollSpyId + item.self[0].hash);
							}
						} else {
							item.self.removeClass('active');
						}
					});

				});

				scope.$on('$destroy', function () {
					$(window).unbind('scroll.' +  namespace);
				});
			}
		}
	}
})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .directive('scaleImage', scaleImage);
    scaleImage.$inject = ['$parse', 'pathUtils', '$timeout'];

    function scaleImage($parse, pathUtils, $timeout) {
        return function(scope, element, attrs) {
            var $element = $(element);
            $element.css("opacity", 0);
            $element.on('bestfit', function() {
                var css;
                var ratio = $(this).width() / $(this).height();
                var pratio = $(this).parent().width() / $(this).parent().height();
                if (ratio < pratio) css = { width: 'auto', height: '100%' };
                else css = { width: '100%', height: 'auto' };
                $(this).css(css);
                if(attrs.updateRelativeElmt){
                    $timeout(function(){
                        $(attrs.updateRelativeElmt).css({
                            width: $element.width(),
                            height: $element.height(),
                        });
                    })
                }
            }).on('load', function() {
                $element.css("opacity", 1);
                $(this).trigger('bestfit');
            }).on('error', function() {
                $element.css("opacity", 1);
            }).trigger('bestfit');
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('pixerf')
        .directive('routeBy', routeBy);
    routeBy.$inject = ['sessionManagerSvc', '$state', 'accountConst'];
    function routeBy(sessionManagerSvc, $state, accountConst) {
        return {
            restrict: 'A',
            scope: {
                routeByType: '=',
                routeStrict: "@"
            },
            priority: 100,
            link: function (scope, element, attrs) {
                element.bind('click', function (event) {
                    var mLoginnedUser = sessionManagerSvc.getCurrentLoginUser().data;
                    var defaultRoute = scope.routeByType.default ? scope.routeByType.default : Object.keys(scope.routeByType)[0];
                    var isExistRouteForType = mLoginnedUser && mLoginnedUser.account_type ? scope.routeByType.hasOwnProperty(mLoginnedUser.account_type) : false;
                    if (scope.routeByType && !mLoginnedUser) {
                        $state.go(scope.routeByType[defaultRoute]);
                    } else if (isExistRouteForType && scope.routeByType) {
                        $state.go(scope.routeByType[mLoginnedUser.account_type]);
                    } else if (!isExistRouteForType && !scope.routeStrict){
                        $state.go(scope.routeByType[defaultRoute]);
                    }
                })
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('pixerf')
        .directive('repeatCompleteEmitter', repeatCompleteEmitter);
    repeatCompleteEmitter.$inject = ['$state'];
    function repeatCompleteEmitter($state) {
        return {
            restrict: "A",
            link: function(scope, element, attrs) {
                if (scope.$last){
                    scope.$emit('repeatCompleteEmitter_last_item');
                }
            }
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('pixerf')
        .directive('redirectToProfile', redirectToProfile);

    redirectToProfile.$inject = ['$state', 'accountConst'];

    function redirectToProfile($state, accountConst) {
        return {
            restrict: 'A',
            scope: {
				redirectToProfile: "="
            },
            link: function(scope, element) {
				var userProfile = scope.redirectToProfile;
				if(!userProfile){
					return ;
				}
				element.bind('click', function() {
					if (userProfile.account_type === accountConst.ACCOUNT_TYPE.PERSONAL) {
						$state.go("user-home-page.personal.home", {id: userProfile.id});
					}else if (userProfile.account_type === accountConst.ACCOUNT_TYPE.BUSINESS) {
						$state.go("user-home-page.business.communities.grid", {id: userProfile.id});
					} else {
						$state.go("user-home-page.guest.home", {id: userProfile.id});
					}
				});
            }
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .directive('preventParentScroll', preventParentScroll);
    preventParentScroll.$inject = ['$rootScope'];
    function preventParentScroll($rootScope) {
        return {
			link : function(scope, elem, attrs) {
				$(document).on('DOMMouseScroll mousewheel', '.pixerf-scrollable-but-not-parent', fn);

				function fn(ev) {
					var $this = $(this),
						scrollTop = this.scrollTop,
						scrollHeight = this.scrollHeight,
						height = $this.innerHeight(),
						delta = (ev.type == 'DOMMouseScroll' ?
							ev.originalEvent.detail * -40 :
							ev.originalEvent.wheelDelta),
						up = delta > 0;

					var prevent = function() {
						ev.stopPropagation();
						ev.preventDefault();
						ev.returnValue = false;
						return false;
					}
					if (!up && -delta > scrollHeight - height - scrollTop) {
						// Scrolling down, but this will take us past the bottom.
						$this.scrollTop(scrollHeight);
						return prevent();
					} else if (up && delta > scrollTop) {
						// Scrolling up, but this will take us past the top.
						$this.scrollTop(0);
						return prevent();
					}
				}
			}
		};
    }
})();                                                                  
(function() {
    'use strict';

    angular
        .module('pixerf')
        .directive('popupLinkClicked', popupLinkClicked);
    popupLinkClicked.$inject = ['$uibModalStack', '$location', 'systemUtils'];
    function popupLinkClicked($uibModalStack, $location, systemUtils) {
        return {
            restrict: 'A',
            scope: {
                popupLinkClicked: '@'
            },
            link: function(scope, element, attr) {
                element.bind('click', function() {
                    $uibModalStack.dismissAll("link clicked");
                    if(scope.popupLinkClicked){
                        $location.path(scope.popupLinkClicked);
                    }
                    systemUtils.digest(scope);
                })
            }
          }
        }
})();                                                                  
(function() {
    'use strict';

    angular
        .module('pixerf')
        .directive('pixerfUserAvatarStyle', pixerfUserAvatarStyle);
    pixerfUserAvatarStyle.$inject = ['accountConst'];
    function pixerfUserAvatarStyle(accountConst) {
        return {
            scope: {
                pixerfUserAvatarStyleUser: '=',
                pixerfUserAvatarStylePersonClass: '@',
                pixerfUserAvatarStyleBusinessClass: '@'
            },
            restrict: 'A',
            link : function(scope, elem, attrs) {
                var $elem = $(elem);
                var personClass = scope.personClass ? scope.pixerfUserAvatarStylePersonClass : 'img-circle';
                var businessClass = scope.businessClass ? scope.pixerfUserAvatarStyleBusinessClass : '';
                if(scope.pixerfUserAvatarStyleUser.account_type === accountConst.ACCOUNT_TYPE.PERSONAL){
                    if(!$elem.hasClass(personClass)){
                        $elem.addClass(personClass);
                    } else {
                        $elem.removeClass(personClass);
                    }
                } else if(scope.pixerfUserAvatarStyleUser.account_type === accountConst.ACCOUNT_TYPE.BUSINESS){
                    if(!$elem.hasClass(businessClass)){
                        $elem.addClass(businessClass);
                    } else {
                        $elem.removeClass(businessClass);
                    }
                }
            }
        };
    }
})();                                                                  
(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('pixerfTruncateText', pixerfTruncateText);

	pixerfTruncateText.$inject = ["$timeout", "$window"];

	function pixerfTruncateText($timeout, $window) {

		var directive = {
			scope: {
				pixerfTruncateText: "="
			},
			restrict: 'A',
			link: function ($scope, element, attrs) {
				var $element = $(element);
				$scope.width = $window.innerWidth;

				$timeout(function () {
					$element.dotdotdot($scope.pixerfTruncateText);
				});

				function onResize() {
					if ($scope.width != $window.innerWidth) {
						$scope.width = $window.innerWidth;
						$element.dotdotdot($scope.pixerfTruncateText);
						$scope.$digest();
					}
				};

				function cleanUp() {
					angular.element($window).off('resize', onResize);
				}

				angular.element($window).on('resize', onResize);
				$scope.$on('$destroy', cleanUp);
			}
		};
		return directive;
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('pixerfSelect', pixerfSelect);

	pixerfSelect.$inject = ['$timeout', 'toastr'];
	function pixerfSelect($timeout, toastr) {
		return {
			restrict: 'A',
			scope: {
				onChanged: "&?",
				classAdded: "@",
				model: '=?'
			},
			link: function (scope, element, attrs) {
				var $selectElement = $(element).find('select');
				var delay = attrs.delay ? parseInt(attrs.delay) : 0;
				var lastSelectedItems = []
				var messageTextOnPririty = '';
				var maxOptionsOnPririty= null
				var signSelectedOptionsOnInit = false;
				function compareItem(from, to){
					return ( (from === to) ||((from + 'FAKE') === to) || (from === (to + 'FAKE')));
				}
				function isSelectedValue(searchValue, options){
					return _.find(options, function (o) { return  compareItem(o, searchValue) });
				}
				function updateDdlSelected(selectedList, isNewValue, item){
					var result = [];
					if(!selectedList) return result;
					selectedList = _.uniq(selectedList);
					for(var i = 0; i < selectedList.length; i++){
						if(!isNewValue && item && compareItem(selectedList[i], item)){
							continue;
						}
						if(selectedList[i].indexOf("FAKE") !== -1){
							result.push(selectedList[i]);
							result.push(selectedList[i].replace('FAKE', ""));
						}else{
							result.push(selectedList[i]);
							result.push(selectedList[i] + 'FAKE');
						}
					}
					result = _.uniq(result);
					return result;
				}
				function trimSelectedValue(selectedList){
					var result = [];
					if(!selectedList) return result;
					for(var i = 0; i < selectedList.length; i++){
						var id = selectedList[i].replace('FAKE', "")
						result.push(id);
					}
					result = _.uniq(result);
					return result;
				}
				function filterSelectedValue(selectedList){
					var result = [];
					var selectOptions = $selectElement[0];
					var selectedItems = trimSelectedValue(selectedList);
					for (var i = 0; i < selectOptions.length; i++) {
						for (var j = 0; j < selectedItems.length; j++)
							if (selectOptions[i].value == selectedItems[j]) {
								var option = { id: selectOptions[i].value, name: selectOptions[i].text };
								result.push(option);
							}
					}
					result = _.uniq(result);
					return result;
				}
				function updateSelectedTextToDll(selectedList){
					var textArr = [];
					var options = attrs.pixerfSelect ? JSON.parse(attrs.pixerfSelect) : '';
					for(var i = 0; i < selectedList.length; i++){
						textArr.push(selectedList[i].name);
					}
					textArr = _.uniq(textArr);
					var el = attrs.$$element.find('.dropdown-toggle')[0];
					if(!el) return;
					var selectBtn = el.getElementsByClassName('filter-option')[0];
					if(!selectBtn) return;

					el.title = textArr.join(', ');
					if(!textArr.length){
						selectBtn.innerHTML = options.noneSelectedHtml;
					}else{
						selectBtn.innerText = textArr.join(', ');
					}
				}

                $timeout(function() {
					var options = attrs.pixerfSelect ? JSON.parse(attrs.pixerfSelect) : '';
					var tmpEle = 0;
					if(options.maxOptionsText && !options.showPriority){
						var messageText = options.maxOptionsText;
						options.maxOptionsText = function(num, group){
							if(event && event.target && options.customAll){
								var element = event.target;
								if(element.innerText == "All Countries"){
									$selectElement.selectpicker('deselectAll');
									scope.$parent.model = [];
									
									setTimeout(function () {
										$selectElement.selectpicker('val', 'all');
										scope.$parent.model.push({id: 'all', name: 'All Countries'});
										scope.onChanged();
									}, 100);
									return ['',''];
								}
							}
							if(num || group){
								toastr.error(messageText);
							}
							return [' ',' '];
						}
					}
					if(options.showPriority){

						scope.$watch('model', function (data) {
							if(data.length) return;
							setTimeout(function () {
								$selectElement.selectpicker('val', '');
								lastSelectedItems = [];
								var el = attrs.$$element.find('.dropdown-toggle')[0];
								if(!el) return;
								var selectBtn = el.getElementsByClassName('filter-option')[0];
								if(!selectBtn) return;
								el.title = options.noneSelectedText;
								selectBtn.innerHTML = options.noneSelectedHtml;
							}, 100);
						}, true)

						messageTextOnPririty = options.maxOptionsText;
						maxOptionsOnPririty = options.maxOptions;
						options.maxOptions++;
						var selectOptions = $selectElement[0];
						if(!selectOptions.length) return;
						var lineBreakEle = _.find(selectOptions, function (o) { return o.value === 'lineBreak'; });
						if(!lineBreakEle) return;
						lineBreakEle.disabled = true;
						lineBreakEle.classList.add("select-line-break");
						setTimeout(function () {
							var el = attrs.$$element.find('.dropdown-toggle')[0];
							if(!el) return;
							var selectBtn = el.getElementsByClassName('filter-option')[0];
							if(!selectBtn) return;
							if(selectBtn.innerText.trim() == options.noneSelectedText.trim()){
								el.title = options.noneSelectedText;
								selectBtn.innerHTML = options.noneSelectedHtml;
							}
						}, 100);
					}

					$selectElement.selectpicker(options);
					if(scope.onChanged){
						$selectElement.on("changed.bs.select", function(event, clickedIndex, newValue, oldValue){
							var selectedValue = $(this).val();
							if(options.customAll && newValue && clickedIndex === 0 && !options.showPriority){
								$selectElement.selectpicker('deselectAll');
								$selectElement.selectpicker('val', 'all');
							} else if(options.customAll && event.target[0].selected && !options.showPriority) {
								scope.$parent.model.shift();
								var selectedItem = {id:event.currentTarget[clickedIndex].value, name: event.currentTarget[clickedIndex].label};
								$selectElement.selectpicker('val', event.currentTarget[clickedIndex].value);
								if(!scope.$parent.model[0] ||scope.$parent.model[0].val != selectedItem.val){
									scope.$parent.model.push(selectedItem);
								}
							}
							else if( options.showPriority && selectedValue) {
								var selectedItem = {id:event.currentTarget[clickedIndex].value, name: event.currentTarget[clickedIndex].label};
								var isNewValue = !isSelectedValue(selectedItem.id, lastSelectedItems);
								if(isNewValue && filterSelectedValue(lastSelectedItems).length >= maxOptionsOnPririty){
									toastr.error(messageTextOnPririty);
									selectedValue = (lastSelectedItems ? lastSelectedItems : selectedValue);
									isNewValue = false;
								}
								selectedValue = updateDdlSelected(selectedValue, isNewValue, selectedItem.id);
								lastSelectedItems = selectedValue;
								$selectElement.selectpicker('val', selectedValue);

								$timeout(function () { 
									scope.$parent.model = filterSelectedValue(selectedValue);
									updateSelectedTextToDll(scope.$parent.model);
									$timeout(function () { 
										scope.onChanged();
									}, 0);
								}, 0);
							}
							if(options.radioType && !newValue){
								$selectElement.selectpicker('val', tmpEle);
							}
							scope.onChanged();
						})
						$selectElement.on("show.bs.select", function(event, clickedIndex){
							if(options.radioType){
								tmpEle = event.currentTarget.value;
							}
							if(options.showPriority && !signSelectedOptionsOnInit){
								signSelectedOptionsOnInit = true;
								var selectedValue = $(this).val();
								selectedValue = updateDdlSelected(selectedValue, false, null);
								lastSelectedItems = selectedValue;
								$selectElement.selectpicker('val', selectedValue);
								updateSelectedTextToDll(scope.$parent.model)
							}
						})
					}
					if(scope.classAdded){
						$selectElement.addClass(scope.classAdded).selectpicker('setStyle')
					}
					
                }, delay);
			}
		}
	}
})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .directive('pixerfScrollSpy', pixerfScrollSpy);
    pixerfScrollSpy.$inject = ['$timeout', 'systemUtils'];
    function pixerfScrollSpy($timeout, systemUtils) {

        return {
            restrict: 'A',
            link : function(scope, elem, attrs) {
                $timeout(function(){
                    if(attrs.pixerfScrollSpy){
                        var $elem = $(elem);
                        var scrollSpyId = $elem.attr("scroll-spy-id");
                        var scrollDirection = $elem.attr("pixerf-scroll-spy-direction");
                        var isFirstSpyItem = $elem.attr("is-first-spy-item");
                        var isLastSpyItem = $elem.attr("is-last-spy-item");
                        var lastScrollTop = 0;
                        var isScrollUp = false;
                        var $window = $(window);
                        $window.off("scroll.pixerfScrollSpy" + scrollSpyId);
                        $window.on("scroll.pixerfScrollSpy" + scrollSpyId, function(event){
                            if(!$elem.is(":visible")){
                                $window.off("scroll.pixerfScrollSpy" + scrollSpyId);
                                return;
                            }
                            var currentScrollTop = $(this).scrollTop();
                            isScrollUp = (currentScrollTop <= lastScrollTop);
                            lastScrollTop = currentScrollTop;

                            if((isScrollUp && scrollDirection === "up") || (!isScrollUp && scrollDirection === "down") || scrollDirection === "both"){
                                var windowHeight = $window.height();
                                var scrollTop = $window.scrollTop();
                                var eleHeight = $elem.height();
                                var y = $elem.offset().top  - scrollTop;
                                var max = windowHeight;
                                var min = windowHeight - $elem.height()/2;
                                var isTop =  scrollTop === 0;
                                var isBottom = scrollTop + windowHeight == $(document).height();
                                if((isTop && isFirstSpyItem) || (isBottom && isLastSpyItem)){
                                    scope.$eval(attrs.pixerfScrollSpy);
                                    systemUtils.digest(scope);
                                } else {
                                    if(y < max  &&  y > min) {
                                        scope.$eval(attrs.pixerfScrollSpy);
                                        systemUtils.digest(scope);
                                    }
                                }
                            }
                        });
                        
                    }
                });
            }
        };
    }
})();
(function() {
    'use strict';

    angular
        .module('pixerf')
        .directive('pixerfPersonLevel', pixerfPersonLevel);

    pixerfPersonLevel.$inject = ['stringUtils', 'accountConst'];
    function pixerfPersonLevel(stringUtils, accountConst) {
        return {
            restrict: "A",
			scope: {
				person: "="
			},
			link: function(scope, element, attrs) {
                var titleString = "";
                if(scope.person.account_type === accountConst.ACCOUNT_TYPE.BUSINESS){
                    titleString = "Business";
                } else if(scope.person.account_type === accountConst.ACCOUNT_TYPE.PERSONAL) {
                    titleString = stringUtils.toTitleCase(!!scope.person.ambassadorship ? ('Ambassador ' + scope.person.ambassadorship) : 'Pixerfer')
                } else {
                    titleString = "Guest User";
                }
                element.html(titleString);
			}
		}
    }
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('pixerfCountDown', pixerfCountDown);
	pixerfCountDown.$inject = ['$rootScope', '$interval', 'dateUtils', '$translate'];

	function pixerfCountDown($rootScope, $interval, dateUtils, $translate) {
		return {
			restrict: 'E',
			replace: true,
			scope: {
				deadline: "=",
				text: '=?',
				hideTimming: "@",
				showTimeOnly: "@",
				blinkClass: '@'
			},
			template: '<div ng-bind="isFinished ? text : countDown"></div>',
			link: function ($scope, element, attrs) {
				$scope.text = $scope.text ? $scope.text : 'closed';
				var closeKey = $scope.text.toLowerCase();
				$scope.text = $translate.instant(closeKey);

				$rootScope.$on('$translateChangeSuccess', function (event, current, previous) {
					$scope.text = $translate.instant(closeKey);
				})

				runMissionCountDown();

				function runMissionCountDown() {
					var endDateMoment = moment($scope.deadline + " 00:00:00", "YYYY-MM-DD HH:mm:ss");
					var blinkClass = $scope.blinkClass ? $scope.blinkClass : 'text--color-pixerf-theme';
					var step = 1000;
					var countDownInterval = $interval(function () {
						var duration = moment.duration(dateUtils.countDown(endDateMoment, step), 'milliseconds');
						if (duration < 0) {
							$scope.isFinished = true;
							$interval.cancel(countDownInterval);
							return;
						}
						var mn = duration.minutes();
						var sc = duration.seconds();
						var durationDay = Math.floor(duration.asDays());
						var dayText = durationDay > 1 ? "days" : "day";
						var dayKey = dayText;
						dayText = $translate.instant(dayKey).toLowerCase();
						if ($scope.hideTimming) {
							$scope.countDown = durationDay + " " + dayText + " left";
						} else if ($scope.showTimeOnly) {
							$scope.countDown = duration.hours() + ":" + (mn > 9 ? mn : "0" + mn) + ":" + (sc > 9 ? sc : "0" + sc);
						} else {
							$scope.countDown = durationDay + " " + dayText + " " + duration.hours() + ":" + (mn > 9 ? mn : "0" + mn) + ":" + (sc > 9 ? sc : "0" + sc);
						}
						if (duration.hours() < 1 && durationDay === 0) {
							element.hasClass(blinkClass) ? element.removeClass(blinkClass) : element.addClass(blinkClass);
						}
					}, step);
				}
			}
		}
	}
})();

(function() {
	'use strict';

	angular
	.module('pixerf')
	.directive('pixerfCloseOnClick', pixerfCloseOnClick);
	pixerfCloseOnClick.$inject = [];
	function pixerfCloseOnClick() {
		return {
			restrict: 'A',
			scope: {
				pixerfCloseOnClick: "@"
			},
			link: function(scope, element, attr) {
				element.bind('click', function(event) {
					if(scope.pixerfCloseOnClick){
						$("body").trigger("click");
						event.stopPropagation();
					}
				})
			}
		}
	}
})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .directive('pixerfBlink', pixerfBlink);
    pixerfBlink.$inject = ['$rootScope', '$interval'];
    function pixerfBlink($rootScope, $interval) {
		return {
			scope: {
				pixerfBlink: "=",
				pixerfBlinkClass: "@"
			},
			link: function($scope, element, attrs) {

				var timeoutId;
				function blink() {
					element.hasClass($scope.pixerfBlinkClass) ? element.removeClass($scope.pixerfBlinkClass) : element.addClass($scope.pixerfBlinkClass);
				}
				$scope.$watch("pixerfBlink", function(newValue){
					if(newValue){
						timeoutId = $interval(function() {
							blink();
						}, 1000);
					} else {
						$interval.cancel(timeoutId);	
					}

				})
				
				element.on('$destroy', function() {
					$interval.cancel(timeoutId);
				});
			}
		}
    }
})();                                                                  
(function() {
    'use strict';

    angular
        .module('pixerf')
        .directive('pixerfBackgroundDelay', pixerfBackgroundDelay);
    pixerfBackgroundDelay.$inject = ['$timeout', 'numberUtils', '$rootScope'];
    function pixerfBackgroundDelay($timeout, numberUtils, $rootScope) {
        return {
            link : function(scope, elem, attrs) {
                if(attrs.pixerfBackgroundDelay){
                    $rootScope.delayTime === 20 ? $rootScope.delayTime = 0 : _.noop ;
                    $rootScope.delayTime ? $rootScope.delayTime ++ : $rootScope.delayTime = 1;
                    var delayTime = $rootScope.delayTime;
                    $timeout(function(){
                        if(elem.prop("tagName") === "img"){
                            elem.attr("src", attrs.pixerfBackgroundDelaySrc);
                        } else{
                            elem.css({ backgroundImage: 'url("' + attrs.pixerfBackgroundDelaySrc + '")' });
                        }
                    }, delayTime*200);
                } else {
                    if(elem.prop("tagName") === "img"){
                        elem.attr("src", attrs.pixerfBackgroundDelaySrc);
                    } else{
                        elem.css({ backgroundImage: 'url("' + attrs.pixerfBackgroundDelaySrc + '")' });
                    }
                }
            }
        };
    }
})();                                                                  
(function() {
    'use strict';

    angular
        .module('pixerf')
        .directive('pixerfAttr', pixerfAttr);
    pixerfAttr.$inject = [];
    function pixerfAttr() {
        return {
            link : function(scope, elem, attrs) {
                var selector = attrs.selector;
                var handler = function (event) {
                    if(event.which === 13) {
                        scope.$apply(function (){
                            scope.$eval(attrs.pixerfAttr);
                        });
                        event.preventDefault();
                    }
                }
                if(selector){
                   $(elem).on("keydown keypress", selector, handler);
                } else {
                    $(elem).on("keydown keypress", handler);
                }
            }
        };
    }
})();                                                                  
(function() {
    'use strict';

    angular
        .module('pixerf')
        .directive('photoFitOverlay', photoFitOverlay);
    photoFitOverlay.$inject = ['$parse', 'pathUtils', '$timeout'];

    function photoFitOverlay($parse, pathUtils, $timeout) {
        return function(scope, element, attrs) {
            var $element = $(element);
            var $img = $element.find("img");
            var $backgroundCover = $element.find(".background-cover");

            $img.on('bestfit', function() {
                var realImgRate = $img[0].naturalWidth / $img[0].naturalHeight;
                var imgTagRate = $img.width() / $img.height();
                if(realImgRate < imgTagRate){
                    $backgroundCover.width($img.height()*$img[0].naturalWidth/$img[0].naturalHeight);
                    $backgroundCover.height($img.height());
                } else {
                    $backgroundCover.width($img.width());
                    $backgroundCover.height($img.width()*$img[0].naturalHeight/$img[0].naturalWidth);
                }
            }).on('load', function() {
                $(this).trigger('bestfit');
            }).trigger('bestfit');

            scope.$watch(attrs.watchSize, function (newVal, oldVal) {
                $timeout(function(){
                    $img.trigger('bestfit');
                });
            }, true);

            $(window).on("resize.overlayFit", _.debounce(function () {
                $timeout(function(){
                    $img.trigger('bestfit');
                });
            }, 400));

            element.on('$destroy', function(){
                $(window).off("resize.overlayFit");
            });
        }
    }
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('photoDetailsOnClick', photoDetailsOnClick);
	photoDetailsOnClick.$inject = ['pixerfApiMediaSvc', 'photoDetailPopupSvc'];

	function photoDetailsOnClick(pixerfApiMediaSvc, photoDetailPopupSvc) {
		return {
			restrict: 'A',
			scope: {
				photoDetailsOnClick: "@"
			},
			link: function (scope, element, attr) {
				if (scope.photoDetailsOnClick) {
                    element.addClass("cursor--pointer");
					element.bind('click', function (event) {
						pixerfApiMediaSvc.get({
							id: scope.photoDetailsOnClick
						}).$promise.then(function (response) {
							photoDetailPopupSvc.showPopup({
								photo: response.data
							});
						})
					})
				}
			}
		}
	}
})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .filter('particalHide', particalHide);

        particalHide.$inject = ['numberUtils'];
    function particalHide(numberUtils) {
       	return function (text, pattern) {
            console.log(arguments);
            if(pattern === 'AAAxxxBBB'){
                var numberFirstLetter = 3;
                var numberLastLetter = 3;
                var firstText = text.substr(0, numberFirstLetter);
                var lastText = text.substr(text.length - numberLastLetter);
                var textReplaced = text.substr(numberFirstLetter, text.length - (numberFirstLetter + numberLastLetter)).replace(/[^\-]/g, '*');
                return firstText + textReplaced + lastText;
            } else {
                return text;
            }
           
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .directive('parseInteger', parseInteger);
    parseInteger.$inject = [];
    function parseInteger() {
        return {
            require: 'ngModel',
                link: function(scope, ele, attr, ctrl){
                    ctrl.$parsers.unshift(function(viewValue){
                        return parseInt(viewValue, 10);
                    });
                }
            };
    }
})();                                                                  
(function() {
    'use strict';

    angular
        .module('pixerf')
        .directive('onWindowResizeEvent', onWindowResizeEvent);
    onWindowResizeEvent.$inject = ['$window'];
    function onWindowResizeEvent($window) {
        return {
            link : function(scope, elem, attrs) {
				var id = new Date().getTime();
				var eventName = 'resize.onWindowResizeEvent' + id;
                $(window).on(eventName, function () {
                    scope.$apply(function (){
                        scope.$eval(attrs.onWindowResizeEvent);
                    });
                });
                scope.$on('$destroy',  function(){
                    $(window).off(eventName);
                });
            }
        };
    }
})();                                                                  
(function() {
    'use strict';

    angular
        .module('pixerf')
        .directive('onOrientationChangeEvent', onOrientationChangeEvent);
    onOrientationChangeEvent.$inject = ['$window'];
    function onOrientationChangeEvent($window) {
        return {
            link : function(scope, elem, attrs) {
                var id = new Date().getTime();
				var eventName = 'orientationchange.onOrientationChangeEvent' + id;
                $(window).on(eventName, function () {
                    
                    scope.$apply(function (){
                        scope.$eval(attrs.onOrientationChangeEvent);
                    });
                });
                scope.$on('$destroy',  function(){
                    $(window).off(eventName);
                });
            }
        };
    }
})();                                                                  
(function() {
    'use strict';

    angular
        .module('pixerf')
        .filter('normalizeLocation', normalizeLocation);

    normalizeLocation.$inject = ['accountUtils'];
    function normalizeLocation(accountUtils) {
       	return function(input) {
			return accountUtils.refineUserGoogleLocation(input)
		};
    }
})();

(function(){
    var ngDragEventDirectives = {};

    angular.forEach(
        'drag dragend dragenter dragexit dragleave dragover dragstart drop'.split(' '),
        function(eventName) {
            var directiveName = 'ng' + eventName.charAt(0).toUpperCase() + eventName.slice(1);

            ngDragEventDirectives[directiveName] = ['$parse', '$rootScope', function($parse, $rootScope) {
                return {
                    restrict: 'A',
                    compile: function($element, attr) {
                        var fn = $parse(attr[directiveName], null, true);

                        return function ngDragEventHandler(scope, element) {
                            element.on(eventName, function(event) {
                                var callback = function() {
                                    fn(scope, {$event: event});
                                };

                                scope.$apply(callback);
                            });
                        };
                    }
                };
            }];
        }
    );

    angular
        .module('ngDrag', [])
        .directive(ngDragEventDirectives);
}());
(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    define(['quill'], factory)
  } else if (typeof exports === 'object') {
    module.exports = factory(require('quill'))
  } else {
    root.Requester = factory(root.Quill)
  }
}(this, function (Quill) {
  'use strict'

  var app
  // declare ngQuill module
  app = angular.module('ngQuill', [])

  app.provider('ngQuillConfig', function () {
    var config = {
      modules: {
        toolbar: [
          ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
          ['blockquote', 'code-block'],

          [{ 'header': 1 }, { 'header': 2 }],               // custom button values
          [{ 'list': 'ordered' }, { 'list': 'bullet' }],
          [{ 'script': 'sub' }, { 'script': 'super' }],      // superscript/subscript
          [{ 'indent': '-1' }, { 'indent': '+1' }],          // outdent/indent
          [{ 'direction': 'rtl' }],                         // text direction

          [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
          [{ 'header': [1, 2, 3, 4, 5, 6, false] }],

          [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
          [{ 'font': [] }],
          [{ 'align': [] }],

          ['clean'],                                         // remove formatting button

          ['link', 'image', 'video']                         // link and image, video
        ]
      },
      theme: 'snow',
      placeholder: 'Insert text here ...',
      readOnly: false,
      bounds: document.body
    }

    this.set = function (customConf) {
      customConf = customConf || {}

      if (customConf.modules) {
        config.modules = customConf.modules
      }
      if (customConf.theme) {
        config.theme = customConf.theme
      }
      if (customConf.placeholder) {
        config.placeholder = customConf.placeholder
      }
      if (customConf.bounds) {
        config.bounds = customConf.bounds
      }
      if (customConf.readOnly) {
        config.readOnly = customConf.readOnly
      }
      if (customConf.formats) {
        config.formats = customConf.formats
      }
    }

    this.$get = function () {
      return config
    }
  })

  app.component('ngQuillEditor', {
    bindings: {
      'modules': '<modules',
      'theme': '@?',
      'readOnly': '<?',
      'formats': '<?',
      'placeholder': '@?',
      'bounds': '<?',
      'onEditorCreated': '&?',
      'onContentChanged': '&?',
      'onSelectionChanged': '&?',
      'ngModel': '<',
      'maxLength': '<',
      'minLength': '<'
    },
    require: {
      ngModelCtrl: 'ngModel'
    },
    transclude: {
      'toolbar': '?ngQuillToolbar'
    },
    template: '<div class="ng-hide" ng-show="$ctrl.ready"><ng-transclude ng-transclude-slot="toolbar"></ng-transclude></div>',
    controller: ['$scope', '$element', '$timeout', '$transclude', 'ngQuillConfig', function ($scope, $element, $timeout, $transclude, ngQuillConfig) {
      var config = {}
      var content
      var editorElem
      var modelChanged = false
      var editorChanged = false
      var editor

      this.validate = function (text) {
        if (this.maxLength) {
          if (text.length > this.maxLength + 1) {
            this.ngModelCtrl.$setValidity('maxlength', false)
          } else {
            this.ngModelCtrl.$setValidity('maxlength', true)
          }
        }

        if (this.minLength > 1) {
          // validate only if text.length > 1
          if (text.length <= this.minLength && text.length > 1) {
            this.ngModelCtrl.$setValidity('minlength', false)
          } else {
            this.ngModelCtrl.$setValidity('minlength', true)
          }
        }
      }

      this.$onChanges = function (changes) {
        if (changes.ngModel && changes.ngModel.currentValue !== changes.ngModel.previousValue) {
          content = changes.ngModel.currentValue

          if (editor && !editorChanged) {
            modelChanged = true
            if (content) {
              editor.pasteHTML(content)
            } else {
              editor.setText('')
            }
          }
          editorChanged = false
        }

        if (editor && changes.readOnly) {
          editor.enable(!changes.readOnly.currentValue)
        }
      }

      this.$onInit = function () {
        config = {
          theme: this.theme || ngQuillConfig.theme,
          readOnly: this.readOnly || ngQuillConfig.readOnly,
          modules: this.modules || ngQuillConfig.modules,
          formats: this.formats || ngQuillConfig.formats,
          placeholder: this.placeholder || ngQuillConfig.placeholder,
          bounds: this.bounds || ngQuillConfig.bounds
        }
      }

      this.$postLink = function () {
        // create quill instance after dom is rendered
        $timeout(function () {
          this._initEditor(editorElem)
        }.bind(this), 0)
      }

      this._initEditor = function (editorElem) {
        var $editorElem = angular.element('<div></div>')
        var container = $element.children()

        editorElem = $editorElem[0]

        // set toolbar to custom one
        if ($transclude.isSlotFilled('toolbar')) {
          config.modules.toolbar = container.find('ng-quill-toolbar').children()[0]
        }

        container.append($editorElem)

        editor = new Quill(editorElem, config)

        this.ready = true

        // mark model as touched if editor lost focus
        editor.on('selection-change', function (range, oldRange, source) {
          if (this.onSelectionChanged) {
            this.onSelectionChanged({
              editor: editor,
              oldRange: oldRange,
              range: range,
              source: source
            })
          }

          if (range) {
            return
          }
          $scope.$applyAsync(function () {
            this.ngModelCtrl.$setTouched()
          }.bind(this))
        }.bind(this))

        // update model if text changes
        editor.on('text-change', function (delta, oldDelta, source) {
          var html = editorElem.children[0].innerHTML
          var text = editor.getText()

          if (html === '<p><br></p>') {
            html = null
          }
          this.validate(text)

          if (!modelChanged) {
            $scope.$applyAsync(function () {
              editorChanged = true

              this.ngModelCtrl.$setViewValue(html)

              if (this.onContentChanged) {
                this.onContentChanged({
                  editor: editor,
                  html: html,
                  text: text,
                  delta: delta,
                  oldDelta: oldDelta,
                  source: source
                })
              }
            }.bind(this))
          }
          modelChanged = false
        }.bind(this))

        // set initial content
        if (content) {
          modelChanged = true

          var contents = editor.clipboard.convert(content)
          editor.setContents(contents)
          editor.history.clear()
        }

        // provide event to get informed when editor is created -> pass editor object.
        if (this.onEditorCreated) {
          this.onEditorCreated({editor: editor})
        }
      }
    }]
  })
}));

(function() {
  var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  angular.module('countrySelect', []).directive('countrySelect', function() {
    var allCountries;
    allCountries = [
      {
        code: 'AF',
        name: 'Afghanistan'
      }, {
        code: 'AL',
        name: 'Albania'
      }, {
        code: 'DZ',
        name: 'Algeria'
      }, {
        code: 'AS',
        name: 'American Samoa'
      }, {
        code: 'AD',
        name: 'Andorre'
      }, {
        code: 'AO',
        name: 'Angola'
      }, {
        code: 'AI',
        name: 'Anguilla'
      }, {
        code: 'AQ',
        name: 'Antarctica'
      }, {
        code: 'AG',
        name: 'Antigua and Barbuda'
      }, {
        code: 'AR',
        name: 'Argentina'
      }, {
        code: 'AM',
        name: 'Armenia'
      }, {
        code: 'AW',
        name: 'Aruba'
      }, {
        code: 'AU',
        name: 'Australia'
      }, {
        code: 'AT',
        name: 'Austria'
      }, {
        code: 'AZ',
        name: 'Azerbaijan'
      }, {
        code: 'BS',
        name: 'Bahamas'
      }, {
        code: 'BH',
        name: 'Bahrain'
      }, {
        code: 'BD',
        name: 'Bangladesh'
      }, {
        code: 'BB',
        name: 'Barbade'
      }, {
        code: 'BY',
        name: 'Belarus'
      }, {
        code: 'BE',
        name: 'Belgium'
      }, {
        code: 'BZ',
        name: 'Belize'
      }, {
        code: 'BJ',
        name: 'Benin'
      }, {
        code: 'BM',
        name: 'Bermuda'
      }, {
        code: 'BT',
        name: 'Bhutan'
      }, {
        code: 'BO',
        name: 'Bolivia'
      }, {
        code: 'BQ',
        name: 'Bonaire, Sint Eustatius and Saba'
      }, {
        code: 'BA',
        name: 'Bosnia and Herzegovina'
      }, {
        code: 'BW',
        name: 'Botswana'
      }, {
        code: 'BV',
        name: 'Bouvet Island'
      }, {
        code: 'BR',
        name: 'Brazil'
      }, {
        code: 'IO',
        name: 'British Indian Ocean Territory'
      }, {
        code: 'VG',
        name: 'British Virgin Islands'
      }, {
        code: 'BN',
        name: 'Brunei'
      }, {
        code: 'BG',
        name: 'Bulgaria'
      }, {
        code: 'BF',
        name: 'Burkina Faso'
      }, {
        code: 'BI',
        name: 'Burundi'
      }, {
        code: 'KH',
        name: 'Cambodia'
      }, {
        code: 'CM',
        name: 'Cameroon'
      }, {
        code: 'CA',
        name: 'Canada'
      }, {
        code: 'CV',
        name: 'Cape Verde'
      }, {
        code: 'KY',
        name: 'Cayman Islands'
      }, {
        code: 'CF',
        name: 'Central African Republic'
      }, {
        code: 'TD',
        name: 'Chad'
      }, {
        code: 'CL',
        name: 'Chile'
      }, {
        code: 'CN',
        name: 'China'
      }, {
        code: 'CX',
        name: 'Christmas Island'
      }, {
        code: 'CC',
        name: 'Cocos (Keeling) Islands'
      }, {
        code: 'CO',
        name: 'Colombia'
      }, {
        code: 'KM',
        name: 'Comoros'
      }, {
        code: 'CG',
        name: 'Congo'
      }, {
        code: 'CD',
        name: 'Congo (Dem. Rep.)'
      }, {
        code: 'CK',
        name: 'Cook Islands'
      }, {
        code: 'CR',
        name: 'Costa Rica'
      }, {
        code: 'ME',
        name: 'Crna Gora'
      }, {
        code: 'HR',
        name: 'Croatia'
      }, {
        code: 'CU',
        name: 'Cuba'
      }, {
        code: 'CW',
        name: 'Curaçao'
      }, {
        code: 'CY',
        name: 'Cyprus'
      }, {
        code: 'CZ',
        name: 'Czech Republic'
      }, {
        code: 'CI',
        name: "Côte D'Ivoire"
      }, {
        code: 'DK',
        name: 'Denmark'
      }, {
        code: 'DJ',
        name: 'Djibouti'
      }, {
        code: 'DM',
        name: 'Dominica'
      }, {
        code: 'DO',
        name: 'Dominican Republic'
      }, {
        code: 'TL',
        name: 'East Timor'
      }, {
        code: 'EC',
        name: 'Ecuador'
      }, {
        code: 'EG',
        name: 'Egypt'
      }, {
        code: 'SV',
        name: 'El Salvador'
      }, {
        code: 'GQ',
        name: 'Equatorial Guinea'
      }, {
        code: 'ER',
        name: 'Eritrea'
      }, {
        code: 'EE',
        name: 'Estonia'
      }, {
        code: 'ET',
        name: 'Ethiopia'
      }, {
        code: 'FK',
        name: 'Falkland Islands'
      }, {
        code: 'FO',
        name: 'Faroe Islands'
      }, {
        code: 'FJ',
        name: 'Fiji'
      }, {
        code: 'FI',
        name: 'Finland'
      }, {
        code: 'FR',
        name: 'France'
      }, {
        code: 'GF',
        name: 'French Guiana'
      }, {
        code: 'PF',
        name: 'French Polynesia'
      }, {
        code: 'TF',
        name: 'French Southern Territories'
      }, {
        code: 'GA',
        name: 'Gabon'
      }, {
        code: 'GM',
        name: 'Gambia'
      }, {
        code: 'GE',
        name: 'Georgia'
      }, {
        code: 'DE',
        name: 'Germany'
      }, {
        code: 'GH',
        name: 'Ghana'
      }, {
        code: 'GI',
        name: 'Gibraltar'
      }, {
        code: 'GR',
        name: 'Greece'
      }, {
        code: 'GL',
        name: 'Greenland'
      }, {
        code: 'GD',
        name: 'Grenada'
      }, {
        code: 'GP',
        name: 'Guadeloupe'
      }, {
        code: 'GU',
        name: 'Guam'
      }, {
        code: 'GT',
        name: 'Guatemala'
      }, {
        code: 'GG',
        name: 'Guernsey and Alderney'
      }, {
        code: 'GN',
        name: 'Guinea'
      }, {
        code: 'GW',
        name: 'Guinea-Bissau'
      }, {
        code: 'GY',
        name: 'Guyana'
      }, {
        code: 'HT',
        name: 'Haiti'
      }, {
        code: 'HM',
        name: 'Heard and McDonald Islands'
      }, {
        code: 'HN',
        name: 'Honduras'
      }, {
        code: 'HK',
        name: 'Hong Kong'
      }, {
        code: 'HU',
        name: 'Hungary'
      }, {
        code: 'IS',
        name: 'Iceland'
      }, {
        code: 'IN',
        name: 'India'
      }, {
        code: 'ID',
        name: 'Indonesia'
      }, {
        code: 'IR',
        name: 'Iran'
      }, {
        code: 'IQ',
        name: 'Iraq'
      }, {
        code: 'IE',
        name: 'Ireland'
      }, {
        code: 'IM',
        name: 'Isle of Man'
      }, {
        code: 'IL',
        name: 'Israel'
      }, {
        code: 'IT',
        name: 'Italy'
      }, {
        code: 'JM',
        name: 'Jamaica'
      }, {
        code: 'JP',
        name: 'Japan'
      }, {
        code: 'JE',
        name: 'Jersey'
      }, {
        code: 'JO',
        name: 'Jordan'
      }, {
        code: 'KZ',
        name: 'Kazakhstan'
      }, {
        code: 'KE',
        name: 'Kenya'
      }, {
        code: 'KI',
        name: 'Kiribati'
      }, {
        code: 'KP',
        name: 'Korea (North)'
      }, {
        code: 'KR',
        name: 'Korea (South)'
      }, {
        code: 'KW',
        name: 'Kuwait'
      }, {
        code: 'KG',
        name: 'Kyrgyzstan'
      }, {
        code: 'LA',
        name: 'Laos'
      }, {
        code: 'LV',
        name: 'Latvia'
      }, {
        code: 'LB',
        name: 'Lebanon'
      }, {
        code: 'LS',
        name: 'Lesotho'
      }, {
        code: 'LR',
        name: 'Liberia'
      }, {
        code: 'LY',
        name: 'Libya'
      }, {
        code: 'LI',
        name: 'Liechtenstein'
      }, {
        code: 'LT',
        name: 'Lithuania'
      }, {
        code: 'LU',
        name: 'Luxembourg'
      }, {
        code: 'MO',
        name: 'Macao'
      }, {
        code: 'MK',
        name: 'Macedonia'
      }, {
        code: 'MG',
        name: 'Madagascar'
      }, {
        code: 'MW',
        name: 'Malawi'
      }, {
        code: 'MY',
        name: 'Malaysia'
      }, {
        code: 'MV',
        name: 'Maldives'
      }, {
        code: 'ML',
        name: 'Mali'
      }, {
        code: 'MT',
        name: 'Malta'
      }, {
        code: 'MH',
        name: 'Marshall Islands'
      }, {
        code: 'MQ',
        name: 'Martinique'
      }, {
        code: 'MR',
        name: 'Mauritania'
      }, {
        code: 'MU',
        name: 'Mauritius'
      }, {
        code: 'YT',
        name: 'Mayotte'
      }, {
        code: 'MX',
        name: 'Mexico'
      }, {
        code: 'FM',
        name: 'Micronesia'
      }, {
        code: 'MD',
        name: 'Moldova'
      }, {
        code: 'MC',
        name: 'Monaco'
      }, {
        code: 'MN',
        name: 'Mongolia'
      }, {
        code: 'MS',
        name: 'Montserrat'
      }, {
        code: 'MA',
        name: 'Morocco'
      }, {
        code: 'MZ',
        name: 'Mozambique'
      }, {
        code: 'MM',
        name: 'Myanmar'
      }, {
        code: 'NA',
        name: 'Namibia'
      }, {
        code: 'NR',
        name: 'Nauru'
      }, {
        code: 'NP',
        name: 'Nepal'
      }, {
        code: 'NL',
        name: 'Netherlands'
      }, {
        code: 'AN',
        name: 'Netherlands Antilles'
      }, {
        code: 'NC',
        name: 'New Caledonia'
      }, {
        code: 'NZ',
        name: 'New Zealand'
      }, {
        code: 'NI',
        name: 'Nicaragua'
      }, {
        code: 'NE',
        name: 'Niger'
      }, {
        code: 'NG',
        name: 'Nigeria'
      }, {
        code: 'NU',
        name: 'Niue'
      }, {
        code: 'NF',
        name: 'Norfolk Island'
      }, {
        code: 'MP',
        name: 'Northern Mariana Islands'
      }, {
        code: 'NO',
        name: 'Norway'
      }, {
        code: 'OM',
        name: 'Oman'
      }, {
        code: 'PK',
        name: 'Pakistan'
      }, {
        code: 'PW',
        name: 'Palau'
      }, {
        code: 'PS',
        name: 'Palestine'
      }, {
        code: 'PA',
        name: 'Panama'
      }, {
        code: 'PG',
        name: 'Papua New Guinea'
      }, {
        code: 'PY',
        name: 'Paraguay'
      }, {
        code: 'PE',
        name: 'Peru'
      }, {
        code: 'PH',
        name: 'Philippines'
      }, {
        code: 'PN',
        name: 'Pitcairn'
      }, {
        code: 'PL',
        name: 'Poland'
      }, {
        code: 'PT',
        name: 'Portugal'
      }, {
        code: 'PR',
        name: 'Puerto Rico'
      }, {
        code: 'QA',
        name: 'Qatar'
      }, {
        code: 'RO',
        name: 'Romania'
      }, {
        code: 'RU',
        name: 'Russia'
      }, {
        code: 'RW',
        name: 'Rwanda'
      }, {
        code: 'RE',
        name: 'Réunion'
      }, {
        code: 'BL',
        name: 'Saint Barthélemy'
      }, {
        code: 'SH',
        name: 'Saint Helena'
      }, {
        code: 'KN',
        name: 'Saint Kitts and Nevis'
      }, {
        code: 'LC',
        name: 'Saint Lucia'
      }, {
        code: 'MF',
        name: 'Saint Martin'
      }, {
        code: 'PM',
        name: 'Saint Pierre and Miquelon'
      }, {
        code: 'VC',
        name: 'Saint Vincent and the Grenadines'
      }, {
        code: 'WS',
        name: 'Samoa'
      }, {
        code: 'SM',
        name: 'San Marino'
      }, {
        code: 'SA',
        name: 'Saudi Arabia'
      }, {
        code: 'SN',
        name: 'Senegal'
      }, {
        code: 'RS',
        name: 'Serbia'
      }, {
        code: 'SC',
        name: 'Seychelles'
      }, {
        code: 'SL',
        name: 'Sierra Leone'
      }, {
        code: 'SG',
        name: 'Singapore'
      }, {
        code: 'SX',
        name: 'Sint Maarten'
      }, {
        code: 'SK',
        name: 'Slovakia'
      }, {
        code: 'SI',
        name: 'Slovenia'
      }, {
        code: 'SB',
        name: 'Solomon Islands'
      }, {
        code: 'SO',
        name: 'Somalia'
      }, {
        code: 'ZA',
        name: 'South Africa'
      }, {
        code: 'GS',
        name: 'South Georgia and the South Sandwich Islands'
      }, {
        code: 'SS',
        name: 'South Sudan'
      }, {
        code: 'ES',
        name: 'Spain'
      }, {
        code: 'LK',
        name: 'Sri Lanka'
      }, {
        code: 'SD',
        name: 'Sudan'
      }, {
        code: 'SR',
        name: 'Suriname'
      }, {
        code: 'SJ',
        name: 'Svalbard and Jan Mayen'
      }, {
        code: 'SZ',
        name: 'Swaziland'
      }, {
        code: 'SE',
        name: 'Sweden'
      }, {
        code: 'CH',
        name: 'Switzerland'
      }, {
        code: 'SY',
        name: 'Syria'
      }, {
        code: 'ST',
        name: 'São Tomé and Príncipe'
      }, {
        code: 'TW',
        name: 'Taiwan'
      }, {
        code: 'TJ',
        name: 'Tajikistan'
      }, {
        code: 'TZ',
        name: 'Tanzania'
      }, {
        code: 'TH',
        name: 'Thailand'
      }, {
        code: 'TG',
        name: 'Togo'
      }, {
        code: 'TK',
        name: 'Tokelau'
      }, {
        code: 'TO',
        name: 'Tonga'
      }, {
        code: 'TT',
        name: 'Trinidad and Tobago'
      }, {
        code: 'TN',
        name: 'Tunisia'
      }, {
        code: 'TR',
        name: 'Turkey'
      }, {
        code: 'TM',
        name: 'Turkmenistan'
      }, {
        code: 'TC',
        name: 'Turks and Caicos Islands'
      }, {
        code: 'TV',
        name: 'Tuvalu'
      }, {
        code: 'UG',
        name: 'Uganda'
      }, {
        code: 'UA',
        name: 'Ukraine'
      }, {
        code: 'AE',
        name: 'United Arab Emirates'
      }, {
        code: 'GB',
        name: 'United Kingdom'
      }, {
        code: 'UM',
        name: 'United States Minor Outlying Islands'
      }, {
        code: 'US',
        name: 'United States of America'
      }, {
        code: 'UY',
        name: 'Uruguay'
      }, {
        code: 'UZ',
        name: 'Uzbekistan'
      }, {
        code: 'VU',
        name: 'Vanuatu'
      }, {
        code: 'VA',
        name: 'Vatican City'
      }, {
        code: 'VE',
        name: 'Venezuela'
      }, {
        code: 'VN',
        name: 'Vietnam'
      }, {
        code: 'VI',
        name: 'Virgin Islands of the United States'
      }, {
        code: 'WF',
        name: 'Wallis and Futuna'
      }, {
        code: 'EH',
        name: 'Western Sahara'
      }, {
        code: 'YE',
        name: 'Yemen'
      }, {
        code: 'ZM',
        name: 'Zambia'
      }, {
        code: 'ZW',
        name: 'Zimbabwe'
      }, {
        code: 'AX',
        name: 'Åland Islands'
      }
    ];
    return {
      restrict: 'AE',
      replace: true,
      scope: {
        priorities: '@csPriorities',
        placeHolder: '@',
        onChanged: '&',
        only: '@csOnly',
        except: '@csExcept',
        any: '@?'
      },
      template: '<select ng-change="onChanged()" ng-options="country.code as country.name for country in countries"><option class="place-holder" ng-if="placeHolder" value="" disabled selected>{{placeHolder}}</option><option value="" ng-if="isSelectionOptional"></option></select>',
      controller: [
        '$scope', '$attrs', function($scope, $attrs) {
          var countryCodesIn, findCountriesIn, includeOnlyRequestedCountries, removeCountry, removeExcludedCountries, separator, updateWithPriorityCountries;
          separator = {
            code: '-',
            name: '────────────────────',
            disabled: true
          };
          countryCodesIn = function(codesString) {
            var codes;
            codes = codesString ? codesString.split(',') : [];
            return codes.map(function(code) {
              return code.trim();
            });
          };
          findCountriesIn = (function(_this) {
            return function(codesString) {
              var country, countryCodes, i, len, ref, ref1, results;
              countryCodes = countryCodesIn(codesString);
              ref = _this.countries;
              results = [];
              for (i = 0, len = ref.length; i < len; i++) {
                country = ref[i];
                if (ref1 = country.code, indexOf.call(countryCodes, ref1) >= 0) {
                  results.push(country);
                }
              }
              return results;
            };
          })(this);
          removeCountry = (function(_this) {
            return function(country) {
              return _this.countries.splice(_this.countries.indexOf(country), 1);
            };
          })(this);
          includeOnlyRequestedCountries = (function(_this) {
            return function() {
              if (!$scope.only) {
                return;
              }
              return _this.countries = findCountriesIn($scope.only);
            };
          })(this);
          removeExcludedCountries = function() {
            var country, i, len, ref, results;
            if (!$scope.except) {
              return;
            }
            ref = findCountriesIn($scope.except);
            results = [];
            for (i = 0, len = ref.length; i < len; i++) {
              country = ref[i];
              results.push(removeCountry(country));
            }
            return results;
          };
          updateWithPriorityCountries = (function(_this) {
            return function() {
              var i, len, priorityCountries, priorityCountry, ref, results;
              priorityCountries = findCountriesIn($scope.priorities);
              if (priorityCountries.length === 0) {
                return;
              }
              _this.countries.unshift(separator);
              ref = priorityCountries.reverse();
              results = [];
              for (i = 0, len = ref.length; i < len; i++) {
                priorityCountry = ref[i];
                removeCountry(priorityCountry);
                results.push(_this.countries.unshift(priorityCountry));
              }
              return results;
            };
          })(this);
          this.countries = allCountries.slice();
          includeOnlyRequestedCountries();
          removeExcludedCountries();
          updateWithPriorityCountries();
          if($scope.any){
            this.countries.unshift({
              code: '',
              name: 'Any'
            })
          }
          $scope.countries = this.countries;
          return $scope.isSelectionOptional = $attrs.csRequired === void 0;
        }
      ]
    };
  });

}).call(this);

(function() {
    'use strict';

    angular
        .module('pixerf')
        .directive('navbarCollapseOnClick', navbarCollapseOnClick);
    navbarCollapseOnClick.$inject = [];
    function navbarCollapseOnClick() {
        return {
            restrict: 'A',
            scope: {
                navbarCollapseOnClick: '&'
			},
			priority: 100,
            link: function(scope, element, attr) {
				if(attr.navbarCollapseOnClick){
					var navMain = $(element);
					navMain.on("click", "*:not([navbar-stop-collapse-on-click])", function () {
						navMain.collapse('hide');
					});
				}
            }
          }
        }
})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .directive('loadingSpinner', loadingSpinner);
    loadingSpinner.$inject = ['$rootScope'];
    function loadingSpinner() {
        return {
			scope: 'A',
			link : function(scope, elem, attrs) {
				var $elem = $(elem);
				$elem.addClass("loading-spinner");
				$elem.prepend('<i class="fa fa-2x fa-spin fa-spinner">');
			}
		};
    }
})();                                                                  
(function () {
    'use strict';

    angular
        .module('pixerf')
        .directive('inputNumberOnly', inputNumberOnly);

    function inputNumberOnly() {
        return {  
            restrict: 'A',  
            link: function (scope, elm, attrs, ctrl) {
                var beforeKeyUpValue;
                elm.on('keydown', function (event) {  
                    var maxDigit = angular.fromJson(attrs["inputNumberOnlyMaxDigits"]);
                    var $input = $(this);  
                    var value = $input.val();  
                    value = value.replace(/[^0-9]/g, '')
                    $input.val(value);
                    var isAllowed = true;
                    var isSkipMaxDigitChecked = false;
                    if (event.which == 64 || event.which == 16) {  
                        // to allow numbers
                    } else if (event.which >= 48 && event.which <= 57) {  
                        // to allow numbers  
                    } else if (event.which >= 96 && event.which <= 105) {
                        // to allow numpad number  
                    } else if ([8, 9, 13, 27, 37, 38, 39, 40].indexOf(event.which) > -1) {  
                        // to allow backspace, enter, escape, arrows  
                        isSkipMaxDigitChecked = true;
                    } else {
                        isAllowed = false;  
                        // to stop others  
                        //alert("Sorry Only Numbers Allowed");  
                    } 
                    if(isAllowed) {
                        if(!isSkipMaxDigitChecked && maxDigit && value.toString().length == maxDigit){ return false; event.preventDefault()};
                        return true;
                    } else{
                        event.preventDefault();
                        return false;
                    }
                });  
            }  
        }  
    }
})();                                                                  
(function() {
    'use strict';

    angular
        .module('pixerf')
        .directive('imgOrientation', imgOrientation);
    imgOrientation.$inject = ['$parse', '$timeout'];

    function imgOrientation($parse, $timeout) {
        return {
            restrict: 'A',
            link: function(scope, element, attrs) {
                var $element = $(element);
                scope.$watch(attrs.imgOrientation, function (newValue, oldValue) {
                    if(newValue === oldValue) return;
                    var rotateDegrees = newValue === null ? 0 : newValue;

                    var originalStyle = attrs.imgOrientationOriginalStyle;
                    console.log(originalStyle);
                    var r = originalStyle + ' rotate(' + rotateDegrees + 'deg)';
                    if(attrs.refitImageAfterRotating && rotateDegrees > 0){
                        var scaleRatio = 1; 
                        if((rotateDegrees/90) % 2 > 0) {
                            scaleRatio = $element.parent().height()/$element.width();
                        }
                        r += (" scale(" + scaleRatio + ")");
                    }
                    var style = {
                        '-moz-transform': r,
                        '-webkit-transform': r,
                        '-o-transform': r,
                        '-ms-transform': r
                    }
                    $element.css(style);
                    if(attrs.imgOrientationCallback){
                        scope.$eval(attrs.imgOrientationCallback);
                    }
                    if(attrs.updateRelativeElmt){
                        var $relateElmt = $(attrs.updateRelativeElmt);
                        $timeout(function(){
                            console.log($element[0].getBoundingClientRect());
                            $relateElmt.width($element[0].getBoundingClientRect().width);    
                            $relateElmt.height($element[0].getBoundingClientRect().height);    
                        },1000);
                    }
                    
                });
            }
        };
    }
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('imageOnloaded', imageOnloaded);

	imageOnloaded.$inject = ['imageUtils'];
	function imageOnloaded(imageUtils) {
		return {
			restrict: 'A',
			scope: {
				imageOnloaded: "=",
				imageOnloadedUrl: '@'
			},
			link: function (scope, element, attrs) {
				if(scope.imageOnloadedUrl){
					imageUtils.loadImageViaUrl(scope.imageOnloadedUrl).then(function(img){
						scope.imageOnloaded.success(img);	
					});
				} else {
					element.bind('load', function () {
						scope.imageOnloaded.sucess();
					});
					element.bind('error', function () {
						if(scope.imageOnloaded.error){
							scope.imageOnloaded.error();
						}
					});
				}
			}
		};
	};
})();

(function () {

	angular
		.module('pixerf')
		.config(translateProvider)

	translateProvider.$inject = ['$translateProvider'];

	function translateProvider($translateProvider) {
		$translateProvider.useStaticFilesLoader({
			prefix: './locales/',
			suffix: '.json?t=' + moment().unix()
		});
		$translateProvider.registerAvailableLanguageKeys(['en', 'id']).fallbackLanguage('en');
		$translateProvider.preferredLanguage("en");
		$translateProvider.forceAsyncReload(true);
	};
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.filter('groupBy', groupBy);

	groupBy.$inject = ["$parse", "$filter"];
	function groupBy($parse, $filter) {
		return function (array, groupByField) {
			var result = [];
			var prev_item = null;
			var groupKey = false;
			var filteredData = $filter('orderBy')(array, groupByField);
			for (var i = 0; i < filteredData.length; i++) {
				groupKey = false;
				if (prev_item !== null) {
					if (prev_item[groupByField] !== filteredData[i][groupByField]) {
						groupKey = true;
					}
				} else {
					groupKey = true;
				}
				if (groupKey) {
					filteredData[i]['group_by_key'] = true;
					filteredData[i]['has_sibling'] = false;
				} else {
					filteredData[i]['group_by_key'] = false;
					filteredData[i]['has_sibling'] = true;
					filteredData[i-1]['has_sibling'] = true;
				}
				result.push(filteredData[i]);
				prev_item = filteredData[i];
			}
			return result;
		}
	}
})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .filter('formatDate', formatDate);

    formatDate.$inject = ['dateUtils'];
    function formatDate(dateUtils) {
       	return function(input, format) {
			return dateUtils.formatToString(input, format);
		};
    }
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('focusMe', focusMe);

	focusMe.$inject = ['$parse', '$timeout'];

	function focusMe($parse, $timeout) {
		return {
			link: function (scope, element, attrs) {
				var model = $parse(attrs.focusMe);
				scope.$watch(model, function (value) {
					if (value === true) {
						$timeout(function () {
							element[0].focus();
						});
					}
				});
			}
		}
	}
})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .directive('eventRightClick', eventRightClick);
    eventRightClick.$inject = ['$parse'];
    function eventRightClick($parse) {
        return  function(scope, element, attrs) {
            var fn = $parse(attrs.ngRightClick);
            element.bind('contextmenu', function(event) {
                scope.$apply(function() {
                    event.preventDefault();
                    fn(scope, {$event:event});
                });
            });
        }
    }
})();                                                                  
(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('eventKey', eventKey);
	eventKey.$inject = [];

	function eventKey() {
		return {
			restrict: 'A',
			scope: {
				onKeyPressed: "="
			},
			link: function (scope, elem, attrs) {
				window.addEventListener("keyup", scope.onKeyPressed);

				scope.$on('$destroy', function () {
					window.removeEventListener("keyup", scope.onKeyPressed);
				})
			}
		};
	}
})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .directive('enter', enter);
    enter.$inject = [];
    function enter() {
        return {
            link : function(scope, elem, attrs) {
                var selector = attrs.selector;
                var handler = function (event) {
                    if(event.which === 13) {
                        scope.$apply(function (){
                            scope.$eval(attrs.enter);
                        });
                        event.preventDefault();
                    }
                }
                if(selector){
                   $(elem).on("keydown keypress", selector, handler);
                } else {
                    $(elem).on("keydown keypress", handler);
                }
            }
        };
    }
})();                                                                  
(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('elementDimension', elementDimension);

	elementDimension.$inject = ['$timeout'];
	function elementDimension($timeout) {
		return {
			restrict: 'A',
			link: function (scope, element, attrs) {
				var img = element.find('img');
				img.bind('load',function () {
					var height,
						width;
					$timeout(function () {
						height = element[0].offsetHeight;
						width = element[0].offsetWidth;
						if (attrs.elementDimension) {
							scope[attrs.elementDimension] = {
								height: height,
								width: width
							};
							return;
						}

						scope.elementSize = {
							height: height,
							width: width
						};
						scope.$apply();
					});
				});
			}
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('dynamicShowHideScroll', dynamicShowHideScroll);

	dynamicShowHideScroll.$inject = ['$timeout', '$window'];

	function dynamicShowHideScroll($timeout, $window) {
		return {
			restrict: 'A',
			link: function (scope, element, attrs) {
				var lastScrollTop = 0;
				var $ele = $(element);
				var namespaceScrolling = '.detectDirection' + moment().unix();
				$timeout(function () {
					angular.element($window).on('scroll' + namespaceScrolling, onScrollAction);
				});

				function onScrollAction() {
					var st = window.pageYOffset || document.documentElement.scrollTop;
					if (st > lastScrollTop) {
						$ele.addClass(attrs.scrollDownClass);
						$ele.removeClass(attrs.scrollUpClass);
					} else {
						$ele.addClass(attrs.scrollUpClass);
						$ele.removeClass(attrs.scrollDownClass);
					}
					lastScrollTop = st <= 0 ? 0 : st;
				}

				scope.$on('$destroy', function () {
					angular.element($window).off('scroll' + namespaceScrolling, onScrollAction);
				});
			}
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('dynamicShowHideScrollPosition', dynamicShowHideScrollPosition);

		dynamicShowHideScrollPosition.$inject = ['$timeout', '$window'];

	function dynamicShowHideScrollPosition($timeout, $window) {
		return {
			restrict: 'A',
			link: function (scope, element, attrs) {
				var lastScrollTop = 0;
				var $ele = $(element);
				var namespaceScrolling = '.detectDirection' + moment().unix();
				var balancingPoint = attrs.balancingPoint ? $(attrs.balancingPoint) : $(element).parent();
				// var elementTop = balancingPoint.offset().top;
				var offsetTop = attrs.offsetTop ? attrs.offsetTop : 0;
				$timeout(function () {
					angular.element($window).on('scroll' + namespaceScrolling, onScrollAction);
					angular.element($window).on('resize' + namespaceScrolling, onScrollAction);
				});

				function onScrollAction() {
					var st = window.pageYOffset || document.documentElement.scrollTop;
					var scrollOverItem = checkScrollOverItem(st, $ele);

					if(!scrollOverItem) {
						$ele.removeClass(attrs.scrollDownClass);
						$ele.removeClass(attrs.scrollUpClass);
						return;
					};

					if (st > lastScrollTop) {
						$ele.addClass(attrs.scrollDownClass);
						$ele.removeClass(attrs.scrollUpClass);
					} else {

						$ele.addClass(attrs.scrollUpClass);
						$ele.removeClass(attrs.scrollDownClass);
					}
					lastScrollTop = st <= 0 ? 0 : st;
				}

				function checkScrollOverItem(windowScroll, element){
					var elementTop = balancingPoint.offset().top;
					var elementHeight = element.outerHeight();
					return (windowScroll > (elementTop + offsetTop));
				}

				scope.$on('$destroy', function () {
					angular.element($window).off('scroll' + namespaceScrolling, onScrollAction);
					angular.element($window).off('resize' + namespaceScrolling, onScrollAction);
				});
			}
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('dynamicPlaceholder', dynamicPlaceholder);

	dynamicPlaceholder.$inject = ['$timeout'];
	function dynamicPlaceholder($timeout) {
		return {
			restrict: 'A',
			link: function (scope, element, attrs) {
				$timeout(function(){
					var $element = $(attrs.placeholderSelector);
					scope.$watch(attrs.dynamicPlaceholder, function (placeholder) {
						if(placeholder){
							$element.attr("placeholder", placeholder);
						}
					});
				});
			}
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.filter('convertToTrustHtml', convertToTrustHtml);

	convertToTrustHtml.$inject = ['$sce'];
	function convertToTrustHtml($sce) {
		return function (input) {
			return $sce.getTrustedHtml(input);
		};
	}
})();

(function () {
    'use strict';

    angular
        .module('pixerf')
        .directive('convertMapping', convertMapping);
    function convertMapping() {
        return {
            require: 'ngModel',
            scope: {
                convertMappingFormatter: '&',
                convertMappingParser: '&'
            },
            link: function (scope, element, attrs, ngModel) {
                ngModel.$parsers.push(function (val) {
                    return scope.convertMappingParser({val: val});
                });
                ngModel.$formatters.push(function (val) {
                    return scope.convertMappingFormatter({val: val});
                });
            }
        };
    }
})();                                                                  
(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('contenteditable', contenteditable);
	function contenteditable() {
		return {
			restrict: "A",
			require: "ngModel",
			link: function (scope, element, attrs, ngModel) {

				function read() {
					ngModel.$setViewValue(element.html());
				}

				ngModel.$render = function () {
					element.html(ngModel.$viewValue || "");
				};

				element.bind("blur keyup change", function () {
					scope.$apply(read);
				});
			}
		};
	}
})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .directive('compile', compile);
    compile.$inject = ['$compile'];
    function compile($compile) {
        return function(scope, element, attrs) {
            scope.$watch(
                function(scope) {
                    // watch the 'compile' expression for changes
                    return scope.$eval(attrs.compile);
                },
                function(value) {
                    // when the 'compile' expression changes
                    // assign it into the current DOM
                    element.html(value);

                    // compile the new DOM and link it to the current
                    // scope.
                    // NOTE: we only compile .childNodes so that
                    // we don't get into infinite loop compiling ourselves
                    $compile(element.contents())(scope);
                }
            );
        };
    }
})();                                                                  
(function() {
	'use strict';

	angular
	.module('pixerf')
	.directive('closeOnScroll', closeOnScroll);
	closeOnScroll.$inject = ['numberUtils'];
	function closeOnScroll(numberUtils) {
		return {
			restrict: 'A',
			link: function(scope, element, attr) {
				var $ele = element;
				var namespaceSroll = 'ele' + numberUtils.getRandomInt(1, 100);
				$(window).on('scroll.' + namespaceSroll , function(e){
					$ele.trigger("click");
					event.stopPropagation();
				})
				element.on('$destroy', function(){
					$(window).unbind('scroll.' + namespaceSroll);
				});
			}
		}
	}
})();

(function () {
    'use strict';

    angular
        .module('pixerf')
        .directive('capitalize', capitalize);
    capitalize.$inject = [];
    function capitalize() {
        return {
            require: 'ngModel',
            link: function (scope, element, attrs, modelCtrl) {
                var capitalize = function (inputValue) {
                    if (inputValue == undefined) inputValue = '';
                    var capitalized = inputValue.toUpperCase();
                    if (capitalized !== inputValue) {
                        modelCtrl.$setViewValue(capitalized);
                        modelCtrl.$render();
                    }
                    return capitalized;
                }
                modelCtrl.$parsers.push(capitalize);
                capitalize(scope[attrs.ngModel]); // capitalize initial value
            }
        };
    }
})();                                                                  
(function() {
    'use strict';

    angular
        .module('pixerf')
        .filter('camelCaseToHuman', camelCaseToHuman);

        camelCaseToHuman.$inject = ['numberUtils'];
    function camelCaseToHuman(numberUtils) {
       	return function (input) {
            input = input || '';
            return input.replace(/([A-Z])/g, ' $1')
                // uppercase the first character
                .replace(/^./, function (str) { return str.toUpperCase(); })
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .filter('bigNumberFormatter', bigNumberFormatter);

    bigNumberFormatter.$inject = ['numberUtils'];
    function bigNumberFormatter(numberUtils) {
       	return function(input) {
			return numberUtils.formatNumberByK(input)
		};
    }
})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .filter('bankSensoredInfo', bankSensoredInfo);

        bankSensoredInfo.$inject = [];
    function bankSensoredInfo() {
       	return function (bankData, pattern) {
            if(pattern === 'AAAxxxBBB'){
                var sensoredInfo = bankData.accountNumber || bankData.cardNumber || bankData.IBAN || bankData.email;
                var numberFirstLetter = 3;
                var numberLastLetter = 3;
                var firstText = sensoredInfo.substr(0, numberFirstLetter);
                var lastText = sensoredInfo.substr(sensoredInfo.length - numberLastLetter);
                var sensoredInfoReplaced = sensoredInfo.substr(numberFirstLetter, sensoredInfo.length - (numberFirstLetter + numberLastLetter)).replace(/[^\-]/g, '*');
                return firstText + sensoredInfoReplaced + lastText;
            } else {
                return sensoredInfo;
            }
           
        };
    }
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.directive('authenticationClick', authenticationClick);
	authenticationClick.$inject = ['toastr', 'sessionManagerSvc', 'resendVerificationEmailPopupSvc', '$uibModalStack', 
		'verifiedBusinessUserPopupSvc', 'translationConst', '$translate', '$state', 'completeProfilePopupSvc', 'accountConst'];
	function authenticationClick(toastr, sessionManagerSvc, resendVerificationEmailPopupSvc, $uibModalStack, 
			verifiedBusinessUserPopupSvc, translationConst, $translate, $state, completeProfilePopupSvc, accountConst) {
		return {
			restrict: 'A',
			scope: {
				authenticationClick: '&',
				noAuthenticationClick: "&",
				authenticationClickAction: '@',
				checkVerifiedEmail: "&",
				hideErrorMessage: "&?",
				allowGuest:"@",
				authenticationFor:"@?"
			},
			priority: 100, // give it higher priority than built-in ng-click
			link: function (scope, element, attr) {
				element.bind('click', function (event) {
					var mLoginnedUser = sessionManagerSvc.getCurrentLoginUser().data;
					if (!mLoginnedUser) {
						if (!scope.authenticationClickAction) scope.authenticationClickAction = "USE_FUNCTION";
						var message = translationConst['LOGIN_TO_' + scope.authenticationClickAction];
						if(!scope.hideErrorMessage){
							toastr.info($translate.instant(message));
						}
						if (attr.noAuthenticationClick) {
							scope.noAuthenticationClick(scope, { $event: event });
						}
						event.preventDefault();
						event.stopPropagation();
					} else {
						if(!mLoginnedUser.account_type){ //Guest user
							if(scope.allowGuest){
								scope.authenticationClick(scope, { $event: event });
								return;
							}
							$uibModalStack.dismissAll();
							// $state.go("sign-up.select-account-type");
							var authenticationFor = '';
							if(scope.authenticationFor){
							authenticationFor = scope.authenticationFor == 'contributor' ? accountConst.ACCOUNT_TYPE.PERSONAL : ((scope.authenticationFor == 'business') ? accountConst.ACCOUNT_TYPE.BUSINESS : '');
							}
							completeProfilePopupSvc.showPopup({'authenticationFor': authenticationFor});
							return;
						} else if (attr.checkVerifiedEmail && !mLoginnedUser.is_email_verified) {
							$uibModalStack.dismissAll();
							if (mLoginnedUser.isBiz) {
								verifiedBusinessUserPopupSvc.showPopup();
							} else {
								resendVerificationEmailPopupSvc.showVerifyEmailPopup();
							}
						} else if(attr.authenticationClick) {
							scope.authenticationClick(scope, { $event: event });
						}
					}
				})
			}
		}
	}
})();

'use strict';

var directiveModule = angular.module('angularjs-dropdown-multiselect', []);

directiveModule.directive('ngDropdownMultiselect', ['$filter', '$document', '$compile', '$parse', '$timeout', 'systemUtils',
    function ($filter, $document, $compile, $parse, $timeout, systemUtils) {

        return {
            restrict: 'AE',
            scope: {
                selectedModel: '=',
                options: '=',
                extraSettings: '=',
                events: '=',
                searchFilter: '=?',
                translationTexts: '=',
                groupBy: '@',
                isDisabled: "=",
                isCategorySelection: "="
            },
            template: function (element, attrs) {
                var checkboxes = attrs.checkboxes ? true : false;
                var groups = attrs.groupBy ? true : false;

                var template = '<div class="multiselect-parent btn-group dropdown-multiselect">';
                template += '<button ng-disabled="isDisabled" type="button" class="dropdown-toggle" ng-class="settings.buttonClasses" ng-click="toggleDropdown()"><div class="angularjs-dropdown-multiselect__dropdown-btn text--truncate pull-left" translate>{{getButtonText()}}&nbsp;</div><span ng-class="settings.caretClass ?  settings.caretClass : ' + "'caret'" + '"></span></button>';
                template += '<ul ng-class="settings.dropdownClass" class="dropdown-menu dropdown-menu-form" ng-style="{display: open ? \'grid\' : \'none\'}" style="overflow: scroll" >';
                template += '<div ng-show="settings.closeOnClick" class="clearfix tip-top-categories"><div><span class="text--bold">{{\'tips\' | translate}}:</span> {{\'tips-select-multiple-categories\' | translate}}</div></div>';
                template += '<li ng-hide="!settings.showCheckAll || settings.selectionLimit > 0"><a data-ng-click="selectAll()"><span class="glyphicon glyphicon-ok"></span>  {{texts.checkAll}}</a>';
                template += '<li ng-show="settings.showUncheckAll" class="multiple-dropdown-selection__select-all-btn"><a class="text--bold" data-ng-click="deselectAll();">{{texts.uncheckAll}}</a></li>';
                template += '<li ng-show="settings.enableSearch"><div class="dropdown-header"><input type="text" class="form-control" style="width: 100%;" ng-model="searchFilter" placeholder="{{texts.searchPlaceholder}}" /></li>';
                template += '<li ng-show="settings.enableSearch" class="divider"></li>';

                if (groups) {
                    template += '<li ng-repeat-start="option in orderedItems | filter: searchFilter" ng-show="getPropertyForObject(option, settings.groupBy) !== getPropertyForObject(orderedItems[$index - 1], settings.groupBy)" role="presentation" class="dropdown-header">{{ getGroupTitle(getPropertyForObject(option, settings.groupBy)) }}</li>';
                    template += '<li ng-repeat-end role="presentation">';
                } else { 
                    if(attrs.isCategorySelection){
                    template += '<li role="presentation" ng-repeat="option in options | filter: searchFilter track by option.itemId" class="{{option.class}}" ng-style="{order: option.index}">';

                    } else {
                        template += '<li role="presentation" ng-repeat="option in options | filter: searchFilter">';
                    }
                }

                template += '<div role="menuitem" tabindex="-1" ng-click="setSelectedItem(getPropertyForObject(option,settings.idProp), false, $event)">';

                if (checkboxes) {
                    template += '<div class="checkbox"><label><input class="checkboxInput" type="checkbox" ng-click="checkboxClick($event, getPropertyForObject(option,settings.idProp))" ng-checked="isChecked(getPropertyForObject(option,settings.idProp))" /> {{getPropertyForObject(option, settings.displayProp)}}</label></div></div>';
                } else {
                    template += '<div data-ng-class="{\'display-text--is-selected\': isChecked(getPropertyForObject(option,settings.idProp))}" class="display-text">{{getPropertyForObject(option, settings.displayProp)}} </div><div data-ng-class="{\'icon-icons_check\': isChecked(getPropertyForObject(option,settings.idProp))}"></div></div>';
                }

                template += '</li>';

                template += '<li class="divider" ng-show="settings.showSelectionLimit && settings.selectionLimit > 1"></li>';
                template += '<li role="presentation" ng-show="settings.showSelectionLimit && settings.selectionLimit > 1"><a role="menuitem">{{selectedModel.length}} {{texts.selectionOf}} {{settings.selectionLimit}} {{texts.selectionCount}}</a></li>';

                template += '</ul>';
                template += '</div>';

                element.html(template);
            },
            link: function ($scope, element, $attrs) {
                var $element = $(element);
                var $dropdownTrigger = $element.children()[0];

                $scope.toggleDropdown = function () {
                    if($scope.isDisabled) return false;
                    $scope.open = !$scope.open;
                    var $dropdown = $element.find(".dropdown-menu");
                    var deltaX = $(window).innerWidth() - ($element.offset().left + $dropdown.outerWidth(true));
                    if(deltaX < 0){
                        $dropdown.css("left", deltaX);
                        $dropdown.addClass("dropdown-menu--adjusted-position");
                    } else {
                        $dropdown.css("left", "");
                        $dropdown.removeClass("dropdown-menu--adjusted-position");
                    }
                };

                $scope.checkboxClick = function ($event, id) {
                    $scope.setSelectedItem(id);
                    $event.stopImmediatePropagation();
                };

                $scope.externalEvents = {
                    onItemSelect: angular.noop,
                    onItemDeselect: angular.noop,
                    onSelectAll: angular.noop,
                    onDeselectAll: angular.noop,
                    onInitDone: angular.noop,
                    onMaxSelectionReached: angular.noop
                };

                $scope.settings = {
                    dynamicTitle: true,
                    scrollable: false,
                    scrollableHeight: '300px',
                    closeOnBlur: true,
                    displayProp: 'label',
                    idProp: 'id',
                    externalIdProp: 'id',
                    enableSearch: false,
                    selectionLimit: 0,
                    showCheckAll: true,
                    showSelectionLimit: false,
                    showUncheckAll: true,
                    closeOnSelect: false,
                    buttonClasses: 'btn btn-default',
                    closeOnDeselect: false,
                    uncheckCustomText: $scope.extraSettings.uncheckCustomText || undefined,
                    groupBy: $attrs.groupBy || undefined,
                    groupByTextProvider: null,
                    smartButtonMaxItems: 0,
                    smartButtonTextConverter: angular.noop
                };

                $scope.texts = {
                    checkAll: 'Check All',
                    uncheckAll: $scope.settings.uncheckCustomText || 'Uncheck All',
                    selectionCount: 'checked',
                    selectionOf: '/',
                    searchPlaceholder: 'Search...',
                    buttonDefaultText: 'Select',
                    dynamicButtonTextSuffix: 'checked'
                };

                $scope.searchFilter = $scope.searchFilter || '';

                if (angular.isDefined($scope.settings.groupBy)) {
                    $scope.$watch('options', function (newValue) {
                        if (angular.isDefined(newValue)) {
                            $scope.orderedItems = $filter('orderBy')(newValue, $scope.settings.groupBy);
                        }
                    });
                }

                angular.extend($scope.settings, $scope.extraSettings || []);
                angular.extend($scope.externalEvents, $scope.events || []);
                angular.extend($scope.texts, $scope.translationTexts);

                $scope.singleSelection = $scope.settings.selectionLimit === 1;

                function getFindObj(id) {
                    var findObj = {};

                    if ($scope.settings.externalIdProp === '') {
                        findObj[$scope.settings.idProp] = id;
                    } else {
                        findObj[$scope.settings.externalIdProp] = id;
                    }

                    return findObj;
                }

                function clearObject(object) {
                    for (var prop in object) {
                        delete object[prop];
                    }
                }

                if ($scope.singleSelection) {
                    if (angular.isArray($scope.selectedModel) && $scope.selectedModel.length === 0) {
                        clearObject($scope.selectedModel);
                    }
                }

                if ($scope.settings.closeOnBlur) {
                    $document.on('click', function (e) {
                        var target = e.target.parentElement;
                        var parentFound = false;

                        while (angular.isDefined(target) && target !== null && !parentFound) {
                            if (_.contains(target.className.split(' '), 'multiselect-parent') && !parentFound) {
                                if(target === $dropdownTrigger) {
                                    parentFound = true;
                                }
                            }
                            target = target.parentElement;
                        }

                        if (!parentFound) {
                            $timeout(function(){
                                $scope.$apply(function () {
                                    $scope.open = false;
                                });
                            })
                        }
                    });
                }

                $scope.getGroupTitle = function (groupValue) {
                    if ($scope.settings.groupByTextProvider !== null) {
                        return $scope.settings.groupByTextProvider(groupValue);
                    }

                    return groupValue;
                };

                $scope.getButtonText = function () {
                    if ($scope.settings.dynamicTitle && ($scope.selectedModel && $scope.selectedModel.length > 0 || (angular.isObject($scope.selectedModel) && _.keys($scope.selectedModel).length > 0))) {
                        if ($scope.settings.smartButtonMaxItems > 0) {
                            var itemsText = [];
                            angular.forEach($scope.selectedModel, function (selectedItem) {
                                var optionItem = _.find($scope.options, function(it){
                                    return it[$scope.settings.idProp] === selectedItem[$scope.settings.idProp];
                                })
                                if (optionItem) {
                                    var displayText = $scope.getPropertyForObject(optionItem, $scope.settings.displayProp);
                                    var converterResponse = $scope.settings.smartButtonTextConverter(displayText, optionItem);
                                    itemsText.unshift(converterResponse ? converterResponse : displayText);
                                }
                            });

                            if ($scope.selectedModel.length > $scope.settings.smartButtonMaxItems) {
                                itemsText = itemsText.slice(0, $scope.settings.smartButtonMaxItems);
                                itemsText.push('...');
                            }

                            return itemsText.join(', ');
                        } else {
                            var totalSelected;

                            if ($scope.singleSelection) {
                                totalSelected = ($scope.selectedModel !== null && angular.isDefined($scope.selectedModel[$scope.settings.idProp])) ? 1 : 0;
                            } else {
                                totalSelected = angular.isDefined($scope.selectedModel) ? $scope.selectedModel.length : 0;
                            }

                            if (totalSelected === 0) {
                                return $scope.texts.buttonDefaultText;
                            } else {
                                return totalSelected + ' ' + $scope.texts.dynamicButtonTextSuffix;
                            }
                        }
                    } else {
                        return $scope.texts.buttonDefaultText;
                    }
                };

                $scope.getPropertyForObject = function (object, property) {
                    if (angular.isDefined(object) && object.hasOwnProperty(property)) {
                        return object[property];
                    }

                    return '';
                };

                $scope.selectAll = function () {
                    $scope.deselectAll(false);
                    $scope.externalEvents.onSelectAll();

                    angular.forEach($scope.options, function (value) {
                        $scope.setSelectedItem(value[$scope.settings.idProp], true);
                    });
                };

                $scope.deselectAll = function (sendEvent) {
                    sendEvent = sendEvent || true;

                    if (sendEvent) {
                        $scope.externalEvents.onDeselectAll();
                    }

                    if ($scope.singleSelection) {
                        clearObject($scope.selectedModel);
                    } else {
                        $scope.selectedModel.splice(0, $scope.selectedModel.length);
                    }

                    $scope.externalEvents.onItemDeselect();
                    $("body").trigger("click");
                };

                $scope.setSelectedItem = function (id, dontRemove, $event) {
                    var findObj = getFindObj(id);
                    var finalObj = null;

                    if ($scope.settings.externalIdProp === '') {
                        finalObj = _.find($scope.options, findObj);
                    } else {
                        finalObj = findObj;
                    }

                    if($scope.settings.singleClick){
                        singleClick($event);
                    }

                    if ($scope.singleSelection) {
                        clearObject($scope.selectedModel);
                        angular.extend($scope.selectedModel, finalObj);
                        $scope.externalEvents.onItemSelect(finalObj);

                        return;
                    }

                    dontRemove = dontRemove || false;

                    var exists = _.findIndex($scope.selectedModel, findObj) !== -1;

                    if (!dontRemove && exists) {
                        $scope.selectedModel.splice(_.findIndex($scope.selectedModel, findObj), 1);
                        $scope.externalEvents.onItemDeselect(findObj);
                    } else if (!exists) {
                        if($scope.settings.selectionLimit === 0 || $scope.selectedModel.length < $scope.settings.selectionLimit){
                            $scope.selectedModel.push(finalObj);
                            $scope.externalEvents.onItemSelect(finalObj);
                        } else {
                            $scope.externalEvents.onMaxSelectionReached();
                        }
                    }

                    if(isCloseOnClick($event)){
                        $("body").trigger("click");
                        $event.stopPropagation();
                    } else {
                        systemUtils.preventTextSelection();
                    }
                };

                function isCloseOnClick($event){
                    if($scope.settings.closeOnClick && $event && !$event.shiftKey)
                        return true;
                    return false;
                }

                function singleClick($event){
                    if($event && !$event.shiftKey){
                        $scope.deselectAll();
                    }
                }

                $scope.isChecked = function (id) {
                    if ($scope.singleSelection) {
                        return $scope.selectedModel !== null && angular.isDefined($scope.selectedModel[$scope.settings.idProp]) && $scope.selectedModel[$scope.settings.idProp] === getFindObj(id)[$scope.settings.idProp];
                    }

                    return _.findIndex($scope.selectedModel, getFindObj(id)) !== -1;
                };

                $scope.externalEvents.onInitDone();
            }
        };
}]);

(function () {
    'use strict';

    angular.module('fancyboxplus', [])
        .service('fancyboxService', fancyboxService)
        .directive('fancyboxable', fancyboxableDirective)
        .directive('fancybox', fancyboxDirective);

    function fancyboxService() {

        //Fancybox-Plus JavaScript API reference:
        // http://igorlino.github.io/fancybox-plus/api.htm

        var service = {
            fancyboxPlus: fancyboxPlus, //returns the fancyboxplus jquery plugin

            showActivity: showActivity,//Shows loading animation
            hideActivity: hideActivity,//Hides loading animation
            next: next,//Displays the next gallery item
            prev: prev,//Displays the previous gallery item
            pos: pos,//Displays item by index from gallery
            cancel: cancel,//Cancels loading content
            close: close,//Hides FancyBox. Within an iframe use - parent.close();
            resize: resize,//Auto-resizes FancyBox height to match height of content
            center: center//Centers FancyBox in viewport
        };
        return service;

        function fancyboxPlus() {
            return $.fancyboxPlus;
        }

        function showActivity() {
            fancyboxPlus().showActivity();
        }

        function hideActivity() {
            fancyboxPlus().hideActivity();
        }

        function pos() {
            fancyboxPlus().pos();
        }

        function cancel() {
            fancyboxPlus().cancel();
        }

        function center() {
            fancyboxPlus().center();
        }

        function next() {
            fancyboxPlus().next();
        }

        function prev() {
            fancyboxPlus().prev();
        }

        function close() {
            fancyboxPlus().close();
        }

        function resize() {
            fancyboxPlus().resize();
        }
    }

    fancyboxableDirective.$inject = ['$compile', '$rootScope', '$http', '$parse', '$timeout', 'fancyboxService'];
    function fancyboxableDirective($compile, $rootScope, $http, $parse, $timeout, fancyboxService) {
        var service = {
            restrict: 'A',
            link: fancyboxableLink,
            priority: 100 // must lower priority than ngSrc (99)
        };
        return service;

        fancyboxableLink.$inject = ['$scope', '$element', '$attributes'];
        function fancyboxableLink($scope, $element, $attributes) {
            var fbp = null;

            $scope.$on('$destroy', function () {
                $element.remove();
            });

            init();

            function init(open) {
                var options = {
                    href: $attributes.src ? $attributes.src : $attributes.href,
                    onComplete: function () {
                        onComplete();
                    }
                };

                //generic way that sets all (non-function) parameters of fancybox-plus.
                if ($attributes.fancyboxable && $attributes.fancyboxable.length > 0) {
                    var fbpOptionsFunc = $parse($attributes.fancyboxable);
                    var fbpOptions = fbpOptionsFunc($scope);
                    angular.extend(options, fbpOptions);
                }

                //clean undefined
                for (var key in options) {
                    if (options.hasOwnProperty(key)) {
                        if (typeof(options[key]) === 'undefined') {
                            delete options[key];
                        }
                    }
                }

                if (typeof(open) !== 'undefined') {
                    options.open = open;
                }

                //wait for the DOM view to be ready
                $timeout(function () {

                    if (!$attributes.ngSrc) {
                        //opens the fancybox using an href.
                        fbp = $($element).fancyboxPlus(options);
                    } else {
                        //$element.bind('load', function() {
                        /*$scope.$apply(function () {
                         options.href = $attributes.src ? $attributes.src : $attributes.href;
                         cb = $.colorbox(options);
                         });*/
                        //wait for the DOM view to be ready
                        $timeout(function () {
                            options.href = $attributes.src ? $attributes.src : $attributes.href;
                            fbp = $($element).fancyboxPlus(options);
                        }, 300);
                        //});
                    }


                }, 0);
            }

            function onComplete() {
                $rootScope.$apply(function () {
                    var content = $('#fbplus-content');
                    $compile(content)($rootScope);
                });
            }
        }


    }

    fancyboxDirective.$inject = ['$compile', '$rootScope', '$http', '$parse', '$timeout', 'fancyboxService'];
    function fancyboxDirective($compile, $rootScope, $http, $parse, $timeout, fancyboxService) {
        var service = {
            restrict: 'E',
            scope: {
                open: '=',
                options: '=',
                templateUrl: '&',

                onStart: '&', //Will be called right before attempting to load the content
                onCancel: '&', //Will be called after loading is canceled
                onComplete: '&', //Will be called once the content is displayed
                onCleanup: '&', //Will be called just before closing
                onClosed: '&' //Will be called once FancyBox is closed

            },
            // require: 'fancybox',
            link: link
            // controller: controller,
            // controllerAs: 'vm'
        };
        return service;

        link.$inject = ['$scope', '$element', '$attributes'];
        function link($scope, $element, $attributes) {
            var fbp = null;

            $scope.$watch('open', function (newValue, oldValue) {
                if (oldValue !== newValue) {
                    updateOpen(newValue);
                }
            });

            $scope.$on('$destroy', function () {
                $element.remove();
            });

            init();

            function updateOpen(newValue) {
                if (newValue) {
                    init(newValue);
                } else {
                    fancyboxService.close();
                }
            }

            function init(open) {
                var options = {
                    href: $attributes.src,
                    boxFor: $attributes.boxFor,
                    onOpen: function () {
                        if ($scope.onOpen && $scope.onOpen()) {
                            $scope.onOpen()();
                        }
                    },
                    onCancel: function () {
                        if ($scope.onCancel && $scope.onCancel()) {
                            $scope.onCancel()();
                        }
                    },
                    onComplete: function () {
                        onComplete();
                        if ($scope.onComplete && $scope.onComplete()) {
                            $scope.onComplete()();
                        }
                    },
                    onCleanup: function () {
                        if ($scope.onCleanup && $scope.onCleanup()) {
                            $scope.onCleanup()();
                        }
                    },
                    onClosed: function () {
                        $scope.$apply(function () {
                            $scope.open = false;
                        });
                        if ($scope.onClosed && $scope.onClosed()) {
                            $scope.onClosed()();
                        }
                    }
                };

                //generic way that sets all (non-function) parameters of fancybox-plus.
                if ($scope.options) {
                    angular.extend(options, $scope.options);
                }

                //clean undefined
                for (var key in options) {
                    if (options.hasOwnProperty(key)) {
                        if (typeof(options[key]) === 'undefined') {
                            delete options[key];
                        }
                    }
                }

                if (typeof(open) !== 'undefined') {
                    options.open = open;
                }

                //wait for the DOM view to be ready
                $timeout(function () {
                    if (options.boxFor) {
                        //opens the element by id boxFor
                        fbp = $(options.boxFor).fancyboxPlus(options);
                    } else if (options.href) {
                        //opens the fancybox-plus using an href.
                        fbp = $.fancyboxPlus(options);
                    }
                }, 0);
            }

            function onComplete() {
                $rootScope.$apply(function () {
                    var content = $('#fbplus-content');
                    $compile(content)($rootScope);
                });
            }
        }
    }

})
();
(function () {

	angular
		.module('pixerf')
		.controller('completeProfilePageCtrl', completeProfilePageCtrl);

	completeProfilePageCtrl.$inject = ['$rootScope', '$scope', 'sessionManagerSvc', '$state', 'stringUtils', 'arrayUtils', 'messageConst', 'systemUtils'];

	function completeProfilePageCtrl($rootScope, $scope, sessionManagerSvc, $state, stringUtils, arrayUtils, messageConst, systemUtils) {

		var self = this;
		self.loginedUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.userAvatar = self.loginedUser.avatar && self.loginedUser.avatar.profileImage ? self.loginedUser.avatar.profileImage : 'assets/images/person-circle.png';
		self.onIncompleteProfileClicked = onIncompleteProfileClicked;
		self.onSkipClicked = onSkipClicked;

		$rootScope.$on(messageConst.BROADCAST.USER_DATA_CHANGE, function(){
			self.userAvatar = sessionManagerSvc.getCurrentLoginUser().data.profile_image_media['300x'];
			self.loginedUser = sessionManagerSvc.getCurrentLoginUser().data;
			systemUtils.digest($scope);
		})

		isSkillCompleted();

		function onIncompleteProfileClicked(){
			if(self.loginedUser && !self.loginedUser.profile_image){
				$state.go("complete-profile-photo");
			} else {
				$state.go("complete-profile-skills");
			}
		}

		function onSkipClicked(){
			$state.go("user-home-page.business");
		}

		function isSkillCompleted(){
			if(self.loginedUser && self.loginedUser.bio && self.loginedUser.profile && arrayUtils.isValueArr(self.loginedUser.profile.specialities) &&
			stringUtils.isValueString(self.loginedUser.profile.years_of_experience) && stringUtils.isValueString(self.loginedUser.profile.services_rate_amount) &&
			self.loginedUser.profile.services_rate_type && arrayUtils.isValueArr(self.loginedUser.profile.cameras) && ((self.loginedUser.profile.availability_weekdays && self.loginedUser.profile.availability_weekdays.length) ||
            (self.loginedUser.profile.availability_weekends && self.loginedUser.profile.availability_weekends.length))){
				self.isSkillCompleted = true;
			} else {
				self.isSkillCompleted = false;
			}
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.config(routerConfig);

	routerConfig.$inject = ['$stateProvider'];

	function routerConfig($stateProvider) {
		'ngInject';
		$stateProvider
			.state('complete-profile-page', {
				url: '/complete-profile-page',
				templateUrl: 'app/complete-profile-page/complete-profile-page.html',
				controller: 'completeProfilePageCtrl',
				controllerAs: 'vm',
				data: {
					pageTitle: "PIXERF - Complete Profile",
					permissions: {
						only: ['AUTHORIZED'],
						redirectTo: function () {
							return "404"  ;
						}
					},
					hideFooter: true
				}
			});
	}
})();

/**
 * Controller for home module
 */
(function(){

  angular
    .module('pixerf')
    .controller('communityInviteLandingPageCtrl', communityInviteLandingPageCtrl);

    communityInviteLandingPageCtrl.$inject = [];

    function communityInviteLandingPageCtrl(){
    	var self = this;
    }
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.config(routerConfig);

	routerConfig.$inject = ['$stateProvider'];

	function routerConfig($stateProvider) {
		'ngInject';
		$stateProvider
			.state('community-invite-landing-page', {
				url: '/community-invite-landing-page',
				templateUrl: 'app/community-invite-landing-page/community-invite-landing-page.html',
				controller: 'communityInviteLandingPageCtrl',
				controllerAs: 'vm',
				data: {
					permissions: {
						only: ['EVERY_ONE']
					},
					pageTitle: "PIXERF - Invitation for "
				}
			})
	}

})();

﻿(function(){

  angular
    .module('pixerf')
    .factory('communityDetailPageSvc', communityDetailPageSvc);

    communityDetailPageSvc.$inject = [];

    function communityDetailPageSvc(){


		return {

		};
    }
})();

(function () {

	angular
		.module('pixerf')
		.controller('communityDetailPageCtrl', communityDetailPageCtrl);

	communityDetailPageCtrl.$inject = ['sessionManagerSvc', 'createCommunityPopupSvc', 'commonConst', 'communityData', 'communityConst', '$state', 'pixerfApiCommunitySvc', 'translationSvc', '$translate', 'toastr', 'confirmPopupSvc', '$timeout', 'inviteCommunityMembersPopupSvc', 'pixerfDiscussionReportPopupSvc', 'pixerfApiEventSvc', 'createEventPopupSvc', 'inviteUserPopupSvc', 'ISO3166'];

	function communityDetailPageCtrl(sessionManagerSvc, createCommunityPopupSvc, commonConst, communityData, communityConst, $state, pixerfApiCommunitySvc, translationSvc, $translate, toastr, confirmPopupSvc, $timeout, inviteCommunityMembersPopupSvc, pixerfDiscussionReportPopupSvc, pixerfApiEventSvc, createEventPopupSvc, inviteUserPopupSvc, ISO3166) {

		var self = this;
		var pixerfEnv = new PixerfEnv().getEnv();
		self.onEditBtnClicked = onEditBtnClicked;
		self.goBackBtnClicked = goBackBtnClicked;
		self.onManageCommunityClicked = onManageCommunityClicked;
		self.onManageBtnLeft = onManageBtnLeft;
		self.onManageBtnHovered = onManageBtnHovered;
		self.onLeaveCommunityClicked = onLeaveCommunityClicked;
		self.onWithDrawRequestClicked = onWithDrawRequestClicked;
		self.onRequestToJoinedClicked = onRequestToJoinedClicked;
		self.community = communityData;
		self.shareLink = pixerfEnv === "PRODUCTION" ? 'https://pixerf.com/#/c/' + self.community.short_code : 'https://qa.pixerf.com/#/c/' + self.community.short_code;
		self.commonConst = commonConst;
		self.communityConst = communityConst;
		self.loginUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.isMine = self.loginUser && self.loginUser.canManageCommunity && self.community.owner.id === self.loginUser.id;
		self.canUpdateCommunity = (self.community && self.community.status == 'active');
		self.isManager = self.community.membership_status === 'manager';
		self.isMember = false;
		self.onCommunityMembershipChanged = onCommunityMembershipChanged;
		self.onBackBtnClicked = onBackBtnClicked;
		self.onSendInviteEmail = onSendInviteEmail;
		self.uploadCommunityAvatarOptions = {};
		self.contextPage = "Community Details";
		self.onInviteMembers = onInviteMembers;
		self.onSendInviteLink = onSendInviteLink;
		self.onCreateCommunity = onCreateCommunity;
		self.onCreateEvent = onCreateEvent;
		self.onDeleteCommunityClicked = onDeleteCommunityClicked;
		self.badgeCommunity = "icon-community_2";
		self.maxStrikes = 3;
		self.SocialShareContent = {};
		self.searchParamsCommunities = {};
		self.searchParamsJoinedCommunities = {};
		self.searchParamsEvents = {};
		self.searchParamsJoinedEvents = {};
		self.shareSettings = {
			circle: true
		};
		self.onReportComminity = onReportComminity;
		self.yourCommunities = [];
		self.joinedCommunities = [];
		self.yourEvents = [];
		self.joinedEvents = [];
		self.yourEventClasses = [];
		self.joinedEventClasses = [];
		self.managers = [];
		self.rules = [];
        self.description = [];
        self.canGoBusinessProfile = self.isMine || self.community.owner.account_type === 'personal' || (self.loginUser && self.loginUser.isAdminInternal);

		init();

		function init() {
			isContentShowed();
			genLabelHeaderButton();
			self.defaultShareText = "Hi there! I would like to invite you to join my Community, \"" + self.community.name + "\" on PIXERF. " + self.shareLink;
			self.communityAvatar = {
				url: self.community.cover && self.community.cover.thumbnail ? self.community.cover.thumbnail : '/assets/images/default/community-default-avatar.png'
			}
			if (self.loginUser && (!self.community.is_private || (self.community.is_private && (self.community.membership_status === 'accepted' || self.community.membership_status === 'manager' || self.isMine)))) {
				getManagers();
				getMemberOfCommunity();
			}
			if (self.isMine || self.community.membership_status === self.communityConst.MEMBERSHIP.MANAGER) {
				$timeout(function () {
					bindShareText();
				});
			}
			self.SocialShareContent = buildSocialShareContent(self.community);

			if (self.loginUser) {
				self.searchParamsCommunities = {
					status: 'active',
					membership: 'owner',
					user_id: self.loginUser.id,
					page: 1,
					page_size: 3
				};
				self.searchParamsEvents = {
					event_statuses: 'active,reported',
					id: self.loginUser.id,
					user_id: self.loginUser.id,
					event_type: 'standard',
					page: 1,
					page_size: 3
				};
				self.searchParamsEventClasses = {
					event_statuses: 'active,reported',
					id: self.loginUser.id,
					user_id: self.loginUser.id,
					event_type: 'class',
					page: 1,
					page_size: 3
				};

				getYourCommunities();
				getYourEvents();
				getYourEventClasses();
			}

			if (self.loginUser && !self.loginUser.isBiz) {
				self.searchParamsJoinedCommunities = {
					status: 'active',
					membership: 'accepted,manager',
					user_id: self.loginUser.id,
					page: 1,
					page_size: 3
				};
				self.searchParamsJoinedEvents = {
					event_statuses: 'active,reported',
					id: self.loginUser.id,
					user_id: self.loginUser.id,
					event_type: 'standard',
					page: 1,
					page_size: 3
				};
				self.searchParamsJoinedEventClasses = {
					event_statuses: 'active,reported',
					id: self.loginUser.id,
					user_id: self.loginUser.id,
					event_type: 'class',
					page: 1,
					page_size: 3
				};

				getJoinedEvents();
				getJoinedEventClasses();
				getJoinedCommunities();
			}

			getCountriesCommunity();
			getPostingPermission();
			generateBadge();
			processRule();
		}

		function generateBadge() {
			if (self.community.is_unlisted) {
				self.badgeCommunity = "icon-icons_hide-password";
			} else if (self.community.is_private) {
				self.badgeCommunity = "icon-lock";
			} else {
				self.badgeCommunity = "icon-community_2";
			}
		}

		function getYourCommunities() {
			pixerfApiCommunitySvc.list(self.searchParamsCommunities).$promise.then(function (response) {
				self.yourCommunities = response.data;
			}).catch(function (error) {
				console.log(error);
			})
		}

		function getJoinedCommunities() {
			pixerfApiCommunitySvc.list(self.searchParamsJoinedCommunities).$promise.then(function (response) {
				self.joinedCommunities = response.data;
			}).catch(function (error) {
				console.log(error);
			})
		}

		function getYourEvents() {
			pixerfApiEventSvc.get_hosting_events(self.searchParamsEvents).$promise.then(function (response) {
				self.yourEvents = response.data;
			}).catch(function (error) {
				console.log(error);
			})
		}

		function getJoinedEvents() {
			pixerfApiEventSvc.get_joined_events(self.searchParamsJoinedEvents).$promise.then(function (response) {
				self.joinedEvents = response.data;
			}).catch(function (error) {
				console.log(error);
			})
		}

		function getYourEventClasses() {
			pixerfApiEventSvc.get_hosting_events(self.searchParamsEventClasses).$promise.then(function (response) {
				self.yourEventClasses = response.data;
			}).catch(function (error) {
				console.log(error);
			})
		}

		function getJoinedEventClasses() {
			pixerfApiEventSvc.get_joined_events(self.searchParamsJoinedEventClasses).$promise.then(function (response) {
				self.joinedEventClasses = response.data;
			}).catch(function (error) {
				console.log(error);
			})
		}

		function getManagers() {
			var params = {
				id: self.community.id,
				membership: 'owner,manager',
				page: 1
			};
			pixerfApiCommunitySvc.get_members(params).$promise.then(function (res) {
				self.managers = res.data;
				for (var i = 0; i < self.managers.length; i++) {
					self.managers[i].archivement = genArchivement(self.managers[i]);
				}
			}).catch(function (err) {
				console.log(err)
			})
		}

		function genArchivement(manager) {
			if (manager.account_type === 'business') {
				return 'Business';
			} else if (manager.ambassadorship === 'pro') {
				return 'Ambassador Pro';
			} else if (manager.ambassadorship === 'maestro') {
				return 'Ambassador Maestro';
			} else {
				return 'Personal';
			}
		}

		function onInviteMembers() {
			inviteCommunityMembersPopupSvc.showPopup({
				community: self.community,
				defaultSearchCondition: {
					isDirectoryChecked: true,
					isEmailChecked: false,
					country: "",
					speciality: ""
				}
			});
		}

		function goBackBtnClicked() {
			window.history.back();
		}

		function onEditBtnClicked() {
			var editedCommunity = $.extend(true, {}, self.community);
			var popup = createCommunityPopupSvc.showPopup({
				mode: commonConst.ACTION.EDIT,
				route: 'no-navigate',
				community: editedCommunity
			});
			popup.result.then(function () {
				self.community.name = editedCommunity.name;
				self.community.description = editedCommunity.description;
			})
		}

		function buildSocialShareContent(community) {
			return {
				'url': window.location.href,
				'description': community.description,
				'title': community.title,
				'media': community.coverImagePath
			};
		}

		function onCommunityMembershipChanged(community) {
			self.community = community;
			isContentShowed();
			$state.reload();
		}

		function isContentShowed() {
			self.isPrivateContentCommunity = self.community.is_private && self.community.membership_status != self.communityConst.MEMBERSHIP.ACCEPTED && self.community.membership_status != self.communityConst.MEMBERSHIP.OWNER;
			self.isInvited = self.community.membership_status === self.communityConst.MEMBERSHIP.INVITED;
		}

		function onBackBtnClicked() {
			window.history.go(-1);
		}

		function onManageCommunityClicked(tabName) {
			$state.go("manage-community.edit-community", {
				id: self.community.id,
				name: self.community.name,
				status: tabName
			});
		}

		function getMemberOfCommunity() {
			var params = {
				id: self.community.id,
				membership: 'accepted',
				page_size: 50
			};
			pixerfApiCommunitySvc.get_members(params).$promise.then(function (res) {
				self.members = res.data;
				if (self.loginUser) {
					var member = _.find(self.members, function (user) {
						return user.id === self.loginUser.id;
					});
					self.isMember = (member && member.id);
				}
				for (var i = 0; i < self.members.length; i++) {
					self.members[i].avatar = self.members[i].profile_image_media && self.members[i].profile_image_media['100x'] ? self.members[i].profile_image_media['100x'] : 'assets/images/default/default-profile.png';
				}
			}).catch(function (err) {
				console.log(err)
			})
		}

		function genLabelHeaderButton() {
			self.isLeaveBtn = !self.isMine && self.loginUser && !self.loginUser.isBiz && self.community.membership_status === self.communityConst.MEMBERSHIP.ACCEPTED;
			if (!self.isLeaveBtn) {
				self.isWithdrawRequestBtn = !self.isMine && self.loginUser && !self.loginUser.isBiz && self.community.membership_status === self.communityConst.MEMBERSHIP.REQUESTED;
			}
		}

		function onManageBtnHovered() {
			self.isHovering = true;
		}

		function onManageBtnLeft() {
			self.isHovering = false;
		}

		function onLeaveCommunityClicked() {
			var confirmMessage = translationSvc.ARE_YOU_SURE_TO_DO_SOMETHING("LEAVE_THE_COMMUNITY", {
				community: self.community.name
			});
			var modal = confirmPopupSvc.showPopup({
				hideTitle: true,
				hideConfirmText: true,
				message: confirmMessage
			});

			modal.result.then(function () {
				pixerfApiCommunitySvc.withdraw_request({
					community_ids: [self.community.id]
				}).$promise.then(function (respone) {
					onCommunityMembershipChanged(self.community);
					toastr.success($translate.instant('no-longer-receive-notifications-from-community', {
						community: self.community.name
					}));
				}).catch(function (err) {
					console.log(err);
					toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
				});
			});
		}

		function onWithDrawRequestClicked() {
			var confirmMessage = translationSvc.ARE_YOU_SURE_TO_DO_SOMETHING("WITHDRAW_REQUEST_JOIN_THE_COMMUNITY", {
				community: self.community.name
			});
			var modal = confirmPopupSvc.showPopup({
				hideTitle: true,
				hideConfirmText: true,
				message: confirmMessage
			});

			modal.result.then(function () {
				pixerfApiCommunitySvc.withdraw_request({
					community_ids: [self.community.id]
				}).$promise.then(function (respone) {
					onCommunityMembershipChanged(self.community);
					toastr.success($translate.instant('you-have-withdrawn-successfully'));
				}).catch(function (err) {
					console.log(err);
					toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
				})
			})
		}

		function onRequestToJoinedClicked() {
			self.isWorking = true;
			pixerfApiCommunitySvc.join({
				id: self.community.id
			}, null).$promise.then(function (respone) {
				onCommunityMembershipChanged(self.community);
				toastr.success($translate.instant('requested-join-community'));
				self.isWorking = false;
			}).catch(function (err) {
				self.isWorking = false;
				if (err && err.data && err.data.data && err.data.data.message) {
					toastr.error(err.data.data.message);
				} else {
					toastr.error(translationSvc.OOPS_DO_SOMETHING_WRONG('SOME_THING_WRONG', true, true));
				}
			})
		}

		function bindShareText() {
			var whatsappLink = "whatsapp://send?text=" + encodeURIComponent(self.defaultShareText);
			appendShareLink("whatsappComShare", whatsappLink);
		}

		function appendShareLink(elementIdSelector, shareLink) {
			var h = document.getElementById(elementIdSelector);
			var s = document.createElement("a");
			var link = shareLink;
			s.setAttribute('href', link);
			h.appendChild(s);
		}

		function onSendInviteEmail() {
			var email = '?body=' + self.defaultShareText;
			window.open('mailto:' + email);
		}

		function onSendInviteLink() {
			inviteCommunityMembersPopupSvc.showPopup({
				community: self.community,
				defaultSearchCondition: {
					isDirectoryChecked: false,
					isEmailChecked: false,
					isLinkChecked: true,
					country: "",
					speciality: ""
				}
			});
		}

		function onReportComminity() {
			pixerfDiscussionReportPopupSvc.showPopup({
				id: self.community.id,
				target: 'report_community'
			});
		}

		function onCreateCommunity() {
			createCommunityPopupSvc.showPopup();
		}

        function processRule() {
			var regex = /\d{1,2}[\,\.]/g;
			var rules = [];
            var description = [];
			if (self.community && self.community.rules) {
				rules = self.community.rules.split("\n");
			}
			for (var i = 0; i < rules.length; i++) {
				self.rules = self.rules.concat({
					text: rules[i],
					isLineItem: !!(rules[i].match(regex) && rules[i].match(regex).length)
				});
			}

            if (self.community && self.community.description) {
				description = self.community.description.split("\n");
			}
			for (var i = 0; i < description.length; i++) {
				self.description = self.description.concat({
					text: description[i],
					isLineItem: !!(description[i].match(regex) && description[i].match(regex).length)
				});
			}
		}

		function onCreateEvent(eventType) {
			var popupData = {
				community: self.community,
				type: eventType
			}
			var eventPopup = createEventPopupSvc.showPopup(popupData);

			eventPopup.result.then(function (event) {
				if (event.status === 'active') {
					self.yourEvents.unshift(event);
					showInviteFriendsPopup(event);
				}
			})
		}

		function getItemType(type){
			if(!type){
				return 'Event/Class';
			}else if(type == 'class'){
				return 'Class';
			}else {
				return 'Event';
			}
		}

		function showInviteFriendsPopup(event) {
			var inviteText = "Invite members to " + getItemType(event.event_type);
			inviteUserPopupSvc.showPopup({
				options: {
					title: inviteText
				},
				community: {
					id: self.community.id,
				},
				event: {
					id: event.id,
					short_code: event.short_code
				},
				defaultSearchCondition: {
					isDirectoryChecked: true,
					isEmailChecked: false,
					country: "",
					speciality: "",
					showSkipBtn: true
				}
			});
		}

		function getCountriesCommunity() {
			self.communityCountries = [];
			var countries = ISO3166.getCountryNames(self.community.countries)
			for (country in countries) {
				self.communityCountries.push(countries[country]);
			}
			self.communityCountries = self.communityCountries.join(", ");
		}

		function getPostingPermission() {
			switch (self.community.start_discussion_permission) {
				case 'anyone':
					self.postingPermission = 'Any member in the Community can start a discussion and reply to the threads.';
					break;
				case 'only_admin':
					self.postingPermission = 'Only admins can start a discussion. Members will only be allowed to reply.';
					break;
			}
		}

		function onDeleteCommunityClicked() {
			var confirmMessage = $translate.instant("delete-community-confirm");
			var modal = confirmPopupSvc.showPopup({
				windowClass: 'confirm-action-popup',
				hideTitle: true,
				hideConfirmText: true,
				cancelBtnText: 'Cancel',
				title: confirmMessage
			});
			modal.result.then(function () {
				pixerfApiCommunitySvc.delete({
					id: self.community.id
				}).$promise.then(function (response) {
					toastr.success("Your community deleted successfully");
					$state.go("user-home-page.personal.communities.grid");
				}, function (err) {});
			})
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.config(routerConfig);

	routerConfig.$inject = ['$stateProvider'];

	function routerConfig($stateProvider) {
		'ngInject';
		$stateProvider
			.state('community-detail-page', {
				abstract: true,
				url: '/community-detail-page/:id/:name',
				templateUrl: 'app/community-detail-page/community-detail-page.html',
				controller: 'communityDetailPageCtrl',
				controllerAs: 'vm',
				data: {
					pageTitle: "PIXERF - Community Detail",
					permissions: {
						only: ['EVERY_ONE']
					},
					hideFooter: true
				},
				params: {
					"id": {
						squash: true,
						value: null
					},
					"name": {
						squash: true,
						value: null
					}
				},
				resolve: {
					communityData: function ($stateParams, pixerfApiCommunitySvc, $q, $state, commonConst) {
						var defer = $q.defer();
						var self = this;
						var communityId = parseInt($stateParams.id);
						if (!$stateParams.id || ($stateParams.id && isNaN(communityId))) {
							$state.go('404');
							defer.reject();
						} else {
							pixerfApiCommunitySvc.get({
								id: communityId
							}).$promise.then(function (response) {
								var community = response.data;
								self.data.pageTitle = "PIXERF - Community: " + community.name;
								defer.resolve(community);
							}, function (err) {
								console.log(err);
								$state.go(commonConst.STATE.COMMUNITY_NOT_FOUND);
								defer.reject();
							})
						}
						return defer.promise;
					}
				}
			})
			.state('community-detail-page.community-detail-events', {
				url: '/events',
				templateUrl: 'app/community-detail-page/components/community-detail-events/community-detail-events.html',
				controller: 'communityDetailEventsCtrl',
				controllerAs: 'vm'
			})
            .state('community-detail-page.community-detail-classes', {
				url: '/classes',
				templateUrl: 'app/community-detail-page/components/community-detail-classes/community-detail-classes.html',
				controller: 'communityDetailClassesCtrl',
				controllerAs: 'vm'
			})
			.state('community-detail-page.community-detail-photos', {
				url: '/photos',
				templateUrl: 'app/community-detail-page/components/community-detail-photos/community-detail-photos.html',
				controller: 'communityDetailPhotosCtrl',
				controllerAs: 'vm'
			})
			.state('community-detail-page.community-detail-album-detail', {
				url: '/albums/:albumId/:albumName',
				templateUrl: 'app/community-detail-page/components/community-detail-album-detail/community-detail-album-detail.html',
				controller: 'communityDetailAlbumDetailsCtrl',
				controllerAs: 'vm'
			})
			.state('community-detail-page.community-detail-discussions', {
				url: '',
				templateUrl: 'app/community-detail-page/components/community-detail-discussions/community-detail-discussions.html',
				controller: 'communityDetailDiscussionsCtrl',
				controllerAs: 'vm'
			});
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('checkoutCtrl', checkoutCtrl);

	checkoutCtrl.$inject = ['headerSvc', 'sessionManagerSvc'];

	function checkoutCtrl(headerSvc, sessionManagerSvc) {
		var self = this;

		self.user = sessionManagerSvc.getCurrentLoginUser().data;
		self.searchFilterBarSettings = headerSvc.getFixedByHeaderSetting();
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.config(routerConfig);

	routerConfig.$inject = ['$stateProvider'];

	function routerConfig($stateProvider) {
		'ngInject';
		$stateProvider
			.state('checkout', {
				templateUrl: 'app/checkout/checkout.html',
				data: {
					pageTitle: "PIXERF - Checkout"
				},
				controller: 'checkoutCtrl',
				controllerAs: 'vm',
				abstract: true
			})
			.state('checkout.shopping-cart', {
				url: '/checkout/shopping-cart',
				templateUrl: 'app/checkout/shopping-cart/shopping-cart-page.html',
				controller: 'shoppingCartPageCtrl',
				controllerAs: 'vm',
				data: {
					pageTitle: "PIXERF - Shopping Cart",
					permissions: {
						only: ['EVERY_ONE'],
						redirectTo: function () {
							return "404";
						}
					},
				}
			})
			.state('checkout.credit-plan', {
				url: '/checkout/credit-plan',
				templateUrl: 'app/checkout/credit-plan/credit-plan-page.html',
				controller: 'creditPlanPageCtrl',
				controllerAs: 'vm',
				data: {
					pageTitle: "PIXERF - Credit Plans",
					permissions: {
						only: ['EVERY_ONE'],
						redirectTo: function () {
							return "404";
						}
					}
				}
			})
			.state('checkout.billing-information', {
				url: '/checkout/billing-information',
				templateUrl: 'app/checkout/billing-information/billing-information-page.html',
				controller: 'billingInformationPageCtrl',
				controllerAs: 'vm',
				data: {
					pageTitle: "PIXERF - Billing Information",
					permissions: {
						only: ['AUTHORIZED'],
						redirectTo: function () {
							return "404";
						}
					},
				}
			})
			.state('checkout.event-payment', {
				url: '/checkout/event-payment/:id',
				templateUrl: 'app/checkout/event-payment-menthod/event-payment-menthod-page.html',
				controller: 'eventPaymentMenthodPageCtrl',
				controllerAs: 'vm',
				data: {
					pageTitle: "PIXERF - Payment Menthod",
					permissions: {
						only: ['EVERY_ONE'],
						redirectTo: function () {
							return "404";
						}
					},
				},
				params: {
					"id": {
						squash: true,
						value: null
					}
				},
				resolve: {
					eventData: function ($stateParams, pixerfApiEventSvc, $q, $state, toastr, store, accountConst) {
						var defer = $q.defer();
						var self = this;
						store.remove(accountConst.TOKEN.PAYMENT_EVENT_AFTER_SIGNED);
						
						var eventId = parseInt($stateParams.id);
						if (!$stateParams.id || ($stateParams.id && isNaN(eventId))) {
							$state.go('404');
							defer.reject();
						} else {
							var params = {
								id: eventId
							};
							pixerfApiEventSvc.get(params).$promise.then(function (response) {
								var event = response.data;
								if(event && ((!event.admission_type == 'ticketed_pixerf') || (event.has_joined))){
									$state.go('404');
									defer.reject();
								}
								defer.resolve(event);
							}, function (err) {
                                if(err.data && err.data.data && err.data.data.key){
                                    toastr.error(err.data.data.message);
                                }
								defer.reject(err);
							})
						}

						return defer.promise;
					}
				}
			})
			.state('checkout.payment', {
				url: '/checkout/payment',
				templateUrl: 'app/checkout/payment-menthod/payment-menthod-page.html',
				controller: 'paymentMenthodPageCtrl',
				controllerAs: 'vm',
				data: {
					pageTitle: "PIXERF - Payment Menthod",
					permissions: {
						only: ['EVERY_ONE'],
						redirectTo: function () {
							return "404";
						}
					},
				}
			});
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('buyStockPageCtrl', buyStockPageCtrl);

	buyStockPageCtrl.$inject = ['categoryUtils', '$state', 'customCommissionBasicFormPopupSvc', 'searchInputSvc', 'sessionManagerSvc'];

	function buyStockPageCtrl(categoryUtils, $state, customCommissionBasicFormPopupSvc, searchInputSvc, sessionManagerSvc) {

		var self = this;
		self.contextPage = "Explore Stock";
		self.loginedUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.onSearchConditionClicked = _.debounce(onSearchConditionClicked, 300);
		self.bookShoot = bookShoot;
		self.onSearchChanged = onSearchChanged;
		self.selectedCategories = [];
		self.searchInput = {};
		self.isViewMoreActived = isViewMoreActived;

		self.categoryBtnSettings = {
			dropdownClass: 'gallery-categoryIds-dropdown-menu',
			dynamicButtonTextSuffix: ' Categories Selected',
			smartButtonMaxItems: 3,
			closeOnClick: true,
			singleClick: true,
			uncheckCustomText: 'All categories',
			caretClass: 'icon-icons_chevron-down',
			buttonClasses: 'multiple-dropdown-selection__btn-dropdown',
			events: {
				onSelectionChanged: function () {
					self.onSearchConditionClicked();
				}
			}
		}

		function onSearchConditionClicked() {
			var params = buildSearchParams($state.params.type);
			params.type = $state.params.type;
			params.page = 1;
			$state.go($state.current.name, params);
		}

		function buildSearchParams(contextCurrent) {
			var params = {
				categoryIds: null
			};
			var ids = categoryUtils.extractIdsFromCategories(self.selectedCategories);
			params.categoryIds = ids;
			return params;
		}

		function bookShoot() {
			customCommissionBasicFormPopupSvc.showPopup();
		}

		function onSearchChanged(tagLength) {
			self.isFullSearchBar = !!(tagLength && tagLength.length);

			if (self.isFullSearchBar) {
				var selectedCategories = buildSearchParams($state.params.type);
				var searchParams = {
					keywords: searchInputSvc.buildKeywords(tagLength),
					type: 'images'
				}

				if (selectedCategories && selectedCategories.categoryIds && selectedCategories.categoryIds.length) {
					searchParams.categoryIds = selectedCategories.categoryIds.join(',');
				}

				$state.go('buy-stock-page.search-result-page', searchParams);
			} else {
				$state.go('buy-stock-page.trending');
			}
		}

		function isViewMoreActived(){
			if (!$state || !$state.current) return;

			var currentStateName = $state.current.name;
			var viewMoreStates = ['buy-stock-page.temporary-photos', 'buy-stock-page.photographers.featuredPhotographer', 'buy-stock-page.pending-photos', 'buy-stock-page.pending-portfolio', 'buy-stock-page.rejected-photos', 'buy-stock-page.general-photos'];
			return viewMoreStates.includes(currentStateName);
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.config(routerConfig);

	routerConfig.$inject = ['$stateProvider'];

	function routerConfig($stateProvider) {
		'ngInject';
		$stateProvider
			.state('buy-stock-page', {
				abstract: true,
				url: '/buy-stock-page',
				templateUrl: 'app/buy-stock-page/buy-stock-page.html',
				controller: 'buyStockPageCtrl',
				controllerAs: 'vm',
				data: {
					pageTitle: "PIXERF - Buy Stock",
					permissions: {
						only: ['EVERY_ONE']
					},
					headerClass: 'buy-stock-highlight'
				}
			})
			.state('buy-stock-page.temporary-photos', {
				url: '/temporary-photos?categoryIds&page',
				templateUrl: 'app/buy-stock-page/components/temporary-photos/temporary-photos.html',
				controller: 'temporaryPhotosCtrl',
				controllerAs: 'vm',
                data: {
					pageTitle: "PIXERF - Temporary Photos",
					hideFooter: true
                }
			})
            .state('buy-stock-page.pending-commercial-license', {
				url: '/pending-commercial-license?categoryIds&page',
				templateUrl: 'app/buy-stock-page/components/pending-commercial-license/pending-commercial-license.html',
				controller: 'pendingCommercialLicenseCtrl',
				controllerAs: 'vm',
                data: {
					pageTitle: "PIXERF - Pending Commercial License",
					hideFooter: true
                }
			})
			.state('buy-stock-page.trending', {
				url: '/trending?categoryIds&page',
				templateUrl: 'app/buy-stock-page/components/trending-photo/trending-photo.html',
				controller: 'trendingPhotoCtrl',
				controllerAs: 'vm',
                data: {
					pageTitle: "PIXERF - Trending",
					hideFooter: true
                }
			})
			.state('buy-stock-page.discover', {
				url: '/discover?categoryIds&page',
				templateUrl: 'app/buy-stock-page/components/discover-photo/discover-photo.html',
				controller: 'discoverPhotoCtrl',
				controllerAs: 'vm',
                data: {
					pageTitle: "PIXERF - Discover",
					hideFooter: true
                }
			})
			.state('buy-stock-page.pending-photos', {
				url: '/pending-photos?categoryIds&page',
				templateUrl: 'app/buy-stock-page/components/pending-photos/pending-photos.html',
				controller: 'pendingPhotosCtrl',
				controllerAs: 'vm',
                data: {
					pageTitle: "PIXERF - Pending Photos",
					hideFooter: true
                }
			})
			.state('buy-stock-page.rejected-photos', {
				url: '/rejected-photos?categoryIds&page',
				templateUrl: 'app/buy-stock-page/components/rejected-photos/rejected-photos.html',
				controller: 'rejectedPhotosCtrl',
				controllerAs: 'vm',
                data: {
					pageTitle: "PIXERF - Rejected Photos",
					hideFooter: true
                }
			})
			.state('buy-stock-page.general-photos', {
				url: '/general-photos?categoryIds&page',
				templateUrl: 'app/buy-stock-page/components/general-photos/general-photos.html',
				controller: 'generalPhotosCtrl',
				controllerAs: 'vm',
                data: {
					pageTitle: "PIXERF - General Photos",
					hideFooter: true
                }
			})
			.state('buy-stock-page.pending-portfolio', {
				url: '/pending-portfolio?categoryIds&page',
				templateUrl: 'app/buy-stock-page/components/pending-portfolio/pending-portfolio.html',
				controller: 'pendingPortfolioCtrl',
				controllerAs: 'vm',
                data: {
					pageTitle: "PIXERF - Pending Portfolio",
					hideFooter: true
                }
			})
			.state('buy-stock-page.editor-pick', {
				url: '/editor-pick?categoryIds&page',
				templateUrl: 'app/buy-stock-page/components/editor-pick/editor-pick.html',
				controller: 'editorPickCtrl',
				controllerAs: 'vm',
                data: {
					pageTitle: "PIXERF - Editor's pick",
					hideFooter: true
                }
			})
			.state('buy-stock-page.search-result-page', {
				url: '/search-result-page?keywords&categoryIds&megapixels&license&orientation&page&type',
				templateUrl: 'app/buy-stock-page/components/search-result-page/search-result-page.html',
				controller: 'stockSearchResultPageCtrl',
				controllerAs: 'vm',
                data: {
					pageTitle: "PIXERF - Search result page",
					hideFooter: true
                }
			})
			.state('buy-stock-page.photographers', {
				abstract: true,
				url: '/photographers',
				templateUrl: 'app/photographer-page/photographer-page.html',
				controller: 'photographerPageCtrl',
				controllerAs: 'vm',
				data: {
					permissions: {
						only: ['EVERY_ONE']
					},
					pageTitle: "PIXERF - Top Photographers",
					hideFooter: true
				}
			})
			.state('buy-stock-page.photographers.featuredPhotographer', {
				url: '/featured-photographers?order',
				templateUrl: 'app/photographer-page/components/featured-photographer-page/featured-photographer-page.html',
				controller: 'featuredPhotographerPageCtrl',
				controllerAs: 'vm',
				data: {
					pageTitle: "PIXERF - Featured Photographers",
				}
			})
			.state('buy-stock-page.photographers.leaderboard', {
				url: '/leaderboard?order',
				templateUrl: 'app/photographer-page/components/leaderboard-page/leaderboard-page.html',
				controller: 'leaderboardPageCtrl',
				controllerAs: 'vm',
				data: {
					pageTitle: "PIXERF - Leaderboard",
				}
			})
			.state('buy-stock-page.about-stock', {
				url: '',
				templateUrl: 'app/buy-stock-page/components/about-stock/about-stock.html',
				controller: 'aboutStockCtrl',
				controllerAs: 'vm',
                data: {
					pageTitle: "PIXERF - Explore Stock"
                }
			});
	}
})();

(function () {

	angular
		.module('pixerf')
		.controller('bookAShootPageCtrl', bookAShootPageCtrl);

	bookAShootPageCtrl.$inject = [];

	function bookAShootPageCtrl() {

		var self = this;
		self.contextPage = "Explore custom content";
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.config(routerConfig);

	routerConfig.$inject = ['$stateProvider'];

	function routerConfig($stateProvider) {
		'ngInject';
		$stateProvider
			.state('book-a-shoot-page', {
				abstract: true,
				url: '/book-a-shoot-page',
				templateUrl: 'app/book-a-shoot-page/book-a-shoot-page.html',
				controller: 'bookAShootPageCtrl',
				controllerAs: 'vm',
				data: {
					pageTitle: "PIXERF - Book A Shoot",
					permissions: {
						only: ['EVERY_ONE']
					},
				}
			})
			.state('book-a-shoot-page.about-custom-content', {
				url: '',
				templateUrl: 'app/book-a-shoot-page/components/about-custom-content/about-custom-content.html',
				controller: 'aboutCustomContentCtrl',
				controllerAs: 'vm',
				params: {
					"section": {
						squash: true,
						value: null
					}
				},
                data: {
					pageTitle: "PIXERF - Explore Custom Content"
                }
			});
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('aboutPixerfPageCtrl', aboutPixerfPageCtrl);

	aboutPixerfPageCtrl.$inject = ['$scope', '$timeout', '$location', '$anchorScroll', '$stateParams', 'pixerfApiNewsSvc', 'systemUtils', '$state', 'selectSignUpTypePopupSvc'];

	function aboutPixerfPageCtrl($scope, $timeout, $location, $anchorScroll, $stateParams, pixerfApiNewsSvc, systemUtils, $state, selectSignUpTypePopupSvc) {

		var self = this;
		self.onNextSlide = onNextSlide;
		self.onPreviousSlide = onPreviousSlide;
		self.onCheckout = onCheckout;
		self.onSignUp = onSignUp;
		self.news = [];

		self.responsive = [{
			breakpoint: 992,
			settings: {
				slidesToShow: 2,
				slidesToScroll: 1
			}
		}, {
			breakpoint: 768,
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1
			}
		}];

		self.slickSetting = {
			onInit: function (slick) {
				self.slick = slick;
				self.isFirstSlickSlide = true;
				self.isLastSlickSlide = false;
				if (self.slick.options.slidesToShow == 1) {
					self.totalSlide = self.news.length - 1;
				} else {
					self.totalSlide = self.news.length - (self.slick.options.slidesToShow - self.slick.options.slidesToScroll);
				}
				if (self.slick.options.slidesToShow != 1) {
					onNextSlide();
				}
				systemUtils.digest($scope);
			},
			onAfterChange: function (event, slick, currentSlide) {
				if ((currentSlide < 1 && self.slick.options.slidesToShow == 1) ||
					currentSlide < 2) {
					self.isFirstSlickSlide = true;
					self.isLastSlickSlide = false;
				} else if (self.totalSlide <= currentSlide) {
					self.isFirstSlickSlide = false;
					self.isLastSlickSlide = true;
				} else {
					self.isFirstSlickSlide = false;
					self.isLastSlickSlide = false;
				}
				systemUtils.digest($scope);
			},
			breakpoint: function (event) {
				if (self.slick.options.slidesToShow == 1) {
					self.totalSlide = self.news.length - 1;
				} else {
					self.totalSlide = self.news.length - (self.slick.options.slidesToShow - self.slick.options.slidesToScroll);
				}
				systemUtils.digest($scope);
			}
		}

		init();

		function init() {
			getNews();
			if ($stateParams.pixerfInNews) {
				$timeout(function () {
					$location.hash("pixerf-in-news");
					$anchorScroll();
				}, 100);
			}
		}

		function getNews() {
			pixerfApiNewsSvc.get({
				page_size: 10
			}).$promise.then(function (data) {
				self.news = data;
				formatDate(self.news);
			})
		}

		function formatDate(newsList) {
			for (var i = 0; i < newsList.length; i++) {
				newsList[i].formattedDate = moment(newsList[i].posted_at).format('MMMM DD, YYYY');
			}
		}

		function onNextSlide() {
			if (self.totalSlide <= self.slick.currentSlide) return;
			self.slick.slickNext();
		}

		function onPreviousSlide() {
			if ((self.slick.currentSlide < 1 && self.slick.options.slidesToShow == 1) ||
				self.slick.currentSlide < 2) return;
			self.slick.slickPrev();
		}

		function onCheckout() {
			$state.go("media-page");
		}

		function onSignUp() {
			selectSignUpTypePopupSvc.showPopup();
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.config(routerConfig);

	routerConfig.$inject = ['$stateProvider'];

	function routerConfig($stateProvider) {
		'ngInject';
		$stateProvider
			.state('about-pixerf', {
				url: '/about-pixerf',
				templateUrl: 'app/about-pixerf/about-pixerf-page.html',
				controller: 'aboutPixerfPageCtrl',
				controllerAs: 'vm',
				data: {
					pageTitle: "PIXERF - About Pixerf",
					permissions: {
						only: ['EVERY_ONE']
					}
				},
				params: {
					"pixerfInNews": {
						squash: true,
						value: null
					}
				},
			});
	}

})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.controller('aboutBusinessPageCtrl', aboutBusinessPageCtrl);

	aboutBusinessPageCtrl.$inject = ['sessionManagerSvc', 'selectSignUpTypePopupSvc'];

	function aboutBusinessPageCtrl(sessionManagerSvc, selectSignUpTypePopupSvc) {

		var self = this;
		self.contextPage = "Explore Business";
		self.loginnedUser = sessionManagerSvc.getCurrentLoginUser().data;
		self.onSignupBtnClicked = onSignupBtnClicked;

		function onSignupBtnClicked() {
			if (!self.loginnedUser) {
				selectSignUpTypePopupSvc.showPopup();
			}
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.config(routerConfig);

	routerConfig.$inject = ['$stateProvider'];

	function routerConfig($stateProvider) {
		'ngInject';
		$stateProvider
			.state('about-business-page', {
				abstract: true,
				url: '/explore-business',
				templateUrl: 'app/about-business-page/about-business-page.html',
				controller: 'aboutBusinessPageCtrl',
				controllerAs: 'vm',
				data: {
					pageTitle: "PIXERF - Explore Business",
					permissions: {
						only: ['EVERY_ONE']
					},
					headerClass: 'for-business-highlight'
				}
			})
			.state('about-business-page.pricing', {
				url: '/pricing',
				templateUrl: 'app/about-business-page/components/pricing/pricing.html',
				controller: 'pricingCtrl',
				controllerAs: 'vm',
				data: {
					pageTitle: "PIXERF - Pricing"
				},
				params: {
					"section": {
						squash: true,
						value: null
					}
				},
			})
			.state('about-business-page.about-business', {
				url: '',
				templateUrl: 'app/about-business-page/components/about-business/about-business.html',
				controller: 'aboutBusinessCtrl',
				controllerAs: 'vm',
				data: {
					pageTitle: "PIXERF - Explore Business"
				},
				params: {
					"section": {
						squash: true,
						value: null
					}
				},
			});
	}
})();

(function () {
	angular
		.module('pixerf')
		.provider('pixerfUrl', function () {

			var pixerfAPIUrlConfigurer = new PixerfAPIUrlConfigurer();
			var baseUrl = pixerfAPIUrlConfigurer.getBaseUrl();
			var fullUrl = pixerfAPIUrlConfigurer.URL_PRFIX + baseUrl + pixerfAPIUrlConfigurer.URL_AFFIX;

			if (baseUrl.startsWith("localhost")) {
				fullUrl = pixerfAPIUrlConfigurer.URL_LOCAL_PRFIX + baseUrl + pixerfAPIUrlConfigurer.URL_AFFIX;
			}

			this.$get = function () {
				return {
					full: fullUrl,
					domainOnly: baseUrl
				}
			}

		});
})();

(function () {
	angular
		.module('pixerf')
		.provider('pixerfFormlyConfig', pixerfFormlyConfigProvider);
	pixerfFormlyConfigProvider.$inject = ['formlyConfigProvider'];

	function pixerfFormlyConfigProvider(formlyConfigProvider) {
		this.$get = function () {}
		this.init = init;

		function init() {
			formlyConfigProvider.setType({
				name: 'usStateSelect',
				template: '<ang-select-usstates ng-model="model[options.key]" class=\"form-control\" required name=\"addressState\"></ang-select-usstates>',
				wrapper: ['bootstrapLabel', 'bootstrapHasError']
			});
			formlyConfigProvider.setType({
				name: 'pixerfRadio',
				template: "<pixerf-radio-btn model=\"model\" property=\"{{options.key}}\" value=\"options.templateOptions.radioValue\" class=\"form-control form-group\" required name=\"model[options.key]\" label=\"{{options.templateOptions.radioLabel}}\"></pixerf-radio-btn>",
				wrapper: ['bootstrapLabel', 'bootstrapHasError']
			});
			formlyConfigProvider.setType({
				name: 'pixerfRadioGroup',
				template: "<div class=\"clearfix\"><div class=\"pixerf-radio-item-wrapper\" ng-repeat=\"radio in options.templateOptions.radios\"  ng-class=\"{'pixerf-radio-item-wrapper--last': $last}\"><pixerf-radio-btn ng-attr-pixerf-radio-btn-data-toogle=\"{{radio.id}}\" ng-attr-data-radio-id=\"{{radio.id}}\" ng-class=\"{'pixerf-invalid': form.$submitted && options.templateOptions.required &&  !model[options.key]}\" is-required=\"options.templateOptions.required\" model=\"model\" property=\"{{options.key}}\" value=\"radio.radioValue\" class=\"form-control form-group\" required name=\"model[options.key]\" label=\"{{radio.radioLabel}}\"></pixerf-radio-btn></div></div><div class=\"message\" ng-if=\"form.$submitted && !model[options.key]\">This field is required</div>",
				wrapper: ['bootstrapLabel', 'bootstrapHasError']
			});
			formlyConfigProvider.setType({
				name: 'inputAutoComplete',
				template: function (options) {
					var str = "<div pixerf-select><select ng-model=\"model[options.key]\" class=\"selectpicker\" data-none-selected-text=\"{{options.templateOptions.placeholder}}\" data-live-search-placeholder=\"Search The Bank...\" data-dropup-auto=\"false\" data-live-search=\"true\">";
					str += "<option data-hidden=\"true\"></option>";
					for (var i = 0; i < options.templateOptions.items.length; i++) {
						var item = options.templateOptions.items[i];
						if (item.swiftCode) {
							str += ("<option value= \"" + item.code + " - " + item.swiftCode + "\">" + item.title + "</option>");
						} else {
							str += ("<option value= \"" + item.code + "\">" + item.title + "</option>");
						}
					}
					str += "</select></div>";
					return str;
				},
				wrapper: ['bootstrapLabel', 'bootstrapHasError']
			});
			formlyConfigProvider.setWrapper({
				name: 'validation',
				types: ['input', 'usStateSelect', 'inputAutoComplete'],
				templateUrl: 'error-messages.html'
			});
			formlyConfigProvider.setWrapper({
				name: 'bootstrapLabel1',
				types: ["input"],
				templateUrl: 'pixerf-bootstrap-label.html'
			});
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.run(runBlock);

	runBlock.$inject = ['googleAnalyticSvc', 'socketSvc', 'resendResetPasswordPopupSvc', '$timeout', '$state', '$log', '$rootScope', '$anchorScroll', 'sessionManagerSvc', 'jwtHelper', '$location', 'toastr', 'signInSvc', 'auth0AuthenticationSvc', 'permissionManagerSvc', 'uploadPhotoSvc', '$uibModalStack', 'store', 'commonConst', 'fileConst', 'formlyConfig', 'formlyValidationMessages', 'outlookContactSvc', 'auth0Utils', '$window', '$http', '$q', '$interval', 'messageConst'];

	function runBlock(googleAnalyticSvc, socketSvc, resendResetPasswordPopupSvc, $timeout, $state, $log, $rootScope, $anchorScroll, sessionManagerSvc, jwtHelper, $location, toastr, signInSvc, auth0AuthenticationSvc, permissionManagerSvc, uploadPhotoSvc, $uibModalStack, store, commonConst, fileConst, formlyConfig, formlyValidationMessages, outlookContactSvc, auth0Utils, $window, $http, $q, $interval, messageConst) {

		formlyConfig.extras.errorExistsAndShouldBeVisibleExpression = 'fc.$touched || form.$submitted';

		formlyValidationMessages.addStringMessage('required', 'This field is required');
		formlyValidationMessages.addTemplateOptionValueMessage('minlength', 'minlength', 'Must be at least', 'characters', 'Too short');
		formlyValidationMessages.addStringMessage('maxlength', 'Max length');
		formlyValidationMessages.addStringMessage('email', 'Invalid format');

		$rootScope.fileConst = fileConst;
		sessionManagerSvc.setMarketplaceTabHistory("/buy-stock-page/trending");
		mobileAndTabletcheck(navigator.userAgent || navigator.vendor || window.opera);
		var mLoginUser = sessionManagerSvc.getCurrentLoginUser().data;

		function mobileAndTabletcheck(agent) {
			$rootScope.mobileAndTabletcheck = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(agent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(agent.substr(0, 4));
		}

		$rootScope.overlay = {
			visible: false
		};
		$rootScope.handleDragOver = function () {
			uploadPhotoSvc.dragPhotoEvent.over();
		}
		$rootScope.handleDragLeave = function () {
			uploadPhotoSvc.dragPhotoEvent.leave();
		}

		googleAnalyticSvc.init();

		$rootScope.$on(messageConst.BROADCAST.USER_DATA_CHANGE, function () {
			mLoginUser = sessionManagerSvc.getCurrentLoginUser().data;
		});

		$rootScope.isUserHomePageState  = false;

		$rootScope.$on('$stateChangeSuccess', function (event, toState) {
			googleAnalyticSvc.trackPageView();
			$rootScope.$state = $state;
			$rootScope.isUserHomePageState  = false;
			$('com-header').show();
			$('com-footer').show();
			if (!toState.data.preventScrollToTop) {
				$anchorScroll();
			}
			if (mLoginUser && mLoginUser.is_banned) {
				// If logged in user is banned, redirect to homepage and show restricted popup
				event.preventDefault();
				$state.go('home');
			} 
			if(toState && toState.name && (toState.name.indexOf("user-home-page") != -1) ){
				$rootScope.isUserHomePageState = true;
			}
		});
		$(window).on("resize.pixerfViewPort", (function () {
			getViewPort();
		}));
		getViewPort();

		function getViewPort() {
			var viewPort = window.innerWidth;
			if (viewPort <= commonConst.SCREEN.MOBILE) {
				$rootScope.isScreenMobile = true;
			} else {
				$rootScope.isScreenMobile = false;
			}
		}

		function goToHomePage() {
			$timeout(function () {
				$location.url($location.path());
			}, 3000);
		}
		handlerRedirectMessage();

		function handlerRedirectMessage() {
			var resetPasswordRedirectData = sessionManagerSvc.getResetPasswordRedirect();
			if (resetPasswordRedirectData) {
				if (resetPasswordRedirectData.success && resetPasswordRedirectData.message === "You can now login to the application with the new password.") {
					signInSvc.showSignInModal({
						message: 'Your password has been changed. <br/> Use your new password to log in.'
					});
				} else if (resetPasswordRedirectData.message === "This URL can be used only once") {
					resendResetPasswordPopupSvc.showPopup({
						messages: {
							m1: "Hi, " + resetPasswordRedirectData.email,
							m2: "The email link to reset your password has expired.",
							m3: "Please request for a new link"
						},
						email: resetPasswordRedirectData.email
					})
				}
				sessionManagerSvc.setResetPasswordRedirect(null);
			} else {
				var param = auth0AuthenticationSvc.getParamterFromURL(window.location.href);
				if (typeof param.success !== "undefined") {
					auth0AuthenticationSvc.signout();
					sessionManagerSvc.setResetPasswordRedirect(param);
					window.location.href = "/";
				}
			}
		}

		function getAppVersion(){
			var def = $q.defer();
			var filePath = './app-version.config.json?t=' + moment().unix();;
			$http.get(filePath)
				.then(function (response) {
					def.resolve(response.data);
				}).catch(function (err) {
					def.reject(err);
				});

			return def.promise;
		}

		function handleAppVersion(){
			getAppVersion().then(
				function success(data){
					call(data.version);
				},
				function error(error){

				}
			);
			function call(vers){
				if(!store.get('version') || store.get('version') != vers){
					store.set('version', vers);
					window.location.reload();
				}
			}
		}

		$interval(handleAppVersion, 1000, 1);

		auth0Utils.handleAuthentication();
		if (window.opener && window.opener.pixerf_outlookAuth && window.opener.authCallback) {
			window.close();
			window.opener.authCallback(outlookContactSvc.getAccessTokenFormHash());
			console.log(window.opener);
		}

		$window.fbAsyncInit = function () {
			FB.init({
				appId: '485548001838575',
				status: true,
				cookie: true,
				xfbml: true,
				version: 'v2.4'
			});
		};

		(function (d) {
			// load the Facebook javascript SDK

			var js,
				id = 'facebook-jssdk',
				ref = d.getElementsByTagName('script')[0];

			if (d.getElementById(id)) {
				return;
			}

			js = d.createElement('script');
			js.id = id;
			js.async = true;
			js.src = "//connect.facebook.net/en_US/sdk.js";

			ref.parentNode.insertBefore(js, ref);

		}(document));


	}

})();

(function () {
	'use strict';

	angular
		.module('pixerf')
		.config(routerConfig);

	routerConfig.$inject = ['$urlRouterProvider'];

	function routerConfig($urlRouterProvider) {
		'ngInject';
		$urlRouterProvider.when('', '/');
		$urlRouterProvider.rule(function ($injector, $location) {
			//what this function returns will be set as the $location.url
			var path = $location.absUrl(),
				normalized = path.toLowerCase();
			if (path.indexOf("/!/") !== -1) {

				//instead of returning a new url string, I'll just change the $location.path directly so I don't have to worry about constructing a new url string and so a new state change is not triggered
				//  $location.replace().absUrl(path.replace('#/', "#!/"));
				return $location.path().replace("/!/", "/");
			}
			// because we've returned nothing, no state change occurs
		});
		$urlRouterProvider.otherwise(function ($injector, $location) {
			if ($location.path().indexOf("access_token") === -1) {
				var state = $injector.get('$state');
				state.go('404');
			}
		});
	}

})();

/* global malarkey:false, moment:false */
(function () {
	'use strict';

	angular
		.module('pixerf')
		.constant('moment', moment);

})();

(function () {
	'use strict';
	angular.module('infinite-scroll').value('THROTTLE_MILLISECONDS', 250);
	angular
		.module('pixerf')
		.config(config);
	config.$inject = ['$logProvider', '$httpProvider', 'toastrConfig', 'angularAuth0Provider', 'jwtInterceptorProvider', 'jwtOptionsProvider',
		'$locationProvider', '$urlRouterProvider', 'pixerfFormlyConfigProvider'
	];

	function config($logProvider, $httpProvider, toastrConfig, angularAuth0Provider, jwtInterceptorProvider, jwtOptionsProvider, $locationProvider, $urlRouterProvider, pixerfFormlyConfigProvider) {

		pixerfFormlyConfigProvider.init();
		// Enable log
		$logProvider.debugEnabled(true);

		// Set options third-party lib
		toastrConfig.maxOpened = 1;
		toastrConfig.autoDismiss = true;
		toastrConfig.allowHtml = true;
		toastrConfig.extendedTimeOut = 15000;
		toastrConfig.closeButton = true;
		toastrConfig.positionClass = 'toast-top-center';
		toastrConfig.toastClass = 'pixerf-alert-message';
		// toastrConfig.progressBar = true;
		jwtOptionsProvider.config({
			whiteListedDomains: ["qa.pixerf.com", "staging.pixerf.com", "phoenix.pixerf.com", "localhost"]
		});
		// $locationProvider.html5Mode(true);
		// $locationProvider.hashPrefix('!');

		jwtInterceptorProvider.tokenGetter = ['store', function (store) {
			var token = store.get('PIXERF.TOKEN');
			return token;
		}];

		$httpProvider.interceptors.push('jwtInterceptor');
		// $httpProvider.interceptors.push('responseInterceptor');
		// $httpProvider.defaults.headers.common['Authentication'] = 'Basic cGl4ZXJmOnBpeGVyZjEyMzQ=';
		// dropzoneOpsProvider.setOptions({
		//   url: pixerfProvider.$get() + '/api/cover',
		//   maxFilesize: '50'

		//   // headers: {"Authorization": "Bearer 12121" }
		// });
		var pixerfAuth0Evn = new PixerfAuth0Configurer().getEnv();
		angularAuth0Provider.init({
			domain: pixerfAuth0Evn.domain,
			clientID: pixerfAuth0Evn.clientID,
			responseType: 'token id_token',
			redirectUri: window.location.href
		});

	}

})();

angular.module("pixerf").run(["$templateCache", function($templateCache) {$templateCache.put("app/about-business-page/about-business-page.html","<div class=about-business-page><div class=about-business-page__top-navigation dynamic-show-hide-scroll scroll-down-class=hide-on-mobile><div class=about-business-page__top-navigation__overlay></div><div class=about-business-page__top-navigation__header><!-- <div class=\"about-business-page__top-navigation__title\">Explore Business:</div> --> <button type=button class=\"about-business-page__top-navigation__button navbar-toggle collapsed\" data-toggle=collapse data-target=#aboutBusiness aria-expanded=false><div class=about-business-page__top-navigation__current-state>{{vm.contextPage}}</div><div class=\"about-business-page__top-navigation__icon arrow-animation-menu-collapse\"><span class=\"icon-bar dash-one\"></span> <span class=\"icon-bar dash-two\"></span></div></button><div id=aboutBusiness class=\"about-business-page__top-navigation__list navbar-collapse collapse\" navbar-collapse-on-click=true><div class=about-business-page__top-navigation__item ui-sref=about-business-page.about-business ui-sref-active=actived>Explore Business</div><div class=about-business-page__top-navigation__item ui-sref=about-business-page.case-studies.about-case-studies ui-sref-active-class=actived ui-sref-active-if=about-business-page.case-studies>Case Studies</div><div class=about-business-page__top-navigation__item ui-sref=about-business-page.pricing ui-sref-active=actived>Pricing</div></div></div></div><section ui-view class=about-business-page__main-content></section></div>");
$templateCache.put("app/about-pixerf/about-pixerf-page.html","<div class=about-pixerf-page><div class=about-pixerf-page__banner><div class=about-pixerf-page__banner__box><div class=about-pixerf-page__banner__corner></div><div class=about-pixerf-page__banner__slogan>Defining Asia and you, for the world</div></div></div><div class=about-pixerf-page__our-target><div class=about-pixerf-page__our-target__col><div class=about-pixerf-page__our-target__col__title>Our Vision</div><div class=about-pixerf-page__our-target__col__description>To be the leading visual content creation platform in Asia, giving people the power to create visuals anywhere for businesses everywhere.</div></div><div class=about-pixerf-page__our-target__col><div class=about-pixerf-page__our-target__col__title>Our Mission</div><div class=about-pixerf-page__our-target__col__description>We make visual content creation simple for businesses. And help creative communities thrive.</div></div><div class=about-pixerf-page__our-target__col><div class=about-pixerf-page__our-target__col__title>Our Products</div><div class=about-pixerf-page__our-target__col__description>Get culturally authentic visual content from our creator community in three easy ways: <a ui-sref=book-a-shoot-page.about-custom-content target=_blank>Custom Content Assignments,</a> <a ui-sref=run-a-challenge-page.about-challenge target=_blank>Community Challenges,</a> <a ui-sref=buy-stock-page.about-stock target=_blank>Visual Marketplace.</a></div></div></div><div class=about-pixerf-page__story><div class=about-pixerf-page__story__title>Our Story</div><div class=about-pixerf-page__story__content><div class=\"about-pixerf-page__story__col first-section\"><div class=\"about-pixerf-page__story__col__left about-pixerf-page__story__col__cover\"><img src=assets/images/about-pixerf/our-story-1.jpg alt=\"PIXERF In 2015\" class=cover-1></div><div class=\"about-pixerf-page__story__col__right about-pixerf-page__story__col__description\"><p>In 2015, PIXERF was founded with a belief that all creators should be given the opportunity to showcase and market their talent. The online platform was the brainchild of Sa’at, a creative business owner, who recognised the limited market of images that capture the essence of Asia in all its vibrant diversity and the breadth and depth of Asian talent waiting to be discovered. Joined by his co-founder and agency partner, Michele, who saw the market gap for quality, authentic and creative Asian imagery, they grew a buzzing online community and marketplace of visual creators to meet the surging demand for quality visual content.</p><p>We count photographers, videographers, filmmakers, creatives and influencers among our community of PIXERFERS.</p></div></div><div class=\"about-pixerf-page__story__col second-section\"><div class=\"about-pixerf-page__story__col__left about-pixerf-page__story__col__description\"><p>Today, PIXERF helps businesses, from startups to corporate giants, create visual content faster and better, with the ambition to make the process of creation absolutely simple and hassle-free. We do that by innovating the creation and production process, empowering visual creators to create visuals anywhere for businesses everywhere and giving businesses more choices to quality photos and videos to meet every need.</p><p>With one of the largest creator networks in Asia, we are proud to call Asia our home.</p></div><div class=\"about-pixerf-page__story__col__right about-pixerf-page__story__col__cover\"><img src=assets/images/about-pixerf/our-story-2.jpg alt=\"PIXERF Today\" class=cover-2></div></div></div></div><div class=about-pixerf-page__visual-content><div class=about-pixerf-page__visual-content__box><div class=about-pixerf-page__visual-content__corner></div><div class=about-pixerf-page__visual-content__slogan>Making Visual Content Creation Simple and Hassle Free</div></div></div><div class=about-pixerf-page__join-creative><div class=about-pixerf-page__join-creative__text>Join the Creative Community</div><button class=about-pixerf-page__join-creative__btn ng-click=vm.onSignUp()>Sign up</button></div><div ng-if=vm.news.length id=pixerf-in-news class=about-pixerf-page__news><div class=about-pixerf-page__news__title>News Room</div><div class=about-pixerf-page__news__list><slick on-init=vm.slickSetting.onInit(slick) on-after-change=\"vm.slickSetting.onAfterChange(event, slick, currentSlide, nextSlide)\" speed=1000 class=about-pixerf-page__news__carousel infinite=false slides-to-scroll=1 slides-to-show=3 dots=false arrows=false center-mode=true responsive=vm.responsive on-breakpoint=\"vm.slickSetting.breakpoint({event, slick, breakpoint})\"><div ng-repeat=\"news in vm.news\" class=about-pixerf-page__news__post><div class=about-pixerf-page__news__post__above><div class=about-pixerf-page__news__post__logo><img ng-src=\"{{news.photo[\'original\']}}\"></div><a ng-href={{news.url}} target=_blank class=about-pixerf-page__news__post__logo-title>{{news.url_text}}</a></div><div class=about-pixerf-page__news__post__bottom><div class=about-pixerf-page__news__post__header><a ng-href={{news.url}} target=_blank class=about-pixerf-page__news__post__title ng-bind-html=news.name></a> <a ng-href={{news.url}} target=_blank class=\"about-pixerf-page__news__post__icon icon-link-to\"></a></div><div class=about-pixerf-page__news__post__date>{{news.formattedDate}}</div></div></div></slick><div class=about-pixerf-page__news__carousel__navigate><div class=\"about-pixerf-page__news__carousel__navigate__left icon-slide-prev-icon\" ng-class=\"{\'disabled\': vm.isFirstSlickSlide}\" ng-click=vm.onPreviousSlide()></div><div class=\"about-pixerf-page__news__carousel__navigate__right icon-slide-next-icon\" ng-class=\"{\'disabled\': vm.isLastSlickSlide}\" ng-click=vm.onNextSlide()></div></div></div><button class=about-pixerf-page__news__check-out ng-click=vm.onCheckout()>Check out our press</button></div></div>");
$templateCache.put("app/buy-stock-page/buy-stock-page.html","<div class=buy-stock-page><div class=buy-stock-page__top-navigation dynamic-show-hide-scroll scroll-down-class=hide-on-mobile><div class=buy-stock-page__top-navigation__overlay></div><div class=buy-stock-page__top-navigation__header><div class=buy-stock-page__top-navigation__header__text-wrapper><button ng-if=!vm.isFullSearchBar type=button class=\"buy-stock-page__top-navigation__button navbar-toggle collapsed\" data-toggle=collapse data-target=#buyStock aria-expanded=false><div class=buy-stock-page__top-navigation__current-state>{{vm.contextPage}}</div><div class=\"buy-stock-page__top-navigation__icon arrow-animation-menu-collapse\"><span class=\"icon-bar dash-one\"></span> <span class=\"icon-bar dash-two\"></span></div></button></div><div ng-if=!vm.isFullSearchBar id=buyStock class=\"buy-stock-page__top-navigation__list navbar-collapse collapse\" navbar-collapse-on-click=true><div class=buy-stock-page__top-navigation__item ui-sref=buy-stock-page.about-stock ui-sref-active=actived>Explore Stock</div><div class=buy-stock-page__top-navigation__item ui-sref=buy-stock-page.trending ui-sref-active=actived>Trending</div><div class=buy-stock-page__top-navigation__item ui-sref=buy-stock-page.discover ui-sref-active=actived>Discover</div><div class=buy-stock-page__top-navigation__item ui-sref=buy-stock-page.editor-pick ui-sref-active=actived>Editors\' Pick</div><div class=buy-stock-page__top-navigation__item ui-sref-active-if=buy-stock-page.galleries ui-sref=buy-stock-page.galleries.signature-galleries ui-sref-active-class=actived>Galleries</div><div ng-if=\"vm.loginedUser && (vm.loginedUser.canCurate || vm.loginedUser.canSeeDirectory)\" uib-dropdown navbar-stop-collapse-on-click class=buy-stock-page__top-navigation__item-more ng-class=\"{\'actived\': vm.isViewMoreActived()}\"><div class=\"buy-stock-page__top-navigation__item-more__btn icon-icons_more\" uib-dropdown-toggle navbar-stop-collapse-on-click></div><ul class=dropdown-menu uib-dropdown-menu role=menu aria-labelledby=single-button><li ng-if=vm.loginedUser.canSeeDirectory ui-sref-active=active ui-sref=buy-stock-page.photographers.featuredPhotographer>Directory</li><li ng-if=vm.loginedUser.canCurate ui-sref-active=active ui-sref=buy-stock-page.pending-photos>Pending Photos</li><li ng-if=vm.loginedUser.canCurate ui-sref-active=active ui-sref=buy-stock-page.pending-portfolio>Pending Portfolio</li><li ng-if=\"vm.loginedUser.role === \'admin_internal\'\" ui-sref-active=active ui-sref=buy-stock-page.pending-commercial-license>Pending Commercial License</li><li ng-if=vm.loginedUser.canCurate ui-sref-active=active ui-sref=buy-stock-page.general-photos>General</li><li ng-if=vm.loginedUser.canCurate ui-sref-active=active ui-sref=buy-stock-page.rejected-photos>Rejected</li><li ng-if=\"vm.loginedUser.role === \'admin_internal\'\" ui-sref-active=active ui-sref=buy-stock-page.temporary-photos>Temporary</li></ul></div></div><div class=buy-stock-page__top-navigation__search-bar ng-class=\"{\'full-search-bar\': vm.isFullSearchBar}\"><div class=buy-stock-page__top-navigation__search-bar__icon><div class=icon-icon-search-2></div></div><search-input instance=vm.searchInput on-value-changed=vm.onSearchChanged(vm.searchInput.tags.data) class=buy-stock-page__top-navigation__search-bar__input></search-input><category-selection-btn settings=vm.categoryBtnSettings selected-model=vm.selectedCategories class=buy-stock-page__top-navigation__search-bar__browse-categories></category-selection-btn></div></div></div><section ui-view class=buy-stock-page__main-content></section></div>");
$templateCache.put("app/book-a-shoot-page/book-a-shoot-page.html","<div class=book-a-shoot-page><div class=book-a-shoot-page__top-navigation dynamic-show-hide-scroll scroll-down-class=hide-on-mobile><div class=book-a-shoot-page__top-navigation__overlay></div><div class=book-a-shoot-page__top-navigation__header><!-- <div class=\"book-a-shoot-page__top-navigation__title\">Explore custom content:</div> --> <button type=button class=\"book-a-shoot-page__top-navigation__button navbar-toggle collapsed\" data-toggle=collapse data-target=#bookAShoot aria-expanded=false><div class=book-a-shoot-page__top-navigation__current-state>{{vm.contextPage}}</div><div class=\"book-a-shoot-page__top-navigation__icon arrow-animation-menu-collapse\"><span class=\"icon-bar dash-one\"></span> <span class=\"icon-bar dash-two\"></span></div></button><div id=bookAShoot class=\"book-a-shoot-page__top-navigation__list navbar-collapse collapse\" navbar-collapse-on-click=true><div class=book-a-shoot-page__top-navigation__item ui-sref-active=actived ui-sref=book-a-shoot-page.about-custom-content>Explore custom content</div></div></div></div><section ui-view class=book-a-shoot-page__main-content></section></div>");
$templateCache.put("app/checkout/checkout.html","<div class=\"relative main__content--md checkout-navigation\" ng-class=\"{\'margin-top--1\': isScreenMobile}\"><div scroll-to-fixed=vm.searchFilterBarSettings class=pixerf-navigation-bar-wrapper><ul class=\"pixerf-navigation-bar clearfix\"><button type=button class=\"navbar-toggle collapsed\" data-toggle=collapse data-target=#checkout-navbar-collapse aria-expanded=false><div class=\"pull-left text--bold\">{{vm.contextPage}}</div><div class=\"pull-right arrow-animation-menu-collapse\"><span class=\"icon-bar dash-one\"></span> <span class=\"icon-bar dash-two\"></span></div></button><div class=\"collapse navbar-collapse pixerf-navbar-text navbar-collapse-desktop\" navbar-collapse-on-click=true id=checkout-navbar-collapse><li ui-sref-active=pixerf-navigation-bar__menu-item--active ui-sref=checkout.shopping-cart class=pixerf-navigation-bar__menu-item translate>{{\'shopping-cart\'}}</li><li ui-sref-active=pixerf-navigation-bar__menu-item--active ui-sref=checkout.payment class=pixerf-navigation-bar__menu-item translate>{{\'Checkout\'}}</li><li ui-sref-active-class=pixerf-navigation-bar__menu-item--active ui-sref-active-if=checkout.credit-plan ui-sref=checkout.credit-plan.credit-plan-list class=pixerf-navigation-bar__menu-item ng-if=vm.user.canBuyCreditPlan translate>{{\'credit-plans\'}}</li><li ui-sref-active=pixerf-navigation-bar__menu-item--active ui-sref=checkout.billing-information class=\"pixerf-navigation-bar__menu-item ng-hide\">BILLING INFORMATION</li></div></ul></div><div class=\"col-md-12 checkout-page__main-content marketplace-wrap\" ui-view></div></div>");
$templateCache.put("app/community-invite-landing-page/community-invite-landing-page.html","<div class=\"community-invite-landing-page no-margin\"><section class=\"row community-invite-landing-page-branding-wrapper\"><div class=\"community-invite-landing-page__branding text-center\"><div class=profile-image-wrapper><a ui-sref=\"user-home-page.personal.home({id: vm.user.id, userName: (vm.user.displayName | toSnakeCase)})\"><pixerf-user-avatar class=profile-image user-data=vm.user lazy=true></pixerf-user-avatar></a></div><p class=\"community-invite-landing-page__branding--earn text-center\">John Dean invited you to join Uniqlo\'s community</p><photo-info-link photo=vm.brandingPhoto></photo-info-link><button class=\"btn btn-pixerf-theme btn-pixerf-theme--no-background community-invite-landing-page__btn-signup text--bold\">Signup to join</button></div></section></div>");
$templateCache.put("app/community-detail-page/community-detail-page.html","<div class=\"community-detail-page main__content--md clearfix\" id=community-detail-page ng-class=\"{\'margin-top--1\': isScreenMobile}\"><div class=community-detail-page__col-left><div class=community-detail-page__user><div class=community-detail-page__user__avatar ui-sref=\"user-home-page.homepage({id: vm.loginUser.id})\"><pixerf-user-avatar user-data=vm.loginUser lazy=true></pixerf-user-avatar></div><div class=community-detail-page__user__name ui-sref=\"user-home-page.homepage({id: vm.loginUser.id})\">{{vm.loginUser.displayName}}</div><!-- <div class=\"community-detail-page__user__acc-type\">{{vm.loginUser.account_type}}</div> --><div class=community-detail-page__user__acc-type pixerf-person-level person=vm.loginUser></div></div><div class=community-detail-page__communities><div class=community-detail-page__communities__header>Your Communities</div><div ng-if=vm.loginUser.canManageCommunity class=community-detail-page__communities__section-wrapper><div class=community-detail-page__communities__title>Communities Owned</div><div ng-if=vm.yourCommunities.length class=\"community-detail-page__communities__list community-detail-page__communities__list__your-communities\"><div ng-repeat=\"item in vm.yourCommunities\" class=community-detail-page__communities__list__info__wrapper><div class=community-detail-page__communities__list__info__avatar ng-style=\"{\'background-image\': \'url(\\\'\' + item.cover.thumbnail + \'\\\')\'}\"></div><div class=community-detail-page__communities__list__info__details><a ui-sref=\"community-detail-page.community-detail-discussions({id: item.id})\" class=\"community-detail-page__communities__list__info__name text--truncate\" ng-class=\"{\'actived\': vm.community.id === item.id}\">{{item.name}}</a><div class=community-detail-page__communities__list__info__member><span class=community-detail-page__communities__list__info__member__value>{{item.member_count}}</span> <span class=community-detail-page__communities__list__info__member__text>{{item.member_count === 1 ? \'member\' : \'members\'}}</span></div></div></div></div></div><div ng-if=\"vm.loginUser.canManageCommunity && !vm.yourCommunities.length\" class=community-detail-page__communities__empty-section-sidebar><div class=community-detail-page__communities__empty-section-sidebar__info>You are not part of any Communities at the moment.</div><div><a ui-sref=for-creator-page.about-community class=\"text--bold text--color-pixerf-theme\" target=_blank>Explore</a> more communities that align with your interest.</div></div><div ng-if=\"!vm.loginUser.isBiz && (!vm.loginUser.canManageCommunity || vm.yourCommunities.length || vm.joinedCommunities.length)\" class=community-detail-page__communities__section-wrapper><div class=community-detail-page__communities__title>Communities Joined</div><div ng-if=vm.joinedCommunities.length ng-repeat=\"item in vm.joinedCommunities\" class=community-detail-page__communities__list__info__wrapper><div class=community-detail-page__communities__list__info__avatar ng-style=\"{\'background-image\': \'url(\\\'\' + item.cover.thumbnail + \'\\\')\'}\"></div><div class=community-detail-page__communities__list__info__details><a ui-sref=\"community-detail-page.community-detail-discussions({id: item.id})\" class=\"community-detail-page__communities__list__info__name text--truncate\" ng-class=\"{\'actived\': vm.community.id === item.id}\">{{item.name}}</a><div class=community-detail-page__communities__list__info__member><span class=community-detail-page__communities__list__info__member__value>{{item.member_count}}</span> <span class=community-detail-page__communities__list__info__member__text>{{item.member_count === 1 ? \'member\' : \'members\'}}</span></div></div></div><div ng-if=!vm.joinedCommunities.length class=community-detail-page__communities__empty-section-sidebar><div class=community-detail-page__communities__empty-section-sidebar__info>You are not part of any Communities at the moment.</div><div><a ui-sref=for-creator-page.about-community class=\"text--bold text--color-pixerf-theme\" target=_blank>Explore</a> more communities that align with your interest.</div></div></div><div ng-if=\"vm.loginUser && vm.loginUser.canManageCommunity\" class=\"community-detail-page__communities__create-button btn btn--transparent\" ng-click=vm.onCreateCommunity()><div class=\"community-detail-page__communities__create-button__icon icon-icons_plus\"></div><div class=community-detail-page__communities__create-button__text>Create a Community</div></div></div><div class=community-detail-page__events><div class=community-detail-page__events__header>Your Events</div><div class=community-detail-page__events__section-wrapper><div ng-if=\"vm.loginUser && vm.loginUser.canManageCommunity\" class=community-detail-page__events__title>Events Hosted</div><div ng-if=vm.yourEvents.length class=\"community-detail-page__events__list community-detail-page__events__list__your-events\"><div ng-repeat=\"item in vm.yourEvents\" class=community-detail-page__events__list__info__wrapper><div class=community-detail-page__events__list__info__avatar ng-style=\"{\'background-image\': \'url(\\\'\' + item.cover.thumbnail + \'\\\')\'}\"></div><div class=community-detail-page__events__list__info__details><a ui-sref=\"event-detail-page.event-photos({id: item.id})\" class=\"community-detail-page__events__list__info__name text--truncate\" ng-class=\"{\'actived\': vm.community.id === item.id}\">{{item.name}}</a><div class=community-detail-page__events__list__info__sub-info><span class=community-detail-page__events__list__info__sub-info__value>{{item.event_datetimes[0].start_datetime | formatDate: \'MMM DD, YYYY\'}}</span></div></div></div></div></div><div ng-if=\"vm.loginUser.canManageCommunity && !vm.yourEvents.length\" class=community-detail-page__events__empty-section-sidebar><div class=community-detail-page__events__empty-section-sidebar__info>You are not taking part in any events at the moment.</div><div><a ui-sref=for-creator-page.about-community class=\"text--bold text--color-pixerf-theme\" target=_blank>Explore</a> more events that align with your interest.</div></div><div ng-if=\"!vm.loginUser.isBiz && (!vm.loginUser.canManageCommunity || vm.yourEvents.length || vm.joinedEvents.length)\" class=community-detail-page__events__section-wrapper><div class=community-detail-page__events__title>Events Joined</div><div ng-if=vm.joinedEvents.length class=\"community-detail-page__events__list community-detail-page__events__list__joined-events\"><div ng-repeat=\"item in vm.joinedEvents\" class=community-detail-page__events__list__info__wrapper><div class=community-detail-page__events__list__info__avatar ng-style=\"{\'background-image\': \'url(\\\'\' + item.cover.thumbnail + \'\\\')\'}\"></div><div class=community-detail-page__events__list__info__details><a ui-sref=\"event-detail-page.event-photos({id: item.id})\" class=\"community-detail-page__events__list__info__name text--truncate\" ng-class=\"{\'actived\': vm.community.id === item.id}\">{{item.name}}</a><div class=community-detail-page__events__list__info__sub-info><span class=community-detail-page__events__list__info__sub-info__value>{{item.event_datetimes[0].start_datetime | formatDate: \'MMM DD, YYYY\'}}</span> <span class=community-detail-page__events__list__info__sub-info__text>{{item.owner.displayName}}</span></div></div></div></div><div ng-if=!vm.joinedEvents.length class=community-detail-page__events__empty-section-sidebar><div class=community-detail-page__events__empty-section-sidebar__info>You are not taking part in any events at the moment.</div><div><a ui-sref=for-creator-page.about-community class=\"text--bold text--color-pixerf-theme\" target=_blank>Explore</a> more events that align with your interest.</div></div></div><div ng-if=\"(vm.isMine || vm.community.membership_status == \'manager\') && vm.loginUser && vm.loginUser.canManageCommunity && vm.canUpdateCommunity\" class=\"community-detail-page__events__create-button btn btn--transparent\" ng-click=\"vm.onCreateEvent(\'event\')\"><div class=\"community-detail-page__events__create-button__icon icon-icons_plus\"></div><div class=community-detail-page__events__create-button__text>{{\'create-new-event\' | translate}}</div></div></div><div class=community-detail-page__events><div class=community-detail-page__events__header>Your Classes</div><div class=community-detail-page__events__section-wrapper><div ng-if=\"vm.loginUser && vm.loginUser.canManageCommunity\" class=community-detail-page__events__title>Classes Hosted</div><div ng-if=vm.yourEventClasses.length class=\"community-detail-page__events__list community-detail-page__events__list__your-events\"><div ng-repeat=\"item in vm.yourEventClasses\" class=community-detail-page__events__list__info__wrapper><div class=community-detail-page__events__list__info__avatar ng-style=\"{\'background-image\': \'url(\\\'\' + item.cover.thumbnail + \'\\\')\'}\"></div><div class=community-detail-page__events__list__info__details><a ui-sref=\"event-detail-page.event-photos({id: item.id})\" class=\"community-detail-page__events__list__info__name text--truncate\" ng-class=\"{\'actived\': vm.community.id === item.id}\">{{item.name}}</a><div class=community-detail-page__events__list__info__sub-info><span class=community-detail-page__events__list__info__sub-info__value>{{item.event_datetimes[0].start_datetime | formatDate: \'MMM DD, YYYY\'}}</span></div></div></div></div></div><div ng-if=\"vm.loginUser.canManageCommunity && !vm.yourEventClasses.length\" class=community-detail-page__events__empty-section-sidebar><div class=community-detail-page__events__empty-section-sidebar__info>You are not taking part in any classes at the moment.</div><div><a ui-sref=for-creator-page.about-community class=\"text--bold text--color-pixerf-theme\" target=_blank>Explore</a> more classes that align with your interest.</div></div><div ng-if=\"!vm.loginUser.isBiz && (!vm.loginUser.canManageCommunity || vm.yourEventClasses.length || vm.joinedEventClasses.length)\" class=community-detail-page__events__section-wrapper><div class=community-detail-page__events__title>Classes Joined</div><div ng-if=vm.joinedEventClasses.length class=\"community-detail-page__events__list community-detail-page__events__list__joined-events\"><div ng-repeat=\"item in vm.joinedEventClasses\" class=community-detail-page__events__list__info__wrapper><div class=community-detail-page__events__list__info__avatar ng-style=\"{\'background-image\': \'url(\\\'\' + item.cover.thumbnail + \'\\\')\'}\"></div><div class=community-detail-page__events__list__info__details><a ui-sref=\"event-detail-page.event-photos({id: item.id})\" class=\"community-detail-page__events__list__info__name text--truncate\" ng-class=\"{\'actived\': vm.community.id === item.id}\">{{item.name}}</a><div class=community-detail-page__events__list__info__sub-info><span class=community-detail-page__events__list__info__sub-info__value>{{item.event_datetimes[0].start_datetime | formatDate: \'MMM DD, YYYY\'}}</span> <span class=community-detail-page__events__list__info__sub-info__text>{{item.owner.displayName}}</span></div></div></div></div><div ng-if=!vm.joinedEventClasses.length class=community-detail-page__events__empty-section-sidebar><div class=community-detail-page__events__empty-section-sidebar__info>You are not taking part in any classes at the moment.</div><div><a ui-sref=for-creator-page.about-community class=\"text--bold text--color-pixerf-theme\" target=_blank>Explore</a> more classes that align with your interest.</div></div></div><div ng-if=\"(vm.isMine || vm.community.membership_status == \'manager\') && vm.loginUser && vm.loginUser.canManageCommunity && vm.canUpdateCommunity\" class=\"community-detail-page__events__create-button btn btn--transparent\" ng-click=\"vm.onCreateEvent(\'class\')\"><div class=\"community-detail-page__events__create-button__icon icon-icons_plus\"></div><div class=community-detail-page__events__create-button__text>{{\'create-new-class\' | translate}}</div></div></div></div><div class=community-detail-page__col-right><section class=community-detail-page__header><div class=community-detail-page__header__background ng-style=\"{\'background-image\': \'url(\\\'\' + vm.community.cover.original + \'\\\')\'}\"><div class=community-detail-page__header__info><div ng-if=\"[\'deactivated\'].includes(vm.community.status)\" class=community-detail-page__header__info__banner-status><span class=\"community-detail-page__header__info__banner-status__icon icon-remove-circle-outline\"></span> <span class=community-detail-page__header__info__banner-status__label>Community {{vm.community.status}}</span></div><div class=community-detail-page__header__info__left><div class=community-detail-page__header__info__name>{{vm.community.name}}</div><div class=community-detail-page__header__info__detail><div class=\"community-detail-page__header__info__detail__icon {{vm.badgeCommunity}}\"></div><div class=community-detail-page__header__info__detail__text><div class=community-detail-page__header__info__detail__type>{{ (vm.community.is_unlisted == true) ? \'Unlisted\' : (vm.community.is_private ? \'Private\' : \'Public\')}} Community</div><div class=community-detail-page__header__info__detail__author>by <a ng-if=vm.canGoBusinessProfile ui-sref=\"user-home-page.homepage({id: vm.community.owner.id})\"><span class=community-detail-page__header__info__detail__author__name>{{vm.community.owner.displayName}}</span></a> <span ng-if=!vm.canGoBusinessProfile class=community-detail-page__header__info__detail__author__name>{{vm.community.owner.displayName}}</span></div></div></div></div><div class=event-detail-page__header__manage-button__wrapper><div ng-if=vm.isLeaveBtn class=\"community-detail-page__header__manage-button btn btn-submit\" ng-mouseover=vm.onManageBtnHovered() ng-mouseleave=vm.onManageBtnLeft() ng-click=vm.onLeaveCommunityClicked()><span ng-if=!vm.isHovering class=\"community-detail-page__header__manage-button__icon icon-icons_check\"></span> <span>{{vm.isHovering ? \'Leave\' : \'Joined\'}}</span></div><div ng-if=vm.isWithdrawRequestBtn class=\"community-detail-page__header__manage-button btn btn-submit\" ng-mouseover=vm.onManageBtnHovered() ng-mouseleave=vm.onManageBtnLeft() ng-click=vm.onWithDrawRequestClicked()><span ng-if=!vm.isHovering class=\"community-detail-page__header__manage-button__icon icon-icons_check\"></span> <span>{{vm.isHovering ? (\'withdraw-request\' | translate) : (\'requested\' | translate)}}</span></div><div ng-if=\"!vm.isWithdrawRequestBtn && !vm.isLeaveBtn && !vm.isMine && vm.loginUser.account_type === \'personal\' && vm.community.membership_status != \'banned\' && vm.community.membership_status != \'manager\'\" class=\"community-detail-page__header__manage-button btn btn-submit\" ng-click=vm.onRequestToJoinedClicked()>{{\'join-community\' | translate}}</div><div ng-if=\"vm.isMine && vm.community.status == \'pending\'\" class=\"community-detail-page__header__manage-button btn community-detail-page__header__manage-button__light-grey-btn\">{{\'pending-approval\' | translate}}</div><div ng-if=\"vm.isMine \" class=\"community-detail-page__header__manage-button btn community-detail-page__header__manage-button__admin\"><span class=\"community-detail-page__header__manage-button__icon icon-star-circle\"></span> <span>{{\'you-are-the-admin\' | translate}}</span></div></div></div></div><div class=community-detail-page__header__bottom-border></div></section><section class=community-detail-page__content><div class=community-detail-page__content__col-left><div class=community-detail-page__content__navigation><button type=button class=\"navbar-toggle collapsed\" data-toggle=collapse data-target=#setting-navbar-collapse aria-expanded=false><div class=\"pull-left text--bold\" translate>{{vm.contextPage}}</div><div class=\"pull-right arrow-animation-menu-collapse\"><span class=\"icon-bar dash-one\"></span> <span class=\"icon-bar dash-two\"></span></div></button><ul class=\"community-detail-page__content__nav-content-list collapse navbar-collapse\" navbar-collapse-on-click=true id=setting-navbar-collapse><li class=community-detail-page__content__nav-content-item ui-sref-active-class=actived ui-sref-active-if=community-detail-page.community-detail-discussions><a ui-sref={{vm.commonConst.STATE.COMMUNITIES_DETAILS_DISCUSSIONS}}>{{\'discussions\' | translate}}</a></li><li class=community-detail-page__content__nav-content-item ui-sref-active-class=actived ui-sref-active-if=community-detail-page.community-detail-classes><a ui-sref={{vm.commonConst.STATE.COMMUNITIES_DETAILS_CLASSES}}>Classes</a></li><li class=community-detail-page__content__nav-content-item ui-sref-active-class=actived ui-sref-active-if=community-detail-page.community-detail-events><a ui-sref={{vm.commonConst.STATE.COMMUNITIES_DETAILS_EVENTS}}>{{\'events\' | translate}}</a></li><li class=community-detail-page__content__nav-content-item ui-sref-active-class=actived ui-sref-active-if=community-detail-page.community-detail-photos><a ui-sref={{vm.commonConst.STATE.COMMUNITIES_DETAILS_PHOTOS}}>{{\'photos\' | translate}}</a></li><li ng-if=vm.loginUser class=community-detail-page__content__btn-report><div uib-dropdown class=community-detail-page__content__btn-report__menu><span uib-dropdown-toggle class=icon-icons_more></span><ul class=community-detail-page__content__btn-report__list uib-dropdown-menu role=menu><li ng-if=\"vm.isMine || vm.community.membership_status == \'manager\'\" role=menuitem class=community-detail-page__content__btn-report__item ng-click=\"vm.onManageCommunityClicked(\'admin\')\">Manage Community</li><li ng-if=vm.isMine role=menuitem class=community-detail-page__content__btn-report__item ng-click=vm.onDeleteCommunityClicked()>Delete Community</li><li ng-if=\"!vm.isMine || vm.community.membership_status == \'manager\'\" role=menuitem class=community-detail-page__content__btn-report__item ng-click=vm.onReportComminity() translate translate-values=\"{thing: (\'community\' | translate)}\">{{\'report-thing\'}}</li></ul></div></li></ul></div><section ui-view class=community-detail-page__main-content></section></div><div class=community-detail-page__content__col-right><!-- <div class=\"community-detail-page__content__col-right__section notification-section\">\r\n					<div class=\"community-detail-page__content__col-right__section__header\">\r\n						<div class=\"community-detail-page__content__col-right__section__title\">Notifications</div>\r\n					</div>\r\n				</div> --><div class=\"community-detail-page__content__col-right__section admin-section\"><div class=community-detail-page__content__col-right__section__header><div class=community-detail-page__content__col-right__section__title>Admins</div><a ui-sref=\"manage-community.members({id: vm.community.id, status: \'admin\'})\"><div ng-if=vm.isMine class=community-detail-page__content__col-right__section__control>{{\'manage\' | translate}}</div></a></div><div ng-if=\"vm.loginUser && vm.managers.length\" class=community-detail-page__content__col-right__section__manager-list><div ng-repeat=\"manager in vm.managers\" class=community-detail-page__content__col-right__section__manager><div class=community-detail-page__content__col-right__section__manager__avatar__wrapper><pixerf-user-avatar class=community-detail-page__content__col-right__section__manager__avatar user-data=manager lazy=true></pixerf-user-avatar></div><div class=community-detail-page__content__col-right__section__manager__details><div class=\"community-detail-page__content__col-right__section__manager__name text--truncate\">{{manager.displayName}}</div><div class=community-detail-page__content__col-right__section__manager__sub-info>{{manager.archivement}}</div></div><div class=community-detail-page__content__col-right__section__manager__badge><div class=community-detail-page__content__col-right__section__manager__badge__wrapper><div class=community-detail-page__content__col-right__section__manager__badge__icon></div><div class=community-detail-page__content__col-right__section__manager__badge__value>{{manager.status}}</div></div></div></div></div></div><div class=\"community-detail-page__content__col-right__section member-section\"><div class=community-detail-page__content__col-right__section__header><div class=community-detail-page__content__col-right__section__title>{{vm.community.member_count}} {{vm.community.member_count === 1 ? (\'member\' | translate) : (\'members\' | translate)}}</div><a ui-sref=\"manage-community.members({id: vm.community.id,name: vm.community.name, status: \'invited\'})\"><div ng-if=\"vm.isMine || vm.isManager\" class=community-detail-page__content__col-right__section__control>{{\'manage\' | translate}}</div></a><a ui-sref=\"view-community.members({id: vm.community.id, name: vm.community.name, status: \'members\'})\"><div ng-if=\"vm.isMember && !vm.isMine\" class=community-detail-page__content__col-right__section__control>{{\'view\' | translate}}</div></a></div><div ng-if=vm.loginUser class=community-detail-page__content__col-right__section__member-list><div ng-repeat=\"member in vm.members | limitTo: 4\" class=community-detail-page__content__col-right__section__member ng-style=\"{\'background-image\': \'url(\\\'\' + member.avatar + \'\\\')\'}\" tooltip-placement=auto uib-tooltip={{member.displayName}}><a ui-sref=\"user-home-page.personal.home({id: member.id})\" target=_blank></a></div><div ng-if=\"vm.members && vm.members.length && vm.community.member_count > 4\" class=community-detail-page__content__col-right__section__info-member>{{vm.community.member_count - 4}}+</div></div><div ng-if=\"(vm.isMine || vm.community.membership_status == \'manager\') && vm.canUpdateCommunity\" class=community-detail-page__content__col-right__section__title translate>{{\'invite-new-members\'}}</div><div ng-if=\"vm.isMine || vm.community.membership_status == \'manager\' \" ng-show=vm.canUpdateCommunity class=community-detail-page__content__col-right__section__social-list><div class=\"community-detail-page__content__col-right__section__social-item whatsapp-icon-grey-color\"><div id=whatsappComShare></div></div><div class=\"community-detail-page__content__col-right__section__social-item email-icon-grey-color\" ng-click=vm.onSendInviteEmail()></div><div class=\"community-detail-page__content__col-right__section__social-item link-icon-grey-color\" ng-click=vm.onSendInviteLink()></div><share ng-click=$event.stopPropagation() settings=vm.shareSettings content-will-be-shared=vm.SocialShareContent ng-if=vm.SocialShareContent class=\"community-detail-page__content__col-right__section__share-social share-social\" title=\"Share this community\"></share></div><button ng-if=\"(vm.isMine || vm.community.membership_status == \'manager\') && vm.canUpdateCommunity\" class=\"community-detail-page__content__col-right__section__invite-members-btn btn btn-submit--transparent\" ng-click=vm.onInviteMembers()>{{\'invite-friends\' | translate}}</button></div><div class=\"community-detail-page__content__col-right__section about-section\"><div class=community-detail-page__content__col-right__section__header><div class=community-detail-page__content__col-right__section__title translate>{{\'about-this-community\'}}</div><div ng-if=vm.isMine class=community-detail-page__content__col-right__section__control ng-click=\"vm.onManageCommunityClicked(\'admin\')\">{{\'edit\' | translate}}</div></div><div ng-if=vm.isMine class=community-detail-page__content__col-right__section__strike-list><div class=community-detail-page__content__col-right__section__strike-list__wrapper><div class=community-detail-page__content__col-right__section__strike-list__list><div ng-repeat=\"srike in [].constructor(vm.maxStrikes) track by $index\" class=community-detail-page__content__col-right__section__strike-list__item ng-class=\"{\'icon-icons_close striked\': $index < vm.community.strike_count}\"></div></div><!-- <div ng-if=\"vm.community.previous_deactivation_count\"\r\n								class=\"community-detail-page__content__col-right__section__strike-list__list\">\r\n								<div ng-repeat=\"srike in [].constructor(vm.community.previous_deactivation_count) track by $index\"\r\n									class=\"community-detail-page__content__col-right__section__strike-list__item icon-icons_close striked-reactived\">\r\n								</div>\r\n							</div> --></div><div class=\"community-detail-page__content__col-right__section__strike-list__tooltip icon-icons-info\" tooltip-placement=auto tooltip-trigger=\"\'outsideClick\'\" tooltip-class=community-detail-page__content__col-right__section__strike-list__tooltip__inner uib-tooltip-html=\"\'community-strike-explain-admin\' | translate\"></div></div><div ng-if=!vm.isEditCommunityDescription class=community-detail-page__content__col-right__section__description><div ng-repeat=\"des in vm.description\" class=community-detail-page__content__col-right__section__description__item ng-class=\"{\'is-line-item\': des.isLineItem}\">{{des.text}}</div></div><textarea ng-if=vm.isEditCommunityDescription placeholder=\"{{\'about-this-community-placeholder\' | translate}}\" class=community-detail-page__content__col-right__section__textarea-description ng-model=vm.communityDescription></textarea><div ng-if=vm.isEditCommunityDescription class=community-detail-page__content__col-right__section__textarea-description__control><div class=community-detail-page__content__col-right__section__textarea-description__control__ok ng-click=vm.onEditDescriontionSave()>{{\'save\' | translate}}</div><div class=community-detail-page__content__col-right__section__textarea-description__control__cancel ng-click=vm.onEditDescriontionCancel()>{{\'cancel\' | translate}}</div></div></div><div class=\"community-detail-page__content__col-right__section region-country-section\"><div class=community-detail-page__content__col-right__section__header><div class=community-detail-page__content__col-right__section__title>Region or Countries</div><div ng-if=vm.isMine class=community-detail-page__content__col-right__section__control ng-click=\"vm.onManageCommunityClicked(\'admin\')\">{{\'edit\' | translate}}</div></div><div class=community-detail-page__content__col-right__section__body>{{vm.communityCountries}}</div></div><div class=\"community-detail-page__content__col-right__section posting-permission-section\"><div class=community-detail-page__content__col-right__section__header><div class=community-detail-page__content__col-right__section__title>Posting Permission</div><div ng-if=vm.isMine class=community-detail-page__content__col-right__section__control ng-click=\"vm.onManageCommunityClicked(\'admin\')\">{{\'edit\' | translate}}</div></div><div class=community-detail-page__content__col-right__section__body>{{vm.postingPermission}}</div></div><div class=\"community-detail-page__content__col-right__section rule-section\"><div class=community-detail-page__content__col-right__section__header><div class=community-detail-page__content__col-right__section__title translate>{{\'community-rules\'}}</div><div ng-if=vm.isMine class=community-detail-page__content__col-right__section__control ng-click=\"vm.onManageCommunityClicked(\'admin\')\">{{\'edit\' | translate}}</div></div><div ng-if=\"!vm.isEditCommunityRules && vm.rules.length\" class=community-detail-page__content__col-right__section__rules><div ng-repeat=\"rule in vm.rules\" class=community-detail-page__content__col-right__section__rules__item ng-class=\"{\'is-line-item\': rule.isLineItem}\">{{rule.text}}</div></div><textarea ng-if=vm.isEditCommunityRules placeholder=\"{{\'community-rule-placeholder\' | translate}}\" class=community-detail-page__content__col-right__section__textarea-description ng-model=vm.communityRules></textarea><div ng-if=vm.isEditCommunityRules class=community-detail-page__content__col-right__section__textarea-description__control><div class=community-detail-page__content__col-right__section__textarea-description__control__ok ng-click=vm.onEditRulesSave()>{{\'save\' | translate}}</div><div class=community-detail-page__content__col-right__section__textarea-description__control__cancel ng-click=vm.onEditRulesCancel()>{{\'cancel\' | translate}}</div></div></div></div></section></div></div>");
$templateCache.put("app/complete-profile-page/complete-profile-page.html","<div class=complete-profile-page><div class=complete-profile-page__wrapper><div class=\"complete-profile-page__main-content clearfix\"><div class=\"complete-profile-page__header clearfix\"><div class=complete-profile-page__header__avatar ng-style=\"{\'background-image\': \'url(\\\'\' + vm.userAvatar+ \'\\\')\'}\"></div><div class=\"complete-profile-page__header__description clearfix\"><div class=\"complete-profile-page__header__description__title col-xs-10 text--bold no-padding\">Hi {{vm.loginedUser.displayName}}</div><div class=\"complete-profile-page__header__description__welcome col-xs-10 no-padding\" translate>{{\'signup-complete-profile\'}}</div></div></div><div class=\"complete-profile-page__content clearfix\"><div class=\"complete-profile-page__content__title text--bold\">{{\'increase-discoverability\' | translate}}:</div><div class=\"complete-profile-page__tile clearfix\"><div class=\"complete-profile-page__tile__title text--bold\" translate>{{\'profile-photo\'}}</div><div class=complete-profile-page__tile__description><div class=complete-profile-page__tile__icon><div class=status-icon ng-class=\"vm.loginedUser && vm.loginedUser.profile_image ? \'icon-icons_check\' : \'icon-person-circle\'\"></div></div><div class=complete-profile-page__tile__content translate>{{\'profile-photo-description\'}}</div></div></div><div class=\"complete-profile-page__tile clearfix\"><div class=\"complete-profile-page__tile__title text--bold\" translate>{{\'skills-experience\'}}</div><div class=complete-profile-page__tile__description><div class=complete-profile-page__tile__icon><div class=status-icon ng-class=\"vm.loginedUser && vm.isSkillCompleted ? \'icon-icons_check\' : \'icon-photography-document\'\"></div></div><div class=complete-profile-page__tile__content translate>{{\'skill-experience-description\'}}</div></div></div></div></div><div class=\"complete-profile-page__footer clearfix\"><div class=complete-profile-page__footer__wrapper><!-- <button class=\"btn complete-profile-page__footer__control-btn skip-btn text--bold btn-cancel--no-background\" ng-click=\"vm.onSkipClicked()\">Skip</button> --> <button class=\"btn btn-submit complete-profile-page__footer__control-btn continue-btn text--bold\" ng-click=vm.onIncompleteProfileClicked()>{{\'continue\' | translate}}</button></div></div></div></div>");
$templateCache.put("app/custom-commission-ad/custom-commission-ad.html","<div class=custom-commission-ad><section class=custom-commission-ad__branding><div class=custom-commission-ad__branding__content><div class=custom-commission-ad__branding__content__header>Hire a creator for your next project</div><div class=custom-commission-ad__branding__content__desc>Need a photographer or videographer? We’ll match you with the best talents in Asia.</div><div id=bcc_001 tracking-element class=custom-commission-ad__branding__content__box ng-click=vm.onBookCcBtnClicked()>Book a shoot Now</div><div class=custom-commission-ad__branding__content__hint translate>{{\'have-multiple-shoots-per-month\'}}</div></div><photo-info-link photo=vm.brandingPhoto></photo-info-link></section><section class=custom-commission-ad__branch><div class=custom-commission-ad__branch__label translate>{{\'we-help-brands\'}}</div><div class=custom-commission-ad__branch__list><div class=\"custom-commission-ad__branch__item grab-food\"><img src=assets/images/custom-commission-ad/grab-food.png alt=\"\"></div><div class=\"custom-commission-ad__branch__item honda\"><img src=assets/images/custom-commission-ad/honda.png alt=\"\"></div><div class=\"custom-commission-ad__branch__item blackmores\"><img src=assets/images/custom-commission-ad/blackmores.png alt=\"\"></div><div class=\"custom-commission-ad__branch__item peoples-association\"><img src=assets/images/custom-commission-ad/peoples-association.png alt=\"\"></div><div class=\"custom-commission-ad__branch__item gurobu-sports\"><img src=assets/images/custom-commission-ad/gurobu-sports.png alt=\"\"></div><div class=\"custom-commission-ad__branch__item cellini\"><img src=assets/images/custom-commission-ad/cellini.png alt=\"\"></div><div class=\"custom-commission-ad__branch__item enterprise-singapore\"><img src=assets/images/custom-commission-ad/enterprise-singapore.png alt=\"\"></div><div class=\"custom-commission-ad__branch__item cnb\"><img src=assets/images/custom-commission-ad/cnb.png alt=\"\"></div><div class=\"custom-commission-ad__branch__item shield\"><img src=assets/images/custom-commission-ad/shield.png alt=\"\"></div><div class=\"custom-commission-ad__branch__item skills-future\"><img src=assets/images/custom-commission-ad/skills-future.png alt=\"\"></div></div></section><section class=custom-commission-ad__three-steps><div class=custom-commission-ad__three-steps__header>It takes just three easy steps.</div><div class=custom-commission-ad__three-steps__description>Let Asia\'s top visual creators fulfil your creative vision. Manage it all from your desk.</div><div class=custom-commission-ad__three-steps__block><div class=custom-commission-ad__three-steps__block__col><div class=\"custom-commission-ad__three-steps__block__icon icon-letter-brief\"></div><div class=custom-commission-ad__three-steps__block__header>Prepare<br>a brief</div><div class=custom-commission-ad__three-steps__block__description>We\'ll work with you to build a brief tailored to your creative vision and brand guidelines.</div></div><div class=custom-commission-ad__three-steps__block__line><div class=custom-commission-ad__three-steps__block__line-background></div></div><div class=custom-commission-ad__three-steps__block__col><div class=\"custom-commission-ad__three-steps__block__icon icon-bestfit\"></div><div class=custom-commission-ad__three-steps__block__header>Find your<br>photographer match</div><div class=custom-commission-ad__three-steps__block__description>Based on the brief, we\'ll match you with the photographer best suited for your needs.</div></div><div class=custom-commission-ad__three-steps__block__line><div class=custom-commission-ad__three-steps__block__line-background></div></div><div class=custom-commission-ad__three-steps__block__col><div class=\"custom-commission-ad__three-steps__block__icon icon-select-photos\"></div><div class=custom-commission-ad__three-steps__block__header>Select the<br>best photos</div><div class=custom-commission-ad__three-steps__block__description>Shortlist the best shots, feedback, approve and download the final photos for immediate use.</div></div></div></section><section class=custom-commission-ad__auto-mobile><div class=custom-commission-ad__auto-mobile__header>Automobile. Lifestyle. Sports. And more.</div><div class=custom-commission-ad__auto-mobile__description>Discover what Custom Commissions have done for real brands out there.</div></section><section class=custom-commission-ad__photo><slick data=vm.slideDatas arrows=false on-init=vm.slickSetting.onInit(slick) adaptive-height=true><div ng-repeat=\"data in vm.slideDatas\" class=slide-{{$index}}-style><div ng-repeat=\"photo in data.photos\" class=\"photo-slide-item photo-{{$index}}\" ng-class=\"{\'info-last\': data.infoLast && $index === data.indexShowInfo, \'info-center\': !data.infoLast && $index === data.indexShowInfo }\" ng-style=\"{\'background-image\': \'url(\' + photo + \')\'}\"><div ng-if=$first class=photo-slide-logo ng-style=\"{\'background-image\': \'url(\' + data.logo + \')\'}\"></div><div ng-if=\"$index === data.indexShowInfo\" class=block-info-wrapper><div class=block-info-wrapper__item><div class=block-info-wrapper__item__value>{{data.slideInfo.photoShoot}}</div><div class=block-info-wrapper__item__label>Photos shot</div></div><div class=\"block-info-wrapper__item spec-block\" ng-style=\"{\'background-color\': data.themeColor}\"><div class=block-info-wrapper__item__sub-block ng-class=\"{\'top-block\': data.slideInfo.models || data.slideInfo.hawkers}\"><div class=block-info-wrapper__item__sub-block__value>{{data.slideInfo.days}}</div><div class=block-info-wrapper__item__sub-block__label>Days</div></div><div ng-if=\"data.slideInfo.models || data.slideInfo.hawkers\" class=block-info-wrapper__item__sub-block></div><div ng-if=\"data.slideInfo.models || data.slideInfo.hawkers\" class=block-info-wrapper__item__sub-block></div><div ng-if=\"data.slideInfo.models || data.slideInfo.hawkers\" class=\"block-info-wrapper__item__sub-block bottom-block\"><div class=block-info-wrapper__item__sub-block__value>{{data.slideInfo.models || data.slideInfo.hawkers}}</div><div class=block-info-wrapper__item__sub-block__label>{{data.slideInfo.models ? \'Models\' : \'Hawkers\'}}</div></div><div ng-if=\"data.slideInfo.models || data.slideInfo.hawkers\" class=block-info-wrapper__item__sub-block__line></div></div><div class=block-info-wrapper__item><div class=block-info-wrapper__item__value>{{data.slideInfo.licensed}}</div><div class=block-info-wrapper__item__label>Photos licensed</div></div></div></div></div></slick><div class=custom-commission-ad__photo__slide-control><div class=\"custom-commission-ad__photo__slide-control__left icon-baseline-arrow_back\" ng-click=vm.onPreviousSlide()></div><div class=\"custom-commission-ad__photo__slide-control__right icon-baseline-arrow_forward\" ng-click=vm.onNextSlide()></div></div></section><section class=custom-commission-ad__photo-assignment><div class=custom-commission-ad__photo-assignment__col-left><div class=custom-commission-ad__photo-assignment__header>Have a photo assignment in mind?</div><div class=custom-commission-ad__photo-assignment__description>Get in touch. Our team is ready to help.</div></div><div class=custom-commission-ad__photo-assignment__col-right><div id=bcc_002 tracking-element class=custom-commission-ad__photo-assignment__box ng-click=vm.onBookCcBtnClicked()>Book a shoot Now</div></div></section><section class=\"row custom-commission-ad__footer clearfix\"><div class=\"custom-commission-ad__footer__main-menu clearfix\"><div class=\"custom-commission-ad__footer__links-wrapper clearfix\"><div class=\"custom-commission-ad__footer__col-right clearfix\"><div class=\"custom-commission-ad__footer__links footer-nav-community\"><div class=custom-commission-ad__footer__apps__btn__wrapper><link-mobile-app></link-mobile-app></div></div><div class=\"custom-commission-ad__footer__social-links clearfix\"><h3 class=custom-commission-ad__footer__links__label translate>{{\'connect-with-us-on\'}}</h3><div class=\"custom-commission-ad__footer__social_btn_wrapper clearfix\"><a href=https://www.facebook.com/Pixerf target=_blank><img src=../../assets/images/casestudies/logos/facebook@2x.png alt=\"facebook link\"> </a><a class=ng-hide href=https://www.pinterest.com/Pixerf/ target=_blank><img src=../../assets/images/casestudies/logos/linked-in@2x.png alt=\"linkedin link\"> </a><a class=ng-hide href=https://plus.google.com/+Pixerf target=_blank><span class=icon-icons_googleplus></span> </a><a class=ng-hide href=https://www.youtube.com/Pixerf target=_blank><span class=\"fa fa-youtube\"></span> </a><a href=http://instagram.com/Pixerf target=_blank><img src=../../assets/images/casestudies/logos/instagram@2x.png alt=\"instagram link\"> </a><a href=https://twitter.com/Pixerf target=_blank><img src=../../assets/images/casestudies/logos/twitter@2x.png alt=\"twitter link\"></a></div></div></div></div></div><div class=\"custom-commission-ad__footer__banner text-center\"><span>© 2020 PIXERF Pte Ltd. All Rights Reserved.</span></div></section></div>");
$templateCache.put("app/custom-commission-basic-form-popup/custom-commission-basic-form-popup.html","<div class=custom-commission-basic-form-popup><button type=button class=close ng-click=vm.cancel()><span class=icon-icons_close aria-hidden=true></span></button><div class=clearfix><div class=\"custom-commission-basic-form-popup__header clearfix\"><div class=\"custom-commission-basic-form-popup__header__title text--extrabold text--color-black\">{{vm.StateData[vm.currentState].title}}</div><div class=custom-commission-basic-form-popup__header__desc ng-bind-html=vm.StateData[vm.currentState].desc></div></div><div class=custom-commission-basic-form-popup__body><div ng-if=\"vm.currentState == 1\" class=custom-commission-basic-form-popup__body__select-type><div class=custom-commission-basic-form-popup__body__select-type__grid-wrapper><div ng-repeat=\"category in vm.categoriesList\" ng-click=vm.onSelectCategory(category.name) class=custom-commission-basic-form-popup__body__select-type__item ng-class=\"{\'active\': vm.formData.category == category.name}\"><div class=\"custom-commission-basic-form-popup__body__select-type__item__background zoom-hover\" ng-style=\"{\'background-image\': \'url(\'+ category.thumbnails + \')\'}\"><div class=custom-commission-basic-form-popup__body__select-type__overlay></div></div><div class=custom-commission-basic-form-popup__body__select-type__item__name>{{category.name}}</div></div><div class=custom-commission-basic-form-popup__body__select-type__item ng-click=\"vm.onSelectCategory(\'Other\')\" ng-class=\"{\'active\': vm.formData.category == \'Other\'}\"><div class=\"custom-commission-basic-form-popup__body__select-type__item__background zoom-hover\"></div><div class=\"custom-commission-basic-form-popup__body__select-type__item__name category-other\">Other</div></div></div></div><div ng-if=\"vm.currentState == 2\" class=custom-commission-basic-form-popup__body__set-budget><div class=input-group-wrap><div class=input-group ng-class=\"{\'invalid\': !vm.isValidBugetFrom()}\"><div class=\"input-group-addon text--color-black-6 text--semibold\">SGD</div><div class=\"custom-commission-basic-form-popup__body__set-budget__math-group clearfix\"><input input-number-only-max-digits=5 required input-number-only validation-min-max validation-min-max-min=0 class=\"form-control custom-commission-basic-form-popup__body__set-budget__input\" placeholder=0 ng-model=vm.formData.budgetFrom></div></div></div><div class=\"custom-commission-basic-form-popup__body__set-budget__hint-sign big-sign\">to</div><div class=input-group-wrap><div class=input-group ng-class=\"{\'invalid\': !vm.isValidBugetTo()}\"><div class=\"input-group-addon text--color-black-6 text--semibold\">SGD</div><div class=\"custom-commission-basic-form-popup__body__set-budget__math-group clearfix\"><input input-number-only-max-digits=5 required input-number-only validation-min-max validation-min-max-min=1 class=\"form-control custom-commission-basic-form-popup__body__set-budget__input\" placeholder=0 ng-model=vm.formData.budgetTo></div></div></div></div><div ng-if=\"vm.currentState == 3\" class=custom-commission-basic-form-popup__body__set-location ng-class=\"{\'error-date\': vm.showErrorDeliveryTime}\"><div class=\"form-group name-wrapper\"><label for=name ng-class=\"!contactDetailForm.$pristine && contactDetailForm.name.$invalid ? \'text--color-error\' : \'text--color-black\'\" translate>{{\'country\'}}</label><pixerf-input-auto-complete dropdown-class=custom-commission-basic-form-popup__body__contries options=vm.countriesOpts name=custom-commission-basic-form-popup__body__countries__input data=vm.countries model=vm.selectedCountries on-changed=vm.onCountriesSelected()></pixerf-input-auto-complete></div><div class=\"form-group name-wrapper\"><label for=name ng-class=\"!contactDetailForm.$pristine && contactDetailForm.name.$invalid ? \'text--color-error\' : \'text--color-black\'\" translate>{{\'city\'}}</label><input ng-if=vm.gplacesOptions required name=location ng-model=vm.formData.city class=form-control g-places-autocomplete force-selection=true options=vm.gplacesOptions></div><div class=\"form-group name-wrapper\"><label for=name ng-class=\"!contactDetailForm.$pristine && contactDetailForm.name.$invalid ? \'text--color-error\' : \'text--color-black\'\">{{\'address\' | translate}} (Optional)</label><input class=form-control type=text ng-model=vm.formData.address></div></div><div ng-if=\"vm.currentState == 4\" class=custom-commission-basic-form-popup__body__set-expected-delivery ng-class=\"{\'error-date\': vm.showErrorDeliveryTime}\"><div class=\"input-group pixerf-calendar-input\"><datetime-dropdown model=vm.formData.deliveryTime options=vm.deliveryTimeOptions invalid=vm.invalidDeliveryTime></datetime-dropdown></div><div class=custom-commission-basic-form-popup__body__set-expected-delivery__error-text><span ng-if=vm.showErrorDeliveryTime>{{\'you-cannot-select-a-date-in-the-past\'| translate}}</span></div></div><form ng-show=\"vm.currentState == 5\" name=contactDetailForm id=contactDetailForm class=\"clearfix custom-commission-basic-form-popup__body__contact-detail-form\"><div class=\"form-group name-wrapper\"><label for=name ng-class=\"!contactDetailForm.$pristine && contactDetailForm.name.$invalid ? \'text--color-error\' : \'text--color-black\'\" translate>{{\'full-name\'}}</label><input maxlength=255 name=name required ng-model=\" vm.formData.fullName\" type=text class=form-control></div><div class=\"form-group email-wrapper\"><label for=email ng-class=\"!contactDetailForm.$pristine && contactDetailForm.email.$invalid ? \'text--color-error\' : \'text--color-black\'\" translate>{{\'Email\'}}</label><input maxlength=255 name=email type=email required ng-model=vm.formData.email type=text class=form-control></div><div class=\"form-group mobile-wrapper\"><label for=mobile ng-class=\"!contactDetailForm.$pristine && contactDetailForm.mobile.$invalid ? \'text--color-error\' : \'text--color-black\'\" translate>{{\'mobile-no\'}}</label><input ng-model=\" vm.formData.mobile\" maxlength=255 name=mobile national-mode=false international-phone-number default-country=sg type=text class=form-control></div><div class=custom-commission-basic-form-popup__body__contact-detail-form__subscrible-news-letter><pixerf-checkbox error=\"!vm.isAgreedTnC && vm.isFormDirty\" model=vm model-property=subcribleNewsLetter></pixerf-checkbox><div class=custom-commission-basic-form-popup__body__contact-detail-form__agreement-sentence translate>{{\'subscrible-newsletter\'}}</div><div class=custom-commission-basic-form-popup__body__contact-detail-form__agreement-by-click translate>{{\'by-clicking-send-share-your-contract-details-for-follow-up-purposes\'}}</div></div></form><div ng-show=\"vm.currentState == 6\" class=custom-commission-basic-form-popup__body__thanks-you><span ng-click=vm.onBrowseSignatureGalleriesBrnClicked() class=custom-commission-basic-form-popup__body__thanks-you__to-signature-galleries>{{\'browse-signature-galleries\'| translate}}</span></div><spinner-win spinner=vm.spinner></spinner-win></div><div class=\"custom-commission-basic-form-popup__footer clearfix\" ng-hide=\"vm.currentState > vm.arraySteps.length\"><div class=custom-commission-basic-form-popup__footer__steps><span ng-repeat=\"step in vm.arraySteps\" class=custom-commission-basic-form-popup__footer__step ng-click=\"vm.canJump(contactDetailForm) && vm.onBackBtnClicked($index + 1)\" ng-class=\"{\'active\': $index == (vm.currentState - 1), \'not-allow\': ($index > (vm.highestState - 1)) || !vm.canJump(contactDetailForm)}\"></span></div><button class=\"btn btn-submit btn-next\" ng-disabled=!vm.canNext(contactDetailForm) ng-click=vm.onNextBtnClicked() translate>{{vm.isSaveingStep() ? \'Send\' : \'next\'}}</button><!-- <button class=\"btn btn-back\" ng-if=\"vm.canBack(profileForm, profileFormBiz)\" ng-click=\"vm.onBackBtnClicked()\"\r\n				translate>{{\'back\'}}\r\n			</button> --></div><div ng-if=[1,2,3,4,5].includes(vm.currentState) class=custom-commission-basic-form-popup__footer__hint>If you have regular or multiple shoot requests, <a ng-click=vm.onContactUsBtnClicked() class=\"text--color-pixerf-theme text--bold\" target=_blank>contact us</a>.</div></div></div>");
$templateCache.put("app/custom-commissions-detail-page/custom-commissions-detail-page.html","<div class=\"custom-commissions-detail-page main__content--md\" ng-class=\"{\'margin-top--1\': isScreenMobile}\"><section class=custom-commissions-detail-page__content><div class=custom-commissions-detail-page__header><div class=custom-commissions-detail-page__logo><img ng-src={{vm.logo}}></div><div class=custom-commissions-detail-page__cc-name>{{vm.customCommissions.name}}</div></div><navigation-horizontal instance=vm.navigation></navigation-horizontal></section><section ui-view class=\"custom-commissions-detail-page__content-view clearfix\"></section></div>");
$templateCache.put("app/discussion-detail-page/discussion-detail-page.html","<div class=\"discussion-detail-page main__content--md\"><div class=discussion-detail-page__header dynamic-show-hide-scroll scroll-down-class=hide-on-mobile><div class=discussion-detail-page__header__back-btn ng-click=vm.onBackbtnClicked()><span class=discussion-detail-page__header__back-btn__icon>&lt;</span> <span translate=back-to translate-values=\"{name: \'Community Discussions\'}\"></span></div><div class=discussion-detail-page__header__control><div class=\"discussion-detail-page__header__control__btn icon-icons_chevron-left\" ng-class=\"{\'disabled\': (vm.currentIndexDiscussion === 0) || (vm.discussions.length == 0)}\" ng-click=vm.onPrevDiscussion()></div><div class=\"discussion-detail-page__header__control__btn icon-icons_chevron-right\" ng-class=\"{\'disabled\': (vm.currentIndexDiscussion === (vm.discussions.length - 1)) || (vm.discussions.length == 0)}\" ng-click=vm.onNextDiscussion()></div></div></div><div class=discussion-detail-page__body><div class=discussion-detail-page__col-left><div class=discussion-detail-page__col-left__detail><div ng-if=\"vm.isCommunityOwner || !vm.isOwner\" uib-dropdown class=discussion-detail-page__col-left__detail__control-more><span uib-dropdown-toggle class=icon-icons_more></span><ul class=discussion-detail-page__col-left__detail__list uib-dropdown-menu role=menu><li ng-if=vm.isCommunityOwner role=menuitem class=discussion-detail-page__col-left__detail__item ng-click=vm.onManageRights()>{{\'manage-rights\' | translate}}</li><li ng-if=!vm.isOwner role=menuitem class=discussion-detail-page__col-left__detail__item ng-click=vm.onReportDiscussion(vm.discussion) translate translate-values=\"{thing: \'post\'}\">{{\'report-thing\'}}</li></ul></div><div ng-if=vm.discussion.is_bookmarked class=\"discussion-detail-page__col-left__bookmarked-flag icon-bookmark\"></div><div class=discussion-detail-page__col-left__header><div class=discussion-detail-page__col-left__header__title ng-class=\"{\'no-control-top-right\': !vm.isCommunityOwner && vm.isOwner}\">{{vm.discussion.subject}}</div></div><div class=discussion-detail-page__col-left__content><div class=discussion-detail-page__col-left__content__info><div class=discussion-detail-page__col-left__content__left><a ng-if=\"vm.discussion.user.account_type === \'personal\'\" ui-sref=\"user-home-page.personal.home({id: vm.discussion.user.id, userName: (vm.discussion.user.displayName | toSnakeCase)})\" target=_blank><pixerf-user-avatar class=discussion-detail-page__col-left__content__left__author-avatar user-data=vm.discussion.user lazy=true></pixerf-user-avatar></a><pixerf-user-avatar ng-if=\"vm.discussion.user.account_type === \'business\'\" class=discussion-detail-page__col-left__content__left__author-avatar user-data=vm.discussion.user lazy=true></pixerf-user-avatar></div><div class=discussion-detail-page__col-left__content__right><div class=discussion-detail-page__col-left__content__right__header><div class=discussion-detail-page__col-left__content__right__name>{{vm.discussion.user.displayName}}</div><div class=discussion-detail-page__col-left__content__right__time>{{vm.inserted_at}}</div></div></div></div><div class=discussion-detail-page__col-left__content__main><div class=discussion-detail-page__col-left__content__right__description>{{vm.discussion.description}}</div><div ng-if=\"vm.discussion.photos && vm.discussion.photos.length\" flex-grid ng-model=vm.discussion.photos rowheight=50 lastrow=justify margins=10><div ng-repeat=\"photo in vm.discussion.photos\"><a ng-attr-fancyboxable=\"{\'type\': \'image\', \'overlayShow\': true, \'hideOnOverlayClick\': true, \'showNavArrows\': true, \'margin\': \'50 10 15 10\', \'centerOnScroll\': true}\" href={{photo.url.large}} rel=discussionAttachment><img ng-src={{photo.url.thumbnail}}></a></div></div></div></div><div class=discussion-detail-page__col-left__info><div ng-if=\"vm.discussion.like_count > 0\" class=discussion-detail-page__col-left__info__like ng-click=vm.onShowListLike() title=\"Click to see who liked this discussion\"><span class=discussion-detail-page__col-left__info__value>{{vm.discussion.like_count}}</span> <span>{{vm.discussion.like_count === 1 ? (\'like\' | translate).toLowerCase() : (\'likes\' | translate).toLowerCase()}}</span></div><div ng-if=\"vm.discussion.reply_count > 0\" class=discussion-detail-page__col-left__info__reply ng-click=vm.onShowListReply() title=\"Click to see who replied this photo\"><span class=discussion-detail-page__col-left__info__value>{{vm.discussion.reply_count}}</span> <span>{{vm.discussion.reply_count === 1 ? (\'reply\' | translate).toLowerCase() : (\'replies\' | translate).toLowerCase()}}</span></div></div><div class=discussion-detail-page__col-left__control><div ng-if=\"vm.isOwner || vm.loginUser.canRemoveReplyDiscussion\" class=\"discussion-detail-page__col-left__control__list discussion-detail-page__col-left__control__owner\"><div ng-if=vm.isOwner class=\"discussion-detail-page__col-left__control__icon discussion-detail-page__col-left__control__owner__edit icon-icons_edit icon-pencil\" ng-click=vm.onEditDiscussion() uib-tooltip=Edit tooltip-placement=left></div><div class=\"discussion-detail-page__col-left__control__icon discussion-detail-page__col-left__control__owner__remove icon-icons_close\" ng-click=vm.onRemoveDiscussion() uib-tooltip=Remove tooltip-placement=left></div></div><div ng-if=!vm.isOwner class=\"discussion-detail-page__col-left__control__list discussion-detail-page__col-left__control__guest\"><div class=\"discussion-detail-page__col-left__control__icon discussion-detail-page__col-left__control__guest__bookmark icon-bookmark\" ng-class=\"{\'bookmarked\': vm.discussion.is_bookmarked}\" authentication-click=vm.onBookmarkToggle($event) uib-tooltip=Bookmark tooltip-placement=left></div><div class=\"discussion-detail-page__col-left__control__icon discussion-detail-page__col-left__control__guest__like icon-icons_like\" ng-class=\"{\'liked\': vm.discussion.is_liked}\" authentication-click=vm.onLikeToggle($event) uib-tooltip=Like tooltip-placement=left></div><!-- <div class=\"discussion-detail-page__col-left__control__icon discussion-detail-page__col-left__control__guest__reply icon-comment-circle\"\r\n							authentication-click=\"vm.onComment(vm.discussion)\" uib-tooltip=\"Comment\"\r\n							tooltip-placement=\"left\"></div> --></div></div></div><div class=discussion-detail-page__col-left__comment><div ng-if=vm.loginUser class=discussion-detail-page__col-left__comment__input><pixerf-user-avatar class=discussion-detail-page__col-left__comment__input__author-avatar user-data=vm.loginUser lazy=true></pixerf-user-avatar><div class=discussion-detail-page__col-left__comment__input__wrapper><div class=discussion-detail-page__col-left__comment__input__author-input__wrapper><div rows=1 type=text enter=vm.onCommentDiscussion(vm.commentText) class=discussion-detail-page__col-left__comment__input__author-input ng-model=vm.commentText contenteditable={{!vm.isAttachmentUploading}}></div><div ng-hide=vm.commentText class=discussion-detail-page__col-left__comment__input__author-input__placeholder>Reply to discussion...</div></div><div ng-hide=!vm.showAttachPhotoBtn id=comment-attach-photos-button class=\"comment-attach-photos-button discussion-detail-page__author-attach-photos-button icon-icons_camera\"></div><div id=comment-attach-photos class=discussion-detail-page__attach pixerf-dropzone dropzone=vm.dropzoneConfig.instance dropzone-config=vm.dropzoneConfig.options event-handlers=vm.dropzoneConfig.eventHandlers><div class=\"comment-attach-photos-button discussion-detail-page__author-attach-photos-button__attach-more\" ng-hide=\"!vm.showAttachPhotoBtn || vm.isAttachmentUploading\">+</div></div></div><button class=discussion-detail-page__col-left__comment__input__submit-btn ng-click=vm.onCommentDiscussion(vm.commentText) uib-tooltip=Publish loading-spinner ng-class=\"{\'is-working\': vm.isAttachmentUploading}\" ng-disabled=vm.isAttachmentUploading></button></div><div class=discussion-detail-page__col-left__comment__list infinite-scroll-disabled=vm.isLastDiscussionComments infinite-scroll=vm.fetchMoreDiscussionComments() infinite-scroll-immediate-check=false><discussion-comment ng-repeat=\"comment in vm.discussionComments track by comment.id\" comment=comment can-reply=true on-removed=vm.onCommentRemoved(data) can-comment=\"vm.isOwner || vm.isMember\" scroll-to-this=\"comment.id === vm.scrollToElement\"></discussion-comment><scroll-paging spinner=vm.spinnerComment is-last-page=vm.isLastDiscussionComments show-message=false></scroll-paging></div></div></div><div class=discussion-detail-page__col-right><div class=discussion-detail-page__col-right__search><div class=\"discussion-detail-page__col-right__search__input__icon icon-icons_search\"></div><input type=text class=discussion-detail-page__col-right__search__input placeholder=\"{{\'search-topic\' | translate}}\" ng-change=vm.onSearchSimilarDiscussion() ng-model=vm.searchSimilarDiscussionsString></div><div class=discussion-detail-page__col-right__results infinite-scroll-disabled=vm.isLastSimilarDiscussionPage infinite-scroll=vm.fetchMoreSimilarDiscussions() infinite-scroll-immediate-check=false><similar-discussion-tile ng-repeat=\"similarDiscussion in vm.similarDiscussions\" discussion=similarDiscussion></similar-discussion-tile><scroll-paging spinner=vm.spinnerSimilarDiscussions is-last-page=vm.isLastSimilarDiscussionPage show-message=false></scroll-paging></div></div></div></div>");
$templateCache.put("app/email-us-page/email-us-page.html","<div class=email-us-page><div class=email-us-page__header translate>{{\'contact-title\'}}</div><div class=email-us-page__infro-form><form name=profileForm><div class=email-us-page__info-form__row><label for=name translate>{{\'name\'}}</label><input required validation-no-hyperlink validation-no-number ng-model=vm.inquiry.name name=name placeholder=\"Enter your name\" class=form-control></div><div class=email-us-page__info-form__row><label for=email translate>{{\'email\'}}</label><input required name=email ng-model=vm.inquiry.email type=email class=form-control placeholder=\"Provide company email if applicable\"></div><div class=email-us-page__info-form__row><label for=topic translate>{{\'topic\'}}</label><pixerf-input-auto-complete data=vm.topicTypes model=vm.selectedTopic options=vm.topicOptions on-changed=vm.onTopicChanged(vm.selectedTopic)></pixerf-input-auto-complete></div><div class=email-us-page__info-form__row><label for=description>How can we help?</label><textarea required rows=4 name=description ng-model=vm.inquiry.description class=\"form-control form-control__textarea\" minlength=50></textarea></div></form></div><button ng-disabled=vm.isWorking type=button class=\"email-us-page__submit-btn btn btn-submit\" ng-click=\"vm.sendEnquire(vm.inquiry, profileForm)\">Leave us a message</button></div>");
$templateCache.put("app/event-detail-page/event-detail-page.html","<div class=\"event-detail-page main__content--md clearfix\" id=event-detail-page ng-class=\"{\'margin-top--1\': isScreenMobile}\"><div class=event-detail-page__col-left><div class=event-detail-page__community><div class=event-detail-page__community__avatar ui-sref=\"user-home-page.homepage({id: vm.loginedUser.id})\"><pixerf-user-avatar user-data=vm.loginedUser lazy=true></pixerf-user-avatar></div><div class=event-detail-page__community__name ui-sref=\"user-home-page.homepage({id: vm.loginedUser.id})\">{{vm.loginedUser.displayName}}</div><div class=event-detail-page__community__acc-type>{{vm.loginedUser.account_type}}</div></div><div class=event-detail-page__events><div class=event-detail-page__events__header>Your {{vm.isTypeClass ? \'Classes\' : \'Events\'}}</div><div ng-if=vm.loginedUser.canManageCommunity class=event-detail-page__events__section-wrapper><div class=event-detail-page__events__title>{{vm.isTypeClass ? \'Classes\' : \'Events\'}} Hosted</div><div ng-if=vm.yourEvents.length class=\"event-detail-page__events__list event-detail-page__events__list__your-events\"><div ng-repeat=\"item in vm.yourEvents\" class=event-detail-page__events__list__info__wrapper><div class=event-detail-page__events__list__info__avatar ng-style=\"{\'background-image\': \'url(\\\'\' + item.cover.thumbnail + \'\\\')\'}\"></div><div class=event-detail-page__events__list__info__details><a ui-sref=\"event-detail-page.event-feed({id: item.id})\" class=\"event-detail-page__events__list__info__name text--truncate\" ng-class=\"{\'actived\': vm.event.id === item.id}\">{{item.name}}</a><div class=event-detail-page__events__list__info__sub-info><span class=event-detail-page__events__list__info__sub-info__value>{{item.event_datetimes[0].start_datetime | formatDate: \'MMM DD, YYYY\'}}</span></div></div></div></div></div><div ng-if=\"vm.loginedUser.canManageCommunity && !vm.yourEvents.length\" class=event-detail-page__events__empty-section-sidebar><div class=event-detail-page__events__empty-section-sidebar__info>You are not taking part in any events at the moment.</div><div><a ui-sref=for-creator-page.about-community class=\"text--bold text--color-pixerf-theme\" target=_blank>Explore</a> more events that align with your interest.</div></div><div ng-if=\"!vm.loginedUser.isBiz && (!vm.loginedUser.canManageCommunity || vm.yourEvents.length || vm.joinedEvents.length)\" class=event-detail-page__events__section-wrapper><div class=event-detail-page__events__title>{{vm.isTypeClass ? \'Classes\' : \'Events\'}} Joined</div><div ng-if=vm.joinedEvents.length class=\"event-detail-page__events__list event-detail-page__events__list__joined-events\"><div ng-repeat=\"item in vm.joinedEvents\" class=event-detail-page__events__list__info__wrapper><div class=event-detail-page__events__list__info__avatar ng-style=\"{\'background-image\': \'url(\\\'\' + item.cover.thumbnail + \'\\\')\'}\"></div><div class=event-detail-page__events__list__info__details><a ui-sref=\"event-detail-page.event-feed({id: item.id})\" class=\"event-detail-page__events__list__info__name text--truncate\" ng-class=\"{\'actived\': vm.event.id === item.id}\">{{item.name}}</a><div class=event-detail-page__events__list__info__sub-info><span class=event-detail-page__events__list__info__sub-info__value>{{item.event_datetimes[0].start_datetime | formatDate: \'MMM DD, YYYY\'}}</span> <span class=event-detail-page__events__list__info__sub-info__text>{{item.owner.displayName}}</span></div></div></div></div><div ng-if=!vm.joinedEvents.length class=event-detail-page__events__empty-section-sidebar><div class=event-detail-page__events__empty-section-sidebar__info>You are not taking part in any events at the moment.</div><div><a ui-sref=for-creator-page.about-community class=\"text--bold text--color-pixerf-theme\" target=_blank>Explore</a> more events that align with your interest.</div></div></div><div ng-if=\"vm.loginedUser && vm.loginedUser.canManageCommunity\" class=\"event-detail-page__events__create-button btn btn--transparent\" ng-click=vm.onCreateEvent()><div class=\"event-detail-page__events__create-button__icon icon-icons_plus\"></div><div class=event-detail-page__events__create-button__text>{{vm.isTypeClass ? \'create-new-class\' : \'create-new-event\' | translate}}</div></div></div></div><div class=event-detail-page__col-right><section class=event-detail-page__header><div class=mobile><div class=event-detail-page__header__background-mobile ng-style=\"{\'background-image\': \'url(\\\'\' + vm.event.cover.original + \'\\\')\'}\"><div class=event-detail-page__header__info__detail><div class=\"event-detail-page__header__info__detail__icon {{vm.badgeEvent}}\"></div><div class=event-detail-page__header__info__detail__text><div class=event-detail-page__header__info__detail__type>{{ (vm.event.is_unlisted == true) ? \'Unlisted\' : (vm.event.is_private ? \'Private\' : \'Public\')}} {{vm.itemType}}</div><div class=event-detail-page__header__info__detail__author>by <span class=event-detail-page__header__info__detail__author__name ui-sref=\"community-detail-page.community-detail-events({id: vm.event.community_id, name: vm.event.community_name})\">{{vm.event.community_name}}</span></div></div></div></div><div class=event-detail-page__header__bottom-border></div><div class=event-detail-page__header__info><div ng-if=\"[\'deleted\', \'rejected\', \'cancelled\'].includes(vm.event.status)\" class=event-detail-page__header__info__banner-status><span class=\"event-detail-page__header__info__banner-status__icon icon-remove-circle-outline\"></span> <span class=event-detail-page__header__info__banner-status__label>{{vm.itemType}} {{vm.event.status}}</span></div><div class=event-detail-page__header__info__left><div class=event-detail-page__header__info__date-time><div class=event-detail-page__header__info__calendar><div class=event-detail-page__header__info__calendar__month>{{vm.eventDate.month}}</div><div class=event-detail-page__header__info__calendar__day>{{vm.eventDate.day}}</div></div><div class=event-detail-page__header__info__calendar__time-group><div class=event-detail-page__header__info__calendar__full-day ng-repeat=\"time in vm.headerSchedules\"><span>{{time.date}},</span> <span>{{time.start}} to {{time.end}}</span></div></div></div><div class=event-detail-page__header__info__name>{{vm.event.name}}</div><!-- <div class=\"event-detail-page__header__info__detail\">\r\n							<div class=\"event-detail-page__header__info__detail__icon {{vm.badgeEvent}}\"></div>\r\n							<div class=\"event-detail-page__header__info__detail__text\">\r\n								<div class=\"event-detail-page__header__info__detail__type\">\r\n									{{ (vm.event.is_unlisted == true) ? \'Unlisted\' : (vm.event.is_private ? \'Private\' : \'Public\')}}\r\n									{{vm.itemType}}</div>\r\n								<div class=\"event-detail-page__header__info__detail__author\">by\r\n									<span class=\"event-detail-page__header__info__detail__author__name\"\r\n										ui-sref=\"community-detail-page.community-detail-events({id: vm.event.community_id, name: vm.event.community_name})\">{{vm.event.community_name}}</span>\r\n								</div>\r\n							</div>\r\n						</div> --></div><div ng-if=!vm.noBookingYet class=event-detail-page__header__manage-button__wrapper><div ng-if=\"!vm.isEventClosed && !vm.isMine && vm.loginedUser.account_type === \'personal\' && !vm.event.has_joined && !vm.event.has_interest\" class=\"event-detail-page__header__manage-button btn btn-submit\" ng-click=vm.onInterested()><span class=\"event-detail-page__header__manage-button__icon icon-star2\"></span> <span>Interested</span></div><div ng-if=\"!vm.isEventClosed && !vm.isMine && vm.loginedUser.account_type === \'personal\' && !vm.event.has_joined && !vm.event.has_interest\" class=\"event-detail-page__header__manage-button btn btn-submit\" ng-click=vm.onGoing()><span class=\"event-detail-page__header__manage-button__icon icon-icons_check\"></span> <span>Going</span></div><div ng-if=\"!vm.isEventClosed && !vm.loginedUser && vm.event && vm.event.id && vm.event.admission_type == \'ticketed_pixerf\'\" class=\"event-detail-page__header__manage-button__btn-list btn btn-submit\" ng-click=vm.onUnloginClicked()><span>Going</span></div><div ng-if=vm.isMine class=\"event-detail-page__header__manage-button btn btn-submit\" ng-click=vm.onManageAttendeesClicked()><span>Manage Attendees</span></div><div ng-if=\"vm.isEventClosed && !vm.isMine\" class=\"event-detail-page__header__manage-button closed-event-label\"><span>Class is closed</span></div><div ng-if=\"!vm.isEventClosed && !vm.isMine && vm.loginedUser.account_type === \'personal\' && (vm.event.has_joined || vm.event.has_interest)\" class=\"event-detail-page__header__manage-button btn btn-submit event-detail-page__header__manage-button__btn-list\"><div class=event-detail-page__header__manage-button__main-btn ng-class=\"{\'disabled-icon\': vm.event.admission_type == \'ticketed_pixerf\' || !vm.event.has_joined}\"><span class=event-detail-page__header__manage-button__icon ng-class=\"{\'icon-icons_check\': vm.event.has_joined, \'icon-star2\': vm.event.has_interest}\"></span> <span>{{vm.event.has_joined ? \'Going\' : \'Interested\'}}</span></div><div ng-if=\"vm.event.admission_type != \'ticketed_pixerf\' || !vm.event.has_joined\" class=\"event-detail-page__header__manage-button__btn-list__icon icon-icons_chevron-down\"></div><div ng-if=\"vm.event.admission_type != \'ticketed_pixerf\' || !vm.event.has_joined\" uib-dropdown class=event-detail-page__header__manage-button__btn-list__btn-wrapper><span uib-dropdown-toggle class=event-detail-page__header__manage-button__btn-list__list-wrapper ng-click=vm.prevenPubbleClick()></span><ul class=event-detail-page__header__manage-button__btn-list__list uib-dropdown-menu role=menu><li role=menuitem class=event-detail-page__header__manage-button__btn-list__item ng-class=\"{\'actived\': vm.membershipEvent.isGoing}\" ng-click=vm.onGoing()><stick-checkbox class=custom-commissions-square-tile__photo__select-button model=vm.membershipEvent model-property=isGoing on-changed=\"vm.onMembershipEventChanged(data, event)\"></stick-checkbox><span class=\"event-detail-page__header__manage-button__btn-list__btn-icon icon-icons_check\"></span> <span class=event-detail-page__header__manage-button__btn-list__item__value>Going</span></li><li role=menuitem class=event-detail-page__header__manage-button__btn-list__item ng-class=\"{\'actived\': vm.membershipEvent.isInterested}\" ng-click=vm.onInterested()><stick-checkbox class=custom-commissions-square-tile__photo__select-button model=vm.membershipEvent model-property=isInterested on-changed=\"vm.onMembershipEventChanged(data, event)\"></stick-checkbox><span class=\"event-detail-page__header__manage-button__btn-list__btn-icon icon-star2\"></span> <span class=event-detail-page__header__manage-button__btn-list__item__value>Interested</span></li></ul></div></div></div></div></div><div class=\"event-detail-page__header__background desktop\" ng-style=\"{\'background-image\': \'url(\\\'\' + vm.event.cover.original + \'\\\')\'}\"><div class=event-detail-page__header__background-mobile ng-style=\"{\'background-image\': \'url(\\\'\' + vm.event.cover.original + \'\\\')\'}\"></div><div class=event-detail-page__header__info><div ng-if=\"[\'deleted\', \'rejected\', \'cancelled\'].includes(vm.event.status)\" class=event-detail-page__header__info__banner-status><span class=\"event-detail-page__header__info__banner-status__icon icon-remove-circle-outline\"></span> <span class=event-detail-page__header__info__banner-status__label>{{vm.itemType}} {{vm.event.status}}</span></div><div class=event-detail-page__header__info__left><div class=event-detail-page__header__info__calendar><div class=event-detail-page__header__info__calendar__month>{{vm.eventDate.month}}</div><div class=event-detail-page__header__info__calendar__day>{{vm.eventDate.day}}</div></div><div class=event-detail-page__header__info__calendar__full-day ng-repeat=\"time in vm.headerSchedules\"><span>{{time.date}},</span> <span>{{time.start}}</span> <span>to</span> <span>{{time.end}}</span></div><div class=event-detail-page__header__info__name>{{vm.event.name}}</div><div class=event-detail-page__header__info__detail><div class=\"event-detail-page__header__info__detail__icon {{vm.badgeEvent}}\"></div><div class=event-detail-page__header__info__detail__text><div class=event-detail-page__header__info__detail__type>{{ (vm.event.is_unlisted == true) ? \'Unlisted\' : (vm.event.is_private ? \'Private\' : \'Public\')}} {{vm.itemType}}</div><div class=event-detail-page__header__info__detail__author>by <span class=event-detail-page__header__info__detail__author__name ui-sref=\"community-detail-page.community-detail-events({id: vm.event.community_id, name: vm.event.community_name})\">{{vm.event.community_name}}</span></div></div></div></div><div ng-if=!vm.noBookingYet class=event-detail-page__header__manage-button__wrapper><div ng-if=\"!vm.isEventClosed && !vm.isMine && vm.loginedUser.account_type === \'personal\' && !vm.event.has_joined && !vm.event.has_interest\" class=\"event-detail-page__header__manage-button btn btn-submit\" ng-click=vm.onInterested()><span class=\"event-detail-page__header__manage-button__icon icon-star2\"></span> <span>Interested</span></div><div ng-if=\"!vm.isEventClosed && !vm.isMine && vm.loginedUser.account_type === \'personal\' && !vm.event.has_joined && !vm.event.has_interest\" class=\"event-detail-page__header__manage-button btn btn-submit\" ng-click=vm.onGoing()><span class=\"event-detail-page__header__manage-button__icon icon-icons_check\"></span> <span>Going</span></div><div ng-if=\"!vm.isEventClosed && !vm.loginedUser && vm.event && vm.event.id && vm.event.admission_type == \'ticketed_pixerf\'\" class=\"event-detail-page__header__manage-button btn btn-submit\" ng-click=vm.onUnloginClicked()><span>Going</span></div><div ng-if=vm.isMine class=\"event-detail-page__header__manage-button btn btn-submit\" ng-click=vm.onManageAttendeesClicked()><span>Manage Attendees</span></div><div ng-if=\"vm.isEventClosed && !vm.isMine\" class=\"event-detail-page__header__manage-button closed-event-label\"><span>Class is closed</span></div><div ng-if=\"!vm.isEventClosed && !vm.isMine && vm.loginedUser.account_type === \'personal\' && (vm.event.has_joined || vm.event.has_interest)\" class=\"event-detail-page__header__manage-button btn btn-submit event-detail-page__header__manage-button__btn-list\"><div class=event-detail-page__header__manage-button__main-btn ng-class=\"{\'disabled-icon\': vm.event.admission_type == \'ticketed_pixerf\' || !vm.event.has_joined}\"><span class=event-detail-page__header__manage-button__icon ng-class=\"{\'icon-icons_check\': vm.event.has_joined, \'icon-star2\': vm.event.has_interest}\"></span> <span>{{vm.event.has_joined ? \'Going\' : \'Interested\'}}</span></div><div ng-if=\"vm.event.admission_type != \'ticketed_pixerf\' || !vm.event.has_joined\" class=\"event-detail-page__header__manage-button__btn-list__icon icon-icons_chevron-down\"></div><div ng-if=\"vm.event.admission_type != \'ticketed_pixerf\' || !vm.event.has_joined\" uib-dropdown class=event-detail-page__header__manage-button__btn-list__btn-wrapper><span uib-dropdown-toggle class=event-detail-page__header__manage-button__btn-list__list-wrapper ng-click=vm.prevenPubbleClick()></span><ul class=event-detail-page__header__manage-button__btn-list__list uib-dropdown-menu role=menu><li role=menuitem class=event-detail-page__header__manage-button__btn-list__item ng-class=\"{\'actived\': vm.membershipEvent.isGoing}\" ng-click=vm.onGoing()><stick-checkbox class=custom-commissions-square-tile__photo__select-button model=vm.membershipEvent model-property=isGoing on-changed=\"vm.onMembershipEventChanged(data, event)\"></stick-checkbox><span class=\"event-detail-page__header__manage-button__btn-list__btn-icon icon-icons_check\"></span> <span class=event-detail-page__header__manage-button__btn-list__item__value>Going</span></li><li role=menuitem class=event-detail-page__header__manage-button__btn-list__item ng-class=\"{\'actived\': vm.membershipEvent.isInterested}\" ng-click=vm.onInterested()><stick-checkbox class=custom-commissions-square-tile__photo__select-button model=vm.membershipEvent model-property=isInterested on-changed=\"vm.onMembershipEventChanged(data, event)\"></stick-checkbox><span class=\"event-detail-page__header__manage-button__btn-list__btn-icon icon-star2\"></span> <span class=event-detail-page__header__manage-button__btn-list__item__value>Interested</span></li></ul></div></div></div></div></div><div class=\"event-detail-page__header__bottom-border desktop\"></div></section><section class=event-detail-page__content><div class=event-detail-page__content__col-left><ul class=event-detail-page__content__nav-content-list uib-dropdown-menu role=menu aria-labelledby=single-button><li class=event-detail-page__content__nav-content-item ui-sref-active-class=actived ui-sref-active-if=event-detail-page.event-feed><a ui-sref={{vm.commonConst.STATE.EVENT_FEED}}>{{vm.itemType}} Discussions</a></li><li class=event-detail-page__content__nav-content-item ui-sref-active-class=actived ui-sref-active-if=event-detail-page.event-photos><a ui-sref={{vm.commonConst.STATE.EVENT_PHOTOS}}>{{vm.itemType}} Photos</a></li><li ng-if=vm.loginedUser class=event-detail-page__content__btn-report><div uib-dropdown class=event-detail-page__content__btn-report__menu><span uib-dropdown-toggle class=icon-icons_more></span><ul class=event-detail-page__content__btn-report__list uib-dropdown-menu role=menu><li ng-if=vm.isMine role=menuitem class=event-detail-page__content__btn-report__item ng-click=vm.onManageEventClicked()>Manage {{vm.itemType}}</li><li ng-if=vm.isMine role=menuitem class=event-detail-page__content__btn-report__item ng-click=vm.onCancelEventClicked()>Cancel {{vm.itemType}}</li><li ng-if=vm.isMine role=menuitem class=event-detail-page__content__btn-report__item ng-click=vm.onDeleteEventClicked()>Delete {{vm.itemType}}</li><li ng-if=!vm.isMine role=menuitem class=event-detail-page__content__btn-report__item ng-click=vm.onReportEvent() translate translate-values=\"{thing: (\'event\' | translate)}\">{{\'report-thing\'}}</li></ul></div></li></ul><div class=\"event-detail-page__content-section__cover mobile\"><hr class=event-detail-page__content-section__line-break></div><div class=mobile><div class=\"event-detail-page__content__col-right__section about-section\"><div class=event-detail-page__content__col-right__section__header><div class=event-detail-page__content__col-right__section__title translate>{{vm.isTypeClass ? \'class-details\' : \'event-details\'}}</div><div ng-if=vm.isMine class=event-detail-page__content__col-right__section__control ng-click=vm.onManageEventClicked()>{{\'edit\' | translate}}</div></div><div class=\"event-detail-page__content__col-right__section__sub-section price-section\"><div class=event-detail-page__content__col-right__section__sub-section__title><div>Price</div><div ng-if=\"!vm.isEventClosed && !vm.noBookingYet && !vm.isMine && vm.loginedUser && vm.loginedUser.account_type === \'personal\' && !vm.event.has_joined && vm.event.admission_type == \'ticketed_pixerf\'\" class=\"event-detail-page__content__col-right__section__sub-section__title signup-button\" ng-click=vm.onGoingEvent()>Purchase now!</div><div ng-if=\"!vm.isEventClosed && !vm.noBookingYet && !vm.isMine && vm.loginedUser && vm.loginedUser.account_type === \'personal\' && !vm.event.has_joined && vm.event.admission_type != \'ticketed_pixerf\'\" class=\"event-detail-page__content__col-right__section__sub-section__title signup-button\" ng-click=vm.onGoingEvent()>Sign up now!</div><div ng-if=\"!vm.noBookingYet && !vm.isMine && vm.event.has_joined\" class=\"event-detail-page__content__col-right__section__sub-section__title signup-button\"><span class=\"event-detail-page__header__manage-button__icon icon-icons_check\"></span> <span>Going!</span></div><div ng-if=\"!vm.isEventClosed && !vm.noBookingYet && !vm.loginedUser && vm.event.admission_type == \'ticketed_pixerf\'\" class=\"event-detail-page__content__col-right__section__sub-section__title signup-button\" ng-click=vm.onUnloginClicked()>Purchase now!</div></div><div class=\"event-detail-page__content__col-right__section__sub-section__body ticket-price\"><div ng-if=vm.event.ticket_price><span>SGD</span><span class=ticket-price-value>{{vm.event.ticket_price}}</span></div><div ng-if=!vm.event.ticket_price class=ticket-price-free>Free Admission</div></div></div><div class=\"event-detail-page__content__col-right__section member-section no-border\"><div class=event-detail-page__content__col-right__section__header><div class=event-detail-page__content__col-right__section__title><span>Attendees</span> <span ng-if=vm.isLimitedCapacity class=member-section__spots-left ng-class=\"{\'sold-out\': !vm.event.stats.available, \'few-spots-left\': vm.isFewSpotsLeft}\">{{vm.ticketAvailabeLable}}</span><!-- <a ui-sref=\"view-event.members({id: vm.event.id, name: vm.event.name,status: \'members\'})\"\r\n										class=\"member-section__view-event\">\r\n										<div ng-if=\"vm.isMember && !vm.isMine\" class=\"member-section__view-event__member\">\r\n											{{\'view\' | translate}}\r\n										</div>\r\n									</a> --></div><a ui-sref=\"manage-event.members({id: vm.event.id,name: vm.event.name, status: \'attendees\'})\"><div ng-if=vm.isMine class=event-detail-page__content__col-right__section__control>{{\'manage\' | translate}}</div></a></div><div class=member-section__stats-info><div class=member-section__stats-info__col ng-click=vm.onGoingList()><div class=member-section__stats-info__col__value>{{vm.event.stats.going}}</div><div class=member-section__stats-info__col__label>going</div></div><div class=member-section__stats-info__col ng-click=vm.onInterestedList()><div class=member-section__stats-info__col__value>{{vm.event.stats.interested}}</div><div class=member-section__stats-info__col__label>interested</div></div><div class=member-section__stats-info__col ng-click=vm.onInvitedList()><div class=member-section__stats-info__col__value>{{vm.event.stats.invited}}</div><div class=member-section__stats-info__col__label>invited</div></div><div class=member-section__stats-info__col><div class=member-section__stats-info__col__value>{{vm.event.stats.not_going || 0}}</div><div class=member-section__stats-info__col__label>not going</div></div></div><div ng-if=vm.loginedUser class=event-detail-page__content__col-right__section__member-list><div ng-repeat=\"member in vm.interactUsers | limitTo: 4\" class=event-detail-page__content__col-right__section__member><a uib-tooltip={{member.displayName}} ui-sref=\"user-home-page.personal.home({id: member.id})\" target=_blank><pixerf-user-avatar user-data=member lazy=true></pixerf-user-avatar></a></div><div ng-if=\"vm.interactUsers.length > 4\" class=event-detail-page__content__col-right__section__info-member>{{vm.interactUsers.length - 4}}+</div></div><div class=member-section__intro ng-bind-html=vm.introInvitedText></div><div ng-if=vm.isMine class=event-detail-page__content__col-right__section__title>Share this {{vm.itemType | lowercase}}</div><div ng-if=vm.isMine class=event-detail-page__content__col-right__section__social-list><div class=\"event-detail-page__content__col-right__section__social-item whatsapp-icon-grey-color\"><div id=whatsappComShare></div></div><div class=\"event-detail-page__content__col-right__section__social-item email-icon-grey-color\" ng-click=vm.onSendInviteEmail()></div><div class=\"event-detail-page__content__col-right__section__social-item link-icon-grey-color\" ng-click=vm.onSendInviteLink()></div><share ng-click=$event.stopPropagation() settings=vm.shareSettings content-will-be-shared=vm.SocialShareContent ng-if=vm.SocialShareContent class=\"event-detail-page__content__col-right__section__share-social share-social\" title=\"Share this community\"></share></div><button ng-if=vm.isMine class=\"event-detail-page__content__col-right__section__invite-members-btn btn btn-submit--transparent\" ng-click=vm.onInviteMembers()>{{\'invite-friends\' | translate}}</button></div><div class=event-detail-page__content__col-right__section__sub-section><div class=event-detail-page__content__col-right__section__sub-section__title translate>{{vm.isTypeClass ? \'about-this-class\' : \'about-this-event\'}}</div><div ng-if=\"!vm.isEditCommunityDescription && !vm.isProcessinDescription\" class=about-section__description__wrapper><div class=about-section__description><div ng-repeat=\"des in vm.description\" class=about-section__description__item ng-class=\"{\'is-line-item\': des.isLineItem}\">{{des.text}}</div></div><div class=\"about-section__toggle-more text--bold text--color-pixerf-theme\" ng-click=vm.onToggleFullDescription(vm.isFullDescription)>See {{vm.isFullDescription ? \'less\' : \'more\'}}</div></div><textarea ng-if=vm.isEditCommunityDescription placeholder=\"{{\'about-this-community-placeholder\' | translate}}\" class=event-detail-page__content__col-right__section__textarea-description ng-model=vm.eventDescription></textarea><div ng-if=vm.isEditCommunityDescription class=event-detail-page__content__col-right__section__textarea-description__control><div class=event-detail-page__content__col-right__section__textarea-description__control__ok ng-click=vm.onEditDescriontionSave()>{{\'save\' | translate}}</div><div class=event-detail-page__content__col-right__section__textarea-description__control__cancel ng-click=vm.onEditDescriontionCancel()>{{\'cancel\' | translate}}</div></div></div><div class=event-detail-page__content__col-right__section__sub-section><div class=event-detail-page__content__col-right__section__sub-section__title>Date and Time</div><div class=event-detail-page__content__col-right__section__sub-section__body><div ng-repeat=\"time in vm.schedules\"><div>{{time.date}}</div><div><span>{{time.start}}</span> <span>to</span> <span>{{time.end}}</span></div></div></div></div><div class=event-detail-page__content__col-right__section__sub-section><div class=event-detail-page__content__col-right__section__sub-section__title>Location <span ng-if=vm.event.is_online>: <span class=online-event-text>Online</span></span></div><div ng-if=!vm.event.is_online class=\"event-detail-page__content__col-right__section__sub-section__body location\">{{vm.event.is_online ? vm.event.broadcast_url : vm.event.location}}</div><div ng-if=vm.event.is_online class=\"event-detail-page__content__col-right__section__sub-section__body location\">Broadcast link will be sent to registered email</div></div><div class=event-detail-page__content__col-right__section__sub-section><div class=event-detail-page__content__col-right__section__sub-section__title>Admission</div><div class=\"event-detail-page__content__col-right__section__sub-section__body admission\">{{vm.admissionType}}<div ng-if=\"!vm.isEventClosed && !vm.noBookingYet && !vm.isMine && vm.loginedUser && vm.loginedUser.account_type === \'personal\' && !vm.event.has_joined && vm.event.admission_type == \'ticketed_pixerf\'\" class=\"event-detail-page__content__col-right__section__sub-section__title signup-button\" ng-click=vm.onGoingEvent()>Purchase now!</div><div ng-if=\"!vm.isEventClosed && !vm.noBookingYet && !vm.isMine && vm.loginedUser && vm.loginedUser.account_type === \'personal\' && !vm.event.has_joined && vm.event.admission_type != \'ticketed_pixerf\'\" class=\"event-detail-page__content__col-right__section__sub-section__title signup-button\" ng-click=vm.onGoingEvent()>Sign up now!</div><div ng-if=\"!vm.isEventClosed && !vm.noBookingYet && !vm.loginedUser && vm.event.admission_type == \'ticketed_pixerf\'\" class=\"event-detail-page__content__col-right__section__sub-section__title signup-button\" ng-click=vm.onUnloginClicked()>Purchase now!</div></div></div><div ng-if=vm.event.ticket_url class=event-detail-page__content__col-right__section__sub-section><div class=event-detail-page__content__col-right__section__sub-section__title>Ticketing</div><div class=\"event-detail-page__content__col-right__section__sub-section__body ticketing\"><div>Ticketed event. Obtain tickets at:</div><div>{{vm.event.ticket_url}}</div></div></div><div class=\"event-detail-page__content__col-right__section__sub-section region-or-country\"><div class=event-detail-page__content__col-right__section__sub-section__title><span>Region or Countries </span><span ng-if=vm.isMine class=event-detail-page__content__col-right__section__control ui-sref=\"manage-community.edit-community({id: vm.event.community_id, status: \'admin\'})\">{{\'edit\' | translate}}</span></div><!-- <div ng-if=\"vm.isMine\" class=\"event-detail-page__content__col-right__section__control\"\r\n								ui-sref=\"manage-community.edit-community({id: vm.event.community_id, status: \'admin\'})\">\r\n								{{\'edit\' | translate}}</div> --><div class=event-detail-page__content__col-right__section__sub-section__body>{{vm.eventCountries}}</div></div></div></div><div class=\"event-detail-page__main-content__cover mobile\"><hr class=event-detail-page__main-content__line-break></div><section ui-view class=event-detail-page__main-content></section></div><div class=\"event-detail-page__content__col-right desktop\"><!-- <div class=\"event-detail-page__content__col-right__section notification-section\">\r\n					<div class=\"event-detail-page__content__col-right__section__header\">\r\n						<div class=\"event-detail-page__content__col-right__section__title\">Notifications</div>\r\n					</div>\r\n				</div> --><div class=\"event-detail-page__content__col-right__section about-section\"><div class=event-detail-page__content__col-right__section__header><div class=event-detail-page__content__col-right__section__title translate>{{vm.isTypeClass ? \'about-this-class\' : \'about-this-event\'}}</div><div ng-if=vm.isMine class=event-detail-page__content__col-right__section__control ng-click=vm.onManageEventClicked()>{{\'edit\' | translate}}</div></div><div ng-if=\"!vm.isEditCommunityDescription && !vm.isProcessinDescription\" class=about-section__description__wrapper><div class=about-section__description><div ng-repeat=\"des in vm.description\" class=about-section__description__item ng-class=\"{\'is-line-item\': des.isLineItem}\">{{des.text}}</div></div><div class=\"about-section__toggle-more text--bold text--color-pixerf-theme\" ng-click=vm.onToggleFullDescription(vm.isFullDescription)>See {{vm.isFullDescription ? \'less\' : \'more\'}}</div></div><textarea ng-if=vm.isEditCommunityDescription placeholder=\"{{\'about-this-community-placeholder\' | translate}}\" class=event-detail-page__content__col-right__section__textarea-description ng-model=vm.eventDescription></textarea><div ng-if=vm.isEditCommunityDescription class=event-detail-page__content__col-right__section__textarea-description__control><div class=event-detail-page__content__col-right__section__textarea-description__control__ok ng-click=vm.onEditDescriontionSave()>{{\'save\' | translate}}</div><div class=event-detail-page__content__col-right__section__textarea-description__control__cancel ng-click=vm.onEditDescriontionCancel()>{{\'cancel\' | translate}}</div></div><div class=event-detail-page__content__col-right__section__sub-section><div class=event-detail-page__content__col-right__section__sub-section__title><div>Price</div><div ng-if=\"!vm.isEventClosed && !vm.noBookingYet && !vm.isMine && vm.loginedUser && vm.loginedUser.account_type === \'personal\' && !vm.event.has_joined && vm.event.admission_type == \'ticketed_pixerf\'\" class=\"event-detail-page__content__col-right__section__sub-section__title signup-button\" ng-click=vm.onGoingEvent()>Purchase now!</div><div ng-if=\"!vm.isEventClosed && !vm.noBookingYet && !vm.isMine && vm.loginedUser && vm.loginedUser.account_type === \'personal\' && !vm.event.has_joined && vm.event.admission_type != \'ticketed_pixerf\'\" class=\"event-detail-page__content__col-right__section__sub-section__title signup-button\" ng-click=vm.onGoingEvent()>Sign up now!</div><div ng-if=\"!vm.noBookingYet && !vm.isMine && vm.event.has_joined\" class=\"event-detail-page__content__col-right__section__sub-section__title signup-button\"><span class=\"event-detail-page__header__manage-button__icon icon-icons_check\"></span> <span>Going!</span></div><div ng-if=\"!vm.isEventClosed && !vm.noBookingYet && !vm.loginedUser && vm.event.admission_type == \'ticketed_pixerf\'\" class=\"event-detail-page__content__col-right__section__sub-section__title signup-button\" ng-click=vm.onUnloginClicked()>Purchase now!</div></div><div class=\"event-detail-page__content__col-right__section__sub-section__body ticket-price\"><div ng-if=vm.event.ticket_price><span>SGD</span><span class=ticket-price-value>{{vm.event.ticket_price}}</span></div><div ng-if=!vm.event.ticket_price class=ticket-price-free>Free Admission</div></div></div><div class=event-detail-page__content__col-right__section__sub-section><div class=event-detail-page__content__col-right__section__sub-section__title>Date and Time</div><div class=event-detail-page__content__col-right__section__sub-section__body><div ng-repeat=\"time in vm.schedules\"><div>{{time.date}}</div><div><span>{{time.start}}</span> <span>to</span> <span>{{time.end}}</span></div></div></div></div><div class=event-detail-page__content__col-right__section__sub-section><div class=event-detail-page__content__col-right__section__sub-section__title>Location <span ng-if=vm.event.is_online>: <span class=online-event-text>Online</span></span></div><div ng-if=!vm.event.is_online class=\"event-detail-page__content__col-right__section__sub-section__body location\">{{vm.event.is_online ? vm.event.broadcast_url : vm.event.location}}</div><div ng-if=vm.event.is_online class=\"event-detail-page__content__col-right__section__sub-section__body location\">Broadcast link will be sent to registered email</div></div><div class=\"event-detail-page__content__col-right__section__sub-section admission\"><div class=admission__wrapper><div class=event-detail-page__content__col-right__section__sub-section__title>Admission</div><div class=\"event-detail-page__content__col-right__section__sub-section__body admission\">{{vm.admissionType}}</div></div><div ng-if=\"!vm.isEventClosed && !vm.noBookingYet && !vm.isMine && vm.loginedUser && vm.loginedUser.account_type === \'personal\' && !vm.event.has_joined && vm.event.admission_type == \'ticketed_pixerf\'\" class=admission__signup-button ng-click=vm.onGoingEvent()>Purchase now!</div><div ng-if=\"!vm.isEventClosed && !vm.noBookingYet && !vm.loginedUser && vm.event.admission_type == \'ticketed_pixerf\'\" class=admission__signup-button ng-click=vm.onUnloginClicked()>Purchase now!</div></div><div ng-if=vm.event.ticket_url class=event-detail-page__content__col-right__section__sub-section><div class=event-detail-page__content__col-right__section__sub-section__title>Ticketing</div><div class=\"event-detail-page__content__col-right__section__sub-section__body ticketing\"><div>Ticketed event. Obtain tickets at:</div><div>{{vm.event.ticket_url}}</div></div></div></div><div class=\"event-detail-page__content__col-right__section region-country-section\"><div class=event-detail-page__content__col-right__section__header><div class=event-detail-page__content__col-right__section__title>Region or Countries</div><div ng-if=vm.isMine class=event-detail-page__content__col-right__section__control ui-sref=\"manage-community.edit-community({id: vm.event.community_id, status: \'admin\'})\">{{\'edit\' | translate}}</div></div><div class=event-detail-page__content__col-right__section__body>{{vm.eventCountries}}</div></div><div class=\"event-detail-page__content__col-right__section member-section\"><div class=event-detail-page__content__col-right__section__header><div class=event-detail-page__content__col-right__section__title><span>Attendees</span> <span ng-if=vm.isLimitedCapacity class=member-section__spots-left ng-class=\"{\'sold-out\': !vm.event.stats.available, \'few-spots-left\': vm.isFewSpotsLeft}\">{{vm.ticketAvailabeLable}}</span><!-- <a ui-sref=\"view-event.members({id: vm.event.id, name: vm.event.name,status: \'members\'})\"\r\n								class=\"member-section__view-event\">\r\n								<div ng-if=\"vm.isMember && !vm.isMine\" class=\"member-section__view-event__member\">\r\n									{{\'view\' | translate}}\r\n								</div>\r\n							</a> --></div><a ui-sref=\"manage-event.members({id: vm.event.id,name: vm.event.name, status: \'attendees\'})\"><div ng-if=vm.isMine class=event-detail-page__content__col-right__section__control>{{\'manage\' | translate}}</div></a></div><div class=member-section__stats-info><div class=member-section__stats-info__col ng-click=vm.onGoingList()><div class=member-section__stats-info__col__value>{{vm.event.stats.going}}</div><div class=member-section__stats-info__col__label>going</div></div><div class=member-section__stats-info__col ng-click=vm.onInterestedList()><div class=member-section__stats-info__col__value>{{vm.event.stats.interested}}</div><div class=member-section__stats-info__col__label>interested</div></div><div class=member-section__stats-info__col ng-click=vm.onInvitedList()><div class=member-section__stats-info__col__value>{{vm.event.stats.invited}}</div><div class=member-section__stats-info__col__label>invited</div></div><div class=member-section__stats-info__col><div class=member-section__stats-info__col__value>{{vm.event.stats.not_going || 0}}</div><div class=member-section__stats-info__col__label>not going</div></div></div><div ng-if=vm.loginedUser class=event-detail-page__content__col-right__section__member-list><div ng-repeat=\"member in vm.interactUsers | limitTo: 4\" class=event-detail-page__content__col-right__section__member><a uib-tooltip={{member.displayName}} ui-sref=\"user-home-page.personal.home({id: member.id})\" target=_blank><pixerf-user-avatar user-data=member lazy=true></pixerf-user-avatar></a></div><div ng-if=\"vm.interactUsers.length > 4\" class=event-detail-page__content__col-right__section__info-member>{{vm.interactUsers.length - 4}}+</div></div><div class=member-section__intro ng-bind-html=vm.introInvitedText></div><div ng-if=vm.isMine class=event-detail-page__content__col-right__section__title>Share this {{vm.itemType | lowercase}}</div><div ng-if=vm.isMine class=event-detail-page__content__col-right__section__social-list><div class=\"event-detail-page__content__col-right__section__social-item whatsapp-icon-grey-color\"><div id=whatsappComShare></div></div><div class=\"event-detail-page__content__col-right__section__social-item email-icon-grey-color\" ng-click=vm.onSendInviteEmail()></div><div class=\"event-detail-page__content__col-right__section__social-item link-icon-grey-color\" ng-click=vm.onSendInviteLink()></div><share ng-click=$event.stopPropagation() settings=vm.shareSettings content-will-be-shared=vm.SocialShareContent ng-if=vm.SocialShareContent class=\"event-detail-page__content__col-right__section__share-social share-social\" title=\"Share this community\"></share></div><button ng-if=vm.isMine class=\"event-detail-page__content__col-right__section__invite-members-btn btn btn-submit--transparent\" ng-click=vm.onInviteMembers()>{{\'invite-friends\' | translate}}</button></div></div></section></div></div>");
$templateCache.put("app/explore-community-page/explore-community-page.html","<div class=\"explore-community-page main__content--md\" ng-class=\"{\'margin-top--1\': isScreenMobile}\"><section class=explore-community-page__search-header dynamic-show-hide-scroll scroll-down-class=hide-on-mobile><div class=explore-community-page__search-input><button ng-click=vm.onSearchBtnClicked() type=button class=explore-community-page__search-input__icon><i class=icon-icons_search></i></button><tags-input placeholder=\"Search communities and events\" add-on-blur=true min-length=1 ng-model=vm.tags.data on-tag-added=vm.tagAdded($tag) on-tag-removed=vm.tagRemoved($tag) replace-spaces-with-dashes=false></tags-input><div class=explore-community-page__search-type><popover-selection-btn dynamic-placeholder=vm.selectedFilterItem.placeholder placeholder-selector=\".header-search-bar input\" close-on-click=true on-selection-changed=vm.onFilteredClicked(item) selected-model=vm.selectedFilterItem settings=vm.searchContext></popover-selection-btn></div></div><div class=explore-community-page__search-header__context><div class=explore-community-page__search-header__text-wrapper><button type=button class=\"explore-community-page__search-header__button navbar-toggle collapsed\" data-toggle=collapse data-target=#exploreCommunity aria-expanded=false><div class=explore-community-page__search-header__current-state>{{vm.contextPage}}</div><div class=\"explore-community-page__search-header__icon arrow-animation-menu-collapse\"><span class=\"icon-bar dash-one\"></span> <span class=\"icon-bar dash-two\"></span></div></button></div><div id=exploreCommunity class=\"explore-community-page__search-header__list navbar-collapse collapse\" navbar-collapse-on-click=true><div class=explore-community-page__search-header__selection-list><div class=explore-community-page__search-header__selection-item ng-class=\"{\'actived-item\': ![\'community\',\'event\',\'class\'].includes(vm.typeSearch)}\" ng-click=\"vm.selectionTypeSearch(\'all\')\">Explore All</div><div class=explore-community-page__search-header__selection-item ng-class=\"{\'actived-item\': vm.typeSearch === \'community\'}\" ng-click=\"vm.selectionTypeSearch(\'community\')\">Communities</div><div class=explore-community-page__search-header__selection-item ng-class=\"{\'actived-item\': vm.typeSearch === \'event\'}\" ng-click=\"vm.selectionTypeSearch(\'event\')\">Events</div><div class=explore-community-page__search-header__selection-item ng-class=\"{\'actived-item\': vm.typeSearch === \'class\'}\" ng-click=\"vm.selectionTypeSearch(\'class\')\">Classses</div></div></div></div></section><section class=explore-community-page__main-content-wrapper><div ng-if=!vm.inSearchContext class=explore-community-page__arrange-by ng-class=\"{\'have-context-header\': vm.showContextLabel}\"><div class=explore-community-page__arrange-by__label>{{\'sort-by\' | translate}}:</div><div class=explore-community-page__arrange-by__list><stick-checkbox on-changed=vm.onArrangeChanged(data) model=vm.arrangeBy model-property=mostEngagement label=most-engagement layout-style=circle-dot group=arrangeBy></stick-checkbox><stick-checkbox on-changed=vm.onArrangeChanged(data) model=vm.arrangeBy model-property=member_count label=most-members layout-style=circle-dot group=arrangeBy></stick-checkbox><stick-checkbox on-changed=vm.onArrangeChanged(data) model=vm.arrangeBy model-property=name label=alphabetical layout-style=circle-dot group=arrangeBy></stick-checkbox></div></div><div ng-if=\"vm.arrangeBy.name && !vm.inSearchContext\" class=explore-community-page__alpha-filter><span ng-repeat=\"letter in vm.letters\" class=explore-community-page__alpha-filter__letter ng-class=\"{\'actived\': letter === vm.isLettedSelected}\" ng-click=vm.onFilterByLetter(letter)>{{letter}}</span></div><div class=explore-community-page__grid infinite-scroll-disabled=vm.isLastPage infinite-scroll=vm.fetchMoreCommunities() infinite-scroll-immediate-check=false><div ng-if=\"vm.communities && vm.communities.length\" class=explore-community-page__grid__communities-section><div ng-if=vm.showContextLabel class=explore-community-page__grid__communities-section__header><div class=explore-community-page__grid__label>{{\'communities\' | translate}}</div><div ng-if=vm.showSeeMore class=explore-community-page__grid__see-more ng-click=\"vm.selectionTypeSearch(\'community\')\">See more</div></div><div ng-if=vm.inSearchContext class=explore-community-page__grid__communities-section__search-results><span ng-if=vm.noOfCommunities>{{vm.noOfCommunities}}</span> communities on \"{{vm.showKeywords}}\"</div><div class=explore-community-page__grid__communities-section__list><div ng-repeat=\"community in vm.communities | limitTo: vm.maxCommunitiesLoaded\"><community-explore-tile community=community></community-explore-tile></div></div></div><div ng-if=\"vm.events && vm.events.length\" class=explore-community-page__grid__events-section><div ng-if=vm.showContextLabel class=explore-community-page__grid__events-section__header><div class=explore-community-page__grid__label>{{\'events\' | translate}}</div><div ng-if=vm.showSeeMore class=explore-community-page__grid__see-more ng-click=\"vm.selectionTypeSearch(\'event\')\">See more</div></div><div ng-if=vm.inSearchContext class=explore-community-page__grid__events-section__search-results><span ng-if=vm.noOfEvents>{{vm.noOfEvents}}</span> events on \"{{vm.showKeywords}}\"</div><div class=explore-community-page__grid__events-section__list><div ng-repeat=\"event in vm.events | limitTo: vm.maxEventsLoaded\"><event-explore-tile event=event></event-explore-tile></div></div></div><div ng-if=\"vm.workshops && vm.workshops.length\" class=explore-community-page__grid__workshops-section><div ng-if=vm.showContextLabel class=explore-community-page__grid__workshops-section__header><div class=explore-community-page__grid__label>{{\'workshops\' | translate}}</div><div ng-if=vm.showSeeMore class=explore-community-page__grid__see-more ng-click=\"vm.selectionTypeSearch(\'workshop\')\">See more</div></div><div ng-if=vm.inSearchContext class=explore-community-page__grid__workshops-section__search-results><span ng-if=vm.noOfWorkshops>{{vm.noOfWorkshops}}</span> workshops on \"{{vm.showKeywords}}\"</div><div class=explore-community-page__grid__workshops-section__list><div ng-repeat=\"workshop in vm.workshops | limitTo: vm.maxWorkshopsLoaded\"><event-explore-tile event=workshop></event-explore-tile></div></div></div></div></section></div>");
$templateCache.put("app/explore-creators-page/explore-creators-page.html","<div class=explore-creators-page><div class=explore-creators-page__top-navigation dynamic-show-hide-scroll scroll-down-class=hide-on-mobile><div class=explore-creators-page__top-navigation__overlay></div><div class=explore-creators-page__top-navigation__header><!-- <div class=\"explore-creators-page__top-navigation__title\">Explore Creators:</div> --> <button type=button class=\"explore-creators-page__top-navigation__button navbar-toggle collapsed\" data-toggle=collapse data-target=#aboutCreators aria-expanded=false><div class=explore-creators-page__top-navigation__current-state>{{vm.contextPage}}</div><div class=\"explore-creators-page__top-navigation__icon arrow-animation-menu-collapse\"><span class=\"icon-bar dash-one\"></span> <span class=\"icon-bar dash-two\"></span></div></button><div id=aboutCreators class=\"explore-creators-page__top-navigation__list navbar-collapse collapse\" navbar-collapse-on-click=true><div class=explore-creators-page__top-navigation__item ui-sref=explore-creators-page.explore-communnity-hub ui-sref-active=actived>Explore Creators</div><div ng-if=\"vm.loginnedUser && vm.loginnedUser.isContributor\" class=explore-creators-page__top-navigation__item ui-sref=explore-creators-page.creator-agreement ui-sref-active=actived>Creator Agreement</div><div ng-if=\"vm.loginnedUser && vm.loginnedUser.isContributor\" class=explore-creators-page__top-navigation__item ui-sref=explore-creators-page.payout-and-pricing ui-sref-active=actived>Payout and Pricing</div></div></div></div><section ui-view class=explore-creators-page__main-content></section></div>");
$templateCache.put("app/for-creator-page/for-creator-page.html","<div class=for-creator-page><div class=for-creator-page__top-navigation dynamic-show-hide-scroll scroll-down-class=hide-on-mobile><div class=for-creator-page__top-navigation__overlay></div><div class=for-creator-page__top-navigation__header><div class=for-creator-page__top-navigation__header__text-wrapper><button ng-if=!vm.isFullSearchBar type=button class=\"for-creator-page__top-navigation__button navbar-toggle collapsed\" data-toggle=collapse data-target=#buyStock aria-expanded=false><div class=for-creator-page__top-navigation__current-state>{{vm.contextPage}}</div><div class=\"for-creator-page__top-navigation__icon arrow-animation-menu-collapse\"><span class=\"icon-bar dash-one\"></span> <span class=\"icon-bar dash-two\"></span></div></button></div><div ng-if=!vm.isFullSearchBar id=buyStock class=\"for-creator-page__top-navigation__list navbar-collapse collapse\" navbar-collapse-on-click=true><div class=for-creator-page__top-navigation__item ui-sref=for-creator-page.about-community ui-sref-active=actived>Explore Community</div><div class=for-creator-page__top-navigation__item ui-sref=for-creator-page.communities ui-sref-active=actived>Communities</div><div class=for-creator-page__top-navigation__item ui-sref=for-creator-page.classes ui-sref-active=actived>Classes</div><div class=for-creator-page__top-navigation__item ui-sref=for-creator-page.events ui-sref-active=actived>Events</div></div><div class=for-creator-page__top-navigation__search-bar ng-class=\"{\'full-search-bar\': vm.isFullSearchBar}\"><div class=for-creator-page__top-navigation__search-bar__icon><div class=icon-icons_search></div></div><tags-input placeholder=\"Search communities and events\" add-on-blur=true min-length=1 ng-model=vm.tags.data on-tag-added=vm.tagAdded($tag) on-tag-removed=vm.tagRemoved($tag) replace-spaces-with-dashes=false class=for-creator-page__top-navigation__search-bar__input></tags-input><div class=for-creator-page__search-type><div class=for-creator-page__search-type__wrapper uib-dropdown is-open=status.isopen><button id=search-selection type=button class=for-creator-page__search-type__selection-button uib-dropdown-toggle ng-disabled=disabled><div class=for-creator-page__search-type__selection-button__icon ng-class=\"{\'icon-community_2\': vm.selecetedType === \'communities\', \'icon-pencil\': vm.selecetedType === \'classes\', \'icon-icons_calendar\': vm.selecetedType === \'events\'}\"></div><div class=for-creator-page__search-type__selection-button__text>{{vm.selecetedType}}</div><div class=for-creator-page__search-type__selection-button__arrow ng-class=\"status.isopen ? \'icon-icons_chevron-up\' : \'icon-icons_chevron-down\'\"></div></button><ul class=\"for-creator-page__search-type__list dropdown-menu\" uib-dropdown-menu role=menu aria-labelledby=search-selection><li role=menuitem class=for-creator-page__search-type__item ng-click=\"vm.onSearchTypeChange(\'all\')\"><div class=for-creator-page__search-type__item__check ng-class=\"{\'icon-icons_check\': ![\'communities\', \'classes\', \'events\'].includes(vm.selecetedType)}\"></div><div class=for-creator-page__search-type__item__text>All</div></li><li role=menuitem class=for-creator-page__search-type__item ng-click=\"vm.onSearchTypeChange(\'communities\')\"><div class=for-creator-page__search-type__item__check ng-class=\"{\'icon-icons_check\': vm.selecetedType === \'communities\'}\"></div><div class=\"for-creator-page__search-type__item__icon icon-community_2\"></div><div class=for-creator-page__search-type__item__text>Communities</div></li><li role=menuitem class=for-creator-page__search-type__item ng-click=\"vm.onSearchTypeChange(\'classes\')\"><div class=for-creator-page__search-type__item__check ng-class=\"{\'icon-icons_check\': vm.selecetedType === \'classes\'}\"></div><div class=\"for-creator-page__search-type__item__icon icon-pencil\"></div><div class=for-creator-page__search-type__item__text>Classes</div></li><li role=menuitem class=for-creator-page__search-type__item ng-click=\"vm.onSearchTypeChange(\'events\')\"><div class=for-creator-page__search-type__item__check ng-class=\"{\'icon-icons_check\': vm.selecetedType === \'events\'}\"></div><div class=\"for-creator-page__search-type__item__icon icon-icons_calendar\"></div><div class=for-creator-page__search-type__item__text>Events</div></li></ul></div></div></div></div></div><section ui-view class=for-creator-page__main-content></section></div>");
$templateCache.put("app/gallery/gallery.html","<section class=\"gallery-page bg--white relative main__content--md\" ng-class=\"{\'margin-top--1\': isScreenMobile}\"><div class=\"marketplace__sub-navigate clearfix\" scroll-to-fixed=vm.scrollToFixedHeaderSettings><div class=marketplace__sub-navigate__back-btn ng-click=vm.onBackbtnClicked()><span class=\"marketplace__sub-navigate__back-btn__icon text--color-black text--bold\">&lt;</span><span translate=back-to translate-values=\"{name: (\'galleries\' | translate)}\"></span></div></div><div class=\"gallery-page__header clearfix\"><div class=gallery-page__header__title>{{vm.gallery.data.title | toTitleCase}}</div><div class=\"gallery-page__header__description col-xs-6 no-padding\">{{vm.gallery.data.description}}</div><div class=\"gallery-page__header__sub clearfix\"><div class=\"gallery-page__header__sub__info clearfix\"><div class=gallery-page__header__sub__avatar><a ui-sref=\"user-home-page.personal.home({id: vm.user.id, userName: (vm.user.displayName | toSnakeCase)})\"><pixerf-user-avatar class=profile-image user-data=vm.user lazy=true></pixerf-user-avatar></a></div><div class=gallery-page__header__sub__author><div class=gallery-page__header__sub__author__by ng-bind=\"vm.gallery.data.is_curated ? (\'curated-by\' | translate) : (\'gallery-by\' | translate)\"></div><div class=gallery-page__header__sub__author__name><a ui-sref=\"user-home-page.personal.home({id: vm.user.id, userName: (vm.user.displayName | toSnakeCase)})\" class=\"pixerf-link--color-theme text--bold\">{{vm.user.displayName}}</a></div></div></div><div class=gallery-page__header__sub__action><button ng-if=vm.isMine ng-click=vm.showEditGalleryPopup() class=\"edit-gallery-btn btn btn-pixerf-theme btn-pixerf-theme--no-background text--bold\" translate translate-values=\"{name: (\'gallery\' | translate)}\">{{\'edit\'}}</button><follow-gallery-btn ng-if=\"!vm.isMine && (!vm.loginnedUser || vm.loginnedUser.canManageGalleries)\" gallery=vm.gallery.data></follow-gallery-btn><div class=\"gallery-page__header__sub__navigation-bar collapse navbar-collapse\" navbar-collapse-on-click=true id=gallery-share-navbar-collapse><share settings=\"{\'flatMode\': true}\" content-will-be-shared=vm.socialShareContent title=\"Share this gallery\"></share></div></div></div></div><div class=gallery-page__main-content><div ng-show=\"vm.photoGrid.photos.length === 0\" class=\"text-center gallery-empty-info ng-hide\"><div class=icon-icons-gallery></div><h4 class=\"gallery-page__main-content__title text--semibold text--color-black\" ng-bind-html=vm.emptyText[vm.type]></h4><p>Click on this icon <span class=icon-icons-add-to-gallery></span> on any photo to save it to your gallery.</p><a ng-if=vm.gallery.data.is_curated class=\"text--color-pixerf-theme gallery-page__discover-market\" ui-sref=buy-stock-page.trending>{{\'discover-marketplace\' | translate}}</a></div><div ng-hide=\"vm.photoGrid.photos.length === 0\" class=\"photos-grid-wrapper clearfix relative\"><photo-grid on-file-removed=vm.onFileRemoved(file) gallery=vm.gallery.data instance=vm.photoGrid></photo-grid></div><div class=\"gallery-page__related-galleries clearfix\"><div class=gallery-page__related-galleries__title translate>{{\'related-galleries-you-like\'}}</div><gallery-grid instance=vm.galleryGrid></gallery-grid></div></div></section>");
$templateCache.put("app/home/home.html","<div class=home><slick speed=1000 class=home__banner infinite=true slides-to-scroll=1 slides-to-show=1 dots=true arrows=false autoplay=true autoplay-speed=3000><div ng-repeat=\"slide in vm.banners\" class=home__banner__slide photo-details-on-click={{slide.id}}><div ng-style=\"{\'background-image\': \'url(\' + slide.photo + \')\'}\" class=home__banner__slide__background-desktop></div><div ng-style=\"{\'background-image\': \'url(\' + slide.photoMobile + \')\'}\" class=home__banner__slide__background-mobile></div><div class=\"home__banner__slide__content {{slide.theme}}\"><banner-box-intro data=slide></banner-box-intro><button class=\"home__banner__slide__content__submit-btn slide-{{$index}}-submit-btn\" ng-click=slide.button.cta()>{{slide.button.text}}</button></div></div></slick><section class=\"home__section home__section__brands\"><div class=home__section__brands__title>Businesses trust our simple and hassle-free visual content creation solutions</div><div class=home__section__brands__carousel__wrapper><slick speed=1000 responsive=vm.responsive class=home__section__brands__carousel infinite=false slides-to-scroll=6 slides-to-show=6 dots=true arrows=true append-arrows=\".home__section home__section__brands__arrow__wrapper\" on-init=vm.slickSetting.onInit(slick) variable-width=true on-after-change=\"vm.slickSetting.onAfterChange(event, slick, currentSlide, nextSlide)\"><div ng-repeat=\"brand in vm.brands\" class=\"home__section__brands__item item-{{$index}}\"><div class=frame-row-1><img ng-src={{brand.photo[0]}} alt=\"\" class=\"home__section__brands__item__photo home__section__brands__item__photo__pc row-1\"> <img ng-src={{brand.photoMobile[0]}} alt=\"\" class=\"home__section__brands__item__photo home__section__brands__item__photo__mobile row-1\"></div><div class=frame-row-2><img ng-src={{brand.photo[1]}} alt=\"\" class=\"home__section__brands__item__photo home__section__brands__item__photo__pc row-2\"> <img ng-src={{brand.photoMobile[1]}} alt=\"\" class=\"home__section__brands__item__photo home__section__brands__item__photo__mobile row-2\"></div></div></slick><div class=home__section__brands__arrow__wrapper><div ng-click=vm.navigateRight() class=\"home__section__brands__arrow__icon icon-slide-prev-icon\" ng-class=\"{\'disabled\': vm.slick.currentSlide == 0}\"></div><div ng-click=vm.navigateNext() class=\"home__section__brands__arrow__icon icon-slide-next-icon\" ng-class=\"{\'disabled\': vm.isLastBrandsSlide}\"></div></div></div></section><section class=\"home__section home__section__col-info\"><div class=home__section__col-info__title>Simple, Reliable and Quick Booking with 24-Hour Response Time</div><info-col-intro context=quick-booking></info-col-intro><div class=\"home__section home__section__col-info__control\"><button class=\"home__section home__section__col-info__control__demo-btn\" ng-click=vm.bookADemo()>Book a Demo</button> <button class=\"home__section home__section__col-info__control__shoot-btn\" ng-click=vm.bookShoot()>Book a Shoot</button></div></section><section class=\"home__section home__section__testimonial\"><div class=home__section__testimonial__title>Hear what brands have to say about working with PIXERF.</div><case-study-intro data=vm.caseStudies class=\"home__section home__section__testimonial__carousel\"></case-study-intro></section><section class=\"home__section home__section__grid-carousel\"><div class=\"home__section home__section__grid-carousel__title\">Home to Asia’s largest visual content creator network</div><div class=\"home__section home__section__grid-carousel__description\">Asia’s next-gen and sought-after talents have joined our community.</div><custom-homepage-grid-carousel></custom-homepage-grid-carousel></section><general-contact-form id=generalContactFormSection context=home-page></general-contact-form></div>");
$templateCache.put("app/jobs/jobs.html","<div class=jobs-page><div class=jobs-page__header photo-details-on-click=102419><div class=jobs-page__header__content><div class=jobs-page__header__content__box>We\'re Hiring!</div></div></div><div class=jobs-page__body><div class=jobs-page__body__content><div class=jobs-page__body__content__title>Love what we do? Join us!</div><div class=jobs-page__body__content__description><div>We\'re a lean, mean, diverse team of passionate individuals who believe in the power of community and the importance of the Asian perspective.</div><div>Do you believe in the same? Then we\'re looking for you!</div></div><div class=jobs-page__body__content__position-list><div class=jobs-page__body__content__position-list__title>OPEN POSITIONS</div><div ng-repeat=\"job in vm.jobs\" class=jobs-page__body__content__position-list__open><div class=jobs-page__body__content__position-list__open__content><div class=jobs-page__body__content__position-list__open__content__title>{{job.title}}</div><div class=jobs-page__body__content__position-list__open__content__description>{{job.description}}</div></div><div class=jobs-page__body__content__position-list__open__cta__wrapper><div class=jobs-page__body__content__position-list__open__cta ng-click=vm.onDetailJob(job.id)>Find out more</div></div></div></div></div></div><div class=jobs-page__footer><div class=jobs-page__footer__content><div class=jobs-page__footer__content__title>Believe You Have It? Connect with Us.</div><div class=jobs-page__footer__content__description>If you don\'t see an opening that fits you, don\'t leave without saying a word. Connect with us, tell us what you do best, and we\'ll see if there\'s a match.</div><a class=jobs-page__footer__cta href=mailto:careers@pixerf.com target=_top>Get in Touch</a></div></div></div>");
$templateCache.put("app/main/main.html","<div><pixerf-navbar></div><div class=container-fluid><pixerf-gallery></div>");
$templateCache.put("app/job-detail-page/job-detail-page.html","<div class=\"main__content--md jobs-detail-page no-margin\" ng-class=\"{\'margin-top--1\': isScreenMobile}\"><section class=jobs-detail-page__main-wrapper><div class=jobs-detail-page__back-btn ng-click=vm.onBackBtnClicked()><span class=icon-icons_chevron-left></span> <span>See more jobs</span></div><div class=jobs-detail-page__main-content-wrapper><div class=jobs-detail-page__col-left><div class=jobs-detail-page__opening-position-wrapper><div class=jobs-detail-page__opening-position><div class=jobs-detail-page__opening-position-title>{{vm.job.title}}</div></div><div class=jobs-detail-page__opening-position-description ng-bind=vm.job.subTitle></div></div><a class=\"jobs-detail-page__apply-btn hide-desktop\" ng-href=\"mailto:careers@pixerf.com?Subject={{vm.job.emailSubject}}\" target=_top>Apply here</a><div class=jobs-detail-page__job-requirement><div class=jobs-detail-page__job-requirement__description-wrapper ng-repeat=\"reqItems in vm.job.description\"><div class=jobs-detail-page__job-requirement-title>{{reqItems.label}}</div><ul class=jobs-detail-page__job-requirement-items><li ng-repeat=\"reqItem in reqItems.descriptions\"><span>{{reqItem}}</span></li></ul></div></div></div><div class=jobs-detail-page__col-right><div>The excitement never stops at PIXERF. We\'re constantly embracing new challenges as a team, and we\'re obsessed with building the perfect product.<br><br>Don\'t expect to work alone. We share between teams, and we look out for each other. You won\'t show up on day one with nothing to do – you can expect to dive in right away, sink or swim.<br><br>Join us. We promise it will never be boring.<br><br>Please attach your CV and indicate your expected salary in the application. Click on the button below, or send an email to <a href=mailto:careers@pixerf.com class=\"text--color-pixerf-theme text--bold\">careers@pixerf.com</a> with the position name as the subject title.</div><a class=jobs-detail-page__apply-btn ng-href=\"mailto:careers@pixerf.com?Subject={{vm.job.emailSubject}}\" target=_top>Apply here</a></div></div></section><section class=jobs-detail-page__footer><div class=jobs-detail-page__footer__content><div class=jobs-detail-page__footer__content__title>Believe You Have It? Connect with Us.</div><div class=jobs-detail-page__footer__content__description>If you don\'t see an opening that fits you, don\'t leave without saying a word. Connect with us, tell us what you do best, and we\'ll see if there\'s a match.</div><a class=jobs-detail-page__footer__cta href=mailto:careers@pixerf.com target=_top>Get in Touch</a></div></section></div>");
$templateCache.put("app/manage-custom-commissions/manage-custom-commissions.html","<div class=\"clearfix setting-top-navigation\" ng-if=!vm.guestUser><div class=\"setting-top-navigation__section-wrapper pixerf-navigation-bar-wrapper\"><!-- <ul class=\"manage-custom-commissions__navigation-bar pixerf-navigation-bar\">\r\n			<button type=\"button\" class=\"setting-top-navigation__collapse-button navbar-toggle collapsed\"\r\n				data-toggle=\"collapse\" data-target=\"#manage-custom-commission-navigation\" aria-expanded=\"false\">\r\n				<div class=\"setting-top-navigation__context\" translate>{{vm.contextPage}}</div>\r\n				<div class=\"setting-top-navigation__mobile-button arrow-animation-menu-collapse\">\r\n					<span class=\"icon-bar dash-one\"></span>\r\n					<span class=\"icon-bar dash-two\"></span>\r\n				</div>\r\n			</button>\r\n			<div class=\"setting-top-navigation__list collapse navbar-collapse\" navbar-collapse-on-click=\"true\"\r\n				id=\"manage-custom-commission-navigation\">\r\n				<li class=\"setting-top-navigation__item\" ui-sref-active=\"setting-top-navigation__item--active\"\r\n					ui-sref=\"setting.manage-custom-commissions.on-going\">\r\n					{{\'ongoing\' | translate}}</li>\r\n			</div>\r\n		</ul> --><div class=\"manage-custom-commissions__main-content clearfix\" ui-view></div></div></div>");
$templateCache.put("app/manage-hub-page/manage-hub-page.html","<div class=manage-hub-page__inner-main-content ui-view></div>");
$templateCache.put("app/manage-detail-community-page/manage-detail-community-page.html","<div class=\"manage-detail-community-page main__content--md\" id=manage-detail-community ng-class=\"{\'margin-top--1\': isScreenMobile}\"><div class=manage-detail-community-page__back-btn ng-click=vm.onBackBtnClicked()>&lt {{\'back-to\' | translate: {name: (\'my-communities\' | translate)}}}</div><section class=manage-detail-community-page__content><div class=manage-detail-community-page__content__sidebar-nav><div class=manage-detail-community-page__content__title>Community</div><div class=manage-detail-community-page__navbar-wrapper><li ng-if=vm.isMine ui-sref-active=actived class=manage-detail-community-page__navbar-wrapper__item ui-sref=\"{{vm.commonConst.STATE.MANAGE_COMMUNITIES_BRIEF}}({status: \'members\'})\" translate>{{\'about\'}}</li><li ui-sref-active-class=actived class=manage-detail-community-page__navbar-wrapper__item ui-sref-active-if=manage-detail-community.manage-detail-community-members ui-sref={{vm.commonConst.STATE.MANAGE_COMMUNITIES_INVITED_MEMBERS}}>{{\'members\'| translate}}</li><li ui-sref-active-class=actived class=manage-detail-community-page__navbar-wrapper__item ui-sref-active-if=manage-detail-community.manage-detail-community-discussions ui-sref={{vm.commonConst.STATE.MANAGE_COMMUNITIES_PENDING_DISCUSSIONS}}>{{\'discussions\'| translate}}</li></div></div><div class=manage-detail-community-page__header-intro__wrapper><div class=manage-detail-community-page__header-intro><a ui-sref=\"community-detail-page.community-detail-discussions({id: vm.community.id,name: vm.community.name})\"><div class=manage-detail-community-page__header-intro__community-avatar-wrapper ng-class=\"{\'circle-avatar\': vm.community.owner.account_type === \'personal\'}\"><img ng-src={{vm.communityAvatar.url}}></div></a><div class=manage-detail-community-page__header-intro__community-info-wrapper><a ui-sref=\"community-detail-page.community-detail-discussions({id: vm.community.id,name: vm.community.name})\"><h1 class=manage-detail-community-page__header-intro__community-name>{{vm.community.name}}</h1></a><div class=clearfix><community-members-label class=manage-detail-community-page__header-intro__community-members-count community=vm.community></community-members-label></div></div><div class=manage-detail-community-page__header-intro__btns-wrapper><button class=\"manage-detail-community-page__header-intro__btns-wrapper__invite-members-btn btn btn-submit--transparent\" ng-click=vm.onInviteMembers()>{{\'invite-members\' | translate}}</button></div></div><section ui-view class=manage-detail-community-page__main-content></section></div></section></div>");
$templateCache.put("app/manage-media-post/manage-media-post.html","<div class=\"clearfix setting-top-navigation\"><div class=\"setting-top-navigation__section-wrapper pixerf-navigation-bar-wrapper\"><ul class=\"manage-media-post__navigation-bar pixerf-navigation-bar\"><button type=button class=\"setting-top-navigation__collapse-button navbar-toggle collapsed\" data-toggle=collapse data-target=#manage-media-post-navigation aria-expanded=false><div class=setting-top-navigation__context translate>{{vm.subContextPage}}</div><div class=\"setting-top-navigation__mobile-button arrow-animation-menu-collapse\"><span class=\"icon-bar dash-one\"></span> <span class=\"icon-bar dash-two\"></span></div></button><div class=\"setting-top-navigation__list collapse navbar-collapse\" navbar-collapse-on-click=true id=manage-media-post-navigation><li class=setting-top-navigation__item ui-sref-active=setting-top-navigation__item--active ui-sref=setting.manage-media-post.create-post>Create Post</li><li class=setting-top-navigation__item ui-sref-active=setting-top-navigation__item--active ui-sref=setting.manage-media-post.published>Published</li></div></ul><div class=\"manage-media-post__main-content clearfix\" ui-view></div></div></div>");
$templateCache.put("app/manage-missions/manage-missions.html","<div class=\"clearfix none-float horizental-centered\" ng-if=!vm.guestUser><div><div class=manage-mission><ul class=\"manage-mission-navigation-bar no-padding clearfix\"><button type=button class=\"navbar-toggle collapsed\" data-toggle=collapse data-target=#earning-navbar-collapse aria-expanded=false><div class=\"pull-left text--bold\">{{vm.subContextPage}}</div><div class=\"pull-right arrow-animation-menu-collapse\"><span class=\"icon-bar dash-one\"></span> <span class=\"icon-bar dash-two\"></span></div></button><div class=\"collapse navbar-collapse no-padding pixerf-navbar-text\" navbar-collapse-on-click=true id=earning-navbar-collapse><li ng-if=vm.canCreateMission ui-sref-active-if=setting.manage-missions.create-mission ui-sref-active-class=\"manage-mission-navigation-bar__menu-item--active \" ui-sref=\"setting.manage-missions.create-mission.getting-started({id: \'\'})\" class=manage-mission-navigation-bar__menu-item>{{\'create-challenge\' | translate}}</li><li ng-if=vm.canCreateMission ui-sref-active-if=setting.manage-missions.draft ui-sref-active-class=\"manage-mission-navigation-bar__menu-item--active \" ui-sref=setting.manage-missions.draft.list-mission-draft class=manage-mission-navigation-bar__menu-item>{{\'unpublished\' | translate}}</li><!-- <li ui-sref-active=\"manage-mission-navigation-bar__menu-item--active\" ui-sref=\"setting.manage-missions.pending\" class=\"manage-mission-navigation-bar__menu-item\">Pending</li> --><li ui-sref-active=manage-mission-navigation-bar__menu-item--active ui-sref=setting.manage-missions.on-going class=manage-mission-navigation-bar__menu-item>{{\'ongoing\' | translate}}</li><li ui-sref-active=manage-mission-navigation-bar__menu-item--active ui-sref=setting.manage-missions.mission-closed class=manage-mission-navigation-bar__menu-item>{{\'closed\' | translate}}</li></div></ul></div><div class=\"manage-mission__main-content clearfix\" ui-view></div></div></div>");
$templateCache.put("app/manage-photos/manage-photos.html","<div class=setting-top-navigation><div class=\"setting-top-navigation__section-wrapper pixerf-navigation-bar-wrapper\" ng-if=!vm.guestUser><ul class=\"manage-photos-page__setting-top-navigation pixerf-navigation-bar\"><button type=button class=\"setting-top-navigation__collapse-button navbar-toggle collapsed\" data-toggle=collapse data-target=#manage-photos-mission-navigation aria-expanded=false><div class=setting-top-navigation__context translate>{{vm.contextPage}}</div><div class=\"setting-top-navigation__mobile-button arrow-animation-menu-collapse\"><span class=\"icon-bar dash-one\"></span> <span class=\"icon-bar dash-two\"></span></div></button><div class=\"setting-top-navigation__list collapse navbar-collapse\" navbar-collapse-on-click=true id=manage-photos-mission-navigation><li class=setting-top-navigation__item ui-sref-active=setting-top-navigation__item--active ui-sref=setting.manage-photos.pending-review>{{\'in-review\' | translate}} ({{vm.numberPhotosReviewing}})</li><li class=setting-top-navigation__item ui-sref-active=setting-top-navigation__item--active ui-sref=setting.manage-photos.rejected>{{\'rejected\' | translate}} ({{vm.numberPhotosRejected}})</li><li class=setting-top-navigation__item ui-sref-active=setting-top-navigation__item--active ui-sref=setting.manage-photos.approved>{{\'approved\' | translate}} ({{vm.numberPhotosApproved}})</li></div></ul><div class=\"manage-photos-page__main-content clearfix\" ui-view></div></div></div>");
$templateCache.put("app/manage-photos-mission/manage-photos-mission.html","<div class=\"clearfix setting-top-navigation\" ng-if=!vm.guestUser><div class=manage-photos-mission__content><div class=manage-photos-mission__header translate>{{\'manage-missions\'}}</div><div class=manage-photos-mission__description><div translate>{{\'joined-view-edit-manage\'}}</div><div translate>{{\'feel-free-to-change-your-submissions\'}}</div></div></div><div class=\"setting-top-navigation__section-wrapper pixerf-navigation-bar-wrapper\"><ul class=\"manage-photos-mission__navigation-bar pixerf-navigation-bar\"><button type=button class=\"setting-top-navigation__collapse-button navbar-toggle collapsed\" data-toggle=collapse data-target=#manage-photos-mission-navigation aria-expanded=false><div class=setting-top-navigation__context translate>{{vm.contextPage}}</div><div class=\"setting-top-navigation__mobile-button arrow-animation-menu-collapse\"><span class=\"icon-bar dash-one\"></span> <span class=\"icon-bar dash-two\"></span></div></button><div class=\"setting-top-navigation__list collapse navbar-collapse\" navbar-collapse-on-click=true id=manage-photos-mission-navigation><li class=setting-top-navigation__item ui-sref-active=setting-top-navigation__item--active ui-sref=setting.manage-photos-mission.pending>{{\'in-review\' | translate}} <span ng-if=\"vm.numberPhotosReviewing > 0\">({{vm.numberPhotosReviewing}})</span></li><li class=setting-top-navigation__item ui-sref-active=setting-top-navigation__item--active ui-sref=setting.manage-photos-mission.approved>{{\'approved\' | translate}} <span ng-if=\"vm.numberPhotosApproved > 0\">({{vm.numberPhotosApproved}})</span></li><li class=setting-top-navigation__item ui-sref-active=setting-top-navigation__item--active ui-sref=setting.manage-photos-mission.rejected>{{\'rejected\' | translate}} <span ng-if=\"vm.numberPhotosRejected > 0\">({{vm.numberPhotosRejected}})</span></li><li class=\"setting-top-navigation__item setting-top-navigation__item__slash\">|</li><li class=setting-top-navigation__item ui-sref-active=setting-top-navigation__item--active ui-sref=setting.manage-photos-mission.awards>{{\'awards\' | translate}}</li></div></ul><div class=\"manage-photos-mission__main-content clearfix\" ui-view></div></div></div>");
$templateCache.put("app/marketplace-ad-page/marketplace-ad-page.html","<div class=marketplace-ad-page><section class=marketplace-ad-page__branding><h1 class=marketplace-ad-page__branding__headline>Get these stock images<br>for just $5</h1><div class=marketplace-ad-page__branding__grid-wrapper><div ng-repeat=\"photo in vm.photos\" class=marketplace-ad-page__branding__item-wrapper ng-click=vm.onPhotoClicked(photo.id)><div class=marketplace-ad-page__branding__item><div class=\"marketplace-ad-page__branding__item__background zoom-hover\" ng-style=\"{\'background-image\': \'url(\\\'\' + photo.thumbnails[\'local\'] + \'\\\')\'}\"></div></div></div><div class=marketplace-ad-page__branding__item-wrapper ui-sref=buy-stock-page.galleries.signature-galleries><div id=gsg_003 tracking-element class=marketplace-ad-page__branding__item>Looking for<br>something else?<br>Browse even more<br>$5 stock images</div></div></div><div class=marketplace-ad-page__branding__hint>Interested in future offers and updates? <span class=marketplace-ad-page__branding__register ng-click=vm.onRegister()>Sign up</span> now.</div></section><section class=\"row marketplace-ad-page__for-business\"><div class=marketplace-ad-page__for-business__header><p class=marketplace-ad-page__for-business__header__text translate>{{\'perfect-for-you-and-your-business\'}}</p><p class=marketplace-ad-page__for-business__header__desc translate>{{\'royalty-free-images-from-asia\'}}.</p></div><div class=marketplace-ad-page__for-business__group><div class=marketplace-ad-page__for-business__group__item><span class=\"marketplace-ad-page__for-business__group__item__icon icon-startups\"></span><div class=marketplace-ad-page__for-business__group__item__title translate>{{\'for-start-ups\'}}</div><div class=marketplace-ad-page__for-business__group__item__desc translate>{{\'running-a-small-budget\'}}.</div></div><div class=marketplace-ad-page__for-business__group__item><span class=\"marketplace-ad-page__for-business__group__item__icon icon-businesses\"></span><div class=marketplace-ad-page__for-business__group__item__title translate>{{\'for-businesses\'}}</div><div class=marketplace-ad-page__for-business__group__item__desc translate>{{\'find-the-perfect-images\'}}.</div></div><div class=marketplace-ad-page__for-business__group__item><span class=\"marketplace-ad-page__for-business__group__item__icon icon-contentcreators\"></span><div class=marketplace-ad-page__for-business__group__item__title translate>{{\'for-content-creators\'}}</div><div class=marketplace-ad-page__for-business__group__item__desc translate>{{\'from-comping-to-billboard\'}}.</div></div></div></section><section class=\"row marketplace-ad-page__category\"><div class=marketplace-ad-page__category__header><p class=marketplace-ad-page__category__header__text translate>{{\'whatever-youre-looking-for\'}}.</p><p class=marketplace-ad-page__category__header__desc translate>{{\'explore-the-best-images\'}}.</p></div><div class=marketplace-ad-page__category__topic><div class=\"marketplace-ad-page__category__topic__cover left level-1\"><div class=\"marketplace-ad-page__category__topic__cover left level-2\"><img src=assets/images/marketplace-ad/Food.jpg alt=\"{{\'food\'| translate}}\" class=marketplace-ad-page__category__topic__cover__icon ng-click=\"vm.goToTopicImage(\'food\')\"><div class=marketplace-ad-page__category__topic__cover__box ng-click=\"vm.goToTopic(\'food\')\" translate>{{\'food\'}}</div></div><div class=\"marketplace-ad-page__category__topic__cover right level-2\"><img src=assets/images/marketplace-ad/Asian-faces.jpg alt=\"{{\'asian-faces\'| translate}}\" class=marketplace-ad-page__category__topic__cover__icon ng-click=\"vm.goToTopicImage(\'asianFaces\')\"><div class=marketplace-ad-page__category__topic__cover__box ng-click=\"vm.goToTopic(\'asianFaces\')\" translate>{{\'asian-faces\'}}</div></div></div><div class=\"marketplace-ad-page__category__topic__cover right level-1\"><div class=\"marketplace-ad-page__category__topic__cover left display-row level-2\"><div class=marketplace-ad-page__category__topic__cover><img src=assets/images/marketplace-ad/Life-style.jpg alt=\"{{\'lifestyle\'| translate}}\" class=marketplace-ad-page__category__topic__cover__icon ng-click=\"vm.goToTopicImage(\'lifestyle\')\"><div class=marketplace-ad-page__category__topic__cover__box ng-click=\"vm.goToTopic(\'lifestyle\')\" translate>{{\'lifestyle\'}}</div></div><div class=marketplace-ad-page__category__topic__cover><img src=assets/images/marketplace-ad/Industrial.jpg alt=\"{{\'industrial\'| translate}}\" class=marketplace-ad-page__category__topic__cover__icon ng-click=\"vm.goToTopicImage(\'industrial\')\"><div class=marketplace-ad-page__category__topic__cover__box ng-click=\"vm.goToTopic(\'industrial\')\" translate>{{\'industrial\'}}</div></div></div><div class=\"marketplace-ad-page__category__topic__cover right level-2\"><img src=assets/images/marketplace-ad/City.jpg alt=\"{{\'city\'| translate}}\" class=marketplace-ad-page__category__topic__cover__icon ng-click=\"vm.goToTopicImage(\'city\')\"><div class=marketplace-ad-page__category__topic__cover__box ng-click=\"vm.goToTopic(\'city\')\" translate>{{\'city\'}}</div></div></div></div><div class=marketplace-ad-page__category__topic><div class=\"marketplace-ad-page__category__topic__cover left level-1\"><img src=assets/images/marketplace-ad/Culture.jpg alt=\"{{\'culture\'| translate}}\" class=marketplace-ad-page__category__topic__cover__icon ng-click=\"vm.goToTopicImage(\'culture\')\"><div class=marketplace-ad-page__category__topic__cover__box ng-click=\"vm.goToTopic(\'culture\')\" translate>{{\'culture\'}}</div></div><div class=\"marketplace-ad-page__category__topic__cover right level-1\"><img src=assets/images/marketplace-ad/Travel.jpg alt=\"{{\'travel\'| translate}}\" class=marketplace-ad-page__category__topic__cover__icon ng-click=\"vm.goToTopicImage(\'travel\')\"><div class=marketplace-ad-page__category__topic__cover__box ng-click=\"vm.goToTopic(\'travel\')\" translate>{{\'travel\'}}</div></div></div></section><section class=marketplace-ad-page__section-bottom><div class=marketplace-ad-page__section-bottom__header><p class=marketplace-ad-page__section-bottom__header__text translate>{{\'want-bigger-savings\'}}</p><p class=marketplace-ad-page__section-bottom__header__desc translate>{{\'with-our-credit-plans\'}}</p></div><div class=marketplace-ad-page__section-bottom__box><div id=gcp_003 tracking-element class=marketplace-ad-page__section-bottom__box__view-credit-plans ng-click=vm.goToCreditPage($event)>Compare credit plans</div></div></section><section class=\"row marketplace-ad-page__footer clearfix\"><div class=\"marketplace-ad-page__footer__main-menu clearfix\"><div class=\"marketplace-ad-page__footer__links-wrapper clearfix\"><div class=\"marketplace-ad-page__footer__col-right clearfix\"><div class=\"marketplace-ad-page__footer__links footer-nav-community\"><div class=marketplace-ad-page__footer__apps_btn_wrapper><link-mobile-app></link-mobile-app></div></div><div class=\"marketplace-ad-page__footer__social-links clearfix\"><h3 class=marketplace-ad-page__footer__links__label translate>{{\'connect-with-us-on\'}}</h3><div class=\"marketplace-ad-page__footer__social_btn_wrapper clearfix\"><a href=https://www.facebook.com/Pixerf target=_blank><img src=../../assets/images/casestudies/logos/facebook@2x.png alt=\"facebook link\"> </a><a class=ng-hide href=https://www.pinterest.com/Pixerf/ target=_blank><img src=../../assets/images/casestudies/logos/linked-in@2x.png alt=\"linkedin link\"> </a><a class=ng-hide href=https://plus.google.com/+Pixerf target=_blank><span class=icon-icons_googleplus></span> </a><a class=ng-hide href=https://www.youtube.com/Pixerf target=_blank><span class=\"fa fa-youtube\"></span> </a><a href=http://instagram.com/Pixerf target=_blank><img src=../../assets/images/casestudies/logos/instagram@2x.png alt=\"instagram link\"> </a><a href=https://twitter.com/Pixerf target=_blank><img src=../../assets/images/casestudies/logos/twitter@2x.png alt=\"twitter link\"></a></div></div></div></div></div><div class=\"marketplace-ad-page__footer__banner text-center\"><span>© 2020 PIXERF Pte Ltd. All Rights Reserved.</span></div></section></div>");
$templateCache.put("app/media-page/media-page.html","<div class=media-page><div class=media-page__banner photo-details-on-click=272514><div class=media-page__banner__box><div class=media-page__banner__box__title>Media</div><div class=media-page__banner__box__content>PIXERF in the news.</div></div></div><div class=media-page__content><div class=media-page__content__list infinite-scroll-disabled=vm.isLastPage infinite-scroll=vm.fetchMoreNews() infinite-scroll-immediate-check=false><div ng-repeat=\"post in vm.posts\" class=media-page__content__post><div class=media-page__content__post__col-left><div class=media-page__content__post__logo><img ng-src=\"{{post.photo[\'original\']}}\"></div><a ng-href={{post.url}} target=_blank class=media-page__content__post__logo-title>{{post.url_text}}</a></div><div class=media-page__content__post__col-right><div class=media-page__content__post__header><a ng-href={{post.url}} target=_blank class=media-page__content__post__title ng-bind-html=post.name></a> <a ng-href={{post.url}} target=_blank class=\"media-page__content__post__icon icon-link-to\"></a></div><div class=media-page__content__post__date>{{post.formattedDate}}</div><div class=media-page__content__post__content>{{post.description}}</div></div></div><spinner-win spinner=vm.spinner></spinner-win></div></div></div>");
$templateCache.put("app/marketplace/marketplace.html","<div class=\"relative main__content--md marketplace\" ng-class=\"{\'margin-top--1\': isScreenMobile, \'marketplace--curator\': vm.loginUser.canCurate}\"><div class=marketplace__top-navigate><div class=marketplace__top-navigate__wrapper><div class=marketplace__top-navigate__label>Explore Marketplace:</div><button type=button class=\"navbar-toggle collapsed\" data-toggle=collapse data-target=#marketplace-navbar-collapse aria-expanded=false><div class=marketplace__top-navigate__navigate-context>{{vm.mobileBreadcrumb}}</div><div class=\"marketplace__top-navigate__navigate-icon arrow-animation-menu-collapse\"><span class=\"icon-bar dash-one\"></span> <span class=\"icon-bar dash-two\"></span></div></button><ul id=marketplace-navbar-collapse class=\"marketplace__top-navigate__list collapse\" navbar-collapse-on-click=true><li class=marketplace__top-navigate__item ui-sref-active=active ui-sref=\"marketplace.photosByType({\'type\': fileConst.FILE_STATE_NAME.TRENDING})\">Trending</li><li class=marketplace__top-navigate__item ui-sref-active=active ui-sref=\"marketplace.photosByType({\'type\': fileConst.FILE_STATE_NAME.DISCOVER})\">Discover</li><li class=marketplace__top-navigate__item ui-sref-active=active ui-sref=\"marketplace.photosByType({\'type\': fileConst.FILE_STATE_NAME.EDITOR_PICK})\">Editors\' Pick</li><li class=marketplace__top-navigate__item ui-sref-active-class=active ui-sref-active-if=marketplace.galleries ui-sref=buy-stock-page.galleries.signature-galleries>Galleries</li><li ng-if=vm.loginUser.canCurate class=\"marketplace__top-navigate__item dynamic-item-show\" ui-sref-active=active ui-sref=\".photosByType({\'type\': fileConst.FILE_STATE_NAME.PENDING, \'page\': 1})\">Pending</li><li ng-if=vm.loginUser.canCurate class=marketplace__top-navigate__item ui-sref-active=active ui-sref=marketplace.photographers.featuredPhotographer translate>{{\'directory\'}}</li><li ng-if=\"vm.loginUser && (vm.loginUser.role === \'admin_internal\')\" class=marketplace__top-navigate__item ui-sref-active=active ui-sref=\".photosByType({\'type\': fileConst.FILE_STATE_NAME.TEMPORARY})\" translate>{{\'temporary\'}}</li><li uib-dropdown navbar-stop-collapse-on-click class=marketplace__top-navigate__item-more><div class=\"marketplace__top-navigate__item-more__btn icon-icons_more\" uib-dropdown-toggle navbar-stop-collapse-on-click></div><ul class=dropdown-menu uib-dropdown-menu role=menu aria-labelledby=single-button><li ng-if=vm.loginUser.canCurate ui-sref-active=active class=\"marketplace__top-navigate__item-more__item dynamic-item-show\" ui-sref=\".photosByType({\'type\': fileConst.FILE_STATE_NAME.PENDING, \'page\': 1})\">Pending Photos</li><li ng-if=vm.loginUser.canCurate ui-sref-active=active class=marketplace__top-navigate__item-more__item ui-sref=\".photosByType({\'type\': fileConst.FILE_STATE_NAME.PENDING_PORTFOLIO, \'page\': 1})\">Pending Portfolio</li><li ng-if=vm.loginUser.canCurate ui-sref-active=active class=marketplace__top-navigate__item-more__item ui-sref=marketplace.pending-submissions>Pending Missions</li><li ng-if=vm.loginUser.canCurate ui-sref-active=active class=marketplace__top-navigate__item-more__item ui-sref=marketplace.rejected-submissions>Rejected Missions</li><li ng-if=vm.loginUser.canCurate ui-sref-active=active class=marketplace__top-navigate__item-more__item ui-sref=\".photosByType({\'type\': fileConst.FILE_STATE_NAME.REJECTED, \'page\': 1})\">Rejected</li><li ng-if=vm.loginUser.canCurate ui-sref-active=active class=marketplace__top-navigate__item-more__item ui-sref=\".photosByType({\'type\': fileConst.FILE_STATE_NAME.GENERAL, \'page\': 1})\">General</li></ul></li></ul></div></div><div ng-if=\"!$state.current.name.split(\'.\').includes(\'galleries\') && !$state.current.name.split(\'.\').includes(\'photographers\')\" class=marketplace__sub-info-navigate scroll-to-fixed=\"{marginTop: 151}\"><div class=marketplace__sub-info-navigate__info-left><div ng-if=\"$state.current.name === \'marketplace.photos\' || $state.current.name === \'marketplace.photosByType\' || $state.current.name === \'marketplace.galleries\' || $state.current.name === \'marketplace.galleriesAll\' || $state.current.name === \'marketplace.pending-submissions\'\" class=marketplace__browse-images><div class=marketplace__browse-images__title>{{\'browse-images\' | translate}}</div></div><li ng-if=\"$state.current.name === \'marketplace.photos\' || $state.current.name === \'marketplace.photosByType\' || $state.current.name === \'marketplace.pending-submissions\'\" class=\"pixerf-filter-bar__menu-item pixerf-filter-bar__menu-item__photo-grid-pager\"><photo-grid-pager unit={{vm.pagerUnit}} total-page=vm.totalPage page=vm.page on-current-page-changed=vm.onCurrentPageChanged(pageNumber) is-shown-num-photos=\"vm.selectedCategories.length > 0\" total-photo-text={{vm.pagerText}}></photo-grid-pager></li></div><ul class=pixerf-filter-bar ng-if=\"$state.current.name === \'marketplace.photos\' || $state.current.name === \'marketplace.photosByType\'\"><li class=pixerf-filter-bar__menu-item ng-class=\"{\'pixerf-filter-bar__menu-item--active\': vm.selectedCategories.length > 0}\"><category-selection-btn settings=vm.categoryBtnSettings selected-model=vm.selectedCategories></category-selection-btn></li></ul></div><section ui-view></section></div>");
$templateCache.put("app/mission-detail-page/mission-detail-page.html","<div class=\"mission-detail-page main__content--md\" ng-class=\"{\'margin-top--1\': isScreenMobile}\"><section class=bg--white><div class=\"marketplace__sub-navigate clearfix\" scroll-to-fixed=vm.fixedSetting><div class=marketplace__sub-navigate__back-btn ng-click=vm.onBackbtnClicked()><span class=\"marketplace__sub-navigate__back-btn__icon text--color-black text--bold\">&lt;</span><span translate=back-to translate-values=\"{name: (\'community-challenges\' | translate)}\"></span></div></div><div class=\"row mission-detail-page__photo-wrapper\" ng-style=\"{\'background-image\': \'url(\' + vm.mission.coverImagePath + \')\'}\" ng-class=\"{\'custom-height\': [121].includes(vm.mission.id), \'custom-position-top\': [125].includes(vm.mission.id)}\"><div class=mission-detail-page__description__details--mobile><div class=mission-detail-page__description__title ng-class=\"{\'max-width-500\' : vm.isCustomMission124}\"><span>{{vm.tmpTranslatedTitle}}</span></div><div class=mission-detail-page__description__text-by translate>{{\'community-challenge-by\'}}</div><div class=\"mission-detail-page__description__author text--bold\">{{vm.mission.sponsor ? vm.mission.sponsor.name : vm.mission.organization.name}}</div></div><div ng-if=[121].includes(vm.mission.id) class=mission-detail-page__photo-wrapper__custom-box-background><div class=mission-detail-page__photo-wrapper__custom-box-background__content>WIN A <span class=highlight-banner>KEYWE DIGITAL LOCK WORTH SGD898</span></div></div><div class=mission-detail-page__description><div class=mission-detail-page__description__logo><img ng-src=\"{{vm.mission.sponsor ? vm.mission.sponsor.logoUrl : vm.mission.organization.profileImageUrl}}\"><div class=mission-detail-page__requirement-note ng-if=\"vm.mission.countries && (vm.mission.countries.length > 0)\"><div class=mission-detail-page__requirement-note__wrap><div class=mission-detail-page__requirement-note__text>{{vm.countriesName}}</div></div></div></div><div class=mission-detail-page__description__details><div class=mission-detail-page__description__title ng-class=\"{\'max-width-500\' : vm.isCustomMission124}\"><span>{{vm.tmpTranslatedTitle}}</span></div><div class=mission-detail-page__description__text-by translate>{{\'community-challenge-by\'}}</div><div class=\"mission-detail-page__description__author text--bold\">{{vm.mission.sponsor ? vm.mission.sponsor.name : vm.mission.organization.name}}</div></div><div class=mission-detail-page__status-wrapper><div class=mission-detail-page__time-remaining ng-if=\"!vm.mission.is_closed && vm.mission.end_date\"><span>{{\'challenge-close-in\' | translate}} </span><pixerf-count-down deadline=vm.mission.end_date></pixerf-count-down></div><div class=\"mission-detail-page__label-status text--bold closed\" ng-if=vm.mission.is_closed translate>{{\'challenge-is-closed\'}}</div><button class=\"mission-detail-page__label-status btn btn-submit\" ng-if=\"!vm.mission.is_closed && (!vm.loginnedUser || vm.loginnedUser.canUploadPhotos)\" ng-class=\"{\'gold-color\': [121].includes(vm.mission.id)}\" authentication-click=vm.onSubmitPhotoClicked() authentication-for=Contributor>{{\'submit-your-photo\' | translate}}</button></div></div><div class=overlay></div></div><div class=pixerf-navigation-bar-wrapper scroll-to-fixed=vm.fixedSetting><ul class=\"pixerf-navigation-bar clearfix\"><button type=button class=\"navbar-toggle collapsed\" data-toggle=collapse data-target=#mission-details-navbar-collapse aria-expanded=false><div class=\"pull-left text--bold\" translate>{{vm.contextPage}}</div><div class=\"pull-right arrow-animation-menu-collapse\"><span class=\"icon-bar dash-one\"></span> <span class=\"icon-bar dash-two\"></span></div></button><li class=\"mission-detail-page__side-items pixerf-filter-bar__menu-item absolute\"><div class=submission__pagination ng-if=\"vm.submissionsCtrl.photoGrid.totalPhotos > 0 && vm.loginnedUser.canManageMission &&  $state.current.name === \'mission-detail-page.submissions\'\"><photo-grid-pager total-photos=vm.submissionsCtrl.photoGrid.totalPhotos total-page=vm.submissionsCtrl.photoGrid.totalPage page=vm.submissionPagination.page on-current-page-changed=vm.onCurrentPageChanged(pageNumber) is-shown-num-photos=true></photo-grid-pager></div></li><div class=\"collapse navbar-collapse pixerf-navbar-text\" id=mission-details-navbar-collapse navbar-collapse-on-click=true><li ui-sref-active=pixerf-navigation-bar__menu-item--active class=pixerf-navigation-bar__menu-item ui-sref=.brief translate>{{\'brief\'}}</li><li ui-sref-active=pixerf-navigation-bar__menu-item--active class=pixerf-navigation-bar__menu-item ui-sref=.visual-inspiration translate>{{\'visual-inspiration\'}}</li><li ui-sref-active=pixerf-navigation-bar__menu-item--active class=pixerf-navigation-bar__menu-item ui-sref=.submissions>{{\'submissions\' | translate}} ({{vm.mission.submissions}})</li><li ui-sref-active=pixerf-navigation-bar__menu-item--active class=pixerf-navigation-bar__menu-item ng-if=vm.loginnedUser.canCurate ui-sref=.pending-submissions-mission>{{\'pending\' | translate}} ({{vm.mission.pending}})</li><li ui-sref-active=pixerf-navigation-bar__menu-item--active class=pixerf-navigation-bar__menu-item ng-if=vm.loginnedUser.canCurate ui-sref=.rejected-submissions-mission>{{\'rejected\' | translate}} ({{vm.mission.rejected}})</li><li ui-sref-active=pixerf-navigation-bar__menu-item--active class=pixerf-navigation-bar__menu-item ng-if=vm.isAwardVisible() ui-sref=.awards translate>{{\'awards\'}}</li></div><button type=button class=\"navbar-toggle collapsed mission-share-btn-collapse\" data-toggle=collapse data-target=#mission-share-navbar-collapse aria-expanded=false ng-if=!vm.isAwardsPage><div class=icon-icons_share></div></button><div class=\"mission-detail-page__share-btn vertical-align-middle--transform collapse navbar-collapse\" navbar-collapse-on-click=true id=mission-share-navbar-collapse ng-if=!vm.isAwardsPage><share settings=\"{\'appendToBody\': true, \'flatMode\': true}\" content-will-be-shared=vm.socialShareContent title=\"Share this mission\"></share></div></ul></div></section><section ui-view></section></div>");
$templateCache.put("app/mission/mission.html","<div class=\"relative mission-page main__content--md\" ng-class=\"{\'margin-top--1\': isScreenMobile}\"><div class=mission-page__navigation-bar-wrapper scroll-to-fixed=vm.fixedSetting><div class=\"mission-page__sub-navigate clearfix\"><div class=mission-page__sub-navigate__title>{{\'explore-missions\' | translate}}:</div><button type=button class=\"navbar-toggle collapsed mission-page__sub-navigate__button\" data-toggle=collapse data-target=#mission-navbar-collapse aria-expanded=false><div class=\"pull-left text--bold mission-page__sub-navigate__label\">{{vm.contextPage}}</div><div class=\"pull-right arrow-animation-menu-collapse mission-page__sub-navigate__icon\"><span class=\"icon-bar dash-one\"></span> <span class=\"icon-bar dash-two\"></span></div></button><div class=\"mission-page__sub-navigate__item-wrapper collapse navbar-collapse clearfix\" id=mission-navbar-collapse navbar-collapse-on-click=true><div class=mission-page__sub-navigate__item ui-sref-active=actived ui-sref=mission.about-mission translate>{{\'about-missions\'}}</div><div class=mission-page__sub-navigate__item ui-sref-active=actived ui-sref=mission.on-going translate>{{\'ongoing\'}}</div><div class=mission-page__sub-navigate__item ui-sref-active=actived ui-sref=mission.mission-joined ng-if=\"vm.loginnedUser && vm.loginnedUser.canJoinMission\" translate>{{\'joined\'}}</div><div class=mission-page__sub-navigate__item ui-sref-active=actived ui-sref=mission.mission-closed translate>{{\'closed\'}}</div><div class=mission-page__sub-navigate__item ui-sref-active=actived ui-sref=mission.mission-agreement translate>{{\'missions-agreement\'}}</div></div></div></div><div class=\"col-md-12 mission-page-wrapper no-padding\" ui-view></div></div>");
$templateCache.put("app/mission-launched-page/mission-launched-page.html","<div class=mission-launched-page><div class=mission-launched-page__icon><img src=assets/images/pixerf-empty-mission.png></div><div class=\"mission-launched-page__mission-name text--semibold text--color-black\">Mission {{vm.mission.title | toTitleCase}}</div><div class=mission-launched-page__description>has been successfully launched! Now sit back and wait for curated submissions to come in.</div><button class=\"mission-launched-page__view-btn btn btn-submit--no-background text--bold\" ng-click=vm.onViewClicked()>View</button></div>");
$templateCache.put("app/model-and-property-releases/model-and-property-releases.html","<div class=model-and-property-releases-page><div class=model-and-property-releases-page__banner photo-details-on-click=82142><div class=model-and-property-releases-page__banner__background></div><div class=model-and-property-releases-page__banner__content><div class=banner-box-intro><div class=\"banner-box-intro__box {{vm.bannerBox.style ? vm.bannerBox.style.styleBackgroundBox : \'\'}}\"><div ng-if=vm.bannerBox.title class=\"banner-box-intro__box__title desktop {{vm.bannerBox.style ? vm.bannerBox.style.styleText : \'\'}}\" ng-bind-html=vm.bannerBox.title></div><div ng-if=vm.bannerBox.title class=\"banner-box-intro__box__title mobile {{vm.bannerBox.style ? vm.bannerBox.style.styleText : \'\'}}\" ng-bind-html=vm.bannerBox.titleMobile></div><div class=banner-box-intro__box__group-btn><a href=assets/files/model_release.pdf class=\"banner-box-intro__box__submit-btn desktop {{vm.bannerBox.style.styleButton}}\">{{vm.bannerBox.buttonText}}</a> <a href=assets/files/property_release.pdf class=\"banner-box-intro__box__submit-btn desktop {{vm.bannerBox.style.styleButton}}\">{{vm.bannerBox.button2ndText}}</a></div></div></div></div></div><section class=\"model-and-property-releases-page__section model-and-property-releases-page__section__what-is-release\"><div class=model-and-property-releases-page__section__title>What is a release?</div><div class=model-and-property-releases-page__section__sub-title>A release is like a consent form. There are two types of releases – model and property.</div><div class=model-and-property-releases-page__section__content><div class=model-and-property-releases-page__section__cover><p class=model-and-property-releases-page__section__paragraph><strong class=text--bold>Model Release: </strong>When a person’s face or likeness is used for commercial purposes, that person must first give consent. If a person is under 18, their parent or legal guardian must give consent.</p><p class=model-and-property-releases-page__section__paragraph><strong class=text--bold>Property Release: </strong>When an image of someone’s private property is used for commercial purposes, the owner(s) must give consent. If the direct owner is not available, a legal representative must give consent.</p></div></div><div class=model-and-property-releases-page__section__sub-title>Releases are a way of ensuring that people’s basic rights to privacy are not violated.</div></section><section class=\"model-and-property-releases-page__section model-and-property-releases-page__section__why-is-release\"><div class=model-and-property-releases-page__section__title>Why are releases important?</div><div class=model-and-property-releases-page__section__content><div class=model-and-property-releases-page__section__cover><p class=model-and-property-releases-page__section__paragraph><strong class=text--bold>If you want your photo to be licensed commercially, you will need to attach the signed release(s).</strong></p></div></div><div class=model-and-property-releases-page__section__sub-title>If there are multiple people or property in your photo, please attach more than one release – one each per person and property.</div><div class=model-and-property-releases-page__section__sub-title><a href=assets/files/model_property_releases.zip><strong class=\"text--color-pixerf-theme text--bold\">Download</strong></a> our PIXERF model and property releases.</div></section><section class=\"model-and-property-releases-page__section model-and-property-releases-page__section__how-can-tell\"><div class=model-and-property-releases-page__section__title>How can I tell if I need a Model or Property release?</div><div class=model-and-property-releases-page__section__content><div class=model-and-property-releases-page__section__cover><p class=model-and-property-releases-page__section__paragraph><strong class=text--bold>Will the person in the photo be able to recognise themselves if they see this photo? </strong><br>If the answer is yes, you need a model release.</p><p class=model-and-property-releases-page__section__paragraph><strong class=text--bold>What does recognisable mean? </strong><br>It’s not as straightforward as being able to see someone’s full-frontal features.<br>A person can be recognisable based on context, location, clothing, tattoos, and other distinct markers.</p></div></div><div class=\"model-and-property-releases-page__section__sub-title desktop\">Here are some examples to help illustrate when you do and do<br>not need to attach a signed release for commercial licensing.</div><div class=\"model-and-property-releases-page__section__sub-title mobile\">Here are some examples to help illustrate when you do and do not need to attach a signed release for commercial licensing.</div></section><section class=\"model-and-property-releases-page__section model-and-property-releases-page__section__model-release\" id=modelReleaseSection><div class=model-and-property-releases-page__section__title>Model Release</div><div class=model-and-property-releases-page__section__release-show><div class=model-and-property-releases-page__section__release-show__category ng-repeat=\"model in vm.modelReleaseData\"><div ng-if=model.category class=model-and-property-releases-page__section__release-show__category__name>{{model.category}}</div><div class=model-and-property-releases-page__section__release-show__category__items><div class=model-and-property-releases-page__section__release-show__item ng-repeat=\"item in model.items\"><div class=model-and-property-releases-page__section__release-show__item__images ng-click=vm.onPhotoCLick(item.id)><img ng-src={{item.imageDesktop}} alt={{item.description}} class=model-and-property-releases-page__section__release-show__item__image-desktop> <img ng-src={{item.imageMobile}} alt={{item.description}} class=model-and-property-releases-page__section__release-show__item__image-mobile></div><div class=model-and-property-releases-page__section__release-show__item__name>{{item.name}}</div><div class=model-and-property-releases-page__section__release-show__item__description>{{item.description}}</div></div></div></div></div></section><section class=\"model-and-property-releases-page__section model-and-property-releases-page__section__property-release\" id=propertyReleaseSection><div class=model-and-property-releases-page__section__title>Property Release</div><div class=model-and-property-releases-page__section__release-show><div class=model-and-property-releases-page__section__release-show__category ng-repeat=\"property in vm.propertyReleaseData\"><div ng-if=property.category class=model-and-property-releases-page__section__release-show__category__name>{{property.category}}</div><div class=model-and-property-releases-page__section__release-show__category__items><div class=model-and-property-releases-page__section__release-show__item ng-repeat=\"item in property.items\"><div class=model-and-property-releases-page__section__release-show__item__images><img ng-src={{item.imageDesktop}} alt={{item.description}} class=model-and-property-releases-page__section__release-show__item__image-desktop> <img ng-src={{item.imageMobile}} alt={{item.description}} class=model-and-property-releases-page__section__release-show__item__image-mobile></div><div class=model-and-property-releases-page__section__release-show__item__name>{{item.name}}</div><div class=model-and-property-releases-page__section__release-show__item__description>{{item.description}}</div></div></div></div></div></section><section class=\"model-and-property-releases-page__section model-and-property-releases-page__section__remember\"><div class=model-and-property-releases-page__section__title>Remember, even if your image cannot be used commercially, it may still be used editorially.</div><div class=model-and-property-releases-page__section__content><div class=model-and-property-releases-page__section__cover><p class=model-and-property-releases-page__section__paragraph><strong class=\"text--bold text--color-pixerf-theme\">Exceptions: </strong><strong class=text--bold>Young children and minors </strong><br>Releases-page-remember-exceptions-young-title-description- Otherwise, all photos with children and minors should be accompanied by model releases, signed by the relevant guardian(s). Our curators review all photos on a case-by-case basis.</p><p class=model-and-property-releases-page__section__paragraph><strong class=\"text--bold text--color-pixerf-theme\">Exceptions: </strong><strong class=text--bold>Ticketed events and locations </strong><br>When a photo is taken inside an event or location that charges for its entry, a property release is always needed, even for editorial use. This is because many of these events and locations often have intellectual property to protect.</p><p>If you have a press pass for the particular event or location, it may also be acceptable in lieu of a property release.</p><br><p><strong>Ticketed events and locations include:</strong><br><ul class=model-and-property-releases-page__section__paragraph__list><li>Concerts and music festivals</li><li>Conventions and trade shows</li><li>Theatre performances</li><li>Museums and art galleries</li><li>Exhibitions that charge for entry</li></ul></p></div></div></section><spinner-win spinner=vm.spinner></spinner-win></div>");
$templateCache.put("app/mission-pending-detail-page/mission-pending-detail-page.html","<div class=\"clearfix none-float horizental-centered\"><div class=mission-pending-detail-page><div class=\"bg--white mission-pending-detail-page__main-contain\"><div class=\"mission-pending-detail-page__back-btn text--semibold\" ng-click=vm.onBackBtnClicked()>&lt Back</div><bread-crumbs on-init=vm.onBreadCrumInit(instance) items=vm.listSteps></bread-crumbs><mission-review mission=vm.mission on-pay=vm.onPay(detail) is-editable=false></mission-review></div></div></div>");
$templateCache.put("app/notification-page/notification-page.html","<div class=\"notification-page relative main__content--md\" ng-class=\"{\'margin-top--1\': isScreenMobile}\"><div scroll-to-fixed=vm.searchFilterBarSettings class=\"relative pixerf-navigation-bar-wrapper navigation-scroll-top\" ng-class=\"{\'pixerf-navigation-bar-position\': isScreenMobile}\"><ul class=pixerf-navigation-bar ng-class=\"{\'no-margin\': isScreenMobile}\"><li ui-sref-active=pixerf-navigation-bar__menu-item--active class=pixerf-navigation-bar__menu-item ui-sref=.notifications>{{\'you\' | translate}}</li><li ui-sref-active=pixerf-navigation-bar__menu-item--active class=pixerf-navigation-bar__menu-item ui-sref=.following>{{\'following\' | translate}}</li></ul></div><section ui-view></section></div>");
$templateCache.put("app/payment-successful-page/payment-successful-page.html","<div class=payment-successful-page><div class=\"payment-successful-page__header clearfix\"><div class=payment-successful-page__icon-wrapper><span class=\"payment-successful-page__icon icon-checked_full_circle text--color-pixerf-theme\"></span></div><div class=\"payment-successful-page__title text--semibold text--color-black\" translate>{{\'payment-successful\'}}</div></div><div class=payment-successful-page__description>You are now ready to launch your Mission.</div><div class=\"payment-successful-page__section mission-details-section\"><div class=payment-successful-page__section-title><div class=\"text--bold text--color-black\">Mission Details <span class=payment-successful-page__section-title__id>ID #{{vm.mission.id}}</span></div><div class=payment-successful-page__section-subtitle></div></div><div class=payment-successful-page__section-content><div class=\"payment-successful-page__section-content__title text--semibold text--color-black\">{{vm.mission.title | toTitleCase}}</div><div class=\"payment-successful-page__section-content__row clearfix\"><div class=payment-successful-page__section-content__row__left>Mission Duration</div><div class=\"payment-successful-page__section-content__row__right text--bold\" ng-bind=\"vm.mission.price.duration === 1 ? vm.mission.price.duration + \' day\' : vm.mission.price.duration + \' days\'\"></div></div><div class=\"payment-successful-page__section-content__row clearfix\"><div class=payment-successful-page__section-content__row__left>Winning Prize(s)</div><div class=\"payment-successful-page__section-content__row__right text--bold\">{{vm.mission.prizes_grouped.WINNER.quantity}}</div></div><div class=\"payment-successful-page__section-content__row clearfix\"><div class=payment-successful-page__section-content__row__left>Special Mention(s)</div><div class=\"payment-successful-page__section-content__row__right text--bold\">{{vm.mission.prizes_grouped.CONSOLATION.quantity}}</div></div></div></div><div class=\"payment-successful-page__section my-credit-section\"><div class=payment-successful-page__section-title><div class=\"text--bold text--color-black\" translate>{{\'my-credits\'}}</div></div><div class=payment-successful-page__section-content><div class=\"payment-successful-page__section-content__row clearfix\"><div class=payment-successful-page__section-content__row__left>Credit Balance as of {{vm.today}}</div><div class=\"payment-successful-page__section-content__row__right text-right\">SGD <span class=text--bold>{{vm.credit_balance | number:2}}</span></div></div><div class=\"payment-successful-page__section-content__row clearfix\"><div class=payment-successful-page__section-content__row__left translate>{{\'mission-service-fee\'}}</div><div class=\"payment-successful-page__section-content__row__right text-right\">-SGD <span class=text--bold>{{vm.service_fee | number:2}}</span></div></div><div class=\"payment-successful-page__section-content__row clearfix\" ng-if=\"vm.mission.price.service_fee && !vm.showAwardOnly\"><div class=\"payment-successful-page__section-content__row clearfix\" ng-repeat=\"discount in vm.mission.price.discounts\" class=clearfix><div class=payment-successful-page__section-content__row__left>{{discount.name}}</div><div class=\"payment-successful-page__section-content__row__right text-right\">+SGD <span class=text--bold>{{discount.amount | number:0}}</span></div></div></div><div class=\"payment-successful-page__section-content__row clearfix\"><div class=payment-successful-page__section-content__row__left translate>{{\'total-prizes\'}}</div><div class=\"payment-successful-page__section-content__row__right text-right\">-SGD <span class=text--bold>{{vm.total_prize | number:2}}</span></div></div><div class=\"payment-successful-page__section-content__last-row clearfix\"><div class=\"payment-successful-page__section-content__last-row__left text--bold\">Remaining Credit Balance</div><div class=\"payment-successful-page__section-content__last-row__right text-right\">SGD <span class=text--bold>{{vm.userCurrentBalance | number:2}}</span></div></div></div></div><mission-move-state-btn mission=vm.mission on-pay=\"vm.onPay({detail: detail})\"></mission-move-state-btn></div>");
$templateCache.put("app/payout-requests-page/payout-requests-page.html","<div class=\"payout-requests-page main__content--md\"><div class=\"payout-requests-page__content clearfix\"><table class=payout-requests-page__table infinite-scroll-disabled=vm.isLastPage infinite-scroll=vm.fetchMorePayouts() infinite-scroll-immediate-check=false><tr class=payout-requests-page__table__header-row><td class=payout-requests-page__table__col>ID</td><td class=payout-requests-page__table__col>Request Date</td><td class=payout-requests-page__table__col>Seller</td><td class=payout-requests-page__table__col>Seller Email</td><td class=payout-requests-page__table__col>Amount</td><td class=payout-requests-page__table__col>State</td><td></td></tr><tr class=payout-requests-page__table__row ng-repeat=\"payout in vm.payouts\"><td class=\"payout-requests-page__table__col payout-requests-page__table__iden-col\">{{payout.id}}</td><td class=\"payout-requests-page__table__col payout-requests-page__table__inserted-at-col\">{{payout.request_date}}</td><td class=\"payout-requests-page__table__col payout-requests-page__table__seller-name-col\">{{payout.seller_name}}</td><td class=\"payout-requests-page__table__col payout-requests-page__table__seller-email-col\">{{payout.seller_email}}</td><td class=\"payout-requests-page__table__col payout-requests-page__table__amount-col\">{{payout.amount}}</td><td class=\"payout-requests-page__table__col payout-requests-page__table__state-col\" ng-class=\"{\'completed\': payout.state === \'completed\'}\">{{payout.state}}</td><td class=payout-requests-page__table__col><button class=\"payout-requests-page__table__submit-btn btn\" ng-class=\"{\'unmark\': payout.state === \'completed\'}\" ng-click=vm.onMarkCompleteClicked(payout)>{{payout.state === \'completed\' ? \'Unmark\' : \'Mark as complete\'}}</button></td></tr><scroll-paging spinner=vm.spinner show-message=\"vm.payouts.length > 0 && vm.searchParams.page > 1\" is-last-page=vm.isLastPage message=\"No more payouts.\"></scroll-paging></table></div></div>");
$templateCache.put("app/photo-page/photo-page.html","<div class=\"relative main__content--md marketplace\" ng-class=\"{\'margin-top--1\': isScreenMobile}\"><div class=\"clearfix relative\"><photo-detail photo-viewer=vm.photoViewer is-edit-mode=vm.isEditing context=\"\'photo-page\'\" photo=vm.photo on-photo-deleted=vm.onDeletePhotoBtnClicked(photo)></photo-detail></div></div>");
$templateCache.put("app/photographer-page/photographer-page.html","<div class=\"relative photographer-page\"><div class=photographer-page__navigation-bar-wrapper><div class=\"photographer-page__item leaderboard\" ui-sref-active=active ui-sref=.leaderboard>Leaderboard</div><div class=\"photographer-page__item featured-photographer\" ui-sref-active=active ui-sref=.featuredPhotographer translate>{{\'featured-photographers\'}}</div></div><section class=relative ui-view></section></div>");
$templateCache.put("app/peoples-page/peoples-page.html","<section class=\"bg-white relative main__content--md peoples-page\" ng-class=\"{\'margin-top--1\': isScreenMobile}\"><div scroll-to-fixed=vm.searchFilterBarSettings class=\"relative pixerf-navigation-bar-wrapper navigation-scroll-top\" ng-class=\"{\'pixerf-navigation-bar-position\': isScreenMobile}\"><ul class=\"pixerf-navigation-bar clearfix\" ng-class=\"{\'no-margin\': isScreenMobile}\"><li class=pixerf-filter-bar__menu-item__floating-left-item><div class=peoples-page__page-title-wrapper><div class=peoples-page__page-title__user><a ui-sref=\"user-home-page.personal.home({id: vm.user.id, userName: (vm.user.displayName | toSnakeCase)})\" class=peoples-page__page-title__user__avatar><pixerf-user-avatar user-data=vm.user lazy=true></pixerf-user-avatar></a><a ui-sref=\"user-home-page.personal.home({id: vm.user.id, userName: (vm.user.displayName | toSnakeCase)})\" class=\"peoples-page__page-title__user__name text--semibold text--color-black text--truncate\" ng-bind=\"vm.loginUser.id == vm.searchParams.personId ? \'You\' : vm.user.displayName\"></a></div></div></li><button type=button class=\"navbar-toggle collapsed\" data-toggle=collapse data-target=#introduction-navbar-collapse aria-expanded=false><div class=\"pull-left text--bold\" ng-bind=\"vm.searchParams.action === \'followers\' && vm.user.stats.follower_count === 1 ? vm.user.stats.follower_count + \' Follower\' : vm.searchParams.action === \'followers\' ? vm.user.stats.follower_count + \' Followers\' : vm.user.stats.following_count + \' Following\'\"></div><div class=\"pull-right arrow-animation-menu-collapse\"><span class=\"icon-bar dash-one\"></span> <span class=\"icon-bar dash-two\"></span></div></button><div class=\"collapse navbar-collapse pixerf-navbar-text\" navbar-collapse-on-click=true id=introduction-navbar-collapse><li ui-sref-active=pixerf-navigation-bar__menu-item--active class=pixerf-navigation-bar__menu-item ui-sref=\"peoples-page.byAffections({userId: vm.searchParams.personId, affectionType: \'followers\'})\"><a><span class=\"pixerf-navigation-bar__menu-item--figure text--semibold\">{{vm.user.stats.follower_count}}</span>{{vm.user.stats.follower_count === 1 ? \'Follower\' : \'Followers\'}}</a></li><li ui-sref-active=pixerf-navigation-bar__menu-item--active class=pixerf-navigation-bar__menu-item ui-sref=\"peoples-page.byAffections({userId: vm.searchParams.personId, affectionType: \'followings\'})\"><a><span class=\"pixerf-navigation-bar__menu-item--figure text--semibold\">{{vm.user.stats.following_count}}</span>Following</a></li><li class=\"pixerf-filter-bar__menu-item__floating-right-item vertical-align-middle--transform\"><div class=\"relative peoples-page__search-wrapper\"><input ng-model=vm.searchString ng-change=vm.onSearchStringChanged() class=\"form-control search-input\" type=text placeholder=\"Search people...\"> <span class=\"peoples-page__search-wrapper__search-icon glyphicon glyphicon-search vertical-align-middle--transform\"></span></div></li></div></ul></div><ui-view></ui-view><scroll-to-top></scroll-to-top></section>");
$templateCache.put("app/portfolio-detail-page/portfolio-detail-page.html","<div><div ui-view></div></div>");
$templateCache.put("app/referral-congrat-page/referral-congrat-page.html","<section class=\"referral-congrat-page clearfix\"><div class=\"referral-congrat-page__content clearfix\"><div class=\"referral-congrat-page__content__wrapper col-sm-offset-1 col-sm-6 col-md-offset-1 col-md-4\"><div class=\"referral-congrat-page__content__header text--bold\">Congratulations!</div><div class=\"referral-congrat-page__content__subheader text--bold\">You\'ve unlocked bigger earnings by joining PIXERF\'s referral programme</div><div class=referral-congrat-page__content__description>You and your friends can now enjoy the opportunities and benefits of higher payouts from our Marketplace.</div><button class=\"btn btn-submit referral-congrat-page__content__next-btn text--bold\" ng-click=vm.onNextBtnClicked()>Upload and Earn Now</button></div></div></section>");
$templateCache.put("app/referral-program-landing-page/referral-program-landing-page.html","<div class=\"referral-program-landing-page no-margin\"><div class=\"referral-program-landing-page__wrapper clearfix\"><section class=\"row about-page-branding-wrapper clearfix\"><div class=referral-program-landing-page__showcase-items><div class=referral-program-landing-page__showcase-background></div><div class=\"overlay text-center\"><div class=referral-program-landing-page__showcase-icon></div><h1 class=\"referral-program-landing-page__showcase-title col-xs-12 text--bold\">Invite friends and earn!</h1><div class=referral-program-landing-page__showcase-description-question>PIXERF\'s referral programme gives both you and your friends bonus earnings from their photo sales. The more friends you refer, the more you earn!</div><div class=referral-program-landing-page__showcase-description-question>This programme is premiere plan exclusively for PIXERF Ambassadors and Featured Photographers at themoment.</div><button class=\"btn referral-program-landing-page__showcase-btn text--bold text--color-pixerf-theme\">Get Started</button><photo-info-link photo=vm.brandingPhoto></photo-info-link></div></div></section><section class=\"row referral-program-landing-page__benefits clearfix\"><div class=\"referral-program-landing-page__benefits__main-content col-xs-12 clearfix\"><div class=\"referral-program-landing-page__benefits__blockcontent col-xs-12 no-padding\"><h3 class=\"referral-program-landing-page__benefits__blockcontent__title text--color-black text--bold\">How it works</h3><div class=\"referral-program-landing-page__benefits__blockcontent__description clearfix\"><div class=\"referral-program-landing-page__benefits__blockcontent__description__item-wrapper col-sm-3\"><div class=\"fake-icon referral-icon circle-coin-icon\"></div><div class=referral-program-landing-page__benefits__blockcontent__description__detail><span class=\"text--bold text--color-black\">Earn 10%</span> from each photo sold of every photographer you refer</div></div><div class=\"referral-program-landing-page__benefits__blockcontent__description__item-wrapper col-sm-3\"><div class=\"fake-icon referral-icon switch-icon\"></div><div class=referral-program-landing-page__benefits__blockcontent__description__detail><span class=\"text--bold text--color-black\">No limit</span> to how many photographers you can refer</div></div><div class=\"referral-program-landing-page__benefits__blockcontent__description__item-wrapper col-sm-3\"><div class=\"fake-icon referral-icon track-icon\"></div><div class=referral-program-landing-page__benefits__blockcontent__description__detail><span class=\"text--bold text--color-black\">Track your earnings</span> easily through your account and cash out anytime</div></div><div class=\"referral-program-landing-page__benefits__blockcontent__description__item-wrapper col-sm-3\"><div class=\"fake-icon referral-icon circle-percent-icon\"></div><div class=referral-program-landing-page__benefits__blockcontent__description__detail><span class=\"text--bold text--color-black\">Bonus earnings</span> run for 12 months from the time a referree signs up</div></div></div><button class=\"btn btn-submit text--bold referral-program-landing-page__get-started-btn\">Get Started</button></div></div></section><section class=\"row referral-program-landing-page__referring clearfix\"><div class=\"referral-program-landing-page__title referral-program-landing-page__referring__title text--bold text--color-black col-xs-12\">Refer your friends and earn today!</div><button class=\"btn referral-program-landing-page__referring__btn btn-submit text--bold\" ng-click=vm.onSigninClicked()>Start Earning</button><div class=referral-program-landing-page__referring__description><div class=referral-program-landing-page__referring__description__read-more>Read more about referral eligibility in our <a href=\"\" class=\"text--color-pixerf-theme text--bold\">Referrals Terms and Conditions</a></div></div></section><section class=\"row referral-program-landing-page__faq clearfix\"><p class=\"referral-program-landing-page__faq__heading text--bold text--color-black\">FAQ</p><div class=\"referral-program-landing-page__faq__info-form clearfix\"><div class=form-group><div class=referral-program-landing-page__faq__section><div class=referral-program-landing-page__faq__section__wrapper><h1 class=referral-program-landing-page__faq__section__title>How does the PIXERF referral programme work?</h1></div></div><div class=referral-program-landing-page__faq__section><div class=referral-program-landing-page__faq__section__wrapper><h1 class=referral-program-landing-page__faq__section__title>What benefits do I get through the referral programme?</h1></div></div><div class=referral-program-landing-page__faq__section><div class=referral-program-landing-page__faq__section__wrapper><h1 class=referral-program-landing-page__faq__section__title>Do the people I invite to the platform get any benefits?</h1></div></div><div class=referral-program-landing-page__faq__section><div class=referral-program-landing-page__faq__section__wrapper><h1 class=referral-program-landing-page__faq__section__title>Who qualifies for the referral programme?</h1></div></div><div class=referral-program-landing-page__faq__section><div class=referral-program-landing-page__faq__section__wrapper><h1 class=referral-program-landing-page__faq__section__title>How long does this referral programme last?</h1></div></div><div class=referral-program-landing-page__faq__section><div class=referral-program-landing-page__faq__section__wrapper><h1 class=referral-program-landing-page__faq__section__title>Can I invite existing users to my referral network?</h1></div></div><div class=referral-program-landing-page__faq__section><div class=referral-program-landing-page__faq__section__wrapper><h1 class=referral-program-landing-page__faq__section__title>When can I cash out my referral earnings?</h1></div></div><div class=referral-program-landing-page__faq__section><div class=referral-program-landing-page__faq__section__wrapper><h1 class=referral-program-landing-page__faq__section__title>What happens when one of the photographers I invited decides to cancel his or her account?</h1></div></div></div></div></section></div></div>");
$templateCache.put("app/referral-program-page/referral-program-page.html","<div class=\"referral-program-page no-margin\"><div class=\"referral-program-page__wrapper clearfix\"><section class=\"row about-page-branding-wrapper clearfix\"><div class=referral-program-page__showcase-items><div class=referral-program-page__showcase-background></div><div class=overlay><h1 class=\"referral-program-page__showcase-title col-xs-12 text--bold\">Give your friends the gift of opportunity</h1><button ng-click=vm.onSigninClicked() class=\"btn btn-submit referral-program-page__showcase__btn text--bold\">Invite Photographers</button><div class=\"referral-program-page__showcase-description col-md-6\">Join our referral programme and invite your friends to join PIXERF today! They will be able to sign up for free and start creating income from their passion in photography.</div><div class=referral-program-page__showcase-description-question>You will also earn 10% from each photo sold by photographers you invite. Offer is valid for 6 months.</div><photo-info-link photo=vm.brandingPhoto></photo-info-link></div></div></section><section class=\"row referral-program-page__intro-invite\"><div class=\"referral-program-page__intro-invite__title referral-program-page__title text--bold text--color-black col-xs-12\">Win &ndash; Win</div><div class=referral-program-page__intro-invite__description>Invite photographers over to PIXERF. You earn from each photo they sell (no limit) and they can start to license their images on our Marketplace, take part in cool Missions or projects of any scale in Custom Commissions.</div><div class=referral-program-page__intro-invite__description>Best of all, there is no limit to how many you can invite. The more you invite, the more you earn.</div></section><section class=\"row referral-program-page__how-it-works clearfix\"><div class=\"referral-program-page__how-it-works__title referral-program-page__title text--bold text--color-black col-xs-12\">How it works</div><div class=\"referral-program-page__how-it-works__main-content col-xs-12 clearfix\"><div class=\"referral-program-page__how-it-works__blockcontent col-sm-4\"><div class=\"referral-program-page__how-it-works__blockcontent__icon clearfix\"><div class=referral-program-page__how-it-works__blockcontent__icon__share></div></div><h3 class=\"referral-program-page__how-it-works__blockcontent__title text--color-black text--bold\">Invite</h3><h4 class=referral-program-page__how-it-works__blockcontent__description>Simply fill in their email address in the drop-down menu and voila! Your invite has been sent.</h4><div class=referral-program-page__dash-devide></div></div><div class=\"referral-program-page__how-it-works__blockcontent col-sm-4\"><div class=\"referral-program-page__how-it-works__blockcontent__icon clearfix\"><div class=referral-program-page__how-it-works__blockcontent__icon__track></div></div><h3 class=\"referral-program-page__how-it-works__blockcontent__title text--color-black text--bold\">Track</h3><h4 class=referral-program-page__how-it-works__blockcontent__description>You can track which of your friends have accepted your invitation through our easy&ndash;to&ndash;use system.</h4><div class=referral-program-page__dash-devide></div></div><div class=\"referral-program-page__how-it-works__blockcontent col-sm-4\"><div class=\"referral-program-page__how-it-works__blockcontent__icon clearfix\"><div class=referral-program-page__how-it-works__blockcontent__icon__earn></div></div><h3 class=\"referral-program-page__how-it-works__blockcontent__title text--color-black text--bold\">Earn</h3><h4 class=referral-program-page__how-it-works__blockcontent__description>Track your earnings through our portal. Cash out anytime you like.</h4></div></div></section><section class=\"row referral-program-page__referring clearfix\"><div class=\"referral-program-page__title referral-program-page__referring__title text--bold text--color-black col-xs-12\">Start referring today</div><button class=\"btn btn-submit referral-program-page__referring__btn text--bold\" ng-click=vm.onSigninClicked()>Invite Now</button><div class=referral-program-page__referring__description><div class=referral-program-page__referring__description__read-more>For more information, please read our <a href=\"\" class=\"text--color-pixerf-theme text--bold\">Referrals Terms and Conditions</a></div><div ng-if=!vm.loginUser>Don\'t have an account yet? <span ng-click=vm.onSignUpClicked() class=\"text--color-pixerf-theme text--bold\">Sign up</span> to PIXERF now.</div></div></section></div></div>");
$templateCache.put("app/referral-start-earning-page/referral-start-earning-page.html","<section class=\"referral-start-earning-page clearfix\"><div class=\"referral-start-earning-page__content clearfix\"><div class=\"referral-start-earning-page__content__wrapper col-sm-offset-1 col-sm-6 col-md-offset-1 col-md-4\"><div class=\"referral-start-earning-page__content__header text--bold\">Sign up now and earn 60% from each photo you upload and licence on our marketplace.<br><br>Upload as many as you want and there is no limit to how many times each photo can be sold.</div><div class=referral-start-earning-page__content__description>Start earning more from your passion today!</div><button ng-click=vm.onSignupClicked() class=\"btn btn-submit referral-start-earning-page__content__start-btn text--bold\">Start Earning</button><div class=\"referral-start-earning-page__content__learn-more text--bold\">Want to learn more? <span>Click here</span></div></div></div></section>");
$templateCache.put("app/run-a-challenge-page/run-a-challenge-page.html","<div class=run-a-challenge-page><div class=run-a-challenge-page__top-navigation dynamic-show-hide-scroll scroll-down-class=hide-on-mobile><div class=run-a-challenge-page__top-navigation__overlay></div><div class=run-a-challenge-page__top-navigation__header><!-- <div class=\"run-a-challenge-page__top-navigation__title\">Explore Challenges:</div> --> <button type=button class=\"run-a-challenge-page__top-navigation__button navbar-toggle collapsed\" data-toggle=collapse data-target=#runAChallange aria-expanded=false><div class=run-a-challenge-page__top-navigation__current-state>{{vm.contextPage}}</div><div class=\"run-a-challenge-page__top-navigation__icon arrow-animation-menu-collapse\"><span class=\"icon-bar dash-one\"></span> <span class=\"icon-bar dash-two\"></span></div></button><div id=runAChallange class=\"run-a-challenge-page__top-navigation__list navbar-collapse collapse\" navbar-collapse-on-click=true><div class=run-a-challenge-page__top-navigation__item ui-sref-active=actived ui-sref=run-a-challenge-page.about-challenge>Explore Challenges</div><div class=run-a-challenge-page__top-navigation__item ui-sref-active=actived ui-sref=run-a-challenge-page.live-challenges>Live Challenges</div><div ng-if=\"vm.loginnedUser && vm.loginnedUser.canJoinMission\" class=run-a-challenge-page__top-navigation__item ui-sref-active=actived ui-sref=run-a-challenge-page.joined-challenges>Joined Challenges</div><div class=run-a-challenge-page__top-navigation__item ui-sref-active=actived ui-sref=run-a-challenge-page.past-challenges>Past Challenges</div><div ng-if=\"!vm.loginnedUser || !vm.loginnedUser.isBiz\" class=run-a-challenge-page__top-navigation__item ui-sref-active=actived ui-sref=run-a-challenge-page.community-challenge-agreement translate>Challenge Agreement</div><div ng-if=\"vm.loginnedUser && vm.loginnedUser.isBiz\" class=run-a-challenge-page__top-navigation__item ui-sref-active=actived ui-sref=run-a-challenge-page.challenge-sponsor-agreement translate>Challenge Sponsor Agreement</div></div></div></div><section ui-view class=run-a-challenge-page__main-content></section></div>");
$templateCache.put("app/send-verify-email-page/send-verify-email-page.html","<div class=send-verify-email-page><div class=\"send-verify-email-page__content clearfix\"><div class=\"send-verify-email-page__wrapper clearfix\"><div class=send-verify-email-page__icon></div><div class=\"send-verify-email-page__description clearfix\"><div class=\"send-verify-email-page__title text--bold\">Check your email</div><div class=send-verify-email-page__description>Click the link in the email we sent you to confirm your registration {{vm.isWorking}}</div></div><div class=\"send-verify-email-page__control clearfix\"><input type=text class=send-verify-email-page__input readonly=readonly ng-model=vm.loginnedUser.email> <button class=\"btn btn-submit send-verify-email-page__send-email-btn text--bold\" ng-disabled=vm.isWorking ng-click=vm.onResendEmailClicked() ng-class=\"{\'is-working\': vm.isWorking}\"><i class=\"fa fa-2x fa-spin fa-spinner\"></i>Resend Email</button></div></div></div></div>");
$templateCache.put("app/setting/setting.html","<div class=\"setting main__content--md\" ng-class=\"{\'margin-top--1\': isScreenMobile}\"><div class=setting__col-left><div scroll-to-fixed=vm.dashboardNavigationOptions><div class=setting__authentication><div class=setting__authentication__avatar ng-class=\"{\'personal-user\': vm.user.account_type === \'personal\'}\"><a ui-sref=user-home-page.homepage href=# ng-if=!vm.updatingdAvatar><pixerf-user-avatar class=pull-left user-data=vm.user lazy=true></pixerf-user-avatar></a></div><div class=setting__authentication__name>{{vm.user.displayName}}</div><div class=setting__authentication__type>{{vm.user.isBiz ? \'Business\' : \'Creator\'}}</div></div><div class=setting__navigation><ul class=setting__navigation__bar><button type=button class=\"navbar-toggle collapsed\" data-toggle=collapse data-target=#setting-navbar-collapse aria-expanded=false><div class=\"pull-left text--bold\" translate>{{vm.contextPage}}</div><div class=\"pull-right arrow-animation-menu-collapse\"><span class=\"icon-bar dash-one\"></span> <span class=\"icon-bar dash-two\"></span></div></button><div class=\"collapse navbar-collapse\" navbar-collapse-on-click=true id=setting-navbar-collapse><div class=setting__navigation__list-group__account-section><div class=setting__navigation__list-group__header>Account</div><a ui-sref-active=list-group-item--active ui-sref={{vm.editProfileRoute.data}} class=setting__navigation__list-group-item translate translate-values=\"{name: (\'profile\' | translate)}\">{{\'edit\'}}</a> <a ng-if=vm.isAbleToChangePassword ui-sref-active=list-group-item--active ui-sref=.change-password class=setting__navigation__list-group-item translate>{{\'change-password\'}}</a> <a ng-if=vm.loginedUser.isContributor ui-sref-active-class=list-group-item--active ui-sref-active-if=setting.purchase-history ui-sref=.purchase-history.order-list class=setting__navigation__list-group-item>{{\'purchase-history\' | translate}}</a> <a ng-if=!vm.loginedUser.isContributor ui-sref-active-class=list-group-item--active ui-sref-active-if=setting.purchase-history ui-sref=setting.purchase-history.custom-content-assignment class=setting__navigation__list-group-item>{{\'purchase-history\' | translate}}</a> <a ui-sref-active=list-group-item--active ui-sref=.my_credit ng-if=\"(vm.user.isTrialUser || vm.user.canBuyCreditPlan) && !vm.guestUser\" class=setting__navigation__list-group-item>{{\'my-credits\' | translate}}</a> <a ui-sref-active-class=list-group-item--active ui-sref=.earnings.my_earnings.images_sold ui-sref-active-if=setting.earnings class=setting__navigation__list-group-item ng-if=\"vm.user.canManageEarning && !vm.guestUser\">{{\'earnings\' | translate}}</a></div><div class=setting__navigation__list-group__manage-section><div class=setting__navigation__list-group__header>Manage</div><a ui-sref-active-class=list-group-item--active ui-sref-active-if=setting.manage-photos ui-sref=setting.manage-photos.pending-review class=setting__navigation__list-group-item ng-if=\"!vm.user.isBiz && !vm.guestUser\">{{\'photos\' | translate}}</a> <a ui-sref-active-class=list-group-item--active ui-sref=setting.manage-custom-commissions.on-going ui-sref-active-if=setting.manage-custom-commissions class=setting__navigation__list-group-item>{{\'custom-content-assignments\' | translate}}</a><div ng-if=\"vm.user.isContributor && !vm.guestUser\" class=setting__navigation__sublist-toggle><div data-toggle=collapse data-target=#contributor-challenge-collapse aria-expanded=true class=setting__navigation__sublist-toggle__header ng-class=\"{\'actived\': $state.includes(\'setting.manage-photos-mission\')}\" ng-click=vm.onContributorChallengesClicked()>{{\'community-challenges\' | translate}}</div><div id=contributor-challenge-collapse class=\"setting__navigation__sublist-toggle__list collapse in\"><a class=setting__navigation__sublist-toggle__item ui-sref-active=actived ui-sref=setting.manage-photos-mission.pending>In Review</a> <a class=setting__navigation__sublist-toggle__item ui-sref-active=actived ui-sref=setting.manage-photos-mission.approved>Approved</a> <a class=setting__navigation__sublist-toggle__item ui-sref-active=actived ui-sref=setting.manage-photos-mission.rejected>Rejected</a> <a class=setting__navigation__sublist-toggle__item ui-sref-active=actived ui-sref=setting.manage-photos-mission.awards>Awards</a></div></div><div ng-if=\"vm.user.canManageMission && !vm.guestUser\" class=setting__navigation__sublist-toggle><div data-toggle=collapse data-target=#contributor-challenge-collapse aria-expanded=true class=setting__navigation__sublist-toggle__header ng-class=\"{\'actived\': $state.includes(\'setting.manage-missions\')}\" authentication-click=vm.onManageMissionClicked() check-verified-email=true>{{\'community-challenges\' | translate}}</div><div id=contributor-challenge-collapse class=\"setting__navigation__sublist-toggle__list collapse in\"><a ng-if=vm.canCreateMission class=setting__navigation__sublist-toggle__item ui-sref-active=actived ui-sref=\"setting.manage-missions.create-mission.getting-started({id: \'\'})\">{{\'create-challenge\' | translate}}</a> <a ng-if=vm.canCreateMission class=setting__navigation__sublist-toggle__item ui-sref-active=actived ui-sref=setting.manage-missions.draft.list-mission-draft>{{\'unpublished\' | translate}}</a> <a class=setting__navigation__sublist-toggle__item ui-sref-active=actived ui-sref=setting.manage-missions.on-going>Ongoing</a> <a class=setting__navigation__sublist-toggle__item ui-sref-active=actived ui-sref=setting.manage-missions.mission-closed>Closed</a></div></div><div ng-if=vm.user.canVerifyBusinessUser authentication-click=vm.onUserVerificationClicked() check-verified-email=true class=setting__navigation__sublist-toggle><div data-toggle=collapse data-target=#user-verification-collapse aria-expanded=true class=setting__navigation__sublist-toggle__header ng-class=\"{\'actived\': $state.includes(\'setting.user-verification\')}\">{{\'user-verification\' | translate}}</div><div id=user-verification-collapse class=\"setting__navigation__sublist-toggle__list collapse in\"><a class=setting__navigation__sublist-toggle__item ui-sref-active=actived ui-sref=setting.user-verification.sign-up>New sign-up</a> <a class=setting__navigation__sublist-toggle__item ui-sref-active=actived ui-sref=setting.user-verification.pending-response>Pending user response</a> <a class=setting__navigation__sublist-toggle__item ui-sref-active=actived ui-sref=setting.user-verification.responded>Responded users</a> <a class=setting__navigation__sublist-toggle__item ui-sref-active=actived ui-sref=setting.user-verification.verified>Verified users</a></div></div><div ng-if=vm.user.canCreateMediaPixerf class=setting__navigation__sublist-toggle><div data-toggle=collapse data-target=#media-pixerf-collapse aria-expanded=true class=setting__navigation__sublist-toggle__header ng-class=\"{\'actived\': $state.includes(\'setting.manage-media-post\')}\" ng-click=vm.onManageMediaPostClicked()>{{\'media\' | translate}}</div><div id=media-pixerf-collapse class=\"setting__navigation__sublist-toggle__list collapse in\"><a class=setting__navigation__sublist-toggle__item ui-sref-active=actived ui-sref=setting.manage-media-post.create-post>Create Post</a> <a class=setting__navigation__sublist-toggle__item ui-sref-active=actived ui-sref=setting.manage-media-post.published>Published</a></div></div><a href=\"\" class=setting__navigation__subnavbar-toggle ng-class=\"{\'actived\': $state.includes(\'setting.manage-communities\') || $state.includes(\'setting.manage-events\') || $state.includes(\'setting.manage-reports\')}\"><button type=button data-toggle=collapse data-target=#community-navbar-collapse aria-expanded=true><div class=setting__navigation__sub-header translate>{{\'community-hub\'}}</div></button></a><div class=\"setting__navigation__subnavbar-toggle__navbar-toggle collapse in\" id=community-navbar-collapse><div class=setting__navigation__sub-list-group><div class=setting__navigation__hub-collapse><a ng-if=!vm.guestUser class=setting__navigation__hub-collapse__header ng-class=\"{\'actived\': $state.includes(\'setting.manage-communities\')}\"><div data-toggle=collapse data-target=#community-collapse aria-expanded=true>{{\'communities\' | translate}}</div></a><div id=community-collapse class=\"setting__navigation__hub-collapse__list collapse in\"><a ng-if=vm.isAdmin class=setting__navigation__hub-collapse__item ui-sref-active=actived ui-sref=setting.manage-communities.manage-pending-approval-communities>Pending Approval</a> <a ng-if=vm.isAdmin class=setting__navigation__hub-collapse__item ui-sref-active=actived ui-sref=setting.manage-communities.manage-action-required-communities>Action Required</a> <a ng-if=vm.isAdmin class=setting__navigation__hub-collapse__item ui-sref-active=actived ui-sref=setting.manage-communities.manage-active-communities>Active</a> <a ng-if=vm.isAdmin class=setting__navigation__hub-collapse__item ui-sref-active=actived ui-sref=setting.manage-communities.manage-inreview-communities>In Review</a> <a ng-if=vm.isAdmin class=setting__navigation__hub-collapse__item ui-sref-active=actived ui-sref=setting.manage-communities.manage-deactivated-communities>Deactivated</a> <a class=setting__navigation__hub-collapse__item ui-sref-active=actived ui-sref=setting.manage-communities.communities>Your Communities</a> <a ng-if=!vm.user.isBiz class=\"setting__navigation__hub-collapse__item setting__navigation__hub-collapse__item__have-label\" ui-sref-active=actived ui-sref=setting.manage-communities.manage-invited-communities><div>Invited</div><div ng-if=\"vm.user.stats && vm.user.stats.total_invited_communities\" class=setting__navigation__hub-collapse__item__highlight-label>{{vm.user.stats.total_invited_communities}}</div></a><a ng-if=!vm.user.isBiz class=setting__navigation__hub-collapse__item ui-sref-active=actived ui-sref=setting.manage-communities.manage-requested-communities>Requested</a> <a ng-if=vm.user.canManageCommunity class=\"setting__navigation__hub-collapse__item setting__navigation__hub-collapse__item__have-label\" ui-sref-active=actived ui-sref=setting.manage-communities.manage-pending-communities><div>Pending</div><div ng-if=\"vm.user.stats && vm.user.stats.total_pending_communities\" class=setting__navigation__hub-collapse__item__highlight-label>{{vm.user.stats.total_pending_communities}}</div></a></div></div><div class=setting__navigation__hub-collapse><a ng-if=!vm.guestUser class=setting__navigation__hub-collapse__header ng-class=\"{\'actived\': $state.includes(\'setting.manage-events\')}\"><div data-toggle=collapse data-target=#event-collapse aria-expanded=true>{{\'events\' | translate}}</div></a><div id=event-collapse class=\"setting__navigation__hub-collapse__list collapse in\"><a ng-if=!vm.user.isBiz class=setting__navigation__hub-collapse__item ui-sref-active=actived ui-sref=setting.manage-events.manage-going-events>Going</a> <a ng-if=!vm.user.isBiz class=\"setting__navigation__hub-collapse__item setting__navigation__hub-collapse__item__have-label\" ui-sref-active=actived ui-sref=setting.manage-events.manage-invited-events><div>Invited</div><div ng-if=\"vm.user.stats && vm.user.stats.total_invited_events\" class=setting__navigation__hub-collapse__item__highlight-label>{{vm.user.stats.total_invited_events}}</div></a><a ng-if=!vm.user.isBiz class=setting__navigation__hub-collapse__item ui-sref-active=actived ui-sref=setting.manage-events.manage-interested-events>Interested</a> <a ng-if=vm.user.canManageCommunity class=setting__navigation__hub-collapse__item ui-sref-active=actived ui-sref=setting.manage-events.manage-hosting-events>Hosting</a> <a ng-if=vm.user.canManageCommunity class=\"setting__navigation__hub-collapse__item setting__navigation__hub-collapse__item__have-label\" ui-sref-active=actived ui-sref=setting.manage-events.manage-draft-events><div>Drafts</div><div ng-if=\"vm.user.stats && vm.user.stats.total_draft_events\" class=setting__navigation__hub-collapse__item__highlight-label>{{vm.user.stats.total_draft_events}}</div></a><a class=setting__navigation__hub-collapse__item ui-sref-active=actived ui-sref=setting.manage-events.manage-past-events>Past Events</a> <a ng-if=vm.isAdmin class=\"setting__navigation__hub-collapse__item setting__navigation__hub-collapse__item__have-label\" ui-sref-active=actived ui-sref=setting.manage-events.manage-in-review-events><div>{{\'in-review\' | translate}}</div><div ng-if=\"vm.user.stats && vm.user.stats.total_draft_events\" class=setting__navigation__hub-collapse__item__highlight-label>{{vm.user.stats.total_inreview_events}}</div></a></div></div></div></div></div></div></ul></div></div></div><div class=setting__col-right><div class=setting__main-content ui-view></div></div></div>");
$templateCache.put("app/sign-in-page/sign-in-page.html","<div class=sign-in-page><sign-in-user></sign-in-user></div>");
$templateCache.put("app/sign-in-popup/sign-in-popup.html","<div class=sign-in-popup><button type=button class=close ng-click=vm.cancel()><span class=icon-icons_close aria-hidden=true></span></button><sign-in-user custom-signup-text=\"Don’t have a Business Account\" before-signin=vm.beforeSignin(user) options=vm.options hidden-login-by-social=true custom-signup-header-text=\"{{vm.isBiz ? \'Log in as a Business\' : \'\'}}\"></sign-in-user></div>");
$templateCache.put("app/signature-galleries-details-page/signature-galleries-details-page.html","<section class=\"signature-galleries-details-page bg--white relative main__content--md\"><div class=signature-galleries-details-page__sub-navigate><div class=signature-galleries-details-page__sub-navigate__back-btn ng-click=vm.onBackBtnClicked()><span class=\"signature-galleries-details-page__sub-navigate__back-btn__icon text--color-black text--bold\">&lt;</span><span translate=back-to translate-values=\"{name: vm.fromExplore ? \'Explore Stock\' : \'Signature Galleries\'}\"></span></div></div><div class=signature-galleries-details-page__header id=pagingBar scroll-to-fixed=vm.pagingBarSetting dynamic-show-hide-scroll scroll-down-class=paging-on-mobile><div class=\"signature-galleries-details-page__control mobile\"><mutiline-dropdown ng-if=vm.galleries.length items=vm.galleries selected=vm.defaultGalleries on-changed=vm.onGalleriesChanged(data) hide-check-icon=true></mutiline-dropdown></div><div class=signature-galleries-details-page__header-row><div class=signature-galleries-details-page__header__title>{{vm.category.title | toTitleCase}}</div><div class=signature-galleries-details-page__control><mutiline-dropdown ng-if=vm.galleries.length items=vm.galleries selected=vm.defaultGalleries on-changed=vm.onGalleriesChanged(data) hide-check-icon=true></mutiline-dropdown><div class=signature-galleries-details-page__photo-grid-pager><photo-grid-pager unit={{vm.pagerUnit}} total-page=vm.totalPage page=vm.page on-current-page-changed=vm.onCurrentPageChanged(pageNumber) is-shown-num-photos=false total-photo-text={{vm.pagerText}}></photo-grid-pager></div></div></div></div><div class=signature-galleries-details-page__main-content><photo-grid context=\"\'MARKET_PLACE\'\" instance=vm.photoGrid on-load-more-page=vm.onLoadMorePage(page) on-scroll-to-photo=vm.onScrollToPhoto(page)><div class=\"text-center marketplace__no-result-message\"><span class=icon-icons_search></span><h3 class=\"text-semibold no-message-notice text--semibold text--color-black\" translate>{{\'no-photos-found\'}}</h3></div></photo-grid></div></section>");
$templateCache.put("app/trend-report-landing-page/trend-report-landing-page.html","<div class=\"trend-report-landing-page no-margin\"><div class=trend-report-landing-page__section1__background-image></div><div class=trend-report-landing-page__section1__background-color></div><section class=\"trend-report-landing-page__section1 clearfix\"><div class=\"trend-report-landing-page__section1__logo col-xs-12 row\"><a href=#><img class=trend-report-landing-page__section1__logo-image src=\"../../assets/images/trend-report/PIXERF logo.svg\" alt=\"PIXERF logo\"></a></div><div class=\"trend-report-landing-page__section1__text col-md-12 row\"><div class=trend-report-landing-page__section1__header><img class=trend-report-landing-page__section1__header__right src=\"../../assets/images/trend-report/TRENDS SPOTTING 2021.svg\" alt=\"trend spotting 2021\"> <img class=trend-report-landing-page__section1__header__left src=\"../../assets/images/trend-report/GOODBYE 2020 HELLO 2021.svg\" alt=goodbye2020></div><div class=trend-report-landing-page__section1__desc><div class=trend-report-landing-page__section1__desc__text>Not just another trend report. Preview Asia’s creative future. Download and get two in one. For free.</div><button ng-click=vm.scrollToSubmitForm() class=\"trend-report-landing-page__section1__desc__download btn btn-submit\">Click to download</button></div></div><div class=\"trend-report-landing-page__section1__direction col-md-12 row\"><div class=trend-report-landing-page__section1__direction__button><i class=\"fa fa-angle-double-down\" aria-hidden=true></i></div><a class=trend-report-landing-page__section1__direction__text>Find out more</a></div></section><section class=\"trend-report-landing-page__section2 clearfix\"><div class=trend-report-landing-page__section2__col-left><div class=trend-report-landing-page__section2__col-left__content><span class=trend-report-landing-page__section2__col-left__trend>TREND REPORTS</span><h5 class=trend-report-landing-page__section2__col-left__header>Trend Spotting 2021</h5><div class=trend-report-landing-page__section2__col-left__content-text>Pop culture, social media and changing social attitudes are influencing what we’re seeing on our screens. What do visual creators and consumers in Asia have to say about it? Discover the nine major shifts with lasting power – and the kind of visual content in demand today. More than a faddish trend, they are a sign of changing times. PIXERF Creative Lab lays it all out.</div></div></div><div class=trend-report-landing-page__section2__col-right><img class=trend-report-landing-page__section2__col-right-image src=../../assets/images/trend-report/TS2021image@2x.jpg alt=\"trend spotting 2021\"></div></section><section class=\"trend-report-landing-page__section3 clearfix\"><div class=trend-report-landing-page__section3__col-left><div class=trend-report-landing-page__section3__col-left__content><span class=trend-report-landing-page__section3__col-left__trend>TREND REPORTS</span><h5 class=trend-report-landing-page__section3__col-left__header>Goodbye 2020, Hello 2021</h5><div class=trend-report-landing-page__section3__col-left__content-text>Retro’s big comeback. The rise of raw and unscripted aesthetic. Telling your brand story in the age of the pandemic. And more. Find out how a year unlike any other has changed visual culture as we know it – and what 2021 has in store. PIXERF’s dynamic Gen Z duo (and Temasek Polytechnic students) Rebecca Sia and Koreen Lim are on the case.</div></div></div><div class=trend-report-landing-page__section3__col-right><img class=trend-report-landing-page__section3__col-right-image src=../../assets/images/trend-report/GB2020image@2x.jpg alt=\"Hello 2021\"></div></section><section class=\"trend-report-landing-page__section4 clearfix\" id=pixerf-submit-form><div class=trend-report-landing-page__section4__content><h4 class=trend-report-landing-page__section4__header>Download the Trend Reports</h4><div class=trend-report-landing-page__section4__submit-form><span class=trend-report-landing-page__section4__submit-form__label>Email</span><form name=inputEmailForm id=inputEmailForm class=trend-report-landing-page__section4__submit-form__input-group><input maxlength=255 name=email type=email required ng-model=vm.email type=text class=\"form-control trend-report-landing-page__section4__submit-form__input-group__input\" ng-class=\"{\'exist-email\': vm.emailNotExist === false}\"> <button ng-disabled=!vm.isInputEmailFormvalid() ng-click=vm.onSubmitEmail() class=\"trend-report-landing-page__section4__submit-form__input-group__button btn btn-submit\">Submit</button></form><div class=trend-report-landing-page__section4__submit-form__privacy>By submitting this form, you agree to receive marketing emails and newsletters from PIXERF. You can unsubscribe at any time. The information you provided will be handled according to PIXERF’s privacy policy.</div></div><div class=trend-report-landing-page__section4__line-break><div class=trend-report-landing-page__section4__line-break__line></div><span class=trend-report-landing-page__section4__line-break__label>OR</span><div class=trend-report-landing-page__section4__line-break__line></div></div><div class=trend-report-landing-page__section4__user-panel><div class=trend-report-landing-page__section4__user-panel__signup><span class=trend-report-landing-page__section4__user-panel__signup__label>Don’t have an account?</span> <button ng-click=vm.onSignupBtnClicked() id=rtr_001 description=\"Signup Email from trend report landing page\" tracking-element class=\"trend-report-landing-page__section4__user-panel__signup__button btn btn-light\">Sign Up</button></div><div class=trend-report-landing-page__section4__user-panel__login><span class=trend-report-landing-page__section4__user-panel__login__label>Already have an account?</span> <button ng-click=vm.onLoginBtnClicked() class=\"trend-report-landing-page__section4__user-panel__login__button btn btn-light\">Log in</button></div></div><div class=trend-report-landing-page__section4__share-panel><span class=trend-report-landing-page__section4__share-panel__label>Share now</span><share settings=\"{\'flatMode\': true}\" content-will-be-shared=vm.socialShareContent title=\"Share this report\"></share></div></div></section></div>");
$templateCache.put("app/trends-report-download-page/trends-report-download-page.html","<div class=trends-report-download-page><div class=trends-report-download-page__title>Trend Reports</div><div class=trends-report-download-page__content><div class=trends-report-download-page__intro><div class=trends-report-download-page__intro__left><img src=../../assets/images/trend-report/good-bye-2020.jpg class=trends-report-download-page__intro__banner><div class=trends-report-download-page__intro__content><div class=trends-report-download-page__intro__content__title>Goodbye 2020, Hello 2021</div><div class=trends-report-download-page__intro__content__description>Looking back on five cultural shifts that rocked Asia\'s visual scene in 2020 — and why they are here to stay.</div><div class=trends-report-download-page__intro__content__control><div class=trends-report-download-page__intro__content__share><img src=../../assets/images/social-icons/Linking.png ng-click=\"vm.copyToClipboard(vm.shareLink, \'Your link has been successfully copied\')\" class=trends-report-download-page__intro__content__share__linking><share settings=\"{\'appendToBody\': true, \'flatMode\': false, \'popoverClass\': \'user-home-page\'}\" content-will-be-shared=vm.socialShareContent class=trends-report-download-page__intro__content__share__sharing></share></div><!-- <a href=\"https://pixerf-bucket.s3-ap-southeast-1.amazonaws.com/trend_reports/Goodbye+2020%2C+Hello+2021_Final.pdf\"\r\n							target=\"_blank\">\r\n							<div class=\"trends-report-download-page__intro__content__read-button btn btn--transparent\">\r\n								Read Report</div>\r\n						</a> --> <a href=https://pixerf-bucket.s3-ap-southeast-1.amazonaws.com/trend_reports/Goodbye+2020%2C+Hello+2021_Final.pdf target=_blank ng-click=vm.onDownloadReport()><div class=\"trends-report-download-page__intro__content__download-button btn btn-submit\">Download</div></a></div></div></div><div class=trends-report-download-page__intro__right><img src=../../assets/images/trend-report/trend-spotting-2021.jpg class=trends-report-download-page__intro__banner><div class=trends-report-download-page__intro__content><div class=trends-report-download-page__intro__content__title>Trend Spotting 2021</div><div class=trends-report-download-page__intro__content__description>Discover 9 big trends behind Asia\'s ever-changing visual culture — and where it’s heading next.</div><div class=trends-report-download-page__intro__content__control><div class=trends-report-download-page__intro__content__share><img src=../../assets/images/social-icons/Linking.png ng-click=\"vm.copyToClipboard(vm.shareLink, \'Your link has been successfully copied\')\" class=trends-report-download-page__intro__content__share__linking><share settings=\"{\'appendToBody\': true, \'flatMode\': false, \'popoverClass\': \'user-home-page\'}\" content-will-be-shared=vm.socialShareContent class=trends-report-download-page__intro__content__share__sharing></share></div><!-- <a href=\"https://pixerf-bucket.s3-ap-southeast-1.amazonaws.com/trend_reports/Trend+Spotting+2021_Final.pdf\"\r\n							target=\"_blank\">\r\n							<div class=\"trends-report-download-page__intro__content__read-button btn btn--transparent\">\r\n								Read Report</div>\r\n						</a> --> <a href=https://pixerf-bucket.s3-ap-southeast-1.amazonaws.com/trend_reports/Trend+Spotting+2021_Final.pdf target=_blank ng-click=vm.onDownloadReport()><div class=\"trends-report-download-page__intro__content__download-button btn btn-submit\">Download</div></a></div></div></div></div><div class=trends-report-download-page__footer><div class=trends-report-download-page__footer__content>Be the first to spot the hottest visual trends in photography today.<br>Check out <a ui-sref=buy-stock-page.galleries.signature-galleries class=\"text--bold text--color-pixerf-theme\" target=_blank>Signature Galleries</a> for the freshest picks of outstanding images from our global community of photographers.</div></div></div></div>");
$templateCache.put("app/user-home-page/user-home-page.html","<section class=\"main__content--md user-home-page\" ng-class=\"{\'margin-top--1\': isScreenMobile, \'personal-acc\': vm.user.account_type === \'personal\', \'business-acc\': vm.user.account_type === \'business\', \'institution-acc\': vm.user.account_type === \'institution\'}\"><div ng-if=vm.banner class=\"alert alert-info user-home-page__profile-incomplete-alert text-center\" role=alert compile=\"vm.banner | translate\"></div><div class=\"user-home-page__banner row user-home-page__cover-photo-wrapper\" ng-style=\"{\'height\': vm.coverImage.cssHeight, \'background-image\': \'url(\\\'\'+ vm.user.avatar.coverImage +\'\\\')\'}\"><div class=user-home-page__banner__button-change-cover></div><div class=user-home-page__banner__footer><div class=black-radiant-overlay></div><div class=pixerf-theme-banner></div><div class=user-home-page__banner__footer__content><div class=user-home-page__banner__avatar-user ng-class=\"!vm.user.account_type || vm.user.account_type === \'personal\' ? \'img-circle\' : \'\'\"><a ng-if=\"vm.isMyProfile && vm.user.canChangeAvatar\" class=user-home-page__user-profile-photo__wrapper ng-attr-uib-tooltip=\"{{\'update-profile-photo\' | translate}}\" ng-attr-tooltip-placement=\"\'top\'\" ng-click=vm.onUserProfilePhotoClicked()><pixerf-user-avatar ng-if=!vm.updatingdAvatar user-data=vm.user lazy=true></pixerf-user-avatar><div pixerf-user-avatar-style pixerf-user-avatar-style-user=vm.user class=overlay></div></a><a ng-if=\"!vm.isMyProfile || !vm.user.canChangeAvatar\" href={{vm.user.avatar.profileImage}} ng-attr-fancyboxable=\"{\'type\': \'image\', \'overlayShow\': true, \'hideOnOverlayClick\': true}\" class=user-home-page__user-profile-photo__wrapper ng-attr-uib-tooltip=\"Click to enlarge\" ng-attr-tooltip-placement=\"\'top\'\"><pixerf-user-avatar user-data=vm.user lazy=true></pixerf-user-avatar></a></div><div class=user-home-page__banner__footer__overlay><div class=\"user-home-page__banner__user-name text--truncate\"><div class=\"user-home-page__banner__display-name text--truncate\">{{vm.user.displayName}}</div><div class=user-home-page__banner__user-type><span class=user-home-page__banner__user-type__ambassador pixerf-person-level person=vm.user></span></div><div class=\"user-home-page__banner__location text--truncate\">{{(vm.user.organization && vm.user.organization.address) ? (vm.user.organization.address.country | isoCountry) : vm.user.location}}</div></div><div ng-if=\"vm.user.badges && vm.user.badges.length\" class=user-home-page__banner__badge ng-class=\"{\'contain-invite-btn\': !vm.isMyProfile && (vm.loginUserCommunities.length > 0)}\"><pixerf-badges popup-detail=true only=\"[\'ABM\', \'ABP\']\" badges=vm.user.badges></pixerf-badges></div><div class=user-home-page__banner__action ng-class=\"{\'contain-invite-btn\': !vm.isMyProfile && (vm.loginUserCommunities.length > 0)}\"><button ng-if=\"!vm.isMyProfile && (vm.loginUserCommunities.length > 0)\" class=\"user-home-page__banner__invite-to-community btn\" uib-tooltip=\"{{\'invite-to-community\' | translate}}\" ng-click=vm.onInviteToComunityClicked()>{{\'invite-to-community\' | translate}}</button> <button ng-if=\"vm.isProfileNotCompleted && vm.isMyProfile\" class=\"user-home-page__banner__edit-profile-btn btn btn-submit\" uib-tooltip=\"{{\'complete-your-profile\' | translate}}\" ng-click=vm.onCompleteProfileClicked()>{{\'complete-your-profile\' | translate}}</button> <button ng-if=\"!vm.isProfileNotCompleted && vm.isMyProfile\" class=\"user-home-page__banner__edit-profile-btn btn btn-submit\" uib-tooltip=\"{{\'edit\' | translate: {name: (\'your-profile\' | translate)}}}\" ng-click=\"vm.onEditProfileClicked(\'edit-profile\')\" translate=edit translate-values=\"{name: (\'profile\' | translate)}\"></button><follow-btn ng-if=\"!vm.isMyProfile && vm.loginnedUser.canFollow\" class=user-home-page__banner__follow-btn user=vm.user></follow-btn></div></div><div class=user-home-page__cover-photo-wrapper__tools><div ng-if=vm.isMyProfile class=user-home-page__cover-photo-wrapper__tools__update-cover-btn><span tooltip-append-to-body=true tooltip-placement=left uib-tooltip=\"{{\'update-cover-photo\' | translate}}\" ng-click=\"vm.showUploadUserProfilePhotos(\'cover\')\" class=icon-icons_camera></span></div></div></div></div><div class=overlay></div></div><div class=user-home-page__inner-main-content ng-class=\"{\'contain-invite-btn\': !vm.isMyProfile && (vm.loginUserCommunities.length > 0)}\" ui-view></div></section>");
$templateCache.put("app/term-policy/policy.html","<div><h3 class=text--bold>Terms of Service</h3><p class=text--bold>Nam porttitor blandit accumsan. Ut vel dictum sem, a pretium dui. In malesuada enim in dolor euismod, id commodo mi consectetur. Curabitur at vestibulum nisi. Nullam vehicula nis veli. Mauris turpis nisl, molestie ut ipsum et, suscipit vehicula odio. Vestibulum interdum vestibulum felis ac molestie. Praesent aliquet quam et liberodictum, vitae dignissim leo eleifend.In in turpis turpis. Quisque justo turpis, vestibulum non enim nec, tempormollis mi. Sed vel tristique quam.</p><h6>Note: These Terms of Service are effective as of September 10, 2016.</h6><h4 class=text--bold>1. Subheader</h4><p>Nam porttitor blandit accumsan. Ut vel dictum sem, a pretium dui. In malesuada enim in dolor euismod, id commodo mi consectetur. Curabitur at vestibulum nisi. Nullam vehicula nisivelit. Mauris turpis nisl, molestie ut ipsum et, suscipit vehicula odio. Vestibulum interdum vestibulum felis ac molestie. Praesent aliquet quam et libero dictum, vitae dignissim leo eleifend In in turpis turpis. Quisque justo turpis, vestibulum non enim nec, tempor mollis mi. Sed vel tristique quam.</p><h4 class=text--bold>2. Subheader</h4><p>Nam porttitor blandit accumsan. Ut vel dictum sem, a pretium dui. In malesuada enim in dolor euismod, id commodo mi consectetur. Curabitur at vestibulum nisi. Nullam vehicula nisivelit. Mauris turpis nisl, molestie ut ipsum et, suscipit vehicula odio. Vestibulum interdum vestibulum felis ac molestie. Praesent aliquet quam et libero dictum, vitae dignissim leo eleifend In in turpis turpis. Quisque justo turpis, vestibulum non enim nec, tempor mollis mi. Sed vel tristique quam.</p><h4 class=text--bold>3. Subheader</h4><p>Nam porttitor blandit accumsan. Ut vel dictum sem, a pretium dui. In malesuada enim in dolor euismod, id commodo mi consectetur. Curabitur at vestibulum nisi. Nullam vehicula nisivelit. Mauris turpis nisl, molestie ut ipsum et, suscipit vehicula odio. Vestibulum interdum vestibulum felis ac molestie. Praesent aliquet quam et libero dictum, vitae dignissim leo eleifend In in turpis turpis. Quisque justo turpis, vestibulum non enim nec, tempor mollis mi. Sed vel tristique quam.</p></div>");
$templateCache.put("app/term-policy/term-policy.html","<div ng-controller=\"termPolicyCtrl as vm\" class=term-policy><nav class=\"navbar text-uppercase term-policy-navbar main__content\"><div class=container-fluid><div class=navbar-header><button type=button class=\"navbar-toggle collapsed\" data-toggle=collapse data-target=#term-policy-navbar-collapse aria-expanded=false><span class=sr-only>Toggle navigation</span><div class=icon-icons_more></div></button></div><div class=\"collapse navbar-collapse pixerf-navbar-text\" id=term-policy-navbar-collapse><ul class=\"nav navbar-nav navbar-left\"><li ui-sref-active=navbar--active ui-sref=.term><a ng-href=#>TERMS OF SERVICE</a></li><li ui-sref-active=navbar--active ui-sref=.policy><a ng-href=#>PRIVACY POLICY</a></li><li ui-sref-active=navbar--active><a ng-href=#>SUBSCRIPTION TERMS</a></li><li><a ng-href=#>IMAGE LICENSE AGREEMENT</a></li></ul></div></div></nav><div class=\"col-md-10 none-float horizental-centered\" ui-view></div></div>");
$templateCache.put("app/term-policy/term.html","<div><h3 class=text--bold>Privacy Policy</h3><p class=text--bold>Nam porttitor blandit accumsan. Ut vel dictum sem, a pretium dui. In malesuada enim in dolor euismod, id commodo mi consectetur. Curabitur at vestibulum nisi. Nullam vehicula nis veli. Mauris turpis nisl, molestie ut ipsum et, suscipit vehicula odio. Vestibulum interdum vestibulum felis ac molestie. Praesent aliquet quam et liberodictum, vitae dignissim leo eleifend.In in turpis turpis. Quisque justo turpis, vestibulum non enim nec, tempormollis mi. Sed vel tristique quam.</p><h6>Note: These Terms of Service are effective as of September 10, 2016.</h6><h4 class=text--bold>1. Subheader</h4><p>Nam porttitor blandit accumsan. Ut vel dictum sem, a pretium dui. In malesuada enim in dolor euismod, id commodo mi consectetur. Curabitur at vestibulum nisi. Nullam vehicula nisivelit. Mauris turpis nisl, molestie ut ipsum et, suscipit vehicula odio. Vestibulum interdum vestibulum felis ac molestie. Praesent aliquet quam et libero dictum, vitae dignissim leo eleifend In in turpis turpis. Quisque justo turpis, vestibulum non enim nec, tempor mollis mi. Sed vel tristique quam.</p><h4 class=text--bold>2. Subheader</h4><p>Nam porttitor blandit accumsan. Ut vel dictum sem, a pretium dui. In malesuada enim in dolor euismod, id commodo mi consectetur. Curabitur at vestibulum nisi. Nullam vehicula nisivelit. Mauris turpis nisl, molestie ut ipsum et, suscipit vehicula odio. Vestibulum interdum vestibulum felis ac molestie. Praesent aliquet quam et libero dictum, vitae dignissim leo eleifend In in turpis turpis. Quisque justo turpis, vestibulum non enim nec, tempor mollis mi. Sed vel tristique quam.</p><h4 class=text--bold>3. Subheader</h4><p>Nam porttitor blandit accumsan. Ut vel dictum sem, a pretium dui. In malesuada enim in dolor euismod, id commodo mi consectetur. Curabitur at vestibulum nisi. Nullam vehicula nisivelit. Mauris turpis nisl, molestie ut ipsum et, suscipit vehicula odio. Vestibulum interdum vestibulum felis ac molestie. Praesent aliquet quam et libero dictum, vitae dignissim leo eleifend In in turpis turpis. Quisque justo turpis, vestibulum non enim nec, tempor mollis mi. Sed vel tristique quam.</p></div>");
$templateCache.put("app/sign-up-page/sign-up-page.html","<div class=sign-up-page><div class=\"sign-up-page__main-content ui-view-container\" ui-view></div></div>");
$templateCache.put("app/checkout/billing-information/billing-information-page.html","<div class=\"billing-information-page no-margin\"><div class=\"billing-information-page__col-wrapper clearfix\"><div class=billing-information-page__header><h4 class=\"text-left text--bold text--color-black\">Billing Address</h4></div><div class=\"bg--white clearfix\"><div class=\"billing-information-page__content clearfix\"><form name=billingInformationForm><div class=\"form-group col-md-6\"><label class=text--bold for=\"\">Email</label><input ng-model=vm.user.email name=email class=form-control readonly=readonly></div><div class=\"form-group col-md-6\"><label class=text--bold for=\"\">Company</label><input ng-model=vm.user.billing_information.company name=company class=form-control focus-me=true></div><div class=\"form-group col-md-6\"><label class=text--bold for=\"\">First Name</label><input validation-no-hyperlink validation-no-number ng-model=vm.user.billing_information.first_name name=first_name class=form-control></div><div class=\"form-group col-md-6\"><label class=text--bold for=\"\">Last Name</label><input validation-no-hyperlink validation-no-number ng-model=vm.user.billing_information.last_name name=last_name class=form-control></div><div class=\"form-group col-md-6\"><label class=text--bold for=\"\">Address</label><input validation-no-hyperlink ng-model=vm.user.billing_information.address name=address class=form-control></div><div class=\"form-group col-md-6\"><label class=text--bold for=\"\">State / Province / Region</label><input validation-no-hyperlink ng-model=vm.user.billing_information.state name=state class=form-control></div><div class=\"form-group col-md-6\"><label class=text--bold for=\"\">City</label><input validation-no-hyperlink validation-no-number ng-model=vm.user.billing_information.city name=city class=form-control></div><div class=\"form-group col-md-6\"><label class=text--bold for=\"\">Country</label><country-select class=form-control ng-model=vm.user.billing_information.country placeholder=Country></country-select></div><div class=\"form-group col-md-6\"><label class=text--bold for=\"\">Postal Code</label><input validation-no-hyperlink ng-model=vm.user.billing_information.postal_code name=postal_code class=form-control></div></form></div><div class=\"billing-information-page__footer clearfix bg--white\"><div role=button class=\"billing-information-page__btn billing-information-page__btn__left btn btn-cancel text--semibold\" ng-click=vm.onBackBtnClicked()>Back</div><div role=button class=\"billing-information-page__btn billing-information-page__btn__right btn btn-submit text--semibold\" ng-click=\"vm.onDoneBtnClicked(vm.user, billingInformationForm)\">Done</div></div></div></div></div>");
$templateCache.put("app/checkout/credit-plan/credit-plan-page.html","<div class=\"credit-plan__main-content clearfix\" ui-view></div>");
$templateCache.put("app/checkout/event-payment-menthod/event-payment-menthod-page.html","<div class=\"event-payment-menthod-page no-margin\"><div class=\"event-payment-menthod-page__col-wrapper clearfix\" ng-show=vm.loginUser><div class=clearfix><section class=\"col-md-7 col-left-min-width no-padding\"><section class=\"col-xs-12 event-payment-menthod-page__select-payment-method\"><div class=event-payment-menthod-page__col-right><div class=\"event-payment-menthod-page__select-payment-method__header text--color-black\" translate>{{\'select-payment-method\'}}</div><shopping-cart-my-credit-balance-review add-credit-btn=true total-to-pay=vm.totalToPay ng-if=vm.loginUser.canBuyCreditPlan></shopping-cart-my-credit-balance-review><billing-information></billing-information><payment-pannel context=CHECKOUT_EVENT display-horizontal=true not-allowed-list=\"[\'PAYPAL\']\" on-payment-method-selected=vm.onPaymentMethodSelected(paymentMethodSelected) amount-to-pay=vm.totalToPay disable-pay-btn=vm.disablePayBtn() on-validation-passed=vm.onValidationPassed() on-complete=vm.onPaymentComplete(data) process-before-pay=vm.signUpForGuestUser() is-guest-payment=vm.isGuestPayment on-paypal-done=vm.onPaypalDone() on-error=vm.onError(pixerfPaymentErrorObject) on-checkbox-agreed-tnc-checked=vm.onAgreedTncChecked() subcrible-news-letter=vm.subcribleNewsLetter></payment-pannel></div></section></section><section class=\"col-md-4 col-md-offset-1 no-padding col-right-min-width event-payment-menthod-page__purchase-detail\"><div class=event-payment-menthod-page__purchase-detail__header>{{\'purchase-detail\' | translate}}</div><div class=photos-purchase><span class=\"photos-purchase__highlight text-lowercase\">1 ticket event </span><span>{{\'selected-for-purchase\' | translate}}</span></div><section class=\"col-md-12 no-padding col-left-min-width\"><div class=event-payment-menthod-page__col-right><div class=event-payment-menthod-page__cart_items-wrapper><div class=\"checkout-item clearfix\"><div class=\"event-payment-menthod-page__purchase-detail__content purchase-detail clearfix\"><div class=\"purchase-detail__col-left clearfix\"><div class=purchase-detail__image ng-style=\"{\'background-image\': \'url(\\\'\' + vm.event.cover.original + \'\\\')\'}\"></div></div><div class=purchase-detail__col-right><div class=\"purchase-detail__header clearfix\"><div class=\"photo-title text--bold text--truncate\">{{vm.event.name}}</div></div><div class=table-checkout><div class=\"table-checkout__row clearfix\"><div class=table-checkout__item-content>{{vm.event.id}}</div></div></div></div></div><div class=\"event-payment-menthod-page__purchase-detail__sub-total text--color-black\"><div class=\"event-payment-menthod-page__purchase-detail__sub-total__price text--bold\">SGD <span class=\"text--bold price-number\">{{item.sub_total}}</span></div></div></div></div></div></section><payment-amount-to-pay title=total-to-pay show-unit=SGD amount=vm.totalToPay amount-discounted=vm.numberDiscounted></payment-amount-to-pay></section></div></div><div class=event-payment-menthod-page__empty-state ng-show=\"vm.cart.data.cart_items.length === 0\"><div class=\"event-payment-menthod-page__empty-state-icon icon-icons_cart\"></div><div class=\"event-payment-menthod-page__empty-state-text text--semibold text--color-black\" translate>{{\'your-cart-is-empty\'}}</div><div ng-click=vm.onContinueXerfingBtnClicked() role=button class=\"event-payment-menthod-page__empty-state__continue-btn btn--transparent btn\" translate>{{\'continue-xerfing\'}}</div></div><spinner-win spinner=vm.spinner></spinner-win><script type=text/ng-template id=event-payment-menthod-page__validation-popup__tooltip-template><div>You may have received this error because:</div>\r\n		<ul>\r\n			<li>The photo(s) are part of a Mission. Mission submissions become temporarily unavailable for licensing until after their Mission ends</li>\r\n			<li>You had previously removed the photo(s) from your cart and are trying to checkout a cached version.</li>\r\n			<li>The photographer has deleted the photo(s) from the Marketplace.</li>\r\n		</ul></script></div>");
$templateCache.put("app/checkout/payment-menthod/payment-menthod-page.html","<div class=\"payment-menthod-page no-margin\"><div class=\"payment-menthod-page__col-wrapper clearfix\" ng-show=\"vm.cart.data.cart_items && vm.cart.data.cart_items.length > 0\"><div class=clearfix><section class=\"col-md-7 col-left-min-width no-padding\"><section class=\"col-xs-12 payment-menthod-page__create-account\" ng-if=!vm.loginUser><div class=payment-menthod-page__header translate>{{\'Checkout\'}}</div><div class=payment-menthod-page__col-left><div class=payment-menthod-page__create-account__form-header><div class=\"create-account-header text--color-black\" translate>{{vm.isLoginState ? \'log-in\':\'create-an-account\'}}</div><div class=\"create-account-login text--color-black\" ng-if=!vm.isLoginState>{{\'already-have-an-account\' | translate}}? <span class=\"create-account-login-btn text--bold\" translate ng-click=\"vm.onLoginBtnClicked(vm.user.data.email, signUpForm)\">{{\'log-in\'}}</span></div><div class=\"create-account-login text--color-black\" ng-if=vm.isLoginState>{{\'new-to-pixerf\' | translate}}? <span class=\"create-account-login-btn text--bold\" translate ng-click=\"vm.onLoginBtnClicked(vm.user.data.email, signUpForm)\">{{\'sign-up\'}}</span></div></div><form name=signUpForm id=signUpForm class=\"payment-menthod-page__create-account__create-account-form clearfix\"><div class=\"form-group email-wrapper clearfix\"><label for=email ng-class=\"!signUpForm.$pristine && !vm.isLoginState && (signUpForm.email.$invalid || !vm.emailNotExist) ? \'text--color-error\' : \'text--color-black\'\" translate>{{\'email\'}}</label><div class=alert-error ng-if=\"!vm.isLoginState && !vm.isChecking && !vm.isEmailValid\">{{vm.errorEmailMessage}}</div><input id=E2 maxlength=255 name=email type=email required ng-model=vm.user.data.email type=text ng-blur=\"vm.onCheckEmailExist(vm.user.data.email, signUpForm)\" class=form-control ng-keyup=\"vm.onInputEmailChanged(vm.user.data.email, signUpForm)\" ng-class=\"{\'exist-email\': vm.emailNotExist === false}\"><div class=\"validate-sign spinner\" ng-if=vm.isChecking><i class=\"fa fa-2x fa-spin fa-spinner\"></i></div><div class=\"validate-sign check-icon text--bold icon-icons_check\" ng-if=\"!vm.isLoginState && !vm.isChecking && vm.emailNotExist\"></div><div class=\"validate-sign check-icon text--bold icon-icons_close\" ng-if=\"!vm.isLoginState && !vm.isChecking && vm.emailNotExist === false\"></div></div><div class=\"form-group password-wrapper clearfix\"><label for=password ng-class=\"!signUpForm.$pristine && signUpForm.password.$invalid ? \'text--color-error\' : \'text--color-black\'\" translate>{{\'password\'}}</label><div class=alert-error ng-if=\"!vm.isWorking && !signUpForm.$pristine && signUpForm.password.$error && signUpForm.password.$error.required\" translate>{{\'input-password\'}}!</div><input id=E3 ng-pattern=\"/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})/\" ng-blur=vm.onPasswordBlur($event) ng-focus=vm.onPasswordFocus($event) ng-keyup=vm.onPasswordKeyup($event) tooltip-is-open=vm.isPasswordPrivacyTooltipShown name=password required ng-attr-type=\"{{vm.isShowPassword.data ? \'text\' : \'password\'}}\" ng-model=vm.user.data.password class=form-control tooltip-trigger=\"\'none\'\" tooltip-class=sign-up__tooltip-password-hint tooltip-append-to-body=true tooltip-placement=right uib-tooltip=\"{{\'password-requirements\' | translate}}\"><div maxlength=255 title=\"{{\'hover-show-hide-password\' | translate}}\" class=\"btn-toogle-password text--bold\" ng-click=\"vm.isShowPassword.data = !vm.isShowPassword.data\" ng-if=vm.isShowPassword.data><i class=\"fa fa-eye-slash\" aria-hidden=true></i></div><div maxlength=255 title=\"{{\'hover-show-hide-password\' | translate}}\" class=\"btn-toogle-password text--bold\" ng-click=\"vm.isShowPassword.data = !vm.isShowPassword.data\" ng-if=!vm.isShowPassword.data><i class=\"fa fa-eye\" aria-hidden=true></i></div><div class=\"partern-error alert-error\" ng-if=\"!vm.isWorking && !signUpForm.$pristine && signUpForm.password.$error && signUpForm.password.$error.pattern\" translate>{{\'password-requirements\'}}</div></div></form></div></section><section class=\"col-xs-12 payment-menthod-page__select-payment-method\"><div class=payment-menthod-page__col-right><div class=\"payment-menthod-page__select-payment-method__header text--color-black\" translate>{{\'select-payment-method\'}}</div><shopping-cart-my-credit-balance-review add-credit-btn=true total-to-pay=vm.totalToPay ng-if=vm.loginUser.canBuyCreditPlan></shopping-cart-my-credit-balance-review><billing-information></billing-information><payment-pannel context=CHECKOUT_CART display-horizontal=true on-payment-method-selected=vm.onPaymentMethodSelected(paymentMethodSelected) amount-to-pay=vm.totalToPay validator=vm.validateCart() disable-pay-btn=vm.disablePayBtn() on-validation-passed=vm.onValidationPassed() on-complete=vm.onPaymentComplete(data) process-before-pay=vm.signUpForGuestUser() is-guest-payment=vm.isGuestPayment on-paypal-done=vm.onPaypalDone() on-error=vm.onError(pixerfPaymentErrorObject) on-checkbox-agreed-tnc-checked=vm.onAgreedTncChecked() subcrible-news-letter=vm.subcribleNewsLetter></payment-pannel></div></section></section><section class=\"col-md-4 col-md-offset-1 no-padding col-right-min-width payment-menthod-page__purchase-detail\"><div class=payment-menthod-page__purchase-detail__header>{{\'purchase-detail\' | translate}}</div><div class=photos-purchase><span class=photos-purchase__highlight>{{vm.cart.data.cart_items.length}}</span> <span class=\"photos-purchase__highlight text-lowercase\">{{vm.cart.data.cart_items.length, plural, =1 {{{\'photo\' | translate}}} other {{{\'photos\' | translate}}} }} </span><span>{{\'selected-for-purchase\' | translate}}</span> <span class=\"payment-menthod-page__purchase-detail__view-cart text--bold\" translate ui-sref=checkout.shopping-cart>{{\'edit-cart\'}}</span></div><section class=\"col-md-12 no-padding col-left-min-width\"><div class=payment-menthod-page__col-right><div class=payment-menthod-page__cart_items-wrapper><div class=\"checkout-item clearfix\" ng-repeat=\"item in vm.cart.data.cart_items\"><div class=\"payment-menthod-page__purchase-detail__content purchase-detail clearfix\"><div class=\"purchase-detail__col-left clearfix\"><a ui-sref=\"photo({id: item.media.id, photoTitle: (item.media.title + \' by \' + item.media.user.displayName | toSnakeCase)})\"><img ng-src=\"{{item.media.thumbnails[\'x500\']}}\" ng-attr-alt=\"{{(item.media.title + \' by \' + item.media.user.displayName) | toSnakeCase}}\"></a></div><div class=purchase-detail__col-right><div class=\"purchase-detail__header clearfix\"><div class=\"photo-title text--bold text--truncate\">{{item.media.title}}</div></div><div class=table-checkout><div class=\"table-checkout__row clearfix\"><div class=table-checkout__item-content>{{item.media.id}}</div></div><div class=\"table-checkout__row clearfix\"><div class=table-checkout__item-content>{{vm.getLicenseType(item.media)}}</div></div><div class=\"table-checkout__row clearfix\"><div class=table-checkout__item-content>{{vm.getReleaseInfo(item.media)}}</div></div></div></div></div><div class=\"payment-menthod-page__purchase-detail__sub-total text--color-black\"><div class=\"payment-menthod-page__purchase-detail__sub-total__price text--bold\">SGD <span class=\"text--bold price-number\">{{item.sub_total}}</span></div></div></div></div></div></section><payment-amount-to-pay title=total-to-pay show-unit=SGD amount=vm.totalToPay amount-discounted=vm.numberDiscounted></payment-amount-to-pay></section></div></div><div class=payment-menthod-page__empty-state ng-show=\"vm.cart.data.cart_items.length === 0\"><div class=\"payment-menthod-page__empty-state-icon icon-icons_cart\"></div><div class=\"payment-menthod-page__empty-state-text text--semibold text--color-black\" translate>{{\'your-cart-is-empty\'}}</div><div ng-click=vm.onContinueXerfingBtnClicked() role=button class=\"payment-menthod-page__empty-state__continue-btn btn--transparent btn\" translate>{{\'continue-xerfing\'}}</div></div><spinner-win spinner=vm.spinner></spinner-win><script type=text/ng-template id=payment-menthod-page__validation-popup__tooltip-template><div>You may have received this error because:</div>\r\n		<ul>\r\n			<li>The photo(s) are part of a Mission. Mission submissions become temporarily unavailable for licensing until after their Mission ends</li>\r\n			<li>You had previously removed the photo(s) from your cart and are trying to checkout a cached version.</li>\r\n			<li>The photographer has deleted the photo(s) from the Marketplace.</li>\r\n		</ul></script></div>");
$templateCache.put("app/checkout/shopping-cart/shopping-cart-page.html","<div class=\"shopping-cart-page no-margin\"><div class=\"shopping-cart-page__col-wrapper clearfix\"><div ng-show=\"vm.cart.data.cart_items && vm.cart.data.cart_items.length > 0\" class=clearfix><div class=shopping-cart-page__header translate>{{\'shopping-cart\'}}</div><div class=photos-purchase><span class=photos-purchase__highlight>{{vm.cart.data.cart_items.length}}</span> <span class=\"photos-purchase__highlight text-lowercase\">{{ vm.cart.data.cart_items.length, plural, =1 {{{\'photo\' | translate}}} other {{{\'photos\' | translate}}} }} </span><span>{{\'selected-for-purchase\' | translate}}</span></div><div class=checkout-section><div class=\"checkout-section__summary col-xs-12 no-padding\"><span class=checkout-section__summary-label translate>{{\'total\'}}</span> <span class=checkout-section__summary-unit>SGD</span> <span class=checkout-section__summary-number ng-bind=\"vm.totalToPay | number:2\"></span></div><div class=\"checkout-section__action col-md-12 no-padding\"><div ng-click=vm.onContinueXerfingBtnClicked() role=button class=\"shopping-cart-page__empty-state__continue-btn btn--transparent btn\" translate>{{\'continue-xerfing\'}}</div><div ng-click=vm.onGoToPaymentBtnClicked() role=button class=\"shopping-cart-page__checkout-btn btn-submit btn\" translate>{{\'continue-with-purchase\'}}</div></div></div><section class=\"col-md-12 no-padding col-left-min-width\"><div class=shopping-cart-page__col-left><div class=shopping-cart-page__cart_items-wrapper><div class=\"checkout-item clearfix\" ng-repeat=\"item in vm.cart.data.cart_items\"><cart-item ng-class=\"{\'invalid\': item.is_invalid}\" item=item is-disabled=vm.isCartItemDisabled on-cart-item-modified=\"vm.onCartItemModified(evt, item)\" on-remove-cart-btn-clicked=\"vm.onRemoveCartBtnClicked(evt, item)\"></cart-item></div></div><div class=\"checkout-section checkout-section__bottom\"><div class=\"checkout-section__summary col-xs-12 no-padding\"><span class=checkout-section__summary-label translate>{{\'total\'}}</span> <span class=checkout-section__summary-unit>SGD</span> <span class=checkout-section__summary-number ng-bind=\"vm.totalToPay | number:2\"></span></div><div class=\"checkout-section__action col-md-12 no-padding\"><div ng-click=vm.onContinueXerfingBtnClicked() role=button class=\"shopping-cart-page__empty-state__continue-btn btn--transparent btn\" translate>{{\'continue-xerfing\'}}</div><div ng-click=vm.onGoToPaymentBtnClicked() role=button class=\"shopping-cart-page__checkout-btn btn-submit btn\" translate>{{\'continue-with-purchase\'}}</div></div></div></div></section></div><div class=shopping-cart-page__empty-state ng-show=\"vm.cart.data.cart_items.length === 0\"><div class=\"shopping-cart-page__empty-state-icon icon-icons_cart\"></div><div class=\"shopping-cart-page__empty-state-text text--semibold text--color-black\" translate>{{\'your-cart-is-empty\'}}</div><div ng-click=vm.onContinueXerfingBtnClicked() role=button class=\"shopping-cart-page__empty-state__continue-btn btn--transparent btn\" translate>{{\'continue-xerfing\'}}</div></div></div><spinner-win spinner=vm.spinner></spinner-win><script type=text/ng-template id=shopping-cart-page__validation-popup__tooltip-template><div>You may have received this error because:</div>\r\n		<ul>\r\n			<li>The photo(s) are part of a Mission. Mission submissions become temporarily unavailable for licensing until after their Mission ends</li>\r\n			<li>You had previously removed the photo(s) from your cart and are trying to checkout a cached version.</li>\r\n			<li>The photographer has deleted the photo(s) from the Marketplace.</li>\r\n		</ul></script></div>");
$templateCache.put("app/components/about-challenges-case-Studies-grid-carousel/about-challenges-case-Studies-grid-carousel.html","<div class=about-challenges-case-Studies-grid-carousel><slick data=vm.slideDatas arrows=false on-init=vm.slickSetting.onInit(slick) adaptive-height=true class=about-challenges-case-Studies-grid-carousel__slick><div ng-repeat=\"data in vm.slideDatas\"><ng-include ng-if=\"$index == 0\" src=\"\'app/components/about-challenges-case-Studies-grid-carousel/slide1-template.html\'\" class=\"about-challenges-case-Studies-grid-carousel__template-include slide-{{$index}}-style\"></ng-include><ng-include ng-if=\"$index == 1\" src=\"\'app/components/about-challenges-case-Studies-grid-carousel/slide2-template.html\'\" class=\"about-challenges-case-Studies-grid-carousel__template-include slide-{{$index}}-style\"></ng-include><ng-include ng-if=\"$index == 2\" src=\"\'app/components/about-challenges-case-Studies-grid-carousel/slide3-template.html\'\" class=\"about-challenges-case-Studies-grid-carousel__template-include slide-{{$index}}-style\"></ng-include><ng-include ng-if=\"$index == 3\" src=\"\'app/components/about-challenges-case-Studies-grid-carousel/slide4-template.html\'\" class=\"about-challenges-case-Studies-grid-carousel__template-include slide-{{$index}}-style\"></ng-include><ng-include ng-if=\"$index == 4\" src=\"\'app/components/about-challenges-case-Studies-grid-carousel/slide5-template.html\'\" class=\"about-challenges-case-Studies-grid-carousel__template-include slide-{{$index}}-style\"></ng-include></div></slick><div class=about-challenges-case-Studies-grid-carousel__slide-control><div class=about-challenges-case-Studies-grid-carousel__slide-control__indicator><div ng-repeat=\"item in vm.slideDatas\" ng-click=vm.onNavClicked($index) ng-class=\"{\'active\': vm.isActive($index)}\" class=about-challenges-case-Studies-grid-carousel__slide-control__indicator__item></div></div></div><div class=about-challenges-case-Studies-grid-carousel__navigate><div class=\"about-challenges-case-Studies-grid-carousel__navigate__left icon-slide-prev-icon\" ng-click=vm.onPreviousSlide()></div><div class=\"about-challenges-case-Studies-grid-carousel__navigate__right icon-slide-next-icon\" ng-click=vm.onNextSlide()></div></div></div>");
$templateCache.put("app/components/about-challenges-case-Studies-grid-carousel/slide1-template.html","<div class=\"about-challenges-case-Studies-grid-carousel__pc-section slide-0-style__center width-100\"><div class=\"slide-0-style__center size-auto vertical\"><div class=\"slide-0-style__center height-34\"><div class=\"photo-slide-item photo-0\" ng-style=\"{\'background-image\': \'url(\' + data.photos[0].url + \')\'}\"></div><div class=\"photo-slide-item photo-1\" ng-style=\"{\'background-image\': \'url(\' + data.photos[1].url + \')\'}\"><div class=photo-slide-awards><div class=photo-slide-awards__logo ng-style=\"{\'background-image\': \'url(assets/images/about-challenges-case-Studies-grid-carousel/slides/flash-back-to-penang-butterworth.svg)\'}\"></div></div></div><div class=\"photo-slide-item photo-2\" ng-style=\"{\'background-image\': \'url(\' + data.photos[2].url + \')\'}\"></div></div><div class=\"slide-0-style__center size-auto\"><div class=\"photo-slide-item photo-3 height-66\" ng-style=\"{\'background-image\': \'url(\' + data.photos[3].url + \')\'}\"><div class=photo-slide-panel><div class=photo-slide-panel__left-side><div class=photo-slide-panel__logo><div class=photo-slide-panel__logo__photo ng-style=\"{\'background-image\': \'url(\' + data.slideInfo.logoUrl + \')\'}\"></div></div><div class=photo-slide-panel__count-down><div class=photo-slide-panel__count-down__item><div class=photo-slide-panel__count-down__header>{{data.slideInfo.submissions}}</div><div class=photo-slide-panel__count-down__desc>Submissions</div></div><div class=photo-slide-panel__count-down__item><div class=photo-slide-panel__count-down__header>{{data.slideInfo.winners}}</div><div class=photo-slide-panel__count-down__desc>Winners</div></div></div></div><div class=photo-slide-panel__content><div class=photo-slide-panel__content__cover><div class=photo-slide-panel__content__header>{{data.slideInfo.header}}</div><div class=photo-slide-panel__content__desc>{{data.slideInfo.desc}}</div></div></div></div></div><div class=\"photo-slide-item photo-4 height-66\" ng-style=\"{\'background-image\': \'url(\' + data.photos[4].url + \')\'}\"><div class=photo-slide-awards-custom><div class=photo-slide-awards-custom__logo ng-style=\"{\'background-image\': \'url(assets/images/about-challenges-case-Studies-grid-carousel/slides/challenge-winner.svg)\'}\"></div><span class=photo-slide-awards-custom__desc-image ng-style=\"{\'background-image\': \'url(assets/images/about-challenges-case-Studies-grid-carousel/slides/Together-at-home.svg)\'}\"></span></div></div></div></div><div class=\"slide-0-style__center width-30 vertical\"><div class=\"photo-slide-item photo-5 height-79\" ng-style=\"{\'background-image\': \'url(\' + data.photos[5].url + \')\'}\"></div><div class=\"photo-slide-item photo-6 size-auto\" ng-style=\"{\'background-image\': \'url(\' + data.photos[6].url + \')\'}\"></div></div></div><div class=about-challenges-case-Studies-grid-carousel__mobile-section><div class=about-challenges-case-Studies-grid-carousel__mobile-section__grid-wrapper><div ng-click=vm.showPhotoPopup(data.photos[0]) class=about-challenges-case-Studies-grid-carousel__mobile-section__item-wrapper><div class=about-challenges-case-Studies-grid-carousel__mobile-section__item><div class=\"about-challenges-case-Studies-grid-carousel__mobile-section__item__background zoom-hover\" ng-style=\"{\'background-image\': \'url(\\\'\' + data.photos[0].urlMobile + \'\\\')\'}\"></div></div></div><div ng-click=vm.showPhotoPopup(data.photos[1]) class=\"about-challenges-case-Studies-grid-carousel__mobile-section__item-wrapper item-plus\"><div class=about-challenges-case-Studies-grid-carousel__mobile-section__item><div class=\"about-challenges-case-Studies-grid-carousel__mobile-section__item__background zoom-hover\" ng-style=\"{\'background-image\': \'url(\\\'\' + data.photos[1].urlMobile + \'\\\')\'}\"><div class=photo-slide-awards-mobile><div class=photo-slide-awards-mobile__logo ng-style=\"{\'background-image\': \'url(assets/images/about-challenges-case-Studies-grid-carousel/slides/flash-back-to-penang-butterworth-mobile.svg)\'}\"></div></div></div></div></div></div><div class=about-challenges-case-Studies-grid-carousel__mobile-section__grid-wrapper><div ng-click=vm.showPhotoPopup(data.photos[2]) class=about-challenges-case-Studies-grid-carousel__mobile-section__item-wrapper><div class=about-challenges-case-Studies-grid-carousel__mobile-section__item><div class=\"about-challenges-case-Studies-grid-carousel__mobile-section__item__background zoom-hover\" ng-style=\"{\'background-image\': \'url(\\\'\' + data.photos[2].urlMobile + \'\\\')\'}\"></div></div></div><div ng-click=vm.showPhotoPopup(data.photos[3]) class=about-challenges-case-Studies-grid-carousel__mobile-section__item-wrapper><div class=about-challenges-case-Studies-grid-carousel__mobile-section__item><div class=\"about-challenges-case-Studies-grid-carousel__mobile-section__item__background zoom-hover\" ng-style=\"{\'background-image\': \'url(\\\'\' + data.photos[3].urlMobile + \'\\\')\'}\"><div class=photo-slide-awards-mobile><div class=photo-slide-awards-mobile__logo ng-style=\"{\'background-image\': \'url(assets/images/about-challenges-case-Studies-grid-carousel/slides/Together-at-home-mobile.svg)\'}\"></div></div></div></div></div><div ng-click=vm.showPhotoPopup(data.photos[4]) class=about-challenges-case-Studies-grid-carousel__mobile-section__item-wrapper><div class=about-challenges-case-Studies-grid-carousel__mobile-section__item><div class=\"about-challenges-case-Studies-grid-carousel__mobile-section__item__background zoom-hover\" ng-style=\"{\'background-image\': \'url(\\\'\' + data.photos[4].urlMobile + \'\\\')\'}\"></div></div></div></div><div class=about-challenges-case-Studies-grid-carousel__mobile-section__grid-wrapper><div ng-click=vm.showPhotoPopup(data.photos[5]) class=\"about-challenges-case-Studies-grid-carousel__mobile-section__item-wrapper item-plus\"><div class=about-challenges-case-Studies-grid-carousel__mobile-section__item><div class=\"about-challenges-case-Studies-grid-carousel__mobile-section__item__background zoom-hover\" ng-style=\"{\'background-image\': \'url(\\\'\' + data.photos[5].urlMobile + \'\\\')\'}\"></div></div></div><div ng-click=vm.showPhotoPopup(data.photos[6]) class=about-challenges-case-Studies-grid-carousel__mobile-section__item-wrapper><div class=about-challenges-case-Studies-grid-carousel__mobile-section__item><div class=\"about-challenges-case-Studies-grid-carousel__mobile-section__item__background zoom-hover\" ng-style=\"{\'background-image\': \'url(\\\'\' + data.photos[6].urlMobile + \'\\\')\'}\"></div></div></div></div><div class=about-challenges-case-Studies-grid-carousel__mobile-section__grid-info-wrapper><div class=\"about-challenges-case-Studies-grid-carousel__mobile-section__item-wrapper background-desert-storm\"><div class=about-challenges-case-Studies-grid-carousel__mobile-section__item><div class=about-challenges-case-Studies-grid-carousel__mobile-section__item__logo ng-style=\"{\'background-image\': \'url(\' + data.slideInfo.logoUrlMobile + \')\'}\"></div></div></div><div class=\"about-challenges-case-Studies-grid-carousel__mobile-section__item-wrapper background-desert-storm\"><div class=about-challenges-case-Studies-grid-carousel__mobile-section__item><div class=about-challenges-case-Studies-grid-carousel__mobile-section__item__count-down><div class=about-challenges-case-Studies-grid-carousel__mobile-section__item__count-down__item><div class=about-challenges-case-Studies-grid-carousel__mobile-section__item__count-down__header>{{data.slideInfo.submissions}}</div><div class=about-challenges-case-Studies-grid-carousel__mobile-section__item__count-down__desc>Submissions</div></div><div class=about-challenges-case-Studies-grid-carousel__mobile-section__item__count-down__item><div class=about-challenges-case-Studies-grid-carousel__mobile-section__item__count-down__header>{{data.slideInfo.winners}}</div><div class=about-challenges-case-Studies-grid-carousel__mobile-section__item__count-down__desc>Winners</div></div></div></div></div></div><div class=\"about-challenges-case-Studies-grid-carousel__mobile-section__grid-wrapper plus-item\"><div class=\"about-challenges-case-Studies-grid-carousel__mobile-section__item-wrapper plus-item\"><div class=about-challenges-case-Studies-grid-carousel__mobile-section__item><div class=about-challenges-case-Studies-grid-carousel__mobile-section__item__info-wrapper><div class=about-challenges-case-Studies-grid-carousel__mobile-section__item__header>{{data.slideInfo.header}}</div><div class=about-challenges-case-Studies-grid-carousel__mobile-section__item__desc>{{data.slideInfo.desc}}</div></div></div></div></div></div>");
$templateCache.put("app/components/about-challenges-case-Studies-grid-carousel/slide2-template.html","<div class=\"case-Studies-grid-carousel__pc-section slide-1-style__center width-100\"><div class=\"slide-1-style__center size-auto vertical\"><div class=\"slide-1-style__center height-56\"><div class=\"photo-slide-item photo-0\" ng-style=\"{\'background-image\': \'url(\' + data.photos[0].url + \')\'}\"><div class=photo-slide-panel><div class=photo-slide-panel__left-side><div class=photo-slide-panel__logo><div class=photo-slide-panel__logo__photo ng-style=\"{\'background-image\': \'url(\' + data.slideInfo.logoUrl + \')\'}\"></div></div><div class=photo-slide-panel__count-down><div class=photo-slide-panel__count-down__item><div class=photo-slide-panel__count-down__header>{{data.slideInfo.submissions}}</div><div class=photo-slide-panel__count-down__desc>Submissions</div></div><div class=photo-slide-panel__count-down__item><div class=photo-slide-panel__count-down__header>{{data.slideInfo.winners}}</div><div class=photo-slide-panel__count-down__desc>Winners</div></div></div></div><div class=photo-slide-panel__content><div class=photo-slide-panel__content__cover><div class=photo-slide-panel__content__header ng-bind-html=data.slideInfo.header></div><div class=photo-slide-panel__content__desc>{{data.slideInfo.desc}}</div></div></div></div></div><div class=\"photo-slide-item photo-1\" ng-style=\"{\'background-image\': \'url(\' + data.photos[1].url + \')\'}\"></div></div><div class=\"slide-1-style__center size-auto\"><div class=\"photo-slide-item photo-2 height-66\" ng-style=\"{\'background-image\': \'url(\' + data.photos[2].url + \')\'}\"><div class=photo-slide-awards><div class=photo-slide-awards__logo ng-style=\"{\'background-image\': \'url(assets/images/about-challenges-case-Studies-grid-carousel/slides/Youth-in-urban-nature.svg)\'}\"></div></div></div><div class=\"photo-slide-item photo-3 height-66\" ng-style=\"{\'background-image\': \'url(\' + data.photos[3].url + \')\'}\"></div></div></div><div class=\"slide-1-style__center width-37 vertical\"><div class=\"photo-slide-item photo-4\" ng-style=\"{\'background-image\': \'url(\' + data.photos[4].url + \')\'}\"><div class=photo-slide-awards><div class=photo-slide-awards__logo ng-style=\"{\'background-image\': \'url(assets/images/about-challenges-case-Studies-grid-carousel/slides/Youth-in-urban-nature.svg)\'}\"></div></div></div><div class=\"photo-slide-item photo-5 height-79\" ng-style=\"{\'background-image\': \'url(\' + data.photos[5].url + \')\'}\"></div><!-- <div class=\"photo-slide-item photo-6 size-auto\"\r\n            ng-style=\"{\'background-image\': \'url(\' + data.photos[6].url + \')\'}\">\r\n        </div> --></div></div><div class=about-challenges-case-Studies-grid-carousel__mobile-section><div class=about-challenges-case-Studies-grid-carousel__mobile-section__grid-wrapper><div ng-click=vm.showPhotoPopup(data.photos[0]) class=about-challenges-case-Studies-grid-carousel__mobile-section__item-wrapper><div class=about-challenges-case-Studies-grid-carousel__mobile-section__item><div class=\"about-challenges-case-Studies-grid-carousel__mobile-section__item__background zoom-hover\" ng-style=\"{\'background-image\': \'url(\\\'\' + data.photos[0].urlMobile + \'\\\')\'}\"></div></div></div><div ng-click=vm.showPhotoPopup(data.photos[1]) class=\"about-challenges-case-Studies-grid-carousel__mobile-section__item-wrapper item-plus\"><div class=about-challenges-case-Studies-grid-carousel__mobile-section__item><div class=\"about-challenges-case-Studies-grid-carousel__mobile-section__item__background zoom-hover\" ng-style=\"{\'background-image\': \'url(\\\'\' + data.photos[1].urlMobile + \'\\\')\'}\"></div></div></div></div><div class=about-challenges-case-Studies-grid-carousel__mobile-section__grid-wrapper><div ng-click=vm.showPhotoPopup(data.photos[2]) class=\"about-challenges-case-Studies-grid-carousel__mobile-section__item-wrapper item-plus\"><div class=about-challenges-case-Studies-grid-carousel__mobile-section__item><div class=\"about-challenges-case-Studies-grid-carousel__mobile-section__item__background zoom-hover\" ng-style=\"{\'background-image\': \'url(\\\'\' + data.photos[2].urlMobile + \'\\\')\'}\"><div class=photo-slide-awards-mobile><div class=photo-slide-awards-mobile__logo ng-style=\"{\'background-image\': \'url(assets/images/about-challenges-case-Studies-grid-carousel/slides/youth-inurban-nature-mobile.svg)\'}\"></div></div></div></div></div><div ng-click=vm.showPhotoPopup(data.photos[3]) class=about-challenges-case-Studies-grid-carousel__mobile-section__item-wrapper><div class=about-challenges-case-Studies-grid-carousel__mobile-section__item><div class=\"about-challenges-case-Studies-grid-carousel__mobile-section__item__background zoom-hover\" ng-style=\"{\'background-image\': \'url(\\\'\' + data.photos[3].urlMobile + \'\\\')\'}\"></div></div></div></div><div class=about-challenges-case-Studies-grid-carousel__mobile-section__grid-wrapper><div ng-click=vm.showPhotoPopup(data.photos[4]) class=about-challenges-case-Studies-grid-carousel__mobile-section__item-wrapper><div class=about-challenges-case-Studies-grid-carousel__mobile-section__item><div class=\"about-challenges-case-Studies-grid-carousel__mobile-section__item__background zoom-hover\" ng-style=\"{\'background-image\': \'url(\\\'\' + data.photos[4].urlMobile + \'\\\')\'}\"></div></div></div><div ng-click=vm.showPhotoPopup(data.photos[5]) class=\"about-challenges-case-Studies-grid-carousel__mobile-section__item-wrapper item-plus\"><div class=about-challenges-case-Studies-grid-carousel__mobile-section__item><div class=\"about-challenges-case-Studies-grid-carousel__mobile-section__item__background zoom-hover\" ng-style=\"{\'background-image\': \'url(\\\'\' + data.photos[5].urlMobile + \'\\\')\'}\"><div class=photo-slide-awards-mobile><div class=photo-slide-awards-mobile__logo ng-style=\"{\'background-image\': \'url(assets/images/about-challenges-case-Studies-grid-carousel/slides/youth-inurban-nature-mobile.svg)\'}\"></div></div></div></div></div></div><div class=about-challenges-case-Studies-grid-carousel__mobile-section__grid-info-wrapper><div class=\"about-challenges-case-Studies-grid-carousel__mobile-section__item-wrapper background-desert-storm\"><div class=about-challenges-case-Studies-grid-carousel__mobile-section__item><div class=about-challenges-case-Studies-grid-carousel__mobile-section__item__logo ng-style=\"{\'background-image\': \'url(\' + data.slideInfo.logoUrlMobile + \')\'}\"></div></div></div><div class=\"about-challenges-case-Studies-grid-carousel__mobile-section__item-wrapper background-desert-storm\"><div class=about-challenges-case-Studies-grid-carousel__mobile-section__item><div class=about-challenges-case-Studies-grid-carousel__mobile-section__item__count-down><div class=about-challenges-case-Studies-grid-carousel__mobile-section__item__count-down__item><div class=about-challenges-case-Studies-grid-carousel__mobile-section__item__count-down__header>{{data.slideInfo.submissions}}</div><div class=about-challenges-case-Studies-grid-carousel__mobile-section__item__count-down__desc>Submissions</div></div><div class=about-challenges-case-Studies-grid-carousel__mobile-section__item__count-down__item><div class=about-challenges-case-Studies-grid-carousel__mobile-section__item__count-down__header>{{data.slideInfo.winners}}</div><div class=about-challenges-case-Studies-grid-carousel__mobile-section__item__count-down__desc>Winners</div></div></div></div></div></div><div class=\"about-challenges-case-Studies-grid-carousel__mobile-section__grid-wrapper plus-item\"><div class=\"about-challenges-case-Studies-grid-carousel__mobile-section__item-wrapper plus-item\"><div class=about-challenges-case-Studies-grid-carousel__mobile-section__item><div class=about-challenges-case-Studies-grid-carousel__mobile-section__item__info-wrapper><div class=about-challenges-case-Studies-grid-carousel__mobile-section__item__header ng-bind-html=data.slideInfo.header></div><div class=about-challenges-case-Studies-grid-carousel__mobile-section__item__desc>{{data.slideInfo.desc}}</div></div></div></div></div></div>");
$templateCache.put("app/components/about-challenges-case-Studies-grid-carousel/slide3-template.html","<div class=\"case-Studies-grid-carousel__pc-section slide-2-style__center width-100 vertical\"><div class=\"slide-2-style__center height-34\"><div class=\"photo-slide-item photo-0\" ng-style=\"{\'background-image\': \'url(\' + data.photos[0].url + \')\'}\"></div><div class=\"photo-slide-item photo-1\" ng-style=\"{\'background-image\': \'url(\' + data.photos[1].url + \')\'}\"></div><div class=\"photo-slide-item photo-2\" ng-style=\"{\'background-image\': \'url(\' + data.photos[2].url + \')\'}\"></div><div class=\"photo-slide-item photo-3\" ng-style=\"{\'background-image\': \'url(\' + data.photos[3].url + \')\'}\"><div class=\"photo-slide-awards photo-slide-awards-double\"><div class=photo-slide-awards__logo ng-style=\"{\'background-image\': \'url(assets/images/about-challenges-case-Studies-grid-carousel/slides/Super-canggih.svg)\'}\"></div></div></div></div><div class=\"slide-2-style__center size-auto\"><div class=\"photo-slide-item photo-4 height-66\" ng-style=\"{\'background-image\': \'url(\' + data.photos[4].url + \')\'}\"><div class=photo-slide-panel><div class=photo-slide-panel__left-side><div class=photo-slide-panel__logo><div class=photo-slide-panel__logo__photo ng-style=\"{\'background-image\': \'url(\' + data.slideInfo.logoUrl + \')\'}\"></div></div><div class=photo-slide-panel__count-down><div class=photo-slide-panel__count-down__item><div class=photo-slide-panel__count-down__header>{{data.slideInfo.submissions}}</div><div class=photo-slide-panel__count-down__desc>Submissions</div></div><div class=photo-slide-panel__count-down__item><div class=photo-slide-panel__count-down__header>{{data.slideInfo.winners}}</div><div class=photo-slide-panel__count-down__desc>Winners</div></div></div></div><div class=photo-slide-panel__content><div class=photo-slide-panel__content__cover><div class=photo-slide-panel__content__header>{{data.slideInfo.header}}</div><div class=photo-slide-panel__content__desc>{{data.slideInfo.desc}}</div></div></div></div></div><div class=\"photo-slide-item photo-5 height-66\" ng-style=\"{\'background-image\': \'url(\' + data.photos[5].url + \')\'}\"><div class=photo-slide-awards><div class=photo-slide-awards__logo ng-style=\"{\'background-image\': \'url(assets/images/about-challenges-case-Studies-grid-carousel/slides/Super-canggih.svg)\'}\"></div></div></div><div class=\"photo-slide-item photo-6 height-66\" ng-style=\"{\'background-image\': \'url(\' + data.photos[6].url + \')\'}\"></div></div></div><div class=about-challenges-case-Studies-grid-carousel__mobile-section><div class=about-challenges-case-Studies-grid-carousel__mobile-section__grid-wrapper><div ng-click=vm.showPhotoPopup(data.photos[0]) class=\"about-challenges-case-Studies-grid-carousel__mobile-section__item-wrapper item-plus\"><div class=about-challenges-case-Studies-grid-carousel__mobile-section__item><div class=\"about-challenges-case-Studies-grid-carousel__mobile-section__item__background zoom-hover\" ng-style=\"{\'background-image\': \'url(\\\'\' + data.photos[0].urlMobile + \'\\\')\'}\"><div class=photo-slide-awards-mobile><div class=photo-slide-awards-mobile__logo ng-style=\"{\'background-image\': \'url(assets/images/about-challenges-case-Studies-grid-carousel/slides/Super-canggih-mobile.svg)\'}\"></div></div></div></div></div><div ng-click=vm.showPhotoPopup(data.photos[1]) class=about-challenges-case-Studies-grid-carousel__mobile-section__item-wrapper><div class=about-challenges-case-Studies-grid-carousel__mobile-section__item><div class=\"about-challenges-case-Studies-grid-carousel__mobile-section__item__background zoom-hover\" ng-style=\"{\'background-image\': \'url(\\\'\' + data.photos[1].urlMobile + \'\\\')\'}\"></div></div></div></div><div class=about-challenges-case-Studies-grid-carousel__mobile-section__grid-wrapper><div ng-click=vm.showPhotoPopup(data.photos[2]) class=about-challenges-case-Studies-grid-carousel__mobile-section__item-wrapper><div class=about-challenges-case-Studies-grid-carousel__mobile-section__item><div class=\"about-challenges-case-Studies-grid-carousel__mobile-section__item__background zoom-hover\" ng-style=\"{\'background-image\': \'url(\\\'\' + data.photos[2].urlMobile + \'\\\')\'}\"></div></div></div><div ng-click=vm.showPhotoPopup(data.photos[3]) class=about-challenges-case-Studies-grid-carousel__mobile-section__item-wrapper><div class=about-challenges-case-Studies-grid-carousel__mobile-section__item><div class=\"about-challenges-case-Studies-grid-carousel__mobile-section__item__background zoom-hover\" ng-style=\"{\'background-image\': \'url(\\\'\' + data.photos[3].urlMobile + \'\\\')\'}\"><div class=photo-slide-awards-mobile><div class=photo-slide-awards-mobile__logo ng-style=\"{\'background-image\': \'url(assets/images/about-challenges-case-Studies-grid-carousel/slides/Super-canggih-mobile.svg)\'}\"></div></div></div></div></div><div ng-click=vm.showPhotoPopup(data.photos[4]) class=about-challenges-case-Studies-grid-carousel__mobile-section__item-wrapper><div class=about-challenges-case-Studies-grid-carousel__mobile-section__item><div class=\"about-challenges-case-Studies-grid-carousel__mobile-section__item__background zoom-hover\" ng-style=\"{\'background-image\': \'url(\\\'\' + data.photos[4].urlMobile + \'\\\')\'}\"></div></div></div></div><div class=about-challenges-case-Studies-grid-carousel__mobile-section__grid-wrapper><div ng-click=vm.showPhotoPopup(data.photos[5]) class=about-challenges-case-Studies-grid-carousel__mobile-section__item-wrapper><div class=about-challenges-case-Studies-grid-carousel__mobile-section__item><div class=\"about-challenges-case-Studies-grid-carousel__mobile-section__item__background zoom-hover\" ng-style=\"{\'background-image\': \'url(\\\'\' + data.photos[5].urlMobile + \'\\\')\'}\"></div></div></div><div ng-click=vm.showPhotoPopup(data.photos[6]) class=\"about-challenges-case-Studies-grid-carousel__mobile-section__item-wrapper item-plus\"><div class=about-challenges-case-Studies-grid-carousel__mobile-section__item><div class=\"about-challenges-case-Studies-grid-carousel__mobile-section__item__background zoom-hover\" ng-style=\"{\'background-image\': \'url(\\\'\' + data.photos[6].urlMobile + \'\\\')\'}\"></div></div></div></div><div class=about-challenges-case-Studies-grid-carousel__mobile-section__grid-info-wrapper><div class=\"about-challenges-case-Studies-grid-carousel__mobile-section__item-wrapper background-desert-storm\"><div class=about-challenges-case-Studies-grid-carousel__mobile-section__item><div class=about-challenges-case-Studies-grid-carousel__mobile-section__item__logo ng-style=\"{\'background-image\': \'url(\' + data.slideInfo.logoUrlMobile + \')\'}\"></div></div></div><div class=\"about-challenges-case-Studies-grid-carousel__mobile-section__item-wrapper background-desert-storm\"><div class=about-challenges-case-Studies-grid-carousel__mobile-section__item><div class=about-challenges-case-Studies-grid-carousel__mobile-section__item__count-down><div class=about-challenges-case-Studies-grid-carousel__mobile-section__item__count-down__item><div class=about-challenges-case-Studies-grid-carousel__mobile-section__item__count-down__header>{{data.slideInfo.submissions}}</div><div class=about-challenges-case-Studies-grid-carousel__mobile-section__item__count-down__desc>Submissions</div></div><div class=about-challenges-case-Studies-grid-carousel__mobile-section__item__count-down__item><div class=about-challenges-case-Studies-grid-carousel__mobile-section__item__count-down__header>{{data.slideInfo.winners}}</div><div class=about-challenges-case-Studies-grid-carousel__mobile-section__item__count-down__desc>Winners</div></div></div></div></div></div><div class=\"about-challenges-case-Studies-grid-carousel__mobile-section__grid-wrapper plus-item\"><div class=\"about-challenges-case-Studies-grid-carousel__mobile-section__item-wrapper plus-item\"><div class=about-challenges-case-Studies-grid-carousel__mobile-section__item><div class=about-challenges-case-Studies-grid-carousel__mobile-section__item__info-wrapper><div class=about-challenges-case-Studies-grid-carousel__mobile-section__item__header ng-bind-html=data.slideInfo.header></div><div class=about-challenges-case-Studies-grid-carousel__mobile-section__item__desc>{{data.slideInfo.desc}}</div></div></div></div></div></div>");
$templateCache.put("app/components/about-challenges-case-Studies-grid-carousel/slide4-template.html","<div class=\"case-Studies-grid-carousel__pc-section slide-3-style__center width-100\"><div class=\"slide-3-style__center size-auto vertical\"><div class=\"slide-3-style__center height-56\"><div class=\"photo-slide-item photo-0\" ng-style=\"{\'background-image\': \'url(\' + data.photos[0].url + \')\'}\"><div class=\"photo-slide-awards-custom top-right\"><div class=photo-slide-awards-custom__logo ng-style=\"{\'background-image\': \'url(assets/images/about-challenges-case-Studies-grid-carousel/slides/challenge-winner.svg)\'}\"></div><span class=photo-slide-awards-custom__desc-image ng-style=\"{\'background-image\': \'url(assets/images/about-challenges-case-Studies-grid-carousel/slides/Museum-of-hacks.svg)\'}\"></span></div><div class=photo-slide-panel><div class=photo-slide-panel__left-side><div class=photo-slide-panel__logo><div class=photo-slide-panel__logo__photo ng-style=\"{\'background-image\': \'url(\' + data.slideInfo.logoUrl + \')\'}\"></div></div><div class=photo-slide-panel__count-down><div class=photo-slide-panel__count-down__item><div class=photo-slide-panel__count-down__header>{{data.slideInfo.submissions}}</div><div class=photo-slide-panel__count-down__desc>Submissions</div></div><div class=photo-slide-panel__count-down__item><div class=photo-slide-panel__count-down__header>{{data.slideInfo.winners}}</div><div class=photo-slide-panel__count-down__desc>Winners</div></div></div></div><div class=photo-slide-panel__content><div class=photo-slide-panel__content__cover><div class=photo-slide-panel__content__header>{{data.slideInfo.header}}</div><div class=photo-slide-panel__content__desc>{{data.slideInfo.desc}}</div></div></div></div></div><div class=\"photo-slide-item photo-1\" ng-style=\"{\'background-image\': \'url(\' + data.photos[1].url + \')\'}\"></div></div><div class=\"slide-3-style__center size-auto\"><div class=\"photo-slide-item photo-2 height-66\" ng-style=\"{\'background-image\': \'url(\' + data.photos[2].url + \')\'}\"></div><div class=\"photo-slide-item photo-3 height-66\" ng-style=\"{\'background-image\': \'url(\' + data.photos[3].url + \')\'}\"></div></div></div><div class=\"slide-3-style__center width-37 vertical\"><div class=\"photo-slide-item photo-4\" ng-style=\"{\'background-image\': \'url(\' + data.photos[4].url + \')\'}\"></div><div class=\"photo-slide-item photo-5 height-79\" ng-style=\"{\'background-image\': \'url(\' + data.photos[5].url + \')\'}\"><div class=photo-slide-awards-custom><div class=photo-slide-awards-custom__logo ng-style=\"{\'background-image\': \'url(assets/images/about-challenges-case-Studies-grid-carousel/slides/challenge-winner.svg)\'}\"></div><span class=photo-slide-awards-custom__desc-image ng-style=\"{\'background-image\': \'url(assets/images/about-challenges-case-Studies-grid-carousel/slides/Museum-of-hacks.svg)\'}\"></span></div></div></div></div><div class=about-challenges-case-Studies-grid-carousel__mobile-section><div class=about-challenges-case-Studies-grid-carousel__mobile-section__grid-wrapper><div ng-click=vm.showPhotoPopup(data.photos[0]) class=about-challenges-case-Studies-grid-carousel__mobile-section__item-wrapper><div class=about-challenges-case-Studies-grid-carousel__mobile-section__item><div class=\"about-challenges-case-Studies-grid-carousel__mobile-section__item__background zoom-hover\" ng-style=\"{\'background-image\': \'url(\\\'\' + data.photos[0].urlMobile + \'\\\')\'}\"><div class=photo-slide-awards-mobile><div class=photo-slide-awards-mobile__logo ng-style=\"{\'background-image\': \'url(assets/images/about-challenges-case-Studies-grid-carousel/slides/Museum-of-hacks-mobile.svg)\'}\"></div></div></div></div></div><div ng-click=vm.showPhotoPopup(data.photos[1]) class=\"about-challenges-case-Studies-grid-carousel__mobile-section__item-wrapper item-plus\"><div class=about-challenges-case-Studies-grid-carousel__mobile-section__item><div class=\"about-challenges-case-Studies-grid-carousel__mobile-section__item__background zoom-hover\" ng-style=\"{\'background-image\': \'url(\\\'\' + data.photos[1].urlMobile + \'\\\')\'}\"></div></div></div><div ng-click=vm.showPhotoPopup(data.photos[2]) class=about-challenges-case-Studies-grid-carousel__mobile-section__item-wrapper><div class=about-challenges-case-Studies-grid-carousel__mobile-section__item><div class=\"about-challenges-case-Studies-grid-carousel__mobile-section__item__background zoom-hover\" ng-style=\"{\'background-image\': \'url(\\\'\' + data.photos[2].urlMobile + \'\\\')\'}\"></div></div></div></div><div class=about-challenges-case-Studies-grid-carousel__mobile-section__grid-wrapper></div><div class=about-challenges-case-Studies-grid-carousel__mobile-section__grid-wrapper><div ng-click=vm.showPhotoPopup(data.photos[3]) class=\"about-challenges-case-Studies-grid-carousel__mobile-section__item-wrapper item-plus\"><div class=about-challenges-case-Studies-grid-carousel__mobile-section__item><div class=\"about-challenges-case-Studies-grid-carousel__mobile-section__item__background zoom-hover\" ng-style=\"{\'background-image\': \'url(\\\'\' + data.photos[3].urlMobile + \'\\\')\'}\"></div></div></div><div ng-click=vm.showPhotoPopup(data.photos[4]) class=about-challenges-case-Studies-grid-carousel__mobile-section__item-wrapper><div class=about-challenges-case-Studies-grid-carousel__mobile-section__item><div class=\"about-challenges-case-Studies-grid-carousel__mobile-section__item__background zoom-hover\" ng-style=\"{\'background-image\': \'url(\\\'\' + data.photos[4].urlMobile + \'\\\')\'}\"></div></div></div><div ng-click=vm.showPhotoPopup(data.photos[5]) class=about-challenges-case-Studies-grid-carousel__mobile-section__item-wrapper><div class=about-challenges-case-Studies-grid-carousel__mobile-section__item><div class=\"about-challenges-case-Studies-grid-carousel__mobile-section__item__background zoom-hover\" ng-style=\"{\'background-image\': \'url(\\\'\' + data.photos[5].urlMobile + \'\\\')\'}\"><div class=photo-slide-awards-mobile><div class=photo-slide-awards-mobile__logo ng-style=\"{\'background-image\': \'url(assets/images/about-challenges-case-Studies-grid-carousel/slides/Museum-of-hacks-mobile.svg)\'}\"></div></div></div></div></div></div><div class=about-challenges-case-Studies-grid-carousel__mobile-section__grid-info-wrapper><div class=\"about-challenges-case-Studies-grid-carousel__mobile-section__item-wrapper background-desert-storm\"><div class=about-challenges-case-Studies-grid-carousel__mobile-section__item><div class=about-challenges-case-Studies-grid-carousel__mobile-section__item__logo ng-style=\"{\'background-image\': \'url(\' + data.slideInfo.logoUrlMobile + \')\'}\"></div></div></div><div class=\"about-challenges-case-Studies-grid-carousel__mobile-section__item-wrapper background-desert-storm\"><div class=about-challenges-case-Studies-grid-carousel__mobile-section__item><div class=about-challenges-case-Studies-grid-carousel__mobile-section__item__count-down><div class=about-challenges-case-Studies-grid-carousel__mobile-section__item__count-down__item><div class=about-challenges-case-Studies-grid-carousel__mobile-section__item__count-down__header>{{data.slideInfo.submissions}}</div><div class=about-challenges-case-Studies-grid-carousel__mobile-section__item__count-down__desc>Submissions</div></div><div class=about-challenges-case-Studies-grid-carousel__mobile-section__item__count-down__item><div class=about-challenges-case-Studies-grid-carousel__mobile-section__item__count-down__header>{{data.slideInfo.winners}}</div><div class=about-challenges-case-Studies-grid-carousel__mobile-section__item__count-down__desc>Winners</div></div></div></div></div></div><div class=\"about-challenges-case-Studies-grid-carousel__mobile-section__grid-wrapper plus-item\"><div class=\"about-challenges-case-Studies-grid-carousel__mobile-section__item-wrapper plus-item\"><div class=about-challenges-case-Studies-grid-carousel__mobile-section__item><div class=about-challenges-case-Studies-grid-carousel__mobile-section__item__info-wrapper><div class=about-challenges-case-Studies-grid-carousel__mobile-section__item__header ng-bind-html=data.slideInfo.header></div><div class=about-challenges-case-Studies-grid-carousel__mobile-section__item__desc>{{data.slideInfo.desc}}</div></div></div></div></div></div>");
$templateCache.put("app/components/about-challenges-case-Studies-grid-carousel/slide5-template.html","<div class=\"case-Studies-grid-carousel__pc-section slide-4-style__center width-100\"><div class=\"slide-4-style__center width-56\"><div class=\"slide-4-style__center width-33 vertical\"><div class=\"photo-slide-item photo-0 size-auto\" ng-style=\"{\'background-image\': \'url(\' + data.photos[0].url + \')\'}\"></div><div class=\"photo-slide-item photo-1 height-34\" ng-style=\"{\'background-image\': \'url(\' + data.photos[1].url + \')\'}\"></div></div><div class=\"slide-4-style__center size-auto vertical\"><div class=\"photo-slide-item photo-2 height-56\" ng-style=\"{\'background-image\': \'url(\' + data.photos[2].url + \')\'}\"><div class=photo-slide-panel><div class=photo-slide-panel__left-side><div class=photo-slide-panel__logo><div class=photo-slide-panel__logo__photo ng-style=\"{\'background-image\': \'url(\' + data.slideInfo.logoUrl + \')\'}\"></div></div><div class=photo-slide-panel__count-down><div class=photo-slide-panel__count-down__item><div class=photo-slide-panel__count-down__header>{{data.slideInfo.submissions}}</div><div class=photo-slide-panel__count-down__desc>Submissions</div></div><div class=photo-slide-panel__count-down__item><div class=photo-slide-panel__count-down__header>{{data.slideInfo.winners}}</div><div class=photo-slide-panel__count-down__desc>Winners</div></div></div></div><div class=photo-slide-panel__content><div class=photo-slide-panel__content__cover><div class=photo-slide-panel__content__header>{{data.slideInfo.header}}</div><div class=photo-slide-panel__content__desc>{{data.slideInfo.desc}}</div></div></div></div></div><div class=\"slide-4-style__center size-auto\"><div class=\"photo-slide-item photo-3 height-100\" ng-style=\"{\'background-image\': \'url(\' + data.photos[3].url + \')\'}\"></div><div class=\"photo-slide-item photo-4 height-100\" ng-style=\"{\'background-image\': \'url(\' + data.photos[4].url + \')\'}\"></div></div></div></div><div class=\"slide-4-style__center size-auto\"><div class=\"slide-4-style__center width-57 vertical\"><div class=\"photo-slide-item photo-5\" ng-style=\"{\'background-image\': \'url(\' + data.photos[5].url + \')\'}\"></div><div class=\"photo-slide-item photo-6\" ng-style=\"{\'background-image\': \'url(\' + data.photos[6].url + \')\'}\"><div class=photo-slide-awards-custom><div class=photo-slide-awards-custom__logo ng-style=\"{\'background-image\': \'url(assets/images/about-challenges-case-Studies-grid-carousel/slides/challenge-winner.svg)\'}\"></div><span class=photo-slide-awards-custom__desc-image ng-style=\"{\'background-image\': \'url(assets/images/about-challenges-case-Studies-grid-carousel/slides/Images-of-asia.svg)\'}\"></span></div></div></div><div class=\"slide-4-style__center size-auto vertical\"><div class=\"photo-slide-item photo-7\" ng-style=\"{\'background-image\': \'url(\' + data.photos[7].url + \')\'}\"></div><div class=\"photo-slide-item photo-8\" ng-style=\"{\'background-image\': \'url(\' + data.photos[8].url + \')\'}\"></div></div></div></div><div class=about-challenges-case-Studies-grid-carousel__mobile-section><div class=about-challenges-case-Studies-grid-carousel__mobile-section__grid-wrapper><div ng-click=vm.showPhotoPopup(data.photos[0]) class=about-challenges-case-Studies-grid-carousel__mobile-section__item-wrapper><div class=about-challenges-case-Studies-grid-carousel__mobile-section__item><div class=\"about-challenges-case-Studies-grid-carousel__mobile-section__item__background zoom-hover\" ng-style=\"{\'background-image\': \'url(\\\'\' + data.photos[0].urlMobile + \'\\\')\'}\"></div></div></div><div ng-click=vm.showPhotoPopup(data.photos[1]) class=about-challenges-case-Studies-grid-carousel__mobile-section__item-wrapper><div class=about-challenges-case-Studies-grid-carousel__mobile-section__item><div class=\"about-challenges-case-Studies-grid-carousel__mobile-section__item__background zoom-hover\" ng-style=\"{\'background-image\': \'url(\\\'\' + data.photos[1].urlMobile + \'\\\')\'}\"></div></div></div><div ng-click=vm.showPhotoPopup(data.photos[2]) class=about-challenges-case-Studies-grid-carousel__mobile-section__item-wrapper><div class=about-challenges-case-Studies-grid-carousel__mobile-section__item><div class=\"about-challenges-case-Studies-grid-carousel__mobile-section__item__background zoom-hover\" ng-style=\"{\'background-image\': \'url(\\\'\' + data.photos[2].urlMobile + \'\\\')\'}\"></div></div></div></div><div class=about-challenges-case-Studies-grid-carousel__mobile-section__grid-wrapper><div ng-click=vm.showPhotoPopup(data.photos[3]) class=about-challenges-case-Studies-grid-carousel__mobile-section__item-wrapper><div class=about-challenges-case-Studies-grid-carousel__mobile-section__item><div class=\"about-challenges-case-Studies-grid-carousel__mobile-section__item__background zoom-hover\" ng-style=\"{\'background-image\': \'url(\\\'\' + data.photos[3].urlMobile + \'\\\')\'}\"></div></div></div><div ng-click=vm.showPhotoPopup(data.photos[4]) class=about-challenges-case-Studies-grid-carousel__mobile-section__item-wrapper><div class=about-challenges-case-Studies-grid-carousel__mobile-section__item><div class=\"about-challenges-case-Studies-grid-carousel__mobile-section__item__background zoom-hover\" ng-style=\"{\'background-image\': \'url(\\\'\' + data.photos[4].urlMobile + \'\\\')\'}\"><div class=photo-slide-awards-mobile><div class=photo-slide-awards-mobile__logo ng-style=\"{\'background-image\': \'url(assets/images/about-challenges-case-Studies-grid-carousel/slides/Images-of-asia-mobile.svg)\'}\"></div></div></div></div></div><div ng-click=vm.showPhotoPopup(data.photos[5]) class=about-challenges-case-Studies-grid-carousel__mobile-section__item-wrapper><div class=about-challenges-case-Studies-grid-carousel__mobile-section__item><div class=\"about-challenges-case-Studies-grid-carousel__mobile-section__item__background zoom-hover\" ng-style=\"{\'background-image\': \'url(\\\'\' + data.photos[5].urlMobile + \'\\\')\'}\"></div></div></div></div><div class=about-challenges-case-Studies-grid-carousel__mobile-section__grid-wrapper><div ng-click=vm.showPhotoPopup(data.photos[6]) class=about-challenges-case-Studies-grid-carousel__mobile-section__item-wrapper><div class=about-challenges-case-Studies-grid-carousel__mobile-section__item><div class=\"about-challenges-case-Studies-grid-carousel__mobile-section__item__background zoom-hover\" ng-style=\"{\'background-image\': \'url(\\\'\' + data.photos[6].urlMobile + \'\\\')\'}\"></div></div></div><div ng-click=vm.showPhotoPopup(data.photos[7]) class=about-challenges-case-Studies-grid-carousel__mobile-section__item-wrapper><div class=about-challenges-case-Studies-grid-carousel__mobile-section__item><div class=\"about-challenges-case-Studies-grid-carousel__mobile-section__item__background zoom-hover\" ng-style=\"{\'background-image\': \'url(\\\'\' + data.photos[7].urlMobile + \'\\\')\'}\"></div></div></div><div ng-click=vm.showPhotoPopup(data.photos[8]) class=about-challenges-case-Studies-grid-carousel__mobile-section__item-wrapper><div class=about-challenges-case-Studies-grid-carousel__mobile-section__item><div class=\"about-challenges-case-Studies-grid-carousel__mobile-section__item__background zoom-hover\" ng-style=\"{\'background-image\': \'url(\\\'\' + data.photos[8].urlMobile + \'\\\')\'}\"></div></div></div></div><div class=about-challenges-case-Studies-grid-carousel__mobile-section__grid-info-wrapper><div class=\"about-challenges-case-Studies-grid-carousel__mobile-section__item-wrapper background-desert-storm\"><div class=about-challenges-case-Studies-grid-carousel__mobile-section__item><div class=about-challenges-case-Studies-grid-carousel__mobile-section__item__logo ng-style=\"{\'background-image\': \'url(\' + data.slideInfo.logoUrlMobile + \')\'}\"></div></div></div><div class=\"about-challenges-case-Studies-grid-carousel__mobile-section__item-wrapper background-desert-storm\"><div class=about-challenges-case-Studies-grid-carousel__mobile-section__item><div class=about-challenges-case-Studies-grid-carousel__mobile-section__item__count-down><div class=about-challenges-case-Studies-grid-carousel__mobile-section__item__count-down__item><div class=about-challenges-case-Studies-grid-carousel__mobile-section__item__count-down__header>{{data.slideInfo.submissions}}</div><div class=about-challenges-case-Studies-grid-carousel__mobile-section__item__count-down__desc>Submissions</div></div><div class=about-challenges-case-Studies-grid-carousel__mobile-section__item__count-down__item><div class=about-challenges-case-Studies-grid-carousel__mobile-section__item__count-down__header>{{data.slideInfo.winners}}</div><div class=about-challenges-case-Studies-grid-carousel__mobile-section__item__count-down__desc>Winners</div></div></div></div></div></div><div class=\"about-challenges-case-Studies-grid-carousel__mobile-section__grid-wrapper plus-item\"><div class=\"about-challenges-case-Studies-grid-carousel__mobile-section__item-wrapper plus-item\"><div class=about-challenges-case-Studies-grid-carousel__mobile-section__item><div class=about-challenges-case-Studies-grid-carousel__mobile-section__item__info-wrapper><div class=about-challenges-case-Studies-grid-carousel__mobile-section__item__header ng-bind-html=data.slideInfo.header></div><div class=about-challenges-case-Studies-grid-carousel__mobile-section__item__desc>{{data.slideInfo.desc}}</div></div></div></div></div></div>");
$templateCache.put("app/components/about-community-case-Studies-grid-carousel/about-community-case-Studies-grid-carousel.html","<div class=about-community-case-Studies-grid-carousel><slick data=vm.slideDatas arrows=false on-init=vm.slickSetting.onInit(slick) adaptive-height=true class=about-community-case-Studies-grid-carousel__slick><div ng-repeat=\"data in vm.slideDatas\"><ng-include ng-if=\"$index == 0\" src=\"\'app/components/about-community-case-Studies-grid-carousel/slide1-template.html\'\" class=\"about-community-case-Studies-grid-carousel__template-include slide-{{$index}}-style\"></ng-include><ng-include ng-if=\"$index == 1\" src=\"\'app/components/about-community-case-Studies-grid-carousel/slide2-template.html\'\" class=\"about-community-case-Studies-grid-carousel__template-include slide-{{$index}}-style\"></ng-include><ng-include ng-if=\"$index == 2\" src=\"\'app/components/about-community-case-Studies-grid-carousel/slide3-template.html\'\" class=\"about-community-case-Studies-grid-carousel__template-include slide-{{$index}}-style\"></ng-include><ng-include ng-if=\"$index == 3\" src=\"\'app/components/about-community-case-Studies-grid-carousel/slide4-template.html\'\" class=\"about-community-case-Studies-grid-carousel__template-include slide-{{$index}}-style\"></ng-include><ng-include ng-if=\"$index == 4\" src=\"\'app/components/about-community-case-Studies-grid-carousel/slide5-template.html\'\" class=\"about-community-case-Studies-grid-carousel__template-include slide-{{$index}}-style\"></ng-include><ng-include ng-if=\"$index == 5\" src=\"\'app/components/about-community-case-Studies-grid-carousel/slide6-template.html\'\" class=\"about-community-case-Studies-grid-carousel__template-include slide-{{$index}}-style\"></ng-include></div></slick><div class=about-community-case-Studies-grid-carousel__slide-control><div class=about-community-case-Studies-grid-carousel__slide-control__indicator><div ng-repeat=\"item in vm.slideDatas\" ng-click=vm.onNavClicked($index) ng-class=\"{\'active\': vm.isActive($index)}\" class=about-community-case-Studies-grid-carousel__slide-control__indicator__item></div></div></div><div class=about-community-case-Studies-grid-carousel__navigate><div class=\"about-community-case-Studies-grid-carousel__navigate__left icon-slide-prev-icon\" ng-click=vm.onPreviousSlide()></div><div class=\"about-community-case-Studies-grid-carousel__navigate__right icon-slide-next-icon\" ng-click=vm.onNextSlide()></div></div></div>");
$templateCache.put("app/components/about-community-case-Studies-grid-carousel/slide1-template.html","<div class=\"about-community-case-Studies-grid-carousel__pc-section slide-0-style__center width-100 vertical\"><div class=\"slide-0-style__center height-40\"><div class=\"photo-slide-item photo-0\" ng-style=\"{\'background-image\': \'url(\' + data.photos[0].url + \')\'}\"></div><div class=\"photo-slide-item photo-1\" ng-style=\"{\'background-image\': \'url(\' + data.photos[1].url + \')\'}\"></div><div class=\"photo-slide-item photo-2\" ng-style=\"{\'background-image\': \'url(\' + data.photos[2].url + \')\'}\"></div></div><div class=\"slide-0-style__center size-auto\"><div class=\"slide-0-style__center vertical width-33\"><div class=\"photo-slide-item photo-3 height-79\" ng-style=\"{\'background-image\': \'url(\' + data.photos[3].url + \')\'}\"></div><div class=\"photo-slide-item photo-4 size-auto\" ng-style=\"{\'background-image\': \'url(\' + data.photos[4].url + \')\'}\"></div></div><div class=\"photo-slide-item photo-5 size-auto\" ng-style=\"{\'background-image\': \'url(\' + data.photos[5].url + \')\'}\"></div><div class=\"photo-slide-item photo-6\" ng-style=\"{\'background-image\': \'url(\' + data.photos[6].url + \')\'}\"><div class=photo-slide-panel><div class=photo-slide-panel__header><div class=photo-slide-panel__header__logo ng-style=\"{\'background-image\': \'url(\' + data.slideInfo.logoUrl + \')\'}\"></div><div class=photo-slide-panel__header__col-right><div class=photo-slide-panel__header__title>{{data.slideInfo.header}}</div><div class=photo-slide-panel__header__location>{{data.slideInfo.subHeader}}</div></div></div><div class=photo-slide-panel__content>{{data.slideInfo.desc}}<div class=photo-slide-panel__source>(Source: The drum)</div></div></div></div></div></div><div class=about-community-case-Studies-grid-carousel__mobile-section><div class=about-community-case-Studies-grid-carousel__mobile-section__grid-wrapper><div ng-click=vm.showPhotoPopup(data.photos[0]) class=about-community-case-Studies-grid-carousel__mobile-section__item-wrapper><div class=about-community-case-Studies-grid-carousel__mobile-section__item><div class=\"about-community-case-Studies-grid-carousel__mobile-section__item__background zoom-hover\" ng-style=\"{\'background-image\': \'url(\\\'\' + data.photos[0].urlMobile + \'\\\')\'}\"></div></div></div><div ng-click=vm.showPhotoPopup(data.photos[1]) class=about-community-case-Studies-grid-carousel__mobile-section__item-wrapper><div class=about-community-case-Studies-grid-carousel__mobile-section__item><div class=\"about-community-case-Studies-grid-carousel__mobile-section__item__background zoom-hover\" ng-style=\"{\'background-image\': \'url(\\\'\' + data.photos[1].urlMobile + \'\\\')\'}\"></div></div></div><div ng-click=vm.showPhotoPopup(data.photos[2]) class=about-community-case-Studies-grid-carousel__mobile-section__item-wrapper><div class=about-community-case-Studies-grid-carousel__mobile-section__item><div class=\"about-community-case-Studies-grid-carousel__mobile-section__item__background zoom-hover\" ng-style=\"{\'background-image\': \'url(\\\'\' + data.photos[2].urlMobile + \'\\\')\'}\"></div></div></div></div><div class=about-community-case-Studies-grid-carousel__mobile-section__grid-wrapper><div ng-click=vm.showPhotoPopup(data.photos[3]) class=\"about-community-case-Studies-grid-carousel__mobile-section__item-wrapper item-plus\"><div class=about-community-case-Studies-grid-carousel__mobile-section__item><div class=\"about-community-case-Studies-grid-carousel__mobile-section__item__background zoom-hover\" ng-style=\"{\'background-image\': \'url(\\\'\' + data.photos[3].urlMobile + \'\\\')\'}\"></div></div></div><div ng-click=vm.showPhotoPopup(data.photos[4]) class=about-community-case-Studies-grid-carousel__mobile-section__item-wrapper><div class=about-community-case-Studies-grid-carousel__mobile-section__item><div class=\"about-community-case-Studies-grid-carousel__mobile-section__item__background zoom-hover\" ng-style=\"{\'background-image\': \'url(\\\'\' + data.photos[4].urlMobile + \'\\\')\'}\"></div></div></div></div><div class=about-community-case-Studies-grid-carousel__mobile-section__grid-wrapper><div ng-click=vm.showPhotoPopup(data.photos[5]) class=about-community-case-Studies-grid-carousel__mobile-section__item-wrapper><div class=about-community-case-Studies-grid-carousel__mobile-section__item><div class=\"about-community-case-Studies-grid-carousel__mobile-section__item__background zoom-hover\" ng-style=\"{\'background-image\': \'url(\\\'\' + data.photos[5].urlMobile + \'\\\')\'}\"></div></div></div><div ng-click=vm.showPhotoPopup(data.photos[6]) class=\"about-community-case-Studies-grid-carousel__mobile-section__item-wrapper item-plus\"><div class=about-community-case-Studies-grid-carousel__mobile-section__item><div class=\"about-community-case-Studies-grid-carousel__mobile-section__item__background zoom-hover\" ng-style=\"{\'background-image\': \'url(\\\'\' + data.photos[6].urlMobile + \'\\\')\'}\"></div></div></div></div><div class=about-community-case-Studies-grid-carousel__mobile-section__grid-info-wrapper><div class=\"about-community-case-Studies-grid-carousel__mobile-section__item-wrapper background-desert-storm\"><div class=about-community-case-Studies-grid-carousel__mobile-section__item><div class=about-community-case-Studies-grid-carousel__mobile-section__item__logo ng-style=\"{\'background-image\': \'url(\' + data.slideInfo.logoUrlMobile + \')\'}\"></div></div><div class=about-community-case-Studies-grid-carousel__mobile-section__item-wrapper__item-border></div></div><div class=\"about-community-case-Studies-grid-carousel__mobile-section__item-wrapper background-desert-storm\"><div class=about-community-case-Studies-grid-carousel__mobile-section__item><div class=about-community-case-Studies-grid-carousel__mobile-section__item__header><div class=about-community-case-Studies-grid-carousel__mobile-section__item__header__text>{{data.slideInfo.header}}</div><div class=about-community-case-Studies-grid-carousel__mobile-section__item__header__desc>{{data.slideInfo.subHeader}}</div></div></div></div></div><div class=\"about-community-case-Studies-grid-carousel__mobile-section__grid-wrapper plus-item\"><div class=\"about-community-case-Studies-grid-carousel__mobile-section__item-wrapper plus-item\"><div class=about-community-case-Studies-grid-carousel__mobile-section__item><div class=about-community-case-Studies-grid-carousel__mobile-section__item__info-wrapper><div class=about-community-case-Studies-grid-carousel__mobile-section__item__desc>{{data.slideInfo.desc}}<div class=photo-slide-panel__source>(Source: The drum)</div></div></div></div></div></div></div>");
$templateCache.put("app/components/about-community-case-Studies-grid-carousel/slide2-template.html","<div class=\"about-community-case-Studies-grid-carousel__pc-section slide-1-style__center width-100 vertical\"><div class=\"slide-1-style__center height-40\"><div class=\"photo-slide-item photo-0\" ng-style=\"{\'background-image\': \'url(\' + data.photos[0].url + \')\'}\"></div><div class=\"photo-slide-item photo-1\" ng-style=\"{\'background-image\': \'url(\' + data.photos[1].url + \')\'}\"></div><div class=\"photo-slide-item photo-2\" ng-style=\"{\'background-image\': \'url(\' + data.photos[2].url + \')\'}\"></div><div class=\"photo-slide-item photo-3\" ng-style=\"{\'background-image\': \'url(\' + data.photos[3].url + \')\'}\"></div></div><div class=\"slide-1-style__center size-auto\"><div class=\"photo-slide-item photo-4 size-auto\" ng-style=\"{\'background-image\': \'url(\' + data.photos[4].url + \')\'}\"></div><div class=\"slide-1-style__center vertical size-auto\"><div class=\"slide-1-style__center height-50\"><div class=\"photo-slide-item photo-5 height-79\" ng-style=\"{\'background-image\': \'url(\' + data.photos[5].url + \')\'}\"></div><div class=\"photo-slide-item photo-6 size-auto\" ng-style=\"{\'background-image\': \'url(\' + data.photos[6].url + \')\'}\"></div></div><div class=\"slide-1-style__center size-auto\"><div class=\"photo-slide-item photo-7 width-33\" ng-style=\"{\'background-image\': \'url(\' + data.photos[7].url + \')\'}\"></div><div class=\"photo-slide-item photo-8 size-auto\" ng-style=\"{\'background-image\': \'url(\' + data.photos[8].url + \')\'}\"></div></div></div><div class=\"photo-slide-item photo-9\" ng-style=\"{\'background-image\': \'url(\' + data.photos[9].url + \')\'}\"><div class=photo-slide-panel><div class=photo-slide-panel__header><div class=photo-slide-panel__header__logo ng-style=\"{\'background-image\': \'url(\' + data.slideInfo.logoUrl + \')\'}\"></div><div class=photo-slide-panel__header__col-right><div class=photo-slide-panel__header__title>{{data.slideInfo.header}}</div><div class=photo-slide-panel__header__location>{{data.slideInfo.subHeader}}</div></div></div><div class=photo-slide-panel__content>{{data.slideInfo.desc}}</div></div></div></div></div><div class=about-community-case-Studies-grid-carousel__mobile-section><div class=\"about-community-case-Studies-grid-carousel__mobile-section__grid-wrapper template-columns-1-2\"><div ng-click=vm.showPhotoPopup(data.photos[0]) class=about-community-case-Studies-grid-carousel__mobile-section__item-wrapper><div class=about-community-case-Studies-grid-carousel__mobile-section__item><div class=\"about-community-case-Studies-grid-carousel__mobile-section__item__background zoom-hover\" ng-style=\"{\'background-image\': \'url(\\\'\' + data.photos[0].urlMobile + \'\\\')\'}\"></div></div></div><div ng-click=vm.showPhotoPopup(data.photos[1]) class=\"about-community-case-Studies-grid-carousel__mobile-section__item-wrapper item-plus\"><div class=about-community-case-Studies-grid-carousel__mobile-section__item><div class=\"about-community-case-Studies-grid-carousel__mobile-section__item__background zoom-hover\" ng-style=\"{\'background-image\': \'url(\\\'\' + data.photos[1].urlMobile + \'\\\')\'}\"></div></div></div></div><div class=\"about-community-case-Studies-grid-carousel__mobile-section__grid-wrapper template-columns-1-1-1\"><div ng-click=vm.showPhotoPopup(data.photos[2]) class=about-community-case-Studies-grid-carousel__mobile-section__item-wrapper><div class=about-community-case-Studies-grid-carousel__mobile-section__item><div class=\"about-community-case-Studies-grid-carousel__mobile-section__item__background zoom-hover\" ng-style=\"{\'background-image\': \'url(\\\'\' + data.photos[2].urlMobile + \'\\\')\'}\"></div></div></div><div ng-click=vm.showPhotoPopup(data.photos[3]) class=\"about-community-case-Studies-grid-carousel__mobile-section__item-wrapper item-plus\"><div class=about-community-case-Studies-grid-carousel__mobile-section__item><div class=\"about-community-case-Studies-grid-carousel__mobile-section__item__background zoom-hover\" ng-style=\"{\'background-image\': \'url(\\\'\' + data.photos[3].urlMobile + \'\\\')\'}\"></div></div></div><div ng-click=vm.showPhotoPopup(data.photos[4]) class=about-community-case-Studies-grid-carousel__mobile-section__item-wrapper><div class=about-community-case-Studies-grid-carousel__mobile-section__item><div class=\"about-community-case-Studies-grid-carousel__mobile-section__item__background zoom-hover\" ng-style=\"{\'background-image\': \'url(\\\'\' + data.photos[4].urlMobile + \'\\\')\'}\"></div></div></div></div><div class=\"about-community-case-Studies-grid-carousel__mobile-section__grid-wrapper template-columns-1-1-1\"><div ng-click=vm.showPhotoPopup(data.photos[5]) class=\"about-community-case-Studies-grid-carousel__mobile-section__item-wrapper item-plus\"><div class=about-community-case-Studies-grid-carousel__mobile-section__item><div class=\"about-community-case-Studies-grid-carousel__mobile-section__item__background zoom-hover\" ng-style=\"{\'background-image\': \'url(\\\'\' + data.photos[5].urlMobile + \'\\\')\'}\"></div></div></div><div ng-click=vm.showPhotoPopup(data.photos[6]) class=about-community-case-Studies-grid-carousel__mobile-section__item-wrapper><div class=about-community-case-Studies-grid-carousel__mobile-section__item><div class=\"about-community-case-Studies-grid-carousel__mobile-section__item__background zoom-hover\" ng-style=\"{\'background-image\': \'url(\\\'\' + data.photos[6].urlMobile + \'\\\')\'}\"></div></div></div><div ng-click=vm.showPhotoPopup(data.photos[7]) class=about-community-case-Studies-grid-carousel__mobile-section__item-wrapper><div class=about-community-case-Studies-grid-carousel__mobile-section__item><div class=\"about-community-case-Studies-grid-carousel__mobile-section__item__background zoom-hover\" ng-style=\"{\'background-image\': \'url(\\\'\' + data.photos[7].urlMobile + \'\\\')\'}\"></div></div></div></div><div class=about-community-case-Studies-grid-carousel__mobile-section__grid-info-wrapper><div class=\"about-community-case-Studies-grid-carousel__mobile-section__item-wrapper background-desert-storm\"><div class=about-community-case-Studies-grid-carousel__mobile-section__item><div class=about-community-case-Studies-grid-carousel__mobile-section__item__logo ng-style=\"{\'background-image\': \'url(\' + data.slideInfo.logoUrlMobile + \')\'}\"></div></div><div class=about-community-case-Studies-grid-carousel__mobile-section__item-wrapper__item-border></div></div><div class=\"about-community-case-Studies-grid-carousel__mobile-section__item-wrapper background-desert-storm\"><div class=about-community-case-Studies-grid-carousel__mobile-section__item><div class=about-community-case-Studies-grid-carousel__mobile-section__item__header><div class=about-community-case-Studies-grid-carousel__mobile-section__item__header__text>{{data.slideInfo.header}}</div><div class=about-community-case-Studies-grid-carousel__mobile-section__item__header__desc>{{data.slideInfo.subHeader}}</div></div></div></div></div><div class=\"about-community-case-Studies-grid-carousel__mobile-section__grid-wrapper plus-item\"><div class=\"about-community-case-Studies-grid-carousel__mobile-section__item-wrapper plus-item\"><div class=about-community-case-Studies-grid-carousel__mobile-section__item><div class=about-community-case-Studies-grid-carousel__mobile-section__item__info-wrapper><div class=about-community-case-Studies-grid-carousel__mobile-section__item__desc>{{data.slideInfo.desc}}</div></div></div></div></div></div>");
$templateCache.put("app/components/about-community-case-Studies-grid-carousel/slide3-template.html","<div class=\"about-community-case-Studies-grid-carousel__pc-section slide-2-style__center width-100 vertical\"><div class=\"slide-2-style__center height-40\"><div class=\"photo-slide-item photo-0\" ng-style=\"{\'background-image\': \'url(\' + data.photos[0].url + \')\'}\"></div><div class=\"photo-slide-item photo-1\" ng-style=\"{\'background-image\': \'url(\' + data.photos[1].url + \')\'}\"></div><div class=\"photo-slide-item photo-2\" ng-style=\"{\'background-image\': \'url(\' + data.photos[2].url + \')\'}\"></div><div class=\"photo-slide-item photo-3\" ng-style=\"{\'background-image\': \'url(\' + data.photos[3].url + \')\'}\"></div></div><div class=\"slide-2-style__center size-auto\"><div class=\"slide-2-style__center vertical size-auto\"><div class=\"slide-2-style__center height-50\"><div class=\"photo-slide-item photo-4 height-79\" ng-style=\"{\'background-image\': \'url(\' + data.photos[4].url + \')\'}\"></div><div class=\"photo-slide-item photo-5 size-auto\" ng-style=\"{\'background-image\': \'url(\' + data.photos[5].url + \')\'}\"></div></div><div class=\"slide-2-style__center size-auto\"><div class=\"photo-slide-item photo-6 width-33\" ng-style=\"{\'background-image\': \'url(\' + data.photos[6].url + \')\'}\"></div><div class=\"photo-slide-item photo-7 size-auto\" ng-style=\"{\'background-image\': \'url(\' + data.photos[7].url + \')\'}\"></div></div></div><div class=\"photo-slide-item photo-8\" ng-style=\"{\'background-image\': \'url(\' + data.photos[8].url + \')\'}\"><div class=photo-slide-panel><div class=photo-slide-panel__header><div class=photo-slide-panel__header__logo ng-style=\"{\'background-image\': \'url(\' + data.slideInfo.logoUrl + \')\'}\"></div><div class=photo-slide-panel__header__col-right><div class=photo-slide-panel__header__title>{{data.slideInfo.header}}</div><div class=photo-slide-panel__header__location>{{data.slideInfo.subHeader}}</div></div></div><div class=photo-slide-panel__content>{{data.slideInfo.desc}}</div></div></div></div></div><div class=about-community-case-Studies-grid-carousel__mobile-section><div class=\"about-community-case-Studies-grid-carousel__mobile-section__grid-wrapper template-columns-1-2\"><div ng-click=vm.showPhotoPopup(data.photos[0]) class=about-community-case-Studies-grid-carousel__mobile-section__item-wrapper><div class=about-community-case-Studies-grid-carousel__mobile-section__item><div class=\"about-community-case-Studies-grid-carousel__mobile-section__item__background zoom-hover\" ng-style=\"{\'background-image\': \'url(\\\'\' + data.photos[0].urlMobile + \'\\\')\'}\"></div></div></div><div ng-click=vm.showPhotoPopup(data.photos[1]) class=\"about-community-case-Studies-grid-carousel__mobile-section__item-wrapper item-plus\"><div class=about-community-case-Studies-grid-carousel__mobile-section__item><div class=\"about-community-case-Studies-grid-carousel__mobile-section__item__background zoom-hover\" ng-style=\"{\'background-image\': \'url(\\\'\' + data.photos[1].urlMobile + \'\\\')\'}\"></div></div></div></div><div class=\"about-community-case-Studies-grid-carousel__mobile-section__grid-wrapper template-columns-1-1-1\"><div ng-click=vm.showPhotoPopup(data.photos[2]) class=about-community-case-Studies-grid-carousel__mobile-section__item-wrapper><div class=about-community-case-Studies-grid-carousel__mobile-section__item><div class=\"about-community-case-Studies-grid-carousel__mobile-section__item__background zoom-hover\" ng-style=\"{\'background-image\': \'url(\\\'\' + data.photos[2].urlMobile + \'\\\')\'}\"></div></div></div><div ng-click=vm.showPhotoPopup(data.photos[3]) class=about-community-case-Studies-grid-carousel__mobile-section__item-wrapper><div class=about-community-case-Studies-grid-carousel__mobile-section__item><div class=\"about-community-case-Studies-grid-carousel__mobile-section__item__background zoom-hover\" ng-style=\"{\'background-image\': \'url(\\\'\' + data.photos[3].urlMobile + \'\\\')\'}\"></div></div></div><div ng-click=vm.showPhotoPopup(data.photos[4]) class=about-community-case-Studies-grid-carousel__mobile-section__item-wrapper><div class=about-community-case-Studies-grid-carousel__mobile-section__item><div class=\"about-community-case-Studies-grid-carousel__mobile-section__item__background zoom-hover\" ng-style=\"{\'background-image\': \'url(\\\'\' + data.photos[4].urlMobile + \'\\\')\'}\"></div></div></div></div><div class=\"about-community-case-Studies-grid-carousel__mobile-section__grid-wrapper template-columns-1-1-1\"><div ng-click=vm.showPhotoPopup(data.photos[5]) class=about-community-case-Studies-grid-carousel__mobile-section__item-wrapper><div class=about-community-case-Studies-grid-carousel__mobile-section__item><div class=\"about-community-case-Studies-grid-carousel__mobile-section__item__background zoom-hover\" ng-style=\"{\'background-image\': \'url(\\\'\' + data.photos[5].urlMobile + \'\\\')\'}\"></div></div></div><div ng-click=vm.showPhotoPopup(data.photos[6]) class=about-community-case-Studies-grid-carousel__mobile-section__item-wrapper><div class=about-community-case-Studies-grid-carousel__mobile-section__item><div class=\"about-community-case-Studies-grid-carousel__mobile-section__item__background zoom-hover\" ng-style=\"{\'background-image\': \'url(\\\'\' + data.photos[6].urlMobile + \'\\\')\'}\"></div></div></div><div ng-click=vm.showPhotoPopup(data.photos[7]) class=about-community-case-Studies-grid-carousel__mobile-section__item-wrapper><div class=about-community-case-Studies-grid-carousel__mobile-section__item><div class=\"about-community-case-Studies-grid-carousel__mobile-section__item__background zoom-hover\" ng-style=\"{\'background-image\': \'url(\\\'\' + data.photos[7].urlMobile + \'\\\')\'}\"></div></div></div></div><div class=about-community-case-Studies-grid-carousel__mobile-section__grid-info-wrapper><div class=\"about-community-case-Studies-grid-carousel__mobile-section__item-wrapper background-desert-storm\"><div class=about-community-case-Studies-grid-carousel__mobile-section__item><div class=about-community-case-Studies-grid-carousel__mobile-section__item__logo ng-style=\"{\'background-image\': \'url(\' + data.slideInfo.logoUrlMobile + \')\'}\"></div></div><div class=about-community-case-Studies-grid-carousel__mobile-section__item-wrapper__item-border></div></div><div class=\"about-community-case-Studies-grid-carousel__mobile-section__item-wrapper background-desert-storm\"><div class=about-community-case-Studies-grid-carousel__mobile-section__item><div class=about-community-case-Studies-grid-carousel__mobile-section__item__header><div class=about-community-case-Studies-grid-carousel__mobile-section__item__header__text>{{data.slideInfo.header}}</div><div class=about-community-case-Studies-grid-carousel__mobile-section__item__header__desc>{{data.slideInfo.subHeader}}</div></div></div></div></div><div class=\"about-community-case-Studies-grid-carousel__mobile-section__grid-wrapper plus-item\"><div class=\"about-community-case-Studies-grid-carousel__mobile-section__item-wrapper plus-item\"><div class=about-community-case-Studies-grid-carousel__mobile-section__item><div class=about-community-case-Studies-grid-carousel__mobile-section__item__info-wrapper><div class=about-community-case-Studies-grid-carousel__mobile-section__item__desc>{{data.slideInfo.desc}}</div></div></div></div></div></div>");
$templateCache.put("app/components/about-community-case-Studies-grid-carousel/slide4-template.html","<div class=\"about-community-case-Studies-grid-carousel__pc-section slide-3-style__center width-100\"><div class=\"slide-3-style__center size-auto vertical\"><div class=\"slide-3-style__center flex-30 size-auto\"><div class=\"photo-slide-item photo-0\" ng-style=\"{\'background-image\': \'url(\' + data.photos[0].url + \')\'}\"></div><div class=\"photo-slide-item photo-1\" ng-style=\"{\'background-image\': \'url(\' + data.photos[1].url + \')\'}\"></div></div><div class=\"slide-3-style__center size-auto\"><div class=\"slide-3-style__center vertical\"><div class=\"photo-slide-item photo-2 height-79\" ng-style=\"{\'background-image\': \'url(\' + data.photos[2].url + \')\'}\"></div><div class=\"photo-slide-item photo-3 size-auto\" ng-style=\"{\'background-image\': \'url(\' + data.photos[3].url + \')\'}\"></div></div><div class=\"slide-3-style__center width-55 vertical\"><div class=\"photo-slide-item photo-4 width-33\" ng-style=\"{\'background-image\': \'url(\' + data.photos[4].url + \')\'}\"></div><div class=\"photo-slide-item photo-5 size-auto\" ng-style=\"{\'background-image\': \'url(\' + data.photos[5].url + \')\'}\"></div></div></div></div><div class=\"slide-3-style__center width-39 vertical\"><div class=\"photo-slide-item photo-6 width-33\" ng-style=\"{\'background-image\': \'url(\' + data.photos[6].url + \')\'}\"></div><div class=\"photo-slide-item photo-7\" ng-style=\"{\'background-image\': \'url(\' + data.photos[7].url + \')\'}\"><div class=photo-slide-panel><div class=photo-slide-panel__header><div class=photo-slide-panel__header__logo ng-style=\"{\'background-image\': \'url(\' + data.slideInfo.logoUrl + \')\'}\"></div><div class=photo-slide-panel__header__col-right><div class=photo-slide-panel__header__title>{{data.slideInfo.header}}</div><div class=photo-slide-panel__header__location>{{data.slideInfo.subHeader}}</div></div></div><div class=photo-slide-panel__content>{{data.slideInfo.desc}}</div></div></div></div></div><div class=about-community-case-Studies-grid-carousel__mobile-section><div class=\"about-community-case-Studies-grid-carousel__mobile-section__grid-wrapper template-columns-1-1-1\"><div ng-click=vm.showPhotoPopup(data.photos[0]) class=about-community-case-Studies-grid-carousel__mobile-section__item-wrapper><div class=about-community-case-Studies-grid-carousel__mobile-section__item><div class=\"about-community-case-Studies-grid-carousel__mobile-section__item__background zoom-hover\" ng-style=\"{\'background-image\': \'url(\\\'\' + data.photos[0].urlMobile + \'\\\')\'}\"></div></div></div><div ng-click=vm.showPhotoPopup(data.photos[1]) class=about-community-case-Studies-grid-carousel__mobile-section__item-wrapper><div class=about-community-case-Studies-grid-carousel__mobile-section__item><div class=\"about-community-case-Studies-grid-carousel__mobile-section__item__background zoom-hover\" ng-style=\"{\'background-image\': \'url(\\\'\' + data.photos[1].urlMobile + \'\\\')\'}\"></div></div></div><div ng-click=vm.showPhotoPopup(data.photos[2]) class=about-community-case-Studies-grid-carousel__mobile-section__item-wrapper><div class=about-community-case-Studies-grid-carousel__mobile-section__item><div class=\"about-community-case-Studies-grid-carousel__mobile-section__item__background zoom-hover\" ng-style=\"{\'background-image\': \'url(\\\'\' + data.photos[2].urlMobile + \'\\\')\'}\"></div></div></div></div><div class=\"about-community-case-Studies-grid-carousel__mobile-section__grid-wrapper template-columns-1-1-1\"><div ng-click=vm.showPhotoPopup(data.photos[3]) class=about-community-case-Studies-grid-carousel__mobile-section__item-wrapper><div class=about-community-case-Studies-grid-carousel__mobile-section__item><div class=\"about-community-case-Studies-grid-carousel__mobile-section__item__background zoom-hover\" ng-style=\"{\'background-image\': \'url(\\\'\' + data.photos[3].urlMobile + \'\\\')\'}\"></div></div></div><div ng-click=vm.showPhotoPopup(data.photos[4]) class=about-community-case-Studies-grid-carousel__mobile-section__item-wrapper><div class=about-community-case-Studies-grid-carousel__mobile-section__item><div class=\"about-community-case-Studies-grid-carousel__mobile-section__item__background zoom-hover\" ng-style=\"{\'background-image\': \'url(\\\'\' + data.photos[4].urlMobile + \'\\\')\'}\"></div></div></div><div ng-click=vm.showPhotoPopup(data.photos[5]) class=about-community-case-Studies-grid-carousel__mobile-section__item-wrapper><div class=about-community-case-Studies-grid-carousel__mobile-section__item><div class=\"about-community-case-Studies-grid-carousel__mobile-section__item__background zoom-hover\" ng-style=\"{\'background-image\': \'url(\\\'\' + data.photos[5].urlMobile + \'\\\')\'}\"></div></div></div></div><div class=\"about-community-case-Studies-grid-carousel__mobile-section__grid-wrapper template-columns-1-2\"><div ng-click=vm.showPhotoPopup(data.photos[6]) class=about-community-case-Studies-grid-carousel__mobile-section__item-wrapper><div class=about-community-case-Studies-grid-carousel__mobile-section__item><div class=\"about-community-case-Studies-grid-carousel__mobile-section__item__background zoom-hover\" ng-style=\"{\'background-image\': \'url(\\\'\' + data.photos[6].urlMobile + \'\\\')\'}\"></div></div></div><div ng-click=vm.showPhotoPopup(data.photos[7]) class=\"about-community-case-Studies-grid-carousel__mobile-section__item-wrapper item-plus\"><div class=about-community-case-Studies-grid-carousel__mobile-section__item><div class=\"about-community-case-Studies-grid-carousel__mobile-section__item__background zoom-hover\" ng-style=\"{\'background-image\': \'url(\\\'\' + data.photos[7].urlMobile + \'\\\')\'}\"></div></div></div></div><div class=about-community-case-Studies-grid-carousel__mobile-section__grid-info-wrapper><div class=\"about-community-case-Studies-grid-carousel__mobile-section__item-wrapper background-desert-storm\"><div class=about-community-case-Studies-grid-carousel__mobile-section__item><div class=about-community-case-Studies-grid-carousel__mobile-section__item__logo ng-style=\"{\'background-image\': \'url(\' + data.slideInfo.logoUrlMobile + \')\'}\"></div></div><div class=about-community-case-Studies-grid-carousel__mobile-section__item-wrapper__item-border></div></div><div class=\"about-community-case-Studies-grid-carousel__mobile-section__item-wrapper background-desert-storm\"><div class=about-community-case-Studies-grid-carousel__mobile-section__item><div class=about-community-case-Studies-grid-carousel__mobile-section__item__header><div class=about-community-case-Studies-grid-carousel__mobile-section__item__header__text>{{data.slideInfo.header}}</div><div class=about-community-case-Studies-grid-carousel__mobile-section__item__header__desc>{{data.slideInfo.subHeader}}</div></div></div></div></div><div class=\"about-community-case-Studies-grid-carousel__mobile-section__grid-wrapper plus-item\"><div class=\"about-community-case-Studies-grid-carousel__mobile-section__item-wrapper plus-item\"><div class=about-community-case-Studies-grid-carousel__mobile-section__item><div class=about-community-case-Studies-grid-carousel__mobile-section__item__info-wrapper><div class=about-community-case-Studies-grid-carousel__mobile-section__item__desc>{{data.slideInfo.desc}}</div></div></div></div></div></div>");
$templateCache.put("app/components/about-community-case-Studies-grid-carousel/slide5-template.html","<div class=\"about-community-case-Studies-grid-carousel__pc-section slide-4-style__center width-100\"><div class=\"slide-4-style__center size-auto vertical\"><div class=\"slide-4-style__center size-auto\"><div class=\"photo-slide-item photo-0 height-79\" ng-style=\"{\'background-image\': \'url(\' + data.photos[0].url + \')\'}\"><div class=\"photo-slide-team-info bottom-right\"><div class=photo-slide-team-info__location>{{data.photos[0].location}}</div><div class=photo-slide-team-info__team-name>{{data.photos[0].team}}</div></div></div><div class=\"slide-4-style__center width-55 vertical\"><div class=\"photo-slide-item photo-1 width-33\" ng-style=\"{\'background-image\': \'url(\' + data.photos[1].url + \')\'}\"><div class=photo-slide-team-info><div class=photo-slide-team-info__location>{{data.photos[1].location}}</div><div class=photo-slide-team-info__team-name>{{data.photos[1].team}}</div></div></div><div class=\"photo-slide-item photo-2 size-auto\" ng-style=\"{\'background-image\': \'url(\' + data.photos[2].url + \')\'}\"><div class=photo-slide-team-info><div class=photo-slide-team-info__location>{{data.photos[2].location}}</div><div class=photo-slide-team-info__team-name>{{data.photos[2].team}}</div></div></div></div></div><div class=\"slide-4-style__center flex-40 size-auto\"><div class=\"photo-slide-item photo-3\" ng-style=\"{\'background-image\': \'url(\' + data.photos[3].url + \')\'}\"><div class=photo-slide-team-info><div class=photo-slide-team-info__location>{{data.photos[3].location}}</div><div class=photo-slide-team-info__team-name>{{data.photos[3].team}}</div></div></div><div class=\"photo-slide-item photo-4\" ng-style=\"{\'background-image\': \'url(\' + data.photos[4].url + \')\'}\"><div class=photo-slide-team-info><div class=photo-slide-team-info__location>{{data.photos[4].location}}</div><div class=photo-slide-team-info__team-name>{{data.photos[4].team}}</div></div></div><div class=\"photo-slide-item photo-5\" ng-style=\"{\'background-image\': \'url(\' + data.photos[5].url + \')\'}\"><div class=photo-slide-team-info><div class=photo-slide-team-info__location>{{data.photos[5].location}}</div><div class=photo-slide-team-info__team-name>{{data.photos[5].team}}</div></div></div></div></div><div class=\"slide-4-style__center width-28 vertical\"><div class=\"photo-slide-item photo-6 width-33\" ng-style=\"{\'background-image\': \'url(\' + data.photos[6].url + \')\'}\"><div class=photo-slide-team-info><div class=photo-slide-team-info__location>{{data.photos[6].location}}</div><div class=photo-slide-team-info__team-name>{{data.photos[6].team}}</div></div></div><div class=\"photo-slide-item photo-7\" ng-style=\"{\'background-image\': \'url(\' + data.photos[7].url + \')\'}\"><div class=photo-slide-panel><div class=photo-slide-panel__header><div class=photo-slide-panel__header__logo ng-style=\"{\'background-image\': \'url(\' + data.slideInfo.logoUrl + \')\'}\"></div><div class=photo-slide-panel__header__col-right><div class=photo-slide-panel__header__location>{{data.slideInfo.subHeader}}</div></div></div><div class=photo-slide-panel__content>{{data.slideInfo.desc}}</div></div></div></div></div><div class=about-community-case-Studies-grid-carousel__mobile-section><div class=\"about-community-case-Studies-grid-carousel__mobile-section__grid-wrapper template-columns-1-1-1\"><div ng-click=vm.showPhotoPopup(data.photos[0]) class=about-community-case-Studies-grid-carousel__mobile-section__item-wrapper><div class=about-community-case-Studies-grid-carousel__mobile-section__item><div class=\"about-community-case-Studies-grid-carousel__mobile-section__item__background zoom-hover\" ng-style=\"{\'background-image\': \'url(\\\'\' + data.photos[0].urlMobile + \'\\\')\'}\"></div></div></div><div ng-click=vm.showPhotoPopup(data.photos[1]) class=about-community-case-Studies-grid-carousel__mobile-section__item-wrapper><div class=about-community-case-Studies-grid-carousel__mobile-section__item><div class=\"about-community-case-Studies-grid-carousel__mobile-section__item__background zoom-hover\" ng-style=\"{\'background-image\': \'url(\\\'\' + data.photos[1].urlMobile + \'\\\')\'}\"></div></div></div><div ng-click=vm.showPhotoPopup(data.photos[2]) class=about-community-case-Studies-grid-carousel__mobile-section__item-wrapper><div class=about-community-case-Studies-grid-carousel__mobile-section__item><div class=\"about-community-case-Studies-grid-carousel__mobile-section__item__background zoom-hover\" ng-style=\"{\'background-image\': \'url(\\\'\' + data.photos[2].urlMobile + \'\\\')\'}\"></div></div></div></div><div class=\"about-community-case-Studies-grid-carousel__mobile-section__grid-wrapper template-columns-1-1-1\"><div ng-click=vm.showPhotoPopup(data.photos[3]) class=about-community-case-Studies-grid-carousel__mobile-section__item-wrapper><div class=about-community-case-Studies-grid-carousel__mobile-section__item><div class=\"about-community-case-Studies-grid-carousel__mobile-section__item__background zoom-hover\" ng-style=\"{\'background-image\': \'url(\\\'\' + data.photos[3].urlMobile + \'\\\')\'}\"></div></div></div><div ng-click=vm.showPhotoPopup(data.photos[4]) class=about-community-case-Studies-grid-carousel__mobile-section__item-wrapper><div class=about-community-case-Studies-grid-carousel__mobile-section__item><div class=\"about-community-case-Studies-grid-carousel__mobile-section__item__background zoom-hover\" ng-style=\"{\'background-image\': \'url(\\\'\' + data.photos[4].urlMobile + \'\\\')\'}\"></div></div></div><div ng-click=vm.showPhotoPopup(data.photos[5]) class=about-community-case-Studies-grid-carousel__mobile-section__item-wrapper><div class=about-community-case-Studies-grid-carousel__mobile-section__item><div class=\"about-community-case-Studies-grid-carousel__mobile-section__item__background zoom-hover\" ng-style=\"{\'background-image\': \'url(\\\'\' + data.photos[5].urlMobile + \'\\\')\'}\"></div></div></div></div><div class=\"about-community-case-Studies-grid-carousel__mobile-section__grid-wrapper template-columns-1-2\"><div ng-click=vm.showPhotoPopup(data.photos[6]) class=about-community-case-Studies-grid-carousel__mobile-section__item-wrapper><div class=about-community-case-Studies-grid-carousel__mobile-section__item><div class=\"about-community-case-Studies-grid-carousel__mobile-section__item__background zoom-hover\" ng-style=\"{\'background-image\': \'url(\\\'\' + data.photos[6].urlMobile + \'\\\')\'}\"></div></div></div><div ng-click=vm.showPhotoPopup(data.photos[7]) class=\"about-community-case-Studies-grid-carousel__mobile-section__item-wrapper item-plus\"><div class=about-community-case-Studies-grid-carousel__mobile-section__item><div class=\"about-community-case-Studies-grid-carousel__mobile-section__item__background zoom-hover\" ng-style=\"{\'background-image\': \'url(\\\'\' + data.photos[7].urlMobile + \'\\\')\'}\"></div></div></div></div><div class=about-community-case-Studies-grid-carousel__mobile-section__grid-info-wrapper><div class=\"about-community-case-Studies-grid-carousel__mobile-section__item-wrapper background-desert-storm\"><div class=about-community-case-Studies-grid-carousel__mobile-section__item><div class=about-community-case-Studies-grid-carousel__mobile-section__item__logo ng-style=\"{\'background-image\': \'url(\' + data.slideInfo.logoUrlMobile + \')\'}\"></div></div><div class=about-community-case-Studies-grid-carousel__mobile-section__item-wrapper__item-border></div></div><div class=\"about-community-case-Studies-grid-carousel__mobile-section__item-wrapper background-desert-storm\"><div class=about-community-case-Studies-grid-carousel__mobile-section__item><div class=about-community-case-Studies-grid-carousel__mobile-section__item__header><div class=about-community-case-Studies-grid-carousel__mobile-section__item__header__text>{{data.slideInfo.header}}</div><div class=about-community-case-Studies-grid-carousel__mobile-section__item__header__desc>{{data.slideInfo.subHeader}}</div></div></div></div></div><div class=\"about-community-case-Studies-grid-carousel__mobile-section__grid-wrapper plus-item\"><div class=\"about-community-case-Studies-grid-carousel__mobile-section__item-wrapper plus-item\"><div class=about-community-case-Studies-grid-carousel__mobile-section__item><div class=about-community-case-Studies-grid-carousel__mobile-section__item__info-wrapper><div class=about-community-case-Studies-grid-carousel__mobile-section__item__desc>{{data.slideInfo.desc}}</div></div></div></div></div></div>");
$templateCache.put("app/components/about-community-case-Studies-grid-carousel/slide6-template.html","<div class=\"about-community-case-Studies-grid-carousel__pc-section slide-5-style__center width-100 vertical\"><div class=\"slide-5-style__center height-34\"><div class=\"photo-slide-item photo-0\" ng-style=\"{\'background-image\': \'url(\' + data.photos[0].url + \')\'}\"><div class=photo-slide-team-info><div class=photo-slide-team-info__location>{{data.photos[0].location}}</div></div></div><div class=\"photo-slide-item photo-1\" ng-style=\"{\'background-image\': \'url(\' + data.photos[1].url + \')\'}\"><div class=photo-slide-team-info><div class=photo-slide-team-info__location>{{data.photos[1].location}}</div></div></div><div class=\"photo-slide-item photo-2\" ng-style=\"{\'background-image\': \'url(\' + data.photos[2].url + \')\'}\"><div class=photo-slide-team-info><div class=photo-slide-team-info__location>{{data.photos[2].location}}</div></div></div><div class=\"photo-slide-item photo-3\" ng-style=\"{\'background-image\': \'url(\' + data.photos[3].url + \')\'}\"><div class=photo-slide-team-info><div class=photo-slide-team-info__location>{{data.photos[3].location}}</div></div></div></div><div class=\"slide-5-style__center height-31\"><div class=\"photo-slide-item photo-4\" ng-style=\"{\'background-image\': \'url(\' + data.photos[4].url + \')\'}\"><div class=photo-slide-team-info><div class=photo-slide-team-info__location>{{data.photos[4].location}}</div></div></div><div class=\"photo-slide-item photo-5\" ng-style=\"{\'background-image\': \'url(\' + data.photos[5].url + \')\'}\"><div class=photo-slide-team-info><div class=photo-slide-team-info__location>{{data.photos[5].location}}</div></div></div><div class=\"photo-slide-item photo-6\" ng-style=\"{\'background-image\': \'url(\' + data.photos[6].url + \')\'}\"><div class=photo-slide-team-info><div class=photo-slide-team-info__location>{{data.photos[6].location}}</div></div></div></div><div class=\"slide-5-style__center size-auto\"><div class=\"photo-slide-item photo-7\" ng-style=\"{\'background-image\': \'url(\' + data.photos[7].url + \')\'}\"><div class=photo-slide-team-info><div class=photo-slide-team-info__location>{{data.photos[7].location}}</div></div></div><div class=\"photo-slide-item photo-8\" ng-style=\"{\'background-image\': \'url(\' + data.photos[8].url + \')\'}\"><div class=photo-slide-team-info><div class=photo-slide-team-info__location>{{data.photos[8].location}}</div></div></div><div class=\"photo-slide-item photo-9\" ng-style=\"{\'background-image\': \'url(\' + data.photos[9].url + \')\'}\"><div class=photo-slide-team-info><div class=photo-slide-team-info__location>{{data.photos[9].location}}</div></div></div><div class=\"photo-slide-item photo-10\" ng-style=\"{\'background-image\': \'url(\' + data.photos[10].url + \')\'}\"><div class=photo-slide-logo-cover><div class=photo-slide-logo-cover__logo ng-style=\"{\'background-image\': \'url(\\\'\' + data.slideInfo.logoUrl + \'\\\')\'}\"></div></div><div class=photo-slide-team-info><div class=photo-slide-team-info__location>{{data.photos[10].location}}</div></div></div></div></div><div class=about-community-case-Studies-grid-carousel__mobile-section><div class=\"about-community-case-Studies-grid-carousel__mobile-section__grid-wrapper template-columns-1-2\"><div ng-click=vm.showPhotoPopup(data.photos[0]) class=about-community-case-Studies-grid-carousel__mobile-section__item-wrapper><div class=about-community-case-Studies-grid-carousel__mobile-section__item><div class=\"about-community-case-Studies-grid-carousel__mobile-section__item__background zoom-hover\" ng-style=\"{\'background-image\': \'url(\\\'\' + data.photos[0].urlMobile + \'\\\')\'}\"></div></div></div><div ng-click=vm.showPhotoPopup(data.photos[1]) class=\"about-community-case-Studies-grid-carousel__mobile-section__item-wrapper item-plus\"><div class=about-community-case-Studies-grid-carousel__mobile-section__item><div class=\"about-community-case-Studies-grid-carousel__mobile-section__item__background zoom-hover\" ng-style=\"{\'background-image\': \'url(\\\'\' + data.photos[1].urlMobile + \'\\\')\'}\"><div class=about-community-case-Studies-grid-carousel__mobile-section__item__location>{{data.photos[1].locationMobile}}</div></div></div></div></div><div class=\"about-community-case-Studies-grid-carousel__mobile-section__grid-wrapper template-columns-2-1\"><div ng-click=vm.showPhotoPopup(data.photos[2]) class=\"about-community-case-Studies-grid-carousel__mobile-section__item-wrapper item-plus\"><div class=about-community-case-Studies-grid-carousel__mobile-section__item><div class=\"about-community-case-Studies-grid-carousel__mobile-section__item__background zoom-hover\" ng-style=\"{\'background-image\': \'url(\\\'\' + data.photos[2].urlMobile + \'\\\')\'}\"><div class=about-community-case-Studies-grid-carousel__mobile-section__item__location>{{data.photos[2].locationMobile}}</div></div></div></div><div ng-click=vm.showPhotoPopup(data.photos[3]) class=about-community-case-Studies-grid-carousel__mobile-section__item-wrapper><div class=about-community-case-Studies-grid-carousel__mobile-section__item><div class=\"about-community-case-Studies-grid-carousel__mobile-section__item__background zoom-hover\" ng-style=\"{\'background-image\': \'url(\\\'\' + data.photos[3].urlMobile + \'\\\')\'}\"></div></div></div></div><div class=\"about-community-case-Studies-grid-carousel__mobile-section__grid-wrapper template-columns-1-2\"><div ng-click=vm.showPhotoPopup(data.photos[6]) class=about-community-case-Studies-grid-carousel__mobile-section__item-wrapper><div class=about-community-case-Studies-grid-carousel__mobile-section__item><div class=\"about-community-case-Studies-grid-carousel__mobile-section__item__background zoom-hover\" ng-style=\"{\'background-image\': \'url(\\\'\' + data.photos[6].urlMobile + \'\\\')\'}\"></div></div></div><div ng-click=vm.showPhotoPopup(data.photos[5]) class=\"about-community-case-Studies-grid-carousel__mobile-section__item-wrapper special-plus\"><div class=about-community-case-Studies-grid-carousel__mobile-section__item><div class=\"about-community-case-Studies-grid-carousel__mobile-section__item__background zoom-hover\" ng-style=\"{\'background-image\': \'url(\\\'\' + data.photos[5].urlMobile + \'\\\')\'}\"><div class=about-community-case-Studies-grid-carousel__mobile-section__item__location>{{data.photos[5].locationMobile}}</div></div></div><div class=about-community-case-Studies-grid-carousel__mobile-section__item><div class=\"about-community-case-Studies-grid-carousel__mobile-section__item__background zoom-hover\" ng-style=\"{\'background-image\': \'url(\\\'\' + data.photos[7].urlMobile + \'\\\')\'}\"><div class=about-community-case-Studies-grid-carousel__mobile-section__item__location>{{data.photos[7].locationMobile}}</div></div></div></div></div><div class=\"about-community-case-Studies-grid-carousel__mobile-section__grid-wrapper template-columns-2-1\"><div ng-click=vm.showPhotoPopup(data.photos[8]) class=\"about-community-case-Studies-grid-carousel__mobile-section__item-wrapper item-plus\"><div class=about-community-case-Studies-grid-carousel__mobile-section__item><div class=\"about-community-case-Studies-grid-carousel__mobile-section__item__background zoom-hover\" ng-style=\"{\'background-image\': \'url(\\\'\' + data.photos[8].urlMobile + \'\\\')\'}\"><div class=about-community-case-Studies-grid-carousel__mobile-section__item__logo-cover><div class=about-community-case-Studies-grid-carousel__mobile-section__item__logo-cover__logo ng-style=\"{\'background-image\': \'url(\\\'\' + data.slideInfo.logoUrlMobile + \'\\\')\'}\"></div></div><div class=about-community-case-Studies-grid-carousel__mobile-section__item__location>{{data.photos[8].locationMobile}}</div></div></div></div><div ng-click=vm.showPhotoPopup(data.photos[9]) class=about-community-case-Studies-grid-carousel__mobile-section__item-wrapper><div class=about-community-case-Studies-grid-carousel__mobile-section__item><div class=\"about-community-case-Studies-grid-carousel__mobile-section__item__background zoom-hover\" ng-style=\"{\'background-image\': \'url(\\\'\' + data.photos[9].urlMobile + \'\\\')\'}\"></div></div></div></div><div class=\"about-community-case-Studies-grid-carousel__mobile-section__grid-wrapper template-columns-1-2\"><div ng-click=vm.showPhotoPopup(data.photos[10]) class=about-community-case-Studies-grid-carousel__mobile-section__item-wrapper><div class=about-community-case-Studies-grid-carousel__mobile-section__item><div class=\"about-community-case-Studies-grid-carousel__mobile-section__item__background zoom-hover\" ng-style=\"{\'background-image\': \'url(\\\'\' + data.photos[10].urlMobile + \'\\\')\'}\"><div class=about-community-case-Studies-grid-carousel__mobile-section__item__location>{{data.photos[10].locationMobile}}</div></div></div></div><div ng-click=vm.showPhotoPopup(data.photos[11]) class=\"about-community-case-Studies-grid-carousel__mobile-section__item-wrapper item-plus\"><div class=about-community-case-Studies-grid-carousel__mobile-section__item><div class=\"about-community-case-Studies-grid-carousel__mobile-section__item__background zoom-hover\" ng-style=\"{\'background-image\': \'url(\\\'\' + data.photos[11].urlMobile + \'\\\')\'}\"></div></div></div></div></div>");
$templateCache.put("app/components/action-popup/action-popup.html","<div class=action-popup><div class=\"action-popup__header clearfix\"><div class=\"action-popup__close icon-icons_close\" role=button ng-click=vm.onCancelClicked()></div></div><div class=action-popup__content><div class=\"action-popup__content__title text--bold text--color-black\">You have uploaded the maximum number of submissions allowed!</div><div class=action-popup__content__description ng-if=vm.data.total_balance>Subsequent submissions will be charged at USD10 each. Asian Geographic will contact you via email for payment. Thanks!</div><button class=\"btn btn-submit action-popup__submit-btn text--bold\" ng-click=vm.onBtnClicked(vm.data.total_balance) ng-bind=\"vm.data.total_balance ? \'Upload Now\' : \'OK\'\"></button></div></div>");
$templateCache.put("app/components/action-reqruied-community-popup/action-reqruied-community-popup.html","<div class=action-reqruied-community-popup><div class=action-reqruied-community-popup__close ng-click=vm.close()><span class=icon-icons_close aria-hidden=true></span></div><div class=action-reqruied-community-popup__content><div class=action-reqruied-community-popup__content__head-label>Request action from Community Owner</div><mutiline-dropdown items=vm.actionRequiredList on-changed=vm.onActionRequiredChanged(data) is-multi-choice=true selected=vm.defaultActionRequired></mutiline-dropdown><div class=action-reqruied-community-popup__content__title-label>Comments</div><div contenteditable=true class=action-reqruied-community-popup__description-input ng-model=vm.comment></div></div><div class=action-reqruied-community-popup__control><button class=\"action-reqruied-community-popup__control__cancel btn btn-cancel--no-background\" ng-click=vm.close()>Cancel</button> <button class=\"action-reqruied-community-popup__control__submit btn btn-submit\" ng-disabled=\"!vm.reason || !vm.comment\" ng-click=vm.onSubmit()>Submit</button></div></div>");
$templateCache.put("app/components/add-bank-transfer-method-popup/add-bank-transfer-method-popup.html","<div class=add-bank-transfer-method-popup__content><h4 class=\"add-bank-transfer-method-popup__content__title text--bold\">Wire Transfer</h4><section class=\"add-bank-transfer-method-popup__content--connected text-center\"><div class=\"icon-icons-tick-with-circle text--color-pixerf-theme\"></div><p class=\"text--semibold add-bank-transfer-method-popup__content--connected__message-title\">Your bank account information has been registered successfully!</p><p class=add-bank-transfer-method-popup__content--connected__message-body>Any transfer fees will be payable by you and will vary from country to country. Please check with your bank regarding applicable fees for incoming payments from Singapore.<br>To help you keep your transfer fees low, a minimum amount of SGD 100 should be accumulated in your account before you can request a payout.</p><p>Please click <b>Finish</b> to complete</p></section></div>");
$templateCache.put("app/components/add-cheque-method-popup/add-cheque-method-popup.html","<div class=add-cheque-method-popup__content><div class=\"add-cheque-method-popup__content__title text--extrabold text--color-black\">Cheque</div><div class=add-cheque-method-popup__content__description><p>If you would like to receive payments by cheque, please contact us at <a class=\"text--color-pixerf-theme text--bold\" href=mailto:payments@pixerf.com>payments@pixerf.com</a>.</p><p>Cheque payments are only available within Singapore and a SGD 2.00 administrative fee will be payable for each cheque. You will receive a cheque by post within five working days.</p></div></div>");
$templateCache.put("app/components/add-inputfield-btn/add-inputfield-btn.html","<div class=add-inputfield-btn><div ng-repeat=\"item in model\" class=add-inputfield-btn__control-wrapper><input class=\"add-inputfield-btn__field form-control\" ng-model=item.value placeholder={{placeholder}} name={{name}} \\> <span ng-if=!vm.isMinCount() class=\"add-inputfield-btn__remove-field icon-icons_close\" ng-click=vm.removefield(item.index)></span></div><button ng-if=!vm.isMaxCount() class=\"add-inputfield-btn__add-button btn text--bold\" ng-click=vm.addfield()><span class=icon-icons_plus></span> Add field</button></div>");
$templateCache.put("app/components/add-payout-method-popup/add-payout-method-popup.html","<pixerf-alert class=signin-popup instance=vm.pixerfAlert></pixerf-alert><div class=\"add-payout-method-popup clearfix\"><div class=\"add-payout-method-popup__header clearfix\"><div class=\"add-payout-method-popup__title text--extrabold text--color-black pull-left\" translate>{{\'add-payout-method\'}}</div><div class=\"add-payout-method-popup__close icon-icons_close\" role=button ng-click=vm.closePopup()></div></div><list-payment-method-popup alert=vm.pixerfAlert selected-payment-method=vm.selectedPaymentMethod ng-hide=\"step !== 1\"></list-payment-method-popup><add-paypal-method-popup pay-pal-data=vm.addedPayoutMethod alert=vm.pixerfAlert ng-if=\"step === 2 && vm.selectedPaymentMethod.code === \'PAYPAL\'\"></add-paypal-method-popup><add-bank-transfer-method-popup bank-info=vm.selectedPaymentMethod.details ng-if=\"step === 2 && vm.selectedPaymentMethod.code === \'BANK_TRANSFER\'\"></add-bank-transfer-method-popup><add-cheque-method-popup alert=vm.pixerfAlert ng-if=\"step === 2 && vm.selectedPaymentMethod.code === \'CHEQUE\'\"></add-cheque-method-popup><div class=\"payout-method-controller clearfix\"><button role=button class=\"payout-method-controller__btn payout-method-controller__btn__left pull-left btn btn--transparent text--semibold\" ng-click=vm.onBackBtnClicked()>{{step == 1 ? \"Cancel\" : \"Back\"}}</button> <button ng-disabled=!vm.selectedPaymentMethod role=button class=\"payout-method-controller__btn payout-method-controller__btn__right pull-left btn btn-submit text--semibold\" ng-click=vm.onNextBtnClicked() ng-if=\"step !== 2\">Next</button> <button ng-disabled=\"vm.isWorking || (vm.selectedPaymentMethod.code === \'PAYPAL\' && !vm.addedPayoutMethod.details)\" role=button class=\"payout-method-controller__btn payout-method-controller__btn__right pull-left btn btn-submit text--semibold\" ng-click=vm.onFinishBtnClicked() ng-if=\"step === 2\">{{\'done\' | translate}}</button></div></div>");
$templateCache.put("app/components/add-paypal-method-popup/add-paypal-method-popup.html","<div class=add-paypal-method-popup__content><section class=add-paypal-method-popup__content--not-connected ng-show=!payPalData.details.email><div class=paypal-logo></div><div class=add-paypal-method-popup__description>PayPal is an online payment processing service that allows you to receive payments from PIXERF. To use PayPal with PIXERF, you must have an existing account with PayPal.<a class=\"text--color-pixerf-theme text--bold\" href=https://www.paypal.com target=_blank> Learn more about Paypal</a></div><button ng-show=!payPalData.details.email ng-click=vm.onConnectPayPalBtnClicked() role=button class=\"add-paypal-method-popup__content__connect-paypal-btn btn btn-submit\">Connect to PayPal</button></section><section class=\"add-paypal-method-popup__content--connected text-center\" ng-show=payPalData.details.email><div class=paypal-logo></div><div class=\"add-paypal-method-popup__status-info clearfix\"><div class=icon-icons_check></div><div class=add-paypal-method-popup__status-info__details><div class=\"text--bold add-paypal-method-popup__content--connected__message-title text--color-black\">Connected to your Paypal account!</div><div class=add-paypal-method-popup__content--connected__message-body>Your PayPal email is <span class=\"text--color-pixerf-theme text--semibold\">{{payPalData.details.email}}</span></div></div></div></section></div>");
$templateCache.put("app/components/add-role/add-role.html","<div class=add-roles><div class=\"row clearfix bg--white\"><div class=setting__main-content__header><h4 class=\"text-left text--bold text--color-black\">Add Page Roles</h4></div><div class=setting__main-content__body><form name=addRolesForm><h6 class=\"text-left setting__main-content__body__title\">Everyone who works on your Page can have a different role depending on what they need to work on. <span class=\"text--color-pixerf-theme text--bold\">Learn More</span></h6><div class=\"clearfix margin-md--top\"><div class=\"clearfix person-role-item\" ng-repeat=\"personRole in vm.personRoles\"><span ng-click=\"vm.removePersonRoleBtnClicked(vm.personRoles, $index)\" class=\"btn-close icon-icons_close\" aria-hidden=true></span><div class=\"form-group col-md-6\"><label required for=\"\">Email</label><input required ng-attr-name=\"{{\'email_\' + $index}}\" type=email ng-model=personRole.email class=form-control placeholder=\"\"></div><div class=\"form-group col-md-6\"><label for=\"\">Assign Role <span uib-tooltip=\"Place holder\" class=icon-icons-info tooltip-placement=auto></span></label><select required ng-attr-name=\"{{\'role_\' + $index}}\" class=form-control ng-model=personRole.role ng-value=role.id ng-options=\"opt.id as opt.name for opt in vm.roles.data\"><option value=\"\"></option></select></div></div><div ng-click=vm.onAddPersonRoleBtnClicked(vm.personRoles) class=\"text--color-pixerf-theme text--bold add_role_btn\">+ Add another person</div></div></form></div></div></div>");
$templateCache.put("app/components/add-to-cart-btn/add-to-cart-btn.html","<div class=\"text-center add-to-cart-btn\"><div><button ng-disabled=\"vm.isWorking || isDisabled\" class=\"container-full btn btn-submit btn-block\" ng-click=vm.onAddToCartClicked(media)>{{mode === \"EDIT\" ? \'Edit Cart\' : (\'add-to-cart\' | translate)}}</button></div></div>");
$templateCache.put("app/components/add-to-gallery/add-to-gallery-popover-tmpl.html","<div><div class=\"popover-title clearfix add-to-gallery__header\"><div class=\"pull-left text--bold text--color-black\" translate>{{\'add-to-gallery\'}}</div><button type=button class=\"add-to-gallery__btn-close close pull-right\" ng-click=\"vm.isOpen.data = false\"><span class=icon-icons_close></span></button></div><div class=add-to-gallery__body><div class=add-to-gallery__create-new-gallery-btn-wrapper authentication-click=vm.onCreateGalleryBtnClicked() check-verified-email=true><span class=icon-icons-plus-box></span> <span class=add-to-gallery__create-new-gallery-btn__btn-label translate>{{\'create-new-gallery\'}}</span></div><div class=\"add-to-gallery__gallery-type-checkbox-wrapper clearfix\" ng-if=file.isMine><stick-checkbox is-disabled=vm.galleryListInstance.spinner.isVisible model=vm model-property=isMyGalleryChecked on-changed=vm.onGalleryCheckboxCheck() label=my-gallery layout-style=solid-square></stick-checkbox><stick-checkbox is-disabled=vm.galleryListInstance.spinner.isVisible model=vm model-property=isCuratedGalleryChecked on-changed=vm.onGalleryCheckboxCheck() label=my-curated-gallery layout-style=solid-square></stick-checkbox></div><galleries-list instance=vm.galleryListInstance ng-if=vm.loginUser user=vm.loginUser gallery-type=vm.galleryType on-galleries-changed=\"vm.onGalleriesChanged(galleries, checkedGalleries)\" on-gallery-item-clicked=\"vm.onGalleryItemClicked(evt, gallery)\"></galleries-list></div><div class=\"clearfix add-to-gallery__tips\" ng-show=closeOnClick><div class=text--color-black>{{\'tip\' | translate}}: {{\'add-photo-to-multiple-gallery\' | translate}}</div></div></div>");
$templateCache.put("app/components/add-to-portfolio-gallery/add-to-portfolio-gallery-popover-tmpl.html","<div><div class=\"popover-title clearfix add-to-gallery__header\"><div class=\"pull-left text--bold text--color-black\" translate>{{\'add-to-portfolio-gallery\'}}</div><button type=button class=\"add-to-gallery__btn-close close pull-right\" ng-click=\"vm.isOpen.data = false\"><span class=icon-icons_close></span></button></div><div class=add-to-gallery__body><div class=add-to-gallery__create-new-gallery-btn-wrapper ng-click=vm.onCreatePortfolioGalleryBtnClicked()><span class=icon-icons-plus-box></span> <span class=add-to-gallery__create-new-gallery-btn__btn-label translate>{{\'create-new-portfolio-gallery\'}}</span></div><portfolio-galleries-list instance=vm.portfolioGalleryListInstance ng-if=vm.loginUser user=vm.loginUser portfolio-id={{vm.portfolioId}} on-portfolio-galleries-changed=\"vm.onPortfolioGalleriesChanged(galleries, checkedGalleries)\" on-portfolio-gallery-item-clicked=\"vm.onPortfolioGalleryItemClicked(evt, portfolioGallery)\"></portfolio-galleries-list></div><div class=\"clearfix add-to-gallery__tips\" ng-show=closeOnClick><div class=text--color-black>{{\'tips\' | translate}}: {{\'add-photo-to-multiple-gallery\' | translate}}</div></div></div>");
$templateCache.put("app/components/additional-entries-popup/additional-entries-popup.html","<div class=additional-entries-popup><div class=\"additional-entries-popup__header clearfix\"><div class=\"additional-entries-popup__close icon-icons_close\" role=button ng-click=vm.onCancelClicked()></div></div><div class=additional-entries-popup__content><form name=additionalEntriesForm><div class=\"additional-entries-popup__info-group clearfix\"><div class=\"additional-entries-popup__info-group__label text--semibold text--color-black\">Please select the number of additional entries you wish to submit</div><div class=\"additional-entries-popup__quantity clearfix\"><div class=\"additional-entries-popup__quantity__label text--semibold text--color-black\">Quantity</div><pixerf-input-auto-complete ng-if=\"vm.quantities.length > 0\" class=additional-entries-popup__quantity__input data=vm.quantities model=vm.geoGraphicInstance.additionalEntries options=vm.bootstrapSelectOptions on-changed=vm.onQuantityChanged(vm.geoGraphicInstance.additionalEntries)></pixerf-input-auto-complete></div></div></form><div class=\"additional-entries-popup__control-btn-wrapper clearfix\"><button ng-disabled=\"!vm.freeEntriesCount && vm.isDisabledUloadbtn\" class=\"btn btn-submit additional-entries-popup__btn text--bold\" ng-click=vm.onSubmitClicked(additionalEntriesForm)>Upload Now</button></div></div></div>");
$templateCache.put("app/components/adult-content-overlay/adult-content-overlay.html","<div class=adult-content-overlay ng-hide=showContent ng-class=\"{\'adult-content-opacity\': buttonShow}\"><div class=\"adult-content-overlay__content text--bold\" ng-show=!buttonShow>Adult Content</div><div ng-show=buttonShow class=adult-content-container><div class=\"adult-content-container__warning text--bold text--color-pixerf-theme\">NOTICE</div><h1 class=\"adult-content-container__title text--bold\">Adult Content</h1><div class=adult-content-container__content>This photo contains elements that may be unsuitable or offensive for some audiences. Because of this, it will not be visible to the public nor available for licensing in our Marketplace. You may consider removing it from your gallery.</div><div class=\"adult-content-container__advised text--bold\">Viewer Discretion Advised</div><button ng-click=\"showContent = !showContent\" class=adult-content-container__button>I got it! Show me the photo</button></div></div>");
$templateCache.put("app/components/agreement-popup/agreement-popup.html","<div class=agreement-popup><button type=button class=close ng-click=vm.cancel()><span class=icon-icons_close aria-hidden=true></span></button><div class=clearfix><div class=\"modal-header text-left\"></div><div class=\"modal-body text-left\"><div class=agreement-popup__checkbox><pixerf-checkbox model=vm model-property=isAgree></pixerf-checkbox><div class=agreement-popup__checkbox__text compile=\"vm.message | translate\"></div></div></div><div class=modal-footer><button ng-disabled=\"!vm.isAgree || vm.isWorking\" ng-click=vm.ok() type=button class=\"btn btn-submit\">{{vm.okBtnText}}</button></div></div></div>");
$templateCache.put("app/components/alert/alert.html","<div class=alert-message ng-class=\"!instance.isVisible ? \'alert-message--hide\' : \'alert-message--show\'\"><div class=alert ng-class=\"\'alert-\' + instance.type \" ng-bind-html=instance.msg></div></div>");
$templateCache.put("app/components/alert-message-popup/alert-message-popup.html","<div class=alert-message-popup><button type=button class=\"alert-message-popup__close-icon close\" ng-click=vm.close()><span class=icon-icons_close aria-hidden=true></span></button><div class=alert-message-popup__content><div class=alert-message-popup__content__title><span ng-if=vm.isPaymentSuccessContex class=icon-icons_check></span><span translate>{{vm.title}}</span></div><div class=alert-message-popup__content__description ng-bind-html=\"vm.description | translate\"></div></div><button ng-if=vm.isPaymentSuccessContex type=button class=\"alert-message-popup__continue-btn btn\" ng-click=vm.onContinue()>Continue Xerfing</button></div>");
$templateCache.put("app/components/approve-reject-release-form/approve-reject-release-form.html","<div class=approve-reject-release-form><div ng-if=vm.loginUser.canCurate><button ng-if=\"file.status === \'pending\'\" ng-disabled=vm.isWorking class=\"container-full btn btn-submit btn-block\" ng-click=\"vm.review(\'approve\')\">Approve For Commercial</button> <button ng-if=\"file.status === \'pending\'\" ng-disabled=vm.isWorking class=\"container-full btn btn--transparent btn-block\" ng-click=\"vm.review(\'reject\')\">Reject</button> <button ng-class=\"{\'btn-submit\': vm.btnLabel === \'Approve For Commercial\', \'btn-submit approve-reject-release-form__approved-btn\': vm.btnLabel === \'Approved\', \'btn--transparent\': vm.btnLabel === \'Reject\' || vm.btnLabel === \'Rejected\' }\" ng-if=\"file.status !== \'pending\'\" ng-disabled=\"vm.isWorking \" ng-mouseover=vm.onMouseOver(file) ng-mouseleave=vm.onMouseLeave() class=\"container-full btn btn-block\" ng-click=vm.review()>{{vm.btnLabel}}</button> <button ng-if=\"file.status === \'rejected\' || file.status === \'approved\'\" ng-disabled=vm.isWorking class=\"container-full btn btn--transparent btn-block\" ng-click=\"vm.review(\'pend\')\">{{\'pending-review\' | translate}}</button></div></div>");
$templateCache.put("app/components/auth/auth.html","<ul ng-switch=vm.isAuthenticated() class=user-panel ng-class=\"vm.isAuthenticated() ? \'user-panel--authenticated\' : \'\'\"><!-- <popover-selection-btn ng-if=\"vm.languagesSetting\" class=\"multi-language-dropdown\" close-on-click=\"true\"\r\n		on-selection-changed=\"vm.onLanguagesSelected(item)\" selected-model=\"vm.language\" settings=\'vm.languagesSetting\'\r\n		selected-default-index=\"{{vm.selectedDefaultIndex}}\">\r\n	</popover-selection-btn> --><!-- <li uib-dropdown=\"\" class=\"user-panel__multi-language dropdown open\" ng-class=\"{\'style-open\': businessMenu.isopen}\"\r\n		ng-mouseover=\"businessMenu.isopen = true\" ng-mouseleave=\"businessMenu.isopen = false\">\r\n		<div uib-dropdown-toggle=\"\" class=\"user-panel__multi-language__button dropdown-toggle\" aria-haspopup=\"true\"\r\n			aria-expanded=\"true\">\r\n			<span class=\"user-panel__multi-language__selected-language\">{{vm.selectedLanguage}}</span>\r\n			<span class=\"icon-icons_chevron-down arrow-direct-with-menu dropdown-icon-menu\"></span>\r\n		</div>\r\n		<ul class=\"dropdown-menu user-panel__multi-language__submenu-btn\" uib-dropdown-menu=\"\" role=\"menu\"\r\n			aria-labelledby=\"single-button\">\r\n			<li ng-click=\"vm.onLanguagesSelected({name: \'English\', value: \'en\'})\">\r\n				<a class=\"text-transform\" ng-class=\"{\'active\': vm.selectedLanguage == \'en\'}\">English - EN</a>\r\n			</li>\r\n			<li>\r\n				<a class=\"text-transform\">Bahasa Indonesia - ID <span>(coming soon)</span></a>\r\n			</li>\r\n		</ul>\r\n	</li> --><li class=\"user-panel__tools user-panel__curation-panel\" ng-if=\"vm.loginedUser && (vm.loginedUser.role === \'admin_internal\' || vm.loginedUser.role === \'curator_internal\')\"><div uib-dropdown navbar-stop-collapse-on-click class=user-panel__curation-panel__item-more><div class=user-panel__curation-panel__item-more__btn uib-dropdown-toggle navbar-stop-collapse-on-click><span class=user-panel__curation-panel__item-more__btn__icon data-ng-style=\"vm.isViewMoreActived() ?{\'background-image\': \'url(assets/images/curation-icon-active.svg)\'} : {\'background-image\': \'url(assets/images/curation-icon.svg)\'}\"></span> <span class=\"icon-icons_chevron-down arrow-direct-with-menu dropdown-icon-menu\"></span></div><ul class=dropdown-menu uib-dropdown-menu role=menu aria-labelledby=single-button><li ng-if=vm.loginedUser.canSeeDirectory ui-sref-active=active ui-sref=buy-stock-page.photographers.featuredPhotographer>Directory</li><li ng-if=vm.loginedUser.canCurate ui-sref-active=active ui-sref=buy-stock-page.pending-photos>Pending Photos</li><li ng-if=vm.loginedUser.canCurate ui-sref-active=active ui-sref=buy-stock-page.pending-portfolio>Pending Portfolio</li><li ng-if=\"vm.loginedUser.role === \'admin_internal\'\" ui-sref-active=active ui-sref=buy-stock-page.pending-commercial-license>Pending Commercial License</li><li ng-if=vm.loginedUser.canCurate ui-sref-active=active ui-sref=buy-stock-page.general-photos>General</li><li ng-if=vm.loginedUser.canCurate ui-sref-active=active ui-sref=buy-stock-page.rejected-photos>Rejected</li><li ng-if=\"vm.loginedUser.role === \'admin_internal\'\" ui-sref-active=active ui-sref=buy-stock-page.temporary-photos>Temporary</li></ul></div></li><li class=\"user-panel__tools user-panel__tools__first-child\" ng-click=vm.showUploadModal() ng-switch-when=true ng-if=\"vm.user.data.canUploadPhotos && !vm.guestUser\"><a class=user-panel__tools__upload href=\"\"><span class=\"icon-icons-upload text--color-pixerf-theme\"></span> <span ng-hide=\"vm.loginedUser && (vm.loginedUser.role === \'admin_internal\' || vm.loginedUser.role === \'curator_internal\')\" class=\"upload-text text--bold text--color-pixerf-theme\" translate>{{\'upload\'}}</span></a></li><li class=\"user-panel__tools user-panel__tools-cart\" role=button ng-class=\"{\'guest-user\': !vm.isAuthenticated()}\"><popover-cart></popover-cart></li><li class=\"user-panel__tools user-panel__tools-notification\" ng-switch-when=true><notification-btn></notification-btn></li><li class=user-panel__avatar><div href=\"\" class=user-panel__avatar__wrapper><span uib-dropdown class=user-panel__avatar__username-wrapper on-toggle=vm.onProfileMenuToggle(open)><span uib-dropdown-toggle ng-switch-when=true><a ng-if=!vm.updatingdAvatar class=user-panel__avatar__user-profile-pic><pixerf-user-avatar class=pull-left user-data=vm.user.data lazy=true></pixerf-user-avatar></a></span><ul class=\"dropdown-menu user-panel__dropdown-menu\" uib-dropdown-menu role=menu aria-labelledby=single-button><div ng-switch-when=true class=proflie-menu__remove-btn ng-if=vm.isProfileMenuOpen><span class=\"icon-bar one\"></span> <span class=\"icon-bar two\"></span></div><li ng-switch-when=true class=user-panel__upload-photos ng-click=vm.showUploadModal() ng-if=\"vm.user.data.canUploadPhotos && !vm.guestUser\"><a href=\"\"><span class=icon-icons-upload></span> <span class=upload-text translate>{{\'upload\'}}</span></a></li><li class=user-panel__tools-cart--mobile role=button><popover-cart></popover-cart></li><li ng-switch-when=true class=user-panel__tools-notification--mobile><notification-btn></notification-btn></li><li ng-switch-when=true role=menuitem class=\"dropdown-menu-title text--extrabold account-title\" translate>{{\'account\'}}</li><li ng-switch-when=true role=menuitem><a ng-click=vm.onCloseBtnClicked() ng-if=!vm.guestUser redirect-to-profile=vm.user.data class=user-panel__dropdown-menu__item>{{\'my-profile\' | translate}}</a> <a ng-if=vm.guestUser redirect-to-profile=vm.user.data>{{\'my-profile\' | translate}}</a></li><li ng-switch-when=true ng-click=vm.onSettingClicked() role=menuitem><a ng-click=vm.onCloseBtnClicked() href=\"\" translate translate-values=\"{name: (\'profile\' | translate)}\" class=user-panel__dropdown-menu__item>{{\'edit\'}}</a></li><li ng-if=vm.isAbleToChangePassword ng-switch-when=true role=menuitem><a ng-click=vm.onCloseBtnClicked() ui-sref=setting.change-password translate class=user-panel__dropdown-menu__item>{{\'change-password\'}}</a></li><li ng-switch-when=true role=menuitem><a ng-click=vm.onCloseBtnClicked() ui-sref=setting.purchase-history.order-list translate class=user-panel__dropdown-menu__item>{{\'purchase-history\'}}</a></li><li ng-switch-when=true role=menuitem><a ng-click=vm.onCloseBtnClicked() ui-sref=setting.earnings.my_earnings.images_sold ng-if=\"vm.user.data.canManageEarning && !vm.guestUser\" translate class=user-panel__dropdown-menu__item>{{\'earnings\'}}</a></li><li ng-switch-when=true ng-if=\"vm.user.data.isTrialUser || vm.user.data.canBuyCreditPlan\" role=menuitem><a ng-click=vm.onCloseBtnClicked() ng-if=!vm.guestUser ui-sref=setting.my_credit class=user-panel__dropdown-menu__item>{{\'my-credits\' | translate}}</a></li><li ng-switch-when=true role=menuitem class=\"dropdown-menu-title auth-menu-manage text--extrabold\" translate>{{\'manage\'}}</li><li ng-switch-when=true role=menuitem ng-if=vm.user.data.isFinanceInternal><a ng-click=vm.onCloseBtnClicked() ui-sref=payout-requests-page class=user-panel__dropdown-menu__item>Payout Requests</a></li><li ng-switch-when=true role=menuitem><a ng-click=vm.onCloseBtnClicked() ui-sref=setting.manage-photos.pending-review ng-if=\"vm.user.data.canUploadPhotos && !vm.guestUser\" class=user-panel__dropdown-menu__item>Photos</a></li><li ng-switch-when=true role=menuitem ng-if=vm.user.data.isContributor><a ui-sref=setting.manage-photos-mission.pending check-verified-email=true ng-if=\"vm.user.data.isContributor && !vm.guestUser\" class=user-panel__dropdown-menu__item>{{\'community-challenges\' | translate}}</a></li><li ng-switch-when=true role=menuitem><a authentication-click=vm.onManageCommissionClicked() ng-if=!vm.guestUser check-verified-email=true class=user-panel__dropdown-menu__item>{{\'custom-content-assignments\' | translate}}</a></li><li ng-switch-when=true role=menuitem ng-if=vm.user.data.isBiz><a ng-if=\"vm.user.data.canManageMission && !vm.guestUser\" authentication-click=vm.onManageMissionClicked() check-verified-email=true class=user-panel__dropdown-menu__item>{{\'community-challenges\' | translate}}</a></li><li ng-switch-when=true role=menuitem ng-if=vm.user.data.canVerifyBusinessUser><a ui-sref=setting.user-verification.sign-up class=user-panel__dropdown-menu__item>{{\'user-verification\' | translate}}</a></li><li ng-switch-when=true role=menuitem ng-if=vm.user.data.canCreateMediaPixerf><a ng-click=vm.onManageMediaPostClicked() class=user-panel__dropdown-menu__item>{{\'media\' | translate}}</a></li><li ng-switch-when=true role=menuitem><a ng-click=vm.onManageCommunityClicked() ng-if=!vm.guestUser check-verified-email=true class=user-panel__dropdown-menu__item>{{\'community-hub\' | translate}}</a></li><li ui-sref=logout role=menuitem class=logout-btn><a translate class=user-panel__dropdown-menu__item>{{\'logout\'}}</a></li></ul><div class=profile-menu-overlay ng-if=vm.isProfileMenuOpen></div></span></div></li><li id=E1 class=user-panel__sign-up-btn ng-switch-when=false ng-click=vm.onSignUpBtnClicked()><a href=\"\" class=text--color-pixerf-theme>{{\'sign-up\' | translate}}</a></li><li class=user-panel__log-in-btn ng-switch-when=false ng-click=vm.onSignInBtnClicked()><a href=\"\">{{\'log-in\' | translate}}</a></li></ul>");
$templateCache.put("app/components/background-slider/background-slider.html","<div class=background-slider><div ng-if=\"photos && photos.length\" ng-repeat=\"photo in photos\" class=background-slider__slide ng-class=\"\'background-slider__slide\' + photo.index\"><div class=background-slider__slide__bg ng-style=\"{\'background-image\':\'url({{photo.url}})\'}\" ng-class=\"{\'background-slider__background\': photo.smallUrl}\"></div><div class=background-slider__slide__bg ng-style=\"{\'background-image\':\'url({{photo.smallUrl}})\'}\" ng-class=\"{\'background-slider__background--small\': photo.smallUrl}\"></div><photo-info-link ng-if=\"!photo.subbgs && !hideAuthor\" photo=photo></photo-info-link></div></div>");
$templateCache.put("app/components/banned-user-btn/banned-user-btn.html","<div class=\"banned-user-btn-wrapper text-center\"><button ng-mouseover=vm.onMouseOver() ng-mouseleave=vm.onMouseLeave() ng-class=\"{\'banned-user-btn--banned\': user.is_banned, \'banned-user-btn--unban\': vm.isHovering}\" class=\"btn btn-pixerf-theme--blue btn-pixerf-theme--no-background text--bold suggest-btn\" authentication-click=vm.onBanClicked() authentication-click-action=SUGESST_PERSON><span class=\"icon- banned-user-btn__icon\"></span><span class=banned-user-btn__btn-label>{{vm.btnLabel}}</span></button></div>");
$templateCache.put("app/components/banned-user-popup/banned-user-popup.html","<div class=banned-user-popup><div class=banned-user-popup__input-form ng-show=\"vm.state == 2\"><div class=banned-user-popup__header translate>{{\'your-account-has-been-flagged\'}}</div><div class=banned-user-popup__sub-header translate>{{\'you-will-not-be-able-to-access-your\'}}</div><div class=banned-user-popup__infro-form><form name=bannedUserForm><div class=banned-user-popup__info-form__row><label for=name translate>{{\'name\'}}</label><input required validation-no-hyperlink validation-no-number ng-model=vm.inquiry.name name=name placeholder=\"Enter your name\" class=form-control></div><div class=banned-user-popup__info-form__row><label for=email translate>{{\'email\'}}</label><input required name=email ng-model=vm.inquiry.email type=email class=form-control placeholder=\"Enter your email\"></div><div class=banned-user-popup__info-form__row><label for=source translate>{{\'verify-source-of-your-photos\'}}</label><input required name=source ng-model=vm.inquiry.topic type=text class=form-control placeholder=\"E.g. IG Handle @pixerf, Facebook username\"></div><div class=banned-user-popup__info-form__row><label for=description translate>{{\'additional-comments\'}}</label><textarea rows=4 name=description ng-model=vm.inquiry.description class=\"form-control form-control__textarea\"></textarea></div></form></div><button ng-disabled=\"vm.isWorking || !bannedUserForm.$valid\" type=button class=\"banned-user-popup__submit-btn btn btn-submit\" ng-click=\"vm.sendEnquire(vm.inquiry, bannedUserForm)\">Verify Account</button></div><div class=banned-user-popup__banned-message ng-show=\"vm.state == 1\"><div class=banned-user-popup__state-1__header>You can\'t access your PIXERF account at the moment.</div><div class=banned-user-popup__state-1__sub-header>We are reviewing the information you provided.</div><div class=banned-user-popup__state-1__message>If you believe we have restricted your account in error, please contact us at <a class=banned-user-popup__state-1__email-admin-btn href=mailto:curator@pixerf.com>curator@pixerf.com </a>.</div><div class=banned-user-popup__state-1__footer><button ng-disabled=vm.isWorking type=button class=\"banned-user-popup__state-1__footer__submit-btn btn btn-submit\" ng-click=vm.onLogoutBtnClicked()>Log Out</button></div></div></div>");
$templateCache.put("app/components/banner-box-intro/banner-box-intro.html","<div class=banner-box-intro><div class=\"banner-box-intro__box {{vm.data.style ? vm.data.style.styleBackgroundBox : \'\'}}\"><div ng-if=vm.data.title class=\"banner-box-intro__box__title {{vm.data.style ? vm.data.style.styleText : \'\'}}\">{{vm.data.title}}</div><div ng-if=vm.data.description class=\"banner-box-intro__box__description {{vm.data.style ? vm.data.style.styleText : \'\'}}\">{{vm.data.description}}</div><button ng-if=vm.data.buttonText class=\"banner-box-intro__box__submit-btn {{vm.data.style.styleButton}}\" ng-click=vm.onBtnClicked()>{{vm.data.buttonText}}</button><ng-transclude ng-if=isTranscluded class=banner-box-intro__box__transclude></ng-transclude></div></div>");
$templateCache.put("app/components/banner-hover-change/banner-hover-change.html","<section class=\"row banner-hover-change\"><div class=\"banner-hover-change__background clearfix\"><div class=your-lens-background ng-show=vm.yourLendsHover></div><div class=your-space-background ng-show=vm.yourSpaceHover></div><div class=your-community-background ng-show=vm.yourCommunityHover></div><div class=banner-hover-change__big-title ng-if=\"!vm.yourLendsHover && !vm.yourSpaceHover && !vm.yourCommunityHover\">Define</div><div class=\"banner-hover-change__block your-lens\"><div class=\"banner-hover-change__block__hover-overlay your-lens\" ng-mouseover=\"vm.yourLendsHover = true\" ng-mouseleave=\"vm.yourLendsHover = false\"><div class=overlay-color><div class=\"overlay-color__label text--semibold\">Uploads</div><div class=\"overlay-color__subtitle text--extrabold\">Through your</div><div class=\"overlay-color__title text--extrabold\">Lens</div><div class=overlay-color__footer><div class=overlay-color__description>Fusce vehicula dolor arcu, sit amet blandit dolor mollis nec. Donec viverra eleifend lacus, vitae ullamcorper metus. Sed sollicitudin ipsum quis nunc sollicitudin ultrices.</div><div class=\"overlay-color__category text--extrabold\">{{\'marketplace\' | translate}}</div></div></div></div><div class=\"banner-hover-change__block__top-title text-overlay text--bold mouseover-condition\" ng-class=\"{\'mouse-in\': !vm.yourLendsHover}\">Uploads</div><div class=\"banner-hover-change__block__content text--extrabold mouseover-condition\" ng-class=\"{\'mouse-in\': !vm.yourLendsHover}\"><span class=title>Through your</span> <span class=highlight>X</span></div><div class=\"banner-hover-change__block__bottom-title text-overlay text--bold mouseover-condition\" ng-class=\"{\'mouse-in\': !vm.yourLendsHover}\">Authentic</div></div><div class=\"banner-hover-change__block your-space\"><div class=\"banner-hover-change__block__hover-overlay your-space\" ng-mouseover=\"vm.yourSpaceHover = true\" ng-mouseleave=\"vm.yourSpaceHover = false\"><div class=overlay-color><div class=\"overlay-color__label text--semibold\">Portfolio</div><div class=\"overlay-color__subtitle text--extrabold\">Through your</div><div class=\"overlay-color__title text--extrabold\">Space</div><div class=overlay-color__footer><div class=overlay-color__description>Fusce vehicula dolor arcu, sit amet blandit dolor mollis nec. Donec viverra eleifend lacus, vitae ullamcorper metus. Sed sollicitudin ipsum quis nunc sollicitudin ultrices.</div><div class=\"overlay-color__category text--extrabold\">Custom Commission</div></div></div></div><div class=\"banner-hover-change__block__top-title text-overlay text--bold mouseover-condition\" ng-class=\"{\'mouse-in\': !vm.yourSpaceHover}\">Portfolio</div><div class=\"banner-hover-change__block__content text--extrabold mouseover-condition\" ng-class=\"{\'mouse-in\': !vm.yourSpaceHover}\"><span class=title>Through your</span> <span class=highlight>XXX</span></div><div class=\"banner-hover-change__block__bottom-title text-overlay text--bold mouseover-condition\" ng-class=\"{\'mouse-in\': !vm.yourSpaceHover}\">Customise</div></div><div class=\"banner-hover-change__block your-community\"><div class=\"banner-hover-change__block__hover-overlay your-community\" ng-mouseover=\"vm.yourCommunityHover = true\" ng-mouseleave=\"vm.yourCommunityHover = false\"><div class=overlay-color><div class=\"overlay-color__label text--semibold\">Participation</div><div class=\"overlay-color__subtitle text--extrabold\">Through your</div><div class=\"overlay-color__title text--extrabold\">Community</div><div class=overlay-color__footer><div class=overlay-color__description>Fusce vehicula dolor arcu, sit amet blandit dolor mollis nec. Donec viverra eleifend lacus, vitae ullamcorper metus. Sed sollicitudin ipsum quis nunc sollicitudin ultrices.</div><div class=\"overlay-color__category text--extrabold\">Missions</div></div></div></div><div class=\"banner-hover-change__block__top-title text-overlay text--bold mouseover-condition\" ng-class=\"{\'mouse-in\': !vm.yourCommunityHover}\">Participation</div><div class=\"banner-hover-change__block__content text--extrabold mouseover-condition\" ng-class=\"{\'mouse-in\': !vm.yourCommunityHover}\"><span class=title>Through your</span> <span class=highlight>XXXX</span></div><div class=\"banner-hover-change__block__bottom-title text-overlay text--bold mouseover-condition\" ng-class=\"{\'mouse-in\': !vm.yourCommunityHover}\">Crowdsource</div></div></div></section>");
$templateCache.put("app/components/bg-changer/bg-changer.html","<div class=bg-changer><div ng-if=!noOverlay class=overlay></div><div class=bg-changer__photos></div><photo-info-link photo=photo ng-if=!hideAuthor></photo-info-link></div>");
$templateCache.put("app/components/billing-information/billing-information.html","<div class=\"billing-pannel ng-hide\"><div class=\"billing-pannel__title clearfix\"><div class=\"pull-left text--semibold\">Billing Information</div><div class=\"pull-right edit-btn text--color-pixerf-theme\" role=button ui-sref=checkout.billing-information>Edit</div></div><div class=billing-pannel__description>{{ vm.user.billing_information.company }}<br>{{ vm.user.billing_information.first_name + \' \' + vm.user.billing_information.last_name }}<br>{{ vm.user.billing_information.address }}<br>{{ vm.user.billing_information.city }} {{ vm.user.billing_information.country }} {{ vm.user.billing_information.postal_code }}</div></div>");
$templateCache.put("app/components/block-member-popup/block-member-popup.html","<div class=block-member-popup><div class=block-member-popup__header><button type=button class=close ng-click=vm.closePopup()><span class=icon-icons_close aria-hidden=true></span></button></div><div class=block-member-popup__body><div class=block-member-popup__body__title>Block Member?</div><div>The member will not be able to find, see or rejoin this Community. Are you sure you want to block this member?</div><div class=block-member-popup__stick-wrapper><div><stick-checkbox on-changed=vm.onDeletePostsComments(vm.blockOptions.posts) model=vm.blockOptions model-property=posts label={{vm.blockPostLabel}} layout-style=regular-square></stick-checkbox></div></div></div><div class=block-member-popup__footer><button class=\"block-member-popup__footer__control btn btn--transparent\" ng-click=vm.closePopup()>Cancel</button> <button class=\"block-member-popup__footer__control btn btn-submit\" ng-click=vm.onConfirm()>Confirm</button></div></div>");
$templateCache.put("app/components/brand-comment-photo-tile/brand-comment-photo-tile.html","<div class=brand-comment-photo-tile><div class=brand-comment-photo-tile__header><div class=brand-comment-photo-tile__header__logo ng-class=\"{\'circle-image\': item.user.account_type === \'personal\'}\"><img ng-src=\"{{item.user.profile_image_media[\'100x\']}}\" alt={{item.user.displayName}}></div><div class=brand-comment-photo-tile__header__name>{{item.user.displayName}}</div><div class=brand-comment-photo-tile__remove-button ng-click=vm.onRemoveClicked(item) ng-if=options.canRemove><div class=icon-icons_close></div></div></div><div class=brand-comment-photo-tile__comment><div class=brand-comment-photo-tile__comment__content>{{item.text}}</div></div><div class=brand-comment-photo-tile__footer><div class=brand-comment-photo-tile__footer__photo><img ng-src=\"{{item.thumbnails[\'160x\']}}\" alt={{item.title}}></div><div class=brand-comment-photo-tile__footer__name>{{item.title}}</div></div></div>");
$templateCache.put("app/components/brands-say-column/brands-say-column.html","<div class=brands-say-column><slick speed=1000 responsive=vm.responsive class=brands-say-column__carousel infinite=false slides-to-scroll=3 slides-to-show=3 dots=false arrows=false on-init=vm.slickSetting.onInit(slick) on-after-change=\"vm.slickSetting.onAfterChange(event, slick, currentSlide, nextSlide)\" on-breakpoint=\"vm.slickSetting.breakpoint({event, slick, breakpoint})\"><div ng-repeat=\"brand in vm.brands\" class=brands-say-column__item><div class=brands-say-column__header><img ng-src={{brand.logo}} class=brands-say-column__header__logo alt={{brand.name}}></div><div class=brands-say-column__body><div class=brands-say-column__body__content><!-- <span class=\"brands-say-column__body__content__double-quotation-marks\">\"</span> --> <span>{{brand.content}}</span></div><div class=brands-say-column__body__author><div class=brands-say-column__body__author__name>{{brand.name}}</div><div class=brands-say-column__body__author__role>{{brand.role}}</div><div ng-if=brand.company class=brands-say-column__body__author__company>{{brand.company}}</div></div></div></div></slick><div class=brands-say-column__slide-control><div class=\"brands-say-column__slide-control__left icon-slide-prev-icon\" ng-click=vm.onPreviousSlide()></div><div class=brands-say-column__slide-control__text>{{vm.currentSlide || 1}} of {{vm.totalSlide}}</div><div class=\"brands-say-column__slide-control__right icon-slide-next-icon\" ng-click=vm.onNextSlide()></div></div></div>");
$templateCache.put("app/components/bread-crumbs/bread-crumbs.html","<ul class=pixerf-breadcrumb><li class=\"pixerf-breadcrumb__item clearfix\" ng-repeat=\"item in items\" ng-class=\"{\'current-item\': $index === vm.currentIndex, \'breadcumb-first-item\': $first, \'prev-item\': $index < vm.currentIndex}\"><div ng-if=!$first class=\"breadcrumb-divide icon-icons_chevron-right\" ng-class=\"{\'current-item\': $index === vm.currentIndex, \'prev-item\': $index < vm.currentIndex}\"></div><div class=breadcrumb-item-wrapper ng-click=vm.onBreadCrubmClicked(item) ng-class=\"{\'breadcrumb-item-wrapper--disabled\': $index > vm.currentIndex}\"><div class=\"breadcrumb-item-table text--bold\"><span class=breadcrumb-item-label translate>{{item.label}}</span></div></div></li></ul>");
$templateCache.put("app/components/bread-crumbs-style-one/bread-crumbs-style-one.html","");
$templateCache.put("app/components/bulk-edit-photo-detail/bulk-edit-photo-detail.html","<div class=\"upload-photo-detail bulk-edit-photo-detail text-left\"><div class=upload-photo-detail__header><h4 class=\"text--bold text--color-black\">{{\'edit-photo\' | translate}}</h4><div ng-show=vm.masterFile.data.id><call-to-action-messages messages=vm.callToActionMesages></call-to-action-messages></div><!-- <div class=\"upload-photo-detail__header__help\">\r\n            <div class=\"text--bold text--color-pixerf-theme upload-photo-detail__header__help__title\">{{\'upload-maximise-licensed\' | translate}}</div>\r\n            <div class=\"upload-photo-detail__header__help__description\">{{\'upload-maximise-licensed-body\' | translate}}</div>\r\n        </div> --></div><ng-form class=upload-photo-detail__body name=uploadform ng-class=\"{\'pixerf-form-dirty\': isFormDirty}\"><!-- <div class=\"form-group upload-photo-detail__category-selection\">\r\n            <label class=\"text--bold\" for=\"\">{{\'category\' | translate}}<span class=\"icon-icons-info upload-photo-detail__small-icon\" tooltip-append-to-body=\"true\" tooltip-class=\"upload-photo-detail__tooltips\" tooltip-placement=\"auto\" uib-tooltip=\"{{\'tool-tip-categories\' | translate}}\" ></span></label>\r\n            <div is-disabled=\"!vm.masterFile.data\" class=\"multiple-dropdown-selection\" ng-dropdown-multiselect=\"\" events=\"{onItemSelect: vm.categoryDropdownSettings.events.onSelectionChanged, onItemDeselect: vm.categoryDropdownSettings.events.onSelectionChanged, onMaxSelectionReached: vm.categoryDropdownSettings.events.onMaxSelectionReached}\" translation-texts=\"{buttonDefaultText: (\'choose-up-to-categories\' | translate: {number: 3})}\" options=\"categories.data\" selected-model=\"vm.masterFile.data.categories\" extra-settings=\"vm.categoryDropdownSettings\" ng-class=\"{\'upload-photo-detail__placeholder-text-categories ng-invalid\': !files[0].categories || files[0].categories.length < 1}\"></div>\r\n        </div> --><div class=form-group><label class=text--bold for=\"\">{{\'keywords\' | translate}} <span class=\"icon-icons-info upload-photo-detail__small-icon\" tooltip-append-to-body=true tooltip-class=upload-photo-detail__tooltips tooltip-placement=auto uib-tooltip=\"{{\'tool-tip-keywords\' | translate}}\"></span></label><div class=relative><tags-input tag-class=vm.getTagClass($tag) min-length=2 template=pixerf-keyword-template display-property=text replace-spaces-with-dashes=false on-invalid-tag=\"vm.onInvalidTag($tag, scope)\" on-tag-added=vm.onTagAdded($tag) ng-disabled=\"\" ng-model=vm.masterFile.data.tags placeholder=\"{{\'add-keywords\' | translate}}\" class=upload-photo-detail__keywords on-tag-removed=vm.onTagRemoved($tag)><auto-complete select-first-match=false source=vm.loadTags($query)></auto-complete><pixerf-placeholder text=\"{{isLoadingClarifai ? \'We are generating keywords for you....\' : \'Adding at least 10 keywords will make it easier for others to search for your photo.\'}}\" is-visible=\"vm.masterFile.data.tags.length === 0\"></pixerf-placeholder><div ng-show=isLoadingClarifai ng-click=$event.stopPropagation() class=\"upload-photo-detail__keywords__loading-indicator absolute absolute--full\"><div class=\"absolute absolute--bottom-half\"><pixerf-loading-indicator></pixerf-loading-indicator></div></div></tags-input></div></div><div class=form-group ng-show=\"vm.masterFile.data.suggestedKeywords.length > 0\"><label class=text--bold for=\"\">{{\'suggested-keywords\' | translate}}</label><div><span class=tag-item ng-repeat=\"suggestedKeyword in vm.masterFile.data.suggestedKeywords\" ng-click=\"vm.addTag(vm.masterFile.data.tags, suggestedKeyword)\"><span class=tag-template><span><span class=text--semibold>{{suggestedKeyword}}</span></span></span></span></div></div><!-- <div class=\"form-group upload-photo-detail__title\">\r\n            <label class=\"text--bold\" for=\"\">{{\'title\' | translate}} <span class=\"icon-icons-info upload-photo-detail__small-icon\" tooltip-append-to-body=\"true\" tooltip-class=\"upload-photo-detail__tooltips\" tooltip-placement=\"auto\" uib-tooltip=\"{{\'tool-tip-title\' | translate}}\"></span></label>\r\n            <input required maxlength=\"50\" ng-disabled=\"files.length === 0\" type=\"text\" class=\"form-control\"  validation-no-file-extension placeholder=\"{{\'give-photo-name\' | translate}}\" ng-model=\"vm.masterFile.data.title\" ng-change=\"vm.synchonizedFilesInfo(files, \'title\', vm.masterFile.data.title)\"></input>\r\n        </div> --><!-- <div class=\"form-group upload-photo-detail__description\">\r\n            <label class=\"text--bold\" for=\"\">{{\'description\' | translate}} <span class=\"icon-icons-info upload-photo-detail__small-icon\" tooltip-append-to-body=\"true\" tooltip-class=\"upload-photo-detail__tooltips\" tooltip-placement=\"auto\" uib-tooltip=\"{{\'tool-tip-description\' | translate}}\"></span></label>\r\n            <textarea name=\"description\" maxlength=\"255\" validation-no-hyperlink ng-disabled=\"files.length === 0\" rows=\"4\" type=\"text\" class=\"form-control\"  placeholder=\"{{\'say-something-about-your-photo\' | translate}}\" ng-model=\"vm.masterFile.data.description\" ng-change=\"vm.synchonizedFilesInfo(files, \'description\', vm.masterFile.data.description)\"></textarea>\r\n            <div class=\"text-right\"><span class=\"textarea__length_descriptioon\">{{vm.masterFile.data.description ? vm.masterFile.data.description.length : 0}}/255</span></div>\r\n        </div> --><div class=\"form-group upload-photo-detail__licensing\"><label class=text--bold for=\"\">{{\'usage\' | translate}}</label><photo-license-info photo=vm.masterFile.data show-multiple-lincense=true></photo-license-info><div class=\"upload-photo-detail__release-form-confirm clearfix\" ng-if=\"vm.masterFile.data.state === \'h\' || !vm.masterFile.data.state || vm.loginUser.canCurate\"><photo-license-deternimation-questions class=upload-photo-detail__release-form-confirm__questions is-required=true media=vm.masterFile.data on-question-answered=vm.onQuestionAnswered(question)></photo-license-deternimation-questions><get-release-form-btn ng-if=\"vm.masterFile.data.has_model_property && vm.masterFile.data.license === \'commercial\'\" class=\"btn btn--blue\"></get-release-form-btn></div></div><photo-release-form-selection alert=alert on-selection-changed=\"vm.synchonizedFilesInfo(files, \'releases\', vm.masterFile.data.releases)\" file=vm.masterFile.data ng-if=\"vm.masterFile.data.has_model_property && vm.masterFile.data.license === \'commercial\'\" class=form-group></photo-release-form-selection><!-- <div class=\"form-group upload-photo-detail__photo-price-wrapper clearfix\" ng-if=\"((vm.masterFile.data.user && vm.masterFile.data.user.isVIP) || (!vm.masterFile.data.user && vm.loginUser.isVIP)) && vm.masterFile.data.price_ranges\">\r\n            <label ng-class=\"{\'pixerf-invalid\': !vm.masterFile.data.price.id}\" class=\" text--bold\" for=\"\">Select Photo Price <span class=\"icon-icons-info upload-photo-detail__small-icon\" tooltip-append-to-body=\"true\" tooltip-class=\"upload-photo-detail__tooltips\" tooltip-placement=\"auto\" uib-tooltip=\"Price your photo based on the Large size – our system will auto-generate other sizes and scale the prices accordingly. 20% for Small, 60% for Medium, 150% for X-Large and 200% for XX-Large.\"></span></label>\r\n            <photo-price-selection class=\"upload-photo-detail__photo-price clearfix\" is-disabled=\"files.length === 0\" settings=\"{options: vm.masterFile.data.price_ranges, isShownSubscribeText: vm.masterFile.data.user && !vm.masterFile.data.user.isNoNeedSubscribe}\" selected-model=\"vm.masterFile.data.price\" on-selection-changed=\"vm.synchonizePrice(files, vm.masterFile.data.price)\"></photo-price-selection>\r\n        </div>\r\n        <div ng-if=\"vm.masterFile.data.price\">\r\n            <photo-price-size-selection photo=\"vm.masterFile.data\" is-readonly=\"false\"></photo-price-size-selection>\r\n        </div> --></ng-form><script type=text/ng-template id=pixerf-keyword-template><div class=\"tag-template\">\r\n        <div>\r\n          <span class=\"text--semibold\">{{$getDisplayText()}}</span>\r\n          <a class=\"remove-button icon-icons_close\" ng-click=\"$removeTag()\"></a>\r\n        </div>\r\n      </div></script><script type=text/ng-template id=pixerf-set-price-tooltip-template><div class=\"tag-template\">\r\n            Level up and unlock different price points. <a href=\"\" target=\"_blank\" class=\'pixerf-link--color-theme\' pixerf-close-on-click=\"true\">Learn more about Levelling.</a>\r\n      </div></script><script type=text/ng-template id=pixerf-upload-photo-release-template><div class=\"tag-template\">\r\n            Models and private property owners need to give you permission to use them in commercial photos.<a ui-sref=\"introduction-support.faq.personal({section: \'licensing\'})\" target=\"_blank\" class=\'text--color-pixerf-theme text--bold\' pixerf-close-on-click=\"true\"> Learn more.</a>\r\n      </div></script></div>");
$templateCache.put("app/components/bulk-edit-photo-popup/bulk-edit-photo-popup.html","<pixerf-alert instance=vm.pixerfAlert></pixerf-alert><div class=\"bulk-edit-photo-popup bulk-edit-photo-popup bg--white\"><button type=button class=\"close bulk-edit-photo-popup__close-btn\" ng-click=vm.closeUploadModal()><span class=icon-icons_close aria-hidden=true></span></button><div class=clearfix><div class=\"bulk-edit-photo-popup__upload-area pull-left\" ng-class=\"{\'bulk-edit-photo-popup__upload-area--full-width\': vm.uploadedFiles.data.length === 0}\"><div class=bulk-edit-photo-popup__upload-area__main-content><form ng-click=\"vm.isFullscreenDropzone.data = false\" super-dropzone=vm.isFullscreenDropzone.data ng-if=\"vm.uploadedFiles.data.length === 0\" pixerf-dropzone dropzone=vm.dropzoneConfig.instance dropzone-config=vm.dropzoneConfig.options event-handlers=vm.dropzoneConfig.eventHandlers class=\"dropzone dz-clickable bulk-edit-photo-popup__upload-area__dropzone\"><div class=bulk-edit-photo-popup__upload-area__dropzone__main-content><img class=bulk-edit-photo-popup__upload-area__dropzone__main-content__pixerf-logo src=assets/images/pixerf-logo-horizental.png><div class=bulk-edit-photo-popup__upload-area__dropzone__main-content__body><p class=\"bulk-edit-photo-popup__upload-area__dropzone__main-content__title text--color-black text--semibold\">{{\'start-adding-photos\' | translate}}</p><p class=bulk-edit-photo-popup__upload-area__dropzone__main-content__drag-and-drop-message><span>{{\'drag-and-drop-photos\' | translate}}</span> <span class=bulk-edit-photo-popup__upload-area__dropzone__main-content__message>{{ \', \' + \'or\' | translate}}</span></p><button class=\"bulk-edit-photo-popup__upload-area__dropzone__main-content__browse-btn btn btn-submit--no-background\">{{\'select-photos\' | translate}}</button></div><div class=bulk-edit-photo-popup__upload-area__dropzone__main-content__preview></div><p class=bulk-edit-photo-popup__upload-area__dropzone__main-content__notice-validate translate translate-values=\"{type: \'JPEGs\', min_required: 5 + \' \' + (\'megapixels\' | translate).toLowerCase(), max_required: \'40MB\'}\">{{\'accept-type-file-size\'}}</p><div class=bulk-edit-photo-popup__upload-area__dropzone__main-content__social><p>{{\'also-import-from\' | translate}}:</p><div class=bulk-edit-photo-popup__upload-area__dropzone__main-content__social__icons><div ng-click=\"vm.showFilePickerPopup(\'FACEBOOK\')\" class=\"ng-hide social-icon social-icon--small social-icon__facebook\"></div><div ng-click=\"vm.showFilePickerPopup(\'googledrive\')\" class=\"social-icon social-icon--small social-icon__google-drive\"></div><div ng-click=\"vm.showFilePickerPopup(\'INSTAGRAM\')\" class=\"social-icon ng-hide social-icon social-icon__instagram\"></div><div ng-click=\"vm.showFilePickerPopup(\'flickr\')\" class=\"social-icon social-icon--small social-icon__flickr\"></div><div ng-click=\"vm.showFilePickerPopup(\'dropbox\')\" class=\"social-icon social-icon--small social-icon__dropbox\"></div></div></div><div class=bulk-edit-photo-popup__contributor-agreement-text translate translate-compile>{{\'upload-contributor-agreement\'}}</div></div></form><form ng-show=\"vm.isFullscreenDropzone.data && vm.uploadedFiles.data.length === 0\" class=\"ng-hide dropzone dz-clickable bulk-edit-photo-popup__upload-area__dropzone dropzone--fake\"><div class=bulk-edit-photo-popup__upload-area__dropzone__main-content><img class=bulk-edit-photo-popup__upload-area__dropzone__main-content__pixerf-logo src=assets/images/pixerf-logo-horizental.png><div class=bulk-edit-photo-popup__upload-area__dropzone__main-content__body><p class=\"bulk-edit-photo-popup__upload-area__dropzone__main-content__title text--color-black\">{{\'i-want-to-upload-photo\' | translate}}</p><p class=bulk-edit-photo-popup__upload-area__dropzone__main-content__drag-and-drop-message><span>{{\'drag-and-drop-photos\' | translate}}</span> <span class=bulk-edit-photo-popup__upload-area__dropzone__main-content__message>{{ \', \' + \'or\' | translate}}</span></p><button class=\"bulk-edit-photo-popup__upload-area__dropzone__main-content__browse-btn btn btn-submit--no-background\">{{\'choose-files\' | translate}}</button></div><div class=bulk-edit-photo-popup__upload-area__dropzone__main-content__preview></div><div class=bulk-edit-photo-popup__upload-area__dropzone__main-content__social><p>{{\'also-import-from\' | translate}}:</p><div class=bulk-edit-photo-popup__upload-area__dropzone__main-content__social__icons><div ng-click=\"vm.showFilePickerPopup(\'FACEBOOK\')\" class=\"ng-hide social-icon social-icon--small social-icon__facebook\"></div><div ng-click=\"vm.showFilePickerPopup(\'googledrive\')\" class=\"social-icon social-icon--small social-icon__google-drive\"></div><div ng-click=\"vm.showFilePickerPopup(\'INSTAGRAM\')\" class=\"social-icon ng-hide social-icon--small social-icon__instagram\"></div><div ng-click=\"vm.showFilePickerPopup(\'flickr\')\" class=\"social-icon social-icon--small social-icon__flickr\"></div><div ng-click=\"vm.showFilePickerPopup(\'dropbox\')\" class=\"social-icon social-icon--small social-icon__dropbox\"></div></div></div><div class=bulk-edit-photo-popup__contributor-agreement-text translate translate-compile>{{\'upload-contributor-agreement\'}}</div></div></form><div class=bulk-edit-photo-popup__upload-area__preview-photos ng-if=\"vm.uploadedFiles.data.length > 0\"><bulk-edit-photo-preview no-nore-photos=vm.noMorePhotos></bulk-edit-photo-preview></div></div><!-- <div class=\"bulk-edit-photo-popup__upload-area__footer\" ng-if=\"!vm.isHideFooter\">\r\n                <span ng-if=\"!vm.mission\" class=\"bulk-edit-photo-popup__upload-area__footer__limit-upload-message\">\r\n                    <span\r\n                        ng-bind-html=\"\'you-have-limit-upload-this-time-element\'| translate:{number:vm.loginUser.stats.weekly_upload_balance}\">\r\n                    </span>\r\n                    <span ng-if=\"!vm.loginUser.isNoNeedSubscribe\" translate>{{\'become-a-subscriber\'}}</span>\r\n                </span>\r\n                <span ng-if=\"vm.mission\" ng-bind=\"vm.footerText\"></span>\r\n            </div> --></div><div class=\"bulk-edit-photo-popup__photo-detail pull-left\" ng-class=\"vm.uploadedFiles.data.length > 0 ? \'bulk-edit-photo-popup__photo-detail--show\': \'\'\"><bulk-edit-photo-detail is-form-dirty=vm.isFormDirty alert=vm.pixerfAlert form-error=vm.formError synchronizable=true master-tags=vm.masterTags files=vm.selectedFiles.data categories=vm.categories></bulk-edit-photo-detail><!-- <div class=\"bulk-edit-photo-popup__publish-btn-wrapper\">\r\n                <button ng-disabled=\"vm.publishing || vm.numProcessingFile > 0\"\r\n                    class=\"bulk-edit-photo-popup__publish-btn btn btn-submit\"\r\n                    ng-class=\"{\'disabled\': vm.selectedFiles.data.length === 0}\"\r\n                    ng-click=\"vm.onPublishBtnClicked(vm.uploadedFiles.data)\">{{vm.publishing ? (vm.mission ? \'Submitting\r\n                    Photo ...\' :\r\n                    \'Publishing Photo ...\') : (vm.mission ? (\'submit-photo\' | translate) : (\'publish-photo\' |\r\n                    translate))}}</button>\r\n            </div> --><div class=\"bulk-edit-photo-popup__photo-info--padding text-center bulk-edit-photo-popup__photo-info__btn-save-cancel-delete-wrapper\"><button class=\"bulk-edit-photo-popup__photo-info__btn-save container-full btn btn-submit btn-block\" ng-disabled=vm.isSaving ng-click=vm.onSaveChangesBtnClicked()>{{vm.isSaving ? \'Saving ...\' : (\'save-changes\' | translate)}}</button><div class=bulk-edit-photo-popup__photo-info__btn-cancel-delete-wrapper><a class=bulk-edit-photo-popup__photo-info__btn-cancel ng-click=vm.onCancelPhotoBtnClicked()>{{\'cancel\' | translate}}</a> <a class=bulk-edit-photo-popup__photo-info__btn-delete ng-click=vm.onDeletePhoto()>{{\'delete\' | translate}}</a></div></div></div></div></div>");
$templateCache.put("app/components/bulk-edit-photo-preview/bulk-edit-photo-preview.html","<div class=upload-photo-preview-area-wrapper><!-- <div class=\"text-left upload-photo-preview__main_content__header\">\r\n		<div ng-click=\"vm.selectAllFiles()\" class=\"upload-photo-preview__main_content__header__select-all-btn-wrapper\">\r\n			<span class=\"icon-icons-plus-box\"></span>\r\n			<a class=\"upload-photo-preview__main_content__header__select-all-btn-wrapper__title\">{{\'select-all\' | translate}}</a>\r\n		</div>\r\n		<div ng-click=\"vm.removeSelectedPhotos(vm.selectedFiles.data)\" ng-show=\"vm.selectedFiles.data.length > 0\"\r\n			class=\"ng-hide upload-photo-preview__main_content__header__remove-btn\">\r\n			<span class=\"icon-icons_minus\"></span>\r\n			<a class=\"upload-photo-preview__main_content__header__remove-btn__title\">{{vm.selectedFiles.data.length === vm.uploadedFiles.data.length ? (\'remove-all\' | translate) : (\'remove-selected-photos\' | translate)}}\r\n				({{vm.selectedFiles.data.length}})</a>\r\n		</div>\r\n	</div> --><div selection={} items=vm.uploadedFiles.data on-selected=\"vm.toggleFileSelection(file, file.isSelected)\" class=\"row upload-photo-preview__main_content__photos-wrapper clearfix\"><div class=upload-photo-preview ng-repeat=\"file in vm.uploadedFiles.data\" ng-class=\"{\'upload-photo-preview--highlighted\': file.isSelected, \'upload-photo-preview--error\':  file.pixerfError}\"><div upload-photo-preview-swap-dimension=file.rotate_by upload-photo-preview-scale data-selection-member ng-attr-id={{file.id}} class=upload-photo-preview-content-wrapper ng-click=\"vm.onFileClicked($event, file)\"><div class=upload-photo-preview__overlay><div class=upload-photo-preview__checkbox ng-if=!file.pixerfError ng-click=\"vm.toggleFileSelection(file); $event.stopPropagation()\" title=\"{{\'select-this-photo\' | translate}}\"><div class=\"pixerf-checkbox pixerf-checkbox--fake\" ng-class=\"{\'pixerf-checkbox--fake--checked\': file.isSelected}\"></div></div><!-- <div class=\"upload-photo-preview__remove-btn\" title=\"Remove this photo\">\r\n						<button type=\"button\" class=\"close\" ng-click=\"vm.removeUploadedFile($index)\"><span\r\n								class=\"icon-icons_close\"></span></button>\r\n					</div> --><!-- <div class=\"upload-photo-preview__rotate-btn\" title=\"Rotate this photo\" ng-if=\"!file.pixerfError\">\r\n						<span ng-click=\"vm.rotatePhoto(file)\" class=\"icon-icons-rotate\"></span>\r\n					</div> --><!-- <div class=\"pixerf-hover\"></div> --></div><div class=\"absolute absolute--full upload-photo-preview__upload-photo-process\" ng-show=\"file.upload.progress < 100 && !file.pixerfError\"><span class=\"absolute text--color-white upload-photo-preview__upload-photo-process__uploading-text absolute--bottom-half text--bold\">{{\'uploading\' | translate}}...{{file.upload.progress}}%</span> <span class=overlay></span></div><div class=\"absolute absolute--full upload-photo-preview__upload-photo-process\" ng-show=\"file.pixerfError && file.pixerfError != \'UPLOAD_PORTFOLIO_VALIDATION_INVALID_MAX_FILESIZE\' && file.pixerfError != \'UPLOAD_PORTFOLIO_VALIDATION_INVALID_MIN_RESOLUTION\'\" ng-class=upload-photo-preview__upload-photo-process><span class=\"absolute text--color-white upload-photo-preview__upload-photo-process__uploading-text upload-photo-preview__upload-photo-process__uploading-text--error absolute--bottom-half text--bold\">{{file.pixerfError === \'UPLOAD_VALIDATION_INVALID_MIN_RESOLUTION\' ? (\'upload-at-least-resolution\' | translate: {value: 5, unit: \'MP\'}) : (\'something-went-wrong\' | translate)}}</span> <span class=overlay></span></div><div class=\"absolute absolute--full upload-photo-preview__upload-photo-process\" ng-show=\"file.pixerfError && file.pixerfError === \'UPLOAD_PORTFOLIO_VALIDATION_INVALID_MAX_FILESIZE\'\" ng-class=upload-photo-preview__upload-photo-process><span class=\"absolute text--color-white upload-photo-preview__upload-photo-process__uploading-text upload-photo-preview__upload-photo-process__uploading-text--error absolute--bottom-half text--bold\" translate translate-values=\"{value: 2, unit: \'MB\'}\">{{\'upload-files-smaller-than\'}}</span> <span class=overlay></span></div><div class=\"absolute absolute--full upload-photo-preview__upload-photo-process\" ng-show=\"file.pixerfError && file.pixerfError === \'UPLOAD_PORTFOLIO_VALIDATION_INVALID_MIN_RESOLUTION\'\" ng-class=upload-photo-preview__upload-photo-process><span class=\"absolute text--color-white upload-photo-preview__upload-photo-process__uploading-text upload-photo-preview__upload-photo-process__uploading-text--error absolute--bottom-half text--bold\" translate translate-values=\"{value: 0.5, unit: (\'megapixels\' | translate)}\">{{\'upload-files-larger-than\'}}</span> <span class=overlay></span></div><img img-orientation-original-style=translateY(-50%) scale-image img-orientation=file.rotate_by ng-attr-src=\"{{file.thumbnail ? file.thumbnail : \'assets/images/icon-market.png\'}}\"></div><!-- <input required validation-no-file-extension data-ng-disabled=\"file.upload.progress < 100\"\r\n				ng-change=\"vm.updateMasterFile(file, \'title\')\" type=\"text\"\r\n				class=\"form-control upload-photo-preview__file-name text--color-black text-left text--truncate\"\r\n				validation-no-file-extension placeholder=\"Title\" ng-model=\"file.title\"></input> --></div></div></div>");
$templateCache.put("app/components/call-to-action-messages/call-to-action-messages.html","<div class=call-action-messages ng-show=\"messages.length > 0\"><div class=call-action-messages__title-wrapper><span class=\"label text--bold text--color-white\"><span class=icon-icons-info></span></span> <span class=\"text--color-pixerf-theme text--bold\">Action(s) required</span></div><div class=call-action-messages__messages-wrapper><div ng-repeat=\"mesage in messages\" class=call-action-messages__message><div compile=mesage></div></div></div></div>");
$templateCache.put("app/components/can-create-community-btn/can-create-community-btn.html","<div class=\"can-create-community-btn-wrapper text-center\"><button ng-mouseover=vm.onMouseOver() ng-mouseleave=vm.onMouseLeave() ng-disabled=vm.isWorking ng-class=\"{\'can-create-community-btn--flagged\': user.can_create_community, \'can-create-community-btn--unflag\': vm.isHovering}\" class=\"btn btn-pixerf-theme--blue btn-pixerf-theme--no-background text--bold can-create-community-btn\" authentication-click=vm.onSuggestClicked() authentication-click-action=SUGESST_PERSON><span class=\"icon- can-create-community-btn__icon\"></span><span class=can-create-community-btn__btn-label>{{vm.btnLabel}}</span></button></div>");
$templateCache.put("app/components/carousel-photo-popup/carousel-photo-popup.html","<div class=carousel-photo-popup__content><button type=button class=close ng-click=vm.close()><span class=icon-icons_close aria-hidden=true></span></button><div class=\"clearfix carousel-photo-popup__content__photo-content\"><div class=carousel-photo-popup__photo ng-style=\"{\'background-image\': \'url(\' + vm.photo.urlMobile + \')\'}\"></div><div class=carousel-photo-popup__info><div ng-if=vm.photo.name class=carousel-photo-popup__info__name>{{vm.photo.name}}</div><div ng-if=vm.photo.country class=carousel-photo-popup__info__country>{{vm.photo.country}}</div><div ng-if=vm.photo.desc class=carousel-photo-popup__info__desc>{{vm.photo.desc}}</div></div></div></div>");
$templateCache.put("app/components/cart/cart.html","<div class=cart><div class=cart__items-wrapper infinite-scroll-disabled=vm.isLastPage.data infinite-scroll=vm.fetchMoreitems() infinite-scroll-immediate-check=false infinite-scroll-container=\"\'.cart-wrapper\'\"><div ng-repeat=\"item in vm.cart.data.cart_items\" ng-click=\"vm.onCartItemClicked({cartItem: item, event: $event})\"><div class=\"cart-item clearfix\"><img class=cart-item__image ng-src=\"{{item.media.thumbnails[\'x100\']}}\" alt=\"\"><div class=\"cart-item__details clearfix\"><div class=cart-item__details__info><div class=\"cart-item__details__title text--bold text--truncate\">{{item.media.title}}</div><div class=\"cart-item__details__size text--truncate\"><span ng-repeat=\"license in item.media.extendedLicenses\" translate>{{license.title}}/</span></div><div ng-repeat=\"price in item.media.price.range\" ng-show=price.isSelected>{{price.description}}</div></div><div class=\"pull-right cart-item__details__right-wrapper\"><div class=\"cart-item__details__cost text--bold\">{{item.sub_total}} SGD</div><div class=\"cart-item__details__remove text--color-pixerf-theme clearfix pull-right\" ng-click=\"vm.onRemoveItemClicked($event, item)\"><div class=\"pull-left text--semibold\" translate>{{\'remove\'}}</div><div class=\"icon-icons_close pull-left\"></div></div></div></div></div><div class=divider ng-if=!$last></div></div></div></div>");
$templateCache.put("app/components/cart-item/cart-item.html","<div class=cart-item><div class=\"cart-item__content clearfix\"><div class=\"cart-item__col-left clearfix\"><a ui-sref=\"photo({id: item.media.id, photoTitle: (item.media.title + \' by \' + item.media.user.displayName | toSnakeCase)})\"><img ng-src=\"{{item.media.thumbnails[\'x500\']}}\" ng-attr-alt=\"{{(item.media.title + \' by \' + item.media.user.displayName) | toSnakeCase}}\"></a><div class=photo-by translate>{{\'photo-by\'}}</div><div class=text-center><a ui-sref=\"user-home-page.personal.home({id: item.media.user.id, userName: (item.media.user.displayName | toSnakeCase)})\" class=text--bold>{{item.media.user.displayName}}</a></div></div><div class=cart-item__col-right><div class=\"cart-item__header clearfix\"><div class=\"text--color-pixerf-theme clearfix cart-item__remove-btn pull-right\" role=button ng-click=\"onRemoveCartBtnClicked({evt: $event, item: item})\"><div class=\"text--semibold pull-left\">{{\'remove\' | translate}}</div><div class=\"icon-icons_close pull-left\"></div></div><div class=\"photo-title text--bold text--truncate\">{{item.media.title}}</div></div><div class=table-checkout><div class=\"table-checkout__row clearfix\"><div class=\"table-checkout__item-label text--bold\">{{\'photo-id\' | translate}}</div><div class=table-checkout__item-content>{{item.media.id}}</div></div><div class=\"table-checkout__row clearfix\"><div class=\"table-checkout__item-label text--bold\" translate>{{\'license-type\'}}</div><div class=table-checkout__item-content>{{vm.getLicenseType(item.media)}}</div></div><div class=\"table-checkout__row clearfix\"><div class=\"table-checkout__item-label text--bold\" translate>{{\'release-info\'}}</div><div class=table-checkout__item-content>{{vm.getReleaseInfo(item.media)}}</div></div></div><photo-price-size-selection is-disabled=isDisabled on-item-selected-changed=\"vm.onVariantSelected(evt, price);\" photo=item.media layout-horizontal=true></photo-price-size-selection><div class=extended-license><div class=\"text--bold extended-license__text\" translate>{{\'extended-license\'}}</div><photo-price-extended-license-selection is-disabled=isDisabled photo=item.media on-item-selected-changed=\"vm.onVariantSelected(evt, license);\"></photo-price-extended-license-selection></div><div ng-if=\"item.discounts && item.discounts.length\" class=cart-item__discount><div ng-repeat=\"discount in item.discounts\" class=cart-item__discount__value>{{discount.name}}</div></div></div></div><div class=\"cart-item__sub-total text--color-black\"><div class=cart-item__sub-total__price>SGD <span class=text--bold>{{item.sub_total}}</span></div><div class=\"cart-item__sub-total__text text--bold\">Subtotal</div></div></div>");
$templateCache.put("app/components/case-Studies-grid-carousel/case-Studies-grid-carousel.html","<div class=case-Studies-grid-carousel><slick data=vm.slideDatas arrows=false on-init=vm.slickSetting.onInit(slick) adaptive-height=true class=case-Studies-grid-carousel__slick><div ng-repeat=\"data in vm.slideDatas\"><ng-include ng-if=\"$index == 0\" src=\"\'app/components/case-Studies-grid-carousel/slide1-template.html\'\" class=\"case-Studies-grid-carousel__template-include slide-{{$index}}-style\"></ng-include><ng-include ng-if=\"$index == 1\" src=\"\'app/components/case-Studies-grid-carousel/slide2-template.html\'\" class=\"case-Studies-grid-carousel__template-include slide-{{$index}}-style\"></ng-include><ng-include ng-if=\"$index == 2\" src=\"\'app/components/case-Studies-grid-carousel/slide3-template.html\'\" class=\"case-Studies-grid-carousel__template-include slide-{{$index}}-style\"></ng-include><ng-include ng-if=\"$index == 3\" src=\"\'app/components/case-Studies-grid-carousel/slide4-template.html\'\" class=\"case-Studies-grid-carousel__template-include slide-{{$index}}-style\"></ng-include><ng-include ng-if=\"$index == 4\" src=\"\'app/components/case-Studies-grid-carousel/slide5-template.html\'\" class=\"case-Studies-grid-carousel__template-include slide-{{$index}}-style\"></ng-include></div></slick><div class=case-Studies-grid-carousel__slide-control><div class=case-Studies-grid-carousel__slide-control__indicator><div ng-repeat=\"item in vm.slideDatas\" ng-click=vm.onNavClicked($index) ng-class=\"{\'active\': vm.isActive($index)}\" class=case-Studies-grid-carousel__slide-control__indicator__item></div></div></div><div class=case-Studies-grid-carousel__navigate><div class=\"case-Studies-grid-carousel__navigate__left icon-slide-prev-icon\" ng-click=vm.onPreviousSlide()></div><div class=\"case-Studies-grid-carousel__navigate__right icon-slide-next-icon\" ng-click=vm.onNextSlide()></div></div></div>");
$templateCache.put("app/components/case-Studies-grid-carousel/slide1-template.html","<div class=\"case-Studies-grid-carousel__pc-section slide-0-style__center vertical\"><div class=\"slide-0-style__center size-auto\"><div class=\"photo-slide-item photo-0\" ng-style=\"{\'background-image\': \'url(\' + data.photos[0].url + \')\'}\"><!-- <div class=\"photo-slide__info {{data.photos[0].infoPosition}}\">\r\n\r\n                <div class=\"photo-slide__info__desc\">\r\n                    {{data.photos[0].desc}}\r\n                </div>\r\n                <div class=\"photo-slide__info__name\">\r\n                    {{data.photos[0].name}}\r\n                </div>\r\n                <div class=\"photo-slide__info__job-desc\">\r\n                    {{data.photos[0].jobDesc}}\r\n                </div>\r\n            </div> --></div><div class=\"photo-slide-item photo-1\" ng-style=\"{\'background-image\': \'url(\' + data.photos[1].url + \')\'}\"><div class=photo-slide-panel><div class=photo-slide-panel__logo><div class=photo-slide-panel__logo__photo ng-style=\"{\'background-image\': \'url(\' + data.slideInfo.logoUrl + \')\'}\"></div></div><div class=photo-slide-panel__content><div class=photo-slide-panel__content__cover><div class=photo-slide-panel__content__top><div class=photo-slide-panel__content__header>{{data.slideInfo.header}}</div><div class=photo-slide-panel__content__desc>{{data.slideInfo.desc}}</div><!-- <a class=\"photo-slide-panel__see-more-btn\">\r\n                                see more\r\n                            </a> --></div><div class=photo-slide-panel__content__list><div class=photo-slide-panel__count-down><div class=photo-slide-panel__count-down__item><div class=photo-slide-panel__count-down__header>{{data.slideInfo.days}}</div><div class=photo-slide-panel__count-down__desc>Days</div></div><div class=photo-slide-panel__count-down__item><div class=photo-slide-panel__count-down__header>{{data.slideInfo.PhotosLicensed}}</div><div class=photo-slide-panel__count-down__desc>Photos licensed</div></div></div></div></div></div></div></div></div><div class=\"slide-0-style__center height-55\"><div class=\"photo-slide-item photo-2\" ng-style=\"{\'background-image\': \'url(\' + data.photos[2].url + \')\'}\"></div><div class=\"photo-slide-item photo-3\" ng-style=\"{\'background-image\': \'url(\' + data.photos[3].url + \')\'}\"></div></div></div><div class=case-Studies-grid-carousel__mobile-section><div class=case-Studies-grid-carousel__mobile-section__grid-wrapper><div ng-repeat=\"item in data.photos\" ng-click=vm.showPhotoPopup(item) ng-if=\"$index < 4\" class=case-Studies-grid-carousel__mobile-section__item-wrapper><div class=case-Studies-grid-carousel__mobile-section__item><div class=\"case-Studies-grid-carousel__mobile-section__item__background zoom-hover\" ng-style=\"{\'background-image\': \'url(\\\'\' + item.urlMobile + \'\\\')\'}\"></div></div></div><div class=\"case-Studies-grid-carousel__mobile-section__item-wrapper background-desert-storm\"><div class=case-Studies-grid-carousel__mobile-section__item><div class=case-Studies-grid-carousel__mobile-section__item__logo ng-style=\"{\'background-image\': \'url(\' + data.slideInfo.logoUrl + \')\'}\"></div></div></div><div class=\"case-Studies-grid-carousel__mobile-section__item-wrapper background-desert-storm\"><div class=case-Studies-grid-carousel__mobile-section__item><div class=case-Studies-grid-carousel__mobile-section__item__count-down><div class=case-Studies-grid-carousel__mobile-section__item__count-down__item><div class=case-Studies-grid-carousel__mobile-section__item__count-down__header>{{data.slideInfo.days}}</div><div class=case-Studies-grid-carousel__mobile-section__item__count-down__desc>Days</div></div><div class=case-Studies-grid-carousel__mobile-section__item__count-down__item><div class=case-Studies-grid-carousel__mobile-section__item__count-down__header>{{data.slideInfo.PhotosLicensed}}</div><div class=case-Studies-grid-carousel__mobile-section__item__count-down__desc>Photos licensed</div></div></div></div></div></div><div class=\"case-Studies-grid-carousel__mobile-section__grid-wrapper plus-item\"><div class=\"case-Studies-grid-carousel__mobile-section__item-wrapper plus-item\"><div class=case-Studies-grid-carousel__mobile-section__item><div class=case-Studies-grid-carousel__mobile-section__item__info-wrapper><div class=case-Studies-grid-carousel__mobile-section__item__header>{{data.slideInfo.header}}</div><div class=case-Studies-grid-carousel__mobile-section__item__desc>{{data.slideInfo.desc}}</div></div></div></div></div></div>");
$templateCache.put("app/components/case-Studies-grid-carousel/slide2-template.html","<div class=\"case-Studies-grid-carousel__pc-section slide-1-style__center width-100\"><div class=\"slide-1-style__center width-32\"><div class=\"photo-slide-item photo-0\" ng-style=\"{\'background-image\': \'url(\' + data.photos[0].url + \')\'}\"></div></div><div class=\"slide-1-style__center size-auto vertical\"><div class=\"slide-1-style__center height-45 position-relative\"><div class=\"photo-slide-item photo-1\" ng-style=\"{\'background-image\': \'url(\' + data.photos[1].url + \')\'}\"></div><div class=\"photo-slide-item photo-2\" ng-style=\"{\'background-image\': \'url(\' + data.photos[2].url + \')\'}\"></div><div class=\"photo-slide-item photo-3\" ng-style=\"{\'background-image\': \'url(\' + data.photos[3].url + \')\'}\"></div><div class=photo-slide-panel><div class=photo-slide-panel__logo><div class=photo-slide-panel__logo__photo ng-style=\"{\'background-image\': \'url(\' + data.slideInfo.logoUrl + \')\'}\"></div></div><div class=photo-slide-panel__content><div class=photo-slide-panel__content__cover><div class=photo-slide-panel__content__top><div class=photo-slide-panel__content__header>{{data.slideInfo.header}}</div><div class=photo-slide-panel__content__desc>{{data.slideInfo.desc}}</div><!-- <a class=\"photo-slide-panel__see-more-btn\">\r\n                                see more\r\n                            </a> --></div><div class=photo-slide-panel__content__list><div class=photo-slide-panel__count-down><div class=photo-slide-panel__count-down__item><div class=photo-slide-panel__count-down__header>{{data.slideInfo.days}}</div><div class=photo-slide-panel__count-down__desc>Days</div></div><div class=photo-slide-panel__count-down__item><div class=photo-slide-panel__count-down__header>{{data.slideInfo.PhotosLicensed}}</div><div class=photo-slide-panel__count-down__desc>Photos licensed</div></div></div></div></div></div></div></div><div class=\"slide-1-style__center size-auto\"><div class=\"photo-slide-item photo-4\" ng-style=\"{\'background-image\': \'url(\' + data.photos[4].url + \')\'}\"></div></div></div></div><div class=case-Studies-grid-carousel__mobile-section><div class=case-Studies-grid-carousel__mobile-section__grid-wrapper><div ng-repeat=\"item in data.photos\" ng-click=vm.showPhotoPopup(item) ng-if=\"$index < 4\" class=case-Studies-grid-carousel__mobile-section__item-wrapper><div class=case-Studies-grid-carousel__mobile-section__item><div class=\"case-Studies-grid-carousel__mobile-section__item__background zoom-hover\" ng-style=\"{\'background-image\': \'url(\\\'\' + item.urlMobile + \'\\\')\'}\"></div></div></div><div class=\"case-Studies-grid-carousel__mobile-section__item-wrapper background-desert-storm\"><div class=case-Studies-grid-carousel__mobile-section__item><div class=case-Studies-grid-carousel__mobile-section__item__logo ng-style=\"{\'background-image\': \'url(\' + data.slideInfo.logoUrl + \')\'}\"></div></div></div><div class=\"case-Studies-grid-carousel__mobile-section__item-wrapper background-desert-storm\"><div class=case-Studies-grid-carousel__mobile-section__item><div class=case-Studies-grid-carousel__mobile-section__item__count-down><div class=case-Studies-grid-carousel__mobile-section__item__count-down__item><div class=case-Studies-grid-carousel__mobile-section__item__count-down__header>{{data.slideInfo.days}}</div><div class=case-Studies-grid-carousel__mobile-section__item__count-down__desc>Days</div></div><div class=case-Studies-grid-carousel__mobile-section__item__count-down__item><div class=case-Studies-grid-carousel__mobile-section__item__count-down__header>{{data.slideInfo.PhotosLicensed}}</div><div class=case-Studies-grid-carousel__mobile-section__item__count-down__desc>Photos licensed</div></div></div></div></div></div><div class=\"case-Studies-grid-carousel__mobile-section__grid-wrapper plus-item\"><div class=\"case-Studies-grid-carousel__mobile-section__item-wrapper plus-item\"><div class=case-Studies-grid-carousel__mobile-section__item><div class=case-Studies-grid-carousel__mobile-section__item__info-wrapper><div class=case-Studies-grid-carousel__mobile-section__item__header>{{data.slideInfo.header}}</div><div class=case-Studies-grid-carousel__mobile-section__item__desc>{{data.slideInfo.desc}}</div></div></div></div></div></div>");
$templateCache.put("app/components/case-Studies-grid-carousel/slide3-template.html","<div class=\"case-Studies-grid-carousel__pc-section slide-2-style__center width-100\"><div class=\"slide-2-style__center width-62 vertical\"><div class=\"slide-2-style__center width-100 height-56\"><div class=\"photo-slide-item photo-0\" ng-style=\"{\'background-image\': \'url(\' + data.photos[0].url + \')\'}\"></div><div class=\"photo-slide-item photo-1\" ng-style=\"{\'background-image\': \'url(\' + data.photos[1].url + \')\'}\"></div></div><div class=\"slide-2-style__center width-100 size-auto\"><div class=\"photo-slide-item photo-2\" ng-style=\"{\'background-image\': \'url(\' + data.photos[2].url + \')\'}\"></div><div class=\"photo-slide-item photo-3\" ng-style=\"{\'background-image\': \'url(\' + data.photos[3].url + \')\'}\"></div></div></div><div class=\"slide-2-style__center size-auto vertical\"><div class=\"photo-slide-item photo-4 position-relative size-auto\" ng-style=\"{\'background-image\': \'url(\' + data.photos[4].url + \')\'}\"><div class=photo-slide-panel><div class=photo-slide-panel__logo><div class=photo-slide-panel__logo__photo ng-style=\"{\'background-image\': \'url(\' + data.slideInfo.logoUrl + \')\'}\"></div></div><div class=photo-slide-panel__content><div class=photo-slide-panel__content__cover><div class=photo-slide-panel__content__top><div class=photo-slide-panel__content__header>{{data.slideInfo.header}}</div><div class=photo-slide-panel__content__desc>{{data.slideInfo.desc}}</div><!-- <a class=\"photo-slide-panel__see-more-btn\">\r\n                                see more\r\n                            </a> --></div><div class=photo-slide-panel__content__list><div class=photo-slide-panel__count-down><div class=photo-slide-panel__count-down__item><div class=photo-slide-panel__count-down__header>{{data.slideInfo.days}}</div><div class=photo-slide-panel__count-down__desc>Days</div></div><div class=photo-slide-panel__count-down__item><div class=photo-slide-panel__count-down__header>{{data.slideInfo.PhotosLicensed}}</div><div class=photo-slide-panel__count-down__desc>Photos licensed</div></div></div></div></div></div></div></div><div class=\"photo-slide-item photo-5 height-56\" ng-style=\"{\'background-image\': \'url(\' + data.photos[5].url + \')\'}\"></div></div></div><div class=case-Studies-grid-carousel__mobile-section><div class=case-Studies-grid-carousel__mobile-section__grid-wrapper><div ng-repeat=\"item in data.photos\" ng-click=vm.showPhotoPopup(item) ng-if=\"$index < 4\" class=case-Studies-grid-carousel__mobile-section__item-wrapper><div class=case-Studies-grid-carousel__mobile-section__item><div class=\"case-Studies-grid-carousel__mobile-section__item__background zoom-hover\" ng-style=\"{\'background-image\': \'url(\\\'\' + item.urlMobile + \'\\\')\'}\"></div></div></div><div class=\"case-Studies-grid-carousel__mobile-section__item-wrapper background-desert-storm\"><div class=case-Studies-grid-carousel__mobile-section__item><div class=case-Studies-grid-carousel__mobile-section__item__logo ng-style=\"{\'background-image\': \'url(\' + data.slideInfo.logoUrl + \')\'}\"></div></div></div><div class=\"case-Studies-grid-carousel__mobile-section__item-wrapper background-desert-storm\"><div class=case-Studies-grid-carousel__mobile-section__item><div class=case-Studies-grid-carousel__mobile-section__item__count-down><div class=case-Studies-grid-carousel__mobile-section__item__count-down__item><div class=case-Studies-grid-carousel__mobile-section__item__count-down__header>{{data.slideInfo.days}}</div><div class=case-Studies-grid-carousel__mobile-section__item__count-down__desc>Days</div></div><div class=case-Studies-grid-carousel__mobile-section__item__count-down__item><div class=case-Studies-grid-carousel__mobile-section__item__count-down__header>{{data.slideInfo.PhotosLicensed}}</div><div class=case-Studies-grid-carousel__mobile-section__item__count-down__desc>Photos licensed</div></div></div></div></div></div><div class=\"case-Studies-grid-carousel__mobile-section__grid-wrapper plus-item\"><div class=\"case-Studies-grid-carousel__mobile-section__item-wrapper plus-item\"><div class=case-Studies-grid-carousel__mobile-section__item><div class=case-Studies-grid-carousel__mobile-section__item__info-wrapper><div class=case-Studies-grid-carousel__mobile-section__item__header>{{data.slideInfo.header}}</div><div class=case-Studies-grid-carousel__mobile-section__item__desc>{{data.slideInfo.desc}}</div></div></div></div></div></div>");
$templateCache.put("app/components/case-Studies-grid-carousel/slide4-template.html","<div class=\"case-Studies-grid-carousel__pc-section slide-3-style__center vertical\"><div class=\"slide-3-style__center size-auto\"><div class=\"photo-slide-item photo-0\" ng-style=\"{\'background-image\': \'url(\' + data.photos[0].url + \')\'}\"></div><div class=\"photo-slide-item photo-1\" ng-style=\"{\'background-image\': \'url(\' + data.photos[1].url + \')\'}\"></div><div class=\"photo-slide-item photo-2\" ng-style=\"{\'background-image\': \'url(\' + data.photos[2].url + \')\'}\"><div class=photo-slide-panel><div class=photo-slide-panel__logo><div class=photo-slide-panel__logo__photo ng-style=\"{\'background-image\': \'url(\' + data.slideInfo.logoUrl + \')\'}\"></div></div><div class=photo-slide-panel__content><div class=photo-slide-panel__content__cover><div class=photo-slide-panel__content__top><div class=photo-slide-panel__content__header>{{data.slideInfo.header}}</div><div class=photo-slide-panel__content__desc>{{data.slideInfo.desc}}</div><!-- <a class=\"photo-slide-panel__see-more-btn\">\r\n                                see more\r\n                            </a> --></div><div class=photo-slide-panel__content__list><div class=photo-slide-panel__count-down><div class=photo-slide-panel__count-down__item><div class=photo-slide-panel__count-down__header>{{data.slideInfo.days}}</div><div class=photo-slide-panel__count-down__desc>Days</div></div><div class=photo-slide-panel__count-down__item><div class=photo-slide-panel__count-down__header>{{data.slideInfo.PhotosLicensed}}</div><div class=photo-slide-panel__count-down__desc>Photos licensed</div></div></div></div></div></div></div></div></div><div class=\"slide-3-style__center height-45\"><div class=\"photo-slide-item photo-3\" ng-style=\"{\'background-image\': \'url(\' + data.photos[3].url + \')\'}\"></div><div class=\"photo-slide-item photo-4\" ng-style=\"{\'background-image\': \'url(\' + data.photos[4].url + \')\'}\"></div><div class=\"photo-slide-item photo-5\" ng-style=\"{\'background-image\': \'url(\' + data.photos[5].url + \')\'}\"></div></div><div class=\"slide-3-style__center height-20\"><div class=\"photo-slide-item photo-6\" ng-style=\"{\'background-image\': \'url(\' + data.photos[6].url + \')\'}\"></div><div class=\"photo-slide-item photo-7\" ng-style=\"{\'background-image\': \'url(\' + data.photos[7].url + \')\'}\"></div><div class=\"photo-slide-item photo-8\" ng-style=\"{\'background-image\': \'url(\' + data.photos[8].url + \')\'}\"></div><div class=\"photo-slide-item photo-9\" ng-style=\"{\'background-image\': \'url(\' + data.photos[9].url + \')\'}\"></div></div></div><div class=case-Studies-grid-carousel__mobile-section><div class=case-Studies-grid-carousel__mobile-section__grid-wrapper><div ng-repeat=\"item in data.photos\" ng-click=vm.showPhotoPopup(item) ng-if=\"$index < 4\" class=case-Studies-grid-carousel__mobile-section__item-wrapper><div class=case-Studies-grid-carousel__mobile-section__item><div class=\"case-Studies-grid-carousel__mobile-section__item__background zoom-hover\" ng-style=\"{\'background-image\': \'url(\\\'\' + item.urlMobile + \'\\\')\'}\"></div></div></div><div class=\"case-Studies-grid-carousel__mobile-section__item-wrapper background-desert-storm\"><div class=case-Studies-grid-carousel__mobile-section__item><div class=case-Studies-grid-carousel__mobile-section__item__logo ng-style=\"{\'background-image\': \'url(\' + data.slideInfo.logoUrl + \')\'}\"></div></div></div><div class=\"case-Studies-grid-carousel__mobile-section__item-wrapper background-desert-storm\"><div class=case-Studies-grid-carousel__mobile-section__item><div class=case-Studies-grid-carousel__mobile-section__item__count-down><div class=case-Studies-grid-carousel__mobile-section__item__count-down__item><div class=case-Studies-grid-carousel__mobile-section__item__count-down__header>{{data.slideInfo.days}}</div><div class=case-Studies-grid-carousel__mobile-section__item__count-down__desc>Days</div></div><div class=case-Studies-grid-carousel__mobile-section__item__count-down__item><div class=case-Studies-grid-carousel__mobile-section__item__count-down__header>{{data.slideInfo.PhotosLicensed}}</div><div class=case-Studies-grid-carousel__mobile-section__item__count-down__desc>Photos licensed</div></div></div></div></div></div><div class=\"case-Studies-grid-carousel__mobile-section__grid-wrapper plus-item\"><div class=\"case-Studies-grid-carousel__mobile-section__item-wrapper plus-item\"><div class=case-Studies-grid-carousel__mobile-section__item><div class=case-Studies-grid-carousel__mobile-section__item__info-wrapper><div class=case-Studies-grid-carousel__mobile-section__item__header>{{data.slideInfo.header}}</div><div class=case-Studies-grid-carousel__mobile-section__item__desc>{{data.slideInfo.desc}}</div></div></div></div></div></div>");
$templateCache.put("app/components/case-Studies-grid-carousel/slide5-template.html","<div class=\"case-Studies-grid-carousel__pc-section slide-4-style__center vertical\"><div class=\"slide-4-style__center height-45\"><div class=\"photo-slide-item photo-0\" ng-style=\"{\'background-image\': \'url(\' + data.photos[0].url + \')\'}\"></div><div class=\"photo-slide-item photo-1\" ng-style=\"{\'background-image\': \'url(\' + data.photos[1].url + \')\'}\"></div><div class=\"photo-slide-item photo-2\" ng-style=\"{\'background-image\': \'url(\' + data.photos[2].url + \')\'}\"><div class=photo-slide-panel><div class=photo-slide-panel__logo><div class=photo-slide-panel__logo__photo ng-style=\"{\'background-image\': \'url(\' + data.slideInfo.logoUrl + \')\'}\"></div></div><div class=photo-slide-panel__content><div class=photo-slide-panel__content__cover><div class=photo-slide-panel__content__top><div class=photo-slide-panel__content__header>{{data.slideInfo.header}}</div><div class=photo-slide-panel__content__desc>{{data.slideInfo.desc}}</div><!-- <a class=\"photo-slide-panel__see-more-btn\">\r\n                                see more\r\n                            </a> --></div><div class=photo-slide-panel__content__list><div class=photo-slide-panel__count-down><div class=photo-slide-panel__count-down__item><div class=photo-slide-panel__count-down__header>{{data.slideInfo.days}}</div><div class=photo-slide-panel__count-down__desc>Days</div></div><div class=photo-slide-panel__count-down__item><div class=photo-slide-panel__count-down__header>{{data.slideInfo.PhotosLicensed}}</div><div class=photo-slide-panel__count-down__desc>Photos licensed</div></div></div></div></div></div></div></div></div><div class=\"slide-4-style__center size-auto\"><div class=\"photo-slide-item photo-3\" ng-style=\"{\'background-image\': \'url(\' + data.photos[3].url + \')\'}\"></div><div class=\"photo-slide-item photo-4\" ng-style=\"{\'background-image\': \'url(\' + data.photos[4].url + \')\'}\"></div><div class=\"photo-slide-item photo-5\" ng-style=\"{\'background-image\': \'url(\' + data.photos[5].url + \')\'}\"></div></div></div><div class=case-Studies-grid-carousel__mobile-section><div class=case-Studies-grid-carousel__mobile-section__grid-wrapper><div ng-repeat=\"item in data.photos\" ng-click=vm.showPhotoPopup(item) ng-if=\"$index < 4\" class=case-Studies-grid-carousel__mobile-section__item-wrapper><div class=case-Studies-grid-carousel__mobile-section__item><div class=\"case-Studies-grid-carousel__mobile-section__item__background zoom-hover\" ng-style=\"{\'background-image\': \'url(\\\'\' + item.urlMobile + \'\\\')\'}\"></div></div></div><div class=\"case-Studies-grid-carousel__mobile-section__item-wrapper background-desert-storm\"><div class=case-Studies-grid-carousel__mobile-section__item><div class=case-Studies-grid-carousel__mobile-section__item__logo ng-style=\"{\'background-image\': \'url(\' + data.slideInfo.logoUrl + \')\'}\"></div></div></div><div class=\"case-Studies-grid-carousel__mobile-section__item-wrapper background-desert-storm\"><div class=case-Studies-grid-carousel__mobile-section__item><div class=case-Studies-grid-carousel__mobile-section__item__count-down><div class=case-Studies-grid-carousel__mobile-section__item__count-down__item><div class=case-Studies-grid-carousel__mobile-section__item__count-down__header>{{data.slideInfo.days}}</div><div class=case-Studies-grid-carousel__mobile-section__item__count-down__desc>Days</div></div><div class=case-Studies-grid-carousel__mobile-section__item__count-down__item><div class=case-Studies-grid-carousel__mobile-section__item__count-down__header>{{data.slideInfo.PhotosLicensed}}</div><div class=case-Studies-grid-carousel__mobile-section__item__count-down__desc>Photos licensed</div></div></div></div></div></div><div class=\"case-Studies-grid-carousel__mobile-section__grid-wrapper plus-item\"><div class=\"case-Studies-grid-carousel__mobile-section__item-wrapper plus-item\"><div class=case-Studies-grid-carousel__mobile-section__item><div class=case-Studies-grid-carousel__mobile-section__item__info-wrapper><div class=case-Studies-grid-carousel__mobile-section__item__header>{{data.slideInfo.header}}</div><div class=case-Studies-grid-carousel__mobile-section__item__desc>{{data.slideInfo.desc}}</div></div></div></div></div></div>");
$templateCache.put("app/components/case-study-carousel/case-study-carousel.html","<div class=case-study-carousel><div class=\"pixerf-slick-nav prev-slide-nav clearfix\" ng-hide=\"!vm.caseStudies || !vm.caseStudies.length || vm.currentSlide == 1\" ng-hide=\"vm.caseStudies.length <= vm.slideToShow\"><div class=\"pixerf-slick-prev icon-icons_chevron-left past-mission-slick-prev\"></div></div><div class=\"pixerf-slick-nav next-slide-nav clearfix\" ng-hide=\"!vm.caseStudies || !vm.caseStudies.length || vm.currentSlide == vm.totalSlideShow\" ng-hide=\"vm.caseStudies.length <= vm.slideToShow\"><div class=\"pixerf-slick-next icon-icons_chevron-right past-mission-slick-next\"></div></div><slick class=case-study-carousel__slick infinite=false on-breakpoint=\"vm.slickConfig.event.breakpoint({event, slick, breakpoint})\" responsive=vm.slickConfig.responsive slides-to-show=4 slides-to-scroll=4 variable-width=true on-init=vm.slickConfig.event.init({slick}) on-before-change=\"vm.slickConfig.event.beforeChange({event, slick, currentSlide, nextSlide})\" on-after-change=\"vm.slickConfig.event.afterChange({event, slick, currentSlide, nextSlide})\" dots=!vm.hideDots prev-arrow=.past-mission-slick-prev next-arrow=.past-mission-slick-next init-onload=true data=vm.caseStudies ng-if=\"vm.caseStudies.length > 0\"><div ng-repeat=\"caseStudy in vm.caseStudies\"><case-study-tile data=caseStudy is-hover-style=true></case-study-tile></div></slick></div>");
$templateCache.put("app/components/case-study-intro/case-study-intro.html","<section class=case-study-intro><slick speed=1000 responsive=vm.responsive on-init=vm.slickSetting.onInit(slick) class=case-study-intro__banner infinite=false slides-to-scroll=1 slides-to-show=1 dots=false arrows=false on-after-change=\"vm.slickSetting.onAfterChange(event, slick, currentSlide, nextSlide)\"><div ng-repeat=\"caseStudy in vm.caseStudies\" class=case-study-intro__banner__slide><div class=case-study-intro__banner__slide__wrapper><div class=case-study-intro__banner__slide__col-left><img ng-src={{caseStudy.coverPhoto}} alt={{caseStudy.name}}></div><div class=case-study-intro__banner__slide__col-right><div class=case-study-intro__banner__slide__col-right__header><div class=case-study-intro__banner__slide__col-right__header__label--mobile>{{caseStudy.label}}</div><div class=case-study-intro__banner__slide__col-right__logo><img class=logo-{{$index}} ng-src={{caseStudy.logo}} alt={{caseStudy.name}}></div><div class=\"case-study-intro__banner__slide__col-right__header__wrapper logo-{{$index}}\"><div class=case-study-intro__banner__slide__col-right__header__label>{{caseStudy.label}}</div><div class=case-study-intro__banner__slide__col-right__header__name>{{caseStudy.name}}</div></div></div><div class=case-study-intro__banner__slide__col-right__body>{{caseStudy.intro}}</div><div class=case-study-intro__banner__slide__col-right__footer><div class=case-study-intro__banner__slide__col-right__author>{{caseStudy.author}}</div><div class=case-study-intro__banner__slide__col-right__role>{{caseStudy.role}}</div><div class=case-study-intro__banner__slide__col-right__company>{{caseStudy.companny}}</div></div></div></div></div></slick><div class=case-study-intro__slide-control><div class=\"case-study-intro__slide-control__left icon-slide-prev-icon\" ng-click=vm.onPreviousSlide()></div><div class=case-study-intro__slide-control__text>{{vm.slick.currentSlide + 1}} of {{vm.caseStudies.length}}</div><div class=\"case-study-intro__slide-control__right icon-slide-next-icon\" ng-click=vm.onNextSlide()></div></div></section>");
$templateCache.put("app/components/case-study-tile/case-study-tile.html","<div class=case-study-tile ng-class=\"{\'hover-style\': isHoverStyle}\"><a ui-sref={{data.link}}><div class=case-study-tile__photo ng-style=\"{\'background-image\': \'url(\' + data.coverImg + \')\'}\"></div><div class=case-study-tile__overlay></div><div class=case-study-tile__wrapper><div class=case-study-tile__description><div class=\"case-study-tile__category text--bold\" translate>{{data.category}}</div><div class=\"case-study-tile__title text--extrabold\" translate>{{data.name}}</div><div class=case-study-tile__content translate>{{data.content}}</div><div class=case-study-tile__details translate>{{data.details}}</div></div></div></a></div>");
$templateCache.put("app/components/category-selection-btn/category-selection-btn.html","<div class=category-selection-btn><div is-disabled=isDisabled class=multiple-dropdown-selection ng-dropdown-multiselect=\"\" events=\"{onItemSelect: vm.categoryDropdownSettings.events.onSelectionChanged, onItemDeselect: vm.categoryDropdownSettings.events.onSelectionChanged}\" translation-texts=\"{buttonDefaultText: \'browse-by-category\', dynamicButtonTextSuffix: \' Categories selected\'}\" options=vm.categories selected-model=selectedModel extra-settings=vm.categoryDropdownSettings is-category-selection=true></div></div>");
$templateCache.put("app/components/challenge-plan/challenge-plan.html","<div class=challenge-plan__wrapper><div ng-repeat=\"item in vm.plans\" class=challenge-plan__item ng-class=\"{\'plan--selected\': item.isSelected, \'custom-theme\': item.isCustom}\" ng-click=vm.onChallengePlanSelected(item)><div ng-if=item.isRecommended class=challenge-plan__recommended-label ng-click=vm.onOfferClicked()>OFFER</div><div class=\"challenge-plan__item__name challenge--{{item.id}}\">{{item.name}}</div><div ng-if=item.value class=challenge-plan__item__value>{{item.value}}</div><div ng-if=item.generalDescription class=challenge-plan__item__general-description>{{item.generalDescription}}</div><div class=challenge-plan__item__description><div ng-if=item.customDescription class=challenge-plan__item__description__custom>{{item.customDescription}}</div><div class=challenge-plan__item__description__header>What you get:</div><div class=challenge-plan__item__description__explain ng-if=item.isCustom><div class=challenge-plan__item__description__explain__text__only-text>Everything in <span class=challenge-plan__item__description__explain__text__supper-gold>Platinum Challenge</span>, plus -</div></div><div ng-repeat=\"content in item.description\" class=\"challenge-plan__item__description__explain {{content.className}}\"><div class=\"challenge-plan__item__description__explain__icon {{content.icon}}\"></div><div class=challenge-plan__item__description__explain__text>{{content.value}}</div></div></div><button ng-if=item.directly class=\"challenge-plan__item__btn btn\" ng-click=vm.onBookNow()>Buy Now</button> <button ng-if=!item.directly class=\"challenge-plan__item__btn btn\" ng-click=vm.onGetAQoute()>Request Quote</button></div></div>");
$templateCache.put("app/components/change-password/change-password.html","<div class=change-password><div class=change-password__header translate>{{\'change-password\'}}</div><div class=change-password__body><form name=passwordForm class=change-password__form><div class=change-password__row ng-class=\"{\'error-show\': vm.currentPasswordError != \'no\'}\"><label for=currentPassword>Current Password</label><div class=change-password__password__wrapper><input required name=currentPassword ng-attr-type=\"{{vm.isShowCurrentPassword.data ? \'text\' : \'password\'}}\" ng-model=vm.changePassword.currentPassword ng-change=vm.onInfoChange(passwordForm) class=\"change-password__password form-control\" ng-class=\"{\'ng-invalid\': vm.currentPasswordError != \'no\'}\"><div maxlength=255 title=\"{{\'hover-show-hide-password\' | translate}}\" class=change-password__row__toggle-show ng-click=\"vm.isShowCurrentPassword.data = !vm.isShowCurrentPassword.data\" translate>{{vm.isShowCurrentPassword.data ? \'hide\' : \'show\'}}</div></div><div class=change-password__error>{{vm.currentPasswordError}}</div></div><div class=change-password__row ng-class=\"{\'error-show\': vm.newPasswordError != \'no\'}\"><label for=password>New Password</label><div class=change-password__password__wrapper><input ng-pattern=\"/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{6,})/\" required name=newPassword ng-attr-type=\"{{vm.isShowNewPassword.data ? \'text\' : \'password\'}}\" ng-model=vm.changePassword.newPassword ng-change=vm.onInfoChange(passwordForm) class=\"change-password__password form-control\"><div maxlength=255 title=\"{{\'hover-show-hide-password\' | translate}}\" class=change-password__row__toggle-show ng-click=\"vm.isShowNewPassword.data = !vm.isShowNewPassword.data\" translate>{{vm.isShowNewPassword.data ? \'hide\' : \'show\'}}</div></div><div class=change-password__error>{{vm.newPasswordError}}</div></div><div class=change-password__row ng-class=\"{\'error-show\': vm.newPasswordAgainError != \'no\'}\"><label for=newPasswordAgain>Re-type New Password</label><div class=change-password__password__wrapper><input ng-pattern=\"/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{6,})/\" required name=newPasswordAgain ng-attr-type=\"{{vm.isShowAgainPassword.data ? \'text\' : \'password\'}}\" ng-model=vm.changePassword.newPasswordAgain ng-change=vm.onInfoChange(passwordForm) class=\"change-password__password form-control\"><div maxlength=255 title=\"{{\'hover-show-hide-password\' | translate}}\" class=change-password__row__toggle-show ng-click=\"vm.isShowAgainPassword.data = !vm.isShowAgainPassword.data\" translate>{{vm.isShowAgainPassword.data ? \'hide\' : \'show\'}}</div></div><div class=change-password__error>{{vm.newPasswordAgainError}}</div></div></form></div><div class=change-password__footer><button class=change-password__save-btn ng-click=vm.onSaveBtnClicked(passwordForm)>{{\'save\' | translate}}</button></div></div>");
$templateCache.put("app/components/cheque-checkout-btn/cheque-checkout-btn.html","<div class=\"cheque-checkout-btn relative\"><button ng-disabled=vm.isWorking class=\"btn btn-submit cheque-checkout-btn__button text--bold\" type=submit id=cheque-checkout-btn no-authentication-click=\"isGuestPayment && vm.onCheckoutBtnClicked()\" hide-error-message=isGuestPayment authentication-click=vm.onCheckoutBtnClicked()>{{vm.isWorking ? \'Processing...\' : \'Pay\' }}</button></div>");
$templateCache.put("app/components/circle-brand/circle-brand.html","<div class=circle-brand><div ng-if=!noHide class=circle-brand__wrapper scroll-to-hide scroll-spacing=200 animate-out={{vm.animationOut}} animate-in={{vm.animationIn}}><div class=circle-brand__text translate>{{data.text}}</div><div class=circle-brand__control-background><div class=circle-brand__control-btn ng-class=\"{\'icon-icons_close\': closeBtn, \'icon-icons_plus\': redirectToState}\" ng-click=vm.onBtnClicked()></div></div></div><div ng-if=noHide class=circle-brand__wrapper><div class=circle-brand__text ng-if=data.text translate>{{data.text}}</div><div class=circle-brand__control-background ng-if=redirectToState><div class=circle-brand__control-btn ng-class=\"{\'icon-icons_close\': closeBtn, \'icon-icons_plus\': redirectToState}\" ng-click=vm.onBtnClicked()></div></div><div class=circle-brand__control-background ng-if=ngHref><a ng-href={{ngHref}} target=_blank><div class=\"circle-brand__control-btn icon-icons_plus\"></div></a></div></div></div>");
$templateCache.put("app/components/client-carousel/client-carousel.html","<section class=client-carousel><slick speed=1000 responsive=vm.responsive class=client-carousel__banner infinite=false slides-to-scroll=1 slides-to-show=1 dots=false arrows=false><div ng-repeat=\"clientPack in vm.clientPacks\" class=client-carousel__banner__slide><img src=clientPack.photo></div></slick></section>");
$templateCache.put("app/components/col-box-icon-text/col-box-icon-text.html","<div class=\"col-box-icon-text {{vm.data.theme}}\"><div class=\"col-box-icon-text__icon {{vm.data.icon}}\"></div><div class=col-box-icon-text__text>{{vm.data.text}}</div></div>");
$templateCache.put("app/components/comment-list/comment-list.html","<div class=comment-list><comment-input ng-if=!noComment placeholder-text={{inputPlaceholderText}} mediaid=targetId comment=vm.newComment on-created-new=vm.onCommentCreated(comment) settings=vm.settings is-custom-commissions={{isCustomCommissions}} submission-id={{targetId}} shoot-id={{shootId}}></comment-input><div ng-if=\"vm.comments.length > 0\" class=comment-list-wrapper><div class=comment-list__list-label>{{listLabel}}</div><div ng-repeat=\"comment in vm.comments\"><comment mediaid=targetId on-deleted=vm.onCommentDeleted(comment) comment=comment context=context is-custom-commissions={{isCustomCommissions}} submission-id={{targetId}} shoot-id={{shootId}}></comment></div><div class=comment-list__load-more-link><a title=\"Click to view more comments\" href=\"\" ng-click=vm.getMoreComments() ng-if=!vm.isLastPage><i class=text--semibold>View more comments</i></a></div><scroll-paging spinner=vm.spinner show-message=false is-last-page=vm.isLastPage></scroll-paging></div><div ng-if=\"vm.comments.length === 0 && !hideEmptyState\" class=\"text-center comment-list__empty-message clearfix\"><h5 class=\"text--color-black text--bold\" translate>{{\'no-comments-yet\'}}</h5><p class=comment-list__empty-message__hint translate>{{\'strike-a-conversation\'}}</p></div></div>");
$templateCache.put("app/components/commision-not-available-popup/commision-not-available-popup.html","<div class=commision-not-available-popup><button type=button class=close ng-click=vm.close()><span class=icon-icons_close aria-hidden=true></span></button><div class=clearfix><div class=\"modal-body text--color-black-2\"><!-- <h1 class=\"commision-not-available-popup__header text--color-black\">{{vm.message.header}}</h1> --><div class=commision-not-available-popup__content ng-bind-html=vm.message.content></div></div><br><div class=modal-footer><button ng-click=vm.close() class=\"btn btn-submit pixerf-btn-sm\">OK</button></div></div></div>");
$templateCache.put("app/components/community-challenge-tile/community-challenge-tile.html","<div class=community-challenge-tile__item ng-click=vm.onChallengeClicked() ng-class=\"{\'empty-challenge\': !vm.mission}\"><div class=community-challenge-tile__header><div class=community-challenge-tile__header__thumbnail ng-style=\"{\'background-image\': \'url(\' + vm.coverPhoto + \')\'}\"></div></div><div ng-if=vm.mission class=community-challenge-tile__body><div class=community-challenge-tile__body__info><div class=community-challenge-tile__body__info__sponsor><span class=community-challenge-tile__body__info__sponsor__label>Mission by</span> <span class=community-challenge-tile__body__info__sponsor__owner>{{vm.mission.sponsor ? vm.mission.sponsor.name : vm.mission.organization.name}}</span></div><div class=community-challenge-tile__body__info__name>{{vm.mission.title}}</div></div><div class=community-challenge-tile__body__info__footer><div class=community-challenge-tile__body__info__footer__value><span>{{\'win-up-to\' | translate}} </span><span>{{vm.mission.total_rewards| currency: (vm.mission.currency ? (mission.currency + \' \') : \'SGD \'):0}}!</span></div><div ng-if=\"!mission.total_rewards && mission.inkind_reward\">{{mission.inkind_reward}}</div><div class=community-challenge-tile__body__info__footer__count-down><pixerf-count-down deadline=vm.mission.end_date></pixerf-count-down></div></div></div><div ng-if=!vm.mission class=community-challenge-tile__body><div class=community-challenge-tile__body__info__name>New challenges coming soon</div></div></div>");
$templateCache.put("app/components/community-challenges-carousel/community-challenges-carousel.html","<div class=community-challenges-carousel><slick speed=1000 responsive=vm.responsive class=community-challenges-carousel__carousel infinite=false slides-to-scroll=3 slides-to-show=3 dots=false arrows=false on-init=vm.slickSetting.onInit(slick) on-after-change=\"vm.slickSetting.onAfterChange(event, slick, currentSlide, nextSlide)\" on-breakpoint=\"vm.slickSetting.breakpoint({event, slick, breakpoint})\" ng-class=\"{\'no-carousel-binding\': vm.missions.length}\"><div ng-repeat=\"mission in vm.missions\" class=community-challenges-carousel__carousel__item><community-challenge-tile mission=mission></community-challenge-tile></div></slick><div ng-if=\"vm.totalSlide > 1\" class=community-challenges-carousel__slide-control><div class=\"community-challenges-carousel__slide-control__left icon-slide-prev-icon\" ng-click=vm.onPreviousSlide()></div><div class=community-challenges-carousel__slide-control__text>{{vm.currentSlide || 1}} of {{vm.totalSlide}}</div><div class=\"community-challenges-carousel__slide-control__right icon-slide-next-icon\" ng-click=vm.onNextSlide()></div></div></div>");
$templateCache.put("app/components/community-detail/community-detail.html","<section class=\"bg-white relative community-detail\"><div class=\"community-detail__header-wrapper clearfix\"><div class=\"clearfix community-detail__header-wrapper__filter-wrapper\" ng-if=!vm.options.hideTools><div class=community-detail__header-wrapper__text translate translate-values=\"{number: vm.community.member_count}\">{{vm.community.member_count == 1 ? \'you-have-member\' : \'you-have-members\'}}</div><div class=\"community-detail__header-wrapper__control-wrapper clearfix\" ng-if=\"vm.community.member_count > 0\"><div class=community-detail__sort-wrapper><span class=\"community-detail__sort-wrapper__filter-label text--color-black text--bold\">Filter by</span><div class=community-detail__sort-wrapper__dropdown ng-class=\"{\'community-detail__sort--active\': !vm.selectedFilter.isDefault}\"><popover-selection-btn close-on-click=true on-selection-changed=vm.onFilteredClicked(item) selected-model=vm.selectedFilter settings=vm.filterSetting></popover-selection-btn></div></div><div class=\"community-detail__search-member-wrapper relative\"><input ng-model=vm.searchString ng-change=vm.onSearchStringChanged() class=\"form-control search-input\" type=text placeholder=\"Find a member...\"> <span class=\"community-detail__search-member-wrapper__search-icon glyphicon glyphicon-search vertical-align-middle--transform\"></span></div></div></div></div><profiles-grid options=vm.profileGridOptions context-view=vm.isManager community=vm.community><div class=community-detail__empty-state><h2>There are no members in this community!</h2></div></profiles-grid></section>");
$templateCache.put("app/components/community-detail-compile-template/community-detail-compile-template.html","<div class=community-detail-compile-template ng-class=\"{\'append-to-body\': appendToBody}\"><div class=community-detail-compile-template__header><img ng-src={{vm.community.cover.thumbnail}} class=community-detail-compile-template__header__cover><div class=community-detail-compile-template__header__info><div class=community-detail-compile-template__header__info__name>{{vm.community.name}}</div><div class=community-detail-compile-template__header__info__created-at>Created on <span>{{vm.fomatedDate}}</span></div></div><div class=community-detail-compile-template__header__controls><div ng-if=vm.isShowActionRequiredButton class=\"community-detail-compile-template__header__controls__button community-detail-compile-template__header__controls__button__reject icon-icons_close\" ng-click=vm.onActionRequiredCommunity()></div><div ng-if=vm.isShowAprroveButton class=\"community-detail-compile-template__header__controls__button community-detail-compile-template__header__controls__button__approve icon-icons_check\" ng-click=vm.onApproveCommunity()></div><div ng-if=vm.isShowMoreButton class=\"community-detail-compile-template__header__controls__button community-detail-compile-template__header__controls__button__more\"><div uib-dropdown class=community-detail-compile-template__header__controls__button__more__btn-wrapper><span uib-dropdown-toggle class=\"community-detail-compile-template__header__controls__button__more__icon icon-icons_more\"></span><ul class=community-detail-compile-template__header__controls__button__more__list uib-dropdown-menu role=menu><li role=menuitem class=community-detail-compile-template__header__controls__button__more__item ng-repeat=\"item in vm.moreList\" ng-click=item.cta(vm.comment)>{{item.label}}</li></ul></div></div><div class=\"community-detail-compile-template__header__controls__button community-detail-compile-template__header__controls__button__close icon-icons_close\" ng-click=vm.onClosed()></div></div></div><div class=community-detail-compile-template__content><img ng-src={{vm.community.cover.medium}} class=community-detail-compile-template__content__cover><div class=community-detail-compile-template__content__general-info><div class=community-detail-compile-template__content__name><div class=community-detail-compile-template__content__name__label>Community Name</div><div class=community-detail-compile-template__content__name__value>{{vm.community.name}}</div></div><div class=community-detail-compile-template__content__privacy ng-class=\"{\'text--color-pixerf-theme\': !community.is_private}\"><span class=community-detail-compile-template__content__privacy__icon ng-class=\"vm.community.is_private ? \'icon-lock\' : \'icon-public-community\'\"></span> <span translate>{{vm.community.is_private ? \'private\' : \'public\'}}</span></div></div><div ng-if=vm.community.description class=community-detail-compile-template__content__about><div class=community-detail-compile-template__content__about__label>About this Community</div><div class=community-detail-compile-template__content__about__value>{{vm.community.description}}</div></div><div ng-if=vm.community.rules class=community-detail-compile-template__content__rule><div class=community-detail-compile-template__content__rule__label>Community Rules</div><div class=community-detail-compile-template__content__rule__value ng-bind-html=vm.community.rules></div></div><div class=community-detail-compile-template__content__country><div class=community-detail-compile-template__content__country__label>Countries</div><div class=community-detail-compile-template__content__country__value ng-bind-html=vm.communityCountries></div></div><div class=community-detail-compile-template__content__required><div class=community-detail-compile-template__content__required__permissions><div class=community-detail-compile-template__content__required__label>Discussion Permissions</div><div class=community-detail-compile-template__content__required__value>{{vm.community.start_discussion_permission === \'anyone\' ? \'Anyone in community\' : \'Admin only\'}}</div></div><div class=community-detail-compile-template__content__required__approval><div class=community-detail-compile-template__content__required__label>Discussion Approval</div><div class=community-detail-compile-template__content__required__value>{{vm.community.moderate_discussions ? \'Approval required\' : \'No Approval required\'}}</div></div></div><div class=community-detail-compile-template__content__member><div class=community-detail-compile-template__content__member__admin><div class=community-detail-compile-template__content__member__label>Admin</div><div class=community-detail-compile-template__content__member__avatar><img ng-class=\"{\'circle\': vm.community.owner.account_type === \'personal\'}\" ng-src=\"{{vm.community.owner.profile_image_media[\'100x\']}}\"></div></div><div ng-if=\"vm.community.moderators && vm.community.moderators.length\" class=community-detail-compile-template__content__member__moderators><div class=community-detail-compile-template__content__member__label>{{vm.community.moderators.length === 1 ? \'Moderator\' : \'Moderators\'}}</div><div class=community-detail-compile-template__content__member__avatar ng-class=\"{\'multi-mods\': vm.community.moderators.length > 1}\"><img ng-repeat=\"mod in vm.community.moderators\" ng-src=\"{{mod.profile_image_media[\'100x\']}}\"></div></div></div></div></div>");
$templateCache.put("app/components/community-detail-edit-compile-template/community-detail-edit-compile-template.html","<div class=community-detail-edit-compile-template ng-class=\"{\'append-to-body\': appendToBody}\"><div class=community-detail-edit-compile-template__header-wrapper><div class=community-detail-edit-compile-template__header><img ng-src={{vm.community.cover.thumbnail}} class=community-detail-edit-compile-template__header__cover><div class=community-detail-edit-compile-template__header__info><div class=community-detail-edit-compile-template__header__info__name>{{vm.community.name}}</div><div class=community-detail-edit-compile-template__header__info__created-at>Created on <span>{{vm.fomatedDate}}</span></div></div><div class=community-detail-edit-compile-template__header__controls><div ng-if=vm.isShowMoreButton class=\"community-detail-edit-compile-template__header__controls__button community-detail-edit-compile-template__header__controls__button__more\"><div uib-dropdown class=community-detail-edit-compile-template__header__controls__button__more__btn-wrapper><span uib-dropdown-toggle class=\"community-detail-edit-compile-template__header__controls__button__more__icon icon-icons_more\"></span><ul class=community-detail-edit-compile-template__header__controls__button__more__list uib-dropdown-menu role=menu><li role=menuitem class=community-detail-edit-compile-template__header__controls__button__more__item ng-repeat=\"item in vm.moreList\" ng-click=item.cta(vm.comment)>{{item.label}}</li></ul></div></div><div class=\"community-detail-edit-compile-template__header__controls__button community-detail-edit-compile-template__header__controls__button__close icon-icons_close\" ng-click=vm.onClosed()></div></div></div><div class=community-detail-edit-compile-template__sub-header><button ng-if=vm.isShowCancelButton class=\"community-detail-edit-compile-template__sub-header__button btn btn-cancel--no-background\" ng-click=vm.onCancel() ng-disabled=\"!vm.canEditCommunity || vm.working\">Cancel</button> <button ng-if=vm.isShowSubmitButton class=\"community-detail-edit-compile-template__sub-header__button btn btn-submit\" ng-click=vm.onSubmitCommunity() ng-disabled=\"!vm.canEditCommunity || vm.working\"><span ng-if=!vm.canEditCommunity class=\"community-detail-edit-compile-template__sub-header__icon icon-icons_check\"></span><div class=community-detail-edit-compile-template__sub-header__button__text ng-class=\"{\'working\': vm.working}\"><i class=\"fa fa-x fa-spin fa-spinner\"></i> <span>{{vm.canEditCommunity ? \'Submit for Approval\' : \'Pending Approval\'}}</span></div></button></div></div><div ng-if=vm.showActionRequiredMessage class=community-detail-edit-compile-template__content__required-action ng-click=vm.onToggleActionRequired(vm.isOpenActionRequired)><div class=community-detail-edit-compile-template__content__required-action__control-toggle><div class=\"community-detail-edit-compile-template__content__required-action__control-toggle__icon icon-circle-warning\"></div><div class=community-detail-edit-compile-template__content__required-action__control-toggle__title>Action required</div><div class=community-detail-edit-compile-template__content__required-action__control-toggle__arrow ng-class=\"vm.isOpenActionRequired ? \'icon-icons_chevron-up\' : \'icon-icons_chevron-down\'\"></div></div><div uib-collapse=!vm.isOpenActionRequired class=\"community-detail-edit-compile-template__content__required-action__content-toggle collapse\"><div class=community-detail-edit-compile-template__content__required-action__content-toggle__title>{{vm.community.community_reject_comments[0].reason}}</div><div class=community-detail-edit-compile-template__content__required-action__content-toggle__description>{{vm.community.community_reject_comments[0].comment}}</div></div></div><div class=community-detail-edit-compile-template__content><div class=community-detail-edit-compile-template__upload-header><div ng-if=\"vm.communityCover && vm.communityCover.url\" class=overlay-reselect ng-click=vm.showUploadCoverPopup()><div class=community-detail-edit-compile-template__upload-header__edit>Change cover</div></div><div ng-if=\"vm.communityCover && vm.communityCover.url\" class=community-detail-edit-compile-template__upload-header__thumbnail-section><img class=community-detail-edit-compile-template__upload-header__thumbnail-section__image ng-src={{vm.communityCover.url}}></div><div ng-if=\"!vm.communityCover || !vm.communityCover.url\" class=community-detail-edit-compile-template__upload-header__submit-btn ng-click=vm.showUploadCoverPopup()><div class=\"btn btn-submit\">{{\'add-cover-photo\' | translate}}</div></div></div><div class=community-detail-edit-compile-template__content__name ng-class=\"{\'error\': vm.actionRequiredFields.includes(\'Community name\')}\"><div class=community-detail-edit-compile-template__content__name__label>Community Name</div><input type=text class=community-detail-edit-compile-template__content__name__value ng-model=vm.newCommunity.name></div><div class=community-detail-edit-compile-template__content__about ng-class=\"{\'error\': vm.actionRequiredFields.includes(\'Description\')}\"><div class=community-detail-edit-compile-template__content__about__label>About this Community</div><div contenteditable=true class=community-detail-edit-compile-template__content__about__value ng-model=vm.newCommunity.description enter=vm.onDescriptionChanged()></div></div><div class=community-detail-edit-compile-template__content__rule ng-class=\"{\'error\': vm.actionRequiredFields.includes(\'Community rules\')}\"><div class=community-detail-edit-compile-template__content__rule__label>Community Rules</div><div contenteditable=true class=community-detail-edit-compile-template__content__rule__value ng-model=vm.newCommunity.rules></div></div><div class=community-detail-edit-compile-template__content__country><label class=community-detail-edit-compile-template__content__country__label translate>{{\'countries\'}}</label><pixerf-input-auto-complete dropdown-class=community-detail-edit-compile-template__content__country__dropdown options=vm.countriesOpts name=countries data=vm.countries model=vm.selectedCountries on-changed=vm.onCountriesSelected()></pixerf-input-auto-complete></div><div class=community-detail-edit-compile-template__content__selection><label class=create-community-form__label translate>{{\'set-your-group-privacy-settings\'}}</label><mutiline-dropdown items=vm.privacyTypes selected=vm.defaultPrivacyType on-changed=vm.onPrivacyTypeChanged(data)></mutiline-dropdown></div><div class=community-detail-edit-compile-template__content__selection><label class=create-community-form__label translate>{{\'permissions-to-create-post\'}}</label><mutiline-dropdown items=vm.postingTypes selected=vm.defaultPostingType on-changed=vm.onPostingTypeChanged(data)></mutiline-dropdown></div><div ng-if=vm.canConfigmoderation class=community-detail-edit-compile-template__content__selection><label class=create-community-form__label translate>{{\'post-approval\'}}</label><mutiline-dropdown items=vm.moderationType selected=vm.defaultModerationType on-changed=vm.onModerationTypeChanged(data)></mutiline-dropdown></div></div></div>");
$templateCache.put("app/components/community-explore-tile/community-explore-tile.html","<div class=community-explore-tile ng-click=vm.onGoCommunityDetails(vm.community)><div class=community-explore-tile__content><div class=community-explore-tile__content__cover><img class=community-explore-tile__content__cover__avatar ng-src={{vm.community.cover.large}}></div><div class=community-explore-tile__content__info><div class=community-explore-tile__content__info__general-wrapper><div class=\"community-explore-tile__content__info__title {{vm.community.id}}\">{{vm.community.name}}</div><div class=community-explore-tile__content__info__general-info><div class=community-explore-tile__content__info__members-count>{{vm.community.member_count === 1 ? (vm.community.member_count + \' member\') : (vm.community.member_count + \' members\')}}</div><span ng-if=vm.countryList.countryListName class=community-explore-tile__content__info__dot></span> <span rel={{vm.tooltipId}} class=community-explore-tile__content__info__coutry-list ng-click=$event.stopPropagation() data-toggle=tooltip data-trigger=hover data-placement=bottom data-html=true data-title={{vm.countryList.countryListTooltipContentHtml}}>{{vm.countryList.countryNamebrief}}</span></div><div class=community-explore-tile__content__info__author><div class=community-explore-tile__content__info__author__avatar><pixerf-user-avatar class=pull-left user-data=vm.community.owner lazy=true></pixerf-user-avatar></div><div class=community-explore-tile__content__info__author__info><div class=community-explore-tile__content__info__author__info__label>Community by</div><div class=community-explore-tile__content__info__author__info__name>{{vm.community.owner.displayName}}</div></div><div class=community-explore-tile__content__info__author__public ng-class=\"{\'private-community\': vm.community.is_private}\"><span class=community-explore-tile__content__info__author__public__private-icon ng-class=\"vm.community.is_private ? \'icon-lock\' : \'icon-public-community\'\"></span> <span class=community-explore-tile__content__info__author__public__label translate>{{(vm.community.is_unlisted == true) ? \'unlisted\' : (vm.community.is_private ? \'private\' : \'public\')}}</span></div></div></div><div ng-if=vm.membershipStatus class=community-explore-tile__content__info__membership ng-class=\"{\'not-join\': vm.community.membership_status != \'accepted\' && vm.community.membership_status != \'requested\' && vm.community.membership_status != \'owner\' && vm.community.membership_status != \'manager\'}\"><div class=community-explore-tile__content__info__membership__button ng-if=\"!vm.community.membership_status || vm.community.membership_status === \'invited\' || vm.community.membership_status === \'rejected\'\" check-verified-email=true authentication-click=vm.requestJoinCommunity(vm.community)>{{vm.membershipStatus | translate}}</div><div class=community-explore-tile__content__info__membership__button ng-if=\"vm.community.membership_status === \'requested\'\" ng-click=vm.onWithdrawRequest(vm.community) ng-mouseover=vm.onManageBtnHovered() ng-mouseleave=vm.onManageBtnLeft()>{{vm.isHovering ? (\'withdraw-request\' | translate) : (\'requested\' | translate)}}</div><div class=community-explore-tile__content__info__membership__button ng-if=\"vm.community.membership_status === \'accepted\'\">{{vm.membershipStatus | translate}}!</div><div class=community-explore-tile__content__info__membership__button ng-if=\"vm.community.membership_status === \'manager\'\">{{vm.membershipStatus | translate}}</div><div class=community-explore-tile__content__info__membership__button ng-if=\"vm.community.membership_status === \'owner\'\" check-verified-email=true authentication-click=vm.onManageCommunity(vm.community)>{{vm.membershipStatus | translate}}</div></div></div></div></div>");
$templateCache.put("app/components/community-grid/community-grid.html","<div class=community-grid ng-class=\"{\'list-details-view\': layout === vm.communityConst.LAYOUT.LIST_VIEW}\"><div class=\"community-grid__communities-list-wrapper clearfix\" infinite-scroll-disabled=vm.isLastPage infinite-scroll=vm.fetchMoreCommunities() infinite-scroll-immediate-check=false><div class=community-grid__communities-list-inner ng-if=\"vm.communities.length > 0\"><div ng-if=\"layout === vm.communityConst.LAYOUT.LIST_VIEW\" ng-repeat=\"community in vm.communities\" class=\"community-grid__community-wrapper text-center\"><community-tile-list-details community=community on-community-membership-changed=vm.onCommunityMembershipChanged(communityId) context={{context}}></community-tile-list-details></div><div ng-if=\"layout != vm.communityConst.LAYOUT.LIST_VIEW\" ng-repeat=\"community in vm.communities\" class=community-grid__community-wrapper><community-explore-tile community=community on-community-membership-changed=vm.onCommunityMembershipChanged(communityId)></community-explore-tile></div><div ng-if=\"layout != vm.communityConst.LAYOUT.LIST_VIEW\" class=\"community-grid__community-wrapper virtual-tile\"><div class=community-grid__virtual-tile></div></div><div ng-if=\"layout != vm.communityConst.LAYOUT.LIST_VIEW\" class=\"community-grid__community-wrapper virtual-tile\"><div class=community-grid__virtual-tile></div></div><div ng-if=\"layout != vm.communityConst.LAYOUT.LIST_VIEW\" class=\"community-grid__community-wrapper virtual-tile\"><div class=community-grid__virtual-tile></div></div></div><ng-transclude ng-if=\"vm.communities.length === 0 && options.customEmptyState\" class=community-grid__no-community></ng-transclude><div ng-if=\"vm.communities.length === 0 && !options.customEmptyState\"><div class=community-grid__content-wrapper><div class=community-grid__title ng-if=vm.isMine>{{\'it-looks-like-you-havent-joined-any-community-yet\' | translate}}</div><div class=community-grid__title ng-if=!vm.isMine>{{\'other-communities-not-managing\' | translate: {name: options.user.displayName}}}</div><div class=community-grid__description translate>{{\'start-connecting-with-other-creators\'}}</div><button ng-if=vm.isMine class=\"btn btn-submit community-grid__action-btn\" ng-click=vm.onEmptyStateBtnClicked() translate>{{\'explore-communities\'}}</button></div></div><scroll-paging spinner=vm.spinner show-message=\"vm.communities.length > 0 && vm.searchParams.page > 1\" is-last-page=vm.isLastPage message=\"No more communities.\"></scroll-paging></div><div class=\"text-center community-grid__btn-wrapper\" ng-if=\"!options.autoLoadWhenScroll && !vm.isLastPage && vm.communities.length > 0\"><button ng-click=vm.onSeeMoreBtnClicked() class=\"btn btn-submit text--bold community-grid__btn-load-more\">See more</button></div></div>");
$templateCache.put("app/components/community-invite-email-popup/community-invite-email-popup.html","<div class=community-invite-email-popup><div class=clearfix><button type=button class=close ng-click=vm.onCloseBtnClicked()><span class=icon-icons_close aria-hidden=true></span></button><div class=\"modal-header text-left\"><h1 class=\"modal--title text--bold text--color-black text-left\">Invite friends to join PIXERF</h1></div><div class=\"modal-body text-center\"><div class=\"relative community-invite-email-popup__search-wrapper\"><span class=\"community-invite-email-popup__search-wrapper__search-icon glyphicon glyphicon-search vertical-align-middle--transform\"></span> <input ng-model=vm.searchString ng-change=vm.onSearchStringChanged() class=\"form-control search-input\" type=text placeholder=\"Search contacts\"></div><div class=community-invite-email-popup__contacts-list-wrapper infinite-scroll-disabled=vm.isLastPage infinite-scroll=vm.fetchMore() infinite-scroll-immediate-check=false infinite-scroll-container=\"\'.community-invite-email-popup__contacts-list-wrapper\'\"><div class=community-invite-email-popup__contact ng-repeat=\"contact in (vm.filteredArray =  (vm.contacts | filter: vm.searchString))\"><email-contact-person contact=contact on-selected=vm.onContactSelected()></email-contact-person></div><scroll-paging spinner=vm.spinner show-message=false is-last-page=vm.isLastPage></scroll-paging></div></div><div class=devider></div><div class=modal-footer><div class=\"relative community-invite-email-popup__checkbox-wrapper\"><pixerf-checkbox model=vm model-property=isSelectAll on-changed=vm.onSelectAllToogle()></pixerf-checkbox><span class=\"text--color-black text--bold\">Select All</span></div><div class=community-invite-email-popup__btn-group><button ng-if=!vm.dontSendInvite ng-disabled=\"vm.isWorking || vm.selectedEmails.length === 0\" ng-click=vm.onSendInvitationBtnClicked() type=button class=\"btn btn-submit text--bold\">{{vm.btnSendInvitationLabel}}</button> <button ng-if=vm.dontSendInvite ng-disabled=\"vm.isWorking || vm.selectedEmails.length === 0\" ng-click=vm.onAddToList() type=button class=\"btn btn-submit\">Add</button></div></div></div></div>");
$templateCache.put("app/components/community-leaving-feedback-popup/community-leaving-feedback-popup.html","<div class=community-leaving-feedback-popup><div class=clearfix><button type=button class=close ng-click=vm.onCancelBtnClicked()><span class=icon-icons_close aria-hidden=true></span></button><div class=\"modal-header text-left\"><h3 class=\"modal--title text--bold text--color-black text-left\">Leaving feedback</h3><p>Please share the reason!</p></div><div class=\"modal-body text-center\"><form name=leavingFeedbackForm class=text-left><div class=\"form-group community-leaving-feedback-popup__content\"><label class=text--bold>Reason</label><textarea required maxlength=255 rows=3 name=content type=text ng-model=vm.content placeholder=\"{{\'tell-us-more\' | translate}}\" class=form-control></textarea><div class=text-right><span class=textarea__length_descriptioon>{{vm.content ? vm.content.length: 0}}/255</span></div></div></form></div><div class=modal-footer><button ng-click=vm.onCancelBtnClicked() type=button class=\"btn btn-cancel\">Cancel</button> <button ng-disabled=\"vm.isWorking || leavingFeedbackForm.content.$error.required\" ng-click=vm.onSaveBtnClicked(vm.content,leavingFeedbackForm) type=button class=\"btn btn-submit\">Save</button></div></div></div>");
$templateCache.put("app/components/community-list-view/community-list-view.html","<div class=community-list-view ng-click=vm.onCommunityClicked(vm.community)><div ng-if=vm.showCheckbox class=\"community-list-view__item community-list-view__select\"><stick-checkbox on-changed=vm.onToggleSelected(vm.community) model=community model-property=isSelected layout-style=regular-square></stick-checkbox></div><div class=community-list-view__community><div class=community-list-view__community__name__wrapper><img ng-src={{community.cover.thumbnail}} class=community-list-view__community__cover> <a class=community-list-view__community__name ng-click=vm.prevenPubbleClick() ui-sref=\"community-detail-page.community-detail-discussions({id: community.id,name: community.name})\" target=_blank>{{community.name}}</a><div ng-if=\"vm.showLabel && vm.isMine\" class=\"community-list-view__item community-list-view__label-owner\"><span class=\"community-list-view__item community-list-view__label-owner__icon\"></span> <span class=\"community-list-view__item community-list-view__label-owner__text\">Owner</span></div></div></div><div ng-if=vm.showPrivacy class=\"community-list-view__item community-list-view__privacy\"><span class=community-list-view__item__mobile-label__haft-col>Privacy:</span> <span class=community-list-view__privacy__icon ng-class=\"community.is_private ? \'icon-lock\' : \'text--color-pixerf-theme icon-public-community\'\"></span> <span ng-class=\"{\'text--color-pixerf-theme\': !community.is_private}\" translate>{{community.is_private ? \'private\' : \'public\'}}</span></div><div ng-if=vm.showMemberCount class=\"community-list-view__item community-list-view__member\"><span class=community-list-view__item__mobile-label__haft-col>Member:</span> <span>{{community.member_count | number: 0}}</span></div><div ng-if=vm.showEventCount class=\"community-list-view__item community-list-view__event\"><span class=community-list-view__item__mobile-label__haft-col>Event:</span> <span>{{community.event_count | number: 0}}</span></div><div ng-if=vm.showPostCount class=\"community-list-view__item community-list-view__post\"><span class=community-list-view__item__mobile-label__haft-col>Post:</span> <span>{{community.discussion_count | number: 0}}</span></div><div ng-if=vm.showPermission class=\"community-list-view__item community-list-view__permissions\"><span class=community-list-view__item__mobile-label__haft-col>Permissions:</span> <span translate>{{community.start_discussion_permission === \'anyone\' ? \'everyone\' : \'admin-only\'}}</span></div><div ng-if=vm.showOwner class=\"community-list-view__item community-list-view__owner\" ng-class=\"{\'circle-profile\': community.owner.account_type === \'personal\'}\"><span class=community-list-view__item__mobile-label__haft-col>Owner:</span> <span class=community-list-view__item__mobile-label__haft-col>{{community.owner.displayName}}</span> <a ng-if=\"community.owner && community.owner.account_type === \'personal\'\" ui-sref=\"user-home-page.homepage({id: community.owner.id})\" target=_blank uib-tooltip={{community.owner.displayName}} ng-click=vm.prevenPubbleClick() tooltip-placement=auto><pixerf-user-avatar class=community-list-view__owner__cover user-data=community.owner lazy=true></pixerf-user-avatar></a><span ng-if=\"community.owner && community.owner.account_type === \'business\'\" uib-tooltip={{community.owner.displayName}} tooltip-placement=auto><pixerf-user-avatar class=community-list-view__owner__cover user-data=community.owner lazy=true></pixerf-user-avatar></span></div><div ng-if=vm.showDateCreated class=\"community-list-view__item community-list-view__date-created\"><span class=community-list-view__item__mobile-label__haft-col>Date created:</span> <span>{{vm.formattedCreatedDate}}</span></div><div ng-if=vm.showDateJoined class=\"community-list-view__item community-list-view__date-joined\"><span class=community-list-view__item__mobile-label__haft-col>Date joined:</span> <span>{{vm.formattedJoinedDate}}</span></div><div ng-if=vm.showDateInvited class=\"community-list-view__item community-list-view__date-invited\"><span class=community-list-view__item__mobile-label__haft-col>Date invited:</span> <span>{{vm.formattedInvitedDate}}</span></div><div ng-if=vm.showDateRequested class=\"community-list-view__item community-list-view__date-requested\"><span class=community-list-view__item__mobile-label__haft-col>Date requested:</span> <span>{{vm.formattedRequestedDate}}</span></div><div ng-if=vm.showStatus class=\"community-list-view__item community-list-view__status\" ng-class=\"{\'long-status\': vm.showReasonApproveRequired}\"><span class=community-list-view__item__mobile-label__haft-col>Status:</span> <span ng-class=\"{\'highlight-status\': vm.formattedStatus == \'Action Required\'}\">{{vm.formattedStatus}}</span></div><div ng-if=vm.showStrike class=\"community-list-view__item community-list-view__strike\"><span class=community-list-view__item__mobile-label__haft-col>Strikes:</span><div class=\"community-list-view__item community-list-view__strike__list__wrapper\"><div class=\"community-list-view__item community-list-view__strike__list\"><div ng-repeat=\"srike in [].constructor(vm.maxStrikes) track by $index\" class=community-list-view__strike__item ng-class=\"{\'striked\': $index < community.strike_count}\"></div></div><div ng-if=\"vm.isAdmin && community.previous_deactivation_count\" class=\"community-list-view__item community-list-view__strike__list reactived-list\"><div ng-repeat=\"srike in [].constructor(community.previous_deactivation_count) track by $index\" class=\"community-list-view__strike__item striked striked-reactived\"></div></div></div></div><div ng-if=vm.showActionRequired class=community-list-view__action-required><div class=community-list-view__action-required__sign ng-click=vm.onToggleActionRequired(vm.isOpenActionRequiredHint)><span class=\"community-list-view__action-required__icon icon-circle-warning\"></span> <span class=community-list-view__action-required__label>Action Required</span> <span class=community-list-view__action-required__icon-dropdown ng-class=\"vm.isOpenActionRequiredHint ? \'icon-icons_chevron-up\' : \'icon-icons_chevron-down\'\"></span></div><div class=\"community-list-view__action-required__hint collapse\" uib-collapse=!vm.isOpenActionRequiredHint><div class=community-list-view__action-required__hint__title>{{community.community_reject_comments[0].reason}}</div><div class=community-list-view__action-required__hint__description>{{community.community_reject_comments[0].comment}}</div></div></div><div ng-if=vm.showReasonApproveRequired class=\"community-list-view__item community-list-view__reason-approve-required\"><span ng-if=\"community.status != \'pending\'\" class=community-list-view__item__mobile-label__haft-col>Action Required:</span> <span ng-if=\"community.status != \'pending\'\">{{community.community_reject_comments[0].reason}}</span></div><div ng-if=\"vm.showCurationControl || vm.showManageButton\" class=\"community-list-view__item community-list-view__controls\" ng-class=\"{\'manage-button-style\': vm.showManageButton, \'col-pending-approval-style\': vm.type == \'pending-approval\'}\"><div class=community-list-view__controls__wrapper><button ng-if=vm.showCurationControl class=\"community-list-view__controls__action-required-button btn btn--transparent\" ng-click=vm.onActionRequiredCommunity()><span class=\"community-list-view__controls__action-required-button__icon icon-circle-warning\"></span> <span class=community-list-view__controls__action-required-button__label>Action required</span></button> <button ng-if=vm.showCurationControl class=\"community-list-view__controls__approve-button btn btn-submit\" ng-click=vm.onApproveCommunity()><span class=\"community-list-view__controls__approve-button__icon icon-icons_check\"></span> <span>Approve</span></button> <button ng-if=vm.showManageButton class=\"community-list-view__controls__manage-button btn btn-submit\" ng-click=vm.onManageCommunity()>Edit</button></div></div><div ng-if=vm.showActionButton class=\"community-list-view__item community-list-view__action-button\"><div class=community-list-view__action-button__wrapper ng-class=\"{\'col-invited-style\': vm.type == \'invited\'}\"><button ng-if=vm.showDeclineBtn class=\"community-list-view__action-button__decline-btn btn btn--transparent\" ng-click=vm.onDenyClicked()><span class=\"community-list-view__action-button__decline-btn__icon icon-circle-warning\"></span> <span class=community-list-view__action-button__decline-btn__label>Decline</span></button> <button ng-if=vm.showAcceptBtn class=\"community-list-view__action-button__accept-btn btn btn-submit\" ng-click=vm.onAcceptClicked()><span class=\"community-list-view__action-button__accept-btn__icon icon-circle-warning\"></span> <span class=community-list-view__action-button__accept-btn__label>Accept</span></button> <button ng-if=vm.showWithdrawBtn class=\"community-list-view__action-button__withdraw-btn btn btn--transparent\" ng-click=vm.onWithdrawCommunity()><span class=\"community-list-view__action-button__withdraw-btn__icon icon-circle-warning\"></span> <span class=community-list-view__action-button__withdraw-btn__label>Withdraw</span></button> <button ng-if=vm.showEditBtn class=\"community-list-view__action-button__withdraw-btn btn btn-submit\" ng-click=vm.onEditCommunity()><span class=\"community-list-view__action-button__withdraw-btn__icon icon-circle-warning\"></span> <span class=community-list-view__action-button__withdraw-btn__label>Edit</span></button></div></div><div ng-if=vm.showActionList class=\"community-list-view__item community-list-view__action-list\"><div uib-dropdown is-open=vm.isActionListOpen class=community-list-view__action-list__btn-wrapper><span uib-dropdown-toggle class=\"community-list-view__action-list__icon icon-icons_more\" ng-click=vm.prevenPubbleClick()></span><ul class=community-list-view__action-list__list uib-dropdown-menu role=menu><li role=menuitem class=community-list-view__action-list__item ng-repeat=\"item in vm.actionList\" ng-click=item.cta(vm.comment)>{{item.label}}</li></ul></div></div><div ng-if=vm.showCombineAction class=\"community-list-view__item community-list-view__combine-action-list\"><div class=community-list-view__combine-action-list__wrapper><button ng-if=vm.showEditBtn class=\"community-list-view__combine-action-list__edit-btn btn btn-submit\" ng-click=vm.onEditCommunity()><span class=\"community-list-view__combine-action-list__edit-btn__icon icon-circle-warning\"></span> <span class=community-list-view__combine-action-list__edit-btn__label>Edit</span></button><div uib-dropdown is-open=vm.isActionListOpen class=community-list-view__action-list__btn-wrapper><span uib-dropdown-toggle class=\"community-list-view__action-list__icon icon-icons_more\" ng-click=vm.prevenPubbleClick()></span><ul class=community-list-view__action-list__list uib-dropdown-menu role=menu><li role=menuitem class=community-list-view__action-list__item ng-repeat=\"item in vm.actionList\" ng-click=item.cta(vm.comment)>{{item.label}}</li></ul></div></div></div></div>");
$templateCache.put("app/components/community-member-filter/community-member-filter.html","<div class=community-member-filter><div class=\"no-padding community-member-filter__row-wrapper\"><stick-checkbox model=vm.searchCondition model-property=isDirectoryChecked on-changed=vm.onDirectoryCheckChanged() label=from-directory></stick-checkbox><stick-checkbox model=vm.searchCondition model-property=isEmailChecked on-changed=vm.onFollowerCheckChanged() label=from-email></stick-checkbox><stick-checkbox model=vm.searchCondition model-property=isLinkChecked on-changed=vm.onLinkCheckChanged() label=copy-invite-link></stick-checkbox></div><div class=\"no-padding community-member-filter__row-wrapper__stretch\"><div class=\"relative community-member-filter__comboxbox-wrapper\" ng-show=vm.searchCondition.isDirectoryChecked><pixerf-input-auto-complete data=vm.countries model=vm.searchCondition.country options=vm.bootstrapSelectOptions.country on-changed=vm.onSearchConditionChanged()></pixerf-input-auto-complete></div><div class=\"relative community-member-filter__comboxbox-wrapper\" ng-show=vm.searchCondition.isDirectoryChecked><pixerf-input-auto-complete ng-if=\"vm.specialities && vm.specialities.length\" data=vm.specialities model=vm.searchCondition.speciality options=vm.bootstrapSelectOptions.speciality on-changed=vm.onSearchConditionChanged()></pixerf-input-auto-complete></div></div></div>");
$templateCache.put("app/components/community-member-item/community-member-item.html","<div class=community-member-item><div class=community-member-item__checkbox-wrapper><pixerf-checkbox model=userData model-property=isSelected on-changed=onSelectedChanged()></pixerf-checkbox></div><div class=community-member-item__user-info><div class=community-member-item__user-info__avatar><a ui-sref=\"user-home-page.personal.home({id: userData.id, userName: (userData.displayName | toSnakeCase)})\"><pixerf-user-avatar user-data=userData lazy=true></pixerf-user-avatar></a></div><div class=community-member-item__user-info__details><div class=community-member-item__user-info__info><div class=community-member-item__user-info__info__details><div class=clearfix><a class=community-member-item__user-info__info__details__name-wrapper ui-sref=\"user-home-page.personal.home({id: userData.id, userName: (userData.displayName | toSnakeCase)})\" popup-link-clicked><div class=\"community-member-item__user-info__info__details__user-name text--truncate text--bold\" uib-tooltip=\"{{userData.displayName || userData.email}}\" tooltip-placement=auto>{{userData.displayName || userData.email}}</div></a></div><div class=community-member-item__user-info__info__details__level><div ng-if=vm.isContextInvitedMember class=community-member-item__user-info__info__context>has been invited to join your Community.</div><div ng-if=vm.isContextPending class=community-member-item__user-info__info__context>has requested to join.</div></div></div></div></div></div><div class=community-member-item__button-group><div ng-if=vm.isContextPending class=\"community-btn community-btn--approve\" ng-click=\"vm.onActionBtnClicked(vm.CONSTANT.ACCEPT, userData, $event)\"><span class=icon-icons_check></span></div><div ng-if=vm.isContextPending class=\"community-btn community-btn--reject\" ng-click=\"vm.onActionBtnClicked(vm.CONSTANT.REJECT, userData, $event)\"><span class=icon-icons_close></span></div><div ng-if=vm.isContextMember class=\"btn btn--black-magento\" ng-click=\"vm.onActionBtnClicked(vm.CONSTANT.REMOVE, userData, $event)\">Remove</div><div ng-if=vm.isContextInvitedMember class=\"btn btn-cancel--no-background\" ng-click=\"vm.onActionBtnClicked(vm.CONSTANT.UNINVITE, userData, $event)\">Un-invite</div><div ng-if=vm.isContextBlockedMember class=\"btn btn-cancel--no-background\" ng-click=\"vm.onActionBtnClicked(vm.CONSTANT.UNBLOCK, userData, $event)\">Unblock</div></div></div>");
$templateCache.put("app/components/community-member-list/community-member-list.html","<div class=community-members-list><div class=community-members-list__list-content ng-if=\"vm.peoples.length > 0\"><div class=\"community-members-list__select-tool-group clearfix\"><div class=community-members-list__select-all ng-if=\"vm.peoples.length > 0 || (vm.isContextPending && community.requested_count > 0) || (vm.isContextInvitedMember && community.invited_count > 0) || (vm.isContextMember && community.member_count > 0)\"><div class=\"community-members-list__select-tool-group__item community-members-list__select-tool-group__item-checkbox relative\"><pixerf-checkbox model=vm model-property=isSelectAll on-changed=vm.onSelectAllToogle()></pixerf-checkbox><span class=\"community-members-list__select-tool-group__item__label text--color-black text--bold\">All</span></div><div class=community-members-list__select-tool-group__button-group><div ng-class=\"{\'disable-acion\': !vm.isActionForMultiActived}\"></div><button ng-if=vm.isContextPending class=\"community-members-list__select-tool-group__control-btn text--semibold\" ng-class=\"vm.isActionForMultiActived ? \'text--color-pixerf-theme\' : \'text--color-disabled\'\" ng-click=vm.onActionClicked(vm.CONSTANT.ACCEPT)><div class=community-members-list__select-tool-group__control-text>Approve Selected</div></button> <button ng-if=vm.isContextPending class=\"community-members-list__select-tool-group__control-btn text--semibold\" ng-class=\"vm.isActionForMultiActived ? \'text--color-pixerf-theme\' : \'text--color-disabled\'\" ng-click=vm.onActionClicked(vm.CONSTANT.REJECT)><div class=community-members-list__select-tool-group__control-text>Reject Selected</div></button> <button ng-if=vm.isContextMember class=\"community-members-list__select-tool-group__control-btn text--semibold\" ng-class=\"vm.isActionForMultiActived ? \'text--color-pixerf-theme\' : \'text--color-disabled\'\" ng-click=vm.onActionClicked(vm.CONSTANT.REMOVE)><div class=community-members-list__select-tool-group__control-text>Remove Selected</div></button> <button ng-if=vm.isContextInvitedMember class=\"community-members-list__select-tool-group__control-btn text--semibold\" ng-class=\"vm.isActionForMultiActived ? \'text--color-pixerf-theme\' : \'text--color-disabled\'\" ng-click=vm.onActionClicked(vm.CONSTANT.UNINVITE)><div class=community-members-list__select-tool-group__control-text>Un-invite Selected</div></button> <button ng-if=vm.isContextBlockedMember class=\"community-members-list__select-tool-group__control-btn text--semibold\" ng-class=\"vm.isActionForMultiActived ? \'text--color-pixerf-theme\' : \'text--color-disabled\'\" ng-click=vm.onActionClicked(vm.CONSTANT.UNBLOCK)><div class=community-members-list__select-tool-group__control-text>Unblock Selected</div></button></div></div><div class=community-members-list__search-member-wrapper ng-if=\"canSearch && (vm.peoples.length != 0 || community.member_count != 0)\"><input ng-model=vm.searchString ng-change=vm.onSearchStringChanged() class=\"form-control search-input\" type=text placeholder=\"Find a member...\"></div></div><div class=community-members-list__wrapper ng-class=\"{\'no-border\': vm.peoples.length === 0}\" infinite-scroll-disabled=vm.isLastPage infinite-scroll=vm.fetchMore() infinite-scroll-immediate-check=false lazy-img-container><div ng-repeat=\"userData in vm.peoples\" class=\"community-members-list__wrapper__item clearfix\"><div ng-click=vm.onUserDataClicked(userData) ng-class=\"{\'actived-info\': userData.id === vm.actiedInfoId && showDetail}\"><community-member-item user-data=userData context={{context}} on-user-status-changed=\"vm.onMembersChanged(memberChanged, action, context)\" on-selected-changed=vm.onMembersSelectedChanged()></community-member-item></div></div><scroll-paging spinner=vm.spinner show-message=false is-last-page=vm.isLastPage></scroll-paging></div></div><div class=community-members-list__list-detail ng-if=\"vm.isContextPending && vm.selectedUser && vm.selectedUser.id && showDetail\"><div class=community-members-list__list-detail__user-info><div class=community-members-list__list-detail__user-info__avatar ng-if=!vm.isWorking><pixerf-user-avatar user-data=vm.selectedUser lazy=true></pixerf-user-avatar></div><div class=community-members-list__list-detail__user-info__cover><div class=\"community-members-list__list-detail__user-info__name text--truncate\">{{vm.selectedUser.displayName}}</div><div class=community-members-list__list-detail__user-info__user-type><span class=community-members-list__list-detail__user-info__user-type__ambassador pixerf-person-level person=vm.selectedUser></span></div><div class=\"community-members-list__list-detail__user-info__location text--truncate\">{{vm.selectedUser.location ? (vm.selectedUser.location | normalizeLocation) : (vm.selectedUser.address.country | isoCountry)}}</div></div></div><div class=community-members-list__list-detail__detail-info><div class=community-members-list__list-detail__detail-info__photo><div class=community-members-list__list-detail__detail-info__value>{{vm.selectedUser.stats.media_count | number}}</div><div class=community-members-list__list-detail__detail-info__label>{{(\'photos\' | translate).toLowerCase()}}</div></div><div class=community-members-list__list-detail__detail-info__follower><div class=community-members-list__list-detail__detail-info__value>{{vm.selectedUser.stats.follower_count | number}}</div><div class=community-members-list__list-detail__detail-info__label>{{(\'followers\' | translate).toLowerCase()}}</div></div><div class=community-members-list__list-detail__detail-info__following><div class=community-members-list__list-detail__detail-info__value>{{vm.selectedUser.stats.following_count | number}}</div><div class=community-members-list__list-detail__detail-info__label>{{(\'following\' | translate).toLowerCase()}}</div></div></div><div class=community-members-list__list-detail__more-detail><button class=\"community-members-list__list-detail__more-detail__button btn btn-submit--no-background\" ng-click=vm.onViewProfileClicked(vm.selectedUser)>{{\'view-profile\'|translate}}</button></div><div class=community-members-list__list-detail__about><div class=community-members-list__list-detail__about__label translate>{{\'about\'}}</div><div>{{vm.selectedUser.bio}}</div></div><div class=community-members-list__list-detail__about><div class=community-members-list__list-detail__about__label translate>{{\'photography-specialities\'}}</div><div>{{vm.selectedUser.profile.specialities}}</div></div></div><div ng-if=\"vm.peoples.length === 0 && !vm.searchString\" class=community-members-list__empty-state><div ng-transclude></div></div></div>");
$templateCache.put("app/components/community-members-label/community-members-label.html","<div class=community-members-label><span ng-bind=\"(community.member_count | bigNumberFormatter) + (community.member_count === 1  ? \' \' + (\'member\' | translate) : \' \' + (\'members\' | translate))\"></span> <a ng-if=\"community.isMine && community.requested_count > 0\" ui-sref=\"setting.manage-communities.community-detail.community-detail-page-manage-pending-approval-member({id: community.id,name: community.name, manage: true})\" class=\"text--semibold text--color-pixerf-theme community-members-label__requests\">· {{community.requested_count === 1 ? community.requested_count + \' \' + (\'request\' | translate) : community.requested_count + \' \' + (\'requests\' | translate)}}</a></div>");
$templateCache.put("app/components/community-pending-invitation/community-pending-invitation.html","<div class=\"community-pending-invitation relative\"><div class=community-pending-invitation__avatar><a ui-sref=\"user-home-page.personal.home({id: userData.id, userName: (userData.displayName | toSnakeCase)})\"><pixerf-user-avatar user-data=userData lazy=true></pixerf-user-avatar></a></div><div class=relative><div class=community-pending-invitation__info><div class=community-pending-invitation__info__details><a ui-sref=\"user-home-page.personal.home({id: userData.id, userName: (userData.displayName | toSnakeCase)})\" popup-link-clicked><div class=\"community-pending-invitation__info__details__user-name text--truncate text--bold text--color-black\" uib-tooltip={{userData.displayName}} tooltip-placement=auto>{{userData.displayName}}</div></a><div ng-if=!userData.connection class=community-pending-invitation__info__details__location>{{userData.address.country ? userData.address.country : userData.location | isoCountry}}</div><div ng-if=!userData.connection class=\"community-pending-invitation__info__details__level text--bold\" pixerf-person-level person=userData></div><div ng-if=!userData.connection class=community-pending-invitation__info__details__followers-count>{{userData.stats.follower_count}} followers</div><div ng-if=userData.connection class=community-pending-invitation__info__details__connection>{{userData.connection}}</div></div></div></div><div class=\"community-pending-invitation__button-group vertical-align-middle--transform\"><button class=\"btn btn-cancel btn-cancel--no-background\" ng-click=vm.onIgnoreBtnClicked()>Cancel Request</button></div></div>");
$templateCache.put("app/components/community-pending-invitations-list/community-pending-invitations-list.html","<div class=community-pending-invitations-list><div infinite-scroll-disabled=vm.isLastPage infinite-scroll=vm.fetchMore() infinite-scroll-immediate-check=false infinite-scroll-container=\"\'.person-list-selection\'\" lazy-img-container><div ng-repeat=\"userData in vm.peoples\" class=clearfix><community-pending-invitation user-data=userData></community-pending-invitation></div><scroll-paging spinner=vm.spinner show-message=false is-last-page=vm.isLastPage></scroll-paging></div><div ng-if=\"vm.peoples.length === 0\"><div ng-transclude></div></div></div>");
$templateCache.put("app/components/community-remove-report-popup/community-remove-report-popup.html","<div class=community-remove-report-popup><div class=community-remove-report-popup__close ng-click=vm.closePopup()><span class=icon-icons_close aria-hidden=true></span></div><div class=community-remove-report-popup__header translate translate-values=\"{type: vm.reportType}\">{{vm.popupTitle}}</div><div class=community-remove-report-popup__body><div class=community-remove-report-popup__body__description ng-bind-html=vm.desciption></div><pixerf-input-auto-complete ng-if=!vm.stateSuccess name=reasons is-required=true options=vm.defaultOptions data=vm.selectionSettings.data model=vm.selectedReason dropdown-class=community-remove-report-popup__select-reasons></pixerf-input-auto-complete></div><div ng-if=!vm.stateSuccess class=community-remove-report-popup__footer><div ng-click=vm.closePopup() class=\"community-remove-report-popup__footer__button btn-cancel--no-background\">Cancel</div><div ng-click=vm.onConfirmClicked() class=\"community-remove-report-popup__footer__button btn-submit\">Confirm</div></div></div>");
$templateCache.put("app/components/community-report-list-view/community-report-list-view.html","<div class=community-report-list-view ng-click=vm.onReportClicked(vm.report)><div ng-if=\"vm.isAdmin && vm.type === \'pending\'\" class=\"community-report-list-view__item community-report-list-view__select\"><stick-checkbox on-changed=vm.onToggleSelected(vm.report) model=report model-property=isSelected layout-style=regular-square is-disabled=vm.disabledCheckbox()></stick-checkbox></div><div class=\"community-report-list-view__name community-report-list-view__community\"><img ng-src={{report.community.cover.thumbnail}} class=community-report-list-view__owner__cover><a class=community-report-list-view__owner__name ng-click=vm.prevenPubbleClick() ui-sref=\"community-detail-page.community-detail-discussions({id: report.community.id,name: report.community.name})\" target=_blank>{{report.community.name}}</a></div><div class=\"community-report-list-view__item community-report-list-view__reason\"><span class=community-report-list-view__item__mobile-label__haft-col>Reason:</span> <span>{{report.reason}}</span></div><div class=\"community-report-list-view__item community-report-list-view__type\"><span class=community-report-list-view__item__mobile-label__haft-col>Type:</span> <span>{{report.typeOfReport}}</span></div><div class=\"community-report-list-view__item community-report-list-view__reporter\"><span class=community-report-list-view__item__mobile-label__haft-col>Reporter:</span> <span>{{report.user.displayName}}</span></div><div class=\"community-report-list-view__item community-report-list-view__date\"><span class=community-report-list-view__item__mobile-label__haft-col>Date:</span> <span>{{vm.fomatedDate}}</span></div><div class=\"community-report-list-view__item community-report-list-view__admin\" ng-class=\"{\'circle-profile\': report.community.owner.account_type === \'personal\'}\"><span class=community-report-list-view__item__mobile-label__haft-col>Admin:</span> <span class=community-report-list-view__item__mobile-label__haft-col>{{report.community.owner.displayName}}</span> <a ng-if=\"report.community.owner && report.community.owner.account_type === \'personal\'\" ui-sref=\"user-home-page.homepage({id: report.community.owner.id})\" target=_blank uib-tooltip={{report.community.owner.displayName}} ng-click=vm.prevenPubbleClick() tooltip-placement=auto><pixerf-user-avatar class=community-report-list-view__admin__cover user-data=report.community.owner lazy=true></pixerf-user-avatar></a><span ng-if=\"report.community.owner && report.community.owner.account_type === \'business\'\" uib-tooltip={{report.community.owner.displayName}} tooltip-placement=auto><img ng-src=\"{{report.community.owner.profile_image_media[\'100x\']}}\" class=community-report-list-view__admin__cover></span></div><div class=\"community-report-list-view__item community-report-list-view__status\"><span class=community-report-list-view__item__mobile-label__haft-col>Status:</span> <span ng-class=\"{\'blue-status-theme\': [\'open\', \'resolved\'].includes(report.status), \'red-status-theme\': report.status === \'validated\'}\">{{vm.status}}</span></div><div ng-if=vm.isAdmin class=\"community-report-list-view__item community-report-list-view__strike\"><span ng-if=vm.isShowStrikeList class=community-report-list-view__item__mobile-label__haft-col>Strikes:</span><div class=\"community-report-list-view__item community-report-list-view__strike__list-wrapper\"><div class=\"community-report-list-view__item community-report-list-view__strike__list\"><div ng-if=vm.isShowStrikeList ng-repeat=\"srike in [].constructor(vm.maxStrikes) track by $index\" class=community-report-list-view__strike__item ng-class=\"{\'striked\': $index < vm.report.community.strike_count}\"></div></div><div ng-if=\"vm.isShowStrikeList && vm.report.community.previous_deactivation_count\" class=community-report-list-view__deactivated__list><div ng-if=\"vm.isShowStrikeList && vm.report.community.previous_deactivation_count\" ng-repeat=\"srike in [].constructor(vm.report.community.previous_deactivation_count) track by $index\" class=community-report-list-view__deactivated__item></div></div></div></div><div ng-if=\"vm.type === \'pending\'\" class=\"community-report-list-view__item community-report-list-view__more\"><div ng-if=!vm.isHideMoreControl uib-dropdown class=community-report-list-view__more__btn-wrapper><span uib-dropdown-toggle class=\"community-report-list-view__more__icon icon-icons_more\" ng-click=vm.prevenPubbleClick()></span><ul class=community-report-list-view__more__list uib-dropdown-menu role=menu><li role=menuitem class=community-report-list-view__more__item ng-repeat=\"item in vm.moreList\" ng-click=item.cta(vm.comment)>{{item.label}}</li></ul></div></div></div>");
$templateCache.put("app/components/community-resolve-report-popup/community-resolve-report-popup.html","<div class=community-resolve-report-popup><div class=community-resolve-report-popup__close ng-click=vm.closePopup()><span class=icon-icons_close aria-hidden=true></span></div><div class=community-resolve-report-popup__header translate translate-values=\"{type: vm.reportType}\">{{vm.popupTitle}}</div><div class=community-resolve-report-popup__body><div class=community-resolve-report-popup__body__description translate translate-values=\"{owner: vm.owner, type: vm.reportType}\">{{vm.desciption}}</div></div><div ng-if=!vm.stateSuccess class=community-resolve-report-popup__footer><div ng-click=vm.closePopup() class=\"community-resolve-report-popup__footer__button btn-cancel--no-background\">Cancel</div><div ng-click=vm.onConfirmClicked() class=\"community-resolve-report-popup__footer__button btn-submit\">Confirm</div></div></div>");
$templateCache.put("app/components/community-tag/community-tag.html","<div class=community-tag><div class=community-tag__info><a ui-sref={{vm.routeOnNavigate}} class=community-tag__logo><pixerf-avatar class=community-tag__logo avatar=community.avatar></pixerf-avatar></a><div class=community-tag__details><div class=\"community-tag__details__content clearfix text-left\"><a class=\"community-tag__details__name text--bold text--color-black\" ui-sref={{vm.routeOnNavigate}}>{{community.name}}</a><div class=community-tag__details__numbers-members>{{community.member_count === 1 ? community.member_count + \' member\' : community.member_count + \' members\'}} <a ui-sref=\"{{vm.commonConst.STATE.COMMUNITIES_DETAILS_DISCUSSIONS}}({id: community.id,name: community.name})\" ng-if=vm.isMine class=\"text--color-pixerf-theme text--semibold\"></a></div></div><div class=\"community-tag__members-details clearfix\"><a ui-sref=\"user-home-page.business({id: member.id})\" class=community-tag__members-details__avatar ng-repeat=\"member in community.members | filter: vm.memberAccepted | limitTo: 8\" uib-tooltip={{member.displayName}} tooltip-placement=top><pixerf-user-avatar class=community-tag__members-details__avatar__img user-data=member lazy=true></pixerf-user-avatar></a></div></div><div class=community-tag__top-right><button ng-if=community.isMine ng-click=vm.onEditBtnClicked() class=\"community-tag__btn-edit btn btn-pixerf-theme--blue btn-pixerf-theme--no-background text--bold\">Edit</button><join-community-btn ng-if=\"!community.isMine && !vm.loginUser.isBiz\" options=vm.joinBtnOptions community=community on-changed=vm.onCommunityMembershipChanged()></join-community-btn><label ng-if=community.is_private class=\"community-tag__private-label text--bold\">Private</label></div></div></div>");
$templateCache.put("app/components/community-tile/community-tile.html","<div class=community-tile><div class=\"community-tile__inner-wrapper cleafix\"><div class=community-tile__background ng-style=\"{\'background-image\': \'url(\\\'\' + vm.communityLogo + \'\\\')\'}\" ng-click=vm.onRedirectToCommunity(community)></div><div class=community-tile__footer><div class=\"community-tile__footer__title text--truncate\" uib-tooltip={{community.name}} ng-click=vm.onRedirectToCommunity(community)>{{community.name}}</div><div class=community-tile__footer__info><div class=community-tile__footer__info__member>{{community.member_count === 1 ? community.member_count + \' \' + (\'member\' | translate) : community.member_count + \' \' + (\'members\' | translate)}}</div><div class=community-tile__footer__info__devide></div><div class=community-tile__footer__info__status translate>{{(community.is_unlisted == true) ? \'unlisted\' : (community.is_private ? \'private\' : \'public\')}}</div></div><div class=community-tile__footer__manager><div class=community-tile__footer__manager__text translate>{{\'posted-by\'}}</div><a class=\"community-tile__footer__manager__author text--truncate\" uib-tooltip={{community.owner.displayName}}>{{community.owner.displayName}}</a></div><div ng-if=community.isMine class=community-tile__footer__divide></div><div ng-if=\"community.isMine && community.type != \'CommunityEvent\'\" class=community-tile__footer__managent ui-sref=\"{{vm.commonConst.STATE.MANAGE_COMMUNITIES_BRIEF}}({id: community.id,name: community.name, manage: true,status: \'members\'})\">{{\'edit\' | translate: {name: (\'community\' | translate)}}}</div><div ng-if=\"community.isMine && community.type === \'CommunityEvent\'\" class=community-tile__footer__managent ui-sref=\"{{vm.commonConst.STATE.EVENT_FEED}}({id: community.id,name: community.name, manage: true})\">{{\'edit\' | translate: {name: (\'event\' | translate)}}}</div></div></div></div>");
$templateCache.put("app/components/community-tile-list-details/community-tile-list-details.html","<div class=community-tile-list-details><div class=community-tile-list-details__container><a ui-sref=\"{{vm.commonConst.STATE.COMMUNITIES_DETAILS_DISCUSSIONS}}({id: community.id,name: community.name})\"><div class=community-tile-list-details__photo ng-style=\"{\'background-image\': \'url(\\\'\' + vm.communityLogo + \'\\\')\'}\"></div></a><div class=community-tile-list-details__content><a ui-sref=\"{{vm.commonConst.STATE.COMMUNITIES_DETAILS_DISCUSSIONS}}({id: community.id,name: community.name})\"><div class=community-tile-list-details__content__info><div class=community-tile-list-details__content__info__name>{{vm.community.name}}</div><div class=community-tile-list-details__content__info__member>{{vm.community.member_count | number}} {{vm.community.member_count == 1 ? (\'member\' | translate).toLowerCase() : (\'members\' | translate).toLowerCase()}}</div></div></a><div class=community-tile-list-details__content__label ng-if=vm.label translate>{{vm.label}}</div></div><div class=community-tile-list-details__control><button class=\"community-tile-list-details__control__btn btn btn-submit--no-background\" ng-click=vm.onControlClicked()>{{vm.controlBtnLabel | translate}}</button></div></div></div>");
$templateCache.put("app/components/community-validate-report-popup/community-validate-report-popup.html","<div class=community-validate-report-popup><div class=community-validate-report-popup__close ng-click=vm.closePopup()><span class=icon-icons_close aria-hidden=true></span></div><div class=community-validate-report-popup__header translate translate-values=\"{type: vm.reportType}\">{{vm.popupTitle}}</div><div class=community-validate-report-popup__body><div class=community-validate-report-popup__body__info><div class=community-validate-report-popup__body__info__wrapper><img ng-src={{vm.avatar}} class=community-validate-report-popup__body__info__avatar><div class=community-validate-report-popup__body__info__name><div class=community-validate-report-popup__body__info__name__owner>{{vm.owner}}</div><div ng-if=vm.subName class=community-validate-report-popup__body__info__name__sub-owner><span class=community-validate-report-popup__body__info__name__sub-owner__label>Hosted by</span> <span class=community-validate-report-popup__body__info__name__sub-owner__value>{{vm.subName}}</span></div></div></div><div class=community-validate-report-popup__body__info__strike><div class=community-validate-report-popup__body__info__strike__label>Strikes</div><div class=community-validate-report-popup__body__info__strike__list><div ng-repeat=\"srike in [].constructor(vm.maxStrikes) track by $index\" class=community-validate-report-popup__body__info__strike__item ng-class=\"{\'icon-icons_close\': $index < vm.strike_count}\"></div></div><div ng-if=vm.report.community.previous_deactivation_count class=community-validate-report-popup__body__info__strike__list><div ng-repeat=\"srike in [].constructor(vm.report.community.previous_deactivation_count) track by $index\" class=\"community-validate-report-popup__body__info__strike__item deactivated icon-icons_close\"></div></div></div></div><div class=community-validate-report-popup__body__description translate translate-values=\"{owner: vm.subName || vm.owner, type: vm.reportType}\">{{vm.desciption}}</div><pixerf-input-auto-complete ng-if=!vm.stateSuccess name=reasons is-required=true options=vm.defaultOptions data=vm.selectionSettings.data model=vm.selectedReason dropdown-class=community-validate-report-popup__select-reasons></pixerf-input-auto-complete></div><div ng-if=!vm.stateSuccess class=community-validate-report-popup__footer><div ng-click=vm.closePopup() class=\"community-validate-report-popup__footer__button btn-cancel--no-background\">Mark as In Review</div><div ng-click=vm.onConfirmClicked() class=\"community-validate-report-popup__footer__button btn-submit\">{{vm.confirmButtonText}}</div></div></div>");
$templateCache.put("app/components/compose-post-popup/compose-post-popup.html","<div class=compose-post-popup><div class=clearfix><button type=button class=close ng-click=vm.closePopup()><span class=icon-icons_close></span></button><div class=\"modal-header text-left\"><div class=modal--user-avatar><img src=assets/images/default/default-profile.png lazy-img-error=assets/images/default/default-profile.png lazy-img={{vm.postData.avatar}}></div><div class=\"modal--title text--bold text--color-black text-left\">{{vm.postData.author}}</div></div><div class=modal-body><textarea class=compose-post-editor name=\"\" cols=30 rows=10 placeholder=\"Write something here...\"></textarea><button class=\"btn btn-submit btn-compose-post text--bold\">Post</button></div></div></div>");
$templateCache.put("app/components/confirm-invite-by-link-popup/confirm-invite-by-link-popup.html","<div class=confirm-invite-by-link-popup><button type=button class=close ng-click=vm.cancel()><span class=icon-icons_close aria-hidden=true></span></button><div class=clearfix><div class=\"confirm-invite-by-link-popup__header clearfix\"><div class=\"confirm-invite-by-link-popup__header__title text--extrabold text--color-black\" ng-bind-html=vm.currentStep.title></div><div class=confirm-invite-by-link-popup__header__desc ng-show=\"(vm.currentState.state == 1) && (vm.isShowConfirmEvent)\">This event is organised by <a ng-click=vm.hidePopup() ui-sref=\"{{vm.commonConst.STATE.COMMUNITIES_DETAILS_DISCUSSIONS}}({id: vm.community.id,name: vm.community.name})\" class=\"text--bold text--color-pixerf-theme\">{{vm.community.name}}</a>. By joining the event, you agree to join this community.</div><div class=confirm-invite-by-link-popup__header__desc ng-hide=\"((vm.currentState.state == 3)&& (vm.currentState.actor == \'Contributor\')) || (vm.currentState.state == 1)\" ng-bind-html=vm.currentStep.desc></div><div class=confirm-invite-by-link-popup__header__desc ng-show=\"(vm.currentState.state == 3) && (vm.currentState.actor == \'Contributor\')\"><span translate>{{\'showcase-your-works-and\'}}</span> <a ng-click=vm.hidePopup() ui-sref=buy-stock-page.trending href=#/marketplace/photos class=\"text--bold text--color-pixerf-theme\">now</a>.</div></div><div class=confirm-invite-by-link-popup__body><div ng-if=\"vm.currentState.state == 1\" class=confirm-invite-by-link-popup__body__select-user-type><div class=\"user-type__select item-{{$index}}\" ng-repeat=\"userType in vm.StateData[1][1].data\" ng-class=\"{\'selected\': userType.key == vm.loginnedUser.account_type}\" ng-click=vm.onUserTypeClicked(userType)><div class=\"user-type__header text--extrabold text--color-black\">{{userType.title}}</div><div class=user-type__desc>{{userType.desc}}</div></div></div><div ng-if=\"vm.currentState.state == 2 && vm.currentState.actor ==\'Business\'\"></div><form name=profileFormBiz id=profileFormBiz class=\"clearfix profile-form-biz\" ng-show=\"vm.currentState.state == 2 && vm.currentState.actor ==\'Business\'\"><div class=\"form-group email-wrapper\" ng-if=\"vm.currentState.step == 1\"><label for=name ng-class=\"!profileFormBiz.$pristine && profileFormBiz.name.$invalid ? \'text--color-error\' : \'text--color-black\'\" translate>{{\'full-name\'}}</label><input maxlength=255 name=name required ng-model=\" vm.loginnedUser.first_name\" type=text class=form-control></div><div class=form-group ng-if=\"vm.currentState.step == 2\"><label for=company ng-class=\"!profileFormBiz.$pristine && profileFormBiz.company.$invalid ? \'text--color-error\' : \'text--color-black\'\" translate>{{\'company-name\'}}</label><input name=company validation-no-hyperlink ng-model=\" vm.loginnedUser.organization.name\" class=form-control required></div><div class=form-group ng-if=\"vm.currentState.step == 3\"><label for=officeType ng-class=\"!profileFormBiz.$pristine && profileFormBiz.officeType.$invalid ? \'text--color-error\' : \'text--color-black\'\" translate>{{\'office-type\'}}</label><select name=officeType class=form-control required ng-model=vm.loginnedUser.organization.office_type><option ng-repeat=\"opt in vm.officeTypes.data\" value={{opt.id}} ng-selected=\"{{(opt.id == vm.loginnedUser.organization.office_type) ? \'selected\' : \'\'}}\">{{opt.name}}</option></select></div><div class=form-group ng-if=\"vm.currentState.step == 4\"><label for=registration ng-class=\"!profileFormBiz.$pristine && profileFormBiz.registration.$invalid ? \'text--color-error\' : \'text--color-black\'\" translate>{{\'company-registration-no\'}}</label><input required name=registration validation-no-hyperlink ng-model=\" vm.loginnedUser.organization.registration_no\" class=form-control></div><div class=form-group ng-if=\"vm.currentState.step == 5\"><label for=country ng-class=\"!profileFormBiz.$pristine && profileFormBiz.country.$invalid ? \'text--color-error\' : \'text--color-black\'\" translate>{{\'country-of-origin\'}}</label><country-select class=form-control required name=country ng-model=\" vm.loginnedUser.organization.address.country\" placeholder=Country></country-select></div><div class=\"form-group col-sm-12 no-padding\" class=sign-up-register-information-modal__country-select ng-class=\"{\'place-holder\': ! vm.loginnedUser.address.country}\" ng-if=\"vm.currentState.step == 6\"><label for=location class=label-sign-up-information ng-class=\"!profileFormBiz.$pristine && profileFormBiz.location.$invalid ? \'text--color-error\' : \'text--color-black\'\">{{\'city\' | translate}}/{{\'state\' | translate}}</label><input id=E10 required validation-no-hyperlink name=location ng-model=vm.loginnedUser.location class=form-control g-places-autocomplete options=vm.gplacesOptions></div></form><form name=profileForm id=profileForm class=\"clearfix profile-form\" ng-show=\"vm.currentState.state == 2 && vm.currentState.actor ==\'Contributor\'\"><div class=\"form-group first-name-field col-sm-6\" ng-if=\"vm.currentState.step == 1\"><label for=first_name class=label-sign-up-information ng-class=\"!profileForm.$pristine && profileForm.first_name.$invalid ? \'text--color-error\' : \'text--color-black\'\" translate>{{\'first-name\'}}</label><input id=E6 maxlength=20 required validation-no-hyperlink validation-no-number name=first_name ng-model=\" vm.loginnedUser.first_name\" class=form-control required focus-me=vm.isFocusField.data></div><div class=\"form-group last-name-field col-sm-6\" ng-if=\"vm.currentState.step == 1\"><label for=last_name class=label-sign-up-information ng-class=\"!profileForm.$pristine && profileForm.last_name.$invalid ? \'text--color-error\' : \'text--color-black\'\" translate>{{\'last-name\'}}</label><input id=E7 maxlength=20 required validation-no-hyperlink validation-no-number name=last_name ng-model=\" vm.loginnedUser.last_name\" class=form-control></div><div class=\"form-group col-sm-12 no-padding\" class=sign-up-register-information-modal__country-select ng-if=\"vm.currentState.step == 2\" ng-class=\"{\'place-holder\': ! vm.loginnedUser.address.country}\"><label for=country class=label-sign-up-information ng-class=\"!profileForm.$pristine && profileForm.country.$invalid ? \'text--color-error\' : \'text--color-black\'\" translate>{{\'country-of-origin\'}}</label><country-select on-changed=\"vm.onCountrySelected( vm.loginnedUser.address.country)\" place-holder=\"Select country\" id=E9 class=form-control required name=country ng-model=\" vm.loginnedUser.address.country\"></country-select></div><div class=\"form-group col-sm-12 no-padding\" class=sign-up-register-information-modal__country-select ng-class=\"{\'place-holder\': ! vm.loginnedUser.address.country}\" ng-if=\"vm.currentState.step == 3\"><label for=location class=label-sign-up-information ng-class=\"!profileForm.$pristine && profileForm.location.$invalid ? \'text--color-error\' : \'text--color-black\'\">{{\'city\' | translate}}/{{\'state\' | translate}}</label><input id=E10 required validation-no-hyperlink name=location ng-model=\" vm.loginnedUser.location\" class=form-control g-places-autocomplete options=vm.gplacesOptions></div><div class=\"form-group col-sm-12 no-padding\" ng-show=\"vm.currentState.step == 4\"><label for=birthday class=label-sign-up-information ng-class=\"!profileForm.$pristine && vm.invalidBirthday ? \'text--color-error\' : \'text--color-black\'\" translate>{{\'birth-date\'}}</label><div class=\"input-group pixerf-calendar-input date-picker-full-width\"><input type=text datepicker-options=\"{showWeeks: false}\" show-button-bar=false name=birthday id=birthday uib-datepicker-popup=d/MM/yyyy ng-model=\" vm.loginnedUser.date_of_birth\" ng-change=vm.validateDOB(profileForm) is-open=vm.filterFromIsVisible> <button type=button class=\"btn pixerf-calendar-input__toogle-btn\" ng-click=\"vm.filterFromIsVisible = !vm.filterFromIsVisible\"><i class=\"glyphicon glyphicon-calendar\"></i></button></div><div class=form-group__subscribe translate translate-values=\"{number: 18}\">{{\'signup-18\'}}</div></div><div class=\"complete-profile-skills__form__group form-group col-sm-12 group-speciality row\" ng-show=\"vm.currentState.step == 5\"><label for=speciality translate>{{\'photography-specialisations\'}}</label><dropdown-tag ng-if=vm.specialities max-selected={{vm.maxSpecialitiesSelected}} data=vm.specialities on-item-removed=\"vm.onItemChanged({items, item})\" on-item-selected=\"vm.onItemChanged({items, item})\" on-exceed-limit=vm.onExccedLimit() on-init=vm.serviceData.specialities></dropdown-tag><div class=form-group__hint translate=select-specialisations translate-values=\"{number: 5}\"></div></div></form><div class=confirm-invite-by-link-popup__body__navigate-btn ng-if=\"(vm.currentState.state == 3) && (vm.currentState.actor == \'Contributor\')\"><button class=\"btn btn-submit btn-upload-photo\" ng-click=vm.onUploadYourPhotosBtnClicked() translate>{{\'upload-your-photos\'}}</button> <button class=\"btn btn-back btn-upload-porfolio\" ng-click=vm.onUploadYourPorfolioBtnClicked() translate>{{\'upload your portfolio\'}}</button></div><spinner-win spinner=vm.spinner></spinner-win></div><div class=confirm-invite-by-link-popup__footer ng-if=\"vm.currentState.state != 3\"><div class=confirm-invite-by-link-popup__footer__steps ng-if=\"vm.currentState.state == 2\"><span ng-repeat=\"step in vm.StateData[2][vm.currentState.actor]\" class=confirm-invite-by-link-popup__footer__step ng-class=\"{\'active\': $index == (vm.currentState.step - 1)}\"></span></div><button class=\"btn btn-submit btn-next\" ng-disabled=\"!vm.canNext(profileForm, profileFormBiz)\" ng-click=vm.onNextBtnClicked()>Join event</button> <button class=\"btn btn-back\" ng-if=\"vm.canBack(profileForm, profileFormBiz)\" ng-click=vm.onBackBtnClicked()>Cancel</button></div></div></div>");
$templateCache.put("app/components/complete-profile-popup/complete-profile-popup.html","<div class=complete-profile-popup><button type=button class=close ng-click=vm.cancel()><span class=icon-icons_close aria-hidden=true></span></button><div class=clearfix><div class=\"complete-profile-popup__header clearfix\"><div class=\"complete-profile-popup__header__title text--extrabold text--color-black\">{{vm.currentStep.title}}</div><div class=complete-profile-popup__header__desc ng-hide=\"(vm.currentState.state == 3) && (vm.currentState.actor == \'Contributor\') && vm.processGuestUser\" ng-bind-html=vm.currentStep.desc></div><div class=complete-profile-popup__header__desc ng-show=\"(vm.currentState.state == 3) && (vm.currentState.actor == \'Contributor\') && vm.processGuestUser\"><span translate>{{\'showcase-your-works-and\'}}</span> <a ng-click=vm.hidePopup() ui-sref=buy-stock-page.trending href=#/marketplace/photos class=\"text--bold text--color-pixerf-theme\">now</a>.</div></div><div class=complete-profile-popup__body><div ng-if=\"vm.currentState.state == 1\" class=complete-profile-popup__body__select-user-type><div class=\"user-type__select item-{{$index}}\" ng-repeat=\"userType in vm.StateData[1][1].data\" ng-class=\"{\'selected\': userType.key == vm.loginnedUser.account_type}\" ng-click=vm.onUserTypeClicked(userType)><div class=\"user-type__header text--extrabold text--color-black\">{{userType.title}}</div><div class=user-type__desc>{{userType.desc}}</div></div></div><div ng-if=\"vm.currentState.state == 2 && vm.currentState.actor ==\'Business\'\"></div><form name=profileFormBiz id=profileFormBiz class=\"clearfix profile-form-biz\" ng-show=\"vm.currentState.state == 2 && vm.currentState.actor ==\'Business\'\"><div class=\"form-group email-wrapper\" ng-if=\"vm.currentState.step == 1\"><label for=name ng-class=\"!profileFormBiz.$pristine && profileFormBiz.name.$invalid ? \'text--color-error\' : \'text--color-black\'\" translate>{{\'full-name\'}}</label><input maxlength=255 name=name required ng-model=\" vm.loginnedUser.first_name\" type=text class=form-control></div><div class=form-group ng-if=\"vm.currentState.step == 2\"><label for=company ng-class=\"!profileFormBiz.$pristine && profileFormBiz.company.$invalid ? \'text--color-error\' : \'text--color-black\'\" translate>{{\'company-name\'}}</label><input name=company validation-no-hyperlink ng-model=\" vm.loginnedUser.organization.name\" class=form-control required></div><div class=form-group ng-if=\"vm.currentState.step == 3\"><label for=officeType ng-class=\"!profileFormBiz.$pristine && profileFormBiz.officeType.$invalid ? \'text--color-error\' : \'text--color-black\'\" translate>{{\'office-type\'}}</label><select name=officeType class=form-control required ng-model=vm.loginnedUser.organization.office_type><option ng-repeat=\"opt in vm.officeTypes.data\" value={{opt.id}} ng-selected=\"{{(opt.id == vm.loginnedUser.organization.office_type) ? \'selected\' : \'\'}}\">{{opt.name}}</option></select></div><div class=form-group ng-if=\"vm.currentState.step == 4\"><label for=registration ng-class=\"!profileFormBiz.$pristine && profileFormBiz.registration.$invalid ? \'text--color-error\' : \'text--color-black\'\" translate>{{\'company-registration-no\'}}</label><input required name=registration validation-no-hyperlink ng-model=\" vm.loginnedUser.organization.registration_no\" class=form-control></div><div class=form-group ng-if=\"vm.currentState.step == 5\"><label for=country ng-class=\"!profileFormBiz.$pristine && profileFormBiz.country.$invalid ? \'text--color-error\' : \'text--color-black\'\">Country you are operating from</label><country-select class=form-control required name=country ng-model=\" vm.loginnedUser.organization.address.country\" placeholder=Country></country-select></div><div class=\"form-group col-sm-12 no-padding\" class=sign-up-register-information-modal__country-select ng-class=\"{\'place-holder\': ! vm.loginnedUser.address.country}\" ng-if=\"vm.currentState.step == 6\"><label for=location class=label-sign-up-information ng-class=\"!profileFormBiz.$pristine && profileFormBiz.location.$invalid ? \'text--color-error\' : \'text--color-black\'\">{{\'city\' | translate}}/{{\'state\' | translate}}</label><input id=E10 required validation-no-hyperlink name=location ng-model=vm.loginnedUser.location class=form-control g-places-autocomplete options=vm.gplacesOptions></div></form><form name=profileForm id=profileForm class=\"clearfix profile-form\" ng-show=\"vm.currentState.state == 2 && vm.currentState.actor ==\'Contributor\'\"><div class=\"form-group first-name-field col-sm-6\" ng-if=\"vm.currentState.step == 1\"><label for=first_name class=label-sign-up-information ng-class=\"!profileForm.$pristine && profileForm.first_name.$invalid ? \'text--color-error\' : \'text--color-black\'\" translate>{{\'first-name\'}}</label><input id=E6 maxlength=20 required validation-no-hyperlink validation-no-number name=first_name ng-model=\" vm.loginnedUser.first_name\" class=form-control required focus-me=vm.isFocusField.data></div><div class=\"form-group last-name-field col-sm-6\" ng-if=\"vm.currentState.step == 1\"><label for=last_name class=label-sign-up-information ng-class=\"!profileForm.$pristine && profileForm.last_name.$invalid ? \'text--color-error\' : \'text--color-black\'\" translate>{{\'last-name\'}}</label><input id=E7 maxlength=20 required validation-no-hyperlink validation-no-number name=last_name ng-model=\" vm.loginnedUser.last_name\" class=form-control></div><div class=\"form-group col-sm-12 no-padding\" class=sign-up-register-information-modal__country-select ng-if=\"vm.currentState.step == 2\" ng-class=\"{\'place-holder\': ! vm.loginnedUser.address.country}\"><label for=country class=label-sign-up-information ng-class=\"!profileForm.$pristine && profileForm.country.$invalid ? \'text--color-error\' : \'text--color-black\'\" translate>{{\'country-of-origin\'}}</label><country-select on-changed=\"vm.onCountrySelected( vm.loginnedUser.address.country)\" place-holder=\"Select country\" id=E9 class=form-control required name=country ng-model=\" vm.loginnedUser.address.country\"></country-select></div><div class=\"form-group col-sm-12 no-padding\" class=sign-up-register-information-modal__country-select ng-class=\"{\'place-holder\': ! vm.loginnedUser.address.country}\" ng-if=\"vm.currentState.step == 3\"><label for=location class=label-sign-up-information ng-class=\"!profileForm.$pristine && profileForm.location.$invalid ? \'text--color-error\' : \'text--color-black\'\">{{\'city\' | translate}}/{{\'state\' | translate}}</label><input id=E10 required validation-no-hyperlink name=location ng-model=\" vm.loginnedUser.location\" class=form-control g-places-autocomplete options=vm.gplacesOptions></div><div class=\"form-group col-sm-12 no-padding\" ng-show=\"vm.currentState.step == 4\"><label for=birthday class=label-sign-up-information ng-class=\"!profileForm.$pristine && vm.invalidBirthday ? \'text--color-error\' : \'text--color-black\'\" translate>{{\'birth-date\'}}</label><div class=\"input-group pixerf-calendar-input date-picker-full-width\"><input type=text datepicker-options=\"{showWeeks: false}\" show-button-bar=false name=birthday id=birthday uib-datepicker-popup=d/MM/yyyy ng-model=\" vm.loginnedUser.date_of_birth\" ng-change=vm.validateDOB(profileForm) is-open=vm.filterFromIsVisible> <button type=button class=\"btn pixerf-calendar-input__toogle-btn\" ng-click=\"vm.filterFromIsVisible = !vm.filterFromIsVisible\"><i class=\"glyphicon glyphicon-calendar\"></i></button></div><div class=form-group__subscribe translate translate-values=\"{number: 18}\">{{\'signup-18\'}}</div></div><div class=\"complete-profile-skills__form__group form-group col-sm-12 group-speciality row\" ng-show=\"vm.currentState.step == 5\"><label for=speciality translate>{{\'photography-specialisations\'}}</label><dropdown-tag ng-if=vm.specialities max-selected={{vm.maxSpecialitiesSelected}} data=vm.specialities on-item-removed=\"vm.onItemChanged({items, item})\" on-item-selected=\"vm.onItemChanged({items, item})\" on-exceed-limit=vm.onExccedLimit() on-init=vm.serviceData.specialities></dropdown-tag><div class=form-group__hint translate=select-specialisations translate-values=\"{number: 5}\"></div></div></form><div class=complete-profile-popup__body__navigate-btn ng-if=\"(vm.currentState.state == 3) && (vm.currentState.actor == \'Contributor\')\"><button class=\"btn btn-submit btn-upload-photo\" ng-if=vm.processGuestUser ng-click=vm.onUploadYourPhotosBtnClicked() translate>{{\'upload-your-photos\'}}</button> <button class=\"btn btn-back btn-upload-porfolio\" ng-if=vm.processGuestUser ng-click=vm.onUploadYourPorfolioBtnClicked() translate>{{\'upload your portfolio\'}}</button> <button class=\"btn btn-submit btn-close-popup\" ng-if=!vm.processGuestUser ng-click=vm.cancel() translate>{{\'close\'}}</button></div><spinner-win spinner=vm.spinner></spinner-win></div><div class=complete-profile-popup__footer ng-if=\"vm.currentState.state != 3\"><div class=complete-profile-popup__footer__steps ng-if=\"vm.currentState.state == 2\"><span ng-repeat=\"step in vm.getSteps()\" class=complete-profile-popup__footer__step ng-class=\"{\'active\': $index == (!vm.processGuestUser && vm.isBusinessType() ? (vm.currentState.step - 4) : (vm.currentState.step - 1))}\"></span></div><button class=\"btn btn-submit btn-next\" ng-disabled=\"!vm.canNext(profileForm, profileFormBiz)\" ng-click=vm.onNextBtnClicked() translate>{{vm.isSaveingStep() ? \'save\' : \'next\'}}</button> <button class=\"btn btn-back\" ng-if=\"vm.canBack(profileForm, profileFormBiz)\" ng-click=vm.onBackBtnClicked() translate>{{\'back\'}}</button></div></div></div>");
$templateCache.put("app/components/confirm-popup/confirm-popup.html","<div class=confirm-popup><div ng-hide=vm.hideCloseBtn class=\"confirm-popup__remove icon-icons_close\" ng-click=vm.onCancel()></div><div ng-if=vm.title class=confirm-popup__header>{{vm.title}}</div><div class=confirm-popup__body compile=\"vm.message | translate\"></div><div class=confirm-popup__footer><button ng-hide=vm.hideCancelBtn ng-click=vm.onCancel() class=\"confirm-popup__footer__cancel-btn btn btn--transparent\" ng-disabled=vm.isWorking>{{vm.cancelBtnText}}</button> <button ng-hide=vm.hideSubmitBtn ng-click=vm.onSubmit() class=\"confirm-popup__footer__submit-btn btn btn-submit\" ng-disabled=vm.isWorking>{{vm.submitBtnText}}</button></div></div>");
$templateCache.put("app/components/confirm-popup-download-hires/confirm-popup-download-hires.html","<div class=confirm-popup-download-hires__container><div class=confirm-popup-download-hires__container__text>Once you download the high resolution photos, this Custom Commission will be completed.<br>Would you like to proceed with the download of the final photos</div><div class=\"confirm-popup-download-hires__container__footer clearfix\"><button class=\"confirm-popup-download-hires__container__footer__cancel-btn btn btn-cancel--no-background\" ng-click=vm.closePopup()>Cancel</button> <button class=\"confirm-popup-download-hires__container__footer__confirm-btn btn btn-submit\" ng-click=vm.onDownloadClicked()>Yes</button></div></div>");
$templateCache.put("app/components/confirm-success-popup/confirm-success-popup.html","<div class=confirm-succes-popup><div ng-hide=vm.hideCloseBtn class=\"confirm-succes-popup__remove icon-icons_close\" ng-click=vm.onCancel()></div><div class=confirm-succes-popup__body><div class=confirm-succes-popup__body__icon ng-class=\"vm.isWarning ? \'icon-warning-circle\' : \'icon-checked_full_circle\'\"></div><div class=confirm-succes-popup__body__message compile=\"vm.message | translate\"></div></div></div>");
$templateCache.put("app/components/confirm-within-icon-popup/confirm-within-icon-popup.html","<div class=confirm-within-icon-popup><div class=\"confirm-within-icon-popup__icon {{vm.icon}}\"></div><div class=confirm-within-icon-popup__header ng-bind-html=vm.title></div><div class=confirm-within-icon-popup__body ng-bind-html=vm.description></div><div class=confirm-within-icon-popup__footer><button ng-click=vm.onCancel() class=\"confirm-within-icon-popup__footer__cancel-btn btn btn--transparent\" ng-disabled=vm.isWorking>{{vm.cancelBtnText}}</button> <button ng-click=vm.onSubmit() class=\"confirm-within-icon-popup__footer__submit-btn btn btn-submit\" ng-disabled=vm.isWorking>{{vm.submitBtnText}}</button></div></div>");
$templateCache.put("app/components/countries-dropdown/countries-dropdown.html","<div class=countries-dropdown><pixerf-input-auto-complete ng-if=vm.countries name=countries dropdown-class=\"countries-dropdown__list countries {{dropdownClass}}\" options=vm.options data=vm.countries model=vm.countriesSelected on-changed=onChanged(vm.countriesSelected)></pixerf-input-auto-complete></div>");
$templateCache.put("app/components/create-community-album-popup/create-community-album-popup.html","<div class=create-community-album-popup><div class=\"create-community-album-popup__close icon-icons_close\" ng-click=vm.close()></div><div class=create-community-album-popup__header>Create Community Albums</div><div class=create-community-album-popup__content><form name=createAlbumForm class=create-community-album-popup__form><label class=create-community-album-popup__label translate>{{\'name\'}}</label><input name=name required ng-model=vm.album.name placeholder=\"Give this album a name\" type=text class=create-community-album-popup__input></form></div><div class=create-community-album-popup__footer><button ng-click=vm.close() type=button class=\"btn btn-cancel\">{{\'cancel\' | translate}}</button> <button ng-disabled=createAlbumForm.title.$error.required ng-click=vm.onCreateCommunityAlbum() type=button class=\"create-community-album-popup__create-btn btn btn-submit\">{{vm.albumId ? \'Update\' : \'Create\'}}</button></div></div>");
$templateCache.put("app/components/create-community-form/create-community-form.html","<div class=\"create-community-form clearfix\"><!-- <div class=\"create-community-form__avatar-wrapper\" ng-if=\"!vm.options.hideAvatar\">\r\n		<pixerf-avatar options=\"vm.uploadCommunityAvatarOptions\" avatar=\"vm.community.avatar\"\r\n			on-init=\"vm.onInit({dropzone: dropzone})\"></pixerf-avatar>\r\n	</div> --><div class=create-community-form__info-form-wrapper><form name=vm.form class=text-left><!-- <div ng-if=\"vm.community.cover && vm.community.cover.medium\" class=\"create-community-form__cover-photo-wrapper\" ng-click=\"vm.showUploadUserProfilePhotos(\'cover\')\">\r\n				<div class=\"hover-cover-style\">Change cover</div>\r\n				<img ng-src=\"{{ vm.community.cover.medium }}\">\r\n			</div> --><div class=create-event-popup__general__upload><div ng-if=\"vm.communityCover && vm.communityCover.url\" class=overlay-reselect ng-click=vm.showUploadAvatarPopup()><button class=\"btn btn-submit create-event-popup__general__upload__edit\">Edit</button></div><div ng-if=\"vm.communityCover && vm.communityCover.url\" class=create-event-popup__general__upload__thumbnail-section ng-class=\"{\'thumbnail-section-highlight\': vm.highlight && vm.highlight.coverimage}\"><img class=create-event-popup__general__upload__thumbnail-section__image ng-src={{vm.communityCover.url}}></div><div ng-if=\"!vm.communityCover || !vm.communityCover.url\" class=create-event-popup__general__upload__submit-btn ng-click=vm.showUploadAvatarPopup()><div class=\"btn btn-submit\">{{\'add-cover-photo\' | translate}}</div></div></div><div class=form-group><label class=create-community-form__label ng-class=\"{\'highlight-section\': vm.highlight && vm.highlight.communityname}\" translate>{{\'community-name\'}}</label><input placeholder=\"E.g. Foodie Photographers Club, Penang Buddies\" name=name required ng-model=vm.community.name type=text class=\"form-control create-community-form__name\" ng-change=\"vm.onChangeModel(\'communityname\')\" ng-class=\"{\'highlight-section\': vm.highlight && vm.highlight.communityname}\"></div><div class=\"form-group create-community-form__description\"><label class=create-community-form__label ng-class=\"{\'highlight-section\': vm.highlight && vm.highlight.description}\" translate>{{\'about-this-community\'}}</label><textarea validation-no-hyperlink required rows=7 name=description type=text ng-class=\"{\'highlight-section\': vm.highlight && vm.highlight.description}\" ng-change=\"vm.onChangeModel(\'description\')\" ng-model=vm.community.description placeholder=\"{{\'about-this-community-placeholder\' | translate}}\" class=form-control></textarea></div><div class=\"form-group create-community-form__country\"><label class=create-community-form__label><span translate>{{\'select-a-region-or-countries\'}} </span><span class=\"icon-icons-info form-group create-community-form__country__tooltip\" tooltip-placement=bottom-right tooltip-trigger=\"\'outsideClick\'\" uib-tooltip-html=\"\'check-out-community-faq\' | translate\"></span></label><custom-radio-button default={{vm.countryRegion.selectedRegion}} class=\"form-group create-community-form__country__region__country-region\" ng-class=\"{\'disabled\': vm.countryRegion.selectedCountry}\" model=vm.countryRegion options=vm.countryRegionOptions model-property=selected value=vm.countryRegionOptions.selections[0].value label=vm.countryRegionOptions.selections[0].label on-changed=vm.onselectedRegionChanged()></custom-radio-button><div ng-if=vm.countryRegion.selectedRegion class=\"form-group create-community-form__country__region-list\"><custom-radio-button ng-repeat=\"item in vm.regionOptions.selections\" default=\"{{(item.value == vm.defaultRegionOption.value) ? \'true\' : \'false\'}}\" class=\"form-group create-community-form__country__region__item\" model=vm.region options=vm.regionOptions model-property={{vm.regionOptions.props}} value=vm.regionOptions.selections[$index].value label=vm.regionOptions.selections[$index].label on-changed=vm.onArrageChanged(data)></custom-radio-button></div><div class=\"form-group create-community-form__country__line-or\"><span class=create-community-form__country__line-or__text>Or</span></div><custom-radio-button default={{vm.countryRegion.selectedCountry}} class=\"form-group create-community-form__country__region__country-region\" ng-class=\"{\'disabled\': vm.countryRegion.selectedRegion}\" model=vm.countryRegion options=vm.countryRegionOptions model-property=selected value=vm.countryRegionOptions.selections[1].value label=vm.countryRegionOptions.selections[1].label on-changed=vm.onselectedCountryChanged()></custom-radio-button><pixerf-input-auto-complete ng-if=vm.countryRegion.selectedCountry dropdown-class=create-community-form__country-dropdown class=\"form-group create-community-form__country__country-dropdown\" options=vm.countriesOpts name=countries data=vm.countries model=vm.selectedCountries on-changed=vm.onCountriesSelected()></pixerf-input-auto-complete></div><div class=form-group><label class=create-community-form__label translate>{{\'set-your-group-privacy-settings\'}}</label><mutiline-dropdown items=vm.privacyTypes selected=vm.defaultPrivacyType on-changed=vm.onPrivacyTypeChanged(data)></mutiline-dropdown></div><div class=form-group><label class=create-community-form__label translate>{{\'permissions-to-create-post\'}}</label><mutiline-dropdown items=vm.postingTypes selected=vm.defaultPostingType on-changed=vm.onPostingTypeChanged(data)></mutiline-dropdown></div><div ng-if=vm.canConfigmoderation class=form-group><label class=create-community-form__label translate>{{\'post-approval\'}}</label><mutiline-dropdown items=vm.moderationType selected=vm.defaultModerationType on-changed=vm.onModerationTypeChanged(data)></mutiline-dropdown></div><div class=\"form-group create-community-form__rule\"><label class=create-community-form__label ng-class=\"{\'highlight-section\': vm.highlight && vm.highlight.communityrules}\">{{\'community-rules\' | translate}} <span class=create-community-form__option-label>({{\'optional\' | translate}})</span></label><textarea validation-no-hyperlink rows=7 name=rule type=text ng-class=\"{\'highlight-section\': vm.highlight && vm.highlight.communityrules}\" ng-change=\"vm.onChangeModel(\'communityrules\')\" ng-model=vm.community.rules class=form-control placeholder=\"{{\'community-rule-placeholder\' | translate}}\">\r\n				</textarea></div></form></div></div>");
$templateCache.put("app/components/create-community-popup/create-community-popup.html","<div class=create-community-popup><div class=clearfix><button ng-disabled=vm.isWorking type=button class=close ng-click=vm.onCloseBtnClicked()><span class=icon-icons_close aria-hidden=true></span></button><div class=\"modal-header text-left\"><h1 class=\"modal--title text-left\" translate>{{vm.currentStep.title}}</h1></div><div class=\"modal-body text-center\"><slick initonloadng-class=\"{\'slick-slider--is-last-slide\': vm.isLastSlide}\" dots=false on-init=vm.slickSetting.onInit(slick) custom-paging=\"vm.slickSetting.customPaging(slick, index)\" append-dots={{vm.slickSetting.appendDots}} adaptive-height=true infinite=false dots=true slides-to-show=1 swipe=false on-before-change=\"vm.slickSetting.onBeforeChange(event, slick, currentSlide, nextSlide)\" on-after-change=\"vm.slickSetting.onAfterChange(event, slick, currentSlide)\" arrows=false disable=vm.slickSetting.disable><div><create-community-form community=vm.community mode=\"\'EDIT\'\" form=vm.createCommunityForm on-change=vm.formOnChange(name) on-init=vm.onAvatarChanged(dropzone) dropzone-instance=vm.dropzoneInstance uploading=vm.isPhotoUploading></create-community-form><div class=create-community-popup__tnc-agreement><pixerf-checkbox error=!vm.isAgreedTnC model=vm model-property=isAgreedTnC></pixerf-checkbox><div class=create-community-popup__tnc-agreement__agreement-sentence translate>{{\'i-agree-community-agreement\'}}</div></div></div><div class=create-community-popup__basic-info-step ng-if=\"vm.popupData.mode !== \'EDIT\' || vm.popupData.step === \'INVITE_MEMBERS\'\"><div><community-member-filter on-changed=vm.onSearchConditionChanged(searchCondition) options=vm.searchFilterOptions></community-member-filter><person-list-selection ng-show=\"vm.layout === \'listPeople\'\" on-init=vm.onPersonListInit(instance) class=create-community-popup__people-list on-selected-status-changed=vm.onPersonSelected()>No Records match search condition!</person-list-selection><div class=create-community-popup__invite-email-wrapper ng-show=\"vm.layout === \'listEmail\'\"><div class=\"create-community-popup__email-input clearfix\"><button class=\"create-community-popup__email-input__invite-btn btn btn-submit\" ng-click=vm.onAddToInviteList(vm.newEmail) ng-disabled=!vm.newEmail>Add</button><div class=create-community-popup__email-input__control><input type=email ng-model=vm.newEmail class=form-control placeholder=\"Email address\"></div></div><div class=\"create-community-popup__invite-email clearfix\" ng-click=vm.onGmailClicked()><div class=\"email-icon email-icon__gmail\"></div><div class=create-community-popup__invite-email__label>Invite your Gmail contacts</div></div><div class=\"create-community-popup__invite-email clearfix\" ng-click=vm.onOutlookClicked()><div class=\"email-icon email-icon__outlook\"></div><div class=create-community-popup__invite-email__label>Invite your Outlook contacts</div></div><div class=\"create-community-popup__list-new-invitation clearfix\"><div class=\"create-community-popup__list-new-invitation__new-member clearfix\" ng-repeat=\"contact in vm.invitedList\"><div class=create-community-popup__list-new-invitation__new-member__address>{{contact}}</div><div class=\"create-community-popup__list-new-invitation__new-member__icon icon-icons_close\" ng-click=vm.onContactRemove(contact)></div></div></div></div></div></div></slick></div><div class=modal-footer><a ng-click=vm.onCancelBtnClicked(vm.community) class=create-community-popup__cancel-btn>{{vm.currentStep.cancelBtnLabel}}</a> <button ng-disabled=\"vm.isWorking || createCommunityForm.name.$error.required || !vm.isSelectedLocation || vm.isPhotoUploading || !vm.isAgreedTnC\" ng-click=vm.onNextBtnClicked(vm.community,createCommunityForm) type=button class=\"btn btn-submit\" loading-spinner ng-class=\"{\'is-working\': vm.isPhotoUploading}\">{{vm.submitBtnLabel}}</button></div></div></div>");
$templateCache.put("app/components/create-discussion-topic-popup/create-discussion-topic-popup.html","<div class=create-discussion-topic-popup><div class=create-discussion-topic-popup__content><div class=\"create-discussion-topic-popup__close-btn icon-icons_close\" ng-click=vm.dismiss()></div><div class=create-discussion-topic-popup__title translate>{{vm.popupHeader}}</div><div class=create-discussion-topic-popup__body><pixerf-user-avatar class=create-discussion-topic-popup__body__avatar user-data=vm.loginUser lazy=true></pixerf-user-avatar><form name=createDiscussionForm class=create-discussion-topic-popup__body__form><div class=create-discussion-topic-popup__body__form__row><label class=create-discussion-topic-popup__body__form__row__label translate>{{\'subject\'}}</label><input name=subject required type=text class=create-discussion-topic-popup__body__form__subject-input ng-model=vm.discussion.subject placeholder=\"{{\'Whats-on-your-mind-today\' | translate}}\"></div><div class=create-discussion-topic-popup__body__form__row><div class=create-discussion-topic-popup__body__form__row__label translate>{{\'description\'}}</div><div class=create-discussion-topic-popup__description-box ng-class=\"{\'ng-invalid\': createDiscussionForm.description.$invalid}\"><textarea textarea-auto-expand name=description required class=create-discussion-topic-popup__body__form__description-input rows=4 ng-model=vm.discussion.description placeholder=\"{{\'share-a-little-more\' | translate}}\"></textarea><div class=create-discussion-topic-popup__photos-attachment><div class=create-discussion-topic-popup__photos-attachment__existing-photo ng-if=\"vm.discussion.photos && vm.discussion.photos.length\"><div ng-repeat=\"photo in vm.discussion.photos\" class=create-discussion-topic-popup__photos-attachment__existing-photo__item><img ng-src={{photo.url.thumbnail}}></div></div><div id=create-discussion-topic-popup__attach-photos-section class=create-discussion-topic-popup__attach pixerf-dropzone dropzone=vm.dropzoneConfig.instance dropzone-config=vm.dropzoneConfig.options event-handlers=vm.dropzoneConfig.eventHandlers><div class=create-discussion-topic-popup__attach-more ng-hide=!vm.showAttachPhotoBtn>+</div></div></div></div></div></form></div><div class=create-discussion-topic-popup__body__control><button ng-hide=\"vm.isUpdateMode && vm.isDraftDiscussion\" ng-disabled=!vm.showAttachPhotoBtn id=create-discussion-topic-popup__attach-photo-button class=\"create-discussion-topic-popup__body__control__private-control btn btn--transparent\">{{\'add-photos\' | translate}}</button><div ng-if=vm.isDraftDiscussion ng-click=vm.onRemoveDiscussion() class=\"create-discussion-topic-popup__body__control__private-control btn btn--transparent visibility-hidden\">{{\'delete-draft\' | translate}}</div><div class=create-discussion-topic-popup__body__control__action-wrapper><!-- <button ng-if=\"!vm.isUpdateMode && !vm.isDraftDiscussion\"\r\n					class=\"create-discussion-topic-popup__body__control__remove btn btn--transparent\"\r\n					ng-click=\"vm.saveDraftDiscussion()\" loading-spinner ng-class=\"{\'is-working\': vm.isAttachmentUploading}\"\r\n					ng-disabled=\"vm.isAttachmentUploading\">{{\'save-as-draft\' | translate}}</button>\r\n				<button ng-if=\"vm.isUpdateMode && vm.isDraftDiscussion\"\r\n					class=\"create-discussion-topic-popup__body__control__remove btn btn--transparent\"\r\n					ng-click=\"vm.updateDraftDiscussion()\" loading-spinner ng-class=\"{\'is-working\': vm.isAttachmentUploading}\"\r\n					ng-disabled=\"vm.isAttachmentUploading\">{{\'save-as-draft\' | translate}}</button> --> <button ng-if=vm.isUpdateMode class=\"create-discussion-topic-popup__body__control__remove btn btn--transparent\" ng-click=vm.onRemoveDiscussion()>{{\'remove\' | translate}}</button> <button ng-if=!vm.isUpdateMode class=\"create-discussion-topic-popup__body__control__update btn btn-submit\" ng-click=vm.onCreateDiscussion(createDiscussionForm) loading-spinner ng-class=\"{\'is-working\': vm.isAttachmentUploading}\" ng-disabled=vm.isAttachmentUploading>{{\'create\' | translate}}</button> <button ng-if=\"vm.isUpdateMode && vm.isDraftDiscussion\" class=\"create-discussion-topic-popup__body__control__update btn btn-submit\" ng-click=\"vm.onUpdateDiscussion(true, createDiscussionForm)\" loading-spinner ng-class=\"{\'is-working\': vm.isAttachmentUploading}\" ng-disabled=vm.isAttachmentUploading>{{\'publish\' | translate}}</button> <button ng-if=\"vm.isUpdateMode && !vm.isDraftDiscussion\" class=\"create-discussion-topic-popup__body__control__update btn btn-submit\" ng-click=\"vm.onUpdateDiscussion(false, createDiscussionForm)\" loading-spinner ng-class=\"{\'is-working\': vm.isAttachmentUploading}\" ng-disabled=vm.isAttachmentUploading>{{\'update\' | translate}}</button></div></div></div></div>");
$templateCache.put("app/components/create-event-popup/create-event-popup.html","<div class=create-event-popup><div class=\"create-event-popup__close-icon icon-icons_close\" ng-click=vm.onCancelCreateEvent()></div><form name=createEventForm><section class=create-event-popup__general><div class=create-event-popup__general__header>{{ vm.event.id ? \'Edit Event/Class\' : \'Create Event/Class\'}}</div><div class=create-event-popup__general__upload><div ng-if=\"vm.eventCover && vm.eventCover.url\" class=overlay-reselect ng-click=vm.showUploadAvatarPopup()><button class=\"btn btn-submit\">Reselect</button></div><div ng-if=\"vm.eventCover && vm.eventCover.url\" class=create-event-popup__general__upload__thumbnail-section><img class=create-event-popup__general__upload__thumbnail-section__image ng-src=\"{{vm.eventCover.url ?  vm.eventCover.url : \'/assets/images/default/community-default-avatar.png\'}}\"></div><div ng-if=\"!vm.eventCover || !vm.eventCover.url\" class=create-event-popup__general__upload__submit-btn ng-click=vm.showUploadAvatarPopup()><div class=\"btn btn-submit\">{{\'select-photo\' | translate}}</div></div></div><div class=create-event-popup__general__label>About</div><div class=create-event-popup__general__about-text>{{\'please-note-that-this-event-will\' | translate}}</div><div class=create-event-popup__general__name__wrapper><div class=create-event-popup__post-creation__event-type><mutiline-dropdown items=vm.eventTypes selected=vm.defaultEventType on-changed=vm.onEventTypeChanged(data)></mutiline-dropdown></div></div><div class=create-event-popup__general__name__wrapper><label for=name class=create-event-popup__general__name__label ng-class=\"(!createEventForm.$pristine || vm.event.id) && createEventForm.name.$invalid ? \'text--color-error\' : \'text--color-black\'\">Event/Class Name</label><input type=text placeholder=\"E.g. Drone Photography Workshop\" name=name class=create-event-popup__general__name__input ng-model=vm.event.name required></div><div class=create-event-popup__general__name__wrapper ng-if=section.event.community_id><label for=name class=create-event-popup__general__name__label ng-class=\"(!createEventForm.$pristine || vm.event.id) && createEventForm.name.$invalid ? \'text--color-error\' : \'text--color-black\'\">Hosted by</label><mutiline-dropdown items=vm.communities selected=vm.defaultCommunity on-changed=vm.onCommunityChanged(data)></mutiline-dropdown></div><div class=create-event-popup__general__description__wrapper><div class=create-event-popup__general__description__label>Description</div><textarea name=description cols=30 rows=10 placeholder=\"What is your event/class about? Who is it for?\" class=create-event-popup__general__description__input ng-model=vm.event.description></textarea></div></section><section class=create-event-popup__details><div class=create-event-popup__details__label>Details</div><div class=create-event-popup__details__location ng-if=!vm.event.is_online><div class=create-event-popup__details__location__overall><label for=location class=create-event-popup__details__location__label ng-class=\"(!createEventForm.$pristine || vm.event.id) && createEventForm.location.$invalid ? \'text--color-error\' : \'text--color-black\'\">Location</label><input type=text name=location class=create-event-popup__details__location__input placeholder=\"e.g. street, city, country, post code\" g-places-autocomplete ng-model=vm.event.location required></div><div class=create-event-popup__details__location__venue><label for=location class=create-event-popup__details__location__label>Venue</label><input type=text name=venue class=create-event-popup__details__location__input placeholder=\"e.g. floor number, room number\" ng-model=vm.event.venue></div><div class=create-event-popup__details__location__link><div class=create-event-popup__details__online-event__checkbox-group><span class=create-event-popup__details__online-event__checkbox-group__label>Registration or Broadcast Link <span class=create-event-popup__details__online-event__checkbox-group__label-info>(optional)</span> </span><input type=text placeholder=\"Registration or Broadcast Link\" name=broadcast_url class=create-event-popup__details__online-event__input ng-model=vm.event.broadcast_url></div></div></div><div class=create-event-popup__details__online-event><label for=name class=create-event-popup__details__online-event__label><stick-checkbox on-changed=\"\" model=vm.event is-disabled=vm.disableOnlineEvent class=create-event-popup__details__online-event__checkbox model-property=is_online label=\"\"></stick-checkbox>This is an online event/class.</label><div class=create-event-popup__details__online-event__checkbox-group ng-if=vm.event.is_online><span class=create-event-popup__details__online-event__checkbox-group__label>Registration or Broadcast Link</span> <input type=text placeholder=\"Registration or Broadcast Link\" name=broadcast_url class=create-event-popup__details__online-event__input ng-model=vm.event.broadcast_url required></div></div><div class=create-event-popup__details__time ng-repeat=\"dateTime in vm.dateTimes\"><div ng-if=\"vm.dateTimes.length > 1\" class=\"create-event-popup__details__time__remove-icon icon-icons_close\" ng-click=vm.onRemoveDateTime($index)></div><div class=create-event-popup__details__location__time__date><div class=create-event-popup__details__location__time__date__label></div><div class=create-event-popup__details__location__time__date__input><label required for=date class=create-event-popup__details__location__time__date__input__label ng-class=\"(!createEventForm.$pristine || vm.event.id) && createEventForm.date.$invalid ? \'text--color-error\' : \'text--color-black\'\">Date</label><div class=pixerf-calendar-input><input type=text name=date class=form-control uib-datepicker-popup=dd/MM/yyyy ng-model=dateTime.date is-open=dateTime.calendar.isVisible close-text=Close ng-class=\"(!createEventForm.$pristine || vm.event.id) && createEventForm.date.$invalid ? \'text--color-error\' : \'text--color-black\'\" alt-input-formats=altInputFormats required> <button type=button class=pixerf-calendar-input__toggle-btn ng-click=\"dateTime.calendar.isVisible = !dateTime.calendar.isVisible\"><i class=\"glyphicon glyphicon-calendar\"></i></button></div></div></div><div class=create-event-popup__details__location__time__start__wrapper><div class=create-event-popup__details__location__time__start__label>Start Time</div><div class=create-event-popup__details__location__time__start__input><timer-dropdown model=dateTime.start_time options=vm.timerOptions></timer-dropdown></div></div><div class=create-event-popup__details__location__time__end__wrapper><div class=create-event-popup__details__location__time__end__label>End Time</div><div class=create-event-popup__details__location__time__end__input><timer-dropdown model=dateTime.end_time options=vm.timerOptions></timer-dropdown></div></div></div><div class=create-event-popup__details__location__time__add-more ng-click=vm.onAddDateTime()>+ Add date and time</div></section><section class=create-event-popup__admission><div class=create-event-popup__admission__label>Admission</div><div class=create-event-popup__admission__capacity-section><mutiline-dropdown items=vm.privacyTypes selected=vm.defaultPrivacyType on-changed=vm.onPrivacyTypeChanged(data)></mutiline-dropdown></div><div class=create-event-popup__admission__capacity-section><mutiline-dropdown items=vm.capacityTypes selected=vm.defaultCapacityType on-changed=vm.onCapacityTypeChanged(data)></mutiline-dropdown><div ng-if=vm.isLimitedCapacity class=create-event-popup__admission__capacity-section__quantity><div class=create-event-popup__admission__capacity-section__quantity__item><div class=create-event-popup__admission__capacity-section__quantity__item__label>Spot(s) Available</div><input type=text ng-model=vm.event.max_attendees class=create-event-popup__admission__capacity-section__quantity__item__input></div></div></div><div class=create-event-popup__admission__event-type-section><mutiline-dropdown items=vm.admissionTypes selected=vm.defaultAdmission on-changed=vm.onAdmissionTypeChanged(data)></mutiline-dropdown><div ng-if=\"vm.event && (vm.event.admission_type == vm.admissionTypes[2].value)\" class=create-event-popup__admission__event-type-section__ticket-url><div class=create-event-popup__admission__event-type-section__ticket-url__item><span class=create-event-popup__admission__event-type-section__ticket-url__item__label>Ticket URL </span><input type=text ng-model=vm.event.ticket_url class=create-event-popup__admission__event-type-section__ticket-url__item__input></div></div><div ng-if=\"vm.event && (vm.event.admission_type == vm.admissionTypes[1].value)\" class=create-event-popup__admission__event-type-section__paid-event><div class=create-event-popup__admission__event-type-section__paid-event__item><stick-checkbox on-changed=vm.onCheckboxPaidEventChanged(vm.event.paid_event) model=vm.event class=create-event-popup__details__online-event__checkbox model-property=paid_event label=\"\"></stick-checkbox><label for=name class=create-event-popup__admission__event-type-section__paid-event__label>This is paid event.</label></div><div class=create-event-popup__admission__event-type-section__paid-event__item><div class=\"create-event-popup__admission__event-type-section__paid-event__input-group ticket-available\"><div class=create-event-popup__admission__event-type-section__paid-event__input-group__label>Current Tickets Available</div><div class=create-event-popup__admission__event-type-section__paid-event__input-group__input><input type=text ng-model=vm.event.max_attendees input-number-only></div></div><div class=\"create-event-popup__admission__event-type-section__paid-event__input-group ticket-price\"><div class=create-event-popup__admission__event-type-section__paid-event__input-group__label>Price</div><div class=create-event-popup__admission__event-type-section__paid-event__input-group__input><input input-number-only ng-disabled=!vm.event.paid_event placeholder=\"$ 0.00\" ng-model=vm.event.ticket_price></div></div></div><!-- <div class=\"create-event-popup__admission__event-type-section__paid-event__item\">\r\n						<label for=\"name\" class=\"create-event-popup__admission__event-type-section__paid-event__label\">\r\n							When are the tickets available?\r\n						</label>\r\n					</div> --><!-- <div class=\"create-event-popup__admission__event-type-section__paid-event__item\">\r\n						<div class=\"create-event-popup__admission__event-type-section__paid-event__input-group sale-start\">\r\n							<div class=\"create-event-popup__admission__event-type-section__paid-event__input-group__label\">Sale start</div>\r\n							<div class=\"create-event-popup__admission__event-type-section__paid-event__input-group__input\">\r\n								<div class=\"pixerf-calendar-input\">\r\n									<input type=\"text\" name=\"start_datetime\" class=\"form-control\" uib-datepicker-popup=\"dd/MM/yyyy\"\r\n										datepicker-options=\"vm.saleStart.options\"\r\n										ng-model=\"vm.saleStart.date\" is-open=\"vm.saleStart.calendar.isVisible\" close-text=\"Close\"\r\n										ng-class=\"(!createEventForm.$pristine || vm.event.id) && createEventForm.start_datetime.$invalid ? \'text--color-error\' : \'text--color-black\'\"\r\n										alt-input-formats=\"altInputFormats\" required />\r\n									<button type=\"button\" class=\"pixerf-calendar-input__toggle-btn\"\r\n										ng-click=\"vm.saleStart.calendar.isVisible = !vm.saleStart.calendar.isVisible\">\r\n										<i class=\"glyphicon glyphicon-calendar\"></i>\r\n									</button>\r\n								</div>\r\n							</div>\r\n						</div>\r\n						<div class=\"create-event-popup__admission__event-type-section__paid-event__input-group start-time\">\r\n							<div class=\"create-event-popup__admission__event-type-section__paid-event__input-group__label\">Start time</div>\r\n							<div class=\"create-event-popup__admission__event-type-section__paid-event__input-group__input\">\r\n								<div uib-timepicker ng-model=\"vm.saleStart.date\" ng-change=\"vm.onStartSaleTimechanged()\"\r\n									show-spinners=\"false\" show-meridian=\"true\"></div>\r\n							</div>\r\n						</div>\r\n					</div>\r\n					<div class=\"create-event-popup__admission__event-type-section__paid-event__item\">\r\n						<div class=\"create-event-popup__admission__event-type-section__paid-event__input-group sale-end\">\r\n							<div class=\"create-event-popup__admission__event-type-section__paid-event__input-group__label\">Sale end</div>\r\n							<div class=\"create-event-popup__admission__event-type-section__paid-event__input-group__input\">\r\n								<div class=\"pixerf-calendar-input\">\r\n									<input type=\"text\" name=\"end_datetime\" class=\"form-control\" uib-datepicker-popup=\"dd/MM/yyyy\"\r\n										datepicker-options=\"vm.saleEnd.options\"\r\n										ng-model=\"vm.saleEnd.date\" is-open=\"vm.saleEnd.calendar.isVisible\" close-text=\"Close\"\r\n										ng-class=\"(!createEventForm.$pristine || vm.event.id) && createEventForm.end_datetime.$invalid ? \'text--color-error\' : \'text--color-black\'\"\r\n										alt-input-formats=\"altInputFormats\" required />\r\n									<button type=\"button\" class=\"pixerf-calendar-input__toggle-btn\"\r\n										ng-click=\"vm.saleEnd.calendar.isVisible = !vm.saleEnd.calendar.isVisible\">\r\n										<i class=\"glyphicon glyphicon-calendar\"></i>\r\n									</button>\r\n								</div>\r\n							</div>\r\n						</div>\r\n						<div class=\"create-event-popup__admission__event-type-section__paid-event__input-group end-time\">\r\n							<div class=\"create-event-popup__admission__event-type-section__paid-event__input-group__label\">End time</div>\r\n							<div class=\"create-event-popup__admission__event-type-section__paid-event__input-group__input\">\r\n								<div uib-timepicker ng-model=\"vm.saleEnd.date\" ng-change=\"changed()\"\r\n									show-spinners=\"false\" show-meridian=\"true\"></div>\r\n							</div>\r\n						</div>\r\n					</div> --></div></div></section><section class=create-event-popup__post-creation><div class=create-event-popup__post-creation__label>Posts Creation</div><div class=create-event-popup__post-creation__permissions><label class=create-event-popup__post-creation__permissions__label translate>{{\'permissions-to-create-post\'}}</label><mutiline-dropdown items=vm.postingTypes selected=vm.defaultPostingType on-changed=vm.onPostingTypeChanged(data)></mutiline-dropdown></div><div ng-if=vm.canConfigmoderation class=create-event-popup__post-creation__post-approval><label class=create-event-popup__post-creation__post-approval__label translate>{{\'post-approval\'}}</label><mutiline-dropdown items=vm.moderationType selected=vm.defaultModerationType on-changed=vm.onModerationTypeChanged(data)></mutiline-dropdown></div></section><div class=create-event-popup__control><button ng-if=\"!vm.event.status || !vm.event.status === \'draft\'\" class=\"create-event-popup__control__button btn btn--transparent\" ng-click=vm.onSaveAsDraftEvent() translate>{{\'save-as-draft\'}}</button> <button class=\"create-event-popup__control__button create-event-popup__control__submit-btn btn btn-submit\" ng-disabled=createEventForm.$invalid ng-click=vm.onCreateEvent()>{{ vm.event.id ? \'Save\' : \'Create\'}}</button></div></form></div>");
$templateCache.put("app/components/create-event-post-popup/create-event-post-popup.html","<div class=create-event-post-popup><div class=create-event-post-popup__content><div class=\"create-event-post-popup__close-btn icon-icons_close\" ng-click=vm.dismiss()></div><div class=create-event-post-popup__title translate>{{vm.popupHeader}}</div><div class=create-event-post-popup__body><pixerf-user-avatar class=create-event-post-popup__body__avatar user-data=vm.loginUser lazy=true></pixerf-user-avatar><div class=create-event-post-popup__body__form><div class=create-event-post-popup__body__form__row><div contenteditable=true class=create-event-post-popup__body__form__description-input rows=3 ng-model=vm.eventPost.description data-text=\"{{\'write-a-post\' | translate}}\"></div><div class=create-event-post-popup__photos-attachment><div class=create-event-post-popup__photos-attachment__existing-photo ng-if=\"vm.eventPost.photos && vm.eventPost.photos.length\"><div ng-repeat=\"photo in vm.eventPost.photos\" class=create-event-post-popup__photos-attachment__existing-photo__item><img ng-src={{photo.url.thumbnail}}></div></div><div id=create-event-post-popup__attach-photos-section class=create-event-post-popup__attach pixerf-dropzone dropzone=vm.dropzoneConfig.instance dropzone-config=vm.dropzoneConfig.options event-handlers=vm.dropzoneConfig.eventHandlers><div class=create-event-post-popup__attach-more ng-hide=!vm.showAttachPhotoBtn>+</div></div></div></div></div></div><div class=create-event-post-popup__body__control><button ng-disabled=!vm.showAttachPhotoBtn id=create-event-post-popup__attach-photo-button class=\"create-event-post-popup__body__control__private-control btn btn--transparent\"><span class=icon-icons_camera></span> {{\'add-photos\' | translate}}</button><div class=create-event-post-popup__body__control__action-wrapper><button ng-if=!vm.isUpdateMode class=\"create-event-post-popup__body__control__update btn btn-submit\" ng-click=vm.onCreateEventPost() loading-spinner ng-class=\"{\'is-working\': vm.isAttachmentUploading}\" ng-disabled=vm.isAttachmentUploading>{{\'create\' | translate}}</button> <button ng-if=vm.isUpdateMode class=\"create-event-post-popup__body__control__update btn btn-submit\" ng-click=vm.onCreateEventPost() loading-spinner ng-class=\"{\'is-working\': vm.isAttachmentUploading}\" ng-disabled=vm.isAttachmentUploading>{{\'save\' | translate}}</button></div></div></div></div>");
$templateCache.put("app/components/create-gallery/create-gallery.html","<pixerf-alert instance=vm.alertSvc></pixerf-alert><div class=create-gallery ng-class=\"{\'create-gallery--edit-mode\': vm.mode === \'EDIT\'}\"><div class=clearfix><button type=button class=close ng-click=vm.onCancelBtnClicked()><span class=icon-icons_close aria-hidden=true></span></button><div class=\"modal-header text-left\"><h3 class=\"modal--title text--bold text--color-black text-left\">{{vm.popupTitle}}</h3><p ng-if=\"!vm.type && vm.mode === \'CREATE\'\" translate>{{\'start-collecting-your-photos\'}}</p><p ng-if=\"vm.type === \'curated\' && vm.mode === \'CREATE\'\" translate>{{\'curated-gallery-description\'}}</p></div><div class=\"modal-body text-center\"><form name=createGalleryForm class=text-left><div ng-if=\"vm.mode === \'EDIT\'\" class=create-gallery__image-cover ng-class=\"{\'hover-show\': vm.cropped.source || vm.coverMedia}\"><div class=create-gallery__image-cover__button ng-click=vm.onEditCoverImage()>Change cover</div><img ng-if=vm.coverMedia class=create-gallery__image-cover__default ng-src={{vm.coverMedia}}></div><div class=form-group><label class=text--bold translate>{{\'title\'}}</label><input maxlength=50 name=title required ng-model=vm.gallery.data.title placeholder=\"{{\'give-this-gallery-name\' | translate}}\" type=text class=form-control></div><div class=\"form-group create-gallery__description\"><label class=text--bold translate>{{\'description\'}}</label><textarea validation-no-hyperlink maxlength=255 rows=3 name=description type=text ng-model=vm.gallery.data.description placeholder=\"{{\'tell-us-more\' | translate}}\" class=form-control></textarea><div class=text-right><span class=textarea__length_descriptioon>{{vm.gallery.data.description ? vm.gallery.data.description.length: 0}}/255</span></div></div><div class=\"form-group pixerf-checkbox pixerf-checkbox--medium create-gallery__restriction-checkbox ng-hide\"><pixerf-checkbox model=vm.gallery.data model-property=is_private></pixerf-checkbox><label class=create-gallery__restriction-checkbox__main-label>Make Private</label><label class=create-gallery__restriction-checkbox__sub-label>Not ready for your big reveal? Private galleries will be hidden from your public profile.</label></div></form></div><div class=modal-footer><button ng-if=\"vm.mode === \'CREATE\'\" ng-click=vm.onCancelBtnClicked() type=button class=\"btn btn-cancel\">{{\'cancel\' | translate}}</button> <a class=btn-delete-gallery ng-if=\"vm.mode === \'EDIT\'\" href=\"\" ng-click=vm.onDeleteGalleryBtnClicked(vm.gallery.data)>{{\'delete\' | translate: {something: (\'this-gallery\' | translate)}}}</a> <button ng-disabled=\"vm.isWorking || createGalleryForm.title.$error.required\" ng-click=vm.onSaveBtnClicked(vm.gallery.data,createGalleryForm) type=button class=\"btn btn-submit btn-save-gallery\">{{vm.mode === \"EDIT\" ? (\'save\' | translate) : (\'done\' | translate)}}</button></div></div></div>");
$templateCache.put("app/components/create-portfolio-gallery/create-portfolio-gallery.html","<div class=create-gallery ng-class=\"{\'create-gallery--edit-mode\': vm.mode === \'EDIT\'}\"><div class=clearfix><button type=button class=close ng-click=vm.onCancelBtnClicked()><span class=icon-icons_close aria-hidden=true></span></button><div class=\"modal-header text-left\"><h3 class=\"modal--title text--bold text--color-black text-left\">{{vm.popupTitle}}</h3><p ng-if=\"vm.mode === \'CREATE\'\">{{\'create-gallery-showcase-portfolio\' | translate}}</p></div><div class=\"modal-body text-center\"><form name=createGalleryForm class=text-left><div ng-if=\"vm.mode === \'EDIT\'\" class=create-gallery__image-cover ng-class=\"{\'hover-show\': vm.cropped.source || vm.coverMedia}\"><div class=create-gallery__image-cover__button ng-click=vm.onEditCoverImage()>Change cover</div><img ng-if=vm.coverMedia class=create-gallery__image-cover__default ng-src={{vm.coverMedia}}></div><div class=form-group><label class=text--bold translate>{{\'title\'}}</label><input maxlength=50 name=title required ng-model=vm.portfolioGallery.data.title placeholder=\"{{\'give-this-gallery-name\' | translate}}\" type=text class=form-control></div></form></div><div class=modal-footer><button ng-if=\"vm.mode === \'CREATE\'\" ng-click=vm.onCancelBtnClicked() type=button class=\"btn btn-cancel\">{{\'cancel\' | translate}}</button> <a class=btn-delete-gallery ng-if=\"vm.mode === \'EDIT\'\" href=\"\" ng-click=vm.onDeletePortfolioGalleryBtnClicked(vm.portfolioGallery.data)>Delete this Gallery</a> <button ng-disabled=\"vm.isWorking || createGalleryForm.title.$error.required\" ng-click=vm.onSaveBtnClicked(vm.portfolioGallery.data,createGalleryForm) type=button class=\"btn btn-submit btn-save-gallery\">{{vm.mode === \"EDIT\" ? (\'save\' | translate) : (\'done\' | translate)}}</button></div></div></div>");
$templateCache.put("app/components/credit-card-form/credit-card-form.html","<div class=credit-card-form><div class=credit-card-form__error-msg ng-bind=\"vm.errorMsg | toTitleCase\"></div><form class=checkout-form name=creditCardForm novalidate><div class=\"form-group relative\"><label>Card Number</label><input id=dumemay focus-me=!!focusField type=text class=form-control ng-model=card.number name=cardNumber cc-number cc-format placeholder=\"•••• •••• •••• ••••\" ng-required=true><div ng-class=\"\"><div ng-class=\"[\'JCB\', \'VISA\', \'MASTERCARD\'].indexOf(creditCardForm.cardNumber.$ccType.toUpperCase()) !== -1 ? \'credit-card-form__image-card-placeholder credit-card-form__image-card-placeholder--is-active credit-card-form__image-card-placeholder__\' +  creditCardForm.cardNumber.$ccType.toLowerCase(): \'\'\" alt=\"\"></div></div></div><div class=form-group><label>Name on card</label><input name=fullname capitalize ng-model=card.fullname type=text class=form-control ng-required=true></div><div class=form-group><div class=row><div class=\"col-md-7 no-padding\"><label>Expiry date</label><div class=row cc-exp><div class=\"col-md-4 credit-card-form__expire-month no-padding\"><input ng-model=card.expMonth name=expMonth type=text class=form-control placeholder=MM input-number-only cc-exp-month ng-required=true></div><div class=\"col-md-4 credit-card-form__expire-year no-padding\"><input ng-model=card.expYear name=expYear type=text class=form-control placeholder=YY input-number-only cc-exp-year ng-required=true></div></div></div><div class=\"col-md-5 no-padding credit-card-form__ccv\"><label>Security Code <span class=credit-card-form__ccv__abbreviation>(CVV/CVC)</span></label><input minlength=3 maxlength=4 input-number-only ng-model=card.sercurityCode type=text class=form-control placeholder=•••• ng-required=true> <span class=icon-icons-info tooltip-placement=auto tooltip-trigger=\"\'click\'\" uib-tooltip-template=\"\'credit-card-form__cvv-tootip\'\"></span></div></div></div><div class=\"form-group credit-card-form__pay-btn-wrapper\" ng-if=!hideSubmitBtn><button ng-disabled=\"!creditCardForm.$valid || vm.isWorking\" ng-click=vm.onSubmitBtnClick(creditCardForm) class=\"btn btn-primary btn-block\"><span>{{vm.isWorking ? \'Sending \' : \'Pay \'}}</span><!-- <span class=\"text--bold credit-card-form__pay-btn__ammount\">{{amountToPay}}</span> --> <span>{{vm.isWorking ? \'... \' : \'\'}}</span></button></div></form><script type=text/ng-template id=credit-card-form__cvv-tootip><div class=\"credit-card-form__cvv-tootip\">\r\n            <div class=\"text-left credit-card-form__cvv-tootip__text\">3 or 4-digit number on the back of your credit card:</div>\r\n            <div class=\"credit-card-form__cvv-tootip__image\">\r\n                <img src=\"data:image/png;base64,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\" alt=\"\">\r\n            </div>\r\n        </div></script></div>");
$templateCache.put("app/components/credit-plans/credit-plans.html","<div class=credit-plans><div class=credit-plans__subtitle><div class=credit-plans__subtitle__header translate>{{\'pixerf-credit-plans\'}}</div><div class=credit-plans__subtitle__description translate>{{\'get-more-spend-less-with-our-credit-plans\'}}</div></div><div class=credit-plans__packages><div class=credit-plans-tile__wrapper><div ng-repeat=\"creditPlan in vm.creditPlans | orderBy:\'id\'\" class=credit-plans-tile ng-class=\"{\'plan--selected\': creditPlan.isSelected, \'custom-theme\': creditPlan.name === \'Enterprise\'}\" ng-click=vm.onCreditPlanSelected(creditPlan)><div ng-if=\"creditPlan.name === \'Premium\'\" class=credit-plans__packages__signal><div class=credit-plans__packages__signal__label translate>{{\'best-value\'}}</div></div><div class=\"credit-plans-tile__type text--color-black\" translate>{{creditPlan.name}}</div><div ng-if=\"creditPlan.name != \'Enterprise\'\" class=credit-plans-tile__main-content><div class=credit-plans-tile__cost>{{creditPlan.value}}</div><div class=\"credit-plans-tile__price text--color-black\"><span class=credit-plans-tile__price__unit></span> <span>{{creditPlan.price}}</span></div><div class=credit-plans-tile__hint translate translate-values=\"{percent: creditPlan.discount_percentage, value: creditPlan.discount_amount}\">{{creditPlan.hint}}</div><div class=credit-plans-tile__desc__header>What you get:</div><div ng-repeat=\"content in creditPlan.moreDescription\" class=credit-plans-tile__more-desc><div class=\"credit-plans-tile__more-desc__icon {{content.icon}}\"></div><div class=credit-plans-tile__more-desc__text><span class=credit-plans-tile__more-desc__special-text>{{content.itemValue}}</span> {{content.value}}</div></div></div><div ng-if=\"creditPlan.name === \'Enterprise\'\" class=credit-plans-tile__main-content><div class=\"credit-plans-tile__desc__header custom\">{{creditPlan.whatuget || \'What you get:\'}}</div><div ng-repeat=\"content in creditPlan.entDesc\" class=credit-plans-tile__ent-desc><div class=\"credit-plans-tile__ent-desc__icon {{content.icon}}\"></div><div class=credit-plans-tile__ent-desc__text>{{content.value}}</div></div></div><div class=credit-plans-tile__footer><!-- <div ng-if=\"creditPlan.directly\" tracking-element\r\n						description=\"Buy Now button #bcp_{{creditPlan.id}}{{context ? \'_\' + context : null}}\"\r\n						id=\"bcp_{{creditPlan.id}}{{context ? \'_\' + context : null}}\"\r\n						class=\"credit-plans-tile__btn btn buy-now-btn\"\r\n						ng-click=\"vm.onCreditPlanClicked(creditPlan)\" translate>{{\'buy-now\'}}</div> --><div ng-if=creditPlan.directly class=\"credit-plans-tile__btn btn buy-now-btn\" ng-click=vm.onGetInTouchClicked() translate>{{\'buy-now\'}}</div><a ng-if=\"!creditPlan.directly && !vm.onGetInTouchClicked\" class=\"credit-plans-tile__btn btn\" href=mailto:{{creditPlan.mailTo}}>{{\'get-in-touch\' | translate}}</a> <a ng-if=\"!creditPlan.directly && vm.onGetInTouchClicked\" class=\"credit-plans-tile__btn btn\" ng-click=vm.onGetInTouchClicked()>Request Enterprise Plan</a></div></div></div></div><div class=credit-plans__note><div class=credit-plans__note__first>Display prices are in Singapore Dollars.</div><div class=credit-plans__note__second>Rollover unused credits for additional year with renewal.</div></div><button class=\"credit-plans__email-us-btn btn\" ng-click=vm.onCantFindWhat()>Can\'t find what I\'m looking for</button></div>");
$templateCache.put("app/components/curator-star-popup/curator-star-popup.html","<div class=curator-star-popup><div class=clearfix><button type=button class=close ng-click=vm.closePopup()><span class=icon-icons_close aria-hidden=true></span></button><div class=\"modal-header text-left\"><h3 class=\"modal--title text--bold text--color-black text-left\" ng-bind=\"(vm.stars.length === 1 ? \'Star \' : \'Stars \') + \'(\' + vm.stars.length + \')\'\"></h3></div><div class=modal-body><div class=curator-star-popup__stars-list><div class=\"curator-star-popup__star text-left clearfix\" ng-repeat=\"star in vm.stars\"><star-item star=star owner-type={{vm.targetType}} owner-id=vm.target.id on-star-removed=vm.onStarRemoved(star)></star-item></div></div><scroll-paging spinner=vm.spinner show-message=false></scroll-paging></div></div></div>");
$templateCache.put("app/components/custom-checkbox/custom-checkbox.html","<div class=custom-checkbox ng-class=\"{\'disabled\': isDisabled, \'selected\': vm.isSelected}\" ng-click=vm.toggle($event)><div class=\"custom-checkbox__button icon-icons_check\"></div></div>");
$templateCache.put("app/components/custom-commission-selection-list/custom-commission-selection-list.html","<div class=custom-commission-selection-list><div class=custom-commission-selection-list__header></div><div class=custom-commission-selection-list__body><custom-commissions-selection-tile data=item datas=vm.items ng-repeat=\"item in vm.items\"></custom-commissions-selection-tile></div></div>");
$templateCache.put("app/components/custom-commissions-photo-popup/custom-commissions-photo-popup.html","<div class=custom-commissions-photo-popup__container ng-class=\"{\'full-screen-mode\': vm.isFullScreenMode}\"><div class=custom-commissions-photo-popup__container__header><div ng-if=vm.data.showDisableDownload class=custom-commissions-photo-popup__download-label ng-class=\"{\'enabled\': vm.data.is_download_enabled, \'disabled\': !vm.data.canDisableDownload}\" ng-click=vm.onToggleEnableDownload(vm.data.is_download_enabled)>{{vm.data.is_download_enabled ? \'Download Enabled\' : \'Download Disabled\'}}</div><button type=button class=close ng-click=vm.closePopup()><span class=icon-icons_close aria-hidden=true></span></button></div><div ng-if=!vm.isWorking class=custom-commissions-photo-popup__container__navigation event-key on-key-pressed=vm.logKey><div class=custom-commissions-photo-popup__container__navigation__previous ng-class=\"{\'disabled\': !vm.isLastPrev}\" ng-disabled=!vm.isLastPrev ng-click=\"vm.isLastPrev && vm.onPreviousBtnClicked()\"><div class=icon-baseline-arrow_back></div></div><div class=custom-commissions-photo-popup__container__navigation__next ng-class=\"{\'disabled\': !vm.isLastNext}\" ng-click=\"vm.isLastNext && vm.onNextBtnClicked()\" ng-disabled=!vm.isLastNext><div class=icon-baseline-arrow_forward></div></div></div><div class=custom-commissions-photo-popup__container__content><div class=custom-commissions-photo-popup__container__photo photo-fit-overlay watch-size=vm.isFullScreenMode><div class=\"overlay background-cover\"><div class=custom-commissions-photo-popup__container__content__zoom ng-click=vm.onFullScreenClicked()><div class=custom-commissions-photo-popup__fancybox-zoom ng-class=\"vm.isFullScreenMode ? \'icon-icons_contract\' : \'icon-icons_expand\'\"></div></div><div ng-if=\"vm.data.downloadButton && vm.data.is_download_enabled\" class=\"custom-commissions-photo-popup__download-btn icon-icons_download\" ng-click=vm.onDownloadPhotoClicked()></div><custom-checkbox class=custom-commissions-photo-popup__select-button model=vm.data model-property=isSelected on-changed=vm.onShortListChanged(data) ng-if=\"(vm.canSelect || (!vm.canSelect && vm.data.is_shortlisted)) && !vm.isWorking && vm.data.is_download_enabled\" is-disabled=!vm.canSelect></custom-checkbox></div><img ng-src=\"{{vm.data.media.thumbnails[\'w/1500x\']}}\" id={{vm.data.media.id}}></div><div class=custom-commissions-photo-popup__container__photo__name>{{vm.data.media.title}}</div><div class=custom-commissions-photo-popup__container__comment__list><comment-list input-placeholder-text=\"Add a note\" on-comment-deleted=vm.onCommentDeleted(comment) on-comment-added=vm.onCommentAdded(comment) target-id=vm.data.id context=\"\'CUSTOM_COMMISSIONS_PHOTO_POPUP\'\" hide-empty-state=true list-label=Notes is-custom-commissions=true shoot-id=vm.shoot.id no-comment=vm.noComment></comment-list></div></div></div>");
$templateCache.put("app/components/custom-commissions-public-tile/custom-commissions-public-tile.html","<div class=custom-commissions-public-tile><a ui-sref=\"custom-commissions-detail-page.approval({id: vm.data.id})\"><div class=custom-commissions-public-tile__container><div class=custom-commissions-public-tile__container__title>{{vm.data.name}}</div><div class=custom-commissions-public-tile__container__type>{{vm.data.type}}</div><div class=custom-commissions-public-tile__container__time><span class=custom-commissions-public-tile__container__time__label>Start date</span> <span class=custom-commissions-public-tile__container__time__detail>{{vm.data.time}}</span></div></div></a></div>");
$templateCache.put("app/components/custom-commissions-selection-tile/custom-commissions-selection-tile.html","<div class=custom-commissions-selection-tile><div class=\"custom-commissions-selection-tile__content clearfix\"><div class=\"custom-commissions-selection-tile__show clearfix\" ng-class=\"{\'custom-commissions-selection-tile__show__item--selected\': vm.selected}\"><div class=custom-commissions-selection-tile__photo ng-click=vm.onPhotoDetailsClicked(vm.data)><img lazy-img-error=\'{{ \"assets/images/icon-market.png\"}}\' lazy-img={{vm.data.url}}></div><div class=\"custom-commissions-selection-tile__name text--truncate\">{{vm.data.media.title}}</div></div><div class=\"custom-commissions-selection-tile__footer clearfix\"><div uib-tooltip=\"Add a note\" class=custom-commissions-selection-tile__comment ng-class=\"{\'custom-commissions-selection-tile__comment__have-note\': vm.data.comment_count}\"><div class=icon-icons_comment ng-click=vm.onPhotoDetailsClicked(vm.data)><div ng-if=vm.data.comment_count class=custom-commissions-selection-tile__comment__count>{{vm.data.comment_count}}</div></div></div><!-- <div class=\"custom-commissions-selection-tile__check-box\" ng-if=\"!vm.settings.hideCheckbox\" tooltip-append-to-body=true ng-attr-uib-tooltip=\"{{vm.selected && checkedCheckboxTooltip ? checkedCheckboxTooltip : (uncheckedCheckboxTooltip ? uncheckedCheckboxTooltip : \'\' )}}\">\r\n				<pixerf-checkbox on-changed=\"onChanged({item: vm})\" model=\"vm\" model-property=\"selected\" is-disabled=\"vm.settings.disableCheckbox\"></pixerf-checkbox>\r\n			</div> --><div class=custom-commissions-selection-tile__check-box ng-if=!vm.settings.hideCheckbox><pixerf-checkbox on-changed=\"onChanged({item: vm})\" model=vm model-property=selected is-disabled=vm.settings.disableCheckbox></pixerf-checkbox></div></div></div></div>");
$templateCache.put("app/components/custom-commissions-square-tile/custom-commissions-square-tile.html","<div class=custom-commissions-square-tile ng-class=\"{\'approval-tile\': vm.item.isSelected, \'show-button-layout\': options.showDownloadButton}\"><div class=custom-commissions-square-tile__overlay></div><div class=custom-commissions-square-tile__content ng-class=\"{\'show-border\': options.showHoverBorder, \'highlight-border\': options.showBorder}\"><div ng-if=options.showDisableDownload class=custom-commissions-square-tile__download-label ng-class=\"{\'enabled\': vm.item.is_download_enabled, \'disabled\': !options.canDisableDownload}\" ng-click=vm.onToggleEnableDownload(vm.item.is_download_enabled)>{{vm.item.is_download_enabled ? \'Download Enabled\' : \'Download Disabled\'}}</div><div class=custom-commissions-square-tile__photo><div ng-if=\"options.canDelete && !vm.item.isSelected && vm.item.comment_count == 0\" class=\"custom-commissions-square-tile__photo__remove-icon icon-icons_close\" ng-click=vm.onRemoveSubmissionClicked()></div><img ng-src=\"{{vm.item.media.thumbnails[\'x400\']}}\" alt={{vm.item.media.title}} ng-click=vm.onPhotoDetailsClicked(vm.item)><custom-checkbox ng-if=\"(options.canSelect || (!options.canSelect && vm.item.isSelected)) && vm.item.is_download_enabled\" class=custom-commissions-square-tile__photo__select-button model=vm.item model-property=isSelected is-disabled=!options.canSelect on-changed=\"vm.onChanged(data, event)\"></custom-checkbox></div><div class=custom-commissions-square-tile__info><div class=custom-commissions-square-tile__info__name ng-class=\"{\'no-hide\': !vm.item.is_download_enabled}\">{{vm.item.media.title}}</div><div class=custom-commissions-square-tile__info__comment ng-class=\"{\'no-hide\': !vm.item.is_download_enabled}\" ng-if=\"vm.item.comment_count > 0 && options.showComment\"><div class=custom-commissions-square-tile__info__comment__number>{{vm.item.comment_count}}</div><div class=\"custom-commissions-square-tile__info__comment__icon icon-comment-circle\"></div></div><div ng-if=vm.item.is_download_enabled class=custom-commissions-square-tile__info__download><div class=\"custom-commissions-square-tile__info__download__btn btn btn-submit\" ng-click=vm.onDownloadPhoto(vm.item)>Download photo</div></div></div></div></div>");
$templateCache.put("app/components/custom-commissions-tile/custom-commissions-tile.html","<div class=custom-commissions-tile><a ui-sref=\"custom-commissions-detail-page.approval({id: vm.data.id})\" class=custom-commissions-tile__wrapper><div class=custom-commissions-tile__photo><img ng-src={{vm.owerLogo}}></div><div class=custom-commissions-tile__content><div class=custom-commissions-tile__content__wrapper><div class=custom-commissions-tile__title>{{vm.data.name}}</div><div class=custom-commissions-tile__type>Full Custom Commissions</div><div class=custom-commissions-tile__time><span>Start date</span> {{vm.data.created_at | formatDate}}</div></div></div></a></div>");
$templateCache.put("app/components/custom-paging-style/custom-paging-style.html","<div class=\"custom-paging-style {{customClass}}\"><div class=custom-paging-style__label>{{vm.label}}</div><div class=custom-paging-style__grid-filter uib-dropdown ng-class=\"{\'open\': vm.isOpenDll}\"><div uib-dropdown-toggle class=custom-paging-style__grid-filter__dropdown-list><div class=custom-paging-style__grid-filter__selected-value>{{vm.rangePageInfo.noOfShowedItems}}</div><div class=\"custom-paging-style__grid-filter__icon icon-icons_chevron-down\"></div></div><ul class=custom-paging-style__grid-filter__list uib-dropdown-menu role=menu><li role=menuitem class=custom-paging-style__grid-filter__item ng-repeat=\"option in vm.listOptions\" ng-class=\"{\'active\': option == vm.rangePageInfo.noOfShowedItems}\" ng-click=vm.onItemClicked(option)><span>{{option}}</span></li></ul></div><div class=custom-paging-style__paging-info><div class=custom-paging-style__paging-info__range-value>{{vm.currentRange}}</div><div class=custom-paging-style__paging-info__text>of</div><div class=custom-paging-style__paging-info__total-value>{{vm.totalItems}}</div></div><div class=custom-paging-style__control><div class=\"custom-paging-style__control__first-page icon-first-page\" ng-disabled=vm.isFirstPage ng-click=vm.onGoFirstPage()></div><div class=\"custom-paging-style__control__previous-page icon-icons_chevron-left\" ng-disabled=vm.isFirstPage ng-click=vm.onGoPreviousPage()></div><div class=\"custom-paging-style__control__next-page icon-icons_chevron-right\" ng-disabled=vm.isLastPage ng-click=vm.onGoNextPage()></div><div class=\"custom-paging-style__control__last-page icon-last-page\" ng-disabled=vm.isLastPage ng-click=vm.onGoLastPage()></div></div></div>");
$templateCache.put("app/components/custom-homepage-grid-carousel/custom-homepage-grid-carousel.html","<div class=custom-homepage-grid-carousel><slick data=vm.slideDatas arrows=false on-init=vm.slickSetting.onInit(slick) adaptive-height=true><div ng-repeat=\"data in vm.slideDatas\"><ng-include ng-if=\"$index == 0\" src=\"\'app/components/custom-homepage-grid-carousel/slide1-template.html\'\" class=\"custom-homepage-grid-carousel__template-include slide-{{$index}}-style\"></ng-include><ng-include ng-if=\"$index == 1\" src=\"\'app/components/custom-homepage-grid-carousel/slide2-template.html\'\" class=\"custom-homepage-grid-carousel__template-include slide-{{$index}}-style\"></ng-include><ng-include ng-if=\"$index == 2\" src=\"\'app/components/custom-homepage-grid-carousel/slide3-template.html\'\" class=\"custom-homepage-grid-carousel__template-include slide-{{$index}}-style\"></ng-include></div></slick><div class=custom-homepage-grid-carousel__slide-control><div class=\"custom-homepage-grid-carousel__slide-control__left icon-slide-prev-icon\" ng-click=vm.onPreviousSlide()></div><div class=custom-homepage-grid-carousel__slide-control__text>{{vm.slick.currentSlide + 1}} of {{vm.slideDatas.length}}</div><div class=\"custom-homepage-grid-carousel__slide-control__right icon-slide-next-icon\" ng-click=vm.onNextSlide()></div></div><div class=custom-homepage-grid-carousel__mobile-section><div class=custom-homepage-grid-carousel__mobile-section__grid-wrapper><div ng-repeat=\"item in vm.mobileData\" ng-click=vm.showPhotoPopup(item) class=custom-homepage-grid-carousel__mobile-section__item-wrapper><div class=custom-homepage-grid-carousel__mobile-section__item><div class=custom-homepage-grid-carousel__mobile-section__item__background ng-style=\"{\'background-image\': \'url(\\\'\' + item.urlMobile + \'\\\')\'}\"></div></div></div></div></div></div>");
$templateCache.put("app/components/custom-homepage-grid-carousel/slide1-template.html","<div class=\"photo-slide-item photo-0\" ng-style=\"{\'background-image\': \'url(\' + data.photos[0].url + \')\'}\"><div class=\"photo-slide__info {{data.photos[0].infoPosition}}\"><div class=photo-slide__info__name>{{data.photos[0].name}}</div><div class=photo-slide__info__country>{{data.photos[0].country}}</div><div class=photo-slide__info__desc>{{data.photos[0].desc}}</div></div></div><div class=slide-0-style__center><div class=\"photo-slide-item photo-1\" ng-style=\"{\'background-image\': \'url(\' + data.photos[1].url + \')\'}\"><div class=\"photo-slide__info {{data.photos[1].infoPosition}}\"><div class=photo-slide__info__name>{{data.photos[1].name}}</div><div class=photo-slide__info__country>{{data.photos[1].country}}</div><div class=photo-slide__info__desc>{{data.photos[1].desc}}</div></div></div><div class=slide-0-style__center__bottom><div class=\"photo-slide-item photo-2\" ng-style=\"{\'background-image\': \'url(\' + data.photos[2].url + \')\'}\"><div class=\"photo-slide__info {{data.photos[2].infoPosition}}\"><div class=photo-slide__info__name>{{data.photos[2].name}}</div><div class=photo-slide__info__country>{{data.photos[2].country}}</div><div class=photo-slide__info__desc>{{data.photos[2].desc}}</div></div></div><div class=\"photo-slide-item photo-3\" ng-style=\"{\'background-image\': \'url(\' + data.photos[3].url + \')\'}\"><div class=\"photo-slide__info {{data.photos[3].infoPosition}}\"><div class=photo-slide__info__name>{{data.photos[3].name}}</div><div class=photo-slide__info__country>{{data.photos[3].country}}</div><div class=photo-slide__info__desc>{{data.photos[3].desc}}</div></div></div></div></div><div class=\"photo-slide-item photo-4\" ng-style=\"{\'background-image\': \'url(\' + data.photos[4].url + \')\'}\"><div class=\"photo-slide__info {{data.photos[4].infoPosition}}\"><div class=photo-slide__info__name>{{data.photos[4].name}}</div><div class=photo-slide__info__country>{{data.photos[4].country}}</div><div class=photo-slide__info__desc>{{data.photos[4].desc}}</div></div></div>");
$templateCache.put("app/components/custom-homepage-grid-carousel/slide2-template.html","<div class=\"slide-1-style__center vertical\"><div class=\"slide-1-style__center__bottom vertical\"><div class=\"photo-slide-item photo-0\" ng-style=\"{\'background-image\': \'url(\' + data.photos[0].url + \')\'}\"><div class=\"photo-slide__info {{data.photos[0].infoPosition}}\"><div class=photo-slide__info__name>{{data.photos[0].name}}</div><div class=photo-slide__info__country>{{data.photos[0].country}}</div><div class=photo-slide__info__desc>{{data.photos[0].desc}}</div></div></div><div class=\"photo-slide-item photo-1\" ng-style=\"{\'background-image\': \'url(\' + data.photos[1].url + \')\'}\"><div class=\"photo-slide__info {{data.photos[1].infoPosition}}\"><div class=photo-slide__info__name>{{data.photos[1].name}}</div><div class=photo-slide__info__country>{{data.photos[1].country}}</div><div class=photo-slide__info__desc>{{data.photos[1].desc}}</div></div></div></div><div class=\"photo-slide-item photo-2\" ng-style=\"{\'background-image\': \'url(\' + data.photos[2].url + \')\'}\"><div class=\"photo-slide__info {{data.photos[2].infoPosition}}\"><div class=photo-slide__info__name>{{data.photos[2].name}}</div><div class=photo-slide__info__country>{{data.photos[2].country}}</div><div class=photo-slide__info__desc>{{data.photos[2].desc}}</div></div></div></div><div class=slide-1-style__center><div class=slide-1-style__center__bottom><div class=\"photo-slide-item photo-3\" ng-style=\"{\'background-image\': \'url(\' + data.photos[3].url + \')\'}\"><div class=\"photo-slide__info {{data.photos[3].infoPosition}}\"><div class=photo-slide__info__name>{{data.photos[3].name}}</div><div class=photo-slide__info__country>{{data.photos[3].country}}</div><div class=photo-slide__info__desc>{{data.photos[3].desc}}</div></div></div><div class=\"photo-slide-item photo-4\" ng-style=\"{\'background-image\': \'url(\' + data.photos[4].url + \')\'}\"><div class=\"photo-slide__info {{data.photos[4].infoPosition}}\"><div class=photo-slide__info__name>{{data.photos[4].name}}</div><div class=photo-slide__info__country>{{data.photos[4].country}}</div><div class=photo-slide__info__desc>{{data.photos[4].desc}}</div></div></div></div><div class=\"photo-slide-item photo-5\" ng-style=\"{\'background-image\': \'url(\' + data.photos[5].url + \')\'}\"><div class=\"photo-slide__info {{data.photos[5].infoPosition}}\"><div class=photo-slide__info__name>{{data.photos[5].name}}</div><div class=photo-slide__info__country>{{data.photos[5].country}}</div><div class=photo-slide__info__desc>{{data.photos[5].desc}}</div></div></div></div>");
$templateCache.put("app/components/custom-homepage-grid-carousel/slide3-template.html","<div class=\"slide-2-style__center width-30\"><div class=\"photo-slide-item photo-0\" ng-style=\"{\'background-image\': \'url(\' + data.photos[0].url + \')\'}\"><div class=\"photo-slide__info {{data.photos[1].infoPosition}}\"><div class=photo-slide__info__name>{{data.photos[0].name}}</div><div class=photo-slide__info__country>{{data.photos[0].country}}</div><div class=photo-slide__info__desc>{{data.photos[0].desc}}</div></div></div><div class=\"photo-slide-item photo-1\" ng-style=\"{\'background-image\': \'url(\' + data.photos[1].url + \')\'}\"><div class=\"photo-slide__info {{data.photos[1].infoPosition}}\"><div class=photo-slide__info__name>{{data.photos[1].name}}</div><div class=photo-slide__info__country>{{data.photos[1].country}}</div><div class=photo-slide__info__desc>{{data.photos[1].desc}}</div></div></div></div><div class=\"slide-2-style__center width-44\"><div class=\"photo-slide-item photo-2\" ng-style=\"{\'background-image\': \'url(\' + data.photos[2].url + \')\'}\"><div class=\"photo-slide__info {{data.photos[2].infoPosition}}\"><div class=photo-slide__info__name>{{data.photos[2].name}}</div><div class=photo-slide__info__country>{{data.photos[2].country}}</div><div class=photo-slide__info__desc>{{data.photos[2].desc}}</div></div></div><div class=\"photo-slide-item photo-3\" ng-style=\"{\'background-image\': \'url(\' + data.photos[3].url + \')\'}\"><div class=\"photo-slide__info {{data.photos[3].infoPosition}}\"><div class=photo-slide__info__name>{{data.photos[3].name}}</div><div class=photo-slide__info__country>{{data.photos[3].country}}</div><div class=photo-slide__info__desc>{{data.photos[3].desc}}</div></div></div></div><div class=\"slide-2-style__center size-auto\"><div class=\"photo-slide-item photo-4\" ng-style=\"{\'background-image\': \'url(\' + data.photos[4].url + \')\'}\"><div class=\"photo-slide__info {{data.photos[4].infoPosition}}\"><div class=photo-slide__info__name>{{data.photos[4].name}}</div><div class=photo-slide__info__country>{{data.photos[4].country}}</div><div class=photo-slide__info__desc>{{data.photos[4].desc}}</div></div></div></div>");
$templateCache.put("app/components/custom-radio-button/custom-radio-button.html","<div class=custom-radio-button ng-click=vm.onRadioClicked(vm.isSelected)><div class=custom-radio-button__icon ng-class=\"{\'checked\': vm.isSelected}\"><div class=custom-radio-button__icon__solid></div></div><span class=custom-radio-button__label ng-if=label translate>{{label}}</span></div>");
$templateCache.put("app/components/datetime-dropdown/datetime-dropdown.html","<div class=\"datetime-dropdown clearfix\"><select ng-if=!options.hideDay required class=\"datetime-dropdown__input day-input\" ng-model=vm.date.day ng-options=\"d for d in vm.days\"><option value=\"\" disabled=disabled selected=selected hidden>Day</option></select><select ng-if=!options.hideMonth required class=\"datetime-dropdown__input month-input\" ng-model=vm.date.month ng-options=\"m for m in vm.months\"><option value=\"\" disabled=disabled selected=selected hidden>Month</option></select><select ng-if=!options.hideYear required class=\"datetime-dropdown__input year-input\" ng-model=vm.date.year ng-options=\"y for y in vm.years\"><option value=\"\" disabled=disabled selected=selected hidden>Year</option></select></div>");
$templateCache.put("app/components/detail-user-view/detail-user-view.html","<div class=detail-user-view><div class=detail-user-view__avatar pixerf-user-avatar-style pixerf-user-avatar-style-user=user><a ui-sref=\"user-home-page.personal.home({id: vm.user.id, userName: (vm.user.displayName | toSnakeCase)})\"><pixerf-user-avatar user-data=vm.user lazy=true></pixerf-user-avatar></a></div><div class=detail-user-view__content><div class=detail-user-view__content__author><a class=\"detail-user-view__content__author__name text--truncate\" uib-tooltip={{vm.user.displayName}} ui-sref=\"user-home-page.personal.home({id: vm.user.id, userName: (vm.user.displayName | toSnakeCase)})\">{{vm.user.displayName}}</a></div><div class=detail-user-view__content__level pixerf-person-level person=user></div><div class=detail-user-view__content__created-at>{{\'joined-on\' | translate}} {{vm.user.formattedJoinedAt}}</div></div><div uib-dropdown class=detail-user-view__control ng-if=owner><div class=\"detail-user-view__control__button icon-icons_more\" uib-dropdown-toggle></div><ul class=detail-user-view__control__dropdown-menu uib-dropdown-menu><li class=detail-user-view__control__dropdown-menu__item ng-click=vm.onRemoveMember(user)>Remove Member</li></ul></div></div>");
$templateCache.put("app/components/discussion-comment/discussion-comment.html","<div class=discussion-comment__block><div id={{vm.comment.id}} scroll-to-element=vm.scrollToThis offset-top=160 class=discussion-comment ng-class=vm.layout><div class=discussion-comment__author><a ng-if=\"vm.comment.user.account_type === \'personal\'\" ui-sref=\"user-home-page.personal.home({id: vm.comment.user.id, userName: (vm.comment.user.displayName | toSnakeCase)})\" target=_blank><pixerf-user-avatar class=discussion-comment__author__avatar user-data=vm.comment.user lazy=true></pixerf-user-avatar></a><pixerf-user-avatar ng-if=\"vm.comment.user.account_type === \'business\'\" class=discussion-comment__author__avatar user-data=vm.comment.user lazy=true></pixerf-user-avatar><div class=discussion-comment__author__text><span class=discussion-comment__author__name>{{vm.comment.user.displayName}}</span> <span class=discussion-comment__author__content>{{vm.comment.text}}</span><div ng-if=\"vm.comment.photos && vm.comment.photos.length\" class=discussion-comment__author__attachment><div ng-repeat=\"photo in vm.comment.photos\" class=discussion-comment__author__attachment__image><a ng-attr-fancyboxable=\"{\'type\': \'image\', \'overlayShow\': true, \'hideOnOverlayClick\': true, \'showNavArrows\': true, \'margin\': \'50 10 15 10\', \'centerOnScroll\': true}\" href={{photo.url.large}} rel=commentAttachment-{{vm.comment.id}}><img ng-src={{photo.url.thumbnail}}></a></div></div><div class=discussion-comment__reply ng-if=\"vm.comment.reply_count > 0\" ng-click=vm.onToggleReplyDropdown()><div class=discussion-comment__reply__count>{{vm.comment.reply_count}}</div><div class=discussion-comment__reply__label>{{vm.comment.reply_count === 1 ? (\'reply\' | translate).toLowerCase() : (\'replies\' | translate).toLowerCase()}}</div><div class=discussion-comment__reply__icon ng-class=\"vm.isRepliedOpen ? \'icon-icons_chevron-up\' : \'icon-icons_chevron-down\'\"></div></div></div></div><div class=discussion-comment__info><div ng-if=\"vm.comment.like_count > 0\" class=\"discussion-comment__info__item discussion-comment__info__like\" ng-click=vm.onShowListLike() title=\"Click to see who liked this discussion\"><span class=discussion-comment__info__like__count>{{vm.comment.like_count}}</span> <span class=discussion-comment__info__like__label>{{vm.comment.like_count === 1 ? (\'like\' | translate).toLowerCase() : (\'likes\' | translate).toLowerCase()}}</span></div><div class=\"discussion-comment__info__item discussion-comment__info__time\">{{vm.time}}</div><div ng-if=\"vm.comment.user.id != vm.loginUser.id\" class=\"discussion-comment__info__item discussion-comment__info__control-like\" ng-class=\"{\'liked\': vm.comment.is_liked}\" authentication-click=vm.onLikeComment(vm.comment)>{{vm.comment.likeLabel}}</div><div ng-if=canReply class=\"discussion-comment__info__item discussion-comment__info__control-reply\" authentication-click=vm.onReplyInput()>{{\'reply\' | translate}}</div><div uib-dropdown class=\"discussion-comment__info__item discussion-comment__info__control-more\"><span uib-dropdown-toggle class=icon-icons_more></span><ul class=discussion-comment__info__control-more__list uib-dropdown-menu role=menu><li ng-if=!vm.isOwner role=menuitem class=discussion-comment__info__control-more__item ng-click=vm.onReportComment(vm.comment) translate translate-values=\"{thing: (\'comment\' | translate)}\">{{\'report-thing\'}}</li><li ng-if=\"vm.isOwner || vm.loginUser.canRemoveReplyDiscussion\" role=menuitem class=discussion-comment__info__control-more__item ng-click=vm.onRemoveComment(vm.comment)>{{\'remove\' | translate}}</li></ul></div></div></div><div ng-if=vm.isRepliedOpen class=\"discussion-comment__child author-block\" ng-repeat=\"subComment in vm.subComments\"><div class=discussion-comment__author><pixerf-user-avatar class=discussion-comment__author__avatar user-data=subComment.user lazy=true></pixerf-user-avatar><div class=discussion-comment__author__text><span class=discussion-comment__author__name>{{subComment.user.displayName}}</span> <span class=discussion-comment__author__content>{{subComment.text}}</span></div></div><div class=discussion-comment__info><div ng-if=\"subComment.like_count > 0\" class=\"discussion-comment__info__item discussion-comment__info__like\" ng-click=vm.onShowListLike(subComment)><span class=discussion-comment__info__like__count>{{subComment.like_count}}</span> <span class=discussion-comment__info__like__label>{{subComment.like_count === 1 ? (\'like\' | translate).toLowerCase() : (\'likes\' | translate).toLowerCase()}}</span></div><div class=\"discussion-comment__info__item discussion-comment__info__time\">{{subComment.time}}</div><div ng-if=\"subComment.user.id != vm.loginUser.id\" class=\"discussion-comment__info__item discussion-comment__info__control-like\" ng-class=\"{\'liked\': subComment.is_liked}\" authentication-click=vm.onLikeComment(subComment)>{{subComment.likeLabel}}</div><div uib-dropdown class=\"discussion-comment__info__item discussion-comment__info__control-more\"><span uib-dropdown-toggle class=icon-icons_more></span><ul class=discussion-comment__info__control-more__list uib-dropdown-menu role=menu><li ng-if=!subComment.isOwner role=menuitem class=discussion-comment__info__control-more__item ng-click=vm.onReportComment(subComment) translate translate-values=\"{thing: (\'comment\' | translate)}\">{{\'report-thing\'}}</li><li ng-if=\"subComment.isOwner || vm.loginUser.canRemoveReplyDiscussion\" role=menuitem class=discussion-comment__info__control-more__item ng-click=\"vm.onRemoveComment(subComment, true)\">{{\'remove\' | translate}}</li></ul></div></div></div><div ng-if=vm.replyCommentShow class=discussion-comment__reply-comment><pixerf-user-avatar class=discussion-comment__reply-comment__author-avatar user-data=vm.loginUser lazy=true></pixerf-user-avatar><div type=text contenteditable={{!vm.isWorking}} class=discussion-comment__reply-comment__input enter=vm.onReplyCommentDiscussion(vm.replyComment) ng-model=vm.replyComment></div><div class=discussion-comment__reply-comment__submit-btn ng-click=vm.onReplyCommentDiscussion(vm.replyComment) uib-tooltip=Publish></div></div></div>");
$templateCache.put("app/components/discussion-item/discussion-item.html","<div class=discussion-item><div uib-dropdown class=discussion-item__control-more><span ng-if=vm.controls.length uib-dropdown-toggle class=icon-icons_more></span><ul class=discussion-item__list uib-dropdown-menu role=menu><li ng-repeat=\"item in vm.controls\" ng-if=item.showControl role=menuitem class=discussion-item__item ng-click=item.cta()>{{item.label}}</li></ul></div><div class=discussion-item__header><div class=discussion-item__header__info><div class=discussion-item__header__info__author><pixerf-user-avatar user-data=vm.discussion.user class=discussion-item__header__info__author__cover lazy=true></pixerf-user-avatar><div class=discussion-item__header__info__author__info><a class=discussion-item__header__info__author__name ng-click=vm.prevenPubbleClick() ui-sref=\"user-home-page.personal.home({id: vm.discussion.user.id, userName: (vm.discussion.user.displayName | toSnakeCase)})\" target=_blank uib-tooltip=\"{{vm.discussion.user.displayName || vm.discussion.user.email}}\">{{vm.discussion.user.displayName || vm.discussion.user.email}} </a><span class=discussion-item__header__info__author__creator-type>{{vm.discussion.user.organization ? vm.discussion.user.organization.name : \'\'}}</span></div></div><div class=discussion-item__header__info__time>{{vm.inserted_at}}</div></div><div class=discussion-item__header__title ng-click=vm.goDetailDiscussion(vm.discussion)>{{vm.discussion.subject}}</div></div><div class=discussion-item__content ng-click=vm.goDetailDiscussion(vm.discussion)><div class=discussion-item__description>{{vm.discussion.description}}</div><div ng-if=\"vm.discussion.photos && vm.discussion.photos.length\" class=discussion-item__photo-grid flex-grid ng-model=vm.discussion.photos rowheight=50 lastrow=justify margins=10><div ng-repeat=\"photo in vm.discussion.photos\"><a ng-attr-fancyboxable=\"{\'type\': \'image\', \'overlayShow\': true, \'hideOnOverlayClick\': true, \'showNavArrows\': true, \'margin\': \'50 10 15 10\', \'centerOnScroll\': true}\" href={{photo.url.large}} rel=discussionAttachment><img ng-src={{photo.url.thumbnail}}></a></div></div></div><div class=discussion-item__info><div class=discussion-item__info__status><div ng-if=\"vm.discussion.like_count > 0\" class=discussion-item__info__like ng-click=vm.onShowListLike() title=\"Click to see who liked this discussion\"><span class=\"discussion-item__control__icon icon-icons_like\"></span> <span class=discussion-item__info__value>{{vm.discussion.like_count}}</span></div><div ng-if=\"vm.discussion.reply_count > 0\" class=discussion-item__info__reply ng-click=vm.onShowListReply() title=\"Click to see who replied this photo\"><span class=discussion-item__info__value>{{vm.discussion.reply_count}}</span> <span>{{vm.discussion.reply_count === 1 ? (\'reply\' | translate).toLowerCase() : (\'replies\' | translate).toLowerCase()}}</span></div></div><div class=discussion-item__info__action><button ng-if=vm.showRejectBtn class=\"discussion-item__info__action__reject-btn btn btn--transparent\" ng-click=vm.onRejectDiscussion()><span class=\"discussion-item__info__action__btn-icon icon-icons_close\"></span> <span class=discussion-item__info__action__btn-label>Reject</span></button> <button ng-if=vm.showApproveBtn class=\"discussion-item__info__action__approve-btn btn btn-submit\" ng-click=vm.onApproveDiscussion()><span class=\"discussion-item__info__action__btn-icon icon-icons_check\"></span> <span class=discussion-item__info__action__btn-label>Approve</span></button> <button ng-if=\"vm.isOwner && vm.showEditBtn\" class=\"discussion-item__info__action__reject-btn btn btn--transparent\" ng-click=vm.onEditDiscussion(vm.discussion)><span class=\"discussion-item__info__action__btn-icon icon-icons_close\"></span> <span class=discussion-item__info__action__btn-label>Edit</span></button> <button ng-if=\"vm.isOwner && vm.showDeleteBtn\" class=\"discussion-item__info__action__approve-btn btn btn-submit\" ng-click=vm.onDeleteDiscussion()><span class=\"discussion-item__info__action__btn-icon icon-icons_check\"></span> <span class=discussion-item__info__action__btn-label>Delete</span></button></div></div></div>");
$templateCache.put("app/components/discussion-tile/discussion-tile.html","<div class=discussion-tile ng-class=\"{\'no-control\': !vm.loginUser}\"><div uib-dropdown class=discussion-tile__control-more><span ng-if=\"vm.isMoreControlOwner || (!vm.isMoreControlOwner && !vm.isOwner)\" uib-dropdown-toggle class=icon-icons_more></span><ul class=discussion-tile__list uib-dropdown-menu role=menu><li ng-if=vm.isMoreControlOwner role=menuitem class=discussion-tile__item ng-click=vm.onManageRights()>{{\'manage-rights\' | translate}}</li><li ng-if=!vm.isMoreControlOwner role=menuitem class=discussion-tile__item ng-click=vm.onReportDiscussion(vm.discussion) translate translate-values=\"{thing: \'post\'}\">{{\'report-thing\'}}</li></ul></div><div class=discussion-tile__header><div class=discussion-tile__header__left><pixerf-user-avatar user-data=vm.discussion.user lazy=true></pixerf-user-avatar></div><div class=discussion-tile__header__right><div class=discussion-tile__header__title ng-click=vm.goDetailDiscussion(vm.discussion)><div class=discussion-tile__header__title__author><div class=discussion-tile__header__title__author__wrapper><span ng-if=\"vm.discussion.user.account_type === \'business\'\" class=discussion-tile__header__title__author__name>{{vm.discussion.user.displayName}}</span> <span ng-if=\"vm.discussion.user.account_type === \'personal\'\" class=discussion-tile__header__title__author__name ng-class=\"{\'cursor-pointer\': vm.discussion.user.account_type === \'personal\'}\" ui-sref=\"user-home-page.personal.home({id: vm.discussion.user.id, userName: (vm.discussion.user.displayName | toSnakeCase)})\">{{vm.discussion.user.displayName}}</span> <span ng-if=vm.showAdminLabel class=discussion-tile__header__title__author__label-owner><span class=discussion-tile__header__title__author__label-owner__icon></span> <span class=discussion-tile__header__title__author__label-owner__text>Admin</span></span></div><div class=discussion-tile__header__title__author__acc-type>{{vm.discussion.user.account_type}}</div></div><div class=discussion-tile__header__title__time>{{vm.inserted_at}}</div></div></div></div><div class=discussion-tile__subject><div class=discussion-tile__subject__text>{{vm.discussion.subject}}</div></div><div class=discussion-tile__content ng-click=vm.goDetailDiscussion(vm.discussion)><div class=discussion-tile__description>{{vm.discussion.description}}</div><div ng-if=\"vm.discussion.photos && vm.discussion.photos.length\" class=discussion-tile__photo-grid flex-grid ng-model=vm.discussion.photos rowheight=50 lastrow=justify margins=10><div ng-repeat=\"photo in vm.discussion.photos\"><a ng-attr-fancyboxable=\"{\'type\': \'image\', \'overlayShow\': true, \'hideOnOverlayClick\': true, \'showNavArrows\': true, \'margin\': \'50 10 15 10\', \'centerOnScroll\': true}\" href={{photo.url.large}} rel=discussionAttachment><img ng-src={{photo.url.thumbnail}}></a></div></div></div><div class=discussion-tile__info><div class=discussion-tile__info__like ng-click=vm.onShowListLike() title=\"Click to see who liked this discussion\"><span class=\"discussion-tile__info__like__icon icon-icons_like\"></span> <span class=discussion-tile__info__value>{{vm.discussion.like_count}}</span></div><div ng-if=\"vm.discussion.reply_count > 0\" class=discussion-tile__info__reply data-toggle=collapse data-target=#comment-section-{{vm.discussion.id}} title=\"Click to see who replied this photo\"><span class=discussion-tile__info__value>{{vm.discussion.reply_count}}</span> <span>{{vm.discussion.reply_count === 1 ? (\'reply\' | translate).toLowerCase() : (\'replies\' | translate).toLowerCase()}}</span></div><div class=discussion-tile__control><div ng-if=vm.isOwner class=\"discussion-tile__control__list discussion-tile__control__owner\"><div class=\"discussion-tile__control__icon discussion-tile__control__owner__edit icon-icons_edit icon-pencil\" authentication-click=vm.onEditDiscussion($event) uib-tooltip=Edit tooltip-placement=left></div><div class=\"discussion-tile__control__icon discussion-tile__control__owner__remove icon-icons_close\" authentication-click=vm.onRemoveDiscussion($event) uib-tooltip=Remove tooltip-placement=left></div><div class=\"discussion-tile__control__icon discussion-tile__control__guest__reply icon-comment-circle\" uib-tooltip=Comment tooltip-placement=left data-toggle=collapse data-target=#comment-section-{{vm.discussion.id}}></div></div><div ng-if=\"!vm.isOwner && vm.isMember\" class=\"discussion-tile__control__list discussion-tile__control__guest\"><div class=\"discussion-tile__control__icon discussion-tile__control__guest__bookmark icon-bookmark\" ng-class=\"{\'bookmarked\': vm.discussion.is_bookmarked}\" uib-tooltip=Bookmark tooltip-placement=left authentication-click=vm.onBookmarkToggle($event)></div><div class=\"discussion-tile__control__icon discussion-tile__control__guest__like icon-icons_like\" ng-class=\"{\'liked\': vm.discussion.is_liked}\" uib-tooltip=Like tooltip-placement=left authentication-click=vm.onLikeToggle($event)></div><div class=\"discussion-tile__control__icon discussion-tile__control__guest__reply icon-comment-circle\" uib-tooltip=Comment tooltip-placement=left data-toggle=collapse data-target=#comment-section-{{vm.discussion.id}}></div></div></div></div><div id=comment-section-{{vm.discussion.id}} class=\"discussion-tile__comment-section collapse\"><div ng-if=vm.loginUser class=discussion-tile__comment-section__comment__input><pixerf-user-avatar class=discussion-tile__comment-section__comment__input__author-avatar user-data=vm.loginUser lazy=true></pixerf-user-avatar><div class=discussion-tile__comment-section__comment__input__wrapper><input type=text class=discussion-tile__comment-section__comment__input__author-input ng-model=vm.commentText></div><button class=discussion-tile__comment-section__comment__input__submit-btn ng-click=vm.onCommentDiscussion(vm.commentText) uib-tooltip=Publish loading-spinner ng-class=\"{\'is-working\': vm.isAttachmentUploading}\" ng-disabled=vm.isAttachmentUploading></button></div><div ng-if=\"vm.discussionComments && vm.discussionComments.length\" class=discussion-tile__comment-section__comment__list><div class=discussion-tile__comment-section__wrapper infinite-scroll-disabled=vm.isLastDiscussionComments infinite-scroll=vm.fetchMoreDiscussionComments() infinite-scroll-immediate-check=false><discussion-comment ng-repeat=\"comment in vm.discussionComments track by comment.id\" comment=comment can-reply=true on-removed=vm.onCommentRemoved(data) can-comment=\"vm.isOwner || vm.isMember\" scroll-to-this=\"comment.id === vm.scrollToElement\"></discussion-comment><scroll-paging spinner=vm.spinnerComment show-message=false is-last-page=vm.isLastDiscussionComments></scroll-paging></div></div></div></div>");
$templateCache.put("app/components/discussion-topic-draft/discussion-topic-draft.html","<div class=discussion-topic-draft><div class=discussion-topic-draft__header><div class=discussion-topic-draft__header__title-wrapper><div class=discussion-topic-draft__header__title>{{vm.discussion.subject}}</div><div class=discussion-topic-draft__header__label>Draft</div></div><div class=discussion-topic-draft__header__info><div class=discussion-topic-draft__header__info__author>Created by <span class=discussion-topic-draft__header__info__author__name>You</span></div><div class=discussion-topic-draft__header__info__dot></div><div class=discussion-topic-draft__header__info__time>{{vm.updated_at}}</div></div></div><div class=discussion-topic-draft__control><div class=\"discussion-topic-draft__control__list discussion-topic-draft__control__owner\"><div class=\"discussion-topic-draft__control__icon discussion-topic-draft__control__owner__edit icon-icons_edit icon-pencil\" ng-click=vm.onEditDiscussion($event) uib-tooltip=Edit tooltip-placement=left></div><div class=\"discussion-topic-draft__control__icon discussion-topic-draft__control__owner__publish\" ng-click=vm.onPublishDiscussion($event) uib-tooltip=Publish tooltip-placement=left></div></div></div></div>");
$templateCache.put("app/components/dropdown-tag/dropdown-tag.html","<div class=dropdown-tag><span class=bs-caret><span class=caret></span></span><ui-select multiple=multiple close-on-select=false ng-model=vm.itemsSelected class=\"dropdown-tag__select clearfix\" on-select=vm.onItemSelected($item) on-remove=vm.onItemRemoved($item)><ui-select-match>{{$item.name}}</ui-select-match><span class=bs-caret><span class=caret></span></span><ui-select-choices repeat=\"item in data\">{{item.name}}</ui-select-choices></ui-select></div>");
$templateCache.put("app/components/earnings/earnings.html","<div class=\"clearfix setting-top-navigation\"><div class=\"setting-top-navigation__section-wrapper pixerf-navigation-bar-wrapper\"><ul class=\"earnings-page__navigation-bar pixerf-navigation-bar\"><button type=button class=\"setting-top-navigation__collapse-button navbar-toggle collapsed\" data-toggle=collapse data-target=#manage-photos-mission-navigation aria-expanded=false><div class=setting-top-navigation__context translate>{{vm.subContextPage}}</div><div class=\"setting-top-navigation__mobile-button arrow-animation-menu-collapse\"><span class=\"icon-bar dash-one\"></span> <span class=\"icon-bar dash-two\"></span></div></button><div class=\"setting-top-navigation__list collapse navbar-collapse\" navbar-collapse-on-click=true id=manage-photos-mission-navigation ng-if=!vm.guestUser><li class=setting-top-navigation__item ui-sref-active-class=setting-top-navigation__item--active ui-sref-active-if=setting.earnings.my_earnings ui-sref=setting.earnings.my_earnings.images_sold>{{\'my-earnings\' | translate}}</li><li class=setting-top-navigation__item ui-sref-active=setting-top-navigation__item--active ui-sref=setting.earnings.transaction_history>{{\'transaction-history\' | translate}}</li><li class=\"setting-top-navigation__item setting-top-navigation__item__slash\">|</li><li class=setting-top-navigation__item ui-sref-active=setting-top-navigation__item--active ui-sref=setting.earnings.payout_method>{{\'payout-method\' | translate}}</li></div></ul><div class=\"earnings-page__main-content clearfix\" ui-view ng-if=!vm.guestUser></div></div></div>");
$templateCache.put("app/components/earnings-popup/earnings-popup.html","<div class=earnings-popup><button type=button class=close ng-click=vm.cancel()><span class=icon-icons_close aria-hidden=true></span></button><div class=clearfix><div class=\"earnings-popup__header clearfix\"><div class=\"earnings-popup__header__title text--extrabold text--color-black\" translate>{{\'how-do-i-earn\'}}</div></div><div class=earnings-popup__body><div class=\"earnings-popup__body__title text--bold text--color-black creative-marketplace\" translate>{{\'creative-marketplace\'}}</div><div class=earnings-popup__body__content translate translate-compile>{{\'earning-popup-creative-marketplace\'}}</div><div class=\"earnings-popup__body__title text--bold text--color-black\" translate>{{\'crowdsourced-missions\'}}</div><div class=earnings-popup__body__content translate translate-compile>{{\'earning-popup-crowdsourced-missions\'}}</div><div class=\"earnings-popup__body__title text--bold text--color-black\" translate>{{\'custom-commission\'}}</div><div class=earnings-popup__body__content translate translate-compile>{{\'earning-popup-custom-commission\'}}</div></div><div class=earnings-popup__footer><button class=\"btn btn-submit btn-learn-more\" ng-click=vm.onLearnMoreClicked() translate>{{\'learn-more\'}}</button></div></div></div>");
$templateCache.put("app/components/edit-cart-btn/edit-cart-btn.html","<div class=\"text-center edit-cart-btn\"><div><button class=\"container-full btn btn-submit btn-block\" authentication-click=vm.onEditCartBtnClicked(cartItem)>Save to Cart</button></div></div>");
$templateCache.put("app/components/edit-password-popup/edit-password-popup.html","<div class=\"edit-password-popup clearfix\"><div class=\"edit-password-popup__header clearfix\"><div class=\"edit-password-popup__title text--extrabold text--color-black\" translate>{{\'change-your-password\'}}</div><div class=\"edit-password-popup__close icon-icons_close text--color-black\" role=button ng-click=vm.onCancelBtnClicked()></div></div><div class=\"edit-password-popup__body clearfix\"><form name=changePasswordForm class=\"edit-password-popup__form clearfix\"><div class=form-group><label for=\"\">New Password</label><input ng-pattern=\"/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{6,})/\" required name=newPassword type=password ng-model=vm.user.data.newPassword class=form-control focus-me=true></div><div class=form-group><label for=\"\">Re-type New Password</label><input ng-pattern=\"/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{6,})/\" required name=newPasswordAgain type=password ng-model=vm.user.data.newPasswordAgain class=form-control></div></form><div class=\"edit-password-popup__control clearfix\"><div class=edit-password-popup__btn-wrapper><button class=\"edit-password-popup__btn btn btn--transparent\" ng-click=vm.onCancelBtnClicked()>{{\'cancel\' | translate}}</button></div><div class=edit-password-popup__btn-wrapper><button class=\"edit-password-popup__btn btn btn-submit\" ng-click=\"vm.onSaveBtnClicked(vm.user.data, changePasswordForm)\">{{\'save\' | translate}}</button></div></div></div></div>");
$templateCache.put("app/components/edit-profile/edit-profile-business.html","<div class=edit-profile-business><div class=\"row clearfix\"><div class=edit-profile-business__header><h4 class=edit-profile-business__header__title translate>{{\'profile\'}}</h4></div><div class=edit-profile-business__body><form name=profileForm><div class=edit-profile-business__photo ng-if=!vm.guestUser><div class=edit-profile-business__cover-photo-wrapper ng-click=\"vm.showUploadUserProfilePhotos(\'cover\')\"><div class=hover-cover-style>Edit</div><img ng-if=!vm.updatingProfile ng-src=\"{{ vm.user.data.avatar.coverImage }}\"></div><div ng-if=!vm.updatingProfile class=edit-profile-business__avatar ng-click=\"vm.showUploadUserProfilePhotos(\'profile\')\"><div class=hover-avatar-business-style>Edit</div><pixerf-user-avatar user-data=vm.user.data></pixerf-user-avatar></div></div><div class=edit-profile-business__profile-section ng-if=!vm.guestUser><div class=edit-profile-business__row><div class=edit-profile-business__name ng-class=\"{\'request-update-info\': vm.invalidBizInfo.first_name}\"><label required for=name translate>{{\'name\'}}</label><input name=name validation-no-hyperlink validation-no-number ng-model=vm.user.data.first_name class=form-control placeholder=\"{{\'name\' | translate}}\" required focus-me=true></div><div class=edit-profile-business__company-name ng-class=\"{\'request-update-info\': vm.invalidBizInfo.name}\"><label required for=company translate>{{\'company-name\'}}</label><input name=company validation-no-hyperlink ng-model=vm.user.data.organization.name class=form-control placeholder=\"{{\'company-name\' | translate}}\" required></div></div><div class=edit-profile-business__row><div class=edit-profile-business__registration-no ng-class=\"{\'request-update-info\': vm.invalidBizInfo.registration_no}\"><label required for=registration translate>{{\'company-registration-no\'}}</label><input required name=registration validation-no-hyperlink ng-model=vm.user.data.organization.registration_no class=form-control placeholder=\"{{\'company-registration-no\' | translate}}\"></div><div class=edit-profile-business__office-type ng-class=\"{\'request-update-info\': vm.invalidBizInfo.office_type}\"><label required for=officeType translate>{{\'office-type\'}}</label><select convert-mapping convert-mapping-parser=vm.officeParser(val) convert-mapping-formatter=vm.officeFormatter(val) required name=officeType class=form-control ng-model=vm.user.data.organization.office_type ng-options=\"opt.name for opt in vm.officeTypes.data track by opt.id \"></select></div></div><div class=edit-profile-business__row><div class=edit-profile-business__business-type><label for=bussiness_type>Bussiness Type</label><div class=edit-profile-business__business-type__list><custom-radio-button ng-repeat=\"item in vm.businessTypeOptions.selections\" class=edit-profile-business__business-type__item model=vm.businessType default=\"{{(item.value == vm.user.data.business_type) ? \'true\' : \'false\'}}\" options=vm.businessTypeOptions model-property={{vm.businessTypeOptions.props}} value=vm.businessTypeOptions.selections[$index].value label=vm.businessTypeOptions.selections[$index].label on-changed=vm.onBusinessTypeChanged(data)></custom-radio-button></div></div></div><div class=edit-profile-business__description><label for=bio translate>{{\'description\'}}</label><textarea name=bio ng-model=vm.user.data.organization.description rows=4 class=form-control placeholder=\"Tell us something about your company\"></textarea></div><div class=edit-profile-business__row><div class=edit-profile-business__country ng-class=\"{\'request-update-info\': vm.invalidBizInfo.country}\"><label required for=country>Country you are operating from</label><country-select class=form-control required name=country on-changed=vm.onCountrySelected(vm.user.data.organization.address.country) ng-model=vm.user.data.organization.address.country placeholder=Country></country-select></div><div class=edit-profile-business__phone ng-class=\"{\'request-update-info\': vm.invalidBizInfo.telephone}\"><label required for=telephone translate>{{\'phone-number\'}}</label><input type=text required national-mode=false international-phone-number default-country=sg ng-model=vm.user.data.organization.telephone name=telephone class=form-control></div></div><div class=edit-profile-business__row><div class=edit-profile-business__address-line-1><label for=street1 translate>{{\'address-line-1\'}}</label><input maxlength=255 name=street1 ng-model=vm.user.data.organization.address.street1 class=form-control placeholder=\"{{\'address-line-1\' | translate}}\"></div><div class=edit-profile-business__address-line-2><label for=street2>{{\'address-line-2\' | translate}}</label><input maxlength=255 name=street2 ng-model=vm.user.data.organization.address.street2 class=form-control placeholder=\"{{\'address-line-2\' | translate}}\"></div></div><div class=edit-profile-business__row><div class=edit-profile-business__city ng-class=\"{\'request-update-info\': vm.invalidBizInfo.city}\"><label required for=city>City / State / Province / Region</label><input maxlength=255 required validation-no-hyperlink validation-no-number name=city ng-model=vm.user.data.organization.address.city class=form-control placeholder=\"City / State / Province / Region\" g-places-autocomplete options=vm.gplacesOptions></div><div class=edit-profile-business__postal-code><label for=postal_code>{{\'postal-code\' | translate}}</label><input maxlength=255 validation-no-hyperlink name=postal_code ng-model=vm.user.data.organization.address.postal_code class=form-control placeholder=\"{{\'postal-code\' | translate}}\"></div></div></div><div class=edit-profile-business__account-section><div class=edit-profile-business__account-section__header translate>{{\'account\'}}</div><div class=edit-profile-business__email><label translate>{{\'your-email\'}}</label><input readonly=true name=email ng-model=vm.user.data.email class=\"form-control disable-focus\"></div></div></form></div><div class=edit-profile-business__footer><div class=edit-profile-business__footer__control><button class=\"edit-profile-business__save-btn btn btn-submit text--bold\" ng-click=\"vm.onSaveBtnClicked(vm.user.data, profileForm)\">{{\'save\' | translate}}</button></div></div></div></div>");
$templateCache.put("app/components/edit-profile/edit-profile-personal.html","<div class=edit-profile-personal><div class=edit-profile-personal__header><h4 class=edit-profile-personal__header__title translate>{{\'profile\'}}</h4></div><div class=edit-profile-personal__body><form name=profileForm class=edit-profile-personal__body__form><div class=edit-profile-personal__photo ng-if=!vm.guestUser><div class=edit-profile-personal__cover-photo-wrapper ng-click=\"vm.showUploadUserProfilePhotos(\'cover\')\"><div class=hover-cover-style>Edit</div><img ng-if=!vm.updatingProfile ng-src=\"{{ vm.user.data.avatar.coverImage }}\"></div><div ng-if=!vm.updatingProfile class=edit-profile-personal__avatar ng-click=\"vm.showUploadUserProfilePhotos(\'profile\')\"><div class=hover-avatar-personal-style>Edit</div><pixerf-user-avatar user-data=vm.user.data lazy=true></pixerf-user-avatar></div></div><div class=edit-profile-personal__profile-section ng-if=!vm.guestUser><div class=edit-profile-personal__row><div class=edit-profile-personal__first-name><label required for=first_name class=label-sign-up-information ng-class=\"!profileForm.$pristine && profileForm.first_name.$invalid ? \'text--color-error\' : \'text--color-black\'\" translate>{{\'first-name\'}}</label><input id=E6 maxlength=20 required validation-no-hyperlink validation-no-number name=first_name ng-model=vm.user.data.first_name class=form-control required focus-me=vm.isFocusField.data></div><div class=edit-profile-personal__last-name><label required for=last_name class=label-sign-up-information ng-class=\"!profileForm.$pristine && profileForm.last_name.$invalid ? \'text--color-error\' : \'text--color-black\'\" translate>{{\'last-name\'}}</label><input id=E7 maxlength=20 required validation-no-hyperlink validation-no-number name=last_name ng-model=vm.user.data.last_name class=form-control></div></div><div class=edit-profile-personal__row><div class=edit-profile-personal__country ng-class=\"{\'place-holder\': !vm.user.data.address.country}\"><label required for=country class=label-sign-up-information ng-class=\"!profileForm.$pristine && profileForm.country.$invalid ? \'text--color-error\' : \'text--color-black\'\" translate>{{\'country-of-origin\'}}</label><country-select on-changed=vm.onCountrySelected(vm.user.data.address.country) place-holder=\"Select country\" id=E9 class=form-control required name=country ng-model=vm.user.data.address.country></country-select></div><div class=edit-profile-personal__location ng-class=\"{\'place-holder\': !vm.user.data.address.country}\"><label required for=location class=label-sign-up-information ng-class=\"!profileForm.$pristine && profileForm.location.$invalid ? \'text--color-error\' : \'text--color-black\'\">{{\'city\' | translate}}/{{\'state\' | translate}}</label><input id=E10 required validation-no-hyperlink name=location ng-model=vm.user.data.location class=form-control g-places-autocomplete options=vm.gplacesOptions></div></div><div class=edit-profile-personal__row><div class=edit-profile-personal__year-of-birth><label required class=label-sign-up-information ng-class=\"!profileForm.$pristine && vm.invalidBirthday ? \'text--color-error\' : \'text--color-black\'\" translate>{{\'birth-date\'}}</label><div class=\"input-group pixerf-calendar-input\"><input type=text datepicker-options=\"{showWeeks: false}\" show-button-bar=false uib-datepicker-popup=d/MM/yyyy ng-model=vm.user.data.date_of_birth is-open=vm.filterFromIsVisible> <button type=button class=\"btn pixerf-calendar-input__toogle-btn\" ng-click=\"vm.filterFromIsVisible = !vm.filterFromIsVisible\"><i class=\"glyphicon glyphicon-calendar\"></i></button></div></div></div></div><div class=edit-profile-personal__ability ng-if=!vm.guestUser><div class=\"edit-profile-personal__header skill-exp clearfix\"><h4 class=\"text-left text--extrabold text--color-black\" translate>{{\'skills-experience\'}}</h4></div><div class=edit-profile-personal__bio><label for=userBio translate>{{\'about-yourself\'}}.</label><textarea name=userBio class=\"input__user-bio form-control\" cols=30 rows=4 ng-model=vm.user.data.bio></textarea></div><div class=\"edit-profile-personal__row edit-profile-personal__skill-exp\"><div class=edit-profile-personal__skill-exp__exp><label for=yearOfExp translate>{{\'years-of-experience\'}}</label><input type=text class=\"input__exp form-control\" name=yearOfExp ng-model=vm.serviceData.years_of_experience maxlength=2 min=0 type=number ng-pattern=/^\\d*$/ ></div><div class=edit-profile-personal__skill-exp__rates><label for=serviceRates translate>{{\'service-rates\'}}</label><div class=clearfix><pixerf-input-auto-complete class=edit-profile-personal__service-rates__dropdown-select options=\"{\'maxOptions\': 1, \'noneSelectedText\': \'Select\'}\" ng-if=vm.serviceRates name=service_rates dropdown-class=edit-profile-personal__dropdown data=vm.serviceRates model=vm.serviceData.serviceRatesSelected on-changed=vm.onServiceRatesSelected(vm.serviceData.serviceRatesSelected)></pixerf-input-auto-complete><div class=edit-profile-personal__service-rates__mount><input maxlength=255 min={{vm.CONST.SERVICES_RATE_MIN}} max={{vm.CONST.SERVICES_RATE_MAX}} type=number ng-pattern=/^\\d*$/ name=service_rates_unit ng-disabled=\"!vm.serviceData.serviceRatesSelected || !vm.serviceData.serviceRatesSelected.length\" validation-no-hyperlink ng-model=vm.serviceData.services_rate_amount class=\"form-control edit-profile-personal__service-rates__money\" placeholder=0.00><div class=edit-profile-personal__service-rates__unit>SGD</div></div></div></div><div class=edit-profile-personal__skill-exp__camera><label for=cameras translate>{{\'your-cameras\'}}</label><tags-input on-tag-adding=\"vm.onValidateTag($tag, $event)\" add-on-space=true add-on-blur=true ng-model=vm.serviceData.cameras type=text tag-class=camera-tag class=\"form-control camera-tag-input\" placeholder=\"Add a camera\"></tags-input></div></div><div class=edit-profile-personal__speciality><label required for=speciality translate>{{\'creator-specialities\'}}</label><dropdown-tag ng-if=vm.specialities max-selected={{vm.maxSpecialitiesSelected}} data=vm.specialities on-item-removed=\"vm.onItemChanged({items, item})\" on-item-selected=\"vm.onItemChanged({items, item})\" on-exceed-limit=vm.onExccedLimit() on-init=vm.serviceData.specialities></dropdown-tag><div class=edit-profile-personal__hint translate=select-speciality translate-values=\"{number: 5}\"></div></div><div class=edit-profile-personal__link-to-portfolio><label for=portfolio_url translate>{{\'link-to-your-portfolio\'}}</label><input name=portfolio_url ng-model=vm.user.data.portfolio_url class=form-control></div></div><div class=edit-profile-personal__availability><div class=edit-profile-personal__availability__title translate>{{\'are-you-interested-to-receive-project-briefs\'}}</div><div class=\"edit-profile-personal__checkbox-item edit-profile-personal__availability__checkbox-item\"><stick-checkbox on-changed=vm.onAvailabilityShowed(vm.serviceData.availability) model=vm.serviceData model-property=availability label=Yes layout-style=solid-square></stick-checkbox><!-- <stick-checkbox on-changed=\"vm.onAvailabilityShowed(vm.serviceData.availability)\"\r\n							model=\"vm.serviceData\" model-property=\"availability\" label=\"No\" is-reversed=\"true\"\r\n							layout-style=\"solid-square\">\r\n						</stick-checkbox> --><stick-checkbox on-changed=vm.onAvailabilityShowed(vm.serviceData.availability) model=vm.serviceData model-property=availability label=\"Not at the moment\" is-reversed=true layout-style=solid-square></stick-checkbox></div><div ng-if=vm.serviceData.availability class=edit-profile-personal__availability><div class=edit-profile-personal__availability-label translate>{{\'availability\'}}</div><div class=edit-profile-personal__availability-wrapper><div class=edit-profile-personal__checkbox-group><div class=edit-profile-personal__availability-label__duration translate>{{\'weekdays\'}}</div><div class=edit-profile-personal__list-options><div class=edit-profile-personal__checkbox-item><stick-checkbox on-changed=\"vm.onAvailabilityChanged(\'availability_weekdays\')\" model=vm.availability_weekdays model-property=day label=day layout-style=solid-square></stick-checkbox></div><div class=edit-profile-personal__checkbox-item><stick-checkbox on-changed=\"vm.onAvailabilityChanged(\'availability_weekdays\')\" model=vm.availability_weekdays model-property=evening label=evening layout-style=solid-square></stick-checkbox></div></div></div><div class=edit-profile-personal__checkbox-group><div class=edit-profile-personal__availability-label__duration translate>{{\'weekends\'}}</div><div class=edit-profile-personal__list-options><div class=edit-profile-personal__checkbox-item><stick-checkbox on-changed=\"vm.onAvailabilityChanged(\'availability_weekends\')\" model=vm.availability_weekends model-property=day label=day layout-style=solid-square></stick-checkbox></div><div class=edit-profile-personal__checkbox-item><stick-checkbox on-changed=\"vm.onAvailabilityChanged(\'availability_weekends\')\" model=vm.availability_weekends model-property=evening label=evening layout-style=solid-square></stick-checkbox></div></div></div></div></div><div ng-if=\"vm.serviceData.availability == true\" class=edit-profile-personal__availability__note>We will review your portfolio and contact you for future assignments.</div></div></form></div><div class=edit-profile-personal__account-section><div class=edit-profile-personal__account-section__header translate>{{\'account\'}}</div><div class=edit-profile-personal__email><label translate>{{\'your-email\'}}</label><input readonly=true name=email ng-model=vm.user.data.email class=\"form-control disable-focus\"></div></div></div><div class=edit-profile-personal__footer><div class=edit-profile-personal__footer__control><button class=\"edit-profile-personal__save-btn btn btn-submit text--bold\" ng-click=\"vm.onSaveBtnClicked(vm.user.data, profileForm)\" translate>{{\'save\'}}</button></div></div>");
$templateCache.put("app/components/edit-subscription/edit-subscription.html","<div><div class=\"row clearfix bg--white\"><h3 class=\"text-left text--bold\">Subscription</h3><p class=text-left>Nam porttitor blandit accumsan. Ut vel dictum sem, a pretium dui. In malesuada enim in dolor euismod, id commodo mi consectetur. Curabitur at vestibulum nisi.Nullam vehicula nisi velit. Mauristurpis nisl, molestie ut ipsum et, suscipit vehicula odio. Vestibulum interdum vestibulum felis acmolestie. Praesent aliquet quam et libero dictum, vitae dignissim leo eleifend. In in turpis turpis.</p><div class=clearfix><div class=\"clearfix edit-subscription__acc-types margin-md--top\"><div class=\"col-md-6 text-left\"><h3><span>Account Type</span><span class=\"glyphicon glyphicon-question-sign\" uib-tooltip=\"Admin can manage all aspects of the Page including creating post, creating ads, creatings missions!\" tooltip-placement=right></span></h3><h5>Curabitur lobortis id lorem id bibendum. Ut id consectetur magna. Quisque volutpat augue enim, pulvinar lobortis nibh lacinia at.</h5></div><div class=\"col-md-6 text-right\"><h3 class=\"text-uppercase text--bold\">Free</h3><h5 class=\"edit-subscription__acc-types__name text--bold\">Personal Account</h5></div></div><div class=clearfix><h3 class=\"text-center text--bold margin-md\">Check out our Plans and Subscriptions</h3><div class=clearfix><div class=\"col-md-6 edit-subscription__acc-types__acc\"><div class=\"text-center edit-subscription__acc-types__acc__header\"><h3>Basic</h3><h3 class=text--bold><sup>SGD$</sup><span class=edit-subscription__acc-types__acc__price>25</span><sup>.00</sup></h3><h4>monthly</h4></div><div class=\"text-left edit-subscription__acc-types__acc__body\"><p>- In hac habitasse platea dictumst.</p><p>- Vivamus adipiscing fermentum quam.</p><p>- Integer et elit eget elit facilisis tristique.</p></div><div class=\"text-center edit-subscription__acc-types__acc__footer\"><div class=\"btn btn-default\">Upgrade</div></div></div><div class=\"col-md-6 edit-subscription__acc-types__acc\"><div class=\"text-center edit-subscription__acc-types__acc__header\"><h3>Professional</h3><h3 class=text--bold><sup>SGD$</sup><span class=edit-subscription__acc-types__acc__price>100</span><sup>.00</sup></h3><h4>yearly</h4></div><div class=\"text-left edit-subscription__acc-types__acc__body\"><p>- In hac habitasse platea dictumst.</p><p>- Vivamus adipiscing fermentum quam.</p><p>- Integer et elit eget elit facilisis tristique.</p></div><div class=\"text-center edit-subscription__acc-types__acc__footer\"><div class=\"btn btn-default\">Upgrade</div></div></div></div><h5 class=\"text-center margin-md\">By clicking \"Select Plan\", I accepted the <a><b>Terms of Service</b></a></h5></div><div class=edit-subscription__faq><div><h3 class=text--bold>Frequently Asked Questions</h3><div class=edit-subscription__faq__items><ul><li ng-repeat=\"faq in vm.faqs.data\" ng-click=\"faq.isCollapsed = !faq.isCollapsed\">{{faq.question}}<span class=\"glyphicon glyphicon-triangle-bottom\"></span><div class=edit-subscription__faq__items__item__answer uib-collapse=faq.isCollapsed><div class=\"well well-lg\">{{faq.answer}}</div></div></li></ul></div></div></div><div class=devider></div><div class=\"text-center edit-subscription__more-question\"><h3 class=text--bold>Have More Questions?</h3><h5 class=margin-md>No problem. That’s what we’re here for! <span class=text--bold><a>Send us an email</a><span></span></span></h5><div class=\"btn btn-default\">Contact Us</div></div></div></div></div>");
$templateCache.put("app/components/email-contact-person/email-contact-person.html","<div class=\"email-contact-person relative\"><div class=\"relative email-contact-person__checkbox-wrapper\" ng-if=!hideSelect><pixerf-checkbox model=contact model-property=isSelected on-changed=onSelected()></pixerf-checkbox></div><div><div class=\"email-contact-person__display-name text--semibold text--truncate\" ng-if=contact.displayName>{{contact.displayName}}</div><div class=\"email-contact-person__email text--truncate\">{{contact.email.address}}</div></div></div>");
$templateCache.put("app/components/email-us-popup/email-us-popup.html","<div class=email-us-popup><div class=email-us-popup__close ng-click=vm.close()><span class=icon-icons_close aria-hidden=true></span></div><div class=email-us-popup__header translate>{{\'contact-title\'}}</div><div class=email-us-popup__infro-form><form name=profileForm><div class=email-us-popup__info-form__row><label for=name translate>{{\'name\'}}</label><input required validation-no-hyperlink validation-no-number ng-model=vm.inquiry.name name=name placeholder=\"Enter your name\" class=form-control></div><div class=email-us-popup__info-form__row><label for=email translate>{{\'email\'}}</label><input required name=email ng-model=vm.inquiry.email type=email class=form-control placeholder=\"Provide company email if applicable\"></div><div class=email-us-popup__info-form__row><label for=topic translate>{{\'topic\'}}</label><pixerf-input-auto-complete data=vm.topicTypes model=vm.selectedTopic options=vm.topicOptions on-changed=vm.onTopicChanged(vm.selectedTopic)></pixerf-input-auto-complete></div><div class=email-us-popup__info-form__row><label for=description>How can we help?</label><textarea required rows=4 name=description ng-model=vm.inquiry.description class=\"form-control form-control__textarea\" minlength=50></textarea></div></form></div><button ng-disabled=vm.isWorking type=button class=\"email-us-popup__submit-btn btn btn-submit\" ng-click=\"vm.sendEnquire(vm.inquiry, profileForm)\">Leave us a message</button></div>");
$templateCache.put("app/components/empty-profile-landing-page/empty-profile-landing-page.html","<div class=empty-profile-landing-page><div class=empty-profile-landing-page__header><div class=empty-profile-landing-page__header__wellcome>{{\'welcome-to-profile-page\'| translate}}</div><div class=empty-profile-landing-page__header__select-type>{{\'what-would-you-like-to-do-next\'| translate}}</div></div><div class=\"empty-profile-landing-page__icons show-{{vm.numberOfDataShow}}-item\" ng-class=\"{\'no-footer\': !vm.footerText}\"><div ng-repeat=\"item in vm.dataToShow\" ng-click=\" item.action()\" ng-hide=item.hidden class=empty-profile-landing-page__icons__item__wrapper><div class=empty-profile-landing-page__icons__item><div class=\"empty-profile-landing-page__icons__item__icon {{item.icon}}\"></div><div class=empty-profile-landing-page__icons__item__desc>{{item.desc}}</div></div></div></div><div ng-if=vm.footerText class=empty-profile-landing-page__footer><div class=empty-profile-landing-page__footer__text ng-bind-html=vm.footerText></div></div></div>");
$templateCache.put("app/components/empty-section/empty-section.html","<div class=empty-event-section><div ng-if=vm.content.title class=empty-event-section__title>{{vm.content.title}}</div><div ng-if=vm.content.description class=empty-event-section__description ng-bind-html=vm.content.description></div><div ng-if=vm.content.buttonText class=empty-event-section__submit-btn ng-click=vm.onAction()>{{vm.content.buttonText}}</div></div>");
$templateCache.put("app/components/event-detail-compile-template/event-detail-compile-template.html","<div class=event-detail-compile-template ng-class=\"{\'append-to-body\': appendToBody}\"><div class=event-detail-compile-template__header><div class=event-detail-compile-template__header__event-info><img ng-src={{vm.event.cover.thumbnail}} class=event-detail-compile-template__header__event-info__cover><div class=event-detail-compile-template__header__event-info__info><div class=event-detail-compile-template__header__event-info__info__name>{{vm.event.name}}</div></div><div class=event-detail-compile-template__header__event-info__controls><div class=\"event-detail-compile-template__header__event-info__controls__button event-detail-compile-template__header__event-info__controls__button__close icon-icons_close\" ng-click=vm.onClosed()></div></div></div><div class=event-detail-compile-template__header__tabs><div ng-click=\"vm.state = vm.viewStates.eventDetail\" class=event-detail-compile-template__header__tabs__item ng-class=\"{\'active\': vm.state == vm.viewStates.eventDetail}\">Event Details</div><div ng-if=vm.showAttendeesTab() ng-click=\"vm.state = vm.viewStates.attendees\" class=event-detail-compile-template__header__tabs__item ng-class=\"{\'active\': vm.state == vm.viewStates.attendees}\">Attendees ({{vm.event.stats.going || 0}})</div></div></div><div ng-if=\"vm.state == vm.viewStates.eventDetail\" class=event-detail-compile-template__content><form name=createEventForm class=event-detail-compile-template__content__event-detail ng-if=\"vm.state == vm.viewStates.eventDetail\"><div class=event-detail-compile-template__content__event-detail__control-button><div ng-if=\"!vm.editMode && vm.showInreviewMessage\" class=event-detail-compile-template__content__event-detail__control-button__notification><span class=event-detail-compile-template__content__event-detail__control-button__notification__icon><i class=\"fa fa-exclamation-circle\" aria-hidden=true></i></span> <span class=event-detail-compile-template__content__event-detail__control-button__notification__text>{{\'this-event-is-in-review\' | translate}}</span></div><div ng-if=\"!vm.editMode && vm.showShareBtn\" class=\"event-detail-compile-template__content__event-detail__control-button__button btn-share-event btn btn-cancel--no-background\" ng-click=vm.onShareEventBtnClicked()>Share Event<share ng-if=vm.SocialShareContent ng-click=$event.stopPropagation() display-vertical=false content-will-be-shared=vm.SocialShareContent class=share-social title=\"Share this event\"></share></div><div ng-if=\"!vm.editMode && vm.showEditEventBtn\" class=\"event-detail-compile-template__content__event-detail__control-button__button btn btn-submit\" ng-click=vm.onEditEventBtnClicked()>Edit Event</div><div ng-if=\"!vm.editMode && vm.showEditDraftBtn\" class=\"event-detail-compile-template__content__event-detail__control-button__button btn btn-cancel--no-background\" ng-click=vm.onEditEventBtnClicked()>Edit draft</div><div ng-if=\"!vm.editMode && vm.showPublishBtn\" class=\"event-detail-compile-template__content__event-detail__control-button__button btn btn-submit\" ng-click=vm.onPublishBtnClicked()>Publish</div><div ng-if=\"!vm.editMode && vm.showDeleteBtn\" class=\"event-detail-compile-template__content__event-detail__control-button__button btn btn-submit\" ng-click=vm.onDeleteEventBtnClicked()>Delete Event</div><div ng-if=\"!vm.editMode && vm.showRejectBtn\" class=\"event-detail-compile-template__content__event-detail__control-button__button btn btn-cancel--no-background\" ng-click=vm.onRejectEventBtnClicked()><i class=\"fa fa-times\" aria-hidden=true></i> Reject</div><div ng-if=\"!vm.editMode && vm.showApproveBtn\" class=\"event-detail-compile-template__content__event-detail__control-button__button btn btn-submit\" ng-click=vm.onApproveEventBtnClicked()><i class=\"fa fa-check\" aria-hidden=true></i> Resolve</div><div ng-if=\"!vm.editMode && vm.showEventCancelledBtn\" class=\"event-detail-compile-template__content__event-detail__control-button__button btn-disabled btn btn-cancel--no-background disabled\">Event cancelled</div><div ng-if=\"!vm.editMode && vm.showEventHasEndedBtn\" class=\"event-detail-compile-template__content__event-detail__control-button__button btn-disabled btn btn-cancel--no-background disabled\">Event has ended</div><div ng-if=\"!vm.editMode && vm.showEventRejectedBtn\" class=\"event-detail-compile-template__content__event-detail__control-button__button btn-disabled btn btn-cancel--no-background disabled\">Event rejected</div><div ng-if=\"!vm.editMode && vm.showEventDeletedBtn\" class=\"event-detail-compile-template__content__event-detail__control-button__button btn-disabled btn btn-cancel--no-background disabled\">Event deleted</div><div ng-click=vm.onShowInreviewMessage() ng-if=\"!vm.editMode && vm.showEventInReviewBtn\" class=\"event-detail-compile-template__content__event-detail__control-button__button btn btn-cancel--no-background\">Event in review</div><div ng-if=\"vm.editMode && vm.showCancelBtn\" class=\"event-detail-compile-template__content__event-detail__control-button__button btn btn-cancel--no-background\" ng-click=vm.onCancelSaveEventBtnClicked()>Cancel</div><div ng-if=\"vm.editMode && vm.showSaveBtn\" class=\"event-detail-compile-template__content__event-detail__control-button__button btn btn-submit\" ng-click=vm.onSaveEventBtnClicked()>Save</div><div ng-if=\"vm.editMode && vm.showSaveDraftBtn\" class=\"event-detail-compile-template__content__event-detail__control-button__button btn btn-cancel--no-background\" ng-click=vm.onSaveEventBtnClicked(true)>Save draft</div><div ng-if=\"vm.editMode && vm.showSaveAndPublishBtn\" class=\"event-detail-compile-template__content__event-detail__control-button__button btn btn-submit\" ng-click=vm.onSaveAndPublishBtnClicked()>Save and Publish</div></div><div ng-if=vm.editMode class=event-detail-compile-template__general__upload><div ng-if=\"vm.eventCover && vm.eventCover.url\" class=overlay-reselect ng-click=vm.showUploadAvatarPopup()><button class=\"btn btn-submit\">Reselect</button></div><div ng-if=\"vm.eventCover && vm.eventCover.url\" class=event-detail-compile-template__general__upload__thumbnail-section><img class=event-detail-compile-template__general__upload__thumbnail-section__image ng-src=\"{{vm.eventCover.url ?  vm.eventCover.url : \'/assets/images/default/community-default-avatar.png\'}}\"></div><div ng-if=\"!vm.eventCover || !vm.eventCover.url\" class=event-detail-compile-template__general__upload__submit-btn ng-click=vm.showUploadAvatarPopup()><div class=\"btn btn-submit\">{{\'select-photo\' | translate}}</div></div></div><img ng-if=!vm.editMode ng-src={{vm.event.cover.medium}} class=event-detail-compile-template__content__event-detail__cover><div class=event-detail-compile-template__content__event-detail__general-info><div class=event-detail-compile-template__content__event-detail__name><div class=event-detail-compile-template__content__event-detail__name__label ng-class=\"(!createEventForm.$pristine || vm.event.id) && createEventForm.name.$invalid ? \'text--color-error\' : \'text--color-black\'\">Event Name</div><div ng-if=!vm.editMode class=event-detail-compile-template__content__event-detail__name__value>{{vm.event.name}}</div><input ng-if=vm.editMode type=text maxlength=50 placeholder=\"E.g. Drone Photography Workshop\" name=name class=event-detail-compile-template__content__event-detail__name__input ng-model=vm.event.name required></div><div ng-if=!vm.editMode class=event-detail-compile-template__content__event-detail__privacy ng-class=\"{\'text--color-pixerf-theme\': !vm.event.is_private}\"><span class=event-detail-compile-template__content__event-detail__privacy__icon ng-class=\"vm.event.is_private ? \'icon-lock\' : \'icon-public-community\'\"></span> <span translate>{{vm.event.is_private ? \'private\' : \'public\'}}</span></div></div><div ng-if=vm.event.description class=event-detail-compile-template__content__event-detail__about><div class=event-detail-compile-template__content__event-detail__about__label>About this Event</div><div ng-if=!vm.editMode class=event-detail-compile-template__content__event-detail__about__value>{{vm.event.description}}</div><textarea ng-if=vm.editMode name=description cols=30 rows=10 placeholder=\"What is your event about? Who is it for?\" class=event-detail-compile-template__content__event-detail__about__input-textarea ng-model=vm.event.description></textarea></div><div class=event-detail-compile-template__content__event-detail__info><div ng-if=vm.editMode class=event-detail-compile-template__content__event-detail__info__header><div class=event-detail-compile-template__content__event-detail__info__label>Details</div></div><div class=event-detail-compile-template__content__event-detail__info__location ng-class=\"{\'edit-mode\' : vm.editMode}\"><div class=event-detail-compile-template__content__event-detail__info__label ng-class=\"{\'edit-mode\' : vm.editMode}\">Location</div><div ng-if=!vm.editMode class=event-detail-compile-template__content__event-detail__info__value>{{vm.event.location}}</div><input ng-if=vm.editMode type=text name=location class=event-detail-compile-template__content__event-detail__info__input g-places-autocomplete ng-model=vm.event.location required></div><div class=event-detail-compile-template__content__event-detail__info__date ng-class=\"{\'edit-mode\' : vm.editMode}\"><div ng-if=!vm.editMode class=event-detail-compile-template__content__event-detail__info__label ng-class=\"{\'edit-mode\' : vm.editMode}\">Date</div><div ng-if=!vm.editMode class=event-detail-compile-template__content__event-detail__info__value><div ng-repeat=\"schedule in vm.schedules\" class=event-detail-page__info-section__content__schedule><div>{{schedule.date}}</div><div>{{schedule.time}}</div></div></div><div ng-if=vm.editMode class=event-detail-compile-template__content__event-detail__info__date-time-select ng-repeat=\"dateTime in vm.dateTimes\"><div class=event-detail-compile-template__content__event-detail__info__date-time-select__date-picker><div class=\"event-detail-compile-template__content__event-detail__info__label edit-mode {{(!createEventForm.$pristine || vm.event.id) && createEventForm.name.$invalid ? \'text--color-error\' : \'text--color-black\'}}\">Date</div><div class=pixerf-calendar-input><div ng-if=\"vm.dateTimes.length > 1\" class=\"event-detail-compile-template__content__event-detail__info__date-time-select__remove-icon icon-icons_close\" ng-click=vm.onRemoveDateTime($index)></div><input type=text name=date class=\"form-control event-detail-compile-template__content__event-detail__info__input\" uib-datepicker-popup=dd/MM/yyyy ng-model=dateTime.date is-open=dateTime.calendar.isVisible close-text=Close ng-class=\"(!createEventForm.$pristine || vm.event.id) && createEventForm.date.$invalid ? \'text--color-error\' : \'text--color-black\'\" alt-input-formats=altInputFormats required> <button type=button class=pixerf-calendar-input__toggle-btn ng-click=\"dateTime.calendar.isVisible = !dateTime.calendar.isVisible\"><i class=\"glyphicon glyphicon-calendar\"></i></button></div></div><div class=event-detail-compile-template__content__event-detail__info__date-time-select__time-picker><div class=\"event-detail-compile-template__content__event-detail__info__label edit-mode\">Start Time</div><div class=event-detail-compile-template__content__event-detail__info__date-time-select__time-dropdown><timer-dropdown model=dateTime.start_time options=vm.timerOptions></timer-dropdown></div></div><div class=event-detail-compile-template__content__event-detail__info__date-time-select__time-picker><div class=\"event-detail-compile-template__content__event-detail__info__label edit-mode\">End Time</div><div class=event-detail-compile-template__content__event-detail__info__date-time-select__time-dropdown><timer-dropdown model=dateTime.end_time options=vm.timerOptions></timer-dropdown></div></div></div></div><div ng-if=vm.editMode class=event-detail-compile-template__content__event-detail__info__date-time-select__add-more ng-click=vm.onAddDateTime()>+ Add date and time</div></div><div class=\"event-detail-compile-template__content__event-detail__info no-border-bottom\"><div ng-if=vm.editMode class=event-detail-compile-template__content__event-detail__info__header><div class=event-detail-compile-template__content__event-detail__info__label>Admission</div></div><div ng-if=!vm.editMode class=event-detail-compile-template__content__event-detail__info__capacity><div class=event-detail-compile-template__content__event-detail__info__label>Capacity</div><div class=event-detail-compile-template__content__event-detail__info__value>{{vm.event.max_attendees_show}}</div></div><div ng-if=!vm.editMode class=event-detail-compile-template__content__event-detail__info__ticketing><div class=event-detail-compile-template__content__event-detail__info__label>Ticketing</div><div class=event-detail-compile-template__content__event-detail__info__value>{{vm.event.admission_type_show}}</div></div><div ng-if=vm.editMode class=event-detail-compile-template__content__event-detail__info__admission><mutiline-dropdown items=vm.admissionTypes selected=vm.defaultAdmissionTypes on-changed=vm.onAdmissionTypesChanged(data)></mutiline-dropdown><mutiline-dropdown items=vm.capacityTypes selected=vm.defaultCapacityType on-changed=vm.onCapacityTypeChanged(data)></mutiline-dropdown><div ng-if=vm.isLimitedCapacity class=event-detail-compile-template__content__event-detail__info__admission__capacity-section><div class=event-detail-compile-template__content__event-detail__info__admission__capacity-section__item><div class=event-detail-compile-template__content__event-detail__info__admission__capacity-section__item__label>Spot(s) Available</div><input type=text ng-model=vm.event.max_attendees class=event-detail-compile-template__content__event-detail__info__admission__capacity-section__item__input></div></div><mutiline-dropdown items=vm.eventTypes selected=vm.defaultEventType on-changed=vm.onEventTypeChanged(data)></mutiline-dropdown><div ng-if=\"vm.event && (vm.event.admission_type == vm.eventTypes[1].value)\" class=event-detail-compile-template__content__event-detail__info__admission__ticket-section><div class=event-detail-compile-template__content__event-detail__info__admission__ticket-section__item><span class=event-detail-compile-template__content__event-detail__info__admission__ticket-section__item__label>Ticket URL </span><input type=text ng-model=vm.event.ticket_url class=event-detail-compile-template__content__event-detail__info__admission__ticket-section__item__input></div></div></div></div><div ng-if=vm.editMode class=\"event-detail-compile-template__content__event-detail__control-button section-bottom no-margin-bottom\"><div ng-if=vm.showTitleBottomCancelThisEvent class=event-detail-compile-template__content__event-detail__control-button__label><a ng-click=vm.onCancelThisEventBtnClicked() ng-class=\"{\'text--color-pixerf-theme\': vm.canCancelEvent}\">Cancel this Event</a></div><div ng-if=vm.showTitleBottomDeleteThisDraft class=event-detail-compile-template__content__event-detail__control-button__label><a ng-click=vm.onDeleteThisDraftBtnClicked() class=text--color-pixerf-theme>Delete this draft</a></div><div class=event-detail-compile-template__content__event-detail__control-button__group-button><div ng-if=vm.showCancelBtnBottom class=\"event-detail-compile-template__content__event-detail__control-button__button btn btn-cancel--no-background\" ng-click=vm.onCancelSaveEventBtnClicked()>Cancel</div><div ng-if=vm.showSaveBtnBottom class=\"event-detail-compile-template__content__event-detail__control-button__button btn btn-submit\" ng-click=vm.onSaveEventBtnClicked()>Save</div><div ng-if=vm.showSaveDraftBtnBottom class=\"event-detail-compile-template__content__event-detail__control-button__button btn btn-cancel--no-background\" ng-click=vm.onSaveEventBtnClicked(true)>Save draft</div><div ng-if=vm.showSaveAndPublishBtnBottom class=\"event-detail-compile-template__content__event-detail__control-button__button btn btn-submit\" ng-click=vm.onSaveAndPublishBtnClicked()>Save and Publish</div></div></div><div ng-if=!vm.editMode class=event-detail-compile-template__content__event-detail__member><div class=event-detail-compile-template__content__event-detail__member__admin><div class=event-detail-compile-template__content__event-detail__member__label>Admin</div><div class=event-detail-compile-template__content__event-detail__member__avatar><img ng-class=\"{\'circle\': vm.event.owner.account_type === \'personal\'}\" ng-src=\"{{vm.event.owner.profile_image_media[\'100x\']}}\"></div></div><div class=event-detail-compile-template__content__event-detail__member__admin><div class=event-detail-compile-template__content__event-detail__member__label>Community</div><div class=event-detail-compile-template__content__event-detail__member__avatar><img ng-src={{vm.commnunityCover}}></div></div></div></form></div><div class=event-detail-compile-template__content__attendees ng-if=\"vm.state == vm.viewStates.attendees\"><section ng-if=\"vm.state == vm.viewStates.attendees\" class=event-detail-compile-template__content__attendees-section><div class=event-detail-compile-template__content__attendees-section__filter><div class=event-detail-compile-template__content__attendees-section__filter__label translate>{{\'filter-by\'}}:</div><mutiline-dropdown items=vm.eventStatFilterBy selected=vm.defaultEventStatFilterBy on-changed=vm.onEventStatFilterByChanged(data) class=event-detail-compile-template__content__attendees-section__filter__dropdown></mutiline-dropdown><div class=event-detail-compile-template__content__attendees-section__filter__group-btn><button ng-if=vm.isShowInviteButton ng-click=vm.onInviteMembers() class=\"event-detail-compile-template__content__attendees-section__filter__invite-btn btn btn-submit\">Invite</button> <button ng-if=vm.showEventCancelledBtn class=\"event-detail-compile-template__content__attendees-section__filter__button btn-disabled btn btn-cancel--no-background disabled\">Event cancelled</button> <button ng-if=vm.showEventRejectedBtn class=\"event-detail-compile-template__content__attendees-section__filter__button btn-disabled btn btn-cancel--no-background disabled\">Event rejected</button> <button ng-if=vm.showEventDeletedBtn class=\"event-detail-compile-template__content__attendees-section__filter__button btn-disabled btn btn-cancel--no-background disabled\">Event deleted</button> <button ng-if=vm.showEventInReviewBtnBottom ng-click=vm.onShowInreviewMessagebottom() class=\"event-detail-compile-template__content__attendees-section__filter__button btn btn-cancel--no-background\">Event in review</button> <button ng-if=vm.showEventHasEndedBtn class=\"event-detail-compile-template__content__attendees-section__filter__button btn-disabled btn btn-cancel--no-background disabled\">Event has ended</button></div></div><div ng-if=\"!vm.editMode && vm.showInreviewMessageBottom\" class=event-detail-compile-template__content__attendees-section__notification><span class=event-detail-compile-template__content__event-detail__control-button__notification__icon><i class=\"fa fa-exclamation-circle\" aria-hidden=true></i></span> <span class=event-detail-compile-template__content__event-detail__control-button__notification__text>{{\'this-event-is-in-review\' | translate}}</span></div><div class=event-detail-compile-template__content__attendees-section__content><div class=event-detail-compile-template__content__attendees-section__content__title>You have <b>{{vm.statsFilter.users}}</b> {{vm.statsFilter.desc}}.<div ng-if=vm.statsFilter.note class=event-detail-compile-template__content__attendees-section__content__note>{{vm.statsFilter.note}}</div></div><user-list-view event=vm.event users=vm.getAttendees() on-removed=vm.onRemovedUser(user) control=vm.showUserControl() context={{vm.userContext}}></user-list-view></div></section></div></div>");
$templateCache.put("app/components/event-detail-tile/event-detail-tile.html","<div class=event-detail-tile><div uib-dropdown class=event-detail-tile__control-more><span ng-if=\"vm.loginUser && !vm.isMine\" uib-dropdown-toggle class=icon-icons_more></span><ul class=event-detail-tile__list uib-dropdown-menu role=menu><li role=menuitem class=event-detail-tile__item ng-click=vm.onReportEvent(vm.data) translate translate-values=\"{thing: \'event\'}\">{{\'report-thing\'}}</li></ul></div><a class=event-detail-tile__cover ui-sref=\"event-detail-page.event-photos({id: vm.data.id, name: (vm.data.name | toSnakeCase)})\"><img ng-src={{vm.data.cover.original}} class=event-detail-tile__img alt=\"\"><div class=event-detail-tile__calendar><div class=event-detail-tile__calendar__month>{{vm.eventDate.month}}</div><div class=event-detail-tile__calendar__day>{{vm.eventDate.day}}</div></div></a><div class=event-detail-tile__info><div class=event-detail-tile__info__time><div ng-repeat=\"time in vm.schedules\">{{time}}</div></div><div class=event-detail-tile__info__name><a ui-sref=\"event-detail-page.event-photos({id: vm.data.id, name: (vm.data.name | toSnakeCase)})\">{{vm.data.name}}</a></div><div class=event-detail-tile__info__subinfo><div class=event-detail-tile__info__subinfo__location><span class=\"event-detail-tile__info__subinfo__location__icon icon-icons-location\"></span> <span class=event-detail-tile__info__subinfo__location__value>{{vm.data.location}}</span></div><div class=event-detail-tile__info__subinfo__type>{{vm.typeEvent}}</div></div><div class=\"event-detail-tile__info__description {{vm.elementClassname}}\"><span class=event-detail-tile__info__description-text>{{vm.data.description}}</span> <span class=event-detail-tile__info__description__read-more ng-click=\"!vm.isProcessinDescription && vm.onToggleFullDescription()\">See {{vm.isFullDescription ? \'less\' : \'more\'}}</span></div><div class=event-detail-tile__info__attendees><div ng-if=vm.data.joined_users.length class=event-detail-tile__info__attendees__label>Who\'s going</div><ul ng-if=vm.data.joined_users.length class=event-detail-tile__info__attendees__list><li ng-repeat=\"user in vm.data.joined_users | limitTo: 3\" class=event-detail-tile__info__attendees__item ng-style=\"{\'background-image\': \'url(\\\'\' + user.profile_image_media[\'100x\'] + \'\\\')\'}\"></li><li ng-if=\"vm.data.stats.going > 3\" class=event-detail-tile__info__attendees__info-item>+{{vm.data.stats.going - 3}}</li></ul><div ng-if=vm.isLimitedCapacity class=event-detail-tile__info__attendees__available ng-class=\"{\'sold-out\': !vm.data.stats.available, \'few-spots-left\': vm.isFewSpotsLeft}\">{{vm.availableTicketLabel}}</div><div ng-if=!vm.isMine class=event-detail-tile__info__control><div class=\"event-detail-tile__info__control__button btn btn-cancel--no-background\" ng-class=\"{\'enabled\': vm.data.has_interest}\" ng-click=vm.onInterested()><span class=\"event-detail-tile__info__control__icon icon-icons_check\"></span>Interested</div><div class=\"event-detail-tile__info__control__button btn btn-cancel--no-background\" ng-class=\"{\'enabled\': vm.data.has_joined}\" ng-click=vm.onGoing()><span class=\"event-detail-tile__info__control__icon icon-icons_check\"></span>Going</div></div></div></div></div>");
$templateCache.put("app/components/event-explore-tile/event-explore-tile.html","<div class=event-explore-tile ng-click=vm.onGoEventDetails(vm.event)><div class=event-explore-tile__content><div class=event-explore-tile__content__cover><img class=event-explore-tile__content__cover__avatar ng-src={{vm.event.cover.large}}></div><div class=event-explore-tile__content__info><div class=event-explore-tile__content__info__general-wrapper><div class=event-explore-tile__content__info__time>{{vm.eventDate}}{{vm.eventTimes}}</div><div class=\"event-explore-tile__content__info__title {{vm.event.id}}\">{{vm.event.name}}</div><div class=event-explore-tile__content__info__general-info><div class=\"event-explore-tile__content__info__general-info__location {{vm.event.id}}\"><span class=\"event-explore-tile__content__info__general-info__location__icon icon-location2\"><span class=\"event-explore-tile__content__info__general-info__location__icon icon-location2\"><span class=path1></span><span class=path2></span> </span></span><span class=event-explore-tile__content__info__general-info__location__address>{{vm.event.info.location || \'All Countries\'}}</span><div class=event-explore-tile__content__info__general-info__admission-type><span class=event-explore-tile__content__info__general-info__divide></span> <span translate>{{vm.admissionType}}</span></div></div></div><div class=event-explore-tile__content__info__members><div class=event-explore-tile__content__info__members__info-wrapper><div class=event-explore-tile__content__info__members__list><div ng-repeat=\"user in vm.interactiveUsers | limitTo: (vm.interactiveUsers.length == 4 ? 4 : 3)\" class=event-explore-tile__content__info__members__item><pixerf-user-avatar user-data=user lazy=true></pixerf-user-avatar></div><div ng-if=\"vm.interactiveUsers.length > 4\" class=event-explore-tile__content__info__members__remaining>+{{vm.interactiveUsers.length - 3}}</div></div><div ng-if=vm.event.info.max_attendees class=event-explore-tile__content__info__spots-available ng-class=\"{\'full-spots\': !vm.spotsAvailable, \'low-available\': (vm.rateSpotsLeft < 20 && vm.spotsAvailable)}\">{{vm.spotsAvailable === 1 ? vm.spotsAvailable + \' spot left\' : vm.spotsAvailable ? vm.spotsAvailable + \' spots left!\' : \'Full\'}}</div><div ng-if=!vm.event.info.max_attendees class=\"event-explore-tile__content__info__spots-available unlimited-capacity\">Unlimited Capacity</div></div><div class=event-explore-tile__content__info__members__hint ng-bind-html=vm.introInvitedText></div></div></div><div ng-if=\"vm.membershipStatus && (!vm.noBookingYet || vm.isOwner)\" class=event-explore-tile__content__info__membership ng-class=\"{\'can-click\': !vm.event.info.has_interest && !vm.event.info.has_joined}\" check-verified-email=true authentication-click=vm.onInterested()><stick-checkbox ng-if=\"vm.event.info.has_interest || vm.event.info.has_joined\" model=vm model-property=selected is-disabled=true label={{vm.membershipStatus}} custom-class=\"{{vm.event.info.has_interest ? \'interested\' : \'joined\'}}\"></stick-checkbox><span ng-if=\"!vm.event.info.has_interest && !vm.event.info.has_joined\">{{vm.membershipStatus | translate}}{{vm.event.membership_status === \'accepted\' ? \"!\" : \"\"}}</span></div><div ng-if=\"vm.noBookingYet && !vm.isOwner\" class=event-explore-tile__content__info__membership><span>Coming soon</span></div></div></div></div>");
$templateCache.put("app/components/event-list-tile/event-list-tile.html","<div class=event-list-tile><a ui-sref=\"event-detail-page.event-photos({id: vm.data.id, name: (vm.data.name | toSnakeCase)})\"><div class=event-list-tile__calendar><div class=event-list-tile__calendar__month>{{vm.eventDate.month}}</div><div class=event-list-tile__calendar__day>{{vm.eventDate.day}}</div></div><div class=\"event-list-tile__info text--truncate\"><div class=event-list-tile__info__timer><div ng-repeat=\"time in vm.schedules\" class=text--truncate>{{time}}</div></div><div class=\"event-list-tile__info__name text--truncate\">{{vm.data.name}}</div><div class=\"event-list-tile__info__location text--truncate\">{{vm.data.location}}</div></div></a></div>");
$templateCache.put("app/components/event-list-view-tile/event-list-view-tile.html","<div class=event-list-view-tile><a ui-sref=\"event-detail-page.event-photos({id: vm.event.id, name: (vm.event.name | toSnakeCase)})\"><div class=event-list-view-tile__avatar ng-style=\"{\'background-image\': \'url(\\\'\' + vm.event.cover.thumbnail + \'\\\')\'}\"></div></a><div class=event-list-view-tile__info><div class=\"event-list-view-tile__info__name text--truncate\">{{vm.event.name}}</div><div class=event-list-view-tile__info__destination><div>{{vm.eventStartDate.day}} {{vm.eventStartDate.month}} {{vm.eventStartDate.year}}{{vm.event.venue? (\', \' + vm.event.venue) : \'\'}}{{vm.event.location? (\', \' + vm.event.location) : \'\'}}</div></div><div class=event-list-view-tile__control ng-if=!vm.isOwner><div class=event-list-view-tile__control__button ng-click=vm.onInterested()>{{vm.event.has_interest ? ((\'you-re-interested\' | translate) + \'!\') : (\'interested\' | translate)}}</div><div ng-if=!vm.event.has_joined class=event-list-view-tile__control__seperate></div><div ng-if=!vm.event.has_joined class=event-list-view-tile__control__button ng-click=vm.onGoing()>{{vm.event.has_joined ? (\'share\' | translate) : (\'going\' | translate)}}</div></div></div></div>");
$templateCache.put("app/components/event-list-view/event-list-view.html","<div class=event-list-view><div ng-if=vm.showCheckbox ng-click=vm.onEventClicked(vm.event) class=\"event-list-view__item event-list-view__select {{\'col-order-\'+ vm.colsOrder.selectBox}}\"><stick-checkbox on-changed=vm.onToggleSelected(vm.event) model=event model-property=isSelected layout-style=regular-square></stick-checkbox></div><div ng-click=vm.onEventClicked(vm.event) class=\"event-list-view__event {{\'col-order-\'+ vm.colsOrder.eventName}}\"><div class=event-list-view__event__name__wrapper><img ng-src={{event.cover.thumbnail}} class=event-list-view__event__cover><a class=event-list-view__event__name ng-class=\"{\'line-through\': [\'cancelled\', \'rejected\'].includes(event.status) }\" ng-click=vm.prevenPubbleClick() ui-sref=\"event-detail-page({id: event.id,name: event.name})\" target=_blank>{{event.name}}</a></div></div><div ng-if=vm.showCommunityName ng-click=vm.onEventClicked(vm.event) class=\"event-list-view__item event-list-view__community {{\'col-order-\'+ vm.colsOrder.communityName}}\"><span class=event-list-view__item__mobile-label__haft-col>Community:</span> {{event.community_name}}</div><div ng-if=vm.showAdmin ng-click=vm.onEventClicked(vm.event) class=\"event-list-view__item event-list-view__admin {{\'col-order-\'+ vm.colsOrder.admin}}\"><span class=event-list-view__item__mobile-label__haft-col>Admin:</span> <span class=event-list-view__item__mobile-label__haft-col>{{vm.event.owner.displayName}}</span><div class=event-list-view__admin__member__avatar><img ng-class=\"{\'circle\': vm.event.owner.account_type === \'personal\'}\" ng-src=\"{{vm.event.owner.profile_image_media[\'100x\']}}\"></div></div><div ng-if=vm.showPrivacy ng-click=vm.onEventClicked(vm.event) class=\"event-list-view__item event-list-view__privacy {{\'col-order-\'+ vm.colsOrder.privacy}}\"><span class=event-list-view__item__mobile-label__haft-col>Privacy:</span><div><span class=event-list-view__privacy__icon ng-class=\"event.is_private ? \'icon-lock\' : \'icon-public-community text--color-pixerf-theme\'\"></span> <span class=event-list-view__privacy__label translate>{{event.is_private ? \'private\' : \'public\'}}</span></div></div><div ng-if=vm.showEventDate ng-click=vm.onEventClicked(vm.event) class=\"event-list-view__item event-list-view__event-date {{\'col-order-\'+ vm.colsOrder.eventTime}}\"><span class=event-list-view__item__mobile-label__haft-col>Date of event:</span><div class=event-list-view__item__mobile-label__list><div ng-repeat=\"time in vm.schedules | orderBy:\'start_datetime\'\">{{time.text}}</div></div></div><div ng-if=vm.showCapacity ng-click=vm.onEventClicked(vm.event) class=\"event-list-view__item event-list-view__capacity {{\'col-order-\'+ vm.colsOrder.attendees}}\" ng-class=\"{\'col-interested-style\': vm.type == \'interested\'}\"><span class=event-list-view__item__mobile-label__haft-col>Capacity:</span> <span>{{event.max_attendees ? event.max_attendees : \'No limit\'}}</span></div><div ng-if=vm.showGoing ng-click=vm.onEventClicked(vm.event) class=\"event-list-view__item event-list-view__event-going {{\'col-order-\'+ vm.colsOrder.statGoing}}\" ng-class=\"{\'col-interested-style\': vm.type == \'interested\', \'col-invited-style\': vm.type == \'invited\'}\"><span class=event-list-view__item__mobile-label__haft-col>Going:</span> <span>{{event.stats.going | number: 0}}</span></div><div ng-if=vm.showInterested ng-click=vm.onEventClicked(vm.event) class=\"event-list-view__item event-list-view__event-interested {{\'col-order-\'+ vm.colsOrder.interested}}\" ng-class=\"{\'col-interested-style\': vm.type == \'interested\', \'col-invited-style\': vm.type == \'invited\'}\"><span class=event-list-view__item__mobile-label__haft-col>Interested:</span> <span>{{event.stats.interested | number: 0}}</span></div><div ng-if=vm.showInvited ng-click=vm.onEventClicked(vm.event) class=\"event-list-view__item event-list-view__event-invited {{\'col-order-\'+ vm.colsOrder.invited}}\"><span class=event-list-view__item__mobile-label__haft-col>Invited:</span> <span>{{event.stats.invited | number: 0}}</span></div><div ng-if=vm.showIsHost ng-click=vm.onEventClicked(vm.event) class=\"event-list-view__item event-list-view__event-host {{\'col-order-\'+ vm.colsOrder.Host}}\"><span class=event-list-view__item__mobile-label__haft-col>Host?:</span> <span>{{vm.isMine ? \'Yes\' : \'No\'}}</span></div><div ng-if=vm.showStatus ng-click=vm.onEventClicked(vm.event) class=\"event-list-view__item event-list-view__status {{\'col-order-\'+ vm.colsOrder.status}}\"><span class=event-list-view__item__mobile-label__haft-col>Status:</span> <span ng-if=vm.isAdmin ng-class=\"event.status == \'draft\' ? \'blue-status-theme\' : \'red-status-theme\'\">{{vm.convetedStatus ? vm.convetedStatus : event.status}}</span> <span ng-if=!vm.isAdmin ng-class=\"{\'red-status-theme\': (vm.convetedStatus && [\'cancelled\',\'reported\',\'rejected\'].includes(vm.convetedStatus)) || (!vm.convetedStatus && [\'cancelled\',\'reported\',\'rejected\'].includes(event.status))}\">{{vm.convetedStatus ? vm.convetedStatus : event.status}}</span></div><div ng-if=vm.showActionList class=\"event-list-view__item event-list-view__action-list\" ng-class=\"{\'col-interested-style\': vm.type == \'interested\', \'col-invited-style\': vm.type == \'invited\', \'col-draft-style\': vm.type == \'draft\', \'col-inreview-style\': vm.type == \'inReview\'}\"><div class=\"event-list-view__item event-list-view__action-list__wrapper\"><button ng-if=vm.showInviteBtn class=\"event-list-view__action-list__invite-btn btn\" ng-class=\"{\'action-margin-right\': [\'hosting\', \'going\'].includes(vm.type), \'btn-cancel\': [\'cancelled\', \'rejected\'].includes(event.status), \'btn-submit\': ![\'cancelled\', \'rejected\'].includes(event.status)}\" ng-click=vm.onInviteFriends()><span class=event-list-view__action-list__invite-btn__label>Invite friends</span></button> <button ng-if=vm.showGoingBtn class=\"event-list-view__action-list__going-btn btn btn-submit\" ng-click=vm.onToggleGoingEvent() ng-class=\"{\'action-margin-right\': vm.type == \'interested\'}\"><span class=event-list-view__action-list__going-btn__label>Going</span></button> <button ng-if=vm.showDeclineBtn class=\"event-list-view__action-list__decline-btn btn btn--transparent\" ng-click=vm.onDeclineEvent() ng-class=\"{\'action-margin-right\': vm.type == \'invited\'}\"><span class=\"event-list-view__action-list__decline-btn__icon icon-icons_close\"></span> <span class=event-list-view__action-list__decline-btn__label>Decline</span></button> <button ng-if=vm.showAcceptBtn class=\"event-list-view__action-list__accept-btn btn btn-submit\" ng-click=vm.onAcceptEvent() ng-class=\"{\'action-margin-right\': vm.type == \'invited\'}\"><span class=\"event-list-view__action-list__accept-btn__icon icon-icons_check\"></span> <span class=event-list-view__action-list__accept-btn__label>Accept</span></button> <button ng-if=vm.showEditBtn class=\"event-list-view__action-list__edit-btn btn btn--transparent\" ng-click=vm.onEditEvent()><span class=event-list-view__action-list__edit-btn__label>Edit Event</span></button> <button ng-if=vm.showCreateBtn class=\"event-list-view__action-list__create-btn btn btn-submit\" ng-click=vm.onCreateEvent()><span class=event-list-view__action-list__create-btn__label>Create Event</span></button><div uib-dropdown is-open=vm.isActionListOpen class=event-list-view__action-list__btn-wrapper><span uib-dropdown-toggle class=\"event-list-view__action-list__icon icon-icons_more\" ng-click=vm.prevenPubbleClick()></span><ul class=event-list-view__action-list__list uib-dropdown-menu role=menu><li role=menuitem class=event-list-view__action-list__item ng-repeat=\"item in vm.actionList\" ng-click=item.cta(vm.comment)>{{item.label}}</li></ul></div></div></div></div>");
$templateCache.put("app/components/event-post-comment/event-post-comment.html","<div class=event-post-comment__block><div id={{vm.comment.id}} scroll-to-element=vm.scrollToThis offset-top=160 class=event-post-comment ng-class=vm.layout><div class=event-post-comment__author><a ng-if=\"vm.comment.user.account_type === \'personal\'\" ui-sref=\"user-home-page.personal.home({id: vm.comment.user.id, userName: (vm.comment.user.displayName | toSnakeCase)})\" target=_blank><pixerf-user-avatar class=event-post-comment__author__avatar user-data=vm.comment.user lazy=true></pixerf-user-avatar></a><pixerf-user-avatar ng-if=\"vm.comment.user.account_type === \'business\'\" class=event-post-comment__author__avatar user-data=vm.comment.user lazy=true></pixerf-user-avatar><div class=event-post-comment__author__text><span class=event-post-comment__author__name>{{vm.comment.user.displayName}}</span> <span class=event-post-comment__author__content>{{vm.comment.text}}</span><div ng-if=\"vm.comment.photos && vm.comment.photos.length\" class=event-post-comment__author__attachment flex-grid ng-model=vm.comment.photos rowheight=100 margins=5><div ng-repeat=\"photo in vm.comment.photos\"><a ng-attr-fancyboxable=\"{\'type\': \'image\', \'overlayShow\': true, \'hideOnOverlayClick\': true, \'showNavArrows\': true, \'margin\': \'50 10 15 10\', \'centerOnScroll\': true}\" href={{photo.url.large}} rel=commentAttachment><img ng-src={{photo.url.thumbnail}}></a></div></div><div class=event-post-comment__reply ng-if=\"vm.comment.reply_count > 0\" ng-click=vm.onToggleReplyDropdown()><div class=event-post-comment__reply__count>{{vm.comment.reply_count}}</div><div class=event-post-comment__reply__label>{{vm.comment.reply_count === 1 ? (\'reply\' | translate).toLowerCase() : (\'replies\' | translate).toLowerCase()}}</div><div class=event-post-comment__reply__icon ng-class=\"vm.isRepliedOpen ? \'icon-icons_chevron-up\' : \'icon-icons_chevron-down\'\"></div></div></div></div><div class=event-post-comment__info><div ng-if=\"vm.comment.like_count > 0\" class=\"event-post-comment__info__item event-post-comment__info__like\" ng-click=vm.onShowListLike() title=\"Click to see who liked this discussion\"><span class=event-post-comment__info__like__count>{{vm.comment.like_count}}</span> <span class=event-post-comment__info__like__label>{{vm.comment.like_count === 1 ? (\'like\' | translate).toLowerCase() : (\'likes\' | translate).toLowerCase()}}</span></div><div class=\"event-post-comment__info__item event-post-comment__info__time\">{{vm.time}}</div><div ng-if=\"vm.comment.user.id != vm.loginUser.id\" class=\"event-post-comment__info__item event-post-comment__info__control-like\" ng-class=\"{\'liked\': vm.comment.is_liked}\" authentication-click=vm.onLikeComment(vm.comment)>{{vm.comment.likeLabel}}</div><div ng-if=canReply class=\"event-post-comment__info__item event-post-comment__info__control-reply\" authentication-click=vm.onReplyInput()>{{\'reply\' | translate}}</div><div uib-dropdown class=\"event-post-comment__info__item event-post-comment__info__control-more\"><span uib-dropdown-toggle class=icon-icons_more></span><ul class=event-post-comment__info__control-more__list uib-dropdown-menu role=menu><li ng-if=!vm.isOwner role=menuitem class=event-post-comment__info__control-more__item ng-click=vm.onReportComment(vm.comment) translate translate-values=\"{thing: (\'comment\' | translate)}\">{{\'report-thing\'}}</li><li ng-if=\"vm.isOwner || vm.loginUser.canRemoveReplyDiscussion\" role=menuitem class=event-post-comment__info__control-more__item ng-click=vm.onRemoveComment(vm.comment)>{{\'remove\' | translate}}</li></ul></div></div></div><div ng-if=vm.isRepliedOpen class=\"event-post-comment__child author-block\" ng-repeat=\"subComment in vm.subComments\"><div class=event-post-comment__author><pixerf-user-avatar class=event-post-comment__author__avatar user-data=subComment.user lazy=true></pixerf-user-avatar><div class=event-post-comment__author__text><span class=event-post-comment__author__name>{{subComment.user.displayName}}</span> <span class=event-post-comment__author__content>{{subComment.text}}</span></div></div><div class=event-post-comment__info><div ng-if=\"subComment.like_count > 0\" class=\"event-post-comment__info__item event-post-comment__info__like\" ng-click=vm.onShowListLike(subComment)><span class=event-post-comment__info__like__count>{{subComment.like_count}}</span> <span class=event-post-comment__info__like__label>{{subComment.like_count === 1 ? (\'like\' | translate).toLowerCase() : (\'likes\' | translate).toLowerCase()}}</span></div><div class=\"event-post-comment__info__item event-post-comment__info__time\">{{subComment.time}}</div><div ng-if=\"subComment.user.id != vm.loginUser.id\" class=\"event-post-comment__info__item event-post-comment__info__control-like\" ng-class=\"{\'liked\': subComment.is_liked}\" authentication-click=vm.onLikeComment(subComment)>{{subComment.likeLabel}}</div><div uib-dropdown class=\"event-post-comment__info__item event-post-comment__info__control-more\"><span uib-dropdown-toggle class=icon-icons_more></span><ul class=event-post-comment__info__control-more__list uib-dropdown-menu role=menu><li ng-if=!subComment.isOwner role=menuitem class=event-post-comment__info__control-more__item ng-click=vm.onReportComment(subComment) translate translate-values=\"{thing: (\'comment\' | translate)}\">{{\'report-thing\'}}</li><li ng-if=\"subComment.isOwner || vm.loginUser.canRemoveReplyDiscussion\" role=menuitem class=event-post-comment__info__control-more__item ng-click=\"vm.onRemoveComment(subComment, true)\">{{\'remove\' | translate}}</li></ul></div></div></div><div ng-if=vm.replyCommentShow class=event-post-comment__reply-comment><pixerf-user-avatar class=event-post-comment__reply-comment__author-avatar user-data=vm.loginUser lazy=true></pixerf-user-avatar><input type=text class=event-post-comment__reply-comment__input ng-model=vm.replyComment><div class=event-post-comment__reply-comment__submit-btn ng-click=vm.onReplyCommentEventPost(vm.replyComment) uib-tooltip=Send></div></div></div>");
$templateCache.put("app/components/event-post-item/event-post-item.html","<div class=discussion-item><div uib-dropdown class=discussion-item__control-more><span ng-if=vm.controls.length uib-dropdown-toggle class=icon-icons_more></span><ul class=discussion-item__list uib-dropdown-menu role=menu><li ng-repeat=\"item in vm.controls\" ng-if=item.showControl role=menuitem class=discussion-item__item ng-click=item.cta()>{{item.label}}</li></ul></div><div class=discussion-item__header><div class=discussion-item__header__info><div class=discussion-item__header__info__author><pixerf-user-avatar user-data=vm.post.user class=discussion-item__header__info__author__cover lazy=true></pixerf-user-avatar><div class=discussion-item__header__info__author__info><a class=discussion-item__header__info__author__name ng-click=vm.prevenPubbleClick() ui-sref=\"user-home-page.personal.home({id: vm.post.user.id, userName: (vm.post.user.displayName | toSnakeCase)})\" target=_blank uib-tooltip=\"{{vm.post.user.displayName || vm.post.user.email}}\">{{vm.post.user.displayName || vm.post.user.email}} </a><span class=discussion-item__header__info__author__creator-type>{{vm.post.user.organization ? vm.post.user.organization.name : \'\'}}</span></div></div><div class=discussion-item__header__info__time>{{vm.inserted_at}}</div></div><div class=discussion-item__header__title ng-click=vm.goDetailDiscussion(vm.post)>{{vm.post.subject}}</div></div><div class=discussion-item__content ng-click=vm.goDetailDiscussion(vm.post)><div class=discussion-item__description>{{vm.post.description}}</div><div ng-if=\"vm.post.photos && vm.post.photos.length\" class=discussion-item__photo-grid flex-grid ng-model=vm.post.photos rowheight=50 lastrow=justify margins=10><div ng-repeat=\"photo in vm.post.photos\"><a ng-attr-fancyboxable=\"{\'type\': \'image\', \'overlayShow\': true, \'hideOnOverlayClick\': true, \'showNavArrows\': true, \'margin\': \'50 10 15 10\', \'centerOnScroll\': true}\" href={{photo.url.large}} rel=discussionAttachment><img ng-src={{photo.url.thumbnail}}></a></div></div></div><div class=discussion-item__info><div class=discussion-item__info__status><div ng-if=\"vm.post.like_count > 0\" class=discussion-item__info__like ng-click=vm.onShowListLike() title=\"Click to see who liked this discussion\"><span class=\"discussion-item__control__icon icon-icons_like\"></span> <span class=discussion-item__info__value>{{vm.post.like_count}}</span></div><div ng-if=\"vm.post.reply_count > 0\" class=discussion-item__info__reply ng-click=vm.onShowListReply() title=\"Click to see who replied this photo\"><span class=discussion-item__info__value>{{vm.post.reply_count}}</span> <span>{{vm.post.reply_count === 1 ? (\'reply\' | translate).toLowerCase() : (\'replies\' | translate).toLowerCase()}}</span></div></div><div class=discussion-item__info__action><button ng-if=vm.showRejectBtn class=\"discussion-item__info__action__reject-btn btn btn--transparent\" ng-click=vm.onRejectDiscussion()><span class=\"discussion-item__info__action__btn-icon icon-icons_close\"></span> <span class=discussion-item__info__action__btn-label>Reject</span></button> <button ng-if=vm.showApproveBtn class=\"discussion-item__info__action__approve-btn btn btn-submit\" ng-click=vm.onApproveDiscussion()><span class=\"discussion-item__info__action__btn-icon icon-icons_check\"></span> <span class=discussion-item__info__action__btn-label>Approve</span></button></div></div></div>");
$templateCache.put("app/components/event-post-tile/event-post-tile.html","<div class=event-post-tile ng-class=\"{\'not-in-community\': vm.isMember || vm.isOwner || !vm.loginUser}\"><div uib-dropdown class=event-post-tile__control-more><span ng-if=\"vm.isMember && !vm.isOwner\" uib-dropdown-toggle class=icon-icons_more></span><ul class=event-post-tile__list uib-dropdown-menu role=menu><li ng-if=!vm.isOwner role=menuitem class=event-post-tile__item ng-click=vm.onReportDiscussion(vm.post) translate translate-values=\"{thing: \'post\'}\">{{\'report-thing\'}}</li></ul></div><div class=event-post-tile__header><div class=event-post-tile__header__left><pixerf-user-avatar user-data=vm.post.user lazy=true></pixerf-user-avatar></div><div class=event-post-tile__header__right><div class=event-post-tile__header__title ng-click=vm.goDetailDiscussion(vm.post)><div class=event-post-tile__header__title__author><div class=event-post-tile__header__title__author__wrapper><span ng-if=\"vm.post.user.account_type === \'business\'\" class=event-post-tile__header__title__author__name>{{vm.post.user.displayName}}</span> <span ng-if=\"vm.post.user.account_type === \'personal\'\" class=event-post-tile__header__title__author__name ng-class=\"{\'cursor-pointer\': vm.post.user.account_type === \'personal\'}\" ui-sref=\"user-home-page.personal.home({id: vm.post.user.id, userName: (vm.post.user.displayName | toSnakeCase)})\">{{vm.post.user.displayName}}</span> <span ng-if=vm.showAdminLabel class=event-post-tile__header__title__author__label-owner><span class=event-post-tile__header__title__author__label-owner__icon></span> <span class=event-post-tile__header__title__author__label-owner__text>Admin</span></span></div><div class=event-post-tile__header__title__author__acc-type>{{vm.post.user.account_type}}</div></div><div class=event-post-tile__header__title__time>{{vm.inserted_at}}</div></div></div></div><div class=event-post-tile__content ng-click=vm.goDetailDiscussion(vm.post)><div class=event-post-tile__description>{{vm.post.description}}</div><div ng-if=\"vm.post.photos && vm.post.photos.length\" class=event-post-tile__photo-grid flex-grid ng-model=vm.post.photos rowheight=250 margins=10><div ng-repeat=\"photo in vm.post.photos\"><a ng-attr-fancyboxable=\"{\'type\': \'image\', \'overlayShow\': true, \'hideOnOverlayClick\': true, \'showNavArrows\': true, \'margin\': \'50 10 15 10\', \'centerOnScroll\': true}\" href={{photo.url.large}} rel=eventAttachment><img ng-src={{photo.url.thumbnail}}></a></div></div></div><div class=event-post-tile__info><div class=event-post-tile__info__like ng-click=vm.onShowListLike() title=\"Click to see who liked this post\"><span class=\"event-post-tile__info__like__icon icon-icons_like\"></span> <span class=event-post-tile__info__value>{{vm.post.like_count}}</span></div><div ng-if=\"vm.post.reply_count > 0\" class=event-post-tile__info__reply title=\"Click to see who replied this photo\" data-toggle=collapse data-target=#comment-section-{{vm.post.id}}><span class=event-post-tile__info__value>{{vm.post.reply_count}}</span> <span>{{vm.post.reply_count === 1 ? (\'reply\' | translate).toLowerCase() : (\'replies\' | translate).toLowerCase()}}</span></div><div class=event-post-tile__control><div ng-if=vm.isOwner class=\"event-post-tile__control__list event-post-tile__control__owner\"><div class=\"event-post-tile__control__icon event-post-tile__control__owner__edit icon-icons_edit icon-pencil\" authentication-click=vm.onEditPost($event) uib-tooltip=Edit tooltip-placement=left></div><div class=\"event-post-tile__control__icon event-post-tile__control__owner__remove icon-icons_close\" authentication-click=vm.onRemovePost($event) uib-tooltip=Remove tooltip-placement=left></div><div class=\"event-post-tile__control__icon event-post-tile__control__guest__reply icon-comment-circle\" uib-tooltip=Comment tooltip-placement=left data-toggle=collapse data-target=#comment-section-{{vm.post.id}}></div></div><div ng-if=\"!vm.isOwner && vm.isMember\" class=\"event-post-tile__control__list event-post-tile__control__guest\"><div class=\"event-post-tile__control__icon event-post-tile__control__guest__like icon-icons_like\" ng-class=\"{\'liked\': vm.post.is_liked}\" uib-tooltip=Like tooltip-placement=left authentication-click=vm.onLikeToggle($event)></div><div class=\"event-post-tile__control__icon event-post-tile__control__guest__reply icon-comment-circle\" uib-tooltip=Comment tooltip-placement=left data-toggle=collapse data-target=#comment-section-{{vm.post.id}}></div></div></div></div><div id=comment-section-{{vm.post.id}} class=\"event-post-tile__comment-section collapse\"><div ng-if=vm.loginUser class=event-post-tile__comment-section__comment__input><pixerf-user-avatar class=event-post-tile__comment-section__comment__input__author-avatar user-data=vm.loginUser lazy=true></pixerf-user-avatar><div class=event-post-tile__comment-section__comment__input__wrapper><input type=text class=event-post-tile__comment-section__comment__input__author-input ng-model=vm.commentText></div><button class=event-post-tile__comment-section__comment__input__submit-btn ng-click=vm.onCommentEventPost(vm.commentText) uib-tooltip=Publish loading-spinner ng-class=\"{\'is-working\': vm.isAttachmentUploading}\" ng-disabled=vm.isAttachmentUploading></button></div><div ng-if=\"vm.eventPostComments && vm.eventPostComments.length\" class=event-post-tile__comment-section__comment__list><div class=event-post-tile__comment-section__wrapper><event-post-comment ng-repeat=\"comment in vm.eventPostComments | orderBy:\'-inserted_at\'\" comment=comment can-reply=true on-removed=vm.onCommentRemoved(data) can-comment=true scroll-to-this=\"comment.id === vm.scrollToElement\"></event-post-comment><scroll-paging spinner=vm.spinnerComment show-message=false is-last-page=vm.isLastEventPostComments></scroll-paging><div ng-if=!vm.isLastEventPostComments ng-click=vm.fetchMoreEventPostComments(vm.searchEventPostComments) class=event-post-tile__comment-section__view-more-btn>View more</div></div></div></div></div>");
$templateCache.put("app/components/explore-creators-grid-carousel/explore-creators-grid-carousel.html","<div class=explore-creators-grid-carousel><div class=explore-creators-grid-carousel__top-header><div class=explore-creators-grid-carousel__top-header__1><span ng-click=vm.onNavClicked(0) ng-class=\"{\'active\': vm.isActive(0)}\">The Definer</span></div><div class=explore-creators-grid-carousel__top-header__2><span ng-click=vm.onNavClicked(1) ng-class=\"{\'active\': vm.isActive(1)}\">Community Leader</span></div><div class=explore-creators-grid-carousel__top-header__3><span ng-click=vm.onNavClicked(2) ng-class=\"{\'active\': vm.isActive(2)}\">Ambassador</span></div><div class=explore-creators-grid-carousel__top-header__4><span ng-click=vm.onNavClicked(3) ng-class=\"{\'active\': vm.isActive(3)}\">UnderExposed</span></div></div><slick data=vm.slideDatas arrows=false on-init=vm.slickSetting.onInit(slick) adaptive-height=true class=explore-creators-grid-carousel__slick><div ng-repeat=\"data in vm.slideDatas\"><ng-include ng-if=\"$index == 0\" src=\"\'app/components/explore-creators-grid-carousel/slide1-template.html\'\" class=explore-creators-grid-carousel__template-include></ng-include><ng-include ng-if=\"$index == 1\" src=\"\'app/components/explore-creators-grid-carousel/slide2-template.html\'\" class=explore-creators-grid-carousel__template-include></ng-include><ng-include ng-if=\"$index == 2\" src=\"\'app/components/explore-creators-grid-carousel/slide3-template.html\'\" class=explore-creators-grid-carousel__template-include></ng-include><ng-include ng-if=\"$index == 3\" src=\"\'app/components/explore-creators-grid-carousel/slide4-template.html\'\" class=explore-creators-grid-carousel__template-include></ng-include></div></slick><div class=explore-creators-grid-carousel__slide-control><div class=explore-creators-grid-carousel__slide-control__pc-section><div class=\"explore-creators-grid-carousel__slide-control__left icon-slide-prev-icon\" ng-click=vm.onPreviousSlide()></div><div class=explore-creators-grid-carousel__slide-control__text>{{vm.slick.currentSlide + 1}} of {{vm.slideDatas.length}}</div><div class=\"explore-creators-grid-carousel__slide-control__right icon-slide-next-icon\" ng-click=vm.onNextSlide()></div></div><div class=explore-creators-grid-carousel__slide-control__mobile-section><div ng-repeat=\"item in vm.slideDatas\" ng-click=vm.onNavClicked($index) ng-class=\"{\'active\': vm.isActive($index)}\" class=explore-creators-grid-carousel__slide-control__mobile-section__item></div></div></div><div class=explore-creators-grid-carousel__navigate-mobile><div class=\"explore-creators-grid-carousel__navigate-mobile__left icon-slide-prev-icon\" ng-click=vm.onPreviousSlide()></div><div class=\"explore-creators-grid-carousel__navigate-mobile__right icon-slide-next-icon\" ng-click=vm.onNextSlide()></div></div></div>");
$templateCache.put("app/components/explore-creators-grid-carousel/slide1-template.html","<div class=\"explore-creators-grid-carousel__pc-section slide-0-style\"><div class=\"slide-0-style__center width-100\"><div class=\"slide-0-style__center width-30 position-relative\"><div class=\"photo-slide-item photo-0\" ng-style=\"{\'background-image\': \'url(\' + data.photos[0].url + \')\'}\"><div class=photo-slide__info><div class=\"photo-slide__info__name display-content\">{{data.photos[0].name}}</div><div class=photo-slide__info__country>{{data.photos[0].country}}</div></div></div><div class=photo-slide-panel><div class=photo-slide-panel__header><div class=photo-slide-panel__header__logo ng-style=\"{\'background-image\': \'url(\\\'\' + data.slideInfo.logoUrl + \'\\\')\'}\"></div></div><div class=photo-slide-panel__content>{{data.slideInfo.desc}}<div class=connect-with-us><a href=mailto:hello@pixerf.com target=_blank class=connect-with-us__pc>Connect with us</a></div></div></div></div><div class=\"slide-0-style__center size-auto vertical\"><div class=\"photo-slide-item photo-1 size-auto\" ng-style=\"{\'background-image\': \'url(\' + data.photos[1].url + \')\'}\"><div class=photo-slide__info><div class=photo-slide__info__name>{{data.photos[1].name}}</div><div class=photo-slide__info__country>{{data.photos[1].country}}</div></div></div><div class=\"photo-slide-item photo-2\" ng-style=\"{\'background-image\': \'url(\' + data.photos[2].url + \')\'}\"><div class=photo-slide__info><div class=photo-slide__info__name>{{data.photos[2].name}}</div><div class=photo-slide__info__country>{{data.photos[2].country}}</div></div></div></div><div class=\"photo-slide-item photo-3\" ng-style=\"{\'background-image\': \'url(\' + data.photos[3].url + \')\'}\"><div class=photo-slide__info><div class=photo-slide__info__name>{{data.photos[3].name}}</div><div class=photo-slide__info__country>{{data.photos[3].country}}</div></div></div></div></div><div class=explore-creators-grid-carousel__mobile-section><div class=explore-creators-grid-carousel__mobile-section__grid-wrapper><div ng-repeat=\"item in data.photos\" ng-click=vm.showPhotoPopup(item) ng-if=\"$index < 4\" class=explore-creators-grid-carousel__mobile-section__item-wrapper><div class=explore-creators-grid-carousel__mobile-section__item><div class=\"explore-creators-grid-carousel__mobile-section__item__background zoom-hover\" ng-style=\"{\'background-image\': \'url(\\\'\' + item.urlMobile + \'\\\')\'}\"></div></div></div></div><div class=explore-creators-grid-carousel__mobile-section__info><div class=explore-creators-grid-carousel__mobile-section__info__grid-wrapper><div class=\"explore-creators-grid-carousel__mobile-section__info__header slide-1\"><div class=explore-creators-grid-carousel__mobile-section__info__logo ng-style=\"{\'background-image\': \'url(\' + data.slideInfo.logoUrlMobile + \')\'}\"></div><div class=explore-creators-grid-carousel__mobile-section__info__header-text>{{data.slideInfo.header}}</div></div><div class=explore-creators-grid-carousel__mobile-section__info__content>{{data.slideInfo.desc}}<div class=connect-with-us><a href=mailto:hello@pixerf.com target=_blank class=connect-with-us__mobile>Connect with us</a></div></div></div></div></div>");
$templateCache.put("app/components/explore-creators-grid-carousel/slide2-template.html","<div class=\"explore-creators-grid-carousel__pc-section slide-1-style slide-1-style__center width-100\"><div class=\"slide-1-style__center width-50\"><div class=\"slide-1-style__center size-auto vertical\"><div class=\"photo-slide-item photo-0\" ng-style=\"{\'background-image\': \'url(\' + data.photos[0].url + \')\'}\"></div><div class=\"slide-1-style__center size-auto\"><div class=\"photo-slide-item photo-1\" ng-style=\"{\'background-image\': \'url(\' + data.photos[1].url + \')\'}\"></div><div class=\"photo-slide-item photo-2\" ng-style=\"{\'background-image\': \'url(\' + data.photos[2].url + \')\'}\"></div></div></div><div class=photo-slide-panel><div class=photo-slide-panel__header><div class=photo-slide-panel__header__logo ng-style=\"{\'background-image\': \'url(\\\'\' + data.slideInfo.logoUrl + \'\\\')\'}\"></div></div><div class=photo-slide-panel__content>{{data.slideInfo.desc}}<div class=connect-with-us><a href=mailto:hello@pixerf.com target=_blank class=connect-with-us__pc>Connect with us</a></div></div></div></div><div class=\"slide-1-style__center size-auto vertical\"><div class=\"slide-1-style__center height-60\"><!-- <div class=\"photo-slide-item photo-2\" ng-style=\"{\'background-image\': \'url(\' + data.photos[2].url + \')\'}\">\r\n            </div> --><div class=\"photo-slide-item photo-3\" ng-style=\"{\'background-image\': \'url(\' + data.photos[3].url + \')\'}\"></div></div><div class=\"slide-1-style__center size-auto\"><div class=\"photo-slide-item photo-4\" ng-style=\"{\'background-image\': \'url(\' + data.photos[4].url + \')\'}\"></div><div class=\"photo-slide-item photo-5\" ng-style=\"{\'background-image\': \'url(\' + data.photos[5].url + \')\'}\"></div></div></div></div><div class=explore-creators-grid-carousel__mobile-section><div class=explore-creators-grid-carousel__mobile-section__grid-wrapper><div ng-repeat=\"item in data.photos\" ng-click=vm.showPhotoPopup(item) ng-if=\"$index < 2\" class=explore-creators-grid-carousel__mobile-section__item-wrapper><div class=explore-creators-grid-carousel__mobile-section__item><div class=\"explore-creators-grid-carousel__mobile-section__item__background zoom-hover\" ng-style=\"{\'background-image\': \'url(\\\'\' + item.urlMobile + \'\\\')\'}\"></div></div></div></div><div class=\"explore-creators-grid-carousel__mobile-section__grid-wrapper item-plus\"><div ng-click=vm.showPhotoPopup(data.photos[2]) class=explore-creators-grid-carousel__mobile-section__item-wrapper><div class=explore-creators-grid-carousel__mobile-section__item><div class=\"explore-creators-grid-carousel__mobile-section__item__background zoom-hover\" ng-style=\"{\'background-image\': \'url(\\\'\' + data.photos[2].urlMobile + \'\\\')\'}\"></div></div></div></div><div class=explore-creators-grid-carousel__mobile-section__info><div class=explore-creators-grid-carousel__mobile-section__info__grid-wrapper><div class=\"explore-creators-grid-carousel__mobile-section__info__header slide-2\"><div class=explore-creators-grid-carousel__mobile-section__info__logo ng-style=\"{\'background-image\': \'url(\' + data.slideInfo.logoUrlMobile + \')\'}\"></div><div class=explore-creators-grid-carousel__mobile-section__info__header-text>{{data.slideInfo.header}}</div></div><div class=explore-creators-grid-carousel__mobile-section__info__content>{{data.slideInfo.desc}}<div class=connect-with-us><a href=mailto:hello@pixerf.com target=_blank class=connect-with-us__mobile>Connect with us</a></div></div></div></div></div>");
$templateCache.put("app/components/explore-creators-grid-carousel/slide3-template.html","<div class=\"explore-creators-grid-carousel__pc-section slide-2-style slide-2-style__center width-100\"><div class=\"slide-2-style__center size-auto\"><div class=\"slide-2-style__center width-51 vertical\"><div class=\"photo-slide-item photo-0\" ng-style=\"{\'background-image\': \'url(\' + data.photos[0].url + \')\'}\"><div class=photo-slide__info><div class=photo-slide__info__name>{{data.photos[0].name}}</div><div class=photo-slide__info__country>{{data.photos[0].country}}</div></div></div><div class=\"photo-slide-item photo-1\" ng-style=\"{\'background-image\': \'url(\' + data.photos[1].url + \')\'}\"><div class=photo-slide__info><div class=photo-slide__info__name>{{data.photos[1].name}}</div><div class=photo-slide__info__country>{{data.photos[1].country}}</div></div></div></div><div class=\"slide-2-style__center size-auto vertical\"><div class=\"photo-slide-item photo-2\" ng-style=\"{\'background-image\': \'url(\' + data.photos[2].url + \')\'}\"><div class=photo-slide__info><div class=photo-slide__info__name>{{data.photos[2].name}}</div><div class=photo-slide__info__country>{{data.photos[2].country}}</div></div></div><div class=\"photo-slide-item photo-3\" ng-style=\"{\'background-image\': \'url(\' + data.photos[3].url + \')\'}\"><div class=photo-slide__info><div class=photo-slide__info__name>{{data.photos[3].name}}</div><div class=photo-slide__info__country>{{data.photos[3].country}}</div></div></div></div></div><div class=slide-2-style__center><div class=photo-slide-panel><div class=photo-slide-panel__header><div class=photo-slide-panel__header__logo ng-style=\"{\'background-image\': \'url(\\\'\' + data.slideInfo.logoUrl + \'\\\')\'}\"></div></div><div class=photo-slide-panel__content>{{data.slideInfo.desc}}<div class=connect-with-us><a href=mailto:hello@pixerf.com target=_blank class=connect-with-us__pc>Connect with us</a></div></div></div></div><div class=\"slide-2-style__center width-30\"><div class=\"slide-2-style__center size-auto vertical\"><div class=\"photo-slide-item photo-4\" ng-style=\"{\'background-image\': \'url(\' + data.photos[4].url + \')\'}\"><div class=photo-slide__info><div class=photo-slide__info__name>{{data.photos[4].name}}</div><div class=photo-slide__info__country>{{data.photos[4].country}}</div></div></div><div class=\"photo-slide-item photo-5\" ng-style=\"{\'background-image\': \'url(\' + data.photos[5].url + \')\'}\"><div class=photo-slide__info><div class=photo-slide__info__name>{{data.photos[5].name}}</div><div class=photo-slide__info__country>{{data.photos[5].country}}</div></div></div></div></div></div><div class=explore-creators-grid-carousel__mobile-section><div class=explore-creators-grid-carousel__mobile-section__grid-wrapper><div ng-click=vm.showPhotoPopup(data.photos[0]) class=explore-creators-grid-carousel__mobile-section__item-wrapper><div class=explore-creators-grid-carousel__mobile-section__item><div class=\"explore-creators-grid-carousel__mobile-section__item__background zoom-hover\" ng-style=\"{\'background-image\': \'url(\\\'\' + data.photos[0].urlMobile + \'\\\')\'}\"></div></div></div><div ng-click=vm.showPhotoPopup(data.photos[4]) class=explore-creators-grid-carousel__mobile-section__item-wrapper><div class=explore-creators-grid-carousel__mobile-section__item><div class=\"explore-creators-grid-carousel__mobile-section__item__background zoom-hover\" ng-style=\"{\'background-image\': \'url(\\\'\' + data.photos[4].urlMobile + \'\\\')\'}\"></div></div></div><div ng-click=vm.showPhotoPopup(data.photos[5]) class=explore-creators-grid-carousel__mobile-section__item-wrapper><div class=explore-creators-grid-carousel__mobile-section__item><div class=\"explore-creators-grid-carousel__mobile-section__item__background zoom-hover\" ng-style=\"{\'background-image\': \'url(\\\'\' + data.photos[5].urlMobile + \'\\\')\'}\"></div></div></div><div ng-click=vm.showPhotoPopup(data.photos[1]) class=explore-creators-grid-carousel__mobile-section__item-wrapper><div class=explore-creators-grid-carousel__mobile-section__item><div class=\"explore-creators-grid-carousel__mobile-section__item__background zoom-hover\" ng-style=\"{\'background-image\': \'url(\\\'\' + data.photos[1].urlMobile + \'\\\')\'}\"></div></div></div></div><div class=explore-creators-grid-carousel__mobile-section__info><div class=explore-creators-grid-carousel__mobile-section__info__grid-wrapper><div class=\"explore-creators-grid-carousel__mobile-section__info__header slide-3\"><div class=explore-creators-grid-carousel__mobile-section__info__logo ng-style=\"{\'background-image\': \'url(\' + data.slideInfo.logoUrlMobile + \')\'}\"></div><div class=explore-creators-grid-carousel__mobile-section__info__header-text>{{data.slideInfo.header}}</div></div><div class=explore-creators-grid-carousel__mobile-section__info__content>{{data.slideInfo.desc}}<div class=connect-with-us><a href=mailto:hello@pixerf.com target=_blank class=connect-with-us__mobile>Connect with us</a></div></div></div></div></div>");
$templateCache.put("app/components/explore-creators-grid-carousel/slide4-template.html","<div class=\"explore-creators-grid-carousel__pc-section slide-3-style slide-3-style__center width-100\"><div class=\"slide-3-style__center width-46 vertical\"><div class=\"slide-3-style__center height-66\"><div class=\"photo-slide-item photo-0\" ng-style=\"{\'background-image\': \'url(\' + data.photos[0].url + \')\'}\"></div><div class=\"photo-slide-item photo-1\" ng-style=\"{\'background-image\': \'url(\' + data.photos[1].url + \')\'}\"></div></div><div class=\"photo-slide-item photo-2\" ng-style=\"{\'background-image\': \'url(\' + data.photos[2].url + \')\'}\"></div></div><div class=\"slide-3-style__center size-auto vertical\"><div class=\"photo-slide-item photo-3\" ng-style=\"{\'background-image\': \'url(\' + data.photos[3].url + \')\'}\"></div><div class=\"photo-slide-item photo-4\" ng-style=\"{\'background-image\': \'url(\' + data.photos[4].url + \')\'}\"></div></div><div class=\"slide-3-style__center width-30\"><div class=photo-slide-panel><div class=photo-slide-panel__header><div class=photo-slide-panel__header__logo ng-style=\"{\'background-image\': \'url(\\\'\' + data.slideInfo.logoUrl + \'\\\')\'}\"></div></div><div class=photo-slide-panel__content>{{data.slideInfo.desc}}<div class=connect-with-us><a href=mailto:hello@pixerf.com target=_blank class=connect-with-us__pc>Connect with us</a></div></div></div><div class=\"photo-slide-item photo-5\" ng-style=\"{\'background-image\': \'url(\' + data.photos[5].url + \')\'}\"></div></div></div><div class=explore-creators-grid-carousel__mobile-section><div class=explore-creators-grid-carousel__mobile-section__grid-wrapper><div ng-repeat=\"item in data.photos\" ng-click=vm.showPhotoPopup(item) ng-if=\"$index < 2\" class=explore-creators-grid-carousel__mobile-section__item-wrapper><div class=explore-creators-grid-carousel__mobile-section__item><div class=\"explore-creators-grid-carousel__mobile-section__item__background zoom-hover\" ng-style=\"{\'background-image\': \'url(\\\'\' + item.urlMobile + \'\\\')\'}\"></div></div></div></div><div class=\"explore-creators-grid-carousel__mobile-section__grid-wrapper item-plus\"><div ng-click=vm.showPhotoPopup(data.photos[2]) class=explore-creators-grid-carousel__mobile-section__item-wrapper><div class=explore-creators-grid-carousel__mobile-section__item><div class=\"explore-creators-grid-carousel__mobile-section__item__background zoom-hover\" ng-style=\"{\'background-image\': \'url(\\\'\' + data.photos[2].urlMobile + \'\\\')\'}\"></div></div></div></div><div class=explore-creators-grid-carousel__mobile-section__info><div class=explore-creators-grid-carousel__mobile-section__info__grid-wrapper><div class=\"explore-creators-grid-carousel__mobile-section__info__header slide-4\"><div class=explore-creators-grid-carousel__mobile-section__info__logo ng-style=\"{\'background-image\': \'url(\' + data.slideInfo.logoUrlMobile + \')\'}\"></div><div class=explore-creators-grid-carousel__mobile-section__info__header-text>{{data.slideInfo.header}}</div></div><div class=explore-creators-grid-carousel__mobile-section__info__content>{{data.slideInfo.desc}}<div class=connect-with-us><a href=mailto:hello@pixerf.com target=_blank class=connect-with-us__mobile>Connect with us</a></div></div></div></div></div>");
$templateCache.put("app/components/featured-photographer-grid/featured-photographer-grid.html","<div class=featured-photographer-grid on-window-resize-event=vm.onWindowResize()><div class=\"featured-photographer-grid__photographers-wrapper clearfix\" infinite-scroll-distance=0.3 infinite-scroll-disabled=vm.isLastPage infinite-scroll=vm.fetchMore() infinite-scroll-immediate-check=false><div class=\"photographer-item-wrapper relative clearfix\" ng-repeat=\"photographer in vm.photographers\"><photographer-tile item=photographer></photographer-tile></div><scroll-paging hide-back-to-top=true spinner=vm.spinner show-message=!!endingMessage message={{endingMessage}} is-last-page=vm.isLastPage></scroll-paging></div><div class=\"featured-photographer-grid__photographers__empty-state text--semibold text--color-black\" ng-if=\"vm.photographers.length === 0\">Oops! It looks like there are no photographers listed.</div></div>");
$templateCache.put("app/components/featured-photographers-carousel/featured-photographers-carousel.html","<div class=featured-photographers-carousel><div class=\"pixerf-slick-nav prev-slide-nav clearfix\" ng-click=vm.prevBtnClicked() ng-show=\"vm.currentSlide && vm.currentSlide > 2\"><div class=\"pixerf-slick-prev icon-icons_chevron-left\"></div></div><div class=\"pixerf-slick-nav next-slide-nav clearfix\" ng-click=vm.nextBtnClicked() ng-show=\"vm.currentSlide < vm.totalSlideShow\"><div class=\"pixerf-slick-next icon-icons_chevron-right\"></div></div><slick class=featured-photographers-carousel__slick infinite=false on-breakpoint=\"vm.slickConfig.event.breakpoint({event, slick, breakpoint})\" slides-to-show=4 slides-to-scroll=4 center-mode=true initial-slide=2 on-init=vm.slickConfig.event.init({slick}) on-before-change=\"vm.slickConfig.event.beforeChange({event, slick, currentSlide, nextSlide})\" on-after-change=\"vm.slickConfig.event.afterChange({event, slick, currentSlide, nextSlide})\" dots=true init-onload=true data=vm.photographers ng-if=\"vm.photographers.length > 0\"><div ng-repeat=\"photographer in vm.photographers\"><div ng-style=\"{\'background-image\': \'url(\' + photographer.url + \')\'}\" class=author></div></div></slick></div>");
$templateCache.put("app/components/feed-tile-grid/feed-tile-grid.html","<div class=feed-tile-grid><div ng-repeat=\"feed in feeds\" class=feed-wrapper><feed-tile feed=feed ng-if=\"(($index - 1) % 4 != 0 && ($index - 2) % 4 != 0)\"></feed-tile><feed-tile feed=feed layout-cover=true ng-if=\"(($index - 1) % 4 === 0 || ($index - 2) % 4 === 0)\"></feed-tile></div></div>");
$templateCache.put("app/components/flag-btn/flag-btn.html","<div class=\"flag-btn-wrapper text-center\"><button ng-mouseover=vm.onMouseOver() ng-mouseleave=vm.onMouseLeave() ng-disabled=vm.isWorking ng-class=\"{\'flag-btn--flagged\': user.is_flagged, \'flag-btn--unflag\': vm.isHovering}\" class=\"btn btn-pixerf-theme--blue btn-pixerf-theme--no-background text--bold flag-btn\" authentication-click=vm.onSuggestClicked() authentication-click-action=SUGESST_PERSON><span class=\"icon- flag-btn__icon\"></span><span class=flag-btn__btn-label>{{vm.btnLabel}}</span></button></div>");
$templateCache.put("app/components/feed-tile/feed-tile.html","<div class=feed-tile><div class=\"feed-tile__wrapper none-cover-layout clearfix\" ng-if=!layoutCover><a ng-href={{feed.link}} target=_blank><div class=feed-tile__background-wrapper><div class=feed-tile__background ng-style=\"{\'background-image\': \'url(\' + feed.thumbnail + \')\'}\"></div><div class=feed-tile__overlay></div></div><div class=feed-tile__footer><div class=feed-tile__category>{{feed.category}}</div><div class=feed-tile__title ng-bind-html=feed.title></div><div class=feed-tile__content--sm>{{feed.content}}</div></div><div class=feed-tile__content>{{feed.content}}</div></a></div><div class=\"feed-tile__wrapper cover-layout clearfix\" ng-if=layoutCover><a ng-href={{feed.link}} target=_blank><div class=feed-tile__background ng-style=\"{\'background-image\': \'url(\' + feed.thumbnail + \')\'}\"><div class=feed-tile__overlay></div></div><div class=\"feed-tile__footer clearfix\"><div class=feed-tile__category>{{feed.category}}</div><div class=feed-tile__title ng-bind-html=feed.title></div><div class=feed-tile__content>{{feed.content}}</div></div></a></div></div>");
$templateCache.put("app/components/follow-btn/follow-btn.html","<div class=\"follow-btn-wrapper text-center\"><div ng-if=vm.loginUser.canFollow><button ng-mouseover=vm.onMouseOver() ng-mouseleave=vm.onMouseLeave() ng-if=\"!vm.isMine && !isIconMode\" ng-disabled=vm.isDoingFollow ng-class=\"{\'follow-btn--followed\': user.is_followed, \'follow-btn--unfollow\': vm.isHovering}\" class=\"btn btn-pixerf-theme--blue btn-pixerf-theme--no-background text--bold follow-btn\" authentication-click=vm.onFollowClicked() authentication-click-action=FOLLOW_PERSON check-verified-email=true authentication-for=Contributor><span class=icon-icons_check></span> <span class=follow-btn__btn-label translate>{{vm.btnLabel}}</span></button><div ng-if=\"!vm.isMine && isIconMode\" class=follow-btn__icon-user ng-disabled=vm.isDoingFollow check-verified-email=true authentication-click=vm.onFollowClicked() authentication-click-action=FOLLOW_PERSON authentication-for=Contributor><span ng-class=\"{\'icon-icons-following-user\': user.is_followed, \'icon-icons-follow-user\': !user.is_followed}\"></span></div></div></div>");
$templateCache.put("app/components/follow-gallery-btn/follow-gallery-btn.html","<div class=\"follow-btn-wrapper text-center\"><button ng-mouseover=vm.onMouseOver() ng-mouseleave=vm.onMouseLeave() ng-disabled=vm.isDoingFollow ng-class=\"{\'follow-btn--followed\': gallery.is_followed, \'follow-btn--unfollow\': vm.isHovering}\" class=\"btn btn-pixerf-theme--blue btn-pixerf-theme--no-background text--bold follow-btn\" authentication-click=vm.onFollowClicked() authentication-click-action=FOLLOW_GALLERY><span class=icon-icons_check></span><span>{{vm.btnLabel}}</span></button></div>");
$templateCache.put("app/components/following-tile/following-tile.html","<div class=following-tile ng-click=\"onGalleryClicked({\'gallery\': gallery})\"><star-btn class=following-tile__star-btn is-show-tooltip=true on-stared-toggled=\"onStaredToggled({\'gallery\': gallery})\" target-type=\"\'gallery\'\" ng-if=\"vm.loginUser.canCurate && !gallery.is_showcase\" target=gallery hover-show-number=true></star-btn><div class=following-tile__cover ng-style=\"{\'background-image\': \'url(\' + gallery.thumbnailPath + \')\'}\" ng-click=\"onGalleryClicked({\'gallery\': gallery})\"><div class=overlay-image></div><div class=overlay></div></div><div class=following-tile__avatar pixerf-user-avatar-style pixerf-user-avatar-style-user=gallery.user pixerf-user-avatar-style-business-class=\"\'no-border\'\"><a ui-sref=\"user-home-page.personal.home({id: gallery.user.id, userName: (gallery.user.displayName| toSnakeCase)})\"><pixerf-user-avatar class=profile-image user-data=gallery.user lazy=true></pixerf-user-avatar></a></div><div class=following-tile__footer><div class=\"following-tile__title text--bold text--truncate\" uib-tooltip={{gallery.title}}>{{gallery.title | toTitleCase}}</div><div class=following-tile__sub-title translate>{{\'curated-by\'}}</div><a class=\"following-tile__username text--semibold text--truncate\" uib-tooltip={{gallery.user.displayName}} ui-sref=\"user-home-page.personal.home({id: gallery.user.id, userName: (gallery.user.displayName| toSnakeCase)})\">{{gallery.user.displayName}}</a></div></div>");
$templateCache.put("app/components/footer/footer.html","<section class=footer ng-if=isVisible><div class=footer__top-nav><div class=footer__top-nav__col><div class=footer__top-nav__col__internal><div class=\"footer__top-nav__col__sub first-element\"><div><div class=footer__top-nav__col__title>Book a Shoot</div><div class=footer__top-nav__col__list><div ng-repeat=\"item in vm.bookaShootNav\" class=\"footer__top-nav__col__item {{item.className}}\"><a href={{item.href}}>{{item.name}}</a></div></div></div></div><div class=\"footer__top-nav__col__sub first-element\"><div><div class=footer__top-nav__col__title>Run a Challenge</div><div class=footer__top-nav__col__list><div ng-repeat=\"item in vm.challengeNav\" class=\"footer__top-nav__col__item {{item.className}}\"><a href={{item.href}}>{{item.name}}</a></div></div></div></div><div class=\"footer__top-nav__col__sub second-element\"><div class=footer__top-nav__col__title>Buy Stock</div><div class=footer__top-nav__col__list><div ng-repeat=\"item in vm.buyStockNav\" class=footer__top-nav__col__item><a href={{item.href}}>{{item.name}}</a></div></div></div><div class=\"footer__top-nav__col__sub third-element\"><div class=\"footer__top-nav__col__sub third-element__first-sub\"><div class=footer__top-nav__col__title>For Business</div><div class=footer__top-nav__col__list><div ng-repeat=\"item in vm.businessNav\" class=footer__top-nav__col__item><a href={{item.href}}>{{item.name}}</a></div></div></div><div class=\"footer__top-nav__col__sub third-element__second-sub--desktop\"><div class=footer__top-nav__col__title>News</div><div class=footer__top-nav__col__list><div ng-repeat=\"item in vm.newsNav\" class=footer__top-nav__col__item><a ng-if=item.route ui-sref={{item.route}} href=#>{{item.name}}</a> <a ng-if=!item.route href={{item.href}} target=_blank ng-bind-html=item.name></a></div></div></div></div><div class=\"footer__top-nav__col__sub fourth-element\"><div class=footer__top-nav__col__title>For Creators</div><div class=footer__top-nav__col__list><div ng-repeat=\"item in vm.creatorsNav\" class=footer__top-nav__col__item><a href={{item.href}}>{{item.name}}</a></div></div></div><div class=\"footer__top-nav__col__sub fifth-element\"><div class=footer__top-nav__col__title>Company</div><div class=footer__top-nav__col__list><div ng-repeat=\"item in vm.companyNav\" class=\"footer__top-nav__col__item {{item.className}}\"><a href={{item.href}}>{{item.name}}</a></div></div></div><div class=\"footer__top-nav__col__sub footer__top-nav__col__sub__support sixth-element\"><div class=footer__top-nav__col__title>Support</div><div class=footer__top-nav__col__list><div ng-repeat=\"item in vm.supportNav\" class=footer__top-nav__col__item><a href={{item.href}}>{{item.name}}</a></div></div></div><div class=\"footer__top-nav__col__sub third-element__second-sub--mobile\"><div class=footer__top-nav__col__title>News</div><div class=footer__top-nav__col__list><div ng-repeat=\"item in vm.newsNav\" class=footer__top-nav__col__item><a ng-if=item.route ui-sref={{item.route}} href=#>{{item.name}}</a> <a ng-if=!item.route href={{item.href}} target=_blank ng-bind-html=item.name></a></div></div></div></div></div><div class=footer__top-nav__col><div class=footer__top-nav__col__title>Download the app</div><link-mobile-app class=footer__top-nav__col__mobile-app></link-mobile-app></div></div><div class=footer__bottom-nav><div class=footer__bottom-nav__logo><img src=assets/images/white-pixerf.svg alt=PIXERF></div><div class=footer__bottom-nav__reserved>© 2023 PIXERF Private Limited. All Rights Reserved.</div><div class=footer__bottom-nav__social-media><div class=\"footer__bottom-nav__social-media__item fb-icon-sprite\"><a href=https://www.facebook.com/Pixerf target=_blank></a></div><div class=\"footer__bottom-nav__social-media__item ig-icon-sprite\"><a href=http://instagram.com/Pixerf target=_blank></a></div><div class=\"footer__bottom-nav__social-media__item li-icon-sprite\"><a href=https://www.linkedin.com/company/pixerf target=_blank></a></div><div class=\"footer__bottom-nav__social-media__item tt-icon-sprite\"><a href=https://twitter.com/Pixerf target=_blank></a></div></div></div></section>");
$templateCache.put("app/components/galleries-list/galleries-list.html","<div scroll=vm.onWindowScroll() class=\"galleries-list-wrapper pixerf-scrollable-but-not-parent\" tabindex=0 ng-mouseover=vm.onGalleriesListHover() ng-mouseleave=vm.onGalleriesListLeave()><div class=galleries-list__gallery-list-wrapper infinite-scroll-disabled=vm.isLastPage.data infinite-scroll=vm.fetchMoreGallaries() infinite-scroll-immediate-check=false infinite-scroll-container=\"\'.galleries-list-wrapper\'\"><div class=\"gallery-item clearfix\" ng-click=\"vm.onGalleryItemClicked($event, gallery)\" ng-repeat=\"gallery in vm.galleries.data | filter : vm.filterFn\"><div class=\"gallery-item__thumbnail pull-left\"><div class=gallery-item__thumbnail__cover-photo ng-style=\"{\'background-image\': \'url(\' + gallery.thumbnailPath + \')\'}\"></div><span ng-show=!gallery.thumbnail class=\"gallery-item__thumbnail__short-name absolute absolute--full text-center text--color-white\">{{gallery.title.substr(0, 1)}}</span></div><div class=\"gallery-item__title text--bold text--color-black pull-left text--truncate\">{{gallery.title}}</div><span ng-show=gallery.isSelected class=icon-icons_check></span></div><div class=\"galleries-list__empty-state text-center\" ng-if=\"vm.galleries.data.length === 0\">You haven\'t created any galleries yet!</div><scroll-paging spinner=vm.spinner show-message=false is-last-page=vm.isLastPage.data message=\"No more gallery to load.\"></scroll-paging></div></div>");
$templateCache.put("app/components/galleries-list-slider/galleries-list-slider.html","<div class=\"galleries-list-slider clearfix\" ng-class=\"{\'guest\': !vm.isMine}\"><div class=\"galleries-list-slider__header clearfix\"><div id=section-{{vm.galleryType}}-gallery class=\"galleries-list-slider__title text--extrabold text--color-black\" translate>{{vm.galleriesTitle}}</div><div class=\"galleries-list-slider__control-wrapper clearfix\" ng-if=\"vm.galleries && vm.galleries.length > 0\"><div class=galleries-list-slider__control-wrapper__see-all ui-sref=\"user-home-page.personal.galleries-type({type: vm.galleryType})\">{{\'see-all\' | translate}}</div><div ng-if=vm.isMine class=galleries-list-slider__control-wrapper__create-btn authentication-click=vm.onCreateGalleryBtnClicked(galleryType) check-verified-email=true>{{\'create-new\' | translate}}</div></div></div><div ng-if=\"vm.galleries && vm.slickReady\" class=clearfix><div ng-if=\"vm.galleries.length === 0\" class=galleries-list-slider__empty-text__container><div class=\"galleries-list-slider__empty-text__btn clearfix\" ng-if=vm.isMine authentication-click=vm.onCreateGalleryBtnClicked(galleryType) check-verified-email=true><div class=\"galleries-list-slider__empty-text__content-wrapper vertical-align-middle--transform\"><div class=\"galleries-list-slider__empty-text__icon icon-icons_plus\"></div><div class=\"galleries-list-slider__empty-text__title text--extrabold\" translate>{{vm.createGalleryTitle}}</div><div class=galleries-list-slider__empty-text__description ng-bind=\"vm.isMine ? (vm.emptyText.description | translate) : (vm.emptyText.guestDescription | translate)\"></div></div></div><div class=\"galleries-list-slider__guest__empty-text clearfix\" ng-if=!vm.isMine><div class=\"galleries-list-slider__guest__empty-text__content-wrapper vertical-align-middle--transform\"><div class=\"galleries-list-slider__guest__empty-text__icon icon-icons-gallery\"></div><h4 class=\"galleries-list-slider__guest__empty-text__header text--semibold\" ng-bind=\"vm.isMine ? vm.emptyText.heading : vm.emptyText.guestHeading\"></h4><h5 class=galleries-list-slider__guest__empty-text__content ng-bind=\"vm.isMine ? vm.emptyText.description : vm.emptyText.guestDescription\"></h5></div></div></div><spinner-win spinner=vm.spinner></spinner-win><div class=galleries-slick-slider ng-class=\"{\'show-slick\': vm.showSlick}\"><pixerf-animation-carousel data=vm.galleries ng-if=\"vm.galleries && vm.galleries.length > 0\" config=vm.carouselConfig instance={{galleryType}} limit=9><item-template><gallery-tile gallery=$parent.data galleries=vm.galleries on-gallery-clicked=\"onGalleryClicked({\'gallery\': $parent.data})\" options=\"{hideAuthor: true}\"></gallery-tile></item-template></pixerf-animation-carousel></div></div></div>");
$templateCache.put("app/components/gallery-grid/gallery-grid.html","<div class=gallery-grid><div class=gallery-grid__wrapper infinite-scroll-disabled=\"vm.isLastPage || !onLoadMorePage\" infinite-scroll=vm.fetchMoreGalleries() infinite-scroll-immediate-check=false><div ng-show=\"vm.galleries.length > 0\" ng-repeat=\"gallery in vm.galleries | limitTo:showOnRow\" class=gallery-grid__item pixerf-scroll-spy=gallery.onScrollTo() scroll-spy-id={{gallery.scrollSpyId}} pixerf-scroll-spy-direction={{gallery.pixerfScrollSpyDirection}} is-first-spy-item={{gallery.isFirstSpyItem}} is-last-spy-item={{gallery.isLastSpyItem}}><gallery-tile gallery=gallery galleries=vm.galleries></gallery-tile></div><ng-transclude class=gallery-grid__no-gallery></ng-transclude><scroll-paging ng-if=!showOnRow spinner=vm.spinner show-message=\"vm.galleries.length > 0 && vm.searchParams.page > 1 && !showOnRow\" is-last-page=vm.isLastPage message=\"No more galleries.\" section-id={{onScrollToSectionId}} offset-top={{onScrollOffsetTop}}></scroll-paging></div></div>");
$templateCache.put("app/components/gallery-tile/gallery-tile.html","<div class=gallery-tile><showcased-gallery-btn ng-if=vm.loginUser.canCurate on-showcased-gallery-selected=vm.onShowcasedGalleryBtnClicked(gallery) gallery=gallery galleries=vm.galleries></showcased-gallery-btn><star-btn class=gallery-tile__star-btn is-show-tooltip=true on-stared-toggled=\"onStaredToggled({\'gallery\': gallery})\" target-type=\"\'gallery\'\" ng-if=\"vm.loginUser.canCurate && !gallery.is_showcase\" target=gallery hover-show-number=true></star-btn><signature-gallery-btn class=gallery-tile__signature-gallery-btn is-show-tooltip=true on-button-toggled=\"onButtonToggled({\'gallery\': gallery})\" target-type=\"\'gallery\'\" ng-if=\"vm.loginUser.isAdminInternal && !gallery.is_showcase\" target=gallery hover-show-number=true></signature-gallery-btn><div class=gallery-tile__item__photo ng-class=\"{\'no-footer\': options.hideAuthor}\"><div class=gallery-tile__carousel active=0><div class=gallery-tile__carousel__item ng-click=vm.onGalleryClicked(gallery)><div class=\"gallery-tile__carousel__photo-cover zoom-hover {{gallery.thumbnailPath}}\" ng-if=gallery.showThumbnail ng-style=\"{\'background-image\': \'url(\' + gallery.thumbnailPath + \')\'}\"><div class=overlay></div></div><div class=\"gallery-tile__carousel__photo-cover zoom-hover\" ng-if=!gallery.showThumbnail ng-style=\"{\'background-color\': gallery.defaultBackgroundColor} \"><div class=overlay></div></div></div></div><div class=gallery-tile__item__content><div class=gallery-tile__item__content__title title={{gallery.title}}>{{gallery.title | toTitleCase}}</div></div></div><div class=gallery-tile__item__footer ng-if=!options.hideAuthor><div class=gallery-tile__item__footer__author><div class=gallery-tile__item__footer__author__avatar><a ui-sref=\"user-home-page.personal.home({id:gallery.user.id, userName: (gallery.user.displayName | toSnakeCase)})\"><pixerf-user-avatar class=profile-image user-data=gallery.user lazy=true></pixerf-user-avatar></a></div><div class=\"gallery-tile__item__footer__author__details text--truncate\"><div class=gallery-tile__item__footer__label ng-bind=\"gallery.is_curated ? (\'curated-by\' | translate) : (\'gallery-by\' | translate)\"></div><a ng-click=$event.stopPropagation(); class=gallery-tile__item__footer__author__name ui-sref=\"user-home-page.personal.home({id: gallery.user.id, userName: (gallery.user.displayName| toSnakeCase)})\">{{gallery.user.displayName}}</a></div></div></div></div>");
$templateCache.put("app/components/general-contact-form/general-contact-form.html","<section class=\"general-contact-form {{context}} {{vm.formTheme}}\"><div class=general-contact-form__col-left><div class=general-contact-form__col-left__content><div class=general-contact-form__col-left__content__background-transparent photo-details-on-click={{vm.box.id}}></div><img class=general-contact-form__col-left__content__background ng-src={{vm.box.photo}} alt=\"contact form background\" photo-details-on-click={{vm.box.id}}><div class=general-contact-form__box-cover><div class=general-contact-form__box><div class=general-contact-form__box__content-wrapper><div class=general-contact-form__box__header>{{vm.box.header}}</div><div class=general-contact-form__box__content>{{vm.box.content}}</div></div></div><button class=\"general-contact-form__book-a-shoot-btn {{vm.box.btnnStyle}}\" ng-click=vm.formBtnClicked()>{{vm.formBtnText}}</button></div></div></div><div class=general-contact-form__col-right><form name=contactUsForm class=general-contact-form__col-right__content><div class=general-contact-form__col-right__row><div class=\"general-contact-form__col-right__group-input full-col\"><label for=\"\">Name</label><input type=text class=general-contact-form__col-right__group-input__input placeholder=\"Enter your name\" validation-no-hyperlink validation-no-number required ng-model=vm.user.full_name name=full_name></div></div><div class=general-contact-form__col-right__row><div class=\"general-contact-form__col-right__group-input full-col\"><label for=\"\">Company Name (optional)</label><input type=text class=general-contact-form__col-right__group-input__input ng-model=vm.user.company name=company></div></div><div class=general-contact-form__col-right__row><div class=\"general-contact-form__col-right__group-input full-col\"><label for=\"\">Email</label><input class=general-contact-form__col-right__group-input__input placeholder=\"Company email if applicable\" ng-model=vm.user.email name=email type=email required></div></div><div class=general-contact-form__col-right__row><div class=\"general-contact-form__col-right__group-input half-col country-selection\"><label for=\"\">Country</label><pixerf-input-auto-complete dropdown-class=\"general-contact-form__col-right__group-input__input country-selection-ddl\" required options=vm.countriesOpts name=custom-commission-basic-form-popup__body__countries__input data=vm.countries model=vm.user.country on-changed=\"vm.onCountrySelected(vm.user.country, contactUsForm)\"></pixerf-input-auto-complete></div><div class=\"general-contact-form__col-right__group-input half-col\"><label for=\"\">Contact Number (optional)</label><input type=text ng-model=vm.user.mobile maxlength=255 name=mobile national-mode=false ng-if=vm.showMobileSelect international-phone-number auto-placeholder=false default-country={{vm.defaultCountryCode}} preferred-countries=\"sg, my, id\" class=\"general-contact-form__col-right__group-input__input general-contact-form__col-right__group-input__phone-number\"></div></div><div class=general-contact-form__col-right__row><div class=\"general-contact-form__col-right__group-input full-col\"><label for=\"\">What do you have in mind?</label><textarea class=general-contact-form__col-right__group-input__textarea ng-model=vm.user.message></textarea></div></div><div class=general-contact-form__col-right__attachment><div class=general-contact-form__col-right__attachment__label>Attach your brief (optional)</div><button class=general-contact-form__browse-btn ng-click=vm.onSelectFile()>Browse</button> <span ng-if=\"vm.file && vm.file.name\" class=general-contact-form__file-name>{{vm.file.name}}</span> <input type=file name=file id=attachFile class=general-contact-form__browse-input></div><div class=general-contact-form__col-right__agreement><stick-checkbox on-changed=vm.onAgreeChanged() model=vm.agreement model-property=isAgree label=\"You agree to receive e-newletters and marketing emails from PIXERF, which you can unsubscribe to at any time. You acknowledge and accept that your information will be used in accordance with PIXERF’s privacy policy.\" layout-style=solid-square></stick-checkbox></div><spinner-win spinner=vm.spinner></spinner-win><button class=general-contact-form__submit-btn ng-disabled=\"!vm.isFormValid(contactUsForm) || vm.spinner.isVisible\" ng-click=vm.onSubmit(contactUsForm)>Leave us a message</button></form></div></section>");
$templateCache.put("app/components/get-release-form-btn/get-release-form-btn.html","<div ng-click=vm.onClicked() class=get-release-form-btn>{{text ? text : \'Download forms\'}}</div>");
$templateCache.put("app/components/gojek-agreement-popup/gojek-agreement-popup.html","<div class=gojek-agreement-popup__content><div class=gojek-agreement-popup__content__modal-header><button type=button class=close ng-click=vm.dismiss()><span class=icon-icons_close aria-hidden=true></span></button></div><div class=gojek-agreement-popup__content__body><div class=gojek-agreement-popup__content__body__description><pixerf-checkbox is-disabled=vm.mission.is_agreement_accepted on-changed=vm.onMissionAgreed() error=\"!vm.mission.is_agreement_accepted && vm.isFormDirty\" model=vm.mission model-property=is_agreement_accepted></pixerf-checkbox><span>By submitting to this Mission you are agreeing to the <a target=_blank ui-sref=run-a-challenge-page.community-challenge-agreement-gojek class=\"text--color-pixerf-theme text--bold\" role=button>Missions Agreement.</a></span></div><button class=\"btn btn-submit gojek-agreement-popup__content__submit-btn\" ng-click=vm.onSubmitClicked() ng-disabled=\"!vm.mission || !vm.mission.is_agreement_accepted\">OK</button></div></div>");
$templateCache.put("app/components/google-location-picker/google-location-picker.html","<div class=google-location-picker><button popover-is-open=vm.isOpen.data uib-popover-template=\"\'myPopoverTemplate.html\'\" popover-placement=left ng-disabled=isDisabled type=button ng-class=\"{{btnClass}} + \' add-location-btn\'\"><span class=text--truncate>{{location.reverse ? location.reverse : \'Add a Location\'}}</span><!-- <span ng-show=\"location\" class=\"icon-icons_check\"></span> --></button><script type=text/ng-template id=myPopoverTemplate.html><div>\r\n        <div class=\"popover-title clearfix\">\r\n          <div class=\"pull-left text--bold text--color-black\">Add a Location</div>\r\n          <div class=\"pull-right text--color-pixerf-theme text--bold\" ng-click=\"vm.isOpen.data = false\">Done</div>\r\n        </div>\r\n        <input class=\"google-location-picker__location-input\" type=\"text\" name=\"\">\r\n        <locationpicker options=\"vm.locationPickerOptions()\"></locationpicker>\r\n      </div></script></div>");
$templateCache.put("app/components/grid-filter/grid-filter.html","<div class=grid-filter uib-dropdown ng-class=\"{\'open\': isOpenDll}\"><span uib-dropdown-toggle class=\"grid-filter__more__icon icon-icons_chevron-down\"></span><ul class=grid-filter__list uib-dropdown-menu role=menu><li class=grid-filter__title>{{vm.title}}</li><li ng-click=vm.onSelectAllBtnClicked() class=grid-filter__select-all ng-class=\"{\'active\': vm.isSelectAll}\" ng-if=multiSelect><span ng-if=vm.isSelectAll class=\"grid-filter__icon-check icon-icons_check\"></span> <span>Select All</span></li><hr class=grid-filter__break-line ng-if=multiSelect><li role=menuitem class=grid-filter__item ng-repeat=\"item in vm.options\" ng-class=\"{\'active\': vm.isSelectedItem(item)}\" ng-click=vm.onItemClicked(item)><span ng-if=vm.isSelectedItem(item) class=\"grid-filter__icon-check icon-icons_check\"></span> <span>{{item.label}}</span></li></ul></div>");
$templateCache.put("app/components/grid-filter-sort/grid-filter-sort.html","<div class=grid-filter-sort uib-dropdown ng-class=\"{\'open\': isOpenDll}\"><span uib-dropdown-toggle class=grid-filter-sort__more__icon ng-class=\"vm.sortDirection.straight ? \'icon-icons_chevron-down\' : \'icon-icons_chevron-up\'\"></span><div class=grid-filter-sort__group><ul class=grid-filter-sort__list role=menu ng-if=sortProperty><li class=grid-filter-sort__title>Sort</li><hr class=grid-filter-sort__break-line><li role=menuitem class=grid-filter-sort__item ng-class=\"{\'active\': vm.sortDirection.straight}\"><stick-checkbox on-changed=vm.onSortChange() model=vm.sortDirection model-property=straight label=A-Z></stick-checkbox></li><li role=menuitem class=grid-filter-sort__item ng-class=\"{\'active\': vm.sortDirection.sortReverse}\"><stick-checkbox on-changed=vm.onSortChange() model=vm.sortDirection model-property=sortReverse label=Z-A></stick-checkbox></li></ul><div ng-if=\"sortProperty &&  vm.options.length\" class=grid-filter-sort__sort-break-line><div class=grid-filter-sort__sort-break-line__line></div><span class=grid-filter-sort__sort-break-line__text>OR</span><div class=grid-filter-sort__sort-break-line__line></div></div><ul class=grid-filter-sort__list role=menu ng-if=vm.options.length><li class=grid-filter-sort__title>{{vm.title}}</li><li class=grid-filter-sort__select-all ng-class=\"{\'active\': vm.isSelectAll}\" ng-if=multiSelect><stick-checkbox on-changed=vm.onSelectAllBtnClicked() model=vm.selectedValue model-property=selectAll label=All></stick-checkbox></li><hr class=grid-filter-sort__break-line ng-if=multiSelect><li role=menuitem class=grid-filter-sort__item ng-repeat=\"item in vm.options\" ng-class=\"{\'active\': vm.isSelectedItem(item)}\"><stick-checkbox on-changed=vm.onItemClicked(item) model=vm.selectedValue model-property={{item.value}} label={{item.label}}></stick-checkbox></li></ul></div></div>");
$templateCache.put("app/components/header/header.html","<div ng-if=isVisible class=main-header ng-class=cssClass><nav class=main-header__wrapper><div class=main-header__content><div class=main-header__content__left><a class=main-header__logo ng-click=vm.onLogoClicked()><div class=pixerf-logo></div></a><!-- <div class=\"form-group header-search-bar mobile-show search-toggle-box\">\r\n					<search-input instance=\"vm.searchInput\" type=\"vm.selectedFilterItem.value\"\r\n						on-clear-tags=\"vm.onClearTags\"></search-input>\r\n					<button ng-click=\"vm.onSearchBtnClicked()\" type=\"button\" class=\"btn\"><i\r\n							class=\"icon-icons_search\"></i></button>\r\n				</div> --></div><div class=main-header__content__middle id=pixerf-main-navbar><ul class=main-header__content__middle__list><li class=main-header__content__middle__item ui-sref-active-class=navbar--active ui-sref-active-if=book-a-shoot-page><a class=text-transform ui-sref=book-a-shoot-page.about-custom-content>Book a Shoot</a></li><li class=main-header__content__middle__item ui-sref-active-class=navbar--active ui-sref-active-if=run-a-challenge-page><a class=text-transform ui-sref=run-a-challenge-page.about-challenge>Run a Challenge</a></li><li class=main-header__content__middle__item ui-sref-active-class=navbar--active ui-sref-active-if=buy-stock-page><a class=text-transform ui-sref=buy-stock-page.about-stock>Buy Stock</a></li><li class=main-header__content__middle__item uib-dropdown=\"\" class=\"business-dropdown-menu dropdown open\" ng-class=\"{\'style-open\': businessMenu.isopen, \'navbar--active\': cssClass.includes(\'for-business-highlight\')}\" ng-mouseover=\"businessMenu.isopen = true\" ng-mouseleave=\"businessMenu.isopen = false\"><div uib-dropdown-toggle=\"\" class=\"business-dropdown-menu__button dropdown-toggle\" aria-haspopup=true aria-expanded=true><span class=\"business-text text-transform\">For Business</span> <span class=\"icon-icons_chevron-down arrow-direct-with-menu dropdown-icon-menu\"></span></div><ul class=\"dropdown-menu business-dropdown-menu__submenu-btn\" uib-dropdown-menu=\"\" role=menu aria-labelledby=single-button><li ui-sref-active-class=navbar--active ui-sref-active-if=about-business-page.about-business ng-click=\"businessMenu.isopen = false\"><a class=text-transform ui-sref=about-business-page.about-business>Explore Business</a></li><li ui-sref-active-class=navbar--active ui-sref-active-if=about-business-page.case-studies ng-click=\"businessMenu.isopen = false\" ui-sref=about-business-page.case-studies.about-case-studies><a class=text-transform>Case Studies</a></li><li ui-sref-active-class=navbar--active ui-sref-active-if=about-business-page.pricing ng-click=\"businessMenu.isopen = false\" ui-sref=about-business-page.pricing><a class=text-transform>Pricing</a></li></ul></li><li class=main-header__content__middle__item uib-dropdown=\"\" class=\"business-dropdown-menu dropdown open\" ng-class=\"{\'style-open\': businessMenu.isopen, \'navbar--active\': cssClass.includes(\'for-news\')}\" ng-mouseover=\"businessMenu.isopen = true\" ng-mouseleave=\"businessMenu.isopen = false\"><div uib-dropdown-toggle=\"\" class=\"business-dropdown-menu__button dropdown-toggle\" aria-haspopup=true aria-expanded=true><span class=\"business-text text-transform\">News</span> <span class=\"icon-icons_chevron-down arrow-direct-with-menu dropdown-icon-menu\"></span></div><ul class=\"dropdown-menu business-dropdown-menu__submenu-btn\" uib-dropdown-menu=\"\" role=menu aria-labelledby=single-button><li ng-click=\"businessMenu.isopen = false\"><a class=text-transform href=https://xerfie.pixerf.com target=_blank>XEEK - Visual. Culture. Tech.</a></li><li ui-sref-active-class=navbar--active ui-sref-active-if=media-page ng-click=\"businessMenu.isopen = false\" ui-sref=media-page><a class=text-transform>Media</a></li></ul></li><li class=main-header__content__middle__item uib-dropdown=\"\" class=\"business-dropdown-menu dropdown open\" ng-class=\"{\'style-open\': creatorMenu.isopen, \'navbar--active\': cssClass.includes(\'for-creator-highlight\')}\" ng-mouseover=\"creatorMenu.isopen = true\" ng-mouseleave=\"creatorMenu.isopen = false\"><div uib-dropdown-toggle=\"\" class=\"business-dropdown-menu__button dropdown-toggle\" aria-haspopup=true aria-expanded=true><span class=\"business-text text-transform\">For Creators</span> <span class=\"icon-icons_chevron-down arrow-direct-with-menu dropdown-icon-menu\"></span></div><ul class=\"dropdown-menu business-dropdown-menu__submenu-btn\" uib-dropdown-menu=\"\" role=menu aria-labelledby=single-button><li ui-sref-active-class=navbar--active ui-sref-active-if=explore-creators-page.explore-communnity-hub ng-click=\"creatorMenu.isopen = false\"><a class=text-transform ui-sref=explore-creators-page.explore-communnity-hub>Explore Creators</a></li><li ui-sref-active-class=navbar--active ui-sref-active-if=run-a-challenge-page.live-challenges ng-click=\"creatorMenu.isopen = false\"><a class=text-transform ui-sref=run-a-challenge-page.live-challenges>Live Challenges</a></li><li ng-if=\"vm.loginUser && vm.loginUser.isContributor\" ui-sref-active-class=navbar--active ui-sref-active-if=explore-creators-page.creator-agreement ng-click=\"creatorMenu.isopen = false\"><a class=text-transform ui-sref=explore-creators-page.creator-agreement>Creator Agreement</a></li><li ng-if=\"vm.loginUser && vm.loginUser.isContributor\" ui-sref-active-class=navbar--active ui-sref-active-if=explore-creators-page.payout-and-pricing ng-click=\"creatorMenu.isopen = false\"><a class=text-transform ui-sref=explore-creators-page.payout-and-pricing>Payout and Pricing</a></li><li ui-sref-active-class=navbar--active ui-sref-active-if=for-creator-page.about-community ng-click=\"creatorMenu.isopen = false\"><a class=text-transform ui-sref=for-creator-page.about-community>About Community</a></li><!-- <li ui-sref-active-class=\"navbar--active\" ui-sref-active-if=\"for-creator-page.communities\"\r\n								ng-click=\"creatorMenu.isopen = false\">\r\n								<a class=\"text-transform\">Communities</a>\r\n							</li>\r\n							<li ui-sref-active-class=\"navbar--active\" ui-sref-active-if=\"for-creator-page.events\"\r\n								ng-click=\"creatorMenu.isopen = false\">\r\n								<a class=\"text-transform\">Events</a>\r\n							</li> --></ul></li></ul><!-- <div class=\"form-group header-search-bar\">\r\n					<search-input instance=\"vm.searchInput\" type=\"vm.selectedFilterItem.value\"\r\n						on-clear-tags=\"vm.onClearTags\"></search-input>\r\n					<button ng-click=\"vm.onSearchBtnClicked()\" type=\"button\" class=\"btn\"><i\r\n							class=\"icon-icons_search\"></i></button>\r\n					<div class=\"header-search-bar__search-type\">\r\n						<popover-selection-btn dynamic-placeholder=\"vm.selectedFilterItem.placeholder\"\r\n							placeholder-selector=\".header-search-bar input\" close-on-click=\"true\"\r\n							on-selection-changed=\"vm.onFilteredClicked(item)\" selected-model=\"vm.selectedFilterItem\"\r\n							settings=\"vm.filterSetting\"></popover-selection-btn>\r\n					</div>\r\n				</div> --></div><mobile-main-menu ng-if=\"isScreenMobile && !vm.isSearchBoxShow\"></mobile-main-menu><pixerf-auth class=main-header__content__right></pixerf-auth><button type=button class=navbar-toggle id=header-navbar-btn ng-click=vm.onMenuBtnClicked() ng-if=\"!vm.isSearchBoxShow && isScreenMobile\"><span class=\"icon-bar one\"></span> <span class=\"icon-bar two\"></span> <span class=\"icon-bar three\"></span></button></div></nav><ng-transclude></ng-transclude></div>");
$templateCache.put("app/components/header/headerBk.html","<div ng-class=cssClass ng-if=isVisible><nav scroll=vm.scrollHandler() ng-class=\"{\'nav-top-parent-style\': !vm.isTransformHeaderStyle.data && cssClass.split(\' \').includes(\'homepage\'), \'no-shadow\': !vm.isTransformHeaderStyle.data && cssClass.split(\' \').includes(\'no-shadow\'), \'nav-has-submenu-style\': cssClass.split(\' \').includes(\'submenu-style\'), \'navigation-search-bar\': !vm.isTransformHeaderStyle.data && cssClass.split(\' \').includes(\'navigation-search-bar\'), \'navbar-fixed-top\': !isScreenMobile}\" class=\"header navbar\"><div class=\"container-fluid relative header-wrapper\"><div class=navbar-header><a class=\"navbar-brand navbar-brand--marginleft\" ng-click=vm.onLogoClicked()><div class=pixerf-logo></div></a><div class=\"form-group header-search-bar mobile-show search-toggle-box\"><search-input instance=vm.searchInput type=vm.selectedFilterItem.value on-clear-tags=vm.onClearTags></search-input><button ng-click=vm.onSearchBtnClicked() type=button class=btn><i class=icon-icons_search></i></button></div><button type=button class=navbar-toggle id=header-navbar-btn ng-click=vm.onMenuBtnClicked() ng-if=\"!vm.isSearchBoxShow && isScreenMobile\"><span class=\"icon-bar one\"></span> <span class=\"icon-bar two\"></span> <span class=\"icon-bar three\"></span></button></div><div class=\"navbar-collapse pixerf-navbar-text\" id=pixerf-main-navbar><ul class=\"nav navbar-nav navbar-left\"><li ui-sref-active-class=navbar--active ui-sref-active-if=book-a-shoot-page><a class=text-transform ui-sref=book-a-shoot-page.about-custom-content>Book a shoot</a></li><li ui-sref-active-class=navbar--active ui-sref-active-if=run-a-challenge-page><a class=text-transform ui-sref=run-a-challenge-page.about-challenge>Run a Challenge</a></li><li ui-sref-active-class=navbar--active ui-sref-active-if=buy-stock-page><a class=text-transform ui-sref=buy-stock-page.about-stock>Buy Stock</a></li><li uib-dropdown=\"\" ui-sref-active-class=navbar--active class=\"business-dropdown-menu dropdown open\" ng-class=\"{\'style-open\': businessMenu.isopen}\" ng-mouseover=\"businessMenu.isopen = true\" ng-mouseleave=\"businessMenu.isopen = false\"><div uib-dropdown-toggle=\"\" class=\"business-dropdown-menu__button dropdown-toggle\" aria-haspopup=true aria-expanded=true><span class=\"business-text text-transform\">For Business</span> <span class=\"icon-icons_chevron-down arrow-direct-with-menu dropdown-icon-menu\"></span></div><ul class=\"dropdown-menu business-dropdown-menu__submenu-btn\" uib-dropdown-menu=\"\" role=menu aria-labelledby=single-button><li ui-sref-active-class=navbar--active ui-sref-active-if=about-business-page.about-business ng-click=\"businessMenu.isopen = false\"><a class=text-transform ui-sref=about-business-page.about-business>PIXERF for Businesses</a></li><li ui-sref-active-class=navbar--active ui-sref-active-if=about-business-page.case-studies.about-case-studies ng-click=\"businessMenu.isopen = false\"><a class=text-transform>Case Studies</a></li><li ui-sref-active-class=navbar--active ui-sref-active-if=about-business-page.pricing ng-click=\"businessMenu.isopen = false\"><a class=text-transform>Pricing</a></li></ul></li><li uib-dropdown=\"\" ui-sref-active-class=navbar--active class=\"business-dropdown-menu dropdown open\" ng-class=\"{\'style-open\': creatorMenu.isopen}\" ng-mouseover=\"creatorMenu.isopen = true\" ng-mouseleave=\"creatorMenu.isopen = false\"><div uib-dropdown-toggle=\"\" class=\"business-dropdown-menu__button dropdown-toggle\" aria-haspopup=true aria-expanded=true><span class=\"business-text text-transform\">For Creators</span> <span class=\"icon-icons_chevron-down arrow-direct-with-menu dropdown-icon-menu\"></span></div><ul class=\"dropdown-menu business-dropdown-menu__submenu-btn\" uib-dropdown-menu=\"\" role=menu aria-labelledby=single-button><li ui-sref-active-class=navbar--active ui-sref-active-if=explore-creators-page.explore-communnity-hub ng-click=\"creatorMenu.isopen = false\"><a class=text-transform ui-sref=explore-creators-page.explore-communnity-hub>PIXERF for Creators</a></li><li ui-sref-active-class=navbar--active ui-sref-active-if=for-creator-page.about-community ng-click=\"creatorMenu.isopen = false\"><a class=text-transform ui-sref=for-creator-page.about-community>About Community</a></li><li ui-sref-active-class=navbar--active ui-sref-active-if=for-creator-page.communities ng-click=\"creatorMenu.isopen = false\"><a class=text-transform>Communities</a></li><li ui-sref-active-class=navbar--active ui-sref-active-if=for-creator-page.events ng-click=\"creatorMenu.isopen = false\"><a class=text-transform>Events</a></li></ul></li></ul><div class=\"form-group header-search-bar\"><search-input instance=vm.searchInput type=vm.selectedFilterItem.value on-clear-tags=vm.onClearTags></search-input><button ng-click=vm.onSearchBtnClicked() type=button class=btn><i class=icon-icons_search></i></button><div class=header-search-bar__search-type><popover-selection-btn dynamic-placeholder=vm.selectedFilterItem.placeholder placeholder-selector=\".header-search-bar input\" close-on-click=true on-selection-changed=vm.onFilteredClicked(item) selected-model=vm.selectedFilterItem settings=vm.filterSetting></popover-selection-btn></div></div></div><mobile-main-menu ng-if=\"isScreenMobile && !vm.isSearchBoxShow\"></mobile-main-menu><pixerf-auth class=\"nav navbar-nav navbar-right\"></pixerf-auth></div></nav><ng-transclude></ng-transclude></div>");
$templateCache.put("app/components/hide-camera/hide-camera.html","<div class=hide-camera-wrapper><div ng-disabled=vm.isWorking class=btn-hide-camera ng-click=vm.onHideCameraBtnClick()><i tooltip-placement=right uib-tooltip=\"{{media.is_camera_model_hidden ?  \'Click to allow people see your camera model\' : \'Click to not allow people see your camera model\'}}\" class=\"fa fa-camera fa-stack-1x\" ng-class=\"{\'camera-model-hidden\': media.is_camera_model_hidden}\"></i></div></div>");
$templateCache.put("app/components/highlight-content-column/highlight-content-column.html","<div class=\"highlight-content-column__background clearfix\" ng-style=\"{\'background-image\': \'url(\' + data.photo + \')\'}\"><div class=your-lens-background ng-class=\"{\'background-show-animate\': vm.yourLendsHover}\" ng-style=\"{\'background-image\': \'url(\' + data.firstCol.photo + \')\'}\"></div><div class=your-space-background ng-class=\"{\'background-show-animate\': vm.yourSpaceHover}\" ng-style=\"{\'background-image\': \'url(\' + data.midCol.photo + \')\'}\"></div><div class=your-community-background ng-class=\"{\'background-show-animate\': vm.yourCommunityHover}\" ng-style=\"{\'background-image\': \'url(\' + data.lastCol.photo + \')\'}\"></div><div class=highlight-content-column__big-title ng-if=\"!vm.yourLendsHover && !vm.yourSpaceHover && !vm.yourCommunityHover\"><div class=highlight-content-column__big-title__header translate>{{data.title}}</div><div class=highlight-content-column__big-title__content translate>{{data.description}}</div></div><a ng-click=vm.onSignUpClicked()><div class=\"highlight-content-column__block your-lens\"><div class=\"highlight-content-column__block__hover-overlay your-lens\" ng-mouseover=\"vm.yourLendsHover = true\" ng-mouseleave=\"vm.yourLendsHover = false\" ng-style=\"{\'background-image\': \'url(\' + data.firstCol.photo + \')\'}\"><div class=overlay-color><div class=overlay-color__footer><div class=overlay-color__description translate>{{data.firstCol.description}}</div><div class=\"overlay-color__category text--extrabold\" ng-bind-html=\"data.firstCol.title | translate\"></div></div></div></div><div class=\"highlight-content-column__block__bottom-title text-overlay text--bold mouseover-condition\" ng-class=\"{\'mouse-in\': !vm.yourLendsHover, \'opacity-text\': vm.yourSpaceHover || vm.yourCommunityHover}\" ng-bind-html=\"data.firstCol.title | translate\"></div></div></a><a ng-click=vm.onSignUpClicked()><div class=\"highlight-content-column__block your-space\"><div class=\"highlight-content-column__block__hover-overlay your-space\" ng-mouseover=\"vm.yourSpaceHover = true\" ng-mouseleave=\"vm.yourSpaceHover = false\" ng-style=\"{\'background-image\': \'url(\' + data.midCol.photo + \')\'}\"><div class=overlay-color><div class=overlay-color__footer><div class=overlay-color__description translate>{{data.midCol.description}}</div><div class=\"overlay-color__category text--extrabold\" ng-bind-html=\"data.midCol.title | translate\"></div></div></div></div><div class=\"highlight-content-column__block__bottom-title text-overlay text--bold mouseover-condition\" ng-class=\"{\'mouse-in\': !vm.yourSpaceHover, \'opacity-text\': vm.yourLendsHover || vm.yourCommunityHover}\" ng-bind-html=\"data.midCol.title | translate\"></div></div></a><a ui-sref={{data.lastCol.linkToState}}><div class=\"highlight-content-column__block your-community\"><div class=\"highlight-content-column__block__hover-overlay your-community\" ng-mouseover=\"vm.yourCommunityHover = true\" ng-mouseleave=\"vm.yourCommunityHover = false\" ng-style=\"{\'background-image\': \'url(\' + data.lastCol.photo + \')\'}\"><div class=overlay-color><div class=overlay-color__footer><div class=overlay-color__description translate>{{data.lastCol.description}}</div><div class=\"overlay-color__category text--extrabold\" ng-bind-html=\"data.lastCol.title | translate\"></div></div></div></div><div class=\"highlight-content-column__block__bottom-title text-overlay text--bold mouseover-condition\" ng-class=\"{\'mouse-in\': !vm.yourCommunityHover, \'opacity-text\': vm.yourLendsHover || vm.yourSpaceHover}\" ng-bind-html=\"data.lastCol.title | translate\"></div></div></a></div>");
$templateCache.put("app/components/home-mobile/home-mobile.html","<div class=home-mobile-page><div class=home-mobile-page__background-overlay></div><div><div class=home-mobile-page__header-logo></div><div class=home-mobile-page__header-intropage></div></div><div class=\"home-mobile-page__footer text-center\"><div class=home-mobile-page__description>Showcase your unique perspectives<br>and get discovered by<br>brands, agencies and media.</div><div role=button class=\"btn btn-submit home-mobile-page__login-btn\" ng-click=vm.onLoginClicked()>Login</div><div role=button class=\"btn btn-submit home-mobile-page__signup-btn\" ng-click=vm.onSignUpClicked()>Sign Up. It\'s Free</div></div></div>");
$templateCache.put("app/components/info-col-intro/info-col-intro.html","<section class=info-col-intro><div class=\"info-col-intro__wrapper col-{{vm.infoCols.length}}\" ng-class=\"{\'space-between\': vm.isSpaceBetween}\"><div class=\"info-col-intro__col {{col.theme}} col-{{vm.infoCols.length}} {{col.paddingStyle}}\" ng-repeat=\"col in vm.infoCols\"><div class=info-col-intro__col__content-box><div ng-if=col.icon class=\"info-col-intro__col__icon {{col.styleIcon}} {{col.icon}}\"></div><div class=\"info-col-intro__col__content {{col.contentTheme}} {{col.styleContent}}\">{{col.content}}</div><button ng-click=col.cta() ng-if=col.button class=\"info-col-intro__col__btn {{col.btnTheme}}\">{{col.button}}</button></div></div></div></section>");
$templateCache.put("app/components/info-require-popup/info-require-popup.html","<div class=info-require-wrapper><div class=clearfix><div class=\"modal-header text-left\"><h3 class=\"modal--title text--bold text--color-black text-left\">{{vm.currentStep.title}}</h3><button ng-if=vm.currentStep.canSkip type=button class=close ng-click=vm.closePopup()><span class=icon-icons_close aria-hidden=true></span></button></div><div class=\"modal-info info-require-content clearfix\"><slick ng-class=\"{\'slick-slider--is-last-slide\': vm.isLastSlide}\" on-init=vm.slickSetting.onInit(slick) append-dots={{vm.slickSetting.appendDots}} adaptive-height=true infinite=false dots=true slides-to-show=1 swipe=false on-before-change=\"vm.slickSetting.onBeforeChange(event, slick, currentSlide, nextSlide)\" on-after-change=\"vm.slickSetting.onAfterChange(event, slick, currentSlide)\" arrows=false><div ng-if=vm.steps.BASIC_INFO data-slide-name=BASIC_INFO><div class=info-require-message-user>Fill in the required information below and let the community get to know you better!</div><form name=vm.profileForm><div class=\"form-group clearfix\" ng-if=\"vm.requiredFields[\'email\']\"><div class=info-require-label-col><label class=info-require-title required for=email>Email</label></div><div class=info-require-data-col><input maxlength=255 required name=email type=email ng-model=vm.userData.email class=form-control placeholder=your@email.com focus-me=true></div></div><div class=\"form-group clearfix\" ng-if=\"vm.requiredFields[\'first_name\']\"><div class=info-require-label-col><label class=info-require-title required for=first_name>First Name</label></div><div class=info-require-data-col><input maxlength=20 required validation-no-hyperlink validation-no-number name=first_name ng-model=vm.userData.first_name class=form-control placeholder=\"First name\" focus-me=true></div></div><div class=\"form-group clearfix\" ng-if=\"vm.requiredFields[\'last_name\']\"><div class=info-require-label-col><label class=info-require-title required for=last_name>Last Name</label></div><div class=info-require-data-col><input maxlength=20 required validation-no-hyperlink validation-no-number name=last_name ng-model=vm.userData.last_name class=form-control placeholder=\"Last name\" focus-me=true></div></div><div class=\"form-group clearfix\" ng-if=\"vm.requiredFields[\'country\']\"><div class=info-require-label-col><label class=info-require-title required for=country>Country</label></div><div class=info-require-data-col><country-select class=form-control required name=country ng-model=vm.userData.address.country placeholder=Country></country-select></div></div><div class=\"form-group clearfix\" ng-if=\"vm.requiredFields[\'location\']\"><div class=info-require-label-col><label required for=location class=info-require-title for=location>Location</label></div><div class=info-require-data-col><input class=form-control maxlength=255 required name=location g-places-autocomplete force-selection=true ng-model=vm.userData.location placeholder=Location></div></div><div class=\"form-group col-md-12 clearfix\" ng-if=\"vm.requiredFields[\'bio\']\"><label required for=\"\">Description</label><textarea required validation-no-hyperlink validation-no-number name=bio maxlength=255 ng-model=vm.userData.bio rows=3 class=form-control placeholder=\"Tell us something about yourself\"></textarea><div class=text-right><span class=textarea__length_descriptioon>{{vm.userData.bio.length}}/255</span></div></div><div class=\"form-group clearfix\" ng-if=\"vm.requiredFields[\'date_of_birth\']\"><div class=info-require-label-col><label class=info-require-title required for=date_of_birth>Date Of Birth</label></div><div class=info-require-data-col><div class=\"input-group pixerf-calendar-input\"><input type=text name=date_of_birth class=form-control uib-datepicker-popup=dd/MM/yyyy ng-model=vm.userData.date_of_birth is-open=vm.userData.isVisible datepicker-options=vm.userData.options close-text=Close alt-input-formats=altInputFormats required validation-under-min-age validation-over-max-age placeholder=DD/MM/YYYY> <button type=button class=\"btn pixerf-calendar-input__toogle-btn\" ng-click=\"vm.userData.isVisible = !vm.userData.isVisible\"><i class=\"glyphicon glyphicon-calendar\"></i></button></div></div></div></form></div><div class=info-require-popup__profile-step ng-if=vm.steps.SPECIALITIES_INFO data-slide-name=SPECIALITIES_INFO><div class=info-require-message-user>Introducing the all-new profile page that comes with more customisable features! Share details about your expertise, and upload Portfolio Galleries to showcase your talent to Businesses.</div><form name=vm.specialitiesForm><div class=\"form-group clearfix\" ng-if=\"vm.requiredFields[\'specialities\']\"><div class=info-require-label-col><label required for=specialities class=info-require-title>Photography Specialities</label></div><div class=info-require-data-col><pixerf-input-auto-complete ng-if=vm.specialities is-required=true name=specialities dropdown-class=info-service-rate-popup__dropdown-specialities options=vm.dopdownOpts data=vm.specialities model=vm.serviceData.specialitiesSelected on-changed=vm.onSpecialitiesSelected(vm.serviceData.specialitiesSelected) ng-class=\"{\'ng-invalid ng-invalid-required\' : !vm.serviceData.specialitiesSelected}\"></pixerf-input-auto-complete></div></div><div class=\"form-group clearfix\" ng-if=\"vm.requiredFields[\'years_of_experience\']\"><div class=info-require-label-col><label required for=experience class=info-require-title translate>{{\'years-of-experience\'}}</label></div><div class=info-require-data-col><input maxlength=2 type=number min=0 ng-pattern=/^\\d*$/ validation-no-hyperlink required name=years_of_experience ng-model=vm.serviceData.years_of_experience class=form-control placeholder=\"Years of experience\"></div></div><div class=\"form-group clearfix\" ng-if=\"vm.requiredFields[\'cameras\']\"><div class=info-require-label-col><label for=cameras class=info-require-title>Cameras</label></div><div class=info-require-data-col><add-inputfield-btn on-size-change=vm.slickSetting.onAfterChange() model=vm.serviceData.camerasSelected placeholder=Camera name=cameras max-count=3 min-count=1></add-inputfield-btn></div></div><div class=\"form-group clearfix\" ng-if=\"vm.requiredFields[\'service_rates\']\"><div class=info-require-label-col><label for=service_rates class=info-require-title translate>{{\'service-rates\'}}</label></div><div class=info-require-data-col><pixerf-input-auto-complete class=info-require-popup__service-rates__dropdown-select options=\"{\'maxOptions\': 1, \'noneSelectedText\': \'Select\', \'container\': \'body\'}\" ng-if=vm.serviceRates name=service_rates dropdown-class=info-require-popup__dropdown data=vm.serviceRates model=vm.serviceData.serviceRatesSelected on-changed=vm.onServiceRatesSelected(vm.serviceData.serviceRatesSelected)></pixerf-input-auto-complete><div class=info-require-popup__service-rates__mount><input maxlength=255 type=number min={{vm.CONST.SERVICES_RATE_MIN}} max={{vm.CONST.SERVICES_RATE_MAX}} ng-disabled=\"!vm.serviceData.serviceRatesSelected || !vm.serviceData.serviceRatesSelected.length\" name=service_rates_unit validation-no-hyperlink ng-model=vm.serviceData.services_rate_amount class=\"form-control info-require-popup__service-rates__money\" placeholder=0.00><div class=info-require-popup__service-rates__unit>SGD</div></div></div></div><div class=\"form-group clearfix\" ng-if=\"vm.requiredFields[\'availability\']\"><div class=info-require-label-col><label class=info-require-title>Availability</label></div><div class=\"info-require-data-col clearfix\"><div class=\"form-group info-require-popup__checkbox-group\"><div class=info-require-popup__availability-label__duration>Weekdays</div><div class=\"clearfix info-require-popup__checkbox-item\"><pixerf-checkbox on-changed=\"vm.onAvailabilityChanged(\'availability_weekdays\')\" model=vm.availability_weekdays model-property=day></pixerf-checkbox><label>Day</label></div><div class=\"clearfix info-require-popup__checkbox-item\"><pixerf-checkbox on-changed=\"vm.onAvailabilityChanged(\'availability_weekdays\')\" model=vm.availability_weekdays model-property=evening></pixerf-checkbox><label>Evening</label></div></div><div class=\"form-group info-require-popup__checkbox-group\"><div class=info-require-popup__availability-label__duration>Weekends</div><div class=\"clearfix info-require-popup__checkbox-item\"><pixerf-checkbox on-changed=\"vm.onAvailabilityChanged(\'availability_weekends\')\" model=vm.availability_weekends model-property=day></pixerf-checkbox><label>Day</label></div><div class=\"clearfix info-require-popup__checkbox-item\"><pixerf-checkbox on-changed=\"vm.onAvailabilityChanged(\'availability_weekends\')\" model=vm.availability_weekends model-property=evening></pixerf-checkbox><label>Evening</label></div></div></div></div></form></div><div class=info-require-popup__profile-step ng-if=vm.steps.PROFILE_IMAGE data-slide-name=PROFILE_IMAGE><h5 class=\"text-center info-require-message-user\" ng-bind=\"vm.userData.isBiz ? \'Select your brand or business logo so the Community knows who you are\' : \'Select a profile photo so the Community knows the photographer behind the shots\'\"></h5><div class=text-center><div class=info-require-popup__profile-step__profile-image-wrapper><!-- <i class=\"icon-icons_profile\"></i> --><div ng-attr-uib-tooltip=\"Update profile photo\" ng-attr-tooltip-placement=\"\'top\'\"><pixerf-user-avatar user-data=vm.userData ng-click=\"vm.showUploadUserProfilePhotos(\'profile\')\"></pixerf-user-avatar></div></div><button ng-click=\"vm.showUploadUserProfilePhotos(\'profile\')\" class=\"btn btn-submit\">Change</button></div></div><div class=info-require-popup__profile-step ng-if=vm.steps.COVER_IMAGE data-slide-name=COVER_IMAGE><h5 class=\"text-center info-require-message-user\" ng-bind=\"vm.userData.isBiz ? \'Select a cover photo that best represents your business\' : \'Select a cover photo that best represents you\' \"></h5><div class=text-center><div class=info-require-popup__profile-step__cover-image-wrapper><!-- <i class=\"icon-icons_profile\"></i> --><div class=info-require-popup__profile-step__cover-image ng-attr-uib-tooltip=\"(\'update-cover-photo\' | translate)\" ng-attr-tooltip-placement=\"\'top\'\" ng-click=\"vm.showUploadUserProfilePhotos(\'cover\')\" ng-style=\"{\'background-image\': \'url(\' + vm.userData.avatar.coverImage + \')\'}\"></div></div><button ng-click=\"vm.showUploadUserProfilePhotos(\'cover\')\" class=\"btn btn-submit\">Change</button></div></div><div class=\"info-require-popup__final-step text-center\" ng-if=vm.steps.UPLOADS data-slide-name=UPLOADS><div><i ng-click=vm.showUploadModal() class=icon-icons-upload></i><div class=info-require-popup__final-step__text><p>Have <span class=text--bold>at least 20 photo uploads</span> in our Marketplace to ensure greater visibility to buyers.</p><p class=info-require-popup__final-step__text__sub>Do also remember to <span class=text--bold>select up to three categories</span> per photo and <span class=text--bold>tag as many relevant keywords</span> as possible.</p></div></div><!-- <button class=\"btn btn-cancel info-require-popup__btn-center\" ng-click=\"vm.closePopup()\">Upload Later</button> --> <button ng-click=vm.showUploadModal() class=\"btn btn-submit info-require-popup__btn-center\">Upload Now</button></div></slick></div><div ng-if=\"!vm.isLastSlide || (vm.isLastSlide && vm.currentStep.name !== \'UPLOADS\')\" class=devider></div><div class=\"info-require-control clearfix\" ng-hide=\"vm.slick.slideCount === 1 && vm.currentStep.name === \'UPLOADS\'\"><button ng-click=\"vm.navigate(\'prev\')\" ng-if=\"!vm.isFirstSlide && !vm.isLastSlide\" type=button class=\"info-require-popup__navigation-btn info-require-popup__navigation-btn-prev btn btn--transparent\">Previous</button> <button ng-disabled=vm.isWorking ng-click=\"vm.navigate(\'next\')\" promise-btn ng-if=\"!vm.isLastSlide || (vm.isLastSlide && vm.currentStep.name !== \'UPLOADS\')\" type=button class=\"info-require-popup__navigation-btn info-require-popup__navigation-btn-next btn btn-submit\">{{vm.isLastSlide && vm.currentStep.name !== \'UPLOADS\'? \'Done\' : \'Next\'}}</button><div class=\"info-require-control__slide-dots relative\"></div></div></div></div>");
$templateCache.put("app/components/input-with-number-control/input-with-number-control.html","<div class=\"input-with-number-control clearfix\"><button class=input-with-number-control__increament_control ng-click=\"vm.onControlClicked(\'minus\')\" ng-disabled=!vm.controlsEnable.minus>-</button> <input input-number-only-max-digits={{vm.settings.maxDigits}} input-number-only validation-min-max validation-min-max-min=vm.settings.min validation-min-max-max=vm.settings.max class=\"form-control input-with-number-control__input\" ng-attr-placeholder={{vm.settings.placeholder}} ng-model=vm.model[vm.settings.propName] ng-change=vm.onChanged() ng-disabled=vm.settings.isDisabled ng-attr-name={{vm.settings.inputName}}> <button class=input-with-number-control__increament_control ng-click=\"vm.onControlClicked(\'plus\')\" ng-disabled=!vm.controlsEnable.plus>+</button></div>");
$templateCache.put("app/components/invitation-to-join-community/invitation-to-join-community.html","<div class=\"invitation-to-join-community clearfix\"><div class=\"invitation-to-join-community__row first-row\"><pixerf-checkbox class=vertical-align-middle--transform model=vm.community model-property=isSelected on-changed=vm.onSelectedChanged()></pixerf-checkbox></div><div class=\"invitation-to-join-community__row invitation-to-join-community__btns third-row\"><div class=vertical-align-middle--transform><button class=\"btn btn--no-box-shadow text--bold invitation-to-join-community__btns__deny-btn pull-left btn--transparent btn-basic\" ng-click=vm.onDenyBtnClicked(vm.community)></button> <button class=\"btn btn-submit pull-left invitation-to-join-community__btns__accept-btn\" authentication-click=vm.onAcceptBtnClicked(vm.community)></button></div></div><div class=second-row><div class=\"row clearfix\"><div class=\"first-row__sub no-padding\"><pixerf-user-avatar user-data=vm.community.owner lazy=true></pixerf-user-avatar></div><div class=\"second-column__sub invitation-to-join-community__row\"><div class=\"invitation-to-join-community__sub-description vertical-align-middle--transform\"><div class=clearfix><div class=\"text--bold text--color-black-6 text--truncate invitation-to-join-community__sub-description__owner-community\"><a ng-if=vm.community.owner.isBiz target=_blank class=text--color-black-6>{{vm.community.owner.displayName}}</a> <a ng-if=!vm.community.owner.isBiz ui-sref=\"user-home-page.business({id: vm.community.owner.id, userName: (vm.community.owner.displayName | toSnakeCase)})\" target=_blank class=text--color-black-6>{{vm.community.owner.displayName}}</a></div><div class=\"text--color-black-5 invitation-to-join-community__sub-description__invited-text\">{{\' invited you to join\'}}</div><div class=\"text--bold text--truncate invitation-to-join-community__sub-description__invited-member\"><a ui-sref=\"{{vm.commonConst.STATE.COMMUNITIES_DETAILS_DISCUSSIONS}}({id: vm.community.id})\" target=_blank class=text--color-black-6>{{\' \' + vm.community.name}}</a></div></div><div class=second-column__sub__no-of-member><span class=text--color-black-5>{{vm.community.member_count === 1 ? vm.community.member_count + \' member\' : vm.community.member_count + \' members\'}}</span> <span class=text--color-black-5>- {{(vm.community.is_unlisted == true) ? \'Unlisted\' : (vm.community.is_private ? \'Private\' : \'Public\')}} <i class=icon-icons-info tooltip-class=invitation-to-join-community__tooltip tooltip-append-to-body=true uib-tooltip-html=\"(vm.community.is_unlisted == true) ? vm.unlistedText : (vm.community.is_private ? vm.privateText :  vm.publicText)\" tooltip-placement=right></i></span></div></div></div></div></div></div>");
$templateCache.put("app/components/invite-community-members-popup/invite-community-members-popup.html","<div class=invite-community-members-popup><div class=clearfix><button ng-disabled=vm.isWorking type=button class=close ng-click=vm.onCloseBtnClicked()><span class=icon-icons_close aria-hidden=true></span></button><div class=\"modal-header invite-community-members-popup__header\"><h1 class=\"modal--title invite-community-members-popup__title\" translate>{{\'invite-members-to-community\'}}</h1></div><div class=\"modal-body text-center\"><div class=invite-community-members-popup__basic-info-step><div class=invite-community-members-popup__basic-info-step__col-left><community-member-filter on-changed=vm.onSearchConditionChanged(searchCondition) options=vm.searchFilterOptions></community-member-filter><person-list-selection ng-show=\"vm.layout === \'listPeople\'\" on-init=vm.onPersonListInit(instance) class=invite-community-members-popup__people-list on-selected-status-changed=vm.onPersonSelected()>{{\'no-records-match-search-condition\' | translate}}</person-list-selection><div class=invite-community-members-popup__invite-email-wrapper ng-show=\"vm.layout === \'listEmail\'\"><div class=invite-community-members-popup__email-input><div class=invite-community-members-popup__email-input__control><input type=email ng-model=vm.newEmail class=form-control placeholder=\"Email address\"></div><button class=\"invite-community-members-popup__email-input__invite-btn btn\" ng-click=vm.onAddToInviteList(vm.newEmail) ng-disabled=!vm.newEmail>{{\'add\' | translate}}</button></div><div class=\"invite-community-members-popup__invite-email clearfix\" ng-click=vm.onGmailClicked()><div class=\"email-icon email-icon__gmail\"></div><div class=invite-community-members-popup__invite-email__label>Invite your Gmail contacts</div></div><div class=\"invite-community-members-popup__invite-email clearfix\" ng-click=vm.onOutlookClicked()><div class=\"email-icon email-icon__outlook\"></div><div class=invite-community-members-popup__invite-email__label>Invite your Outlook contacts</div></div><div class=\"invite-community-members-popup__list-new-invitation clearfix\" ng-if=\"vm.layout != \'shareLink\'\"><div class=\"invite-community-members-popup__list-new-invitation__new-member clearfix\" ng-repeat=\"contact in vm.invitedList\"><div class=invite-community-members-popup__list-new-invitation__new-member__address>{{contact}}</div><div class=\"invite-community-members-popup__list-new-invitation__new-member__icon icon-icons_close\" ng-click=vm.onContactRemove(contact)></div></div></div><div class=\"invite-community-members-popup__list-new-invitation clearfix\" ng-if=\"vm.layout === \'shareLink\'\">{{\'share\' | translate}}</div></div><div class=invite-community-members-popup__invite-link-wrapper ng-show=\"vm.layout === \'shareLink\'\"><div class=invite-community-members-popup__invite-link-wrapper__title>Share your invite link with them</div><div class=invite-community-members-popup__invite-link-wrapper__share-link><input class=invite-community-members-popup__invite-link-wrapper__link ng-model=vm.shareLink readonly=readonly><div ng-click=\"vm.copyToClipboard(vm.shareLink, \'Your link has been successfully copied\')\" class=invite-community-members-popup__invite-link-wrapper__copy-btn translate>{{\'copy\'}}</div></div><div class=invite-community-members-popup__invite-message-title>{{\'invite-message\' | translate}}:</div><textarea rows=5 class=invite-community-members-popup__invite-message-content ng-model=vm.defaultShareText ng-change=vm.sharedTextChanged()></textarea><div class=invite-community-members-popup__share-info><div class=invite-community-members-popup__share-title>Or share with:</div><div class=invite-community-members-popup__share-list><div class=\"invite-community-members-popup__share-list__item whatsapp-share\"><div id=whatsappComShare class=\"social-media-icon whatsapp-icon\"></div></div></div></div></div></div><div class=invite-community-members-popup__basic-info-step__col-right ng-if=\"vm.layout === \'listPeople\'\"></div></div></div><div ng-if=\"vm.layout != \'shareLink\'\" class=devider></div><div ng-if=\"vm.layout != \'shareLink\'\" class=modal-footer><a ng-click=vm.onCancelBtnClicked() class=invite-community-members-popup__cancel-btn>{{\'cancel\' | translate}}</a> <button ng-if=\"vm.layout === \'listPeople\'\" ng-disabled=\"vm.isWorking || vm.numSelected === 0\" ng-click=vm.onSendBtnClicked() type=button class=\"btn btn-submit\">{{vm.submitBtnLabel}}</button> <button ng-if=\"vm.layout === \'listEmail\'\" ng-disabled=\"vm.isWorking || vm.invitedList.length === 0\" ng-click=vm.onSendListEmailsClicked() type=button class=\"btn btn-submit\">{{\'send-invite\' | translate}}</button></div></div></div>");
$templateCache.put("app/components/invite-to-community-popup/invite-to-community-popup.html","<div class=invite-to-community-popup><div class=clearfix><button ng-disabled=vm.isWorking type=button class=close ng-click=vm.onCloseBtnClicked()><span class=icon-icons_close aria-hidden=true></span></button><div class=\"modal-header invite-to-community-popup__header\"><h1 class=\"modal--title invite-community-members-popup__title\" translate translate-values=\"{name: vm.user.displayName}\">{{\'invite-to-join-your-communities\'}}</h1></div><div class=\"modal-body text-center\"><div class=invite-to-community-popup__basic-info-step><div ng-repeat=\"community in vm.communities\" class=\"invite-to-community-popup__community-wrapper text-center\"><div class=invite-to-community-popup__community-item__container ng-class=\"{\'first-item\': $index == 0}\"><a ng-click=vm.onCloseBtnClicked() ui-sref=\"{{vm.commonConst.STATE.COMMUNITIES_DETAILS_DISCUSSIONS}}({id: community.id,name: community.name})\"><div class=invite-to-community-popup__community-item__photo ng-style=\"{\'background-image\': \'url(\\\'\' + vm.getCommunityLogo(community) + \'\\\')\'}\"></div></a><div class=invite-to-community-popup__community-item__content><a ng-click=vm.onCloseBtnClicked() ui-sref=\"{{vm.commonConst.STATE.COMMUNITIES_DETAILS_DISCUSSIONS}}({id: community.id,name: community.name})\"><div class=invite-to-community-popup__community-item__content__info><div class=invite-to-community-popup__community-item__content__info__name>{{community.name}}</div></div></a><div class=invite-to-community-popup__community-item__content__label ng-if=vm.label translate>{{vm.label}}</div></div><div class=invite-to-community-popup__community-item__control><button class=\"invite-to-community-popup__community-item__control__btn btn btn-submit--no-background\" ng-click=vm.onInviteBtnclicked(community) ng-class=\"{\'invited\': vm.isInvitedCommunivty(community)}\" ng-disabled=\"vm.spinner.isVisible || vm.isInvitedCommunivty(community)\"><i ng-if=vm.isInvitedCommunivty(community) class=\"fa fa-check\" aria-hidden=true></i> <span translate>{{vm.isInvitedCommunivty(community) ? \'invited\' : \'invite\'}}</span></button></div></div></div><div ng-if=\"(vm.communities.length <= 0) && !vm.spinner.isVisible\" class=invite-to-community-popup__suggest-no-community><div class=invite-to-community-popup__suggest-no-community__title>{{\'you-do-not-own-any-community\' | translate}}</div><div class=invite-to-community-popup__suggest-no-community__description translate>{{\'but-its-always-a-good-time-to-build-one\'}}</div><button class=\"btn btn-submit invite-to-community-popup__suggest-no-community__action-btn\" ng-click=vm.onCreateCommunityClicked() translate>{{\'explore-communities\'}}</button></div><spinner-win spinner=vm.spinner></spinner-win></div></div></div></div>");
$templateCache.put("app/components/invite-user-by-link/invite-user-by-link.html","<div class=\"invite-users-event col-xs-12\"><spinner-win spinner=vm.spinner class=col-xs-12></spinner-win></div>");
$templateCache.put("app/components/invite-user-by-link/invite-user-to-community-by-link.html","<div class=\"invite-users-event col-xs-12\"><spinner-win spinner=vm.spinner class=col-xs-12></spinner-win></div>");
$templateCache.put("app/components/invite-user-popup/invite-user-popup.html","<div class=invite-user-popup><button ng-disabled=vm.isWorking type=button class=\"invite-user-popup__close-icon close\" ng-click=vm.onCloseBtnClicked()><span class=icon-icons_close aria-hidden=true></span></button><div class=invite-user-popup__header><div class=invite-user-popup__title translate>{{vm.options.title}}</div></div><div class=invite-user-popup__body><div class=invite-user-popup__col-left ng-class=\"{\'two-column\': vm.layout != \'link\'}\"><community-member-filter on-changed=vm.onSearchConditionChanged(searchCondition) options=vm.searchFilterOptions></community-member-filter><person-list-selection ng-show=\"vm.layout === \'directory\'\" on-init=vm.onPersonListInit(instance) class=invite-user-popup__people-list on-selected-status-changed=vm.onPersonSelected(data)>{{\'no-records-match-search-condition\' | translate}}</person-list-selection><div class=invite-user-popup__invite-email-wrapper ng-show=\"vm.layout === \'email\'\"><div class=invite-user-popup__invite-email-wrapper__header><div class=invite-user-popup__email-input><div class=invite-user-popup__email-input__control><input type=email ng-model=vm.newEmail class=form-control placeholder=\"Invite by email\"></div><button class=\"invite-user-popup__email-input__invite-btn btn\" ng-click=vm.onAddToInviteList(vm.newEmail) ng-disabled=!vm.newEmail>{{\'add\' | translate}}</button></div><div class=\"invite-user-popup__invite-email clearfix\" ng-click=vm.onGmailClicked()><div class=\"email-icon email-icon__gmail\"></div><div class=invite-user-popup__invite-email__label translate>{{\'invite-your-gmail-contacts\'}}</div></div><div class=\"invite-user-popup__invite-email clearfix\" ng-click=vm.onOutlookClicked()><div class=\"email-icon email-icon__outlook\"></div><div class=invite-user-popup__invite-email__label translate>{{\'invite-your-outlook-contacts\'}}</div></div></div><div class=\"invite-user-popup__list-new-invitation clearfix\" ng-if=\"vm.layout === \'email\'\"><person-selection ng-repeat=\"person in vm.invitedList\" ng-if=\"(person.email || person.email.address)\" person=person mode=select options=vm.listEmailOptions on-removed=vm.onRemoveFromSelectedPeople(data) on-selected=vm.onPersonSelected(person)></person-selection></div></div><div class=invite-user-popup__invite-link-wrapper ng-show=\"vm.layout === \'link\'\"><div class=invite-user-popup__invite-link-wrapper__title translate>{{\'share-your-invite-link-with-them\'}}</div><div class=invite-user-popup__invite-link-wrapper__share-link><input class=invite-user-popup__invite-link-wrapper__link ng-model=vm.link readonly=readonly><div ng-click=\"vm.copyToClipboard(vm.link, \'Your link has been successfully copied\')\" class=invite-user-popup__invite-link-wrapper__copy-btn>{{\'copy\' | translate}}</div></div><div class=invite-user-popup__invite-message-title>{{\'invite-message\' | translate}}:</div><textarea rows=5 class=invite-user-popup__invite-message-content ng-model=vm.defaultShareText ng-change=vm.sharedTextChanged()></textarea><div class=invite-user-popup__share-info><div class=invite-user-popup__share-title>{{\'or-share-with\' | translate}}:</div><div class=invite-user-popup__share-list><div class=\"invite-user-popup__share-list__item whatsapp-share\"><div id=whatsappComShare class=\"social-media-icon whatsapp-icon\"></div></div></div></div></div></div><div class=invite-user-popup__col-right ng-if=\"vm.layout != \'link\'\"><div class=invite-user-popup__col-right__control-info><div class=invite-user-popup__col-right__control-info__selected-quantity><span class=invite-user-popup__col-right__control-info__selected-quantity__value>{{vm.selectedPeople.length}}</span> {{(\'selected\' | translate).toLowerCase()}}</div><div ng-if=vm.selectedPeople.length class=invite-user-popup__col-right__control-info__remove-btn ng-click=vm.onRemoveSelectedPeople()>{{\'remove-all\' | translate}}</div></div><div class=invite-user-popup__col-right__selected-user-list><person-selection ng-repeat=\"person in vm.selectedPeople\" person=person mode=remove options=vm.selectedPeopleOptions on-removed=vm.onRemoveFromSelectedPeople(data)></person-selection></div></div></div><div class=invite-user-popup__footer><button ng-click=vm.onCancelBtnClicked() ng-show=vm.searchFilterOptions.defaultSearchCondition.showSkipBtn class=\"invite-user-popup__cancel-btn btn btn-cancel--no-background\">{{\'skip\' | translate}}</button> <button ng-if=\"vm.layout != \'link\'\" ng-disabled=\"vm.isWorking || vm.selectedPeople.length === 0\" ng-click=vm.onSendBtnClicked() type=button class=\"invite-user-popup__action-btn btn btn-submit\">{{\'invite\' | translate}}</button></div></div>");
$templateCache.put("app/components/join-community-btn/join-community-btn.html","<div class=\"join-community-btn-wrapper dropdown\"><button ng-if=\"!vm.mLoginnedUser.isBiz || !vm.isHideBtnWithBizAcc\" data-toggle=dropdown ng-mouseover=vm.onMouseOver() ng-mouseleave=vm.onMouseLeave() ng-disabled=vm.isWorking ng-class=\"{\'join-community-btn--joined\': community.is_joined, \'join-community-btn--leave\': vm.isHovering, \'btn-submit--no-background\': community.membership_status === vm.STATUS.INVITED, \'btn-pixerf-theme--blue\': community.membership_status != vm.STATUS.INVITED}\" class=\"btn text--bold join-community-btn btn-block\" authentication-click=vm.onBtnClicked() authentication-for=Contributor><span class=icon-icons_check></span> <span class=join-community-btn__btn-label>{{vm.btnLabel}}</span> <span ng-if=\"community.membership_status === vm.STATUS.INVITED\" class=caret></span></button><ul class=dropdown-menu aria-labelledby=drop5 ng-show=\"community.membership_status === vm.STATUS.INVITED\"><li ng-click=vm.onBtnClicked(vm.ACTION.REJECT)><a>Reject to join this community</a></li><li ng-click=vm.onBtnClicked(vm.ACTION.ACCEPT)><a>Accept to join this community</a></li></ul></div>");
$templateCache.put("app/components/leader-board/leader-board.html","<div class=leader-board on-window-resize-event=vm.onWindowResize()><div class=leader-board__photographers-wrapper infinite-scroll-distance=0.3 infinite-scroll-disabled=vm.isLastPage infinite-scroll=vm.fetchMore() infinite-scroll-immediate-check=false><div class=\"photographer-item-wrapper relative clearfix\" ng-repeat=\"photographer in vm.photographers\"><photographer layout={{layoutPhotogarpher}} is-hide-ranking=isHideRanking number=\"{{$index + 1}}\" item=photographer rank={{photographer.leaderboard.rank}} unit={{vm.unit}} highlight-top=highlightTop></photographer></div><scroll-paging hide-back-to-top=true spinner=vm.spinner show-message=!!endingMessage message={{endingMessage}} is-last-page=vm.isLastPage></scroll-paging></div><div class=\"leader-board__photographers__empty-state text--semibold text--color-black\" ng-if=\"vm.photographers.length === 0\">{{\'oops-looks-like-no-photographers\' | translate}}</div></div>");
$templateCache.put("app/components/license-review/license-review-popover.html","<div class=\"clearfix photo-license-popover\"><h4 class=\"text-left text--color-black text--semibold photo-license-popover__title\">Please confirm licence type.</h4><div class=\"photo-license-popover__close-btn icon-icons_close pull-right\" role=button title=Close ng-click=vm.onCloseBtnClicked()></div><photo-license-deternimation-questions curate-mode=true class=upload-photo-detail__release-form-confirm__questions media=vm.savedData on-question-answered=vm.onQuestionAnswered(question)></photo-license-deternimation-questions><div class=photo-license-popover__btns-wrapper><button ng-disabled=vm.isWorking class=\"btn btn-submit\" ng-click=vm.onApproveBtnClicked()>Confirm</button></div><spinner-win is-overlay-mode=true spinner=vm.spinner></spinner-win></div>");
$templateCache.put("app/components/license-review/license-review.html","<div class=license-review><ng-transclude></ng-transclude><button ng-click=vm.onPopoverOpenned() class=\"license-review__content-overlay absolute absolute--full\" popover-trigger=\"\'outsideClick\'\" popover-append-to-body=true popover-class=license-review-popover-parent uib-popover-template=\"\'app/components/license-review/license-review-popover.html\'\" popover-placement=\"auto bottom\"></button></div>");
$templateCache.put("app/components/license-review-popup/license-review-popup.html","<div class=license-review-popup><h4 class=license-review-popup__title>Please confirm licence type.</h4><div class=\"license-review-popup__close-btn icon-icons_close pull-right\" role=button title=Close ng-click=vm.onCloseBtnClicked()></div><photo-license-deternimation-questions curate-mode=true class=license-review-popup__questions media=vm.savedData on-question-answered=vm.onQuestionAnswered(question)></photo-license-deternimation-questions><div class=license-review-popup__btns-wrapper><button ng-disabled=vm.isWorking class=\"btn btn-submit\" ng-click=vm.onApproveBtnClicked()>Confirm</button></div><spinner-win is-overlay-mode=true spinner=vm.spinner></spinner-win></div>");
$templateCache.put("app/components/like-btn/like-btn.html","<div class=like-btn-wrapper><div ng-disabled=media.isMine ng-class=\"{\'btn-like--liked\': media.is_liked, \'btn-like__like-count-hover\': hoverShowNumber}\" class=btn-like ng-attr-title={{vm.getLikeBtnTitle(media)}}><span class=icon-icons_like authentication-click=vm.onLikePhotoBtnClick(media) check-verified-email=true></span> <span ng-if=hoverShowNumber class=\"btn-like__like-count like-count--hover\" authentication-click=vm.onLikePhotoBtnClick(media) check-verified-email=true>{{vm.getLikeCount(media.like_count)}}</span> <span ng-click=vm.onShowLikedListBtnClick(file) class=\"btn-like__counter text--semibold\" title=\"{{\'click-to-see-who-like-this-photo\' | translate}}\">{{media.like_count}} {{(\'likes\' | translate).toLowerCase()}}</span></div></div>");
$templateCache.put("app/components/link-mobile-app/link-mobile-app.html","<div><div class=ios-logo ng-if=\"vm.isIOS || !vm.isAndroid\"><a href=\"https://itunes.apple.com/app/pixerf/id1165272133?mt=8\" target=_blank><img class=app_store src=assets/images/apple-store.png></a></div><div class=android-logo ng-if=\"vm.isAndroid || !vm.isIOS\"><a href=\"https://play.google.com/store/apps/details?id=com.pixerf.android\" target=_blank><img class=app_store src=assets/images/play-store.png></a></div></div>");
$templateCache.put("app/components/list-payment-method-popup/list-payment-method-popup.html","<div class=list-payment-method-popup__content><div class=list-payment-method-popup__description>For all payout requests within the same month, payment will be released to you on the last day of the following month.</div><div class=list-payment-method-popup__method ng-repeat=\"paymentMethod in vm.paymentMethods\" ng-click=vm.onPaymentMethodClicked(paymentMethod)><div ng-class=\"{\'icon-icons-bullet--checked\': paymentMethod.isSelected, \'icon-icons-bullet\': !paymentMethod.isSelected}\" class=list-payment-method-popup__icon-selection></div><div class=\"list-payment-method-popup__method__content clearfix\"><div class=\"list-payment-method-popup__method__label text--extrabold text--color-black\">{{paymentMethod.name}}</div><div class=list-payment-method-popup__method__fees>{{paymentMethod.fee}}</div><div class=list-payment-method-popup__method__details>{{paymentMethod.details}}</div></div></div><!-- <table class=\"list-payment-method-popup__table method-table text--color-black\">\r\n    <tr class=\"method-table__header method-table__row\">\r\n      <th class=\"method-table__col method-table__col__method col-xs-3 no-padding text--bold\">Method</th>\r\n      <th class=\"method-table__col method-table__col__fees col-xs-4 no-padding\">Fees</th>\r\n      <th class=\"method-table__col method-table__col__details col-xs-5 no-padding\">Details</th>\r\n    </tr>\r\n    <tr class=\"method-table__row\" ng-repeat=\"paymentMethod in vm.paymentMethods\"\r\n      ng-click=\"vm.onPaymentMethodClicked(paymentMethod)\">\r\n      <td class=\"method-table__col method-table__col__method text--bold\">\r\n        <span\r\n          ng-class=\"{\'icon-icons-bullet--checked btn-pixerf-theme\': paymentMethod.isSelected, \'icon-icons-bullet\': !paymentMethod.isSelected}\"\r\n          class=\" method-table__icon-selection\"></span>\r\n        <span class=\"method-table__label-selection\">{{paymentMethod.name}}</span>\r\n      </td>\r\n      <td class=\"method-table__col method-table__col__fees\">{{paymentMethod.fee}}</td>\r\n      <td class=\"method-table__col method-table__col__details\">{{paymentMethod.details}}</td>\r\n    </tr>\r\n  </table> --></div>");
$templateCache.put("app/components/manage-communities/manage-communities.html","<div class=manage-communities><div class=manage-communities__right-content><div class=manage-communities__right-content__breadcrum><span class=manage-communities__right-content__breadcrum__item>Community</span> <span class=manage-communities__right-content__breadcrum__item>></span> <span class=manage-communities__right-content__breadcrum__item>Communities</span> <span class=manage-communities__right-content__breadcrum__item>></span> <span class=\"manage-communities__right-content__breadcrum__item actived\" translate>{{vm.subContextPage}}</span></div><div class=manage-communities__right-content__navigation><ul class=setting-top-navigation ng-class=\"{\'nav-business\': vm.user.isBiz}\"><button type=button class=\"setting-top-navigation__collapse-button navbar-toggle collapsed\" data-toggle=collapse data-target=#manage-communities-navigation aria-expanded=false><div class=setting-top-navigation__context translate>{{vm.subContextPage}}</div><div class=\"setting-top-navigation__mobile-button arrow-animation-menu-collapse\"><span class=\"icon-bar dash-one\"></span> <span class=\"icon-bar dash-two\"></span></div></button><div class=\"setting-top-navigation__list collapse navbar-collapse\" navbar-collapse-on-click=true id=manage-communities-navigation><li ng-if=vm.isAdmin class=setting-top-navigation__item ui-sref-active=setting-top-navigation__item--active ui-sref=setting.manage-communities.manage-pending-approval-communities>{{\'pending-approval\' | translate}}</li><li ng-if=vm.isAdmin class=setting-top-navigation__item ui-sref-active=setting-top-navigation__item--active ui-sref=setting.manage-communities.manage-action-required-communities>{{\'action-required\' | translate}}</li><li ng-if=vm.isAdmin class=setting-top-navigation__item ui-sref-active=setting-top-navigation__item--active ui-sref=setting.manage-communities.manage-active-communities>{{\'active\' | translate}}</li><li ng-if=vm.isAdmin class=setting-top-navigation__item ui-sref-active=setting-top-navigation__item--active ui-sref=setting.manage-communities.manage-inreview-communities>{{\'in-review\' | translate}}</li><li ng-if=vm.isAdmin class=setting-top-navigation__item ui-sref-active=setting-top-navigation__item--active ui-sref=setting.manage-communities.manage-deactivated-communities>{{\'deactivated\' | translate}}</li><li class=setting-top-navigation__item ui-sref-active=setting-top-navigation__item--active ui-sref=setting.manage-communities.communities>{{\'your-communities\' | translate}} <span ng-if=\"vm.user.stats && vm.user.stats.total_my_communities\">({{vm.user.stats.total_my_communities}})</span></li><li ng-if=!vm.user.isBiz class=setting-top-navigation__item ui-sref-active=setting-top-navigation__item--active ui-sref=setting.manage-communities.manage-invited-communities>{{\'invited\' | translate}} <span ng-if=\"vm.user.stats && vm.user.stats.total_invited_communities\">({{vm.user.stats.total_invited_communities}})</span></li><li ng-if=!vm.user.isBiz class=setting-top-navigation__item ui-sref-active=setting-top-navigation__item--active ui-sref=setting.manage-communities.manage-requested-communities>{{\'requested\' | translate}} <span ng-if=\"vm.user.stats && vm.user.stats.total_requested_communities\">({{vm.user.stats.total_requested_communities}})</span></li><li ng-if=vm.user.canManageCommunity class=setting-top-navigation__item ui-sref-active=setting-top-navigation__item--active ui-sref=setting.manage-communities.manage-pending-communities>{{\'pending\' | translate}} <span ng-if=\"vm.user.stats && vm.user.stats.total_pending_communities\">({{vm.user.stats.total_pending_communities}})</span></li></div></ul></div><div class=manage-community ui-view></div></div></div>");
$templateCache.put("app/components/manage-community/manage-community.html","<div class=\"manage-community__master main__content--md\" ng-class=\"{\'margin-top--1\': vm.isScreenMobile}\"><a class=\"manage-community__master__header-top col-xs-12\" ui-sref=\"community-detail-page.community-detail-discussions({id: vm.community.id,name: vm.community.name})\"><img class=manage-community__master__header-top__logo ng-src={{vm.community.cover.thumbnail}}><div class=manage-community__master__header-top__name>{{vm.community.name}}</div></a><div class=manage-community__master__body><ul class=manage-community__master__col-left><div class=manage-community__master__header-name translate>{{\'manage-community\'}}</div><button type=button class=\"navbar-toggle collapsed\" data-toggle=collapse data-target=#manage-community-navbar-collapse aria-expanded=false><div class=\"pull-left text--bold\" translate>{{\'manage-community\'}}</div><div class=\"pull-right arrow-animation-menu-collapse\"><span class=\"icon-bar dash-one\"></span> <span class=\"icon-bar dash-two\"></span></div></button><div class=\"manage-community__master__navigation collapse navbar-collapse\" navbar-collapse-on-click=true id=manage-community-navbar-collapse><a ui-sref-active-class=active ui-sref-active-if=manage-community.members ui-sref=\"manage-community.members({status: \'members\'})\" class=manage-community__master__navigation__item>{{\'manage-members\' | translate}} <span class=manage-community__master__navigation__item__count>{{vm.community.stats.requested_count}}</span> </a><a ui-sref-active-class=active ui-sref-active-if=manage-community.pending-posts ui-sref=manage-community.pending-posts class=manage-community__master__navigation__item>{{\'pending-posts\' | translate}} <span class=manage-community__master__navigation__item__count>{{vm.community.stats.pending_discussions}}</span> </a><a ui-sref-active-class=active ui-sref-active-if=manage-community.reports ui-sref=\"manage-community.reports({status: \'reported-posts-action-required\'})\" class=manage-community__master__navigation__item>{{\'reports\' | translate}} <span class=manage-community__master__navigation__item__count>{{vm.community.pending_report_count}}</span> </a><a ui-sref-active-class=active ui-sref-active-if=manage-community.edit-community ui-sref=\"{{vm.isOwner ? \'manage-community.edit-community\': \'manage-community.members\'}}\" ng-class=\"{\'disabled\' : !vm.isOwner}\" class=manage-community__master__navigation__item>{{\'edit-community\' | translate}}</a></div></ul><div class=manage-community__master__col-right><div class=manage-community><div class=manage-community__right-content><div class=manage-community__right-content__navigation ng-if=vm.showTopCountMember><ul class=setting-top-navigation ng-class=\"{\'nav-business\': vm.user.isBiz}\"><div class=manage-community__right-content__navigation__breadcrum><span class=manage-community__right-content__navigation__breadcrum__item translate>{{\'manage-community\'}} </span><span class=manage-community__right-content__navigation__breadcrum__item translate>> {{\'manage-members\'}} </span><span class=\"manage-community__right-content__navigation__breadcrum__item active\" translate>> {{vm.subContextPage}}</span></div><button type=button class=\"setting-top-navigation__collapse-button navbar-toggle collapsed\" data-toggle=collapse data-target=#manage-communities-navigation aria-expanded=false><div class=setting-top-navigation__context translate>{{vm.subContextPage}}</div><div class=\"setting-top-navigation__mobile-button arrow-animation-menu-collapse\"><span class=\"icon-bar dash-one\"></span> <span class=\"icon-bar dash-two\"></span></div></button><div class=\"setting-top-navigation__list collapse navbar-collapse\" navbar-collapse-on-click=true id=manage-communities-navigation><li class=setting-top-navigation__item ui-sref-active=setting-top-navigation__item--active ui-sref=\"manage-community.members({status: \'members\'})\">{{\'members\' | translate}}{{\' (\' + (vm.community.member_count || \'0\') + \')\'}}</li><li class=setting-top-navigation__item ui-sref-active=setting-top-navigation__item--active ui-sref=\"manage-community.members({status: \'admin\'})\">{{\'admin\' | translate}}{{\' (\' + (vm.community.manager_count ? (vm.community.manager_count + 1) :\'0\') + \')\'}}</li><li class=setting-top-navigation__item ui-sref-active=setting-top-navigation__item--active ui-sref=\"manage-community.members({status: \'requested\'})\">{{\'requested\' |translate}}{{\' (\' + (vm.community.stats.requested_count || \'0\') + \')\'}}</li><li class=setting-top-navigation__item ui-sref-active=setting-top-navigation__item--active ui-sref=\"manage-community.members({status: \'invited\'})\">{{\'invited\' |translate}}{{\' (\' + (vm.community.stats.invited_count || \'0\') + \')\'}}</li><li class=setting-top-navigation__item ui-sref-active=setting-top-navigation__item--active ui-sref=\"manage-community.members({status: \'blocked\'})\">{{\'blocked\' | translate}}{{\' (\' + (vm.community.blocked_count || \'0\') + \')\'}}</li></div></ul></div><div class=\"manage-community__right-content__navigation reports-navigation\" ng-if=vm.showReportsNav><div class=manage-community__right-content__navigation__breadcrum><span class=manage-community__right-content__navigation__breadcrum__item translate>{{\'manage-community\'}} </span><span class=manage-community__right-content__navigation__breadcrum__item translate>> {{\'reports\'}} </span><span class=\"manage-community__right-content__navigation__breadcrum__item active\" translate>> {{vm.subContextPage}}</span></div><button type=button class=\"setting-top-navigation__collapse-button navbar-toggle collapsed\" data-toggle=collapse data-target=#manage-communities-navigation aria-expanded=false><div class=setting-top-navigation__context translate>{{vm.subContextPage}}</div><div class=\"setting-top-navigation__mobile-button arrow-animation-menu-collapse\"><span class=\"icon-bar dash-one\"></span> <span class=\"icon-bar dash-two\"></span></div></button><ul class=setting-top-navigation ng-class=\"{\'nav-business\': vm.user.isBiz}\"><div class=\"setting-top-navigation__list collapse navbar-collapse\" navbar-collapse-on-click=true id=manage-communities-navigation><li class=setting-top-navigation__item ui-sref-active=setting-top-navigation__item--active ui-sref=\"manage-community.reports({status: \'reported-posts-action-required\'})\">{{\'reported-posts-action-required\' | translate}}{{\' (\' + (vm.community.pending_report_count || \'0\') + \')\'}}</li><li class=setting-top-navigation__item ui-sref-active=setting-top-navigation__item--active ui-sref=\"manage-community.reports({status: \'past-reported-posts\'})\">{{\'past-reported-posts\' | translate}}{{\' (\' + (vm.community.resolved_report_count || \'0\') + \')\'}}</li></div></ul></div><div class=manage-community__content ui-view></div></div></div></div></div></div>");
$templateCache.put("app/components/manage-community-report-list-view/manage-community-report-list-view.html","<div class=manage-community-report-list-view><div ng-if=\"vm.isAdmin && 0\" class=\"manage-community-report-list-view__item manage-community-report-list-view__select\"><stick-checkbox on-changed=vm.onToggleSelected(vm.report) model=report model-property=isSelected layout-style=regular-square is-disabled=vm.disabledCheckbox()></stick-checkbox></div><div class=\"manage-community-report-list-view__item manage-community-report-list-view__type\"><span class=manage-community-report-list-view__item__mobile-label__haft-col>Type:</span> <span>{{report.typeOfReport}}</span></div><div class=\"manage-community-report-list-view__item manage-community-report-list-view__reason\"><span class=manage-community-report-list-view__item__mobile-label__haft-col>Reason:</span> <span class=manage-community-report-list-view__reason__text>{{report.reason}}</span></div><div class=\"manage-community-report-list-view__item manage-community-report-list-view__reporter\"><span class=manage-community-report-list-view__item__mobile-label__haft-col>Reporter:</span> <a ng-click=vm.prevenPubbleClick() ui-sref=\"user-home-page.personal.home({id: report.user.id, userName: (report.user.displayName | toSnakeCase)})\" target=_blank><pixerf-user-avatar user-data=vm.reportAvatar uib-tooltip=\"{{report.user.displayName || report.user.email}}\" class=manage-community-report-list-view__reporter__cover lazy=true></pixerf-user-avatar></a></div><div class=\"manage-community-report-list-view__item manage-community-report-list-view__event\"><a ng-if=\"report.item_type ==\'event\'\" ui-sref=\"event-detail-page({id: report.event.id, name:report.event.name})\" target=_blank><img ng-src={{report.event.cover.thumbnail}} class=manage-community-report-list-view__event__cover><a class=manage-community-report-list-view__event__name ui-sref=\"event-detail-page({id: report.event.id, name:report.event.name})\" target=_blank>{{report.event.name}}</a></a><div ng-if=\"report.item_type !=\'event\'\">N/A</div></div><div class=\"manage-community-report-list-view__item manage-community-report-list-view__date\"><span class=manage-community-report-list-view__item__mobile-label__haft-col>Date:</span> <span>{{vm.fomatedDate}}</span></div><div class=\"manage-community-report-list-view__item manage-community-report-list-view__status\"><span class=manage-community-report-list-view__item__mobile-label__haft-col>Status:</span> <span ng-class=\"{\'blue-status-theme\': [\'open\', \'resolved\'].includes(report.status), \'red-status-theme\': report.status === \'validated\'}\">{{report.statusText}}</span></div><div class=\"manage-community-report-list-view__item manage-community-report-list-view__more\"><div uib-dropdown class=manage-community-report-list-view__more__btn-wrapper><button class=\"manager-member-list-view__action__btn btn btn-submit\" ng-click=vm.onReportClicked(vm.report)><span class=manager-member-list-view__action__btn-label>View Post</span></button></div></div></div>");
$templateCache.put("app/components/manage-event/manage-event.html","<div class=\"manage-event__master main__content--md\" ng-class=\"{\'margin-top--1\': vm.isScreenMobile}\"><a class=\"manage-event__master__header-top col-xs-12\" target=_blank ui-sref=\"event-detail-page({id: vm.event.id,name: vm.event.name})\"><img class=manage-event__master__header-top__logo ng-src={{vm.event.cover.thumbnail}}><div class=manage-event__master__header-top__name>{{vm.event.name}}</div></a><div class=manage-event__master__body><ul class=manage-event__master__col-left><div class=manage-event__master__header-name translate>{{vm.isTypeClass ? \'manage-class\' : \'manage-event\'}}</div><button type=button class=\"navbar-toggle collapsed\" data-toggle=collapse data-target=#manage-event-navbar-collapse aria-expanded=false><div class=\"pull-left text--bold\" translate>{{vm.isTypeClass ? \'manage-class\' : \'manage-event\'}}</div><div class=\"pull-right arrow-animation-menu-collapse\"><span class=\"icon-bar dash-one\"></span> <span class=\"icon-bar dash-two\"></span></div></button><div class=\"manage-event__master__navigation collapse navbar-collapse\" navbar-collapse-on-click=true id=manage-event-navbar-collapse><a ui-sref-active-class=active ui-sref-active-if=manage-event.members ui-sref=\"manage-event.members({status: \'attendees\'})\" class=manage-event__master__navigation__item>{{\'manage-attendees\' | translate}} <span class=manage-event__master__navigation__item__count>{{vm.event.requested_count || \'0\'}}</span> </a><a ui-sref-active-class=active ui-sref-active-if=manage-event.pending-posts ui-sref=manage-event.pending-posts class=manage-event__master__navigation__item>{{\'pending-posts\' | translate}} <span class=manage-event__master__navigation__item__count>{{vm.event.post_count || \'0\'}}</span> </a><a ui-sref-active-class=active ui-sref-active-if=manage-event.reports ui-sref=\"manage-event.reports({status: \'reported-posts-action-required\'})\" class=manage-event__master__navigation__item>{{\'reports\' | translate}} <span class=manage-event__master__navigation__item__count>{{vm.event.report_count || \'0\'}}</span> </a><a ui-sref-active-class=active ui-sref-active-if=manage-event.edit-event ui-sref=\"{{vm.isOwner ? \'manage-event.edit-event\': \'manage-event.members\'}}\" ng-class=\"{\'disabled\' : !vm.isOwner}\" class=manage-event__master__navigation__item>{{ vm.isTypeClass ? \'edit-class\' : \'edit-event\' | translate}}</a></div></ul><div class=manage-event__master__col-right><div class=manage-event><div class=manage-event__right-content><div class=manage-event__right-content__navigation ng-if=vm.showTopCountMember><ul class=setting-top-navigation ng-class=\"{\'nav-business\': vm.user.isBiz}\"><div class=manage-event__right-content__navigation__breadcrum><span class=manage-event__right-content__navigation__breadcrum__item translate>{{\'manage-event\'}} </span><span class=manage-event__right-content__navigation__breadcrum__item translate>> {{\'manage-members\'}} </span><span class=\"manage-event__right-content__navigation__breadcrum__item active\" translate>> {{vm.subContextPage}}</span></div><button type=button class=\"setting-top-navigation__collapse-button navbar-toggle collapsed\" data-toggle=collapse data-target=#manage-communities-navigation aria-expanded=false><div class=setting-top-navigation__context translate>{{vm.subContextPage}}</div><div class=\"setting-top-navigation__mobile-button arrow-animation-menu-collapse\"><span class=\"icon-bar dash-one\"></span> <span class=\"icon-bar dash-two\"></span></div></button><div class=\"setting-top-navigation__list collapse navbar-collapse\" navbar-collapse-on-click=true id=manage-communities-navigation><li class=setting-top-navigation__item ui-sref-active=setting-top-navigation__item--active ui-sref=\"manage-event.members({status: \'attendees\'})\">{{\'attendees\' | translate}}{{\' (\' + (vm.event.stats.going || \'0\') + \')\'}}</li><li class=setting-top-navigation__item ui-sref-active=setting-top-navigation__item--active ui-sref=\"manage-event.members({status: \'invited\'})\">{{\'invited\' | translate}}{{\' (\' + (vm.event.stats.invited || \'0\') + \')\'}}</li><li class=setting-top-navigation__item ui-sref-active=setting-top-navigation__item--active ui-sref=\"manage-event.members({status: \'interested\'})\">{{\'interested\' |translate}}{{\' (\' + (vm.event.stats.interested || \'0\') + \')\'}}</li></div></ul></div><div class=\"manage-event__right-content__navigation reports-navigation\" ng-if=vm.showReportsNav><div class=manage-event__right-content__navigation__breadcrum><span class=manage-event__right-content__navigation__breadcrum__item translate>{{\'manage-community\'}} </span><span class=manage-event__right-content__navigation__breadcrum__item translate>> {{\'reports\'}} </span><span class=\"manage-event__right-content__navigation__breadcrum__item active\" translate>> {{vm.subContextPage}}</span></div><button type=button class=\"setting-top-navigation__collapse-button navbar-toggle collapsed\" data-toggle=collapse data-target=#manage-communities-navigation aria-expanded=false><div class=setting-top-navigation__context translate>{{vm.subContextPage}}</div><div class=\"setting-top-navigation__mobile-button arrow-animation-menu-collapse\"><span class=\"icon-bar dash-one\"></span> <span class=\"icon-bar dash-two\"></span></div></button><ul class=setting-top-navigation ng-class=\"{\'nav-business\': vm.user.isBiz}\"><div class=\"setting-top-navigation__list collapse navbar-collapse\" navbar-collapse-on-click=true id=manage-communities-navigation><li class=setting-top-navigation__item ui-sref-active=setting-top-navigation__item--active ui-sref=\"manage-event.reports({status: \'reported-posts-action-required\'})\">{{\'reported-posts-action-required\' | translate}}{{\' (\' + (vm.event.pending_report_count || \'0\') + \')\'}}</li><!-- <li class=\"setting-top-navigation__item\"\r\n									ui-sref-active=\"setting-top-navigation__item--active\"\r\n									ui-sref=\"manage-event.reports({status: \'past-reported-posts\'})\">\r\n									{{\'past-reported-posts\' | translate}}{{\' (\' + (vm.event.resolved_report_count || \'0\') + \')\'}}</li> --></div></ul></div><div class=manage-event__content ng-if=!vm.loading ui-view></div></div></div></div></div></div>");
$templateCache.put("app/components/manage-photos-status/manage-photos-status.html","<div class=manage-photos-status><div class=manage-photos-status__media><div class=manage-photos-status__wrapper><a ng-if=\"media.type === \'portfolio\'\" class=manage-photos-status__col-left ng-attr-fancyboxable=\"{\'type\': \'image\', \'overlayShow\': true, \'hideOnOverlayClick\': true, keys:{next: null, prev: null}, \'showNavArrows\': false, \'margin\': \'50 10 15 10\', \'centerOnScroll\': true}\" href=\"{{media.thumbnails[\'x400\']}}\" rel=portfolioGallery><img ng-attr-alt={{media.title}} ng-src=\"{{\'assets/images/default/default-cover.png\'}}\" ng-attr-lazy-img-error=\'{{ \"assets/images/default/default-cover.png\"}}\' ng-attr-lazy-img=\"{{media.thumbnails[\'x400\']}}\"> </a><a ng-if=\"media.type != \'portfolio\'\" class=manage-photos-status__col-left ui-sref=\"photo({id: media.id, photoTitle: (media.title + \' by \' + media.user.displayName | toSnakeCase)})\"><img ng-attr-alt={{media.title}} ng-src=\"{{\'assets/images/default/default-cover.png\'}}\" ng-attr-lazy-img-error=\'{{ \"assets/images/default/default-cover.png\"}}\' ng-attr-lazy-img=\"{{media.thumbnails[\'x400\']}}\"></a><div class=manage-photos-status__col-right><div class=manage-photos-status__col-right__wrapper><div class=\"manage-photos-status__title text--bold\">{{media.title}}</div><div class=manage-photos-status__id>{{\'photo-id\' | translate}} #{{media.id}}</div><div class=\"manage-photos-status__status text--bold\" ng-if=\"status && status != \'rejectedMission\'\" ng-class=\"{\'text-danger\': status === \'rejected\', \'text--color-blue\': status === \'review\'}\">{{ status, select, review {{{\'reviewing\' | translate}}} other {{{\'rejected\' | translate}}} }}</div><div class=\"manage-photos-status__status text--bold text-danger\" ng-if=\"status === \'rejectedMission\'\">{{ media.state != \'r\' ? (\'rejected-from-mission-only\' | translate) : (\'rejected-from-mission-and-marketplace\' | translate) }} <span ng-if=\"media.state != \'r\'\" class=manage-photos-status__status__rejected-hint uib-tooltip=\"Rejected mission submissions can still pass the curation into the PIXERF Marketplace. You will find your photo in the Creative Marketplace.\">i</span></div><div ng-if=\"status === \'review\'\" translate translate-values=\"{number: 3}\">{{\'manage-photos-review-process\'}}</div><div class=\"manage-photos-status__current__reason text-danger\" ng-if=media.reject_reason>{{media.reject_reason}}</div><a ng-show=\"type === \'purchase\'\" ui-sref=\"user-home-page.personal.home({id: media.user.id, userName: (media.user.displayName| toSnakeCase)})\" class=text--semibold><span>by {{media.user.displayName}}</span></a> <span class=\"manage-photos-status__photo-type text--bold\" ng-if=\"media.type === \'portfolio\'\">{{\'portfolio\' | translate}}</span></div></div></div><div class=manage-photos-status__current><div ng-if=\"status === \'review\' && media.type != \'portfolio\'\" class=\"manage-photos-status__submit-btn btn btn-submit\" role=button ng-click=vm.onEditPhotoClicked(media)>{{\'edit-photo\' | translate}}</div><div class=\"manage-photos-status__delete-btn btn btn--transparent\" role=button ng-click=vm.onDeleteBtnClicked()><pixerf-delete-media-btn pixerf-delete-media-btn-media=media pixerf-delete-media-btn-btn-label=\"{{label ? label : \'delete-photo\'}}\" pixerf-delete-media-btn-on-media-deleted=\"onMediaDeleted({media: media})\"></pixerf-delete-media-btn></div></div></div></div>");
$templateCache.put("app/components/manage-events/manage-events.html","<div class=manage-events><div class=manage-events__right-content><div class=manage-events__right-content__breadcrum><span class=manage-events__right-content__breadcrum__item>Community</span> <span class=manage-events__right-content__breadcrum__item>></span> <span class=manage-events__right-content__breadcrum__item>Events</span> <span class=manage-events__right-content__breadcrum__item>></span> <span class=\"manage-events__right-content__breadcrum__item actived\" translate>{{vm.subContextPage}}</span></div><div class=manage-events__right-content__navigation><ul class=setting-top-navigation ng-class=\"{\'nav-business\': vm.user.isBiz}\"><button type=button class=\"setting-top-navigation__collapse-button navbar-toggle collapsed\" data-toggle=collapse data-target=#manage-events-navigation aria-expanded=false><div class=setting-top-navigation__context translate>{{vm.subContextPage}}</div><div class=\"setting-top-navigation__mobile-button arrow-animation-menu-collapse\"><span class=\"icon-bar dash-one\"></span> <span class=\"icon-bar dash-two\"></span></div></button><div class=\"setting-top-navigation__list collapse navbar-collapse\" navbar-collapse-on-click=true id=manage-events-navigation><li ng-if=!vm.user.isBiz class=setting-top-navigation__item ui-sref-active=setting-top-navigation__item--active ui-sref=setting.manage-events.manage-going-events>{{\'going\' | translate}} <span ng-if=\"vm.user.stats && vm.user.stats.total_going_events\">({{vm.user.stats.total_going_events}})</span></li><li ng-if=!vm.user.isBiz class=setting-top-navigation__item ui-sref-active=setting-top-navigation__item--active ui-sref=setting.manage-events.manage-invited-events>{{\'invited\' | translate}} <span ng-if=\"vm.user.stats && vm.user.stats.total_invited_events\">({{vm.user.stats.total_invited_events}})</span></li><li ng-if=!vm.user.isBiz class=setting-top-navigation__item ui-sref-active=setting-top-navigation__item--active ui-sref=setting.manage-events.manage-interested-events>{{\'interested\' | translate}} <span ng-if=\"vm.user.stats && vm.user.stats.total_interested_events\">({{vm.user.stats.total_interested_events}})</span></li><li ng-if=vm.user.canManageCommunity class=setting-top-navigation__item ui-sref-active=setting-top-navigation__item--active ui-sref=setting.manage-events.manage-hosting-events>{{\'hosting\' | translate}} <span ng-if=\"vm.user.stats && vm.user.stats.total_upcoming_hosted_events\">({{vm.user.stats.total_upcoming_hosted_events}})</span></li><li ng-if=vm.user.canManageCommunity class=setting-top-navigation__item ui-sref-active=setting-top-navigation__item--active ui-sref=setting.manage-events.manage-draft-events>{{\'drafts\' | translate}} <span ng-if=\"vm.user.stats && vm.user.stats.total_draft_events\">({{vm.user.stats.total_draft_events}})</span></li><li class=setting-top-navigation__item ui-sref-active=setting-top-navigation__item--active ui-sref=setting.manage-events.manage-past-events>{{\'past-events\' | translate}} <span ng-if=\"vm.user.stats && vm.user.stats.total_past_events\">({{vm.user.stats.total_past_events}})</span></li><li ng-if=vm.isAdmin class=setting-top-navigation__item ui-sref-active=setting-top-navigation__item--active ui-sref=setting.manage-events.manage-in-review-events>{{\'in-review\' | translate}} <span ng-if=\"vm.user.stats && vm.user.stats.total_inreview_events\">({{vm.user.stats.total_inreview_events}})</span></li></div></ul></div><div class=manage-event ui-view></div></div></div>");
$templateCache.put("app/components/manage-report-detail-compile-template/manage-report-detail-compile-template.html","<div class=manage-report-detail-compile-template ng-class=\"{\'append-to-body\': appendToBody}\"><div class=manage-report-detail-compile-template__header><div class=manage-report-detail-compile-template__header__info><span class=manage-report-detail-compile-template__header__info__header-text>{{vm.headerText}}</span></div><div class=manage-report-detail-compile-template__header__controls><div class=\"manage-report-detail-compile-template__header__controls__button manage-report-detail-compile-template__header__controls__button__close icon-icons_close\" ng-click=vm.onClosed()></div></div></div><div class=manage-report-detail-compile-template__content><div class=\"manage-report-detail-compile-template__content__reason {{vm.status}}\"><span>This comment was reported for </span>{{vm.report.reason}}</div><div class=manage-report-detail-compile-template__content__type-control><div class=manage-report-detail-compile-template__content__type-control__info><div class=manage-report-detail-compile-template__content__type-control__info__type><span class=manage-report-detail-compile-template__content__type-control__info__label>Report type:</span> <span class=manage-report-detail-compile-template__content__type-control__info__type-content>{{vm.reportType}}</span></div><div class=manage-report-detail-compile-template__content__type-control__info__date><span class=manage-report-detail-compile-template__content__type-control__info__label>Reported date</span> <span class=manage-report-detail-compile-template__content__type-control__info__date-content>{{vm.reportFomatedDate}}</span></div></div><div class=manage-report-detail-compile-template__content__type-control__author><div class=manage-report-detail-compile-template__content__user__label>Reporter:</div><div class=manage-report-detail-compile-template__content__user__info><pixerf-user-avatar class=manage-report-detail-compile-template__content__user__avatar user-data=vm.report.user lazy=true></pixerf-user-avatar><div class=manage-report-detail-compile-template__content__user__name><span class=manage-report-detail-compile-template__content__user__name__display-name>{{vm.report.user.displayName}}</span> <span class=manage-report-detail-compile-template__content__user__name__organization>{{vm.report.user.data.organization.name}}</span></div></div></div><div class=manage-report-detail-compile-template__content__type-control__relevant-community><div class=manage-report-detail-compile-template__content__type-control__relevant-community__label>Relevant Community Page:</div><div class=manage-report-detail-compile-template__content__type-control__relevant-community__content><img ng-src={{vm.report.community.cover.thumbnail}} class=manage-report-detail-compile-template__header__cover><div class=manage-report-detail-compile-template__content__type-control__relevant-community__content__name>{{vm.report.community.name}}</div></div></div></div><div ng-if=\"!vm.hideDiscussion && vm.report.discussion\" class=manage-report-detail-compile-template__content__report><div class=manage-report-detail-compile-template__content__report__author><div class=manage-report-detail-compile-template__content__report__group><pixerf-user-avatar class=manage-report-detail-compile-template__content__report__avatar user-data=vm.report.discussion.user lazy=true></pixerf-user-avatar><div class=manage-report-detail-compile-template__content__report__user><span class=manage-report-detail-compile-template__content__report__user__display-name>{{vm.report.discussion.user.displayName}}</span> <span ng-if=vm.report.discussion.user.organization.name class=manage-report-detail-compile-template__content__report__user__organization>{{vm.report.discussion.user.organization.name}}</span></div></div><div class=manage-report-detail-compile-template__content__report__time>{{vm.getPreciseDiff(vm.report.discussion.inserted_at)}}</div></div><div class=manage-report-detail-compile-template__content__report__community-subject>{{vm.report.discussion.subject}}</div><div class=manage-report-detail-compile-template__content__report__community-desc ng-class=\"{\'reported-item\': vm.reportType == \'post\'}\">{{vm.report.discussion.description}}</div><div class=manage-report-detail-compile-template__content__report-info><div class=manage-report-detail-compile-template__content__report-info__like ng-click=vm.onShowListLike() title=\"Click to see who liked this discussion\"><span class=\"manage-report-detail-compile-template__content__report-info__icon icon-icons_like\"></span> <span class=manage-report-detail-compile-template__content__report-info__value>{{vm.report.discussion.like_count}}</span></div><div class=manage-report-detail-compile-template__content__report-info__reply ng-click=vm.onShowListReply() title=\"Click to see who replied this photo\"><span class=manage-report-detail-compile-template__content__report-info__value>{{vm.report.discussion.reply_count}}</span> <span>{{vm.report.discussion.reply_count === 1 ? (\'reply\' | translate).toLowerCase() : (\'replies\' | translate).toLowerCase()}}</span></div></div><div class=manage-report-detail-compile-template__content__reply-item ng-if=\"vm.reportType == \'comment\'\" ng-repeat=\"reply in vm.replyItems\"><div class=manage-report-detail-compile-template__content__reply-item__author><div class=manage-report-detail-compile-template__content__reply-item__group><pixerf-user-avatar class=manage-report-detail-compile-template__content__reply-item__avatar user-data=reply.user lazy=true></pixerf-user-avatar><div class=manage-report-detail-compile-template__content__reply-item__user><span class=manage-report-detail-compile-template__content__reply-item__user__display-name>{{reply.user.displayName}}</span> <span ng-if=reply.user.organization class=manage-report-detail-compile-template__content__reply-item__user__organization>{{reply.user.organization.name}}</span></div></div><div class=manage-report-detail-compile-template__content__reply-item__time>{{vm.getPreciseDiff(reply.inserted_at)}}</div></div><div class=manage-report-detail-compile-template__content__reply-item__desc ng-class=\"{\'reported-item\': vm.report.id == reply.id}\">{{reply.description}}</div></div></div><div class=manage-report-detail-compile-template__content__report ng-if=vm.hideDiscussion><div class=manage-report-detail-compile-template__content__removed-message>{{\'please-note-you-can-no-longer-view-the-reported\' | translate}}</div></div></div></div>");
$templateCache.put("app/components/manage-right-community-popup/manage-right-community-popup.html","<div class=manage-right-community-popup><div class=\"manage-right-community-popup__close-btn icon-icons_close\" ng-click=vm.close(true)></div><div class=custom-select><select class=manage-right-community-popup__list ng-model=vm.permission><option value=anyone selected=selected>Anyone in the Community<!-- <div>Any member in the community can start a discussion and reply to the threads.</div> --></option><option value=only_admin>Only Admin<!-- <div>Only admins can start a discussion. Members will only be allowed to reply.</div> --></option></select></div></div>");
$templateCache.put("app/components/manage-reports/manage-reports.html","<div class=manage-reports><div class=manage-reports__right-content><div class=manage-reports__right-content__breadcrum><span class=manage-reports__right-content__breadcrum__item>Community</span> <span class=manage-reports__right-content__breadcrum__item>></span> <span class=manage-reports__right-content__breadcrum__item>Reports</span> <span class=manage-reports__right-content__breadcrum__item>></span> <span class=\"manage-reports__right-content__breadcrum__item active\" translate>{{vm.subContextPage}}</span></div><div class=manage-reports__right-content__navigation><ul class=setting-top-navigation ng-class=\"{\'nav-business\': vm.user.isBiz}\"><button type=button class=\"setting-top-navigation__collapse-button navbar-toggle collapsed\" data-toggle=collapse data-target=#manage-reports-navigation aria-expanded=false><div class=setting-top-navigation__context translate>{{vm.subContextPage}}</div><div class=\"setting-top-navigation__mobile-button arrow-animation-menu-collapse\"><span class=\"icon-bar dash-one\"></span> <span class=\"icon-bar dash-two\"></span></div></button><div class=\"setting-top-navigation__list collapse navbar-collapse\" navbar-collapse-on-click=true id=manage-reports-navigation><li ng-if=\"vm.user.canManageCommunity || vm.isAdmin\" class=\"setting-top-navigation__item first-item\" ui-sref-active=setting-top-navigation__item--active ui-sref={{vm.commonConst.STATE.MANAGE_PENDING_REPORTS}}>{{\'pending\' | translate}} <span ng-if=\"vm.user.stats && vm.user.stats.total_pending_reports\">({{vm.user.stats.total_pending_reports}})</span></li><li ng-if=\"vm.user.canManageCommunity || vm.isAdmin\" class=setting-top-navigation__item ui-sref-active=setting-top-navigation__item--active ui-sref={{vm.commonConst.STATE.MANAGE_PAST_REPORTS}}>{{\'past\' | translate}} <span ng-if=\"vm.user.stats && vm.user.stats.total_past_reports\">({{vm.user.stats.total_past_reports}})</span></li></div></ul></div><div class=manage-report ui-view></div></div></div>");
$templateCache.put("app/components/manager-event-member-list-view/manager-event-member-list-view.html","<div class=manager-event-member-list-view ng-click=vm.onMemberClicked(vm.member)><div ng-if=vm.showCheckbox class=\"manager-event-member-list-view__item manager-event-member-list-view__select\"><stick-checkbox on-changed=vm.onToggleSelected(vm.member) model=member model-property=isSelected layout-style=regular-square></stick-checkbox></div><div class=\"manager-event-member-list-view__item manager-event-member-list-view__name\"><pixerf-user-avatar user-data=vm.member class=manager-event-member-list-view__member__cover lazy=true></pixerf-user-avatar><a class=manager-event-member-list-view__member__name ng-click=vm.prevenPubbleClick() ui-sref=\"user-home-page.personal.home({id: vm.member.id, userName: (vm.member.displayName | toSnakeCase)})\" target=_blank uib-tooltip=\"{{vm.member.displayName || vm.member.email}}\">{{vm.member.displayName || vm.member.email}}</a></div><div class=\"manager-event-member-list-view__item manager-event-member-list-view__admin\" ng-if=vm.showAdmin><span class=\"manager-event-member-list-view__item manager-event-member-list-view__item__haft-col\">Admin:</span><div class=\"manager-event-member-list-view__item manager-event-member-list-view__label__wrapper\">{{vm.member.isCommunityManager ? \'Manager\' : \'\'}}</div></div><div class=\"manager-event-member-list-view__item manager-event-member-list-view__creator-type\"><span class=\"manager-event-member-list-view__item manager-event-member-list-view__item__haft-col\">Creator Type:</span> <span>{{vm.accountType}}</span></div><div class=\"manager-event-member-list-view__item manager-event-member-list-view__country\"><span class=\"manager-event-member-list-view__item manager-event-member-list-view__item__haft-col\">Country:</span> <span>{{vm.member.country}}</span></div><div class=\"manager-event-member-list-view__item manager-event-member-list-view__member-of-community\"><span class=\"manager-event-member-list-view__item manager-event-member-list-view__item__haft-col\">Member?</span> <span>{{vm.member.isCommunityMember ? \'Yes\' : \'No\'}}</span></div><div class=\"manager-event-member-list-view__item manager-event-member-list-view__status\" ng-if=vm.showStatus><span class=\"manager-event-member-list-view__item manager-event-member-list-view__item__haft-col\">Status?</span> <span>{{vm.member.inviteStatus}}</span></div><div class=\"manager-event-member-list-view__item manager-event-member-list-view__action\" ng-class=\"{\'full-size\': vm.type ==\'requested\', \'medium\': (vm.type ==\'invited\' || vm.type ==\'blocked\')}\"><div uib-dropdown is-open=vm.isMoreListOpen class=manager-event-member-list-view__action__btn-wrapper><button ng-if=vm.showInviteBtn class=\"manager-event-member-list-view__action__approve-btn btn btn-submit\" ng-click=vm.onInviteMember()><span class=\"manager-event-member-list-view__action__btn-icon icon-icons_check\"></span> <span class=manager-event-member-list-view__action__btn-label>Invite</span></button> <button ng-if=vm.showWithdrawtBtn class=\"manager-event-member-list-view__action__withdraw-btn btn btn--transparent\" ng-click=vm.onWithdrawMember()><span class=\"manager-event-member-list-view__action__btn-icon icon-icons_close\"></span> <span class=manager-event-member-list-view__action__btn-label>Withdraw</span></button> <span ng-if=vm.showMoreListBtn uib-dropdown-toggle class=\"manager-event-member-list-view__action__icon icon-icons_more\" ng-click=vm.prevenPubbleClick()></span><ul class=manager-event-member-list-view__list uib-dropdown-menu role=menu><li role=menuitem class=manager-event-member-list-view__list__item ng-repeat=\"item in vm.moreList\" ng-click=item.cta(vm.member) ng-if=!item.hideItem>{{item.label}}</li></ul></div></div></div>");
$templateCache.put("app/components/manager-member-list-view/manager-member-list-view.html","<div class=manager-member-list-view ng-click=vm.onMemberClicked(vm.member)><div ng-if=vm.showCheckbox class=\"manager-member-list-view__item manager-member-list-view__select\"><stick-checkbox on-changed=vm.onToggleSelected(vm.member) model=member model-property=isSelected layout-style=regular-square></stick-checkbox></div><div class=\"manager-member-list-view__item manager-member-list-view__name\"><pixerf-user-avatar user-data=vm.memberAvatar class=manager-member-list-view__memmber__cover lazy=true></pixerf-user-avatar><a class=manager-member-list-view__memmber__name ng-click=vm.prevenPubbleClick() ui-sref=\"user-home-page.personal.home({id: vm.member.id, userName: (vm.member.displayName | toSnakeCase)})\" target=_blank uib-tooltip=\"{{vm.member.displayName || vm.member.email}}\">{{vm.member.displayName || vm.member.email}}</a></div><div class=\"manager-member-list-view__item manager-member-list-view__admin\" ng-if=vm.showAdmin><span class=\"manager-member-list-view__item manager-member-list-view__item__haft-col\">Admin:</span><div class=\"manager-member-list-view__item manager-member-list-view__label__wrapper\">{{vm.role}}</div></div><div class=\"manager-member-list-view__item manager-member-list-view__creator-type\"><span class=\"manager-member-list-view__item manager-member-list-view__item__haft-col\">Creator Type:</span> <span>{{vm.accountType}}</span></div><div class=\"manager-member-list-view__item manager-member-list-view__country\"><span class=\"manager-member-list-view__item manager-member-list-view__item__haft-col\">Country:</span> <span>{{vm.member.country}}</span></div><div class=\"manager-member-list-view__item manager-member-list-view__specialty\"><span class=\"manager-member-list-view__item manager-member-list-view__item__haft-col\">Specialities:</span> <span class=\"manager-member-list-view__item manager-member-list-view__specialty__text-content\">{{vm.specialities}}</span></div><div class=\"manager-member-list-view__item manager-member-list-view__invitation-from\" ng-if=vm.showInvitationFrom><span class=\"manager-member-list-view__item manager-member-list-view__item__haft-col\">Invitation from:</span><pixerf-user-avatar user-data=vm.inviterAvatar class=manager-member-list-view__memmber__cover lazy=true></pixerf-user-avatar></div><div class=\"manager-member-list-view__item manager-member-list-view__member-since\"><span class=\"manager-member-list-view__item manager-member-list-view__item__haft-col\">{{vm.timeText}}</span> <span>{{vm.joinDate | formatDate: \'MMM DD, YYYY\' }}</span></div><div class=\"manager-member-list-view__item manager-member-list-view__action\" ng-class=\"{\'full-size\': vm.type ==\'requested\', \'medium\': (vm.type ==\'invited\' || vm.type ==\'blocked\')}\"><div uib-dropdown is-open=vm.isMoreListOpen class=manager-member-list-view__action__btn-wrapper><button ng-if=vm.showRejectBtn class=\"manager-member-list-view__action__reject-btn btn btn--transparent\" ng-click=vm.onRejectMember()><span class=\"manager-member-list-view__action__btn-icon icon-icons_close\"></span> <span class=manager-member-list-view__action__btn-label>Reject</span></button> <button ng-if=vm.showApproveBtn class=\"manager-member-list-view__action__approve-btn btn btn-submit\" ng-click=vm.onApproveMember()><span class=\"manager-member-list-view__action__btn-icon icon-icons_check\"></span> <span class=manager-member-list-view__action__btn-label>Approve</span></button> <button ng-if=vm.showWithdrawtBtn class=\"manager-member-list-view__action__withdraw-btn btn btn--transparent\" ng-click=vm.onWithdrawMember()><span class=\"manager-member-list-view__action__btn-icon icon-icons_close\"></span> <span class=manager-member-list-view__action__btn-label>Withdraw</span></button> <button ng-if=vm.showUnblockBtn class=\"manager-member-list-view__action__unblock-btn btn btn--transparent\" ng-click=vm.onUnblockMember()><span class=manager-member-list-view__action__btn-label>Unblock</span></button> <span ng-if=vm.showMoreListBtn uib-dropdown-toggle class=\"manager-member-list-view__action__icon icon-icons_more\" ng-click=vm.prevenPubbleClick()></span><ul class=manager-member-list-view__list uib-dropdown-menu role=menu><li role=menuitem class=manager-member-list-view__list__item ng-repeat=\"item in vm.moreList\" ng-click=item.cta(vm.member) ng-if=!item.hideItem>{{item.label}}</li></ul></div></div></div>");
$templateCache.put("app/components/max-photos-commissions-popup/max-photos-commissions-popup.html","<div class=max-photos-commissions-popup__container><div class=max-photos-commissions-popup__container__text>If you would like to select more than {{vm.data}} photos as part of the final deliverables, please contact us at <span>business@pixerf.com</span></div><div class=\"max-photos-commissions-popup__container__footer clearfix\"><button class=\"max-photos-commissions-popup__container__footer__cancel-btn btn btn-cancel--no-background\" ng-click=vm.closePopup()>Close</button> <button class=\"max-photos-commissions-popup__container__footer__confirm-btn btn btn-submit\" ng-click=vm.requestDownload()>Email</button></div></div>");
$templateCache.put("app/components/media-post-tile/media-post-tile.html","<div class=media-post-tile><div ng-if=!vm.isEditMode class=media-post-tile__col-left><div class=media-post-tile__logo><img ng-src=\"{{vm.post.photo[\'original\']}}\"></div><a ng-href={{vm.post.url}} target=_blank class=media-post-tile__logo-title>{{vm.post.url_text}}</a></div><div ng-if=!vm.isEditMode class=media-post-tile__col-right><div class=media-post-tile__header><a ng-href={{vm.post.url}} target=_blank class=media-post-tile__title ng-bind-html=vm.post.name></a> <a ng-href={{vm.post.url}} target=_blank class=\"media-post-tile__icon icon-link-to\"></a></div><div class=media-post-tile__date>{{vm.post.formattedDate}}</div><div class=media-post-tile__content>{{vm.post.description}}</div></div><form ng-if=vm.isEditMode name=profileForm class=media-post-tile__content__form><div class=media-post-tile__content__col-left><div class=media-post-tile__content__col-left__dropzone><div id=media-post-tile__attach-photos-section pixerf-dropzone dropzone=vm.dropzoneConfig.instance dropzone-config=vm.dropzoneConfig.options event-handlers=vm.dropzoneConfig.eventHandlers><div id=preview ng-class=\"{\'cropped-photo\': vm.dropzoneConfig.instance.files && vm.dropzoneConfig.instance.files.length}\"></div><img ng-if=\"vm.newPost.photo && vm.newPost.photo[\'original\'] && !vm.dropzoneConfig.instance.files.length\" class=media-post-tile__attach__exist-photo ng-src=\"{{vm.newPost.photo[\'original\']}}\"></div></div></div><div class=media-post-tile__content__col-right><div class=media-post-tile__content__col-right__row><div class=media-post-tile__content__form__group><label>Headline</label><input class=form-control maxlength=1000 ng-model=vm.newPost.name></div></div><div class=media-post-tile__content__col-right__row><div class=media-post-tile__content__form__group><label>Date</label><div class=media-post-tile__content__form__date-group><input class=form-control type=text datepicker-options=\"{showWeeks: false}\" show-button-bar=false uib-datepicker-popup=d/MM/yyyy ng-model=vm.newPost.posted_at is-open=vm.filterFromIsVisible><div class=media-post-tile__content__form__date-group__calendar-icon ng-click=\"vm.filterFromIsVisible = !vm.filterFromIsVisible\"><i class=\"glyphicon glyphicon-calendar\"></i></div></div></div></div><div class=media-post-tile__content__col-right__row><div class=media-post-tile__content__form__group><label>Publication name</label><input class=form-control maxlength=1000 ng-model=vm.newPost.url_text></div><div class=media-post-tile__content__form__group><label>URL of full article</label><input class=form-control maxlength=1000 ng-model=vm.newPost.url></div></div><div class=media-post-tile__content__col-right__row><div class=media-post-tile__content__form__group><label>Summary of news article</label><textarea rows=5 ng-model=vm.newPost.description class=form-control></textarea></div></div></div></form><div class=media-post-tile__control><div ng-if=!vm.isEditMode class=\"media-post-tile__control__edit icon-write\" ng-click=vm.onEditPost()></div><div ng-if=!vm.isEditMode class=\"media-post-tile__control__delete icon-icons_close\" ng-click=vm.onDeletePost(vm.post.id)></div><div ng-if=vm.isEditMode class=\"media-post-tile__control__edit icon-icons_check\" ng-click=vm.savePost(vm.post.id)></div><div ng-if=vm.isEditMode class=\"media-post-tile__control__delete icon-icons_close\" ng-click=vm.cancelEdit()></div></div></div>");
$templateCache.put("app/components/mission-awards-row/mission-awards-row.html","<div class=\"mission-awards-row clearfix\"><div class=\"mission-awards-row__row clearfix\"><div class=\"mission-awards-row__row-wrapper clearfix\"><div class=mission-awards-row__col-left ng-click=vm.onPhotoCLick(mission.winner.id)><img ng-attr-alt={{mission.winner.title}} ng-src=\"{{\'assets/images/default/default-cover.png\'}}\" ng-attr-lazy-img-error=\'{{ \"assets/images/default/default-cover.png\"}}\' ng-attr-lazy-img={{mission.winner.urlSmall}}></div><div class=\"mission-awards-row__col-right clearfix\"><div class=mission-awards-row__badge><pixerf-badges badges=mission.winner.badges></pixerf-badges></div><div class=mission-awards-row__info><div class=mission-awards-row__info__title>{{mission.winner.title}}</div><div class=mission-awards-row__info__sponsor>{{mission.mission.title}}</div><div class=mission-awards-row__info__prize><div class=mission-awards-row__info__inkind ng-if=mission.inkind_reward>{{mission.inkind_reward}}</div><div class=mission-awards-row__info__reward ng-if=\"vm.prize > 0\"><span class=mission-awards-row__info__unit>{{mission.currency || \'SGD\'}}</span> <span class=mission-awards-row__info__value>{{vm.prize}}</span></div></div></div><div class=\"mission-awards-row__status clearfix\" ng-class=\"{\'text--color-blue\': !vm.isClaimed}\"><div class=mission-awards-row__status__text>{{!vm.isClaimed ? (\'pending\' | translate) : (\'claimed\' | translate)}}</div><div class=\"mission-awards-row__status__icon icon-icons_check\" ng-if=vm.isClaimed></div></div></div></div></div></div>");
$templateCache.put("app/components/mission-bill/mission-bill.html","<div class=mission-bill><div class=\"mission-bill__mission-total-rewards form-group text-right clearfix\"><span class=\"mission-bill__mission-total-rewards__label text--color-black-6 text--bold\" translate>{{\'total-prizes\'}}</span><div class=\"mission-bill__mission-total-rewards__wrapper clearfix\"><span class=\"mission-bill__mission-total-rewards__number text--color-black-6 text--bold\" ng-bind=vm.mission.prizes_grouped.totalReward|number:0></span> <span class=mission-bill__currency-unit-label>SGD</span></div></div><div class=\"mission-bill__mission-service-fee form-group text-right clearfix\"><span class=\"mission-bill__mission-service-fee__label text--color-black-6 text--bold\" translate>{{\'mission-service-fee\'}}</span><div class=\"mission-bill__mission-service-fee__wrapper clearfix\"><span ng-if=vm.mission.price.service_fee class=\"mission-bill__mission-service-fee__number text--color-black-6 text--bold\" ng-bind=\"vm.mission.price.service_fee | number:0\"></span><div class=\"mission-bill__mission-service-fee__number--tba text--color-black-6\" ng-if=!vm.mission.price.service_fee>To be advised after review</div><span ng-if=vm.mission.price.service_fee class=mission-bill__currency-unit-label>SGD</span></div></div><div class=\"mission-bill__mission-discounts form-group text-right clearfix text--color-blue\" ng-if=\"vm.mission.price.service_fee && !vm.showAwardOnly\"><div ng-repeat=\"discount in vm.mission.price.discounts\"><span class=\"mission-bill__mission-discounts__label text--bold\">{{discount.name}}</span><div class=\"mission-bill__mission-discounts__wrapper clearfix\"><span class=\"mission-bill__mission-discounts__number text--bold\" ng-bind=\"discount.amount | number:0\"></span> <span class=mission-bill__currency-unit-label ng-if=vm.mission.price.service_fee>- SGD</span></div></div></div><div class=\"mission-bill__mission-total-amount form-group text-right clearfix\"><span class=\"mission-bill__mission-total-amount__label text--color-black-6 text--bold\">{{vm.showAwardOnly ? (\'total-amount\' | translate) : (\'grand-total\' | translate)}}</span><div class=\"mission-bill__mission-total-amount__wrapper clearfix\"><span class=\"mission-bill__mission-total-amount__number text--color-black-6 text--bold\" ng-bind=\"vm.mission.bill.totalToPay | number:0\"></span> <span class=mission-bill__currency-unit-label>SGD</span></div></div></div>");
$templateCache.put("app/components/mission-draft-item/mission-draft-item.html","<div class=\"mission-draft-item clearfix\"><div class=\"mission-draft-item__details-info clearfix\"><div class=mission-draft-item__details-info__photo ng-style=\"{\'background-image\': \'url(\' + mission.thumbnailPath + \')\'}\"></div><div class=mission-draft-item__details-info__description><div class=\"mission-draft-item__details-info__mission-id text--bold\">ID #{{mission.id}}</div><div class=\"mission-draft-item__details-info__mission-name text--bold\">{{mission.title}}</div><div class=mission-draft-item__details-info__date-updated ng-bind=\"mission.start_date ? \'Edited on \' + mission.start_date : \'\'\"></div></div></div><div class=mission-draft-item__status-label><div class=\"mission-status-label label-draft\">Draft</div></div><div class=mission-draft-item__action><div class=mission-draft-item__darft-action><a ui-sref=\"setting.manage-missions.create-mission.review({id: mission.id})\"><button class=\"mission-draft-item__edit-button mission-btn\">Edit</button></a> <button class=\"mission-draft-item__delete-button mission-btn\" ng-disabled=vm.isWorking ng-click=vm.onMissionDeleted(mission.id)>Delete</button></div></div></div>");
$templateCache.put("app/components/mission-gallery/mission-gallery.html","<a class=mission-gallery role=button ui-sref=\"mission-detail-page.brief({id: mission.id,name: (mission.title | toSnakeCase)})\"><div class=mission-gallery__background ng-class=\"{\'full-height\': hideFooter, \'show-badge\': showBadge}\" ng-mouseover=\"vm.mouseInMission = true\" ng-mouseleave=\"vm.mouseInMission = false\"><div ng-if=vm.mouseInMission><bg-changer background-changer use-sequence=true photos=mission.top_submissions no-watermark=true timer=1000 hide-author=true></bg-changer></div><div ng-hide=\"mission.top_submissions.length > 0 && vm.mouseInMission\" class=\"mission-gallery__background-cover absolute absolute--full\" ng-style=\"{\'background-image\': \'url(\' + mission.thumbnailPath + \')\'}\"></div><div class=overlay></div><div class=mission-gallery-hover></div><div class=mission-badge ng-if=showBadge><div class=\"mission-badge__icon icon-icons-badge-M\"></div><div class=mission-badge__title>{{mission.title}}</div></div><div class=mission-gallery__description-wrapper><div class=\"mission-gallery__details clearfix\"><div class=mission-gallery__details__time-remaining><pixerf-count-down deadline=mission.end_date></pixerf-count-down></div></div><div class=\"mission-gallery__title text--extrabold\">{{mission.title}}</div><div class=\"mission-gallery__reward text--bold\" ng-class=\"{\'reward-one-line\': mission.winners === 1}\" ng-if=\"mission.total_rewards && !mission.is_goJek\"><div class=mission-gallery__reward-unit>{{\'win-up-to\' | translate}} <span ng-bind=\"mission.currency ? mission.currency : \'SGD\'\"></span> <span class=mission-gallery__reward-money>{{mission.total_rewards | number}}</span></div></div><div class=\"mission-gallery__reward text--bold\" ng-if=mission.is_goJek><div class=mission-gallery__reward-unit>{{mission.winners === 1 ? mission.winners + \' winner\' : mission.winners + \' winners\'}}</div><div class=mission-gallery__reward-unit>{{\'win-up-to\' | translate}} {{mission.currency}} {{mission.total_rewards | number}}</div></div><div ng-if=\"!mission.total_rewards && mission.inkind_reward && !mission.is_goJek\" class=mission-gallery__reward><div class=\"mission-gallery__reward-unit text--bold\"><span class=\"mission-gallery__reward-money text--bold inkind\">{{mission.inkind_reward}}</span></div></div></div></div><div class=\"mission-gallery__footer clearfix\" ng-if=!hideFooter><div class=\"mission-gallery__footer__logo-wrapper pull-left\"><img ng-src=\"{{mission.sponsor ? mission.sponsor.logoUrlList : mission.organization.profileImageListUrl}}\" alt=\"\" class=mission-gallery__footer__logo></div><div class=\"mission-gallery__footer__brand clearfix\"><div class=mission-gallery__footer__label translate>{{\'community-challenge-by\'}}</div><div class=\"mission-gallery__footer__name text--truncate text--bold text--color-black\">{{mission.sponsor ? mission.sponsor.name : mission.organization.name}}</div></div></div></a>");
$templateCache.put("app/components/mission-grid/mission-grid.html","<div class=mission-grid><div class=clearfix ng-if=\"vm.missions.length >0\"><div ng-repeat=\"mission in vm.missions\" class=\"clearfix mission-grid__mission-wrapper\"><mission-gallery mission=mission></mission-gallery></div></div><ng-transclude ng-if=\"vm.missions.length === 0\" class=mission-grid__no-mission></ng-transclude><scroll-paging spinner=vm.spinner show-message=\"vm.missions.length > 0 && vm.searchParams.page > 1\" is-last-page=vm.isLastPage message=\"No more missions.\"></scroll-paging></div>");
$templateCache.put("app/components/mission-inspiration-photo/mission-inspiration-photo-more-popover.html","<div class=mission-inspiration-photo-more-popover><div class=mission-inspiration-photo-more-popover__item-wrapper><div class=mission-inspiration-photo-more-popover__item ng-click=vm.onSetMissionCoverClicked(media)>Set as Mission Cover</div></div></div>");
$templateCache.put("app/components/mission-inspiration-photo/mission-inspiration-photo.html","<div class=mission-inspiration-photo__link rel=visual-inspiration__slider-wrapper__item><div class=\"relative mission-inspiration-photo\"><img ng-src=\"{{media.thumbnails[\'x400\']}}\" ng-class=\"{\'last-visual-inspiration-photo\': $parent.$last}\"><div ng-click=\"$event.preventDefault(); vm.clickOutSide($event);\"><div popover-popup-delay=250 ng-if=vm.loginnedUser.canManageMission uib-popover-template=\"\'app/components/mission-inspiration-photo/mission-inspiration-photo-more-popover.html\'\" popover-placement=bottom popover-trigger=\"\'outsideClick\'\" class=mission-inspiration-photo__more-btn title=\"More actions\"><span class=icon-icons_more></span></div></div></div><!-- <fancybox open=\"vm.isOpen\" box-for=\"[rel=visual-inspiration__slider-wrapper__item]\" options=\"{\'type\': \'image\', \'overlayShow\': true, \'hideOnOverlayClick\': true}\" /> --></div>");
$templateCache.put("app/components/mission-inspiration-photos/mission-inspiration-photos.html","<div class=\"mission-inspiration-photos form-group col-sm-12 no-padding\"><!-- <label class=\"text--bold\">Add Visual Inspiration<span tooltip-append-to-body=\"true\" class=\"icon-icons-info mission-inspiration-photos__icon-tooltips\" tooltip-class=\"manage-mission-tooltip\" uib-tooltip=\"Help photographers understand your art direction better with visuals that show what you’re looking for. IMPORTANT: Only upload photos that you have the rights to use.\"></span></label> --><div class=mission-inspiration-photos__main-contain__media-wrapper><div class=mission-inspiration-photos__main-contain__media-item ng-repeat=\"media in mission.media\"><div class=mission-inspiration-photos__main-contain__media-item__media-exist><img ng-src={{media.thumbnail}} alt={{media.title}}><div class=\"absolute absolute--full upload-photo-preview__upload-photo-process text-center\" ng-show=\"media.upload.progress < 100 && !media.pixerfError\"><span class=\"absolute text--color-white upload-photo-preview__upload-photo-process__uploading-text absolute--bottom-half text--bold\">{{\'uploading\' | translate}}...{{media.upload.progress}}%</span> <span class=overlay></span></div></div><div class=\"mission-inspiration-photos__main-contain__media-item__footer clearfix\"><div class=\"mission-inspiration-photos__main-contain__media-item__set-cover-checkbox pull-left\" ng-click=\"vm.onSetCoverCheckboxClicked(media); $event.stopPropagation()\"><div title=\"Click to set as mission cover\" class=\"pixerf-checkbox pixerf-checkbox--fake\" ng-class=\"{\'pixerf-checkbox--fake--checked\': media.isSelected}\"></div><span ng-class=\"{\'text--color-pixerf-theme text--semi-bold\': media.isSelected}\" class=pixerf-link--color-theme translate>{{\'set-as-cover\'}}</span></div><div class=\"mission-inspiration-photos__main-contain__media-item__media-remove-btn text--bold pull-left\" role=button ng-click=vm.onRemoveImageBtnClicked(media)><span>{{\'remove\' | translate}}</span></div></div></div></div><div class=clearfix><div pixerf-dropzone dropzone=vm.dropzoneConfig.instance dropzone-config=vm.dropzoneConfig.options event-handlers=vm.dropzoneConfig.eventHandlers><!-- DROPZONE AREA --><div class=\"col-md-12 dropzone-main-content-wrapper no-padding\"><div class=\"dropzone dz-clickable dz-message dropzone-main-content__box\"><div class=ng-hide id=mission-inspiration-photos-previews></div><div class=\"dropzone-info text-center\"><p class=\"text--color-black-2 dropzone-info__drag-a-drop\" translate>{{\'drag-and-drop-photos\'}}</p><p class=\"text--color-black-2 dropzone-info__or\">- {{\'or\' | translate}} -</p><button class=\"dropzone-info__selet-btn btn btn--black text--bold\" translate>{{\'browse\'}}</button></div></div></div></div></div><div class=mission-inspiration-photos__main-contain__require-note translate translate-values=\"{object: (\'photos\' | translate).toLowerCase(), number_1: 3, number_2: mission.inspiration_limit, min_resolution: 0.5, max_resolution: 4}\">{{\'missions-form-10\'}}</div></div>");
$templateCache.put("app/components/mission-launch-successfully-popup/mission-launch-successfully-popup.html","<div class=mission-launch-successfully-popup><div class=clearfix><div class=\"modal-body text--color-black-2\"><h1 class=\"mission-launch-successfully-popup__header text--semibold text--color-black\">{{vm.message.header}}</h1><div class=mission-launch-successfully-popup__content ng-bind-html=vm.message.content></div></div><br><div class=modal-footer><button ng-click=vm.close() class=\"btn btn-submit pixerf-btn-sm\">View</button></div></div></div>");
$templateCache.put("app/components/mission-move-state-btn/mission-move-state-btn.html","<div class=\"mission-move-state-btn clearfix\"><button ng-if=\"vm.mission.process_state === \'draft\' || vm.mission.process_state === \'rejected\' || !vm.mission.process_state\" class=\"btn btn--transparent\" ng-click=vm.onSaveDraftBtnClicked(missionForm) ng-disabled=vm.isWorking>{{vm.isWorking ? \'Saving...\' : (\'save-as-draft\' | translate)}}</button><div class=\"mission-move-state-btn__agreement-checkbox clearfix\" ng-if=\"vm.mission.process_state === \'draft\' || vm.mission.process_state === \'to_revise\' || vm.mission.process_state === \'rejected\' || !vm.mission.process_state\"><stick-checkbox model=vm model-property=isAgreedMnT label=submit-mission-sponsor-agreement layout-style=solid-square custom-class=mission-agreement-checkbox></stick-checkbox></div><button ng-if=\"vm.mission.process_state === \'draft\' || vm.mission.process_state === \'rejected\' || vm.mission.process_state === \'to_revise\' || !vm.mission.process_state\" class=\"btn btn-submit create-mission-step-review__overview__solid-theme-btn\" ng-click=vm.onSubmitBtnClicked() ng-disabled=\"vm.isWorking || !vm.isAgreedMnT\">{{vm.isWorking ? \'Submitting...\' : \'Confirm & Submit\'}}</button> <button ng-if=\"vm.mission.process_state === \'draft\' || vm.mission.process_state === \'rejected\' || vm.mission.process_state === \'to_revise\' || !vm.mission.process_state\" class=\"btn btn-submit--no-background\" ng-click=vm.onPreviewClicked(vm.mission)>{{\'preview\' | translate}}</button> <button ng-if=\"vm.mission.process_state === \'pending_approval\' && vm.loginUser.canReviewMission\" class=\"btn btn-submit\" ng-click=vm.onApproveMissionClicked() ng-disabled=vm.isWorking>{{\'approve\' | translate}}</button> <button ng-if=\"vm.mission.process_state === \'pending_approval\' && vm.loginUser.canReviewMission\" class=\"btn create-mission-step-five__overview__blank-btn btn-submit--no-background\" ng-click=vm.onToReviseMissionClicked() ng-disabled=vm.isWorking>{{\'to-revise\' | translate}}</button> <button ng-if=\"vm.mission.process_state === \'pending_approval\' && vm.loginUser.canReviewMission\" class=\"btn create-mission-step-five__overview__blank-btn btn-cancel text--color-black\" ng-click=vm.onRejectMissionClicked() ng-disabled=vm.isWorking>{{\'reject\' | translate}}</button> <button ng-if=\"vm.mission.process_state === \'pending_payment\' && !vm.loginUser.canReviewMission\" class=\"btn btn-submit create-mission-step-five__overview__solid-theme-btn\" ng-click=vm.onPayClicked() ng-disabled=vm.isWorking>{{\'pay-with-credits\' | translate}}</button> <button ng-if=\"vm.mission.process_state === \'ready_to_launch\'\" class=\"btn btn-submit\" ng-click=vm.onLaunchMissionBtnClicked() ng-disabled=vm.isWorking>{{\'launch-mission-now\' | translate}}</button></div>");
$templateCache.put("app/components/mission-review/mission-review.html","<section class=mission-review><div class=\"create-mission__form-wrapper clearfix\"><div class=\"create-mission-step-review__overview clearfix\"><div class=\"create-mission-step-review__overview__col-left clearfix\"><h3 class=\"text-left create-mission-step-review__header text--color-black text--bold\">Summary</h3><mission-review-section-title mission=vm.mission is-editable=vm.isEditable></mission-review-section-title><mission-review-section-detail mission=vm.mission is-editable=vm.isEditable></mission-review-section-detail><mission-review-section-brief mission=vm.mission is-editable=vm.isEditable></mission-review-section-brief><mission-review-section-art-direction mission=vm.mission is-editable=vm.isEditable></mission-review-section-art-direction><mission-review-section-sponsor mission=vm.mission is-editable=vm.isEditable></mission-review-section-sponsor></div><div class=\"create-mission-step-review__overview__col-right clearfix\"><shopping-cart-my-credit-balance-review total-to-pay=vm.mission.bill.totalToPay add-credit-btn=true></shopping-cart-my-credit-balance-review><mission-review-section-reward mission=vm.mission is-editable=vm.isEditable></mission-review-section-reward><div class=devider></div><div class=\"mission-review__overview__col-right__fee clearfix\"><mission-bill mission=vm.mission></mission-bill></div><mission-move-state-btn mission=vm.mission on-pay=\"vm.onPay({detail: detail})\"></mission-move-state-btn><div class=mission-review__overview__col-right__tnc-text ng-if=\"vm.mission.process_state === \'draft\' || vm.mission.process_state === \'rejected\' || !vm.mission.process_state\"><div class=mission-review__overview__col-right__tnc-text__noticed>You won’t be charged yet.</div><div>You will be notified within 3–5 working days if your Mission brief is approved or more information is required.</div></div></div></div></div></section>");
$templateCache.put("app/components/mission-reward/mission-reward.html","<section class=mission-reward><form name=vm.rewardForm class=create-mission__form-wrapper ng-class=\"{\'pixerf-form-dirty\': vm.rewardForm.$dirty}\"><div class=clearfix><div><pixerf-combobox on-changed=vm.onMissionPriceChanged(selectedItem) on-init=vm.onComboboxInit(instance) options=vm.mission.prices model=vm.mission.price is-editing=true settings=\'{\"propName\": \"name\", \"id\": field.id}\'></pixerf-combobox><div><div class=mission-reward__custom-duration ng-if=\"vm.mission.price.id == -1\"><label class=\"text--bold text--bold text--color-black-6\">Set your Mission Duration</label><input placeholder=0 required name=duration class=\"form-control mission-reward__duration\" ng-model=vm.mission.price.duration input-number-only input-number-only-max-digits=2 validation-min-max validation-min-max-min=\"vm.prizeRuleSet[vm.mission.price.name][\'duration\'].min\" validation-min-max-max=\"vm.prizeRuleSet[vm.mission.price.name][\'duration\'].max\"> <span>days</span><span>(Select up to 60 days)</span><div ng-show=\"vm.rewardForm.$dirty && (vm.rewardForm.duration.$error.validationMinMaxMin || vm.rewardForm.duration.$error.validationMinMaxMax)\" class=pixerf-invalid>Please enter a figure between {{vm.prizeRuleSet[vm.mission.price.name][\'duration\'].min}} and {{vm.prizeRuleSet[vm.mission.price.name][\'duration\'].max}}</div></div><div class=\"mission-reward__prize-item clearfix\"><div class=clearfix><div class=\"mission-reward__prize-item__no-winners form-group\"><label class=\"mission-reward__field-label text--bold text--color-black-6\">No. of Mission Winners</label><label class=mission-reward__field-label-rule>(Max. {{vm.prizeRuleSet[vm.mission.price.name][\'WINNER\'].quantity.max}})</label><div class=\"mission-reward__math-group clearfix\"><input-with-number-control on-changed=vm.onRewardChanged() model=\"vm.mission.prizes_grouped[\'WINNER\']\" options=\"{max: vm.prizeRuleSet[vm.mission.price.name][\'WINNER\'].quantity.max, min: vm.prizeRuleSet[vm.mission.price.name][\'WINNER\'].quantity.min, inputName: \'noWinner\', maxDigits: 3}\"></input-with-number-control></div><div ng-show=\"vm.rewardForm.$dirty && (vm.rewardForm.noWinner.$error.validationMinMaxMin || vm.rewardForm.noWinner.$error.validationMinMaxMax)\" class=pixerf-invalid>Please enter a figure between {{vm.prizeRuleSet[vm.mission.price.name][\'WINNER\'].quantity.min}} and {{vm.prizeRuleSet[vm.mission.price.name][\'WINNER\'].quantity.max}}</div></div><div class=\"mission-reward__prize-item__prize-amount form-group\"><label class=\"mission-reward__field-label text--bold text--color-black-6\">Winning Prize (each)</label><label class=mission-reward__field-label-rule>(Max. SGD {{vm.prizeRuleSet[vm.mission.price.name][\'WINNER\'].value.max | number}})</label><div class=input-group><div class=\"input-group-addon text--color-black-6 text--semibold\">SGD</div><div class=\"mission-reward__math-group clearfix\"><input input-number-only-max-digits=5 required input-number-only validation-min-max validation-min-max-min=\"vm.prizeRuleSet[vm.mission.price.name][\'WINNER\'].value.min\" validation-min-max-max=\"vm.prizeRuleSet[vm.mission.price.name][\'WINNER\'].value.max\" class=\"form-control mission-reward__prize-item__prize-amount__input\" placeholder=0 ng-model=\"vm.mission.prizes_grouped[\'WINNER\'].value\" ng-change=vm.onRewardChanged() name=winnerPrizeValue></div></div><div ng-show=\"vm.rewardForm.$dirty && (vm.rewardForm.winnerPrizeValue.$error.validationMinMaxMin || vm.rewardForm.winnerPrizeValue.$error.validationMinMaxMax)\" class=pixerf-invalid>Please enter a figure between {{vm.prizeRuleSet[vm.mission.price.name][\'WINNER\'].value.min}} and {{vm.prizeRuleSet[vm.mission.price.name][\'WINNER\'].value.max | number}}</div></div></div></div><div class=\"mission-reward__prize-item clearfix\"><div class=clearfix><div class=\"mission-reward__prize-item__no-winners form-group\"><label class=\"mission-reward__field-label text--bold text--color-black-6\">No. of Special Mentions</label><label class=mission-reward__field-label-rule>(Max. {{vm.prizeRuleSet[vm.mission.price.name][\'CONSOLATION\'].quantity.max}})</label><div class=\"mission-reward__math-group clearfix\"><input-with-number-control on-changed=vm.onRewardChanged() model=\"vm.mission.prizes_grouped[\'CONSOLATION\']\" options=\"{max: vm.prizeRuleSet[vm.mission.price.name][\'CONSOLATION\'].quantity.max, min: vm.prizeRuleSet[vm.mission.price.name][\'CONSOLATION\'].quantity.min, inputName: \'noSpecialMention\', maxDigits: 3}\"></input-with-number-control></div><div ng-show=\"vm.rewardForm.$dirty && (vm.rewardForm.noSpecialMention.$error.validationMinMaxMin || vm.rewardForm.noSpecialMention.$error.validationMinMaxMax)\" class=pixerf-invalid>Please enter a figure between {{vm.prizeRuleSet[vm.mission.price.name][\'CONSOLATION\'].quantity.min}} and {{vm.prizeRuleSet[vm.mission.price.name][\'CONSOLATION\'].quantity.max}}</div></div><div class=\"mission-reward__prize-item__prize-amount form-group\"><label class=\"mission-reward__field-label text--bold text--color-black-6\">Special Mention Prize (each)</label><label class=mission-reward__field-label-rule>(Max. SGD {{vm.prizeRuleSet[vm.mission.price.name][\'CONSOLATION\'].value.max}})</label><div class=input-group><div class=\"input-group-addon text--color-black-6 text--semibold\">SGD</div><div class=\"mission-reward__math-group clearfix\"><input readonly=readonly class=\"form-control mission-reward__prize-item__prize-amount__input\" placeholder=0 ng-model=\"vm.mission.prizes_grouped[\'CONSOLATION\'].value\" ng-change=vm.onRewardChanged()></div></div></div></div></div></div></div></div></form></section>");
$templateCache.put("app/components/mission-sponsor-logo/mission-sponsor-logo.html","<div class=\"clearfix mission-sponsor-logo\"><button ng-click=vm.onUploadBtnClicked() ng-disabled=vm.isWorking ng-click=$event.stopPropagation() class=\"btn--black-magento mission-sponsor-logo__upload-btn btn\">{{vm.isWorking ? \"Uploading...\" : \"Upload\"}}</button><div class=\"dz-preview dz-file-preview ng-hide dropzone-preview\"></div></div>");
$templateCache.put("app/components/mission-status-item/mission-status-item.html","<div class=\"mission-status-item clearfix\"><a ui-sref=\"{{vm.linkToAction ? vm.linkToAction : \'.\'}}\"><div class=\"mission-status-item__details-info clearfix\"><div class=mission-status-item__details-info__photo-wrapper><div class=mission-status-item__details-info__photo ng-style=\"{\'background-image\': \'url(\' + mission.thumbnailPath + \')\'}\"></div></div><div class=mission-status-item__details-info__description><div class=\"mission-status-item__details-info__mission-id text--bold\">Mission ID #{{mission.id}}</div><div class=\"mission-status-item__details-info__mission-name text--bold text--color-black text--truncate\">{{mission.title}}</div><div class=mission-status-item__details-info__date-updated ng-bind=\"mission.created_at ? \'Created on \' + mission.created_at : \'\'\"></div></div><div class=mission-status-item__details-info__owner ng-if=vm.user.canReviewMission>{{mission.organization.name}}</div></div></a><div class=mission-status-item__status-label ng-if=vm.statusLabel><div class=\"mission-status-label text-center\" ng-class=\"{\'label-draft\': vm.isDraft, \'label-reviewing\': vm.isPendingApproval, \'label-approved\': vm.isPendingPayment, \'label-ready\': vm.isReadyToLaunch, \'label-revise\': vm.isActionRequired || vm.isRejected}\">{{vm.statusLabel}}</div></div><div class=mission-status-item__action><div class=mission-draft-item__darft-action ng-if=vm.isDraft><a ui-sref=\"{{vm.linkToAction ? vm.linkToAction : \'.\'}}\"><button class=\"btn btn-submit--no-background mission-btn\">Edit</button> </a><button class=\"btn btn-cancel--no-background mission-btn\" ng-disabled=vm.isWorking ng-click=vm.onMissionDeleted(mission.id)>Delete</button></div><div class=mission-status-item__launch-action ng-if=!vm.isDraft><div class=mission-status-item__action-description ng-class=\"{\'text--color-pixerf-theme\': vm.isActionRequired}\" ng-bind-html=vm.descriptionText></div><a ui-sref=\"{{vm.linkToAction ? vm.linkToAction : \'.\'}}\"><button ng-if=vm.actionButtonText class=\"btn mission-btn text--bold\" ng-class=\"{\'btn-cancel--no-background\': vm.isActionRequired, \'btn-submit\': vm.isPendingPayment || vm.isReadyToLaunch}\">{{vm.actionButtonText}}</button></a></div></div></div>");
$templateCache.put("app/components/mission-status-list/mission-status-list.html","<div class=mission-status-list><div ng-repeat=\"mission in missions\" class=mission-status-list__item><div class=\"mission-status-list__group-by text--bold text--color-black\" ng-show=mission.group_by_key>Created on {{mission.start_date}}</div><mission-status-item mission=mission></mission-status-item></div></div>");
$templateCache.put("app/components/mobile-main-menu/mobile-main-menu.html","<div class=\"navbar-collapse pixerf-navbar-text mobile-navigation\" id=mobile-pixerf-main-navbar><div class=mobile-navigation__header><div class=mobile-navigation__header__left><a class=mobile-navigation__header__logo__wrapper ng-click=vm.onLogoClicked()><div class=pixerf-logo></div></a></div><div ng-if=!vm.user class=mobile-navigation__header__right><div class=mobile-navigation__header__right__signup-btn ng-click=vm.onSignUpBtnClicked()>Sign up</div><div class=mobile-navigation__header__right__signin-btn ng-click=vm.onSignInBtnClicked()>Sign in</div></div></div><ul class=mobile-navigation__list><li ui-sref-active-class=actived ui-sref-active-if=marketplace class=mobile-navigation__list__wrapper ng-click=vm.onCloseBtnClicked()><a ui-sref=book-a-shoot-page.about-custom-content class=mobile-navigation__title>Book a Shoot</a></li><li ui-sref-active-class=actived ui-sref-active-if=marketplace class=mobile-navigation__list__wrapper ng-click=vm.onCloseBtnClicked()><a ui-sref=run-a-challenge-page.about-challenge class=mobile-navigation__title>Run a Challenge</a></li><li ui-sref-active-class=actived ui-sref-active-if=marketplace class=mobile-navigation__list__wrapper ng-click=vm.onCloseBtnClicked()><a ui-sref=buy-stock-page.about-stock class=mobile-navigation__title>Buy Stock</a></li><li uib-dropdown class=mobile-navigation__sub-menu is-open=vm.isBusinessOpen><div uib-dropdown-toggle class=mobile-navigation__sub-menu__item-wrapper><span class=mobile-navigation__sub-menu__title>For Business</span> <span class=arrow-direct-with-menu ng-class=\"vm.isBusinessOpen ? \'icon-icons_chevron-up\' : \'icon-icons_chevron-down\'\"></span></div><ul class=\"dropdown-menu mobile-navigation__sub-menu__sub-list\" uib-dropdown-menu role=menu aria-labelledby=single-button><li ui-sref-active-class=actived ng-repeat=\"item in vm.businessNav\" ui-sref-active-if={{item.route}} class=mobile-navigation__sub-menu__item ng-click=vm.onCloseBtnClicked()><a href={{item.href}}>{{item.name}}</a></li></ul></li><li uib-dropdown class=mobile-navigation__sub-menu is-open=vm.isNewsOpen><div uib-dropdown-toggle class=mobile-navigation__sub-menu__item-wrapper><span class=mobile-navigation__sub-menu__title>News</span> <span class=arrow-direct-with-menu ng-class=\"vm.isNewsOpen ? \'icon-icons_chevron-up\' : \'icon-icons_chevron-down\'\"></span></div><ul class=\"dropdown-menu mobile-navigation__sub-menu__sub-list\" uib-dropdown-menu role=menu aria-labelledby=single-button><li ui-sref-active-class=actived ng-repeat=\"item in vm.newsNav\" ui-sref-active-if={{item.route}} class=mobile-navigation__sub-menu__item ng-click=vm.onCloseBtnClicked()><a ng-if=item.route ui-sref={{item.route}} href=#>{{item.name}}</a> <a ng-if=!item.route href={{item.href}} target=_blank>{{item.name}}</a></li></ul></li><li uib-dropdown class=mobile-navigation__sub-menu is-open=vm.isCreatorsOpen><div uib-dropdown-toggle class=mobile-navigation__sub-menu__item-wrapper><span class=mobile-navigation__sub-menu__title>For Creators</span> <span class=arrow-direct-with-menu ng-class=\"vm.isCreatorsOpen ? \'icon-icons_chevron-up\' : \'icon-icons_chevron-down\'\"></span></div><ul class=\"dropdown-menu mobile-navigation__sub-menu__sub-list\" uib-dropdown-menu role=menu aria-labelledby=single-button><li ui-sref-active-class=actived ng-repeat=\"item in vm.creatorsNav\" ui-sref-active-if={{item.route}} class=mobile-navigation__sub-menu__item ng-click=vm.onCloseBtnClicked()><a href={{item.href}}>{{item.name}}</a></li></ul></li></ul></div>");
$templateCache.put("app/components/mutiline-dropdown/mutiline-dropdown.html","<div class=mutiline-dropdown><button type=button class=mutiline-dropdown__input data-toggle=dropdown><div ng-if=!isMultiChoice class=mutiline-dropdown__input-wrapper><div class=mutiline-dropdown__input__title translate>{{vm.selectedItem.title}}</div><div class=mutiline-dropdown__input__description translate>{{vm.selectedItem.description}}</div><span class=\"mutiline-dropdown__input__icon icon-icons_chevron-down\"></span></div><div ng-if=isMultiChoice class=mutiline-dropdown__multi-choice-wrapper><div class=mutiline-dropdown__input__title ng-repeat=\"item in vm.selectedItem\"><span>{{item.title}}</span> <span ng-bind=\"($index < (vm.selectedItem.length - 1)) ? \',\' : \'\'\"></span></div><span class=\"mutiline-dropdown__input__icon icon-icons_chevron-down\"></span></div></button><ul class=\"mutiline-dropdown__list dropdown-menu\"><li class=mutiline-dropdown__item ng-class=\"{\'selected\': item.isSelected}\" ng-repeat=\"item in items\" id={{item.value}} ng-click=vm.onSelectedItem(item)><div ng-if=!hideCheckIcon class=\"mutiline-dropdown__item__icon icon-icons_check\"></div><div class=mutiline-dropdown__item__info><div class=mutiline-dropdown__item__title translate>{{item.title}}</div><div class=mutiline-dropdown__item__description translate>{{item.description}}</div></div></li></ul></div>");
$templateCache.put("app/components/my-credit/my-credit.html","<div class=my-credit-page ng-if=!vm.guestUser><div class=my-credit-page__title translate>{{\'my-credits\'}}</div><div class=my-credit-page__intro translate translate-compile>{{\'credits-page-01\'}}</div><div class=my-credit-page__content-section><div class=my-credit-page__total-credit><div class=my-credit-page__total-credit__description><div class=my-credit-page__total-credit__label-left><div class=my-credit-page__label translate>{{\'available-credit-balance\'}}</div><div class=my-credit-page__time>{{\'as-of\' | translate}} {{vm.today}}</div></div><div class=my-credit-page__credit><span class=my-credit-page__credit__currency>SGD</span> {{vm.credit | number:2}}</div></div><div class=my-credit-page__description translate>{{\'credits-page-02\'}}</div></div><div class=buy-credit><div class=buy-credit__descripption-text translate>{{\'credits-page-03\'}}</div><div class=buy-credit__control-wrapper><a ui-sref=\"about-business-page.pricing({section: \'creditPlansSection\'})\" class=\"buy-credit__btn btn btn-submit\" translate>{{\'view-our-credit-plans\'}}</a> <a ui-sref=buy-stock-page.trending class=\"buy-credit__btn btn btn-cancel--no-background\" translate>{{\'browse-creative-marketplace\'}}</a></div></div></div></div>");
$templateCache.put("app/components/my-credit-checkout-btn/my-credit-checkout-btn.html","<div class=\"my-credit-checkout-btn relative\"><button ng-disabled=vm.isWorking class=\"btn btn-submit btn-checkout text--bold\" type=submit no-authentication-click=\"isGuestPayment && vm.onCheckoutBtnClicked()\" hide-error-message=isGuestPayment ng-click=vm.onCheckoutBtnClicked()>{{vm.isWorking ? \'Processing...\' : \'Pay\' }}</button></div>");
$templateCache.put("app/components/navigation-horizontal/navigation-horizontal.html","<section class=navigation-horizontal><ul class=\"navigation-horizontal__wrap-list clearfix\"><button type=button class=\"navigation-horizontal__collapse-btn navbar-toggle collapsed\" data-toggle=collapse data-target=#{{collapseId}} aria-expanded=false><div class=navigation-horizontal__context>{{instance.context | translate}}</div><div class=\"navigation-horizontal__icon arrow-animation-menu-collapse\"><span class=\"icon-bar dash-one\"></span> <span class=\"icon-bar dash-two\"></span></div></button><div class=\"navigation-horizontal__list-item navbar-collapse collapse\" id={{collapseId}} ng-class=\"{\'no-border\': options.hideBorder}\" navbar-collapse-on-click=true><li ng-repeat=\"item in instance.items\" ng-if=\"item.permissions && item.permissions.length ? item.permissions.includes(vm.loginedUser.role) : true\" ui-sref-active=navigation-horizontal__menu-item--active class=navigation-horizontal__menu-item ui-sref={{item.redirectTo}}><span>{{item.name | translate}}</span> <span ng-if=item.value>({{item.value}})</span></li></div></ul></section>");
$templateCache.put("app/components/navigation-step/navigation-step.html","<div class=step-navigation><span ng-click=onStepClicked(step) ng-repeat=\"step in steps.data\" ng-class=\"{\'step-navigation__step--active\': step.isActive}\" class=\"badge step-navigation__step\" ng-style=\"{\'left\' : $index === 0 ? \'0%\' : 100/(steps.data.length - $index) + \'%\' }\">{{$index + 1}}</span><div class=text--hr></div></div>");
$templateCache.put("app/components/newsfeed-list/newsfeed-list.html","<div class=newsfeed-list-wrapper><div class=newsfeed-list ng-class=\"{\'newsfeed-list--scrollable pixerf-scrollable-but-not-parent\': container, \'newsfeed-list--loading\': vm.spinner.isVisible}\"><div ng-show=\"vm.activities.length === 0 && !vm.spinner.isVisible\" class=newsfeed-list--empty>There is currently no activity from any of the Pixerfers you are following.</div><ul class=newsfeed-list__items-wrapper infinite-scroll-disabled=vm.isNoMoreActivitiesToLoad infinite-scroll=vm.fetchMoreActivities() infinite-scroll-container=\"container ? \'.newsfeed-popover-wrapper .newsfeed-list\' : \'\'\"><li class=\"newsfeed-list__item clearfix\" ng-repeat=\"item in vm.activities\" ng-click=vm.onNotificationClicked(item)><div class=\"newsfeed-list__item__actor-wrapper col-md-10 col-sm-10 col-xs-10 no-padding\"><div class=\"newsfeed-list__item__actor pull-left text-center\" ng-click=\"vm.onNotificationClicked(item, $event)\"><a ng-attr-ui-sref=\"{{item.actor.link.uisref ? item.actor.link.uisref : null}}\" ui-sref-opts=\"{reload: true, notify: true}\" class=newsfeed-list__item__actor__thumbnail><img ng-if=\"item.actor.type !== \'user\'\" ng-src={{item.actor.thumbnail}}><pixerf-user-avatar ng-if=\"item.actor.type === \'user\'\" user-data=item.actor lazy=true></pixerf-user-avatar></a></div><div class=\"clearfix newsfeed-list__item__text-wrapper text-left\" ng-attr-title={{item.plainText}}><div class=newsfeed-list__item__text><div class=notification-list__item__text__content ng-click=\"vm.onNotificationClicked(item, $event)\" compile=item.text></div><div class=newsfeed-list__item__text__time>{{item.insertedAtFormatted | timeAgo}}</div></div></div></div><div class=\"newsfeed-list__item__object col-md-2 col-sm-2 col-xs-2 no-padding text-center\" ng-click=\"vm.onNotificationClicked(item, $event)\"><a ng-attr-ui-sref=\"{{item.object.link.uisref ? item.object.link.uisref : null}}\" ui-sref-opts=\"{reload: true, notify: true}\" class=newsfeed-list__item__object__thubmnail ng-attr-title={{item.object.content}}><img ng-if=\"item.object.type !== \'user\'\" ng-src={{item.object.thumbnail}} fallback-src=\"{{\'assets/images/icon-market.png\'}}\"><pixerf-user-avatar ng-if=\"item.object.type === \'user\'\" user-data=item.object lazy=true></pixerf-user-avatar></a></div></li></ul><scroll-paging show-message=\"vm.activities.length > 0\" message=\"No more activities.\" spinner=vm.spinner is-last-page=vm.isNoMoreActivitiesToLoad></scroll-paging></div></div>");
$templateCache.put("app/components/nomination-badge/nomination-badge.html","<div class=nomination-badge><div ng-repeat=\"badge in vm.badges\"><div class=\"{{\'nomination-badge\' + \'__\' + badge.name}}\"></div></div></div>");
$templateCache.put("app/components/notice-small-screen-popup/notice-small-screen-popup.html","<div class=notice-small-screen><div class=notice-background-overlay></div><div class=navbar-header><div class=notice-pixerf-logo></div><div class=notice-homepage-intropage></div></div><div class=notice-small-screen--wrapper><div class=thanks>Thank you for your interest in PIXERF!</div><div class=description><div>Our mobile app will be ready soon.</div><div>In the meantime, we’re much better looking on desktop.</div></div><div class=see-you>See you there!</div></div><div class=notice-footer><strong>Athena Tan</strong> - Mount Bromo, Picturesque</div></div>");
$templateCache.put("app/components/notification-btn/notification-btn.html","<div class=\"notification-btn btn-basic btn-basic--no-background\"><a class=\"mobile-show notification-popover-redirect\" ui-sref=notification.notifications ng-click=vm.onCloseBtnClicked()></a><div ng-click=vm.onNotificationBtnClicked() popover-popup-delay=150 ng-attr-title={{vm.tooltip}} popover-append-to-body=true popover-class=notification-popover popover-trigger=\"\'outsideClick\'\" uib-popover-template=\"\'app/components/notification-btn/notification-popover.html\'\" popover-placement=bottom type=button><span class=icon-icons_bell></span> <span ng-show=\"vm.numUnreadActivities.data > 0\" ng-class=\"{\'pixerf-badge--hover\': vm.isHover}\" class=\"pixerf-badge notification-btn__notification-badge-quantity animated--bounce\" ng-bind=\"vm.numUnreadActivities.data | bigNumberFormatter\"></span> <span class=\"notification-btn__text-description mobile-show\" translate>{{\'notifications\'}}</span></div></div>");
$templateCache.put("app/components/notification-btn/notification-popover.html","<div class=notification-popover-wrapper><div class=\"notification-popover__header clearfix\"><div class=\"notification-popover__header__text pull-left text--bold\" translate>{{\'notifications\'}}</div><a ng-click=vm.onMarkAllAsReadBtnClicked() class=\"notification-popover__header__text pull-right pixerf-link pixerf-link--color-blue\" ng-if=\"vm.numUnreadActivities.data > 0 && !vm.isWorking\"><div translate>{{\'mark-all-as-read\'}}</div></a></div><div class=notification-board><notification-list container=true on-list-loaded=vm.onListLoaded(response) parent-class=.notification-popover-wrapper scroll-spy-offset=450 on-init=vm.onNotificationListInit(instance) on-marked-as-read=vm.onMarkedAsRead()></notification-list></div></div>");
$templateCache.put("app/components/notification-flash-message/notification-flash-message.html","<div ng-click=vm.onNotificationClicked(vm.message.data) ng-show=vm.isVisible.data class=notification-flash-message ng-mouseover=vm.onMouserHover(vm.message) ng-mouseleave=vm.onMouseLeave(vm.message) ng-class=\"{\'notification-flash-message--no-animation\': vm.message.data.isClosedFast}\"><button title=Close type=button class=close ng-click=\"vm.close(vm.message.data, $event)\"><span class=icon-icons_close aria-hidden=true></span></button><div><div ng-click=\"vm.onNotificationClicked(vm.message.data, $event)\" class=notification-flash-message__message ng-class=\"{\'notification-flash-message__message--show-message\': vm.message.data.target.type === \'comment\'}\" compile=vm.message.data.text></div><span class=\"notification-flash-message__message__comment-content text--truncate\" ng-if=\"vm.message.data.target.type === \'comment\'\">{{ \'&nbsp\'+ vm.message.data.target.content}}</span></div><audio id=xyz src=assets/audio/notification-alert.mp3 preload=auto></audio></div>");
$templateCache.put("app/components/notification-list/notification-list.html","<div class=notification-list-wrapper><nav id=navbarNotificationList class=\"navbar navbar-light bg-light\"><ul class=\"nav nav-pills\"><li class=nav-item ng-repeat=\"item in vm.activities.data\" data-id={{item.id}}><a class=nav-link href=#notification{{item.id}}>{{item.id}}</a></li></ul></nav><div class=\"notification-list scroll-spy-component\" ng-class=\"{\'notification-list--scrollable\': container, \'notification-list--loading\': vm.spinner.isVisible}\" lazy-img-container data-spy=scroll data-target=#navbarNotificationList><div ng-show=\"vm.activities.data.length === 0 && !vm.spinner.isVisible\" class=notification-list--empty>You don\'t have any notifications!</div><ul class=notification-list__items-wrapper infinite-scroll-disabled=vm.isNoMoreActivitiesToLoad infinite-scroll=vm.fetchMoreActivities() infinite-scroll-container=\"container ? \'.notification-popover-wrapper .notification-list\' : \'.notification-page__notification-list-wrapper .notification-list\'\"><li class=notification-list__item ng-repeat=\"item in vm.activities.data\" ng-class=\"{\'notification-list__item--unread\': !item.is_read}\" ng-click=vm.onNotificationClicked(item) id=notification{{item.id}}><div class=notification-list__item__actor-wrapper><div ng-if=!vm.hideActorList.includes(item.verb) class=notification-list__item__actor ng-click=\"vm.onNotificationClicked(item, $event)\"><a ui-sref=\"{{item.actor.link.uisref ? item.actor.link.uisref : \'.\'}}\" ui-sref-opts=\"{reload: true, notify: true}\" class=notification-list__item__actor__thumbnail><img ng-if=\"item.actor.type !== \'user\'\" ng-src={{item.actor.thumbnail}}><pixerf-user-avatar ng-if=\"item.actor.type === \'user\'\" user-data=item.actor lazy=true></pixerf-user-avatar></a></div><div class=notification-list__item__text-wrapper ng-attr-title={{item.plainText}}><div class=notification-list__item__text><div class=notification-list__item__text__content ng-click=\"vm.onNotificationClicked(item, $event)\" compile=item.text></div><div class=notification-list__item__text__time>{{item.insertedAtFormatted | timeAgo}}</div></div></div><div class=notification-list__item__object ng-click=\"vm.onNotificationClicked(item, $event)\"><a ui-sref=\"{{item.object.link.uisref ? item.object.link.uisref : \'.\'}}\" ui-sref-opts=\"{reload: true, notify: true}\" class=notification-list__item__object__thubmnail ng-attr-title={{item.object.content}}><img ng-if=\"item.object.type !== \'user\'\" ng-src={{item.object.thumbnail}} fallback-src=\"{{\'assets/images/icon-market.png\'}}\"><pixerf-user-avatar ng-if=\"item.object.type === \'user\'\" user-data=item.object lazy=true></pixerf-user-avatar></a></div></div></li></ul><scroll-paging id=scrollPaging message=\"No more notifications.\" show-message=\"container ? false : vm.activities.data.length > 0\" spinner=vm.spinner is-last-page=vm.isNoMoreActivitiesToLoad hide-back-to-top=\"container ? true : false\" scroll-element=.notification-list.scroll-spy-component></scroll-paging></div><div ui-sref=notification.notifications class=\"notification-list__item notification-list__item__see-more text-center\" ng-click=vm.onSeeAllActivitiesBtnClicked()><a class=\"pixerf-link--color-theme text--semibold\">{{\'see-all\' | translate}}<a></a></a></div></div>");
$templateCache.put("app/components/notification-popup/notification-popup.html","<div class=notification-popup><div class=clearfix><div class=modal-info><div class=\"modal--title text-center text--color-black\" translate>{{vm.header}}</div><div class=\"modal-body text-center\"><p translate>{{vm.message}}!</p></div></div></div></div>");
$templateCache.put("app/components/notify-business-pending-popup/notify-business-pending-popup.html","<div class=notify-business-pending-popup><div class=\"notify-business-pending-popup__remove icon-icons_close\" ng-click=vm.close()></div><div class=notify-business-pending-popup__header>{{vm.message.title}}</div><div class=notify-business-pending-popup__body ng-bind-html=vm.message.content></div><div class=notify-business-pending-popup__footer><button ng-click=vm.onNextBtnClicked() class=notify-business-pending-popup__footer__submit-btn>{{vm.message.btnText}}</button></div></div>");
$templateCache.put("app/components/notify-feature-not-available-popup/notify-feature-not-available-popup.html","<div class=notify-feature-not-available-popup><button type=button class=close ng-click=vm.close()><span class=icon-icons_close aria-hidden=true></span></button><div class=clearfix><div class=\"modal-body text--color-black-2\"><h1 class=\"notify-feature-not-available-popup__header text--color-black\">{{vm.message.header}}</h1><div class=notify-feature-not-available-popup__content ng-bind-html=vm.message.content></div></div><br><div class=modal-footer><button ng-click=vm.close() class=\"btn btn-submit pixerf-btn-sm\">OK</button></div></div></div>");
$templateCache.put("app/components/notify-topup-credit-popup/notify-topup-credit-popup.html","<div class=notify-topup-credit-popup><button type=button class=close ng-click=vm.close()><span class=icon-icons_close aria-hidden=true></span></button><div class=clearfix><div class=\"modal-body text--color-black-2\"><!-- <h1 class=\"notify-topup-credit-popup__header text--color-black\">{{vm.message.header}}</h1> --><div class=notify-topup-credit-popup__content ng-bind-html=vm.message.content></div></div><br><div class=modal-footer><button ng-click=vm.onPurchaseBtnClicked() class=\"btn btn-submit pixerf-btn-sm\">Purchase Now</button></div></div></div>");
$templateCache.put("app/components/omise-checkout-btn/omise-checkout-btn.html","<div class=\"omise-checkout-btn relative\"><button ng-disabled=vm.isWorking class=\"btn btn-submit omise-checkout-btn__button text--bold\" type=submit id={{vm.buttonId}} no-authentication-click=\"isGuestPayment && vm.onCheckoutBtnClicked()\" hide-error-message=isGuestPayment allow-guest=true authentication-click=vm.onCheckoutBtnClicked()>{{vm.isWorking ? (\'processing\' | translate) + \'...\' : (\'pay-button\' | translate) }}</button></div>");
$templateCache.put("app/components/organization-detail-popup/organization-detail-popup.html","<div class=organization-detail-popup><button type=button class=close ng-click=vm.close()><span class=icon-icons_close aria-hidden=true></span></button><div class=clearfix><div class=\"modal-body text--color-black-2\"><h1 class=\"organization-detail-popup__header text--color-black text--semibold\">Company Details</h1><div class=organization-detail-popup__content><div class=\"organization-detail-popup__row clearfix\"><div class=organization-detail-popup__label>Name:</div><div class=\"organization-detail-popup__detail text--color-black text--semibold\">{{vm.info.organization.name}}</div></div><div class=\"organization-detail-popup__row clearfix\"><div class=organization-detail-popup__label>Registration no:</div><div class=\"organization-detail-popup__detail text--color-black text--semibold\">{{vm.info.organization.registration_no}}</div></div><div class=\"organization-detail-popup__row clearfix\"><div class=organization-detail-popup__label>Office type:</div><div class=\"organization-detail-popup__detail text--color-black text--semibold\">{{vm.info.organization.office_type}}</div></div><div class=\"organization-detail-popup__row clearfix\"><div class=organization-detail-popup__label>Country:</div><div class=\"organization-detail-popup__detail text--color-black text--semibold\">{{vm.info.organization.address.country | isoCountry}}</div></div></div></div><div class=modal-footer><button ng-click=vm.close() class=\"btn btn-submit organization-detail-popup__btn\">OK</button></div></div></div>");
$templateCache.put("app/components/payment-amount-to-pay/payment-amount-to-pay.html","<div class=payment-amount-to-pay><div class=\"payment-amount-to-pay__discount-wrapper text--bold clearfix\" ng-if=amountDiscounted><div class=\"payment-amount-to-pay__discounted-label pull-left text--color-black-4\">Discount</div><div class=pull-right><span class=\"payment-amount-to-pay__discounted-unit text--color-pixerf-theme\">- SGD</span> <span class=\"payment-amount-to-pay__discounted-number text--color-pixerf-theme\" ng-bind=\"amountDiscounted | number:0\"></span></div></div><div class=\"text--bold clearfix text--color-black-4\"><div class=\"payment-amount-to-pay__summary-label pull-left text--bold\" translate>{{title}}</div><div class=pull-right ng-if=amount><span class=payment-amount-to-pay__summary-unit>{{showUnit ? showUnit : \'$\'}}</span> <span class=\"payment-amount-to-pay__summary-number text--bold\" ng-bind=\"amount | number:0\"></span></div></div></div>");
$templateCache.put("app/components/payment-pannel/payment-pannel.html","<div class=payment-pannel><div class=\"payment-pannel__payment-method clearfix\"><div class=payment-pannel__payment-method__select-menthod ng-class=\"{\'display-horizontal\': displayHorizontal}\"><div ng-class=\"{\'payment-pannel__payment-method__item--disabled\': paymentMethod.isDisabled()}\" class=\"clearfix payment-pannel__payment-method__item\" ng-repeat=\"paymentMethod in vm.paymentMethods\" ng-click=vm.onPaymentMethodClicked(paymentMethod)><div ng-class=\"{\'text--color-pixerf-theme icon-icons-bullet--checked\': paymentMethod.isSelected, \'icon-icons-bullet\': !paymentMethod.isSelected}\" class=payment-pannel__payment-method__icon></div><div class=payment-pannel__payment-method__desciption ng-class=paymentMethod.id.toLowerCase()>{{paymentMethod.id === \'MY_CREDIT\' ? paymentMethod.name : \'\'}}</div></div></div><credit-card-form error-message-builder=\"vm.errorMessageBuilder({err: err})\" ng-if=\"(vm.selectedPaymentMethod.id == \'OMISE\') && displayHorizontal\" hide-submit-btn=true card=vm.cardInfo on-submit=vm.onPayBtnClick() amount-to-pay=amountToPay></credit-card-form><payment-amount-to-pay title={{vm.paymentAmountToPayTitle}} amount=amountToPay show-unit=\"{{isGuestPayment ? \'SGD\' : \'\' }}\"></payment-amount-to-pay><div ng-if=showPriceHint class=payment-pannel__hint-unit>{{showPriceHint}}</div><div ng-if=!skipsToAgree class=\"payment-pannel__tnc-agreement relative\" ng-class=\"{\'payment-pannel__tnc-agreement--error\': !vm.isAgreedTnC && vm.isFormDirty}\"><div class=payment-pannel__tnc-agreement__subscrible-news-letter ng-if=isGuestPayment><pixerf-checkbox error=\"!vm.isAgreedTnC && vm.isFormDirty\" model=vm model-property=subcribleNewsLetter on-changed=vm.onCheckboxSubscribleNewsLetterChanged()></pixerf-checkbox><div class=payment-pannel__tnc-agreement__agreement-sentence translate>{{\'subscrible-newsletter\'}}</div></div><div class=payment-pannel__tnc-agreement__agreement-license><pixerf-checkbox error=\"!vm.isAgreedTnC && vm.isFormDirty\" model=vm model-property=isAgreedTnC on-changed=vm.onCheckboxAgreedTncChanged()></pixerf-checkbox><div class=payment-pannel__tnc-agreement__agreement-sentence translate>{{\'i-agree-license-agreement\'}}</div></div><div class=payment-pannel__footage-note ng-if=displayHorizontal>By registering with PIXERF, you accept our <a ui-sref=introduction-company.privacy class=text--bold target=_blank>Privacy Policy</a> and <a ui-sref=introduction-company.terms class=text--bold target=_blank>Terms</a>.<br>Visit our <a ui-sref=introduction-support.faq.business class=text--bold target=_blank>FAQ</a> for more details.</div></div><div ng-switch=vm.selectedPaymentMethod.id class=\"payment-pannel__checkout-btn relative\"><my-credit-checkout-btn ng-switch-when=MY_CREDIT on-error=\"onError({pixerfPaymentErrorObject: pixerfPaymentErrorObject})\" process-before-pay=processBeforePay() is-guest-payment=isGuestPayment on-complete=\"onComplete({data: data})\"></my-credit-checkout-btn><paypal-checkout-btn context={{context}} ng-switch-when=PAYPAL on-validation-passed=onValidationPassed() skipcheckverifiedemail={{vm.skipCheckVerifiedEmail}} on-error=\"onError({pixerfPaymentErrorObject: pixerfPaymentErrorObject})\" on-paypal-done=onPaypalDone() process-before-pay=processBeforePay is-guest-payment=isGuestPayment on-complete=\"onComplete({data: data})\"></paypal-checkout-btn><omise-checkout-btn context={{context}} validator=validator() ng-switch-when=OMISE on-validation-passed=onValidationPassed() card=vm.cardInfo on-error=\"onError({pixerfPaymentErrorObject: pixerfPaymentErrorObject})\" process-before-pay=processBeforePay() is-guest-payment=isGuestPayment can-show-credit-popup={{vm.omisePaymentShowCreaditPopup}} on-complete=\"onComplete({data: data})\"></omise-checkout-btn><cheque-checkout-btn context={{context}} ng-switch-when=WIRE_TRANSFER on-error=\"onError({pixerfPaymentErrorObject: pixerfPaymentErrorObject})\" process-before-pay=processBeforePay() is-guest-payment=isGuestPayment on-complete=\"onComplete({data: data})\"></cheque-checkout-btn><div ng-click=vm.onBtnCoverClicked() ng-disabled=\"!vm.isAgreedTnC || vm.customCreditPlan || disablePayBtn\" ng-if=\"!vm.isAgreedTnC || vm.customCreditPlan || disablePayBtn\" class=\"absolute absolute--full payment-pannel__checkout-btn__cover zindex\" title=\"{{\'please-accept-license-agreement\' | translate}}\"></div></div></div><div class=payment-pannel__footage ng-if=\"vm.selectedPaymentMethod.id !== \'MY_CREDIT\'\" ng-class=\"{\'display-horizontal\': displayHorizontal}\"><div class=\"clearfix payment-pannel__footage__wrapper\"><div class=\"payment-pannel__footage__text text--bold text--color-black\">Secure Payment:</div><div class=payment-pannel__footage__logo-wrapper><a ng-href={{vm.selectedPaymentMethod.link}} target=_blank><div ng-class=\"\'payment-pannel__payment-method__logo payment-pannel__payment-method__logo__\' + vm.selectedPaymentMethod.id.toLowerCase()\"></div></a></div></div><!-- <div class=\"payment-pannel__footage-note\">By checking out, you have agreed to PIXERF\'s <a ui-sref=\"introduction-company.privacy\" class=\"text--bold\" target=\"_blank\">Privacy Policy</a> and <a ui-sref=\"introduction-company.terms\" class=\"text--bold\" target=\"_blank\">Terms</a>. Visit the <a ui-sref=\"introduction-support.faq.business\" class=\"text--bold\" target=\"_blank\">Business FAQ</a> for more information.</div> --></div></div>");
$templateCache.put("app/components/paypal-checkout-btn/paypal-checkout-btn.html","<div class=\"paypal-checkout-btn relative\" ng-class=\"{\'working\': vm.isWorking}\"><paypal-button id=my-paypal-btn style=vm.style env=vm.env payment=vm.payment commit=true on-authorize=vm.onAuthorize></paypal-button></div>");
$templateCache.put("app/components/pending-discussion-detail-tile/pending-discussion-detail-tile.html","<div class=pending-discussion-detail-tile><div class=pending-discussion-detail-tile__subject>{{vm.discussion.subject}}</div><div class=pending-discussion-detail-tile__post-info><span class=pending-discussion-detail-tile__post-info__label>Posted by</span> <span class=pending-discussion-detail-tile__post-info__author>{{vm.discussion.user.displayName}}</span> <span class=pending-discussion-detail-tile__post-info__dot></span> <span class=pending-discussion-detail-tile__post-info__date>{{vm.postedDate}}</span></div><div class=pending-discussion-detail-tile__description>{{vm.discussion.description}}</div><div class=pending-discussion-detail-tile__photo-attachments><div ng-if=\"vm.discussion.photos && vm.discussion.photos.length\" flex-grid ng-model=vm.discussion.photos rowheight=50 lastrow=justify margins=10><div ng-repeat=\"photo in vm.discussion.photos\"><a ng-attr-fancyboxable=\"{\'type\': \'image\', \'overlayShow\': true, \'hideOnOverlayClick\': true, \'showNavArrows\': true, \'margin\': \'50 10 15 10\', \'centerOnScroll\': true}\" href={{photo.url.large}} rel=discussionAttachment><img ng-src={{photo.url.thumbnail}}></a></div></div></div><div class=pending-discussion-detail-tile__footer><div class=pending-discussion-detail-tile__footer__left-control ng-click=vm.onRejectDiscussion(vm.discussion)><span class=\"pending-discussion-detail-tile__footer__icon icon-icons_close\"></span> <span class=pending-discussion-detail-tile__footer__text>Reject</span></div><div class=pending-discussion-detail-tile__footer__right-control ng-click=vm.onApproveDiscussion(vm.discussion)><span class=\"pending-discussion-detail-tile__footer__icon icon-icons_check\"></span> <span class=pending-discussion-detail-tile__footer__text>Approve</span></div></div></div>");
$templateCache.put("app/components/people-list/people-list-popup.html","<pixerf-alert instance=vm.alertSvc></pixerf-alert><div class=people-list-popup><div class=clearfix><button type=button class=close ng-click=vm.closePopup()><span class=icon-icons_close aria-hidden=true></span></button><div class=\"modal-header text-left\"><h3 class=\"modal--title text--bold text--color-black text-left\" translate>{{vm.popupTitle}}</h3></div><div class=\"modal-body text-center people-list-popup-scroll-wrapper\" infinite-scroll-disabled=vm.isLastPage infinite-scroll=vm.fetchMorePeoples() infinite-scroll-immediate-check=false infinite-scroll-container=\"\'.people-list-popup-scroll-wrapper\'\" lazy-img-container><div class=\"people-list-popup__people-wrapper text-left\" ng-repeat=\"people in vm.peoples\"><a ng-if=\"people.account_type != \'business\'\" ui-sref=\"user-home-page.personal.home({id: people.id, userName: (people.displayName| toSnakeCase)})\" class=people-list-popup__people__avatar ng-click=vm.closePopup()><pixerf-user-avatar user-data=people lazy=true></pixerf-user-avatar></a><a ng-if=\"people.account_type != \'business\'\" ui-sref=\"user-home-page.personal.home({id: people.id, userName: (people.displayName| toSnakeCase)})\" ng-click=vm.closePopup() class=\"people-list-popup__people__name text--semibold text--color-black text--truncate\" ng-bind=people.displayName></a> <a ng-if=\"people.account_type === \'business\'\" class=people-list-popup__people__avatar><pixerf-user-avatar user-data=people lazy=true></pixerf-user-avatar></a><a ng-if=\"people.account_type === \'business\'\" class=\"people-list-popup__people__name text--semibold text--color-black text--truncate\" ng-bind=people.displayName></a><follow-btn ng-if=\"people.account_type != \'business\'\" class=pull-right user=people login-user=vm.user></follow-btn></div><scroll-paging spinner=vm.spinner show-message=false is-last-page=vm.isLastPage></scroll-paging></div><div class=\"modal-footer text-left\" ng-if=\"!vm.options || !vm.options.hideSeeAll\"><a ui-sref=\"peoples-page.byAffections({affectionType: vm.searchParams.action , userId: vm.searchParams.personId})\" ng-click=vm.closePopup()>{{\'see-all\' | translate}}</a></div></div></div>");
$templateCache.put("app/components/people-with-selection/people-with-selection.html","<div class=\"people-with-selection relative\"><div class=people-with-selection__avatar><a ui-sref=\"user-home-page.personal.home({id: people.id, userName: (people.displayName | toSnakeCase)})\"><pixerf-user-avatar user-data=people lazy=true></pixerf-user-avatar></a></div><div class=people-with-selection__control><div class=people-with-selection__info><div class=people-with-selection__info__details><a ui-sref=\"user-home-page.personal.home({id: people.id, userName: (people.displayName | toSnakeCase)})\" popup-link-clicked><div class=\"user-name text--truncate text--bold text--color-black\" uib-tooltip={{people.displayName}}>{{people.displayName}}</div></a><div class=people-with-selection__info__details__level pixerf-person-level person=people></div></div></div><div class=\"relative people-with-selection__checkbox-wrapper\"><stick-checkbox model=people model-property=isSelected on-changed=\"onSelectedStatusChanged({data: people})\"></stick-checkbox></div></div></div>");
$templateCache.put("app/components/person-list-selection/person-list-selection.html","<div class=\"clearfix person-list-selection\"><div class=\"person-list-selection__search-member-wrapper relative\"><input ng-model=vm.searchString ng-change=vm.onSearchStringChanged() class=\"form-control search-input\" type=text placeholder=\"Find a member...\"> <span class=\"person-list-selection__search-member-wrapper__search-icon glyphicon glyphicon-search vertical-align-middle--transform\"></span></div><div infinite-scroll-disabled=\"vm.isLastPage || options.disableScroll\" infinite-scroll=vm.fetchMorePeoples() infinite-scroll-immediate-check=false infinite-scroll-container=\"\'.person-list-selection\'\" lazy-img-container><div ng-repeat=\"people in vm.peoples\" class=person-list-selection__item-wrapper><people-with-selection people=people on-selected-status-changed=\"onSelectedStatusChanged({data: people})\"></people-with-selection></div><scroll-paging spinner=vm.spinner show-message=false is-last-page=vm.isLastPage></scroll-paging></div><div class=person-list-selection__empty-state ng-if=\"vm.peoples.length === 0\"><div ng-transclude></div></div></div>");
$templateCache.put("app/components/person-selection/person-selection.html","<div class=person-selection><div class=person-selection__avatar><a ui-sref=\"user-home-page.personal.home({id: person.id, userName: (person.displayName | toSnakeCase)})\"><pixerf-user-avatar user-data=person lazy=true></pixerf-user-avatar></a></div><div class=person-selection__info><div class=person-selection__info__details><a ui-sref=\"user-home-page.personal.home({id: person.id, userName: (person.displayName | toSnakeCase)})\" popup-link-clicked><div class=person-selection__name uib-tooltip={{person.displayName}}>{{person.displayName}}</div></a><div ng-if=options.showEmail class=person-selection__info__subinfo>{{person.email.address || person.email}}</div><div ng-if=options.showLevel class=person-selection__info__subinfo pixerf-person-level person=person></div></div><div class=person-selection__control-wrapper><stick-checkbox ng-if=\"mode === \'select\'\" model=person model-property=isSelected on-changed=onSelected(person)></stick-checkbox><div ng-if=\"mode === \'remove\'\" class=\"person-selection__control-wrapper__close-btn icon-icons_close\" ng-click=\"onRemoved({data: person})\"></div></div></div></div>");
$templateCache.put("app/components/photo/more-action-popover.html","<div class=photo-more-action-popover><div class=photo-more-action-popover__item-wrapper><div class=photo-more-action-popover__item ng-click=vm.setPhotoAsCover()>Set as Gallery Cover</div><div class=photo-more-action-popover__item ng-click=\"vm.removePhotoFromGallery(file, gallery)\">Remove from Gallery</div></div></div>");
$templateCache.put("app/components/photo/photo.html","<div ng-click=vm.onPhotoClicked(file) ng-style=\"{\'background-image\': \'url(\' + vm.imageUrl + \')\'}\" class=photo ng-attr-data-photo-id=file.id ng-class=\"{\'bulk-edit-photo\': vm.isBulkEditPhoto, \'bulk-edit-photo-selected\' : vm.isBulkEditPhotoSelected()}\" ng-attr-title=\"{{vm.isDeletedPhoto ? \'Deleted\' : (!options.hideCuratorBtns && vm.isLogined && (vm.loginUser.canCurate) && file.license != \'commercial\' && !vm.isPortfolioPhoto ? \'License Type: Editorial\' : !options.hideCuratorBtns && vm.isLogined && (vm.loginUser.canCurate) && !vm.isPortfolioPhoto ? \'License Type: Commercial\' : \'\')}}\"><span class=\"manage-photos-approved__photo-type text--bold\" ng-if=\"file.type === \'portfolio\'\">Portfolio</span> <a class=overlay ng-if=!vm.isPortfolioPhoto ng-attr-href={{file.path}} ng-click=$event.preventDefault();></a> <a class=overlay ng-if=vm.isPortfolioPhoto ng-click=$event.preventDefault(); ng-attr-fancyboxable=\"{\'type\': \'image\', \'overlayShow\': true, \'hideOnOverlayClick\': true, keys:{next: null, prev: null}, \'showNavArrows\': false, \'margin\': \'50 10 15 10\', \'centerOnScroll\': true}\" href={{file.urlSmall}} rel=portfolioGallery></a><div class=pixerf-hover ng-if=\"simpleSelectMode && file.isSelected\"></div><div class=photo__backdrop ng-if=vm.isDeletedPhoto ng-click=$event.stopPropagation()></div><stick-checkbox ng-if=\"vm.isBulkEditPhoto && vm.isBulkEditPhotoSelected()\" class=photo__bulk-edit-photo-cover__checkbox model=vm model-property=isBulkEditPhotoSelectedItem label=\"\" layout-style=solid-square></stick-checkbox><div class=photo__tools-wrapper><div class=photo__tools-wrapper__left ng-if=\"!simpleSelectMode && !vm.isPortfolioPhoto && !overlayMode\"><pixerf-photo-state-btn need-review-license=true options=vm.photoStateBtnOptions ng-if=\"vm.isLogined && (vm.loginUser.canCurate) && !options.hideCuratorBtns\" ng-click=$event.stopPropagation() class=photo__tools pixerf-photo-state-btn-state=g pixerf-photo-state-btn-media=file title=\"Move to General\" bulk-photo-state=vm.bulkSelectedPhoto></pixerf-photo-state-btn><pixerf-photo-state-btn ng-if=\"vm.isLogined && (vm.loginUser.canCurate) && !options.hideCuratorBtns\" options=vm.photoStateBtnOptions ng-click=$event.stopPropagation() class=photo__tools pixerf-photo-state-btn-state=h pixerf-photo-state-btn-media=file title=\"Move to Pending\"></pixerf-photo-state-btn><pixerf-photo-state-btn need-review-license=true options=vm.photoStateBtnOptions ng-if=\"vm.isLogined && (vm.loginUser.canCurate) && !options.hideCuratorBtns\" ng-click=$event.stopPropagation() class=photo__tools pixerf-photo-state-btn-state=d pixerf-photo-state-btn-media=file title=\"Move to Discover\" bulk-photo-state=vm.bulkSelectedPhoto></pixerf-photo-state-btn><pixerf-photo-state-btn need-review-license=true options=vm.photoStateBtnOptions ng-if=\"vm.isLogined && (vm.loginUser.canCurate) && !options.hideCuratorBtns\" ng-click=$event.stopPropagation() class=photo__tools pixerf-photo-state-btn-state=t pixerf-photo-state-btn-media=file title=\"Move to Trending\" bulk-photo-state=vm.bulkSelectedPhoto></pixerf-photo-state-btn><like-btn ng-if=\"file && !options.hideLike\" ng-click=$event.stopPropagation() class=\"photo__tools photo__tools__like\" media=file hover-show-number=true></like-btn><star-btn is-show-tooltip=true ng-if=\"vm.loginUser && vm.loginUser.canCurate && !options.hideCuratorBtns\" class=\"photo__tools photo__tools__star-btn\" target=file ng-click=$event.stopPropagation() hover-show-number=true></star-btn><pixerf-photo-state-btn is-need-confirm=\"file.state !==\'h\' && file.state !==\'r\'\" options=vm.photoStateBtnOptions need-review-license=\"!!file.user.ambassadorship && (file.state ===\'h\' || file.state ===\'r\')\" ng-if=\"vm.isLogined && (vm.loginUser.isAdminInternal || ((file.state ===\'e\') && vm.loginUser.canCurate && options.showBtnE)) && !options.hideCuratorBtns && (!!file.user.ambassadorship || (!file.user.ambassadorship && file.state !==\'h\' && file.state !==\'r\'))\" ng-click=$event.stopPropagation() class=photo__tools pixerf-photo-state-btn-state=e pixerf-photo-state-btn-media=file title=\"Set as Editor\'s Pick\" bulk-photo-state=vm.bulkSelectedPhoto></pixerf-photo-state-btn><div class=\"photo__tools photo__view-count\"><span class=icon-view-count></span> <span class=photo__view-count__text>{{file.view_count}}</span></div></div><div class=photo__tools-wrapper__left ng-if=vm.isPortfolioPhoto><pixerf-photo-state-btn ng-if=\"vm.isLogined && (vm.loginUser.canCurate) && !options.hideCuratorBtns\" options=vm.photoStateBtnOptions ng-click=$event.stopPropagation() class=photo__tools pixerf-photo-state-btn-state=g pixerf-photo-state-btn-media=file title=\"Move to General\" bulk-photo-state=vm.bulkSelectedPhoto></pixerf-photo-state-btn><pixerf-photo-state-btn ng-if=\"vm.isLogined && (vm.loginUser.canCurate) && !options.hideCuratorBtns\" options=vm.photoStateBtnOptions ng-click=$event.stopPropagation() class=photo__tools pixerf-photo-state-btn-state=h pixerf-photo-state-btn-media=file title=\"Move to Pending\" bulk-photo-state=vm.bulkSelectedPhoto></pixerf-photo-state-btn><pixerf-photo-state-btn ng-if=\"vm.isLogined && (vm.loginUser.canCurate) && !options.hideCuratorBtns\" options=vm.photoStateBtnOptions ng-click=$event.stopPropagation() class=photo__tools pixerf-photo-state-btn-state=d pixerf-photo-state-btn-media=file title=\"Move to Discover\" bulk-photo-state=vm.bulkSelectedPhoto></pixerf-photo-state-btn><pixerf-photo-state-btn ng-if=\"vm.isLogined && (vm.loginUser.canCurate) && !options.hideCuratorBtns\" options=vm.photoStateBtnOptions ng-click=$event.stopPropagation() class=photo__tools pixerf-photo-state-btn-state=t pixerf-photo-state-btn-media=file title=\"Move to Trending\" bulk-photo-state=vm.bulkSelectedPhoto></pixerf-photo-state-btn></div><div class=photo__tools-wrapper__right ng-if=\"!simpleSelectMode && !overlayMode\"><pixerf-photo-state-btn ng-if=\"vm.isLogined && (vm.loginUser.canCurate) && !options.hideCuratorBtns\" ng-click=$event.stopPropagation() class=photo__tools pixerf-photo-state-btn-state=r pixerf-photo-state-btn-media=file options=vm.photoStateBtnOptions ng-attr-title=\"{{file.state===\'r\' && file.reject_reason ? \'Reject Reason: \' + file.reject_reason : \'Reject this photo\'}}\" bulk-photo-state=vm.bulkSelectedPhoto></pixerf-photo-state-btn><div class=\"photo__tools photo__tools__delete-photo photo__tools__delete-btn\" ng-click=\"vm.onDeletePhoto(); $event.stopPropagation()\" title=\"Delete this photo\" role=button tabindex=0><span class=photo__tools__delete-photo__label role=button tabindex=0>X</span></div><div ng-if=\"vm.showAddToCart && !vm.guestUser && file.state !=\'r\'\" ng-click=\"$event.stopPropagation(); vm.onAddToCartBtnClicked(file)\" class=\"photo__tools__add-to-cart photo__tools\" ng-class=\"{\'disabled\':vm.isAddedToCart}\" title=\"{{vm.isAddedToCart ? \'purchased\' : \'add-to-cart\' | translate}}\"><span class=\"{{vm.isAddedToCart ? \'icon-cart-purchased\' : \'icon-icons_cart\'}}\"></span></div><add-to-gallery add-when-gallery-created=true ng-click=$event.stopPropagation() ng-if=\"!gallery && !options.hideAddToGallery && !vm.isPortfolioPhoto && (!vm.isLogined || vm.loginUser.canManageGalleries) && !vm.guestUser && file.state !=\'r\' \" file=file close-on-click=true class=\"add-to-gallery photo__tools--right\" on-gallery-item-clicked=\"vm.onGalleryItemClicked(file, gallery)\"><div authentication-click popover-enable=vm.isEnable popover-popup-delay=250 ng-click=vm.clickOutSide() popover-append-to-body=true popover-class=add-to-gallery popover-is-open=vm.isOpen.data ng-class=\"{\'no-opacity\' : vm.isOpen.data}\" type=button uib-popover-template=\"\'app/components/add-to-gallery/add-to-gallery-popover-tmpl.html\'\" popover-placement=\"auto left\" popover-trigger=\"\'outsideClick\'\" title=\"{{\'add-photo-to-your-gallery\' | translate}}\" class=\"photo__tools photo__tools__add-to-gallery\"><span class=icon-icons-add-to-gallery></span></div></add-to-gallery><div ng-if=options.showRemoveBtn class=\"photo__tools photo__tools__remove-btn\" title=\"Remove this photo\"><button type=button class=close ng-click=\"$event.stopPropagation(); onRemoveBtnClick({file: file})\"><span class=icon-icons_close></span></button></div><div ng-if=\"false && !vm.isPortfolioPhoto\" class=\"photo__tools__add-to-cart photo__tools\" title=\"{{\'add-photo-to-your-cart\' | translate}}\"><span class=icon-icons_cart></span></div><!-- <div ng-click=\"vm.clickOutSide($event)\">\r\n      <div ng-click=\"vm.clickOutSide($event)\">\r\n        <div popover-popup-delay=\"250\" ng-if=\"gallery && gallery.isMine\"\r\n          uib-popover-template=\"\'app/components/photo/more-action-popover.html\'\" popover-placement=\"bottom\"\r\n          popover-trigger=\"\'outsideClick\'\" class=\"photo__tools__more photo__tools photo__tools--right\"\r\n          title=\"More actions\">\r\n          <span class=\"icon-icons_more\"></span>\r\n        </div>\r\n      </div>\r\n      <share ng-click=\"$event.stopPropagation()\" content-will-be-shared=\"vm.socialShareContent\" ng-if=\"gallery\"\r\n        class=\"photo__tools__share photo__tools photo__tools--right \" title=\"{{\'hover-share-this-photo\' | translate}}\">\r\n      </share> --></div></div><div class=photo__info ng-if=\"!simpleSelectMode && !options.hidePhotoInfo && !overlayMode\"><div class=photo__info__author ng-show=\"!file.isMine || context === \'MARKET_PLACE\'\"><a ng-click=$event.stopPropagation() ui-sref=\"user-home-page.personal.home({id: file.user.id, userName: (file.user.displayName | toSnakeCase)})\" target=_blank><div class=photo__info__author__avatar ng-class=\"{\'flagged-user\': vm.isFlaggedUser()}\"><pixerf-user-avatar user-data=file.user lazy=true></pixerf-user-avatar></div><div class=\"photo__info__author__name text--truncate text--semibold\">{{file.user.displayName}}</div></a></div><div class=\"photo__info__title text--truncate\" ng-show=\"file.isMine && context !== \'MARKET_PLACE\' && !vm.isPortfolioPhoto\">{{file.title}}</div></div><div ng-if=simpleSelectMode class=photo__select-checkbox ng-click=\"$event.stopPropagation(); vm.onPhotoClicked(file);\" title=\"{{\'select-this-photo\' | translate}}\"><div class=\"pixerf-checkbox pixerf-checkbox--fake\" ng-class=\"{\'pixerf-checkbox--fake--checked\': file.isSelected}\"></div></div><div ng-if=overlayMode class=photo__select-checkbox ng-click=\"$event.stopPropagation(); vm.onPhotoClicked(file);\" title=\"{{\'select-this-photo\' | translate}}\"></div></div>");
$templateCache.put("app/components/photo-detail/photo-detail.html","<div class=photo-detail><div class=\"clearfix relative\"><div class=\"photo-detail__main-content bg--white\"><div class=\"content-wrapper relative\"><div class=absolute--full><photo-viewer instance=photoViewer on-photo-saved=vm.onPhotoRotated() on-navigate=vm.setPhoto(photo) photo=photo class=photo-detail__main-content__photo-thumbnail photo-loaded=vm.onItemImageLoadHandler></photo-viewer></div></div><ng-include ng-if=\"isMobile && !isEditMode.data\" src=\"\'app/components/photo-detail/segments/photo-detail-user-photo-brief.html\'\"></ng-include><div class=clearfix><photo-exif-info media=photo class=\"photo-exif-info col-md-12\"></photo-exif-info><div class=\"ng-hide photo-detail__main-content__report-photo col-md-2 text-right\"><h5><a class=text--color-pixerf-theme href=\"\">Report this Photo</a></h5></div></div><div ng-if=!isEditMode.data><ng-include ng-if=!isMobile src=\"\'app/components/photo-detail/segments/photo-detail-keyword-similar.html\'\"></ng-include></div></div><div ng-class=\"{\'overflow--scroll\': !isEditMode.data}\" class=\"photo-detail__photo-info bg--white\"><ng-include ng-if=\"!isMobile && !isEditMode.data\" src=\"\'app/components/photo-detail/segments/photo-detail-user-photo-brief.html\'\"></ng-include><div class=\"photo-detail__photo-info--padding photo-detail__photo-info__private-label\" ng-if=\"photo.isMine && !photo.price\" ng-show=false><span class=\"label label-warning\">Private</span> <span class=icon-icons-info tooltip-placement=right tooltip-class=text-left tooltip-append-to-body=true uib-tooltip-html=vm.privateToolTip tooltip-placement=auto></span></div><div ng-if=!isEditMode.data class=\"photo-detail__photo-info__devider devider\"></div><div class=\"photo-detail__photo-info--padding photo-detail__photo-info__pricing\" ng-if=!isEditMode.data><h5 ng-if=!isMobile class=\"text--extrabold text--color-black photo-detail__photo-info__pricing__header--dimension\" translate>{{\'licensing-details\'}}</h5><div ng-if=isMobile class=photo-detail__item__header data-toggle=collapse data-target=#photo-details-licensing aria-expanded=true><h5 class=\"text--extrabold text--color-black photo-detail__photo-info__pricing__header--dimension\" translate>{{\'licensing-details\'}}</h5><span class=\"photo-detail__item__collapse-icon icon-icons_plus\"></span> <span class=\"photo-detail__item__collapse-icon icon-icons_minus\"></span></div><div class=\"clearfix photo-detail__photo-info__pricing__price-item collapse in\" id=photo-details-licensing><div class=clearfix><div class=\"pull-left col-md-5 no-padding\"><div class=\"photo-detail__photo-info__pricing__header--license-type text--bold text--color-black\" translate>{{\'license-type\'}}</div></div><photo-license-info photo=photo></photo-license-info></div><div class=clearfix><div class=\"pull-left col-md-8 no-padding ng-hide\"><div class=\"photo-detail__photo-info__pricing__price-item__dimension-title text--bold text--color-black-2\" translate>{{\'price\'}}</div></div><div class=\"pull-left col-md-4 no-padding ng-hide\"><div class=\"text--color-black-2 text-right photo-detail__photo-info__pricing__price-item__editorial\">{{photo.price ? (\'SGD \' + photo.price) : \'Not set\'}}</div></div></div><div class=\"text--color-black-2 pull-left col-md-12 no-padding text--subcribe-pricing\" ng-if=\"!isMobile && !photo.in_mission && !photo.user.isNoNeedSubscribe\"><a ui-sref=introduction-pixerfer.subscriptions.personal target=_blank><span class=\"text--color-pixerf-theme text--bold\">{{\'subscribe\' | translate}} </span></a><span translate translate-values=\"{number: 5}\">{{\'to-sell-your-photos-at-different-price\'}}</span></div></div><h5 class=\"text--semibold photo-detail__photo-info__pricing__header--dimension ng-hide\" translate>{{\'dimension\'}}</h5><hr ng-if=isMobile class=photo-detail__mobile-devider><div ng-if=isMobile class=photo-detail__item__header data-toggle=collapse data-target=#photo-details-photo-price-size-selection aria-expanded=true><h5 class=\"text--extrabold text--color-black photo-detail__photo-info__pricing__header--dimension\" translate>{{\'Pricing Details\'}}</h5><span class=\"photo-detail__item__collapse-icon icon-icons_plus\"></span> <span class=\"photo-detail__item__collapse-icon icon-icons_minus\"></span></div><div id=photo-details-photo-price-size-selection class=\"photo-detail__photo-price-size-selection collapse in\"><div class=\"text--color-black-2 pull-left col-md-12 no-padding text--subcribe-pricing mobile\" ng-if=\"isMobile && !photo.in_mission && !photo.user.isNoNeedSubscribe\"><a ui-sref=introduction-pixerfer.subscriptions.personal target=_blank><span class=\"text--color-pixerf-theme text--bold\">{{\'subscribe\' | translate}} </span></a><span translate translate-values=\"{number: 5}\">{{\'to-sell-your-photos-at-different-price\'}}</span></div><photo-price-size-selection class=clearfix is-readonly=photo.isMine ng-if=!photo.in_mission photo=vm.cartItem.media on-item-selected-changed=\"vm.onVariantSelected(evt, price)\" ng-if=!photo.in_mission></photo-price-size-selection><div ng-if=photo.in_mission class=photo-original-size-wrapper><div class=\"photo-detail__photo-info__pricing__header--license-type text--bold text--color-black-2\" translate>{{\'photo-size\'}}</div><photo-original-size photo=photo></photo-original-size></div><photo-price-extended-license-selection class=clearfix ng-if=\"!photo.isMine && !photo.in_mission\" photo=vm.cartItem.media on-item-selected-changed=\"vm.onVariantSelected(evt, price)\"></photo-price-extended-license-selection></div><div ng-if=\"!photo.isMine && !photo.in_mission\" class=\"clearfix photo-detail__photo-info__pricing__price-item photo-detail__photo-info__pricing__price-item--sub-total\"><label class=\"text--extrabold text--color-black photo-detail__photo-info__pricing__price-item--sub-total__label\">Sub-total</label><div class=\"pull-right text--color-black col-md-3 no-padding text-right photo-detail__photo-info__pricing__price-item--sub-total__value\">SGD <span class=text--extrabold>{{vm.cartItem.sub_total}}</span></div></div><winner-photo-selection ng-if=\"photo.in_mission && vm.loginnedUser && vm.loginnedUser.canManageMission && !photo.mission.is_awarded  && photo.mission.is_closed && photo.state != \'r\' && photo.state != \'h\'\" mission=photo.mission media=photo></winner-photo-selection><div class=photo-detail__badge ng-if=\"photo.badges.length > 0\"><pixerf-badges badges=photo.badges></pixerf-badges></div></div><div class=\"photo-detail__photo-info--padding ng-hide\"><call-to-action-messages messages=vm.callToActionMesages></call-to-action-messages></div><hr ng-if=isMobile class=photo-detail__mobile-devider--no-margin><div class=\"photo-detail__photo-info--padding photo-detail__photo-info--btns-wrapper\" ng-if=!isEditMode.data><div class=photo-detail__photo-info__notice-in-mission ng-if=photo.in_mission compile=\"\'this-photo-is-part-of-mission\' | translate\"></div><div class=\"text-center photo-detail__photo-info__btn-edit-wrapper text--bold\" ng-if=\"photo.isMine || (vm.loginnedUser && vm.loginnedUser.canCurate)\"><button ng-click=vm.onEditBtnClicked() class=\"photo-detail__photo-info__btn-edit container-full btn btn-cancel--no-background btn-block\">{{\'edit-photo\' | translate}}</button></div><div ng-if=\"vm.loginnedUser && vm.loginnedUser.canDownloadComp\" class=\"photo-detail__photo-info__download-comp btn btn-cancel--no-background\" ng-click=vm.onDownloadComp(photo)>{{\'download-comp\' | translate}}</div><add-to-cart-btn ng-attr-title=\"{{photo.in_mission ? \'This photo is under review in a Mission\' : \'\'}}\" is-disabled=photo.in_mission on-added=vm.onAddedToCart(addedCartItem) media=vm.cartItem.media ng-if=\"!photo.isMine && !vm.cartItem.id && photo.state !=\'r\'\" ng-class=\"{\'btn-no-background\': vm.loginnedUser && vm.loginnedUser.canCurate && photo.status && photo.status !== \'none\' && photo.releases.length > 0}\"></add-to-cart-btn><div class=\"text-center photo-detail__photo-info__btn-nominate-wrapper\" ng-if=!photo.isMine><button tooltip-append-to-body=true tooltip-class=photo-detail__nominate-tooltip tooltip-enable=vm.loginnedUser tooltip-placement=left uib-tooltip-html=vm.tooltips.nomination authentication-click=vm.onNominateBtnClicked() check-verified-email=true class=\"photo-detail__photo-info__btn-nominate container-full btn btn-block\" ng-class=\"{\'btn-cancel--no-background\': (vm.loginnedUser && vm.loginnedUser.canCurate && photo.status && photo.status !== \'none\' && photo.releases.length > 0), \'btn--black\': !(vm.loginnedUser && vm.loginnedUser.canCurate && photo.status && photo.status !== \'none\' && photo.releases.length > 0)}\">{{photo.is_nominated ? (\'nominated\' | translate) : (\'nominate-this-photo\' | translate)}}</button><div class=photo-detail__photo-info__nominate-note translate>{{\'nominate-your-favourite-photos\'}}</div></div><nomination-badge nomination-count=photo.nomination_count></nomination-badge><div ng-if=\"photo.status && photo.status !== \'none\' && photo.releases.length > 0\"><approve-reject-release-form alert=alert file=photo></approve-reject-release-form></div></div><hr ng-if=isMobile class=photo-detail__mobile-devider--no-margin><div ng-if=isEditMode.data class=\"height--full photo-detail__photo-info__edit-detail overflow--scroll\"><upload-photo-detail is-loading-clarifai=vm.isLoadingClarifai alert=alert form-error=vm.formError is-form-dirty=vm.isFormDirty files=[photo] categories=vm.categories></upload-photo-detail><div class=\"photo-detail__photo-info--padding text-center photo-detail__photo-info__btn-save-cancel-delete-wrapper\"><button class=\"photo-detail__photo-info__btn-save container-full btn btn-submit btn-block\" ng-disabled=vm.isSaving ng-click=vm.onSaveChangesBtnClicked()>{{vm.isSaving ? \'Saving ...\' : (\'save-changes\' | translate)}}</button><div class=photo-detail__photo-info__btn-cancel-delete-wrapper><a class=photo-detail__photo-info__btn-cancel ng-click=vm.onCancelPhotoBtnClicked()>{{\'cancel\' | translate}}</a> <a class=photo-detail__photo-info__btn-delete><pixerf-delete-media-btn pixerf-delete-media-btn-media=photo pixerf-delete-media-btn-btn-label=delete pixerf-delete-media-btn-on-media-deleted=\"onPhotoDeleted({photo: media})\" context=vm.context></pixerf-delete-media-btn></a></div></div></div><div ng-if=\"!isEditMode.data && isMobile\" class=photo-detail__main-content><ng-include src=\"\'app/components/photo-detail/segments/photo-detail-keyword-similar.html\'\"></ng-include></div><div ng-if=\"!isEditMode.data && !photo.isMissionWinnerSelectionMode\" class=\"devider full-width\"></div><div ng-if=\"!isEditMode.data && !photo.isMissionWinnerSelectionMode\" class=\"photo-detail__photo-info--padding photo-detail__photo-info__comments-wrapper\"><h5 class=\"text--extrabold text--color-black photo-detail__photo-info__comments-label\" translate>{{\'comments\'}}</h5><comment-list context=\"photo.isMine ? \'IN_MY_HOUSE\' : \'\'\" target-id=photo.id></comment-list></div></div></div></div>");
$templateCache.put("app/components/photo-detail-popup/photo-detail-popup.html","<pixerf-alert instance=vm.pixerfAlert></pixerf-alert><div class=photo-detail-popup scroll-to-top-modal-target=.photo-detail-modal scroll-to-top-modal=vm.shouldScrollTop.data><button type=button class=\"close photo-detail-popup__close-btn\" ng-click=vm.closePopup()><span class=\"icon-icons_close text--color-white\" aria-hidden=true></span></button><div class=\"clearfix relative\"><photo-detail photo-viewer=vm.photoViewer is-edit-mode=vm.isEditing alert=vm.pixerfAlert on-saved=vm.onSaved(savedPhoto) photo=vm.data.photo on-photo-deleted=vm.onDeletePhotoBtnClicked(photo) context=vm.context></photo-detail></div></div>");
$templateCache.put("app/components/photo-exif-info/photo-exif-info.html","<div class=photo-exif-info><div class=photo-exif-info__header data-toggle=collapse data-target=#photo-details-collapse aria-expanded=true><h5 class=photo-exif-info__title translate>{{\'photo-details\'}}</h5><span class=\"photo-exif-info__collapse-icon icon-icons_plus\"></span> <span class=\"photo-exif-info__collapse-icon icon-icons_minus\"></span></div><h5 class=photo-exif-info__title translate>{{\'photo-details\'}}</h5><div class=\"collapse in\" id=photo-details-collapse><div class=photo-exif-info__exif-items><div class=\"photo-exif-info__item photo-exif-info__item__camera-info\"><div ng-if=!vm.showInfoCamera class=photo-exif-info__item__camera-info__not-available translate>{{\'camera-info-not-available\'}}</div><div ng-if=media.camera.model class=photo-exif-info__item__camera-info__model>{{media.camera.cameraFormated}}</div><div ng-if=\"media.camera.model && media.isMine\" class=photo-exif-info__item__camera-info__hide><hide-camera media=media class=photo-exif-info__item__camera-info__hide-icon></hide-camera></div><div class=photo-exif-info__item__camera-info__first-prop>{{media.camera.lens_model}}</div><div class=photo-exif-info__item__camera-info__second-prop>{{media.camera.takenInfo}}</div></div><div class=\"photo-exif-info__item photo-exif-info__item__date-time\"><div class=photo-exif-info__item__row><label class=photo-exif-info__item__title translate>{{\'location\'}}</label><div class=photo-exif-info__item__description>{{media.location.formatted_address ? media.location.formatted_address : media.location}}</div></div><div class=photo-exif-info__item__row><label class=photo-exif-info__item__title translate>{{\'date-taken\'}}</label><div class=photo-exif-info__item__description>{{media.camera.imageCapturedDateFormated}}</div></div><div class=photo-exif-info__item__row><label class=photo-exif-info__item__title translate>{{\'date-uploaded\'}}</label><div class=photo-exif-info__item__description>{{media.createdAtFormated}}</div></div></div><div class=\"photo-exif-info__item photo-exif-info__item__others\"><div class=photo-exif-info__item__row><label class=photo-exif-info__item__title translate>{{\'photo-id\'}}</label><div class=photo-exif-info__item__description>{{media.id}}</div></div><div class=photo-exif-info__item__row><label class=photo-exif-info__item__title translate>{{\'release-info\'}}</label><div class=photo-exif-info__item__description>{{vm.buildPhotoReleaseInfo(media)}}</div></div></div></div></div></div>");
$templateCache.put("app/components/photo-grid/photo-grid.html","<div class=photo-grid on-window-resize-event=vm.onWindowResize() on-orientation-change-event=vm.onOrientationChange() ng-class=\"{\'photo-grid--fresh\': vm.isFresh && vm.spinner.isVisible}\"><div infinite-scroll-distance=0.5 class=\"clearfix photo-grid__photos-container\" infinite-scroll-disabled=vm.isNoMorePhotoToLoad infinite-scroll=vm.fetchMorePhotos() infinite-scroll-immediate-check=false infinite-scroll-container=vm.containerClass></div><ng-transclude class=ng-hide ng-hide=\"vm.photos.length > 0 || vm.spinner.isVisible\"></ng-transclude><scroll-paging spinner=vm.spinner show-message=\"!hideNoMoreMessage && vm.photos.length > 0\" hide-back-to-top=\"vm.totalPage < 2\" is-last-page=vm.isNoMorePhotoToLoad message=\"{{\'no-more-photos\' | translate}}\"></scroll-paging></div>");
$templateCache.put("app/components/photo-grid-pager/photo-grid-pager.html","<form ng-submit=\"onCurrentPageChanged({pageNumber: page})\" class=photo-grid-pager><!-- <span class=\"photo-grid-pager__page-total-photos\"><span class=\"text--bold text--color-black\">{{isShownNumPhotos ? totalPhotos : totalPhotoText}}</span> <span class=\"photo-grid-pager__item-unit\"> {{unit ? unit : (totalPhotos === 1 ? \'Photo\' : \'Photos\')}}</span></span> --> <span class=photo-grid-pager__page-text translate>{{\'page\'}}</span> <input ng-disabled=spinner.isVisible parse-integer number-range=\"{{\'[1,\' + totalPage  + \']\'}}\" class=photo-grid-pager__page-number-input ng-model=page> <span class=photo-grid-pager__page-total-page_pretext translate>{{\'of\'}}</span> <span class=\"photo-grid-pager__page-total-page__number text--bold\">{{totalPage}}</span> <span ng-if=isShowPageText class=photo-grid-pager__page-total-page-posttext translate>{{totalPage === 1 ? \'page\' : \'pages\'}}</span></form>");
$templateCache.put("app/components/photo-info-link/photo-info-link.html","<div class=photo-info-link><div translate>{{\'photo-by\'}}</div><a class=text--bold ui-sref=\"user-home-page.personal.home({id: photo.user.id, userName: (photo.user.name | toSnakeCase)})\">{{photo.user.name}}</a><br><!-- <a ui-sref=\"photo({id: photo.id, photoTitle: (photo.title + \' by \' + photo.user.name | toSnakeCase)})\" target=\"_blank\">{{photo.title}}</a> --><!--<a >{{photo.title}}</a>--></div>");
$templateCache.put("app/components/photo-license-deternimation-questions/photo-license-deternimation-questions.html","<div class=\"clearfix photo-license-deternimation-questions\"><div class=photo-license-deternimation-questions__question><label ng-class=\"{\'pixerf-invalid\': isRequired && !media.license}\" class=\"text--semibold text--color-black-2\" for=\"\" translate>{{\'upload-apply-commercial-license\'}} <span class=icon-icons-info ng-if=!curateMode tooltip-append-to-body=true tooltip-class=photo-license-deternimation-questions__tooltips tooltip-placement=top uib-tooltip=\"Photos available for Commercial licensing tend to be more popular with brands and agencies.\"></span></label><table><tr class=photo-license-deternimation-questions__question__answer><td><pixerf-radio-btn data-radio-id=license-commercial is-required=true value=\"\'commercial\'\" model=media property=license on-changed=\"onQuestionAnswered({evt: evt, \'question\':\'COMMERCIAL?\'})\"></pixerf-radio-btn></td><td class=photo-license-deternimation-questions__question__answer__text><label pixerf-radio-btn-data-toogle=license-commercial class=\"text--color-black-2 cursor--pointer\"><span translate>{{\'yes\'}}</span> <span class=\"photo-license-deternimation-questions__question__user-selection text--color-blue\" ng-if=\"curateMode && media.user_selection.license===\'commercial\'\">(User original answer)</span></label></td></tr><tr class=photo-license-deternimation-questions__question__answer><td><pixerf-radio-btn data-radio-id=license-editorial is-required=true value=\"\'editorial\'\" model=media property=license on-changed=\"onQuestionAnswered({evt: evt, \'question\': \'NOT_COMMERCIAL?\'})\"></pixerf-radio-btn></td><td class=photo-license-deternimation-questions__question__answer__text><label pixerf-radio-btn-data-toogle=license-editorial class=\"text--color-black-2 cursor--pointer\"><span translate>{{\'upload-no-commercial-license\'}}</span> <span class=\"photo-license-deternimation-questions__question__user-selection text--color-blue\" ng-if=\"curateMode && media.user_selection.license===\'editorial\'\">(User original answer)</span></label></td></tr></table></div><div class=\"photo-license-deternimation-questions__question photo-license-deternimation-questions__question__commercial\" ng-show=\"media.license === \'commercial\'\"><label ng-class=\"{\'pixerf-invalid\': isRequired && media.has_model_property === null }\" class=\"text--semibold text--color-black-2\" for=\"\">Does your photo require a model and/or property release?</label><table><tr class=photo-license-deternimation-questions__question__answer><td><pixerf-radio-btn data-radio-id=release-form-yes is-required=true value=true model=media property=has_model_property on-changed=\"onQuestionAnswered({evt: evt, \'question\':\'NEED_RELEASE_FORM?\'})\"></pixerf-radio-btn></td><td class=photo-license-deternimation-questions__question__answer__text><label pixerf-radio-btn-data-toogle=release-form-yes class=\"text--color-black-2 cursor--pointer\"><span>Yes</span> <span class=\"photo-license-deternimation-questions__question__user-selection text--color-blue\" ng-if=\"curateMode && media.user_selection.license===\'commercial\' && media.user_selection.has_model_property\">(User original answer)</span></label><ul ng-if=\"curateMode && media.releases.length > 0\" class=photo-release-form-selection__dropdown__items><li ng-repeat=\"releaseForm in media.releases\" role=menuitem><span class=photo-release-form-selection__dropdown__item>{{releaseForm.filename}}</span> - <span ng-class=\"{\'text--color-error\': media.status===\'rejected\', \'text--color-good\': media.status===\'approved\'}\">{{media.status | toTitleCase}}</span></li></ul></td></tr><tr class=photo-license-deternimation-questions__question__answer><td><pixerf-radio-btn data-radio-id=release-form-no is-required=true value=false model=media property=has_model_property on-changed=\"onQuestionAnswered({evt: evt, \'question\':\'NO_NEED_RELEASE?\'})\"></pixerf-radio-btn></td><td class=photo-license-deternimation-questions__question__answer__text><label pixerf-radio-btn-data-toogle=release-form-no class=\"text--color-black-2 cursor--pointer\"><span>No</span> <span class=\"photo-license-deternimation-questions__question__user-selection text--color-blue\" ng-if=\"curateMode && media.user_selection.license===\'commercial\' && !media.user_selection.has_model_property\">(User original answer)</span> <span ng-if=!curateMode class=icon-icons-info tooltip-append-to-body=true tooltip-class=photo-license-deternimation-questions__tooltips tooltip-placement=top uib-tooltip=\"Only select this option if there are no people or private properties in your photo.\"></span></label></td></tr></table></div></div>");
$templateCache.put("app/components/photo-license-info/photo-license-info.html","<div class=photo-license-info><table class=table><tr><th class=relative><span class=\"photo-license-info__text photo-license-info__license-label\" translate>{{\'editorial\'}}</span><span class=icon-icons-info tooltip-class=\"photo-license-tooltip photo-license-tooltip-editorial\" tooltip-trigger=\"\'outsideClick\'\" tooltip-append-to-body=true uib-tooltip-template=\"\'photo-license-tooltip-template-editorial\'\"></span></th><td class=\"photo-license-info__text text-right text--bold class-1\" translate>{{\'yes\'}}</td></tr><tr ng-if=\"(photo.license === \'commercial\' && (vm.hasModelProperty(photo.has_model_property))) ||  photo.license === \'editorial\' ||  vm.isMultipleLicense(photo.license)\"><th class=relative><span class=\"photo-license-info__text photo-license-info__license-label\" translate>{{\'commercial\'}} </span><span class=icon-icons-info tooltip-class=\"photo-license-tooltip photo-license-tooltip-commercial\" tooltip-trigger=\"\'outsideClick\'\" tooltip-append-to-body=true uib-tooltip-template=\"\'photo-license-tooltip-template-commercial\'\"></span></th><td ng-show=\'!vm.isMultipleLicense(photo.license) && (photo.license === \"editorial\")\' class=\"photo-license-info__text text-right text--bold class-2\" translate>{{\'no\'}}</td><td ng-show=vm.isMultipleLicense(photo.license) class=\"photo-license-info__text text-right text--bold class-2\" translate>{{\'multiple-lincense\'}}</td><td class=\"photo-license-info__text text-right text--bold class-3\" ng-show=\'!vm.isMultipleLicense(photo.license) && (photo.license === \"commercial\" && ((photo.has_model_property && photo.status === \"approved\") || photo.has_model_property === false))\'>{{ vm.getCommercialStatus() | translate}}<request-license-btn ng-show=vm.showDownloadRelease() media=photo class=\"pixerf-link pixerf-link--color-theme\">{{ \'download-release\' | translate}}</request-license-btn></td><td class=\"photo-license-info__text text-right text--bold class-4\" ng-show=\'!vm.isMultipleLicense(photo.license) && (photo.license === \"commercial\" && photo.has_model_property && photo.status !== \"approved\")\'><div tooltip-class=photo-license-tooltip tooltip-trigger=\"\'outsideClick\'\" tooltip-append-to-body=true uib-tooltip-template=\"\'photo-license-pending-review-tooltip-template\'\" class=pixerf-link--color-blue>{{ vm.getCommercialStatus() | translate}}</div><request-license-btn ng-show=vm.showDownloadRelease() media=photo class=\"pixerf-link pixerf-link--color-theme\">{{ \'download-release\' | translate}}</request-license-btn></td></tr><tr ng-if=\"vm.loginnedUser && vm.loginnedUser.canCurate\" class=photo-license-info__text ng-show=\'photo.license === \"commercial\" && (photo.has_model_property ) && !(photo.releases && photo.releases.length)\'><th></th><td class=\"pixerf-link pixerf-link--color-theme request-release-form text--semibold text-right\" ng-click=vm.onRequestReleaseFormBrnclicked(photo)>Request release form</td></tr></table><div class=photo-license-info__request-license-btn-wrapper ng-if=\"photo.license === \'editorial\' && photo.isMine\"><request-license-btn ng-show=vm.loginnedUser media=photo class=\"pixerf-link pixerf-link--color-theme\">{{\'request-for-commercial-licensing\' | translate}}</request-license-btn></div><script type=text/ng-template id=photo-license-pending-review-tooltip-template><div class=\"tag-template\">\r\n            Our curators are currently reviewing the release forms for this photo. <a ui-sref=\"introduction-support.faq.personal({section: \'licensing\'})\"\r\n                target=\"_blank\" class=\'text--color-pixerf-theme text--bold\'>{{\'learn-more\' | translate}}.</a>\r\n        </div></script><script type=text/ng-template id=photo-license-tooltip-template><div class=\"tag-template\">\r\n            <span ng-bind=\"photo.status !== \'pending\' && photo.status !== \'rejected\' &&  photo.license === \'editorial\' ? (\'tool-tip-editorial\' | translate) : photo.status !== \'pending\' && photo.status !== \'rejected\' &&  photo.license === \'commercial\' ? (\'tool-tip-commercial\' | translate) : \'\'\"></span>\r\n            <a  ui-sref=\"introduction-support.faq.personal({section: \'licensing\'})\" target=\"_blank\" class=\'text--color-pixerf-theme text--bold\' pixerf-close-on-click=\"true\"> {{\'learn-more\' | translate}}.</a>\r\n        </div></script><script type=text/ng-template id=photo-license-tooltip-template-commercial><div class=\"tag-template\">\r\n            <span translate>{{\'tool-tip-commercial\'}}</span>\r\n            <a ui-sref=\"introduction-support.faq.personal({section: \'licensing\'})\" target=\"_blank\" class=\'text--color-pixerf-theme text--bold\' pixerf-close-on-click=\"true\"> {{\'learn-more\' | translate}}.</a>\r\n        </div></script><script type=text/ng-template id=photo-license-tooltip-template-editorial><div class=\"tag-template\">\r\n            <span translate>{{\'tool-tip-editorial\'}}</span>\r\n            <a\r\n            ui-sref=\"introduction-support.faq.personal({section: \'licensing\'})\" target=\"_blank\" class=\'text--color-pixerf-theme text--bold\' pixerf-close-on-click=\"true\"> {{\'learn-more\' | translate}}.</a>\r\n        </div></script></div>");
$templateCache.put("app/components/photo-original-size/photo-original-size.html","<div class=photo-original-size><div class=\"clearfix photo-original-size__item\"><div class=\"pull-left no-padding\"><div class=\"photo-original-size__item__dimension-title text--semibold text--color-black-2\">{{photo.price.range[photo.price.range.length - 1].title}}<span uib-tooltip-html=\"photo.price.range[photo.price.range.length - 1].toolTips\" tooltip-append-to-body=true class=icon-icons-info tooltip-class=photo-original-size__item__tooltips tooltip-placement=auto></span></div><div class=photo-original-size__item__dimension-description>{{photo.price.range[photo.price.range.length - 1].description}}</div></div></div></div>");
$templateCache.put("app/components/photo-price-extended-license-selection/photo-price-extended-license-selection.html","<div class=photo-price-extended-license-selection><div ng-repeat=\"license in photo.extendedLicenses\" ng-class=\"{\'photo-price-extended-license-selection__item--disabled\': license.isDisabled}\" class=\"clearfix photo-price-extended-license-selection__item relative\"><pixerf-checkbox is-disabled=\"license.isDisabled || isDisabled\" model=license model-property=isSelected on-changed=\"vm.onLicenseItemSelectionChanged(evt, license)\"></pixerf-checkbox><label>{{license.title | translate}}<span uib-tooltip-html=\"license.tooltips | translate\" tooltip-append-to-body=true class=icon-icons-info tooltip-class=photo-price-extended-license-selection__item__tooltips tooltip-placement=auto></span></label><div class=\"pull-right text--color-black col-md-3 no-padding text-right\">SGD <span class=text--bold>{{license.price}}</span></div></div></div>");
$templateCache.put("app/components/photo-price-selection/photo-price-selection.html","<div class=photo-price-selection><div uib-dropdown><button ng-disabled=isDisabled type=button class=\"photo-price-selection__btn-select-price btn btn--white btn-block text-left\" uib-dropdown-toggle>{{selectedModel ? (selectedModel !== \'Multiple prices\' ? selectedModel.displayValue : selectedModel) : \'Select Large photo price\'}} <span class=\"caret pull-right\"></span></button><ul class=dropdown-menu uib-dropdown-menu role=menu aria-labelledby=single-button><li ng-click=\"vm.onItemClicked(price, $event)\" ng-repeat=\"price in vm.pricesList\" role=menuitem><a class=photo-price-selection__dropdown__price-item>{{price.displayValue}}</a></li></ul></div><p ng-if=settings.isShownSubscribeText class=photo-price-selection__description><a ui-sref=introduction-pixerfer.subscriptions.personal target=_blank><span class=\"text--color-pixerf-theme text--bold\">{{\'subscribe\' | translate}} </span></a><span translate translate-values=\"{number: 5}\">{{\'to-sell-your-photos-at-different-price\'}}</span></p></div>");
$templateCache.put("app/components/photo-price-size-selection/photo-price-size-selection.html","<div class=photo-price-size-selection ng-class=\"{\'layout-horizontal clearfix\': vm.layoutHorizontal}\"><div class=\"clearfix photo-price-size-selection__item\" ng-if=!vm.layoutHorizontal ng-repeat=\"price in photo.price.range\"><div class=\"pull-left col-md-1 col-xs-1 no-padding\" ng-if=!isReadonly ng-click=\"vm.onPriceItemClicked($event, price)\" ng-class=\"{\'icon-icons-bullet--checked\' : price.isSelected, \'icon-icons-bullet\': !price.isSelected}\"></div><div class=\"pull-left col-md-8 col-xs-8 no-padding\"><div class=\"photo-price-size-selection__item__dimension-title text--bold text--color-black\"><span class=photo-price-size-selection__item__dimension-title-text>{{\'size-\' + price.title.toLowerCase() | translate}}</span> <span uib-tooltip-html=price.toolTips tooltip-append-to-body=true class=icon-icons-info tooltip-class=photo-price-size-selection__item__tooltips tooltip-placement=auto></span> <span ng-if=\"price.title.toLowerCase() === \'x-small\'\" class=photo-price-size-selection__item__new-label>New!</span></div><div class=photo-price-size-selection__item__dimension-description>{{price.description}}</div></div><div class=\"pull-right text--color-black col-xs-3 col-md-3 no-padding text-right\">SGD <span class=text--bold>{{price.price}}</span></div></div><div ng-if=vm.layoutHorizontal><div class=\"clearfix photo-price-size-selection__item-wrapper\"><div class=\"text--color-black text-right pull-right photo-price-size-selection__item__price\">SGD <span class=text--bold>{{vm.selectedPrice.price}}</span></div><div class=\"clearfix photo-price-size-selection__item text--semibold\" ng-class=\"{\'photo-price-size-selection__item--selected\' : priceItem.isSelected}\" ng-repeat=\"priceItem in photo.price.range\" ng-click=\"vm.onPriceItemClicked($event, priceItem)\">{{priceItem.size}}</div></div><div class=photo-price-size-selection__item__dimension-description>{{vm.selectedPrice.description}}</div></div></div>");
$templateCache.put("app/components/photo-release-form-selection/photo-release-form-selection.html","<div class=photo-release-form-selection><div class=form-group><div class=clearfix><label ng-class=\"{\'text--color-pixerf-theme\' : file.has_model_property && file.releases.length === 0}\" class=\"text--bold pull-left\" for=\"\">Attach photo release form(s)</label><!--<div class=\"icon-icons-info pull-left\" tooltip-trigger=\"\'outsideClick\'\" uib-tooltip-template=\"\'pixerf-upload-photo-release-template\'\"></div>--></div><form ng-if=\"file.status !== \'approved\'\" class=\"photo-release-form-selection__photo-release-btns clearfix\" pixerf-dropzone dropzone=vm.dropzoneConfig.instance dropzone-config=vm.dropzoneConfig.options event-handlers=vm.dropzoneConfig.eventHandlers><button ng-click=\"vm.onUploadFormBtnClicked(\'model\')\" class=\"btn btn--white\"><span class=icon-icons_plus></span><span class=photo-release-form-selection__photo-release-btns__btn-label>Model</span></button> <button ng-click=\"vm.onUploadFormBtnClicked(\'property\')\" class=\"btn btn--white\"><span class=icon-icons_plus></span><span class=photo-release-form-selection__photo-release-btns__btn-label>Property</span></button></form></div><div class=photo-release-form-selection__dropdown ng-if=\"file.status !== \'approved\'\"><div uib-dropdown><button ng-disabled=isDisabled type=button class=\"photo-release-form-selection__btn-dropdown btn btn--white btn-block text-left\" uib-dropdown-toggle>Select existing release form<span class=\"caret pull-right\"></span></button><div class=dropdown-menu uib-dropdown-menu role=menu aria-labelledby=single-button><div class=photo-release-form-selection__dropdown__search-text-box><span class=\"photo-release-form-selection__dropdown__search-icon icon-icon-search-2 vertical-align-middle--transform\"></span> <input ng-click=$event.stopPropagation() ng-model=vm.searchReleaseFormText class=\"form-control photo-release-form-selection__dropdown__search-text-box__input\" placeholder=\"Search release form\"></div><div class=photo-release-form-selection__dropdown__items><div ng-click=\"$event.stopPropagation(); vm.isCollapsed[\'model\'] = !vm.isCollapsed[\'model\']\" class=\"text--bold photo-release-form-selection__dropdown__item__form-type-title\"><span ng-class=\"{\'icon-icons_plus\': vm.isCollapsed[\'model\'], \'icon-icons_minus\': !vm.isCollapsed[\'model\']}\"></span>Model Release</div><div uib-collapse=\"vm.isCollapsed[\'model\']\"><div class=photo-release-form-selection__empty-list ng-if=\"vm.userReleaseForms[\'model\'].length === 0\">You haven\'t uploaded any model release forms yet.</div><div class=photo-release-form-selection__dropdown__item ng-repeat=\"releaseForm in vm.userReleaseForms[\'model\'] | searchStringFilter:vm.searchReleaseFormText:\'filename\'\" ng-class=\"{\'photo-release-form-selection__dropdown__item--selected\': releaseForm.isSelected}\" ng-click=\"vm.onItemClicked(releaseForm, $event)\" role=menuitem><span ng-show=releaseForm.isSelected class=\"photo-release-form-selection__dropdown__item__tick-icon icon-icons_check\"></span><span>{{releaseForm.filename}}</span></div></div></div><div class=photo-release-form-selection__dropdown__items><div ng-click=\"$event.stopPropagation(); vm.isCollapsed[\'property\'] = !vm.isCollapsed[\'property\']\" class=\"text--bold photo-release-form-selection__dropdown__item__form-type-title\"><span ng-class=\"{\'icon-icons_plus\': vm.isCollapsed[\'property\'], \'icon-icons_minus\': !vm.isCollapsed[\'property\']}\"></span>Property Release</div><div uib-collapse=\"vm.isCollapsed[\'property\']\"><div class=photo-release-form-selection__empty-list ng-if=\"vm.userReleaseForms[\'property\'].length === 0\">You haven\'t uploaded any property release forms yet.</div><div class=photo-release-form-selection__dropdown__item ng-repeat=\"releaseForm in vm.userReleaseForms[\'property\']\" ng-class=\"{\'photo-release-form-selection__dropdown__item--selected\': releaseForm.isSelected}\" ng-click=\"vm.onItemClicked(releaseForm, $event)\" role=menuitem><span ng-show=releaseForm.isSelected class=\"photo-release-form-selection__dropdown__item__tick-icon icon-icons_check\"></span><span>{{releaseForm.filename}}</span></div></div></div></div></div></div><div class=photo-release-form-selection__selected-release-forms-wrapper><ul><li class=\"text-left photo-release-form-selection__selected-release-forms__item\" ng-repeat=\"releaseForm in file.releases\"><span class=\"text--truncate photo-release-form-selection__selected-release-forms__item__form-name\">{{releaseForm.filename}}</span><div class=photo-release-form-selection__selected-release-forms__item__tool-wrapper><span title=\"Uploading ...\" class=photo-release-form-selection__selected-release-forms__item__upload-progress ng-show=\"releaseForm.upload && releaseForm.upload.progress < 100\"><pixerf-loading-indicator></pixerf-loading-indicator></span><span ng-if=\"file.status !== \'approved\'\" title=Remove class=icon-icons_close ng-click=vm.onRemoveBtnClick(releaseForm)></span></div></li></ul></div><div id=photo-release-form-previews class=ng-hide><!--<script type=\"text/ng-template\" id=\"pixerf-upload-photo-release-template\">\r\n      <div class=\"tag-template\">\r\n            Models and private property owners need to give you permission to use them in commercial photos.<a href=\"#/introduction/support/faq/licensing\" target=\"_blank\" class=\'text--color-pixerf-theme text--bold\'> Learn more.</a>\r\n      </div>\r\n    </script>--></div>");
$templateCache.put("app/components/photo-usage/photo-usage.html","<div class=photo-usage-dropdown><div uib-dropdown><button ng-disabled=isDisabled ng-class=\"{\'text--color-black\': file.license}\" class=\"btn btn--white photo-usage-dropdown__btn-license\" uib-dropdown-toggle type=button>{{file.license ? file.license.charAt(0).toUpperCase() + file.license.substr(1) : \'Select\'}} <span class=caret></span></button><ul class=dropdown-menu uib-dropdown-menu role=menu aria-labelledby=single-button><li class=clearfix ng-click=vm.onItemClicked(usage) role=menuitem ng-repeat=\"usage in vm.photoUsages\"><div ng-class=\"usage.isSelected ? \'icon-icons-bullet--checked\': \'icon-icons-bullet\'\" class=col-md-1></div><div class=\"col-md-10 photo-usage-dropdown__display-text\"><a ng-class=\"usage.isSelected ? \'text--color-pixerf-theme\' : \'text--color-black\'\">{{usage.name}}</a><p class=photo-usage-dropdown__license-description ng-bind-html=usage.description></p></div></li></ul></div></div>");
$templateCache.put("app/components/photo-viewer/photo-viewer.html","<div class=\"photo-viewer text-center relative\" upload-photo-preview-scale><div class=upload-photo-preview__overlay event-right-click><div class=photo__tools-wrapper><div class=photo__tools-wrapper__left ng-if=\"vm.loginUser && vm.loginUser.canCurate\"><pixerf-photo-state-btn need-review-license=true ng-click=$event.stopPropagation() class=\"photo__tools photo__tools--left\" pixerf-photo-state-btn-state=g pixerf-photo-state-btn-media=photo title=\"Move to General\"></pixerf-photo-state-btn><pixerf-photo-state-btn ng-click=$event.stopPropagation() class=\"photo__tools photo__tools--left\" pixerf-photo-state-btn-state=h pixerf-photo-state-btn-media=photo title=\"Move to Pending\"></pixerf-photo-state-btn><pixerf-photo-state-btn need-review-license=true ng-click=$event.stopPropagation() class=\"photo__tools photo__tools--left\" pixerf-photo-state-btn-state=d pixerf-photo-state-btn-media=photo title=\"Move to Discover\"></pixerf-photo-state-btn><pixerf-photo-state-btn need-review-license=true ng-click=$event.stopPropagation() class=\"photo__tools photo__tools--left\" pixerf-photo-state-btn-state=t pixerf-photo-state-btn-media=photo title=\"Move to Trending\"></pixerf-photo-state-btn><star-btn is-show-tooltip=true class=\"photo__tools photo__tools--left photo__tools__star-btn\" target=photo ng-click=$event.stopPropagation() hover-show-number=true></star-btn><pixerf-photo-state-btn is-need-confirm=\"photo.state !==\'h\' && photo.state !==\'r\'\" need-review-license=\"!!photo.user.ambassadorship && (photo.state ===\'h\' || photo.state ===\'r\')\" ng-if=\"vm.loginUser && (vm.loginUser.isAdminInternal) && (!!photo.user.ambassadorship || (!photo.user.ambassadorship && photo.state !==\'h\' && photo.state !==\'r\'))\" ng-click=$event.stopPropagation() class=\"photo__tools photo__tools--left\" pixerf-photo-state-btn-state=e pixerf-photo-state-btn-media=photo title=\"Set as Editor\'s Pick\"></pixerf-photo-state-btn></div><div class=photo__tools-wrapper__right ng-if=\"vm.loginUser && (vm.loginUser.canCurate)\"><pixerf-photo-state-btn ng-click=$event.stopPropagation() class=photo__tools pixerf-photo-state-btn-state=r pixerf-photo-state-btn-media=photo ng-attr-title=\"{{photo.state===\'r\' && photo.reject_reason ? \'Reject Reason: \' + photo.reject_reason : \'Reject this photo\'}}\"></pixerf-photo-state-btn></div><div class=photo-viewer__toolbar ng-if=\"photo.isMine && false\"><div class=photo-viewer__toolbar__reset-btn ng-show=\"vm.originRotateStep !== vm.rotateStep\"><span ng-click=vm.resetRotation()>Reset</span></div><div class=photo-viewer__toolbar__rotate-btn ng-click=vm.rotatePhoto()><div><div class=icon-icons-rotate></div><div class=\"photo-viewer__toolbar__rotate-btn__label text--bold\">Rotate</div></div></div><div class=photo-viewer__toolbar__save-btn><button ng-disabled=vm.isWorking ng-click=vm.saveRotation() class=\"btn btn-submit\" ng-show=\"vm.originRotateStep !== vm.rotateStep\">Save</button></div></div></div></div><a ng-disabled=!vm.isLastPrev ng-if=vm.showNavigateBtn ng-click=\"vm.isLastPrev && vm.navigate(\'prev\')\" class=\"photo-viewer__photo-navigator photo-viewer__photo-navigator__prev-photo\" ng-class=\"{\'disabled\': !vm.isLastPrev}\"><span class=icon-icons_chevron-left></span> </a><img ng-attr-alt={{photo.title}} scale-image ng-src={{photo.url}} refit-image-after-rotating=true img-orientation-original-style img-orientation=vm.rotateStep image-onloaded=photoLoaded> <a ng-disabled=!vm.isLastNext ng-if=vm.showNavigateBtn event-key on-key-pressed=vm.logKey ng-click=\"vm.isLastNext && vm.navigate(\'next\')\" class=\"photo-viewer__photo-navigator photo-viewer__photo-navigator__next-photo\" ng-class=\"{\'disabled\': !vm.isLastNext}\"><span class=icon-icons_chevron-right></span></a></div>");
$templateCache.put("app/components/photographer/photographer.html","<div class=\"photographer clearfix\"><div class=\"photographer__col-left-most-wrapper clearfix relative\"><div class=\"vertical-align-middle--transform text-center photographer__col-left-most-wrapper__ranking-info\" ng-if=!isHideRanking><div class=crown-icon ng-if=\"rank == 1 || rank == 2 || rank == 3\"><span class=photographer__icon-rank ng-class=\"{\'photographer__icon-rank--1\': rank == 1, \'photographer__icon-rank--2\': rank == 2, \'photographer__icon-rank--3\': rank == 3 }\"></span></div><div ng-class=\"{\'photographer__col-left-most-wrapper__ranking-info__rank-no--highlighted\': rank < 31 && highlightTop}\" class=\"photographer__col-left-most-wrapper__ranking-info__rank-no text--bold\">{{rank}}</div><div ng-if=\"unit !== \'earnings\'\" class=\"photographer__col-left-most-wrapper__ranking-info__rank-score text--bold\">{{item.leaderboard[unit] | number:0}}</div><div ng-if=\"unit === \'earnings\'\" class=photographer__col-left-most-wrapper__ranking-info__rank-unit><div class=\"photographer__col-left-most-wrapper__ranking-info__rank-score text--bold\">{{item.leaderboard[\'earning_from_photos\'] | number:0}}</div><div>from photos</div><div class=\"photographer__col-left-most-wrapper__ranking-info__rank-score text--bold\">{{item.leaderboard[\'earning_from_missions\'] | number:0}}</div><div>from missions</div></div><div ng-if=\"unit !== \'earnings\'\" class=photographer__col-left-most-wrapper__ranking-info__rank-unit>{{item.leaderboard[unit] === 1 ? unit.substr(0, unit.length - 1) : unit }}</div></div><div class=\"vertical-align-middle--transform text-center photographer__col-left-most-wrapper__number-info\" ng-if=isHideRanking><div class=\"photographer__col-left-most-wrapper__number-no text--bold\">{{number}}</div></div></div><div class=\"photographer__col-avatar vertical-align-middle--transform\"><div class=photographer__avatar><a ui-sref=\"user-home-page.personal.home({id: item.id, userName: (item.displayName | toSnakeCase)})\" class=clearfix><pixerf-user-avatar user-data=item lazy=true></pixerf-user-avatar></a></div></div><div class=\"photographer__col-photo relative clearfix\"><div class=\"photographer__col-photo__inner-wrapper vertical-align-middle--transform\"><div class=photographer__photo ng-repeat=\"photo in item.media\"><photo on-photo-popup-closed=\"vm.onPhotoPopupClosed(originalFile, newFile)\" display-size=thumbnail file=photo options=\"{\'hideCuratorBtns\': true, \'hideAddToGallery\': true, \'hidePhotoInfo\': true, \'hideLike\': true}\"></photo></div></div></div><div class=\"photographer__col-left-wrapper clearfix\"><div class=photographer__col-left-wrapper__inner-wrapper><div class=photographer__col-author><div class=\"photographer__author__name text--bold text--truncate\"><a class=text--color-black ui-sref=\"user-home-page.personal.home({id: item.id, userName: (item.displayName | toSnakeCase)})\">{{item.displayName}}</a></div><div class=\"photographer__author__level text--color-black text--truncate text--bold\">{{!!item.ambassadorship ? (\'Ambassador \' + item.ambassadorship) : \'Pixerfer\' | toTitleCase}}</div><div class=\"photographer__author__country text--truncate\">{{item.address.country ? item.address.country : item.location | isoCountry}}</div><follow-btn class=photographer__follow-btn user=item></follow-btn><suggest-btn user=item></suggest-btn></div></div><div class=photographer__col-badges><pixerf-badges popup-detail=true badges=item.badges></pixerf-badges></div></div></div>");
$templateCache.put("app/components/photographer-tile/photographer-tile.html","<div class=\"photographer-tile clearfix\"><div class=\"photographer-tile__header clearfix\"><div class=\"photographer-tile__overall clearfix\"><div class=\"photographer-tile__avatar clearfix\"><a ui-sref=\"user-home-page.personal.home({id: item.id, userName: (item.displayName | toSnakeCase)})\" class=clearfix target=_blank><pixerf-user-avatar user-data=item lazy=true></pixerf-user-avatar></a></div><!-- <div class=\"photographer-tile__rating\"><span class=\"text--bold texdt--color-black\">4</span>/5</div> --></div><div class=\"photographer-tile__info clearfix\"><div class=\"photographer-tile__author__name text--bold text--truncate\"><a class=text--color-black ui-sref=\"user-home-page.personal.home({id: item.id, userName: (item.displayName | toSnakeCase)})\" target=_blank>{{item.displayName}}</a></div><div class=\"photographer-tile__author__level text--color-black text--truncate text--bold\">{{!!item.ambassadorship ? (\'Ambassador \' + item.ambassadorship) : \'Pixerfer\' | toTitleCase}}</div><div class=\"photographer-tile__author__country text--truncate\">{{item.address.country ? item.address.country : item.location | isoCountry}}</div><suggest-btn user=item ng-if=\"vm.loginnedUser && vm.loginnedUser.canCurate\"></suggest-btn><div class=\"photographer-tile__status clearfix\"><follow-btn class=photographer-tile__follow-btn user=item></follow-btn><div class=photographer-tile__available>{{item.is_available_for_cc ? \'Available for Hire\' : \'\'}}</div></div></div></div><div class=photographer-tile__description><div class=photographer-tile__badges><pixerf-badges popup-detail=true badges=item.badges></pixerf-badges></div><div class=\"photographer-tile__feature-photo clearfix\"><div class=\"photographer-tile__photo clearfix\" ng-repeat=\"photo in item.media\"><photo on-photo-popup-closed=\"vm.onPhotoPopupClosed(originalFile, newFile)\" display-size=thumbnail file=photo options=\"{\'hideCuratorBtns\': true, \'hideAddToGallery\': true, \'hidePhotoInfo\': true, \'hideLike\': true}\"></photo></div></div></div></div>");
$templateCache.put("app/components/photographer-grid/photographer-grid.html","<div class=photographer-grid><div class=\"photographer-grid__photographers-wrapper clearfix\" infinite-scroll-distance=0.3 infinite-scroll-disabled=vm.isLastPage infinite-scroll=vm.fetchMore() infinite-scroll-immediate-check=false><div class=\"photographer-item-wrapper relative clearfix\" ng-repeat=\"photographer in vm.photographers\"><photographer-tile item=photographer></photographer-tile></div><scroll-paging hide-back-to-top=true spinner=vm.spinner show-message=!!endingMessage message={{endingMessage}} is-last-page=vm.isLastPage></scroll-paging></div><div class=\"photographer-grid__photographers__empty-state text--semibold text--color-black\" ng-if=\"vm.photographers.length === 0\">Oops! It looks like there are no photographers listed.</div></div>");
$templateCache.put("app/components/pixerf-animation-carousel/pixerf-animation-carousel.html","<div class=pixerf-animation-carousel id=carousel-{{instance}}><div class=\"pixerf-slick-nav prev-slide-nav clearfix\"><div class=\"pixerf-slick-prev icon-icons_chevron-left\"></div></div><div class=\"pixerf-slick-nav next-slide-nav clearfix\"><div class=\"pixerf-slick-next icon-icons_chevron-right\"></div></div><slick class=pixerf-animation-carousel__slick id={{instance}} infinite={{vm.config.infinite}} slides-to-show={{vm.config.slidesToShow}} slides-to-scroll={{vm.config.slidesToScroll}} on-init=vm.config.event.init({slick}) responsive=vm.config.responsive dots={{vm.config.dots}} init-onload=true data=vm.datas next-arrow=\"#carousel-{{instance}} .pixerf-slick-nav.next-slide-nav\" prev-arrow=\"#carousel-{{instance}} .pixerf-slick-nav.prev-slide-nav\"><div ng-repeat=\"data in vm.datas | limitTo: limit\"><div ng-transclude=itemTemplate></div></div></slick></div>");
$templateCache.put("app/components/pixerf-avatar/pixerf-avatar.html","<div ng-class=\"{\'pixerf-avatar--editable\': options.canEdit}\" class=\"text-center pixerf-avatar\" ng-attr-uib-tooltip=\"{{options.canEdit && options.hoverEditText ?  options.hoverEditText : null}}\" tooltip-placement=top tooltip-append-to-body=true role=button><img ng-src=\"{{avatar.url ?  avatar.url : \'/assets/images/default/community-default-avatar.png\'}}\"><div ng-if=options.canEdit class=overlay ng-click=\"vm.showUploadAvatarPopup(\'profile\')\"></div><a ng-if=\"options.canEdit && !options.hideText\" class=\"pixerf-avatar__edit-link pixerf-link--normal--hover--color-theme\" ng-click=\"vm.showUploadAvatarPopup(\'profile\')\">{{options.editText ? options.editText : (\'change-cover\' | translate)}}</a></div>");
$templateCache.put("app/components/pixerf-badges/pixerf-badges.html","<div class=\"pixerf-badges clearfix\" ng-class=\"{\'pixerf-badges--detail-mode\': showDescription}\"><div class=\"pixerf-badges__badge clearfix\" ng-repeat=\"badge in badges\"><div ng-click=vm.onBadgeClicked() class=pixerf-badges__badge__badge-icon ng-class=badge.class ng-if=\"popupDetail && ((only && only.indexOf(badge.code) !== -1) || (excludes && excludes.indexOf(badge.code) === -1) || (!only && !excludes))\"><div ng-if=badge.link popup-link-clicked={{badge.link}} class=\"pixerf-badges__badge__badge-name cursor--pointer\">{{badge.title}}</div></div><div class=pixerf-badges__badge__badge-icon ng-class=badge.class ng-if=\"!popupDetail && ((only && only.indexOf(badge.code) !== -1) || (excludes && excludes.indexOf(badge.code) === -1) || (!only && !excludes))\"><div ng-if=badge.link popup-link-clicked={{badge.link}} class=\"pixerf-badges__badge__badge-name cursor--pointer\">{{badge.title}}</div></div><div class=pixerf-badges__badge__description ng-if=showDescription><h1 class=text--bold>{{badge.title}}</h1><p>{{badge.description}}</p></div></div></div>");
$templateCache.put("app/components/pixerf-badges-popup/pixerf-badges-popup.html","<div class=\"pixerf-user-info-popup clearfix\"><div class=\"modal-header text-left\"><button type=button class=close ng-click=vm.closePopup()><span class=icon-icons_close aria-hidden=true></span></button></div><div class=\"modal-body text-left\"><pixerf-badges show-description=true badges=vm.badges></pixerf-badges></div><div class=modal-footer></div></div>");
$templateCache.put("app/components/pixerf-carousel/pixerf-carousel.html","<div class=pixerf-carousel on-window-resize-event=onElementResize()><div class=pixerf-carousel__slide><div class=pixerf-carousel__list-item><ng-transclude></ng-transclude></div></div><div ng-click=onPrevClicked() class=pixerf-carousel__prev ng-if=showIndicateButton ng-class=\"{\'disabled\': disableInspirationPrevBtn}\"></div><div ng-click=onNextClicked() class=pixerf-carousel__next ng-if=showIndicateButton ng-class=\"{\'disabled\': disableInspirationNextBtn}\"></div></div>");
$templateCache.put("app/components/pixerf-checkbox/pixerf-checkbox.html","<div class=\"pixerf-checkbox pixerf-checkbox--fake\" ng-class=\"{\'pixerf-checkbox--fake--error\': error, \'pixerf-checkbox--fake--disabled\': isDisabled, \'pixerf-checkbox--fake--checked\': isReversed ? model[modelProperty] === false : model[modelProperty] === true, \'pixerf-checkbox--fake--unknown\': model[modelProperty] === \'unknown\'}\"><div ng-if=authenticationCheck authentication-click=toogle($event) class=pixerf-checkbox__child-size></div><div ng-if=!authenticationCheck ng-click=toogle($event) class=pixerf-checkbox__child-size></div></div>");
$templateCache.put("app/components/pixerf-clients/pixerf-clients.html","<div class=pixerf-clients><slick class=pixerf-clients__carousel-inner speed=1000 autoplay-speed=2000 slides-to-show=4 touch-move=true slides-to-scroll=3 autoplay=true responsive=vm.clientSlideConfig.responsive arrows=false><div class=\"pixerf-clients__client-logo client-{{client.id}}\" ng-repeat=\"client in vm.clients\"><img ng-src={{client.url}}></div></slick></div>");
$templateCache.put("app/components/pixerf-combobox/pixerf-combobox.html","<div class=pixerf-combobox><div ng-show=!vm.isEditing>{{vm.selectedItem.label}}</div><div ng-show=vm.isEditing class=ng-hide><select class=form-control ng-change=vm.onChange() ng-model=vm.selectedItem ng-options=\"opt.label for opt in vm.options track by opt.label\" ng-required=vm.configs.isRequired name={{vm.configs.name}}><option class=ng-hide></option></select></div></div>");
$templateCache.put("app/components/pixerf-confirm-popup/pixerf-confirm-popup.html","<div class=pixerf-confirm-popup ng-class=\"{\'pixerf-confirm-popup__include-close-btn\': !vm.hideCloseBtn }\"><div ng-hide=vm.hideCloseBtn class=\"pixerf-confirm-popup__close-btn icon-close-thin\" ng-click=vm.close()></div><div class=clearfix><div class=\"modal-header text-left\"><h3 ng-hide=vm.hideTitle class=\"modal--title text--bold text--color-black text-left\">PIXERF.com says:</h3></div><div class=\"modal-body text-left\"><div compile=\"vm.message | translate\"></div><p class=pixerf-confirm-popup__confirm-text ng-hide=vm.hideConfirmText>{{vm.confirmText ? vm.confirmText : (\'are-you-sure-you-want-to-continue\' | translate)}}</p><p class=pixerf-confirm-popup__confirm-text ng-show=vm.htmlConfirmText ng-bind-html=vm.htmlConfirmText></p></div><div class=modal-footer><button ng-hide=vm.hideCancelBtn ng-click=vm.cancel() type=button class=\"btn btn-cancel\">{{vm.cancelBtnText}}</button> <button ng-disabled=vm.isWorking ng-click=vm.ok() type=button class=\"btn btn-submit\">{{vm.okBtnText}}</button></div></div></div>");
$templateCache.put("app/components/pixerf-credit-card-popup/pixerf-credit-card-popup.html","<div class=pixerf-credit-card-popup><div class=modal-header><div class=modal--title><h3 class=\"text--bold text-center\">Pay with Credit/Debit Card</h3></div><button title=Close ng-disabled=vm.isWorking type=button class=close ng-click=vm.close()><span class=icon-icons_close></span></button></div><credit-card-form error-message-builder=\"vm.settings.errorMessageBuilder(err, form)\" focus-field=vm.focusField instance=vm.settings.creditCardForm card=vm.settings.card on-submit=vm.onPayBtnClick() amount-to-pay={{vm.settings.amountToPay}}></credit-card-form><div class=modal-footer><div class=pixerf-credit-card-popup__vendor-logo><span class=pixerf-credit-card-popup__vendor-logo__vendor-name>Secured by</span> <a ng-href={{vm.settings.vendor.link}} target=__blank><img ng-src={{vm.settings.vendor.logo}}></a></div></div></div>");
$templateCache.put("app/components/pixerf-curator-reject-photo-popup/pixerf-curator-reject-photo-popup.html","<div class=pixerf-curator-reject-photo-popup><div class=clearfix><button type=button class=close ng-click=vm.closePopup()><span class=icon-icons_close aria-hidden=true></span></button><div class=\"modal-header text-left\"><h3 class=\"modal--title text--bold text--color-black text-left\">Reject Photo</h3></div><div class=\"modal-body text-center\"><div class=\"form-group pixerf-curator-reject-photo-popup__reasons\"><popover-selection-btn close-on-click=true selected-model=vm.selectedReason settings=vm.selectionSettings></popover-selection-btn></div></div><div class=modal-footer><button ng-click=vm.closePopup() type=button class=\"btn btn-cancel\">Cancel</button> <button ng-attr-title=\"{{vm.selectedReason ? \'Reject this photo\' : \'Choose reason to reject this photo\'}}\" ng-disabled=\"vm.isWorking || !vm.selectedReason || vm.file.state === \'r\'\" ng-click=vm.onRejectBtnClicked() type=button class=\"btn btn-submit\">Reject</button></div></div></div>");
$templateCache.put("app/components/pixerf-delete-media-btn/pixerf-delete-media-btn.html","<div class=\"pixerf-delete-media-btn text-center\"><div ng-click=vm.onDeletePhotoBtnClicked() ng-disabled=vm.isWorking class=\"pixerf-delete-media-btn text-center\" translate>{{pixerfDeleteMediaBtnBtnLabel}}</div></div>");
$templateCache.put("app/components/pixerf-discussion-report-popup/pixerf-discussion-report-popup.html","<div class=pixerf-discussion-report-popup><div class=clearfix><div class=\"modal-header text-left\"><h3 class=\"modal--title text--extrabold text--color-black text-left\" ng-if=!vm.stateSuccess translate translate-values=\"{thing: vm.typeReport}\">{{\'report-thing\'}}</h3><h3 class=\"modal--title text--extrabold text--color-black text-left\" ng-if=vm.stateSuccess translate>{{\'thank-you-for-making-our-ommunities-better\'}}</h3><div ng-if=vm.stateSuccess translate>{{\'We-will-review-your-report\'}}</div></div><div class=\"modal-body text-center\"><div class=\"form-group pixerf-discussion-report-popup__reasons\" ng-hide=vm.stateSuccess><pixerf-input-auto-complete name=reasons is-required=true options=vm.defaultOptions data=vm.selectionSettings.data model=vm.selectedReason dropdown-class=pixerf-discussion-report-popup__select-reasons></pixerf-input-auto-complete></div><div class=\"form-group pixerf-discussion-report-popup__desc\" ng-hide=vm.stateSuccess ng-if=vm.showDescription><textarea maxlength=2000 rows=5 name=content type=text ng-model=vm.description placeholder=\"{{\'tell-us-more\' | translate}}\" class=form-control></textarea></div></div><div class=modal-footer><button ng-click=vm.closePopup() type=button class=\"btn btn-cancel\" ng-hide=vm.stateSuccess translate>{{\'cancel\'}}</button> <button ng-attr-title=\"{{vm.selectedReason ? \'report this discussion\' : \'Choose reason to report this discussion\'}}\" ng-disabled=\"vm.isWorking || !vm.selectedReason || vm.file.state === \'r\'\" ng-click=vm.onReportBtnClicked() ng-hide=vm.stateSuccess type=button class=\"btn btn-submit\" translate>{{\'send-report\'}}</button></div></div></div>");
$templateCache.put("app/components/pixerf-group-selection-btn/pixerf-group-selection-btn.html","<div class=\"pixerf-group-selection clearfix\"><form name=groupSelectionForm><div class=\"form-group col-sm-12 no-padding pixerf-group-selection__items\" ng-repeat=\"item in vm.items\"><label class=\"pixerf-group-selection__title text--semibold text--color-black\">{{item.label}}</label><div class=pixerf-group-selection__list-selection><div class=pixerf-group-selection__list-selection__item ng-repeat=\"requimentItem in item.options\" ng-click=\"vm.onItemSelected(item, requimentItem)\"><div ng-if=\"!customField || (!$last && customField)\" class=pixerf-group-selection__item ng-class=\"requimentItem.isSelected ? \'item-selected\' : \'\'\"><label class=text--bold ng-bind=\"!requimentItem.label ? \'No\' : requimentItem.label === true ? \'Yes\' : requimentItem.label\"></label></div><div ng-if=\"$last && customField\" class=pixerf-group-selection__item__custom-field><button ng-if=$last class=\"form-control custom-field\" ng-class=\"vm.isCustomFieldActived ? \'item-selected\' : \'\'\" ng-click=\"vm.onCustonFieldClicked(item, vm.customValue)\">Custom</button></div></div><div ng-if=vm.isCustomFieldActived class=custom-wrapper><input name=customValue placeholder=Custom class=\"form-control custom-field__input\" placeholder=0 type=number min=1 ng-model=vm.customValue.label type=text ng-change=\"vm.onCustomValueSet(item, vm.customValue)\"><div class=custom-wrapper__unit>days</div></div></div></div></form></div>");
$templateCache.put("app/components/pixerf-input-auto-complete/pixerf-input-auto-complete.html","<div class=pixerf-input-auto-complete><div pixerf-select={{options}} on-changed=onChanged() model=model class-added={{dropdownClass}}><select multiple=multiple class=form-control ng-model=model ng-options=\"opt.name for opt in data track by opt.id\" ng-required=isRequired name={{name}}></select></div></div>");
$templateCache.put("app/components/pixerf-ios-toggle-btn/pixerf-ios-toggle-btn.html","<div class=pixerf-ios-toggle-btn><input ng-click=toogle($event) ng-model=model[modelProperty] type=checkbox class=ios-toggle id=one><label class=checkbox-label data-off=Off data-on=On for=one></label></div>");
$templateCache.put("app/components/pixerf-loading-indicator/pixerf-loading-indicator.html","<div class=pixerf-loading-indicator><div class=uil-default-css><div style=\"top:80px;left:93px;width:14px;height:40px;-webkit-transform:rotate(0deg) translate(0,-60px);transform:rotate(0deg) translate(0,-60px);border-radius:10px;position:absolute\"></div><div style=\"top:80px;left:93px;width:14px;height:40px;-webkit-transform:rotate(21deg) translate(0,-60px);transform:rotate(21deg) translate(0,-60px);border-radius:10px;position:absolute\"></div><div style=\"top:80px;left:93px;width:14px;height:40px;-webkit-transform:rotate(42deg) translate(0,-60px);transform:rotate(42deg) translate(0,-60px);border-radius:10px;position:absolute\"></div><div style=\"top:80px;left:93px;width:14px;height:40px;-webkit-transform:rotate(63deg) translate(0,-60px);transform:rotate(63deg) translate(0,-60px);border-radius:10px;position:absolute\"></div><div style=\"top:80px;left:93px;width:14px;height:40px;-webkit-transform:rotate(84deg) translate(0,-60px);transform:rotate(84deg) translate(0,-60px);border-radius:10px;position:absolute\"></div><div style=\"top:80px;left:93px;width:14px;height:40px;-webkit-transform:rotate(105deg) translate(0,-60px);transform:rotate(105deg) translate(0,-60px);border-radius:10px;position:absolute\"></div><div style=\"top:80px;left:93px;width:14px;height:40px;-webkit-transform:rotate(127deg) translate(0,-60px);transform:rotate(127deg) translate(0,-60px);border-radius:10px;position:absolute\"></div><div style=\"top:80px;left:93px;width:14px;height:40px;-webkit-transform:rotate(148deg) translate(0,-60px);transform:rotate(148deg) translate(0,-60px);border-radius:10px;position:absolute\"></div><div style=\"top:80px;left:93px;width:14px;height:40px;-webkit-transform:rotate(169deg) translate(0,-60px);transform:rotate(169deg) translate(0,-60px);border-radius:10px;position:absolute\"></div><div style=\"top:80px;left:93px;width:14px;height:40px;-webkit-transform:rotate(190deg) translate(0,-60px);transform:rotate(190deg) translate(0,-60px);border-radius:10px;position:absolute\"></div><div style=\"top:80px;left:93px;width:14px;height:40px;-webkit-transform:rotate(211deg) translate(0,-60px);transform:rotate(211deg) translate(0,-60px);border-radius:10px;position:absolute\"></div><div style=\"top:80px;left:93px;width:14px;height:40px;-webkit-transform:rotate(232deg) translate(0,-60px);transform:rotate(232deg) translate(0,-60px);border-radius:10px;position:absolute\"></div><div style=\"top:80px;left:93px;width:14px;height:40px;-webkit-transform:rotate(254deg) translate(0,-60px);transform:rotate(254deg) translate(0,-60px);border-radius:10px;position:absolute\"></div><div style=\"top:80px;left:93px;width:14px;height:40px;-webkit-transform:rotate(275deg) translate(0,-60px);transform:rotate(275deg) translate(0,-60px);border-radius:10px;position:absolute\"></div><div style=\"top:80px;left:93px;width:14px;height:40px;-webkit-transform:rotate(296deg) translate(0,-60px);transform:rotate(296deg) translate(0,-60px);border-radius:10px;position:absolute\"></div><div style=\"top:80px;left:93px;width:14px;height:40px;-webkit-transform:rotate(317deg) translate(0,-60px);transform:rotate(317deg) translate(0,-60px);border-radius:10px;position:absolute\"></div><div style=\"top:80px;left:93px;width:14px;height:40px;-webkit-transform:rotate(338deg) translate(0,-60px);transform:rotate(338deg) translate(0,-60px);border-radius:10px;position:absolute\"></div></div></div>");
$templateCache.put("app/components/pixerf-message-popup/pixerf-message-popup.html","<div class=pixerf-message-popup><button ng-hide=\"vm.setting.backdrop === \'static\'\" type=button class=close ng-click=vm.close()><span class=icon-icons_close aria-hidden=true></span></button><div class=clearfix><div class=\"modal-body text-left text--color-black-2\"><div class=greeting-message ng-bind-html=vm.setting.message></div></div><br><div class=modal-footer ng-if=vm.setting.showBtn><button ng-click=vm.close() ng-class=vm.setting.btnClass ng-bind=vm.setting.bntText></button></div></div></div>");
$templateCache.put("app/components/pixerf-photo-state-btn/pixerf-photo-state-btn.html","<div class=pixerf-photo-state-btn ng-class=\"{\'pixerf-photo-state-btn--active\': (vm.highlightBtn()).isPinkHighlight, \'pixerf-photo-state-btn--black-active\': (vm.highlightBtn()).isBlackHighlight}\"><license-review ng-if=\"needReviewLicense && (pixerfPhotoStateBtnMedia.state === \'h\' || pixerfPhotoStateBtnMedia.state === \'r\')\" file=pixerfPhotoStateBtnMedia on-approved=vm.updateState(pixerfPhotoStateBtnMedia) bulk-files=bulkPhotoState><span class=pixerf-photo-state-btn__label>{{vm.convertStateToShow(pixerfPhotoStateBtnState)}}</span></license-review><span ng-if=\"!needReviewLicense || (needReviewLicense && pixerfPhotoStateBtnMedia.state !== \'h\')\" class=pixerf-photo-state-btn__label ng-click=vm.onBtnClicked(pixerfPhotoStateBtnMedia)>{{vm.convertStateToShow(pixerfPhotoStateBtnState)}}</span></div>");
$templateCache.put("app/components/pixerf-placeholder/pixerf-placeholder.html","<div ng-keypress=\"isForceHide = true\" ng-show=\"isVisible && !isForceHide\" class=\"pixerf-placeholder absolute--full absolute\" ng-bind=text></div>");
$templateCache.put("app/components/pixerf-quill-editor/pixerf-quill-editor.html","<div class=pixerf-quill-editor><ng-quill-editor required=true on-editor-created=options.onEditorCreated(editor) on-content-changed=\"vm.onContentChanged(editor, html, text, delta, oldDelta, source)\" ng-model=model></ng-quill-editor></div>");
$templateCache.put("app/components/pixerf-radio-btn/pixerf-radio-btn.html","<div class=pixerf-radio-btn><div class=pixerf-radio-btn__icon ng-if=authenticationCheck authentication-click=toogle($event) ng-class=\"{\'icon-icons-bullet--checked\': model[property] === value, \'icon-icons-bullet\': model[property] === value, \'pixerf-invalid\': isRequired && model[property] !== true &&  model[property] !== false && !model[property]}\"></div><div class=pixerf-radio-btn__icon ng-if=!authenticationCheck ng-click=toogle($event) ng-class=\"{\'icon-icons-bullet--checked\': model[property] === value, \'icon-icons-bullet\': model[property] !== value, \'pixerf-invalid\': isRequired  && model[property] !== true &&  model[property] !== false && !model[property]}\"></div><span class=pixerf-radio-btn__label ng-if=label>{{label}}</span></div>");
$templateCache.put("app/components/pixerf-tv-carousel/pixerf-tv-carousel.html","<div class=pixerf-tv-carousel id=carousel-pixerf-tv-{{instance}}><div class=\"pixerf-slick-nav prev-slide-nav clearfix\" ng-click=vm.prevBtnClicked()><div class=\"pixerf-slick-prev icon-icons_chevron-left\"></div></div><div class=\"pixerf-slick-nav next-slide-nav clearfix\" ng-click=vm.nextBtnClicked()><div class=\"pixerf-slick-next icon-icons_chevron-right\"></div></div><slick class=pixerf-tv-carousel__slick infinite=false slides-to-show=4 slides-to-scroll=4 on-init=vm.slickConfig.event.init({slick}) dots=true init-onload=true responsive=vm.slickConfig.responsive data=vm.photographers ng-if=\"vm.photographers.length > 0\" id={{instance}} next-arrow=\"#carousel-pixerf-tv-{{instance}} .pixerf-slick-nav.next-slide-nav\" prev-arrow=\"#carousel-pixerf-tv-{{instance}} .pixerf-slick-nav.prev-slide-nav\"><div ng-repeat=\"photographer in vm.photographers\" ng-mouseover=\"vm.onHover(photographer.id, true)\" ng-mouseleave=\"vm.onHover(photographer.id, false)\"><div class=pixerf-tv-carousel__photo-cover ng-style=\"{\'background-image\': \'url(\' + photographer.photo + \')\'}\"></div><div class=pixerf-tv-carousel__overlay-wrapper ng-click=vm.onVideoClicked(photographer.videoFull)><div class=pixerf-tv-carousel__play-icon></div><video id={{photographer.id}} playsinline ng-src={{photographer.url}} loop></video><div class=pixerf-tv-carousel__footer translate>{{photographer.description}}</div></div></div></slick></div>");
$templateCache.put("app/components/pixerf-user/pixerf-user.html","<div class=\"pixerf-user-wrapper relative\"><div ng-if=options.canRemove class=pixerf-user__remove-btn ng-click=\"$event.stopPropagation(); onRemoveBtnClick({userData: userData})\" title=Remove><span class=icon-icons_close></span></div><a ui-sref=\"user-home-page.personal.home({id: userData.id, userName: (userData.displayName | toSnakeCase)})\"><div class=\"relative pixerf-user__image\" ng-style=\"{\'background-image\':\'url(\\\'\' + vm.photo + \'\\\')\'}\"><div class=overlay-image></div><div class=overlay></div></div></a><div class=pixerf-user__info__avatar pixerf-user-avatar-style pixerf-user-avatar-style-user=userData><a ui-sref=\"user-home-page.personal.home({id: userData.id, userName: (userData.displayName | toSnakeCase)})\"><pixerf-user-avatar user-data=userData lazy=true></pixerf-user-avatar></a></div><div class=pixerf-user__info__author><a class=\"text--bold text--truncate text--color-black\" uib-tooltip={{userData.displayName}} ui-sref=\"user-home-page.personal.home({id: userData.id, userName: (userData.displayName | toSnakeCase)})\">{{userData.displayName}}</a></div><div class=pixerf-user__info__location>{{userData.address.country ? userData.address.country : userData.location | isoCountry}}</div><div class=\"pixerf-user__info__level text--bold text--color-black\" pixerf-person-level person=userData></div><div class=pixerf-user__info__followers-count ng-if=!isHideFollowers>{{userData.stats.follower_count}} followers</div><follow-btn ng-if=\"options.canFollow && !vm.isMyProfile\" user=userData on-follow-status-changed=\"onFollowStatusChanged({status: status})\"></follow-btn></div>");
$templateCache.put("app/components/pixerf-user-avatar/pixerf-user-avatar.html","<img ng-attr-alt={{userData.displayName}} ng-src=\"{{lazy ? defaultAvatar : userData.avatar.profileImage}}\" ng-attr-lazy-img-error=\"{{lazy ? defaultAvatar : null}}\" ng-attr-lazy-img=\"{{lazy ? userData.avatar.profileImage : null}}\" ng-class=\"!userData.account_type || userData.account_type === \'personal\' ? \'img-circle\' : \'\'\">");
$templateCache.put("app/components/placeholder-event-explore-tile/placeholder-event-explore-tile.html","<div class=placeholder-event-explore-tile><div class=placeholder-event-explore-tile__content><div class=\"placeholder-event-explore-tile__content__cover {{type}}\"></div><div class=placeholder-event-explore-tile__content__info>{{type}}<br>coming soon</div></div></div>");
$templateCache.put("app/components/popover-cart/popover-cart.html","<div class=popover-cart is-open=vm.isOpen uib-dropdown ng-attr-title=\"You have {{vm.cart.data.cart_items.length}} item(s) in your cart\" ng-hide=\"!vm.isAuthenticated() && (vm.cart.data.cart_items.length ==0)\"><a class=\"mobile-show popover-cart-popover-redirect\" ui-sref=checkout.shopping-cart ng-click=vm.onCloseBtnClicked()></a> <button uib-dropdown-toggle class=\"icon-icons_cart relative\" ng-disabled=vm.isDisablePopup()><span class=notification-item-cart-quantity ng-bind=vm.cart.data.cart_items.length></span></button><div class=\"dropdown-menu user-panel__dropdown-menu list-cart__dropdown-menu\" uib-dropdown-menu role=menu><cart on-cart-item-clicked=vm.onCartItemClicked(cartItem) on-cart-item-removed=vm.onCartItemRemoved()></cart><div class=list-cart__footer><div><span class=\"text--color-pixerf-theme text--bold\" ng-bind=vm.cart.data.cart_items.length></span><span class=text--semibold> <span class=text-lowercase>{{ vm.cart.data.cart_items.length, plural, =1 {{{\'photo\' | translate}}} other {{{\'photos\' | translate}}} }} </span>{{\'selected-for-purchase\' | translate}}</span></div><div class=control-cart><div role=button class=\"control-cart__continue btn--transparent btn\" ng-click=vm.onContinueXerfingBtnClicked()>{{\'continue\' | translate}} Xerfing</div><div role=button class=\"control-cart__view btn btn-submit\" ng-click=vm.viewCartList()>{{\'view-cart\' | translate}}</div></div></div></div><span class=\"popover-cart__text-description mobile-show\">Cart</span></div>");
$templateCache.put("app/components/popover-selection-btn/popover-selection-btn.html","<div class=popover-selection-btn><button class=text--truncate popover-trigger=\"\'outsideClick\'\" popover-placement=bottom ng-attr-popover-append-to-body=\"{{appendParent == \'true\' || !appendParent}}\" ng-attr-popover-class=\"{{ popoverClass ? \'selection-filter popover-selection-btn \' + popoverClass : \'selection-filter popover-selection-btn\'}}\" uib-popover-template=\"\'popover-selection-btn-popover.html\'\" type=button ng-class=\"settings.btnClass ? settings.btnClass : \'btn-basic btn-basic--bg-white\'\">{{settings.defaultText && !selectedModel ? settings.defaultText : (selectedModel.name | translate)}} <span class=\"icon-icons_chevron-down dropdown-icon-menu\"></span></button><script type=text/ng-template id=popover-selection-btn-popover.html><ul class=\"popover-selection-btn__items\">\r\n            <li class=\"popover-selection-btn__items__item\" ng-class=\"{\'popover-selection-btn__items__item--active\': option.isSelected, \'disabled\': option.isSelected}\" ng-disabled=\"option.isSelected\" ng-click=\"!option.isSelected && vm.onItemClicked(option)\" ng-repeat=\"option in vm.options\" compile=\"option.name | translate\"></li>\r\n        </ul></script></div>");
$templateCache.put("app/components/portfolio-galleries-list/portfolio-galleries-list.html","<div scroll=vm.onWindowScroll() class=\"galleries-list-wrapper pixerf-scrollable-but-not-parent\" tabindex=0><div class=\"galleries-list__gallery-list-wrapper portfolio-galleries-list\" infinite-scroll-disabled=vm.isLastPage.data infinite-scroll=vm.fetchMorePortfolioGallaries() infinite-scroll-immediate-check=false infinite-scroll-container=\"\'.galleries-list-wrapper\'\"><div class=\"gallery-item clearfix\" ng-click=\"vm.onPortfolioGalleryItemClicked($event, portfolio)\" ng-repeat=\"portfolio in vm.portfolios.data\"><div class=\"gallery-item__thumbnail pull-left\"><div class=gallery-item__thumbnail__cover-photo ng-style=\"{\'background-image\': \'url(\' + portfolio.coverPath + \')\'}\"></div><span ng-show=!portfolio.thumbnail class=\"gallery-item__thumbnail__short-name absolute absolute--full text-center text--color-white\">{{portfolio.title.substr(0, 1)}}</span></div><div class=\"gallery-item__title text--bold text--color-black pull-left text--truncate\">{{portfolio.title}} <span class=\"gallery-item__number-photos-gallery text--semibold\" ng-bind=\"{{portfolio.media_count + portfolio.pending_media_count}} == 1 ? {{portfolio.media_count + portfolio.pending_media_count}} + \' photo\' : {{portfolio.media_count + portfolio.pending_media_count}} + \' photos\'\"></span></div><span ng-show=portfolio.isSelected class=icon-icons_check></span></div><div class=\"galleries-list__empty-state text-center\" ng-if=\"vm.portfolioGalleries.data.length === 0\">You haven\'t created any portfolio galleries yet!</div><scroll-paging spinner=vm.spinner show-message=false is-last-page=vm.isLastPage.data message=\"No more gallery to load.\"></scroll-paging></div></div>");
$templateCache.put("app/components/portfolio-grid/portfolio-grid.html","<div class=portfolio-grid><div class=\"portfolio-grid__wrapper text-center\" infinite-scroll-disabled=vm.isLastPage infinite-scroll=vm.fetchMorePortfolios() infinite-scroll-immediate-check=false><div class=portfolio-grid__item ng-repeat=\"portfolio in vm.portfolios\"><portfolio-tile portfolio=portfolio on-portfolio-clicked=\"onPortfolioClicked({\'portfolio\': portfolio})\"></portfolio-tile></div><scroll-paging spinner=vm.spinner show-message=\"vm.portfolios.length > 0 && vm.searchParams.page > 1\" is-last-page=vm.isLastPage message=\"No more portfolios.\" section-id={{onScrollToSectionId}} offset-top={{onScrollOffsetTop}}></scroll-paging></div></div>");
$templateCache.put("app/components/portfolio-list-slider/portfolio-list-slider.html","<div class=portfolio-list-slider><div class=portfolio-list-slider__container ng-if=\"!minShowList || (minShowList && vm.portfolios.length >= minShowList)\" ng-class=\"{\'small-size\' : isSmallSize, \'guest\': !vm.isMine}\"><div class=\"portfolio-list-slider__header clearfix\"><div id=section-{{vm.portfolioContext}}-portfolio class=\"portfolio-list-slider__title text--extrabold text--color-black\" ng-if=!hideName>{{vm.portfolio.name}} {{vm.totalCount ? \'(\' + vm.totalCount + \')\' : \'\'}}</div><div class=\"portfolio-list-slider__control-wrapper clearfix\" ng-if=\"vm.portfolios && vm.portfolios.length > 0\"><div class=portfolio-list-slider__control-wrapper__see-all ui-sref=\"user-home-page.{{vm.loginUser.account_type}}.portfolio.grid({portfolioId: vm.portfolio.id})\">{{\'see-all\' | translate}}</div><div ng-if=vm.isMine class=portfolio-list-slider__control-wrapper__create-btn authentication-click=vm.onUploadPortfolioPhoto(vm.portfolio.id) check-verified-email=true>{{\'create-new\' | translate}}</div></div></div><div ng-if=\"vm.portfolios.length === 0\" class=portfolio-list-slider__empty-text__container><div class=\"portfolio-list-slider__empty-text create-btn clearfix\" ng-if=vm.isMine ng-click=vm.onUploadPortfolioPhoto(vm.portfolio.id)><div class=\"portfolio-list-slider__empty-text__content-wrapper vertical-align-middle--transform\"><div class=\"portfolio-list-slider__empty-text__icon icon-icons_plus\"></div><div class=\"portfolio-list-slider__empty-text__title text--extrabold\" ng-bind=\"vm.isMine ? (\'create-portfolio\' | translate) : vm.userDisplayName + \' has not uploaded photos to this Portfolio Gallery\'\"></div><div class=portfolio-list-slider__empty-text__description ng-if=vm.isMine>{{\'showcase-your-work-to-brands\' | translate}}</div></div></div><div class=\"portfolio-list-slider__empty-text clearfix\" ng-if=!vm.isMine><div class=\"portfolio-list-slider__empty-text__content-wrapper vertical-align-middle--transform\"><div class=portfolio-list-slider__empty-text__title ng-bind=\"vm.userDisplayName + \' has not uploaded photos to this Portfolio Gallery\'\"></div></div></div></div><spinner-win spinner=vm.spinner></spinner-win><div class=\"portfolios-slick-slider clearfix\" ng-class=\"{\'show-slick\': vm.showSlick}\"><pixerf-animation-carousel data=vm.portfolios ng-if=\"vm.portfolios && vm.portfolios.length > 0\" config=vm.carouselConfig instance={{vm.portfolioContext}} limit=9><item-template><portfolio-tile portfolio=$parent.data speciality={{vm.portfolio.name}} on-portfolio-clicked=\"onPortfolioClicked({\'portfolio\': $parent.data})\" ng-attr-is-small-size=\"{{isSmallSize ? true : undefined}}\"></portfolio-tile></item-template></pixerf-animation-carousel></div></div></div>");
$templateCache.put("app/components/portfolio-photo/portfolio-photo.html","<div class=portfolio-photo ng-style=\"{\'background-image\': \'url(\\\'\' + vm.displaySize + \'\\\')\'}\"><a class=portfolio-photo__fancy-box ng-attr-fancyboxable=\"{\'type\': \'image\', \'overlayShow\': true, \'hideOnOverlayClick\': true, \'showNavArrows\': true, \'margin\': \'50 10 15 10\', \'centerOnScroll\': true}\" href={{vm.displaySize}} rel=portfolioGallery></a><div class=\"photo__tools-wrapper clearfix\"><div class=photo__tools-wrapper__left><pixerf-photo-state-btn ng-if=\"vm.isLogined && (vm.loginUser.canCurate) && !options.hideCuratorBtns\" ng-click=$event.stopPropagation() class=\"photo__tools photo__tools--left\" pixerf-photo-state-btn-state=g pixerf-photo-state-btn-media=file title=\"Move to General\"></pixerf-photo-state-btn><pixerf-photo-state-btn ng-if=\"vm.isLogined && (vm.loginUser.canCurate) && !options.hideCuratorBtns\" ng-click=$event.stopPropagation() class=\"photo__tools photo__tools--left\" pixerf-photo-state-btn-state=h pixerf-photo-state-btn-media=file title=\"Move to Pending\"></pixerf-photo-state-btn><pixerf-photo-state-btn ng-if=\"vm.isLogined && (vm.loginUser.canCurate) && !options.hideCuratorBtns\" ng-click=$event.stopPropagation() class=\"photo__tools photo__tools--left\" pixerf-photo-state-btn-state=d pixerf-photo-state-btn-media=file title=\"Move to Discover\"></pixerf-photo-state-btn><pixerf-photo-state-btn ng-if=\"vm.isLogined && (vm.loginUser.canCurate) && !options.hideCuratorBtns\" ng-click=$event.stopPropagation() class=\"photo__tools photo__tools--left\" pixerf-photo-state-btn-state=t pixerf-photo-state-btn-media=file title=\"Move to Trending\"></pixerf-photo-state-btn></div><div class=photo__tools-wrapper__right><pixerf-photo-state-btn ng-if=\"vm.isLogined && (vm.loginUser.canCurate) && !options.hideCuratorBtns\" ng-click=$event.stopPropagation() class=\"photo__tools photo__tools--right\" pixerf-photo-state-btn-state=r pixerf-photo-state-btn-media=file ng-attr-title=\"{{file.state===\'r\' && file.reject_reason ? \'Reject Reason: \' + file.reject_reason : \'Reject this photo\'}}\"></pixerf-photo-state-btn></div></div><div class=\"portfolio-photo__remove-btn remove-portfolio-photo-btn\" ng-if=vm.isMine ng-click=\"vm.onRemovePortfolioPhotoClicked(file, portfolioGallery)\"><span class=\"portfolio-photo__removed-icon icon-icons_close\"></span></div></div>");
$templateCache.put("app/components/portfolio-photo-grid/portfolio-photo-grid.html","<div class=photo-grid on-window-resize-event=vm.onWindowResize() on-orientation-change-event=vm.onOrientationChange() ng-class=\"{\'photo-grid--fresh\': vm.isFresh && vm.spinner.isVisible}\"><div infinite-scroll-distance=0.5 class=\"clearfix photo-grid__photos-container\" infinite-scroll-disabled=vm.isNoMorePhotoToLoad infinite-scroll=vm.fetchMorePhotos() infinite-scroll-immediate-check=false infinite-scroll-container=vm.containerClass></div><ng-transclude class=ng-hide ng-hide=\"vm.photos.length > 0 || vm.spinner.isVisible\"></ng-transclude><scroll-paging spinner=vm.spinner show-message=\"!hideNoMoreMessage && vm.photos.length > 0\" hide-back-to-top=\"vm.totalPage < 2\" is-last-page=vm.isNoMorePhotoToLoad message=\"{{\'no-more-photos\' | translate}}\"></scroll-paging></div>");
$templateCache.put("app/components/portfolio-tile/portfolio-tile.html","<div class=portfolio-tile><div class=portfolio-tile__item__photo ng-class=\"{\'no-footer\': options.hideAuthor}\"><div class=portfolio-tile__carousel active=0><div class=portfolio-tile__carousel__item ng-click=\"onPortfolioClicked({\'portfolio\': portfolio})\"><div class=\"portfolio-tile__carousel__photo-cover zoom-hover\" ng-if=\"portfolio.cover_media.thumbnails[\'x400\']\" ng-style=\"{\'background-image\': \'url(\\\'\' +  portfolio.cover_media.thumbnails[\'x400\'] + \'\\\')\'}\"><div class=overlay></div></div><div ng-if=\"!portfolio.cover_media.thumbnails[\'x400\']\" class=\"portfolio-tile__carousel__photo-cover zoom-hover\" ng-style=\"{\'background-color\': portfolio.defaultBackgroundColor} \"><div class=overlay></div></div></div></div><div class=portfolio-tile__item__content><div>{{(speciality || portfolio.speciality) | toTitleCase}}</div><div class=portfolio-tile__item__content__title title={{portfolio.title}}>{{portfolio.title | toTitleCase}}</div></div></div></div>");
$templateCache.put("app/components/portfolio-welcome-popup/portfolio-welcome-popup.html","<div class=\"portfolio-welcome-popup clearfix\"><div class=modal-info><div class=\"modal--title text-center text--color-black\">{{vm.greetingMessage}}</div><div class=\"modal-body text-center\"><p ng-bind-html=vm.welcomeMessage></p></div><div class=modal-footer><button ng-click=vm.ok() type=button class=\"btn btn-submit portfolio-welcome-popup__ok-btn\">OK</button></div></div></div>");
$templateCache.put("app/components/prevent-submit-mission-popup/prevent-submit-mission-popup.html","<div class=prevent-submit-mission-popup__container><div class=\"prevent-submit-mission-popup__close icon-icons_close\" role=button ng-click=vm.closePopup()></div><div class=prevent-submit-mission-popup__body><div class=prevent-submit-mission-popup__content><div class=prevent-submit-mission-popup__content__header>{{\'sorry\' | translate}}!</div><div class=prevent-submit-mission-popup__content__description>This mission is only open to {{vm.nationality}} photographers and/or photographers based in {{vm.countries}}</div></div><button class=\"prevent-submit-mission-popup__button btn btn-submit\" ng-click=vm.onBrowseClicked() translate>{{\'browse-other-missions\'}}</button></div></div>");
$templateCache.put("app/components/profiles-grid/profiles-grid.html","<div class=profiles-grid><div ng-if=\"vm.profiles.length > 0\" class=\"profiles-grid-wrapper clearfix\" infinite-scroll-disabled=\"vm.isLastPage || !options.scrollToPaging\" infinite-scroll=vm.fetchMore() infinite-scroll-immediate-check=false><div ng-repeat=\"profile in vm.profiles\" class=profiles-grid__item><detail-user-view owner=contextView user=profile on-removed=vm.onRemoveBtnClick(user) options=vm.options></detail-user-view></div></div><ng-transclude ng-if=\"vm.profiles.length === 0 && !vm.searchParams.keywords && !vm.searchParams.ambassadorship\"></ng-transclude><spinner-win spinner=vm.spinner></spinner-win></div>");
$templateCache.put("app/components/purchase-history/purchase-history.html","<div class=purchase-history><div class=\"completed-header text-center\" ng-if=vm.orderId><div class=\"completed-header__signed icon-icons_check text--color-pixerf-theme\"></div><div class=completed-header__title>{{\'purchase-completed\' | translate}}</div><div class=completed-header__order>{{\'your-order-no-is\' | translate}} <a class=\"pixerf-link--normal--hover--color-theme text--semibold\" ui-sref=\"setting.purchase-history.order-details({orderId: vm.orderId})\">{{vm.orderId}}</a><br>{{\'thank-you-purchase-completed\' | translate}}</div></div><div class=\"purchase-history__navigation-bar clearfix\" ng-if=!vm.hideHeaderBar><div class=purchase-history__header><div class=purchase-history__title translate>{{\'purchase-history\'}}</div><div class=purchase-history__description translate>{{\'track-the-transactions\'}}</div></div><navigation-horizontal ng-if=\"vm.loginedUser.canManageMission || vm.loginedUser.canBuyCreditPlan\" instance=vm.navigation options=vm.navigationOptions></navigation-horizontal></div><div class=purchase-history__main-content ui-view></div></div>");
$templateCache.put("app/components/purchase-sold-history-item/purchase-sold-history-item.html","<div class=\"purchase-sold-history-item clearfix\" ng-class=\"type === \'purchase\' ? \'purchase-item\' : \'\'\"><div class=\"purchase-sold-history-item__media clearfix\" ng-repeat=\"media in item.media\"><div class=purchase-sold-history-item__order ng-if=\"type === \'purchase\'\"><stick-checkbox on-changed=vm.onSelectedItem(media) model=media model-property=selected></stick-checkbox></div><div class=\"purchase-sold-history-item__wrapper clearfix\" ng-class=\"type === \'purchase\' ? \'col-xs-11\' : \'col-xs-8 col-sm-9\'\"><a class=\"purchase-sold-history-item__col-left pull-left\" ui-sref=\"photo({id: media.id})\"><img lazy-img-error=assets/images/icon-market.png lazy-img=\"{{media.thumbnails[\'150x\']}}\" alt={{media.title}}></a><div class=\"purchase-sold-history-item__col-right clearfix\"><div class=purchase-sold-history-item__col-right__title><div class=text--bold>{{\'photo-id\' | translate}} #{{media.id}}</div><div class=text--bold>{{media.title}}</div><a ng-show=\"type === \'purchase\'\" ui-sref=\"user-home-page.personal.home({id: media.user.id, userName: (media.user.displayName | toSnakeCase)})\" class=text--semibold><span>by {{media.user.displayName}}</span></a></div><div class=\"table-photo-detail__row clearfix\"><div class=\"table-photo-detail__item-label text--bold\" translate>{{\'license-type\'}}</div><div class=\"table-photo-detail__item-content pull-left\">{{media.license}}</div></div><div class=table-photo-detail__size>{{media.size}}</div><div class=table-photo-detail__description>{{media.description}}</div></div><div title=\"Download this photo\" ng-click=\"vm.onDownloadBtnClicked($event, media)\" role=button class=\"purchase-sold-history-item__button-download btn btn-cancel--no-background\" ng-show=\"type === \'purchase\'\">Download image</div><a ng-attr-href={{media.downloadLink}}></a></div></div></div>");
$templateCache.put("app/components/referral-program/referral-program.html","<div class=\"clearfix none-float horizental-centered referral-program\"><div class=clearfix><div class=referral-program><ul class=\"referral-program-navigation-bar no-padding clearfix\"><button type=button class=\"navbar-toggle collapsed\" data-toggle=collapse data-target=#referral-navbar-collapse aria-expanded=false><div class=\"pull-left text--bold\">{{vm.subContextPage}}</div><div class=\"pull-right arrow-animation-menu-collapse\"><span class=\"icon-bar dash-one\"></span> <span class=\"icon-bar dash-two\"></span></div></button><div class=\"collapse navbar-collapse no-padding pixerf-navbar-text\" navbar-collapse-on-click=true id=referral-navbar-collapse><li ui-sref-active=referral-program-navigation-bar__menu-item--active ui-sref=setting.referral_program.invite class=referral-program-navigation-bar__menu-item>Invite</li><li ui-sref-active=referral-program-navigation-bar__menu-item--active ui-sref=setting.referral_program.track class=referral-program-navigation-bar__menu-item>Track</li></div></ul></div><div class=\"manage-community clearfix\" ui-view></div></div></div>");
$templateCache.put("app/components/referral-program-invite-section/referral-program-invite-section.html","<section class=referral-program-invite-section><div class=\"referral-program-invite-section__content clearfix\"><div class=\"referral-program-invite-section__title text--bold text--color-black\">Invite Friends</div><div class=referral-program-invite-section__description>Join our referral programme and invite your friends to join PIXERF today!</div><div class=\"referral-program-invite-section__input clearfix\"><div ng-if=!vm.emails class=overlay-disable></div><div class=\"btn referral-program-invite-section__invite-btn btn-submit--no-background\" ng-click=vm.onInviteClicked()>Invite</div><div class=referral-program-invite-section__control><tags-input on-tag-adding=\"vm.onValidateTag($tag, $event)\" add-on-space=true add-on-blur=true ng-model=vm.emails placeholder=\"Enter email addresses\" type=email tag-class=referral-tag class=form-control allowed-tags-pattern=^([a-zA-Z0-9_\\-\\.]+)@([a-zA-Z0-9_\\-\\.]+)\\.([a-zA-Z]{2,5})$></tags-input></div></div></div></section>");
$templateCache.put("app/components/referrals-intro-popover/referrals-intro-popover.html","<div class=referrals-intro-popover><div class=mobile-show><a class=referrals-intro-popover__mobile-item ui-sref=referral-program ng-click=vm.onCloseBtnClicked()><span class=\"referrals-intro-popover__icon-mobile icon-gift\"></span> <span class=referrals-intro-popover__text-description>Referral Program</span></a></div><div class=desktop-show><div class=\"referrals-intro-popover__icon in\" popover-trigger=\"\'outsideClick\'\" popover-popup-delay=150 ng-attr-title={{vm.tooltip}} uib-popover-template=\"\'newFeatureTemplate.html\'\" popover-placement=bottom-center popover-class=new-feature-coming popover-append-to-body=true><span class=icon-gift></span></div></div><script type=text/ng-template id=newFeatureTemplate.html><div class=\"fake-icon\" ng-click=\"vm.closePopover()\">\r\n		  <div class=\"icon-gift\"></div>\r\n		</div>\r\n		<div id=\"new-feature-popover\" class=\"new-feature-popover\" ng-click=\"vm.closePopover()\">\r\n		  <div class=\"new-feature-popover__title text--bold\">New!</div>\r\n		  <div>Unlock cash rewards for you and higher earnings for your friends with our referral programme.</div>\r\n		  <button class=\"btn text--bold btn-submit\" ui-sref=\"referral-program\">{{\'find-out-how\' | translate}}</button>\r\n		</div></script></div>");
$templateCache.put("app/components/register-bank-info-popup/register-bank-info-popup.html","<div class=register-bank-info-popup><div class=modal-header><button ng-disabled=vm.isWorking type=button class=close data-dismiss=modal aria-label=Close ng-click=vm.close()><span aria-hidden=true>&times;</span></button><h4 class=\"modal-title text--bold\">Bank Information</h4><div class=\"well well-lg\">Note: Are there any fields that you’re not sure about? Check with your bank for the correct information first before submitting. Any inaccuracies may cause a delay in your payment.</div></div><div class=modal-body><form name=vm.form novalidate ng-class=\"{\'pixerf-form-submitted\': vm.form.$submitted}\"><div class=form-group><label required for=\"\">Currency</label><currency-select mapper=vm.currencyCodeMapper extractor=vm.currencyCodeExtractor class=register-bank-info-popup__currency-select search-placeholder=\"Search currency...\" none-selected-text=\"Choose your currency\" ng-model=vm.bankInfo.targetCurrency currencies=vm.currencies ng-change=vm.onCurrentSelectionChanged()></currency-select></div><formly-form form=vm.form model=vm.bankInfo fields=vm.banksConfiguration></formly-form></form></div><div class=modal-footer><button ng-disabled=vm.isWorking role=button class=\"btn btn--transparent text--semibold\" ng-click=vm.close()>Cancel</button> <button ng-disabled=vm.isWorking role=button class=\"btn btn-submit text--semibold\" ng-click=vm.onSaveBtnClicked(vm.form)>Save</button></div><script type=text/ng-template id=error-messages.html><formly-transclude></formly-transclude>\r\n        <div ng-messages=\"fc.$error\" ng-if=\"form.$submitted || options.formControl.$touched\" class=\"error-messages\">\r\n          <div ng-message=\"{{ ::name }}\" ng-repeat=\"(name, message) in ::options.validation.messages\" class=\"message\">{{ message(fc.$viewValue, fc.$modelValue, this)}}</div>\r\n        </div></script><script type=text/ng-template id=pixerf-bootstrap-label.html><div>\r\n            <label for=\"{{id}}\" class=\"control-label {{to.labelSrOnly ? \'sr-only\' : \'\'}}\" ng-if=\"to.pixerfLabel\">\r\n              {{to.pixerfLabel}}\r\n              {{to.required ? \'*\' : \'\'}}\r\n            </label>\r\n            <span ng-if=\"to.tooltip\" class=\"icon-icons-info\" tooltip-placement=\"right\" tooltip-class=\"text-left\"  uib-tooltip=\"{{to.tooltip}}\"></span>\r\n            <formly-transclude></formly-transclude>\r\n        </div></script></div>");
$templateCache.put("app/components/remove-member-popup/remove-member-list-reason-popup.html","");
$templateCache.put("app/components/remove-member-popup/remove-member-popup.html","<div class=remove-member-popup><div class=remove-member-popup__header><button type=button class=close ng-click=vm.closePopup()><span class=icon-icons_close aria-hidden=true></span></button></div><div class=remove-member-popup__body><div class=remove-member-popup__body__title>Remove a Member</div><popover-selection-btn append-parent=false close-on-click=true selected-model=vm.selectedReason settings=vm.selectionSettings on-selection-changed=vm.onReasonChange()></popover-selection-btn><div class=remove-member-popup__stick-wrapper><div><stick-checkbox on-changed=vm.onDeletePostsComments(vm.blockOptions.posts) model=vm.blockOptions model-property=posts label={{vm.blockPostLabel}} layout-style=regular-square></stick-checkbox></div><div><stick-checkbox on-changed=vm.onDeclinePending(vm.blockOptions.pending) model=vm.blockOptions model-property=pending label={{vm.declinePendingLabel}} layout-style=regular-square></stick-checkbox></div><div class=remove-member-popup__stick-wrapper__block-item><stick-checkbox on-changed=vm.onBlock(vm.blockOptions.block) model=vm.blockOptions model-property=block label=\"Block member\" layout-style=regular-square></stick-checkbox><div class=remove-member-popup__stick-wrapper__hint>{{vm.blockHintLabel}}</div></div></div></div><div class=remove-member-popup__footer><button class=\"remove-member-popup__footer__control btn btn--transparent\" ng-click=vm.closePopup()>Cancel</button> <button ng-disabled=vm.isDisabledConfirmBtn class=\"remove-member-popup__footer__control btn btn-submit\" ng-click=vm.onConfirm()>Confirm</button></div></div>");
$templateCache.put("app/components/report-detail-compile-template/report-detail-compile-template.html","<div class=report-detail-compile-template ng-class=\"{\'append-to-body\': appendToBody}\"><div class=report-detail-compile-template__header><img ng-src={{vm.report.community.cover.thumbnail}} class=report-detail-compile-template__header__cover><div class=report-detail-compile-template__header__info><div class=report-detail-compile-template__header__info__name>{{vm.report.community.name}}</div><div class=report-detail-compile-template__header__info__created-at>Created on <span>{{vm.communityFomatedDate}}</span></div></div><div class=report-detail-compile-template__header__controls><div class=\"report-detail-compile-template__header__controls__button report-detail-compile-template__header__controls__button__close icon-icons_close\" ng-click=vm.onClosed()></div></div></div><div class=report-detail-compile-template__content><div class=report-detail-compile-template__content__user><div class=report-detail-compile-template__content__user__wrapper><div class=report-detail-compile-template__content__user__label>Reporter:</div><div class=report-detail-compile-template__content__user__info><pixerf-user-avatar class=report-detail-compile-template__content__user__avatar user-data=vm.report.user lazy=true></pixerf-user-avatar><div class=report-detail-compile-template__content__user__name>{{vm.report.user.displayName}}</div></div></div><div class=report-detail-compile-template__content__user__wrapper><div class=report-detail-compile-template__content__user__label>Owner/Author:</div><div class=report-detail-compile-template__content__user__info><pixerf-user-avatar class=report-detail-compile-template__content__user__avatar user-data=vm.report.community.owner lazy=true></pixerf-user-avatar><div class=report-detail-compile-template__content__user__name>{{vm.report.community.owner.displayName}}</div></div></div></div><div class=report-detail-compile-template__content__type-control><div class=report-detail-compile-template__content__type-control__info><div>Report type: <span>{{vm.reportType}}</span></div><div>Reported date {{vm.reportFomatedDate}}</div></div><div class=report-detail-compile-template__content__type-control__action><div ng-if=vm.isShowStrike class=report-detail-compile-template__content__type-control__action__strike><div class=report-detail-compile-template__content__type-control__action__strike__label>strikes:</div><div class=report-detail-compile-template__content__type-control__action__strike__list><div ng-repeat=\"strike in [].constructor(vm.maxStrikes) track by $index\" class=report-detail-compile-template__content__type-control__action__strike__item ng-class=\"{\'icon-icons_close\': $index < vm.report.community.strike_count}\"></div></div><div ng-if=vm.report.community.previous_deactivation_count class=report-detail-compile-template__content__type-control__action__deactivated__list><div ng-repeat=\"strike in [].constructor(vm.report.community.previous_deactivation_count) track by $index\" class=\"report-detail-compile-template__content__type-control__action__deactivated__item default-item icon-icons_close\"></div></div></div><div class=report-detail-compile-template__content__type-control__action__button__wrapper ng-class=\"{\'label-layout\': vm.isShowStatusLabel}\"><div ng-if=\"vm.isShowResolveButton && (vm.report.community.previous_deactivation_count < 3)\" class=\"report-detail-compile-template__content__type-control__action__button report-detail-compile-template__content__type-control__action__button__resolve btn-cancel--no-background\" ng-click=vm.onResolveReport()>{{\'resolve\' | translate}}</div><div ng-if=vm.isShowRemoveButton class=\"report-detail-compile-template__content__type-control__action__button report-detail-compile-template__content__type-control__action__button__remove btn-submit\" ng-click=vm.onRemoveReport()>{{vm.removeText | translate}}</div><div ng-if=vm.isShowValidateButton class=\"report-detail-compile-template__content__type-control__action__button report-detail-compile-template__content__type-control__action__button__remove btn-submit\" ng-click=vm.onValidateReport()>{{\'validate\' | translate}}</div><div ng-if=vm.isShowStatusLabel class=report-detail-compile-template__content__type-control__label ng-class=\"{\'blue-status-theme\': [\'open\', \'resolved\'].includes(vm.report.status), \'red-status-theme\': vm.report.status === \'validated\'}\">{{vm.report.status === \'open\' ? \'in review\' : vm.report.status}}</div></div></div></div><div ng-if=vm.showReportReasonMessage class=report-detail-compile-template__content__reason-message ng-click=vm.onToggleReportReason(vm.isOpenReportReason) ng-class=\"{\'no-description\': !vm.report.description}\"><div class=report-detail-compile-template__content__reason-message__control-toggle><div class=report-detail-compile-template__content__reason-message__control-toggle__title translate translate-values=\"{thing: vm.reportType, reason: vm.report.reason}\">{{\'this-thing-was-reported-for-reason\'}}</div><div ng-if=vm.report.description class=report-detail-compile-template__content__reason-message__control-toggle__arrow ng-class=\"vm.isOpenReportReason ? \'icon-icons_chevron-up\' : \'icon-icons_chevron-down\'\"></div></div><div ng-if=vm.report.description uib-collapse=!vm.isOpenReportReason class=\"report-detail-compile-template__content__reason-message__content-toggle collapse\"><div class=report-detail-compile-template__content__reason-message__content-toggle__description>{{vm.report.description}}</div></div></div><div ng-if=\"vm.reportType === \'community\'\" class=report-detail-compile-template__main-info__community><img ng-src={{vm.community.cover.medium}} class=report-detail-compile-template__main-info__community__cover><div class=report-detail-compile-template__main-info__community__general-info><div class=report-detail-compile-template__main-info__community__name><div class=report-detail-compile-template__main-info__community__name__label>Community Name</div><div class=report-detail-compile-template__main-info__community__name__value>{{vm.community.name}}</div></div><div class=report-detail-compile-template__main-info__community__privacy ng-class=\"{\'text--color-pixerf-theme\': !vm.community.is_private}\"><span class=report-detail-compile-template__main-info__community__privacy__icon ng-class=\"vm.community.is_private ? \'icon-lock\' : \'icon-public-community\'\"></span> <span translate>{{vm.community.is_private ? \'private\' : \'public\'}}</span></div></div><div ng-if=vm.community.description class=report-detail-compile-template__main-info__community__about><div class=report-detail-compile-template__main-info__community__about__label>About this Community</div><div class=report-detail-compile-template__main-info__community__about__value>{{vm.community.description}}</div></div><div ng-if=vm.community.rules class=report-detail-compile-template__main-info__community__rule><div class=report-detail-compile-template__main-info__community__rule__label>Community Rules</div><div class=report-detail-compile-template__main-info__community__rule__value ng-bind-html=vm.community.rules></div></div><div class=report-detail-compile-template__main-info__community__required><div class=report-detail-compile-template__main-info__community__required__permissions><div class=report-detail-compile-template__main-info__community__required__label>Discussion Permissions</div><div class=report-detail-compile-template__main-info__community__required__value>{{vm.community.start_discussion_permission === \'anyone\' ? \'Anyone in community\' : \'Admin only\'}}</div></div><div class=report-detail-compile-template__main-info__community__required__approval><div class=report-detail-compile-template__main-info__community__required__label>Discussion Approval</div><div class=report-detail-compile-template__main-info__community__required__value>{{vm.community.moderate_discussions ? \'Approval required\' : \'No Approval required\'}}</div></div></div><div class=report-detail-compile-template__main-info__community__member><div class=report-detail-compile-template__main-info__community__member__admin><div class=report-detail-compile-template__main-info__community__member__label>Admin</div><div class=report-detail-compile-template__main-info__community__member__avatar><img ng-class=\"{\'circle\': vm.community.owner.account_type === \'personal\'}\" ng-src=\"{{vm.community.owner.profile_image_media[\'100x\']}}\"></div></div><div ng-if=\"vm.community.moderators && vm.community.moderators.length\" class=report-detail-compile-template__main-info__community__member__moderators><div class=report-detail-compile-template__main-info__community__member__label>{{vm.community.moderators.length === 1 ? \'Moderator\' : \'Moderators\'}}</div><div class=report-detail-compile-template__main-info__community__member__avatar ng-class=\"{\'multi-mods\': vm.community.moderators.length > 1}\"><img ng-repeat=\"mod in vm.community.moderators\" ng-src=\"{{mod.profile_image_media[\'100x\']}}\"></div></div></div></div><div ng-if=\"vm.reportType === \'event\'\" class=report-detail-compile-template__main-info__event><img ng-src={{vm.event.cover.medium}} class=report-detail-compile-template__main-info__event__cover><div class=report-detail-compile-template__main-info__event__general-info><div class=report-detail-compile-template__main-info__event__name><div class=report-detail-compile-template__main-info__event__name__label>Event Name</div><div class=report-detail-compile-template__main-info__event__name__value>{{vm.event.name}}</div></div><div class=report-detail-compile-template__main-info__event__privacy ng-class=\"{\'text--color-pixerf-theme\': !vm.event.is_private}\"><span class=report-detail-compile-template__main-info__event__privacy__icon ng-class=\"vm.event.is_private ? \'icon-lock\' : \'icon-public-community\'\"></span> <span translate>{{vm.event.is_private ? \'private\' : \'public\'}}</span></div></div><div ng-if=vm.event.description class=report-detail-compile-template__main-info__event__about><div class=report-detail-compile-template__main-info__event__about__label>About this Event</div><div class=report-detail-compile-template__main-info__event__about__value>{{vm.event.description}}</div></div><div class=report-detail-compile-template__main-info__event__destination><div class=report-detail-compile-template__main-info__event__destination__location><div class=report-detail-compile-template__main-info__event__destination__label>Location</div><div class=report-detail-compile-template__main-info__event__destination__value>{{vm.event.location}}</div></div><div class=report-detail-compile-template__main-info__event__destination__location><div class=report-detail-compile-template__main-info__event__destination__label>Venue</div><div class=report-detail-compile-template__main-info__event__destination__value>{{vm.event.venue}}</div></div><div class=report-detail-compile-template__main-info__event__destination__date><div class=report-detail-compile-template__main-info__event__destination__label>Date</div><div class=report-detail-compile-template__main-info__event__destination__value><div ng-repeat=\"schedule in vm.eventSchedules\" class=event-detail-page__info-section__content__schedule><div>{{schedule.date}}</div><div>{{schedule.time}}</div></div></div></div></div><div class=report-detail-compile-template__main-info__event__general><div class=report-detail-compile-template__main-info__event__general__wrapper><div class=report-detail-compile-template__main-info__event__general__label>Capacity</div><div class=report-detail-compile-template__main-info__event__general__value>{{vm.max_attendees_show}}</div></div><div class=report-detail-compile-template__main-info__event__general__wrapper><div class=report-detail-compile-template__main-info__event__general__label>Ticketing</div><div class=report-detail-compile-template__main-info__event__general__value>{{vm.admission_type_show}}</div></div></div><div class=report-detail-compile-template__main-info__event__member><div class=report-detail-compile-template__main-info__event__member__admin><div class=report-detail-compile-template__main-info__event__member__label>Admin</div><div class=report-detail-compile-template__main-info__event__member__avatar><img ng-class=\"{\'circle\': vm.event.owner.account_type === \'personal\'}\" ng-src=\"{{vm.report.community.owner.profile_image_media[\'100x\']}}\"></div></div><div class=report-detail-compile-template__main-info__event__community><div class=report-detail-compile-template__main-info__event__community__label>Community</div><div class=report-detail-compile-template__main-info__event__community__avatar><img ng-src={{vm.report.community.cover.thumbnail}}></div></div></div></div><div ng-if=\"vm.reportType === \'post\'\" class=report-detail-compile-template__main-info__discussion><div class=report-detail-compile-template__main-info__discussion__name>{{vm.discussion.subject}}</div><div class=report-detail-compile-template__main-info__discussion__about><div ng-if=\"vm.discussion && vm.discussion.user && vm.discussion.user.displayName\" class=report-detail-compile-template__main-info__discussion__about__label>Posted by</div><div class=report-detail-compile-template__main-info__discussion__about__value>{{vm.discussion.user.displayName}}</div><div class=report-detail-compile-template__main-info__discussion__about__divide></div><div class=report-detail-compile-template__main-info__discussion__about__date>{{vm.discussionFomatedDate}}</div></div><div class=report-detail-compile-template__main-info__discussion__description>{{vm.discussion.description}}</div><div ng-if=\"vm.discussion.photos && vm.discussion.photos.length\" class=report-detail-compile-template__main-info__discussion__photo><div flex-grid ng-model=vm.discussion.photos rowheight=50 lastrow=justify margins=10><div ng-repeat=\"photo in vm.discussion.photos\"><a ng-attr-fancyboxable=\"{\'type\': \'image\', \'overlayShow\': true, \'hideOnOverlayClick\': true, \'showNavArrows\': true, \'margin\': \'50 10 15 10\', \'centerOnScroll\': true}\" href={{photo.url.large}} rel=discussionAttachment><img ng-src={{photo.url.thumbnail}}></a></div></div></div></div><div ng-if=\"vm.reportType === \'comment\'\" class=report-detail-compile-template__main-info__comment><div class=report-detail-compile-template__main-info__comment__author><a ng-if=\"vm.comment.user.account_type === \'personal\'\" class=report-detail-compile-template__main-info__comment__author__wrapper ui-sref=\"user-home-page.personal.home({id: vm.comment.user.id})\" target=_blank><pixerf-user-avatar class=report-detail-compile-template__main-info__comment__author__avatar user-data=vm.comment.user lazy=true></pixerf-user-avatar></a><pixerf-user-avatar ng-if=\"vm.comment.user.account_type === \'business\'\" class=report-detail-compile-template__main-info__comment__author__avatar user-data=vm.comment.user lazy=true></pixerf-user-avatar><div class=report-detail-compile-template__main-info__comment__general-info><div class=report-detail-compile-template__main-info__comment__general-info__name>{{vm.comment.user.displayName}}</div><div class=report-detail-compile-template__main-info__comment__general-info__date>{{vm.commentFomatedDate}}</div></div></div><div class=report-detail-compile-template__main-info__comment__description>{{vm.comment.text}}</div><div ng-if=\"vm.comment.photos && vm.comment.photos.length\" class=report-detail-compile-template__main-info__comment__photo><div flex-grid ng-model=vm.comment.photos rowheight=50 lastrow=justify margins=10><div ng-repeat=\"photo in vm.comment.photos\"><a ng-attr-fancyboxable=\"{\'type\': \'image\', \'overlayShow\': true, \'hideOnOverlayClick\': true, \'showNavArrows\': true, \'margin\': \'50 10 15 10\', \'centerOnScroll\': true}\" href={{photo.url.large}} rel=commentAttachment><img ng-src={{photo.url.thumbnail}}></a></div></div></div></div><div class=report-detail-compile-template__button__wrapper><div ng-if=\"vm.isShowResolveButton && ( vm.report.community.previous_deactivation_count < 3)\" class=\"report-detail-compile-template__button report-detail-compile-template__button__resolve btn-cancel--no-background\" ng-click=vm.onResolveReport()>{{\'resolve\' | translate}}</div><div ng-if=vm.isShowRemoveButton class=\"report-detail-compile-template__button report-detail-compile-template__button__remove btn-submit\" ng-click=vm.onRemoveReport()>{{vm.removeText | translate}}</div><div ng-if=vm.isShowValidateButton class=\"report-detail-compile-template__button report-detail-compile-template__button__remove btn-submit\" ng-click=vm.onValidateReport()>{{\'validate\' | translate}}</div></div></div></div>");
$templateCache.put("app/components/report-item/report-item.html","<div><div class=report-item__reason><span>This comment was reported for </span><span class=report-item__reason__text>{{vm.reason}}</span> <span>by </span><span class=report-item__reason__text>{{vm.user.displayName || vm.user.email}}</span></div><div class=report-item><div uib-dropdown class=report-item__control-more><span ng-if=vm.controls.length uib-dropdown-toggle class=icon-icons_more></span><ul class=report-item__list uib-dropdown-menu role=menu><li ng-repeat=\"item in vm.controls\" ng-if=item.showControl role=menuitem class=report-item__item ng-click=item.cta()>{{item.label}}</li></ul></div><div class=report-item__header><div class=report-item__header__info><div class=report-item__header__info__author><pixerf-user-avatar user-data=vm.discussionAvatar class=report-item__header__info__author__cover lazy=true></pixerf-user-avatar><div class=report-item__header__info__author__info><a class=report-item__header__info__author__name ng-click=vm.prevenPubbleClick() ui-sref=\"user-home-page.personal.home({id: vm.discussion.user.id, userName: (vm.discussion.user.displayName | toSnakeCase)})\" target=_blank uib-tooltip=\"{{vm.discussion.user.displayName || vm.discussion.user.email}}\">{{vm.discussion.user.displayName || vm.discussion.user.email}} </a><span class=report-item__header__info__author__creator-type>{{vm.discussion.user.organization ? vm.discussion.user.organization.name : \'\'}}</span></div></div><div class=report-item__header__info__time>{{vm.inserted_at}}</div></div><div class=report-item__header__title ng-click=vm.goDetailDiscussion(vm.discussion)>{{vm.discussion.subject}}</div></div><div class=report-item__content ng-click=vm.goDetailDiscussion(vm.discussion)><div class=report-item__description>{{vm.discussion.description}}</div><div ng-if=\"vm.discussion.photos && vm.discussion.photos.length\" class=report-item__photo-grid flex-grid ng-model=vm.discussion.photos rowheight=50 lastrow=justify margins=10><div ng-repeat=\"photo in vm.discussion.photos\"><a ng-attr-fancyboxable=\"{\'type\': \'image\', \'overlayShow\': true, \'hideOnOverlayClick\': true, \'showNavArrows\': true, \'margin\': \'50 10 15 10\', \'centerOnScroll\': true}\" href={{photo.url.large}} rel=discussionAttachment><img ng-src={{photo.url.thumbnail}}></a></div></div></div><div class=report-item__info><div class=report-item__info__status><div ng-if=\"vm.discussion.like_count > 0\" class=report-item__info__like ng-click=vm.onShowListLike() title=\"Click to see who liked this discussion\"><span class=\"report-item__control__icon icon-icons_like\"></span> <span class=report-item__info__value>{{vm.discussion.like_count}}</span></div><div ng-if=\"vm.discussion.reply_count > 0\" class=report-item__info__reply ng-click=vm.onShowListReply() title=\"Click to see who replied this photo\"><span class=report-item__info__value>{{vm.discussion.reply_count}}</span> <span>{{vm.discussion.reply_count === 1 ? (\'reply\' | translate).toLowerCase() : (\'replies\' | translate).toLowerCase()}}</span></div></div><div class=report-item__info__action><button ng-if=vm.showKeepPostBtn class=\"report-item__info__action__reject-btn btn btn--transparent\" ng-click=vm.onKeepPost()><span class=\"report-item__info__action__btn-icon icon-icons_close\"></span> <span class=report-item__info__action__btn-label>Keep Post</span></button> <button ng-if=vm.showRemovePostBtn class=\"report-item__info__action__approve-btn btn btn-submit\" ng-click=vm.onRemovePost()><span class=\"report-item__info__action__btn-icon icon-icons_check\"></span> <span class=report-item__info__action__btn-label>Remove Post</span></button></div></div></div></div>");
$templateCache.put("app/components/request-hires-popup/request-hires-popup.html","<div class=request-hires-popup__container><div class=request-hires-popup__container__text>You will not be able to reselect photos or request for further edits once you download the high resolution files.<br><br>Please confirm if you would like to proceed with the request.</div><div class=\"request-hires-popup__container__footer clearfix\"><button class=\"request-hires-popup__container__footer__cancel-btn btn btn-cancel--no-background\" ng-click=vm.dismiss()>Cancel</button> <button class=\"request-hires-popup__container__footer__confirm-btn btn btn-submit\" ng-click=vm.requestDownload()>Yes</button></div></div>");
$templateCache.put("app/components/request-license-btn/request-license-btn.html","<div class=request-license-btn><span class=text--semibold authentication-click=vm.onRequestLicenseBtnClicked(media)><ng-transclude></ng-transclude></span></div>");
$templateCache.put("app/components/request-license-popup/request-license-popup.html","<pixerf-alert instance=vm.pixerfAlert></pixerf-alert><div class=request-license-popup><div class=\"request-license-popup__close-icon icon-icons_close\" ng-click=vm.close()></div><div class=clearfix><div class=\"modal-header text-left text--bold\" translate>{{\'request-for-license\'}}</div><div class=\"modal-body text-left\"><p>Hey there! Our Curators have yet to approve the commercial license for this photo.</p><p>If you\'d like to use this photo for commercial purposes, you can send a request for immediate review and we\'ll pop it to the top of our priority list.</p></div><div class=modal-footer><div class=modal-footer__group-btn><button ng-click=vm.close() type=button class=\"btn btn-cancel\">{{\'no-thanks\' | translate}}</button> <button ng-click=vm.onRequestLicenseBtnClicked() type=button class=\"btn btn-submit\">{{\'send-request\' | translate}}</button></div></div></div></div>");
$templateCache.put("app/components/request-payout-btn/request-payout-btn.html","<button ng-disabled=\"vm.isWorking || earnings.available_payout == 0\" class=\"btn btn-submit my-earnings-page__request-btn\" ng-click=\"vm.onRequestPayoutBtnClicked(earnings, payoutMethod)\">{{\'request-payout\' | translate}}</button>");
$templateCache.put("app/components/request-to-join-community/request-to-join-community.html","<div class=\"request-to-join-community clearfix\"><div class=\"request-to-join-community__row first-column\"><pixerf-checkbox class=vertical-align-middle--transform model=vm.community model-property=isSelected on-changed=vm.onSelectedChanged()></pixerf-checkbox></div><div class=\"request-to-join-community__row request-to-join-community__btns third-column\"><div class=vertical-align-middle--transform><button class=\"btn btn--black-magento pull-left request-to-join-community__btns__withdraw-btn\" ng-click=vm.onWithdrawBtnClicked(vm.community)></button></div></div><div class=\"clearfix second-column\"><div class=\"row clearfix\"><pixerf-avatar class=\"first-column no-padding\" avatar=vm.community.avatar></pixerf-avatar><div class=\"request-to-join-community__row second-column__sub\"><div class=clearfix><div class=\"text--bold text--truncate\"><a ui-sref=\"{{vm.commonConst.STATE.COMMUNITIES_DETAILS_DISCUSSIONS}}({id: vm.community.id})\" target=_blank class=text--color-black-6>{{vm.community.name}}</a></div><div class=\"text--color-black-5 second-column__sub__no-of-member\">{{vm.community.member_count | number:0}} members</div></div></div></div></div></div>");
$templateCache.put("app/components/resend-reset-password-popup/resend-reset-password-popup.html","<div class=resend-reset-password-popup><div class=clearfix><button type=button class=close ng-click=vm.cancel()><span class=icon-icons_close aria-hidden=true></span></button><div class=\"modal--title text-left text--color-black\">{{vm.messages.m1}}</div><br><div class=\"modal-body text-left text--color-black-2\"><p class=greeting-message>{{vm.messages.m2}}</p><p class=description-message>{{vm.messages.m3}}</p></div><br><div class=modal-footer><button ng-click=vm.cancel() type=button class=\"btn btn-cancel pixerf-btn-tn pull-right\">Cancel</button> <button class=\"btn btn-submit pull-left pixerf-btn-tn text-left\" ng-click=vm.onResendBtnClicked()>{{vm.resendEmail}}</button></div></div></div>");
$templateCache.put("app/components/resend-verification-email-popup/resend-verification-email-popup.html","<pixerf-alert instance=vm.pixerfAlert.data></pixerf-alert><div class=sign-up-verify-popup><div class=clearfix><button type=button class=close ng-click=vm.cancel()><span class=icon-icons_close aria-hidden=true></span></button><div class=\"modal__title text--semibold text--color-black\">{{vm.messages.m1}}</div><br><div class=\"modal-body text-center\"><p class=\"greeting-message text--bold text--color-black\">{{vm.messages.m2}}</p><p class=description-message>{{vm.messages.m3}}</p></div><br><div class=modal-footer><button ng-hide=vm.isHideResendBtn class=\"btn btn-submit pixerf-btn-tn text-center\" ng-click=vm.onResendBtnClicked()>{{vm.resendBtnTxt}}</button> <button ng-click=vm.cancel() type=button class=\"btn btn-cancel pixerf-btn-tn\">{{vm.cancelBtnTxt}}</button></div></div></div>");
$templateCache.put("app/components/reset-password/reset-password.html","<pixerf-alert instance=vm.pixerfAlert></pixerf-alert><div id=reset-password class=\"reset-password credential-modal\"><div class=clearfix><button type=button class=close ng-click=vm.cancel()><span aria-hidden=true>×</span></button><div class=\"modal-header text-center\"><h3 class=\"modal--title text--bold text--color-black\">Forgot your password?</h3><h5 class=reset-password__guidelines>Enter the email address that you used to register. We\'ll send you an email with a link to reset your password.</h5></div><div class=\"modal-body text-center\"><form class=margin-md--top name=resetPasswordForm><div class=form-group><input ng-disabled=vm.isWorking required name=email ng-click=\"vm.userValidation.data.errors.email = null\" uib-popover={{vm.userValidation.data.errors.email}} popover-trigger=false popover-is-open=\"vm.userValidation.data.errors.email !== null\" popover-placement=top-left ng-model=vm.email.data placeholder=Email type=email class=form-control enter=\"vm.onSendBtnClicked(vm.email.data, resetPasswordForm)\"></div></form></div><div class=modal-footer><button ng-disabled=vm.isWorking ng-click=\"vm.onSendBtnClicked(vm.email.data, resetPasswordForm)\" type=button class=\"btn btn-block btn-submit modal__btn-sign-in\">Send</button> <button ng-click=vm.cancel() type=button class=\"btn btn-cancel btn-block btn-cancel\">Cancel</button></div></div></div>");
$templateCache.put("app/components/scroll-paging/scroll-paging.html","<div class=scroll-paging ng-class=\"{\'scroll-paging--loading\': spinner.isVisible}\"><spinner-win ng-if=spinner.isVisible spinner=spinner></spinner-win><!--<spinner spinner=\"spinner\"></spinner>--><div ng-if=\"isLastPage && showMessage && !spinner.isVisible\" class=\"scroll-paging__last-page-message text-center\"><span>{{message}}</span> <a ng-show=!hideBackToTop class=\"text--color-pixerf-theme text--bold\" ng-click=\"vm.scrollToSection(sectionId, offsetTop)\">{{\'back-to\' | translate: {name: (\'top\' | translate).toLowerCase()}}}</a></div></div>");
$templateCache.put("app/components/scroll-to/scroll-to.html","<a class=scroll-arrow href=\"\" ng-class=\"color === \'black\' ? \'scroll-arrow--black\' : \'\'\"><span class=arrow-icon ng-if=!text ng-class=\"direction === \'up\' ? \'icon-icons_chevron-up\' : \'icon-icons_chevron-down\'\"></span> <span ng-if=text class=scroll-text>{{text}}</span> </a>");
$templateCache.put("app/components/scroll-to-top/scroll-to-top.html","<div class=\"btn btn-default scroll-to-top-btn\" title=\"Scroll to Top\"><span class=icon-icons-arrow-up></span></div>");
$templateCache.put("app/components/search-input/search-input.html","<form class=search-input enter=vm.onEnterKeyPressed() selector=input><tags-input add-on-blur=true min-length=1 placeholder=\"{{placeholder ? placeholder : \'Search images\'}}\" ng-model=vm.tags.data on-tag-added=vm.tagAdded($tag) on-tag-removed=vm.tagRemoved($tag) replace-spaces-with-dashes=false></tags-input></form>");
$templateCache.put("app/components/select-exist-photos-popup/select-exist-photos-popup.html","<div class=select-exist-photos-popup><button type=button class=close ng-click=vm.closePopup(vm.objectParams)><span class=icon-icons_close aria-hidden=true></span></button><div class=select-exist-photos-popup__header>{{vm.options.title}}</div><div class=select-exist-photos-popup__content><div class=select-exist-photos-popup__content__photo-grid><div infinite-scroll-disabled=vm.isNoMorePageToLoad infinite-scroll=vm.fetchMorePhotos() infinite-scroll-immediate-check=false infinite-scroll-container=\"\'.select-exist-photos-popup__content__photo-grid\'\"><div flex-grid ng-model=vm.photos><div ng-repeat=\"photo in vm.photos\" ng-click=vm.onPhotoSelected(photo)><img ng-src=\"{{photo.thumbnails[\'x400\']}}\"></div></div><scroll-paging spinner=vm.spinner show-message=vm.isNoMorePageToLoad is-last-page=vm.isNoMorePageToLoad message=\"No more photos.\"></scroll-paging></div></div></div></div>");
$templateCache.put("app/components/select-my-photo-popup/select-my-photo-popup.html","<div class=select-my-photo-popup><div class=\"select-my-photo-popup__header clearfix\"><button class=\"btn select-my-photo-popup__close icon-icons_close\" role=button ng-click=vm.closePopup()></button><div class=\"select-my-photo-popup__description pull-left text--color-black text--bold\"><span translate>{{vm.isSingleSelect ? \'select-your-photo\' : \'select-your-photos\'}}</span> <span ng-if=!vm.isSingleSelect>({{vm.selectedPhotos.length}})</span></div><div class=select-my-photo-popup__search-wrapper><div class=\"select-my-photo-popup__search-bar pull-right\"><search-input tags=vm.tags on-value-changed=vm.search()></search-input><button ng-click=vm.onSearchBtnClicked() type=button class=\"select-my-photo-popup__search-button pull-right\"><i class=icon-icons_search></i></button></div></div></div><div class=select-my-photo-popup__content><div class=select-my-photo-popup__content__photo-grid><photo-grid height=65vh hide-no-more-message=true ideal-height=250 container=.select-my-photo-popup__content instance=vm.photoGrid on-before-render=vm.onBeforeGridRender(photos) simple-select-mode=true on-photo-clicked=vm.onPhotoSelected(file)><div class=\"text-center search-result-page__no-result-message\" ng-if=\"vm.photoGrid.photos.length === 0 && !vm.isSearching\"><span class=icon-icons_search></span><h3 class=\"text-semibold no-message-notice text--semibold text--color-black\" translate>{{\'no-results-found\'}}</h3></div></photo-grid></div></div><div class=select-my-photo-popup__content__button-wrapper><div class=\"select-my-photo-popup__content__button select-my-photo-popup__content__button-cancel btn--transparent btn\" ng-click=vm.closePopup() translate>{{\'cancel\'}}</div><button ng-disabled=\"vm.isWorking || vm.selectedPhotos.length === 0\" class=\"select-my-photo-popup__content__button select-my-photo-popup__content__button-submit btn-submit btn\" ng-click=vm.onSubmitPhotoToMissionClicked() translate>{{\'submit-to-challenge\'}}</button></div></div>");
$templateCache.put("app/components/select-new-exist-cover-popup/select-new-exist-cover-popup.html","<div class=select-new-exist-cover-popup><div class=\"select-new-exist-cover-popup__close icon-icons_close\" ng-click=vm.closePopup()></div><div class=select-new-exist-cover-popup__header>Change Cover Photo</div><div class=select-new-exist-cover-popup__body><div class=\"btn btn-submit select-new-exist-cover-popup__button\" ng-click=vm.onUploadNewPhotoBtnClicked()>Upload new photo</div><div class=select-new-exist-cover-popup__hint>OR</div><div class=\"btn btn-submit select-new-exist-cover-popup__button\" ng-click=vm.onUploadFromMineBtnClicked()>Select existing photos</div></div></div>");
$templateCache.put("app/components/select-type-reject-photo-popup/select-type-reject-photo-popup.html","<div class=select-type-reject-photo-popup__content><div class=clearfix><button type=button class=close ng-click=vm.closePopup()><span class=icon-icons_close aria-hidden=true></span></button><div class=modal-header><div class=modal--title>Reject photo from</div></div><div class=modal-footer><button ng-click=\"vm.onRejectClicked(\'mission\')\" type=button class=\"btn btn-submit select-type-reject-photo-popup__mission-btn\">Mission only</button> <button ng-click=\"vm.onRejectClicked(\'all\')\" type=button class=\"btn btn--grey select-type-reject-photo-popup__missiong-marketpplace-btn\">Mission and Marketplace</button></div></div></div>");
$templateCache.put("app/components/send-release-form-email-popup/send-release-form-email-popup.html","<pixerf-alert instance=vm.pixerfAlert.data></pixerf-alert><div class=send-release-form-email-popup><div class=clearfix><button type=button class=close ng-click=vm.cancel()><span class=icon-icons_close aria-hidden=true></span></button><div class=\"modal--title text-left\">Commercial license pending for approval.</div><div class=\"modal-body text-left\"><p>Please fill up and upload the PIXERF release form(s).</p><p>Would you like us to email you the release form(s)?</p></div><div class=\"modal-footer text-center\"><div class=modal-footer__group-btn><button ng-click=vm.cancel() type=button class=\"btn btn-cancel\">No, I already have a copy</button> <button ng-disabled=vm.isWorking class=\"btn btn-submit text-center\" ng-click=vm.onSendEmailBtnClicked(vm.fileHandles)>Yes, please email me</button></div></div></div></div>");
$templateCache.put("app/components/set-ambassador-btn/set-ambassador-btn.html","<div class=\"set-ambassador-btn-wrapper text-center\"><button ng-click=vm.onClicked() ng-mouseover=vm.onMouseOver() ng-mouseleave=vm.onMouseLeave() ng-disabled=vm.isWorking ng-class=\"{\'set-ambassador-btn--set\': !!vm.ambassadorship, \'set-ambassador-btn--unset\': vm.isHovering}\" class=\"btn btn-pixerf-theme--blue btn-pixerf-theme--no-background text--bold set-ambassador-btn\"><span class=\"icon- ambassador-btn__icon\"></span><span class=set-ambassador-btn__btn-label>{{vm.btnLabel}}</span></button></div>");
$templateCache.put("app/components/setting-add-role/setting-add-role.html","<div class=setting-add-roles><div class=\"row clearfix bg--white\"><add-roles user=vm.user></add-roles><div class=\"row setting__main-content__footer\"><div class=\"form-group col-md-12 text-center\"><button class=\"edit-password__btn-wrapper__btn btn btn-submit pixerf-btn-md\" ng-click=\"vm.onSaveBtnClicked(vm.personRoles, addRolesForm)\">Save</button></div></div></div></div>");
$templateCache.put("app/components/share/share-icons.html","<div class=\"pixerf-share__social-icons text--color-black-2\"><a socialshare socialshare-provider=facebook socialshare-title={{contentWillBeShared.title}} socialshare-description={{contentWillBeShared.description}} socialshare-via=485548001838575 socialshare-type=share socialshare-media={{contentWillBeShared.media}} socialshare-url={{contentWillBeShared.url}} class=pixerf-share__social-icons__icon title=\"{{\'share-to\' | translate: {social_media: \'facebook\'}}}\" pixerf-close-on-click=true><span class=icon-icons_facebook></span> </a><a socialshare socialshare-provider=twitter socialshare-via=pixerf socialshare-url={{contentWillBeShared.url}} socialshare-text={{contentWillBeShared.title}} class=pixerf-share__social-icons__icon title=\"{{\'share-to\' | translate: {social_media: \'twitter\'}}}\" pixerf-close-on-click=true><span class=\"fa fa-twitter\"></span> </a><a socialshare socialshare-provider=pinterest socialshare-text={{contentWillBeShared.description}} socialshare-media={{contentWillBeShared.media}} socialshare-url={{contentWillBeShared.url}} class=pixerf-share__social-icons__icon title=\"{{\'share-to\' | translate: {social_media: \'pinterest\'}}}\" pixerf-close-on-click=true><span class=\"fa fa-pinterest\"></span></a></div>");
$templateCache.put("app/components/share/share-popover.html","<ng-include src=\"\'app/components/share/share-icons.html\'\"></ng-include><!-- <a href=\"\">Embeded link</a> -->");
$templateCache.put("app/components/share/share.html","<div class=pixerf-share ng-class=\"{\'display-vertical\': displayVertical}\"><a ng-if=!settings.flatMode class=pixerf-share__link><span type=button popover-trigger=\"\'outsideClick\'\" popover-class={{vm.popoverClass}} popover-append-to-body=settings.appendToBody uib-popover-template=\"\'app/components/share/share-popover.html\'\" popover-placement=\"{{settings.popoverPlacement ||\'bottom\'}}\" class=\"{{settings && settings.circle ? \'social-icon-grey-color\' : \'icon-icons_share\'}}\"></span></a><div ng-if=settings.flatMode><ng-include src=\"\'app/components/share/share-icons.html\'\"></ng-include></div></div>");
$templateCache.put("app/components/shopping-cart-my-credit-balance-review/shopping-cart-my-credit-balance-review.html","<div class=shopping-cart-my-credit-balance-review><div class=\"shopping-cart-my-credit-balance-review__title text--bold\" translate>{{\'my-credits\'}}</div><div class=shopping-cart-my-credit-balance-review__balance-wrapper><div class=\"clearfix text--bold\"><div class=\"shopping-cart-my-credit-balance-review__balance-money clearfix\"><div class=\"shopping-cart-my-credit-balance-review__balance-money__unit pull-left\">SGD</div><div class=\"shopping-cart-my-credit-balance-review__balance-money__number pull-left\">{{vm.currentBalance | number:2}}</div></div><div class=shopping-cart-my-credit-balance-review__balance-text translate>{{\'available-balance\'}}</div></div><div ng-if=addCreditBtn><div class=shopping-cart-my-credit-balance-review__save-wrapper ng-if=\"vm.currentBalance === 0\"><div class=\"shopping-cart-my-credit-balance-review__save-title text--bold\">SAVE NOW!</div><div class=shopping-cart-my-credit-balance-review__save-description>Our flexible credit plans suit any budget and will help you save more. Use only what you need, when you need.</div></div><div class=\"shopping-cart-my-credit-balance-review__notice call-action-messages__title-wrapper\" ng-if=\"vm.currentBalance < vm.totalToPay && vm.currentBalance !== 0\"><span class=\"shopping-cart-my-credit-balance-review__notice-icon label text--bold text--color-white\">!</span> <span class=shopping-cart-my-credit-balance-review__notice-text>Oops! It looks like your Credit needs a top-up.</span></div><a ui-sref=checkout.credit-plan.credit-plan-list target=_blank><div role=button class=\"btn btn-submit--no-background btn-add-more-credit\" ng-bind=\"vm.currentBalance < vm.totalToPay ? \'Add More Credit\' : (\'view-credit-plans\' | translate)\"></div></a></div></div></div>");
$templateCache.put("app/components/shortcut/shortcut.html","<div class=shortcut ng-class=context><div class=shortcut__icon ng-class=vm.dataBinding.icon></div><div class=shortcut__btn authentication-click=onButtonClicked()>{{vm.dataBinding.title}}</div></div>");
$templateCache.put("app/components/showcased-gallery-btn/showcased-gallery-btn.html","<div><div ng-if=\"!gallery.is_starred && gallery.user.isAdminInternal\" ng-class=\"{\'showcased-gallery-btn--selected\': gallery.is_showcase}\" class=showcased-gallery-btn ng-click=\"vm.onShowcasedGalleryBtnClicked(gallery); $event.stopPropagation()\" title=\"{{gallery.is_showcase ? \'Remove showcase gallery\' : \'Set as showcase gallery\'}}\"><span class=\"fa fa-home\"></span></div></div>");
$templateCache.put("app/components/sign-in/sign-in.html","<pixerf-alert class=signin-popup instance=vm.pixerfAlert.data></pixerf-alert><div id=sign-in class=credential-modal><div class=clearfix><button type=button class=close ng-click=vm.cancel()><span class=icon-icons_close aria-hidden=true></span></button><div class=\"credential-modal__header-logo mobile-show\"><div class=pixerf-logo></div></div><div class=\"modal-header text-center\"><h3 class=\"modal--title text--bold text--color-black\" translate>{{\'welcome-back\'}}!</h3></div><div class=\"modal-body text-center\"><div ng-click=\"vm.onSignInBtnClicked(\'facebook\')\"><a class=\"btn btn-block btn-social btn-facebook\" ng-click=\"\"><span class=\"fa fa-facebook\"></span> Log In with Facebook</a></div><div class=\"text--hr text-uppercase\"><span>or</span></div><form name=signInForm><div class=form-group><input name=email required ng-model=vm.user.data.email placeholder=Email type=text class=form-control></div><div class=form-group><input enter=\"vm.onSignInBtnClicked(\'Username-Password-Authentication\',signInForm)\" name=password required type=password ng-model=vm.user.data.password placeholder=Password class=form-control></div></form></div><div class=modal-footer><button ng-click=\"vm.onSignInBtnClicked(\'Username-Password-Authentication\',signInForm)\" type=button class=\"btn btn-block btn-submit modal__btn-sign-in text--semibold\">Log In</button><div class=modal-footer-foot-notes><a ng-click=vm.showResetPasswordModal()>Forgot your password?</a><h5>New to PIXERF? <a class=\"text--bold text--color-pixerf-theme\" ng-click=vm.showSignUpModal()>Sign Up Now</a><h5></h5></h5></div></div></div></div>");
$templateCache.put("app/components/sign-in-user/sign-in-user.html","<div id=sign-in class=sign-in-user><div class=\"sign-in-user__wrapper clearfix\"><div class=\"sign-in-user__header clearfix\"><h3 class=\"sign-in-user__header__title text--extrabold text--color-black\">{{\'welcome-back\' | translate}}! <span ng-if=customSignupHeaderText><br>{{customSignupHeaderText}}</span></h3></div><div class=sign-in-user__content><div class=\"sign-in-user__content__label text--bold\" translate ng-hide=hiddenLoginBySocial>{{\'log-in-with\'}}</div><div class=row ng-hide=options.hiddenLoginBySocial><!-- <div class=\"sign-in-user__content__social-btn fb-btn col-xs-6 no-padding-left\" ng-click=\"vm.onSignInBtnClicked(\'facebook\')\">\r\n					<a class=\"btn btn-block btn-social btn-facebook text--bold\" ng-click=\"\" ng-disabled=\"vm.isWorking\">\r\n						<span class=\"fa fa-facebook\"></span>\r\n						Facebook\r\n					</a>\r\n				</div> --><div class=\"sign-in-user__content__social-btn google-btn no-padding-left\" ng-click=\"vm.onSignInBtnClicked(\'google-oauth2\')\"><a class=\"btn btn-block btn-social btn-google text--bold text--color-black\" ng-click=\"\" ng-disabled=vm.isWorking><span class=social-media-google></span> <span>Google</span></a></div></div><div ng-hide=hiddenLoginBySocial class=\"sign-in-user__content__label text--bold\" translate>{{\'signup-with-email\'}}</div><div class=sign-in-user__error-not-biz-acc ng-if=options.isBiz><span ng-if=vm.showNotBizAccError>{{\'sorry-this-feature-is-only-available-for-Business-users\'| translate}}</span></div><form name=signInForm><div class=form-group><label for=email ng-class=\"!signInForm.$pristine && signInForm.email.$invalid ? \'text--color-error\' : \'text--color-black\'\" translate>{{\'email\'}}</label><input name=email required ng-model=vm.user.data.email type=text class=form-control></div><div class=\"form-group password-wrapper\"><label for=password ng-class=\"!signInForm.$pristine && signInForm.password.$invalid ? \'text--color-error\' : \'text--color-black\'\" translate>{{\'password\'}}</label><input enter=\"vm.onSignInBtnClicked(\'Username-Password-Authentication\',signInForm)\" name=password required type=password ng-model=vm.user.data.password class=form-control ng-attr-type=\"{{vm.isShowPassword.data ? \'text\' : \'password\'}}\"><div maxlength=255 title=\"{{\'hover-show-hide-password\' | translate}}\" class=\"btn-toogle-password text--bold\" ng-click=\"vm.isShowPassword.data = !vm.isShowPassword.data\" ng-if=vm.isShowPassword.data>{{\'hide\' | translate}}</div><div maxlength=255 title=\"{{\'hover-show-hide-password\' | translate}}\" class=\"btn-toogle-password text--bold\" ng-click=\"vm.isShowPassword.data = !vm.isShowPassword.data\" ng-if=!vm.isShowPassword.data>{{\'show\' | translate}}</div></div><a class=\"forgot-password text--bold\" ng-click=vm.showResetPasswordModal() translate>{{\'forgot-password\'}}?</a></form></div><div class=sign-in-user__footer><button ng-disabled=vm.isWorking ng-class=\"{\'is-working\': vm.isWorking}\" ng-click=\"vm.onSignInBtnClicked(\'Username-Password-Authentication\',signInForm)\" type=button class=\"btn btn-block btn-submit sign-in-user__footer__signup-btn\" translate><i class=\"fa fa-2x fa-spin fa-spinner\"></i>{{\'log-in\'}}</button><div class=sign-in-user__footer__notes><h5>{{options.isBiz ? customSignupText :(\'new-to-pixerf\' | translate)}}? <a class=\"text--bold text--color-black\" ng-click=vm.showSignUpModal()><span translate>{{\'sign-up-now\'}}</span></a><h5></h5></h5></div></div></div></div>");
$templateCache.put("app/components/signature-gallery-btn/signature-gallery-btn.html","<div><div ng-attr-title=\"{{vm.loginnedUser.canOverrideCuration ? \'\' : !target.is_signature ? \'Signatured this photo\' : \'Remove signature\'}}\" ng-class=\"{\'signature-gallery-btn--signatured\': target.is_signature, \'signature-gallery-btn__signature-gallery-count-hover\': hoverShowNumber}\" class=signature-gallery-btn ng-click=\"vm.onSignatureBtnClicked(target); $event.stopPropagation()\" ng-mouseover=\"vm.loginnedUser.canOverrideCuration ? vm.onMouseInCuratorStars(target) : \'\'\" tooltip-placement=bottom tooltip-is-open=\"isShowTooltip && vm.tooltipsCurators.length > 0\" tooltip-class=tooltip-curators ng-attr-uib-tooltip-template=\"isShowTooltip && vm.tooltipsCurators.length > 0 && vm.loginnedUser.canOverrideCuration ? \'curators-tooltip-template\' : \'\'\"><span class=icon-icons-gallery></span></div><script type=text/ng-template id=curators-tooltip-template ng-if=\"isShowTooltip && vm.tooltipsCurators.length > 0\"><div class=\"tag-template\" ng-repeat=\"curator in vm.tooltipsCurators\">\r\n            <span>{{curator}}</span>\r\n        </div></script></div>");
$templateCache.put("app/components/signature-section/signature-section.html","<section class=\"row trendinggallaries no-margin\"><div class=\"row text-center trendinggallaries-intro\"><p class=\"trendinggallaries-intro-title col-md-5 none-float horizental-centered\">Signature</p></div><div class=\"row trendinggallaries-menu\"><nav class=navbar><div class=container-fluid><div class=navbar-header><button type=button class=\"navbar-toggle collapsed\" data-toggle=collapse data-target=#trendinggallaries-nav aria-expanded=false><div class=trendinggallaries-menu-name>{{vm.selectedCategory.data.name}}<div class=arrow-animation-menu-collapse><span class=\"icon-bar dash-one\"></span> <span class=\"icon-bar dash-two\"></span></div></div></button></div><div class=\"collapse navbar-collapse pixerf-navbar-text\" navbar-collapse-on-click=true id=trendinggallaries-nav><ul class=\"nav navbar-nav navbar-left col-md-12\"><li class=trendinggallaries-nav_menu__menu-item ng-class=\"category.isSelected ? \'navbar--active\' : \'\'\" ng-repeat=\"category in vm.signatureCategories.data.expanded\" ng-click=vm.onCategorySelected(category)><a>{{category.name}}</a></li></ul></div></div></nav></div><div class=trendinggallaries-mobile-screen><!-- <div uib-carousel active=\"active\" class=\"trendinggallaries-carousel\" interval=\"vm.slideInterval\">\r\n			<div uib-slide ng-repeat=\"slide in vm.slides track by slide.id\" index=\"slide.id\">\r\n				<div class=\"carousel-inner\"	ng-swipe-left=\"$parent.vm.next()\" ng-swipe-right=\"$parent.vm.prev()\"> </div>\r\n				<div class=\"trendinggallaries-carousel trendinggallaries-carousel-showcase\" style=\"background-image: url({{slide.url}});\"></div>\r\n			</div>\r\n		</div> --><div class=\"trendinggallaries-carousel carousel\"><slick dots=true class=carousel-inner infinite=true speed=1000 autoplayspeed=400 slides-to-show=1 touch-move=true slides-to-scroll=1 autoplay=true init-onload=true data=vm.slides><div ng-repeat=\"slide in vm.slides track by slide.id\" index=slide.id class=item><div class=\"trendinggallaries-carousel trendinggallaries-carousel-showcase\" style=\"background-image: url({{slide.url}})\"></div></div></slick></div><div class=trendinggallaries-photos-galleryinfo><div class=trendinggallaries-photos-galleryinfo-cell><h2 class=\"trendinggallaries-photos-galleryinfo-title text--bold text--color-black\">Discover the beauty<br>of PIXERF Signature</h2><h3 class=trendinggallaries-photos-galleryinfo-text>Here\'s one more way for you to stand out. We\'re looking for beautiful, premium quality Asian stock photos to feature in our finely curated Signature galleries.</h3><button ng-if=\"!vm.loginUser || vm.loginUser.canUploadPhotos\" authentication-click type=button class=\"btn btn-submit trendinggallaries-photos-galleryinfo-explorebtn\" ng-click=vm.onStartUploading()>Start Uploading</button> <a ng-if=\"vm.loginUser && !vm.loginUser.canUploadPhotos\" class=\"btn btn-submit trendinggallaries-photos-galleryinfo-explorebtn\" ng-href=#/marketplace/galleries/pixerf>Start Searching</a></div></div></div><div class=\"trendinggallaries-photos clearfix\"><div class=\"trendinggallaries-photos-big no-padding\" ng-style=\"{\'background-image\': \'url(\' + vm.selectedCategory.data.galleries[0].url + \')\'}\" ng-click=\"vm.onGallerySelected( vm.selectedCategory.data.galleries[0])\"><div class=overlay></div><div class=\"pixerf-hover text--color-white text--bold pixerf-hover-text-xlg\"><span class=pixerf-hover-text ng-bind-html=vm.selectedCategory.data.galleries[0].title></span></div></div><div class=\"trendinggallaries-photos-small no-padding\"><div class=row><div ng-style=\"{\'background-image\': \'url(\' + vm.selectedCategory.data.galleries[1].url + \')\'}\" class=trendinggallaries-photos-small-item ng-click=\"vm.onGallerySelected( vm.selectedCategory.data.galleries[1])\"><div class=overlay></div><div class=\"pixerf-hover text--color-white text--bold pixerf-hover-text-lg\"><span class=pixerf-hover-text ng-bind-html=vm.selectedCategory.data.galleries[1].title></span></div></div><div ng-style=\"{\'background-image\': \'url(\' + vm.selectedCategory.data.galleries[2].url + \')\'}\" class=trendinggallaries-photos-small-item ng-click=\"vm.onGallerySelected( vm.selectedCategory.data.galleries[2])\"><div class=overlay></div><div class=\"pixerf-hover text--color-white text--bold pixerf-hover-text-lg\"><span class=pixerf-hover-text ng-bind-html=vm.selectedCategory.data.galleries[2].title></span></div></div></div><div class=row><div ng-style=\"{\'background-image\': \'url(\' + vm.selectedCategory.data.galleries[3].url + \')\'}\" class=trendinggallaries-photos-small-item ng-click=\"vm.onGallerySelected( vm.selectedCategory.data.galleries[3])\"><div class=overlay></div><div class=\"pixerf-hover text--color-white text--bold pixerf-hover-text-lg\"><span class=pixerf-hover-text ng-bind-html=vm.selectedCategory.data.galleries[3].title></span></div></div><div class=trendinggallaries-photos-galleryinfo><div class=trendinggallaries-photos-galleryinfo-cell><h2 class=\"trendinggallaries-photos-galleryinfo-title text--bold text--color-black\">Discover the beauty<br>of PIXERF Signature</h2><h3 class=trendinggallaries-photos-galleryinfo-text>Here\'s one more way for you to stand out. We\'re looking for beautiful, premium quality Asian stock photos to feature in our finely curated Signature galleries.</h3><button ng-if=\"!vm.loginUser || vm.loginUser.canUploadPhotos\" authentication-click type=button class=\"btn btn-submit trendinggallaries-photos-galleryinfo-explorebtn\" ng-click=vm.onStartUploading()>Start Uploading</button> <a ng-if=\"vm.loginUser && !vm.loginUser.canUploadPhotos\" class=\"btn btn-submit trendinggallaries-photos-galleryinfo-explorebtn\" ng-href=#/marketplace/galleries/pixerf>Start Searching</a></div></div></div></div><div ng-if=\"context !== \'ABOUT_PAGE\'\"><scroll-to target=\"\'section.homepage-brands\'\" class=scroll-arrow></div></div></section>");
$templateCache.put("app/components/signup-add-role-popup/signup-add-role-popup.html","<div class=signup-add-role-popup><button type=button class=close ng-click=vm.cancel()><span class=icon-icons_close aria-hidden=true></span></button><add-role user=vm.user></add-role><div class=\"form-group text-center\"><button class=\"btn btn-cancel pixerf-btn-md\" ng-click=vm.back()>Back</button> <button class=\"btn btn-submit pixerf-btn-md\" ng-click=\"vm.onDoneBtnClicked(vm.user, profileForm)\">Done</button></div></div>");
$templateCache.put("app/components/similar-discussion-tile/similar-discussion-tile.html","<div class=similar-discussion-tile ng-click=vm.goDetailDiscussion(vm.discussion)><div class=similar-discussion-tile__title>{{vm.discussion.subject}}</div><div class=similar-discussion-tile__info><div class=similar-discussion-tile__info__author>{{vm.discussion.user.displayName}}</div><div class=similar-discussion-tile__info__dot></div><div class=similar-discussion-tile__info__time>{{vm.inserted_at}}</div></div></div>");
$templateCache.put("app/components/spinner/spinner.html","<div ng-show=spinner.isVisible class=relative><div class=text-center><img src=assets/images/ajax-loader.gif alt=\"\"></div></div>");
$templateCache.put("app/components/spinner-win/spinner-win.html","<div class=spinner-win ng-show=spinner.isVisible ng-class=\"{\'spinner-win--isOverlay-mode absolute absolute--full\': isOverlayMode}\"><div class=bg_preloader><div class=\"preloader one\"></div><div class=\"preloader two\"></div><div class=\"preloader three\"></div></div></div>");
$templateCache.put("app/components/splash-message-popup/splash-message-popup.html","<div class=splash-message-popup><div class=splash-message-popup__header><div class=\"splash-message-popup__close icon-icons_close\" ng-class=\"{\'reverse\': vm.popup.id === \'splashPopupShowFlag_1258\'}\" role=button ng-click=vm.onCloseBtnClicked()></div></div><div ng-if=\"vm.popup.id === \'splashPopupShowFlag_1371\'\" class=splash-message-popup__body><div class=splash-message-popup__col-right><div class=\"splash-message-popup__time-remaining bigger-size\"><pixerf-count-down deadline=vm.end_date></pixerf-count-down></div><div class=splash-message-popup__title>The Future of Penang</div><div class=splash-message-popup__prize-wrapper><div class=splash-message-popup__prize-wrapper__winner>5 winners</div><div class=splash-message-popup__prize-wrapper__value>150 SGD each</div></div><div class=splash-message-popup__description>Calling all Malaysian photographers. We\'re looking for shots of the city Future of Penang. Capture Penang now and add your twist on how the future living, working and playing can be like in Penang. The future is yours to create. Show us the Futuristic Penang you hope to see! Send in your best entries to our new photo challenge, The Future of Penang and win $750 worth of cash prizes!</div><div class=splash-message-popup__controller><div class=splash-message-popup__controller__find-out-more ng-click=vm.onFindout()>Find out more</div><div class=splash-message-popup__controller__join ng-click=vm.onJoinChallenge(127)>Join the Challenge!</div></div><div class=splash-message-popup__checkbox><stick-checkbox model=vm model-property=isDontShowAgain on-changed=vm.onCheckboxClicked() label=\"Do not show this pop-up again.\"></stick-checkbox></div></div><div class=splash-message-popup__col-left><img ng-src={{vm.bannerSrc}} class=splash-message-popup__col-left__first-item></div></div></div>");
$templateCache.put("app/components/star-btn/star-btn.html","<div><div ng-attr-title=\"{{vm.loginnedUser.canOverrideCuration ? \'\' : !target.is_starred ? \'Star this photo\' : \'Remove star\'}}\" ng-class=\"{\'star-btn--stared\': target.is_starred, \'star-btn__star-count-hover\': hoverShowNumber}\" class=star-btn ng-click=\"vm.onStarBtnClicked(target, $event); $event.stopPropagation()\" ng-mouseover=\"vm.loginnedUser.canOverrideCuration ? vm.onMouseInCuratorStars(target) : \'\'\" tooltip-placement=bottom-left tooltip-is-open=\"isShowTooltip && vm.tooltipsCurators.length > 0\" tooltip-class=tooltip-curators ng-attr-uib-tooltip-template=\"isShowTooltip && vm.tooltipsCurators.length > 0 && vm.loginnedUser.canOverrideCuration ? \'curators-tooltip-template\' : \'\'\"><span class=icon-icons_star></span> <span ng-if=hoverShowNumber class=\"star-btn__star-count star-count--hover\">{{vm.getStarCount(target.star_count)}}</span></div><script type=text/ng-template id=curators-tooltip-template ng-if=\"isShowTooltip && vm.tooltipsCurators.length > 0\"><div class=\"tag-template\" ng-repeat=\"curator in vm.tooltipsCurators\">\r\n            <span>{{curator}}</span>\r\n        </div></script></div>");
$templateCache.put("app/components/star-item/star-item.html","<div class=star-item><a popup-link-clicked=\"{{\'/user-home-page/\' + star.user.id + \'/\' + (star.user.displayName | toSnakeCase)}}\" class=star-item__avatar><img class=img-circle src=assets/images/default/default-profile.png lazy-img-error=assets/images/default/default-profile.png lazy-img={{star.user.avatar.profileImage}}></a><div class=star-item__name><a popup-link-clicked=\"{{\'/user-home-page/\' + star.user.id + \'/\' + (star.user.displayName | toSnakeCase)}}\" class=\"star-item__name-link text--semibold text--color-black text--truncate\" ng-bind=\"vm.loginUser.id === star.user.id ? \'You\' : (star.user.displayName | toSnakeCase)\"></a></div><div class=unstar-btn-wrapper><button ng-disabled=vm.isWorking ng-click=vm.onRemoveStarBtnClick(star) class=\"btn btn-submit text--bold unstar-btn\">Remove</button></div></div>");
$templateCache.put("app/components/stick-checkbox/stick-checkbox.html","<div class=\"stick-checkbox {{customClass}}\" ng-class=\"{\'have-label\': label}\"><div class=\"stick-checkbox__stick {{layoutStyle}}\" ng-class=\"{\'error\': error,\r\n    \'disabled\': isDisabled,\r\n    \'checked\': isReversed ? model[modelProperty] === false : model[modelProperty] === true,\r\n    \'unknown\': model[modelProperty] === \'unknown\'}\"><div ng-if=authenticationCheck authentication-click=toogle($event) class=stick-checkbox__stick__child><div ng-if=\"layoutStyle === \'solid-box\'\" class=stick-checkbox__solid-box></div></div><div ng-if=!authenticationCheck ng-click=toogle($event) class=stick-checkbox__stick__child><div ng-if=\"layoutStyle === \'solid-box\'\" class=stick-checkbox__solid-box></div></div></div><div class=stick-checkbox__label translate>{{label}}</div></div>");
$templateCache.put("app/components/submit-frame-mission-popup/submit-frame-mission-popup.html","<div class=submit-frame-mission-popup><div class=\"submit-frame-mission-popup__close icon-icons_close\" role=button ng-click=vm.closePopup()></div><div class=submit-frame-mission-popup__content><div class=submit-frame-mission-popup__content__header><div class=submit-frame-mission-popup__content__header__proccess><div class=submit-frame-mission-popup__content__header__proccess__item ng-repeat=\"frame in vm.numberOfFrames track by $index\" ng-class=\"{\'done\': $index < vm.storedPhoto}\"></div></div><div ng-if=\"vm.storedPhoto <= vm.mission.number_of_frames\" class=submit-frame-mission-popup__content__header__title>Submitting {{vm.storedPhoto}} of {{vm.mission.number_of_frames}} photos</div><div class=submit-frame-mission-popup__content__header__description>To enter the mission, select {{vm.mission.number_of_frames}} photos to be uploaded.</div></div><div class=submit-frame-mission-popup__content__control-wrapper><div class=\"submit-frame-mission-popup__content__button btn btn-submit\" authentication-click=vm.onUploadNewPhotoBtnClicked() check-verified-email=true>{{\'upload-new-photo\' | translate}}</div><div class=submit-frame-mission-popup__content__hint>- {{\'or\' | translate}} -</div><div class=\"submit-frame-mission-popup__content__button btn btn-submit\" authentication-click=vm.onUploadFromMineBtnClicked() check-verified-email=true>{{\'from-my-photos\' | translate}}</div></div></div><div class=submit-frame-mission-popup__footer__wrapper><div class=submit-frame-mission-popup__footer><stick-checkbox on-changed=vm.onMissionAgreed() model=vm.mission model-property=is_agreement_accepted label={{vm.missionAgreement}} is-disabled=vm.mission.is_agreement_accepted error=\"!vm.mission.is_agreement_accepted && vm.isFormDirty\" layout-style=regular-square></stick-checkbox></div></div></div>");
$templateCache.put("app/components/submit-mission-photo-popup/submit-mission-photo-popup.html","<div class=\"submit-mission-photo-popup clearfix\"><div class=\"submit-mission-photo-popup__header clearfix\"><div class=\"submit-mission-photo-popup__close icon-icons_close\" role=button ng-click=vm.closePopup()></div></div><div class=submit-mission-photo-popup__content><div class=\"submit-mission-photo-popup__content__title text--extrabold text--color-black\" translate>{{\'submission-popup-how\'}}</div><div class=text-center><div class=\"submit-mission-photo-popup__content__button btn btn-submit text--bold\" authentication-click=vm.onUploadNewPhotoBtnClicked() check-verified-email=true>{{\'upload-new-photo\' | translate}}</div><div class=text--color-black>- {{\'or\' | translate}} -</div><div class=\"submit-mission-photo-popup__content__button btn btn-submit text--bold\" authentication-click=vm.onUploadFromMineBtnClicked() check-verified-email=true>{{\'from-my-photos\' | translate}}</div></div></div><div class=submit-mission-photo-popup__footer__wrapper><div class=\"submit-mission-photo-popup__footer pixerf-checkbox clearfix\"><pixerf-checkbox is-disabled=vm.mission.is_agreement_accepted on-changed=vm.onMissionAgreed() error=\"!vm.mission.is_agreement_accepted && vm.isFormDirty\" model=vm.mission model-property=is_agreement_accepted></pixerf-checkbox><span ng-if=!vm.mission.is_ioa compile=vm.missionAgreement></span> <span ng-if=vm.mission.is_ioa>I agree to PIXERF\'s <a target=_blank ui-sref=run-a-challenge-page.community-challenge-agreement class=\"text--color-pixerf-theme text--bold\" role=button>Challenge Agreement</a> and Asian Geographic Images of Asia photography competition\'s <a target=_blank href=http://www.asiangeo.com/ioa-rules-and-regulations/ class=\"text--color-pixerf-theme text--bold\" role=button>Terms & Conditions</a></span></div></div></div>");
$templateCache.put("app/components/subscribe/subscribe-popup.html","<div class=subscribe-popup__wrapper><div class=\"subscribe-popup__header clearfix\"><div class=subscribe-popup__header__title>XERFIE Newsletter</div><div class=\"subscribe-popup__close icon-icons_close\" role=button ng-click=vm.closePopup()></div></div><div class=subscribe-popup__body><div class=subscribe-popup__input><form name=subscribeForm><input required type=email ng-model=vm.email class=form-control name=email placeholder=\"Enter your email\"></form><div class=subscribe-popup__btn ng-click=vm.onSendEmail(subscribeForm)>Send</div></div><button class=\"subscribe-popup__close-btn btn btn-submit\" ng-click=vm.closePopup()>Cancel</button></div></div>");
$templateCache.put("app/components/subscribe/subscribe.html","<div class=subscribe><div class=subscribe__input><form name=subscribeForm><input required type=email ng-model=vm.email class=form-control name=email placeholder=\"Enter your email\"></form><div class=subscribe__btn ng-click=vm.onSendEmail(subscribeForm)>Send</div></div></div>");
$templateCache.put("app/components/subscription-type-popup/subscription-type-popup.html","<div class=subscription-type-popup><div class=\"subscription-type-popup__header clearfix\"><div class=\"subscription-type-popup__close icon-icons_close\" role=button ng-click=vm.onCancelClicked()></div></div><div class=subscription-type-popup__content><div class=subscription-type-popup__banner></div><!-- <slick infinite=false on-init=\"vm.slickSetting.onInit(slick)\" on-before-change=\"vm.slickSetting.onBeforeChange(event, slick, currentSlide, nextSlide)\"\r\n		on-after-change=\"vm.slickSetting.onAfterChange(event, slick, currentSlide)\" arrows=false draggable=false> --><div class=subscription-type-popup__select-type><div class=subscription-type-popup__select-type__wrapper><form name=AsiaGeoForm><div class=\"subscription-type-popup__select-type__header text--bold text--color-black\">I am a/an ...</div><div class=\"subscription-type-popup__list-selections clearfix\"><div class=subscription-type-popup__list-selections__item><pixerf-checkbox model=vm.geoGraphicInstance model-property=isNotAScubscriber on-changed=\"vm.onSubscriptionSelected(\'not_subscriber\')\"></pixerf-checkbox><div class=\"subscription-type-popup__list-selections__item__description clearfix\"><div class=\"subscription-type-popup__type-checkbox__label text--bold text--color-black\">PIXERF user</div><div class=subscription-type-popup__type-checkbox__description><div>1 free entry</div><div>Any additional entries at USD10 each*</div></div></div></div><div class=subscription-type-popup__list-selections__item><pixerf-checkbox model=vm.geoGraphicInstance model-property=isPrintSubscriber on-changed=\"vm.onSubscriptionSelected(\'print_subscriber\')\"></pixerf-checkbox><div class=\"subscription-type-popup__list-selections__item__description clearfix\"><div class=\"subscription-type-popup__type-checkbox__label text--bold text--color-black\">Asian Geographic Print subscriber</div><div class=subscription-type-popup__type-checkbox__description><div>6 free entries</div><div>Any additional entries at USD10 each*</div></div><div class=\"collapse subscription-type-popup__info-group clearfix\" uib-collapse=\"vm.targetSection !== \'print_subscriber\'\" aria-expanded=false aria-hidden=true><input type=email name=email class=\"subscription-type-popup__info-group__input form-control\" required ng-model=vm.geoGraphicInstance.email placeholder=\"Enter your membership email address\"><div class=subscription-type-popup__info-group__label>Asian Geographic will verify your membership email. If verification is unsuccessful, the additional entries will be removed.</div></div></div></div><div class=subscription-type-popup__list-selections__item><pixerf-checkbox model=vm.geoGraphicInstance model-property=isEScubscriber on-changed=\"vm.onSubscriptionSelected(\'e_subscriber\')\"></pixerf-checkbox><div class=\"subscription-type-popup__list-selections__item__description clearfix\"><div class=\"subscription-type-popup__type-checkbox__label text--bold text--color-black\">Asian Geographic e-subscriber</div><div class=subscription-type-popup__type-checkbox__description><div>4 free entries</div><div>Any additional entries at USD10 each*</div></div><div class=\"collapse subscription-type-popup__info-group clearfix\" uib-collapse=\"vm.targetSection !== \'e_subscriber\'\" aria-expanded=false aria-hidden=true><input type=email name=email class=\"subscription-type-popup__info-group__input form-control\" required ng-model=vm.geoGraphicInstance.email placeholder=\"Enter your membership email address\"><div class=subscription-type-popup__info-group__label>Asian Geographic will verify your membership email. If verification is unsuccessful, the additional entries will be removed.</div></div></div></div></div></form><div class=\"subscription-type-popup__control-btn-wrapper clearfix\"><button ng-if=\"vm.geoGraphicInstance.isEScubscriber || vm.geoGraphicInstance.isPrintSubscriber || vm.geoGraphicInstance.isNotAScubscriber\" class=\"btn btn-submit subscription-type-popup__btn text--bold\" ng-click=vm.onNextClicked(AsiaGeoForm)>Upload</button></div></div><div class=subscription-type-popup__footer>*Asian Geographic will contact you directly for any additional payment required</div></div><!-- <div class=\"subscription-type-popup__additional-entries\">\r\n				<div ng-if=\"vm.freeEntriesCount > 0\" class=\"additional-entries-popup__free-entries text--semibold\">\r\n					You have {{vm.freeEntriesCount}} free entries\r\n				</div>\r\n				<form name=\"additionalEntriesForm\" ng-if=\"vm.freeEntriesCount === 0\">\r\n					<div class=\"additional-entries-popup__info-group clearfix\">\r\n						<div class=\"additional-entries-popup__info-group__label text--semibold text--color-black\" ng-bind-html=\"vm.isSuggest ? \'Do you want to add more entries<br/>(USD10 each)?\' : \'You dont have any free entries<br/>Additional entries (USD10 each)\'\"></div>\r\n						<div class=\"additional-entries-popup__quantity clearfix\">\r\n							<div class=\"additional-entries-popup__quantity__label text--semibold text--color-black\">Quantity</div>\r\n							<pixerf-input-auto-complete ng-if=\"vm.quantities.length && vm.quantities.length > 0\" class=\"additional-entries-popup__quantity__input\" data=\"vm.quantities\" model=\"vm.geoGraphicInstance.additionalEntries\" options=\"vm.bootstrapSelectOptions\" on-changed=\"vm.onQuantityChanged(vm.geoGraphicInstance.additionalEntries)\"></pixerf-input-auto-complete>\r\n						</div>\r\n					</div>\r\n				</form>\r\n				<div class=\"additional-entries-popup__control-btn-wrapper clearfix\">\r\n					<button ng-disabled=\"!vm.freeEntriesCount && vm.isDisabledUloadbtn\" class=\"btn btn-submit additional-entries-popup__btn text--bold\" ng-click=\"vm.onSubmitClicked(additionalEntriesForm)\">Upload</button>\r\n				</div>\r\n			</div>\r\n		</slick> --></div></div>");
$templateCache.put("app/components/suggest-btn/suggest-btn.html","<div class=\"suggest-btn-wrapper text-center\"><button ng-mouseover=vm.onMouseOver() ng-mouseleave=vm.onMouseLeave() ng-disabled=vm.isDoingSuggest ng-class=\"{\'suggest-btn--suggested\': user.is_suggested, \'suggest-btn--unsuggest\': vm.isHovering}\" class=\"btn btn-pixerf-theme--blue btn-pixerf-theme--no-background text--bold suggest-btn\" authentication-click=vm.onSuggestClicked() authentication-click-action=SUGESST_PERSON><span class=\"icon- suggest-btn__icon\"></span><span class=suggest-btn__btn-label>{{vm.btnLabel}}</span></button></div>");
$templateCache.put("app/components/successfully-action-popup/successfully-action-popup.html","<div class=successfully-action-popup><div class=\"successfully-action-popup__remove icon-icons_close\" ng-click=vm.close()></div><div class=successfully-action-popup__header><div class=\"successfully-action-popup__header__icon icon-icons_check\"></div><div class=successfully-action-popup__header__message compile=\"vm.data.title | translate\"></div></div><div class=successfully-action-popup__body><div class=successfully-action-popup__body__message compile=\"vm.data.message | translate\"></div></div><div class=successfully-action-popup__footer><div class=successfully-action-popup__footer__left-btn ng-click=vm.leftBtnClicked()>Continue browsing</div><div class=successfully-action-popup__footer__right-btn ng-click=vm.rightBtnClicked()>View Community</div></div></div>");
$templateCache.put("app/components/tile-photo/tile-photo.html","<div ng-click=vm.onPhotoClicked(file) class=tile-photo ng-class=\"{\'hide-caption\' : hideCaption, \'bulk-edit-photo\': vm.isBulkEditPhoto, \'bulk-edit-photo-selected\' : vm.isBulkEditPhotoSelected()}\" ng-attr-title=\"{{showLicense ? ( file.license != \'commercial\' && !(file.type === \'portfolio\' || file.type === 5) ? \'License Type: Editorial\' : !(file.type === \'portfolio\' || file.type === 5) ? \'License Type: Commercial\' : \'\') : \'\'}}\"><span class=tile-photo__photo-type ng-if=\"file.type === \'portfolio\'\">Portfolio</span> <a class=overlay ng-attr-href={{file.path}} ng-click=$event.preventDefault();></a> <a class=overlay ng-if=vm.isPortfolioPhoto ng-click=$event.preventDefault(); ng-attr-fancyboxable=\"{\'type\': \'image\', \'overlayShow\': true, \'hideOnOverlayClick\': true, keys:{next: null, prev: null}, \'showNavArrows\': false, \'margin\': \'50 10 15 10\', \'centerOnScroll\': true}\" href={{file.urlSmall}} rel=portfolioGallery></a> <img ng-src={{vm.imageUrl}}><stick-checkbox ng-if=\"vm.isBulkEditPhoto && vm.isBulkEditPhotoSelected()\" class=tile-photo__bulk-edit-photo-cover__checkbox model=vm model-property=isBulkEditPhotoSelectedItem label=\"\" layout-style=solid-square></stick-checkbox><div class=tile-photo__status><div class=tile-photo__status__set-state__left ng-if=!vm.isPortfolioPhoto><pixerf-photo-state-btn need-review-license=true ng-if=\"vm.isLogined && (vm.loginUser.canCurate) && !options.hideCuratorBtns\" ng-click=$event.stopPropagation() class=tile-photo__button pixerf-photo-state-btn-state=g pixerf-photo-state-btn-media=file title=\"Move to General\" bulk-photo-state=vm.bulkSelectedPhoto></pixerf-photo-state-btn><pixerf-photo-state-btn ng-if=\"vm.isLogined && (vm.loginUser.canCurate) && !options.hideCuratorBtns\" ng-click=$event.stopPropagation() class=tile-photo__button pixerf-photo-state-btn-state=h pixerf-photo-state-btn-media=file title=\"Move to Pending\" bulk-photo-state=vm.bulkSelectedPhoto></pixerf-photo-state-btn><pixerf-photo-state-btn need-review-license=true ng-if=\"vm.isLogined && (vm.loginUser.canCurate) && !options.hideCuratorBtns\" ng-click=$event.stopPropagation() class=tile-photo__button pixerf-photo-state-btn-state=d pixerf-photo-state-btn-media=file title=\"Move to Discover\" bulk-photo-state=vm.bulkSelectedPhoto></pixerf-photo-state-btn><pixerf-photo-state-btn need-review-license=true ng-if=\"vm.isLogined && (vm.loginUser.canCurate) && !options.hideCuratorBtns\" ng-click=$event.stopPropagation() class=tile-photo__button pixerf-photo-state-btn-state=t pixerf-photo-state-btn-media=file title=\"Move to Trending\" bulk-photo-state=vm.bulkSelectedPhoto></pixerf-photo-state-btn><like-btn ng-if=\"file && !options.hideLike\" ng-click=$event.stopPropagation() class=\"tile-photo__button tile-photo__button__like\" media=file hover-show-number=true></like-btn><star-btn is-show-tooltip=true ng-if=\"vm.loginUser && vm.loginUser.canCurate && !options.hideCuratorBtns\" class=\"tile-photo__button tile-photo__button__star-btn\" target=file ng-click=$event.stopPropagation() hover-show-number=true></star-btn><pixerf-photo-state-btn is-need-confirm=\"file.state !==\'h\' && file.state !==\'r\'\" need-review-license=\"!!file.user.ambassadorship && (file.state ===\'h\' || file.state ===\'r\')\" ng-if=\"vm.isLogined && (vm.loginUser.isAdminInternal || ((file.state ===\'e\') && vm.loginUser.canCurate && options.showBtnE)) && !options.hideCuratorBtns && (!!file.user.ambassadorship || (!file.user.ambassadorship && file.state !==\'h\' && file.state !==\'r\'))\" ng-click=$event.stopPropagation() class=tile-photo__button pixerf-photo-state-btn-state=e pixerf-photo-state-btn-media=file title=\"Set as Editor\'s Pick\" bulk-photo-state=vm.bulkSelectedPhoto></pixerf-photo-state-btn><div class=tile-photo__view-count><span class=icon-view-count></span> <span class=tile-photo__view-count__text>{{file.view_count}}</span></div></div><div class=tile-photo__status__set-state__right ng-if=\"!simpleSelectMode && !overlayMode\"><pixerf-photo-state-btn ng-if=\"vm.isLogined && (vm.loginUser.canCurate) && !options.hideCuratorBtns\" ng-click=$event.stopPropagation() class=\"tile-photo__button tile-photo__button__reject\" pixerf-photo-state-btn-state=r pixerf-photo-state-btn-media=file ng-attr-title=\"{{file.state===\'r\' && file.reject_reason ? \'Reject Reason: \' + file.reject_reason : \'Reject this photo\'}}\" bulk-photo-state=vm.bulkSelectedPhoto></pixerf-photo-state-btn><div ng-if=\"vm.showAddToCart && file.state !=\'r\'\" ng-click=\"$event.stopPropagation(); vm.onAddToCartBtnClicked(file)\" class=\"tile-photo__button tile-photo__button__add-to-cart\" ng-class=\"{\'disabled\':vm.isAddedToCart}\" title=\"{{vm.isAddedToCart ? \'purchased\' : \'add-to-cart\' | translate}}\"><span class=\"{{vm.isAddedToCart ? \'icon-cart-purchased\' : \'icon-icons_cart\'}}\"></span></div><add-to-gallery add-when-gallery-created=true ng-click=$event.stopPropagation() ng-if=\"!gallery && !options.hideAddToGallery && !vm.isPortfolioPhoto && (!vm.isLogined || vm.loginUser.canManageGalleries) && file.state !=\'r\' \" file=file close-on-click=true class=\"tile-photo__button tile-photo__button__add-to-gallery\" on-gallery-item-clicked=\"vm.onGalleryItemClicked(file, gallery)\"><div authentication-click popover-enable=vm.isEnable popover-popup-delay=250 ng-click=vm.clickOutSide() popover-append-to-body=true popover-class=add-to-gallery popover-is-open=vm.isOpen.data ng-class=\"{\'no-opacity\' : vm.isOpen.data}\" type=button uib-popover-template=\"\'app/components/add-to-gallery/add-to-gallery-popover-tmpl.html\'\" popover-placement=\"auto left\" popover-trigger=\"\'outsideClick\'\" title=\"{{\'add-photo-to-your-gallery\' | translate}}\" class=tile-photo__button__add-to-gallery__wrapper><span class=icon-icons-add-to-gallery></span></div></add-to-gallery><div ng-if=options.showRemoveBtn class=tile-photo__button title=\"Remove this photo\"><button type=button class=close ng-click=\"$event.stopPropagation(); onRemoveBtnClick({file: file})\"><span class=icon-icons_close></span></button></div><div ng-if=\"false && !vm.isPortfolioPhoto\" class=tile-photo__button title=\"{{\'add-photo-to-your-cart\' | translate}}\"><span class=icon-icons_cart></span></div><div ng-click=vm.clickOutSide($event)><div popover-popup-delay=250 ng-if=\"gallery && gallery.isMine\" uib-popover-template=\"\'app/components/photo/more-action-popover.html\'\" popover-placement=bottom popover-trigger=\"\'outsideClick\'\" class=tile-photo__button title=\"More actions\"><span class=icon-icons_more></span></div></div><share ng-click=$event.stopPropagation() content-will-be-shared=vm.socialShareContent ng-if=gallery class=tile-photo__button title=\"{{\'hover-share-this-photo\' | translate}}\"></share></div></div><div class=tile-photo__info><div class=tile-photo__info__author ng-show=\"!file.isMine || context === \'MARKET_PLACE\'\"><a ng-click=$event.stopPropagation() ui-sref=\"user-home-page.personal.home({id: file.user.id, userName: (file.user.displayName | toSnakeCase)})\" target=_blank><div class=tile-photo__info__author__avatar><pixerf-user-avatar user-data=file.user lazy=true></pixerf-user-avatar></div><div class=\"tile-photo__info__author__name text--truncate\">{{file.user.displayName}}</div></a></div><div class=\"tile-photo__info__title text--truncate\" ng-show=\"file.isMine && context !== \'MARKET_PLACE\' && !vm.isPortfolioPhoto\">{{file.title}}</div></div></div>");
$templateCache.put("app/components/timer-dropdown/timer-dropdown.html","<div class=timer-dropdown><div class=timer-dropdown__wrapper><div class=timer-dropdown__label>Hour</div><select ng-required=isRequired class=\"timer-dropdown__input hour-input\" ng-model=vm.timer.hour ng-options=\"h for h in vm.hours\"><option value=\"\" disabled=disabled selected=selected hidden>{{placeholder.hour}}</option></select></div><div class=\"timer-dropdown__wrapper timer-dropdown__min\"><div class=timer-dropdown__label>Min</div><select ng-required=isRequired class=\"timer-dropdown__input mins-input\" ng-model=vm.timer.min ng-options=\"m for m in vm.mins\"><option value=\"\" disabled=disabled selected=selected hidden>{{placeholder.min}}</option></select></div><div ng-if=!vm.options.noSecond class=\"timer-dropdown__wrapper timer-dropdown__second\"><div ng-hide=vm.options.hideSecondLabel class=timer-dropdown__label>Second</div><select ng-required=isRequired class=\"timer-dropdown__input second-input\" ng-model=vm.timer.second ng-options=\"s for s in vm.seconds\"><option value=\"\" disabled=disabled selected=selected hidden>{{placeholder.second}}</option></select></div><div ng-if=vm.options.showPm class=\"timer-dropdown__wrapper timer-dropdown__show-option\"><select ng-required=isRequired class=\"timer-dropdown__input show-option-input\" ng-model=vm.timer.options ng-options=\"op for op in vm.showOption\"><option value=\"\" disabled=disabled selected=selected hidden>{{placeholder.showOption}}</option></select></div></div>");
$templateCache.put("app/components/toogle-user-cover-fullheight-btn/toogle-user-cover-fullheight-btn.html","<div class=toogle-user-cover-fullheight-btn ng-show=vm.isExpandable><div image-onloaded-url={{coverImage.url}} image-onloaded=vm.onUserCoverImageLoaded ng-click=vm.toolgeFullviewMode()><ng-transclude></ng-transclude></div></div>");
$templateCache.put("app/components/top-up-successfully-popup/top-up-successfully-popup.html","<div class=top-up-successfully-popup><div class=clearfix><div class=\"modal-body text--color-black-2\"><h1 class=\"top-up-successfully-popup__header text--color-black\">{{vm.message.header}}</h1><div class=top-up-successfully-popup__content ng-bind-html=vm.message.content></div></div><br><div class=modal-footer><button ng-click=vm.close() class=\"btn btn-pixerf-theme top-up-successfully-popup__cta\">OK</button></div></div></div>");
$templateCache.put("app/components/top-up-summary/top-up-summary.html","<div class=top-up-summary><div class=\"top-up-summary__title text--bold text--color-black\">{{title}} as of {{vm.today}}</div><div class=topup-details><div class=\"topup-details__wrapper text--color-black-2 text--semibold\"><div class=\"topup-details__row clearfix\"><div class=\"topup-details__label text--semibold\">Current Balance</div><div class=\"topup-details__price text-right\">SGD {{currentBalance | number:2}}</div></div><div class=\"topup-details__row clearfix\"><div class=\"topup-details__label text--semibold\">New Credits</div><div class=\"topup-details__price text-right\" ng-if=item.price>SGD {{item.price | number:2}}</div></div><!-- <div class=\"topup-details__row clearfix\">\r\n				<div class=\"topup-details__label\">(You Pay)</div>\r\n				<div class=\"topup-details__price text-right\">(SGD {{item.price | number:2}})</div>\r\n			</div> --></div><div class=\"topup-details__total text--bold text--color-pixerf-theme clearfix\"><div class=topup-details__label>New Balance</div><div class=\"topup-details__price text-right\" ng-if=item.price>SGD {{newBalance | number:2}}</div></div></div></div>");
$templateCache.put("app/components/upload-avatar-popup/upload-avatar-popup.html","<div class=upload-avatar-popup><div class=\"row clearfix bg--white\"><div class=\"setting__main-content__body clearfix relative\"><pixerf-loading-indicator class=\"absolute absolute--full\" ng-show=\"vm.isGeneratingThumbnail || vm.uploading\"></pixerf-loading-indicator><form pixerf-dropzone pixerf-dropzone-cropper=vm.cropper dropzone=vm.dropzoneConfig.instance dropzone-config=vm.dropzoneConfig.options event-handlers=vm.dropzoneConfig.eventHandlers><div class=\"col-md-12 dropzone-main-content-wrapper\"><div class=\"dropzone dz-message\" style=\"overflow: auto; text-align: center\"><div ng-show=\"vm.showMessage && !vm.uploading\"><div class=dropzone-info><div class=upload-avatar-popup-icon><i class=\"icon-icons_profile ng-hide\"></i></div><h4 class=text--color-black>{{vm.popupData.introText}}</h4><p class=text--color-black-2>{{\'drag-and-drop-photo\' | translate}}</p><p class=text--color-black-2>- {{\'or\' | translate}} -</p><button class=\"upload-avatar-popup__upload-photo__upload-area__dropzone__main-content__browse-btn btn btn-submit--no-background\" translate>{{\'select-photo\'}}</button></div></div><div class=\"upload-avatar-popup__previews ng-hide\"></div><div ng-click=$event.stopPropagation() class=dropzone-main-content__cropper-wrapper ng-show=!vm.showMessage><div id=crop-image></div></div><div class=upload-avatar-popup__tips ng-bind-html=vm.popupData.rulesText></div></div></div></form></div><div class=\"row setting__main-content__footer\"><div class=\"form-group col-md-12 text-center clearfix\"><div class=\"upload-avatar-popup-popup__upload-wrapper pull-right\"><button title=\"Choose another photo\" type=submit class=\"upload-avatar-popup__upload-photo__upload-area__dropzone__main-content__browse-btn btn btn-submit--no-background\" ng-show=\"vm.dropzoneConfig.instance.getAcceptedFiles().length > 0\" ng-disabled=vm.uploading>{{\'reselect-photo\' | translate}}</button> <button title=\"Upload and apply change\" type=submit class=\"btn btn-submit pixerf-btn-md\" ng-click=vm.upload() ng-disabled=vm.uploading ng-show=\"vm.dropzoneConfig.instance.getAcceptedFiles().length > 0\">{{\'upload\' | translate}}</button></div><div class=\"upload-avatar-popup-popup__cancel-wrapper pull-left\"><button type=submit class=\"btn btn-cancel pixerf-btn-md\" ng-click=vm.cancel()>{{\'cancel\' | translate}}</button></div></div></div></div></div>");
$templateCache.put("app/components/upload-avatar-zone/upload-avatar-zone.html","<div class=upload-avatar-zone><div class=\"row clearfix\"><div class=\"upload-avatar-zone__body clearfix\"><pixerf-loading-indicator class=\"absolute absolute--full\" ng-show=\"vm.isGeneratingThumbnail || vm.uploading\"></pixerf-loading-indicator><form pixerf-dropzone pixerf-dropzone-cropper=vm.cropper dropzone=vm.dropzoneConfig.instance dropzone-config=vm.dropzoneConfig.options event-handlers=vm.dropzoneConfig.eventHandlers><div class=\"col-md-12 dropzone-main-content-wrapper no-padding\"><div class=\"dropzone dz-message\"><div ng-show=\"vm.showMessage && !vm.uploading\"><div class=dropzone-info><div ng-if=!vm.data.hideIcon class=upload-profile-photo-icon><i class=icon-person-circle></i></div></div></div><div id=previews ng-class=\"{\'ng-hide\': vm.data.type === \'profile\'}\"></div><div ng-click=$event.stopPropagation() class=dropzone-main-content__cropper-wrapper ng-show=!vm.showMessage ng-class=\"{\'hide-slider\': hideControl === \'true\'}\"><div id=crop-image></div><div class=\"solid-strange horizontal horizontal-1\"></div><div class=\"solid-strange horizontal horizontal-2\"></div><div class=\"solid-strange vertical vertical-1\"></div><div class=\"solid-strange vertical vertical-2\"></div></div><div class=dropzone-guideline ng-show=!vm.showMessage><div class=text--bold>Drag to reposition</div></div><div class=dropzone-zoom-control ng-show=\"!vm.showMessage && hideControl != \'true\'\"><div class=\"zoom-btn zoom-out-btn\"><span class=icon-remove-circle-outline></span></div><div class=\"zoom-btn zoom-in-btn\"><span class=icon-add-circle-outline></span></div></div></div></div></form></div><!-- <div class=\"upload-avatar-zone__control clearfix\">\r\n			<div class=\"upload-avatar-zone__control-wrapper form-group col-md-12 text-center clearfix\">\r\n				<div class=\"upload-profile-photo-popup__upload-wrapper pull-right\">\r\n					<button class=\"upload-avatar-zone__control-btn btn-submit-photo btn btn-submit--no-background text--bold\" ng-disabled=\"vm.uploading\" ng-class=\"vm.dropzoneConfig.instance.getAcceptedFiles().length > 0 ? \'change-btn\' : \'browse-btn\'\">{{ vm.dropzoneConfig.instance.getAcceptedFiles().length > 0 ? \'Change Photo\' : \'Select Photo\'}}</button>\r\n					<button title=\"Upload and apply change\" type=\"submit\" class=\"upload-avatar-zone__control-btn upload-btn btn btn-submit\" ng-click=\"vm.upload()\"\r\n					 ng-disabled=\"vm.uploading\" ng-show=\"vm.dropzoneConfig.instance.getAcceptedFiles().length > 0\">Save Photo</button>\r\n				</div>\r\n				<div class=\"upload-avatar-zone__control back-btn pull-left\">\r\n					<button type=\"submit\" class=\"btn btn-cancel pixerf-btn-md\" ng-click=\"vm.onBackbtnClicked()\">Back</button>\r\n				</div>\r\n			</div>\r\n		</div> --></div></div>");
$templateCache.put("app/components/upload-btn/upload-btn.html","<div class=upload-btn><div><button type=button class=\"btn btn-submit text--bold\" authentication-click=vm.onStartUploading()>Start Uploading</button></div></div>");
$templateCache.put("app/components/upload-community-album-photo/upload-community-album-photo.html","<div class=\"upload-photo bg--white\"><button type=button class=\"close upload-photo__close-btn\" ng-click=vm.closeUploadModal()><span class=icon-icons_close aria-hidden=true></span></button><div class=clearfix><div class=\"upload-photo__upload-area pull-left\"><div class=upload-photo__upload-area__main-content><div ng-click=\"vm.isFullscreenDropzone.data = false\" super-dropzone=vm.isFullscreenDropzone.data ng-if=\"vm.uploadedFiles.data.length === 0\" pixerf-dropzone dropzone=vm.dropzoneConfig.instance dropzone-config=vm.dropzoneConfig.options event-handlers=vm.dropzoneConfig.eventHandlers class=\"dropzone dz-clickable upload-photo__upload-area__dropzone\"><div class=upload-photo__upload-area__dropzone__main-content><img class=upload-photo__upload-area__dropzone__main-content__pixerf-logo src=assets/images/pixerf-logo-horizental.png><div class=upload-photo__upload-area__dropzone__main-content__body><p class=\"upload-photo__upload-area__dropzone__main-content__title text--color-black text--semibold\">{{\'start-adding-photos\' | translate}}.</p></div><div class=upload-photo__upload-area__dropzone__main-content__preview></div><button class=\"upload-photo__upload-area__dropzone__main-content__browse-btn btn btn-submit--no-background\">{{\'select-photos\' | translate}}</button><!-- <p class=\"upload-photo__upload-area__dropzone__main-content__notice-validate\" translate translate-values=\"{type: \'JPEGs\', min_required: vm.minFileRes + \' \' + (\'megapixels\' | translate).toLowerCase(), max_required: vm.maxFileRes + \'MB\'}\">{{\'accept-type-file-size\'}}</p> --><div class=upload-photo__upload-area__dropzone__main-content__social><p>{{\'also-import-from\' | translate}}:</p><div class=upload-photo__upload-area__dropzone__main-content__social__icons><div ng-click=\"vm.showFilePickerPopup(\'FACEBOOK\')\" class=\"ng-hide social-icon social-icon__facebook\"></div><div ng-click=\"vm.showFilePickerPopup(\'googledrive\')\" class=\"social-icon social-icon__google-drive\"></div><div ng-click=\"vm.showFilePickerPopup(\'INSTAGRAM\')\" class=\"ng-hide social-icon social-icon__instagram\"></div><div ng-click=\"vm.showFilePickerPopup(\'flickr\')\" class=\"social-icon social-icon__flickr\"></div><div ng-click=\"vm.showFilePickerPopup(\'dropbox\')\" class=\"social-icon social-icon__dropbox\"></div></div></div><div class=upload-photo__contributor-agreement-text translate>{{\'by-uploading-I-agree-pixerf-terms-conditions\'}}</div></div></div><div class=upload-photo__upload-area__dropzone__main-content__preview></div><div class=upload-photo__upload-area__preview-photos ng-if=\"vm.uploadedFiles.data.length > 0\"><upload-photo-preview></upload-photo-preview></div></div><div class=upload-photo__upload-area__footer><!-- <span translate translate-values=\"{number: vm.maxPhotoPerGallery}\">{{\'you-can-upload-a-maximum-each-portfolio\'}}</span> --></div></div><div class=\"upload-photo__photo-detail pull-left upload-photo__photo-detail--show\"><div class=upload-photo__publish-btn-wrapper><button ng-disabled=\"(vm.uploadedFiles.data.length === 0 || vm.publishing || vm.numProcessingFile == 0)\" class=\"upload-photo__publish-btn btn btn-submit\" ng-click=vm.onPublishBtnClicked(vm.uploadedFiles.data)>{{\'upload\' | translate}}</button></div></div></div><div class=\"validate-sign spinner\" ng-if=vm.publishing><i class=\"fa fa-2x fa-spin fa-spinner\"></i></div></div>");
$templateCache.put("app/components/upload-community-event-photo/upload-community-event-photo.html","<div class=\"upload-photo bg--white\"><button type=button class=\"close upload-photo__close-btn\" ng-click=vm.closeUploadModal()><span class=icon-icons_close aria-hidden=true></span></button><div class=clearfix><div class=\"upload-photo__upload-area pull-left\"><div class=upload-photo__upload-area__main-content><div ng-click=\"vm.isFullscreenDropzone.data = false\" super-dropzone=vm.isFullscreenDropzone.data ng-if=\"vm.uploadedFiles.data.length === 0\" pixerf-dropzone dropzone=vm.dropzoneConfig.instance dropzone-config=vm.dropzoneConfig.options event-handlers=vm.dropzoneConfig.eventHandlers class=\"dropzone dz-clickable upload-photo__upload-area__dropzone\"><div class=upload-photo__upload-area__dropzone__main-content><img class=upload-photo__upload-area__dropzone__main-content__pixerf-logo src=assets/images/pixerf-logo-horizental.png><div class=upload-photo__upload-area__dropzone__main-content__body><p class=\"upload-photo__upload-area__dropzone__main-content__title text--color-black text--semibold\">{{\'start-adding-photos\' | translate}}.</p></div><div class=upload-photo__upload-area__dropzone__main-content__preview></div><button class=\"upload-photo__upload-area__dropzone__main-content__browse-btn btn btn-submit--no-background\">{{\'select-photos\' | translate}}</button><!-- <p class=\"upload-photo__upload-area__dropzone__main-content__notice-validate\" translate translate-values=\"{type: \'JPEGs\', min_required: vm.minFileRes + \' \' + (\'megapixels\' | translate).toLowerCase(), max_required: vm.maxFileRes + \'MB\'}\">{{\'accept-type-file-size\'}}</p> --><div class=upload-photo__upload-area__dropzone__main-content__social><p>{{\'also-import-from\' | translate}}:</p><div class=upload-photo__upload-area__dropzone__main-content__social__icons><div ng-click=\"vm.showFilePickerPopup(\'FACEBOOK\')\" class=\"ng-hide social-icon social-icon__facebook\"></div><div ng-click=\"vm.showFilePickerPopup(\'googledrive\')\" class=\"social-icon social-icon__google-drive\"></div><div ng-click=\"vm.showFilePickerPopup(\'INSTAGRAM\')\" class=\"ng-hide social-icon social-icon__instagram\"></div><div ng-click=\"vm.showFilePickerPopup(\'flickr\')\" class=\"social-icon social-icon__flickr\"></div><div ng-click=\"vm.showFilePickerPopup(\'dropbox\')\" class=\"social-icon social-icon__dropbox\"></div></div></div><div class=upload-photo__contributor-agreement-text translate>{{\'by-uploading-I-agree-pixerf-terms-conditions\'}}</div></div></div><div class=upload-photo__upload-area__dropzone__main-content__preview></div><div class=upload-photo__upload-area__preview-photos ng-if=\"vm.uploadedFiles.data.length > 0\"><upload-photo-preview></upload-photo-preview></div></div><div class=upload-photo__upload-area__footer><span translate translate-values=\"{number: vm.maxPhotoPerAlbum}\">{{\'you-can-upload-a-maximum-each-event-album\'}}</span></div></div><div class=\"upload-photo__photo-detail pull-left upload-photo__photo-detail--show\"><div class=upload-photo__publish-btn-wrapper><button ng-disabled=\"(vm.uploadedFiles.data.length === 0 || vm.publishing || vm.numProcessingFile == 0)\" class=\"upload-photo__publish-btn btn btn-submit\" ng-click=vm.onPublishBtnClicked(vm.uploadedFiles.data)>{{\'upload\' | translate}}</button></div></div></div><div class=\"validate-sign spinner\" ng-if=vm.publishing><i class=\"fa fa-2x fa-spin fa-spinner\"></i></div></div>");
$templateCache.put("app/components/upload-cover-popup/upload-cover-popup.html","<div class=upload-cover-popup><div class=upload-cover-popup__container><div class=upload-cover-popup__body><pixerf-loading-indicator class=upload-cover-popup__indicator ng-show=\"vm.isGeneratingThumbnail || vm.uploading\"></pixerf-loading-indicator><form pixerf-dropzone pixerf-dropzone-cropper=vm.cropper dropzone=vm.dropzoneConfig.instance dropzone-config=vm.dropzoneConfig.options event-handlers=vm.dropzoneConfig.eventHandlers><div class=dropzone-main-content-wrapper><div class=\"upload-cover-popup__dropzone dropzone dz-message\"><div ng-show=\"vm.showMessage && !vm.uploading\"><div class=\"upload-cover-popup__upload-area dropzone-info\"><div class=upload-cover-popup__upload-area__headline><span ng-if=!vm.popupData.introText>{{\'change-cover-photo\' | translate}}</span> <span ng-if=vm.popupData.introText>{{vm.popupData.introText}}</span></div><div class=upload-cover-popup__upload-area__subline>{{\'drag-and-drop-photo\' | translate}}</div><div class=upload-cover-popup__upload-area__hint>- OR -</div><button class=\"upload-cover-popup__upload btn btn-submit\" translate>{{\'select-photo\'}}</button></div></div><div class=\"upload-cover-popup__previews ng-hide\"></div><div ng-click=$event.stopPropagation() class=upload-cover-popup__cropper-wrapper ng-show=!vm.showMessage><div id=crop-image></div></div><div class=upload-cover-popup__tips ng-bind-html=vm.popupData.rulesText></div></div></div></form></div><div class=upload-cover-popup__footer><div class=upload-cover-popup__control><div class=upload-cover-popup__control__left><button type=submit class=\"upload-cover-popup__cancel btn btn-cancel\" ng-click=vm.cancel()>{{\'cancel\' | translate}}</button></div><div class=upload-cover-popup__control__right><button title=\"Choose another photo\" type=submit class=\"upload-cover-popup__upload btn btn-submit--no-background\" ng-show=\"vm.dropzoneConfig.instance.getAcceptedFiles().length > 0\" ng-disabled=vm.uploading>{{\'reselect-photo\' | translate}}</button> <button title=\"Upload and apply change\" type=submit class=\"upload-cover-popup__submit btn btn-submit\" ng-click=vm.upload() ng-disabled=vm.uploading ng-show=\"vm.dropzoneConfig.instance.getAcceptedFiles().length > 0\">{{\'upload\' | translate}}</button></div></div></div></div></div>");
$templateCache.put("app/components/upload-custom-commissions-popup/upload-custom-commissions-popup.html","<div class=upload-custom-commissions-popup><button type=button class=\"close upload-custom-commissions-popup__close-btn\" ng-click=vm.closeUploadModal()><span class=icon-icons_close aria-hidden=true></span></button><div class=\"upload-custom-commissions-popup__container clearfix\"><div class=upload-custom-commissions-popup__frame><div class=upload-custom-commissions-popup__frame__title>{{vm.popupData.popupTitle}}</div><div class=\"upload-custom-commissions-popup__frame__upload-area clearfix\"><form ng-click=\"vm.isFullscreenDropzone.data = false\" super-dropzone=vm.isFullscreenDropzone.data ng-if=\"vm.uploadedFiles.data.length === 0\" pixerf-dropzone dropzone=vm.dropzoneConfig.instance dropzone-config=vm.dropzoneConfig.options event-handlers=vm.dropzoneConfig.eventHandlers class=\"dropzone dz-clickable upload-custom-commissions-popup__frame__upload-area__dropzone\"><div class=upload-custom-commissions-popup__frame__upload-area__main-content><div class=upload-custom-commissions-popup__frame__upload-area__preview></div><div class=\"upload-custom-commissions-popup__frame__upload-area__browse-btn dz-message\" data-dz-message><span>Click to upload photos</span></div></div></form><div class=upload-photo__upload-area__preview-photos ng-if=\"vm.uploadedFiles.data.length > 0\"><upload-photo-preview></upload-photo-preview></div></div></div><div class=upload-custom-commissions-popup__frame__upload-area__preview></div><form name=vm.uploadForm></form><button loading-spinner ng-class=\"{\'is-working\': vm.publishing}\" ng-disabled=\"vm.selectedFiles.data.length === 0 || vm.publishing || vm.numProcessingFile > 0\" class=\"upload-custom-commissions-popup__publish-btn btn btn-submit\" ng-click=vm.onPublishBtnClicked(vm.uploadedFiles.data)>{{vm.uploadBtnText}}</button></div></div>");
$templateCache.put("app/components/upload-photo/upload-photo.html","<pixerf-alert instance=vm.pixerfAlert></pixerf-alert><div class=\"upload-photo bg--white\"><button type=button class=\"close upload-photo__close-btn\" ng-click=vm.closeUploadModal()><span class=icon-icons_close aria-hidden=true></span></button><div class=clearfix><div class=\"upload-photo__upload-area pull-left\" ng-class=\"{\'upload-photo__upload-area--full-width\': vm.uploadedFiles.data.length === 0}\"><div class=upload-photo__upload-area__main-content><form ng-click=\"vm.isFullscreenDropzone.data = false\" super-dropzone=vm.isFullscreenDropzone.data ng-if=\"vm.uploadedFiles.data.length === 0\" pixerf-dropzone dropzone=vm.dropzoneConfig.instance dropzone-config=vm.dropzoneConfig.options event-handlers=vm.dropzoneConfig.eventHandlers class=\"dropzone dz-clickable upload-photo__upload-area__dropzone\"><div class=upload-photo__upload-area__dropzone__main-content><img class=upload-photo__upload-area__dropzone__main-content__pixerf-logo src=assets/images/pixerf-logo-horizental.png><div class=upload-photo__upload-area__dropzone__main-content__body><p class=\"upload-photo__upload-area__dropzone__main-content__title text--color-black text--semibold\">{{\'start-adding-photos\' | translate}}</p><p class=upload-photo__upload-area__dropzone__main-content__drag-and-drop-message><span>{{\'drag-and-drop-photos\' | translate}}</span> <span class=upload-photo__upload-area__dropzone__main-content__message>{{ \', \' + \'or\' | translate}}</span></p><button class=\"upload-photo__upload-area__dropzone__main-content__browse-btn btn btn-submit--no-background\">{{\'select-photos\' | translate}}</button></div><div class=upload-photo__upload-area__dropzone__main-content__preview></div><p class=upload-photo__upload-area__dropzone__main-content__notice-validate translate translate-values=\"{type: \'JPEGs\', min_required: 5 + \' \' + (\'megapixels\' | translate).toLowerCase(), max_required: \'40MB\'}\">{{\'accept-type-file-size\'}}</p><div class=upload-photo__upload-area__dropzone__main-content__social><p>{{\'also-import-from\' | translate}}:</p><div class=upload-photo__upload-area__dropzone__main-content__social__icons><div ng-click=\"vm.showFilePickerPopup(\'FACEBOOK\')\" class=\"ng-hide social-icon social-icon--small social-icon__facebook\"></div><div ng-click=\"vm.showFilePickerPopup(\'googledrive\')\" class=\"social-icon social-icon--small social-icon__google-drive\"></div><div ng-click=\"vm.showFilePickerPopup(\'INSTAGRAM\')\" class=\"social-icon ng-hide social-icon social-icon__instagram\"></div><div ng-click=\"vm.showFilePickerPopup(\'flickr\')\" class=\"social-icon social-icon--small social-icon__flickr\"></div><div ng-click=\"vm.showFilePickerPopup(\'dropbox\')\" class=\"social-icon social-icon--small social-icon__dropbox\"></div></div></div><div class=upload-photo__contributor-agreement-text translate translate-compile>{{\'upload-contributor-agreement\'}}</div></div></form><form ng-show=\"vm.isFullscreenDropzone.data && vm.uploadedFiles.data.length === 0\" class=\"ng-hide dropzone dz-clickable upload-photo__upload-area__dropzone dropzone--fake\"><div class=upload-photo__upload-area__dropzone__main-content><img class=upload-photo__upload-area__dropzone__main-content__pixerf-logo src=assets/images/pixerf-logo-horizental.png><div class=upload-photo__upload-area__dropzone__main-content__body><p class=\"upload-photo__upload-area__dropzone__main-content__title text--color-black\">{{\'i-want-to-upload-photo\' | translate}}</p><p class=upload-photo__upload-area__dropzone__main-content__drag-and-drop-message><span>{{\'drag-and-drop-photos\' | translate}}</span> <span class=upload-photo__upload-area__dropzone__main-content__message>{{ \', \' + \'or\' | translate}}</span></p><button class=\"upload-photo__upload-area__dropzone__main-content__browse-btn btn btn-submit--no-background\">{{\'choose-files\' | translate}}</button></div><div class=upload-photo__upload-area__dropzone__main-content__preview></div><div class=upload-photo__upload-area__dropzone__main-content__social><p>{{\'also-import-from\' | translate}}:</p><div class=upload-photo__upload-area__dropzone__main-content__social__icons><div ng-click=\"vm.showFilePickerPopup(\'FACEBOOK\')\" class=\"ng-hide social-icon social-icon--small social-icon__facebook\"></div><div ng-click=\"vm.showFilePickerPopup(\'googledrive\')\" class=\"social-icon social-icon--small social-icon__google-drive\"></div><div ng-click=\"vm.showFilePickerPopup(\'INSTAGRAM\')\" class=\"social-icon ng-hide social-icon--small social-icon__instagram\"></div><div ng-click=\"vm.showFilePickerPopup(\'flickr\')\" class=\"social-icon social-icon--small social-icon__flickr\"></div><div ng-click=\"vm.showFilePickerPopup(\'dropbox\')\" class=\"social-icon social-icon--small social-icon__dropbox\"></div></div></div><div class=upload-photo__contributor-agreement-text translate translate-compile>{{\'upload-contributor-agreement\'}}</div></div></form><div class=upload-photo__upload-area__preview-photos ng-if=\"vm.uploadedFiles.data.length > 0\"><upload-photo-preview no-nore-photos=vm.noMorePhotos></upload-photo-preview></div></div><div class=upload-photo__upload-area__footer ng-if=!vm.isHideFooter><span ng-if=!vm.mission class=upload-photo__upload-area__footer__limit-upload-message><span ng-bind-html=\"\'you-have-limit-upload-this-time-element\'| translate:{number:vm.loginUser.stats.weekly_upload_balance}\"></span> <span ng-if=!vm.loginUser.isNoNeedSubscribe translate>{{\'become-a-subscriber\'}}</span> </span><span ng-if=vm.mission ng-bind=vm.footerText></span></div></div><div class=\"upload-photo__photo-detail pull-left\" ng-class=\"vm.uploadedFiles.data.length > 0 ? \'upload-photo__photo-detail--show\': \'\'\"><upload-photo-detail is-form-dirty=vm.isFormDirty alert=vm.pixerfAlert form-error=vm.formError synchronizable=true files=vm.selectedFiles.data categories=vm.categories></upload-photo-detail><div class=upload-photo__publish-btn-wrapper><button ng-disabled=\"vm.publishing || vm.numProcessingFile > 0\" class=\"upload-photo__publish-btn btn btn-submit\" ng-class=\"{\'disabled\': vm.selectedFiles.data.length === 0}\" ng-click=vm.onPublishBtnClicked(vm.uploadedFiles.data)>{{vm.publishing ? (vm.mission ? \'Submitting Photo ...\' : \'Publishing Photo ...\') : (vm.mission ? (\'submit-photo\' | translate) : (\'publish-photo\' | translate))}}</button></div></div></div></div>");
$templateCache.put("app/components/upload-photo-detail/upload-photo-detail.html","<div class=\"upload-photo-detail text-left\"><div class=upload-photo-detail__header><h4 class=\"text--bold text--color-black\">{{\'edit-photo\' | translate}}</h4><div ng-show=vm.masterFile.data.id><call-to-action-messages messages=vm.callToActionMesages></call-to-action-messages></div><div class=upload-photo-detail__header__help><div class=\"text--bold text--color-pixerf-theme upload-photo-detail__header__help__title\">{{\'upload-maximise-licensed\' | translate}}</div><div class=upload-photo-detail__header__help__description>{{\'upload-maximise-licensed-body\' | translate}}</div></div></div><ng-form class=upload-photo-detail__body name=uploadform ng-class=\"{\'pixerf-form-dirty\': isFormDirty}\"><div class=\"form-group upload-photo-detail__category-selection\"><label class=text--bold for=\"\">{{\'category\' | translate}}<span class=\"icon-icons-info upload-photo-detail__small-icon\" tooltip-append-to-body=true tooltip-class=upload-photo-detail__tooltips tooltip-placement=auto uib-tooltip=\"{{\'tool-tip-categories\' | translate}}\"></span></label><div is-disabled=!vm.masterFile.data class=multiple-dropdown-selection ng-dropdown-multiselect=\"\" events=\"{onItemSelect: vm.categoryDropdownSettings.events.onSelectionChanged, onItemDeselect: vm.categoryDropdownSettings.events.onSelectionChanged, onMaxSelectionReached: vm.categoryDropdownSettings.events.onMaxSelectionReached}\" translation-texts=\"{buttonDefaultText: (\'choose-up-to-categories\' | translate: {number: 3})}\" options=categories.data selected-model=vm.masterFile.data.categories extra-settings=vm.categoryDropdownSettings ng-class=\"{\'upload-photo-detail__placeholder-text-categories ng-invalid\': !files[0].categories || files[0].categories.length < 1}\"></div></div><div class=form-group><label class=text--bold for=\"\">{{\'keywords\' | translate}} <span class=\"icon-icons-info upload-photo-detail__small-icon\" tooltip-append-to-body=true tooltip-class=upload-photo-detail__tooltips tooltip-placement=auto uib-tooltip=\"{{\'tool-tip-keywords\' | translate}}\"></span></label><div class=relative><tags-input tag-class=vm.getTagClass($tag) min-length=2 template=pixerf-keyword-template display-property=text replace-spaces-with-dashes=false on-invalid-tag=\"vm.onInvalidTag($tag, scope)\" on-tag-added=vm.onTagAdded($tag) ng-disabled=\"files.length === 0\" ng-model=vm.masterFile.data.tags placeholder=\"{{\'add-keywords\' | translate}}\" class=upload-photo-detail__keywords on-tag-removed=vm.onTagRemoved($tag)><auto-complete select-first-match=false source=vm.loadTags($query)></auto-complete><pixerf-placeholder text=\"{{isLoadingClarifai ? \'We are generating keywords for you....\' : \'Adding at least 10 keywords will make it easier for others to search for your photo.\'}}\" is-visible=\"vm.masterFile.data.tags.length === 0\"></pixerf-placeholder><div ng-show=isLoadingClarifai ng-click=$event.stopPropagation() class=\"upload-photo-detail__keywords__loading-indicator absolute absolute--full\"><div class=\"absolute absolute--bottom-half\"><pixerf-loading-indicator></pixerf-loading-indicator></div></div></tags-input></div></div><div class=form-group ng-show=\"vm.masterFile.data.suggestedKeywords.length > 0\"><label class=text--bold for=\"\">{{\'suggested-keywords\' | translate}}</label><div><span class=tag-item ng-repeat=\"suggestedKeyword in vm.masterFile.data.suggestedKeywords\" ng-click=\"vm.addTag(vm.masterFile.data.tags, suggestedKeyword)\"><span class=tag-template><span><span class=text--semibold>{{suggestedKeyword}}</span></span></span></span></div></div><div class=\"form-group upload-photo-detail__title\"><label class=text--bold for=\"\">{{\'title\' | translate}} <span class=\"icon-icons-info upload-photo-detail__small-icon\" tooltip-append-to-body=true tooltip-class=upload-photo-detail__tooltips tooltip-placement=auto uib-tooltip=\"{{\'tool-tip-title\' | translate}}\"></span></label><input required maxlength=50 ng-disabled=\"files.length === 0\" type=text class=form-control validation-no-file-extension placeholder=\"{{\'give-photo-name\' | translate}}\" ng-model=vm.masterFile.data.title ng-change=\"vm.synchonizedFilesInfo(files, \'title\', vm.masterFile.data.title)\"></div><div class=\"form-group upload-photo-detail__description\"><label class=text--bold for=\"\">{{\'description\' | translate}} <span class=\"icon-icons-info upload-photo-detail__small-icon\" tooltip-append-to-body=true tooltip-class=upload-photo-detail__tooltips tooltip-placement=auto uib-tooltip=\"{{\'tool-tip-description\' | translate}}\"></span></label><textarea name=description maxlength=255 validation-no-hyperlink ng-disabled=\"files.length === 0\" rows=4 type=text class=form-control placeholder=\"{{\'say-something-about-your-photo\' | translate}}\" ng-model=vm.masterFile.data.description ng-change=\"vm.synchonizedFilesInfo(files, \'description\', vm.masterFile.data.description)\"></textarea><div class=text-right><span class=textarea__length_descriptioon>{{vm.masterFile.data.description ? vm.masterFile.data.description.length : 0}}/255</span></div></div><div class=\"form-group upload-photo-detail__licensing\"><label class=text--bold for=\"\">{{\'usage\' | translate}}</label><photo-license-info photo=vm.masterFile.data></photo-license-info><div class=\"upload-photo-detail__release-form-confirm clearfix\" ng-if=\"vm.masterFile.data.state === \'h\' || !vm.masterFile.data.state || vm.loginUser.canCurate\"><photo-license-deternimation-questions class=upload-photo-detail__release-form-confirm__questions is-required=true media=vm.masterFile.data on-question-answered=vm.onQuestionAnswered(question)></photo-license-deternimation-questions><get-release-form-btn ng-if=\"vm.masterFile.data.has_model_property && vm.masterFile.data.license === \'commercial\'\" class=\"btn btn--blue\"></get-release-form-btn></div></div><photo-release-form-selection alert=alert on-selection-changed=\"vm.synchonizedFilesInfo(files, \'releases\', vm.masterFile.data.releases)\" file=vm.masterFile.data ng-if=\"vm.masterFile.data.has_model_property && vm.masterFile.data.license === \'commercial\'\" class=form-group></photo-release-form-selection><div class=\"form-group upload-photo-detail__photo-price-wrapper clearfix\" ng-if=\"((vm.masterFile.data.user && vm.masterFile.data.user.isVIP) || (!vm.masterFile.data.user && vm.loginUser.isVIP)) && vm.masterFile.data.price_ranges\"><label ng-class=\"{\'pixerf-invalid\': !vm.masterFile.data.price.id}\" class=text--bold for=\"\">Select Photo Price <span class=\"icon-icons-info upload-photo-detail__small-icon\" tooltip-append-to-body=true tooltip-class=upload-photo-detail__tooltips tooltip-placement=auto uib-tooltip=\"Price your photo based on the Large size – our system will auto-generate other sizes and scale the prices accordingly. 20% for Small, 60% for Medium, 150% for X-Large and 200% for XX-Large.\"></span></label><photo-price-selection class=\"upload-photo-detail__photo-price clearfix\" is-disabled=\"files.length === 0\" settings=\"{options: vm.masterFile.data.price_ranges, isShownSubscribeText: vm.masterFile.data.user && !vm.masterFile.data.user.isNoNeedSubscribe}\" selected-model=vm.masterFile.data.price on-selection-changed=\"vm.synchonizePrice(files, vm.masterFile.data.price)\"></photo-price-selection></div><div ng-if=vm.masterFile.data.price><photo-price-size-selection photo=vm.masterFile.data is-readonly=false></photo-price-size-selection></div><div class=\"form-group upload-photo-detail__btns-wrapper\"><div class=form-group><div class=upload-photo-detail__add-location><span class=icon-icons-location></span><!-- <input maxlength=\"255\" ng-disabled=\"files.length === 0\"  ng-change=\"vm.synchonizedFilesInfo(files, \'location\', vm.masterFile.data.location)\" g-places-autocomplete force-selection=\"true\" ng-model = \"vm.masterFile.data.location\" placeholder=\"Enter location\" class=\"upload-photo-detail__add-location__input text--color-black form-control\"></input> --><div id=searchBoxContainer><input id=searchBox type=text maxlength=255 ng-disabled=\"files.length === 0\" ng-model=vm.masterFile.data.location placeholder=\"Enter location\" class=\"upload-photo-detail__add-location__input text--color-black form-control\"></div></div></div><div class=\"form-group upload-photo-detail__btn-add-to-gallery-wrapper\"><add-to-gallery is-last-page=vm.isLastPage load-more-galleries=vm.loadMoreGalleries() spinner=vm.spinner class=add-to-gallery file=vm.masterFile.data on-gallery-item-clicked=\"vm.onGallerySelected(gallery); vm.synchonizedFilesInfo(files, \'galleries\', vm.masterFile.data.galleries)\" is-disabled=!vm.masterFile.data add-when-gallery-created=true><button popover-append-to-body=true popover-class=add-to-gallery popover-is-open=vm.isOpen.data popover-trigger=\"\'outsideClick\'\" uib-popover-template=\"\'app/components/add-to-gallery/add-to-gallery-popover-tmpl.html\'\" popover-placement=\"auto left\" ng-disabled=!file type=button class=\"upload-photo-detail__btn upload-photo-detail__btn-add-to-gallery btn btn--white add-to-gallery-btn\"><span class=icon-icons-add-to-gallery></span> <span class=text--truncate ng-class=\"{\'text--color-black\': file.galleriesName !== \'Choose Gallery\'}\">{{file.galleriesName}}</span></button></add-to-gallery></div></div></ng-form><script type=text/ng-template id=pixerf-keyword-template><div class=\"tag-template\">\r\n        <div>\r\n          <span class=\"text--semibold\">{{$getDisplayText()}}</span>\r\n          <a class=\"remove-button icon-icons_close\" ng-click=\"$removeTag()\"></a>\r\n        </div>\r\n      </div></script><script type=text/ng-template id=pixerf-set-price-tooltip-template><div class=\"tag-template\">\r\n            Level up and unlock different price points. <a href=\"\" target=\"_blank\" class=\'pixerf-link--color-theme\' pixerf-close-on-click=\"true\">Learn more about Levelling.</a>\r\n      </div></script><script type=text/ng-template id=pixerf-upload-photo-release-template><div class=\"tag-template\">\r\n            Models and private property owners need to give you permission to use them in commercial photos.<a ui-sref=\"introduction-support.faq.personal({section: \'licensing\'})\" target=\"_blank\" class=\'text--color-pixerf-theme text--bold\' pixerf-close-on-click=\"true\"> Learn more.</a>\r\n      </div></script></div>");
$templateCache.put("app/components/upload-photo-exit-confirm/upload-photo-exit-confirm.html","<div class=upload-photo-exit-confirm><div ng-hide=vm.hideCloseBtn class=\"upload-photo-exit-confirm__remove icon-close-thin\" ng-click=vm.cancel()></div><div class=\"upload-photo-exit-confirm__icon icon-attention\"></div><div class=upload-photo-exit-confirm__header>The selected photos have not been uploaded to PIXERF</div><div class=upload-photo-exit-confirm__body>Please confirm if you want to proceed with the cancellation of the upload.</div><div class=upload-photo-exit-confirm__footer><button ng-click=vm.cancel() class=\"upload-photo-exit-confirm__footer__cancel-btn btn btn--transparent\" ng-disabled=vm.isWorking>No - Resume Upload</button> <button ng-click=vm.ok() class=\"upload-photo-exit-confirm__footer__submit-btn btn btn-submit\" ng-disabled=vm.isWorking>Yes - Cancel Upload</button></div></div>");
$templateCache.put("app/components/upload-photo-preview/upload-photo-preview.html","<div class=upload-photo-preview-area-wrapper><div class=\"text-left upload-photo-preview__main_content__header\"><div ng-click=vm.selectAllFiles() class=upload-photo-preview__main_content__header__select-all-btn-wrapper><span class=icon-icons-plus-box></span> <a class=upload-photo-preview__main_content__header__select-all-btn-wrapper__title>{{\'select-all\' | translate}}</a></div><div ng-click=vm.removeSelectedPhotos(vm.selectedFiles.data) ng-show=\"vm.selectedFiles.data.length > 0\" class=\"ng-hide upload-photo-preview__main_content__header__remove-btn\"><span class=icon-icons_minus></span> <a class=upload-photo-preview__main_content__header__remove-btn__title>{{vm.selectedFiles.data.length === vm.uploadedFiles.data.length ? (\'remove-all\' | translate) : (\'remove-selected-photos\' | translate)}} ({{vm.selectedFiles.data.length}})</a></div></div><div selection={} items=vm.uploadedFiles.data on-selected=\"vm.toggleFileSelection(f, isSelected)\" class=\"row upload-photo-preview__main_content__photos-wrapper clearfix\"><div class=upload-photo-preview ng-repeat=\"file in vm.uploadedFiles.data\" ng-class=\"{\'upload-photo-preview--highlighted\': file.isSelected, \'upload-photo-preview--error\':  file.pixerfError}\"><div upload-photo-preview-swap-dimension=file.rotate_by upload-photo-preview-scale data-selection-member ng-attr-id={{file.id}} class=upload-photo-preview-content-wrapper ng-click=\"vm.onFileClicked($event, file)\"><div class=upload-photo-preview__overlay><div class=upload-photo-preview__checkbox ng-if=!file.pixerfError ng-click=\"vm.toggleFileSelection(file); $event.stopPropagation()\" title=\"{{\'select-this-photo\' | translate}}\"><div class=\"pixerf-checkbox pixerf-checkbox--fake\" ng-class=\"{\'pixerf-checkbox--fake--checked\': file.isSelected}\"></div></div><div class=upload-photo-preview__remove-btn title=\"Remove this photo\"><button type=button class=close ng-click=vm.removeUploadedFile($index)><span class=icon-icons_close></span></button></div><div class=upload-photo-preview__rotate-btn title=\"Rotate this photo\" ng-if=!file.pixerfError><span ng-click=vm.rotatePhoto(file) class=icon-icons-rotate></span></div><div class=pixerf-hover></div></div><div class=\"absolute absolute--full upload-photo-preview__upload-photo-process\" ng-show=\"file.upload.progress < 100 && !file.pixerfError\"><span class=\"absolute text--color-white upload-photo-preview__upload-photo-process__uploading-text absolute--bottom-half text--bold\">{{\'uploading\' | translate}}...{{file.upload.progress}}%</span> <span class=overlay></span></div><div class=\"absolute absolute--full upload-photo-preview__upload-photo-process\" ng-show=\"file.pixerfError && file.pixerfError != \'UPLOAD_PORTFOLIO_VALIDATION_INVALID_MAX_FILESIZE\' && file.pixerfError != \'UPLOAD_PORTFOLIO_VALIDATION_INVALID_MIN_RESOLUTION\'\" ng-class=upload-photo-preview__upload-photo-process><span class=\"absolute text--color-white upload-photo-preview__upload-photo-process__uploading-text upload-photo-preview__upload-photo-process__uploading-text--error absolute--bottom-half text--bold\">{{file.pixerfError === \'UPLOAD_VALIDATION_INVALID_MIN_RESOLUTION\' ? (\'upload-at-least-resolution\' | translate: {value: 5, unit: \'MP\'}) : (\'something-went-wrong\' | translate)}}</span> <span class=overlay></span></div><div class=\"absolute absolute--full upload-photo-preview__upload-photo-process\" ng-show=\"file.pixerfError && file.pixerfError === \'UPLOAD_PORTFOLIO_VALIDATION_INVALID_MAX_FILESIZE\'\" ng-class=upload-photo-preview__upload-photo-process><span class=\"absolute text--color-white upload-photo-preview__upload-photo-process__uploading-text upload-photo-preview__upload-photo-process__uploading-text--error absolute--bottom-half text--bold\" translate translate-values=\"{value: 2, unit: \'MB\'}\">{{\'upload-files-smaller-than\'}}</span> <span class=overlay></span></div><div class=\"absolute absolute--full upload-photo-preview__upload-photo-process\" ng-show=\"file.pixerfError && file.pixerfError === \'UPLOAD_PORTFOLIO_VALIDATION_INVALID_MIN_RESOLUTION\'\" ng-class=upload-photo-preview__upload-photo-process><span class=\"absolute text--color-white upload-photo-preview__upload-photo-process__uploading-text upload-photo-preview__upload-photo-process__uploading-text--error absolute--bottom-half text--bold\" translate translate-values=\"{value: 0.5, unit: (\'megapixels\' | translate)}\">{{\'upload-files-larger-than\'}}</span> <span class=overlay></span></div><img img-orientation-original-style=translateY(-50%) scale-image img-orientation=file.rotate_by ng-attr-src=\"{{file.thumbnail ? file.thumbnail : \'assets/images/icon-market.png\'}}\"></div><input required validation-no-file-extension data-ng-disabled=\"file.upload.progress < 100\" ng-change=\"vm.updateMasterFile(file, \'title\')\" type=text class=\"form-control upload-photo-preview__file-name text--color-black text-left text--truncate\" validation-no-file-extension placeholder=Title ng-model=file.title></div><div class=\"col-md-3 upload-photo-preview upload-photo-preview--add-more text-center\"><div class=upload-photo-preview-content-wrapper><form ng-if=!vm.noMorePhotos ng-click=\"vm.isFullscreenDropzone.data = false\" super-dropzone=vm.isFullscreenDropzone.data ng-class=\"{\'supper-dropzone\': vm.isFullscreenDropzone.data}\" pixerf-dropzone dropzone=vm.dropzoneConfigSmall.instance dropzone-config=vm.dropzoneConfigSmall.options event-handlers=vm.dropzoneConfigSmall.eventHandlers class=\"upload-photo-preview--add-more__dropzone dropzone dz-clickable\"><div class=upload-photo-preview--add-more__dropzone__content><p class=upload-photo-preview--add-more__dropzone__content__add-more-label ng-if=!vm.hideSocialUpload translate>{{\'add-more-photos\'}}</p><!-- <p ng-if=\"!vm.hideSocialUpload\">- {{\'or\' | translate}} -</p> --> <button class=\"upload-photo-preview--add-more__dropzone__content__browse-btn--small btn btn-submit--no-background\" translate>{{vm.chooseFileBtnText || \'choose-files\'}}</button><div ng-if=!vm.hideSocialUpload class=upload-photo__upload-area__dropzone__main-content__social><p>{{\'also-import-from\'| translate}}:<br><a ng-click=\"vm.showFilePickerPopup(\'googledrive\')\" class=\"text--color-pixerf-theme text--bold\">Google Drive,</a> <a ng-click=\"vm.showFilePickerPopup(\'flickr\')\" class=\"text--color-pixerf-theme text--bold\">Flickr</a> and <a ng-click=\"vm.showFilePickerPopup(\'dropbox\')\" class=\"text--color-pixerf-theme text--bold\">Dropbox</a></p></div></div></form><form ng-show=vm.isFullscreenDropzone.data class=\"upload-photo-preview--add-more__dropzone dropzone dropzone--fake ng-hide\"><div class=upload-photo-preview--add-more__dropzone__content><p class=upload-photo-preview--add-more__dropzone__content__add-more-label ng-if=!vm.hideSocialUpload>Add more files</p><!-- <p ng-if=\"!vm.hideSocialUpload\">- {{\'or\' | translate}} -</p> --> <button class=\"upload-photo-preview--add-more__dropzone__content__browse-btn--small btn btn-submit--no-background\" translate>{{vm.chooseFileBtnText || \'choose-files\'}}</button><div ng-if=!vm.hideSocialUpload class=upload-photo__upload-area__dropzone__main-content__social><p>{{\'also-import-from\'| translate}}:<br><a ng-click=\"vm.showFilePickerPopup(\'googledrive\')\" class=\"text--color-pixerf-theme text--bold\">Google Drive,</a> <a ng-click=\"vm.showFilePickerPopup(\'flickr\')\" class=\"text--color-pixerf-theme text--bold\">Flickr</a> and <a ng-click=\"vm.showFilePickerPopup(\'dropbox\')\" class=\"text--color-pixerf-theme text--bold\">Dropbox</a></p></div></div></form></div></div></div></div>");
$templateCache.put("app/components/upload-portfolio-photo/upload-portfolio-photo.html","<div class=\"upload-photo bg--white\"><button type=button class=\"close upload-photo__close-btn\" ng-click=vm.closeUploadModal()><span class=icon-icons_close aria-hidden=true></span></button><div class=clearfix><div class=\"upload-photo__upload-area pull-left\"><div class=upload-photo__upload-area__main-content><form ng-click=\"vm.isFullscreenDropzone.data = false\" super-dropzone=vm.isFullscreenDropzone.data ng-if=\"vm.uploadedFiles.data.length === 0\" pixerf-dropzone dropzone=vm.dropzoneConfig.instance dropzone-config=vm.dropzoneConfig.options event-handlers=vm.dropzoneConfig.eventHandlers class=\"dropzone dz-clickable upload-photo__upload-area__dropzone\"><div class=upload-photo__upload-area__dropzone__main-content><img class=upload-photo__upload-area__dropzone__main-content__pixerf-logo src=assets/images/pixerf-logo-horizental.png><div class=upload-photo__upload-area__dropzone__main-content__body><p class=\"upload-photo__upload-area__dropzone__main-content__title text--color-black text--semibold\">{{\'start-adding-photos\' | translate}}.</p></div><div class=upload-photo__upload-area__dropzone__main-content__preview></div><button class=\"upload-photo__upload-area__dropzone__main-content__browse-btn btn btn-submit--no-background\">{{\'select-photos\' | translate}}</button><p class=upload-photo__upload-area__dropzone__main-content__notice-validate translate translate-values=\"{type: \'JPEGs\', min_required: vm.minFileRes + \' \' + (\'megapixels\' | translate).toLowerCase(), max_required: vm.maxFileRes + \'MB\'}\">{{\'accept-type-file-size\'}}</p><div class=upload-photo__upload-area__dropzone__main-content__social><p>{{\'also-import-from\' | translate}}:</p><div class=upload-photo__upload-area__dropzone__main-content__social__icons><div ng-click=\"vm.showFilePickerPopup(\'FACEBOOK\')\" class=\"ng-hide social-icon social-icon__facebook\"></div><div ng-click=\"vm.showFilePickerPopup(\'googledrive\')\" class=\"social-icon social-icon__google-drive\"></div><div ng-click=\"vm.showFilePickerPopup(\'INSTAGRAM\')\" class=\"ng-hide social-icon social-icon__instagram\"></div><div ng-click=\"vm.showFilePickerPopup(\'flickr\')\" class=\"social-icon social-icon__flickr\"></div><div ng-click=\"vm.showFilePickerPopup(\'dropbox\')\" class=\"social-icon social-icon__dropbox\"></div></div></div><div class=upload-photo__contributor-agreement-text translate>{{\'by-uploading-I-agree-pixerf-terms-conditions\'}}</div></div></form><div class=upload-photo__upload-area__dropzone__main-content__preview></div><div class=upload-photo__upload-area__preview-photos ng-if=\"vm.uploadedFiles.data.length > 0\"><upload-photo-preview></upload-photo-preview></div></div><div class=upload-photo__upload-area__footer><span translate translate-values=\"{number: vm.maxPhotoPerGallery}\">{{\'you-can-upload-a-maximum-each-portfolio\'}}</span></div></div><div class=\"upload-photo__photo-detail pull-left upload-photo__photo-detail--show\"><upload-portfolio-photo-detail is-form-dirty=vm.isFormDirty portfolio-id={{vm.portfolioId}} form-error=vm.formError synchronizable=true files=vm.selectedFiles.data></upload-portfolio-photo-detail><div class=upload-photo__publish-btn-wrapper><button ng-disabled=\"vm.selectedFiles.data.length === 0 || vm.publishing || vm.numProcessingFile > 0\" class=\"upload-photo__publish-btn btn btn-submit\" ng-click=vm.onPublishBtnClicked(vm.uploadedFiles.data)>{{vm.publishing ? \'Publishing Portfolio Gallery\' : (\'publish-portfolio-gallery\' | translate)}}</button></div></div></div></div>");
$templateCache.put("app/components/upload-profile-photo/upload-profile-photo.html","<div class=upload-profile-photo><div class=\"row clearfix bg--white\"><div class=\"setting__main-content__body clearfix relative\" ng-class=\"{\'img-cover\': vm.data.type === \'cover\'}\"><pixerf-loading-indicator class=\"absolute absolute--full\" ng-show=\"vm.isGeneratingThumbnail || vm.uploading\"></pixerf-loading-indicator><form pixerf-dropzone pixerf-dropzone-cropper=vm.cropper dropzone=vm.dropzoneConfig.instance dropzone-config=vm.dropzoneConfig.options event-handlers=vm.dropzoneConfig.eventHandlers><!-- DROPZONE AREA --><div class=\"col-md-12 dropzone-main-content-wrapper\"><div class=\"dropzone dz-message\" style=\"overflow: auto; text-align: center\"><div ng-show=\"vm.showMessage && !vm.uploading\"><div class=dropzone-info><div ng-if=!vm.data.hideIcon class=upload-profile-photo-icon><i class=icon-icons_profile></i></div><h4 class=text--color-black ng-if=!vm.data.headline>{{vm.data.type === \'cover\' ? (\'change-cover-photo\' | translate) : (\'change-profile-photo\' | translate)}}</h4><h4 class=text--color-black ng-if=vm.data.headline>{{vm.data.headline}}</h4><p class=text--color-black-2>{{\'drag-and-drop-photo\' | translate}}</p><p class=text--color-black-2>- OR -</p><button class=\"upload-photo__upload-area__dropzone__main-content__browse-btn btn btn-submit--no-background\">{{\'select-photo\' | translate}}</button></div></div><div id=previews ng-class=\"{\'ng-hide\': vm.data.type === \'profile\' || vm.data.type === \'cover\'}\"></div><div ng-click=$event.stopPropagation() class=dropzone-main-content__cropper-wrapper ng-show=!vm.showMessage><div id=crop-image></div></div><div ng-if=\"vm.data.type === \'profile\'\" class=upload-profile-photo__tips><h6>{{\'tips\' | translate}}:</h6><p translate translate-values=\"{type_1: \'JPG\', type_2: \'PNG\'}\">{{\'photo-following-formats\'}}</p><p translate translate-values=\"{resolution: \'400 x 400\'}\">{{\'photo-should-be-square\'}}</p><p translate translate-values=\"{value: 10, unit: \'MB\'}\">{{\'maximum-file-size-is\'}}</p></div><div ng-if=\"vm.data.type === \'cover\'\" class=upload-profile-photo__tips><h6>{{\'tips\' | translate}}:</h6><p translate translate-values=\"{resolution: \'1500 x 500\'}\">{{\'recommend-dimensions-at-least\'}}</p><p translate translate-values=\"{value: 10, unit: \'MB\'}\">{{\'maximum-file-size-is\'}}</p><p translate translate-values=\"{type_1: \'JPG\', type_2: \'PNG\'}\">{{\'photo-following-formats\'}}</p></div></div></div></form></div><div class=\"row setting__main-content__footer\"><div class=\"form-group col-md-12 text-center clearfix\"><div class=\"upload-profile-photo-popup__upload-wrapper pull-right\"><button title=\"Choose another photo\" type=submit class=\"upload-photo__upload-area__dropzone__main-content__browse-btn btn btn-submit--no-background text--bold\" ng-show=\"vm.dropzoneConfig.instance.getAcceptedFiles().length > 0\" ng-disabled=vm.uploading>{{\'reselect-photo\' | translate}}</button> <button title=\"Upload and apply change\" type=submit class=\"btn btn-submit pixerf-btn-md\" ng-click=vm.upload() ng-disabled=vm.uploading ng-show=\"vm.dropzoneConfig.instance.getAcceptedFiles().length > 0\">{{\'upload\' | translate}}</button></div><div class=\"upload-profile-photo-popup__cancel-wrapper pull-left\"><button type=submit class=\"btn btn-cancel pixerf-btn-md\" ng-click=vm.cancel()>{{\'cancel\' | translate}}</button></div></div></div></div></div>");
$templateCache.put("app/components/user-info/user-info.html","<div class=\"user-info relative\"><div class=user-info__avatar><a ui-sref=\"user-home-page.personal.home({id: userData.id, userName: (userData.displayName | toSnakeCase)})\"><pixerf-user-avatar user-data=userData lazy=true></pixerf-user-avatar></a></div><div class=relative><div class=user-info__info><div class=user-info__info__details><a ui-sref=\"user-home-page.personal.home({id: userData.id, userName: (userData.displayName | toSnakeCase)})\" popup-link-clicked><div class=\"user-info__info__details__user-name text--truncate text--bold text--color-black\" uib-tooltip={{userData.displayName}}>{{userData.displayName}}</div></a><div class=user-info__info__details__location>{{userData.address.country ? userData.address.country : userData.location | isoCountry}}</div><div class=\"user-info__info__details__level text--bold\" pixerf-person-level person=userData></div><div class=user-info__info__details__followers-count>{{userData.stats.follower_count}} followers</div></div></div></div></div>");
$templateCache.put("app/components/user-info-verification-tile/user-info-verification-tile.html","<div class=user-info-verification-tile><div class=user-info-verification-tile__info><div class=user-info-verification-tile__info__identify><div class=user-info-verification-tile__info__identify__left><span class=user-info-verification-tile__info__identify__label>User ID</span> <span class=user-info-verification-tile__info__identify__value>{{vm.user.id}}</span></div><div ng-if=vm.verificationDate class=user-info-verification-tile__info__identify__right>Validation request email sent on <span>{{vm.verificationDate}}</span>.</div></div><div class=user-info-verification-tile__info__description ng-bind-html=vm.hintAction></div><div class=user-info-verification-tile__info__form><div class=\"user-info-verification-tile__info__form__row order__first-name\" ng-class=\"{\'user-updated-info\': vm.updatedInfo.first_name, \'hide-checkbox\': vm.hideCheckbox}\"><stick-checkbox is-disabled=vm.disabledInput on-changed=vm.onDeletePostsComments() model=vm.invalidInfo model-property=first_name label=\"Your Name\" layout-style=\"{{vm.disabledInput ? \'solid-box\' : \'regular-square\'}}\"></stick-checkbox><div class=user-info-verification-tile__info__form__value>{{vm.user.first_name}}</div></div><div class=\"user-info-verification-tile__info__form__row order__email\" ng-class=\"{\'user-updated-info\': vm.updatedInfo.email, \'hide-checkbox\': vm.hideCheckbox}\"><stick-checkbox is-disabled=vm.disabledInput on-changed=vm.onDeletePostsComments() model=vm.invalidInfo model-property=email label=Email layout-style=\"{{vm.disabledInput ? \'solid-box\' : \'regular-square\'}}\"></stick-checkbox><div class=user-info-verification-tile__info__form__value>{{vm.user.email}}</div></div><div class=\"user-info-verification-tile__info__form__row order__telephone\" ng-class=\"{\'user-updated-info\': vm.updatedInfo.telephone, \'hide-checkbox\': vm.hideCheckbox}\"><stick-checkbox is-disabled=vm.disabledInput on-changed=vm.onDeletePostsComments() model=vm.invalidInfo model-property=telephone label=\"Phone Number\" layout-style=\"{{vm.disabledInput ? \'solid-box\' : \'regular-square\'}}\"></stick-checkbox><div class=user-info-verification-tile__info__form__value>{{vm.user.organization.telephone}}</div></div><div class=\"user-info-verification-tile__info__form__row order__organization-name\" ng-class=\"{\'user-updated-info\': vm.updatedInfo.name, \'hide-checkbox\': vm.hideCheckbox}\"><stick-checkbox is-disabled=vm.disabledInput on-changed=vm.onDeletePostsComments() model=vm.invalidInfo model-property=name label=\"Company Name\" layout-style=\"{{vm.disabledInput ? \'solid-box\' : \'regular-square\'}}\"></stick-checkbox><div class=user-info-verification-tile__info__form__value>{{vm.user.organization.name}}</div></div><div class=\"user-info-verification-tile__info__form__row order__registration-no\" ng-class=\"{\'user-updated-info\': vm.updatedInfo.registration_no, \'hide-checkbox\': vm.hideCheckbox}\"><stick-checkbox is-disabled=vm.disabledInput on-changed=vm.onDeletePostsComments() model=vm.invalidInfo model-property=registration_no label=\"Company Registration No.\" layout-style=\"{{vm.disabledInput ? \'solid-box\' : \'regular-square\'}}\"></stick-checkbox><div class=user-info-verification-tile__info__form__value>{{vm.user.organization.registration_no}}</div></div><div class=\"user-info-verification-tile__info__form__row order__office-type\" ng-class=\"{\'user-updated-info\': vm.updatedInfo.office_type, \'hide-checkbox\': vm.hideCheckbox}\"><stick-checkbox is-disabled=vm.disabledInput on-changed=vm.onDeletePostsComments() model=vm.invalidInfo model-property=office_type label=\"Type of Office\" layout-style=\"{{vm.disabledInput ? \'solid-box\' : \'regular-square\'}}\"></stick-checkbox><div class=user-info-verification-tile__info__form__value>{{vm.user.organization.office_type}}</div></div><div class=\"user-info-verification-tile__info__form__row order__country\" ng-class=\"{\'user-updated-info\': vm.updatedInfo.country, \'hide-checkbox\': vm.hideCheckbox}\"><stick-checkbox is-disabled=vm.disabledInput on-changed=vm.onDeletePostsComments() model=vm.invalidInfo model-property=country label=\"Country of operation\" layout-style=\"{{vm.disabledInput ? \'solid-box\' : \'regular-square\'}}\"></stick-checkbox><div class=user-info-verification-tile__info__form__value>{{vm.country}}</div></div><div class=\"user-info-verification-tile__info__form__row order__city\" ng-class=\"{\'user-updated-info\': vm.updatedInfo.city, \'hide-checkbox\': vm.hideCheckbox}\"><stick-checkbox is-disabled=vm.disabledInput on-changed=vm.onDeletePostsComments() model=vm.invalidInfo model-property=city label=\"City / State / Province / Region\" layout-style=\"{{vm.disabledInput ? \'solid-box\' : \'regular-square\'}}\"></stick-checkbox><div class=user-info-verification-tile__info__form__value>{{vm.user.organization.address.city}}</div></div></div></div><div ng-if=vm.showComment class=user-info-verification-tile__comment><div class=user-info-verification-tile__comment__label>Additional Comment for the user</div><textarea ng-disabled=vm.disabledInput required rows=2 class=user-info-verification-tile__comment__input ng-model=vm.comment></textarea></div><div class=user-info-verification-tile__control><div ng-if=vm.showEmailBtn class=user-info-verification-tile__email-user-btn ng-click=vm.emailUserToValidateInfo()>Email User to validate selected fields</div><div ng-if=vm.showVerifyBtn class=user-info-verification-tile__verify-user-btn ng-click=vm.verifyUser()>Verify User</div><div ng-if=vm.showRemindBtn class=user-info-verification-tile__remind-user-btn ng-click=vm.remindUserValidate()>Remind User to validate selected fields</div><div ng-if=!vm.hideRejectBtn class=user-info-verification-tile__reject-user-btn ng-click=vm.rejectUser()>Reject User</div></div></div>");
$templateCache.put("app/components/upload-portfolio-photo-detail/upload-portfolio-photo-detail.html","<div class=\"upload-photo-detail text-left\"><div class=upload-photo-detail__header><h4 class=\"text--bold text--color-black\" translate>{{\'portfolio\'}}</h4></div><ng-form class=upload-photo-detail__body name=uploadform ng-class=\"{\'pixerf-form-dirty\': isFormDirty}\"><div class=\"form-group upload-photo-detail__btns-wrapper\"><div class=\"form-group upload-photo-detail__btn-add-to-gallery-wrapper\"><div ng-if=vm.showSelectPortfolio class=upload-photo-detail__select-special-list><popover-selection-btn close-on-click=true on-selection-changed=vm.onSelectPortfolioClicked(item) selected-model=vm.selectedPortfolio settings=vm.portfolioSetting></popover-selection-btn></div><add-to-portfolio-gallery is-last-page=vm.isLastPage spinner=vm.spinner class=add-to-gallery file=vm.masterFile.data portfolio-id={{vm.portfolioId}} on-portfolio-gallery-item-clicked=\"vm.onPortfolioGallerySelected(portfolioGallery); vm.synchonizedFilesInfo(files, \'galleries\', vm.masterFile.data.galleries)\" is-disabled=!vm.masterFile.data add-when-gallery-created=true><button popover-append-to-body=true popover-class=add-to-gallery popover-is-open=vm.isOpen.data popover-trigger=\"\'outsideClick\'\" uib-popover-template=\"\'app/components/add-to-portfolio-gallery/add-to-portfolio-gallery-popover-tmpl.html\'\" popover-placement=\"auto left\" ng-disabled=!file type=button class=\"upload-photo-detail__btn upload-photo-detail__btn-add-to-gallery btn btn--white add-to-gallery-btn\"><span class=icon-icons-add-to-gallery></span> <span class=text--truncate ng-class=\"{\'text--color-black\': file.portfolioGalleriesName !== \'choose-portfolio-gallery\'}\" translate>{{file.portfolioGalleriesName}}</span></button></add-to-portfolio-gallery></div></div></ng-form></div>");
$templateCache.put("app/components/user-list-view/user-list-view.html","<div class=user-list-view><div ng-repeat=\"user in users\" class=user-list-view__user><div class=user-list-view__user__avatar pixerf-user-avatar-style pixerf-user-avatar-style-user=user><a ui-sref=\"user-home-page.personal.photos({id: user.id, userName: (user.displayName | toSnakeCase)})\"><pixerf-user-avatar user-data=user lazy=true></pixerf-user-avatar></a></div><div class=user-list-view__user__content><div class=user-list-view__user__content__author><a class=\"user-list-view__user__content__author__name text--truncate\" uib-tooltip={{user.displayName}} ui-sref=\"user-home-page.personal.photos({id: user.id, userName: (user.displayName | toSnakeCase)})\">{{user.displayName}}</a></div></div><div uib-dropdown class=user-list-view__user__control ng-if=\"control && vm.actions && vm.actions.length\"><div class=\"user-list-view__user__control__button icon-icons_more\" uib-dropdown-toggle></div><ul class=user-list-view__user__control__dropdown-menu uib-dropdown-menu><li role=menuitem class=user-list-view__user__control__dropdown-menu__item ng-repeat=\"action in vm.actions\" ng-click=action.cta(user)>{{action.label}}</li></ul></div></div></div>");
$templateCache.put("app/components/user-tag/user-tag.html","<div class=user-tag><div class=user-tag__avatar><a ui-sref=\"user-home-page.personal.home({id: userData.id, userName: (userData.displayName | toSnakeCase)})\"><pixerf-user-avatar user-data=userData lazy=true></pixerf-user-avatar></a></div><div class=user-tag__control><div class=user-tag__info><div class=user-tag__info__details><a ui-sref=\"user-home-page.personal.home({id: userData.id, userName: (userData.displayName | toSnakeCase)})\"><div class=\"user-name text--truncate text--bold text--color-black\" uib-tooltip={{userData.displayName}}>{{userData.displayName}}</div></a><div class=location>{{userData.address.country ? userData.address.country : userData.location | isoCountry}}</div></div></div><follow-btn user=userData ng-if=!vm.isMyProfile on-follow-status-changed=\"onFollowStatusChanged({status: status})\"></follow-btn></div></div>");
$templateCache.put("app/components/user-post-tile/user-post-tile.html","<div class=\"post-item clearfix\"><div class=\"post-item__header clearfix\"><div class=post-item__business-author-avatar><pixerf-user-avatar class=profile-image user-data=postData lazy=true></pixerf-user-avatar></div><div class=post-item__info><div class=\"post-item__business-author-name text--bold\">{{postData.author}}</div><div class=\"post-item__tracked clearfix\"><div class=post-item__tracked__time>{{postData.time}}</div></div></div><div uib-dropdown class=post-item__controls><span uib-dropdown-toggle class=icon-icons_more></span><ul class=post-item__dropdown-menu-more uib-dropdown-menu role=menu aria-labelledby=single-button><li role=menuitem class=post-item__dropdown-item ng-if=vm.isOwner>Copy link to post</li><li role=menuitem class=post-item__dropdown-item ng-if=vm.isOwner>Edit post</li><li role=menuitem class=post-item__dropdown-item ng-if=vm.isOwner>Delete post</li><li role=menuitem class=post-item__dropdown-item ng-if=!vm.isOwner>Report this post</li></ul></div></div><div class=post-item__content-wrapper><div class=\"post-item__content post-item-type-{{postData.type}}\"><div class=post-item__content__title>{{postData.content}}</div><div ng-class=\"{\'loading\': !vm.loaded}\" class=post-item__content__group-photos id=justified-gallery-{{postData.id}}></div></div></div><div class=\"post-item__footer clearfix\"><div class=post-item__like><div class=post-item__like-text>{{postData.likeCount}}</div><div class=icon-icons_like></div></div><div class=post-item__comment data-toggle=collapse data-target=#comment-collapse-{{postData.id}} aria-expanded=false><div class=post-item__comment-text>{{postData.commentCount}}</div><div class=icon-icons_comment></div></div><div class=\"post-item__share icon-icons_share\"></div></div><div class=\"post-item__comment-wrapper collapse clearfix\" id=comment-collapse-{{postData.id}}><!-- <spinner-win spinner=\"vm.spinner\"></spinner-win> --><comment-list context=\"isOwner ? \'IN_MY_HOUSE\' : \'\'\" target-id=postData.id hide-empty-state=true></comment-list></div></div>");
$templateCache.put("app/components/user-verification/user-verification.html","<div class=\"clearfix setting-top-navigation\"><div class=user-verification__breadcrum><span class=user-verification__breadcrum__item>Manage</span> <span class=user-verification__breadcrum__item>></span> <span class=user-verification__breadcrum__item>User Verification</span> <span class=user-verification__breadcrum__item>></span> <span class=\"user-verification__breadcrum__item actived\" translate>{{vm.contextPage}}</span></div><div class=\"setting-top-navigation__section-wrapper pixerf-navigation-bar-wrapper\"><ul class=\"user-verification__navigation-bar pixerf-navigation-bar\"><button type=button class=\"setting-top-navigation__collapse-button navbar-toggle collapsed\" data-toggle=collapse data-target=#user-verification-navigation aria-expanded=false><div class=setting-top-navigation__context translate>{{vm.contextPage}}</div><div class=\"setting-top-navigation__mobile-button arrow-animation-menu-collapse\"><span class=\"icon-bar dash-one\"></span> <span class=\"icon-bar dash-two\"></span></div></button><div class=\"setting-top-navigation__list collapse navbar-collapse\" navbar-collapse-on-click=true id=user-verification-navigation><li class=setting-top-navigation__item ui-sref-active=setting-top-navigation__item--active ui-sref=setting.user-verification.sign-up>New sign-up</li><li class=setting-top-navigation__item ui-sref-active=setting-top-navigation__item--active ui-sref=setting.user-verification.pending-response>Pending user response</li><li class=setting-top-navigation__item ui-sref-active=setting-top-navigation__item--active ui-sref=setting.user-verification.responded>Responded users</li><li class=setting-top-navigation__item ui-sref-active=setting-top-navigation__item--active ui-sref=setting.user-verification.verified>Verified users</li><li class=setting-top-navigation__item ui-sref-active=setting-top-navigation__item--active ui-sref=setting.user-verification.rejected>Rejected users</li></div></ul><div class=\"user-verification__main-content clearfix\" ui-view></div></div></div>");
$templateCache.put("app/components/verified-business-email-popup/verified-business-email-popup.html","<div class=verified-business-email><div class=clearfix><div class=mobile-show><div class=verified-business-email__header><div class=pixerf-logo></div></div><div class=verified-business-email__content-wrapper><div class=\"verified-business-email__signed icon-icons_check text--color-pixerf-theme\"></div><div class=\"verified-business-email__notice-wrapper text-center\"><h3>Email Verified</h3><div class=welcome-pixerf>Awesome! You’re now a verified Business user! Get started on your journey to unlock the potential of PIXERF’s community of visual artists for your creative needs.</div><!-- <div ng-if=\"vm.mobileOS === \'iOS\'\" class=\"verified-business-email__os\">Download our iOS app\r\n						</br>from the App Store now.\r\n					</div>\r\n					<div ng-if=\"vm.mobileOS === \'Android\'\" class=\"verified-business-email__os\">Download our android app\r\n						</br>from the Google Play now.\r\n					</div>\r\n					<link-mobile-app></link-mobile-app> --></div></div></div><div class=\"modal-body text-left text--color-black-2\"><p class=greeting-message>Awesome! You’re now a verified Business user! Get started on your journey to unlock the potential of PIXERF’s community of visual artists for your creative needs.</p></div><br><div class=modal-footer><button class=\"btn-submit--no-background btn btn-pixerf-theme--no-background text--bold\" ng-click=vm.onStartClicked()>Start Now</button></div></div></div>");
$templateCache.put("app/components/verified-business-user-popup/verified-business-user-popup.html","<div class=verified-business-user-popup><button type=button class=close ng-click=vm.close()><span class=icon-icons_close aria-hidden=true></span></button><div class=clearfix><div class=\"modal-body text--color-black-2\"><h1 class=\"verified-business-user-popup__header text--color-black\">{{vm.message.header}}</h1><div class=verified-business-user-popup__content>{{vm.message.content}}</div></div><br><div class=modal-footer><button ng-click=vm.onBrowseMarketplaceClicked() class=\"btn btn-submit verified-business-user-popup__btn\">Browse Marketplace</button></div></div></div>");
$templateCache.put("app/components/verified-email-popup/verified-email-popup.html","<div class=verified-email><div class=clearfix><div class=mobile-show><div class=verified-email__header><div class=pixerf-logo></div></div><div class=verified-email__content-wrapper><div class=\"verified-email__signed icon-icons_check text--color-pixerf-theme\"></div><div class=\"verified-email__notice-wrapper text-center\"><h3>Email Verified</h3><div class=welcome-pixerf>Welcome to PIXERF!</div><div ng-if=\"vm.mobileOS === \'iOS\'\" class=verified-email__os>Download our iOS app<br>from the App Store now.</div><div ng-if=\"vm.mobileOS === \'Android\'\" class=verified-email__os>Download our android app<br>from the Google Play now.</div><link-mobile-app></link-mobile-app></div></div></div><div class=\"modal-body text-left text--color-black-2\"><p class=greeting-message>You’re now a Pixerfer! Get started on your PIXERF journey by uploading your photos and establishing your online presence. All it takes is three easy steps:</p><ul><li>1. Upload and title your photos.</li><li>2. Select categories and enter keywords.</li><li>3. Have your Galleries featured on the Marketplace.</li></ul></div><br><div class=modal-footer><button class=\"btn-submit--no-background btn btn-pixerf-theme--no-background text--bold\" ng-click=vm.showUploadModal()>Start Now</button></div></div></div>");
$templateCache.put("app/components/verify-business-btn/verify-business-btn.html","<div class=\"verify-btn-wrapper text-center\"><button ng-class=\"{\'verify-btn--verified\': user.is_email_verified}\" class=\"btn btn-pixerf-theme--blue btn-pixerf-theme--no-background text--bold verify-btn\" authentication-click=vm.onVerifiedEmailClicked() authentication-click-action=VERIFY_PERSON><span class=\"icon- verify-btn__icon\"></span><span class=verify-btn__btn-label>{{vm.btnLabel}}</span></button></div>");
$templateCache.put("app/components/video-popup/video-popup.html","<div class=video-popup__content><button type=button class=close ng-click=vm.close()><span class=icon-icons_close aria-hidden=true></span></button><div class=clearfix><video ng-src={{vm.video}} autoplay controls id={{vm.videoId}}></video></div></div>");
$templateCache.put("app/components/view-community/view-community.html","<div class=\"view-community__master main__content--md\" ng-class=\"{\'margin-top--1\': vm.isScreenMobile}\"><a class=\"view-community__master__header-top col-xs-12\" target=_blank ui-sref=\"community-detail-page.community-detail-discussions({id: vm.community.id,name: vm.community.name})\"><img class=view-community__master__header-top__logo ng-src={{vm.community.cover.thumbnail}}><div class=view-community__master__header-top__name>{{vm.community.name}}</div></a><div class=view-community__master__body><ul class=view-community__master__col-left><div class=view-community__master__header-name translate>{{\'view-community\'}}</div><button type=button class=\"navbar-toggle collapsed\" data-toggle=collapse data-target=#view-community-navbar-collapse aria-expanded=false><div class=\"pull-left text--bold\" translate>{{\'view-community\'}}</div><div class=\"pull-right arrow-animation-menu-collapse\"><span class=\"icon-bar dash-one\"></span> <span class=\"icon-bar dash-two\"></span></div></button><div class=\"view-community__master__navigation collapse navbar-collapse\" navbar-collapse-on-click=true id=view-community-navbar-collapse><a ui-sref-active=active ui-sref=\"view-community.members({status: \'members\'})\" class=view-community__master__navigation__item>{{\'view-members\' | translate}} <span class=view-community__master__navigation__item__count>{{vm.community.stats.requested_count}}</span> </a><a ng-if=\"vm.isManager() || vm.isOwner()\" ui-sref-active=active ui-sref=view-community.pending-posts class=view-community__master__navigation__item>{{\'pending-posts\' | translate}} <span class=view-community__master__navigation__item__count>{{vm.community.stats.pending_discussions}}</span></a></div></ul><div class=view-community__master__col-right><div class=manage-community><div class=manage-community__right-content><div class=manage-community__right-content__navigation ng-if=vm.showTopCountMember><ul class=setting-top-navigation ng-class=\"{\'nav-business\': vm.user.isBiz}\"><div class=manage-community__right-content__navigation__breadcrum><span class=manage-community__right-content__navigation__breadcrum__item translate>{{\'manage-community\'}} </span><span class=manage-community__right-content__navigation__breadcrum__item translate>> {{\'manage-members\'}} </span><span class=\"manage-community__right-content__navigation__breadcrum__item active\" translate>> {{vm.subContextPage}}</span></div><button type=button class=\"setting-top-navigation__collapse-button navbar-toggle collapsed\" data-toggle=collapse data-target=#manage-communities-navigation aria-expanded=false><div class=setting-top-navigation__context translate>{{vm.subContextPage}}</div><div class=\"setting-top-navigation__mobile-button arrow-animation-menu-collapse\"><span class=\"icon-bar dash-one\"></span> <span class=\"icon-bar dash-two\"></span></div></button><div class=\"setting-top-navigation__list collapse navbar-collapse\" navbar-collapse-on-click=true id=manage-communities-navigation><li class=setting-top-navigation__item ui-sref-active=setting-top-navigation__item--active ui-sref=\"view-community.members({status: \'members\'})\">{{\'members\' | translate}}{{\' (\' + (vm.community.member_count || \'0\') + \')\'}}</li></div></ul></div><div class=\"manage-community__right-content__navigation reports-navigation\" ng-if=vm.showReportsNav><div class=manage-community__right-content__navigation__breadcrum><span class=manage-community__right-content__navigation__breadcrum__item translate>{{\'manage-community\'}} </span><span class=manage-community__right-content__navigation__breadcrum__item translate>> {{\'reports\'}} </span><span class=\"manage-community__right-content__navigation__breadcrum__item active\" translate>> {{vm.subContextPage}}</span></div><button type=button class=\"setting-top-navigation__collapse-button navbar-toggle collapsed\" data-toggle=collapse data-target=#manage-communities-navigation aria-expanded=false><div class=setting-top-navigation__context translate>{{vm.subContextPage}}</div><div class=\"setting-top-navigation__mobile-button arrow-animation-menu-collapse\"><span class=\"icon-bar dash-one\"></span> <span class=\"icon-bar dash-two\"></span></div></button><ul class=setting-top-navigation ng-class=\"{\'nav-business\': vm.user.isBiz}\"><div class=\"setting-top-navigation__list collapse navbar-collapse\" navbar-collapse-on-click=true id=manage-communities-navigation><li class=setting-top-navigation__item ui-sref-active=setting-top-navigation__item--active ui-sref=\"manage-community.reports({status: \'reported-posts-action-required\'})\">{{\'reported-posts-action-required\' | translate}}{{\' (\' + (vm.community.pending_report_count || \'0\') + \')\'}}</li><li class=setting-top-navigation__item ui-sref-active=setting-top-navigation__item--active ui-sref=\"manage-community.reports({status: \'past-reported-posts\'})\">{{\'past-reported-posts\' | translate}}{{\' (\' + (vm.community.resolved_report_count || \'0\') + \')\'}}</li></div></ul></div><div class=manage-community__content ui-view></div></div></div></div></div></div>");
$templateCache.put("app/components/view-event/view-event.html","<div class=\"view-event__master main__content--md\" ng-class=\"{\'margin-top--1\': vm.isScreenMobile}\"><a class=\"view-event__master__header-top col-xs-12\" target=_blank ui-sref=\"event-detail-page({id: vm.event.id,name: vm.event.name})\"><img class=view-event__master__header-top__logo ng-src={{vm.event.cover.thumbnail}}><div class=view-event__master__header-top__name>{{vm.event.name}}</div></a><div class=view-event__master__body><ul class=view-event__master__col-left><div class=view-event__master__header-name translate>{{\'view-event\'}}</div><button type=button class=\"navbar-toggle collapsed\" data-toggle=collapse data-target=#view-event-navbar-collapse aria-expanded=false><div class=\"pull-left text--bold\" translate>{{\'view-event\'}}</div><div class=\"pull-right arrow-animation-menu-collapse\"><span class=\"icon-bar dash-one\"></span> <span class=\"icon-bar dash-two\"></span></div></button><div class=\"view-event__master__navigation collapse navbar-collapse\" navbar-collapse-on-click=true id=view-event-navbar-collapse><a ui-sref-active-class=active ui-sref-active-if=view-event.members ui-sref=\"view-event.members({status: \'attendees\'})\" class=view-event__master__navigation__item>{{\'view-attendees\' | translate}} <span class=view-event__master__navigation__item__count>{{vm.event.stats.going || \'0\'}}</span> </a><a ui-sref-active-class=active ui-sref-active-if=view-event.pending-posts ui-sref=view-event.pending-posts class=view-event__master__navigation__item>{{\'pending-posts\' | translate}} <span class=view-event__master__navigation__item__count>{{vm.event.post_count || \'0\'}}</span></a></div></ul><div class=view-event__master__col-right><div class=manage-community><div class=view-event__right-content><div class=view-event__right-content__navigation ng-if=vm.showTopCountMember><ul class=setting-top-navigation ng-class=\"{\'nav-business\': vm.user.isBiz}\"><div class=view-event__right-content__navigation__breadcrum><span class=view-event__right-content__navigation__breadcrum__item translate>{{\'view-event\'}} </span><span class=view-event__right-content__navigation__breadcrum__item translate>> {{\'view-members\'}} </span><span class=\"view-event__right-content__navigation__breadcrum__item active\" translate>> {{vm.subContextPage}}</span></div><button type=button class=\"setting-top-navigation__collapse-button navbar-toggle collapsed\" data-toggle=collapse data-target=#manage-communities-navigation aria-expanded=false><div class=setting-top-navigation__context translate>{{vm.subContextPage}}</div><div class=\"setting-top-navigation__mobile-button arrow-animation-menu-collapse\"><span class=\"icon-bar dash-one\"></span> <span class=\"icon-bar dash-two\"></span></div></button><div class=\"setting-top-navigation__list collapse navbar-collapse\" navbar-collapse-on-click=true id=manage-communities-navigation><li class=setting-top-navigation__item ui-sref-active=setting-top-navigation__item--active ui-sref=\"manage-event.members({status: \'attendees\'})\">{{\'attendees\' | translate}}{{\' (\' + (vm.event.stats.going || \'0\') + \')\'}}</li></div></ul></div><div class=\"view-event__right-content__navigation reports-navigation\" ng-if=vm.showReportsNav><div class=view-event__right-content__navigation__breadcrum><span class=view-event__right-content__navigation__breadcrum__item translate>{{\'view-event\'}} </span><span class=view-event__right-content__navigation__breadcrum__item translate>> {{\'reports\'}} </span><span class=\"view-event__right-content__navigation__breadcrum__item active\" translate>> {{vm.subContextPage}}</span></div><button type=button class=\"setting-top-navigation__collapse-button navbar-toggle collapsed\" data-toggle=collapse data-target=#manage-communities-navigation aria-expanded=false><div class=setting-top-navigation__context translate>{{vm.subContextPage}}</div><div class=\"setting-top-navigation__mobile-button arrow-animation-menu-collapse\"><span class=\"icon-bar dash-one\"></span> <span class=\"icon-bar dash-two\"></span></div></button><ul class=setting-top-navigation ng-class=\"{\'nav-business\': vm.user.isBiz}\"><div class=\"setting-top-navigation__list collapse navbar-collapse\" navbar-collapse-on-click=true id=manage-communities-navigation><li class=setting-top-navigation__item ui-sref-active=setting-top-navigation__item--active ui-sref=\"manage-event.reports({status: \'reported-posts-action-required\'})\">{{\'reported-posts-action-required\' | translate}}{{\' (\' + (vm.event.pending_report_count || \'0\') + \')\'}}</li></div></ul></div><div class=view-event__content ng-if=!vm.loading ui-view></div></div></div></div></div></div>");
$templateCache.put("app/components/waiting-event-launch-popup/waiting-event-launch-popup.html","<div class=waiting-event-launch-popup><div class=waiting-event-launch-popup__close ng-click=vm.close()><span class=icon-icons_close aria-hidden=true></span></div><div class=waiting-event-launch-popup__message>When do you want to launch this?</div><div class=waiting-event-launch-popup__control><div class=waiting-event-launch-popup__control__launch-later ng-click=vm.launchLater()>Launch 30 days before {{vm.eventType}}</div><div class=waiting-event-launch-popup__control__launch-now ng-click=vm.launchNow()>Launch Now</div></div></div>");
$templateCache.put("app/components/welcome-popup/welcome-popup.html","<div class=welcome-popup><div class=clearfix><div class=\"horizental-centered modal-avatar\"><pixerf-user-avatar user-data=vm.person lazy=true></pixerf-user-avatar></div><div class=modal-info><div class=\"modal--title text-center text--color-black\">{{vm.greetingMessage}}</div><div class=\"modal-body text-center\"><p translate>{{vm.welcomeMessage}}!</p></div></div></div></div>");
$templateCache.put("app/components/winner-photo-selection/winner-photo-selection.html","<div class=winner-photo-selection><div class=\"winner-photo-selection__winner-wrapper clearfix\" ng-if=\"vm.numberWinnersRemaining > 0 || vm.isPhotoAwarded\"><div class=text--bold>Select Your Mission Winners</div><div ng-repeat=\"prize in mission.prizes_grouped[\'GRAND_WINNER\'] | filter: vm.filterUnawardedPrizes\" class=\"clearfix winner-photo-selection__item relative\"><div ng-click=vm.onWinnerSelectionChanged(prize) class=\"winner-photo-selection__title-wrapper pull-left clearfix\"><div class=winner-photo-selection__title-icon ng-class=\"{\'text--color-pixerf-theme icon-icons-bullet--checked\': prize.isSelected, \'icon-icons-bullet\': !prize.isSelected, \'winner-photo-selection__title-icon--disable\': vm.isWorking}\"></div><label role=button>{{prize.name || \'Mission Winner\'}}</label></div><div class=\"pull-right text--color-black-2 col-md-3 no-padding text-right\">SGD {{prize.value}}</div></div><div ng-repeat=\"prize in mission.prizes_grouped[\'WINNER\'] | filter: vm.filterUnawardedPrizes\" class=\"clearfix winner-photo-selection__item relative\"><div ng-click=vm.onWinnerSelectionChanged(prize) class=\"winner-photo-selection__title-wrapper pull-left clearfix\"><div class=winner-photo-selection__title-icon ng-class=\"{\'text--color-pixerf-theme icon-icons-bullet--checked\': prize.isSelected, \'icon-icons-bullet\': !prize.isSelected, \'winner-photo-selection__title-icon--disable\': vm.isWorking}\"></div><label role=button>{{prize.name || \'Mission Winner\'}}</label></div><div class=\"pull-right text--color-black-2 col-md-3 no-padding text-right\">SGD {{prize.value}}</div></div></div><div class=\"winner-photo-selection__consolation-wrapper clearfix ng-hide\" ng-show=\"mission.prizes_grouped[\'CONSOLATION\'].length > 0 && vm.consolation && (vm.numberConsolationRemaining > 0 || vm.isPhotoAwarded)\"><div class=text--bold>Select Special Mention Prizes</div><div class=\"clearfix winner-photo-selection__item relative\"><div ng-click=vm.onConsolationSelectionChanged() class=\"winner-photo-selection__title-wrapper pull-left clearfix\"><div class=winner-photo-selection__title-icon ng-class=\"{\'text--color-pixerf-theme icon-icons-bullet--checked\': vm.consolation.isSelected, \'icon-icons-bullet\': !vm.consolation.isSelected}\"></div><label role=button>Special Mention ({{vm.numberConsolationRemaining}})</label></div></div></div></div>");
$templateCache.put("app/error/404/404.html","<div><section class=\"row error-400 bg-404 no-margin\"><div class=ops>Oops!</div><div class=not-exist-notice>The page you are looking for does not exist.</div><button class=\"btn btn--take-back text--bold\" ng-click=vm.takeBack()>Take Me Back</button></section></div>");
$templateCache.put("app/error/500/500.html","<div><section class=\"row error-500 homepage-intropage bg-server-error no-margin\"><div class=ops>Oops!</div><div class=not-exist-notice>We are in the midst of fixing it and will have things back to normal again.</div><div class=try-later>Please try back later.</div></section></div>");
$templateCache.put("app/introduction/company/company.html","<div class=\"relative main__content--md introduction-page\" ng-class=\"{\'margin-top--1\': isScreenMobile}\"><div scroll-to-fixed=vm.searchFilterBarSettings class=\"pixerf-navigation-bar-wrapper navigation-scroll-top\"><ul class=\"pixerf-navigation-bar clearfix\" ng-class=\"{\'no-margin\': isScreenMobile}\"><button type=button class=\"navbar-toggle collapsed\" data-toggle=collapse data-target=#introduction-navbar-collapse aria-expanded=false><div class=\"pull-left text--bold\">{{vm.contextPage}}</div><div class=\"pull-right arrow-animation-menu-collapse\"><span class=\"icon-bar dash-one\"></span> <span class=\"icon-bar dash-two\"></span></div></button><div class=\"collapse navbar-collapse pixerf-navbar-text\" navbar-collapse-on-click=true id=introduction-navbar-collapse><li ui-sref-active=pixerf-navigation-bar__menu-item--active ui-sref=about-pixerf class=pixerf-navigation-bar__menu-item>About</li><li ui-sref-active=pixerf-navigation-bar__menu-item--active ui-sref=introduction-company.terms class=pixerf-navigation-bar__menu-item>Terms</li><li ui-sref-active=pixerf-navigation-bar__menu-item--active ui-sref=introduction-company.privacy class=pixerf-navigation-bar__menu-item>Privacy</li><li ui-sref-active=pixerf-navigation-bar__menu-item--active ui-sref=introduction-company.license class=pixerf-navigation-bar__menu-item>Licence Agreement</li></div></ul></div><div class=\"col-md-12 introduction-page__main-content marketplace-wrap\" ui-view></div></div>");
$templateCache.put("app/introduction/discover/discover.html","<div class=\"relative main__content--md introduction-page\" ng-class=\"{\'margin-top--1\': isScreenMobile}\"><!-- <div scroll-to-fixed=\'{\"marginTop\": 60}\' class=\"pixerf-navigation-bar-wrapper\">\r\n        <ul class=\"pixerf-navigation-bar\">\r\n            <li ui-sref-active=\"pixerf-navigation-bar__menu-item--active\" ui-sref=\"introduction-discover.mission\" class=\"pixerf-navigation-bar__menu-item\">Mission</li>\r\n            <li ui-sref-active=\"pixerf-navigation-bar__menu-item--active\" ui-sref=\"introduction-discover.marketplace\" class=\"pixerf-navigation-bar__menu-item\">MarketPlace</li>\r\n            <li ui-sref-active=\"pixerf-navigation-bar__menu-item--active\" ui-sref=\"introduction-discover.signature-gallery\" class=\"pixerf-navigation-bar__menu-item\">Pixerfer\'s GALLERIES</li>\r\n        </ul>\r\n    </div> --><div class=\"col-md-12 introduction-page__main-content marketplace-wrap\" ui-view></div></div>");
$templateCache.put("app/introduction/pixerfer/pixerfer.html","<div class=\"relative main__content--md introduction-page\" ng-class=\"{\'margin-top--1\': isScreenMobile}\"><div scroll-to-fixed=vm.searchFilterBarSettings class=\"pixerf-navigation-bar-wrapper navigation-scroll-top\"><ul class=\"pixerf-navigation-bar clearfix\" ng-class=\"{\'no-margin\': isScreenMobile}\"><button type=button class=\"navbar-toggle collapsed\" data-toggle=collapse data-target=#subcription-navbar-collapse aria-expanded=false><div class=\"pull-left text--bold\" ng-if=\"vm.contextPage == \'Personal\' || vm.contextPage == \'Business\'\">Subscriptions</div><div class=\"pull-right arrow-animation-menu-collapse\"><span class=\"icon-bar dash-one\"></span> <span class=\"icon-bar dash-two\"></span></div><div class=text--bold ng-class=\"(vm.contextPage == \'Personal\' || vm.contextPage == \'Business\') ? \'pull-right\' : \'pull-left\'\">{{vm.contextPage}}</div></button><div class=navbar-collapse-desktop><li ui-sref-active-class=pixerf-navigation-bar__menu-item--active ui-sref-active-if=introduction-pixerfer.subscriptions ui-sref=introduction-pixerfer.subscriptions.personal class=pixerf-navigation-bar__menu-item>Subscriptions</li><li ui-sref-active=pixerf-navigation-bar__menu-item--active ui-sref=introduction-pixerfer.credit-plans class=\"pixerf-navigation-bar__menu-item ng-hide\">CREDIT PLANS</li><li ui-sref-active-class=pixerf-navigation-bar__menu-item--active ui-sref-active-if=introduction-pixerfer.payout ui-sref=introduction-pixerfer.payout.personal class=pixerf-navigation-bar__menu-item>Payout & Pricing</li><li ui-sref-active=pixerf-navigation-bar__menu-item--active ui-sref=introduction-pixerfer.about-leveling class=\"pixerf-navigation-bar__menu-item ng-hide\">ABOUT LEVELLING</li><!-- <li ui-sref-active=\"pixerf-navigation-bar__menu-item--active\" ui-sref=\"#\" class=\"pixerf-navigation-bar__menu-item\">ABOUT LEVELLING</li> --></div><div class=navbar-collapse-mobile><div class=\"collapse navbar-collapse pixerf-navbar-text\" navbar-collapse-on-click=true id=subcription-navbar-collapse><li ui-sref-active-class=pixerf-navigation-bar__menu-item--active ui-sref-active-if=introduction-pixerfer.subscriptions ui-sref=introduction-pixerfer.subscriptions.personal class=pixerf-navigation-bar__menu-item data-toggle=collapse data-target=#subcription-sub-navbar-collapse aria-expanded=false>SUBSCRIPTIONS</li><ul class=pixerf-subnavigation-bar id=subcription-sub-navbar-collapse><li ui-sref-active=pixerf-subnavigation-bar__menu-item--active ui-sref=introduction-pixerfer.subscriptions.personal class=pixerf-subnavigation-bar__menu-item>PERSONAL</li><li ui-sref-active=pixerf-subnavigation-bar__menu-item--active ui-sref=introduction-pixerfer.subscriptions.business class=pixerf-subnavigation-bar__menu-item>BUSINESS</li></ul><li ui-sref-active=pixerf-navigation-bar__menu-item--active ui-sref=introduction-pixerfer.credit-plans class=\"pixerf-navigation-bar__menu-item ng-hide\">CREDIT PLANS</li><li ui-sref-active-class=pixerf-navigation-bar__menu-item--active ui-sref-active-if=introduction-pixerfer.payout ui-sref=introduction-pixerfer.payout.personal class=pixerf-navigation-bar__menu-item>PAYOUT & PRICING</li><li ui-sref-active=pixerf-navigation-bar__menu-item--active ui-sref=introduction-pixerfer.about-leveling class=\"pixerf-navigation-bar__menu-item ng-hide\">ABOUT LEVELLING</li><!-- <li ui-sref-active=\"pixerf-navigation-bar__menu-item--active\" ui-sref=\"#\" class=\"pixerf-navigation-bar__menu-item\">ABOUT LEVELLING</li> --></div></div></ul></div><div class=\"col-md-12 introduction-page__main-content marketplace-wrap\" ui-view></div></div>");
$templateCache.put("app/introduction/support/support.html","<div class=\"relative main__content--md introduction-page\" ng-class=\"{\'margin-top--1\': isScreenMobile}\"><!-- <div scroll-to-fixed=\"vm.searchFilterBarSettings\" class=\"pixerf-navigation-bar-wrapper navigation-scroll-top clearfix\">\r\n		<ul class=\"pixerf-navigation-bar clearfix\" ng-class=\"{\'no-margin\': isScreenMobile}\">\r\n			<button type=\"button\" class=\"navbar-toggle collapsed\" data-toggle=\"collapse\" data-target=\"#support-navbar-collapse\" aria-expanded=\"false\">\r\n				<div class=\"pull-left text--bold\" ng-if=\"vm.contextPage == \'Contributor\' || vm.contextPage == \'Business\'\">FAQ</div>\r\n				<div class=\"pull-right arrow-animation-menu-collapse\">\r\n					<span class=\"icon-bar dash-one\"></span>\r\n					<span class=\"icon-bar dash-two\"></span>\r\n				</div>\r\n				<div class=\"text--bold\" ng-class=\"(vm.contextPage == \'Contributor\' || vm.contextPage == \'Business\') ? \'pull-right\' : \'pull-left\'\">{{vm.contextPage}}</div>\r\n			</button>\r\n			<div class=\"navbar-collapse-desktop\">\r\n					<li ui-sref-active=\"pixerf-navigation-bar__menu-item--active\" ui-sref=\"email-us-page\" class=\"pixerf-navigation-bar__menu-item\">Support</li>\r\n					<li ui-sref-active-class=\"pixerf-navigation-bar__menu-item--active\" ui-sref-active-if=\"introduction-support.faq\" ui-sref=\"introduction-support.faq.personal\" class=\"pixerf-navigation-bar__menu-item\">FAQ</li>\r\n					<li ui-sref-active=\"pixerf-navigation-bar__menu-item--active\" ui-sref=\"introduction-support.releases\" class=\"pixerf-navigation-bar__menu-item\">Releases</li>\r\n					<li ui-sref-active=\"pixerf-navigation-bar__menu-item--active\" ui-sref=\"#\" class=\"ng-hide pixerf-navigation-bar__menu-item\">JOBS</li>\r\n			</div>\r\n			<div class=\"navbar-collapse-mobile\">\r\n				<div class=\"collapse navbar-collapse pixerf-navbar-text\" navbar-collapse-on-click=\"true\" id=\"support-navbar-collapse\">\r\n					<li ui-sref-active=\"pixerf-navigation-bar__menu-item--active\" ui-sref=\"email-us-page\" class=\"pixerf-navigation-bar__menu-item\">SUPPORT</li>\r\n					<li ui-sref-active-class=\"pixerf-navigation-bar__menu-item--active\" ui-sref-active-if=\"introduction-support.faq\" ui-sref=\"introduction-support.faq.personal\" class=\"pixerf-navigation-bar__menu-item\" data-toggle=\"collapse\" data-target=\"#subcription-sub-navbar-collapse\" aria-expanded=\"false\">FAQ</li>\r\n						<ul class=\"pixerf-subnavigation-bar\" id=\"subcription-sub-navbar-collapse\">\r\n							<li ui-sref-active=\"pixerf-subnavigation-bar__menu-item--active\" ui-sref=\"introduction-support.faq.personal\" class=\"pixerf-subnavigation-bar__menu-item\">CONTRIBUTOR</li>\r\n							<li ui-sref-active=\"pixerf-subnavigation-bar__menu-item--active\" ui-sref=\"introduction-support.faq.business\" class=\"pixerf-subnavigation-bar__menu-item\">BUSINESS</li>\r\n						</ul>\r\n					<li ui-sref-active=\"pixerf-navigation-bar__menu-item--active\" ui-sref=\"introduction-support.releases\" class=\"pixerf-navigation-bar__menu-item\">RELEASES</li>\r\n					<li ui-sref-active=\"pixerf-navigation-bar__menu-item--active\" ui-sref=\"#\" class=\"ng-hide pixerf-navigation-bar__menu-item\">JOBS</li>\r\n				</div>\r\n			</div>\r\n		</ul>\r\n    </div> --><div class=\"col-md-12 introduction-page__main-content marketplace-wrap\" ui-view></div></div>");
$templateCache.put("app/manage-custom-commissions/completed/custom-commissions-completed.html","");
$templateCache.put("app/manage-custom-commissions/on-going/custom-commissions-on-going.html","<div class=custom-commissions-on-going><div class=custom-commissions-on-going__header><div class=custom-commissions-on-going__title translate>{{\'view-ongoing-custom-commissions-here\'}}</div><div class=custom-commissions-on-going__order><div class=custom-commissions-on-going__order__text translate>{{\'sort-by\'}}</div><ul class=custom-commissions-on-going__order__input><li class=custom-commissions-on-going__order__input__select ng-class=\"{\'custom-commissions-on-going__order__input__select--active\': !vm.selectedSize.isDefault}\"><popover-selection-btn close-on-click=true on-selection-changed=vm.onFilteredClicked(item) selected-model=vm.selectedFilterItem settings=vm.filterSetting></popover-selection-btn></li></ul></div></div><div class=custom-commissions-on-going__body infinite-scroll-disabled=vm.isLastPage infinite-scroll=vm.fetchMoreOngoingCustomCommission() infinite-scroll-immediate-check=false><custom-commissions-tile data=item ng-repeat=\"item in vm.customCommissions\"></custom-commissions-tile><scroll-paging spinner=vm.spinner is-last-page=vm.isLastPage></scroll-paging></div></div>");
$templateCache.put("app/manage-media-post/create-media-post/create-media-post.html","<div class=create-media-post><div class=create-media-post__content><form name=profileForm class=create-media-post__content__form><div class=create-media-post__content__col-left><div class=create-media-post__content__col-left__dropzone><div id=create-media-post__attach-photos-section pixerf-dropzone dropzone=vm.dropzoneConfig.instance dropzone-config=vm.dropzoneConfig.options event-handlers=vm.dropzoneConfig.eventHandlers><div id=preview ng-class=\"{\'cropped-photo\': vm.dropzoneConfig.instance.files && vm.dropzoneConfig.instance.files.length}\"></div><div ng-if=vm.showAttachPhotoBtn class=create-media-post__attach><div class=\"create-media-post__attach__icon icon-Upload-a-photo\"></div><div class=create-media-post__attach__text>Image from article or publication logo</div></div></div></div></div><div class=create-media-post__content__col-right><div class=create-media-post__content__col-right__row><div class=create-media-post__content__form__group><label>Headline</label><input class=form-control maxlength=1000 ng-model=vm.post.name></div></div><div class=create-media-post__content__col-right__row><div class=create-media-post__content__form__group><label>Date</label><div class=create-media-post__content__form__date-group><input class=form-control type=text datepicker-options=\"{showWeeks: false}\" show-button-bar=false uib-datepicker-popup=d/MM/yyyy ng-model=vm.post.posted_at is-open=vm.filterFromIsVisible><div class=create-media-post__content__form__date-group__calendar-icon ng-click=\"vm.filterFromIsVisible = !vm.filterFromIsVisible\"><i class=\"glyphicon glyphicon-calendar\"></i></div></div></div></div><div class=create-media-post__content__col-right__row><div class=create-media-post__content__form__group><label>Publication name</label><input class=form-control maxlength=1000 ng-model=vm.post.url_text></div><div class=create-media-post__content__form__group><label>URL of full article</label><input class=form-control maxlength=1000 ng-model=vm.post.url></div></div><div class=create-media-post__content__col-right__row><div class=create-media-post__content__form__group><label>Summary of news article</label><textarea rows=5 ng-model=vm.post.description class=form-control></textarea></div></div></div></form><div class=create-media-post__content__publish-btn ng-click=vm.savePost()>Publish</div></div></div>");
$templateCache.put("app/manage-media-post/published-media-post/published-media-post.html","<div class=published-media-post><div ng-if=vm.posts.length class=published-media-post__list infinite-scroll-disabled=vm.isLastPage infinite-scroll=vm.fetchMorePosts() infinite-scroll-immediate-check=false><media-post-tile ng-repeat=\"post in vm.posts\" data=post on-delete-item=vm.onDeletedPost(id)></media-post-tile><spinner-win spinner=vm.spinner></spinner-win></div></div>");
$templateCache.put("app/manage-missions/create-mission/create-mission.html","<div class=create-mission><bread-crumbs on-init=vm.onBreadCrumInit(instance) current-index=vm.currentStepIndex items=vm.listSteps on-bread-crubm-clicked=vm.navigateTo(step)></bread-crumbs><div class=\"bg--white create-mission__main-contain\"><section class=create-mission__wrapper ui-view></section></div><div class=\"create-mission__control-row-wrapper clearfix\"><button class=\"btn btn-submit create-mission__submit-btn text--semibold\" ng-click=vm.onNextBtnClicked(missionForm) ng-disabled=vm.isWorking ng-if=vm.navigationBtnStatus.next translate>{{\'next\'}}</button> <button class=\"btn btn-submit create-mission__cancel-btn text--semibold btn-cancel--no-background\" ng-click=vm.onBackBtnClicked(missionForm) ng-disabled=vm.isWorking ng-if=vm.navigationBtnStatus.back>Back</button><div class=create-mission__got-question><div class=create-mission__got-question__title translate>{{\'got-a-question\'}}</div><div class=create-mission__got-question__email translate>{{\'check-out-faq\'}}</div></div></div></div>");
$templateCache.put("app/manage-missions/mission-draft/mission-draft.html","<section class=manage-missions-draft__wrapper ui-view></section>");
$templateCache.put("app/manage-missions/mission-pending/mission-pending.html","<div class=\"manage-missions-draft no-margin clearfix\"><div class=\"manage-missions-draft__col-wrapper clearfix\"><section class=no-padding><div class=manage-missions-draft__intro><div class=\"manage-missions-draft__intro__title text--bold\">MISSION PENDING</div><div class=manage-missions-draft__intro__description>Edit and delete your Missions here. Once our team has reviewed your Mission details, you will be able to launch your Missions at the click of a button!</div></div><div class=manage-missions-draft__col-left infinite-scroll-disabled=vm.isLastPage infinite-scroll=vm.fetchMoreItems() infinite-scroll-immediate-check=false><div ng-if=\"vm.items.length > 0\"><mission-status-list missions=vm.items></mission-status-list></div><div class=text-center ng-if=\"vm.items.length === 0\">{{\'no-records-found\' | translate}}</div></div><spinner-win spinner=vm.spinner></spinner-win></section><section class=\"col-md-4 no-padding ng-hide\"><div class=manage-missions-draft__col-right><div class=manage-missions-draft__col-right__description>Vivamus quis quam vehicula, semper purus fermentum, sagittis urna. Cras sed lorem gravida, egestas sem euismod, cursus purus. In et nisl ornare, ullamcorper justo at, tristique libero. Donec venenatis, odio a efficitur maximus, massa magna iaculis massa, tempus posuere tortor purus ut arcu.</div></div></section></div></div><section class=manage-mission__get-started><div class=\"manage-mission__get-started__branding text--color-black\">NEED HELP REGARDING HOW TO<br>RUN A MISSION?</div><div class=\"manage-mission__get-started__description text--color-black\">Talk to us! Our team will answer all your questions regarding Missions.</div><button ui-sref=email-us-page class=\"btn btn-submit manage-mission__lets-talk-btn text--bold\" ng-disabled=vm.isWorking>Get in Touch</button></section>");
$templateCache.put("app/manage-missions/mission-preview/mission-preview.html","<div class=\"mission-preview mission-detail-page main__content--md\" ng-class=\"{\'margin-top--1\': isScreenMobile}\"><button type=button class=\"close mission-preview-popup__close-btn\" ng-click=vm.closePopup()><span class=\"icon-icons_close text--color-white\" aria-hidden=true></span></button><section class=bg--white><div class=\"row mission-detail-page__photo-wrapper\" ng-style=\"{\'background-image\': \'url(\\\'\' + vm.coverMedia + \'\\\')\'}\"><div class=mission-detail-page__description><div class=mission-detail-page__description__logo><img ng-src=\"{{vm.mission.sponsor ? vm.mission.sponsor.logoUrl : vm.mission.organization.profileImageUrl}}\"><div class=mission-detail-page__requirement-note ng-if=\"vm.mission.countries && (vm.mission.countries.length > 0)\"><div class=mission-detail-page__requirement-note__wrap><div class=mission-detail-page__requirement-note__text>{{vm.countriesName}}</div></div></div></div><div class=mission-detail-page__description__details><div class=mission-detail-page__description__title>{{vm.mission.title}}</div><div class=mission-detail-page__description__text-by translate>{{\'community-challenge-by\'}}</div><div class=\"mission-detail-page__description__author text--bold\">{{vm.mission.sponsor ? vm.mission.sponsor.name : vm.mission.organization.name}}</div></div><div class=mission-detail-page__status-wrapper><button class=\"mission-detail-page__label-status btn btn-submit\">{{\'submit-your-photo\' | translate}}</button></div></div><div class=overlay></div></div><div class=pixerf-navigation-bar-wrapper><ul class=\"pixerf-navigation-bar clearfix\"><button type=button class=\"navbar-toggle collapsed\" data-toggle=collapse data-target=#mission-details-navbar-collapse aria-expanded=false><div class=\"pull-left text--bold\">{{vm.contextPage}}</div><div class=\"pull-right arrow-animation-menu-collapse\"><span class=\"icon-bar dash-one\"></span> <span class=\"icon-bar dash-two\"></span></div></button><div class=\"collapse navbar-collapse pixerf-navbar-text\" id=mission-details-navbar-collapse navbar-collapse-on-click=true><li ui-sref-active=pixerf-navigation-bar__menu-item--active class=pixerf-navigation-bar__menu-item translate>{{\'brief\'}}</li><li ui-sref-active=pixerf-navigation-bar__menu-item--active class=pixerf-navigation-bar__menu-item translate>{{\'visual-inspiration\'}}</li><li ui-sref-active=pixerf-navigation-bar__menu-item--active class=pixerf-navigation-bar__menu-item translate>{{\'submissions\'}}</li></div><button type=button class=\"navbar-toggle collapsed mission-share-btn-collapse\" data-toggle=collapse data-target=#mission-share-navbar-collapse aria-expanded=false><div class=icon-icons_share></div></button><div class=\"mission-detail-page__share-btn vertical-align-middle--transform collapse navbar-collapse\" navbar-collapse-on-click=true id=mission-share-navbar-collapse><share settings=\"{\'appendToBody\': true, \'flatMode\': true}\" content-will-be-shared=vm.socialShareContent title=\"Share this mission\"></share></div></ul></div></section><section class=\"brief bg--white\"><mission-info mission=vm.mission is-preview-mode=true></mission-info></section></div>");
$templateCache.put("app/manage-photos-mission/approved/manage-approved-photos-mission.html","<div class=manage-approved-photos-mission><div class=\"manage-approved-photos-mission__content-wrapper clearfix\"><section infinite-scroll-disabled=vm.isLastPage infinite-scroll=vm.fetchMoreItems() infinite-scroll-immediate-check=false><div class=manage-approved-photos-mission__list><div ng-show=\"vm.showedData.length > 0\"><div class=\"manage-approved-photos-mission__item clearfix\" ng-repeat=\"data in vm.showedData\"><div class=\"manage-approved-photos-mission__title clearfix\" ng-click=vm.onCollapseToggle(data.mission.id)><div class=manage-approved-photos-mission__group-info><span class=manage-approved-photos-mission__mission-name>\'{{data.mission.name}}\'</span> <span ng-if=data.mission.sponsor>/</span> <span ng-if=data.mission.sponsor>{{data.mission.sponsor}}</span> <span ng-if=\"data.mission.approved > 0\">({{data.mission.approved}})</span></div><div class=manage-approved-photos-mission__collapse-icon ng-class=\"vm.isCollapsed.{{data.mission.id}} ? \'icon-icons_chevron-down\' : \'icon-icons_chevron-up\'\"></div></div><div class=\"manage-approved-photos-mission__photo-grid collapse cursor-text clearfix\" uib-collapse=vm.isCollapsed.{{data.mission.id}} aria-expanded=false aria-hidden=true ng-click=$event.stopPropagation()><div class=\"manage-approved-photos-mission__item__img clearfix\" ng-repeat=\"item in data.photos\"><div class=manage-approved-photos-mission__item__img__link ng-click=vm.onPhotoClicked(item)><img ng-attr-alt={{item.title}} ng-src=\"{{\'assets/images/default/default-cover.png\'}}\" ng-attr-lazy-img-error=\'{{ \"assets/images/default/default-cover.png\"}}\' ng-attr-lazy-img={{item.urlSmall}}></div></div></div></div></div><div class=manage-approved-photos-mission__empty ng-show=\"vm.showedData.length === 0\"><div class=manage-approved-photos-mission__empty__wrapper><div class=manage-approved-photos-mission__empty__title translate>{{\'you-have-not-joined-any-missions\'}}</div><div class=manage-approved-photos-mission__empty__desc translate translate-values=\"{number: vm.fileConst.UPLOAD_PHOTO_VALIDATION.MISSION_LIMIT}\">{{\'joined-join-missions\'}}</div><button type=button class=\"manage-approved-photos-mission__empty__explore-btn btn btn-submit\" ng-click=vm.onExploreMissionsClicked() translate>{{\'explore-missions\'}}</button></div></div></div></section></div><spinner-win spinner=vm.spinner></spinner-win></div>");
$templateCache.put("app/manage-photos-mission/awards/manage-awards-photos-mission.html","<div class=manage-awards-photos-mission><div class=\"manage-awards-photos-mission__content-wrapper clearfix\"><section class=clearfix><div class=manage-awards-photos-mission__list><div class=manage-awards-photos-mission__pending-section ng-if=vm.pendingAwards.length><div class=clearfix ng-click=\"vm.onCollapseToggle(\'pendingAwards\')\"><div class=manage-awards-photos-mission__pending-section__title translate>{{\'pending\'}}</div><div class=manage-awards-photos-mission__collapse-icon ng-class=\"vm.isCollapsed.pendingAwards ? \'icon-icons_chevron-down\' : \'icon-icons_chevron-up\'\"></div></div><div class=\"collapse cursor-text\" uib-collapse=vm.isCollapsed.pendingAwards aria-expanded=false aria-hidden=true ng-click=$event.stopPropagation()><div ng-if=!vm.isCollapsed.pendingAwards infinite-scroll-disabled=vm.isLastPage.pending infinite-scroll=\"vm.fetchMoreItems(\'pending\')\" infinite-scroll-immediate-check=false><div class=\"manage-awards-photos-mission-item clearfix\" ng-repeat=\"awardsMission in vm.pendingAwards\"><mission-awards-row mission=awardsMission></mission-awards-row></div></div></div></div><div class=manage-awards-photos-mission__past-section ng-if=vm.claimedAwards.length><div class=clearfix ng-click=\"vm.onCollapseToggle(\'claimedAwards\')\"><div class=manage-awards-photos-mission__past-section__title translate>{{\'past-awards\'}}</div><div class=manage-awards-photos-mission__collapse-icon ng-class=\"vm.isCollapsed.claimedAwards ? \'icon-icons_chevron-down\' : \'icon-icons_chevron-up\'\"></div></div><div class=\"collapse cursor-text\" uib-collapse=vm.isCollapsed.claimedAwards aria-expanded=false aria-hidden=true ng-click=$event.stopPropagation()><div ng-if=!vm.isCollapsed.claimedAwards infinite-scroll-disabled=vm.isLastPage.rejected infinite-scroll=\"vm.fetchMoreItems(\'rejected\')\" infinite-scroll-immediate-check=false><div class=\"manage-awards-photos-mission-item clearfix\" ng-repeat=\"awardsMission in vm.claimedAwards\"><mission-awards-row mission=awardsMission></mission-awards-row></div></div></div></div><div class=manage-awards-photos-mission__empty ng-show=\"vm.pendingAwards.length === 0 && vm.claimedAwards.length === 0\"><div class=manage-awards-photos-mission__empty__wrapper><div class=manage-awards-photos-mission__empty__title translate>{{\'you-have-not-joined-any-missions\'}}</div><div class=manage-awards-photos-mission__empty__desc translate translate-values=\"{number: vm.fileConst.UPLOAD_PHOTO_VALIDATION.MISSION_LIMIT}\">{{\'joined-join-missions\'}}</div><button type=button class=\"manage-awards-photos-mission__empty__explore-btn btn btn-submit\" ng-click=vm.onExploreMissionsClicked() translate>{{\'explore-missions\'}}</button></div></div></div></section></div><spinner-win spinner=vm.spinner></spinner-win></div>");
$templateCache.put("app/manage-photos-mission/pending/manage-pending-photos-mission.html","<div class=manage-pending-photos-mission><div class=\"manage-pending-photos-mission__content-wrapper clearfix\"><section infinite-scroll-disabled=vm.isLastPage infinite-scroll=vm.fetchMoreItems() infinite-scroll-immediate-check=false><div class=manage-pending-photos-mission__list><div ng-show=\"vm.showedData.length > 0\"><div class=manage-pending-photos-mission__item ng-repeat=\"data in vm.showedData\"><div class=clearfix ng-click=vm.onCollapseToggle(data.mission.id)><div class=manage-pending-photos-mission__group-info><span class=manage-pending-photos-mission__mission-name>\'{{data.mission.name}}\'</span> <span ng-if=data.mission.sponsor>/</span> <span ng-if=data.mission.sponsor>{{data.mission.sponsor}}</span> <span ng-if=\"data.mission.pending > 0\">({{data.mission.pending}})</span></div><div class=manage-pending-photos-mission__collapse-icon ng-class=\"vm.isCollapsed.{{data.mission.id}} ? \'icon-icons_chevron-down\' : \'icon-icons_chevron-up\'\"></div></div><div class=\"collapse cursor-text\" uib-collapse=vm.isCollapsed.{{data.mission.id}} aria-expanded=false aria-hidden=true ng-click=$event.stopPropagation()><div class=\"manage-pending-photos-mission-item clearfix\" ng-repeat=\"item in data.photos\"><manage-photos-status status=\"\'review\'\" media=item on-media-deleted=vm.onMediaDeleted(media) label=\"Remove from Mission\"></manage-photos-status></div></div></div></div><div class=manage-pending-photos-mission__empty ng-show=\"vm.showedData.length === 0\"><div class=manage-pending-photos-mission__empty__wrapper><div class=manage-pending-photos-mission__empty__title translate>{{\'you-have-not-joined-any-missions\'}}</div><div class=manage-pending-photos-mission__empty__desc translate translate-values=\"{number: vm.fileConst.UPLOAD_PHOTO_VALIDATION.MISSION_LIMIT}\">{{\'joined-join-missions\'}}</div><button type=button class=\"manage-pending-photos-mission__empty__explore-btn btn btn-submit\" ng-click=vm.onExploreMissionsClicked() translate>{{\'explore-missions\'}}</button></div></div></div></section></div><spinner-win spinner=vm.spinner></spinner-win></div>");
$templateCache.put("app/manage-photos-mission/rejected/manage-rejected-photos-mission.html","<div class=manage-rejected-photos-mission><div class=\"manage-rejected-photos-mission__content-wrapper clearfix\"><section infinite-scroll-disabled=vm.isLastPage infinite-scroll=vm.fetchMoreItems() infinite-scroll-immediate-check=false><div class=manage-rejected-photos-mission__list><div ng-show=\"vm.showedData.length > 0\"><div class=manage-rejected-photos-mission__item ng-repeat=\"data in vm.showedData\"><div class=clearfix ng-click=vm.onCollapseToggle(data.mission.id)><div class=manage-rejected-photos-mission__group-info><span class=manage-rejected-photos-mission__mission-name>\'{{data.mission.name}}\'</span> <span ng-if=data.mission.sponsor>/</span> <span ng-if=data.mission.sponsor>{{data.mission.sponsor}}</span> <span ng-if=\"data.mission.rejected > 0\">({{data.mission.rejected}})</span></div><div class=manage-rejected-photos-mission__collapse-icon ng-class=\"vm.isCollapsed.{{data.mission.id}} ? \'icon-icons_chevron-down\' : \'icon-icons_chevron-up\'\"></div></div><div class=\"collapse cursor-text\" uib-collapse=vm.isCollapsed.{{data.mission.id}} aria-expanded=false aria-hidden=true ng-click=$event.stopPropagation()><div class=\"manage-rejected-photos-mission-item clearfix\" ng-repeat=\"item in data.photos\"><manage-photos-status status=\"\'rejectedMission\'\" media=item on-media-deleted=vm.onMediaDeleted(media)></manage-photos-status></div></div></div></div><div class=manage-rejected-photos-mission__empty ng-show=\"vm.showedData.length === 0\"><div class=manage-rejected-photos-mission__empty__wrapper><div class=manage-rejected-photos-mission__empty__title translate>{{\'you-have-not-joined-any-missions\'}}</div><div class=manage-rejected-photos-mission__empty__desc translate translate-values=\"{number: vm.fileConst.UPLOAD_PHOTO_VALIDATION.MISSION_LIMIT}\">{{\'joined-join-missions\'}}</div><button type=button class=\"manage-rejected-photos-mission__empty__explore-btn btn btn-submit\" ng-click=vm.onExploreMissionsClicked() translate>{{\'explore-missions\'}}</button></div></div></div></section></div><spinner-win spinner=vm.spinner></spinner-win></div>");
$templateCache.put("app/microsites/stay-home-stay-creative/stay-home-stay-creative.html","<div class=stay-home-stay-creative><section class=stay-home-stay-creative__banner-section id=banner><div class=stay-home-stay-creative__banner-section__logo><a href=/ ><img src=assets/images/microsites/stay-home-stay-creative/pixerf-logo.png alt=PIXERF></a></div><!-- <popover-selection-btn ng-if=\"vm.languagesSetting\" class=\"multi-language-dropdown\" close-on-click=\"true\"\r\n			on-selection-changed=\"vm.onLanguagesSelected(item)\" selected-model=\"vm.language\"\r\n			settings=\'vm.languagesSetting\' selected-default-index=\"{{vm.selectedDefaultIndex}}\">\r\n		</popover-selection-btn> --><div class=stay-home-stay-creative__banner-section__content-wrapper><div class=stay-home-stay-creative__banner-section__slogan></div><div class=stay-home-stay-creative__banner-section__description translate=stayhomestaycreative-banner-description></div></div><div class=stay-home-stay-creative__banner-section__join-mission-from-home><div class=stay-home-stay-creative__banner-section__join-mission-from-home__title translate=stayhomestaycreative-banner-join-from-home></div><div ng-if=\"vm.missionOutsideMyWindow.status === \'happening\'\" class=stay-home-stay-creative__banner-section__join-mission-from-home__block-info ng-click=vm.goMissionDetail(vm.missionOutsideMyWindow)><div ng-if=\"vm.missionOutsideMyWindow.remaining > 1\" class=stay-home-stay-creative__banner-section__join-mission-from-home__block-info__remaining translate=no-of-days-left translate-values=\"{\'number\': vm.missionOutsideMyWindow.remaining}\"></div><div ng-if=\"vm.missionOutsideMyWindow.remaining == 1\" class=stay-home-stay-creative__banner-section__join-mission-from-home__block-info__remaining translate=no-of-day-left translate-values=\"{\'number\': vm.missionOutsideMyWindow.remaining}\"></div><div ng-if=\"vm.missionOutsideMyWindow.remaining == 0\" class=stay-home-stay-creative__banner-section__join-mission-from-home__block-info__remaining>{{countDown}}</div><div class=stay-home-stay-creative__banner-section__join-mission-from-home__block-info__header>{{vm.missionOutsideMyWindow.name}}</div><div class=stay-home-stay-creative__banner-section__join-mission-from-home__block-info__prize><div class=stay-home-stay-creative__banner-section__join-mission-from-home__block-info__winner translate=no-of-winners translate-values=\"{number: 20}\"></div><div class=stay-home-stay-creative__banner-section__join-mission-from-home__block-info__value translate=currency-value-prize translate-values=\"{currency: \'SGD50\'}\"></div></div></div><div ng-if=\"vm.missionSuddenlyChef.status === \'happening\'\" class=stay-home-stay-creative__banner-section__join-mission-from-home__block-info ng-click=vm.goMissionDetail(vm.missionSuddenlyChef)><div ng-if=\"vm.missionSuddenlyChef.remaining > 1\" class=stay-home-stay-creative__banner-section__join-mission-from-home__block-info__remaining translate=no-of-days-left translate-values=\"{\'number\': vm.missionSuddenlyChef.remaining}\"></div><div ng-if=\"vm.missionSuddenlyChef.remaining == 1\" class=stay-home-stay-creative__banner-section__join-mission-from-home__block-info__remaining translate=no-of-day-left translate-values=\"{\'number\': vm.missionSuddenlyChef.remaining}\"></div><div class=stay-home-stay-creative__banner-section__join-mission-from-home__block-info__header>{{vm.missionSuddenlyChef.name}}</div><div class=stay-home-stay-creative__banner-section__join-mission-from-home__block-info__prize><div class=stay-home-stay-creative__banner-section__join-mission-from-home__block-info__winner translate=no-of-winners translate-values=\"{number: 20}\"></div><div class=stay-home-stay-creative__banner-section__join-mission-from-home__block-info__value translate=currency-value-prize translate-values=\"{currency: \'SGD50\'}\"></div></div></div><div ng-if=\"vm.missionFrameStories.status === \'happening\'\" class=stay-home-stay-creative__banner-section__join-mission-from-home__block-info ng-click=vm.goMissionDetail(vm.missionFrameStories)><div ng-if=\"vm.missionFrameStories.remaining > 1\" class=stay-home-stay-creative__banner-section__join-mission-from-home__block-info__remaining translate=no-of-days-left translate-values=\"{\'number\': vm.missionFrameStories.remaining}\"></div><div ng-if=\"vm.missionFrameStories.remaining == 1\" class=stay-home-stay-creative__banner-section__join-mission-from-home__block-info__remaining translate=no-of-day-left translate-values=\"{\'number\': vm.missionFrameStories.remaining}\"></div><div ng-if=\"vm.missionFrameStories.remaining == 0\" class=stay-home-stay-creative__banner-section__join-mission-from-home__block-info__remaining>{{countDown}}</div><div class=stay-home-stay-creative__banner-section__join-mission-from-home__block-info__header>{{vm.missionFrameStories.name}}</div><div class=stay-home-stay-creative__banner-section__join-mission-from-home__block-info__winner translate=no-of-winners translate-values=\"{number: 7}\"></div><div class=stay-home-stay-creative__banner-section__join-mission-from-home__block-info__prize>{{vm.missionFrameStories.customPrize | translate}}</div></div><div ng-if=\"vm.missionOutsideMyWindow.status === \'upcoming\' || vm.missionSuddenlyChef.status === \'upcoming\' || vm.missionFrameStories.status === \'upcoming\'\" class=stay-home-stay-creative__banner-section__join-mission-from-home__upcoming-info><!-- <div class=\"stay-home-stay-creative__banner-section__join-mission-from-home__upcoming-info__title\">\r\n					{{\'upcoming-missions\' | translate}}:</div> --><div class=stay-home-stay-creative__banner-section__join-mission-from-home__upcoming-info__block ng-if=\"vm.missionOutsideMyWindow.status === \'upcoming\'\"><div class=stay-home-stay-creative__banner-section__join-mission-from-home__upcoming-info__name>{{vm.missionOutsideMyWindow.name}}</div><div class=stay-home-stay-creative__banner-section__join-mission-from-home__upcoming-info__date>{{vm.missionOutsideMyWindow.launchesDate}}</div></div><div class=stay-home-stay-creative__banner-section__join-mission-from-home__upcoming-info__block ng-if=\"vm.missionSuddenlyChef.status === \'upcoming\'\"><div class=stay-home-stay-creative__banner-section__join-mission-from-home__upcoming-info__name>{{vm.missionSuddenlyChef.name}}</div><div class=stay-home-stay-creative__banner-section__join-mission-from-home__upcoming-info__date>{{vm.missionSuddenlyChef.launchesDate}}</div></div><!-- <div class=\"stay-home-stay-creative__banner-section__join-mission-from-home__upcoming-info__block\"\r\n					ng-if=\"vm.missionFrameStories.status === \'upcoming\'\">\r\n					<div class=\"stay-home-stay-creative__banner-section__join-mission-from-home__upcoming-info__name\">\r\n						{{vm.missionFrameStories.name}}</div>\r\n					<div class=\"stay-home-stay-creative__banner-section__join-mission-from-home__upcoming-info__date\">\r\n						{{vm.missionFrameStories.launchesDate}}</div>\r\n				</div> --></div></div><div class=stay-home-stay-creative__banner-section__see-more ng-click=\"vm.scrollNextSection(\'wear-a-smile\')\"><div class=stay-home-stay-creative__banner-section__see-more__icon><img src=assets/images/microsites/stay-home-stay-creative/scroll-down.png></div><div class=stay-home-stay-creative__banner-section__see-more__text translate=see-more></div></div><div class=stay-home-stay-creative__banner-section__overlay></div><div class=stay-home-stay-creative__image-by><span class=stay-home-stay-creative__image-by__label>Image by</span> <span class=stay-home-stay-creative__image-by__author>Ketan Dalvi</span></div></section><section class=stay-home-stay-creative__wear-a-smile-section id=wear-a-smile><div class=\"stay-home-stay-creative__col-left stay-home-stay-creative__wear-a-smile-section__col-left\"><div class=stay-home-stay-creative__wear-a-smile-section__col-left__content-block><div class=stay-home-stay-creative__wear-a-smile-section__col-left__content-block__title>Wear a Smile</div><div class=stay-home-stay-creative__wear-a-smile-section__col-left__content-block__description translate=stayhomestaycreative-wearasmile-description-1></div><div class=stay-home-stay-creative__wear-a-smile-section__col-left__content-block__description translate=stayhomestaycreative-wearasmile-description-2></div></div><div class=stay-home-stay-creative__wear-a-smile-section__col-left__footer><div class=stay-home-stay-creative__wear-a-smile-section__col-left__button translate=watch-smile-video ng-click=vm.seeMoreSmilesClicked(vm.videoSmiles)></div><div class=stay-home-stay-creative__wear-a-smile-section__col-left__subtitle translate=stayhomestaycreative></div></div></div><div class=\"stay-home-stay-creative__col-right stay-home-stay-creative__wear-a-smile-section__col-right\"><div class=stay-home-stay-creative__wear-a-smile-section__col-right__item><img src=assets/images/microsites/stay-home-stay-creative/wear-a-smile-1.jpg></div><div class=stay-home-stay-creative__wear-a-smile-section__col-right__item><img src=assets/images/microsites/stay-home-stay-creative/wear-a-smile-2.jpg></div><div class=stay-home-stay-creative__wear-a-smile-section__col-right__item><img src=assets/images/microsites/stay-home-stay-creative/wear-a-smile-3.jpg></div><div class=stay-home-stay-creative__wear-a-smile-section__col-right__item><img src=assets/images/microsites/stay-home-stay-creative/wear-a-smile-4.jpg></div></div></section><section class=stay-home-stay-creative__outside-my-window-section id=outside-my-window><div class=\"stay-home-stay-creative__col-left stay-home-stay-creative__outside-my-window-section__col-left\"><div class=stay-home-stay-creative__outside-my-window-section__col-left__logo ng-class=\"{\'grey-out-button\': vm.missionOutsideMyWindow.status === \'upcoming\', \'ongoing-mission\': vm.missionOutsideMyWindow.status === \'happening\', \'closed-mission\': vm.missionOutsideMyWindow.status != \'happening\'}\" ng-click=\"vm.goMissionDetail(vm.missionOutsideMyWindow, vm.missionOutsideMyWindow.status)\">{{vm.missionOutsideMyWindow.label | translate}}</div><div class=stay-home-stay-creative__outside-my-window-section__col-left__content-block><div ng-if=\"vm.missionOutsideMyWindow.status === \'upcoming\'\" class=stay-home-stay-creative__suddenly-chef-section__col-left__content-block__date>{{\'launches-on\' | translate}} {{vm.missionOutsideMyWindow.launchesDate}}</div><div ng-if=\"vm.missionOutsideMyWindow.status === \'happening\' && vm.missionOutsideMyWindow.remaining != 0\" class=stay-home-stay-creative__outside-my-window-section__col-left__content-block__date translate=no-of-days-left translate-values=\"{number: vm.missionOutsideMyWindow.remaining}\"></div><div ng-if=\"vm.missionOutsideMyWindow.status === \'happening\' && vm.missionOutsideMyWindow.remaining == 0\" class=stay-home-stay-creative__outside-my-window-section__col-left__content-block__date>{{countDown}}</div><div class=stay-home-stay-creative__outside-my-window-section__col-left__content-block__name>Outside My Window</div><div class=stay-home-stay-creative__outside-my-window-section__col-left__content-block__prize><div class=stay-home-stay-creative__outside-my-window-section__col-left__content-block__prize__winner translate=no-of-winners translate-values=\"{number: 20}\"></div><div class=stay-home-stay-creative__outside-my-window-section__col-left__content-block__prize__value translate=currency-value-prize translate-values=\"{currency: \'SGD50\'}\"></div></div><div class=stay-home-stay-creative__outside-my-window-section__col-left__content-block__description translate=stayhomestaycreative-outsidemywindow-description-1></div></div><div class=stay-home-stay-creative__wear-a-smile-section__col-left__footer><div ng-if=\"vm.missionOutsideMyWindow.status === \'past\'\" class=stay-home-stay-creative__outside-my-window-section__col-left__button ng-class=\"{\'grey-out-button closed-mission\': vm.missionOutsideMyWindow.status === \'upcoming\'}\" ng-click=\"vm.goMissionDetail(vm.missionOutsideMyWindow, vm.missionOutsideMyWindow.status)\" translate>{{vm.missionOutsideMyWindow.btnText}}</div><div ng-if=\"vm.missionOutsideMyWindow.status != \'past\'\" class=stay-home-stay-creative__outside-my-window-section__col-left__button ng-class=\"{\'grey-out-button closed-mission\': vm.missionOutsideMyWindow.status === \'upcoming\'}\" ng-click=\"vm.goMissionDetail(vm.missionOutsideMyWindow, vm.missionOutsideMyWindow.status)\">{{((\'join-the-mission\' | translate) + \'!\')}}</div><div class=stay-home-stay-creative__outside-my-window-section__col-left__subtitle translate=stayhomestaycreative></div></div></div><div class=\"stay-home-stay-creative__col-right stay-home-stay-creative__outside-my-window-section__col-right\"><div class=stay-home-stay-creative__outside-my-window-section__col-right__item><a href=https://pixerf.com/#/photo/10762 target=_blank><img src=assets/images/microsites/stay-home-stay-creative/outside-my-window.jpg></a></div><div class=stay-home-stay-creative__image-by><span class=stay-home-stay-creative__image-by__label>Image by</span> <a href=https://pixerf.com/#/photo/10762 target=_blank><span class=stay-home-stay-creative__image-by__author>Liew Kai Wen</span></a></div></div></section><section class=stay-home-stay-creative__suddenly-chef-section id=suddenly-chef><div class=\"stay-home-stay-creative__col-left stay-home-stay-creative__suddenly-chef-section__col-left\"><div ng-click=\"vm.goMissionDetail(vm.missionSuddenlyChef, vm.missionSuddenlyChef.status)\" class=stay-home-stay-creative__suddenly-chef-section__col-left__logo ng-class=\"{\'grey-out-button\': vm.missionSuddenlyChef.status === \'upcoming\', \'ongoing-mission\': vm.missionSuddenlyChef.status === \'happening\', \'closed-mission\': vm.missionSuddenlyChef.status != \'happening\'}\">{{vm.missionSuddenlyChef.label | translate}}</div><div class=stay-home-stay-creative__suddenly-chef-section__col-left__content-block><div ng-if=\"vm.missionSuddenlyChef.status === \'upcoming\'\" class=stay-home-stay-creative__suddenly-chef-section__col-left__content-block__date>{{\'launches-on\' | translate}} {{vm.missionSuddenlyChef.launchesDate}}</div><div ng-if=\"vm.missionSuddenlyChef.status === \'happening\'\" class=stay-home-stay-creative__suddenly-chef-section__col-left__content-block__date translate=no-of-days-left translate-values=\"{number: vm.missionSuddenlyChef.remaining}\"></div><div class=stay-home-stay-creative__suddenly-chef-section__col-left__content-block__name>Suddenly Chef</div><div class=stay-home-stay-creative__suddenly-chef-section__col-left__content-block__prize><div class=stay-home-stay-creative__suddenly-chef-section__col-left__content-block__prize__winner translate=no-of-winners translate-values=\"{number: 20}\"></div><div class=stay-home-stay-creative__suddenly-chef-section__col-left__content-block__prize__value translate=currency-value-prize translate-values=\"{currency: \'SGD50\'}\"></div></div><div class=stay-home-stay-creative__suddenly-chef-section__col-left__content-block__description translate=stayhomestaycreative-suddenlychef-description-1></div></div><div class=stay-home-stay-creative__wear-a-smile-section__col-left__footer><div ng-if=\"vm.missionSuddenlyChef.status === \'past\'\" class=stay-home-stay-creative__suddenly-chef-section__col-left__button ng-class=\"{\'grey-out-button closed-mission\' :vm.missionSuddenlyChef.status === \'upcoming\'}\" ng-click=\"vm.goMissionDetail(vm.missionSuddenlyChef, vm.missionSuddenlyChef.status)\" translate>{{vm.missionSuddenlyChef.btnText}}</div><div ng-if=\"vm.missionSuddenlyChef.status != \'past\'\" class=stay-home-stay-creative__suddenly-chef-section__col-left__button ng-class=\"{\'grey-out-button closed-mission\' :vm.missionSuddenlyChef.status === \'upcoming\'}\" ng-click=\"vm.goMissionDetail(vm.missionSuddenlyChef, vm.missionSuddenlyChef.status)\">{{((\'join-the-mission\' | translate) + \'!\')}}</div><div class=stay-home-stay-creative__suddenly-chef-section__col-left__subtitle translate=stayhomestaycreative></div></div></div><div class=\"stay-home-stay-creative__col-right stay-home-stay-creative__suddenly-chef-section__col-right\"><div class=stay-home-stay-creative__suddenly-chef-section__col-right__item><a href=https://pixerf.com/#/photo/101517 target=_blank><img src=assets/images/microsites/stay-home-stay-creative/suddenly-chelf.jpg></a></div><div class=stay-home-stay-creative__image-by><span class=stay-home-stay-creative__image-by__label>Image by</span> <a href=https://pixerf.com/#/photo/101517 target=_blank><span class=stay-home-stay-creative__image-by__author>Todd Beltz</span></a></div></div></section><section class=stay-home-stay-creative__frame-section id=frame><div class=\"stay-home-stay-creative__col-left stay-home-stay-creative__frame-section__col-left\"><div class=stay-home-stay-creative__frame-section__col-left__logo ng-class=\"{\'grey-out-button\': vm.missionFrameStories.status === \'upcoming\', \'ongoing-mission\': vm.missionFrameStories.status === \'happening\', \'closed-mission\': vm.missionFrameStories.status != \'happening\'}\">{{vm.missionFrameStories.label | translate}}</div><div class=stay-home-stay-creative__frame-section__col-left__content-block><!-- <div ng-if=\"vm.missionFrameStories.status === \'upcoming\'\"\r\n					class=\"stay-home-stay-creative__frame-section__col-left__content-block__date\">\r\n					{{\'launches-on\' | translate}} {{vm.missionFrameStories.launchesDate}}</div> --><div ng-if=\"vm.missionFrameStories.status === \'happening\'\" class=stay-home-stay-creative__suddenly-chef-section__col-left__content-block__date translate=no-of-days-left translate-values=\"{number: vm.missionFrameStories.remaining}\"></div><div class=stay-home-stay-creative__frame-section__col-left__content-block__name>4-Frame Stories</div><div class=stay-home-stay-creative__frame-section__col-left__content-block__prize><div class=stay-home-stay-creative__frame-section__col-left__content-block__prize__winner translate>{{vm.missionFrameStories.customPrize}}</div></div><div class=stay-home-stay-creative__frame-section__col-left__content-block__description translate=stayhomestaycreative-4framestories-description-1></div></div><div class=stay-home-stay-creative__wear-a-smile-section__col-left__footer><div ng-if=\"vm.missionFrameStories.status === \'past\'\" class=stay-home-stay-creative__frame-section__col-left__button ng-class=\"{\'grey-out-button closed-mission\' :vm.missionFrameStories.status === \'upcoming\'}\" ng-click=\"vm.goMissionDetail(vm.missionFrameStories, vm.missionFrameStories.status)\" translate>{{vm.missionFrameStories.btnText}}</div><div ng-if=\"vm.missionFrameStories.status != \'past\'\" class=stay-home-stay-creative__frame-section__col-left__button ng-class=\"{\'grey-out-button closed-mission\' :vm.missionFrameStories.status === \'upcoming\'}\" ng-click=\"vm.goMissionDetail(vm.missionFrameStories, vm.missionFrameStories.status)\">{{((\'join-the-mission\' | translate) + \'!\')}}</div><div class=stay-home-stay-creative__frame-section__col-left__subtitle translate=stayhomestaycreative></div></div></div><div class=\"stay-home-stay-creative__col-right stay-home-stay-creative__frame-section__col-right\"><div class=stay-home-stay-creative__frame-section__col-right__item><a href=https://pixerf.com/#/user-home-page/36084/Yik-Keat-Lee/personal/photos target=_blank><img src=assets/images/microsites/stay-home-stay-creative/frame-1.jpg></a></div><div class=stay-home-stay-creative__frame-section__col-right__item><a href=https://pixerf.com/#/user-home-page/36084/Yik-Keat-Lee/personal/photos target=_blank><img src=assets/images/microsites/stay-home-stay-creative/frame-2.jpg></a></div><div class=stay-home-stay-creative__frame-section__col-right__item><a href=https://pixerf.com/#/user-home-page/36084/Yik-Keat-Lee/personal/photos target=_blank><img src=assets/images/microsites/stay-home-stay-creative/frame-3.jpg></a></div><div class=stay-home-stay-creative__frame-section__col-right__item><a href=https://pixerf.com/#/user-home-page/36084/Yik-Keat-Lee/personal/photos target=_blank><img src=assets/images/microsites/stay-home-stay-creative/frame-4.jpg></a></div><div class=stay-home-stay-creative__image-by><span class=stay-home-stay-creative__image-by__label>Images by</span> <a href=https://pixerf.com/#/user-home-page/36084/Yik-Keat-Lee/personal/photos target=_blank><span class=stay-home-stay-creative__image-by__author>Yik Keat Lee</span></a></div></div></section></div>");
$templateCache.put("app/notification-page/notification-page-following/notification-page-following.html","<div class=notification-page__notification-list-wrapper><newsfeed-list on-list-loaded=vm.onListLoaded(response) on-init=vm.onNotificationListInit(instance)></newsfeed-list></div>");
$templateCache.put("app/notification-page/notification-page-notifications/notification-page-notifications.html","<div class=notification-page__notification-list-wrapper><notification-list on-list-loaded=vm.onListLoaded(response) on-init=vm.onNotificationListInit(instance) parent-class=.notification-page__notification-list-wrapper scroll-spy-offset=750></notification-list><div class=\"btn btn-default scroll-to-top-btn\" title=\"Scroll to Top\" ng-click=vm.scrollToTop()><span class=icon-icons-arrow-up></span></div></div>");
$templateCache.put("app/peoples-page/peoples-page-by-affections/peoples-page-by-affections.html","<div class=peoples-page__content-wrapper><div class=\"peoples-page__header-wrapper clearfix\"><div class=\"relative peoples-page__search-wrapper\"><input ng-model=vm.parent.searchString ng-change=vm.parent.onSearchStringChanged() class=\"form-control search-input\" type=text placeholder=\"Search people...\"> <span class=\"peoples-page__search-wrapper__search-icon glyphicon glyphicon-search vertical-align-middle--transform\"></span></div></div><div class=\"peoples-page__peoples-list-wrapper clearfix text-left\"><div ng-repeat=\"people in vm.parent.peoples\" class=peoples-page__peoples-list__item infinite-scroll-disabled=vm.parent.isLastPage infinite-scroll=vm.parent.fetchMorePeoples() infinite-scroll-immediate-check=false><user-tag is-hide-remove-btn=true user-data=people on-follow-status-changed=vm.parent.onFollowStatusChanged(status)></user-tag></div><scroll-paging hide-back-to-top=true spinner=vm.parent.spinner show-message=\"vm.parent.peoples.length > 0\" message=\"No more records\" is-last-page=vm.parent.isLastPage></scroll-paging><div class=\"peoples-page__peoples-list__empty-state clearfix\" ng-if=vm.parent.isEmptyState><h4 class=\"text--semibold text--color-black\" ng-bind-html=vm.parent.emptyMessage></h4><div ng-switch=vm.parent.isMine><div ng-switch-when=true>Check out other great <a class=\"pixerf-link pixerf-link--color-theme\" ui-sref=marketplace.photographers.featuredPhotographer>Pixerfer!</a> or browse the<a class=\"pixerf-link pixerf-link--color-theme\" ui-sref=buy-stock-page.trending> Market Place</a> and<br>click on photographers\' name to view their profile.<br>Love their work? Then follow them!</div><div ng-switch-when=false><div>Follow {{vm.parent.user.displayName}}</div><follow-btn user=vm.parent.user login-user=vm.parent.loginUser></follow-btn></div></div></div><div class=\"peoples-page__peoples-list__empty-state clearfix\" ng-if=\"!vm.parent.isEmptyState && vm.parent.peoples.length === 0 && vm.parent.searchString\"><h4 class=\"text--semibold text--color-black\">No records found for \'{{vm.parent.searchString}}\'</h4></div></div></div>");
$templateCache.put("app/portfolio-detail-page/portfolio-detail-page-photos/portfolio-detail-page-photos.html","<div class=portfolio-detail-page-photos__wrapper><h1 class=\"portfolio-detail-page-photos__title text--bold text--color-black\">{{vm.portfolioGallery.data.title | toTitleCase}}</h1><div class=\"portfolio-detail-page-photos__breadscrum clearfix\"><a class=\"portfolio-detail-page-photos__breadscrum__root text--bold text--color-black\" ui-sref=user-home-page.personal.portfolio.carousel>{{vm.breadcrumbRoot}}</a> <span class=portfolio-detail-page-photos__breadscrum__divide>> </span><a class=\"portfolio-detail-page-photos__breadscrum__sub-level text--bold text--color-black\" ui-sref=\"user-home-page.personal.portfolio.grid({portfolioId: vm.portfolioId})\">{{vm.breadcrumbSublevel | toTitleCase}}</a><div ng-if=vm.isMine class=\"portfolio-detail-page-photos__owner-controls clearfix\"><div ng-click=vm.onUploadPortfolioPhoto(vm.portfolioId) class=\"portfolio-detail-page-photos__upload-photos text--bold text--color-pixerf-theme\"><span class=icon-icons_plus></span> {{\'upload-photos\' | translate}}</div><div ng-click=vm.showEditPortfolioGalleryPopup(vm.portfolioType) class=\"portfolio-detail-page-photos__edit-btn text--color-pixerf-theme text--bold\"><span class=icon-icons_edit></span> {{\'edit\' | translate}}</div></div></div><portfolio-list-slider ng-if=!vm.isRefeshing min-show-list=2 portfolio=vm.portfolio instance=vm.portfolioGrid owner=vm.user hide-name=true hide-upload=true on-portfolio-clicked=vm.onPortfolioClicked(portfolio) is-small-size=true></portfolio-list-slider><div ng-if=!vm.portfolioGallery.data.media_count class=\"text-center portfolio-detail-page-photos__empty-text\"><div class=\"portfolio-detail-page-photos__empty-text__icon icon-icons-gallery\"></div><h4 class=\"portfolio-detail-page-photos__empty-text__header text--semibold\" ng-if=vm.isMine translate>{{\'get-sorted-now\'}}</h4><div class=portfolio-detail-page-photos__empty-text__description ng-if=vm.isMine>{{\'showcase-your-work-to-brands\' | translate}}</div><div class=\"portfolio-detail-page-photos__empty-text__header text--semibold\" ng-if=!vm.isMine>{{vm.user.displayName}} hasn\'t any photos in this gallery yet.</div><button class=\"portfolio-detail-page-photos__empty-text__upload-photos-btn clearfix btn text--bold btn-pixerf-theme\" ng-if=vm.isMine ng-click=vm.onUploadPortfolioPhoto(vm.portfolioId)>{{\'upload-photos\' | translate}}</button></div><portfolio-photo-grid instance=vm.portfolioPhotoGrid on-portfolio-photo-removed=vm.onPortfolioPhotoRemoved(file) portfolio-gallery=vm.portfolioGallery.data></portfolio-photo-grid></div>");
$templateCache.put("app/about-business-page/components/case-studies/case-studies.html","<div class=case-studies-page><section ui-view class=case-studies-page__main-content></section></div>");
$templateCache.put("app/about-business-page/components/about-business/about-business.html","<div class=about-business><div class=about-business__banner photo-details-on-click=22114><div class=about-business__banner__background></div><div class=about-business__banner__content><banner-box-intro data=vm.bannerBox is-transcluded=true><button class=about-business__banner__content__submit-btn ng-click=vm.onSignUpBiz()>{{vm.bannerBtnText}}</button></banner-box-intro></div></div><section class=\"about-business__section about-business__section__business\"><div class=about-business__section__business__title>Why Businesses Choose PIXERF.</div><info-col-intro context=about-business></info-col-intro><div class=about-business__section__business__footer>Have a specific request? <a class=highlight-text ng-click=vm.onContactUsBtnClicked()>Contact us</a>. Or <a class=highlight-text ng-click=vm.onRequestADemoBtnClicked()>request a demo</a>.</div></section><section class=\"about-business__section about-business__section__get-connected\"><div class=about-business__section__get-connected__col-left><img src=assets/images/about-business/get-connected.jpg photo-details-on-click=15208></div><div class=about-business__section__get-connected__col-right><div class=about-business__section__get-connected__col-right__title>Get connected with PIXERF\'s creators in Asia at Community Hub.</div><div class=about-business__section__get-connected__col-right__content><div>From influencers to commercial professionals. From budding enthusiasts to drone specialists. We will connect you with the best talents for your next project.</div><div>If you\'re looking for content collaborations or partnerships, you\'ve come to the right place.</div></div><button ng-click=vm.onEmailUs() class=about-business__section__get-connected__col-right__btn>Contact us</button></div></section><section class=\"about-business__section about-business__section__col-box\" id=priceSection><div class=about-business__section__col-box__title>Get a business account for free for a whole year!</div><div class=about-business__section__col-box__grid><div ng-repeat=\"data in vm.colBoxData\" class=about-business__section__col-box__item><col-box-icon-text data=data></col-box-icon-text></div></div><div class=about-business__section__col-box__hint><div class=about-business__section__col-box__hint__text>You\'ll get to enjoy all these for $0 for the first year.</div><button ng-if=!vm.isLoggedInBusiness class=about-business__section__col-box__create-business-btn sign-up-directly=business>Create a free business account</button></div></section><general-contact-form id=generalContactFormSection context=about-business></general-contact-form></div>");
$templateCache.put("app/about-business-page/components/pricing/pricing.html","<div class=pricing scroll-spy=\"{offset:200, duration:200}\" scroll-spy-id=pricingPageScroll><div class=pricing__col-left dynamic-show-hide-scroll scroll-down-class=hide-on-mobile><button type=button class=\"pricing__top-navigation__button navbar-toggle collapsed\" data-toggle=collapse data-target=#subPricingNav aria-expanded=false><div class=pricing__top-navigation__current-state ng-class=\"{\'red-theme\': vm.isRedContext, \'lightblue-theme\': vm.isLightblueContext, \'darkblue-theme\': vm.isDarkblueContext}\">{{vm.subContextPage}}</div><div class=\"pricing__top-navigation__icon arrow-animation-menu-collapse\"><span class=\"icon-bar dash-one\"></span> <span class=\"icon-bar dash-two\"></span></div></button><div id=subPricingNav class=\"pricing__col-left__list navbar-collapse collapse\" scroll-to-fixed=vm.subPricingNavOptions navbar-collapse-on-click=true><div class=\"pricing__col-left__item section-1\"><a href=#section-1 ng-click=\"vm.onGoToSection(\'#section-1\')\">Book Your Shoot Now</a></div><div class=\"pricing__col-left__item section-2\"><a href=#section-2 ng-click=\"vm.onGoToSection(\'#section-2\')\">Buy Photo Challenge Plans</a></div><div class=\"pricing__col-left__item section-3\"><a href=#section-3 ng-click=\"vm.onGoToSection(\'#section-3\')\">Buy Stock Image Credit Plans</a></div></div></div><div class=pricing__col-right><div class=pricing__col-right__content><div id=section-1 class=pricing__col-right__content__section-1><div class=\"pricing__col-right__content__section-1__header pricing__col-right__content__section-1__header__pc\">Get the best price and hire a pro for your next assignment, photography or videography.</div><div class=\"pricing__col-right__content__section-1__header pricing__col-right__content__section-1__header__mobile\">Get the best price and hire a pro for your next assignment, photo-graphy or videography.</div><button ng-click=vm.onBookAShoot() class=\"pricing__col-right__content__section-1__box__btn btn\">Book a Shoot Now</button><div class=pricing__col-right__content__section-1__footer><div class=pricing__col-right__content__section-1__footer__hint>If you are a business with frequent shoot requirements, enjoy more value and dedicated support.</div><button ng-click=vm.onFindOutHow() class=\"pricing__col-right__content__section-1__footer__button btn\">Find out how</button></div></div><div id=section-2 class=pricing__col-right__content__section-2><div class=pricing__col-right__content__section-2__header>Launch a Photo Challenge and get exclusive images for less.</div><div class=pricing__col-right__content__section-2__description>Join brands like <span class=text--bold>Grab</span> and <span class=text--bold>Asian Geographic</span> and use challenges to get exclusive images direct from our community in Asia.</div><div class=pricing__col-right__content__section-2__plan><challenge-plan on-button-clicked=vm.onChallengePlanClicked() on-get-in-touch-clicked=vm.onGetInTrouch() on-recommended-clicked=\"vm.onGoToSection(\'#offerSection\')\"></challenge-plan><div class=pricing__col-right__content__section-2__note><div class=pricing__col-right__content__section-2__note__first>Prices are in Singapore dollars.</div><div class=pricing__col-right__content__section-2__note__second>Plans are not inclusive of prizes to be sponsored by customers.</div></div><div id=offerSection class=pricing__col-right__content__section-2__footer><div class=pricing__col-right__content__section-2__footer__left>OFFER</div><div class=pricing__col-right__content__section-2__footer__box><div class=pricing__col-right__content__section-2__footer__box__content><div class=pricing__col-right__content__section-2__footer__box__content__title>Sign up for Platinum Challenge and get 50% OFF!</div><div class=\"pricing__col-right__content__section-2__footer__box__btn btn\" ng-click=vm.onLaunchChallenge()>Book Now</div></div><div class=pricing__col-right__content__section-2__footer__box__content__description>Book a <strong class=text--bold>Platinum Challenge</strong> and get the next one free.</div><div class=pricing__col-right__content__section-2__footer__box__content__next-promotion>Promotion ends 31 Mar 2022.</div></div></div></div></div><div id=section-3 class=pricing__col-right__content__section-3><credit-plans id=creditPlansSection on-get-in-touch-clicked=vm.onRequeestCustomPlan()></credit-plans></div></div></div></div>");
$templateCache.put("app/buy-stock-page/components/about-stock/about-stock.html","<div class=about-stock><div class=about-stock__banner photo-details-on-click=82142><div class=about-stock__banner__background></div><div class=about-stock__banner__marketing-plan>Pay less and download more. Enjoy up to 30% less on credit plans.</div><div class=about-stock__banner__content><banner-box-intro data=vm.bannerBox on-btn-clicked=vm.buyCreditPlan()></banner-box-intro></div></div><section class=\"about-stock__section about-stock__section__category\"><div class=about-stock__section__category__title>Whatever you\'re looking for, we have it.</div><div class=about-stock__section__category__sub-title>Fresh, ready-to-license visual content in every category.</div><div class=about-stock__section__category__grid-wrapper><div ng-repeat=\"category in vm.categories\" ng-click=vm.bookShoot() class=about-stock__section__category__item-wrapper ui-sref=\"signature-galleries-details-page({id: category.id, title: category.name, fromExplore: \'explore\'})\"><div class=about-stock__section__category__item><div class=\"about-stock__section__category__item__background zoom-hover\" ng-style=\"{\'background-image\': \'url(\\\'\' + category.thumbnails + \'\\\')\'}\"><div class=about-stock__section__category__overlay></div></div><div class=about-stock__section__category__item__inner-content><div class=about-stock__section__category__item__name>{{category.name}}</div><button class=about-stock__section__category__item__book-btn>View Gallery</button></div></div></div></div><div class=about-stock__section__category__hint><div class=about-stock__section__category__hint__text>If you\'re looking for help to source tailor-made images.</div><button class=about-stock__section__category__check-out-btn ng-click=vm.bookADemo()>Reach out to our team</button></div></section><section class=\"about-stock__section about-stock__section__fresh\" photo-details-on-click=168965><div class=about-stock__section__fresh__content><div class=about-stock__section__fresh__content__title>Fresh, authentic, original images. Now up to 30% off.</div><button class=about-stock__section__fresh__content__btn ng-click=vm.moveTocreditPlansSection()>Buy a Credit Plan</button></div></section><section class=\"about-stock__section about-stock__section__credit-plan\"><credit-plans id=creditPlansSection on-get-in-touch-clicked=vm.goToHomepageContact()></credit-plans></section><section class=\"about-stock__section about-stock__section__footer\" photo-details-on-click=205730><div class=about-stock__section__footer__content><div class=about-stock__section__footer__content__box><div class=about-stock__section__footer__content__box__title>Still looking for the right image?</div><div class=about-stock__section__footer__content__box__description>Get custom content shot for your brand or next campaign in Asia.</div><button class=about-stock__section__footer__content__submit-btn ng-click=vm.bookAShoot()>Book a Shoot</button></div></div></section></div>");
$templateCache.put("app/buy-stock-page/components/discover-photo/discover-photo.html","<div class=discover-photo><div id=pagingBar class=discover-photo__header scroll-to-fixed=vm.pagingBarSetting dynamic-show-hide-scroll scroll-down-class=paging-on-mobile><div class=discover-photo__header__browse-images>Discover</div><div class=discover-photo__header__photo-grid-pager><photo-grid-pager unit={{vm.pagerUnit}} total-page=vm.totalPage page=vm.page on-current-page-changed=vm.onCurrentPageChanged(pageNumber) is-shown-num-photos=\"vm.selectedCategories.length > 0\" total-photo-text={{vm.pagerText}}></photo-grid-pager></div></div><div class=discover-photo__photo-grid><div class=photos-grid-wrapper><photo-grid on-load-more-page=vm.onLoadMorePage(page) ng-attr-shuffle={{vm.shuffle}} on-scroll-to-photo=vm.onScrollToPhoto(page) context=\"\'MARKET_PLACE\'\" instance=vm.photoGrid><div class=\"text-center marketplace__no-result-message\"><span class=icon-icons_search></span><h3 class=\"text-semibold no-message-notice text--semibold text--color-black\" translate>{{\'no-photos-found\'}}</h3></div></photo-grid></div></div></div>");
$templateCache.put("app/buy-stock-page/components/editor-pick/editor-pick.html","<div class=editor-pick><div id=pagingBar class=editor-pick__header scroll-to-fixed=vm.pagingBarSetting dynamic-show-hide-scroll scroll-down-class=paging-on-mobile><div class=editor-pick__header__browse-images>Editor\'s Pick</div><div class=editor-pick__header__photo-grid-pager><photo-grid-pager unit={{vm.pagerUnit}} total-page=vm.totalPage page=vm.page on-current-page-changed=vm.onCurrentPageChanged(pageNumber) is-shown-num-photos=\"vm.selectedCategories.length > 0\" total-photo-text={{vm.pagerText}}></photo-grid-pager></div></div><div class=editor-pick__photo-grid><div class=photos-grid-wrapper><photo-grid on-load-more-page=vm.onLoadMorePage(page) ng-attr-shuffle={{vm.shuffle}} on-scroll-to-photo=vm.onScrollToPhoto(page) context=\"\'MARKET_PLACE\'\" instance=vm.photoGrid><div class=\"text-center marketplace__no-result-message\"><span class=icon-icons_search></span><h3 class=\"text-semibold no-message-notice text--semibold text--color-black\" translate>{{\'no-photos-found\'}}</h3></div></photo-grid></div></div></div>");
$templateCache.put("app/buy-stock-page/components/general-photos/general-photos.html","<div class=general-photos><div id=pagingBar class=general-photos__header scroll-to-fixed=vm.pagingBarSetting dynamic-show-hide-scroll scroll-down-class=paging-on-mobile><div class=general-photos__header__browse-images>General</div><div class=general-photos__header__photo-grid-pager><photo-grid-pager unit={{vm.pagerUnit}} total-page=vm.totalPage page=vm.page on-current-page-changed=vm.onCurrentPageChanged(pageNumber) is-shown-num-photos=\"vm.selectedCategories.length > 0\" total-photo-text={{vm.pagerText}}></photo-grid-pager></div></div><div class=general-photos__photo-grid><div class=photos-grid-wrapper><photo-grid on-load-more-page=vm.onLoadMorePage(page) ng-attr-shuffle={{vm.shuffle}} on-scroll-to-photo=vm.onScrollToPhoto(page) context=\"\'MARKET_PLACE\'\" instance=vm.photoGrid><div class=\"text-center marketplace__no-result-message\"><span class=icon-icons_search></span><h3 class=\"text-semibold no-message-notice text--semibold text--color-black\" translate>{{\'no-photos-found\'}}</h3></div></photo-grid></div></div></div>");
$templateCache.put("app/buy-stock-page/components/pending-commercial-license/pending-commercial-license.html","<div class=pending-commercial-license><div id=pagingBar class=pending-commercial-license__header scroll-to-fixed=vm.pagingBarSetting dynamic-show-hide-scroll scroll-down-class=paging-on-mobile><div class=pending-commercial-license__header__browse-images>Pending Commercial License</div><div class=pending-commercial-license__header__photo-grid-pager><photo-grid-pager unit={{vm.pagerUnit}} total-page=vm.totalPage page=vm.page on-current-page-changed=vm.onCurrentPageChanged(pageNumber) is-shown-num-photos=\"vm.selectedCategories.length > 0\" total-photo-text={{vm.pagerText}}></photo-grid-pager></div></div><div class=pending-commercial-license__photo-grid><div class=photos-grid-wrapper><photo-grid on-load-more-page=vm.onLoadMorePage(page) ng-attr-shuffle={{vm.shuffle}} on-scroll-to-photo=vm.onScrollToPhoto(page) context=\"\'MARKET_PLACE\'\" instance=vm.photoGrid is-pending-commercial-custom=true><div class=\"text-center marketplace__no-result-message\"><span class=icon-icons_search></span><h3 class=\"text-semibold no-message-notice text--semibold text--color-black\" translate>{{\'no-photos-found\'}}</h3></div></photo-grid></div></div></div>");
$templateCache.put("app/buy-stock-page/components/pending-photos/pending-photos.html","<div class=pending-photos><div id=pagingBar class=pending-photos__header scroll-to-fixed=vm.pagingBarSetting dynamic-show-hide-scroll scroll-down-class=paging-on-mobile><div class=pending-photos__header__browse-images>Pending Photos</div><div class=pending-photos__header__photo-grid-pager><div class=bulk-edit-photo ng-if=vm.canBulkEditPhoto><button type=button class=bulk-edit-photo__select-photo-btn ng-click=vm.selectPhotoBtnClicked(true) ng-if=!vm.isSelectedPhotos>Select Photo</button> <button type=button class=bulk-edit-photo__edit-btn ng-click=vm.bulkEditPhoto() ng-if=\"vm.isSelectedPhotos && vm.bulkSelectedPhoto.length\">Edit Photo ({{vm.bulkSelectedPhoto.length}})</button> <button type=button class=bulk-edit-photo__cancel-btn ng-click=vm.selectPhotoBtnClicked(false) ng-if=vm.isSelectedPhotos>Cancel</button></div><photo-grid-pager unit={{vm.pagerUnit}} total-page=vm.totalPage page=vm.page on-current-page-changed=vm.onCurrentPageChanged(pageNumber) is-shown-num-photos=\"vm.selectedCategories.length > 0\" total-photo-text={{vm.pagerText}}></photo-grid-pager></div></div><div class=pending-photos__photo-grid><div class=photos-grid-wrapper><photo-grid on-load-more-page=vm.onLoadMorePage(page) ng-attr-shuffle={{vm.shuffle}} on-scroll-to-photo=vm.onScrollToPhoto(page) context=\"\'MARKET_PLACE\'\" instance=vm.photoGrid options=vm.options><div class=\"text-center marketplace__no-result-message\"><span class=icon-icons_search></span><h3 class=\"text-semibold no-message-notice text--semibold text--color-black\" translate>{{\'no-photos-found\'}}</h3></div></photo-grid></div></div></div>");
$templateCache.put("app/buy-stock-page/components/pending-portfolio/pending-portfolio.html","<div class=pending-portfolio><div id=pagingBar class=pending-portfolio__header scroll-to-fixed=vm.pagingBarSetting dynamic-show-hide-scroll scroll-down-class=paging-on-mobile><div class=pending-portfolio__header__browse-images>Pending Portfolio</div><div class=pending-portfolio__header__photo-grid-pager><photo-grid-pager unit={{vm.pagerUnit}} total-page=vm.totalPage page=vm.page on-current-page-changed=vm.onCurrentPageChanged(pageNumber) is-shown-num-photos=\"vm.selectedCategories.length > 0\" total-photo-text={{vm.pagerText}}></photo-grid-pager></div></div><div class=pending-portfolio__photo-grid><div class=photos-grid-wrapper><photo-grid on-load-more-page=vm.onLoadMorePage(page) ng-attr-shuffle={{vm.shuffle}} on-scroll-to-photo=vm.onScrollToPhoto(page) context=\"\'MARKET_PLACE\'\" instance=vm.photoGrid><div class=\"text-center marketplace__no-result-message\"><span class=icon-icons_search></span><h3 class=\"text-semibold no-message-notice text--semibold text--color-black\" translate>{{\'no-photos-found\'}}</h3></div></photo-grid></div></div></div>");
$templateCache.put("app/buy-stock-page/components/rejected-photos/rejected-photos.html","<div class=rejected-photos><div id=pagingBar class=rejected-photos__header scroll-to-fixed=vm.pagingBarSetting dynamic-show-hide-scroll scroll-down-class=paging-on-mobile><div class=rejected-photos__header__browse-images>Rejected</div><div class=rejected-photos__header__photo-grid-pager><photo-grid-pager unit={{vm.pagerUnit}} total-page=vm.totalPage page=vm.page on-current-page-changed=vm.onCurrentPageChanged(pageNumber) is-shown-num-photos=\"vm.selectedCategories.length > 0\" total-photo-text={{vm.pagerText}}></photo-grid-pager></div></div><div class=rejected-photos__photo-grid><div class=photos-grid-wrapper><photo-grid on-load-more-page=vm.onLoadMorePage(page) ng-attr-shuffle={{vm.shuffle}} on-scroll-to-photo=vm.onScrollToPhoto(page) context=\"\'MARKET_PLACE\'\" instance=vm.photoGrid><div class=\"text-center marketplace__no-result-message\"><span class=icon-icons_search></span><h3 class=\"text-semibold no-message-notice text--semibold text--color-black\" translate>{{\'no-photos-found\'}}</h3></div></photo-grid></div></div></div>");
$templateCache.put("app/buy-stock-page/components/search-result-page/search-result-page.html","<div class=stock-search-result-page><div id=pagingBar class=stock-search-result-page__header scroll-to-fixed=vm.pagingBarSetting dynamic-show-hide-scroll scroll-down-class=paging-on-mobile><div class=stock-search-result-page__header__browse-images>{{\'browse-images\' | translate}}</div><div class=stock-search-result-page__header__photo-grid-pager><photo-grid-pager total-photos=vm.photoGrid.totalPhotos total-page=vm.photoGrid.totalPage page=vm.page on-current-page-changed=vm.onCurrentPageChanged(pageNumber) is-shown-num-photos=true></photo-grid-pager><!-- <div class=\"stock-search-result-page__header__filter\"> --><div class=pixerf-filter-bar__control-filter><li class=\"pixerf-filter-bar__menu-item pixerf-filter-bar__menu-item__filter-by-btn\" ng-class=\"{\'pixerf-filter-bar__menu-item--active\': vm.selectedCategories.length > 0, \'show-filter\': vm.isShowAllFilters}\"><stick-checkbox model=vm model-property=isShowAllFilters on-changed=vm.onFilterCheckboxClicked() label=filter-by layout-style=solid-square></stick-checkbox></li></div><div ng-if=vm.isShowAllFilters class=pixerf-filter-bar__filter-dropdown-wrapper><li class=pixerf-filter-bar__menu-item ng-class=\"{\'pixerf-filter-bar__menu-item--active\': !vm.selectedOrientation.isDefault}\"><popover-selection-btn class=btn-first-filter popover-class=\"\'buy-stock__search-result-page\'\" close-on-click=true on-selection-changed=vm.onSearchConditionClicked() selected-model=vm.selectedOrientation settings=\'{\"items\" : [\"Any Orientation\", \"Landscape\", \"Portrait\", \"Square\"]}\'></popover-selection-btn></li><li class=pixerf-filter-bar__menu-item ng-class=\"{\'pixerf-filter-bar__menu-item--active\': !vm.selectedUsage.isDefault}\"><popover-selection-btn close-on-click=true popover-class=\"\'buy-stock__search-result-page\'\" on-selection-changed=vm.onSearchConditionClicked() selected-model=vm.selectedUsage settings=\'{\"items\" : [\"Any Usage\", \"Commercial\", \"Editorial\"]}\'></popover-selection-btn></li><li class=pixerf-filter-bar__menu-item ng-class=\"{\'pixerf-filter-bar__menu-item--active\': !vm.selectedSize.isDefault}\"><popover-selection-btn class=btn-last-filter popover-class=\"\'buy-stock__search-result-page\'\" close-on-click=true on-selection-changed=vm.onSearchConditionClicked() selected-model=vm.selectedSize settings=\'{\"items\" : [\"Any Size\", \"Small\", \"Medium\", \"Large\", \"X-Large\", \"XX-Large\"]}\'></popover-selection-btn></li></div><!-- </div> --></div></div><div class=stock-search-result-page__photo-grid><div class=photos-grid-wrapper><photo-grid on-load-more-page=vm.onLoadMorePage(page) ng-attr-shuffle={{vm.shuffle}} on-scroll-to-photo=vm.onScrollToPhoto(page) context=\"\'MARKET_PLACE\'\" instance=vm.photoGrid><div class=\"text-center marketplace__no-result-message\"><span class=icon-icons_search></span><h3 class=\"text-semibold no-message-notice text--semibold text--color-black\" translate>{{\'no-photos-found\'}}</h3></div></photo-grid></div></div></div>");
$templateCache.put("app/buy-stock-page/components/stock-galleries/stock-galleries.html","<section class=stock-galleries><div class=stock-galleries__sub-navigation dynamic-show-hide-scroll scroll-down-class=hide-on-mobile><button type=button class=\"stock-galleries__sub-navigation__button navbar-toggle collapsed\" data-toggle=collapse data-target=#subGalleriesNav aria-expanded=false><div class=stock-galleries__sub-navigation__current-state>{{vm.subContextPage}}</div><div class=\"stock-galleries__sub-navigation__icon arrow-animation-menu-collapse\"><span class=\"icon-bar dash-one\"></span> <span class=\"icon-bar dash-two\"></span></div></button><div id=subGalleriesNav class=\"stock-galleries__sub-navigation__list navbar-collapse collapse\" navbar-collapse-on-click=true><div ng-repeat=\"item in vm.galleriesType\" class=stock-galleries__sub-navigation__item ng-class=\"{\'active\': vm.defaultGalleriesType === item.value}\" ng-click=vm.onGalleriesTypeChanged(item)>{{item.title}}</div></div></div><div ng-if=vm.showCreditPlanBar class=\"stock-galleries__top-bar collapsed\" data-toggle=collapse data-target=#credit-plan-collapse><div>Pay less and download more. Enjoy up to 30% less on credit plans.</div><div class=icon-doubledropdown></div></div><div id=credit-plan-collapse class=\"stock-galleries__content-toggle collapse\" event-key on-key-pressed=vm.logKey><div class=credit-plans__header><button type=button class=\"close credit-plans__close-btn\" ng-click=vm.closeCreditPlanPopup()><span class=\"icon-icons_close text--color-white\" aria-hidden=true></span></button></div><credit-plans on-plan-selected=vm.onPlanSelected(plan) context=popup></credit-plans><div class=credit-plan-page__hint-text><div>{{\'credits-text\' | translate}}</div></div></div><div class=stock-galleries__header ng-class=\"{\'have-credit-plan-top-bar\': vm.showCreditPlanBar}\"><div class=stock-galleries__header__wrapper><div class=stock-galleries__header__title ng-bind-html=vm.header></div><div ng-if=vm.description class=stock-galleries__header__description ng-bind-html=vm.description></div></div><div class=stock-galleries__header__control><mutiline-dropdown items=vm.galleriesType selected=vm.defaultGalleriesType on-changed=vm.onGalleriesTypeChanged(data) hide-check-icon=true></mutiline-dropdown></div></div><div ui-view></div></section>");
$templateCache.put("app/buy-stock-page/components/temporary-photos/temporary-photos.html","<div class=temporary-photos><div id=pagingBar class=temporary-photos__header scroll-to-fixed=vm.pagingBarSetting dynamic-show-hide-scroll scroll-down-class=paging-on-mobile><div class=temporary-photos__header__browse-images>Temporary</div><div class=temporary-photos__header__photo-grid-pager><photo-grid-pager unit={{vm.pagerUnit}} total-page=vm.totalPage page=vm.page on-current-page-changed=vm.onCurrentPageChanged(pageNumber) is-shown-num-photos=\"vm.selectedCategories.length > 0\" total-photo-text={{vm.pagerText}}></photo-grid-pager></div></div><div class=temporary-photos__photo-grid><div class=photos-grid-wrapper><photo-grid on-load-more-page=vm.onLoadMorePage(page) ng-attr-shuffle={{vm.shuffle}} on-scroll-to-photo=vm.onScrollToPhoto(page) context=\"\'MARKET_PLACE\'\" instance=vm.photoGrid><div class=\"text-center marketplace__no-result-message\"><span class=icon-icons_search></span><h3 class=\"text-semibold no-message-notice text--semibold text--color-black\" translate>{{\'no-photos-found\'}}</h3></div></photo-grid></div></div></div>");
$templateCache.put("app/buy-stock-page/components/trending-photo/trending-photo.html","<div class=trending-photo><div id=pagingBar class=trending-photo__header scroll-to-fixed=vm.pagingBarSetting dynamic-show-hide-scroll scroll-down-class=paging-on-mobile><div class=trending-photo__header__browse-images>Trending</div><div class=trending-photo__header__photo-grid-pager><div class=bulk-edit-photo ng-if=vm.canBulkEditPhoto><button type=button class=bulk-edit-photo__select-photo-btn ng-click=vm.selectPhotoBtnClicked(true) ng-if=!vm.isSelectedPhotos>Select Photo</button> <button type=button class=bulk-edit-photo__edit-btn ng-click=vm.bulkEditPhoto() ng-if=\"vm.isSelectedPhotos && vm.bulkSelectedPhoto.length\">Edit Photo ({{vm.bulkSelectedPhoto.length}})</button> <button type=button class=bulk-edit-photo__cancel-btn ng-click=vm.selectPhotoBtnClicked(false) ng-if=vm.isSelectedPhotos>Cancel</button></div><photo-grid-pager unit={{vm.pagerUnit}} total-page=vm.totalPage page=vm.page on-current-page-changed=vm.onCurrentPageChanged(pageNumber) is-shown-num-photos=\"vm.selectedCategories.length > 0\" total-photo-text={{vm.pagerText}}></photo-grid-pager></div></div><div class=trending-photo__photo-grid><div class=photos-grid-wrapper><photo-grid on-load-more-page=vm.onLoadMorePage(page) ng-attr-shuffle={{vm.shuffle}} on-scroll-to-photo=vm.onScrollToPhoto(page) context=\"\'MARKET_PLACE\'\" instance=vm.photoGrid options=vm.options><div class=\"text-center marketplace__no-result-message\"><span class=icon-icons_search></span><h3 class=\"text-semibold no-message-notice text--semibold text--color-black\" translate>{{\'no-photos-found\'}}</h3></div></photo-grid></div></div></div>");
$templateCache.put("app/book-a-shoot-page/components/about-custom-content/about-custom-content.html","<div class=about-custom-content><div class=about-custom-content__banner><div class=about-custom-content__banner__background></div><div class=about-custom-content__banner__content><banner-box-intro data=vm.bannerBox on-btn-clicked=vm.bookShoot()></banner-box-intro></div></div><section class=\"about-custom-content__section about-custom-content__section__brands\"><div class=about-custom-content__section__brands__title>The visual content creation service trusted by these brands and more.</div><div class=about-custom-content__section__brands__list><div ng-repeat=\"brand in vm.brands\" class=about-custom-content__section__brands__item><div ng-style=\"{\'background-image\': \'url(\\\'\' + brand.photo + \'\\\')\'}\" class=\"about-custom-content__section__brands__item__photo desktop-item-photo-{{$index}}\"></div></div></div><div class=about-custom-content__section__brands__mobile><div class=about-custom-content__section__brands__carousel__wrapper><slick speed=1000 class=about-custom-content__section__brands__carousel infinite=false slides-to-scroll=3 slides-to-show=3 dots=true arrows=true append-arrows=\".home__section about-custom-content__section__brands__arrow__wrapper\" on-init=vm.slickSetting.onInit(slick) on-after-change=\"vm.slickSetting.onAfterChange(event, slick, currentSlide, nextSlide)\"><div class=\"about-custom-content__section__brands__item item-0\"><img ng-src={{vm.brands[0].photoMobile}} alt=\"\" class=\"about-custom-content__section__brands__item__photo row-1\"> <img ng-src={{vm.brands[5].photoMobile}} alt=\"\" class=\"about-custom-content__section__brands__item__photo row-2\"></div><div class=\"about-custom-content__section__brands__item item-1\"><img ng-src={{vm.brands[1].photoMobile}} alt=\"\" class=\"about-custom-content__section__brands__item__photo row-1\"> <img ng-src={{vm.brands[6].photoMobile}} alt=\"\" class=\"about-custom-content__section__brands__item__photo row-2\"></div><div class=\"about-custom-content__section__brands__item item-2\"><img ng-src={{vm.brands[2].photoMobile}} alt=\"\" class=\"about-custom-content__section__brands__item__photo row-1\"> <img ng-src={{vm.brands[7].photoMobile}} alt=\"\" class=\"about-custom-content__section__brands__item__photo row-2\"></div><div class=\"about-custom-content__section__brands__item item-3\"><img ng-src={{vm.brands[3].photoMobile}} alt=\"\" class=\"about-custom-content__section__brands__item__photo row-1\"> <img ng-src={{vm.brands[8].photoMobile}} alt=\"\" class=\"about-custom-content__section__brands__item__photo row-2\"></div><div class=\"about-custom-content__section__brands__item item-4\"><img ng-src={{vm.brands[4].photoMobile}} alt=\"\" class=\"about-custom-content__section__brands__item__photo row-1\"> <img ng-src={{vm.brands[9].photoMobile}} alt=\"\" class=\"about-custom-content__section__brands__item__photo row-2\"></div></slick><div class=about-custom-content__section__brands__arrow__wrapper><div ng-click=vm.navigateRight() class=\"about-custom-content__section__brands__arrow__icon icon-slide-prev-icon\" ng-class=\"{\'disabled\': vm.slick.currentSlide == 0}\"></div><div ng-click=vm.navigateNext() class=\"about-custom-content__section__brands__arrow__icon icon-slide-next-icon\" ng-class=\"{\'disabled\': vm.isLastBrandsSlide}\"></div></div></div></div></section><section class=\"about-custom-content__section about-custom-content__section__specialist\"><div class=about-custom-content__section__specialist__title>Find the best specialist to shoot for your next project in any major city in Asia.</div><div class=about-custom-content__grid-wrapper><div ng-repeat=\"category in vm.categories\" ng-click=vm.bookShoot(category.name) class=about-custom-content__item-wrapper><div class=\"about-custom-content__item item-{{$index}}\"><div class=\"about-custom-content__item__background zoom-hover\" ng-style=\"{\'background-image\': \'url(\\\'\' + category.thumbnails + \'\\\')\'}\"><div class=about-custom-content__overlay></div></div><div class=about-custom-content__item__inner-content><div class=about-custom-content__item__name>{{category.name}}</div><button class=about-custom-content__item__book-btn>Book Now</button></div></div></div></div><!-- <div class=\"about-custom-content__section__specialist__note\">If you have regular or multiple shoot requests, <a\r\n				ng-click=\"vm.runChallenge()\" class=\"text--bold text--color-blue-theme\">contact us</a> for help!</div> --><div class=\"about-custom-content__section about-custom-content__section__specialist__control\"><button class=\"about-custom-content__section about-custom-content__section__specialist__control__case-studies-btn\" ng-click=vm.runChallenge()>Multiple shoot requests</button> <button class=\"about-custom-content__section about-custom-content__section__specialist__control__shoot-btn\" ng-click=vm.onEmailUs()>Can’t find what I\'m looking for</button></div></section><section class=\"about-custom-content__section about-custom-content__section__col-info\"><div class=about-custom-content__section__col-info__title>Creating perfect images for your brand in 4 simple steps.</div><info-col-intro context=creating-perfect-images></info-col-intro><div class=\"about-custom-content__section about-custom-content__section__col-info__control\"><button class=\"about-custom-content__section about-custom-content__section__col-info__control__case-studies-btn\" ng-click=vm.viewCaseStudies()>View case studies</button> <button class=\"about-custom-content__section about-custom-content__section__col-info__control__shoot-btn\" ng-click=vm.bookShoot()>Book a Shoot</button></div></section><section class=\"about-custom-content__section about-custom-content__section__statistical\"><div class=about-custom-content__section__statistical__box><div class=about-custom-content__section__statistical__box__col><div class=\"about-custom-content__section__statistical__box__photo photo-creator\"></div><div class=about-custom-content__section__statistical__box__info><div class=about-custom-content__section__statistical__box__info__label>OVER</div><div class=about-custom-content__section__statistical__box__info__highlight>70k</div><div class=about-custom-content__section__statistical__box__info__unit>CREATORS</div></div></div><div class=about-custom-content__section__statistical__box__col><div class=\"about-custom-content__section__statistical__box__photo photo-country\"></div><div class=about-custom-content__section__statistical__box__info><div class=about-custom-content__section__statistical__box__info__label>OVER</div><div class=about-custom-content__section__statistical__box__info__highlight>60</div><div class=about-custom-content__section__statistical__box__info__unit>COUNTRIES</div></div></div><div class=about-custom-content__section__statistical__box__col><div class=\"about-custom-content__section__statistical__box__photo photo-photo\"></div><div class=about-custom-content__section__statistical__box__info><div class=about-custom-content__section__statistical__box__info__label>OVER</div><div class=about-custom-content__section__statistical__box__info__highlight>100k</div><div class=about-custom-content__section__statistical__box__info__unit>PHOTOS TAKEN</div></div></div><div class=about-custom-content__section__statistical__box__col><div class=\"about-custom-content__section__statistical__box__photo photo-video\"></div><div class=about-custom-content__section__statistical__box__info><div class=about-custom-content__section__statistical__box__info__intro-highlight>Booking for video shoots now open</div></div></div></div></section><section class=\"about-custom-content__section about-custom-content__section__case-studies-carousel\" id=caseStudySection><div class=\"about-custom-content__section about-custom-content__section__case-studies-carousel__title\">Making visual content creation simple and hassle-free for businesses.</div><div class=\"about-custom-content__section about-custom-content__section__case-studies-carousel__description\">Discover how Custom Content Assignment has helped brands create great visual content.</div><case-studies-grid-carousel></case-studies-grid-carousel></section><general-contact-form id=generalContactFormSection context=about-custom-cotnent class=\"about-custom-content__section about-custom-content__section__contact-form\"></general-contact-form></div>");
$templateCache.put("app/community-detail-page/components/community-detail-album-detail/community-detail-album-detail.html","<div class=community-detail-album-detail><div class=community-detail-album-detail__header><div class=community-detail-album-detail__album-name>{{vm.album.name}}</div><div class=community-detail-album-detail__group-btn><div ng-if=vm.isMine class=\"community-detail-album-detail__upload-btn btn-submit\" ng-click=vm.onUploadBtnClicked()><span class=\"community-detail-album-detail__upload-btn-icon icon-icons_plus\"></span> <span class=community-detail-album-detail__upload-btn-label>Upload</span></div><div ng-if=vm.isMine uib-dropdown class=community-detail-album-detail__more__menu><span uib-dropdown-toggle class=icon-icons_more></span><ul class=community-detail-album-detail__more__list uib-dropdown-menu role=menu><li role=menuitem class=community-detail-album-detail__more__item ng-click=vm.onEditAlbum()>Edit</li><li role=menuitem class=community-detail-album-detail__more__item ng-click=vm.onDeleteAlbum()>Delete</li></ul></div></div></div><div ng-if=vm.photos.length class=community-detail-album-detail__photo-list><div flex-grid ng-model=vm.photos margins=3 rowheight=200><div ng-repeat=\"photo in vm.photos\" class=community-detail-album-detail__photo-list__item><div ng-if=vm.isMine class=\"community-detail-album-detail__photo-list__remove-icon icon-icons_close\" uib-tooltip=\"Remove this photo\" ng-click=vm.onDeletePhotoAlbum(photo) tooltip-placement=auto tooltip-append-to-body=true></div><div ng-if=vm.isMine class=\"community-detail-album-detail__photo-list__set-as-cover icon-icons_image\" uib-tooltip=\"Set as cover\" ng-click=vm.setAsCover(photo) tooltip-append-to-body=true tooltip-placement=auto></div><a ng-attr-fancyboxable=\"{\'type\': \'image\', \'overlayShow\': true, \'hideOnOverlayClick\': true, \'showNavArrows\': true, \'margin\': \'50 10 15 10\', \'centerOnScroll\': true}\" href={{photo.file.large}} rel=discussionAttachment><img ng-src={{photo.file.medium}}></a></div></div></div></div>");
$templateCache.put("app/community-detail-page/components/community-detail-discussions/community-detail-discussions.html","<div class=community-detail-discussions><div class=community-detail-discussions__wrapper ng-if=vm.showSearchDiscussion><div class=community-detail-discussions__header><div class=community-detail-discussions__header__search><div class=\"community-detail-discussions__header__search__input__icon icon-icons_search\"></div><input type=text class=community-detail-discussions__header__search__input placeholder=\"{{\'search-topic\' | translate}}\" ng-change=vm.onSearchDiscussion() ng-model=vm.searchDiscussionString></div></div><div ng-if=\"vm.canStartDiscussion && vm.canUpdateCommunity\" class=community-detail-discussions__topic><div class=community-detail-discussions__topic__label translate>{{\'create-post\'}}</div><div class=community-detail-discussions__topic__input-wrapper><div class=community-detail-discussions__topic__owner-avatar><pixerf-user-avatar user-data=vm.loginUser lazy=true></pixerf-user-avatar></div><div class=community-detail-discussions__topic__input ng-click=vm.onStartDiscussion()>{{\'Whats-on-your-mind-today\' | translate}}</div></div><div ng-if=vm.draftDiscussions.length class=community-detail-discussions__topic__draft><discussion-topic-draft ng-repeat=\"draftDiscussion in vm.draftDiscussions\" discussion=draftDiscussion community=vm.community on-published=vm.onDraftDiscussionPublished(draftDiscussion) on-removed=vm.onDraftDiscussionRemoved(data)></discussion-topic-draft></div></div></div><div class=community-detail-discussions__thread><div ng-if=vm.showDiscussions class=community-detail-discussions__thread__header><div class=community-detail-discussions__thread__label translate>{{\'discussions\'}}</div><div class=community-detail-discussions__thread__arrange><div class=community-detail-discussions__thread__arrange__label>{{\'arrange-by\' | translate}}:</div><div class=community-detail-discussions__thread__arrange__list><custom-radio-button is-disabled=!vm.discussions.length ng-repeat=\"item in vm.arrangeOptions.selections\" default=\"{{(item.value == vm.defaultArrangeBy.arrangeBy) ? \'true\' : \'false\'}}\" class=community-detail-discussions__thread__arrange__item ng-class=\"{\'disabled\': !vm.discussions.length}\" model=vm.arrangeBy options=vm.arrangeOptions model-property={{vm.arrangeOptions.props}} value=vm.arrangeOptions.selections[$index].value label=vm.arrangeOptions.selections[$index].label on-changed=vm.onArrageChanged(data)></custom-radio-button></div></div></div><div class=community-detail-discussions__thread__body><div ng-if=\"!vm.discussions.length && !vm.isWorking\" class=community-detail-discussions__thread__body__empty><div ng-if=\"!vm.community.is_private && (!vm.community.membership_status || vm.community.membership_status === \'requested\')\" class=community-detail-discussions__thread__body__empty__title>{{vm.isOwner ? \'You do not\' : vm.community.name + \' doesn\\\'t\'}} have any ongoing discussions</div><div ng-if=\"vm.community.is_private && (!vm.community.membership_status || vm.community.membership_status === \'requested\')\" class=community-detail-discussions__thread__body__empty__title>This community is private.</div><div ng-if=\"vm.community.is_private && (!vm.community.membership_status || vm.community.membership_status === \'requested\') && !vm.isBusinessAcc\" class=community-detail-discussions__thread__body__empty__content>Join this community to see their discussions and events.</div><div ng-if=\"vm.community.is_private && (!vm.community.membership_status || vm.community.membership_status === \'requested\') && !vm.isBusinessAcc\" class=\"community-detail-discussions__thread__body__empty__button btn\" ng-class=\"vm.community.membership_status === \'requested\' ? \'btn-cancel--no-background\' : \'btn-submit\'\" authentication-click=vm.onRequestToJoinedClicked() check-verified-email=true>{{vm.submitButtonText}}</div><div ng-if=\"vm.community.is_private && (!vm.community.membership_status || vm.community.membership_status === \'requested\') && vm.isBusinessAcc\" class=community-detail-discussions__thread__body__empty__content>Want to get in touch with the Community? <a class=\"text--color-pixerf-theme text--bold\" href=mailto:business@pixerf.com>Email</a> us.</div><div ng-if=vm.canStartDiscussion class=community-detail-discussions__thread__body__empty__content translate>{{\'discussions-keep-your-community-engaged\'}}</div><div ng-if=\"vm.canStartDiscussion && vm.canUpdateCommunity\" class=\"community-detail-discussions__thread__body__empty__button btn btn-submit\" ng-click=vm.onStartDiscussion()>{{\'start-a-discussion\' | translate}}</div></div><div ng-if=vm.discussions.length class=community-detail-discussions__thread__body__discussions infinite-scroll-disabled=vm.isLastPage infinite-scroll=vm.fetchMoreDiscussions() infinite-scroll-immediate-check=false><discussion-tile ng-repeat=\"discussion in vm.discussions\" discussion=discussion arrange-by=\"{{vm.arrangeBy.arrangeBy || vm.defaultArrangeBy.arrangeBy}}\" community=vm.community on-removed=vm.onDiscussionRemoved(discussion)></discussion-tile></div></div></div></div>");
$templateCache.put("app/community-detail-page/components/community-detail-classes/community-detail-classes.html","<div class=community-detail-classes><div class=community-detail-classes__header><div class=community-detail-classes__header__search><div class=\"community-detail-classes__header__search__icon icon-icons_search\"></div><input type=text class=community-detail-classes__header__search__input placeholder=\"{{\'search-class\' | translate}}\" ng-change=vm.onSearchEvents() ng-model=vm.searchEventsString></div><div ng-if=\"(vm.isMine || vm.community.membership_status == \'manager\') && vm.canUpdateCommunity\" class=community-detail-classes__create-new ng-click=vm.onCreateEvent()><span class=\"community-detail-classes__create-new__icon icon-icons_plus\"></span> <span class=community-detail-classes__create-new__label>New Class</span></div></div><div ng-if=!vm.searchEventsString class=community-detail-classes__upcoming infinite-scroll-disabled=vm.isLastUpcomingEvent infinite-scroll=\"vm.fetchMoreEvents(\'upcoming\')\" infinite-scroll-immediate-check=false><div class=community-detail-classes__section-label translate>{{\'upcoming-classes\'}}</div><empty-section ng-if=!vm.upcomingEvents.length content=vm.emptyUpcomingEvents on-submit=vm.onCreateEvent()></empty-section><div ng-if=vm.upcomingEvents.length class=community-detail-classes__upcoming__list><event-detail-tile ng-repeat=\"event in vm.upcomingEvents\" data=event></event-detail-tile></div><scroll-paging spinner=vm.spinner is-last-page=vm.isLastUpcomingEvent message=\"No more upcoming events.\"></scroll-paging></div><div ng-if=!vm.searchEventsString class=community-detail-classes__past infinite-scroll-disabled=vm.isLastPastEvent infinite-scroll=\"vm.fetchMoreEvents(\'past\')\" infinite-scroll-immediate-check=false><div ng-if=vm.pastEvents.length class=community-detail-classes__section-label translate>{{\'past-classes\'}}</div><div ng-if=vm.pastEvents.length class=community-detail-classes__past__list><event-list-tile ng-repeat=\"event in vm.pastEvents\" data=event></event-list-tile></div><scroll-paging spinner=vm.spinnerPastEvents is-last-page=vm.isLastPastEvent message=\"No more past classes.\"></scroll-paging></div><div ng-if=vm.searchEventsString class=community-detail-classes__upcoming infinite-scroll-disabled=vm.isLastSearchEvent infinite-scroll=\"vm.fetchMoreEvents(\'search\')\" infinite-scroll-immediate-check=false><div class=community-detail-classes__section-label>Search result</div><empty-section ng-if=!vm.searchEvents.length content=vm.emptySearchEvent></empty-section><div ng-if=vm.upcomingEvents.length class=community-detail-classes__upcoming__list><event-detail-tile ng-repeat=\"event in vm.searchEvents\" data=event></event-detail-tile></div><scroll-paging spinner=vm.spinnerPastEvents is-last-page=vm.isLastSearchEvent message=\"No more past classes.\"></scroll-paging></div></div>");
$templateCache.put("app/community-detail-page/components/community-detail-events/community-detail-events.html","<div class=community-detail-events><div class=community-detail-events__header><div class=community-detail-events__header__search><div class=\"community-detail-events__header__search__icon icon-icons_search\"></div><input type=text class=community-detail-events__header__search__input placeholder=\"{{\'search-event\' | translate}}\" ng-change=vm.onSearchEvents() ng-model=vm.searchEventsString></div><div ng-if=\"(vm.isMine || vm.community.membership_status == \'manager\') && vm.canUpdateCommunity\" class=community-detail-events__create-new ng-click=vm.onCreateEvent()><span class=\"community-detail-events__create-new__icon icon-icons_plus\"></span> <span class=community-detail-events__create-new__label translate>{{\'new-event\'}}</span></div></div><div ng-if=!vm.searchEventsString class=community-detail-events__upcoming infinite-scroll-disabled=vm.isLastUpcomingEvent infinite-scroll=\"vm.fetchMoreEvents(\'upcoming\')\" infinite-scroll-immediate-check=false><div class=community-detail-events__section-label translate>{{\'upcoming-events\'}}</div><empty-section ng-if=!vm.upcomingEvents.length content=vm.emptyUpcomingEvents on-submit=vm.onCreateEvent()></empty-section><div ng-if=vm.upcomingEvents.length class=community-detail-events__upcoming__list><event-detail-tile ng-repeat=\"event in vm.upcomingEvents\" data=event></event-detail-tile></div><scroll-paging spinner=vm.spinner is-last-page=vm.isLastUpcomingEvent message=\"No more upcoming events.\"></scroll-paging></div><div ng-if=!vm.searchEventsString class=community-detail-events__past infinite-scroll-disabled=vm.isLastPastEvent infinite-scroll=\"vm.fetchMoreEvents(\'past\')\" infinite-scroll-immediate-check=false><div ng-if=vm.pastEvents.length class=community-detail-events__section-label translate>{{\'past-events\'}}</div><div ng-if=vm.pastEvents.length class=community-detail-events__past__list><event-list-tile ng-repeat=\"event in vm.pastEvents\" data=event></event-list-tile></div><scroll-paging spinner=vm.spinnerPastEvents is-last-page=vm.isLastPastEvent message=\"No more past events.\"></scroll-paging></div><div ng-if=vm.searchEventsString class=community-detail-events__upcoming infinite-scroll-disabled=vm.isLastSearchEvent infinite-scroll=\"vm.fetchMoreEvents(\'search\')\" infinite-scroll-immediate-check=false><div class=community-detail-events__section-label>Search result</div><empty-section ng-if=!vm.searchEvents.length content=vm.emptySearchEvent></empty-section><div ng-if=vm.upcomingEvents.length class=community-detail-events__upcoming__list><event-detail-tile ng-repeat=\"event in vm.searchEvents\" data=event></event-detail-tile></div><scroll-paging spinner=vm.spinnerPastEvents is-last-page=vm.isLastSearchEvent message=\"No more past events.\"></scroll-paging></div></div>");
$templateCache.put("app/community-detail-page/components/community-detail-page-brief/community-detail-page-brief.html","<section class=community-detail-page-brief><h2 class=\"community-detail-page-brief__about-title text--semibold text--color-black\" translate>{{\'about-this-community\'}}</h2><p ng-bind-html=vm.community.description></p><div ng-if=vm.isPrivatedContent class=\"community-detail-page-brief__privated-section text--color-black-6\"><div class=\"community-detail-page-brief__privated-section__icon icon-lock\"></div><div class=\"community-detail-page-brief__privated-section__text text--semibold\">This Community is Private.</div></div></section>");
$templateCache.put("app/community-detail-page/components/community-detail-page-invite-member/community-detail-page-invite-member.html","<div class=\"community-detail-page-invite-member clearfix relative\"><div><div class=community-detail-page-invite-member__page-title><h2 class=\"text--bold text--color-black\">Invite a Pixerf\'s member</h2><p>Invite Pixerf\'s photographer to join your community.</p><button class=\"btn btn-pixerf-theme btn-pixerf-theme--no-background text--bold\" ng-click=vm.onInvitePxerferClicked()>Invite</button></div><h2>Or</h2><div class=community-detail-page-invite-member__page-title><h2 class=\"text--bold text--color-black\">Share your love for photograpphy</h2><p>Invite a friend to PIXERF. Nam porttitor blandit accumsan. Ut vel dictum sem.</p></div></div><div class=community-detail-page-invite-member__main-content><div class=clearfix><div class=\"col-md-5 col-sm-7 col-xs-12 no-padding community-detail-page-invite-member__email-wrapper\"><input maxlength=50 name=name required ng-model=vm.invite.name placeholder=\"Enter email address\" type=text class=\"form-control community-detail-page-invite-member__email\"></div><button class=\"btn btn-pixerf-theme btn-pixerf-theme--no-background text--bold community-detail-page-invite-member__btn-send-invite\" ng-click=vm.onBtnSendInviteClicked()>Send Invite</button></div><div class=\"community-detail-page-invite-member__import-from-email-contact clearfix\"><div class=community-detail-page-invite-member__import-from-email-contact__label><span>Import contact from</span></div><div class=community-detail-page-invite-member__email-icon-wrapper ng-click=vm.onGmailClicked()><div class=\"email-icon email-icon__gmail\"></div><div class=community-detail-page-invite-member__email-icon-wrapper__label>Gmail</div></div><div class=community-detail-page-invite-member__email-icon-wrapper ng-click=vm.onOutlookClicked()><div class=\"email-icon email-icon__outlook\"></div><div class=community-detail-page-invite-member__email-icon-wrapper__label>Outlook</div></div></div><div class=community-detail-page-invite-member__pending-invitation-list><h2 ng-if=\"vm.memberGridInit.peoples.length >0\" class=community-detail-page-invite-member__pending-invitation-list__header>Waiting for acceptances({{vm.memberGridInit.peoples.length}})</h2><community-pending-invitations-list community=vm.community on-init=vm.onMemberGridInit(instance)>There is no invitation.</community-pending-invitations-list></div></div></div>");
$templateCache.put("app/community-detail-page/components/community-detail-page-members/community-detail-page-members.html","<div class=community-detail-page-members><community-detail is-manager=\"vm.parent.community.isMine || vm.parent.community.isManager\" community=vm.parent.community options=vm.communityDetailOptions></community-detail></div>");
$templateCache.put("app/community-detail-page/components/community-detail-photos/community-detail-photos.html","<div class=community-detail-photos><div class=community-detail-photos__section-row><div class=community-detail-photos__section-header><div class=community-detail-photos__section-header__title>Community Albums</div><button ng-if=vm.isMine class=community-detail-photos__section-header__new-album-btn ng-click=vm.onCreateNewAlbum()><span class=\"community-detail-photos__section-header__new-album-btn__icon icon-icons_plus\"></span> <span class=community-detail-photos__section-header__new-album-btn__label>New Album</span></button></div><empty-section ng-if=!vm.communityAlbums.length content=vm.emptyCommunityAlbums></empty-section><div ng-if=vm.communityAlbums.length class=community-detail-photos__tile-grid infinite-scroll-disabled=vm.isLastCommunityPage infinite-scroll=vm.fetchMoreCommunityAlbums() infinite-scroll-immediate-check=false><div ng-repeat=\"photo in vm.communityAlbums\" class=community-detail-photos__tile ng-click=vm.onCommunityAlbumClicked(photo)><div class=community-detail-photos__tile__cover><img ng-src={{photo.cover_photo.file.thumbnail}}></div><div class=community-detail-photos__tile__name>{{photo.name}}</div><div class=community-detail-photos__tile__no-of-images>{{photo.photo_count === 1 ? photo.photo_count + \' photo\' : photo.photo_count + \' photos\'}}</div></div><scroll-paging spinner=vm.spinnerCommunity is-last-page=vm.isLastCommunityPage></scroll-paging></div></div><div ng-if=vm.eventAlbums.length class=community-detail-photos__section-row><div class=community-detail-photos__section-header><div class=community-detail-photos__section-header__title>Albums of Classes</div></div><div class=community-detail-photos__tile-grid infinite-scroll-disabled=vm.isLastEventPage infinite-scroll=vm.fetchMoreEventAlbums() infinite-scroll-immediate-check=false><div ng-repeat=\"photo in vm.eventAlbums\" class=community-detail-photos__tile ng-click=vm.onEventAlbumClicked(photo)><div class=community-detail-photos__tile__cover><img ng-src={{photo.cover.medium}}></div><div class=community-detail-photos__tile__name>{{photo.name}}</div><div class=community-detail-photos__tile__no-of-images>{{photo.photo_count === 1 ? photo.photo_count + \' photo\' : photo.photo_count + \' photos\'}}</div></div><scroll-paging spinner=vm.spinnerEvent is-last-page=vm.isLastEventPage></scroll-paging></div></div></div>");
$templateCache.put("app/complete-profile-page/components/complete-profile-photo/complete-profile-photo.html","<div class=complete-profile-photo><div class=complete-profile-photo__wrapper><div class=\"complete-profile-photo__main-content clearfix\"><div class=\"complete-profile-photo__header clearfix\"><div class=\"complete-profile-photo__title text--bold\">Hi {{vm.loginedUser.displayName}}, {{\'profile-member-community\' | translate}}</div><div class=complete-profile-photo__description translate>{{\'profile-complete\'}}</div></div><div class=\"complete-profile-photo__content clearfix\"><div class=complete-profile-photo__content__left><div class=\"complete-profile-photo__content__title text--bold\" translate>{{\'add-profile-photo\'}}</div><div class=complete-profile-photo__content__description translate>{{\'profile-photo-description\'}}</div><div class=\"complete-profile-photo__content__required text--bold\">{{\'profile-photo-requirement\' | translate}}:</div><ul class=complete-profile-photo__content__required__list><li class=complete-profile-photo__content__required__item translate>{{\'profile-photo-requirement1\'}}</li><li class=complete-profile-photo__content__required__item translate>{{\'profile-photo-requirement2\'}}</li><li class=complete-profile-photo__content__required__item translate>{{\'profile-photo-requirement3\'}}</li></ul></div><div class=complete-profile-photo__content__right><div class=complete-profile-photo__content__avatar><div id=adjusted-photo class=clearfix ng-show=vm.isAdjustedPhoto><div class=\"hint text--bold text--color-black\">Looking good!</div></div><upload-avatar-zone on-file-added=vm.onAvatarAdded(file) on-init=vm.onDropzoneInit(instance) hide-control={{vm.isAdjustedPhoto}} on-successed=vm.onAvataUpdated(handle)></upload-avatar-zone><span ng-show=vm.isAdjustedPhoto class=icon-icons_check></span></div></div></div></div><div class=\"complete-profile-photo__footer clearfix\"><div class=complete-profile-photo__footer__wrapper><button class=\"btn complete-profile-photo__footer__control-btn back-btn text--bold btn--transparent\" ng-click=vm.onBackBtnClicked() ng-if=vm.newAvatar>Back</button> <button class=\"btn complete-profile-photo__footer__control-btn skip-btn text--bold btn-cancel--no-background\" ng-click=vm.onSkipUpadateAvatarClicked() ng-if=!vm.newAvatar>Skip</button> <button class=\"btn complete-profile-photo__footer__control-btn continue-btn text--bold\" ng-class=\"vm.newAvatar ? \'btn-submit--no-background\': \'btn-submit\'\" ng-click=vm.onUploadphoto()>{{vm.newAvatar ? \'Change Photo\' : \'Choose Photo\'}}</button> <button class=\"btn btn-submit complete-profile-photo__footer__control-btn continue-btn text--bold\" ng-if=vm.newAvatar ng-click=vm.onSaveAvatar()>Save photo</button></div></div></div></div>");
$templateCache.put("app/complete-profile-page/components/complete-profile-skills/complete-profile-skills.html","<div class=complete-profile-skills><div class=complete-profile-skills__wrapper><div class=\"complete-profile-skills__main-content clearfix\"><div class=\"complete-profile-skills__header clearfix\"><div class=\"complete-profile-skills__title text--bold col-xs-12 col-sm-8\" translate>{{\'skills-experience\'}}</div><div class=\"complete-profile-skills__description col-xs-12 col-sm-8\" translate>{{\'skill-experience-description\'}}</div></div><div class=\"complete-profile-skills__content clearfix\"><form name=skillForm class=complete-profile-skills__form><div class=\"complete-profile-skills__form__group form-group col-sm-6 group-first-name\" ng-if=!vm.loginedUser.first_name><label required for=first_name translate>{{\'first-name\'}}</label><input required type=text class=\"input__exp form-control\" maxlength=20 name=first_name ng-model=vm.user.first_name type=first_name></div><div class=\"complete-profile-skills__form__group form-group col-sm-6 group-last-name\" ng-if=!vm.loginedUser.last_name><label required for=last_name translate>{{\'last-name\'}}</label><input required type=text class=\"input__exp form-control\" maxlength=20 name=last_name ng-model=vm.user.last_name type=last_name></div><div class=\"form-group col-sm-6 complete-profile-skills__form__group group-country\" ng-class=\"{\'place-holder\': !vm.user.country}\" ng-if=\"!vm.loginedUser.address || !vm.loginedUser.address.country\"><label required for=country class=label-sign-up-information translate>{{\'country\'}}</label><country-select on-changed=vm.onCountrySelected(vm.user.country) place-holder=\"Select country\" id=E9 class=form-control required name=country ng-model=vm.user.country></country-select></div><div class=\"form-group col-sm-6 complete-profile-skills__form__group group-location\" ng-class=\"{\'place-holder\': !vm.user.location}\" ng-if=!vm.loginedUser.location><label required for=location class=label-sign-up-information translate>{{\'location\'}}</label><input id=E10 required validation-no-hyperlink name=location ng-model=vm.user.location class=form-control g-places-autocomplete options=vm.gplacesOptions></div><div class=\"form-group col-sm-6 complete-profile-skills__form__group group-birthday\" ng-if=!vm.loginedUser.date_of_birth><label required for=\"\" class=label-sign-up-information translate>{{\'birthday\'}}</label><div class=\"input-group pixerf-calendar-input\"><datetime-dropdown model=vm.user.date_of_birth min-age={{vm.age.min}} max-age={{vm.age.max}} invalid=vm.invalidBirthday></datetime-dropdown></div></div><div class=\"complete-profile-skills__form__group form-group col-sm-12 group-bio\"><label for=userBio translate>{{\'about-yourself\'}}</label><textarea name=userBio class=\"input__user-bio form-control\" cols=30 rows=4 ng-model=vm.user.bio maxlength=255></textarea></div><div class=\"complete-profile-skills__form__group form-group col-sm-6 group-exp\"><label required for=yearOfExp translate>{{\'years-of-experience\'}}</label><input required type=text class=\"input__exp form-control\" name=yearOfExp ng-model=vm.serviceData.years_of_experience maxlength=2 min=0 type=number ng-pattern=/^\\d*$/ ></div><div class=\"complete-profile-skills__form__group form-group col-sm-6 group-rates\"><label for=serviceRates translate>{{\'service-rates\'}}</label><div class=clearfix><pixerf-input-auto-complete class=complete-profile-skills__service-rates__dropdown-select options=\"{\'maxOptions\': 1, \'noneSelectedText\': \'Select\'}\" ng-if=vm.serviceRates name=service_rates dropdown-class=complete-profile-skills__dropdown data=vm.serviceRates model=vm.serviceData.serviceRatesSelected on-changed=vm.onServiceRatesSelected(vm.serviceData.serviceRatesSelected)></pixerf-input-auto-complete><div class=complete-profile-skills__service-rates__mount><input maxlength=255 min={{vm.CONST.SERVICES_RATE_MIN}} max={{vm.CONST.SERVICES_RATE_MAX}} type=number ng-pattern=/^\\d*$/ name=service_rates_unit ng-disabled=\"!vm.serviceData.serviceRatesSelected || !vm.serviceData.serviceRatesSelected.length\" validation-no-hyperlink ng-model=vm.serviceData.services_rate_amount class=\"form-control complete-profile-skills__service-rates__money\" placeholder=0.00><div class=complete-profile-skills__service-rates__unit>SGD</div></div></div></div><div class=\"complete-profile-skills__form__group form-group col-sm-12 group-speciality\"><label for=speciality required translate>{{\'photography-specialty\'}}</label><dropdown-tag ng-if=vm.specialities max-selected={{vm.maxSpecialitiesSelected}} data=vm.specialities on-item-removed=\"vm.onItemChanged({items, item})\" on-item-selected=\"vm.onItemChanged({items, item})\" on-exceed-limit=vm.onExccedLimit() on-init=vm.serviceData.specialities></dropdown-tag><div class=form-group__hint translate=select-speciality translate-values=\"{number: 5}\"></div></div><div class=\"complete-profile-skills__form__group form-group col-sm-12 group-camera\"><label for=cameras translate>{{\'preferred-cameras\'}}</label><tags-input on-tag-adding=\"vm.onValidateTag($tag, $event)\" add-on-space=true add-on-blur=true ng-model=vm.serviceData.cameras type=text tag-class=camera-tag class=\"form-control camera-tag-input\" placeholder=\"Add a camera\"></tags-input></div><div class=\"complete-profile-skills__form__group form-group col-sm-12 group-availability\"><label class=\"col-xs-12 no-padding\" translate>{{\'take-up-cc\'}}</label><div class=\"edit-profile-personal__checkbox-item clearfix pull-left\"><stick-checkbox on-changed=vm.onAvailabilityShowed(vm.serviceData.availability) model=vm.serviceData model-property=availability label=yes layout-style=solid-square></stick-checkbox></div><div ng-if=vm.serviceData.availability class=\"complete-profile-skills__availability clearfix\"><div class=complete-profile-skills__availability-label translate>{{\'availability\'}}</div><div><div class=\"form-group complete-profile-skills__checkbox-group clearfix\"><div class=complete-profile-skills__availability-label__duration translate>{{\'weekdays\'}}</div><div class=\"clearfix complete-profile-skills__checkbox-item\"><stick-checkbox on-changed=\"vm.onAvailabilityChanged(\'availability_weekdays\')\" model=vm.availability_weekdays model-property=day label=day layout-style=solid-square></stick-checkbox></div><div class=\"clearfix complete-profile-skills__checkbox-item\"><stick-checkbox on-changed=\"vm.onAvailabilityChanged(\'availability_weekdays\')\" model=vm.availability_weekdays model-property=evening label=evening layout-style=solid-square></stick-checkbox></div></div><div class=\"form-group complete-profile-skills__checkbox-group clearfix\"><div class=complete-profile-skills__availability-label__duration translate>{{\'weekends\'}}</div><div class=\"clearfix complete-profile-skills__checkbox-item\"><stick-checkbox on-changed=\"vm.onAvailabilityChanged(\'availability_weekends\')\" model=vm.availability_weekends model-property=day label=day layout-style=solid-square></stick-checkbox></div><div class=\"clearfix complete-profile-skills__checkbox-item\"><stick-checkbox on-changed=\"vm.onAvailabilityChanged(\'availability_weekends\')\" model=vm.availability_weekends model-property=evening label=evening layout-style=solid-square></stick-checkbox></div></div></div></div></div></form></div></div><div class=\"complete-profile-skills__footer clearfix\"><div class=complete-profile-skills__footer__wrapper><button class=\"btn complete-profile-skills__footer__control-btn skip-btn text--bold btn-cancel--no-background\" ng-click=vm.onBackBtnClicked()>{{\'back\' | translate}}</button> <button class=\"btn btn-submit complete-profile-skills__footer__control-btn continue-btn text--bold\" ng-click=vm.onCompleted(skillForm)>{{\'continue\' | translate}}</button></div></div></div></div>");
$templateCache.put("app/components/comment-list/comment/comment.html","<div class=\"comment clearfix\" ng-class=\"{\'comment--editable\': vm.isEditMode }\"><a class=pull-left popup-link-clicked=\"{{\'/user-home-page/\' + comment.user.id + \'/\'+ (comment.user.displayName | toSnakeCase)}}\"><pixerf-user-avatar class=profile-image user-data=comment.user lazy=true></pixerf-user-avatar></a><div class=\"pull-left comment__content\"><a popup-link-clicked=\"{{\'/user-home-page/\' + comment.user.id + \'/\'+ (comment.user.displayName | toSnakeCase)}}\" class=\"comment__content__author-name text--truncate text--semibold text--color-black\">{{comment.user.displayName}}</a><div ng-if=!vm.isEditMode><span class=\"comment--text text--color-black-2\">{{comment.text}}</span> <span class=comment__edited-label><i>{{comment.isEdited ? \'Edited\': \'\'}}</i></span></div><div ng-if=vm.isEditMode><comment-input mediaid=mediaid focus=vm.isEditMode settings=\"{\'hidePerson\': true, \'hideIcon\': true}\" comment=comment on-edited=vm.onEditedCallback() shoot-id={{shootId}} submission-id={{submissionId}} is-custom-commissions={{isCustomCommissions}}></comment-input></div><div class=comment__extra-info><span class=\"comment__date text--color-black-3\">{{comment.createdAtFormated}}</span> <a ng-if=\"comment.isMine && !vm.isEditMode\" ng-click=vm.onEditCommentCliced() class=\"comment__btn comment__btn__edit-btn pixerf-link--color-blue\">Edit</a> <span class=comment__btn__devider ng-if=\"comment.isMine && !vm.isEditMode\">·</span> <a ng-if=\"comment.isMine && !vm.isEditMode || context === \'IN_MY_HOUSE\'\" ng-click=vm.onDeleteCommentClicked() class=\"comment__btn comment__btn__delete-btn pixerf-link--color-theme\">Delete</a> <span class=comment__btn__devider ng-if=\"comment.isMine && vm.isEditMode\">·</span> <a ng-if=vm.isEditMode ng-click=vm.onCancelBtnClicked()>Cancel</a></div></div></div>");
$templateCache.put("app/components/comment-list/comment-input/comment-input.html","<div class=comment-input><form ng-if=comment.user name=commentForm><a class=\"pull-left comment-input__avatar\" ng-hide=settings.hidePerson popup-link-clicked=\"{{\'/user-home-page/\' + comment.user.id + \'/\'+ (comment.user.displayName | toSnakeCase)}}\"><pixerf-user-avatar class=profile-image user-data=comment.user lazy=true></pixerf-user-avatar></a><textarea name=commentText focus-me=focus ng-disabled=vm.isWorking enter=vm.submit(commentForm) authentication-click check-verified-email=true placeholder=\"{{placeholderText || (\'add-a-comment\' | translate)}}\" validation-no-hyperlink msd-elastic ng-model=comment.text class=\"comment-box form-control\" rows=1></textarea><button ng-show=settings.showPostBtn ng-click=vm.submit(commentForm) class=\"btn btn-submit ng-hide\">Post</button> <span ng-hide=settings.hideIcon class=icon-icons_comment></span></form><div ng-if=!comment.user>{{\'have-a-comment\' | translate}} <span compile=\"\'sign-up-to-share\' | translate\"></span></div></div>");
$templateCache.put("app/components/earnings/payout-method/payout-method.html","<div class=payout-method-page><div class=payout-method-page__header><div class=\"payout-method-page__title text--bold text--color-black\" translate>{{\'payout-preferences\'}}</div><div class=payout-method-page__description translate>{{\'payout-preferences-description\'}}</div></div><div class=\"payout-method-page__empty-list text-center\" ng-if=\"vm.payoutMethods.length === 0\"><div class=payout-method-page__empty-list__icon></div><div class=\"payout-method-page__empty-list__title text--bold\" translate>{{\'no-payout-methods\'}}</div><div role=button class=\"payout-method-page__btn btn btn-submit\" ng-click=vm.addPaymentMethod() translate>{{\'add-payout-method\'}}</div></div><div class=\"payout-method-page__list text-center\" ng-if=\"vm.payoutMethods.length != 0\"><table class=\"payment-method pixerf-table\"><tr class=payment-method__header><th class=\"payment-method__header__col payment-method__col__payout\">{{\'set-default-payout\' | translate}}</th><th class=\"payment-method__header__col payment-method__col__details\">{{\'details\' | translate}}</th><th class=\"payment-method__header__col payment-method__col__remove\"></th></tr><tr class=payment-method__row ng-repeat=\"payoutMethod in vm.payoutMethods\"><td class=\"payment-method__col payment-method__col__payout\"><div ng-class=\"{\'icon-icons-bullet--checked\': payoutMethod.is_default, \'icon-icons-bullet\': !payoutMethod.is_default}\" class=payment-method__icon-selection ng-click=vm.onPaymentMethodClicked(payoutMethod)></div><div class=payment-method__col__payout__icon><div class=icon-img ng-class=\"{\'photo-paypal-icon\': payoutMethod.code === \'PAYPAL\', \'photo-bank-transfer-icon\': payoutMethod.code === \'BANK_TRANSFER\'}\"></div></div><div class=payment-method__col__payout__label>{{payoutMethod.name}}</div></td><td class=\"payment-method__col payment-method__col__details\">{{payoutMethod.details | bankSensoredInfo:\'AAAxxxBBB\'}}</td><td class=\"payment-method__col payment-method__col__remove clearfix\"><div class=\"pull-right clearfix\"><div class=\"payment-method__edit-btn clearfix\" role=button ng-if=\"payoutMethod.code !== \'PAYPAL\'\" ng-click=vm.onEditPaymentMethodClicked(payoutMethod)><div class=\"payment-method__btn__text pull-left text--bold\" translate>{{\'edit\'}}</div><div class=\"payment-method__btn__icon icon-icons_edit pull-left\"></div></div><div class=\"payment-method__remove-btn clearfix\" role=button ng-click=vm.onRemovePaymentMethodClicked(payoutMethod)><div class=\"payment-method__btn__text pull-left text--bold\" translate>{{\'remove\'}}</div><div class=\"payment-method__btn__icon icon-icons_close pull-left\"></div></div></div></td></tr></table><div role=button class=\"payout-method-page__btn btn btn-submit\" ng-click=vm.addPaymentMethod()>{{\'add-more-payout-methods\' | translate}}</div></div></div>");
$templateCache.put("app/components/earnings/my-earnings/my-earnings.html","<div class=my-earnings-page><div class=\"my-earnings-page__widthdraw-block clearfix\"><div class=my-earnings-page__widthdraw-block__content><div class=my-earnings-page__widthdraw-block__headline><span class=my-earnings-page__widthdraw-block__headline__label>{{\'available-for-withdrawal\' | translate}}</span> <span class=my-earnings-page__widthdraw-block__headline__time>as of {{vm.today}}</span></div><div class=\"my-earnings-page__widthdraw-block__value clearfix\" ng-click=vm.onToggleDetailsEarning(vm.isOpenDetailsEarning)><div class=my-earnings-page__widthdraw-block__value__currency>SGD</div><div class=my-earnings-page__widthdraw-block__value__number>{{earnings.available_payout | number}}</div><div ng-if=earnings.components.length class=my-earnings-page__collapse-icon ng-class=\"!vm.isOpenDetailsEarning ? \'icon-icons_chevron-down\' : \'icon-icons_chevron-up\'\"></div></div></div><request-payout-btn class=my-earnings-page__widthdraw-block__request-button earnings=earnings onsucess=vm.onPayoutRequested(earnings)></request-payout-btn></div><div ng-if=earnings.components.length class=\"my-earnings-page__details-earning collapse\" uib-collapse=!vm.isOpenDetailsEarning><div class=my-earnings-page__details-earning__block><table class=my-earnings-page__details-earning__table><tr class=my-earnings-page__details-earning__header><th class=my-earnings-page__details-earning__header__date translate>{{\'date\'}}</th><th class=my-earnings-page__details-earning__header__photo-id translate>{{\'photo-id\'}}</th><th class=my-earnings-page__details-earning__header__category translate>{{\'category\'}}</th><th class=my-earnings-page__details-earning__header__description translate>{{\'description\'}}</th><th class=my-earnings-page__details-earning__header__discount>Credit Plan Discount</th><th class=my-earnings-page__details-earning__header__earning translate>{{\'earning\'}}</th></tr><tr class=my-earnings-page__details-earning__row ng-repeat=\"item in earnings.components\"><td class=my-earnings-page__details-earning__row__date><span class=my-earnings-page__details-earning__row__mobile-label translate>{{\'date\'}}</span> <span class=my-earnings-page__details-earning__row__value>{{item.date}}</span></td><td class=my-earnings-page__details-earning__row__photo-id><div ng-click=vm.onPhotoCLick(item.photo_id)><span class=my-earnings-page__details-earning__row__mobile-label translate>{{\'photo-id\'}}</span> <span class=\"my-earnings-page__details-earning__row__value my-earnings-page__details-earning__row__photo-id__value\">{{item.photo_id}}</span></div></td><td class=my-earnings-page__details-earning__row__category><span class=my-earnings-page__details-earning__row__mobile-label translate>{{\'category\'}}</span> <span class=my-earnings-page__details-earning__row__value>{{item.category}}</span></td><td class=my-earnings-page__details-earning__row__description><span class=my-earnings-page__details-earning__row__mobile-label translate>{{\'description\'}}</span><div class=my-earnings-page__details-earning__row__description__compile-value><span class=\"my-earnings-page__details-earning__row__description__compile-value__primary-value text--truncate\" uib-tooltip={{item.description}}>{{item.description}}</span> <span class=\"my-earnings-page__details-earning__row__description__compile-value__suplement-value text--truncate\" ng-if=item.prize_name>{{item.prize_name}}</span></div></td><td class=\"my-earnings-page__details-earning__row__discount clearfix\"><span class=my-earnings-page__details-earning__row__mobile-label>Credit Plan Discount</span><div class=my-earnings-page__details-earning__row__discount__compile-value><span ng-if=item.percentage_discount class=my-earnings-page__details-earning__row__discount__compile-value__primary-value>{{item.percentage_discount | number: 0}}% of Payout</span> <span ng-if=!item.percentage_discount class=my-earnings-page__details-earning__row__discount__compile-value__primary-value>-</span></div></td><td class=my-earnings-page__details-earning__row__earning><span class=my-earnings-page__details-earning__row__mobile-label translate>{{\'earning\'}}</span><div class=my-earnings-page__details-earning__row__value><span class=my-earnings-page__details-earning__row__earning__currency>{{item.currency}}</span> <span class=my-earnings-page__details-earning__row__earning__amount>{{item.amount | number}}</span></div></td></tr></table></div></div><div class=my-earnings-page__explain-details translate>{{\'request-transaction-details\'}}</div><div class=\"my-earnings-page__earning-summary clearfix\"><div class=my-earnings-page__earning-summary__headline translate>{{\'earnings-summary\'}}</div><div class=my-earnings-page__earning-summary__how-much translate translate-values=\"{money: \'$\' + (earnings.total | number)}\">{{\'you-have-earned-to-date\'}}</div><div class=my-earnings-page__earning-summary__how-earn ng-click=vm.onEaningsClicked()>How do I earn?</div></div><div class=my-earnings-page__earning-summary__block><div class=my-earnings-page__earning-summary__cell><div class=my-earnings-page__earning-summary__cell__title>{{\'withdrawn\' | translate}}</div><div class=my-earnings-page__earning-summary__cell__value>${{earnings.total_withdrawn | number:2}}</div></div><div class=my-earnings-page__earning-summary__cell><div class=my-earnings-page__earning-summary__cell__title>{{\'processing\' | translate}}</div><div class=my-earnings-page__earning-summary__cell__value>${{earnings.pending_payout | number:2}}</div></div><div class=my-earnings-page__earning-summary__cell><div class=my-earnings-page__earning-summary__cell__title>{{\'available-for-withdrawal\' | translate}}</div><div class=my-earnings-page__earning-summary__cell__value>${{earnings.available_payout | number:2}}</div></div><div class=\"my-earnings-page__earning-summary__cell my-earnings-page__earning-summary__total-earning\"><div class=my-earnings-page__earning-summary__total-earning__title>{{\'total-earnings\' | translate}}</div><div class=my-earnings-page__earning-summary__total-earning__value>${{earnings.total | number:2}}</div></div></div></div>");
$templateCache.put("app/components/earnings/photos-sold/photos-sold.html","<div class=photo-sold__main-content ui-view></div>");
$templateCache.put("app/components/earnings/transaction-history/transaction-history.html","<div class=transaction-history infinite-scroll-disabled=vm.isLastPage infinite-scroll=vm.fetchMorePurchasedItems() infinite-scroll-immediate-check=false><div class=transaction-history__filter__wrapper><div class=transaction-history__filter__wrapper__from><div class=transaction-history__filter__text-filter>From</div><div class=transaction-history__filter__input><input type=text name=fromDate class=form-control uib-datepicker-popup=\"d MMM yyyy\" ng-model=vm.selectedFilter.fromDate is-open=fromDate.isVisible datepicker-options=\"{showWeeks: false}\" show-button-bar=false> <button type=button class=transaction-history__filter__input__btn ng-click=\"fromDate.isVisible = !fromDate.isVisible\"><i class=\"glyphicon glyphicon-calendar\"></i></button></div></div><div class=transaction-history__filter__wrapper__to><div class=transaction-history__filter__text-filter>To</div><div class=transaction-history__filter__input><input type=text name=toDate class=form-control uib-datepicker-popup=\"d MMM yyyy\" ng-model=vm.selectedFilter.toDate is-open=toDate.isVisible datepicker-options=\"{showWeeks: false}\" show-button-bar=false> <button type=button class=transaction-history__filter__input__btn ng-click=\"toDate.isVisible = !toDate.isVisible\"><i class=\"glyphicon glyphicon-calendar\"></i></button></div></div></div><div class=transaction-history__table-wrapper><table class=\"transaction-history__table pixerf-table\"><tr class=transaction-history__table__header><th class=\"transaction-history__table__column transaction-history__table__column-transaction-id\">{{\'transaction-ref\' | translate}}</th><th class=\"transaction-history__table__column transaction-history__table__column-date\" ng-click=\"reverse = !reverse\">{{\'date\' | translate}} <span ng-class=\"{\'glyphicon glyphicon-triangle-bottom\': !reverse, \'glyphicon glyphicon-triangle-top\': reverse}\"></span></th><th class=\"transaction-history__table__column transaction-history__table__column-description\">{{\'transaction-amount\' | translate}}</th><th class=\"transaction-history__table__column transaction-history__table__column-method\">{{\'payment-method\' | translate}}</th><th class=\"transaction-history__table__column transaction-history__table__column-status\">{{\'status\' | translate}}</th></tr><tr class=transaction-history__table__row ng-repeat=\"item in vm.items | orderBy:purchasedDateFormatted:reverse\"><td class=transaction-history__table__column-transaction-id>#{{item.id}}</td><td class=transaction-history__table__column-date>{{item.purchasedDateFormatted}}</td><td class=transaction-history__table__column-description>SGD {{item.amount | number:2}}</td><td class=transaction-history__table__column-method>{{item.method}}</td><td class=transaction-history__table__column-status><span ng-class=\"{\'text--color-pixerf-theme text--bold\': item.status === \'rejected\', \'text--color-blue text--bold\': item.status === \'requested\' || item.status === \'processing\'}\" ng-bind=\"item.status === \'requested\' ? (\'processing\' | translate) : (item.status | translate)\"></span> <span uib-tooltip-html=\"vm.statusToolTips[item.status === \'requested\' ? \'processing\' : item.status] | translate\" tooltip-placement=auto tooltip-append-to-body=true tooltip-trigger=\"\'outsideClick\'\" class=\"transaction-status__tooltips-icon vertical-align-middle\" ng-class=\"item.status === \'rejected\' ? \'icon-warning\' : \'icon-icons-info\'\" tooltip-class=transaction-status__tooltips></span></td></tr></table></div><div class=\"sold-list__content__items--no-records text-center text--semibold\" ng-show=\"vm.items.length === 0 && !vm.spinner.isVisible\">{{\'no-records-found\' | translate}}</div><scroll-paging spinner=vm.spinner show-message=\"vm.items.length > 0 && vm.searchParams.page > 1\" is-last-page=vm.isLastPage></scroll-paging></div>");
$templateCache.put("app/components/manage-communities/manage-action-required-communities/manage-action-required-communities.html","<div class=manage-action-required-communities><section ng-if=\"(vm.actionRequiredCommunities && vm.actionRequiredCommunities.length) || vm.searchActionRequiredCommunityString\" class=manage-action-required-communities__action-required><div class=manage-action-required-communities__action-required__toggle-control><span class=manage-action-required-communities__action-required__toggle-control__label>{{(\'action-required\' | translate) | toTitleCase}} {{\' (\' + vm.totalActionRequiredCommunities +\')\'}}</span></div><div class=manage-action-required-communities__action-required__toggle><div class=manage-action-required-communities__action-required__subcontent>Communities that require action will be moved to Action Required, until the user resubmits the form.</div><div class=manage-action-required-communities__action-required__table-control><div class=manage-action-required-communities__action-required__table-control__search><div class=\"manage-action-required-communities__action-required__table-control__search__input__icon icon-icons_search\"></div><input type=text class=manage-action-required-communities__action-required__table-control__search__input placeholder=\"{{\'search-community\' | translate}}\" ng-change=vm.onSearchActionRequiredCommunity() ng-model=vm.searchActionRequiredCommunityString></div></div><div ng-if=\"vm.selecedActionRequiredCommunities.length && vm.isOpenActionRequiredNotification\" class=manage-action-required-communities__action-required__notification><div class=manage-action-required-communities__pending-approval__notification__number-selected><span class=manage-action-required-communities__pending-approval__notification__number-selected__value>{{vm.selecedActionRequiredCommunities.length}}</span> selected</div><div class=manage-action-required-communities__pending-approval__notification__first-control>Edit comments</div><div class=\"manage-action-required-communities__pending-approval__notification__close-button icon-icons_close\" ng-click=\"vm.onCloseNotification(\'action-required\')\"></div></div><div class=manage-action-required-communities__action-required__table><div class=manage-action-required-communities__action-required__table__header><div class=manage-action-required-communities__action-required__table__header__select><stick-checkbox on-changed=vm.onSelectAllActionRequiredCommunities(vm.isSelectedAllActionRequiredCommunities) model=vm model-property=isSelectedAllActionRequiredCommunities label=all layout-style=regular-square></stick-checkbox></div><div class=\"manage-action-required-communities__action-required__table__header__label manage-action-required-communities__action-required__table__header__owner\" ng-click=\"vm.sortByProps(\'name\', true)\">Community Name <span class=manage-action-required-communities__pending-approval__table__sort-icon ng-class=\"propertyActionRequiredName === \'name\' && !reverse ? \'icon-icons_chevron-up\' : \'icon-icons_chevron-down\'\"></span></div><div class=\"manage-action-required-communities__action-required__table__header__label manage-action-required-communities__action-required__table__header__privacy\" ng-click=\"vm.sortByProps(\'is_private\', true)\">Privacy <span class=manage-action-required-communities__pending-approval__table__sort-icon ng-class=\"propertyActionRequiredName === \'is_private\' && !reverse ? \'icon-icons_chevron-up\' : \'icon-icons_chevron-down\'\"></span></div><div class=\"manage-action-required-communities__action-required__table__header__label manage-action-required-communities__action-required__table__header__permissions\" ng-click=\"vm.sortByProps(\'start_discussion_permission\', true)\">Permissions <span class=manage-action-required-communities__pending-approval__table__sort-icon ng-class=\"propertyActionRequiredName === \'start_discussion_permission\' && !reverse ? \'icon-icons_chevron-up\' : \'icon-icons_chevron-down\'\"></span></div><div class=manage-action-required-communities__action-required__table__header__admin>Admin</div><div class=\"manage-action-required-communities__action-required__table__header__label manage-action-required-communities__action-required__table__header__date-created\" ng-click=\"vm.sortByProps(\'inserted_at\', true)\">Date created <span class=manage-action-required-communities__pending-approval__table__sort-icon ng-class=\"propertyActionRequiredName === \'inserted_at\' && !reverse ? \'icon-icons_chevron-up\' : \'icon-icons_chevron-down\'\"></span></div><div class=manage-action-required-communities__action-required__table__header__action-required>Status</div><div class=manage-action-required-communities__action-required__table__header__more>More</div></div><community-list-view ng-repeat=\"community in vm.actionRequiredCommunities\" class=manage-action-required-communities__action-required__table__body ng-class=\"{\'actived\': community.selected}\" community=community on-toggle-selected=vm.onSelectActionRequiredCommunity(community) type=action-required on-community-clicked=\"vm.onCommunityClicked(community, \'action-required\')\" on-manage-clicked=\"vm.onCommunityClicked(community, \'manage\')\"></community-list-view></div><div ng-if=\"!vm.actionRequiredCommunities.length && !vm.searchParamsActionRequired.keyword\" class=manage-action-required-communities__action-required__empty-section>You do not have any action required communities.</div><div ng-if=\"!vm.actionRequiredCommunities.length && vm.searchParamsActionRequired.keyword\" class=manage-action-required-communities__action-required__empty-section>No result.</div><custom-paging-style ng-if=!vm.spinnerActionRequired.isVisible options=vm.customPagingOptions custom-class=manage-action-required-communities__data-control total-items=vm.totalActionRequiredCommunities total-pages=vm.totalActionRequiredPage on-page-changed=vm.onActionRequiredCommunitiesListChanged(data) on-page-size-changed=vm.onPageSizeActionRequiredCommunitiesChanged(data) show-items=vm.searchParamsActionRequired.page_size current-page=vm.searchParamsActionRequired.page></custom-paging-style></div></section><section ng-show=vm.isCommunityDetailsViewOpen class=\"fade-out manage-action-required-communities__community-detail-wrapper\"><community-detail-compile-template ng-if=\"vm.selectedCommunity && vm.contextCompileTemplate != \'manage\'\" community=vm.selectedCommunity on-closed=vm.onCommunityDetailsViewClosed() context={{vm.contextCompileTemplate}} on-status-changed=\"vm.onCommunityGridChanged(community, vm.contextCompileTemplate)\"></community-detail-compile-template><community-detail-edit-compile-template ng-if=\"vm.selectedCommunity && vm.contextCompileTemplate === \'manage\'\" community=vm.selectedCommunity on-closed=vm.onCommunityDetailsViewClosed() context={{vm.contextCompileTemplate}} on-status-changed=\"vm.onCommunityGridChanged(community, vm.contextCompileTemplate)\"></community-detail-edit-compile-template></section></div>");
$templateCache.put("app/components/manage-communities/manage-deactivated-communities/manage-deactivated-communities.html","<div class=manage-deactivated-communities><section class=manage-deactivated-communities__deactivated><div class=manage-deactivated-communities__deactivated__toggle-control><span class=manage-deactivated-communities__deactivated__toggle-control__label>{{(\'deactivated\' | translate) + \' (\' + vm.totalDeactivatedCommunities + \')\'}}</span></div><div class=manage-deactivated-communities__deactivated__toggle><div class=manage-deactivated-communities__deactivated__subcontent ng-bind-html=\"\'manage-deactivated-community-description\' | translate\"></div><div class=manage-deactivated-communities__deactivated__table-control><div class=manage-deactivated-communities__deactivated__table-control__search><div class=\"manage-deactivated-communities__deactivated__table-control__search__input__icon icon-icons_search\"></div><input type=text class=manage-deactivated-communities__deactivated__table-control__search__input placeholder=\"{{\'search-community\' | translate}}\" ng-change=vm.onSearchCommunity() ng-model=vm.searchCommunityString></div></div><div ng-if=\"vm.selecedDeactivatedCommunities.length && vm.isOpenNotification\" class=manage-deactivated-communities__deactivated__notification><div class=manage-deactivated-communities__deactivated__notification__number-selected><span class=manage-deactivated-communities__deactivated__notification__number-selected__value>{{vm.selecedDeactivatedCommunities.length}}</span> selected</div><div class=manage-deactivated-communities__deactivated__notification__first-control ng-click=vm.onReactivateCommunities(vm.selecedDeactivatedCommunities)>Reactivate selected</div><div class=\"manage-deactivated-communities__deactivated__notification__close-button icon-icons_close\" ng-click=vm.onCloseNotification()></div></div><div class=manage-deactivated-communities__deactivated__table><div class=manage-deactivated-communities__deactivated__table__header><div ng-if=vm.isAdmin class=manage-deactivated-communities__deactivated__table__header__select><stick-checkbox on-changed=vm.onSelectAllDeactivatedCommunities(vm.isSelectedAllDeactivatedCommunities) model=vm model-property=isSelectedAllDeactivatedCommunities label=all layout-style=regular-square></stick-checkbox></div><div class=manage-deactivated-communities__deactivated__table__header__owner>Community Name</div><div class=manage-deactivated-communities__deactivated__table__header__privacy>Privacy</div><div class=manage-deactivated-communities__deactivated__table__header__member>Members</div><div class=manage-deactivated-communities__deactivated__table__header__event>Events</div><div class=manage-deactivated-communities__deactivated__table__header__post>Posts</div><div class=manage-deactivated-communities__deactivated__table__header__admin>Admin</div><div class=manage-deactivated-communities__deactivated__table__header__date-created>Date created</div><div class=manage-deactivated-communities__deactivated__table__header__strike>Strikes</div><div ng-if=vm.isAdmin class=manage-deactivated-communities__deactivated__table__header__more></div></div><community-list-view ng-repeat=\"community in vm.deactivatedCommunities\" class=manage-deactivated-communities__deactivated__table__body ng-class=\"{\'actived\': community.selected}\" community=community on-toggle-selected=vm.onSelectDeactivatedCommunity(community) type=deactivate on-community-clicked=vm.onCommunityClicked(community) on-status-changed=vm.onDeactivatedCommunityGridChanged(community)></community-list-view></div><div ng-if=\"!vm.deactivatedCommunities.length && !vm.searchParams.keyword\" class=manage-deactivated-communities__deactivated__empty-section>You do not have any communities.</div><div ng-if=\"!vm.deactivatedCommunities.length && vm.searchParams.keyword\" class=manage-deactivated-communities__deactivated__empty-section>No result.</div><custom-paging-style ng-if=!vm.spinner.isVisible options=vm.customPagingOptions custom-class=manage-deactivated-communities__data-control total-items=vm.totalDeactivatedCommunities total-pages=vm.totalDeactivatedPage on-page-changed=vm.onDeactivatedCommunitiesListChanged(data) on-page-size-changed=vm.onPageSizeDeactivatedCommunitiesChanged(data) show-items=vm.searchParams.page_size current-page=vm.searchParams.page></custom-paging-style></div></section><section ng-show=vm.isCommunityDetailsViewOpen class=\"fade-out manage-deactivated-communities__community-detail-wrapper\"><community-detail-compile-template ng-if=vm.selectedCommunity community=vm.selectedCommunity on-closed=vm.onCommunityDetailsViewClosed() context=deactivate on-status-changed=vm.onDeactivatedCommunityGridChanged(community)></community-detail-compile-template></section></div>");
$templateCache.put("app/components/manage-communities/manage-active-communities/manage-active-communities.html","<div class=manage-active-communities><section class=manage-active-communities__active><div class=manage-active-communities__active__toggle-control><span class=manage-active-communities__active__toggle-control__label>{{(\'active\' | translate) + \' (\' + vm.totalActiveCommunities + \')\'}}</span></div><div class=manage-active-communities__active__toggle><div class=manage-active-communities__active__subcontent ng-bind-html=\"\'manage-active-community-description\' | translate\"></div><div class=manage-active-communities__active__table-control><div class=manage-active-communities__active__table-control__search><div class=\"manage-active-communities__active__table-control__search__input__icon icon-icons_search\"></div><input type=text class=manage-active-communities__active__table-control__search__input placeholder=\"{{\'search-community\' | translate}}\" ng-change=vm.onSearchCommunity() ng-model=vm.searchCommunityString></div></div><div ng-if=\"vm.selecedActiveCommunities.length && vm.isOpenNotification\" class=manage-active-communities__active__notification><div class=manage-active-communities__active__notification__number-selected><span class=manage-active-communities__active__notification__number-selected__value>{{vm.selecedActiveCommunities.length}}</span> selected</div><div class=manage-active-communities__active__notification__first-control ng-click=vm.onMoveInReviewCommunities(vm.selecedActiveCommunities)>Move to In Review</div><div class=manage-active-communities__active__notification__second-control ng-click=vm.onDeactiveCommunities(vm.selecedActiveCommunities)>Deactivate selected</div><div class=\"manage-active-communities__active__notification__close-button icon-icons_close\" ng-click=vm.onCloseNotification()></div></div><div class=manage-active-communities__active__table><div class=manage-active-communities__active__table__header><div ng-if=vm.isAdmin class=manage-active-communities__active__table__header__select><stick-checkbox on-changed=vm.onSelectAllActiveCommunities(vm.isSelectedAllActiveCommunities) model=vm model-property=isSelectedAllActiveCommunities label=all layout-style=regular-square></stick-checkbox></div><div class=\"manage-active-communities__active__table__header__label manage-active-communities__active__table__header__owner\" ng-click=\"vm.sortByProps(\'name\')\">Community Name <span class=manage-pending-communities__pending-approval__table__sort-icon ng-class=\"propertyName === \'name\' && !reverse ? \'icon-icons_chevron-up\' : \'icon-icons_chevron-down\'\"></span></div><div class=\"manage-active-communities__active__table__header__label manage-active-communities__active__table__header__privacy\" ng-click=\"vm.sortByProps(\'is_private\')\">Privacy <span class=manage-pending-communities__pending-approval__table__sort-icon ng-class=\"propertyName === \'is_private\' && !reverse ? \'icon-icons_chevron-up\' : \'icon-icons_chevron-down\'\"></span></div><div class=\"manage-active-communities__active__table__header__label manage-active-communities__active__table__header__member\" ng-click=\"vm.sortByProps(\'member_count\')\">Members <span class=manage-pending-communities__pending-approval__table__sort-icon ng-class=\"propertyName === \'member_count\' && !reverse ? \'icon-icons_chevron-up\' : \'icon-icons_chevron-down\'\"></span></div><div class=\"manage-active-communities__active__table__header__label manage-active-communities__active__table__header__event\" ng-click=\"vm.sortByProps(\'event_count\')\">Events <span class=manage-pending-communities__pending-approval__table__sort-icon ng-class=\"propertyName === \'event_count\' && !reverse ? \'icon-icons_chevron-up\' : \'icon-icons_chevron-down\'\"></span></div><div class=\"manage-active-communities__active__table__header__label manage-active-communities__active__table__header__post\" ng-click=\"vm.sortByProps(\'post_count\')\">Posts <span class=manage-pending-communities__pending-approval__table__sort-icon ng-class=\"propertyName === \'post_count\' && !reverse ? \'icon-icons_chevron-up\' : \'icon-icons_chevron-down\'\"></span></div><div class=manage-active-communities__active__table__header__admin>Admin</div><div class=\"manage-active-communities__active__table__header__label manage-active-communities__active__table__header__date-created\" ng-click=\"vm.sortByProps(\'inserted_at\')\">Date created <span class=manage-pending-communities__pending-approval__table__sort-icon ng-class=\"propertyName === \'inserted_at\' && !reverse ? \'icon-icons_chevron-up\' : \'icon-icons_chevron-down\'\"></span></div><div class=manage-active-communities__active__table__header__strike>Strikes</div><div ng-if=!vm.isAdmin class=manage-active-communities__active__table__header__controls></div><div class=manage-active-communities__active__table__header__more></div></div><community-list-view ng-repeat=\"community in vm.activeCommunities\" class=manage-active-communities__active__table__body ng-class=\"{\'actived\': community.selected}\" community=community on-toggle-selected=vm.onSelectActiveCommunity(community) type=active on-community-clicked=\"vm.onCommunityClicked(community, \'active\')\" on-status-changed=vm.onActiveCommunityGridChanged(community) on-manage-clicked=\"vm.onCommunityClicked(community, \'manage\')\"></community-list-view></div><div ng-if=\"!vm.activeCommunities.length && !vm.searchParams.keyword\" class=manage-active-communities__active__empty-section>You do not have any communities.</div><div ng-if=\"!vm.activeCommunities.length && vm.searchParams.keyword\" class=manage-active-communities__active__empty-section>No result.</div><custom-paging-style ng-if=!vm.spinner.isVisible options=vm.customPagingOptions custom-class=manage-active-communities__data-control total-items=vm.totalActiveCommunities total-pages=vm.totalActivePage on-page-changed=vm.onActiveCommunitiesListChanged(data) on-page-size-changed=vm.onPageSizeActiveCommunitiesChanged(data) show-items=vm.searchParams.page_size current-page=vm.searchParams.page></custom-paging-style></div></section><section ng-show=vm.isCommunityDetailsViewOpen class=\"fade-out manage-active-communities__community-detail-wrapper\"><community-detail-compile-template ng-if=\"vm.selectedCommunity && vm.contextCompileTemplate != \'manage\'\" community=vm.selectedCommunity on-closed=vm.onCommunityDetailsViewClosed() context={{vm.contextCompileTemplate}} on-status-changed=vm.onActiveCommunityGridChanged(community)></community-detail-compile-template><community-detail-edit-compile-template ng-if=\"vm.selectedCommunity && vm.contextCompileTemplate === \'manage\'\" community=vm.selectedCommunity on-closed=vm.onCommunityDetailsViewClosed() context={{vm.contextCompileTemplate}} on-status-changed=vm.onActiveCommunityGridChanged(community)></community-detail-edit-compile-template></section></div>");
$templateCache.put("app/components/manage-communities/manage-invited-communities/manage-invited-communities.html","<div class=manage-invited-communities><section class=manage-invited-communities__content><div class=manage-invited-communities__content__table-control><div class=manage-invited-communities__content__table-control__search><div class=\"manage-invited-communities__content__table-control__search__input__icon icon-icons_search\"></div><input type=text class=manage-invited-communities__content__table-control__search__input placeholder=\"{{\'search-community\' | translate}}\" ng-change=vm.onSearchCommunity() ng-model=vm.searchCommunityString></div></div><div ng-if=\"vm.selectedCommunities.length && vm.isOpenNotification\" class=manage-invited-communities__content__notification><div class=manage-invited-communities__content__notification__number-selected><span class=manage-invited-communities__content__notification__number-selected__value>{{vm.selectedCommunities.length}}</span> selected</div><div class=manage-invited-communities__content__notification__first-control ng-click=vm.onDeclineCommunities(vm.selectedCommunities)>Decline selected</div><div class=manage-invited-communities__content__notification__first-control ng-click=vm.onAcceptCommunities(vm.selectedCommunities)>Accept selected</div><div class=\"manage-invited-communities__content__notification__close-button icon-icons_close\" ng-click=vm.onCloseNotification()></div></div><div class=manage-invited-communities__content__table><div class=manage-invited-communities__content__table__header><div class=manage-invited-communities__content__table__header__select><stick-checkbox on-changed=vm.onSelectAllCommunities(vm.isSelectedAllCommunities) model=vm model-property=isSelectedAllCommunities label=all layout-style=regular-square></stick-checkbox></div><div class=manage-invited-communities__content__table__header__community-name ng-click=\"vm.onSortByChanged(\'name\', vm.sortNameBy)\"><span>Community Name</span> <span class=\"manage-invited-communities__content__table___sort-icon icon-chevron-up-down\"></span></div><div class=manage-invited-communities__content__table__header__owner>Owner</div><div class=manage-invited-communities__content__table__header__date-invited ng-click=\"vm.onSortByChanged(\'membership_inserted_at\', vm.sortDateBy)\"><span>Date invited</span> <span class=\"manage-invited-communities__content__table___sort-icon icon-chevron-up-down\"></span></div><div class=manage-invited-communities__content__table__header__action>Actions</div></div><community-list-view ng-repeat=\"community in vm.communities\" class=manage-invited-communities__content__table__body ng-class=\"{\'actived\': community.selected}\" community=community on-toggle-selected=vm.onSelectCommunity(community) type=invited on-community-clicked=vm.onCommunityClicked(community) on-status-changed=vm.onCommunityGridChanged(community)></community-list-view></div><div ng-if=\"!vm.communities.length && !vm.searchParams.keyword\" class=manage-invited-communities__content__empty-section>You do not have any communities.</div><div ng-if=\"!vm.communities.length && vm.searchParams.keyword\" class=manage-invited-communities__content__empty-section>No result.</div><custom-paging-style ng-if=!vm.spinner.isVisible options=vm.customPagingOptions custom-class=manage-invited-communities__data-control total-items=vm.totalCommunities total-pages=vm.totalPage on-page-changed=vm.onCommunitiesListChanged(data) on-page-size-changed=vm.onPageSizeCommunitiesChanged(data) show-items=vm.searchParams.page_size current-page=vm.searchParams.page></custom-paging-style></section><section class=manage-invited-communities__footer><a ui-sref=for-creator-page.about-community class=\"text--bold text--color-pixerf-theme\" target=_blank>Explore</a> more communities that align with your interest.</section></div>");
$templateCache.put("app/components/manage-communities/manage-inreview-communities/manage-inreview-communities.html","<div class=manage-inreview-communities><section class=manage-inreview-communities__inreview><div class=manage-inreview-communities__inreview__toggle-control><span class=manage-inreview-communities__inreview__toggle-control__label>{{(\'in-review\' | translate) + \' (\' + vm.totalInReviewCommunities + \')\'}}</span></div><div class=manage-inreview-communities__inreview__toggle><div class=manage-inreview-communities__inreview__table-control><div class=manage-inreview-communities__inreview__table-control__search><div class=\"manage-inreview-communities__inreview__table-control__search__input__icon icon-icons_search\"></div><input type=text class=manage-inreview-communities__inreview__table-control__search__input placeholder=\"{{\'search-community\' | translate}}\" ng-change=vm.onSearchCommunity() ng-model=vm.searchCommunityString></div></div><div ng-if=\"vm.selecedInreviewCommunities.length && vm.isOpenNotification\" class=manage-inreview-communities__inreview__notification><div class=manage-inreview-communities__inreview__notification__number-selected><span class=manage-inreview-communities__inreview__notification__number-selected__value>{{vm.selecedInreviewCommunities.length}}</span> selected</div><div class=manage-inreview-communities__inreview__notification__first-control ng-click=vm.onReactivateCommunities(vm.selecedInreviewCommunities)>Reactivate selected</div><div class=manage-inreview-communities__inreview__notification__second-control ng-click=vm.onDeactivateCommunities(vm.selecedInreviewCommunities)>Deactivate selected</div><div class=\"manage-inreview-communities__inreview__notification__close-button icon-icons_close\" ng-click=vm.onCloseNotification()></div></div><div class=manage-inreview-communities__inreview__table><div class=manage-inreview-communities__inreview__table__header><div ng-if=vm.isAdmin class=manage-inreview-communities__inreview__table__header__select><stick-checkbox on-changed=vm.onSelectAllInreviewCommunities(vm.isSelectedAllInreviewCommunities) model=vm model-property=isSelectedAllInreviewCommunities label=all layout-style=regular-square></stick-checkbox></div><div class=manage-inreview-communities__inreview__table__header__owner>Community Name</div><div class=manage-inreview-communities__inreview__table__header__privacy>Privacy</div><div class=manage-inreview-communities__inreview__table__header__member>Members</div><div class=manage-inreview-communities__inreview__table__header__event>Events</div><div class=manage-inreview-communities__inreview__table__header__post>Posts</div><div class=manage-inreview-communities__inreview__table__header__admin>Admin</div><div class=manage-inreview-communities__inreview__table__header__date-created>Date created</div><div class=manage-inreview-communities__inreview__table__header__strike>Strikes</div><div ng-if=vm.isAdmin class=manage-inreview-communities__inreview__table__header__more></div></div><community-list-view ng-repeat=\"community in vm.inreviewCommunities\" class=manage-inreview-communities__inreview__table__body ng-class=\"{\'actived\': community.selected}\" community=community on-toggle-selected=vm.onSelectInreviewCommunity(community) type=in-review on-community-clicked=vm.onCommunityClicked(community) on-status-changed=vm.onInreviewCommunityGridChanged(community)></community-list-view></div><div ng-if=\"!vm.inreviewCommunities.length && !vm.searchParams.keyword\" class=manage-inreview-communities__inreview__empty-section>You do not have any communities.</div><div ng-if=\"!vm.inreviewCommunities.length && vm.searchParams.keyword\" class=manage-inreview-communities__inreview__empty-section>No result.</div><custom-paging-style ng-if=!vm.spinner.isVisible options=vm.customPagingOptions custom-class=manage-inreview-communities__data-control total-items=vm.totalInReviewCommunities total-pages=vm.totalInReviewPage on-page-changed=vm.onInreviewCommunitiesListChanged(data) on-page-size-changed=vm.onPageSizeInreviewCommunitiesChanged(data) show-items=vm.searchParams.page_size current-page=vm.searchParams.page></custom-paging-style></div></section><section ng-show=vm.isCommunityDetailsViewOpen class=\"fade-out manage-inreview-communities__community-detail-wrapper\"><community-detail-compile-template ng-if=vm.selectedCommunity community=vm.selectedCommunity on-closed=vm.onCommunityDetailsViewClosed() context=in-review on-status-changed=vm.onInreviewCommunityGridChanged(community)></community-detail-compile-template></section></div>");
$templateCache.put("app/components/manage-communities/manage-joined-communities/manage-joined-communities.html","<div class=manage-joined-communities><div class=\"manage-joined-communities__header clearfix\"><div class=manage-joined-communities__header__left translate>{{\'joined-communities\'}}</div><div ng-if=\"vm.isMyProfile && vm.user.canManageCommunity\" class=\"manage-joined-communities__header__right btn btn-cancel--no-background\" ng-click=vm.onCreateCommunityClicked()><span class=\"manage-joined-communities__header__right__icon icon-icons_plus\"></span> <span class=manage-joined-communities__header__right__text>{{\'create-community\' | translate}}</span></div></div><community-grid layout={{vm.communityConst.LAYOUT.LIST_VIEW}} on-init=vm.onCreatedCommunityGridInit(instance) getter=vm.getUserCommunities() search-params=\"{\'status\': \'accepted\'}\" options=vm.communityGridOptions context={{vm.communityConst.CONTEXT.JOINED}}><div class=manage-joined-communities__content-wrapper><div class=manage-joined-communities__title ng-if=vm.isMyProfile>{{\'it-looks-like-you-havent-joined-any-community-yet\' | translate}}</div><div class=manage-joined-communities__title ng-if=!vm.isMyProfile>{{\'other-communities-not-managing\' | translate: {name: vm.user.displayName}}}</div><div class=manage-joined-communities__description translate>{{\'start-connecting-with-other-creators\'}}</div><button ng-if=vm.isMyProfile class=\"btn btn-submit manage-joined-communities__action-btn\" ng-click=vm.onCreateCommunityClicked() translate>{{\'explore-communities\'}}</button></div></community-grid></div>");
$templateCache.put("app/components/manage-communities/manage-my-communities/manage-my-communities.html","<div class=manage-my-communities><section class=manage-my-communities__content><div class=manage-my-communities__content__table-control><div class=manage-my-communities__content__table-control__search><div class=\"manage-my-communities__content__table-control__search__input__icon icon-icons_search\"></div><input type=text class=manage-my-communities__content__table-control__search__input placeholder=\"{{\'search-community\' | translate}}\" ng-change=vm.onSearchCommunity() ng-model=vm.searchCommunityString></div></div><div ng-if=\"vm.selecedDeactivatedCommunities.length && vm.isOpenNotification\" class=manage-my-communities__content__notification><div class=manage-my-communities__content__notification__number-selected><span class=manage-my-communities__content__notification__number-selected__value>{{vm.selecedDeactivatedCommunities.length}}</span> selected</div><div class=\"manage-my-communities__content__notification__close-button icon-icons_close\" ng-click=vm.onCloseNotification()></div></div><div class=manage-my-communities__content__table><div class=manage-my-communities__content__table__header><div class=manage-my-communities__content__table__header__select><stick-checkbox on-changed=vm.onSelectAllDeactivatedCommunities(vm.isSelectedAllDeactivatedCommunities) model=vm model-property=isSelectedAllDeactivatedCommunities label=all layout-style=regular-square></stick-checkbox></div><div class=manage-my-communities__content__table__header__community-name ng-click=\"vm.onSortByChanged(\'name\', vm.sortNameBy)\"><span>Community Name</span> <span class=\"manage-my-communities__content__table___sort-icon icon-chevron-up-down\"></span></div><div class=manage-my-communities__content__table__header__owner>Owner</div><div class=manage-my-communities__content__table__header__date-joined ng-click=\"vm.onSortByChanged(\'membership_inserted_at\', vm.sortDateBy)\"><span>Date joined</span> <span class=\"manage-my-communities__content__table___sort-icon icon-chevron-up-down\"></span></div><div class=manage-my-communities__content__table__header__status>Status</div><div class=manage-my-communities__content__table__header__strike><span>Strikes</span> <span class=\"icon-icons-info manage-my-communities__content__table__header__strike__tooltip\" tooltip-placement=bottom-right tooltip-trigger=\"\'outsideClick\'\" uib-tooltip-html=\"\'community-strike-explain\' | translate\"></span></div><div class=manage-my-communities__content__table__header__action>Actions</div></div><community-list-view ng-repeat=\"community in vm.deactivatedCommunities\" class=manage-my-communities__content__table__body ng-class=\"{\'actived\': community.selected}\" community=community on-toggle-selected=vm.onSelectDeactivatedCommunity(community) type=my-communities on-community-clicked=vm.onCommunityClicked(community) on-manage-clicked=vm.onManageCommunityClicked(community) on-status-changed=vm.onDeactivatedCommunityGridChanged(community)></community-list-view></div><div ng-if=\"!vm.deactivatedCommunities.length && !vm.searchParams.keyword\" class=manage-my-communities__content__empty-section>You do not have any communities.</div><div ng-if=\"!vm.deactivatedCommunities.length && vm.searchParams.keyword\" class=manage-my-communities__content__empty-section>No result.</div><custom-paging-style ng-if=!vm.spinner.isVisible options=vm.customPagingOptions custom-class=manage-my-communities__data-control total-items=vm.totalDeactivatedCommunities total-pages=vm.totalDeactivatedPage on-page-changed=vm.onDeactivatedCommunitiesListChanged(data) on-page-size-changed=vm.onPageSizeDeactivatedCommunitiesChanged(data) show-items=vm.searchParams.page_size current-page=vm.searchParams.page></custom-paging-style></section><section class=manage-my-communities__footer><a ui-sref=for-creator-page.about-community class=\"text--bold text--color-pixerf-theme\" target=_blank>Explore</a> more communities that align with your interest.</section></div>");
$templateCache.put("app/components/manage-communities/manage-pending-approval-communities/manage-pending-approval-communities.html","<div class=manage-pending-approval-communities><section class=manage-pending-approval-communities__pending-approval><div class=manage-pending-approval-communities__pending-approval__toggle-control><span class=manage-pending-approval-communities__pending-approval__toggle-control__label>{{(\'pending-approval\' | translate) | toTitleCase}} {{\' (\' + vm.totalPendingCommunities + \')\'}}</span></div><div class=manage-pending-approval-communities__pending-approval__toggle><div class=manage-pending-approval-communities__pending-approval__subcontent>Approve or request changes to all new communities here.</div><div class=manage-pending-approval-communities__pending-approval__table-control><div class=manage-pending-approval-communities__pending-approval__table-control__search><div class=\"manage-pending-approval-communities__pending-approval__table-control__search__input__icon icon-icons_search\"></div><input type=text class=manage-pending-approval-communities__pending-approval__table-control__search__input placeholder=\"{{\'search-community\' | translate}}\" ng-change=vm.onSearchPendingCommunity() ng-model=vm.searchPendingCommunityString></div></div><div ng-if=\"vm.selecedPendingCommunities.length && vm.isOpenPendingNotification\" class=manage-pending-approval-communities__pending-approval__notification><div class=manage-pending-approval-communities__pending-approval__notification__number-selected><span class=manage-pending-approval-communities__pending-approval__notification__number-selected__value>{{vm.selecedPendingCommunities.length}}</span> selected</div><div class=manage-pending-approval-communities__pending-approval__notification__first-control ng-click=vm.onApproveCommunities(vm.selecedPendingCommunities)>Approve selected</div><div class=manage-pending-approval-communities__pending-approval__notification__second-control ng-click=vm.onActionRequireCommunities(vm.selecedPendingCommunities)>Request action for selected</div><div class=\"manage-pending-approval-communities__pending-approval__notification__close-button icon-icons_close\" ng-click=\"vm.onCloseNotification(\'pending\')\"></div></div><div class=manage-pending-approval-communities__pending-approval__table><div class=manage-pending-approval-communities__pending-approval__table__header><div class=manage-pending-approval-communities__pending-approval__table__header__select><stick-checkbox on-changed=vm.onSelectAllPendingCommunities(vm.isSelectedAllPendingCommunities) model=vm model-property=isSelectedAllPendingCommunities label=all layout-style=regular-square></stick-checkbox></div><div class=\"manage-pending-approval-communities__pending-approval__table__header__label manage-pending-approval-communities__pending-approval__table__header__owner\" ng-click=\"vm.sortByProps(\'name\')\">Community Name <span class=manage-pending-approval-communities__pending-approval__table__sort-icon ng-class=\"propertyName === \'name\' && !reverse ? \'icon-icons_chevron-up\' : \'icon-icons_chevron-down\'\"></span></div><div class=\"manage-pending-approval-communities__pending-approval__table__header__label manage-pending-approval-communities__pending-approval__table__header__privacy\" ng-click=\"vm.sortByProps(\'is_private\')\">Privacy <span class=manage-pending-approval-communities__pending-approval__table__sort-icon ng-class=\"propertyName === \'is_private\' && !reverse ? \'icon-icons_chevron-up\' : \'icon-icons_chevron-down\'\"></span></div><div class=\"manage-pending-approval-communities__pending-approval__table__header__label manage-pending-approval-communities__pending-approval__table__header__permissions\" ng-click=\"vm.sortByProps(\'start_discussion_permission\')\">Permissions <span class=manage-pending-approval-communities__pending-approval__table__sort-icon ng-class=\"propertyName === \'start_discussion_permission\' && !reverse ? \'icon-icons_chevron-up\' : \'icon-icons_chevron-down\'\"></span></div><div class=manage-pending-approval-communities__pending-approval__table__header__admin>Admin</div><div class=\"manage-pending-approval-communities__pending-approval__table__header__label manage-pending-approval-communities__pending-approval__table__header__date-created\" ng-click=\"vm.sortByProps(\'inserted_at\')\">Date created <span class=manage-pending-approval-communities__pending-approval__table__sort-icon ng-class=\"propertyName === \'inserted_at\' && !reverse ? \'icon-icons_chevron-up\' : \'icon-icons_chevron-down\'\"></span></div><div class=manage-pending-approval-communities__pending-approval__table__header__controls></div></div><community-list-view ng-repeat=\"community in vm.pendingCommunities\" class=manage-pending-approval-communities__pending-approval__table__body ng-class=\"{\'actived\': community.selected}\" community=community on-toggle-selected=vm.onSelectPendingCommunity(community) type=pending-approval on-community-clicked=\"vm.onCommunityClicked(community, \'pending\')\" on-status-changed=\"vm.onCommunityGridChanged(community, \'pending\')\" on-manage-clicked=\"vm.onCommunityClicked(community, \'manage\')\"></community-list-view></div><div ng-if=\"!vm.pendingCommunities.length && !vm.searchParamsPending.keyword\" class=manage-pending-approval-communities__pending-approval__empty-section>You do not have any pending approval communities.</div><div ng-if=\"!vm.pendingCommunities.length && vm.searchParamsPending.keyword\" class=manage-pending-approval-communities__pending-approval__empty-section>No result.</div><custom-paging-style ng-if=!vm.spinnerPending.isVisible options=vm.customPagingOptions custom-class=manage-pending-approval-communities__data-control total-items=vm.totalPendingCommunities total-pages=vm.totalPendingPage on-page-changed=vm.onPendingCommunitiesListChanged(data) on-page-size-changed=vm.onPageSizePendingCommunitiesChanged(data) show-items=vm.searchParamsPending.page_size current-page=vm.searchParamsPending.page></custom-paging-style></div></section><section ng-show=vm.isCommunityDetailsViewOpen class=\"fade-out manage-pending-approval-communities__community-detail-wrapper\"><community-detail-compile-template ng-if=vm.selectedCommunity community=vm.selectedCommunity on-closed=vm.onCommunityDetailsViewClosed() context={{vm.contextCompileTemplate}} on-status-changed=\"vm.onCommunityGridChanged(community, vm.contextCompileTemplate)\"></community-detail-compile-template></section></div>");
$templateCache.put("app/components/manage-communities/manage-pending-communities/manage-pending-communities.html","<div class=manage-pending-communities><section class=manage-pending-communities__content><div class=manage-pending-communities__content__table-control><div class=manage-pending-communities__content__table-control__search><div class=\"manage-pending-communities__content__table-control__search__input__icon icon-icons_search\"></div><input type=text class=manage-pending-communities__content__table-control__search__input placeholder=\"{{\'search-community\' | translate}}\" ng-change=vm.onSearchCommunity() ng-model=vm.searchCommunityString></div></div><div ng-if=\"vm.selectedCommunities.length && vm.isOpenNotification\" class=manage-pending-communities__content__notification><div class=manage-pending-communities__content__notification__number-selected><span class=manage-pending-communities__content__notification__number-selected__value>{{vm.selectedCommunities.length}}</span> selected</div><div class=manage-pending-communities__content__notification__first-control ng-click=vm.onDeleteCommunities(vm.selectedCommunities)>Delete selected</div><div class=\"manage-pending-communities__content__notification__close-button icon-icons_close\" ng-click=vm.onCloseNotification()></div></div><div class=manage-pending-communities__content__table><div class=manage-pending-communities__content__table__header><div class=manage-pending-communities__content__table__header__select><stick-checkbox on-changed=vm.onSelectAllCommunities(vm.isSelectedAllCommunities) model=vm model-property=isSelectedAllCommunities label=all layout-style=regular-square></stick-checkbox></div><div class=manage-pending-communities__content__table__header__community-name ng-click=\"vm.onSortByChanged(\'name\', vm.sortNameBy)\"><span>Community Name</span> <span class=\"manage-pending-communities__content__table___sort-icon icon-chevron-up-down\"></span></div><div class=manage-pending-communities__content__table__header__date-created ng-click=\"vm.onSortByChanged(\'inserted_at\', vm.sortDateBy)\"><span>Date created</span> <span class=\"manage-pending-communities__content__table___sort-icon icon-chevron-up-down\"></span></div><div class=manage-pending-communities__content__table__header__status ng-click=\"vm.onSortByChanged(\'status\', vm.sortStatusBy)\"><span>Status</span> <span class=\"manage-pending-communities__content__table___sort-icon icon-chevron-up-down\"></span></div><div class=manage-pending-communities__content__table__header__action-required ng-click=\"vm.onSortByChanged(\'community_reject_comments\', vm.sortReasonBy)\"><span>Action Required</span> <span class=\"manage-pending-communities__content__table___sort-icon icon-chevron-up-down\"></span></div><div class=manage-pending-communities__content__table__header__action>Actions</div></div><community-list-view ng-repeat=\"community in vm.communities\" class=manage-pending-communities__content__table__body ng-class=\"{\'actived\': community.selected}\" community=community on-toggle-selected=vm.onSelectCommunity(community) type=pending on-community-clicked=vm.onCommunityClicked(community) on-manage-clicked=vm.onManageCommunityClicked(community) on-status-changed=vm.onCommunityGridChanged(community)></community-list-view></div><div ng-if=\"!vm.communities.length && !vm.searchParams.keyword\" class=manage-my-communities__content__empty-section>You do not have any communities.</div><div ng-if=\"!vm.communities.length && vm.searchParams.keyword\" class=manage-my-communities__content__empty-section>No result.</div><custom-paging-style ng-if=!vm.spinner.isVisible options=vm.customPagingOptions custom-class=manage-pending-communities__data-control total-items=vm.totalCommunities total-pages=vm.totalPage on-page-changed=vm.onCommunitiesListChanged(data) on-page-size-changed=vm.onPageSizeCommunitiesChanged(data) show-items=vm.searchParams.page_size current-page=vm.searchParams.page></custom-paging-style></section><section class=manage-pending-communities__footer><a ui-sref=for-creator-page.about-community class=\"text--bold text--color-pixerf-theme\" target=_blank>Explore</a> more communities that align with your interest.</section></div>");
$templateCache.put("app/components/manage-communities/manage-requested-communities/manage-requested-communities.html","<div class=manage-requested-communities><section class=manage-requested-communities__content><div class=manage-requested-communities__content__table-control><div class=manage-requested-communities__content__table-control__search><div class=\"manage-requested-communities__content__table-control__search__input__icon icon-icons_search\"></div><input type=text class=manage-requested-communities__content__table-control__search__input placeholder=\"{{\'search-community\' | translate}}\" ng-change=vm.onSearchCommunity() ng-model=vm.searchCommunityString></div></div><div ng-if=\"vm.selecedRequestedCommunities.length && vm.isOpenNotification\" class=manage-requested-communities__content__notification><div class=manage-requested-communities__content__notification__number-selected><span class=manage-requested-communities__content__notification__number-selected__value>{{vm.selecedRequestedCommunities.length}}</span> selected</div><div class=manage-requested-communities__content__notification__first-control ng-click=vm.onWithdrawCommunities(vm.selecedRequestedCommunities)>Withdraw selected</div><div class=\"manage-requested-communities__content__notification__close-button icon-icons_close\" ng-click=vm.onCloseNotification()></div></div><div class=manage-requested-communities__content__table><div class=manage-requested-communities__content__table__header><div class=manage-requested-communities__content__table__header__select><stick-checkbox on-changed=vm.onSelectAllRequestedCommunities(vm.isSelectedAllRequestedCommunities) model=vm model-property=isSelectedAllRequestedCommunities label=all layout-style=regular-square></stick-checkbox></div><div class=manage-requested-communities__content__table__header__community-name ng-click=\"vm.onSortByChanged(\'name\', vm.sortNameBy)\"><span>Community Name</span> <span class=\"manage-requested-communities__content__table___sort-icon icon-chevron-up-down\"></span></div><div class=manage-requested-communities__content__table__header__owner>Owner</div><div class=manage-requested-communities__content__table__header__date-requested ng-click=\"vm.onSortByChanged(\'membership_inserted_at\', vm.sortDateBy)\"><span>Date requested</span> <span class=\"manage-requested-communities__content__table___sort-icon icon-chevron-up-down\"></span></div><div class=manage-requested-communities__content__table__header__action>Actions</div></div><community-list-view ng-repeat=\"community in vm.requestedCommunities\" class=manage-requested-communities__content__table__body ng-class=\"{\'actived\': community.selected}\" community=community on-toggle-selected=vm.onSelectRequestedCommunity(community) type=requested on-community-clicked=vm.onCommunityClicked(community) on-manage-clicked=\"vm.onCommunityClicked(community, \'manage\')\" on-status-changed=vm.onRequestedCommunityGridChanged(community)></community-list-view></div><div ng-if=\"!vm.requestedCommunities.length && !vm.searchParams.keyword\" class=manage-requested-communities__content__empty-section>You do not have any communities.</div><div ng-if=\"!vm.requestedCommunities.length && vm.searchParams.keyword\" class=manage-requested-communities__content__empty-section>No result.</div><custom-paging-style ng-if=!vm.spinner.isVisible options=vm.customPagingOptions custom-class=manage-requested-communities__data-control total-items=vm.totalRequestedCommunities total-pages=vm.totalRequestedPage on-page-changed=vm.onRequestedCommunitiesListChanged(data) on-page-size-changed=vm.onPageSizeRequestedCommunitiesChanged(data) show-items=vm.searchParams.page_size current-page=vm.searchParams.page></custom-paging-style></section><section class=manage-requested-communities__footer><a ui-sref=for-creator-page.about-community class=\"text--bold text--color-pixerf-theme\" target=_blank>Explore</a> more communities that align with your interest.</section></div>");
$templateCache.put("app/components/manage-community/edit-community/edit-community.html","<section class=manage-edit-community><div class=manage-edit-community__action-required ng-if=\"!vm.spinner.isVisible && !vm.showFinishActionRequireMessage && vm.showActionRequired\"><div class=manage-edit-community__action-required__header><span class=\"manage-edit-community__action-required__icon icon-warning-circle\"></span> <span>Action required</span></div><div class=manage-edit-community__action-required__content><div class=manage-edit-community__action-required__item ng-repeat=\"action in vm.community.community_reject_comments\"><div class=manage-edit-community__action-required__item__reason>{{action.reason}}</div><div class=manage-edit-community__action-required__item__comment>{{action.comment}}</div></div></div></div><div class=manage-edit-community__action-required-done ng-if=0><span class=manage-edit-community__action-required-done__icon><i class=\"fa fa-check\" aria-hidden=true></i> </span><span>{{\'your-changes-have-been-successfully-submitted-approval\' | translate}}</span></div><div class=manage-edit-community__header><img ng-src={{vm.community.cover.thumbnail}} class=manage-edit-community__header__cover><div class=manage-edit-community__header__right><a class=manage-edit-community__header__name>{{vm.community.name}} </a><span class=manage-edit-community__header__create-date>Created on {{vm.community.inserted_at | formatDate: \'MMM DD, YYYY\'}}</span></div></div><create-community-form community=vm.community mode=\"\'EDIT\'\" options=vm.createCommunityFormOptions form=vm.createCommunityForm dropzone-instance=vm.dropzoneInstance uploading=vm.isPhotoUploading highlight=vm.reasonListNeedUpdate on-change=vm.formOnChange()></create-community-form><spinner-win spinner=vm.spinner></spinner-win><div class=manage-edit-community__btns><div class=manage-edit-community__btns__wrapper><div class=manage-edit-community__btns__wrapper__left><button class=\"btn btn--black-magento community-detail-button-left\" ng-click=vm.deleteBtnClicked(vm.community)>{{\'delete\' | translate: {something: (\'community\' | translate)}}}</button></div><div class=manage-edit-community__btns__wrapper__right><button type=submit class=\"btn btn-cancel pixerf-btn-md community-detail-button-right\" ng-click=vm.cancelBtnClicked()>{{\'cancel\' | translate}}</button> <button type=submit class=\"btn btn-submit pixerf-btn-md community-detail-button-right\" ng-click=vm.saveBtnClicked(vm.community) loading-spinner ng-class=\"{\'is-working\': vm.isPhotoUploading}\" ng-disabled=\"!vm.formChanged || vm.isPhotoUploading || vm.spinner.isVisible || (vm.showActionRequired && !vm.isFinishActionRequired())\">{{\'submit-for-approval\' | translate}}</button></div></div></div></section>");
$templateCache.put("app/components/manage-community/manage-community-members/manage-community-members.html","<div class=manage-community-members><section><div class=manage-community-members__toggle><div class=manage-community-members__control-data><div class=manage-community-members__search><div class=\"manage-community-members__search__input__icon icon-icons_search\"></div><input type=text class=manage-community-members__search__input placeholder=\"{{\'search-members\' | translate}}\" ng-change=vm.onSearchMembers() ng-model=vm.searchMemberString></div></div><div ng-if=\"vm.selecedActiveMember.length && vm.isOpenNotification\" class=manage-community-members__notification><div class=manage-community-members__notification__number-selected><span class=manage-community-members__notification__number-selected__value>{{vm.selecedActiveCommunities.length}}</span> selected</div><div class=manage-community-members__notification__first-control ng-click=vm.onMoveInReviewCommunities(vm.selecedActiveCommunities)>Move to In Review</div><div class=manage-community-members__notification__second-control ng-click=vm.onDeactiveCommunities(vm.selecedActiveCommunities)>Deactivate selected</div><div class=\"manage-community-members__notification__close-button icon-icons_close\" ng-click=vm.onCloseNotification()></div></div><div class=manage-community-members__table><div class=manage-community-members__table__header><div ng-if=\"vm.isAdmin && 0\" class=manage-community-members__table__header__select><stick-checkbox on-changed=vm.onSelectAllActiveCommunities(vm.isSelectedAllActiveCommunities) model=vm model-property=isSelectedAllActiveCommunities label=all layout-style=regular-square></stick-checkbox></div><div class=\"manage-community-members__table__header__label manage-community-members__table__header__creator-name\" ng-click=\"vm.sortByProps(\'displayName\')\">Creator Name <span class=\"manage-pending-communities__pending-approval__table__sort-icon icon-chevron-up-down\"></span></div><div class=\"manage-community-members__table__header__label manage-community-members__table__header__admin\" ng-click=\"vm.sortByProps(\'is_private\')\" ng-if=vm.showAdmin>Admin <span class=\"manage-pending-status-approval__table__sort-icon icon-chevron-up-down\"></span></div><div class=\"manage-community-members__table__header__label manage-community-members__table__header__creator-type\">Creator Type<grid-filter-sort title=Filter options=vm.accountTypeFilterOptions multi-select=true sort-property=account_type reverse=vm.reverse selected=vm.selectedTypes on-changed=vm.onTypeFilterChanged(items)></grid-filter-sort></div><div class=\"manage-community-members__table__header__label manage-community-members__table__header__country\" ng-click=\"vm.sortByProps(\'country\')\">Country <span class=\"manage-pending-communities__pending-approval__table__sort-icon icon-chevron-up-down\"></span></div><div class=\"manage-community-members__table__header__label manage-community-members__table__header__specialty\">Specialty<grid-filter-sort title=Filter options=vm.specialtyFilterOptions multi-select=true selected=vm.selectedSpecialties on-changed=vm.onSpecialtyFilterChanged(items)></grid-filter-sort></div><div class=\"manage-community-members__table__header__label manage-community-members__table__header__invitation-from\" ng-click=\"vm.sortByProps(\'event_count\')\" ng-if=\"vm.showInvitationFrom \">Invitation from <span class=\"manage-pending-communities__pending-approval__table__sort-icon icon-chevron-up-down\"></span></div><div class=\"manage-community-members__table__header__label manage-community-members__table__header__member-since\" ng-click=\"vm.sortByProps(\'membership_joined_at\')\" ng-if=vm.showMemberSince>Member Since<span class=\"manage-pending-communities__pending-approval__table__sort-icon icon-chevron-up-down\"></span></div><div class=\"manage-community-members__table__header__label manage-community-members__table__header__member-since\" ng-click=\"vm.sortByProps(\'membership_joined_at\')\" ng-if=vm.showDateRequest>Date Requested<span class=\"manage-pending-communities__pending-approval__table__sort-icon icon-chevron-up-down\"></span></div><div class=\"manage-community-members__table__header__label manage-community-members__table__header__member-since\" ng-click=\"vm.sortByProps(\'membership_joined_at\')\" ng-if=vm.showDateInvited>Date Invited<span class=\"manage-pending-communities__pending-approval__table__sort-icon icon-chevron-up-down\"></span></div><div class=\"manage-community-members__table__header__label manage-community-members__table__header__member-since\" ng-click=\"vm.sortByProps(\'membership_banned_at\')\" ng-if=vm.showDateBlocked>Date Blocked<span class=\"manage-pending-communities__pending-approval__table__sort-icon icon-chevron-up-down\"></span></div><div class=\"manage-community-members__table__header__label manage-community-members__table__header__action\" ng-class=\"{\'full-size\': vm.memberShipName ==\'requested\', \'medium\': (vm.memberShipName ==\'invited\' || vm.memberShipName ==\'banned\')}\">Action</div></div><div ng-repeat=\"member in vm.members | orderBy:propertyName:vm.reverse\"><manager-member-list-view ng-class=\"{\'actived\': member.selected}\" type={{vm.stateName}} member=member on-removed=vm.onRemovedUser(member) community=vm.community on-toggle-selected=vm.onSelectActiveCommunity(member) on-member-clicked=\"vm.onCommunityClicked(member, \'active\')\" on-status-changed=vm.onStatusChanged(member) , can-set-manager=vm.isUserManager on-manage-clicked=\"vm.onCommunityClicked(community, \'manage\')\"></manager-member-list-view></div><scroll-paging spinner=vm.spinner is-last-page=vm.isLastPage message=\"No more communities.\"></scroll-paging><custom-paging-style ng-if=\"vm.totalMembers  && !vm.spinner.isVisible\" options=vm.customPagingOptions custom-class=manage-community-members__data-control total-items=vm.totalMembers total-pages=vm.totalPage on-page-changed=vm.onListChanged(data) on-page-size-changed=vm.onPageSizeChanged(data) show-items=vm.searchParams.page_size current-page=vm.searchParams.page></custom-paging-style></div></div></section><section ng-show=vm.isCommunityDetailsViewOpen class=\"fade-out manage-community-members__community-detail-wrapper\"><community-detail-compile-template ng-if=\"vm.selectedCommunity && vm.contextCompileTemplate != \'manage\'\" community=vm.selectedCommunity on-closed=vm.onCommunityDetailsViewClosed() context={{vm.contextCompileTemplate}} on-status-changed=vm.onActiveCommunityGridChanged(community)></community-detail-compile-template><community-detail-edit-compile-template ng-if=\"vm.selectedCommunity && vm.contextCompileTemplate === \'manage\'\" community=vm.selectedCommunity on-closed=vm.onCommunityDetailsViewClosed() context={{vm.contextCompileTemplate}} on-status-changed=vm.onActiveCommunityGridChanged(community)></community-detail-edit-compile-template></section></div>");
$templateCache.put("app/components/manage-community/manage-community-reports/manage-community-reports.html","<div class=manage-community-reports><div class=manage-community-reports__reported-posts-action-required ng-if=\"vm.status ==\'reported-posts-action-required\'\"><div class=manage-community-reports__reported-posts-action-required__page-desc><span translate>{{\'view-and-manage-pending-reports-here\'}}</span><br><span translate>{{\'you-are-encouraged-to-resolve-or-take-necessary-action-on-these-reports-quickly\'}}</span></div><div class=manage-community-reports__reported-posts-action-required__header-post>Reported Posts on Community Page</div><div class=manage-community-reports__reported-posts-action-required__content><div ng-if=vm.reports.length class=manage-community-reports__report-item infinite-scroll-disabled=vm.isLastPage infinite-scroll=vm.fetchMoreDiscussions() infinite-scroll-immediate-check=false><report-item ng-repeat=\"report in vm.reports\" report=report ng-if=report.discussion arrange-by=\"{{vm.arrangeBy.arrangeBy || vm.defaultArrangeBy.arrangeBy}}\" on-removed=vm.onDiscussionRemoved(report) on-remove-from-community=vm.onRemoveFromCommunity(report.user) on-block-from-community=vm.onBlockFromCommunity(report.user) on-remove-post=vm.onRemovePost(report) on-keep-post=vm.onKeepPost(report)></report-item></div></div></div><div class=manage-community-reports__past-reported-posts ng-if=\"vm.status ==\'past-reported-posts\'\"><div class=manage-community-reports__past-reported-posts__page-desc><span translate>{{\'view-and-manage-past-reports-here\'}}</span></div><section class=manage-community-reports__past-reported-posts><div class=manage-community-reports__past-reported-posts__toggle><div class=manage-community-reports__past-reported-posts__control-data><div class=manage-community-reports__past-reported-posts__search><div class=\"manage-community-reports__past-reported-posts__search__input__icon icon-icons_search\"></div><input type=text class=manage-community-reports__past-reported-posts__search__input placeholder=\"{{\'search-reports\' | translate}}\" ng-change=vm.onSearchPastReport() ng-model=vm.searchPastReportString></div></div><div class=manage-community-reports__past-reported-posts__table><div class=manage-community-reports__past-reported-posts__table__header><!-- <div class=\"manage-community-reports__past-reported-posts__table__header__label manage-community-reports__past-reported-posts__table__header__community\"\r\n                            ng-click=\"vm.onCummunityFilterClicked()\">Report Type \r\n                            <grid-filter title=\"Filter by\" options=\"vm.communityNameFilterOptions\" multi-select=\"true\" selected=\"vm.selectedCommunities\"\r\n                                on-changed=\"vm.onFilterChanged(items)\" is-open-dll=\"vm.isOpenCommunityFilter\"></grid-filter>\r\n                        </div> --><div class=\"manage-community-reports__past-reported-posts__table__header__label manage-community-reports__past-reported-posts__table__header__type\" ng-click=\"vm.sortByProps(\'typeOfReport\')\">Report Type <span class=\"manage-community-reports__past-reported-posts__table__table__sort-icon icon-chevron-up-down\"></span></div><div class=\"manage-community-reports__past-reported-posts__table__header__label manage-community-reports__past-reported-posts__table__header__reason\" ng-click=\"vm.sortByProps(\'reason\')\">Reason for report <span class=\"manage-community-reports__past-reported-posts__table__table__sort-icon icon-chevron-up-down\"></span></div><div class=\"manage-community-reports__past-reported-posts__table__header__label manage-community-reports__past-reported-posts__table__header__reporter\" ng-click=\"vm.sortByProps(\'user.displayName\')\">Author <span class=\"manage-community-reports__past-reported-posts__table__table__sort-icon icon-chevron-up-down\"></span></div><div class=\"manage-community-reports__past-reported-posts__table__header__label manage-community-reports__past-reported-posts__table__header__event\">Relevant Event Page</div><div class=\"manage-community-reports__past-reported-posts__table__header__label manage-community-reports__past-reported-posts__table__header__date\" ng-click=\"vm.sortByProps(\'inserted_at\')\">Report date <span class=\"manage-community-reports__past-reported-posts__table__sort-icon icon-chevron-up-down\"></span></div><div class=\"manage-community-reports__past-reported-posts__table__header__label manage-community-reports__past-reported-posts__table__header__status\" ng-click=\"vm.sortByProps(\'statusText\')\">Status <span class=\"manage-community-reports__past-reported-posts__table__sort-icon icon-chevron-up-down\"></span></div><div class=\"manage-community-reports__past-reported-posts__table__header__label manage-community-reports__past-reported-posts__table__header__action\">Action</div></div><div ng-repeat=\"report in vm.reports | orderBy:propertyName:reverse\"><manage-community-report-list-view ng-class=\"{\'actived\': report.selected}\" report=report on-report-clicked=vm.onReportClicked(report)></manage-community-report-list-view></div><scroll-paging spinner=vm.spinnerPast is-last-page=vm.isLastPage message=\"No more reports.\"></scroll-paging><custom-paging-style ng-if=vm.totalPastReports options=vm.customPagingOptions custom-class=manage-past-reports__data-control total-items=vm.totalPastReports total-pages=vm.totalPage on-page-changed=vm.onListChanged(data) on-page-size-changed=vm.onPageSizeChanged(data) show-items=vm.searchParams.page_size current-page=vm.searchParams.page></custom-paging-style></div></div></section><section ng-show=vm.isReportDetailsViewOpen class=\"fade-out manage-past-reports__report-detail-wrapper\"><manage-report-detail-compile-template ng-if=vm.selectedReport report=vm.selectedReport on-closed=vm.onReportDetailsViewClosed() context=past on-status-changed=vm.onReportGridChanged(data)></manage-report-detail-compile-template></section></div></div>");
$templateCache.put("app/components/manage-community/pending-posts/pending-posts.html","<div class=manager-community-pending-post><div class=manager-community-pending-post__header-top>Pending Posts for approval ({{vm.community.stats.pending_discussions || 0}})</div><div ng-if=vm.discussions.length class=manager-community-pending-post__discussions infinite-scroll-disabled=vm.isLastPage infinite-scroll=vm.fetchMoreDiscussions() infinite-scroll-immediate-check=false><discussion-item ng-repeat=\"discussion in vm.discussions\" discussion=discussion arrange-by=\"{{vm.arrangeBy.arrangeBy || vm.defaultArrangeBy.arrangeBy}}\" community=vm.community on-removed=vm.onDiscussionRemoved(discussion) on-remove-from-community=vm.onRemoveFromCommunity(discussion.user) on-block-from-community=vm.onBlockFromCommunity(discussion.user) on-approve-discussion=vm.onApproveDiscussion(discussion) on-reject-discussion=vm.onRejectDiscussion(discussion) type=managePendingPost></discussion-item></div></div>");
$templateCache.put("app/components/manage-event/edit-event/edit-event.html","<section class=manage-edit-event><div class=manage-edit-event-content><form name=createEventForm><section class=manage-edit-event-content__general><div class=manage-edit-event-content__general__header>{{ vm.event.id ? (\'Edit \') + vm.itemTypeUpercase : (\'Create \' + vm.itemTypeUpercase)}}</div><div class=manage-edit-event-content__general__upload><div ng-if=\"vm.eventCover && vm.eventCover.url\" class=overlay-reselect ng-click=vm.showUploadAvatarPopup()><button class=\"btn btn-submit\">Reselect</button></div><div ng-if=\"vm.eventCover && vm.eventCover.url\" class=manage-edit-event-content__general__upload__thumbnail-section><img class=manage-edit-event-content__general__upload__thumbnail-section__image ng-src=\"{{vm.eventCover.url ?  vm.eventCover.url : \'/assets/images/default/community-default-avatar.png\'}}\"></div><div ng-if=\"!vm.eventCover || !vm.eventCover.url\" class=manage-edit-event-content__general__upload__submit-btn ng-click=vm.showUploadAvatarPopup()><div class=\"btn btn-submit\">{{\'select-photo\' | translate}}</div></div></div><div class=manage-edit-event-content__general__label>Tell us more about this {{vm.itemTypeUpercase}}</div><div class=manage-edit-event-content__general__event-section><mutiline-dropdown items=vm.eventTypes selected=vm.defaultEventType on-changed=vm.onEventTypeChanged(data)></mutiline-dropdown></div><div class=manage-edit-event-content__general__name__wrapper><label required for=name class=manage-edit-event-content__general__name__label ng-class=\"(!createEventForm.$pristine || vm.event.id) && createEventForm.name.$invalid ? \'text--color-error\' : \'text--color-black\'\">{{vm.itemTypeUpercase}} Name</label><input type=text placeholder=\"E.g. Drone Photography Workshop\" name=name class=manage-edit-event-content__general__name__input ng-model=vm.event.name required></div><div class=manage-edit-event-content__general__description__wrapper><div class=manage-edit-event-content__general__description__label>Description</div><textarea name=description cols=30 rows=10 placeholder=\"{{\'What is your \' + vm.itemType + \' about? Who is it for?\'}}\" class=manage-edit-event-content__general__description__input ng-model=vm.event.description></textarea></div></section><section class=manage-edit-event-content__details><div class=manage-edit-event-content__details__label>Details</div><div class=manage-edit-event-content__details__location ng-if=!vm.event.is_online><div class=manage-edit-event-content__details__location__overall><label for=location class=manage-edit-event-content__details__location__label ng-class=\"(!createEventForm.$pristine || vm.event.id) && createEventForm.location.$invalid ? \'text--color-error\' : \'text--color-black\'\">Location</label><input type=text name=location class=manage-edit-event-content__details__location__input placeholder=\"e.g. street, city, country, post code\" g-places-autocomplete ng-model=vm.event.location required></div><div class=manage-edit-event-content__details__location__venue><label for=location class=manage-edit-event-content__details__location__label>Venue</label><input type=text name=venue class=manage-edit-event-content__details__location__input placeholder=\"e.g. floor number, room number\" ng-model=vm.event.venue></div><div class=manage-edit-event-content__details__location__link><div class=manage-edit-event-content__details__online-event__checkbox-group><span class=manage-edit-event-content__details__online-event__checkbox-group__label>Registration or Broadcast Link <span class=manage-edit-event-content__details__online-event__checkbox-group__label-info>(optional)</span> </span><input type=text placeholder=\"Registration or Broadcast Link\" name=broadcast_url class=manage-edit-event-content__details__online-event__input ng-model=vm.event.broadcast_url></div></div></div><div class=manage-edit-event-content__details__online-event><label for=name class=manage-edit-event-content__details__online-event__label><stick-checkbox on-changed=\"\" model=vm.event is-disabled=vm.disableOnlineEvent class=manage-edit-event-content__details__online-event__checkbox model-property=is_online label=\"\"></stick-checkbox>This is an online {{vm.itemType}}.</label><div class=manage-edit-event-content__details__online-event__checkbox-group ng-if=vm.event.is_online><span class=manage-edit-event-content__details__online-event__checkbox-group__label>Registration or Broadcast Link</span> <input type=text placeholder=\"Registration or Broadcast Link\" name=broadcast_url class=manage-edit-event-content__details__online-event__input ng-model=vm.event.broadcast_url required></div></div><div class=manage-edit-event-content__details__time ng-repeat=\"dateTime in vm.dateTimes\"><div ng-if=\"vm.dateTimes.length > 1\" class=\"manage-edit-event-content__details__time__remove-icon icon-icons_close\" ng-click=vm.onRemoveDateTime($index)></div><div class=manage-edit-event-content__details__location__time__date><div class=manage-edit-event-content__details__location__time__date__label></div><div class=manage-edit-event-content__details__location__time__date__input><label required for=date class=manage-edit-event-content__details__location__time__date__input__label ng-class=\"(!createEventForm.$pristine || vm.event.id) && createEventForm.date.$invalid ? \'text--color-error\' : \'text--color-black\'\">Date</label><div class=pixerf-calendar-input><input type=text name=date class=form-control uib-datepicker-popup=dd/MM/yyyy ng-model=dateTime.date is-open=dateTime.calendar.isVisible close-text=Close ng-class=\"(!createEventForm.$pristine || vm.event.id) && createEventForm.date.$invalid ? \'text--color-error\' : \'text--color-black\'\" alt-input-formats=altInputFormats required> <button type=button class=pixerf-calendar-input__toggle-btn ng-click=\"dateTime.calendar.isVisible = !dateTime.calendar.isVisible\"><i class=\"glyphicon glyphicon-calendar\"></i></button></div></div></div><div class=manage-edit-event-content__details__location__time__start__wrapper><div class=manage-edit-event-content__details__location__time__start__label>Start Time</div><div class=manage-edit-event-content__details__location__time__start__input><timer-dropdown model=dateTime.start_time options=vm.timerOptions></timer-dropdown></div></div><div class=manage-edit-event-content__details__location__time__end__wrapper><div class=manage-edit-event-content__details__location__time__end__label>End Time</div><div class=manage-edit-event-content__details__location__time__end__input><timer-dropdown model=dateTime.end_time options=vm.timerOptions></timer-dropdown></div></div></div><div class=manage-edit-event-content__details__location__time__add-more ng-click=vm.onAddDateTime()>+ Add date and time</div></section><section class=manage-edit-event-content__admission><div class=manage-edit-event-content__admission__label>Admission</div><div class=manage-edit-event-content__admission__capacity-section><mutiline-dropdown items=vm.privacyTypes selected=vm.defaultPrivacyType on-changed=vm.onPrivacyTypeChanged(data)></mutiline-dropdown></div><div class=manage-edit-event-content__admission__capacity-section><mutiline-dropdown items=vm.capacityTypes selected=vm.defaultCapacityType on-changed=vm.onCapacityTypeChanged(data)></mutiline-dropdown><div ng-if=vm.isLimitedCapacity class=manage-edit-event-content__admission__capacity-section__quantity><div class=manage-edit-event-content__admission__capacity-section__quantity__item><div class=manage-edit-event-content__admission__capacity-section__quantity__item__label>Spot(s) Available</div><input type=text ng-model=vm.event.max_attendees class=manage-edit-event-content__admission__capacity-section__quantity__item__input></div></div></div><div class=manage-edit-event-content__admission__event-type-section><mutiline-dropdown items=vm.admissionTypes selected=vm.defaultAdmission on-changed=vm.onAdmissionTypeChanged(data)></mutiline-dropdown><div ng-if=\"vm.event && (vm.event.admission_type == vm.admissionTypes[2].value)\" class=manage-edit-event-content__admission__event-type-section__ticket-url><div class=manage-edit-event-content__admission__event-type-section__ticket-url__item><span class=manage-edit-event-content__admission__event-type-section__ticket-url__item__label>Ticket URL </span><input type=text ng-model=vm.event.ticket_url class=manage-edit-event-content__admission__event-type-section__ticket-url__item__input></div></div><div ng-if=\"vm.event && (vm.event.admission_type == vm.admissionTypes[1].value)\" class=create-event-popup__admission__event-type-section__paid-event><div class=create-event-popup__admission__event-type-section__paid-event__item><stick-checkbox on-changed=vm.onCheckboxPaidEventChanged(vm.event.paid_event) model=vm.event class=create-event-popup__details__online-event__checkbox model-property=paid_event label=\"\"></stick-checkbox><label for=name class=create-event-popup__admission__event-type-section__paid-event__label>This is paid event.</label></div><div class=create-event-popup__admission__event-type-section__paid-event__item><div class=\"create-event-popup__admission__event-type-section__paid-event__input-group ticket-available\"><div class=create-event-popup__admission__event-type-section__paid-event__input-group__label>Current Tickets Available</div><div class=create-event-popup__admission__event-type-section__paid-event__input-group__input><input type=text ng-model=vm.event.max_attendees input-number-only></div></div><div class=\"create-event-popup__admission__event-type-section__paid-event__input-group ticket-price\"><div class=create-event-popup__admission__event-type-section__paid-event__input-group__label>Price</div><div class=create-event-popup__admission__event-type-section__paid-event__input-group__input><input input-number-only ng-disabled=!vm.event.paid_event placeholder=\"$ 0.00\" ng-model=vm.event.ticket_price></div></div></div></div></div></section><section class=manage-edit-event-content__post-creation><div class=manage-edit-event-content__post-creation__label>Posts Creation</div><div class=manage-edit-event-content__post-creation__permissions><label class=manage-edit-event-content__post-creation__permissions__label translate>{{\'permissions-to-create-post\'}}</label><mutiline-dropdown items=vm.postingTypes selected=vm.defaultPostingType on-changed=vm.onPostingTypeChanged(data)></mutiline-dropdown></div><div ng-if=vm.canConfigmoderation class=manage-edit-event-content__post-creation__post-approval><label class=manage-edit-event-content__post-creation__post-approval__label translate>{{\'post-approval\'}}</label><mutiline-dropdown items=vm.moderationType selected=vm.defaultModerationType on-changed=vm.onModerationTypeChanged(data)></mutiline-dropdown></div></section></form></div><div class=manage-edit-event__btns><div class=manage-edit-event__btns__wrapper><div class=manage-edit-event__btns__wrapper__left><button class=\"btn-cancel-event btn btn--black-magento community-detail-button-left pixerf-btn-md\" ng-click=vm.cancelEvent()>{{vm.isTypeClass ? \'cancel-class\' : \'cancel-event\' | translate: {something: (\'community\' | translate)}}}</button> <button class=\"btn btn--black-magento community-detail-button-left pixerf-btn-md\" ng-click=vm.deleteBtnClicked()>{{vm.isTypeClass ? \'delete-class\': \'delete-event\' | translate: {something: (\'community\' | translate)}}}</button></div><div class=manage-edit-event__btns__wrapper__right><button type=submit class=\"btn btn-cancel pixerf-btn-md community-detail-button-right\" ng-click=vm.cancelBtnClicked()>{{\'cancel-changes\' | translate}}</button> <button type=submit class=\"btn btn-submit pixerf-btn-md community-detail-button-right\" ng-click=vm.onCreateEvent(vm.community) loading-spinner ng-class=\"{\'is-working\': vm.isPhotoUploading}\" ng-disabled=\"vm.isPhotoUploading || !vm.canSaveEvent(createEventForm)\">{{\'save-changes\' |translate}}</button></div></div></div></section>");
$templateCache.put("app/components/manage-event/manage-event-members/manage-event-members.html","<div class=manage-event-members><section><div class=manage-event-members__toggle><div class=manage-event-members__control-data><div class=manage-event-members__search><div class=\"manage-event-members__search__input__icon icon-icons_search\"></div><input type=text class=manage-event-members__search__input placeholder=\"{{\'search-members\' | translate}}\" ng-change=vm.onSearchMembers() ng-model=vm.searchMemberString></div></div><div ng-if=\"vm.selecedActiveMember.length && vm.isOpenNotification\" class=manage-event-members__notification><div class=manage-event-members__notification__number-selected><span class=manage-event-members__notification__number-selected__value>{{vm.selecedActiveCommunities.length}}</span> selected</div><div class=manage-event-members__notification__first-control ng-click=vm.onMoveInReviewCommunities(vm.selecedActiveCommunities)>Move to In Review</div><div class=manage-event-members__notification__second-control ng-click=vm.onDeactiveCommunities(vm.selecedActiveCommunities)>Deactivate selected</div><div class=\"manage-event-members__notification__close-button icon-icons_close\" ng-click=vm.onCloseNotification()></div></div><div class=manage-event-members__table><div class=manage-event-members__table__header><div ng-if=vm.isAdmin class=manage-event-members__table__header__select><stick-checkbox on-changed=vm.onSelectAllActiveCommunities(vm.isSelectedAllActiveCommunities) model=vm model-property=isSelectedAllActiveCommunities label=all layout-style=regular-square></stick-checkbox></div><div class=\"manage-event-members__table__header__label manage-event-members__table__header__creator-name\" ng-click=\"vm.sortByProps(\'displayName\')\">Creator Name <span class=\"manage-pending-communities__pending-approval__table__sort-icon icon-chevron-up-down\"></span></div><div class=\"manage-event-members__table__header__label manage-event-members__table__header__admin\" ng-click=\"vm.sortByProps(\'isCommunityManager\')\" ng-if=vm.showAdmin>Admin <span class=\"manage-pending-communities__pending-approval__table__sort-icon icon-chevron-up-down\"></span></div><div class=\"manage-event-members__table__header__label manage-event-members__table__header__creator-type\" ng-click=\"vm.sortByProps(\'account_type\')\">Creator Type <span class=\"manage-pending-communities__pending-approval__table__sort-icon icon-chevron-up-down\"></span></div><div class=\"manage-event-members__table__header__label manage-event-members__table__header__country\" ng-click=\"vm.sortByProps(\'country\')\">Country <span class=\"manage-pending-communities__pending-approval__table__sort-icon icon-chevron-up-down\"></span></div><div class=\"manage-event-members__table__header__label manage-event-members__table__header__member\" ng-click=\"vm.sortByProps(\'isCommunityMember\')\">Member? <span class=\"manage-pending-communities__pending-approval__table__sort-icon icon-chevron-up-down\"></span></div><div class=\"manage-event-members__table__header__label manage-event-members__table__header__status\" ng-click=\"vm.sortByProps(\'inviteStatus\')\" ng-if=vm.showStatus>Status<span class=\"manage-pending-communities__pending-approval__table__sort-icon icon-chevron-up-down\"></span></div><div class=\"manage-event-members__table__header__label manage-event-members__table__header__action\" ng-class=\"{\'full-size\': vm.memberShipName ==\'requested\', \'medium\': (vm.memberShipName ==\'invited\' || vm.memberShipName ==\'banned\')}\">Action</div></div><div ng-repeat=\"member in vm.members | orderBy:propertyName:reverse\"><manager-event-member-list-view ng-class=\"{\'actived\': member.selected}\" type={{vm.stateName}} member=member on-removed=vm.onRemovedUser(member) community=vm.community event=vm.event on-toggle-selected=vm.onSelectActiveCommunity(member) on-member-clicked=\"vm.onCommunityClicked(member, \'active\')\" on-status-changed=vm.onStatusChanged(member) on-manage-clicked=\"vm.onCommunityClicked(community, \'manage\')\"></manager-event-member-list-view></div><scroll-paging spinner=vm.spinner is-last-page=vm.isLastPage message=\"No more communities.\"></scroll-paging><custom-paging-style ng-if=\"vm.totalMembers  && !vm.spinner.isVisible\" options=vm.customPagingOptions custom-class=manage-event-members__data-control total-items=vm.totalMembers total-pages=vm.totalPage on-page-changed=vm.onListChanged(data) on-page-size-changed=vm.onPageSizeChanged(data) show-items=vm.searchParams.page_size current-page=vm.searchParams.page></custom-paging-style></div></div></section><section ng-show=vm.isCommunityDetailsViewOpen class=\"fade-out manage-event-members__community-detail-wrapper\"><community-detail-compile-template ng-if=\"vm.selectedCommunity && vm.contextCompileTemplate != \'manage\'\" community=vm.selectedCommunity on-closed=vm.onCommunityDetailsViewClosed() context={{vm.contextCompileTemplate}} on-status-changed=vm.onActiveCommunityGridChanged(community)></community-detail-compile-template><community-detail-edit-compile-template ng-if=\"vm.selectedCommunity && vm.contextCompileTemplate === \'manage\'\" community=vm.selectedCommunity on-closed=vm.onCommunityDetailsViewClosed() context={{vm.contextCompileTemplate}} on-status-changed=vm.onActiveCommunityGridChanged(community)></community-detail-edit-compile-template></section></div>");
$templateCache.put("app/components/manage-event/manage-event-reports/manage-event-reports.html","<div class=manage-event-reports><div class=manage-event-reports__reported-posts-action-required ng-if=\"vm.status ==\'reported-posts-action-required\'\"><div class=manage-event-reports__reported-posts-action-required__page-desc><span translate>{{\'view-and-manage-pending-reports-for-your-event-posts-here\'}}</span><br><span translate>{{\'you-are-encouraged-to-resolve-or-take-necessary-action-on-these-reports-quickly\'}}</span></div><div class=manage-event-reports__reported-posts-action-required__content><div ng-if=vm.reports.length class=manage-event-reports__report-item infinite-scroll-disabled=vm.isLastPage infinite-scroll=vm.fetchMoreDiscussions() infinite-scroll-immediate-check=false><report-item ng-repeat=\"report in vm.reports\" report=report ng-if=report.discussion arrange-by=\"{{vm.arrangeBy.arrangeBy || vm.defaultArrangeBy.arrangeBy}}\" on-removed=vm.onDiscussionRemoved(report) on-remove-from-community=vm.onRemoveFromCommunity(report.user) on-block-from-community=vm.onBlockFromCommunity(report.user) on-remove-post=vm.onRemovePost(report) on-keep-post=vm.onKeepPost(report)></report-item></div></div></div><div class=manage-event-reports__past-reported-posts ng-if=\"vm.status ==\'past-reported-posts\'\"><div class=manage-event-reports__past-reported-posts__page-desc><span translate>{{\'view-and-manage-past-reports-here\'}}</span></div><section class=manage-event-reports__past-reported-posts><div class=manage-event-reports__past-reported-posts__toggle><div class=manage-event-reports__past-reported-posts__control-data><div class=manage-event-reports__past-reported-posts__search><div class=\"manage-event-reports__past-reported-posts__search__input__icon icon-icons_search\"></div><input type=text class=manage-event-reports__past-reported-posts__search__input placeholder=\"{{\'search-reports\' | translate}}\" ng-change=vm.onSearchPastReport() ng-model=vm.searchPastReportString></div></div><div class=manage-event-reports__past-reported-posts__table><div class=manage-event-reports__past-reported-posts__table__header><div class=\"manage-event-reports__past-reported-posts__table__header__label manage-event-reports__past-reported-posts__table__header__type\">Report Type<grid-filter title=\"Filter by\" options=vm.typeFilterOptions multi-select=true selected=vm.selectedTypes on-changed=vm.onTypeFilterChanged(items)></grid-filter></div><div class=\"manage-event-reports__past-reported-posts__table__header__label manage-event-reports__past-reported-posts__table__header__reason\">Reason for report<grid-filter title=\"Filter by\" options=vm.reasonFilterOptions multi-select=true selected=vm.selectedReasons on-changed=vm.onReasonFilterChanged(items)></grid-filter></div><div class=\"manage-event-reports__past-reported-posts__table__header__label manage-event-reports__past-reported-posts__table__header__reporter\">Author</div><div class=\"manage-event-reports__past-reported-posts__table__header__label manage-event-reports__past-reported-posts__table__header__event\">Relevant Event Page<grid-filter title=\"Filter by\" options=vm.typeFilterOptions multi-select=true selected=vm.selectedTypes on-changed=vm.onTypeFilterChanged(items)></grid-filter></div><div class=\"manage-event-reports__past-reported-posts__table__header__label manage-event-reports__past-reported-posts__table__header__date\" ng-click=\"vm.sortByProps(\'inserted_at\')\">Report date<span class=manage-event-reports__past-reported-posts__table__sort-icon ng-class=\"propertyName === \'inserted_at\' && !reverse ? \'icon-icons_chevron-up\' : \'icon-icons_chevron-down\'\"></span></div><div class=\"manage-event-reports__past-reported-posts__table__header__label manage-event-reports__past-reported-posts__table__header__status\">Status</div><div class=\"manage-event-reports__past-reported-posts__table__header__label manage-event-reports__past-reported-posts__table__header__action\">Action</div></div><div ng-repeat=\"report in vm.reports | orderBy:propertyName:reverse\"><manage-community-report-list-view ng-class=\"{\'actived\': report.selected}\" report=report on-report-clicked=vm.onReportClicked(report)></manage-community-report-list-view></div><scroll-paging spinner=vm.spinnerPast is-last-page=vm.isLastPage message=\"No more reports.\"></scroll-paging><custom-paging-style ng-if=vm.totalPastReports options=vm.customPagingOptions custom-class=manage-past-reports__data-control total-items=vm.totalPastReports total-pages=vm.totalPastPage on-page-changed=vm.onPastReportsListChanged(data) on-page-size-changed=vm.onPageSizePastReportsChanged(data) show-items=vm.searchParams.page_size current-page=vm.searchParams.page></custom-paging-style></div></div></section><section ng-show=vm.isReportDetailsViewOpen class=\"fade-out manage-past-reports__report-detail-wrapper\"><manage-report-detail-compile-template ng-if=vm.selectedReport report=vm.selectedReport on-closed=vm.onReportDetailsViewClosed() context=past on-status-changed=vm.onReportGridChanged(data)></manage-report-detail-compile-template></section></div></div>");
$templateCache.put("app/components/manage-event/pending-posts/pending-posts.html","<div class=manager-community-pending-post><div class=manager-community-pending-post__header-top>Pending Event/Class Posts for approval ({{vm.community.post_count || 0}})</div><div ng-if=vm.posts.length class=manager-community-pending-post__discussions infinite-scroll-disabled=vm.isLastPage infinite-scroll=vm.fetchMoreDiscussions() infinite-scroll-immediate-check=false><event-post-item ng-repeat=\"post in vm.posts\" post=post arrange-by=\"{{vm.arrangeBy.arrangeBy || vm.defaultArrangeBy.arrangeBy}}\" community=vm.community on-removed=vm.onDiscussionRemoved(post) event=vm.event on-remove-from-community=vm.onRemoveFromCommunity(post.user) on-block-from-community=vm.onBlockFromCommunity(post.user) on-approve-discussion=vm.onApprovePost(post) on-reject-discussion=vm.onRejectPost(post)></event-post-item></div></div>");
$templateCache.put("app/components/manage-events/manage-draft-events/manage-draft-events.html","<div class=manage-draft-events><section class=manage-draft-events__content><div class=manage-draft-events__content__table-control><div class=manage-draft-events__content__table-control__search><div class=\"manage-draft-events__content__table-control__search__input__icon icon-icons_search\"></div><input type=text class=manage-draft-events__content__table-control__search__input placeholder=\"{{\'search-event\' | translate}}\" ng-change=vm.onSearchEvent() ng-model=vm.searchEventString></div></div><div ng-if=\"vm.selectedEvents.length && vm.isOpenNotification\" class=manage-draft-events__content__notification><div class=manage-draft-events__content__notification__number-selected><span class=manage-draft-events__content__notification__number-selected__value>{{vm.selectedEvents.length}}</span> selected</div><div class=manage-draft-events__content__notification__first-control ng-click=vm.onCreateEvents(vm.selectedEvents)>Create selected</div><div class=manage-draft-events__content__notification__second-control ng-click=vm.onDeleteEvents(vm.selectedEvents)>Delete selected</div><div class=\"manage-draft-events__content__notification__close-button icon-icons_close\" ng-click=vm.onCloseNotification()></div></div><div class=manage-draft-events__content__table><div class=manage-draft-events__content__table__header><div class=manage-draft-events__content__table__header__select><stick-checkbox on-changed=vm.onSelectAllEvents(vm.isSelectedAllEvents) model=vm model-property=isSelectedAllEvents label=all layout-style=regular-square></stick-checkbox></div><div class=manage-draft-events__content__table__header__event-name ng-click=\"vm.onSortByChanged(\'name\', vm.sortNameBy)\"><span>Event Name</span> <span class=\"manage-going-events__content__table___sort-icon icon-chevron-up-down\"></span></div><div class=manage-draft-events__content__table__header__community-name>Community</div><div class=manage-draft-events__content__table__header__draft-last-saved ng-click=\"vm.onSortByChanged(\'event_datetimes\', vm.sortDateBy)\"><span>Draft last saved</span> <span class=\"manage-going-events__content__table___sort-icon icon-chevron-up-down\"></span></div><div class=manage-draft-events__content__table__header__action>Actions</div></div><event-list-view ng-repeat=\"event in vm.events\" class=manage-draft-events__content__table__body ng-class=\"{\'actived\': event.selected}\" event=event on-toggle-selected=vm.onSelectedEvent(event) type=draft on-status-changed=vm.eventGridChanged(event)></event-list-view></div><div ng-if=\"!vm.events.length && !vm.searchParams.keywords\" class=manage-draft-events__content__empty-section>You do not have any draft events.</div><div ng-if=\"!vm.events.length && vm.searchParams.keywords\" class=manage-draft-events__content__empty-section>No result.</div><custom-paging-style ng-if=!vm.spinner.isVisible options=vm.customPagingOptions custom-class=manage-draft-events__data-control total-items=vm.totalEvents total-pages=vm.totalPage on-page-changed=vm.onEventsListChanged(data) on-page-size-changed=vm.onPageSizeEventsChanged(data) show-items=vm.searchParams.page_size current-page=vm.searchParams.page></custom-paging-style></section><section class=manage-draft-events__footer><a ui-sref=for-creator-page.about-community class=\"text--bold text--color-pixerf-theme\" target=_blank>Explore</a> more events across all Pixerf communities.</section></div>");
$templateCache.put("app/components/manage-events/manage-going-events/manage-going-events.html","<div class=manage-going-events><section class=manage-going-events__content><div class=manage-going-events__content__title>This Week</div><div class=manage-going-events__content__table-control><div class=manage-going-events__content__table-control__search><div class=\"manage-going-events__content__table-control__search__input__icon icon-icons_search\"></div><input type=text class=manage-going-events__content__table-control__search__input placeholder=\"{{\'search-event\' | translate}}\" ng-change=vm.onSearchGoingEvents() ng-model=vm.searchGoingEventsString></div></div><div ng-if=\"vm.selectedGoingEvents.length && vm.isOpenNotification\" class=manage-going-events__content__notification><div class=manage-going-events__content__notification__number-selected><span class=manage-going-events__content__notification__number-selected__value>{{vm.selectedGoingEvents.length}}</span> selected</div><div class=manage-going-events__content__notification__first-control ng-click=\"vm.onNotGoingEvents(vm.selectedGoingEvents, \'going\')\">Not Going selected</div><div class=\"manage-going-events__content__notification__close-button icon-icons_close\" ng-click=vm.onCloseNotification()></div></div><div class=manage-going-events__content__table><div class=manage-going-events__content__table__header><div class=manage-going-events__content__table__header__select><stick-checkbox on-changed=vm.onSelectAllGoingEvent(vm.isSelectedAllGoingEvent) model=vm model-property=isSelectedAllGoingEvent label=all layout-style=regular-square></stick-checkbox></div><div class=manage-going-events__content__table__header__event-name ng-click=\"vm.onSortByChanged(\'name\', vm.sortNameBy)\"><span>Event Name</span> <span class=\"manage-going-events__content__table___sort-icon icon-chevron-up-down\"></span></div><div class=manage-going-events__content__table__header__community-name>Community</div><div class=manage-going-events__content__table__header__privacy>Privacy</div><div class=manage-going-events__content__table__header__date-of-event ng-click=\"vm.onSortByChanged(\'event_datetimes\', vm.sortDateBy)\"><span>Date of Event</span> <span class=\"manage-going-events__content__table___sort-icon icon-chevron-up-down\"></span></div><div class=manage-going-events__content__table__header__going>Going</div><div class=manage-going-events__content__table__header__status>Status</div><div class=manage-going-events__content__table__header__action>Actions</div></div><event-list-view ng-repeat=\"event in vm.goingEvents\" class=manage-going-events__content__table__body ng-class=\"{\'actived\': event.selected}\" event=event on-toggle-selected=vm.onSelectedGoingEvent(event) type=going on-status-changed=vm.onGoingEventGridChanged(event)></event-list-view></div><div ng-if=\"!vm.goingEvents.length && !vm.searchParams.keywords\" class=manage-going-events__content__empty-section>You do not have any upcoming events this week.</div><div ng-if=\"!vm.goingEvents.length && vm.searchParams.keywords\" class=manage-going-events__content__empty-section>No result.</div><custom-paging-style ng-if=!vm.spinner.isVisible options=vm.customPagingOptions custom-class=manage-going-events__data-control total-items=vm.totalGoingEvents total-pages=vm.totalPage on-page-changed=vm.onGoingEventsListChanged(data) on-page-size-changed=vm.onPageSizeGoingEventsChanged(data) show-items=vm.searchParams.page_size current-page=vm.searchParams.page></custom-paging-style></section><section class=manage-going-events__content><div class=manage-going-events__content__title>Other upcoming events</div><div class=manage-going-events__content__table-control><div class=manage-going-events__content__table-control__search><div class=\"manage-going-events__content__table-control__search__input__icon icon-icons_search\"></div><input type=text class=manage-going-events__content__table-control__search__input placeholder=\"{{\'search-event\' | translate}}\" ng-change=vm.onSearchUpcomingEvents() ng-model=vm.searchUpcomingEventString></div></div><div ng-if=\"vm.selectedUpcomingEvents.length && vm.isOpenNotification\" class=manage-going-events__content__notification><div class=manage-going-events__content__notification__number-selected><span class=manage-going-events__content__notification__number-selected__value>{{vm.selectedUpcomingEvents.length}}</span> selected</div><div class=manage-going-events__content__notification__first-control ng-click=\"vm.onNotGoingEvents(vm.selectedUpcomingEvents, \'upcoming\')\">Not Going selected</div><div class=\"manage-going-events__content__notification__close-button icon-icons_close\" ng-click=vm.onCloseNotification()></div></div><div class=manage-going-events__content__table><div class=manage-going-events__content__table__header><div class=manage-going-events__content__table__header__select><stick-checkbox on-changed=vm.onSelectAllUpcomingEvent(vm.isSelectedAllUpcomingEvent) model=vm model-property=isSelectedAllUpcomingEvent label=all layout-style=regular-square></stick-checkbox></div><div class=manage-going-events__content__table__header__event-name ng-click=\"vm.onSortByChanged(\'name\', vm.sortNameBy, true)\"><span>Event Name</span> <span class=\"manage-going-events__content__table___sort-icon icon-chevron-up-down\"></span></div><div class=manage-going-events__content__table__header__community-name>Community</div><div class=manage-going-events__content__table__header__privacy>Privacy</div><div class=manage-going-events__content__table__header__date-of-event ng-click=\"vm.onSortByChanged(\'event_datetimes\', vm.sortDateBy, true)\"><span>Date of Event</span> <span class=\"manage-going-events__content__table___sort-icon icon-chevron-up-down\"></span></div><div class=manage-going-events__content__table__header__going>Going</div><div class=manage-going-events__content__table__header__status>Status</div><div class=manage-going-events__content__table__header__action>Actions</div></div><event-list-view ng-repeat=\"event in vm.upcomingEvents\" class=manage-going-events__content__table__body ng-class=\"{\'actived\': event.selected}\" event=event on-toggle-selected=vm.onSelectedUpcomingEvent(event) type=going on-status-changed=vm.onUpcomingEventGridChanged(event)></event-list-view></div><div ng-if=\"!vm.upcomingEvents.length && !vm.searchUpcomingParams.keywords\" class=manage-going-events__content__empty-section>You do not have any other upcoming events.</div><div ng-if=\"!vm.upcomingEvents.length && vm.searchUpcomingParams.keywords\" class=manage-going-events__content__empty-section>No result.</div><custom-paging-style ng-if=!vm.spinnerUpcoming.isVisible options=vm.customPagingOptions custom-class=manage-going-events__data-control total-items=vm.totalUpcomingEvents total-pages=vm.totalUpcomingPage on-page-changed=vm.onUpcomingEventListChanged(data) on-page-size-changed=vm.onPageSizeUpcomingEventChanged(data) show-items=vm.searchUpcomingParams.page_size current-page=vm.searchUpcomingParams.page></custom-paging-style></section><section class=manage-going-events__footer><a ui-sref=for-creator-page.about-community class=\"text--bold text--color-pixerf-theme\" target=_blank>Explore</a> more events across all Pixerf communities.</section></div>");
$templateCache.put("app/components/manage-events/manage-hosting-events/manage-hosting-events.html","<div class=manage-hosting-events><section class=manage-hosting-events__content><div class=manage-hosting-events__content__table-control><div class=manage-hosting-events__content__table-control__search><div class=\"manage-hosting-events__content__table-control__search__input__icon icon-icons_search\"></div><input type=text class=manage-hosting-events__content__table-control__search__input placeholder=\"{{\'search-event\' | translate}}\" ng-change=vm.onSearchEvent() ng-model=vm.searchEventString></div></div><div ng-if=\"vm.selectedEvents.length && vm.isOpenNotification\" class=manage-hosting-events__content__notification><div class=manage-hosting-events__content__notification__number-selected><span class=manage-hosting-events__content__notification__number-selected__value>{{vm.selectedEvents.length}}</span> selected</div><div class=manage-hosting-events__content__notification__first-control ng-click=vm.onDeleteEvents(vm.selectedEvents)>Delete selected</div><div class=\"manage-hosting-events__content__notification__close-button icon-icons_close\" ng-click=vm.onCloseNotification()></div></div><div class=manage-hosting-events__content__table><div class=manage-hosting-events__content__table__header><div class=manage-hosting-events__content__table__header__select><stick-checkbox on-changed=vm.onSelectAllEvents(vm.isSelectedAllEvents) model=vm model-property=isSelectedAllEvents label=all layout-style=regular-square></stick-checkbox></div><div class=manage-hosting-events__content__table__header__event-name ng-click=\"vm.onSortByChanged(\'name\', vm.sortNameBy)\"><span>Event Name</span> <span class=\"manage-going-events__content__table___sort-icon icon-chevron-up-down\"></span></div><div class=manage-hosting-events__content__table__header__community-name>Community</div><div class=manage-hosting-events__content__table__header__privacy>Privacy</div><div class=manage-hosting-events__content__table__header__date-of-event ng-click=\"vm.onSortByChanged(\'event_datetimes\', vm.sortDateBy)\"><span>Date of Event</span> <span class=\"manage-going-events__content__table___sort-icon icon-chevron-up-down\"></span></div><div class=manage-hosting-events__content__table__header__going>Going</div><div class=manage-hosting-events__content__table__header__status>Status</div><div class=manage-hosting-events__content__table__header__action>Actions</div></div><event-list-view ng-repeat=\"event in vm.events\" class=manage-hosting-events__content__table__body ng-class=\"{\'actived\': event.selected}\" event=event on-toggle-selected=vm.onSelectedEvent(event) type=hosting on-event-clicked=\"vm.onEventClicked(event, action)\" on-status-changed=vm.eventGridChanged(event) on-manage-clicked=\"vm.onEventClicked(event, \'manage\')\"></event-list-view></div><div ng-if=\"!vm.events.length && !vm.searchParams.keywords\" class=manage-hosting-events__content__empty-section>You do not have any events.</div><div ng-if=\"!vm.events.length && vm.searchParams.keywords\" class=manage-hosting-events__content__empty-section>No result.</div><custom-paging-style ng-if=!vm.spinner.isVisible options=vm.customPagingOptions custom-class=manage-hosting-events__data-control total-items=vm.totalEvents total-pages=vm.totalInvitedPage on-page-changed=vm.onEventsListChanged(data) on-page-size-changed=vm.onPageSizeEventsChanged(data) show-items=vm.searchParams.page_size current-page=vm.searchParams.page></custom-paging-style></section><section class=manage-hosting-events__footer><a ui-sref=for-creator-page.about-community class=\"text--bold text--color-pixerf-theme\" target=_blank>Explore</a> more events across all Pixerf communities.</section></div>");
$templateCache.put("app/components/manage-events/manage-in-review-events/manage-in-review-events.html","<div class=manage-in-review-events><section class=manage-in-review-events__pending-approval><div class=manage-in-review-events__pending-approval__toggle-control><span class=manage-in-review-events__pending-approval__toggle-control__label>{{(\'in-review\' | translate) | toTitleCase}} ({{$parent.vm.countTotal.total_inreview_events || 0}})</span></div><div class=\"manage-in-review-events__pending-approval__toggle collapse\" uib-collapse=!vm.isOpenPendingApproval><div class=manage-in-review-events__pending-approval__subcontent>{{\'here-you-can-view-all-events-under-review-or-investigation\' | translate}}</div><div class=manage-in-review-events__pending-approval__table-control><div class=manage-in-review-events__pending-approval__table-control__search><div class=\"manage-in-review-events__pending-approval__table-control__search__input__icon icon-icons_search\"></div><input type=text class=manage-in-review-events__pending-approval__table-control__search__input placeholder=\"{{\'search-events\' | translate}}\" ng-change=vm.onSearchOngoingEvent() ng-model=vm.searchOngoingEventString></div></div><div ng-if=\"vm.selectedEvents.length && vm.isOpenPendingNotification\" class=manage-in-review-events__pending-approval__notification><div class=manage-in-review-events__pending-approval__notification__number-selected><span class=manage-in-review-events__pending-approval__notification__number-selected__value>{{vm.selectedEvents.length}}</span> selected</div><div class=manage-in-review-events__pending-approval__notification__first-control ng-click=vm.onApproveEvents(vm.selectedEvents)>Resolve selected</div><div class=manage-in-review-events__pending-approval__notification__second-control ng-click=vm.onRejectEvents(vm.selectedEvents)>Reject selected</div><div class=\"manage-in-review-events__pending-approval__notification__close-button icon-icons_close\" ng-click=\"vm.onCloseNotification(\'pending\')\"></div></div><div class=manage-in-review-events__pending-approval__table infinite-scroll-disabled=vm.isLastActionRequiredPage infinite-scroll=vm.fetchMorePendingCommunitiesList() infinite-scroll-immediate-check=false><div class=manage-in-review-events__pending-approval__table__header><div class=\"manage-in-review-events__pending-approval__table__header__select {{\'col-order-\'+ vm.colsOrder.selectBox}}\"><stick-checkbox on-changed=vm.onSelectAllEvents(vm.isSelectedAllEvents) model=vm model-property=isSelectedAllEvents label=all layout-style=regular-square></stick-checkbox></div><div class=\"manage-in-review-events__pending-approval__table__header__label manage-in-review-events__pending-approval__table__header__event-name {{\'col-order-\'+ vm.colsOrder.eventName}}\">Event Name</div><div class=\"manage-in-review-events__pending-approval__table__header__label manage-in-review-events__pending-approval__table__header__community-name {{\'col-order-\'+ vm.colsOrder.communityName}}\" ng-click=vm.onCommunityFilterClicked()><div class=manage-in-review-events__pending-approval__table__header__label__sub-list><span>Community</span><grid-filter title=Show options=vm.communityNameFilterOptions multi-select=true on-changed=vm.onFilterChanged(items) is-open-dll=vm.isOpenCommunityFilter selected=vm.selectedCommunity></grid-filter></div></div><div class=\"manage-in-review-events__pending-approval__table__header__label manage-in-review-events__pending-approval__table__header__admin {{\'col-order-\'+ vm.colsOrder.admin}}\" ng-if=vm.showAdminColm>Admin</div><div class=\"manage-in-review-events__pending-approval__table__header__label manage-in-review-events__pending-approval__table__header__privacy {{\'col-order-\'+ vm.colsOrder.privacy}}\"><div class=manage-in-review-events__pending-approval__table__header__label__sub-list><span>Privacy</span><grid-filter title=Order options=vm.communityPrivacyFilterOptions multi-select=false on-changed=vm.sortBySelected(items)></grid-filter></div></div><div class=\"manage-in-review-events__pending-approval__table__header__label manage-in-review-events__pending-approval__table__header__date-of-event {{\'col-order-\'+ vm.colsOrder.eventTime}}\"><div class=manage-in-review-events__pending-approval__table__header__label__sub-list><span>Date of event</span><grid-filter title=Order options=vm.dateOfEventFilterOptions multi-select=false on-changed=vm.sortBySelected(items)></grid-filter></div></div><div class=\"manage-in-review-events__pending-approval__table__header__label manage-in-review-events__pending-approval__table__header__capacity {{\'col-order-\'+ vm.colsOrder.attendees}}\">Capacity</div><div class=\"manage-in-review-events__pending-approval__table__header__label manage-in-review-events__pending-approval__table__header__status {{\'col-order-\'+ vm.colsOrder.status}}\">Status</div><div class=\"manage-in-review-events__pending-approval__table__header__label manage-in-review-events__pending-approval__table__header__action {{\'col-order-\'+ vm.colsOrder.actions}}\">Action</div></div><event-list-view ng-repeat=\"event in vm.events\" class=manage-hosting-events__content__table__body ng-class=\"{\'actived\': event.selected}\" event=event on-toggle-selected=vm.onSelectedEvent(event) type=inReview on-event-clicked=\"vm.onEventClicked(event, action)\" on-status-changed=vm.onEventDetailsViewClosed(event) on-manage-clicked=\"vm.onEventClicked(event, \'manage\')\"></event-list-view></div><div ng-if=\"!vm.events.length && !vm.searchParams.keywords\" class=manage-in-review-events__content__empty-section>You do not have in review events.</div><div ng-if=\"!vm.events.length && vm.searchParams.keywords\" class=manage-in-review-events__content__empty-section>No result.</div><custom-paging-style ng-if=!vm.spinner.isVisible options=vm.customPagingOptions custom-class=manage-events__data-control total-items=vm.totalActiveEvents total-pages=vm.totalActivePage on-page-changed=vm.onListChanged(data) on-page-size-changed=vm.onPageSizeChanged(data) show-items=vm.searchParams.page_size current-page=vm.searchParams.page></custom-paging-style></div></section><section ng-show=vm.isEventDetailsViewOpen class=\"fade-out manage-in-review-events__event-detail-wrapper\"><event-detail-compile-template ng-if=vm.selectedEvent event=vm.selectedEvent on-closed=vm.onEventDetailsViewClosed(event) context=inReview options=vm.viewEventDetailOptions on-status-changed=\"vm.onCommunityGridChanged(community, vm.contextCompileTemplate)\"></event-detail-compile-template></section></div>");
$templateCache.put("app/components/manage-events/manage-interested-events/manage-interested-events.html","<div class=manage-interested-events><section class=manage-interested-events__content><div class=manage-interested-events__content__table-control><div class=manage-interested-events__content__table-control__search><div class=\"manage-interested-events__content__table-control__search__input__icon icon-icons_search\"></div><input type=text class=manage-interested-events__content__table-control__search__input placeholder=\"{{\'search-event\' | translate}}\" ng-change=vm.onSearchEvent() ng-model=vm.searchEventString></div></div><div ng-if=\"vm.selectedEvents.length && vm.isOpenNotification\" class=manage-interested-events__content__notification><div class=manage-interested-events__content__notification__number-selected><span class=manage-interested-events__content__notification__number-selected__value>{{vm.selectedEvents.length}}</span> selected</div><div class=manage-interested-events__content__notification__first-control ng-click=vm.onGoingCommunities(vm.selectedEvents)>Going selected</div><div class=\"manage-interested-events__content__notification__close-button icon-icons_close\" ng-click=vm.onCloseNotification()></div></div><div class=manage-interested-events__content__table><div class=manage-interested-events__content__table__header><div class=manage-interested-events__content__table__header__select><stick-checkbox on-changed=vm.onSelectAllEvents(vm.isSelectedAllEvents) model=vm model-property=isSelectedAllEvents label=all layout-style=regular-square></stick-checkbox></div><div class=manage-interested-events__content__table__header__event-name ng-click=\"vm.onSortByChanged(\'name\', vm.sortNameBy)\"><span>Event Name</span> <span class=\"manage-going-events__content__table___sort-icon icon-chevron-up-down\"></span></div><div class=manage-interested-events__content__table__header__community-name>Community</div><div class=manage-interested-events__content__table__header__privacy>Privacy</div><div class=manage-interested-events__content__table__header__date-of-event ng-click=\"vm.onSortByChanged(\'event_datetimes\', vm.sortDateBy)\"><span>Date of Event</span> <span class=\"manage-going-events__content__table___sort-icon icon-chevron-up-down\"></span></div><div class=manage-interested-events__content__table__header__capacity>Capacity</div><div class=manage-interested-events__content__table__header__going>Going</div><div class=manage-interested-events__content__table__header__interested>Interested</div><div class=manage-interested-events__content__table__header__action>Actions</div></div><event-list-view ng-repeat=\"event in vm.events\" class=manage-interested-events__content__table__body ng-class=\"{\'actived\': event.selected}\" event=event on-toggle-selected=vm.onSelectedEvent(event) type=interested on-status-changed=vm.eventGridChanged(event)></event-list-view></div><div ng-if=\"!vm.events.length && !vm.searchParams.keywords\" class=manage-interested-events__content__empty-section>You do not have any interested events.</div><div ng-if=\"!vm.events.length && vm.searchParams.keywords\" class=manage-interested-events__content__empty-section>No results.</div><custom-paging-style ng-if=!vm.spinner.isVisible options=vm.customPagingOptions custom-class=manage-interested-events__data-control total-items=vm.totalEvents total-pages=vm.totalInvitedPage on-page-changed=vm.onEventsListChanged(data) on-page-size-changed=vm.onPageSizeEventsChanged(data) show-items=vm.searchParams.page_size current-page=vm.searchParams.page></custom-paging-style></section><section class=manage-interested-events__footer><a ui-sref=for-creator-page.about-community class=\"text--bold text--color-pixerf-theme\" target=_blank>Explore</a> more events across all Pixerf communities.</section></div>");
$templateCache.put("app/components/manage-events/manage-invited-events/manage-invited-events.html","<div class=manage-invited-events><section class=manage-invited-events__content><div class=manage-invited-events__content__table-control><div class=manage-invited-events__content__table-control__search><div class=\"manage-invited-events__content__table-control__search__input__icon icon-icons_search\"></div><input type=text class=manage-invited-events__content__table-control__search__input placeholder=\"{{\'search-event\' | translate}}\" ng-change=vm.onSearchEvent() ng-model=vm.searchEventString></div></div><div ng-if=\"vm.selectedEvents.length && vm.isOpenNotification\" class=manage-invited-events__content__notification><div class=manage-invited-events__content__notification__number-selected><span class=manage-invited-events__content__notification__number-selected__value>{{vm.selectedEvents.length}}</span> selected</div><div class=manage-invited-events__content__notification__first-control ng-click=vm.onDeclineCommunities(vm.selectedEvents)>Decline selected</div><div class=manage-invited-events__content__notification__second-control ng-click=vm.onAcceptCommunities(vm.selectedEvents)>Accept selected</div><div class=\"manage-invited-events__content__notification__close-button icon-icons_close\" ng-click=vm.onCloseNotification()></div></div><div class=manage-invited-events__content__table><div class=manage-invited-events__content__table__header><div class=manage-invited-events__content__table__header__select><stick-checkbox on-changed=vm.onSelectAllEvents(vm.isSelectedAllEvents) model=vm model-property=isSelectedAllEvents label=all layout-style=regular-square></stick-checkbox></div><div class=manage-invited-events__content__table__header__event-name ng-click=\"vm.onSortByChanged(\'name\', vm.sortNameBy)\"><span>Event Name</span> <span class=\"manage-going-events__content__table___sort-icon icon-chevron-up-down\"></span></div><div class=manage-invited-events__content__table__header__community-name>Community</div><div class=manage-invited-events__content__table__header__privacy>Privacy</div><div class=manage-invited-events__content__table__header__date-of-event ng-click=\"vm.onSortByChanged(\'event_datetimes\', vm.sortDateBy)\"><span>Date of Event</span> <span class=\"manage-going-events__content__table___sort-icon icon-chevron-up-down\"></span></div><div class=manage-invited-events__content__table__header__going>Going</div><div class=manage-invited-events__content__table__header__interested>Interested</div><div class=manage-invited-events__content__table__header__action>Actions</div></div><event-list-view ng-repeat=\"event in vm.events\" class=manage-invited-events__content__table__body ng-class=\"{\'actived\': event.selected}\" event=event on-toggle-selected=vm.onSelectedEvent(event) type=invited on-event-clicked=\"vm.onEventClicked(event, action)\" on-status-changed=vm.onEventDetailsViewClosed(event) on-manage-clicked=\"vm.onEventClicked(event, \'manage\')\"></event-list-view></div><div ng-if=\"!vm.events.length && !vm.searchParams.keywords\" class=manage-going-events__content__empty-section>You do not have any invited events.</div><div ng-if=\"!vm.events.length && vm.searchParams.keywords\" class=manage-going-events__content__empty-section>No results.</div><custom-paging-style ng-if=!vm.spinner.isVisible options=vm.customPagingOptions custom-class=manage-invited-events__data-control total-items=vm.totalEvents total-pages=vm.totalInvitedPage on-page-changed=vm.onEventsListChanged(data) on-page-size-changed=vm.onPageSizeEventsChanged(data) show-items=vm.searchParams.page_size current-page=vm.searchParams.page></custom-paging-style></section><section class=manage-invited-events__footer><a ui-sref=for-creator-page.about-community class=\"text--bold text--color-pixerf-theme\" target=_blank>Explore</a> more events across all Pixerf communities.</section></div>");
$templateCache.put("app/components/manage-events/manage-past-events/manage-past-events.html","<div class=manage-past-events><section class=manage-past-events__content><div class=manage-past-events__content__table-control><div class=manage-past-events__content__table-control__search><div class=\"manage-past-events__content__table-control__search__input__icon icon-icons_search\"></div><input type=text class=manage-past-events__content__table-control__search__input placeholder=\"{{\'search-event\' | translate}}\" ng-change=vm.onSearchEvent() ng-model=vm.searchEventString></div></div><div class=manage-past-events__content__table><div class=manage-past-events__content__table__header><div class=manage-past-events__content__table__header__event-name ng-click=\"vm.onSortByChanged(\'name\', vm.sortNameBy)\"><span>Event Name</span> <span class=\"manage-going-events__content__table___sort-icon icon-chevron-up-down\"></span></div><div class=manage-past-events__content__table__header__community-name>Community</div><div class=manage-past-events__content__table__header__privacy>Privacy</div><div class=manage-past-events__content__table__header__date-of-event ng-click=\"vm.onSortByChanged(\'event_datetimes\', vm.sortDateBy)\"><span>Date of Event</span> <span class=\"manage-going-events__content__table___sort-icon icon-chevron-up-down\"></span></div><div class=manage-past-events__content__table__header__attended ng-click=\"vm.onSortByChanged(\'stats.going\', vm.sortStatsBy)\"><span>Attended</span> <span class=\"manage-going-events__content__table___sort-icon icon-chevron-up-down\"></span></div><div class=manage-past-events__content__table__header__host>Host?</div><div class=manage-past-events__content__table__header__status>Status</div></div><event-list-view ng-repeat=\"event in vm.events\" class=manage-past-events__content__table__body ng-class=\"{\'actived\': event.selected}\" event=event on-toggle-selected=vm.onSelectedEvent(event) type=past-events on-event-clicked=\"vm.onEventClicked(event, action)\" on-status-changed=vm.onEventDetailsViewClosed(event) on-manage-clicked=\"vm.onEventClicked(event, \'manage\')\"></event-list-view></div><div ng-if=\"!vm.events.length && !vm.searchParams.keywords\" class=manage-past-events__content__empty-section>You do not have any past events.</div><div ng-if=\"!vm.events.length && vm.searchParams.keywords\" class=manage-past-events__content__empty-section>No results.</div><custom-paging-style ng-if=!vm.spinner.isVisible options=vm.customPagingOptions custom-class=manage-past-events__data-control total-items=vm.totalEvents total-pages=vm.totalPage on-page-changed=vm.onEventsListChanged(data) on-page-size-changed=vm.onPageSizeEventsChanged(data) show-items=vm.searchParams.page_size current-page=vm.searchParams.page></custom-paging-style></section><section class=manage-past-events__footer><a ui-sref=for-creator-page.about-community class=\"text--bold text--color-pixerf-theme\" target=_blank>Explore</a> more events across all Pixerf communities.</section></div>");
$templateCache.put("app/components/manage-reports/manage-past-reports/manage-past-reports.html","<div class=manage-past-reports><section class=manage-past-reports__past><div class=manage-past-reports__past__toggle-control__label>{{(\'past\' | translate) | toTitleCase}} <span ng-if=vm.totalPastReports>({{vm.totalPastReports}})</span></div><div class=manage-past-reports__past__toggle><div class=manage-past-reports__past__subcontent><div>View and manage all past reports here.</div></div><div class=manage-past-reports__past__control-data><div class=manage-past-reports__past__control-data__label translate>{{\'sort-by\'}}:</div><mutiline-dropdown items=vm.sortBy selected=vm.defaultSortBy on-changed=vm.onSortByChanged(data) class=manage-past-reports__past__control-data__dropdown></mutiline-dropdown><div class=manage-past-reports__past__spacing></div><div class=manage-past-reports__past__search><div class=\"manage-past-reports__past__search__input__icon icon-icons_search\"></div><input type=text class=manage-past-reports__past__search__input placeholder=\"{{\'search-reports\' | translate}}\" ng-change=vm.onSearchPastReport() ng-model=vm.searchPastReportString></div></div><div class=manage-past-reports__past__table><div class=manage-past-reports__past__table__header><div class=\"manage-past-reports__past__table__header__label manage-past-reports__past__table__header__community\" ng-click=vm.onCummunityFilterClicked()>Community Name<grid-filter title=\"Filter by\" options=vm.communityNameFilterOptions multi-select=true selected=vm.selectedCommunities on-changed=vm.onFilterChanged(items) is-open-dll=vm.isOpenCommunityFilter></grid-filter></div><div class=\"manage-past-reports__past__table__header__label manage-past-reports__past__table__header__reason\">Reason for report<grid-filter title=\"Filter by\" options=vm.reasonFilterOptions multi-select=true selected=vm.selectedReasons on-changed=vm.onReasonFilterChanged(items)></grid-filter></div><div class=\"manage-past-reports__past__table__header__label manage-past-reports__past__table__header__type\">Type of report<grid-filter title=\"Filter by\" options=vm.typeFilterOptions multi-select=true selected=vm.selectedTypes on-changed=vm.onTypeFilterChanged(items)></grid-filter></div><div class=\"manage-past-reports__past__table__header__label manage-past-reports__past__table__header__reporter\">Reporter</div><div class=\"manage-past-reports__past__table__header__label manage-past-reports__past__table__header__date\" ng-click=\"vm.sortByProps(\'inserted_at\')\">Report date<span class=manage-past-reports__past__table__sort-icon ng-class=\"propertyName === \'inserted_at\' && !reverse ? \'icon-icons_chevron-up\' : \'icon-icons_chevron-down\'\"></span></div><div class=\"manage-past-reports__past__table__header__label manage-past-reports__past__table__header__admin\">Admin</div><div class=\"manage-past-reports__past__table__header__label manage-past-reports__past__table__header__status\">Status</div><div ng-if=vm.isAdmin class=\"manage-past-reports__past__table__header__label manage-past-reports__past__table__header__strikes\">Strikes</div></div><div ng-repeat=\"report in vm.pastReports | orderBy:propertyName:reverse\"><community-report-list-view ng-class=\"{\'actived\': report.selected}\" report=report type=past on-report-clicked=vm.onReportClicked(report)></community-report-list-view></div><scroll-paging spinner=vm.spinnerPast is-last-page=vm.isLastPage message=\"No more reports.\"></scroll-paging><custom-paging-style ng-if=vm.totalPastReports options=vm.customPagingOptions custom-class=manage-past-reports__data-control total-items=vm.totalPastReports total-pages=vm.totalPastPage on-page-changed=vm.onPastReportsListChanged(data) on-page-size-changed=vm.onPageSizePastReportsChanged(data) show-items=vm.searchParams.page_size current-page=vm.searchParams.page></custom-paging-style></div></div></section><section ng-show=vm.isReportDetailsViewOpen class=\"fade-out manage-past-reports__report-detail-wrapper\"><report-detail-compile-template ng-if=vm.selectedReport report=vm.selectedReport on-closed=vm.onReportDetailsViewClosed() context=past on-status-changed=vm.onReportGridChanged(data)></report-detail-compile-template></section></div>");
$templateCache.put("app/components/manage-reports/manage-pending-reports/manage-pending-reports.html","<div class=manage-pending-reports><section class=manage-pending-reports__pending><div class=manage-pending-reports__pending__toggle-control__label>{{(\'pending\' | translate) | toTitleCase}} <span ng-if=vm.totalPendingReports>({{vm.totalPendingReports}})</span></div><div class=manage-pending-reports__pending__toggle><div class=manage-pending-reports__pending__subcontent><div>View and manage pending reports here.</div><div>You are encouraged to resolve or take necessary action on these reports quickly.</div></div><div class=manage-pending-reports__pending__control-data><div class=manage-pending-reports__pending__control-data__label translate>{{\'sort-by\'}}:</div><mutiline-dropdown items=vm.sortBy selected=vm.defaultSortBy on-changed=vm.onSortByChanged(data) class=manage-pending-reports__pending__control-data__dropdown></mutiline-dropdown><div class=manage-pending-reports__pending__spacing></div><div class=manage-pending-reports__pending__search><div class=\"manage-pending-reports__pending__search__input__icon icon-icons_search\"></div><input type=text class=manage-pending-reports__pending__search__input placeholder=\"{{\'search-reports\' | translate}}\" ng-change=vm.onSearchPendingReport() ng-model=vm.searchPendingReportString></div></div><div ng-if=\"vm.seletedPendingReports.length && vm.isOpenPendingNotification\" class=manage-pending-reports__pending__notification><div class=manage-pending-reports__pending__notification__number-selected><span class=manage-pending-reports__pending__notification__number-selected__value>{{vm.seletedPendingReports.length}}</span> selected</div><div class=manage-pending-reports__pending__notification__second-control ng-click=vm.onResolveReports(vm.seletedPendingReports)>Resolve selected</div><div class=\"manage-pending-reports__pending__notification__close-button icon-icons_close\" ng-click=\"vm.onCloseNotification(\'pending\')\"></div></div><div class=manage-pending-reports__pending__table><div class=manage-pending-reports__pending__table__header><div ng-if=vm.isAdmin class=manage-pending-reports__pending__table__header__select><stick-checkbox on-changed=vm.onSelectAllPendingReports(vm.isSelectedAllPendingReports) model=vm model-property=isSelectedAllPendingReports label=all layout-style=regular-square></stick-checkbox></div><div class=\"manage-pending-reports__pending__table__header__label manage-pending-reports__pending__table__header__community\" ng-click=vm.onCummunityFilterClicked()>Community Name<grid-filter title=\"Filter by\" options=vm.communityNameFilterOptions multi-select=true selected=vm.selectedCommunities on-changed=vm.onFilterChanged(items) is-open-dll=vm.isOpenCommunityFilter></grid-filter></div><div class=\"manage-pending-reports__pending__table__header__label manage-pending-reports__pending__table__header__reason\">Reason for report<grid-filter title=\"Filter by\" options=vm.reasonFilterOptions multi-select=true selected=vm.selectedReasons on-changed=vm.onReasonFilterChanged(items)></grid-filter></div><div class=\"manage-pending-reports__pending__table__header__label manage-pending-reports__pending__table__header__type\">Type of report<grid-filter title=\"Filter by\" options=vm.typeFilterOptions multi-select=true selected=vm.selectedTypes on-changed=vm.onTypeFilterChanged(items)></grid-filter></div><div class=\"manage-pending-reports__pending__table__header__label manage-pending-reports__pending__table__header__reporter\">Reporter</div><div class=\"manage-pending-reports__pending__table__header__label manage-pending-reports__pending__table__header__date\" ng-click=\"vm.sortByProps(\'inserted_at\')\">Report date<span class=manage-pending-reports__pending__table__sort-icon ng-class=\"propertyName === \'inserted_at\' && !reverse ? \'icon-icons_chevron-up\' : \'icon-icons_chevron-down\'\"></span></div><div class=\"manage-pending-reports__pending__table__header__label manage-pending-reports__pending__table__header__admin\">Admin</div><div class=\"manage-pending-reports__pending__table__header__label manage-pending-reports__pending__table__header__status\">Status</div><div ng-if=vm.isAdmin class=\"manage-pending-reports__pending__table__header__label manage-pending-reports__pending__table__header__strikes\">Strikes</div><div ng-if=!vm.isAdmin class=manage-pending-reports__pending__table__header__controls__user-more></div><div ng-if=vm.isAdmin class=manage-pending-reports__pending__table__header__controls></div></div><div ng-repeat=\"report in vm.pendingReports | orderBy:propertyName:reverse\"><community-report-list-view ng-class=\"{\'actived\': report.selected}\" report=report on-toggle-selected=vm.onSelectPendingReport(report) type=pending on-report-clicked=vm.onReportClicked(report) on-status-changed=vm.onReportGridChanged(data)></community-report-list-view></div><scroll-paging spinner=vm.spinnerPending is-last-page=vm.isLastPage message=\"No more reports.\"></scroll-paging><custom-paging-style ng-if=vm.totalPendingReports options=vm.customPagingOptions custom-class=manage-pending-reports__data-control total-items=vm.totalPendingReports total-pages=vm.totalPendingPage on-page-changed=vm.onPendingReportsListChanged(data) on-page-size-changed=vm.onPageSizePendingReportsChanged(data) show-items=vm.searchParams.page_size current-page=vm.searchParams.page></custom-paging-style></div></div></section><section ng-show=vm.isReportDetailsViewOpen class=\"fade-out manage-pending-reports__report-detail-wrapper\"><report-detail-compile-template ng-if=vm.selectedReport report=vm.selectedReport on-closed=vm.onReportDetailsViewClosed() context=pending on-status-changed=vm.onReportGridChanged(data)></report-detail-compile-template></section></div>");
$templateCache.put("app/components/mission-review/mission-review-section-art-direction/mission-review-section-art-direction.html","<div class=mission-review-section-art-direction__art-direction><form name=artDirectionForm><div class=\"mission-review-section-art-direction__art-direction__header clearfix\"><div class=\"mission-review-section-art-direction__art-direction__title text--color-black\" translate>{{\'art-direction\'}}</div><mission-review-section-edit-btn validator=vm.validator(vm.mission) ng-if=vm.isEditable is-editing=vm.isEditing mission=vm.mission backup=vm.backup() restore=vm.restore()></mission-review-section-edit-btn></div><div class=mission-review-section-art-direction__art-direction__content><div ng-bind-html=vm.mission.art_direction ng-if=vm.mission.art_direction ng-show=!vm.isEditing></div><div class=ng-hide ng-show=vm.isEditing><pixerf-quill-editor name=artDirection options=vm.artDirectionEditorOptions model=vm.mission.art_direction></pixerf-quill-editor><div class=text-right><span class=textarea__length_descriptioon>{{vm.descriptionLength ? vm.descriptionLength : 0}}/1500</span></div></div></div></form><div class=mission-review-section-art-direction__insipiration-photos><div ng-show=!vm.isEditing><div ng-repeat=\"photo in vm.mission.media\" class=\"relative mission-review-section-art-direction__insipiration-photos__photo\"><img class=image-vertical-center ng-src={{photo.urlSmall}}><div class=mission-review-section-art-direction__insipiration-photos__cover-image ng-if=\"vm.mission.cover_media.id === photo.id\"><div title=\"Cover image\" class=\"pixerf-checkbox pixerf-checkbox--fake pixerf-checkbox--fake--checked\"></div><div class=\"mission-review-section-art-direction__insipiration-photos__cover-image-text text--color-pixerf-theme\">Set as cover</div></div></div></div><mission-inspiration-photos ng-show=vm.isEditing num-processing-file=vm.numProcessingFile mission=vm.mission class=ng-hide></mission-inspiration-photos></div></div>");
$templateCache.put("app/components/mission-review/mission-review-section-brief/mission-review-section-brief.html","<div class=mission-review-section-brief><form name=brieftForm><div class=\"mission-review-section-brief__header clearfix\"><div class=\"mission-review-section-brief__title text--color-black\" translate>{{\'challenge-brief\'}}</div><mission-review-section-edit-btn validator=vm.validator(vm.mission) ng-if=vm.isEditable is-editing=vm.isEditing mission=vm.mission backup=vm.backup() restore=vm.restore()></mission-review-section-edit-btn></div><div class=mission-review-section-brief__content><div ng-bind-html=vm.mission.description ng-if=vm.mission.description ng-show=!vm.isEditing></div><div class=ng-hide ng-show=vm.isEditing><pixerf-quill-editor class=ng-hide ng-show=vm.isEditing name=artDirection options=vm.briefEditorOptions model=vm.mission.description></pixerf-quill-editor><div class=text-right><span class=textarea__length_descriptioon>{{vm.briefLength ? vm.briefLength : 0}}/3000</span></div></div></div></form></div>");
$templateCache.put("app/components/mission-review/mission-review-section-detail/mission-review-section-detail.html","<div class=\"mission-review-section-detail create-mission-step-review__overview__mission-details\"><form name=missionDetailsForm><div class=\"create-mission-step-review__overview__mission-details__header clearfix\"><div class=\"create-mission-step-review__overview__mission-details__title text--color-black\">Mission Details</div><mission-review-section-edit-btn ng-if=vm.isEditable is-editing=vm.isEditing mission=vm.mission backup=vm.backup() restore=vm.restore()></mission-review-section-edit-btn></div><div class=\"create-mission-step-review__overview__mission-details__country-select clearfix\"><div class=\"mission-review-section-detail__requirement__title mission-review-section-detail__label-country-select text--bold text--color-black\">Countries:</div><div ng-if=!vm.isEditing class=mission-review-section-detail__dropdown-country-select><span ng-repeat=\"country in vm.selectedCountries\">{{country.name}}<span ng-if=!$last>,</span></span></div><pixerf-input-auto-complete ng-if=vm.isEditing dropdown-class=create-mission__country-dropdown options=vm.countriesOpts name=mission_countries data=vm.countries model=vm.selectedCountries on-changed=vm.onCountriesSelected()></pixerf-input-auto-complete><!-- <div class=\"custom-commission-review-getting-started__row clearfix\" ng-class=\"{\'field-invalid\': vm.error === vm.customCommissionsConst.VALIDATE_SECTION.TYPE && !vm.isEditing}\">\r\n				<div class=\"custom-commission-review-getting-started__col-left text--bold text--color-black\">Looking for</div>\r\n				<div ng-if=\"!vm.isEditing\" class=\"custom-commission-review-getting-started__col-right\">\r\n					<span ng-repeat=\"type in vm.selectedType\">{{type.name}}</span><span ng-if=\"!$last\">, </span>\r\n				</div>\r\n				<pixerf-input-auto-complete ng-if=\"vm.isEditing\" options=\"{\'maxOptions\': 1, \'noneSelectedText\': \'\'}\" name=\"customcommission_duration\" data=\"vm.type\" model=\"vm.selectedType\" on-changed=\"vm.onTypeSelected()\"></pixerf-input-auto-complete>\r\n			</div> --></div><div class=create-mission-step-review__overview__mission-details__content><div ng-repeat=\"field in vm.fields\"><div class=\"mission-review-section-detail__requirement clearfix\"><label class=\"mission-review-section-detail__requirement__title text--bold text--color-black\">{{field.label}}</label><pixerf-combobox on-init=vm.onComboboxInit(instance) options=field.options model=vm.mission[field.value] is-editing=vm.isEditing settings=\'{\"propName\": \"label\", \"id\": field.value}\'></pixerf-combobox></div></div></div></form></div>");
$templateCache.put("app/components/mission-review/mission-review-section-edit-btn/mission-review-section-edit-btn.html","<div class=\"mission-review-section-edit-btn__btns-wrapper clearfix\"><div class=\"mission-review-section-edit-btn__edit-btn text--color-pixerf-theme\" ng-click=vm.onEditBtnClicked() ng-show=!vm.isEditing><span class=icon-write></span> <span class=text--bold>Edit</span></div><div class=\"mission-review-section-edit-btn__cancel-btn ng-hide\" ng-click=vm.onCancelBtnClicked() ng-show=vm.isEditing>Cancel</div><div class=\"mission-review-section-edit-btn__save-btn text--bold text--color-pixerf-theme ng-hide\" ng-disabled=vm.isWorking ng-click=vm.onSaveBtnClicked() ng-show=vm.isEditing>Save</div></div>");
$templateCache.put("app/components/mission-review/mission-review-section-reward/mission-review-section-reward.html","<div class=mission-review-section-reward><div name=vm.durationRewardsForm><div class=\"mission-review-section-reward__header clearfix\"><div class=mission-review-section-reward__title>Overview</div><mission-review-section-edit-btn validator=vm.validator() ng-if=vm.isEditable is-editing=vm.isEditing mission=vm.mission backup=vm.backup() restore=vm.restore()></mission-review-section-edit-btn></div><div class=devider></div><div class=mission-review-section-reward__prizes-wrapper><div class=\"text--bold text--color-black-6 mission-review-section-reward__prizes-summary\" ng-show=!vm.isEditing><div class=mission-review-section-reward__prizes-summary__item ng-if=vm.mission.price.duration>{{vm.mission.price.duration}}-day Mission</div><div class=mission-review-section-reward__prizes-summary__item>{{vm.mission.prizes_grouped[\"WINNER\"].quantity}} x Winning Prize(s)</div><div ng-if=\"vm.mission.prizes_grouped[\'CONSOLATION\']\" class=mission-review-section-reward__prizes-summary__item>{{vm.mission.prizes_grouped[\"CONSOLATION\"].quantity}} x Special Mention(s)</div></div><mission-reward on-init=vm.onMssionAwardInit(instance) ng-class=ng-hide ng-if=vm.isEditing mission=vm.mission></mission-reward></div></div></div>");
$templateCache.put("app/components/mission-review/mission-review-section-sponsor/mission-review-section-sponsor.html","<div class=mission-review-section-sponsor><form name=missionSponsorForm><div class=\"mission-review-section-sponsor__header clearfix\"><div class=\"mission-review-section-sponsor__title text--color-black\">Mission Sponsor</div><mission-review-section-edit-btn validator=vm.validator(vm.mission) ng-if=vm.isEditable is-editing=vm.isEditing mission=vm.mission backup=vm.backup() restore=vm.restore()></mission-review-section-edit-btn></div><div class=mission-review-section-sponsor__content><div ng-if=!vm.isEditing><h5 class=\"text--color-black text--semibold\">{{vm.mission.sponsor ? (\'missions-form-12\' | translate) : (\'missions-form-11\' | translate)}}</h5></div><div><div class=clearfix ng-if=vm.isEditing><h5 class=\"text--color-black text--semibold\" translate>{{\'missions-form-07\'}}</h5><div class=mission-review-section-sponsor__options><div class=\"clearfix relative mission-review-section-sponsor__options__option\"><stick-checkbox model=vm.mission model-property=noSponsor on-changed=vm.onCheckboxChanged() label=missions-form-08 layout-style=solid-square></stick-checkbox></div><div class=\"clearfix relative mission-review-section-sponsor__options__option\"><stick-checkbox model=vm.mission model-property=noSponsor is-reversed=true on-changed=vm.onCheckboxChanged() label=missions-form-09 layout-style=solid-square></stick-checkbox></div></div></div><div class=\"relative clearfix mission-review-section-sponsor__sponsor-detail\" ng-if=!vm.mission.noSponsor><div class=\"dropzone-info form-group\"><label class=\"text--bold text--color-black-6\" translate>{{\'mission-sponsor-logo\'}}</label><div class=create-mission-step-sponsor__thumbnail><img ng-src={{vm.mission.sponsor.logoUrl}}></div><mission-sponsor-logo ng-if=vm.isEditing mission=vm.mission context=.mission-review-section-sponsor></mission-sponsor-logo></div><div class=form-group><label class=\"text--bold text--color-black-6\" translate>{{\'name-mission-sponsor\'}}</label><input ng-if=vm.isEditing required placeholder=\"Who is running this Mission\" class=form-control ng-model=vm.mission.sponsor.name><div ng-if=!vm.isEditing>{{vm.mission.sponsor.name}}</div></div><div class=\"col-md-12 no-padding form-group\"><label class=\"text--bold text--color-black-6\" translate>{{\'description-mission-sponsor\'}}</label><textarea ng-if=vm.isEditing required ng-model=vm.mission.sponsor.description class=form-control placeholder=\"{{\'description-mission-sponsor-detail\' | translate}}\"></textarea><div ng-if=!vm.isEditing>{{vm.mission.sponsor.description}}</div></div></div></div></div></form></div>");
$templateCache.put("app/components/mission-review/mission-review-section-title/mission-review-section-title.html","<div class=mission-review-section-title><form class=form-group><div class=\"clearfix relative\"><h1 ng-if=!vm.isEditing class=\"create-mission__title text--bold text--color-black\">{{vm.mission.title}}</h1><input ng-if=vm.isEditing required placeholder=\"{{\'mission-name-placeholder\' | translate}}\" class=\"form-control create-mission__title text--bold text--color-black\" ng-model=vm.mission.title><mission-review-section-edit-btn validator=vm.validator(vm.mission) ng-if=vm.isEditable is-editing=vm.isEditing mission=vm.mission backup=vm.backup() restore=vm.restore() class=mission-review-section-title__edit-btn></mission-review-section-edit-btn></div><p class=create-mission__sub-title>ID #{{vm.mission.id}}</p></form></div>");
$templateCache.put("app/components/photo-detail/segments/photo-detail-keyword-similar.html","<div><div class=photo-detail__main-content__keywords ng-if=\"!isEditMode.data && !photo.isMissionWinnerSelectionMode\"><div class=photo-detail__main-content__keywords__header data-toggle=collapse data-target=#photo-details-keywords aria-expanded=true><h5 class=photo-detail__main-content__keywords__title translate>{{\'keywords\'}}</h5><span class=\"photo-detail__main-content__keywords__collapse-icon icon-icons_plus\"></span> <span class=\"photo-detail__main-content__keywords__collapse-icon icon-icons_minus\"></span></div><h5 class=\"text--color-black text--extrabold photo-detail__main-content__keywords__title\" translate>{{\'keywords\'}}</h5><div class=\"collapse in\" id=photo-details-keywords><span ng-repeat=\"tag in photo.tags\" class=\"tag-item tag-item--readonly\" ng-click=vm.onTagClicked(tag)><span class=tag-template><span><span class=\"text--bold text--truncate tag-text-holder\">{{tag.text}}</span></span></span></span></div></div><hr ng-if=isMobile class=photo-detail__mobile-devider><div class=photo-detail__main-content__similar-photos ng-if=\"!isEditMode.data && !photo.isMissionWinnerSelectionMode\"><h5 class=\"text--color-black text--extrabold photo-detail__main-content__similar-photos__title\" translate>{{\'similar-photos\'}}</h5><div class=\"photos-grid-wrapper clearfix relative\" ng-class=\"{\'curator-interface\': vm.loginnedUser.canCurate}\"><photo-grid hide-no-more-message=true ideal-height=\"isMobile ? 150 : 200\" context=context on-init=vm.onPhotoGridInit(photoGrid) container=\".photo-detail__main-content__similar-photos .photos-grid-wrapper\"><div class=text-center><span class=icon-icons-gallery></span><h5 class=\"text-semibold no-message-notice\" translate>{{\'cannot-find-any-similar-photos\'}}</h5></div></photo-grid></div></div></div>");
$templateCache.put("app/components/photo-detail/segments/photo-detail-tools-wrapper.html","<div class=photo-detail__tools-wrapper><like-btn media=photo class=photo-detail__tools-wrapper__like-btn></like-btn><div class=photo-detail__view-count><span class=icon-view-count></span> <span class=photo-detail__view-count__value>{{photo.view_count === 1 ? (photo.view_count + \' view\') : (photo.view_count + \' views\')}}</span></div><div ng-if=\"vm.showAddToCart && photo.state !=\'r\'\" ng-click=vm.onAddToCartBtnClicked(vm.cartItem.media) class=photo-detail__tools-wrapper__add-to-cart ng-class=\"{\'disabled\':vm.isAddedToCart}\" title=\"{{vm.isAddedToCart ? \'purchased\' : \'add-to-cart\' | translate}}\"><span class=\"{{vm.isAddedToCart ? \'icon-cart-purchased\' : \'icon-icons_cart\'}}\"></span></div><add-to-gallery file=photo ng-if=\"(!vm.loginnedUser || vm.loginnedUser.canManageGalleries) && photo.state !=\'r\'\" class=\"photo-detail__tools-wrapper__add-to-gallery add-to-gallery\" on-gallery-item-clicked=\"vm.onGalleryItemClicked(file, gallery)\" add-when-gallery-created=true><button authentication-click popover-enable=vm.isEnable class=\"btn-basic btn-basic--no-background\" popover-append-to-body=true popover-class=add-to-gallery popover-is-open=vm.isOpen.data ng-class=\"{\'no-opacity\' : vm.isOpen.data}\" type=button uib-popover-template=\"\'app/components/add-to-gallery/add-to-gallery-popover-tmpl.html\'\" popover-placement=\"auto left\" popover-trigger=\"\'outsideClick\'\" title=\"{{\'add-photo-to-your-gallery\' | translate}}\"><span class=icon-icons-add-to-gallery></span></button></add-to-gallery><div ng-if=\"vm.loginnedUser && vm.loginnedUser.canDownloadComp\" title=\"{{\'download-comp\' | translate}}\" class=\"photo-detail__tools-wrapper__icon-download icon-icons_download\" ng-click=vm.onDownloadComp(photo)></div><share settings=\"{\'appendToBody\': true, \'popoverPlacement\': \'left\'}\" ng-if=vm.showShareBtn content-will-be-shared=vm.socialShareContent ng-if=true class=photo-detail__tools-wrapper__share-btn title=\"{{\'hover-share-this-photo\' | translate}}\"></share></div>");
$templateCache.put("app/components/photo-detail/segments/photo-detail-user-photo-brief.html","<div class=photo-detail__photo-info__top-info><div ng-if=isMobile><ng-include src=\"\'app/components/photo-detail/segments/photo-detail-tools-wrapper.html\'\"></ng-include></div><div class=clearfix><a class=\"photo-detail__photo-info__author pull-left\" popup-link-clicked=\"{{\'/user-home-page/\' + photo.user.id +\'/\'+ (photo.user.displayName| toSnakeCase)}}\"><pixerf-user-avatar class=\"profile-image pull-left\" user-data=photo.user lazy=true></pixerf-user-avatar><h2 class=\"photo-detail__photo-info__author__username text--truncate pull-left text--bold text--color-black\">{{photo.user.displayName}}</h2></a><follow-btn ng-attr-title=\"{{photo.user.is_followed ? (\'unfollow-this-person\' | translate) : (\'follow-this-person\' | translate)}}\" user=photo.user ng-if=!photo.user.isMine is-icon-mode=true></follow-btn></div><div itemscope itemtype=http://schema.org/Product><h1 itemprop=name ng-attr-title={{photo.title}} class=\"text--semibold text--color-black photo-detail__photo-info__title\">{{photo.title}}</h1><h2 class=photo-detail__photo-info__description itemprop=description>{{photo.description}}</h2></div><div ng-if=!isMobile><ng-include src=\"\'app/components/photo-detail/segments/photo-detail-tools-wrapper.html\'\"></ng-include></div></div>");
$templateCache.put("app/components/photographer/photographer-grid-styles/photographer-grid-styles.html","<div class=\"photographer-grid-styles clearfix\"><a ui-sref=\"user-home-page.personal.home({id: item.id, userName: (item.displayName | toSnakeCase)})\"><div class=photographer-grid__cover-photo ng-style=\"{\'background-image\': \'url(\' + item.avatar.coverImage + \')\'}\"><div class=overlay-image></div></div></a><div class=photographer-grid__avatar pixerf-user-avatar-style pixerf-user-avatar-style-user=item><a ui-sref=\"user-home-page.personal.home({id: item.id, userName: (item.displayName | toSnakeCase)})\"><pixerf-user-avatar user-data=item lazy=true></pixerf-user-avatar><div class=overlay></div></a></div><div class=photographer-grid__author><div class=\"photographer-grid__author__name text--bold text--truncate\"><a ui-sref=\"user-home-page.personal.home({id: item.id, userName: (item.displayName | toSnakeCase)})\">{{item.displayName}}</a></div><div class=\"photographer-grid__author__country text--truncate\">{{item.address.country ? item.address.country : item.location | isoCountry}}</div><div class=\"photographer-grid__author__level text--truncate text--bold\">{{!!item.ambassadorship ? (\'Ambassador \' + item.ambassadorship) : \'Pixerfer\' | toTitleCase}}</div><pixerf-badges popup-detail=true class=photographer-grid__badges-wrapper badges=item.badges></pixerf-badges><follow-btn class=photographer-grid__follow-btn user=item></follow-btn><suggest-btn user=item ng-if=\"vm.loginUser && vm.loginUser.isAdminInternal\"></suggest-btn></div></div>");
$templateCache.put("app/components/purchase-history/credit-list/credit-list.html","<div class=credit-list infinite-scroll-disabled=vm.isLastPage infinite-scroll=vm.fetchMorePurchasedItems() infinite-scroll-immediate-check=false><div class=credit-list__content><div class=\"credit-list__content__header clearfix\"><div class=credit-list__filter__wrapper><div class=credit-list__filter__wrapper__from><div class=credit-list__text-filter>From</div><div class=credit-list__filter__input><input type=text name=fromDate class=form-control uib-datepicker-popup=\"d MMM yyyy\" ng-model=vm.selectedFilter.fromDate is-open=fromDate.isVisible datepicker-options=\"{showWeeks: false}\" show-button-bar=false> <button type=button class=credit-list__filter__input__btn ng-click=\"fromDate.isVisible = !fromDate.isVisible\"><i class=\"glyphicon glyphicon-calendar\"></i></button></div></div><div class=credit-list__filter__wrapper__to><div class=credit-list__text-filter>To</div><div class=credit-list__filter__input><input type=text name=toDate class=form-control uib-datepicker-popup=\"d MMM yyyy\" ng-model=vm.selectedFilter.toDate is-open=toDate.isVisible datepicker-options=\"{showWeeks: false}\" show-button-bar=false> <button type=button class=credit-list__filter__input__btn ng-click=\"toDate.isVisible = !toDate.isVisible\"><i class=\"glyphicon glyphicon-calendar\"></i></button></div></div></div></div><div class=credit-list__table-wrapper><div class=credit-list__table-wrapper__download-all ng-click=vm.onDownloadReceipts()>{{vm.downloadText}}</div><div class=credit-list__table__wrapper><table class=credit-list__table><tr class=\"credit-list__table__header text--bold text--color-black\"><th></th><th class=\"credit-list__table__column credit-list__table__column-date\" ng-click=\"reverse = !reverse\">{{\'date\' | translate}}<!-- <span ng-class=\"{\'glyphicon glyphicon-triangle-bottom\': !reverse, \'glyphicon glyphicon-triangle-top\': reverse}\"></span> --></th><th class=\"credit-list__table__column credit-list__table__column-order\" translate>{{\'order-no\'}}</th><th class=\"credit-list__table__column credit-list__table__column-main-details text-center\" translate>{{\'credits-purchased\'}}</th><th class=\"credit-list__table__column credit-list__table__column-payment-method\" translate>{{\'payment-method\'}}</th><th class=credit-list__table__column></th></tr><tr class=credit-list__table__row ng-repeat=\"item in vm.items | orderBy:purchasedDateFormatted:reverse\" ng-class=\"$index % 2 === 0 ? \'credit-list__table__row-even\' : \'credit-list__table__row-odd\'\"><td class=credit-list__table__column-select><stick-checkbox on-changed=vm.onSelectedItem(item) model=item model-property=selected></stick-checkbox></td><td class=credit-list__table__column-date>{{item.purchasedDateFormatted}}</td><td class=credit-list__table__column-order>{{item.id}}</td><td class=\"credit-list__table__column-main-details text-center\">SGD {{item.user_credit_plan.credit_plan.value | number}}</td><td class=credit-list__table__column-payment-method translate>{{item.payment_method}}</td><td class=\"credit-list__table__column-view-photos text--bold text--color-pixerf-theme\"><button class=\"btn credit-list__table__download-invoice-btn btn--grey-magento\" ng-click=\"vm.onDownloadBtnClicked($event, item)\">{{\'receipt\' | translate}}</button> <a ng-attr-href={{item.downloadLink}} target=_blank></a></td></tr></table></div></div><div class=\"credit-list__content__items--no-records text-center text--semibold\" ng-show=\"vm.items.length === 0 && !vm.spinner.isVisible\">{{\'no-records-found\' | translate}}</div><scroll-paging spinner=vm.spinner show-message=\"vm.items.length > 0 && vm.searchParams.page > 1\" is-last-page=vm.isLastPage></scroll-paging></div></div>");
$templateCache.put("app/components/purchase-history/custom-content-assignment/custom-content-assignment.html","<div class=custom-content-assignment infinite-scroll-disabled=vm.isLastPage infinite-scroll=vm.fetchMorePurchasedItems() infinite-scroll-immediate-check=false><div class=custom-content-assignment__content><div class=\"custom-content-assignment__content__header clearfix\"><div class=custom-content-assignment__filter__wrapper><div class=custom-content-assignment__filter__wrapper__from><div class=custom-content-assignment__text-filter>From</div><div class=custom-content-assignment__filter__input><input type=text name=fromDate class=form-control uib-datepicker-popup=\"d MMM yyyy\" ng-model=vm.selectedFilter.fromDate is-open=fromDate.isVisible datepicker-options=\"{showWeeks: false}\" show-button-bar=false> <button type=button class=custom-content-assignment__filter__input__btn ng-click=\"fromDate.isVisible = !fromDate.isVisible\"><i class=\"glyphicon glyphicon-calendar\"></i></button></div></div><div class=custom-content-assignment__filter__wrapper__to><div class=custom-content-assignment__text-filter>To</div><div class=custom-content-assignment__filter__input><input type=text name=toDate class=form-control uib-datepicker-popup=\"d MMM yyyy\" ng-model=vm.selectedFilter.toDate is-open=toDate.isVisible datepicker-options=\"{showWeeks: false}\" show-button-bar=false> <button type=button class=custom-content-assignment__filter__input__btn ng-click=\"toDate.isVisible = !toDate.isVisible\"><i class=\"glyphicon glyphicon-calendar\"></i></button></div></div></div></div><div class=custom-content-assignment__table-wrapper><div class=custom-content-assignment__table-wrapper__download-all ng-click=vm.onDownloadReceipts()>{{vm.downloadText}}</div><div class=custom-content-assignment__table__wrapper><table class=custom-content-assignment__table><tr class=\"custom-content-assignment__table__header text--bold text--color-black\"><th></th><th class=\"custom-content-assignment__table__column custom-content-assignment__table__column-date\" ng-click=\"reverse = !reverse\">{{\'date\' | translate}}<!-- <span ng-class=\"{\'glyphicon glyphicon-triangle-bottom\': !reverse, \'glyphicon glyphicon-triangle-top\': reverse}\"></span> --></th><th class=\"custom-content-assignment__table__column custom-content-assignment__table__column-order\" translate>{{\'order-no\'}}</th><th class=\"custom-content-assignment__table__column custom-content-assignment__table__column-main-details\">CCA ID</th><th class=\"custom-content-assignment__table__column custom-content-assignment__table__column-payment-method\" translate>{{\'payment-method\'}}</th><th class=custom-content-assignment__table__column></th></tr><tr class=custom-content-assignment__table__row ng-repeat=\"item in vm.items | orderBy:purchasedDateFormatted:reverse\" ng-class=\"$index % 2 === 0 ? \'custom-content-assignment__table__row-even\' : \'custom-content-assignment__table__row-odd\'\"><td class=custom-content-assignment__table__column-select><stick-checkbox on-changed=vm.onSelectedItem(item) model=item model-property=selected></stick-checkbox></td><td class=custom-content-assignment__table__column-date>{{item.purchasedDateFormatted}}</td><td class=custom-content-assignment__table__column-order>{{item.id}}</td><td class=custom-content-assignment__table__column-main-details>{{item.custom_commission.id}}</td><td class=custom-content-assignment__table__column-payment-method translate>{{item.payment_method}}</td><td class=\"custom-content-assignment__table__column-view-photos text--bold text--color-pixerf-theme\"><button class=\"btn custom-content-assignment__table__download-invoice-btn btn--grey-magento\" ng-click=\"vm.onDownloadBtnClicked($event, item)\">{{\'receipt\' | translate}}</button> <a ng-attr-href={{item.downloadLink}} target=_blank></a></td></tr></table></div></div><div class=\"custom-content-assignment__content__items--no-records text-center text--semibold\" ng-show=\"vm.items.length === 0 && !vm.spinner.isVisible\">{{\'no-records-found\' | translate}}</div><scroll-paging spinner=vm.spinner show-message=\"vm.items.length > 0 && vm.searchParams.page > 1\" is-last-page=vm.isLastPage></scroll-paging></div></div>");
$templateCache.put("app/components/purchase-history/mission-list/mission-list.html","<div class=mission-list infinite-scroll-disabled=vm.isLastPage infinite-scroll=vm.fetchMorePurchasedItems() infinite-scroll-immediate-check=false><div class=mission-list__content><div class=\"mission-list__content__header clearfix\"><div class=mission-list__content__count><span translate translate-values=\"{number: vm.totalItem ? vm.totalItem : 0}\">{{\'you-have-run-missions\'}}</span> <span ng-bind=\"vm.totalItem === 1 ? (\'mission\' | translate) : (\'missions\' | translate)\"></span></div><div class=mission-list__filter__wrapper><div class=mission-list__filter__wrapper__from><div class=mission-list__text-filter>From</div><div class=mission-list__filter__input><input type=text name=fromDate class=form-control uib-datepicker-popup=\"d MMM yyyy\" ng-model=vm.selectedFilter.fromDate is-open=fromDate.isVisible datepicker-options=\"{showWeeks: false}\" show-button-bar=false> <button type=button class=mission-list__filter__input__btn ng-click=\"fromDate.isVisible = !fromDate.isVisible\"><i class=\"glyphicon glyphicon-calendar\"></i></button></div></div><div class=mission-list__filter__wrapper__to><div class=mission-list__text-filter>To</div><div class=mission-list__filter__input><input type=text name=toDate class=form-control uib-datepicker-popup=\"d MMM yyyy\" ng-model=vm.selectedFilter.toDate is-open=toDate.isVisible datepicker-options=\"{showWeeks: false}\" show-button-bar=false> <button type=button class=mission-list__filter__input__btn ng-click=\"toDate.isVisible = !toDate.isVisible\"><i class=\"glyphicon glyphicon-calendar\"></i></button></div></div></div></div><div class=mission-list__table-wrapper><div class=mission-list__table-wrapper__download-all ng-click=vm.onDownloadReceipts()>{{vm.downloadText}}</div><div class=mission-list__table__wrapper><table class=mission-list__table><tr class=mission-list__table__header><th></th><th class=\"mission-list__table__column mission-list__table__column-date\" ng-click=\"reverse = !reverse\">{{\'date\' | translate}}<!-- <span ng-class=\"{\'glyphicon glyphicon-triangle-bottom\': !reverse, \'glyphicon glyphicon-triangle-top\': reverse}\"></span> --></th><th class=\"mission-list__table__column mission-list__table__column-order\">{{\'order-no\' | translate}}</th><th class=\"mission-list__table__column mission-list__table__column-main-details text-left\">{{\'mission-name\' | translate}}</th><th class=\"mission-list__table__column mission-list__table__column-no-award\">No. of Awards</th><th class=\"mission-list__table__column mission-list__table__column-credit-used\">{{\'payment-method\' | translate}}</th><th class=mission-list__table__column></th></tr><tr class=mission-list__table__row ng-repeat=\"item in vm.items | orderBy:purchasedDateFormatted:reverse\" ng-class=\"$index % 2 === 0 ? \'mission-list__table__row-even\' : \'mission-list__table__row-odd\'\"><td class=mission-list__table__column-select><stick-checkbox on-changed=vm.onSelectedItem(item) model=item model-property=selected></stick-checkbox></td><td class=mission-list__table__column-date>{{item.purchasedDateFormatted}}</td><td class=mission-list__table__column-order>{{item.id}}</td><td class=\"mission-list__table__column-main-details text-left\"><a ui-sref=\"mission-detail-page.brief({id: item.mission.id})\" target=_blank>{{item.mission.title}}</a></td><td class=mission-list__table__column-no-award>{{item.mission.prizes.length}}</td><td class=mission-list__table__column-payment-method translate>{{item.payment_method}}</td><td class=mission-list__table__column-credit-used><div class=text--bold><button class=\"btn mission-list__table__download-invoice-btn btn--grey-magento\" ng-click=\"vm.onDownloadBtnClicked($event, item, \'receipt\')\">{{\'receipt\' | translate}}</button> <a ng-attr-href={{item.downloadLink}} target=_blank></a></div></td></tr></table></div></div><div class=\"mission-list__content__items--no-records text-center text--semibold\" ng-show=\"vm.items.length === 0 && !vm.spinner.isVisible\">{{\'no-records-found\' | translate}}</div><scroll-paging spinner=vm.spinner show-message=\"vm.items.length > 0 && vm.searchParams.page > 1\" is-last-page=vm.isLastPage></scroll-paging></div></div>");
$templateCache.put("app/components/purchase-history/order-details/order-details.html","<div class=order-details><div class=order-details__back-btn ng-click=vm.onBackBtnClicked()><span class=icon-icons_chevron-left></span> <span>Back to Purchase History</span></div><div class=\"order-details__header-wrapper clearfix\"><div class=order-details__header-left><div class=\"order-details__time-purchase text--bold\"><span>{{vm.item.media.length}}</span> <span ng-bind=\"vm.item.media.length === 1 ? \'image\' : \'images\'\"></span> purchased on <span>{{vm.item.purchasedDateFormatted}}</span></div><a ui-sref=setting.purchase-history.order-list>Order ID #{{vm.orderId}}</a></div></div><div class=order-details__content><div class=order-details__control><div class=order-details__download-receipt><div class=order-details__view-receipt-btn ng-click=\"vm.onDownloadBtnClicked($event, vm.item, \'receipt\')\">Download receipt</div><a ng-attr-href={{vm.item.downloadLink}} target=_blank></a></div><div class=order-details__download-all ng-click=vm.onDownloadSelected()>{{vm.downloadText}}</div></div><div class=order-details__item><purchase-sold-history-item class=order-details__item-content type=\"\'purchase\'\" item=vm.item on-selected=vm.onSelectedMedia(data)></purchase-sold-history-item></div><div class=browse-for-more-images-btn ui-sref=buy-stock-page.galleries.signature-galleries><div class=browse-for-more-images-btn__content>{{\'browse-for-more-images\' | translate}}</div></div><scroll-paging spinner=vm.spinner></scroll-paging></div></div>");
$templateCache.put("app/components/purchase-history/order-list/order-list.html","<div class=order-list infinite-scroll-disabled=vm.isLastPage infinite-scroll=vm.fetchMorePurchasedItems() infinite-scroll-immediate-check=false><div class=order-list><div class=order-list__header><div class=order-list__count>{{\'purchase-history-licensed\' | translate}} <span class=text--bold ng-bind=\"vm.items.length === 0 ? 0 : vm.totalItem\"></span> <span ng-bind=\"vm.totalItem === 1 ? (\'image\' | translate) : (\'images\' | translate)\"></span></div><div class=order-list__view-style><div class=order-list__view-style__title>View by:</div><div class=order-list__view-style__list><custom-radio-button class=order-list__view-style__item model=vm.viewByProps options=vm.viewByOptions model-property={{vm.viewByOptions.props}} value=vm.viewByOptions.selections[0].value label=vm.viewByOptions.selections[0].label on-changed=vm.onArrageChanged(data)></custom-radio-button><custom-radio-button class=order-list__view-style__item model=vm.viewByProps options=vm.viewByOptions model-property={{vm.viewByOptions.props}} value=vm.viewByOptions.selections[1].value label=vm.viewByOptions.selections[1].label default=true on-changed=vm.onArrageChanged(data)></custom-radio-button></div></div></div><div class=order-list__filter><div class=order-list__filter__wrapper><div class=order-list__filter__wrapper__from><div class=order-list__text-filter>From</div><div class=order-list__filter__input><input type=text name=fromDate class=form-control uib-datepicker-popup=\"d MMM yyyy\" ng-model=vm.selectedFilter.fromDate is-open=fromDate.isVisible datepicker-options=\"{showWeeks: false}\" show-button-bar=false> <button type=button class=order-list__filter__input__btn ng-click=\"fromDate.isVisible = !fromDate.isVisible\"><i class=\"glyphicon glyphicon-calendar\"></i></button></div></div><div class=order-list__filter__wrapper__to><div class=order-list__text-filter>To</div><div class=order-list__filter__input><input type=text name=toDate class=form-control uib-datepicker-popup=\"d MMM yyyy\" ng-model=vm.selectedFilter.toDate is-open=toDate.isVisible datepicker-options=\"{showWeeks: false}\" show-button-bar=false> <button type=button class=order-list__filter__input__btn ng-click=\"toDate.isVisible = !toDate.isVisible\"><i class=\"glyphicon glyphicon-calendar\"></i></button></div></div></div><div ng-if=\"vm.viewBy === \'images\'\" class=order-list__search><div class=icon-icons_search></div><input type=text ng-change=vm.onSearch() class=\"order-list__search__input form-control\" ng-model=vm.searchString></div></div><div ng-if=\"vm.viewBy != \'images\'\" class=order-list__table-wrapper><div class=order-list__table-wrapper__download-all ng-click=vm.onDownloadReceipts()>{{vm.downloadText}}</div><div class=order-list__table__wrapper><table class=order-list__table><tr class=order-list__table__header><th></th><th class=\"order-list__table__column order-list__table__column-date\" ng-click=\"reverse = !reverse\">{{\'date\' | translate}}<!-- <span ng-class=\"{\'glyphicon glyphicon-triangle-bottom\': !reverse, \'glyphicon glyphicon-triangle-top\': reverse}\"></span> --></th><th class=\"order-list__table__column order-list__table__column-order\">{{\'order-no\' | translate}}</th><th class=\"order-list__table__column order-list__table__column-main-details text-center\">{{\'no-of-images\' | translate}}</th><th class=\"order-list__table__column order-list__table__column-payment-method\">{{\'payment-method\' | translate}}</th><th class=order-list__table__column></th></tr><tr class=order-list__table__row ng-repeat=\"item in vm.items | orderBy:purchasedDateFormatted:reverse\" ng-class=\"$index % 2 === 0 ? \'order-list__table__row-even\' : \'order-list__table__row-odd\'\"><td class=order-list__table__column-select><stick-checkbox on-changed=vm.onSelectedItem(item) model=item model-property=selected></stick-checkbox></td><td class=order-list__table__column-date>{{item.purchasedDateFormatted}}</td><td class=order-list__table__column-order>{{item.id}}</td><td class=\"order-list__table__column-main-details text-center\"><span ng-if=\"item.order_type === \'marketplace\'\" ui-sref=\"setting.purchase-history.order-details({orderId: item.id})\" class=\"text--bold text--color-pixerf-theme\" role=button>{{item.media_count}}</span> <span ng-if=\"item.order_type === \'custom_commission\'\" ui-sref=\"custom-commissions-detail-page.approval({id: item.custom_commission_id})\" class=\"text--bold text--color-pixerf-theme\" role=button>{{item.media_count}}</span></td><td class=order-list__table__column-payment-method translate>{{item.payment.payment_method ? item.payment.payment_method : \'Free\'}}</td><td class=order-list__table__column-view-photos><div ng-if=\"item.payment.payment_method !== \'Credit Plan\'\" class=text--bold><button class=\"btn order-list__table__download-invoice-btn btn--grey-magento\" ng-click=\"vm.onDownloadBtnClicked($event, item, \'receipt\')\">{{\'receipt\' | translate}}</button> <a ng-attr-href={{item.downloadLink}} target=_blank></a></div><div ng-if=\"item.payment.payment_method === \'Credit Plan\'\">{{item.payment.amount | number:2}} {{\'credits-used\' | translate}}</div></td></tr></table></div></div><div ng-if=\"vm.viewBy === \'images\'\" class=order-list__flex-photo-grid><div class=order-list__flex-photo-grid__download-control><div class=\"order-list__flex-photo-grid__download-control__download-selected btn btn-cancel--no-background\" ng-class=\"{\'is-working\': vm.spinnerDownloadSelected.isVisible, \'is-disabled\': !vm.selectedItems.length}\" ng-click=vm.onDownloadSelectedItemsClicked()><span class=download-text>Download Selected</span></div></div><div class=order-list__flex-photo-grid__image-grid><div ng-repeat=\"item in vm.items\" class=order-list__flex-photo-grid__item><div class=order-list__flex-photo-grid__item__photo><img ng-src=\"{{item.thumbnails[\'150x\']}}\"><stick-checkbox model=item model-property=isSelected layout-style=solid-circle on-changed=vm.onSelectedImage(item)></stick-checkbox></div><div class=order-list__flex-photo-grid__item__content><div class=order-list__flex-photo-grid__item__content__purchased-date>{{item.purchasedDateFormatted}}</div><div class=\"order-list__flex-photo-grid__item__content__title text--truncate\">{{item.title}}</div><div class=order-list__flex-photo-grid__item__content__license>{{item.formatedLicense}}</div></div><div class=\"order-list__flex-photo-grid__item__button btn btn-submit\" ng-click=\"vm.onDownloadBtnClicked($event, item, \'download\')\">Download image</div><a ng-attr-href={{item.downloadLink}} target=_blank></a></div></div></div><div class=\"order-list__items--no-records text-center text--semibold\" ng-show=\"vm.items.length === 0 && !vm.spinner.isVisible\">{{\'no-records-found\' | translate}}</div><div class=browse-for-more-images-btn ui-sref=buy-stock-page.galleries.signature-galleries><div class=browse-for-more-images-btn__content>{{\'browse-for-more-images\' | translate}}</div></div><!-- <scroll-paging spinner=\"vm.spinner\" show-message=\"vm.items.length > 0 && vm.searchParams.page > 1\"\r\n			is-last-page=\"vm.isLastPage\"></scroll-paging> --></div></div>");
$templateCache.put("app/components/purchase-history/purchase-history-mission-details/purchase-history-mission-details.html","<div class=order-details><div class=order-details__back-btn ng-click=vm.onBackBtnClicked()><span class=icon-icons_chevron-left></span> <span>Back to Purchase History</span></div><div class=\"order-details__header-wrapper clearfix\"><div class=order-details__header-left><div class=\"order-details__time-purchase text--bold\"><span>{{vm.item.media.length}}</span> <span ng-bind=\"vm.item.media.length === 1 ? \'image\' : \'images\'\"></span> purchased on <span>{{vm.item.purchasedDateFormatted}}</span></div><div>Order ID #{{vm.orderId}}</div></div><button type=button class=\"order-details__view-receipt-btn btn btn-submit--no-background\" ng-click=\"vm.onDownloadBtnClicked($event, vm.item, \'receipt\')\">View Receipt</button> <a ng-attr-href={{vm.item.downloadLink}} target=_blank></a></div><div class=order-details__content><div class=order-details__item><purchase-sold-history-item class=order-details__item-content type=\"\'purchase\'\" item=vm.item></purchase-sold-history-item></div><scroll-paging spinner=vm.spinner></scroll-paging></div></div>");
$templateCache.put("app/components/user-verification/new-sign-up/verification-new-sign-up.html","<div class=verification-new-sign-up><div class=verification-new-sign-up__title>These are users whom PIXERF have reached out for further validation of the information they provided.</div><div class=verification-new-sign-up__list infinite-scroll-disabled=vm.isLastPage infinite-scroll=vm.fetchMoreUsers() infinite-scroll-immediate-check=false><user-info-verification-tile ng-repeat=\"user in vm.users\" data=user context=new on-status-changed=vm.onUserStatusChanged(user)></user-info-verification-tile><spinner-win spinner=vm.spinner></spinner-win></div></div>");
$templateCache.put("app/components/user-verification/pending-user-response/verification-pending-user-response.html","<div class=verification-pending-user-response><div class=verification-pending-user-response__title>These are users whom PIXERF have reached out for further validation of the information they provided.</div><div class=verification-pending-user-response__list infinite-scroll-disabled=vm.isLastPage infinite-scroll=vm.fetchMoreUsers() infinite-scroll-immediate-check=false><user-info-verification-tile ng-repeat=\"user in vm.users\" data=user context=pending on-status-changed=vm.onUserStatusChanged(user)></user-info-verification-tile><spinner-win spinner=vm.spinner></spinner-win></div></div>");
$templateCache.put("app/components/user-verification/rejected-users/verification-rejected-users.html","<div class=verification-rejected-users><div class=verification-rejected-users__title>These are users who have been rejected by PIXERF.</div><div class=verification-rejected-users__list infinite-scroll-disabled=vm.isLastPage infinite-scroll=vm.fetchMoreUsers() infinite-scroll-immediate-check=false><user-info-verification-tile ng-repeat=\"user in vm.users\" data=user context=rejected on-status-changed=vm.onUserStatusChanged(user)></user-info-verification-tile><spinner-win spinner=vm.spinner></spinner-win></div></div>");
$templateCache.put("app/components/user-verification/responded-users/verification-responded-users.html","<div class=verification-responded-users><div class=verification-responded-users__title>These are users who have submitted changes on their Edit Profile page.</div><div class=verification-responded-users__list infinite-scroll-disabled=vm.isLastPage infinite-scroll=vm.fetchMoreUsers() infinite-scroll-immediate-check=false><user-info-verification-tile ng-repeat=\"user in vm.users\" data=user context=responded on-status-changed=vm.onUserStatusChanged(user)></user-info-verification-tile><spinner-win spinner=vm.spinner></spinner-win></div></div>");
$templateCache.put("app/components/user-verification/verified-users/verification-verified-users.html","<div class=verification-responded-users><div class=verification-responded-users__title>These are users who have been verified by PIXERF.</div><div class=verification-responded-users__list infinite-scroll-disabled=vm.isLastPage infinite-scroll=vm.fetchMoreUsers() infinite-scroll-immediate-check=false><user-info-verification-tile ng-repeat=\"user in vm.users\" data=user context=verified on-status-changed=vm.onUserStatusChanged(user)></user-info-verification-tile><spinner-win spinner=vm.spinner></spinner-win></div></div>");
$templateCache.put("app/components/view-community/pending-posts/pending-posts.html","<div class=view-community-pending-post><div class=view-community-pending-post__header-top>Pending Posts for approval ({{vm.community.stats.pending_discussions || 0}})</div><div ng-if=vm.discussions.length class=view-community-pending-post__discussions infinite-scroll-disabled=vm.isLastPage infinite-scroll=vm.fetchMoreDiscussions() infinite-scroll-immediate-check=false><discussion-item ng-repeat=\"discussion in vm.discussions\" discussion=discussion arrange-by=\"{{vm.arrangeBy.arrangeBy || vm.defaultArrangeBy.arrangeBy}}\" community=vm.community on-removed=vm.onDiscussionRemoved(discussion) on-remove-from-community=vm.onRemoveFromCommunity(discussion.user) on-block-from-community=vm.onBlockFromCommunity(discussion.user) on-approve-discussion=vm.onApproveDiscussion(discussion) on-reject-discussion=vm.onRejectDiscussion(discussion) on-delete-discussion=vm.onDeleteDiscussion(discussion) type=viewPendingPost></discussion-item></div></div>");
$templateCache.put("app/components/view-community/view-community-members/view-community-members.html","<div class=view-community-members><section><div class=view-community-members__toggle><div class=view-community-members__control-data><div class=view-community-members__search><div class=\"view-community-members__search__input__icon icon-icons_search\"></div><input type=text class=view-community-members__search__input placeholder=\"{{\'search-members\' | translate}}\" ng-change=vm.onSearchMembers() ng-model=vm.searchMemberString></div></div><div ng-if=\"vm.selecedActiveMember.length && vm.isOpenNotification\" class=view-community-members__notification><div class=view-community-members__notification__number-selected><span class=view-community-members__notification__number-selected__value>{{vm.selecedActiveCommunities.length}}</span> selected</div><div class=view-community-members__notification__first-control ng-click=vm.onMoveInReviewCommunities(vm.selecedActiveCommunities)>Move to In Review</div><div class=view-community-members__notification__second-control ng-click=vm.onDeactiveCommunities(vm.selecedActiveCommunities)>Deactivate selected</div><div class=\"view-community-members__notification__close-button icon-icons_close\" ng-click=vm.onCloseNotification()></div></div><div class=view-community-members__table><div class=view-community-members__table__header><div ng-if=\"vm.isAdmin && 0\" class=view-community-members__table__header__select><stick-checkbox on-changed=vm.onSelectAllActiveCommunities(vm.isSelectedAllActiveCommunities) model=vm model-property=isSelectedAllActiveCommunities label=all layout-style=regular-square></stick-checkbox></div><div class=\"view-community-members__table__header__label view-community-members__table__header__creator-name\" ng-click=\"vm.sortByProps(\'displayName\')\">Creator Name <span class=\"manage-pending-communities__pending-approval__table__sort-icon icon-chevron-up-down\"></span></div><div class=\"view-community-members__table__header__label view-community-members__table__header__admin\" ng-click=\"vm.sortByProps(\'is_private\')\" ng-if=vm.showAdmin>Admin <span class=\"manage-pending-status-approval__table__sort-icon icon-chevron-up-down\"></span></div><div class=\"view-community-members__table__header__label view-community-members__table__header__creator-type\">Creator Type<grid-filter-sort title=Filter options=vm.accountTypeFilterOptions multi-select=true sort-property=account_type reverse=vm.reverse selected=vm.selectedTypes on-changed=vm.onTypeFilterChanged(items)></grid-filter-sort></div><div class=\"view-community-members__table__header__label view-community-members__table__header__country\" ng-click=\"vm.sortByProps(\'country\')\">Country <span class=\"manage-pending-communities__pending-approval__table__sort-icon icon-chevron-up-down\"></span></div><div class=\"view-community-members__table__header__label view-community-members__table__header__specialty\">Specialty<grid-filter-sort title=Filter options=vm.specialtyFilterOptions multi-select=true selected=vm.selectedSpecialties on-changed=vm.onSpecialtyFilterChanged(items)></grid-filter-sort></div><div class=\"view-community-members__table__header__label view-community-members__table__header__invitation-from\" ng-click=\"vm.sortByProps(\'event_count\')\" ng-if=\"vm.showInvitationFrom \">Invitation from <span class=\"manage-pending-communities__pending-approval__table__sort-icon icon-chevron-up-down\"></span></div><div class=\"view-community-members__table__header__label view-community-members__table__header__member-since\" ng-click=\"vm.sortByProps(\'membership_joined_at\')\" ng-if=vm.showMemberSince>Member Since<span class=\"manage-pending-communities__pending-approval__table__sort-icon icon-chevron-up-down\"></span></div><div class=\"view-community-members__table__header__label view-community-members__table__header__member-since\" ng-click=\"vm.sortByProps(\'membership_joined_at\')\" ng-if=vm.showDateRequest>Date Requested<span class=\"manage-pending-communities__pending-approval__table__sort-icon icon-chevron-up-down\"></span></div><div class=\"view-community-members__table__header__label view-community-members__table__header__member-since\" ng-click=\"vm.sortByProps(\'membership_joined_at\')\" ng-if=vm.showDateInvited>Date Invited<span class=\"manage-pending-communities__pending-approval__table__sort-icon icon-chevron-up-down\"></span></div><div class=\"view-community-members__table__header__label view-community-members__table__header__member-since\" ng-click=\"vm.sortByProps(\'membership_banned_at\')\" ng-if=vm.showDateBlocked>Date Blocked<span class=\"manage-pending-communities__pending-approval__table__sort-icon icon-chevron-up-down\"></span></div><div class=\"view-community-members__table__header__label view-community-members__table__header__action\" ng-class=\"{\'full-size\': vm.memberShipName ==\'requested\', \'medium\': (vm.memberShipName ==\'invited\' || vm.memberShipName ==\'banned\')}\">Action</div></div><div ng-repeat=\"member in vm.members | orderBy:propertyName:vm.reverse\"><manager-member-list-view ng-class=\"{\'actived\': member.selected}\" type={{vm.listViewType}} member=member on-removed=vm.onRemovedUser(member) community=vm.community on-toggle-selected=vm.onSelectActiveCommunity(member) on-member-clicked=\"vm.onCommunityClicked(member, \'active\')\" on-status-changed=vm.onStatusChanged(member) , can-set-manager=false on-manage-clicked=\"vm.onCommunityClicked(community, \'manage\')\"></manager-member-list-view></div><scroll-paging spinner=vm.spinner is-last-page=vm.isLastPage message=\"No more communities.\"></scroll-paging><custom-paging-style ng-if=\"vm.totalMembers  && !vm.spinner.isVisible\" options=vm.customPagingOptions custom-class=view-community-members__data-control total-items=vm.totalMembers total-pages=vm.totalPage on-page-changed=vm.onListChanged(data) on-page-size-changed=vm.onPageSizeChanged(data) show-items=vm.searchParams.page_size current-page=vm.searchParams.page></custom-paging-style></div></div></section><section ng-show=vm.isCommunityDetailsViewOpen class=\"fade-out view-community-members__community-detail-wrapper\"><community-detail-compile-template ng-if=\"vm.selectedCommunity && vm.contextCompileTemplate != \'manage\'\" community=vm.selectedCommunity on-closed=vm.onCommunityDetailsViewClosed() context={{vm.contextCompileTemplate}} on-status-changed=vm.onActiveCommunityGridChanged(community)></community-detail-compile-template><community-detail-edit-compile-template ng-if=\"vm.selectedCommunity && vm.contextCompileTemplate === \'manage\'\" community=vm.selectedCommunity on-closed=vm.onCommunityDetailsViewClosed() context={{vm.contextCompileTemplate}} on-status-changed=vm.onActiveCommunityGridChanged(community)></community-detail-edit-compile-template></section></div>");
$templateCache.put("app/components/view-event/pending-posts/pending-posts.html","<div class=view-community-pending-post><div class=view-community-pending-post__header-top>Pending Event/Class Posts for approval ({{vm.community.post_count || 0}})</div><div ng-if=vm.posts.length class=view-community-pending-post__discussions infinite-scroll-disabled=vm.isLastPage infinite-scroll=vm.fetchMoreDiscussions() infinite-scroll-immediate-check=false><event-post-item ng-repeat=\"post in vm.posts\" post=post arrange-by=\"{{vm.arrangeBy.arrangeBy || vm.defaultArrangeBy.arrangeBy}}\" community=vm.community on-removed=vm.onDiscussionRemoved(post) event=vm.event on-remove-from-community=vm.onRemoveFromCommunity(post.user) on-block-from-community=vm.onBlockFromCommunity(post.user) on-approve-discussion=vm.onApprovePost(post) on-reject-discussion=vm.onRejectPost(post)></event-post-item></div></div>");
$templateCache.put("app/components/view-event/view-event-members/view-event-members.html","<div class=view-event-members><section><div class=view-event-members__toggle><div class=view-event-members__control-data><div class=view-event-members__search><div class=\"view-event-members__search__input__icon icon-icons_search\"></div><input type=text class=view-event-members__search__input placeholder=\"{{\'search-members\' | translate}}\" ng-change=vm.onSearchMembers() ng-model=vm.searchMemberString></div></div><div ng-if=\"vm.selecedActiveMember.length && vm.isOpenNotification\" class=view-event-members__notification><div class=view-event-members__notification__number-selected><span class=view-event-members__notification__number-selected__value>{{vm.selecedActiveCommunities.length}}</span> selected</div><div class=view-event-members__notification__first-control ng-click=vm.onMoveInReviewCommunities(vm.selecedActiveCommunities)>Move to In Review</div><div class=view-event-members__notification__second-control ng-click=vm.onDeactiveCommunities(vm.selecedActiveCommunities)>Deactivate selected</div><div class=\"view-event-members__notification__close-button icon-icons_close\" ng-click=vm.onCloseNotification()></div></div><div class=view-event-members__table><div class=view-event-members__table__header><div ng-if=vm.isAdmin class=view-event-members__table__header__select><stick-checkbox on-changed=vm.onSelectAllActiveCommunities(vm.isSelectedAllActiveCommunities) model=vm model-property=isSelectedAllActiveCommunities label=all layout-style=regular-square></stick-checkbox></div><div class=\"view-event-members__table__header__label view-event-members__table__header__creator-name\" ng-click=\"vm.sortByProps(\'displayName\')\">Creator Name <span class=\"manage-pending-communities__pending-approval__table__sort-icon icon-chevron-up-down\"></span></div><div class=\"view-event-members__table__header__label view-event-members__table__header__admin\" ng-click=\"vm.sortByProps(\'isCommunityManager\')\" ng-if=vm.showAdmin>Admin <span class=\"manage-pending-communities__pending-approval__table__sort-icon icon-chevron-up-down\"></span></div><div class=\"view-event-members__table__header__label view-event-members__table__header__creator-type\" ng-click=\"vm.sortByProps(\'account_type\')\">Creator Type <span class=\"manage-pending-communities__pending-approval__table__sort-icon icon-chevron-up-down\"></span></div><div class=\"view-event-members__table__header__label view-event-members__table__header__country\" ng-click=\"vm.sortByProps(\'country\')\">Country <span class=\"manage-pending-communities__pending-approval__table__sort-icon icon-chevron-up-down\"></span></div><div class=\"view-event-members__table__header__label view-event-members__table__header__member\" ng-click=\"vm.sortByProps(\'isCommunityMember\')\">Member? <span class=\"manage-pending-communities__pending-approval__table__sort-icon icon-chevron-up-down\"></span></div><div class=\"view-event-members__table__header__label view-event-members__table__header__status\" ng-click=\"vm.sortByProps(\'inviteStatus\')\" ng-if=vm.showStatus>Status<span class=\"manage-pending-communities__pending-approval__table__sort-icon icon-chevron-up-down\"></span></div><div class=\"view-event-members__table__header__label view-event-members__table__header__action\" ng-class=\"{\'full-size\': vm.memberShipName ==\'requested\', \'medium\': (vm.memberShipName ==\'invited\' || vm.memberShipName ==\'banned\')}\">Action</div></div><div ng-repeat=\"member in vm.members | orderBy:propertyName:reverse\"><manager-event-member-list-view ng-class=\"{\'actived\': member.selected}\" type=viewEvent ng-if=\"self.loginedUser && member.id != self.loginedUser.id\" member=member on-removed=vm.onRemovedUser(member) community=vm.community event=vm.event on-toggle-selected=vm.onSelectActiveCommunity(member) on-member-clicked=\"vm.onCommunityClicked(member, \'active\')\" on-status-changed=vm.onStatusChanged(member) on-manage-clicked=\"vm.onCommunityClicked(community, \'manage\')\"></manager-event-member-list-view></div><scroll-paging spinner=vm.spinner is-last-page=vm.isLastPage message=\"No more communities.\"></scroll-paging><custom-paging-style ng-if=\"vm.totalMembers  && !vm.spinner.isVisible\" options=vm.customPagingOptions custom-class=view-event-members__data-control total-items=vm.totalMembers total-pages=vm.totalPage on-page-changed=vm.onListChanged(data) on-page-size-changed=vm.onPageSizeChanged(data) show-items=vm.searchParams.page_size current-page=vm.searchParams.page></custom-paging-style></div></div></section><section ng-show=vm.isCommunityDetailsViewOpen class=\"fade-out view-event-members__community-detail-wrapper\"><community-detail-compile-template ng-if=\"vm.selectedCommunity && vm.contextCompileTemplate != \'manage\'\" community=vm.selectedCommunity on-closed=vm.onCommunityDetailsViewClosed() context={{vm.contextCompileTemplate}} on-status-changed=vm.onActiveCommunityGridChanged(community)></community-detail-compile-template><community-detail-edit-compile-template ng-if=\"vm.selectedCommunity && vm.contextCompileTemplate === \'manage\'\" community=vm.selectedCommunity on-closed=vm.onCommunityDetailsViewClosed() context={{vm.contextCompileTemplate}} on-status-changed=vm.onActiveCommunityGridChanged(community)></community-detail-edit-compile-template></section></div>");
$templateCache.put("app/custom-commissions-detail-page/components/custom-commission-detail-page-grid-controls/custom-commission-detail-page-grid-controls.html","<div class=\"custom-commission-detail-page-grid-controls clearfix\"><div class=custom-commission-detail-page-grid-controls__order__text translate>{{\'sort-by\'}}</div><ul class=\"custom-commission-detail-page-grid-controls__order__input clearfix\"><li class=custom-commission-detail-page-grid-controls__order__input__select><popover-selection-btn close-on-click=true on-selection-changed=vm.onSelectionChange(item) selected-model=vm.selectedFilterItem settings=vm.filterSetting></popover-selection-btn></li></ul><div class=\"custom-commission-detail-page-grid-controls__layout clearfix\"><div class=custom-commission-detail-page-grid-controls__layout__grid><span class=\"fa fa-th\"></span></div><div class=custom-commission-detail-page-grid-controls__layout__list><span class=icon-icons_navicon></span></div></div></div>");
$templateCache.put("app/custom-commissions-detail-page/components/custom-commission-detail-page-photo-grid/custom-commission-detail-page-photo-grid.html","<div class=custom-commission-detail-page-photo-grid ng-class=vm.viewMode><div ng-if=\"vm.items.length == 0\"><ng-transclude></ng-transclude></div><div ng-if=\"vm.items.length > 0\" class=\"custom-commission-detail-page-photo-grid__control clearfix\"><custom-commission-detail-page-grid-controls on-selection-change=vm.onSortChange(item)></custom-commission-detail-page-grid-controls></div><div class=custom-commission-detail-page-photo-grid__photos-wrapper ng-class=vm.viewMode><div ng-show=\"vm.viewMode == \'group\'\" ng-if=\"vm.itemByGroup.length > 0 || true\" infinite-scroll-disabled=vm.isLastPage infinite-scroll=vm.fetchMoreItems() infinite-scroll-immediate-check=false><div class=\"custom-commission-detail-page-photo-grid__collection clearfix\" ng-repeat=\"group in vm.itemByGroup\"><div class=\"custom-commission-detail-page-photo-grid__items clearfix\"><div class=custom-commission-detail-page-photo-grid__group-header><div class=custom-commission-detail-page-photo-grid__group-header__time>{{group[0].title}}</div><div class=custom-commission-detail-page-photo-grid__group-header__comment ng-if=hideComment><span class=text--bold>{{vm.loginedUser.id == group[0].media.user.id ? \'You said\' : group[0].media.user.displayName + \' says\'}}: </span>\"{{group[0].note}}\"</div></div><div class=\"custom-commission-detail-page-photo-grid__group-wrapper clearfix\"><custom-commissions-selection-tile settings=settingsCustomComissionsTile data=item ng-repeat=\"item in group\" on-changed=vm.onPhotoSelected(item) datas=group unchecked-checkbox-tooltip={{itemUncheckedCheckboxTooltip}} checked-checkbox-tooltip={{itemCheckedCheckboxTooltip}} is-group=true custom-commissions-id={{customCommissionId}}></custom-commissions-selection-tile></div></div></div></div><div ng-show=\"vm.viewMode == \'flat\'\" class=clearfix ng-if=\"vm.items.length > 0\" infinite-scroll-disabled=vm.isLastPage infinite-scroll=vm.fetchMoreItems() infinite-scroll-immediate-check=false><custom-commissions-selection-tile settings=settingsCustomComissionsTile data=item ng-repeat=\"item in vm.items\" on-changed=vm.onPhotoSelected(item) datas=vm.items is-group=true custom-commissions-id={{customCommissionId}}></custom-commissions-selection-tile></div><spinner-win spinner=vm.spinner></spinner-win></div></div>");
$templateCache.put("app/custom-commissions-detail-page/components/custom-commission-detail-page-selection-guided-text/custom-commission-detail-page-selection-guided-text.html","<div class=custom-commissions-detail-page__content-view__footer__left__inner-wrapper><div class=\"custom-commissions-detail-page__content-view__footer__icon vertical-align-middle--flex\" ng-if=iconClass><div class=icon-remove-circle-outline></div></div><div class=\"custom-commissions-detail-page__content-view__footer__description vertical-align-middle--flex\"><div class=\"custom-commissions-detail-page__content-view__footer__item-selected text--semibold\">{{data.selectedItems.length + (data.selectedItems.length == 1 ? \' photo\' : \' photos\')}} selected</div><div class=custom-commissions-detail-page__content-view__footer__hint>Shift+click to multi-select</div></div></div>");
$templateCache.put("app/custom-commissions-detail-page/components/custom-commission-detail-page-upload-guided-zone/custom-commission-detail-page-upload-guided-zone.html","<div class=custom-commission-detail-page-upload-guided-zone><div class=\"custom-commission-detail-page-upload-guided-zone__content__empty-state custom-commission-detail-page-upload-guided-zone__dropzone\"><div class=custom-commission-detail-page-upload-guided-zone__dropzone__label><span class=custom-commission-detail-page-upload-guided-zone__dropzone__icon>&nbsp;</span><div class=custom-commission-detail-page-upload-guided-zone__dropzone__title>{{text}}</div><div class=custom-commission-detail-page-upload-guided-zone__dropzone__drop-text-wrapper><!-- <div>Drag & drop here</div>\r\n                <div>- OR -</div> --></div></div><button class=\"custom-commission-detail-page-upload-guided-zone__dropzone__select-photo btn btn-submit\" ng-click=onSelectBtnClicked()>{{\'select-photos\' | translate}}</button></div></div>");
$templateCache.put("app/custom-commissions-detail-page/components/custom-commissions-detail-page-approval/custom-commissions-detail-page-approval.html","<div class=custom-commissions-detail-page-approval><section ui-view=leftCol class=custom-commissions-detail-page-approval__left-col></section><section ui-view=mainContent class=custom-commissions-detail-page-approval__main-content></section><section ui-view=rightCol class=custom-commissions-detail-page-approval__right-col></section></div>");
$templateCache.put("app/custom-commissions-detail-page/components/custom-commissions-detail-page-brief/custom-commissions-detail-page-brief.html","<div class=custom-commissions-detail-page-brief></div>");
$templateCache.put("app/custom-commissions-detail-page/components/custom-commissions-detail-page-delivery/custom-commissions-detail-page-delivery.html","<div class=custom-commissions-detail-page-delivery><section ui-view=leftCol class=custom-commissions-detail-page-delivery__left-col></section><section ui-view=mainContent class=custom-commissions-detail-page-delivery__main-content></section></div>");
$templateCache.put("app/custom-commissions-detail-page/components/custom-commissions-detail-page-download/custom-commissions-detail-page-download.html","<div class=custom-commissions-detail-page-download><div class=custom-commissions-detail-page-download__content><div ng-if=\"vm.tickets.length == 0\" class=custom-commissions-detail-page-download__no-tickest-message-wrapper><div ng-if=\"vm.parent.customCommissions.stats.selected_submission_count === vm.parent.customCommissions.selection_limit\"><div>To request for the high resolution files, please click on the \"Selected photos\" tab and submit your request.</div><!-- <a ui-sref=\"custom-commissions-detail-page.shortlist\"><button class=\"btn btn-submit\">Request Hires photos</button></a> --></div><div ng-if=\"vm.parent.customCommissions.stats.selected_submission_count < vm.parent.customCommissions.selection_limit\"><div>Please complete your selection of <span class=\"text--bold text--color-black\">{{vm.customCommissionsData.selection_limit}}</span> photos in order to request for the high resolution files.</div><a ui-sref=custom-commissions-detail-page.selection><button class=\"btn btn-submit\">{{\'select-photos\' | translate}}</button></a></div></div><div ng-repeat=\"item in vm.tickets\"><div class=custom-commissions-detail-page-download__content__pending ng-if=\"item.state == \'open\'\"><div class=custom-commissions-detail-page-download__content__pending__title>You have requested <a class=\"text--bold text--color-black\">{{item.assigned_to.first_name + \' \' + item.assigned_to.last_name}}</a> to upload the high resolution photos from this Custom Commission.</div><div class=custom-commissions-detail-page-download__content__pending__label-download>Download link</div><div class=\"custom-commissions-detail-page-download__content__pending__link-download text--semibold\">Pending download link</div></div><div class=custom-commissions-detail-page-download__content__container ng-if=\"item.state == \'responded\'\"><div class=custom-commissions-detail-page-download__content__container__title><div class=custom-commissions-detail-page-download__content__container__author__label><span class=custom-commissions-detail-page-download__content__container__author__title>{{item.assigned_to.first_name + \' \' + item.assigned_to.last_name}}</span> has uploaded the high resolution photos</div><div class=custom-commissions-detail-page-download__content__container__time>1 file, {{item.metadata.sizeFormatted}} in total - Will be deleted on <span class=custom-commissions-detail-page-download__content__container__time__label>{{item.metadata.expiryFormatted}}</span></div></div><div class=custom-commissions-detail-page-download__content__container__message ng-if=item.metadata.message><div class=custom-commissions-detail-page-download__content__container__message__label>Message</div><div class=custom-commissions-detail-page-download__content__container__message__content>{{item.metadata.message}}</div></div><div class=custom-commissions-detail-page-download__content__container__link-download><div class=custom-commissions-detail-page-download__content__container__link-download__label>Download link</div><a ng-href={{item.metadata.downloadLink}} class=custom-commissions-detail-page-download__content__container__link-download__content>{{item.metadata.downloadLink}}</a><!-- <button class=\"custom-commissions-detail-page-download__content__container__link-download__request-btn btn btn-submit\" ng-click=\"vm.onRequestAgainClicked()\">Request again</button> --></div></div></div></div></div>");
$templateCache.put("app/custom-commissions-detail-page/components/custom-commissions-detail-page-hi-res/custom-commissions-detail-page-hi-res.html","<div class=custom-commissions-detail-page-hi-res><div class=custom-commissions-detail-page__content-view__top-btns ng-if=\"vm.photoGrid.totalPhotos > 0  && vm.customCommissionsData.selection_state == \'open\'\"><button loading-spinner ng-disabled=vm.isWorking ng-class=\"{\'is-working\': vm.isWorking}\" ng-if=\"vm.photoGrid.totalPhotos >=  vm.customCommissionsData.selection_limit\" class=\"custom-commissions-detail-page-hi-res__ btn btn-submit\" ng-click=vm.onReleaseClicked()>Releases</button> <button ng-if=\"vm.photoGrid.totalPhotos < vm.customCommissionsData.selection_limit\" class=\"btn btn-submit\" ng-click=vm.onUploadPhotoClicked()>Upload</button></div><div class=\"custom-commissions-detail-page-hi-res__content clearfix\"><div><custom-commission-detail-page-photo-grid custom-commission-id=vm.customCommissionsData.id on-init=vm.onPhotoGridInit(instance) on-photo-selected=vm.onPhotoSelected(item) settings-custom-comissions-tile=vm.settingsCustomComissionsTile><custom-commission-detail-page-upload-guided-zone ng-if=\"(!vm.items || !vm.photoGrid.totalPhotos) && vm.customCommissionsData.selection_state == \'open\'\" on-select-btn-clicked=vm.onUploadPhotoClicked() text=\"Upload high-resolution photos here.\"></custom-commission-detail-page-upload-guided-zone><div class=custom-commissions-detail-page-hi-res__content__empty-state ng-if=!vm.customCommissionsData.selection_state>{{vm.customCommissionsData.organization.name}} has not requested for the high resolution photos yet.</div></custom-commission-detail-page-photo-grid></div></div><div ng-if=\"vm.selectedItems && vm.selectedItems.length && vm.customCommissionsData.selection_state !== \'responded\'\" class=custom-commissions-detail-page__content-view__footer><div class=\"custom-commissions-detail-page__content-view__footer__left vertical-align-middle--flex\"><custom-commission-detail-page-selection-guided-text data=vm icon-class=true></custom-commission-detail-page-selection-guided-text></div><div class=\"custom-commissions-detail-page__content-view__footer__right vertical-align-middle--flex\"><button class=\"custom-commissions-detail-page__content-view__footer__shortlist-btn btn btn--white-magento\" ng-click=vm.onDelBtnClicked(vm.selectedItems)>Delete</button></div></div></div>");
$templateCache.put("app/custom-commissions-detail-page/components/custom-commissions-detail-page-selection/custom-commissions-detail-page-selection.html","<div class=custom-commissions-detail-page-selection><div class=custom-commissions-detail-page__content-view__top-btns ng-if=\"vm.loginedUser.isContributor && vm.photoGrid.items.length && !vm.commissionsData.selection_state\"><button class=\"btn btn-submit\" ng-click=vm.onUploadPhotoClicked()>Upload More</button></div><div class=custom-commissions-detail-page-selection__content><custom-commission-detail-page-photo-grid hide-comment=true item-unchecked-checkbox-tooltip=\"{{vm.loginedUser.isBiz ? \'Add to selection\' : \'Delete\'}}\" custom-commission-id=vm.commissionsData.id on-init=vm.onPhotoGridInit(instance) on-photo-selected=vm.onPhotoSelected(item) settings-custom-comissions-tile=vm.settingsCustomComissionsTile><custom-commission-detail-page-upload-guided-zone ng-if=\"!vm.commissionsData.selection_state && vm.loginedUser.isContributor && (vm.photoGrid.items.length === 0)\" on-select-btn-clicked=vm.onUploadPhotoClicked() text=\"Upload low resolution photos for the client\'s selection.\"></custom-commission-detail-page-upload-guided-zone><div class=custom-commissions-detail-page-hi-res__content__empty-state ng-if=\"vm.commissionsData.stats.selected_submission_count == 0 && vm.loginedUser.isBiz\">The photographer has not uploaded images from this Custom Commission yet.</div><!-- <div class=\"custom-commissions-detail-page-hi-res__content__empty-state\" ng-if=\"vm.commissionsData.stats.selected_submission_count > 0\">\r\n\r\n				All submissions are selected.\r\n			</div> --></custom-commission-detail-page-photo-grid></div><div ng-if=\"vm.selectedItems && vm.selectedItems.length && !vm.commissionsData.selection_state\" class=custom-commissions-detail-page__content-view__footer><div class=\"custom-commissions-detail-page__content-view__footer__left vertical-align-middle--flex\"><custom-commission-detail-page-selection-guided-text data=vm></custom-commission-detail-page-selection-guided-text></div><div class=\"custom-commissions-detail-page__content-view__footer__right vertical-align-middle--flex\"><div class=custom-commissions-detail-page__content-view__footer__right__inner-wrapper><div class=vertical-align-middle--flex ng-if=\"vm.loginedUser.isBiz && vm.selectedItems.length + vm.commissionsData.stats.selected_submission_count == vm.commissionsData.selection_limit\"><div class=\"custom-commissions-detail-page__content-view__footer__right__inner-wrapper__text text--semibold\">You have selected the maximum number of photos.</div></div><div class=vertical-align-middle--flex ng-if=vm.loginedUser.isBiz><button class=\"custom-commissions-detail-page__content-view__footer__shortlist-btn btn btn--white-magento\" ng-click=vm.onAddToShortlist(vm.selectedItems)>Add to Selection</button></div></div><button class=\"custom-commissions-detail-page__content-view__footer__shortlist-btn btn btn--white-magento\" ng-if=vm.loginedUser.isContributor ng-click=vm.onDelBtnClicked(vm.selectedItems)>Delete</button></div></div></div>");
$templateCache.put("app/custom-commissions-detail-page/components/custom-commissions-detail-page-shortlist/custom-commissions-detail-page-shortlist.html","<div class=custom-commissions-detail-page-shortlist><div class=\"custom-commissions-detail-page__content-view__header clearfix\"><div class=custom-commissions-detail-page__content-view__header__left-text>{{vm.customCommissionsData.organization.name}} has selected <span class=\"text--bold text--color-black\">{{vm.customCommissionsData.stats.selected_submission_count}}/{{vm.customCommissionsData.selection_limit}}</span> photos, and has <span class=\"text--bold text--color-black\">{{vm.customCommissionsData.selection_limit - vm.customCommissionsData.stats.selected_submission_count}}</span> remaining photos to select.</div></div><div class=\"custom-commissions-detail-page-shortlist__content clearfix\"><custom-commission-detail-page-photo-grid item-unchecked-checkbox-tooltip=\"{{vm.isManager ? \'Remove from selection\' : \'\'}}\" view-mode=flat custom-commission-id=vm.customCommissionsData.id on-init=vm.onPhotoGridInit(instance) on-photo-selected=vm.onPhotoSelected(item) settings-custom-comissions-tile=vm.settingsCustomComissionsTile></custom-commission-detail-page-photo-grid></div><div class=custom-commissions-detail-page__content-view__footer ng-if=\"vm.isManager && ((vm.selectedItems && vm.selectedItems.length) || ((!vm.selectedItems || !vm.selectedItems.length) && vm.customCommissionsData.stats.selected_submission_count == vm.customCommissionsData.selection_limit))\"><div class=\"custom-commissions-detail-page__content-view__footer__left vertical-align-middle--flex\" ng-if=\"vm.selectedItems && vm.selectedItems.length\"><custom-commission-detail-page-selection-guided-text data=vm icon-class=true></custom-commission-detail-page-selection-guided-text></div><div class=\"custom-commissions-detail-page__content-view__footer__right vertical-align-middle--flex\"><div class=custom-commissions-detail-page__content-view__footer__right__inner-wrapper ng-if=\"(!vm.selectedItems || !vm.selectedItems.length) && vm.customCommissionsData.stats.selected_submission_count == vm.customCommissionsData.selection_limit\"><div class=vertical-align-middle--flex ng-if=\"vm.canRequestDownload && !vm.customCommissionsData.selection_state\"><div class=custom-commissions-detail-page__content-view__footer__right__inner-wrapper__text>Would you like to request for the high resolution photos?</div></div><div class=vertical-align-middle--flex ng-if=vm.customCommissionsData.selection_state><div class=\"custom-commissions-detail-page__content-view__footer__right__inner-wrapper__text text--semibold\">You have already requested for high-res photos.</div></div><div class=vertical-align-middle--flex ng-if=\"vm.canRequestDownload && !vm.customCommissionsData.selection_state\"><button class=\"custom-commissions-detail-page__content-view__footer__shortlist-btn btn btn--white-magento\" ng-click=vm.onRequestBtnClicked()>Request high-res photos</button></div></div><button class=\"custom-commissions-detail-page__content-view__footer__shortlist-btn btn btn--white-magento\" ng-if=\"vm.selectedItems && vm.selectedItems.length && vm.canRequestDownload && !vm.customCommissionsData.selection_state\" ng-click=vm.onDelBtnClicked(vm.selectedItems)>Remove from Selection</button></div></div></div>");
$templateCache.put("app/error/404/community/community-not-found.html","<div class=community-not-found><section class=\"row community-not-found__bg no-margin\"><div class=ops>Oops!</div><div class=not-exist-notice>The community you are looking for does not exist.</div><button class=\"btn btn--take-back text--bold\" ng-click=vm.takeBack()>Take Me Back</button></section></div>");
$templateCache.put("app/event-detail-page/components/event-feed/event-feed.html","<div class=event-feed><div class=event-feed__wrapper ng-if=\"!vm.community.is_private || (vm.community.is_private && (vm.community.membership_status === \'accepted\' || vm.community.membership_status === \'owner\'))\"><!-- <div class=\"event-feed__header\">\r\n			<div class=\"event-feed__header__search\">\r\n				<div class=\"event-feed__header__search__input__icon icon-icons_search\"></div>\r\n				<input type=\"text\" class=\"event-feed__header__search__input\"\r\n					placeholder=\"Search for posts in this community\" ng-change=\"vm.onSearchPost()\"\r\n					ng-model=\"vm.searchPostString\"></input>\r\n			</div>\r\n		</div> --><div ng-if=vm.canStartPost class=event-feed__topic><div class=event-feed__topic__label translate>{{\'create-post\'}}</div><div class=event-feed__topic__input-wrapper><div class=event-feed__topic__owner-avatar><pixerf-user-avatar user-data=vm.loginedUser lazy=true></pixerf-user-avatar></div><div class=event-feed__topic__input ng-click=vm.onStartPost()>{{\'Whats-on-your-mind-today\' | translate}}</div></div></div></div><div class=event-feed__thread><div ng-if=\"!vm.event.is_private || (vm.event.is_private && vm.event.has_joined) || (vm.event.is_private && vm.canStartPost)\" class=event-feed__thread__header><div class=event-feed__thread__label translate>{{\'discussions\'}}</div><!-- <div class=\"event-feed__thread__arrange\">\r\n				<div class=\"event-feed__thread__arrange__label\">{{\'arrange-by\' | translate}}:</div>\r\n				<div class=\"event-feed__thread__arrange__list\">\r\n					<custom-radio-button is-disabled=\"!vm.posts.length\" ng-repeat=\"item in vm.arrangeOptions.selections\"\r\n						default=\"{{(item.value == vm.defaultArrangeBy.arrangeBy) ? \'true\' : \'false\'}}\"\r\n						class=\"event-feed__thread__arrange__item\" ng-class=\"{\'disabled\': !vm.posts.length}\"\r\n						model=\"vm.arrangeBy\" options=\"vm.arrangeOptions\" model-property=\"{{vm.arrangeOptions.props}}\"\r\n						value=\"vm.arrangeOptions.selections[$index].value\"\r\n						label=\"vm.arrangeOptions.selections[$index].label\" on-changed=\"vm.onArrageChanged(data)\">\r\n					</custom-radio-button>\r\n				</div>\r\n			</div> --></div><div class=event-feed__thread__body><div ng-if=\"vm.event.is_private && !vm.event.is_community_member && !vm.canStartPost\" class=event-feed__thread__body__empty><div class=event-feed__thread__body__empty__title>This {{vm.itemType}} is private.</div><div class=event-feed__thread__body__empty__content>Join the hosting community to see join {{vm.itemType}} and view {{vm.itemType}} posts and photos.</div><div class=\"event-feed__thread__body__empty__button btn btn-submit\" authentication-click=vm.onRequestToJoinedClicked() check-verified-email=true>{{vm.submitButtonText}}</div></div><div ng-if=\"!vm.posts.length && !vm.isWorking && (!vm.event.is_private || vm.event.is_community_member || vm.canStartPost)\" class=event-feed__thread__body__empty><div class=event-feed__thread__body__empty__title>{{vm.isMine ? \'You do not\' : vm.event.community_name + \' doesn\\\'t\'}} have any {{vm.itemType}} discussions</div><div ng-if=vm.canStartPost class=event-feed__thread__body__empty__content translate>{{vm.isTypeClass ? \'class-post-keep-your-community-engaged\' : \'event-post-keep-your-community-engaged\'}}</div><div ng-if=vm.canStartPost class=\"event-feed__thread__body__empty__button btn btn-submit\" ng-click=vm.onStartPost()>{{vm.isTypeClass ? \'start-a-class-post\' : \'start-a-event-post\' | translate}}</div></div><div ng-if=vm.posts.length class=event-feed__thread__body__discussions infinite-scroll-disabled=vm.isLastPage infinite-scroll=vm.fetchMorePosts() infinite-scroll-immediate-check=false><event-post-tile ng-repeat=\"post in vm.posts\" post=post community=vm.community ng-if=\"post.status ==\'published\'\" on-removed=vm.onPostRemoved(post) is-member=vm.event.is_community_member></event-post-tile></div></div></div></div><!-- <div class=\"event-feed\">\r\n    <div class=\"event-feed__post\">\r\n        <div ng-if=\"vm.canCreatePost\" class=\"event-feed__post__label\" translate>{{\'create-a-new-post\'}}</div>\r\n        <div ng-if=\"vm.canCreatePost\" class=\"event-feed__post__input-wrapper\">\r\n            <div class=\"event-feed__post__owner-avatar\"\r\n                ng-style=\"{\'background-image\': \'url(\\\'\' + vm.loginedUser.profile_image_media[\'100x\'] + \'\\\')\'}\"></div>\r\n            <div class=\"event-feed__post__input\" ng-click=\"vm.onStartPost()\">{{\'write-a-post\' | translate}}</div>\r\n        </div>\r\n        <div class=\"event-feed__post__thread\">\r\n            <empty-section ng-if=\"!vm.posts.length\" content=\"vm.emptyPost\" on-submit=vm.onStartPost()></empty-section>\r\n            <div ng-if=\"vm.posts.length\" class=\"community-detail-post__thread__body__post\"\r\n                infinite-scroll-disabled=\"vm.isLastPage\" infinite-scroll=\"vm.fetchMoreEventPosts()\"\r\n                infinite-scroll-immediate-check=\"false\">\r\n                <event-post-tile ng-repeat=\"post in vm.posts\" post=\"post\"\r\n                    community=\"vm.community\" on-removed=\"vm.onPostRemoved(post)\"></event-post-tile>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div> -->");
$templateCache.put("app/event-detail-page/components/event-photos/event-photos.html","<div class=event-photos><div class=event-photos__post><div class=event-photos__post__header><div class=event-photos__post__label translate>{{vm.event.name}}</div><button ng-if=vm.isMine class=event-photos__post__header__btn ng-click=vm.onAddPhotos()><span class=\"event-photos__post__header__btn-icon icon-icons_plus\"></span> <span class=event-photos__post__header__btn-label>Add photo</span></button></div><div ng-if=vm.photos.length class=event-photos__post__photo-list><div flex-grid ng-model=vm.photos margins=3 rowheight=200><div ng-repeat=\"photo in vm.photos\" class=event-photos__post__photo-list__item><div ng-if=vm.isMine class=\"event-photos__post__photo-list__remove-icon icon-icons_close\" uib-tooltip=\"Remove this photo\" ng-click=vm.onDeletePhoto(photo) tooltip-append-to-body=true></div><a ng-attr-fancyboxable=\"{\'type\': \'image\', \'overlayShow\': true, \'hideOnOverlayClick\': true, \'showNavArrows\': true, \'margin\': \'50 10 15 10\', \'centerOnScroll\': true}\" href={{photo.url.large}} rel=discussionAttachment><img ng-src={{photo.url.medium}}></a></div></div></div><!-- <div ng-if=\"vm.isMine\" class=\"event-photos__post__label\" translate>{{\'create-a-new-post\'}}</div> --><div class=event-photos__post__thread><empty-section ng-if=!vm.photos.length content=vm.emptyPhotos on-submit=vm.onAddPhotos()></empty-section><div ng-if=vm.emptyPhotos.length class=community-detail-post__thread__body__post infinite-scroll-disabled=vm.isLastPage infinite-scroll=vm.fetchMoreEventPosts() infinite-scroll-immediate-check=false><event-post-tile ng-repeat=\"post in vm.posts\" post=post community=vm.community on-removed=vm.onPostRemoved(post)></event-post-tile></div></div></div></div>");
$templateCache.put("app/event-detail-page/components/event-schedule/event-schedule.html","<div class=event-schedule>Schedule</div>");
$templateCache.put("app/explore-creators-page/components/creator-agreement/creator-agreement.html","<div class=\"contributor-page no-margin\"><section class=\"row contributor-page-branding-wrapper\"><div class=\"contributor-page__branding contributor__branding\"><p class=\"contributor-page__branding--earn text-center\">Creator Agreement</p><photo-info-link photo=vm.brandingPhoto></photo-info-link></div></section><section class=\"row contributor-page-howitworks__wrapper\"><div class=contributor-page-howitworks__content-left><p class=\"contributor-page-howitworks__heading text--semibold text--color-black\">Creator Agreement</p><div class=contributor-page-howitworks__main-content><p>This Creator Agreement (the \"<u>Agreement</u>\") sets forth the terms and conditions between you (the \"<u>Creator</u>\" or \"<u>You</u>\"), and PIXERF Pte Ltd to submit or upload any Marketplace Visual Content.</p><p>Please review this Agreement carefully before submitting or uploading any Marketplace Visual Content. By submitting or uploading any Marketplace Visual Content, you agree to be bound by the terms of this Agreement, in addition to the <span ui-sref=introduction-company.terms class=subscription-page-business-link>Terms and Conditions</span> and our <span ui-sref=introduction-company.privacy class=subscription-page-business-link>Privacy Policy</span>. If you do not agree to this Creator Agreement, please do not submit or upload any Marketplace Visual Content.</p><p>We reserve the right to make changes to this Agreement at any time as published from time to time through the Site. By using the Site on or after the date on which this Agreement have been revised, your use would be deemed as acceptance of the revised terms.</p><p>Unless otherwise defined in this Agreement, the terms used herein shall bear the same meanings as in the Terms and Conditions.</p><ol><li><span class=\"contributor-page-howitworks__sub-heading text--bold text--color-black\">Submission of Marketplace Visual Content</span><ol><li>PIXERF may determine at its sole discretion which Marketplace Visual Content is deemed suitable for submission or upload by the Creator. PIXERF may provide submission guidelines and procedures for the Marketplace Visual Content, which may be revised from time to time, and you agree to comply with such submission guidelines and procedures (including any revisions thereto) by submitting or uploading any Marketplace Visual Content. Any breach of these guidelines and procedures may be deemed to be a breach of this Agreement. Each submission or upload of Marketplace Visual Content will be governed by the terms and conditions of this Agreement.</li><li><span class=\"text--bold text--color-black\">Removal of Marketplace Visual Content.</span> PIXERF reserves the right to remove or reject Marketplace Visual Content based on marketability, the Creator’s failure or neglect to comply with the submission guidelines or procedures, or for any reason whatsoever in its sole discretion. Any licence for the Marketplace Visual Content which had been issued or granted prior to such removal or termination of this Agreement shall continue in effect in accordance with the terms of the applicable <span ui-sref=introduction-company.license class=subscription-page-business-link>Licence Agreement</span>.</li><li><span class=\"text--bold text--color-black\">Releases.</span> Marketplace Visual Content may be marked as for \"Editorial Use Only\" or for \"Commercial Use\". You may be required to submit model or property releases for your Marketplace Visual Content in order for it to be marked as for \"Commercial Use\", if the Marketplace Visual Content contains images or people or persons in relation to model releases, or if the Marketplace Visual Content contains identifiable property in relation to property releases (collectively, the \"<u>Releases</u>\"). The forms for these Releases can requested to be sent to you via email when you upload an image for commercial licensing.</li></ol></li><li><span class=\"contributor-page-howitworks__sub-heading text--bold text--color-black\">Grant of Rights</span><ol><li>Subject to this Agreement, the Creator may grant PIXERF either an exclusive or a non-exclusive licence to license, sublicense, market and distribute the Marketplace Visual Content worldwide and the right to copy, use, reproduce, distribute, publish, transmit, broadcast, perform, display, exhibit, adapt, modify, edit or enhance any Marketplace Visual Content, in whole or in part, alone or in combination with any other material, in any media or embodiment, now known or later developed, for any lawful purpose, including the right to distribute and sell consumer products (for example, by reproducing the Marketplace Visual Content on products sold to consumers including but not limited to posters, mugs, calendars, website templates, card templates).</li><li>PIXERF shall have complete and sole discretion regarding the terms, conditions and pricing of any Marketplace Visual Content licensed to other Users without the prior approval of the Creator.</li><li>If the Creator elects to grant PIXERF an exclusive licence in relation to the Marketplace Visual Content, the Creator agrees to not license or distribute the Marketplace Visual Content to any other party until the exclusivity period expires. The Creator may use any Marketplace Visual Content submitted for their own personal, non-commercial purposes, for example their portfolio, personal website and self-promotion. However, the Creator shall refer any licensing requests regarding the Marketplace Visual Content to PIXERF.</li><li>In addition to the foregoing, the Creator grants PIXERF the right, but not the obligation, to use the Creator’s name, trademarks and trade names, and the right to reproduce, display, transmit, exhibit, modify and adapt any Marketplace Visual Content to promote, market and advertise PIXERF or otherwise for PIXERF’s own business purposes in relation to the promotion of the Site; and the Creator agrees that no compensation or further consent will be required for such use.</li><li>In the event that the Creator has elected to grant PIXERF an exclusive licence in relation to the Marketplace Visual Content, the Creator thereby grants PIXERF the exclusive right, but not the obligation, to determine in its sole discretion whether and to what extent to proceed with any legal proceedings or action, and/or to defend any claims or counterclaims regarding the Marketplace Visual Content. Any such legal action or proceeding may be settled or resolved by PIXERF without the Creator’s prior approval and will not be subject to it, provided that PIXERF shall not enter into any settlement or resolution which will diminish the Creator’s ownership in the Marketplace Visual Content.</li><li>Where PIXERF has elected to commence any legal proceedings or actions, and/or to defend any claims or counterclaims regarding the Marketplace Visual Content, the Creator agrees to give PIXERF control of the handling, settlement, or defence of any such claims, and to provide assistance to PIXERF in relation to the legal proceedings or actions, including but not limited to providing PIXERF and our professional advisors with reasonable access to any relevant documents and records. The Creator further agrees to be named in and be joined in as a party to any such proceedings or actions in or defence of any legal claim.</li><li>Where PIXERF has elected not to commence any legal proceedings or actions, and/or to defend any claims or counterclaims regarding the Marketplace Visual Content, the Creator retains the right to bring an action in its own name and at its own expense. The Creator agrees that any recovery it receives in its own legal action involving the Marketplace Visual Content, whether through settlement, adjudication or otherwise, shall be divided between PIXERF and the Creator pursuant to the provisions in Clause 5 (Compensation) after payment of all reasonable legal costs and expenses.</li></ol></li><li><span class=\"contributor-page-howitworks__sub-heading text--bold text--color-black\">Proprietary Rights</span><ol><li><span class=\"text--bold text--color-black\">Ownership.</span> The Creator retains ownership and copyright in the Marketplace Visual Content. While PIXERF will take commercially reasonable steps to ensure that the rights of the Creators are not violated by other Users or other parties, PIXERF has no obligation to pursue any legal action regarding any alleged infringement of any rights in relation to any Marketplace Visual Content.</li><li><span class=\"text--bold text--color-black\">Credit.</span> While PIXERF will use commercially reasonable efforts to credit the Creator as the source of the Marketplace Visual Content, the Creator acknowledges that the Users may not credit the Creator as the owner of the Marketplace Visual Content licensed by PIXERF, and that PIXERF may be associated with the Marketplace Visual Content as the source of such content, without any liability to PIXERF or the Users. The Creator further acknowledges and agrees that related metadata may be altered, removed or modified, without any liability to PIXERF or the Users.</li><li>The Creator acknowledges that PIXERF prohibits any Marketplace Visual Content, descriptive information regarding such content or any other material that infringes on any patent, trademark, copyright, trade secret, right to privacy, right to publicity, or any other applicable law or proprietary right from being submitted or uploaded to the Site. By submitting or uploading Marketplace Visual Content, you are warranting that you own all ownership rights to the Marketplace Visual Content or are the authorised representative of the copyright owner(s) of such Marketplace Visual Content, with full power to grant the rights set out in this Agreement.</li></ol></li><li><span class=\"contributor-page-howitworks__sub-heading text--bold text--color-black\">Fair Storage</span><ol><li>Creators are limited to a maximum of 50 new photographs/images submissions or uploads per week, with a maximum of 1,600 photographs/images in total and approximately 40 Gb of storage. If these limits are exceeded, restrictions may be imposed on your account, including but not limited to restricted access to your Marketplace Visual Content or a requirement to upgrade, at PIXERF’s sole discretion.</li></ol></li><li><span class=\"contributor-page-howitworks__sub-heading text--bold text--color-black\">Compensation</span><ol><li>PIXERF shall pay the Creator licence fees for the Creator’s Marketplace Visual Content in accordance with the following rate schedule (“<u>Content Licence Fees</u>”).<p style=\"margin-top: 10px\">Fifty per cent (50%) of the net licence fees PIXERF receives from the licensing of the Creator’s Marketplace Visual Content and Community Challenge submissions to Users in relation to standard and extended licences.</p><p style=\"margin-bottom: 0\">The net licence fees refer to the gross licence fees received by PIXERF after deducting any applicable tax, duties or levies, currency conversion costs and wire transfer fees.</p></li><li>PIXERF shall pay the Creator the Content Licence Fees within thirty (30) days following the end of the reporting month in which the Creator’s Marketplace Visual Content was licensed, or subject to PayPal’s turnaround time. All payments shall be made in Singapore dollars.</li><li>PIXERF will use its best endeavours to provide an accurate statement in the Creator’s user account page of their Marketplace Visual Content that have been licensed to other Users.</li><li>In the event that a refund of a payment received or accrued from a third party is required, PIXERF is specifically authorised to deduct the Creator’s share of this overpayment from any subsequent amount due to the Creator.</li><li>Notwithstanding the provisions herein, PIXERF is entitled to set-off against any amount owing to the Creator, all amounts to which PIXERF is or may be entitled to under this Agreement or otherwise by law, including withholding amounts as security for any pending or threatened claim relating to any representation, warranty or indemnity of the Creator pursuant to this Agreement.</li><li>The Creator acknowledges that the above rate schedule is subject to change at the sole discretion of PIXERF, subject to PIXERF providing you with thirty (30) days’ written notice of such change to the email address stated in your account information. You may terminate this Agreement at any time in accordance with these terms if you are not agreeable to the rate schedule. If you continue to submit or upload Marketplace Visual Content or fail to terminate this Agreement, this will be deemed as an acceptance by you of any changes to the rate schedule.</li></ol></li><li><span class=\"contributor-page-howitworks__sub-heading text--bold text--color-black\">Taxes</span><ol><li>You shall pay all applicable goods and services tax, duties or levies whatsoever at the rate which may from time to time be imposed or charged at any time by any government, statutory or tax authority on or calculated by reference to the amount of any sums payable by you hereunder or to reimburse us for the payment of such taxes, duties or levies immediately on receipt of written notice from us.</li><li>If PIXERF shall at any time be compelled by any applicable law to withhold or deduct any tax on your behalf from any amount payable to you hereunder, we shall, when making payment to you, make payment of such tax at the applicable rate to the appropriate tax authority and shall furnish to you written receipts from the appropriate tax authority certifying that such payments have been made.</li></ol></li><li><span class=\"contributor-page-howitworks__sub-heading text--bold text--color-black\">Term and Termination</span><ol><li>This Agreement continues in effect until it is terminated by the Creator or by PIXERF as set out in these terms. Either party may terminate this Agreement by giving seven (7) days’ written notice to the other party. Either party may terminate this Agreement immediately by giving written notice if the other party breaches or fails to comply with any of the terms of this Agreement, makes an assignment for the benefit of its creditors, becomes insolvent, or is subject to bankruptcy or liquidation proceedings.</li><li>Upon termination of this Agreement, PIXERF will remove the Creator’s applicable Marketplace Visual Content from the marketplace within sixty (60) days from the date of termination. PIXERF may retain digital copies of the Marketplace Visual Content for our records.</li><li>Notwithstanding the provisions herein, any licence for the Marketplace Visual Content which had been issued or granted prior to such termination of this Agreement shall continue in effect in accordance with the terms of the applicable Licence Agreement. PIXERF will continue to make payments due to the Creator in accordance with Clause 5 (Compensation). In addition and subject to PIXERF’s discretion, Marketplace Visual Content removed by you for any reason may be available for license to those Business Users that previously downloaded “comp” versions of the removed Marketplace Visual Content.</li></ol></li><li><span class=\"contributor-page-howitworks__sub-heading text--bold text--color-black\">Representations and Warranties by the Creator</span><ol><li>The Creator represents and warrants to PIXERF as follows:<ol><li>the Creator has the full right and authority to execute and perform its obligations in accordance with the terms of this Agreement;</li><li>if the Creator is an individual, is at least 18 years old, and has the full power and authority to enter into this Agreement and perform its obligations hereunder;</li><li>the Creator is the sole and exclusive owner, including copyright, of any Marketplace Visual Content submitted or uploaded, or is the authorised representative of the applicable copyright owner(s) of the Marketplace Visual Content, with full power to grant the rights set out in this Agreement;</li><li>the Creator has not granted any rights or interests in any Marketplace Visual Content to any third party that is contrary to any of the rights or interests granted to PIXERF under this Agreement;</li><li>the Creator will not submit or upload any Marketplace Visual Content that:<ol><li>is defamatory, profane, inappropriate, indecent, obscene or pornographic;</li><li>infringes, violates or misappropriates any third party copyrights, trademarks, rights of privacy or publicity, or any applicable law, rule or regulation;</li></ol></li><li>any descriptions, keywords, metadata, copyright management information or other information or documents (such as Releases) submitted with the Marketplace Visual Content is timely, accurate and complete, does not contain false or misleading information, and complies with PIXERF\'s applicable submission guidelines or policies;</li><li>the Creator has obtained valid and binding model and/or property releases for each Marketplace Visual Content where necessary or required by applicable law, and that PIXERF may use such Marketplace Visual Content without obtaining any further consents or making payment of any additional fees to any third parties;</li><li>the Creator acknowledges and agrees that the creator or source of the Marketplace Visual Content may not be credited by other Users, and that the Marketplace Visual Content may be modified, adapted and/or used in connection with sensitive, unflattering or controversial subject matters, materials or contexts;</li><li>the Creator will not use the Site for the purposes of conducting and/or disseminating surveys, contests, pyramid schemes, chain letters, junk email, spamming or sending of any duplicative or unsolicited messages; and</li><li>the Creator will not transmit, submit or upload any files that contain viruses, Trojan horses, time bombs, spyware, adware, or other malicious, invasive or deleterious code or programme.</li></ol></li></ol></li><li><span class=\"contributor-page-howitworks__sub-heading text--bold text--color-black\">Disclaimer of Warranties</span><ol><li>The Site, including any content contained or services provided therein, is provided on an \"as is\", \"as available\" basis, without representation, warranty or condition of any kind, implied, express or statutory, including but not limited to the representations or warranties of non-infringement of third party rights, title, merchantability, satisfactory quality and/or fitness for a particular purpose. In particular, PIXERF does not represent or warrant the transmission, accuracy, completeness, timeliness or adequacy of the Site or any content available for downloading, or that its use will be provided uninterrupted or error free.</li></ol></li><li><span class=\"contributor-page-howitworks__sub-heading text--bold text--color-black\">Indemnity</span><ol><li><span class=\"text--bold text--color-black\">Creator Indemnity.</span> The Creator agrees to indemnify, defend and hold PIXERF, our officers, directors, shareholders, predecessors, successors in interest, employees, agents, subsidiaries and affiliates, harmless from all demands, claims, actions, proceedings, judgements, orders, decrees, damages, costs, losses and expenses of any nature whatsoever (including but not limited to legal costs on an indemnity basis) against us by any third party due to or arising out of or in connection with any breach or alleged breach or failure by you (or anyone acting on your behalf) to comply with any representation or warranty or other term of this Agreement. You agree that PIXERF may retain any amounts due to the Creator in the event that PIXERF is owed any sum under this clause.</li><li>The Creator’s obligations under the foregoing indemnity may not be offset against any other claim the Creator may have against PIXERF, or any of our officers, directors, employees, agents, subsidiaries and affiliates. The Creator agrees that these indemnity obligations shall survive any termination of their user account on the Site.</li></ol></li><li><span class=\"contributor-page-howitworks__sub-heading text--bold text--color-black\">Disclaimer of Liability</span><ol><li>Notwithstanding any other provision in this Agreement, PIXERF shall not be liable to the Creator or any other person or entity for any punitive, special, indirect, consequential, incidental or other similar damages, costs or losses arising out of this Agreement, its termination or expiration. Some jurisdictions do not permit the exclusion or limitation of implied warranties or liability.</li></ol></li><li><span class=\"contributor-page-howitworks__sub-heading text--bold text--color-black\">General</span><ol><li><span class=\"text--bold text--color-black\">Notices.</span> All notices required to be sent to PIXERF under this Agreement shall be sent via email to <a href=mailto:notify@pixerf.com class=subscription-page-business-link>notify@pixerf.com</a>. All notices required to be sent to you by PIXERF under this Agreement shall be sent via email to the email address set out in your user account.</li><li><span class=\"text--bold text--color-black\">Severability.</span> The illegality, invalidity or unenforceability of any provision of this Agreement under the law of any jurisdiction shall not affect its legality, validity or enforceability under the law of any other jurisdiction nor the legality, validity or enforceability of any other provision.</li><li><span class=\"text--bold text--color-black\">No Waiver.</span> No failure on the part of any party to exercise, and no delay on its part in exercising, any right or remedy under this Agreement will operate as a waiver thereof, nor will any single or partial exercise of any right or remedy preclude any other or further exercise thereof or the exercise of any other right or remedy. The rights and remedies provided in this Agreement are cumulative and not exclusive of any rights or remedies provided by law.</li></ol></li><li><span class=\"contributor-page-howitworks__sub-heading text--bold text--color-black\">Governing Law</span><ol><li>This Agreement shall be construed and its performance governed in accordance with the law of the Republic of Singapore.</li></ol></li></ol><p style=\"padding-top: 30px\">The last update to our Terms and Conditions was posted on 31 August 2021.</p></div></div><div class=contributor-page-howitworks__content-right></div></section></div>");
$templateCache.put("app/explore-creators-page/components/explore-communnity-hub/explore-communnity-hub.html","<div class=explore-communnity-hub><div class=explore-communnity-hub__banner photo-details-on-click=288471><div class=explore-communnity-hub__banner__background></div><div class=explore-communnity-hub__banner__content><banner-box-intro data=vm.bannerBox on-btn-clicked=vm.runChallenge() is-transcluded=true><button class=explore-communnity-hub__banner__content__submit-btn ng-click=vm.onSignUpCreator()>{{vm.bannerBtnText}}</button></banner-box-intro></div></div><section class=\"explore-communnity-hub__section explore-communnity-hub__section__passion\"><div class=explore-communnity-hub__section__passion__title>Turn your passion into profit.</div><div class=explore-communnity-hub__section__passion__sub-title>All you have to do is shoot, share and earn.</div><info-col-intro context=explore-communnity-hub></info-col-intro></section><section class=\"explore-communnity-hub__section explore-communnity-hub__section__statistics\" photo-details-on-click=147992><div class=explore-communnity-hub__section__statistics__top-box><div class=\"explore-communnity-hub__section__statistics__box size-box dark-box order-top-box--1\"><div class=explore-communnity-hub__section__statistics__box__content><div class=explore-communnity-hub__section__statistics__box__content__top>OVER</div><div class=explore-communnity-hub__section__statistics__box__content__value>70k</div><div class=explore-communnity-hub__section__statistics__box__content__bottom>CREATORS</div></div></div><div class=\"explore-communnity-hub__section__statistics__box size-box light-box order-top-box--2\"><div class=explore-communnity-hub__section__statistics__box__content><div class=explore-communnity-hub__section__statistics__box__content__top></div><div class=explore-communnity-hub__section__statistics__box__content__value>100+</div><div class=explore-communnity-hub__section__statistics__box__content__bottom>COUNTRIES</div></div></div><div class=\"explore-communnity-hub__section__statistics__box size-box dark-box order-top-box--3\"><div class=explore-communnity-hub__section__statistics__box__content><div class=explore-communnity-hub__section__statistics__box__content__top></div><div class=explore-communnity-hub__section__statistics__box__content__value>500+</div><div class=explore-communnity-hub__section__statistics__box__content__bottom>SHOOT ASSIGNMENTS</div></div></div><div class=\"explore-communnity-hub__section__statistics__box size-box light-box order-top-box--4\"><div class=explore-communnity-hub__section__statistics__box__content><div class=explore-communnity-hub__section__statistics__box__content__top>OVER</div><div class=explore-communnity-hub__section__statistics__box__content__value>100k</div><div class=explore-communnity-hub__section__statistics__box__content__bottom>IMAGES LICENSED</div></div></div></div><div class=explore-communnity-hub__section__statistics__bottom-box><div class=\"explore-communnity-hub__section__statistics__box size-box dark-box order-bottom-box--1\"><div class=explore-communnity-hub__section__statistics__box__content><div class=explore-communnity-hub__section__statistics__box__content__top>OVER</div><div class=explore-communnity-hub__section__statistics__box__content__value>50</div><div class=explore-communnity-hub__section__statistics__box__content__bottom>CHALLENGES</div></div></div><div class=\"explore-communnity-hub__section__statistics__box size-box light-box order-bottom-box--2\"><div class=explore-communnity-hub__section__statistics__box__content><div class=explore-communnity-hub__section__statistics__box__content__top>AVERAGE SUBMISSIONS</div><div class=explore-communnity-hub__section__statistics__box__content__value>140</div><div class=explore-communnity-hub__section__statistics__box__content__bottom>PER CHALLENGE</div></div></div><div class=\"explore-communnity-hub__section__statistics__box size-box dark-box order-bottom-box--3\"><div class=explore-communnity-hub__section__statistics__box__content><div class=explore-communnity-hub__section__statistics__box__content__top>AVERAGE PRIZE MONEY</div><div class=explore-communnity-hub__section__statistics__box__content__value>$700</div><div class=explore-communnity-hub__section__statistics__box__content__bottom>PER CHALLENGE</div></div></div></div></section><section class=\"explore-communnity-hub__section explore-communnity-hub__section__how-it-works\" id=exploreCommunnityHubHowItWorks><div class=explore-communnity-hub__section__how-it-works__title>How it Works</div><div class=explore-communnity-hub__section__how-it-works__sub-title>All you have to do is shoot, share and earn.</div><div class=explore-communnity-hub__section__how-it-works__box><div class=explore-communnity-hub__section__how-it-works__box__col><div class=\"explore-communnity-hub__section__how-it-works__box__col__icon icon-edit-person\"></div><div class=explore-communnity-hub__section__how-it-works__box__col__text>Sign up for a creator account and register your expertise and interest.</div></div><div class=explore-communnity-hub__section__how-it-works__box__col><div class=\"explore-communnity-hub__section__how-it-works__box__col__icon icon-carousel-photo\"></div><div class=explore-communnity-hub__section__how-it-works__box__col__text>Upload your portfolio in Galleries and showcase your talent.</div></div><div class=explore-communnity-hub__section__how-it-works__box__col><div class=\"explore-communnity-hub__section__how-it-works__box__col__icon icon-warning-bell\"></div><div class=explore-communnity-hub__section__how-it-works__box__col__text>Get notified when you have a booking, stock image sale or won some prize money and use our service to communicate with clients.</div></div><div class=explore-communnity-hub__section__how-it-works__box__col><div class=\"explore-communnity-hub__section__how-it-works__box__col__icon icon-search-money\"></div><div class=explore-communnity-hub__section__how-it-works__box__col__text>Keep track of your opportunities and earnings on one platform.</div></div></div></section><section class=\"explore-communnity-hub__section explore-communnity-hub__section__case-studies-carousel\"><div class=explore-communnity-hub__section__case-studies-carousel__title>The search continues for Asia’s best and promising talents.</div><div class=explore-communnity-hub__section__case-studies-carousel__sub-title>Discover how Custom Content Assignment has helped real brands procure great visual content.</div><explore-creators-grid-carousel id=exploreCommunnityHubCaseStudiesGridCarouselSection class=explore-communnity-hub__section__case-studies-carousel__content></explore-creators-grid-carousel></section><general-contact-form id=generalContactFormSection context=explore-communnity-hub on-cta-btn-clicked=vm.onSignUpCreator() class=\"about-challenge__section about-challenge__section__contact-form\"></general-contact-form></div>");
$templateCache.put("app/explore-creators-page/components/payout-and-pricing/payout-and-pricing.html","<div class=\"payout-page payout-personal no-margin\"><section class=\"row payout-page-branding-wrapper\"><div class=payout-page__branding photo-details-on-click=106913><div class=banner-box-intro ng-click=\"$event.preventDefault(); $event.stopPropagation()\"><div class=\"banner-box-intro__box black--02\"><div class=banner-box-intro__box__title>You\'re Sitting on Gold</div><div class=\"banner-box-intro__box__description desktop\">Select a photographer or videographer from<br>among Asia’s best talents.</div><div class=\"banner-box-intro__box__description mobile\">Select a photographer or<br>videographer from among<br>Asia’s best talents.</div></div></div></div><photo-info-link photo=vm.brandingPhoto></photo-info-link></section><section class=\"row payout-page-earn__wrapper\"><div class=\"row payout-page-earn__enjoy-high-rates\"><div class=payout-page-earn__col-left><p class=\"payout-page-earn__heading text--color-black\">Enjoy high payout rates</p><div class=payout-page-earn__description>The photos you have could be earning you real money. Turn them into gold and upload them to PIXERF now! That\'s why PIXERF offers one of the best payout rates in the market, with no conditions of exclusivity.</div></div><div class=\"payout-personal__content clearfix\"><div class=\"payout-personal__content__user col-sm-9\"><div class=\"payout-personal__content__user-title text--bold\">FREE USERS</div><div class=\"payout-personal__content__user-detail clearfix\"><div class=\"payout-personal__content__user-group clearfix\"><div class=payout-personal__content__user-col-left><img class=payout-personal__content__user-icon src=assets/images/footer-pages/earn.svg></div><div class=payout-personal__content__user-col-right><div class=\"text--bold-switch-semibold text--color-black payout-personal__content__user-can-earn\">You can earn</div><div class=payout-personal__content__user-percent><span class=text--bold>50</span><span class=payout-personal__content__user-percent-unit>%</span></div><div class=\"text--bold-switch-semibold text--color-black payout-personal__content__user-for-image\">for every image licensed</div></div></div><div class=payout-personal__content__user-description>Free users earn 50% of the net price of their photos licensed through Marketplace and Challenges.</div></div></div></div></div><div class=payout-personal__request-wrapper><div class=\"payout-personal__request-title text--semibold text--color-black\">Request your payout</div><div class=\"payout-personal__request-col-wrapper clearfix\"><div class=\"payout-personal__request-col payout-request-first-col col-sm-4\"><div class=\"payout-personal__request-col__icon payout-personal__request-col__icon--paypal text--bold\"></div><div class=\"payout-personal__request-col__title text--bold\">PayPal</div><div class=payout-personal__request-col__description>PayPal is one of the fastest, safest ways to send money online. Please check here if your country can receive payments via PayPal.</div></div><div class=\"payout-personal__request-col payout-request-mid-col col-sm-4\"><div class=\"payout-personal__request-col__icon payout-personal__request-col__icon--wire-transfer text--bold\"></div><div class=\"payout-personal__request-col__title text--bold\">Wire Transfer</div><div class=payout-personal__request-col__description>A wire transfer can be made from one bank account to another bank account. Transfer fees in respective countries will apply.</div></div><div class=\"payout-personal__request-col payout-request-last-col col-sm-4\"><div class=\"payout-personal__request-col__icon payout-personal__request-col__icon--cheque text--bold\"></div><div class=\"payout-personal__request-col__title text--bold\">Cheque</div><div class=payout-personal__request-col__description>We currently offer cheque payments in Singapore, with a small fee applicable per cheque.</div></div><div class=for-more-information>For more information about our Payout & Pricing, check out our FAQ <a ui-sref=introduction-support.faq.personal class=\"text--bold text--color-pixerf-theme\">here!</a></div></div></div><div class=for-more-information>For more information about our Payout & Pricing, check out our<a ui-sref=introduction-support.faq.personal class=\"text--bold text--color-pixerf-theme\"> FAQ here!</a></div></section><!-- <section class=\"row payout-page-couple text--color-black\">\r\n		<div class=\"payout-page-couple__infotext\">PIXERF is here to help!</div>\r\n		<div class=\"payout-page-faq__more-content\">\r\n			Check out our <a class=\"credit-plans-page-faq__more-content--faq-link\"\r\n				ui-sref=\"introduction-support.faq.personal\">FAQs</a> or\r\n			send us an email.\r\n		</div>\r\n		<button type=\"button\" class=\"btn payout-page-ask__account-type-btn btn-submit\" ui-sref=\"email-us-page\">Ask\r\n			PIXERF</button>\r\n	</section> --><general-contact-form id=generalContactFormSection context=payout-and-pricing></general-contact-form></div>");
$templateCache.put("app/for-creator-page/components/about-community/about-community.html","<div class=about-community><div class=about-community__banner photo-details-on-click=177717><div class=about-community__banner__background></div><div class=about-community__banner__content><banner-box-intro data=vm.bannerBox on-btn-clicked=vm.runChallenge() is-transcluded=true><button class=about-community__banner__content__submit-btn ng-click=vm.whyCommunityHubBtnClicked()>Why Community Hub</button></banner-box-intro></div></div><section class=\"about-community__section about-community__section__comming-soon-community-list\"><div class=about-community__section__comming-soon-community-list__title>Watch this space - we will be introducing Community Hub soon!</div></section><section class=\"about-community__section about-community__section__community\"><div class=about-community__section__community__header><div class=about-community__section__community__title>Popular Communities</div><div class=about-community__section__community__see-more ng-click=\"vm.onSeeMore(\'communities\')\">See more Communities</div></div><div class=about-community__section__community__grid><div ng-repeat=\"community in vm.communities\" class=about-community__section__community__item-wrapper><community-explore-tile community=community></community-explore-tile></div></div></section><section class=\"about-community__section about-community__section__wrapper\"><section class=about-community__section__event-class><div class=about-community__section__event-class__header><div class=about-community__section__event-class__title>Upcoming Classes</div><div ng-if=vm.eventClasses.length class=about-community__section__event-class__see-more ng-click=\"vm.onSeeMore(\'classes\')\">See more Classes</div></div><div class=about-community__section__event-class__grid><div ng-if=vm.eventClasses.length ng-repeat=\"eventClass in vm.eventClasses\" class=about-community__section__event-class__item-wrapper><event-explore-tile event=eventClass type=class></event-explore-tile></div><div ng-if=!vm.eventClasses.length><placeholder-event-explore-tile type=classes></placeholder-event-explore-tile></div></div></section><section class=about-community__section__event><div class=about-community__section__event__header><div class=about-community__section__event__title>Upcoming Events</div><div ng-if=vm.events.length class=about-community__section__event__see-more ng-click=\"vm.onSeeMore(\'events\')\">See more Events</div></div><div class=about-community__section__event__grid><div ng-if=vm.events.length ng-repeat=\"event in vm.events\" class=about-community__section__event__item-wrapper><event-explore-tile event=event></event-explore-tile></div><div ng-if=!vm.events.length><placeholder-event-explore-tile type=events></placeholder-event-explore-tile></div></div></section></section><section class=\"about-community__section about-community__section__business\" id=reasonsToJoinPIXERFCommunityHub><div class=about-community__section__business__title>Reasons to Join PIXERF Community Hub.</div><info-col-intro context=about-community class=bout-community__section__business__col-intro></info-col-intro><div class=about-community__section__business__control><button class=about-community__section__business__control__signup-btn ng-click=vm.signup()>Sign up</button> <button class=about-community__section__business__control__explore-btn ng-click=vm.exploreCommunities()>Explore Communities</button></div></section><section class=\"about-community__section about-community__section__community-hub\"><div class=about-community__section__community-hub__title>Join Community Hub and become part of the fastest growing network of creators in Asia. Connect, learn and collaborate with the best.</div><div class=about-community__section__community-hub__control><button ng-if=vm.canCreateCommunity class=about-community__section__community-hub__control__create-community-btn ng-click=vm.createCommunity()>Create a Community</button> <button class=about-community__section__community-hub__control__join-community-btn ng-click=vm.applyCommunityBtnClicked()>Apply to be a Community Leader</button></div><!-- <div class=\"about-community__section__community-hub__looking-for-help\">\r\n			Looking for help? <a href=\"\" class=\"highlight-text\">Contact us</a>.\r\n		</div> --></section><section class=\"about-community__section about-community__section__case-studies-carousel\"><about-community-case-studies-grid-carousel id=aboutCommunityCaseStudiesGridCarouselSection></about-community-case-studies-grid-carousel></section></div>");
$templateCache.put("app/for-creator-page/components/explore-classes/explore-classes.html","<section class=explore-classes__main-content-wrapper><div class=explore-classes__grid infinite-scroll-disabled=vm.isLastPage infinite-scroll=vm.fetchMoreEvents() infinite-scroll-immediate-check=false><div class=explore-classes__grid__events-section><div class=explore-classes__grid__events-section__header><div class=explore-classes__grid__label>Explore Classes</div></div><div class=explore-classes__arrange-by ng-class=\"{\'have-context-header\': vm.showContextLabel}\"><div class=explore-classes__arrange-by__label>{{\'sort-by\' | translate}}:</div><div class=explore-classes__arrange-by__list><stick-checkbox on-changed=vm.onArrangeChanged(data) model=vm.arrangeBy model-property=mostEngagement label=\"Most active\" layout-style=circle-dot group=arrangeBy></stick-checkbox><stick-checkbox on-changed=vm.onArrangeChanged(data) model=vm.arrangeBy model-property=member_count label=most-members layout-style=circle-dot group=arrangeBy></stick-checkbox><stick-checkbox on-changed=vm.onArrangeChanged(data) model=vm.arrangeBy model-property=name label=alphabetical layout-style=circle-dot group=arrangeBy></stick-checkbox></div></div><div ng-if=vm.arrangeBy.name class=explore-classes__alpha-filter><span ng-repeat=\"letter in vm.letters\" class=explore-classes__alpha-filter__letter ng-class=\"{\'actived\': letter === vm.isLettedSelected}\" ng-click=vm.onFilterByLetter(letter)>{{letter}}</span></div><div ng-if=\"vm.events && vm.events.length\" class=explore-classes__grid__events-section__list><div ng-repeat=\"event in vm.events\"><event-explore-tile event=event></event-explore-tile></div></div><div ng-if=\"!vm.events || !vm.events.length\" class=explore-classes__grid__events-section__list><placeholder-event-explore-tile type=classes></placeholder-event-explore-tile></div></div></div></section>");
$templateCache.put("app/for-creator-page/components/explore-communities/explore-communities.html","<section class=explore-communities__main-content-wrapper><div class=explore-communities__grid infinite-scroll-disabled=vm.isLastPage infinite-scroll=vm.fetchMoreCommunities() infinite-scroll-immediate-check=false><div class=explore-communities__grid__communities-section><div class=explore-communities__grid__communities-section__header><div class=explore-communities__grid__label>Explore Communities</div><div class=explore-communities__grid__sub-label>Click on specific communities to submit membership request or find out more about it.</div></div><div class=explore-communities__arrange-by ng-class=\"{\'have-context-header\': vm.showContextLabel}\"><div class=explore-communities__arrange-by__label>{{\'sort-by\' | translate}}:</div><div class=explore-communities__arrange-by__list><stick-checkbox on-changed=vm.onArrangeChanged(data) model=vm.arrangeBy model-property=mostEngagement label=\"Most active\" layout-style=circle-dot group=arrangeBy></stick-checkbox><stick-checkbox on-changed=vm.onArrangeChanged(data) model=vm.arrangeBy model-property=member_count label=most-members layout-style=circle-dot group=arrangeBy></stick-checkbox><stick-checkbox on-changed=vm.onArrangeChanged(data) model=vm.arrangeBy model-property=name label=alphabetical layout-style=circle-dot group=arrangeBy></stick-checkbox></div></div><div ng-if=vm.arrangeBy.name class=explore-communities__alpha-filter><span ng-repeat=\"letter in vm.letters\" class=explore-communities__alpha-filter__letter ng-class=\"{\'actived\': letter === vm.isLettedSelected}\" ng-click=vm.onFilterByLetter(letter)>{{letter}}</span></div><div ng-if=\"vm.communities && vm.communities.length\" class=explore-communities__grid__communities-section__list><div ng-repeat=\"community in vm.communities\"><community-explore-tile community=community></community-explore-tile></div></div></div></div></section>");
$templateCache.put("app/for-creator-page/components/explore-events/explore-events.html","<section class=explore-events__main-content-wrapper><div class=explore-events__grid infinite-scroll-disabled=vm.isLastPage infinite-scroll=vm.fetchMoreEvents() infinite-scroll-immediate-check=false><div class=explore-events__grid__events-section><div class=explore-events__grid__events-section__header><div class=explore-events__grid__label>Explore Events</div></div><div class=explore-events__arrange-by ng-class=\"{\'have-context-header\': vm.showContextLabel}\"><div class=explore-events__arrange-by__label>{{\'sort-by\' | translate}}:</div><div class=explore-events__arrange-by__list><stick-checkbox on-changed=vm.onArrangeChanged(data) model=vm.arrangeBy model-property=mostEngagement label=\"Most active\" layout-style=circle-dot group=arrangeBy></stick-checkbox><stick-checkbox on-changed=vm.onArrangeChanged(data) model=vm.arrangeBy model-property=member_count label=most-members layout-style=circle-dot group=arrangeBy></stick-checkbox><stick-checkbox on-changed=vm.onArrangeChanged(data) model=vm.arrangeBy model-property=name label=alphabetical layout-style=circle-dot group=arrangeBy></stick-checkbox></div></div><div ng-if=vm.arrangeBy.name class=explore-events__alpha-filter><span ng-repeat=\"letter in vm.letters\" class=explore-events__alpha-filter__letter ng-class=\"{\'actived\': letter === vm.isLettedSelected}\" ng-click=vm.onFilterByLetter(letter)>{{letter}}</span></div><div ng-if=\"vm.events && vm.events.length\" class=explore-events__grid__events-section__list><div ng-repeat=\"event in vm.events\"><event-explore-tile event=event></event-explore-tile></div></div><div ng-if=\"!vm.events || !vm.events.length\" class=explore-events__grid__events-section__list><placeholder-event-explore-tile type=events></placeholder-event-explore-tile></div></div></div></section>");
$templateCache.put("app/for-creator-page/components/search-communities-events-results/search-communities-events-results.html","<section class=search-communities-events-results__main-content-wrapper><div class=search-communities-events-results__arrange-by ng-class=\"{\'have-context-header\': vm.showContextLabel}\"><div class=search-communities-events-results__arrange-by__label>{{\'sort-by\' | translate}}:</div><div class=search-communities-events-results__arrange-by__list><stick-checkbox on-changed=vm.onArrangeChanged(data) model=vm.arrangeBy model-property=mostEngagement label=\"Most active\" layout-style=circle-dot group=arrangeBy></stick-checkbox><stick-checkbox on-changed=vm.onArrangeChanged(data) model=vm.arrangeBy model-property=member_count label=most-members layout-style=circle-dot group=arrangeBy></stick-checkbox><stick-checkbox on-changed=vm.onArrangeChanged(data) model=vm.arrangeBy model-property=name label=alphabetical layout-style=circle-dot group=arrangeBy></stick-checkbox></div></div><div ng-if=vm.arrangeBy.name class=search-communities-events-results__alpha-filter><span ng-repeat=\"letter in vm.letters\" class=search-communities-events-results__alpha-filter__letter ng-class=\"{\'actived\': letter === vm.isLettedSelected}\" ng-click=vm.onFilterByLetter(letter)>{{letter}}</span></div><div class=search-communities-events-results__grid infinite-scroll-disabled=vm.isLastPage infinite-scroll=vm.fetchMoreCommunities() infinite-scroll-immediate-check=false><div ng-if=\"vm.communities && vm.communities.length\" class=search-communities-events-results__grid__communities-section><div class=search-communities-events-results__grid__communities-section__header><div class=search-communities-events-results__grid__label>{{\'communities\' | translate}}</div></div><div class=search-communities-events-results__grid__communities-section__list><div ng-repeat=\"community in vm.communities\"><community-explore-tile community=community></community-explore-tile></div></div></div><div ng-if=\"vm.eventClasses && vm.eventClasses.length\" class=explore-classes__grid__events-section><div class=explore-classes__grid__events-section__header><div class=explore-classes__grid__label>Classes</div></div><div class=explore-classes__grid__events-section__list><div ng-repeat=\"eventClass in vm.eventClasses\"><event-explore-tile event=eventClass></event-explore-tile></div></div></div><div ng-if=\"vm.events && vm.events.length\" class=explore-events__grid__events-section><div class=explore-events__grid__events-section__header><div class=explore-events__grid__label>{{\'events\' | translate}}</div></div><div class=explore-events__grid__events-section__list><div ng-repeat=\"event in vm.events\"><event-explore-tile event=event></event-explore-tile></div></div></div></div></section>");
$templateCache.put("app/introduction/company/community-guidelines/community-guidelines.html","<div class=\"community-guidelines-page no-margin\"><section class=\"row community-guidelines-page-branding-wrapper\"><div class=community-guidelines-page__branding><p class=\"community-guidelines-page__branding--earn text-center\">{{\'community-guidelines\' | translate}}</p><photo-info-link photo=vm.brandingPhoto></photo-info-link></div></section><section class=\"row community-guidelines-page__wrapper\"><div class=community-guidelines-page__page-header><h1 class=\"community-guidelines-page__page-header__title text--color-black text--bold\">Welcome to the PIXERF Community!</h1><h3 class=community-guidelines-page__page-header__desc>We are glad to have you. Before you take part in discussions, here are some basic rules you need to know.</h3><div class=community-guidelines-page__paragraph><h5 class=community-guidelines-page__paragraph-heading>WHAT IS COMMUNITY?</h5><p class=community-guidelines-page__paragraph-content>Community is where exciting things happen. Where visual creators, brands and anyone interested in images can define themselves with Asian visual content that is fresh, original and 100% authentic. By posting their latest work. Asking for feedback from fellow peers and pros. Sharing tips, tricks, ideas and things that inspire them. And organising creative events or workshops for other creators. Make this space your creative outlet, classroom, and go-to source for inspiration. Ready to join? To get started, check out our Community Guidelines.</p></div><div class=community-guidelines-page__paragraph><h5 class=community-guidelines-page__paragraph-heading>WHAT ARE COMMUNITY GUIDELINES?</h5><p class=community-guidelines-page__paragraph-content>We want Community to be a place where visual creators around the world can share, grow, learn, collaborate and network with each other. Maybe even find a few opportunities along the way. This is also where businesses get to know creators better. Our aim is to make Community a vibrant and welcoming place to inspire and get inspired.</p><p class=community-guidelines-page__paragraph-content>To make this happen, we need your help. That’s why we have created these guidelines to help you comment, post and interact with other members in the best way possible. Keep in mind the do’s and don’ts and help create a safe and respectful environment for Communities to thrive.</p><p class=community-guidelines-page__paragraph-content>By taking part in the Community, you agree to these guidelines and Terms of Use.</p></div></div><section class=\"row community-guidelines-page__main-content\"><ol><li><span class=\"community-guidelines-page__main-content__sub-heading sub-heading text--bold text--color-black\">A. POSTING AND COMMENTING</span><ol><li><span class=\"community-guidelines-page__main-content__sub-heading sub-heading text--bold text--color-black\">1. Share your own work (or those you have a right to share)</span><p class=\"community-guidelines-page__main-content__sub-content sub-content\">Generally, we encourage you to share your own visual content. This includes photos, illustrations and videos. If you are sharing content made by another creator (for example, on a discussion post about your photography role models), please be sure that you have explicit permission from the creator, and include their name clearly in your post. Never claim another creator’s work as your own. Always respect the Intellectual Property rights and trademarks of others. To learn more about it, visit <a target=_blank href=https://www.ipos.gov.sg/understanding-innovation-ip/copyright class=\"text--bold text--color-pixerf-theme\" tabindex=0>this page</a>.</p><div class=community-guidelines-page__main-content__sample><p class=community-guidelines-page__main-content__sample-heading>Here is an example of how you can credit a creator in the body of your post.</p><p class=community-guidelines-page__main-content__sample-content>Photographer: Henri Cartier-Bresson, from The Decisive Moment.</p><p class=community-guidelines-page__main-content__sample-content>Stills from Singapore Dreaming (Director: Yen Yen Woo, Colin Goh)</p></div><div class=community-guidelines-page__main-content__sample><p class=community-guidelines-page__main-content__sample-heading>You can also use the following template:</p><p class=community-guidelines-page__main-content__sample-content>Creator: (name of Creator), (Project Name)</p><p class=community-guidelines-page__main-content__sample-content>Project: (Project Name), (Creator’s Name)</p></div></li><li><span class=\"community-guidelines-page__main-content__sub-heading sub-heading text--bold text--color-black\">2. We have a diverse audience, so mind what you post</span><p class=\"community-guidelines-page__main-content__sub-content sub-content\">Our community is diverse. Some are comfortable with explicit content (like nudity, sex, death or violence). Some are not. Certain content may be emotionally upsetting to others. Always consider what you are about to post. When unsure, insert a Content Warning in the subject headline of your post.</p><div class=community-guidelines-page__main-content__sample><p class=community-guidelines-page__main-content__sample-heading>Here is an example of how you can insert a Content Warning.</p><p class=\"community-guidelines-page__main-content__sample-content text--semibold\">Photographing people in action (Content Warning: Violence)</p><p class=community-guidelines-page__main-content__sample-content>Recently, I got the opportunity to photograph a local bullfighting festival in Spain. It’s an interesting experience! These are some photos I took that day. This is my first time photographing subjects in motion and keeping the subject in focus is a challenge.</p></div></li><li><span class=\"community-guidelines-page__main-content__sub-heading sub-heading text--bold text--color-black\">3. Stay spam-free and on-topic</span><p class=\"community-guidelines-page__main-content__sub-content sub-content\">Don’t spam by posting repetitive posts and comments. When commenting on a discussion, keep to the topic discussed and don’t hijack the post to promote unrelated subjects. Keep your discussion topic related to visual creative works.</p></li></ol></li><li><span class=\"community-guidelines-page__main-content__sub-heading sub-heading text--bold text--color-black\">B. INTERACTING WITH OTHERS</span><ol><li><span class=\"community-guidelines-page__main-content__sub-heading sub-heading text--bold text--color-black\">1. Do not use a fake identity</span><p class=\"community-guidelines-page__main-content__sub-content sub-content\">You don’t have to use your real name as your username, especially if you are working under a creative alias. But don’t impersonate someone you are not, or create accounts that seek to mislead others about your identity.</p></li><li><span class=\"community-guidelines-page__main-content__sub-heading sub-heading text--bold text--color-black\">2. Respect others’ privacy</span><p class=\"community-guidelines-page__main-content__sub-content sub-content\">Don’t use this Community to reveal private information about other people. You wouldn’t like anyone to spill your personal information on public forums, so be considerate to others too.</p></li><li><span class=\"community-guidelines-page__main-content__sub-heading sub-heading text--bold text--color-black\">3. Gathering contact details? Get the members’ consent first</span><p class=\"community-guidelines-page__main-content__sub-content sub-content\">Before gathering anything that counts as personal information (for example, the contact details of Community Members who have signed up for an Event), there are two things to keep in mind. First, state clearly that you are collecting this data on behalf of yourself and not on behalf of PIXERF. You should also inform Community members who have shared their personal information with you on how you plan to use this information, and obtain their express permission before proceeding. You should not reuse this information for any other purpose than the one that has been agreed upon.</p></li><li><span class=\"community-guidelines-page__main-content__sub-heading sub-heading text--bold text--color-black\">4. Keep the conversation civil.</span><p class=\"community-guidelines-page__main-content__sub-content sub-content\">Disagreements are fine. Criticism is good. But be civil and avoid personal insults. Hate speech is strictly not allowed. Steer clear of profanities and slurs, especially those intended to hurt members of a community based on their race, ethnicity, national origin, sex, gender, gender identity, sexual orientation, religious affiliation, disabilities, or health status.</p><ol><li>4.1 Don’t threaten the harm and personal safety of other members. This includes both physical threats and threats of theft, vandalism or other kinds of harm. Remember: there is always a real person on the other side of the screen. Don’t say something you won’t say to a person standing next to you.</li></ol></li><li><span class=\"community-guidelines-page__main-content__sub-heading sub-heading text--bold text--color-black\">5. Follow the law. And do the right thing.</span><p class=\"community-guidelines-page__main-content__sub-content sub-content\"><span>Make sure that your posts and comments are not in violation of local and international laws.</span><br><span>Don’t incite others to commit crime or engage in dishonest action such as posting fake reviews.</span><br><span>Don’t offer, buy, sell or promote illegal services, drugs or activities.</span><br><span>Don’t glorify or amplify self-harm or messages that seek to harm others.</span><br><span>Before posting or commenting, think about how your post may be received by others.</span><br></p></li><li><span class=\"community-guidelines-page__main-content__sub-heading sub-heading text--bold text--color-black\">6. No personal or political rants, please.</span><p class=\"community-guidelines-page__main-content__sub-content sub-content\">There is a right forum for every kind of discussion. As much as possible, discussions in the Community should focus on the craft and creativity behind your visual content. Avoid using this space to air personal grievances or political rants (for example, to stoke criticism for any political movement or someone you dislike).</p><p class=\"community-guidelines-page__main-content__sub-content sub-content\">However, any information relevant to the visual work discussed is fair game. If you are sharing a photo series that touches on political matters or social issues, you are encouraged to share the background or context that inspires your work, and other members can share their views on it as well, provided that the discussion remains on topic.</p></li><li><span class=\"community-guidelines-page__main-content__sub-heading sub-heading text--bold text--color-black\">7. Beware of fake news</span><p class=\"community-guidelines-page__main-content__sub-content sub-content\">Fake news can look as legitimate as the real one. Always verify the accuracy of a news piece before resharing the content. Consider: Is the source a reputable news agency or website? To be safe, check if it has been shared by multiple news sources!</p></li></ol></li><li><span class=\"community-guidelines-page__main-content__sub-heading sub-heading text--bold text--color-black\">C. HOW CAN YOU HELP</span><ol><li><span class=\"community-guidelines-page__main-content__sub-heading sub-heading text--bold text--color-black\">1. Reporting offensive content</span><p class=\"community-guidelines-page__main-content__sub-content sub-content\">If you see any content that violates our guidelines, you can help by making a report.<br>This is how.</p><p class=\"community-guidelines-page__main-content__sub-content sub-content\"><span class=text--semibold>Click the Report button on the comment or post in question, and choose the reason why. </span>The Community Admin will review the offending content and take appropriate action as soon as possible.</p></li><li><span class=\"community-guidelines-page__main-content__sub-heading sub-heading text--bold text--color-black\">2. Creating a better experience for yourself</span><p class=\"community-guidelines-page__main-content__sub-content sub-content\">Seen posts or comments you dislike, but are not in violation of Community Guidelines? You can block the member who posted this content.</p></li></ol></li><li><span class=\"community-guidelines-page__main-content__sub-heading sub-heading text--bold text--color-black\">D. THE CHECKLIST</span><p class=\"community-guidelines-page__main-content__sub-content sub-content\">In general, here are the six questions you need to watch out for:</p><ol><li><span class=\"community-guidelines-page__main-content__sub-heading sub-heading text--bold text--color-black\">1. Is it my right to post this?</span><p class=\"community-guidelines-page__main-content__sub-content sub-content\">Always ask yourself: do I have the right to post what I’m posting? If I’m not the creator of the content in question, do I have the right to repost it? And as stated above, you must clearly mention the creator of the visual content you’re posting!</p></li><li><span class=\"community-guidelines-page__main-content__sub-heading sub-heading text--bold text--color-black\">2. Is it appropriate?</span><p class=\"community-guidelines-page__main-content__sub-content sub-content\">Be mindful when posting imagery that contain graphic or sexually explicit content. Ask yourself: is this really related to the topic I’m sharing? We allow images of nudity and violence only in certain contexts, such as in photojournalism or artistic photography works. However, sexual images that involve a minor are strictly not allowed in any context without exception.</p></li><li><span class=\"community-guidelines-page__main-content__sub-heading sub-heading text--bold text--color-black\">3. Is it hate speech or bullying?</span><p class=\"community-guidelines-page__main-content__sub-content sub-content\">Hate speech refers to messages that seek to harm or negatively represent an entire group of people based on a shared identity. Don’t threaten other members with violence, doxxing or other forms of retaliation. Any threats toward other members will be considered a violation to our guidelines. Repeated offenders will also be banned.</p></li><li><span class=\"community-guidelines-page__main-content__sub-heading sub-heading text--bold text--color-black\">4. Is it self-harming?</span><p class=\"community-guidelines-page__main-content__sub-content sub-content\">Don’t post content that seeks to promote or encourage others into self-harming behaviour. Again, context matters. Posts or visual content that seek to educate on these issues or to report them from a journalistic perspective will be allowed on a case-to-case basis.</p></li><li><span class=\"community-guidelines-page__main-content__sub-heading sub-heading text--bold text--color-black\">5. Is it graphically violent?</span><p class=\"community-guidelines-page__main-content__sub-content sub-content\">Don\'t share visual content that depicts graphic violence (such as intense physical harm to human beings or animals), except in the context of photojournalism and only when accompanied with a Content Warning in the subject headline.</p></li><li><span class=\"community-guidelines-page__main-content__sub-heading sub-heading text--bold text--color-black\">6. Is it legal?</span><p class=\"community-guidelines-page__main-content__sub-content sub-content\">Content that supports terrorism, organised crime or hate groups, or incite other members to take part in illegal activities, is not allowed and will be removed.</p></li></ol></li><li><span class=\"community-guidelines-page__main-content__sub-heading sub-heading text--bold text--color-black\">E. CONTENT IDEAS</span><p class=\"community-guidelines-page__main-content__sub-content sub-content\">Need an idea to get started? We got you covered. These are just a few examples of what you can post.</p><ol><li><span class=\"community-guidelines-page__main-content__sub-heading sub-heading text--bold text--color-black\">1. Reviews</span><p class=\"community-guidelines-page__main-content__sub-content sub-content\">Got a cool new camera or photography gear? Found a handy software for post-processing? From books to apps to photography gear, we want to hear your thoughts.</p></li><li><span class=\"community-guidelines-page__main-content__sub-heading sub-heading text--bold text--color-black\">2. What’s trending</span><p class=\"community-guidelines-page__main-content__sub-content sub-content\">Tell us the big hype right now. Seen a new movie with amazing cinematography? Or a video challenge that every photographer should try? Share it with the Community.</p></li><li><span class=\"community-guidelines-page__main-content__sub-heading sub-heading text--bold text--color-black\">3. Buy & sell</span><p class=\"community-guidelines-page__main-content__sub-content sub-content\">Looking for a specific vintage lens? Trying to downsize your camera collection? Buy, sell, and trade your gear with fellow photographers you can trust!</p></li><li><span class=\"community-guidelines-page__main-content__sub-heading sub-heading text--bold text--color-black\">4. Then & now</span><p class=\"community-guidelines-page__main-content__sub-content sub-content\">How much have you improved as a photographer? Compare and contrast your old and recent works and blow us away! You can invite other members to share their journey too.</p></li><li><span class=\"community-guidelines-page__main-content__sub-heading sub-heading text--bold text--color-black\">5. Weekly challenges</span><p class=\"community-guidelines-page__main-content__sub-content sub-content\">Post weekly challenges for members in your Community and get them to shoot new photos based on a specific theme!</p></li><li><span class=\"community-guidelines-page__main-content__sub-heading sub-heading text--bold text--color-black\">6. Launches & Promos</span><p class=\"community-guidelines-page__main-content__sub-content sub-content\">Is your brand launching a new product or service? Let our members know. You can even include promo codes for early birds! If it is related to photography, we’re up for it.</p></li><li><span class=\"community-guidelines-page__main-content__sub-heading sub-heading text--bold text--color-black\">7. Events & Happenings</span><p class=\"community-guidelines-page__main-content__sub-content sub-content\">What is happening around the corner? From workshops to art festivals, do not let others miss the fun. Advertise your event, organise local meetups or tell us where you are</p></li><li><span class=\"community-guidelines-page__main-content__sub-heading sub-heading text--bold text--color-black\">8. Tips & Tricks</span><p class=\"community-guidelines-page__main-content__sub-content sub-content\">If you are a pro at a photography genre (or know a clever trick to make an amazing shot), show us the steps. From photography tutorials to art livestreams, give us a peek into your creative process.</p></li><li><span class=\"community-guidelines-page__main-content__sub-heading sub-heading text--bold text--color-black\">9. Request for Advice</span><p class=\"community-guidelines-page__main-content__sub-content sub-content\">Experimenting with a new photography style? Trying to figure out how to improve your shot? Shoot your questions and let the pros share their secrets.</p></li><li><span class=\"community-guidelines-page__main-content__sub-heading sub-heading text--bold text--color-black\">10. Inspiration</span><p class=\"community-guidelines-page__main-content__sub-content sub-content\">Who (or what) is your creative muse? Iconic photography masters, underrated artists, talents on the rise or listening to live concerts? Tell us about the works and people who fuel your creativity.</p></li></ol></li></ol></section></section></div>");
$templateCache.put("app/introduction/company/license/license.html","<div class=\"license-page no-margin\"><section class=\"row license-page-branding-wrapper\"><div class=\"license-page__branding license__branding\"><p class=\"license-page__branding--earn text-center\">Licence Agreement</p><photo-info-link photo=vm.brandingPhoto></photo-info-link></div></section><section class=\"row license-page-howitworks__wrapper\"><div class=license-page-howitworks__content-left><p class=\"license-page-howitworks__heading text--semibold text--color-black\">Licence Agreement</p><div class=license-page-howitworks__main-content><p>This Licence Agreement (the \"<u>Agreement</u>\") sets forth the terms and conditions between you (the \"<u>Licensee</u>\" or \"<u>You</u>\"), and PIXERF Pte Ltd as the licensor (the \"<u>Licensor</u>\").</p><p>Please review this Agreement carefully before downloading any Marketplace Visual Content. By downloading any Marketplace Visual Content, you agree to be bound by the terms of this Agreement, the <span ui-sref=introduction-company.terms class=subscription-page-business-link>Terms and Conditions</span> and our <span ui-sref=introduction-company.privacy class=subscription-page-business-link>Privacy Policy.</span></p><p>We reserve the right to make changes to this Agreement at any time as published from time to time through the Site. By using the Site on or after the date on which this Agreement have been revised, your use would be deemed as acceptance of the revised terms.<br>Unless otherwise defined in this Agreement, the terms used herein shall bear the same meanings as in the Terms and Conditions.</p><ol><li><span class=\"license-page-howitworks__sub-heading text--bold text--color-black\">Licence Terms</span><ol><li>PIXERF offers two types of licences: standard and extended licences. Subject to availability, the Licensee may choose the type of licence for each file of the Marketplace Visual Content which the Licensee downloads from PIXERF (the “<u>Licensed Visual Content</u>”).</li><li><span class=\"text--bold text--color-black\">Standard Licence.</span> Subject to the terms of this Agreement, a standard licence gives the Licensee a worldwide, non-transferable, non-sublicensable, non-assignable, non-exclusive right to copy, reproduce, modify, edit, perform, broadcast, display or publish, in whole or in part, the Licensed Visual Content, and right to create derivative works (collectively, the “<u>use</u>”) for a maximum of 500,000 copies for print production, and 1,000,000 impressions for digital production for all uses in any media.<br><br><span class=\"text--bold text--color-black\">Single Seat</span>. This licence is granted to one Licensee. You may not store the Licensed Visual Content on a server or other content management system which gives more than one person simultaneous access to the Licensed Visual Content. Limited, temporary transfers of the Licensed Visual Content are permitted to third parties for the sole purpose of the creation of the final product, provided that such third parties agree to abide by the terms of this Agreement. The Licensee must purchase an additional multi-seat licence for other members of your organisation to access and use the Licensed Visual Content.</li><li><span class=\"text--bold text--color-black\">Extended Licence.</span> The Licensee may purchase an extended licence to increase the usage rights granted in the standard licence as follows:<ol><li><span class=\"text--bold text--color-black\">Products for Resale</span>. This extension allows the Licensee to use the Licensed Visual Content in connection with any print or electronic products intended for resale or distribution, including but not limited to cards, stationery items, calendars, apparel, posters, mobile applications or other items for resale or other distribution. This includes electronic or digital templates intended for resale or other distribution (such as website templates, electronic greeting card templates) and \"on demand\" products (that is, products in which a third party may select the Licensed Visual Content for customisation on a product on a made-to-order basis, such as posters, mugs and t-shirts).</li><li><span class=\"text--bold text--color-black\">Unlimited Print Run and Digital Impressions</span>. This extension allows the Licensee to use the Licensed Visual Content to create unlimited (a) print reproductions in excess of 500,000 copies, including without limitation, advertising, marketing and promotional materials, newspapers, magazines, books or product packaging; and (b) digital impressions in excess of 1,000,000 copies, including without limitation, video, television, cinema, software, applications, and electronic documents, subject to the restricted uses in Clause 2 below.</li><li><span class=\"text--bold text--color-black\">Multi-Seat</span>. This extension allows the Licensee to provide multiple members of a team within the same organisation access to the Licensed Visual Content. Unless a multi-seat license is purchased, the Licensed Visual Content may not be stored on a server or content management system which gives more than one person simultaneous access to the content.</li></ol></li><li><span class=\"text--bold text--color-black\">Derivative Works</span>. In the event that the Licensee creates a derivative work based on or incorporating any Licensed Visual Content, all rights in and to such Licensed Visual Content shall continue to be owned by PIXERF or its creators, subject to the Licensee’s rights to use such Licensed Visual Content in accordance with this Agreement. The Licensee grants PIXERF the right to display or reference the Licensee’s said derivative work for any marketing, educational and/or promotional purposes.</li><li><span class=\"text--bold text--color-black\">Comp Licence</span>. If you are a Business User and depending on your credit plan, you may use [watermarked or low resolution] Marketplace Visual Content from the Marketplace on a complimentary basis for test or sample (comp) use only, [for up to thirty (30) days after download]. Unless a licence is purchased, such content cannot be used in any final materials or project, or be made publicly available in any manner. PIXERF makes no guarantees that any content you download under a Comp Licence will be available for license thereafter.</li><li>If you wish to purchase a licence beyond the coverage specified above, please contact <a class=\"pixerf-link pixerf-link--color-theme\" href=mailto:licensing@pixerf.com target=_top>licensing@pixerf.com</a>.</li></ol></li><li><span class=\"license-page-howitworks__sub-heading text--bold text--color-black\">Restrictions on Use of Licensed Visual Content</span><ol><li>The Licensee agrees not to do the following without the prior written consent of PIXERF, which may be given at its sole discretion:<ol><li>Sub-license, sell, assign, convey or transfer any of its rights under this Agreement;</li><li>Sell, license, distribute or use any Licensed Visual Content or its final products in such a way as to permit others to download, extract, access or redistribute the Licensed Visual Content as a standalone file, that is, separate from the project or end use;</li><li>Unless an applicable extended licence has been obtained, use or incorporate any Licensed Visual Content in print or electronic products for resale or distribution without regard to the size of the print run, manufacturing units, or impressions of such products (including individual downloads), including but not limited to screen-savers or wallpapers for mobile devices, presentation templates, website designs, clothing, accessories, bags, mugs, posters or any other electronic or non-electronic matter;</li><li>Unless an applicable extended licence has been obtained, use the Licensed Visual Content to create print reproductions in excess of 500,000 copies, including without limitation, advertising, marketing and promotional materials, newspapers, magazines, books or product packaging; and digital impressions in excess of 1,000,000 copies, including without limitation, video, television, cinema, software, applications, and electronic documents;</li><li>Unless an applicable extended licence has been obtained, allow multiple members of a team within the same organisation access the Licensed Visual Content, as well as store the Licensed Visual Content on a server or content management system which gives more than one person simultaneous access to the content;</li><li>Upload any Licensed Visual Content as an unmodified standalone file to file-sharing websites or other third party websites that claim to acquire ownership or any other proprietary rights in the Licensed Visual Content contrary to the terms of this Agreement;</li><li>Use or incorporate any Licensed Visual Content as part of a logo, trademark, design mark, service mark, trade name or business name;</li><li>Use any Licensed Visual Content in an inappropriate, profane, tortuous, obscene, indecent, abusive, defamatory, libellous, pornographic, or otherwise unlawful manner, whether on its own or together with any other topic, subject matter or material;</li><li>Use any Licensed Visual Content in any manner prohibited by any applicable laws, rules or regulations which you may be subject to;</li><li>Falsely represent, whether expressly or impliedly, that the Licensee is the original creator of a work which is made up or derived substantially from any Licensed Visual Content.</li></ol></li><li><span class=\"text--bold text--color-black\">For Editorial Use.</span> If the Licensed Visual Content is marked \"Editorial Use Only\", you may not use such Licensed Visual Content for any commercial, promotional, endorsement, advertising or merchandising purposes. This Licensed Visual Content is intended to be used only in connection with events that are newsworthy or of general interest, for example, in a blog post, textbook, magazine or newspaper article.</li><li><span class=\"text--bold text--color-black\">Sensitive Use Disclaimer.</span> If a Licensed Visual Content that features models or property is used in connection with any subject matter or material that would be unflattering or unduly controversial to a reasonable person, the Licensee must accompany each such use with a statement indicating that: (1) the Licensed Visual Content is being used for illustrative purposes only; and (2) any person depicted in the Licensed Visual Content is a model. This disclaimer is not required for Licensed Visual Content marked as \"Editorial Use Only\" which are used in an editorial manner.</li><li><span class=\"text--bold text--color-black\">Releases.</span> Save for model releases for identifiable persons on Licensed Visual Content marked as \"Commercial Use\", PIXERF grants no rights and makes no warranties with regard to the use of names, trademarks, registered, unregistered or copyrighted designs or works of art or architecture depicted in any Licensed Visual Content, and the Licensee must satisfy itself that all the necessary rights or consents as may be required for reproduction of such Licensed Visual Content have been obtained. The Licensee acknowledges that no releases are obtained for Licensed Visual Content marked as \"Editorial Use Only\", and that some jurisdictions provide legal protection where a person\'s image, likeness or property is being used for commercial purposes when they have not provided a release.</li></ol></li><li><span class=\"license-page-howitworks__sub-heading text--bold text--color-black\">Warranty</span><ol><li>Subject to the terms of this Agreement, with regard to the Licensed Visual Content which have been marked as \"Commercial Use\", PIXERF warrants that the Licensee’s use of such unmodified Licensed Visual Content in accordance with this Agreement will not infringe any third party copyrights, trademarks, or right of privacy or publicity to the underlying Licensed Visual Content.</li><li>Save as expressly provided for in Clause 3.1 above, the Licensed Visual Content are provided on an \"as is\", \"as available\" basis, without representation, warranty or condition of any kind, implied, express or statutory, including but not limited to the representations or warranties of non-infringement of third party rights, title, merchantability, satisfactory quality and/or fitness for a particular purpose. You assume full responsibility and risk for the use of the Licensed Visual Content.</li></ol></li><li><span class=\"license-page-howitworks__sub-heading text--bold text--color-black\">Indemnity</span><ol><li><span class=\"text--bold text--color-black\">Licensee Indemnity.</span> You agree to indemnify and hold us, our officers, directors, shareholders, predecessors, successors in interest, employees, agents, subsidiaries and affiliates, harmless from all demands, claims, actions, proceedings, judgements, orders, decrees, damages, costs, losses and expenses of any nature whatsoever (including but not limited to reasonable legal costs) against us by any third party due to or arising out of or in connection with any modifications made to the Licensed Visual Content or the context in which the Licensed Visual Content is used; or any breach or alleged breach or failure by you (or anyone acting on your behalf) to comply with any of these terms, our Terms and Conditions, and our Privacy Policy.</li><li>Your obligations under the foregoing indemnity may not be offset against any other claim you may have against PIXERF, or any of our officers, directors, employees, agents, subsidiaries and affiliates. You agree that these indemnity obligations shall survive any termination of your account on the Site.</li><li><span class=\"text--bold text--color-black\">PIXERF Indemnity</span>. Provided that the Licensed Visual Content is used in accordance with this Agreement, and that you are not otherwise in breach of this Agreement, PIXERF agrees, subject to the terms in this Clause, to indemnify and hold you, your officers, directors, employees, corporate parent, subsidiaries and affiliates, harmless from all demands, claims, actions, proceedings, judgements, orders, decrees, damages, costs, losses and expenses of any nature whatsoever (including but not limited to reasonable legal costs) against you by any third party due to or arising out of or in connection with any actual lawsuit or legal proceeding alleging that PIXERF is in breach of its warranties in Clause 3 above.</li><li>PIXERF’s indemnity obligations in this Clause are conditional upon the following: (i) you shall promptly provide PIXERF with written notice of any claim; (ii) you shall provide PIXERF and our professional advisors with all information and relevant documents and records, or otherwise cooperate with PIXERF in any way reasonably requested by PIXERF, to enable PIXERF to handle, defend or settle such claim; and (iii) you shall give PIXERF control of the handling, settlement or defence of any such claim, provided that PIXERF shall not enter into any settlement which imposes any material obligations on you without your prior written consent. PIXERF shall not be liable for legal fees and other related costs and expenses incurred prior to you providing such written notice to PIXERF of the claim for which the indemnity is sought.</li></ol></li><li><span class=\"license-page-howitworks__sub-heading text--bold text--color-black\">Limitation of Liability</span><ol><li>Notwithstanding any other provision in this Agreement, PIXERF will not be liable to you or any other person or entity for any punitive, special, indirect, consequential, incidental or other similar damages, costs or losses arising out of this Agreement, its termination or expiration. Some jurisdictions do not permit the exclusion or limitation of implied warranties or liability.</li><li>The total maximum aggregate liability of PIXERF or any of our officers, directors, shareholders, predecessors, successors, employees, agents, subsidiaries and affiliates, owed to the Licensee arising from this Agreement, its termination or expiration shall not in any event exceed SGD500 per Licensed Visual Content, provided that the maximum aggregate liability in respect of all claims over the duration of one year, regardless of the number of Licensed Visual Content, shall not exceed SGD5,000.</li></ol></li><li><span class=\"license-page-howitworks__sub-heading text--bold text--color-black\">Intellectual Property Rights</span><ol><li><span class=\"text--bold text--color-black\">Ownership.</span> All the Licensed Visual Content are owned, licensed to or controlled by either PIXERF or the creators who supply the Licensed Visual Content. All rights not expressly granted to the Licensee in this Agreement are reserved by PIXERF and/or the creators.</li><li><span class=\"text--bold text--color-black\">Attribution</span>. If the Licensee is using the Licensed Visual Content for editorial purposes, it must include the following credit adjacent to the Licensed Visual Content or in the visual production credits: \"Creator’s Name / PIXERF\".</li></ol></li><li><span class=\"license-page-howitworks__sub-heading text--bold text--color-black\">Cancellation</span><ol><li>You may not cancel any licences. No refund of credits will be permitted.</li></ol></li><li><span class=\"license-page-howitworks__sub-heading text--bold text--color-black\">Payment</span><ol><li>You may purchase the Licensed Visual Content through your PayPal account or credit card, or through credits. You may purchase credits from PIXERF in pre-set credit plans as set out on the Site, which allows you to download the Licensed Visual Content and thereby license files from PIXERF. All credits purchased are non-refundable.</li><li>Credits may be purchased via your PayPal account or credit card. By providing your payment information, you represent and warrant that you are the holder of that PayPal account or the cardholder (as the case may be), and that you authorise PIXERF to charge the account or card for all payments stated herein, and to provide that information to third parties for the purposes of facilitating payment. You agree to verify any information requested by PIXERF for purposes of acknowledging or completing any payment.</li></ol></li><li><span class=\"license-page-howitworks__sub-heading text--bold text--color-black\">Taxes</span><ol><li>You agree to pay and be responsible for any and all taxes, duties or levies whatsoever imposed or charged by any government statutory or tax authority on or calculated by reference to the amount of any sums payable by it hereunder in any jurisdiction as a result of the licence granted to you or your use of the Licensed Visual Content pursuant to this Agreement.</li></ol></li><li><span class=\"license-page-howitworks__sub-heading text--bold text--color-black\">Termination</span><ol><li>This Agreement continues in effect until it is terminated by either you or PIXERF as set out in these terms. You may terminate this Agreement by ceasing to use the Licensed Visual Content and deleting or destroying all copies thereof. PIXERF may terminate the Agreement with immediate effect at any time without notice to you if you have breached or failed to comply with any of these terms.</li><li>In the event of any termination, you will have no rights to the continued use or access to the Licensed Visual Content, and must delete and destroy all copies thereof, whether electronic or print. If requested, you agree to provide PIXERF with written confirmation that you have complied with these requirements.</li><li>PIXERF may discontinue licensing any Licensed Visual Content at any time in its sole discretion. Upon notice from PIXERF, or upon your knowledge, that any Licensed Visual Content may be subject to a claim of infringement of a third party\'s right for which PIXERF may be liable, PIXERF may require you to immediately, and at your own expense: cease using the Licensed Visual Content, delete or destroy any copies; and ensure that your clients, distributors and/or employer do likewise. PIXERF will provide you with a replacement Licensed Visual Content (determined by PIXERF in its reasonable commercial judgment) free of charge, subject to the other terms of this Agreement.</li></ol></li><li><span class=\"license-page-howitworks__sub-heading text--bold text--color-black\">General</span><ol><li><span class=\"text--bold text--color-black\">Notices</span>. All notices required to be sent to PIXERF under this Agreement shall be sent via email to <a href=mailto:notify@pixerf.com class=subscription-page-business-link>notify@pixerf.com</a>. All notices required to be sent to you by PIXERF under this Agreement shall be sent via email to the email address set out in your account.</li><li><span class=\"text--bold text--color-black\">Severability</span>. The illegality, invalidity or unenforceability of any provision of this Agreement under the law of any jurisdiction shall not affect its legality, validity or enforceability under the law of any other jurisdiction nor the legality, validity or enforceability of any other provision.</li><li><span class=\"text--bold text--color-black\">No Waiver</span>. No failure on the part of any party to exercise, and no delay on its part in exercising, any right or remedy under this Agreement will operate as a waiver thereof, nor will any single or partial exercise of any right or remedy preclude any other or further exercise thereof or the exercise of any other right or remedy. The rights and remedies provided in this Agreement are cumulative and not exclusive of any rights or remedies provided by law.</li></ol></li><li><span class=\"license-page-howitworks__sub-heading text--bold text--color-black\">Governing Law</span><ol><li>This Agreement shall be construed and its performance governed in accordance with the law of the Republic of Singapore.</li></ol><br><p>The last update to our License Agreement was posted on 31 August 2021.</p></li></ol></div></div><div class=license-page-howitworks__content-right></div></section></div>");
$templateCache.put("app/introduction/company/privacy/privacy.html","<div class=\"privacy-page no-margin\"><section class=\"row privacy-page-branding-wrapper\"><div class=privacy-page__branding><p class=\"privacy-page__branding--earn text-center\">Privacy Policy</p><photo-info-link photo=vm.brandingPhoto></photo-info-link></div></section><section class=\"row privacy-page-howitworks__wrapper\"><div class=privacy-page-howitworks__content-left><p class=\"privacy-page-howitworks__heading text--semibold text--color-black\">Privacy Policy</p><div class=privacy-page-howitworks__main-content><p>This Privacy Policy governs our web and mobile applications and any associated software, and includes all modifications, enhancements or updates thereto (collectively, the \"<span class=text--bold>Site</span>\") as owned and operated by PIXERF. For the purpose of this Privacy Policy, \"<span class=text--bold>PIXERF</span>\", \"<span class=text--bold>we</span>\", \"<span class=text--bold>our</span>\" or \"<span class=text--bold>us</span>\" shall refer to PIXERF Pte Ltd.<br><br>By accessing and using any part of the Site, you shall be deemed to have accepted to be legally bound by the terms of this Privacy Policy without limitation or qualification. If you do not agree to the terms of this Privacy Policy, please do not access or use the Site. Any continued access or use of the Site (whether this time or in future) will imply that you have accepted the terms of this Privacy Policy.<br><br>Your privacy is very important to us and we are committed to maintaining your trust. Accordingly, we have developed this Privacy Policy in order for you to understand how we collect, use, communicate and disclose and make use of your personal information.</p><ol><li><span class=\"terms-page-howitworks__sub-heading text--bold text--color-black\">Collection, Use and Disclosure of Personal Information</span><p style=\"padding-top: 15px\">If you are only browsing this Site, we do not capture data that allows us to identify you individually. This Site automatically receives and records information on our server logs from your browser, including your IP address, cookie information, and the page(s) requested. This information may be used to improve the overall user experience.<br><br>By providing your personal information to us, whether or not through the Site, you consent to our collection, use and disclosure of your personal information in accordance with this Privacy Policy.<br><br>We may collect, use and/or disclose your personal information for the following purposes:</p><ol><li>setting up your registered user account and profile on the Site;</li><li>to provide and improve our services, including informing you of any change or updates in our services;</li><li>for targeted online marketing;</li><li>for accounting, billing and verification purposes;</li><li>to contact you regarding any complaints, feedback, queries, requests, claims or disputes;</li><li>to facilitate investigations into any suspicious or illegal activity on the Site;</li><li>for internal administrative and management purposes;</li><li>to protect and enforce our contractual and legal rights and obligations;</li><li>where required by any act, statute, law, or regulation, rules, directives, or by the order of a government authority or a court or tribunal of competent jurisdiction;</li><li>such other purposes consented by you for which your personal information is collected;</li><li>any other purpose reasonably related to the aforesaid.</li></ol></li><p style=\"padding-top:30px; padding-left: 20px\">You acknowledge and agree that your user name, profile picture, contact information and Community memberships may be displayed and made available to other users of the Site. Your personal information which you post on the Site may also be displayed to other Users or persons both on and off the Site, depending on your settings and how you interact with the Site. As we rely on your personal information to provide our services to you, you agree to ensure that the information provided by you is accurate, complete and up to date. If you are providing personal data to us for and on behalf of another individual, you represent and warrant that you have obtained the necessary authority and consent to disclose such personal data to us for the relevant purposes, and that such information is true, complete and accurate.<br><br>We may disclose your personal information to our partners and/or third parties whom we have engaged to provide our services, to maintain this Site or to protect the security or integrity of this Site and our databases, or such other persons and for such purposes as you have consented to. We will use commercially reasonable efforts to ensure that such partners do not use your personal information for a purpose other than the purposes for which the personal information was originally given.</p><li><span class=\"terms-page-howitworks__sub-heading text--bold text--color-black\">Confidentiality</span><p style=\"padding-top: 15px\">Save where expressly provided herein, we will not reveal to any person, firm or company any information which may come to our knowledge hereunder and shall keep with complete secrecy the personal information provided by you and shall not use or attempt to use any such personal information in any manner without your permission. These restrictions shall cease to apply to information or knowledge which may come into the public domain other than as a result of any act or breach of this Privacy Policy by us.</p></li><li><span class=\"terms-page-howitworks__sub-heading text--bold text--color-black\">Changing or Deleting Your Information</span><p style=\"padding-top: 15px\">You may review and change your personal information in your account settings. We will not be responsible for any modification of your personal information specified in your account.<br><br>We will only retain your personal information as long as necessary for the fulfilment of the purposes stated in this Privacy Policy and any applicable terms and conditions, or as required or permitted by applicable laws.</p></li><li><span class=\"terms-page-howitworks__sub-heading text--bold text--color-black\">Security of Your Personal Information</span><p style=\"padding-top: 15px\">Your account information is protected by a password. It is important that you protect against unauthorised access of your account and information by choosing your password carefully, and keeping your password and computer secure by signing out after using our services.<br><br>You should also take appropriate steps to keep your information, software and equipment secure. This includes clearing your Internet browser cookies and cache before and after using any services on the Site.<br><br>Where appropriate, we will take reasonable security safeguards to protect your personal information against loss or theft, as well as unauthorised access, disclosure, copying, use or modification. Unfortunately the sending of information via the internet is not completely secure and on occasion such information can be intercepted. We cannot guarantee the security of data that you choose to send us electronically, and the sending of any such information will be at your own risk. We do not accept liability for the security, authenticity, integrity or confidentiality of any transaction and other communications made through the Site.<br><br>Internet communications may be susceptible to interference or interception by third parties. Despite our best efforts, we make no warranties that the Site is free of viruses or other unauthorised software.</p></li><li><span class=\"terms-page-howitworks__sub-heading text--bold text--color-black\">Third Parties</span><p style=\"padding-top: 15px\">The Site may contain hyperlinks to and from other Internet websites, which may have different privacy practices. Please read the privacy policies of the other websites you visit.</p><p style=\"padding-top: 15px\">This Privacy Policy does not apply to information which you provide or make accessible to third parties, including Community creators and other Users (if applicable). Any such disclosure is subject to the relevant third party’s privacy policy or practices, which PIXERF is not responsible for.</p></li><li><span class=\"terms-page-howitworks__sub-heading text--bold text--color-black\">Modification</span><p style=\"padding-top: 15px\">The terms of this Privacy Policy may be revised, changed and updated from time to time, without notice to you. All changes will be posted on this page, and your continued access or use of the Site after such changes have been posted will constitute your agreement to the modified Privacy Policy and all of the changes. We therefore encourage you to read this Privacy Policy each time you visit this Site.</p></li><li><span class=\"terms-page-howitworks__sub-heading text--bold text--color-black\">Contacts</span><p style=\"padding-top: 15px\">If you have any comments, concerns or questions about this Privacy Policy, our policies and practices, or any requests pursuant to this Privacy Policy, please contact us at <a href=mailto:notify@pixerf.com class=subscription-page-business-link>notify@pixerf.com</a> .</p></li><li><span class=\"terms-page-howitworks__sub-heading text--bold text--color-black\">Terms and Conditions</span><p style=\"padding-top: 15px\">By accessing or using the Site, you are deemed to have also accepted our Terms and Conditions <span ui-sref=introduction-company.terms class=subscription-page-business-link>here.</span></p></li></ol><p style=\"padding-top: 15px\">The last update to our Privacy Policy was posted on 12 October 2020.</p></div></div><div class=privacy-page-howitworks__content-right></div></section></div>");
$templateCache.put("app/introduction/company/terms/terms.html","<div class=\"terms-page no-margin\"><section class=\"row terms-page-branding-wrapper\"><div class=terms-page__branding><p class=\"terms-page__branding--earn text-center\">Terms and Conditions</p><photo-info-link photo=vm.brandingPhoto></photo-info-link></div></section><section class=\"row terms-page-howitworks__wrapper\"><div class=terms-page-howitworks__content-left><p class=\"terms-page-howitworks__heading text--semibold text--color-black\">Terms and Conditions</p><div class=terms-page-howitworks__main-content><ol><li><span class=\"terms-page-howitworks__sub-heading text--bold text--color-black\">General Information</span><ol><li>Please review these Terms carefully before using this Site.</li><li>By downloading, installing or using the Site or by registering with us, you acknowledge and agree to be bound by the Terms herein and our Privacy Policy <span ui-sref=introduction-company.privacy class=subscription-page-business-link>here</span>. If you do not agree to these Terms, please do not access or use the Site.</li><li>We reserve the right to make changes to these Terms at any time without prior notice to you as published from time to time through the Site. By using the Site on or after the date on which the Terms have been revised, your use would be deemed as acceptance of the revised Terms.</li></ol></li><li><span class=\"terms-page-howitworks__sub-heading text--bold text--color-black\">Definitions</span><ol><li>In these Terms, unless the context otherwise requires, the following words or expressions shall have the following meanings:<ol><li>\"<u>Business User</u>\" means a User which is a registered business or company and which has registered with PIXERF through a unique corporate email account.</li><li>\"<u>Community</u>\" means a community created through the community feature on the Site;</li><li>\"<u>Content</u>\" means the materials located on this Site, including the text, information, graphics, audio, video, as well as any software programmes available on or through the Site.</li><li>\"<u>Custom Content Assignment Platform</u>\" means the platform provided on the Site through which Users may commission User Visual Content based on the terms of the Custom Content Assignment Agreement (for Commissioners) here, and the selected User may submit the commissioned User Visual Content based on the terms of the Custom Content Assignment Agreement (for Visual Content Creators) here.</li><li>\"<u>Marketplace</u>\" means the platform provided on the Site through which Users may contribute Marketplace Visual Content based on the terms of the Creator Agreement <span ui-sref=introduction-company.contributor class=subscription-page-business-link>here</span>, and other Users may purchase licences for such Marketplace Visual Content based on the terms of the Licence Agreement <span ui-sref=introduction-company.license class=subscription-page-business-link>here</span>.</li><li>\"<u>Marketplace Visual Content</u>\" means the User Visual Content which a User posts, uploads, displays or otherwise makes available on or through the Marketplace.</li><li>\"<u>Community Challenge</u>\" means a challenge run on or through the Site by Users based on the terms of the Challenge Sponsor Agreement, and whereby other Users may contribute Community Challenge Visual Content based on the terms of the Challenge Agreement <span ui-sref=mission.mission-agreement class=subscription-page-business-link>here</span>.</li><li>\"<u>Community Challenge Visual Content</u>\" means the User Visual Content which a User posts, uploads, displays or otherwise makes available on the Site pursuant to a Community Challenge.</li><li>\"<u>Personal User</u>\" or \"<u>Creator</u>\" means a User who is an individual.</li><li>\"<u>PIXERF</u>\", \"<u>we</u>\", \"<u>our</u>\" or \"<u>us</u>\" refers to PIXERF Pte Ltd.</li><li>\"<u>Privacy Policy</u>\" means the privacy policy found <span ui-sref=introduction-company.privacy class=subscription-page-business-link>here</span> which provides details of how we collect, use and store personal information.</li><li>\"<u>Services</u>\" means the collective functionality and features as provided by us through our Site.</li><li>\"<u>Site</u>\" means the web and mobile applications and any associated software as owned and operated by PIXERF, and shall include all modifications, enhancements or updates thereto.</li><li>\"<u>Terms</u>\" means the terms and conditions herein, as well as our Privacy Policy.</li><li>\"<u>User</u>\", \"<u>Users</u>\" or \"<u>you</u>\" means the users who are registered with PIXERF for the use of our Services, and shall include the Personal User and the Business User. Where the context requires, these references shall include any individual representing or acting on behalf of a User.</li><li>\"<u>User Content</u>\" means the content which a User posts, uploads, displays or otherwise makes available, whether privately or publicly, on or through the Site, and includes User Visual Content.</li><li>\"<u>User Visual Content</u>\" means the content, including photographs, illustrations, vector graphics and videos, which a User posts, uploads, displays or otherwise makes available on or through the Site, whether through the Marketplace, a Community Challenge or the Custom Content Assignment Platform.</li></ol></li></ol></li><li><span class=\"terms-page-howitworks__sub-heading text--bold text--color-black\">Registration</span><ol><li>You will need to register an account with us before using our Services.</li><li>To register, you must be 18 years old and above and must complete the registration process. You confirm that all information provided by you is true, accurate, correct and up to date. If you are registering as a Business User on behalf of your organisation, you confirm that you have the necessary authority and consent to do so.</li><li>You are responsible for the confidentiality of your username and password and shall take ownership of all activity and transactions under your account. It is important that you protect against unauthorised access of your account and information by choosing your password carefully, and keeping your password and electronic devices secure by signing out after using the Services.</li></ol></li><li><span class=\"terms-page-howitworks__sub-heading text--bold text--color-black\">Provision of Account or Services</span><ol><li>We shall have the right to restrict, suspend or terminate your account or access to the Site, or to restrict, suspend or cease to provide any Services to you at any time at our sole discretion for any reason or no reason. Where such restriction or suspension of Services is due to planned downtimes for maintenance of the Site and the Content, this will be communicated in advance on or through the Site. You agree that PIXERF shall not be liable to you or any third party for any losses or damages that may result from such suspension, restriction or termination.</li><li>We may, at our sole discretion, develop and provide updates to the Site and the Services including upgrades, bug fixes, patches and other error corrections and/or new features (collectively, the \"<u>Updates</u>\"). Updates may also modify or delete in their entirety certain features and functionality. You acknowledge and agree that we have no obligation to provide any Updates or to continue to provide or enable any particular feature or functionality. You should promptly download and install all Updates, failing which you may not obtain the full features and functionality of the Site or the Services. By downloading and installing the Updates, whether such installation was automatic or not, you agree that the Updates are deemed part of the Site and are subject to the Terms herein.</li></ol></li><li><span class=\"terms-page-howitworks__sub-heading text--bold text--color-black\">Use of Site and Services</span><ol><li>By using the Site or the Services, you agree to abide by all the Terms herein as well as our Privacy Policy <span ui-sref=introduction-company.privacy class=subscription-page-business-link>here</span>.</li><li><u>General Conduct Rules</u> - You agree that you will not:<ol><li>defame, abuse, harass, stalk, threaten or otherwise violate the legal rights (such as rights of privacy) of others;</li><li>provide false or inaccurate information when registering for an account on the Site or when using the Services;</li><li>impersonate any person, brand or entity, or misrepresent your identity or affiliation with any person, brand or entity;</li><li>create a false identity for the purpose of misleading others;</li><li>post any information that is abusive, threatening, obscene, defamatory, libellous, or racially, sexually, religiously, or otherwise objectionable and offensive;</li><li>publish, post, upload, distribute or disseminate any inappropriate, profane, defamatory, tortious, obscene, indecent or unlawful topic, name, material or information;</li><li>upload, or otherwise make available, files that contain images, photographs, videos, software or other material protected by intellectual property laws, including, by way of example, and not as limitation, copyright or trademark laws (or by rights of privacy or publicity) unless you have ownership or control the rights thereto or have received all necessary consent to do the same;</li><li>use any material or information, including images, photographs and videos, which are made available through the Site in any manner that infringes any copyright, trademark, patent, trade secret, or other proprietary right of any party;</li><li>upload, or otherwise make available, files that contain viruses, corrupted files, or any other similar software or programmes that may damage the operation of another\'s electronic device or property;</li><li>use the Site or the Services for any unlawful purpose, or for the promotion of illegal activities;</li><li>use another User’s account without consent or permission;</li><li>knowingly disseminate information that you know, or reasonably ought to know, to be confidential in nature, in violation of any duty of confidentiality which you are subject to; or</li><li>use the Site or the Services in violation of these Terms, or in violation of any applicable laws, rules or regulations.</li></ol></li><li><u>Site Usage Rules</u> - You agree that you will not:<ol><li>make improper use the Site or the Services, or for any purpose not reasonably intended by PIXERF;</li><li>interfere or attempt to interfere with the proper functioning of the Site or the Services;</li><li>make improper use of our support services or submit false reports of abuse or misconduct;</li><li>disparage, tarnish or otherwise harm PIXERF, including the Site and the Services;</li><li>reverse engineer, decompile, reverse assemble, modify or attempt to discover any software (source code or object code) or other products or processes accessible through the Site or the Services;</li><li>interfere or circumvent any security feature of the Site or the Services or any feature which restricts or enforces limitations on the use of or access to the Site or the Services or any Content;</li><li>probe, scan or test the vulnerability of any system or network or breach or circumvent any security or authentication measures;</li><li>sell access to the Services or any part thereof other than through a mechanism approved by PIXERF; or</li><li>bypass any measure we take to restrict access to the Site or the Services; or use any technology or device to scrape, spider, or crawl the Services to harvest data, or publish or link to malicious content intended to damage or disrupt another user’s mobile device or computer.</li></ol></li><li><u>Rules Relating to User Content</u> - We reserve the right to remove any information, data or User Content from the Site or the Services at our sole and absolute discretion. By transmitting and submitting any User Content, you further agree that:<ol><li>you understand and agree that by posting, uploading, submitting or making available User Content on the Site, we have the right to display or share such User Content on our platforms or with any other Users and third parties as we may deem appropriate for the provision of the Services;</li><li>you will not post any User Content or other information that is malicious, false, inaccurate or misleading;</li><li>you will not submit User Content, and in particular Marketplace Visual Content, that is copyrighted or subject to third party confidentiality or proprietary rights, including but not limited to privacy, unless you are the owner of such rights or have the appropriate permission from their rightful owner to specifically submit such content and grant us a licence to display such content;</li><li>you understand that User Content posted by you may be republished and if you do not have the right to submit User Content for such use, you may be subject to liability for which PIXERF will not be responsible;</li><li>you will not post information in breach of any legal duty owed to a third party, such as a duty of confidentiality;</li><li>you understand and agree that PIXERF does not research, verify, endorse, represent, warrant or guarantee the truthfulness, completeness, accuracy, reliability, or veracity of any content on the Site, including but not limited to User Content, and that PIXERF has no liability with respect to any such content;</li><li>you will not upload, or otherwise make available, files that contain images, photographs, videos, software or other material protected by intellectual property laws, including, by way of example, and not as limitation, copyright or trademark laws (or by rights of privacy or publicity) unless you have ownership or control of the rights thereto or have received all necessary consent to do the same; and</li><li>you understand and agree that any liability, loss or damage that occurs as a result of the use of any User Content that you make available or access through your use of the Service is your sole responsibility. PIXERF shall not be responsible for any misuse of your User Content. You also agree and understand that PIXERF cannot pre-screen and monitor all User Content.</li></ol></li></ol></li><li><span class=\"terms-page-howitworks__sub-heading text--bold text--color-black\">Portfolio Platform for Personal Users</span><ol><li>You may submit or upload User Visual Content to your portfolio under your account, in accordance with this Clause. The maximum number of User Visual Content which you may submit or upload to your portfolio is as set out in the Site.</li><li>Notwithstanding any contrary provision, PIXERF reserves the right in its sole discretion to remove or reject any User Visual Content submitted or uploaded to your portfolio for any reason whatsoever.</li><li>By submitting or uploading User Visual Content to your portfolio under your account, you grant PIXERF a non-exclusive licence to display such User Visual Content for your non-commercial portfolio purposes.</li></ol></li><li><span class=\"terms-page-howitworks__sub-heading text--bold text--color-black\">Credit Plans for Business Users</span><ol class=terms-page-howitworks__indent-not-list><div><span class=\"terms-page-howitworks__sub-heading text--bold text--color-black\">Consumer advisory</span> - This Credit Plan is regarded as a stored value facility under Singapore law. PIXERF Pte. Ltd., the holder of the Credit Plan stored value facility, does not require the approval of the Monetary Authority of Singapore. Consumers (Business Users) are advised to read these Terms carefully.</div></ol><ol><li><u>Credit Plan</u> - You may purchase credits (\"<u>Credits</u>\") as set out on the Site, which may be used to purchase certain products and services available through the Site, such as licensing of visual content. PIXERF reserves the right in its sole and absolute discretion to reject your request to purchase the Credits.</li><li>Credits may be purchased via your Paypal account or credit/debit card, cheque or wire transfer. By providing your payment information, you represent and warrant that you are the holder of that Paypal account or the cardholder (as the case may be), and that you authorise PIXERF to charge the account or card for all payments stated herein, and to provide that information to third parties for the purposes of facilitating payment. You agree to verify any information requested by PIXERF for purposes of acknowledging or completing any payment.</li><li>The Credits will not expire provided that you log in to your account at least once every twelve (12) months, failing which the Credits will be valid for a period of eighteen (18) months from the date of purchase and will expire thereafter. PIXERF shall have the right to deal with the expired Credits in such manner as it deems fit. You hereby agree that PIXERF shall not be liable to you for any expired Credits.</li><li>The Credits are not redeemable for cash and are not refundable. The Credits are also non-transferable and non-exchangeable. You will not receive any interest or other earnings on your Credits. PIXERF may receive interest on amounts which it holds on your behalf. You agree to assign your rights for any interest accruing from your Credits (if applicable) to PIXERF.</li><li><u>Promotions</u> - All our promotions (if any) are subject to availability and our prevailing terms and conditions.</li></ol></li><li><span class=\"terms-page-howitworks__sub-heading text--bold text--color-black\">Community</span><ol><li>These Terms, the Community Platform Guidelines and any other policies we may notify to you, and the Community Rules (if any) govern the use of the Community feature, including all posts, discussions and events therein.</li><li><u>General Rules</u><ol><li>Community owners shall not inaccurately tag content or encourage members to inaccurately tag content;</li><li>you may not issue invitations to join a Community or an event by “spam inviting” or other general mass mailing methods;</li><li>you shall ensure that your posts, discussions, Communities, events and other content and interactions in the Community (as may be applicable) comply with all applicable laws, statutes and regulations.</li></ol></li><li>If you collect content and information directly from your Community members, it must be made clear that you, and not PIXERF, are collecting such information. You shall provide notice about and obtain Community members’ consent for your collection and use of the content and information that you collect. You are responsible for and shall ensure that all necessary permissions to collect and use their content and information have been obtained, and shall at all times comply with any applicable laws including data protection and privacy laws.</li><li>Community owners may impose fees for an event on their Community. Where event fees are applicable, disclosure of such fees must be made clearly and in advance. The ticketing and payment for events are handled by Community owners through third party service providers and platforms. Community owners shall ensure that it complies with the terms and conditions of the third party provider(s) of the applicable ticketing and payment services. PIXERF does not provide such services and is not a party to the Community owner’s agreement with the third party service provider. PIXERF will not be responsible or liable for any User’s use of such third party services.</li><li>In addition, PIXERF cannot ensure that Community owners will use any event fees made to them as they had indicated or as you may have expected. Please verify before making payments of event fees and check the refund policy of the Community event (if any) before making any such payments.</li><li>The Community administrator:<ol><li>shall ensure the Community remains active and shall administer and manage the Community, including its members, posts, discussions and events;</li><li>is responsible for policing the Community and ensuring that the members, posts, discussions and events comply with these Terms, the Community Rules (if any); the Community Platform Guidelines, and all other applicable terms and policies, and may remove any content or member which is not in compliance; and</li><li>shall promptly assist PIXERF with any requests or queries it may have and any steps which may need to be taken in relation to any flagged or reported Community, its content or event.</li></ol>Where any content has been reported or flagged by a Community member, the Community administrator shall resolve the matter within three (3) days of notification. PIXERF is entitled, but not obliged, to take such action it may deem appropriate if the matter has not been resolved by such period.</li><li>You acknowledge that PIXERF does not supervise, control, monitor, vet, verify or endorse the Communities and any posts, discussions, interactions, events and other content therein. You agree that PIXERF is not responsible for any content on or events in a Community, or the conduct of any Community creators or members, whether on the Community, at any events or elsewhere.</li><li>If a Community or any of its content or event has been reported or flagged, or where there has been any failure to comply with the Terms, Community Rules, Community Platform Guidelines, or any other applicable terms and policies, PIXERF may remove the content in question, suspend activity in or access to the Community or parts thereof, or otherwise de-activate the Community, at its sole discretion. If the relevant issue is remediable, the Community administrator may submit a written request for the Community to be reactivated, which shall be accompanied by a description of the measures which they will implement or the steps which will be taken to prevent the issue from arising again. PIXERF may reactivate the Community at its sole discretion. Any reactivation does not prevent PIXERF from de-activating the Community again or taking any other action which it may deem appropriate.</li></ol></li><li><span class=\"terms-page-howitworks__sub-heading text--bold text--color-black\">Communications</span><ol><div style=\"padding-top: 15px\">All communications between you and PIXERF may be retained by us for our internal records. Save as where expressly provided for in these Terms and our Privacy Policy <span ui-sref=introduction-company.privacy class=subscription-page-business-link>here</span>, we will not reveal such communications to any person, firm or company and shall not use or attempt to use any such communications in any manner without your permission, unless we believe in good faith that the disclosure is necessary to comply with a legal process; protect the rights, property or safety of PIXERF or another party; enforce this agreement; or respond to any complaints.</div></ol></li><li><span class=\"terms-page-howitworks__sub-heading text--bold text--color-black\">Electronic Delivery</span><ol><li>Where appropriate, we use available technology to protect the security of communications made through the Site. However, as no data transmission over the Internet can be guaranteed to be completely secure, we cannot guarantee the security of any information you transmit to us, and you transmit such information at your own risk. We do not accept liability for the security, authenticity, integrity or confidentiality of any transaction and other communications made through the Site.</li><li>Internet communications may be susceptible to interference or interception by third parties. Despite our best efforts, we make no warranties that the Site is free of viruses or other unauthorised software. You should take appropriate steps to keep your information, software and equipment secure. This includes clearing your Internet browser cookies and cache before and after using the Service on the Site.</li></ol></li><li><span class=\"terms-page-howitworks__sub-heading text--bold text--color-black\">Acknowledgement</span><ol><li>You acknowledge and agree that:<ol><li>you are solely responsible (and that we have no responsibility to you or to any third party) for any data and User Content that you transmit, update or upload while using the Site and for the consequences of your actions (including any fees, charges, losses or damages which we may suffer) by doing so;</li><li>your use of the Site and reliance on the Content are entirely at your own risk, and therefore we specifically disclaim any liability arising from or in connection with your use of the Site or the Content;</li><li>PIXERF is not responsible or liable for any User\'s or other\'s content or actions, including any misuse of our Services;</li><li>we reserve the right to review materials posted, to edit, refuse to post, to remove any Content, terminate your access to the Site and the Services at our sole discretion at any time, without notice, for any reason whatsoever;</li><li>the Site may become temporarily unavailable for a number of reasons, including but not limited to, capacity constraints, transmission limitations, equipment modifications, upgrades, relocations, and repairs. Notwithstanding this, we will use reasonable commercial efforts to minimise such non-availability of the Site.</li></ol></li></ol></li><li><span class=\"terms-page-howitworks__sub-heading text--bold text--color-black\">No Warranty</span><ol><li>The Site, the Services and the Content are provided on an \"as is\", \"as available\" basis. We do not warrant the correctness, accuracy, adequacy, completeness, timeliness or validity of the Site, the Services and/or the Content, and expressly disclaim liability for errors or omissions in the Content. No warranty of any kind, implied, express or statutory, including but not limited to the warranties of non-infringement of third party rights, title, merchantability, satisfactory quality and/or fitness for a particular purpose, is given in conjunction with the Site, the Services and/or the Content. You assume full responsibility and risk for your use of the Site and the Services.</li><li>We do not make any representation or warranty, express or implied, with respect to any third party information or services and/or the User Content provided to PIXERF, or its transmission, timeliness, accuracy or completeness, including any implied warranties or warranties of merchantability or fitness for a particular purpose. PIXERF will not be liable in any way to you or to any third party for any inaccuracy, error or delay in or omission of any third party data or service, or the transmission or delivery of any such third party data or service and any loss or damage arising from (a) any such inaccuracy, error, delay or omission; (b) non-performance; or (c) interruption in any such third party data or service due to either any negligent act or omission by PIXERF or force majeure or any other cause beyond the control of PIXERF. You further specifically acknowledge that PIXERF and its officers, directors, employees, agents, subsidiaries and affiliates are not liable, and you agree not to hold the aforementioned parties liable, for the conduct of third parties, and that the risk of the Site and the Services and of injury, damage or loss from the foregoing rests entirely with you.</li><li>We do not warrant that the Site and/or any Services will be provided uninterrupted or free from errors or that any identified faults will be corrected; further, no warranty is given that the Site and the Services are free from any computer virus or other malicious, destructive or corrupting code/programme. No advice or information, whether oral or written, obtained from PIXERF or through the Site or the Services, will create any warranty not expressly made herein.</li></ol></li><li><span class=\"terms-page-howitworks__sub-heading text--bold text--color-black\">Disclaimer of Liability</span><ol><p style=\"padding-top: 10px\">Save as provided for in the Licence Agreement, and to the fullest extent permitted by law, we shall in no event be liable for any death, injury, direct, indirect, incidental, special, consequential, exemplary damages or other indirect damages or costs of any kind suffered or incurred by you or any third party arising from or in connection with your use of the Site, the Services or the Content.</p></ol></li><li><span class=\"terms-page-howitworks__sub-heading text--bold text--color-black\">Representation and Warranty</span><ol><li>You hereby represent and warrant that:<ol><li>all information provided by you is accurate, complete and up to date, including any compliance with licences, governmental or third party approvals and consents;</li><li>you have all necessary permissions, rights and licences to provide the User Content to the Site, and that such User Content does not violate the rights of any individual or entity;</li><li>you are not contractually and/or legally restricted from performing any of your obligations herein or any actions that you may take;</li><li>you will notify PIXERF promptly of any unauthorised access to or use of the Site, the Content, or of your account;</li><li>you will not reveal or otherwise misuse any information available through the Site.</li></ol></li></ol></li><li><span class=\"terms-page-howitworks__sub-heading text--bold text--color-black\">Indemnity</span><ol><li>You shall indemnify and hold us, our officers, directors, shareholders, predecessors, successors in interest, employees, agents, subsidiaries and affiliates, harmless from all demands, claims, actions, proceedings, judgements, orders, decrees, damages, costs, losses and expenses of any nature whatsoever against us by any third party due to or arising out of or in connection with any failure by you to comply with any of these Terms, our Privacy Policy or otherwise by your use of the Site or the Services.</li><li>Your obligations under the foregoing indemnity may not be offset against any other claim you may have against PIXERF, or any our officers, directors, employees, agents, subsidiaries and affiliates.</li><li>You remain solely responsible for all User Content that you upload, post, transmit, or otherwise disseminate using, or in connection with, the Site or the Services.</li><li>You agree that this provision shall survive any termination of your account on the Site.</li></ol></li><li><span class=\"terms-page-howitworks__sub-heading text--bold text--color-black\">Proprietary Rights</span><ol><li>The Site is owned and operated by PIXERF. The Content located on the Site is protected by copyright, trademark and other forms of proprietary rights. Unless expressly stated, all rights, title, benefit and interest in the Content are owned by, licensed to or controlled by PIXERF.</li><li>You acknowledge and agree that we own, or have the licence to use, the Site and the Content, including the source and object codes, pages, documents and online graphics, audio, video and such other content found in the Site and any and all intellectual property rights used or embodied in or in connection thereto. The Site and the Content shall not be reproduced, republished, transmitted or distributed in any way, without the prior written permission of PIXERF or the applicable proprietary right holder.</li><li>You agree that PIXERF may, at its sole and absolute discretion and to the extent permitted by law, access, preserve or disclose your account information, usage history and activity in order to:<ol><li>comply with any applicable law, regulation, legal process, or government request;</li><li>respond to claims that any Content or User Content violates the rights of third parties;</li><li>enforce these Terms and investigate potential violations thereof;</li><li>detect, prevent, or otherwise address fraud, security, or technical issues;</li><li>protect the rights, property, or personal safety of PIXERF, its Users, or the public.</li></ol></li></ol></li><li><span class=\"terms-page-howitworks__sub-heading text--bold text--color-black\">Termination</span><ol><li>The term of this agreement commences when you register your account with us, and will continue in effect until terminated by you or PIXERF as set out in these Terms.</li><li>If you wish to terminate this Agreement, please contact PIXERF at <a href=mailto:notify@pixerf.com class=\"text--bold text--color-pixerf-theme\">notify@pixerf.com</a> using your email address registered with PIXERF. PIXERF will revert within fifteen (15) working days and inform you whether or not the account termination request has been approved. This request may not be approved by PIXERF in certain scenarios. For example, if your account (i) has any ongoing Custom Content Assignments; (ii) has any User Visual Content in the process of being licensed; (iii) has any Community Challenge Visual Content in ongoing Community Challenges and/or which have been selected as Challenge Winners or Special Mentions; or (iv) has existing credit plans or subscriptions. If the request has not been approved, PIXERF will indicate the reason and inform you when you can request for account termination.<br><br>If the request has been approved, the account deletion process may take up to 180 days. PIXERF will summarise any existing sales in respect of your account, and it is your responsibility to request for the remaining earning payout (if any) within seven (7) days from PIXERF’s notification.</li><li>PIXERF may terminate the agreement with immediate effect without any written notice to you if PIXERF ceases to provide the Site at its sole discretion, or if you have breached or violated any of these Terms or the Privacy Policy <span ui-sref=introduction-company.privacy class=subscription-page-business-link>here</span>, or where otherwise provided for in these Terms.</li><li>In the event of any termination, you will have no rights to the continued use or access to the Site, the Services or your account. It is your responsibility to retain copies of your User Visual Content. PIXERF will have no obligation to maintain your account or to retain or forward any information in your account, except as required by the applicable law. PIXERF will retain your contact details for administrative reasons, including in case of any potential future disputes, and your User Visual Content that have been licensed prior to termination.</li></ol></li><li><span class=\"terms-page-howitworks__sub-heading text--bold text--color-black\">General</span><ol><li>Nothing contained in these Terms shall be so construed as to create any agency, partnership or joint venture of any kind between the parties hereto.</li><li>No failure by us to exercise and no delay by us in exercising any right, power or remedy under these Terms will operate as a waiver. Nor will any single or partial exercise by us of any right, power or remedy preclude any other or further exercise of that or any other right, power or remedy by us. No waiver shall be valid unless in writing signed by us. The rights and remedies herein are in addition to any rights or remedies provided by law.</li><li>All rights and obligations hereunder are personal to the parties and each party shall not assign any such rights and obligations to any third party without the prior consent in writing of us.</li><li>Any one or more clauses, stipulations or provisions of these Terms, or any part thereof, which is declared or adjudged to be illegal, invalid, prohibited or unenforceable under any applicable law in any jurisdiction shall be ineffective to the extent of such illegality, invalidity, prohibition or unenforceability without invalidating, vitiating or rendering unenforceable the remaining clauses, stipulations or provisions of these Terms, and any such illegality, invalidity, prohibition or unenforceability in any jurisdiction shall not invalidate, vitiate or render unenforceable any such clauses, stipulations or provisions in any other jurisdiction.</li></ol></li><li><span class=\"terms-page-howitworks__sub-heading text--bold text--color-black\">Dispute Resolution</span><ol><li>If you have any disputes or differences arising out of or in connection with these Terms or the Privacy Policy <span ui-sref=introduction-company.privacy class=subscription-page-business-link>here</span>, including any question regarding their existence, validity or termination, you agree to notify PIXERF of the same in writing by way of email at <a class=\"pixerf-link pixerf-link--color-theme\" href=mailto:notify@pixerf.com target=_top>notify@pixerf.com</a>.</li><li>Any dispute arising out of or in connection with these Terms or the Privacy Policy <span ui-sref=introduction-company.privacy class=subscription-page-business-link>here</span> including any questions regarding its existence, validity or termination shall be referred to and finally resolved by arbitration in Singapore in accordance with the Arbitration Rules of the Singapore International Arbitration Centre for the time being in force which rules are deemed to be incorporated by reference into this provision. The Tribunal shall consist of one arbitrator (\"<u>Arbitrator</u>\") to be appointed by the Chairman of the Singapore International Arbitration Centre. The language of the arbitration shall be English.</li><li>The decision in writing of the Arbitrator shall be final and conclusive upon both parties. The costs and expenses of arbitration, including the compensation and expenses of the Arbitrator, shall be borne by the parties as the Arbitrator may determine. Either party may apply to any court which has jurisdiction for an order confirming the award or commence legal proceedings to sue on the award. Except as provided below, any right of either party to judicial action on any matter subject to arbitration hereunder is hereby waived, except suit to enforce the arbitration award.</li><li>Notwithstanding the above and the arbitration provided for herein, actions initiated or maintained by either party for injunctive relief, whether mandatory or prohibitory or similar relief in equity are not subject to arbitration and may be brought by either party in any court which has jurisdiction. Actions may also be initiated or maintained by either party where the same is relevant or necessary for such party to obtain or secure any interlocutory or interim relief, including but not limited to proceedings for detention, custody or preservation of any property.</li></ol></li><li><span class=\"terms-page-howitworks__sub-heading text--bold text--color-black\">Governing Law</span><ol><p style=\"padding-top: 10px\">These Terms shall be construed and its performance governed in accordance with the law of the Republic of Singapore.</p></ol></li></ol><p style=\"padding-top: 30px\">The last update to our Terms and Conditions was posted on 31 August 2021.</p></div></div><div class=terms-page-howitworks__content-right></div></section></div>");
$templateCache.put("app/introduction/discover/marketplace/marketplace.html","<div class=\"marketplace-page no-margin\"><section class=\"row marketplace-page-branding-wrapper\"><div class=marketplace-page__branding><p class=marketplace-page__branding--earn>EARN MONEY WITH YOUR PHOTOS</p><p class=marketplace-page__branding--showcase>Showcase Your Unique Style to Buyers Around the World</p><button class=\"btn btn--transparent marketplace-page__btn-signup\">Sign Up. It\'s Free</button></div></section><section class=\"row marketplace-page-howitworks__wrapper\"><p class=\"marketplace-page-howitworks__heading text--bold text--color-black\">HOW IT WORKS</p><div class=col-md-4><span class=\"icon-icons_camera text--color-black\"></span><br><span class=marketplace-page-howitworks__blocktitle>SHOOT TO EARN</span><p class=marketplace-page-howitworks__blockpara>Take on a PIXERF Mission.Read<br>The Creative brief and submit your<br>best photo. Favorites are nominated<br>and the best ones are bought.</p></div><div class=col-md-4><span class=\"icon-icons_image text--color-black\"></span><br><span class=marketplace-page-howitworks__blocktitle>GET ACCESS</span><p class=marketplace-page-howitworks__blockpara>If Buyers nominate your work,<br>you\'ll level up. This earns you access<br>to live Buyer Missions and<br>commissioned assignments.</p></div><div class=col-md-4><span class=\"icon-icons_search text--color-black\"></span><br><span class=marketplace-page-howitworks__blocktitle>BUILD YOUR PORTFOLIO</span><p class=marketplace-page-howitworks__blockpara>Your best photos can also<br>be selected to move into our<br>Marketplace, making it available for<br>our Buyers to purchase directly.</p></div></section><section class=\"row marketplace-page-infographic\"><div class=marketplace-page-infographic__infotext>Infographic</div></section></div>");
$templateCache.put("app/introduction/discover/signature-gallery/signature-gallery.html","<div class=\"signature-gallery-page no-margin\"><section class=\"row signature-gallery-page-branding-wrapper\"><div class=signature-gallery-page__branding><p class=signature-gallery-page__branding--earn>AUTHENTIC HAND-PICKED<br>IMAGES JUST FOR YOU</p><p class=signature-gallery-page__branding--showcase>Lorem ipsum dolor sit amet, consectetur adipiscing elit</p><button class=\"btn btn--transparent signature-gallery-page__btn-signup\">Sign Up. It\'s Free</button></div></section><section class=\"row signature-gallery-page-howitworks__wrapper\"><p class=\"signature-gallery-page-howitworks__heading text--bold text--color-black\">HOW IT WORKS</p><div class=col-md-4><span class=\"icon-icons_camera text--color-black\"></span><br><span class=signature-gallery-page-howitworks__blocktitle>REQUEST PHOTOS</span><p class=signature-gallery-page-howitworks__blockpara>Tell Photographers what you\'re looking<br>for, set price, and when you need it.</p></div><div class=col-md-4><span class=\"icon-icons_image text--color-black\"></span><br><span class=signature-gallery-page-howitworks__blocktitle>REVIEW SUBMISSIONS</span><p class=signature-gallery-page-howitworks__blockpara>Nominate your favorites to help other<br>photographers know what you like and<br>organize your real time feed.</p></div><div class=col-md-4><span class=\"icon-icons_search text--color-black\"></span><br><span class=signature-gallery-page-howitworks__blocktitle>PURCHASE THE BEST</span><p class=signature-gallery-page-howitworks__blockpara>License photos that best match your<br>original vision and award photographers<br></p></div></section><section class=\"row signature-gallery-page-infographic\"><div class=signature-gallery-page-infographic__infotext>Infographic</div></section><div ng-include=footer.html></div></div>");
$templateCache.put("app/introduction/pixerfer/about-leveling/about-leveling.html","<div class=\"about-leveling-page no-margin\"><section class=\"row about-leveling-page-branding-wrapper\"><div class=about-leveling-page__branding><p class=\"about-leveling-page__branding--earn col-md-8 col-md-offset-2\">CONNECT, PLAY THE GAME AND LET THE LEVELS TAKE YOU FURTHER</p><p class=\"about-leveling-page__branding--showcase col-md-6 col-md-offset-3\">Levelling enables you to unlock different price points as you move up the ranks. Advance through the levels to earn points and gain more exposure!</p></div></section><section class=\"row about-leveling-page-howitworks__wrapper\"><p class=\"about-leveling-page-howitworks__heading text--bold text--color-black\">SOMETHING BIG IS COMING</p><div class=about-leveling-page-howitworks__main-content><p>The more you participate, the more you\'ll be rewarded.<br>We\'ll be revealing more about levelling soon.</p></div><p class=\"about-leveling-page-howitworks__heading text--bold text--color-black\">WATCH THIS SPACE!</p><div class=\"row about-leveling-page-infographic\"><div class=about-leveling-page-infographic__infotext><img src=assets/images/footer-pages/levelling-01.jpg alt=\"\" width=80%></div></div></section><section class=\"row about-leveling-page-couple text--color-black\"><div class=about-leveling-page-couple__infotext>PIXERF is here to help!</div><div class=about-leveling-page-faq__more-content>Check out our <a class=mission-page-faq__more-content--faq-link ui-sref=introduction-support.faq.personal>FAQs</a> or send us an email.</div><button type=button class=\"btn about-leveling-page-howitworks__account-type-btn btn-submit\" ui-sref=email-us-page>Ask PIXERF</button></section></div>");
$templateCache.put("app/introduction/pixerfer/credit-plans/credit-plans.html","<div class=\"credit-plans-page no-margin\"><section class=\"row credit-plans-page-branding-wrapper\"><div class=credit-plans-page__branding><p class=\"credit-plans-page__branding--earn col-md-6 col-md-offset-3\">IMAGINE VALUE, AMPLIFIED</p><p class=\"credit-plans-page__branding--showcase col-md-6 col-md-offset-3\">Promoting your brand across multiple channels? Our credit plans make it easy.<br>We can help you do more with less.</p></div></section><section class=\"row credit-plans-page-earn__wrapper\"><p class=\"credit-plans-page-earn__heading text--bold text--color-black\">SOMETHING EXCITING IS COMING</p><div class=subscriptions-page-pricing__main-content>You deserve a competitive price for the great work you do, and we know it!<br>We’ll be revealing our payout and pricing schemes soon.</div><p class=\"credit-plans-page-earn__heading text--bold text--color-black\">WATCH THIS SPACE!</p><!-- <div class=\"credit-plans-page-earn__main-content\">\r\n      <div class=\"col-md-4\">\r\n        <div class=\"credit-plans-page-earn__main-content--pricing-bg col-md-12\">\r\n          <div class=\"credit-plans-page-earn__main-content--pricing\">\r\n            <h2>STANDARD</h2>\r\n            <h1><sub>SGD</sub>900 <sup>.00</sup></h1>\r\n            <p>Save SGD 100</p>\r\n          </div>\r\n          <div class=\"credit-plans-page-earn__main-content--pricing-benefits\">\r\n            <strong>SGD 1,000</strong> banked into <br>\r\n            your PIXERF account <br>\r\n            <strong>(Save 10%)</strong>\r\n          </div>\r\n          <div class=\"\">\r\n            <button type=\"button\" class=\"credit-plans-page-earn__subscribe-btn\">Sign Up</button>\r\n          </div>\r\n        </div>\r\n      </div>\r\n      <div class=\"col-md-4\">\r\n        <div class=\"credit-plans-page-earn__main-content--pricing-bg col-md-12\">\r\n          <div class=\"credit-plans-page-earn__main-content--pricing\">\r\n            <h2>PREMIUM</h2>\r\n            <h1><sub>SGD</sub>2,550 <sup>.00</sup></h1>\r\n            <p>Save SGD 450</p>\r\n          </div>\r\n          <div class=\"credit-plans-page-earn__main-content--pricing-benefits\">\r\n            <strong>SGD 3,000</strong> banked into <br>\r\n            your PIXERF account <br>\r\n            <strong>(Save 15%)</strong>\r\n          </div>\r\n          <div class=\"\">\r\n            <button type=\"button\" class=\"credit-plans-page-earn__subscribe-btn\">Sign Up</button>\r\n          </div>\r\n        </div>\r\n      </div>\r\n      <div class=\"col-md-4\">\r\n        <div class=\"credit-plans-page-earn__main-content--pricing-bg col-md-12\">\r\n          <div class=\"credit-plans-page-earn__main-content--pricing\">\r\n            <h2>PREMIUM</h2>\r\n            <h1><sub>SGD</sub>4,000 <sup>.00</sup></h1>\r\n            <p>Save SGD 1,000</p>\r\n          </div>\r\n          <div class=\"credit-plans-page-earn__main-content--pricing-benefits\">\r\n            <strong>SGD 5,000</strong> banked into <br>\r\n            your PIXERF account <br>\r\n            <strong>(Save 20%)</strong>\r\n          </div>\r\n          <div class=\"\">\r\n            <button type=\"button\" class=\"credit-plans-page-earn__subscribe-btn\">Sign Up</button>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div> --></section><section class=\"row credit-plans-page-couple text--color-black\"><div class=credit-plans-page-couple__infotext>PIXERF is here to help!</div><div class=credit-plans-page-faq__more-content>Check out our <a class=credit-plans-page-faq__more-content--faq-link ui-sref=introduction-support.faq.personal>FAQs</a> or send us an email.</div><button type=button class=\"btn credit-plans-page-ask__account-type-btn btn-submit\" ui-sref=email-us-page>Ask PIXERF</button></section></div>");
$templateCache.put("app/introduction/pixerfer/payout/biz-payout.html","<div class=\"payout-page no-margin\"><section class=\"row payout-page-branding-wrapper\"><div class=payout-page__branding><p class=\"payout-page__branding--earn col-md-6 col-md-offset-3\">BE PART OF THE CREATIVE BIG BANG</p><p class=\"payout-page__branding--showcase col-md-6 col-md-offset-3\">PIXERF is the only visual marketplace that offers the most attractive<br>payouts for businesses. We offer customisable pricing plans.<br>Check it out for yourself</p></div></section><section class=\"row payout-page-earn__wrapper text--color-black\"><p class=\"payout-page-earn__heading text--bold\">PAYOUT</p><div class=\"payout-page-earn__content payout-page-earn__content--business\"><div class=\"payout-page-earn__from-market--marketsize payout-page-earn__from-market--marketsize--business pull-left\"><div class=\"payout-page-earn__from-market--title text--bold text--color-pixerf-theme\">From Marketplace & Missions</div><div class=\"payout-page-earn__from-market--percent text--bold\">40%</div><div class=payout-page-earn__from-market--unit>payout for<br>every image sold</div><div class=\"payout-page-earn__from-market--description payout-page-earn__from-market--description--business\">Free business accounts earn 40% of the net price of their visuals licensed through Marketplace and Missions.</div></div><div class=\"payout-page-earn__from-market--marketsize payout-page-earn__from-market--marketsize--business pull-left\"><div class=\"payout-page-earn__from-market--title text--bold text--color-pixerf-theme\">From Marketplace & Missions</div><div class=\"payout-page-earn__from-market--percent text--bold\">60%</div><div class=payout-page-earn__from-market--unit>payout for<br>every image sold</div><div class=\"payout-page-earn__from-market--description payout-page-earn__from-market--description--business\">Premium accounts earn 60% of the net price of their visuals licensed through Marketplace and Missions.</div></div><div class=\"payout-page-earn__from-mission--missionsize payout-page-earn__from-mission--missionsize--business pull-right\"><div class=\"payout-page-earn__from-market--title text--bold text--color-pixerf-theme\">From Marketplace & Missions</div><div class=pull-left><div class=\"payout-page-earn__from-market--percent text--bold\">60%</div><div class=payout-page-earn__from-market--unit>payout for<br>every image sold</div></div><div class=pull-right><div class=\"payout-page-earn__from-market--percent text--bold\">70%</div><div class=payout-page-earn__from-market--unit>payout for<br>every image sold</div></div><div class=\"pull-left payout-page-earn__from-market--description payout-page-earn__from-market--description--mission-business\">Executive accounts earn 60% and 70% of the net price of their visuals licensed through Marketplace and Missions respectively.</div></div></div></section><section class=\"payout-page-earn__payoutwrapper text--color-black\"><p class=\"payout-page-earn__heading text--bold\">PRICING</p><div class=\"row payout-page-earn__content--business payout-page-earn__content\"><div class=\"col-md-4 payout-page-pricing__title pull-left text--bold\">FREE USER<div class=payout-page-pricing__box><div class=\"payout-page-pricing__box--boxtitle text--color-pixerf-theme\">Based on your level</div><div class=payout-page-pricing__box--content><span>Avid Pixerfer</span><span class=payout-page-pricing__box--right-content>------ SGD10</span><br><span>Savvy Pixerfer</span><span class=payout-page-pricing__box--right-content>------ SGD30</span><br><span>Advanced Pixerfer</span><span class=payout-page-pricing__box--right-content> -- SGD50</span><br><span>Expert Pixerfer</span><span class=payout-page-pricing__box--right-content> ----- SGD70</span><br><span>Pixerfer Whiz</span><span class=payout-page-pricing__box--right-content> ------ SGD90</span><br></div></div></div><div class=\"col-md-4 payout-page-pricing__title pull-left text--bold\">PREMIUM<div class=payout-page-pricing__box><div class=\"payout-page-pricing__box--boxtitle text--color-pixerf-theme\">3-tier pricing</div><div class=\"payout-page-pricing__box--content payout-page-pricing__box--content-premium\"><div>Small</div><div class=payout-page-pricing__box--subtitle-pricing>10% of price set for large photo</div><div>Medium</div><div class=payout-page-pricing__box--subtitle-pricing>50% of price set for large photo</div><div>Large</div><div class=payout-page-pricing__box--subtitle-pricing>SGD100 SGD150 SGD200</div></div></div></div><div class=\"col-md-4 payout-page-pricing__title pull-right text--bold\">EXECUTIVE<div class=payout-page-pricing__box><div class=\"payout-page-pricing__box--boxtitle text--color-pixerf-theme\">5-tier pricing</div><div class=\"payout-page-pricing__box--content payout-page-pricing__box--content-excutive\"><div>Small</div><div class=payout-page-pricing__box--subtitle-pricing>10% of price set for large photo</div><div>Medium</div><div class=payout-page-pricing__box--subtitle-pricing>50% of price set for large photo</div><div>Large</div><div class=payout-page-pricing__box--subtitle-pricing>SGD100 - 1,000</div><div class=payout-page-pricing__box--subtitle-pricing>(increments of SGD100)</div></div></div></div></div></section><section class=\"row payout-page-couple text--color-black\"><div class=payout-page-couple__infotext>PIXERF is here to help!</div><div class=payout-page-faq__more-content>Check out our <a class=credit-plans-page-faq__more-content--faq-link ui-sref=introduction-support.faq.personal>FAQs</a> or send us an email</div><button type=button class=\"btn payout-page-ask__account-type-btn btn-submit\" ui-sref=email-us-page>Ask PIXERF</button></section></div>");
$templateCache.put("app/introduction/pixerfer/payout/payout.html","<div><!-- <div class=\"pixerf-subnavigation-bar-wrapper\">\r\n        <ul class=\"pixerf-subnavigation-bar\">\r\n            <li ui-sref-active=\"pixerf-subnavigation-bar__menu-item--active\" ui-sref=\"introduction-pixerfer.payout.personal\" class=\"pixerf-subnavigation-bar__menu-item\">PERSONAL</li>\r\n            <li ui-sref-active=\"pixerf-subnavigation-bar__menu-item--active\" ui-sref=\"introduction-pixerfer.payout.business\" class=\"pixerf-subnavigation-bar__menu-item\">BUSINESS</li>\r\n        </ul>\r\n    </div> --><!-- <div class=\"col-md-12 introduction-page__main-content marketplace-wrap\" ui-view></div> --></div><div ui-view></div>");
$templateCache.put("app/introduction/pixerfer/payout/per-payout.html","<div class=\"payout-page payout-personal no-margin\"><section class=\"row payout-page-branding-wrapper\"><div class=payout-page__branding><p class=payout-page__branding--earn>You\'re Sitting on Gold</p><p class=payout-page__branding--showcase>The photos you have could be earning you real money. Turn them into gold and upload them to PIXERF now!</p><photo-info-link photo=vm.brandingPhoto></photo-info-link></div></section><section class=\"row payout-page-earn__wrapper\"><p class=\"payout-page-earn__heading text--color-black\">Enjoy high payout rates</p><div class=payout-page-earn__description>The photos you have could be earning you real money. Turn them into gold and upload them to PIXERF now! That\'s why PIXERF offers one of the best payout rates in the market, with no conditions of exclusivity.</div><div class=\"payout-personal__content clearfix\"><div class=\"payout-personal__content__user col-sm-6 col-sm-offset-3\"><div class=\"payout-personal__content__user-title text--bold\">Free Users</div><div class=\"payout-personal__content__user-detail clearfix\"><div class=\"text--bold-switch-semibold text--color-black\">Earn</div><div class=\"payout-personal__content__user-percent text--color-pixerf-theme\"><span class=text--bold>50</span><span class=payout-personal__content__user-percent-unit>%</span></div><div class=\"text--bold-switch-semibold text--color-black\">for every image licensed</div><div class=payout-personal__content__user-description>Free users earn 50% of the net price of their photos licensed through Marketplace and Challenges.</div></div></div><!-- <div class=\"payout-personal__content__user col-sm-6\">\r\n				<div class=\"payout-personal__content__user-title text--bold \">Paid Users</div>\r\n				<div class=\"payout-personal__content__user-detail clearfix\">\r\n					<div class=\"text--semibold text--color-black\">Earn</div>\r\n					<div class=\"payout-personal__content__user-percent text--color-pixerf-theme\"><span class=\"text--bold\">60</span><span class=\"payout-personal__content__user-percent-unit\">%</span></div>\r\n					<div class=\"text--semibold text--color-black\">for every image licensed</div>\r\n					<div class=\"payout-personal__content__user-description\">Paid users earn 60% of the net price of their photos licensed through Marketplace and Challenges.</div>\r\n				</div>\r\n			</div> --></div><div class=payout-personal__request-wrapper><div class=\"payout-personal__request-title text--semibold text--color-black\">Request your payout</div><div class=\"payout-personal__request-col-wrapper clearfix\"><div class=\"payout-personal__request-col payout-request-first-col col-sm-4\"><div class=\"payout-personal__request-col__icon payout-personal__request-col__icon--paypal text--bold\"></div><div class=\"payout-personal__request-col__title text--bold text--color-pixerf-theme\">PayPal</div><div class=payout-personal__request-col__description>PayPal is one of the fastest, safest ways to send money online. <a href=\"https://www.paypal.com/us/cgi-bin/webscr?cmd=_display-country-functionality-outside\" class=\"text--bold text--color-pixerf-theme\">Please check here</a> if your country can receive payments via PayPal.</div></div><div class=\"payout-personal__request-col payout-request-mid-col col-sm-4\"><div class=\"payout-personal__request-col__icon payout-personal__request-col__icon--wire-transfer text--bold\"></div><div class=\"payout-personal__request-col__title text--bold text--color-pixerf-theme\">Wire Transfer</div><div class=payout-personal__request-col__description>A wire transfer can be made from one bank account to another bank account. Transfer fees in respective countries will apply.</div></div><div class=\"payout-personal__request-col payout-request-last-col col-sm-4\"><div class=\"payout-personal__request-col__icon payout-personal__request-col__icon--cheque text--bold\"></div><div class=\"payout-personal__request-col__title text--bold text--color-pixerf-theme\">Cheque</div><div class=payout-personal__request-col__description>We currently offer cheque payments in Singapore, with a small fee applicable per cheque.</div></div></div><div class=for-more-information>For more information about our Payout & Pricing, check out our FAQ <a ui-sref=introduction-support.faq.personal class=\"text--bold text--color-pixerf-theme\">here!</a></div></div></section><section class=\"row payout-page-couple text--color-black\"><div class=payout-page-couple__infotext>PIXERF is here to help!</div><div class=payout-page-faq__more-content>Check out our <a class=credit-plans-page-faq__more-content--faq-link ui-sref=introduction-support.faq.personal>FAQs</a> or send us an email.</div><button type=button class=\"btn payout-page-ask__account-type-btn btn-submit\" ui-sref=email-us-page>Ask PIXERF</button></section></div>");
$templateCache.put("app/introduction/pixerfer/subscriptions/biz-subscriptions.html","<div class=\"subscriptions-page no-margin\"><section class=\"row subscriptions-page-branding2-wrapper\"><div class=subscriptions-page__branding2><p class=subscriptions-page__branding--earn>Make Your Brand Stand Out</p><p class=subscriptions-page__branding--showcase>Subscribe to unlock customisable home page features, additional uploads and greater earnings.<br>Differentiate yourself today.</p><photo-info-link photo=vm.brandingPhoto></photo-info-link></div></section><section class=\"row subscriptions-page-pricing__wrapper\"><p class=\"subscriptions-page-pricing__heading text--semibold text--color-black\">Something exciting is coming</p><div class=subscriptions-page-pricing__main-content>Want to take your photography to the next level, receive higher payouts and earn more?<br>We’ll be revealing our subscription plans soon.<p class=\"subscriptions-page-pricing__heading text--semibold text--color-black\">Watch this space!</p></div><!-- <div class=\"subscriptions-page-pricing__main-content\">\r\n        <div class=\"subscriptions-page-pricing__main-content--pricing-benefits-biz col-md-3\">\r\n          <ul>\r\n            <li>Photo Sizes & Prices</li>\r\n            <li>Business Profile Page</li>\r\n            <li>Multi-User Account Function</li>\r\n            <li>Personal Portfolio Microsite</li>\r\n            <li>Microsite Templates</li>\r\n          </ul>\r\n        </div>\r\n        <div class=\"col-md-3\">\r\n          <div class=\"subscriptions-page-pricing__main-content--pricing-bg col-md-12\">\r\n            <div class=\"subscriptions-page-pricing__main-content--pricing\">\r\n              <h2>FREE</h2>\r\n              <h1 class=\"free\">Free</h1>\r\n              <p>Business Account</p>\r\n            </div>\r\n            <ul>\r\n              <li>\r\n                SGD 10 - 90<br><br><br><br><br><br><br>\r\n              </li>\r\n              <li>20 photo uploads per day</li>\r\n              <li>X<br><br><br><br></li>\r\n              <li>X</li>\r\n              <li>X</li>\r\n              <li><button type=\"button\" class=\"subscriptions-page-pricing__subscribe-btn\">Sign Up</button></li>\r\n            </ul>\r\n          </div>\r\n        </div>\r\n        <div class=\"col-md-3\">\r\n          <div class=\"subscriptions-page-pricing__main-content--pricing-bg col-md-12\">\r\n            <div class=\"subscriptions-page-pricing__main-content--pricing\">\r\n              <h2>PREMIUM</h2>\r\n              <h1><sub>SGD</sub>120 <sup>.00</sup><sub>/ yearly</sub></h1>\r\n              <p>SGD 10.00 / month</p>\r\n            </div>\r\n            <ul>\r\n              <li>\r\n                <strong>Small</strong>\u2028<br>\r\n                10% of price set for large photo<br>\r\n                <strong>Medium</strong><br>\r\n                50% of price set for large photo<br>\r\n                <strong>Large</strong><br>\r\n                SGD 100 - 500 <br>(increments of SGD 100)\r\n              </li>\r\n              <li>200 photo uploads per day</li>\r\n              <li>Admin <br> Curator <br> Buyer <br><br> </li>\r\n              <li>50 photo uploads per week</li>\r\n              <li>Choice of 5 template(s)</li>\r\n              <li><button type=\"button\" class=\"subscriptions-page-pricing__subscribe-btn\">Sign Up</button></li>\r\n            </ul>\r\n          </div>\r\n        </div>\r\n        <div class=\"col-md-3\">\r\n          <div class=\"subscriptions-page-pricing__main-content--pricing-bg col-md-12\">\r\n            <div class=\"subscriptions-page-pricing__main-content--pricing\">\r\n              <h2>EXECUTIVE</h2>\r\n              <h1><sub>SGD</sub>300 <sup>.00</sup><sub>/ yearly</sub></h1>\r\n              <p>SGD 25.00 / month</p>\r\n            </div>\r\n            <ul>\r\n              <li>\r\n                <strong>Small</strong>\u2028<br>\r\n                10% of price set for large photo<br>\r\n                <strong>Medium</strong><br>\r\n                50% of price set for large photo<br>\r\n                <strong>Large</strong><br>\r\n                SGD 100 - 1,000 <br>(increments of SGD 100)\r\n              </li>\r\n              <li>Unlimited photo uploads per day</li>\r\n              <li>Admin <br> Curator <br> Buyer <br> Marketer</li>\r\n              <li>200 photo uploads per week</li>\r\n              <li>Choice of 10 template(s)</li>\r\n              <li><button type=\"button\" class=\"subscriptions-page-pricing__subscribe-btn\">Sign Up</button></li>\r\n            </ul>\r\n          </div>\r\n        </div>\r\n    </div> --><!-- <div class=\"subscriptions-page-pricing__accept-terms col-md-12\">\r\n      <p>By clicking “Sign Up“, I accepted the <a class=\"credit-plans-page-faq__more-content--faq-link\" ui-sref=\"introduction-company.terms\">Terms of Service</a></p>\r\n    </div> --></section><section class=\"row subscriptions-page-couple text--color-black\"><div class=subscriptions-page-couple__infotext>PIXERF is here to help!</div><div class=subscriptions-page-faq__more-content>Check out our <a class=credit-plans-page-faq__more-content--faq-link ui-sref=introduction-support.faq.personal>FAQs</a> or send us an email.</div><button type=button class=\"btn subscriptions-page-pricing__account-type-btn btn-submit\" ui-sref=email-us-page>Ask PIXERF</button></section></div>");
$templateCache.put("app/introduction/pixerfer/subscriptions/per-subscriptions.html","<div class=\"subscriptions-page no-margin\"><section class=\"row subscriptions-page-branding-wrapper\"><div class=subscriptions-page__branding><p class=subscriptions-page__branding--earn>Be a Pixerfer Pro or Maestro</p><p class=subscriptions-page__branding--showcase>Subscribe to receive higher payouts and take your photos to the next level.<br>Choose what works best for you.</p><photo-info-link photo=vm.brandingPhoto></photo-info-link></div></section><section class=\"row subscriptions-page-pricing__wrapper\"><p class=\"subscriptions-page-pricing__heading text--semibold text--color-black\">Something exciting is coming</p><div class=subscriptions-page-pricing__main-content>Want to take your photography to the next level, receive higher payouts and earn more?<br>We’ll be revealing our subscription plans soon.<p class=\"subscriptions-page-pricing__heading text--semibold text--color-black\">Watch this space!</p></div><!-- <div class=\"subscriptions-page-pricing__main-content\">\r\n        <div class=\"subscriptions-page-pricing__main-content--pricing-benefits col-md-3\">\r\n          <ul>\r\n            <li>Photo Sizes & Prices</li>\r\n            <li>User Profile Page</li>\r\n            <li>Payout Per Image Sold</li>\r\n            <li>Payout Per Mission Image Sold</li>\r\n            <li>Multi-Seat</li>\r\n            <li>Personal Portfolio Microsite</li>\r\n            <li>Microsite Templates</li>\r\n          </ul>\r\n        </div>\r\n        <div class=\"col-md-3\">\r\n          <div class=\"subscriptions-page-pricing__main-content--pricing-bg col-md-12\">\r\n            <div class=\"subscriptions-page-pricing__main-content--pricing\">\r\n              <h2>PIXERFER</h2>\r\n              <h1 class=\"free\">Free</h1>\r\n              <p>User Account</p>\r\n            </div>\r\n            <ul>\r\n              <li><strong>Based on your level</strong><br>\r\n                Avid Pixerfer - SGD 10<br>\r\n                Savvy Pixerfer - SGD 30<br>\r\n                Advanced Pixerfer - SGD 50<br>\r\n                Expert Pixerfer - SGD 70<br>\r\n                Pixerfer Whiz - SGD 90\r\n              </li>\r\n              <li>20 photo uploads per day</li>\r\n              <li>40%</li>\r\n              <li>40%</li>\r\n              <li>X</li>\r\n              <li>X</li>\r\n              <li>X</li>\r\n              <li><button type=\"button\" class=\"subscriptions-page-pricing__subscribe-btn\">Sign Up</button></li>\r\n            </ul>\r\n          </div>\r\n        </div>\r\n        <div class=\"col-md-3\">\r\n          <div class=\"subscriptions-page-pricing__main-content--pricing-bg col-md-12\">\r\n            <div class=\"subscriptions-page-pricing__main-content--pricing\">\r\n              <h2>PIXERFER PRO</h2>\r\n              <h1><sub>SGD</sub>23 <sup>.00</sup><sub>/ yearly</sub></h1>\r\n              <p>SGD 1.92 / month</p>\r\n            </div>\r\n            <ul>\r\n              <li>\r\n                <strong>Small</strong>\u2028<br>\r\n                10% of price set for large photo<br>\r\n                <strong>Medium</strong><br>\r\n                50% of price set for large photo<br>\r\n                <strong>Large</strong><br>\r\n                SGD 100, 150, 200\r\n              </li>\r\n              <li>50 photo uploads per day</li>\r\n              <li>50%</li>\r\n              <li>60%</li>\r\n              <li>SGD 100</li>\r\n              <li>X</li>\r\n              <li>X</li>\r\n              <li><button type=\"button\" class=\"subscriptions-page-pricing__subscribe-btn\">Sign Up</button></li>\r\n            </ul>\r\n          </div>\r\n        </div>\r\n        <div class=\"col-md-3\">\r\n          <div class=\"subscriptions-page-pricing__main-content--pricing-bg col-md-12\">\r\n            <div class=\"subscriptions-page-pricing__main-content--pricing\">\r\n              <h2>PIXERFER MAESTRO</h2>\r\n              <h1><sub>SGD</sub>63 <sup>.00</sup><sub>/ yearly</sub></h1>\r\n              <p>SGD 5.25 / month</p>\r\n            </div>\r\n            <ul>\r\n              <li>\r\n                <strong>Small</strong>\u2028<br>\r\n                10% of price set for large photo<br>\r\n                <strong>Medium</strong><br>\r\n                50% of price set for large photo<br>\r\n                <strong>Large</strong><br>\r\n                SGD 100, 200, 300, 400, 500\r\n              </li>\r\n              <li>100 photo uploads per day</li>\r\n              <li>50%</li>\r\n              <li>60%</li>\r\n              <li>SGD 100 - 500</li>\r\n              <li>20 photo uploads per week</li>\r\n              <li>Choice of 3 template(s)</li>\r\n              <li><button type=\"button\" class=\"subscriptions-page-pricing__subscribe-btn\">Sign Up</button></li>\r\n            </ul>\r\n          </div>\r\n        </div>\r\n    </div>\r\n    <div class=\"subscriptions-page-pricing__accept-terms col-md-12\">\r\n      <p>By clicking “Sign Up“, I accepted the <a class=\"credit-plans-page-faq__more-content--faq-link\" ui-sref=\"introduction-company.terms\">Terms of Service</a></p>\r\n    </div> --></section><section class=\"row subscriptions-page-couple text--color-black\"><div class=subscriptions-page-couple__infotext>PIXERF is here to help!</div><div class=subscriptions-page-faq__more-content>Check out our <a class=credit-plans-page-faq__more-content--faq-link ui-sref=introduction-support.faq.personal>FAQs</a> or send us an email.</div><button type=button class=\"btn subscriptions-page-pricing__account-type-btn btn-submit\" ui-sref=email-us-page>Ask PIXERF</button></section></div>");
$templateCache.put("app/introduction/pixerfer/subscriptions/subscriptions.html","<div class=\"sub__content--md navbar-collapse-desktop\"><div class=pixerf-subnavigation-bar-wrapper><ul class=pixerf-subnavigation-bar><li ui-sref-active=pixerf-subnavigation-bar__menu-item--active ui-sref=introduction-pixerfer.subscriptions.personal class=pixerf-subnavigation-bar__menu-item>PERSONAL</li><li ui-sref-active=pixerf-subnavigation-bar__menu-item--active ui-sref=introduction-pixerfer.subscriptions.business class=pixerf-subnavigation-bar__menu-item>BUSINESS</li></ul></div><!-- <div class=\"col-md-12 introduction-page__main-content marketplace-wrap\" ui-view></div> --></div><div ui-view></div>");
$templateCache.put("app/introduction/support/faq/faq-business.html","<div class=\"faq-page no-margin\"><section class=\"row faq-page-howitworks__wrapper text-left\"><p class=\"faq-page-howitworks__heading text--extrabold text--color-black\" translate>{{\'faq-title\'}}</p><div class=\"faq-page-howitworks__infro-form clearfix\"><div class=form-group><div id=general class=faq-page-howitworks__infro-form--section-wrapper ng-click=\"vm.onSectionClicked(\'general\')\"><div><h1 class=faq-page-howitworks__infro-form--title ng-class=\"{\'title-disable\' : vm.targetSection !== \'general\'}\">{{\'general\' | translate}} <span class=\"pull-right fa faq-page-howitworks__infro-form--sign\" ng-class=\"vm.targetSection !== \'general\' ? \'fa-plus title-disable\' : \'fa-minus\'\"></span></h1></div><div class=\"collapse cursor-text\" uib-collapse=\"vm.targetSection !== \'general\'\" aria-expanded=false aria-hidden=true ng-click=$event.stopPropagation()><h5 class=text--bold translate>{{\'faq-business-general-section-subtitle-1\'}}</h5><p translate>{{\'faq-business-general-section-subtitle-1-description-1\'}}</p><p translate>{{\'faq-business-general-section-subtitle-1-description-2\'}}</p><p translate>{{\'faq-business-general-section-subtitle-1-description-3\'}}</p><p translate>{{\'faq-business-general-section-subtitle-1-description-4\'}}</p><h5 class=text--bold translate>{{\'faq-business-general-section-subtitle-2\'}}</h5><p translate>{{\'faq-business-general-section-subtitle-2-description-1\'}}</p><p translate>{{\'faq-business-general-section-subtitle-2-description-2\'}}</p><h5 class=text--bold translate>{{\'faq-business-general-section-subtitle-3\'}}</h5><p translate>{{\'faq-business-general-section-subtitle-3-description-1\'}}</p></div></div><div id=account class=faq-page-howitworks__infro-form--section-wrapper ng-click=\"vm.onSectionClicked(\'account\')\"><div><h1 class=faq-page-howitworks__infro-form--title ng-class=\"{\'title-disable\' : vm.targetSection !== \'account\'}\">{{\'account\' | translate}} <span class=\"pull-right fa faq-page-howitworks__infro-form--sign\" ng-class=\"vm.targetSection !== \'account\' ? \'fa-plus title-disable\' : \'fa-minus\'\"></span></h1></div><div class=\"collapse cursor-text\" uib-collapse=\"vm.targetSection !== \'account\'\" aria-expanded=false aria-hidden=true ng-click=$event.stopPropagation()><h5 class=text--bold translate>{{\'faq-business-account-section-subtitle-1\'}}</h5><p translate>{{\'faq-business-account-section-subtitle-1-description-1\'}}</p><ul class=faq-list-dot><li translate>{{\'faq-business-account-section-subtitle-1-description-2\'}}</li><li translate>{{\'faq-business-account-section-subtitle-1-description-3\'}}</li><li translate>{{\'faq-business-account-section-subtitle-1-description-4\'}}</li></ul><p translate>{{\'faq-business-account-section-subtitle-1-description-5\'}}</p><h5 class=text--bold translate>{{\'faq-business-account-section-subtitle-2\'}}</h5><p translate>{{\'faq-business-account-section-subtitle-2-description-1\'}}</p><h5 class=text--bold translate>{{\'faq-business-account-section-subtitle-3\'}}</h5><p translate>{{\'faq-business-account-section-subtitle-3-description-1\'}}</p></div></div><div id=cca class=faq-page-howitworks__infro-form--section-wrapper ng-click=\"vm.onSectionClicked(\'cca\')\"><div><h1 class=faq-page-howitworks__infro-form--title ng-class=\"{\'title-disable\' : vm.targetSection !== \'cca\'}\">{{\'custom-content-assignment\' | translate}} <span class=\"pull-right fa faq-page-howitworks__infro-form--sign\" ng-class=\"vm.targetSection !== \'cca\' ? \'fa-plus title-disable\' : \'fa-minus\'\"></span></h1></div><div class=\"collapse cursor-text\" uib-collapse=\"vm.targetSection !== \'cca\'\" aria-expanded=false aria-hidden=true ng-click=$event.stopPropagation()><h5 class=text--bold translate>{{\'faq-business-cca-section-subtitle-1\'}}</h5><p translate>{{\'faq-business-cca-section-subtitle-1-description-1\'}}</p><h5 class=text--bold translate>{{\'faq-business-cca-section-subtitle-2\'}}</h5><p translate>{{\'faq-business-cca-section-subtitle-2-description-1\'}}</p><ul class=faq-list-number><li compile=\"\'faq-business-cca-section-subtitle-2-description-2\' | translate\"></li><li translate>{{\'faq-business-cca-section-subtitle-2-description-3\'}}</li><li translate>{{\'faq-business-cca-section-subtitle-2-description-4\'}}</li><li translate>{{\'faq-business-cca-section-subtitle-2-description-5\'}}</li></ul></div></div><div id=challenge class=faq-page-howitworks__infro-form--section-wrapper ng-click=\"vm.onSectionClicked(\'challenge\')\"><div><h1 class=faq-page-howitworks__infro-form--title ng-class=\"{\'title-disable\' : vm.targetSection !== \'challenge\'}\">{{\'community-challenge\' | translate}} <span class=\"pull-right fa faq-page-howitworks__infro-form--sign\" ng-class=\"vm.targetSection !== \'challenge\' ? \'fa-plus title-disable\' : \'fa-minus\'\"></span></h1></div><div class=\"collapse cursor-text\" uib-collapse=\"vm.targetSection !== \'challenge\'\" aria-expanded=false aria-hidden=true ng-click=$event.stopPropagation()><h5 class=text--bold translate>{{\'faq-business-challenge-section-subtitle-1\'}}</h5><p translate>{{\'faq-business-challenge-section-subtitle-1-description-1\'}}</p><h5 class=text--bold translate>{{\'faq-business-challenge-section-subtitle-2\'}}</h5><p translate>{{\'faq-business-challenge-section-subtitle-2-description-1\'}}</p><p translate>{{\'faq-business-challenge-section-subtitle-2-description-2\'}}</p><p translate>{{\'faq-business-challenge-section-subtitle-2-description-3\'}}</p><p compile=\"\'faq-business-challenge-section-subtitle-2-description-4\' | translate\"></p><h5 class=text--bold translate>{{\'faq-business-challenge-section-subtitle-3\'}}</h5><p translate>{{\'faq-business-challenge-section-subtitle-3-description-1\'}}</p><ul class=faq-list-number><li compile=\"\'faq-business-challenge-section-subtitle-3-description-2\' | translate\"></li><li translate>{{\'faq-business-challenge-section-subtitle-3-description-3\'}}</li><li translate>{{\'faq-business-challenge-section-subtitle-3-description-4\'}}</li><li translate>{{\'faq-business-challenge-section-subtitle-3-description-5\'}}</li></ul></div></div><div id=marketplace class=faq-page-howitworks__infro-form--section-wrapper ng-click=\"vm.onSectionClicked(\'marketplace\')\"><div><h1 class=faq-page-howitworks__infro-form--title ng-class=\"{\'title-disable\' : vm.targetSection !== \'marketplace\'}\">{{\'visual-marketplace\' | translate}} <span class=\"pull-right fa faq-page-howitworks__infro-form--sign\" ng-class=\"vm.targetSection !== \'marketplace\' ? \'fa-plus title-disable\' : \'fa-minus\'\"></span></h1></div><div class=\"collapse cursor-text\" uib-collapse=\"vm.targetSection !== \'marketplace\'\" aria-expanded=false aria-hidden=true ng-click=$event.stopPropagation()><h5 class=text--bold translate>{{\'faq-business-marketplace-section-subtitle-1\'}}</h5><p translate>{{\'faq-business-marketplace-section-subtitle-1-description-1\'}}</p><h5 class=text--bold translate>{{\'faq-business-marketplace-section-subtitle-2\'}}</h5><p translate>{{\'faq-business-marketplace-section-subtitle-2-description-1\'}}</p><p compile=\"\'faq-business-marketplace-section-subtitle-2-description-2\' | translate\"></p><h5 class=text--bold translate>{{\'faq-business-marketplace-section-subtitle-3\'}}</h5><p translate>{{\'faq-business-marketplace-section-subtitle-3-description-1\'}}</p><h5 class=text--bold translate>{{\'faq-business-marketplace-section-subtitle-4\'}}</h5><p translate>{{\'faq-business-marketplace-section-subtitle-4-description-1\'}}</p><ul class=faq-list-dot><li translate>{{\'faq-business-marketplace-section-subtitle-4-description-2\'}}</li><li translate>{{\'faq-business-marketplace-section-subtitle-4-description-3\'}}</li><li translate>{{\'faq-business-marketplace-section-subtitle-4-description-4\'}}</li><li translate>{{\'faq-business-marketplace-section-subtitle-4-description-5\'}}</li><li translate>{{\'faq-business-marketplace-section-subtitle-4-description-6\'}}</li><li translate>{{\'faq-business-marketplace-section-subtitle-4-description-7\'}}</li><li translate>{{\'faq-business-marketplace-section-subtitle-4-description-8\'}}</li></ul><p translate>{{\'faq-business-marketplace-section-subtitle-4-description-9\'}}</p><ul class=faq-list-dot><li translate>{{\'faq-business-marketplace-section-subtitle-4-description-10\'}}</li><li translate>{{\'faq-business-marketplace-section-subtitle-4-description-11\'}}</li><li translate>{{\'faq-business-marketplace-section-subtitle-4-description-12\'}}</li><li translate>{{\'faq-business-marketplace-section-subtitle-4-description-13\'}}</li><li translate>{{\'faq-business-marketplace-section-subtitle-4-description-14\'}}</li></ul><h5 class=text--bold translate>{{\'faq-business-marketplace-section-subtitle-5\'}}</h5><p translate>{{\'faq-business-marketplace-section-subtitle-5-description-1\'}}</p><h5 class=text--bold translate>{{\'faq-business-marketplace-section-subtitle-6\'}}</h5><p translate>{{\'faq-business-marketplace-section-subtitle-6-description-1\'}}</p><h5 class=text--bold translate>{{\'faq-business-marketplace-section-subtitle-7\'}}</h5><p translate>{{\'faq-business-marketplace-section-subtitle-7-description-1\'}}</p><p translate>{{\'faq-business-marketplace-section-subtitle-7-description-2\'}}</p><p translate>{{\'faq-business-marketplace-section-subtitle-7-description-3\'}}</p><p translate>{{\'faq-business-marketplace-section-subtitle-7-description-4\'}}</p><h5 class=text--bold translate>{{\'faq-business-marketplace-section-subtitle-8\'}}</h5><p translate>{{\'faq-business-marketplace-section-subtitle-8-description-1\'}}</p><h5 class=text--bold translate>{{\'faq-business-marketplace-section-subtitle-9\'}}</h5><p translate>{{\'faq-business-marketplace-section-subtitle-9-description-1\'}}</p><h5 class=text--bold translate>{{\'faq-business-marketplace-section-subtitle-10\'}}</h5><p translate>{{\'faq-business-marketplace-section-subtitle-10-description-1\'}}</p><h5 class=text--bold translate>{{\'faq-business-marketplace-section-subtitle-11\'}}</h5><p translate>{{\'faq-business-marketplace-section-subtitle-11-description-1\'}}</p><h5 class=text--bold translate>{{\'faq-business-marketplace-section-subtitle-12\'}}</h5><p translate>{{\'faq-business-marketplace-section-subtitle-12-description-1\'}}</p><p compile=\"\'faq-business-marketplace-section-subtitle-12-description-2\' | translate\"></p><h5 class=text--bold translate>{{\'faq-business-marketplace-section-subtitle-13\'}}</h5><ul class=faq-list-number><li compile=\"\'faq-business-marketplace-section-subtitle-13-description-1\' | translate\"></li><li translate>{{\'faq-business-marketplace-section-subtitle-13-description-2\'}}</li><li translate>{{\'faq-business-marketplace-section-subtitle-13-description-3\'}}</li></ul><h5 class=text--bold translate>{{\'faq-business-marketplace-section-subtitle-14\'}}</h5><p translate>{{\'faq-business-marketplace-section-subtitle-14-description-1\'}}</p><h5 class=text--bold translate>{{\'faq-business-marketplace-section-subtitle-15\'}}</h5><p translate>{{\'faq-business-marketplace-section-subtitle-15-description-1\'}}</p><h5 class=text--bold translate>{{\'faq-business-marketplace-section-subtitle-16\'}}</h5><p translate>{{\'faq-business-marketplace-section-subtitle-16-description-1\'}}</p></div></div><div id=communityHub class=faq-page-howitworks__infro-form--section-wrapper ng-click=\"vm.onSectionClicked(\'communityHub\')\"><div><h1 class=faq-page-howitworks__infro-form--title ng-class=\"{\'title-disable\' : vm.targetSection !== \'communityHub\'}\">{{\'community-hub\' | translate}} (We will be introducing Community Hub soon!) <span class=\"pull-right fa faq-page-howitworks__infro-form--sign\" ng-class=\"vm.targetSection !== \'communityHub\' ? \'fa-plus title-disable\' : \'fa-minus\'\"></span></h1></div><div class=\"collapse cursor-text\" uib-collapse=\"vm.targetSection !== \'communityHub\'\" aria-expanded=false aria-hidden=true ng-click=$event.stopPropagation()><h5 class=text--bold translate>{{\'faq-business-community-hub-section-subtitle-1\'}}</h5><p translate>{{\'faq-business-community-hub-section-subtitle-1-description-1\'}}</p><h5 class=text--bold translate>{{\'faq-business-community-hub-section-subtitle-2\'}}</h5><p translate>{{\'faq-business-community-hub-section-subtitle-2-description-1\'}}</p><p translate>{{\'faq-business-community-hub-section-subtitle-2-description-2\'}}</p><p translate>{{\'faq-business-community-hub-section-subtitle-2-description-3\'}}</p><p translate>{{\'faq-business-community-hub-section-subtitle-2-description-4\'}}</p><p translate>{{\'faq-business-community-hub-section-subtitle-2-description-5\'}}</p></div></div></div></div></section></div>");
$templateCache.put("app/introduction/support/faq/faq-personal.html","<div class=\"faq-page no-margin\"><section class=\"row faq-page-howitworks__wrapper text-left\"><p class=\"faq-page-howitworks__heading text--extrabold text--color-black\" translate>{{\'faq-title\'}}</p><div class=\"faq-page-howitworks__infro-form clearfix\"><div class=form-group><div id=general class=faq-page-howitworks__infro-form--section-wrapper ng-click=\"vm.onSectionClicked(\'general\')\"><div><h1 class=faq-page-howitworks__infro-form--title ng-class=\"{\'title-disable\' : vm.targetSection !== \'general\' }\">General<span class=\"pull-right fa faq-page-howitworks__infro-form--sign\" ng-class=\"vm.targetSection !== \'general\' ? \'fa-plus title-disable\' : \'fa-minus\'\"></span></h1></div><div class=\"collapse cursor-text\" uib-collapse=\"vm.targetSection !== \'general\'\" aria-expanded=false aria-hidden=true ng-click=$event.stopPropagation()><h5 class=text--bold translate>{{\'faq-general-section-subtitle-1\'}}</h5><p translate>{{\'faq-general-section-subtitle-1-description-1\'}}</p><p translate>{{\'faq-general-section-subtitle-1-description-2\'}}</p><p translate>{{\'faq-general-section-subtitle-1-description-3\'}}</p><p translate>{{\'faq-general-section-subtitle-1-description-4\'}}</p><h5 class=text--bold translate>{{\'faq-general-section-subtitle-2\'}}</h5><p translate>{{\'faq-general-section-subtitle-2-description-1\'}}</p></div></div><div id=account class=faq-page-howitworks__infro-form--section-wrapper ng-click=\"vm.onSectionClicked(\'account\')\"><div><h1 class=faq-page-howitworks__infro-form--title ng-class=\"{\'title-disable\' : vm.targetSection !== \'account\'}\">{{\'account\' | translate}}<span class=\"pull-right fa faq-page-howitworks__infro-form--sign\" ng-class=\"vm.targetSection !== \'account\' ? \'fa-plus title-disable\' : \'fa-minus\'\"></span></h1></div><div class=\"collapse cursor-text\" uib-collapse=\"vm.targetSection !== \'account\'\" aria-expanded=false aria-hidden=true ng-click=$event.stopPropagation()><h5 class=text--bold translate>{{\'faq-account-section-subtitle-1\'}}</h5><p translate>{{\'faq-account-section-subtitle-1-description-1\'}}</p><h5 class=text--bold translate>{{\'faq-account-section-subtitle-2\'}}</h5><p translate>{{\'faq-account-section-subtitle-2-description-1\'}}</p></div></div><div id=marketplace class=faq-page-howitworks__infro-form--section-wrapper ng-click=\"vm.onSectionClicked(\'marketplace\')\"><div><h1 class=faq-page-howitworks__infro-form--title ng-class=\"{\'title-disable\' : vm.targetSection !== \'marketplace\'}\">{{\'visual-marketplace\' | translate}}<span class=\"pull-right fa faq-page-howitworks__infro-form--sign\" ng-class=\"vm.targetSection !== \'marketplace\' ? \'fa-plus title-disable\' : \'fa-minus\'\"></span></h1></div><div class=\"collapse cursor-text\" uib-collapse=\"vm.targetSection !== \'marketplace\'\" aria-expanded=false aria-hidden=true ng-click=$event.stopPropagation()><h5 class=text--bold translate>{{\'faq-marketplace-section-subtitle-1\'}}</h5><p translate>{{\'faq-marketplace-section-subtitle-1-description-1\'}}</p><p translate>{{\'faq-marketplace-section-subtitle-1-description-2\'}}</p><h5 class=text--bold translate>{{\'faq-marketplace-section-subtitle-2\'}}</h5><p translate>{{\'faq-marketplace-section-subtitle-2-description-1\'}}</p><p translate>{{\'faq-marketplace-section-subtitle-2-description-2\'}}</p><h5 class=text--bold translate>{{\'faq-marketplace-section-subtitle-3\'}}</h5><p translate>{{\'faq-marketplace-section-subtitle-3-description-1\'}}</p><h5 class=text--bold translate>{{\'faq-marketplace-section-subtitle-4\'}}</h5><p translate>{{\'faq-marketplace-section-subtitle-4-description-1\'}}</p><h5 class=text--bold translate>{{\'faq-marketplace-section-subtitle-5\'}}</h5><p translate>{{\'faq-marketplace-section-subtitle-5-description-1\'}}</p><h5 class=text--bold translate>{{\'faq-marketplace-section-subtitle-6\'}}</h5><ul class=faq-list-number><li translate>{{\'faq-marketplace-section-subtitle-6-description-1\'}}</li><li translate>{{\'faq-marketplace-section-subtitle-6-description-2\'}}</li><li translate>{{\'faq-marketplace-section-subtitle-6-description-3\'}}</li><li translate>{{\'faq-marketplace-section-subtitle-6-description-4\'}}</li></ul><p compile=\"\'faq-marketplace-section-subtitle-6-description-5\' | translate\"></p><h5 class=text--bold translate>{{\'faq-marketplace-section-subtitle-7\'}}</h5><p translate>{{\'faq-marketplace-section-subtitle-7-description-1\'}}</p><ul class=faq-list-number><li translate>{{\'faq-marketplace-section-subtitle-7-description-2\'}}</li><li translate>{{\'faq-marketplace-section-subtitle-7-description-3\'}}</li><li translate>{{\'faq-marketplace-section-subtitle-7-description-4\'}}</li><li translate>{{\'faq-marketplace-section-subtitle-7-description-5\'}}</li><li translate>{{\'faq-marketplace-section-subtitle-7-description-6\'}}</li><li translate>{{\'faq-marketplace-section-subtitle-7-description-7\'}}</li></ul><p translate>{{\'faq-marketplace-section-subtitle-7-description-8\'}}</p><h5 class=text--bold translate>{{\'faq-marketplace-section-subtitle-8\'}}</h5><p translate>{{\'faq-marketplace-section-subtitle-8-description-1\'}}</p><p translate>{{\'faq-marketplace-section-subtitle-8-description-2\'}}</p><h5 class=text--bold translate>{{\'faq-marketplace-section-subtitle-9\'}}</h5><p translate>{{\'faq-marketplace-section-subtitle-9-description-1\'}}</p><p compile=\"\'faq-marketplace-section-subtitle-9-description-2\' | translate\"></p><p compile=\"\'faq-marketplace-section-subtitle-9-description-3\' | translate\"></p><h5 class=text--bold translate>{{\'faq-marketplace-section-subtitle-10\'}}</h5><p translate>{{\'faq-marketplace-section-subtitle-10-description-1\'}}</p><h5 id=editorialCommercialLicenses class=text--bold translate>{{\'faq-marketplace-section-subtitle-11\'}}</h5><p translate>{{\'faq-marketplace-section-subtitle-11-description-1\'}}</p><ul class=faq-list-dot><li translate>{{\'faq-marketplace-section-subtitle-11-description-2\'}}</li><li translate>{{\'faq-marketplace-section-subtitle-11-description-3\'}}</li><li translate>{{\'faq-marketplace-section-subtitle-11-description-4\'}}</li><li translate>{{\'faq-marketplace-section-subtitle-11-description-5\'}}</li><li translate>{{\'faq-marketplace-section-subtitle-11-description-6\'}}</li><li translate>{{\'faq-marketplace-section-subtitle-11-description-7\'}}</li><li translate>{{\'faq-marketplace-section-subtitle-11-description-8\'}}</li></ul><p translate>{{\'faq-marketplace-section-subtitle-11-description-9\'}}</p><ul class=faq-list-dot><li translate>{{\'faq-marketplace-section-subtitle-11-description-10\'}}</li><li translate>{{\'faq-marketplace-section-subtitle-11-description-11\'}}</li><li translate>{{\'faq-marketplace-section-subtitle-11-description-12\'}}</li><li translate>{{\'faq-marketplace-section-subtitle-11-description-13\'}}</li><li translate>{{\'faq-marketplace-section-subtitle-11-description-14\'}}</li></ul><h5 class=text--bold translate>{{\'faq-marketplace-section-subtitle-12\'}}</h5><p translate>{{\'faq-marketplace-section-subtitle-12-description-1\'}}</p><p translate>{{\'faq-marketplace-section-subtitle-12-description-2\'}}</p><p translate>{{\'faq-marketplace-section-subtitle-12-description-3\'}}</p><ul class=faq-list-dot><li translate>{{\'faq-marketplace-section-subtitle-12-description-4\'}}</li><li translate>{{\'faq-marketplace-section-subtitle-12-description-5\'}}</li><li translate>{{\'faq-marketplace-section-subtitle-12-description-6\'}}</li><li translate>{{\'faq-marketplace-section-subtitle-12-description-7\'}}</li><li translate>{{\'faq-marketplace-section-subtitle-12-description-8\'}}</li></ul><p translate>{{\'faq-marketplace-section-subtitle-12-description-9\'}}</p><h5 class=text--bold translate>{{\'faq-marketplace-section-subtitle-13\'}}</h5><p translate>{{\'faq-marketplace-section-subtitle-13-description-1\'}}</p><p translate>{{\'faq-marketplace-section-subtitle-13-description-2\'}}</p><p compile=\"\'faq-marketplace-section-subtitle-13-description-3\' | translate\"></p><h5 class=text--bold translate>{{\'faq-marketplace-section-subtitle-14\'}}</h5><p compile=\"\'faq-marketplace-section-subtitle-14-description-1\' | translate\"></p></div></div><div id=community-challenge class=faq-page-howitworks__infro-form--section-wrapper ng-click=\"vm.onSectionClicked(\'community-challenge\')\"><div><h1 class=faq-page-howitworks__infro-form--title ng-class=\"{\'title-disable\' : vm.targetSection !== \'community-challenge\'}\">{{\'community-challenge\' | translate}}<span class=\"pull-right fa faq-page-howitworks__infro-form--sign\" ng-class=\"vm.targetSection !== \'community-challenge\' ? \'fa-plus title-disable\' : \'fa-minus\'\"></span></h1></div><div class=\"collapse cursor-text margin-top-15\" uib-collapse=\"vm.targetSection !== \'community-challenge\'\" aria-expanded=false aria-hidden=true ng-click=$event.stopPropagation()><h5 class=text--bold translate>{{\'faq-community-challenge-section-subtitle-1\'}}</h5><p translate>{{\'faq-community-challenge-section-subtitle-1-description-1\'}}</p><h5 class=text--bold translate>{{\'faq-community-challenge-section-subtitle-2\'}}</h5><p translate>{{\'faq-community-challenge-section-subtitle-2-description-1\'}}</p><h5 class=text--bold translate>{{\'faq-community-challenge-section-subtitle-3\'}}</h5><p translate>{{\'faq-community-challenge-section-subtitle-3-description-1\'}}</p><h5 class=text--bold translate>{{\'faq-community-challenge-section-subtitle-4\'}}</h5><p translate>{{\'faq-community-challenge-section-subtitle-4-description-1\'}}</p><h5 class=text--bold translate>{{\'faq-community-challenge-section-subtitle-5\'}}</h5><p translate>{{\'faq-community-challenge-section-subtitle-5-description-1\'}}</p><h5 class=text--bold translate>{{\'faq-community-challenge-section-subtitle-6\'}}</h5><p translate>{{\'faq-community-challenge-section-subtitle-6-description-1\'}}</p><h5 class=text--bold translate>{{\'faq-community-challenge-section-subtitle-7\'}}</h5><p translate>{{\'faq-community-challenge-section-subtitle-7-description-1\'}}</p><h5 class=text--bold translate>{{\'faq-community-challenge-section-subtitle-8\'}}</h5><p translate>{{\'faq-community-challenge-section-subtitle-8-description-1\'}}</p><h5 class=text--bold translate>{{\'faq-community-challenge-section-subtitle-9\'}}</h5><p translate>{{\'faq-community-challenge-section-subtitle-9-description-1\'}}</p><h5 class=text--bold translate>{{\'faq-community-challenge-section-subtitle-10\'}}</h5><p compile=\"\'faq-community-challenge-section-subtitle-10-description-1\' | translate\"></p></div></div><div id=cca class=faq-page-howitworks__infro-form--section-wrapper ng-click=\"vm.onSectionClicked(\'cca\')\"><div><h1 class=faq-page-howitworks__infro-form--title ng-class=\"{\'title-disable\' : vm.targetSection !== \'cca\'}\">{{\'custom-content-assignment\' | translate}}<span class=\"pull-right fa faq-page-howitworks__infro-form--sign\" ng-class=\"vm.targetSection !== \'cca\' ? \'fa-plus title-disable\' : \'fa-minus\'\"></span></h1></div><div class=\"collapse cursor-text margin-top-15\" uib-collapse=\"vm.targetSection !== \'cca\'\" aria-expanded=false aria-hidden=true ng-click=$event.stopPropagation()><h5 class=text--bold translate>{{\'faq-cca-section-subtitle-1\'}}</h5><p translate>{{\'faq-cca-section-subtitle-1-description-1\'}}</p><h5 class=text--bold translate>{{\'faq-cca-section-subtitle-2\'}}</h5><p translate>{{\'faq-cca-section-subtitle-2-description-1\'}}</p><h5 class=text--bold translate>{{\'faq-cca-section-subtitle-3\'}}</h5><p translate>{{\'faq-cca-section-subtitle-3-description-1\'}}</p><h5 class=text--bold translate>{{\'faq-cca-section-subtitle-4\'}}</h5><ul class=faq-list-number><li translate>{{\'faq-cca-section-subtitle-4-description-1\'}}</li><li translate>{{\'faq-cca-section-subtitle-4-description-2\'}}</li><li translate>{{\'faq-cca-section-subtitle-4-description-3\'}}</li></ul><h5 class=text--bold translate>{{\'faq-cca-section-subtitle-5\'}}</h5><p translate>{{\'faq-cca-section-subtitle-5-description-1\'}}</p><p translate>{{\'faq-cca-section-subtitle-5-description-2\'}}</p><h5 class=text--bold translate>{{\'faq-cca-section-subtitle-6\'}}</h5><ul class=faq-list-number><li translate>{{\'faq-cca-section-subtitle-6-description-1\'}}</li><li compile=\"\'faq-cca-section-subtitle-6-description-2\' | translate\"></li><li compile=\"\'faq-cca-section-subtitle-6-description-3\' | translate\"></li><li translate>{{\'faq-cca-section-subtitle-6-description-4\'}}</li><li translate>{{\'faq-cca-section-subtitle-6-description-5\'}}</li><li translate>{{\'faq-cca-section-subtitle-6-description-6\'}}</li><li translate>{{\'faq-cca-section-subtitle-6-description-7\'}}</li></ul></div></div><div id=payout class=faq-page-howitworks__infro-form--section-wrapper ng-click=\"vm.onSectionClicked(\'payout\')\"><div><h1 class=faq-page-howitworks__infro-form--title ng-class=\"{\'title-disable\' : vm.targetSection !== \'payout\'}\">{{\'payouts\' | translate}}<span class=\"pull-right fa faq-page-howitworks__infro-form--sign\" ng-class=\"vm.targetSection !== \'payout\' ? \'fa-plus title-disable\' : \'fa-minus\'\"></span></h1></div><div class=\"collapse cursor-text margin-top-15\" uib-collapse=\"vm.targetSection !== \'payout\'\" aria-expanded=false aria-hidden=true ng-click=$event.stopPropagation()><h5 class=text--bold translate>{{\'faq-payout-section-subtitle-1\'}}</h5><p translate>{{\'faq-payout-section-subtitle-1-description-1\'}}</p><p class=\"text--bold no-margin\" translate>{{\'faq-payout-section-subtitle-1-description-2\'}}</p><p translate>{{\'faq-payout-section-subtitle-1-description-3\'}}</p><p class=\"text--bold no-margin\" translate>{{\'faq-payout-section-subtitle-1-description-4\'}}</p><p compile=\"\'faq-payout-section-subtitle-1-description-5\' | translate\">></p><p translate>{{\'faq-payout-section-subtitle-1-description-6\'}}</p><p class=\"text--bold no-margin\" translate>{{\'faq-payout-section-subtitle-1-description-7\'}}</p><p compile=\"\'faq-payout-section-subtitle-1-description-8\' | translate\">></p><table class=table><tbody><tr><th class=text--bold>Payment Mode</th><th class=text--bold>Fees</th></tr><tr><td>PayPal</td><td>PayPal transaction fees will apply</td></tr><tr><td>Wire Transfer</td><td>Transfer fees in respective countries will apply</td></tr><tr><td>Cheque</td><td>An admin fee of SGD2.00 will apply for each cheque. Option only available in Singapore</td></tr></tbody></table></div></div><div id=community class=faq-page-howitworks__infro-form--section-wrapper ng-click=\"vm.onSectionClicked(\'community\')\"><div><h1 class=faq-page-howitworks__infro-form--title ng-class=\"{\'title-disable\' : vm.targetSection !== \'community\'}\">{{\'community-hub\' | translate}} (We will be introducing Community Hub soon!)<span class=\"pull-right fa faq-page-howitworks__infro-form--sign\" ng-class=\"vm.targetSection !== \'community\' ? \'fa-plus title-disable\' : \'fa-minus\'\"></span></h1></div><div class=\"collapse cursor-text margin-top-15\" uib-collapse=\"vm.targetSection !== \'community\'\" aria-expanded=false aria-hidden=true ng-click=$event.stopPropagation()><h5 class=text--bold translate>{{\'faq-community-section-subtitle-1\'}}</h5><p translate>{{\'faq-community-section-subtitle-1-description-1\'}}</p><p translate>{{\'faq-community-section-subtitle-1-description-2\'}}</p><h5 class=text--bold translate>{{\'faq-community-section-subtitle-2\'}}</h5><p compile=\"\'faq-community-section-subtitle-2-description-1\' | translate\"></p><h5 class=text--bold translate>{{\'faq-community-section-subtitle-3\'}}</h5><p translate>{{\'faq-community-section-subtitle-3-description-1\'}}</p><h5 class=text--bold translate>{{\'faq-community-section-subtitle-4\'}}</h5><p translate>{{\'faq-community-section-subtitle-4-description-1\'}}</p><ul class=faq-list-number><li translate>{{\'faq-community-section-subtitle-4-description-2\'}}</li><li translate>{{\'faq-community-section-subtitle-4-description-3\'}}</li><li translate>{{\'faq-community-section-subtitle-4-description-4\'}}</li></ul><h5 class=text--bold translate>{{\'faq-community-section-subtitle-5\'}}</h5><p translate>{{\'faq-community-section-subtitle-5-description-1\'}}</p><p translate>{{\'faq-community-section-subtitle-5-description-2\'}}</p></div></div><div id=tips-guides class=faq-page-howitworks__infro-form--section-wrapper ng-click=\"vm.onSectionClicked(\'tips-guides\')\"><div><h1 class=faq-page-howitworks__infro-form--title ng-class=\"{\'title-disable\' : vm.targetSection !== \'tips-guides\'}\">{{\'tips-&-guides\' | translate}}<span class=\"pull-right fa faq-page-howitworks__infro-form--sign\" ng-class=\"vm.targetSection !== \'tips-guides\' ? \'fa-plus title-disable\' : \'fa-minus\'\"></span></h1></div><div class=\"collapse cursor-text margin-top-15\" uib-collapse=\"vm.targetSection !== \'tips-guides\'\" aria-expanded=false aria-hidden=true ng-click=$event.stopPropagation()><h5 class=text--bold translate>{{\'faq-tips-guides-section-subtitle-1\'}}</h5><p translate>{{\'faq-tips-guides-section-subtitle-1-description-1\'}}</p><p translate>{{\'faq-tips-guides-section-subtitle-1-description-2\'}}</p><p translate>{{\'faq-tips-guides-section-subtitle-1-description-3\'}}</p><h5 class=text--bold translate>{{\'faq-tips-guides-section-subtitle-2\'}}</h5><ul class=faq-list-number><li translate>{{\'faq-tips-guides-section-subtitle-2-description-1\'}}</li><li compile=\"\'faq-tips-guides-section-subtitle-2-description-2\' | translate\"></li><li compile=\"\'faq-tips-guides-section-subtitle-2-description-3\' | translate\"></li><li compile=\"\'faq-tips-guides-section-subtitle-2-description-4\' | translate\"></li></ul><h5 class=text--bold translate>{{\'faq-tips-guides-section-subtitle-3\'}}</h5><p translate>{{\'faq-tips-guides-section-subtitle-3-description-1\'}}</p><ul class=faq-list-number><li translate>{{\'faq-tips-guides-section-subtitle-3-description-2\'}}</li><li translate>{{\'faq-tips-guides-section-subtitle-3-description-3\'}}</li></ul><h5 class=text--bold translate>{{\'faq-tips-guides-section-subtitle-4\'}}</h5><p translate>{{\'faq-tips-guides-section-subtitle-4-description-1\'}}</p></div></div></div></div></section></div>");
$templateCache.put("app/introduction/support/faq/faq.html","<div class=faq-page__navigation-bar-wrapper scroll-to-fixed=vm.searchFilterBarSettings><section class=\"faq-page__header clearfix\"><button type=button class=\"navbar-toggle collapsed mission-page__sub-navigate__button\" data-toggle=collapse data-target=#leaderboard-navbar-collapse aria-expanded=false><div class=\"pull-left text--bold mission-page__sub-navigate__label\">{{vm.contextPage}}</div><div class=\"pull-right arrow-animation-menu-collapse mission-page__sub-navigate__icon\"><span class=\"icon-bar dash-one\"></span> <span class=\"icon-bar dash-two\"></span></div></button><div class=\"faq-page__header__navigation collapse navbar-collapse clearfix\" id=leaderboard-navbar-collapse navbar-collapse-on-click=true><div class=\"faq-page__header__navigation__item leaderboard\" ui-sref-active=actived ui-sref=introduction-support.faq.personal>{{\'creator\' | translate}}</div><div class=\"faq-page__header__navigation__item featured-photographer\" ui-sref-active=actived ui-sref=introduction-support.faq.business>{{\'business\' | translate}}</div></div></section></div><div ui-view></div>");
$templateCache.put("app/introduction/support/releases/releases.html","<div class=\"releases-page no-margin\"><section class=\"row releases-page__branding-wrapper\"><div class=releases-page__branding><div class=\"releases-page__branding-heading clearfix\"><div class=\"releases-page__branding--intro text--extrabold\" translate>{{\'realeases-page-title-1\'}}</div><div class=\"releases-page__branding--sub-intro text--extrabold\" translate>{{\'realeases-page-title-2\'}}</div></div><div class=\"releases-page__branding__button-wrapper clearfix\"><a href=assets/files/model_release.pdf class=\"releases-page__branding__button btn btn--white-transparent btn-download-model\" target=_blank title=\"Download Model Release form\">{{\'model-release\' | translate}}</a> <a href=assets/files/property_release.pdf class=\"releases-page__branding__button btn btn--white-transparent btn-download-property\" target=_blank title=\"Download Property Release form\">{{\'property-release\' | translate}}</a></div><photo-info-link photo=vm.brandingPhoto></photo-info-link></div></section><section class=\"row releases-page__content\"><div class=\"what-releases clearfix\"><div class=releases-page__content__title translate>{{\'releases-page-subtitle-1\'}}</div><div translate>{{\'releases-page-subtitle-1-description-1\'}}</div><div class=\"releases-page__content__block-wrapper clearfix\"><div class=\"releases-page__content__block__spacing col-sm-6 no-padding\"><div class=releases-page__content__block><div class=\"what-releases__block-title text--highlight\" translate>{{\'model\'}}</div><div translate translate-values=\"{number: 18}\">{{\'releases-page-subtitle-1-model-block-description\'}}</div></div></div><div class=\"releases-page__content__block__spacing col-sm-6 no-padding\"><div class=releases-page__content__block><div class=\"what-releases__block-title text--highlight\" translate>{{\'property\'}}</div><div translate>{{\'releases-page-subtitle-1-property-block-description\'}}</div></div></div></div><div translate>{{\'releases-page-subtitle-1-description-2\'}}</div></div><div class=\"why-releases clearfix\"><div class=releases-page__content__title translate>{{\'releases-page-subtitle-2\'}}</div><div class=\"releases-page__content__block-wrapper clearfix\"><div class=\"releases-page__content__block col-sm-5 text--highlight\" translate>{{\'releases-page-subtitle-2-description-1\'}}</div><div class=\"why-releases__block__right col-sm-7\"><div translate>{{\'releases-page-subtitle-2-description-2\'}}</div><div translate>{{\'releases-page-subtitle-2-description-3\'}}</div><a href=assets/files/model_property_releases.zip class=\"btn btn-submit\">{{\'download\' | translate}}</a></div></div></div><div class=\"how-releases clearfix\"><div class=releases-page__content__title translate>{{\'releases-page-subtitle-3\'}}</div><div class=\"releases-page__content__block-wrapper clearfix\"><div class=\"releases-page__content__block__spacing col-sm-6 no-padding\"><div class=releases-page__content__block><div class=\"how-releases__block-title text--highlight\" translate>{{\'releases-page-subtitle-3-block-1-title\'}}</div><div class=how-releases__block-paragraph translate>{{\'releases-page-subtitle-3-block-1-description-1\'}}</div></div></div><div class=\"releases-page__content__block__spacing col-sm-6 no-padding\"><div class=releases-page__content__block><div class=\"how-releases__block-title text--highlight\" translate>{{\'releases-page-subtitle-3-block-2-title\'}}</div><div class=how-releases__block-paragraph translate>{{\'releases-page-subtitle-3-block-2-description-1\'}}</div><div class=how-releases__block-paragraph translate>{{\'releases-page-subtitle-3-block-2-description-2\'}}</div></div></div></div><div class=\"releases-page__note text--highlight col-sm-7 no-padding\" translate>{{\'releases-page-subtitle-3-description-1\'}}</div></div><div class=\"model-release clearfix\"><div class=releases-page__content__title translate>{{\'model-release\'}}</div><div class=model-release__title translate>{{\'posed-shots\'}}</div><div class=\"model-release__col clearfix\"><div class=\"model-release__item model-release__col--left\"><div class=model-release__image><img src=assets/images/release-page/required-iden.jpg alt=\"\"></div><div class=model-release__col__title translate>{{\'required\'}}</div><div class=model-release__col__description translate>{{\'releases-page-posed-shots-required\'}}</div></div><div class=\"model-release__item model-release__col--right\"><div class=model-release__image><img src=assets/images/release-page/not-required-iden.jpg alt=\"\"></div><div class=model-release__col__title translate>{{\'not-required\'}}</div><div class=model-release__col__description translate>{{\'releases-page-posed-shots-not-required\'}}</div></div></div><div class=model-release__title>Silhouette</div><div class=\"model-release__col clearfix\"><div class=\"model-release__item model-release__col--left\"><div class=model-release__image><img src=assets/images/release-page/required-silhouettes.jpg alt=\"\"></div><div class=model-release__col__title translate>{{\'required\'}}</div><div class=model-release__col__description translate>{{\'releases-page-silhouette-required\'}}</div></div><div class=\"model-release__item model-release__col--right\"><div class=model-release__image><img src=assets/images/release-page/not-required-silhouettes.jpg alt=\"\"></div><div class=model-release__col__title translate>{{\'not-required\'}}</div><div class=model-release__col__description translate>{{\'releases-page-silhouette-not-required\'}}</div></div></div><div class=model-release__title translate>{{\'back-view\'}}</div><div class=\"model-release__col clearfix\"><div class=\"model-release__item model-release__col--left\"><div class=model-release__image><img src=assets/images/release-page/required-back-view.jpg alt=\"\"></div><div class=model-release__col__title translate>{{\'required\'}}</div><div class=model-release__col__description translate>{{\'releases-page-back-view-required\'}}</div></div><div class=\"model-release__item model-release__col--right\"><div class=model-release__image><img src=assets/images/release-page/not-required-back-view.jpg alt=\"\"></div><div class=model-release__col__title translate>{{\'not-required\'}}</div><div class=model-release__col__description translate>{{\'releases-page-back-view-not-required\'}}</div></div></div><div class=model-release__title translate>{{\'body-parts-and-tattoos\'}}</div><div class=\"model-release__col clearfix\"><div class=\"model-release__item model-release__col--left\"><div class=model-release__image><img src=assets/images/release-page/required-parts-tattoos.jpg alt=\"\"></div><div class=model-release__col__title translate>{{\'required\'}}</div><div class=model-release__col__description translate>{{\'releases-page-body-parts-required\'}}</div></div><div class=\"model-release__item model-release__col--right\"><div class=model-release__image><img src=assets/images/release-page/not-required-parts-tattoos.jpg alt=\"\"></div><div class=model-release__col__title translate>{{\'not-required\'}}</div><div class=model-release__col__description translate>{{\'releases-page-body-parts-not-required\'}}</div></div></div><div class=releases-page__content__title translate>{{\'property-release\'}}</div><div class=model-release__title translate>{{\'interior-and-exterior\'}}</div><div class=\"model-release__col clearfix\"><div class=\"model-release__item model-release__col--left\"><div class=model-release__image><img src=assets/images/release-page/required-interior-exterior.jpg alt=\"\"></div><div class=model-release__col__title translate>{{\'required\'}}</div><div class=model-release__col__description translate>{{\'releases-page-interior-and-exterior-required\'}}</div></div><div class=\"model-release__item model-release__col--right\"><div class=model-release__image><img src=assets/images/release-page/not-required-iden.jpg alt=\"\"></div><div class=model-release__col__title translate>{{\'not-required\'}}</div><div class=model-release__col__description translate>{{\'releases-page-interior-and-exterior-not-required\'}}</div></div></div><div class=model-release__title translate>{{\'design-and-structure\'}}</div><div class=\"model-release__col clearfix\"><div class=\"model-release__item model-release__col--left\"><div class=model-release__image><img src=assets/images/release-page/required-design-structure.jpg alt=\"\"></div><div class=model-release__col__title translate>{{\'required\'}}</div><div class=model-release__col__description translate>{{\'releases-page-design-and-structure-required\'}}</div></div><div class=\"model-release__item model-release__col--right\"><div class=model-release__image><img src=assets/images/release-page/not-required-design-structure.jpg alt=\"\"></div><div class=model-release__col__title translate>{{\'not-required\'}}</div><div class=model-release__col__description translate>{{\'releases-page-design-and-structure-not-required\'}}</div></div></div></div><div class=\"remember clearfix\"><div class=releases-page__content__title translate>{{\'releases-page-remember\'}}</div><div class=\"releases-page__content__block-wrapper clearfix\"><div class=\"releases-page__content__block__spacing col-sm-6 no-padding\"><div class=releases-page__content__block><div class=\"how-releases__block-title text--highlight\" translate>{{\'releases-page-remember-exceptions-young-title\'}}</div><div class=how-releases__block-paragraph translate>{{\'releases-page-remember-exceptions-young-title-description-\'}}</div><div class=how-releases__block-paragraph translate>{{\'releases-page-remember-exceptions-young-title-description-2\'}}</div></div></div><div class=\"releases-page__content__block__spacing col-sm-6 no-padding\"><div class=releases-page__content__block><div class=\"how-releases__block-title text--highlight\" translate>{{\'releases-page-remember-exceptions-ticket-title\'}}</div><div class=how-releases__block-paragraph translate>{{\'releases-page-remember-exceptions-ticket-title-description-1\'}}</div><div class=how-releases__block-paragraph translate>{{\'releases-page-remember-exceptions-ticket-title-description-2\'}}</div></div></div></div><div class=remember__ticketed><div class=remember__ticketed__title translate>{{\'releases-page-ticketed-events-title\'}}</div><div class=\"releases-page__content__block-wrapper clearfix\"><div class=\"releases-page__content__block__spacing col-sm-6 no-padding\"><ul class=releases-page__content__block><li><div translate>{{\'releases-page-ticketed-events-description-1\'}}</div></li><li><div translate>{{\'releases-page-ticketed-events-description-2\'}}</div></li><li><div translate>{{\'releases-page-ticketed-events-description-3\'}}</div></li></ul></div><div class=\"releases-page__content__block__spacing col-sm-6 no-padding\"><ul class=releases-page__content__block><li><div translate>{{\'releases-page-ticketed-events-description-4\'}}</div></li><li><div translate>{{\'releases-page-ticketed-events-description-5\'}}</div></li></ul></div></div></div></div></section></div>");
$templateCache.put("app/manage-detail-community-page/components/manage-detail-community-blocked-members/manage-detail-community-blocked-members.html","<section class=manage-detail-community-blocked-members><div class=manage-detail-community-blocked-members__page-title ng-if=vm.isEmptyList><div class=manage-detail-community-blocked-members__description translate translate-values=\"{number: vm.memberGrid.totalCount}\">{{\'you-have-blocked-members\'}}</div><div class=manage-detail-community-blocked-members__hint>These members will not be able to find, see or join your community</div></div><community-member-list community=vm.community on-init=vm.onMemberGridInit(instance) context=COMMUNITY_BLOCKED_MEMBER show-detail=true><div class=text-center><div class=\"no-record-title text--semibold text--color-black\">There are no blocked member requests.</div></div></community-member-list></section>");
$templateCache.put("app/manage-detail-community-page/components/manage-detail-community-brief/manage-detail-community-brief.html","<section class=manage-detail-community-brief><create-community-form community=vm.community mode=\"\'EDIT\'\" options=vm.createCommunityFormOptions form=vm.createCommunityForm dropzone-instance=vm.dropzoneInstance uploading=vm.isPhotoUploading></create-community-form><div class=\"manage-detail-community-brief__btns clearfix\"><div class=\"manage-detail-community-brief__btns__wrapper clearfix\"><button type=submit class=\"btn btn-cancel pixerf-btn-md community-detail-button-left\" ng-click=vm.cancelBtnClicked()>{{\'cancel\' | translate}}</button> <button type=submit class=\"btn btn-submit pixerf-btn-md community-detail-button-left\" ng-click=vm.saveBtnClicked(vm.community) loading-spinner ng-class=\"{\'is-working\': vm.isPhotoUploading}\" ng-disabled=vm.isPhotoUploading>{{\'save-changes\' | translate}}</button> <button class=\"btn btn--black-magento community-detail-button-right\" ng-click=vm.deleteBtnClicked(vm.community)>{{\'delete\' | translate: {something: (\'community\' | translate)}}}</button></div></div></section>");
$templateCache.put("app/manage-detail-community-page/components/manage-detail-community-current-members/manage-detail-community-current-members.html","<div class=manage-detail-community-current-members><div class=manage-detail-community-current-members__page-title><div ng-if=vm.memberGrid.peoples.length class=manage-detail-community-current-members__description translate translate-values=\"{number: vm.memberGrid.peoples.length}\">{{vm.memberGrid.peoples.length == 1 ? \'you-have-member\' : \'you-have-members\'}}</div></div><community-detail is-manager=\"vm.parent.community.isMine || vm.parent.community.isManager\" community=vm.parent.community options=vm.communityDetailOptions></community-detail></div>");
$templateCache.put("app/manage-detail-community-page/components/manage-detail-community-discussions/manage-detail-community-discussions.html","<section class=manage-detail-community-discussions><ul class=manage-detail-community-discussions__navigation><button type=button class=\"setting-top-navigation__collapse-button navbar-toggle collapsed\" data-toggle=collapse data-target=#community-detail-manage-member aria-expanded=false><div class=setting-top-navigation__context translate>{{vm.subContextPage}}</div><div class=\"setting-top-navigation__mobile-button arrow-animation-menu-collapse\"><span class=\"icon-bar dash-one\"></span> <span class=\"icon-bar dash-two\"></span></div></button><div class=\"manage-detail-community-discussions__navigation__list collapse navbar-collapse\" navbar-collapse-on-click=true id=community-detail-manage-member><li class=manage-detail-community-discussions__navigation__item ui-sref-active=actived ui-sref={{vm.commonConst.STATE.MANAGE_COMMUNITIES_PENDING_DISCUSSIONS}}>{{\'pending\' | translate}}</li></div></ul><div class=manage-detail-community-discussions__main-content ui-view></div></section>");
$templateCache.put("app/manage-detail-community-page/components/manage-detail-community-invited-members/manage-detail-community-invited-members.html","<section class=manage-detail-community-invited-members><div class=manage-detail-community-invited-members__page-title ng-if=vm.isEmptyList><div class=manage-detail-community-invited-members__description translate translate-values=\"{number: vm.totalCount}\">{{vm.totalCount == 1 ? \'you-have-pending-invitation\' : \'you-have-pending-invitations\'}}</div><div class=manage-detail-community-invited-members__search><input ng-model=vm.searchString ng-change=vm.onSearchStringChanged() class=\"form-control search-input\" type=text placeholder=\"{{\'search-invited\' | translate}}\"></div></div><community-member-list community=vm.community on-init=vm.onMemberGridInit(instance) context=COMMUNITY_INVITED_MEMBER><div class=text-center><div class=\"no-record-title text--semibold text--color-black\">You have not invited anyone</div><div class=\"no-record-title text--semibold text--color-black\">to join this community yet.</div><div class=no-record-description>All invited members will be listed here.</div></div></community-member-list></section>");
$templateCache.put("app/manage-detail-community-page/components/manage-detail-community-members/manage-detail-community-members.html","<section class=manage-detail-community-members><ul class=\"manage-detail-community-members__navigation clearfix\"><button type=button class=\"setting-top-navigation__collapse-button navbar-toggle collapsed\" data-toggle=collapse data-target=#community-detail-manage-member aria-expanded=false><div class=setting-top-navigation__context translate>{{vm.subContextPage}}</div><div class=\"setting-top-navigation__mobile-button arrow-animation-menu-collapse\"><span class=\"icon-bar dash-one\"></span> <span class=\"icon-bar dash-two\"></span></div></button><div class=\"manage-detail-community-members__navigation__list collapse navbar-collapse\" navbar-collapse-on-click=true id=community-detail-manage-member><li class=manage-detail-community-members__navigation__item ui-sref-active=actived ui-sref={{vm.commonConst.STATE.MANAGE_COMMUNITIES_INVITED_MEMBERS}}>{{\'invited\' | translate}} ({{vm.community.invited_count || 0}})</li><li class=manage-detail-community-members__navigation__item ui-sref-active=actived ui-sref={{vm.commonConst.STATE.MANAGE_COMMUNITIES_REQUESTED_MEMBERS}}>{{\'requested\' | translate}} ({{vm.community.requested_count || 0}})</li><li class=manage-detail-community-members__navigation__item ui-sref-active=actived ui-sref={{vm.commonConst.STATE.MANAGE_COMMUNITIES_CURRENT_MEMBERS}}>{{\'current\' | translate}} ({{vm.community.member_count || 0}})</li><li class=manage-detail-community-members__navigation__item ui-sref-active=actived ui-sref={{vm.commonConst.STATE.MANAGE_COMMUNITIES_BLOCKED_MEMBERS}}>{{\'blocked\' | translate}} ({{vm.community.blocked_count || 0}})</li></div></ul><div class=\"manage-detail-community-members__main-content clearfix\" ui-view></div></section>");
$templateCache.put("app/manage-detail-community-page/components/manage-detail-community-pending-discussions/manage-detail-community-pending-discussions.html","<section class=manage-detail-community-pending-discussions><div class=manage-detail-community-pending-discussions__page-title ng-if=vm.totalPendingDiscussions><div class=manage-detail-community-pending-discussions__description translate translate-values=\"{number: vm.totalPendingDiscussions}\">{{vm.totalPendingDiscussions == 1 ? \'you-have-pending-discussion\' : \'you-have-pending-discussions\'}}</div></div><div class=manage-detail-community-pending-discussions__list-discussion infinite-scroll-disabled=vm.isLastPage infinite-scroll=vm.fetchMorePendingDiscussions() infinite-scroll-immediate-check=false><pending-discussion-detail-tile ng-repeat=\"discussion in vm.discussions\" class=manage-detail-community-pending-discussions__item-discussion discussion=discussion on-status-changed=vm.onStatusChanged(data)></pending-discussion-detail-tile><scroll-paging spinner=vm.spinner is-last-page=vm.isLastPage show-message=\"!vm.discussions.length && vm.searchParams.page == 1\" message=\"There are no discussions pending approval.\" hide-back-to-top=true></scroll-paging></div></section>");
$templateCache.put("app/manage-detail-community-page/components/manage-detail-community-requested-members/manage-detail-community-requested-members.html","<section class=manage-detail-community-requested-members><div class=manage-detail-community-requested-members__page-title ng-if=vm.isEmptyList><div class=manage-detail-community-requested-members__description translate translate-values=\"{number: vm.memberGrid.totalCount}\">{{vm.memberGrid.totalCount == 1 ? \'you-have-pending-request\' : \'you-have-pending-requests\'}}</div><div class=manage-detail-community-requested-members__search><input ng-model=vm.searchString ng-change=vm.onSearchStringChanged() class=\"form-control search-input\" type=text placeholder=\"{{\'search-requested\' | translate}}\"></div></div><community-member-list community=vm.community on-init=vm.onMemberGridInit(instance) context=COMMUNITY_PENDING_MEMBER show-detail=true><div class=text-center><div class=\"no-record-title text--semibold text--color-black\">There are no pending member requests.</div><div class=no-record-description>Members who have requested to join this community will be listed here.</div></div></community-member-list></section>");
$templateCache.put("app/manage-detail-community-page/components/manage-detail-community-unpublished-discussions/manage-detail-community-unpublished-discussions.html","");
$templateCache.put("app/manage-missions/create-mission/create-mission-step-brief/create-mission-step-brief.html","<section class=create-mission-step-brief><h3 class=\"text-center text--color-black text--semibold\" translate>{{\'missions-form-06\'}}</h3><div class=\"create-mission__form-wrapper clearfix\"><form name=vm.createMissionCtrl.briefForm><div class=\"form-group create-mission-step-one__mission-name\"><label class=\"label-sign-up-information text--bold\" translate>{{\'mission-name\'}}</label><div><input maxlength=40 required name=missionMame ng-model=vm.mission.title class=\"form-control create-mission-step-one__input\" placeholder=\"{{\'mission-name-placeholder\' | translate}}\" focus-me=true><div class=\"text-right create-mission-step-one__mission-name__character-counter\"><span class=textarea__length_descriptioon>{{vm.mission.title.length ? vm.mission.title.length : 0}}/40</span></div></div><label class=\"label-sign-up-information text--bold\" translate>{{\'brief\'}}</label><pixerf-quill-editor name=brief options=vm.briefEditorOptions model=vm.mission.description></pixerf-quill-editor><div class=text-right><span class=textarea__length_descriptioon>{{vm.briefLength ? vm.briefLength : 0}}/3000</span></div></div></form></div></section>");
$templateCache.put("app/manage-missions/create-mission/create-mission-step-getting-started/create-mission-step-getting-started.html","<div class=create-mission-step-getting-started><h1 class=\"create-mission__main-contain__header text--semibold text--color-black\" translate>{{\'missions-form-01\'}}</h1><form class=\"text-center create-mission-step-getting-started__duration-wrapper\" name=vm.createMissionCtrl.gettingStartedForm><div class=clearfix><h4 class=\"text--color-black text--bold create-mission-step-getting-started__duration__title\" translate>{{\'missions-form-02\'}}</h4><pixerf-input-auto-complete options=vm.durationOpts name=mission_duration dropdown-class=\"\" data=vm.mission.prices model=vm.selectedPrices on-changed=vm.onMissionDurationSelected()></pixerf-input-auto-complete></div><div class=\"create-mission-step-getting-started__country-select clearfix\"><h4 class=\"text--color-black text--bold create-mission-step-getting-started__duration__title\" translate>{{\'missions-form-03\'}}</h4><pixerf-input-auto-complete dropdown-class=create-mission__country-dropdown options=vm.countriesOpts name=mission_countries data=vm.countries model=vm.selectedCountries on-changed=vm.onCountriesSelected()></pixerf-input-auto-complete></div></form></div>");
$templateCache.put("app/manage-missions/create-mission/create-mission-step-review/create-mission-step-review.html","<section class=create-mission-step-review><mission-review mission=vm.mission is-editable=true></mission-review></section>");
$templateCache.put("app/manage-missions/create-mission/create-mission-step-reward/create-mission-step-reward.html","<section class=create-mission-step-reward><h3 class=\"text-center text--color-black-6 text--semibold\" translate translate-values=\"{number: vm.mission.price.name}\">{{\'missions-form-04\'}}</h3><p class=text-center translate>{{\'missions-form-05\'}}</p><div class=\"create-mission-step-reward__main-content clearfix\"><form name=vm.createMissionCtrl.rewardForm class=create-mission__form-wrapper ng-class=\"{\'pixerf-form-dirty\': vm.createMissionCtrl.rewardForm.$dirty}\"><div class=clearfix><div><div class=\"create-mission-step-reward__custom-duration create-mission-step-reward__mission-winner__col-left form-group\" ng-if=\"vm.mission.price.id == -1\"><label class=text--bold>Set your Mission Duration</label><input placeholder=0 required name=duration class=\"form-control create-mission-step-reward__mission-winner__number-input\" ng-model=vm.mission.price.duration input-number-only input-number-only-max-digits=2 validation-min-max validation-min-max-min=\"vm.prizeRuleSet[vm.mission.price.name][\'duration\'].min\" validation-min-max-max=\"vm.prizeRuleSet[vm.mission.price.name][\'duration\'].max\"> <span>days</span><span>(Select up to 60 days)</span><div ng-show=\"vm.createMissionCtrl.rewardForm.$dirty && (vm.createMissionCtrl.rewardForm.duration.$error.validationMinMaxMin || vm.createMissionCtrl.rewardForm.duration.$error.validationMinMaxMax)\" class=pixerf-invalid>Please enter a figure between {{vm.prizeRuleSet[vm.mission.price.name][\'duration\'].min}} and {{vm.prizeRuleSet[vm.mission.price.name][\'duration\'].max | number}}</div></div><div class=\"create-mission-step-reward__mission-winner clearfix\"><div class=\"create-mission-step-reward__mission-winner__col-left clearfix\"><div class=\"create-mission-step-reward__mission-winner__number form-group\"><label class=\"create-mission-step-reward__field-label text--bold text--color-black-6\" translate>{{\'number-mission-winners\'}}</label><label class=create-mission-step-reward__field-label-rule>({{\'max\' | translate}}. {{vm.prizeRuleSet[vm.mission.price.name][\'WINNER\'].quantity.max}})</label><div class=\"create-mission-step-reward__math-group clearfix\"><input-with-number-control on-changed=vm.onRewardChanged() model=\"vm.mission.prizes_grouped[\'WINNER\']\" options=\"{max: vm.prizeRuleSet[vm.mission.price.name][\'WINNER\'].quantity.max, min: vm.prizeRuleSet[vm.mission.price.name][\'WINNER\'].quantity.min, inputName: \'noWinner\', maxDigits: 3}\"></input-with-number-control><div class=create-mission-step-reward__hint-sign>X</div></div><div ng-show=\"vm.createMissionCtrl.rewardForm.$dirty && (vm.createMissionCtrl.rewardForm.noWinner.$error.validationMinMaxMin || vm.createMissionCtrl.rewardForm.noWinner.$error.validationMinMaxMax)\" class=pixerf-invalid>Please enter a figure between {{vm.prizeRuleSet[vm.mission.price.name][\'WINNER\'].quantity.min}} and {{vm.prizeRuleSet[vm.mission.price.name][\'WINNER\'].quantity.max | number}}</div></div><div class=\"create-mission-step-reward__mission-winner__reward form-group\"><label class=\"create-mission-step-reward__field-label text--bold text--color-black-6\" translate>{{\'winning-prize-each\'}}</label><label class=create-mission-step-reward__field-label-rule>({{\'max\' | translate}}. SGD {{vm.prizeRuleSet[vm.mission.price.name][\'WINNER\'].value.max | number}})</label><div class=input-group><div class=\"input-group-addon text--color-black-6 text--semibold\">SGD</div><div class=\"create-mission-step-reward__math-group clearfix\"><input input-number-only-max-digits=5 required input-number-only validation-min-max validation-min-max-min=\"vm.prizeRuleSet[vm.mission.price.name][\'WINNER\'].value.min\" validation-min-max-max=\"vm.prizeRuleSet[vm.mission.price.name][\'WINNER\'].value.max\" class=\"form-control create-mission-step-reward__mission-winner__reward-input\" placeholder=0 ng-model=\"vm.mission.prizes_grouped[\'WINNER\'].value\" ng-change=vm.onRewardChanged() name=winnerPrizeValue><div class=\"create-mission-step-reward__hint-sign big-sign\">=</div></div></div><div ng-show=\"vm.createMissionCtrl.rewardForm.$dirty && (vm.createMissionCtrl.rewardForm.winnerPrizeValue.$error.validationMinMaxMin || vm.createMissionCtrl.rewardForm.winnerPrizeValue.$error.validationMinMaxMax)\" class=pixerf-invalid>Please enter a figure between {{vm.prizeRuleSet[vm.mission.price.name][\'WINNER\'].value.min}} and {{vm.prizeRuleSet[vm.mission.price.name][\'WINNER\'].value.max | number}}</div></div></div><div class=\"create-mission-step-reward__mission-winner__total text-right form-group\"><span class=\"create-mission-step-reward__mission-winner__total-label text--color-black-6 text--bold\" ng-bind=\"vm.mission.prizes_grouped[\'WINNER\'].total| number:0\"></span> <span class=create-mission-step-reward__currency-unit-label>SGD</span></div></div><div class=\"create-mission-step-reward__mission-consolation clearfix\"><div class=\"create-mission-step-reward__mission-consolation__col-left clearfix\"><div class=\"create-mission-step-reward__mission-consolation__number form-group\"><label class=\"create-mission-step-reward__field-label text--bold text--color-black-6\" translate>{{\'number-special-mentions\'}}</label><label class=create-mission-step-reward__field-label-rule>({{\'max\' | translate}}. {{vm.prizeRuleSet[vm.mission.price.name][\'CONSOLATION\'].quantity.max}})</label><div class=\"create-mission-step-reward__math-group clearfix\"><input-with-number-control on-changed=vm.onRewardChanged() model=\"vm.mission.prizes_grouped[\'CONSOLATION\']\" options=\"{max: vm.prizeRuleSet[vm.mission.price.name][\'CONSOLATION\'].quantity.max, min: vm.prizeRuleSet[vm.mission.price.name][\'CONSOLATION\'].quantity.min, inputName: \'noConsolation\', maxDigits: 3}\"></input-with-number-control><div ng-show=\"vm.createMissionCtrl.rewardForm.$dirty && (vm.createMissionCtrl.rewardForm.noConsolation.$error.validationMinMaxMin || vm.createMissionCtrl.rewardForm.noConsolation.$error.validationMinMaxMax)\" class=pixerf-invalid>Please enter a figure between {{vm.prizeRuleSet[vm.mission.price.name][\'CONSOLATION\'].quantity.min}} and {{vm.prizeRuleSet[vm.mission.price.name][\'CONSOLATION\'].quantity.max | number}}</div><div class=create-mission-step-reward__hint-sign>X</div></div></div><div class=\"create-mission-step-reward__mission-consolation__reward form-group\"><label class=\"create-mission-step-reward__field-label create-mission-step-reward__field-label--no-rule text--bold text--color-black-6\" translate>{{\'special-mention-prize-each\'}}</label><div class=input-group><div class=\"input-group-addon text--color-black-6 text--semibold\">SGD</div><div class=\"create-mission-step-reward__math-group clearfix\"><input class=\"form-control create-mission-step-reward__mission-consolation__reward-input\" placeholder=50 ng-model=\"vm.mission.prizes_grouped[\'CONSOLATION\'].value\" disabled=disabled><div class=\"create-mission-step-reward__hint-sign big-sign\">=</div></div></div></div></div><div class=\"create-mission-step-reward__mission-consolation__total text-right form-group\"><span class=\"create-mission-step-reward__mission-consolation__total-label text--color-black-6 text--bold\" ng-bind=\"vm.mission.prizes_grouped[\'CONSOLATION\'].total | number:0\"></span> <span class=create-mission-step-reward__currency-unit-label>SGD</span></div></div></div></div></form><div class=devider></div><mission-bill mission=vm.mission show-award-only=true></mission-bill></div></section>");
$templateCache.put("app/manage-missions/create-mission/create-mission-step-specification/create-mission-step-specification.html","<section class=create-mission-step-specification><div class=\"create-mission__form-wrapper clearfix\"><form name=vm.createMissionCtrl.specificationForm><pixerf-group-selection-btn group=vm.mission items=vm.specifications></pixerf-group-selection-btn></form></div></section>");
$templateCache.put("app/manage-missions/create-mission/create-mission-step-specification-one/create-mission-step-specification-one.html","<section class=create-mission-step-specification-one><div class=\"create-mission__form-wrapper clearfix\"><form name=vm.createMissionCtrl.specificationOneForm><pixerf-group-selection-btn group=vm.mission items=vm.specifications></pixerf-group-selection-btn></form></div></section>");
$templateCache.put("app/manage-missions/create-mission/create-mission-step-sponsor/create-mission-step-sponsor.html","<section class=create-mission-step-sponsor><h3 class=\"text-center text--color-black text--semibold\">Profile of Mission Sponsor</h3><div class=\"create-mission__form-wrapper clearfix\"><form name=vm.createMissionCtrl.sponsorForm><div class=clearfix><div class=\"relative create-mission-step-sponsor__col col-fixed\"><div class=\"create-mission-step-sponsor__col__inner create-mission-step-sponsor__col__thumbnail\"><div class=create-mission-step-sponsor__thumbnail><img ng-if=vm.mission.sponsor.profile_image ng-src={{vm.mission.sponsor.logoUrl}}></div></div><!-- DROPZONE AREA --><div class=\"form-group create-mission-step-sponsor__col__inner\"><div><div class=dropzone-info><label class=\"label-sign-up-information text--semibold text--color-black\" translate>{{\'mission-sponsor-logo\'}}</label><mission-sponsor-logo mission=vm.mission context=.create-mission-step-sponsor></mission-sponsor-logo></div></div></div></div><div class=\"relative create-mission-step-sponsor__col__flexible\"><div class=\"form-group create-mission-step-sponsor__col__sponsor-name\"><div class=create-mission-step-sponsor__col__inner><label class=\"label-sign-up-information text--semibold text--color-black\" translate>{{\'name-mission-sponsor\'}}</label><input required placeholder=\"Who is running this Mission\" class=form-control ng-model=vm.mission.sponsor.name></div></div></div></div><div class=\"col-md-12 no-padding create-mission-step-sponsor__description form-group\"><label class=\"label-sign-up-information text--semibold text--color-black\" translate>{{\'description-mission-sponsor\'}}</label><textarea required ng-model=vm.mission.sponsor.description class=form-control placeholder=\"{{\'description-mission-sponsor-detail\' | translate}}\"></textarea></div></form></div></section>");
$templateCache.put("app/manage-missions/create-mission/create-mission-step-sponsor-options/create-mission-step-sponsor-options.html","<section class=create-mission-step-sponsor-options><h3 class=\"text-center text--color-black text--semibold\" translate>{{\'missions-form-07\'}}</h3><div class=\"create-mission__form-wrapper clearfix\"><form name=vm.createMissionCtrl.sponsorOptionsForm><div class=\"clearfix create-mission-step-sponsor-options__checkbox-wrapper relative\"><stick-checkbox error=\"vm.createMissionCtrl.sponsorOptionsForm.$dirty && vm.mission.noSponsor === undefined\" model=vm.mission model-property=noSponsor on-changed=vm.onCheckboxChanged() label=missions-form-08 layout-style=solid-square></stick-checkbox></div><div class=\"clearfix create-mission-step-sponsor-options__checkbox-wrapper relative\"><stick-checkbox error=\"vm.createMissionCtrl.sponsorOptionsForm.$dirty && vm.mission.noSponsor === undefined\" model=vm.mission model-property=noSponsor is-reversed=true on-changed=vm.onCheckboxChanged() label=missions-form-09 layout-style=solid-square></stick-checkbox></div></form></div></section>");
$templateCache.put("app/manage-missions/create-mission/create-mission-step-visual-inspiration/create-mission-step-visual-inspiration.html","<section class=create-mission-step-visual-inspiration><h3 class=\"text-center text--color-black text--semibold\" translate>{{\'visual-inspiration-moodboard\'}}</h3><div class=\"create-mission__form-wrapper clearfix\"><form name=vm.createMissionCtrl.visualInspirationForm><div class=\"form-group col-sm-12 no-padding\"><label class=\"label-sign-up-information text--bold\" translate>{{\'art-direction\'}}</label><pixerf-quill-editor name=artDirection options=vm.artDirectionEditorOptions model=vm.mission.art_direction></pixerf-quill-editor><div class=text-right><span class=textarea__length_descriptioon>{{vm.descriptionLength ? vm.descriptionLength : 0}}/1500</span></div></div><mission-inspiration-photos num-processing-file=vm.numProcessingFile ng-if=vm.mission mission=vm.mission></mission-inspiration-photos></form></div></section>");
$templateCache.put("app/manage-missions/mission-draft/list-missions-draft/list-missions-draft.html","<div class=\"manage-missions-draft no-margin clearfix\"><div class=\"manage-missions-draft__col-wrapper clearfix\"><section class=\"no-padding clearfix\"><div class=manage-missions-draft__intro><div class=\"manage-missions-draft__intro__title text--semibold text--color-black\" translate>{{\'unpublished-missions\'}}</div><div class=manage-missions-draft__intro__description translate>{{\'missions-form-14\'}}</div></div><div class=\"manage-missions-draft__filter-wrapper clearfix\"><div class=\"manage-missions-draft__filter-label text--bold text--color-black\" translate>{{\'filter-by\'}}</div><li class=\"manage-missions-draft__filter-control pixerf-filter-bar__menu-item clearfix\" ng-class=\"{\'pixerf-filter-bar__menu-item--active\': !vm.selectedItem.isDefault}\"><popover-selection-btn class=btn-first-filter close-on-click=true on-selection-changed=vm.onFilterSelected(vm.selectedItem.value) selected-model=vm.selectedItem settings=vm.filterSetting></popover-selection-btn></li></div><div class=manage-missions-draft__sub-title ng-if=\"vm.items.length > 0\"><div class=\"manage-missions-draft__sub-title__item-last text--bold text--color-black\">{{\'remarks\' | translate}}</div><div class=\"manage-missions-draft__sub-title__item-mid text--bold text--color-black\">{{\'status\' | translate}}</div><div class=\"manage-missions-draft__sub-title__item-first text--bold text--color-black\">{{\'details\' | translate}}</div></div><div class=manage-missions-draft__col-left infinite-scroll-disabled=vm.isLastPage infinite-scroll=vm.fetchMoreItems() infinite-scroll-immediate-check=false><div ng-if=\"vm.items.length > 0\"><div class=\"manage-missions-draft-item clearfix\" ng-repeat=\"mission in vm.items\"><mission-status-item mission=mission on-mission-deleted=vm.onMissionDeleted(mission)></mission-status-item></div></div><div class=\"manage-missions-draft__no-mission text-center\" ng-if=\"vm.items.length === 0 && vm.noUnpublishedMission\"><div class=\"manage-missions-draft__no-mission__text text--bold-switch-semibold text--color-black\">There are no unpublished Missions at this time.</div><div class=manage-missions-draft__no-mission__text__content>Be inspired to start a new Mission and crowdsource diverse Asian perspectives quickly and easily for your creative needs. Launching a Mission is easy with PIXERF!</div><!-- <button type=\"button\" class=\"btn btn-submit manage-missions-draft__create-btn text--bold\" ui-sref=\"setting.manage-missions.create-mission.getting-started\">{{\'create-mission\' | translate}}</button> --></div></div><spinner-win spinner=vm.spinner></spinner-win></section></div></div>");
$templateCache.put("app/manage-photos/components/manage-photos-sold/manage-photos-sold.html","<div class=\"manage-photos-sold no-margin\"><div class=\"manage-photos-sold__col-wrapper clearfix\"><section class=\"col-md-8 no-padding col-left-min-width\"><div class=manage-photos-sold__intro><div class=\"manage-photos-sold__intro__title text--color-black text--semibold\">{{\'congratulations\' | translate}}!</div><div class=manage-photos-sold__intro__description>When your photo is licensed, you earn a portion of the price as your payout. Your payout rate may vary depending on the type of account you have.</div></div><div class=manage-photos-sold__col-left><div ng-show=\"vm.items.length > 0\"><div class=manage-photos-sold__main-content ui-view></div><a ui-sref=setting.earnings.photos_sold.sold-list><div class=\"btn btn-submit manage-photos-sold__history-btn\">Photo Sold History</div></a></div><div class=text-center ng-show=\"vm.items.length === 0\">You have no photos sold at the moment.</div></div><spinner-win spinner=vm.spinner></spinner-win></section><section class=\"col-md-4 no-padding col-right-min-width\"><div class=manage-photos-sold__col-right><div class=manage-photos-sold__earning><div class=\"manage-photos-sold__earning__title text--bold\">{{\'your-earnings\' | translate}}</div><div class=\"manage-photos-sold__earning__contain clearfix\"><div class=\"manage-photos-sold__earning__total col-xs-6 no-padding\"><div class=\"manage-photos-sold__earning__total-text text--bold\">{{\'total-earnings\' | translate}}</div><div class=manage-photos-sold__earning__total-date>as of {{vm.today}}</div></div><div class=\"manage-photos-sold__earning__money col-xs-6 no-padding text--bold\">SGD {{vm.earnings.total | number:2}}</div></div><a ui-sref=setting.earnings.my_earnings.images_sold><div class=\"btn btn-submit--no-background manage-photos-sold__earning-check-btn text--bold\">Check My Earnings</div></a></div><div class=manage-photos-sold__earn-more><div class=\"manage-photos-sold__earn-more__title text--color-black text--bold\">Earn more money?</div><div class=manage-photos-sold__earn-more__description>Learn how to succeed on PIXERF and best practices when prepping your photos for sale.</div><a ui-sref=\"introduction-support.faq.personal({section: \'pricing\'})\" target=_blank><div class=\"btn btn-submit manage-photos-sold__earn-more__learn-how-earn-btn text--bold\">Learn How to Earn</div></a></div></div></section></div></div>");
$templateCache.put("app/manage-photos/components/photos-approved/photos-approved.html","<div class=\"manage-photos-approved no-margin\"><div class=\"manage-photos-approved__col-wrapper clearfix\"><section class=\"col-md-12 no-padding col-left-min-width\"><div class=manage-photos-approved__intro><div class=manage-photos-approved__intro__description translate>{{\'approved-description\'}}</div><div class=manage-photos-approved__info__filters-wrapper><label class=\"manage-photos-approved__info__filters__label text--bold\" translate>{{\'sort-by\'}}</label><ul class=manage-photos-approved__info__sort><li class=manage-photos-approved__info__sort__item ng-class=\"{\'manage-photos-approved__info__sort__item--active\': !vm.selectedSize.isDefault}\"><popover-selection-btn close-on-click=true on-selection-changed=vm.onFilteredClicked(item) selected-model=vm.selectedFilterItem settings=vm.filterSetting></popover-selection-btn></li></ul></div></div><div ng-if=\"vm.gridSort === \'freshness\'\" class=\"manage-photos-approved__col-left group-dates clearfix relative photos-grid-wrapper\"><div ng-if=\"vm.items.length > 0\" infinite-scroll-disabled=vm.isLastPage infinite-scroll=vm.fetchMorePhotos() infinite-scroll-immediate-check=false><div class=group-by-month ng-repeat=\"item in vm.bidingItems\"><h3 data-toggle=collapse data-target=#group-by-{{item.collapse}}>{{item.title}}</h3><div id=group-by-{{item.collapse}} class=\"collapse in\"><div flex-grid ng-model=item margins=3 rowheight=250><tile-photo ng-repeat=\"photo in item.data\" on-photo-clicked=\"onPhotoClicked({file: photo})\" context=context on-added-or-removed-from-gallery=vm.onAddedOrRemovedFromGallery(photo) on-file-removed=vm.onFileRemoved(photo) gallery=gallery file=photo></tile-photo></div></div></div><scroll-paging spinner=vm.spinner show-message=\"vm.gridSort === \'freshness\' && vm.bidingItems.length > 0\" hide-back-to-top=\"vm.totalPage < 2\" is-last-page=vm.isLastPage message=\"{{\'no-more-photos\' | translate}}\"></scroll-paging></div></div><div ng-if=\"vm.gridSort != \'freshness\'\" class=\"manage-photos-approved__col-left group-likes clearfix relative photos-grid-wrapper\"><div infinite-scroll-disabled=vm.isLastPage infinite-scroll=vm.fetchMorePhotos() infinite-scroll-immediate-check=false><div flex-grid ng-model=vm.bidingItems margins=3 rowheight=250><tile-photo ng-repeat=\"item in vm.bidingItems\" on-photo-clicked=\"onPhotoClicked({file: item})\" context=context on-added-or-removed-from-gallery=vm.onAddedOrRemovedFromGallery(item) on-file-removed=vm.onFileRemoved(item) gallery=gallery file=item></tile-photo></div><scroll-paging spinner=vm.spinner show-message=\"vm.gridSort != \'freshness\' && vm.bidingItems.length > 0\" hide-back-to-top=\"vm.totalPage < 2\" is-last-page=vm.isLastPage message=\"{{\'no-more-photos\' | translate}}\"></scroll-paging></div></div></section></div></div>");
$templateCache.put("app/manage-photos/components/photos-pending-review/photos-pending-review.html","<div class=\"manage-photos-review no-margin\"><div class=\"manage-photos-review__col-wrapper clearfix\"><section class=\"no-padding col-left-min-width\"><div class=manage-photos-review__intro><div class=manage-photos-review__intro__description translate>{{\'in-review-description\'}}</div></div><div class=row><div class=manage-photos-review__col-left><div ng-show=\"vm.items.length > 0\"><div class=\"manage-photos-review-item clearfix\" ng-repeat=\"item in vm.items\" infinite-scroll-disabled=vm.isLastPage infinite-scroll=vm.fetchMoreItems() infinite-scroll-immediate-check=false><manage-photos-status status=\"\'review\'\" media=item on-media-deleted=vm.onMediaDeleted(media)></manage-photos-status></div></div><div class=\"manage-photos-review__no-data text-center\" ng-show=\"vm.items.length === 0\"><span class=manage-photos-review__no-data__icon>&nbsp;</span> <strong class=\"manage-photos-review__no-data__title text--bold\" translate>{{\'in-review-no-photos\'}}</strong><p class=manage-photos-review__no-data__desc translate>{{\'in-review-upload-earn\'}}</p><button type=button class=\"btn btn-submit text--bold\" authentication-click=vm.showUploadModal()>{{\'upload\' | translate}}</button></div></div></div></section></div><spinner-win spinner=vm.spinner></spinner-win></div>");
$templateCache.put("app/manage-photos/components/photos-rejected/photos-rejected.html","<div class=\"manage-photos-rejected no-margin\"><div class=\"manage-photos-rejected__col-wrapper clearfix\"><section class=\"col-md-12 no-padding col-left-min-width\"><div class=manage-photos-rejected__intro><div class=manage-photos-rejected__intro__description translate>{{\'rejected-description\'}}</div></div><div class=manage-photos-rejected__col-left infinite-scroll-disabled=vm.isLastPage infinite-scroll=vm.fetchMoreItems() infinite-scroll-immediate-check=false><div ng-show=\"vm.items.length > 0\"><div class=\"manage-photos-review-item clearfix\" ng-repeat=\"item in vm.items\"><manage-photos-status status=\"\'rejected\'\" media=item on-media-deleted=vm.onMediaDeleted(media)></manage-photos-status></div></div><div class=\"manage-photos-rejected__no-data text-center\" ng-show=\"vm.items.length === 0\"><span class=manage-photos-rejected__no-data__icon>&nbsp;</span> <strong class=\"manage-photos-rejected__no-data__title text--bold\" translate>{{\'rejected-no-photos\'}}</strong><p class=manage-photos-rejected__no-data__desc translate>{{\'in-review-upload-earn\'}}</p><button type=button class=\"btn btn-submit text--bold\" ng-click=vm.showUploadModal() translate>{{\'upload\'}}</button></div></div><spinner-win spinner=vm.spinner></spinner-win></section></div></div>");
$templateCache.put("app/marketplace/components/marketplace-galleries/marketplace-galleries.html","<section class=\"marketplace-galleries bg-white relative\"><div class=marketplace-galleries__sub-navigation><div ng-repeat=\"item in vm.galleriesType\" class=marketplace-galleries__sub-navigation__item ng-class=\"{\'active\': vm.defaultGalleriesType === item.value}\" ng-click=vm.onGalleriesTypeChanged(item)>{{item.title}}</div></div><div ng-if=vm.showCreditPlanBar class=\"marketplace-galleries__top-bar collapsed\" data-toggle=collapse data-target=#credit-plan-collapse><div>Pay less and download more. Enjoy up to 30% less on credit plans.</div><div class=icon-doubledropdown></div></div><div id=credit-plan-collapse class=\"marketplace-galleries__content-toggle collapse\" event-key on-key-pressed=vm.logKey><div class=credit-plans__header><button type=button class=\"close credit-plans__close-btn\" ng-click=vm.closeCreditPlanPopup()><span class=\"icon-icons_close text--color-white\" aria-hidden=true></span></button></div><credit-plans on-plan-selected=vm.onPlanSelected(plan) context=popup></credit-plans><div class=credit-plan-page__hint-text><div>{{\'credits-text\' | translate}}</div></div></div><div class=marketplace-galleries__header ng-class=\"{\'have-credit-plan-top-bar\': vm.showCreditPlanBar}\"><div class=marketplace-galleries__header__wrapper><div class=marketplace-galleries__header__title ng-bind-html=vm.header></div><div ng-if=vm.description class=marketplace-galleries__header__description ng-bind-html=vm.description></div></div><div class=marketplace-galleries__header__control><mutiline-dropdown items=vm.galleriesType selected=vm.defaultGalleriesType on-changed=vm.onGalleriesTypeChanged(data) hide-check-icon=true></mutiline-dropdown></div></div><div ui-view></div></section>");
$templateCache.put("app/marketplace/components/marketplace-galleries-grid/marketplace-galleries-grid.html","<section class=\"marketplace-galleries bg-white relative clearfix marketplace-galleries-grid\"><div class=\"marketplace__sub-navigate clearfix\" scroll-to-fixed=vm.scrollToFixedHeaderSettings><div class=marketplace__sub-navigate__back-btn ng-click=vm.onBackbtnClicked()><span class=\"marketplace__sub-navigate__back-btn__icon text--color-black text--bold\">&lt;</span>{{\'back-to\' | translate: {name: (\'gallery\' | translate).toLowerCase()}}}</div></div><div class=\"marketplace-galleries__block pixerfer-galleries\"><div class=\"galleries__header clearfix\"><div class=\"galleries__title text--extrabold\" translate>{{vm.headerName}}</div><div class=galleries__description translate>{{vm.description}}</div></div><div class=galleries__grid><gallery-grid instance=vm.galleryGridAll on-scroll-to-gallery=vm.onScrollToGallery(page) on-load-more-page=vm.onLoadMorePage(page)></gallery-grid></div></div></section>");
$templateCache.put("app/marketplace/components/marketplace-photos/marketplace-photos.html","<div class=marketplace-photos><div class=\"photos-grid-wrapper clearfix relative\" ng-class=\"{\'temporary-state\': vm.photoGrid.isTemporaryType}\"><photo-grid on-load-more-page=vm.onLoadMorePage(page) ng-attr-shuffle={{vm.shuffle}} on-scroll-to-photo=vm.onScrollToPhoto(page) context=\"\'MARKET_PLACE\'\" instance=vm.photoGrid><div class=\"text-center marketplace__no-result-message\"><span class=icon-icons_search></span><h3 class=\"text-semibold no-message-notice text--semibold text--color-black\" translate>{{\'no-photos-found\'}}</h3></div></photo-grid></div></div>");
$templateCache.put("app/marketplace/components/pending-submissions/pending-submissions.html","<div class=pending-submissions><div infinite-scroll-disabled=vm.isLastPage infinite-scroll=vm.fetchMorePhotos() infinite-scroll-immediate-check=false><div class=group-by-mission ng-repeat=\"item in vm.bidingItems\"><div class=pending-submissions__title data-toggle=collapse data-target=#group-by-{{item.collapse}}>{{item.title}}</div><div class=pending-submissions__grid id=group-by-{{item.collapse}} class=\"collapse in\"><div flex-grid ng-model=item margins=3 rowheight=250><tile-photo ng-repeat=\"photo in item.data\" on-photo-clicked=\"onPhotoClicked({file: photo})\" context=context on-added-or-removed-from-gallery=vm.onAddedOrRemovedFromGallery(photo) on-file-removed=vm.onFileRemoved(photo) options=vm.options gallery=gallery file=photo></tile-photo></div></div></div><scroll-paging spinner=vm.spinner show-message=false hide-back-to-top=\"vm.totalPage < 2\" is-last-page=vm.isLastPage message=\"{{\'no-more-photos\' | translate}}\"></scroll-paging></div></div>");
$templateCache.put("app/marketplace/components/rejected-submissions/rejected-submissions.html","<div class=rejected-submissions><div infinite-scroll-disabled=vm.isLastPage infinite-scroll=vm.fetchMorePhotos() infinite-scroll-immediate-check=false><div class=group-by-mission ng-repeat=\"item in vm.bidingItems\"><div class=rejected-submissions__title data-toggle=collapse data-target=#group-by-{{item.collapse}}>{{item.title}}</div><div class=rejected-submissions__grid id=group-by-{{item.collapse}} class=\"collapse in\"><div flex-grid ng-model=item margins=3 rowheight=250><tile-photo ng-repeat=\"photo in item.data\" on-photo-clicked=\"onPhotoClicked({file: photo})\" context=context on-added-or-removed-from-gallery=vm.onAddedOrRemovedFromGallery(photo) on-file-removed=vm.onFileRemoved(photo) options=vm.options gallery=gallery file=photo></tile-photo></div></div></div><scroll-paging spinner=vm.spinner show-message=false hide-back-to-top=\"vm.totalPage < 2\" is-last-page=vm.isLastPage message=\"{{\'no-more-photos\' | translate}}\"></scroll-paging></div></div>");
$templateCache.put("app/mission-detail-page/components/awards/awards.html","<div ng-include=vm.getTemplate(vm.parent.mission)></div>");
$templateCache.put("app/mission-detail-page/components/brief/brief.html","<section class=\"brief bg--white\"><mission-info mission=vm.parent.mission allow-to-submit-submission=\"!vm.parent.loginnedUser.canManageMission && !vm.parent.mission.is_closed\" on-submit-photo-clicked=vm.onSubmitPhotoClicked()></mission-info></section>");
$templateCache.put("app/mission-detail-page/components/pending-submissions-mission/pending-submissions-mission.html","<section class=submission><div scroll-to-element=vm.isScrollToPixerferSubmission class=\"submission__other bg--white\" ng-class=\"{\'submission__other--marketer-view\': vm.loginnedUser.canManageMission}\"><div scroll-to-fixed=vm.fixedSetting class=\"submission__other__title text--semibold text--color-black\" ng-if=!vm.loginnedUser.canManageMission><ul class=\"clearfix relative\"><div class=\"submission__other__heading text--extrabold\" translate>{{\'pending-submissions\'}}</div><li class=\"submission__other__pagination pixerf-filter-bar__menu-item pixerf-filter-bar__menu-item__photo-grid-pager pull-left\" ng-if=\"vm.photoGrid.totalPhotos > 0\"><photo-grid-pager total-photos=vm.photoGrid.totalPhotos is-shown-num-photos=true total-page=vm.photoGrid.totalPage page=vm.parent.submissionPagination.page on-current-page-changed=vm.parent.onCurrentPageChanged(pageNumber) is-show-page-text=true></photo-grid-pager></li></ul></div><div class=submission__photo-grid><photo-grid instance=vm.photoGrid on-file-removed=\"vm.onSubmissionRemoved(file, \'others\')\" on-load-more-page=vm.parent.onLoadMorePage(page) on-photo-clicked-callback=vm.onPhotoSelected(file) on-scroll-to-photo=vm.parent.onScrollToPage(page) options=vm.options><div class=\"text-center submission__other__empty-state\"><div class=submission__other__empty-state__gallery></div><h4 class=\"text--semibold text--color-black submission__other__empty-state__title\" translate>{{\'no-images-submitted\'}}</h4><div class=submission__other__empty-state__notices translate>{{\'uploaded-image-spends-time-before-sorted\'}}</div></div></photo-grid></div></div></section>");
$templateCache.put("app/mission-detail-page/components/rejected-submissions-mission/rejected-submissions-mission.html","<section class=submission><div scroll-to-element=vm.isScrollToPixerferSubmission class=\"submission__other bg--white\" ng-class=\"{\'submission__other--marketer-view\': vm.loginnedUser.canManageMission}\"><div scroll-to-fixed=vm.fixedSetting class=\"submission__other__title text--semibold text--color-black\" ng-if=!vm.loginnedUser.canManageMission><ul class=\"clearfix relative\"><div class=\"submission__other__heading text--extrabold\" translate>{{\'rejected-submissions\'}}</div><li class=\"submission__other__pagination pixerf-filter-bar__menu-item pixerf-filter-bar__menu-item__photo-grid-pager pull-left\" ng-if=\"vm.photoGrid.totalPhotos > 0\"><photo-grid-pager total-photos=vm.photoGrid.totalPhotos is-shown-num-photos=true total-page=vm.photoGrid.totalPage page=vm.parent.submissionPagination.page on-current-page-changed=vm.parent.onCurrentPageChanged(pageNumber) is-show-page-text=true></photo-grid-pager></li></ul></div><div class=submission__photo-grid><photo-grid instance=vm.photoGrid on-file-removed=\"vm.onSubmissionRemoved(file, \'others\')\" on-load-more-page=vm.parent.onLoadMorePage(page) on-photo-clicked-callback=vm.onPhotoSelected(file) on-scroll-to-photo=vm.parent.onScrollToPage(page) options=vm.options><div class=\"text-center submission__other__empty-state\"><div class=submission__other__empty-state__gallery></div><h4 class=\"text--semibold text--color-black submission__other__empty-state__title\" translate>{{\'no-images-submitted\'}}</h4><div class=submission__other__empty-state__notices translate>{{\'uploaded-image-spends-time-before-sorted\'}}</div></div></photo-grid></div></div></section>");
$templateCache.put("app/mission-detail-page/components/submissions/submissions.html","<section class=submission><!-- <div class=\"submission__owner\" ng-if=\"!vm.loginnedUser.canManageMission && (!vm.loginnedUser || vm.loginnedUser.canUploadPhotos)\">\r\n		<div class=\"submission__owner__title text--semibold text--color-black\">My Submissions</div>\r\n		<photo-grid class=\"submission__my-submission-photo-grid\" hide-no-more-message=\"true\" on-file-removed=\"vm.onSubmissionRemoved(file, extraParams)\" on-remove-btn-click=\"vm.onRemoveParticipationClicked(file)\" options=\"{\'hideAddToGallery\': true, \'showRemoveBtn\': !vm.parent.mission.is_closed, \'hideCuratorBtns\': true}\" ideal-height=\"200\" on-init=\"vm.onMySubmissionGridInit(photoGrid)\">\r\n			<div ng-if=\"!vm.parent.mission.is_closed\">\r\n			<div class=\"submission__submitted_entry__empty-state\">\r\n				<div class=\"submission__submitted_entry__empty-state__title text--color-black text--bold\">How would you like to submit?</div>\r\n				<div class=\"btn btn-submit text--bold submission__upload-new-btn\" authentication-click=\"vm.onUploadNewPhotoBtnClicked()\" check-verified-email=\"true\">Upload New Photo</div>\r\n				<div class=\"btn btn-submit text--bold submission__upload-exist-btn\" authentication-click=\"vm.onUploadFromMineBtnClicked()\" check-verified-email=\"true\">Select From My Photos</div>\r\n				<div class=\"submission__submitted_entry__empty-state__mission-agreement-checkbox__wrapper clearfix\">\r\n					<div class=\"submission__submitted_entry__empty-state__mission-agreement-checkbox pixerf-checkbox relative\">\r\n						<pixerf-checkbox authentication-check=true is-disabled=\"vm.parent.mission.is_agreement_accepted\" on-changed=\"vm.onMissionAgreed()\" error=\"!vm.parent.mission.is_agreement_accepted && vm.isFormDirty\" model=\"vm.parent.mission\" model-property=\"is_agreement_accepted\"></pixerf-checkbox>\r\n						<span ng-if=\"!vm.isAsiaGeoMission\">I agree to the <a target=\"_blank\" ui-sref=\"mission.mission-agreement\" class=\"text--color-pixerf-theme text--bold\" role=\"button\">Missions Agreement.</a></span>\r\n						<span ng-if=\"vm.isAsiaGeoMission\">I agree to PIXERF\'s <a target=\"_blank\" ui-sref=\"mission.mission-agreement\" class=\"text--color-pixerf-theme text--bold\" role=\"button\">Missions Agreement</a> and Asian Geographic Images of Asia photography competition\'s <a target=\"_blank\" href=\"http://www.asiangeo.com/ioa-rules-and-regulations/\" class=\"text--color-pixerf-theme text--bold\" role=\"button\">Terms & Conditions</a> </span>\r\n					</div>\r\n				</div>\r\n			</div>\r\n			<div class=\"submission__owner__submit-photo-section__description\">\r\n				<span ng-if=\"!vm.isAsiaGeoMission\">\r\n					You can submit up to 6 photos per Mission.<br/>\r\n					All submissions, other than those selected, will be released into the Marketplace after 30 days.<br/>\r\n					For more details, check out our <a target=\"_blank\" ui-sref=\"mission.mission-agreement\" class=\"text--color-pixerf-theme text--bold\" role=\"button\">Missions Agreement.</a>\r\n				</span>\r\n				<span ng-if=\"vm.isAsiaGeoMission\">\r\n					You may submit 1 photo to any of the five Images of Asia 2018 Missions.<br/>\r\n					Asian Geographic Print subscribers may submit up to 6 photos.<br/>\r\n					Asian Geographic e-magazine subscribers may submit up to 4 photos.<br/>\r\n					All submissions, other than those selected, will be released into the Marketplace after 30 days.<br/>\r\n					For more details, check out our <a target=\"_blank\" ui-sref=\"mission.mission-agreement\" class=\"text--color-pixerf-theme text--bold\" role=\"button\">Missions Agreement.</a>\r\n				</span>\r\n			</div>\r\n		</div>\r\n			<div  ng-if=\"vm.parent.mission.is_closed\" class=\"submission__owner__closed-mission-description\">You didn\'t submit any photos to this Mission!<br/>\r\n			How about checking our ongoing Missions instead?</div>\r\n			<button ng-if=\"vm.parent.mission.is_closed\" type=\"button\" class=\"btn btn-submit submission__owner__explore-button\" ui-sref=\"mission.on-going\">Explore Missions</button>\r\n		</photo-grid>\r\n\r\n		<div class=\"submission__owner__submit-photo-section\" ng-if=\"vm.mySubmissionGrid && vm.mySubmissionGrid.photos.length > 0 && !vm.parent.mission.is_closed\">\r\n			<button type=\"button\" class=\"btn btn-submit submission__owner__submit-button text--bold\" ng-click=\"vm.onSubmitPhotoClicked()\" >{{vm.parent.mission.has_joined ? \"Submit More Photos\" : \"Submit Your Photo\"}}</button>\r\n		</div>\r\n	</div> --><div scroll-to-element=vm.isScrollToPixerferSubmission class=\"submission__other bg--white\" ng-class=\"{\'submission__other--marketer-view\': vm.loginnedUser.canManageMission}\"><div scroll-to-fixed=vm.fixedSetting class=\"submission__other__title text--semibold text--color-black\"><ul class=\"clearfix relative\"><div class=\"submission__other__heading text--extrabold\" translate>{{\'pixerfers-submissions\'}}</div><li class=\"submission__other__pagination pixerf-filter-bar__menu-item pixerf-filter-bar__menu-item__photo-grid-pager pull-left\" ng-if=\"vm.totalPhotos > 0\"><photo-grid-pager total-photos=vm.totalPhotos is-shown-num-photos=true total-page=vm.totalPage page=vm.parent.submissionPagination.page on-current-page-changed=vm.onCurrentPageChanged(pageNumber) is-show-page-text=true></photo-grid-pager></li></ul></div><div class=submission__photo-grid><div ng-if=vm.parent.mission.is_multi_frame infinite-scroll-disabled=vm.isLastPage infinite-scroll=vm.fetchMorePhotos() infinite-scroll-immediate-check=false><div class=group-by-photographer ng-repeat=\"item in vm.bidingItems\"><div class=group-by-photographer__collapse data-toggle=collapse data-target=#group-by-{{item.collapse}}><div class=group-by-photographer__avatar><img ng-src={{item.avatar.profileImageSmall}}></div><div class=group-by-photographer__title>{{item.title}}</div></div><div id=group-by-{{item.collapse}} class=\"group-by-photographer__item-list collapse in\"><div flex-grid ng-model=item margins=3 rowheight=50 lastrow=justify><tile-photo ng-repeat=\"photo in item.data\" on-photo-clicked=\"onPhotoClicked({file: photo})\" context=vm.context on-added-or-removed-from-gallery=vm.onAddedOrRemovedFromGallery(photo) on-file-removed=vm.onFileRemoved(photo) gallery=gallery file=photo mission=vm.parent.mission></tile-photo></div></div></div><scroll-paging spinner=vm.spinner show-message=\"vm.gridSort === \'freshness\' && vm.bidingItems.length > 0\" hide-back-to-top=\"vm.totalPage < 2\" is-last-page=vm.isLastPage message=\"{{\'no-more-photos\' | translate}}\"></scroll-paging></div><!-- <div ng-if=\"!vm.parent.mission.is_multi_frame\" infinite-scroll-disabled=\"vm.isLastPage\"\r\n				infinite-scroll=\"vm.fetchMorePhotos()\" infinite-scroll-immediate-check=\"false\">\r\n				<div flex-grid ng-model=\"vm.bidingItems\" margins=\"3\" rowheight=\"250\">\r\n					<tile-photo ng-repeat=\"item in vm.bidingItems\" on-photo-clicked=\"onPhotoClicked({file: item})\"\r\n						context=\"mission\" on-added-or-removed-from-gallery=\"vm.onAddedOrRemovedFromGallery(item)\"\r\n						on-file-removed=\"vm.onFileRemoved(item)\" gallery=\"gallery\" file=\"item\" mission=\"vm.parent.mission\">\r\n					</tile-photo>\r\n				</div>\r\n				<scroll-paging spinner=\"vm.spinner\"\r\n					show-message=\"vm.gridSort != \'freshness\' && vm.bidingItems.length > 0\"\r\n					hide-back-to-top=\"vm.totalPage < 2\" is-last-page=\"vm.isLastPage\"\r\n					message=\"{{\'no-more-photos\' | translate}}\"></scroll-paging>\r\n			</div> --><div ng-if=!vm.parent.mission.is_multi_frame><photo-grid instance=vm.photoGrid on-file-removed=\"vm.onSubmissionRemoved(file, \'others\')\" on-load-more-page=vm.parent.onLoadMorePage(page) on-photo-clicked-callback=vm.onPhotoSelected(file) on-scroll-to-photo=vm.parent.onScrollToPage(page)><div class=\"text-center submission__other__empty-state\"><div class=submission__other__empty-state__gallery></div><h4 class=\"text--semibold text--color-black submission__other__empty-state__title\" translate>{{\'no-images-submitted\'}}</h4><div class=submission__other__empty-state__notices translate>{{\'uploaded-image-spends-time-before-sorted\'}}</div></div></photo-grid></div></div></div><div class=\"mission-detail-page__footer clearfix\"><div class=\"mission-detail-page__footer__title text--extrabold\" translate>{{\'crowdsource-business-banner\'}}</div><div class=mission-detail-page__footer__description><div translate>{{\'crowdsource-business-description-1\'}}</div><div translate>{{\'crowdsource-business-description-2\'}}</div></div><button class=\"mission-detail-page__footer__btn text--bold btn btn--white-magento\" ui-sref=run-a-challenge-page.live-challenges>{{\'find-out-how\' | translate}}</button></div></section>");
$templateCache.put("app/mission/components/mission-agreement/mission-agreement.html","<div class=\"terms-page no-margin missions-agreement\"><section class=\"row missions-agreement__wrapper\"><div class=missions-agreement__content-left><p class=missions-agreement__heading>Missions Agreement</p><div class=missions-agreement__main-content><p>This Missions Agreement (the \"<u class=\"text--bold text--color-black\">Agreement</u>\") between you (the \"<u class=\"text--bold text--color-black\">you</u>\", \"<u class=\"text--bold text--color-black\">your</u>\" or the \"<u class=\"text--bold text--color-black\">Mission Participant</u>\") and PIXERF PTE LTD \"<u>PIXERF</u>\" sets forth the terms and conditions that apply when you submit or upload any Mission Visual Content (as defined below) for the purposes of participating in a Mission (as defined below).</p><p>Please review this Agreement carefully before submitting or uploading any Mission Visual Content. By either submitting or uploading any Mission Visual Content, you agree to be bound by the terms of this Agreement, the <a ui-sref=explore-creators-page.creator-agreement target=__blank class=subscription-page-business-link>Contributor Agreement</a>, the <a target=__blank ui-sref=introduction-company.terms class=subscription-page-business-link>Terms and Conditions</a> and the <a target=__blank ui-sref=introduction-company.privacy class=subscription-page-business-link>Privacy Policy</a>. If you do not agree to any of these terms, please do not submit or upload any Mission Visual Content.</p><p>The Missions are not sponsored by, associated with or connected to Apple or Google in any manner.</p><ol><li><span class=missions-agreement__sub-heading>Interpretation and Definitions</span><ol><li>In this Agreement, unless the context otherwise requires, the following words or expressions shall have the following meanings:</li><table class=missions-agreement__table><tr><th>“<span class=\"text--bold text--color-black\">Mission</span>”</th><td>means an event organised by PIXERF on or through PIXERF’s platform at www.pixerf.com for the Mission Sponsor to crowdsourced Mission Visual Content in accordance with the specified requirements;</td></tr><tr><th>“<span class=\"text--bold text--color-black\">Mission Period</span>”</th><td>means, in relation to a particular Mission, the period of time during which you may submit or upload Mission Visual Content for that Mission;</td></tr><tr><th>“<span class=\"text--bold text--color-black\">Mission End Date</span>”</th><td>means, in relation to a particular Mission, the date on which the relevant Mission Period ends;</td></tr><tr><th>“<span class=\"text--bold text--color-black\">Mission Specific Rules</span>”</th><td>refers to the specific terms and conditions that are applicable to a particular Mission;</td></tr><tr><th>“<span class=\"text--bold text--color-black\">Mission Sponsor</span>”</th><td>means, in relation to a particular Mission, either PIXERF or the third party who commissioned the Mission (as the case may be);</td></tr><tr><th>“<span class=\"text--bold text--color-black\">Mission Start Date</span>”</th><td>means, in relation to a particular Mission, the date on which the relevant Mission Period begins; and</td></tr><tr><th>“<span class=\"text--bold text--color-black\">Mission Visual Content</span>”</th><td>means the content, including photographs, illustrations, vector graphics and videos, which you post, upload, display or otherwise make available for the purposes of participating in a Mission.</td></tr></table><li>In the event of any inconsistency or conflict between the provisions of this Agreement and any of the provisions of the <a target=__blank ui-sref=explore-creators-page.creator-agreement class=subscription-page-business-link>Contributor Agreement</a>, the <a target=__blank ui-sref=introduction-company.terms class=subscription-page-business-link>Terms and Conditions</a> or the<a target=__blank ui-sref=introduction-company.privacy class=subscription-page-business-link>Privacy Policy</a>, the provisions of this Agreement shall prevail.</li><li>Unless otherwise defined in this Agreement, the terms used herein shall bear the same meanings as in the <a target=__blank ui-sref=introduction-company.terms class=subscription-page-business-link>Terms and Conditions</a>.</li></ol></li><li><span class=missions-agreement__sub-heading>Submission of Mission Visual Content</span><ol><li>PIXERF may determine at its sole discretion which Mission Visual Content is deemed suitable for submission or upload by you. PIXERF may provide submission guidelines and procedures for the Mission Visual Content, which may be revised from time to time, and you agree to comply with such submission guidelines and procedures (including any revisions thereto) by submitting or uploading any Mission Visual Content. Any breach of these guidelines and procedures may be deemed to be a breach of this Agreement in PIXERF’s sole discretion.</li><li><span class=\"text--bold text--color-black\">Mission Specific Rules.</span> Each Mission Visual Content which you submit or upload will be subject to the Mission Specific Rules, which may include, but is not limited to, eligibility and participation requirements; artistic directions or requirements; the Mission Start Date; the Mission Period; and the applicable prizes.</li><li>You agree that the Mission Sponsor and/or PIXERF may make changes and amendments to the Mission Specific Rules and/or to the terms of this Agreement at any time, for whatever reason, and without any prior notice, and you agree to be bound by such changes and amendments.</li><li>All information requested by and supplied to PIXERF for the purpose of a Mission must be complete, up-to-date, accurate and not misleading. PIXERF reserves the right, in its sole discretion, to disqualify any Mission Participant at any time if they provide any incomplete, outdated, inaccurate or misleading details and/or information.</li><li><span class=\"text--bold text--color-black\">Removal of Mission Visual Content.</span> PIXERF reserves the right to remove or reject Mission Visual Content based on marketability, your failure or neglect to comply with the Mission Specific Rules or any other submission guidelines or procedures, or for any other reason whatsoever as determined by PIXERF in its sole and absolute discretion. Any licence for the Mission Visual Content which had been issued or granted by you prior to such removal or termination of this Agreement shall continue in effect. If PIXERF elects to remove or reject any such Mission Visual Content which is not already available in the Marketplace, this Mission Visual Content may be transferred by PIXERF in its discretion to the Marketplace through the Mission Participant’s account. Upon such transfer, the Transfer Terms set out in Clause 7.2 below shall apply.</li><li><span class=\"text--bold text--color-black\">Releases.</span> Mission Visual Content may be marked as for \"Editorial Use Only\" or for \"Commercial Use\". You may be required to submit model or property releases for your Mission Visual Content in order for it to be marked as for \"Commercial Use\", if the Mission Visual Content contains images of people or persons in relation to model releases, or if the Mission Visual Content contains identifiable property in relation to property releases (collectively, the \"Releases\"). The forms for these Releases can be downloaded from the particular Mission’s web page or from <a class=subscription-page-business-link ui-sref=introduction-support.releases>https://pixerf.com/#/introduction/support/releases</a>.</li></ol></li><li><span class=missions-agreement__sub-heading>Winning Submission(s) and Special Mention Submission(s)</span><ol><li><span class=\"text--bold text--color-black\">Selection</span>. After the Mission End Date, the Mission Sponsor and/or PIXERF shall select the Winning Submissions(s) and the Special Mention Submission(s) (if any) from the Mission Visual Content in accordance with the Mission Specific Rules (the “<span class=\"text--bold text--color-black\">Winning Submission(s)</span>” and the “<span class=\"text--bold text--color-black\">Special Mention Submission(s)</span>” respectively). The Mission Sponsor shall make its selections within 30 days from the Mission End Date. In the event that the Mission Sponsor fails to select the Winning Submission(s) within the 30-day period, PIXERF shall be entitled, but not obliged, to select the Winning Submission(s) within 7 days from the 30-day period. Upon selection by the Mission Sponsor and/or PIXERF (as the case may be), PIXERF shall notify the Mission Participant(s) who had submitted or uploaded the Winning Submission(s) or the Special Mention Submission(s) (if any) of the same through email at the email address provided to PIXERF.</li><li><span class=\"text--bold text--color-black\">Winning Prize(s)</span>. The Mission Participant(s) who had posted, uploaded or displayed the Mission Visual Content which is/are selected as the Winning Submission(s) shall be entitled to the prize (the “<span class=\"text--bold text--color-black\">Winning Prize(s)</span>”), the particulars of which shall be stipulated in the Mission Specific Rules. The Winning Prize(s) may be monetary, non-monetary or a combination of both. For the avoidance of doubt, the relevant provisions of the <a target=__blank ui-sref=explore-creators-page.creator-agreement class=subscription-page-business-link>Contributor Agreement</a> on compensation in respect of Missions submissions shall not apply to the Winning Submission(s).</li><li><span class=\"text--bold text--color-black\">Special Mention Prize(s)</span>. The Mission Participant(s) who had posted, uploaded or displayed the Mission Visual Content which is/are selected as the Special Mention Submission(s) (if any) shall be entitled to the monetary prize(s) (the “<span class=\"text--bold text--color-black\">Special Mention Prize</span>”) in accordance with the following rate schedule:<p></p><p>[*x per cent (x%)] of S$50.00 (being the licensing fee PIXERF will receive from the licensing of each of the Mission Participant(s)’s Special Mention Submission(s)) in relation to standard licences.</p><p>* [x%] refers to the applicable percentage as set out in the relevant provisions of the <a target=__blank ui-sref=explore-creators-page.creator-agreement class=subscription-page-business-link>Contributor Agreement</a> on compensation in respect of Missions submissions, which will be varied accordingly.</p></li><li>The Winning Prize(s) and the Special Mention Prize(s) (if any) are subject to the following conditions:<ol><li>such prize(s) must be accepted by the Mission Participant(s) without substitution, transfer, exchange or assignment;</li><li>the Mission Participant(s) shall be responsible for any and all costs and expenses which they may incur in the course of or arising from claiming or using such prize(s) or part thereof; and</li><li>the Mission Participant(s) agree and acknowledge that PIXERF may substitute such prize(s) or part thereof, for a replacement that PIXERF determines to be of equal or greater value if such prize(s) or part thereof cannot be awarded or delivered for any reason.</li></ol></li><li>Any award or payment to the Mission Participant(s) who posted, uploaded or displayed the Winning Submission(s) and/or the Special Mention Submission(s) (if any) shall be made in accordance with Clause 4.</li></ol></li><li><span class=missions-agreement__sub-heading>Prize Award</span><ol><li>The Mission Participant(s) who are entitled to Winning Prize(s) or Special Mention Prize(s), where such prize(s) or part thereof are monetary, shall, within two (2) weeks from the date of the email notification from PIXERF of such selection as set out in Clause 3.2, inform PIXERF of whether they elect to receive payment via PayPal, a cheque or wire transfer, and:<ol><li>if such Mission Participant(s) elects to receive payment through PayPal, the valid PayPal payment details to which PIXERF may transfer or remit the monetary prize(s) or part thereof; or</li><li>if such Mission Participant(s) elects to receive payment in a cheque or through wire transfer, all information necessary for PIXERF to make arrangements to effect such payment. If the Mission Participant elects to receive payment via cheque or wire transfer, they shall bear any applicable transaction fees or charges.</li></ol><p>PIXERF shall effect payment of the monetary prize(s) to the relevant Mission Participant(s) within thirty (30) days following the end of the reporting month during which the Mission Participant(s) informs PIXERF of the requested information above. The Mission Participant(s) acknowledges and agrees that PIXERF relies on them to provide the requested information above, and that PIXERF shall not be liable if they fail to notify PIXERF in accordance with this clause</p></li><li>Where the Winning Prize(s) or part thereof are non-monetary, PIXERF shall make arrangements for its collection and inform you accordingly. PIXERF shall have no obligations in respect of any non-monetary prize(s) which are not collected by the time and date specified by PIXERF.</li><li>Notwithstanding any provision to the contrary, PIXERF shall only be responsible for awarding or delivering the Winning Prize(s) and/or the Special Mention Prize(s) (as the case may be) to the Mission Participant(s) if PIXERF receives the same from the relevant Mission Sponsor by the applicable date. PIXERF shall not be liable to any person in the event that the Mission Sponsor fails and/or neglects to deliver or send the Winning Prize(s) and/or the Special Mention Prize(s) (as the case may be) to it.</li></ol></li><li><span class=missions-agreement__sub-heading>Grant of Rights</span><ol><li>Subject to this Agreement, you may grant PIXERF either an exclusive or a non-exclusive licence to license, sublicense, market and distribute the Mission Visual Content worldwide, and to copy, use, reproduce, distribute, publish, transmit, broadcast, perform, display, exhibit, adapt, modify, edit or enhance any Mission Visual Content, in whole or in part, alone or in combination with any other material, in any media or embodiment, now known or later developed, for any lawful purpose, including the right to distribute and sell consumer products (for example, by reproducing the Mission Visual Content on products sold to consumers including but not limited to posters, mugs, calendars, website templates, card templates).</li><li>PIXERF shall have complete and sole discretion regarding the terms, conditions and pricing of any Mission Visual Content that it sub-licenses to other Users without your prior approval.</li><li>If you elect to grant PIXERF an exclusive licence in relation to the Mission Visual Content, you agree to not license or distribute the Mission Visual Content to any other party until the exclusivity period expires. You may use any Mission Visual Content submitted for your own personal, non-commercial purposes, for example, your portfolio, personal website and self-promotion. However, you shall refer any licensing requests regarding the Mission Visual Content to PIXERF.</li><li>In addition to the foregoing, you grant PIXERF the right, but not the obligation, to use your name, trademarks and trade names, and the right to reproduce, display, transmit, exhibit, modify and adapt any Mission Visual Content to promote, market and advertise PIXERF or otherwise for PIXERF’s own business purposes in relation to the promotion of the Site; and you agree that no compensation or further consent will be required for such use.</li><li>In the event that you have elected to grant PIXERF an exclusive licence in relation to the Mission Visual Content, you thereby grant PIXERF the exclusive right, but not the obligation, to determine in its sole discretion whether and to what extent to proceed with any legal proceedings or action, and/or to defend any claims or counterclaims regarding the Mission Visual Content. Any such legal action or proceeding may be settled or resolved by PIXERF without your prior approval and will not be subject to it, provided that PIXERF shall not enter into any settlement or resolution which will diminish your ownership in the Mission Visual Content.</li><li>Where PIXERF has elected to commence any legal proceedings or actions, and/or to defend any claims or counterclaims regarding the Mission Visual Content, you agree to give PIXERF control of the handling, settlement, or defence of any such claims, and to provide assistance to PIXERF in relation to the legal proceedings or actions, including but not limited to providing PIXERF and our professional advisors with reasonable access to any relevant documents and records. You further agree to be named in and be joined in as a party to any such proceedings or actions in or defence of any legal claim.</li><li>Where PIXERF has elected not to commence any legal proceedings or actions, and/or to defend any claims or counterclaims regarding the Mission Visual Content, you retain the right to bring an action in your own name and at your own expense. You agree that any recovery you receive in your own legal action involving the Mission Visual Content, whether through settlement, adjudication or otherwise, shall be divided between you and PIXERF in accordance with the applicable percentages as set out in the relevant provisions of the <a target=__blank ui-sref=explore-creators-page.creator-agreement class=subscription-page-business-link>Contributor Agreement</a> on compensation after payment of all reasonable legal costs and expenses.</li></ol></li><li><span class=missions-agreement__sub-heading>Proprietary Rights</span><ol><li><span class=\"text--bold text--color-black\">Ownership</span>. You retain ownership of the copyright in the Mission Visual Content. While PIXERF will take commercially reasonable steps to ensure that your rights are not violated by other Users or other parties, PIXERF has no obligation to pursue any legal action regarding any alleged infringement of any rights in relation to any Mission Visual Content.</li><li><span class=\"text--bold text--color-black\">Credit</span>. While PIXERF will use commercially reasonable efforts to credit you as the source of the Mission Visual Content, you acknowledge that the Users may not credit you as the owner or author of the Mission Visual Content licensed by PIXERF, and that PIXERF may be associated with the Mission Visual Content as the source of such content, without any liability to PIXERF or the Users. You further acknowledge and agree that related metadata may be altered, removed or modified, without any liability to PIXERF or the Users.</li><li>You acknowledge that PIXERF prohibits any Mission Visual Content, descriptive information regarding such content or any other material that infringes on any patent, trademark, copyright, trade secret, right to privacy, right to publicity, or any other applicable law or proprietary right from being submitted or uploaded to the Site. By submitting or uploading Mission Visual Content, you are warranting that you own all ownership rights to the Mission Visual Content or are the authorised representative of the copyright owner(s) of such Mission Visual Content, with full power to grant the rights set out in this Agreement.</li></ol></li><li><span class=missions-agreement__sub-heading>Transfer of Mission Visual Content to Marketplace</span><ol><li>You agree that all Mission Visual Content will be transferred by PIXERF to the Marketplace in accordance with the Transfer Terms by either (i) the date following thirty-seven (37) days after the Mission End Date or (ii) date following when the Winning Submission(s) and Special Mention Submission(s) (if any) are selected, whichever is earlier, save for the Winning Submission(s) which will be transferred by the date following sixty (60) days after the Mission End Date.</li><li>The terms contained in this clause govern the transfer of the Mission Visual Content to the Marketplace (the <span class=\"text--bold text--color-black\">“Transfer Terms</span>”). You agree that:<ol><li>(a) upon such transfer, the <a target=__blank ui-sref=explore-creators-page.creator-agreement class=subscription-page-business-link>Contributor Agreement</a> shall apply to such transferred Mission Visual Content as though you had posted, uploaded, displayed or otherwise made available on or through the Marketplace such transferred Mission Visual Content; and</li><li>(b) upon such transfer and in relation to such transferred Mission Visual Content, the terms of the <a target=__blank ui-sref=explore-creators-page.creator-agreement class=subscription-page-business-link>Contributor Agreement</a> shall take precedence in the event of any conflict or inconsistency between the terms of the <a target=__blank ui-sref=explore-creators-page.creator-agreement class=subscription-page-business-link>Contributor Agreement</a> and the terms of this Agreement, the <a target=__blank ui-sref=introduction-company.terms class=subscription-page-business-link>Terms and Conditions</a> or the <a target=__blank ui-sref=introduction-company.privacy class=subscription-page-business-link>Privacy Policy</a>.</li></ol></li></ol></li><li><span class=missions-agreement__sub-heading>Taxes</span><ol><li>You shall pay all applicable goods and services tax, duties or levies whatsoever at the rate which may from time to time be imposed or charged at any time by any government, statutory or tax authority on or calculated by reference to the amount of any sums payable by you hereunder or to reimburse us for the payment of such taxes, duties or levies immediately on receipt of written notice from us.</li><li>If PIXERF shall at any time be compelled by any applicable law to withhold or deduct any tax on your behalf from any amount payable to you hereunder, we shall, when making payment to you, make payment of such tax at the applicable rate to the appropriate tax authority and shall furnish to you written receipts from the appropriate tax authority certifying that such payments have been made.</li></ol></li><li><span class=missions-agreement__sub-heading>Term and Termination</span><ol><li>This Agreement continues in effect until it is terminated by you or by PIXERF as set out in these terms. You may terminate this Agreement by giving seven (7) days’ written notice to PIXERF prior to the Mission End Date. PIXERF may terminate this Agreement immediately by giving written notice to you. Either party may terminate this Agreement immediately by giving written notice if the other party breaches or fails to comply with any of the terms of this Agreement, makes an assignment for the benefit of its creditors, becomes insolvent, or is subject to bankruptcy or liquidation proceedings.</li><li>If you had terminated this Agreement in accordance with Clause 9.1, you have the right but not the obligation to remove from the Mission any of your Mission Visual Content which you had submitted or uploaded. However, such removal does not mean that it will be removed from the Marketplace.</li><li>If PIXERF had terminated this Agreement in accordance with Clause 9.1, PIXERF has the right to remove any of your Mission Visual Content at any time and from time to time after such termination.</li><li>If this Agreement is terminated, whether by you or PIXERF and for whatever reason,<ol><li>PIXERF may retain digital copies of the Mission Visual Content for PIXERF’s records; and</li><li>PIXERF will not be obliged to select any of your Mission Visual Content as the Winning Submission(s) or Special Mention Submission(s) (if applicable) and, accordingly, will not be obliged to award or deliver any Winning Prize(s) or Special Mention Prize(s) to you as set out in Clauses 3 and 4 above.</li></ol></li><li>Notwithstanding the provisions herein, any licence for the Mission Visual Content which had been issued or granted by you prior to any termination of this Agreement shall continue in effect.</li></ol></li><li><span class=missions-agreement__sub-heading>Your Representations and Warranties</span><ol><li>You represent and warrant to PIXERF as follows:<ol><li>you have the full right and authority to execute and perform your obligations in accordance with the terms of this Agreement;</li><li>if you are an individual, that you are at least 18 years old, and have the full power and authority to enter into this Agreement and perform your obligations hereunder;</li><li>you are the sole and exclusive owner, including copyright, of any Mission Visual Content submitted or uploaded, or are the authorised representative of the applicable copyright owner(s) of the Mission Visual Content, with full power to grant the rights set out in this Agreement</li><li>you have not granted any rights or interests in any Mission Visual Content to any third party that is contrary to any of the rights or interests granted to PIXERF under this Agreement;</li><li>you will not submit or upload any Mission Visual Content that:<ol><li>is defamatory, profane, inappropriate, indecent, obscene or pornographic;</li><li>infringes, violates or misappropriates any third party copyrights, trademarks, rights of privacy or publicity, or any applicable law, rule or regulation;</li></ol></li><li>any descriptions, keywords, metadata, copyright management information or other information or documents (such as Releases) submitted with the Mission Visual Content is timely, accurate and complete, does not contain false or misleading information, and complies with PIXERF\'s applicable submission guidelines or policies;</li><li>you have obtained valid and binding model and/or property releases for each Mission Visual Content where necessary or required by applicable law, and that PIXERF may use such Mission Visual Content without obtaining any further consents or making payment of any additional fees to any third parties;</li><li>you acknowledge and agree that the creator or source of the Mission Visual Content may not be credited by other Users, and that the Mission Visual Content may be modified, adapted and/or used in connection with sensitive, unflattering or controversial subject matters, materials or contexts;</li><li>you will not use the Site for the purposes of conducting and/or disseminating surveys, contests, pyramid schemes, chain letters, junk email, spamming or sending of any duplicative or unsolicited messages; and</li><li>you will not transmit, submit or upload any files that contain viruses, Trojan horses, time bombs, spyware, adware, or other malicious, invasive or deleterious code or programme.</li></ol></li></ol></li><li><span class=missions-agreement__sub-heading>Disclaimer of Warranties</span><ol><li>The Mission(s), including any content, services, Winning Prize(s) or Special Mention Prize(s) provided in relation thereto, are provided on an \"as is\", \"as available\" basis, without representation, warranty or condition of any kind, implied, express or statutory, including but not limited to the representations or warranties of non-infringement of third party rights, title, merchantability, satisfactory quality and/or fitness for a particular purpose. In particular, PIXERF does not represent or warrant the transmission, accuracy, completeness, timeliness or adequacy of the Mission(s), or that it would be provided uninterrupted or error free.</li></ol></li><li><span class=missions-agreement__sub-heading>Indemnity</span><ol><li>You agree to indemnify, defend and hold PIXERF, our officers, directors, shareholders, predecessors, successors in interest, employees, agents, subsidiaries and affiliates, harmless from all demands, claims, actions, proceedings, judgements, orders, decrees, damages, costs, losses and expenses of any nature whatsoever (including but not limited to legal costs on an indemnity basis) against us by any third party due to or arising out of or in connection with any breach or alleged breach or failure by you (or anyone acting on your behalf) to comply with any representation or warranty or other term of this Agreement. You agree that PIXERF may retain any amounts due to you in the event that PIXERF is owed any sum under this clause</li><li>Your obligations under the foregoing indemnity may not be offset against any other claim that you may have against PIXERF, or any of our officers, directors, employees, agents, subsidiaries and affiliates. You agree that these indemnity obligations shall survive any termination of your user account on the Site.</li></ol></li><li><span class=missions-agreement__sub-heading>Disclaimer of Liability</span><ol><li>Notwithstanding any other provision in this Agreement, PIXERF shall not be liable to you or any other person or entity for any punitive, special, indirect, consequential, incidental or other similar damages, costs or losses arising out of this Agreement, its termination or expiration. Some jurisdictions do not permit the exclusion or limitation of implied warranties or liability.</li></ol></li><li><span class=missions-agreement__sub-heading>General</span><ol><li><span class=\"text--bold text--color-black\">Notices</span>. All notices required to be sent to PIXERF under this Agreement shall be sent via email to notify@pixerf.com. All notices required to be sent to you by PIXERF under this Agreement shall be sent via email to the email address set out in your user account.</li><li><span class=\"text--bold text--color-black\">Severability</span>. The illegality, invalidity or unenforceability of any provision of this Agreement under the law of any jurisdiction shall not affect its legality, validity or enforceability under the law of any other jurisdiction nor the legality, validity or enforceability of any other provision.</li><li><span class=\"text--bold text--color-black\">No Waiver</span>. No failure on the part of any party to exercise, and no delay on its part in exercising, any right or remedy under this Agreement will operate as a waiver thereof, nor will any single or partial exercise of any right or remedy preclude any other or further exercise thereof or the exercise of any other right or remedy. The rights and remedies provided in this Agreement are cumulative and not exclusive of any rights or remedies provided by law.</li></ol></li><li><span class=missions-agreement__sub-heading>Governing Law</span><ol><li>This Agreement shall be construed and its performance governed in accordance with the law of the Republic of Singapore.</li></ol></li><p>The last update to our Mission Agreement was posted on 27th March 2018.</p></ol></div></div><div class=missions-agreement__content-right></div></section></div>");
$templateCache.put("app/mission-detail-page/components/visual-inspiration/visual-inspiration.html","<section class=visual-inspiration><div class=brief__visual-inspiration ng-if=\"vm.parent.mission.media && vm.parent.mission.media.length > 0\"><div ng-if=\"vm.bidingItems.length > 0 && vm.parent.mission.is_multi_frame\"><div class=visual-inspiration__group-by-frame ng-repeat=\"item in vm.bidingItems\"><h3 class=visual-inspiration__group-by-frame__title data-toggle=collapse data-target=#group-by-{{$index}}>{{item.data[0].title}}</h3><div id=group-by-{{$index}} class=\"collapse in\"><div flex-grid ng-model=item margins=3 rowheight=50 lastrow=justify><div class=visual-inspiration__group-by-frame__media ng-repeat=\"photo in item.data\"><img ng-src=\"{{photo.thumbnails[\'x400\']}}\" alt=\"\"></div></div></div></div></div><div ng-if=\"vm.parent.mission.media.length > 0 && !vm.parent.mission.is_multi_frame\"><div flex-grid ng-model=vm.parent.mission margins=3 rowheight=200><div class=visual-inspiration__group-by-frame__media ng-repeat=\"photo in vm.parent.mission.media\"><img ng-src=\"{{photo.thumbnails[\'x400\']}}\" alt=\"\"></div></div></div></div><div class=\"mission-detail-page__footer clearfix\"><div class=\"mission-detail-page__footer__title text--extrabold\" translate>{{\'crowdsource-business-banner\'}}</div><div class=mission-detail-page__footer__description><div translate>{{\'crowdsource-business-description-1\'}}</div><div translate>{{\'crowdsource-business-description-2\'}}</div></div><button class=\"mission-detail-page__footer__btn text--bold btn btn--white-magento\" ui-sref=run-a-challenge-page.live-challenges>{{\'find-out-how\' | translate}}</button></div></section>");
$templateCache.put("app/mission/components/mission-agreement-gojek/mission-agreement.html","<div class=\"terms-page no-margin missions-agreement\"><section class=\"row missions-agreement__wrapper\"><div class=missions-agreement__content-left><p class=missions-agreement__heading>Missions Agreement</p><div class=missions-agreement__main-content><p>This Missions Agreement (the \"<u class=\"text--bold text--color-black\">Agreement</u>\") between you (the \"<u class=\"text--bold text--color-black\">you</u>\", \"<u class=\"text--bold text--color-black\">your</u>\" or the \"<u class=\"text--bold text--color-black\">Mission Participant</u>\") and PIXERF PTE LTD \"<u>PIXERF</u>\" sets forth the terms and conditions that apply when you submit or upload any Mission Visual Content (as defined below) for the purposes of participating in a Mission (as defined below).</p><p>Please review this Agreement carefully before submitting or uploading any Mission Visual Content. By either submitting or uploading any Mission Visual Content, you agree to be bound by the terms of this Agreement, the <a ui-sref=explore-creators-page.creator-agreement target=__blank class=subscription-page-business-link>Contributor Agreement</a>, the <a target=__blank ui-sref=introduction-company.terms class=subscription-page-business-link>Terms and Conditions</a> and the <a target=__blank ui-sref=introduction-company.privacy class=subscription-page-business-link>Privacy Policy</a>. If you do not agree to any of these terms, please do not submit or upload any Mission Visual Content.</p><p>The Missions are not sponsored by, associated with or connected to Apple or Google in any manner.</p><ol><li><span class=missions-agreement__sub-heading>Interpretation and Definitions</span><ol><li>In this Agreement, unless the context otherwise requires, the following words or expressions shall have the following meanings:</li><table class=missions-agreement__table><tr><th>“<span class=\"text--bold text--color-black\">Mission</span>”</th><td>means an event organised by PIXERF on or through PIXERF’s platform at www.pixerf.com for the Mission Sponsor to crowdsourced Mission Visual Content in accordance with the specified requirements;</td></tr><tr><th>“<span class=\"text--bold text--color-black\">Mission Period</span>”</th><td>means, in relation to a particular Mission, the period of time during which you may submit or upload Mission Visual Content for that Mission;</td></tr><tr><th>“<span class=\"text--bold text--color-black\">Mission End Date</span>”</th><td>means, in relation to a particular Mission, the date on which the relevant Mission Period ends;</td></tr><tr><th>“<span class=\"text--bold text--color-black\">Mission Specific Rules</span>”</th><td>refers to the specific terms and conditions that are applicable to a particular Mission;</td></tr><tr><th>“<span class=\"text--bold text--color-black\">Mission Sponsor</span>”</th><td>means, in relation to a particular Mission, either PIXERF or the third party who commissioned the Mission (as the case may be);</td></tr><tr><th>“<span class=\"text--bold text--color-black\">Mission Start Date</span>”</th><td>means, in relation to a particular Mission, the date on which the relevant Mission Period begins; and</td></tr><tr><th>“<span class=\"text--bold text--color-black\">Mission Visual Content</span>”</th><td>means the content, including photographs, illustrations, vector graphics and videos, which you post, upload, display or otherwise make available for the purposes of participating in a Mission.</td></tr></table><li>In the event of any inconsistency or conflict between the provisions of this Agreement and any of the provisions of the <a target=__blank ui-sref=explore-creators-page.creator-agreement class=subscription-page-business-link>Contributor Agreement</a>, the <a target=__blank ui-sref=introduction-company.terms class=subscription-page-business-link>Terms and Conditions</a> or the<a target=__blank ui-sref=introduction-company.privacy class=subscription-page-business-link>Privacy Policy</a>, the provisions of this Agreement shall prevail.</li><li>Unless otherwise defined in this Agreement, the terms used herein shall bear the same meanings as in the <a target=__blank ui-sref=introduction-company.terms class=subscription-page-business-link>Terms and Conditions</a>.</li></ol></li><li><span class=missions-agreement__sub-heading>Submission of Mission Visual Content</span><ol><li>PIXERF may determine at its sole discretion which Mission Visual Content is deemed suitable for submission or upload by you. PIXERF may provide submission guidelines and procedures for the Mission Visual Content, which may be revised from time to time, and you agree to comply with such submission guidelines and procedures (including any revisions thereto) by submitting or uploading any Mission Visual Content. Any breach of these guidelines and procedures may be deemed to be a breach of this Agreement in PIXERF’s sole discretion.</li><li><span class=\"text--bold text--color-black\">Mission Specific Rules.</span> Each Mission Visual Content which you submit or upload will be subject to the Mission Specific Rules, which may include, but is not limited to, eligibility and participation requirements; artistic directions or requirements; the Mission Start Date; the Mission Period; and the applicable prizes.</li><li>You agree that the Mission Sponsor and/or PIXERF may make changes and amendments to the Mission Specific Rules and/or to the terms of this Agreement at any time, for whatever reason, and without any prior notice, and you agree to be bound by such changes and amendments.</li><li>All information requested by and supplied to PIXERF for the purpose of a Mission must be complete, up-to-date, accurate and not misleading. PIXERF reserves the right, in its sole discretion, to disqualify any Mission Participant at any time if they provide any incomplete, outdated, inaccurate or misleading details and/or information.</li><li><span class=\"text--bold text--color-black\">Removal of Mission Visual Content.</span> PIXERF reserves the right to remove or reject Mission Visual Content based on marketability, your failure or neglect to comply with the Mission Specific Rules or any other submission guidelines or procedures, or for any other reason whatsoever as determined by PIXERF in its sole and absolute discretion. Any licence for the Mission Visual Content which had been issued or granted by you prior to such removal or termination of this Agreement shall continue in effect. If PIXERF elects to remove or reject any such Mission Visual Content which is not already available in the Marketplace, this Mission Visual Content may be transferred by PIXERF in its discretion to the Marketplace through the Mission Participant’s account. Upon such transfer, the Transfer Terms set out in Clause 7.2 below shall apply.</li><li><span class=\"text--bold text--color-black\">Releases.</span> Mission Visual Content may be marked as for \"Editorial Use Only\" or for \"Commercial Use\". You may be required to submit model or property releases for your Mission Visual Content in order for it to be marked as for \"Commercial Use\", if the Mission Visual Content contains images of people or persons in relation to model releases, or if the Mission Visual Content contains identifiable property in relation to property releases (collectively, the \"Releases\"). The forms for these Releases can be downloaded from the particular Mission’s web page or from <a class=subscription-page-business-link ui-sref=introduction-support.releases>https://pixerf.com/#/introduction/support/releases</a>.</li></ol></li><li><span class=missions-agreement__sub-heading>Winning Submission(s) and Special Mention Submission(s)</span><ol><li><span class=\"text--bold text--color-black\">Selection</span>. After the Mission End Date, the Mission Sponsor, PIXERF and PIXERF’s external panel of judges shall select the Winning Submissions(s) and the Special Mention Submission(s) (if any) from the Mission Visual Content in accordance with the Mission Specific Rules (the “<span class=\"text--bold text--color-black\">Winning Submission(s)</span>” and the “<span class=\"text--bold text--color-black\">Special Mention Submission(s)</span>” respectively). The Mission Sponsor shall make its selections within 1 day from the Mission End Date. In the event that the Mission Sponsor fails to select the Winning Submission(s) within the 1-day period, PIXERF shall be entitled, but not obliged, to select the Winning Submission(s) within 1 day from the 1-day period. Upon selection by the Mission Sponsor, PIXERF and PIXERF’s external panel of judges, PIXERF shall notify the Mission Participant(s) who had submitted or uploaded the Winning Submission(s) or the Special Mention Submission(s) (if any) of the same through email at the email address provided to PIXERF.</li><li><span class=\"text--bold text--color-black\">Winning Prize(s)</span>. The Mission Participant(s) who had posted, uploaded or displayed the Mission Visual Content which is/are selected as the Winning Submission(s) shall be entitled to the prize (the “<span class=\"text--bold text--color-black\">Winning Prize(s)</span>”), the particulars of which shall be stipulated in the Mission Specific Rules. The Winning Prize(s) may be monetary, non-monetary or a combination of both. For the avoidance of doubt, the relevant provisions of the <a target=__blank ui-sref=explore-creators-page.creator-agreement class=subscription-page-business-link>Contributor Agreement</a> on compensation in respect of Missions submissions shall not apply to the Winning Submission(s).</li><li><span class=\"text--bold text--color-black\">Special Mention Prize(s)</span>. The Mission Participant(s) who had posted, uploaded or displayed the Mission Visual Content which is/are selected as the Special Mention Submission(s) (if any) shall be entitled to the monetary prize(s) (the “<span class=\"text--bold text--color-black\">Special Mention Prize</span>”) in accordance with the following rate schedule:<p></p><p>[*x per cent (x%)] of S$50.00 (being the licensing fee PIXERF will receive from the licensing of each of the Mission Participant(s)’s Special Mention Submission(s)) in relation to standard licences.</p><p>* [x%] refers to the applicable percentage as set out in the relevant provisions of the <a target=__blank ui-sref=explore-creators-page.creator-agreement class=subscription-page-business-link>Contributor Agreement</a> on compensation in respect of Missions submissions, which will be varied accordingly.</p></li><li>The Winning Prize(s) and the Special Mention Prize(s) (if any) are subject to the following conditions:<ol><li>such prize(s) must be accepted by the Mission Participant(s) without substitution, transfer, exchange or assignment;</li><li>the Mission Participant(s) shall be responsible for any and all costs and expenses which they may incur in the course of or arising from claiming or using such prize(s) or part thereof; and</li><li>the Mission Participant(s) agree and acknowledge that PIXERF may substitute such prize(s) or part thereof, for a replacement that PIXERF determines to be of equal or greater value if such prize(s) or part thereof cannot be awarded or delivered for any reason.</li></ol></li><li>Any award or payment to the Mission Participant(s) who posted, uploaded or displayed the Winning Submission(s) and/or the Special Mention Submission(s) (if any) shall be made in accordance with Clause 4.</li></ol></li><li><span class=missions-agreement__sub-heading>Prize Award</span><ol><li>The Mission Participant(s) who are entitled to Winning Prize(s) or Special Mention Prize(s), where such prize(s) or part thereof are monetary, shall, within two (2) weeks from the date of the email notification from PIXERF of such selection as set out in Clause 3.2, inform PIXERF of whether they elect to receive payment via PayPal, a cheque or wire transfer, and:<ol><li>if such Mission Participant(s) elects to receive payment through PayPal, the valid PayPal payment details to which PIXERF may transfer or remit the monetary prize(s) or part thereof; or</li><li>if such Mission Participant(s) elects to receive payment in a cheque or through wire transfer, all information necessary for PIXERF to make arrangements to effect such payment. If the Mission Participant elects to receive payment via cheque or wire transfer, they shall bear any applicable transaction fees or charges.</li></ol><p>PIXERF shall effect payment of the monetary prize(s) to the relevant Mission Participant(s) within thirty (30) days following the end of the reporting month during which the Mission Participant(s) informs PIXERF of the requested information above. The Mission Participant(s) acknowledges and agrees that PIXERF relies on them to provide the requested information above, and that PIXERF shall not be liable if they fail to notify PIXERF in accordance with this clause</p></li><li>Where the Winning Prize(s) or part thereof are non-monetary, PIXERF shall make arrangements for its collection and inform you accordingly. PIXERF shall have no obligations in respect of any non-monetary prize(s) which are not collected by the time and date specified by PIXERF.</li><li>Notwithstanding any provision to the contrary, PIXERF shall only be responsible for awarding or delivering the Winning Prize(s) and/or the Special Mention Prize(s) (as the case may be) to the Mission Participant(s) if PIXERF receives the same from the relevant Mission Sponsor by the applicable date. PIXERF shall not be liable to any person in the event that the Mission Sponsor fails and/or neglects to deliver or send the Winning Prize(s) and/or the Special Mention Prize(s) (as the case may be) to it.</li></ol></li><li><span class=missions-agreement__sub-heading>Grant of Rights</span><ol><li>Subject to this Agreement, you may grant PIXERF either an exclusive or a non-exclusive licence to license, sublicense, market and distribute the Mission Visual Content worldwide, and to copy, use, reproduce, distribute, publish, transmit, broadcast, perform, display, exhibit, adapt, modify, edit or enhance any Mission Visual Content, in whole or in part, alone or in combination with any other material, in any media or embodiment, now known or later developed, for any lawful purpose, including the right to distribute and sell consumer products (for example, by reproducing the Mission Visual Content on products sold to consumers including but not limited to posters, mugs, calendars, website templates, card templates).</li><li>PIXERF shall have complete and sole discretion regarding the terms, conditions and pricing of any Mission Visual Content that it sub-licenses to other Users without your prior approval.</li><li>You grant the Mission Sponsor and exclusive license in relation to the Mission Visual Content for one (1) year from the Mission End Date. You agree to not license or distribute the Mission Visual Content to any other party until the exclusivity period expires. You may use ay Mission Visual Content submitted for your own personal, non-commercial purposes, for example, your portfolio, personal website and self-promotion. However, you shall refer any licensing requests regarding the Mission Visual Content to PIXERF.</li><li>In addition to the foregoing, you grant PIXERF the right, but not the obligation, to use your name, trademarks and trade names, and the right to reproduce, display, transmit, exhibit, modify and adapt any Mission Visual Content to promote, market and advertise PIXERF or otherwise for PIXERF’s own business purposes in relation to the promotion of the Site; and you agree that no compensation or further consent will be required for such use.</li><li>In the event that you have elected to grant PIXERF an exclusive licence in relation to the Mission Visual Content, you thereby grant PIXERF the exclusive right, but not the obligation, to determine in its sole discretion whether and to what extent to proceed with any legal proceedings or action, and/or to defend any claims or counterclaims regarding the Mission Visual Content. Any such legal action or proceeding may be settled or resolved by PIXERF without your prior approval and will not be subject to it, provided that PIXERF shall not enter into any settlement or resolution which will diminish your ownership in the Mission Visual Content.</li><li>Where PIXERF has elected to commence any legal proceedings or actions, and/or to defend any claims or counterclaims regarding the Mission Visual Content, you agree to give PIXERF control of the handling, settlement, or defence of any such claims, and to provide assistance to PIXERF in relation to the legal proceedings or actions, including but not limited to providing PIXERF and our professional advisors with reasonable access to any relevant documents and records. You further agree to be named in and be joined in as a party to any such proceedings or actions in or defence of any legal claim.</li><li>Where PIXERF has elected not to commence any legal proceedings or actions, and/or to defend any claims or counterclaims regarding the Mission Visual Content, you retain the right to bring an action in your own name and at your own expense. You agree that any recovery you receive in your own legal action involving the Mission Visual Content, whether through settlement, adjudication or otherwise, shall be divided between you and PIXERF in accordance with the applicable percentages as set out in the relevant provisions of the <a target=__blank ui-sref=explore-creators-page.creator-agreement class=subscription-page-business-link>Contributor Agreement</a> on compensation after payment of all reasonable legal costs and expenses.</li></ol></li><li><span class=missions-agreement__sub-heading>Proprietary Rights</span><ol><li><span class=\"text--bold text--color-black\">Ownership</span>. You retain ownership of the copyright in the Mission Visual Content. While PIXERF will take commercially reasonable steps to ensure that your rights are not violated by other Users or other parties, PIXERF has no obligation to pursue any legal action regarding any alleged infringement of any rights in relation to any Mission Visual Content.</li><li><span class=\"text--bold text--color-black\">Credit</span>. While PIXERF will use commercially reasonable efforts to credit you as the source of the Mission Visual Content, you acknowledge that the Users may not credit you as the owner or author of the Mission Visual Content licensed by PIXERF, and that PIXERF may be associated with the Mission Visual Content as the source of such content, without any liability to PIXERF or the Users. You further acknowledge and agree that related metadata may be altered, removed or modified, without any liability to PIXERF or the Users.</li><li>You acknowledge that PIXERF prohibits any Mission Visual Content, descriptive information regarding such content or any other material that infringes on any patent, trademark, copyright, trade secret, right to privacy, right to publicity, or any other applicable law or proprietary right from being submitted or uploaded to the Site. By submitting or uploading Mission Visual Content, you are warranting that you own all ownership rights to the Mission Visual Content or are the authorised representative of the copyright owner(s) of such Mission Visual Content, with full power to grant the rights set out in this Agreement.</li></ol></li><li><span class=missions-agreement__sub-heading>Transfer of Mission Visual Content to Marketplace</span><ol><li>You agree that all Mission Visual Content will be transferred by PIXERF to the Marketplace in accordance with the Transfer Terms by the date following one (1) year after the Winning Submission(s) and Special Mention Submission(s) (if any) are selected.</li><li>The terms contained in this clause govern the transfer of the Mission Visual Content to the Marketplace (the <span class=\"text--bold text--color-black\">“Transfer Terms</span>”). You agree that:<ol><li>(a) upon such transfer, the <a target=__blank ui-sref=explore-creators-page.creator-agreement class=subscription-page-business-link>Contributor Agreement</a> shall apply to such transferred Mission Visual Content as though you had posted, uploaded, displayed or otherwise made available on or through the Marketplace such transferred Mission Visual Content; and</li><li>(b) upon such transfer and in relation to such transferred Mission Visual Content, the terms of the <a target=__blank ui-sref=explore-creators-page.creator-agreement class=subscription-page-business-link>Contributor Agreement</a> shall take precedence in the event of any conflict or inconsistency between the terms of the <a target=__blank ui-sref=explore-creators-page.creator-agreement class=subscription-page-business-link>Contributor Agreement</a> and the terms of this Agreement, the <a target=__blank ui-sref=introduction-company.terms class=subscription-page-business-link>Terms and Conditions</a> or the <a target=__blank ui-sref=introduction-company.privacy class=subscription-page-business-link>Privacy Policy</a>.</li></ol></li></ol></li><li><span class=missions-agreement__sub-heading>Taxes</span><ol><li>You shall pay all applicable goods and services tax, duties or levies whatsoever at the rate which may from time to time be imposed or charged at any time by any government, statutory or tax authority on or calculated by reference to the amount of any sums payable by you hereunder or to reimburse us for the payment of such taxes, duties or levies immediately on receipt of written notice from us.</li><li>If PIXERF shall at any time be compelled by any applicable law to withhold or deduct any tax on your behalf from any amount payable to you hereunder, we shall, when making payment to you, make payment of such tax at the applicable rate to the appropriate tax authority and shall furnish to you written receipts from the appropriate tax authority certifying that such payments have been made.</li></ol></li><li><span class=missions-agreement__sub-heading>Term and Termination</span><ol><li>This Agreement continues in effect until it is terminated by you or by PIXERF as set out in these terms. You may terminate this Agreement by giving seven (7) days’ written notice to PIXERF prior to the Mission End Date. PIXERF may terminate this Agreement immediately by giving written notice to you. Either party may terminate this Agreement immediately by giving written notice if the other party breaches or fails to comply with any of the terms of this Agreement, makes an assignment for the benefit of its creditors, becomes insolvent, or is subject to bankruptcy or liquidation proceedings.</li><li>If you had terminated this Agreement in accordance with Clause 9.1, you have the right but not the obligation to remove from the Mission any of your Mission Visual Content which you had submitted or uploaded. However, such removal does not mean that it will be removed from the Marketplace.</li><li>If PIXERF had terminated this Agreement in accordance with Clause 9.1, PIXERF has the right to remove any of your Mission Visual Content at any time and from time to time after such termination.</li><li>If this Agreement is terminated, whether by you or PIXERF and for whatever reason,<ol><li>PIXERF may retain digital copies of the Mission Visual Content for PIXERF’s records; and</li><li>PIXERF will not be obliged to select any of your Mission Visual Content as the Winning Submission(s) or Special Mention Submission(s) (if applicable) and, accordingly, will not be obliged to award or deliver any Winning Prize(s) or Special Mention Prize(s) to you as set out in Clauses 3 and 4 above.</li></ol></li><li>Notwithstanding the provisions herein, any licence for the Mission Visual Content which had been issued or granted by you prior to any termination of this Agreement shall continue in effect.</li></ol></li><li><span class=missions-agreement__sub-heading>Your Representations and Warranties</span><ol><li>You represent and warrant to PIXERF as follows:<ol><li>you have the full right and authority to execute and perform your obligations in accordance with the terms of this Agreement;</li><li>if you are an individual, that you are at least 18 years old, and have the full power and authority to enter into this Agreement and perform your obligations hereunder;</li><li>you are the sole and exclusive owner, including copyright, of any Mission Visual Content submitted or uploaded, or are the authorised representative of the applicable copyright owner(s) of the Mission Visual Content, with full power to grant the rights set out in this Agreement</li><li>you have not granted any rights or interests in any Mission Visual Content to any third party that is contrary to any of the rights or interests granted to PIXERF under this Agreement;</li><li>you will not submit or upload any Mission Visual Content that:<ol><li>is defamatory, profane, inappropriate, indecent, obscene or pornographic;</li><li>infringes, violates or misappropriates any third party copyrights, trademarks, rights of privacy or publicity, or any applicable law, rule or regulation;</li></ol></li><li>any descriptions, keywords, metadata, copyright management information or other information or documents (such as Releases) submitted with the Mission Visual Content is timely, accurate and complete, does not contain false or misleading information, and complies with PIXERF\'s applicable submission guidelines or policies;</li><li>you have obtained valid and binding model and/or property releases for each Mission Visual Content where necessary or required by applicable law, and that PIXERF may use such Mission Visual Content without obtaining any further consents or making payment of any additional fees to any third parties;</li><li>you acknowledge and agree that the creator or source of the Mission Visual Content may not be credited by other Users, and that the Mission Visual Content may be modified, adapted and/or used in connection with sensitive, unflattering or controversial subject matters, materials or contexts;</li><li>you will not use the Site for the purposes of conducting and/or disseminating surveys, contests, pyramid schemes, chain letters, junk email, spamming or sending of any duplicative or unsolicited messages; and</li><li>you will not transmit, submit or upload any files that contain viruses, Trojan horses, time bombs, spyware, adware, or other malicious, invasive or deleterious code or programme.</li></ol></li></ol></li><li><span class=missions-agreement__sub-heading>Disclaimer of Warranties</span><ol><li>The Mission(s), including any content, services, Winning Prize(s) or Special Mention Prize(s) provided in relation thereto, are provided on an \"as is\", \"as available\" basis, without representation, warranty or condition of any kind, implied, express or statutory, including but not limited to the representations or warranties of non-infringement of third party rights, title, merchantability, satisfactory quality and/or fitness for a particular purpose. In particular, PIXERF does not represent or warrant the transmission, accuracy, completeness, timeliness or adequacy of the Mission(s), or that it would be provided uninterrupted or error free.</li></ol></li><li><span class=missions-agreement__sub-heading>Indemnity</span><ol><li>You agree to indemnify, defend and hold PIXERF, our officers, directors, shareholders, predecessors, successors in interest, employees, agents, subsidiaries and affiliates, harmless from all demands, claims, actions, proceedings, judgements, orders, decrees, damages, costs, losses and expenses of any nature whatsoever (including but not limited to legal costs on an indemnity basis) against us by any third party due to or arising out of or in connection with any breach or alleged breach or failure by you (or anyone acting on your behalf) to comply with any representation or warranty or other term of this Agreement. You agree that PIXERF may retain any amounts due to you in the event that PIXERF is owed any sum under this clause</li><li>Your obligations under the foregoing indemnity may not be offset against any other claim that you may have against PIXERF, or any of our officers, directors, employees, agents, subsidiaries and affiliates. You agree that these indemnity obligations shall survive any termination of your user account on the Site.</li></ol></li><li><span class=missions-agreement__sub-heading>Disclaimer of Liability</span><ol><li>Notwithstanding any other provision in this Agreement, PIXERF shall not be liable to you or any other person or entity for any punitive, special, indirect, consequential, incidental or other similar damages, costs or losses arising out of this Agreement, its termination or expiration. Some jurisdictions do not permit the exclusion or limitation of implied warranties or liability.</li></ol></li><li><span class=missions-agreement__sub-heading>General</span><ol><li><span class=\"text--bold text--color-black\">Notices</span>. All notices required to be sent to PIXERF under this Agreement shall be sent via email to notify@pixerf.com. All notices required to be sent to you by PIXERF under this Agreement shall be sent via email to the email address set out in your user account.</li><li><span class=\"text--bold text--color-black\">Severability</span>. The illegality, invalidity or unenforceability of any provision of this Agreement under the law of any jurisdiction shall not affect its legality, validity or enforceability under the law of any other jurisdiction nor the legality, validity or enforceability of any other provision.</li><li><span class=\"text--bold text--color-black\">No Waiver</span>. No failure on the part of any party to exercise, and no delay on its part in exercising, any right or remedy under this Agreement will operate as a waiver thereof, nor will any single or partial exercise of any right or remedy preclude any other or further exercise thereof or the exercise of any other right or remedy. The rights and remedies provided in this Agreement are cumulative and not exclusive of any rights or remedies provided by law.</li></ol></li><li><span class=missions-agreement__sub-heading>Governing Law</span><ol><li>This Agreement shall be construed and its performance governed in accordance with the law of the Republic of Singapore.</li></ol></li><p>The last update to our Mission Agreement was posted on 16 August 2019.</p></ol></div></div><div class=missions-agreement__content-right></div></section></div>");
$templateCache.put("app/mission/components/mission-closed/mission-closed.html","<div class=\"mission-closed-page no-margin\"><div class=mission-closed-page__wrapper><section class=\"row mission-closed-page__main-content\"><div class=\"mission-closed-page__main-content__title text--extrabold text--color-black\" translate>{{\'closed-missions\'}}</div><div class=mission-closed-page__main-content__description ng-show=\"vm.missions.length > 0\"><div ng-if=!vm.isMyMission translate>{{\'closed-missions-winning\'}}</div><div ng-if=vm.isMyMission>Review all completed Challenges here. Check out all the submissions and select Challenge Winners and Special Mentions!</div></div><div class=\"mission-closed-page__no-mission__description text-center\" ng-show=\"vm.missions.length === 0\"><div ng-if=!vm.isMyMission>Check out our past winning photos and photographers.</div><div ng-if=vm.isMyMission>Review all completed Challenges here. Check out all the submissions and select Challenge Winners and Special Mentions!</div></div></section><div class=\"mission-closed-page__main-content__mission-grid clearfix\" infinite-scroll-disabled=vm.isLastPage infinite-scroll=vm.fetchMoreItems() infinite-scroll-immediate-check=false><div ng-show=\"vm.missions.length > 0\"><div ng-repeat=\"mission in vm.missions\" class=\"clearfix col-md-4 col-sm-6 mission-closed-page__main-content__mission-item\"><mission-gallery mission=mission></mission-gallery></div></div><div class=\"mission-closed-page__no-mission text-center\" ng-show=\"vm.missions.length === 0\"><div ng-if=!vm.isMyMission><img src=assets/images/pixerf-empty-mission.png><div class=\"mission-closed-page__no-mission__text text--bold-switch-semibold text--color-black\">There are no closed<br>Missions at this time.</div><div class=mission-closed-page__no-mission__text__content translate translate-values=\"{number: 6}\">{{\'joined-join-missions\'}}</div><button type=button class=\"btn btn-submit mission-closed-page__create-btn text--bold\" ui-sref=run-a-challenge-page.live-challenges>{{\'explore-missions\' | translate}}</button></div><div ng-if=vm.isMyMission><div class=\"mission-closed-page__no-mission__text text--bold-switch-semibold text--color-black\">No closed Community Challenges at this time.</div><div class=mission-closed-page__no-mission__text__content>Tap into the power of PIXERF’s growing community of visual artists and crowdsource diverse Asian perspectives to power your creative brief.</div><div class=mission-closed-page__no-mission__text__content>{{\'find-perfect-image-for-brand\'}}</div><!-- <button type=\"button\" class=\"btn btn-submit mission-closed-page__create-btn text--bold\" ui-sref=\"setting.manage-missions.create-mission.getting-started\">{{\'create-mission\' | translate}}</button> --></div></div></div><spinner-win spinner=vm.spinner></spinner-win></div><section class=\"row mission-closed-page__footer text--color-black col-md-12\" ng-if=\"vm.missions.length > 0\"><div class=mission-closed-page__footer__title>{{\'join-other-missions\' | translate}}</div><button type=button class=\"mission-closed-page__footer__button btn btn--white-magento\" ui-sref=run-a-challenge-page.live-challenges>{{\'explore-missions\' | translate}}</button></section></div>");
$templateCache.put("app/mission/components/mission-sponsor-agreement/mission-sponsor-agreement.html","<div class=\"terms-page no-margin missions-agreement\"><section class=\"row terms-page-branding-wrapper\"><div class=missions-agreement__branding><p class=\"terms-page__branding--earn text-center\">Missions Sponsor Agreement</p><photo-info-link photo=vm.missionPhoto></photo-info-link></div></section><section class=\"row terms-page-howitworks__wrapper\"><div class=terms-page-howitworks__content-left><p class=\"terms-page-howitworks__heading text--bold-switch-semibold text--color-black\">Missions Sponsor Agreement</p><div class=terms-page-howitworks__main-content><p>This Mission Sponsor Agreement (the \"<u class=\"text--bold text--color-black\">Agreement</u>\") between you (the \"<u class=\"text--bold text--color-black\">you</u>\", \"<u class=\"text--bold text--color-black\">your</u>\" or the \"<u class=\"text--bold text--color-black\">Mission Sponsor</u>\") and PIXERF PTE LTD (\"<u>PIXERF</u>\") sets forth the terms and conditions that apply when you run a Mission (as defined below).</p><p>By submitting an application to run a Mission, you agree to be bound by the terms of this Agreement, the <a target=__blank ui-sref=introduction-company.license class=subscription-page-business-link>Licence Agreement</a>, the <a target=__blank ui-sref=introduction-company.terms class=subscription-page-business-link>Terms and Conditions</a> and the <a target=__blank ui-sref=introduction-company.privacy class=subscription-page-business-link>Privacy Policy</a>. If you do not agree to any of these terms, please do not apply to run a Mission.</p><p>We reserve the right to make changes to this Agreement at any time without prior notice. By applying to run a Mission on or after the date on which the Agreement has been revised, your use would be deemed as acceptance of the revised Agreement.</p><ol><li><span class=\"terms-page-howitworks__sub-heading text--bold text--color-black\">Interpretation</span><ol><li>In this Agreement, unless the context otherwise requires, the following words or expressions shall have the following meanings:</li><table class=missions-agreement__table><tr><th>\"<span class=\"text--bold text--color-black\">Licence Agreement</span>\"</th><td>means the licence agreement available at https://pixerf.com/#/introduction/company/license, as may be amended from time to time;</td></tr><tr><th>\"<span class=\"text--bold text--color-black\">Mission</span>\"</th><td>means an event organised by PIXERF on or through PIXERF\'s platform at www.pixerf.com for the Mission Sponsor to crowdsourced Mission Visual Content in accordance with the specified requirements;</td></tr><tr><th>\"<span class=\"text--bold text--color-black\">Mission Brief</span>\"</th><td>refers to the specific terms applicable to a particular Mission;</td></tr><tr><th>\"<span class=\"text--bold text--color-black\">Mission End Date</span>\"</th><td>means, in relation to a particular Mission, the date on which the relevant Mission Period ends;</td></tr><tr><th>\"<span class=\"text--bold text--color-black\">Mission Participant</span>\"</th><td>means a user of PIXERF who submits Mission Visual Content for the purposes of participating in a Mission;</td></tr><tr><th>\"<span class=\"text--bold text--color-black\">Mission Period</span>\"</th><td>means, in relation to a particular Mission, the period of time during which Users may submit or upload Mission Visual Content for that Mission;</td></tr><tr><th>\"<span class=\"text--bold text--color-black\">Mission Visual Content</span>\"</th><td>means the content, including photographs, illustrations, vector graphics and videos, which a Mission Participant may post, upload, display or otherwise make available for the purposes of participating in a Mission.</td></tr></table><li>In the event of any inconsistency or conflict between the provisions of this Agreement and the provisions of the <a target=__blank ui-sref=introduction-company.license class=subscription-page-business-link>Licence Agreement</a>, the <a target=__blank ui-sref=introduction-company.terms class=subscription-page-business-link>Terms and Conditions</a> or the <a target=__blank ui-sref=introduction-company.privacy class=subscription-page-business-link>Privacy Policy</a>, the provisions of this Agreement shall prevail. Unless otherwise defined in this Agreement, the terms used herein shall bear the same meanings as in the <a target=__blank ui-sref=introduction-company.terms class=subscription-page-business-link>Terms and Conditions</a>.</li></ol></li><li><span class=\"terms-page-howitworks__sub-heading text--bold text--color-black\">Applying for a Mission</span><ol><li><span class=\"terms-page-howitworks__sub-heading text--bold text--color-black\">Application.</span> You may submit your application to run a Mission through the Site. In the course of your application, you will be required to set out a description / brief of the Mission, the Mission Brief and such other information as may be required.</li><li><span class=\"terms-page-howitworks__sub-heading text--bold text--color-black\">Mission Types.</span> You may choose from the following types of Missions:<ol><li><u>Standard Mission (30-day Mission)</u></li><table class=missions-agreement__table><tr><th>Mission Fee:</th><td>S$800 (excluding prize money)</td></tr><tr><th>Duration:</th><td>30 days</td></tr><tr><th>Number of Winners:</th><td>Up to 3 Winning Submissions</td></tr><tr><th>Number of Special Mentions:</th><td>Up to 5 Special Mention Submissions</td></tr><tr><th>Winning Prize monetary value:</th><td>Minimum of S$150<br>Maximum of S$500</td></tr><tr><th>Special Mention prize:</th><td>S$50 per Special Mention</td></tr></table><li><u>Standard Mission (45-day Mission)</u></li><table class=missions-agreement__table><tr><th>Mission Fee:</th><td>S$1,000 (excluding prize money)</td></tr><tr><th>Duration:</th><td>45 days</td></tr><tr><th>Number of Winners:</th><td>Up to 5 Winning Submissions</td></tr><tr><th>Number of Special Mentions:</th><td>Up to 10 Special Mention Submissions</td></tr><tr><th>Winning Prize monetary value:</th><td>Minimum of S$150<br>Maximum of S$800</td></tr><tr><th>Special Mention prize:</th><td>S$50 per Special Mention</td></tr></table><li><u>Customised Mission</u></li><table class=missions-agreement__table><tr><th>Mission Fee:</th><td>Variable fee. To be determined by PIXERF</td></tr><tr><th>Duration:</th><td>Between 1 day and 60 days</td></tr><tr><th>Number of Winners:</th><td>Up to 100 Winning Submissions</td></tr><tr><th>Number of Special Mentions:</th><td>500</td></tr><tr><th>Winning Prize monetary value:</th><td>Minimum of S$100<br>Maximum of S$100,000<br>Additional option of offering in-kind prizes in conjunction with the monetary prize</td></tr><tr><th>Special Mention prize:</th><td>S$50 per Special Mention</td></tr></table></ol></li><li><span class=\"terms-page-howitworks__sub-heading text--bold text--color-black\">Launch.</span> PIXERF will review your application, and has the sole and absolute discretion to launch the Mission or reject your application. If the Mission is launched, it will be displayed on the Site and Mission Participants would be able to submit their Mission Visual Content in respect of your Mission.</li><li>You agree that PIXERF may, but is not obliged to, make additions, deletion or any other amendments to the Mission Brief at any time, for any reason whatsoever, and without any notice to you.</li></ol></li><li><span class=\"terms-page-howitworks__sub-heading text--bold text--color-black\">Removal of Mission Visual Content</span><p>PIXERF may, at its sole discretion, remove or reject any Mission Visual Content for any reasons whatsoever, including but not limited to marketability or the Mission Participant\'s failure or neglect to comply with any curatorial and submission guidelines or procedures.</p></li><li><span class=\"terms-page-howitworks__sub-heading text--bold text--color-black\">Winning Submission(s) and Special Mention Submission(s)</span><ol><li><span class=\"terms-page-howitworks__sub-heading text--bold text--color-black\">Selection</span>. You shall select the winning submission(s) and the special mention submission(s) from the Mission Visual Content in accordance with the mission brief (the \"<span class=\"text--bold text--color-black\">Winning Submission(s)</span>\" and the \"<span class=\"text--bold text--color-black\">Special Mention Submission(s)</span>\" respectively)and notify PIXERF of your selection within thirty (30) days after the Mission End Date. Any such selection shall be final and conclusive once notified to PIXERF.</li><li>If you wish to award more Special Mention Submissions than you had initially selected when selecting your Mission type (up to the maximum number permitted for your Mission type), you may do so by notifying PIXERF at <a href=mailto:business@pixerf.com class=subscription-page-business-link>business@pixerf.com</a> and making payment of such additional Special Mention Submission(s) in accordance with Clause 5 (Payment) below.</li><li>In the event that you do not select the Winning Submission(s) within the 30-day period as set out in Clause 4.1 for any reason whatsoever, PIXERF shall be entitled, but not obliged, to select them on your behalf within seven (7) days from the end of the 30-day period.</li><li><span class=\"terms-page-howitworks__sub-heading text--bold text--color-black\">Prize</span>. The Mission Participant(s) who had posted, uploaded or displayed the Winning Submission(s) shall be entitled to the prize as displayed in the Mission Brief (the \"<span class=\"text--bold text--color-black\">Prize</span>\").</li><li>After thirty (30) days from the Mission End Date, or thirty-seven (37) days from the Mission End Date if you do not select the Winning Submission(s) within the 30-day period, any Mission Visual Content which were not selected by you or PIXERF (as the case may be) as the Winning Submission(s) or the Special Mention Submission(s) will be transferred to the Marketplace as Marketplace Visual Content. PIXERF shall not be liable for any costs, charges, damages or losses sustained or incurred by any party which arises, whether directly or indirectly, from any delay, failure or neglect by you in selecting the Winning Submission(s) or the Special Mention Submission(s) by the relevant date.</li><li><span class=\"terms-page-howitworks__sub-heading text--bold text--color-black\">Notice</span>. While PIXERF will use reasonable endeavours to notify the Mission Participant(s) who submitted or uploaded the Winning Submission(s) and/or the Special Mention Submission(s) of the same by way of email at their email address provided to PIXERF within thirty (30) days from the Mission End Date, or thirty-seven (37) days from the Mission End Date if you do not select the Winning Submission(s) within the 30-day period, PIXERF shall not be obliged to do so.</li></ol></li><li><span class=\"terms-page-howitworks__sub-heading text--bold text--color-black\">Payment</span><ol><li>Your Credits will be used to pay for your Mission and the prizes for the Winning Submission(s) and Special Mention Submission(s) before the Mission can be launched. You shall make such payment (i) within fifteen (15) days of the date on which your Mission application is approved; or (ii) when you want to launch the Mission, whichever is earlier.</li><li>Your Credits will also be used to pay for any additional Special Mention Submission(s) which you wish to select, and any other additional features in this Agreement. If you have insufficient Credits to purchase your selected Special Mention Submission(s), PIXERF shall notify you accordingly. You will only be given the Special Mention Submission(s) which you have sufficient Credits for.</li></ol></li><li><span class=\"terms-page-howitworks__sub-heading text--bold text--color-black\">Taxes</span><ol><li>You shall pay all applicable goods and services tax, duties or levies whatsoever at the rate which may from time to time be imposed or charged at any time by any government, statutory or tax authority on or calculated by reference to the amount of any sums payable by you under this Agreement or to reimburse us for the payment of such taxes, duties or levies immediately on receipt of written notice from PIXERF.</li><li>If PIXERF shall at any time be compelled by any applicable law to withhold or deduct any tax on your behalf from any amount payable to you hereunder, PIXERF shall, when making payment to you, make payment of such tax at the applicable rate to the appropriate tax authority and shall promptly furnish to you written receipts from the appropriate tax authority certifying that such payments have been made.</li></ol></li><li><span class=\"terms-page-howitworks__sub-heading text--bold text--color-black\">Grant of Licence</span><ol><li>Subject to receipt of all sums payable from you to PIXERF under this Agreement, PIXERF grants to you the relevant licence(s) to the Winning Submission(s) and/or the Special Mention Submission(s) as stated in the Mission Brief. Unless otherwise stated in the Mission Brief, such applicable licence shall be the Standard Licence as described in the <a target=__blank ui-sref=introduction-company.license class=subscription-page-business-link>Licence Agreement</a>.</li><li>In addition, the Winning Submission(s) will only be transferred to the Marketplace after sixty (60) days from the date of award. If you wish to extend this period, you may submit a written request to PIXERF at <a href=mailto:business@pixerf.com class=subscription-page-business-link>business@pixerf.com</a>. PIXERF may grant such extension for an additional amount at its discretion.</li></ol></li><li><span class=\"terms-page-howitworks__sub-heading text--bold text--color-black\">Intellectual Property Rights</span><p>Limited Transfer of Rights. All Mission Visual Content shall be owned, licensed to or controlled by either PIXERF or the Mission Participant(s) who submitted or uploaded the Mission Visual Content. Save for those rights expressly granted to you in this Agreement, no other rights to the Mission Visual Content are granted by PIXERF to you.</p></li><li><span class=\"terms-page-howitworks__sub-heading text--bold text--color-black\">Terms and Termination</span><ol><li>This Agreement shall continue in effect until it is terminated by either you or PIXERF as set out in these terms. You may terminate this Agreement by giving PIXERF no less than seven (7) working days’ notice in writing if PIXERF has breached or failed to comply with any of its obligations under this Agreement.</li><li>PIXERF may terminate this Agreement by giving you no less than seven (7) working days\' notice in writing for any reason. PIXERF may also terminate this Agreement immediately by giving you written notice if you fail or refuse to perform or comply with any of your obligations under this Agreement or any other agreement which you may have with PIXERF; or engage in any conduct which may affect or damage the name, reputation or goodwill of PIXERF.</li><li>In the event of termination of this Agreement for any reason, you shall:<ol><li>cease to use or access any Mission Visual Content, and must delete and destroy all copies of the same thereof, whether electronic or print. If requested, you shall prove to PIXERF\'s satisfaction that you have complied with these requirements;</li><li>not be entitled to, and waive any entitlement to any refund, in full or part thereof, of any sums of money already paid to PIXERF. For the avoidance for doubt, this would apply even if you do not obtain the required subject, quality or number of submissions for your Mission.</li></ol></li><li>Notwithstanding the termination of this Agreement, all the provisions of this Agreement which are intended to have effect on and/or after the termination of this Agreement shall survive the termination and shall be deemed to remain in full force and effect.</li></ol></li><li><span class=\"terms-page-howitworks__sub-heading text--bold text--color-black\">Disclaimer of Warranties</span><p>Any content or services provided by PIXERF under this Agreement, including the Mission Visual Content, are provided on an \"as is\", \"as available\" basis, without representation, warranty or condition of any kind, implied, express or statutory, including but not limited to the representations or warranties of non-infringement of third party rights, title, merchantability, satisfactory quality and/or fitness for a particular purpose. In particular, PIXERF does not represent or warrant the transmission, accuracy, completeness, timeliness or adequacy of any content or services.</p></li><li><span class=\"terms-page-howitworks__sub-heading text--bold text--color-black\">Disclaimer of Liability</span><p>Notwithstanding any other provision in this Agreement, PIXERF shall not be liable to you or any other person or entity for any punitive, special, direct, indirect, consequential, incidental or other similar damages, costs or losses of any kind suffered or incurred by you or any third party arising from or in connection with this Agreement, its termination or expiration.</p></li><li><span class=\"terms-page-howitworks__sub-heading text--bold text--color-black\">Indemnity</span><p>You agree to indemnify, defend and hold PIXERF, its officers, directors, shareholders, predecessors, successors-in-title, employees, agents, subsidiaries and affiliates, harmless from all demands, claims, actions, proceedings, judgements, orders, decrees, damages, costs, losses and expenses of any nature whatsoever (including but not limited to legal costs on an indemnity basis) arising out of or in connection with any breach or alleged breach or failure by you (or anyone acting on your behalf) to comply with any of terms of this Agreement. These indemnity obligations shall survive any termination of this Agreement or your user account on the Site.</p></li><li><span class=\"terms-page-howitworks__sub-heading text--bold text--color-black\">General</span><ol><li><span class=\"text--bold text--color-black\">Notices</span>. All notices required to be sent to PIXERF under this Agreement shall be sent via email to <a href=mailto:business@pixerf.com class=subscription-page-business-link>business@pixerf.com</a>. All notices required to be sent to you by PIXERF under this Agreement shall be sent via email to the email address set out in your user account.</li><li><span class=\"text--bold text--color-black\">Severability</span>. The illegality, invalidity or unenforceability of any provision of this Agreement under the law of any jurisdiction shall not affect its legality, validity or enforceability under the law of any other jurisdiction nor the legality, validity or enforceability of any other provision.</li><li><span class=\"text--bold text--color-black\">No Waiver</span>. No failure on the part of any party to exercise, and no delay on its part in exercising, any right or remedy under this Agreement will operate as a waiver thereof, nor will any single or partial exercise of any right or remedy preclude any other or further exercise thereof or the exercise of any other right or remedy. The rights and remedies provided in this Agreement are cumulative and not exclusive of any rights or remedies provided by law.</li><li><span class=\"text--bold text--color-black\">Governing Law</span>. This Agreement shall be construed and its performance governed in accordance with the laws of the Republic of Singapore.</li></ol></li><p>The last update to our Mission Sponsor Agreement was posted on 20 August 2018.</p></ol></div></div><div class=terms-page-howitworks__content-right></div></section></div>");
$templateCache.put("app/mission/components/mission-info/mission-info.html","<section class=\"mission-info bg--white\"><div class=\"clearfix mission-info__description-requirement-wrapper\"><div class=mission-info-description-wrapper><div ng-if=vm.mission.is_closed class=mission-info__title-ended__text translate>{{\'this-mission-has-ended\'}}</div><div class=mission-info__title-ended ng-class=\"{\'closed-mission-style\': vm.mission.is_closed}\"><div><div ng-if=\"vm.mission && vm.mission.inkind_reward\" class=mission-info__inkind><span class=\"mission-info__brief-medal__icon icon-medal\"></span> <span class=mission-info__inkind__value>Win {{vm.mission.inkind_reward}}</span></div><div class=\"mission-info__brief-medal__prize-pack clearfix\" ng-if=vm.kindWinners.grandWinner><div class=\"mission-info__brief-medal__prize-pack__medal bg-medal_blank_winner\"></div><div class=mission-info__brief-medal__prize-pack__value><span>{{vm.mission.currency}} {{vm.kindWinners.grandWinner.value}}</span></div></div><div ng-if=\"vm.mission && !vm.mission.inkind_reward && !vm.isCustomMission124\" class=mission-info__without-inkind><div class=\"mission-info__brief-medal__prize-pack clearfix\" ng-if=vm.kindWinners.firstWinner><div class=\"mission-info__brief-medal__prize-pack__medal bg-medal_first_winner\"></div><div class=mission-info__brief-medal__prize-pack__value><span>{{vm.mission.currency}} {{vm.kindWinners.firstWinner.value}}</span></div></div><div class=\"mission-info__brief-medal__prize-pack clearfix\" ng-if=vm.kindWinners.secondWinner><div class=\"mission-info__brief-medal__prize-pack__medal bg-medal_second_winner\"></div><div class=mission-info__brief-medal__prize-pack__value><span>{{vm.mission.currency}} {{vm.kindWinners.secondWinner.value}}</span></div></div><div class=\"mission-info__brief-medal__prize-pack clearfix\" ng-if=vm.kindWinners.thirdWinner><div class=\"mission-info__brief-medal__prize-pack__medal bg-medal_third_winner\"></div><div class=mission-info__brief-medal__prize-pack__value><span>{{vm.mission.currency}} {{vm.kindWinners.thirdWinner.value}}</span></div></div><div class=\"mission-info__brief-medal__prize-pack clearfix\" ng-if=vm.kindWinners.winner><div class=mission-info__brief-medal__prize-pack__medal ng-class=\"vm.kindWinners.firstWinner ? \'bg-medal_general_winner\' : \'bg-medal_blank_winner\'\"></div><div class=mission-info__brief-medal__prize-pack__value><span ng-if=vm.isMultiWinners>{{vm.kindWinners.winner.quantity}} <span class=mission-info__brief-medal__prize-pack__value__multiply>X</span></span> <span>{{vm.mission.currency}} {{vm.kindWinners.winner.value}} <span ng-if=vm.isMultiWinners class=mission-info__brief-medal__prize-pack__value__each-text translate>{{\'each\'}}</span></span></div></div></div><div class=\"mission-info__brief-medal__prize-pack clearfix\" ng-if=\"vm.mission.id == 121 || vm.mission.id == 122\"><div class=mission-info__brief-medal__prize-pack__medal ng-class=\"vm.kindWinners.firstWinner ? \'bg-medal_general_winner\' : \'bg-medal_blank_winner\'\"></div><div class=mission-info__brief-medal__prize-pack__value><span>{{vm.kindWinners.consolation.quantity}} <span class=mission-info__brief-medal__prize-pack__value__multiply>X</span></span> <span>Special Mentions</span></div></div><div class=\"mission-info__brief-medal__prize-pack clearfix mission-info__brief-medal__prize-pack__custom-topkinkd\" ng-if=vm.isCustomMission124><div class=\"mission-info__brief-medal__prize-pack__medal icon-medal\"></div><div class=mission-info__brief-medal__prize-pack__value><span>Top Prizes: {{vm.kindWinners.winner.quantity}} x <span ng-bind-html=vm.kindWinners.winner.name></span> (Worth S${{vm.kindWinners.winner.value}} each)</span></div></div><div class=\"mission-info__brief-medal__prize-pack clearfix mission-info__brief-medal__prize-pack__custom-merit\" ng-if=vm.isCustomMission124><div class=\"mission-info__brief-medal__prize-pack__medal bg-medal_blank_winner\"></div><div class=mission-info__brief-medal__prize-pack__value><span>{{vm.kindWinners.consolation.quantity}} Merit Prizes:<br><span ng-bind-html=vm.kindWinners.consolation.name></span></span></div></div></div></div><div class=\"mission-info-description__brief-section clearfix\" ng-class=\"{\'closed-mission-style\': vm.mission.is_closed}\" ng-if=vm.tmpTranslatedDescription><div class=\"mission-info-description__sub-title text--extrabold text--color-black\" translate>{{\'challenge-brief\'}}</div><div class=\"mission-info-description ql-editor\" ng-bind-html=vm.tmpTranslatedDescription></div></div><div class=\"mission-info-description__description-section clearfix\" ng-class=\"{\'closed-mission-style\': vm.mission.is_closed}\" ng-if=vm.tmpTranslatedArtDirection><div class=\"mission-info-description__sub-title text--extrabold text--color-black\" translate>{{\'art-direction\'}}</div><div class=\"mission-info-description ql-editor\" ng-bind-html=vm.tmpTranslatedArtDirection></div></div></div><div class=\"mission-info__requirement-wrapper no-padding\" ng-class=\"{\'no-margin\': !vm.mission.is_closed}\"><div class=mission-info__requirement ng-class=\"{\'closed-mission-style\': vm.mission.is_closed}\"><div class=\"mission-info__requirement-title text--extrabold text--color-black\" translate>{{\'image-requirements\'}}</div><div class=\"mission-info__requirement-list clearfix\"><div class=\"mission-info__requirement-item clearfix\" ng-repeat=\"item in vm.requirements\"><div class=\"mission-info__requirement-item__icon-wrapper no-padding\"><div class=\"text--bold mission-info__requirement-item__label text--color-black text--extrabold\">{{item.title}}</div></div><div class=mission-info__requirement-item__value translate>{{item.value}}</div></div></div><div class=mission-info__note translate>{{\'release-copy-download\'}}</div></div></div><div scroll-to-element=vm.scrollToVisualInspiration class=mission-info__visual-inspiration ng-if=\"!vm.mission.is_closed && vm.mission.media && vm.mission.media.length > 0\"><div class=\"mission-info__visual-inspiration__header clearfix\"><div class=\"mission-info__visual-inspiration__title text--extrabold text--color-black\" translate>{{\'visual-inspiration\'}}</div><div class=mission-info__visual-inspiration__check-out translate>{{\'check-out-our-visual-inspiration\'}}</div></div><div ng-if=\"vm.bidingItems.length > 0  && vm.mission.is_multi_frame\"><div class=visual-inspiration__group-by-frame ng-repeat=\"item in vm.bidingItems\"><h3 class=visual-inspiration__group-by-frame__title data-toggle=collapse data-target=#group-by-{{$index}}>{{item.data[0].title}}</h3><div id=group-by-{{$index}} class=\"collapse in\"><div flex-grid ng-model=item margins=3 rowheight=50 lastrow=justify><div class=visual-inspiration__group-by-frame__media ng-repeat=\"photo in item.data\"><img ng-src=\"{{photo.thumbnails[\'x400\']}}\" alt=\"\"></div></div></div></div></div><div ng-if=\"!vm.mission.is_multi_frame && vm.mission.media.length\"><div flex-grid ng-model=vm.mission margins=3 rowheight=200><div class=visual-inspiration__group-by-frame__media ng-repeat=\"photo in vm.mission.media\"><img ng-src=\"{{photo.thumbnails[\'x400\']}}\" alt=\"\"></div></div></div></div></div><div class=\"mission-detail-page__footer clearfix\" ng-if=!vm.mission.is_closed><div class=\"mission-detail-page__footer__title text--extrabold\" translate>{{\'crowdsource-business-banner\'}}</div><div class=mission-detail-page__footer__description><div translate>{{\'crowdsource-business-description-1\'}}</div><div translate>{{\'crowdsource-business-description-2\'}}</div></div><button class=\"mission-detail-page__footer__btn text--bold btn btn--white-magento\" ui-sref=run-a-challenge-page.live-challenges>{{\'find-out-how\' | translate}}</button></div></section>");
$templateCache.put("app/mission/components/mission-joined/mission-joined.html","<div class=\"mission-joined-page no-margin\"><div class=mission-joined-page__wrapper><section class=\"row mission-joined-page__main-content\"><div class=\"mission-joined-page__main-content__title text--color-black text--extrabold\" translate>{{\'your-missions\'}}</div><div class=mission-joined-page__main-content__description ng-show=\"vm.missions.length > 0\">{{\'joined-view-edit-manage\' | translate}}<br>{{\'feel-free-to-change-your-submissions\' | translate}}<br><br><br>{{\'you-are-running\' | translate}}</div><div class=\"mission-closed-page__no-mission__description text-center\" ng-show=\"vm.missions.length === 0\" translate>{{\'joined-view-edit-manage\'}}</div></section><div class=\"mission-joined-page__main-content__mission-grid clearfix\" infinite-scroll-disabled=vm.isLastPage infinite-scroll=vm.fetchMoreItems() infinite-scroll-immediate-check=false><div ng-show=\"vm.missions.length > 0\"><div ng-repeat=\"mission in vm.missions\" class=\"clearfix col-md-4 col-sm-6 mission-joined-page__main-content__mission-item\"><mission-gallery mission=mission></mission-gallery></div></div><div class=\"mission-closed-page__no-mission text-center\" ng-show=\"vm.missions.length === 0\"><img src=assets/images/pixerf-empty-mission.png><div class=\"mission-closed-page__no-mission__text text--bold-switch-semibold text--color-black\" translate>{{\'not-joined-missions\'}}</div><div class=mission-closed-page__no-mission__text__content translate translate-values=\"{number: 6}\">{{\'joined-join-missions\'}}</div><button type=button class=\"btn btn-submit mission-closed-page__create-btn text--bold\" ui-sref=run-a-challenge-page.live-challenges>{{\'explore-missions\' | translate}}</button></div></div><spinner-win spinner=vm.spinner></spinner-win></div><section class=\"row mission-joined-page__footer col-md-12\" ng-if=\"vm.missions.length > 0\"><div class=\"mission-joined-page__footer__title text--bold-switch-semibold\">{{\'join-other-missions\' | translate}}</div><button type=button class=\"mission-joined-page__footer__button text--bold btn btn--white-magento\" ui-sref=run-a-challenge-page.live-challenges>{{\'explore-missions\' | translate}}</button></section></div>");
$templateCache.put("app/mission/components/on-going/on-going.html","<div class=\"on-going-page no-margin\"><section class=\"row on-going-page__main-content\"><div class=\"on-going-page__main-content__title text--extrabold\" translate>{{\'ongoing-community-challenges\'}}</div><div class=on-going-page__main-content__description><div translate>{{\'ongoing-give-us\'}}</div></div><div ng-show=\"vm.missions.length > 0\" class=on-going-page__setting-redirect-btn><div>Launch a Community Challenge today.</div><button type=button class=\"btn btn-submit mission-closed-page__redirect-btn text--bold\" ui-sref=email-us-page>Tell us your brief</button></div></section><div class=\"on-going-page__main-content__mission-grid clearfix\" ng-class=\"{\'grid-have-frame\': vm.missions.length === 0}\" infinite-scroll-disabled=vm.isLastPage infinite-scroll=vm.fetchMoreItems() infinite-scroll-immediate-check=false><div ng-show=\"vm.missions.length > 0\"><div ng-repeat=\"mission in vm.missions\" class=\"clearfix col-md-4 col-sm-6 on-going-page__main-content__mission-item\"><mission-gallery mission=mission></mission-gallery></div></div><div class=\"on-going-page__no-mission text-center\" ng-show=\"vm.missions.length === 0\"><div ng-if=!vm.isMyMission><img src=assets/images/pixerf-empty-mission.png><div class=\"on-going-page__no-mission__text text--bold\" translate>{{\'ongoing-empty-state-no-ongoing\'}}</div><div class=on-going-page__no-mission__text__content><div translate>{{\'ongoing-empty-state-coming-soon\'}}</div><div class=on-going-page__no-mission__scocial-media><a href=https://www.facebook.com/Pixerf target=_blank><div class=\"photo-icon-media photo-fb-icon\"></div></a><a href=http://instagram.com/Pixerf target=_blank><div class=\"photo-icon-media photo-ig-icon\"></div></a><a href=https://twitter.com/Pixerf target=_blank><div class=\"photo-icon-media photo-tw-icon\"></div></a></div></div></div><div ng-if=vm.isMyMission><div class=\"mission-closed-page__no-mission__text text--bold-switch-semibold text--color-black\" translate>{{\'launch-your-first-mission\'}}</div><div class=mission-closed-page__no-mission__text__content translate>{{\'ongoing-empty-state-tap-into\'}}</div><div class=mission-closed-page__no-mission__text__content translate>{{\'find-perfect-image-for-brand\'}}</div><!-- <button type=\"button\" class=\"btn btn-submit mission-closed-page__create-btn text--bold\" ui-sref=\"setting.manage-missions.create-mission.getting-started\">{{\'create-mission\' | translate}}</button> --> <button type=button class=\"btn btn-submit mission-closed-page__redirect-btn text--bold\" ui-sref=email-us-page>Tell us your brief</button></div></div></div></div><spinner-win spinner=vm.spinner></spinner-win><section class=\"row on-going-page__footer text--color-black col-md-12\"><div class=on-going-page__footer__title translate>{{\'crowdsource-business-banner\'}}</div><div class=on-going-page__footer__description><div translate>{{\'crowdsource-business-description-1\'}}</div><div translate>{{\'crowdsource-business-description-2\'}}</div></div><button type=button class=\"on-going-page__footer__button text--bold btn btn--white-magento\" ui-sref=email-us-page>{{\'find-out-how\' | translate}}</button></section>");
$templateCache.put("app/photographer-page/components/featured-photographer-page/featured-photographer-page.html","<div class=featured-photographer-page><div class=\"featured-photographer-page__title text--bold\" translate>{{\'curated-list-creators\'}}</div><div class=featured-photographer-page__description translate>{{\'search-by-specialty\'}}</div><div class=\"featured-photographer-page__filter-wrapper clearfix\"><div class=\"featured-photographer-page__filter-wrapper__info clearfix\"><div class=\"featured-photographer-page__filter clearfix\"><div class=\"featured-photographer-page__filter__label text--bold\" translate>{{\'im-looking-for\'}}</div><pixerf-input-auto-complete ng-if=vm.communities is-required=true name=communities dropdown-class=\"featured-photographer-page__dropdown communities\" options=vm.dopdownOpts data=vm.communities model=vm.communitiesSelected on-changed=vm.onCommunitiesSelected(vm.communitiesSelected)></pixerf-input-auto-complete></div><div class=\"featured-photographer-page__filter clearfix\"><div class=\"featured-photographer-page__filter__label text--bold\" translate>{{\'specialising-in\'}}</div><pixerf-input-auto-complete ng-if=vm.specialities is-required=true name=specialities dropdown-class=\"featured-photographer-page__dropdown specialities\" options=vm.dopdownOptsSpec data=vm.specialities model=vm.specialitiesSelected on-changed=vm.onSpecialitiesSelected(vm.specialitiesSelected)></pixerf-input-auto-complete><!-- <div class=\"featured-photographer-page__filter__hint\">Select multiple speciality at once?<br />Just hold down on\r\n					the \"Shift\" key as you click!</div> --></div><div class=\"featured-photographer-page__filter clearfix\"><div class=\"featured-photographer-page__filter__label text--bold\" translate>{{\'located-at\'}}</div><!-- <country-select class=\"form-control\" ng-model=\"vm.countrySelected\" any=\"true\"></country-select> --><countries-dropdown close-on-scroll=tue model=vm.countriesInstance on-changed=vm.onCountriesSelected(vm.countriesInstance.countriesSelected) dropdown-class=featured-photographer-page__dropdown></countries-dropdown></div></div><div class=\"featured-photographer-page__filter-wrapper__action clearfix\"><button class=\"btn search-btn btn--black\" ng-click=vm.onSearchClicked()><span class=icon-icons_search></span> {{\'search\' | translate}}</button><div class=\"reset-btn text--bold\" ng-click=vm.onResetClicked() translate>{{reset}}</div></div></div><featured-photographer-grid search-params=vm.searchParams instance=vm.leaderBoard type={{vm.type}} order={{vm.order}} page={{vm.page}} on-paging=vm.onPaging(page)></featured-photographer-grid><!-- <leader-board display-order-not-ranking=\"vm.loginUser.canCurate\" is-hide-ranking=\"true\"\r\n	 highlight-top=\"vm.type ===\'leaderboard\'\" instance=\"vm.leaderBoard\" type=\"{{vm.type}}\" order=\"{{vm.order}}\" page=\"{{vm.page}}\"\r\n	 on-paging=\"vm.onPaging(page)\"></leader-board> --><div class=featured-photographer-page__ending-message-wrapper ng-if=\"vm.type === \'leaderboard\' && vm.leaderBoard.isLastPage\"><div class=featured-photographer-page__ending-message-wrapper__message ng-bind-html=vm.endingMessage></div><upload-btn class=featured-photographer-page__ending-message-wrapper__upload-btn></upload-btn></div></div>");
$templateCache.put("app/photographer-page/components/leaderboard-page/leaderboard-page.html","<div class=photographer-page-leaderboard><div class=\"photographer-page-leaderboard__title text--bold\">Meet the PIXERF Community</div><div class=photographer-page-leaderboard__description>Visual creators from all over the world. Explore our most active members here.</div><div class=\"photographer-page-leaderboard__filter-wrapper clearfix\"><div class=\"photographer-page-leaderboard__filter-wrapper__info clearfix\"><div class=\"photographer-page-leaderboard__filter specialities clearfix\"><div class=\"photographer-page-leaderboard__filter__label text--bold text--color-black\">{{\'specialising-in\' | translate}}</div><pixerf-input-auto-complete ng-if=vm.specialities is-required=true name=specialities dropdown-class=\"photographer-page-leaderboard__dropdown specialities\" options=vm.dopdownOpts data=vm.specialities model=vm.specialitiesSelected on-changed=vm.onSpecialitiesSelected(vm.specialitiesSelected)></pixerf-input-auto-complete></div><div class=\"photographer-page-leaderboard__filter countries clearfix\"><div class=\"photographer-page-leaderboard__filter__label text--bold text--color-black\">Locating at</div><countries-dropdown close-on-scroll=tue model=vm.countriesInstance on-changed=vm.onCountriesSelected(vm.countriesInstance.countriesSelected) dropdown-class=featured-photographer-page__dropdown></countries-dropdown></div><div class=\"photographer-page-leaderboard__filter sort-by clearfix\"><div class=\"photographer-page-leaderboard__filter__label text--bold text--color-black\" translate>{{\'sort-by\'}}</div><ul class=sort-by__dropdown><li class=sort-by__item ng-class=\"{\'actived\': !vm.selectedSize.isDefault}\"><popover-selection-btn close-on-click=true on-selection-changed=vm.onFilteredClicked(item) selected-model=vm.selectedFilterItem settings=vm.filterSetting></popover-selection-btn></li></ul></div><div class=\"photographer-page-leaderboard__filter search-name clearfix\"><div class=\"photographer-page-leaderboard__filter__label text--bold text--color-black\">Search by Name</div><input type=text ng-change=\"vm.onSearch(vm.photographer, vm.selectedFilterItem)\" class=\"form-control photographer-page-leaderboard__search-input\" ng-model=vm.photographer></div></div><div class=\"photographer-page-leaderboard__filter-wrapper__action clearfix\"><div class=\"photographer-page-leaderboard__reset-btn text--bold\" ng-click=vm.onResetClicked()>Reset</div></div></div><div class=\"photographer-page-leaderboard__info clearfix\"><div class=\"photographer-page-leaderboard__info__col-left clearfix\" ng-if=\"vm.loginUser.leaderboard && vm.loginUser.leaderboard.rank\"><div class=photographer-page-leaderboard__info__rank><div class=photographer-page-leaderboard__info__rank__icon><span class=icon-icons_grid-view></span></div><div class=photographer-page-leaderboard__info__rank__label>MY RANK</div></div><div class=photographer-page-leaderboard__info__rank__text>You\'re currently ranked #{{vm.loginUser.leaderboard.rank}} with {{vm.loginUser.leaderboard.points | number:0}} points</div></div><div class=\"photographer-page-leaderboard__info__col-right clearfix\"><!-- <div class=\"photographer-page-leaderboard__info__search-input\">\r\n                <input type=\"text\" ng-change=\"vm.onSearch(vm.photographer, vm.selectedFilterItem)\" class=\"form-control photographer-page-leaderboard__search-input\" ng-model=\"vm.photographer\" placeholder=\"Search by name\">\r\n            </div>\r\n            <div class=\"photographer-page-leaderboard__info__filters-wrapper\">\r\n                <label class=\"photographer-page-leaderboard__info__filters__label text--bold\">Sort by</label>\r\n                <ul class=\"photographer-page-leaderboard__info__sort\">\r\n                    <li class=\"photographer-page-leaderboard__info__sort__item\" ng-class=\"{\'photographer-page-leaderboard__info__sort__item--active\': !vm.selectedSize.isDefault}\">\r\n                        <popover-selection-btn close-on-click=\"true\" on-selection-changed=\"vm.onFilteredClicked(item)\"\r\n                        selected-model=\"vm.selectedFilterItem\" settings=\"vm.filterSetting\"></popover-selection-btn>\r\n                    </li>\r\n                </ul>\r\n            </div> --></div></div><leader-board search-params=vm.searchParams instance=vm.leaderBoard type={{vm.type}} order={{vm.order}} page={{vm.page}} on-paging=vm.onPaging(page)></leader-board></div>");
$templateCache.put("app/run-a-challenge-page/components/about-challenge/about-challenge.html","<div class=about-challenge><div class=about-challenge__banner photo-details-on-click=169702><div class=about-challenge__banner__background></div><div class=about-challenge__banner__content><banner-box-intro data=vm.bannerBox on-btn-clicked=vm.runChallenge()></banner-box-intro></div></div><section class=\"about-challenge__section about-challenge__section__ongoing-challenge\"><div class=about-challenge__section__ongoing-challenge__title>Community Challenges this week.</div><div class=about-challenge__section__ongoing-challenge__sub-title>Crowdsource from our network of 70,000 creators in Asia for localised and culturally authentic photos and videos with Live Community Challenges.</div><community-challenges-carousel ng-if=\"vm.missions && vm.missions.length\" missions=vm.missions></community-challenges-carousel><community-challenge-tile ng-if=\"!vm.missions || !vm.missions.length\"></community-challenge-tile><div class=about-challenge__section__ongoing-challenge__hint><div class=about-challenge__section__ongoing-challenge__hint__text>Looking for inspiration to create brand awareness?</div><button class=about-challenge__section__ongoing-challenge__check-out-btn ui-sref=run-a-challenge-page.past-challenges>Check out Past Challenges</button></div></section><section class=\"about-challenge__section about-challenge__section__col-info\"><div class=about-challenge__section__col-info__title>Creating perfect images for your brand in 4 simple steps.</div><info-col-intro context=about-challenges></info-col-intro><div class=about-challenge__section__col-info__control><button class=about-challenge__section__col-info__control__case-studies-btn ng-click=vm.viewCaseStudies()>View case studies</button> <button class=about-challenge__section__col-info__control__shoot-btn ng-click=vm.runChallenge()>Launch a Challenge</button></div></section><section class=\"about-challenge__section about-challenge__section__community-challenge\"><div class=about-challenge__section__community-challenge__title>What brands say about Community Challenge</div><brands-say-column data=vm.communityChallengesSay></brands-say-column></section><section class=\"about-challenge__section about-challenge__section__carousel\"><div class=about-challenge__section__carousel__title>Discover how brands have used Community Challenges to source for photos effectively.</div><about-challenges-case-studies-grid-carousel id=aboutChallengesCaseStudiesGridCarouselSection></about-challenges-case-studies-grid-carousel></section><general-contact-form id=generalContactFormSection context=about-challenges-page on-cta-btn-clicked=vm.runChallenge() class=\"about-challenge__section about-challenge__section__contact-form\"></general-contact-form></div>");
$templateCache.put("app/run-a-challenge-page/components/challenge-sponsor-agreement/challenge-sponsor-agreement.html","<div class=\"terms-page no-margin challenge-sponsor-agreement\"><section class=\"row challenge-sponsor-agreement__wrapper\"><div class=challenge-sponsor-agreement__content-left><p class=challenge-sponsor-agreement__heading>Community Challenge Sponsor Agreement</p><div class=terms-page-howitworks__main-content><p>This Community Challenge Sponsor Agreement (the \"<u class=\"text--bold text--color-black\">Agreement</u>\") between you (the \"<u class=\"text--bold text--color-black\">you</u>\", \"<u class=\"text--bold text--color-black\">your</u>\" or the \"<u class=\"text--bold text--color-black\">Community Challenge Sponsor</u>\") and PIXERF PTE LTD (\"<u>PIXERF</u>\") sets forth the terms and conditions that apply when you run a Community Challenge (as defined below).</p><p>By submitting an application to run a Community Challenge, you agree to be bound by the terms of this Agreement, the <a target=__blank ui-sref=introduction-company.license class=subscription-page-business-link>Licence Agreement</a>, the <a target=__blank ui-sref=introduction-company.terms class=subscription-page-business-link>Terms and Conditions</a> and the <a target=__blank ui-sref=introduction-company.privacy class=subscription-page-business-link>Privacy Policy</a>. If you do not agree to any of these terms, please do not apply to run a Community Challenge.</p><p>We reserve the right to make changes to this Agreement at any time without prior notice. By applying to run a Community Challenge on or after the date on which the Agreement has been revised, your use would be deemed as acceptance of the revised Agreement.</p><ol><li><span class=\"terms-page-howitworks__sub-heading text--bold text--color-black\">Interpretation</span><ol><li>In this Agreement, unless the context otherwise requires, the following words or expressions shall have the following meanings:</li><table class=challenge-sponsor-agreement__table><tr><th>\"<span class=\"text--bold text--color-black\">Licence Agreement</span>\"</th><td>means the licence agreement available at https://pixerf.com/#/introduction/company/license, as may be amended from time to time;</td></tr><tr><th>\"<span class=\"text--bold text--color-black\">Community Challenge</span>\"</th><td>means an event organised by PIXERF on or through PIXERF\'s platform at www.pixerf.com for the Community Challenge Sponsor to crowdsourced Community Challenge Visual Content in accordance with the specified requirements;</td></tr><tr><th>\"<span class=\"text--bold text--color-black\">Community Challenge Brief</span>\"</th><td>refers to the specific terms applicable to a particular Community Challenge;</td></tr><tr><th>\"<span class=\"text--bold text--color-black\">Community Challenge End Date</span>\"</th><td>means, in relation to a particular Community Challenge, the date on which the relevant Community Challenge Period ends;</td></tr><tr><th>\"<span class=\"text--bold text--color-black\">Community Challenge Participant</span>\"</th><td>means a user of PIXERF who submits Community Challenge Visual Content for the purposes of participating in a Community Challenge;</td></tr><tr><th>\"<span class=\"text--bold text--color-black\">Community Challenge Period</span>\"</th><td>means, in relation to a particular Community Challenge, the period of time during which Users may submit or upload Community Challenge Visual Content for that Community Challenge;</td></tr><tr><th>\"<span class=\"text--bold text--color-black\">Community Challenge Visual Content</span>\"</th><td>means the content, including photographs, illustrations, vector graphics and videos, which a Community Challenge Participant may post, upload, display or otherwise make available for the purposes of participating in a Community Challenge.</td></tr></table><li>In the event of any inconsistency or conflict between the provisions of this Agreement and the provisions of the <a target=__blank ui-sref=introduction-company.license class=subscription-page-business-link>Licence Agreement</a>, the <a target=__blank ui-sref=introduction-company.terms class=subscription-page-business-link>Terms and Conditions</a> or the <a target=__blank ui-sref=introduction-company.privacy class=subscription-page-business-link>Privacy Policy</a>, the provisions of this Agreement shall prevail. Unless otherwise defined in this Agreement, the terms used herein shall bear the same meanings as in the <a target=__blank ui-sref=introduction-company.terms class=subscription-page-business-link>Terms and Conditions</a>.</li></ol></li><li><span class=\"terms-page-howitworks__sub-heading text--bold text--color-black\">Applying for a Community Challenge</span><ol><li><span class=\"terms-page-howitworks__sub-heading text--bold text--color-black\">Application.</span> You may submit your application to run a Community Challenge through the Site. In the course of your application, you will be required to set out a description / brief of the Community Challenge, the Community Challenge Brief and such other information as may be required.</li><li><span class=\"terms-page-howitworks__sub-heading text--bold text--color-black\">Community Challenge Types.</span> You may choose from the following types of Community Challenges:<ol><li><u>Standard Challenge (30-day Challenge)</u></li><table class=challenge-sponsor-agreement__table><tr><th>Challenge Fee:</th><td>S$800 (excluding prize money)</td></tr><tr><th>Duration:</th><td>30 days</td></tr><tr><th>Number of Winners:</th><td>Up to 3 Winning Submissions</td></tr><tr><th>Number of Special Mentions:</th><td>Up to 5 Special Mention Submissions</td></tr><tr><th>Winning Prize monetary value:</th><td>Minimum of S$150<br>Maximum of S$500</td></tr><tr><th>Special Mention prize:</th><td>S$50 per Special Mention</td></tr></table><li><u>Standard Challenge (45-day Challenge)</u></li><table class=challenge-sponsor-agreement__table><tr><th>Challenge Fee:</th><td>S$1,000 (excluding prize money)</td></tr><tr><th>Duration:</th><td>45 days</td></tr><tr><th>Number of Winners:</th><td>Up to 5 Winning Submissions</td></tr><tr><th>Number of Special Mentions:</th><td>Up to 10 Special Mention Submissions</td></tr><tr><th>Winning Prize monetary value:</th><td>Minimum of S$150<br>Maximum of S$800</td></tr><tr><th>Special Mention prize:</th><td>S$50 per Special Mention</td></tr></table><li><u>Customised Challenge</u></li><table class=challenge-sponsor-agreement__table><tr><th>Challenge Fee:</th><td>Variable fee. To be determined by PIXERF</td></tr><tr><th>Duration:</th><td>Between 1 day and 60 days</td></tr><tr><th>Number of Winners:</th><td>Up to 100 Winning Submissions</td></tr><tr><th>Number of Special Mentions:</th><td>500</td></tr><tr><th>Winning Prize monetary value:</th><td>Minimum of S$100<br>Maximum of S$100,000<br>Additional option of offering in-kind prizes in conjunction with the monetary prize</td></tr><tr><th>Special Mention prize:</th><td>S$50 per Special Mention</td></tr></table></ol></li><li><span class=\"terms-page-howitworks__sub-heading text--bold text--color-black\">Launch.</span> PIXERF will review your application, and has the sole and absolute discretion to launch the Community Challenge or reject your application. If the Community Challenge is launched, it will be displayed on the Site and Community Challenge Participants would be able to submit their Community Challenge Visual Content in respect of your Community Challenge.</li><li>You agree that PIXERF may, but is not obliged to, make additions, deletion or any other amendments to the Community Challenge Brief at any time, for any reason whatsoever, and without any notice to you.</li></ol></li><li><span class=\"terms-page-howitworks__sub-heading text--bold text--color-black\">Removal of Community Challenge Visual Content</span><p>PIXERF may, at its sole discretion, remove or reject any Community Challenge Visual Content for any reasons whatsoever, including but not limited to marketability or the Community Challenge Participant\'s failure or neglect to comply with any curatorial and submission guidelines or procedures.</p></li><li><span class=\"terms-page-howitworks__sub-heading text--bold text--color-black\">Winning Submission(s) and Special Mention Submission(s)</span><ol><li><span class=\"terms-page-howitworks__sub-heading text--bold text--color-black\">Selection</span>. You shall select the winning submission(s) and the special mention submission(s) from the Community Challenge Visual Content in accordance with the Community Challenge brief (the \"<span class=\"text--bold text--color-black\">Winning Submission(s)</span>\" and the \"<span class=\"text--bold text--color-black\">Special Mention Submission(s)</span>\" respectively)and notify PIXERF of your selection within thirty (30) days after the Community Challenge End Date. Any such selection shall be final and conclusive once notified to PIXERF.</li><li>If you wish to award more Special Mention Submissions than you had initially selected when selecting your Community Challenge type (up to the maximum number permitted for your Community Challenge type), you may do so by notifying PIXERF at <a href=mailto:business@pixerf.com class=subscription-page-business-link>business@pixerf.com</a> and making payment of such additional Special Mention Submission(s) in accordance with Clause 5 (Payment) below.</li><li>In the event that you do not select the Winning Submission(s) within the 30-day period as set out in Clause 4.1 for any reason whatsoever, PIXERF shall be entitled, but not obliged, to select them on your behalf within seven (7) days from the end of the 30-day period.</li><li><span class=\"terms-page-howitworks__sub-heading text--bold text--color-black\">Prize</span>. The Community Challenge Participant(s) who had posted, uploaded or displayed the Winning Submission(s) shall be entitled to the prize as displayed in the Community Challenge Brief (the \"<span class=\"text--bold text--color-black\">Prize</span>\").</li><li>After thirty (30) days from the Community Challenge End Date, or thirty-seven (37) days from the Community Challenge End Date if you do not select the Winning Submission(s) within the 30-day period, any Community Challenge Visual Content which were not selected by you or PIXERF (as the case may be) as the Winning Submission(s) or the Special Mention Submission(s) will be transferred to the Marketplace as Marketplace Visual Content. PIXERF shall not be liable for any costs, charges, damages or losses sustained or incurred by any party which arises, whether directly or indirectly, from any delay, failure or neglect by you in selecting the Winning Submission(s) or the Special Mention Submission(s) by the relevant date.</li><li><span class=\"terms-page-howitworks__sub-heading text--bold text--color-black\">Notice</span>. While PIXERF will use reasonable endeavours to notify the Community Challenge Participant(s) who submitted or uploaded the Winning Submission(s) and/or the Special Mention Submission(s) of the same by way of email at their email address provided to PIXERF within thirty (30) days from the Community Challenge End Date, or thirty-seven (37) days from the Community Challenge End Date if you do not select the Winning Submission(s) within the 30-day period, PIXERF shall not be obliged to do so.</li></ol></li><li><span class=\"terms-page-howitworks__sub-heading text--bold text--color-black\">Payment</span><ol><li>You may choose to make payment via Paypal or bank transfer for your Challenge and the prizes for the Winning Submission(s) and Special Mention Submission(s) before the Challenge can be launched. You shall make such payment (i) within fifteen (15) days of the date on which your Challenge application is approved; or (ii) when you want to launch the Challenge, whichever is earlier.</li><li>You may choose to make payment via Paypal or bank transfer for any additional Special Mention Submission(s) which you wish to select, and any other additional features in this Agreement.</li></ol></li><li><span class=\"terms-page-howitworks__sub-heading text--bold text--color-black\">Taxes</span><ol><li>You shall pay all applicable goods and services tax, duties or levies whatsoever at the rate which may from time to time be imposed or charged at any time by any government, statutory or tax authority on or calculated by reference to the amount of any sums payable by you under this Agreement or to reimburse us for the payment of such taxes, duties or levies immediately on receipt of written notice from PIXERF.</li><li>If PIXERF shall at any time be compelled by any applicable law to withhold or deduct any tax on your behalf from any amount payable to you hereunder, PIXERF shall, when making payment to you, make payment of such tax at the applicable rate to the appropriate tax authority and shall promptly furnish to you written receipts from the appropriate tax authority certifying that such payments have been made.</li></ol></li><li><span class=\"terms-page-howitworks__sub-heading text--bold text--color-black\">Grant of Licence</span><ol><li>Subject to receipt of all sums payable from you to PIXERF under this Agreement, PIXERF grants to you the relevant licence(s) to the Winning Submission(s) and/or the Special Mention Submission(s) as stated in the Community Challenge Brief. Unless otherwise stated in the Community Challenge Brief, such applicable licence shall be the Standard Licence as described in the <a target=__blank ui-sref=introduction-company.license class=subscription-page-business-link>Licence Agreement</a>.</li><li>In addition, the Winning Submission(s) will only be transferred to the Marketplace after sixty (60) days from the date of award. If you wish to extend this period, you may submit a written request to PIXERF at <a href=mailto:business@pixerf.com class=subscription-page-business-link>business@pixerf.com</a>. PIXERF may grant such extension for an additional amount at its discretion.</li></ol></li><li><span class=\"terms-page-howitworks__sub-heading text--bold text--color-black\">Intellectual Property Rights</span><p>Limited Transfer of Rights. All Community Challenge Visual Content shall be owned, licensed to or controlled by either PIXERF or the Community Challenge Participant(s) who submitted or uploaded the Community Challenge Visual Content. Save for those rights expressly granted to you in this Agreement, no other rights to the Community Challenge Visual Content are granted by PIXERF to you.</p></li><li><span class=\"terms-page-howitworks__sub-heading text--bold text--color-black\">Terms and Termination</span><ol><li>This Agreement shall continue in effect until it is terminated by either you or PIXERF as set out in these terms. You may terminate this Agreement by giving PIXERF no less than seven (7) working days’ notice in writing if PIXERF has breached or failed to comply with any of its obligations under this Agreement.</li><li>PIXERF may terminate this Agreement by giving you no less than seven (7) working days\' notice in writing for any reason. PIXERF may also terminate this Agreement immediately by giving you written notice if you fail or refuse to perform or comply with any of your obligations under this Agreement or any other agreement which you may have with PIXERF; or engage in any conduct which may affect or damage the name, reputation or goodwill of PIXERF.</li><li>In the event of termination of this Agreement for any reason, you shall:<ol><li>cease to use or access any Community Challenge Visual Content, and must delete and destroy all copies of the same thereof, whether electronic or print. If requested, you shall prove to PIXERF\'s satisfaction that you have complied with these requirements;</li><li>not be entitled to, and waive any entitlement to any refund, in full or part thereof, of any sums of money already paid to PIXERF. For the avoidance for doubt, this would apply even if you do not obtain the required subject, quality or number of submissions for your Community Challenge.</li></ol></li><li>Notwithstanding the termination of this Agreement, all the provisions of this Agreement which are intended to have effect on and/or after the termination of this Agreement shall survive the termination and shall be deemed to remain in full force and effect.</li></ol></li><li><span class=\"terms-page-howitworks__sub-heading text--bold text--color-black\">Disclaimer of Warranties</span><p>Any content or services provided by PIXERF under this Agreement, including the Community Challenge Visual Content, are provided on an \"as is\", \"as available\" basis, without representation, warranty or condition of any kind, implied, express or statutory, including but not limited to the representations or warranties of non-infringement of third party rights, title, merchantability, satisfactory quality and/or fitness for a particular purpose. In particular, PIXERF does not represent or warrant the transmission, accuracy, completeness, timeliness or adequacy of any content or services.</p></li><li><span class=\"terms-page-howitworks__sub-heading text--bold text--color-black\">Disclaimer of Liability</span><p>Notwithstanding any other provision in this Agreement, PIXERF shall not be liable to you or any other person or entity for any punitive, special, direct, indirect, consequential, incidental or other similar damages, costs or losses of any kind suffered or incurred by you or any third party arising from or in connection with this Agreement, its termination or expiration.</p></li><li><span class=\"terms-page-howitworks__sub-heading text--bold text--color-black\">Indemnity</span><p>You agree to indemnify, defend and hold PIXERF, its officers, directors, shareholders, predecessors, successors-in-title, employees, agents, subsidiaries and affiliates, harmless from all demands, claims, actions, proceedings, judgements, orders, decrees, damages, costs, losses and expenses of any nature whatsoever (including but not limited to legal costs on an indemnity basis) arising out of or in connection with any breach or alleged breach or failure by you (or anyone acting on your behalf) to comply with any of terms of this Agreement. These indemnity obligations shall survive any termination of this Agreement or your user account on the Site.</p></li><li><span class=\"terms-page-howitworks__sub-heading text--bold text--color-black\">General</span><ol><li><span class=\"text--bold text--color-black\">Notices</span>. All notices required to be sent to PIXERF under this Agreement shall be sent via email to <a href=mailto:business@pixerf.com class=subscription-page-business-link>business@pixerf.com</a>. All notices required to be sent to you by PIXERF under this Agreement shall be sent via email to the email address set out in your user account.</li><li><span class=\"text--bold text--color-black\">Severability</span>. The illegality, invalidity or unenforceability of any provision of this Agreement under the law of any jurisdiction shall not affect its legality, validity or enforceability under the law of any other jurisdiction nor the legality, validity or enforceability of any other provision.</li><li><span class=\"text--bold text--color-black\">No Waiver</span>. No failure on the part of any party to exercise, and no delay on its part in exercising, any right or remedy under this Agreement will operate as a waiver thereof, nor will any single or partial exercise of any right or remedy preclude any other or further exercise thereof or the exercise of any other right or remedy. The rights and remedies provided in this Agreement are cumulative and not exclusive of any rights or remedies provided by law.</li><li><span class=\"text--bold text--color-black\">Governing Law</span>. This Agreement shall be construed and its performance governed in accordance with the laws of the Republic of Singapore.</li></ol></li><p>The last update to our Community Challenge Sponsor Agreement was posted on 31 August 2021.</p></ol></div></div><div class=terms-page-howitworks__content-right></div></section></div>");
$templateCache.put("app/run-a-challenge-page/components/community-challenge-agreement/community-challenge-agreement.html","<div class=\"terms-page no-margin community-challenge-agreement\"><section class=\"row community-challenge-agreement__wrapper\"><div class=community-challenge-agreement__content-left><p class=community-challenge-agreement__heading>Community Challenge Agreement</p><div class=community-challenge-agreement__main-content><p>This Community Challenge Agreement (the \"<u class=\"text--bold text--color-black\">Agreement</u>\") between you (the \"<u class=\"text--bold text--color-black\">you</u>\", \"<u class=\"text--bold text--color-black\">your</u>\" or the \"<u class=\"text--bold text--color-black\">Community Challenge Participant</u>\") and PIXERF PTE LTD \"<u>PIXERF</u>\" sets forth the terms and conditions that apply when you submit or upload any Community Challenge Visual Content (as defined below) for the purposes of participating in a Community Challenge (as defined below).</p><p>Please review this Agreement carefully before submitting or uploading any Community Challenge Visual Content. By either submitting or uploading any Community Challenge Visual Content, you agree to be bound by the terms of this Agreement, the <a ui-sref=explore-creators-page.creator-agreement target=__blank class=subscription-page-business-link>Creator Agreement</a>, the <a target=__blank ui-sref=introduction-company.terms class=subscription-page-business-link>Terms and Conditions</a> and the <a target=__blank ui-sref=introduction-company.privacy class=subscription-page-business-link>Privacy Policy</a>. If you do not agree to any of these terms, please do not submit or upload any Community Challenge Visual Content.</p><p>The Community Challenges are not sponsored by, associated with or connected to Apple or Google in any manner.</p><ol><li><span class=community-challenge-agreement__sub-heading>Interpretation and Definitions</span><ol><li>In this Agreement, unless the context otherwise requires, the following words or expressions shall have the following meanings:</li><table class=community-challenge-agreement__table><tr><th>“<span class=\"text--bold text--color-black\">Community Challenge</span>”</th><td>means an event organised by PIXERF on or through PIXERF’s platform at www.pixerf.com for the Community Challenge Sponsor to crowdsourced Community Challenge Visual Content in accordance with the specified requirements;</td></tr><tr><th>“<span class=\"text--bold text--color-black\">Community Challenge Period</span>”</th><td>means, in relation to a particular Community Challenge, the period of time during which you may submit or upload Community Challenge Visual Content for that Community Challenge;</td></tr><tr><th>“<span class=\"text--bold text--color-black\">Community Challenge End Date</span>”</th><td>means, in relation to a particular Community Challenge, the date on which the relevant Community Challenge Period ends;</td></tr><tr><th>“<span class=\"text--bold text--color-black\">Community Challenge Specific Rules</span>”</th><td>refers to the specific terms and conditions that are applicable to a particular Community Challenge;</td></tr><tr><th>“<span class=\"text--bold text--color-black\">Community Challenge Sponsor</span>”</th><td>means, in relation to a particular Community Challenge, either PIXERF or the third party who commissioned the Community Challenge (as the case may be);</td></tr><tr><th>“<span class=\"text--bold text--color-black\">Community Challenge Start Date</span>”</th><td>means, in relation to a particular Community Challenge, the date on which the relevant Community Challenge Period begins; and</td></tr><tr><th>“<span class=\"text--bold text--color-black\">Community Challenge Visual Content</span>”</th><td>means the content, including photographs, illustrations, vector graphics and videos, which you post, upload, display or otherwise make available for the purposes of participating in a Community Challenge.</td></tr></table><li>In the event of any inconsistency or conflict between the provisions of this Agreement and any of the provisions of the <a target=__blank ui-sref=explore-creators-page.creator-agreement class=subscription-page-business-link>Creator Agreement</a>, the <a target=__blank ui-sref=introduction-company.terms class=subscription-page-business-link>Terms and Conditions</a> or the<a target=__blank ui-sref=introduction-company.privacy class=subscription-page-business-link>Privacy Policy</a>, the provisions of this Agreement shall prevail.</li><li>Unless otherwise defined in this Agreement, the terms used herein shall bear the same meanings as in the <a target=__blank ui-sref=introduction-company.terms class=subscription-page-business-link>Terms and Conditions</a>.</li></ol></li><li><span class=community-challenge-agreement__sub-heading>Submission of Community Challenge Visual Content</span><ol><li>PIXERF may determine at its sole discretion which Community Challenge Visual Content is deemed suitable for submission or upload by you. PIXERF may provide submission guidelines and procedures for the Community Challenge Visual Content, which may be revised from time to time, and you agree to comply with such submission guidelines and procedures (including any revisions thereto) by submitting or uploading any Community Challenge Visual Content. Any breach of these guidelines and procedures may be deemed to be a breach of this Agreement in PIXERF’s sole discretion.</li><li><span class=\"text--bold text--color-black\">Community Challenge Specific Rules.</span> Each Community Challenge Visual Content which you submit or upload will be subject to the Community Challenge Specific Rules, which may include, but is not limited to, eligibility and participation requirements; artistic directions or requirements; the Community Challenge Start Date; the Community Challenge Period; and the applicable prizes.</li><li>You agree that the Community Challenge Sponsor and/or PIXERF may make changes and amendments to the Community Challenge Specific Rules and/or to the terms of this Agreement at any time, for whatever reason, and without any prior notice, and you agree to be bound by such changes and amendments.</li><li>All information requested by and supplied to PIXERF for the purpose of a Community Challenge must be complete, up-to-date, accurate and not misleading. PIXERF reserves the right, in its sole discretion, to disqualify any Community Challenge Participant at any time if they provide any incomplete, outdated, inaccurate or misleading details and/or information.</li><li><span class=\"text--bold text--color-black\">Removal of Community Challenge Visual Content.</span> PIXERF reserves the right to remove or reject Community Challenge Visual Content based on marketability, your failure or neglect to comply with the Community Challenge Specific Rules or any other submission guidelines or procedures, or for any other reason whatsoever as determined by PIXERF in its sole and absolute discretion. Any licence for the Community Challenge Visual Content which had been issued or granted by you prior to such removal or termination of this Agreement shall continue in effect. If PIXERF elects to remove or reject any such Community Challenge Visual Content which is not already available in the Marketplace, this Community Challenge Visual Content may be transferred by PIXERF in its discretion to the Marketplace through the Community Challenge Participant’s account. Upon such transfer, the Transfer Terms set out in Clause 7.2 below shall apply.</li><li><span class=\"text--bold text--color-black\">Releases.</span> Community Challenge Visual Content may be marked as for \"Editorial Use Only\" or for \"Commercial Use\". You may be required to submit model or property releases for your Community Challenge Visual Content in order for it to be marked as for \"Commercial Use\", if the Community Challenge Visual Content contains images of people or persons in relation to model releases, or if the Community Challenge Visual Content contains identifiable property in relation to property releases (collectively, the \"Releases\"). The forms for these Releases can be downloaded from the particular Community Challenge’s web page or from <a class=subscription-page-business-link ui-sref=introduction-support.releases>https://pixerf.com/#/introduction/support/releases</a>.</li></ol></li><li><span class=community-challenge-agreement__sub-heading>Winning Submission(s) and Special Mention Submission(s)</span><ol><li><span class=\"text--bold text--color-black\">Selection</span>. After the Community Challenge End Date, the Community Challenge Sponsor and/or PIXERF shall select the Winning Submissions(s) and the Special Mention Submission(s) (if any) from the Community Challenge Visual Content in accordance with the Community Challenge Specific Rules (the “<span class=\"text--bold text--color-black\">Winning Submission(s)</span>” and the “<span class=\"text--bold text--color-black\">Special Mention Submission(s)</span>” respectively). The Community Challenge Sponsor shall make its selections within 30 days from the Community Challenge End Date. In the event that the Community Challenge Sponsor fails to select the Winning Submission(s) within the 30-day period, PIXERF shall be entitled, but not obliged, to select the Winning Submission(s) within 7 days from the 30-day period. Upon selection by the Community Challenge Sponsor and/or PIXERF (as the case may be), PIXERF shall notify the Community Challenge Participant(s) who had submitted or uploaded the Winning Submission(s) or the Special Mention Submission(s) (if any) of the same through email at the email address provided to PIXERF.</li><li><span class=\"text--bold text--color-black\">Winning Prize(s)</span>. The Community Challenge Participant(s) who had posted, uploaded or displayed the Community Challenge Visual Content which is/are selected as the Winning Submission(s) shall be entitled to the prize (the “<span class=\"text--bold text--color-black\">Winning Prize(s)</span>”), the particulars of which shall be stipulated in the Community Challenge Specific Rules. The Winning Prize(s) may be monetary, non-monetary or a combination of both. For the avoidance of doubt, the relevant provisions of the <a target=__blank ui-sref=explore-creators-page.creator-agreement class=subscription-page-business-link>Creator Agreement</a> on compensation in respect of Community Challenges submissions shall not apply to the Winning Submission(s).</li><li><span class=\"text--bold text--color-black\">Special Mention Prize(s)</span>. The Community Challenge Participant(s) who had posted, uploaded or displayed the Community Challenge Visual Content which is/are selected as the Special Mention Submission(s) (if any) shall be entitled to the monetary prize(s) (the “<span class=\"text--bold text--color-black\">Special Mention Prize</span>”) in accordance with the following rate schedule:<p></p><p>[*x per cent (x%)] of S$50.00 (being the licensing fee PIXERF will receive from the licensing of each of the Community Challenge Participant(s)’s Special Mention Submission(s)) in relation to standard licences.</p><p>* [x%] refers to the applicable percentage as set out in the relevant provisions of the <a target=__blank ui-sref=explore-creators-page.creator-agreement class=subscription-page-business-link>Creator Agreement</a> on compensation in respect of Community Challenge\'s submissions, which will be varied accordingly.</p></li><li>The Winning Prize(s) and the Special Mention Prize(s) (if any) are subject to the following conditions:<ol><li>such prize(s) must be accepted by the Community Challenge Participant(s) without substitution, transfer, exchange or assignment;</li><li>the Community Challenge Participant(s) shall be responsible for any and all costs and expenses which they may incur in the course of or arising from claiming or using such prize(s) or part thereof; and</li><li>the Community Challenge Participant(s) agree and acknowledge that PIXERF may substitute such prize(s) or part thereof, for a replacement that PIXERF determines to be of equal or greater value if such prize(s) or part thereof cannot be awarded or delivered for any reason.</li></ol></li><li>Any award or payment to the Community Challenge Participant(s) who posted, uploaded or displayed the Winning Submission(s) and/or the Special Mention Submission(s) (if any) shall be made in accordance with Clause 4.</li></ol></li><li><span class=community-challenge-agreement__sub-heading>Prize Award</span><ol><li>The Community Challenge Participant(s) who are entitled to Winning Prize(s) or Special Mention Prize(s), where such prize(s) or part thereof are monetary, shall, within two (2) weeks from the date of the email notification from PIXERF of such selection as set out in Clause 3.2, inform PIXERF of whether they elect to receive payment via PayPal, a cheque or wire transfer, and:<ol><li>if such Community Challenge Participant(s) elects to receive payment through PayPal, the valid PayPal payment details to which PIXERF may transfer or remit the monetary prize(s) or part thereof; or</li><li>if such Community Challenge Participant(s) elects to receive payment in a cheque or through wire transfer, all information necessary for PIXERF to make arrangements to effect such payment. If the Community Challenge Participant elects to receive payment via cheque or wire transfer, they shall bear any applicable transaction fees or charges.</li></ol><p>PIXERF shall effect payment of the monetary prize(s) to the relevant Community Challenge Participant(s) within thirty (30) days following the end of the reporting month during which the Community Challenge Participant(s) informs PIXERF of the requested information above. The Community Challenge Participant(s) acknowledges and agrees that PIXERF relies on them to provide the requested information above, and that PIXERF shall not be liable if they fail to notify PIXERF in accordance with this clause</p></li><li>Where the Winning Prize(s) or part thereof are non-monetary, PIXERF shall make arrangements for its collection and inform you accordingly. PIXERF shall have no obligations in respect of any non-monetary prize(s) which are not collected by the time and date specified by PIXERF.</li><li>Notwithstanding any provision to the contrary, PIXERF shall only be responsible for awarding or delivering the Winning Prize(s) and/or the Special Mention Prize(s) (as the case may be) to the Community Challenge Participant(s) if PIXERF receives the same from the relevant Community Challenge Sponsor by the applicable date. PIXERF shall not be liable to any person in the event that the Community Challenge Sponsor fails and/or neglects to deliver or send the Winning Prize(s) and/or the Special Mention Prize(s) (as the case may be) to it.</li></ol></li><li><span class=community-challenge-agreement__sub-heading>Grant of Rights</span><ol><li>Subject to this Agreement, you may grant PIXERF either an exclusive or a non-exclusive licence to license, sublicense, market and distribute the Community Challenge Visual Content worldwide, and to copy, use, reproduce, distribute, publish, transmit, broadcast, perform, display, exhibit, adapt, modify, edit or enhance any Community Challenge Visual Content, in whole or in part, alone or in combination with any other material, in any media or embodiment, now known or later developed, for any lawful purpose, including the right to distribute and sell consumer products (for example, by reproducing the Community Challenge Visual Content on products sold to consumers including but not limited to posters, mugs, calendars, website templates, card templates).</li><li>PIXERF shall have complete and sole discretion regarding the terms, conditions and pricing of any Community Challenge Visual Content that it sub-licenses to other Users without your prior approval.</li><li>If you elect to grant PIXERF an exclusive licence in relation to the Community Challenge Visual Content, you agree to not license or distribute the Community Challenge Visual Content to any other party until the exclusivity period expires. You may use any Community Challenge Visual Content submitted for your own personal, non-commercial purposes, for example, your portfolio, personal website and self-promotion. However, you shall refer any licensing requests regarding the Community Challenge Visual Content to PIXERF.</li><li>In addition to the foregoing, you grant PIXERF the right, but not the obligation, to use your name, trademarks and trade names, and the right to reproduce, display, transmit, exhibit, modify and adapt any Community Challenge Visual Content to promote, market and advertise PIXERF or otherwise for PIXERF’s own business purposes in relation to the promotion of the Site; and you agree that no compensation or further consent will be required for such use.</li><li>In the event that you have elected to grant PIXERF an exclusive licence in relation to the Community Challenge Visual Content, you thereby grant PIXERF the exclusive right, but not the obligation, to determine in its sole discretion whether and to what extent to proceed with any legal proceedings or action, and/or to defend any claims or counterclaims regarding the Community Challenge Visual Content. Any such legal action or proceeding may be settled or resolved by PIXERF without your prior approval and will not be subject to it, provided that PIXERF shall not enter into any settlement or resolution which will diminish your ownership in the Community Challenge Visual Content.</li><li>Where PIXERF has elected to commence any legal proceedings or actions, and/or to defend any claims or counterclaims regarding the Community Challenge Visual Content, you agree to give PIXERF control of the handling, settlement, or defence of any such claims, and to provide assistance to PIXERF in relation to the legal proceedings or actions, including but not limited to providing PIXERF and our professional advisors with reasonable access to any relevant documents and records. You further agree to be named in and be joined in as a party to any such proceedings or actions in or defence of any legal claim.</li><li>Where PIXERF has elected not to commence any legal proceedings or actions, and/or to defend any claims or counterclaims regarding the Community Challenge Visual Content, you retain the right to bring an action in your own name and at your own expense. You agree that any recovery you receive in your own legal action involving the Community Challenge Visual Content, whether through settlement, adjudication or otherwise, shall be divided between you and PIXERF in accordance with the applicable percentages as set out in the relevant provisions of the <a target=__blank ui-sref=explore-creators-page.creator-agreement class=subscription-page-business-link>Creator Agreement</a> on compensation after payment of all reasonable legal costs and expenses.</li></ol></li><li><span class=community-challenge-agreement__sub-heading>Proprietary Rights</span><ol><li><span class=\"text--bold text--color-black\">Ownership</span>. You retain ownership of the copyright in the Community Challenge Visual Content. While PIXERF will take commercially reasonable steps to ensure that your rights are not violated by other Users or other parties, PIXERF has no obligation to pursue any legal action regarding any alleged infringement of any rights in relation to any Community Challenge Visual Content.</li><li><span class=\"text--bold text--color-black\">Credit</span>. While PIXERF will use commercially reasonable efforts to credit you as the source of the Community Challenge Visual Content, you acknowledge that the Users may not credit you as the owner or author of the Community Challenge Visual Content licensed by PIXERF, and that PIXERF may be associated with the Community Challenge Visual Content as the source of such content, without any liability to PIXERF or the Users. You further acknowledge and agree that related metadata may be altered, removed or modified, without any liability to PIXERF or the Users.</li><li>You acknowledge that PIXERF prohibits any Community Challenge Visual Content, descriptive information regarding such content or any other material that infringes on any patent, trademark, copyright, trade secret, right to privacy, right to publicity, or any other applicable law or proprietary right from being submitted or uploaded to the Site. By submitting or uploading Community Challenge Visual Content, you are warranting that you own all ownership rights to the Community ChallengeVisual Content or are the authorised representative of the copyright owner(s) of such Community Challenge Visual Content, with full power to grant the rights set out in this Agreement.</li></ol></li><li><span class=community-challenge-agreement__sub-heading>Transfer of Community Challenge Visual Content to Marketplace</span><ol><li>You agree that all Community Challenge Visual Content will be transferred by PIXERF to the Marketplace in accordance with the Transfer Terms by either (i) the date following thirty-seven (37) days after the Community Challenge End Date or (ii) date following when the Winning Submission(s) and Special Mention Submission(s) (if any) are selected, whichever is earlier, save for the Winning Submission(s) which will be transferred by the date following sixty (60) days after the Community Challenge End Date.</li><li>The terms contained in this clause govern the transfer of the Community Challenge Visual Content to the Marketplace (the <span class=\"text--bold text--color-black\">“Transfer Terms</span>”). You agree that:<ol><li>(a) upon such transfer, the <a target=__blank ui-sref=explore-creators-page.creator-agreement class=subscription-page-business-link>Creator Agreement</a> shall apply to such transferred Community Challenge Visual Content as though you had posted, uploaded, displayed or otherwise made available on or through the Marketplace such transferred Community Challenge Visual Content; and</li><li>(b) upon such transfer and in relation to such transferred Community Challenge Visual Content, the terms of the <a target=__blank ui-sref=explore-creators-page.creator-agreement class=subscription-page-business-link>Creator Agreement</a> shall take precedence in the event of any conflict or inconsistency between the terms of the <a target=__blank ui-sref=explore-creators-page.creator-agreement class=subscription-page-business-link>Creator Agreement</a> and the terms of this Agreement, the <a target=__blank ui-sref=introduction-company.terms class=subscription-page-business-link>Terms and Conditions</a> or the <a target=__blank ui-sref=introduction-company.privacy class=subscription-page-business-link>Privacy Policy</a>.</li></ol></li></ol></li><li><span class=community-challenge-agreement__sub-heading>Taxes</span><ol><li>You shall pay all applicable goods and services tax, duties or levies whatsoever at the rate which may from time to time be imposed or charged at any time by any government, statutory or tax authority on or calculated by reference to the amount of any sums payable by you hereunder or to reimburse us for the payment of such taxes, duties or levies immediately on receipt of written notice from us.</li><li>If PIXERF shall at any time be compelled by any applicable law to withhold or deduct any tax on your behalf from any amount payable to you hereunder, we shall, when making payment to you, make payment of such tax at the applicable rate to the appropriate tax authority and shall furnish to you written receipts from the appropriate tax authority certifying that such payments have been made.</li></ol></li><li><span class=community-challenge-agreement__sub-heading>Term and Termination</span><ol><li>This Agreement continues in effect until it is terminated by you or by PIXERF as set out in these terms. You may terminate this Agreement by giving seven (7) days’ written notice to PIXERF prior to the Community Challenge End Date. PIXERF may terminate this Agreement immediately by giving written notice to you. Either party may terminate this Agreement immediately by giving written notice if the other party breaches or fails to comply with any of the terms of this Agreement, makes an assignment for the benefit of its creditors, becomes insolvent, or is subject to bankruptcy or liquidation proceedings.</li><li>If you had terminated this Agreement in accordance with Clause 9.1, you have the right but not the obligation to remove from the Community Challenge any of your Community Challenge Visual Content which you had submitted or uploaded. However, such removal does not mean that it will be removed from the Marketplace.</li><li>If PIXERF had terminated this Agreement in accordance with Clause 9.1, PIXERF has the right to remove any of your Community Challenge Visual Content at any time and from time to time after such termination.</li><li>If this Agreement is terminated, whether by you or PIXERF and for whatever reason,<ol><li>PIXERF may retain digital copies of the Community Challenge Visual Content for PIXERF’s records; and</li><li>PIXERF will not be obliged to select any of your Community Challenge Visual Content as the Winning Submission(s) or Special Mention Submission(s) (if applicable) and, accordingly, will not be obliged to award or deliver any Winning Prize(s) or Special Mention Prize(s) to you as set out in Clauses 3 and 4 above.</li></ol></li><li>Notwithstanding the provisions herein, any licence for the Community Challenge Visual Content which had been issued or granted by you prior to any termination of this Agreement shall continue in effect.</li></ol></li><li><span class=community-challenge-agreement__sub-heading>Your Representations and Warranties</span><ol><li>You represent and warrant to PIXERF as follows:<ol><li>you have the full right and authority to execute and perform your obligations in accordance with the terms of this Agreement;</li><li>if you are an individual, that you are at least 18 years old, and have the full power and authority to enter into this Agreement and perform your obligations hereunder;</li><li>you are the sole and exclusive owner, including copyright, of any Community Challenge Visual Content submitted or uploaded, or are the authorised representative of the applicable copyright owner(s) of the Community Challenge Visual Content, with full power to grant the rights set out in this Agreement</li><li>you have not granted any rights or interests in any Community Challenge Visual Content to any third party that is contrary to any of the rights or interests granted to PIXERF under this Agreement;</li><li>you will not submit or upload any Community Challenge Visual Content that:<ol><li>is defamatory, profane, inappropriate, indecent, obscene or pornographic;</li><li>infringes, violates or misappropriates any third party copyrights, trademarks, rights of privacy or publicity, or any applicable law, rule or regulation;</li></ol></li><li>any descriptions, keywords, metadata, copyright management information or other information or documents (such as Releases) submitted with the Community Challenge Visual Content is timely, accurate and complete, does not contain false or misleading information, and complies with PIXERF\'s applicable submission guidelines or policies;</li><li>you have obtained valid and binding model and/or property releases for each Community Challenge Visual Content where necessary or required by applicable law, and that PIXERF may use such Community Challenge Visual Content without obtaining any further consents or making payment of any additional fees to any third parties;</li><li>you acknowledge and agree that the creator or source of the Community Challenge Visual Content may not be credited by other Users, and that the Community Challenge Visual Content may be modified, adapted and/or used in connection with sensitive, unflattering or controversial subject matters, materials or contexts;</li><li>you will not use the Site for the purposes of conducting and/or disseminating surveys, contests, pyramid schemes, chain letters, junk email, spamming or sending of any duplicative or unsolicited messages; and</li><li>you will not transmit, submit or upload any files that contain viruses, Trojan horses, time bombs, spyware, adware, or other malicious, invasive or deleterious code or programme.</li></ol></li></ol></li><li><span class=community-challenge-agreement__sub-heading>Disclaimer of Warranties</span><ol><li>The Community Challenge(s), including any content, services, Winning Prize(s) or Special Mention Prize(s) provided in relation thereto, are provided on an \"as is\", \"as available\" basis, without representation, warranty or condition of any kind, implied, express or statutory, including but not limited to the representations or warranties of non-infringement of third party rights, title, merchantability, satisfactory quality and/or fitness for a particular purpose. In particular, PIXERF does not represent or warrant the transmission, accuracy, completeness, timeliness or adequacy of the Community Challenge(s), or that it would be provided uninterrupted or error free.</li></ol></li><li><span class=community-challenge-agreement__sub-heading>Indemnity</span><ol><li>You agree to indemnify, defend and hold PIXERF, our officers, directors, shareholders, predecessors, successors in interest, employees, agents, subsidiaries and affiliates, harmless from all demands, claims, actions, proceedings, judgements, orders, decrees, damages, costs, losses and expenses of any nature whatsoever (including but not limited to legal costs on an indemnity basis) against us by any third party due to or arising out of or in connection with any breach or alleged breach or failure by you (or anyone acting on your behalf) to comply with any representation or warranty or other term of this Agreement. You agree that PIXERF may retain any amounts due to you in the event that PIXERF is owed any sum under this clause</li><li>Your obligations under the foregoing indemnity may not be offset against any other claim that you may have against PIXERF, or any of our officers, directors, employees, agents, subsidiaries and affiliates. You agree that these indemnity obligations shall survive any termination of your user account on the Site.</li></ol></li><li><span class=community-challenge-agreement__sub-heading>Disclaimer of Liability</span><ol><li>Notwithstanding any other provision in this Agreement, PIXERF shall not be liable to you or any other person or entity for any punitive, special, indirect, consequential, incidental or other similar damages, costs or losses arising out of this Agreement, its termination or expiration. Some jurisdictions do not permit the exclusion or limitation of implied warranties or liability.</li></ol></li><li><span class=community-challenge-agreement__sub-heading>General</span><ol><li><span class=\"text--bold text--color-black\">Notices</span>. All notices required to be sent to PIXERF under this Agreement shall be sent via email to notify@pixerf.com. All notices required to be sent to you by PIXERF under this Agreement shall be sent via email to the email address set out in your user account.</li><li><span class=\"text--bold text--color-black\">Severability</span>. The illegality, invalidity or unenforceability of any provision of this Agreement under the law of any jurisdiction shall not affect its legality, validity or enforceability under the law of any other jurisdiction nor the legality, validity or enforceability of any other provision.</li><li><span class=\"text--bold text--color-black\">No Waiver</span>. No failure on the part of any party to exercise, and no delay on its part in exercising, any right or remedy under this Agreement will operate as a waiver thereof, nor will any single or partial exercise of any right or remedy preclude any other or further exercise thereof or the exercise of any other right or remedy. The rights and remedies provided in this Agreement are cumulative and not exclusive of any rights or remedies provided by law.</li></ol></li><li><span class=community-challenge-agreement__sub-heading>Governing Law</span><ol><li>This Agreement shall be construed and its performance governed in accordance with the law of the Republic of Singapore.</li></ol></li><p>The last update to our Community Challenge Agreement was posted on 31 August 2021.</p></ol></div></div><div class=community-challenge-agreement__content-right></div></section></div>");
$templateCache.put("app/run-a-challenge-page/components/community-challenge-agreement-gojek/community-challenge-agreement-gojek.html","<div class=\"terms-page no-margin community-challenge-agreement-gojek\"><section class=\"row community-challenge-agreement-gojek__wrapper\"><div class=community-challenge-agreement-gojek__content-left><p class=community-challenge-agreement-gojek__heading>Missions Agreement</p><div class=community-challenge-agreement-gojek__main-content><p>This Missions Agreement (the \"<u class=\"text--bold text--color-black\">Agreement</u>\") between you (the \"<u class=\"text--bold text--color-black\">you</u>\", \"<u class=\"text--bold text--color-black\">your</u>\" or the \"<u class=\"text--bold text--color-black\">Mission Participant</u>\") and PIXERF PTE LTD \"<u>PIXERF</u>\" sets forth the terms and conditions that apply when you submit or upload any Mission Visual Content (as defined below) for the purposes of participating in a Mission (as defined below).</p><p>Please review this Agreement carefully before submitting or uploading any Mission Visual Content. By either submitting or uploading any Mission Visual Content, you agree to be bound by the terms of this Agreement, the <a ui-sref=explore-creators-page.creator-agreement target=__blank class=subscription-page-business-link>Contributor Agreement</a>, the <a target=__blank ui-sref=introduction-company.terms class=subscription-page-business-link>Terms and Conditions</a> and the <a target=__blank ui-sref=introduction-company.privacy class=subscription-page-business-link>Privacy Policy</a>. If you do not agree to any of these terms, please do not submit or upload any Mission Visual Content.</p><p>The Missions are not sponsored by, associated with or connected to Apple or Google in any manner.</p><ol><li><span class=community-challenge-agreement-gojek__sub-heading>Interpretation and Definitions</span><ol><li>In this Agreement, unless the context otherwise requires, the following words or expressions shall have the following meanings:</li><table class=community-challenge-agreement-gojek__table><tr><th>“<span class=\"text--bold text--color-black\">Mission</span>”</th><td>means an event organised by PIXERF on or through PIXERF’s platform at www.pixerf.com for the Mission Sponsor to crowdsourced Mission Visual Content in accordance with the specified requirements;</td></tr><tr><th>“<span class=\"text--bold text--color-black\">Mission Period</span>”</th><td>means, in relation to a particular Mission, the period of time during which you may submit or upload Mission Visual Content for that Mission;</td></tr><tr><th>“<span class=\"text--bold text--color-black\">Mission End Date</span>”</th><td>means, in relation to a particular Mission, the date on which the relevant Mission Period ends;</td></tr><tr><th>“<span class=\"text--bold text--color-black\">Mission Specific Rules</span>”</th><td>refers to the specific terms and conditions that are applicable to a particular Mission;</td></tr><tr><th>“<span class=\"text--bold text--color-black\">Mission Sponsor</span>”</th><td>means, in relation to a particular Mission, either PIXERF or the third party who commissioned the Mission (as the case may be);</td></tr><tr><th>“<span class=\"text--bold text--color-black\">Mission Start Date</span>”</th><td>means, in relation to a particular Mission, the date on which the relevant Mission Period begins; and</td></tr><tr><th>“<span class=\"text--bold text--color-black\">Mission Visual Content</span>”</th><td>means the content, including photographs, illustrations, vector graphics and videos, which you post, upload, display or otherwise make available for the purposes of participating in a Mission.</td></tr></table><li>In the event of any inconsistency or conflict between the provisions of this Agreement and any of the provisions of the <a target=__blank ui-sref=explore-creators-page.creator-agreement class=subscription-page-business-link>Contributor Agreement</a>, the <a target=__blank ui-sref=introduction-company.terms class=subscription-page-business-link>Terms and Conditions</a> or the<a target=__blank ui-sref=introduction-company.privacy class=subscription-page-business-link>Privacy Policy</a>, the provisions of this Agreement shall prevail.</li><li>Unless otherwise defined in this Agreement, the terms used herein shall bear the same meanings as in the <a target=__blank ui-sref=introduction-company.terms class=subscription-page-business-link>Terms and Conditions</a>.</li></ol></li><li><span class=community-challenge-agreement-gojek__sub-heading>Submission of Mission Visual Content</span><ol><li>PIXERF may determine at its sole discretion which Mission Visual Content is deemed suitable for submission or upload by you. PIXERF may provide submission guidelines and procedures for the Mission Visual Content, which may be revised from time to time, and you agree to comply with such submission guidelines and procedures (including any revisions thereto) by submitting or uploading any Mission Visual Content. Any breach of these guidelines and procedures may be deemed to be a breach of this Agreement in PIXERF’s sole discretion.</li><li><span class=\"text--bold text--color-black\">Mission Specific Rules.</span> Each Mission Visual Content which you submit or upload will be subject to the Mission Specific Rules, which may include, but is not limited to, eligibility and participation requirements; artistic directions or requirements; the Mission Start Date; the Mission Period; and the applicable prizes.</li><li>You agree that the Mission Sponsor and/or PIXERF may make changes and amendments to the Mission Specific Rules and/or to the terms of this Agreement at any time, for whatever reason, and without any prior notice, and you agree to be bound by such changes and amendments.</li><li>All information requested by and supplied to PIXERF for the purpose of a Mission must be complete, up-to-date, accurate and not misleading. PIXERF reserves the right, in its sole discretion, to disqualify any Mission Participant at any time if they provide any incomplete, outdated, inaccurate or misleading details and/or information.</li><li><span class=\"text--bold text--color-black\">Removal of Mission Visual Content.</span> PIXERF reserves the right to remove or reject Mission Visual Content based on marketability, your failure or neglect to comply with the Mission Specific Rules or any other submission guidelines or procedures, or for any other reason whatsoever as determined by PIXERF in its sole and absolute discretion. Any licence for the Mission Visual Content which had been issued or granted by you prior to such removal or termination of this Agreement shall continue in effect. If PIXERF elects to remove or reject any such Mission Visual Content which is not already available in the Marketplace, this Mission Visual Content may be transferred by PIXERF in its discretion to the Marketplace through the Mission Participant’s account. Upon such transfer, the Transfer Terms set out in Clause 7.2 below shall apply.</li><li><span class=\"text--bold text--color-black\">Releases.</span> Mission Visual Content may be marked as for \"Editorial Use Only\" or for \"Commercial Use\". You may be required to submit model or property releases for your Mission Visual Content in order for it to be marked as for \"Commercial Use\", if the Mission Visual Content contains images of people or persons in relation to model releases, or if the Mission Visual Content contains identifiable property in relation to property releases (collectively, the \"Releases\"). The forms for these Releases can be downloaded from the particular Mission’s web page or from <a class=subscription-page-business-link ui-sref=introduction-support.releases>https://pixerf.com/#/introduction/support/releases</a>.</li></ol></li><li><span class=community-challenge-agreement-gojek__sub-heading>Winning Submission(s) and Special Mention Submission(s)</span><ol><li><span class=\"text--bold text--color-black\">Selection</span>. After the Mission End Date, the Mission Sponsor, PIXERF and PIXERF’s external panel of judges shall select the Winning Submissions(s) and the Special Mention Submission(s) (if any) from the Mission Visual Content in accordance with the Mission Specific Rules (the “<span class=\"text--bold text--color-black\">Winning Submission(s)</span>” and the “<span class=\"text--bold text--color-black\">Special Mention Submission(s)</span>” respectively). The Mission Sponsor shall make its selections within 1 day from the Mission End Date. In the event that the Mission Sponsor fails to select the Winning Submission(s) within the 1-day period, PIXERF shall be entitled, but not obliged, to select the Winning Submission(s) within 1 day from the 1-day period. Upon selection by the Mission Sponsor, PIXERF and PIXERF’s external panel of judges, PIXERF shall notify the Mission Participant(s) who had submitted or uploaded the Winning Submission(s) or the Special Mention Submission(s) (if any) of the same through email at the email address provided to PIXERF.</li><li><span class=\"text--bold text--color-black\">Winning Prize(s)</span>. The Mission Participant(s) who had posted, uploaded or displayed the Mission Visual Content which is/are selected as the Winning Submission(s) shall be entitled to the prize (the “<span class=\"text--bold text--color-black\">Winning Prize(s)</span>”), the particulars of which shall be stipulated in the Mission Specific Rules. The Winning Prize(s) may be monetary, non-monetary or a combination of both. For the avoidance of doubt, the relevant provisions of the <a target=__blank ui-sref=explore-creators-page.creator-agreement class=subscription-page-business-link>Contributor Agreement</a> on compensation in respect of Missions submissions shall not apply to the Winning Submission(s).</li><li><span class=\"text--bold text--color-black\">Special Mention Prize(s)</span>. The Mission Participant(s) who had posted, uploaded or displayed the Mission Visual Content which is/are selected as the Special Mention Submission(s) (if any) shall be entitled to the monetary prize(s) (the “<span class=\"text--bold text--color-black\">Special Mention Prize</span>”) in accordance with the following rate schedule:<p></p><p>[*x per cent (x%)] of S$50.00 (being the licensing fee PIXERF will receive from the licensing of each of the Mission Participant(s)’s Special Mention Submission(s)) in relation to standard licences.</p><p>* [x%] refers to the applicable percentage as set out in the relevant provisions of the <a target=__blank ui-sref=explore-creators-page.creator-agreement class=subscription-page-business-link>Contributor Agreement</a> on compensation in respect of Missions submissions, which will be varied accordingly.</p></li><li>The Winning Prize(s) and the Special Mention Prize(s) (if any) are subject to the following conditions:<ol><li>such prize(s) must be accepted by the Mission Participant(s) without substitution, transfer, exchange or assignment;</li><li>the Mission Participant(s) shall be responsible for any and all costs and expenses which they may incur in the course of or arising from claiming or using such prize(s) or part thereof; and</li><li>the Mission Participant(s) agree and acknowledge that PIXERF may substitute such prize(s) or part thereof, for a replacement that PIXERF determines to be of equal or greater value if such prize(s) or part thereof cannot be awarded or delivered for any reason.</li></ol></li><li>Any award or payment to the Mission Participant(s) who posted, uploaded or displayed the Winning Submission(s) and/or the Special Mention Submission(s) (if any) shall be made in accordance with Clause 4.</li></ol></li><li><span class=community-challenge-agreement-gojek__sub-heading>Prize Award</span><ol><li>The Mission Participant(s) who are entitled to Winning Prize(s) or Special Mention Prize(s), where such prize(s) or part thereof are monetary, shall, within two (2) weeks from the date of the email notification from PIXERF of such selection as set out in Clause 3.2, inform PIXERF of whether they elect to receive payment via PayPal, a cheque or wire transfer, and:<ol><li>if such Mission Participant(s) elects to receive payment through PayPal, the valid PayPal payment details to which PIXERF may transfer or remit the monetary prize(s) or part thereof; or</li><li>if such Mission Participant(s) elects to receive payment in a cheque or through wire transfer, all information necessary for PIXERF to make arrangements to effect such payment. If the Mission Participant elects to receive payment via cheque or wire transfer, they shall bear any applicable transaction fees or charges.</li></ol><p>PIXERF shall effect payment of the monetary prize(s) to the relevant Mission Participant(s) within thirty (30) days following the end of the reporting month during which the Mission Participant(s) informs PIXERF of the requested information above. The Mission Participant(s) acknowledges and agrees that PIXERF relies on them to provide the requested information above, and that PIXERF shall not be liable if they fail to notify PIXERF in accordance with this clause</p></li><li>Where the Winning Prize(s) or part thereof are non-monetary, PIXERF shall make arrangements for its collection and inform you accordingly. PIXERF shall have no obligations in respect of any non-monetary prize(s) which are not collected by the time and date specified by PIXERF.</li><li>Notwithstanding any provision to the contrary, PIXERF shall only be responsible for awarding or delivering the Winning Prize(s) and/or the Special Mention Prize(s) (as the case may be) to the Mission Participant(s) if PIXERF receives the same from the relevant Mission Sponsor by the applicable date. PIXERF shall not be liable to any person in the event that the Mission Sponsor fails and/or neglects to deliver or send the Winning Prize(s) and/or the Special Mention Prize(s) (as the case may be) to it.</li></ol></li><li><span class=community-challenge-agreement-gojek__sub-heading>Grant of Rights</span><ol><li>Subject to this Agreement, you may grant PIXERF either an exclusive or a non-exclusive licence to license, sublicense, market and distribute the Mission Visual Content worldwide, and to copy, use, reproduce, distribute, publish, transmit, broadcast, perform, display, exhibit, adapt, modify, edit or enhance any Mission Visual Content, in whole or in part, alone or in combination with any other material, in any media or embodiment, now known or later developed, for any lawful purpose, including the right to distribute and sell consumer products (for example, by reproducing the Mission Visual Content on products sold to consumers including but not limited to posters, mugs, calendars, website templates, card templates).</li><li>PIXERF shall have complete and sole discretion regarding the terms, conditions and pricing of any Mission Visual Content that it sub-licenses to other Users without your prior approval.</li><li>You grant the Mission Sponsor and exclusive license in relation to the Mission Visual Content for one (1) year from the Mission End Date. You agree to not license or distribute the Mission Visual Content to any other party until the exclusivity period expires. You may use ay Mission Visual Content submitted for your own personal, non-commercial purposes, for example, your portfolio, personal website and self-promotion. However, you shall refer any licensing requests regarding the Mission Visual Content to PIXERF.</li><li>In addition to the foregoing, you grant PIXERF the right, but not the obligation, to use your name, trademarks and trade names, and the right to reproduce, display, transmit, exhibit, modify and adapt any Mission Visual Content to promote, market and advertise PIXERF or otherwise for PIXERF’s own business purposes in relation to the promotion of the Site; and you agree that no compensation or further consent will be required for such use.</li><li>In the event that you have elected to grant PIXERF an exclusive licence in relation to the Mission Visual Content, you thereby grant PIXERF the exclusive right, but not the obligation, to determine in its sole discretion whether and to what extent to proceed with any legal proceedings or action, and/or to defend any claims or counterclaims regarding the Mission Visual Content. Any such legal action or proceeding may be settled or resolved by PIXERF without your prior approval and will not be subject to it, provided that PIXERF shall not enter into any settlement or resolution which will diminish your ownership in the Mission Visual Content.</li><li>Where PIXERF has elected to commence any legal proceedings or actions, and/or to defend any claims or counterclaims regarding the Mission Visual Content, you agree to give PIXERF control of the handling, settlement, or defence of any such claims, and to provide assistance to PIXERF in relation to the legal proceedings or actions, including but not limited to providing PIXERF and our professional advisors with reasonable access to any relevant documents and records. You further agree to be named in and be joined in as a party to any such proceedings or actions in or defence of any legal claim.</li><li>Where PIXERF has elected not to commence any legal proceedings or actions, and/or to defend any claims or counterclaims regarding the Mission Visual Content, you retain the right to bring an action in your own name and at your own expense. You agree that any recovery you receive in your own legal action involving the Mission Visual Content, whether through settlement, adjudication or otherwise, shall be divided between you and PIXERF in accordance with the applicable percentages as set out in the relevant provisions of the <a target=__blank ui-sref=explore-creators-page.creator-agreement class=subscription-page-business-link>Contributor Agreement</a> on compensation after payment of all reasonable legal costs and expenses.</li></ol></li><li><span class=community-challenge-agreement-gojek__sub-heading>Proprietary Rights</span><ol><li><span class=\"text--bold text--color-black\">Ownership</span>. You retain ownership of the copyright in the Mission Visual Content. While PIXERF will take commercially reasonable steps to ensure that your rights are not violated by other Users or other parties, PIXERF has no obligation to pursue any legal action regarding any alleged infringement of any rights in relation to any Mission Visual Content.</li><li><span class=\"text--bold text--color-black\">Credit</span>. While PIXERF will use commercially reasonable efforts to credit you as the source of the Mission Visual Content, you acknowledge that the Users may not credit you as the owner or author of the Mission Visual Content licensed by PIXERF, and that PIXERF may be associated with the Mission Visual Content as the source of such content, without any liability to PIXERF or the Users. You further acknowledge and agree that related metadata may be altered, removed or modified, without any liability to PIXERF or the Users.</li><li>You acknowledge that PIXERF prohibits any Mission Visual Content, descriptive information regarding such content or any other material that infringes on any patent, trademark, copyright, trade secret, right to privacy, right to publicity, or any other applicable law or proprietary right from being submitted or uploaded to the Site. By submitting or uploading Mission Visual Content, you are warranting that you own all ownership rights to the Mission Visual Content or are the authorised representative of the copyright owner(s) of such Mission Visual Content, with full power to grant the rights set out in this Agreement.</li></ol></li><li><span class=community-challenge-agreement-gojek__sub-heading>Transfer of Mission Visual Content to Marketplace</span><ol><li>You agree that all Mission Visual Content will be transferred by PIXERF to the Marketplace in accordance with the Transfer Terms by the date following one (1) year after the Winning Submission(s) and Special Mention Submission(s) (if any) are selected.</li><li>The terms contained in this clause govern the transfer of the Mission Visual Content to the Marketplace (the <span class=\"text--bold text--color-black\">“Transfer Terms</span>”). You agree that:<ol><li>(a) upon such transfer, the <a target=__blank ui-sref=explore-creators-page.creator-agreement class=subscription-page-business-link>Contributor Agreement</a> shall apply to such transferred Mission Visual Content as though you had posted, uploaded, displayed or otherwise made available on or through the Marketplace such transferred Mission Visual Content; and</li><li>(b) upon such transfer and in relation to such transferred Mission Visual Content, the terms of the <a target=__blank ui-sref=explore-creators-page.creator-agreement class=subscription-page-business-link>Contributor Agreement</a> shall take precedence in the event of any conflict or inconsistency between the terms of the <a target=__blank ui-sref=explore-creators-page.creator-agreement class=subscription-page-business-link>Contributor Agreement</a> and the terms of this Agreement, the <a target=__blank ui-sref=introduction-company.terms class=subscription-page-business-link>Terms and Conditions</a> or the <a target=__blank ui-sref=introduction-company.privacy class=subscription-page-business-link>Privacy Policy</a>.</li></ol></li></ol></li><li><span class=community-challenge-agreement-gojek__sub-heading>Taxes</span><ol><li>You shall pay all applicable goods and services tax, duties or levies whatsoever at the rate which may from time to time be imposed or charged at any time by any government, statutory or tax authority on or calculated by reference to the amount of any sums payable by you hereunder or to reimburse us for the payment of such taxes, duties or levies immediately on receipt of written notice from us.</li><li>If PIXERF shall at any time be compelled by any applicable law to withhold or deduct any tax on your behalf from any amount payable to you hereunder, we shall, when making payment to you, make payment of such tax at the applicable rate to the appropriate tax authority and shall furnish to you written receipts from the appropriate tax authority certifying that such payments have been made.</li></ol></li><li><span class=community-challenge-agreement-gojek__sub-heading>Term and Termination</span><ol><li>This Agreement continues in effect until it is terminated by you or by PIXERF as set out in these terms. You may terminate this Agreement by giving seven (7) days’ written notice to PIXERF prior to the Mission End Date. PIXERF may terminate this Agreement immediately by giving written notice to you. Either party may terminate this Agreement immediately by giving written notice if the other party breaches or fails to comply with any of the terms of this Agreement, makes an assignment for the benefit of its creditors, becomes insolvent, or is subject to bankruptcy or liquidation proceedings.</li><li>If you had terminated this Agreement in accordance with Clause 9.1, you have the right but not the obligation to remove from the Mission any of your Mission Visual Content which you had submitted or uploaded. However, such removal does not mean that it will be removed from the Marketplace.</li><li>If PIXERF had terminated this Agreement in accordance with Clause 9.1, PIXERF has the right to remove any of your Mission Visual Content at any time and from time to time after such termination.</li><li>If this Agreement is terminated, whether by you or PIXERF and for whatever reason,<ol><li>PIXERF may retain digital copies of the Mission Visual Content for PIXERF’s records; and</li><li>PIXERF will not be obliged to select any of your Mission Visual Content as the Winning Submission(s) or Special Mention Submission(s) (if applicable) and, accordingly, will not be obliged to award or deliver any Winning Prize(s) or Special Mention Prize(s) to you as set out in Clauses 3 and 4 above.</li></ol></li><li>Notwithstanding the provisions herein, any licence for the Mission Visual Content which had been issued or granted by you prior to any termination of this Agreement shall continue in effect.</li></ol></li><li><span class=community-challenge-agreement-gojek__sub-heading>Your Representations and Warranties</span><ol><li>You represent and warrant to PIXERF as follows:<ol><li>you have the full right and authority to execute and perform your obligations in accordance with the terms of this Agreement;</li><li>if you are an individual, that you are at least 18 years old, and have the full power and authority to enter into this Agreement and perform your obligations hereunder;</li><li>you are the sole and exclusive owner, including copyright, of any Mission Visual Content submitted or uploaded, or are the authorised representative of the applicable copyright owner(s) of the Mission Visual Content, with full power to grant the rights set out in this Agreement</li><li>you have not granted any rights or interests in any Mission Visual Content to any third party that is contrary to any of the rights or interests granted to PIXERF under this Agreement;</li><li>you will not submit or upload any Mission Visual Content that:<ol><li>is defamatory, profane, inappropriate, indecent, obscene or pornographic;</li><li>infringes, violates or misappropriates any third party copyrights, trademarks, rights of privacy or publicity, or any applicable law, rule or regulation;</li></ol></li><li>any descriptions, keywords, metadata, copyright management information or other information or documents (such as Releases) submitted with the Mission Visual Content is timely, accurate and complete, does not contain false or misleading information, and complies with PIXERF\'s applicable submission guidelines or policies;</li><li>you have obtained valid and binding model and/or property releases for each Mission Visual Content where necessary or required by applicable law, and that PIXERF may use such Mission Visual Content without obtaining any further consents or making payment of any additional fees to any third parties;</li><li>you acknowledge and agree that the creator or source of the Mission Visual Content may not be credited by other Users, and that the Mission Visual Content may be modified, adapted and/or used in connection with sensitive, unflattering or controversial subject matters, materials or contexts;</li><li>you will not use the Site for the purposes of conducting and/or disseminating surveys, contests, pyramid schemes, chain letters, junk email, spamming or sending of any duplicative or unsolicited messages; and</li><li>you will not transmit, submit or upload any files that contain viruses, Trojan horses, time bombs, spyware, adware, or other malicious, invasive or deleterious code or programme.</li></ol></li></ol></li><li><span class=community-challenge-agreement-gojek__sub-heading>Disclaimer of Warranties</span><ol><li>The Mission(s), including any content, services, Winning Prize(s) or Special Mention Prize(s) provided in relation thereto, are provided on an \"as is\", \"as available\" basis, without representation, warranty or condition of any kind, implied, express or statutory, including but not limited to the representations or warranties of non-infringement of third party rights, title, merchantability, satisfactory quality and/or fitness for a particular purpose. In particular, PIXERF does not represent or warrant the transmission, accuracy, completeness, timeliness or adequacy of the Mission(s), or that it would be provided uninterrupted or error free.</li></ol></li><li><span class=community-challenge-agreement-gojek__sub-heading>Indemnity</span><ol><li>You agree to indemnify, defend and hold PIXERF, our officers, directors, shareholders, predecessors, successors in interest, employees, agents, subsidiaries and affiliates, harmless from all demands, claims, actions, proceedings, judgements, orders, decrees, damages, costs, losses and expenses of any nature whatsoever (including but not limited to legal costs on an indemnity basis) against us by any third party due to or arising out of or in connection with any breach or alleged breach or failure by you (or anyone acting on your behalf) to comply with any representation or warranty or other term of this Agreement. You agree that PIXERF may retain any amounts due to you in the event that PIXERF is owed any sum under this clause</li><li>Your obligations under the foregoing indemnity may not be offset against any other claim that you may have against PIXERF, or any of our officers, directors, employees, agents, subsidiaries and affiliates. You agree that these indemnity obligations shall survive any termination of your user account on the Site.</li></ol></li><li><span class=community-challenge-agreement-gojek__sub-heading>Disclaimer of Liability</span><ol><li>Notwithstanding any other provision in this Agreement, PIXERF shall not be liable to you or any other person or entity for any punitive, special, indirect, consequential, incidental or other similar damages, costs or losses arising out of this Agreement, its termination or expiration. Some jurisdictions do not permit the exclusion or limitation of implied warranties or liability.</li></ol></li><li><span class=community-challenge-agreement-gojek__sub-heading>General</span><ol><li><span class=\"text--bold text--color-black\">Notices</span>. All notices required to be sent to PIXERF under this Agreement shall be sent via email to notify@pixerf.com. All notices required to be sent to you by PIXERF under this Agreement shall be sent via email to the email address set out in your user account.</li><li><span class=\"text--bold text--color-black\">Severability</span>. The illegality, invalidity or unenforceability of any provision of this Agreement under the law of any jurisdiction shall not affect its legality, validity or enforceability under the law of any other jurisdiction nor the legality, validity or enforceability of any other provision.</li><li><span class=\"text--bold text--color-black\">No Waiver</span>. No failure on the part of any party to exercise, and no delay on its part in exercising, any right or remedy under this Agreement will operate as a waiver thereof, nor will any single or partial exercise of any right or remedy preclude any other or further exercise thereof or the exercise of any other right or remedy. The rights and remedies provided in this Agreement are cumulative and not exclusive of any rights or remedies provided by law.</li></ol></li><li><span class=community-challenge-agreement-gojek__sub-heading>Governing Law</span><ol><li>This Agreement shall be construed and its performance governed in accordance with the law of the Republic of Singapore.</li></ol></li><p>The last update to our Mission Agreement was posted on 16 August 2019.</p></ol></div></div><div class=community-challenge-agreement-gojek__content-right></div></section></div>");
$templateCache.put("app/run-a-challenge-page/components/live-challenges/live-challenges.html","<div class=\"live-challenges no-margin\"><div class=live-challenges__wrapper><section class=\"row live-challenges__main-content\"><div class=\"live-challenges__main-content__title text--extrabold\" translate>{{\'ongoing-community-challenges\'}}</div><div class=live-challenges__main-content__description><div translate>{{\'ongoing-give-us\'}}</div></div><div ng-show=\"vm.missions.length > 0\" class=live-challenges__setting-redirect-btn><div>Launch a Community Challenge today.</div><button type=button class=\"btn btn-submit mission-closed-page__redirect-btn text--bold\" ui-sref=email-us-page>Tell us your brief</button></div></section><div class=\"live-challenges__main-content__mission-grid clearfix\" ng-class=\"{\'grid-have-frame\': vm.missions.length === 0}\" infinite-scroll-disabled=vm.isLastPage infinite-scroll=vm.fetchMoreItems() infinite-scroll-immediate-check=false><div ng-show=\"vm.missions.length > 0\"><div ng-repeat=\"mission in vm.missions\" class=\"clearfix col-md-4 col-sm-6 live-challenges__main-content__mission-item\"><mission-gallery mission=mission></mission-gallery></div></div><div class=\"live-challenges__no-mission text-center\" ng-show=\"vm.missions.length === 0\"><div ng-if=!vm.isMyMission><img src=assets/images/pixerf-empty-mission.svg><div class=\"live-challenges__no-mission__text text--bold\" translate>{{\'ongoing-empty-state-no-ongoing\'}}</div><div class=live-challenges__no-mission__text__content><div translate>{{\'ongoing-empty-state-coming-soon\'}}</div><div class=live-challenges__no-mission__scocial-media><a href=https://www.facebook.com/Pixerf target=_blank><div class=\"photo-icon-media photo-fb-icon\"></div></a><a href=http://instagram.com/Pixerf target=_blank><div class=\"photo-icon-media photo-ig-icon\"></div></a><a href=https://twitter.com/Pixerf target=_blank><div class=\"photo-icon-media photo-tw-icon\"></div></a></div></div></div><div ng-if=vm.isMyMission><div class=\"mission-closed-page__no-mission__text text--bold-switch-semibold text--color-black\" translate>{{\'launch-your-first-mission\'}}</div><div class=mission-closed-page__no-mission__text__content translate>{{\'ongoing-empty-state-tap-into\'}}</div><div class=mission-closed-page__no-mission__text__content translate>{{\'find-perfect-image-for-brand\'}}</div><!-- <button type=\"button\" class=\"btn btn-submit mission-closed-page__create-btn text--bold\" ui-sref=\"setting.manage-missions.create-mission.getting-started\">{{\'create-mission\' | translate}}</button> --> <button type=button class=\"btn btn-submit mission-closed-page__redirect-btn text--bold\" ui-sref=email-us-page>Tell us your brief</button></div></div></div><spinner-win spinner=vm.spinner></spinner-win></div><section class=\"row live-challenges__footer text--color-black col-md-12\"><div class=live-challenges__footer__title translate>{{\'crowdsource-business-banner\'}}</div><div class=live-challenges__footer__description><div translate>{{\'crowdsource-business-description-1\'}}</div><div translate>{{\'crowdsource-business-description-2\'}}</div></div><button type=button class=\"live-challenges__footer__button text--bold btn\" ui-sref=email-us-page>{{\'find-out-how\' | translate}}</button></section></div>");
$templateCache.put("app/run-a-challenge-page/components/joined-challenges/joined-challenges.html","<div class=\"joined-challenges no-margin\"><div class=joined-challenges__wrapper><section class=\"row joined-challenges__main-content\"><div class=\"joined-challenges__main-content__title text--color-black text--extrabold\" translate>{{\'your-community-challenges\'}}</div><div class=joined-challenges__main-content__description ng-show=\"vm.missions.length > 0\">{{\'joined-view-edit-manage\' | translate}}<br>{{\'feel-free-to-change-your-submissions\' | translate}}<br><br><br>{{\'you-are-running\' | translate}}</div><div class=joined-challenges__no-mission__description ng-show=\"vm.missions.length === 0\" translate>{{\'joined-view-edit-manage\'}}</div></section><div class=\"joined-challenges__main-content__mission-grid clearfix\" infinite-scroll-disabled=vm.isLastPage infinite-scroll=vm.fetchMoreItems() infinite-scroll-immediate-check=false><div ng-show=\"vm.missions.length > 0\"><div ng-repeat=\"mission in vm.missions\" class=\"clearfix col-md-4 col-sm-6 joined-challenges__main-content__mission-item\"><mission-gallery mission=mission></mission-gallery></div></div><div class=\"joined-challenges__no-mission text-center\" ng-show=\"vm.missions.length === 0\"><img src=assets/images/footer-pages/earn.svg><div class=\"joined-challenges__no-mission__text text--bold-switch-semibold text--color-black\" translate>{{\'not-joined-community-challenges\'}}</div><div class=joined-challenges__no-mission__text__content translate translate-values=\"{number: 6}\">{{\'joined-join-missions\'}}</div><button type=button class=\"btn joined-challenges__create-btn text--bold\" ui-sref=run-a-challenge-page.live-challenges>{{\'explore-missions\' | translate}}</button></div></div><spinner-win spinner=vm.spinner></spinner-win></div><section class=\"row joined-challenges__footer col-md-12\" ng-if=\"vm.missions.length > 0\"><div class=\"joined-challenges__footer__title text--bold-switch-semibold\">{{\'join-other-missions\' | translate}}</div><button type=button class=\"joined-challenges__footer__button text--bold btn\" ui-sref=run-a-challenge-page.live-challenges>{{\'explore-missions\' | translate}}</button></section></div>");
$templateCache.put("app/run-a-challenge-page/components/past-challenges/past-challenges.html","<div class=\"past-challenges no-margin\"><div class=past-challenges__wrapper><section class=\"row past-challenges__main-content\"><div class=\"past-challenges__main-content__title text--extrabold text--color-black\" translate>{{\'closed-missions\'}}</div><div class=past-challenges__main-content__description ng-show=\"vm.missions.length > 0\"><div ng-if=!vm.isMyMission translate>{{\'closed-missions-winning\'}}</div><div ng-if=vm.isMyMission>Review all completed Challenges here. Check out all the submissions and select Challenge Winners and Special Mentions!</div></div><div class=\"past-challenges__no-mission__description text-center\" ng-show=\"vm.missions.length === 0\"><div ng-if=!vm.isMyMission>Check out our past winning photos and photographers.</div><div ng-if=vm.isMyMission>Review all completed Challenges here. Check out all the submissions and select Challenge Winners and Special Mentions!</div></div></section><div class=\"past-challenges__main-content__mission-grid clearfix\" infinite-scroll-disabled=vm.isLastPage infinite-scroll=vm.fetchMoreItems() infinite-scroll-immediate-check=false><div ng-show=\"vm.missions.length > 0\"><div ng-repeat=\"mission in vm.missions\" class=\"clearfix col-md-4 col-sm-6 past-challenges__main-content__mission-item\"><mission-gallery mission=mission></mission-gallery></div></div><div class=\"past-challenges__no-mission text-center\" ng-show=\"vm.missions.length === 0\"><div ng-if=!vm.isMyMission><img src=assets/images/pixerf-empty-mission.svg><div class=\"past-challenges__no-mission__text text--bold-switch-semibold text--color-black\">There are no closed<br>Community Challenges at this time.</div><div class=past-challenges__no-mission__text__content translate translate-values=\"{number: 6}\">{{\'joined-join-missions\'}}</div><button type=button class=\"btn btn-submit past-challenges__create-btn text--bold\" ui-sref=run-a-challenge-page.live-challenges>{{\'explore-missions\' | translate}}</button></div><div ng-if=vm.isMyMission><div class=\"past-challenges__no-mission__text text--bold-switch-semibold text--color-black\">No closed Community Challenges at this time.</div><div class=past-challenges__no-mission__text__content>Tap into the power of PIXERF’s growing community of visual artists and crowdsource diverse Asian perspectives to power your creative brief.</div><div class=past-challenges__no-mission__text__content>{{\'find-perfect-image-for-brand\'}}</div><!-- <button type=\"button\" class=\"btn btn-submit past-challenges__create-btn text--bold\" ui-sref=\"setting.manage-missions.create-mission.getting-started\">{{\'create-mission\' | translate}}</button> --></div></div></div><spinner-win spinner=vm.spinner></spinner-win></div><section class=\"row past-challenges__footer text--color-black col-md-12\" ng-if=\"vm.missions.length > 0\"><div class=past-challenges__footer__title>{{\'join-other-missions\' | translate}}</div><button type=button class=\"past-challenges__footer__button btn\" ui-sref=run-a-challenge-page.live-challenges>{{\'explore-missions\' | translate}}</button></section></div>");
$templateCache.put("app/user-home-page/components/guest-home-page/guest-home-page.html","<div class=guest-home-page><empty-profile-landing-page user-type=personal ng-if=\"vm.isMyProfile && (vm.bidingItems && vm.bidingItems.length == 0) && (vm.portfolios && vm.portfolios.length ==0)\"></empty-profile-landing-page><section class=\"guest-home-page__section-wrapper guest-home-page__portfolio\" ng-if=\"vm.portfolios && vm.portfolios.length > 0\"><div class=guest-home-page__title>{{\'portfolio\' | translate}}</div><pixerf-animation-carousel data=vm.portfolios ng-if=\"vm.portfolios && vm.portfolios.length > 0\" config=vm.carouselConfig instance=portfolioCarousel limit=9><item-template><portfolio-tile portfolio=$parent.data speciality={{$parent.data.speciality}} on-portfolio-clicked=\"vm.onPortfolioClicked({\'portfolio\': $parent.data})\"></portfolio-tile></item-template></pixerf-animation-carousel></section><section class=\"guest-home-page__section-wrapper guest-home-page__photo\" ng-if=\"vm.bidingItems && vm.bidingItems.length \"><div class=guest-home-page__header-filter><div class=guest-home-page__title>{{\'photos\' | translate}}</div><div class=guest-home-page__filters-wrapper><label class=guest-home-page__filters__label translate>{{\'sort-by\'}}</label><ul class=guest-home-page__filters__sort><li class=guest-home-page__sort__item ng-class=\"{\'guest-home-page__sort__item--active\': !vm.selectedSize.isDefault}\"><popover-selection-btn close-on-click=true on-selection-changed=vm.onFilteredClicked(item) selected-model=vm.selectedFilterItem settings=vm.filterSetting selected-default-index={{vm.selectedDefaultIndex}}></popover-selection-btn></li></ul></div></div><div ng-if=\"vm.gridSort === \'freshness\'\" class=guest-home-page__content-section><div ng-if=\"vm.items.length > 0\" infinite-scroll-disabled=vm.isLastPage infinite-scroll=vm.fetchMorePhotos() infinite-scroll-immediate-check=false><div class=group-by-month ng-repeat=\"item in vm.bidingItems\"><div class=guest-home-page__content-section__group-title data-toggle=collapse data-target=#group-by-{{item.collapse}}>{{item.title}}</div><div id=group-by-{{item.collapse}} class=\"collapse in\"><div flex-grid ng-model=item margins=3 rowheight=250><tile-photo ng-repeat=\"photo in item.data\" on-photo-clicked=\"onPhotoClicked({file: photo})\" context=context on-added-or-removed-from-gallery=vm.onAddedOrRemovedFromGallery(photo) on-file-removed=vm.onFileRemoved(photo) gallery=gallery file=photo show-license=\"(vm.loginnedUser && vm.loginnedUser.canCurate) ? \'true\' : \'false\'\" hide-caption=true></tile-photo></div></div></div><scroll-paging spinner=vm.spinner show-message=\"vm.gridSort === \'freshness\' && vm.bidingItems.length > 0\" hide-back-to-top=\"vm.totalPage < 2\" is-last-page=vm.isLastPage message=\"{{\'no-more-photos\' | translate}}\"></scroll-paging></div></div><div ng-if=\"vm.gridSort != \'freshness\'\" class=guest-home-page__content-section><div infinite-scroll-disabled=vm.isLastPage infinite-scroll=vm.fetchMorePhotos() infinite-scroll-immediate-check=false><div flex-grid ng-model=vm.bidingItems margins=3 rowheight=250><tile-photo ng-repeat=\"item in vm.bidingItems\" on-photo-clicked=\"onPhotoClicked({file: item})\" context=context on-added-or-removed-from-gallery=vm.onAddedOrRemovedFromGallery(item) on-file-removed=vm.onFileRemoved(item) gallery=gallery file=item show-license=\"(vm.loginnedUser && vm.loginnedUser.canCurate) ? \'true\' : \'false\'\" hide-caption=true options=vm.options></tile-photo></div><scroll-paging spinner=vm.spinner show-message=\"vm.gridSort != \'freshness\' && vm.bidingItems.length > 0\" hide-back-to-top=\"vm.totalPage < 2\" is-last-page=vm.isLastPage message=\"{{\'no-more-photos\' | translate}}\"></scroll-paging></div></div></section></div>");
$templateCache.put("app/user-home-page/components/user-front-page/user-front-page.html","<div class=\"user-front-page main-news\"><div class=\"user-front-page__tools clearfix\" ng-if=vm.parent.isMyProfile><div class=user-front-page__box-input ng-class=\"{\'is-focused\': vm.isFocusedInput}\"><div class=user-front-page__popup-overlay ng-click=vm.onOutSideClicked()></div><div class=\"user-front-page__popup-input clearfix\"><div></div><div><div class=user-front-page__placeholder ng-if=!vm.newFeedContent>What\'s new?</div><div type=text class=\"user-front-page__input form-control\" ng-model=vm.newFeedContent></div></div><div class=\"user-front-page__popup-left-control clearfix\"><popover-selection-btn class=user-front-page__type-post close-on-click=true on-selection-changed=vm.onFilteredClicked(item) selected-model=vm.selectedFilter settings=vm.filterSetting></popover-selection-btn><div class=\"user-front-page__popup-icon-wrapper clearfix\"><div class=\"user-front-page__popup-image-icon icon-icons_camera\"></div><div class=\"user-front-page__popup-title-icon icon-photography-document\"></div></div></div><button class=\"user-front-page__input-btn btn btn-submit\">Post</button></div></div></div><div class=user-front-page__posts><div ng-if=\"vm.posts.length != 0\" ng-repeat=\"post in vm.posts\"><user-post-tile post-data=post is-owner={{vm.parent.isMyProfile}}></user-post-tile></div><div ng-if=\"(vm.posts || vm.posts.length === 0) && vm.user.isBiz\" class=user-front-page__empty-state><div class=user-front-page__empty-state__header><div class=\"user-front-page__empty-state__header__title text--color-black\">Welcome to your Feed!</div><div class=user-front-page__empty-state__header__content>Get updates and content uploads from your community and pages you follow. This is also where you get the latest news and articles from our blog, XERFIE.</div></div><div class=\"user-front-page__empty-state__section empty-section-1\"><div class=user-front-page__empty-state__section__content-wrapper><div class=user-front-page__empty-state__section__title>Welcome to your Business Page!</div><div class=user-front-page__empty-state__section__description>This is where you can unlock the power of PIXERF\'s platform to connect to over 50,000 visual artists and get on-brand, authentic Asian visual content for your creative needs.</div><div class=user-front-page__overlay></div></div></div><div class=\"user-front-page__empty-state__section empty-section-2 clearfix\"><div class=\"user-front-page__empty-state__section-column user-front-page__empty-state__section-column__section-column-1 clearfix\"><div class=user-front-page__empty-state__section-column__title>Build your Community</div><div class=user-front-page__empty-state__section-column__description>Start inviting visual artists from PIXERF to your business page and build a community of photographers specially for you. Easily match your creative brief or visual needs to this community or invite them to submit quotes for Custom Commissions.</div><button class=\"btn btn-submit user-front-page__empty-state__section-column__btn\" authentication-click=vm.onBuildCommunityClicked() check-verified-email=true>Create</button><div class=user-front-page__overlay></div></div><div class=\"user-front-page__empty-state__section-column user-front-page__empty-state__section-column__section-column-2 clearfix\"><div class=user-front-page__empty-state__section-column__title>Custom Commissions</div><div class=user-front-page__empty-state__section-column__description>Obtain highly-customised visuals tailored to your campaign, at any scale. Choose to open your Custom Commissions to PIXERF\'s entire community, or keep it private and choose who can apply for your project. Contact us to launch one now.</div><a href=mailto:business@pixerf.com class=\"credit-plans-page-faq__more-content--faq-link text--bold\"><button class=\"btn btn-submit user-front-page__empty-state__section-column__btn\">Contact Us</button></a><div class=user-front-page__overlay></div></div><div class=\"user-front-page__empty-state__section-column user-front-page__empty-state__section-column__section-column-3 clearfix\"><div class=user-front-page__empty-state__section-column__title>{{\'missions\' | translate}}</div><div class=user-front-page__empty-state__section-column__description>Crowdsource diverse Asian perspectives through Missions. Unlock the potential of our regional user base. Write your creative brief, upload visual guidelines, wait for submissions and reward the best.</div><button class=\"btn btn-submit user-front-page__empty-state__section-column__btn\" authentication-click=vm.onCreateMissionClicked() check-verified-email=true>Launch</button><div class=user-front-page__overlay></div></div></div><div class=\"user-front-page__empty-state__section empty-section-3\"><div class=user-front-page__empty-state__section__content-wrapper><div class=user-front-page__empty-state__section__title>XERFIE</div><div class=user-front-page__empty-state__section__description>Get the latest trends and news in the visual space, meet some of Asia\'s best talents or geek out at the latest tech in photography, videography and more. XERFIE is a blog that is all things Asia, all things visual, just for you.</div><div class=user-front-page__overlay></div></div></div></div><div ng-if=\"(vm.posts || vm.posts.length === 0) && !vm.user.isBiz\" class=user-front-page__empty-state><div class=user-front-page__empty-state__header><div class=\"user-front-page__empty-state__header__title text--color-black\">Welcome to your Feed!</div><div class=user-front-page__empty-state__header__content>Get updates and content uploads from your community and pages you follow. This is also where you get the latest news and articles from our blog, XERFIE.</div></div><div class=\"user-front-page__empty-state__section empty-section-3\"><div class=user-front-page__empty-state__section__content-wrapper><div class=user-front-page__empty-state__section__title>XERFIE</div><div class=user-front-page__empty-state__section__description>Get the latest trends and news in the visual space, meet some of Asia\'s best talents or geek out at the latest tech in photography, videography and more. XERFIE is a blog that is all things Asia, all things visual, just for you.</div><div class=user-front-page__overlay></div></div></div><div class=\"user-front-page__empty-state__section empty-section-2 clearfix\"><div class=\"user-front-page__empty-state__section-column user-front-page__empty-state__section-column__section-column-2-a clearfix\"><div class=user-front-page__empty-state__section-column__title>{{\'missions\' | translate}}</div><div class=user-front-page__empty-state__section-column__description>Explore our active Missions and submit your best work to win attractive prizes and challenge yourself with unique briefs from all over Asia!</div><a class=\"btn btn-submit user-front-page__empty-state__section-column__btn\" ui-sref=run-a-challenge-page.live-challenges>{{\'explore-missions\' | translate}}</a><div class=user-front-page__overlay></div></div><div class=\"user-front-page__empty-state__section-column user-front-page__empty-state__section-column__section-column-2-b clearfix\"><div class=user-front-page__empty-state__section-column__title>Build your Community</div><div class=user-front-page__empty-state__section-column__description>Connect with other visual artists, follow your favourite brands or create your own community and invite other visual artists to share in your passion and exchange ideas. Communities also allow you to get access to Custom Commissions from agencies and businesses across Asia.</div><a class=\"btn btn-submit user-front-page__empty-state__section-column__btn\" ui-sref=for-creator-page.about-community>Explore Communities</a><div class=user-front-page__overlay></div></div></div></div></div></div>");
$templateCache.put("app/user-home-page/components/more-tools/more-tools.html","<div class=more-tools uib-dropdown><a uib-dropdown-toggle><span class=icon-icons_more></span></a><ul class=dropdown-menu uib-dropdown-menu role=menu aria-labelledby=single-button><li role=menuitem ng-if=\"vm.loginnedUser && vm.loginnedUser.isAdminInternal && vm.user.isContributor\"><suggest-btn user=vm.user></suggest-btn></li><li ng-if=\"vm.loginnedUser && vm.loginnedUser.isAdminInternal && vm.user.isContributor\" class=divider></li><li ng-if=\"vm.loginnedUser && vm.loginnedUser.isAdminInternal && vm.user.isContributor\" role=menuitem><set-ambassador-btn on-ambassadorship-changed=vm.onAmbassadorshipChanged(ambassadorship) user=vm.user></set-ambassador-btn></li><li ng-if=\"vm.loginnedUser && vm.loginnedUser.canVerifyBusinessUser && vm.user.isBiz\" role=menuitem><verify-business-btn user=vm.user></verify-business-btn></li><li ng-if=\"vm.loginnedUser && vm.loginnedUser.isAdminInternal\" class=divider></li><li ng-if=\"vm.loginnedUser && vm.loginnedUser.isAdminInternal\" role=menuitem><banned-user-btn user=vm.user></banned-user-btn></li><li ng-if=\"vm.loginnedUser && (vm.loginnedUser.isAdminInternal || vm.loginnedUser.isCurator)\" class=divider></li><li role=menuitem ng-if=\"vm.loginnedUser && (vm.loginnedUser.isAdminInternal || vm.loginnedUser.isCurator)\"><flag-btn user=vm.user></flag-btn></li><li ng-if=\"vm.loginnedUser && vm.loginnedUser.isAdminInternal && vm.user.isBiz\" class=divider></li><li role=menuitem ng-if=\"vm.loginnedUser && vm.loginnedUser.isAdminInternal && vm.user.isBiz\"><can-create-community-btn user=vm.user></can-create-community-btn></li></ul></div>");
$templateCache.put("app/user-home-page/components/user-profile-communities/user-profile-communities.html","<div class=\"user-profile-communities clearfix relative\"><div ui-view></div></div>");
$templateCache.put("app/user-home-page/components/user-profile-galleries/galleries.html","<div class=user-galleries-page><galleries-list-slider ng-if=\"!vm.isTypeGalleryShowAll && !vm.user.isBiz\" gallery-type=default gallery-grid=vm.galleryDefault owner=vm.user on-gallery-clicked=vm.onGalleryClicked(gallery) is-mine=vm.isMine></galleries-list-slider><div class=user-galleries-page__grid-wrapper ng-if=\"vm.isTypeGalleryShowAll === \'default\' && !vm.user.isBiz\"><div id=section-default-gallery class=\"user-galleries-page__title text--bold text--color-black\">{{ vm.isMine ? (\'my-galleries\' | translate) : (\'galleries\' | translate)}}</div><a class=\"user-galleries-page__back-btn text--underline\" ng-click=vm.goBackBtnClicked()>&lt Back</a><div class=user-galleries-page__create-new-gallery ng-if=vm.isMine authentication-click=vm.onCreateGalleryBtnClicked(vm.galleryDefault) check-verified-email=true><div class=\"user-galleries-page__create-new-gallery__icon icon-icons_plus\"></div><div class=\"user-galleries-page__create-new-gallery__title text--bold text--color-black\">{{\'create-new-gallery\' | translate}}</div></div><gallery-grid class=user-galleries-page__gallery-collapse instance=vm.galleryDefault on-scroll-to-section-id=section-default-gallery on-scroll-offset-top={{vm.scrollOffsetTopGallery}} on-load-more-page=true></gallery-grid></div><galleries-list-slider ng-if=!vm.isTypeGalleryShowAll gallery-type=curated gallery-grid=vm.galleryCurated owner=vm.user on-gallery-clicked=vm.onGalleryClicked(gallery) is-mine=vm.isMine></galleries-list-slider><div class=user-galleries-page__grid-wrapper ng-if=\"vm.isTypeGalleryShowAll === \'curated\'\"><div id=section-curated-gallery class=\"user-galleries-page__title text--bold text--color-black\">{{\'curated-galleries\' | translate}}</div><a class=\"user-galleries-page__back-btn text--underline\" ng-click=vm.goBackBtnClicked()>&lt Back</a><div class=user-galleries-page__create-new-gallery ng-if=vm.isMine authentication-click=vm.onCreateGalleryBtnClicked(vm.galleryCurated) check-verified-email=true><div class=\"user-galleries-page__create-new-gallery__icon icon-icons_plus\"></div><div class=\"user-galleries-page__create-new-gallery__title text--bold text--color-black\">{{\'curate-new-gallery\' | translate}}</div></div><gallery-grid class=user-galleries-page__gallery-collapse instance=vm.galleryCurated on-scroll-to-section-id=section-curated-gallery on-scroll-offset-top={{vm.scrollOffsetTopGallery}} on-load-more-page=true></gallery-grid></div><galleries-list-slider ng-if=!vm.isTypeGalleryShowAll gallery-type=following gallery-grid=vm.galleryFollowing owner=vm.user on-gallery-clicked=vm.onGalleryClicked(gallery) is-mine=vm.isMine></galleries-list-slider><div class=user-galleries-page__grid-wrapper ng-if=\"vm.isTypeGalleryShowAll === \'following\'\"><div id=section-following-gallery class=\"user-galleries-page__title text--bold text--color-black\">{{\'following-galleries\' | translate}}</div><a class=\"user-galleries-page__back-btn text--underline\" ng-click=vm.goBackBtnClicked()>&lt Back</a><div class=user-galleries-page__create-new-gallery ng-if=vm.isMine authentication-click=buy-stock-page.galleries.pixerfer-galleries check-verified-email=true><div class=\"user-galleries-page__create-new-gallery__icon icon-icons_plus\"></div><div class=\"user-galleries-page__create-new-gallery__title text--bold text--color-black\">{{\'discover-gallery\' | translate}}</div></div><gallery-grid context=\"\'following\'\" class=user-galleries-page__gallery-collapse instance=vm.galleryFollowing on-scroll-to-section-id=section-following-gallery on-scroll-offset-top={{vm.scrollOffsetTopGallery}} on-load-more-page=true></gallery-grid></div></div>");
$templateCache.put("app/user-home-page/components/personal-home-page/personal-home-page.html","<div class=personal-home-page><empty-profile-landing-page ng-if=\"vm.isMyProfile && (vm.loginnedUser.account_type && vm.bidingItems && vm.bidingItems.length == 0) && (vm.portfolios && vm.portfolios.length ==0)\"></empty-profile-landing-page><section class=\"personal-home-page__section-wrapper personal-home-page__portfolio\" ng-if=\"vm.portfolios && vm.portfolios.length > 0\"><div class=personal-home-page__title>{{\'portfolio\' | translate}}</div><pixerf-animation-carousel data=vm.portfolios ng-if=\"vm.portfolios && vm.portfolios.length > 0\" config=vm.carouselConfig instance=portfolioCarousel limit=9><item-template><portfolio-tile portfolio=$parent.data speciality={{$parent.data.speciality}} on-portfolio-clicked=\"vm.onPortfolioClicked({\'portfolio\': $parent.data})\"></portfolio-tile></item-template></pixerf-animation-carousel></section><section class=\"personal-home-page__section-wrapper personal-home-page__photo\" ng-if=\"vm.bidingItems && vm.bidingItems.length \"><div class=personal-home-page__header-filter><div class=personal-home-page__title>{{\'photos\' | translate}}</div><div class=personal-home-page__filters-wrapper><label class=personal-home-page__filters__label translate>{{\'sort-by\'}}</label><ul class=personal-home-page__filters__sort><li class=personal-home-page__sort__item ng-class=\"{\'personal-home-page__sort__item--active\': !vm.selectedSize.isDefault}\"><popover-selection-btn close-on-click=true on-selection-changed=vm.onFilteredClicked(item) selected-model=vm.selectedFilterItem settings=vm.filterSetting selected-default-index={{vm.selectedDefaultIndex}}></popover-selection-btn></li></ul></div></div><div ng-if=\"vm.gridSort === \'freshness\'\" class=personal-home-page__content-section><div ng-if=\"vm.items.length > 0\" infinite-scroll-disabled=vm.isLastPage infinite-scroll=vm.fetchMorePhotos() infinite-scroll-immediate-check=false><div class=group-by-month ng-repeat=\"item in vm.bidingItems\"><div class=personal-home-page__content-section__group-title data-toggle=collapse data-target=#group-by-{{item.collapse}}>{{item.title}}</div><div id=group-by-{{item.collapse}} class=\"collapse in\"><div flex-grid ng-model=item margins=3 rowheight=250><tile-photo ng-repeat=\"photo in item.data\" on-photo-clicked=\"onPhotoClicked({file: photo})\" context=context on-added-or-removed-from-gallery=vm.onAddedOrRemovedFromGallery(photo) on-file-removed=vm.onFileRemoved(photo) gallery=gallery file=photo show-license=\"(vm.loginnedUser && vm.loginnedUser.canCurate) ? \'true\' : \'false\'\" hide-caption=true></tile-photo></div></div></div><scroll-paging spinner=vm.spinner show-message=\"vm.gridSort === \'freshness\' && vm.bidingItems.length > 0\" hide-back-to-top=\"vm.totalPage < 2\" is-last-page=vm.isLastPage message=\"{{\'no-more-photos\' | translate}}\"></scroll-paging></div></div><div ng-if=\"vm.gridSort != \'freshness\'\" class=personal-home-page__content-section><div infinite-scroll-disabled=vm.isLastPage infinite-scroll=vm.fetchMorePhotos() infinite-scroll-immediate-check=false><div flex-grid ng-model=vm.bidingItems margins=3 rowheight=250><tile-photo ng-repeat=\"item in vm.bidingItems\" on-photo-clicked=\"onPhotoClicked({file: item})\" context=context on-added-or-removed-from-gallery=vm.onAddedOrRemovedFromGallery(item) on-file-removed=vm.onFileRemoved(item) gallery=gallery file=item show-license=\"(vm.loginnedUser && vm.loginnedUser.canCurate) ? \'true\' : \'false\'\" hide-caption=true options=vm.options></tile-photo></div><scroll-paging spinner=vm.spinner show-message=\"vm.gridSort != \'freshness\' && vm.bidingItems.length > 0\" hide-back-to-top=\"vm.totalPage < 2\" is-last-page=vm.isLastPage message=\"{{\'no-more-photos\' | translate}}\"></scroll-paging></div></div></section></div>");
$templateCache.put("app/user-home-page/components/user-profile-photos/user-profile-photos.html","<div class=\"user-profile-photos clearfix relative photos-grid-wrapper\"><div class=user-profile-photos__filters-wrapper ng-if=\"vm.gridSort != \'freshness\'\"><label class=user-profile-photos__filters__label translate>{{\'sort-by\'}}</label><ul class=user-profile-photos__filters__sort><li class=user-profile-photos__sort__item ng-class=\"{\'user-profile-photos__sort__item--active\': !vm.selectedSize.isDefault}\"><popover-selection-btn close-on-click=true on-selection-changed=vm.onFilteredClicked(item) selected-model=vm.selectedFilterItem settings=vm.filterSetting selected-default-index={{vm.selectedDefaultIndex}}></popover-selection-btn></li></ul></div><div ng-if=\"vm.gridSort === \'freshness\'\" class=user-profile-photos__content-section><div ng-if=\"vm.items.length > 0\" infinite-scroll-disabled=vm.isLastPage infinite-scroll=vm.fetchMorePhotos() infinite-scroll-immediate-check=false><div class=group-by-month ng-repeat=\"item in vm.bidingItems\"><div class=user-profile-photos__content-section__group-title data-toggle=collapse data-target=#group-by-{{item.collapse}}><div class=group-by-month__text>{{item.title}}</div><div class=user-profile-photos__filters-wrapper ng-if=\"$index == 0\"><label class=user-profile-photos__filters__label translate>{{\'sort-by\'}}</label><ul class=user-profile-photos__filters__sort><li class=user-profile-photos__sort__item ng-class=\"{\'user-profile-photos__sort__item--active\': !vm.selectedSize.isDefault}\"><popover-selection-btn close-on-click=true on-selection-changed=vm.onFilteredClicked(item) selected-model=vm.selectedFilterItem settings=vm.filterSetting selected-default-index={{vm.selectedDefaultIndex}}></popover-selection-btn></li></ul></div></div><div id=group-by-{{item.collapse}} class=\"collapse in\"><div flex-grid ng-model=item margins=3 rowheight=250><tile-photo ng-repeat=\"photo in item.data\" on-photo-clicked=\"onPhotoClicked({file: photo})\" context=context on-added-or-removed-from-gallery=vm.onAddedOrRemovedFromGallery(photo) on-file-removed=vm.onFileRemoved(photo) gallery=gallery file=photo show-license=\"(vm.loginnedUser && vm.loginnedUser.canCurate) ? \'true\' : \'false\'\" hide-caption=true options=vm.options></tile-photo></div></div></div><scroll-paging spinner=vm.spinner show-message=\"vm.gridSort === \'freshness\' && vm.bidingItems.length > 0\" hide-back-to-top=\"vm.totalPage < 2\" is-last-page=vm.isLastPage message=\"{{\'no-more-photos\' | translate}}\"></scroll-paging></div></div><div ng-if=\"vm.gridSort != \'freshness\'\" class=user-profile-photos__content-section><div infinite-scroll-disabled=vm.isLastPage infinite-scroll=vm.fetchMorePhotos() infinite-scroll-immediate-check=false><div flex-grid ng-model=vm.bidingItems margins=3 rowheight=250><tile-photo ng-repeat=\"item in vm.bidingItems\" on-photo-clicked=\"onPhotoClicked({file: item})\" context=context on-added-or-removed-from-gallery=vm.onAddedOrRemovedFromGallery(item) on-file-removed=vm.onFileRemoved(item) gallery=gallery file=item show-license=\"(vm.loginnedUser && vm.loginnedUser.canCurate) ? \'true\' : \'false\'\" hide-caption=true options=vm.options></tile-photo>></div><scroll-paging spinner=vm.spinner show-message=\"vm.gridSort != \'freshness\' && vm.bidingItems.length > 0\" hide-back-to-top=\"vm.totalPage < 2\" is-last-page=vm.isLastPage message=\"{{\'no-more-photos\' | translate}}\"></scroll-paging></div></div></div>");
$templateCache.put("app/user-home-page/components/user-profile-portfolio/user-profile-portfolio.html","<div class=user-profile-portfolio><div class=\"user-profile-portfolio__portfolio-description text-center\" translate>{{\'photos-in-portfolio-are-strictly\'}}</div><div ui-view></div></div>");
$templateCache.put("app/user-home-page/components/user-profile-navigation/user-profile-navigation.html","<!-- <div>\r\n	<div class=\"pixerf-navigation-bar-wrapper__cover-on-scroll\"\r\n		ng-class=\"{\'active\': (vm.canBulkEditPhoto && vm.allowBulkEditPhotoOnState)}\">\r\n	</div>\r\n	\r\n</div> --><div id=user-profile-navigation class=\"pixerf-navigation-bar-wrapper {{navigationClass}}\" ng-class=\"{\'pixerf-navigation-bar-wrapper--fixed\': (vm.canBulkEditPhoto && vm.allowBulkEditPhotoOnState)}\"><ul class=\"pixerf-navigation-bar clearfix\" scroll-to-fixed=vm.scrollToFixedConfig scroll-to-fixed-when=vm.scrollToFixedWhen dynamic-show-hide-scroll-position scroll-down-class=hide-on-mobile scroll-up-class=show-on-mobile balancing-point=.pixerf-navigation-bar-wrapper offset-top=58 ng-class=\"{\'pixerf-navigation-bar--big-size\': (vm.canBulkEditPhoto && vm.allowBulkEditPhotoOnState)}\"><button type=button class=\"navbar-toggle collapsed\" data-toggle=collapse data-target=#user-profile-navbar-collapse aria-expanded=false><div class=\"pull-left text--bold relative\"><span>{{context}}</span><div class=arrow-animation-menu-collapse><span class=\"icon-bar dash-one\"></span> <span class=\"icon-bar dash-two\"></span></div></div></button><div class=\"collapse navbar-collapse pixerf-navbar-text\" id=user-profile-navbar-collapse navbar-collapse-on-click=true><li ng-if=vm.user.isContributor ui-sref-active=pixerf-navigation-bar__menu-item--active class=pixerf-navigation-bar__menu-item ui-sref=user-home-page.personal.home>{{\'home\' | translate}}</li><li ng-if=vm.isGuestUser() ui-sref-active=pixerf-navigation-bar__menu-item--active class=pixerf-navigation-bar__menu-item ui-sref=user-home-page.guest.home>{{\'home\' | translate}}</li><li ng-if=\"vm.user.canUploadPhotos && !vm.isGuestUser()\" ui-sref-active=pixerf-navigation-bar__menu-item--active class=pixerf-navigation-bar__menu-item ui-sref=user-home-page.{{vm.user.account_type}}.photos><span>{{\'photos\' | translate}}</span></li><li ng-if=vm.user.canManageGalleries ui-sref-active=pixerf-navigation-bar__menu-item--active class=pixerf-navigation-bar__menu-item ui-sref=\"user-home-page.{{vm.user.account_type ? vm.user.account_type : \'guest\'}}.galleries\"><span>{{\'galleries\' | translate}}</span></li><a ui-sref=user-home-page.{{vm.user.account_type}}.portfolio.carousel ng-if=!vm.isGuestUser()><li ng-if=vm.user.canManagePortfolios ui-sref-active=pixerf-navigation-bar__menu-item--active class=pixerf-navigation-bar__menu-item ui-sref=user-home-page.{{vm.user.account_type}}.portfolio><span>{{\'portfolio\' | translate}}</span></li></a><li ui-sref=user-home-page.{{vm.user.account_type}}.communities.grid ng-if=!vm.isGuestUser() ui-sref-active=pixerf-navigation-bar__menu-item--active class=pixerf-navigation-bar__menu-item>{{\'communities\' | translate}}</li></div><button type=button class=business-info-btn-collapse ng-click=vm.onOrgDetailClicked(vm.user)><div class=icon-icons-info></div></button><div class=business-share-btn-collapse ng-if=\"!(vm.canBulkEditPhoto && vm.allowBulkEditPhotoOnState)\"><share settings=\"{\'appendToBody\': true, \'flatMode\': false, \'popoverClass\': \'user-home-page\'}\" content-will-be-shared=vm.socialShareContent></share></div><div class=\"business-share-btn-collapse business-share-btn-collapse__bulk-edit-photo-cover\" ng-if=\"vm.canBulkEditPhoto && vm.allowBulkEditPhotoOnState\"><share settings=\"{\'appendToBody\': true, \'flatMode\': false, \'popoverClass\': \'user-home-page\'}\" content-will-be-shared=vm.socialShareContent></share><div class=bulk-edit-photo><button type=button class=bulk-edit-photo__select-photo-btn ng-click=vm.selectPhotoBtnClicked(true) ng-if=!vm.isSelectedPhotos>Select Photo</button> <button type=button class=bulk-edit-photo__edit-btn ng-click=vm.bulkEditPhoto() ng-if=\"vm.isSelectedPhotos && vm.bulkSelectedPhoto.length\">Edit Photo ({{vm.bulkSelectedPhoto.length}})</button> <button type=button class=bulk-edit-photo__cancel-btn ng-click=vm.selectPhotoBtnClicked(false) ng-if=vm.isSelectedPhotos>Cancel</button></div></div><button type=button class=business-more-btn-collapse data-toggle=collapse aria-expanded=false ng-if=\"vm.loginnedUser.isAdminInternal || (vm.loginnedUser.canVerifyBusinessUser && vm.user.isBiz)\"><more-tools class=user-homepage__more-tools-btn></more-tools></button></ul></div>");
$templateCache.put("app/sign-up-page/components/select-sign-up-type/select-sign-up-type.html","<div class=select-sign-up-type><div class=select-sign-up-type__wrapper><div class=\"select-sign-up-type__header clearfix\"><h3 class=\"select-sign-up-type__header__title text--extrabold text--color-black\" translate>{{\'signup-join-asia\'}}</h3><h4 class=\"select-sign-up-type__header__subtitle text--bold text--color-black\" translate>{{\'signup-user-type\'}}</h4></div><div class=\"select-sign-up-type__types clearfix\"><div class=\"block-section select-sign-up-type__types--personal clearfix\"><div class=\"select-sign-up-type__types__icon contributor-icon\"></div><div class=\"select-sign-up-type__types__info clearfix\"><h4 class=\"select-sign-up-type__types__title text--color-black text--bold\" translate>{{\'creator\'}}</h4><div class=select-sign-up-type__types__description><h6 class=select-sign-up-type__types__description__detail translate>{{\'contributor-description\'}}</h6></div></div><button id=E4 class=\"btn btn-submit select-sign-up-type__types__select-btn\" ng-click=\"vm.onTypeClicked(\'personal\')\" translate>{{\'select\'}}</button></div><div class=\"block-section select-sign-up-type__types--business clearfix\"><div class=\"select-sign-up-type__types__icon business-icon\"></div><div class=\"select-sign-up-type__types__info clearfix\"><h4 class=\"select-sign-up-type__types__title text--color-black text--bold\" translate>{{\'business\'}}</h4><div class=select-sign-up-type__types__description><h6 class=select-sign-up-type__types__description__detail translate>{{\'business-description\'}}</h6></div></div><button id=E5 class=\"btn btn-submit select-sign-up-type__types__select-btn\" ng-click=\"vm.onTypeClicked(\'business\')\" translate>{{\'select\'}}</button></div></div><div class=select-sign-up-type__types__footer>{{\'already-have-an-account\' | translate}}? <span ui-sref=sign-in-page class=\"select-sign-up-type__types__footer__login-nav text--bold text--color-black\" translate>{{\'log-in\'}}</span></div></div></div>");
$templateCache.put("app/sign-up-page/components/select-sign-up-type-popup/select-sign-up-type-popup.html","<div class=select-sign-up-type><button type=button class=close ng-click=vm.cancel()><span class=icon-icons_close aria-hidden=true></span></button><div class=select-sign-up-type__wrapper><div class=\"select-sign-up-type__header clearfix\"><h3 class=\"select-sign-up-type__header__title text--extrabold text--color-black\" translate>{{\'signup-join-asia\'}}</h3><h4 class=\"select-sign-up-type__header__subtitle text--bold text--color-black\" translate>{{\'choose-your-user-type\'}}</h4></div><div class=select-sign-up-type__select-user-type><div class=\"user-type__select item-0\" ng-click=\"vm.onTypeClicked(\'personal\')\" ng-class=\"{\'selected\': \'personal\' == vm.loginnedUser.account_type}\"><div class=\"user-type__header text--extrabold text--color-black\">{{\'creator\' | translate}}</div><div class=user-type__desc>{{\'contributor-description\' | translate}}</div></div><div class=\"user-type__select item-1\" ng-click=\"vm.onTypeClicked(\'business\')\" ng-class=\"{\'selected\': \'business\' == vm.loginnedUser.account_type}\"><div class=\"user-type__header text--extrabold text--color-black\">{{\'business\' | translate}}</div><div class=user-type__desc>{{\'business-description\' | translate}}</div></div><div class=\"user-type__select item-2\" ng-click=\"vm.onTypeClicked(\'guest\')\" ng-class=\"{\'selected\': \'guest\' == vm.loginnedUser.account_type}\"><div class=\"user-type__header text--extrabold text--color-black\">{{\'guest\' | translate}}</div><div class=user-type__desc>{{\'for-anyone-who-wants-to-browse-and-purchase\' | translate}}</div></div></div><div class=select-sign-up-type__types__footer><div class=select-sign-up-type__types__footer__tips>{{\'already-have-an-account\' | translate}}? <span ng-click=vm.loginBtnClicked() class=\"select-sign-up-type__types__footer__login-nav text--bold text--color-black\" translate>{{\'log-in\'}}</span></div><button class=\"btn btn-submit btn-next\" ng-disabled=!vm.canNext() ng-click=vm.onNextClicked() translate>{{\'next\'}}</button></div></div></div>");
$templateCache.put("app/sign-up-page/components/sign-up-business-email/sign-up-business-email.html","<div class=\"sign-up-business-email clearfix\"><div class=sign-up-business-email__wrapper><div class=\"sign-up-business-email__header clearfix\"><h3 class=\"sign-up-business-email__header__title text--extrabold text--color-black\" translate>{{\'onboarding-business\'}}</h3></div><div class=sign-up-business-email__content><form name=signUpForm class=clearfix><div class=\"form-group email-wrapper\"><label for=name ng-class=\"!signUpForm.$pristine && signUpForm.name.$invalid ? \'text--color-error\' : \'text--color-black\'\" translate>{{\'name\'}}</label><div class=alert-error ng-if=\"!vm.isWorking && !signUpForm.$pristine && signUpForm.name.$error && signUpForm.name.$error.required\">Please input your name!</div><input maxlength=255 name=name required ng-model=vm.user.data.first_name type=text class=form-control></div><div class=\"form-group email-wrapper\"><label for=email ng-class=\"!signUpForm.$pristine && (signUpForm.email.$invalid || !vm.emailNotExist) ? \'text--color-error\' : \'text--color-black\'\" translate>{{\'email\'}}</label><div class=alert-error ng-if=\"!vm.isChecking && !vm.isEmailValid\">{{vm.errorEmailMessage}}</div><input id=E2 maxlength=255 name=email type=email required ng-model=vm.user.data.email type=text ng-blur=\"vm.onCheckEmailExist(vm.user.data.email, signUpForm)\" class=form-control ng-class=\"{\'exist-email\': vm.emailNotExist === false}\"><div class=\"validate-sign spinner\" ng-if=vm.isChecking><i class=\"fa fa-2x fa-spin fa-spinner\"></i></div><div class=\"validate-sign check-icon text--bold icon-icons_check\" ng-if=\"!vm.isChecking && vm.emailNotExist\"></div><div class=\"validate-sign check-icon text--bold icon-icons_close\" ng-if=\"!vm.isChecking && vm.emailNotExist === false\"></div></div><div class=\"form-group password-wrapper\"><label for=password ng-class=\"!signUpForm.$pristine && signUpForm.password.$invalid ? \'text--color-error\' : \'text--color-black\'\" translate>{{\'password\'}}</label><div class=alert-error ng-if=\"!vm.isWorking && !signUpForm.$pristine && signUpForm.password.$error && signUpForm.password.$error.required\">{{\'input-password\' | translate}}!</div><input id=E3 ng-pattern=\"/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})/\" ng-blur=vm.onPasswordBlur($event) ng-focus=vm.checkPrivacyTooltipShown($event) ng-keyup=vm.checkPrivacyTooltipShown($event) tooltip-is-open=vm.isPasswordPrivacyTooltipShown name=password required ng-attr-type=\"{{vm.isShowPassword.data ? \'text\' : \'password\'}}\" ng-model=vm.user.data.password class=form-control tooltip-trigger=\"\'none\'\" tooltip-class=sign-up__tooltip-password-hint tooltip-append-to-body=true uib-tooltip=\"{{\'password-requirements\' | translate}}\"><div maxlength=255 title=\"{{\'hover-show-hide-password\' | translate}}\" class=\"btn-toogle-password text--bold\" ng-click=\"vm.isShowPassword.data = !vm.isShowPassword.data\" ng-if=vm.isShowPassword.data>{{\'hide\' | translate}}</div><div maxlength=255 title=\"{{\'hover-show-hide-password\' | translate}}\" class=\"btn-toogle-password text--bold\" ng-click=\"vm.isShowPassword.data = !vm.isShowPassword.data\" ng-if=!vm.isShowPassword.data>{{\'show\' | translate}}</div><div class=\"partern-error alert-error\" ng-if=\"!vm.isWorking && !signUpForm.$pristine && signUpForm.password.$error && signUpForm.password.$error.pattern\">{{\'password-requirements\' | translate}}</div></div></form></div><div class=sign-up-business-email__footer><button id=E789 ng-click=\"vm.onSignUpBtnClicked(\'Username-Password-Authentication\',signUpForm)\" type=button class=\"btn btn-block btn-submit sign-up-business-email__footer__signup-btn\" ng-disabled=vm.isWorking ng-class=\"{\'is-working\': vm.isWorking}\"><i class=\"fa fa-2x fa-spin fa-spinner\"></i>{{\'sign-up\' | translate}}</button><div class=sign-up-business-email__footer__notes><div class=sign-up-business-email__footer__notes__context translate>{{\'signup-agree-terms\'}}</div><div class=sign-up-business-email__footer__notes__context>Not a Business? <a class=\"text--bold text--color-black\" ng-click=vm.onChangeTypeClicked()>Sign up</a> as a Contributor</div></div></div></div></div>");
$templateCache.put("app/sign-up-page/components/sign-up-business-info/sign-up-business-info.html","<div class=\"sign-up-business-info clearfix\"><div class=sign-up-business-info__wrapper><div class=\"sign-up-business-info__header clearfix\"><h3 class=\"sign-up-business-info__header__title text--bold text--color-black\" translate>{{\'personal-info-page\'}}</h3></div><div class=sign-up-business-info__content><form name=profileForm class=clearfix><div class=\"form-group email-wrapper\" ng-if=vm.processGuestUser><label for=name required ng-class=\"!profileForm.$pristine && profileForm.name.$invalid ? \'text--color-error\' : \'text--color-black\'\" translate>{{\'name\'}}</label><input maxlength=255 name=name required ng-model=vm.user.data.first_name type=text class=form-control></div><div class=form-group><label required for=company ng-class=\"!profileForm.$pristine && profileForm.company.$invalid ? \'text--color-error\' : \'text--color-black\'\" translate>{{\'company-name\'}}</label><input name=company validation-no-hyperlink ng-model=vm.user.data.organization.name class=form-control required></div><div class=form-group><label required for=registration ng-class=\"!profileForm.$pristine && profileForm.registration.$invalid ? \'text--color-error\' : \'text--color-black\'\" translate>{{\'company-registration-no\'}}</label><input required name=registration validation-no-hyperlink ng-model=vm.user.data.organization.registration_no class=form-control></div><div class=form-group><label required for=officeType ng-class=\"!profileForm.$pristine && profileForm.officeType.$invalid ? \'text--color-error\' : \'text--color-black\'\" translate>{{\'type-of-office\'}}</label><select convert-mapping convert-mapping-parser=vm.officeParser(val) convert-mapping-formatter=vm.officeFormatter(val) required name=officeType class=form-control ng-model=vm.user.data.organization.office_type ng-options=\"opt.name for opt in vm.officeTypes.data track by opt.id \"></select></div><div class=form-group><label required for=telephone ng-class=\"!profileForm.$pristine && profileForm.telephone.$invalid ? \'text--color-error\' : \'text--color-black\'\" translate>{{\'phone-number\'}}</label><input type=text required national-mode=false international-phone-number default-country=sg ng-model=vm.user.data.organization.telephone name=telephone class=form-control></div><div class=form-group><label required for=country ng-class=\"!profileForm.$pristine && profileForm.country.$invalid ? \'text--color-error\' : \'text--color-black\'\">Country you are operating from</label><country-select class=form-control required name=country on-changed=vm.onCountrySelected(vm.user.data.organization.address.country) ng-model=vm.user.data.organization.address.country></country-select></div><div class=form-group><label required for=city ng-class=\"!profileForm.$pristine && profileForm.city.$invalid ? \'text--color-error\' : \'text--color-black\'\">City / State / Province / Region</label><input maxlength=255 required validation-no-hyperlink validation-no-number name=city ng-model=vm.user.data.organization.address.city class=form-control g-places-autocomplete options=vm.gplacesOptions></div></form></div><div class=sign-up-business-info__footer><button id=E12 ng-disabled=vm.isWorking ng-class=\"{\'is-working\': vm.isWorking}\" class=\"btn btn-block btn-submit sign-up-business-info__footer__signup-btn\" ng-click=\"vm.onDoneBtnClicked(vm.user.data, profileForm)\"><i class=\"fa fa-2x fa-spin fa-spinner\"></i>{{\'done\' | translate}}</button></div></div></div>");
$templateCache.put("app/sign-up-page/components/sign-up-guest-popup/sign-up-guest-popup.html","<div class=\"sign-up-guest-popup clearfix\"><div class=sign-up-guest-popup__wrapper><div class=\"sign-up-guest-popup__header clearfix\"><button type=button class=close ng-click=vm.cancel()><span class=icon-icons_close aria-hidden=true></span></button><h3 class=\"sign-up-guest-popup__header__title text--extrabold text--color-black\" translate>{{(vm.currentState == vm.states.validateEmail) ? \'sign-up-as-a-guest\' : \'personal-info-page\'}}</h3></div><div class=sign-up-guest-popup__content><form name=signUpForm class=clearfix ng-show=\"vm.currentState == vm.states.validateEmail\"><div class=\"form-group email-wrapper\"><label for=email ng-class=\"!signUpForm.$pristine && (signUpForm.email.$invalid || !vm.emailNotExist) ? \'text--color-error\' : \'text--color-black\'\" translate>{{\'email\'}}</label><div class=alert-error ng-if=\"!vm.isChecking && !vm.isEmailValid\">{{vm.errorEmailMessage}}</div><input id=E2 maxlength=255 name=email type=email required ng-model=vm.user.data.email type=text ng-blur=\"vm.onCheckEmailExist(vm.user.data.email, signUpForm)\" class=form-control ng-class=\"{\'exist-email\': vm.emailNotExist === false}\"><div class=\"validate-sign spinner\" ng-if=vm.isChecking><i class=\"fa fa-2x fa-spin fa-spinner\"></i></div><div class=\"validate-sign check-icon text--bold icon-icons_check\" ng-if=\"!vm.isChecking && vm.emailNotExist\"></div><div class=\"validate-sign check-icon text--bold icon-icons_close\" ng-if=\"!vm.isChecking && vm.emailNotExist === false\"></div></div><div class=\"form-group password-wrapper\"><label for=password ng-class=\"!signUpForm.$pristine && signUpForm.password.$invalid ? \'text--color-error\' : \'text--color-black\'\" translate>{{\'password\'}}</label><div class=alert-error ng-if=\"!vm.isWorking && !signUpForm.$pristine && signUpForm.password.$error && signUpForm.password.$error.required\">{{\'input-password\' | translate}}!</div><input id=E3 ng-pattern=\"/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})/\" ng-blur=vm.onPasswordBlur($event) ng-focus=vm.checkPrivacyTooltipShown($event) ng-keyup=vm.checkPrivacyTooltipShown($event) tooltip-is-open=vm.isPasswordPrivacyTooltipShown name=password required ng-attr-type=\"{{vm.isShowPassword.data ? \'text\' : \'password\'}}\" ng-model=vm.user.data.password class=form-control tooltip-trigger=\"\'none\'\" tooltip-class=sign-up__tooltip-password-hint tooltip-append-to-body=true uib-tooltip=\"{{\'password-requirements\' | translate}}\"><div maxlength=255 title=\"{{\'hover-show-hide-password\' | translate}}\" class=\"btn-toogle-password text--bold\" ng-click=\"vm.isShowPassword.data = !vm.isShowPassword.data\" ng-if=vm.isShowPassword.data>{{\'hide\' | translate}}</div><div maxlength=255 title=\"{{\'hover-show-hide-password\' | translate}}\" class=\"btn-toogle-password text--bold\" ng-click=\"vm.isShowPassword.data = !vm.isShowPassword.data\" ng-if=!vm.isShowPassword.data>{{\'show\' | translate}}</div><div class=\"partern-error alert-error\" ng-if=\"!vm.isWorking && !signUpForm.$pristine && signUpForm.password.$error && signUpForm.password.$error.pattern\">{{\'password-requirements\' | translate}}</div></div></form></div><div class=sign-up-guest-popup__footer><button id=E789 ng-if=\"vm.currentState == vm.states.validateEmail\" ng-click=\"vm.onSignUpBtnClicked(\'Username-Password-Authentication\',signUpForm)\" type=button class=\"btn btn-block btn-submit sign-up-guest-popup__footer__signup-btn\" ng-disabled=vm.isWorking ng-class=\"{\'is-working\': vm.isWorking}\"><i class=\"fa fa-2x fa-spin fa-spinner\"></i>{{\'sign-up\' | translate}}</button><div ng-if=\"vm.currentState == vm.states.validateEmail\" class=sign-up-guest-popup__footer__notes><div class=sign-up-guest-popup__footer__notes__context translate>{{\'signup-agree-terms\'}}</div><div class=sign-up-guest-popup__footer__notes__context ng-hide=vm.hideLogin>{{\'already-have-an-account\' | translate}}? <span ng-click=vm.loginBtnClicked() class=\"select-sign-up-type__types__footer__login-nav text--bold text--color-black\" translate>{{\'log-in\'}}</span></div></div></div></div></div>");
$templateCache.put("app/sign-up-page/components/sign-up-personal-email/sign-up-personal-email.html","<div class=\"sign-up-personal-email clearfix\"><div class=sign-up-personal-email__wrapper><div class=\"sign-up-personal-email__header clearfix\"><h3 class=\"sign-up-personal-email__header__title text--extrabold text--color-black\" translate>{{\'signup-contributor\'}}</h3></div><div class=\"sign-up-personal-email__content clearfix\"><div class=\"sign-up-personal-email__content__label text--bold\" translate>{{\'sign-up-with\'}}</div><div class=row><!-- <div class=\"sign-up-personal-email__content__social-btn fb-btn col-xs-6 no-padding-left\"\r\n					ng-click=\"vm.onSignUpBtnClicked(\'facebook\')\">\r\n					<a class=\"btn btn-block btn-social btn-facebook text--bold\" ng-click=\"\">\r\n						<span class=\"fa fa-facebook\"></span>\r\n						Facebook\r\n					</a>\r\n				</div> --><div class=\"sign-up-personal-email__content__social-btn google-btn no-padding-left\" ng-click=\"vm.onSignUpBtnClicked(\'google-oauth2\')\"><a class=\"btn btn-block btn-social btn-google text--bold text--color-black\" ng-click=\"\"><span class=social-media-google></span> Google</a></div></div><div class=\"sign-up-personal-email__content__label text--bold\" translate>{{\'signup-with-email\'}}</div><form name=signUpForm class=clearfix><div class=\"form-group email-wrapper clearfix\"><label for=email ng-class=\"!signUpForm.$pristine && (signUpForm.email.$invalid || !vm.emailNotExist) ? \'text--color-error\' : \'text--color-black\'\" translate>{{\'email\'}}</label><div class=alert-error ng-if=\"!vm.isChecking && !vm.isEmailValid\">{{vm.errorEmailMessage}}</div><input id=E2 maxlength=255 name=email type=email required ng-model=vm.user.data.email type=text ng-blur=\"vm.onCheckEmailExist(vm.user.data.email, signUpForm)\" class=form-control ng-class=\"{\'exist-email\': vm.emailNotExist === false}\"><div class=\"validate-sign spinner\" ng-if=vm.isChecking><i class=\"fa fa-2x fa-spin fa-spinner\"></i></div><div class=\"validate-sign check-icon text--bold icon-icons_check\" ng-if=\"!vm.isChecking && vm.emailNotExist\"></div><div class=\"validate-sign check-icon text--bold icon-icons_close\" ng-if=\"!vm.isChecking && vm.emailNotExist === false\"></div></div><div class=\"form-group password-wrapper clearfix\"><label for=password ng-class=\"!signUpForm.$pristine && signUpForm.password.$invalid ? \'text--color-error\' : \'text--color-black\'\" translate>{{\'password\'}}</label><div class=alert-error ng-if=\"!vm.isWorking && !signUpForm.$pristine && signUpForm.password.$error && signUpForm.password.$error.required\" translate>{{\'input-password\'}}!</div><input id=E3 ng-pattern=\"/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})/\" ng-blur=vm.onPasswordBlur($event) ng-focus=vm.onPasswordFocus($event) ng-keyup=vm.onPasswordKeyup($event) tooltip-is-open=vm.isPasswordPrivacyTooltipShown name=password required ng-attr-type=\"{{vm.isShowPassword.data ? \'text\' : \'password\'}}\" ng-model=vm.user.data.password class=form-control tooltip-trigger=\"\'none\'\" tooltip-class=sign-up__tooltip-password-hint tooltip-append-to-body=true tooltip-placement=right uib-tooltip=\"{{\'password-requirements\' | translate}}\"><div maxlength=255 title=\"{{\'hover-show-hide-password\' | translate}}\" class=\"btn-toogle-password text--bold\" ng-click=\"vm.isShowPassword.data = !vm.isShowPassword.data\" ng-if=vm.isShowPassword.data>{{\'hide\' | translate}}</div><div maxlength=255 title=\"{{\'hover-show-hide-password\' | translate}}\" class=\"btn-toogle-password text--bold\" ng-click=\"vm.isShowPassword.data = !vm.isShowPassword.data\" ng-if=!vm.isShowPassword.data>{{\'show\' | translate}}</div><div class=\"partern-error alert-error\" ng-if=\"!vm.isWorking && !signUpForm.$pristine && signUpForm.password.$error && signUpForm.password.$error.pattern\" translate>{{\'password-requirements\'}}</div></div></form></div><div class=sign-up-personal-email__footer><button id=E789 ng-click=\"vm.onSignUpBtnClicked(\'Username-Password-Authentication\',signUpForm)\" type=button class=\"btn btn-block btn-submit sign-up-personal-email__footer__signup-btn\" ng-disabled=vm.isWorking ng-class=\"{\'is-working\': vm.isWorking}\" translate><i class=\"fa fa-2x fa-spin fa-spinner\"></i>{{\'next\'}}</button><div class=sign-up-personal-email__footer__notes><div class=sign-up-personal-email__footer__notes__context translate>{{\'signup-agree-terms\'}}</div></div></div></div></div>");
$templateCache.put("app/sign-up-page/components/sign-up-business-popup/sign-up-business-popup.html","<div class=\"sign-up-business-popup clearfix\"><div class=sign-up-business-popup__wrapper><div class=\"sign-up-business-popup__header clearfix\"><button type=button class=close ng-click=vm.cancel()><span class=icon-icons_close aria-hidden=true></span></button><h3 class=\"sign-up-business-popup__header__title text--extrabold text--color-black\" translate>{{(vm.currentState == vm.states.validateEmail) ? \'sign-up-as-a-business-to-continue\' : \'personal-info-page\'}}</h3></div><div class=sign-up-business-popup__content><form name=signUpForm class=clearfix ng-show=\"vm.currentState == vm.states.validateEmail\"><div class=\"form-group email-wrapper\"><label for=name ng-class=\"!signUpForm.$pristine && signUpForm.name.$invalid ? \'text--color-error\' : \'text--color-black\'\" translate>{{\'name\'}}</label><div class=alert-error ng-if=\"!vm.isWorking && !signUpForm.$pristine && signUpForm.name.$error && signUpForm.name.$error.required\">Please input your name!</div><input maxlength=255 name=name required ng-model=vm.user.data.first_name type=text class=form-control></div><div class=\"form-group email-wrapper\"><label for=email ng-class=\"!signUpForm.$pristine && (signUpForm.email.$invalid || !vm.emailNotExist) ? \'text--color-error\' : \'text--color-black\'\" translate>{{\'email\'}}</label><div class=alert-error ng-if=\"!vm.isChecking && !vm.isEmailValid\">{{vm.errorEmailMessage}}</div><input id=E2 maxlength=255 name=email type=email required ng-model=vm.user.data.email type=text ng-blur=\"vm.onCheckEmailExist(vm.user.data.email, signUpForm)\" class=form-control ng-class=\"{\'exist-email\': vm.emailNotExist === false}\"><div class=\"validate-sign spinner\" ng-if=vm.isChecking><i class=\"fa fa-2x fa-spin fa-spinner\"></i></div><div class=\"validate-sign check-icon text--bold icon-icons_check\" ng-if=\"!vm.isChecking && vm.emailNotExist\"></div><div class=\"validate-sign check-icon text--bold icon-icons_close\" ng-if=\"!vm.isChecking && vm.emailNotExist === false\"></div></div><div class=\"form-group password-wrapper\"><label for=password ng-class=\"!signUpForm.$pristine && signUpForm.password.$invalid ? \'text--color-error\' : \'text--color-black\'\" translate>{{\'password\'}}</label><div class=alert-error ng-if=\"!vm.isWorking && !signUpForm.$pristine && signUpForm.password.$error && signUpForm.password.$error.required\">{{\'input-password\' | translate}}!</div><input id=E3 ng-pattern=\"/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})/\" ng-blur=vm.onPasswordBlur($event) ng-focus=vm.checkPrivacyTooltipShown($event) ng-keyup=vm.checkPrivacyTooltipShown($event) tooltip-is-open=vm.isPasswordPrivacyTooltipShown name=password required ng-attr-type=\"{{vm.isShowPassword.data ? \'text\' : \'password\'}}\" ng-model=vm.user.data.password class=form-control tooltip-trigger=\"\'none\'\" tooltip-class=sign-up__tooltip-password-hint tooltip-append-to-body=true uib-tooltip=\"{{\'password-requirements\' | translate}}\"><div maxlength=255 title=\"{{\'hover-show-hide-password\' | translate}}\" class=\"btn-toogle-password text--bold\" ng-click=\"vm.isShowPassword.data = !vm.isShowPassword.data\" ng-if=vm.isShowPassword.data>{{\'hide\' | translate}}</div><div maxlength=255 title=\"{{\'hover-show-hide-password\' | translate}}\" class=\"btn-toogle-password text--bold\" ng-click=\"vm.isShowPassword.data = !vm.isShowPassword.data\" ng-if=!vm.isShowPassword.data>{{\'show\' | translate}}</div><div class=\"partern-error alert-error\" ng-if=\"!vm.isWorking && !signUpForm.$pristine && signUpForm.password.$error && signUpForm.password.$error.pattern\">{{\'password-requirements\' | translate}}</div></div></form><form name=profileForm class=clearfix ng-show=\"vm.currentState == vm.states.fullfillInfo\"><div class=\"form-group email-wrapper\" ng-if=vm.processGuestUser><label for=name required ng-class=\"!profileForm.$pristine && profileForm.name.$invalid ? \'text--color-error\' : \'text--color-black\'\" translate>{{\'name\'}}</label><input maxlength=255 name=name required ng-model=vm.user.data.first_name type=text class=form-control></div><div class=form-group><label required for=company ng-class=\"!profileForm.$pristine && profileForm.company.$invalid ? \'text--color-error\' : \'text--color-black\'\" translate>{{\'company-name\'}}</label><input name=company validation-no-hyperlink ng-model=vm.user.data.organization.name class=form-control required></div><div class=form-group><label required for=registration ng-class=\"!profileForm.$pristine && profileForm.registration.$invalid ? \'text--color-error\' : \'text--color-black\'\" translate>{{\'company-registration-no\'}}</label><input required name=registration validation-no-hyperlink ng-model=vm.user.data.organization.registration_no class=form-control></div><div class=form-group><label required for=officeType ng-class=\"!profileForm.$pristine && profileForm.officeType.$invalid ? \'text--color-error\' : \'text--color-black\'\" translate>{{\'type-of-office\'}}</label><select convert-mapping convert-mapping-parser=vm.officeParser(val) convert-mapping-formatter=vm.officeFormatter(val) required name=officeType class=form-control ng-model=vm.user.data.organization.office_type ng-options=\"opt.name for opt in vm.officeTypes.data track by opt.id \"></select></div><div class=form-group><label required for=telephone ng-class=\"!profileForm.$pristine && profileForm.telephone.$invalid ? \'text--color-error\' : \'text--color-black\'\" translate>{{\'phone-number\'}}</label><input type=text required national-mode=false international-phone-number default-country=sg ng-model=vm.user.data.organization.telephone name=telephone class=form-control></div><div class=form-group><label required for=country ng-class=\"!profileForm.$pristine && profileForm.country.$invalid ? \'text--color-error\' : \'text--color-black\'\">Country you are operating from</label><country-select class=form-control required name=country on-changed=vm.onCountrySelected(vm.user.data.organization.address.country) ng-model=vm.user.data.organization.address.country></country-select></div><div class=form-group><label required for=city ng-class=\"!profileForm.$pristine && profileForm.city.$invalid ? \'text--color-error\' : \'text--color-black\'\">City / State / Province / Region</label><input maxlength=255 required validation-no-hyperlink validation-no-number name=city ng-model=vm.user.data.organization.address.city class=form-control g-places-autocomplete options=vm.gplacesOptions></div></form></div><div class=sign-up-business-popup__footer><button id=E789 ng-if=\"vm.currentState == vm.states.validateEmail\" ng-click=\"vm.onSignUpBtnClicked(\'Username-Password-Authentication\',signUpForm)\" type=button class=\"btn btn-block btn-submit sign-up-business-popup__footer__signup-btn\" ng-disabled=vm.isWorking ng-class=\"{\'is-working\': vm.isWorking}\"><i class=\"fa fa-2x fa-spin fa-spinner\"></i>{{\'sign-up\' | translate}}</button><div ng-if=\"vm.currentState == vm.states.validateEmail\" class=sign-up-business-popup__footer__notes><div class=sign-up-business-popup__footer__notes__context translate>{{\'signup-agree-terms\'}}</div><div class=sign-up-business-popup__footer__notes__context>{{\'already-have-an-account\' | translate}}? <span ng-click=vm.loginBtnClicked() class=\"select-sign-up-type__types__footer__login-nav text--bold text--color-black\" translate>{{\'log-in\'}}</span> <span ng-if=vm.isFixedForBiz>as a Business</span></div></div><button ng-if=\"vm.currentState == vm.states.fullfillInfo\" id=E12 ng-disabled=vm.isWorking ng-class=\"{\'is-working\': vm.isWorking}\" class=\"btn btn-block btn-submit sign-up-business-info__footer__signup-btn\" ng-click=\"vm.onDoneBtnClicked(vm.user.data, profileForm)\"><i class=\"fa fa-2x fa-spin fa-spinner\"></i>{{\'done\' | translate}}</button></div></div></div>");
$templateCache.put("app/sign-up-page/components/sign-up-personal-info/sign-up-personal-info.html","<div class=\"sign-up-personal-info clearfix\"><div class=sign-up-personal-info__wrapper><div class=\"sign-up-personal-info__header clearfix\"><h3 class=\"sign-up-personal-info__header__title text--bold text--color-black\" translate>{{\'personal-info-page\'}}</h3></div><div class=sign-up-personal-info__content><form name=profileForm class=clearfix><div class=\"form-group first-name-field col-sm-6\"><label for=first_name class=label-sign-up-information ng-class=\"!profileForm.$pristine && profileForm.first_name.$invalid ? \'text--color-error\' : \'text--color-black\'\" translate>{{\'first-name\'}}</label><input id=E6 maxlength=20 required validation-no-hyperlink validation-no-number name=first_name ng-model=vm.user.data.first_name class=form-control required focus-me=vm.isFocusField.data></div><div class=\"form-group last-name-field col-sm-6\"><label for=last_name class=label-sign-up-information ng-class=\"!profileForm.$pristine && profileForm.last_name.$invalid ? \'text--color-error\' : \'text--color-black\'\" translate>{{\'last-name\'}}</label><input id=E7 maxlength=20 required validation-no-hyperlink validation-no-number name=last_name ng-model=vm.user.data.last_name class=form-control></div><div class=\"form-group col-sm-12 no-padding\" class=sign-up-register-information-modal__country-select ng-class=\"{\'place-holder\': !vm.user.data.address.country}\"><label for=country class=label-sign-up-information ng-class=\"!profileForm.$pristine && profileForm.country.$invalid ? \'text--color-error\' : \'text--color-black\'\" translate>{{\'country-of-origin\'}}</label><country-select on-changed=vm.onCountrySelected(vm.user.data.address.country) place-holder=\"Select country\" id=E9 class=form-control required name=country ng-model=vm.user.data.address.country></country-select></div><div class=\"form-group col-sm-12 no-padding\" class=sign-up-register-information-modal__country-select ng-class=\"{\'place-holder\': !vm.user.data.address.country}\"><label for=location class=label-sign-up-information ng-class=\"!profileForm.$pristine && profileForm.location.$invalid ? \'text--color-error\' : \'text--color-black\'\">{{\'city\' | translate}}/{{\'state\' | translate}}</label><input id=E10 required validation-no-hyperlink name=location ng-model=vm.user.data.location class=form-control g-places-autocomplete options=vm.gplacesOptions></div><div class=\"form-group col-sm-12 no-padding\"><label for=\"\" class=label-sign-up-information ng-class=\"!profileForm.$pristine && vm.invalidBirthday ? \'text--color-error\' : \'text--color-black\'\" translate>{{\'birthday\'}}</label><div class=\"input-group pixerf-calendar-input\"><input type=text datepicker-options=\"{showWeeks: false}\" show-button-bar=false uib-datepicker-popup=d/MM/yyyy ng-model=vm.user.data.date_of_birth is-open=vm.filterFromIsVisible> <button type=button class=\"btn pixerf-calendar-input__toogle-btn\" ng-click=\"vm.filterFromIsVisible = !vm.filterFromIsVisible\"><i class=\"glyphicon glyphicon-calendar\"></i></button></div><div class=form-group__subscribe translate translate-values=\"{number: 18}\">{{\'signup-18\'}}</div></div></form></div><div class=sign-up-personal-info__footer><button id=E12 ng-disabled=vm.isWorking ng-class=\"{\'is-working\': vm.isWorking}\" class=\"btn btn-block btn-submit sign-up-personal-info__footer__signup-btn\" ng-click=\"vm.onDoneBtnClicked(vm.user.data, profileForm)\"><i class=\"fa fa-2x fa-spin fa-spinner\"></i>{{\'done\' | translate}}</button></div></div></div>");
$templateCache.put("app/sign-up-page/components/sign-up-personal-popup/sign-up-personal-popup.html","<div class=\"sign-up-personal-popup clearfix\"><div class=sign-up-personal-popup__wrapper><div class=\"sign-up-personal-popup__header clearfix\"><button type=button class=close ng-click=vm.cancel()><span class=icon-icons_close aria-hidden=true></span></button><h3 class=\"sign-up-personal-popup__header__title text--extrabold text--color-black\" translate>{{(vm.currentState == vm.states.validateEmail) ? \'signup-contributor\' : \'personal-info-page\'}}</h3></div><div class=sign-up-personal-popup__content><form name=signUpForm class=clearfix ng-show=\"vm.currentState == vm.states.validateEmail\"><div class=\"sign-up-personal-email__content__label text--bold\" translate>{{\'sign-up-with\'}}</div><div class=row><!-- <div class=\"sign-up-personal-email__content__social-btn fb-btn col-xs-6 no-padding-left\"\r\n						ng-click=\"vm.onSignUpBtnClicked(\'facebook\')\">\r\n						<a class=\"btn btn-block btn-social btn-facebook text--bold\" ng-click=\"\">\r\n							<span class=\"fa fa-facebook\"></span>\r\n							Facebook\r\n						</a>\r\n					</div> --><div class=\"sign-up-personal-email__content__social-btn google-btn no-padding-left\" ng-click=\"vm.onSignUpBtnClicked(\'google-oauth2\')\"><a class=\"btn btn-block btn-social btn-google text--bold text--color-black\" ng-click=\"\"><span class=social-media-google></span> Google</a></div></div><div class=\"sign-up-personal-email__content__label text--bold\" translate>{{\'signup-with-email\'}}</div><div class=\"form-group email-wrapper clearfix\"><label for=email ng-class=\"!signUpForm.$pristine && (signUpForm.email.$invalid || !vm.emailNotExist) ? \'text--color-error\' : \'text--color-black\'\" translate>{{\'email\'}}</label><div class=alert-error ng-if=\"!vm.isChecking && !vm.isEmailValid\">{{vm.errorEmailMessage}}</div><input id=E2 maxlength=255 name=email type=email required ng-model=vm.user.data.email type=text ng-blur=\"vm.onCheckEmailExist(vm.user.data.email, signUpForm)\" class=form-control ng-class=\"{\'exist-email\': vm.emailNotExist === false}\"><div class=\"validate-sign spinner\" ng-if=vm.isChecking><i class=\"fa fa-2x fa-spin fa-spinner\"></i></div><div class=\"validate-sign check-icon text--bold icon-icons_check\" ng-if=\"!vm.isChecking && vm.emailNotExist\"></div><div class=\"validate-sign check-icon text--bold icon-icons_close\" ng-if=\"!vm.isChecking && vm.emailNotExist === false\"></div></div><div class=\"form-group password-wrapper clearfix\"><label for=password ng-class=\"!signUpForm.$pristine && signUpForm.password.$invalid ? \'text--color-error\' : \'text--color-black\'\" translate>{{\'password\'}}</label><div class=alert-error ng-if=\"!vm.isWorking && !signUpForm.$pristine && signUpForm.password.$error && signUpForm.password.$error.required\" translate>{{\'input-password\'}}!</div><input id=E3 ng-pattern=\"/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})/\" ng-blur=vm.onPasswordBlur($event) ng-focus=vm.onPasswordFocus($event) ng-keyup=vm.onPasswordKeyup($event) tooltip-is-open=vm.isPasswordPrivacyTooltipShown name=password required ng-attr-type=\"{{vm.isShowPassword.data ? \'text\' : \'password\'}}\" ng-model=vm.user.data.password class=form-control tooltip-trigger=\"\'none\'\" tooltip-class=sign-up__tooltip-password-hint tooltip-append-to-body=true tooltip-placement=right uib-tooltip=\"{{\'password-requirements\' | translate}}\"><div maxlength=255 title=\"{{\'hover-show-hide-password\' | translate}}\" class=\"btn-toogle-password text--bold\" ng-click=\"vm.isShowPassword.data = !vm.isShowPassword.data\" ng-if=vm.isShowPassword.data>{{\'hide\' | translate}}</div><div maxlength=255 title=\"{{\'hover-show-hide-password\' | translate}}\" class=\"btn-toogle-password text--bold\" ng-click=\"vm.isShowPassword.data = !vm.isShowPassword.data\" ng-if=!vm.isShowPassword.data>{{\'show\' | translate}}</div><div class=\"partern-error alert-error\" ng-if=\"!vm.isWorking && !signUpForm.$pristine && signUpForm.password.$error && signUpForm.password.$error.pattern\" translate>{{\'password-requirements\'}}</div></div></form><form name=profileForm class=clearfix ng-show=\"vm.currentState == vm.states.fullfillInfo\"><div class=\"form-group first-name-field col-sm-6\"><label for=first_name class=label-sign-up-information ng-class=\"!profileForm.$pristine && profileForm.first_name.$invalid ? \'text--color-error\' : \'text--color-black\'\" translate>{{\'first-name\'}}</label><input id=E6 maxlength=20 required validation-no-hyperlink validation-no-number name=first_name ng-model=vm.user.data.first_name class=form-control required focus-me=vm.isFocusField.data></div><div class=\"form-group last-name-field col-sm-6\"><label for=last_name class=label-sign-up-information ng-class=\"!profileForm.$pristine && profileForm.last_name.$invalid ? \'text--color-error\' : \'text--color-black\'\" translate>{{\'last-name\'}}</label><input id=E7 maxlength=20 required validation-no-hyperlink validation-no-number name=last_name ng-model=vm.user.data.last_name class=form-control></div><div class=\"form-group col-sm-12 no-padding\" class=sign-up-register-information-modal__country-select ng-class=\"{\'place-holder\': !vm.user.data.address.country}\"><label for=country class=label-sign-up-information ng-class=\"!profileForm.$pristine && profileForm.country.$invalid ? \'text--color-error\' : \'text--color-black\'\" translate>{{\'country-of-origin\'}}</label><country-select on-changed=vm.onCountrySelected(vm.user.data.address.country) place-holder=\"Select country\" id=E9 class=form-control required name=country ng-model=vm.user.data.address.country></country-select></div><div class=\"form-group col-sm-12 no-padding\" class=sign-up-register-information-modal__country-select ng-class=\"{\'place-holder\': !vm.user.data.address.country}\"><label for=location class=label-sign-up-information ng-class=\"!profileForm.$pristine && profileForm.location.$invalid ? \'text--color-error\' : \'text--color-black\'\">{{\'city\' | translate}}/{{\'state\' | translate}}</label><input id=E10 required validation-no-hyperlink name=location ng-model=vm.user.data.location class=form-control g-places-autocomplete options=vm.gplacesOptions></div><div class=\"form-group col-sm-12 no-padding\"><label for=\"\" class=label-sign-up-information ng-class=\"!profileForm.$pristine && vm.invalidBirthday ? \'text--color-error\' : \'text--color-black\'\" translate>{{\'birthday\'}}</label><div class=\"input-group pixerf-calendar-input\"><input type=text datepicker-options=\"{showWeeks: false}\" show-button-bar=false uib-datepicker-popup=d/MM/yyyy ng-model=vm.user.data.date_of_birth is-open=vm.filterFromIsVisible> <button type=button class=\"btn pixerf-calendar-input__toogle-btn\" ng-click=\"vm.filterFromIsVisible = !vm.filterFromIsVisible\"><i class=\"glyphicon glyphicon-calendar\"></i></button></div><div class=form-group__subscribe translate translate-values=\"{number: 18}\">{{\'signup-18\'}}</div></div></form></div><div class=sign-up-personal-popup__footer><button id=E789 ng-if=\"vm.currentState == vm.states.validateEmail\" ng-click=\"vm.onSignUpBtnClicked(\'Username-Password-Authentication\',signUpForm)\" type=button class=\"btn btn-block btn-submit sign-up-personal-popup__footer__signup-btn\" ng-disabled=vm.isWorking ng-class=\"{\'is-working\': vm.isWorking}\"><i class=\"fa fa-2x fa-spin fa-spinner\"></i>{{\'sign-up\' | translate}}</button><div ng-if=\"vm.currentState == vm.states.validateEmail\" class=sign-up-personal-popup__footer__notes><div class=sign-up-personal-popup__footer__notes__context translate>{{\'signup-agree-terms\'}}</div><div class=sign-up-personal-popup__footer__notes__context>{{\'already-have-an-account\' | translate}}? <span ng-click=vm.loginBtnClicked() class=\"select-sign-up-type__types__footer__login-nav text--bold text--color-black\" translate>{{\'log-in\'}}</span> <span ng-if=vm.isFixedForBiz>as a Business</span></div></div><button ng-if=\"vm.currentState == vm.states.fullfillInfo\" id=E12 ng-disabled=vm.isWorking ng-class=\"{\'is-working\': vm.isWorking}\" class=\"btn btn-block btn-submit sign-up-business-info__footer__signup-btn\" ng-click=\"vm.onDoneBtnClicked(vm.user.data, profileForm)\"><i class=\"fa fa-2x fa-spin fa-spinner\"></i>{{\'done\' | translate}}</button></div></div></div>");
$templateCache.put("app/about-business-page/components/case-studies/about-case-studies/about-case-studies.html","<div class=about-case-studies><div class=about-case-studies__title>Brands who trust us</div><div class=about-case-studies__description>We have expanded the possibilities for both international and local brands to create scalable high quality custom visuals across Asia through our extensive network of creators.</div><div class=about-case-studies__description__sub>Learn how these featured customers did it!</div><div class=about-case-studies__grid><div ng-repeat=\"caseStudy in vm.caseStudies\" class=case-study-box ng-click=vm.onGoToDetails(caseStudy.id)><div class=case-study-box__content ng-style=\"{\'background-image\': \'url(\\\'\' + caseStudy.cover + \'\\\')\'}\"><div class=\"case-study-box__overlay-embed overlay-case-study--{{caseStudy.id}}\"></div><div class=case-study-box__overlay><div class=\"case-study-box__overlay__logo logo-{{caseStudy.id}}\" ng-style=\"{\'background-image\': \'url(\\\'\' + caseStudy.logo + \'\\\')\'}\"></div><div class=case-study-box__overlay__text>View Case Study</div></div><div class=case-study-box__info><div class=case-study-box__info__owner>{{caseStudy.owner}}</div><div class=case-study-box__info__title><span>{{caseStudy.type}}</span> <span ng-if=caseStudy.subType>-</span> <span ng-if=caseStudy.subType>{{caseStudy.subType}}</span></div></div></div></div></div></div>");
$templateCache.put("app/about-business-page/components/case-studies/case-study-details/case-study-ademco.html","<div class=\"case-study-details case-study-ademco\"><div class=case-study-details__banner photo-details-on-click=28741><div class=case-study-details__banner__back-btn ng-click=vm.onBackAboutCaseStudy()><span class=icon-icons_chevron-left></span> <span>Read more stories</span></div><div class=case-study-details__banner__box><div class=case-study-details__banner__box__type>{{vm.caseStudy.type}}</div><div class=case-study-details__banner__box__title>{{vm.caseStudy.title}}</div><div class=case-study-details__banner__box__owner>{{vm.caseStudy.client}}</div></div></div><div class=case-study-details__content><div class=case-study-details__content__back-btn ng-click=vm.onBackAboutCaseStudy() dynamic-show-hide-scroll scroll-down-class=hide-on-mobile><span class=icon-icons_chevron-left></span> <span>Read more stories</span></div><div class=case-study-details__content__section-1><div class=case-study-details__content__section-1__col-left><div class=case-study-details__content__section-1__col-left__content><div class=case-study-details__content__section-1__logo><img ng-src={{vm.caseStudy.logo}}></div><div class=case-study-details__content__section-1__list><div class=case-study-details__content__section-1__item><span class=case-study-details__content__section-1__item__title>CLIENT:</span> <span>{{vm.caseStudy.company || vm.caseStudy.client}}</span></div><div class=case-study-details__content__section-1__item><span class=case-study-details__content__section-1__item__title>TYPE:</span> <span>{{vm.caseStudy.contentType}}</span></div><div ng-if=vm.caseStudy.category class=case-study-details__content__section-1__item><span class=case-study-details__content__section-1__item__title>CATEGORY:</span> <span>{{vm.caseStudy.category}}</span></div><div ng-if=vm.caseStudy.daysOfShoots class=case-study-details__content__section-1__item><span class=case-study-details__content__section-1__item__title>DAYS OF SHOOT:</span> <span>{{vm.caseStudy.daysOfShoots}}</span></div><div ng-if=vm.caseStudy.imageLicensed class=case-study-details__content__section-1__item><span class=case-study-details__content__section-1__item__title>IMAGE LICENSED:</span> <span>{{vm.caseStudy.imageLicensed}}</span></div><div ng-if=vm.caseStudy.location class=case-study-details__content__section-1__item><span class=case-study-details__content__section-1__item__title>LOCATION:</span> <span>{{vm.caseStudy.location}}</span></div><div ng-if=vm.caseStudy.imageSubmissions class=case-study-details__content__section-1__item><span class=case-study-details__content__section-1__item__title>IMAGE SUBMISSIONS:</span> <span>{{vm.caseStudy.imageSubmissions}}</span></div><div ng-if=vm.caseStudy.reach class=case-study-details__content__section-1__item><span class=case-study-details__content__section-1__item__title>REACH:</span> <span>{{vm.caseStudy.reach}}</span></div></div><div class=case-study-details__content__section-1__button ng-click=vm.bookAShoot()>Book a Shoot</div></div></div><div class=case-study-details__content__section-1__col-right><div class=case-study-details__content__section-1__back-btn ng-click=vm.onBackAboutCaseStudy()><span class=icon-icons_chevron-left></span> <span>Read more stories</span></div><div class=case-study-details__content__section-1__content><p>Ademco is Asia’s Leading Security Provider. They came to PIXERF to execute a corporate photoshoot to highlight to their customers and potential clients what actually goes on in the control command centre without giving away too much of their trade secrets. One of the key factor for their success is their officers on duty who handles the cases that comes through with excellence.</p></div><div class=case-study-details__content__section-1__background photo-details-on-click=147404><div class=case-study-details__content__section-1__box><div class=case-study-details__content__section-1__box__title>Services included:</div><div class=case-study-details__content__section-1__box__list><div class=case-study-details__content__section-1__box__item>Photography Services</div><div class=case-study-details__content__section-1__box__item>Makeup Artist Services</div><div class=case-study-details__content__section-1__box__item>Social media promotion</div><div class=case-study-details__content__section-1__box__item>Post photography Services (Editing)</div></div></div></div></div></div><div class=case-study-details__content__section-2 photo-details-on-click=122364><div class=case-study-details__content__section-2__overlay></div><div class=case-study-details__content__section-2__box><div class=case-study-details__content__section-2__box__title>The usage of the images are meant for their corporate portfolio, marketing both on Web and digital spaces.</div></div></div><div class=case-study-details__content__section-3><div class=case-study-details__content__section-3__col-left></div><div class=case-study-details__content__section-3__col-right><div class=case-study-details__content__section-3__photo photo-details-on-click=159218></div><div class=case-study-details__content__section-3__content><p>With that in mind, the team executed a brand / corporate photoshoot that shows the main activities that the Ademco team goes through from reporting, customer service to ensuring overall operations of projects running smooth.</p><p>The usage of the images are meant for their corporate portfolio, marketing both on Web and digital spaces. The shoot was executed in 1 day with a total of 10 internal talents that was coordinated for the shoot. There are 40 licensed photos out of over 800 images shot. (edited)</p></div></div></div><div class=case-study-details__content__section-4><div flex-grid ng-model=vm.caseStudy.photos rowheight=300 margins=20 lastrow=justify borderstyle=-20 class=case-study-details__content__section-4__photo-grid><div ng-repeat=\"photo in vm.caseStudy.photos\" class=case-study-details__content__section-4__item><img ng-src={{photo.url}} photo-details-on-click={{photo.id}}><div ng-if=photo.badge class=case-study-details__badge class=case-study-details__content__section-4__item ng-click=\"vm.onGoMissionDetails({id: photo.missionId, name: (photo.missionName | toSnakeCase)})\"><div class=case-study-details__badge__icon></div><div class=case-study-details__badge__name>{{photo.badge}}</div></div></div></div></div><div ng-if=\"vm.slideDatas && vm.slideDatas.length\" class=case-study-details__content__section-5><div class=case-study-details__content__section-5__title>Read more case studies</div><div class=case-study-details__content__section-5__content><div class=case-study-details__content__section-5__carousel__wrapper><slick speed=1000 class=case-study-details__content__section-5__carousel infinite=false slides-to-scroll=3 slides-to-show=3 dots=true arrows=false on-init=vm.slickSetting.onInit(slick) on-after-change=\"vm.slickSetting.onAfterChange(event, slick, currentSlide, nextSlide)\"><div ng-repeat=\"data in vm.slideDatas\"><div class=case-study-details__content__section-5__item ng-style=\"{\'background-image\': \'url(\\\'\' + data.cover + \'\\\')\'}\"><div class=case-study-details__content__section-5__item__info ng-click=vm.onGotoCaseStudy(data)><div class=case-study-details__content__section-5__item__info__auth>{{data.owner}}</div><div class=case-study-details__content__section-5__item__info__type>{{data.type}}{{data.subType ? \' - \' + data.subType: \'\'}}</div></div></div></div></slick><slick speed=1000 class=case-study-details__content__section-5__carousel--mobile infinite=false slides-to-scroll=1 slides-to-show=1 dots=true arrows=false center-mode=true on-init=vm.slickMobileSetting.onInit(slick) on-after-change=\"vm.slickMobileSetting.onAfterChange(event, slick, currentSlide, nextSlide)\"><div ng-repeat=\"data in vm.slideDatas\"><div class=case-study-details__content__section-5__item ng-style=\"{\'background-image\': \'url(\\\'\' + data.cover + \'\\\')\'}\"><div class=case-study-details__content__section-5__item__info ng-click=vm.onGotoCaseStudy(data)><div class=case-study-details__content__section-5__item__info__auth>{{data.owner}}</div><div class=case-study-details__content__section-5__item__info__type>{{data.type}}{{data.subType ? \' - \' + data.subType: \'\'}}</div></div></div></div></slick><div class=case-study-details__content__section-5__carousel__navigate><div class=\"case-study-details__content__section-5__carousel__navigate__left icon-slide-prev-icon\" ng-class=\"{\'disabled\': vm.isFirstSlickSlide, \'disabled-mobile\': vm.isFirstSlickMobileSlide}\" ng-click=vm.onPreviousSlide()></div><div class=\"case-study-details__content__section-5__carousel__navigate__right icon-slide-next-icon\" ng-class=\"{\'disabled\': vm.isLastSlickSlide, \'disabled-mobile\': vm.isLastSlickMobileSlide}\" ng-click=vm.onNextSlide()></div></div></div></div></div></div></div>");
$templateCache.put("app/about-business-page/components/case-studies/case-study-details/case-study-asian-geographic.html","<div class=\"case-study-details case-study-asian-geographic\"><div class=case-study-details__banner photo-details-on-click=170269><div class=case-study-details__banner__back-btn ng-click=vm.onBackAboutCaseStudy()><span class=icon-icons_chevron-left></span> <span>Read more stories</span></div><div class=case-study-details__banner__box><div class=case-study-details__banner__box__type>{{vm.caseStudy.type}}</div><div class=case-study-details__banner__box__title>{{vm.caseStudy.title}}</div><div class=case-study-details__banner__box__owner>{{vm.caseStudy.client}}</div></div></div><div class=case-study-details__content><div class=case-study-details__content__back-btn ng-click=vm.onBackAboutCaseStudy() dynamic-show-hide-scroll scroll-down-class=hide-on-mobile><span class=icon-icons_chevron-left></span> <span>Read more stories</span></div><div class=case-study-details__content__section-1><div class=case-study-details__content__section-1__col-left><div class=case-study-details__content__section-1__col-left__content><div class=case-study-details__content__section-1__logo><img ng-src={{vm.caseStudy.logo}}></div><div class=case-study-details__content__section-1__list><div class=case-study-details__content__section-1__item><span class=case-study-details__content__section-1__item__title>CLIENT:</span> <span>{{vm.caseStudy.company || vm.caseStudy.client}}</span></div><div class=case-study-details__content__section-1__item><span class=case-study-details__content__section-1__item__title>TYPE:</span> <span>{{vm.caseStudy.contentType}}</span></div><div ng-if=vm.caseStudy.category class=case-study-details__content__section-1__item><span class=case-study-details__content__section-1__item__title>CATEGORY:</span> <span>{{vm.caseStudy.category}}</span></div><div ng-if=vm.caseStudy.daysOfShoots class=case-study-details__content__section-1__item><span class=case-study-details__content__section-1__item__title>DAYS OF SHOOT:</span> <span>{{vm.caseStudy.daysOfShoots}}</span></div><div ng-if=vm.caseStudy.imageLicensed class=case-study-details__content__section-1__item><span class=case-study-details__content__section-1__item__title>IMAGE LICENSED:</span> <span>{{vm.caseStudy.imageLicensed}}</span></div><div ng-if=vm.caseStudy.location class=case-study-details__content__section-1__item><span class=case-study-details__content__section-1__item__title>LOCATION:</span> <span>{{vm.caseStudy.location}}</span></div><div ng-if=vm.caseStudy.imageSubmissions class=case-study-details__content__section-1__item><span class=case-study-details__content__section-1__item__title>IMAGE SUBMISSIONS:</span> <span>{{vm.caseStudy.imageSubmissions}}</span></div><div ng-if=vm.caseStudy.reach class=case-study-details__content__section-1__item><span class=case-study-details__content__section-1__item__title>REACH:</span> <span>{{vm.caseStudy.reach}}</span></div></div><div class=case-study-details__content__section-1__button ng-click=vm.bookAShoot()>Book a Shoot</div></div></div><div class=case-study-details__content__section-1__col-right><div class=case-study-details__content__section-1__back-btn ng-click=vm.onBackAboutCaseStudy()><span class=icon-icons_chevron-left></span> <span>Read more stories</span></div><div class=case-study-details__content__section-1__content><p>PIXERF teamed up with Asia\'s renowned magazine brand to enhance the reach and relevance of its prestigious photo competition.</p><p>For 14 years, Asian Geographic magazine has held the annual Images of Asia competition to celebrate the vitality and diversity of Asia through the lens of photography. In 2018, the magazine engaged PIXERF as a technology partner to reach out to a wider community of photographers via our Community Challenges platform. To meet this objective, we identified a need to simplify the contest submission process into something hassle-free and digitally intuitive for the smartphone generation.</p></div><div class=case-study-details__content__section-1__background photo-details-on-click=166411><div class=case-study-details__content__section-1__box><div class=case-study-details__content__section-1__box__title>Services included:</div><div class=case-study-details__content__section-1__box__list><div class=case-study-details__content__section-1__box__item>Refinement of brief</div><div class=case-study-details__content__section-1__box__item>Curation of visual inspiration</div><div class=case-study-details__content__section-1__box__item>Social media promotion</div><div class=case-study-details__content__section-1__box__item>Curation of submissions</div><div class=case-study-details__content__section-1__box__item>Award announcement posts</div></div></div></div></div></div><div class=case-study-details__content__section-2 photo-details-on-click=165282><div class=case-study-details__content__section-2__box><div class=case-study-details__content__section-2__box__title>\"Bringing PIXERF onboard allowed us to leverage their platform and community. The partnership enhanced the submissions received and we gained useful data from it.\"</div><div class=case-study-details__content__section-2__box__author><div class=case-study-details__content__section-2__box__author__name>John Thet</div><div class=case-study-details__content__section-2__box__author__position>CEO<br>Asian Geographic</div></div><div class=case-study-details__content__section-2__badge ng-click=\"vm.onGoMissionDetails({id: 61, name: \'Images-of-Asia-–-Wildlife\'})\"><div class=case-study-details__badge><div class=case-study-details__badge__icon></div><div class=case-study-details__badge__name>Images of Asia - Wildlife</div></div></div></div></div><div class=case-study-details__content__section-3><div class=case-study-details__content__section-3__col-left></div><div class=case-study-details__content__section-3__col-right><div class=case-study-details__content__section-3__photo photo-details-on-click=167375></div><div class=case-study-details__content__section-3__content><p>Traditionally, photographers were required to submit their photos through one of the following methods: email, post, or the contest website. To simplify the process, we created a streamlined registration journey that caters to Asian Geographic magazine subscribers, non-subscribers, and the PIXERF community. Reflecting the changing trends within the photography landscape, a new category for Mobile Photographers was also added – opening the competition to a new generation of promising enthusiasts and mobile photographers.</p><p>The competition ramped up to an exciting live judging event where a panel of judges from different countries, including rising photographer and PIXERF Ambassador Shavonne Wong, selected the winning images from each category. The client’s feedback was largely positive. In addition to raising the quality of submissions, data gathered from the Community Challenges platform will help the brand to plan its future engagement efforts.</p></div></div></div><div class=case-study-details__content__section-4><div flex-grid ng-model=vm.caseStudy.photos rowheight=300 margins=20 lastrow=justify borderstyle=-20 class=case-study-details__content__section-4__photo-grid><div ng-repeat=\"photo in vm.caseStudy.photos\" class=case-study-details__content__section-4__item><img ng-src={{photo.url}} photo-details-on-click={{photo.id}}><div ng-if=photo.badge class=case-study-details__badge class=case-study-details__content__section-4__item ng-click=\"vm.onGoMissionDetails({id: photo.missionId, name: (photo.missionName | toSnakeCase)})\"><div class=case-study-details__badge__icon></div><div class=case-study-details__badge__name>{{photo.badge}}</div></div></div></div></div><div ng-if=\"vm.slideDatas && vm.slideDatas.length\" class=case-study-details__content__section-5><div class=case-study-details__content__section-5__title>Read more case studies</div><div class=case-study-details__content__section-5__content><div class=case-study-details__content__section-5__carousel__wrapper><slick speed=1000 class=case-study-details__content__section-5__carousel infinite=false slides-to-scroll=3 slides-to-show=3 dots=true arrows=false on-init=vm.slickSetting.onInit(slick) on-after-change=\"vm.slickSetting.onAfterChange(event, slick, currentSlide, nextSlide)\"><div ng-repeat=\"data in vm.slideDatas\"><div class=case-study-details__content__section-5__item ng-style=\"{\'background-image\': \'url(\\\'\' + data.cover + \'\\\')\'}\"><div class=case-study-details__content__section-5__item__info ng-click=vm.onGotoCaseStudy(data)><div class=case-study-details__content__section-5__item__info__auth>{{data.owner}}</div><div class=case-study-details__content__section-5__item__info__type>{{data.type}}{{data.subType ? \' - \' + data.subType: \'\'}}</div></div></div></div></slick><slick speed=1000 class=case-study-details__content__section-5__carousel--mobile infinite=false slides-to-scroll=1 slides-to-show=1 dots=true arrows=false center-mode=true on-init=vm.slickMobileSetting.onInit(slick) on-after-change=\"vm.slickMobileSetting.onAfterChange(event, slick, currentSlide, nextSlide)\"><div ng-repeat=\"data in vm.slideDatas\"><div class=case-study-details__content__section-5__item ng-style=\"{\'background-image\': \'url(\\\'\' + data.cover + \'\\\')\'}\"><div class=case-study-details__content__section-5__item__info ng-click=vm.onGotoCaseStudy(data)><div class=case-study-details__content__section-5__item__info__auth>{{data.owner}}</div><div class=case-study-details__content__section-5__item__info__type>{{data.type}}{{data.subType ? \' - \' + data.subType: \'\'}}</div></div></div></div></slick><div class=case-study-details__content__section-5__carousel__navigate><div class=\"case-study-details__content__section-5__carousel__navigate__left icon-slide-prev-icon\" ng-class=\"{\'disabled\': vm.isFirstSlickSlide, \'disabled-mobile\': vm.isFirstSlickMobileSlide}\" ng-click=vm.onPreviousSlide()></div><div class=\"case-study-details__content__section-5__carousel__navigate__right icon-slide-next-icon\" ng-class=\"{\'disabled\': vm.isLastSlickSlide, \'disabled-mobile\': vm.isLastSlickMobileSlide}\" ng-click=vm.onNextSlide()></div></div></div></div></div></div></div>");
$templateCache.put("app/about-business-page/components/case-studies/case-study-details/case-study-blackmores.html","<div class=\"case-study-details case-study-blackmores\"><div class=case-study-details__banner><div class=case-study-details__banner__back-btn ng-click=vm.onBackAboutCaseStudy()><span class=icon-icons_chevron-left></span> <span>Read more stories</span></div><div class=case-study-details__banner__box><div class=case-study-details__banner__box__type>{{vm.caseStudy.type}}</div><div class=case-study-details__banner__box__title>{{vm.caseStudy.title}}</div><div class=case-study-details__banner__box__owner>{{vm.caseStudy.client}}</div></div></div><div class=case-study-details__content><div class=case-study-details__content__back-btn ng-click=vm.onBackAboutCaseStudy() dynamic-show-hide-scroll scroll-down-class=hide-on-mobile><span class=icon-icons_chevron-left></span> <span>Read more stories</span></div><div class=case-study-details__content__section-1><div class=case-study-details__content__section-1__col-left><div class=case-study-details__content__section-1__col-left__content><div class=case-study-details__content__section-1__logo><img ng-src={{vm.caseStudy.logo}}></div><div class=case-study-details__content__section-1__list><div class=case-study-details__content__section-1__item><span class=case-study-details__content__section-1__item__title>CLIENT:</span> <span>{{vm.caseStudy.company || vm.caseStudy.client}}</span></div><div class=case-study-details__content__section-1__item><span class=case-study-details__content__section-1__item__title>TYPE:</span> <span>{{vm.caseStudy.contentType}}</span></div><div ng-if=vm.caseStudy.category class=case-study-details__content__section-1__item><span class=case-study-details__content__section-1__item__title>CATEGORY:</span> <span>{{vm.caseStudy.category}}</span></div><div ng-if=vm.caseStudy.daysOfShoots class=case-study-details__content__section-1__item><span class=case-study-details__content__section-1__item__title>DAYS OF SHOOT:</span> <span>{{vm.caseStudy.daysOfShoots}}</span></div><div ng-if=vm.caseStudy.imageLicensed class=case-study-details__content__section-1__item><span class=case-study-details__content__section-1__item__title>IMAGE LICENSED:</span> <span>{{vm.caseStudy.imageLicensed}}</span></div><div ng-if=vm.caseStudy.location class=case-study-details__content__section-1__item><span class=case-study-details__content__section-1__item__title>LOCATION:</span> <span>{{vm.caseStudy.location}}</span></div><div ng-if=vm.caseStudy.imageSubmissions class=case-study-details__content__section-1__item><span class=case-study-details__content__section-1__item__title>IMAGE SUBMISSIONS:</span> <span>{{vm.caseStudy.imageSubmissions}}</span></div><div ng-if=vm.caseStudy.reach class=case-study-details__content__section-1__item><span class=case-study-details__content__section-1__item__title>REACH:</span> <span>{{vm.caseStudy.reach}}</span></div></div><div class=case-study-details__content__section-1__button ng-click=vm.bookAShoot()>Book a Shoot</div></div></div><div class=case-study-details__content__section-1__col-right><div class=case-study-details__content__section-1__back-btn ng-click=vm.onBackAboutCaseStudy()><span class=icon-icons_chevron-left></span> <span>Read more stories</span></div><div class=case-study-details__content__section-1__content>For this Custom Content Assignment, we helped Australia’s leading health supplement company Blackmores to produce content for a marketing campaign promoting a new range of Vitamin E products. The campaign was targeted at health-conscious Asian consumers who value natural ingredients.</div><div class=case-study-details__content__section-1__background><div class=case-study-details__content__section-1__box><div class=case-study-details__content__section-1__box__title>Services included:</div><div class=case-study-details__content__section-1__box__list><div class=case-study-details__content__section-1__box__item>Sourcing and matching photographers to assignment</div><div class=case-study-details__content__section-1__box__item>Sourcing of props and location</div><div class=case-study-details__content__section-1__box__item>Art direction and styling services</div><div class=case-study-details__content__section-1__box__item>Photography services</div><div class=case-study-details__content__section-1__box__item>Post-production editing</div><div class=case-study-details__content__section-1__box__item>Logistical support</div></div></div></div></div></div><div class=case-study-details__content__section-2><div class=case-study-details__content__section-2__box><div class=case-study-details__content__section-2__box__title>The resulting shots emphasised the all natural ingredients of its products and aligned with its global branding guidelines.</div></div></div><div class=case-study-details__content__section-3><div class=case-study-details__content__section-3__col-left></div><div class=case-study-details__content__section-3__col-right><div class=case-study-details__content__section-3__photo></div><div class=case-study-details__content__section-3__content><p>We worked together with Blackmores to refine the brief and matched them with a commercial photographer who were able to execute the shoots at speed. The resulting shots emphasised the all natural ingredients of its products and aligned with its global branding guidelines.</p></div></div></div><div class=case-study-details__content__section-4><div flex-grid ng-model=vm.caseStudy.photos rowheight=300 margins=20 lastrow=justify borderstyle=-20 class=case-study-details__content__section-4__photo-grid><div ng-repeat=\"photo in vm.caseStudy.photos\"><img ng-src={{photo.url}}></div></div></div><div ng-if=\"vm.slideDatas && vm.slideDatas.length\" class=case-study-details__content__section-5><div class=case-study-details__content__section-5__title>Read more case studies</div><div class=case-study-details__content__section-5__content><div class=case-study-details__content__section-5__carousel__wrapper><slick speed=1000 class=case-study-details__content__section-5__carousel infinite=false slides-to-scroll=3 slides-to-show=3 dots=true arrows=false on-init=vm.slickSetting.onInit(slick) on-after-change=\"vm.slickSetting.onAfterChange(event, slick, currentSlide, nextSlide)\"><div ng-repeat=\"data in vm.slideDatas\"><div class=case-study-details__content__section-5__item ng-style=\"{\'background-image\': \'url(\\\'\' + data.cover + \'\\\')\'}\"><div class=case-study-details__content__section-5__item__info ng-click=vm.onGotoCaseStudy(data)><div class=case-study-details__content__section-5__item__info__auth>{{data.owner}}</div><div class=case-study-details__content__section-5__item__info__type>{{data.type}}{{data.subType ? \' - \' + data.subType: \'\'}}</div></div></div></div></slick><slick speed=1000 class=case-study-details__content__section-5__carousel--mobile infinite=false slides-to-scroll=1 slides-to-show=1 dots=true arrows=false center-mode=true on-init=vm.slickMobileSetting.onInit(slick) on-after-change=\"vm.slickMobileSetting.onAfterChange(event, slick, currentSlide, nextSlide)\"><div ng-repeat=\"data in vm.slideDatas\"><div class=case-study-details__content__section-5__item ng-style=\"{\'background-image\': \'url(\\\'\' + data.cover + \'\\\')\'}\"><div class=case-study-details__content__section-5__item__info ng-click=vm.onGotoCaseStudy(data)><div class=case-study-details__content__section-5__item__info__auth>{{data.owner}}</div><div class=case-study-details__content__section-5__item__info__type>{{data.type}}{{data.subType ? \' - \' + data.subType: \'\'}}</div></div></div></div></slick><div class=case-study-details__content__section-5__carousel__navigate><div class=\"case-study-details__content__section-5__carousel__navigate__left icon-slide-prev-icon\" ng-class=\"{\'disabled\': vm.isFirstSlickSlide, \'disabled-mobile\': vm.isFirstSlickMobileSlide}\" ng-click=vm.onPreviousSlide()></div><div class=\"case-study-details__content__section-5__carousel__navigate__right icon-slide-next-icon\" ng-class=\"{\'disabled\': vm.isLastSlickSlide, \'disabled-mobile\': vm.isLastSlickMobileSlide}\" ng-click=vm.onNextSlide()></div></div></div></div></div></div></div>");
$templateCache.put("app/about-business-page/components/case-studies/case-study-details/case-study-cellini.html","<div class=\"case-study-details case-study-cellini\"><div class=case-study-details__banner><div class=case-study-details__banner__back-btn ng-click=vm.onBackAboutCaseStudy()><span class=icon-icons_chevron-left></span> <span>Read more stories</span></div><div class=case-study-details__banner__box><div class=case-study-details__banner__box__type>{{vm.caseStudy.type}}</div><div class=case-study-details__banner__box__title>{{vm.caseStudy.title}}</div><div class=case-study-details__banner__box__owner>{{vm.caseStudy.client}}</div></div></div><div class=case-study-details__content><div class=case-study-details__content__back-btn ng-click=vm.onBackAboutCaseStudy() dynamic-show-hide-scroll scroll-down-class=hide-on-mobile><span class=icon-icons_chevron-left></span> <span>Read more stories</span></div><div class=case-study-details__content__section-1><div class=case-study-details__content__section-1__col-left><div class=case-study-details__content__section-1__col-left__content><div class=case-study-details__content__section-1__logo><img ng-src={{vm.caseStudy.logo}}></div><div class=case-study-details__content__section-1__list><div class=case-study-details__content__section-1__item><span class=case-study-details__content__section-1__item__title>CLIENT:</span> <span>{{vm.caseStudy.company || vm.caseStudy.client}}</span></div><div class=case-study-details__content__section-1__item><span class=case-study-details__content__section-1__item__title>TYPE:</span> <span>{{vm.caseStudy.contentType}}</span></div><div ng-if=vm.caseStudy.category class=case-study-details__content__section-1__item><span class=case-study-details__content__section-1__item__title>CATEGORY:</span> <span>{{vm.caseStudy.category}}</span></div><div ng-if=vm.caseStudy.daysOfShoots class=case-study-details__content__section-1__item><span class=case-study-details__content__section-1__item__title>DAYS OF SHOOT:</span> <span>{{vm.caseStudy.daysOfShoots}}</span></div><div ng-if=vm.caseStudy.imageLicensed class=case-study-details__content__section-1__item><span class=case-study-details__content__section-1__item__title>IMAGE LICENSED:</span> <span>{{vm.caseStudy.imageLicensed}}</span></div><div ng-if=vm.caseStudy.location class=case-study-details__content__section-1__item><span class=case-study-details__content__section-1__item__title>LOCATION:</span> <span>{{vm.caseStudy.location}}</span></div><div ng-if=vm.caseStudy.imageSubmissions class=case-study-details__content__section-1__item><span class=case-study-details__content__section-1__item__title>IMAGE SUBMISSIONS:</span> <span>{{vm.caseStudy.imageSubmissions}}</span></div><div ng-if=vm.caseStudy.reach class=case-study-details__content__section-1__item><span class=case-study-details__content__section-1__item__title>REACH:</span> <span>{{vm.caseStudy.reach}}</span></div></div><div class=case-study-details__content__section-1__button ng-click=vm.bookAShoot()>Book a Shoot</div></div></div><div class=case-study-details__content__section-1__col-right><div class=case-study-details__content__section-1__back-btn ng-click=vm.onBackAboutCaseStudy()><span class=icon-icons_chevron-left></span> <span>Read more stories</span></div><div class=case-study-details__content__section-1__content>For Singapore furniture brand Cellini, we made sure that the photos for their social media marketing had just the desired look: relaxed, contemporary and effortless. The photoshoot covers all the furniture pieces and furnishings in the brand\'s collection, shot in just over two days.</div><div class=case-study-details__content__section-1__background><div class=case-study-details__content__section-1__box><div class=case-study-details__content__section-1__box__title>Services included:</div><div class=case-study-details__content__section-1__box__list><div class=case-study-details__content__section-1__box__item>Sourcing and matching photographers to assignment</div><div class=case-study-details__content__section-1__box__item>Art direction and styling services</div><div class=case-study-details__content__section-1__box__item>Photography services</div><div class=case-study-details__content__section-1__box__item>Post-production editing</div><div class=case-study-details__content__section-1__box__item>Logistical support</div></div></div></div></div></div><div class=case-study-details__content__section-2><div class=case-study-details__content__section-2__box><div class=case-study-details__content__section-2__box__title>\"The process was well planned and executed, and we are happy with the quality of photos delivered.\"</div><div class=case-study-details__content__section-2__box__author><div class=case-study-details__content__section-2__box__author__name>Kerine Yong</div><div class=case-study-details__content__section-2__box__author__position>Assistant Regional Marketing Manager<br>Cellini Design Center Pte Ltd</div></div></div></div><div class=case-study-details__content__section-3><div class=case-study-details__content__section-3__col-left></div><div class=case-study-details__content__section-3__col-right><div class=case-study-details__content__section-3__photo></div><div class=case-study-details__content__section-3__content><p>To ensure timely delivery within this short timeframe, we enlisted a seasoned photographer with extensive experience in interior and lifestyle photography and the ability to execute the shoots independently, without a moodboard at hand. Cellini was satisfied with the outcome and continued to engage the photographer for subsequent projects.</p></div></div></div><div class=case-study-details__content__section-4><div flex-grid ng-model=vm.caseStudy.photos rowheight=300 margins=20 lastrow=justify borderstyle=-20 class=case-study-details__content__section-4__photo-grid><div ng-repeat=\"photo in vm.caseStudy.photos\"><img ng-src={{photo.url}}></div></div></div><div ng-if=\"vm.slideDatas && vm.slideDatas.length\" class=case-study-details__content__section-5><div class=case-study-details__content__section-5__title>Read more case studies</div><div class=case-study-details__content__section-5__content><div class=case-study-details__content__section-5__carousel__wrapper><slick speed=1000 class=case-study-details__content__section-5__carousel infinite=false slides-to-scroll=3 slides-to-show=3 dots=true arrows=false on-init=vm.slickSetting.onInit(slick) on-after-change=\"vm.slickSetting.onAfterChange(event, slick, currentSlide, nextSlide)\"><div ng-repeat=\"data in vm.slideDatas\"><div class=case-study-details__content__section-5__item ng-style=\"{\'background-image\': \'url(\\\'\' + data.cover + \'\\\')\'}\"><div class=case-study-details__content__section-5__item__info ng-click=vm.onGotoCaseStudy(data)><div class=case-study-details__content__section-5__item__info__auth>{{data.owner}}</div><div class=case-study-details__content__section-5__item__info__type>{{data.type}}{{data.subType ? \' - \' + data.subType: \'\'}}</div></div></div></div></slick><slick speed=1000 class=case-study-details__content__section-5__carousel--mobile infinite=false slides-to-scroll=1 slides-to-show=1 dots=true arrows=false center-mode=true on-init=vm.slickMobileSetting.onInit(slick) on-after-change=\"vm.slickMobileSetting.onAfterChange(event, slick, currentSlide, nextSlide)\"><div ng-repeat=\"data in vm.slideDatas\"><div class=case-study-details__content__section-5__item ng-style=\"{\'background-image\': \'url(\\\'\' + data.cover + \'\\\')\'}\"><div class=case-study-details__content__section-5__item__info ng-click=vm.onGotoCaseStudy(data)><div class=case-study-details__content__section-5__item__info__auth>{{data.owner}}</div><div class=case-study-details__content__section-5__item__info__type>{{data.type}}{{data.subType ? \' - \' + data.subType: \'\'}}</div></div></div></div></slick><div class=case-study-details__content__section-5__carousel__navigate><div class=\"case-study-details__content__section-5__carousel__navigate__left icon-slide-prev-icon\" ng-class=\"{\'disabled\': vm.isFirstSlickSlide, \'disabled-mobile\': vm.isFirstSlickMobileSlide}\" ng-click=vm.onPreviousSlide()></div><div class=\"case-study-details__content__section-5__carousel__navigate__right icon-slide-next-icon\" ng-class=\"{\'disabled\': vm.isLastSlickSlide, \'disabled-mobile\': vm.isLastSlickMobileSlide}\" ng-click=vm.onNextSlide()></div></div></div></div></div></div></div>");
$templateCache.put("app/about-business-page/components/case-studies/case-study-details/case-study-cooler-lumpur.html","<div class=\"case-study-details case-study-cooler-lumpur\"><div class=case-study-details__banner photo-details-on-click=269695><div class=case-study-details__banner__back-btn ng-click=vm.onBackAboutCaseStudy()><span class=icon-icons_chevron-left></span> <span>Read more stories</span></div><div class=case-study-details__banner__box><div class=case-study-details__banner__box__type>{{vm.caseStudy.type}}</div><div class=case-study-details__banner__box__title>{{vm.caseStudy.title}}</div><div class=case-study-details__banner__box__owner>{{vm.caseStudy.client}}</div></div></div><div class=case-study-details__content><div class=case-study-details__content__back-btn ng-click=vm.onBackAboutCaseStudy() dynamic-show-hide-scroll scroll-down-class=hide-on-mobile><span class=icon-icons_chevron-left></span> <span>Read more stories</span></div><div class=case-study-details__content__section-1><div class=case-study-details__content__section-1__col-left><div class=case-study-details__content__section-1__col-left__content><div class=case-study-details__content__section-1__logo><img ng-src={{vm.caseStudy.logo}}></div><div class=case-study-details__content__section-1__list><div class=case-study-details__content__section-1__item><span class=case-study-details__content__section-1__item__title>CLIENT:</span> <span>{{vm.caseStudy.company || vm.caseStudy.client}}</span></div><div class=case-study-details__content__section-1__item><span class=case-study-details__content__section-1__item__title>TYPE:</span> <span>{{vm.caseStudy.contentType}}</span></div><div ng-if=vm.caseStudy.category class=case-study-details__content__section-1__item><span class=case-study-details__content__section-1__item__title>CATEGORY:</span> <span>{{vm.caseStudy.category}}</span></div><div ng-if=vm.caseStudy.daysOfShoots class=case-study-details__content__section-1__item><span class=case-study-details__content__section-1__item__title>DAYS OF SHOOT:</span> <span>{{vm.caseStudy.daysOfShoots}}</span></div><div ng-if=vm.caseStudy.imageLicensed class=case-study-details__content__section-1__item><span class=case-study-details__content__section-1__item__title>IMAGE LICENSED:</span> <span>{{vm.caseStudy.imageLicensed}}</span></div><div ng-if=vm.caseStudy.location class=case-study-details__content__section-1__item><span class=case-study-details__content__section-1__item__title>LOCATION:</span> <span>{{vm.caseStudy.location}}</span></div><div ng-if=vm.caseStudy.imageSubmissions class=case-study-details__content__section-1__item><span class=case-study-details__content__section-1__item__title>IMAGE SUBMISSIONS:</span> <span>{{vm.caseStudy.imageSubmissions}}</span></div><div ng-if=vm.caseStudy.reach class=case-study-details__content__section-1__item><span class=case-study-details__content__section-1__item__title>REACH:</span> <span>{{vm.caseStudy.reach}}</span></div></div><div class=case-study-details__content__section-1__button ng-click=vm.bookAShoot()>Book a Shoot</div></div></div><div class=case-study-details__content__section-1__col-right><div class=case-study-details__content__section-1__back-btn ng-click=vm.onBackAboutCaseStudy()><span class=icon-icons_chevron-left></span> <span>Read more stories</span></div><div class=case-study-details__content__section-1__content>To celebrate the community and raise its profile, the Cooler Lumpur festival launched a Community Challenge titled Super Canggih, which translates to “super cool”. This challenge asked Malaysian photographers, pros and amateurs alike, to show us something cool and extraordinary through their lens.</div><div class=case-study-details__content__section-1__background photo-details-on-click=194873><div class=case-study-details__content__section-1__box><div class=case-study-details__content__section-1__box__title>Services included:</div><div class=case-study-details__content__section-1__box__list><div class=case-study-details__content__section-1__box__item>Refinement of brief</div><div class=case-study-details__content__section-1__box__item>Curation of visual inspiration</div><div class=case-study-details__content__section-1__box__item>Photo walks with PIXERF Ambassadors</div><div class=case-study-details__content__section-1__box__item>Social media promotion</div><div class=case-study-details__content__section-1__box__item>Curation of submissions</div><div class=case-study-details__content__section-1__box__item>Award announcement posts</div></div></div></div></div></div><div class=case-study-details__content__section-2 photo-details-on-click=270256><div class=case-study-details__content__section-2__box><div class=case-study-details__content__section-2__box__title>The challenge was geo-fenced to just photographers within Malaysia and gathered submissions that covered multiple subjects and genres from street to abstract photography.</div><div class=case-study-details__content__section-2__badge ng-click=\"vm.onGoMissionDetails({id: 81, name: \'SuperCanggih\'})\"><div class=case-study-details__badge><div class=case-study-details__badge__icon></div><div class=case-study-details__badge__name>Super Canggih</div></div></div></div></div><div class=case-study-details__content__section-3><div class=case-study-details__content__section-3__col-left></div><div class=case-study-details__content__section-3__col-right><div class=case-study-details__content__section-3__photo photo-details-on-click=262293></div><div class=case-study-details__content__section-3__content><p>We also organised a photowalk with PIXERF Ambassadors in Kuala Lumpur for the challenge\'s participants. The challenge was geo-fenced to just photographers within Malaysia and gathered submissions that covered multiple subjects and genres from street to abstract photography.</p></div></div></div><div class=case-study-details__content__section-4><div flex-grid ng-model=vm.caseStudy.photos rowheight=300 margins=20 lastrow=justify borderstyle=-20 class=case-study-details__content__section-4__photo-grid><div ng-repeat=\"photo in vm.caseStudy.photos\"><img ng-src={{photo.url}} photo-details-on-click={{photo.id}}></div></div></div><div ng-if=\"vm.slideDatas && vm.slideDatas.length\" class=case-study-details__content__section-5><div class=case-study-details__content__section-5__title>Read more case studies</div><div class=case-study-details__content__section-5__content><div class=case-study-details__content__section-5__carousel__wrapper><slick speed=1000 class=case-study-details__content__section-5__carousel infinite=false slides-to-scroll=3 slides-to-show=3 dots=true arrows=false on-init=vm.slickSetting.onInit(slick) on-after-change=\"vm.slickSetting.onAfterChange(event, slick, currentSlide, nextSlide)\"><div ng-repeat=\"data in vm.slideDatas\"><div class=case-study-details__content__section-5__item ng-style=\"{\'background-image\': \'url(\\\'\' + data.cover + \'\\\')\'}\"><div class=case-study-details__content__section-5__item__info ng-click=vm.onGotoCaseStudy(data)><div class=case-study-details__content__section-5__item__info__auth>{{data.owner}}</div><div class=case-study-details__content__section-5__item__info__type>{{data.type}}{{data.subType ? \' - \' + data.subType: \'\'}}</div></div></div></div></slick><slick speed=1000 class=case-study-details__content__section-5__carousel--mobile infinite=false slides-to-scroll=1 slides-to-show=1 dots=true arrows=false center-mode=true on-init=vm.slickMobileSetting.onInit(slick) on-after-change=\"vm.slickMobileSetting.onAfterChange(event, slick, currentSlide, nextSlide)\"><div ng-repeat=\"data in vm.slideDatas\"><div class=case-study-details__content__section-5__item ng-style=\"{\'background-image\': \'url(\\\'\' + data.cover + \'\\\')\'}\"><div class=case-study-details__content__section-5__item__info ng-click=vm.onGotoCaseStudy(data)><div class=case-study-details__content__section-5__item__info__auth>{{data.owner}}</div><div class=case-study-details__content__section-5__item__info__type>{{data.type}}{{data.subType ? \' - \' + data.subType: \'\'}}</div></div></div></div></slick><div class=case-study-details__content__section-5__carousel__navigate><div class=\"case-study-details__content__section-5__carousel__navigate__left icon-slide-prev-icon\" ng-class=\"{\'disabled\': vm.isFirstSlickSlide, \'disabled-mobile\': vm.isFirstSlickMobileSlide}\" ng-click=vm.onPreviousSlide()></div><div class=\"case-study-details__content__section-5__carousel__navigate__right icon-slide-next-icon\" ng-class=\"{\'disabled\': vm.isLastSlickSlide, \'disabled-mobile\': vm.isLastSlickMobileSlide}\" ng-click=vm.onNextSlide()></div></div></div></div></div></div></div>");
$templateCache.put("app/about-business-page/components/case-studies/case-study-details/case-study-details.html","<div class=case-study-details><div class=case-study-details__banner><div class=case-study-details__banner__box><div class=case-study-details__banner__box__type>{{vm.caseStudy.type}}</div><div class=case-study-details__banner__box__title>{{vm.caseStudy.title}}</div><div class=case-study-details__banner__box__owner>{{vm.caseStudy.client}}</div></div></div><div class=case-study-details__content><div class=case-study-details__content__section-1><div class=case-study-details__content__section-1__col-left><div class=case-study-details__content__section-1__col-left__content><div class=case-study-details__content__section-1__logo><img ng-src={{vm.caseStudy.logo}}></div><div class=case-study-details__content__section-1__list><div class=case-study-details__content__section-1__item><span class=case-study-details__content__section-1__item__title>CLIENT:</span> <span>{{vm.caseStudy.client}}</span></div><div class=case-study-details__content__section-1__item><span class=case-study-details__content__section-1__item__title>TYPE:</span> <span>{{vm.caseStudy.contentType}}</span></div><div class=case-study-details__content__section-1__item><span class=case-study-details__content__section-1__item__title>CATEGORY:</span> <span>{{vm.caseStudy.category}}</span></div><div class=case-study-details__content__section-1__item><span class=case-study-details__content__section-1__item__title>DAYS OF SHOOT:</span> <span>{{vm.caseStudy.DaysOfShoots}}</span></div><div class=case-study-details__content__section-1__item><span class=case-study-details__content__section-1__item__title>IMAGE LICENSED:</span> <span>{{vm.caseStudy.ImageLicensed}}</span></div><div class=case-study-details__content__section-1__item><span class=case-study-details__content__section-1__item__title>LOCATION:</span> <span>{{vm.caseStudy.Location}}</span></div></div><div class=case-study-details__content__section-1__button></div></div></div><div class=case-study-details__content__section-1__col-right></div></div><div class=case-study-details__content__section-2><div class=case-study-details__content__section-2__box><div class=case-study-details__content__section-2__box__title></div><div class=case-study-details__content__section-2__box__author><div class=case-study-details__content__section-2__box__author__name></div><div class=case-study-details__content__section-2__box__author__position></div></div></div></div><div class=case-study-details__content__section-3></div><div class=case-study-details__content__section-4></div></div></div>");
$templateCache.put("app/about-business-page/components/case-studies/case-study-details/case-study-enterprise-singapore.html","<div class=\"case-study-details case-study-enterprise-singapore\"><div class=case-study-details__banner photo-details-on-click=28741><div class=case-study-details__banner__overlay></div><div class=case-study-details__banner__back-btn ng-click=vm.onBackAboutCaseStudy()><span class=icon-icons_chevron-left></span> <span>Read more stories</span></div><div class=case-study-details__banner__box><div class=case-study-details__banner__box__type>{{vm.caseStudy.type}}</div><div class=case-study-details__banner__box__title>{{vm.caseStudy.title}}</div><div class=case-study-details__banner__box__owner>{{vm.caseStudy.client}}</div></div></div><div class=case-study-details__content><div class=case-study-details__content__back-btn ng-click=vm.onBackAboutCaseStudy() dynamic-show-hide-scroll scroll-down-class=hide-on-mobile><span class=icon-icons_chevron-left></span> <span>Read more stories</span></div><div class=case-study-details__content__section-1><div class=case-study-details__content__section-1__col-left><div class=case-study-details__content__section-1__col-left__content><div class=case-study-details__content__section-1__logo><img ng-src={{vm.caseStudy.logo}}></div><div class=case-study-details__content__section-1__list><div class=case-study-details__content__section-1__item><span class=case-study-details__content__section-1__item__title>CLIENT:</span> <span>{{vm.caseStudy.company || vm.caseStudy.client}}</span></div><div class=case-study-details__content__section-1__item><span class=case-study-details__content__section-1__item__title>TYPE:</span> <span>{{vm.caseStudy.contentType}}</span></div><div ng-if=vm.caseStudy.category class=case-study-details__content__section-1__item><span class=case-study-details__content__section-1__item__title>CATEGORY:</span> <span>{{vm.caseStudy.category}}</span></div><div ng-if=vm.caseStudy.daysOfShoots class=case-study-details__content__section-1__item><span class=case-study-details__content__section-1__item__title>DAYS OF SHOOT:</span> <span>{{vm.caseStudy.daysOfShoots}}</span></div><div ng-if=vm.caseStudy.imageLicensed class=case-study-details__content__section-1__item><span class=case-study-details__content__section-1__item__title>IMAGE LICENSED:</span> <span>{{vm.caseStudy.imageLicensed}}</span></div><div ng-if=vm.caseStudy.location class=case-study-details__content__section-1__item><span class=case-study-details__content__section-1__item__title>LOCATION:</span> <span>{{vm.caseStudy.location}}</span></div><div ng-if=vm.caseStudy.imageSubmissions class=case-study-details__content__section-1__item><span class=case-study-details__content__section-1__item__title>IMAGE SUBMISSIONS:</span> <span>{{vm.caseStudy.imageSubmissions}}</span></div><div ng-if=vm.caseStudy.reach class=case-study-details__content__section-1__item><span class=case-study-details__content__section-1__item__title>REACH:</span> <span>{{vm.caseStudy.reach}}</span></div></div><div class=case-study-details__content__section-1__button ng-click=vm.bookAShoot()>Book a Shoot</div></div></div><div class=case-study-details__content__section-1__col-right><div class=case-study-details__content__section-1__back-btn ng-click=vm.onBackAboutCaseStudy()><span class=icon-icons_chevron-left></span> <span>Read more stories</span></div><div class=case-study-details__content__section-1__content><p>A photoshoot that was coordinated with a tie up with Singapore Press Holdings. PIXERF was engaged to capture portraits of the people from the chosen local businesses to be featured in the article that SPH was running. The outcome of the shoot was to capture the real moments of the business as the interview with the press was on-going. There was no need for Makeup, set up, props etc. This shoot was a combination of portraits and events.</p></div><div class=case-study-details__content__section-1__background photo-details-on-click=147404><div class=case-study-details__content__section-1__box><div class=case-study-details__content__section-1__box__title>Services included:</div><div class=case-study-details__content__section-1__box__list><div class=case-study-details__content__section-1__box__item>Photography Services</div><div class=case-study-details__content__section-1__box__item>Post photography Services (Editing)</div></div></div></div></div></div><div class=case-study-details__content__section-2 photo-details-on-click=122364><div class=case-study-details__content__section-2__overlay></div><div class=case-study-details__content__section-2__box><div class=case-study-details__content__section-2__box__title>The challenge for this project is about selecting the appropriate and skilled photographer to capture portraits shot as well as in-the-moment, moments.</div></div></div><div class=case-study-details__content__section-3><div class=case-study-details__content__section-3__col-left></div><div class=case-study-details__content__section-3__col-right><div class=case-study-details__content__section-3__photo photo-details-on-click=159218></div><div class=case-study-details__content__section-3__content><p>The challenge for this project is about selecting the appropriate and skilled photographer to capture portraits shot as well as in-the-moment, moments. The project took 18 days in total to complete as we had 18 local businesses to cover and it required coordination from PIXERF with client, photographer and press to pull through. In total, the client licensed 160 photos.</p></div></div></div><div class=case-study-details__content__section-4><div flex-grid ng-model=vm.caseStudy.photos rowheight=300 margins=20 lastrow=justify borderstyle=-20 class=case-study-details__content__section-4__photo-grid><div ng-repeat=\"photo in vm.caseStudy.photos\" class=case-study-details__content__section-4__item><img ng-src={{photo.url}} photo-details-on-click={{photo.id}}><div ng-if=photo.badge class=case-study-details__badge class=case-study-details__content__section-4__item ng-click=\"vm.onGoMissionDetails({id: photo.missionId, name: (photo.missionName | toSnakeCase)})\"><div class=case-study-details__badge__icon></div><div class=case-study-details__badge__name>{{photo.badge}}</div></div></div></div></div><div ng-if=\"vm.slideDatas && vm.slideDatas.length\" class=case-study-details__content__section-5><div class=case-study-details__content__section-5__title>Read more case studies</div><div class=case-study-details__content__section-5__content><div class=case-study-details__content__section-5__carousel__wrapper><slick speed=1000 class=case-study-details__content__section-5__carousel infinite=false slides-to-scroll=3 slides-to-show=3 dots=true arrows=false on-init=vm.slickSetting.onInit(slick) on-after-change=\"vm.slickSetting.onAfterChange(event, slick, currentSlide, nextSlide)\"><div ng-repeat=\"data in vm.slideDatas\"><div class=case-study-details__content__section-5__item ng-style=\"{\'background-image\': \'url(\\\'\' + data.cover + \'\\\')\'}\"><div class=case-study-details__content__section-5__item__info ng-click=vm.onGotoCaseStudy(data)><div class=case-study-details__content__section-5__item__info__auth>{{data.owner}}</div><div class=case-study-details__content__section-5__item__info__type>{{data.type}}{{data.subType ? \' - \' + data.subType: \'\'}}</div></div></div></div></slick><slick speed=1000 class=case-study-details__content__section-5__carousel--mobile infinite=false slides-to-scroll=1 slides-to-show=1 dots=true arrows=false center-mode=true on-init=vm.slickMobileSetting.onInit(slick) on-after-change=\"vm.slickMobileSetting.onAfterChange(event, slick, currentSlide, nextSlide)\"><div ng-repeat=\"data in vm.slideDatas\"><div class=case-study-details__content__section-5__item ng-style=\"{\'background-image\': \'url(\\\'\' + data.cover + \'\\\')\'}\"><div class=case-study-details__content__section-5__item__info ng-click=vm.onGotoCaseStudy(data)><div class=case-study-details__content__section-5__item__info__auth>{{data.owner}}</div><div class=case-study-details__content__section-5__item__info__type>{{data.type}}{{data.subType ? \' - \' + data.subType: \'\'}}</div></div></div></div></slick><div class=case-study-details__content__section-5__carousel__navigate><div class=\"case-study-details__content__section-5__carousel__navigate__left icon-slide-prev-icon\" ng-class=\"{\'disabled\': vm.isFirstSlickSlide, \'disabled-mobile\': vm.isFirstSlickMobileSlide}\" ng-click=vm.onPreviousSlide()></div><div class=\"case-study-details__content__section-5__carousel__navigate__right icon-slide-next-icon\" ng-class=\"{\'disabled\': vm.isLastSlickSlide, \'disabled-mobile\': vm.isLastSlickMobileSlide}\" ng-click=vm.onNextSlide()></div></div></div></div></div></div></div>");
$templateCache.put("app/about-business-page/components/case-studies/case-study-details/case-study-gojek.html","<div class=\"case-study-details case-study-gojek\"><div class=case-study-details__banner photo-details-on-click=232939><div class=case-study-details__banner__back-btn ng-click=vm.onBackAboutCaseStudy()><span class=icon-icons_chevron-left></span> <span>Read more stories</span></div><div class=case-study-details__banner__box><div class=case-study-details__banner__box__type>{{vm.caseStudy.type}}</div><div class=case-study-details__banner__box__title>{{vm.caseStudy.title}}</div><div class=case-study-details__banner__box__owner>{{vm.caseStudy.client}}</div></div></div><div class=case-study-details__content><div class=case-study-details__content__back-btn ng-click=vm.onBackAboutCaseStudy() dynamic-show-hide-scroll scroll-down-class=hide-on-mobile><span class=icon-icons_chevron-left></span> <span>Read more stories</span></div><div class=case-study-details__content__section-1><div class=case-study-details__content__section-1__col-left><div class=case-study-details__content__section-1__col-left__content><div class=case-study-details__content__section-1__logo><img ng-src={{vm.caseStudy.logo}}></div><div class=case-study-details__content__section-1__list><div class=case-study-details__content__section-1__item><span class=case-study-details__content__section-1__item__title>CLIENT:</span> <span>{{vm.caseStudy.company || vm.caseStudy.client}}</span></div><div class=case-study-details__content__section-1__item><span class=case-study-details__content__section-1__item__title>TYPE:</span> <span>{{vm.caseStudy.contentType}}</span></div><div ng-if=vm.caseStudy.category class=case-study-details__content__section-1__item><span class=case-study-details__content__section-1__item__title>CATEGORY:</span> <span>{{vm.caseStudy.category}}</span></div><div ng-if=vm.caseStudy.daysOfShoots class=case-study-details__content__section-1__item><span class=case-study-details__content__section-1__item__title>DAYS OF SHOOT:</span> <span>{{vm.caseStudy.daysOfShoots}}</span></div><div ng-if=vm.caseStudy.imageLicensed class=case-study-details__content__section-1__item><span class=case-study-details__content__section-1__item__title>IMAGE LICENSED:</span> <span>{{vm.caseStudy.imageLicensed}}</span></div><div ng-if=vm.caseStudy.location class=case-study-details__content__section-1__item><span class=case-study-details__content__section-1__item__title>LOCATION:</span> <span>{{vm.caseStudy.location}}</span></div><div ng-if=vm.caseStudy.imageSubmissions class=case-study-details__content__section-1__item><span class=case-study-details__content__section-1__item__title>IMAGE SUBMISSIONS:</span> <span>{{vm.caseStudy.imageSubmissions}}</span></div><div ng-if=vm.caseStudy.reach class=case-study-details__content__section-1__item><span class=case-study-details__content__section-1__item__title>REACH:</span> <span>{{vm.caseStudy.reach}}</span></div></div><div class=case-study-details__content__section-1__button ng-click=vm.bookAShoot()>Book a Shoot</div></div></div><div class=case-study-details__content__section-1__col-right><div class=case-study-details__content__section-1__back-btn ng-click=vm.onBackAboutCaseStudy()><span class=icon-icons_chevron-left></span> <span>Read more stories</span></div><div class=case-study-details__content__section-1__content><p>As part of Gojek\'s rebranding campaign, Indonesian’s leading multi-service tech platform ran a Community Challenge to crowdsourced images that support their new brand tagline, <i>\"Pasti Ada Jalan\"</i>. Hundreds of entries poured in from all parts of Indonesia demonstrating life hacks in the most interesting and surprising ways.</p><p>The quality of the submissions was so amazing that Gojek decided to give more prizes, increasing from 10 to 30 winners.</p></div><div class=case-study-details__content__section-1__background photo-details-on-click=231448><div class=case-study-details__content__section-1__box><div class=case-study-details__content__section-1__box__title>Services included:</div><div class=case-study-details__content__section-1__box__list><div class=case-study-details__content__section-1__box__item>Challenge brief</div><div class=case-study-details__content__section-1__box__item>Curation of visual inspiration</div><div class=case-study-details__content__section-1__box__item>Jury sourcing</div><div class=case-study-details__content__section-1__box__item>Selection of winners</div><div class=case-study-details__content__section-1__box__item>Award announcement posts</div><div class=case-study-details__content__section-1__box__item>Social Media Posting</div><div class=case-study-details__content__section-1__box__item>Publicity through newsletter</div><div class=case-study-details__content__section-1__box__item>Event Management</div></div></div></div></div></div><div class=case-study-details__content__section-2 photo-details-on-click=232955><div class=case-study-details__content__section-2__box><div class=case-study-details__content__section-2__box__title>\"PIXERF has been super cool to work with. Very reactive and experimental. What we wanted was a wildly niche solution…but PIXERF came in with an interesting solution to gamify it.\"</div><div class=case-study-details__content__section-2__box__author><div class=case-study-details__content__section-2__box__author__name>VJ Anand</div><div class=case-study-details__content__section-2__box__author__position>VP Creative<br>Gojek Indonesia</div></div><div class=case-study-details__content__section-2__badge ng-click=\"vm.onGoMissionDetails({id: 72, name: \'Museum-of-Hacks\'})\"><div class=case-study-details__badge><div class=case-study-details__badge__icon></div><div class=case-study-details__badge__name>Museum of Hacks</div></div></div></div></div><div class=case-study-details__content__section-3><div class=case-study-details__content__section-3__col-left></div><div class=case-study-details__content__section-3__col-right><div class=case-study-details__content__section-3__photo photo-details-on-click=233491></div><div class=case-study-details__content__section-3__content><p>We worked together and went beyond the contest - we organised a \"Museum of Hacks\" that included a photo exhibition, live judging and a prize giving ceremony. Our PIXERF creative community and other Indonesian photographers gathered at a hip cafe in central Jakarta for this event.</p></div></div></div><div class=case-study-details__content__section-4><div flex-grid ng-model=vm.caseStudy.photos margins=20 lastrow=justify borderstyle=-20 class=case-study-details__content__section-4__photo-grid><div ng-repeat=\"photo in vm.caseStudy.photos\"><img ng-src={{photo.url}} photo-details-on-click={{photo.id}}></div></div><div flex-grid ng-model=vm.caseStudy.photoSecondGrid margins=20 lastrow=justify borderstyle=-20 class=case-study-details__content__section-4__photo-grid><div ng-repeat=\"photo in vm.caseStudy.photoSecondGrid\"><img ng-src={{photo.url}} photo-details-on-click={{photo.id}}></div></div></div><div ng-if=\"vm.slideDatas && vm.slideDatas.length\" class=case-study-details__content__section-5><div class=case-study-details__content__section-5__title>Read more case studies</div><div class=case-study-details__content__section-5__content><div class=case-study-details__content__section-5__carousel__wrapper><slick speed=1000 class=case-study-details__content__section-5__carousel infinite=false slides-to-scroll=3 slides-to-show=3 dots=true arrows=false on-init=vm.slickSetting.onInit(slick) on-after-change=\"vm.slickSetting.onAfterChange(event, slick, currentSlide, nextSlide)\"><div ng-repeat=\"data in vm.slideDatas\"><div class=case-study-details__content__section-5__item ng-style=\"{\'background-image\': \'url(\\\'\' + data.cover + \'\\\')\'}\"><div class=case-study-details__content__section-5__item__info ng-click=vm.onGotoCaseStudy(data)><div class=case-study-details__content__section-5__item__info__auth>{{data.owner}}</div><div class=case-study-details__content__section-5__item__info__type>{{data.type}}{{data.subType ? \' - \' + data.subType: \'\'}}</div></div></div></div></slick><slick speed=1000 class=case-study-details__content__section-5__carousel--mobile infinite=false slides-to-scroll=1 slides-to-show=1 dots=true arrows=false center-mode=true on-init=vm.slickMobileSetting.onInit(slick) on-after-change=\"vm.slickMobileSetting.onAfterChange(event, slick, currentSlide, nextSlide)\"><div ng-repeat=\"data in vm.slideDatas\"><div class=case-study-details__content__section-5__item ng-style=\"{\'background-image\': \'url(\\\'\' + data.cover + \'\\\')\'}\"><div class=case-study-details__content__section-5__item__info ng-click=vm.onGotoCaseStudy(data)><div class=case-study-details__content__section-5__item__info__auth>{{data.owner}}</div><div class=case-study-details__content__section-5__item__info__type>{{data.type}}{{data.subType ? \' - \' + data.subType: \'\'}}</div></div></div></div></slick><div class=case-study-details__content__section-5__carousel__navigate><div class=\"case-study-details__content__section-5__carousel__navigate__left icon-slide-prev-icon\" ng-class=\"{\'disabled\': vm.isFirstSlickSlide, \'disabled-mobile\': vm.isFirstSlickMobileSlide}\" ng-click=vm.onPreviousSlide()></div><div class=\"case-study-details__content__section-5__carousel__navigate__right icon-slide-next-icon\" ng-class=\"{\'disabled\': vm.isLastSlickSlide, \'disabled-mobile\': vm.isLastSlickMobileSlide}\" ng-click=vm.onNextSlide()></div></div></div></div></div></div></div>");
$templateCache.put("app/about-business-page/components/case-studies/case-study-details/case-study-gurobu.html","<div class=\"case-study-details case-study-gurobu\"><div class=case-study-details__banner><div class=case-study-details__banner__back-btn ng-click=vm.onBackAboutCaseStudy()><span class=icon-icons_chevron-left></span> <span>Read more stories</span></div><div class=case-study-details__banner__overlay></div><div class=case-study-details__banner__box><div class=case-study-details__banner__box__type>{{vm.caseStudy.type}}</div><div class=case-study-details__banner__box__title>{{vm.caseStudy.title}}</div><div class=case-study-details__banner__box__owner>{{vm.caseStudy.client}}</div></div></div><div class=case-study-details__content><div class=case-study-details__content__back-btn ng-click=vm.onBackAboutCaseStudy() dynamic-show-hide-scroll scroll-down-class=hide-on-mobile><span class=icon-icons_chevron-left></span> <span>Read more stories</span></div><div class=case-study-details__content__section-1><div class=case-study-details__content__section-1__col-left><div class=case-study-details__content__section-1__col-left__content><div class=case-study-details__content__section-1__logo><img ng-src={{vm.caseStudy.logo}}></div><div class=case-study-details__content__section-1__list><div class=case-study-details__content__section-1__item><span class=case-study-details__content__section-1__item__title>CLIENT:</span> <span>{{vm.caseStudy.company || vm.caseStudy.client}}</span></div><div class=case-study-details__content__section-1__item><span class=case-study-details__content__section-1__item__title>TYPE:</span> <span>{{vm.caseStudy.contentType}}</span></div><div ng-if=vm.caseStudy.category class=case-study-details__content__section-1__item><span class=case-study-details__content__section-1__item__title>CATEGORY:</span> <span>{{vm.caseStudy.category}}</span></div><div ng-if=vm.caseStudy.daysOfShoots class=case-study-details__content__section-1__item><span class=case-study-details__content__section-1__item__title>DAYS OF SHOOT:</span> <span>{{vm.caseStudy.daysOfShoots}}</span></div><div ng-if=vm.caseStudy.imageLicensed class=case-study-details__content__section-1__item><span class=case-study-details__content__section-1__item__title>IMAGE LICENSED:</span> <span>{{vm.caseStudy.imageLicensed}}</span></div><div ng-if=vm.caseStudy.location class=case-study-details__content__section-1__item><span class=case-study-details__content__section-1__item__title>LOCATION:</span> <span>{{vm.caseStudy.location}}</span></div><div ng-if=vm.caseStudy.imageSubmissions class=case-study-details__content__section-1__item><span class=case-study-details__content__section-1__item__title>IMAGE SUBMISSIONS:</span> <span>{{vm.caseStudy.imageSubmissions}}</span></div><div ng-if=vm.caseStudy.reach class=case-study-details__content__section-1__item><span class=case-study-details__content__section-1__item__title>REACH:</span> <span>{{vm.caseStudy.reach}}</span></div></div><div class=case-study-details__content__section-1__button ng-click=vm.bookAShoot()>Book a Shoot</div></div></div><div class=case-study-details__content__section-1__col-right><div class=case-study-details__content__section-1__back-btn ng-click=vm.onBackAboutCaseStudy()><span class=icon-icons_chevron-left></span> <span>Read more stories</span></div><div class=case-study-details__content__section-1__content>A fresh image library was needed for the relaunch of Gurobu, a sporting goods retailer catering to baseball and softball fans in Asia. The images were intended for the brand’s new website, interior spaces, e-commerce store, and other marketing purposes.</div><div class=case-study-details__content__section-1__background><div class=case-study-details__content__section-1__box><div class=case-study-details__content__section-1__box__title>Services included:</div><div class=case-study-details__content__section-1__box__list><div class=case-study-details__content__section-1__box__item>Sourcing and matching photographers to assignment</div><div class=case-study-details__content__section-1__box__item>Sourcing of locations and models</div><div class=case-study-details__content__section-1__box__item>Art direction and styling services</div><div class=case-study-details__content__section-1__box__item>Photography services</div><div class=case-study-details__content__section-1__box__item>Post-production editing</div><div class=case-study-details__content__section-1__box__item>Logistical support</div></div></div></div></div></div><div class=case-study-details__content__section-2><div class=case-study-details__content__section-2__box><div class=case-study-details__content__section-2__box__title>We helped them to set the right visual direction: dynamic, action-centric, exciting for all ages, and featuring real Asian faces.</div></div></div><div class=case-study-details__content__section-3><div class=case-study-details__content__section-3__col-left></div><div class=case-study-details__content__section-3__col-right><div class=case-study-details__content__section-3__photo></div><div class=case-study-details__content__section-3__content><p>We helped them to set the right visual direction: dynamic, action-centric, exciting for all ages, and featuring real Asian faces. The photoshoot involved multiple models, props and a mix of indoor and outdoor locations, and had to be executed within 4 days. We enlisted an accomplished fashion and commercial photographer who excels at brand photoshoots and lighting scenes to achieve a dramatic effect.</p></div></div></div><div class=case-study-details__content__section-4><div flex-grid ng-model=vm.caseStudy.photos rowheight=300 margins=20 lastrow=justify borderstyle=-20 class=case-study-details__content__section-4__photo-grid><div ng-repeat=\"photo in vm.caseStudy.photos\"><img ng-src={{photo.url}}></div></div></div><div ng-if=\"vm.slideDatas && vm.slideDatas.length\" class=case-study-details__content__section-5><div class=case-study-details__content__section-5__title>Read more case studies</div><div class=case-study-details__content__section-5__content><div class=case-study-details__content__section-5__carousel__wrapper><slick speed=1000 class=case-study-details__content__section-5__carousel infinite=false slides-to-scroll=3 slides-to-show=3 dots=true arrows=false on-init=vm.slickSetting.onInit(slick) on-after-change=\"vm.slickSetting.onAfterChange(event, slick, currentSlide, nextSlide)\"><div ng-repeat=\"data in vm.slideDatas\"><div class=case-study-details__content__section-5__item ng-style=\"{\'background-image\': \'url(\\\'\' + data.cover + \'\\\')\'}\"><div class=case-study-details__content__section-5__item__info ng-click=vm.onGotoCaseStudy(data)><div class=case-study-details__content__section-5__item__info__auth>{{data.owner}}</div><div class=case-study-details__content__section-5__item__info__type>{{data.type}}{{data.subType ? \' - \' + data.subType: \'\'}}</div></div></div></div></slick><slick speed=1000 class=case-study-details__content__section-5__carousel--mobile infinite=false slides-to-scroll=1 slides-to-show=1 dots=true arrows=false center-mode=true on-init=vm.slickMobileSetting.onInit(slick) on-after-change=\"vm.slickMobileSetting.onAfterChange(event, slick, currentSlide, nextSlide)\"><div ng-repeat=\"data in vm.slideDatas\"><div class=case-study-details__content__section-5__item ng-style=\"{\'background-image\': \'url(\\\'\' + data.cover + \'\\\')\'}\"><div class=case-study-details__content__section-5__item__info ng-click=vm.onGotoCaseStudy(data)><div class=case-study-details__content__section-5__item__info__auth>{{data.owner}}</div><div class=case-study-details__content__section-5__item__info__type>{{data.type}}{{data.subType ? \' - \' + data.subType: \'\'}}</div></div></div></div></slick><div class=case-study-details__content__section-5__carousel__navigate><div class=\"case-study-details__content__section-5__carousel__navigate__left icon-slide-prev-icon\" ng-class=\"{\'disabled\': vm.isFirstSlickSlide, \'disabled-mobile\': vm.isFirstSlickMobileSlide}\" ng-click=vm.onPreviousSlide()></div><div class=\"case-study-details__content__section-5__carousel__navigate__right icon-slide-next-icon\" ng-class=\"{\'disabled\': vm.isLastSlickSlide, \'disabled-mobile\': vm.isLastSlickMobileSlide}\" ng-click=vm.onNextSlide()></div></div></div></div></div></div></div>");
$templateCache.put("app/about-business-page/components/case-studies/case-study-details/case-study-people-association.html","<div class=\"case-study-details case-study-people-association\"><div class=case-study-details__banner><div class=case-study-details__banner__back-btn ng-click=vm.onBackAboutCaseStudy()><span class=icon-icons_chevron-left></span> <span>Read more stories</span></div><div class=case-study-details__banner__box><div class=case-study-details__banner__box__type>{{vm.caseStudy.type}}</div><div class=case-study-details__banner__box__title>{{vm.caseStudy.title}}</div><div class=case-study-details__banner__box__owner>{{vm.caseStudy.client}}</div></div></div><div class=case-study-details__content><div class=case-study-details__content__back-btn ng-click=vm.onBackAboutCaseStudy() dynamic-show-hide-scroll scroll-down-class=hide-on-mobile><span class=icon-icons_chevron-left></span> <span>Read more stories</span></div><div class=case-study-details__content__section-1><div class=case-study-details__content__section-1__col-left><div class=case-study-details__content__section-1__col-left__content><div class=case-study-details__content__section-1__logo><img ng-src={{vm.caseStudy.logo}}></div><div class=case-study-details__content__section-1__list><div class=case-study-details__content__section-1__item><span class=case-study-details__content__section-1__item__title>CLIENT:</span> <span>{{vm.caseStudy.company || vm.caseStudy.client}}</span></div><div class=case-study-details__content__section-1__item><span class=case-study-details__content__section-1__item__title>TYPE:</span> <span>{{vm.caseStudy.contentType}}</span></div><div ng-if=vm.caseStudy.category class=case-study-details__content__section-1__item><span class=case-study-details__content__section-1__item__title>CATEGORY:</span> <span>{{vm.caseStudy.category}}</span></div><div ng-if=vm.caseStudy.daysOfShoots class=case-study-details__content__section-1__item><span class=case-study-details__content__section-1__item__title>DAYS OF SHOOT:</span> <span>{{vm.caseStudy.daysOfShoots}}</span></div><div ng-if=vm.caseStudy.imageLicensed class=case-study-details__content__section-1__item><span class=case-study-details__content__section-1__item__title>IMAGE LICENSED:</span> <span>{{vm.caseStudy.imageLicensed}}</span></div><div ng-if=vm.caseStudy.location class=case-study-details__content__section-1__item><span class=case-study-details__content__section-1__item__title>LOCATION:</span> <span>{{vm.caseStudy.location}}</span></div><div ng-if=vm.caseStudy.imageSubmissions class=case-study-details__content__section-1__item><span class=case-study-details__content__section-1__item__title>IMAGE SUBMISSIONS:</span> <span>{{vm.caseStudy.imageSubmissions}}</span></div><div ng-if=vm.caseStudy.reach class=case-study-details__content__section-1__item><span class=case-study-details__content__section-1__item__title>REACH:</span> <span>{{vm.caseStudy.reach}}</span></div></div><div class=case-study-details__content__section-1__button ng-click=vm.bookAShoot()>Book a Shoot</div></div></div><div class=case-study-details__content__section-1__col-right><div class=case-study-details__content__section-1__back-btn ng-click=vm.onBackAboutCaseStudy()><span class=icon-icons_chevron-left></span> <span>Read more stories</span></div><div class=case-study-details__content__section-1__content>When a Singapore-based creative agency needed to convert People’s Association’s in-person courses into a full library of virtual content in a matter of days, we matched them with the right videographers. Despite tight shooting restrictions and a short timeframe, the hired team were able to deliver at scale.</div><div class=case-study-details__content__section-1__background><div class=case-study-details__content__section-1__box><div class=case-study-details__content__section-1__box__title>Services included:</div><div class=case-study-details__content__section-1__box__list><div class=case-study-details__content__section-1__box__item>Sourcing and matching photographers and videographers to assignment</div><div class=case-study-details__content__section-1__box__item>Sourcing of models and props</div><div class=case-study-details__content__section-1__box__item>Art direction and styling services</div><div class=case-study-details__content__section-1__box__item>Photography services</div><div class=case-study-details__content__section-1__box__item>Post-production editing</div><div class=case-study-details__content__section-1__box__item>Logistical support</div></div></div></div></div></div><div class=case-study-details__content__section-2><div class=case-study-details__content__section-2__box><div class=case-study-details__content__section-2__box__title>Despite tight shooting restrictions and a short timeframe, the hired team were able to deliver at scale.</div></div></div><div class=case-study-details__content__section-3><div class=case-study-details__content__section-3__col-left></div><div class=case-study-details__content__section-3__col-right><div class=case-study-details__content__section-3__photo></div><div class=case-study-details__content__section-3__content><p>Subsequently, we were re-engaged for another People\'s Association project within the same year. For the client\'s lifestyle-oriented app and website, the agency requested a shoot that involves multiple locations, scenes and models to depict a wide range of indoor and outdoor activities.</p><p>Working with a family and lifestyle photographer who specialises in capturing human moments, we aligned closely with all parties involved to ensure that the project was executed perfectly and delivered on time.</p></div></div></div><div class=case-study-details__content__section-4><div flex-grid ng-model=vm.caseStudy.photos rowheight=200 margins=20 lastrow=justify borderstyle=-20 class=case-study-details__content__section-4__photo-grid><div ng-repeat=\"photo in vm.caseStudy.photos\"><img ng-src={{photo.url}}></div></div><div flex-grid ng-model=vm.caseStudy.photoSecondGrid rowheight=200 margins=20 lastrow=justify borderstyle=-20 class=case-study-details__content__section-4__photo-grid><div ng-repeat=\"photo in vm.caseStudy.photoSecondGrid\"><img ng-src={{photo.url}}></div></div></div><div ng-if=\"vm.slideDatas && vm.slideDatas.length\" class=case-study-details__content__section-5><div class=case-study-details__content__section-5__title>Read more case studies</div><div class=case-study-details__content__section-5__content><div class=case-study-details__content__section-5__carousel__wrapper><slick speed=1000 class=case-study-details__content__section-5__carousel infinite=false slides-to-scroll=3 slides-to-show=3 dots=true arrows=false on-init=vm.slickSetting.onInit(slick) on-after-change=\"vm.slickSetting.onAfterChange(event, slick, currentSlide, nextSlide)\"><div ng-repeat=\"data in vm.slideDatas\"><div class=case-study-details__content__section-5__item ng-style=\"{\'background-image\': \'url(\\\'\' + data.cover + \'\\\')\'}\"><div class=case-study-details__content__section-5__item__info ng-click=vm.onGotoCaseStudy(data)><div class=case-study-details__content__section-5__item__info__auth>{{data.owner}}</div><div class=case-study-details__content__section-5__item__info__type>{{data.type}}{{data.subType ? \' - \' + data.subType: \'\'}}</div></div></div></div></slick><slick speed=1000 class=case-study-details__content__section-5__carousel--mobile infinite=false slides-to-scroll=1 slides-to-show=1 dots=true arrows=false center-mode=true on-init=vm.slickMobileSetting.onInit(slick) on-after-change=\"vm.slickMobileSetting.onAfterChange(event, slick, currentSlide, nextSlide)\"><div ng-repeat=\"data in vm.slideDatas\"><div class=case-study-details__content__section-5__item ng-style=\"{\'background-image\': \'url(\\\'\' + data.cover + \'\\\')\'}\"><div class=case-study-details__content__section-5__item__info ng-click=vm.onGotoCaseStudy(data)><div class=case-study-details__content__section-5__item__info__auth>{{data.owner}}</div><div class=case-study-details__content__section-5__item__info__type>{{data.type}}{{data.subType ? \' - \' + data.subType: \'\'}}</div></div></div></div></slick><div class=case-study-details__content__section-5__carousel__navigate><div class=\"case-study-details__content__section-5__carousel__navigate__left icon-slide-prev-icon\" ng-class=\"{\'disabled\': vm.isFirstSlickSlide, \'disabled-mobile\': vm.isFirstSlickMobileSlide}\" ng-click=vm.onPreviousSlide()></div><div class=\"case-study-details__content__section-5__carousel__navigate__right icon-slide-next-icon\" ng-class=\"{\'disabled\': vm.isLastSlickSlide, \'disabled-mobile\': vm.isLastSlickMobileSlide}\" ng-click=vm.onNextSlide()></div></div></div></div></div></div></div>");
$templateCache.put("app/about-business-page/components/case-studies/case-study-details/case-study-petronas.html","<div class=\"case-study-details case-study-petronas\"><div class=case-study-details__banner><div class=case-study-details__banner__overlay></div><div class=case-study-details__banner__back-btn ng-click=vm.onBackAboutCaseStudy()><span class=icon-icons_chevron-left></span> <span>Read more stories</span></div><div class=case-study-details__banner__box><div class=case-study-details__banner__box__type>{{vm.caseStudy.type}}</div><div class=case-study-details__banner__box__title>{{vm.caseStudy.title}}</div><div class=case-study-details__banner__box__owner>{{vm.caseStudy.client}}</div></div></div><div class=case-study-details__content><div class=case-study-details__content__back-btn ng-click=vm.onBackAboutCaseStudy() dynamic-show-hide-scroll scroll-down-class=hide-on-mobile><span class=icon-icons_chevron-left></span> <span>Read more stories</span></div><div class=case-study-details__content__section-1><div class=case-study-details__content__section-1__col-left><div class=case-study-details__content__section-1__col-left__content><div class=case-study-details__content__section-1__logo><img ng-src={{vm.caseStudy.logo}}></div><div class=case-study-details__content__section-1__list><div class=case-study-details__content__section-1__item><span class=case-study-details__content__section-1__item__title>CLIENT:</span> <span>{{vm.caseStudy.company || vm.caseStudy.client}}</span></div><div class=case-study-details__content__section-1__item><span class=case-study-details__content__section-1__item__title>TYPE:</span> <span>{{vm.caseStudy.contentType}}</span></div><div ng-if=vm.caseStudy.category class=case-study-details__content__section-1__item><span class=case-study-details__content__section-1__item__title>CATEGORY:</span> <span>{{vm.caseStudy.category}}</span></div><div ng-if=vm.caseStudy.daysOfShoots class=case-study-details__content__section-1__item><span class=case-study-details__content__section-1__item__title>DAYS OF SHOOT:</span> <span>{{vm.caseStudy.daysOfShoots}}</span></div><div ng-if=vm.caseStudy.imageLicensed class=case-study-details__content__section-1__item><span class=case-study-details__content__section-1__item__title>IMAGE LICENSED:</span> <span>{{vm.caseStudy.imageLicensed}}</span></div><div ng-if=vm.caseStudy.location class=case-study-details__content__section-1__item><span class=case-study-details__content__section-1__item__title>LOCATION:</span> <span>{{vm.caseStudy.location}}</span></div><div ng-if=vm.caseStudy.imageSubmissions class=case-study-details__content__section-1__item><span class=case-study-details__content__section-1__item__title>IMAGE SUBMISSIONS:</span> <span>{{vm.caseStudy.imageSubmissions}}</span></div><div ng-if=vm.caseStudy.reach class=case-study-details__content__section-1__item><span class=case-study-details__content__section-1__item__title>REACH:</span> <span>{{vm.caseStudy.reach}}</span></div></div><div class=case-study-details__content__section-1__button ng-click=vm.bookAShoot()>Book a Shoot</div></div></div><div class=case-study-details__content__section-1__col-right><div class=case-study-details__content__section-1__back-btn ng-click=vm.onBackAboutCaseStudy()><span class=icon-icons_chevron-left></span> <span>Read more stories</span></div><div class=case-study-details__content__section-1__content>In Malaysia, PETRONAS is synonymous with oil, gas and electricity that power cities. But for its nationwide campaign, the brand wants its name to stand for another kind of energy: the can-do spirit of its people. Through a series of billboard images, PETRONAS wanted to bring out the pride of every state by highlighting their strengths. Working with the creative team at Ensemble, the agency managing the project, we enlisted local talents to produce this campaign who also represented Malaysians doing great things in difficult times.</div><div class=case-study-details__content__section-1__background><div class=case-study-details__content__section-1__box><div class=case-study-details__content__section-1__box__title>Services included:</div><div class=case-study-details__content__section-1__box__list><div class=case-study-details__content__section-1__box__item>Sourcing and matching photographers to assignment</div><div class=case-study-details__content__section-1__box__item>Managing multiple creators in multiple locations</div><div class=case-study-details__content__section-1__box__item>Sourcing of locations, talents and props</div><div class=case-study-details__content__section-1__box__item>Photography services</div><div class=case-study-details__content__section-1__box__item>Post-production editing</div><div class=case-study-details__content__section-1__box__item>Logistical support</div></div></div></div></div></div><div class=case-study-details__content__section-2><div class=case-study-details__content__section-2__box><div class=case-study-details__content__section-2__box__title>\"These photographer talents were able to avoid being bound to the initial visual concepts from a very corporate standpoint and act as advisors to improve it with their take on authenticity.\"</div><div class=case-study-details__content__section-2__box__author><div class=case-study-details__content__section-2__box__author__name>Ensemble</div><div class=case-study-details__content__section-2__box__author__position>Creative Agency for Petronas campaign</div></div></div></div><div class=case-study-details__content__section-3><div class=case-study-details__content__section-3__col-left></div><div class=case-study-details__content__section-3__col-right><div class=case-study-details__content__section-3__photo></div><div class=case-study-details__content__section-3__content><p>With multiple locations and distinct themes, it was important to select the right photographer for each location. We matched them to 6 up-and-coming creators on the PIXERF platform who had the experience and strength in non-conventional documentary styles to capture the subjects in their own unique way.</p><p>These creators worked on a variety of scenes - from lifestyle shoots in Kuala Lumpur and Penang, aerial shoots in Malacca and Bangi, to an underwater shoot in Sipadan Island, Sabah. They were able to draw on their local expertise to execute their assignments successfully and capture truly authentic, little seen images of Malaysia.</p></div></div></div><div class=case-study-details__content__section-4><div flex-grid ng-model=vm.caseStudy.photos rowheight=300 margins=20 lastrow=justify borderstyle=-20 class=case-study-details__content__section-4__photo-grid><div ng-repeat=\"photo in vm.caseStudy.photos\"><img ng-src={{photo.url}}></div></div></div><div ng-if=\"vm.slideDatas && vm.slideDatas.length\" class=case-study-details__content__section-5><div class=case-study-details__content__section-5__title>Read more case studies</div><div class=case-study-details__content__section-5__content><div class=case-study-details__content__section-5__carousel__wrapper><slick speed=1000 class=case-study-details__content__section-5__carousel infinite=false slides-to-scroll=3 slides-to-show=3 dots=true arrows=false on-init=vm.slickSetting.onInit(slick) on-after-change=\"vm.slickSetting.onAfterChange(event, slick, currentSlide, nextSlide)\"><div ng-repeat=\"data in vm.slideDatas\"><div class=case-study-details__content__section-5__item ng-style=\"{\'background-image\': \'url(\\\'\' + data.cover + \'\\\')\'}\"><div class=case-study-details__content__section-5__item__info ng-click=vm.onGotoCaseStudy(data)><div class=case-study-details__content__section-5__item__info__auth>{{data.owner}}</div><div class=case-study-details__content__section-5__item__info__type>{{data.type}}{{data.subType ? \' - \' + data.subType: \'\'}}</div></div></div></div></slick><slick speed=1000 class=case-study-details__content__section-5__carousel--mobile infinite=false slides-to-scroll=1 slides-to-show=1 dots=true arrows=false center-mode=true on-init=vm.slickMobileSetting.onInit(slick) on-after-change=\"vm.slickMobileSetting.onAfterChange(event, slick, currentSlide, nextSlide)\"><div ng-repeat=\"data in vm.slideDatas\"><div class=case-study-details__content__section-5__item ng-style=\"{\'background-image\': \'url(\\\'\' + data.cover + \'\\\')\'}\"><div class=case-study-details__content__section-5__item__info ng-click=vm.onGotoCaseStudy(data)><div class=case-study-details__content__section-5__item__info__auth>{{data.owner}}</div><div class=case-study-details__content__section-5__item__info__type>{{data.type}}{{data.subType ? \' - \' + data.subType: \'\'}}</div></div></div></div></slick><div class=case-study-details__content__section-5__carousel__navigate><div class=\"case-study-details__content__section-5__carousel__navigate__left icon-slide-prev-icon\" ng-class=\"{\'disabled\': vm.isFirstSlickSlide, \'disabled-mobile\': vm.isFirstSlickMobileSlide}\" ng-click=vm.onPreviousSlide()></div><div class=\"case-study-details__content__section-5__carousel__navigate__right icon-slide-next-icon\" ng-class=\"{\'disabled\': vm.isLastSlickSlide, \'disabled-mobile\': vm.isLastSlickMobileSlide}\" ng-click=vm.onNextSlide()></div></div></div></div></div></div></div>");
$templateCache.put("app/about-business-page/components/case-studies/case-study-details/case-study-salam-singapore.html","<div class=\"case-study-details case-study-salam-singapore\"><div class=case-study-details__banner photo-details-on-click=28741><div class=case-study-details__banner__back-btn ng-click=vm.onBackAboutCaseStudy()><span class=icon-icons_chevron-left></span> <span>Read more stories</span></div><div class=case-study-details__banner__box><div class=case-study-details__banner__box__type>{{vm.caseStudy.type}}</div><div class=case-study-details__banner__box__title>{{vm.caseStudy.title}}</div><div class=case-study-details__banner__box__owner>{{vm.caseStudy.client}}</div></div></div><div class=case-study-details__content><div class=case-study-details__content__back-btn ng-click=vm.onBackAboutCaseStudy() dynamic-show-hide-scroll scroll-down-class=hide-on-mobile><span class=icon-icons_chevron-left></span> <span>Read more stories</span></div><div class=case-study-details__content__section-1><div class=case-study-details__content__section-1__col-left><div class=case-study-details__content__section-1__col-left__content><div class=case-study-details__content__section-1__logo><img ng-src={{vm.caseStudy.logo}}></div><div class=case-study-details__content__section-1__list><div class=case-study-details__content__section-1__item><span class=case-study-details__content__section-1__item__title>CLIENT:</span> <span>{{vm.caseStudy.company || vm.caseStudy.client}}</span></div><div class=case-study-details__content__section-1__item><span class=case-study-details__content__section-1__item__title>TYPE:</span> <span>{{vm.caseStudy.contentType}}</span></div><div ng-if=vm.caseStudy.category class=case-study-details__content__section-1__item><span class=case-study-details__content__section-1__item__title>CATEGORY:</span> <span>{{vm.caseStudy.category}}</span></div><div ng-if=vm.caseStudy.daysOfShoots class=case-study-details__content__section-1__item><span class=case-study-details__content__section-1__item__title>DAYS OF SHOOT:</span> <span>{{vm.caseStudy.daysOfShoots}}</span></div><div ng-if=vm.caseStudy.imageLicensed class=case-study-details__content__section-1__item><span class=case-study-details__content__section-1__item__title>IMAGE LICENSED:</span> <span>{{vm.caseStudy.imageLicensed}}</span></div><div ng-if=vm.caseStudy.location class=case-study-details__content__section-1__item><span class=case-study-details__content__section-1__item__title>LOCATION:</span> <span>{{vm.caseStudy.location}}</span></div><div ng-if=vm.caseStudy.imageSubmissions class=case-study-details__content__section-1__item><span class=case-study-details__content__section-1__item__title>IMAGE SUBMISSIONS:</span> <span>{{vm.caseStudy.imageSubmissions}}</span></div><div ng-if=vm.caseStudy.reach class=case-study-details__content__section-1__item><span class=case-study-details__content__section-1__item__title>REACH:</span> <span>{{vm.caseStudy.reach}}</span></div></div><div class=case-study-details__content__section-1__button ng-click=vm.bookAShoot()>Book a Shoot</div></div></div><div class=case-study-details__content__section-1__col-right><div class=case-study-details__content__section-1__back-btn ng-click=vm.onBackAboutCaseStudy()><span class=icon-icons_chevron-left></span> <span>Read more stories</span></div><div class=case-study-details__content__section-1__content>PIXERF’s “Faces of Singaporean Muslims” photo contest invited the local Muslim community to define themselves through their own lens. This Mission was one among many interactive activities held at Salam Singapore, a three-day community festival celebrating the 50th anniversary of Muis. Our biggest challenge: making the contest as easy and rewarding as possible to encourage visitors to participate without taking too much of their time.</div><div class=case-study-details__content__section-1__background photo-details-on-click=147404><div class=case-study-details__content__section-1__badge ng-click=\"vm.onGoMissionDetails({id: 44, name: \'Faces-of-Singaporean-Muslims\'})\"><div class=case-study-details__badge><div class=case-study-details__badge__icon></div><div class=case-study-details__badge__name>Faces of Singaporean Muslims</div></div></div><div class=case-study-details__content__section-1__box><div class=case-study-details__content__section-1__box__title>Services included:</div><div class=case-study-details__content__section-1__box__list><div class=case-study-details__content__section-1__box__item>Refinement of brief</div><div class=case-study-details__content__section-1__box__item>Curation of visual inspiration</div><div class=case-study-details__content__section-1__box__item>Social media promotion</div><div class=case-study-details__content__section-1__box__item>Curation of submissions</div><div class=case-study-details__content__section-1__box__item>Award announcement posts</div></div></div></div></div></div><div class=case-study-details__content__section-2 photo-details-on-click=122364><div class=case-study-details__content__section-2__box><div class=case-study-details__content__section-2__box__title>The submissions received told compelling stories about a vibrant, modern and inspiring community.</div><div class=case-study-details__content__section-2__badge ng-click=\"vm.onGoMissionDetails({id: 44, name: \'Faces-of-Singaporean-Muslims\'})\"><div class=case-study-details__badge><div class=case-study-details__badge__icon></div><div class=case-study-details__badge__name>Faces of Singaporean Muslims</div></div></div></div></div><div class=case-study-details__content__section-3><div class=case-study-details__content__section-3__col-left></div><div class=case-study-details__content__section-3__col-right><div class=case-study-details__content__section-3__photo photo-details-on-click=159218><div class=case-study-details__content__section-3__badge ng-click=\"vm.onGoMissionDetails({id: 44, name: \'Faces-of-Singaporean-Muslims\'})\"><div class=case-study-details__badge><div class=case-study-details__badge__icon></div><div class=case-study-details__badge__name>Faces of Singaporean Muslims</div></div></div></div><div class=case-study-details__content__section-3__content><p>PIXERF worked closely with the client and appointed a creative agency to facilitate a fully-customised online Challenge as part of their omni-channel campaign strategy. This included conducting outreach efforts during the event, promoting the Challenge, and calling for submissions. Our curation team reviewed each photo and caption to ensure that the submissions focused on Singaporean Muslims as the brief requested.</p><p>At the end of the Challenge, 28 winners received SGD 100 each, with one grand prize winner getting an additional SGD 500. The submissions received told compelling stories about a vibrant, modern and inspiring community. A post-event uptick in submissions also proved the efficacy of the on-ground engagement in driving participation.</p></div></div></div><div class=case-study-details__content__section-4><div flex-grid ng-model=vm.caseStudy.photos rowheight=300 margins=20 lastrow=justify borderstyle=-20 class=case-study-details__content__section-4__photo-grid><div ng-repeat=\"photo in vm.caseStudy.photos\" class=case-study-details__content__section-4__item><img ng-src={{photo.url}} photo-details-on-click={{photo.id}}><div ng-if=photo.badge class=case-study-details__badge class=case-study-details__content__section-4__item ng-click=\"vm.onGoMissionDetails({id: photo.missionId, name: (photo.missionName | toSnakeCase)})\"><div class=case-study-details__badge__icon></div><div class=case-study-details__badge__name>{{photo.badge}}</div></div></div></div></div><div ng-if=\"vm.slideDatas && vm.slideDatas.length\" class=case-study-details__content__section-5><div class=case-study-details__content__section-5__title>Read more case studies</div><div class=case-study-details__content__section-5__content><div class=case-study-details__content__section-5__carousel__wrapper><slick speed=1000 class=case-study-details__content__section-5__carousel infinite=false slides-to-scroll=3 slides-to-show=3 dots=true arrows=false on-init=vm.slickSetting.onInit(slick) on-after-change=\"vm.slickSetting.onAfterChange(event, slick, currentSlide, nextSlide)\"><div ng-repeat=\"data in vm.slideDatas\"><div class=case-study-details__content__section-5__item ng-style=\"{\'background-image\': \'url(\\\'\' + data.cover + \'\\\')\'}\"><div class=case-study-details__content__section-5__item__info ng-click=vm.onGotoCaseStudy(data)><div class=case-study-details__content__section-5__item__info__auth>{{data.owner}}</div><div class=case-study-details__content__section-5__item__info__type>{{data.type}}{{data.subType ? \' - \' + data.subType: \'\'}}</div></div></div></div></slick><slick speed=1000 class=case-study-details__content__section-5__carousel--mobile infinite=false slides-to-scroll=1 slides-to-show=1 dots=true arrows=false center-mode=true on-init=vm.slickMobileSetting.onInit(slick) on-after-change=\"vm.slickMobileSetting.onAfterChange(event, slick, currentSlide, nextSlide)\"><div ng-repeat=\"data in vm.slideDatas\"><div class=case-study-details__content__section-5__item ng-style=\"{\'background-image\': \'url(\\\'\' + data.cover + \'\\\')\'}\"><div class=case-study-details__content__section-5__item__info ng-click=vm.onGotoCaseStudy(data)><div class=case-study-details__content__section-5__item__info__auth>{{data.owner}}</div><div class=case-study-details__content__section-5__item__info__type>{{data.type}}{{data.subType ? \' - \' + data.subType: \'\'}}</div></div></div></div></slick><div class=case-study-details__content__section-5__carousel__navigate><div class=\"case-study-details__content__section-5__carousel__navigate__left icon-slide-prev-icon\" ng-class=\"{\'disabled\': vm.isFirstSlickSlide, \'disabled-mobile\': vm.isFirstSlickMobileSlide}\" ng-click=vm.onPreviousSlide()></div><div class=\"case-study-details__content__section-5__carousel__navigate__right icon-slide-next-icon\" ng-class=\"{\'disabled\': vm.isLastSlickSlide, \'disabled-mobile\': vm.isLastSlickMobileSlide}\" ng-click=vm.onNextSlide()></div></div></div></div></div></div></div>");
$templateCache.put("app/about-business-page/components/case-studies/case-study-details/case-study-shield.html","<div class=\"case-study-details case-study-shield\"><div class=case-study-details__banner><div class=case-study-details__banner__overlay></div><div class=case-study-details__banner__back-btn ng-click=vm.onBackAboutCaseStudy()><span class=icon-icons_chevron-left></span> <span>Read more stories</span></div><div class=case-study-details__banner__box><div class=case-study-details__banner__box__type>{{vm.caseStudy.type}}</div><div class=case-study-details__banner__box__title>{{vm.caseStudy.title}}</div><div class=case-study-details__banner__box__owner>{{vm.caseStudy.client}}</div></div></div><div class=case-study-details__content><div class=case-study-details__content__back-btn ng-click=vm.onBackAboutCaseStudy() dynamic-show-hide-scroll scroll-down-class=hide-on-mobile><span class=icon-icons_chevron-left></span> <span>Read more stories</span></div><div class=case-study-details__content__section-1><div class=case-study-details__content__section-1__col-left><div class=case-study-details__content__section-1__col-left__content><div class=case-study-details__content__section-1__logo><img ng-src={{vm.caseStudy.logo}}></div><div class=case-study-details__content__section-1__list><div class=case-study-details__content__section-1__item><span class=case-study-details__content__section-1__item__title>CLIENT:</span> <span>{{vm.caseStudy.company || vm.caseStudy.client}}</span></div><div class=case-study-details__content__section-1__item><span class=case-study-details__content__section-1__item__title>TYPE:</span> <span>{{vm.caseStudy.contentType}}</span></div><div ng-if=vm.caseStudy.category class=case-study-details__content__section-1__item><span class=case-study-details__content__section-1__item__title>CATEGORY:</span> <span>{{vm.caseStudy.category}}</span></div><div ng-if=vm.caseStudy.daysOfShoots class=case-study-details__content__section-1__item><span class=case-study-details__content__section-1__item__title>DAYS OF SHOOT:</span> <span>{{vm.caseStudy.daysOfShoots}}</span></div><div ng-if=vm.caseStudy.imageLicensed class=case-study-details__content__section-1__item><span class=case-study-details__content__section-1__item__title>IMAGE LICENSED:</span> <span>{{vm.caseStudy.imageLicensed}}</span></div><div ng-if=vm.caseStudy.location class=case-study-details__content__section-1__item><span class=case-study-details__content__section-1__item__title>LOCATION:</span> <span>{{vm.caseStudy.location}}</span></div><div ng-if=vm.caseStudy.imageSubmissions class=case-study-details__content__section-1__item><span class=case-study-details__content__section-1__item__title>IMAGE SUBMISSIONS:</span> <span>{{vm.caseStudy.imageSubmissions}}</span></div><div ng-if=vm.caseStudy.reach class=case-study-details__content__section-1__item><span class=case-study-details__content__section-1__item__title>REACH:</span> <span>{{vm.caseStudy.reach}}</span></div></div><div class=case-study-details__content__section-1__button ng-click=vm.bookAShoot()>Book a Shoot</div></div></div><div class=case-study-details__content__section-1__col-right><div class=case-study-details__content__section-1__back-btn ng-click=vm.onBackAboutCaseStudy()><span class=icon-icons_chevron-left></span> <span>Read more stories</span></div><div class=case-study-details__content__section-1__content>For this custom content assignment, we helped Shield, a mobile-first risk intelligence company, enlist a professional crew to shoot a video that showcases the business advantages of using Shield’s risk intelligence solutions experienced by its customer, Ovo, a leading Indonesian payments, rewards and financial services platform.</div><div class=case-study-details__content__section-1__background><div class=case-study-details__content__section-1__box><div class=case-study-details__content__section-1__box__title>Services included:</div><div class=case-study-details__content__section-1__box__list><div class=case-study-details__content__section-1__box__item>Selecting video team</div><div class=case-study-details__content__section-1__box__item>Pre-production services</div><div class=case-study-details__content__section-1__box__item>Video direction services</div><div class=case-study-details__content__section-1__box__item>Videography services</div><div class=case-study-details__content__section-1__box__item>Post-production editing</div><div class=case-study-details__content__section-1__box__item>Logistical support</div></div></div></div></div></div><div class=case-study-details__content__section-2><div class=case-study-details__content__section-2__box><div class=case-study-details__content__section-2__box__title>The video is a perfect example of executing a shoot overseas, with speed and minimal coordination from your desk.</div></div></div><div class=case-study-details__content__section-3><div class=case-study-details__content__section-3__col-left></div><div class=case-study-details__content__section-3__col-right><div class=case-study-details__content__section-3__photo></div><div class=case-study-details__content__section-3__content><p>The customer story was taken against the backdrop of the rise of mobile payment in Indonesia. The video is a perfect example of executing a shoot overseas, with speed and minimal coordination from your desk.</p><p>Refer to Ovo customer story video link: <a href=https://www.shield.com class=highlight-text target=_blank>https://www.shield.com/</a></p></div></div></div><div class=case-study-details__content__section-4><div flex-grid ng-model=vm.caseStudy.photos rowheight=300 margins=20 lastrow=justify borderstyle=-20 class=case-study-details__content__section-4__photo-grid><div ng-repeat=\"photo in vm.caseStudy.photos\"><img ng-src={{photo.url}}></div></div></div><div ng-if=\"vm.slideDatas && vm.slideDatas.length\" class=case-study-details__content__section-5><div class=case-study-details__content__section-5__title>Read more case studies</div><div class=case-study-details__content__section-5__content><div class=case-study-details__content__section-5__carousel__wrapper><slick speed=1000 class=case-study-details__content__section-5__carousel infinite=false slides-to-scroll=3 slides-to-show=3 dots=true arrows=false on-init=vm.slickSetting.onInit(slick) on-after-change=\"vm.slickSetting.onAfterChange(event, slick, currentSlide, nextSlide)\"><div ng-repeat=\"data in vm.slideDatas\"><div class=case-study-details__content__section-5__item ng-style=\"{\'background-image\': \'url(\\\'\' + data.cover + \'\\\')\'}\"><div class=case-study-details__content__section-5__item__info ng-click=vm.onGotoCaseStudy(data)><div class=case-study-details__content__section-5__item__info__auth>{{data.owner}}</div><div class=case-study-details__content__section-5__item__info__type>{{data.type}}{{data.subType ? \' - \' + data.subType: \'\'}}</div></div></div></div></slick><slick speed=1000 class=case-study-details__content__section-5__carousel--mobile infinite=false slides-to-scroll=1 slides-to-show=1 dots=true arrows=false center-mode=true on-init=vm.slickMobileSetting.onInit(slick) on-after-change=\"vm.slickMobileSetting.onAfterChange(event, slick, currentSlide, nextSlide)\"><div ng-repeat=\"data in vm.slideDatas\"><div class=case-study-details__content__section-5__item ng-style=\"{\'background-image\': \'url(\\\'\' + data.cover + \'\\\')\'}\"><div class=case-study-details__content__section-5__item__info ng-click=vm.onGotoCaseStudy(data)><div class=case-study-details__content__section-5__item__info__auth>{{data.owner}}</div><div class=case-study-details__content__section-5__item__info__type>{{data.type}}{{data.subType ? \' - \' + data.subType: \'\'}}</div></div></div></div></slick><div class=case-study-details__content__section-5__carousel__navigate><div class=\"case-study-details__content__section-5__carousel__navigate__left icon-slide-prev-icon\" ng-class=\"{\'disabled\': vm.isFirstSlickSlide, \'disabled-mobile\': vm.isFirstSlickMobileSlide}\" ng-click=vm.onPreviousSlide()></div><div class=\"case-study-details__content__section-5__carousel__navigate__right icon-slide-next-icon\" ng-class=\"{\'disabled\': vm.isLastSlickSlide, \'disabled-mobile\': vm.isLastSlickMobileSlide}\" ng-click=vm.onNextSlide()></div></div></div></div></div></div></div>");
$templateCache.put("app/about-business-page/components/case-studies/case-study-details/case-study-storytel.html","<div class=\"case-study-details case-study-storytel\"><div class=case-study-details__banner photo-details-on-click=28741><div class=case-study-details__banner__back-btn ng-click=vm.onBackAboutCaseStudy()><span class=icon-icons_chevron-left></span> <span>Read more stories</span></div><div class=case-study-details__banner__box><div class=case-study-details__banner__box__type>{{vm.caseStudy.type}}</div><div class=case-study-details__banner__box__title>{{vm.caseStudy.title}}</div><div class=case-study-details__banner__box__owner>{{vm.caseStudy.client}}</div></div></div><div class=case-study-details__content><div class=case-study-details__content__back-btn ng-click=vm.onBackAboutCaseStudy() dynamic-show-hide-scroll scroll-down-class=hide-on-mobile><span class=icon-icons_chevron-left></span> <span>Read more stories</span></div><div class=case-study-details__content__section-1><div class=case-study-details__content__section-1__col-left><div class=case-study-details__content__section-1__col-left__content><div class=case-study-details__content__section-1__logo><img ng-src={{vm.caseStudy.logo}}></div><div class=case-study-details__content__section-1__list><div class=case-study-details__content__section-1__item><span class=case-study-details__content__section-1__item__title>CLIENT:</span> <span>{{vm.caseStudy.company || vm.caseStudy.client}}</span></div><div class=case-study-details__content__section-1__item><span class=case-study-details__content__section-1__item__title>TYPE:</span> <span>{{vm.caseStudy.contentType}}</span></div><div ng-if=vm.caseStudy.category class=case-study-details__content__section-1__item><span class=case-study-details__content__section-1__item__title>CATEGORY:</span> <span>{{vm.caseStudy.category}}</span></div><div ng-if=vm.caseStudy.daysOfShoots class=case-study-details__content__section-1__item><span class=case-study-details__content__section-1__item__title>DAYS OF SHOOT:</span> <span>{{vm.caseStudy.daysOfShoots}}</span></div><div ng-if=vm.caseStudy.imageLicensed class=case-study-details__content__section-1__item><span class=case-study-details__content__section-1__item__title>IMAGE LICENSED:</span> <span>{{vm.caseStudy.imageLicensed}}</span></div><div ng-if=vm.caseStudy.location class=case-study-details__content__section-1__item><span class=case-study-details__content__section-1__item__title>LOCATION:</span> <span>{{vm.caseStudy.location}}</span></div><div ng-if=vm.caseStudy.imageSubmissions class=case-study-details__content__section-1__item><span class=case-study-details__content__section-1__item__title>IMAGE SUBMISSIONS:</span> <span>{{vm.caseStudy.imageSubmissions}}</span></div><div ng-if=vm.caseStudy.reach class=case-study-details__content__section-1__item><span class=case-study-details__content__section-1__item__title>REACH:</span> <span>{{vm.caseStudy.reach}}</span></div></div><div class=case-study-details__content__section-1__button ng-click=vm.bookAShoot()>Book a Shoot</div></div></div><div class=case-study-details__content__section-1__col-right><div class=case-study-details__content__section-1__back-btn ng-click=vm.onBackAboutCaseStudy()><span class=icon-icons_chevron-left></span> <span>Read more stories</span></div><div class=case-study-details__content__section-1__content><p>StoryTel\'s team came to PIXERF with a proposition to ensure the brand\'s goal can come through with the visual content to be created, which is positioning audible books as something that can easily be incorporated in one\'s lifestyle and everyday activities. While in Europe and other Western countries, gardening in porches for example seems like an ideal opportunity for an audio book scenario, but it wasn\'t as relevant in and for the Asian Market.</p><p>Another goal to meet with this shoot was to ensure that all of Story Tel’s Asia Market was represented through this shoot. With a couple of demographics to target, PIXERF team was also engaged to recruit talents that meet the project’s requirement.</p></div><div class=case-study-details__content__section-1__background photo-details-on-click=147404><div class=case-study-details__content__section-1__box><div class=case-study-details__content__section-1__box__title>Services included:</div><div class=case-study-details__content__section-1__box__list><div class=case-study-details__content__section-1__box__item>Photography Services</div><div class=case-study-details__content__section-1__box__item>Location sourcing and engagement</div><div class=case-study-details__content__section-1__box__item>Talents scouting and engagement</div><div class=case-study-details__content__section-1__box__item>Post Photography services, Editing, Digital Imaging</div></div></div></div></div></div><div class=case-study-details__content__section-2 photo-details-on-click=122364><div class=case-study-details__content__section-2__overlay></div><div class=case-study-details__content__section-2__box><div class=case-study-details__content__section-2__box__title>With a couple of demographics to target, PIXERF team was also engaged to recruit talents that meet the project’s requirement.</div></div></div><div class=case-study-details__content__section-3><div class=case-study-details__content__section-3__col-left></div><div class=case-study-details__content__section-3__col-right><div class=case-study-details__content__section-3__photo photo-details-on-click=159218></div><div class=case-study-details__content__section-3__content><p>Overall, the 1-day shoot that was packed from morning till evening, with a total of 9 talents, 16 scenes and two locations (indoor and outdoor) in order to achieve the requirements of he brief. This required the PIXERF team to ensure the scheduling of talents, makeup artists, props master were all in synced to meet the delivery of the shoot. The team also ensured the HQ in Sweden was glued in to the shoot the entire time, Technology made this possible and the team catered for this with additional tethering equipment and portable data for internet connection.</p><p>This project deliverables covers 40 licensed photos from over 500 images shot. The images required were for usage that covers social media and large formats like billboards.</p></div></div></div><div class=case-study-details__content__section-4><div flex-grid ng-model=vm.caseStudy.photos rowheight=300 margins=20 lastrow=justify borderstyle=-20 class=case-study-details__content__section-4__photo-grid><div ng-repeat=\"photo in vm.caseStudy.photos\" class=case-study-details__content__section-4__item><img ng-src={{photo.url}} photo-details-on-click={{photo.id}}><div ng-if=photo.badge class=case-study-details__badge class=case-study-details__content__section-4__item ng-click=\"vm.onGoMissionDetails({id: photo.missionId, name: (photo.missionName | toSnakeCase)})\"><div class=case-study-details__badge__icon></div><div class=case-study-details__badge__name>{{photo.badge}}</div></div></div></div></div><div ng-if=\"vm.slideDatas && vm.slideDatas.length\" class=case-study-details__content__section-5><div class=case-study-details__content__section-5__title>Read more case studies</div><div class=case-study-details__content__section-5__content><div class=case-study-details__content__section-5__carousel__wrapper><slick speed=1000 class=case-study-details__content__section-5__carousel infinite=false slides-to-scroll=3 slides-to-show=3 dots=true arrows=false on-init=vm.slickSetting.onInit(slick) on-after-change=\"vm.slickSetting.onAfterChange(event, slick, currentSlide, nextSlide)\"><div ng-repeat=\"data in vm.slideDatas\"><div class=case-study-details__content__section-5__item ng-style=\"{\'background-image\': \'url(\\\'\' + data.cover + \'\\\')\'}\"><div class=case-study-details__content__section-5__item__info ng-click=vm.onGotoCaseStudy(data)><div class=case-study-details__content__section-5__item__info__auth>{{data.owner}}</div><div class=case-study-details__content__section-5__item__info__type>{{data.type}}{{data.subType ? \' - \' + data.subType: \'\'}}</div></div></div></div></slick><slick speed=1000 class=case-study-details__content__section-5__carousel--mobile infinite=false slides-to-scroll=1 slides-to-show=1 dots=true arrows=false center-mode=true on-init=vm.slickMobileSetting.onInit(slick) on-after-change=\"vm.slickMobileSetting.onAfterChange(event, slick, currentSlide, nextSlide)\"><div ng-repeat=\"data in vm.slideDatas\"><div class=case-study-details__content__section-5__item ng-style=\"{\'background-image\': \'url(\\\'\' + data.cover + \'\\\')\'}\"><div class=case-study-details__content__section-5__item__info ng-click=vm.onGotoCaseStudy(data)><div class=case-study-details__content__section-5__item__info__auth>{{data.owner}}</div><div class=case-study-details__content__section-5__item__info__type>{{data.type}}{{data.subType ? \' - \' + data.subType: \'\'}}</div></div></div></div></slick><div class=case-study-details__content__section-5__carousel__navigate><div class=\"case-study-details__content__section-5__carousel__navigate__left icon-slide-prev-icon\" ng-class=\"{\'disabled\': vm.isFirstSlickSlide, \'disabled-mobile\': vm.isFirstSlickMobileSlide}\" ng-click=vm.onPreviousSlide()></div><div class=\"case-study-details__content__section-5__carousel__navigate__right icon-slide-next-icon\" ng-class=\"{\'disabled\': vm.isLastSlickSlide, \'disabled-mobile\': vm.isLastSlickMobileSlide}\" ng-click=vm.onNextSlide()></div></div></div></div></div></div></div>");
$templateCache.put("app/about-business-page/components/case-studies/case-study-details/case-study-straits-city.html","<div class=\"case-study-details case-study-straits-city\"><div class=case-study-details__banner photo-details-on-click=298962><div class=case-study-details__banner__back-btn ng-click=vm.onBackAboutCaseStudy()><span class=icon-icons_chevron-left></span> <span>Read more stories</span></div><div class=case-study-details__banner__box><div class=case-study-details__banner__box__type>{{vm.caseStudy.type}}</div><div class=case-study-details__banner__box__title>{{vm.caseStudy.title}}</div><div class=case-study-details__banner__box__owner>{{vm.caseStudy.client}}</div></div></div><div class=case-study-details__content><div class=case-study-details__content__back-btn ng-click=vm.onBackAboutCaseStudy() dynamic-show-hide-scroll scroll-down-class=hide-on-mobile><span class=icon-icons_chevron-left></span> <span>Read more stories</span></div><div class=case-study-details__content__section-1><div class=case-study-details__content__section-1__col-left><div class=case-study-details__content__section-1__col-left__content><div class=case-study-details__content__section-1__logo><img ng-src={{vm.caseStudy.logo}}></div><div class=case-study-details__content__section-1__list><div class=case-study-details__content__section-1__item><span class=case-study-details__content__section-1__item__title>CLIENT:</span> <span>{{vm.caseStudy.company || vm.caseStudy.client}}</span></div><div class=case-study-details__content__section-1__item><span class=case-study-details__content__section-1__item__title>TYPE:</span> <span>{{vm.caseStudy.contentType}}</span></div><div ng-if=vm.caseStudy.category class=case-study-details__content__section-1__item><span class=case-study-details__content__section-1__item__title>CATEGORY:</span> <span>{{vm.caseStudy.category}}</span></div><div ng-if=vm.caseStudy.daysOfShoots class=case-study-details__content__section-1__item><span class=case-study-details__content__section-1__item__title>DAYS OF SHOOT:</span> <span>{{vm.caseStudy.daysOfShoots}}</span></div><div ng-if=vm.caseStudy.imageLicensed class=case-study-details__content__section-1__item><span class=case-study-details__content__section-1__item__title>IMAGE LICENSED:</span> <span>{{vm.caseStudy.imageLicensed}}</span></div><div ng-if=vm.caseStudy.location class=case-study-details__content__section-1__item><span class=case-study-details__content__section-1__item__title>LOCATION:</span> <span>{{vm.caseStudy.location}}</span></div><div ng-if=vm.caseStudy.imageSubmissions class=case-study-details__content__section-1__item><span class=case-study-details__content__section-1__item__title>IMAGE SUBMISSIONS:</span> <span>{{vm.caseStudy.imageSubmissions}}</span></div><div ng-if=vm.caseStudy.reach class=case-study-details__content__section-1__item><span class=case-study-details__content__section-1__item__title>REACH:</span> <span>{{vm.caseStudy.reach}}</span></div></div><div class=case-study-details__content__section-1__button ng-click=vm.bookAShoot()>Book a Shoot</div></div></div><div class=case-study-details__content__section-1__col-right><div class=case-study-details__content__section-1__back-btn ng-click=vm.onBackAboutCaseStudy()><span class=icon-icons_chevron-left></span> <span>Read more stories</span></div><div class=case-study-details__content__section-1__content>Straits Trading, an investment company with stakes in real estate, requested a crowdsourced photo challenge for its key project, Straits City, an integrated development in Penang. The client wanted to generate buzz about the project and procure images to be used for marketing and its social media feed. For the photo challenge, we proposed a theme that would draw attention to the location’s multifaceted appeal, from Penang’s historic heritage to its modern-day charms.</div><div class=case-study-details__content__section-1__background photo-details-on-click=315046><div class=case-study-details__content__section-1__box><div class=case-study-details__content__section-1__box__title>Services included:</div><div class=case-study-details__content__section-1__box__list><div class=case-study-details__content__section-1__box__item>Refinement of brief</div><div class=case-study-details__content__section-1__box__item>Curation of visual inspiration</div><div class=case-study-details__content__section-1__box__item>Social media promotion</div><div class=case-study-details__content__section-1__box__item>Curation of submissions</div><div class=case-study-details__content__section-1__box__item>Award announcement posts</div></div></div></div></div></div><div class=case-study-details__content__section-2 photo-details-on-click=314905><div class=case-study-details__content__section-2__box><div class=case-study-details__content__section-2__box__title>Winning images that capture life in vivid detail.</div></div><div class=case-study-details__content__section-2__badge ng-click=\"vm.onGoMissionDetails({id: 115, name: \'Together-at-Home\'})\"><div class=case-study-details__badge><div class=case-study-details__badge__icon></div><div class=case-study-details__badge__name>Together at home</div></div></div></div><div class=case-study-details__content__section-3><div class=case-study-details__content__section-3__col-left></div><div class=case-study-details__content__section-3__col-right><div class=case-study-details__content__section-3__photo photo-details-on-click=210628></div><div class=case-study-details__content__section-3__content><p>A set of three Malaysia-geofenced challenges were set up, focusing on the past, present and future of Penang with briefs that encouraged authentic and unique submissions. The challenges drew enthusiastic response from photographers in Malaysia.</p><p>Another challenge, launched amid Covid-19 movement restrictions in Malaysia, encouraged participants to showcase moments of bonding, joy and intimacy within the confines of home.</p></div></div></div><div class=case-study-details__content__section-4><div flex-grid ng-model=vm.caseStudy.photos rowheight=300 margins=20 lastrow=justify borderstyle=-20 class=case-study-details__content__section-4__photo-grid><div ng-repeat=\"photo in vm.caseStudy.photos\" class=case-study-details__content__section-4__item><img ng-src={{photo.url}} photo-details-on-click={{photo.id}}><div ng-if=photo.badge class=case-study-details__badge ng-click=\"vm.onGoMissionDetails({id: photo.missionId, name: (photo.missionName | toSnakeCase)})\"><div class=case-study-details__badge__icon></div><div class=case-study-details__badge__name>{{photo.badge}}</div></div></div></div></div><div ng-if=\"vm.slideDatas && vm.slideDatas.length\" class=case-study-details__content__section-5><div class=case-study-details__content__section-5__title>Read more case studies</div><div class=case-study-details__content__section-5__content><div class=case-study-details__content__section-5__carousel__wrapper><slick speed=1000 class=case-study-details__content__section-5__carousel infinite=false slides-to-scroll=3 slides-to-show=3 dots=true arrows=false on-init=vm.slickSetting.onInit(slick) on-after-change=\"vm.slickSetting.onAfterChange(event, slick, currentSlide, nextSlide)\"><div ng-repeat=\"data in vm.slideDatas\"><div class=case-study-details__content__section-5__item ng-style=\"{\'background-image\': \'url(\\\'\' + data.cover + \'\\\')\'}\"><div class=case-study-details__content__section-5__item__info ng-click=vm.onGotoCaseStudy(data)><div class=case-study-details__content__section-5__item__info__auth>{{data.owner}}</div><div class=case-study-details__content__section-5__item__info__type>{{data.type}}{{data.subType ? \' - \' + data.subType: \'\'}}</div></div></div></div></slick><slick speed=1000 class=case-study-details__content__section-5__carousel--mobile infinite=false slides-to-scroll=1 slides-to-show=1 dots=true arrows=false center-mode=true on-init=vm.slickMobileSetting.onInit(slick) on-after-change=\"vm.slickMobileSetting.onAfterChange(event, slick, currentSlide, nextSlide)\"><div ng-repeat=\"data in vm.slideDatas\"><div class=case-study-details__content__section-5__item ng-style=\"{\'background-image\': \'url(\\\'\' + data.cover + \'\\\')\'}\"><div class=case-study-details__content__section-5__item__info ng-click=vm.onGotoCaseStudy(data)><div class=case-study-details__content__section-5__item__info__auth>{{data.owner}}</div><div class=case-study-details__content__section-5__item__info__type>{{data.type}}{{data.subType ? \' - \' + data.subType: \'\'}}</div></div></div></div></slick><div class=case-study-details__content__section-5__carousel__navigate><div class=\"case-study-details__content__section-5__carousel__navigate__left icon-slide-prev-icon\" ng-class=\"{\'disabled\': vm.isFirstSlickSlide, \'disabled-mobile\': vm.isFirstSlickMobileSlide}\" ng-click=vm.onPreviousSlide()></div><div class=\"case-study-details__content__section-5__carousel__navigate__right icon-slide-next-icon\" ng-class=\"{\'disabled\': vm.isLastSlickSlide, \'disabled-mobile\': vm.isLastSlickMobileSlide}\" ng-click=vm.onNextSlide()></div></div></div></div></div></div></div>");
$templateCache.put("app/about-business-page/components/case-studies/case-study-details/case-study-wwf.html","<div class=\"case-study-details case-study-wwf\"><div class=case-study-details__banner photo-details-on-click=3267><div class=case-study-details__banner__back-btn ng-click=vm.onBackAboutCaseStudy()><span class=icon-icons_chevron-left></span> <span>Read more stories</span></div><div class=case-study-details__banner__box><div class=case-study-details__banner__box__type>{{vm.caseStudy.type}}</div><div class=case-study-details__banner__box__title>{{vm.caseStudy.title}}</div><div class=case-study-details__banner__box__owner>{{vm.caseStudy.client}}</div></div></div><div class=case-study-details__content><div class=case-study-details__content__back-btn ng-click=vm.onBackAboutCaseStudy() dynamic-show-hide-scroll scroll-down-class=hide-on-mobile><span class=icon-icons_chevron-left></span> <span>Read more stories</span></div><div class=case-study-details__content__section-1><div class=case-study-details__content__section-1__col-left><div class=case-study-details__content__section-1__col-left__content><div class=case-study-details__content__section-1__logo><img ng-src={{vm.caseStudy.logo}}></div><div class=case-study-details__content__section-1__list><div class=case-study-details__content__section-1__item><span class=case-study-details__content__section-1__item__title>CLIENT:</span> <span>{{vm.caseStudy.company || vm.caseStudy.client}}</span></div><div class=case-study-details__content__section-1__item><span class=case-study-details__content__section-1__item__title>TYPE:</span> <span>{{vm.caseStudy.contentType}}</span></div><div ng-if=vm.caseStudy.category class=case-study-details__content__section-1__item><span class=case-study-details__content__section-1__item__title>CATEGORY:</span> <span>{{vm.caseStudy.category}}</span></div><div ng-if=vm.caseStudy.daysOfShoots class=case-study-details__content__section-1__item><span class=case-study-details__content__section-1__item__title>DAYS OF SHOOT:</span> <span>{{vm.caseStudy.daysOfShoots}}</span></div><div ng-if=vm.caseStudy.imageLicensed class=case-study-details__content__section-1__item><span class=case-study-details__content__section-1__item__title>IMAGE LICENSED:</span> <span>{{vm.caseStudy.imageLicensed}}</span></div><div ng-if=vm.caseStudy.location class=case-study-details__content__section-1__item><span class=case-study-details__content__section-1__item__title>LOCATION:</span> <span>{{vm.caseStudy.location}}</span></div><div ng-if=vm.caseStudy.imageSubmissions class=case-study-details__content__section-1__item><span class=case-study-details__content__section-1__item__title>IMAGE SUBMISSIONS:</span> <span>{{vm.caseStudy.imageSubmissions}}</span></div><div ng-if=vm.caseStudy.reach class=case-study-details__content__section-1__item><span class=case-study-details__content__section-1__item__title>REACH:</span> <span>{{vm.caseStudy.reach}}</span></div></div><div class=case-study-details__content__section-1__button ng-click=vm.bookAShoot()>Book a Shoot</div></div></div><div class=case-study-details__content__section-1__col-right><div class=case-study-details__content__section-1__back-btn ng-click=vm.onBackAboutCaseStudy()><span class=icon-icons_chevron-left></span> <span>Read more stories</span></div><div class=case-study-details__content__section-1__content>Brands are looking for cost-effective and non-traditional ways of doing campaigns to engage a younger generation of fans on social media. WWF’s Community Challenge aims to generate conversations about the presence of nature within the urban environment we work, live and play in.</div><div class=case-study-details__content__section-1__background photo-details-on-click=215722><div class=case-study-details__content__section-1__box><div class=case-study-details__content__section-1__box__title>Services included:</div><div class=case-study-details__content__section-1__box__list><div class=case-study-details__content__section-1__box__item>Refinement of brief</div><div class=case-study-details__content__section-1__box__item>Curation of visual inspiration</div><div class=case-study-details__content__section-1__box__item>Social media promotion</div><div class=case-study-details__content__section-1__box__item>Curation of submission</div><div class=case-study-details__content__section-1__box__item>Award announcement posts</div></div></div></div></div></div><div class=case-study-details__content__section-2 photo-details-on-click=278817><div class=case-study-details__content__section-2__box><div class=case-study-details__content__section-2__box__title>\"PIXERF\'s photo contest more than met our expectations by giving us diverse yet unique shots.\"</div><div class=case-study-details__content__section-2__box__author><div class=case-study-details__content__section-2__box__author__name>Niharika Iyengar</div><div class=case-study-details__content__section-2__box__author__position>Assistant, Digital Engagement</div></div></div></div><div class=case-study-details__content__section-3><div class=case-study-details__content__section-3__col-left></div><div class=case-study-details__content__section-3__col-right><div class=case-study-details__content__section-3__photo photo-details-on-click=279176></div><div class=case-study-details__content__section-3__content><p>We worked with WWF to define the scope and reach of the challenge and craft an open brief to attract diverse submissions. We also pushed the challenge on our social media channels to maximise exposure to our 70,000-strong community.</p></div></div></div><div class=case-study-details__content__section-4><div flex-grid ng-model=vm.caseStudy.photos rowheight=300 margins=20 lastrow=justify borderstyle=-20 class=case-study-details__content__section-4__photo-grid><div ng-repeat=\"photo in vm.caseStudy.photos\"><img ng-src={{photo.url}} photo-details-on-click={{photo.id}}><div ng-if=photo.badge class=case-study-details__badge class=case-study-details__content__section-4__item ng-click=\"vm.onGoMissionDetails({id: photo.missionId, name: (photo.missionName | toSnakeCase)})\"><div class=case-study-details__badge__icon></div><div class=case-study-details__badge__name>{{photo.badge}}</div></div></div></div></div><div ng-if=\"vm.slideDatas && vm.slideDatas.length\" class=case-study-details__content__section-5><div class=case-study-details__content__section-5__title>Read more case studies</div><div class=case-study-details__content__section-5__content><div class=case-study-details__content__section-5__carousel__wrapper><slick speed=1000 class=case-study-details__content__section-5__carousel infinite=false slides-to-scroll=3 slides-to-show=3 dots=true arrows=false on-init=vm.slickSetting.onInit(slick) on-after-change=\"vm.slickSetting.onAfterChange(event, slick, currentSlide, nextSlide)\"><div ng-repeat=\"data in vm.slideDatas\"><div class=case-study-details__content__section-5__item ng-style=\"{\'background-image\': \'url(\\\'\' + data.cover + \'\\\')\'}\"><div class=case-study-details__content__section-5__item__info ng-click=vm.onGotoCaseStudy(data)><div class=case-study-details__content__section-5__item__info__auth>{{data.owner}}</div><div class=case-study-details__content__section-5__item__info__type>{{data.type}}{{data.subType ? \' - \' + data.subType: \'\'}}</div></div></div></div></slick><slick speed=1000 class=case-study-details__content__section-5__carousel--mobile infinite=false slides-to-scroll=1 slides-to-show=1 dots=true arrows=false center-mode=true on-init=vm.slickMobileSetting.onInit(slick) on-after-change=\"vm.slickMobileSetting.onAfterChange(event, slick, currentSlide, nextSlide)\"><div ng-repeat=\"data in vm.slideDatas\"><div class=case-study-details__content__section-5__item ng-style=\"{\'background-image\': \'url(\\\'\' + data.cover + \'\\\')\'}\"><div class=case-study-details__content__section-5__item__info ng-click=vm.onGotoCaseStudy(data)><div class=case-study-details__content__section-5__item__info__auth>{{data.owner}}</div><div class=case-study-details__content__section-5__item__info__type>{{data.type}}{{data.subType ? \' - \' + data.subType: \'\'}}</div></div></div></div></slick><div class=case-study-details__content__section-5__carousel__navigate><div class=\"case-study-details__content__section-5__carousel__navigate__left icon-slide-prev-icon\" ng-class=\"{\'disabled\': vm.isFirstSlickSlide, \'disabled-mobile\': vm.isFirstSlickMobileSlide}\" ng-click=vm.onPreviousSlide()></div><div class=\"case-study-details__content__section-5__carousel__navigate__right icon-slide-next-icon\" ng-class=\"{\'disabled\': vm.isLastSlickSlide, \'disabled-mobile\': vm.isLastSlickMobileSlide}\" ng-click=vm.onNextSlide()></div></div></div></div></div></div></div>");
$templateCache.put("app/checkout/credit-plan/components/credit-plan-checkout/credit-plan-checkout.html","<div class=credit-plan-checkout><section class=credit-plan-checkout__content><div class=credit-plan-checkout__content__wrapper><div class=credit-plan-checkout__content__title translate>{{\'order-summary\'}}</div><div class=\"credit-plan-checkout__content__package clearfix\"><div class=credit-plan-checkout__content__package__intro><div class=\"credit-plan-checkout__content__package__intro__title clearfix\" ng-click=vm.onToggleDetailsPlan(vm.isOpenDetailsPlan)><div class=credit-plan-checkout__content__package__intro__title__text>{{vm.package.name}} PIXERF Credit Package</div><div class=credit-plan-checkout__content__package__intro__icon ng-class=\"vm.isOpenDetailsPlan ? \'icon-icons_chevron-up\' : \'icon-icons_chevron-down\'\"></div></div><div class=credit-plan-checkout__content__package__intro__description>Get {{vm.package.value}} PIXERF credits banked into your PIXERF account</div><div class=\"credit-plan-checkout__content__package__intro__collapse collapse cursor-text\" uib-collapse=!vm.isOpenDetailsPlan><div class=credit-plan-checkout__content__package__intro__list><div class=credit-plan-checkout__content__package__intro__list__item><div class=\"credit-plan-checkout__content__package__intro__list__icon icon-icons_check\"></div><div class=credit-plan-checkout__content__package__intro__list__text>Use credits for all image collections</div></div><div class=credit-plan-checkout__content__package__intro__list__item><div class=\"credit-plan-checkout__content__package__intro__list__icon icon-icons_check\"></div><div class=credit-plan-checkout__content__package__intro__list__text translate>{{\'credits-2\'}}</div></div><div class=credit-plan-checkout__content__package__intro__list__item><div class=\"credit-plan-checkout__content__package__intro__list__icon icon-icons_check\"></div><div class=credit-plan-checkout__content__package__intro__list__text translate>{{\'credits-3\'}}</div></div><!-- <div class=\"credit-plan-checkout__content__package__intro__list__item\">\r\n								<div class=\"credit-plan-checkout__content__package__intro__list__icon icon-icons_check\">\r\n								</div>\r\n								<div class=\"credit-plan-checkout__content__package__intro__list__text\">Enjoy 50% off\r\n									multi-seat licensing</div>\r\n							</div> --></div><div class=credit-plan-checkout__content__package__intro__collapse__hint>$1 is equivalent to 1 image credit</div></div></div><div class=credit-plan-checkout__content__package__cost><div class=credit-plan-checkout__content__package__cost__value>{{vm.package.value}}</div><div class=credit-plan-checkout__content__package__cost__price>${{vm.package.price}}</div></div><div class=credit-plan-checkout__content__package__discount><div class=credit-plan-checkout__content__package__discount__cell><div class=credit-plan-checkout__content__package__discount__label>SAVE</div><div class=credit-plan-checkout__content__package__discount__amount>{{vm.package.discount}}</div></div></div></div></div><payment-pannel show-price-hint=\"Prices shown in Singapore Dollars\" skips-to-agree=true context=TOPUP_CREDIT_PLANS not-allowed-list=\"[\'MY_CREDIT\']\" amount-to-pay=vm.package.price on-complete=vm.onPaymentComplete(data) on-error=vm.onError(pixerfPaymentErrorObject) on-payment-method-selected=vm.onPaymentMethodSelected(paymentMethodSelected)></payment-pannel></section></div>");
$templateCache.put("app/checkout/credit-plan/components/credit-plan-list/credit-plan-list.html","<div class=\"credit-plan-page no-margin\"><div class=credit-plan-page__col-wrapper><div class=credit-plan-page__header><div class=credit-plan-page__header__title>{{\'welcome\' | translate}}.</div><div class=credit-plan-page__header__description>{{\'you-are-one-click-away-from-amazing-asian-images\' | translate}}</div></div><section class=credit-plan-page__image-prices-section><div class=credit-plan-page__image-prices-section__header translate>{{\'creative-marketplace\'}}</div><div class=\"credit-plan-page__image-prices-section__title credit-plan-page__title\" translate>{{\'ala-carte-img-prices\'}}</div><div class=\"credit-plan-page__image-prices-section__description credit-plan-page__description\" translate>{{\'for-head-turning-images-starting-from\'}}</div><div class=credit-plan-page__image-prices-section__content><table class=credit-plan-page__image-prices-section__content__table><tr class=credit-plan-page__image-prices-section__content__table__row-header><td ng-repeat=\"image in vm.imagePrices\" class=credit-plan-page__image-prices-section__content__table__col-detail-wrapper><div class=credit-plan-page__image-prices-section__content__table__size translate>{{image.size}}</div><div class=credit-plan-page__image-prices-section__content__table__description translate>{{image.description}}</div></td></tr><tr class=credit-plan-page__image-prices-section__content__table__row-content><td ng-repeat=\"image in vm.imagePrices\" class=credit-plan-page__image-prices-section__content__table__col-detail-wrapper><div ng-if=!$first class=credit-plan-page__image-prices-section__content__table__label translate>{{\'starts-from\'}}</div><div class=credit-plan-page__image-prices-section__content__table__price ng-class=\"{\'no-label\': $first}\">{{image.price}}</div></td></tr></table><div class=credit-plan-page__image-prices-section__content__table--mobile__wrapper><div ng-repeat=\"image in vm.imagePrices\" class=\"credit-plan-page__image-prices-section__content__table--mobile clearfix\"><div class=credit-plan-page__image-prices-section__content__table--mobile__col-left><div class=credit-plan-page__image-prices-section__content__table__size translate>{{image.size}}</div><div class=credit-plan-page__image-prices-section__content__table__description translate>{{image.description}}</div></div><div class=credit-plan-page__image-prices-section__content__table--mobile__col-right><div ng-if=!$first class=credit-plan-page__image-prices-section__content__table__label translate>{{\'starts-from\'}}</div><div class=credit-plan-page__image-prices-section__content__table__price ng-class=\"{\'no-label\': $first}\">{{image.price}}</div></div></div></div><div class=credit-plan-page__hint-text><div>Image prices are set in Singapore dollars.</div><div>PIXERF Ambassadors price their photos higher than the rates above.</div></div><!-- <div class=\"credit-plan-page__hint-text-link\">Want to be a PIXERF Ambassador? Click here to apply.</div> --> <a class=\"btn btn-submit credit-plan-page__link-btn\" ui-sref=buy-stock-page.trending target=_blank translate>{{\'browse-creative-marketplace\'}}</a></div></section><section id=creditplan class=credit-plan-page__credit-packages-section scroll-to-element=vm.scrollToThis offset-top=100><div class=credit-plan-page__col-left><credit-plans on-plan-selected=vm.onPlanSelected(plan)></credit-plans></div><div class=credit-plan-page__hint-text><div>{{\'credits-text\' | translate}}</div></div><div class=credit-plan-page__hint-text-link>Ready to get started? Contact our PIXERF rep <a href=mailto:business@pixerf.com target=_blank class=\"text--bold text--color-pixerf-theme\">here</a>.</div><a class=\"btn btn-submit credit-plan-page__link-btn\" ui-sref=buy-stock-page.trending target=_blank translate>{{\'browse-creative-marketplace\'}}</a></section><section class=credit-plan-page__crowdsourced-missions-section><div class=credit-plan-page__crowdsourced-missions-section__header><div class=\"credit-plan-page__crowdsourced-missions-section__header__title credit-plan-page__big-title\" translate>{{\'crowdsourced-missions\'}}</div><div class=\"credit-plan-page__crowdsourced-missions-section__header__description credit-plan-page__description\" translate>{{\'run-photo-challenges-with-ease\'}}</div></div><div class=credit-plan-page__crowdsourced-missions-section__content-wrapper><div ng-repeat=\"mission in vm.crowdsourcedMissions\" class=crowdsourced-missions-tile ng-class=\"{\'plan--selected\': mission.isSelected, \'custom-col\': mission.type === \'custom\'}\" ng-click=vm.onMissionClicked(mission)><div ng-if=$first class=credit-plan-page__crowdsourced-missions-section__popular-sign><div class=credit-plan-page__crowdsourced-missions-section__popular-sign__text translate>{{\'popular\'}}</div><div class=\"credit-plan-page__crowdsourced-missions-section__popular-sign__icon icon-blank_star\"></div></div><div class=\"credit-plan-page__crowdsourced-missions-section__type text--color-black\" translate>{{mission.title}}</div><div class=credit-plan-page__crowdsourced-missions-section__subtitle-wrapper><span class=credit-plan-page__crowdsourced-missions-section__duration ng-if=\"mission.type != \'custom\'\">{{mission.duration}}</span> <span class=credit-plan-page__crowdsourced-missions-section__subtitle translate>{{mission.subtitle}}</span></div><ul class=credit-plan-page__crowdsourced-missions-section__desc-wrapper><li class=credit-plan-page__crowdsourced-missions-section__desc ng-repeat=\"desc in mission.description\" translate translate-values=\"{number: mission.numberOfWinners}\">{{desc}}</li></ul><button class=\"btn credit-plan-page__crowdsourced-missions-section__btn\" ng-class=\"mission.type === \'custom\' ? \'btn-submit\' : \'btn-cancel--no-background\' \" ng-click=vm.onMadeOrderClicked(mission.mailTo)>{{\'get-in-touch\' | translate}}</button></div></div><div class=credit-plan-page__hint-text-link>Need help selecting a Mission plan? Talk to our PIXERF Rep <a href=mailto:business@pixerf.com class=\"text--bold text--color-pixerf-theme\">here</a>.</div><a class=\"btn btn-submit credit-plan-page__link-btn\" ui-sref=run-a-challenge-page.about-challenge target=_blank translate>{{\'learn-more-about-crowdsourced-missions\'}}</a></section><!-- <section class=\"credit-plan-page__themed-packages-section\">\r\n			<div class=\"credit-plan-page__themed-packages-section__title credit-plan-page__title\" translate>\r\n				{{\'themed-packs-small-biz\'}}</div>\r\n			<div class=\"credit-plan-page__themed-packages-section__content__wrapper\">\r\n				<div class=\"credit-plan-page__themed-packages-section__content__tile\"\r\n					ng-repeat=\"theme in vm.themePackages\">\r\n					<div ng-if=\"$first\" class=\"credit-plan-page__themed-packages-section__content__signal\">\r\n						<div class=\"credit-plan-page__themed-packages-section__content__signal__label\" translate>\r\n							{{\'best-value\'}}</div>\r\n					</div>\r\n					<div class=\"credit-plan-page__themed-packages-section__content__tile__title\" translate>\r\n						{{theme.title}}</div>\r\n					<div class=\"credit-plan-page__themed-packages-section__content__tile__subtitle\" translate\r\n						translate-values=\"{percent: theme.percentOff}\">{{theme.subtitle}}</div>\r\n					<div class=\"credit-plan-page__themed-packages-section__content__tile__description\" translate\r\n						translate-values=\"{number: theme.numberImages}\">{{theme.description}}</div>\r\n				</div>\r\n			</div>\r\n			<div class=\"credit-plan-page__themed-packages-section__footer__wrapper\">\r\n				<div class=\"credit-plan-page__themed-packages-section__footer__title\" translate>\r\n					{{\'custom-commissions-1a\'}}</div>\r\n				<div class=\"credit-plan-page__themed-packages-section__footer__content__wrapper\">\r\n					<div\r\n						class=\"credit-plan-page__themed-packages-section__footer__item received__item received__item__first\">\r\n						<div class=\"credit-plan-page__themed-packages-section__footer__icon icon-zoom_resize\"></div>\r\n						<div class=\"credit-plan-page__themed-packages-section__footer__text\" translate>\r\n							{{\'single-theme-pack\'}}</div>\r\n					</div>\r\n					<div\r\n						class=\"credit-plan-page__themed-packages-section__footer__item received__item received__item__second\">\r\n						<div class=\"credit-plan-page__themed-packages-section__footer__icon icon-three_gallery\"></div>\r\n						<div class=\"credit-plan-page__themed-packages-section__footer__text\" translate>\r\n							{{\'themed-packs\'}}</div>\r\n					</div>\r\n					<div\r\n						class=\"credit-plan-page__themed-packages-section__footer__item received__item received__item__third\">\r\n						<a class=\"btn btn-submit credit-plan-page__themed-packages-section__footer__btn\"\r\n							href=\"mailto:business@pixerf.com?Subject=I\'m%20interested%20to%20purchase%20a%20Themed%20Image%20Pack\">{{\'custom-commissions-1g\' | translate}}</a>\r\n					</div>\r\n				</div>\r\n			</div>\r\n		</section> --><section class=credit-plan-page__custom-commissions-section><div class=\"credit-plan-page__custom-commissions-section__title credit-plan-page__big-title\" translate>{{\'custom-commissions\'}}</div><div class=\"credit-plan-page__custom-commissions-section__description credit-plan-page__description\" translate>{{\'custom-commissions-1\'}}</div><div class=credit-plan-page__custom-commissions-section__content-wrapper><div class=credit-plan-page__custom-commissions-section__receive><div class=credit-plan-page__custom-commissions-section__receive__wrapper><div class=credit-plan-page__custom-commissions-section__receive__tile><div class=\"credit-plan-page__custom-commissions-section__receive__icon icon-multicity\"></div><div class=credit-plan-page__custom-commissions-section__receive__text translate>{{\'custom-commissions-1b\'}}</div></div><div class=credit-plan-page__custom-commissions-section__receive__tile><div class=\"credit-plan-page__custom-commissions-section__receive__icon icon-perfectbrief\"></div><div class=credit-plan-page__custom-commissions-section__receive__text translate>{{\'custom-commissions-1c\'}}</div></div><div class=credit-plan-page__custom-commissions-section__receive__tile><div class=\"credit-plan-page__custom-commissions-section__receive__icon icon-producers\"></div><div class=credit-plan-page__custom-commissions-section__receive__text translate>{{\'custom-commissions-1d\'}}</div></div><div class=credit-plan-page__custom-commissions-section__receive__tile><div class=\"credit-plan-page__custom-commissions-section__receive__icon icon-bestfit\"></div><div class=credit-plan-page__custom-commissions-section__receive__text translate>{{\'custom-commissions-1e\'}}</div></div></div></div><div class=credit-plan-page__custom-commissions-section__get-started><div class=credit-plan-page__custom-commissions-section__get-started__title translate>{{\'custom-commissions-get-started-1a\'}}</div><div class=credit-plan-page__custom-commissions-section__get-started__subtitle translate>{{\'custom-commissions-get-started-1b\'}}</div><div class=credit-plan-page__custom-commissions-section__get-started__description translate>{{\'custom-commissions-get-started-1c\'}}</div><a class=\"btn btn-submit credit-plan-page__custom-commissions-section__get-started__btn\" href=\"mailto:business@pixerf.com?Subject=I\'d%20like%20to%20book%20a%20Custom%20Commission\">{{\'book-now\' | translate}}</a></div></div><div class=credit-plan-page__hint-text-link translate translate-values=\"{link: \'mailto:business@pixerf.com\'}\">{{\'got-questions-about-how-it-works\'}}</div><a class=\"btn btn-submit credit-plan-page__link-btn\" ui-sref=case-studies target=_blank translate>{{\'see-what-other-brands-have-done\'}}</a></section><section class=credit-plan-page__enquries translate>{{\'for-any-enquires\'}}</section><!-- <section class=\"credit-plan-page__faq-section\">\r\n			<h2 class=\"credit-plan-page__title\" translate>{{\'faq-title\'}}</h2>\r\n			<div class=\"credit-plan-page__faq-section__items-wrapper\">\r\n				<div class=\"credit-plan-page__faq-section__left\">\r\n					<div class=\"credit-plan-page__faq-section__item\" ng-repeat=\"item in vm.imagesFaqs\">\r\n						<h5 class=\"text--bold text--color-black\" translate>{{item.question}}</h5>\r\n						<p compile=\"item.answer | translate\"></p>\r\n					</div>\r\n				</div>\r\n				<div class=\"credit-plan-page__faq-section__right\">\r\n					<div class=\"credit-plan-page__faq-section__item\" ng-repeat=\"item in vm.missionFaqs\">\r\n						<h5 class=\"text--bold text--color-black\" translate>{{item.question}}</h5>\r\n						<p compile=\"item.answer | translate\"></p>\r\n					</div>\r\n				</div>\r\n			</div>\r\n			<div class=\"devider\"></div>\r\n			<div class=\"credit-plan-page__faq-section__footer\">\r\n				<a><button ui-sref=\"introduction-support.faq.business\" class=\"btn btn--transparent text--extrabold\">See\r\n						all FAQs</button></a>\r\n			</div>\r\n		</section> --></div></div>");
$templateCache.put("app/checkout/credit-plan/components/credit-plan-payment-successful/credit-plan-payment-successful.html","<div class=credit-plan-payment-successful-page><div class=credit-plan-payment-successful-page__content><div class=credit-plan-payment-successful-page__header><div class=\"credit-plan-payment-successful-page__header__icon icon-icons_check\"></div><div class=credit-plan-payment-successful-page__header__title translate>{{\'payment-successful\'}}</div></div><div class=credit-plan-payment-successful-page__subtitle><div class=credit-plan-payment-successful-page__subtitle__details>{{vm.credit}} PIXERF credits have been banked into your PIXERF account.</div><div class=credit-plan-payment-successful-page__subtitle__hint translate>{{\'you-are-well-on-your-way\'}}</div></div><div class=credit-plan-payment-successful-page__my-credit><div class=credit-plan-payment-successful-page__my-credit__title translate>{{\'my-credits\'}}</div><div class=credit-plan-payment-successful-page__my-credit__content><div class=\"credit-plan-payment-successful-page__my-credit__row clearfix\"><div class=credit-plan-payment-successful-page__my-credit__row__left translate>{{\'original-credit-balance\'}}</div><div class=\"credit-plan-payment-successful-page__my-credit__row__right credit-balance\">{{vm.formatOriginCredit}}</div></div><div class=\"credit-plan-payment-successful-page__my-credit__row clearfix\"><div class=credit-plan-payment-successful-page__my-credit__row__left translate>{{\'image-credit-purchased\'}}</div><div class=credit-plan-payment-successful-page__my-credit__row__right>{{vm.credit}}</div></div><div class=\"credit-plan-payment-successful-page__my-credit__row credit-plan-payment-successful-page__my-credit__row__total clearfix\"><div class=\"credit-plan-payment-successful-page__my-credit__row__left credit-plan-payment-successful-page__my-credit__row__total-left\" translate>{{\'total-credit-balance\'}}</div><div class=\"credit-plan-payment-successful-page__my-credit__row__right credit-plan-payment-successful-page__my-credit__row__total-right\">{{vm.formatTotalCredit}}</div></div></div><div class=credit-plan-payment-successful-page__my-credit__hint translate>{{\'credits-text\'}}</div></div><div class=credit-plan-payment-successful-page__footer><div class=credit-plan-payment-successful-page__footer__title translate>{{\'start-using-your-credits-to\'}}</div><div class=\"credit-plan-payment-successful-page__footer__control clearfix\"><button class=\"credit-plan-payment-successful-page__hint-btn btn btn-submit\" ng-click=vm.onBrowseMarketplaceClicked() translate>{{\'buy-creative-marketplace-images\'}}</button><!-- <button class=\"credit-plan-payment-successful-page__hint-btn btn btn--transparent\"\r\n					ng-click=\"vm.onLaunchMissionClicked()\">Launch a Crowdsourced Mission</button> --></div></div></div></div>");
$templateCache.put("app/checkout/credit-plan/components/credit-plan-payment-wire-transfer/credit-plan-payment-wire-transfer.html","<div class=credit-plan-payment-wire-transfer-page><div class=\"credit-plan-payment-wire-transfer__content text-center\"><div class=credit-plan-payment-wire-transfer__header><div class=credit-plan-payment-wire-transfer__icon></div><div class=\"credit-plan-payment-wire-transfer__header-title text--semibold\">Thank you!</div></div><div class=credit-plan-payment-wire-transfer__description><div class=credit-plan-payment-wire-transfer__description__detail>For all payments via cheque or wire transfer, we will contact you within 3–5 working days with the necessary payment details.</div><div class=credit-plan-payment-wire-transfer__description__detail>Credits will only be reflected once payment is approved.</div></div><button class=\"credit-plan-payment-wire-transfer__hint-btn btn btn--transparent text--color-pixerf-theme\" ng-click=vm.onSubmitClicked()>OK</button></div></div>");
$templateCache.put("app/components/earnings/photos-sold/sold-details/sold-details.html","<div class=sold-details><div class=sold-details__back-btn ng-click=vm.onBackBtnClicked()><span class=icon-icons_chevron-left></span> <span>Back</span></div><div class=\"sold-details__header-wrapper clearfix\"><div class=sold-details__header-left><div class=\"sold-details__time-purchase text--bold\"><span>{{vm.item.media.length}}</span> <span>photos</span> sold on <span>{{vm.item.purchasedDateFormatted}}</span></div><div>Order ID #{{vm.orderId}}</div></div><button type=button class=\"sold-details__view-receipt-btn btn btn-submit--no-background text--bold\" ng-click=\"vm.onDownloadBtnClicked($event, vm.item, \'invoice\')\">{{\'invoice\' | translate}}</button> <a ng-attr-href={{vm.item.downloadLink}} target=_blank></a></div><div class=sold-details__content><div class=sold-details__item><purchase-sold-history-item class=sold-details__item-content type=\"\'sold\'\" item=vm.item></purchase-sold-history-item></div><scroll-paging spinner=vm.spinner></scroll-paging></div></div>");
$templateCache.put("app/components/earnings/photos-sold/sold-list/sold-list.html","<div class=sold-list infinite-scroll-disabled=vm.isLastPage infinite-scroll=vm.fetchMorePurchasedItems() infinite-scroll-immediate-check=false><div class=sold-list__content><!-- <div class=\"sold-list__content__label text--semibold text--color-black\">Sold History</div> --><div class=\"purchase-history__content__filter clearfix\"><div class=\"purchase-history__content__filter__from-wrapper clearfix\"><div class=\"purchase-history__content__filter__dropdown-custom-text clearfix\"><span class=\"purchase-history__text-filter-from text--bold text--color-black\">From</span><popover-selection-btn on-selection-changed=vm.onFilterChanged() popover-class=\"\'popover-purchase-history-filter-month\'\" class=\"purchase-history__dropdown-filter-btn dropdown-filter-month\" close-on-click=true selected-model=vm.selectedFilter.fromMonth settings=vm.filtersFromMonth></popover-selection-btn></div><popover-selection-btn on-selection-changed=vm.onFilterChanged() popover-class=\"\'popover-purchase-history-filter-year\'\" class=\"purchase-history__dropdown-filter-btn dropdown-filter-year\" close-on-click=true selected-model=vm.selectedFilter.fromYear settings=vm.filtersFromYear></popover-selection-btn></div><div class=\"purchase-history__content__filter__to-wrapper clearfix\"><div class=\"purchase-history__content__filter__dropdown-custom-text clearfix\"><span class=\"purchase-history__text-filter-to text--bold text--color-black\">To</span><popover-selection-btn on-selection-changed=vm.onFilterChanged() popover-class=\"\'popover-purchase-history-filter-month\'\" class=\"purchase-history__dropdown-filter-btn dropdown-filter-month\" close-on-click=true selected-model=vm.selectedFilter.toMonth settings=vm.filtersToMonth></popover-selection-btn></div><popover-selection-btn on-selection-changed=vm.onFilterChanged() popover-class=\"\'popover-purchase-history-filter-year\'\" class=\"purchase-history__dropdown-filter-btn dropdown-filter-year\" close-on-click=true selected-model=vm.selectedFilter.toYear settings=vm.filtersToYear></popover-selection-btn></div></div><!-- <div class=\"sold-list__content__filter clearfix\">\r\n			<div class=\"sold-list__content__filter__from-wrapper clearfix\">\r\n				<span class=\"sold-list__text-filter-from\">Filter from</span>\r\n				<div class=\"input-group pixerf-calendar-input sold-list__dropdown-filter-time\">\r\n					<input type=\"text\" name=\"from_date\" class=\"form-control\" datepicker-options=\"{minMode: \'month\'}\" datepicker-mode=\"\'month\'\" uib-datepicker-popup=\"MM/yyyy\" ng-model=\"vm.selectedFilter.fromTime\" is-open=\"vm.filterFromIsVisible\" close-text=\"Close\" alt-input-formats=\"altInputFormats\" placeholder=\"MM/YYYY\" />\r\n					<button type=\"button\" class=\"btn pixerf-calendar-input__toogle-btn\" ng-click=\"vm.filterFromIsVisible = !vm.filterFromIsVisible\"><i class=\"glyphicon glyphicon-calendar\"></i></button>\r\n				</div>\r\n			</div>\r\n			<div class=\"sold-list__content__filter__to-wrapper clearfix\">\r\n				<span class=\"sold-list__text-filter-to\">to</span>\r\n				<div class=\"input-group pixerf-calendar-input sold-list__dropdown-filter-time\">\r\n					<input type=\"text\" name=\"from_date\" class=\"form-control\" datepicker-options=\"{minMode: \'month\'}\" datepicker-mode=\"\'month\'\" uib-datepicker-popup=\"MM/yyyy\" ng-model=\"vm.selectedFilter.toTime\" is-open=\"vm.filterToIsVisible\" close-text=\"Close\" alt-input-formats=\"altInputFormats\" placeholder=\"MM/YYYY\" />\r\n					<button type=\"button\" class=\"btn pixerf-calendar-input__toogle-btn\" ng-click=\"vm.filterToIsVisible = !vm.filterToIsVisible\"><i class=\"glyphicon glyphicon-calendar\"></i></button>\r\n				</div>\r\n				<button class=\"sold-list__content__filter__search-btn btn btn-default\" ng-click=\"vm.onSearchFilterClick(vm.selectedFilter)\"><i class=\"icon-icons_search\"></i></button>\r\n			</div>\r\n		</div> --><div class=sold-list__content__count>{{\'you-have-sold\' | translate}} <span class=text--bold ng-bind=\"vm.items.length === 0 ? 0 : vm.totalMedia\"></span> <span ng-bind=\"vm.totalMedia === 1 ? \'photo\' : \'photos\'\"></span></div><div class=sold-list__table-wrapper><table class=sold-list__table><tr class=\"sold-list__table__header text--bold text--color-black\"><th class=\"sold-list__table__column sold-list__table__column-date\" ng-click=\"reverse = !reverse\">{{\'date\' | translate}} <span ng-class=\"{\'glyphicon glyphicon-triangle-bottom\': !reverse, \'glyphicon glyphicon-triangle-top\': reverse}\"></span></th><th class=\"sold-list__table__column sold-list__table__column-order\">{{\'order-no\' | translate}}</th><th class=\"sold-list__table__column sold-list__table__column-count\">{{\'no-of-photos\' | translate}}</th><th class=sold-list__table__column></th></tr><tr class=sold-list__table__row ng-repeat=\"item in vm.items | orderBy:purchasedDateFormatted:reverse\" ng-class=\"$index % 2 === 0 ? \'sold-list__table__row-even\' : \'sold-list__table__row-odd\'\"><td class=sold-list__table__column-date>{{item.purchasedDateFormatted}}</td><td class=text-center>{{item.id}}</td><td class=text-center>{{item.media.length}}</td><td class=\"sold-list__table__column-view-photos text--bold text--color-pixerf-theme\"><span ui-sref=\"setting.earnings.photos_sold.sold-details({orderId: item.id})\">View <span class=sold-list__table__view-photo-text>Photos</span></span></td></tr></table></div><div class=\"sold-list__content__items--no-records text-center text--semibold\" ng-show=\"vm.items.length === 0 && !vm.spinner.isVisible\">{{\'no-records-found\' | translate}}</div><scroll-paging spinner=vm.spinner show-message=\"vm.items.length > 0 && vm.searchParams.page > 1\" is-last-page=vm.isLastPage></scroll-paging></div></div>");
$templateCache.put("app/components/referral-program/components/referral-program-invite/referral-program-invite.html","<div class=\"referral-program-invite clearfix\" infinite-scroll-disabled=vm.isLastPage infinite-scroll=vm.fetchMoreEmails()><div class=referral-program-invite__wrapper><div class=\"referral-program-invite__header clearfix\"><div class=\"referral-program-invite__title text--bold text--color-black no-padding col-xs-12 col-md-8\"><div class=referral-program-invite__title__heading>Invite friends and you both can earn 10% more!</div></div><div class=\"referral-program-invite__subtitle no-padding col-xs-12 col-md-8\">Invite all your creative friends and earn 10% bonus from their photo sales for 12 months. They earn 10% more on thier payment too! <a ui-sref=referral-program class=\"text--bold text--color-pixerf-theme\" target=_blank>{{\'find-out-how\' | translate}}</a></div></div><div class=\"referral-program-invite__email clearfix\"><div class=\"referral-program-invite__email-input clearfix col-xs-12 col-md-8 no-padding\"><button ng-disabled=\"vm.invitees.length == 0\" class=\"btn btn-submit referral-program-invite__email-input__invite-btn text--bold\" ng-click=vm.onInviteClicked()>Send Invites</button><div class=referral-program-invite__email-input__control><tags-input on-tag-adding=\"vm.onValidateTag($tag, $event)\" add-on-space=true add-on-blur=true ng-model=vm.invitees placeholder=\"Email addresses, seperated by spacebar\" type=email tag-class=referral-tag class=form-control allowed-tags-pattern=^([a-zA-Z0-9_\\-\\.]+)@([a-zA-Z0-9_\\-\\.]+)\\.([a-zA-Z]{2,5})$></tags-input></div></div></div><div class=\"referral-program-invite__import clearfix\"><div class=\"referral-program-invite__email-icon-wrapper gmail-wrapper\" ng-click=vm.onGmailClicked()><div class=\"email-icon email-icon__gmail\"></div><div class=\"referral-program-invite__email-icon-wrapper__label text--color-black text--bold\">Invite your Gmail contacts</div></div><div class=\"referral-program-invite__email-icon-wrapper outlook-wrapper\" ng-click=vm.onOutlookClicked()><div class=\"email-icon email-icon__outlook\"></div><div class=\"referral-program-invite__email-icon-wrapper__label text--color-black text--bold\">Invite your Outlook contacts</div></div></div><div class=\"referral-program-invite__share-link clearfix\"><div class=\"referral-program-invite__share-link__title text--bold text--color-black\">Or share your unique referral link with them</div><div class=\"referral-program-invite__referral-link clearfix\"><input type=text ng-model=vm.referralLink readonly=readonly> <button ng-click=\"vm.copyToClipboard(vm.referralLink, \'Your link has been successfully copied\')\" class=\"text--bold text--color-pixerf-theme\">Copy</button></div><div class=\"referral-program-invite__share-link__icon-wrapper clearfix\"><div class=referral-program-invite__share-link__icon><a ng-href=\"{{\'https://wa.me/?text=Join Pixerf now: \' +  vm.referralLinkEncoded}}\"><div class=\"social-media-icon whatsapp-icon\"></div></a></div><div class=referral-program-invite__share-link__icon><a ng-click=vm.onFbMessengerClicked()><div class=\"social-media-icon messenger-icon\"></div></a></div><div class=referral-program-invite__share-link__icon><a ng-click=vm.onFbShareBtnClicked()><div class=\"social-media-icon facebook-icon\"></div></a></div></div></div><div class=\"referral-program-invite__invited-friends clearfix\"><div ng-hide=\"vm.friends.length == 0\" class=\"referral-program-invite__invited-friends__header clearfix\"><div class=\"referral-program-invite__invited-friends__title text--bold text--color-black\">You\'ve invited ({{vm.totalEmails}}) <span ng-bind=\"vm.totalEmails === 1 ? \'friend\' : \'friends\'\"></span></div><div class=referral-program-invite__invited-friends__check-referral-earning><a ui-sref=setting.referral_program.track class=\"text--bold text--color-pixerf-theme\">Check your referral earnings</a></div></div><h4 ng-show=\"vm.friends.length == 0\" class=\"text-center ng-hide\">You haven\'t invited any friends!</h4><div class=referral-program-invite__invited-friends__list ng-hide=\"vm.friends.length == 0\"><div class=\"referral-program-invite__invited-friends__list__header text--bold text--color-black clearfix\"><div class=\"referral-program-invite__invited-friends__list__header-col header-col-email col-xs-4\">Email</div><div class=\"referral-program-invite__invited-friends__list__header-col header-col-status col-xs-4\" ng-click=\"vm.sortBy(\'status\')\">Status<span ng-class=\"{\'glyphicon glyphicon-triangle-bottom\': !vm.reverse && vm.propertyName === \'status\', \'glyphicon glyphicon-triangle-top\': vm.reverse && vm.propertyName === \'status\'}\"></span></div><div class=\"referral-program-invite__invited-friends__list__header-col header-col-expire col-xs-4\" ng-click=\"vm.sortBy(\'expire\')\">Expiry Date<span ng-class=\"{\'glyphicon glyphicon-triangle-bottom\': !vm.reverse && vm.propertyName === \'expire\', \'glyphicon glyphicon-triangle-top\': vm.reverse && vm.propertyName === \'expire\'}\"></span></div></div><div class=\"referral-program-invite__invited-friends__item clearfix\" ng-repeat=\"friend in vm.friends | orderBy:vm.propertyName:vm.reverse\"><div class=\"referral-program-invite__invited-friends__item__email text--color-black text--bold col-xs-4 text--truncate\"><span tooltip-class=referral-invite-tooltip uib-tooltip=\"{{friend.email ? friend.email : friend}}\" tooltip-append-to-body=true>{{friend.email ? friend.email : friend}}</span></div><div ng-class=\"{\'text--color-good text--bold\': friend.status == \'signed_up\'}\" class=\"referral-program-invite__invited-friends__item__status col-xs-4 text--truncate\"><span tooltip-class=referral-invite-tooltip uib-tooltip={{friend.statusDisplay}} tooltip-append-to-body=true>{{friend.statusDisplay}}</span></div><div class=\"referral-program-invite__invited-friends__item__status col-xs-4 text--truncate\"><span tooltip-class=referral-invite-tooltip uib-tooltip={{friend.expire}} tooltip-append-to-body=true>{{friend.expire}}</span></div></div><scroll-paging spinner=vm.spinner is-last-page=vm.isLastPage></scroll-paging></div></div></div></div>");
$templateCache.put("app/components/referral-program/components/referral-program-track/referral-program-track.html","<div class=\"referral-program-track clearfix\"><div class=referral-program-track__wrapper><!-- <div class=\"referral-program-track__header clearfix\">\r\n			<div class=\"referral-program-track__title text--bold text--color-black\">Donec faci</div>\r\n			<div class=\"referral-program-track__subtitle no-padding col-xs-10 col-sm-7\">Vestibulum rutrum quam vitae fringilla tincidunt. Suspendisse nec tortor urna. Ut laoreet sodales nisi, qu.</div>\r\n		</div> --><div class=\"referral-program-track__earning clearfix\"><div class=\"referral-program-track__earning__col-left col-sm-7 col-xs-12\"><div class=\"referral-program-track__earning__col-left__title text--bold text--color-black\">Referral Earnings</div><div class=\"referral-program-track__earning__col-left__time text--bold text--color-black\">as of {{vm.today}}</div><div class=referral-program-track__earning__col-left__description>This is how much you\'ve earned through your referral network and their licensed photos. Refer more of your friends and watch your earnings grow!</div></div><div class=\"referral-program-track__earning__col-right col-sm-5 col-xs-12\"><div class=\"referral-program-track__earning__col-right__money text--color-black\">SGD <span class=text--bold>{{vm.earnings.total_earning_from_referrals ? (vm.earnings.total_earning_from_referrals | number:2) : 0}}</span></div><button ui-sref=setting.earnings.payout_method class=\"referral-program-track__earning__col-right__withdraw-btn btn btn-submit text--bold\">Request Payout</button></div></div></div></div>");
$templateCache.put("app/custom-commissions-detail-page/components/custom-commissions-detail-page-approval/confirm-approval/custom-commissions-approval-confirm-approval.html","<div class=custom-commissions-approval-confirm-approval><div class=custom-commissions-approval-confirm-approval__content><div class=custom-commissions-approval-confirm-approval__tab><div class=custom-commissions-approval-confirm-approval__tab__item ng-class=\"{\'actived\': vm.currentTab === vm.tabs[0]}\" ng-click=vm.onTabClicked(vm.tabs[0]) ng-if=vm.isManager>{{\'approved\' | translate}}</div><div class=custom-commissions-approval-confirm-approval__tab__item ng-class=\"{\'actived\': vm.currentTab === vm.tabs[1]}\" ng-click=vm.onTabClicked(vm.tabs[1])>{{\'comments\' | translate}}</div></div><div class=custom-commissions-approval-confirm-approval__tab-content><div class=custom-commissions-approval-confirm-approval__tab-content__approved ng-if=\"vm.currentTab === vm.tabs[0]\"><div class=custom-commissions-approval-confirm-approval__tab-content__header><div class=custom-commissions-approval-confirm-approval__tab-content__header__left-info><span class=custom-commissions-approval-confirm-approval__tab-content__header__number>{{vm.shoot.stats.selected_submission_count}}/{{vm.shoot.required_selection_quantity}}</span> <span class=custom-commissions-approval-confirm-approval__tab-content__header__text translate>{{\'approved\'}}</span></div></div><div class=custom-commissions-approval-confirm-approval__tab-content__photo-grid><custom-commissions-square-tile shoot=vm.shoot ng-repeat=\"item in vm.approvedList\" item=item options=vm.customCommissionsTileOptions list=vm.approvedList on-selected=vm.dataSelected(data) on-deselected=vm.dataDeselected(data)></custom-commissions-square-tile></div><div class=custom-commissions-approval-confirm-approval__tab-content__footer><button class=\"btn custom-commissions-approval-confirm-approval__tab-content__footer__confirm-btn\" ng-class=\"vm.isDownloadRequested ? \'btn-cancel--no-background\' : \' btn-submit\'\" ng-disabled=\"vm.isDisableConfirmApproval || vm.isDownloadRequested\" ng-click=vm.onConfirmApprovalClicked()>{{ vm.isDownloadRequested ? (\'approval-submitted\' | translate) : (\'confirm-approval\' | translate)}}</button></div></div><div class=\"custom-commissions-approval-confirm-approval__tab-content__comments clearfix\" ng-if=\"vm.currentTab === vm.tabs[1]\"><div class=custom-commissions-approval-confirm-approval__tab-content__header><div class=custom-commissions-approval-confirm-approval__tab-content__header__left-info><span class=custom-commissions-approval-confirm-approval__tab-content__header__number>{{vm.commentList.length}}</span> <span class=custom-commissions-approval-confirm-approval__tab-content__header__text translate>{{\'comments\'}}</span></div></div><div class=custom-commissions-approval-confirm-approval__tab-content__comment-grid><brand-comment-photo-tile ng-repeat=\"item in vm.commentList\" item=item on-item-removed=vm.onCommentRemoved(item) submission-id=\"\" shoot-id=vm.shoot.id options=vm.commentOptions></brand-comment-photo-tile></div></div></div></div></div>");
$templateCache.put("app/custom-commissions-detail-page/components/custom-commissions-detail-page-approval/main-content/custom-commissions-approval-main-content.html","<div class=custom-commissions-approval-main-content><div class=custom-commissions-approval-main-content__header><div class=custom-commissions-approval-main-content__header__wrapper><div ng-if=\"vm.customCommissions.selection_mode === vm.customCommissionsConst.MODE.PER_SHOOT\" class=custom-commissions-approval-main-content__header__name>{{vm.shoot.name}}</div><div ng-if=\"vm.customCommissions.selection_mode === vm.customCommissionsConst.MODE.ACROSS_CC\" class=custom-commissions-approval-main-content__header__cross-name><div ng-if=vm.shoot.name class=custom-commissions-approval-main-content__header__cross-view-name>You are currently viewing images from <span class=text--color-pixerf-theme>{{vm.shoot.name}}</span>.</div><div ng-if=!vm.shoot.name class=custom-commissions-approval-main-content__header__cross-view-image>You are currently viewing all <span class=text--color-pixerf-theme>{{vm.customCommissions.total_submission_count}}</span> images.</div><div>You may select up to <span class=text--bold>{{vm.customCommissions.required_selection_quantity}}</span> images across all shoots.</div></div><div class=custom-commissions-detail-page__upload-btn ng-if=!vm.isManager><button class=\"btn btn-submit\" ng-click=vm.onUploadPhotoClicked()>{{\'upload\' | translate}}</button></div></div><div class=\"custom-commissions-approval-main-content__header__sub-info clearfix\"><div class=custom-commissions-approval-main-content__header__sub-info__progress ng-if=\"vm.shoot.required_selection_quantity && vm.customCommissions.selection_mode === vm.customCommissionsConst.MODE.PER_SHOOT\"><span class=custom-commissions-approval-main-content__header__sub-info__progress__current>{{vm.shoot.stats.selected_submission_count}}/{{vm.shoot.required_selection_quantity}}</span> <span class=custom-commissions-approval-main-content__header__sub-info__progress__description translate translate-values=\"{something: (\'photos\' | translate)}\">{{\'something-approved\'}}</span></div><div class=custom-commissions-approval-main-content__header__sub-info__progress ng-if=\"vm.customCommissions.selection_mode === vm.customCommissionsConst.MODE.ACROSS_CC\"><span class=custom-commissions-approval-main-content__header__sub-info__progress__current>{{vm.customCommissions.total_selected_submission_count}}/{{vm.customCommissions.required_selection_quantity}}</span> <span class=custom-commissions-approval-main-content__header__sub-info__progress__description>total images selected</span></div><div class=custom-commissions-approval-main-content__header__sub-info__select-all ng-click=vm.decideSelecteOrDeselectAll() ng-if=\"(vm.items.length && vm.isManager) && (vm.shoot.required_selection_quantity >= vm.shoot.stats.uploaded_lowres_count) && vm.customCommissionsTileOptions.canSelect\" translate>{{vm.selectAllBtn}}</div><div class=custom-commissions-approval-main-content__header__sub-info__control-header><div class=custom-commissions-approval-main-content__header__sub-info__arrange><span class=custom-commissions-approval-main-content__header__sub-info__arrange__label>{{\'arrange-by\' | translate}}:</span><ul class=custom-commissions-approval-main-content__header__sub-info__arrange__input><li class=custom-commissions-approval-main-content__header__sub-info__arrange__label><popover-selection-btn close-on-click=true on-selection-changed=vm.onArrageChanged(item) selected-model=vm.arrange settings=vm.arrangeOptions></popover-selection-btn></li></ul></div><div class=custom-commissions-approval-main-content__header__sub-info__download ng-if=\"vm.items.length && vm.isManager\"><div ng-if=vm.items.length class=custom-commissions-approval-main-content__header__sub-info__download__download-all-btn ng-click=vm.onDownloadAllClicked() ng-disabled=\"vm.isDownloading || !vm.isLastPage\">Download all images ({{vm.shoot.stats.selected_submission_count || vm.items.length}})</div><div ng-if=vm.items.length class=custom-commissions-approval-main-content__header__sub-info__download__download-pdf-btn ng-click=vm.onDownloadPdfClicked() ng-disabled=!vm.isLastPage>Download PDF ({{vm.shoot.stats.selected_submission_count || vm.items.length}})</div></div></div></div></div><div class=custom-commissions-approval-main-content__photo-grid><custom-commissions-square-tile shoot=vm.shoot custom-commissions=vm.customCommissions ng-repeat=\"item in vm.items\" list=vm.items item=item on-changed=vm.dataChanged(data) on-selected=\"vm.dataSelected(data, event)\" on-deselected=vm.dataDeselected(data) on-deleted=vm.onSubmissionDeleted(data) options=vm.customCommissionsTileOptions></custom-commissions-square-tile><scroll-paging ng-if=vm.items.length spinner=vm.spinner show-message=true is-last-page=vm.isLastPage message=\"No more photos.\" hide-back-to-top=true></scroll-paging></div></div>");
$templateCache.put("app/custom-commissions-detail-page/components/custom-commissions-detail-page-approval/mission-approved-preview/mission-approved-preview.html","<div class=mission-approved-preview ng-class=\"{\'margin-top--1\': isScreenMobile}\"><div class=mission-approved-preview__header><div class=mission-approved-preview__header__title><span class=\"mission-approved-preview__header__download-file-label text--bold\">{{\'download-file-in\' | translate}}</span> <button type=button class=mission-approved-preview__close-btn ng-click=vm.closePopup()><span class=\"icon-icons_close text--color-black\" aria-hidden=true></span></button></div><div class=mission-approved-preview__header__download-select><div class=mission-approved-preview__header__download-select-items><div class=\"clearfix mission-approved-preview__header__download-select-item text--bold\" ng-class=\"{\'mission-approved-preview__header__download-select-item--selected\' : downloadSize.isSelected }\" ng-repeat=\"downloadSize in vm.downloadSizeItem\" ng-click=\"vm.onDownloadSizeItemClicked($event, downloadSize)\">{{downloadSize.size}}</div></div><button class=\"mission-approved-preview__header__download-btn btn btn-submit\" ng-click=vm.onDowloadBtnClicked($event)>{{\'download\' | translate}}</button> <a ng-attr-href={{vm.downloadLink}} target=_blank></a></div></div><section class=mission-approved-preview__mission-detail><div class=mission-approved-preview__mission-detail__info><div class=\"mission-approved-preview__mission-detail__header text--extrabold\">{{\'Custom Photography Services for \' + vm.organizationName}}</div><div class=\"mission-approved-preview__mission-detail__client text--semibold\">Client: {{vm.organizationName}}</div><div class=\"mission-approved-preview__mission-detail__date text--semibold\">{{\'date-of-shoot\' | translate }}: {{vm.data.shoot.start_date | date:\'dd MMMM yyyy\'}}</div></div><div class=mission-approved-preview__mission-detail__pixerf-logo></div><div class=\"mission-approved-preview__mission-detail__path text--semibold\"><span>{{\'ongoing-custom-commissions\' | translate}} ></span> <span>{{\' \' + vm.data.customCommissions.name + \' \'}}> </span><span>{{\' \' + vm.data.shoot.name}}</span></div></section><section class=mission-approved-preview__images><div ng-repeat=\"item in vm.bindingData.items\" class=\"mission-approved-preview__images-item col-xs-{{vm.bindingData.col}} size-{{vm.selectedSize.size}}\"><div class=\"mission-approved-preview__images-item-media size-{{vm.selectedSize.size}}\"><img ng-src=\"{{item.media.thumbnails[\'x400\']}}\" alt={{item.media.title}}></div><span class=mission-approved-preview__images-item__name>{{item.media.title}}</span></div></section><div class=overlay ng-if=vm.isWorking><div class=\"validate-sign spinner\"><i class=\"fa fa-2x fa-spin fa-spinner\"></i></div></div><section class=mission-approved-preview__footer><span class=mission-approved-preview__footer-datetime>{{vm.footerDatetime}} </span><span class=mission-approved-preview__footer-paging>{{\'Page \' + vm.currentPage + \' of \' + vm.totalPage}}</span></section></div>");
$templateCache.put("app/custom-commissions-detail-page/components/custom-commissions-detail-page-approval/shoot-list/custom-commissions-approval-shoot-list.html","<div class=custom-commissions-approval-shoot-list><div ng-if=\"vm.customCommissions.selection_mode === vm.customCommissionsConst.MODE.PER_SHOOT\" class=custom-commissions-approval-shoot-list__headline__wrapper ng-class=\"{\'header-no-wrap\': vm.editShootLabel}\"><div ng-if=!vm.editShootLabel class=custom-commissions-approval-shoot-list__headline>{{vm.customCommissions.shoot_label_name}}</div><input ng-if=vm.editShootLabel type=text class=custom-commissions-approval-shoot-list__headline__input-edit-shoot-label ng-model=vm.shootLabelName><div ng-if=\"vm.isMine && !vm.editShootLabel\" class=\"custom-commissions-approval-shoot-list__headline__icon icon-icons_edit\" uib-tooltip=\"{{\'edit\' | translate}}\" ng-click=vm.onShootLabelEdit()></div><div ng-if=vm.editShootLabel class=custom-commissions-approval-shoot-list__headline__edit-control-wrapper><div class=\"custom-commissions-approval-shoot-list__headline__icon icon-icons_check\" uib-tooltip=\"{{\'accept\' | translate}}\" ng-click=vm.onAcceptShootLabelClicked()></div><div class=\"custom-commissions-approval-shoot-list__headline__icon icon-icons_close\" uib-tooltip=\"{{\'cancel\' | translate}}\" ng-click=vm.onCancelShootLabelClicked()></div></div></div><div ng-if=\"vm.customCommissions.selection_mode === vm.customCommissionsConst.MODE.ACROSS_CC\" class=custom-commissions-approval-shoot-list__headline__wrapper ng-click=\"vm.onShootClicked(null, true)\"><div class=custom-commissions-approval-shoot-list__headline__all ng-class=\"{\'actived\': vm.isSelectAll}\">All ({{vm.customCommissions.total_submission_count}} images)</div></div><div class=custom-commissions-approval-shoot-list__list><div class=custom-commissions-approval-shoot-list__scroll-wrapper><ul class=custom-commissions-approval-shoot-list__list__wrapper><li ng-repeat=\"item in vm.items\" class=custom-commissions-approval-shoot-list__list__item ng-class=\"{\'actived\': item.id === vm.customCommissionsDetailPageApprovalCtrl.selectedShoot.id}\" ng-click=vm.onShootClicked(item)><div class=custom-commissions-approval-shoot-list__list__item__name uib-tooltip={{item.name}}>{{item.name}}</div><div class=custom-commissions-approval-shoot-list__list__item__progress ng-class=\"{\'full-progress\': item.stats.selected_submission_count === item.required_selection_quantity, \'progressing\': item.stats.total_count}\" ng-if=item.required_selection_quantity><span class=custom-commissions-approval-shoot-list__list__item__progress__select>{{item.stats.uploaded_lowres_count}}</span> <span class=custom-commissions-approval-shoot-list__list__item__progress__short-list>/{{item.required_selection_quantity}}</span></div><div class=custom-commissions-approval-shoot-list__list__item__progress__comment-count ng-if=\"item.stats.comment_count > 0\"><div class=custom-commissions-approval-shoot-list__list__item__progress__comment-count__value>{{item.stats.comment_count}}</div></div><div class=custom-commissions-approval-shoot-list__list__item__new ng-if=\"item.stats.comment_count === 0\"><div class=custom-commissions-approval-shoot-list__list__item__new__dot ng-show=\"!item.is_viewed && item.stats.total_count > 0\" ng-if=vm.isManager></div></div></li></ul></div></div></div>");
$templateCache.put("app/custom-commissions-detail-page/components/custom-commissions-detail-page-delivery/main-content/custom-commissions-delivery-main-content.html","<div class=custom-commissions-delivery-main-content><div class=custom-commissions-delivery-main-content__header><div class=custom-commissions-delivery-main-content__header__wrapper><div class=custom-commissions-delivery-main-content__header__name>{{vm.shoot.name}}</div><div class=\"custom-commissions-delivery-main-content__header__sub-info clearfix\"><div class=custom-commissions-delivery-main-content__header__sub-info__progress><span class=custom-commissions-delivery-main-content__header__sub-info__progress__current>{{vm.isManager ? (vm.selectedItems.length + \'/\' + vm.shoot.required_selection_quantity) : vm.shoot.stats.uploaded_hires_count}}</span> <span class=custom-commissions-delivery-main-content__header__sub-info__progress__description>photos {{vm.isManager ? \'selected\' : \'uploaded\'}}</span></div><div ng-if=vm.isManager class=custom-commissions-delivery-main-content__header__sub-info__select-all ng-click=vm.decideSelecteOrDeselectAll() translate>{{vm.selectAllBtn}}</div></div></div><div class=custom-commissions-delivery-main-content__header__sub-info__download ng-if=vm.isManager><div ng-if=vm.selectedItems.length class=\"custom-commissions-delivery-main-content__header__sub-info__download__download-selected-btn btn btn-cancel--no-background\" ng-click=vm.onDownloadPhotosClicked()>Download Selected</div><div ng-if=vm.shoot.stats.uploaded_hires_count class=\"custom-commissions-delivery-main-content__header__sub-info__download__download-all-btn btn btn-submit--transparent\" ng-click=vm.onDownloadAllClicked() ng-disabled=vm.isDownloading>Download All</div></div><div class=custom-commissions-detail-page__upload-btn ng-if=!vm.isManager><button class=\"btn btn-submit\" ng-click=vm.onUploadPhotoClicked()>{{\'upload\' | translate}}</button></div></div><div class=custom-commissions-delivery-main-content__photo-grid><custom-commissions-square-tile shoot=vm.shoot ng-repeat=\"item in vm.items\" list=vm.items item=item on-changed=vm.dataChanged(data) on-selected=vm.dataSelected(data) on-deselected=vm.dataDeselected(data) options=vm.customCommissionsTileOptions></custom-commissions-square-tile></div></div>");
$templateCache.put("app/custom-commissions-detail-page/components/custom-commissions-detail-page-delivery/shoot-list/custom-commissions-delivery-shoot-list.html","<div class=custom-commissions-delivery-shoot-list><div class=custom-commissions-delivery-shoot-list__headline__wrapper><div class=custom-commissions-delivery-shoot-list__headline>{{vm.customCommissions.shoot_label_name}}</div></div><!-- <div ng-if=\"vm.customCommissions.selection_mode === vm.customCommissionsConst.MODE.ACROSS_CC\"\r\n		class=\"custom-commissions-delivery-shoot-list__headline__wrapper\" ng-click=\"vm.onShootClicked(null, true)\">\r\n		<div class=\"custom-commissions-delivery-shoot-list__headline__all\" ng-class=\"{\'actived\': vm.isSelectAll}\">All</div>\r\n	</div> --><div class=custom-commissions-delivery-shoot-list__list><div class=custom-commissions-delivery-shoot-list__scroll-wrapper><ul class=custom-commissions-delivery-shoot-list__list__wrapper><li ng-repeat=\"item in vm.items\" class=custom-commissions-delivery-shoot-list__list__item ng-class=\"{\'actived\': item.id === vm.customCommissionsDetailPageDeliveryCtrl.selectedShoot.id}\" ng-click=vm.onShootClicked(item)><div class=custom-commissions-delivery-shoot-list__list__item__name uib-tooltip={{item.name}}>{{item.name}}</div><div class=custom-commissions-delivery-shoot-list__list__item__progress ng-class=\"{\'full-progress\': item.stats.uploaded_hires_count > (item.required_selection_quantity - 1), \'progressing\': item.stats.uploaded_hires_count > 0}\" ng-if=item.required_selection_quantity><span class=custom-commissions-delivery-shoot-list__list__item__progress__select>{{item.stats.uploaded_hires_count}}</span> <span class=custom-commissions-delivery-shoot-list__list__item__progress__short-list>/{{item.required_selection_quantity}}</span></div></li></ul></div></div></div>");
$templateCache.put("app/manage-photos/components/manage-photos-sold/manage-photos-sold-details/manage-photos-sold-details.html","<div class=manage-photos-sold-details><div class=manage-photos-sold-details__back-btn ng-click=vm.onBackBtnClicked()><span class=icon-icons_chevron-left></span> <span>Back</span></div><div class=\"manage-photos-sold-details__header-wrapper clearfix\"><div class=manage-photos-sold-details__header-left><div class=\"manage-photos-sold-details__time-purchase text--bold\"><span>{{vm.item.media.length}}</span> <span>photos</span> sold on <span>{{vm.item.purchasedDateFormatted}}</span></div><div>Order ID #{{vm.orderId}}</div></div><button type=button class=\"manage-photos-sold-details__view-receipt-btn btn btn-submit--no-background text--bold\" ng-click=\"vm.onDownloadBtnClicked($event, vm.item, \'invoice\')\">{{\'invoice\' | translate}}</button> <a ng-attr-href={{vm.item.downloadLink}} target=_blank></a></div><div class=manage-photos-sold-details__content><div class=manage-photos-sold-details__item><purchase-sold-history-item class=manage-photos-sold-details__item-content type=\"\'sold\'\" item=vm.item></purchase-sold-history-item></div><scroll-paging spinner=vm.spinner></scroll-paging></div></div>");
$templateCache.put("app/manage-photos/components/manage-photos-sold/manage-photos-sold-list/manage-photos-sold-list.html","<div class=manage-photos-sold-list__table-wrapper><table class=manage-photos-sold-list__table><tr class=\"manage-photos-sold-list__table__header text--bold text--color-black\"><th class=\"manage-photos-sold-list__table__column manage-photos-sold-list__table__column-date\" ng-click=\"reverse = !reverse\">Sold Date <span ng-class=\"{\'glyphicon glyphicon-triangle-bottom\': !reverse, \'glyphicon glyphicon-triangle-top\': reverse}\"></span></th><th class=\"manage-photos-sold-list__table__column manage-photos-sold-list__table__column-order\">{{\'order-no\' | translate}}</th><th class=\"manage-photos-sold-list__table__column manage-photos-sold-list__table__column-count\">No. of Photos</th><th class=manage-photos-sold-list__table__column></th></tr><tr class=manage-photos-sold-list__table__row ng-repeat=\"item in vm.items | orderBy:purchasedDateFormatted:reverse\" ng-class=\"$index % 2 === 0 ? \'manage-photos-sold-list__table__row-even\' : \'manage-photos-sold-list__table__row-odd\'\"><td class=manage-photos-sold-list__table__column-date>{{item.purchasedDateFormatted}}</td><td class=text-center>{{item.id}}</td><td class=text-center>{{item.media.length}}</td><td class=\"manage-photos-sold-list__table__column-view-photos text--bold text--color-pixerf-theme\"><span ui-sref=\"manage-photos.manage-photos-sold.sold-details({orderId: item.id})\">View <span class=manage-photos-sold-list__table__view-photo-text>Photos</span></span></td></tr></table></div>");
$templateCache.put("app/marketplace/components/marketplace-galleries/marketplace-curated-galleries/marketplace-curated-galleries.html","<section class=marketplace-curated-galleries><div class=marketplace-curated-galleries__grid><gallery-grid instance=vm.galleryGridAll on-scroll-to-gallery=vm.onScrollToGallery(page) on-load-more-page=vm.onLoadMorePage(page)></gallery-grid></div></section>");
$templateCache.put("app/marketplace/components/marketplace-galleries/marketplace-followed-galleries/marketplace-followed-galleries.html","<section class=marketplace-followed-galleries><div class=marketplace-followed-galleries__grid><gallery-grid instance=vm.galleryGridAll on-scroll-to-gallery=vm.onScrollToGallery(page) on-load-more-page=vm.onLoadMorePage(page)></gallery-grid></div></section>");
$templateCache.put("app/marketplace/components/marketplace-galleries/marketplace-pixerfer-galleries/marketplace-pixerfer-galleries.html","<section class=marketplace-pixerfer-galleries><div class=marketplace-pixerfer-galleries__grid><gallery-grid instance=vm.galleryGridAll on-scroll-to-gallery=vm.onScrollToGallery(page) on-load-more-page=vm.onLoadMorePage(page)></gallery-grid></div></section>");
$templateCache.put("app/marketplace/components/marketplace-galleries/marketplace-signature-galleries/marketplace-signature-galleries.html","<div class=marketplace-signature-galleries><div class=marketplace-signature-galleries__grid-wrapper><div ng-repeat=\"category in vm.categories\" ui-sref=\"signature-galleries-details-page({id: category.id, title: category.name})\" class=marketplace-signature-galleries__item-wrapper><div class=marketplace-signature-galleries__item><div class=\"marketplace-signature-galleries__item__background zoom-hover\" ng-style=\"{\'background-image\': \'url(\\\'\' + category.thumbnails[\'local\'] + \'\\\')\'}\"><div class=marketplace-signature-galleries__overlay></div></div><div class=marketplace-signature-galleries__item__name>{{category.name}}</div></div></div></div></div>");
$templateCache.put("app/mission-detail-page/components/awards/awards-public/awards-public.html","<section class=\"awards awards-public bg--white\"><div class=awards__content><div class=\"awards__content__title text--extrabold text--color-black\">{{\'congratulations\' | translate}}!</div><div class=awards__content__winner-congra ng-bind=\"vm.parent.mission.winners > 1 ? (\'the-winning-entries-in-this-mission-were-submitted-by\' | translate) : (\'the-winning-entry-in-this-mission-was-submitted-by\' | translate)\"></div><div ng-repeat=\"prize in vm.parent.mission.prizes_grouped[\'GRAND_WINNER\']\" class=\"awards__content__winner__wrapper clearfix\"><div class=awards__content__winner-photo-grid photo-fit-overlay><div class=awards__content__winner-photo ng-click=vm.onAwardedPhotoClicked(prize.winner.media)><img src=assets/images/spinner.gif alt=\"Winning Photo\" lazy-img-error=\'\"assets/images/icon-market.png\"\' lazy-img={{prize.winner.media.thumbnailX}}></div><div class=\"awards__content__winner-author cursor--pointer clearfix background-cover\" ng-click=vm.onAwardedPhotoClicked(prize.winner.media) ng-show=\"prize.winner && prize.winner.media && prize.winner.media.thumbnailX\"><div class=awards__content__winner-author__sign ng-click=$event.stopPropagation() ui-sref=\"user-home-page.personal.home({id: prize.winner.media.user.id, userName: (prize.winner.media.user.displayName | toSnakeCase)})\"><div class=awards__content__winner-author__table-cell><div class=awards__content__winner-logo><div class=\"awards__content__winner-ranking-award grand-prize icon-icons-badge-MGW\"></div><div class=awards__content__winner-title uib-tooltip={{vm.parent.mission.title}} tooltip-placement=right>{{ vm.parent.mission.id ==87 ? \'#Outside MyWindow\' : vm.parent.mission.title}}</div></div></div><div class=awards__content__winner-author__table-cell><div class=awards__content__winner-author__name uib-tooltip={{prize.winner.media.user.displayName}} tooltip-placement=right>{{vm.hyphen(prize.winner.media.user.displayName, 6)}}</div></div></div><div class=awards__content__winner-share-btn id=mission-share-navbar-collapse><share settings=\"{\'appendToBody\': true, \'flatMode\': true}\" display-vertical=true content-will-be-shared=\"{\'url\': vm.getCurrentUrl(), \'description\': vm.parent.description, \'title\': vm.parent.mission.title, \'media\': prize.winner.media.thumbnailX}\" title=\"Share this mission\"></share></div></div></div></div><div ng-repeat=\"prize in vm.parent.mission.prizes_grouped[\'WINNER\']\" class=\"awards__content__winner__wrapper clearfix\"><div class=awards__content__winner-photo-grid photo-fit-overlay><div class=awards__content__winner-photo ng-click=vm.onAwardedPhotoClicked(prize.winner.media)><img src=assets/images/spinner.gif alt=\"Winning Photo\" lazy-img-error=\'\"assets/images/icon-market.png\"\' lazy-img={{prize.winner.media.thumbnailX}}></div><div class=\"awards__content__winner-author cursor--pointer clearfix background-cover\" ng-click=vm.onAwardedPhotoClicked(prize.winner.media) ng-show=\"prize.winner && prize.winner.media && prize.winner.media.thumbnailX\"><div class=awards__content__winner-author__sign ng-click=$event.stopPropagation() ui-sref=\"user-home-page.personal.home({id: prize.winner.media.user.id, userName: (prize.winner.media.user.displayName | toSnakeCase)})\"><div class=awards__content__winner-author__table-cell><div class=awards__content__winner-logo><div class=awards__content__winner-ranking-award ng-class=\"vm.isRankingAward ? \'icon-mission-winner-1st\' : \'icon-icons-badge-M\'\"></div><div class=awards__content__winner-title uib-tooltip={{vm.parent.mission.title}} ng-class=\"vm.isRankingAward ? \'\' : \'text-align-upper\'\" tooltip-placement=right>{{ vm.parent.mission.id ==87 ? \'#Outside MyWindow\' : vm.parent.mission.title}}</div></div></div><div class=awards__content__winner-author__table-cell><div class=awards__content__winner-author__name uib-tooltip={{prize.winner.media.user.displayName}} tooltip-placement=right>{{vm.hyphen(prize.winner.media.user.displayName, 6)}}</div></div></div><div class=awards__content__winner-share-btn id=mission-share-navbar-collapse><share settings=\"{\'appendToBody\': true, \'flatMode\': true}\" display-vertical=true content-will-be-shared=\"{\'url\': vm.getCurrentUrl(), \'description\': vm.parent.description, \'title\': vm.parent.mission.title, \'media\': prize.winner.media.thumbnailX}\" title=\"Share this mission\"></share></div></div></div></div><div ng-repeat=\"prize in vm.parent.mission.prizes_grouped[\'RUNNER_UP_1\']\" class=\"awards__content__winner__wrapper clearfix\"><div class=awards__content__winner-photo-grid photo-fit-overlay><div class=awards__content__winner-photo ng-click=vm.onAwardedPhotoClicked(prize.winner.media)><img src=assets/images/spinner.gif alt=\"Winning Photo\" lazy-img-error=\'\"assets/images/icon-market.png\"\' lazy-img={{prize.winner.media.thumbnailX}}></div><div class=\"awards__content__winner-author cursor--pointer clearfix background-cover\" ng-click=vm.onAwardedPhotoClicked(prize.winner.media) ng-show=\"prize.winner && prize.winner.media && prize.winner.media.thumbnailX\"><div class=awards__content__winner-author__sign ng-click=$event.stopPropagation() ui-sref=\"user-home-page.personal.home({id: prize.winner.media.user.id, userName: (prize.winner.media.user.displayName | toSnakeCase)})\"><div class=awards__content__winner-author__table-cell><div class=awards__content__winner-logo><div class=awards__content__winner-ranking-award ng-class=\"vm.isRankingAward ? \'icon-mission-winner-2nd\' : \'icon-icons-badge-M\'\"></div><div class=awards__content__winner-title uib-tooltip={{vm.parent.mission.title}} ng-class=\"vm.isRankingAward ? \'\' : \'text-align-upper\'\" tooltip-placement=right>{{ vm.parent.mission.id ==87 ? \'#Outside MyWindow\' : vm.parent.mission.title}}</div></div></div><div class=awards__content__winner-author__table-cell><div class=awards__content__winner-author__name uib-tooltip={{prize.winner.media.user.displayName}} tooltip-placement=right>{{vm.hyphen(prize.winner.media.user.displayName, 6)}}</div></div></div><div class=awards__content__winner-share-btn id=mission-share-navbar-collapse><share settings=\"{\'appendToBody\': true, \'flatMode\': true}\" display-vertical=true content-will-be-shared=\"{\'url\': vm.getCurrentUrl(), \'description\': vm.parent.description, \'title\': vm.parent.mission.title, \'media\': prize.winner.media.thumbnailX}\" title=\"Share this mission\"></share></div></div></div></div><div ng-repeat=\"prize in vm.parent.mission.prizes_grouped[\'RUNNER_UP_2\']\" class=\"awards__content__winner__wrapper clearfix\"><div class=awards__content__winner-photo-grid photo-fit-overlay><div class=awards__content__winner-photo ng-click=vm.onAwardedPhotoClicked(prize.winner.media)><img src=assets/images/spinner.gif alt=\"Winning Photo\" lazy-img-error=\'\"assets/images/icon-market.png\"\' lazy-img={{prize.winner.media.thumbnailX}}></div><div class=\"awards__content__winner-author cursor--pointer clearfix background-cover\" ng-click=vm.onAwardedPhotoClicked(prize.winner.media) ng-show=\"prize.winner && prize.winner.media && prize.winner.media.thumbnailX\"><div class=awards__content__winner-author__sign ng-click=$event.stopPropagation() ui-sref=\"user-home-page.personal.home({id: prize.winner.media.user.id, userName: (prize.winner.media.user.displayName | toSnakeCase)})\"><div class=awards__content__winner-author__table-cell><div class=awards__content__winner-logo><div class=awards__content__winner-ranking-award ng-class=\"vm.isRankingAward ? \'icon-mission-winner-3rd\' : \'icon-icons-badge-M\'\"></div><div class=awards__content__winner-title uib-tooltip={{vm.parent.mission.title}} ng-class=\"vm.isRankingAward ? \'\' : \'text-align-upper\'\" tooltip-placement=right>{{ vm.parent.mission.id ==87 ? \'#Outside MyWindow\' : vm.parent.mission.title}}</div></div></div><div class=awards__content__winner-author__table-cell><div class=awards__content__winner-author__name uib-tooltip={{prize.winner.media.user.displayName}} tooltip-placement=right>{{vm.hyphen(prize.winner.media.user.displayName, 6)}}</div></div></div><div class=awards__content__winner-share-btn id=mission-share-navbar-collapse><share settings=\"{\'appendToBody\': true, \'flatMode\': true}\" display-vertical=true content-will-be-shared=\"{\'url\': vm.getCurrentUrl(), \'description\': vm.parent.description, \'title\': vm.parent.mission.title, \'media\': prize.winner.media.thumbnailX}\" title=\"Share this mission\"></share></div></div></div></div><div ng-show=\"vm.parent.mission.prizes_grouped[\'CONSOLATION\'].length > 0\" class=clearfix ng-class=\"{\'custom-mission-award-layout\': vm.isRankingAward}\"><div class=awards__content__winner-photo-consolation-grid photo-fit-overlay><div class=awards__content__winner-photo-consolation ng-repeat=\"prize in vm.parent.mission.prizes_grouped[\'CONSOLATION\']\" ng-class=\"{\'row-odd\': $odd, \'row-even\': $even}\" photo-fit-overlay><div class=awards__content__winner-consolation__photo ng-click=vm.onAwardedPhotoClicked(prize.winner.media)><img src=assets/images/spinner.gif alt=\"Winning Photo\" lazy-img-error=\'\"assets/images/icon-market.png\"\' lazy-img={{prize.winner.media.thumbnailX}}></div><div class=\"awards__content__winner-author cursor--pointer clearfix background-cover\" ng-click=vm.onAwardedPhotoClicked(prize.winner.media) ng-show=\"prize.winner && prize.winner.media && prize.winner.media.thumbnailX\"><div class=awards__content__winner-author__sign ng-click=$event.stopPropagation() ui-sref=\"user-home-page.personal.home({id: prize.winner.media.user.id, userName: (prize.winner.media.user.displayName | toSnakeCase)})\"><div class=awards__content__winner-author__table-cell><div class=awards__content__winner-logo><div class=awards__content__winner-ranking-award ng-class=\"{\'icon-icons-badge-M\': vm.isRankingAward, \'icon-icons-badge-MC\': !vm.isRankingAward}\"></div><div class=awards__content__winner-title uib-tooltip={{vm.parent.mission.title}} ng-class=\"vm.isRankingAward ? \'text-align-upper\' :  \'\'\" tooltip-placement=right>{{ vm.parent.mission.id ==87 ? \'#Outside MyWindow\' : vm.parent.mission.title}}</div></div></div><div class=awards__content__winner-author__table-cell><div class=awards__content__winner-author__name uib-tooltip={{prize.winner.media.user.displayName}} tooltip-placement=right>{{vm.hyphen(prize.winner.media.user.displayName, 6)}}</div></div></div><div class=awards__content__winner-share-btn id=mission-share-navbar-collapse><share settings=\"{\'appendToBody\': true, \'flatMode\': true}\" display-vertical=true content-will-be-shared=\"{\'url\': vm.getCurrentUrl(), \'description\': vm.getMissionDescription(), \'title\': vm.parent.mission.title, \'media\': prize.winner.media.thumbnailX}\" title=\"Share this mission\"></share></div></div></div></div></div><div ng-show=\"vm.parent.mission.prizes_grouped[\'SPECIAL_MENTION\'].length > 0\" class=clearfix ng-class=\"{\'custom-mission-award-layout\': vm.isRankingAward}\"><div class=awards__content__winner-photo-consolation-grid photo-fit-overlay><div class=awards__content__winner-photo-consolation ng-repeat=\"prize in vm.parent.mission.prizes_grouped[\'SPECIAL_MENTION\']\" ng-class=\"{\'row-odd\': $odd, \'row-even\': $even}\" photo-fit-overlay><div class=awards__content__winner-consolation__photo ng-click=vm.onAwardedPhotoClicked(prize.winner.media)><img src=assets/images/spinner.gif alt=\"Winning Photo\" lazy-img-error=\'\"assets/images/icon-market.png\"\' lazy-img={{prize.winner.media.thumbnailX}}></div><div class=\"awards__content__winner-author cursor--pointer clearfix background-cover\" ng-click=vm.onAwardedPhotoClicked(prize.winner.media) ng-show=\"prize.winner && prize.winner.media && prize.winner.media.thumbnailX\"><div class=awards__content__winner-author__sign ng-click=$event.stopPropagation() ui-sref=\"user-home-page.personal.home({id: prize.winner.media.user.id, userName: (prize.winner.media.user.displayName | toSnakeCase)})\"><div class=awards__content__winner-author__table-cell><div class=awards__content__winner-logo><div class=awards__content__winner-ranking-award ng-class=\"{\'icon-icons-badge-M\': vm.isRankingAward, \'icon-icons-badge-MC\': !vm.isRankingAward}\"></div><div class=awards__content__winner-title uib-tooltip={{vm.parent.mission.title}} ng-class=\"vm.isRankingAward ? \'text-align-upper\' :  \'\'\" tooltip-placement=right>{{ vm.parent.mission.id ==87 ? \'#Outside MyWindow\' : vm.parent.mission.title}}</div></div></div><div class=awards__content__winner-author__table-cell><div class=awards__content__winner-author__name uib-tooltip={{prize.winner.media.user.displayName}} tooltip-placement=right>{{vm.hyphen(prize.winner.media.user.displayName, 6)}}</div></div></div><div class=awards__content__winner-share-btn id=mission-share-navbar-collapse><share settings=\"{\'appendToBody\': true, \'flatMode\': true}\" display-vertical=true content-will-be-shared=\"{\'url\': vm.getCurrentUrl(), \'description\': vm.getMissionDescription(), \'title\': vm.parent.mission.title, \'media\': prize.winner.media.thumbnailX}\" title=\"Share this mission\"></share></div></div></div></div></div></div></section>");
$templateCache.put("app/mission-detail-page/components/awards/awards-selection/awards-selection.html","<section class=\"awards awards-selection bg--white\"><div class=awards__content><div class=\"awards__content__title text--semibold text--color-black\">Congratulations on a successful Mission!</div><div class=awards__content__description><div class=\"text--bold awards__content__sub-description\">It\'s now time to select your winners.</div><div class=awards__content__note-text>Mission Winning Submissions will be exclusive to you for 60 days starting from your Mission end date, after which it will move to the Marketplace for others to license.</div><div class=awards__content__sub-note-text>You can also license additional images, known as Special Mentions, for SGD 50 each at the largest size available.</div><div class=\"text--bold awards__content__hint\">Remember to complete all your selections within 30 days from your Mission end date!</div></div><div ng-if=\"vm.parent.mission.prizes_grouped[\'GRAND_WINNER\']\"><div class=\"awards__content__winner-logo icon-icons-badge-MGW\"></div><div class=\"awards__content__winner-select-text text--bold\">Selected Mission Grand Winners</div><div class=\"awards__content__winner-photo-grid clearfix\"><div title=\"Select grand winner(s)\" class=\"cursor--pointer awards__content__winner-photo awards__content__winner-photo__selection text--color-pixerf-theme text--bold clearfix\" ui-sref=mission-detail-page.submissions ng-hide=\"vm.isAllPrizeAwared(vm.parent.mission.prizes_grouped, \'GRAND_WINNER\')\"><span class=icon-icons_plus></span> <span class=awards__content__winner-photo__selection-text>Select</span></div><div class=awards__content__winner-photo ng-repeat=\"prize in vm.parent.mission.prizes_grouped[\'GRAND_WINNER\'] | filter:vm.filterAwardedPrize\"><img ng-src={{prize.winner.media.urlSmall}} alt=\"\" ng-click=vm.onAwardedPhotoClicked(prize.winner.media)><div class=\"clearfix absolute awards__content__winner-bottom-control\"><span ng-show=\"vm.mission.prizes_grouped[\'GRAND_WINNER\'].length > 1\" class=\"pull-left text--bold\">Grand Winner #{{$index+1}}</span> <span ng-click=vm.onWinnerRemovedBtnClicked(prize) class=\"pull-right text--color-pixerf-theme text--semibold\" role=button><span class=\"icon-icons_close awards__content__winner-bottom-control-icon\"></span> Remove</span></div></div></div></div><div><div class=\"awards__content__winner-logo icon-icons-badge-M\"></div><div class=\"awards__content__winner-select-text text--bold\">Selected Mission Winners</div><div class=\"awards__content__winner-photo-grid clearfix\"><div title=\"Select winner(s)\" class=\"cursor--pointer awards__content__winner-photo awards__content__winner-photo__selection text--color-pixerf-theme text--bold clearfix\" ui-sref=mission-detail-page.submissions ng-hide=\"vm.isAllPrizeAwared(vm.parent.mission.prizes_grouped, \'WINNER\')\"><span class=icon-icons_plus></span> <span class=awards__content__winner-photo__selection-text>Select</span></div><div class=awards__content__winner-photo ng-repeat=\"prize in vm.parent.mission.prizes_grouped[\'WINNER\'] | filter:vm.filterAwardedPrize\"><img ng-src={{prize.winner.media.urlSmall}} alt=\"\" ng-click=vm.onAwardedPhotoClicked(prize.winner.media)><div class=\"clearfix absolute awards__content__winner-bottom-control\"><span ng-show=\"vm.mission.prizes_grouped[\'WINNER\'].length > 1\" class=\"pull-left text--bold\">Winner #{{$index+1}}</span> <span ng-click=vm.onWinnerRemovedBtnClicked(prize) class=\"pull-right text--color-pixerf-theme text--semibold\" role=button><span class=\"icon-icons_close awards__content__winner-bottom-control-icon\"></span> Remove</span></div></div></div></div><div ng-show=\"vm.parent.mission.prizes_grouped[\'CONSOLATION\'].length  > 0\"><div class=\"awards__content__winner-consolation-logo icon-icons-badge-MC\"></div><div class=\"awards__content__winner-select-text text--bold\">Selected Special Mention Prizes</div><div class=\"awards__content__winner-photo-consolation-grid clearfix\"><div title=\"Select Special Mention(s)\" class=\"cursor--pointer awards__content__winner-photo-consolation awards__content__winner-photo-consolation__selection text--color-pixerf-theme text--bold clearfix\" ng-hide=\"vm.isAllPrizeAwared(vm.parent.mission.prizes_grouped, \'CONSOLATION\')\" ui-sref=mission-detail-page.submissions><span class=icon-icons_plus></span> <span class=awards__content__winner-photo-consolation__selection-text>Select</span></div><div class=awards__content__winner-photo-consolation ng-repeat=\"prize in vm.parent.mission.prizes_grouped[\'CONSOLATION\'] | filter:vm.filterAwardedPrize\"><img ng-click=vm.onAwardedPhotoClicked(prize.winner.media) ng-src={{prize.winner.media.urlSmall}} alt=\"\"><div class=\"clearfix absolute awards__content__winner-bottom-control\"><span ng-click=vm.onWinnerRemovedBtnClicked(prize) class=\"pull-right text--color-pixerf-theme text--semibold\" role=button><span class=\"icon-icons_close awards__content__winner-bottom-control-icon\"></span> Remove</span></div></div></div></div><button ng-disabled=vm.isWorking class=\"btn btn-submit text--bold awards__content__publish-btn\" ng-click=vm.onPublishWinnerBtnClicked()>Publish Winners</button></div></section>");
$templateCache.put("app/user-home-page/components/Institution/Institution-profile/Institution-profile.html","<section class=Institution-profile><div class=\"user-home-page__content Institution-profile__content\"><div ui-view=sidebarInstitution></div><div class=user-home-page__inner-main-content ui-view=mainInstitution></div></div></section>");
$templateCache.put("app/user-home-page/components/Institution/sidebar-Institution-profile/sidebar-Institution-profile.html","<section class=sidebar-institution-profile>this is sidebar Institution</section>");
$templateCache.put("app/user-home-page/components/communities/user-profile-communities/user-profile-communities.html","<section class=user-profile-communities><div class=user-profile-communities__container><div ui-view=sidebarCommunities class=user-profile-communities__sidebar-left></div><div class=user-profile-communities__main-content><user-profile-navigation user=vm.user context={{vm.contextPage}}></user-profile-navigation><div class=user-profile-communities__inner-main-content ui-view=mainCommunities></div></div></div></section>");
$templateCache.put("app/user-home-page/components/business/business-profile/business-profile.html","<section class=business-profile><div class=business-profile__container><div ui-view=sidebarBusiness class=business-profile__sidebar-left></div><div class=business-profile__main-content><user-profile-navigation user=vm.user context={{vm.contextPage}} options=vm.options></user-profile-navigation><div class=business-profile__inner-main-content ui-view=mainBusiness></div></div></div></section>");
$templateCache.put("app/user-home-page/components/business/sidebar-business-profile/sidebar-business-profile.html","<section class=sidebar-business-profile scroll-to-fixed=vm.sidebarScrollToFixed scroll-to-fixed-when=vm.scrollToFixedWhen><div class=sidebar-business-profile__brief><div ng-if=vm.isMyProfile class=sidebar-business-profile__description><div ng-if=\"vm.user.bio || (vm.isMyProfile && vm.user.isBiz) || vm.user.organization.description\" class=\"sidebar-business-profile__description-label text--extrabold\" translate>{{\'about\'}}</div><div ng-if=\"vm.user.bio || vm.user.organization.description\" class=sidebar-business-profile__description-text>{{(vm.user && vm.user.organization) ? vm.user.organization.description : vm.user.bio}}</div></div></div><div class=user-home-page__sidebar__commission ng-if=\"vm.isMyProfile && vm.user.canManageCustomCommissions\"><shortcut user=vm.user data=vm.shortcutCustomCommission on-button-clicked=vm.onRunCustomCommissionClicked()></shortcut></div><div class=user-home-page__sidebar__mission ng-if=\"vm.isMyProfile && vm.user.canManageMission\"><shortcut user=vm.user data=vm.shortcutMission on-button-clicked=vm.onRunMissionClicked()></shortcut></div><div class=user-home-page__sidebar__buy-stock ng-if=vm.isMyProfile><shortcut user=vm.user data=vm.shortcutStock on-button-clicked=vm.onBuyStock()></shortcut></div><div class=user-home-page__sidebar__community ng-if=\"vm.isMyProfile &&  vm.user.canManageCommunity\"><shortcut user=vm.user data=vm.shortcutCommunity on-button-clicked=vm.onCreateCommunity()></shortcut></div><div class=user-home-page__sidebar__mission ng-if=\"vm.user.canManageMission && vm.missions.length > 0\"><div class=user-home-page__sidebar__mission__header><div class=\"user-home-page__sidebar__mission__header__label pull-left text--bold text--color-black\" translate>{{\'ongoing-missions\'}}</div><a ng-if=vm.isMyProfile ui-sref=setting.manage-missions.on-going class=\"user-home-page__sidebar__mission__header__label text--color-pixerf-theme text--bold\" translate>{{\'see-all\'}}</a> <a ng-if=!vm.isMyProfile ui-sref=run-a-challenge-page.live-challenges class=\"user-home-page__sidebar__mission__header__label text--color-pixerf-theme text--bold\" translate>{{\'see-all\'}}</a></div><div ng-repeat=\"mission in vm.missions\" class=mission-grid__mission-wrapper><mission-gallery mission=mission hide-footer=true></mission-gallery></div></div><div class=user-home-page__sidebar__commission ng-if=\"vm.isMyProfile && vm.customCommissions.length > 0\"><div class=user-home-page__sidebar__commission__title>Ongoing Custom Content Assignments</div><div><custom-commissions-public-tile data=item ng-repeat=\"item in vm.customCommissions\"></custom-commissions-public-tile></div></div></section>");
$templateCache.put("app/user-home-page/components/guest/sidebar-guest-profile/sidebar-guest-profile.html","<section class=sidebar-guest-profile scroll-to-fixed=vm.sidebarScrollToFixed scroll-to-fixed-when=vm.scrollToFixedWhen><div class=sidebar-guest-profile__brief><div ng-if=\"vm.user.canBeFollowed || vm.user.canFollow || vm.user.canUploadPhotos\" class=sidebar-guest-profile__user-interact><div ng-if=vm.user.canUploadPhotos class=sidebar-guest-profile__photos><div class=sidebar-guest-profile__photos__number>{{vm.user.stats.media_count}}</div><div class=sidebar-guest-profile__photos__text>{{ vm.user.stats.media_count, plural, =1 {{{\'photo\' | translate}}} other {{{\'photos\' | translate}}} }}</div></div><div ng-if=vm.user.canBeFollowed class=sidebar-guest-profile__followers ng-click=vm.onFollowersBtnClicked()><div class=sidebar-guest-profile__followers__number>{{vm.user.stats.follower_count}}</div><div class=sidebar-guest-profile__followers__text>{{ vm.user.stats.follower_count, plural, =1 {{{\'follower\' | translate}}} other {{{\'followers\' | translate}}} }}</div></div><div ng-if=vm.user.canFollow class=sidebar-guest-profile__following ng-click=vm.onFollowingsBtnClicked()><div class=sidebar-guest-profile__following__number>{{vm.user.stats.following_count}}</div><div class=sidebar-guest-profile__following__text>{{\'following\' | translate}}</div></div></div><div ng-if=vm.isMyProfile class=sidebar-guest-profile__description><div ng-if=vm.user.bio class=\"sidebar-guest-profile__description-label text--bold\" translate>{{\'about\'}}</div><div ng-if=vm.user.bio class=sidebar-guest-profile__description-text>{{vm.user.bio}}</div></div></div><div class=sidebar-guest-profile__service-rates ng-if=vm.user.profile><div class=sidebar-guest-profile__service-rates__desc-wrapper ng-if=\"vm.user.profile && vm.user.profile.services_rate_amount != null && vm.user.profile.services_rate_type\"><div class=\"sidebar-guest-profile__service-rates__desc-header clearfix\"><div class=\"sidebar-guest-profile__service-rates__title text--bold text--color-black\">{{vm.user.profile.services_rate_type}}</div></div><div class=sidebar-guest-profile__service-rates__description>SGD <span class=\"rate-amount text--bold\">{{vm.user.profile.services_rate_amount}}</span></div></div><div class=sidebar-guest-profile__service-rates__desc-wrapper ng-if=\"vm.user.profile && vm.user.profile.years_of_experience != null\"><div class=\"sidebar-guest-profile__service-rates__desc-header clearfix\"><div class=\"sidebar-guest-profile__service-rates__title text--bold text--color-black\">{{\'years-of-experience\' | translate}}</div></div><div class=sidebar-guest-profile__service-rates__description ng-bind=\"vm.serviceData.years_of_experience == \'1\' ? vm.serviceData.years_of_experience + \' year\' : vm.serviceData.years_of_experience + \' years\'\"></div></div><div class=sidebar-guest-profile__service-rates__desc-wrapper ng-if=\"vm.user.profile && (vm.user.profile.availability_weekdays || vm.user.profile.availability_weekends) && (vm.user.profile.availability_weekdays.length || vm.user.profile.availability_weekends.length)\"><div class=\"sidebar-guest-profile__service-rates__desc-header clearfix\"><div class=\"sidebar-guest-profile__service-rates__title text--bold text--color-black\">{{\'availabilties\' | translate}}</div></div><div class=sidebar-guest-profile__service-rates__description ng-if=vm.serviceData.availability_weekdays>{{\'weekdays\' | translate}}: {{vm.serviceData.availability_weekdays | translate}}</div><div class=sidebar-guest-profile__service-rates__description ng-if=vm.serviceData.availability_weekends>{{\'weekends\' | translate}}: {{vm.serviceData.availability_weekends | translate}}</div></div><div class=sidebar-guest-profile__service-rates__desc-wrapper ng-if=\"vm.user.profile && vm.user.profile.cameras && vm.user.profile.cameras.length\"><div class=\"sidebar-guest-profile__service-rates__desc-header clearfix\"><div class=\"sidebar-guest-profile__service-rates__title text--bold text--color-black\">{{\'camera\' | translate}}</div></div><div class=sidebar-guest-profile__service-rates__description>{{vm.serviceData.cameras}}</div></div><div class=sidebar-guest-profile__service-rates__desc-wrapper ng-if=\"vm.user.profile && vm.user.profile.specialities && vm.user.profile.specialities.length\"><div class=\"sidebar-guest-profile__service-rates__desc-header clearfix\"><div class=\"sidebar-guest-profile__service-rates__title text--bold text--color-black\">{{\'photography-specialities\' | translate}}</div></div><div class=sidebar-guest-profile__service-rates__description>{{vm.serviceData.specialities}}</div></div></div></section>");
$templateCache.put("app/user-home-page/components/guest/guest-profile/guest-profile.html","<section class=guest-profile><div class=guest-profile__container><div ui-view=sidebarPersonal class=guest-profile__sidebar-left></div><div class=guest-profile__main-content><user-profile-navigation user=vm.user context={{vm.contextPage}}></user-profile-navigation><div class=guest-profile__inner-main-content ui-view=mainPersonal></div></div></div></section>");
$templateCache.put("app/user-home-page/components/personal/personal-profile/personal-profile.html","<section class=personal-profile><div class=personal-profile__container><div ui-view=sidebarPersonal class=personal-profile__sidebar-left></div><div class=personal-profile__main-content><user-profile-navigation user=vm.user context={{vm.contextPage}} options=vm.options></user-profile-navigation><div class=personal-profile__inner-main-content ui-view=mainPersonal></div></div></div></section>");
$templateCache.put("app/user-home-page/components/personal/sidebar-personal-profile/sidebar-personal-profile.html","<section class=sidebar-personal-profile scroll-to-fixed=vm.sidebarScrollToFixed scroll-to-fixed-when=vm.scrollToFixedWhen><div class=sidebar-personal-profile__brief><div ng-if=\"vm.user.canBeFollowed || vm.user.canFollow || vm.user.canUploadPhotos\" class=sidebar-personal-profile__user-interact><div ng-if=vm.user.canUploadPhotos class=sidebar-personal-profile__photos><div class=sidebar-personal-profile__photos__number>{{vm.user.stats.media_count}}</div><div class=sidebar-personal-profile__photos__text>{{ vm.user.stats.media_count, plural, =1 {{{\'photo\' | translate}}} other {{{\'photos\' | translate}}} }}</div></div><div ng-if=vm.user.canBeFollowed class=sidebar-personal-profile__followers ng-click=vm.onFollowersBtnClicked()><div class=sidebar-personal-profile__followers__number>{{vm.user.stats.follower_count}}</div><div class=sidebar-personal-profile__followers__text>{{ vm.user.stats.follower_count, plural, =1 {{{\'follower\' | translate}}} other {{{\'followers\' | translate}}} }}</div></div><div ng-if=vm.user.canFollow class=sidebar-personal-profile__following ng-click=vm.onFollowingsBtnClicked()><div class=sidebar-personal-profile__following__number>{{vm.user.stats.following_count}}</div><div class=sidebar-personal-profile__following__text>{{\'following\' | translate}}</div></div></div><div ng-if=vm.isMyProfile class=sidebar-personal-profile__description><div ng-if=vm.user.bio class=\"sidebar-personal-profile__description-label text--bold\" translate>{{\'about\'}}</div><div ng-if=vm.user.bio class=sidebar-personal-profile__description-text>{{vm.user.bio}}</div></div></div><div class=sidebar-personal-profile__service-rates ng-if=vm.user.profile><div class=sidebar-personal-profile__service-rates__desc-wrapper ng-if=\"vm.user.profile && vm.user.profile.services_rate_amount != null && vm.user.profile.services_rate_type\"><div class=\"sidebar-personal-profile__service-rates__desc-header clearfix\"><div class=\"sidebar-personal-profile__service-rates__title text--bold text--color-black\">{{vm.user.profile.services_rate_type}}</div></div><div class=sidebar-personal-profile__service-rates__description>SGD <span class=\"rate-amount text--bold\">{{vm.user.profile.services_rate_amount}}</span></div></div><div class=sidebar-personal-profile__service-rates__desc-wrapper ng-if=\"vm.user.profile && vm.user.profile.years_of_experience != null\"><div class=\"sidebar-personal-profile__service-rates__desc-header clearfix\"><div class=\"sidebar-personal-profile__service-rates__title text--bold text--color-black\">{{\'years-of-experience\' | translate}}</div></div><div class=sidebar-personal-profile__service-rates__description ng-bind=\"vm.serviceData.years_of_experience == \'1\' ? vm.serviceData.years_of_experience + \' year\' : vm.serviceData.years_of_experience + \' years\'\"></div></div><div class=sidebar-personal-profile__service-rates__desc-wrapper ng-if=\"vm.user.profile && (vm.user.profile.availability_weekdays || vm.user.profile.availability_weekends) && (vm.user.profile.availability_weekdays.length || vm.user.profile.availability_weekends.length)\"><div class=\"sidebar-personal-profile__service-rates__desc-header clearfix\"><div class=\"sidebar-personal-profile__service-rates__title text--bold text--color-black\">{{\'availabilties\' | translate}}</div></div><div class=sidebar-personal-profile__service-rates__description ng-if=vm.serviceData.availability_weekdays>{{\'weekdays\' | translate}}: {{vm.serviceData.availability_weekdays | translate}}</div><div class=sidebar-personal-profile__service-rates__description ng-if=vm.serviceData.availability_weekends>{{\'weekends\' | translate}}: {{vm.serviceData.availability_weekends | translate}}</div></div><div class=sidebar-personal-profile__service-rates__desc-wrapper ng-if=\"vm.user.profile && vm.user.profile.cameras && vm.user.profile.cameras.length\"><div class=\"sidebar-personal-profile__service-rates__desc-header clearfix\"><div class=\"sidebar-personal-profile__service-rates__title text--bold text--color-black\">{{\'camera\' | translate}}</div></div><div class=sidebar-personal-profile__service-rates__description>{{vm.serviceData.cameras}}</div></div><div class=sidebar-personal-profile__service-rates__desc-wrapper ng-if=\"vm.user.profile && vm.user.profile.specialities && vm.user.profile.specialities.length\"><div class=\"sidebar-personal-profile__service-rates__desc-header clearfix\"><div class=\"sidebar-personal-profile__service-rates__title text--bold text--color-black\">{{\'photography-specialities\' | translate}}</div></div><div class=sidebar-personal-profile__service-rates__description>{{vm.serviceData.specialities}}</div></div></div></section>");
$templateCache.put("app/user-home-page/components/user-profile-communities/user-profile-communities-grid/user-profile-communities-grid.html","<div class=user-profile-communities-grid><div class=user-profile-communities-grid__empty-profile-landing-page ng-if=\"vm.isMyProfile &&!(vm.user.account_type && vm.user.canManageCommunity && vm.myCommunities && vm.myCommunities.length)\"><empty-profile-landing-page></empty-profile-landing-page></div><div ng-if=\"vm.user.canManageCommunity && vm.myCommunities && vm.myCommunities.length\" class=user-profile-communities-grid__my-communities><div class=user-profile-communities-grid__header><div class=user-profile-communities-grid__header__left translate>{{\'my-communities\'}}</div><!-- <div ng-if=\"vm.isMyProfile && vm.myCommunities.length\"\r\n				class=\"user-profile-communities-grid__header__right btn btn-cancel--no-background\"\r\n				check-verified-email=\"true\" authentication-click=\"vm.onCreateCommunityClicked()\">\r\n				<span class=\"user-profile-communities-grid__header__right__icon icon-icons_plus\"></span>\r\n				<span\r\n					class=\"user-profile-communities-grid__header__right__text\">{{\'create-community\' | translate}}</span>\r\n			</div> --></div><div class=user-profile-communities-grid__my-communities__grid-wrapper infinite-scroll-disabled=vm.isLastMyCommunitiesPage infinite-scroll=vm.fetchMoreMyCommunities() infinite-scroll-immediate-check=false><div class=user-profile-communities-grid__communities-list-inner ng-if=vm.myCommunities.length><div ng-repeat=\"community in vm.myCommunities\" class=user-profile-communities-grid__community-wrapper><community-explore-tile community=community on-community-membership-changed=vm.onMyCommunitiesGridChanged(communityId)></community-explore-tile></div></div><div ng-if=!vm.myCommunities.length><div class=user-profile-communities-grid__empty-section><div ng-if=vm.isMyProfile class=user-profile-communities-grid__empty-section__wrapper><div class=user-profile-communities-grid__empty-section__title>{{\'you-do-not-own-any-community\' | translate}}</div><div class=user-profile-communities-grid__empty-section__description translate>{{\'but-its-always-a-good-time-to-build-one\'}}</div></div><div ng-if=!vm.isMyProfile class=user-profile-communities-grid__empty-section__wrapper><div class=user-profile-communities-grid__empty-section__title>{{\'other-communities-not-managing\' | translate: {name: vm.user.displayName}}}</div></div><button ng-if=\"vm.isMyProfile && vm.canManageCommunity\" class=\"btn btn-submit user-profile-communities-grid__empty-section__action-btn\" ng-click=vm.onCreateCommunityClicked() translate>{{\'create-a-community\'}}</button></div></div><scroll-paging spinner=vm.spinnerMyCommunities show-message=\"vm.myCommunities.length > 0 && vm.searchParams.page > 1\" is-last-page=vm.isLastMyCommunitiesPage message=\"No more communities.\"></scroll-paging></div></div><div class=user-profile-communities-grid__joined-communities ng-if=vm.joinedCommunities.length><div class=user-profile-communities-grid__header><div class=user-profile-communities-grid__header__left translate>{{\'joined-communities\'}}</div></div><div class=user-profile-communities-grid__joined-communities__grid-wrapper infinite-scroll-disabled=vm.isLastJoinedCommunitiesPage infinite-scroll=vm.fetchMoreJoinedCommunities() infinite-scroll-immediate-check=false><div class=user-profile-communities-grid__communities-list-inner ng-if=vm.joinedCommunities.length><div ng-repeat=\"community in vm.joinedCommunities\" class=user-profile-communities-grid__community-wrapper><community-explore-tile community=community on-community-membership-changed=vm.onJoinCommunitiesGridChanged(communityId)></community-explore-tile></div></div><div ng-if=!vm.joinedCommunities.length><div class=user-profile-communities-grid__empty-section><div ng-if=vm.isMyProfile class=user-profile-communities-grid__empty-section__wrapper><div class=user-profile-communities-grid__empty-section__title>{{\'you-communities-not-joined\' | translate}}</div><div class=user-profile-communities-grid__empty-section__description>{{\'find-a-community-based-on-your-interests\' | translate}}</div></div><div ng-if=!vm.isMyProfile class=user-profile-communities-grid__empty-section__wrapper><div class=user-profile-communities-grid__empty-section__title>{{\'other-communities-not-joined\' | translate: {name: vm.user.displayName}}}</div></div><button ng-if=vm.isMyProfile class=\"btn btn-submit user-profile-communities-grid__empty-section__action-btn\" ng-click=vm.onExploreCommunities() translate>{{\'explore-communities\'}}</button></div></div><scroll-paging spinner=vm.spinnerJoinedCommunities show-message=\"vm.joinedCommunities.length > 0 && vm.searchParams.page > 1\" is-last-page=vm.isLastJoinedCommunitiesPage message=\"No more communities.\"></scroll-paging></div></div></div>");
$templateCache.put("app/user-home-page/components/user-profile-portfolio/user-profile-portfolio-carousel/user-profile-portfolio-carousel.html","<div class=user-profile-portfolio-carousel><div class=user-profile-portfolio__empty-text ng-if=\"!vm.user.profile || !vm.user.profile.specialities.length\"><div class=\"user-profile-portfolio__empty-text__icon icon-icons-gallery\"></div><div class=\"user-profile-portfolio__empty-text__text text--semibold\" ng-if=!vm.isMine>{{vm.user.displayName}} hasn\'t created a Portfolio Gallery yet</div></div><div ng-repeat=\"portfolio in vm.portfolios\" ng-if=!vm.portfolioClicked><portfolio-list-slider portfolio=portfolio instance=vm[portfolio.grid] owner=vm.user on-portfolio-clicked=vm.onPortfolioClicked(portfolio)></portfolio-list-slider></div></div>");
$templateCache.put("app/user-home-page/components/user-profile-portfolio/user-profile-portfolio-grid/user-profile-portfolio-grid.html","<div class=user-profile-portfolio-grid><div class=user-profile-portfolio-grid__grid-wrapper><h1 id=section-default-gallery class=\"user-profile-portfolio-grid__title text--bold text--color-black\">{{vm.portfolioName | toTitleCase}}</h1><div class=user-profile-portfolio-grid__breadscrum><a class=\"user-profile-portfolio-grid__breadscrum__root text--bold text--color-black\" ui-sref=user-home-page.personal.portfolio.carousel>All</a></div><div class=user-profile-portfolio-grid__create-new-gallery ng-if=vm.isMine ng-click=vm.onUploadPortfolioPhoto(vm.portfolioId)><div class=\"user-profile-portfolio-grid__create-new-gallery__icon icon-icons_plus\"></div><div class=\"user-profile-portfolio-grid__create-new-gallery__title text--bold text--color-black\">{{\'upload-photos\' | translate}}</div></div><portfolio-grid class=user-profile-portfolio-grid__portfolio-collapse instance=vm.portfolioGrid on-scroll-to-section-id=section-default-portfolio on-scroll-offset-top={{vm.scrollOffsetTopPortfolio}} on-portfolio-clicked=vm.onPortfolioClicked(portfolio)></portfolio-grid></div></div>");
$templateCache.put("app/buy-stock-page/components/stock-galleries/components/curated-galleries/curated-galleries.html","<section class=curated-galleries><div class=curated-galleries__grid><gallery-grid instance=vm.galleryGridAll on-scroll-to-gallery=vm.onScrollToGallery(page) on-load-more-page=vm.onLoadMorePage(page)></gallery-grid></div></section>");
$templateCache.put("app/buy-stock-page/components/stock-galleries/components/followed-galleries/followed-galleries.html","<section class=followed-galleries><div class=followed-galleries__grid><gallery-grid instance=vm.galleryGridAll on-scroll-to-gallery=vm.onScrollToGallery(page) on-load-more-page=vm.onLoadMorePage(page)></gallery-grid></div></section>");
$templateCache.put("app/buy-stock-page/components/stock-galleries/components/pixerfer-galleries/pixerfer-galleries.html","<section class=pixerfer-galleries><div class=pixerfer-galleries__grid><gallery-grid instance=vm.galleryGridAll on-scroll-to-gallery=vm.onScrollToGallery(page) on-load-more-page=vm.onLoadMorePage(page)></gallery-grid></div></section>");
$templateCache.put("app/buy-stock-page/components/stock-galleries/components/signature-galleries/signature-galleries.html","<div class=signature-galleries><div class=signature-galleries__grid-wrapper><div ng-repeat=\"category in vm.categories\" ui-sref=\"signature-galleries-details-page({id: category.id, title: category.name})\" class=signature-galleries__item-wrapper><div class=signature-galleries__item><div class=\"signature-galleries__item__background zoom-hover\" ng-style=\"{\'background-image\': \'url(\\\'\' + category.thumbnails[\'local\'] + \'\\\')\'}\"><div class=signature-galleries__overlay></div></div><div class=signature-galleries__item__name>{{category.name}}</div></div></div></div></div>");
$templateCache.put("app/components/earnings/my-earnings/components/images-sold/images-sold.html","<div class=images-sold infinite-scroll-disabled=vm.isLastPage infinite-scroll=vm.fetchMorePurchasedItems() infinite-scroll-immediate-check=false><div class=images-sold__content><div class=\"purchase-history__content__filter clearfix\"><div class=\"purchase-history__content__filter__from-wrapper clearfix\"><div class=\"purchase-history__content__filter__dropdown-custom-text clearfix\"><span class=\"purchase-history__text-filter-from text--bold text--color-black\">From</span><popover-selection-btn on-selection-changed=vm.onFilterChanged() popover-class=\"\'popover-purchase-history-filter-month\'\" class=\"purchase-history__dropdown-filter-btn dropdown-filter-month\" close-on-click=true selected-model=vm.selectedFilter.fromMonth settings=vm.filtersFromMonth></popover-selection-btn></div><popover-selection-btn on-selection-changed=vm.onFilterChanged() popover-class=\"\'popover-purchase-history-filter-year\'\" class=\"purchase-history__dropdown-filter-btn dropdown-filter-year\" close-on-click=true selected-model=vm.selectedFilter.fromYear settings=vm.filtersFromYear></popover-selection-btn></div><div class=\"purchase-history__content__filter__to-wrapper clearfix\"><div class=\"purchase-history__content__filter__dropdown-custom-text clearfix\"><span class=\"purchase-history__text-filter-to text--bold text--color-black\">To</span><popover-selection-btn on-selection-changed=vm.onFilterChanged() popover-class=\"\'popover-purchase-history-filter-month\'\" class=\"purchase-history__dropdown-filter-btn dropdown-filter-month\" close-on-click=true selected-model=vm.selectedFilter.toMonth settings=vm.filtersToMonth></popover-selection-btn></div><popover-selection-btn on-selection-changed=vm.onFilterChanged() popover-class=\"\'popover-purchase-history-filter-year\'\" class=\"purchase-history__dropdown-filter-btn dropdown-filter-year\" close-on-click=true selected-model=vm.selectedFilter.toYear settings=vm.filtersToYear></popover-selection-btn></div></div><div class=\"images-sold__content__count clearfix\">{{\'you-have-sold\' | translate}} <span class=text--bold ng-bind=\"vm.items.length === 0 ? 0 : vm.totalMedia\"></span> <span>{{vm.totalMedia === 1 ? (\'photo\' | translate) : (\'photos\'| translate )}}</span></div><div class=images-sold__table-wrapper><table class=\"images-sold__table pixerf-table\"><tr class=images-sold__table__header><th class=\"images-sold__table__column images-sold__table__column-date\" ng-click=\"reverse = !reverse\"><div class=images-sold__table__column-date__label>{{\'date\' | translate}}</div><div class=icon-list_arrange ng-class=\"{\'up\': reverse}\"></div></th><th class=\"images-sold__table__column images-sold__table__column-order\">{{\'order-no\' | translate}}</th><th class=\"images-sold__table__column images-sold__table__column-count\">{{\'no-of-photos\' | translate}}</th><th class=images-sold__table__column></th></tr><tr class=images-sold__table__row ng-repeat=\"item in vm.items | orderBy:purchasedDateFormatted:reverse\"><td class=images-sold__table__column-date>{{item.purchasedDateFormatted}}</td><td class=text-center>{{item.id}}</td><td class=text-center>{{item.media.length}}</td><td class=\"images-sold__table__column-view-photos text--bold text--color-pixerf-theme\"><span ui-sref=\"setting.earnings.photos_sold.sold-details({orderId: item.id})\">{{\'view-photos\' | translate}}</span></td></tr></table></div><div class=\"images-sold__content__items--no-records text-center text--semibold\" ng-show=\"vm.items.length === 0 && !vm.spinner.isVisible\">{{\'no-records-found\' | translate}}</div><scroll-paging spinner=vm.spinner show-message=\"vm.items.length > 0 && vm.searchParams.page > 1\" is-last-page=vm.isLastPage></scroll-paging></div></div>");
$templateCache.put("app/components/earnings/my-earnings/components/referrals/referrals.html","<div class=my-earning-referrals infinite-scroll-disabled=vm.isLastPage infinite-scroll=vm.fetchMorePurchasedItems() infinite-scroll-immediate-check=false><div class=my-earning-referrals__content><div class=my-earning-referrals__table-wrapper><table class=my-earning-referrals__table><tr class=\"my-earning-referrals__table__header text--bold text--color-black\"><th class=\"referrals-column friends\">Your friends</th><th class=\"referrals-column image-sold\" ng-click=\"soldReverse = !soldReverse\"><div class=referrals-column__order-label>Image they sold</div><div class=icon-list_arrange ng-class=\"{\'up\': soldReverse}\"></div></th><th class=\"referrals-column expiry-date\" ng-click=\"dateReverse = !dateReverse\"><div class=referrals-column__order-label>Referral Expiry Date</div><div class=icon-list_arrange ng-class=\"{\'up\': dateReverse}\"></div></th></tr><tr class=my-earning-referrals__table__row ng-repeat=\"item in vm.items | orderBy:purchasedDateFormatted:reverse\"><td class=\"referrals-column friends\">{{item.email}}</td><td class=\"referrals-column image-sold\">{{item.image}}</td><td class=\"referrals-column expiry-date\">{{item.expiry_date}}</td></tr></table></div><div class=\"my-earning-referrals__content__items--no-records text-center text--semibold\" ng-show=\"vm.items.length === 0 && !vm.spinner.isVisible\">{{\'no-records-found\' | translate}}</div><scroll-paging spinner=vm.spinner show-message=\"vm.items.length > 0 && vm.searchParams.page > 1\" is-last-page=vm.isLastPage></scroll-paging></div></div>");}]);